/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(551);
	__webpack_require__(1571);
	__webpack_require__(1974);
	__webpack_require__(1973);
	__webpack_require__(1264);
	__webpack_require__(240);
	module.exports = __webpack_require__(1363);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(470);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(801)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(506)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(16);
	var core = __webpack_require__(60);
	var hide = __webpack_require__(43);
	var redefine = __webpack_require__(44);
	var ctx = __webpack_require__(61);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(2102);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(2103);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	var _interopRequireWildcard = __webpack_require__(1210)['default'];
	
	exports.__esModule = true;
	
	var _utilsChildrenValueInputValidation = __webpack_require__(1049);
	
	var _utilsChildrenValueInputValidation2 = _interopRequireDefault(_utilsChildrenValueInputValidation);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _Accordion2 = __webpack_require__(1980);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	exports.Accordion = _Accordion3['default'];
	
	var _Alert2 = __webpack_require__(1981);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	exports.Alert = _Alert3['default'];
	
	var _Badge2 = __webpack_require__(1982);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	exports.Badge = _Badge3['default'];
	
	var _Breadcrumb2 = __webpack_require__(1983);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	exports.Breadcrumb = _Breadcrumb3['default'];
	
	var _BreadcrumbItem2 = __webpack_require__(1190);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	
	var _Button2 = __webpack_require__(523);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	exports.Button = _Button3['default'];
	
	var _ButtonGroup2 = __webpack_require__(1191);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	exports.ButtonGroup = _ButtonGroup3['default'];
	
	var _ButtonInput2 = __webpack_require__(1984);
	
	var _ButtonInput3 = _interopRequireDefault(_ButtonInput2);
	
	exports.ButtonInput = _ButtonInput3['default'];
	
	var _ButtonToolbar2 = __webpack_require__(1985);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	
	var _Carousel2 = __webpack_require__(1986);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	exports.Carousel = _Carousel3['default'];
	
	var _CarouselItem2 = __webpack_require__(1192);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	exports.CarouselItem = _CarouselItem3['default'];
	
	var _Clearfix2 = __webpack_require__(1988);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	exports.Clearfix = _Clearfix3['default'];
	
	var _Col2 = __webpack_require__(1193);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	exports.Col = _Col3['default'];
	
	var _CollapsibleNav2 = __webpack_require__(1989);
	
	var _CollapsibleNav3 = _interopRequireDefault(_CollapsibleNav2);
	
	exports.CollapsibleNav = _CollapsibleNav3['default'];
	
	var _Dropdown2 = __webpack_require__(912);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	exports.Dropdown = _Dropdown3['default'];
	
	var _DropdownButton2 = __webpack_require__(1990);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	exports.DropdownButton = _DropdownButton3['default'];
	
	var _Glyphicon2 = __webpack_require__(1045);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	exports.Glyphicon = _Glyphicon3['default'];
	
	var _Grid2 = __webpack_require__(1046);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	exports.Grid = _Grid3['default'];
	
	var _Image2 = __webpack_require__(1993);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	exports.Image = _Image3['default'];
	
	var _Input2 = __webpack_require__(1994);
	
	var _Input3 = _interopRequireDefault(_Input2);
	
	exports.Input = _Input3['default'];
	
	var _Interpolate2 = __webpack_require__(1197);
	
	var _Interpolate3 = _interopRequireDefault(_Interpolate2);
	
	exports.Interpolate = _Interpolate3['default'];
	
	var _Jumbotron2 = __webpack_require__(1995);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	exports.Jumbotron = _Jumbotron3['default'];
	
	var _Label2 = __webpack_require__(1996);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	exports.Label = _Label3['default'];
	
	var _ListGroup2 = __webpack_require__(1997);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	exports.ListGroup = _ListGroup3['default'];
	
	var _ListGroupItem2 = __webpack_require__(1198);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	exports.ListGroupItem = _ListGroupItem3['default'];
	
	var _MenuItem2 = __webpack_require__(2005);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	exports.MenuItem = _MenuItem3['default'];
	
	var _Media2 = __webpack_require__(1998);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	exports.Media = _Media3['default'];
	
	var _Modal2 = __webpack_require__(2006);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	exports.Modal = _Modal3['default'];
	
	var _ModalBody2 = __webpack_require__(1199);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	exports.ModalBody = _ModalBody3['default'];
	
	var _ModalFooter2 = __webpack_require__(1200);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	exports.ModalFooter = _ModalFooter3['default'];
	
	var _ModalHeader2 = __webpack_require__(1201);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	exports.ModalHeader = _ModalHeader3['default'];
	
	var _ModalTitle2 = __webpack_require__(1202);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	exports.ModalTitle = _ModalTitle3['default'];
	
	var _Nav2 = __webpack_require__(1203);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	exports.Nav = _Nav3['default'];
	
	var _Navbar2 = __webpack_require__(2009);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	exports.Navbar = _Navbar3['default'];
	
	var _NavBrand2 = __webpack_require__(1204);
	
	var _NavBrand3 = _interopRequireDefault(_NavBrand2);
	
	exports.NavBrand = _NavBrand3['default'];
	
	var _NavbarBrand2 = __webpack_require__(1048);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	exports.NavbarBrand = _NavbarBrand3['default'];
	
	var _NavDropdown2 = __webpack_require__(2008);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	exports.NavDropdown = _NavDropdown3['default'];
	
	var _NavItem2 = __webpack_require__(1205);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	exports.NavItem = _NavItem3['default'];
	
	var _Overlay2 = __webpack_require__(1206);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	exports.Overlay = _Overlay3['default'];
	
	var _OverlayTrigger2 = __webpack_require__(2013);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	
	var _PageHeader2 = __webpack_require__(2014);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	exports.PageHeader = _PageHeader3['default'];
	
	var _PageItem2 = __webpack_require__(2015);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	exports.PageItem = _PageItem3['default'];
	
	var _Pager2 = __webpack_require__(2016);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	exports.Pager = _Pager3['default'];
	
	var _Pagination2 = __webpack_require__(2017);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	exports.Pagination = _Pagination3['default'];
	
	var _Panel2 = __webpack_require__(2019);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	exports.Panel = _Panel3['default'];
	
	var _PanelGroup2 = __webpack_require__(1207);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	exports.PanelGroup = _PanelGroup3['default'];
	
	var _Popover2 = __webpack_require__(2020);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	exports.Popover = _Popover3['default'];
	
	var _ProgressBar2 = __webpack_require__(2021);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	exports.ProgressBar = _ProgressBar3['default'];
	
	var _ResponsiveEmbed2 = __webpack_require__(2022);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	
	var _Row2 = __webpack_require__(2023);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	exports.Row = _Row3['default'];
	
	var _SafeAnchor2 = __webpack_require__(463);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	exports.SafeAnchor = _SafeAnchor3['default'];
	
	var _SplitButton2 = __webpack_require__(2024);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	exports.SplitButton = _SplitButton3['default'];
	
	var _Tab2 = __webpack_require__(2026);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	exports.Tab = _Tab3['default'];
	
	var _Table2 = __webpack_require__(2027);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	exports.Table = _Table3['default'];
	
	var _Tabs2 = __webpack_require__(2028);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	exports.Tabs = _Tabs3['default'];
	
	var _Thumbnail2 = __webpack_require__(2029);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	exports.Thumbnail = _Thumbnail3['default'];
	
	var _Tooltip2 = __webpack_require__(2030);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	exports.Tooltip = _Tooltip3['default'];
	
	var _Well2 = __webpack_require__(2031);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	exports.Well = _Well3['default'];
	
	var _Collapse2 = __webpack_require__(804);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	exports.Collapse = _Collapse3['default'];
	
	var _Fade2 = __webpack_require__(1044);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	exports.Fade = _Fade3['default'];
	
	var _FormControls2 = __webpack_require__(1195);
	
	var _FormControls = _interopRequireWildcard(_FormControls2);
	
	exports.FormControls = _FormControls;
	var utils = {
	  bootstrapUtils: _utilsBootstrapUtils2['default'],
	  childrenValueInputValidation: _utilsChildrenValueInputValidation2['default'],
	  createChainedFunction: _utilsCreateChainedFunction2['default'],
	  ValidComponentChildren: _utilsValidComponentChildren2['default']
	};
	exports.utils = utils;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.sanitize = sanitize;
	exports.replace = replace;
	
	exports.default = function (target) {
	    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var defaultValue = arguments[2];
	
	    var keySet = key instanceof Array && key || [key];
	
	    if (typeof target == 'string') {
	        return target;
	    }
	
	    if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) == 'object') {
	        var keySanitized;
	        var value;
	
	        for (var i = 0; i < keySet.length; i++) {
	            keySanitized = sanitize(keySet[i]);
	
	            value = target[keySanitized];
	            value = value && value.default || value;
	            if (value) break;
	        }
	
	        if (defaultValue === undefined) {
	            return value || keySanitized;
	        }
	        return value || defaultValue;
	    }
	
	    return 'invalid extraction';
	};
	
	function sanitize(value) {
	    if (value) {
	        value = value.toString();
	        value = value === value.toUpperCase() && value.toLowerCase() || value;
	        value = value.charAt(0).toLowerCase() + value.slice(1);
	        value = value.replace(/[-_\s]([a-z])/g, function (m) {
	            return m[1].toUpperCase();
	        });
	    }
	    return value;
	}
	
	function replace(value) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (value) {
	        value = value.toString();
	
	        Object.keys(data).forEach(function (key) {
	            if (data[key] === true) {
	                // remove key
	                value = value.replace('{' + sanitize(key) + '}', '');
	            } else if (data[key] != null && data[key] !== false) {
	                // replace key
	                value = value.replace('{' + sanitize(key) + '}', data[key]);
	            }
	        });
	        // remove optional text with unmatched keys
	        value = value.replace(/\[\[([^\[\]]*{[\w]+}[^\[\]]*)+\]\]/g, '');
	        // remove brackets
	        value = value.replace(/\[\[([^\[\]]*)\]\]/g, '$1');
	        // remove unmatched keys
	        value = value.replace(/{[\w]+}/g, '');
	    }
	    return value;
	}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.statusReducer = statusReducer;
	exports.status = status;
	exports.infoStatus = infoStatus;
	exports.errorStatus = errorStatus;
	exports.discardStatus = discardStatus;
	exports.statusMiddleware = statusMiddleware;
	var NAMESPACE = 'Core';
	
	var STATUS_CHANGED = exports.STATUS_CHANGED = NAMESPACE + '/StatusChanged';
	var STATUS_DISCARDED = exports.STATUS_DISCARDED = NAMESPACE + '/StatusDiscarded';
	
	// reducers
	
	function statusReducer() {
	    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case STATUS_CHANGED:
	            return action.status;
	        case STATUS_DISCARDED:
	            return null;
	        default:
	            return status;
	    }
	}
	
	// actions
	
	function status(type, message) {
	    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
	
	    return {
	        type: STATUS_CHANGED,
	        status: {
	            type: type,
	            message: message,
	            timeout: timeout
	        }
	    };
	}
	
	function infoStatus(message) {
	    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
	
	    return {
	        type: STATUS_CHANGED,
	        status: {
	            type: 'info',
	            message: message,
	            timeout: timeout
	        }
	    };
	}
	
	function errorStatus(message) {
	    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
	
	    return {
	        type: STATUS_CHANGED,
	        status: {
	            type: 'danger',
	            message: message,
	            timeout: timeout
	        }
	    };
	}
	
	function discardStatus() {
	    return {
	        type: STATUS_DISCARDED
	    };
	}
	
	// middlewares
	
	function statusMiddleware(_ref) {
	    var dispatch = _ref.dispatch;
	
	    var timer;
	
	    return function (next) {
	        return function (action) {
	            if (action.type == STATUS_CHANGED) {
	                if (timer) {
	                    clearTimeout(timer);
	                }
	
	                if (action.status.timeout) {
	                    timer = setTimeout(function () {
	                        dispatch(discardStatus());
	                    }, action.status.timeout);
	                }
	                return next(action);
	            }
	            return next(action);
	        };
	    };
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.connectForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.nodeIsValid = nodeIsValid;
	exports.nodeHasValue = nodeHasValue;
	exports.checkboxField = checkboxField;
	exports.buttonField = buttonField;
	exports.selectField = selectField;
	exports.arrayItemField = arrayItemField;
	exports.addArrayItemField = addArrayItemField;
	exports.updateField = updateField;
	exports.integerField = integerField;
	exports.percentageField = percentageField;
	exports.controlledField = controlledField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jjv = __webpack_require__(172);
	
	var _jjv2 = _interopRequireDefault(_jjv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TOUCHED_TRUE_PROPAGATE = 'touchedTruePropagate';
	var TOUCHED_FALSE_PROPAGATE = 'touchedFalsePropagate';
	var TOUCHED_TRUE = 'touchedTrue';
	var TOUCHED_FALSE = 'touchedFalse';
	
	function nodeIsValid() {
	    for (var _len = arguments.length, nodes = Array(_len), _key = 0; _key < _len; _key++) {
	        nodes[_key] = arguments[_key];
	    }
	
	    return nodes.find(function (node) {
	        return !!node && !node.isValid();
	    }) == null;
	}
	
	function nodeHasValue() {
	    for (var _len2 = arguments.length, nodes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        nodes[_key2] = arguments[_key2];
	    }
	
	    return nodes.find(function (node) {
	        var value = node && node().value;
	
	        if (value == null) {
	            return false;
	        } else if (value instanceof Array) {
	            return value.length > 0;
	        }
	        return true;
	    }) != null;
	}
	
	function checkboxField(field) {
	    var checked = !!field.value;
	
	    function onChange() {
	        field.onChange(!checked);
	    }
	
	    return _extends({}, field, { checked: checked, onChange: onChange });
	}
	
	function buttonField(field, value) {
	    var active = field.value == value;
	
	    function onClick(event) {
	        if (event) {
	            event.preventDefault();
	        }
	        field.onChange(value);
	    }
	
	    return { active: active, onClick: onClick };
	}
	
	function selectField(field, multi) {
	    var value;
	    var onChange;
	
	    if (multi) {
	        value = field.value;
	
	        onChange = function onChange(event) {
	            var options = [].concat(_toConsumableArray(event.target.options));
	            var nextValue = options.filter(function (o) {
	                return o.selected;
	            }).map(function (o) {
	                return o.value;
	            });
	            field.onChange(nextValue);
	        };
	    } else {
	        value = field.value || '';
	        onChange = field.onChange;
	    }
	
	    return _extends({}, field, { value: value, onChange: onChange });
	}
	
	function arrayItemField(field) {
	    var arrayValue = field.value || [];
	    var value = arrayValue[0];
	
	    function onChange(eventOrValue) {
	        var nextValue;
	        if (eventOrValue && eventOrValue.target) {
	            nextValue = eventOrValue.target.value;
	        } else {
	            nextValue = eventOrValue;
	        }
	
	        var nextItemValue;
	        if (nextValue instanceof Date) {
	            nextItemValue = nextValue;
	        } else if (nextValue && (typeof nextValue === 'undefined' ? 'undefined' : _typeof(nextValue)) == 'object') {
	            nextItemValue = _extends({}, arrayValue[0], nextValue);
	        } else {
	            nextItemValue = nextValue;
	        }
	
	        var nextArrayValue = [].concat(_toConsumableArray(arrayValue));
	        nextArrayValue[0] = nextItemValue || null;
	        if (nextArrayValue.length == 1 && !nextArrayValue[0]) {
	            // reset array
	            nextArrayValue = [];
	        }
	
	        field.onChange(nextArrayValue);
	    }
	
	    return _extends({}, field, { value: value, onChange: onChange });
	}
	
	function addArrayItemField(field) {
	    var arrayValue = field.value || [];
	    var value = null;
	
	    function onChange(value) {
	        var nextValue = [value].concat(_toConsumableArray(arrayValue));
	        field.onChange(nextValue);
	    }
	
	    return _extends({}, field, { value: value, onChange: onChange });
	}
	
	function updateField(field, originalValue) {
	    var value = field.value;
	    if (field.value === undefined) {
	        value = originalValue;
	    }
	
	    function onChange(event) {
	        var value = event.target.value || null;
	
	        var nextValue = value;
	        if (value == originalValue) {
	            nextValue = undefined;
	        }
	        field.onChange(nextValue);
	    }
	
	    return _extends({}, field, { value: value, onChange: onChange });
	}
	
	function integerField(field) {
	    function onChange(eventOrValue) {
	        var nextValue;
	        if (eventOrValue && eventOrValue.target) {
	            nextValue = eventOrValue.target.value;
	        } else {
	            nextValue = eventOrValue;
	        }
	
	        field.onChange(parseInt(nextValue));
	    }
	
	    return _extends({}, field, { onChange: onChange });
	}
	
	function percentageField(field) {
	    var value = field.value && Math.round(field.value * 100);
	
	    function onChange(eventOrValue) {
	        var nextValue;
	        if (eventOrValue && eventOrValue.target) {
	            nextValue = eventOrValue.target.value;
	        } else {
	            nextValue = eventOrValue;
	        }
	
	        field.onChange(parseInt(nextValue) / 100);
	    }
	
	    return _extends({}, field, { value: value, onChange: onChange });
	}
	
	function controlledField(field) {
	    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    // workaround when passing null value to react input text area
	    // this prevent the component to become uncontrolled
	    var value = field.value || defaultValue;
	    return _extends({}, field, { value: value });
	}
	
	function filter(object, keys, allways) {
	    if (keys && (object || allways)) {
	        return keys.reduce(function (r, v) {
	            r[v] = object && object[v];
	            return r;
	        }, {});
	    }
	    return object;
	}
	
	function includes(source, target) {
	    source = source instanceof Array && source || [source];
	    target = target instanceof Array && target || [target];
	
	    for (var i = 0; i < target.length; i++) {
	        if (source.indexOf(target[i]) < 0) return false;
	    }
	    return true;
	}
	
	function empty(object) {
	    return object && Object.keys(object).findIndex(function (k) {
	        return object[k] != null;
	    }) < 0;
	}
	
	function sanitize(schema, value) {
	    if (includes(schema.type, ['object', 'null'])) {
	        if (empty(value)) return null;
	    }
	
	    if (value === 0 || value === false || value === undefined) return value;
	    return value || null;
	}
	
	function sanitizeValidation(value) {
	    if (value === undefined) return null;
	    return value;
	}
	
	function getTouched(touched, schema, target, property) {
	    if (includes(schema.type, ['object', 'null'])) {
	        if (!(target && target[property])) return TOUCHED_FALSE_PROPAGATE;
	    }
	
	    if (touched == TOUCHED_TRUE_PROPAGATE) return touched;
	    if (touched == TOUCHED_FALSE_PROPAGATE) return touched;
	    return target && target[property] !== undefined && TOUCHED_TRUE || TOUCHED_FALSE;
	}
	
	function isTouched(touched) {
	    return touched == TOUCHED_TRUE_PROPAGATE || touched == TOUCHED_TRUE;
	}
	
	function connectForm(options) {
	    var formName = options.name || 'form';
	    var targetName = options.target;
	    var targetAlias = options.alias || targetName;
	    var selectSchema = typeof options.schema == 'function' && options.schema || function () {
	        return options.schema;
	    };
	    var actionType = options.action;
	    var validator = options.validator || (0, _jjv2.default)();
	
	    return function (WrappedComponent) {
	        var FormConnector = function (_React$Component) {
	            _inherits(FormConnector, _React$Component);
	
	            function FormConnector(props) {
	                _classCallCheck(this, FormConnector);
	
	                var _this = _possibleConstructorReturn(this, (FormConnector.__proto__ || Object.getPrototypeOf(FormConnector)).call(this, props));
	
	                var nextTarget = props[targetName];
	                var schema = selectSchema(nextTarget, props);
	                var touched = TOUCHED_FALSE;
	                var nextForm = _this._computeNextForm(schema, null, touched, nextTarget);
	
	                _this._schema = schema;
	                _this._touched = touched;
	
	                _this.state = _defineProperty({}, formName, nextForm);
	                return _this;
	            }
	
	            _createClass(FormConnector, [{
	                key: 'componentWillReceiveProps',
	                value: function componentWillReceiveProps(nextProps) {
	                    var nextTarget = nextProps[targetName];
	                    var target = this.props[targetName];
	                    var form = this.state.form;
	
	
	                    var schema = selectSchema(nextTarget, nextProps);
	                    var nextForm = this._computeNextForm(schema, this._schema == schema && form || null, this._touched, nextTarget, target);
	
	                    this._schema = schema;
	
	                    this.setState(_defineProperty({}, formName, nextForm));
	                }
	            }, {
	                key: '_computeNextForm',
	                value: function _computeNextForm(schema, form, touched, nextTarget, target) {
	                    var _this2 = this;
	
	                    if (!form || nextTarget !== target) {
	                        var nextForm = this._createForm(schema, nextTarget);
	
	                        for (var property in schema.properties) {
	                            var propSchema = schema.properties[property];
	                            var propRoot = form && form[property];
	                            var propNextTarget = (nextTarget || undefined) && nextTarget[property];
	                            var propTarget = (target || undefined) && target[property];
	                            var propTouched = getTouched(touched, propSchema, nextTarget, property);
	
	                            nextForm[property] = this._computeNextNode(property, propTouched, propSchema, propRoot, propNextTarget, propTarget, function (value) {
	                                var dispatch = _this2.props.dispatch;
	
	                                dispatch(_defineProperty({
	                                    type: actionType
	                                }, targetAlias, value));
	                            });
	                        }
	                        return nextForm;
	                    }
	                    return form;
	                }
	            }, {
	                key: '_createForm',
	                value: function _createForm(schema, value) {
	                    var _this3 = this;
	
	                    var errors = validator.validate(schema, sanitizeValidation(value));
	
	                    var form = function form(fields) {
	                        var fieldsValue = filter(value, fields);
	
	                        return {
	                            value: fieldsValue,
	                            onChange: function onChange(eventOrValue) {
	                                var dispatch = _this3.props.dispatch;
	
	
	                                var nextFieldsValue;
	                                if (eventOrValue && eventOrValue.target) {
	                                    nextFieldsValue = eventOrValue.target.value;
	                                } else {
	                                    nextFieldsValue = eventOrValue;
	                                }
	                                nextFieldsValue = filter(nextFieldsValue, fields, true);
	
	                                dispatch(_defineProperty({
	                                    type: actionType
	                                }, targetAlias, sanitize(schema, nextFieldsValue)));
	                            }
	                        };
	                    };
	
	                    form.isValid = function () {
	                        return errors == null;
	                    };
	
	                    form.validate = function () {
	                        var nextTarget = _this3.props[targetName];
	
	                        var touched = errors == null && TOUCHED_FALSE || TOUCHED_TRUE_PROPAGATE;
	
	                        if (_this3._touched != touched) {
	                            // show / hide errors
	                            var nextForm = _this3._computeNextForm(_this3._schema, null, touched, nextTarget);
	
	                            _this3._touched = touched;
	
	                            _this3.setState(_defineProperty({}, formName, nextForm));
	                        }
	
	                        return errors == null;
	                    };
	
	                    return form;
	                }
	            }, {
	                key: '_computeNextNode',
	                value: function _computeNextNode(property, touched, schema, node, nextTarget, target, onChange) {
	                    var _this4 = this;
	
	                    if (!node || nextTarget !== target) {
	                        var prop;
	                        var prop;
	
	                        var _ret = function () {
	                            var nextNode = _this4._createNode(property, touched, schema, nextTarget);
	
	                            for (prop in schema.properties) {
	                                var propSchema = schema.properties[prop];
	                                var propNode = node && node[prop];
	                                var propNextTarget = (nextTarget || undefined) && nextTarget[prop];
	                                var propTarget = (target || undefined) && target[prop];
	                                var propTouched = getTouched(touched, propSchema, nextTarget, prop);
	
	                                nextNode[prop] = _this4._computeNextNode(prop, propTouched, propSchema, propNode, propNextTarget, propTarget, function (value) {
	                                    var nextValue = _extends({}, nextTarget, value);
	                                    nextNode._onChange(_defineProperty({}, property, sanitize(schema, nextValue)));
	                                });
	                            }
	
	                            if (schema.items) {
	                                for (prop in schema.items.properties) {
	                                    var _propSchema = schema.items.properties[prop];
	                                    var _propNode = node && node[prop];
	                                    var _propNextTarget = (nextTarget || undefined) && (nextTarget[0] || undefined) && nextTarget[0][prop];
	                                    var _propTarget = (target || undefined) && (target[0] || undefined) && target[0][prop];
	                                    var _propTouched = getTouched(touched, _propSchema, nextTarget && nextTarget[0], prop);
	
	                                    nextNode[prop] = _this4._computeNextNode(prop, _propTouched, _propSchema, _propNode, _propNextTarget, _propTarget, function (value) {
	                                        var arrayValue = nextTarget || [];
	                                        var nextItemValue = _extends({}, arrayValue[0], value);
	
	                                        var nextArrayValue = [].concat(_toConsumableArray(arrayValue));
	                                        nextArrayValue[0] = nextItemValue;
	                                        nextNode._onChange(_defineProperty({}, property, sanitize(schema, nextArrayValue)));
	                                    });
	                                }
	                            }
	
	                            nextNode._onChange = onChange;
	                            return {
	                                v: nextNode
	                            };
	                        }();
	
	                        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	                    }
	
	                    node._onChange = onChange;
	                    return node;
	                }
	            }, {
	                key: '_createNode',
	                value: function _createNode(property, touched, schema, value) {
	                    var errors = validator.validate(schema, sanitizeValidation(value));
	                    var field;
	
	                    var node = function node() {
	                        return field || (field = {
	                            value: value,
	                            bsStyle: isTouched(touched) && errors && 'error' || null,
	                            onChange: function onChange(eventOrValue) {
	                                var nextValue;
	                                if (eventOrValue && eventOrValue.target) {
	                                    nextValue = eventOrValue.target.value;
	                                } else {
	                                    nextValue = eventOrValue;
	                                }
	
	                                node._onChange(_defineProperty({}, property, sanitize(schema, nextValue)));
	                            }
	                        });
	                    };
	
	                    if (schema.items) {
	                        node.add = function (event) {
	                            var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	                            if (event) {
	                                event.preventDefault();
	                            }
	
	                            var arrayValue = value || [];
	                            var nextArrayValue = [item].concat(_toConsumableArray(arrayValue));
	
	                            node._onChange(_defineProperty({}, property, sanitize(schema, nextArrayValue)));
	                        };
	
	                        node.remove = function (event, item) {
	                            if (event) {
	                                event.preventDefault();
	                            }
	
	                            var arrayValue = value || [];
	                            var index = item && arrayValue.indexOf(item) || 0;
	                            if (index >= 0) {
	                                var nextArrayValue = [].concat(_toConsumableArray(arrayValue));
	                                nextArrayValue.splice(index, 1);
	
	                                if (nextArrayValue.length == 1 && !nextArrayValue[0]) {
	                                    // reset array
	                                    nextArrayValue = [];
	                                }
	
	                                node._onChange(_defineProperty({}, property, sanitize(schema, nextArrayValue)));
	                            }
	                        };
	
	                        node.size = function () {
	                            var arrayValue = value || [];
	                            return arrayValue.length;
	                        };
	                    }
	
	                    node.isRequired = function () {
	                        return !(schema.type && schema.type instanceof Array && schema.type.indexOf('null') >= 0);
	                    };
	
	                    node.isValid = function () {
	                        return errors == null;
	                    };
	
	                    return node;
	                }
	            }, {
	                key: 'getWrappedInstance',
	                value: function getWrappedInstance() {
	                    var wrappedInstance = this.refs.wrappedInstance;
	
	                    return wrappedInstance;
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    return _react2.default.createElement(WrappedComponent, _extends({ ref: 'wrappedInstance' }, this.props, this.state));
	                }
	            }]);
	
	            return FormConnector;
	        }(_react2.default.Component);
	
	        return FormConnector;
	    };
	}
	
	exports.connectForm = connectForm;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.sanitize = sanitize;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(925);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function sanitize(value) {
	    if (value) {
	        value = value.toString();
	        value = value === value.toUpperCase() && value.toLowerCase() || value;
	        value = value.charAt(0).toLowerCase() + value.slice(1);
	    }
	    return value;
	}
	
	var Icon = function (_Component) {
	    _inherits(Icon, _Component);
	
	    function Icon() {
	        _classCallCheck(this, Icon);
	
	        return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	    }
	
	    _createClass(Icon, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                icon = _props.icon,
	                size = _props.size,
	                count = _props.count,
	                active = _props.active,
	                status = _props.status,
	                other = _objectWithoutProperties(_props, ['icon', 'size', 'count', 'active', 'status']);
	
	            var iconClass = icon && sanitize(icon);
	            var sizeClass = size && size.toLowerCase();
	            var statusClass = status && status.toLowerCase();
	
	            return _react2.default.createElement(
	                'i',
	                _extends({
	                    className: (0, _classnames2.default)(_Icon2.default.default, _Icon2.default[iconClass], _Icon2.default[sizeClass], _defineProperty({}, _Icon2.default.active, active))
	                }, other),
	                count && _react2.default.createElement(
	                    'span',
	                    { className: (0, _classnames2.default)(_Icon2.default.count, _Icon2.default[statusClass]) },
	                    count
	                ) || null
	            );
	        }
	    }]);
	
	    return Icon;
	}(_react.Component);
	
	Icon.propTypes = {
	    icon: _react.PropTypes.string.isRequired,
	    size: _react.PropTypes.string.isRequired,
	    active: _react.PropTypes.bool,
	    count: _react.PropTypes.any,
	    status: _react.PropTypes.string
	};
	exports.default = Icon;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactBootstrap = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoaderButton = function (_Component) {
	    _inherits(LoaderButton, _Component);
	
	    function LoaderButton(props) {
	        _classCallCheck(this, LoaderButton);
	
	        var _this = _possibleConstructorReturn(this, (LoaderButton.__proto__ || Object.getPrototypeOf(LoaderButton)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(LoaderButton, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.loading != this.props.loading) {
	                var loading = nextProps.loading;
	
	                var element = (0, _reactDom.findDOMNode)(this);
	
	                this.setState({
	                    loading: loading,
	                    width: loading && element.offsetWidth - 1 || null
	                });
	            }
	        }
	    }, {
	        key: '_onClick',
	        value: function _onClick(event) {
	            var _this2 = this;
	
	            var onClick = this.props.onClick;
	
	
	            var result = onClick(event);
	            if (result && typeof result.then == 'function') {
	                var promise = result;
	                var element = (0, _reactDom.findDOMNode)(this);
	
	                this.setState({
	                    loading: true,
	                    width: element.offsetWidth - 1
	                });
	
	                promise.then(function () {
	                    _this2.setState({
	                        loading: false,
	                        width: null
	                    });
	                }).catch(function () {
	                    _this2.setState({
	                        loading: false,
	                        width: null
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                disabled = _props.disabled,
	                onClick = _props.onClick,
	                others = _objectWithoutProperties(_props, ['children', 'disabled', 'onClick']);
	
	            var _state = this.state,
	                loading = _state.loading,
	                width = _state.width;
	
	
	            var defaultStyle = { width: width };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Button,
	                _extends({
	                    style: defaultStyle,
	                    disabled: loading || disabled,
	                    onClick: function onClick(e) {
	                        return _this3._onClick(e);
	                    }
	                }, others),
	                loading && _react2.default.createElement(
	                    'span',
	                    null,
	                    '...'
	                ) || children
	            );
	        }
	    }]);
	
	    return LoaderButton;
	}(_react.Component);
	
	LoaderButton.propTypes = {};
	exports.default = LoaderButton;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        ticketsStatusEnum: {
	            opened: 'tickets non cloturés',
	            closed: 'tickets cloturés'
	        },
	        creationDateTimeFormat: '[Création] ' + _i18n.translations.fr.dateFormat.default + ' ' + _i18n.translations.fr.timeFormat.long,
	        searchStream: {
	            xs: 'rechercher',
	            sm: 'rechercher dans les tickets'
	        },
	        searchCity: {
	            xs: 'ville',
	            sm: 'rechercher votre ville'
	        },
	        searchCompany: {
	            xs: 'entreprise',
	            sm: 'rechercher votre entreprise'
	        },
	        searchAgency: {
	            xs: 'portefeuille',
	            sm: 'rechercher votre portefeuille'
	        },
	        searchPatrimony: {
	            xs: 'patrimoine',
	            sm: 'rechercher votre patrimoine'
	        },
	        searchCallPurpose: {
	            xs: 'type d\'incident',
	            sm: 'rechercher un type d\'incident'
	        },
	        searchProvider: 'rechercher un fournisseur',
	        searchIncident: 'rechercher un type d\'incident',
	        callPurposez: 'raison d\'appel',
	        callPurposezz: 'incident',
	        callPurpose: 'qualification',
	        callPurposes: 'types d\'incidents',
	        correctOtp: 'Corriger',
	        callPurposeEnum: {
	            alarm: 'Alarme',
	            barrier: 'Barrieres levantes',
	            boiler: 'Chaudiere',
	            bucket: 'Assainissement',
	            bugs: 'Insecte',
	            climber: 'Cordiste',
	            closedlock: 'Securite',
	            door: 'Porte de hall',
	            electricity: 'Electricite',
	            elevator: 'Ascenseur',
	            evacuate: 'Evacuation d\'un immeuble',
	            explosion: 'Incendie ou explosion sur site',
	            fence: 'Portail coulissant',
	            flood: 'Innondation',
	            gas: 'Stockage gaz',
	            gasvent: 'Vmc gaz',
	            heater: 'Chauffage',
	            hotwater: 'Eau chaude',
	            intercom: 'Interphone',
	            intrusionalarm: 'Detection intrusion',
	            keys: 'Serrurerie vitrerie menuiserie',
	            litter: 'Vide ordure',
	            masonry: 'Maconnerie',
	            message: 'Message',
	            monitoring: 'Loge telesurveille',
	            onduty: 'Astreinte',
	            openlock: 'Intrusion Gardiennage',
	            parkingvent: 'ventilation parking',
	            pipe: 'Debouchage',
	            plumber: 'Plomberie',
	            pressure: 'Surpresseur',
	            pump: 'Relevage',
	            relocate: 'Demande de relogement',
	            rollerblind: 'Volet Roulant HNO',
	            roof: 'Couverture Charpente',
	            smokevent: 'Desenfumage',
	            swimmingpool: 'Piscine',
	            tap: 'Engorgement eaux usees',
	            tv: 'Television',
	            vent: 'Vmc',
	            warning: 'Incident Grave',
	            waterdrop: 'Fuite eau',
	            window: 'Menuiserie vitrerie',
	            wrench: 'Multi-technique'
	        },
	        searchSummary: 'synthèse de recherche',
	        callerIdentity: 'identification appelant',
	        contactToCallback: 'personne à rappeler',
	        contactToCallbackSameAsCaller: 'la personne à rappeler est l\'appelant',
	        interventionLocation: 'lieu d\'intervention',
	        interventionMonitoring: 'suivi d\'intervention',
	        interventionReport: 'rapport d\'intervention',
	        interventionDetail: 'détail de l\'intervention',
	        interventionFilled: 'renseigner l\'intervention',
	        interventionTime: 'délai d\'intervention',
	        interventionTimeText: 'Délai entre la prise en charge d\'une mission par un fournisseur et le début de son intervention[[{token}. Ce délai ne respecte pas les engagements.]]',
	        interventionDuration: 'durée d\'intervention',
	        interventionDurationText: 'Intervalle de temps entre le début et la fin de l\'intervention',
	        interventionStartedDate: 'date d\'intervention',
	        interventionScheduledDate: 'date d\'intervention prévue',
	        repairTime: 'délai de réparation',
	        repairTimeText: 'Délai entre la prise en charge d\'une mission par un fournisseur et la fin de son intervention[[{token}. Ce délai ne respecte pas les engagements.]]',
	        callCenterResponseTime: 'délai de transmission',
	        callCenterResponseTimeText: 'Intervalle entre la création du ticket et la prise en charge par le fournisseur',
	        callCenterReactionTime: 'temps de réaction',
	        callCenterReactionTimeText: 'Intervalle entre la réception de la demande et la première action de l\'opérateur visant à sa résolution',
	        additionalData: 'informations complémentaires',
	        interventionAcceptation: 'prise en charge',
	        acceptIntervention: 'intervention acceptée',
	        refuseIntervention: 'intervention refusée',
	        changeRecourse: 'changer de recours',
	        journalEvent: 'journal du ticket',
	        journalEventEnum: {
	            callEmittedTo: {
	                phone: 'Appel sortant vers {called} sur {identifier}',
	                fax: 'Fax envoyé vers {called} sur {identifier}',
	                mail: 'Email envoyé à {called} ({identifier})',
	                sms: 'Sms envoyé à {called} sur {identifier}'
	            },
	            callReceived: {
	                phone: 'Appel reçu de {caller} ({identifier})',
	                fax: 'Fax reçu de {caller} ({identifier})',
	                mail: 'Email reçu de {caller} ({identifier})',
	                sms: 'Sms reçu de {caller} ({identifier})'
	            },
	            assigneeIdentified: {
	                recourseChanged: 'Changement de recours vers {assignee}',
	                initialIdentification: 'Le ticket est assigné à {assignee}'
	            },
	            instructionsForAssigneeDefined: 'une instruction a été définie pour {assignee}',
	            documentAttached: 'Le document {fileName} a été attaché au ticket',
	            sendingServiceOrderReported: 'OE {ref} envoyé le {sendingDate}',
	            callAnsweredByProvider: '{assignee} a répondu à l\'appel',
	            callNotAnsweredByProvider: '{assignee} ne répond pas à l\'appel',
	            interventionRequested: 'Intervention transmise par {medium} à {assignee} sur {identifier}',
	            interventionAccepted: 'Prise en charge par {assignee}',
	            notificationForInterventionAcceptedRequested: 'l\'envoi d’un email, vers {email}, {otherRecipients} a été déclenché',
	            interventionRefused: 'Intervention refusée par {assignee}',
	            ticketReopened: 'Ticket Réouvert par l\'opérateur',
	            logTrialAdded: '{trialLabel}',
	            messageAdded: 'Message : {message}',
	            ticketCancelled: 'Ticket annulé',
	            arrivedOnSite: 'Arrivée de {assignee} sur site',
	            goneFromSite: 'Départ de {assignee} du site',
	            interventionScheduled: 'Intervention prévue le {date} entre {startTime} et {endTime}',
	            interventionDeadlineDefined: 'Date butoir d\'intervention au {deadline}',
	            interventionStarted: 'Intervention débuté par {assignee}',
	            interventionFinished: 'Intervention terminée par {assignee}',
	            formalNoticeForProviderReported: 'Fournisseur mis en demeure au {deadline}',
	            ticketUpdated: 'Mise à jour du ticket par l\'opérateur',
	            ticketClosed: 'Ticket clos[[ - nature de la panne : {brakeDownNature}]]',
	            ticketArchived: 'Ticket archivé',
	            permanentlyFixed: 'Réparation définitive[[ - nature de la panne : {brakeDownNature}]]',
	            partiallyFixed: 'Réparation provisoire[[ - nature de la panne : {brakeDownNature}]]',
	            ticketClosedImpossibleRepair: 'Réparation impossible[[ - nature de la panne : {brakeDownNature}]]',
	            postponedFix: 'Réparation ajournée[[ - nature de la panne : {brakeDownNature}]]',
	            closedBeyondCallCenterScope: 'Hors périmètre',
	            closedAfterSeveralUnsuccessfulRecalls: 'Clôture suite à plusieurs relances infructueuses',
	            ticketInformationsCorrected: 'Correction des informations du ticket.[[ description: {new_request}.]][[ instructions: {new_instructions}.]][[ rapport: {new_closingReport}.]]',
	            ticketEventInformationsCorrected: 'Correction des informations d\'un évènement : {text}',
	            missionFinished: 'Mission finie pour {companyName}',
	            openingTicketPurposeCorrected: 'Diagnostique corrigé : {otpLabel}',
	            locationReferenceCorrected: 'Localisation corrigé',
	            callerCorrected: 'Appelant corrigé',
	            workflowAppliedToTicket: 'Workflow appliqué au ticket',
	            ticketQualifiedByCriteria: 'Critères de qualification appliqués',
	            contextualCommentDisplayedOnTicket: 'Commentaire contextuel affiché sur le ticket',
	            accessRestrictedToTicket: 'Ticket à accès restreint'
	        },
	        stateEnum: {
	            ticketOpened: 'ticket ouvert',
	            assigneeIdentified: 'fournisseur identifié',
	            interventionAccepted: 'pris en charge par le fournisseur',
	            interventionStarted: 'intervention en cours',
	            interventionFinished: 'intervention en cours',
	            ticketClosed: 'ticket clos',
	            ticketArchived: 'ticket archivé',
	            ticketCancelled: 'Ticket annulé',
	            permanentlyFixed: 'réparation définitive',
	            partiallyFixed: 'réparation partielle',
	            ticketClosedImpossibleRepair: 'réparation impossible',
	            postponedFix: 'réparation ajournée',
	            closedBeyondCallCenterScope: 'Hors périmètre',
	            closedAfterSeveralUnsuccessfulRecalls: 'fermé après plusieurs appels infructueux'
	        },
	        newTicket: 'nouveau ticket',
	        newTicketText: ['Des tickets similaires existent', 'Etes vous sûr de vouloir créer un nouveau ticket ?'],
	        newTickets: 'tickets',
	        existingTickets: 'tickets existants',
	        openTicket: 'ouvrir le ticket',
	        closeTicket: 'clôturer le ticket',
	        closingReport: 'rapport de clôture',
	        identifyAssignee: 'identifier l\'intervenant',
	        patrimonyProviderContacts: 'Intervenants du client',
	        patrimonyProviderContactsz: 'qualifiés',
	        otherProviderContacts: 'Autres contacts',
	        otherProviderContactsz: 'autres',
	        activityProviderCompanies: 'Fournisseurs du centre d\'appel',
	        periodTickets: 'tickets sur la periode',
	        periodTicketsText: '{count} tickets ont été créés sur la période du {from} au {to}',
	        lastWeek: 'semaine dernière',
	        lastWeekTickets: 'tickets la semaine dernière',
	        lastWeekTicketsText: '{count} tickets ont été créés au cours de la semaine dernière',
	        thisMonth: 'mois actuel',
	        thisMonthTickets: 'tickets ce mois-ci',
	        thisMonthTicketsText: '{count} tickets ont été créés au cours de ce mois-ci',
	        lastMonth: 'mois dernier',
	        lastMonthTickets: 'tickets le mois dernier',
	        lastMonthTicketsText: '{count} tickets ont été créés au cours du mois dernier',
	        ticketsDistribution: 'répartition des tickets',
	        ticketsCreationFrequency: 'fréquence de création de tickets',
	        dailyCreatedTicketCount: 'nombre de tickets créés par jour',
	        ticketsDashboardStatusEnum: {
	            opened: 'non cloturés',
	            closed: 'cloturés'
	        },
	        ticketsInterventionEnum: {
	            with: 'pris en charge',
	            without: 'non pris en charge'
	        },
	        agency: 'portefeuille',
	        correctLocationReference: 'Corriger le lieu d\'intervention',
	        correctCaller: 'Corriger l\'appelant',
	        agencies: 'portefeuilles',
	        byAgency: 'par portefeuille',
	        assignee: 'intervenant',
	        assigneeTypeEnum: {
	            providerContact: 'Intervenant du client',
	            providerCompany: 'Fournisseur externe',
	            anonymous: 'Intervenant annonyme'
	        },
	        provider: 'intervenant',
	        providers: 'fournisseurs',
	        providersTop10: 'top 10 des fournisseurs',
	        patrimony: 'patrimoine',
	        patrimonies: 'patrimoines',
	        patrimoniesTop10: 'top 10 des patrimoines',
	        company: 'société',
	        closingRate: 'taux de clôture',
	        closingEvent: 'type de clôture',
	        aboutClosingRate: 'Pour en savoir plus sur le taux de clôture de vos dossiers, contactez votre service clients',
	        summary: 'synthèse',
	        diagnostic: 'diagnostic',
	        seekSupport: 'solliciter',
	        supportUserEnum: {
	            manager: 'manager',
	            admin: 'admin',
	            inspector: 'inspecteur',
	            careTaker: 'gardien',
	            administrator: 'gestionnaire'
	        },
	        request: 'description du problème',
	        instructions: 'instruction interne non visible par les résidents',
	        response: 'réponse à l\'appelant',
	        addAddress: 'ajouter une adresse',
	        addAddressCity: 'code postal, ville',
	        addAddressStreet: 'numéro, adresse',
	        cmdTypeEnum: {
	            fixPermanently: 'réparation définitive',
	            fixPartially: 'réparation provisoire',
	            postponeFix: 'réparation ajournée',
	            closeTicketImpossibleRepair: 'réparation impossible',
	            closeBeyondCallCenterScope: 'hors périmètre',
	            cancelTicket: 'annulation du ticket'
	        },
	        mediumTypeEnum: {
	            phone: 'tél',
	            fax: 'fax',
	            mail: 'email'
	        },
	        mediumTypezEnum: {
	            phone: 'téléphone',
	            fax: 'fax',
	            mail: 'email'
	        },
	        scheduleIntervention: 'Programmer l\'intervention',
	        startInterventionDate: 'Début d\'intervention',
	        finishInterventionDate: 'Fin d\'intervention',
	        addMessage: 'Ajouter un message',
	        percentage: 'pourcentage',
	        exportTickets: 'Télécharger le rapport',
	        exportXlsxTickets: 'Télécharger le rapport Excel',
	        exportPdfTickets: 'Télécharger le rapport PDF',
	        exportingTickets: 'Téléchargement en cours',
	        ticketExportEnum: {
	            exportXlsx: 'Export excel',
	            exportPdf: 'Liasse de tickets',
	            reportPdf: 'Rapport de gestion'
	        },
	        xlsxTicketSheet: 'Tickets',
	        xlsxTicketSheetColumnEnum: {
	            ref: 'numéro de ticket',
	            created: 'date de création',
	            agency: 'agence',
	            callerName: 'appelant',
	            callerPhone: 'téléphone',
	            callerEmail: 'email',
	            request: 'description',
	            callPurpose: 'type d\'incident',
	            assigneeName: 'intervenant',
	            assigneePhone: 'tel intervenant',
	            assigneeType: 'type d\'intervenant',
	            serviceOrderRef: 'n° OE',
	            serviceOrderSendingDate: 'date d\'envoi de l\'OE',
	            interventionScheduledStartDate: 'rendez-vous (au plus tôt)',
	            interventionScheduledEndDate: 'rendez-vous (au plus tard)',
	            interventionDeadline: 'date butoir',
	            formalNoticeDate: 'date MED',
	            formalNoticeDeadline: 'date butoir MED',
	            addressStreet: 'adresse',
	            addressZipCode: 'code postal',
	            addressCity: 'ville',
	            addressFloor: 'étage',
	            addressUnit: 'numéro d\'appartement',
	            addressEntrance: 'entrée',
	            addressElevator: 'ascenseur',
	            addressStaircase: 'escalier',
	            addressBuilding: 'bâtiment',
	            addressComplement: 'complément d\'adresse',
	            missionFinished: 'mission terminée',
	            freeComments: 'commentaires',
	            status: 'statut',
	            state: 'etat'
	        },
	        xlsxAgencySheet: 'Répartition par agence',
	        xlsxAgencySheetColumnEnum: {
	            label: 'agence',
	            count: 'nombre de tickets'
	        },
	        xlsxCallPurposeSheet: 'Répartition par type d\'incident',
	        xlsxCallPurposeSheetColumnEnum: {
	            value: 'type d\'incident',
	            count: 'nombre de tickets'
	        },
	        xlsxProviderSheet: 'Répartition par fournisseur',
	        xlsxProviderSheetColumnEnum: {
	            label: 'fournisseurs',
	            count: 'nombre de tickets'
	        },
	        pdfExportPageEnum: {
	            journal: 'journal'
	        },
	        pdfReportPageEnum: {
	            agency: 'portefeuilles',
	            patrimony: 'patrimoines',
	            provider: 'fournisseurs'
	        },
	        pdfStatusEnum: {
	            closed: 'tx clôture'
	        },
	        pdfInterventionEnum: {
	            with: '   tx   P.E.C'
	        },
	        pdfPatrimonyTable: 'top 10 des patrimoines les plus consommateurs',
	        pdfPatrimonyTableColumnEnum: {
	            label: 'patrimonies',
	            count: 'tickets',
	            percentage: 'en %',
	            closingRate: 'tx clôture',
	            interventionRate: 'tx P.E.C.'
	        },
	        pdfPatrimonyChart: 'comparatif avec la période précédente',
	        pdfProviderTable: 'top 10 des fournisseurs les plus actifs',
	        pdfProviderTableColumnEnum: {
	            label: 'fournisseurs',
	            count: 'tickets',
	            percentage: 'en %',
	            closingRate: 'tx clôture',
	            interventionRate: 'tx P.E.C.'
	        },
	        pdfProviderChart: 'fiabilité des fournisseurs',
	        pdfProviderChartAxisEnum: {
	            x: 'taux de réparation définitive',
	            y: 'délai de prise en charge'
	        },
	        pdfAgencyTable: 'top 10 des portefeuilles les plus consommateurs',
	        pdfAgencyTableColumnEnum: {
	            label: 'portefeuilles',
	            count: 'tickets',
	            percentage: 'en %',
	            closingRate: 'tx clôture',
	            interventionRate: 'tx P.E.C.'
	        },
	        pdfAgencyChart: 'performance de gestion des demandes',
	        pdfCallPurposeTable: 'répartition des types de demande',
	        pdfCallPurposeTableColumnEnum: {
	            label: 'types de demandes',
	            count: 'tickets',
	            percentage: 'en %',
	            closingRate: 'tx clôture',
	            interventionRate: 'tx P.E.C.'
	        },
	        pdfTicketOpened: 'tickets ouverts',
	        pdfTicketClosed: 'tickets clôturés',
	        pdfWithIntervention: 'pris en charge',
	        pdfWithoutIntervention: 'non pris en charge',
	        pdfWithInterventionIndex: 'P.E.C. : prise en charge',
	        pdfPreviousPeriodIndex: 'Barre claire : période précédente',
	        reportSendingServiceOrder: 'envoyer un OE',
	        serviceOrder: 'OE {ref} envoyé le {sendingDate}',
	        serviceOrderRef: 'n° OE',
	        serviceOrderDate: 'date d\'envoi de l\'OE',
	        defineInterventionDeadline: 'définir une date butoir',
	        reportFormalNoticeForProvider: 'mettre en demeure l\'intervenant',
	        correctTicketInformations: 'corriger le ticket',
	        correctTicketEventInformations: 'corriger',
	        receiveCallz: 'recevoir un appel',
	        receiveCallzAction: 'interaction entrante',
	        receiveCallzEnum: {
	            receiveCall: 'autre',
	            receiveCallFromAssignee: 'intervenant',
	            receiveCallFromCaller: 'appelant',
	            receiveCallFromContactToCallback: 'personne à rappeler'
	        },
	        receiveCallEnum: {
	            receiveCall: 'appel reçu',
	            receiveCallFromAssignee: 'appel reçu de l\'intervenant',
	            receiveCallFromCaller: 'appel reçu de l\'appelant',
	            receiveCallFromContactToCallback: 'appel reçu de la personne à rappeler'
	        },
	        emitCallz: 'émettre un appel',
	        emitCallzAction: 'interaction sortante',
	        emitCallzEnum: {
	            emitCall: 'autre',
	            emitCallToAssignee: 'intervenant',
	            emitCallToCaller: 'appelant',
	            emitCallToContactToCallback: 'personne à rappeler'
	        },
	        emitCallEnum: {
	            emitCall: 'appel émis',
	            emitCallToAssignee: 'appel émis vers l\'intervenant',
	            emitCallToCaller: 'appel émis vers l\'appelant',
	            emitCallToContactToCallback: 'appel émis vers la personne à rappeler'
	        },
	        updateTicket: 'actions',
	        caller: 'appelant',
	        recipientSupplementEnum: {
	            floor: 'étage',
	            unit: 'numéro d\'appartement',
	            entrance: 'entrée',
	            elevator: 'ascenseur',
	            staircase: 'escalier'
	        },
	        geographicalSupplementEnum: {
	            building: 'bâtiment'
	        },
	        pickCompany: 'choisir une entreprise',
	        nameType: 'type de contact',
	        nameTypeEnum: {
	            civilName: 'individu',
	            poorName: 'service'
	        },
	        gender: 'civilité',
	        genderEnum: {
	            male: 'M.',
	            female: 'Mme.'
	        },
	        contactDetails: 'contexte de l\'appel',
	        contactDetailsText: 'Merci de renseigner un moyen de contact',
	        maxTicketPdfExportSizeExceeded: 'L\'export PDF est limité à 350 tickets',
	        managementReport: 'de gestion',
	        managementReportPeriod: 'pour la période du {from} au {to}',
	        reportPdfInfo: 'Une période par défaut d\'un an est sélectionnée pour l\'export du rapport de gestion',
	        openingTicketInstruction: 'instruction',
	        acknowledgeInstruction: 'j\'ai pris connaissance de l\'instruction',
	        emitCallHintEnum: {
	            assigneeInterventionTransfer: 'Transmission de l\'intervention',
	            assigneeIncidentAggravation: 'Agravation de l\'incident',
	            assigneeRemindIntervention: 'Relancer d\'intervention',
	            assigneeOther: 'Autre',
	            callerIncidentAggravation: 'Agravation de l\'incident',
	            callerAcceptIntervention: 'Prise en charge de l\'intervention',
	            callerComplementaryInformation: 'Informations complémentaires',
	            callerContactWithCompany: 'Prise de contact de l\'entreprise',
	            callerSatisfaction: 'Contact satisfaction',
	            callerOther: 'Autre'
	        },
	        emitCallCommentEnum: {
	            assigneeIncidentAggravation: 'Nous avons contacté {name} au {phone} pour lui indiquer que l\'incident s\'est agravé. Précisions : ',
	            assigneeRemindIntervention: 'Nous avons contacté {name} au {phone} pour relancer l\'intervention. Précisions : ',
	            assigneeOther: 'Nous avons contacté {name} au {phone} pour : ',
	            callerIncidentAggravation: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour lui demander si l\'incident ne s\'était pas agravé. Précisions : ',
	            callerAcceptIntervention: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour l\'informer que l\'intervention est prise en charge. Précisions : ',
	            callerComplementaryInformation: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour avoir des informations complémentaires sur l\'intervention. Précisions : ',
	            callerContactWithCompany: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour lui demander si l\'entreprise l\'a bien contactée. Précisions : ',
	            callerSatisfaction: 'Nous avons contacté [[{firstName} {lastName}]]{value} au Téléphone pour connaitre sa satisfaction',
	            callerOther: 'Nous avons contacté [[{firstName} {lastName}]]{value} au {phone} pour : '
	        },
	        receiveCallHintEnum: {
	            assigneeComplementaryInformation: 'Infos complémentaires',
	            assigneeInterventionAdditionalContactInformation: 'Précisions sur les coordonnées de l\'intervention',
	            assigneeInterventionCancellation: 'Annulation de l\'intervention',
	            assigneeInterventionAcceptation: 'Acceptation de l\'intervention',
	            assigneeImpossibleAccess: 'Accès impossible',
	            assigneeScheduleIntervention: 'Programmation de l\'intervention',
	            assigneeOther: 'Autre',
	            callerIncidentAggravation: 'Agravation de l\'incident',
	            callerProviderPassed: 'Information passage du technicien',
	            callerComplementaryInformation: 'Informations complémentaires',
	            callerIncidentAccess: 'Infos d\'accès à l\'incident',
	            callerOther: 'Autre'
	        },
	        receiveCallCommentEnum: {
	            assigneeComplementaryInformation: '{name} nous a contacté pour avoir des informations complémentaires. Précisions : ',
	            assigneeInterventionAdditionalContactInformation: '{name} nous a contacté pour demander des précisions sur les coordonnées de l\'intervention. Précisions : ',
	            assigneeInterventionCancellation: '{name} nous a contacté pour nous dire qu\'il n\'interviendra pas. Précisions : Intervention acceptée par l\'intervenant/ intervention refusée / A préciser dans le commentaire',
	            assigneeInterventionAcceptation: '{name} nous a contacté pour nous dire qu\'il interviendra. A préciser dans le commentaire',
	            assigneeImpossibleAccess: '{name} nous a contacté pour nous dire qu\'il n\'a pas accès à l\'instalation. A préciser dans le commentaire',
	            assigneeScheduleIntervention: '{name} nous a contacté pour nous dire qu\'il programme l\'intervention. Précisions : Intervention acceptée par l\'intervenant/ intervention refusée / A préciser dans le commentaire',
	            assigneeOther: '{name} nous a contacté pour : ',
	            callerIncidentAggravation: '{name} nous a contacté pour  nous dire que l\'incident s\'était agravé. Précisions : ',
	            callerProviderPassed: '{name} nous a contacté pour nous demander quant l\'entreprise allait passer. Précisions : ',
	            callerComplementaryInformation: '{name} nous a contacté pour  avoir des informations complémentaires. Précisions : ',
	            callerIncidentAccess: '{name} nous a contacté pour nous donner des informations complémentaires pour accéder à l\'incident. Précisions : ',
	            callerOther: '{name} nous a contacté pour : '
	        },
	        openTicketLocationHintEnum: {
	            unknownArea: 'Cet incident a été détecté comme étant impossible à localiser précisément',
	            commomArea: 'Cet incident a été détecté comme étant situé dans les parties communes',
	            privateAreaExtending: 'Cet incident a été détecté comme étant situé exclusivement dans les parties privatives mais pouvant atteindre les parties communes',
	            privateArea: 'Cet incident a été détecté comme étant situé exclusivement dans les parties privatives',
	            otherArea: 'Autre'
	        },
	        openTicketSeverityHintEnum: {
	            unknownSeverity: 'Nous attendons des informations complémentaires sur la gravité de la demande',
	            urgentSeverity: 'Cet incident a été détecté comme urgent',
	            notUrgentSeverityExtending: 'Cet incident a été détecté comme pouvant devenir rapidement urgent',
	            notUrgentSeverity: 'Cet incident a été détecté comme non urgent'
	        },
	        openTicketResponseEnum: {
	            unknownAreaUnknownSeverity: 'Nous mettons la demande d\'intervention en stand by, le temps de récolter des informations complémentaires',
	            commomAreaUnknownSeverity: 'Nous mettons la demande d\'intervention en stand by, le temps de récolter des informations complémentaires',
	            privateAreaExtendingUnknownSeverity: 'Nous mettons la demande d\'intervention en stand by, le temps de récolter des informations complémentaires',
	            privateAreaUnknownSeverity: 'Nous mettons la demande d\'intervention en stand by, le temps de récolter des informations complémentaires',
	            unknownAreaUrgentSeverity: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
	            commomAreaUrgentSeverity: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
	            privateAreaExtendingUrgentSeverity: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
	            privateAreaUrgentSeverity: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
	            unknownAreaNotUrgentSeverityExtending: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
	            commomAreaNotUrgentSeverityExtending: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
	            privateAreaExtendingNotUrgentSeverityExtending: 'Nous ne pouvons déclencher l\'intervention car l\'incident est privative et ne peut engendrer des dégâts sur les parties communes, nous vous conseillons d\'attendre des horaires de jour pour appeler un professionnel. Nous transmettons notre conversation à votre gestionnaire',
	            privateAreaNotUrgentSeverityExtending: 'Nous déclenchons une intervention auprès d\'un prestataire spécialisé, en précisant au client que l\'intervention lui sera refacturée. Nous vous recontactons rapidement afin de vous préciser le nom du prestataire et l\'heure d\'intervention prévisionnelle',
	            unknownAreaNotUrgentSeverity: 'Nous ne pouvons déclencher l\'intervention car l\'incident est privative et ne peut engendrer des dégâts sur les parties communes. Nous transmettons la demande à votre gestionnaire',
	            commomAreaNotUrgentSeverity: 'Nous ne pouvons déclencher l\'intervention car l\'incident n\'a pas de caractère d\'urgence. Nous transmettons la demande à votre gestionnaire',
	            privateAreaExtendingNotUrgentSeverity: 'Nous ne pouvons déclencher l\'intervention car l\'incident est privative et ne peut engendrer des dégâts sur les parties communes. Nous transmettons la demande à votre gestionnaire',
	            privateAreaNotUrgentSeverity: 'Nous ne pouvons déclencher l\'intervention car l\'incident est privative et ne peut engendrer des dégâts sur les parties communes. Nous transmettons la demande à votre gestionnaire'
	        },
	        phonePlaceholder: '#Téléphone',
	        namePlaceholder: '#Nom',
	        incidentLocation: 'Situation',
	        incidentSeverity: 'Gravité',
	        incidentResponse: 'Réponse à l\'appelant',
	        noTicketInfo: 'aucune information n\'est disponible',
	        satisfaction: 'satisfaction',
	        openTicketSteps: {
	            identify: 'identification',
	            contactToCallback: 'contact',
	            request: 'diagnostic',
	            response: 'réponse'
	        },
	        callbackContact: 'rappeler {name}',
	        interventionCmdTypeEnum: {
	            'acceptIntervention': 'Accepte l\'intervention',
	            'refuseIntervention': 'Refuse l\'intervention'
	        },
	        requestInterventionAcceptedNotificationCmdTypeEnum: {
	            'sendNotif': 'Confirmer l\'email {email} pour envoi du bon d\'intervention',
	            'doNotSendNotif': 'Ne pas envoyer de bon d\'intervention'
	        },
	        finishMission: 'finir la mission',
	        finishMissionHintEnum: {
	            'scheduleInterventionManager': 'Intervention a planifier en heure ouvrée suivant le choix du gestionnaire',
	            'interventionPostponed': 'Intervention différée en heure ouvrée grâce aux conseil du téléconseiller',
	            'scheduleInterventionSelf': 'Intervention a planifier en heure ouvrée : à vérifier par vos soins',
	            'interventionPaused': 'Intervention en standby a traiter en journée',
	            'interventionImpossible': 'Intervention impossible, aucun prestataire de référencé',
	            'interventionInProgress': 'Intervention en cours, vérifiez la bonne exécution de la réparation',
	            'interventionResolved': 'Incident solutionné grâce aux conseil du téléconseiller',
	            'otherInterventiom': 'Incident divers à gérer en heure ouvrée'
	        },
	        finishedMissionEvent: 'a terminé sa mission',
	        callerStatus: 'Statut de l\'appelant',
	        callerStatuses: ['Gestionnaire', 'Membre conseil syndical', 'Président CS', 'Gardien', 'Locataire', 'Co-propriétaire'],
	        restrictedAccess: 'Ticket à diffusion restreinte',
	        interventionModalDetail: 'finalite de l\'appel',
	        bonDintervention: 'bon d\'intervention'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(134)('wks');
	var uid = __webpack_require__(101);
	var Symbol = __webpack_require__(16).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(914)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(63);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(18)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _browser = __webpack_require__(54);
	
	function brand() {
	    return location.hostname.split('.')[0].replace(/[_-]/g, '');
	}
	
	var config = {
	    env: ("production") || 'development',
	    https: process.env.HTTPS == 'true',
	    api: {
	        url: (true) && ((0, _browser.supportCORS)() && ("https://dashboard-back-prod.performance-immo.com/api/v1") || '/api/v1') || ("https://dashboard-back-prod.performance-immo.com/api/v1"),
	        event: {
	            url: (true) && ((0, _browser.supportCORS)() && ("https://dashboard-back-prod.performance-immo.com/api/vEvent") || '/api/vEvent') || ("https://dashboard-back-prod.performance-immo.com/api/vEvent")
	        },
	        front: {
	            url: '/api/vFront'
	        }
	    },
	    socket: {
	        front: {
	            url: '/socket/vFront',
	            protocol: 'v1'
	        }
	    },
	    audit: {
	        url: (undefined) || 'http://localhost:9000',
	        api: {
	            url: (true) && ((0, _browser.supportCORS)() && (undefined) || '/audit/api') || (undefined)
	        }
	    },
	    ticketHelper: {
	        api: {
	            url: (true) && ((0, _browser.supportCORS)() && ("https://prod-tickethelper.performance-immo.com/api/v1") || '/tickethelper/api/v1') || ("https://prod-tickethelper.performance-immo.com/api/v1")
	        }
	    },
	    administrativeDivision: {
	        api: {
	            url: (true) && ((0, _browser.supportCORS)() && (("https://administrativedivision-prod.performance-immo.com") || 'unset') || '/administrativedivision') || ("https://administrativedivision-prod.performance-immo.com")
	        }
	    },
	    google: {
	        apiKey: ("AIzaSyAKSKAHrN7_NVXuXmNtt6K_3U0noYKO4G8")
	    },
	    intercom: {
	        appId: ("pjmzx202")
	    },
	    resource: (true) && ({"excelia":{"logo":{"url":"//res.cloudinary.com/performance-immo/image/upload/c_scale,h_90/v1504170893/excelia/logo.jpg"},"welcome":{"text":"**Adresse**\\\n67 route de la reine\\\n92100 Boulogne\\\n\\\n**Pour toute demande :**\\\n\\\nreclamation@excelia.eu\\\n01 41 22 55 38","url":"//res.cloudinary.com/performance-immo/image/upload/c_scale,h_90/v1504170893/excelia/logo.jpg"}},"nexity":{"welcome":{"url":"//res.cloudinary.com/performance-immo/image/upload/c_scale,h_90/v1554991328/nexity/documents/logo.png","text":"**Adresse**\\\n67 route de la reine\\\n92100 Boulogne\\\n\\\n**Pour toute demande :**\\\n\\\nreclamation@excelia.eu\\\n01 41 22 55 38"},"logo":{"url":"//res.cloudinary.com/performance-immo/image/upload/c_scale,h_90/v1554991328/nexity/documents/logo.png"}},"homeland":{"logo":{"url":"//res.cloudinary.com/performance-immo/image/upload/c_scale,h_90/v1494922952/homeland/logo.png"}},"convergence":{"logo":{"url":"//res.cloudinary.com/performance-immo/image/upload/c_scale,h_90/v1466683570/convergence/logo.jpg"}}})[brand()] || {},
	    data: {
	        providerCoverageCriteriaActivityUids: (true) && ({"providercoveragecriteriaactivityuids":["7699d009-a392-4921-ae43-910b27c1b586","93d9d38c-ba25-40db-8b62-f193cb218fec","d0781a04-91bc-491f-a42d-f4ca6d6067da","9d385a3e-a76f-42f9-baac-24d287266897","8e58d6cc-bdbb-4419-999a-1c1104679c38"]})['providercoveragecriteriaactivityuids'] || ['dqsmlkdmsqlkdmqslkdmqslk']
	    },
	    feature: {
	        audit: (undefined) == 'true'
	    },
	    whiteMark: {
	        titlePrefix: ("Performance IMMO"),
	        bottomLogo: ("//res.cloudinary.com/performance-immo/image/upload/v1575639875/logo-sm_a5tygw.png"),
	        bottomLogoLink: ("https://www.performance-immo.com"),
	        cguLink: ("http://www.performance-immo.com/cgps/")
	    }
	};
	
	exports.default = config;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(11);
	var IE8_DOM_DEFINE = __webpack_require__(289);
	var toPrimitive = __webpack_require__(69);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(1247);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(1246);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(2108);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(2107);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(67);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.linkFinder = linkFinder;
	exports.relFinder = relFinder;
	exports.relFilter = relFilter;
	function linkFinder(rels) {
	    rels = rels instanceof Array && rels || [rels];
	
	    return function (link) {
	        return rels.find(function (r) {
	            return r == link.rel;
	        }) != null;
	    };
	}
	
	function relFinder(links) {
	    return function (rel) {
	        return links.find(function (l) {
	            return l.rel == rel;
	        }) != null;
	    };
	}
	
	function relFilter(links) {
	    return function (rel) {
	        return links.find(function (l) {
	            return l.rel == rel;
	        }) != null;
	    };
	}

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        errorTypeEnum: {
	            impossibleToPerfomCommandOnNonExistingProviderCompany: 'Votre demande est invalide',
	            activityAlreadyAssignedToProviderCompany: 'Cette activité est déjà associée à ce fournisseur',
	            activityIsNotAssignedToProviderCompany: 'Cette activité n\'est pas associée à ce fournisseur',
	            callOutChargeRangeOverlapExistingCallOutChargeRange: 'Les distances d\'intervention ne sont pas contiguës',
	            callOutChargeRangeDoesNotTouchAnotherExistingCallOutChargeRange: 'Les distances d\'intervention ne sont pas contiguës',
	            interventionPeriodOverlapAnothers: 'Des périodes d\'intervention se chevauchent',
	            interventionPeriodDefinedAsReferenceCanNotBeRemovedIfNotTheOnlyOne: 'La période d\'intervention de référence ne peut être supprimée',
	            impossibleToDefineServiceChargeInPercentageForAReferencePeriod: 'Le tarif de la période d\'intervention de référence ne peut pas être un pourcentage',
	            impossibleToRemoveActivityBecauseOfLinkedInterventionPeriod: 'Des périodes d\'intervention sont définies pour cette activité',
	            openingTicketPurposesNotAvailableForThisProviderContact: 'Une raison d\'ouverture de ticket n\'est pas disponible pour ce contact fournisseur',
	            openingTicketPurposesNotAvailableForThisInterventionPeriod: 'Une raison d\'ouverture de ticket n\'est pas disponible pour cette période d\'intervention',
	            timelimitsCantBeDefinedWithSameOpeningTicketPurposes: 'Une raison d\'ouverture de ticket ne peut avoir qu\'un seul délai',
	            repairTimelimitShouldBeGreaterThanCorrespondingInterventionTimelimit: 'Le délai maximal de réparation d\'une raison d\'ouverture de ticket doit être suppérieur à celui d\'intervention',
	            interventionPeriodIsIncoherent: {
	                startDateIsNotMinusThanEndDate: 'La date de début doit précéder la date de fin',
	                onePeriodRangeHaveDuplicateWeekDay: 'Des jours de la semaine sont dupliqués',
	                onePeriodRangeHaveItsTimeslotThatOverlap: 'Des plages horaires se chevauchent',
	                periodRangeOverlapAnotherOne: 'Des périodes se chevauchent',
	                exclusionsHaveDuplicateSpecificDays: 'Des exclusions comportent des jours dupliqués',
	                oneDayOfExclusionsHaveTimeslotThatOverlap: 'Des exclusions comportent des plages horaires se chevauchant',
	                specificDaysPeriodHaveDuplicateDays: 'Des jours spécifiques sont dupliqués',
	                specificDaysPeriodHaveTimeslotsThatOverlap: 'Des jours spécifiques comportent des plages horaires se chevauchant'
	            }
	        },
	        searchStream: {
	            xs: 'rechercher',
	            sm: 'rechercher un fournisseur'
	        },
	        searchCoverage: {
	            xs: 'couverture',
	            sm: 'couverture fournisseur'
	        },
	        searchProviderContactStream: {
	            xs: 'rechercher',
	            sm: 'rechercher un contact fournisseur'
	        },
	        searchActivity: {
	            xs: 'rechercher',
	            sm: 'rechercher une activité'
	        },
	        searchSummary: 'synthèse de recherche',
	        useSearchProviderFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
	        provider: 'fournisseur',
	        providerz: 'entreprise',
	        providersz: 'entreprises',
	        newProvider: 'nouveau fournisseur',
	        selectProvider: 'choisir un fournisseur',
	        providerDirectory: 'annuaire',
	        useSearchProviderContactFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
	        providerContact: 'contact fournisseur',
	        providerContacts: 'contacts fournisseur',
	        providerContactz: 'contact',
	        providerContactsz: 'contacts',
	        newProviderContact: 'nouveau contact fournisseur',
	        updateProviderContact: 'modification',
	        myProviderContacts: 'mes fournisseurs',
	        patrimonyProviderContactText: 'le fournisseur à été affilié au patrimoine',
	        agencyProviderContactText: 'le fournisseur est référencé sur le portefeuille du patrimoine',
	        contactInformation: 'coordonnées',
	        providers: 'fournisseurs',
	        tickets: 'tickets',
	        synthesis: 'synthèse',
	        siret: 'siret',
	        documents: 'documents',
	        interventionDelay: 'délai d\'intervention',
	        interventionDelayText: 'Délai entre la prise en charge d\'une mission par un fournisseur et le début de son intervention',
	        interventionNumber: 'nombre d\'interventions',
	        interventionNumberText: 'comptées sur une période',
	        missionAcceptedDelay: 'délai de prise en charge',
	        missionAcceptedDelayText: 'Délai entre le premier appel au fournisseur et la prise en charge effective de la mission par celui-ci',
	        repairDelay: 'délai de réparation',
	        repairDelayText: 'Délai entre la prise en charge d\'une mission par un fournisseur et la fin de son intervention',
	        callBeforeMissionAccepted: 'nombre d\'appels avant prise en charge',
	        callBeforeMissionAcceptedText: 'Nombre d\'appels émis vers un fournisseur avant qu\'il prenne en charge la mission',
	        intervention: 'intervention',
	        missionAccepted: 'prise en charge',
	        repair: 'réparation',
	        delays: 'délais',
	        callCount: 'nombre d\'appels',
	        selectDateRange: 'sélectionner une période',
	        filterStats: 'filtrer les statistiques',
	        interventionCount: 'nombre d\'interventions',
	        scores: 'indicateurs de confiance',
	        undeclaredWorkReportState: {
	            xs: 'TD',
	            sm: 'travail dissimulé'
	        },
	        insuranceReportState: {
	            xs: 'AS',
	            sm: 'assurances'
	        },
	        specificDocumentsReportState: {
	            xs: 'SP',
	            sm: 'spécifique actradis'
	        },
	        associateProvider: 'associer un fournisseur',
	        associateDissociatePatrimonies: 'patrimoines',
	        assignRemoveActivities: 'activités',
	        addActivity: 'ajouter une activité',
	        batiref: 'Batiref',
	        actradis: 'Actradis',
	        actradisReportStateEnum: {
	            ok: 'les documents {text} sont valides',
	            documentExpiredInLessThan15Days: 'les documents {text} sont sur le point d\'expirer',
	            documentExpired: 'les documents {text} ont expiré',
	            noDocument: 'les documents {text} sont indisponibles'
	        },
	        nameType: 'type de contact',
	        nameTypeEnum: {
	            civilName: 'individu',
	            poorName: 'service'
	        },
	        gender: 'civilité',
	        genderEnum: {
	            male: 'M.',
	            female: 'Mme.'
	        },
	        statsCorrupted: 'Certaines données sont invalides',
	        activity: 'activité',
	        activities: 'activités',
	        activitiez: 'activité(s)',
	        byActivity: 'par activité',
	        assignActivity: 'associer une activité',
	        unAssignActivity: 'dissocier l\'activité',
	        unAssignActivityText: ['Vous êtes sur le point de dissocier l\'activité {label}.'],
	        newInterventionPeriod: 'nouvelle période d\'intervention',
	        removeInterventionPeriod: 'supprimer la période d\'intervention',
	        removeInterventionPeriodText: ['Vous êtes sur le point de supprimer la période d\'intervention {label}.'],
	        interventionZone: 'zone d\'intervention',
	        serviceCharge: 'tarif horaire',
	        percentageServiceChargeInfo: '{percentage} % du tarif de référence',
	        callOutCharge: 'frais de déplacement',
	        startRange: 'distance minimale',
	        endRange: 'distance maximale',
	        periodTypeEnum: {
	            dateTimePeriod: 'période',
	            weekDaysPeriod: 'jours de la semaine',
	            specificDaysPeriod: 'jours spécifiques'
	        },
	        timeSlot: 'plage horaire',
	        addTimeSlot: 'ajouter une plage horaire',
	        removeTimeSlot: 'supprimer la plage horaire',
	        timeSlotTypeEnum: {
	            allDayLong: 'toute la journée',
	            hourPeriods: 'plage horaire'
	        },
	        chargeTypeEnum: {
	            chargePercentage: '%',
	            fixChargeValue: '€'
	        },
	        period: 'période',
	        periodRanges: 'jours de la semaine',
	        addPeriodRange: 'ajouter une période',
	        removePeriodRange: 'supprimer la période',
	        exclusions: 'exclusions',
	        addExclusion: 'ajouter une exclusion',
	        removeExclusion: 'supprimer l\'exclusion',
	        addDay: 'ajouter un jour',
	        removeDay: 'supprimer le jour',
	        removeDayRange: 'supprimer la période',
	        subscription: 'abonnement',
	        forWhat: 'pour quoi',
	        forWhatEnum: {
	            requestForQuotation: 'devis',
	            urgency: 'urgence'
	        },
	        forWho: 'pour qui',
	        forWhoEnum: {
	            individuals: 'particuliers',
	            professionals: 'professionnels'
	        },
	        defineContactInfo: 'contact de l\'entreprise',
	        repairTimelimit: 'délai maximum de réparation',
	        repairTimelimitRate: 'respect des délais de réparation',
	        interventionTimelimit: 'délai maximum d\' intervention',
	        interventionTimelimitRate: 'respect des délais d\' intervention',
	        openingTicketPurposes: 'raisons d\'ouverture de ticket',
	        commitments: 'engagements',
	        commitmentCompliancyRate: 'taux de respect des engagements',
	        compliantTickets: 'tickets respectant les engagements',
	        notCompliantTickets: 'tickets ne respectant pas les engagements',
	        qualifiedTickets: 'tickets éligibles',
	        copyActivity: 'copier une activité',
	        copyProviderContactActivity: 'Attention les engagements de délais ne seront pas copiés',
	        copyInterventionPeriod: 'copier les engagements d\'une période d\'intervention',
	        fillinAssistant: 'aide à la saisie',
	        linkedWithInfo: {
	            linkedToPatrimony: 'fournisseur sous contrat ou associé au patrimoine',
	            linkedToAgency: 'fournisseur référencé par l\'agence',
	            linkedToCompany: 'fournisseur référencé par le client',
	            linkedToContract: 'fournisseur sous contrat'
	        },
	        foundViaInterventionZone: 'fournisseur à proximité',
	        coverage: 'couverture',
	        coverageRate: 'taux de couverture global',
	        providerCoverage: 'couverture',
	        cities: 'villes',
	        cityCoverageMap: 'carte des villes',
	        byCity: 'par ville',
	        department: 'département',
	        departmentCoverageMap: 'carte des départements',
	        byDepartment: 'par département',
	        zipCodes: 'code postal',
	        zipCodesInfo: 'liste de codes postaux séparés par une virgule',
	        coverageActivityIsRequired: 'Au moins une activité doit être sélectionnée'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_TICKET_QUERY = exports.DEFAULT_QUERY = exports.CORRECT_OTP = exports.RESTRICT_ACCESS_CMD_SENT = exports.ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL = exports.ACCEPT_INTERVENTION_CMD_UPDATED = exports.FINISH_MISSION_CMD_UPDATED = exports.EMIT_CALL_TO_CMD_UPDATED = exports.RECEIVE_CALL_CMD_UPDATED = exports.CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED = exports.CORRECT_TICKET_INFORMATIONS_CMD_UPDATED = exports.CLOSE_TICKET_CMD_UPDATED = exports.ADD_MESSAGE_CMD_UPDATED = exports.FINISH_INTERVENTION_CMD_UPDATED = exports.START_INTERVENTION_CMD_UPDATED = exports.SCHEDULE_INTERVENTION_CMD_UPDATED = exports.REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_UPDATED = exports.DEFINE_INTERVENTION_DEADLINE_CMD_UPDATED = exports.REPORT_SENDING_SERVICE_ORDER_CMD_UPDATED = exports.IDENTIFY_ASSIGNEE_CMD_UPDATED = exports.CORRECT_CALLER_CMD_UPDATED = exports.CORRECT_LOCATION_REFERENCE_CMD_RESET = exports.CORRECT_LOCATION_REFERENCE_CMD_SENT = exports.CORRECT_LOCATION_REFERENCE_CMD_UPDATED = exports.OPEN_TICKET_CMD_UPDATED = exports.REPORT_PDF_TICKETS_OPTION_UPDATED = exports.EXPORT_PDF_TICKETS_OPTION_UPDATED = exports.EXPORT_XLSX_TICKETS_OPTION_UPDATED = exports.PDF_TICKETS_REPORTED = exports.PDF_TICKETS_EXPORTED = exports.XLSX_TICKETS_EXPORTED = exports.FINISH_MISSION_CMD_SENT = exports.EMIT_CALL_TO_CMD_SENT = exports.RECEIVE_CALL_CMD_SENT = exports.CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT = exports.CORRECT_TICKET_INFORMATIONS_CMD_RESET = exports.CORRECT_TICKET_INFORMATIONS_CMD_SENT = exports.CLOSE_TICKET_CMD_SENT = exports.ADD_MESSAGE_CMD_SENT = exports.FINISH_INTERVENTION_CMD_SENT = exports.START_INTERVENTION_CMD_SENT = exports.SCHEDULE_INTERVENTION_CMD_SENT = exports.REFUSE_INTERVENTION_CMD_SENT = exports.ACCEPT_INTERVENTION_CMD_SENT = exports.REQUEST_INTERVENTION_CMD_SENT = exports.REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT = exports.DEFINE_INTERVENTION_DEADLINE_CMD_SENT = exports.REPORT_SENDING_SERVICE_ORDER_CMD_SENT = exports.IDENTIFY_ASSIGNEE_CMD_SENT = exports.OPEN_TICKET_CMD_RESET = exports.OPEN_TICKET_CMD_SENT = exports.CRITERIA_UPDATED = exports.TICKET_CREATED = exports.TICKET_LOADED = exports.MINOR_TICKET_STREAM_QUERIED = exports.TICKET_STREAM_QUERIED = exports.TICKET_STREAM_LOADED = exports.LINKS_LOADED = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadLinks = loadLinks;
	exports.queryTicketStream = queryTicketStream;
	exports.queryMinorTicketStream = queryMinorTicketStream;
	exports.loadTicketStream = loadTicketStream;
	exports.enterTicket = enterTicket;
	exports.loadTicket = loadTicket;
	exports.restrictAccessToCall = restrictAccessToCall;
	exports.sendOpenTicketCmd = sendOpenTicketCmd;
	exports.sendSimplifiedRequestQualified = sendSimplifiedRequestQualified;
	exports.sendIdentifyAssigneeCmd = sendIdentifyAssigneeCmd;
	exports.sendReportSendingServiceOrderCmd = sendReportSendingServiceOrderCmd;
	exports.sendDefineInterventionDeadlineCmd = sendDefineInterventionDeadlineCmd;
	exports.sendReportFormalNoticeForProviderCmd = sendReportFormalNoticeForProviderCmd;
	exports.sendRequestInterventionCmd = sendRequestInterventionCmd;
	exports.sendAcceptInterventionCmd = sendAcceptInterventionCmd;
	exports.sendRefuseInterventionCmd = sendRefuseInterventionCmd;
	exports.sendScheduleInterventionCmd = sendScheduleInterventionCmd;
	exports.sendStartInterventionCmd = sendStartInterventionCmd;
	exports.sendFinishInterventionCmd = sendFinishInterventionCmd;
	exports.sendAddMessageCmd = sendAddMessageCmd;
	exports.sendCloseTicketCmd = sendCloseTicketCmd;
	exports.sendCorrectTicketInformationsCmd = sendCorrectTicketInformationsCmd;
	exports.sendCorrectTicketEventInformationsCmd = sendCorrectTicketEventInformationsCmd;
	exports.sendReceiveCallCmd = sendReceiveCallCmd;
	exports.sendEmitCallToCmd = sendEmitCallToCmd;
	exports.sendFinishMissionCmd = sendFinishMissionCmd;
	exports.exportXlsxTickets = exportXlsxTickets;
	exports.exportPdfTickets = exportPdfTickets;
	exports.exportPdfTicket = exportPdfTicket;
	exports.reportPdfTickets = reportPdfTickets;
	exports.updateCriteria = updateCriteria;
	exports.updateExportXlsxTicketsOption = updateExportXlsxTicketsOption;
	exports.updateReportPdfTicketsOption = updateReportPdfTicketsOption;
	exports.updateOpenTicketCmd = updateOpenTicketCmd;
	exports.updateCorrectLocationReferenceCmd = updateCorrectLocationReferenceCmd;
	exports.updateCorrectCallerCmd = updateCorrectCallerCmd;
	exports.fetchDocumentsForOpenTicket = fetchDocumentsForOpenTicket;
	exports.resetOpenTicketCmd = resetOpenTicketCmd;
	exports.updateIdentifyAssigneeCmd = updateIdentifyAssigneeCmd;
	exports.updateCloseTicketCmd = updateCloseTicketCmd;
	exports.updateStartInterventionCmd = updateStartInterventionCmd;
	exports.updateFinishInterventionCmd = updateFinishInterventionCmd;
	exports.resetCorrectTicketInformationsCmd = resetCorrectTicketInformationsCmd;
	exports.updateCorrectTicketEventInformationsCmd = updateCorrectTicketEventInformationsCmd;
	exports.updateReceiveCallCmd = updateReceiveCallCmd;
	exports.updateEmitCallToCmd = updateEmitCallToCmd;
	exports.updateFinishMissionCmd = updateFinishMissionCmd;
	exports.chooseIfSendNotificationWhenInterventionAccepted = chooseIfSendNotificationWhenInterventionAccepted;
	exports.updateOtherRecipientInInterventionAcceptedNotification = updateOtherRecipientInInterventionAcceptedNotification;
	exports.createTicket = createTicket;
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _fileSaver = __webpack_require__(1012);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _progress = __webpack_require__(965);
	
	var _progress2 = _interopRequireDefault(_progress);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _i18n = __webpack_require__(80);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _models = __webpack_require__(49);
	
	var _protocol = __webpack_require__(270);
	
	var _actions = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NAMESPACE = 'Ticket';
	var LINKS_LOADED = exports.LINKS_LOADED = NAMESPACE + '/LinksLoaded';
	var TICKET_STREAM_LOADED = exports.TICKET_STREAM_LOADED = NAMESPACE + '/TicketStreamLoaded';
	var TICKET_STREAM_QUERIED = exports.TICKET_STREAM_QUERIED = NAMESPACE + '/TicketStreamQueried';
	var MINOR_TICKET_STREAM_QUERIED = exports.MINOR_TICKET_STREAM_QUERIED = NAMESPACE + '/MinorTicketStreamQueried';
	var TICKET_LOADED = exports.TICKET_LOADED = NAMESPACE + '/TicketLoaded';
	var TICKET_CREATED = exports.TICKET_CREATED = NAMESPACE + '/TicketCreated';
	var CRITERIA_UPDATED = exports.CRITERIA_UPDATED = NAMESPACE + '/CriteriaUpdated';
	var OPEN_TICKET_CMD_SENT = exports.OPEN_TICKET_CMD_SENT = NAMESPACE + '/OpenTicketCmdSent';
	var OPEN_TICKET_CMD_RESET = exports.OPEN_TICKET_CMD_RESET = NAMESPACE + '/OpenTicketCmdReset';
	var IDENTIFY_ASSIGNEE_CMD_SENT = exports.IDENTIFY_ASSIGNEE_CMD_SENT = NAMESPACE + '/IdentifyAssigneeCmdSent';
	var REPORT_SENDING_SERVICE_ORDER_CMD_SENT = exports.REPORT_SENDING_SERVICE_ORDER_CMD_SENT = NAMESPACE + '/ReportSendingServiceOrderCmdSent';
	var DEFINE_INTERVENTION_DEADLINE_CMD_SENT = exports.DEFINE_INTERVENTION_DEADLINE_CMD_SENT = NAMESPACE + '/DefineInterventionDeadlineCmdSent';
	var REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT = exports.REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT = NAMESPACE + '/ReportFormalNoticeForProviderCmdSent';
	var REQUEST_INTERVENTION_CMD_SENT = exports.REQUEST_INTERVENTION_CMD_SENT = NAMESPACE + '/RequestInterventionCmdSent';
	var ACCEPT_INTERVENTION_CMD_SENT = exports.ACCEPT_INTERVENTION_CMD_SENT = NAMESPACE + '/AcceptInterventionCmdSent';
	var REFUSE_INTERVENTION_CMD_SENT = exports.REFUSE_INTERVENTION_CMD_SENT = NAMESPACE + '/RefuseInterventionCmdSent';
	var SCHEDULE_INTERVENTION_CMD_SENT = exports.SCHEDULE_INTERVENTION_CMD_SENT = NAMESPACE + '/ScheduleInterventionCmdSent';
	var START_INTERVENTION_CMD_SENT = exports.START_INTERVENTION_CMD_SENT = NAMESPACE + '/StartInterventionCmdSent';
	var FINISH_INTERVENTION_CMD_SENT = exports.FINISH_INTERVENTION_CMD_SENT = NAMESPACE + '/FinishInterventionCmdSent';
	var ADD_MESSAGE_CMD_SENT = exports.ADD_MESSAGE_CMD_SENT = NAMESPACE + '/AddMessageCmdSent';
	var CLOSE_TICKET_CMD_SENT = exports.CLOSE_TICKET_CMD_SENT = NAMESPACE + '/CloseTicketCmdSent';
	var CORRECT_TICKET_INFORMATIONS_CMD_SENT = exports.CORRECT_TICKET_INFORMATIONS_CMD_SENT = NAMESPACE + '/CorrectTicketInformationsCmdSent';
	var CORRECT_TICKET_INFORMATIONS_CMD_RESET = exports.CORRECT_TICKET_INFORMATIONS_CMD_RESET = NAMESPACE + '/CorrectTicketInformationsCmdReset';
	var CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT = exports.CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT = NAMESPACE + '/CorrectTicketEventInformationsCmdSent';
	var RECEIVE_CALL_CMD_SENT = exports.RECEIVE_CALL_CMD_SENT = NAMESPACE + '/ReceiveCallCmdSent';
	var EMIT_CALL_TO_CMD_SENT = exports.EMIT_CALL_TO_CMD_SENT = NAMESPACE + '/EmitCallToCmdSent';
	var FINISH_MISSION_CMD_SENT = exports.FINISH_MISSION_CMD_SENT = NAMESPACE + '/FinishMissionCmdSent';
	var XLSX_TICKETS_EXPORTED = exports.XLSX_TICKETS_EXPORTED = NAMESPACE + '/XlsxTicketsExported';
	var PDF_TICKETS_EXPORTED = exports.PDF_TICKETS_EXPORTED = NAMESPACE + '/PdfTicketsExported';
	var PDF_TICKETS_REPORTED = exports.PDF_TICKETS_REPORTED = NAMESPACE + '/PdfTicketsReported';
	// form actions
	var EXPORT_XLSX_TICKETS_OPTION_UPDATED = exports.EXPORT_XLSX_TICKETS_OPTION_UPDATED = NAMESPACE + '/ExportXlsxTicketsOptionUpdated';
	var EXPORT_PDF_TICKETS_OPTION_UPDATED = exports.EXPORT_PDF_TICKETS_OPTION_UPDATED = NAMESPACE + '/ExportPdfTicketsOptionUpdated';
	var REPORT_PDF_TICKETS_OPTION_UPDATED = exports.REPORT_PDF_TICKETS_OPTION_UPDATED = NAMESPACE + '/ReportPdfTicketsOptionUpdated';
	var OPEN_TICKET_CMD_UPDATED = exports.OPEN_TICKET_CMD_UPDATED = NAMESPACE + '/OpenTicketCmdUpdated';
	var CORRECT_LOCATION_REFERENCE_CMD_UPDATED = exports.CORRECT_LOCATION_REFERENCE_CMD_UPDATED = NAMESPACE + '/CorrectLocationReferenceCmdUpdated';
	var CORRECT_LOCATION_REFERENCE_CMD_SENT = exports.CORRECT_LOCATION_REFERENCE_CMD_SENT = NAMESPACE + '/CorrectLocationReferenceCmdSent';
	var CORRECT_LOCATION_REFERENCE_CMD_RESET = exports.CORRECT_LOCATION_REFERENCE_CMD_RESET = NAMESPACE + '/CorrectLocationReferenceCmdReset';
	var CORRECT_CALLER_CMD_UPDATED = exports.CORRECT_CALLER_CMD_UPDATED = NAMESPACE + '/CorrectCallerCmdUpdated';
	var IDENTIFY_ASSIGNEE_CMD_UPDATED = exports.IDENTIFY_ASSIGNEE_CMD_UPDATED = NAMESPACE + '/IdentifyAssigneeCmdUpdated';
	var REPORT_SENDING_SERVICE_ORDER_CMD_UPDATED = exports.REPORT_SENDING_SERVICE_ORDER_CMD_UPDATED = NAMESPACE + '/ReportSendingServiceOrderCmdUpdated';
	var DEFINE_INTERVENTION_DEADLINE_CMD_UPDATED = exports.DEFINE_INTERVENTION_DEADLINE_CMD_UPDATED = NAMESPACE + '/DefineInterventionDeadlineCmdUpdated';
	var REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_UPDATED = exports.REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_UPDATED = NAMESPACE + '/ReportFormalNoticeForProviderCmdUpdated';
	var SCHEDULE_INTERVENTION_CMD_UPDATED = exports.SCHEDULE_INTERVENTION_CMD_UPDATED = NAMESPACE + '/ScheduleInterventionCmdUpdated';
	var START_INTERVENTION_CMD_UPDATED = exports.START_INTERVENTION_CMD_UPDATED = NAMESPACE + '/StartInterventionCmdUpdated';
	var FINISH_INTERVENTION_CMD_UPDATED = exports.FINISH_INTERVENTION_CMD_UPDATED = NAMESPACE + '/FinishInterventionCmdUpdated';
	var ADD_MESSAGE_CMD_UPDATED = exports.ADD_MESSAGE_CMD_UPDATED = NAMESPACE + '/AddMessageCmdUpdated';
	var CLOSE_TICKET_CMD_UPDATED = exports.CLOSE_TICKET_CMD_UPDATED = NAMESPACE + '/CloseTicketCmdUpdated';
	var CORRECT_TICKET_INFORMATIONS_CMD_UPDATED = exports.CORRECT_TICKET_INFORMATIONS_CMD_UPDATED = NAMESPACE + '/CorrectTicketInformationsCmdUpdated';
	var CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED = exports.CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED = NAMESPACE + '/CorrectTicketEventInformationsCmdUpdated';
	var RECEIVE_CALL_CMD_UPDATED = exports.RECEIVE_CALL_CMD_UPDATED = NAMESPACE + '/ReceiveCallCmdUpdated';
	var EMIT_CALL_TO_CMD_UPDATED = exports.EMIT_CALL_TO_CMD_UPDATED = NAMESPACE + '/EmitCallToCmdUpdated';
	var FINISH_MISSION_CMD_UPDATED = exports.FINISH_MISSION_CMD_UPDATED = NAMESPACE + '/FinishMissionCmdUpdated';
	var ACCEPT_INTERVENTION_CMD_UPDATED = exports.ACCEPT_INTERVENTION_CMD_UPDATED = NAMESPACE + '/AcceptInterventionCmdUpdated';
	var ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL = exports.ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL = NAMESPACE + '/AcceptInterventionCmdUpdatedEmail';
	var RESTRICT_ACCESS_CMD_SENT = exports.RESTRICT_ACCESS_CMD_SENT = NAMESPACE + '/RestrictAccessCmdSent';
	var CORRECT_OTP = exports.CORRECT_OTP = NAMESPACE + '/CorrectOTP';
	
	var DEFAULT_QUERY = exports.DEFAULT_QUERY = {
	    range: { offset: 0, limit: 19 }
	};
	
	var DEFAULT_TICKET_QUERY = exports.DEFAULT_TICKET_QUERY = _extends({}, DEFAULT_QUERY, {
	    fullText: null,
	    status: null,
	    location: null,
	    clientCompany: null,
	    agency: null,
	    callPurpose: null,
	    from: null,
	    to: null,
	    activeProviders: null,
	    patrimony: null
	});
	
	function loadLinks() {
	    var query = {
	        range: { offset: 0, limit: 0 }
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/tickets', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: LINKS_LOADED,
	            _links: json._links
	        };
	    }), LINKS_LOADED);
	}
	
	function queryTicketStream(ticketQuery) {
	    return loadTicketStream(ticketQuery, TICKET_STREAM_QUERIED);
	}
	
	function queryMinorTicketStream(ticketQuery) {
	    return loadTicketStream(ticketQuery, MINOR_TICKET_STREAM_QUERIED);
	}
	
	function loadTicketStream(ticketQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var query = state.ticket.query;
	
	
	        ticketQuery = _extends({}, DEFAULT_TICKET_QUERY, query, ticketQuery);
	
	        var ticketsPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/tickets', ticketQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var statsPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/tickets/stats', ticketQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	
	        return Promise.all([ticketsPromise, statsPromise]).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                ticketsResponse = _ref3[0],
	                statsResponse = _ref3[1];
	
	            return {
	                type: action || TICKET_STREAM_LOADED,
	                range: ticketsResponse.headers.contentRange,
	                stream: ticketsResponse.json.result,
	                aggregations: ticketsResponse.json.aggregations,
	                _links: ticketsResponse.json._links,
	                stats: statsResponse.json,
	                query: ticketQuery
	            };
	        });
	    }, action || TICKET_STREAM_LOADED);
	}
	
	function enterTicket(dispatch, params) {
	    return dispatch(loadTicket(params.id)).then(function (loadTicketAction) {
	        var patrimony = loadTicketAction.ticket.linkedEntities.patrimony;
	        return Promise.all([patrimony && dispatch((0, _actions.loadPatrimony)(patrimony.uid))]);
	    });
	}
	
	function loadTicket(id) {
	    return (0, _loading2.default)(function (state) {
	        var ticket = state.ticket.ticket;
	
	        id = id || ticket.uid;
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/tickets/' + id), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref4) {
	            var json = _ref4.json;
	
	            return {
	                type: TICKET_LOADED,
	                ticket: json
	            };
	        });
	    }, TICKET_LOADED);
	}
	
	function restrictAccessToCall(dispatch) {
	    return function (_) {
	        return dispatch((0, _loading2.default)(function (state) {
	            var option = {
	                body: {
	                    processUid: _nodeUuid2.default.v4(),
	                    'commandType': 'RestrictAccessToTicket',
	                    accessControlList: [{
	                        'accessControlType': 'PatrimonyUser',
	                        'accessGrantTo': 'TicketCaller'
	                    }]
	                },
	                method: 'PATCH'
	
	            };
	
	            return fetch(_config2.default.api.event.url + '/tickets/' + state.ticket.ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (json) {
	                return {
	                    type: RESTRICT_ACCESS_CMD_SENT,
	                    events: json.events
	                };
	            });
	        }, RESTRICT_ACCESS_CMD_SENT));
	    };
	}
	
	function sendOpenTicketCmd() {
	    return (0, _loading2.default)(function (state) {
	        var openTicketCmd = state.ticket.openTicketCmd;
	
	        var _openTicketCmd$ticket = openTicketCmd.ticket,
	            _openTicketCmd$ticket2 = _openTicketCmd$ticket.callerz,
	            namez = _openTicketCmd$ticket2.namez,
	            uid = _openTicketCmd$ticket2.uid,
	            callerz = _objectWithoutProperties(_openTicketCmd$ticket2, ['namez', 'uid']),
	            contactToCallback = _openTicketCmd$ticket.contactToCallback,
	            _openTicketCmd$ticket3 = _openTicketCmd$ticket.address,
	            number = _openTicketCmd$ticket3.number,
	            street = _openTicketCmd$ticket3.street,
	            digicode = _openTicketCmd$ticket3.digicode,
	            staircase = _openTicketCmd$ticket3.staircase,
	            floor = _openTicketCmd$ticket3.floor,
	            address = _objectWithoutProperties(_openTicketCmd$ticket3, ['number', 'street', 'digicode', 'staircase', 'floor']),
	            openingTicketPurpose = _openTicketCmd$ticket.openingTicketPurpose,
	            request = _openTicketCmd$ticket.request,
	            ticket = _objectWithoutProperties(_openTicketCmd$ticket, ['callerz', 'contactToCallback', 'address', 'openingTicketPurpose', 'request']),
	            locationRef = openTicketCmd.locationRef,
	            restrictedAccess = openTicketCmd.restrictedAccess,
	            requestUid = openTicketCmd.requestUid,
	            qualification = openTicketCmd.qualification;
	
	        var recipientSupplement = floor || staircase ? { recipientSupplement: { floor: floor, staircase: staircase } } : undefined;
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                openedDate: new Date(),
	                locationRef: _extends({}, locationRef, {
	                    agencyUid: locationRef.agencyUid && locationRef.agencyUid.uid,
	                    patrimonyUid: locationRef.patrimonyUid && locationRef.patrimonyUid.uid
	                }),
	                ticket: _extends({
	                    address: _extends({
	                        street: [number, street].filter(function (v) {
	                            return v;
	                        }).join(', '),
	                        complement: [digicode && 'digicode: ' + digicode].filter(function (v) {
	                            return v;
	                        }).join(', ')
	                    }, recipientSupplement, address),
	                    caller: _extends({
	                        uid: uid && uid.uid,
	                        name: namez && _extends({ nameType: 'CivilName' }, namez)
	                    }, callerz),
	                    contactToCallback: contactToCallback && _extends({
	                        name: contactToCallback.namez
	                    }, contactToCallback),
	                    callPurposeLabel: openingTicketPurpose.label,
	                    callPurposeUid: openingTicketPurpose.uid,
	                    altCallPurpose: {},
	                    additionalData: {},
	                    claimNumber: {},
	                    request: request
	                }, ticket)
	            }, Boolean(restrictedAccess) ? {
	                accessControlList: [{
	                    'accessControlType': 'PatrimonyUser',
	                    'accessGrantTo': 'TicketCaller'
	                }]
	            } : {}, Boolean(requestUid) ? { fromSimplifiedRequest: requestUid } : {}, qualification ? { qualification: qualification } : {}, {
	                commandType: 'OpenTicket'
	            })
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref5) {
	            var json = _ref5.json;
	
	            return {
	                type: OPEN_TICKET_CMD_SENT,
	                events: json.events
	            };
	        });
	    }, OPEN_TICKET_CMD_SENT);
	}
	
	function sendSimplifiedRequestQualified(requestUid, ticketUid) {
	    if (!requestUid) {
	        return Promise.resolve();
	    }
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            ticketUid: ticketUid,
	            commandType: 'QualifySimplifiedRequest'
	        }
	    };
	    return fetch(_config2.default.api.event.url + '/simplifiedrequests/' + requestUid, (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse);
	}
	
	function sendIdentifyAssigneeCmd(ticketId) {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket = state.ticket,
	            ticket = _state$ticket.ticket,
	            identifyAssigneeCmd = _state$ticket.identifyAssigneeCmd;
	
	        var assignee = identifyAssigneeCmd.assignee,
	            cmd = _objectWithoutProperties(identifyAssigneeCmd, ['assignee']);
	
	        ticketId = ticketId || ticket.uid;
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                assignee: _extends({}, assignee, {
	                    providerUid: assignee.providerUid.uid
	                }),
	                commandType: 'IdentifyAssignee'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticketId, (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref6) {
	            var json = _ref6.json;
	
	            return {
	                type: IDENTIFY_ASSIGNEE_CMD_SENT,
	                events: json.events
	            };
	        });
	    }, IDENTIFY_ASSIGNEE_CMD_SENT);
	}
	
	function sendReportSendingServiceOrderCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket2 = state.ticket,
	            ticket = _state$ticket2.ticket,
	            reportSendingServiceOrderCmd = _state$ticket2.reportSendingServiceOrderCmd;
	        var assignee = ticket.assignee;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                reportDate: new Date(),
	                assignee: cmdAssignee(assignee),
	                commandType: 'ReportSendingServiceOrder'
	            }, reportSendingServiceOrderCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REPORT_SENDING_SERVICE_ORDER_CMD_SENT
	            };
	        });
	    }, REPORT_SENDING_SERVICE_ORDER_CMD_SENT);
	}
	
	function sendDefineInterventionDeadlineCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket3 = state.ticket,
	            ticket = _state$ticket3.ticket,
	            defineInterventionDeadlineCmd = _state$ticket3.defineInterventionDeadlineCmd;
	        var assignee = ticket.assignee;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                assignee: cmdAssignee(assignee),
	                commandType: 'DefineInterventionDeadline'
	            }, defineInterventionDeadlineCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DEFINE_INTERVENTION_DEADLINE_CMD_SENT
	            };
	        });
	    }, DEFINE_INTERVENTION_DEADLINE_CMD_SENT);
	}
	
	function sendReportFormalNoticeForProviderCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket4 = state.ticket,
	            ticket = _state$ticket4.ticket,
	            reportFormalNoticeForProviderCmd = _state$ticket4.reportFormalNoticeForProviderCmd;
	        var assignee = ticket.assignee;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                reportDate: new Date(),
	                assignee: cmdAssignee(assignee),
	                commandType: 'ReportFormalNoticeForProvider'
	            }, reportFormalNoticeForProviderCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT
	            };
	        });
	    }, REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT);
	}
	
	function sendRequestInterventionCmd() {
	    // this cmd is considered a specialised version of EmitCallToCmd
	
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket5 = state.ticket,
	            ticket = _state$ticket5.ticket,
	            emitCallToCmd = _state$ticket5.emitCallToCmd;
	        var assignee = ticket.assignee;
	
	        var recipient = emitCallToCmd.recipient,
	            cmd = _objectWithoutProperties(emitCallToCmd, ['recipient']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                assignee: cmdAssignee(assignee),
	                commandType: 'RequestIntervention'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REQUEST_INTERVENTION_CMD_SENT
	            };
	        });
	    }, REQUEST_INTERVENTION_CMD_SENT);
	}
	
	function sendAcceptInterventionCmd(ticketId) {
	    return (0, _loading2.default)(function (store) {
	        var _store$ticket = store.ticket,
	            ticket = _store$ticket.ticket,
	            acceptInterventionCmd = _store$ticket.acceptInterventionCmd;
	        var assignee = ticket.assignee;
	        var sendItOrNot = acceptInterventionCmd.sendItOrNot,
	            otherEmails = acceptInterventionCmd.otherEmails;
	
	        var ticketId = ticketId || ticket.uid;
	
	        var otherRecipients = otherEmails.filter(Boolean);
	        var assigneeEmail = assignee && sendItOrNot === 'doNotSendNotif' ? null : sendItOrNot;
	        var requestNotificationTo = assigneeEmail ? { requestNotificationTo: { assigneeEmail: assigneeEmail, otherRecipients: otherRecipients } } : null;
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                assignee: cmdAssignee(assignee)
	            }, requestNotificationTo, {
	                commandType: 'AcceptIntervention'
	            })
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticketId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ACCEPT_INTERVENTION_CMD_SENT
	            };
	        });
	    }, ACCEPT_INTERVENTION_CMD_SENT);
	}
	
	function sendRefuseInterventionCmd(ticketId) {
	    return (0, _loading2.default)(function (state) {
	        var ticket = state.ticket.ticket;
	        var assignee = ticket.assignee;
	
	        var ticketId = ticketId || ticket.uid;
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                assignee: cmdAssignee(assignee),
	                commandType: 'RefuseIntervention'
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticketId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REFUSE_INTERVENTION_CMD_SENT
	            };
	        });
	    }, REFUSE_INTERVENTION_CMD_SENT);
	}
	
	function sendScheduleInterventionCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket6 = state.ticket,
	            ticket = _state$ticket6.ticket,
	            scheduleInterventionCmd = _state$ticket6.scheduleInterventionCmd;
	        var assignee = ticket.assignee;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                assignee: cmdAssignee(assignee),
	                commandType: 'ScheduleIntervention'
	            }, scheduleInterventionCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: SCHEDULE_INTERVENTION_CMD_SENT
	            };
	        });
	    }, SCHEDULE_INTERVENTION_CMD_SENT);
	}
	
	function sendStartInterventionCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket7 = state.ticket,
	            ticket = _state$ticket7.ticket,
	            startInterventionCmd = _state$ticket7.startInterventionCmd;
	        var assignee = ticket.assignee;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                assignee: cmdAssignee(assignee),
	                commandType: 'StartIntervention'
	            }, startInterventionCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: START_INTERVENTION_CMD_SENT
	            };
	        });
	    }, START_INTERVENTION_CMD_SENT);
	}
	
	function sendFinishInterventionCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket8 = state.ticket,
	            ticket = _state$ticket8.ticket,
	            finishInterventionCmd = _state$ticket8.finishInterventionCmd;
	        var assignee = ticket.assignee;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                assignee: cmdAssignee(assignee),
	                commandType: 'FinishIntervention'
	            }, finishInterventionCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: FINISH_INTERVENTION_CMD_SENT
	            };
	        });
	    }, FINISH_INTERVENTION_CMD_SENT);
	}
	
	function sendAddMessageCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket9 = state.ticket,
	            ticket = _state$ticket9.ticket,
	            addMessageCmd = _state$ticket9.addMessageCmd;
	        var assignee = ticket.assignee;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                messageAddedDate: new Date(),
	                assignee: assignee && cmdAssignee(assignee),
	                commandType: 'AddMessage'
	            }, addMessageCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_MESSAGE_CMD_SENT
	            };
	        });
	    }, ADD_MESSAGE_CMD_SENT);
	}
	
	function sendCloseTicketCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket10 = state.ticket,
	            ticket = _state$ticket10.ticket,
	            closeTicketCmd = _state$ticket10.closeTicketCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                closingDate: new Date(),
	                date: new Date(), // used only by CancelTicket for legacy reasons
	                stillOnSite: 'NotAsked'
	            }, closeTicketCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: CLOSE_TICKET_CMD_SENT
	            };
	        });
	    }, CLOSE_TICKET_CMD_SENT);
	}
	
	function sendCorrectTicketInformationsCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket11 = state.ticket,
	            ticket = _state$ticket11.ticket,
	            correctTicketInformationsCmd = _state$ticket11.correctTicketInformationsCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                commandType: 'CorrectTicketInformations'
	            }, correctTicketInformationsCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: CORRECT_TICKET_INFORMATIONS_CMD_SENT
	            };
	        });
	    }, CORRECT_TICKET_INFORMATIONS_CMD_SENT);
	}
	
	function sendCorrectTicketEventInformationsCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket12 = state.ticket,
	            ticket = _state$ticket12.ticket,
	            correctTicketEventInformationsCmd = _state$ticket12.correctTicketEventInformationsCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                commandType: 'CorrectTicketEventInformations'
	            }, correctTicketEventInformationsCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT
	            };
	        });
	    }, CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT);
	}
	
	function sendReceiveCallCmd(ticketId) {
	    return (0, _loading2.default)(function (state) {
	        var receiveCallCmd = state.ticket.receiveCallCmd;
	
	        var callerz = receiveCallCmd.callerz,
	            cmd = _objectWithoutProperties(receiveCallCmd, ['callerz']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                commandType: 'ReceiveCall',
	                caller: callerz
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticketId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: RECEIVE_CALL_CMD_SENT
	            };
	        });
	    }, RECEIVE_CALL_CMD_SENT);
	}
	
	function sendEmitCallToCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket13 = state.ticket,
	            ticket = _state$ticket13.ticket,
	            emitCallToCmd = _state$ticket13.emitCallToCmd;
	
	        var _emitCallToCmd$recipi = emitCallToCmd.recipient,
	            namez = _emitCallToCmd$recipi.namez,
	            provider = _emitCallToCmd$recipi.provider,
	            recipient = _objectWithoutProperties(_emitCallToCmd$recipi, ['namez', 'provider']),
	            cmd = _objectWithoutProperties(emitCallToCmd, ['recipient']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date(),
	                commandType: 'EmitCallTo',
	                recipient: _extends({
	                    name: namez,
	                    provider: provider && cmdProvider(provider)
	                }, recipient)
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: EMIT_CALL_TO_CMD_SENT
	            };
	        });
	    }, EMIT_CALL_TO_CMD_SENT);
	}
	
	function sendFinishMissionCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$ticket14 = state.ticket,
	            ticket = _state$ticket14.ticket,
	            finishMissionCmd = _state$ticket14.finishMissionCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                endMissionDate: new Date(),
	                commandType: 'FinishMission'
	            }, finishMissionCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/tickets/' + ticket.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: FINISH_MISSION_CMD_SENT
	            };
	        });
	    }, FINISH_MISSION_CMD_SENT);
	}
	
	function exportXlsxTickets(exportOption) {
	    return (0, _progress2.default)(function (state) {
	        var _state$ticket15 = state.ticket,
	            query = _state$ticket15.query,
	            exportXlsxTicketsOption = _state$ticket15.exportXlsxTicketsOption;
	
	        var worker = new Worker(WORKER_SCRIPT_PATH);
	
	        exportOption = _extends({}, exportXlsxTicketsOption, exportOption);
	
	        worker.addEventListener('message', function (event) {
	            switch (event.data.type) {
	                case _protocol.XLSX_EXPORT_COMPLETED:
	                    _fileSaver2.default.saveAs(event.data.xlsx, 'export-' + (0, _moment2.default)().format(_i18n2.default.dateFormat.file) + '.xlsx');
	                    break;
	            }
	        });
	
	        worker.postMessage({ type: _protocol.START_XLSX_EXPORT, query: query, option: exportOption });
	        return worker;
	    }, XLSX_TICKETS_EXPORTED);
	}
	
	function exportPdfTickets(exportOption) {
	    return (0, _progress2.default)(function (state) {
	        var _state$ticket16 = state.ticket,
	            query = _state$ticket16.query,
	            exportPdfTicketsOption = _state$ticket16.exportPdfTicketsOption;
	
	        var worker = new Worker(WORKER_SCRIPT_PATH);
	
	        exportOption = _extends({}, exportPdfTicketsOption, exportOption);
	
	        worker.addEventListener('message', function (event) {
	            switch (event.data.type) {
	                case _protocol.PDF_EXPORT_COMPLETED:
	                    _fileSaver2.default.saveAs(event.data.pdf, 'export-' + (0, _moment2.default)().format(_i18n2.default.dateFormat.file) + '.pdf');
	                    break;
	            }
	        });
	
	        worker.postMessage({ type: _protocol.START_PDF_EXPORT, query: query, option: exportOption });
	        return worker;
	    }, PDF_TICKETS_EXPORTED);
	}
	
	function exportPdfTicket(exportOption) {
	    return (0, _progress2.default)(function (state) {
	        var ticket = state.ticket.ticket;
	
	        var worker = new Worker(WORKER_SCRIPT_PATH);
	
	        exportOption = _extends({
	            pages: ['journal']
	        }, exportOption);
	
	        worker.addEventListener('message', function (event) {
	            switch (event.data.type) {
	                case _protocol.PDF_EXPORT_COMPLETED:
	                    _fileSaver2.default.saveAs(event.data.pdf, 'export-' + ticket.uid + '.pdf');
	                    break;
	            }
	        });
	
	        worker.postMessage({ type: _protocol.START_PDF_EXPORT, ticketId: ticket.uid, option: exportOption });
	        return worker;
	    }, PDF_TICKETS_EXPORTED);
	}
	
	function reportPdfTickets(reportQuery, reportOption) {
	    return (0, _progress2.default)(function (state) {
	        var authenticated = state.user.authenticated;
	        var _state$ticket17 = state.ticket,
	            query = _state$ticket17.query,
	            reportPdfTicketsOption = _state$ticket17.reportPdfTicketsOption;
	
	        var worker = new Worker(WORKER_SCRIPT_PATH);
	
	        reportQuery = _extends({}, query, reportQuery);
	
	        reportOption = _extends({}, reportPdfTicketsOption, reportOption);
	
	        worker.addEventListener('message', function (event) {
	            switch (event.data.type) {
	                case _protocol.PDF_REPORT_COMPLETED:
	                    _fileSaver2.default.saveAs(event.data.pdf, 'report-' + (0, _moment2.default)().format(_i18n2.default.dateFormat.file) + '.pdf');
	                    break;
	            }
	        });
	
	        worker.postMessage({ type: _protocol.START_PDF_REPORT, authenticated: authenticated, query: reportQuery, option: reportOption });
	        return worker;
	    }, PDF_TICKETS_REPORTED);
	}
	
	function updateCriteria(criteria) {
	    return {
	        type: CRITERIA_UPDATED,
	        criteria: criteria
	    };
	}
	
	function updateExportXlsxTicketsOption(option) {
	    return {
	        type: EXPORT_XLSX_TICKETS_OPTION_UPDATED,
	        option: option
	    };
	}
	
	function updateReportPdfTicketsOption(option) {
	    return {
	        type: REPORT_PDF_TICKETS_OPTION_UPDATED,
	        option: option
	    };
	}
	
	function updateOpenTicketCmd(cmd) {
	    return {
	        type: OPEN_TICKET_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	function updateCorrectLocationReferenceCmd(cmd) {
	    return {
	        type: CORRECT_LOCATION_REFERENCE_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateCorrectCallerCmd(cmd) {
	    return {
	        type: CORRECT_CALLER_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function fetchDocumentsForOpenTicket() {
	    return (0, _loading2.default)(function (state) {
	        return fetch(_config2.default.api.url + '/documents?aggregatetype=SimplifiedRequest&aggregateuid=' + state.ticket.openTicketCmd.requestUid, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref7) {
	            var json = _ref7.json;
	
	            return {
	                type: OPEN_TICKET_CMD_UPDATED,
	                cmd: {
	                    photos: json.documents
	                }
	            };
	        });
	    });
	}
	
	function resetOpenTicketCmd() {
	    return {
	        type: OPEN_TICKET_CMD_RESET
	    };
	}
	
	function updateIdentifyAssigneeCmd(cmd) {
	    return {
	        type: IDENTIFY_ASSIGNEE_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateCloseTicketCmd(cmd) {
	    return {
	        type: CLOSE_TICKET_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateStartInterventionCmd(cmd) {
	    return {
	        type: START_INTERVENTION_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateFinishInterventionCmd(cmd) {
	    return {
	        type: FINISH_INTERVENTION_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function resetCorrectTicketInformationsCmd(cmd) {
	    return {
	        type: CORRECT_TICKET_INFORMATIONS_CMD_RESET,
	        cmd: cmd
	    };
	}
	
	function updateCorrectTicketEventInformationsCmd(cmd) {
	    return {
	        type: CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateReceiveCallCmd(cmd) {
	    return {
	        type: RECEIVE_CALL_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateEmitCallToCmd(cmd) {
	    return {
	        type: EMIT_CALL_TO_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateFinishMissionCmd(cmd) {
	    return {
	        type: FINISH_MISSION_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function chooseIfSendNotificationWhenInterventionAccepted(cmd) {
	    return {
	        type: ACCEPT_INTERVENTION_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateOtherRecipientInInterventionAcceptedNotification(cmd) {
	    return _extends({
	        type: ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL
	    }, cmd);
	}
	
	function createTicket() {
	    return {
	        type: TICKET_CREATED,
	        ticket: {
	            additionalDataz: {},
	            stats: {},
	            journal: [],
	            _links: []
	        }
	    };
	}
	
	function cmdProvider(providerContact) {
	    var uid = providerContact.uid;
	
	
	    return {
	        providerType: 'ReferencedProvider',
	        providerUid: uid
	    };
	}
	
	function cmdAssignee(ticketAssignee) {
	    var uid = ticketAssignee.uid,
	        assigneeType = ticketAssignee.assigneeType,
	        assignee = _objectWithoutProperties(ticketAssignee, ['uid', 'assigneeType']);
	
	    switch (assigneeType) {
	        case 'ProviderContact':
	            return {
	                providerUid: uid,
	                assigneeType: 'ReferencedProviderContact'
	            };
	        case 'ProviderCompany':
	            return {
	                providerUid: uid,
	                assigneeType: 'ReferencedProviderCompany'
	            };
	        case 'Anonymous':
	            return _extends({
	                providerUid: uid,
	                assigneeType: 'AnonymousAssignee'
	            }, assignee);
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(122);
	var ReactBrowserEventEmitter = __webpack_require__(175);
	var ReactCurrentOwner = __webpack_require__(78);
	var ReactDOMFeatureFlags = __webpack_require__(475);
	var ReactElement = __webpack_require__(41);
	var ReactEmptyComponentRegistry = __webpack_require__(481);
	var ReactInstanceHandles = __webpack_require__(109);
	var ReactInstanceMap = __webpack_require__(143);
	var ReactMarkupChecksum = __webpack_require__(484);
	var ReactPerf = __webpack_require__(64);
	var ReactReconciler = __webpack_require__(105);
	var ReactUpdateQueue = __webpack_require__(246);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(22);
	var emptyObject = __webpack_require__(145);
	var containsNode = __webpack_require__(496);
	var instantiateReactComponent = __webpack_require__(190);
	var invariant = __webpack_require__(14);
	var setInnerHTML = __webpack_require__(181);
	var shouldUpdateReactComponent = __webpack_require__(255);
	var validateDOMNesting = __webpack_require__(257);
	var warning = __webpack_require__(23);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.phoneField = phoneField;
	exports.phonesField = phonesField;
	exports.phoneFormat = phoneFormat;
	
	exports.default = function (value) {
	
	    function formatz() {
	        if (value) {
	            var _parse6 = (0, _libphonenumberJs.parse)(value, { country: { default: 'FR' } }),
	                country = _parse6.country,
	                phone = _parse6.phone;
	
	            if (country == 'FR') return (0, _libphonenumberJs.format)(phone, country, 'National');
	            if (country) return (0, _libphonenumberJs.format)(phone, country, 'International');
	        }
	        return value;
	    }
	
	    function toNational() {
	        var formatter = new _libphonenumberJs.asYouType('FR');
	        formatter.input(value);
	        return formatter.national_number;
	    }
	
	    function toE164() {
	        var _parse7 = (0, _libphonenumberJs.parse)(value, { country: { default: 'FR' } }),
	            country = _parse7.country,
	            phone = _parse7.phone;
	
	        if (phone) return (0, _libphonenumberJs.format)(phone, country, 'International_plaintext');
	        return null;
	    }
	
	    return { format: formatz, toNational: toNational, toE164: toE164 };
	};
	
	var _libphonenumberJs = __webpack_require__(799);
	
	function phoneField(field) {
	    var value = field.value;
	
	    if (value) {
	        var _parse = (0, _libphonenumberJs.parse)(value, { country: { default: 'FR' } }),
	            country = _parse.country,
	            phone = _parse.phone;
	
	        if (country == 'FR') {
	            value = (0, _libphonenumberJs.format)(phone, country, 'National');
	        } else if (country) {
	            value = (0, _libphonenumberJs.format)(phone, country, 'International');
	        }
	    }
	
	    function onChange(event) {
	        var nextValue = event.target.value;
	
	        if (nextValue) {
	            var _parse2 = (0, _libphonenumberJs.parse)(nextValue, { country: { default: 'FR' } }),
	                _country = _parse2.country,
	                _phone = _parse2.phone;
	
	            if (_phone) {
	                nextValue = (0, _libphonenumberJs.format)(_phone, _country, 'International_plaintext');
	            } else {
	                var formatter = new _libphonenumberJs.asYouType('FR');
	                nextValue = formatter.input(nextValue);
	            }
	        }
	
	        field.onChange(nextValue);
	    }
	
	    value = value || ''; // fix uncontrolled input issue
	
	    return _extends({}, field, { value: value, onChange: onChange });
	}
	
	function phonesField(field) {
	    var arrayValue = field.value || [];
	
	    var value = arrayValue.map(function (value) {
	        if (value) {
	            var _parse3 = (0, _libphonenumberJs.parse)(value, { country: { default: 'FR' } }),
	                country = _parse3.country,
	                phone = _parse3.phone;
	
	            if (country == 'FR') return (0, _libphonenumberJs.format)(phone, country, 'National');
	            if (country) return (0, _libphonenumberJs.format)(phone, country, 'International');
	        }
	
	        return value;
	    });
	
	    function onChange(value) {
	        var nextArrayValue = value.map(function (value) {
	            if (value) {
	                var _parse4 = (0, _libphonenumberJs.parse)(value, { country: { default: 'FR' } }),
	                    country = _parse4.country,
	                    phone = _parse4.phone;
	
	                if (phone) return (0, _libphonenumberJs.format)(phone, country, 'International_plaintext');
	
	                var formatter = new _libphonenumberJs.asYouType('FR');
	                return formatter.input(value);
	            }
	            return value;
	        });
	
	        if (nextArrayValue.length == 1 && !nextArrayValue[0]) {
	            // reset array
	            nextArrayValue = [];
	        }
	
	        field.onChange(nextArrayValue);
	    }
	
	    value = value.map(function (v) {
	        return v || '';
	    }); // fix uncontrolled input issue
	
	    return _extends({}, field, { value: value, onChange: onChange });
	}
	
	function phoneFormat(value) {
	    if (value) {
	        var _parse5 = (0, _libphonenumberJs.parse)(value),
	            phone = _parse5.phone;
	
	        return !!phone;
	    }
	    return true;
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(78);
	
	var assign = __webpack_require__(22);
	var canDefineProperty = __webpack_require__(179);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(2202);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Card = function (_Component) {
	    _inherits(Card, _Component);
	
	    function Card() {
	        _classCallCheck(this, Card);
	
	        return _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
	    }
	
	    _createClass(Card, [{
	        key: 'render',
	        value: function render() {
	            var _cx;
	
	            var _props = this.props,
	                children = _props.children,
	                kind = _props.kind,
	                position = _props.position,
	                justified = _props.justified,
	                grouped = _props.grouped,
	                active = _props.active,
	                status = _props.status,
	                header = _props.header,
	                help = _props.help,
	                addon = _props.addon,
	                onClick = _props.onClick;
	
	            var kindClass = kind && kind.toLowerCase();
	            var positionClass = position && position.toLowerCase();
	            var statusClass = status && status.toLowerCase();
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Card2.default.default, _Card2.default[kindClass], _Card2.default[statusClass], _Card2.default[positionClass], (_cx = {}, _defineProperty(_cx, _Card2.default.clickable, onClick), _defineProperty(_cx, _Card2.default.justified, justified), _defineProperty(_cx, _Card2.default.grouped, grouped), _defineProperty(_cx, _Card2.default.active, active), _cx)) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _Card2.default.header },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: _Card2.default.headerMain,
	                            onClick: onClick },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _Card2.default.headerMainContent },
	                            addon && _react2.default.createElement(
	                                'div',
	                                { className: _Card2.default.addon },
	                                addon
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _Card2.default.container },
	                                header
	                            )
	                        )
	                    ),
	                    help && _react2.default.createElement(
	                        'div',
	                        { className: _Card2.default.headerSide },
	                        help
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: _Card2.default.body,
	                        onClick: onClick },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Card2.default.bodyContent },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Card;
	}(_react.Component);
	
	Card.propTypes = {
	    kind: _react.PropTypes.string,
	    position: _react.PropTypes.string,
	    justified: _react.PropTypes.bool,
	    grouped: _react.PropTypes.bool,
	    active: _react.PropTypes.bool,
	    status: _react.PropTypes.string,
	    header: _react.PropTypes.node.isRequired,
	    help: _react.PropTypes.node,
	    addon: _react.PropTypes.node,
	    onClick: _react.PropTypes.func
	};
	exports.default = Card;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(30);
	var createDesc = __webpack_require__(97);
	module.exports = __webpack_require__(28) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(16);
	var hide = __webpack_require__(43);
	var has = __webpack_require__(50);
	var SRC = __webpack_require__(101)('src');
	var $toString = __webpack_require__(557);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(60).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var fails = __webpack_require__(18);
	var defined = __webpack_require__(67);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_USER_QUERY = exports.DEFAULT_AGENCY_QUERY = exports.DEFAULT_COMPANY_QUERY = exports.DEFAULT_QUERY = exports.USER_CONFIGS_UPDATED = exports.COMPANY_CONFIGS_UPDATED = exports.DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED = exports.UPDATE_LOGIN_CMD_UPDATED = exports.UPDATE_USER_CMD_UPDATED = exports.IDENTIFY_COMPANY_CMD_UPDATED = exports.UPDATE_COMPANY_CMD_UPDATED = exports.UPDATE_AGENCY_CMD_UPDATED = exports.REFERENCE_USER_CMD_UPDATED = exports.REFERENCE_AGENCY_CMD_UPDATED = exports.REFERENCE_COMPANY_CMD_UPDATED = exports.MINOR_COMPANY_CRITERIA_RESET = exports.MINOR_COMPANY_CRITERIA_UPDATED = exports.USER_CRITERIA_UPDATED = exports.AGENCY_CRITERIA_UPDATED = exports.COMPANY_CRITERIA_UPDATED = exports.USER_CONFIGS_SENT = exports.COMPANY_CONFIGS_SENT = exports.SEND_ACTIVATION_EMAIL_DEMAND_SENT = exports.DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT = exports.DISABLE_USER_CMD_SENT = exports.DISSOCIATE_USER_FROM_PATRIMONY_CMD_SENT = exports.ASSOCIATE_USER_WITH_PATRIMONY_CMD_SENT = exports.DISSOCIATE_USER_FROM_AGENCY_CMD_SENT = exports.ASSOCIATE_USER_WITH_AGENCY_CMD_SENT = exports.UPDATE_LOGIN_CMD_SENT = exports.UPDATE_USER_CMD_SENT = exports.UPGRADE_COMPANY_TO_STANDARD_ACCOUNT_CMD_SENT = exports.DOWNGRADE_PREMIUM_ACCOUNT_CMD_SENT = exports.UPGRADE_COMPANY_TO_PREMIUM_ACCOUNT_CMD_SENT = exports.CANCEL_COMPANY_CMD_SENT = exports.REACTIVE_COMPANY_CMD_SENT = exports.IDENTIFY_COMPANY_CMD_SENT = exports.UPDATE_COMPANY_CMD_SENT = exports.DELETE_AGENCY_CMD_SENT = exports.UPDATE_AGENCY_CMD_SENT = exports.REFERENCE_USER_CMD_SENT = exports.REFERENCE_AGENCY_CMD_SENT = exports.REFERENCE_COMPANY_CMD_SENT = exports.SUBSIDIARY_STREAM_QUERIED = exports.SUBSIDIARY_STREAM_LOADED = exports.AGENCY_LOADED = exports.AGENCY_STREAM_QUERIED = exports.AGENCY_STREAM_LOADED = exports.USER_CONFIGS_QUERIED = exports.USER_CONFIGS_LOADED = exports.USER_STREAM_LOADED = exports.COMPANY_CONFIGS_QUERIED = exports.COMPANY_CONFIGS_LOADED = exports.COMPANY_LOADED = exports.MINOR_COMPANY_STREAM_QUERIED = exports.COMPANY_STREAM_QUERIED = exports.COMPANY_STREAM_LOADED = exports.LINKS_LOADED = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadLinks = loadLinks;
	exports.queryCompanyStream = queryCompanyStream;
	exports.queryMinorCompanyStream = queryMinorCompanyStream;
	exports.loadCompanyStream = loadCompanyStream;
	exports.loadCompany = loadCompany;
	exports.queryCompanyConfigs = queryCompanyConfigs;
	exports.loadCompanyConfigs = loadCompanyConfigs;
	exports.loadUserStream = loadUserStream;
	exports.queryUserConfigs = queryUserConfigs;
	exports.loadUserConfigs = loadUserConfigs;
	exports.queryAgencyStream = queryAgencyStream;
	exports.loadAgencyStream = loadAgencyStream;
	exports.queryHoldingAgencyStream = queryHoldingAgencyStream;
	exports.loadHoldingAgencyStream = loadHoldingAgencyStream;
	exports.loadAgency = loadAgency;
	exports.querySubsidiaryStream = querySubsidiaryStream;
	exports.loadSubsidiaryStream = loadSubsidiaryStream;
	exports.sendReferenceCompanyCmd = sendReferenceCompanyCmd;
	exports.sendReferenceAgencyCmd = sendReferenceAgencyCmd;
	exports.sendReferenceUserCmd = sendReferenceUserCmd;
	exports.sendUpdateAgencyCmd = sendUpdateAgencyCmd;
	exports.sendUpdateCompanyCmd = sendUpdateCompanyCmd;
	exports.sendIdentifyCompanyCmd = sendIdentifyCompanyCmd;
	exports.sendReactiveCompanyCmd = sendReactiveCompanyCmd;
	exports.sendCancelCompanyCmd = sendCancelCompanyCmd;
	exports.sendUpgradeCompanyToPremiumAccountCmd = sendUpgradeCompanyToPremiumAccountCmd;
	exports.sendDowngradePremiumAccountCmd = sendDowngradePremiumAccountCmd;
	exports.sendUpgradeCompanyToStandardAccountCmd = sendUpgradeCompanyToStandardAccountCmd;
	exports.sendDeleteAgencyCmd = sendDeleteAgencyCmd;
	exports.sendUpdateUserCmd = sendUpdateUserCmd;
	exports.sendUpdateLoginCmd = sendUpdateLoginCmd;
	exports.sendAssociateUserWithAgencyCmd = sendAssociateUserWithAgencyCmd;
	exports.sendDissociateUserFromAgencyCmd = sendDissociateUserFromAgencyCmd;
	exports.sendAssociateUserWithPatrimonyCmd = sendAssociateUserWithPatrimonyCmd;
	exports.sendDissociateUserFromPatrimonyCmd = sendDissociateUserFromPatrimonyCmd;
	exports.sendDisableUserCmd = sendDisableUserCmd;
	exports.sendDowngradeExecutiveToPatrimonyManagerCmd = sendDowngradeExecutiveToPatrimonyManagerCmd;
	exports.sendSendActivationEmailDemand = sendSendActivationEmailDemand;
	exports.sendCompanyConfigs = sendCompanyConfigs;
	exports.sendUserConfigs = sendUserConfigs;
	exports.updateReferenceCompanyCmd = updateReferenceCompanyCmd;
	exports.updateReferenceUserCmd = updateReferenceUserCmd;
	exports.updateUpdateAgencyCmd = updateUpdateAgencyCmd;
	exports.updateUpdateCompanyCmd = updateUpdateCompanyCmd;
	exports.updateUpdateUserCmd = updateUpdateUserCmd;
	exports.updateUpdateLoginCmd = updateUpdateLoginCmd;
	exports.updateMinorCompanyCriteria = updateMinorCompanyCriteria;
	exports.resetMinorCompanyCriteria = resetMinorCompanyCriteria;
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var NAMESPACE = 'Company';
	var LINKS_LOADED = exports.LINKS_LOADED = NAMESPACE + '/LinksLoaded';
	var COMPANY_STREAM_LOADED = exports.COMPANY_STREAM_LOADED = NAMESPACE + '/CompanyStreamLoaded';
	var COMPANY_STREAM_QUERIED = exports.COMPANY_STREAM_QUERIED = NAMESPACE + '/CompanyStreamQueried';
	var MINOR_COMPANY_STREAM_QUERIED = exports.MINOR_COMPANY_STREAM_QUERIED = NAMESPACE + '/MinorCompanyStreamQueried';
	var COMPANY_LOADED = exports.COMPANY_LOADED = NAMESPACE + '/CompanyLoaded';
	var COMPANY_CONFIGS_LOADED = exports.COMPANY_CONFIGS_LOADED = NAMESPACE + '/CompanyConfigsLoaded';
	var COMPANY_CONFIGS_QUERIED = exports.COMPANY_CONFIGS_QUERIED = NAMESPACE + '/CompanyConfigsQueried';
	var USER_STREAM_LOADED = exports.USER_STREAM_LOADED = NAMESPACE + '/UserStreamLoaded';
	var USER_CONFIGS_LOADED = exports.USER_CONFIGS_LOADED = NAMESPACE + '/UserConfigsLoaded';
	var USER_CONFIGS_QUERIED = exports.USER_CONFIGS_QUERIED = NAMESPACE + '/UserConfigsQueried';
	var AGENCY_STREAM_LOADED = exports.AGENCY_STREAM_LOADED = NAMESPACE + '/AgencyStreamLoaded';
	var AGENCY_STREAM_QUERIED = exports.AGENCY_STREAM_QUERIED = NAMESPACE + '/AgencyStreamQueried';
	var AGENCY_LOADED = exports.AGENCY_LOADED = NAMESPACE + '/AgencyLoaded';
	var SUBSIDIARY_STREAM_LOADED = exports.SUBSIDIARY_STREAM_LOADED = NAMESPACE + '/SubsidiaryStreamLoaded';
	var SUBSIDIARY_STREAM_QUERIED = exports.SUBSIDIARY_STREAM_QUERIED = NAMESPACE + '/SubsidiaryStreamQueried';
	var REFERENCE_COMPANY_CMD_SENT = exports.REFERENCE_COMPANY_CMD_SENT = NAMESPACE + '/ReferenceCompanyCmdSent';
	var REFERENCE_AGENCY_CMD_SENT = exports.REFERENCE_AGENCY_CMD_SENT = NAMESPACE + '/ReferenceAgencyCmdSent';
	var REFERENCE_USER_CMD_SENT = exports.REFERENCE_USER_CMD_SENT = NAMESPACE + '/ReferenceUserCmdSent';
	var UPDATE_AGENCY_CMD_SENT = exports.UPDATE_AGENCY_CMD_SENT = NAMESPACE + '/UpdateAgencyCmdSent';
	var DELETE_AGENCY_CMD_SENT = exports.DELETE_AGENCY_CMD_SENT = NAMESPACE + '/DeleteAgencyCmdSent';
	var UPDATE_COMPANY_CMD_SENT = exports.UPDATE_COMPANY_CMD_SENT = NAMESPACE + '/UpdateCompanyCmdSent';
	var IDENTIFY_COMPANY_CMD_SENT = exports.IDENTIFY_COMPANY_CMD_SENT = NAMESPACE + '/IdentifyCompanyCmdSent';
	var REACTIVE_COMPANY_CMD_SENT = exports.REACTIVE_COMPANY_CMD_SENT = NAMESPACE + '/ReactiveCompanyCmdSent';
	var CANCEL_COMPANY_CMD_SENT = exports.CANCEL_COMPANY_CMD_SENT = NAMESPACE + '/CancelCompanyCmdSent';
	var UPGRADE_COMPANY_TO_PREMIUM_ACCOUNT_CMD_SENT = exports.UPGRADE_COMPANY_TO_PREMIUM_ACCOUNT_CMD_SENT = NAMESPACE + '/UpgradeCompanyToPremiumAccountCmdSent';
	var DOWNGRADE_PREMIUM_ACCOUNT_CMD_SENT = exports.DOWNGRADE_PREMIUM_ACCOUNT_CMD_SENT = NAMESPACE + '/DowngradePremiumAccountCmdSent';
	var UPGRADE_COMPANY_TO_STANDARD_ACCOUNT_CMD_SENT = exports.UPGRADE_COMPANY_TO_STANDARD_ACCOUNT_CMD_SENT = NAMESPACE + '/UpgradeCompanyToStandardAccountCmdSent';
	var UPDATE_USER_CMD_SENT = exports.UPDATE_USER_CMD_SENT = NAMESPACE + '/UpdateUserCmdSent';
	var UPDATE_LOGIN_CMD_SENT = exports.UPDATE_LOGIN_CMD_SENT = NAMESPACE + '/UpdateLoginCmdSent';
	var ASSOCIATE_USER_WITH_AGENCY_CMD_SENT = exports.ASSOCIATE_USER_WITH_AGENCY_CMD_SENT = NAMESPACE + '/AssociateUserWithAgencyCmdSent';
	var DISSOCIATE_USER_FROM_AGENCY_CMD_SENT = exports.DISSOCIATE_USER_FROM_AGENCY_CMD_SENT = NAMESPACE + '/DissociateUserFromAgencyCmdSent';
	var ASSOCIATE_USER_WITH_PATRIMONY_CMD_SENT = exports.ASSOCIATE_USER_WITH_PATRIMONY_CMD_SENT = NAMESPACE + '/AssociateUserWithPatrimonyCmdSent';
	var DISSOCIATE_USER_FROM_PATRIMONY_CMD_SENT = exports.DISSOCIATE_USER_FROM_PATRIMONY_CMD_SENT = NAMESPACE + '/DissociateUserFromPatrimonyCmdSent';
	var DISABLE_USER_CMD_SENT = exports.DISABLE_USER_CMD_SENT = NAMESPACE + '/DisableUserCmdSent';
	var DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT = exports.DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT = NAMESPACE + '/DowngradeExecutiveToPatrimonyManagerCmdSent';
	var SEND_ACTIVATION_EMAIL_DEMAND_SENT = exports.SEND_ACTIVATION_EMAIL_DEMAND_SENT = NAMESPACE + '/SendActivationEmailDemandSent';
	var COMPANY_CONFIGS_SENT = exports.COMPANY_CONFIGS_SENT = NAMESPACE + '/CompanyConfigsSent';
	var USER_CONFIGS_SENT = exports.USER_CONFIGS_SENT = NAMESPACE + '/UserConfigsSent';
	// form actions
	var COMPANY_CRITERIA_UPDATED = exports.COMPANY_CRITERIA_UPDATED = NAMESPACE + '/CompanyCriteriaUpdated';
	var AGENCY_CRITERIA_UPDATED = exports.AGENCY_CRITERIA_UPDATED = NAMESPACE + '/AgencyCriteriaUpdated';
	var USER_CRITERIA_UPDATED = exports.USER_CRITERIA_UPDATED = NAMESPACE + '/UserCriteriaUpdated';
	var MINOR_COMPANY_CRITERIA_UPDATED = exports.MINOR_COMPANY_CRITERIA_UPDATED = NAMESPACE + '/MinorCompanyCriteriaUpdated';
	var MINOR_COMPANY_CRITERIA_RESET = exports.MINOR_COMPANY_CRITERIA_RESET = NAMESPACE + '/MinorCompanyCriteriaReset';
	var REFERENCE_COMPANY_CMD_UPDATED = exports.REFERENCE_COMPANY_CMD_UPDATED = NAMESPACE + '/ReferenceCompanyCmdUpdated';
	var REFERENCE_AGENCY_CMD_UPDATED = exports.REFERENCE_AGENCY_CMD_UPDATED = NAMESPACE + '/ReferenceAgencyCmdUpdated';
	var REFERENCE_USER_CMD_UPDATED = exports.REFERENCE_USER_CMD_UPDATED = NAMESPACE + '/ReferenceUserCmdUpdated';
	var UPDATE_AGENCY_CMD_UPDATED = exports.UPDATE_AGENCY_CMD_UPDATED = NAMESPACE + '/UpdateAgencyCmdUpdated';
	var UPDATE_COMPANY_CMD_UPDATED = exports.UPDATE_COMPANY_CMD_UPDATED = NAMESPACE + '/UpdateCompanyCmdUpdated';
	var IDENTIFY_COMPANY_CMD_UPDATED = exports.IDENTIFY_COMPANY_CMD_UPDATED = NAMESPACE + '/IdentifyCompanyCmdUpdated';
	var UPDATE_USER_CMD_UPDATED = exports.UPDATE_USER_CMD_UPDATED = NAMESPACE + '/UpdateUserCmdUpdated';
	var UPDATE_LOGIN_CMD_UPDATED = exports.UPDATE_LOGIN_CMD_UPDATED = NAMESPACE + '/UpdateLoginCmdUpdated';
	var DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED = exports.DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED = NAMESPACE + '/DowngradeExecutiveToPatrimonyManagerCmdUpdated';
	var COMPANY_CONFIGS_UPDATED = exports.COMPANY_CONFIGS_UPDATED = NAMESPACE + '/CompanyConfigsUpdated';
	var USER_CONFIGS_UPDATED = exports.USER_CONFIGS_UPDATED = NAMESPACE + '/UserConfigsUpdated';
	
	function array(array, properties) {
	    array = [].concat(_toConsumableArray(array));
	    Object.keys(properties).forEach(function (key) {
	        return array[key] = properties[key];
	    });
	    return array;
	}
	
	function reduceArray(result, array) {
	    result.push.apply(result, _toConsumableArray(array));
	    return result;
	}
	
	var DEFAULT_QUERY = exports.DEFAULT_QUERY = {
	    range: { offset: 0, limit: 19 }
	};
	
	var DEFAULT_COMPANY_QUERY = exports.DEFAULT_COMPANY_QUERY = _extends({}, DEFAULT_QUERY, {
	    fullText: null,
	    billingType: null,
	    companyType: null,
	    includeSubsidiaries: null
	});
	
	var DEFAULT_AGENCY_QUERY = exports.DEFAULT_AGENCY_QUERY = _extends({}, DEFAULT_QUERY, {
	    companyUid: null,
	    holdingUid: null,
	    active: null
	});
	
	var DEFAULT_USER_QUERY = exports.DEFAULT_USER_QUERY = _extends({}, DEFAULT_QUERY, {
	    companyUid: null,
	    active: null
	});
	
	function loadLinks() {
	    var query = {
	        range: { offset: 0, limit: 0 }
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: LINKS_LOADED,
	            _links: json._links
	        };
	    }), LINKS_LOADED);
	}
	
	function queryCompanyStream(companyQuery) {
	    return loadCompanyStream(companyQuery, COMPANY_STREAM_QUERIED);
	}
	
	function queryMinorCompanyStream(companyQuery) {
	    return loadCompanyStream(companyQuery, MINOR_COMPANY_STREAM_QUERIED);
	}
	
	function loadCompanyStream(companyQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var _state$company = state.company,
	            query = _state$company.query,
	            minorQuery = _state$company.minorQuery;
	
	
	        companyQuery = _extends({}, DEFAULT_QUERY, action && action.includes('Minor') && minorQuery || query, companyQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies', companyQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	            var headers = _ref2.headers,
	                json = _ref2.json;
	
	            return {
	                type: action || COMPANY_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                _links: json._links,
	                query: companyQuery
	            };
	        });
	    }, action || COMPANY_STREAM_LOADED);
	}
	
	function loadCompany(id) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	        id = id || company && company.uid;
	
	        var userQuery = {
	            range: { offset: 0, limit: 0 }
	        };
	
	        var subsidiaryQuery = {
	            range: { offset: 0, limit: 0 }
	        };
	
	        var agencyQuery = {
	            active: true
	        };
	
	        var companyPromise = fetch(_config2.default.api.url + '/clientcompanies/' + id, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var agenciesPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + id + '/agencies', agencyQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var usersPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + id + '/users', userQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var subsidiariesPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + id + '/subsidiaries', subsidiaryQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	
	        return Promise.all([companyPromise, agenciesPromise, usersPromise, subsidiariesPromise]).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 4),
	                companyResponse = _ref4[0],
	                agenciesResponse = _ref4[1],
	                usersResponse = _ref4[2],
	                subsidiariesResponse = _ref4[3];
	
	            return {
	                type: COMPANY_LOADED,
	                company: companyResponse.json,
	                companyAgencies: array(agenciesResponse.json.result, {
	                    count: agenciesResponse.headers.contentRange.count,
	                    _links: agenciesResponse.json._links
	                }),
	                companyUsers: {
	                    count: usersResponse.headers.contentRange.count,
	                    _links: usersResponse.json._links
	                },
	                companySubsidiaries: {
	                    count: subsidiariesResponse.headers.contentRange.count,
	                    _links: subsidiariesResponse.json._links
	                }
	            };
	        });
	    }, COMPANY_LOADED);
	}
	
	function queryCompanyConfigs() {
	    return loadCompanyConfigs(COMPANY_CONFIGS_QUERIED);
	}
	
	function loadCompanyConfigs(action) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/configs', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref5) {
	            var json = _ref5.json;
	
	            return {
	                type: action || COMPANY_CONFIGS_LOADED,
	                companyConfigs: json
	            };
	        });
	    }, action || COMPANY_CONFIGS_LOADED);
	}
	
	function loadUserStream(userQuery) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var query = state.company.user.query;
	
	
	        userQuery = _extends({}, DEFAULT_QUERY, {
	            companyUid: company && company.uid
	        }, query, userQuery);
	
	        var _userQuery = userQuery,
	            companyUid = _userQuery.companyUid,
	            apiUserQuery = _objectWithoutProperties(_userQuery, ['companyUid']);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + companyUid + '/users', apiUserQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref6) {
	            var headers = _ref6.headers,
	                json = _ref6.json;
	
	            return {
	                type: USER_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                query: userQuery
	            };
	        });
	    }, USER_STREAM_LOADED);
	}
	
	function queryUserConfigs(userId) {
	    return loadUserConfigs(userId, USER_CONFIGS_QUERIED);
	}
	
	function loadUserConfigs(userId, action) {
	    return (0, _loading2.default)(fetch(_config2.default.api.url + '/users/' + userId + '/configs', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref7) {
	        var json = _ref7.json;
	
	        return {
	            type: action || USER_CONFIGS_LOADED,
	            userConfigs: json
	        };
	    }), action || USER_CONFIGS_LOADED);
	}
	
	function queryAgencyStream(agencyQuery) {
	    return loadAgencyStream(agencyQuery, AGENCY_STREAM_QUERIED);
	}
	
	function loadAgencyStream(agencyQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var query = state.company.agency.query;
	
	
	        agencyQuery = _extends({}, DEFAULT_AGENCY_QUERY, {
	            companyUid: company && company.uid
	        }, query, agencyQuery);
	
	        var _agencyQuery = agencyQuery,
	            companyUid = _agencyQuery.companyUid,
	            apiAgencyQuery = _objectWithoutProperties(_agencyQuery, ['companyUid']);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + companyUid + '/agencies', apiAgencyQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref8) {
	            var headers = _ref8.headers,
	                json = _ref8.json;
	
	            return {
	                type: action || AGENCY_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                query: agencyQuery
	            };
	        });
	    }, action || AGENCY_STREAM_LOADED);
	}
	
	function queryHoldingAgencyStream(agencyQuery) {
	    return loadHoldingAgencyStream(agencyQuery, AGENCY_STREAM_QUERIED);
	}
	
	function loadHoldingAgencyStream(agencyQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var query = state.company.agency.query;
	
	
	        agencyQuery = _extends({}, DEFAULT_AGENCY_QUERY, {
	            holdingUid: company && company.uid
	        }, query, agencyQuery);
	
	        var _agencyQuery2 = agencyQuery,
	            holdingUid = _agencyQuery2.holdingUid,
	            apiAgencyQuery = _objectWithoutProperties(_agencyQuery2, ['holdingUid']);
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + holdingUid + '/subsidiaries', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref9) {
	            var json = _ref9.json;
	
	            var subsidiaries = json.result;
	            var agenciesPromises = subsidiaries.map(function (s) {
	                return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + s.uid + '/agencies', apiAgencyQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	            });
	            return Promise.all(agenciesPromises);
	        }).then(function (agenciesResponses) {
	            return {
	                type: action || AGENCY_STREAM_LOADED,
	                stream: agenciesResponses.map(function (r) {
	                    return r.json.result;
	                }).reduce(reduceArray),
	                range: null,
	                query: agencyQuery
	            };
	        });
	    }, action || AGENCY_STREAM_LOADED);
	}
	
	function loadAgency(companyId, agencyId) {
	    return (0, _loading2.default)(function (state) {
	        var agency = state.company.agency.agency;
	
	        companyId = companyId || agency && agency.company.uid;
	        agencyId = agencyId || agency && agency.uid;
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + companyId + '/agencies/' + agencyId, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref10) {
	            var json = _ref10.json;
	
	            return {
	                type: AGENCY_LOADED,
	                agency: json
	            };
	        });
	    }, AGENCY_LOADED);
	}
	
	function querySubsidiaryStream(subsidiaryQuery) {
	    return loadSubsidiaryStream(subsidiaryQuery, SUBSIDIARY_STREAM_QUERIED);
	}
	
	function loadSubsidiaryStream(subsidiaryQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var query = state.company.subsidiary.query;
	
	
	        subsidiaryQuery = _extends({}, DEFAULT_QUERY, {
	            holdingUid: company && company.uid
	        }, query, subsidiaryQuery);
	
	        var _subsidiaryQuery = subsidiaryQuery,
	            holdingUid = _subsidiaryQuery.holdingUid,
	            apiSubsidiaryQuery = _objectWithoutProperties(_subsidiaryQuery, ['holdingUid']);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + holdingUid + '/subsidiaries', apiSubsidiaryQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref11) {
	            var headers = _ref11.headers,
	                json = _ref11.json;
	
	            return {
	                type: action || SUBSIDIARY_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                query: subsidiaryQuery
	            };
	        });
	    }, action || SUBSIDIARY_STREAM_LOADED);
	}
	
	function sendReferenceCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var referenceCompanyCmd = state.company.referenceCompanyCmd;
	
	        var label = referenceCompanyCmd.label,
	            cmd = _objectWithoutProperties(referenceCompanyCmd, ['label']);
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                createdDate: new Date().toISOString().slice(0, 10),
	                name: label
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref12) {
	            var json = _ref12.json;
	
	            return {
	                type: REFERENCE_COMPANY_CMD_SENT,
	                events: json.events
	            };
	        });
	    }, REFERENCE_COMPANY_CMD_SENT);
	}
	
	function sendReferenceAgencyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$company2 = state.company,
	            referenceAgencyCmd = _state$company2.referenceAgencyCmd,
	            company = _state$company2.company;
	
	        var _referenceAgencyCmd$a = referenceAgencyCmd.agency,
	            ref = _referenceAgencyCmd$a.ref,
	            label = _referenceAgencyCmd$a.label,
	            emails = _referenceAgencyCmd$a.emails,
	            phones = _referenceAgencyCmd$a.phones,
	            agency = _objectWithoutProperties(_referenceAgencyCmd$a, ['ref', 'label', 'emails', 'phones']);
	
	        var option = {
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                createdDate: new Date().toISOString().slice(0, 10),
	                commandType: 'CreateAgency',
	                agency: _extends({
	                    extName: ref,
	                    name: label,
	                    emails: emails || [],
	                    phones: phones || []
	                }, agency)
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid + '/agencies', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REFERENCE_AGENCY_CMD_SENT
	            };
	        });
	    }, REFERENCE_AGENCY_CMD_SENT);
	}
	
	function sendReferenceUserCmd() {
	    return (0, _loading2.default)(function (state) {
	        var referenceUserCmd = state.company.referenceUserCmd;
	        var managedPatrimonies = referenceUserCmd.managedPatrimonies;
	
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4()
	            }, referenceUserCmd, {
	                managedPatrimonies: managedPatrimonies && managedPatrimonies.map(function (a) {
	                    return a.uid;
	                })
	            })
	        };
	
	        return fetch(_config2.default.api.event.url + '/users', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REFERENCE_USER_CMD_SENT
	            };
	        });
	    }, REFERENCE_USER_CMD_SENT);
	}
	
	function sendUpdateAgencyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var updateAgencyCmd = state.company.updateAgencyCmd;
	
	        var _updateAgencyCmd$agen = updateAgencyCmd.agency,
	            uid = _updateAgencyCmd$agen.uid,
	            company = _updateAgencyCmd$agen.company,
	            ref = _updateAgencyCmd$agen.ref,
	            label = _updateAgencyCmd$agen.label,
	            emails = _updateAgencyCmd$agen.emails,
	            phones = _updateAgencyCmd$agen.phones,
	            agency = _objectWithoutProperties(_updateAgencyCmd$agen, ['uid', 'company', 'ref', 'label', 'emails', 'phones']);
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                updatedDate: new Date().toISOString().slice(0, 10),
	                commandType: 'UpdateAgency',
	                agency: _extends({
	                    extName: ref,
	                    name: label,
	                    emails: emails || [],
	                    phones: phones || []
	                }, agency)
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid + '/agencies/' + uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_AGENCY_CMD_SENT
	            };
	        });
	    }, UPDATE_AGENCY_CMD_SENT);
	}
	
	function sendUpdateCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$company3 = state.company,
	            updateCompanyCmd = _state$company3.updateCompanyCmd,
	            company = _state$company3.company;
	
	        var label = updateCompanyCmd.label,
	            cmd = _objectWithoutProperties(updateCompanyCmd, ['label']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                updatedDate: new Date().toISOString().slice(0, 10),
	                name: label
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_COMPANY_CMD_SENT
	            };
	        });
	    }, UPDATE_COMPANY_CMD_SENT);
	}
	
	function sendIdentifyCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$company4 = state.company,
	            identifyCompanyCmd = _state$company4.identifyCompanyCmd,
	            company = _state$company4.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'IdentifyCompany'
	            }, identifyCompanyCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: IDENTIFY_COMPANY_CMD_SENT
	            };
	        });
	    }, IDENTIFY_COMPANY_CMD_SENT);
	}
	
	function sendReactiveCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                reactivatedDate: new Date().toISOString().slice(0, 10),
	                commandType: 'ReactiveCompany'
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REACTIVE_COMPANY_CMD_SENT
	            };
	        });
	    }, REACTIVE_COMPANY_CMD_SENT);
	}
	
	function sendCancelCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                canceledDate: new Date().toISOString().slice(0, 10),
	                commandType: 'CancelCompany'
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: CANCEL_COMPANY_CMD_SENT
	            };
	        });
	    }, CANCEL_COMPANY_CMD_SENT);
	}
	
	function sendUpgradeCompanyToPremiumAccountCmd() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                upgradedDate: new Date().toISOString().slice(0, 10),
	                commandType: 'UpgradeCompanyToPremiumAccount'
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPGRADE_COMPANY_TO_PREMIUM_ACCOUNT_CMD_SENT
	            };
	        });
	    }, UPGRADE_COMPANY_TO_PREMIUM_ACCOUNT_CMD_SENT);
	}
	
	function sendDowngradePremiumAccountCmd() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                downgradedDate: new Date().toISOString().slice(0, 10),
	                commandType: 'DowngradePremiumAccount'
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DOWNGRADE_PREMIUM_ACCOUNT_CMD_SENT
	            };
	        });
	    }, DOWNGRADE_PREMIUM_ACCOUNT_CMD_SENT);
	}
	
	function sendUpgradeCompanyToStandardAccountCmd() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                upgradedDate: new Date().toISOString().slice(0, 10),
	                commandType: 'UpgradeCompanyToStandardAccount'
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/clientcompanies/' + company.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPGRADE_COMPANY_TO_STANDARD_ACCOUNT_CMD_SENT
	            };
	        });
	    }, UPGRADE_COMPANY_TO_STANDARD_ACCOUNT_CMD_SENT);
	}
	
	function sendDeleteAgencyCmd(companyId, agencyId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            deletedDate: new Date().toISOString().slice(0, 10),
	            commandType: 'DeleteAgency',
	            agencyUid: agencyId
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_config2.default.api.event.url + '/clientcompanies/' + companyId + '/agencies/' + agencyId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: DELETE_AGENCY_CMD_SENT
	        };
	    }), DELETE_AGENCY_CMD_SENT);
	}
	
	function sendUpdateUserCmd() {
	    return (0, _loading2.default)(function (state) {
	        var updateUserCmd = state.company.updateUserCmd;
	
	        var uid = updateUserCmd.uid,
	            cmd = _objectWithoutProperties(updateUserCmd, ['uid']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'UpdateUser'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/users/' + uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_USER_CMD_SENT
	            };
	        });
	    }, UPDATE_USER_CMD_SENT);
	}
	
	function sendUpdateLoginCmd() {
	    return (0, _loading2.default)(function (state) {
	        var updateLoginCmd = state.company.updateLoginCmd;
	
	        var uid = updateLoginCmd.uid,
	            cmd = _objectWithoutProperties(updateLoginCmd, ['uid']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'UpdateLogin'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/users/' + uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_LOGIN_CMD_SENT
	            };
	        });
	    }, UPDATE_LOGIN_CMD_SENT);
	}
	
	function sendAssociateUserWithAgencyCmd(userId, agencyId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'AssociateUserWithAgency',
	            agencyUid: agencyId
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: ASSOCIATE_USER_WITH_AGENCY_CMD_SENT
	        };
	    }), ASSOCIATE_USER_WITH_AGENCY_CMD_SENT);
	}
	
	function sendDissociateUserFromAgencyCmd(userId, agencyId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'DissociateUserFromAgency',
	            agencyUid: agencyId
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: DISSOCIATE_USER_FROM_AGENCY_CMD_SENT
	        };
	    }), DISSOCIATE_USER_FROM_AGENCY_CMD_SENT);
	}
	
	function sendAssociateUserWithPatrimonyCmd(userId, patrimonyId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'AssociateUserWithPatrimony',
	            patrimonyUid: patrimonyId
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: ASSOCIATE_USER_WITH_PATRIMONY_CMD_SENT
	        };
	    }), ASSOCIATE_USER_WITH_PATRIMONY_CMD_SENT);
	}
	
	function sendDissociateUserFromPatrimonyCmd(userId, patrimonyId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'DissociateUserFromPatrimony',
	            patrimonyUid: patrimonyId
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: DISSOCIATE_USER_FROM_PATRIMONY_CMD_SENT
	        };
	    }), DISSOCIATE_USER_FROM_PATRIMONY_CMD_SENT);
	}
	
	function sendDisableUserCmd(userId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'DisableUser'
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: DISABLE_USER_CMD_SENT
	        };
	    }), DISABLE_USER_CMD_SENT);
	}
	
	function sendDowngradeExecutiveToPatrimonyManagerCmd(userId) {
	    return (0, _loading2.default)(function (state) {
	        var downgradeExecutiveToPatrimonyManagerCmd = state.company.downgradeExecutiveToPatrimonyManagerCmd;
	        var managedPatrimonies = downgradeExecutiveToPatrimonyManagerCmd.managedPatrimonies;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'DowngradeExecutiveToPatrimonyManager'
	            }, downgradeExecutiveToPatrimonyManagerCmd, {
	                managedPatrimonies: managedPatrimonies && managedPatrimonies.map(function (a) {
	                    return a.uid;
	                })
	            })
	        };
	
	        return fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT
	            };
	        });
	    }, DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT);
	}
	
	function sendSendActivationEmailDemand(userId) {
	    var option = {
	        body: {
	            userUid: userId
	        }
	    };
	
	    return fetch(_config2.default.api.url + '/sendActivationEmailDemand', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: SEND_ACTIVATION_EMAIL_DEMAND_SENT
	        };
	    });
	}
	
	function sendCompanyConfigs() {
	    return (0, _loading2.default)(function (state) {
	        var _state$company5 = state.company,
	            company = _state$company5.company,
	            companyConfigs = _state$company5.companyConfigs;
	
	
	        var option = {
	            method: 'PATCH',
	            body: companyConfigs
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/configs', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function () {
	            return {
	                type: COMPANY_CONFIGS_SENT
	            };
	        });
	    }, COMPANY_CONFIGS_SENT);
	}
	
	function sendUserConfigs(userId) {
	    return (0, _loading2.default)(function (state) {
	        var userConfigs = state.company.user.userConfigs;
	
	
	        var option = {
	            method: 'PATCH',
	            body: userConfigs
	        };
	
	        return fetch(_config2.default.api.url + '/users/' + userId + '/configs', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function () {
	            return {
	                type: USER_CONFIGS_SENT
	            };
	        });
	    }, USER_CONFIGS_SENT);
	}
	
	function updateReferenceCompanyCmd(cmd) {
	    return {
	        type: REFERENCE_COMPANY_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateReferenceUserCmd(cmd) {
	    return {
	        type: REFERENCE_USER_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateUpdateAgencyCmd(cmd) {
	    return {
	        type: UPDATE_AGENCY_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateUpdateCompanyCmd(cmd) {
	    return {
	        type: UPDATE_COMPANY_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateUpdateUserCmd(cmd) {
	    return {
	        type: UPDATE_USER_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateUpdateLoginCmd(cmd) {
	    return {
	        type: UPDATE_LOGIN_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateMinorCompanyCriteria(cmd) {
	    return {
	        type: MINOR_COMPANY_CRITERIA_UPDATED,
	        cmd: cmd
	    };
	}
	
	function resetMinorCompanyCriteria(cmd) {
	    return {
	        type: MINOR_COMPANY_CRITERIA_RESET,
	        cmd: cmd
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_CONTACT_STATS_QUERY = exports.DEFAULT_CONTACT_QUERY = exports.DEFAULT_PROVIDER_COVERAGE_QUERY = exports.DEFAULT_PROVIDER_QUERY = exports.DEFAULT_QUERY = exports.EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED = exports.SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED = exports.ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED = exports.ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED = exports.UPDATE_PROVIDER_CONTACT_CMD_UPDATED = exports.ADD_PROVIDER_CONTACT_CMD_UPDATED = exports.REFERENCE_PROVIDER_COMPANY_CMD_UPDATED = exports.CONTACT_MINOR_CRITERIA_RESET = exports.CONTACT_MINOR_CRITERIA_UPDATED = exports.CONTACT_FILTER_UPDATED = exports.CONTACT_CRITERIA_UPDATED = exports.PROVIDER_COVERAGE_CRITERIA_UPDATED = exports.PROVIDER_MINOR_CRITERIA_RESETTED = exports.PROVIDER_MINOR_CRITERIA_UPDATED = exports.PROVIDER_CRITERIA_UPDATED = exports.EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_INTERVENTION_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_REPAIR_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT = exports.SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_CALL_OUT_CHARGES_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_INTERVENTION_ZONE_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_SERVICE_CHARGE_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT = exports.UNASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT = exports.ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT = exports.REMOVE_ACTIVITY_FROM_PROVIDER_CONTACT_CMD_SENT = exports.ASSIGN_ACTIVITY_TO_PROVIDER_CONTACT_CMD_SENT = exports.DISSOCIATE_PROVIDER_CONTACT_FROM_PATRIMONY_CMD_SENT = exports.ASSOCIATE_PROVIDER_CONTACT_WITH_PATRIMONY_CMD_SENT = exports.ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT = exports.UPDATE_PROVIDER_CONTACT_CMD_SENT = exports.ADD_PROVIDER_CONTACT_CMD_SENT = exports.REFERENCE_PROVIDER_COMPANY_CMD_SENT = exports.CONTACT_LOADED = exports.CONTACT_SUGGEST_QUERIED = exports.CONTACT_SUGGEST_LOADED = exports.CONTACT_STREAM_QUERIED = exports.CONTACT_STREAM_LOADED = exports.CONTACT_LINKS_LOADED = exports.PROVIDER_LOADED = exports.PROVIDER_COVERAGE_LOADED = exports.PROVIDER_SUGGEST_QUERIED = exports.PROVIDER_SUGGEST_LOADED = exports.PROVIDER_STREAM_QUERIED = exports.PROVIDER_STREAM_LOADED = exports.PROVIDER_LINKS_LOADED = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadProviderLinks = loadProviderLinks;
	exports.queryProviderStream = queryProviderStream;
	exports.loadProviderStream = loadProviderStream;
	exports.queryProviderSuggest = queryProviderSuggest;
	exports.loadProviderSuggest = loadProviderSuggest;
	exports.loadProviderCoverage = loadProviderCoverage;
	exports.loadProvider = loadProvider;
	exports.loadContactLinks = loadContactLinks;
	exports.queryContactStream = queryContactStream;
	exports.loadContactStream = loadContactStream;
	exports.queryContactSuggest = queryContactSuggest;
	exports.loadContactSuggest = loadContactSuggest;
	exports.loadContact = loadContact;
	exports.sendReferenceProviderCompanyCmd = sendReferenceProviderCompanyCmd;
	exports.sendAddProviderContactCmd = sendAddProviderContactCmd;
	exports.sendUpdateProviderContactCmd = sendUpdateProviderContactCmd;
	exports.sendAssociateProviderContactWithProviderCompanyCmd = sendAssociateProviderContactWithProviderCompanyCmd;
	exports.sendAssociateProviderContactWithPatrimonyCmd = sendAssociateProviderContactWithPatrimonyCmd;
	exports.sendDissociateProviderContactFromPatrimonyCmd = sendDissociateProviderContactFromPatrimonyCmd;
	exports.sendAssignActivityToProviderContactCmd = sendAssignActivityToProviderContactCmd;
	exports.sendRemoveActivityFromProviderContactCmd = sendRemoveActivityFromProviderContactCmd;
	exports.sendAssignActivityToProviderCompanyCmd = sendAssignActivityToProviderCompanyCmd;
	exports.sendUnAssignActivityFromProviderCompanyCmd = sendUnAssignActivityFromProviderCompanyCmd;
	exports.sendDefineUpdateInterventionPeriodForActivityCmd = sendDefineUpdateInterventionPeriodForActivityCmd;
	exports.sendRemoveInterventionPeriodCmd = sendRemoveInterventionPeriodCmd;
	exports.sendDefineServiceChargeForInterventionPeriodCmd = sendDefineServiceChargeForInterventionPeriodCmd;
	exports.sendRemoveServiceChargeFromInterventionPeriodCmd = sendRemoveServiceChargeFromInterventionPeriodCmd;
	exports.sendDefineInterventionZoneForInterventionPeriodCmd = sendDefineInterventionZoneForInterventionPeriodCmd;
	exports.sendRemoveInterventionZoneFromInterventionPeriodCmd = sendRemoveInterventionZoneFromInterventionPeriodCmd;
	exports.sendDefineCallOutChargesForInterventionPeriodCmd = sendDefineCallOutChargesForInterventionPeriodCmd;
	exports.sendRemoveCallOutChargesFromInterventionPeriodCmd = sendRemoveCallOutChargesFromInterventionPeriodCmd;
	exports.sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd = sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd;
	exports.sendDefineContactInfosForProviderCompanyCmd = sendDefineContactInfosForProviderCompanyCmd;
	exports.sendDefineRepairTimelimitForInterventionPeriodCmd = sendDefineRepairTimelimitForInterventionPeriodCmd;
	exports.sendRemoveRepairTimelimitFromInterventionPeriodCmd = sendRemoveRepairTimelimitFromInterventionPeriodCmd;
	exports.sendDefineInterventionTimelimitForInterventionPeriodCmd = sendDefineInterventionTimelimitForInterventionPeriodCmd;
	exports.sendRemoveInterventionTimelimitFromInterventionPeriodCmd = sendRemoveInterventionTimelimitFromInterventionPeriodCmd;
	exports.sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd = sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd;
	exports.updateAddProviderContactCmd = updateAddProviderContactCmd;
	exports.updateUpdateProviderContactCmd = updateUpdateProviderContactCmd;
	exports.updateAssociateProviderContactWithProviderCompanyCmd = updateAssociateProviderContactWithProviderCompanyCmd;
	exports.updateDefineUpdateInterventionPeriodForActivityCmd = updateDefineUpdateInterventionPeriodForActivityCmd;
	exports.updateDefineServiceChargeForInterventionPeriodCmd = updateDefineServiceChargeForInterventionPeriodCmd;
	exports.updateDefineInterventionZoneForInterventionPeriodCmd = updateDefineInterventionZoneForInterventionPeriodCmd;
	exports.updateDefineCallOutChargesForInterventionPeriodCmd = updateDefineCallOutChargesForInterventionPeriodCmd;
	exports.updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd = updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd;
	exports.updateDefineContactInfosForProviderCompanyCmd = updateDefineContactInfosForProviderCompanyCmd;
	exports.updateDefineRepairTimelimitForInterventionPeriodCmd = updateDefineRepairTimelimitForInterventionPeriodCmd;
	exports.updateDefineInterventionTimelimitForInterventionPeriodCmd = updateDefineInterventionTimelimitForInterventionPeriodCmd;
	exports.updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd = updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd;
	exports.updateProviderCriteria = updateProviderCriteria;
	exports.updateProviderCoverageCriteria = updateProviderCoverageCriteria;
	exports.updateProviderMinorCriteria = updateProviderMinorCriteria;
	exports.resetProviderMinorCriteria = resetProviderMinorCriteria;
	exports.updateContactMinorCriteria = updateContactMinorCriteria;
	exports.resetContactMinorCriteria = resetContactMinorCriteria;
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _fetchz = __webpack_require__(86);
	
	var _momentz = __webpack_require__(186);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _links2 = __webpack_require__(33);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NAMESPACE = 'Provider';
	var PROVIDER_LINKS_LOADED = exports.PROVIDER_LINKS_LOADED = NAMESPACE + '/ProviderLinksLoaded';
	var PROVIDER_STREAM_LOADED = exports.PROVIDER_STREAM_LOADED = NAMESPACE + '/ProviderStreamLoaded';
	var PROVIDER_STREAM_QUERIED = exports.PROVIDER_STREAM_QUERIED = NAMESPACE + '/ProviderStreamQueried';
	var PROVIDER_SUGGEST_LOADED = exports.PROVIDER_SUGGEST_LOADED = NAMESPACE + '/ProviderSuggestLoaded';
	var PROVIDER_SUGGEST_QUERIED = exports.PROVIDER_SUGGEST_QUERIED = NAMESPACE + '/ProviderSuggestQueried';
	var PROVIDER_COVERAGE_LOADED = exports.PROVIDER_COVERAGE_LOADED = NAMESPACE + '/ProviderCoverageLoaded';
	var PROVIDER_LOADED = exports.PROVIDER_LOADED = NAMESPACE + '/ProviderLoaded';
	var CONTACT_LINKS_LOADED = exports.CONTACT_LINKS_LOADED = NAMESPACE + '/ContactLinksLoaded';
	var CONTACT_STREAM_LOADED = exports.CONTACT_STREAM_LOADED = NAMESPACE + '/ContactStreamLoaded';
	var CONTACT_STREAM_QUERIED = exports.CONTACT_STREAM_QUERIED = NAMESPACE + '/ContactStreamQueried';
	var CONTACT_SUGGEST_LOADED = exports.CONTACT_SUGGEST_LOADED = NAMESPACE + '/ContactSuggestLoaded';
	var CONTACT_SUGGEST_QUERIED = exports.CONTACT_SUGGEST_QUERIED = NAMESPACE + '/ContactSuggestQueried';
	var CONTACT_LOADED = exports.CONTACT_LOADED = NAMESPACE + '/ContactLoaded';
	var REFERENCE_PROVIDER_COMPANY_CMD_SENT = exports.REFERENCE_PROVIDER_COMPANY_CMD_SENT = NAMESPACE + '/ReferenceProviderCmdSent';
	var ADD_PROVIDER_CONTACT_CMD_SENT = exports.ADD_PROVIDER_CONTACT_CMD_SENT = NAMESPACE + '/AddProviderContactCmdSent';
	var UPDATE_PROVIDER_CONTACT_CMD_SENT = exports.UPDATE_PROVIDER_CONTACT_CMD_SENT = NAMESPACE + '/UpdateProviderContactCmdSent';
	var ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT = exports.ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT = NAMESPACE + '/AssociateProviderContactWithProviderCompanyCmdSent';
	var ASSOCIATE_PROVIDER_CONTACT_WITH_PATRIMONY_CMD_SENT = exports.ASSOCIATE_PROVIDER_CONTACT_WITH_PATRIMONY_CMD_SENT = NAMESPACE + '/AssociateProviderContactWithPatrimonyCmdSent';
	var DISSOCIATE_PROVIDER_CONTACT_FROM_PATRIMONY_CMD_SENT = exports.DISSOCIATE_PROVIDER_CONTACT_FROM_PATRIMONY_CMD_SENT = NAMESPACE + '/DissociateProviderContactFromPatrimonyCmdSent';
	var ASSIGN_ACTIVITY_TO_PROVIDER_CONTACT_CMD_SENT = exports.ASSIGN_ACTIVITY_TO_PROVIDER_CONTACT_CMD_SENT = NAMESPACE + '/AssignActivityToProviderContactCmdSent';
	var REMOVE_ACTIVITY_FROM_PROVIDER_CONTACT_CMD_SENT = exports.REMOVE_ACTIVITY_FROM_PROVIDER_CONTACT_CMD_SENT = NAMESPACE + '/RemoveActivityFromProviderContactCmdSent';
	var ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT = exports.ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT = NAMESPACE + '/AssignActivityToProviderCompanyCmdSent';
	var UNASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT = exports.UNASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT = NAMESPACE + '/UnAssignActivityToProviderCompanyCmdSent';
	var DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT = exports.DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT = NAMESPACE + '/DefineUpdateInterventionPeriodForActivityCmdSent';
	var REMOVE_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveInterventionPeriodCmdSent';
	var DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineServiceChargeForInterventionPeriodCmdSent';
	var REMOVE_SERVICE_CHARGE_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_SERVICE_CHARGE_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveServiceChargeFromInterventionPeriodCmdSent';
	var DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineInterventionZoneForInterventionPeriodCmdSent';
	var REMOVE_INTERVENTION_ZONE_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_INTERVENTION_ZONE_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveInterventionZoneFromInterventionPeriodCmdSent';
	var DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineCallOutChargesForInterventionPeriodCmdSent';
	var REMOVE_CALL_OUT_CHARGES_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_CALL_OUT_CHARGES_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveCallOutChargesFromInterventionPeriodCmdSent';
	var SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/SubscribeProviderCompanyToDirectoryForInterventionPeriodCmdSent';
	var DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT = exports.DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT = NAMESPACE + '/DefineContactInfosForProviderCompanyCmdSent';
	var DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineRepairTimelimitForInterventionPeriodCmdSent';
	var REMOVE_REPAIR_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_REPAIR_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveRepairTimelimitFromInterventionPeriodCmdSent';
	var DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT = exports.DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/DefineInterventionTimelimitForInterventionPeriodCmdSent';
	var REMOVE_INTERVENTION_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.REMOVE_INTERVENTION_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/RemoveInterventionTimelimitFromInterventionPeriodCmdSent';
	var EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT = exports.EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT = NAMESPACE + '/ExcludeOpeningTicketPurposesFromInterventionPeriodCmdSent';
	// form actions
	var PROVIDER_CRITERIA_UPDATED = exports.PROVIDER_CRITERIA_UPDATED = NAMESPACE + '/ProviderCriteriaUpdated';
	var PROVIDER_MINOR_CRITERIA_UPDATED = exports.PROVIDER_MINOR_CRITERIA_UPDATED = NAMESPACE + '/ProviderMinorCriteriaUpdated';
	var PROVIDER_MINOR_CRITERIA_RESETTED = exports.PROVIDER_MINOR_CRITERIA_RESETTED = NAMESPACE + '/ProviderMinorCriteriaResetted';
	var PROVIDER_COVERAGE_CRITERIA_UPDATED = exports.PROVIDER_COVERAGE_CRITERIA_UPDATED = NAMESPACE + '/ProviderCoverageCriteriaUpdated';
	var CONTACT_CRITERIA_UPDATED = exports.CONTACT_CRITERIA_UPDATED = NAMESPACE + '/ContactCriteriaUpdated';
	var CONTACT_FILTER_UPDATED = exports.CONTACT_FILTER_UPDATED = NAMESPACE + '/ContactFilterUpdated';
	var CONTACT_MINOR_CRITERIA_UPDATED = exports.CONTACT_MINOR_CRITERIA_UPDATED = NAMESPACE + '/ContactMinorCriteriaUpdated';
	var CONTACT_MINOR_CRITERIA_RESET = exports.CONTACT_MINOR_CRITERIA_RESET = NAMESPACE + '/ContactMinorCriteriaReset';
	var REFERENCE_PROVIDER_COMPANY_CMD_UPDATED = exports.REFERENCE_PROVIDER_COMPANY_CMD_UPDATED = NAMESPACE + '/ReferenceProviderCompanyCmdUpdated';
	var ADD_PROVIDER_CONTACT_CMD_UPDATED = exports.ADD_PROVIDER_CONTACT_CMD_UPDATED = NAMESPACE + '/AddProviderContactCmdUpdated';
	var UPDATE_PROVIDER_CONTACT_CMD_UPDATED = exports.UPDATE_PROVIDER_CONTACT_CMD_UPDATED = NAMESPACE + '/UpdateProviderContactCmdUpdated';
	var ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED = exports.ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED = NAMESPACE + '/AssociateProviderContactWithProviderCompanyCmdUpdated';
	var ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED = exports.ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED = NAMESPACE + '/AssignActivityToProviderCompanyCmdUpdated';
	var DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED = exports.DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED = NAMESPACE + '/DefineUpdateInterventionPeriodForActivityCmdUpdated';
	var DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineServiceChargeForInterventionPeriodCmdUpdated';
	var DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineInterventionZoneForInterventionPeriodCmdUpdated';
	var DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineCallOutChargesForInterventionPeriodCmdUpdated';
	var SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/SubscribeProviderCompanyToDirectoryForInterventionPeriodCmdUpdated';
	var DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED = exports.DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED = NAMESPACE + '/DefineContactInfosForProviderCompanyCmdUpdated';
	var DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineRepairTimelimitForInterventionPeriodCmdUpdated';
	var DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED = exports.DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/DefineInterventionTimelimitForInterventionPeriodCmdUpdated';
	var EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED = exports.EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED = NAMESPACE + '/ExcludeOpeningTicketPurposesFromInterventionPeriodCmdUpdated';
	
	var DEFAULT_QUERY = exports.DEFAULT_QUERY = {
	    range: { offset: 0, limit: 19 }
	};
	
	var DEFAULT_PROVIDER_QUERY = exports.DEFAULT_PROVIDER_QUERY = _extends({}, DEFAULT_QUERY, {
	    fullText: null,
	    activityUid: null,
	    filtered: null
	});
	
	var DEFAULT_PROVIDER_COVERAGE_QUERY = exports.DEFAULT_PROVIDER_COVERAGE_QUERY = {
	    zipCodes: null,
	    department: null,
	    activityUids: null
	};
	
	var DEFAULT_CONTACT_QUERY = exports.DEFAULT_CONTACT_QUERY = _extends({}, DEFAULT_QUERY, {
	    companyUid: null,
	    agencyUids: null,
	    providerCompanyUid: null,
	    patrimonyUids: null,
	    activityUids: null,
	    openingTicketPurposeUids: null,
	    fullText: null
	});
	
	var DEFAULT_CONTACT_STATS_QUERY = exports.DEFAULT_CONTACT_STATS_QUERY = {
	    from: null,
	    to: null
	};
	
	function loadProviderLinks() {
	    var query = {
	        range: { offset: 0, limit: 0 }
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/providercompanies', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: PROVIDER_LINKS_LOADED,
	            _links: json._links
	        };
	    }), PROVIDER_LINKS_LOADED);
	}
	
	function queryProviderStream(providerQuery) {
	    return loadProviderStream(providerQuery, PROVIDER_STREAM_QUERIED);
	}
	
	function loadProviderStream(providerQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var query = state.provider.query;
	
	
	        providerQuery = _extends({}, DEFAULT_PROVIDER_QUERY, query, providerQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/providercompanies', providerQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	            var headers = _ref2.headers,
	                json = _ref2.json;
	
	            return {
	                type: action || PROVIDER_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                _links: json._links,
	                query: providerQuery
	            };
	        });
	    }, action || PROVIDER_STREAM_LOADED);
	}
	
	function queryProviderSuggest(suggestQuery) {
	    return loadProviderSuggest(suggestQuery, PROVIDER_SUGGEST_QUERIED);
	}
	
	function loadProviderSuggest(suggestQuery, action) {
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/providercompanies/suggest', suggestQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref3) {
	        var headers = _ref3.headers,
	            json = _ref3.json;
	
	        return {
	            type: action || PROVIDER_SUGGEST_LOADED,
	            suggest: json.result
	        };
	    }), action || PROVIDER_SUGGEST_LOADED);
	}
	
	function loadProviderCoverage(coverageQuery) {
	    return (0, _loading2.default)(function (state) {
	        var query = state.provider.coverage.query;
	
	
	        coverageQuery = _extends({}, DEFAULT_PROVIDER_COVERAGE_QUERY, query, coverageQuery);
	
	        if (coverageQuery.zipCodes || coverageQuery.department || coverageQuery.city) {
	            var _coverageQuery = coverageQuery,
	                activityUids = _coverageQuery.activityUids,
	                zipCodes = _coverageQuery.zipCodes,
	                department = _coverageQuery.department,
	                city = _coverageQuery.city,
	                body = _objectWithoutProperties(_coverageQuery, ['activityUids', 'zipCodes', 'department', 'city']);
	
	            var option = {
	                body: _extends({}, body, {
	                    activityuids: activityUids && activityUids.map(function (a) {
	                        return a.uid;
	                    }) || [],
	                    zipcodes: zipCodes && zipCodes.split(/[,;:\s]+/) || undefined,
	                    cityuids: city && [city.cityUid] || undefined,
	                    department: department && department.departmentNumber || undefined
	                })
	            };
	
	            return fetch(_config2.default.api.url + '/providercompanies/citycoverage', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref4) {
	                var headers = _ref4.headers,
	                    json = _ref4.json;
	
	                return {
	                    type: PROVIDER_COVERAGE_LOADED,
	                    coverage: json.cities,
	                    query: coverageQuery
	                };
	            });
	        } else {
	            var _coverageQuery2 = coverageQuery,
	                _activityUids = _coverageQuery2.activityUids,
	                _body = _objectWithoutProperties(_coverageQuery2, ['activityUids']);
	
	            var _option = {
	                body: _extends({}, _body, {
	                    activityuids: _activityUids && _activityUids.map(function (a) {
	                        return a.uid;
	                    }) || []
	                })
	            };
	
	            return fetch(_config2.default.api.url + '/providercompanies/departmentcoverage', (0, _fetchz.apiOption)(_option)).then(_fetchz.apiResponse).then(function (_ref5) {
	                var headers = _ref5.headers,
	                    json = _ref5.json;
	
	                return {
	                    type: PROVIDER_COVERAGE_LOADED,
	                    coverage: json.departments,
	                    query: coverageQuery
	                };
	            });
	        }
	    }, PROVIDER_COVERAGE_LOADED);
	}
	
	function loadProvider(id) {
	    return (0, _loading2.default)(function (state) {
	        var provider = state.provider.provider;
	
	        id = id || provider && provider.uid;
	
	        return fetch(_config2.default.api.url + '/providercompanies/' + id, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref6) {
	            var json = _ref6.json;
	
	            return {
	                type: PROVIDER_LOADED,
	                provider: json
	            };
	        });
	    }, PROVIDER_LOADED);
	}
	
	function loadContactLinks() {
	    var query = {
	        range: { offset: 0, limit: 0 }
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/providercontacts', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref7) {
	        var json = _ref7.json;
	
	        return {
	            type: CONTACT_LINKS_LOADED,
	            _links: json._links
	        };
	    }), CONTACT_LINKS_LOADED);
	}
	
	function queryContactStream(contactQuery) {
	    return loadContactStream(contactQuery, CONTACT_STREAM_QUERIED);
	}
	
	function loadContactStream(contactQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var query = state.provider.contact.query;
	
	
	        contactQuery = _extends({}, DEFAULT_CONTACT_QUERY, query, contactQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/providercontacts', contactQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref8) {
	            var headers = _ref8.headers,
	                json = _ref8.json;
	
	            return {
	                type: action || CONTACT_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                _links: json._links,
	                query: contactQuery
	            };
	        });
	    }, action || CONTACT_STREAM_LOADED);
	}
	
	function queryContactSuggest(suggestQuery) {
	    return loadContactSuggest(suggestQuery, CONTACT_SUGGEST_QUERIED);
	}
	
	function loadContactSuggest(suggestQuery, action) {
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/providercontacts/suggest', suggestQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref9) {
	        var headers = _ref9.headers,
	            json = _ref9.json;
	
	        return {
	            type: action || CONTACT_SUGGEST_LOADED,
	            suggest: json.result
	        };
	    }), action || CONTACT_SUGGEST_LOADED);
	}
	
	function loadContact(id, query) {
	    return (0, _loading2.default)(function (state) {
	        var _state$provider$conta = state.provider.contact,
	            contact = _state$provider$conta.contact,
	            contactStatsQuery = _state$provider$conta.contactStatsQuery;
	
	        id = id || contact && contact.uid;
	
	        query = _extends({}, DEFAULT_CONTACT_STATS_QUERY, contactStatsQuery, query);
	
	        var contactPromise = fetch(_config2.default.api.url + '/providercontacts/' + id, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var statsPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/providercontacts/' + id + '/stats', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	
	        return Promise.all([contactPromise, statsPromise]).then(function (_ref10) {
	            var _ref11 = _slicedToArray(_ref10, 2),
	                contactResponse = _ref11[0],
	                statsResponse = _ref11[1];
	
	            return {
	                type: CONTACT_LOADED,
	                contact: contactResponse.json,
	                contactStats: statsResponse.json,
	                contactStatsQuery: query
	            };
	        });
	    }, CONTACT_LOADED);
	}
	
	function sendReferenceProviderCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var referenceProviderCompanyCmd = state.provider.referenceProviderCompanyCmd;
	
	        var label = referenceProviderCompanyCmd.label,
	            cmd = _objectWithoutProperties(referenceProviderCompanyCmd, ['label']);
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                createdDate: new Date().toISOString().slice(0, 10),
	                commandType: 'ReferenceProviderCompany',
	                name: label
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref12) {
	            var json = _ref12.json;
	
	            return {
	                type: REFERENCE_PROVIDER_COMPANY_CMD_SENT,
	                events: json.events
	            };
	        });
	    }, REFERENCE_PROVIDER_COMPANY_CMD_SENT);
	}
	
	function sendAddProviderContactCmd(providerId) {
	    return (0, _loading2.default)(function (state) {
	        var addProviderContactCmd = state.provider.addProviderContactCmd;
	
	        var companyUid = addProviderContactCmd.companyUid,
	            providerCompanyUid = addProviderContactCmd.providerCompanyUid,
	            namez = addProviderContactCmd.namez,
	            phones = addProviderContactCmd.phones,
	            fax = addProviderContactCmd.fax,
	            emails = addProviderContactCmd.emails,
	            cmd = _objectWithoutProperties(addProviderContactCmd, ['companyUid', 'providerCompanyUid', 'namez', 'phones', 'fax', 'emails']);
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date().toISOString().slice(0, 10),
	                companyUid: companyUid && companyUid.uid,
	                providerCompanyUid: providerId || providerCompanyUid && providerCompanyUid.uid,
	                name: namez,
	                phones: phones || [],
	                fax: fax || [],
	                emails: emails || [],
	                commandType: 'AddProviderContact'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_PROVIDER_CONTACT_CMD_SENT
	            };
	        });
	    }, ADD_PROVIDER_CONTACT_CMD_SENT);
	}
	
	function sendUpdateProviderContactCmd() {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.provider.contact.contact;
	        var updateProviderContactCmd = state.provider.updateProviderContactCmd;
	
	        var namez = updateProviderContactCmd.namez,
	            phones = updateProviderContactCmd.phones,
	            fax = updateProviderContactCmd.fax,
	            emails = updateProviderContactCmd.emails,
	            cmd = _objectWithoutProperties(updateProviderContactCmd, ['namez', 'phones', 'fax', 'emails']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                date: new Date().toISOString().slice(0, 10),
	                name: namez,
	                phones: phones || [],
	                fax: fax || [],
	                emails: emails || [],
	                commandType: 'UpdateProviderContact'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_PROVIDER_CONTACT_CMD_SENT
	            };
	        });
	    }, UPDATE_PROVIDER_CONTACT_CMD_SENT);
	}
	
	function sendAssociateProviderContactWithProviderCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.provider.contact.contact;
	        var associateProviderContactWithProviderCompanyCmd = state.provider.associateProviderContactWithProviderCompanyCmd;
	
	        var providerCompanyUid = associateProviderContactWithProviderCompanyCmd.providerCompanyUid,
	            cmd = _objectWithoutProperties(associateProviderContactWithProviderCompanyCmd, ['providerCompanyUid']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AssociateProviderContactWithProviderCompany',
	                providerCompanyUid: providerCompanyUid.uid
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT
	            };
	        });
	    }, ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT);
	}
	
	function sendAssociateProviderContactWithPatrimonyCmd(patrimonyUid) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.provider.contact.contact;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AssociateProviderContactWithPatrimony',
	                patrimonyUid: patrimonyUid
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ASSOCIATE_PROVIDER_CONTACT_WITH_PATRIMONY_CMD_SENT
	            };
	        });
	    }, ASSOCIATE_PROVIDER_CONTACT_WITH_PATRIMONY_CMD_SENT);
	}
	
	function sendDissociateProviderContactFromPatrimonyCmd(patrimonyUid) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.provider.contact.contact;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'DissociateProviderContactFromPatrimony',
	                patrimonyUid: patrimonyUid
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DISSOCIATE_PROVIDER_CONTACT_FROM_PATRIMONY_CMD_SENT
	            };
	        });
	    }, DISSOCIATE_PROVIDER_CONTACT_FROM_PATRIMONY_CMD_SENT);
	}
	
	function sendAssignActivityToProviderContactCmd(activityUid, incidentTypeUids, contactUid) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.provider.contact.contact;
	
	        activityUid = activityUid.uid || activityUid;
	        incidentTypeUids = incidentTypeUids.map(function (it) {
	            return it.uid || it;
	        });
	        contactUid = contactUid && contactUid.uid || contactUid || contact.uid;
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AssignActivityToProviderContact',
	                activityUid: activityUid,
	                includedIncidentTypes: incidentTypeUids
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contactUid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ASSIGN_ACTIVITY_TO_PROVIDER_CONTACT_CMD_SENT
	            };
	        });
	    }, ASSIGN_ACTIVITY_TO_PROVIDER_CONTACT_CMD_SENT);
	}
	
	function sendRemoveActivityFromProviderContactCmd(activityUid) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.provider.contact.contact;
	
	        activityUid = activityUid.uid || activityUid;
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'RemoveActivityFromProviderContact',
	                activityUid: activityUid
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_ACTIVITY_FROM_PROVIDER_CONTACT_CMD_SENT
	            };
	        });
	    }, REMOVE_ACTIVITY_FROM_PROVIDER_CONTACT_CMD_SENT);
	}
	
	function sendAssignActivityToProviderCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$provider = state.provider,
	            provider = _state$provider.provider,
	            assignActivityToProviderCompanyCmd = _state$provider.assignActivityToProviderCompanyCmd;
	
	        var activityUid = assignActivityToProviderCompanyCmd.activityUid,
	            cmd = _objectWithoutProperties(assignActivityToProviderCompanyCmd, ['activityUid']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AssignActivityToProviderCompany',
	                activityUid: activityUid && activityUid.uid
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies/' + provider.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT
	            };
	        });
	    }, ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT);
	}
	
	function sendUnAssignActivityFromProviderCompanyCmd(activityId) {
	    return (0, _loading2.default)(function (state) {
	        var provider = state.provider.provider;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'UnAssignActivityFromProviderCompany',
	                activityUid: activityId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies/' + provider.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UNASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT
	            };
	        });
	    }, UNASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT);
	}
	
	function sendDefineUpdateInterventionPeriodForActivityCmd(_links, activityId, defineUpdateCmd) {
	    return (0, _loading2.default)(function (state) {
	        var defineUpdateInterventionPeriodForActivityCmd = state.provider.defineUpdateInterventionPeriodForActivityCmd;
	
	        var _ref13 = defineUpdateCmd || defineUpdateInterventionPeriodForActivityCmd,
	            _ref13$period = _ref13.period,
	            periodRanges = _ref13$period.periodRanges,
	            exclusions = _ref13$period.exclusions,
	            days = _ref13$period.days,
	            timeSlot = _ref13$period.timeSlot,
	            startDate = _ref13$period.startDate,
	            endDate = _ref13$period.endDate,
	            period = _objectWithoutProperties(_ref13$period, ['periodRanges', 'exclusions', 'days', 'timeSlot', 'startDate', 'endDate']),
	            cmd = _objectWithoutProperties(_ref13, ['period']);
	
	        function periodMapper(period) {
	            return {
	                start: (0, _moment2.default)(period.start, (0, _momentz.parseFormat)(period.start, 'HH:mm:ss')).format('HH:mm:ss'),
	                end: (0, _moment2.default)(period.end, (0, _momentz.parseFormat)(period.end, 'HH:mm:ss')).format('HH:mm:ss')
	            };
	        }
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                activityUid: activityId,
	                period: _extends({
	                    periodRanges: periodRanges && periodRanges.map(function (periodRange) {
	                        return _extends({}, periodRange, {
	                            timeSlot: _extends({}, periodRange.timeSlot, {
	                                periods: periodRange.timeSlot.periods && periodRange.timeSlot.periods.map(periodMapper)
	                            })
	                        });
	                    }),
	                    exclusions: exclusions && exclusions.map(function (exclusion) {
	                        return _extends({}, exclusion, {
	                            days: exclusion.days.map(function (d) {
	                                return (0, _moment2.default)(d).format('YYYY-MM-DD');
	                            }),
	                            timeSlot: _extends({}, exclusion.timeSlot, {
	                                periods: exclusion.timeSlot.periods && exclusion.timeSlot.periods.map(periodMapper)
	                            })
	                        });
	                    }) || [],
	                    days: days && days.map(function (d) {
	                        return (0, _moment2.default)(d).format('YYYY-MM-DD');
	                    }),
	                    timeSlot: timeSlot && _extends({}, timeSlot, {
	                        periods: timeSlot.periods && timeSlot.periods.map(periodMapper)
	                    }),
	                    startDate: startDate && (0, _moment2.default)(startDate).format('YYYY-MM-DD'),
	                    endDate: endDate && (0, _moment2.default)(endDate).format('YYYY-MM-DD')
	                }, period)
	            }, cmd)
	        };
	
	        return fetch(_links.find((0, _links2.linkFinder)(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])).href, (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref14) {
	            var json = _ref14.json;
	
	            return {
	                type: DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT,
	                events: json.events
	            };
	        });
	    }, DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT);
	}
	
	function sendRemoveInterventionPeriodCmd(_links, activityId, interventionPeriodId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'RemoveInterventionPeriod',
	            activityUid: activityId,
	            interventionPeriodUid: interventionPeriodId
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_links.find((0, _links2.linkFinder)('RemoveInterventionPeriod')).href, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: REMOVE_INTERVENTION_PERIOD_CMD_SENT
	        };
	    }), REMOVE_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendDefineServiceChargeForInterventionPeriodCmd(activityId, interventionPeriodId, defineCmd) {
	    return (0, _loading2.default)(function (state) {
	        var _state$provider2 = state.provider,
	            provider = _state$provider2.provider,
	            defineServiceChargeForInterventionPeriodCmd = _state$provider2.defineServiceChargeForInterventionPeriodCmd;
	
	        var _ref15 = defineCmd || defineServiceChargeForInterventionPeriodCmd,
	            charge = _ref15.charge,
	            cmd = _objectWithoutProperties(_ref15, ['charge']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'DefineServiceChargeForInterventionPeriod',
	                activityUid: activityId,
	                interventionPeriodUid: interventionPeriodId,
	                charge: _extends({
	                    currency: 'EURO',
	                    chargeType: 'FixChargeValue'
	                }, charge)
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies/' + provider.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendRemoveServiceChargeFromInterventionPeriodCmd(activityId, interventionPeriodId) {
	    return (0, _loading2.default)(function (state) {
	        var provider = state.provider.provider;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'RemoveServiceChargeFromInterventionPeriod',
	                activityUid: activityId,
	                interventionPeriodUid: interventionPeriodId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies/' + provider.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_SERVICE_CHARGE_FROM_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, REMOVE_SERVICE_CHARGE_FROM_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendDefineInterventionZoneForInterventionPeriodCmd(_links, activityId, interventionPeriodId, defineCmd) {
	    return (0, _loading2.default)(function (state) {
	        var defineInterventionZoneForInterventionPeriodCmd = state.provider.defineInterventionZoneForInterventionPeriodCmd;
	
	        var _ref16 = defineCmd || defineInterventionZoneForInterventionPeriodCmd,
	            _ref16$zone = _ref16.zone,
	            address = _ref16$zone.address,
	            range = _ref16$zone.range,
	            cmd = _objectWithoutProperties(_ref16, ['zone']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'DefineInterventionZoneForInterventionPeriod',
	                activityUid: activityId,
	                interventionPeriodUid: interventionPeriodId,
	                zone: {
	                    address: _extends({}, address, {
	                        addressType: 'PlaceId'
	                    }),
	                    range: _extends({}, range, {
	                        unit: 'meter'
	                    }),
	                    zoneType: 'AddressZone'
	                }
	            }, cmd)
	        };
	
	        return fetch(_links.find((0, _links2.linkFinder)('DefineInterventionZoneForInterventionPeriod')).href, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendRemoveInterventionZoneFromInterventionPeriodCmd(_links, activityId, interventionPeriodId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'RemoveInterventionZoneFromInterventionPeriod',
	            activityUid: activityId,
	            interventionPeriodUid: interventionPeriodId
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_links.find((0, _links2.linkFinder)('RemoveInterventionZoneFromInterventionPeriod')).href, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: REMOVE_INTERVENTION_ZONE_FROM_INTERVENTION_PERIOD_CMD_SENT
	        };
	    }), REMOVE_INTERVENTION_ZONE_FROM_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendDefineCallOutChargesForInterventionPeriodCmd(activityId, interventionPeriodId, defineCmd) {
	    return (0, _loading2.default)(function (state) {
	        var _state$provider3 = state.provider,
	            provider = _state$provider3.provider,
	            defineCallOutChargesForInterventionPeriodCmd = _state$provider3.defineCallOutChargesForInterventionPeriodCmd;
	
	        var _ref17 = defineCmd || defineCallOutChargesForInterventionPeriodCmd,
	            callOutCharges = _ref17.callOutCharges,
	            cmd = _objectWithoutProperties(_ref17, ['callOutCharges']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'DefineCallOutChargesForInterventionPeriod',
	                activityUid: activityId,
	                interventionPeriodUid: interventionPeriodId,
	                callOutCharges: callOutCharges && callOutCharges.map(function (callOutCharge) {
	                    return {
	                        range: _extends({
	                            unit: 'meter'
	                        }, callOutCharge.range),
	                        charge: _extends({
	                            currency: 'EURO',
	                            chargeType: 'FixChargeValue'
	                        }, callOutCharge.charge)
	                    };
	                })
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies/' + provider.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendRemoveCallOutChargesFromInterventionPeriodCmd(activityId, interventionPeriodId) {
	    return (0, _loading2.default)(function (state) {
	        var provider = state.provider.provider;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'RemoveCallOutChargesFromInterventionPeriod',
	                activityUid: activityId,
	                interventionPeriodUid: interventionPeriodId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies/' + provider.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_CALL_OUT_CHARGES_FROM_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, REMOVE_CALL_OUT_CHARGES_FROM_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(activityId, interventionPeriodId, subscribeCmd) {
	    return (0, _loading2.default)(function (state) {
	        var _state$provider4 = state.provider,
	            provider = _state$provider4.provider,
	            subscribeProviderCompanyToDirectoryForInterventionPeriodCmd = _state$provider4.subscribeProviderCompanyToDirectoryForInterventionPeriodCmd;
	
	        var cmd = subscribeCmd || subscribeProviderCompanyToDirectoryForInterventionPeriodCmd;
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'SubscribeProviderCompanyToDirectoryForInterventionPeriod',
	                activityUid: activityId,
	                interventionPeriodUid: interventionPeriodId
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies/' + provider.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendDefineContactInfosForProviderCompanyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$provider5 = state.provider,
	            provider = _state$provider5.provider,
	            defineContactInfosForProviderCompanyCmd = _state$provider5.defineContactInfosForProviderCompanyCmd;
	
	        var namez = defineContactInfosForProviderCompanyCmd.namez,
	            phones = defineContactInfosForProviderCompanyCmd.phones,
	            fax = defineContactInfosForProviderCompanyCmd.fax,
	            emails = defineContactInfosForProviderCompanyCmd.emails,
	            cmd = _objectWithoutProperties(defineContactInfosForProviderCompanyCmd, ['namez', 'phones', 'fax', 'emails']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                name: namez,
	                phones: phones || [],
	                fax: fax || [],
	                emails: emails || [],
	                commandType: 'DefineContactInfosForProviderCompany'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercompanies/' + provider.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT
	            };
	        });
	    }, DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT);
	}
	
	function sendDefineRepairTimelimitForInterventionPeriodCmd(interventionPeriodId, defineCmd) {
	    return (0, _loading2.default)(function (state) {
	        var defineRepairTimelimitForInterventionPeriodCmd = state.provider.defineRepairTimelimitForInterventionPeriodCmd;
	        var contact = state.provider.contact.contact;
	
	        var _ref18 = defineCmd || defineRepairTimelimitForInterventionPeriodCmd,
	            timelimits = _ref18.timelimits,
	            cmd = _objectWithoutProperties(_ref18, ['timelimits']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'DefineRepairTimelimitForInterventionPeriod',
	                interventionPeriodUid: interventionPeriodId,
	                timelimits: timelimits && timelimits.map(function (timelimit) {
	                    return _extends({}, timelimit, {
	                        timelimit: _extends({
	                            unit: 'milliseconds'
	                        }, timelimit.timelimit)
	                    });
	                })
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendRemoveRepairTimelimitFromInterventionPeriodCmd(interventionPeriodId) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.provider.contact.contact;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'RemoveRepairTimelimitFromInterventionPeriod',
	                interventionPeriodUid: interventionPeriodId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_REPAIR_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, REMOVE_REPAIR_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendDefineInterventionTimelimitForInterventionPeriodCmd(interventionPeriodId, defineCmd) {
	    return (0, _loading2.default)(function (state) {
	        var defineInterventionTimelimitForInterventionPeriodCmd = state.provider.defineInterventionTimelimitForInterventionPeriodCmd;
	        var contact = state.provider.contact.contact;
	
	        var _ref19 = defineCmd || defineInterventionTimelimitForInterventionPeriodCmd,
	            timelimits = _ref19.timelimits,
	            cmd = _objectWithoutProperties(_ref19, ['timelimits']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'DefineInterventionTimelimitForInterventionPeriod',
	                interventionPeriodUid: interventionPeriodId,
	                timelimits: timelimits && timelimits.map(function (timelimit) {
	                    return _extends({}, timelimit, {
	                        timelimit: _extends({
	                            unit: 'milliseconds'
	                        }, timelimit.timelimit)
	                    });
	                })
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendRemoveInterventionTimelimitFromInterventionPeriodCmd(interventionPeriodId) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.provider.contact.contact;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'RemoveInterventionTimelimitFromInterventionPeriod',
	                interventionPeriodUid: interventionPeriodId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_INTERVENTION_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, REMOVE_INTERVENTION_TIMELIMIT_FROM_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd(interventionPeriodId, excludeCmd) {
	    return (0, _loading2.default)(function (state) {
	        var excludeOpeningTicketPurposesFromInterventionPeriodCmd = state.provider.excludeOpeningTicketPurposesFromInterventionPeriodCmd;
	        var contact = state.provider.contact.contact;
	
	        var cmd = excludeCmd || excludeOpeningTicketPurposesFromInterventionPeriodCmd;
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'ExcludeOpeningTicketPurposesFromInterventionPeriod',
	                interventionPeriodUid: interventionPeriodId
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/providercontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT
	            };
	        });
	    }, EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT);
	}
	
	function updateAddProviderContactCmd(cmd) {
	    return {
	        type: ADD_PROVIDER_CONTACT_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateUpdateProviderContactCmd(cmd) {
	    return {
	        type: UPDATE_PROVIDER_CONTACT_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateAssociateProviderContactWithProviderCompanyCmd(cmd) {
	    return {
	        type: ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateDefineUpdateInterventionPeriodForActivityCmd(cmd) {
	    return {
	        type: DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateDefineServiceChargeForInterventionPeriodCmd(cmd) {
	    return {
	        type: DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateDefineInterventionZoneForInterventionPeriodCmd(cmd) {
	    return {
	        type: DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateDefineCallOutChargesForInterventionPeriodCmd(cmd) {
	    return {
	        type: DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(cmd) {
	    return {
	        type: SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateDefineContactInfosForProviderCompanyCmd(cmd) {
	    return {
	        type: DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateDefineRepairTimelimitForInterventionPeriodCmd(cmd) {
	    return {
	        type: DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateDefineInterventionTimelimitForInterventionPeriodCmd(cmd) {
	    return {
	        type: DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd(cmd) {
	    return {
	        type: EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateProviderCriteria(criteria) {
	    return {
	        type: PROVIDER_CRITERIA_UPDATED,
	        criteria: criteria
	    };
	}
	
	function updateProviderCoverageCriteria(criteria) {
	    return {
	        type: PROVIDER_COVERAGE_CRITERIA_UPDATED,
	        criteria: criteria
	    };
	}
	
	function updateProviderMinorCriteria(minorCriteria) {
	    return {
	        type: PROVIDER_MINOR_CRITERIA_UPDATED,
	        minorCriteria: minorCriteria
	    };
	}
	
	function resetProviderMinorCriteria() {
	    return {
	        type: PROVIDER_MINOR_CRITERIA_RESETTED
	    };
	}
	
	function updateContactMinorCriteria(minorCriteria) {
	    return {
	        type: CONTACT_MINOR_CRITERIA_UPDATED,
	        minorCriteria: minorCriteria
	    };
	}
	
	function resetContactMinorCriteria() {
	    return {
	        type: CONTACT_MINOR_CRITERIA_RESET
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        searchStream: {
	            xs: 'rechercher',
	            sm: 'rechercher une entreprise'
	        },
	        useSearchCompanyFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
	        companies: 'entreprises',
	        newCompany: 'nouvelle entreprise',
	        updateCompany: 'modification',
	        enableCompany: 'activer l\'entreprise ...',
	        enableCompanyText: ['Vous êtes sur le point d\'activer l\'entreprise {label}.'],
	        disableCompany: 'désactiver l\'entreprise ...',
	        disableCompanyText: ['Vous êtes sur le point de désactiver l\'entreprise {label}.'],
	        newSubsidiary: 'nouvelle filiale',
	        subsidiary: 'filiale',
	        callCenter: 'centre d\'appel',
	        newAgency: 'nouveau portefeuille',
	        updateAgency: 'modification',
	        deleteAgency: 'supprimer le portefeuille ...',
	        deleteAgencyText: ['Vous êtes sur le point de supprimer le portefeuille {label}.', 'Cette action est irréversible.'],
	        disableUser: 'désactiver l\'utilisateur ...',
	        disableUserText: ['Vous êtes sur le point de désactiver l\'utilisateur {login}.'],
	        upgradePremiumAccount: 'souscrire au compte prémium ...',
	        upgradePremiumAccountText: ['Vous êtes sur le point de souscrir au compte prémium pour l\'entreprise {label}.'],
	        downgradePremiumAccount: 'révoquer le compte prémium ...',
	        downgradePremiumAccountText: ['Vous êtes sur le point de révoquer le compte prémium de l\'entreprise {label}.'],
	        upgradeStandardAccount: 'souscrire au compte standard ...',
	        upgradeStandardAccountText: ['Vous êtes sur le point de souscrir au compte standard pour l\'entreprise {label}.'],
	        job: 'poste',
	        addAgency: 'ajouter un portefeuille',
	        agency: 'portefeuille',
	        agencies: 'portefeuilles',
	        associateDissociateAgencies: 'modifier les portefeuilles',
	        associateDissociatePatrimonies: 'modifier les patrimoines',
	        downgradeExecutiveToPatrimonyManager: 'transformer en compte gestionnaire',
	        newUser: 'nouvel utilisateur',
	        updateUser: 'modification',
	        users: 'utilisateurs',
	        user: 'utilisateur',
	        patrimony: 'patrimoine',
	        tickets: 'tickets',
	        synthesis: 'synthèse',
	        subsidiaries: 'filiales',
	        documents: 'documents',
	        providers: 'fournisseurs',
	        email: 'email',
	        phone: 'téléphone',
	        fax: 'fax',
	        login: 'email',
	        updateLogin: 'modifier le login',
	        companyTypeEnum: {
	            clientAccount: 'entreprise',
	            clientAccountHolding: 'holding',
	            callCenter: 'centre d\'appel'
	        },
	        referenceCompanyCmdTypeEnum: {
	            createClientAccount: 'entreprise',
	            createClientAccountHolding: 'holding',
	            createCallCenter: 'centre d\'appel'
	        },
	        referenceUserCmdTypeEnum: {
	            referenceCallCenterUser: 'utilisateur',
	            referenceCallCenterOperator: 'opérateur',
	            referenceExecutive: 'cadre',
	            referenceClientAccountManager: 'administrateur',
	            referencePatrimonyManager: 'gestionnaire'
	        },
	        userTypeEnum: {
	            callCenterUser: 'utilisateur',
	            callCenterOperator: 'opérateur',
	            executive: 'cadre',
	            clientAccountManager: 'administrateur',
	            patrimonyManager: 'gestionnaire'
	        },
	        billingType: 'type de compte',
	        billingTypeEnum: {
	            standardAccount: 'compte standard',
	            premiumAccount: 'compte prémium',
	            sponsoredAccount: 'compte sponsorisé'
	        },
	        sendActivationEmail: 'renvoyer l\'email d\'activation',
	        activationEmailSent: 'un email a été envoyé',
	        userActive: 'Comptes activés',
	        userInactive: 'Comptes désactivés',
	        agencyActive: 'Portefeuilles activés',
	        agencyInactive: 'Portefeuilles désactivés',
	        identifyCompany: 'identification',
	        siret: 'siret',
	        ticketUidGeneratorPrefix: 'préfix',
	        ticketUidGeneratorPrefixText: 'Le préfix doit comporter une à trois lettres',
	        acknowledgeTicketUidGenerator: 'j\'ai pris connaissance du fait que le format des numéros de ticket sera modifié à partir de maintenant',
	        ticketOpenedNotifications: 'recevoir un email lors de la création d\'un ticket',
	        daybookNotifications: 'recevoir la main courante',
	        simplifiedRequestOpenedNotifications: 'recevoir un email lors de la création d\'une demande simplifiée',
	        reportPdfAgency: 'Télécharger le rapport PDF',
	        reportingAgency: 'Téléchargement en cours',
	        workflows: 'processus',
	        openingticketpurposeref: 'Raison d\'ouverture',
	        parameters: 'paramètres',
	        openingticketinstructions: 'instructions',
	        satisfactioncampaigns: 'satisfaction',
	        qualifCriterias: 'arbres qualification',
	        criteriaref: 'critères',
	        contextualcommentref: 'Commentaires',
	        notifications: 'Notifications'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FinishMissionCmd = exports.EmitCallToCmd = exports.ReceiveCallCmd = exports.CorrectTicketEventInformationsCmd = exports.CorrectTicketInformationsCmd = exports.CloseTicketCmd = exports.AddMessageCmd = exports.FinishInterventionCmd = exports.StartInterventionCmd = exports.ScheduleInterventionCmd = exports.ReportFormalNoticeForProviderCmd = exports.DefineInterventionDeadlineCmd = exports.ReportSendingServiceOrderCmd = exports.IdentifyAssigneeCmd = exports.OpenTicketCmd = exports.ReportPdfTicketsOption = exports.ExportPdfTicketsOption = exports.ExportXlsxTicketsOption = exports.Criteria = exports.Ticket = exports.FINISH_MISSION_HINTS = exports.OPEN_TICKET_SEVERITY_HINTS = exports.OPEN_TICKET_LOCATION_HINTS = exports.RECEIVE_CALL_FROM_CALLER_HINTS = exports.RECEIVE_CALL_FROM_ASSIGNEE_HINTS = exports.EMIT_CALL_TO_CALLER_HINTS = exports.EMIT_CALL_TO_ASSIGNEE_HINTS = exports.CORRECT_TICKET_EVENT_NAMES = exports.INCIDENT_TYPE_ITEM_ICONS = exports.CALL_PURPOSES = exports.SUPPORT_USERS = exports.INTERVENTION_CMD_TYPES = exports.CLOSE_TICKET_CMD_TYPES = exports.PDF_EXPORT_PAGES = exports.PDF_REPORT_PAGES = exports.XLSX_TICKET_SHEET_COLUMNS = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createValidator = createValidator;
	exports.mediumToContactMedium = mediumToContactMedium;
	exports.plainContactToContactMedium = plainContactToContactMedium;
	exports.nameToPlainName = nameToPlainName;
	
	var _jjv = __webpack_require__(172);
	
	var _jjv2 = _interopRequireDefault(_jjv);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _validate = __webpack_require__(532);
	
	var _datez = __webpack_require__(278);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var XLSX_TICKET_SHEET_COLUMNS = exports.XLSX_TICKET_SHEET_COLUMNS = ['ref', 'created', 'agency', 'addressStreet', 'addressZipCode', 'addressCity', 'addressFloor', 'addressUnit', 'addressEntrance', 'addressElevator', 'addressStaircase', 'addressBuilding', 'addressComplement', 'callerName', 'callerPhone', 'callerEmail', 'request', 'callPurpose', 'assigneeName', 'assigneePhone', 'assigneeType', 'serviceOrderRef', 'serviceOrderSendingDate', 'interventionScheduledStartDate', 'interventionScheduledEndDate', 'interventionDeadline', 'formalNoticeDate', 'formalNoticeDeadline', 'missionFinished', 'freeComments', 'status', 'state'];
	
	var PDF_REPORT_PAGES = exports.PDF_REPORT_PAGES = ['agency', 'patrimony', 'provider'];
	var PDF_EXPORT_PAGES = exports.PDF_EXPORT_PAGES = ['journal'];
	
	var CLOSE_TICKET_CMD_TYPES = exports.CLOSE_TICKET_CMD_TYPES = ['FixPermanently', 'FixPartially', 'PostponeFix', 'CloseTicketImpossibleRepair', 'CloseBeyondCallCenterScope', 'CancelTicket'];
	var INTERVENTION_CMD_TYPES = exports.INTERVENTION_CMD_TYPES = ['AcceptIntervention', 'RefuseIntervention'];
	var SUPPORT_USERS = exports.SUPPORT_USERS = ['Manager', 'Admin', 'Inspector', 'CareTaker', 'Administrator'];
	
	var CALL_PURPOSES = exports.CALL_PURPOSES = {
	    electrecityHeating: ['boiler', 'heater', 'electrecity', 'elecman', 'lamp'],
	    plumbing: ['hotwater', 'plumber', 'tap', 'waterdrop', 'waterman', 'watertap'],
	    vmcGaz: ['vent', 'smokevent', 'parkingvent', 'gasvent', 'aircon', 'gasman', 'gas', 'manogas', 'pipe', 'pressure'],
	    dangerAlarm: ['extinctor', 'firealarm', 'firefighters', 'intrusionalarm', 'alarm', 'burglar', 'evacuate', 'explosion', 'flood', 'vandalism'],
	    sanitation: ['litter', 'pump', 'bucket'],
	    elevator: ['elevator'],
	    access: ['barrier', 'closedlock', 'openlock', 'fence', 'door', 'window', 'rollerblind', 'keys', 'brokenglass'],
	    parking: ['parking'],
	    monitoring: ['terminal', 'monitoring', 'tv']
	};
	
	var INCIDENT_TYPE_ITEM_ICONS = exports.INCIDENT_TYPE_ITEM_ICONS = {
	    accesGarage: 'parking',
	    aggretion: 'vandalism',
	    alarme: 'alarm',
	    ampouleGrillee: 'lamp',
	    ascenseur: 'elevator',
	    autreGenerique: 'other',
	    barriereLevante: 'barrier',
	    blattesCafards: 'bugs',
	    bornes: 'terminal',
	    cabineNonPresente: 'elevator',
	    cabinePresente: 'elevator',
	    cassee: 'brokenglass',
	    chaude: 'hotwater',
	    chaudiere: 'boiler',
	    chauffage: 'heater',
	    circuit: 'pipe',
	    clef: 'keys',
	    climatisation: 'aircon',
	    collectif: 'relocate',
	    compteurGaz: 'manogas',
	    conteneurPoubelle: 'litter',
	    couverture: 'roof',
	    cumulusChauffeBain: 'boiler',
	    debitEau: 'tap',
	    degradation: 'vandalism',
	    demande: 'questionmark',
	    desenfumage: 'smokevent',
	    eau: 'waterdrop',
	    eauChaudeSanitaire: 'hotwater',
	    eauSale: 'bucket',
	    effraction: 'openlock',
	    electrecite: 'electrecity',
	    electrique: 'electrecity',
	    electrocution: 'electrecity',
	    explosion: 'explosion',
	    extracteur: 'vent',
	    extracteurFumees: 'smokevent',
	    FlagrantDelit: 'burglar',
	    fuiteEau: 'waterdrop',
	    fuiteGaz: 'gas',
	    garage: 'parking',
	    gardiennage: 'careTaker',
	    gaz: 'gas',
	    grave: 'warning',
	    guepesFrelonsAbeilles: 'bugs',
	    horsService: 'wrench',
	    importante: 'warning',
	    incendie: 'firefighters',
	    incidentsGraves: 'warning',
	    individuel: 'manager',
	    individusSuspects: 'burglar',
	    infiltration: 'waterdrop',
	    informationDossier: 'questionmark',
	    informationTravaux: 'questionmark',
	    innondation: 'flood',
	    insectes: 'bugs',
	    institutionnel: 'police',
	    interphone: 'intercom',
	    intrusion: 'intrusionalarm',
	    issue: 'door',
	    localVideOrdure: 'litter',
	    logeGardien: 'careTaker',
	    maconnerie: 'masonry',
	    mauvaisFonctionnement: 'fail',
	    menuiserie: 'window',
	    message: 'message',
	    nettoyage: 'bucket',
	    ouverture: 'openlock',
	    panne: 'wrench',
	    panneChaudiere: 'boiler',
	    panneEclairage: 'lamp',
	    panneElectricite: 'electrecity',
	    panneGaz: 'gas',
	    panneTotale: 'fail',
	    panneTV: 'tv',
	    parking: 'parking',
	    parkingGarage: 'parking',
	    parkingMecanique: 'parking',
	    piscine: 'swimmingpool',
	    pompeRelevage: 'pump',
	    portailCoulissant: 'fence',
	    porteAcces: 'door',
	    porteAntiIntrusion: 'door',
	    porteAscenseur: 'elevator',
	    porteGarage: 'fence',
	    portePrivative: 'door',
	    pressionFaible: 'pressure',
	    problemeExtincteur: 'extinctor',
	    radiateur: 'heater',
	    risque: 'warning',
	    risqueGrave: 'warning',
	    robinet: 'watertap',
	    serrureHS: 'keys',
	    signalement: 'marker',
	    situationRisque: 'warning',
	    soutienPersonnes: 'relocate',
	    tags: 'vandalism',
	    telesurveillance: 'monitoring',
	    tNTHertzien: 'tv',
	    urgent: 'warning',
	    ventilationGaz: 'gasvent',
	    videOrdure: 'litter',
	    videoSurveillance: 'monitoring',
	    vitreCassee: 'brokenglass',
	    vmc: 'vent',
	    voletRoulantStore: 'rollerblind'
	};
	
	var CORRECT_TICKET_EVENT_NAMES = exports.CORRECT_TICKET_EVENT_NAMES = ['MessageAdded', 'CallReceived', 'CallEmittedTo'];
	var EMIT_CALL_TO_ASSIGNEE_HINTS = exports.EMIT_CALL_TO_ASSIGNEE_HINTS = ['assigneeInterventionTransfer', 'assigneeIncidentAggravation', 'assigneeRemindIntervention', 'assigneeOther'];
	var EMIT_CALL_TO_CALLER_HINTS = exports.EMIT_CALL_TO_CALLER_HINTS = ['callerIncidentAggravation', 'callerAcceptIntervention', 'callerComplementaryInformation', 'callerContactWithCompany', 'callerSatisfaction', 'callerOther'];
	var RECEIVE_CALL_FROM_ASSIGNEE_HINTS = exports.RECEIVE_CALL_FROM_ASSIGNEE_HINTS = ['assigneeComplementaryInformation', 'assigneeInterventionAdditionalContactInformation', 'assigneeInterventionCancellation', 'assigneeInterventionAcceptation', 'assigneeImpossibleAccess', 'assigneeScheduleIntervention', 'assigneeOther'];
	var RECEIVE_CALL_FROM_CALLER_HINTS = exports.RECEIVE_CALL_FROM_CALLER_HINTS = ['callerIncidentAggravation', 'callerProviderPassed', 'callerComplementaryInformation', 'callerIncidentAccess', 'callerOther'];
	var OPEN_TICKET_LOCATION_HINTS = exports.OPEN_TICKET_LOCATION_HINTS = ['unknownArea', 'commomArea', 'privateAreaExtending', 'privateArea', 'otherArea'];
	var OPEN_TICKET_SEVERITY_HINTS = exports.OPEN_TICKET_SEVERITY_HINTS = ['unknownSeverity', 'urgentSeverity', 'notUrgentSeverityExtending', 'notUrgentSeverity'];
	var FINISH_MISSION_HINTS = exports.FINISH_MISSION_HINTS = ['scheduleInterventionManager', 'interventionPostponed', 'scheduleInterventionSelf', 'interventionPaused', 'interventionImpossible', 'interventionInProgress', 'interventionResolved', 'otherInterventiom'];
	
	function createValidator() {
	    var validator = (0, _jjv2.default)();
	
	    validator.addCheck('anyRequired', _validate.anyRequired);
	    validator.addFormat('phone', _phonez.phoneFormat);
	    return validator;
	}
	
	var Ticket = exports.Ticket = function Ticket() {
	    _classCallCheck(this, Ticket);
	};
	
	Ticket.schema = {
	    type: 'object',
	    properties: {}
	};
	
	Ticket.accurateStatus = function (ticket) {
	    if (ticket && ticket.state) {
	        switch (ticket.state.value) {
	            case 'TicketArchived':
	                return 'archived';
	            case 'TicketCancelled':
	                return 'canceled';
	        }
	    }
	    return ticket && ticket.status || null;
	};
	
	Ticket.findActiveStateJournalEvent = function (ticket) {
	    if (ticket && ticket.state) {
	        var stateDate = ticket.state.date;
	        var stateEvent = ticket.state.value;
	
	        return ticket.journal.find(function (event) {
	            return stateEvent == event.eventName && (0, _datez.isSameDay)(stateDate, event.date);
	        });
	    }
	    return null;
	};
	
	Ticket.findJournalEvent = function (ticket, eventName) {
	    if (ticket && ticket.journal) {
	        return ticket.journal.find(function (event) {
	            return eventName == event.eventName;
	        });
	    }
	    return null;
	};
	
	Ticket.findJournalEvents = function (ticket, eventName) {
	    var events = [];
	
	    if (ticket && ticket.journal) {
	        ticket.journal.forEach(function (event) {
	            if (eventName == event.eventName) {
	                events.push(event);
	            }
	        });
	    }
	    return events;
	};
	
	Ticket.isRepairTimeCompliant = function (ticket) {
	    if (ticket && ticket.assignee && ticket.assignee.repairTimelimit && ticket.stats.repairTime) {
	        return ticket.stats.repairTime <= ticket.assignee.commitments.repairTimelimit.value;
	    }
	    return true;
	};
	
	Ticket.isInterventionTimeCompliant = function (ticket) {
	    if (ticket && ticket.assignee && ticket.assignee.commitments.interventionTimelimit && ticket.stats.interventionTime) {
	        return ticket.stats.interventionTime <= ticket.assignee.commitments.interventionTimelimit.value;
	    }
	    return true;
	};
	
	Ticket.extractJournalEvent = function (target, event) {
	    var eventName = (0, _extract.sanitize)(event && event.eventName);
	
	    if (target) {
	        var eventData = event && event.data;
	        var targetEvent = target[eventName];
	
	        switch (eventName) {
	            case 'callEmittedTo':
	                return targetEvent && targetEvent[(0, _extract.sanitize)(eventData.medium)] || eventName;
	            case 'callReceived':
	                return targetEvent && targetEvent[(0, _extract.sanitize)(eventData.medium)] || eventName;
	            case 'assigneeIdentified':
	                return targetEvent && targetEvent[(0, _extract.sanitize)(eventData.identificationType)] || eventName;
	            default:
	                return targetEvent || eventName;
	        }
	    }
	    return eventName;
	};
	
	Ticket.replaceJournalEvent = function (value, event) {
	    if (value) {
	        var eventName = (0, _extract.sanitize)(event && event.eventName);
	        var eventData = event && event.data;
	
	        switch (eventName) {
	            case 'interventionScheduled':
	                return (0, _extract.replace)(value, _extends({}, eventData, {
	                    date: (0, _moment2.default)(eventData.scheduledStartDate).format(_i18n2.default.dateFormat.default),
	                    startTime: (0, _moment2.default)(eventData.scheduledStartDate).format(_i18n2.default.timeFormat.default),
	                    endTime: (0, _moment2.default)(eventData.scheduledEndDate).format(_i18n2.default.timeFormat.default)
	                }));
	            case 'sendingServiceOrderReported':
	                return (0, _extract.replace)(value, _extends({}, eventData, {
	                    sendingDate: (0, _moment2.default)(eventData.sendingDate).format(_i18n2.default.dateFormat.default)
	                }));
	            case 'interventionDeadlineDefined':
	            case 'formalNoticeForProviderReported':
	                return (0, _extract.replace)(value, _extends({}, eventData, {
	                    deadline: (0, _moment2.default)(eventData.deadline).format(_i18n2.default.dateFormat.default)
	                }));
	            case 'interventionRequested':
	                return (0, _extract.replace)(value, _extends({}, eventData, {
	                    medium: (0, _extract2.default)(_i18n2.default.mediumTypezEnum, eventData.medium),
	                    identifier: (0, _phonez2.default)(eventData.identifier).format()
	                }));
	            case 'callEmittedTo':
	            case 'callReceived':
	                return (0, _extract.replace)(value, _extends({}, eventData, {
	                    identifier: (0, _phonez2.default)(eventData.identifier).format()
	                }));
	            default:
	                return (0, _extract.replace)(value, eventData);
	        }
	    }
	    return value;
	};
	
	var Criteria = exports.Criteria = function Criteria() {
	    _classCallCheck(this, Criteria);
	};
	
	Criteria.schema = {
	    type: 'object',
	    properties: {
	        fullText: { type: 'string' },
	        status: { type: 'string' },
	        intervention: { type: 'boolean' },
	        location: { type: 'array' },
	        clientCompany: { type: 'array' },
	        agency: { type: 'array' },
	        patrimony: { type: 'array' },
	        callPurpose: { type: 'array' },
	        from: { type: 'date' },
	        to: { type: 'date' }
	    }
	};
	
	var ExportXlsxTicketsOption = exports.ExportXlsxTicketsOption = function ExportXlsxTicketsOption() {
	    _classCallCheck(this, ExportXlsxTicketsOption);
	};
	
	ExportXlsxTicketsOption.schema = {
	    type: 'object',
	    properties: {
	        ticketSheetColumns: { type: 'array' },
	        ticketSheetAdditionalData: { type: ['boolean', 'null'] }
	    }
	};
	
	var ExportPdfTicketsOption = exports.ExportPdfTicketsOption = function ExportPdfTicketsOption() {
	    _classCallCheck(this, ExportPdfTicketsOption);
	};
	
	ExportPdfTicketsOption.schema = {
	    type: 'object',
	    properties: {
	        pages: { type: 'array' }
	    }
	};
	
	var ReportPdfTicketsOption = exports.ReportPdfTicketsOption = function ReportPdfTicketsOption() {
	    _classCallCheck(this, ReportPdfTicketsOption);
	};
	
	ReportPdfTicketsOption.schema = {
	    type: 'object',
	    properties: {
	        pages: { type: 'array' },
	        from: { type: ['date', 'null'] },
	        to: { type: ['date', 'null'] }
	    }
	};
	
	var OpenTicketCmd = exports.OpenTicketCmd = function OpenTicketCmd() {
	    _classCallCheck(this, OpenTicketCmd);
	};
	
	OpenTicketCmd.schemaCache = (0, _cache2.default)();
	
	OpenTicketCmd.schema = {
	    type: 'object',
	    properties: {
	        acknowledgeInstruction: {
	            type: ['boolean', 'null'],
	            enum: [true, null]
	        },
	        company: { type: 'object' },
	        locationRef: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    patrimonyUid: { type: 'object' },
	                    locationReferenceType: {
	                        type: 'string',
	                        enum: ['PatrimonyLocation']
	                    }
	                },
	                required: ['patrimonyUid', 'locationReferenceType']
	            }, {
	                type: 'object',
	                properties: {
	                    agencyUid: { type: 'object' },
	                    locationReferenceType: {
	                        type: 'string',
	                        enum: ['AgencyLocation']
	                    }
	                },
	                required: ['agencyUid', 'locationReferenceType']
	            }]
	        },
	        restrictedAccess: {
	            type: 'boolean'
	        },
	        ticket: {
	            type: 'object',
	            properties: {
	                callerz: {
	                    oneOf: [{
	                        type: 'object',
	                        properties: {
	                            namez: {
	                                type: 'object',
	                                properties: {
	                                    firstName: { type: 'string' },
	                                    lastName: { type: 'string' },
	                                    company: { type: ['string', 'null'] }
	                                },
	                                required: ['firstName', 'lastName']
	                            },
	                            status: {
	                                type: ['string', 'null']
	                            },
	                            medium: {
	                                oneOf: [{
	                                    type: 'object',
	                                    properties: {
	                                        phone: {
	                                            type: 'string',
	                                            format: 'phone'
	                                        }
	                                    },
	                                    required: ['phone']
	                                }, {
	                                    type: 'object',
	                                    properties: {
	                                        mail: {
	                                            type: 'string',
	                                            format: 'email'
	                                        }
	                                    },
	                                    required: ['mail']
	                                }, {
	                                    type: 'object',
	                                    properties: {
	                                        fax: {
	                                            type: 'string',
	                                            format: 'phone'
	                                        }
	                                    },
	                                    required: ['fax']
	                                }]
	                            },
	                            comment: { type: ['string', 'null'] },
	                            callerType: {
	                                type: 'string',
	                                enum: ['HumanCaller']
	                            }
	                        },
	                        required: ['namez', 'callerType']
	                    }, {
	                        type: 'object',
	                        properties: {
	                            callerType: {
	                                type: 'string',
	                                enum: ['ReferencedContactCaller']
	                            }
	                        },
	                        required: ['callerType']
	                    }]
	                },
	                contactToCallback: {
	                    type: ['object', 'null'],
	                    properties: {
	                        namez: { type: 'string' },
	                        medium: {
	                            oneOf: [{
	                                type: 'object',
	                                properties: {
	                                    phone: {
	                                        type: 'string',
	                                        format: 'phone'
	                                    }
	                                },
	                                required: ['phone']
	                            }, {
	                                type: 'object',
	                                properties: {
	                                    mail: {
	                                        type: 'string',
	                                        format: 'email'
	                                    }
	                                },
	                                required: ['mail']
	                            }, {
	                                type: 'object',
	                                properties: {
	                                    fax: {
	                                        type: 'string',
	                                        format: 'phone'
	                                    }
	                                },
	                                required: ['fax']
	                            }]
	                        },
	                        availability: { type: ['date', 'null'] },
	                        comment: { type: ['string', 'null'] }
	                    },
	                    required: ['namez', 'medium']
	                },
	                address: {
	                    type: 'object',
	                    properties: {
	                        number: { type: ['string', 'null'] },
	                        street: { type: 'string' },
	                        zipCode: { type: 'string' },
	                        city: { type: 'string' },
	                        staircase: { type: ['string', 'null'] },
	                        floor: { type: ['string', 'null'] },
	                        digicode: { type: ['string', 'null'] }
	                    },
	                    required: ['street', 'zipCode', 'city']
	                },
	                openingTicketPurpose: { type: 'object' },
	                request: { type: 'string' },
	                instructions: { type: ['string', 'null'] }
	            },
	            required: ['callerz', 'address', 'openingTicketPurpose', 'request']
	        }
	    },
	    required: ['company', 'locationRef', 'ticket']
	};
	
	OpenTicketCmd.selectSchema = function (cmd) {
	    var locationReferenceType = cmd && cmd.locationRef && cmd.locationRef.locationReferenceType || 'PatrimonyLocation';
	    var callerType = cmd && cmd.ticket && cmd.ticket.callerz && cmd.ticket.callerz.callerType || 'ReferencedContactCaller';
	
	    return OpenTicketCmd.schemaCache([locationReferenceType, callerType], function () {
	        var locationRefSchema = OpenTicketCmd.schema.properties.locationRef.oneOf.find(function (schema) {
	            return schema.properties.locationReferenceType.enum.indexOf(locationReferenceType) >= 0;
	        });
	
	        var callerzSchema = OpenTicketCmd.schema.properties.ticket.properties.callerz.oneOf.find(function (schema) {
	            return schema.properties.callerType.enum.indexOf(callerType) >= 0;
	        });
	
	        return _extends({}, OpenTicketCmd.schema, {
	            properties: _extends({}, OpenTicketCmd.schema.properties, {
	                locationRef: locationRefSchema,
	                ticket: _extends({}, OpenTicketCmd.schema.properties.ticket, {
	                    properties: _extends({}, OpenTicketCmd.schema.properties.ticket.properties, {
	                        callerz: callerzSchema
	                    })
	                })
	            })
	        });
	    });
	};
	
	var IdentifyAssigneeCmd = exports.IdentifyAssigneeCmd = function IdentifyAssigneeCmd() {
	    _classCallCheck(this, IdentifyAssigneeCmd);
	};
	
	IdentifyAssigneeCmd.schema = {
	    type: 'object',
	    properties: {
	        assignee: { type: 'object' },
	        comment: { type: ['string', 'null'] },
	        instructions: { type: ['string', 'null'] }
	    },
	    required: ['assignee']
	};
	
	var ReportSendingServiceOrderCmd = exports.ReportSendingServiceOrderCmd = function ReportSendingServiceOrderCmd() {
	    _classCallCheck(this, ReportSendingServiceOrderCmd);
	};
	
	ReportSendingServiceOrderCmd.schema = {
	    type: 'object',
	    properties: {
	        ref: { type: 'string' },
	        sendingDate: { type: 'date' }
	    },
	    required: ['ref', 'sendingDate']
	};
	
	var DefineInterventionDeadlineCmd = exports.DefineInterventionDeadlineCmd = function DefineInterventionDeadlineCmd() {
	    _classCallCheck(this, DefineInterventionDeadlineCmd);
	};
	
	DefineInterventionDeadlineCmd.schema = {
	    type: 'object',
	    properties: {
	        deadline: { type: 'date' }
	    },
	    required: ['deadline']
	};
	
	var ReportFormalNoticeForProviderCmd = exports.ReportFormalNoticeForProviderCmd = function ReportFormalNoticeForProviderCmd() {
	    _classCallCheck(this, ReportFormalNoticeForProviderCmd);
	};
	
	ReportFormalNoticeForProviderCmd.schema = {
	    type: 'object',
	    properties: {
	        deadline: { type: 'date' }
	    },
	    required: ['deadline']
	};
	
	var ScheduleInterventionCmd = exports.ScheduleInterventionCmd = function ScheduleInterventionCmd() {
	    _classCallCheck(this, ScheduleInterventionCmd);
	};
	
	ScheduleInterventionCmd.schema = {
	    type: 'object',
	    properties: {
	        startDate: { type: 'date' },
	        endDate: { type: 'date' }
	    },
	    required: ['startDate', 'endDate']
	};
	
	var StartInterventionCmd = exports.StartInterventionCmd = function StartInterventionCmd() {
	    _classCallCheck(this, StartInterventionCmd);
	};
	
	StartInterventionCmd.schema = {
	    type: 'object',
	    properties: {
	        startedDate: { type: 'date' }
	    },
	    required: ['startedDate']
	};
	
	var FinishInterventionCmd = exports.FinishInterventionCmd = function FinishInterventionCmd() {
	    _classCallCheck(this, FinishInterventionCmd);
	};
	
	FinishInterventionCmd.schema = {
	    type: 'object',
	    properties: {
	        finishedDate: { type: 'date' }
	    },
	    required: ['finishedDate']
	};
	
	var AddMessageCmd = exports.AddMessageCmd = function AddMessageCmd() {
	    _classCallCheck(this, AddMessageCmd);
	};
	
	AddMessageCmd.schema = {
	    type: 'object',
	    properties: {
	        message: { type: 'string' }
	    },
	    required: ['message']
	};
	
	var CloseTicketCmd = exports.CloseTicketCmd = function CloseTicketCmd() {
	    _classCallCheck(this, CloseTicketCmd);
	};
	
	CloseTicketCmd.schema = {
	    oneOf: [{
	        type: 'object',
	        properties: {
	            report: { type: ['string', 'null'] },
	            commandType: {
	                type: 'string',
	                enum: ['FixPermanently', 'FixPartially', 'PostponeFix', 'CloseTicketImpossibleRepair']
	            }
	        },
	        required: ['commandType']
	    }, {
	        type: 'object',
	        properties: {
	            comment: { type: ['string', 'null'] },
	            commandType: {
	                type: 'string',
	                enum: ['CancelTicket', 'CloseBeyondCallCenterScope']
	            }
	        },
	        required: ['commandType']
	    }]
	};
	
	CloseTicketCmd.selectSchema = function (cmd) {
	    var commandType = cmd && cmd.commandType || CLOSE_TICKET_CMD_TYPES[0];
	
	    return CloseTicketCmd.schema.oneOf.find(function (schema) {
	        return schema.properties.commandType.enum.indexOf(commandType) >= 0;
	    });
	};
	
	var CorrectTicketInformationsCmd = exports.CorrectTicketInformationsCmd = function CorrectTicketInformationsCmd() {
	    _classCallCheck(this, CorrectTicketInformationsCmd);
	};
	
	CorrectTicketInformationsCmd.schema = {
	    type: 'object',
	    properties: {
	        fieldsToCorrect: {
	            type: 'object',
	            properties: {
	                request: { type: ['string', 'null'] },
	                instructions: { type: ['string', 'null'] },
	                closingReport: { type: ['string', 'null'] }
	            },
	            anyRequired: ['request', 'instructions', 'closingReport']
	        }
	    },
	    required: ['fieldsToCorrect']
	};
	
	var CorrectTicketEventInformationsCmd = exports.CorrectTicketEventInformationsCmd = function CorrectTicketEventInformationsCmd() {
	    _classCallCheck(this, CorrectTicketEventInformationsCmd);
	};
	
	CorrectTicketEventInformationsCmd.schema = {
	    type: 'object',
	    properties: {
	        text: { type: 'string' }
	    },
	    required: ['text']
	};
	
	var ReceiveCallCmd = exports.ReceiveCallCmd = function ReceiveCallCmd() {
	    _classCallCheck(this, ReceiveCallCmd);
	};
	
	ReceiveCallCmd.schema = {
	    type: 'object',
	    properties: {
	        callerz: { type: 'string' },
	        callPurpose: { type: 'string' },
	        medium: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    phone: {
	                        type: 'string',
	                        format: 'phone'
	                    }
	                },
	                required: ['phone']
	            }, {
	                type: 'object',
	                properties: {
	                    mail: {
	                        type: 'string',
	                        format: 'email'
	                    }
	                },
	                required: ['mail']
	            }, {
	                type: 'object',
	                properties: {
	                    fax: {
	                        type: 'string',
	                        format: 'phone'
	                    }
	                },
	                required: ['fax']
	            }]
	        },
	        comment: { type: ['string', 'null'] }
	    },
	    required: ['callerz', 'callPurpose', 'medium']
	};
	
	var EmitCallToCmd = exports.EmitCallToCmd = function EmitCallToCmd() {
	    _classCallCheck(this, EmitCallToCmd);
	};
	
	EmitCallToCmd.schemaCache = (0, _cache2.default)();
	
	EmitCallToCmd.schema = {
	    type: 'object',
	    properties: {
	        recipient: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    namez: {
	                        oneOf: [{
	                            type: 'object',
	                            properties: {
	                                firstName: { type: 'string' },
	                                lastName: { type: 'string' },
	                                gender: { type: ['string', 'null'] },
	                                nameType: {
	                                    type: 'string',
	                                    enum: ['CivilName']
	                                }
	                            },
	                            required: ['firstName', 'lastName', 'nameType']
	                        }, {
	                            type: 'object',
	                            properties: {
	                                value: { type: 'string' },
	                                nameType: {
	                                    type: 'string',
	                                    enum: ['PoorName']
	                                }
	                            },
	                            required: ['value', 'nameType']
	                        }]
	                    },
	                    personaType: {
	                        type: 'string',
	                        enum: ['UnClassifiedPersona']
	                    }
	                },
	                required: ['namez', 'personaType']
	            }, {
	                type: 'object',
	                properties: {
	                    provider: { type: 'object' },
	                    personaType: {
	                        type: 'string',
	                        enum: ['ProviderPersona']
	                    }
	                },
	                required: ['provider', 'personaType']
	            }]
	        },
	        medium: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    phone: {
	                        type: 'string',
	                        format: 'phone'
	                    }
	                },
	                required: ['phone']
	            }, {
	                type: 'object',
	                properties: {
	                    mail: {
	                        type: 'string',
	                        format: 'email'
	                    }
	                },
	                required: ['mail']
	            }, {
	                type: 'object',
	                properties: {
	                    fax: {
	                        type: 'string',
	                        format: 'phone'
	                    }
	                },
	                required: ['fax']
	            }]
	        },
	        comment: { type: ['string', 'null'] }
	    },
	    required: ['medium', 'recipient']
	};
	
	EmitCallToCmd.selectSchema = function (cmd) {
	    var personaType = cmd && cmd.recipient && cmd.recipient.personaType || 'UnClassifiedPersona';
	    var nameType = cmd && cmd.recipient && cmd.recipient.namez && cmd.recipient.namez.nameType || 'CivilName';
	
	    return EmitCallToCmd.schemaCache([personaType, nameType /*, interventionAcceptedType*/], function () {
	        var recipientSchema = EmitCallToCmd.schema.properties.recipient.oneOf.find(function (schema) {
	            return schema.properties.personaType.enum.indexOf(personaType) >= 0;
	        });
	
	        if (personaType == 'UnClassifiedPersona') {
	            var namezSchema = recipientSchema.properties.namez.oneOf.find(function (schema) {
	                return schema.properties.nameType.enum.indexOf(nameType) >= 0;
	            });
	
	            recipientSchema = _extends({}, recipientSchema, {
	                properties: _extends({}, recipientSchema.properties, {
	                    namez: namezSchema
	                })
	            });
	        }
	
	        return _extends({}, EmitCallToCmd.schema, {
	            properties: _extends({}, EmitCallToCmd.schema.properties, {
	                recipient: recipientSchema
	            })
	        });
	    });
	};
	
	var FinishMissionCmd = exports.FinishMissionCmd = function FinishMissionCmd() {
	    _classCallCheck(this, FinishMissionCmd);
	};
	
	FinishMissionCmd.schema = {
	    type: 'object',
	    properties: {
	        comment: { type: ['string', 'null'] }
	    }
	};
	
	function mediumToContactMedium(medium) {
	    if (medium && medium.mediumType) {
	        return {
	            phone: medium.mediumType == 'PHONE' && (0, _phonez2.default)(medium.identifier).toE164() || undefined,
	            mail: medium.mediumType == 'MAIL' && medium.identifier || undefined,
	            fax: medium.mediumType == 'FAX' && (0, _phonez2.default)(medium.identifier).toE164() || undefined,
	            contactMediumType: medium.mediumType == 'PHONE' && 'Phone' || medium.mediumType == 'MAIL' && 'Mail' || medium.mediumType == 'FAX' && 'Fax'
	        };
	    }
	    if (medium && medium.contactInfoType) {
	        return {
	            phone: medium.phone,
	            mail: medium.mail,
	            fax: medium.fax,
	            contactMediumType: medium.contactInfoType
	        };
	    }
	    return medium;
	}
	
	function plainContactToContactMedium(type) {
	    return function (plain) {
	        return {
	            phone: type == 'Phone' && (0, _phonez2.default)(plain).toE164() || undefined,
	            mail: type == 'Mail' && plain || undefined,
	            fax: type == 'Fax' && (0, _phonez2.default)(plain).toE164() || undefined,
	            contactMediumType: type
	        };
	    };
	}
	
	function nameToPlainName(name) {
	    if (name && name.nameType == 'CivilName') return [name.firstName, name.lastName].filter(function (v) {
	        return v;
	    }).join(' ') || null;
	    if (name && name.nameType == 'PoorName') return name.value;
	    if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) == 'object') return name.value || [name.firstName, name.lastName].filter(function (v) {
	        return v;
	    }).join(' ') || null;
	    return name;
	}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(133);
	var createDesc = __webpack_require__(97);
	var toIObject = __webpack_require__(53);
	var toPrimitive = __webpack_require__(69);
	var has = __webpack_require__(50);
	var IE8_DOM_DEFINE = __webpack_require__(289);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(50);
	var toObject = __webpack_require__(32);
	var IE_PROTO = __webpack_require__(221)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(132);
	var defined = __webpack_require__(67);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.supportCORS = supportCORS;
	exports.supportHistory = supportHistory;
	exports.supportWorker = supportWorker;
	exports.supportWebSocket = supportWebSocket;
	exports.isIE = isIE;
	exports.screenSize = screenSize;
	exports.mediaQuery = mediaQuery;
	exports.matchMedia = matchMedia;
	exports.scrollTop = scrollTop;
	exports.resolveLocationPathname = resolveLocationPathname;
	// must be the same as bootstrap
	var SCREEN_SM_MIN = exports.SCREEN_SM_MIN = 768;
	var SCREEN_MD_MIN = exports.SCREEN_MD_MIN = 992;
	var SCREEN_LG_MIN = exports.SCREEN_LG_MIN = 1200;
	
	function supportCORS() {
	    return 'withCredentials' in new XMLHttpRequest();
	}
	
	function supportHistory() {
	    return window.history && window.history.pushState && true || false;
	}
	
	function supportWorker() {
	    if (isIE('edge')) return false; // IE Edge is buggy https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9243268/
	    return window.Worker && true || false;
	}
	
	function supportWebSocket() {
	    return window.WebSocket && true || false;
	}
	
	function isIE(version) {
	    var userAgent = navigator.userAgent.toLowerCase();
	
	    var ieVersion;
	
	    if (userAgent.indexOf('msie') >= 0) {
	        ieVersion = parseInt(userAgent.split('msie')[1]);
	    } else if (userAgent.indexOf('trident/') >= 0) {
	        ieVersion = 11;
	    } else if (userAgent.indexOf('edge/') >= 0) {
	        ieVersion = 'edge';
	    }
	
	    if (ieVersion && version) return ieVersion == version;
	    if (ieVersion) return true;
	    return false;
	}
	
	function screenSize() {
	    var width = window.innerWidth;
	
	    if (width >= SCREEN_LG_MIN) return 'lg';
	    if (width >= SCREEN_MD_MIN) return 'md';
	    if (width >= SCREEN_SM_MIN) return 'sm';
	    return 'xs';
	}
	
	function mediaQuery() {
	    var width = window.innerWidth;
	
	    if (width >= SCREEN_LG_MIN) return ['lg', 'md', 'sm', 'xs'];
	    if (width >= SCREEN_MD_MIN) return ['md', 'sm', 'xs'];
	    if (width >= SCREEN_SM_MIN) return ['sm', 'xs'];
	    return ['xs'];
	}
	
	function matchMedia(size) {
	    return mediaQuery().indexOf(size) > -1;
	}
	
	function scrollTop(duration) {
	    var start = document.body.scrollTop;
	    var change = -start;
	    var increment = 20;
	
	    function easeInOut(currentTime, start, change, duration) {
	        currentTime /= duration / 2;
	
	        if (currentTime < 1) {
	            return change / 2 * currentTime * currentTime + start;
	        }
	
	        currentTime -= 1;
	        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
	    }
	
	    function animateScroll(elapsedTime) {
	        elapsedTime += increment;
	        var position = easeInOut(elapsedTime, start, change, duration);
	        document.body.scrollTop = position;
	
	        if (elapsedTime < duration) {
	            setTimeout(function () {
	                return animateScroll(elapsedTime);
	            }, increment);
	        }
	    }
	
	    animateScroll(0);
	}
	
	function resolveLocationPathname(nextPathname) {
	    var pathnameSegments = window.location.pathname.split('/').slice(1);
	
	    nextPathname = nextPathname.replace(/^\/\*\//, '/' + pathnameSegments[0] + '/');
	    nextPathname = nextPathname.replace(/^(\/[\w-]+)\/\*\//, '$1/' + pathnameSegments[1] + '/');
	    nextPathname = nextPathname.replace(/^(\/[\w-]+\/[\w-]+)\/\*\//, '$1/' + pathnameSegments[2] + '/');
	    return nextPathname;
	}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(189);
	var PooledClass = __webpack_require__(79);
	var ReactPerf = __webpack_require__(64);
	var ReactReconciler = __webpack_require__(105);
	var Transaction = __webpack_require__(147);
	
	var assign = __webpack_require__(22);
	var invariant = __webpack_require__(14);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        patrimonies: 'patrimoines',
	        patrimony: 'patrimoine',
	        newPatrimony: 'nouveau patrimoine',
	        updatePatrimony: 'modification',
	        searchPatrimony: {
	            xs: 'patrimoine',
	            sm: 'rechercher votre patrimoine'
	        },
	        searchStream: {
	            xs: 'rechercher',
	            sm: 'rechercher un patrimoine'
	        },
	        searchAgency: {
	            xs: 'portefeuille',
	            sm: 'rechercher votre portefeuille'
	        },
	        useSearchPatrimonyFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
	        useSearchContactFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
	        newLot: 'nouveau lot',
	        updateLot: 'modification',
	        deleteLot: 'supprimer le lot ...',
	        deleteLotText: ['Vous êtes sur le point de supprimer le lot {ref}.', 'Cette action est irréversible.'],
	        lot: 'lot',
	        lots: 'lots',
	        lotNumber: 'numéro de lot',
	        usage: 'sous catégorie',
	        usageEnum: {
	            residentialParking: 'parking',
	            residentialCellar: 'cave',
	            residentialAnnex: 'annexe',
	            apartment: 'appartement',
	            individualHouse: 'maison individuelle',
	            tertiaryParking: 'parking',
	            workspace: 'surface',
	            workstation: 'poste de travail',
	            office: 'bureau',
	            retailShop: 'commerce / boutique',
	            warehouse: 'entrepôt',
	            gasStation: 'station service',
	            meetingRoom: 'salle de réunion',
	            restaurant: 'restaurant',
	            fitness: 'fitness',
	            spa: 'spa',
	            sportFacility: 'équipement sportif',
	            pool: 'piscine',
	            poolHouse: 'pool house',
	            playground: 'jeux d\'enfants',
	            laundry: 'laverie',
	            otherService: 'autre',
	            boilerRoom: 'chaufferie',
	            elevator: 'ascenseur',
	            ventilationSystem: 'ventilation',
	            gate: 'porte / portail',
	            intercom: 'interphone',
	            binStorageArea: 'local poubelle',
	            machineRoom: 'local technique',
	            gardeningShed: ' local jardin',
	            otherTechnical: 'autre'
	        },
	        usageGroupEnum: {
	            residential: 'résidentiel',
	            tertiary: 'tertiaire',
	            service: 'service',
	            technical: 'technique'
	        },
	        patrimonyContact: 'contact',
	        patrimonyContacts: 'contacts',
	        patrimonyContactsFilteredByPatrimony: 'contacts du patrimoine',
	        allPatrimonyContacts: 'tous les contacts',
	        newPatrimonyContact: 'nouveau contact',
	        updatePatrimonyContact: 'modification',
	        linkPatrimonyContact: 'associer un contact',
	        unlinkPatrimonyContact: 'dissocier un contact',
	        patrimonyContactLinkType: 'role',
	        patrimonyContactLinkTypeEnum: {
	            linkToPatrimonyAsHomeOwnerAssociation: {
	                default: 'conseil syndical',
	                member: 'membre du conseil syndical',
	                president: 'président du conseil syndical'
	            },
	            linkToPatrimonyAsCareTaker: 'gardien',
	            linkToLotAsTenant: 'locataire',
	            linkToLotAsOwner: 'propriétaire',
	            linkToLotAsLandlord: 'propriétaire bailleur',
	            linkToNonReferencedLot: {
	                default: 'lot non réfeŕencé',
	                tenant: 'locataire',
	                owner: 'propriétaire',
	                landlord: 'propriétaire bailleur'
	            }
	        },
	        patrimonyUserLinkTypeEnum: {
	            CallCenterUser: 'utilisateur',
	            CallCenterOperator: 'opérateur',
	            ClientAccountManager: 'administrateur',
	            Executive: 'cadre',
	            PatrimonyManager: 'gestionnaire'
	        },
	
	        homeOwnerAssociation: 'conseil syndical',
	        homeOwnerAssociationPosition: 'position',
	        linkedToNonReferencedLotPosition: 'titi',
	        homeOwnerAssociationPositionEnum: {
	            member: 'membre du conseil syndical',
	            president: 'président du conseil syndical'
	        },
	        complementaryAddresses: 'adresses complémentaires',
	        addAddress: 'ajouter une adresse',
	        removeAddress: 'supprimer l\'adresse',
	        synthesis: 'synthèse',
	        additionalInfos: 'Informations',
	        directory: 'annuaire',
	        tickets: 'tickets',
	        audits: 'audits',
	        newAudit: 'audit',
	        lastAudits: 'derniers audits',
	        providers: 'fournisseurs',
	        documents: 'documents',
	        agency: 'portefeuille',
	        agencies: 'portefeuilles',
	        addAgency: 'ajouter un portefeuille',
	        building: 'bâtiment',
	        buildings: 'bâtiments',
	        currentYearStats: 'statistiques sur l\'année en cours',
	        openedTickets: 'tickets ouverts',
	        nextInterventions: 'interventions à venir',
	        newAudits: 'audits réalisés',
	        nextPatrimonyEvent: 'prochain évènement du patrimoine',
	        nextLotEvent: 'prochain évènement du lot',
	        nextBuildingEvent: 'prochain évènement du bâtiment',
	        description: 'description',
	        callPurpose: 'type d\'incident',
	        providersTop10: 'top 10 des fournisseurs',
	        powerConsumption: 'conso. élect.',
	        elevator: 'ascenseur',
	        addressCount: 'nombre d\'adresses',
	        referenceInfo: 'identifiant spécifique à la gestion du lot',
	        lotNumberInfo: 'identifiant administratif du lot dans son patrimoine',
	        nameType: 'type de contact',
	        nameTypeEnum: {
	            civilName: 'individu',
	            poorName: 'service'
	        },
	        gender: 'civilité',
	        genderEnum: {
	            male: 'M.',
	            female: 'Mme.'
	        },
	        contactDetails: 'informations de contact',
	        contactDetailsText: 'Merci de renseigner au moins un moyen de contact',
	        reportPdfPatrimony: 'Télécharger le rapport PDF',
	        reportingPatrimony: 'Téléchargement en cours',
	        patrimonyUser: {
	            createInSameTime: 'Inviter le contact à se connecter',
	            linkToUserError: 'Un utilisateur existe déjà avec cet email',
	            linkToUser: 'Associer',
	            stateToIcon: {
	                NoAccount: '',
	                ActiveAccount: 'opened',
	                NotActiveAccount: 'closed'
	            },
	            stateToTooltip: {
	                NoAccount: 'Pas de compte utilisateur',
	                ActiveAccount: 'Compte utilisateur actif',
	                NotActiveAccount: 'Compte utilisateur inactif'
	            },
	            title: {
	                NoAccount: 'Inviter le contact à se connecter',
	                ActiveAccount: 'Désactiver le compte utilisateur',
	                NotActiveAccount: 'Modifier le compte utilisateur'
	            }
	        },
	        userAccount: 'Compte utilisateur',
	        user: {
	            login: 'email',
	            disable: 'désactiver l\'utilisateur ...',
	            sendActivationEmail: 'renvoyer l\'email d\'activation',
	            activationEmailSent: 'un email a été envoyé'
	        }
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _styleMaps = __webpack_require__(150);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	}
	
	function prefix(props, variant) {
	  if (props === undefined) props = {};
	
	  !(props.bsClass || '').trim() ?  false ? _invariant2['default'](false, 'A `bsClass` prop is required for this component') : _invariant2['default'](false) : undefined;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _react.PropTypes.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	exports.bsClass = bsClass;
	var bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _react.PropTypes.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = _extends({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	exports.bsStyles = bsStyles;
	var bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = existing.reduce(function (result, size) {
	    if (_styleMaps2['default'].SIZES[size] && _styleMaps2['default'].SIZES[size] !== size) {
	      result.push(_styleMaps2['default'].SIZES[size]);
	    }
	    return result.concat(size);
	  }, []);
	
	  var propType = _react.PropTypes.oneOf(values);
	
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = _extends({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	exports.bsSizes = bsSizes;
	exports['default'] = {
	
	  prefix: prefix,
	
	  getClassSet: function getClassSet(props) {
	    var classes = {};
	    var bsClassName = prefix(props);
	
	    if (bsClassName) {
	      var bsSize = undefined;
	
	      classes[bsClassName] = true;
	
	      if (props.bsSize) {
	        bsSize = _styleMaps2['default'].SIZES[props.bsSize] || bsSize;
	      }
	
	      if (bsSize) {
	        classes[prefix(props, bsSize)] = true;
	      }
	
	      if (props.bsStyle) {
	        if (props.bsStyle.indexOf(prefix(props)) === 0) {
	           false ? _warning2['default'](false, // small migration convenience, since the old method required manual prefixing
	          'bsStyle will automatically prefix custom values with the bsClass, so there is no ' + 'need to append it manually. (bsStyle: ' + props.bsStyle + ', bsClass: ' + prefix(props) + ')') : undefined;
	          classes[props.bsStyle] = true;
	        } else {
	          classes[prefix(props, props.bsStyle)] = true;
	        }
	      }
	    }
	
	    return classes;
	  },
	
	  /**
	   * Add a style variant to a Component. Mutates the propTypes of the component
	   * in order to validate the new variant.
	   */
	  addStyle: function addStyle(Component, styleVariant) {
	    bsStyles(styleVariant, Component);
	  }
	};
	var _curry = curry;
	exports._curry = _curry;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LoaderForm = exports.LoaderButton = exports.Loader = exports.STATUS_LOADED = exports.STATUS_LOADING_FAILED = exports.STATUS_LOADING_DELAYED = exports.STATUS_LOADING = exports.LOADING_FAILED = exports.LOADING_DELAYED = exports.LOADING = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadingReducer = loadingReducer;
	exports.loadingMiddleware = loadingMiddleware;
	exports.connectLoading = connectLoading;
	exports.connectLoadingLock = connectLoadingLock;
	exports.isLoading = isLoading;
	exports.isLoadingDelayed = isLoadingDelayed;
	exports.default = loading;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Loader = __webpack_require__(1352);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NAMESPACE = 'Core';
	var LOADING = exports.LOADING = NAMESPACE + '/Loading';
	var LOADING_DELAYED = exports.LOADING_DELAYED = NAMESPACE + '/LoadingDelayed';
	var LOADING_FAILED = exports.LOADING_FAILED = NAMESPACE + '/LoadingFailed';
	
	var STATUS_LOADING = exports.STATUS_LOADING = 'Loading';
	var STATUS_LOADING_DELAYED = exports.STATUS_LOADING_DELAYED = 'LoadingDelayed';
	var STATUS_LOADING_FAILED = exports.STATUS_LOADING_FAILED = 'LoadingFailed';
	var STATUS_LOADED = exports.STATUS_LOADED = 'Loaded';
	
	// reducer
	
	var loadingReducerLock = false;
	
	function loadingReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case LOADING:
	            if (!loadingReducerLock) {
	                // action is not consecutive 
	                if (state && Object.keys(state).reduce(function (r, n) {
	                    return r || state[n] == STATUS_LOADING_FAILED || state[n] == STATUS_LOADED;
	                }, false)) {
	                    // all previous consecutive actions completed
	                    state = null;
	                }
	            }
	            return _extends({}, state, _defineProperty({}, action.name, STATUS_LOADING));
	        case LOADING_DELAYED:
	            return _extends({}, state, _defineProperty({}, action.name, STATUS_LOADING_DELAYED));
	        case LOADING_FAILED:
	            loadingReducerLock = true;
	            setTimeout(function () {
	                return loadingReducerLock = false;
	            }, 0);
	            return _extends({}, state, _defineProperty({}, action.name, STATUS_LOADING_FAILED));
	        default:
	            if (state && state[action.type] != undefined) {
	                loadingReducerLock = true;
	                setTimeout(function () {
	                    return loadingReducerLock = false;
	                }, 0);
	                return _extends({}, state, _defineProperty({}, action.type, STATUS_LOADED));
	            }
	            return state;
	    }
	}
	
	// middleware
	
	function loadingMiddleware(_ref) {
	    var dispatch = _ref.dispatch;
	
	    return function (next) {
	        return function (action) {
	            if (action.loader) {
	
	                dispatch({
	                    type: LOADING,
	                    name: action.name
	                });
	
	                var timer = setTimeout(function () {
	                    dispatch({
	                        type: LOADING_DELAYED,
	                        name: action.name
	                    });
	                }, action.delay);
	
	                return Promise.resolve(next(action.loader)).then(function (action) {
	                    clearTimeout(timer);
	                    return action;
	                }).catch(function (error) {
	                    clearTimeout(timer);
	
	                    dispatch({
	                        type: LOADING_FAILED,
	                        name: action.name
	                    });
	                    console.error(error);
	
	                    return Promise.reject(error);
	                });
	            }
	            return next(action);
	        };
	    };
	}
	
	// higher order component
	
	function connectLoading() {
	    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return function (WrappedComponent) {
	        var LoadingConnector = function (_Component) {
	            _inherits(LoadingConnector, _Component);
	
	            function LoadingConnector(props) {
	                _classCallCheck(this, LoadingConnector);
	
	                var _this = _possibleConstructorReturn(this, (LoadingConnector.__proto__ || Object.getPrototypeOf(LoadingConnector)).call(this, props));
	
	                _this.state = {};
	                return _this;
	            }
	
	            _createClass(LoadingConnector, [{
	                key: 'componentWillMount',
	                value: function componentWillMount() {
	                    var loading = this.props.loading;
	
	
	                    var actionLoadingDelayed = isLoadingDelayed(loading, option.include, option.exclude);
	                    this.setState({ actionLoadingDelayed: actionLoadingDelayed });
	                }
	            }, {
	                key: 'componentWillReceiveProps',
	                value: function componentWillReceiveProps(nextProps) {
	                    var _this2 = this;
	
	                    if (nextProps.loading != this.props.loading) {
	                        var _loading = nextProps.loading;
	                        var actionLoadingDelayed = this.state.actionLoadingDelayed;
	
	
	                        clearTimeout(this._timer);
	                        this._timer = setTimeout(function () {
	                            // wait for consecutive actions
	                            var nextActionLoadingDelayed = actionLoadingDelayed && isLoading(_loading, option.include, option.exclude) || isLoadingDelayed(_loading, option.action);
	                            _this2.setState({ actionLoadingDelayed: nextActionLoadingDelayed });
	                        }, 0);
	                    }
	                }
	            }, {
	                key: 'componentWillUnmount',
	                value: function componentWillUnmount() {
	                    clearTimeout(this._timer);
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    var actionLoadingDelayed = this.state.actionLoadingDelayed;
	
	
	                    if (actionLoadingDelayed) {
	                        return _react2.default.createElement(_Loader2.default, null);
	                    }
	                    return _react2.default.createElement(WrappedComponent, this.props);
	                }
	            }]);
	
	            return LoadingConnector;
	        }(_react.Component);
	
	        return LoadingConnector;
	    };
	}
	
	function connectLoadingLock() {
	    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return function (WrappedComponent) {
	        var LoadingLockConnector = function (_Component2) {
	            _inherits(LoadingLockConnector, _Component2);
	
	            function LoadingLockConnector(props) {
	                _classCallCheck(this, LoadingLockConnector);
	
	                var _this3 = _possibleConstructorReturn(this, (LoadingLockConnector.__proto__ || Object.getPrototypeOf(LoadingLockConnector)).call(this, props));
	
	                _this3.state = {
	                    actionLoading: false
	                };
	                return _this3;
	            }
	
	            _createClass(LoadingLockConnector, [{
	                key: 'componentWillReceiveProps',
	                value: function componentWillReceiveProps(nextProps) {
	                    var _this4 = this;
	
	                    if (nextProps.loading != this.props.loading) {
	                        var _loading2 = nextProps.loading;
	
	
	                        clearTimeout(this._timer);
	                        this._timer = setTimeout(function () {
	                            // wait for consecutive actions
	                            var actionLoading = isLoading(_loading2, option.include, option.exclude);
	                            _this4.setState({ actionLoading: actionLoading });
	                        }, 0);
	                    }
	                }
	            }, {
	                key: 'componentWillUnmount',
	                value: function componentWillUnmount() {
	                    clearTimeout(this._timer);
	                }
	            }, {
	                key: 'shouldComponentUpdate',
	                value: function shouldComponentUpdate(nextProps, nextState) {
	                    return !nextState.actionLoading;
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    return _react2.default.createElement(WrappedComponent, this.props);
	                }
	            }]);
	
	            return LoadingLockConnector;
	        }(_react.Component);
	
	        return LoadingLockConnector;
	    };
	}
	
	// component
	
	var Loader = function (_Component3) {
	    _inherits(Loader, _Component3);
	
	    function Loader(props) {
	        _classCallCheck(this, Loader);
	
	        var _this5 = _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).call(this, props));
	
	        _this5.state = {};
	        return _this5;
	    }
	
	    _createClass(Loader, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                loading = _props.loading,
	                include = _props.include,
	                exclude = _props.exclude;
	
	
	            var actionLoadingDelayed = isLoadingDelayed(loading, include, exclude);
	            this.setState({ actionLoadingDelayed: actionLoadingDelayed });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this6 = this;
	
	            if (nextProps.loading != this.props.loading) {
	                var _loading3 = nextProps.loading,
	                    include = nextProps.include,
	                    exclude = nextProps.exclude;
	                var actionLoadingDelayed = this.state.actionLoadingDelayed;
	
	
	                clearTimeout(this._timer);
	                this._timer = setTimeout(function () {
	                    // wait for consecutive actions
	                    var nextActionLoadingDelayed = actionLoadingDelayed && isLoading(_loading3, include, exclude) || isLoadingDelayed(_loading3, include, exclude);
	                    _this6.setState({ actionLoadingDelayed: nextActionLoadingDelayed });
	                }, 0);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	            var actionLoadingDelayed = this.state.actionLoadingDelayed;
	
	
	            if (actionLoadingDelayed) {
	                return _react2.default.createElement(_Loader2.default, null);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                children
	            );
	        }
	    }]);
	
	    return Loader;
	}(_react.Component);
	
	Loader.propTypes = {
	    include: _react.PropTypes.any,
	    exclude: _react.PropTypes.any
	};
	
	
	exports.Loader = Loader = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading
	    };
	})(Loader);
	
	exports.Loader = Loader;
	
	var LoaderButton = function (_Component4) {
	    _inherits(LoaderButton, _Component4);
	
	    function LoaderButton(props) {
	        _classCallCheck(this, LoaderButton);
	
	        var _this7 = _possibleConstructorReturn(this, (LoaderButton.__proto__ || Object.getPrototypeOf(LoaderButton)).call(this, props));
	
	        _this7.state = {};
	        return _this7;
	    }
	
	    _createClass(LoaderButton, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props2 = this.props,
	                loading = _props2.loading,
	                action = _props2.action;
	
	
	            var actionLoading = isLoading(loading, action);
	            this.setState({ actionLoading: actionLoading });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this8 = this;
	
	            if (nextProps.loading != this.props.loading) {
	                var _loading4 = nextProps.loading,
	                    action = nextProps.action;
	                var actionLoading = this.state.actionLoading;
	
	
	                clearTimeout(this._timer);
	                this._timer = setTimeout(function () {
	                    // wait for consecutive actions
	                    var nextActionLoading = isLoading(_loading4, action);
	                    _this8.setState({ actionLoading: nextActionLoading });
	                }, 0);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                loading = _props3.loading,
	                _onClick = _props3.onClick,
	                others = _objectWithoutProperties(_props3, ['loading', 'onClick']);
	
	            var actionLoading = this.state.actionLoading;
	
	
	            return _react2.default.createElement(_LoaderButton2.default, _extends({
	                loading: actionLoading,
	                onClick: function onClick(e) {
	                    _onClick(e);
	                }
	            }, others));
	        }
	    }]);
	
	    return LoaderButton;
	}(_react.Component);
	
	LoaderButton.propTypes = {
	    action: _react.PropTypes.any
	};
	
	
	exports.LoaderButton = LoaderButton = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading
	    };
	})(LoaderButton);
	
	exports.LoaderButton = LoaderButton;
	
	var LoaderForm = function (_Component5) {
	    _inherits(LoaderForm, _Component5);
	
	    function LoaderForm(props) {
	        _classCallCheck(this, LoaderForm);
	
	        var _this9 = _possibleConstructorReturn(this, (LoaderForm.__proto__ || Object.getPrototypeOf(LoaderForm)).call(this, props));
	
	        _this9.state = {};
	        return _this9;
	    }
	
	    _createClass(LoaderForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props4 = this.props,
	                loading = _props4.loading,
	                action = _props4.action;
	
	
	            var actionLoading = isLoading(loading, action);
	            this.setState({ actionLoading: actionLoading });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this10 = this;
	
	            if (nextProps.loading != this.props.loading) {
	                var _loading5 = nextProps.loading,
	                    action = nextProps.action;
	                var actionLoading = this.state.actionLoading;
	
	
	                clearTimeout(this._timer);
	                this._timer = setTimeout(function () {
	                    // wait for consecutive actions
	                    var nextActionLoading = isLoading(_loading5, action);
	                    _this10.setState({ actionLoading: nextActionLoading });
	                }, 0);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: '_enhance',
	        value: function _enhance(children) {
	            var _this11 = this;
	
	            return _react2.default.Children.map(children, function (child) {
	                if (child && child.type && (child.type.displayName == 'Button' || child.type.displayName == 'Input')) {
	                    return _react2.default.cloneElement(child, {
	                        disabled: true
	                    });
	                }
	                if (child && child.props) {
	                    var _children = child.props.children;
	
	
	                    return _children && _react2.default.cloneElement(child, {
	                        children: _this11._enhance(_children)
	                    }) || child;
	                }
	                return child;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props5 = this.props,
	                children = _props5.children,
	                loading = _props5.loading,
	                action = _props5.action,
	                others = _props5.others;
	            var actionLoading = this.state.actionLoading;
	
	
	            return _react2.default.createElement(
	                'form',
	                others,
	                actionLoading && this._enhance(children) || children
	            );
	        }
	    }]);
	
	    return LoaderForm;
	}(_react.Component);
	
	LoaderForm.propTypes = {
	    loading: _react.PropTypes.object.isRequired,
	    action: _react.PropTypes.any
	};
	exports.LoaderForm = LoaderForm;
	
	// helpers
	
	function match(value, regexes) {
	    regexes = regexes instanceof Array && regexes || [regexes];
	    return regexes.find(function (r) {
	        return value.match(r);
	    }) && true || false;
	}
	
	function isLoading(loading, include, exclude) {
	    var result = loading && true || false;
	    result = result && Object.keys(loading).find(function (n) {
	        return loading[n] == STATUS_LOADING || loading[n] == STATUS_LOADING_DELAYED;
	    }) && true || false;
	    result = result && (!include || Object.keys(loading).find(function (n) {
	        return match(n, include);
	    })) && true || false;
	    result = result && (!exclude || !Object.keys(loading).find(function (n) {
	        return match(n, exclude);
	    })) && true || false;
	    return result;
	}
	
	function isLoadingDelayed(loading, include, exclude) {
	    var result = loading && true || false;
	    result = result && Object.keys(loading).find(function (n) {
	        return loading[n] == STATUS_LOADING_DELAYED;
	    }) && true || false;
	    result = result && (!include || Object.keys(loading).find(function (n) {
	        return match(n, include);
	    })) && true || false;
	    result = result && (!exclude || !Object.keys(loading).find(function (n) {
	        return match(n, exclude);
	    })) && true || false;
	    return result;
	}
	
	// action
	
	function loading(loader, name) {
	    var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 700;
	
	    return { loader: loader, name: name, delay: delay };
	}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(37);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(18);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(61);
	var IObject = __webpack_require__(132);
	var toObject = __webpack_require__(32);
	var toLength = __webpack_require__(27);
	var asc = __webpack_require__(205);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3);
	var core = __webpack_require__(60);
	var fails = __webpack_require__(18);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(19);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(474);


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$create = __webpack_require__(1209)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(2036)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLogin = exports.getPhone = exports.getPatrimonyUserState = exports.DEFAULT_CONTACT_QUERY = exports.DEFAULT_PATRIMONY_QUERY = exports.DEFAULT_QUERY = exports.DISABLE_USER_CMD_SENT = exports.ADD_CONTACT_CMD_UPDATED = exports.UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED = exports.LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED = exports.ADD_ADDRESS_TO_LOT_CMD_UPDATED = exports.ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED = exports.UPDATE_LOT_CMD_UPDATED = exports.UPDATE_PATRIMONY_CMD_UPDATED = exports.REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED = exports.REFERENCE_LOT_CMD_UPDATED = exports.REFERENCE_PATRIMONY_CMD_UPDATED = exports.MINOR_CONTACT_CRITERIA_UPDATED = exports.CONTACT_CRITERIA_UPDATED = exports.MINOR_CRITERIA_UPDATED = exports.CRITERIA_UPDATED = exports.UPDATE_USER_CMD_SENT = exports.UPDATE_USER_CMD_UPDATED = exports.LINK_USER_CMD_SENT = exports.REFERENCE_USER_CMD_SENT = exports.REMOVE_CONTACT_CMD_SENT = exports.ADD_CONTACT_CMD_SENT = exports.UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT = exports.REMOVE_LINK_FROM_PATRIMONY_CONTACT_CMD_SENT = exports.LINK_PATRIMONY_CONTACT_WITH_CMD_SENT = exports.DELETE_LOT_CMD_SENT = exports.REMOVE_ADDRESS_FROM_LOT_CMD_SENT = exports.ADD_ADDRESS_TO_LOT_CMD_SENT = exports.DISSOCIATE_PATRIMONY_FROM_AGENCY_CMD_SENT = exports.ASSOCIATE_PATRIMONY_IN_AGENCY_CMD_SENT = exports.REMOVE_COMPLEMENTARY_ADDRESS_FROM_PATRIMONY_CMD_SENT = exports.ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT = exports.UPDATE_LOT_CMD_RESET = exports.UPDATE_LOT_CMD_SENT = exports.UPDATE_PATRIMONY_CMD_SENT = exports.REFERENCE_PATRIMONY_CONTACT_CMD_SENT = exports.REFERENCE_BUILDING_CMDS_SENT = exports.REFERENCE_LOT_CMD_SENT = exports.REFERENCE_PATRIMONY_CMD_SENT = exports.MINOR_CONTACT_STREAM_QUERIED = exports.MINOR_CONTACT_STREAM_LOADED = exports.CONTACT_LOADED = exports.CONTACT_STREAM_QUERIED = exports.CONTACT_STREAM_LOADED = exports.CONTACT_LINKS_LOADED = exports.BUILDING_LOADED = exports.LOT_LOADED = exports.LOT_STREAM_LOADED = exports.PATRIMONY_LOADED = exports.PATRIMONY_STREAM_QUERIED = exports.PATRIMONY_STREAM_LOADED = exports.LINKS_LOADED = exports.MINOR_CONTACT_CRITERIA_RESET = exports.MINOR_CRITERIA_RESETTED = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadLinks = loadLinks;
	exports.queryPatrimonyStream = queryPatrimonyStream;
	exports.loadPatrimonyStream = loadPatrimonyStream;
	exports.loadPatrimony = loadPatrimony;
	exports.loadLotAndBuildingStream = loadLotAndBuildingStream;
	exports.loadLotStream = loadLotStream;
	exports.loadLot = loadLot;
	exports.loadBuilding = loadBuilding;
	exports.loadContactLinks = loadContactLinks;
	exports.queryContactStream = queryContactStream;
	exports.loadContactStream = loadContactStream;
	exports.queryMinorContactStream = queryMinorContactStream;
	exports.loadMinorContactStream = loadMinorContactStream;
	exports.loadContact = loadContact;
	exports.sendReferencePatrimonyCmd = sendReferencePatrimonyCmd;
	exports.sendReferenceBuildingCmds = sendReferenceBuildingCmds;
	exports.sendReferenceLotCmd = sendReferenceLotCmd;
	exports.sendReferencePatrimonyContactCmd = sendReferencePatrimonyContactCmd;
	exports.sendUpdatePatrimonyCmd = sendUpdatePatrimonyCmd;
	exports.sendUpdateLotCmd = sendUpdateLotCmd;
	exports.sendAddComplementaryAddressToPatrimonyCmd = sendAddComplementaryAddressToPatrimonyCmd;
	exports.sendRemoveComplementaryAddressFromPatrimonyCmd = sendRemoveComplementaryAddressFromPatrimonyCmd;
	exports.sendAssociatePatrimonyInAgencyCmd = sendAssociatePatrimonyInAgencyCmd;
	exports.sendDissociatePatrimonyFromAgencyCmd = sendDissociatePatrimonyFromAgencyCmd;
	exports.sendAddAddressToLotCmd = sendAddAddressToLotCmd;
	exports.sendRemoveAddressFromLotCmd = sendRemoveAddressFromLotCmd;
	exports.sendDeleteLotCmd = sendDeleteLotCmd;
	exports.sendLinkPatrimonyContactWithCmd = sendLinkPatrimonyContactWithCmd;
	exports.sendRemoveLinkFromPatrimonyContactCmd = sendRemoveLinkFromPatrimonyContactCmd;
	exports.sendUpdatePatrimonyContactIdentityCmd = sendUpdatePatrimonyContactIdentityCmd;
	exports.sendAddContactCmd = sendAddContactCmd;
	exports.sendRemoveContactCmd = sendRemoveContactCmd;
	exports.updateReferenceLotCmd = updateReferenceLotCmd;
	exports.updateAddAddressToLotCmd = updateAddAddressToLotCmd;
	exports.updateUpdateLotCmd = updateUpdateLotCmd;
	exports.resetUpdateLotCmd = resetUpdateLotCmd;
	exports.updateReferencePatrimonyContactCmd = updateReferencePatrimonyContactCmd;
	exports.updateLinkPatrimonyContactWithCmd = updateLinkPatrimonyContactWithCmd;
	exports.updateUpdatePatrimonyContactIdentityCmd = updateUpdatePatrimonyContactIdentityCmd;
	exports.updateMinorCriteria = updateMinorCriteria;
	exports.resetMinorCriteria = resetMinorCriteria;
	exports.updateMinorContactCriteria = updateMinorContactCriteria;
	exports.resetMinorContactCriteria = resetMinorContactCriteria;
	exports.resetReferenceUserCmd = resetReferenceUserCmd;
	exports.updateReferenceUserCmd = updateReferenceUserCmd;
	exports.sendReferenceUserCmd = sendReferenceUserCmd;
	exports.sendLinkPatrimonyContactWithUser = sendLinkPatrimonyContactWithUser;
	exports.sendUpdateLoginCmd = sendUpdateLoginCmd;
	exports.sendShouldCreateUser = sendShouldCreateUser;
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _links = __webpack_require__(33);
	
	var _actions = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NAMESPACE = 'Patrimony';
	var MINOR_CRITERIA_RESETTED = exports.MINOR_CRITERIA_RESETTED = NAMESPACE + '/MinorCriteriaResetted';
	var MINOR_CONTACT_CRITERIA_RESET = exports.MINOR_CONTACT_CRITERIA_RESET = NAMESPACE + '/MinorContactCriteriaReset';
	var LINKS_LOADED = exports.LINKS_LOADED = NAMESPACE + '/LinksLoaded';
	var PATRIMONY_STREAM_LOADED = exports.PATRIMONY_STREAM_LOADED = NAMESPACE + '/PatrimonyStreamLoaded';
	var PATRIMONY_STREAM_QUERIED = exports.PATRIMONY_STREAM_QUERIED = NAMESPACE + '/PatrimonyStreamQueried';
	var PATRIMONY_LOADED = exports.PATRIMONY_LOADED = NAMESPACE + '/PatrimonyLoaded';
	var LOT_STREAM_LOADED = exports.LOT_STREAM_LOADED = NAMESPACE + '/LotStreamLoaded';
	var LOT_LOADED = exports.LOT_LOADED = NAMESPACE + '/LotLoaded';
	var BUILDING_LOADED = exports.BUILDING_LOADED = NAMESPACE + '/BuildingLoaded';
	var CONTACT_LINKS_LOADED = exports.CONTACT_LINKS_LOADED = NAMESPACE + '/ContactLinksLoaded';
	var CONTACT_STREAM_LOADED = exports.CONTACT_STREAM_LOADED = NAMESPACE + '/ContactStreamLoaded';
	var CONTACT_STREAM_QUERIED = exports.CONTACT_STREAM_QUERIED = NAMESPACE + '/ContactStreamQueried';
	var CONTACT_LOADED = exports.CONTACT_LOADED = NAMESPACE + '/ContactLoaded';
	var MINOR_CONTACT_STREAM_LOADED = exports.MINOR_CONTACT_STREAM_LOADED = NAMESPACE + '/MinorContactStreamLoaded';
	var MINOR_CONTACT_STREAM_QUERIED = exports.MINOR_CONTACT_STREAM_QUERIED = NAMESPACE + '/MinorContactStreamQueried';
	var REFERENCE_PATRIMONY_CMD_SENT = exports.REFERENCE_PATRIMONY_CMD_SENT = NAMESPACE + '/ReferencePatrimonyCmdSent';
	var REFERENCE_LOT_CMD_SENT = exports.REFERENCE_LOT_CMD_SENT = NAMESPACE + '/ReferenceLotCmdSent';
	var REFERENCE_BUILDING_CMDS_SENT = exports.REFERENCE_BUILDING_CMDS_SENT = NAMESPACE + '/ReferenceBuildingCmdsSent';
	var REFERENCE_PATRIMONY_CONTACT_CMD_SENT = exports.REFERENCE_PATRIMONY_CONTACT_CMD_SENT = NAMESPACE + '/ReferencePatrimonyContactCmdSent';
	var UPDATE_PATRIMONY_CMD_SENT = exports.UPDATE_PATRIMONY_CMD_SENT = NAMESPACE + '/UpdatePatrimonyCmdSent';
	var UPDATE_LOT_CMD_SENT = exports.UPDATE_LOT_CMD_SENT = NAMESPACE + '/UpdateLotCmdSent';
	var UPDATE_LOT_CMD_RESET = exports.UPDATE_LOT_CMD_RESET = NAMESPACE + '/UpdateLotCmdReset';
	var ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT = exports.ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT = NAMESPACE + '/AddComplementaryAddressToPatrimonyCmdSent';
	var REMOVE_COMPLEMENTARY_ADDRESS_FROM_PATRIMONY_CMD_SENT = exports.REMOVE_COMPLEMENTARY_ADDRESS_FROM_PATRIMONY_CMD_SENT = NAMESPACE + '/RemoveComplementaryAddressFromPatrimonyCmdSent';
	var ASSOCIATE_PATRIMONY_IN_AGENCY_CMD_SENT = exports.ASSOCIATE_PATRIMONY_IN_AGENCY_CMD_SENT = NAMESPACE + 'AssociatePatrimonyInAgencyCmdSent';
	var DISSOCIATE_PATRIMONY_FROM_AGENCY_CMD_SENT = exports.DISSOCIATE_PATRIMONY_FROM_AGENCY_CMD_SENT = NAMESPACE + 'DissociatePatrimonyFromAgencyCmdSent';
	var ADD_ADDRESS_TO_LOT_CMD_SENT = exports.ADD_ADDRESS_TO_LOT_CMD_SENT = NAMESPACE + '/AddAddressToLotCmdSent';
	var REMOVE_ADDRESS_FROM_LOT_CMD_SENT = exports.REMOVE_ADDRESS_FROM_LOT_CMD_SENT = NAMESPACE + '/RemoveAddressFromLotCmdSent';
	var DELETE_LOT_CMD_SENT = exports.DELETE_LOT_CMD_SENT = NAMESPACE + '/DeleteLotCmdSent';
	var LINK_PATRIMONY_CONTACT_WITH_CMD_SENT = exports.LINK_PATRIMONY_CONTACT_WITH_CMD_SENT = NAMESPACE + '/LinkPatrimonyContactWithCmdSent';
	var REMOVE_LINK_FROM_PATRIMONY_CONTACT_CMD_SENT = exports.REMOVE_LINK_FROM_PATRIMONY_CONTACT_CMD_SENT = NAMESPACE + '/RemoveLinkFromPatrimonyContactCmdSent';
	var UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT = exports.UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT = NAMESPACE + '/UpdatePatrimonyContactIdentityCmdSent';
	var ADD_CONTACT_CMD_SENT = exports.ADD_CONTACT_CMD_SENT = NAMESPACE + './AddContactCmdSent';
	var REMOVE_CONTACT_CMD_SENT = exports.REMOVE_CONTACT_CMD_SENT = NAMESPACE + './RemoveContactCmdSent';
	
	var REFERENCE_USER_CMD_SENT = exports.REFERENCE_USER_CMD_SENT = NAMESPACE + '/ReferenceUserCmdSent';
	var LINK_USER_CMD_SENT = exports.LINK_USER_CMD_SENT = NAMESPACE + '/LinkUserCmdSent';
	var UPDATE_USER_CMD_UPDATED = exports.UPDATE_USER_CMD_UPDATED = NAMESPACE + '/UpdateUserCmdUpdated';
	var UPDATE_USER_CMD_SENT = exports.UPDATE_USER_CMD_SENT = NAMESPACE + '/UpdateUserCmdSent';
	// form actions
	var CRITERIA_UPDATED = exports.CRITERIA_UPDATED = NAMESPACE + '/CriteriaUpdated';
	var MINOR_CRITERIA_UPDATED = exports.MINOR_CRITERIA_UPDATED = NAMESPACE + '/MinorCriteriaUpdated';
	var CONTACT_CRITERIA_UPDATED = exports.CONTACT_CRITERIA_UPDATED = NAMESPACE + '/ContactCriteriaUpdated';
	var MINOR_CONTACT_CRITERIA_UPDATED = exports.MINOR_CONTACT_CRITERIA_UPDATED = NAMESPACE + '/MinorContactCriteriaUpdated';
	var REFERENCE_PATRIMONY_CMD_UPDATED = exports.REFERENCE_PATRIMONY_CMD_UPDATED = NAMESPACE + '/ReferencePatrimonyCmdUpdated';
	var REFERENCE_LOT_CMD_UPDATED = exports.REFERENCE_LOT_CMD_UPDATED = NAMESPACE + '/ReferenceLotCmdUpdated';
	var REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED = exports.REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED = NAMESPACE + '/ReferencePatrimonyContactCmdUpdated';
	var UPDATE_PATRIMONY_CMD_UPDATED = exports.UPDATE_PATRIMONY_CMD_UPDATED = NAMESPACE + '/UpdatePatrimonyCmdUpdated';
	var UPDATE_LOT_CMD_UPDATED = exports.UPDATE_LOT_CMD_UPDATED = NAMESPACE + '/UpdateLotCmdUpdated';
	var ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED = exports.ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED = NAMESPACE + '/AddComplementaryAddressToPatrimonyCmdUpdated';
	var ADD_ADDRESS_TO_LOT_CMD_UPDATED = exports.ADD_ADDRESS_TO_LOT_CMD_UPDATED = NAMESPACE + '/AddAddressToLotCmdUpdated';
	var LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED = exports.LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED = NAMESPACE + '/LinkPatrimonyContactWithCmdUpdated';
	var UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED = exports.UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED = NAMESPACE + '/UpdatePatrimonyContactIdentityCmdUpdated';
	var ADD_CONTACT_CMD_UPDATED = exports.ADD_CONTACT_CMD_UPDATED = NAMESPACE + './AddContactCmdUpdated';
	
	var DISABLE_USER_CMD_SENT = exports.DISABLE_USER_CMD_SENT = 'User/DisableUserCmdSent';
	
	var DEFAULT_QUERY = exports.DEFAULT_QUERY = {
	    range: { offset: 0, limit: 19 }
	};
	
	var DEFAULT_PATRIMONY_QUERY = exports.DEFAULT_PATRIMONY_QUERY = _extends({}, DEFAULT_QUERY, {
	    fullText: null,
	    agencyUids: null,
	    companyUid: null,
	    zipCode: null,
	    placeId: null,
	    geoLocation: null
	});
	
	var DEFAULT_CONTACT_QUERY = exports.DEFAULT_CONTACT_QUERY = _extends({}, DEFAULT_QUERY, {
	    patrimonyUids: null,
	    lotUid: null
	});
	
	function loadLinks() {
	    var query = {
	        range: { offset: 0, limit: 0 }
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonies', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: LINKS_LOADED,
	            _links: json._links
	        };
	    }), LINKS_LOADED);
	}
	
	function queryPatrimonyStream(patrimonyQuery) {
	    return loadPatrimonyStream(patrimonyQuery, PATRIMONY_STREAM_QUERIED);
	}
	
	function loadPatrimonyStream(patrimonyQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var query = state.patrimony.query;
	
	
	        patrimonyQuery = _extends({}, DEFAULT_PATRIMONY_QUERY, query, patrimonyQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonies', patrimonyQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	            var headers = _ref2.headers,
	                json = _ref2.json;
	
	            return {
	                type: action || PATRIMONY_STREAM_LOADED,
	                range: headers.contentRange,
	                stream: json.result,
	                aggregations: json.aggregations,
	                _links: json._links,
	                query: patrimonyQuery
	            };
	        });
	    }, action || PATRIMONY_STREAM_LOADED);
	}
	
	function loadPatrimony(id) {
	    return (0, _loading2.default)(function (state) {
	        var patrimony = state.patrimony.patrimony;
	
	        var _appLinks = state.app._links;
	        id = id || patrimony && patrimony.uid;
	
	        var buildingsQuery = {
	            range: { offset: 0, limit: 0 }
	        };
	
	        var lotsQuery = {
	            range: { offset: 0, limit: 0 },
	            patrimonyUid: id
	        };
	
	        var contactsQuery = {
	            range: { offset: 0, limit: 0 },
	            patrimonyUids: id
	        };
	
	        var patrimonyPromise = fetch(_config2.default.api.url + '/patrimonies/' + id, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var buildingsPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonies/' + id + '/buildings', buildingsQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var lotsPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/lots', lotsQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var contactsPromise = _appLinks.find((0, _links.linkFinder)('patrimonycontacts')) && fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonycontacts', contactsQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	
	        return Promise.all([patrimonyPromise, buildingsPromise, lotsPromise, contactsPromise]).then(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 4),
	                patrimonyResponse = _ref4[0],
	                buildingsResponse = _ref4[1],
	                lotsResponse = _ref4[2],
	                contactsResponse = _ref4[3];
	
	            return {
	                type: PATRIMONY_LOADED,
	                patrimony: patrimonyResponse.json,
	                patrimonyBuildings: {
	                    count: buildingsResponse.headers.contentRange.count,
	                    _links: buildingsResponse.json._links
	                },
	                patrimonyLots: {
	                    count: lotsResponse.headers.contentRange.count,
	                    _links: lotsResponse.json._links
	                },
	                patrimonyContacts: contactsResponse && {
	                    count: contactsResponse.headers && contactsResponse.headers.contentRange ? contactsResponse.headers.contentRange.count : 0,
	                    _links: contactsResponse.json && contactsResponse.json._links ? contactsResponse.json._links : []
	                } || {}
	            };
	        });
	    }, PATRIMONY_LOADED);
	}
	
	function loadLotAndBuildingStream(patrimonyId) {
	    return (0, _loading2.default)(function (state) {
	        var patrimony = state.patrimony.patrimony;
	
	        patrimonyId = patrimonyId || patrimony && patrimony.uid;
	
	        var lotsQuery = {
	            patrimonyUid: patrimonyId
	        };
	
	        var lotsPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/lots', lotsQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var buildingsPromise = fetch(_config2.default.api.url + '/patrimonies/' + patrimonyId + '/buildings', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	
	        return Promise.all([lotsPromise, buildingsPromise]).then(function (_ref5) {
	            var _ref6 = _slicedToArray(_ref5, 2),
	                lotsResponse = _ref6[0],
	                buildingsResponse = _ref6[1];
	
	            return {
	                type: LOT_STREAM_LOADED,
	                lot: {
	                    stream: lotsResponse.json.result
	                },
	                building: {
	                    stream: buildingsResponse.json.result
	                }
	            };
	        });
	    }, LOT_STREAM_LOADED);
	}
	
	function loadLotStream(patrimonyId, buildingId) {
	    return (0, _loading2.default)(function (state) {
	        var building = state.patrimony.building.building;
	
	        patrimonyId = patrimonyId || building && building.patrimony.uid;
	        buildingId = buildingId || building && building.uid;
	
	        var query = {
	            patrimonyUid: patrimonyId,
	            buildingUids: buildingId
	        };
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/lots', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref7) {
	            var json = _ref7.json;
	
	            return {
	                type: LOT_STREAM_LOADED,
	                lot: {
	                    stream: json.result
	                },
	                building: {
	                    stream: []
	                }
	            };
	        });
	    }, LOT_STREAM_LOADED);
	}
	
	function loadLot(id) {
	    return (0, _loading2.default)(function (state) {
	        var lot = state.patrimony.lot.lot;
	
	        id = id || lot && lot.uid;
	
	        var contactsQuery = {
	            range: { offset: 0, limit: 0 },
	            lotUid: id
	        };
	
	        var lotPromise = fetch(_config2.default.api.url + '/lots/' + id, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var contactsPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonycontacts', contactsQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	
	        return Promise.all([lotPromise, contactsPromise]).then(function (_ref8) {
	            var _ref9 = _slicedToArray(_ref8, 2),
	                lotResponse = _ref9[0],
	                contactsResponse = _ref9[1];
	
	            return {
	                type: LOT_LOADED,
	                lot: lotResponse.json,
	                lotContacts: {
	                    count: contactsResponse.headers.contentRange.count,
	                    _links: contactsResponse.json._links
	                }
	            };
	        });
	    }, LOT_LOADED);
	}
	
	function loadBuilding(patrimonyId, buildingId) {
	    return (0, _loading2.default)(function (state) {
	        var patrimony = state.patrimony.patrimony;
	        var building = state.patrimony.building.building;
	
	        patrimonyId = patrimonyId || patrimony && patrimony.uid;
	        buildingId = buildingId || building && building.uid;
	
	        var lotsQuery = {
	            range: { offset: 0, limit: 0 },
	            patrimonyUid: patrimonyId,
	            buildingUids: buildingId
	        };
	
	        var buildingPromise = fetch(_config2.default.api.url + '/patrimonies/' + patrimonyId + '/buildings/' + buildingId, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	        var lotsPromise = fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/lots', lotsQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	
	        return Promise.all([buildingPromise, lotsPromise]).then(function (_ref10) {
	            var _ref11 = _slicedToArray(_ref10, 2),
	                buildingResponse = _ref11[0],
	                lotsResponse = _ref11[1];
	
	            return {
	                type: BUILDING_LOADED,
	                building: buildingResponse.json,
	                buildingLots: {
	                    count: lotsResponse.headers.contentRange.count,
	                    _links: lotsResponse.json._links
	                }
	            };
	        });
	    }, BUILDING_LOADED);
	}
	
	function loadContactLinks() {
	    var query = {
	        range: { offset: 0, limit: 0 }
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonycontacts', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref12) {
	        var json = _ref12.json;
	
	        return {
	            type: CONTACT_LINKS_LOADED,
	            _links: json._links
	        };
	    }), CONTACT_LINKS_LOADED);
	}
	
	function queryContactStream(contactQuery) {
	    return loadContactStream(contactQuery, CONTACT_STREAM_QUERIED);
	}
	
	function loadContactStream(contactQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var query = state.patrimony.contact.query;
	
	
	        contactQuery = _extends({}, DEFAULT_CONTACT_QUERY, query, contactQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonycontacts', contactQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref13) {
	            var headers = _ref13.headers,
	                json = _ref13.json;
	
	            return {
	                type: action || CONTACT_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                _links: json._links,
	                query: contactQuery
	            };
	        });
	    }, action || CONTACT_STREAM_LOADED);
	}
	
	function queryMinorContactStream(contactQuery) {
	    return loadMinorContactStream(contactQuery, MINOR_CONTACT_STREAM_QUERIED);
	}
	
	function loadMinorContactStream(contactQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var minorQuery = state.patrimony.contact.minorQuery;
	
	
	        contactQuery = _extends({}, DEFAULT_CONTACT_QUERY, minorQuery, contactQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonycontacts', contactQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref14) {
	            var headers = _ref14.headers,
	                json = _ref14.json;
	
	            return {
	                type: action || MINOR_CONTACT_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                query: contactQuery
	            };
	        });
	    }, action || MINOR_CONTACT_STREAM_LOADED);
	}
	
	function loadContact(id) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.patrimony.contact.contact;
	
	        id = id || contact && contact.uid;
	
	        return fetch(_config2.default.api.url + '/patrimonycontacts/' + id, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref15) {
	            var json = _ref15.json;
	
	            return {
	                type: CONTACT_LOADED,
	                contact: json
	            };
	        });
	    }, CONTACT_LOADED);
	}
	
	function sendReferencePatrimonyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var referencePatrimonyCmd = state.patrimony.referencePatrimonyCmd;
	
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'ReferencePatrimony'
	            }, referencePatrimonyCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonies', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REFERENCE_PATRIMONY_CMD_SENT
	            };
	        });
	    }, REFERENCE_PATRIMONY_CMD_SENT);
	}
	
	function sendReferenceBuildingCmds(addresses) {
	    return (0, _loading2.default)(function (state) {
	        var patrimony = state.patrimony.patrimony;
	
	
	        var promises = addresses.map(function (address) {
	            if (address.building && address.building.label && !address.building.uid) {
	                var option = {
	                    method: 'PATCH',
	                    body: {
	                        processUid: _nodeUuid2.default.v4(),
	                        commandType: 'ReferenceBuilding',
	                        label: address.building.label
	                    }
	                };
	
	                return fetch(_config2.default.api.event.url + '/patrimonies/' + patrimony.uid, (0, _fetchz.apiOption)(option)).then(function (response) {
	                    return (0, _fetchz.apiResponse)(response, { status: [400] });
	                }).then(function (_ref16) {
	                    var response = _ref16.response,
	                        json = _ref16.json;
	
	                    var buildingId;
	                    if (response.status == 200) {
	                        buildingId = json.events.find(function (e) {
	                            return e.eventType == 'BuildingReferenced';
	                        }).buildingUid;
	                    } else {
	                        buildingId = json.buildingUid;
	                    }
	                    return _extends({}, address, { building: _extends({}, address.building, { uid: buildingId }) });
	                });
	            } else {
	                return address;
	            }
	        });
	
	        return Promise.all(promises).then(function (addresses) {
	            return {
	                type: REFERENCE_BUILDING_CMDS_SENT,
	                addresses: addresses
	            };
	        });
	    }, REFERENCE_BUILDING_CMDS_SENT);
	}
	
	function sendReferenceLotCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$patrimony = state.patrimony,
	            referenceLotCmd = _state$patrimony.referenceLotCmd,
	            patrimony = _state$patrimony.patrimony;
	
	        // API expects a building UID 
	
	        var addresses = referenceLotCmd.addresses.map(function (address) {
	            if (address.building) {
	                return _extends({}, address, { building: address.building.uid });
	            } else {
	                return address;
	            }
	        });
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'ReferenceLot',
	                patrimonyUid: patrimony.uid
	            }, referenceLotCmd, {
	                addresses: addresses
	            })
	        };
	
	        return fetch(_config2.default.api.event.url + '/lots', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REFERENCE_LOT_CMD_SENT
	            };
	        });
	    }, REFERENCE_LOT_CMD_SENT);
	}
	
	function sendReferencePatrimonyContactCmd() {
	    return (0, _loading2.default)(function (state) {
	        var referencePatrimonyContactCmd = state.patrimony.referencePatrimonyContactCmd;
	
	        var namez = referencePatrimonyContactCmd.namez,
	            linkedWithEntities = referencePatrimonyContactCmd.linkedWithEntities,
	            linkedWithPatrimonyAsHomeOwnerAssociation = referencePatrimonyContactCmd.linkedWithPatrimonyAsHomeOwnerAssociation,
	            cmd = _objectWithoutProperties(referencePatrimonyContactCmd, ['namez', 'linkedWithEntities', 'linkedWithPatrimonyAsHomeOwnerAssociation']);
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                name: _extends({}, namez, {
	                    nameType: 'CivilName'
	                }),
	                linkedWithEntities: [linkedWithEntities, linkedWithPatrimonyAsHomeOwnerAssociation].filter(function (v) {
	                    return v;
	                })
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonycontacts', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref17) {
	            var json = _ref17.json;
	            var events = json.events;
	
	            return {
	                type: REFERENCE_PATRIMONY_CONTACT_CMD_SENT,
	                contactUid: events.find(function (e) {
	                    return e.eventType === 'PatrimonyContactReferenced';
	                }).aggregateUid,
	                name: _extends({}, namez, {
	                    nameType: 'CivilName'
	                })
	            };
	        });
	    }, REFERENCE_PATRIMONY_CONTACT_CMD_SENT);
	}
	
	function sendUpdatePatrimonyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$patrimony2 = state.patrimony,
	            updatePatrimonyCmd = _state$patrimony2.updatePatrimonyCmd,
	            patrimony = _state$patrimony2.patrimony;
	
	        var patrimonyId = patrimony.uid;
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'UpdatePatrimony',
	                comment: 'Reference or Label Updated'
	            }, updatePatrimonyCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonies/' + patrimonyId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_PATRIMONY_CMD_SENT
	            };
	        });
	    }, UPDATE_PATRIMONY_CMD_SENT);
	}
	
	function sendUpdateLotCmd() {
	    return (0, _loading2.default)(function (state) {
	        var updateLotCmd = state.patrimony.updateLotCmd;
	        var lot = state.patrimony.lot.lot;
	
	        var lotId = lot.uid;
	        var lotNumber = updateLotCmd.lotNumber,
	            ref = updateLotCmd.ref,
	            usage = updateLotCmd.usage;
	
	
	        var option = function option(cmdName, cmd) {
	            return {
	                method: 'PATCH',
	                body: _extends({
	                    processUid: _nodeUuid2.default.v4(),
	                    commandType: cmdName
	                }, cmd)
	            };
	        };
	
	        return Promise.all([lotNumber && fetch(_config2.default.api.event.url + '/lots/' + lotId, (0, _fetchz.apiOption)(option('UpdateLotNumber', { lotNumber: lotNumber }))).then(_fetchz.errorResponse), ref && fetch(_config2.default.api.event.url + '/lots/' + lotId, (0, _fetchz.apiOption)(option('UpdateLotReference', { ref: ref }))).then(_fetchz.errorResponse), usage && fetch(_config2.default.api.event.url + '/lots/' + lotId, (0, _fetchz.apiOption)(option('UpdateLotUsage', { usage: usage }))).then(_fetchz.errorResponse)]).then(function () {
	            return {
	                type: UPDATE_LOT_CMD_SENT
	            };
	        });
	    }, UPDATE_LOT_CMD_SENT);
	}
	
	function sendAddComplementaryAddressToPatrimonyCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$patrimony3 = state.patrimony,
	            addComplementaryAddressToPatrimonyCmd = _state$patrimony3.addComplementaryAddressToPatrimonyCmd,
	            patrimony = _state$patrimony3.patrimony;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AddComplementaryAddressToPatrimony'
	            }, addComplementaryAddressToPatrimonyCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonies/' + patrimony.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT
	            };
	        });
	    }, ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT);
	}
	
	function sendRemoveComplementaryAddressFromPatrimonyCmd(addressId) {
	    return (0, _loading2.default)(function (state) {
	        var patrimony = state.patrimony.patrimony;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'RemoveComplementaryAddressFromPatrimony',
	                addressUid: addressId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonies/' + patrimony.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_COMPLEMENTARY_ADDRESS_FROM_PATRIMONY_CMD_SENT
	            };
	        });
	    }, REMOVE_COMPLEMENTARY_ADDRESS_FROM_PATRIMONY_CMD_SENT);
	}
	
	function sendAssociatePatrimonyInAgencyCmd(agencyId) {
	    return (0, _loading2.default)(function (state) {
	        var patrimony = state.patrimony.patrimony;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AssociatePatrimonyInAgency',
	                agencyUid: agencyId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonies/' + patrimony.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ASSOCIATE_PATRIMONY_IN_AGENCY_CMD_SENT
	            };
	        });
	    }, ASSOCIATE_PATRIMONY_IN_AGENCY_CMD_SENT);
	}
	
	function sendDissociatePatrimonyFromAgencyCmd(agencyId) {
	    return (0, _loading2.default)(function (state) {
	        var patrimony = state.patrimony.patrimony;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'DissociatePatrimonyFromAgency',
	                agencyUid: agencyId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonies/' + patrimony.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DISSOCIATE_PATRIMONY_FROM_AGENCY_CMD_SENT
	            };
	        });
	    }, DISSOCIATE_PATRIMONY_FROM_AGENCY_CMD_SENT);
	}
	
	function sendAddAddressToLotCmd() {
	    return (0, _loading2.default)(function (state) {
	        var addAddressToLotCmd = state.patrimony.addAddressToLotCmd;
	        var lot = state.patrimony.lot.lot;
	
	        var address = addAddressToLotCmd.address,
	            cmd = _objectWithoutProperties(addAddressToLotCmd, ['address']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AddAddressToLot',
	                address: address.building && _extends({}, address, { building: address.building.uid }) || address
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/lots/' + lot.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_ADDRESS_TO_LOT_CMD_SENT
	            };
	        });
	    }, ADD_ADDRESS_TO_LOT_CMD_SENT);
	}
	
	function sendRemoveAddressFromLotCmd(addressId) {
	    return (0, _loading2.default)(function (state) {
	        var lot = state.patrimony.lot.lot;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'RemoveAddressFromLot',
	                addressUid: addressId
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/lots/' + lot.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_ADDRESS_FROM_LOT_CMD_SENT
	            };
	        });
	    }, REMOVE_ADDRESS_FROM_LOT_CMD_SENT);
	}
	
	function sendDeleteLotCmd(lotId) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'DeleteLot'
	        }
	    };
	
	    return (0, _loading2.default)(fetch(_config2.default.api.event.url + '/lots/' + lotId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: DELETE_LOT_CMD_SENT
	        };
	    }), DELETE_LOT_CMD_SENT);
	}
	
	function sendLinkPatrimonyContactWithCmd(contactId) {
	    return (0, _loading2.default)(function (state) {
	        var linkPatrimonyContactWithCmd = state.patrimony.linkPatrimonyContactWithCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'LinkPatrimonyContactWith'
	            }, linkPatrimonyContactWithCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonycontacts/' + contactId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: LINK_PATRIMONY_CONTACT_WITH_CMD_SENT
	            };
	        });
	    }, LINK_PATRIMONY_CONTACT_WITH_CMD_SENT);
	}
	
	function sendRemoveLinkFromPatrimonyContactCmd(linkedWith) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.patrimony.contact.contact;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'RemoveLinkFromPatrimonyContact',
	                linkedWith: toLinkedWithCmd(linkedWith)
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonycontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_LINK_FROM_PATRIMONY_CONTACT_CMD_SENT
	            };
	        });
	    }, REMOVE_LINK_FROM_PATRIMONY_CONTACT_CMD_SENT);
	}
	
	function sendUpdatePatrimonyContactIdentityCmd() {
	    return (0, _loading2.default)(function (state) {
	        var updatePatrimonyContactIdentityCmd = state.patrimony.updatePatrimonyContactIdentityCmd;
	        var contact = state.patrimony.contact.contact;
	
	        var namez = updatePatrimonyContactIdentityCmd.namez,
	            cmd = _objectWithoutProperties(updatePatrimonyContactIdentityCmd, ['namez']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'UpdatePatrimonyContactIdentity',
	                name: _extends({}, namez, {
	                    nameType: 'CivilName'
	                })
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonycontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT
	            };
	        });
	    }, UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT);
	}
	
	function sendAddContactCmd() {
	    return (0, _loading2.default)(function (state) {
	        var addContactCmd = state.patrimony.addContactCmd;
	        var contact = state.patrimony.contact.contact;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AddContact'
	            }, addContactCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonycontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_CONTACT_CMD_SENT
	            };
	        });
	    }, ADD_CONTACT_CMD_SENT);
	}
	
	function sendRemoveContactCmd(medium) {
	    return (0, _loading2.default)(function (state) {
	        var contact = state.patrimony.contact.contact;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                contact: medium,
	                commandType: 'RemoveContact'
	            }
	        };
	
	        return fetch(_config2.default.api.event.url + '/patrimonycontacts/' + contact.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_CONTACT_CMD_SENT
	            };
	        });
	    }, REMOVE_CONTACT_CMD_SENT);
	}
	
	function updateReferenceLotCmd(cmd) {
	    return {
	        type: REFERENCE_LOT_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateAddAddressToLotCmd(cmd) {
	    return {
	        type: ADD_ADDRESS_TO_LOT_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateUpdateLotCmd(cmd) {
	    return {
	        type: UPDATE_LOT_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function resetUpdateLotCmd() {
	    return {
	        type: UPDATE_LOT_CMD_RESET
	    };
	}
	
	function updateReferencePatrimonyContactCmd(cmd) {
	    return {
	        type: REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateLinkPatrimonyContactWithCmd(cmd) {
	    return {
	        type: LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateUpdatePatrimonyContactIdentityCmd(cmd) {
	    return {
	        type: UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateMinorCriteria(minorCriteria) {
	    return {
	        type: MINOR_CRITERIA_UPDATED,
	        minorCriteria: minorCriteria
	    };
	}
	
	function resetMinorCriteria() {
	    return {
	        type: MINOR_CRITERIA_RESETTED
	    };
	}
	
	function updateMinorContactCriteria(minorCriteria) {
	    return {
	        type: MINOR_CONTACT_CRITERIA_UPDATED,
	        minorCriteria: minorCriteria
	    };
	}
	
	function resetMinorContactCriteria() {
	    var minorCriteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return {
	        type: MINOR_CONTACT_CRITERIA_RESET,
	        minorCriteria: minorCriteria
	    };
	}
	
	function toLinkedWithCmd(linkedWith) {
	    var patrimony = linkedWith.patrimony,
	        lot = linkedWith.lot,
	        linkedWithCmd = _objectWithoutProperties(linkedWith, ['patrimony', 'lot']);
	
	    return _extends({}, linkedWithCmd, {
	        patrimonyUid: patrimony && patrimony.uid,
	        lotUid: lot && lot.uid
	    });
	}
	
	/*export const getPatrimonyUserState = (contact) => {
	    return contact.patrimonyUserState.stateType
	}*/
	
	var getPatrimonyUserState = exports.getPatrimonyUserState = function getPatrimonyUserState(contact) {
	    if (contact._links.find((0, _links.linkFinder)(['CreatePatrimonyUser', 'LinkPatrimonyContactToUser']))) return 'NoAccount';else if (contact._links.find((0, _links.linkFinder)(['DisableUser']))) return 'ActiveAccount';else if (contact._links.find((0, _links.linkFinder)(['UpdateLogin']))) return 'NotActiveAccount';else return contact.patrimonyUserState.stateType;
	};
	
	var getCommandType = function getCommandType(contact) {
	    return {
	        NoAccount: 'ReferencePatrimonyUser',
	        NotActiveAccount: 'UpdateLogin',
	        ActiveAccount: 'ActiveUser'
	    }[getPatrimonyUserState(contact)];
	};
	
	var toName = function toName(name) {
	    var firstName = name.firstName,
	        lastName = name.lastName,
	        value = name.value;
	
	    return name.nameType === 'CivilName' ? { firstName: firstName, lastName: lastName } : { lastName: value };
	};
	
	var toUpdateUserCmdUpdated = function toUpdateUserCmdUpdated(contact) {
	    return _extends({
	        login: getLogin(contact)
	    }, toName(contact.name), {
	        phone: getPhone(contact),
	        contactUid: contact.uid
	    });
	};
	var getContactInfo = function getContactInfo(contactInfoType, map) {
	    return function (contact) {
	        var contactInfo = contact.contacts.filter(function (c) {
	            return c.contactInfoType === contactInfoType;
	        })[0];
	        return contactInfo ? map(contactInfo) : null;
	    };
	};
	
	var getPhone = exports.getPhone = getContactInfo('Phone', function (c) {
	    return c.phone;
	});
	var getLogin = exports.getLogin = function getLogin(contact) {
	    if (contact.patrimonyUserState.login) {
	        return contact.patrimonyUserState.login;
	    }
	    return getContactInfo('Mail', function (c) {
	        return c.mail;
	    })(contact);
	};
	
	function resetReferenceUserCmd() {
	    return {
	        type: UPDATE_USER_CMD_UPDATED
	    };
	}
	
	function updateReferenceUserCmd(show, patrimonyContact) {
	    return {
	        type: UPDATE_USER_CMD_UPDATED,
	        cmd: show ? _extends({}, toUpdateUserCmdUpdated(patrimonyContact), {
	            commandType: getCommandType(patrimonyContact)
	        }) : null
	    };
	}
	
	function sendReferenceUserCmd(login) {
	    return (0, _loading2.default)(function (state) {
	        var _state$patrimony4 = state.patrimony,
	            updateUserCmd = _state$patrimony4.updateUserCmd,
	            patrimony = _state$patrimony4.patrimony;
	        var patrimonyUid = patrimony.uid;
	        var loginCmd = updateUserCmd.login;
	
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4()
	            }, updateUserCmd, {
	                login: login ? login : loginCmd,
	                patrimonies: [patrimonyUid]
	            })
	        };
	
	        return fetch(_config2.default.api.event.url + '/users', (0, _fetchz.apiOption)(option)).then(function (r) {
	            return (0, _fetchz.apiResponse)(r, { status: [400] });
	        }).then(function (_ref18) {
	            var response = _ref18.response,
	                headers = _ref18.headers,
	                json = _ref18.json;
	            var status = response.status;
	
	            return {
	                type: REFERENCE_USER_CMD_SENT,
	                userUid: json.events ? json.events.find(function (e) {
	                    return e.eventType === 'PatrimonyUserReferenced';
	                }).aggregateUid : json.uid,
	                errorType: status === 400 ? json.errorType : null,
	                status: status
	            };
	        });
	    }, REFERENCE_USER_CMD_SENT);
	}
	
	function sendLinkPatrimonyContactWithUser(patrimonyUid, contactUid) {
	    return (0, _loading2.default)(function (state) {
	        var updateUserCmd = state.patrimony.updateUserCmd;
	        var userUid = updateUserCmd.userUid,
	            login = updateUserCmd.login,
	            contactUidCommand = updateUserCmd.contactUid;
	
	
	        contactUid = contactUid ? contactUid : contactUidCommand;
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                processUid: _nodeUuid2.default.v4(),
	                userUid: userUid,
	                commandType: 'LinkPatrimonyContactWithUser'
	            }
	        };
	
	        return Promise.all([fetch(_config2.default.api.event.url + '/patrimonycontacts/' + contactUid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse), (0, _actions.sendAssociateUserWithPatrimonyCmd)(userUid, patrimonyUid)]).then(function () {
	            return {
	                type: LINK_USER_CMD_SENT,
	                status: status,
	                contactUid: contactUid,
	                userUid: userUid,
	                login: login
	            };
	        });
	    }, LINK_USER_CMD_SENT);
	}
	
	function sendUpdateLoginCmd(uid, login) {
	    var option = {
	        method: 'PATCH',
	        body: {
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'UpdateLogin',
	            login: login
	        }
	    };
	
	    return fetch(_config2.default.api.event.url + '/users/' + uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return { type: UPDATE_USER_CMD_SENT };
	    });
	}
	
	function sendShouldCreateUser(shouldCreateUser) {
	    return {
	        type: REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED,
	        cmd: { shouldCreateUser: shouldCreateUser }
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(311);
	var $export = __webpack_require__(3);
	var shared = __webpack_require__(134)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(315))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(28)) {
	  var LIBRARY = __webpack_require__(83);
	  var global = __webpack_require__(16);
	  var fails = __webpack_require__(18);
	  var $export = __webpack_require__(3);
	  var $typed = __webpack_require__(166);
	  var $buffer = __webpack_require__(226);
	  var ctx = __webpack_require__(61);
	  var anInstance = __webpack_require__(92);
	  var propertyDesc = __webpack_require__(97);
	  var hide = __webpack_require__(43);
	  var redefineAll = __webpack_require__(98);
	  var toInteger = __webpack_require__(63);
	  var toLength = __webpack_require__(27);
	  var toIndex = __webpack_require__(309);
	  var toAbsoluteIndex = __webpack_require__(100);
	  var toPrimitive = __webpack_require__(69);
	  var has = __webpack_require__(50);
	  var classof = __webpack_require__(114);
	  var isObject = __webpack_require__(19);
	  var toObject = __webpack_require__(32);
	  var isArrayIter = __webpack_require__(212);
	  var create = __webpack_require__(94);
	  var getPrototypeOf = __webpack_require__(52);
	  var gOPN = __webpack_require__(95).f;
	  var getIterFn = __webpack_require__(228);
	  var uid = __webpack_require__(101);
	  var wks = __webpack_require__(25);
	  var createArrayMethod = __webpack_require__(66);
	  var createArrayIncludes = __webpack_require__(154);
	  var speciesConstructor = __webpack_require__(135);
	  var ArrayIterators = __webpack_require__(229);
	  var Iterators = __webpack_require__(115);
	  var $iterDetect = __webpack_require__(159);
	  var setSpecies = __webpack_require__(99);
	  var arrayFill = __webpack_require__(204);
	  var arrayCopyWithin = __webpack_require__(281);
	  var $DP = __webpack_require__(30);
	  var $GOPD = __webpack_require__(51);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(182);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var translations = exports.translations = {
	    fr: {
	        moment: {
	            relativeTime: {
	                future: 'dans %s',
	                past: 'il y a %s',
	                s: '%d s',
	                m: '%d min',
	                mm: '%d mins',
	                h: '%d h',
	                hh: '%d h',
	                d: '%d j',
	                dd: '%d j',
	                M: '%d mois',
	                MM: '%d mois',
	                y: '%d an',
	                yy: '%d ans'
	            }
	        },
	        dateFormat: {
	            default: 'DD/MM/YYYY',
	            short: 'DD/MM/YY',
	            long: '[le] DD/MM/YYYY',
	            longer: 'dddd DD MMMM YYYY',
	            from: '[du] ddd DD MMM',
	            fromLonger: '[du] ddd DD MMM YYYY',
	            to: '[au] ddd DD MMM',
	            toLonger: '[au] ddd DD MMM YYYY',
	            file: 'YYYY-MM-DD'
	        },
	        timeFormat: {
	            default: 'HH[h]mm',
	            long: '[à] HH[h]mm',
	            from: '[de] HH[h]mm',
	            to: '[à] HH[h]mm'
	        },
	        dateTimeFormat: {
	            default: 'DD/MM/YYYY [à] HH[h]mm'
	        },
	        featureNotImplemented: 'Cette fonctionnalité n’est pas activée pour le moment',
	        formInvalid: 'Certains champs du formulaire n\'ont pas été remplis ou sont invalides. Merci de vérifier votre saisie.',
	        send: 'envoyer',
	        status: 'statut',
	        statusEnum: {
	            opened: 'en cours',
	            closed: 'cloturé'
	        },
	        currencyEnum: {
	            euro: '€'
	        },
	        description: 'description',
	        state: 'état',
	        city: 'ville',
	        date: 'date',
	        distance: 'distance',
	        distanceFromTo: 'de {from} à {to}',
	        from: 'du',
	        to: 'au',
	        search: 'recherche',
	        stats: 'statistiques',
	        address: 'adresse',
	        addresses: 'adresses',
	        address_es: 'adresse(s)',
	        addressNumber: 'numéro',
	        addressStreet: 'rue',
	        addressZipCode: 'code postal',
	        addressCity: 'ville',
	        addressBuilding: 'bâtiment',
	        addressEntrance: 'entrée',
	        addressElevator: 'ascenseur',
	        addressStaircase: 'escalier',
	        addressFloor: 'étage',
	        addressUnit: 'numéro',
	        addressDigicode: 'digicode',
	        contacts: 'contacts',
	        phone: 'tél',
	        fax: 'fax',
	        email: 'email',
	        firstName: 'prénom',
	        lastName: 'nom',
	        name: 'nom',
	        company: 'société',
	        reference: 'référence',
	        number: 'numéro',
	        title: 'titre',
	        label: 'label',
	        select: 'sélectionner ...',
	        comment: 'Commentaire interne non visible par le prestataire',
	        instructionsForAssignee: 'Instructions qui seront transmises au prestataire pour le bon déroulement de son intervention',
	        callReason: 'raison de l\'appel',
	        commentz: 'commenter',
	        change: 'modification',
	        save: 'sauvegarder',
	        next: 'suivant',
	        previous: 'précédent',
	        validate: 'valider',
	        add: 'ajouter',
	        update: 'modifier',
	        delete: 'supprimer',
	        remove: 'supprimer',
	        cancel: 'annuler',
	        close: 'fermer',
	        enable: 'activer',
	        disable: 'désactiver',
	        associate: 'associer',
	        dissociate: 'dissocier',
	        assign: 'associer',
	        unassign: 'dissocier',
	        schedule: 'programmer',
	        exportz: 'exporter',
	        upgrade: 'souscrire',
	        downgrade: 'révoquer',
	        corrected: 'édité',
	        text: 'texte',
	        configs: 'configuration',
	        poweredBy: 'Ce service vous est proposé par',
	        report: 'rapport',
	        selectAll: 'tout sélectionner',
	        unselectAll: 'tout désélectionner',
	        charge: 'tarif',
	        days: 'jours',
	        expired: 'expiré',
	        processed: 'traité',
	        by: 'par',
	        showMore: 'voir plus'
	    }
	};
	
	exports.default = translations.fr;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(788)
	var ieee754 = __webpack_require__(794)
	var isArray = __webpack_require__(333)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(25)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(43)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(101)('meta');
	var isObject = __webpack_require__(19);
	var has = __webpack_require__(50);
	var setDesc = __webpack_require__(30).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(18)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ServerError = exports.ForbiddenError = exports.UnauthorizedError = exports.NotFoundError = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.jsonOption = jsonOption;
	exports.cookieOption = cookieOption;
	exports.apiOption = apiOption;
	exports.apiUrl = apiUrl;
	exports.errorResponse = errorResponse;
	exports.headerResponse = headerResponse;
	exports.jsonResponse = jsonResponse;
	exports.apiResponse = apiResponse;
	exports.only = only;
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFoundError = exports.NotFoundError = function (_Error) {
	    _inherits(NotFoundError, _Error);
	
	    function NotFoundError(message, type, data) {
	        _classCallCheck(this, NotFoundError);
	
	        var _this = _possibleConstructorReturn(this, (NotFoundError.__proto__ || Object.getPrototypeOf(NotFoundError)).call(this, message));
	
	        _this.stack = new Error().stack;
	        _this.name = 'NotFoundError';
	        _this.message = message;
	        _this.statusCode = 404;
	        _this.type = type;
	        _this.data = data;
	        return _this;
	    }
	
	    return NotFoundError;
	}(Error);
	
	var UnauthorizedError = exports.UnauthorizedError = function (_Error2) {
	    _inherits(UnauthorizedError, _Error2);
	
	    function UnauthorizedError(message, type, data) {
	        _classCallCheck(this, UnauthorizedError);
	
	        var _this2 = _possibleConstructorReturn(this, (UnauthorizedError.__proto__ || Object.getPrototypeOf(UnauthorizedError)).call(this, message));
	
	        _this2.stack = new Error().stack;
	        _this2.name = 'UnauthorizedError';
	        _this2.message = message;
	        _this2.statusCode = 401;
	        _this2.type = type;
	        _this2.data = data;
	        return _this2;
	    }
	
	    return UnauthorizedError;
	}(Error);
	
	var ForbiddenError = exports.ForbiddenError = function (_Error3) {
	    _inherits(ForbiddenError, _Error3);
	
	    function ForbiddenError(message, type, data) {
	        _classCallCheck(this, ForbiddenError);
	
	        var _this3 = _possibleConstructorReturn(this, (ForbiddenError.__proto__ || Object.getPrototypeOf(ForbiddenError)).call(this, message));
	
	        _this3.stack = new Error().stack;
	        _this3.name = 'ForbiddenError';
	        _this3.message = message;
	        _this3.statusCode = 403;
	        _this3.type = type;
	        _this3.data = data;
	        return _this3;
	    }
	
	    return ForbiddenError;
	}(Error);
	
	var ServerError = exports.ServerError = function (_Error4) {
	    _inherits(ServerError, _Error4);
	
	    function ServerError(message, statusCode, type, data) {
	        _classCallCheck(this, ServerError);
	
	        var _this4 = _possibleConstructorReturn(this, (ServerError.__proto__ || Object.getPrototypeOf(ServerError)).call(this, message));
	
	        _this4.stack = new Error().stack;
	        _this4.name = 'ServerError';
	        _this4.message = message;
	        _this4.statusCode = statusCode;
	        _this4.type = type;
	        _this4.data = data;
	        return _this4;
	    }
	
	    return ServerError;
	}(Error);
	
	function jsonOption() {
	    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var defaultOption = {
	        method: 'post',
	        headers: {
	            'Accept': 'application/json',
	            'Content-Type': 'application/json'
	        }
	    };
	
	    return _extends({}, defaultOption, option, { body: JSON.stringify(option.body) });
	}
	
	function cookieOption() {
	    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var defaultOption = {
	        credentials: 'include'
	    };
	
	    return _extends({}, defaultOption, option);
	}
	
	function apiOption() {
	    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return cookieOption(option.body && jsonOption(option) || option);
	}
	
	function apiUrl(url) {
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    function stringify(value) {
	        if (value instanceof Date) return (0, _moment2.default)(value).format('YYYY-MM-DD');
	        return value;
	    }
	
	    function sanitize(value) {
	        if (value === 0 || value === false) return value;
	        return value || null;
	    }
	
	    var queryArray = Object.keys(query).reduce(function (result, key) {
	        var value = query[key];
	
	        if (value == null) {
	            value = [];
	        } else if (value instanceof Array) {
	            value = value.map(function (v) {
	                return sanitize(stringify((typeof v === 'undefined' ? 'undefined' : _typeof(v)) == 'object' && v.uid || v.value || v));
	            });
	        } else if (value instanceof Date) {
	            value = sanitize(stringify(value));
	            value = [value];
	        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
	            value = sanitize(Object.keys(value).map(function (k) {
	                return stringify(value[k]);
	            }).join(Object.keys(value).length == 2 && '-' || ','));
	            value = [value];
	        } else {
	            value = sanitize(value);
	            value = [value];
	        }
	
	        value.filter(function (value) {
	            return value != null;
	        }).forEach(function (value) {
	            result.push(key.toLowerCase() + '=' + encodeURIComponent(value));
	        });
	        return result;
	    }, []);
	
	    var queryString = queryArray.length > 0 && '?' + queryArray.join('&') || '';
	    return url + queryString;
	}
	
	function errorResponse(response) {
	    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (response.status >= 200 && response.status < 300) {
	        return response;
	    }
	
	    if (option.status && option.status.indexOf(response.status) >= 0) {
	        return response;
	    }
	
	    return getSafeJson(response).then(function (json) {
	        var statusText = response.statusText;
	        var statusCode = response.status;
	        var errorType = json && json.errorType;
	        var data = json && json.data;
	
	        switch (statusCode) {
	            case 401:
	                throw new UnauthorizedError(statusText, errorType, data);
	            case 403:
	                throw new ForbiddenError(statusText, errorType, data);
	            case 404:
	                throw new NotFoundError(statusText, errorType, data);
	            default:
	                throw new ServerError(statusText, statusCode, errorType, data);
	        }
	    });
	}
	
	function headerResponse(response) {
	    var contentRangeHeader = response.headers.get('Content-Range');
	    var header = {};
	
	    if (contentRangeHeader) {
	        var _contentRangeHeader$s = contentRangeHeader.split(/[-/]/),
	            _contentRangeHeader$s2 = _slicedToArray(_contentRangeHeader$s, 3),
	            offset = _contentRangeHeader$s2[0],
	            limit = _contentRangeHeader$s2[1],
	            count = _contentRangeHeader$s2[2];
	
	        header.contentRange = {
	            offset: parseInt(offset),
	            limit: parseInt(limit),
	            count: parseInt(count)
	        };
	    }
	
	    return header;
	}
	
	function jsonResponse(response) {
	    return getSafeJson(response);
	}
	
	function apiResponse(response, option) {
	    return Promise.resolve(errorResponse(response, option)).then(function (response) {
	        return Promise.all([headerResponse(response), jsonResponse(response)]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                headers = _ref2[0],
	                json = _ref2[1];
	
	            return { response: response, headers: headers, json: json };
	        });
	    });
	}
	
	function only(statusCodesOrTypes, callback) {
	    statusCodesOrTypes = statusCodesOrTypes instanceof Array && statusCodesOrTypes || [statusCodesOrTypes];
	
	    return function (error) {
	        if (statusCodesOrTypes.indexOf(error.statusCode) >= 0 || statusCodesOrTypes.indexOf(error.type) >= 0) return callback(error);
	        return Promise.reject(error);
	    };
	}
	
	function getSafeJson(response) {
	    var contentType = response.headers.get('Content-Type');
	    if (contentType && contentType.match(/application\/json/i)) {
	        return response.json();
	    }
	    return Promise.resolve({});
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ExcludeOpeningTicketPurposesFromInterventionPeriodCmd = exports.DefineInterventionTimelimitForInterventionPeriodCmd = exports.DefineRepairTimelimitForInterventionPeriodCmd = exports.DefineContactInfosForProviderCompanyCmd = exports.SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd = exports.DefineCallOutChargesForInterventionPeriodCmd = exports.DefineInterventionZoneForInterventionPeriodCmd = exports.DefineServiceChargeForInterventionPeriodCmd = exports.DefineUpdateInterventionPeriodForActivityCmd = exports.AssignActivityToProviderCompanyCmd = exports.AssociateProviderContactWithProviderCompanyCmd = exports.UpdateProviderContactCmd = exports.AddProviderContactCmd = exports.ReferenceProviderCompanyCmd = exports.Filter = exports.ContactCriteria = exports.ProviderCoverageCriteria = exports.ProviderCriteria = exports.InterventionPeriod = exports.CHARGE_TYPES = exports.TIME_SLOT_TYPES = exports.PERIOD_TYPES = exports.FOR_WHOS = exports.FOR_WHATS = exports.WEEK_DAYS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createValidator = createValidator;
	exports.resolveActivities = resolveActivities;
	
	var _jjv = __webpack_require__(172);
	
	var _jjv2 = _interopRequireDefault(_jjv);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _phonez = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WEEK_DAYS = exports.WEEK_DAYS = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
	var FOR_WHATS = exports.FOR_WHATS = ['RequestForQuotation', 'Urgency'];
	var FOR_WHOS = exports.FOR_WHOS = ['Individuals', 'Professionals'];
	var PERIOD_TYPES = exports.PERIOD_TYPES = ['DateTimePeriod', 'WeekDaysPeriod', 'SpecificDaysPeriod'];
	var TIME_SLOT_TYPES = exports.TIME_SLOT_TYPES = ['AllDayLong', 'HourPeriods'];
	var CHARGE_TYPES = exports.CHARGE_TYPES = ['FixChargeValue', 'ChargePercentage'];
	
	var InterventionPeriod = exports.InterventionPeriod = function InterventionPeriod() {
	    _classCallCheck(this, InterventionPeriod);
	};
	
	InterventionPeriod.isExpired = function (interventionPeriod) {
	    var now = new Date();
	
	    function lastDayReducer(result, day) {
	        var dayz = (0, _moment2.default)(day).toDate();
	        if (!result || dayz > result) {
	            result = dayz;
	        }
	        return result;
	    }
	
	    if (interventionPeriod.period.days) {
	        var lastDay = interventionPeriod.period.days.reduce(lastDayReducer, null);
	        if (lastDay < now) return true;
	    }
	
	    if (interventionPeriod.period.endDate) {
	        var endDate = (0, _moment2.default)(interventionPeriod.period.endDate).toDate();
	        if (endDate < now) return true;
	    }
	
	    return false;
	};
	
	function createValidator() {
	    var validator = (0, _jjv2.default)();
	
	    validator.addFormat('phone', _phonez.phoneFormat);
	    return validator;
	}
	
	function resolveActivities(ref, activities) {
	    ref = ref || [];
	
	    return activities.map(function (activity) {
	        return ref.find(function (a) {
	            return a.uid == activity.activityUid;
	        });
	    }).filter(function (a) {
	        return a;
	    });
	}
	
	var ProviderCriteria = exports.ProviderCriteria = function ProviderCriteria() {
	    _classCallCheck(this, ProviderCriteria);
	};
	
	ProviderCriteria.schema = {
	    type: 'object',
	    properties: {
	        fullText: { type: 'string' },
	        activityUid: { type: 'array' },
	        filtered: { type: 'boolean' }
	    }
	};
	
	var ProviderCoverageCriteria = exports.ProviderCoverageCriteria = function ProviderCoverageCriteria() {
	    _classCallCheck(this, ProviderCoverageCriteria);
	};
	
	ProviderCoverageCriteria.schema = {
	    type: 'object',
	    properties: {
	        zipCodes: { type: ['string', 'null'] },
	        department: { type: 'object' },
	        city: { type: 'object' },
	        activityUids: { type: 'array' }
	    },
	    required: ['activityUids']
	};
	
	var ContactCriteria = exports.ContactCriteria = function ContactCriteria() {
	    _classCallCheck(this, ContactCriteria);
	};
	
	ContactCriteria.schema = {
	    type: 'object',
	    properties: {
	        fullText: { type: 'string' }
	    }
	};
	
	var Filter = exports.Filter = function Filter() {
	    _classCallCheck(this, Filter);
	};
	
	Filter.schema = {
	    type: 'object',
	    properties: {
	        from: { type: 'date' },
	        to: { type: 'date' }
	    }
	};
	
	var ReferenceProviderCompanyCmd = exports.ReferenceProviderCompanyCmd = function ReferenceProviderCompanyCmd() {
	    _classCallCheck(this, ReferenceProviderCompanyCmd);
	};
	
	ReferenceProviderCompanyCmd.schema = {
	    type: 'object',
	    properties: {
	        label: { type: 'string' },
	        siretNumber: {
	            type: 'string',
	            pattern: '^[a-zA-Z0-9]{14}$'
	        }
	    },
	    required: ['label', 'siretNumber']
	};
	
	var AddProviderContactCmd = exports.AddProviderContactCmd = function AddProviderContactCmd() {
	    _classCallCheck(this, AddProviderContactCmd);
	};
	
	AddProviderContactCmd.schemaCache = (0, _cache2.default)();
	
	AddProviderContactCmd.schema = {
	    type: 'object',
	    properties: {
	        namez: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    firstName: { type: 'string' },
	                    lastName: { type: 'string' },
	                    gender: { type: ['string', 'null'] },
	                    nameType: {
	                        type: 'string',
	                        enum: ['CivilName']
	                    }
	                },
	                required: ['firstName', 'lastName', 'nameType']
	            }, {
	                type: 'object',
	                properties: {
	                    value: { type: 'string' },
	                    nameType: {
	                        type: 'string',
	                        enum: ['PoorName']
	                    }
	                },
	                required: ['value', 'nameType']
	            }]
	        },
	        emails: {
	            type: ['array', 'null'],
	            items: {
	                type: 'string',
	                format: 'email'
	            }
	        },
	        phones: {
	            type: ['array', 'null'],
	            items: {
	                type: 'string',
	                format: 'phone'
	            }
	        },
	        fax: {
	            type: ['array', 'null'],
	            items: {
	                type: 'string',
	                format: 'phone'
	            }
	        },
	        companyUid: { type: 'object' },
	        providerCompanyUid: { type: 'object' }
	    },
	    required: ['namez', 'companyUid', 'providerCompanyUid']
	};
	
	AddProviderContactCmd.selectSchema = function (cmd) {
	    var nameType = cmd && cmd.namez && cmd.namez.nameType || 'CivilName';
	
	    return AddProviderContactCmd.schemaCache(nameType, function () {
	        var namezSchema = AddProviderContactCmd.schema.properties.namez.oneOf.find(function (schema) {
	            return schema.properties.nameType.enum.indexOf(nameType) >= 0;
	        });
	
	        return _extends({}, AddProviderContactCmd.schema, {
	            properties: _extends({}, AddProviderContactCmd.schema.properties, {
	                namez: namezSchema
	            })
	        });
	    });
	};
	
	var UpdateProviderContactCmd = exports.UpdateProviderContactCmd = function UpdateProviderContactCmd() {
	    _classCallCheck(this, UpdateProviderContactCmd);
	};
	
	UpdateProviderContactCmd.schemaCache = (0, _cache2.default)();
	
	UpdateProviderContactCmd.schema = {
	    type: 'object',
	    properties: {
	        namez: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    firstName: { type: 'string' },
	                    lastName: { type: 'string' },
	                    gender: { type: ['string', 'null'] },
	                    nameType: {
	                        type: 'string',
	                        enum: ['CivilName']
	                    }
	                },
	                required: ['firstName', 'lastName', 'nameType']
	            }, {
	                type: 'object',
	                properties: {
	                    value: { type: 'string' },
	                    nameType: {
	                        type: 'string',
	                        enum: ['PoorName']
	                    }
	                },
	                required: ['value', 'nameType']
	            }]
	        },
	        emails: {
	            type: 'array',
	            items: {
	                type: 'string',
	                format: 'email'
	            }
	        },
	        phones: {
	            type: 'array',
	            items: {
	                type: 'string',
	                format: 'phone'
	            }
	        },
	        fax: {
	            type: 'array',
	            items: {
	                type: 'string',
	                format: 'phone'
	            }
	        }
	    },
	    required: ['namez']
	};
	
	UpdateProviderContactCmd.selectSchema = function (cmd) {
	    var nameType = cmd && cmd.namez && cmd.namez.nameType || 'CivilName';
	
	    return UpdateProviderContactCmd.schemaCache(nameType, function () {
	        var namezSchema = UpdateProviderContactCmd.schema.properties.namez.oneOf.find(function (schema) {
	            return schema.properties.nameType.enum.indexOf(nameType) >= 0;
	        });
	
	        return _extends({}, UpdateProviderContactCmd.schema, {
	            properties: _extends({}, UpdateProviderContactCmd.schema.properties, {
	                namez: namezSchema
	            })
	        });
	    });
	};
	
	var AssociateProviderContactWithProviderCompanyCmd = exports.AssociateProviderContactWithProviderCompanyCmd = function AssociateProviderContactWithProviderCompanyCmd() {
	    _classCallCheck(this, AssociateProviderContactWithProviderCompanyCmd);
	};
	
	AssociateProviderContactWithProviderCompanyCmd.schema = {
	    type: 'object',
	    properties: {
	        providerCompanyUid: { type: 'object' }
	    },
	    required: ['providerCompanyUid']
	};
	
	var AssignActivityToProviderCompanyCmd = exports.AssignActivityToProviderCompanyCmd = function AssignActivityToProviderCompanyCmd() {
	    _classCallCheck(this, AssignActivityToProviderCompanyCmd);
	};
	
	AssignActivityToProviderCompanyCmd.schema = {
	    type: 'object',
	    properties: {
	        activityUid: { type: 'object' }
	    },
	    required: ['activityUid']
	};
	
	var DefineUpdateInterventionPeriodForActivityCmd = exports.DefineUpdateInterventionPeriodForActivityCmd = function DefineUpdateInterventionPeriodForActivityCmd() {
	    _classCallCheck(this, DefineUpdateInterventionPeriodForActivityCmd);
	};
	
	DefineUpdateInterventionPeriodForActivityCmd.schemaCache = (0, _cache2.default)();
	DefineUpdateInterventionPeriodForActivityCmd.alternateSchemaCache = (0, _cache2.default)();
	
	DefineUpdateInterventionPeriodForActivityCmd.schema = {
	    type: 'object',
	    properties: {
	        period: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    label: { type: 'string' },
	                    startDate: { type: 'date' },
	                    endDate: { type: 'date' },
	                    periodType: {
	                        type: 'string',
	                        enum: ['DateTimePeriod']
	                    }
	                },
	                required: ['label', 'startDate', 'endDate', 'periodType']
	            }, {
	                type: 'object',
	                properties: {
	                    label: { type: 'string' },
	                    periodRanges: {
	                        type: 'array',
	                        minItems: 1,
	                        items: {
	                            type: 'object',
	                            properties: {
	                                weekDays: {
	                                    type: 'array',
	                                    minItems: 1
	                                },
	                                timeSlot: {
	                                    oneOf: [{
	                                        type: 'object',
	                                        properties: {
	                                            timeSlotType: {
	                                                type: 'string',
	                                                enum: ['AllDayLong']
	                                            }
	                                        },
	                                        required: ['timeSlotType']
	                                    }, {
	                                        type: 'object',
	                                        properties: {
	                                            periods: {
	                                                type: 'array',
	                                                minItems: 1,
	                                                items: {
	                                                    type: 'object',
	                                                    properties: {
	                                                        start: { type: 'date' },
	                                                        end: { type: 'date' }
	                                                    },
	                                                    required: ['start', 'end']
	                                                }
	                                            },
	                                            timeSlotType: {
	                                                type: 'string',
	                                                enum: ['HourPeriods']
	                                            }
	                                        },
	                                        required: ['periods', 'timeSlotType']
	                                    }]
	                                }
	                            },
	                            required: ['weekDays', 'timeSlot']
	                        }
	                    },
	                    exclusions: {
	                        type: ['array', 'null'],
	                        items: {
	                            type: 'object',
	                            properties: {
	                                days: {
	                                    type: 'array',
	                                    minItems: 1,
	                                    items: { type: 'date' }
	                                },
	                                timeSlot: {
	                                    oneOf: [{
	                                        type: 'object',
	                                        properties: {
	                                            timeSlotType: {
	                                                type: 'string',
	                                                enum: ['AllDayLong']
	                                            }
	                                        },
	                                        required: ['timeSlotType']
	                                    }, {
	                                        type: 'object',
	                                        properties: {
	                                            periods: {
	                                                type: 'array',
	                                                minItems: 1,
	                                                items: {
	                                                    type: 'object',
	                                                    properties: {
	                                                        start: { type: 'date' },
	                                                        end: { type: 'date' }
	                                                    },
	                                                    required: ['start', 'end']
	                                                }
	                                            },
	                                            timeSlotType: {
	                                                type: 'string',
	                                                enum: ['HourPeriods']
	                                            }
	                                        },
	                                        required: ['periods', 'timeSlotType']
	                                    }]
	                                }
	                            },
	                            required: ['days', 'timeSlot']
	                        }
	                    },
	                    startDate: { type: ['date', 'null'] },
	                    endDate: { type: ['date', 'null'] },
	                    periodType: {
	                        type: 'string',
	                        enum: ['WeekDaysPeriod']
	                    }
	                },
	                required: ['label', 'periodRanges', 'periodType']
	            }, {
	                type: 'object',
	                properties: {
	                    label: { type: 'string' },
	                    days: {
	                        type: 'array',
	                        minItems: 1,
	                        items: { type: 'date' }
	                    },
	                    timeSlot: {
	                        oneOf: [{
	                            type: 'object',
	                            properties: {
	                                timeSlotType: {
	                                    type: 'string',
	                                    enum: ['AllDayLong']
	                                }
	                            },
	                            required: ['timeSlotType']
	                        }, {
	                            type: 'object',
	                            properties: {
	                                periods: {
	                                    type: 'array',
	                                    minItems: 1,
	                                    items: {
	                                        type: 'object',
	                                        properties: {
	                                            start: { type: 'date' },
	                                            end: { type: 'date' }
	                                        },
	                                        required: ['start', 'end']
	                                    }
	                                },
	                                timeSlotType: {
	                                    type: 'string',
	                                    enum: ['HourPeriods']
	                                }
	                            },
	                            required: ['periods', 'timeSlotType']
	                        }]
	                    },
	                    periodType: {
	                        type: 'string',
	                        enum: ['SpecificDaysPeriod']
	                    }
	                },
	                required: ['label', 'days', 'periodType']
	            }]
	        }
	    },
	    required: ['period']
	};
	
	DefineUpdateInterventionPeriodForActivityCmd.selectSchema = function (cmd) {
	    var periodType = cmd && cmd.period && cmd.period.periodType || PERIOD_TYPES[0];
	    var periodTimeSlotType = cmd && cmd.period && cmd.period.timeSlot && cmd.period.timeSlot.timeSlotType || TIME_SLOT_TYPES[0];
	
	    return DefineUpdateInterventionPeriodForActivityCmd.schemaCache([periodType, periodTimeSlotType], function () {
	        var periodSchema = DefineUpdateInterventionPeriodForActivityCmd.schema.properties.period.oneOf.find(function (schema) {
	            return schema.properties.periodType.enum.indexOf(periodType) >= 0;
	        });
	
	        var periodTimeSlotSchema = periodSchema.properties.timeSlot && periodSchema.properties.timeSlot.oneOf.find(function (schema) {
	            return schema.properties.timeSlotType.enum.indexOf(periodTimeSlotType) >= 0;
	        });
	
	        if (periodTimeSlotSchema) {
	            return _extends({}, DefineUpdateInterventionPeriodForActivityCmd.schema, {
	                properties: _extends({}, DefineUpdateInterventionPeriodForActivityCmd.schema.properties, {
	                    period: _extends({}, periodSchema, {
	                        properties: _extends({}, periodSchema.properties, {
	                            timeSlot: periodTimeSlotSchema
	                        })
	                    })
	                })
	            });
	        }
	
	        return _extends({}, DefineUpdateInterventionPeriodForActivityCmd.schema, {
	            properties: _extends({}, DefineUpdateInterventionPeriodForActivityCmd.schema.properties, {
	                period: periodSchema
	            })
	        });
	    });
	};
	
	DefineUpdateInterventionPeriodForActivityCmd.selectAlternateSchema = function (cmd) {
	    // resolve oneOf definitions which are nested in arrays.
	    // this can't be done in selectSchema ; otherwise validation will fail
	    var periodRangeTimeSlotType = cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges[0] && cmd.period.periodRanges[0].timeSlot && cmd.period.periodRanges[0].timeSlot.timeSlotType || TIME_SLOT_TYPES[0];
	    var exclusionTimeSlotType = cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions[0] && cmd.period.exclusions[0].timeSlot && cmd.period.exclusions[0].timeSlot.timeSlotType || TIME_SLOT_TYPES[0];
	
	    return DefineUpdateInterventionPeriodForActivityCmd.alternateSchemaCache([periodRangeTimeSlotType, exclusionTimeSlotType], function () {
	        var periodSchema = DefineUpdateInterventionPeriodForActivityCmd.schema.properties.period.oneOf.find(function (schema) {
	            return schema.properties.periodType.enum.indexOf('WeekDaysPeriod') >= 0;
	        });
	
	        var periodRangeTimeSlotSchema = periodSchema.properties.periodRanges.items.properties.timeSlot.oneOf.find(function (schema) {
	            return schema.properties.timeSlotType.enum.indexOf(periodRangeTimeSlotType) >= 0;
	        });
	
	        var exclusionTimeSlotSchema = periodSchema.properties.exclusions.items.properties.timeSlot.oneOf.find(function (schema) {
	            return schema.properties.timeSlotType.enum.indexOf(exclusionTimeSlotType) >= 0;
	        });
	
	        return {
	            properties: {
	                period: {
	                    properties: {
	                        periodRanges: {
	                            items: {
	                                properties: {
	                                    timeSlot: periodRangeTimeSlotSchema
	                                }
	                            }
	                        },
	                        exclusions: {
	                            items: {
	                                properties: {
	                                    timeSlot: exclusionTimeSlotSchema
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        };
	    });
	};
	
	var DefineServiceChargeForInterventionPeriodCmd = exports.DefineServiceChargeForInterventionPeriodCmd = function DefineServiceChargeForInterventionPeriodCmd() {
	    _classCallCheck(this, DefineServiceChargeForInterventionPeriodCmd);
	};
	
	DefineServiceChargeForInterventionPeriodCmd.schema = {
	    type: 'object',
	    properties: {
	        charge: {
	            type: 'object',
	            properties: {
	                value: { type: 'number' },
	                chargeType: { type: 'string' }
	            },
	            required: ['value', 'chargeType']
	        }
	    },
	    required: ['charge']
	};
	
	var DefineInterventionZoneForInterventionPeriodCmd = exports.DefineInterventionZoneForInterventionPeriodCmd = function DefineInterventionZoneForInterventionPeriodCmd() {
	    _classCallCheck(this, DefineInterventionZoneForInterventionPeriodCmd);
	};
	
	DefineInterventionZoneForInterventionPeriodCmd.schema = {
	    type: 'object',
	    properties: {
	        zone: {
	            type: 'object',
	            properties: {
	                address: {
	                    type: 'object',
	                    properties: {
	                        number: { type: ['string', 'null'] },
	                        street: { type: 'string' },
	                        zipCode: { type: 'string' },
	                        city: { type: 'string' }
	                    },
	                    required: ['street', 'zipCode', 'city']
	                },
	                range: {
	                    type: 'object',
	                    properties: {
	                        value: { type: 'number' }
	                    },
	                    required: ['value']
	                }
	            },
	            required: ['address', 'range']
	        }
	    },
	    required: ['zone']
	};
	
	var DefineCallOutChargesForInterventionPeriodCmd = exports.DefineCallOutChargesForInterventionPeriodCmd = function DefineCallOutChargesForInterventionPeriodCmd() {
	    _classCallCheck(this, DefineCallOutChargesForInterventionPeriodCmd);
	};
	
	DefineCallOutChargesForInterventionPeriodCmd.schema = {
	    type: 'object',
	    properties: {
	        callOutCharges: {
	            type: 'array',
	            minItems: 1,
	            items: {
	                type: 'object',
	                properties: {
	                    range: {
	                        type: 'object',
	                        properties: {
	                            start: { type: 'number' },
	                            end: { type: 'number' }
	                        },
	                        required: ['start']
	                    },
	                    charge: {
	                        type: 'object',
	                        properties: {
	                            value: { type: 'number' }
	                        },
	                        required: ['value']
	                    }
	                },
	                required: ['range', 'charge']
	            }
	        }
	    },
	    required: ['callOutCharges']
	};
	
	var SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd = exports.SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd = function SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd() {
	    _classCallCheck(this, SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd);
	};
	
	SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd.schema = {
	    type: 'object',
	    properties: {
	        subscriptions: {
	            type: 'array',
	            minItems: 1,
	            maxItems: 2,
	            items: {
	                type: 'object',
	                properties: {
	                    forWhat: {
	                        type: 'array',
	                        minItems: 1
	                    },
	                    forWho: { type: 'string' }
	                },
	                required: ['forWhat', 'forWho']
	            }
	        }
	    },
	    required: ['subscriptions']
	};
	
	var DefineContactInfosForProviderCompanyCmd = exports.DefineContactInfosForProviderCompanyCmd = function DefineContactInfosForProviderCompanyCmd() {
	    _classCallCheck(this, DefineContactInfosForProviderCompanyCmd);
	};
	
	DefineContactInfosForProviderCompanyCmd.schemaCache = (0, _cache2.default)();
	
	DefineContactInfosForProviderCompanyCmd.schema = {
	    type: 'object',
	    properties: {
	        namez: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    firstName: { type: 'string' },
	                    lastName: { type: 'string' },
	                    gender: { type: ['string', 'null'] },
	                    nameType: {
	                        type: 'string',
	                        enum: ['CivilName']
	                    }
	                },
	                required: ['firstName', 'lastName', 'nameType']
	            }, {
	                type: 'object',
	                properties: {
	                    value: { type: 'string' },
	                    nameType: {
	                        type: 'string',
	                        enum: ['PoorName']
	                    }
	                },
	                required: ['value', 'nameType']
	            }]
	        },
	        emails: {
	            type: 'array',
	            items: {
	                type: 'string',
	                format: 'email'
	            }
	        },
	        phones: {
	            type: 'array',
	            items: {
	                type: 'string',
	                format: 'phone'
	            }
	        },
	        fax: {
	            type: 'array',
	            items: {
	                type: 'string',
	                format: 'phone'
	            }
	        }
	    },
	    required: ['namez']
	};
	
	DefineContactInfosForProviderCompanyCmd.selectSchema = function (cmd) {
	    var nameType = cmd && cmd.namez && cmd.namez.nameType || 'CivilName';
	
	    return DefineContactInfosForProviderCompanyCmd.schemaCache(nameType, function () {
	        var namezSchema = DefineContactInfosForProviderCompanyCmd.schema.properties.namez.oneOf.find(function (schema) {
	            return schema.properties.nameType.enum.indexOf(nameType) >= 0;
	        });
	
	        return _extends({}, DefineContactInfosForProviderCompanyCmd.schema, {
	            properties: _extends({}, DefineContactInfosForProviderCompanyCmd.schema.properties, {
	                namez: namezSchema
	            })
	        });
	    });
	};
	
	var DefineRepairTimelimitForInterventionPeriodCmd = exports.DefineRepairTimelimitForInterventionPeriodCmd = function DefineRepairTimelimitForInterventionPeriodCmd() {
	    _classCallCheck(this, DefineRepairTimelimitForInterventionPeriodCmd);
	};
	
	DefineRepairTimelimitForInterventionPeriodCmd.schema = {
	    type: 'object',
	    properties: {
	        timelimits: {
	            type: 'array',
	            minItems: 1,
	            items: {
	                type: 'object',
	                properties: {
	                    timelimit: {
	                        type: 'object',
	                        properties: {
	                            value: { type: 'number' }
	                        },
	                        required: ['value']
	                    },
	                    openingTicketPurposes: {
	                        type: 'array',
	                        minItems: 1
	                    }
	                },
	                required: ['timelimit', 'openingTicketPurposes']
	            }
	        }
	    },
	    required: ['timelimits']
	};
	
	var DefineInterventionTimelimitForInterventionPeriodCmd = exports.DefineInterventionTimelimitForInterventionPeriodCmd = function DefineInterventionTimelimitForInterventionPeriodCmd() {
	    _classCallCheck(this, DefineInterventionTimelimitForInterventionPeriodCmd);
	};
	
	DefineInterventionTimelimitForInterventionPeriodCmd.schema = {
	    type: 'object',
	    properties: {
	        timelimits: {
	            type: 'array',
	            minItems: 1,
	            items: {
	                type: 'object',
	                properties: {
	                    timelimit: {
	                        type: 'object',
	                        properties: {
	                            value: { type: 'number' }
	                        },
	                        required: ['value']
	                    },
	                    openingTicketPurposes: {
	                        type: 'array',
	                        minItems: 1
	                    }
	                },
	                required: ['timelimit', 'openingTicketPurposes']
	            }
	        }
	    },
	    required: ['timelimits']
	};
	
	var ExcludeOpeningTicketPurposesFromInterventionPeriodCmd = exports.ExcludeOpeningTicketPurposesFromInterventionPeriodCmd = function ExcludeOpeningTicketPurposesFromInterventionPeriodCmd() {
	    _classCallCheck(this, ExcludeOpeningTicketPurposesFromInterventionPeriodCmd);
	};
	
	ExcludeOpeningTicketPurposesFromInterventionPeriodCmd.schema = {
	    type: 'object',
	    properties: {
	        openingTicketPurposes: { type: 'array' }
	    },
	    required: ['openingTicketPurposes']
	};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	(function() {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  var support = {
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob();
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = xhr.getAllResponseHeaders().trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this._initBody(bodyInit)
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return;
	      }
	
	      xhr.onload = function() {
	        var status = (xhr.status === 1223) ? 204 : xhr.status
	        if (status < 100 || status > 599) {
	          reject(new TypeError('Network request failed'))
	          return
	        }
	        var options = {
	          status: status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})();
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = global.fetch;
	}.call(global));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonToggle = function (_Component) {
	    _inherits(ButtonToggle, _Component);
	
	    function ButtonToggle() {
	        _classCallCheck(this, ButtonToggle);
	
	        return _possibleConstructorReturn(this, (ButtonToggle.__proto__ || Object.getPrototypeOf(ButtonToggle)).apply(this, arguments));
	    }
	
	    _createClass(ButtonToggle, [{
	        key: '_toggle',
	        value: function _toggle(event, item) {
	            var _props = this.props,
	                multi = _props.multi,
	                value = _props.value,
	                onChange = _props.onChange,
	                identify = _props.identify;
	
	
	            event.preventDefault();
	
	            var nextValue;
	
	            if (multi) {
	                var previousValue = value || [];
	                var itemId = identify(item);
	                var index = previousValue.findIndex(function (v) {
	                    return identify(v) == itemId;
	                });
	
	                nextValue = [].concat(_toConsumableArray(previousValue));
	                if (index >= 0) {
	                    nextValue.splice(index, 1);
	                } else {
	                    nextValue.push(item);
	                }
	            } else {
	                if ((value && identify(value)) != identify(item)) {
	                    nextValue = item;
	                } else {
	                    nextValue = null;
	                }
	            }
	
	            onChange(nextValue);
	        }
	    }, {
	        key: '_isActive',
	        value: function _isActive(item) {
	            var _props2 = this.props,
	                multi = _props2.multi,
	                value = _props2.value,
	                identify = _props2.identify;
	
	
	            if (multi) {
	                var itemId = identify(item);
	                return value && value.find(function (v) {
	                    return identify(v) == itemId;
	                }) != null || false;
	            }
	            return item == value;
	        }
	    }, {
	        key: '_enhance',
	        value: function _enhance(children) {
	            var _this2 = this;
	
	            return _react2.default.Children.map(children, function (child) {
	                if (child && child.type && child.type.displayName == 'Button') {
	                    var value = child.props.value;
	
	
	                    return _react2.default.cloneElement(child, {
	                        active: _this2._isActive(value),
	                        onClick: function onClick(e) {
	                            return _this2._toggle(e, value);
	                        }
	                    });
	                }
	                if (child && child.props) {
	                    var _children = child.props.children;
	
	
	                    return _children && _react2.default.cloneElement(child, {
	                        children: _this2._enhance(_children)
	                    }) || child;
	                }
	                return child;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                children = _props3.children,
	                multi = _props3.multi,
	                value = _props3.value,
	                onChange = _props3.onChange;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this._enhance(children)
	            );
	        }
	    }]);
	
	    return ButtonToggle;
	}(_react.Component);
	
	ButtonToggle.propTypes = {
	    multi: _react.PropTypes.bool,
	    identify: _react.PropTypes.func,
	    value: _react.PropTypes.any,
	    onChange: _react.PropTypes.func.isRequired
	};
	ButtonToggle.defaultProps = {
	    identify: function identify(v) {
	        return v;
	    }
	};
	exports.default = ButtonToggle;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(61);
	var call = __webpack_require__(292);
	var isArrayIter = __webpack_require__(212);
	var anObject = __webpack_require__(11);
	var toLength = __webpack_require__(27);
	var getIterFn = __webpack_require__(228);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(11);
	var dPs = __webpack_require__(298);
	var enumBugKeys = __webpack_require__(208);
	var IE_PROTO = __webpack_require__(221)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(207)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(210).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(300);
	var hiddenKeys = __webpack_require__(208).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(300);
	var enumBugKeys = __webpack_require__(208);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(44);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(16);
	var dP = __webpack_require__(30);
	var DESCRIPTORS = __webpack_require__(28);
	var SPECIES = __webpack_require__(25)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(63);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(327)('wks');
	var uid = __webpack_require__(329);
	var Symbol = __webpack_require__(119).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(838);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(79);
	
	var assign = __webpack_require__(22);
	var emptyFunction = __webpack_require__(65);
	var warning = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(174);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(138);
	util.inherits = __webpack_require__(89);
	/*</replacement>*/
	
	var Readable = __webpack_require__(501);
	var Writable = __webpack_require__(258);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.percentage = percentage;
	exports.average = average;
	exports.max = max;
	function percentage(_ref) {
	    var source = _ref.source,
	        identify = _ref.identify,
	        match = _ref.match;
	
	    var total = source.reduce(function (r, v) {
	        return r + identify(v);
	    }, 0);
	    var count = identify(source.find(match) || {}) || 0;
	    return Math.round(count / total * 100);
	}
	
	function average(_ref2) {
	    var source = _ref2.source,
	        _ref2$identify = _ref2.identify,
	        identify = _ref2$identify === undefined ? function (v) {
	        return v;
	    } : _ref2$identify,
	        _ref2$accuracy = _ref2.accuracy,
	        accuracy = _ref2$accuracy === undefined ? 1 : _ref2$accuracy;
	
	    return Math.round(source.reduce(function (r, v) {
	        return r + identify(v);
	    }, 0) / source.length / accuracy) * accuracy;
	}
	
	function max(_ref3) {
	    var source = _ref3.source,
	        _ref3$identify = _ref3.identify,
	        identify = _ref3$identify === undefined ? function (v) {
	        return v;
	    } : _ref3$identify;
	
	    return source.reduce(function (result, value) {
	        var val = identify(value);
	        return val > result && val || result;
	    }, 0);
	}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(489);
	
	var invariant = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ }),
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _DashboardPanel = __webpack_require__(2205);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DashboardPanel = function (_Component) {
	    _inherits(DashboardPanel, _Component);
	
	    function DashboardPanel(props) {
	        _classCallCheck(this, DashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (DashboardPanel.__proto__ || Object.getPrototypeOf(DashboardPanel)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(DashboardPanel, [{
	        key: '_openHelp',
	        value: function _openHelp(event) {
	            event.preventDefault();
	            this.setState({ helpOpened: true });
	        }
	    }, {
	        key: '_closeHelp',
	        value: function _closeHelp() {
	            this.setState({ helpOpened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _cx,
	                _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                size = _props.size,
	                light = _props.light,
	                status = _props.status,
	                header = _props.header,
	                help = _props.help,
	                onClick = _props.onClick;
	            var helpOpened = this.state.helpOpened;
	            var _refs = this.refs,
	                helpButton = _refs.helpButton,
	                helpContainer = _refs.helpContainer;
	
	            var sizeClass = size && size.toLowerCase();
	            var statusClass = status && status.toLowerCase();
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(_DashboardPanel2.default.default, _DashboardPanel2.default[sizeClass], _DashboardPanel2.default[statusClass], (_cx = {}, _defineProperty(_cx, _DashboardPanel2.default.light, light), _defineProperty(_cx, _DashboardPanel2.default.clickable, onClick), _cx)),
	                    onClick: onClick },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        ref: 'helpContainer',
	                        className: _DashboardPanel2.default.header },
	                    help && _react2.default.createElement(
	                        'div',
	                        { className: _DashboardPanel2.default.headerSide },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                ref: 'helpButton',
	                                className: _DashboardPanel2.default.help,
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openHelp(e);
	                                },
	                                onMouseOver: function onMouseOver(e) {
	                                    return _this2._openHelp(e);
	                                },
	                                onMouseOut: function onMouseOut() {
	                                    return _this2._closeHelp();
	                                } },
	                            '?'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Overlay,
	                            { rootClose: true,
	                                target: function target() {
	                                    return (0, _reactDom.findDOMNode)(helpButton);
	                                },
	                                placement: 'bottom',
	                                show: helpOpened,
	                                container: helpContainer,
	                                onHide: function onHide() {
	                                    return _this2._closeHelp();
	                                } },
	                            _react2.default.createElement(
	                                _reactBootstrap.Tooltip,
	                                null,
	                                help
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DashboardPanel2.default.headerMain },
	                        header
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _DashboardPanel2.default.body },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DashboardPanel2.default.bodyContent },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DashboardPanel;
	}(_react.Component);
	
	DashboardPanel.propTypes = {
	    size: _react.PropTypes.string,
	    light: _react.PropTypes.bool,
	    status: _react.PropTypes.string,
	    header: _react.PropTypes.object.isRequired,
	    help: _react.PropTypes.object,
	    onClick: _react.PropTypes.func
	};
	DashboardPanel.defaultProps = {};
	exports.default = DashboardPanel;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UserConfigs = exports.CompanyConfigs = exports.DowngradeExecutiveToPatrimonyManagerCmd = exports.UpdateLoginCmd = exports.UpdateUserCmd = exports.IdentifyCompanyCmd = exports.UpdateCompanyCmd = exports.UpdateAgencyCmd = exports.ReferenceUserCmd = exports.ReferenceAgencyCmd = exports.ReferenceCompanyCmd = exports.AgencyCriteria = exports.UserCriteria = exports.CompanyCriteria = exports.BILLING_TYPES = exports.UPDATE_COMPANY_CMD_TYPES = exports.REFERENCE_USER_CMD_TYPES = exports.REFERENCE_COMPANY_CMD_TYPES = undefined;
	exports.createValidator = createValidator;
	
	var _jjv = __webpack_require__(172);
	
	var _jjv2 = _interopRequireDefault(_jjv);
	
	var _phonez = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var REFERENCE_COMPANY_CMD_TYPES = exports.REFERENCE_COMPANY_CMD_TYPES = ['CreateClientAccount', 'CreateClientAccountHolding', 'CreateCallCenter'];
	var REFERENCE_USER_CMD_TYPES = exports.REFERENCE_USER_CMD_TYPES = ['ReferenceExecutive', 'ReferenceClientAccountManager', 'ReferencePatrimonyManager', 'ReferenceCallCenterUser', 'ReferenceCallCenterOperator'];
	var UPDATE_COMPANY_CMD_TYPES = exports.UPDATE_COMPANY_CMD_TYPES = ['UpdateClientAccount', 'UpdateClientAccountHolding', 'UpdateCallCenter'];
	var BILLING_TYPES = exports.BILLING_TYPES = ['SponsoredAccount', 'StandardAccount'];
	
	function createValidator() {
	    var validator = (0, _jjv2.default)();
	
	    validator.addFormat('phone', _phonez.phoneFormat);
	    return validator;
	}
	
	var CompanyCriteria = exports.CompanyCriteria = function CompanyCriteria() {
	    _classCallCheck(this, CompanyCriteria);
	};
	
	CompanyCriteria.schema = {
	    type: 'object',
	    properties: {
	        fullText: { type: 'string' }
	    }
	};
	
	var UserCriteria = exports.UserCriteria = function UserCriteria() {
	    _classCallCheck(this, UserCriteria);
	};
	
	UserCriteria.schema = {
	    type: 'object',
	    properties: {
	        active: { type: 'boolean' }
	    }
	};
	
	var AgencyCriteria = exports.AgencyCriteria = function AgencyCriteria() {
	    _classCallCheck(this, AgencyCriteria);
	};
	
	AgencyCriteria.schema = {
	    type: 'object',
	    properties: {
	        active: { type: 'boolean' }
	    }
	};
	
	var ReferenceCompanyCmd = exports.ReferenceCompanyCmd = function ReferenceCompanyCmd() {
	    _classCallCheck(this, ReferenceCompanyCmd);
	};
	
	ReferenceCompanyCmd.schema = {
	    oneOf: [{
	        type: 'object',
	        properties: {
	            label: { type: 'string' },
	            siretNumber: {
	                type: ['string', 'null'],
	                pattern: '^[a-zA-Z0-9]{14}$'
	            },
	            callCenterReference: { type: 'string' },
	            billingType: {
	                type: 'string',
	                enum: ['SponsoredAccount']
	            },
	            commandType: {
	                type: 'string',
	                enum: ['CreateClientAccount', 'CreateClientAccountHolding']
	            }
	        },
	        required: ['label', 'callCenterReference', 'commandType']
	    }, {
	        type: 'object',
	        properties: {
	            label: { type: 'string' },
	            siretNumber: {
	                type: 'string',
	                pattern: '^[a-zA-Z0-9]{14}$'
	            },
	            callCenterReference: { type: 'string' },
	            billingType: {
	                type: 'string',
	                enum: ['StandardAccount']
	            },
	            commandType: {
	                type: 'string',
	                enum: ['CreateClientAccount', 'CreateClientAccountHolding']
	            }
	        },
	        required: ['label', 'callCenterReference', 'siretNumber', 'commandType']
	    }, {
	        type: 'object',
	        properties: {
	            label: { type: 'string' },
	            siretNumber: {
	                type: ['string', 'null'],
	                pattern: '^[a-zA-Z0-9]{14}$'
	            },
	            commandType: {
	                type: 'string',
	                enum: ['CreateCallCenter']
	            }
	        },
	        required: ['label', 'commandType']
	    }]
	};
	
	ReferenceCompanyCmd.selectSchema = function (cmd) {
	    return ReferenceCompanyCmd.schema.oneOf.find(function (schema) {
	        var commandType = cmd && cmd.commandType || REFERENCE_COMPANY_CMD_TYPES[0];
	        var billingType = cmd && cmd.billingType || BILLING_TYPES[0];
	
	        return schema.properties.commandType.enum.indexOf(commandType) >= 0 && (!schema.properties.billingType || schema.properties.billingType.enum.indexOf(billingType) >= 0);
	    });
	};
	
	var ReferenceAgencyCmd = exports.ReferenceAgencyCmd = function ReferenceAgencyCmd() {
	    _classCallCheck(this, ReferenceAgencyCmd);
	};
	
	ReferenceAgencyCmd.schema = {
	    type: 'object',
	    properties: {
	        agency: {
	            type: 'object',
	            properties: {
	                ref: { type: 'string' },
	                label: { type: 'string' },
	                emails: {
	                    type: ['array', 'null'],
	                    items: {
	                        type: 'string',
	                        format: 'email'
	                    }
	                },
	                phones: {
	                    type: ['array', 'null'],
	                    items: {
	                        type: 'string',
	                        format: 'phone'
	                    }
	                },
	                fax: {
	                    type: ['string', 'null'],
	                    format: 'phone'
	                },
	                address: {
	                    type: ['object', 'null'],
	                    properties: {
	                        number: { type: ['string', 'null'] },
	                        street: { type: 'string' },
	                        zipCode: { type: 'string' },
	                        city: { type: 'string' }
	                    },
	                    required: ['street', 'zipCode', 'city']
	                }
	            },
	            required: ['ref', 'label']
	        }
	    },
	    required: ['agency']
	};
	
	var ReferenceUserCmd = exports.ReferenceUserCmd = function ReferenceUserCmd() {
	    _classCallCheck(this, ReferenceUserCmd);
	};
	
	ReferenceUserCmd.schema = {
	    oneOf: [{
	        type: 'object',
	        properties: {
	            firstName: { type: 'string' },
	            lastName: { type: 'string' },
	            login: {
	                type: 'string',
	                format: 'email'
	            },
	            job: { type: ['string', 'null'] },
	            phone: {
	                type: ['string', 'null'],
	                format: 'phone'
	            },
	            managedPatrimonies: {
	                type: 'array',
	                minItems: 1
	            },
	            commandType: {
	                type: 'string',
	                enum: ['ReferencePatrimonyManager']
	            }
	        },
	        required: ['firstName', 'lastName', 'login', 'managedPatrimonies', 'commandType']
	    }, {
	        type: 'object',
	        properties: {
	            firstName: { type: 'string' },
	            lastName: { type: 'string' },
	            login: {
	                type: 'string',
	                format: 'email'
	            },
	            job: { type: ['string', 'null'] },
	            phone: {
	                type: ['string', 'null'],
	                format: 'phone'
	            },
	            managedAgencies: {
	                type: 'array',
	                minItems: 1
	            },
	            commandType: {
	                type: 'string',
	                enum: ['ReferenceExecutive']
	            }
	        },
	        required: ['firstName', 'lastName', 'login', 'managedAgencies', 'commandType']
	    }, {
	        type: 'object',
	        properties: {
	            firstName: { type: 'string' },
	            lastName: { type: 'string' },
	            login: {
	                type: 'string',
	                format: 'email'
	            },
	            job: { type: ['string', 'null'] },
	            phone: {
	                type: ['string', 'null'],
	                format: 'phone'
	            },
	            commandType: {
	                type: 'string',
	                enum: ['ReferenceCallCenterUser', 'ReferenceCallCenterOperator', 'ReferenceClientAccountManager']
	            }
	        },
	        required: ['firstName', 'lastName', 'login', 'commandType']
	    }]
	};
	
	ReferenceUserCmd.selectSchema = function (cmd) {
	    return ReferenceUserCmd.schema.oneOf.find(function (schema) {
	        var commandType = cmd && cmd.commandType || REFERENCE_USER_CMD_TYPES[0];
	        return schema.properties.commandType.enum.indexOf(commandType) >= 0;
	    });
	};
	
	var UpdateAgencyCmd = exports.UpdateAgencyCmd = function UpdateAgencyCmd() {
	    _classCallCheck(this, UpdateAgencyCmd);
	};
	
	UpdateAgencyCmd.schema = {
	    type: 'object',
	    properties: {
	        agency: {
	            type: 'object',
	            properties: {
	                ref: { type: 'string' },
	                label: { type: 'string' },
	                emails: {
	                    type: ['array', 'null'],
	                    items: {
	                        type: 'string',
	                        format: 'email'
	                    }
	                },
	                phones: {
	                    type: ['array', 'null'],
	                    items: {
	                        type: 'string',
	                        format: 'phone'
	                    }
	                },
	                fax: {
	                    type: ['string', 'null'],
	                    format: 'phone'
	                },
	                address: {
	                    type: ['object', 'null'],
	                    properties: {
	                        number: { type: ['string', 'null'] },
	                        street: { type: 'string' },
	                        zipCode: { type: 'string' },
	                        city: { type: 'string' }
	                    },
	                    required: ['street', 'zipCode', 'city']
	                }
	            },
	            required: ['ref', 'label']
	        }
	    },
	    required: ['agency']
	};
	
	var UpdateCompanyCmd = exports.UpdateCompanyCmd = function UpdateCompanyCmd() {
	    _classCallCheck(this, UpdateCompanyCmd);
	};
	
	UpdateCompanyCmd.schema = {
	    type: 'object',
	    properties: {
	        label: { type: 'string' }
	    },
	    required: ['label']
	};
	
	var IdentifyCompanyCmd = exports.IdentifyCompanyCmd = function IdentifyCompanyCmd() {
	    _classCallCheck(this, IdentifyCompanyCmd);
	};
	
	IdentifyCompanyCmd.schema = {
	    type: 'object',
	    properties: {
	        siretNumber: {
	            type: 'string',
	            pattern: '^[a-zA-Z0-9]{14}$'
	        }
	    },
	    required: ['siretNumber']
	};
	
	var UpdateUserCmd = exports.UpdateUserCmd = function UpdateUserCmd() {
	    _classCallCheck(this, UpdateUserCmd);
	};
	
	UpdateUserCmd.schema = {
	    type: 'object',
	    properties: {
	        firstName: { type: 'string' },
	        lastName: { type: 'string' },
	        job: { type: ['string', 'null'] },
	        phone: {
	            type: ['string', 'null'],
	            format: 'phone'
	        }
	    },
	    required: ['firstName', 'lastName']
	};
	
	var UpdateLoginCmd = exports.UpdateLoginCmd = function UpdateLoginCmd() {
	    _classCallCheck(this, UpdateLoginCmd);
	};
	
	UpdateLoginCmd.schema = {
	    type: 'object',
	    properties: {
	        login: {
	            type: 'string',
	            format: 'email'
	        }
	    },
	    required: ['login']
	};
	
	var DowngradeExecutiveToPatrimonyManagerCmd = exports.DowngradeExecutiveToPatrimonyManagerCmd = function DowngradeExecutiveToPatrimonyManagerCmd() {
	    _classCallCheck(this, DowngradeExecutiveToPatrimonyManagerCmd);
	};
	
	DowngradeExecutiveToPatrimonyManagerCmd.schema = {
	    type: 'object',
	    properties: {
	        managedPatrimonies: {
	            type: 'array',
	            minItems: 1
	        }
	    },
	    required: ['managedPatrimonies']
	};
	
	var CompanyConfigs = exports.CompanyConfigs = function CompanyConfigs() {
	    _classCallCheck(this, CompanyConfigs);
	};
	
	CompanyConfigs.schema = {
	    type: 'object',
	    properties: {
	        ticketUidGenerator: {
	            type: 'object',
	            properties: {
	                uidPrefix: {
	                    type: 'string',
	                    pattern: '^[A-Z]{1,3}$'
	                },
	                acknowledge: {
	                    type: 'boolean',
	                    enum: [true]
	                }
	            },
	            required: ['uidPrefix', 'acknowledge']
	        }
	    }
	};
	
	var UserConfigs = exports.UserConfigs = function UserConfigs() {
	    _classCallCheck(this, UserConfigs);
	};
	
	UserConfigs.schema = {
	    type: 'object',
	    properties: {
	        ticketOpenedNotifications: { type: 'boolean' },
	        daybookNotifications: { type: 'boolean' },
	        simplifiedRequestOpenedNotifications: { type: 'boolean' }
	    }
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED = exports.CREATE_UPDATE_CATEGORY_ACTION_UPDATED = exports.CREATE_UPDATE_TAG_ACTION_UPDATED = exports.UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED = exports.CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED = exports.DISABLE_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.ENABLE_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.DISSOCIATE_ACTIVITY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.REMOVE_CATEGORY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.ADD_CATEGORY_TO_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.REMOVE_TAG_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.ADD_TAG_TO_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.MOVE_PARENT_CATEGORY_ACTION_SENT = exports.CREATE_UPDATE_CATEGORY_ACTION_RESET = exports.CREATE_UPDATE_CATEGORY_ACTION_SENT = exports.CREATE_UPDATE_TAG_ACTION_RESET = exports.CREATE_UPDATE_TAG_ACTION_SENT = exports.UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.TICKET_CLAIM_REF_LOADED = exports.ACTIVITY_REF_QUERIED = exports.ACTIVITY_REF_LOADED = exports.OPENING_TICKET_PURPOSE_REF_QUERIED = exports.OPENING_TICKET_PURPOSE_REF_LOADED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.queryOpeningTicketPurposeRef = queryOpeningTicketPurposeRef;
	exports.fetchOpeningTicketPurposeRef = fetchOpeningTicketPurposeRef;
	exports.loadOpeningTicketPurposeRef = loadOpeningTicketPurposeRef;
	exports.queryActivityRef = queryActivityRef;
	exports.loadActivityRef = loadActivityRef;
	exports.loadTicketClaimRef = loadTicketClaimRef;
	exports.sendCreateOpeningTicketPurposeAction = sendCreateOpeningTicketPurposeAction;
	exports.sendUpdateOpeningTicketPurposeAction = sendUpdateOpeningTicketPurposeAction;
	exports.sendCreateUpdateTagAction = sendCreateUpdateTagAction;
	exports.sendCreateUpdateCategoryAction = sendCreateUpdateCategoryAction;
	exports.sendMoveParentCategoryAction = sendMoveParentCategoryAction;
	exports.sendAddTagToOpeningTicketPurposeAction = sendAddTagToOpeningTicketPurposeAction;
	exports.sendRemoveTagFromOpeningTicketPurposeAction = sendRemoveTagFromOpeningTicketPurposeAction;
	exports.sendAddCategoryToOpeningTicketPurposeAction = sendAddCategoryToOpeningTicketPurposeAction;
	exports.sendRemoveCategoryFromOpeningTicketPurposeAction = sendRemoveCategoryFromOpeningTicketPurposeAction;
	exports.sendAssociateActivityWithOpeningTicketPurposeAction = sendAssociateActivityWithOpeningTicketPurposeAction;
	exports.sendDissociateActivityFromOpeningTicketPurposeAction = sendDissociateActivityFromOpeningTicketPurposeAction;
	exports.sendEnableOpeningTicketPurposeAction = sendEnableOpeningTicketPurposeAction;
	exports.sendDisableOpeningTicketPurposeAction = sendDisableOpeningTicketPurposeAction;
	exports.updateCreateOpeningTicketPurposeAction = updateCreateOpeningTicketPurposeAction;
	exports.updateUpdateOpeningTicketPurposeAction = updateUpdateOpeningTicketPurposeAction;
	exports.updateCreateUpdateTagAction = updateCreateUpdateTagAction;
	exports.resetCreateUpdateTagAction = resetCreateUpdateTagAction;
	exports.updateCreateUpdateCategoryAction = updateCreateUpdateCategoryAction;
	exports.resetCreateUpdateCategoryAction = resetCreateUpdateCategoryAction;
	exports.updateAssociateActivityWithOpeningTicketPurposeAction = updateAssociateActivityWithOpeningTicketPurposeAction;
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NAMESPACE = 'Reference';
	var OPENING_TICKET_PURPOSE_REF_LOADED = exports.OPENING_TICKET_PURPOSE_REF_LOADED = NAMESPACE + '/OpeningTicketPurposeRefLoaded';
	var OPENING_TICKET_PURPOSE_REF_QUERIED = exports.OPENING_TICKET_PURPOSE_REF_QUERIED = NAMESPACE + '/OpeningTicketPurposeRefQueried';
	var ACTIVITY_REF_LOADED = exports.ACTIVITY_REF_LOADED = NAMESPACE + '/ActivityRefLoaded';
	var ACTIVITY_REF_QUERIED = exports.ACTIVITY_REF_QUERIED = NAMESPACE + '/ActivityRefQueried';
	var TICKET_CLAIM_REF_LOADED = exports.TICKET_CLAIM_REF_LOADED = NAMESPACE + 'TicketClaimRefLoaded';
	var CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/CreateOpeningTicketPurposeActionSent';
	var UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/UpdateOpeningTicketPurposeActionSent';
	var CREATE_UPDATE_TAG_ACTION_SENT = exports.CREATE_UPDATE_TAG_ACTION_SENT = NAMESPACE + '/CreateUpdateTagActionSent';
	var CREATE_UPDATE_TAG_ACTION_RESET = exports.CREATE_UPDATE_TAG_ACTION_RESET = NAMESPACE + '/CreateUpdateTagActionReset';
	var CREATE_UPDATE_CATEGORY_ACTION_SENT = exports.CREATE_UPDATE_CATEGORY_ACTION_SENT = NAMESPACE + '/CreateUpdateCategoryActionSent';
	var CREATE_UPDATE_CATEGORY_ACTION_RESET = exports.CREATE_UPDATE_CATEGORY_ACTION_RESET = NAMESPACE + '/CreateUpdateCategoryActionReset';
	var MOVE_PARENT_CATEGORY_ACTION_SENT = exports.MOVE_PARENT_CATEGORY_ACTION_SENT = NAMESPACE + '/MoveParentCategoryActionSent';
	var ADD_TAG_TO_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.ADD_TAG_TO_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/AddTagToOpeningTicketPurposeActionSent';
	var REMOVE_TAG_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.REMOVE_TAG_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/RemoveTagFromOpeningTicketPurposeActionSent';
	var ADD_CATEGORY_TO_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.ADD_CATEGORY_TO_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/AddCategoryToOpeningTicketPurposeActionSent';
	var REMOVE_CATEGORY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.REMOVE_CATEGORY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/RemoveCategoryFromOpeningTicketPurposeActionSent';
	var ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/AssociateActivityWithOpeningTicketPurposeActionSent';
	var DISSOCIATE_ACTIVITY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.DISSOCIATE_ACTIVITY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/DissociateActivityFromOpeningTicketPurposeActionSent';
	var ENABLE_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.ENABLE_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/EnableOpeningTicketPurposeActionSent';
	var DISABLE_OPENING_TICKET_PURPOSE_ACTION_SENT = exports.DISABLE_OPENING_TICKET_PURPOSE_ACTION_SENT = NAMESPACE + '/DisableOpeningTicketPurposeActionSent';
	// form actions
	var CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED = exports.CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED = NAMESPACE + '/CreateOpeningTicketPurposeActionUpdated';
	var UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED = exports.UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED = NAMESPACE + '/UpdateOpeningTicketPurposeActionUpdated';
	var CREATE_UPDATE_TAG_ACTION_UPDATED = exports.CREATE_UPDATE_TAG_ACTION_UPDATED = NAMESPACE + '/CreateUpdateTagActionUpdated';
	var CREATE_UPDATE_CATEGORY_ACTION_UPDATED = exports.CREATE_UPDATE_CATEGORY_ACTION_UPDATED = NAMESPACE + '/CreateUpdateCategoryActionUpdated';
	var ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED = exports.ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED = NAMESPACE + '/AssociateActivityWithOpeningTicketPurposeActionUpdated';
	
	function queryOpeningTicketPurposeRef(companyId) {
	    return loadOpeningTicketPurposeRef(companyId, OPENING_TICKET_PURPOSE_REF_QUERIED);
	}
	
	function fetchOpeningTicketPurposeRef(companyId) {
	    return fetch(_config2.default.api.url + '/clientcompanies/' + companyId + '/openingticketpurposeref', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse);
	}
	
	function loadOpeningTicketPurposeRef(companyId, action) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	        companyId = companyId && companyId.uid || companyId || company.uid;
	
	        return fetchOpeningTicketPurposeRef(companyId).then(function (_ref) {
	            var json = _ref.json;
	
	            return {
	                type: action || OPENING_TICKET_PURPOSE_REF_LOADED,
	                ref: json
	            };
	        }).catch((0, _fetchz.only)(404, function (error) {
	            return {
	                type: action || OPENING_TICKET_PURPOSE_REF_LOADED,
	                ref: {
	                    openingTicketPurposes: [],
	                    categories: [],
	                    tags: [],
	                    default: {
	                        openingTicketPurpose: { uid: '00000000-0000-0000-0000-000000000000', enabled: true, label: 'Autre raison d\'ouverture de Ticket', tags: [{ uid: '11111111-1111-1111-1111-111111111111' }], categories: [], activities: [] },
	                        tag: { uid: '11111111-1111-1111-1111-111111111111', label: 'Autre', iconId: 'other' }
	                    }
	                }
	            };
	        }));
	    }, action || OPENING_TICKET_PURPOSE_REF_LOADED);
	}
	
	function queryActivityRef() {
	    return loadActivityRef(ACTIVITY_REF_QUERIED);
	}
	
	function loadActivityRef(action) {
	    return (0, _loading2.default)(fetch(_config2.default.ticketHelper.api.url + '/universalactivitiesref', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	        var json = _ref2.json;
	
	        return {
	            type: action || ACTIVITY_REF_LOADED,
	            ref: json.ref
	        };
	    }).catch((0, _fetchz.only)(404, function (error) {
	        return {
	            type: action || ACTIVITY_REF_LOADED,
	            ref: []
	        };
	    })), action || ACTIVITY_REF_LOADED);
	}
	
	function loadTicketClaimRef() {
	    return (0, _loading2.default)(fetch(_config2.default.api.url + '/ticketclaimref', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref3) {
	        var json = _ref3.json;
	
	        return {
	            type: TICKET_CLAIM_REF_LOADED,
	            ref: json
	        };
	    }).catch((0, _fetchz.only)(404, function (error) {
	        return {
	            type: TICKET_CLAIM_REF_LOADED,
	            ref: {
	                urgencyLevel: [],
	                ticketClaimCategory: [],
	                failureCause: [],
	                treatmentPriority: [],
	                postAnalysis: [],
	                severity: []
	            }
	        };
	    })), TICKET_CLAIM_REF_LOADED);
	}
	
	function sendCreateOpeningTicketPurposeAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var createOpeningTicketPurposeAction = state.reference.createOpeningTicketPurposeAction;
	
	        var tagUids = createOpeningTicketPurposeAction.tagUids,
	            categoryUids = createOpeningTicketPurposeAction.categoryUids,
	            action = _objectWithoutProperties(createOpeningTicketPurposeAction, ['tagUids', 'categoryUids']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'CreateOpeningTicketPurpose',
	                tagUids: tagUids && tagUids.map(function (t) {
	                    return t.uid;
	                }) || [],
	                categoryUids: categoryUids && categoryUids.map(function (c) {
	                    return c.uid;
	                }) || []
	            }, action)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref4) {
	            var json = _ref4.json;
	
	            return {
	                type: CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT,
	                openingTicketPurposeUid: json.openingTicketPurposeUid
	            };
	        });
	    }, CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendUpdateOpeningTicketPurposeAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var updateOpeningTicketPurposeAction = state.reference.updateOpeningTicketPurposeAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'UpdateOpeningTicketPurpose'
	            }, updateOpeningTicketPurposeAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT
	            };
	        });
	    }, UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendCreateUpdateTagAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var createUpdateTagAction = state.reference.createUpdateTagAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({}, createUpdateTagAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref5) {
	            var json = _ref5.json;
	
	            return {
	                type: CREATE_UPDATE_TAG_ACTION_SENT,
	                tagUid: json.tagUid || createUpdateTagAction.uid
	            };
	        });
	    }, CREATE_UPDATE_TAG_ACTION_SENT);
	}
	
	function sendCreateUpdateCategoryAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var createUpdateCategoryAction = state.reference.createUpdateCategoryAction;
	
	        var parentUid = createUpdateCategoryAction.parentUid,
	            action = _objectWithoutProperties(createUpdateCategoryAction, ['parentUid']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                parentUid: parentUid && parentUid.uid
	            }, action)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref6) {
	            var json = _ref6.json;
	
	            return {
	                type: CREATE_UPDATE_CATEGORY_ACTION_SENT,
	                categoryUid: json.categoryUid || createUpdateCategoryAction.uid
	            };
	        });
	    }, CREATE_UPDATE_CATEGORY_ACTION_SENT);
	}
	
	function sendMoveParentCategoryAction(parentCategoryId, categoryId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'MoveParentCategory',
	                parentUid: parentCategoryId,
	                uid: categoryId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: MOVE_PARENT_CATEGORY_ACTION_SENT
	            };
	        });
	    }, MOVE_PARENT_CATEGORY_ACTION_SENT);
	}
	
	function sendAddTagToOpeningTicketPurposeAction(openingTicketPurposeId, tagId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'AddTagToOpeningTicketPurpose',
	                uid: openingTicketPurposeId,
	                tagUid: tagId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_TAG_TO_OPENING_TICKET_PURPOSE_ACTION_SENT
	            };
	        });
	    }, ADD_TAG_TO_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendRemoveTagFromOpeningTicketPurposeAction(openingTicketPurposeId, tagId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'RemoveTagFromOpeningTicketPurpose',
	                uid: openingTicketPurposeId,
	                tagUid: tagId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_TAG_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT
	            };
	        });
	    }, REMOVE_TAG_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendAddCategoryToOpeningTicketPurposeAction(openingTicketPurposeId, categoryId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'AddCategoryToOpeningTicketPurpose',
	                uid: openingTicketPurposeId,
	                categoryUid: categoryId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_CATEGORY_TO_OPENING_TICKET_PURPOSE_ACTION_SENT
	            };
	        });
	    }, ADD_CATEGORY_TO_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendRemoveCategoryFromOpeningTicketPurposeAction(openingTicketPurposeId, categoryId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'RemoveCategoryFromOpeningTicketPurpose',
	                uid: openingTicketPurposeId,
	                categoryUid: categoryId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_CATEGORY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT
	            };
	        });
	    }, REMOVE_CATEGORY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendAssociateActivityWithOpeningTicketPurposeAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var associateActivityWithOpeningTicketPurposeAction = state.reference.associateActivityWithOpeningTicketPurposeAction;
	
	        var uid = associateActivityWithOpeningTicketPurposeAction.uid,
	            activityUid = associateActivityWithOpeningTicketPurposeAction.activityUid,
	            action = _objectWithoutProperties(associateActivityWithOpeningTicketPurposeAction, ['uid', 'activityUid']);
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'AssociateActivityWithOpeningTicketPurpose',
	                uid: uid && uid.uid,
	                activityUid: activityUid && activityUid.uid
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT
	            };
	        });
	    }, ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendDissociateActivityFromOpeningTicketPurposeAction(openingTicketPurposeId, activityId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'DissociateActivityFromOpeningTicketPurpose',
	                uid: openingTicketPurposeId,
	                activityUid: activityId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref7) {
	            var json = _ref7.json;
	
	            return {
	                type: DISSOCIATE_ACTIVITY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT,
	                providerContactUpdated: json.providerContactUpdated
	            };
	        });
	    }, DISSOCIATE_ACTIVITY_FROM_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendEnableOpeningTicketPurposeAction(openingTicketPurposeId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'EnableOpeningTicketPurpose',
	                uid: openingTicketPurposeId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ENABLE_OPENING_TICKET_PURPOSE_ACTION_SENT
	            };
	        });
	    }, ENABLE_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function sendDisableOpeningTicketPurposeAction(openingTicketPurposeId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'DisableOpeningTicketPurpose',
	                uid: openingTicketPurposeId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketpurposeref', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DISABLE_OPENING_TICKET_PURPOSE_ACTION_SENT
	            };
	        });
	    }, DISABLE_OPENING_TICKET_PURPOSE_ACTION_SENT);
	}
	
	function updateCreateOpeningTicketPurposeAction(action) {
	    return {
	        action: action,
	        type: CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED
	    };
	}
	
	function updateUpdateOpeningTicketPurposeAction(action) {
	    return {
	        action: action,
	        type: UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED
	    };
	}
	
	function updateCreateUpdateTagAction(action) {
	    return {
	        action: action,
	        type: CREATE_UPDATE_TAG_ACTION_UPDATED
	    };
	}
	
	function resetCreateUpdateTagAction() {
	    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return {
	        action: action,
	        type: CREATE_UPDATE_TAG_ACTION_RESET
	    };
	}
	
	function updateCreateUpdateCategoryAction(action) {
	    return {
	        action: action,
	        type: CREATE_UPDATE_CATEGORY_ACTION_UPDATED
	    };
	}
	
	function resetCreateUpdateCategoryAction() {
	    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return {
	        action: action,
	        type: CREATE_UPDATE_CATEGORY_ACTION_RESET
	    };
	}
	
	function updateAssociateActivityWithOpeningTicketPurposeAction(action) {
	    return {
	        action: action,
	        type: ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(59);
	var TAG = __webpack_require__(25)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(30).f;
	var has = __webpack_require__(50);
	var TAG = __webpack_require__(25)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var defined = __webpack_require__(67);
	var fails = __webpack_require__(18);
	var spaces = __webpack_require__(224);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(232)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.get_phone_code = get_phone_code;
	exports.get_national_number_pattern = get_national_number_pattern;
	exports.get_formats = get_formats;
	exports.get_national_prefix = get_national_prefix;
	exports.get_national_prefix_formatting_rule = get_national_prefix_formatting_rule;
	exports.get_national_prefix_for_parsing = get_national_prefix_for_parsing;
	exports.get_national_prefix_transform_rule = get_national_prefix_transform_rule;
	exports.get_national_prefix_is_optional_when_formatting = get_national_prefix_is_optional_when_formatting;
	exports.get_leading_digits = get_leading_digits;
	exports.get_format_pattern = get_format_pattern;
	exports.get_format_format = get_format_format;
	exports.get_format_leading_digits_patterns = get_format_leading_digits_patterns;
	exports.get_format_national_prefix_formatting_rule = get_format_national_prefix_formatting_rule;
	exports.get_format_national_prefix_is_optional_when_formatting = get_format_national_prefix_is_optional_when_formatting;
	exports.get_format_national_prefix_is_mandatory_when_formatting = get_format_national_prefix_is_mandatory_when_formatting;
	exports.get_format_uses_national_prefix = get_format_uses_national_prefix;
	exports.get_format_international_format = get_format_international_format;
	exports.get_metadata_by_country_phone_code = get_metadata_by_country_phone_code;
	exports.get_types = get_types;
	exports.get_type_fixed_line = get_type_fixed_line;
	exports.get_type_mobile = get_type_mobile;
	exports.get_type_toll_free = get_type_toll_free;
	exports.get_type_premium_rate = get_type_premium_rate;
	exports.get_type_personal_number = get_type_personal_number;
	exports.get_type_voice_mail = get_type_voice_mail;
	exports.get_type_uan = get_type_uan;
	exports.get_type_pager = get_type_pager;
	exports.get_type_voip = get_type_voip;
	exports.get_type_shared_cost = get_type_shared_cost;
	exports.get_country_phone_code = get_country_phone_code;
	function get_phone_code(country_metadata) {
		return country_metadata[0];
	}
	
	function get_national_number_pattern(country_metadata) {
		return country_metadata[1];
	}
	
	function get_formats(country_metadata) {
		return country_metadata[2] || [];
	}
	
	function get_national_prefix(country_metadata) {
		return country_metadata[3];
	}
	
	function get_national_prefix_formatting_rule(country_metadata) {
		return country_metadata[4];
	}
	
	function get_national_prefix_for_parsing(country_metadata) {
		var national_prefix_for_parsing = country_metadata[5];
	
		// If `national_prefix_for_parsing` is not set explicitly,
		// then infer it from `national_prefix` (if any)
		if (!national_prefix_for_parsing) {
			national_prefix_for_parsing = get_national_prefix(country_metadata);
		}
	
		return national_prefix_for_parsing;
	}
	
	function get_national_prefix_transform_rule(country_metadata) {
		return country_metadata[6];
	}
	
	function get_national_prefix_is_optional_when_formatting(country_metadata) {
		return country_metadata[7];
	}
	
	function get_leading_digits(country_metadata) {
		return country_metadata[8];
	}
	
	function get_format_pattern(format_array) {
		return format_array[0];
	}
	
	function get_format_format(format_array) {
		return format_array[1];
	}
	
	function get_format_leading_digits_patterns(format_array) {
		return format_array[2] || [];
	}
	
	function get_format_national_prefix_formatting_rule(format_array, country_metadata) {
		return format_array[3] || get_national_prefix_formatting_rule(country_metadata);
	}
	
	function get_format_national_prefix_is_optional_when_formatting(format_array, country_metadata) {
		return format_array[4] || get_national_prefix_is_optional_when_formatting(country_metadata);
	}
	
	function get_format_national_prefix_is_mandatory_when_formatting(format_array, country_metadata) {
		var national_prefix_formatting_rule = get_format_national_prefix_formatting_rule(format_array, country_metadata);
	
		// National prefix is omitted if there's no national prefix formatting rule
		// set for this country, or when the national prefix formatting rule
		// contains no national prefix itself, or when this rule is set but
		// national prefix is optional for this phone number format
		// (and it is not enforced explicitly)
		return national_prefix_formatting_rule &&
		// Check that national prefix formatting rule is not a dummy one.
		// Check that national prefix formatting rule actually has national prefix digit(s).
		get_format_uses_national_prefix(national_prefix_formatting_rule) &&
		// Or maybe national prefix is optional for this format
		!get_format_national_prefix_is_optional_when_formatting(format_array, country_metadata);
	}
	
	// Checks whether national prefix formatting rule contains national prefix
	function get_format_uses_national_prefix(national_prefix_formatting_rule) {
		// Check that national prefix formatting rule is not a dummy one
		return national_prefix_formatting_rule !== '$1' &&
		// Check that national prefix formatting rule actually has national prefix digit(s)
		/\d/.test(national_prefix_formatting_rule.replace('$1', ''));
	}
	
	function get_format_international_format(format_array) {
		return format_array[5] || get_format_format(format_array);
	}
	
	// Formatting information for regions which share
	// a country calling code is contained by only one region
	// for performance reasons. For example, for NANPA region
	// ("North American Numbering Plan Administration",
	//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
	// it will be contained in the metadata for `US`.
	function get_metadata_by_country_phone_code(country_phone_code, metadata) {
		var country_code = metadata.country_phone_code_to_countries[country_phone_code][0];
		return metadata.countries[country_code];
	}
	
	function get_types(country_metadata) {
		return country_metadata[9];
	}
	
	function get_type(country_metadata, index) {
		return get_types(country_metadata) ? get_types(country_metadata)[index] : undefined;
	}
	
	function get_type_fixed_line(country_metadata) {
		return get_type(country_metadata, 0);
	}
	
	function get_type_mobile(country_metadata) {
		return get_type(country_metadata, 1);
	}
	
	function get_type_toll_free(country_metadata) {
		return get_type(country_metadata, 2);
	}
	
	function get_type_premium_rate(country_metadata) {
		return get_type(country_metadata, 3);
	}
	
	function get_type_personal_number(country_metadata) {
		return get_type(country_metadata, 4);
	}
	
	function get_type_voice_mail(country_metadata) {
		return get_type(country_metadata, 5);
	}
	
	function get_type_uan(country_metadata) {
		return get_type(country_metadata, 6);
	}
	
	function get_type_pager(country_metadata) {
		return get_type(country_metadata, 7);
	}
	
	function get_type_voip(country_metadata) {
		return get_type(country_metadata, 8);
	}
	
	function get_type_shared_cost(country_metadata) {
		return get_type(country_metadata, 9);
	}
	
	function get_country_phone_code(country, country_metadata) {
		return get_phone_code(country_metadata[country]);
	}
	//# sourceMappingURL=metadata.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DIGIT_MAPPINGS = exports.VALID_PUNCTUATION = exports.VALID_DIGITS = exports.PLUS_CHARS = undefined;
	
	var _extends2 = __webpack_require__(316);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(757);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(168);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = parse;
	exports.normalize = normalize;
	exports.replace_characters = replace_characters;
	exports.is_viable_phone_number = is_viable_phone_number;
	exports.extract_formatted_phone_number = extract_formatted_phone_number;
	exports.parse_phone_number = parse_phone_number;
	exports.parse_phone_number_and_country_phone_code = parse_phone_number_and_country_phone_code;
	exports.strip_national_prefix = strip_national_prefix;
	exports.find_country_code = find_country_code;
	
	var _common = __webpack_require__(173);
	
	var _metadata = __webpack_require__(120);
	
	var _format = __webpack_require__(238);
	
	var _types = __webpack_require__(239);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The maximum length of the country calling code.
	// This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	
	var MAX_LENGTH_COUNTRY_CODE = 3;
	
	// The minimum length of the national significant number.
	var MIN_LENGTH_FOR_NSN = 2;
	
	// The ITU says the maximum length should be 15,
	// but one can find longer numbers in Germany.
	var MAX_LENGTH_FOR_NSN = 17;
	
	// We don't allow input strings for parsing to be longer than 250 chars.
	// This prevents malicious input from consuming CPU.
	var MAX_INPUT_STRING_LENGTH = 250;
	
	var PLUS_CHARS = exports.PLUS_CHARS = '+\uFF0B';
	
	// Digits accepted in phone numbers
	// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
	var VALID_DIGITS = exports.VALID_DIGITS = '0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9';
	
	// `DASHES` will be right after the opening square bracket of the "character class"
	var DASHES = '-\u2010-\u2015\u2212\u30FC\uFF0D';
	var SLASHES = '\uFF0F/';
	var DOTS = '\uFF0E.';
	var WHITESPACE = ' \xA0\xAD\u200B\u2060\u3000';
	var BRACKETS = '()\uFF08\uFF09\uFF3B\uFF3D\\[\\]';
	var TILDES = '~\u2053\u223C\uFF5E';
	
	// Regular expression of acceptable punctuation found in phone numbers. This
	// excludes punctuation found as a leading character only. This consists of dash
	// characters, white space characters, full stops, slashes, square brackets,
	// parentheses and tildes. Full-width variants are also present.
	var VALID_PUNCTUATION = exports.VALID_PUNCTUATION = '' + DASHES + SLASHES + DOTS + WHITESPACE + BRACKETS + TILDES;
	
	// Pattern to capture digits used in an extension.
	// Places a maximum length of '7' for an extension.
	var CAPTURING_EXTN_DIGITS = '([' + VALID_DIGITS + ']{1,7})';
	
	// The RFC 3966 format for extensions.
	var RFC3966_EXTN_PREFIX = ';ext=';
	
	/**
	 * Regexp of all possible ways to write extensions, for use when parsing. This
	 * will be run as a case-insensitive regexp match. Wide character versions are
	 * also provided after each ASCII version. There are three regular expressions
	 * here. The first covers RFC 3966 format, where the extension is added using
	 * ';ext='. The second more generic one starts with optional white space and
	 * ends with an optional full stop (.), followed by zero or more spaces/tabs
	 * /commas and then the numbers themselves. The other one covers the special
	 * case of American numbers where the extension is written with a hash at the
	 * end, such as '- 503#'. Note that the only capturing groups should be around
	 * the digits that you want to capture as part of the extension, or else parsing
	 * will fail! We allow two options for representing the accented o - the
	 * character itself, and one in the unicode decomposed form with the combining
	 * acute accent.
	 */
	var EXTN_PATTERNS_FOR_PARSING = RFC3966_EXTN_PREFIX + CAPTURING_EXTN_DIGITS + '|' + '[ \xA0\\t,]*' + '(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|' + '[;,x\uFF58#\uFF03~\uFF5E]|int|anexo|\uFF49\uFF4E\uFF54)' + '[:\\.\uFF0E]?[ \xA0\\t,-]*' + CAPTURING_EXTN_DIGITS + '#?|' + '[- ]+([' + VALID_DIGITS + ']{1,5})#';
	
	// Regexp of all known extension prefixes used by different regions followed by
	// 1 or more valid digits, for use when parsing.
	var EXTN_PATTERN = new RegExp('(?:' + EXTN_PATTERNS_FOR_PARSING + ')$', 'i');
	
	//  Regular expression of viable phone numbers. This is location independent.
	//  Checks we have at least three leading digits, and only valid punctuation,
	//  alpha characters and digits in the phone number. Does not include extension
	//  data. The symbol 'x' is allowed here as valid punctuation since it is often
	//  used as a placeholder for carrier codes, for example in Brazilian phone
	//  numbers. We also allow multiple '+' characters at the start.
	//
	//  Corresponds to the following:
	//  [digits]{minLengthNsn}|
	//  plus_sign*
	//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
	//
	//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
	//  they are entered as "15" etc, but only if there is no punctuation in them.
	//  The second expression restricts the number of digits to three or more, but
	//  then allows them to be in international form, and to have alpha-characters
	//  and punctuation. We split up the two reg-exes here and combine them when
	//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
	//  with ^ and append $ to each branch.
	//
	//  "Note VALID_PUNCTUATION starts with a -,
	//   so must be the first in the range" (c) Google devs.
	//  (wtf did they mean by saying that; probably nothing)
	//
	var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}';
	//
	// And this is the second reg-exp:
	// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
	//
	var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';
	
	// The combined regular expression for valid phone numbers:
	//
	var VALID_PHONE_NUMBER_PATTERN = new RegExp(
	// Either a short two-digit-only phone number
	'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
	// Or a longer fully parsed phone number (min 3 characters)
	'^' + VALID_PHONE_NUMBER +
	// Phone number extensions
	'(?:' + EXTN_PATTERNS_FOR_PARSING + ')?' + '$', 'i');
	
	// This consists of the plus symbol, digits, and arabic-indic digits.
	var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']');
	
	// Regular expression of trailing characters that we want to remove.
	var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + ']+$');
	
	var LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+');
	
	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	var DIGIT_MAPPINGS = exports.DIGIT_MAPPINGS = {
		'0': '0',
		'1': '1',
		'2': '2',
		'3': '3',
		'4': '4',
		'5': '5',
		'6': '6',
		'7': '7',
		'8': '8',
		'9': '9',
		'\uFF10': '0', // Fullwidth digit 0
		'\uFF11': '1', // Fullwidth digit 1
		'\uFF12': '2', // Fullwidth digit 2
		'\uFF13': '3', // Fullwidth digit 3
		'\uFF14': '4', // Fullwidth digit 4
		'\uFF15': '5', // Fullwidth digit 5
		'\uFF16': '6', // Fullwidth digit 6
		'\uFF17': '7', // Fullwidth digit 7
		'\uFF18': '8', // Fullwidth digit 8
		'\uFF19': '9', // Fullwidth digit 9
		'\u0660': '0', // Arabic-indic digit 0
		'\u0661': '1', // Arabic-indic digit 1
		'\u0662': '2', // Arabic-indic digit 2
		'\u0663': '3', // Arabic-indic digit 3
		'\u0664': '4', // Arabic-indic digit 4
		'\u0665': '5', // Arabic-indic digit 5
		'\u0666': '6', // Arabic-indic digit 6
		'\u0667': '7', // Arabic-indic digit 7
		'\u0668': '8', // Arabic-indic digit 8
		'\u0669': '9', // Arabic-indic digit 9
		'\u06F0': '0', // Eastern-Arabic digit 0
		'\u06F1': '1', // Eastern-Arabic digit 1
		'\u06F2': '2', // Eastern-Arabic digit 2
		'\u06F3': '3', // Eastern-Arabic digit 3
		'\u06F4': '4', // Eastern-Arabic digit 4
		'\u06F5': '5', // Eastern-Arabic digit 5
		'\u06F6': '6', // Eastern-Arabic digit 6
		'\u06F7': '7', // Eastern-Arabic digit 7
		'\u06F8': '8', // Eastern-Arabic digit 8
		'\u06F9': '9' // Eastern-Arabic digit 9
	};
	
	var default_options = {
		country: {}
	
		// `options`:
		//  {
		//    country:
		//    {
		//      restrict - (a two-letter country code)
		//                 the phone number must be in this country
		//
		//      default - (a two-letter country code)
		//                default country to use for phone number parsing and validation
		//                (if no country code could be derived from the phone number)
		//    }
		//  }
		//
		// Returns `{ country, number }`
		//
		// Example use cases:
		//
		// ```js
		// parse('8 (800) 555-35-35', 'RU')
		// parse('8 (800) 555-35-35', 'RU', metadata)
		// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
		// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
		// parse('+7 800 555 35 35')
		// parse('+7 800 555 35 35', metadata)
		// ```
		//
	};function parse(arg_1, arg_2, arg_3) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3),
		    text = _sort_out_arguments.text,
		    options = _sort_out_arguments.options,
		    metadata = _sort_out_arguments.metadata;
	
		// Validate country codes
	
		// Validate `default` country
	
	
		if (options.country.default && !metadata.countries[options.country.default]) {
			throw new Error('Unknown country code: ' + options.country.default);
		}
	
		// Validate `restrict` country
		if (options.country.restrict && !metadata.countries[options.country.restrict]) {
			throw new Error('Unknown country code: ' + options.country.restrict);
		}
	
		// Parse the phone number
	
		var formatted_phone_number = void 0;
		var extension = void 0;
	
		// Parse RFC 3966 phone number URI.
		if (text && text.indexOf('tel:') === 0) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = (0, _getIterator3.default)(text.split(';')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var part = _step.value;
	
					var _part$split = part.split(':'),
					    _part$split2 = (0, _slicedToArray3.default)(_part$split, 2),
					    name = _part$split2[0],
					    value = _part$split2[1];
	
					switch (name) {
						case 'tel':
							formatted_phone_number = value;
							break;
						case 'ext':
							extension = value;
							break;
						case 'phone-context':
							// Domain contexts are ignored.
							if (value[0] === '+') {
								formatted_phone_number = value + formatted_phone_number;
							}
							break;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		} else {
			formatted_phone_number = extract_formatted_phone_number(text);
		}
	
		// If the phone number is not viable, then abort.
		if (!is_viable_phone_number(formatted_phone_number)) {
			return {};
		}
	
		// Attempt to parse extension first, since it doesn't require region-specific
		// data and we want to have the non-normalised number here.
		var with_extension_stripped = strip_extension(formatted_phone_number);
	
		if (with_extension_stripped.extension) {
			formatted_phone_number = with_extension_stripped.number, extension = with_extension_stripped.extension;
		}
	
		var _parse_phone_number_a = parse_phone_number_and_country_phone_code(formatted_phone_number, metadata),
		    country_phone_code = _parse_phone_number_a.country_phone_code,
		    number = _parse_phone_number_a.number;
	
		// Maybe invalid country phone code encountered
	
	
		if (!number) {
			return {};
		}
	
		var country = void 0;
		var country_metadata = void 0;
	
		// Whether the phone number is formatted as an international phone number
		var is_international = false;
	
		if (country_phone_code) {
			is_international = true;
	
			// Check country restriction
			if (options.country.restrict && country_phone_code !== (0, _metadata.get_phone_code)(metadata.countries[options.country.restrict])) {
				return {};
			}
	
			// Formatting information for regions which share
			// a country calling code is contained by only one region
			// for performance reasons. For example, for NANPA region
			// ("North American Numbering Plan Administration",
			//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
			// it will be contained in the metadata for `US`.
			country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, metadata);
	
			// `country` will be set later,
			// because, for example, for NANPA countries
			// there are several countries corresponding
			// to the same `1` country phone code.
			// Therefore, to reliably determine the exact country,
			// national (significant) number should be parsed first.
		} else if (options.country.restrict || options.country.default) {
			country = options.country.restrict || options.country.default;
			country_metadata = metadata.countries[country];
	
			number = normalize(formatted_phone_number);
		}
	
		if (!country_metadata) {
			return {};
		}
	
		var national_number = number;
	
		// Only strip national prefixes for non-international phone numbers
		// because national prefixes can't be present in international phone numbers.
		// Otherwise, while forgiving, it would parse a NANPA number `+1 1877 215 5230`
		// first to `1877 215 5230` and then, stripping the leading `1`, to `877 215 5230`,
		// and then it would assume that's a valid number which it isn't.
		// So no forgiveness for grandmas here.
		// The issue asking for this fix:
		// https://github.com/catamphetamine/libphonenumber-js/issues/159
		if (!is_international) {
			national_number = strip_national_prefix(number, country_metadata);
		}
	
		var did_have_national_prefix = national_number !== number;
	
		// https://github.com/catamphetamine/libphonenumber-js/issues/67
		// if (!is_international && !did_have_national_prefix &&
		// 		is_national_prefix_required(national_number, country_metadata))
		// {
		// 	return {}
		// }
	
		// Sometimes there are several countries
		// corresponding to the same country phone code
		// (e.g. NANPA countries all having `1` country phone code).
		// Therefore, to reliably determine the exact country,
		// national (significant) number should have been parsed first.
		//
		if (!country) {
			// When `metadata.json` is generated, all "ambiguous" country phone codes
			// get their countries populated with the full set of
			// "phone number type" regular expressions.
			country = find_country_code(country_phone_code, national_number, metadata);
	
			// Just in case there appears to be a bug in Google's metadata
			// and the exact country could not be extracted from the phone number.
			/* istanbul ignore if */
			if (!country) {
				return {};
			}
	
			// Update metadata to be for this specific country
			country_metadata = metadata.countries[country];
		}
	
		// Validate national (significant) number length.
		//
		// A sidenote:
		//
		// They say that sometimes national (significant) numbers
		// can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
		// https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
		// Such numbers will just be discarded.
		//
		if (national_number.length > MAX_LENGTH_FOR_NSN) {
			return {};
		}
	
		// National number pattern is different for each country,
		// even for those ones which are part of the "NANPA" group.
		var national_number_rule = new RegExp((0, _metadata.get_national_number_pattern)(country_metadata));
	
		// Check if national phone number pattern matches the number
		if (!(0, _common.matches_entirely)(national_number, national_number_rule)) {
			return {};
		}
	
		var result = {
			country: country,
			phone: national_number
		};
	
		if (extension) {
			result.ext = extension;
		}
	
		return result;
	}
	
	// Normalizes a string of characters representing a phone number.
	// This converts wide-ascii and arabic-indic numerals to European numerals,
	// and strips punctuation and alpha characters.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	function normalize(number) {
		return replace_characters(number, DIGIT_MAPPINGS);
	}
	
	// For any character not being part of `replacements`
	// it is removed from the phone number.
	function replace_characters(text, replacements) {
		var replaced = '';
	
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;
	
		try {
			for (var _iterator2 = (0, _getIterator3.default)(text), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var character = _step2.value;
	
				var replacement = replacements[character.toUpperCase()];
	
				if (replacement !== undefined) {
					replaced += replacement;
				}
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	
		return replaced;
	}
	
	// Checks to see if the string of characters could possibly be a phone number at
	// all. At the moment, checks to see that the string begins with at least 2
	// digits, ignoring any punctuation commonly found in phone numbers. This method
	// does not require the number to be normalized in advance - but does assume
	// that leading non-number symbols have been removed, such as by the method
	// `extract_possible_number`.
	//
	function is_viable_phone_number(number) {
		return number.length >= MIN_LENGTH_FOR_NSN && (0, _common.matches_entirely)(number, VALID_PHONE_NUMBER_PATTERN);
	}
	
	function extract_formatted_phone_number(text) {
		if (!text || text.length > MAX_INPUT_STRING_LENGTH) {
			return '';
		}
	
		// Attempt to extract a possible number from the string passed in
	
		var starts_at = text.search(PHONE_NUMBER_START_PATTERN);
	
		if (starts_at < 0) {
			return '';
		}
	
		return text
		// Trim everything to the left of the phone number
		.slice(starts_at)
		// Remove trailing non-numerical characters
		.replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
	}
	
	// Parses a formatted phone number.
	function parse_phone_number(number) {
		if (!number) {
			return '';
		}
	
		var is_international = LEADING_PLUS_CHARS_PATTERN.test(number);
	
		// Remove non-digits
		// (and strip the possible leading '+')
		number = normalize(number);
	
		if (is_international) {
			return '+' + number;
		}
	
		return number;
	}
	
	// Parses a formatted phone number
	// and returns `{ country_phone_code, number }`
	// where `number` is the national (significant) phone number.
	//
	// (aka `maybeExtractCountryPhoneCode`)
	//
	function parse_phone_number_and_country_phone_code(number, metadata) {
		number = parse_phone_number(number);
	
		if (!number) {
			return {};
		}
	
		// If this is not an international phone number,
		// then don't extract country phone code.
		if (number[0] !== '+') {
			return { number: number };
		}
	
		// Strip the leading '+' sign
		number = number.slice(1);
	
		// Fast abortion: country codes do not begin with a '0'
		if (number[0] === '0') {
			return {};
		}
	
		// The thing with country phone codes
		// is that they are orthogonal to each other
		// i.e. there's no such country phone code A
		// for which country phone code B exists
		// where B starts with A.
		// Therefore, while scanning digits,
		// if a valid country code is found,
		// that means that it is the country code.
		//
		var i = 1;
		while (i <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
			var country_phone_code = number.slice(0, i);
	
			if (metadata.country_phone_code_to_countries[country_phone_code]) {
				return { country_phone_code: country_phone_code, number: number.slice(i) };
			}
	
			i++;
		}
	
		return {};
	}
	
	// Strips any national prefix (such as 0, 1) present in the number provided
	function strip_national_prefix(number, country_metadata) {
		var national_prefix_for_parsing = (0, _metadata.get_national_prefix_for_parsing)(country_metadata);
	
		if (!number || !national_prefix_for_parsing) {
			return number;
		}
	
		// Attempt to parse the first digits as a national prefix
		var national_prefix_pattern = new RegExp('^(?:' + national_prefix_for_parsing + ')');
		var national_prefix_matcher = national_prefix_pattern.exec(number);
	
		// If no national prefix is present in the phone number,
		// but if the national prefix is optional for this country,
		// then consider this phone number valid.
		//
		// Google's reference `libphonenumber` implementation
		// wouldn't recognize such phone numbers as valid,
		// but I think it would perfectly make sense
		// to consider such phone numbers as valid
		// because if a national phone number was originally
		// formatted without the national prefix
		// then it must be parseable back into the original national number.
		// In other words, `parse(format(number))`
		// must always be equal to `number`.
		//
		if (!national_prefix_matcher) {
			return number;
		}
	
		var national_significant_number = void 0;
	
		// `national_prefix_for_parsing` capturing groups
		// (used only for really messy cases: Argentina, Brazil, Mexico, Somalia)
		var any_groups_were_captured = national_prefix_matcher[national_prefix_matcher.length - 1];
		var national_prefix_transform_rule = (0, _metadata.get_national_prefix_transform_rule)(country_metadata);
	
		// If the national number tranformation is needed then do it
		if (national_prefix_transform_rule && any_groups_were_captured) {
			national_significant_number = number.replace(national_prefix_pattern, national_prefix_transform_rule);
		}
		// Else, no transformation is necessary,
		// and just strip the national prefix.
		else {
				national_significant_number = number.slice(national_prefix_matcher[0].length);
			}
	
		// Verify the parsed national (significant) number for this country
		var national_number_rule = new RegExp((0, _metadata.get_national_number_pattern)(country_metadata));
	
		// If the original number (before stripping national prefix) was viable,
		// and the resultant number is not, then prefer the original phone number.
		// This is because for some countries (e.g. Russia) the same digit could be both
		// a national prefix and a leading digit of a valid national phone number,
		// like `8` is the national prefix for Russia and both
		// `8 800 555 35 35` and `800 555 35 35` are valid numbers.
		if ((0, _common.matches_entirely)(number, national_number_rule) && !(0, _common.matches_entirely)(national_significant_number, national_number_rule)) {
			return number;
		}
	
		// Return the parsed national (significant) number
		return national_significant_number;
	}
	
	function find_country_code(country_phone_code, national_phone_number, metadata) {
		// Is always non-empty, because `country_phone_code` is always valid
		var possible_countries = metadata.country_phone_code_to_countries[country_phone_code];
	
		// If there's just one country corresponding to the country code,
		// then just return it, without further phone number digits validation.
		if (possible_countries.length === 1) {
			return possible_countries[0];
		}
	
		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;
	
		try {
			for (var _iterator3 = (0, _getIterator3.default)(possible_countries), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var country_code = _step3.value;
	
				var country = metadata.countries[country_code];
	
				// Leading digits check would be the simplest one
				if ((0, _metadata.get_leading_digits)(country)) {
					if (national_phone_number && national_phone_number.search((0, _metadata.get_leading_digits)(country)) === 0) {
						return country_code;
					}
				}
				// Else perform full validation with all of those bulky
				// fixed-line/mobile/etc regular expressions.
				else if ((0, _types2.default)({ phone: national_phone_number, country: country_code }, metadata)) {
						return country_code;
					}
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}
	}
	
	// export function is_national_prefix_required(national_number, country_metadata)
	// {
	// 	const format = choose_format_for_number(get_formats(country_metadata), national_number)
	//
	// 	if (format)
	// 	{
	// 		return get_format_national_prefix_is_mandatory_when_formatting(format, country_metadata)
	// 	}
	// }
	
	// Sort out arguments
	function sort_out_arguments(arg_1, arg_2, arg_3) {
		var text = void 0;
		var options = void 0;
		var metadata = void 0;
	
		// Normalize numerical `value`.
		// https://github.com/catamphetamine/libphonenumber-js/issues/142
		// `parse(88005553535, ...)`.
		if (typeof arg_1 === 'number') {
			arg_1 = String(arg_1);
		}
	
		// If the phone number is passed as a string.
		// `parse('88005553535', ...)`.
		if (typeof arg_1 === 'string') {
			text = arg_1;
		}
	
		// If "resrict country" argument is being passed
		// then convert it to an `options` object.
		// `parse('88005553535', 'RU', [options], metadata)`.
		if (typeof arg_2 === 'string') {
			options = { country: { restrict: arg_2 } };
			metadata = arg_3;
		}
		// No "resrict country" argument is being passed.
		// International phone number is passed.
		// `parse('+78005553535', [options], metadata)`.
		else {
				if (arg_3) {
					options = arg_2;
					metadata = arg_3;
				} else {
					metadata = arg_2;
				}
			}
	
		// Metadata is required.
		if (!metadata || !metadata.countries) {
			throw new Error('Metadata is required');
		}
	
		// Apply default options.
		if (options) {
			options = (0, _extends3.default)({}, default_options, options);
		} else {
			options = default_options;
		}
	
		return { text: text, options: options, metadata: metadata };
	}
	
	// Strips any extension (as in, the part of the number dialled after the call is
	// connected, usually indicated with extn, ext, x or similar) from the end of
	// the number, and returns it.
	function strip_extension(number) {
		var start = number.search(EXTN_PATTERN);
		if (start < 0) {
			return {};
		}
	
		// If we find a potential extension, and the number preceding this is a viable
		// number, we assume it is an extension.
		var number_without_extension = number.slice(0, start);
		/* istanbul ignore if - seems a bit of a redundant check */
		if (!is_viable_phone_number(number_without_extension)) {
			return {};
		}
	
		var matches = number.match(EXTN_PATTERN);
		var i = 1;
		while (i < matches.length) {
			if (matches[i] != null && matches[i].length > 0) {
				return {
					number: number_without_extension,
					extension: matches[i]
				};
			}
			i++;
		}
	}
	//# sourceMappingURL=parse.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.routeReducer = exports.GONE_BACK = exports.HISTORY_CLEARED = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.goBack = goBack;
	exports.push = push;
	exports.clearHistory = clearHistory;
	exports.connectLocationChangeLock = connectLocationChangeLock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(148);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NAMESPACE = 'Core';
	var HISTORY_CLEARED = exports.HISTORY_CLEARED = NAMESPACE + '/HistoryCleared';
	var GONE_BACK = exports.GONE_BACK = NAMESPACE + '/GoneBack';
	
	// actions
	
	function goBack() {
	    return function (state) {
	        var _state$router = state.router,
	            history = _state$router.history,
	            back = _state$router.back;
	
	
	        if (back) {
	            window.location = back;
	            return {
	                type: GONE_BACK
	            };
	        }
	        return (0, _reactRouterRedux.replace)(state.router.history[1] || '/');
	    };
	}
	
	function push(nextPathname) {
	    return function (state) {
	        var location = state.router.location;
	
	        var pathnameSegments = location.pathname.split('/').slice(1);
	
	        nextPathname = nextPathname.replace(/^\/\*/, '/' + pathnameSegments[0]);
	        nextPathname = nextPathname.replace(/^(\/[\w-]+)\/\*/, '$1/' + pathnameSegments[1]);
	        nextPathname = nextPathname.replace(/^(\/[\w-]+\/[\w-]+)\/\*/, '$1/' + pathnameSegments[2]);
	        return (0, _reactRouterRedux.push)(nextPathname);
	    };
	}
	
	function clearHistory() {
	    return {
	        type: HISTORY_CLEARED
	    };
	}
	
	// reducers
	
	function locationBeforeTransitions() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _reactRouterRedux.LOCATION_CHANGE:
	            return action.payload;
	        default:
	            return state;
	    }
	}
	
	function location() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _reactRouterRedux.LOCATION_CHANGE:
	            return action.payload;
	        default:
	            return state;
	    }
	}
	
	function history() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _reactRouterRedux.LOCATION_CHANGE:
	            var nextLocation = action.payload;
	
	            if (nextLocation.action == 'REPLACE') {
	                // replace location
	                if (nextLocation.pathname == (state[1] && state[1].pathname)) return [nextLocation];
	                return [nextLocation, state[1]];
	            }
	
	            if (nextLocation.action == 'POP') {
	                // replace location
	                return [nextLocation, state[0]];
	            }
	
	            if (nextLocation.pathname == (state[0] && state[0].pathname)) {
	                // replace location
	                return [nextLocation, state[1]];
	            }
	
	            // push location
	            return [nextLocation, state[0]];
	        case HISTORY_CLEARED:
	            return [state[0]];
	        default:
	            return state;
	    }
	}
	
	function back() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return state;
	}
	
	var routeReducer = exports.routeReducer = (0, _redux.combineReducers)({ locationBeforeTransitions: locationBeforeTransitions, location: location, history: history, back: back });
	
	// higher order component
	
	function connectLocationChangeLock() {
	    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return function (WrappedComponent) {
	        var LocationChangeLockConnector = function (_Component) {
	            _inherits(LocationChangeLockConnector, _Component);
	
	            function LocationChangeLockConnector(props) {
	                _classCallCheck(this, LocationChangeLockConnector);
	
	                var _this = _possibleConstructorReturn(this, (LocationChangeLockConnector.__proto__ || Object.getPrototypeOf(LocationChangeLockConnector)).call(this, props));
	
	                _this.state = {
	                    locationChanged: false
	                };
	                return _this;
	            }
	
	            _createClass(LocationChangeLockConnector, [{
	                key: 'componentWillReceiveProps',
	                value: function componentWillReceiveProps(nextProps) {
	                    if (nextProps.location != this.props.location) {
	                        var _location = nextProps.location;
	
	
	                        var locationChanged = !option.pathName || _location.pathname.match(option.pathName) == null;
	                        this.setState({ locationChanged: locationChanged });
	                    }
	                }
	            }, {
	                key: 'shouldComponentUpdate',
	                value: function shouldComponentUpdate(nextProps, nextState) {
	                    return !nextState.locationChanged;
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    return _react2.default.createElement(WrappedComponent, this.props);
	                }
	            }]);
	
	            return LocationChangeLockConnector;
	        }(_react.Component);
	
	        return LocationChangeLockConnector;
	    };
	}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddContactCmd = exports.UpdatePatrimonyContactIdentityCmd = exports.LinkPatrimonyContactWithCmd = exports.AddAddressToLotCmd = exports.AddComplementaryAddressToPatrimonyCmd = exports.UpdateLotCmd = exports.UpdatePatrimonyCmd = exports.ReferencePatrimonyContactCmd = exports.ReferenceLotCmd = exports.ReferencePatrimonyCmd = exports.ContactCriteria = exports.Criteria = exports.Contact = exports.CONTACT_LOT_LINK_TYPES = exports.CONTACT_PATRIMONY_LINK_TYPES = exports.NON_REFERENCED_LOT_POSITIONS = exports.HOME_OWNER_ASSOCIATION_POSITIONS = exports.USAGES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createValidator = createValidator;
	
	var _jjv = __webpack_require__(172);
	
	var _jjv2 = _interopRequireDefault(_jjv);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _extract = __webpack_require__(12);
	
	var _validate = __webpack_require__(532);
	
	var _phonez = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var USAGES = exports.USAGES = {
	    residential: ['ResidentialParking', 'ResidentialCellar', 'ResidentialAnnex', 'Apartment', 'IndividualHouse'],
	    tertiary: ['TertiaryParking', 'Workspace', 'Workstation', 'Office', 'RetailShop', 'Warehouse', 'GasStation'],
	    service: ['MeetingRoom', 'Restaurant', 'Fitness', 'SPA', 'SportFacility', 'Pool', 'PoolHouse', 'Playground', 'Laundry', 'OtherService'],
	    technical: ['BoilerRoom', 'Elevator', 'VentilationSystem', 'Gate', 'Intercom', 'BinStorageArea', 'MachineRoom', 'GardeningShed', 'OtherTechnical']
	};
	
	var HOME_OWNER_ASSOCIATION_POSITIONS = exports.HOME_OWNER_ASSOCIATION_POSITIONS = ['Member', 'President'];
	var NON_REFERENCED_LOT_POSITIONS = exports.NON_REFERENCED_LOT_POSITIONS = ['Tenant', 'Owner', 'Landlord'];
	
	var CONTACT_PATRIMONY_LINK_TYPES = exports.CONTACT_PATRIMONY_LINK_TYPES = ['LinkToPatrimonyAsCareTaker', 'LinkToPatrimonyAsHomeOwnerAssociation', 'LinkToNonReferencedLot'];
	var CONTACT_LOT_LINK_TYPES = exports.CONTACT_LOT_LINK_TYPES = ['LinkToLotAsTenant', 'LinkToLotAsOwner', 'LinkToLotAsLandlord'];
	
	function createValidator() {
	    var validator = (0, _jjv2.default)();
	
	    validator.addCheck('anyRequired', _validate.anyRequired);
	    validator.addFormat('phone', _phonez.phoneFormat);
	    return validator;
	}
	
	var Contact = exports.Contact = function Contact() {
	    _classCallCheck(this, Contact);
	};
	
	Contact.filterLinkedWith = function (contact, _ref) {
	    var patrimony = _ref.patrimony,
	        lot = _ref.lot;
	
	    var patrimonyUid = patrimony && patrimony.uid || patrimony;
	    var lotUid = lot && lot.uid || lot;
	
	    if (contact && contact.linkedWith) {
	        if (patrimonyUid) {
	            return contact.linkedWith.filter(function (l) {
	                return (l.patrimony && l.patrimony.uid) === patrimonyUid && l.linkType !== 'NonMember';
	            });
	        }
	        if (lotUid) {
	            return CONTACT_LOT_LINK_TYPES.reduce(function (result, linkType) {
	                var link = contact.linkedWith.find(function (l) {
	                    return l.linkType === linkType && (l.lot && l.lot.uid) === lotUid;
	                });
	                if (link) {
	                    result.push(link);
	                }
	                return result;
	            }, []);
	        }
	        return contact.linkedWith;
	    }
	    return [];
	};
	
	Contact.extractLinkedWith = function (target, link) {
	    var linkType = (0, _extract.sanitize)(link && link.linkType);
	
	    if (target) {
	        var position = link && link.position;
	        var targetLinkType = target[linkType];
	
	        switch (linkType) {
	            case 'linkToPatrimonyAsHomeOwnerAssociation':
	                return targetLinkType && targetLinkType[(0, _extract.sanitize)(position)] || linkType;
	            case 'linkToNonReferencedLot':
	                return targetLinkType && targetLinkType[(0, _extract.sanitize)(link.linkedAs)] || linkType;
	            default:
	                return targetLinkType || linkType;
	        }
	    }
	    return linkType;
	};
	
	var Criteria = exports.Criteria = function Criteria() {
	    _classCallCheck(this, Criteria);
	};
	
	Criteria.schema = {
	    type: 'object',
	    properties: {
	        fullText: { type: 'string' },
	        agencyUids: { type: 'array' }
	    }
	};
	
	var ContactCriteria = exports.ContactCriteria = function ContactCriteria() {
	    _classCallCheck(this, ContactCriteria);
	};
	
	ContactCriteria.schema = {
	    type: 'object',
	    properties: {
	        fullText: { type: 'string' },
	        patrimonyUids: { type: 'string' }
	    }
	};
	
	var ReferencePatrimonyCmd = exports.ReferencePatrimonyCmd = function ReferencePatrimonyCmd() {
	    _classCallCheck(this, ReferencePatrimonyCmd);
	};
	
	ReferencePatrimonyCmd.schema = {
	    type: 'object',
	    properties: {
	        ref: { type: 'string' },
	        label: { type: 'string' },
	        agencyUids: {
	            type: 'array',
	            minItems: 1
	        }
	    },
	    required: ['ref', 'label', 'agencyUids']
	};
	
	var ReferenceLotCmd = exports.ReferenceLotCmd = function ReferenceLotCmd() {
	    _classCallCheck(this, ReferenceLotCmd);
	};
	
	ReferenceLotCmd.schema = {
	    type: 'object',
	    properties: {
	        ref: { type: 'string' },
	        lotNumber: { type: 'string' },
	        usage: { type: 'string' },
	        addresses: {
	            type: 'array',
	            minItems: 1,
	            items: {
	                type: 'object',
	                properties: {
	                    number: { type: ['string', 'null'] },
	                    street: { type: 'string' },
	                    zipCode: { type: 'string' },
	                    city: { type: 'string' },
	                    recipientSupplement: {
	                        properties: {
	                            entrance: { type: ['string', 'null'] },
	                            elevator: { type: ['string', 'null'] },
	                            staircase: { type: ['string', 'null'] },
	                            floor: { type: ['string', 'null'] },
	                            unit: { type: ['string', 'null'] }
	                        }
	                    },
	                    digicode: { type: ['string', 'null'] },
	                    building: {
	                        properties: {
	                            uid: { type: ['string', 'null'] },
	                            label: { type: ['string', 'null'] }
	                        }
	                    }
	                },
	                required: ['street', 'zipCode', 'city']
	            }
	        }
	    },
	    required: ['ref', 'lotNumber', 'usage', 'addresses']
	};
	
	var ReferencePatrimonyContactCmd = exports.ReferencePatrimonyContactCmd = function ReferencePatrimonyContactCmd() {
	    _classCallCheck(this, ReferencePatrimonyContactCmd);
	};
	
	ReferencePatrimonyContactCmd.schemaCache = (0, _cache2.default)();
	
	ReferencePatrimonyContactCmd.schema = {
	    type: 'object',
	    properties: {
	        namez: {
	            type: 'object',
	            properties: {
	                firstName: { type: 'string' },
	                lastName: { type: 'string' },
	                gender: { type: ['string', 'null'] },
	                company: { type: ['string', 'null'] }
	            },
	            required: ['firstName', 'lastName']
	        },
	        linkedWithEntities: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    lotUid: { type: 'string' },
	                    linkType: {
	                        type: 'string',
	                        enum: ['LinkToLotAsTenant', 'LinkToLotAsOwner', 'LinkToLotAsLandlord']
	                    }
	                },
	                required: ['lotUid', 'linkType']
	            }, {
	                type: 'object',
	                properties: {
	                    patrimonyUid: { type: 'string' },
	                    linkType: {
	                        type: 'string',
	                        enum: ['LinkToPatrimonyAsCareTaker']
	                    }
	                },
	                required: ['patrimonyUid', 'linkType']
	            }, {
	                type: 'object',
	                properties: {
	                    patrimonyUid: { type: 'string' },
	                    position: { type: 'string' },
	                    linkType: {
	                        type: 'string',
	                        enum: ['LinkToPatrimonyAsHomeOwnerAssociation']
	                    }
	                },
	                required: ['patrimonyUid', 'position', 'linkType']
	            }, {
	                type: 'object',
	                properties: {
	                    patrimonyUid: { type: 'string' },
	                    linkedAs: { type: 'string' },
	                    linkType: {
	                        type: 'string',
	                        enum: ['LinkToNonReferencedLot']
	                    }
	                },
	                required: ['patrimonyUid', 'linkedAs', 'linkType']
	            }]
	        },
	        linkedWithPatrimonyAsHomeOwnerAssociation: {
	            type: ['object', 'null'],
	            properties: {
	                patrimonyUid: { type: 'string' },
	                position: { type: 'string' },
	                linkType: {
	                    type: 'string',
	                    enum: ['LinkToPatrimonyAsHomeOwnerAssociation']
	                }
	            },
	            required: ['patrimonyUid', 'position', 'linkType']
	        },
	        linkedToNonReferencedLot: {
	            type: ['object', 'null'],
	            properties: {
	                patrimonyUid: { type: 'string' },
	                position: { type: 'string' },
	                linkType: {
	                    type: 'string',
	                    enum: ['LinkedToNonReferencedLot']
	                }
	            },
	            required: ['patrimonyUid', 'position', 'linkType']
	        },
	        contacts: {
	            type: 'array',
	            minItems: 1,
	            items: {
	                oneOf: [{
	                    type: 'object',
	                    properties: {
	                        phone: {
	                            type: 'string',
	                            format: 'phone'
	                        }
	                    },
	                    required: ['phone']
	                }, {
	                    type: 'object',
	                    properties: {
	                        mail: {
	                            type: 'string',
	                            format: 'email'
	                        }
	                    },
	                    required: ['mail']
	                }, {
	                    type: 'object',
	                    properties: {
	                        fax: {
	                            type: 'string',
	                            format: 'phone'
	                        }
	                    },
	                    required: ['fax']
	                }]
	            }
	        },
	        address: {
	            type: ['object', 'null'],
	            properties: {
	                number: { type: ['string', 'null'] },
	                street: { type: 'string' },
	                zipCode: { type: 'string' },
	                city: { type: 'string' },
	                staircase: { type: ['string', 'null'] },
	                floor: { type: ['string', 'null'] },
	                digicode: { type: ['string', 'null'] }
	            },
	            required: ['street', 'zipCode', 'city']
	        }
	    },
	    required: ['namez', 'linkedWithEntities', 'contacts']
	};
	
	ReferencePatrimonyContactCmd.selectSchema = function (cmd) {
	    var linkType = cmd && cmd.linkedWithEntities && cmd.linkedWithEntities.linkType || CONTACT_PATRIMONY_LINK_TYPES[0];
	
	    return ReferencePatrimonyContactCmd.schemaCache(linkType, function () {
	        var linkedWithEntitiesSchema = ReferencePatrimonyContactCmd.schema.properties.linkedWithEntities.oneOf.find(function (schema) {
	            return schema.properties.linkType.enum.indexOf(linkType) >= 0;
	        });
	
	        var schema = _extends({}, ReferencePatrimonyContactCmd.schema, {
	            properties: _extends({}, ReferencePatrimonyContactCmd.schema.properties, {
	                linkedWithEntities: linkedWithEntitiesSchema
	            })
	        });
	
	        if (linkType != 'LinkToLotAsOwner' && linkType != 'LinkToLotAsLandlord') {
	            delete schema.properties.linkedWithPatrimonyAsHomeOwnerAssociation;
	        }
	        return schema;
	    });
	};
	
	var UpdatePatrimonyCmd = exports.UpdatePatrimonyCmd = function UpdatePatrimonyCmd() {
	    _classCallCheck(this, UpdatePatrimonyCmd);
	};
	
	UpdatePatrimonyCmd.schema = {
	    type: 'object',
	    properties: {
	        ref: { type: 'string' },
	        label: { type: 'string' }
	    },
	    required: ['ref', 'label']
	};
	
	var UpdateLotCmd = exports.UpdateLotCmd = function UpdateLotCmd() {
	    _classCallCheck(this, UpdateLotCmd);
	};
	
	UpdateLotCmd.schema = {
	    type: 'object',
	    properties: {
	        ref: { type: ['string', 'null'] },
	        lotNumber: { type: ['string', 'null'] },
	        usage: { type: ['string', 'null'] }
	    },
	    anyRequired: ['ref', 'lotNumber', 'usage']
	};
	
	var AddComplementaryAddressToPatrimonyCmd = exports.AddComplementaryAddressToPatrimonyCmd = function AddComplementaryAddressToPatrimonyCmd() {
	    _classCallCheck(this, AddComplementaryAddressToPatrimonyCmd);
	};
	
	AddComplementaryAddressToPatrimonyCmd.schema = {
	    type: 'object',
	    properties: {
	        complementaryAddress: {
	            type: 'object',
	            properties: {
	                number: { type: ['string', 'null'] },
	                street: { type: 'string' },
	                zipCode: { type: 'string' },
	                city: { type: 'string' }
	            },
	            required: ['street', 'zipCode', 'city']
	        }
	    },
	    required: ['complementaryAddress']
	};
	
	var AddAddressToLotCmd = exports.AddAddressToLotCmd = function AddAddressToLotCmd() {
	    _classCallCheck(this, AddAddressToLotCmd);
	};
	
	AddAddressToLotCmd.schema = {
	    type: 'object',
	    properties: {
	        address: {
	            type: 'object',
	            properties: {
	                number: { type: ['string', 'null'] },
	                street: { type: 'string' },
	                zipCode: { type: 'string' },
	                city: { type: 'string' },
	                recipientSupplement: {
	                    properties: {
	                        entrance: { type: ['string', 'null'] },
	                        elevator: { type: ['string', 'null'] },
	                        staircase: { type: ['string', 'null'] },
	                        floor: { type: ['string', 'null'] },
	                        unit: { type: ['string', 'null'] }
	                    }
	                },
	                digicode: { type: ['string', 'null'] },
	                building: {
	                    properties: {
	                        uid: { type: ['string', 'null'] },
	                        label: { type: ['string', 'null'] }
	                    }
	                }
	            },
	            required: ['street', 'zipCode', 'city']
	        }
	    },
	    required: ['address']
	};
	
	var LinkPatrimonyContactWithCmd = exports.LinkPatrimonyContactWithCmd = function LinkPatrimonyContactWithCmd() {
	    _classCallCheck(this, LinkPatrimonyContactWithCmd);
	};
	
	LinkPatrimonyContactWithCmd.schemaCache = (0, _cache2.default)();
	
	LinkPatrimonyContactWithCmd.schema = {
	    type: 'object',
	    properties: {
	        linkedWith: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    lotUid: { type: 'string' },
	                    linkType: {
	                        type: 'string',
	                        enum: ['LinkToLotAsTenant', 'LinkToLotAsOwner', 'LinkToLotAsLandlord']
	                    }
	                },
	                required: ['lotUid', 'linkType']
	            }, {
	                type: 'object',
	                properties: {
	                    patrimonyUid: { type: 'string' },
	                    linkType: {
	                        type: 'string',
	                        enum: ['LinkToPatrimonyAsCareTaker']
	                    }
	                },
	                required: ['patrimonyUid', 'linkType']
	            }, {
	                type: 'object',
	                properties: {
	                    patrimonyUid: { type: 'string' },
	                    position: { type: 'string' },
	                    linkType: {
	                        type: 'string',
	                        enum: ['LinkToPatrimonyAsHomeOwnerAssociation']
	                    }
	                },
	                required: ['patrimonyUid', 'position', 'linkType']
	            }]
	        }
	    },
	    required: ['linkedWith']
	};
	
	LinkPatrimonyContactWithCmd.selectSchema = function (cmd) {
	    var linkType = cmd && cmd.linkedWith && cmd.linkedWith.linkType || CONTACT_PATRIMONY_LINK_TYPES[0];
	
	    return LinkPatrimonyContactWithCmd.schemaCache(linkType, function () {
	        var linkedWithSchema = LinkPatrimonyContactWithCmd.schema.properties.linkedWith.oneOf.find(function (schema) {
	            return schema.properties.linkType.enum.indexOf(linkType) >= 0;
	        });
	
	        return _extends({}, LinkPatrimonyContactWithCmd.schema, {
	            properties: _extends({}, LinkPatrimonyContactWithCmd.schema.properties, {
	                linkedWith: linkedWithSchema
	            })
	        });
	    });
	};
	
	var UpdatePatrimonyContactIdentityCmd = exports.UpdatePatrimonyContactIdentityCmd = function UpdatePatrimonyContactIdentityCmd() {
	    _classCallCheck(this, UpdatePatrimonyContactIdentityCmd);
	};
	
	UpdatePatrimonyContactIdentityCmd.schema = {
	    type: 'object',
	    properties: {
	        namez: {
	            type: 'object',
	            properties: {
	                firstName: { type: 'string' },
	                lastName: { type: 'string' },
	                gender: { type: ['string', 'null'] },
	                company: { type: ['string', 'null'] }
	            },
	            required: ['firstName', 'lastName']
	        },
	        address: {
	            type: 'object',
	            properties: {
	                number: { type: ['string', 'null'] },
	                street: { type: 'string' },
	                zipCode: { type: 'string' },
	                city: { type: 'string' },
	                staircase: { type: ['string', 'null'] },
	                floor: { type: ['string', 'null'] },
	                digicode: { type: ['string', 'null'] }
	            },
	            required: ['street', 'zipCode', 'city']
	        }
	    },
	    required: ['namez']
	};
	
	var AddContactCmd = exports.AddContactCmd = function AddContactCmd() {
	    _classCallCheck(this, AddContactCmd);
	};
	
	AddContactCmd.schema = {
	    type: 'object',
	    properties: {
	        contact: {
	            oneOf: [{
	                type: 'object',
	                properties: {
	                    phone: {
	                        type: 'string',
	                        format: 'phone'
	                    }
	                },
	                required: ['phone']
	            }, {
	                type: 'object',
	                properties: {
	                    mail: {
	                        type: 'string',
	                        format: 'email'
	                    }
	                },
	                required: ['mail']
	            }, {
	                type: 'object',
	                properties: {
	                    fax: {
	                        type: 'string',
	                        format: 'phone'
	                    }
	                },
	                required: ['fax']
	            }]
	        }
	    },
	    required: ['contact']
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(1054);
	
	/**
	 * Checks whether a prop provides a type of element.
	 *
	 * The type of element can be provided in two forms:
	 * - tag name (string)
	 * - a return value of React.createClass(...)
	 *
	 * @param props
	 * @param propName
	 * @param componentName
	 * @returns {Error|undefined}
	 */
	
	function validate(props, propName, componentName) {
	  var errBeginning = _common.errMsg(props, propName, componentName, '. Expected an Element `type`');
	
	  if (typeof props[propName] !== 'function') {
	    if (_react2['default'].isValidElement(props[propName])) {
	      return new Error(errBeginning + ', not an actual Element');
	    }
	
	    if (typeof props[propName] !== 'string') {
	      return new Error(errBeginning + ' such as a tag name or return value of React.createClass(...)');
	    }
	  }
	}
	
	exports['default'] = _common.createChainableTypeChecker(validate);
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	__webpack_require__(2066);
	
	__webpack_require__(2067);
	
	__webpack_require__(2068);
	
	__webpack_require__(2069);
	
	__webpack_require__(2070);
	
	__webpack_require__(2071);
	
	__webpack_require__(2072);
	
	var _Helmet = __webpack_require__(2063);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	exports["default"] = _Helmet2["default"];
	module.exports = exports["default"];

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        errorTypeEnum: {
	            anotherCampaignIsAlreadyStarted: 'Une autre campagne est en cours',
	            ticketWasNotOpenedInTheElligiblePeriodForThisCampaign: 'Ce ticket est trop ancien pour être éligible dans cette campagne de satisfaction',
	            alreadyExistSatisfactionCampaignAnswerForThisTicket: 'Une note de satisfaction a déjà été donnée pour ce ticket'
	        },
	        satisfaction: 'satisfaction',
	        campaign: 'campagne de satisfaction',
	        newCampaign: 'nouvelle campagne de satisfaction',
	        answer: 'réponse',
	        answers: 'réponses',
	        answerCount: 'nombre de réponses',
	        answerRate: 'taux de réponses',
	        answerRateGoal: 'objectif de taux de réponses',
	        forAnswerGoal: 'pour un objectif de {answerGoal}%',
	        question: 'question',
	        questions: 'questions',
	        notationScale: 'échelle de notation',
	        notationScalePosition: 'position',
	        notationScaleLabel: 'réponse',
	        addNotationScale: 'ajouter',
	        synthesis: 'synthèse',
	        ticket: 'ticket',
	        rate: 'taux',
	        score: 'notation',
	        averageScore: 'note moyenne',
	        start: 'activer',
	        startCampaign: 'activer la campagne',
	        startCampaignText: ['Vous êtes sur le point d\'activer la campagne de satisfaction {title}.', 'Attention, une fois démarrée, il ne vous sera plus possible d\'ajouter de questions ou de modifier l\'échelle de notation.'],
	        finish: 'arrêter',
	        finishCampaign: 'arrêter la campagne',
	        finishCampaignText: ['Vous êtes sur le point d\'arrêter la campagne de satisfaction {title}.', 'Attention, une fois arrêtée, il ne vous sera plus possible de redémarrer la campagne, il vous faudra en créer une nouvelle.'],
	        elligibleTicketDate: 'date d\'éligibilité des tickets',
	        outOfEligibleTicketCount: 'sur {ticketCount} tickets éligibles',
	        globalComment: 'Commentaire général'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(11);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(59);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(60);
	var global = __webpack_require__(16);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(83) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(11);
	var aFunction = __webpack_require__(37);
	var SPECIES = __webpack_require__(25)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(171);
	var createDesc = __webpack_require__(325);
	module.exports = __webpack_require__(118) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	/**
	 * Maps children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} mapFunction.
	 * @param {*} mapContext Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapValidComponents(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (_react2['default'].isValidElement(child)) {
	      var lastIndex = index;
	      index++;
	      return func.call(context, child, lastIndex);
	    }
	
	    return child;
	  });
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc.
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachValidComponents(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.forEach(children, function (child) {
	    if (_react2['default'].isValidElement(child)) {
	      func.call(context, child, index);
	      index++;
	    }
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function numberOfValidComponents(children) {
	  var count = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (_react2['default'].isValidElement(child)) {
	      count++;
	    }
	  });
	
	  return count;
	}
	
	/**
	 * Determine if the Child container has one or more "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @returns {boolean}
	 */
	function hasValidComponent(children) {
	  var hasValid = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!hasValid && _react2['default'].isValidElement(child)) {
	      hasValid = true;
	    }
	  });
	
	  return hasValid;
	}
	
	function find(children, finder) {
	  var child = undefined;
	
	  forEachValidComponents(children, function (c, idx) {
	    if (!child && finder(c, idx, children)) {
	      child = c;
	    }
	  });
	
	  return child;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} findFunc.
	 * @param {*} findContext Context for findContext.
	 * @returns {array} of children that meet the findFunc return statement
	 */
	function findValidComponents(children, func, context) {
	  var index = 0;
	  var returnChildren = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (_react2['default'].isValidElement(child)) {
	      if (func.call(context, child, index)) {
	        returnChildren.push(child);
	      }
	      index++;
	    }
	  });
	
	  return returnChildren;
	}
	
	exports['default'] = {
	  map: mapValidComponents,
	  forEach: forEachValidComponents,
	  numberOf: numberOfValidComponents,
	  find: find,
	  findValidComponents: findValidComponents,
	  hasValidComponent: hasValidComponent
	};
	module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(2133);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(469);
	var EventPluginUtils = __webpack_require__(819);
	var ReactErrorUtils = __webpack_require__(482);
	
	var accumulateInto = __webpack_require__(491);
	var forEachAccumulated = __webpack_require__(492);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(77);
	var EventPluginHub = __webpack_require__(141);
	
	var warning = __webpack_require__(23);
	
	var accumulateInto = __webpack_require__(491);
	var forEachAccumulated = __webpack_require__(492);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(106);
	
	var getEventTarget = __webpack_require__(251);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_ANSWER_QUERY = exports.DEFAULT_CAMPAIGN_QUERY = exports.DEFAULT_QUERY = exports.ANSWER_ACTION_UPDATED = exports.START_CAMPAIGN_ACTION_UPDATED = exports.DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED = exports.ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED = exports.UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED = exports.UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED = exports.CREATE_CAMPAIGN_ACTION_UPDATED = exports.ANSWER_ACTION_SENT = exports.FINISH_CAMPAIGN_ACTION_SENT = exports.START_CAMPAIGN_ACTION_SENT = exports.DEFINE_ANSWER_RATE_GOAL_ACTION_SENT = exports.REMOVE_QUESTION_FROM_CAMPAIGN_ACTION_SENT = exports.ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT = exports.UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT = exports.UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT = exports.CREATE_CAMPAIGN_ACTION_SENT = exports.ANSWER_STREAM_QUERIED = exports.ANSWER_STREAM_LOADED = exports.CAMPAIGN_QUERIED = exports.CAMPAIGN_LOADED = exports.CAMPAIGN_STREAM_LOADED = exports.CAMPAIGN_LINKS_LOADED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadCampaignLinks = loadCampaignLinks;
	exports.loadCampaignStream = loadCampaignStream;
	exports.queryCampaign = queryCampaign;
	exports.loadCampaign = loadCampaign;
	exports.queryActiveCampaign = queryActiveCampaign;
	exports.loadActiveCampaign = loadActiveCampaign;
	exports.queryAnswerStream = queryAnswerStream;
	exports.loadAnswerStream = loadAnswerStream;
	exports.sendCreateCampaignAction = sendCreateCampaignAction;
	exports.sendUpdateNotationScaleOfCampaignAction = sendUpdateNotationScaleOfCampaignAction;
	exports.sendUpdateTitleOfCampaignAction = sendUpdateTitleOfCampaignAction;
	exports.sendAddQuestionToCampaignAction = sendAddQuestionToCampaignAction;
	exports.sendRemoveQuestionFromCampaignAction = sendRemoveQuestionFromCampaignAction;
	exports.sendDefineAnswerRateGoalAction = sendDefineAnswerRateGoalAction;
	exports.sendStartCampaignAction = sendStartCampaignAction;
	exports.sendFinishCampaignAction = sendFinishCampaignAction;
	exports.sendAnswerAction = sendAnswerAction;
	exports.updateCreateCampaignAction = updateCreateCampaignAction;
	exports.updateUpdateNotationScaleOfCampaignAction = updateUpdateNotationScaleOfCampaignAction;
	exports.updateUpdateTitleOfCampaignAction = updateUpdateTitleOfCampaignAction;
	exports.updateDefineAnswerRateGoalAction = updateDefineAnswerRateGoalAction;
	exports.updateAnswerAction = updateAnswerAction;
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NAMESPACE = 'Satisfaction';
	var CAMPAIGN_LINKS_LOADED = exports.CAMPAIGN_LINKS_LOADED = NAMESPACE + '/CampaignLinksLoaded';
	var CAMPAIGN_STREAM_LOADED = exports.CAMPAIGN_STREAM_LOADED = NAMESPACE + '/CampaignStreamLoaded';
	var CAMPAIGN_LOADED = exports.CAMPAIGN_LOADED = NAMESPACE + '/CampaignLoaded';
	var CAMPAIGN_QUERIED = exports.CAMPAIGN_QUERIED = NAMESPACE + '/CampaignQueried';
	var ANSWER_STREAM_LOADED = exports.ANSWER_STREAM_LOADED = NAMESPACE + '/AnswerStreamLoaded';
	var ANSWER_STREAM_QUERIED = exports.ANSWER_STREAM_QUERIED = NAMESPACE + '/AnswerStreamQueried';
	var CREATE_CAMPAIGN_ACTION_SENT = exports.CREATE_CAMPAIGN_ACTION_SENT = NAMESPACE + '/CreateCampaignActionSent';
	var UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT = exports.UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT = NAMESPACE + '/UpdateNotationScaleOfCampaignActionSent';
	var UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT = exports.UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT = NAMESPACE + '/UpdateTitleOfCampaignActionSent';
	var ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT = exports.ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT = NAMESPACE + '/AddQuestionToCampaignActionSent';
	var REMOVE_QUESTION_FROM_CAMPAIGN_ACTION_SENT = exports.REMOVE_QUESTION_FROM_CAMPAIGN_ACTION_SENT = NAMESPACE + '/RemoveQuestionFromCampaignActionSent';
	var DEFINE_ANSWER_RATE_GOAL_ACTION_SENT = exports.DEFINE_ANSWER_RATE_GOAL_ACTION_SENT = NAMESPACE + '/DefineAnswerRateGoalActionSent';
	var START_CAMPAIGN_ACTION_SENT = exports.START_CAMPAIGN_ACTION_SENT = NAMESPACE + '/StartCampaignActionSent';
	var FINISH_CAMPAIGN_ACTION_SENT = exports.FINISH_CAMPAIGN_ACTION_SENT = NAMESPACE + '/FinishCampaignActionSent';
	var ANSWER_ACTION_SENT = exports.ANSWER_ACTION_SENT = NAMESPACE + '/AnswerActionSent';
	// form actions
	var CREATE_CAMPAIGN_ACTION_UPDATED = exports.CREATE_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/CreateCampaignActionUpdated';
	var UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED = exports.UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/UpdateNotationScaleOfCampaignActionUpdated';
	var UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED = exports.UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/UpdateTitleOfCampaignActionUpdated';
	var ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED = exports.ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/AddQuestionToCampaignActionUpdated';
	var DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED = exports.DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED = NAMESPACE + '/DefineAnswerRateGoalActionUpdated';
	var START_CAMPAIGN_ACTION_UPDATED = exports.START_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/StartCampaignActionUpdated';
	var ANSWER_ACTION_UPDATED = exports.ANSWER_ACTION_UPDATED = NAMESPACE + '/AnswerActionUpdated';
	
	var DEFAULT_QUERY = exports.DEFAULT_QUERY = {
	    range: { offset: 0, limit: 19 }
	};
	
	var DEFAULT_CAMPAIGN_QUERY = exports.DEFAULT_CAMPAIGN_QUERY = {
	    companyUid: null
	};
	
	var DEFAULT_ANSWER_QUERY = exports.DEFAULT_ANSWER_QUERY = _extends({}, DEFAULT_QUERY, {
	    companyUid: null,
	    campaignUid: null,
	    ticketUid: null
	});
	
	function loadCampaignLinks() {
	    var query = {
	        range: { offset: 0, limit: 0 }
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/satisfactioncampaigns', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: CAMPAIGN_LINKS_LOADED,
	            _links: json._links
	        };
	    }), CAMPAIGN_LINKS_LOADED);
	}
	
	function loadCampaignStream(campaignQuery) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var query = state.satisfaction.campaign.query;
	
	
	        campaignQuery = _extends({}, DEFAULT_CAMPAIGN_QUERY, {
	            companyUid: company && company.uid
	        }, query, campaignQuery);
	
	        var _campaignQuery = campaignQuery,
	            companyUid = _campaignQuery.companyUid,
	            apiCampaignQuery = _objectWithoutProperties(_campaignQuery, ['companyUid']);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + companyUid + '/satisfactioncampaigns', apiCampaignQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	            var json = _ref2.json;
	
	            return {
	                type: CAMPAIGN_STREAM_LOADED,
	                stream: json.result,
	                _links: json._links,
	                query: campaignQuery
	            };
	        });
	    }, CAMPAIGN_STREAM_LOADED);
	}
	
	function queryCampaign(companyId, campaignId) {
	    return loadCampaign(companyId, campaignId, CAMPAIGN_QUERIED);
	}
	
	function loadCampaign(companyId, campaignId, action) {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	
	        companyId = companyId || campaign && campaign.company.uid;
	        campaignId = campaignId || campaign && campaign.uid;
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + companyId + '/satisfactioncampaigns/' + campaignId, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref3) {
	            var json = _ref3.json;
	
	            return {
	                type: action || CAMPAIGN_LOADED,
	                campaign: json
	            };
	        });
	    }, action || CAMPAIGN_LOADED);
	}
	
	function queryActiveCampaign(companyId) {
	    return loadActiveCampaign(companyId, CAMPAIGN_QUERIED);
	}
	
	function loadActiveCampaign(companyId, action) {
	    return (0, _loading2.default)(fetch(_config2.default.api.url + '/clientcompanies/' + companyId + '/satisfactioncampaigns/active', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref4) {
	        var json = _ref4.json;
	
	        return {
	            type: action || CAMPAIGN_LOADED,
	            campaign: json
	        };
	    }).catch((0, _fetchz.only)([403, 404], function (error) {
	        return {
	            type: action || CAMPAIGN_LOADED,
	            campaign: null
	        };
	    })), action || CAMPAIGN_LOADED);
	}
	
	function queryAnswerStream(answerQuery, action) {
	    return loadAnswerStream(answerQuery, ANSWER_STREAM_QUERIED);
	}
	
	function loadAnswerStream(answerQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var query = state.satisfaction.answer.query;
	
	
	        answerQuery = _extends({}, DEFAULT_ANSWER_QUERY, {
	            companyUid: company && company.uid
	        }, query, answerQuery);
	
	        var _answerQuery = answerQuery,
	            companyUid = _answerQuery.companyUid,
	            apiAnswerQuery = _objectWithoutProperties(_answerQuery, ['companyUid']);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + companyUid + '/satisfactioncampaignanswers', apiAnswerQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref5) {
	            var headers = _ref5.headers,
	                json = _ref5.json;
	
	            return {
	                type: action || ANSWER_STREAM_LOADED,
	                stream: json.result,
	                range: headers.contentRange,
	                query: answerQuery
	            };
	        });
	    }, action || ANSWER_STREAM_LOADED);
	}
	
	function sendCreateCampaignAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var createCampaignAction = state.satisfaction.createCampaignAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'CreateCampaign'
	            }, createCampaignAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/satisfactioncampaigns', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref6) {
	            var json = _ref6.json;
	
	            return {
	                type: CREATE_CAMPAIGN_ACTION_SENT,
	                satisfactionCampaignUid: json.satisfactionCampaignUid
	            };
	        });
	    }, CREATE_CAMPAIGN_ACTION_SENT);
	}
	
	function sendUpdateNotationScaleOfCampaignAction() {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	        var updateNotationScaleOfCampaignAction = state.satisfaction.updateNotationScaleOfCampaignAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'UpdateNotationScaleOfCampaign',
	                campaignUid: campaign.uid
	            }, updateNotationScaleOfCampaignAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT
	            };
	        });
	    }, UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT);
	}
	
	function sendUpdateTitleOfCampaignAction() {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	        var updateTitleOfCampaignAction = state.satisfaction.updateTitleOfCampaignAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'UpdateTitleOfCampaign',
	                campaignUid: campaign.uid
	            }, updateTitleOfCampaignAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT
	            };
	        });
	    }, UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT);
	}
	
	function sendAddQuestionToCampaignAction() {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	        var addQuestionToCampaignAction = state.satisfaction.addQuestionToCampaignAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'AddQuestionToCampaign',
	                campaignUid: campaign.uid
	            }, addQuestionToCampaignAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT
	            };
	        });
	    }, ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT);
	}
	
	function sendRemoveQuestionFromCampaignAction(questionId) {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'RemoveQuestionFromCampaign',
	                campaignUid: campaign.uid,
	                questionUid: questionId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_QUESTION_FROM_CAMPAIGN_ACTION_SENT
	            };
	        });
	    }, REMOVE_QUESTION_FROM_CAMPAIGN_ACTION_SENT);
	}
	
	function sendDefineAnswerRateGoalAction() {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	        var defineAnswerRateGoalAction = state.satisfaction.defineAnswerRateGoalAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'DefineAnswersRateGoal',
	                campaignUid: campaign.uid
	            }, defineAnswerRateGoalAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DEFINE_ANSWER_RATE_GOAL_ACTION_SENT
	            };
	        });
	    }, DEFINE_ANSWER_RATE_GOAL_ACTION_SENT);
	}
	
	function sendStartCampaignAction() {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	        var startCampaignAction = state.satisfaction.startCampaignAction;
	
	        var elligibleCreateTicketDate = startCampaignAction.elligibleCreateTicketDate,
	            action = _objectWithoutProperties(startCampaignAction, ['elligibleCreateTicketDate']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'StartCampaign',
	                campaignUid: campaign.uid,
	                elligibleCreateTicketDate: (0, _moment2.default)(elligibleCreateTicketDate).format('YYYY-MM-DD')
	            }, action)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: START_CAMPAIGN_ACTION_SENT
	            };
	        });
	    }, START_CAMPAIGN_ACTION_SENT);
	}
	
	function sendFinishCampaignAction() {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'FinishCampaign',
	                campaignUid: campaign.uid
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: FINISH_CAMPAIGN_ACTION_SENT
	            };
	        });
	    }, FINISH_CAMPAIGN_ACTION_SENT);
	}
	
	function sendAnswerAction() {
	    return (0, _loading2.default)(function (state) {
	        var campaign = state.satisfaction.campaign.campaign;
	        var answerAction = state.satisfaction.answerAction;
	
	
	        var option = {
	            body: _extends({
	                action: 'Answer',
	                campaignUid: campaign.uid
	            }, answerAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaignanswers', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ANSWER_ACTION_SENT
	            };
	        });
	    }, ANSWER_ACTION_SENT);
	}
	
	function updateCreateCampaignAction(action) {
	    return {
	        type: CREATE_CAMPAIGN_ACTION_UPDATED,
	        action: action
	    };
	}
	
	function updateUpdateNotationScaleOfCampaignAction(action) {
	    return {
	        type: UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED,
	        action: action
	    };
	}
	
	function updateUpdateTitleOfCampaignAction(action) {
	    return {
	        type: UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED,
	        action: action
	    };
	}
	
	function updateDefineAnswerRateGoalAction(action) {
	    return {
	        type: DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED,
	        action: action
	    };
	}
	
	function updateAnswerAction(action) {
	    return {
	        type: ANSWER_ACTION_UPDATED,
	        action: action
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(1257);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2149);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2148);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2147);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(1256);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(1258);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(914)['default'];
	
	var _Object$create = __webpack_require__(1209)['default'];
	
	var _Object$keys = __webpack_require__(464)['default'];
	
	exports.__esModule = true;
	
	var constant = function constant(obj) {
	  return _Object$assign(_Object$create({
	    values: function values() {
	      var _this = this;
	
	      return _Object$keys(this).map(function (k) {
	        return _this[k];
	      });
	    }
	  }), obj);
	};
	
	var styleMaps = {
	
	  SIZES: {
	    'large': 'lg',
	    'medium': 'md',
	    'small': 'sm',
	    'xsmall': 'xs',
	    'lg': 'lg',
	    'md': 'md',
	    'sm': 'sm',
	    'xs': 'xs'
	  },
	  GRID_COLUMNS: 12
	};
	
	var Sizes = constant({
	  LARGE: 'large',
	  MEDIUM: 'medium',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	});
	
	exports.Sizes = Sizes;
	var State = constant({
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	});
	
	exports.State = State;
	var DEFAULT = 'default';
	exports.DEFAULT = DEFAULT;
	var PRIMARY = 'primary';
	exports.PRIMARY = PRIMARY;
	var LINK = 'link';
	exports.LINK = LINK;
	var INVERSE = 'inverse';
	
	exports.INVERSE = INVERSE;
	exports['default'] = styleMaps;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	'use strict';
	
	exports.__esModule = true;
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        errorTypeEnum: {
	            onlyOneClaimOpenedByTicket: 'Une réclamation existe déjà pour ce ticket'
	        },
	        openedDateTimeFormat: '[Ouvert] ' + _i18n.translations.fr.dateFormat.default + ' ' + _i18n.translations.fr.timeFormat.long,
	        searchStream: {
	            xs: 'rechercher',
	            sm: 'rechercher dans les réclamations'
	        },
	        stateEnum: {
	            opened: 'ouvert',
	            qualified: 'qualifié',
	            answered: 'réponse à la réclamation',
	            challenged: 'contesté',
	            challengeAnswered: 'réponse à la contestation'
	        },
	        assignedEntity: 'porteur de l\'action corrective',
	        accountableEntity: 'organisme responsable',
	        entityEnum: {
	            callCenter: 'Centre d\'appel',
	            clientAccount: 'Client',
	            none: 'Autre'
	        },
	        ticket: 'ticket',
	        claims: 'réclamations',
	        ticketClaim: 'réclamation',
	        ticketClaims: 'réclamations',
	        ticketClaimNotProcessed: 'la réclamation n\'est pas encore traitée',
	        newTicketClaim: 'nouvelle réclamation',
	        openTicketClaim: 'ouvrir la réclamation',
	        qualifyTicketClaim: 'qualifier la réclamation',
	        answerTicketClaim: 'répondre à la réclamation',
	        challengeTicketClaim: 'contester la réclamation',
	        answerChallengeTicketClaim: 'répondre à la contestation',
	        ticketClaimCategory: 'typologie de réclamation',
	        failureCause: 'cause de défaillance identifiée',
	        postAnalysis: 'analyse',
	        ticketClaimAnswer: 'réponse à la réclamation',
	        callerIdentity: 'identification appelant',
	        interventionLocation: 'lieu d\'intervention',
	        interventionMonitoring: 'suivi d\'intervention',
	        ticketReference: 'référence du ticket',
	        urgencyLevel: 'priorité de traitement',
	        category: 'catégorie',
	        treatmentPriority: 'priorité',
	        severity: 'sévérité',
	        qualification: 'qualification',
	        challenge: 'contestation',
	        challengeAnswer: 'réponse à la contestation',
	        agency: 'portefeuille',
	        selectAgency: 'portefeuille',
	        externalClientName: 'Nom du client final',
	        externalPatrimonyReference: 'Lot ou installation concerné(e)',
	        externalCallDate: 'Date et heure d\'appel du client'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RESET_LOGIN_DEMAND_UPDATED = exports.RESET_PASSWORD_CMD_UPDATED = exports.RESET_PASSWORD_DEMAND_UPDATED = exports.ACTIVE_USER_CMD_UPDATED = exports.UPDATE_USER_CMD_UPDATED = exports.AUTHENTICATED_USER_CONFIGS_UPDATED = exports.CREDENTIAL_UPDATED = exports.RESET_LOGIN_CMD_SENT = exports.RESET_LOGIN_DEMAND_SENT = exports.RESET_PASSWORD_CMD_SENT = exports.RESET_PASSWORD_DEMAND_SENT = exports.ACTIVE_USER_CMD_SENT = exports.UPDATE_USER_CMD_SENT = exports.AUTHENTICATED_USER_CONFIGS_SENT = exports.AUTHENTICATED_USER_CONFIGS_RESET = exports.AUTHENTICATED_USER_CONFIGS_LOADED = exports.AUTHENTICATED_USER_DISCARDED = exports.AUTHENTICATED_USER_LOADED = exports.LOGGED_OUT = exports.LOGGED_IN = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadAuthenticatedUser = loadAuthenticatedUser;
	exports.loadAuthenticatedUserConfigs = loadAuthenticatedUserConfigs;
	exports.sendAuthenticatedUserConfigs = sendAuthenticatedUserConfigs;
	exports.login = login;
	exports.logout = logout;
	exports.sendActiveUserCmd = sendActiveUserCmd;
	exports.sendResetPasswordDemand = sendResetPasswordDemand;
	exports.sendResetPasswordCmd = sendResetPasswordCmd;
	exports.sendUpdateUserCmd = sendUpdateUserCmd;
	exports.sendResetLoginDemand = sendResetLoginDemand;
	exports.sendResetLoginCmd = sendResetLoginCmd;
	exports.updateActiveUserCmd = updateActiveUserCmd;
	exports.updateResetPasswordCmd = updateResetPasswordCmd;
	exports.updateUpdateUserCmd = updateUpdateUserCmd;
	exports.updateResetLoginDemand = updateResetLoginDemand;
	exports.resetAuthenticatedUserConfigs = resetAuthenticatedUserConfigs;
	exports.discardAuthenticatedUser = discardAuthenticatedUser;
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NAMESPACE = 'User';
	
	var LOGGED_IN = exports.LOGGED_IN = NAMESPACE + '/LoggedIn';
	var LOGGED_OUT = exports.LOGGED_OUT = NAMESPACE + '/LoggedOut';
	var AUTHENTICATED_USER_LOADED = exports.AUTHENTICATED_USER_LOADED = NAMESPACE + '/AuthenticatedUserLoaded';
	var AUTHENTICATED_USER_DISCARDED = exports.AUTHENTICATED_USER_DISCARDED = NAMESPACE + '/AuthenticatedUserDiscarded';
	var AUTHENTICATED_USER_CONFIGS_LOADED = exports.AUTHENTICATED_USER_CONFIGS_LOADED = NAMESPACE + '/AuthenticatedUserConfigsLoaded';
	var AUTHENTICATED_USER_CONFIGS_RESET = exports.AUTHENTICATED_USER_CONFIGS_RESET = NAMESPACE + '/AuthenticatedUserConfigsReset';
	var AUTHENTICATED_USER_CONFIGS_SENT = exports.AUTHENTICATED_USER_CONFIGS_SENT = NAMESPACE + '/AuthenticatedUserConfigsSent';
	var UPDATE_USER_CMD_SENT = exports.UPDATE_USER_CMD_SENT = NAMESPACE + '/UpdateUserCmdSent';
	var ACTIVE_USER_CMD_SENT = exports.ACTIVE_USER_CMD_SENT = NAMESPACE + '/ActiveUserCmdSent';
	var RESET_PASSWORD_DEMAND_SENT = exports.RESET_PASSWORD_DEMAND_SENT = NAMESPACE + '/ResetPasswordDemandSent';
	var RESET_PASSWORD_CMD_SENT = exports.RESET_PASSWORD_CMD_SENT = NAMESPACE + '/ResetPasswordCmdSent';
	var RESET_LOGIN_DEMAND_SENT = exports.RESET_LOGIN_DEMAND_SENT = NAMESPACE + '/ResetLoginDemandSent';
	var RESET_LOGIN_CMD_SENT = exports.RESET_LOGIN_CMD_SENT = NAMESPACE + '/ResetLoginCmdSent';
	// form action
	var CREDENTIAL_UPDATED = exports.CREDENTIAL_UPDATED = NAMESPACE + '/CredentialUpdated';
	var AUTHENTICATED_USER_CONFIGS_UPDATED = exports.AUTHENTICATED_USER_CONFIGS_UPDATED = NAMESPACE + '/AuthenticatedUserConfigsUpdated';
	var UPDATE_USER_CMD_UPDATED = exports.UPDATE_USER_CMD_UPDATED = NAMESPACE + '/UpdateUserCmdUpdated';
	var ACTIVE_USER_CMD_UPDATED = exports.ACTIVE_USER_CMD_UPDATED = NAMESPACE + '/ActiveUserCmdUpdated';
	var RESET_PASSWORD_DEMAND_UPDATED = exports.RESET_PASSWORD_DEMAND_UPDATED = NAMESPACE + '/ResetPasswordDemandUpdated';
	var RESET_PASSWORD_CMD_UPDATED = exports.RESET_PASSWORD_CMD_UPDATED = NAMESPACE + '/ResetPasswordCmdUpdated';
	var RESET_LOGIN_DEMAND_UPDATED = exports.RESET_LOGIN_DEMAND_UPDATED = NAMESPACE + '/ResetLoginDemandUpdated';
	
	function loadAuthenticatedUser() {
	    return fetch(_config2.default.api.url + '/users/auth', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: AUTHENTICATED_USER_LOADED,
	            user: json
	        };
	    });
	}
	
	function loadAuthenticatedUserConfigs() {
	    return (0, _loading2.default)(function (state) {
	        var authenticated = state.user.authenticated;
	
	
	        return fetch(_config2.default.api.url + '/users/' + authenticated.uid + '/configs', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	            var json = _ref2.json;
	
	            return {
	                type: AUTHENTICATED_USER_CONFIGS_LOADED,
	                userConfigs: json
	            };
	        });
	    }, AUTHENTICATED_USER_CONFIGS_LOADED);
	}
	
	function sendAuthenticatedUserConfigs() {
	    return (0, _loading2.default)(function (state) {
	        var _state$user = state.user,
	            authenticated = _state$user.authenticated,
	            authenticatedConfigs = _state$user.authenticatedConfigs;
	
	
	        var option = {
	            method: 'PATCH',
	            body: authenticatedConfigs
	        };
	
	        return fetch(_config2.default.api.url + '/users/' + authenticated.uid + '/configs', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function () {
	            return {
	                type: AUTHENTICATED_USER_CONFIGS_SENT
	            };
	        });
	    }, AUTHENTICATED_USER_CONFIGS_SENT);
	}
	
	function login() {
	    return function (state) {
	        var credential = state.user.credential;
	        var login = credential.login,
	            password = credential.password;
	
	
	        var option = {
	            body: {
	                login: login.trim(),
	                password: password
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/login', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: LOGGED_IN
	            };
	        });
	    };
	}
	
	function logout() {
	    return fetch(_config2.default.api.url + '/logout', (0, _fetchz.apiOption)()).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: LOGGED_OUT
	        };
	    });
	}
	
	function sendActiveUserCmd() {
	    return function (state) {
	        var activeUserCmd = state.user.activeUserCmd;
	
	        var userId = activeUserCmd.userId,
	            confirmPassword = activeUserCmd.confirmPassword,
	            cmd = _objectWithoutProperties(activeUserCmd, ['userId', 'confirmPassword']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'ActiveUser'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ACTIVE_USER_CMD_SENT
	            };
	        });
	    };
	}
	
	function sendResetPasswordDemand(demand) {
	    return function (state) {
	        var resetPasswordDemand = state.user.resetPasswordDemand;
	
	
	        demand = _extends({}, resetPasswordDemand, demand);
	
	        var option = {
	            body: demand
	        };
	
	        return fetch(_config2.default.api.url + '/resetPasswordDemand', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: RESET_PASSWORD_DEMAND_SENT
	            };
	        }).catch((0, _fetchz.only)(404, function (error) {
	            return Promise.reject(_extends({}, error, { type: 'UserNotFound' }));
	        }));
	    };
	}
	
	function sendResetPasswordCmd() {
	    return function (state) {
	        var resetPasswordCmd = state.user.resetPasswordCmd;
	
	        var userId = resetPasswordCmd.userId,
	            confirmPassword = resetPasswordCmd.confirmPassword,
	            cmd = _objectWithoutProperties(resetPasswordCmd, ['userId', 'confirmPassword']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'ResetPassword'
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: RESET_PASSWORD_CMD_SENT
	            };
	        });
	    };
	}
	
	function sendUpdateUserCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$user2 = state.user,
	            authenticated = _state$user2.authenticated,
	            updateUserCmd = _state$user2.updateUserCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'UpdateUser'
	            }, updateUserCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/users/' + authenticated.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_USER_CMD_SENT
	            };
	        });
	    }, UPDATE_USER_CMD_SENT);
	}
	
	function sendResetLoginDemand() {
	    return function (state) {
	        var resetLoginDemand = state.user.resetLoginDemand;
	
	
	        var option = {
	            body: resetLoginDemand
	        };
	
	        return fetch(_config2.default.api.url + '/resetLoginDemand', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: RESET_LOGIN_DEMAND_SENT
	            };
	        });
	    };
	}
	
	function sendResetLoginCmd(cmd) {
	    var userId = cmd.userId,
	        apiCmd = _objectWithoutProperties(cmd, ['userId']);
	
	    var option = {
	        method: 'PATCH',
	        body: _extends({
	            processUid: _nodeUuid2.default.v4(),
	            commandType: 'ResetLogin'
	        }, apiCmd)
	    };
	
	    return (0, _loading2.default)(fetch(_config2.default.api.event.url + '/users/' + userId, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	        return {
	            type: RESET_LOGIN_CMD_SENT
	        };
	    }), RESET_LOGIN_CMD_SENT);
	}
	
	function updateActiveUserCmd(cmd) {
	    return {
	        type: ACTIVE_USER_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateResetPasswordCmd(cmd) {
	    return {
	        type: RESET_PASSWORD_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateUpdateUserCmd(cmd) {
	    return {
	        type: UPDATE_USER_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	
	function updateResetLoginDemand(demand) {
	    return {
	        type: RESET_LOGIN_DEMAND_UPDATED,
	        demand: demand
	    };
	}
	
	function resetAuthenticatedUserConfigs(userConfigs) {
	    return {
	        type: AUTHENTICATED_USER_CONFIGS_RESET,
	        userConfigs: userConfigs
	    };
	}
	
	function discardAuthenticatedUser() {
	    return {
	        type: AUTHENTICATED_USER_DISCARDED
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(53);
	var toLength = __webpack_require__(27);
	var toAbsoluteIndex = __webpack_require__(100);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(16);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(44);
	var redefineAll = __webpack_require__(98);
	var meta = __webpack_require__(84);
	var forOf = __webpack_require__(93);
	var anInstance = __webpack_require__(92);
	var isObject = __webpack_require__(19);
	var fails = __webpack_require__(18);
	var $iterDetect = __webpack_require__(159);
	var setToStringTag = __webpack_require__(116);
	var inheritIfRequired = __webpack_require__(211);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(312);
	var redefine = __webpack_require__(44);
	var hide = __webpack_require__(43);
	var fails = __webpack_require__(18);
	var defined = __webpack_require__(67);
	var wks = __webpack_require__(25);
	var regexpExec = __webpack_require__(219);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(59);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(19);
	var cof = __webpack_require__(59);
	var MATCH = __webpack_require__(25)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(25)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(83) || !__webpack_require__(18)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(16)[K];
	});


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(114);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(37);
	var ctx = __webpack_require__(61);
	var forOf = __webpack_require__(93);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(63);
	var defined = __webpack_require__(67);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(16);
	var hide = __webpack_require__(43);
	var uid = __webpack_require__(101);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(16);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(758), __esModule: true };

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(233);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(169);
	var IE8_DOM_DEFINE = __webpack_require__(767);
	var toPrimitive = __webpack_require__(781);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(118) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(795);


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.matches_entirely = matches_entirely;
	// Checks whether the entire input sequence can be matched
	// against the regular expression.
	function matches_entirely() {
		var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var regular_expression = arguments[1];
	
		if (typeof regular_expression === 'string') {
			regular_expression = '^(?:' + regular_expression + ')$';
		}
	
		var matched_groups = text.match(regular_expression);
		return matched_groups !== null && matched_groups[0].length === text.length;
	}
	//# sourceMappingURL=common.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(77);
	var EventPluginHub = __webpack_require__(141);
	var EventPluginRegistry = __webpack_require__(469);
	var ReactEventEmitterMixin = __webpack_require__(833);
	var ReactPerf = __webpack_require__(64);
	var ViewportMetrics = __webpack_require__(490);
	
	var assign = __webpack_require__(22);
	var isEventSupported = __webpack_require__(253);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(182);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(144);
	var ViewportMetrics = __webpack_require__(490);
	
	var getEventModifierState = __webpack_require__(250);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(81)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var cache = [];
	
	    return function (key, build) {
	        var entry = cache.find(function (e) {
	            return keyEquals(e.key, key);
	        });
	
	        if (!entry) {
	            var value = build();
	            entry = { key: key, value: value };
	            cache.push(entry);
	        }
	        return entry.value;
	    };
	};
	
	function keyEquals(key1, key2) {
	    if (key1 == key2) {
	        return true;
	    }
	
	    if (key1 instanceof Array && key2 instanceof Array) {
	        return key1.length == key2.length && key1.every(function (v, i) {
	            return v == key2[i];
	        });
	    }
	
	    return false;
	}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Box = __webpack_require__(2201);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Box = function (_Component) {
	    _inherits(Box, _Component);
	
	    function Box() {
	        _classCallCheck(this, Box);
	
	        return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
	    }
	
	    _createClass(Box, [{
	        key: 'render',
	        value: function render() {
	            var _cx;
	
	            var _props = this.props,
	                children = _props.children,
	                kind = _props.kind,
	                active = _props.active,
	                status = _props.status,
	                header = _props.header,
	                help = _props.help,
	                background = _props.background,
	                onClick = _props.onClick;
	
	            var kindClass = kind && kind.toLowerCase();
	            var statusClass = status && status.toLowerCase();
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Box2.default.default, _Box2.default[statusClass], _Box2.default[kindClass], (_cx = {}, _defineProperty(_cx, _Box2.default.clickable, onClick), _defineProperty(_cx, _Box2.default.active, active), _cx)) },
	                background && _react2.default.createElement(
	                    'div',
	                    { className: _Box2.default.background },
	                    background
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _Box2.default.header },
	                    header,
	                    help && _react2.default.createElement(
	                        'div',
	                        {
	                            className: _Box2.default.help,
	                            onClick: onClick },
	                        help
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _Box2.default.body },
	                    children
	                )
	            );
	        }
	    }]);
	
	    return Box;
	}(_react.Component);
	
	Box.propTypes = {
	    kind: _react.PropTypes.string,
	    active: _react.PropTypes.bool,
	    status: _react.PropTypes.string,
	    header: _react.PropTypes.node,
	    help: _react.PropTypes.node,
	    background: _react.PropTypes.node
	};
	exports.default = Box;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.humanize = humanize;
	exports.humanizeShort = humanizeShort;
	exports.parseFormat = parseFormat;
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function humanize(duration) {
	    if (duration && duration.asMilliseconds() > 0) {
	        var format = [];
	
	        if (duration.years() > 0) {
	            format.push(duration.years() + 'an');
	        }
	        if (duration.months() > 0) {
	            format.push(duration.months() + 'mois');
	        }
	        if (duration.days() > 0) {
	            format.push(duration.days() + 'j');
	        }
	        if (duration.hours() > 0) {
	            format.push(duration.hours() + 'h');
	        }
	        if (duration.minutes() > 0) {
	            format.push(duration.minutes() + 'min');
	        }
	        if (duration.seconds() > 0) {
	            format.push(duration.seconds() + 's');
	        }
	
	        return format.slice(0, 2).join(' ');
	    }
	    return '---';
	}
	
	function humanizeShort(duration) {
	    if (duration && duration.asMilliseconds() > 0) {
	        var locale = _moment2.default.localeData();
	
	        var seconds = Math.round(duration.as('s'));
	        var minutes = Math.round(duration.as('m'));
	        var hours = Math.round(duration.as('h'));
	        var days = Math.round(duration.as('d'));
	        var months = Math.round(duration.as('M'));
	        var years = Math.round(duration.as('y'));
	
	        if (seconds < 120) return locale.relativeTime(seconds, true, 's');
	        if (minutes <= 1) return locale.relativeTime(minutes, true, 'm');
	        if (minutes < 120) return locale.relativeTime(minutes, true, 'mm');
	        if (hours <= 1) return locale.relativeTime(hours, true, 'h');
	        if (hours < 48) return locale.relativeTime(hours, true, 'hh');
	        if (days <= 1) return locale.relativeTime(days, true, 'd');
	        if (days < 60) return locale.relativeTime(days, true, 'dd');
	        if (months <= 1) return locale.relativeTime(months, true, 'M');
	        if (months < 24) return locale.relativeTime(months, true, 'MM');
	        if (years <= 1) return locale.relativeTime(years, true, 'y');
	        return locale.relativeTime(years, true, 'yy');
	    }
	    return 0;
	}
	
	function parseFormat(source, format) {
	    // workaround when providing a parse format with a date to moment as it gives unexpected results
	    if (source instanceof Date) return undefined;
	    return format;
	}

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(79);
	
	var assign = __webpack_require__(22);
	var invariant = __webpack_require__(14);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(824);
	var ReactEmptyComponent = __webpack_require__(480);
	var ReactNativeComponent = __webpack_require__(486);
	
	var assign = __webpack_require__(22);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_TICKET_CLAIM_QUERY = exports.DEFAULT_QUERY = exports.ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED = exports.CHALLENGE_TICKET_CLAIM_CMD_UPDATED = exports.ANSWER_TICKET_CLAIM_CMD_UPDATED = exports.QUALIFY_TICKET_CLAIM_CMD_UPDATED = exports.OPEN_TICKET_CLAIM_CMD_UPDATED = exports.ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT = exports.CHALLENGE_TICKET_CLAIM_CMD_SENT = exports.ANSWER_TICKET_CLAIM_CMD_SENT = exports.QUALIFY_TICKET_CLAIM_CMD_SENT = exports.OPEN_TICKET_CLAIM_CMD_SENT = exports.TICKET_CLAIM_STREAM_QUERIED = exports.TICKET_CLAIM_STREAM_LOADED = exports.TICKET_CLAIM_CREATED = exports.TICKET_CLAIM_LOADED = exports.LINKS_LOADED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadLinks = loadLinks;
	exports.queryTicketClaimStream = queryTicketClaimStream;
	exports.loadTicketClaimStream = loadTicketClaimStream;
	exports.loadTicketClaim = loadTicketClaim;
	exports.sendOpenTicketClaimCmd = sendOpenTicketClaimCmd;
	exports.sendQualifyTicketClaimCmd = sendQualifyTicketClaimCmd;
	exports.sendAnswerTicketClaimCmd = sendAnswerTicketClaimCmd;
	exports.sendChallengeTicketClaimCmd = sendChallengeTicketClaimCmd;
	exports.sendAnswerChallengeTicketClaimCmd = sendAnswerChallengeTicketClaimCmd;
	exports.createTicketClaim = createTicketClaim;
	exports.updateOpenTicketClaimCmd = updateOpenTicketClaimCmd;
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NAMESPACE = 'Claim';
	var LINKS_LOADED = exports.LINKS_LOADED = NAMESPACE + '/LinksLoaded';
	var TICKET_CLAIM_LOADED = exports.TICKET_CLAIM_LOADED = NAMESPACE + '/TicketClaimLoaded';
	var TICKET_CLAIM_CREATED = exports.TICKET_CLAIM_CREATED = NAMESPACE + '/TicketClaimCreated';
	var TICKET_CLAIM_STREAM_LOADED = exports.TICKET_CLAIM_STREAM_LOADED = NAMESPACE + '/TicketClaimStreamLoaded';
	var TICKET_CLAIM_STREAM_QUERIED = exports.TICKET_CLAIM_STREAM_QUERIED = NAMESPACE + '/TicketClaimStreamQueried';
	var OPEN_TICKET_CLAIM_CMD_SENT = exports.OPEN_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/OpenTicketClaimCmdSent';
	var QUALIFY_TICKET_CLAIM_CMD_SENT = exports.QUALIFY_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/QualifyTicketClaimCmdSent';
	var ANSWER_TICKET_CLAIM_CMD_SENT = exports.ANSWER_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/AnswerTicketClaimCmdSent';
	var CHALLENGE_TICKET_CLAIM_CMD_SENT = exports.CHALLENGE_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/ChallengeTicketClaimCmdSent';
	var ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT = exports.ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/AnswerChallengeTicketClaimCmdSent';
	// form actions
	var OPEN_TICKET_CLAIM_CMD_UPDATED = exports.OPEN_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/OpenTicketClaimCmdUpdated';
	var QUALIFY_TICKET_CLAIM_CMD_UPDATED = exports.QUALIFY_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/QualifyTicketClaimCmdUpdated';
	var ANSWER_TICKET_CLAIM_CMD_UPDATED = exports.ANSWER_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/AnswerTicketClaimCmdUpdated';
	var CHALLENGE_TICKET_CLAIM_CMD_UPDATED = exports.CHALLENGE_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/ChallengeTicketClaimCmdUpdated';
	var ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED = exports.ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/AnswerChallengeTicketClaimCmdUpdated';
	
	var DEFAULT_QUERY = exports.DEFAULT_QUERY = {
	    range: { offset: 0, limit: 19 }
	};
	
	var DEFAULT_TICKET_CLAIM_QUERY = exports.DEFAULT_TICKET_CLAIM_QUERY = _extends({}, DEFAULT_QUERY);
	
	function loadLinks() {
	    var query = {
	        range: { offset: 0, limit: 0 }
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/ticketclaims', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: LINKS_LOADED,
	            _links: json._links
	        };
	    }), LINKS_LOADED);
	}
	
	function queryTicketClaimStream(claimQuery) {
	    return loadTicketClaimStream(claimQuery, TICKET_CLAIM_STREAM_QUERIED);
	}
	
	function loadTicketClaimStream(claimQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var query = state.claim.query;
	
	
	        claimQuery = _extends({}, DEFAULT_TICKET_CLAIM_QUERY, query, claimQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/ticketclaims', claimQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	            var json = _ref2.json,
	                headers = _ref2.headers;
	
	            return {
	                type: action || TICKET_CLAIM_STREAM_LOADED,
	                range: headers.contentRange,
	                stream: json.result,
	                _links: json._links,
	                query: claimQuery
	            };
	        });
	    }, action || TICKET_CLAIM_STREAM_LOADED);
	}
	
	function loadTicketClaim(id) {
	    return (0, _loading2.default)(function (state) {
	        var ticketClaim = state.claim.ticketClaim;
	
	        id = id || ticketClaim.uid;
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/ticketclaims/' + id), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref3) {
	            var json = _ref3.json;
	
	            return {
	                type: TICKET_CLAIM_LOADED,
	                ticketClaim: json
	            };
	        });
	    }, TICKET_CLAIM_LOADED);
	}
	
	function sendOpenTicketClaimCmd() {
	    return (0, _loading2.default)(function (state) {
	        var openTicketClaimCmd = state.claim.openTicketClaimCmd;
	
	        var externalClientName = openTicketClaimCmd.externalClientName,
	            externalPatrimonyReference = openTicketClaimCmd.externalPatrimonyReference,
	            externalCallDate = openTicketClaimCmd.externalCallDate,
	            description = openTicketClaimCmd.description,
	            cmd = _objectWithoutProperties(openTicketClaimCmd, ['externalClientName', 'externalPatrimonyReference', 'externalCallDate', 'description']);
	
	        var fullDescription = [externalClientName && _i18n2.default.externalClientName + ' : ' + externalClientName + '. ', externalPatrimonyReference && _i18n2.default.externalPatrimonyReference + ' : ' + externalPatrimonyReference + '. ', externalCallDate && _i18n2.default.externalCallDate + ' : ' + (0, _moment2.default)(externalCallDate).format(_i18n2.default.dateTimeFormat.default) + '. ', description + '.'].filter(function (t) {
	            return t;
	        }).join('\r\n');
	
	        var option = {
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                description: fullDescription
	            }, cmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/ticketclaims', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref4) {
	            var json = _ref4.json;
	
	            return {
	                type: OPEN_TICKET_CLAIM_CMD_SENT,
	                events: json.events
	            };
	        });
	    }, OPEN_TICKET_CLAIM_CMD_SENT);
	}
	
	function sendQualifyTicketClaimCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$claim = state.claim,
	            ticketClaim = _state$claim.ticketClaim,
	            qualifyTicketClaimCmd = _state$claim.qualifyTicketClaimCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'QualifyTicketClaim'
	            }, qualifyTicketClaimCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/ticketclaims/' + ticketClaim.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: QUALIFY_TICKET_CLAIM_CMD_SENT
	            };
	        });
	    }, QUALIFY_TICKET_CLAIM_CMD_SENT);
	}
	
	function sendAnswerTicketClaimCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$claim2 = state.claim,
	            ticketClaim = _state$claim2.ticketClaim,
	            answerTicketClaimCmd = _state$claim2.answerTicketClaimCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AnswerTicketClaim'
	            }, answerTicketClaimCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/ticketclaims/' + ticketClaim.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ANSWER_TICKET_CLAIM_CMD_SENT
	            };
	        });
	    }, ANSWER_TICKET_CLAIM_CMD_SENT);
	}
	
	function sendChallengeTicketClaimCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$claim3 = state.claim,
	            ticketClaim = _state$claim3.ticketClaim,
	            challengeTicketClaimCmd = _state$claim3.challengeTicketClaimCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'ChallengeTicketClaim'
	            }, challengeTicketClaimCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/ticketclaims/' + ticketClaim.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: CHALLENGE_TICKET_CLAIM_CMD_SENT
	            };
	        });
	    }, CHALLENGE_TICKET_CLAIM_CMD_SENT);
	}
	
	function sendAnswerChallengeTicketClaimCmd() {
	    return (0, _loading2.default)(function (state) {
	        var _state$claim4 = state.claim,
	            ticketClaim = _state$claim4.ticketClaim,
	            answerChallengeTicketClaimCmd = _state$claim4.answerChallengeTicketClaimCmd;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                processUid: _nodeUuid2.default.v4(),
	                commandType: 'AnswerChallengeTicketClaim'
	            }, answerChallengeTicketClaimCmd)
	        };
	
	        return fetch(_config2.default.api.event.url + '/ticketclaims/' + ticketClaim.uid, (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT
	            };
	        });
	    }, ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT);
	}
	
	function createTicketClaim(ticketClaim) {
	    return {
	        type: TICKET_CLAIM_CREATED,
	        ticketClaim: _extends({
	            _links: []
	        }, ticketClaim)
	    };
	}
	
	function updateOpenTicketClaimCmd(cmd) {
	    return {
	        type: OPEN_TICKET_CLAIM_CMD_UPDATED,
	        cmd: cmd
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        welcome: 'bienvenue sur votre espace personnel',
	        signin: 'login',
	        signout: 'logout',
	        login: 'email',
	        email: 'email',
	        password: 'mot de passe',
	        activeUser: 'activez votre compte',
	        userActivated: 'votre compte a été activé',
	        userConfigs: 'paramétrage',
	        forgotPassword: 'mot de passe oublié',
	        resetPassword: 'changez votre mot de passe',
	        currentPassword: 'mot de passe actuel',
	        confirmPassword: 'confirmation du mot de passe',
	        resetPasswordEmailSent: 'un email vous a été envoyé',
	        passwordResetted: 'votre mot de passe a été changé',
	        resetLogin: 'changez votre login',
	        resetLoginEmailSent: 'un email vous a été envoyé',
	        loginResetted: 'votre login a été changé',
	        job: 'poste',
	        phone: 'téléphone',
	        updateUser: 'profile',
	        changePassword: 'mot de passe',
	        changeEmail: 'email',
	        manageAccount: 'gérez votre compte',
	        ticketOpenedNotifications: 'recevoir un email lors de la création d\'un ticket',
	        daybookNotifications: 'recevoir la main courante',
	        simplifiedRequestOpenedNotifications: 'recevoir un email lors de la création d\'une demande simplifiée'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_TODO_QUERY = exports.DEFAULT_QUERY = exports.UPDATE_STEP_ACTION_RESET = exports.UPDATE_STEP_ACTION_UPDATED = exports.ADD_STEP_ACTION_UPDATED = exports.UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED = exports.UPDATE_WORKFLOW_LABEL_ACTION_UPDATED = exports.CREATE_WORKFLOW_ACTION_UPDATED = exports.TODO_CRITERIA_UPDATED = exports.UPDATE_STEP_ACTION_SENT = exports.REMOVE_STEP_ACTION_SENT = exports.ADD_STEP_ACTION_SENT = exports.UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT = exports.UPDATE_WORKFLOW_LABEL_ACTION_SENT = exports.REMOVE_WORKFLOW_ACTION_SENT = exports.CREATE_WORKFLOW_ACTION_SENT = exports.TODO_CRITERIA_RESET = exports.TODO_STATUS_QUERIED = exports.TODO_STREAM_LOADED = exports.NEXT_STEP_QUERIED = exports.NEXT_STEP_LOADED = exports.WORKFLOW_STREAM_LOADED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadWorkflowStream = loadWorkflowStream;
	exports.queryNextStep = queryNextStep;
	exports.loadNextStep = loadNextStep;
	exports.loadTodoStream = loadTodoStream;
	exports.queryTodoStatus = queryTodoStatus;
	exports.sendCreateWorkflowAction = sendCreateWorkflowAction;
	exports.sendRemoveWorkflowAction = sendRemoveWorkflowAction;
	exports.sendUpdateWorkflowLabelAction = sendUpdateWorkflowLabelAction;
	exports.sendUpdateIdentifiedRequestsAction = sendUpdateIdentifiedRequestsAction;
	exports.sendAddStepAction = sendAddStepAction;
	exports.sendRemoveStepAction = sendRemoveStepAction;
	exports.sendUpdateStepAction = sendUpdateStepAction;
	exports.resetTodoCriteria = resetTodoCriteria;
	exports.updateUpdateIdentifiedRequestsAction = updateUpdateIdentifiedRequestsAction;
	exports.updateWorkflowLabelAction = updateWorkflowLabelAction;
	exports.updateAddStepAction = updateAddStepAction;
	exports.resetUpdateStepAction = resetUpdateStepAction;
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NAMESPACE = 'Workflow';
	var WORKFLOW_STREAM_LOADED = exports.WORKFLOW_STREAM_LOADED = NAMESPACE + '/WorkflowStreamLoaded';
	var NEXT_STEP_LOADED = exports.NEXT_STEP_LOADED = NAMESPACE + '/NextStepLoaded';
	var NEXT_STEP_QUERIED = exports.NEXT_STEP_QUERIED = NAMESPACE + '/NextStepQueried';
	var TODO_STREAM_LOADED = exports.TODO_STREAM_LOADED = NAMESPACE + '/TodoStreamLoaded';
	var TODO_STATUS_QUERIED = exports.TODO_STATUS_QUERIED = NAMESPACE + '/TodoStatusQueried';
	var TODO_CRITERIA_RESET = exports.TODO_CRITERIA_RESET = NAMESPACE + '/TodoCriteriaReset';
	var CREATE_WORKFLOW_ACTION_SENT = exports.CREATE_WORKFLOW_ACTION_SENT = NAMESPACE + '/CreateWorkflowActionSent';
	var REMOVE_WORKFLOW_ACTION_SENT = exports.REMOVE_WORKFLOW_ACTION_SENT = NAMESPACE + '/RemoveWorkflowActionSent';
	var UPDATE_WORKFLOW_LABEL_ACTION_SENT = exports.UPDATE_WORKFLOW_LABEL_ACTION_SENT = NAMESPACE + '/UpdateWorkflowLabelActionSent';
	var UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT = exports.UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT = NAMESPACE + '/UpdateIdentifiedRequestsActionSent';
	var ADD_STEP_ACTION_SENT = exports.ADD_STEP_ACTION_SENT = NAMESPACE + '/AddStepActionSent';
	var REMOVE_STEP_ACTION_SENT = exports.REMOVE_STEP_ACTION_SENT = NAMESPACE + '/RemoveStepActionSent';
	var UPDATE_STEP_ACTION_SENT = exports.UPDATE_STEP_ACTION_SENT = NAMESPACE + '/UpdateStepActionSent';
	// form actions
	var TODO_CRITERIA_UPDATED = exports.TODO_CRITERIA_UPDATED = NAMESPACE + '/TodoCriteriaUpdated';
	var CREATE_WORKFLOW_ACTION_UPDATED = exports.CREATE_WORKFLOW_ACTION_UPDATED = NAMESPACE + '/CreateWorkflowActionUpdated';
	var UPDATE_WORKFLOW_LABEL_ACTION_UPDATED = exports.UPDATE_WORKFLOW_LABEL_ACTION_UPDATED = NAMESPACE + '/UpdateWorkflowLabelActionUpdated';
	var UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED = exports.UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED = NAMESPACE + '/UpdateIdentifiedRequestsActionUpdated';
	var ADD_STEP_ACTION_UPDATED = exports.ADD_STEP_ACTION_UPDATED = NAMESPACE + '/AddStepActionUpdated';
	var UPDATE_STEP_ACTION_UPDATED = exports.UPDATE_STEP_ACTION_UPDATED = NAMESPACE + '/UpdateStepActionUpdated';
	var UPDATE_STEP_ACTION_RESET = exports.UPDATE_STEP_ACTION_RESET = NAMESPACE + '/UpdateStepActionReset';
	
	var DEFAULT_QUERY = exports.DEFAULT_QUERY = {
	    range: { offset: 0, limit: 19 }
	};
	
	var DEFAULT_TODO_QUERY = exports.DEFAULT_TODO_QUERY = _extends({}, DEFAULT_QUERY);
	
	function loadWorkflowStream(companyId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        companyId = companyId || company.uid;
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + companyId + '/workflows', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	            var headers = _ref.headers,
	                json = _ref.json;
	
	            return {
	                type: WORKFLOW_STREAM_LOADED,
	                stream: json.result
	            };
	        });
	    }, WORKFLOW_STREAM_LOADED);
	}
	
	function queryNextStep(ticketId) {
	    return loadNextStep(ticketId, NEXT_STEP_QUERIED);
	}
	
	function loadNextStep(ticketId, action) {
	    return (0, _loading2.default)(function (state) {
	        var ticket = state.ticket.ticket;
	
	
	        ticketId = ticketId || ticket.uid;
	
	        return fetch(_config2.default.api.url + '/tickets/' + ticketId + '/nextstep', (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	            var headers = _ref2.headers,
	                json = _ref2.json;
	
	            return {
	                type: action || NEXT_STEP_LOADED,
	                nextStep: json
	            };
	        }).catch((0, _fetchz.only)(404, function (error) {
	            return {
	                type: action || NEXT_STEP_LOADED,
	                nextStep: null
	            };
	        }));
	    }, action || NEXT_STEP_LOADED);
	}
	
	function loadTodoStream(todoQuery) {
	    return (0, _loading2.default)(function (state) {
	        var query = state.workflow.todo.query;
	
	
	        todoQuery = _extends({}, DEFAULT_TODO_QUERY, query, todoQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/todolist', todoQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref3) {
	            var headers = _ref3.headers,
	                json = _ref3.json;
	
	            return {
	                type: TODO_STREAM_LOADED,
	                range: headers.contentRange,
	                stream: json.result,
	                aggregations: json.aggregations,
	                query: todoQuery
	            };
	        });
	    }, TODO_STREAM_LOADED);
	}
	
	function queryTodoStatus(actor) {
	    var query = {
	        range: { offset: 0, limit: 0 },
	        actor: actor
	    };
	
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/todolist', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref4) {
	        var headers = _ref4.headers,
	            json = _ref4.json;
	
	        return {
	            type: TODO_STATUS_QUERIED,
	            status: json.aggregations.expectedDateStatus
	        };
	    }), TODO_STATUS_QUERIED);
	}
	
	function sendCreateWorkflowAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var createWorkflowAction = state.workflow.createWorkflowAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'CreateWorkflow'
	            }, createWorkflowAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/workflows', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref5) {
	            var json = _ref5.json;
	
	            return {
	                type: CREATE_WORKFLOW_ACTION_SENT,
	                workflowUid: json.uid
	            };
	        });
	    }, CREATE_WORKFLOW_ACTION_SENT);
	}
	
	function sendRemoveWorkflowAction(workflowId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'RemoveWorkflow',
	                workflowUid: workflowId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/workflows', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_WORKFLOW_ACTION_SENT
	            };
	        });
	    }, REMOVE_WORKFLOW_ACTION_SENT);
	}
	
	function sendUpdateWorkflowLabelAction(workflowId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var updateWorkflowLabelAction = state.workflow.updateWorkflowLabelAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'UpdateWorkflowLabel',
	                workflowUid: workflowId
	            }, updateWorkflowLabelAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/workflows', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_WORKFLOW_LABEL_ACTION_SENT
	            };
	        });
	    }, UPDATE_WORKFLOW_LABEL_ACTION_SENT);
	}
	
	function sendUpdateIdentifiedRequestsAction(workflowId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var updateIdentifiedRequestsAction = state.workflow.updateIdentifiedRequestsAction;
	
	        var identifiedRequests = updateIdentifiedRequestsAction.identifiedRequests,
	            action = _objectWithoutProperties(updateIdentifiedRequestsAction, ['identifiedRequests']);
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'UpdateIdentifiedRequests',
	                workflowUid: workflowId,
	                identifiedRequests: identifiedRequests.map(function (ir) {
	                    return ir.uid;
	                })
	            }, action)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/workflows', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT
	            };
	        });
	    }, UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT);
	}
	
	function sendAddStepAction(workflowId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var addStepAction = state.workflow.addStepAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'AddStep',
	                workflowUid: workflowId
	            }, addStepAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/workflows', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ADD_STEP_ACTION_SENT
	            };
	        });
	    }, ADD_STEP_ACTION_SENT);
	}
	
	function sendRemoveStepAction(workflowId, stepId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'RemoveStep',
	                workflowUid: workflowId,
	                stepUid: stepId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/workflows', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: REMOVE_STEP_ACTION_SENT
	            };
	        });
	    }, REMOVE_STEP_ACTION_SENT);
	}
	
	function sendUpdateStepAction(workflowId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var updateStepAction = state.workflow.updateStepAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'UpdateStep',
	                workflowUid: workflowId
	            }, updateStepAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/workflows', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: UPDATE_STEP_ACTION_SENT
	            };
	        });
	    }, UPDATE_STEP_ACTION_SENT);
	}
	
	function resetTodoCriteria(criteria) {
	    return {
	        type: TODO_CRITERIA_RESET,
	        criteria: criteria
	    };
	}
	
	function updateUpdateIdentifiedRequestsAction(action) {
	    return {
	        type: UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED,
	        action: action
	    };
	}
	
	function updateWorkflowLabelAction(action) {
	    return {
	        type: UPDATE_WORKFLOW_LABEL_ACTION_UPDATED,
	        action: action
	    };
	}
	
	function updateAddStepAction(action) {
	    return {
	        type: ADD_STEP_ACTION_UPDATED,
	        action: action
	    };
	}
	
	function resetUpdateStepAction(action) {
	    return {
	        type: UPDATE_STEP_ACTION_RESET,
	        action: action
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        errorTypeEnum: {
	            workflowUidShouldBeUniq: 'Erreur de validation',
	            workflowLabelShouldBeUniq: 'Ce nom de workflow est déjà utilisé',
	            requestCanBeLinkedToOnlyOneWorkflow: 'Un workflow utilise déjà cette demande',
	            stepOrderError: 'L\'ordre des tâches est invalide',
	            impossibleToRemoveThisStepBecauseNextDependsOnIt: 'La tâche suivante dépend de celle-ci',
	            stepDoesNotExist: 'La tâche n\'existe pas',
	            workflowDoesNotExist: 'Le workflow n\'existe pas',
	            stepCoherencyError: {
	                shouldHaveNoEventAfterThisStep: 'Aucune tâche ne peut apparaître après {stepInError}',
	                shouldNotBeAfterTheseEvents: '{stepInError} ne peut apparaître après {stepsBefore}'
	            },
	            companyDoesNotHaveRequieredBillingTypeLevel: 'Seul les entreprises {expectedLevels} peuvent créer un workflow',
	            workflowNumberLimitExceeded: 'Votre type de compte vous permet de créer {limit} workflows maximum. Merci de contacter votre chargé de compte si besoin'
	        },
	        billingTypeEnum: {
	            standardAccount: 'compte standard',
	            premiumAccount: 'compte prémium',
	            sponsoredAccount: 'compte sponsorisé'
	        },
	        newWorkflow: 'nouveau workflow',
	        workflowLabel: 'saisisez le nom du workflow',
	        updateWorkflowLabel: 'modification',
	        newStep: 'nouvelle tâche',
	        fillStep: 'saisissez une tâche',
	        saveStep: 'enregistrer la tâche',
	        updateStep: 'modifier la tâche',
	        identifiedRequests: 'type d\'incident',
	        openTicket: 'ouverture du ticket',
	        expectedEvent: 'Nom de la tâche',
	        expectedEventEnum: {
	            documentAttached: 'Document attaché',
	            callEmittedTo: 'Appel sortant',
	            callReceived: 'Appel reçu',
	            assigneeIdentified: 'Intervenant identifié',
	            interventionDeadlineDefined: 'Date butoir d\'intervention',
	            formalNoticeForProviderReported: 'Fournisseur mis en demeure',
	            sendingServiceOrderReported: 'OE envoyé',
	            callAnsweredByProvider: 'Réponse à l\'appel',
	            callNotAnsweredByProvider: 'Pas de réponse à l\'appel',
	            interventionRequested: 'Intervention demandée',
	            interventionAccepted: 'Prise en charge',
	            interventionRefused: 'Mission refusée',
	            interventionScheduled: 'Intervention prévue',
	            arrivedOnSite: 'Arrivée du fournisseur sur site',
	            goneFromSite: 'Départ du fournisseur du site',
	            interventionStarted: 'Intervention débuté par le fournisseur',
	            interventionFinished: 'Intervention terminée par le fournisseur',
	            missionFinished: 'Mission terminée',
	            ticketCancelled: 'Ticket annulé',
	            ticketClosed: 'Ticket clos',
	            ticketArchived: 'Ticket archivé',
	            permanentlyFixed: 'Réparation définitive',
	            partiallyFixed: 'Réparation provisoire',
	            ticketClosedImpossibleRepair: 'Réparation impossible',
	            postponedFix: 'Réparation ajournée',
	            closedBeyondCallCenterScope: 'Hors périmètre',
	            closedAfterSeveralUnsuccessfulRecalls: 'Clôture suite à plusieurs relances infructueuses'
	        },
	        expectedCommandEnum: {
	            notifyCallEmitted: 'Emettre un appel',
	            notifyCallReceived: 'recevoir un appel',
	            identifyAssignee: 'Sélectionner le fournisseur',
	            changeRecourse: 'Changer de recours',
	            defineInterventionDeadline: 'Définir une date butoir d\'intervention',
	            reportFormalNoticeForProvider: 'Définir une date butoir de mise en demeure',
	            reportSendingServiceOrder: 'Consigner le Numéro d\'ordre de service',
	            notifyCallAnsweredByProvider: 'Répondre à l\'appel',
	            notifyCallNotAnsweredByProvider: 'Ne pas répondre à l\'appel',
	            requestIntervention: 'Demander l\'intervention',
	            acceptIntervention: 'Prendre en charge l\'intervention',
	            refuseIntervention: 'Refuser l\'intervention',
	            scheduleIntervention: 'Programmer l\'intervention',
	            arriveOnSite: 'Déclarer l\'arrivée du fournisseur sur le site',
	            goFromSite: 'Déclarer le départ du fournisseur sur du site',
	            startIntervention: 'Déclarer le début d\'intervention',
	            finishIntervention: 'Déclarer la fin d\'intervention',
	            finishMission: 'Finir la mission',
	            cancelTicket: 'Annuler le ticket',
	            closeTicket: 'Clôturer le ticket',
	            archiveTicket: 'Archiver le ticket',
	            fixPermanently: 'Déclarer une réparation définitive',
	            fixPartially: 'Déclarer une réparation partielle',
	            closeTicketImpossibleRepair: 'Déclarer une réparation impossible',
	            postponeFix: 'Déclarer une réparation ajournée',
	            closeBeyondCallCenterScope: 'Déclarer le ticket en dehors du scope du centre d\'appel',
	            closeAfterSeveralUnsuccessfulRecalls: 'Clôturer le ticket suite à relances infructueuses'
	        },
	        actors: 'Responsables',
	        actorEnum: {
	            callCenterOperator: 'Opérateur',
	            executive: 'Cadre',
	            patrimonyManager: 'Gestionnaire'
	        },
	        order: 'Position',
	        duration: 'Durée',
	        stepTimeLimitType: 'Contrainte de temps',
	        stepTimeLimitTypeEnum: {
	            durationAfterPreviousStep: 'Après la dernière étape'
	        },
	        removeWorkflowText: ['Vous êtes sur le point de supprimer le workflow {label}.', 'Cette action est irréversible.'],
	        nextStep: 'prochaine action attendue',
	        overdue: 'dépassé',
	        todolist: 'liste des actions à réaliser',
	        todos: 'actions',
	        youHaveNoTodo: 'Vous n\'avez pas de tâche à réaliser. Pour définir vos processus, merci de contacter votre chargé de compte',
	        youHaveNoTodoClickText: ['Vous n\'avez pas de tâche à réaliser. Pour définir vos processus, merci de ', 'cliquer ici', ' ou de contacter votre chargé de compte'],
	        youAreOperator: 'Vous êtes intervenu sur ce ticket',
	        newTicket: 'nouveau ticket',
	        searchAgency: 'filtrer par portefeuille',
	        searchCompany: 'filtrer par entreprise',
	        searchExpectedCommand: 'filtrer par action',
	        searchActor: 'filtrer par responsable',
	        searchOperator: 'filtrer par opérateur',
	        expectedDateStatus: 'délais des actions',
	        expectedDateStatusEnum: {
	            todo: 'courant',
	            todoWithin12Hours: 'prioritaire',
	            timeout: 'urgent'
	        }
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Buffer) {//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	/*global window, require, define */
	(function(_window) {
	  'use strict';
	
	  // Unique ID creation requires a high quality random # generator.  We feature
	  // detect to determine the best RNG source, normalizing to a function that
	  // returns 128-bits of randomness, since that's what's usually required
	  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;
	
	  function setupBrowser() {
	    // Allow for MSIE11 msCrypto
	    var _crypto = _window.crypto || _window.msCrypto;
	
	    if (!_rng && _crypto && _crypto.getRandomValues) {
	      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	      //
	      // Moderately fast, high quality
	      try {
	        var _rnds8 = new Uint8Array(16);
	        _whatwgRNG = _rng = function whatwgRNG() {
	          _crypto.getRandomValues(_rnds8);
	          return _rnds8;
	        };
	        _rng();
	      } catch(e) {}
	    }
	
	    if (!_rng) {
	      // Math.random()-based (RNG)
	      //
	      // If all else fails, use Math.random().  It's fast, but is of unspecified
	      // quality.
	      var  _rnds = new Array(16);
	      _mathRNG = _rng = function() {
	        for (var i = 0, r; i < 16; i++) {
	          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
	          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }
	
	        return _rnds;
	      };
	      if ('undefined' !== typeof console && console.warn) {
	        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
	      }
	    }
	  }
	
	  function setupNode() {
	    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
	    //
	    // Moderately fast, high quality
	    if (true) {
	      try {
	        var _rb = __webpack_require__(1592).randomBytes;
	        _nodeRNG = _rng = _rb && function() {return _rb(16);};
	        _rng();
	      } catch(e) {}
	    }
	  }
	
	  if (_window) {
	    setupBrowser();
	  } else {
	    setupNode();
	  }
	
	  // Buffer class to use
	  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;
	
	  // Maps for number <-> hex string conversion
	  var _byteToHex = [];
	  var _hexToByte = {};
	  for (var i = 0; i < 256; i++) {
	    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	    _hexToByte[_byteToHex[i]] = i;
	  }
	
	  // **`parse()` - Parse a UUID into it's component bytes**
	  function parse(s, buf, offset) {
	    var i = (buf && offset) || 0, ii = 0;
	
	    buf = buf || [];
	    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
	      if (ii < 16) { // Don't overflow!
	        buf[i + ii++] = _hexToByte[oct];
	      }
	    });
	
	    // Zero out remaining bytes if string was short
	    while (ii < 16) {
	      buf[i + ii++] = 0;
	    }
	
	    return buf;
	  }
	
	  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	  function unparse(buf, offset) {
	    var i = offset || 0, bth = _byteToHex;
	    return  bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]];
	  }
	
	  // **`v1()` - Generate time-based UUID**
	  //
	  // Inspired by https://github.com/LiosK/UUID.js
	  // and http://docs.python.org/library/uuid.html
	
	  // random #'s we need to init node and clockseq
	  var _seedBytes = _rng();
	
	  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	  var _nodeId = [
	    _seedBytes[0] | 0x01,
	    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	  ];
	
	  // Per 4.2.2, randomize (14 bit) clockseq
	  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	  // Previous uuid creation time
	  var _lastMSecs = 0, _lastNSecs = 0;
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v1(options, buf, offset) {
	    var i = buf && offset || 0;
	    var b = buf || [];
	
	    options = options || {};
	
	    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;
	
	    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();
	
	    // Per 4.2.1.2, use count of uuid's generated during the current clock
	    // cycle to simulate higher resolution clock
	    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;
	
	    // Time since last uuid creation (in msecs)
	    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	    // Per 4.2.1.2, Bump clockseq on clock regression
	    if (dt < 0 && options.clockseq == null) {
	      clockseq = clockseq + 1 & 0x3fff;
	    }
	
	    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	    // time interval
	    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
	      nsecs = 0;
	    }
	
	    // Per 4.2.1.2 Throw error if too many uuids are requested
	    if (nsecs >= 10000) {
	      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	    }
	
	    _lastMSecs = msecs;
	    _lastNSecs = nsecs;
	    _clockseq = clockseq;
	
	    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	    msecs += 12219292800000;
	
	    // `time_low`
	    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	    b[i++] = tl >>> 24 & 0xff;
	    b[i++] = tl >>> 16 & 0xff;
	    b[i++] = tl >>> 8 & 0xff;
	    b[i++] = tl & 0xff;
	
	    // `time_mid`
	    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	    b[i++] = tmh >>> 8 & 0xff;
	    b[i++] = tmh & 0xff;
	
	    // `time_high_and_version`
	    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	    b[i++] = tmh >>> 16 & 0xff;
	
	    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	    b[i++] = clockseq >>> 8 | 0x80;
	
	    // `clock_seq_low`
	    b[i++] = clockseq & 0xff;
	
	    // `node`
	    var node = options.node || _nodeId;
	    for (var n = 0; n < 6; n++) {
	      b[i + n] = node[n];
	    }
	
	    return buf ? buf : unparse(b);
	  }
	
	  // **`v4()` - Generate random UUID**
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v4(options, buf, offset) {
	    // Deprecated - 'format' argument, as supported in v1.2
	    var i = buf && offset || 0;
	
	    if (typeof(options) === 'string') {
	      buf = (options === 'binary') ? new BufferClass(16) : null;
	      options = null;
	    }
	    options = options || {};
	
	    var rnds = options.random || (options.rng || _rng)();
	
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = (rnds[6] & 0x0f) | 0x40;
	    rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	    // Copy bytes to buffer, if provided
	    if (buf) {
	      for (var ii = 0; ii < 16; ii++) {
	        buf[i + ii] = rnds[ii];
	      }
	    }
	
	    return buf || unparse(rnds);
	  }
	
	  // Export public API
	  var uuid = v4;
	  uuid.v1 = v1;
	  uuid.v4 = v4;
	  uuid.parse = parse;
	  uuid.unparse = unparse;
	  uuid.BufferClass = BufferClass;
	  uuid._rng = _rng;
	  uuid._mathRNG = _mathRNG;
	  uuid._nodeRNG = _nodeRNG;
	  uuid._whatwgRNG = _whatwgRNG;
	
	  if (('undefined' !== typeof module) && module.exports) {
	    // Publish as node.js module
	    module.exports = uuid;
	  } else if (true) {
	    // Publish as AMD module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {return uuid;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	
	  } else {
	    // Publish as global (in browsers)
	    _previousRoot = _window.uuid;
	
	    // **`noConflict()` - (browser only) to reset global 'uuid' var**
	    uuid.noConflict = function() {
	      _window.uuid = _previousRoot;
	      return uuid;
	    };
	
	    _window.uuid = uuid;
	  }
	})('undefined' !== typeof window ? window : null);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var createReactClass = __webpack_require__(1589);
	
	module.exports = createReactClass({
	  initialize: function(node) {
	    if (node === null) return;
	
	    var app;
	
	    if (this.props.src.embed) {
	      // Elm 0.18
	      app = this.props.src.embed(node, this.props.flags);
	    } else if (this.props.src.init) {
	      // Elm 0.19
	      // Note that Elm 0.19 doesn't treat `node` as a container, but rather as a placeholder.
	      // The Elm App will replace the provided node, rather than mount itself within the provided node.
	      // This can cause react-dom runtime errors when unmounting this React component.
	      // The workaround is to create an extra <div>, which React doesn't control, and allow Elm to replace that node.
	      var elmPlaceholder = document.createElement("div");
	      node.appendChild(elmPlaceholder);
	      app = this.props.src.init({
	        node: elmPlaceholder,
	        flags: this.props.flags
	      });
	    }
	
	    if (app && typeof this.props.ports !== "undefined") {
	      this.props.ports(app.ports);
	    }
	  },
	
	  shouldComponentUpdate: function(prevProps) {
	    return false;
	  },
	
	  render: function() {
	    return React.createElement("div", { ref: this.initialize });
	  }
	});


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.0.3'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(1238)('wks')
	  , uid        = __webpack_require__(922)
	  , Symbol     = __webpack_require__(465).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

/***/ }),
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DashboardPanelAdd = __webpack_require__(2206);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DashboardPanelAdd = function (_Component) {
	    _inherits(DashboardPanelAdd, _Component);
	
	    function DashboardPanelAdd() {
	        _classCallCheck(this, DashboardPanelAdd);
	
	        return _possibleConstructorReturn(this, (DashboardPanelAdd.__proto__ || Object.getPrototypeOf(DashboardPanelAdd)).apply(this, arguments));
	    }
	
	    _createClass(DashboardPanelAdd, [{
	        key: 'render',
	        value: function render() {
	            var onClick = this.props.onClick;
	
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(_DashboardPanelAdd2.default.default, _defineProperty({}, _DashboardPanelAdd2.default.clickable, onClick)),
	                    onClick: onClick },
	                _react2.default.createElement(
	                    'div',
	                    { className: _DashboardPanelAdd2.default.add },
	                    '+'
	                )
	            );
	        }
	    }]);
	
	    return DashboardPanelAdd;
	}(_react.Component);
	
	DashboardPanelAdd.propTypes = {};
	exports.default = DashboardPanelAdd;

/***/ }),
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(165)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(32);
	var toAbsoluteIndex = __webpack_require__(100);
	var toLength = __webpack_require__(27);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(553);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(30);
	var createDesc = __webpack_require__(97);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var document = __webpack_require__(16).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(25)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(16).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var setPrototypeOf = __webpack_require__(220).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(115);
	var ITERATOR = __webpack_require__(25)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(94);
	var descriptor = __webpack_require__(97);
	var setToStringTag = __webpack_require__(116);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(43)(IteratorPrototype, __webpack_require__(25)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(83);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(44);
	var hide = __webpack_require__(43);
	var Iterators = __webpack_require__(115);
	var $iterCreate = __webpack_require__(213);
	var setToStringTag = __webpack_require__(116);
	var getPrototypeOf = __webpack_require__(52);
	var ITERATOR = __webpack_require__(25)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(16);
	var macrotask = __webpack_require__(225).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(59)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(37);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(131);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(19);
	var anObject = __webpack_require__(11);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(61)(Function.call, __webpack_require__(51).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(134)('keys');
	var uid = __webpack_require__(101);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(158);
	var defined = __webpack_require__(67);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(63);
	var defined = __webpack_require__(67);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(61);
	var invoke = __webpack_require__(290);
	var html = __webpack_require__(210);
	var cel = __webpack_require__(207);
	var global = __webpack_require__(16);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(59)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(16);
	var DESCRIPTORS = __webpack_require__(28);
	var LIBRARY = __webpack_require__(83);
	var $typed = __webpack_require__(166);
	var hide = __webpack_require__(43);
	var redefineAll = __webpack_require__(98);
	var fails = __webpack_require__(18);
	var anInstance = __webpack_require__(92);
	var toInteger = __webpack_require__(63);
	var toLength = __webpack_require__(27);
	var toIndex = __webpack_require__(309);
	var gOPN = __webpack_require__(95).f;
	var dP = __webpack_require__(30).f;
	var arrayFill = __webpack_require__(204);
	var setToStringTag = __webpack_require__(116);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(16);
	var core = __webpack_require__(60);
	var LIBRARY = __webpack_require__(83);
	var wksExt = __webpack_require__(310);
	var defineProperty = __webpack_require__(30).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(114);
	var ITERATOR = __webpack_require__(25)('iterator');
	var Iterators = __webpack_require__(115);
	module.exports = __webpack_require__(60).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(82);
	var step = __webpack_require__(293);
	var Iterators = __webpack_require__(115);
	var toIObject = __webpack_require__(53);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(214)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(119);
	var core = __webpack_require__(103);
	var ctx = __webpack_require__(765);
	var hide = __webpack_require__(136);
	var has = __webpack_require__(170);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(327)('keys');
	var uid = __webpack_require__(329);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(321);
	var defined = __webpack_require__(230);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FIRST_GROUP_PATTERN = undefined;
	
	var _extends2 = __webpack_require__(316);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(168);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = format;
	exports.format_national_number_using_format = format_national_number_using_format;
	exports.format_national_number = format_national_number;
	exports.choose_format_for_number = choose_format_for_number;
	exports.local_to_international_style = local_to_international_style;
	
	var _common = __webpack_require__(173);
	
	var _parse = __webpack_require__(121);
	
	var _metadata = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_options = {
		formatExtension: function formatExtension(number, extension) {
			return number + ' ext. ' + extension;
		}
	
		// Formats a phone number
		//
		// Example use cases:
		//
		// ```js
		// format('8005553535', 'RU', 'International')
		// format('8005553535', 'RU', 'International', metadata)
		// format({ phone: '8005553535', country: 'RU' }, 'International')
		// format({ phone: '8005553535', country: 'RU' }, 'International', metadata)
		// format('+78005553535', 'National')
		// format('+78005553535', 'National', metadata)
		// ```
		//
	}; // This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	
	function format(arg_1, arg_2, arg_3, arg_4, arg_5) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4, arg_5),
		    input = _sort_out_arguments.input,
		    format_type = _sort_out_arguments.format_type,
		    options = _sort_out_arguments.options,
		    metadata = _sort_out_arguments.metadata;
	
		var country_metadata = void 0;
	
		if (input.country) {
			country_metadata = metadata.countries[input.country];
		}
	
		var _parse_phone_number_a = (0, _parse.parse_phone_number_and_country_phone_code)(input.phone, metadata),
		    country_phone_code = _parse_phone_number_a.country_phone_code,
		    number = _parse_phone_number_a.number;
	
		if (country_phone_code) {
			// Check country restriction
			if (input.country && country_metadata && country_phone_code !== (0, _metadata.get_phone_code)(country_metadata)) {
				return input.phone;
			}
	
			country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, metadata);
		}
	
		if (!country_metadata) {
			return input.phone;
		}
	
		switch (format_type) {
			case 'International':
				if (!number) {
					return '+' + (0, _metadata.get_phone_code)(country_metadata);
				}
				var national_number = format_national_number(number, 'International', false, country_metadata);
				var international_number = '+' + (0, _metadata.get_phone_code)(country_metadata) + ' ' + national_number;
				if (input.ext || input.ext === 0) {
					return options.formatExtension(international_number, input.ext);
				}
				return international_number;
	
			case 'E.164':
			// "International_plaintext" is deprecated
			case 'International_plaintext':
				// `E.164` doesn't define "phone number extensions".
				return '+' + (0, _metadata.get_phone_code)(country_metadata) + input.phone;
	
			case 'RFC3966':
				return '+' + (0, _metadata.get_phone_code)(country_metadata) + input.phone + (input.ext || input.ext === 0 ? ';ext=' + input.ext : '');
	
			case 'National':
				if (!number) {
					return '';
				}
				var _national_number = format_national_number(number, 'National', false, country_metadata);
				if (input.ext || input.ext === 0) {
					return options.formatExtension(_national_number, input.ext);
				}
				return _national_number;
		}
	}
	
	// This was originally set to $1 but there are some countries for which the
	// first group is not used in the national pattern (e.g. Argentina) so the $1
	// group does not match correctly.  Therefore, we use \d, so that the first
	// group actually used in the pattern will be matched.
	var FIRST_GROUP_PATTERN = exports.FIRST_GROUP_PATTERN = /(\$\d)/;
	
	function format_national_number_using_format(number, format, international, enforce_national_prefix, country_metadata) {
		var format_pattern_matcher = new RegExp((0, _metadata.get_format_pattern)(format));
	
		var national_prefix_formatting_rule = (0, _metadata.get_format_national_prefix_formatting_rule)(format, country_metadata);
	
		// National prefix is omitted if there's no national prefix formatting rule
		// set for this country, or when this rule is set but
		// national prefix is optional for this phone number format
		// (and it is not enforced explicitly)
		var national_prefix_may_be_omitted = !national_prefix_formatting_rule || national_prefix_formatting_rule && (0, _metadata.get_format_national_prefix_is_optional_when_formatting)(format, country_metadata) && !enforce_national_prefix;
	
		if (!international && !national_prefix_may_be_omitted) {
			return number.replace(format_pattern_matcher, (0, _metadata.get_format_format)(format).replace(FIRST_GROUP_PATTERN, national_prefix_formatting_rule));
		}
	
		var formatted_number = number.replace(format_pattern_matcher, international ? (0, _metadata.get_format_international_format)(format) : (0, _metadata.get_format_format)(format));
	
		if (international) {
			return local_to_international_style(formatted_number);
		}
	
		return formatted_number;
	}
	
	function format_national_number(number, format_as, enforce_national_prefix, country_metadata) {
		var format = choose_format_for_number((0, _metadata.get_formats)(country_metadata), number);
	
		if (!format) {
			return number;
		}
	
		return format_national_number_using_format(number, format, format_as === 'International', enforce_national_prefix, country_metadata);
	}
	
	function choose_format_for_number(available_formats, national_number) {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = (0, _getIterator3.default)(available_formats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var _format = _step.value;
	
				// Validate leading digits
				if ((0, _metadata.get_format_leading_digits_patterns)(_format).length > 0) {
					// The last leading_digits_pattern is used here, as it is the most detailed
					var last_leading_digits_pattern = (0, _metadata.get_format_leading_digits_patterns)(_format)[(0, _metadata.get_format_leading_digits_patterns)(_format).length - 1];
	
					// If leading digits don't match then move on to the next phone number format
					if (national_number.search(last_leading_digits_pattern) !== 0) {
						continue;
					}
				}
	
				// Check that the national number matches the phone number format regular expression
				if ((0, _common.matches_entirely)(national_number, new RegExp((0, _metadata.get_format_pattern)(_format)))) {
					return _format;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}
	
	// Removes brackets and replaces dashes with spaces.
	//
	// E.g. "(999) 111-22-33" -> "999 111 22 33"
	//
	function local_to_international_style(local) {
		return local.replace(new RegExp('[' + _parse.VALID_PUNCTUATION + ']+', 'g'), ' ').trim();
	}
	
	// Sort out arguments
	function sort_out_arguments() {
		var arg_1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var arg_2 = arguments[1];
		var arg_3 = arguments[2];
		var arg_4 = arguments[3];
		var arg_5 = arguments[4];
	
		var input = void 0;
		var format_type = void 0;
		var options = void 0;
		var metadata = void 0;
	
		// Sort out arguments.
	
		// If the phone number is passed as a string.
		// `format('8005553535', ...)`.
		if (typeof arg_1 === 'string') {
			// If country code is supplied.
			// `format('8005553535', 'RU', 'National', [options], metadata)`.
			if (typeof arg_3 === 'string') {
				// Will be `parse()`d later in code
				input = {
					phone: arg_1,
					country: arg_2
				};
	
				format_type = arg_3;
	
				if (arg_5) {
					options = arg_4;
					metadata = arg_5;
				} else {
					metadata = arg_4;
				}
			}
			// Just an international phone number is supplied
			// `format('+78005553535', 'National', [options], metadata)`.
			else {
					// Will be `parse()`d later in code
					input = {
						phone: arg_1
					};
	
					if (typeof arg_2 !== 'string') {
						throw new Error('Format type argument not passed for `format()`');
					}
	
					format_type = arg_2;
	
					if (arg_4) {
						options = arg_3;
						metadata = arg_4;
					} else {
						metadata = arg_3;
					}
				}
		}
		// If the phone number is passed as a parsed number object.
		// `format({ phone: '8005553535', country: 'RU' }, 'National', [options], metadata)`.
		else {
				input = arg_1;
				format_type = arg_2;
	
				if (arg_4) {
					options = arg_3;
					metadata = arg_4;
				} else {
					metadata = arg_3;
				}
			}
	
		// Metadata is required.
		if (!metadata) {
			throw new Error('Metadata is required');
		}
	
		// Validate `format_type`.
		switch (format_type) {
			case 'International':
			case 'E.164':
			// "International_plaintext" is deprecated
			case 'International_plaintext':
			case 'National':
			case 'RFC3966':
				break;
			default:
				throw new Error('Unknown format type argument passed to "format()": "' + format_type + '"');
		}
	
		// Apply default options.
		if (options) {
			options = (0, _extends3.default)({}, default_options, options);
		} else {
			options = default_options;
		}
	
		return { input: input, format_type: format_type, options: options, metadata: metadata };
	}
	//# sourceMappingURL=format.js.map

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = get_number_type;
	exports.is_of_type = is_of_type;
	exports.sort_out_arguments = sort_out_arguments;
	
	var _parse = __webpack_require__(121);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _common = __webpack_require__(173);
	
	var _metadata = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Finds out national phone number type (fixed line, mobile, etc)
	function get_number_type(arg_1, arg_2, arg_3) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3),
		    input = _sort_out_arguments.input,
		    metadata = _sort_out_arguments.metadata;
	
		// When no input was passed
	
	
		if (!input) {
			return;
		}
	
		// When `parse()` returned `{}`
		// meaning that the phone number is not a valid one.
		if (!input.country) {
			return;
		}
	
		var national_number = input.phone;
		var country_metadata = metadata.countries[input.country];
	
		// The following is copy-pasted from the original function:
		// https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
	
		// Is this national number even valid for this country
		if (!is_of_type(national_number, (0, _metadata.get_national_number_pattern)(country_metadata))) {
			return; // 'UNKNOWN'
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_premium_rate)(country_metadata))) {
			return 'PREMIUM_RATE';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_toll_free)(country_metadata))) {
			return 'TOLL_FREE';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_shared_cost)(country_metadata))) {
			return 'SHARED_COST';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_voip)(country_metadata))) {
			return 'VOIP';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_personal_number)(country_metadata))) {
			return 'PERSONAL_NUMBER';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_pager)(country_metadata))) {
			return 'PAGER';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_uan)(country_metadata))) {
			return 'UAN';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_voice_mail)(country_metadata))) {
			return 'VOICEMAIL';
		}
	
		// Is it fixed line number
		if (is_of_type(national_number, (0, _metadata.get_type_fixed_line)(country_metadata))) {
			// Because duplicate regular expressions are removed
			// to reduce metadata size, if there's no "mobile" pattern
			// then it means it was removed due to being a duplicate of some other pattern.
			//
			if (!(0, _metadata.get_type_mobile)(country_metadata)) {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			// Check if the number happens to qualify as both fixed line and mobile.
			// (no such country in the minimal metadata set)
			/* istanbul ignore if */
			if (is_of_type(national_number, (0, _metadata.get_type_mobile)(country_metadata))) {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			return 'FIXED_LINE';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_mobile)(country_metadata))) {
			return 'MOBILE';
		}
	
		// return 'UNKNOWN'
	}
	
	function is_of_type(national_number, type) {
		// // Check if any possible number lengths are present;
		// // if so, we use them to avoid checking
		// // the validation pattern if they don't match.
		// // If they are absent, this means they match
		// // the general description, which we have
		// // already checked before a specific number type.
		// if (get_possible_lengths(type) &&
		// 	get_possible_lengths(type).indexOf(national_number.length) === -1)
		// {
		// 	return false
		// }
	
		// get_type_pattern(type) === type
		return (0, _common.matches_entirely)(national_number, type);
	}
	
	// Sort out arguments
	function sort_out_arguments(arg_1, arg_2, arg_3) {
		var input = void 0;
		var metadata = void 0;
	
		// Normalize numerical `value`.
		// https://github.com/catamphetamine/libphonenumber-js/issues/142
		// `getNumberType(88005553535, ...)`.
		if (typeof arg_1 === 'number') {
			arg_1 = String(arg_1);
		}
	
		// If the phone number is passed as a string.
		// `getNumberType('88005553535', ...)`.
		if (typeof arg_1 === 'string') {
			// If "resrict country" argument is being passed
			// then convert it to an `options` object.
			// `getNumberType('88005553535', 'RU', metadata)`.
			if (typeof arg_2 === 'string' || arg_2 === undefined) {
				metadata = arg_3;
	
				// `parse` extracts phone numbers from raw text,
				// therefore it will cut off all "garbage" characters,
				// while this `validate` function needs to verify
				// that the phone number contains no "garbage"
				// therefore the explicit `is_viable_phone_number` check.
				if ((0, _parse.is_viable_phone_number)(arg_1)) {
					input = (0, _parse2.default)(arg_1, arg_2, metadata);
				}
			}
			// No "resrict country" argument is being passed.
			// International phone number is passed.
			// `getNumberType('+78005553535', metadata)`.
			else {
					metadata = arg_2;
	
					// `parse` extracts phone numbers from raw text,
					// therefore it will cut off all "garbage" characters,
					// while this `validate` function needs to verify
					// that the phone number contains no "garbage"
					// therefore the explicit `is_viable_phone_number` check.
					if ((0, _parse.is_viable_phone_number)(arg_1)) {
						input = (0, _parse2.default)(arg_1, metadata);
					}
				}
		}
		// If the phone number is passed as a parsed phone number.
		// `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
		else {
				// The `arg_1` must be a valid phone number
				// as a whole, not just a part of it which gets parsed here.
				if (arg_1 && arg_1.phone && (0, _parse.is_viable_phone_number)(arg_1.phone)) {
					input = arg_1;
				}
	
				metadata = arg_2;
			}
	
		// Metadata is required.
		if (!metadata || !metadata.countries) {
			throw new Error('Metadata is required');
		}
	
		return { input: input, metadata: metadata };
	}
	//# sourceMappingURL=types.js.map

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(122);
	var ReactPerf = __webpack_require__(64);
	
	var quoteAttributeValueForBrowser = __webpack_require__(859);
	var warning = __webpack_require__(23);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(488);
	var ReactPropTypeLocations = __webpack_require__(177);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(245);
	var ReactMount = __webpack_require__(39);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(468);
	var DOMPropertyOperations = __webpack_require__(241);
	var ReactMount = __webpack_require__(39);
	var ReactPerf = __webpack_require__(64);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(78);
	var ReactElement = __webpack_require__(41);
	var ReactInstanceMap = __webpack_require__(143);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(22);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.9';

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(78);
	var ReactInstanceMap = __webpack_require__(143);
	var ReactMount = __webpack_require__(39);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	var escapeTextContentForBrowser = __webpack_require__(180);
	var setInnerHTML = __webpack_require__(181);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(78);
	var ReactElement = __webpack_require__(41);
	var ReactInstanceHandles = __webpack_require__(109);
	
	var getIteratorFn = __webpack_require__(252);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(22);
	var emptyFunction = __webpack_require__(65);
	var warning = __webpack_require__(23);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(174);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(138);
	util.inherits = __webpack_require__(89);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(883)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(504);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(183).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(503);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(107);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(107);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90), __webpack_require__(882).setImmediate, (function() { return this; }())))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(501);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(258);
	exports.Duplex = __webpack_require__(107);
	exports.Transform = __webpack_require__(502);
	exports.PassThrough = __webpack_require__(874);


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Picker = __webpack_require__(2214);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function sourceFilter(value, identify, multi) {
	    if (multi) {
	        return function (item) {
	            return !(value && value.find(function (v) {
	                return identify(v) == identify(item);
	            }));
	        };
	    }
	
	    var valueId = value && identify(value);
	    return function (item) {
	        return !(valueId == identify(item));
	    };
	}
	
	var Picker = function (_Component) {
	    _inherits(Picker, _Component);
	
	    function Picker(props) {
	        _classCallCheck(this, Picker);
	
	        var _this = _possibleConstructorReturn(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));
	
	        _this.state = {
	            filteredSource: []
	        };
	        return _this;
	    }
	
	    _createClass(Picker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                source = _props.source,
	                value = _props.value,
	                identify = _props.identify,
	                multi = _props.multi;
	
	
	            var filteredSource = source.filter(sourceFilter(value, identify, multi));
	            this.setState({ filteredSource: filteredSource });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.source != this.props.source || nextProps.value != this.props.value) {
	                var source = nextProps.source,
	                    value = nextProps.value,
	                    identify = nextProps.identify,
	                    multi = nextProps.multi;
	
	
	                var filteredSource = source.filter(sourceFilter(value, identify, multi));
	                this.setState({ filteredSource: filteredSource });
	            }
	        }
	    }, {
	        key: '_add',
	        value: function _add(event, item) {
	            var _props2 = this.props,
	                multi = _props2.multi,
	                identify = _props2.identify,
	                value = _props2.value,
	                onChange = _props2.onChange,
	                onSubmit = _props2.onSubmit;
	
	
	            event.preventDefault();
	
	            if (multi) {
	                var previousValue = value || [];
	                var itemId = identify(item);
	                var index = previousValue.findIndex(function (value) {
	                    return identify(value) == itemId;
	                });
	
	                if (index < 0) {
	                    if (onSubmit) {
	                        onSubmit('Add', item);
	                    }
	
	                    if (onChange) {
	                        var nextValue = [].concat(_toConsumableArray(previousValue));
	                        nextValue.push(item);
	                        onChange(nextValue);
	                    }
	                }
	            } else {
	                if ((value && identify(value)) != identify(item)) {
	                    if (onSubmit) {
	                        onSubmit('Add', item);
	                    }
	
	                    if (onChange) {
	                        onChange(item);
	                    }
	                }
	            }
	        }
	    }, {
	        key: '_remove',
	        value: function _remove(event, item) {
	            var _props3 = this.props,
	                multi = _props3.multi,
	                identify = _props3.identify,
	                value = _props3.value,
	                onChange = _props3.onChange,
	                onSubmit = _props3.onSubmit;
	
	
	            event.preventDefault();
	
	            if (multi) {
	                var previousValue = value || [];
	                var itemId = identify(item);
	                var index = previousValue.findIndex(function (value) {
	                    return identify(value) == itemId;
	                });
	
	                if (index >= 0) {
	                    if (onSubmit) {
	                        onSubmit('Remove', item);
	                    }
	
	                    if (onChange) {
	                        var nextValue = [].concat(_toConsumableArray(previousValue));
	                        nextValue.splice(index, 1);
	                        onChange(nextValue);
	                    }
	                }
	            } else {
	                if ((value && identify(value)) == identify(item)) {
	                    if (onSubmit) {
	                        onSubmit('Remove', value);
	                    }
	
	                    if (onChange) {
	                        onChange(null);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                source = _props4.source,
	                display = _props4.display,
	                identify = _props4.identify,
	                disable = _props4.disable,
	                header = _props4.header,
	                after = _props4.after,
	                split = _props4.split,
	                multi = _props4.multi,
	                size = _props4.size,
	                bsStyle = _props4.bsStyle,
	                value = _props4.value,
	                onChange = _props4.onChange,
	                onSubmit = _props4.onSubmit,
	                children = _props4.children,
	                other = _objectWithoutProperties(_props4, ['source', 'display', 'identify', 'disable', 'header', 'after', 'split', 'multi', 'size', 'bsStyle', 'value', 'onChange', 'onSubmit', 'children']);
	
	            var filteredSource = this.state.filteredSource;
	
	            var sizeClass = size && size.toLowerCase();
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Picker2.default.default, _Picker2.default[sizeClass], _defineProperty({}, _Picker2.default.error, bsStyle == 'error')) },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    split && children && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _Picker2.default.body },
	                            children
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: split && (children && 4 || 6) || 12 },
	                        (split || !value) && _react2.default.createElement(
	                            'div',
	                            null,
	                            header,
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _Picker2.default.result },
	                                filteredSource.map(function (item) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        {
	                                            className: (0, _classnames2.default)(_defineProperty({}, _Picker2.default.disabled, disable(item))),
	                                            key: identify(item) },
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                className: _Picker2.default.add,
	                                                onClick: function onClick(e) {
	                                                    return !disable(item) && _this2._add(e, item) || e.preventDefault();
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            display(item)
	                                        )
	                                    );
	                                }),
	                                after && _react2.default.createElement(
	                                    'li',
	                                    {
	                                        key: 'after',
	                                        className: _Picker2.default.after },
	                                    after
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: split && (children && 4 || 6) || 12 },
	                        !multi && value && _react2.default.createElement(
	                            'div',
	                            { className: _Picker2.default.picked },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _Picker2.default.remove },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        onClick: function onClick(e) {
	                                            return _this2._remove(e, value);
	                                        } },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _Picker2.default.container },
	                                display(value, 'Picked')
	                            )
	                        ),
	                        multi && value && _react2.default.createElement(
	                            'ul',
	                            { className: _Picker2.default.result },
	                            value.map(function (value) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    {
	                                        className: (0, _classnames2.default)(_defineProperty({}, _Picker2.default.disabled, disable(value))),
	                                        key: identify(value) },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            className: _Picker2.default.remove,
	                                            onClick: function onClick(e) {
	                                                return !disable(value) && _this2._remove(e, value) || e.preventDefault();
	                                            } },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        display(value)
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Picker;
	}(_react.Component);
	
	Picker.propTypes = {
	    source: _react.PropTypes.array.isRequired,
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    disable: _react.PropTypes.func,
	    header: _react.PropTypes.object,
	    after: _react.PropTypes.object,
	    split: _react.PropTypes.bool,
	    multi: _react.PropTypes.bool,
	    size: _react.PropTypes.string,
	    bsStyle: _react.PropTypes.string,
	    value: _react.PropTypes.any,
	    onChange: _react.PropTypes.func,
	    onSubmit: _react.PropTypes.func
	};
	Picker.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    },
	    disable: function disable(v) {
	        return false;
	    }
	};
	exports.default = Picker;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.autocompleteMatcher = autocompleteMatcher;
	exports.provideAutocompleteMatcher = provideAutocompleteMatcher;
	exports.addressField = addressField;
	exports.getPredictionAddress = getPredictionAddress;
	exports.highlightPrediction = highlightPrediction;
	exports.displayPrediction = displayPrediction;
	
	var _maps = __webpack_require__(1093);
	
	var _maps2 = _interopRequireDefault(_maps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var autocompleteService;
	var placesService;
	
	function getAutocompleteService() {
	    if (autocompleteService) return autocompleteService;
	    return autocompleteService = new _maps2.default.places.AutocompleteService();
	}
	
	function getPlacesService() {
	    if (placesService) return placesService;
	
	    var element = document.createElement('div');
	    document.body.appendChild(element);
	    return placesService = new _maps2.default.places.PlacesService(element);
	}
	
	function autocompleteMatcher(q, cb) {
	    if (q) {
	        var options = {
	            input: q,
	            componentRestrictions: {
	                country: 'fr'
	            },
	            types: ['geocode']
	        };
	
	        getAutocompleteService().getPlacePredictions(options, function (predictions) {
	            cb(predictions || []);
	        });
	    } else {
	        cb([]);
	    }
	}
	
	function provideAutocompleteMatcher(predictionOptions) {
	    var input = predictionOptions.input,
	        otherPredictionOption = _objectWithoutProperties(predictionOptions, ['input']);
	
	    var inputPrefix = input && input + ' ' || '';
	
	    return function (q, cb) {
	        if (q) {
	            var options = _extends({
	                input: inputPrefix + q,
	                componentRestrictions: {
	                    country: 'fr'
	                },
	                types: ['geocode']
	            }, otherPredictionOption);
	
	            getAutocompleteService().getPlacePredictions(options, function (predictions) {
	                cb(predictions || []);
	            });
	        } else {
	            cb([]);
	        }
	    };
	}
	
	function addressField(field) {
	
	    function onChange(prediction) {
	        getPredictionAddress(prediction, field.onChange);
	    }
	
	    return _extends({}, field, { onChange: onChange });
	}
	
	function getPredictionAddress(prediction, cb) {
	
	    function populateAddress(address, addressComponent) {
	        addressComponent.types.forEach(function (type) {
	            switch (type) {
	                case 'street_number':
	                    address.number = addressComponent['long_name'];
	                    break;
	                case 'route':
	                    address.street = addressComponent['long_name'];
	                    break;
	                case 'locality':
	                    address.city = addressComponent['long_name'];
	                    break;
	                case 'country':
	                    address.country = addressComponent['long_name'];
	                    break;
	                case 'postal_code':
	                    address.zipCode = addressComponent['long_name'];
	                    break;
	            }
	        });
	        return address;
	    }
	
	    getPlacesService().getDetails({ placeId: prediction.place_id }, function (place) {
	        if (place) {
	            var address = {
	                number: null,
	                street: null,
	                city: null,
	                country: null,
	                zipCode: null,
	                checker: {
	                    googlePlaceId: place['place_id']
	                },
	                geoLocation: {
	                    lat: place.geometry.location.lat(),
	                    lng: place.geometry.location.lng()
	                }
	            };
	
	            address = place['address_components'].reduce(populateAddress, address);
	            cb(address);
	        } else {
	            cb(null);
	        }
	    });
	}
	
	function highlightPrediction(prediction) {
	    var chars = prediction.description;
	    var matches = prediction['matched_substrings'];
	    var index = -1;
	    var offset = -1;
	    var limit = -1;
	    next();
	
	    function next() {
	        index++;
	        if (index < matches.length) {
	            offset = matches[index].offset;
	            limit = offset + matches[index].length - 1;
	        }
	    }
	
	    var highlight = [].concat(_toConsumableArray(chars)).map(function (char, index) {
	        var result = char;
	
	        if (index == offset) {
	            result = '<b>' + result;
	        }
	
	        if (index == limit) {
	            result = result + '</b>';
	            next();
	        }
	
	        return result;
	    }).join('');
	
	    return { __html: highlight };
	}
	
	function displayPrediction(prediction) {
	    return prediction.description;
	}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        errorTypeEnum: {
	            labelShouldBeUniq: 'Ce nom existe déjà',
	            lastCategoryCanNotBeRemoved: 'Une raison d\'ouverture de ticket doit avoir au moins une catégorie',
	            categoryIsAlreadyAssociatedWithOpeningTicketPurpose: 'Cette catégorie est déjà associée à la raison d\'ouverture de ticket',
	            lastTagCanNotBeRemoved: 'Une raison d\'ouverture de ticket doit avoir au moins un tag',
	            openingTicketPurposeDoesNotExist: 'Cette raison d\'ouverture de ticket n\'est pas éditable'
	        },
	        openingTicketPurposes: 'raisons d\'ouverture de ticket',
	        newOpeningTicketPurpose: 'nouvelle raison d\'ouverture de ticket',
	        searchOpeningTicketPurpose: 'rechercher une demande',
	        categories: 'catégories',
	        manageCategories: 'catégories',
	        searchCategory: 'rechercher une catégorie',
	        newCategory: 'nouvelle catégorie',
	        updateCategory: 'modification',
	        addCategory: 'ajouter une catégorie',
	        addChildCategory: 'ajouter une sous catégorie',
	        parentCategory: 'parent',
	        tags: 'tags',
	        manageTags: 'tags',
	        searchTag: 'rechercher un tag',
	        newTag: 'nouveau tag',
	        updateTag: 'modification',
	        addTag: 'ajouter un tag',
	        icon: 'icon',
	        searchIcon: 'rechercher une icon',
	        activities: 'activités',
	        associateActivity: 'associer une activité',
	        associateActivityText: ['associez cette raison d\'ouverture de ticket aux contacts fournisseurs de votre choix'],
	        dissociateActivity: 'dissocier une activité',
	        dissociateActivityText: ['Vous êtes sur le point de dissocier l\'activité {label}.', '[[{count} contacts fournisseurs ne seront plus associés à cette raison d\'ouverture de ticket.]]'],
	        reference: 'référence externe',
	        referenceInfo: 'la référence externe vous sert à faire le lien entre votre référentiel sur l\'application et un éventuel référentiel sur un autre système',
	        enableOpeningTicketPurpose: 'activer la raison d\'ouverture de ticket ...',
	        enableOpeningTicketPurposeText: ['Vous êtes sur le point d\'activer la raison d\'ouverture de ticket {label}.'],
	        disableOpeningTicketPurpose: 'désactiver la raison d\'ouverture de ticket ...',
	        disableOpeningTicketPurposeText: ['Vous êtes sur le point de désactiver la raison d\'ouverture de ticket {label}.'],
	        searchProviderContact: 'rechercher un contact fournisseur',
	        providerContactDissociatedFromOpeningTicketPurpose: '{count} contacts fournisseurs ont été dissociés de cette raison d\'ouverture de ticket'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(336),
	    isString = __webpack_require__(1021),
	    support = __webpack_require__(1025);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  if (support.unindexedChars && isString(value)) {
	    var index = -1,
	        length = value.length,
	        result = Object(value);
	
	    while (++index < length) {
	      result[index] = value.charAt(index);
	    }
	    return result;
	  }
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(55);
	var Transaction = __webpack_require__(147);
	
	var assign = __webpack_require__(22);
	var emptyFunction = __webpack_require__(65);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Typeahead = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.matcher = matcher;
	exports.multiMatcher = multiMatcher;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RootCloseWrapper = __webpack_require__(1243);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _TypeaheadInput = __webpack_require__(2230);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function escapeRegExp(value) {
	    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	function matcher(_ref) {
	    var source = _ref.source,
	        _ref$identify = _ref.identify,
	        identify = _ref$identify === undefined ? function (v) {
	        return v;
	    } : _ref$identify;
	
	    return function (q, cb) {
	        var matches;
	
	        if (q) {
	            var regexp = new RegExp(escapeRegExp(q), 'i');
	            matches = source.filter(function (value) {
	                return regexp.test(identify(value));
	            });
	        } else {
	            matches = source;
	        }
	
	        cb(matches);
	    };
	}
	
	function multiMatcher(matchers) {
	    return function (q, cb) {
	        var result = [];
	        var count = matchers.length;
	
	        matchers.forEach(function (matcher) {
	            matcher(q, function (matches) {
	                count--;
	                result.push.apply(result, _toConsumableArray(matches));
	
	                if (count == 0) {
	                    cb(result);
	                }
	            });
	        });
	    };
	}
	
	var Typeahead = function (_Component) {
	    _inherits(Typeahead, _Component);
	
	    function Typeahead(props) {
	        _classCallCheck(this, Typeahead);
	
	        var _this = _possibleConstructorReturn(this, (Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call(this, props));
	
	        _this.state = {
	            opened: false,
	            matches: []
	        };
	        return _this;
	    }
	
	    _createClass(Typeahead, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var source = this.props.source;
	
	
	            source(null, function (matches) {
	                _this2.setState({ matches: matches });
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this3 = this;
	
	            if (nextProps.source != this.props.source) {
	                var source = nextProps.source;
	
	
	                source(null, function (matches) {
	                    _this3.setState({
	                        opened: false,
	                        matches: matches,
	                        query: null
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            var _this4 = this;
	
	            var source = this.props.source;
	
	
	            source(null, function (matches) {
	                _this4.setState({
	                    opened: false,
	                    matches: matches,
	                    query: null
	                });
	            });
	        }
	    }, {
	        key: '_match',
	        value: function _match(event) {
	            var _this5 = this;
	
	            var source = this.props.source;
	
	            var query = event.target.value || null;
	
	            this.setState({ query: query });
	
	            source(query, function (matches) {
	                var opened = matches.length > 0;
	                _this5.setState({ opened: opened, matches: matches });
	            });
	        }
	    }, {
	        key: '_select',
	        value: function _select(event, value) {
	            var _props = this.props,
	                onChange = _props.onChange,
	                display = _props.display;
	
	
	            event.preventDefault();
	            this.setState({
	                opened: false,
	                query: display(value, 'Query')
	            });
	            onChange(value);
	        }
	    }, {
	        key: '_open',
	        value: function _open() {
	            var matches = this.state.matches;
	
	
	            this.setState({
	                opened: matches.length > 0
	            });
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({
	                opened: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props2 = this.props,
	                children = _props2.children,
	                source = _props2.source,
	                display = _props2.display,
	                highlight = _props2.highlight,
	                value = _props2.value,
	                onChange = _props2.onChange,
	                addonBefore = _props2.addonBefore,
	                addonAfter = _props2.addonAfter,
	                others = _objectWithoutProperties(_props2, ['children', 'source', 'display', 'highlight', 'value', 'onChange', 'addonBefore', 'addonAfter']);
	
	            var _state = this.state,
	                opened = _state.opened,
	                query = _state.query,
	                matches = _state.matches;
	
	
	            var matchElement = function matchElement(match, index) {
	                var html = highlight && highlight(match) || null;
	                var text = !html && display(match) || null;
	
	                return _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this6._select(e, match);
	                            },
	                            dangerouslySetInnerHTML: html },
	                        text
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TypeaheadInput2.default.default },
	                _react2.default.createElement(
	                    _RootCloseWrapper2.default,
	                    { noWrap: true,
	                        onRootClose: function onRootClose() {
	                            return _this6._close();
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _TypeaheadInput2.default.inputGroup },
	                            addonBefore && _react2.default.createElement('span', null),
	                            _react2.default.createElement('input', _extends({
	                                type: 'text',
	                                value: query,
	                                onFocus: function onFocus(e) {
	                                    return _this6._open(e);
	                                },
	                                onChange: function onChange(e) {
	                                    return _this6._match(e);
	                                }
	                            }, others)),
	                            addonAfter && _react2.default.createElement('span', null)
	                        ),
	                        opened && _react2.default.createElement(
	                            'ul',
	                            { className: _TypeaheadInput2.default.result },
	                            matches.map(matchElement)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Typeahead;
	}(_react.Component);
	
	Typeahead.propTypes = {
	    source: _react.PropTypes.func.isRequired,
	    display: _react.PropTypes.func,
	    highlight: _react.PropTypes.func,
	    onChange: _react.PropTypes.func.isRequired,
	    addonBefore: _react.PropTypes.bool,
	    addonAfter: _react.PropTypes.bool
	};
	Typeahead.defaultProps = {
	    display: function display(v) {
	        return v;
	    }
	};
	
	var TypeaheadInput = function (_Component2) {
	    _inherits(TypeaheadInput, _Component2);
	
	    function TypeaheadInput() {
	        _classCallCheck(this, TypeaheadInput);
	
	        return _possibleConstructorReturn(this, (TypeaheadInput.__proto__ || Object.getPrototypeOf(TypeaheadInput)).apply(this, arguments));
	    }
	
	    _createClass(TypeaheadInput, [{
	        key: 'reset',
	        value: function reset() {
	            var typeahead = this.refs.typeahead;
	
	            typeahead.reset();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                source = _props3.source,
	                display = _props3.display,
	                highlight = _props3.highlight,
	                onChange = _props3.onChange,
	                placeholder = _props3.placeholder,
	                disabled = _props3.disabled,
	                bsStyle = _props3.bsStyle,
	                addonBefore = _props3.addonBefore,
	                addonAfter = _props3.addonAfter,
	                others = _objectWithoutProperties(_props3, ['source', 'display', 'highlight', 'onChange', 'placeholder', 'disabled', 'bsStyle', 'addonBefore', 'addonAfter']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Input,
	                _extends({
	                    addonBefore: addonBefore,
	                    addonAfter: addonAfter
	                }, others),
	                _react2.default.createElement(Typeahead, {
	                    ref: 'typeahead',
	                    className: 'form-control',
	                    source: source,
	                    display: display,
	                    highlight: highlight,
	                    onChange: onChange,
	                    placeholder: placeholder,
	                    disabled: disabled,
	                    addonBefore: addonBefore != null,
	                    addonAfter: addonAfter != null })
	            );
	        }
	    }]);
	
	    return TypeaheadInput;
	}(_react.Component);
	
	exports.Typeahead = Typeahead;
	exports.default = TypeaheadInput;

/***/ }),
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Breadcrumb = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.redirect = redirect;
	exports.after = after;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function redirect(to) {
	    var selectPathname = typeof to == 'function' && to || function () {
	        return to;
	    };
	
	    return function (nextState, replaceState) {
	        var location = nextState.location;
	
	        var pathnameSegments = location.pathname.split('/').slice(1);
	
	        var replacePathname = selectPathname();
	        replacePathname = replacePathname.replace(/^\/\*\//, '/' + pathnameSegments[0] + '/');
	        replacePathname = replacePathname.replace(/^(\/[\w-]+)\/\*\//, '$1/' + pathnameSegments[1] + '/');
	        replacePathname = replacePathname.replace(/^(\/[\w-]+\/[\w-]+)\/\*\//, '$1/' + pathnameSegments[2] + '/');
	        replaceState({ pathname: replacePathname });
	    };
	}
	
	function after(onEnter) {
	    return function (nextState, replaceState) {
	        setTimeout(function () {
	            onEnter(nextState, replaceState, function () {});
	        }, 0);
	    };
	}
	
	function pathBuilder(result, route) {
	    var path = route.path;
	    var pathTokens = path && path.split('/').filter(function (t) {
	        return !!t;
	    }) || [];
	
	    result.push.apply(result, _toConsumableArray(pathTokens));
	    return result;
	}
	
	var Breadcrumb = function (_Component) {
	    _inherits(Breadcrumb, _Component);
	
	    function Breadcrumb(props) {
	        _classCallCheck(this, Breadcrumb);
	
	        var _this = _possibleConstructorReturn(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).call(this, props));
	
	        _this.state = {
	            path: []
	        };
	        return _this;
	    }
	
	    _createClass(Breadcrumb, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var routes = this.props.routes;
	
	
	            var path = routes.reduce(pathBuilder, []);
	            this.setState({ path: path });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.routes != this.props.routes) {
	                var routes = nextProps.routes;
	
	
	                var path = routes.reduce(pathBuilder, []);
	                this.setState({ path: path });
	            }
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var _props = this.props,
	                history = _props.history,
	                params = _props.params;
	
	            var locationPathname = '/' + path.map(function (t) {
	                return params[t.slice(1)] || t;
	            }).join('/');
	
	            event.preventDefault();
	            history.push(locationPathname);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                display = _props2.display,
	                disable = _props2.disable;
	            var path = this.state.path;
	
	
	            var isActive = function isActive(index) {
	                return index == path.length - 1;
	            };
	
	            return _react2.default.createElement(
	                'ol',
	                { className: 'breadcrumb' },
	                path.map(function (token, index) {
	                    return _react2.default.createElement(
	                        'li',
	                        {
	                            key: index,
	                            className: (0, _classnames2.default)({ active: isActive(index) }) },
	                        (isActive(index) || disable(token)) && display(token) || _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, path.slice(0, index + 1));
	                                } },
	                            display(token)
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return Breadcrumb;
	}(_react.Component);
	
	Breadcrumb.propTypes = {
	    history: _react.PropTypes.object.isRequired,
	    routes: _react.PropTypes.array.isRequired,
	    params: _react.PropTypes.array.isRequired,
	    display: _react.PropTypes.func,
	    disable: _react.PropTypes.func
	};
	Breadcrumb.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    disable: function disable(v) {
	        return false;
	    }
	};
	exports.Breadcrumb = Breadcrumb;

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OPENING_TICKET_PURPOSE_REF_ICONS = exports.OPENING_TICKET_PURPOSE_REF_ICONS = ['1-Admin', '1-Animaux', '1-Bricolage', '1-Junior', '1-Pressing', '1-Seniors', 'Achatappartement', 'Achatmaison', 'Aide course', 'Aide devoir', 'Aide hygiene', 'Aide repas', 'aircon', 'alarm', 'Assurance habitation', 'Autre animal', 'Babysitting', 'barrier', 'boiler_1', 'boiler', 'brokenglass', 'bucket', 'burglar', 'careTaker', 'Chat', 'Chemise', 'Chien', 'Colocation avec GLI', 'Colocation sans GLI', 'Coloocation etudiante avec GLI', 'Coloocation etudiante sans GLI', 'Compteur electric', 'Demenagement', 'door', 'electrecity', 'electricité', 'elevator', 'explosion', 'extinctor', 'fail', 'fence', 'firefighters', 'flood', 'gas', 'gasvent', 'Gaz', 'heater', 'hotwater', 'Installation electric', 'intercom', 'internet', 'intrusionalarm', 'Jardinage', 'keys', 'key', 'lamp', 'Lessive', 'linge au poids', 'litter', 'Locationappartement', 'Location etudiante avec GLI', 'Location etudiante sans GLI', 'Location hors etudiante avec GLI', 'Location hors etudiante sans GLI', 'Locationmaison', 'Location voiture', 'manager', 'manogas', 'marker', 'masonry', 'MenagePrintemps', 'Menage', 'Menage-travaux', 'message', 'monitoring', 'openlock', 'other', 'Outiltravaux', 'Pantalon', 'parking', 'Peinture', 'Petitstravaux', 'pipe', 'police', 'pressure', 'pump', 'questionmark', 'Raccordement', 'relocate', 'Repassage', 'rollerblind', 'roof', 'smokevent', 'Surface', 'swimmingpool', 'tablette', 'tap', 'terminal', 'tv', 'vandalism', 'vent', 'Veste', 'Vitre', 'voir_les_demandes', 'warning', 'waterdrop', 'watertap', 'window', 'wrench'].map(function (t) {
	    return t.replace(/ /g, '_');
	});
	
	var OpeningTicketPurposeRef = exports.OpeningTicketPurposeRef = function OpeningTicketPurposeRef() {
	    _classCallCheck(this, OpeningTicketPurposeRef);
	};
	
	OpeningTicketPurposeRef.expendChildrenCategories = function (reference, category) {
	    if (category) {
	        var childrenCategories = reference.categories.reduce(function (result, childCategory) {
	            if (childCategory.parent && childCategory.parent.uid == category.uid) {
	                result.push.apply(result, _toConsumableArray(OpeningTicketPurposeRef.expendChildrenCategories(reference, childCategory)));
	            }
	            return result;
	        }, []);
	
	        return [category].concat(_toConsumableArray(childrenCategories));
	    }
	    return [];
	};
	
	OpeningTicketPurposeRef.expendParentCategories = function (reference, category) {
	    if (category) {
	        var parentCategory = category.parent && reference.categories.find(function (c) {
	            return c.uid == category.parent.uid;
	        });
	        return [].concat(_toConsumableArray(OpeningTicketPurposeRef.expendParentCategories(reference, parentCategory)), [category]);
	    }
	    return [];
	};
	
	OpeningTicketPurposeRef.getLeafCategory = function (categoryPath) {
	    var leaf;
	
	    for (var i = 0; i < categoryPath.length; i++) {
	        var parentCategory = categoryPath[i - 1];
	        var category = categoryPath[i];
	
	        if ((category.parent && category.parent.uid) != (parentCategory && parentCategory.uid)) break;
	        leaf = category;
	    }
	    return leaf;
	};
	
	OpeningTicketPurposeRef.truncCategoryPath = function (categoryPath, rootCategory) {
	    if (!rootCategory && !(categoryPath[0] && categoryPath[0].parent)) {
	        return categoryPath;
	    }
	
	    if (!rootCategory && categoryPath[0] && categoryPath[0].parent) {
	        return [];
	    }
	
	    var index = categoryPath.findIndex(function (c) {
	        return c.uid == rootCategory.uid;
	    });
	    if (index < 0) {
	        return [];
	    } else {
	        return categoryPath.slice(index + 1);
	    }
	};
	
	OpeningTicketPurposeRef.isDefaultOpeningTicketPurpose = function (reference, openingTicketPurpose) {
	    return reference.default.openingTicketPurpose.uid == openingTicketPurpose.uid;
	};
	
	var CreateOpeningTicketPurposeAction = exports.CreateOpeningTicketPurposeAction = function CreateOpeningTicketPurposeAction() {
	    _classCallCheck(this, CreateOpeningTicketPurposeAction);
	};
	
	CreateOpeningTicketPurposeAction.schema = {
	    type: 'object',
	    properties: {
	        label: { type: 'string' },
	        extId: { type: ['string', 'null'] },
	        categoryUids: {
	            type: 'array',
	            minItems: 1,
	            items: { type: 'object' }
	        },
	        tagUids: {
	            type: 'array',
	            minItems: 1,
	            items: { type: 'object' }
	        }
	    },
	    required: ['label', 'categoryUids', 'tagUids']
	};
	
	var UpdateOpeningTicketPurposeAction = exports.UpdateOpeningTicketPurposeAction = function UpdateOpeningTicketPurposeAction() {
	    _classCallCheck(this, UpdateOpeningTicketPurposeAction);
	};
	
	UpdateOpeningTicketPurposeAction.schema = {
	    type: 'object',
	    properties: {
	        label: { type: 'string' },
	        extId: { type: ['string', 'null'] }
	    },
	    required: ['label']
	};
	
	var CreateUpdateTagAction = exports.CreateUpdateTagAction = function CreateUpdateTagAction() {
	    _classCallCheck(this, CreateUpdateTagAction);
	};
	
	CreateUpdateTagAction.schema = {
	    type: 'object',
	    properties: {
	        label: { type: 'string' },
	        iconId: { type: 'string' },
	        action: { type: 'string' }
	    },
	    required: ['label', 'iconId', 'action']
	};
	
	var CreateUpdateCategoryAction = exports.CreateUpdateCategoryAction = function CreateUpdateCategoryAction() {
	    _classCallCheck(this, CreateUpdateCategoryAction);
	};
	
	CreateUpdateCategoryAction.schema = {
	    type: 'object',
	    properties: {
	        label: { type: 'string' },
	        iconId: { type: 'string' },
	        action: { type: 'string' },
	        parentUid: { type: ['object', 'null'] }
	    },
	    required: ['label', 'iconId', 'action']
	};
	
	var AssociateActivityWithOpeningTicketPurposeAction = exports.AssociateActivityWithOpeningTicketPurposeAction = function AssociateActivityWithOpeningTicketPurposeAction() {
	    _classCallCheck(this, AssociateActivityWithOpeningTicketPurposeAction);
	};
	
	AssociateActivityWithOpeningTicketPurposeAction.schema = {
	    type: 'object',
	    properties: {
	        activityUid: { type: 'object' }
	    },
	    required: ['activityUid']
	};

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAMESPACE = 'Ticket';
	
	// export xlsx worker
	var START_XLSX_EXPORT = exports.START_XLSX_EXPORT = NAMESPACE + '/StartXlsxExport';
	var STOP_XLSX_EXPORT = exports.STOP_XLSX_EXPORT = NAMESPACE + '/StopXlsxExport';
	var XLSX_EXPORT_COMPLETED = exports.XLSX_EXPORT_COMPLETED = NAMESPACE + '/XlsxExportCompleted';
	var XLSX_EXPORT_PROGRESSED = exports.XLSX_EXPORT_PROGRESSED = NAMESPACE + '/XlsxExportProgressed';
	var XLSX_EXPORT_FAILED = exports.XLSX_EXPORT_FAILED = NAMESPACE + '/XlsxExportFailed';
	// export pdf worker
	var START_PDF_EXPORT = exports.START_PDF_EXPORT = NAMESPACE + '/StartPdfExport';
	var STOP_PDF_EXPORT = exports.STOP_PDF_EXPORT = NAMESPACE + '/StopPdfExport';
	var PDF_EXPORT_COMPLETED = exports.PDF_EXPORT_COMPLETED = NAMESPACE + '/PdfExportCompleted';
	var PDF_EXPORT_PROGRESSED = exports.PDF_EXPORT_PROGRESSED = NAMESPACE + '/PdfExportProgressed';
	var PDF_EXPORT_FAILED = exports.PDF_EXPORT_FAILED = NAMESPACE + '/PdfExportFailed';
	// report pdf worker
	var START_PDF_REPORT = exports.START_PDF_REPORT = NAMESPACE + '/StartPdfReport';
	var STOP_PDF_REPORT = exports.STOP_PDF_REPORT = NAMESPACE + '/StopPdfReport';
	var PDF_REPORT_COMPLETED = exports.PDF_REPORT_COMPLETED = NAMESPACE + '/PdfReportCompleted';
	var PDF_REPORT_PROGRESSED = exports.PDF_REPORT_PROGRESSED = NAMESPACE + '/PdfReportProgressed';
	var PDF_REPORT_FAILED = exports.PDF_REPORT_FAILED = NAMESPACE + '/PdfReportFailed';

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (root['Chartist'] = factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    root['Chartist'] = factory();
	  }
	}(this, function () {
	
	/* Chartist.js 0.9.8
	 * Copyright © 2016 Gion Kunz
	 * Free to use under either the WTFPL license or the MIT license.
	 * https://raw.githubusercontent.com/gionkunz/chartist-js/master/LICENSE-WTFPL
	 * https://raw.githubusercontent.com/gionkunz/chartist-js/master/LICENSE-MIT
	 */
	/**
	 * The core module of Chartist that is mainly providing static functions and higher level functions for chart modules.
	 *
	 * @module Chartist.Core
	 */
	var Chartist = {
	  version: '0.9.8'
	};
	
	(function (window, document, Chartist) {
	  'use strict';
	
	  /**
	   * This object contains all namespaces used within Chartist.
	   *
	   * @memberof Chartist.Core
	   * @type {{svg: string, xmlns: string, xhtml: string, xlink: string, ct: string}}
	   */
	  Chartist.namespaces = {
	    svg: 'http://www.w3.org/2000/svg',
	    xmlns: 'http://www.w3.org/2000/xmlns/',
	    xhtml: 'http://www.w3.org/1999/xhtml',
	    xlink: 'http://www.w3.org/1999/xlink',
	    ct: 'http://gionkunz.github.com/chartist-js/ct'
	  };
	
	  /**
	   * Helps to simplify functional style code
	   *
	   * @memberof Chartist.Core
	   * @param {*} n This exact value will be returned by the noop function
	   * @return {*} The same value that was provided to the n parameter
	   */
	  Chartist.noop = function (n) {
	    return n;
	  };
	
	  /**
	   * Generates a-z from a number 0 to 26
	   *
	   * @memberof Chartist.Core
	   * @param {Number} n A number from 0 to 26 that will result in a letter a-z
	   * @return {String} A character from a-z based on the input number n
	   */
	  Chartist.alphaNumerate = function (n) {
	    // Limit to a-z
	    return String.fromCharCode(97 + n % 26);
	  };
	
	  /**
	   * Simple recursive object extend
	   *
	   * @memberof Chartist.Core
	   * @param {Object} target Target object where the source will be merged into
	   * @param {Object...} sources This object (objects) will be merged into target and then target is returned
	   * @return {Object} An object that has the same reference as target but is extended and merged with the properties of source
	   */
	  Chartist.extend = function (target) {
	    target = target || {};
	
	    var sources = Array.prototype.slice.call(arguments, 1);
	    sources.forEach(function(source) {
	      for (var prop in source) {
	        if (typeof source[prop] === 'object' && source[prop] !== null && !(source[prop] instanceof Array)) {
	          target[prop] = Chartist.extend({}, target[prop], source[prop]);
	        } else {
	          target[prop] = source[prop];
	        }
	      }
	    });
	
	    return target;
	  };
	
	  /**
	   * Replaces all occurrences of subStr in str with newSubStr and returns a new string.
	   *
	   * @memberof Chartist.Core
	   * @param {String} str
	   * @param {String} subStr
	   * @param {String} newSubStr
	   * @return {String}
	   */
	  Chartist.replaceAll = function(str, subStr, newSubStr) {
	    return str.replace(new RegExp(subStr, 'g'), newSubStr);
	  };
	
	  /**
	   * Converts a number to a string with a unit. If a string is passed then this will be returned unmodified.
	   *
	   * @memberof Chartist.Core
	   * @param {Number} value
	   * @param {String} unit
	   * @return {String} Returns the passed number value with unit.
	   */
	  Chartist.ensureUnit = function(value, unit) {
	    if(typeof value === 'number') {
	      value = value + unit;
	    }
	
	    return value;
	  };
	
	  /**
	   * Converts a number or string to a quantity object.
	   *
	   * @memberof Chartist.Core
	   * @param {String|Number} input
	   * @return {Object} Returns an object containing the value as number and the unit as string.
	   */
	  Chartist.quantity = function(input) {
	    if (typeof input === 'string') {
	      var match = (/^(\d+)\s*(.*)$/g).exec(input);
	      return {
	        value : +match[1],
	        unit: match[2] || undefined
	      };
	    }
	    return { value: input };
	  };
	
	  /**
	   * This is a wrapper around document.querySelector that will return the query if it's already of type Node
	   *
	   * @memberof Chartist.Core
	   * @param {String|Node} query The query to use for selecting a Node or a DOM node that will be returned directly
	   * @return {Node}
	   */
	  Chartist.querySelector = function(query) {
	    return query instanceof Node ? query : document.querySelector(query);
	  };
	
	  /**
	   * Functional style helper to produce array with given length initialized with undefined values
	   *
	   * @memberof Chartist.Core
	   * @param length
	   * @return {Array}
	   */
	  Chartist.times = function(length) {
	    return Array.apply(null, new Array(length));
	  };
	
	  /**
	   * Sum helper to be used in reduce functions
	   *
	   * @memberof Chartist.Core
	   * @param previous
	   * @param current
	   * @return {*}
	   */
	  Chartist.sum = function(previous, current) {
	    return previous + (current ? current : 0);
	  };
	
	  /**
	   * Multiply helper to be used in `Array.map` for multiplying each value of an array with a factor.
	   *
	   * @memberof Chartist.Core
	   * @param {Number} factor
	   * @returns {Function} Function that can be used in `Array.map` to multiply each value in an array
	   */
	  Chartist.mapMultiply = function(factor) {
	    return function(num) {
	      return num * factor;
	    };
	  };
	
	  /**
	   * Add helper to be used in `Array.map` for adding a addend to each value of an array.
	   *
	   * @memberof Chartist.Core
	   * @param {Number} addend
	   * @returns {Function} Function that can be used in `Array.map` to add a addend to each value in an array
	   */
	  Chartist.mapAdd = function(addend) {
	    return function(num) {
	      return num + addend;
	    };
	  };
	
	  /**
	   * Map for multi dimensional arrays where their nested arrays will be mapped in serial. The output array will have the length of the largest nested array. The callback function is called with variable arguments where each argument is the nested array value (or undefined if there are no more values).
	   *
	   * @memberof Chartist.Core
	   * @param arr
	   * @param cb
	   * @return {Array}
	   */
	  Chartist.serialMap = function(arr, cb) {
	    var result = [],
	        length = Math.max.apply(null, arr.map(function(e) {
	          return e.length;
	        }));
	
	    Chartist.times(length).forEach(function(e, index) {
	      var args = arr.map(function(e) {
	        return e[index];
	      });
	
	      result[index] = cb.apply(null, args);
	    });
	
	    return result;
	  };
	
	  /**
	   * This helper function can be used to round values with certain precision level after decimal. This is used to prevent rounding errors near float point precision limit.
	   *
	   * @memberof Chartist.Core
	   * @param {Number} value The value that should be rounded with precision
	   * @param {Number} [digits] The number of digits after decimal used to do the rounding
	   * @returns {number} Rounded value
	   */
	  Chartist.roundWithPrecision = function(value, digits) {
	    var precision = Math.pow(10, digits || Chartist.precision);
	    return Math.round(value * precision) / precision;
	  };
	
	  /**
	   * Precision level used internally in Chartist for rounding. If you require more decimal places you can increase this number.
	   *
	   * @memberof Chartist.Core
	   * @type {number}
	   */
	  Chartist.precision = 8;
	
	  /**
	   * A map with characters to escape for strings to be safely used as attribute values.
	   *
	   * @memberof Chartist.Core
	   * @type {Object}
	   */
	  Chartist.escapingMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    '\'': '&#039;'
	  };
	
	  /**
	   * This function serializes arbitrary data to a string. In case of data that can't be easily converted to a string, this function will create a wrapper object and serialize the data using JSON.stringify. The outcoming string will always be escaped using Chartist.escapingMap.
	   * If called with null or undefined the function will return immediately with null or undefined.
	   *
	   * @memberof Chartist.Core
	   * @param {Number|String|Object} data
	   * @return {String}
	   */
	  Chartist.serialize = function(data) {
	    if(data === null || data === undefined) {
	      return data;
	    } else if(typeof data === 'number') {
	      data = ''+data;
	    } else if(typeof data === 'object') {
	      data = JSON.stringify({data: data});
	    }
	
	    return Object.keys(Chartist.escapingMap).reduce(function(result, key) {
	      return Chartist.replaceAll(result, key, Chartist.escapingMap[key]);
	    }, data);
	  };
	
	  /**
	   * This function de-serializes a string previously serialized with Chartist.serialize. The string will always be unescaped using Chartist.escapingMap before it's returned. Based on the input value the return type can be Number, String or Object. JSON.parse is used with try / catch to see if the unescaped string can be parsed into an Object and this Object will be returned on success.
	   *
	   * @memberof Chartist.Core
	   * @param {String} data
	   * @return {String|Number|Object}
	   */
	  Chartist.deserialize = function(data) {
	    if(typeof data !== 'string') {
	      return data;
	    }
	
	    data = Object.keys(Chartist.escapingMap).reduce(function(result, key) {
	      return Chartist.replaceAll(result, Chartist.escapingMap[key], key);
	    }, data);
	
	    try {
	      data = JSON.parse(data);
	      data = data.data !== undefined ? data.data : data;
	    } catch(e) {}
	
	    return data;
	  };
	
	  /**
	   * Create or reinitialize the SVG element for the chart
	   *
	   * @memberof Chartist.Core
	   * @param {Node} container The containing DOM Node object that will be used to plant the SVG element
	   * @param {String} width Set the width of the SVG element. Default is 100%
	   * @param {String} height Set the height of the SVG element. Default is 100%
	   * @param {String} className Specify a class to be added to the SVG element
	   * @return {Object} The created/reinitialized SVG element
	   */
	  Chartist.createSvg = function (container, width, height, className) {
	    var svg;
	
	    width = width || '100%';
	    height = height || '100%';
	
	    // Check if there is a previous SVG element in the container that contains the Chartist XML namespace and remove it
	    // Since the DOM API does not support namespaces we need to manually search the returned list http://www.w3.org/TR/selectors-api/
	    Array.prototype.slice.call(container.querySelectorAll('svg')).filter(function filterChartistSvgObjects(svg) {
	      return svg.getAttributeNS(Chartist.namespaces.xmlns, 'ct');
	    }).forEach(function removePreviousElement(svg) {
	      container.removeChild(svg);
	    });
	
	    // Create svg object with width and height or use 100% as default
	    svg = new Chartist.Svg('svg').attr({
	      width: width,
	      height: height
	    }).addClass(className).attr({
	      style: 'width: ' + width + '; height: ' + height + ';'
	    });
	
	    // Add the DOM node to our container
	    container.appendChild(svg._node);
	
	    return svg;
	  };
	
	  /**
	   * Ensures that the data object passed as second argument to the charts is present and correctly initialized.
	   *
	   * @param  {Object} data The data object that is passed as second argument to the charts
	   * @return {Object} The normalized data object
	   */
	  Chartist.normalizeData = function(data) {
	    // Ensure data is present otherwise enforce
	    data = data || {series: [], labels: []};
	    data.series = data.series || [];
	    data.labels = data.labels || [];
	
	    // Check if we should generate some labels based on existing series data
	    if (data.series.length > 0 && data.labels.length === 0) {
	      var normalized = Chartist.getDataArray(data),
	          labelCount;
	
	      // If all elements of the normalized data array are arrays we're dealing with
	      // data from Bar or Line charts and we need to find the largest series if they are un-even
	      if (normalized.every(function(value) {
	        return value instanceof Array;
	      })) {
	        // Getting the series with the the most elements
	        labelCount = Math.max.apply(null, normalized.map(function(series) {
	          return series.length;
	        }));
	      } else {
	        // We're dealing with Pie data so we just take the normalized array length
	        labelCount = normalized.length;
	      }
	
	      // Setting labels to an array with emptry strings using our labelCount estimated above
	      data.labels = Chartist.times(labelCount).map(function() {
	        return '';
	      });
	    }
	    return data;
	  };
	
	  /**
	   * Reverses the series, labels and series data arrays.
	   *
	   * @memberof Chartist.Core
	   * @param data
	   */
	  Chartist.reverseData = function(data) {
	    data.labels.reverse();
	    data.series.reverse();
	    for (var i = 0; i < data.series.length; i++) {
	      if(typeof(data.series[i]) === 'object' && data.series[i].data !== undefined) {
	        data.series[i].data.reverse();
	      } else if(data.series[i] instanceof Array) {
	        data.series[i].reverse();
	      }
	    }
	  };
	
	  /**
	   * Convert data series into plain array
	   *
	   * @memberof Chartist.Core
	   * @param {Object} data The series object that contains the data to be visualized in the chart
	   * @param {Boolean} reverse If true the whole data is reversed by the getDataArray call. This will modify the data object passed as first parameter. The labels as well as the series order is reversed. The whole series data arrays are reversed too.
	   * @param {Boolean} multi Create a multi dimensional array from a series data array where a value object with `x` and `y` values will be created.
	   * @return {Array} A plain array that contains the data to be visualized in the chart
	   */
	  Chartist.getDataArray = function (data, reverse, multi) {
	    // If the data should be reversed but isn't we need to reverse it
	    // If it's reversed but it shouldn't we need to reverse it back
	    // That's required to handle data updates correctly and to reflect the responsive configurations
	    if(reverse && !data.reversed || !reverse && data.reversed) {
	      Chartist.reverseData(data);
	      data.reversed = !data.reversed;
	    }
	
	    // Recursively walks through nested arrays and convert string values to numbers and objects with value properties
	    // to values. Check the tests in data core -> data normalization for a detailed specification of expected values
	    function recursiveConvert(value) {
	      if(Chartist.isFalseyButZero(value)) {
	        // This is a hole in data and we should return undefined
	        return undefined;
	      } else if((value.data || value) instanceof Array) {
	        return (value.data || value).map(recursiveConvert);
	      } else if(value.hasOwnProperty('value')) {
	        return recursiveConvert(value.value);
	      } else {
	        if(multi) {
	          var multiValue = {};
	
	          // Single series value arrays are assumed to specify the Y-Axis value
	          // For example: [1, 2] => [{x: undefined, y: 1}, {x: undefined, y: 2}]
	          // If multi is a string then it's assumed that it specified which dimension should be filled as default
	          if(typeof multi === 'string') {
	            multiValue[multi] = Chartist.getNumberOrUndefined(value);
	          } else {
	            multiValue.y = Chartist.getNumberOrUndefined(value);
	          }
	
	          multiValue.x = value.hasOwnProperty('x') ? Chartist.getNumberOrUndefined(value.x) : multiValue.x;
	          multiValue.y = value.hasOwnProperty('y') ? Chartist.getNumberOrUndefined(value.y) : multiValue.y;
	
	          return multiValue;
	
	        } else {
	          return Chartist.getNumberOrUndefined(value);
	        }
	      }
	    }
	
	    return data.series.map(recursiveConvert);
	  };
	
	  /**
	   * Converts a number into a padding object.
	   *
	   * @memberof Chartist.Core
	   * @param {Object|Number} padding
	   * @param {Number} [fallback] This value is used to fill missing values if a incomplete padding object was passed
	   * @returns {Object} Returns a padding object containing top, right, bottom, left properties filled with the padding number passed in as argument. If the argument is something else than a number (presumably already a correct padding object) then this argument is directly returned.
	   */
	  Chartist.normalizePadding = function(padding, fallback) {
	    fallback = fallback || 0;
	
	    return typeof padding === 'number' ? {
	      top: padding,
	      right: padding,
	      bottom: padding,
	      left: padding
	    } : {
	      top: typeof padding.top === 'number' ? padding.top : fallback,
	      right: typeof padding.right === 'number' ? padding.right : fallback,
	      bottom: typeof padding.bottom === 'number' ? padding.bottom : fallback,
	      left: typeof padding.left === 'number' ? padding.left : fallback
	    };
	  };
	
	  Chartist.getMetaData = function(series, index) {
	    var value = series.data ? series.data[index] : series[index];
	    return value ? Chartist.serialize(value.meta) : undefined;
	  };
	
	  /**
	   * Calculate the order of magnitude for the chart scale
	   *
	   * @memberof Chartist.Core
	   * @param {Number} value The value Range of the chart
	   * @return {Number} The order of magnitude
	   */
	  Chartist.orderOfMagnitude = function (value) {
	    return Math.floor(Math.log(Math.abs(value)) / Math.LN10);
	  };
	
	  /**
	   * Project a data length into screen coordinates (pixels)
	   *
	   * @memberof Chartist.Core
	   * @param {Object} axisLength The svg element for the chart
	   * @param {Number} length Single data value from a series array
	   * @param {Object} bounds All the values to set the bounds of the chart
	   * @return {Number} The projected data length in pixels
	   */
	  Chartist.projectLength = function (axisLength, length, bounds) {
	    return length / bounds.range * axisLength;
	  };
	
	  /**
	   * Get the height of the area in the chart for the data series
	   *
	   * @memberof Chartist.Core
	   * @param {Object} svg The svg element for the chart
	   * @param {Object} options The Object that contains all the optional values for the chart
	   * @return {Number} The height of the area in the chart for the data series
	   */
	  Chartist.getAvailableHeight = function (svg, options) {
	    return Math.max((Chartist.quantity(options.height).value || svg.height()) - (options.chartPadding.top +  options.chartPadding.bottom) - options.axisX.offset, 0);
	  };
	
	  /**
	   * Get highest and lowest value of data array. This Array contains the data that will be visualized in the chart.
	   *
	   * @memberof Chartist.Core
	   * @param {Array} data The array that contains the data to be visualized in the chart
	   * @param {Object} options The Object that contains the chart options
	   * @param {String} dimension Axis dimension 'x' or 'y' used to access the correct value and high / low configuration
	   * @return {Object} An object that contains the highest and lowest value that will be visualized on the chart.
	   */
	  Chartist.getHighLow = function (data, options, dimension) {
	    // TODO: Remove workaround for deprecated global high / low config. Axis high / low configuration is preferred
	    options = Chartist.extend({}, options, dimension ? options['axis' + dimension.toUpperCase()] : {});
	
	    var highLow = {
	        high: options.high === undefined ? -Number.MAX_VALUE : +options.high,
	        low: options.low === undefined ? Number.MAX_VALUE : +options.low
	      };
	    var findHigh = options.high === undefined;
	    var findLow = options.low === undefined;
	
	    // Function to recursively walk through arrays and find highest and lowest number
	    function recursiveHighLow(data) {
	      if(data === undefined) {
	        return undefined;
	      } else if(data instanceof Array) {
	        for (var i = 0; i < data.length; i++) {
	          recursiveHighLow(data[i]);
	        }
	      } else {
	        var value = dimension ? +data[dimension] : +data;
	
	        if (findHigh && value > highLow.high) {
	          highLow.high = value;
	        }
	
	        if (findLow && value < highLow.low) {
	          highLow.low = value;
	        }
	      }
	    }
	
	    // Start to find highest and lowest number recursively
	    if(findHigh || findLow) {
	      recursiveHighLow(data);
	    }
	
	    // Overrides of high / low based on reference value, it will make sure that the invisible reference value is
	    // used to generate the chart. This is useful when the chart always needs to contain the position of the
	    // invisible reference value in the view i.e. for bipolar scales.
	    if (options.referenceValue || options.referenceValue === 0) {
	      highLow.high = Math.max(options.referenceValue, highLow.high);
	      highLow.low = Math.min(options.referenceValue, highLow.low);
	    }
	
	    // If high and low are the same because of misconfiguration or flat data (only the same value) we need
	    // to set the high or low to 0 depending on the polarity
	    if (highLow.high <= highLow.low) {
	      // If both values are 0 we set high to 1
	      if (highLow.low === 0) {
	        highLow.high = 1;
	      } else if (highLow.low < 0) {
	        // If we have the same negative value for the bounds we set bounds.high to 0
	        highLow.high = 0;
	      } else if (highLow.high > 0) {
	        // If we have the same positive value for the bounds we set bounds.low to 0
	        highLow.low = 0;
	      } else {
	        // If data array was empty, values are Number.MAX_VALUE and -Number.MAX_VALUE. Set bounds to prevent errors
	        highLow.high = 1;
	        highLow.low = 0;
	      }
	    }
	
	    return highLow;
	  };
	
	  /**
	   * Checks if the value is a valid number or string with a number.
	   *
	   * @memberof Chartist.Core
	   * @param value
	   * @returns {Boolean}
	   */
	  Chartist.isNum = function(value) {
	    return !isNaN(value) && isFinite(value);
	  };
	
	  /**
	   * Returns true on all falsey values except the numeric value 0.
	   *
	   * @memberof Chartist.Core
	   * @param value
	   * @returns {boolean}
	   */
	  Chartist.isFalseyButZero = function(value) {
	    return !value && value !== 0;
	  };
	
	  /**
	   * Returns a number if the passed parameter is a valid number or the function will return undefined. On all other values than a valid number, this function will return undefined.
	   *
	   * @memberof Chartist.Core
	   * @param value
	   * @returns {*}
	   */
	  Chartist.getNumberOrUndefined = function(value) {
	    return isNaN(+value) ? undefined : +value;
	  };
	
	  /**
	   * Gets a value from a dimension `value.x` or `value.y` while returning value directly if it's a valid numeric value. If the value is not numeric and it's falsey this function will return undefined.
	   *
	   * @param value
	   * @param dimension
	   * @returns {*}
	   */
	  Chartist.getMultiValue = function(value, dimension) {
	    if(Chartist.isNum(value)) {
	      return +value;
	    } else if(value) {
	      return value[dimension || 'y'] || 0;
	    } else {
	      return 0;
	    }
	  };
	
	  /**
	   * Pollard Rho Algorithm to find smallest factor of an integer value. There are more efficient algorithms for factorization, but this one is quite efficient and not so complex.
	   *
	   * @memberof Chartist.Core
	   * @param {Number} num An integer number where the smallest factor should be searched for
	   * @returns {Number} The smallest integer factor of the parameter num.
	   */
	  Chartist.rho = function(num) {
	    if(num === 1) {
	      return num;
	    }
	
	    function gcd(p, q) {
	      if (p % q === 0) {
	        return q;
	      } else {
	        return gcd(q, p % q);
	      }
	    }
	
	    function f(x) {
	      return x * x + 1;
	    }
	
	    var x1 = 2, x2 = 2, divisor;
	    if (num % 2 === 0) {
	      return 2;
	    }
	
	    do {
	      x1 = f(x1) % num;
	      x2 = f(f(x2)) % num;
	      divisor = gcd(Math.abs(x1 - x2), num);
	    } while (divisor === 1);
	
	    return divisor;
	  };
	
	  /**
	   * Calculate and retrieve all the bounds for the chart and return them in one array
	   *
	   * @memberof Chartist.Core
	   * @param {Number} axisLength The length of the Axis used for
	   * @param {Object} highLow An object containing a high and low property indicating the value range of the chart.
	   * @param {Number} scaleMinSpace The minimum projected length a step should result in
	   * @param {Boolean} onlyInteger
	   * @return {Object} All the values to set the bounds of the chart
	   */
	  Chartist.getBounds = function (axisLength, highLow, scaleMinSpace, onlyInteger) {
	    var i,
	      optimizationCounter = 0,
	      newMin,
	      newMax,
	      bounds = {
	        high: highLow.high,
	        low: highLow.low
	      };
	
	    bounds.valueRange = bounds.high - bounds.low;
	    bounds.oom = Chartist.orderOfMagnitude(bounds.valueRange);
	    bounds.step = Math.pow(10, bounds.oom);
	    bounds.min = Math.floor(bounds.low / bounds.step) * bounds.step;
	    bounds.max = Math.ceil(bounds.high / bounds.step) * bounds.step;
	    bounds.range = bounds.max - bounds.min;
	    bounds.numberOfSteps = Math.round(bounds.range / bounds.step);
	
	    // Optimize scale step by checking if subdivision is possible based on horizontalGridMinSpace
	    // If we are already below the scaleMinSpace value we will scale up
	    var length = Chartist.projectLength(axisLength, bounds.step, bounds);
	    var scaleUp = length < scaleMinSpace;
	    var smallestFactor = onlyInteger ? Chartist.rho(bounds.range) : 0;
	
	    // First check if we should only use integer steps and if step 1 is still larger than scaleMinSpace so we can use 1
	    if(onlyInteger && Chartist.projectLength(axisLength, 1, bounds) >= scaleMinSpace) {
	      bounds.step = 1;
	    } else if(onlyInteger && smallestFactor < bounds.step && Chartist.projectLength(axisLength, smallestFactor, bounds) >= scaleMinSpace) {
	      // If step 1 was too small, we can try the smallest factor of range
	      // If the smallest factor is smaller than the current bounds.step and the projected length of smallest factor
	      // is larger than the scaleMinSpace we should go for it.
	      bounds.step = smallestFactor;
	    } else {
	      // Trying to divide or multiply by 2 and find the best step value
	      while (true) {
	        if (scaleUp && Chartist.projectLength(axisLength, bounds.step, bounds) <= scaleMinSpace) {
	          bounds.step *= 2;
	        } else if (!scaleUp && Chartist.projectLength(axisLength, bounds.step / 2, bounds) >= scaleMinSpace) {
	          bounds.step /= 2;
	          if(onlyInteger && bounds.step % 1 !== 0) {
	            bounds.step *= 2;
	            break;
	          }
	        } else {
	          break;
	        }
	
	        if(optimizationCounter++ > 1000) {
	          throw new Error('Exceeded maximum number of iterations while optimizing scale step!');
	        }
	      }
	    }
	
	    // step must not be less than EPSILON to create values that can be represented as floating number.
	    var EPSILON = 2.221E-16;
	    bounds.step = Math.max(bounds.step, EPSILON);
	
	    // Narrow min and max based on new step
	    newMin = bounds.min;
	    newMax = bounds.max;
	    while(newMin + bounds.step <= bounds.low) {
	      newMin += bounds.step;
	    }
	    while(newMax - bounds.step >= bounds.high) {
	      newMax -= bounds.step;
	    }
	    bounds.min = newMin;
	    bounds.max = newMax;
	    bounds.range = bounds.max - bounds.min;
	
	    var values = [];
	    for (i = bounds.min; i <= bounds.max; i += bounds.step) {
	      var value = Chartist.roundWithPrecision(i);
	      if (value !== values[values.length - 1]) {
	        values.push(i);
	      }
	    }
	    bounds.values = values;
	    return bounds;
	  };
	
	  /**
	   * Calculate cartesian coordinates of polar coordinates
	   *
	   * @memberof Chartist.Core
	   * @param {Number} centerX X-axis coordinates of center point of circle segment
	   * @param {Number} centerY X-axis coordinates of center point of circle segment
	   * @param {Number} radius Radius of circle segment
	   * @param {Number} angleInDegrees Angle of circle segment in degrees
	   * @return {{x:Number, y:Number}} Coordinates of point on circumference
	   */
	  Chartist.polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
	    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
	
	    return {
	      x: centerX + (radius * Math.cos(angleInRadians)),
	      y: centerY + (radius * Math.sin(angleInRadians))
	    };
	  };
	
	  /**
	   * Initialize chart drawing rectangle (area where chart is drawn) x1,y1 = bottom left / x2,y2 = top right
	   *
	   * @memberof Chartist.Core
	   * @param {Object} svg The svg element for the chart
	   * @param {Object} options The Object that contains all the optional values for the chart
	   * @param {Number} [fallbackPadding] The fallback padding if partial padding objects are used
	   * @return {Object} The chart rectangles coordinates inside the svg element plus the rectangles measurements
	   */
	  Chartist.createChartRect = function (svg, options, fallbackPadding) {
	    var hasAxis = !!(options.axisX || options.axisY);
	    var yAxisOffset = hasAxis ? options.axisY.offset : 0;
	    var xAxisOffset = hasAxis ? options.axisX.offset : 0;
	    // If width or height results in invalid value (including 0) we fallback to the unitless settings or even 0
	    var width = svg.width() || Chartist.quantity(options.width).value || 0;
	    var height = svg.height() || Chartist.quantity(options.height).value || 0;
	    var normalizedPadding = Chartist.normalizePadding(options.chartPadding, fallbackPadding);
	
	    // If settings were to small to cope with offset (legacy) and padding, we'll adjust
	    width = Math.max(width, yAxisOffset + normalizedPadding.left + normalizedPadding.right);
	    height = Math.max(height, xAxisOffset + normalizedPadding.top + normalizedPadding.bottom);
	
	    var chartRect = {
	      padding: normalizedPadding,
	      width: function () {
	        return this.x2 - this.x1;
	      },
	      height: function () {
	        return this.y1 - this.y2;
	      }
	    };
	
	    if(hasAxis) {
	      if (options.axisX.position === 'start') {
	        chartRect.y2 = normalizedPadding.top + xAxisOffset;
	        chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
	      } else {
	        chartRect.y2 = normalizedPadding.top;
	        chartRect.y1 = Math.max(height - normalizedPadding.bottom - xAxisOffset, chartRect.y2 + 1);
	      }
	
	      if (options.axisY.position === 'start') {
	        chartRect.x1 = normalizedPadding.left + yAxisOffset;
	        chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
	      } else {
	        chartRect.x1 = normalizedPadding.left;
	        chartRect.x2 = Math.max(width - normalizedPadding.right - yAxisOffset, chartRect.x1 + 1);
	      }
	    } else {
	      chartRect.x1 = normalizedPadding.left;
	      chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
	      chartRect.y2 = normalizedPadding.top;
	      chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
	    }
	
	    return chartRect;
	  };
	
	  /**
	   * Creates a grid line based on a projected value.
	   *
	   * @memberof Chartist.Core
	   * @param position
	   * @param index
	   * @param axis
	   * @param offset
	   * @param length
	   * @param group
	   * @param classes
	   * @param eventEmitter
	   */
	  Chartist.createGrid = function(position, index, axis, offset, length, group, classes, eventEmitter) {
	    var positionalData = {};
	    positionalData[axis.units.pos + '1'] = position;
	    positionalData[axis.units.pos + '2'] = position;
	    positionalData[axis.counterUnits.pos + '1'] = offset;
	    positionalData[axis.counterUnits.pos + '2'] = offset + length;
	
	    var gridElement = group.elem('line', positionalData, classes.join(' '));
	
	    // Event for grid draw
	    eventEmitter.emit('draw',
	      Chartist.extend({
	        type: 'grid',
	        axis: axis,
	        index: index,
	        group: group,
	        element: gridElement
	      }, positionalData)
	    );
	  };
	
	  /**
	   * Creates a label based on a projected value and an axis.
	   *
	   * @memberof Chartist.Core
	   * @param position
	   * @param length
	   * @param index
	   * @param labels
	   * @param axis
	   * @param axisOffset
	   * @param labelOffset
	   * @param group
	   * @param classes
	   * @param useForeignObject
	   * @param eventEmitter
	   */
	  Chartist.createLabel = function(position, length, index, labels, axis, axisOffset, labelOffset, group, classes, useForeignObject, eventEmitter) {
	    var labelElement;
	    var positionalData = {};
	
	    positionalData[axis.units.pos] = position + labelOffset[axis.units.pos];
	    positionalData[axis.counterUnits.pos] = labelOffset[axis.counterUnits.pos];
	    positionalData[axis.units.len] = length;
	    positionalData[axis.counterUnits.len] = Math.max(0, axisOffset - 10);
	
	    if(useForeignObject) {
	      // We need to set width and height explicitly to px as span will not expand with width and height being
	      // 100% in all browsers
	      var content = '<span class="' + classes.join(' ') + '" style="' +
	        axis.units.len + ': ' + Math.round(positionalData[axis.units.len]) + 'px; ' +
	        axis.counterUnits.len + ': ' + Math.round(positionalData[axis.counterUnits.len]) + 'px">' +
	        labels[index] + '</span>';
	
	      labelElement = group.foreignObject(content, Chartist.extend({
	        style: 'overflow: visible;'
	      }, positionalData));
	    } else {
	      labelElement = group.elem('text', positionalData, classes.join(' ')).text(labels[index]);
	    }
	
	    eventEmitter.emit('draw', Chartist.extend({
	      type: 'label',
	      axis: axis,
	      index: index,
	      group: group,
	      element: labelElement,
	      text: labels[index]
	    }, positionalData));
	  };
	
	  /**
	   * Helper to read series specific options from options object. It automatically falls back to the global option if
	   * there is no option in the series options.
	   *
	   * @param {Object} series Series object
	   * @param {Object} options Chartist options object
	   * @param {string} key The options key that should be used to obtain the options
	   * @returns {*}
	   */
	  Chartist.getSeriesOption = function(series, options, key) {
	    if(series.name && options.series && options.series[series.name]) {
	      var seriesOptions = options.series[series.name];
	      return seriesOptions.hasOwnProperty(key) ? seriesOptions[key] : options[key];
	    } else {
	      return options[key];
	    }
	  };
	
	  /**
	   * Provides options handling functionality with callback for options changes triggered by responsive options and media query matches
	   *
	   * @memberof Chartist.Core
	   * @param {Object} options Options set by user
	   * @param {Array} responsiveOptions Optional functions to add responsive behavior to chart
	   * @param {Object} eventEmitter The event emitter that will be used to emit the options changed events
	   * @return {Object} The consolidated options object from the defaults, base and matching responsive options
	   */
	  Chartist.optionsProvider = function (options, responsiveOptions, eventEmitter) {
	    var baseOptions = Chartist.extend({}, options),
	      currentOptions,
	      mediaQueryListeners = [],
	      i;
	
	    function updateCurrentOptions(mediaEvent) {
	      var previousOptions = currentOptions;
	      currentOptions = Chartist.extend({}, baseOptions);
	
	      if (responsiveOptions) {
	        for (i = 0; i < responsiveOptions.length; i++) {
	          var mql = window.matchMedia(responsiveOptions[i][0]);
	          if (mql.matches) {
	            currentOptions = Chartist.extend(currentOptions, responsiveOptions[i][1]);
	          }
	        }
	      }
	
	      if(eventEmitter && mediaEvent) {
	        eventEmitter.emit('optionsChanged', {
	          previousOptions: previousOptions,
	          currentOptions: currentOptions
	        });
	      }
	    }
	
	    function removeMediaQueryListeners() {
	      mediaQueryListeners.forEach(function(mql) {
	        mql.removeListener(updateCurrentOptions);
	      });
	    }
	
	    if (!window.matchMedia) {
	      throw 'window.matchMedia not found! Make sure you\'re using a polyfill.';
	    } else if (responsiveOptions) {
	
	      for (i = 0; i < responsiveOptions.length; i++) {
	        var mql = window.matchMedia(responsiveOptions[i][0]);
	        mql.addListener(updateCurrentOptions);
	        mediaQueryListeners.push(mql);
	      }
	    }
	    // Execute initially without an event argument so we get the correct options
	    updateCurrentOptions();
	
	    return {
	      removeMediaQueryListeners: removeMediaQueryListeners,
	      getCurrentOptions: function getCurrentOptions() {
	        return Chartist.extend({}, currentOptions);
	      }
	    };
	  };
	
	
	  /**
	   * Splits a list of coordinates and associated values into segments. Each returned segment contains a pathCoordinates
	   * valueData property describing the segment.
	   *
	   * With the default options, segments consist of contiguous sets of points that do not have an undefined value. Any
	   * points with undefined values are discarded.
	   *
	   * **Options**
	   * The following options are used to determine how segments are formed
	   * ```javascript
	   * var options = {
	   *   // If fillHoles is true, undefined values are simply discarded without creating a new segment. Assuming other options are default, this returns single segment.
	   *   fillHoles: false,
	   *   // If increasingX is true, the coordinates in all segments have strictly increasing x-values.
	   *   increasingX: false
	   * };
	   * ```
	   *
	   * @memberof Chartist.Core
	   * @param {Array} pathCoordinates List of point coordinates to be split in the form [x1, y1, x2, y2 ... xn, yn]
	   * @param {Array} values List of associated point values in the form [v1, v2 .. vn]
	   * @param {Object} options Options set by user
	   * @return {Array} List of segments, each containing a pathCoordinates and valueData property.
	   */
	  Chartist.splitIntoSegments = function(pathCoordinates, valueData, options) {
	    var defaultOptions = {
	      increasingX: false,
	      fillHoles: false
	    };
	
	    options = Chartist.extend({}, defaultOptions, options);
	
	    var segments = [];
	    var hole = true;
	
	    for(var i = 0; i < pathCoordinates.length; i += 2) {
	      // If this value is a "hole" we set the hole flag
	      if(valueData[i / 2].value === undefined) {
	        if(!options.fillHoles) {
	          hole = true;
	        }
	      } else {
	        if(options.increasingX && i >= 2 && pathCoordinates[i] <= pathCoordinates[i-2]) {
	          // X is not increasing, so we need to make sure we start a new segment
	          hole = true;
	        }
	
	
	        // If it's a valid value we need to check if we're coming out of a hole and create a new empty segment
	        if(hole) {
	          segments.push({
	            pathCoordinates: [],
	            valueData: []
	          });
	          // As we have a valid value now, we are not in a "hole" anymore
	          hole = false;
	        }
	
	        // Add to the segment pathCoordinates and valueData
	        segments[segments.length - 1].pathCoordinates.push(pathCoordinates[i], pathCoordinates[i + 1]);
	        segments[segments.length - 1].valueData.push(valueData[i / 2]);
	      }
	    }
	
	    return segments;
	  };
	}(window, document, Chartist));
	;/**
	 * Chartist path interpolation functions.
	 *
	 * @module Chartist.Interpolation
	 */
	/* global Chartist */
	(function(window, document, Chartist) {
	  'use strict';
	
	  Chartist.Interpolation = {};
	
	  /**
	   * This interpolation function does not smooth the path and the result is only containing lines and no curves.
	   *
	   * @example
	   * var chart = new Chartist.Line('.ct-chart', {
	   *   labels: [1, 2, 3, 4, 5],
	   *   series: [[1, 2, 8, 1, 7]]
	   * }, {
	   *   lineSmooth: Chartist.Interpolation.none({
	   *     fillHoles: false
	   *   })
	   * });
	   *
	   *
	   * @memberof Chartist.Interpolation
	   * @return {Function}
	   */
	  Chartist.Interpolation.none = function(options) {
	    var defaultOptions = {
	      fillHoles: false
	    };
	    options = Chartist.extend({}, defaultOptions, options);
	    return function none(pathCoordinates, valueData) {
	      var path = new Chartist.Svg.Path();
	      var hole = true;
	
	      for(var i = 0; i < pathCoordinates.length; i += 2) {
	        var currX = pathCoordinates[i];
	        var currY = pathCoordinates[i + 1];
	        var currData = valueData[i / 2];
	
	        if(currData.value !== undefined) {
	
	          if(hole) {
	            path.move(currX, currY, false, currData);
	          } else {
	            path.line(currX, currY, false, currData);
	          }
	
	          hole = false;
	        } else if(!options.fillHoles) {
	          hole = true;
	        }
	      }
	
	      return path;
	    };
	  };
	
	  /**
	   * Simple smoothing creates horizontal handles that are positioned with a fraction of the length between two data points. You can use the divisor option to specify the amount of smoothing.
	   *
	   * Simple smoothing can be used instead of `Chartist.Smoothing.cardinal` if you'd like to get rid of the artifacts it produces sometimes. Simple smoothing produces less flowing lines but is accurate by hitting the points and it also doesn't swing below or above the given data point.
	   *
	   * All smoothing functions within Chartist are factory functions that accept an options parameter. The simple interpolation function accepts one configuration parameter `divisor`, between 1 and ∞, which controls the smoothing characteristics.
	   *
	   * @example
	   * var chart = new Chartist.Line('.ct-chart', {
	   *   labels: [1, 2, 3, 4, 5],
	   *   series: [[1, 2, 8, 1, 7]]
	   * }, {
	   *   lineSmooth: Chartist.Interpolation.simple({
	   *     divisor: 2,
	   *     fillHoles: false
	   *   })
	   * });
	   *
	   *
	   * @memberof Chartist.Interpolation
	   * @param {Object} options The options of the simple interpolation factory function.
	   * @return {Function}
	   */
	  Chartist.Interpolation.simple = function(options) {
	    var defaultOptions = {
	      divisor: 2,
	      fillHoles: false
	    };
	    options = Chartist.extend({}, defaultOptions, options);
	
	    var d = 1 / Math.max(1, options.divisor);
	
	    return function simple(pathCoordinates, valueData) {
	      var path = new Chartist.Svg.Path();
	      var prevX, prevY, prevData;
	
	      for(var i = 0; i < pathCoordinates.length; i += 2) {
	        var currX = pathCoordinates[i];
	        var currY = pathCoordinates[i + 1];
	        var length = (currX - prevX) * d;
	        var currData = valueData[i / 2];
	
	        if(currData.value !== undefined) {
	
	          if(prevData === undefined) {
	            path.move(currX, currY, false, currData);
	          } else {
	            path.curve(
	              prevX + length,
	              prevY,
	              currX - length,
	              currY,
	              currX,
	              currY,
	              false,
	              currData
	            );
	          }
	
	          prevX = currX;
	          prevY = currY;
	          prevData = currData;
	        } else if(!options.fillHoles) {
	          prevX = currX = prevData = undefined;
	        }
	      }
	
	      return path;
	    };
	  };
	
	  /**
	   * Cardinal / Catmull-Rome spline interpolation is the default smoothing function in Chartist. It produces nice results where the splines will always meet the points. It produces some artifacts though when data values are increased or decreased rapidly. The line may not follow a very accurate path and if the line should be accurate this smoothing function does not produce the best results.
	   *
	   * Cardinal splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
	   *
	   * All smoothing functions within Chartist are factory functions that accept an options parameter. The cardinal interpolation function accepts one configuration parameter `tension`, between 0 and 1, which controls the smoothing intensity.
	   *
	   * @example
	   * var chart = new Chartist.Line('.ct-chart', {
	   *   labels: [1, 2, 3, 4, 5],
	   *   series: [[1, 2, 8, 1, 7]]
	   * }, {
	   *   lineSmooth: Chartist.Interpolation.cardinal({
	   *     tension: 1,
	   *     fillHoles: false
	   *   })
	   * });
	   *
	   * @memberof Chartist.Interpolation
	   * @param {Object} options The options of the cardinal factory function.
	   * @return {Function}
	   */
	  Chartist.Interpolation.cardinal = function(options) {
	    var defaultOptions = {
	      tension: 1,
	      fillHoles: false
	    };
	
	    options = Chartist.extend({}, defaultOptions, options);
	
	    var t = Math.min(1, Math.max(0, options.tension)),
	      c = 1 - t;
	
	    return function cardinal(pathCoordinates, valueData) {
	      // First we try to split the coordinates into segments
	      // This is necessary to treat "holes" in line charts
	      var segments = Chartist.splitIntoSegments(pathCoordinates, valueData, {
	        fillHoles: options.fillHoles
	      });
	
	      if(!segments.length) {
	        // If there were no segments return 'Chartist.Interpolation.none'
	        return Chartist.Interpolation.none()([]);
	      } else if(segments.length > 1) {
	        // If the split resulted in more that one segment we need to interpolate each segment individually and join them
	        // afterwards together into a single path.
	          var paths = [];
	        // For each segment we will recurse the cardinal function
	        segments.forEach(function(segment) {
	          paths.push(cardinal(segment.pathCoordinates, segment.valueData));
	        });
	        // Join the segment path data into a single path and return
	        return Chartist.Svg.Path.join(paths);
	      } else {
	        // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
	        // segment
	        pathCoordinates = segments[0].pathCoordinates;
	        valueData = segments[0].valueData;
	
	        // If less than two points we need to fallback to no smoothing
	        if(pathCoordinates.length <= 4) {
	          return Chartist.Interpolation.none()(pathCoordinates, valueData);
	        }
	
	        var path = new Chartist.Svg.Path().move(pathCoordinates[0], pathCoordinates[1], false, valueData[0]),
	          z;
	
	        for (var i = 0, iLen = pathCoordinates.length; iLen - 2 * !z > i; i += 2) {
	          var p = [
	            {x: +pathCoordinates[i - 2], y: +pathCoordinates[i - 1]},
	            {x: +pathCoordinates[i], y: +pathCoordinates[i + 1]},
	            {x: +pathCoordinates[i + 2], y: +pathCoordinates[i + 3]},
	            {x: +pathCoordinates[i + 4], y: +pathCoordinates[i + 5]}
	          ];
	          if (z) {
	            if (!i) {
	              p[0] = {x: +pathCoordinates[iLen - 2], y: +pathCoordinates[iLen - 1]};
	            } else if (iLen - 4 === i) {
	              p[3] = {x: +pathCoordinates[0], y: +pathCoordinates[1]};
	            } else if (iLen - 2 === i) {
	              p[2] = {x: +pathCoordinates[0], y: +pathCoordinates[1]};
	              p[3] = {x: +pathCoordinates[2], y: +pathCoordinates[3]};
	            }
	          } else {
	            if (iLen - 4 === i) {
	              p[3] = p[2];
	            } else if (!i) {
	              p[0] = {x: +pathCoordinates[i], y: +pathCoordinates[i + 1]};
	            }
	          }
	
	          path.curve(
	            (t * (-p[0].x + 6 * p[1].x + p[2].x) / 6) + (c * p[2].x),
	            (t * (-p[0].y + 6 * p[1].y + p[2].y) / 6) + (c * p[2].y),
	            (t * (p[1].x + 6 * p[2].x - p[3].x) / 6) + (c * p[2].x),
	            (t * (p[1].y + 6 * p[2].y - p[3].y) / 6) + (c * p[2].y),
	            p[2].x,
	            p[2].y,
	            false,
	            valueData[(i + 2) / 2]
	          );
	        }
	
	        return path;
	      }
	    };
	  };
	
	  /**
	   * Monotone Cubic spline interpolation produces a smooth curve which preserves monotonicity. Unlike cardinal splines, the curve will not extend beyond the range of y-values of the original data points.
	   *
	   * Monotone Cubic splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
	   *
	   * The x-values of subsequent points must be increasing to fit a Monotone Cubic spline. If this condition is not met for a pair of adjacent points, then there will be a break in the curve between those data points.
	   *
	   * All smoothing functions within Chartist are factory functions that accept an options parameter.
	   *
	   * @example
	   * var chart = new Chartist.Line('.ct-chart', {
	   *   labels: [1, 2, 3, 4, 5],
	   *   series: [[1, 2, 8, 1, 7]]
	   * }, {
	   *   lineSmooth: Chartist.Interpolation.monotoneCubic({
	   *     fillHoles: false
	   *   })
	   * });
	   *
	   * @memberof Chartist.Interpolation
	   * @param {Object} options The options of the monotoneCubic factory function.
	   * @return {Function}
	   */
	  Chartist.Interpolation.monotoneCubic = function(options) {
	    var defaultOptions = {
	      fillHoles: false
	    };
	
	    options = Chartist.extend({}, defaultOptions, options);
	
	    return function monotoneCubic(pathCoordinates, valueData) {
	      // First we try to split the coordinates into segments
	      // This is necessary to treat "holes" in line charts
	      var segments = Chartist.splitIntoSegments(pathCoordinates, valueData, {
	        fillHoles: options.fillHoles,
	        increasingX: true
	      });
	
	      if(!segments.length) {
	        // If there were no segments return 'Chartist.Interpolation.none'
	        return Chartist.Interpolation.none()([]);
	      } else if(segments.length > 1) {
	        // If the split resulted in more that one segment we need to interpolate each segment individually and join them
	        // afterwards together into a single path.
	          var paths = [];
	        // For each segment we will recurse the monotoneCubic fn function
	        segments.forEach(function(segment) {
	          paths.push(monotoneCubic(segment.pathCoordinates, segment.valueData));
	        });
	        // Join the segment path data into a single path and return
	        return Chartist.Svg.Path.join(paths);
	      } else {
	        // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
	        // segment
	        pathCoordinates = segments[0].pathCoordinates;
	        valueData = segments[0].valueData;
	
	        // If less than three points we need to fallback to no smoothing
	        if(pathCoordinates.length <= 4) {
	          return Chartist.Interpolation.none()(pathCoordinates, valueData);
	        }
	
	        var xs = [],
	          ys = [],
	          i,
	          n = pathCoordinates.length / 2,
	          ms = [],
	          ds = [], dys = [], dxs = [],
	          path;
	
	        // Populate x and y coordinates into separate arrays, for readability
	
	        for(i = 0; i < n; i++) {
	          xs[i] = pathCoordinates[i * 2];
	          ys[i] = pathCoordinates[i * 2 + 1];
	        }
	
	        // Calculate deltas and derivative
	
	        for(i = 0; i < n - 1; i++) {
	          dys[i] = ys[i + 1] - ys[i];
	          dxs[i] = xs[i + 1] - xs[i];
	          ds[i] = dys[i] / dxs[i];
	        }
	
	        // Determine desired slope (m) at each point using Fritsch-Carlson method
	        // See: http://math.stackexchange.com/questions/45218/implementation-of-monotone-cubic-interpolation
	
	        ms[0] = ds[0];
	        ms[n - 1] = ds[n - 2];
	
	        for(i = 1; i < n - 1; i++) {
	          if(ds[i] === 0 || ds[i - 1] === 0 || (ds[i - 1] > 0) !== (ds[i] > 0)) {
	            ms[i] = 0;
	          } else {
	            ms[i] = 3 * (dxs[i - 1] + dxs[i]) / (
	              (2 * dxs[i] + dxs[i - 1]) / ds[i - 1] +
	              (dxs[i] + 2 * dxs[i - 1]) / ds[i]);
	
	            if(!isFinite(ms[i])) {
	              ms[i] = 0;
	            }
	          }
	        }
	
	        // Now build a path from the slopes
	
	        path = new Chartist.Svg.Path().move(xs[0], ys[0], false, valueData[0]);
	
	        for(i = 0; i < n - 1; i++) {
	          path.curve(
	            // First control point
	            xs[i] + dxs[i] / 3,
	            ys[i] + ms[i] * dxs[i] / 3,
	            // Second control point
	            xs[i + 1] - dxs[i] / 3,
	            ys[i + 1] - ms[i + 1] * dxs[i] / 3,
	            // End point
	            xs[i + 1],
	            ys[i + 1],
	
	            false,
	            valueData[i + 1]
	          );
	        }
	
	        return path;
	      }
	    };
	  };
	
	  /**
	   * Step interpolation will cause the line chart to move in steps rather than diagonal or smoothed lines. This interpolation will create additional points that will also be drawn when the `showPoint` option is enabled.
	   *
	   * All smoothing functions within Chartist are factory functions that accept an options parameter. The step interpolation function accepts one configuration parameter `postpone`, that can be `true` or `false`. The default value is `true` and will cause the step to occur where the value actually changes. If a different behaviour is needed where the step is shifted to the left and happens before the actual value, this option can be set to `false`.
	   *
	   * @example
	   * var chart = new Chartist.Line('.ct-chart', {
	   *   labels: [1, 2, 3, 4, 5],
	   *   series: [[1, 2, 8, 1, 7]]
	   * }, {
	   *   lineSmooth: Chartist.Interpolation.step({
	   *     postpone: true,
	   *     fillHoles: false
	   *   })
	   * });
	   *
	   * @memberof Chartist.Interpolation
	   * @param options
	   * @returns {Function}
	   */
	  Chartist.Interpolation.step = function(options) {
	    var defaultOptions = {
	      postpone: true,
	      fillHoles: false
	    };
	
	    options = Chartist.extend({}, defaultOptions, options);
	
	    return function step(pathCoordinates, valueData) {
	      var path = new Chartist.Svg.Path();
	
	      var prevX, prevY, prevData;
	
	      for (var i = 0; i < pathCoordinates.length; i += 2) {
	        var currX = pathCoordinates[i];
	        var currY = pathCoordinates[i + 1];
	        var currData = valueData[i / 2];
	
	        // If the current point is also not a hole we can draw the step lines
	        if(currData.value !== undefined) {
	          if(prevData === undefined) {
	            path.move(currX, currY, false, currData);
	          } else {
	            if(options.postpone) {
	              // If postponed we should draw the step line with the value of the previous value
	              path.line(currX, prevY, false, prevData);
	            } else {
	              // If not postponed we should draw the step line with the value of the current value
	              path.line(prevX, currY, false, currData);
	            }
	            // Line to the actual point (this should only be a Y-Axis movement
	            path.line(currX, currY, false, currData);
	          }
	
	          prevX = currX;
	          prevY = currY;
	          prevData = currData;
	        } else if(!options.fillHoles) {
	          prevX = prevY = prevData = undefined;
	        }
	      }
	
	      return path;
	    };
	  };
	
	}(window, document, Chartist));
	;/**
	 * A very basic event module that helps to generate and catch events.
	 *
	 * @module Chartist.Event
	 */
	/* global Chartist */
	(function (window, document, Chartist) {
	  'use strict';
	
	  Chartist.EventEmitter = function () {
	    var handlers = [];
	
	    /**
	     * Add an event handler for a specific event
	     *
	     * @memberof Chartist.Event
	     * @param {String} event The event name
	     * @param {Function} handler A event handler function
	     */
	    function addEventHandler(event, handler) {
	      handlers[event] = handlers[event] || [];
	      handlers[event].push(handler);
	    }
	
	    /**
	     * Remove an event handler of a specific event name or remove all event handlers for a specific event.
	     *
	     * @memberof Chartist.Event
	     * @param {String} event The event name where a specific or all handlers should be removed
	     * @param {Function} [handler] An optional event handler function. If specified only this specific handler will be removed and otherwise all handlers are removed.
	     */
	    function removeEventHandler(event, handler) {
	      // Only do something if there are event handlers with this name existing
	      if(handlers[event]) {
	        // If handler is set we will look for a specific handler and only remove this
	        if(handler) {
	          handlers[event].splice(handlers[event].indexOf(handler), 1);
	          if(handlers[event].length === 0) {
	            delete handlers[event];
	          }
	        } else {
	          // If no handler is specified we remove all handlers for this event
	          delete handlers[event];
	        }
	      }
	    }
	
	    /**
	     * Use this function to emit an event. All handlers that are listening for this event will be triggered with the data parameter.
	     *
	     * @memberof Chartist.Event
	     * @param {String} event The event name that should be triggered
	     * @param {*} data Arbitrary data that will be passed to the event handler callback functions
	     */
	    function emit(event, data) {
	      // Only do something if there are event handlers with this name existing
	      if(handlers[event]) {
	        handlers[event].forEach(function(handler) {
	          handler(data);
	        });
	      }
	
	      // Emit event to star event handlers
	      if(handlers['*']) {
	        handlers['*'].forEach(function(starHandler) {
	          starHandler(event, data);
	        });
	      }
	    }
	
	    return {
	      addEventHandler: addEventHandler,
	      removeEventHandler: removeEventHandler,
	      emit: emit
	    };
	  };
	
	}(window, document, Chartist));
	;/**
	 * This module provides some basic prototype inheritance utilities.
	 *
	 * @module Chartist.Class
	 */
	/* global Chartist */
	(function(window, document, Chartist) {
	  'use strict';
	
	  function listToArray(list) {
	    var arr = [];
	    if (list.length) {
	      for (var i = 0; i < list.length; i++) {
	        arr.push(list[i]);
	      }
	    }
	    return arr;
	  }
	
	  /**
	   * Method to extend from current prototype.
	   *
	   * @memberof Chartist.Class
	   * @param {Object} properties The object that serves as definition for the prototype that gets created for the new class. This object should always contain a constructor property that is the desired constructor for the newly created class.
	   * @param {Object} [superProtoOverride] By default extens will use the current class prototype or Chartist.class. With this parameter you can specify any super prototype that will be used.
	   * @return {Function} Constructor function of the new class
	   *
	   * @example
	   * var Fruit = Class.extend({
	     * color: undefined,
	     *   sugar: undefined,
	     *
	     *   constructor: function(color, sugar) {
	     *     this.color = color;
	     *     this.sugar = sugar;
	     *   },
	     *
	     *   eat: function() {
	     *     this.sugar = 0;
	     *     return this;
	     *   }
	     * });
	   *
	   * var Banana = Fruit.extend({
	     *   length: undefined,
	     *
	     *   constructor: function(length, sugar) {
	     *     Banana.super.constructor.call(this, 'Yellow', sugar);
	     *     this.length = length;
	     *   }
	     * });
	   *
	   * var banana = new Banana(20, 40);
	   * console.log('banana instanceof Fruit', banana instanceof Fruit);
	   * console.log('Fruit is prototype of banana', Fruit.prototype.isPrototypeOf(banana));
	   * console.log('bananas prototype is Fruit', Object.getPrototypeOf(banana) === Fruit.prototype);
	   * console.log(banana.sugar);
	   * console.log(banana.eat().sugar);
	   * console.log(banana.color);
	   */
	  function extend(properties, superProtoOverride) {
	    var superProto = superProtoOverride || this.prototype || Chartist.Class;
	    var proto = Object.create(superProto);
	
	    Chartist.Class.cloneDefinitions(proto, properties);
	
	    var constr = function() {
	      var fn = proto.constructor || function () {},
	        instance;
	
	      // If this is linked to the Chartist namespace the constructor was not called with new
	      // To provide a fallback we will instantiate here and return the instance
	      instance = this === Chartist ? Object.create(proto) : this;
	      fn.apply(instance, Array.prototype.slice.call(arguments, 0));
	
	      // If this constructor was not called with new we need to return the instance
	      // This will not harm when the constructor has been called with new as the returned value is ignored
	      return instance;
	    };
	
	    constr.prototype = proto;
	    constr.super = superProto;
	    constr.extend = this.extend;
	
	    return constr;
	  }
	
	  // Variable argument list clones args > 0 into args[0] and retruns modified args[0]
	  function cloneDefinitions() {
	    var args = listToArray(arguments);
	    var target = args[0];
	
	    args.splice(1, args.length - 1).forEach(function (source) {
	      Object.getOwnPropertyNames(source).forEach(function (propName) {
	        // If this property already exist in target we delete it first
	        delete target[propName];
	        // Define the property with the descriptor from source
	        Object.defineProperty(target, propName,
	          Object.getOwnPropertyDescriptor(source, propName));
	      });
	    });
	
	    return target;
	  }
	
	  Chartist.Class = {
	    extend: extend,
	    cloneDefinitions: cloneDefinitions
	  };
	
	}(window, document, Chartist));
	;/**
	 * Base for all chart types. The methods in Chartist.Base are inherited to all chart types.
	 *
	 * @module Chartist.Base
	 */
	/* global Chartist */
	(function(window, document, Chartist) {
	  'use strict';
	
	  // TODO: Currently we need to re-draw the chart on window resize. This is usually very bad and will affect performance.
	  // This is done because we can't work with relative coordinates when drawing the chart because SVG Path does not
	  // work with relative positions yet. We need to check if we can do a viewBox hack to switch to percentage.
	  // See http://mozilla.6506.n7.nabble.com/Specyfing-paths-with-percentages-unit-td247474.html
	  // Update: can be done using the above method tested here: http://codepen.io/gionkunz/pen/KDvLj
	  // The problem is with the label offsets that can't be converted into percentage and affecting the chart container
	  /**
	   * Updates the chart which currently does a full reconstruction of the SVG DOM
	   *
	   * @param {Object} [data] Optional data you'd like to set for the chart before it will update. If not specified the update method will use the data that is already configured with the chart.
	   * @param {Object} [options] Optional options you'd like to add to the previous options for the chart before it will update. If not specified the update method will use the options that have been already configured with the chart.
	   * @param {Boolean} [override] If set to true, the passed options will be used to extend the options that have been configured already. Otherwise the chart default options will be used as the base
	   * @memberof Chartist.Base
	   */
	  function update(data, options, override) {
	    if(data) {
	      this.data = data;
	      // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
	      this.eventEmitter.emit('data', {
	        type: 'update',
	        data: this.data
	      });
	    }
	
	    if(options) {
	      this.options = Chartist.extend({}, override ? this.options : this.defaultOptions, options);
	
	      // If chartist was not initialized yet, we just set the options and leave the rest to the initialization
	      // Otherwise we re-create the optionsProvider at this point
	      if(!this.initializeTimeoutId) {
	        this.optionsProvider.removeMediaQueryListeners();
	        this.optionsProvider = Chartist.optionsProvider(this.options, this.responsiveOptions, this.eventEmitter);
	      }
	    }
	
	    // Only re-created the chart if it has been initialized yet
	    if(!this.initializeTimeoutId) {
	      this.createChart(this.optionsProvider.getCurrentOptions());
	    }
	
	    // Return a reference to the chart object to chain up calls
	    return this;
	  }
	
	  /**
	   * This method can be called on the API object of each chart and will un-register all event listeners that were added to other components. This currently includes a window.resize listener as well as media query listeners if any responsive options have been provided. Use this function if you need to destroy and recreate Chartist charts dynamically.
	   *
	   * @memberof Chartist.Base
	   */
	  function detach() {
	    // Only detach if initialization already occurred on this chart. If this chart still hasn't initialized (therefore
	    // the initializationTimeoutId is still a valid timeout reference, we will clear the timeout
	    if(!this.initializeTimeoutId) {
	      window.removeEventListener('resize', this.resizeListener);
	      this.optionsProvider.removeMediaQueryListeners();
	    } else {
	      window.clearTimeout(this.initializeTimeoutId);
	    }
	
	    return this;
	  }
	
	  /**
	   * Use this function to register event handlers. The handler callbacks are synchronous and will run in the main thread rather than the event loop.
	   *
	   * @memberof Chartist.Base
	   * @param {String} event Name of the event. Check the examples for supported events.
	   * @param {Function} handler The handler function that will be called when an event with the given name was emitted. This function will receive a data argument which contains event data. See the example for more details.
	   */
	  function on(event, handler) {
	    this.eventEmitter.addEventHandler(event, handler);
	    return this;
	  }
	
	  /**
	   * Use this function to un-register event handlers. If the handler function parameter is omitted all handlers for the given event will be un-registered.
	   *
	   * @memberof Chartist.Base
	   * @param {String} event Name of the event for which a handler should be removed
	   * @param {Function} [handler] The handler function that that was previously used to register a new event handler. This handler will be removed from the event handler list. If this parameter is omitted then all event handlers for the given event are removed from the list.
	   */
	  function off(event, handler) {
	    this.eventEmitter.removeEventHandler(event, handler);
	    return this;
	  }
	
	  function initialize() {
	    // Add window resize listener that re-creates the chart
	    window.addEventListener('resize', this.resizeListener);
	
	    // Obtain current options based on matching media queries (if responsive options are given)
	    // This will also register a listener that is re-creating the chart based on media changes
	    this.optionsProvider = Chartist.optionsProvider(this.options, this.responsiveOptions, this.eventEmitter);
	    // Register options change listener that will trigger a chart update
	    this.eventEmitter.addEventHandler('optionsChanged', function() {
	      this.update();
	    }.bind(this));
	
	    // Before the first chart creation we need to register us with all plugins that are configured
	    // Initialize all relevant plugins with our chart object and the plugin options specified in the config
	    if(this.options.plugins) {
	      this.options.plugins.forEach(function(plugin) {
	        if(plugin instanceof Array) {
	          plugin[0](this, plugin[1]);
	        } else {
	          plugin(this);
	        }
	      }.bind(this));
	    }
	
	    // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
	    this.eventEmitter.emit('data', {
	      type: 'initial',
	      data: this.data
	    });
	
	    // Create the first chart
	    this.createChart(this.optionsProvider.getCurrentOptions());
	
	    // As chart is initialized from the event loop now we can reset our timeout reference
	    // This is important if the chart gets initialized on the same element twice
	    this.initializeTimeoutId = undefined;
	  }
	
	  /**
	   * Constructor of chart base class.
	   *
	   * @param query
	   * @param data
	   * @param defaultOptions
	   * @param options
	   * @param responsiveOptions
	   * @constructor
	   */
	  function Base(query, data, defaultOptions, options, responsiveOptions) {
	    this.container = Chartist.querySelector(query);
	    this.data = data;
	    this.defaultOptions = defaultOptions;
	    this.options = options;
	    this.responsiveOptions = responsiveOptions;
	    this.eventEmitter = Chartist.EventEmitter();
	    this.supportsForeignObject = Chartist.Svg.isSupported('Extensibility');
	    this.supportsAnimations = Chartist.Svg.isSupported('AnimationEventsAttribute');
	    this.resizeListener = function resizeListener(){
	      this.update();
	    }.bind(this);
	
	    if(this.container) {
	      // If chartist was already initialized in this container we are detaching all event listeners first
	      if(this.container.__chartist__) {
	        this.container.__chartist__.detach();
	      }
	
	      this.container.__chartist__ = this;
	    }
	
	    // Using event loop for first draw to make it possible to register event listeners in the same call stack where
	    // the chart was created.
	    this.initializeTimeoutId = setTimeout(initialize.bind(this), 0);
	  }
	
	  // Creating the chart base class
	  Chartist.Base = Chartist.Class.extend({
	    constructor: Base,
	    optionsProvider: undefined,
	    container: undefined,
	    svg: undefined,
	    eventEmitter: undefined,
	    createChart: function() {
	      throw new Error('Base chart type can\'t be instantiated!');
	    },
	    update: update,
	    detach: detach,
	    on: on,
	    off: off,
	    version: Chartist.version,
	    supportsForeignObject: false
	  });
	
	}(window, document, Chartist));
	;/**
	 * Chartist SVG module for simple SVG DOM abstraction
	 *
	 * @module Chartist.Svg
	 */
	/* global Chartist */
	(function(window, document, Chartist) {
	  'use strict';
	
	  /**
	   * Chartist.Svg creates a new SVG object wrapper with a starting element. You can use the wrapper to fluently create sub-elements and modify them.
	   *
	   * @memberof Chartist.Svg
	   * @constructor
	   * @param {String|Element} name The name of the SVG element to create or an SVG dom element which should be wrapped into Chartist.Svg
	   * @param {Object} attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
	   * @param {String} className This class or class list will be added to the SVG element
	   * @param {Object} parent The parent SVG wrapper object where this newly created wrapper and it's element will be attached to as child
	   * @param {Boolean} insertFirst If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
	   */
	  function Svg(name, attributes, className, parent, insertFirst) {
	    // If Svg is getting called with an SVG element we just return the wrapper
	    if(name instanceof Element) {
	      this._node = name;
	    } else {
	      this._node = document.createElementNS(Chartist.namespaces.svg, name);
	
	      // If this is an SVG element created then custom namespace
	      if(name === 'svg') {
	        this.attr({
	          'xmlns:ct': Chartist.namespaces.ct
	        });
	      }
	    }
	
	    if(attributes) {
	      this.attr(attributes);
	    }
	
	    if(className) {
	      this.addClass(className);
	    }
	
	    if(parent) {
	      if (insertFirst && parent._node.firstChild) {
	        parent._node.insertBefore(this._node, parent._node.firstChild);
	      } else {
	        parent._node.appendChild(this._node);
	      }
	    }
	  }
	
	  /**
	   * Set attributes on the current SVG element of the wrapper you're currently working on.
	   *
	   * @memberof Chartist.Svg
	   * @param {Object|String} attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added. If this parameter is a String then the function is used as a getter and will return the attribute value.
	   * @param {String} ns If specified, the attribute will be obtained using getAttributeNs. In order to write namepsaced attributes you can use the namespace:attribute notation within the attributes object.
	   * @return {Object|String} The current wrapper object will be returned so it can be used for chaining or the attribute value if used as getter function.
	   */
	  function attr(attributes, ns) {
	    if(typeof attributes === 'string') {
	      if(ns) {
	        return this._node.getAttributeNS(ns, attributes);
	      } else {
	        return this._node.getAttribute(attributes);
	      }
	    }
	
	    Object.keys(attributes).forEach(function(key) {
	      // If the attribute value is undefined we can skip this one
	      if(attributes[key] === undefined) {
	        return;
	      }
	
	      if (key.indexOf(':') !== -1) {
	        var namespacedAttribute = key.split(':');
	        this._node.setAttributeNS(Chartist.namespaces[namespacedAttribute[0]], key, attributes[key]);
	      } else {
	        this._node.setAttribute(key, attributes[key]);
	      }
	    }.bind(this));
	
	    return this;
	  }
	
	  /**
	   * Create a new SVG element whose wrapper object will be selected for further operations. This way you can also create nested groups easily.
	   *
	   * @memberof Chartist.Svg
	   * @param {String} name The name of the SVG element that should be created as child element of the currently selected element wrapper
	   * @param {Object} [attributes] An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
	   * @param {String} [className] This class or class list will be added to the SVG element
	   * @param {Boolean} [insertFirst] If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
	   * @return {Chartist.Svg} Returns a Chartist.Svg wrapper object that can be used to modify the containing SVG data
	   */
	  function elem(name, attributes, className, insertFirst) {
	    return new Chartist.Svg(name, attributes, className, this, insertFirst);
	  }
	
	  /**
	   * Returns the parent Chartist.SVG wrapper object
	   *
	   * @memberof Chartist.Svg
	   * @return {Chartist.Svg} Returns a Chartist.Svg wrapper around the parent node of the current node. If the parent node is not existing or it's not an SVG node then this function will return null.
	   */
	  function parent() {
	    return this._node.parentNode instanceof SVGElement ? new Chartist.Svg(this._node.parentNode) : null;
	  }
	
	  /**
	   * This method returns a Chartist.Svg wrapper around the root SVG element of the current tree.
	   *
	   * @memberof Chartist.Svg
	   * @return {Chartist.Svg} The root SVG element wrapped in a Chartist.Svg element
	   */
	  function root() {
	    var node = this._node;
	    while(node.nodeName !== 'svg') {
	      node = node.parentNode;
	    }
	    return new Chartist.Svg(node);
	  }
	
	  /**
	   * Find the first child SVG element of the current element that matches a CSS selector. The returned object is a Chartist.Svg wrapper.
	   *
	   * @memberof Chartist.Svg
	   * @param {String} selector A CSS selector that is used to query for child SVG elements
	   * @return {Chartist.Svg} The SVG wrapper for the element found or null if no element was found
	   */
	  function querySelector(selector) {
	    var foundNode = this._node.querySelector(selector);
	    return foundNode ? new Chartist.Svg(foundNode) : null;
	  }
	
	  /**
	   * Find the all child SVG elements of the current element that match a CSS selector. The returned object is a Chartist.Svg.List wrapper.
	   *
	   * @memberof Chartist.Svg
	   * @param {String} selector A CSS selector that is used to query for child SVG elements
	   * @return {Chartist.Svg.List} The SVG wrapper list for the element found or null if no element was found
	   */
	  function querySelectorAll(selector) {
	    var foundNodes = this._node.querySelectorAll(selector);
	    return foundNodes.length ? new Chartist.Svg.List(foundNodes) : null;
	  }
	
	  /**
	   * This method creates a foreignObject (see https://developer.mozilla.org/en-US/docs/Web/SVG/Element/foreignObject) that allows to embed HTML content into a SVG graphic. With the help of foreignObjects you can enable the usage of regular HTML elements inside of SVG where they are subject for SVG positioning and transformation but the Browser will use the HTML rendering capabilities for the containing DOM.
	   *
	   * @memberof Chartist.Svg
	   * @param {Node|String} content The DOM Node, or HTML string that will be converted to a DOM Node, that is then placed into and wrapped by the foreignObject
	   * @param {String} [attributes] An object with properties that will be added as attributes to the foreignObject element that is created. Attributes with undefined values will not be added.
	   * @param {String} [className] This class or class list will be added to the SVG element
	   * @param {Boolean} [insertFirst] Specifies if the foreignObject should be inserted as first child
	   * @return {Chartist.Svg} New wrapper object that wraps the foreignObject element
	   */
	  function foreignObject(content, attributes, className, insertFirst) {
	    // If content is string then we convert it to DOM
	    // TODO: Handle case where content is not a string nor a DOM Node
	    if(typeof content === 'string') {
	      var container = document.createElement('div');
	      container.innerHTML = content;
	      content = container.firstChild;
	    }
	
	    // Adding namespace to content element
	    content.setAttribute('xmlns', Chartist.namespaces.xmlns);
	
	    // Creating the foreignObject without required extension attribute (as described here
	    // http://www.w3.org/TR/SVG/extend.html#ForeignObjectElement)
	    var fnObj = this.elem('foreignObject', attributes, className, insertFirst);
	
	    // Add content to foreignObjectElement
	    fnObj._node.appendChild(content);
	
	    return fnObj;
	  }
	
	  /**
	   * This method adds a new text element to the current Chartist.Svg wrapper.
	   *
	   * @memberof Chartist.Svg
	   * @param {String} t The text that should be added to the text element that is created
	   * @return {Chartist.Svg} The same wrapper object that was used to add the newly created element
	   */
	  function text(t) {
	    this._node.appendChild(document.createTextNode(t));
	    return this;
	  }
	
	  /**
	   * This method will clear all child nodes of the current wrapper object.
	   *
	   * @memberof Chartist.Svg
	   * @return {Chartist.Svg} The same wrapper object that got emptied
	   */
	  function empty() {
	    while (this._node.firstChild) {
	      this._node.removeChild(this._node.firstChild);
	    }
	
	    return this;
	  }
	
	  /**
	   * This method will cause the current wrapper to remove itself from its parent wrapper. Use this method if you'd like to get rid of an element in a given DOM structure.
	   *
	   * @memberof Chartist.Svg
	   * @return {Chartist.Svg} The parent wrapper object of the element that got removed
	   */
	  function remove() {
	    this._node.parentNode.removeChild(this._node);
	    return this.parent();
	  }
	
	  /**
	   * This method will replace the element with a new element that can be created outside of the current DOM.
	   *
	   * @memberof Chartist.Svg
	   * @param {Chartist.Svg} newElement The new Chartist.Svg object that will be used to replace the current wrapper object
	   * @return {Chartist.Svg} The wrapper of the new element
	   */
	  function replace(newElement) {
	    this._node.parentNode.replaceChild(newElement._node, this._node);
	    return newElement;
	  }
	
	  /**
	   * This method will append an element to the current element as a child.
	   *
	   * @memberof Chartist.Svg
	   * @param {Chartist.Svg} element The Chartist.Svg element that should be added as a child
	   * @param {Boolean} [insertFirst] Specifies if the element should be inserted as first child
	   * @return {Chartist.Svg} The wrapper of the appended object
	   */
	  function append(element, insertFirst) {
	    if(insertFirst && this._node.firstChild) {
	      this._node.insertBefore(element._node, this._node.firstChild);
	    } else {
	      this._node.appendChild(element._node);
	    }
	
	    return this;
	  }
	
	  /**
	   * Returns an array of class names that are attached to the current wrapper element. This method can not be chained further.
	   *
	   * @memberof Chartist.Svg
	   * @return {Array} A list of classes or an empty array if there are no classes on the current element
	   */
	  function classes() {
	    return this._node.getAttribute('class') ? this._node.getAttribute('class').trim().split(/\s+/) : [];
	  }
	
	  /**
	   * Adds one or a space separated list of classes to the current element and ensures the classes are only existing once.
	   *
	   * @memberof Chartist.Svg
	   * @param {String} names A white space separated list of class names
	   * @return {Chartist.Svg} The wrapper of the current element
	   */
	  function addClass(names) {
	    this._node.setAttribute('class',
	      this.classes(this._node)
	        .concat(names.trim().split(/\s+/))
	        .filter(function(elem, pos, self) {
	          return self.indexOf(elem) === pos;
	        }).join(' ')
	    );
	
	    return this;
	  }
	
	  /**
	   * Removes one or a space separated list of classes from the current element.
	   *
	   * @memberof Chartist.Svg
	   * @param {String} names A white space separated list of class names
	   * @return {Chartist.Svg} The wrapper of the current element
	   */
	  function removeClass(names) {
	    var removedClasses = names.trim().split(/\s+/);
	
	    this._node.setAttribute('class', this.classes(this._node).filter(function(name) {
	      return removedClasses.indexOf(name) === -1;
	    }).join(' '));
	
	    return this;
	  }
	
	  /**
	   * Removes all classes from the current element.
	   *
	   * @memberof Chartist.Svg
	   * @return {Chartist.Svg} The wrapper of the current element
	   */
	  function removeAllClasses() {
	    this._node.setAttribute('class', '');
	
	    return this;
	  }
	
	  /**
	   * Get element height using `getBoundingClientRect`
	   *
	   * @memberof Chartist.Svg
	   * @return {Number} The elements height in pixels
	   */
	  function height() {
	    return this._node.getBoundingClientRect().height;
	  }
	
	  /**
	   * Get element width using `getBoundingClientRect`
	   *
	   * @memberof Chartist.Core
	   * @return {Number} The elements width in pixels
	   */
	  function width() {
	    return this._node.getBoundingClientRect().width;
	  }
	
	  /**
	   * The animate function lets you animate the current element with SMIL animations. You can add animations for multiple attributes at the same time by using an animation definition object. This object should contain SMIL animation attributes. Please refer to http://www.w3.org/TR/SVG/animate.html for a detailed specification about the available animation attributes. Additionally an easing property can be passed in the animation definition object. This can be a string with a name of an easing function in `Chartist.Svg.Easing` or an array with four numbers specifying a cubic Bézier curve.
	   * **An animations object could look like this:**
	   * ```javascript
	   * element.animate({
	   *   opacity: {
	   *     dur: 1000,
	   *     from: 0,
	   *     to: 1
	   *   },
	   *   x1: {
	   *     dur: '1000ms',
	   *     from: 100,
	   *     to: 200,
	   *     easing: 'easeOutQuart'
	   *   },
	   *   y1: {
	   *     dur: '2s',
	   *     from: 0,
	   *     to: 100
	   *   }
	   * });
	   * ```
	   * **Automatic unit conversion**
	   * For the `dur` and the `begin` animate attribute you can also omit a unit by passing a number. The number will automatically be converted to milli seconds.
	   * **Guided mode**
	   * The default behavior of SMIL animations with offset using the `begin` attribute is that the attribute will keep it's original value until the animation starts. Mostly this behavior is not desired as you'd like to have your element attributes already initialized with the animation `from` value even before the animation starts. Also if you don't specify `fill="freeze"` on an animate element or if you delete the animation after it's done (which is done in guided mode) the attribute will switch back to the initial value. This behavior is also not desired when performing simple one-time animations. For one-time animations you'd want to trigger animations immediately instead of relative to the document begin time. That's why in guided mode Chartist.Svg will also use the `begin` property to schedule a timeout and manually start the animation after the timeout. If you're using multiple SMIL definition objects for an attribute (in an array), guided mode will be disabled for this attribute, even if you explicitly enabled it.
	   * If guided mode is enabled the following behavior is added:
	   * - Before the animation starts (even when delayed with `begin`) the animated attribute will be set already to the `from` value of the animation
	   * - `begin` is explicitly set to `indefinite` so it can be started manually without relying on document begin time (creation)
	   * - The animate element will be forced to use `fill="freeze"`
	   * - The animation will be triggered with `beginElement()` in a timeout where `begin` of the definition object is interpreted in milli seconds. If no `begin` was specified the timeout is triggered immediately.
	   * - After the animation the element attribute value will be set to the `to` value of the animation
	   * - The animate element is deleted from the DOM
	   *
	   * @memberof Chartist.Svg
	   * @param {Object} animations An animations object where the property keys are the attributes you'd like to animate. The properties should be objects again that contain the SMIL animation attributes (usually begin, dur, from, and to). The property begin and dur is auto converted (see Automatic unit conversion). You can also schedule multiple animations for the same attribute by passing an Array of SMIL definition objects. Attributes that contain an array of SMIL definition objects will not be executed in guided mode.
	   * @param {Boolean} guided Specify if guided mode should be activated for this animation (see Guided mode). If not otherwise specified, guided mode will be activated.
	   * @param {Object} eventEmitter If specified, this event emitter will be notified when an animation starts or ends.
	   * @return {Chartist.Svg} The current element where the animation was added
	   */
	  function animate(animations, guided, eventEmitter) {
	    if(guided === undefined) {
	      guided = true;
	    }
	
	    Object.keys(animations).forEach(function createAnimateForAttributes(attribute) {
	
	      function createAnimate(animationDefinition, guided) {
	        var attributeProperties = {},
	          animate,
	          timeout,
	          easing;
	
	        // Check if an easing is specified in the definition object and delete it from the object as it will not
	        // be part of the animate element attributes.
	        if(animationDefinition.easing) {
	          // If already an easing Bézier curve array we take it or we lookup a easing array in the Easing object
	          easing = animationDefinition.easing instanceof Array ?
	            animationDefinition.easing :
	            Chartist.Svg.Easing[animationDefinition.easing];
	          delete animationDefinition.easing;
	        }
	
	        // If numeric dur or begin was provided we assume milli seconds
	        animationDefinition.begin = Chartist.ensureUnit(animationDefinition.begin, 'ms');
	        animationDefinition.dur = Chartist.ensureUnit(animationDefinition.dur, 'ms');
	
	        if(easing) {
	          animationDefinition.calcMode = 'spline';
	          animationDefinition.keySplines = easing.join(' ');
	          animationDefinition.keyTimes = '0;1';
	        }
	
	        // Adding "fill: freeze" if we are in guided mode and set initial attribute values
	        if(guided) {
	          animationDefinition.fill = 'freeze';
	          // Animated property on our element should already be set to the animation from value in guided mode
	          attributeProperties[attribute] = animationDefinition.from;
	          this.attr(attributeProperties);
	
	          // In guided mode we also set begin to indefinite so we can trigger the start manually and put the begin
	          // which needs to be in ms aside
	          timeout = Chartist.quantity(animationDefinition.begin || 0).value;
	          animationDefinition.begin = 'indefinite';
	        }
	
	        animate = this.elem('animate', Chartist.extend({
	          attributeName: attribute
	        }, animationDefinition));
	
	        if(guided) {
	          // If guided we take the value that was put aside in timeout and trigger the animation manually with a timeout
	          setTimeout(function() {
	            // If beginElement fails we set the animated attribute to the end position and remove the animate element
	            // This happens if the SMIL ElementTimeControl interface is not supported or any other problems occured in
	            // the browser. (Currently FF 34 does not support animate elements in foreignObjects)
	            try {
	              animate._node.beginElement();
	            } catch(err) {
	              // Set animated attribute to current animated value
	              attributeProperties[attribute] = animationDefinition.to;
	              this.attr(attributeProperties);
	              // Remove the animate element as it's no longer required
	              animate.remove();
	            }
	          }.bind(this), timeout);
	        }
	
	        if(eventEmitter) {
	          animate._node.addEventListener('beginEvent', function handleBeginEvent() {
	            eventEmitter.emit('animationBegin', {
	              element: this,
	              animate: animate._node,
	              params: animationDefinition
	            });
	          }.bind(this));
	        }
	
	        animate._node.addEventListener('endEvent', function handleEndEvent() {
	          if(eventEmitter) {
	            eventEmitter.emit('animationEnd', {
	              element: this,
	              animate: animate._node,
	              params: animationDefinition
	            });
	          }
	
	          if(guided) {
	            // Set animated attribute to current animated value
	            attributeProperties[attribute] = animationDefinition.to;
	            this.attr(attributeProperties);
	            // Remove the animate element as it's no longer required
	            animate.remove();
	          }
	        }.bind(this));
	      }
	
	      // If current attribute is an array of definition objects we create an animate for each and disable guided mode
	      if(animations[attribute] instanceof Array) {
	        animations[attribute].forEach(function(animationDefinition) {
	          createAnimate.bind(this)(animationDefinition, false);
	        }.bind(this));
	      } else {
	        createAnimate.bind(this)(animations[attribute], guided);
	      }
	
	    }.bind(this));
	
	    return this;
	  }
	
	  Chartist.Svg = Chartist.Class.extend({
	    constructor: Svg,
	    attr: attr,
	    elem: elem,
	    parent: parent,
	    root: root,
	    querySelector: querySelector,
	    querySelectorAll: querySelectorAll,
	    foreignObject: foreignObject,
	    text: text,
	    empty: empty,
	    remove: remove,
	    replace: replace,
	    append: append,
	    classes: classes,
	    addClass: addClass,
	    removeClass: removeClass,
	    removeAllClasses: removeAllClasses,
	    height: height,
	    width: width,
	    animate: animate
	  });
	
	  /**
	   * This method checks for support of a given SVG feature like Extensibility, SVG-animation or the like. Check http://www.w3.org/TR/SVG11/feature for a detailed list.
	   *
	   * @memberof Chartist.Svg
	   * @param {String} feature The SVG 1.1 feature that should be checked for support.
	   * @return {Boolean} True of false if the feature is supported or not
	   */
	  Chartist.Svg.isSupported = function(feature) {
	    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#' + feature, '1.1');
	  };
	
	  /**
	   * This Object contains some standard easing cubic bezier curves. Then can be used with their name in the `Chartist.Svg.animate`. You can also extend the list and use your own name in the `animate` function. Click the show code button to see the available bezier functions.
	   *
	   * @memberof Chartist.Svg
	   */
	  var easingCubicBeziers = {
	    easeInSine: [0.47, 0, 0.745, 0.715],
	    easeOutSine: [0.39, 0.575, 0.565, 1],
	    easeInOutSine: [0.445, 0.05, 0.55, 0.95],
	    easeInQuad: [0.55, 0.085, 0.68, 0.53],
	    easeOutQuad: [0.25, 0.46, 0.45, 0.94],
	    easeInOutQuad: [0.455, 0.03, 0.515, 0.955],
	    easeInCubic: [0.55, 0.055, 0.675, 0.19],
	    easeOutCubic: [0.215, 0.61, 0.355, 1],
	    easeInOutCubic: [0.645, 0.045, 0.355, 1],
	    easeInQuart: [0.895, 0.03, 0.685, 0.22],
	    easeOutQuart: [0.165, 0.84, 0.44, 1],
	    easeInOutQuart: [0.77, 0, 0.175, 1],
	    easeInQuint: [0.755, 0.05, 0.855, 0.06],
	    easeOutQuint: [0.23, 1, 0.32, 1],
	    easeInOutQuint: [0.86, 0, 0.07, 1],
	    easeInExpo: [0.95, 0.05, 0.795, 0.035],
	    easeOutExpo: [0.19, 1, 0.22, 1],
	    easeInOutExpo: [1, 0, 0, 1],
	    easeInCirc: [0.6, 0.04, 0.98, 0.335],
	    easeOutCirc: [0.075, 0.82, 0.165, 1],
	    easeInOutCirc: [0.785, 0.135, 0.15, 0.86],
	    easeInBack: [0.6, -0.28, 0.735, 0.045],
	    easeOutBack: [0.175, 0.885, 0.32, 1.275],
	    easeInOutBack: [0.68, -0.55, 0.265, 1.55]
	  };
	
	  Chartist.Svg.Easing = easingCubicBeziers;
	
	  /**
	   * This helper class is to wrap multiple `Chartist.Svg` elements into a list where you can call the `Chartist.Svg` functions on all elements in the list with one call. This is helpful when you'd like to perform calls with `Chartist.Svg` on multiple elements.
	   * An instance of this class is also returned by `Chartist.Svg.querySelectorAll`.
	   *
	   * @memberof Chartist.Svg
	   * @param {Array<Node>|NodeList} nodeList An Array of SVG DOM nodes or a SVG DOM NodeList (as returned by document.querySelectorAll)
	   * @constructor
	   */
	  function SvgList(nodeList) {
	    var list = this;
	
	    this.svgElements = [];
	    for(var i = 0; i < nodeList.length; i++) {
	      this.svgElements.push(new Chartist.Svg(nodeList[i]));
	    }
	
	    // Add delegation methods for Chartist.Svg
	    Object.keys(Chartist.Svg.prototype).filter(function(prototypeProperty) {
	      return ['constructor',
	          'parent',
	          'querySelector',
	          'querySelectorAll',
	          'replace',
	          'append',
	          'classes',
	          'height',
	          'width'].indexOf(prototypeProperty) === -1;
	    }).forEach(function(prototypeProperty) {
	      list[prototypeProperty] = function() {
	        var args = Array.prototype.slice.call(arguments, 0);
	        list.svgElements.forEach(function(element) {
	          Chartist.Svg.prototype[prototypeProperty].apply(element, args);
	        });
	        return list;
	      };
	    });
	  }
	
	  Chartist.Svg.List = Chartist.Class.extend({
	    constructor: SvgList
	  });
	}(window, document, Chartist));
	;/**
	 * Chartist SVG path module for SVG path description creation and modification.
	 *
	 * @module Chartist.Svg.Path
	 */
	/* global Chartist */
	(function(window, document, Chartist) {
	  'use strict';
	
	  /**
	   * Contains the descriptors of supported element types in a SVG path. Currently only move, line and curve are supported.
	   *
	   * @memberof Chartist.Svg.Path
	   * @type {Object}
	   */
	  var elementDescriptions = {
	    m: ['x', 'y'],
	    l: ['x', 'y'],
	    c: ['x1', 'y1', 'x2', 'y2', 'x', 'y'],
	    a: ['rx', 'ry', 'xAr', 'lAf', 'sf', 'x', 'y']
	  };
	
	  /**
	   * Default options for newly created SVG path objects.
	   *
	   * @memberof Chartist.Svg.Path
	   * @type {Object}
	   */
	  var defaultOptions = {
	    // The accuracy in digit count after the decimal point. This will be used to round numbers in the SVG path. If this option is set to false then no rounding will be performed.
	    accuracy: 3
	  };
	
	  function element(command, params, pathElements, pos, relative, data) {
	    var pathElement = Chartist.extend({
	      command: relative ? command.toLowerCase() : command.toUpperCase()
	    }, params, data ? { data: data } : {} );
	
	    pathElements.splice(pos, 0, pathElement);
	  }
	
	  function forEachParam(pathElements, cb) {
	    pathElements.forEach(function(pathElement, pathElementIndex) {
	      elementDescriptions[pathElement.command.toLowerCase()].forEach(function(paramName, paramIndex) {
	        cb(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
	      });
	    });
	  }
	
	  /**
	   * Used to construct a new path object.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Boolean} close If set to true then this path will be closed when stringified (with a Z at the end)
	   * @param {Object} options Options object that overrides the default objects. See default options for more details.
	   * @constructor
	   */
	  function SvgPath(close, options) {
	    this.pathElements = [];
	    this.pos = 0;
	    this.close = close;
	    this.options = Chartist.extend({}, defaultOptions, options);
	  }
	
	  /**
	   * Gets or sets the current position (cursor) inside of the path. You can move around the cursor freely but limited to 0 or the count of existing elements. All modifications with element functions will insert new elements at the position of this cursor.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Number} [pos] If a number is passed then the cursor is set to this position in the path element array.
	   * @return {Chartist.Svg.Path|Number} If the position parameter was passed then the return value will be the path object for easy call chaining. If no position parameter was passed then the current position is returned.
	   */
	  function position(pos) {
	    if(pos !== undefined) {
	      this.pos = Math.max(0, Math.min(this.pathElements.length, pos));
	      return this;
	    } else {
	      return this.pos;
	    }
	  }
	
	  /**
	   * Removes elements from the path starting at the current position.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Number} count Number of path elements that should be removed from the current position.
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function remove(count) {
	    this.pathElements.splice(this.pos, count);
	    return this;
	  }
	
	  /**
	   * Use this function to add a new move SVG path element.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Number} x The x coordinate for the move element.
	   * @param {Number} y The y coordinate for the move element.
	   * @param {Boolean} [relative] If set to true the move element will be created with relative coordinates (lowercase letter)
	   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function move(x, y, relative, data) {
	    element('M', {
	      x: +x,
	      y: +y
	    }, this.pathElements, this.pos++, relative, data);
	    return this;
	  }
	
	  /**
	   * Use this function to add a new line SVG path element.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Number} x The x coordinate for the line element.
	   * @param {Number} y The y coordinate for the line element.
	   * @param {Boolean} [relative] If set to true the line element will be created with relative coordinates (lowercase letter)
	   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function line(x, y, relative, data) {
	    element('L', {
	      x: +x,
	      y: +y
	    }, this.pathElements, this.pos++, relative, data);
	    return this;
	  }
	
	  /**
	   * Use this function to add a new curve SVG path element.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Number} x1 The x coordinate for the first control point of the bezier curve.
	   * @param {Number} y1 The y coordinate for the first control point of the bezier curve.
	   * @param {Number} x2 The x coordinate for the second control point of the bezier curve.
	   * @param {Number} y2 The y coordinate for the second control point of the bezier curve.
	   * @param {Number} x The x coordinate for the target point of the curve element.
	   * @param {Number} y The y coordinate for the target point of the curve element.
	   * @param {Boolean} [relative] If set to true the curve element will be created with relative coordinates (lowercase letter)
	   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function curve(x1, y1, x2, y2, x, y, relative, data) {
	    element('C', {
	      x1: +x1,
	      y1: +y1,
	      x2: +x2,
	      y2: +y2,
	      x: +x,
	      y: +y
	    }, this.pathElements, this.pos++, relative, data);
	    return this;
	  }
	
	  /**
	   * Use this function to add a new non-bezier curve SVG path element.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Number} rx The radius to be used for the x-axis of the arc.
	   * @param {Number} ry The radius to be used for the y-axis of the arc.
	   * @param {Number} xAr Defines the orientation of the arc
	   * @param {Number} lAf Large arc flag
	   * @param {Number} sf Sweep flag
	   * @param {Number} x The x coordinate for the target point of the curve element.
	   * @param {Number} y The y coordinate for the target point of the curve element.
	   * @param {Boolean} [relative] If set to true the curve element will be created with relative coordinates (lowercase letter)
	   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function arc(rx, ry, xAr, lAf, sf, x, y, relative, data) {
	    element('A', {
	      rx: +rx,
	      ry: +ry,
	      xAr: +xAr,
	      lAf: +lAf,
	      sf: +sf,
	      x: +x,
	      y: +y
	    }, this.pathElements, this.pos++, relative, data);
	    return this;
	  }
	
	  /**
	   * Parses an SVG path seen in the d attribute of path elements, and inserts the parsed elements into the existing path object at the current cursor position. Any closing path indicators (Z at the end of the path) will be ignored by the parser as this is provided by the close option in the options of the path object.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {String} path Any SVG path that contains move (m), line (l) or curve (c) components.
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function parse(path) {
	    // Parsing the SVG path string into an array of arrays [['M', '10', '10'], ['L', '100', '100']]
	    var chunks = path.replace(/([A-Za-z])([0-9])/g, '$1 $2')
	      .replace(/([0-9])([A-Za-z])/g, '$1 $2')
	      .split(/[\s,]+/)
	      .reduce(function(result, element) {
	        if(element.match(/[A-Za-z]/)) {
	          result.push([]);
	        }
	
	        result[result.length - 1].push(element);
	        return result;
	      }, []);
	
	    // If this is a closed path we remove the Z at the end because this is determined by the close option
	    if(chunks[chunks.length - 1][0].toUpperCase() === 'Z') {
	      chunks.pop();
	    }
	
	    // Using svgPathElementDescriptions to map raw path arrays into objects that contain the command and the parameters
	    // For example {command: 'M', x: '10', y: '10'}
	    var elements = chunks.map(function(chunk) {
	        var command = chunk.shift(),
	          description = elementDescriptions[command.toLowerCase()];
	
	        return Chartist.extend({
	          command: command
	        }, description.reduce(function(result, paramName, index) {
	          result[paramName] = +chunk[index];
	          return result;
	        }, {}));
	      });
	
	    // Preparing a splice call with the elements array as var arg params and insert the parsed elements at the current position
	    var spliceArgs = [this.pos, 0];
	    Array.prototype.push.apply(spliceArgs, elements);
	    Array.prototype.splice.apply(this.pathElements, spliceArgs);
	    // Increase the internal position by the element count
	    this.pos += elements.length;
	
	    return this;
	  }
	
	  /**
	   * This function renders to current SVG path object into a final SVG string that can be used in the d attribute of SVG path elements. It uses the accuracy option to round big decimals. If the close parameter was set in the constructor of this path object then a path closing Z will be appended to the output string.
	   *
	   * @memberof Chartist.Svg.Path
	   * @return {String}
	   */
	  function stringify() {
	    var accuracyMultiplier = Math.pow(10, this.options.accuracy);
	
	    return this.pathElements.reduce(function(path, pathElement) {
	        var params = elementDescriptions[pathElement.command.toLowerCase()].map(function(paramName) {
	          return this.options.accuracy ?
	            (Math.round(pathElement[paramName] * accuracyMultiplier) / accuracyMultiplier) :
	            pathElement[paramName];
	        }.bind(this));
	
	        return path + pathElement.command + params.join(',');
	      }.bind(this), '') + (this.close ? 'Z' : '');
	  }
	
	  /**
	   * Scales all elements in the current SVG path object. There is an individual parameter for each coordinate. Scaling will also be done for control points of curves, affecting the given coordinate.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Number} x The number which will be used to scale the x, x1 and x2 of all path elements.
	   * @param {Number} y The number which will be used to scale the y, y1 and y2 of all path elements.
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function scale(x, y) {
	    forEachParam(this.pathElements, function(pathElement, paramName) {
	      pathElement[paramName] *= paramName[0] === 'x' ? x : y;
	    });
	    return this;
	  }
	
	  /**
	   * Translates all elements in the current SVG path object. The translation is relative and there is an individual parameter for each coordinate. Translation will also be done for control points of curves, affecting the given coordinate.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Number} x The number which will be used to translate the x, x1 and x2 of all path elements.
	   * @param {Number} y The number which will be used to translate the y, y1 and y2 of all path elements.
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function translate(x, y) {
	    forEachParam(this.pathElements, function(pathElement, paramName) {
	      pathElement[paramName] += paramName[0] === 'x' ? x : y;
	    });
	    return this;
	  }
	
	  /**
	   * This function will run over all existing path elements and then loop over their attributes. The callback function will be called for every path element attribute that exists in the current path.
	   * The method signature of the callback function looks like this:
	   * ```javascript
	   * function(pathElement, paramName, pathElementIndex, paramIndex, pathElements)
	   * ```
	   * If something else than undefined is returned by the callback function, this value will be used to replace the old value. This allows you to build custom transformations of path objects that can't be achieved using the basic transformation functions scale and translate.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Function} transformFnc The callback function for the transformation. Check the signature in the function description.
	   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
	   */
	  function transform(transformFnc) {
	    forEachParam(this.pathElements, function(pathElement, paramName, pathElementIndex, paramIndex, pathElements) {
	      var transformed = transformFnc(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
	      if(transformed || transformed === 0) {
	        pathElement[paramName] = transformed;
	      }
	    });
	    return this;
	  }
	
	  /**
	   * This function clones a whole path object with all its properties. This is a deep clone and path element objects will also be cloned.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Boolean} [close] Optional option to set the new cloned path to closed. If not specified or false, the original path close option will be used.
	   * @return {Chartist.Svg.Path}
	   */
	  function clone(close) {
	    var c = new Chartist.Svg.Path(close || this.close);
	    c.pos = this.pos;
	    c.pathElements = this.pathElements.slice().map(function cloneElements(pathElement) {
	      return Chartist.extend({}, pathElement);
	    });
	    c.options = Chartist.extend({}, this.options);
	    return c;
	  }
	
	  /**
	   * Split a Svg.Path object by a specific command in the path chain. The path chain will be split and an array of newly created paths objects will be returned. This is useful if you'd like to split an SVG path by it's move commands, for example, in order to isolate chunks of drawings.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {String} command The command you'd like to use to split the path
	   * @return {Array<Chartist.Svg.Path>}
	   */
	  function splitByCommand(command) {
	    var split = [
	      new Chartist.Svg.Path()
	    ];
	
	    this.pathElements.forEach(function(pathElement) {
	      if(pathElement.command === command.toUpperCase() && split[split.length - 1].pathElements.length !== 0) {
	        split.push(new Chartist.Svg.Path());
	      }
	
	      split[split.length - 1].pathElements.push(pathElement);
	    });
	
	    return split;
	  }
	
	  /**
	   * This static function on `Chartist.Svg.Path` is joining multiple paths together into one paths.
	   *
	   * @memberof Chartist.Svg.Path
	   * @param {Array<Chartist.Svg.Path>} paths A list of paths to be joined together. The order is important.
	   * @param {boolean} close If the newly created path should be a closed path
	   * @param {Object} options Path options for the newly created path.
	   * @return {Chartist.Svg.Path}
	   */
	
	  function join(paths, close, options) {
	    var joinedPath = new Chartist.Svg.Path(close, options);
	    for(var i = 0; i < paths.length; i++) {
	      var path = paths[i];
	      for(var j = 0; j < path.pathElements.length; j++) {
	        joinedPath.pathElements.push(path.pathElements[j]);
	      }
	    }
	    return joinedPath;
	  }
	
	  Chartist.Svg.Path = Chartist.Class.extend({
	    constructor: SvgPath,
	    position: position,
	    remove: remove,
	    move: move,
	    line: line,
	    curve: curve,
	    arc: arc,
	    scale: scale,
	    translate: translate,
	    transform: transform,
	    parse: parse,
	    stringify: stringify,
	    clone: clone,
	    splitByCommand: splitByCommand
	  });
	
	  Chartist.Svg.Path.elementDescriptions = elementDescriptions;
	  Chartist.Svg.Path.join = join;
	}(window, document, Chartist));
	;/* global Chartist */
	(function (window, document, Chartist) {
	  'use strict';
	
	  var axisUnits = {
	    x: {
	      pos: 'x',
	      len: 'width',
	      dir: 'horizontal',
	      rectStart: 'x1',
	      rectEnd: 'x2',
	      rectOffset: 'y2'
	    },
	    y: {
	      pos: 'y',
	      len: 'height',
	      dir: 'vertical',
	      rectStart: 'y2',
	      rectEnd: 'y1',
	      rectOffset: 'x1'
	    }
	  };
	
	  function Axis(units, chartRect, ticks, options) {
	    this.units = units;
	    this.counterUnits = units === axisUnits.x ? axisUnits.y : axisUnits.x;
	    this.chartRect = chartRect;
	    this.axisLength = chartRect[units.rectEnd] - chartRect[units.rectStart];
	    this.gridOffset = chartRect[units.rectOffset];
	    this.ticks = ticks;
	    this.options = options;
	  }
	
	  function createGridAndLabels(gridGroup, labelGroup, useForeignObject, chartOptions, eventEmitter) {
	    var axisOptions = chartOptions['axis' + this.units.pos.toUpperCase()];
	    var projectedValues = this.ticks.map(this.projectValue.bind(this));
	    var labelValues = this.ticks.map(axisOptions.labelInterpolationFnc);
	
	    projectedValues.forEach(function(projectedValue, index) {
	      var labelOffset = {
	        x: 0,
	        y: 0
	      };
	
	      // TODO: Find better solution for solving this problem
	      // Calculate how much space we have available for the label
	      var labelLength;
	      if(projectedValues[index + 1]) {
	        // If we still have one label ahead, we can calculate the distance to the next tick / label
	        labelLength = projectedValues[index + 1] - projectedValue;
	      } else {
	        // If we don't have a label ahead and we have only two labels in total, we just take the remaining distance to
	        // on the whole axis length. We limit that to a minimum of 30 pixel, so that labels close to the border will
	        // still be visible inside of the chart padding.
	        labelLength = Math.max(this.axisLength - projectedValue, 30);
	      }
	
	      // Skip grid lines and labels where interpolated label values are falsey (execpt for 0)
	      if(Chartist.isFalseyButZero(labelValues[index]) && labelValues[index] !== '') {
	        return;
	      }
	
	      // Transform to global coordinates using the chartRect
	      // We also need to set the label offset for the createLabel function
	      if(this.units.pos === 'x') {
	        projectedValue = this.chartRect.x1 + projectedValue;
	        labelOffset.x = chartOptions.axisX.labelOffset.x;
	
	        // If the labels should be positioned in start position (top side for vertical axis) we need to set a
	        // different offset as for positioned with end (bottom)
	        if(chartOptions.axisX.position === 'start') {
	          labelOffset.y = this.chartRect.padding.top + chartOptions.axisX.labelOffset.y + (useForeignObject ? 5 : 20);
	        } else {
	          labelOffset.y = this.chartRect.y1 + chartOptions.axisX.labelOffset.y + (useForeignObject ? 5 : 20);
	        }
	      } else {
	        projectedValue = this.chartRect.y1 - projectedValue;
	        labelOffset.y = chartOptions.axisY.labelOffset.y - (useForeignObject ? labelLength : 0);
	
	        // If the labels should be positioned in start position (left side for horizontal axis) we need to set a
	        // different offset as for positioned with end (right side)
	        if(chartOptions.axisY.position === 'start') {
	          labelOffset.x = useForeignObject ? this.chartRect.padding.left + chartOptions.axisY.labelOffset.x : this.chartRect.x1 - 10;
	        } else {
	          labelOffset.x = this.chartRect.x2 + chartOptions.axisY.labelOffset.x + 10;
	        }
	      }
	
	      if(axisOptions.showGrid) {
	        Chartist.createGrid(projectedValue, index, this, this.gridOffset, this.chartRect[this.counterUnits.len](), gridGroup, [
	          chartOptions.classNames.grid,
	          chartOptions.classNames[this.units.dir]
	        ], eventEmitter);
	      }
	
	      if(axisOptions.showLabel) {
	        Chartist.createLabel(projectedValue, labelLength, index, labelValues, this, axisOptions.offset, labelOffset, labelGroup, [
	          chartOptions.classNames.label,
	          chartOptions.classNames[this.units.dir],
	          chartOptions.classNames[axisOptions.position]
	        ], useForeignObject, eventEmitter);
	      }
	    }.bind(this));
	  }
	
	  Chartist.Axis = Chartist.Class.extend({
	    constructor: Axis,
	    createGridAndLabels: createGridAndLabels,
	    projectValue: function(value, index, data) {
	      throw new Error('Base axis can\'t be instantiated!');
	    }
	  });
	
	  Chartist.Axis.units = axisUnits;
	
	}(window, document, Chartist));
	;/**
	 * The auto scale axis uses standard linear scale projection of values along an axis. It uses order of magnitude to find a scale automatically and evaluates the available space in order to find the perfect amount of ticks for your chart.
	 * **Options**
	 * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
	 * ```javascript
	 * var options = {
	 *   // If high is specified then the axis will display values explicitly up to this value and the computed maximum from the data is ignored
	 *   high: 100,
	 *   // If low is specified then the axis will display values explicitly down to this value and the computed minimum from the data is ignored
	 *   low: 0,
	 *   // This option will be used when finding the right scale division settings. The amount of ticks on the scale will be determined so that as many ticks as possible will be displayed, while not violating this minimum required space (in pixel).
	 *   scaleMinSpace: 20,
	 *   // Can be set to true or false. If set to true, the scale will be generated with whole numbers only.
	 *   onlyInteger: true,
	 *   // The reference value can be used to make sure that this value will always be on the chart. This is especially useful on bipolar charts where the bipolar center always needs to be part of the chart.
	 *   referenceValue: 5
	 * };
	 * ```
	 *
	 * @module Chartist.AutoScaleAxis
	 */
	/* global Chartist */
	(function (window, document, Chartist) {
	  'use strict';
	
	  function AutoScaleAxis(axisUnit, data, chartRect, options) {
	    // Usually we calculate highLow based on the data but this can be overriden by a highLow object in the options
	    var highLow = options.highLow || Chartist.getHighLow(data.normalized, options, axisUnit.pos);
	    this.bounds = Chartist.getBounds(chartRect[axisUnit.rectEnd] - chartRect[axisUnit.rectStart], highLow, options.scaleMinSpace || 20, options.onlyInteger);
	    this.range = {
	      min: this.bounds.min,
	      max: this.bounds.max
	    };
	
	    Chartist.AutoScaleAxis.super.constructor.call(this,
	      axisUnit,
	      chartRect,
	      this.bounds.values,
	      options);
	  }
	
	  function projectValue(value) {
	    return this.axisLength * (+Chartist.getMultiValue(value, this.units.pos) - this.bounds.min) / this.bounds.range;
	  }
	
	  Chartist.AutoScaleAxis = Chartist.Axis.extend({
	    constructor: AutoScaleAxis,
	    projectValue: projectValue
	  });
	
	}(window, document, Chartist));
	;/**
	 * The fixed scale axis uses standard linear projection of values along an axis. It makes use of a divisor option to divide the range provided from the minimum and maximum value or the options high and low that will override the computed minimum and maximum.
	 * **Options**
	 * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
	 * ```javascript
	 * var options = {
	 *   // If high is specified then the axis will display values explicitly up to this value and the computed maximum from the data is ignored
	 *   high: 100,
	 *   // If low is specified then the axis will display values explicitly down to this value and the computed minimum from the data is ignored
	 *   low: 0,
	 *   // If specified then the value range determined from minimum to maximum (or low and high) will be divided by this number and ticks will be generated at those division points. The default divisor is 1.
	 *   divisor: 4,
	 *   // If ticks is explicitly set, then the axis will not compute the ticks with the divisor, but directly use the data in ticks to determine at what points on the axis a tick need to be generated.
	 *   ticks: [1, 10, 20, 30]
	 * };
	 * ```
	 *
	 * @module Chartist.FixedScaleAxis
	 */
	/* global Chartist */
	(function (window, document, Chartist) {
	  'use strict';
	
	  function FixedScaleAxis(axisUnit, data, chartRect, options) {
	    var highLow = options.highLow || Chartist.getHighLow(data.normalized, options, axisUnit.pos);
	    this.divisor = options.divisor || 1;
	    this.ticks = options.ticks || Chartist.times(this.divisor).map(function(value, index) {
	      return highLow.low + (highLow.high - highLow.low) / this.divisor * index;
	    }.bind(this));
	    this.ticks.sort(function(a, b) {
	      return a - b;
	    });
	    this.range = {
	      min: highLow.low,
	      max: highLow.high
	    };
	
	    Chartist.FixedScaleAxis.super.constructor.call(this,
	      axisUnit,
	      chartRect,
	      this.ticks,
	      options);
	
	    this.stepLength = this.axisLength / this.divisor;
	  }
	
	  function projectValue(value) {
	    return this.axisLength * (+Chartist.getMultiValue(value, this.units.pos) - this.range.min) / (this.range.max - this.range.min);
	  }
	
	  Chartist.FixedScaleAxis = Chartist.Axis.extend({
	    constructor: FixedScaleAxis,
	    projectValue: projectValue
	  });
	
	}(window, document, Chartist));
	;/**
	 * The step axis for step based charts like bar chart or step based line charts. It uses a fixed amount of ticks that will be equally distributed across the whole axis length. The projection is done using the index of the data value rather than the value itself and therefore it's only useful for distribution purpose.
	 * **Options**
	 * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
	 * ```javascript
	 * var options = {
	 *   // Ticks to be used to distribute across the axis length. As this axis type relies on the index of the value rather than the value, arbitrary data that can be converted to a string can be used as ticks.
	 *   ticks: ['One', 'Two', 'Three'],
	 *   // If set to true the full width will be used to distribute the values where the last value will be at the maximum of the axis length. If false the spaces between the ticks will be evenly distributed instead.
	 *   stretch: true
	 * };
	 * ```
	 *
	 * @module Chartist.StepAxis
	 */
	/* global Chartist */
	(function (window, document, Chartist) {
	  'use strict';
	
	  function StepAxis(axisUnit, data, chartRect, options) {
	    Chartist.StepAxis.super.constructor.call(this,
	      axisUnit,
	      chartRect,
	      options.ticks,
	      options);
	
	    this.stepLength = this.axisLength / (options.ticks.length - (options.stretch ? 1 : 0));
	  }
	
	  function projectValue(value, index) {
	    return this.stepLength * index;
	  }
	
	  Chartist.StepAxis = Chartist.Axis.extend({
	    constructor: StepAxis,
	    projectValue: projectValue
	  });
	
	}(window, document, Chartist));
	;/**
	 * The Chartist line chart can be used to draw Line or Scatter charts. If used in the browser you can access the global `Chartist` namespace where you find the `Line` function as a main entry point.
	 *
	 * For examples on how to use the line chart please check the examples of the `Chartist.Line` method.
	 *
	 * @module Chartist.Line
	 */
	/* global Chartist */
	(function(window, document, Chartist){
	  'use strict';
	
	  /**
	   * Default options in line charts. Expand the code view to see a detailed list of options with comments.
	   *
	   * @memberof Chartist.Line
	   */
	  var defaultOptions = {
	    // Options for X-Axis
	    axisX: {
	      // The offset of the labels to the chart area
	      offset: 30,
	      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
	      position: 'end',
	      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
	      labelOffset: {
	        x: 0,
	        y: 0
	      },
	      // If labels should be shown or not
	      showLabel: true,
	      // If the axis grid should be drawn or not
	      showGrid: true,
	      // Interpolation function that allows you to intercept the value from the axis label
	      labelInterpolationFnc: Chartist.noop,
	      // Set the axis type to be used to project values on this axis. If not defined, Chartist.StepAxis will be used for the X-Axis, where the ticks option will be set to the labels in the data and the stretch option will be set to the global fullWidth option. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
	      type: undefined
	    },
	    // Options for Y-Axis
	    axisY: {
	      // The offset of the labels to the chart area
	      offset: 40,
	      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
	      position: 'start',
	      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
	      labelOffset: {
	        x: 0,
	        y: 0
	      },
	      // If labels should be shown or not
	      showLabel: true,
	      // If the axis grid should be drawn or not
	      showGrid: true,
	      // Interpolation function that allows you to intercept the value from the axis label
	      labelInterpolationFnc: Chartist.noop,
	      // Set the axis type to be used to project values on this axis. If not defined, Chartist.AutoScaleAxis will be used for the Y-Axis, where the high and low options will be set to the global high and low options. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
	      type: undefined,
	      // This value specifies the minimum height in pixel of the scale steps
	      scaleMinSpace: 20,
	      // Use only integer values (whole numbers) for the scale steps
	      onlyInteger: false
	    },
	    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
	    width: undefined,
	    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
	    height: undefined,
	    // If the line should be drawn or not
	    showLine: true,
	    // If dots should be drawn or not
	    showPoint: true,
	    // If the line chart should draw an area
	    showArea: false,
	    // The base for the area chart that will be used to close the area shape (is normally 0)
	    areaBase: 0,
	    // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions available in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
	    lineSmooth: true,
	    // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
	    low: undefined,
	    // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
	    high: undefined,
	    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
	    chartPadding: {
	      top: 15,
	      right: 15,
	      bottom: 5,
	      left: 10
	    },
	    // When set to true, the last grid line on the x-axis is not drawn and the chart elements will expand to the full available width of the chart. For the last label to be drawn correctly you might need to add chart padding or offset the last label with a draw event handler.
	    fullWidth: false,
	    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
	    reverseData: false,
	    // Override the class names that get used to generate the SVG structure of the chart
	    classNames: {
	      chart: 'ct-chart-line',
	      label: 'ct-label',
	      labelGroup: 'ct-labels',
	      series: 'ct-series',
	      line: 'ct-line',
	      point: 'ct-point',
	      area: 'ct-area',
	      grid: 'ct-grid',
	      gridGroup: 'ct-grids',
	      vertical: 'ct-vertical',
	      horizontal: 'ct-horizontal',
	      start: 'ct-start',
	      end: 'ct-end'
	    }
	  };
	
	  /**
	   * Creates a new chart
	   *
	   */
	  function createChart(options) {
	    this.data = Chartist.normalizeData(this.data);
	    var data = {
	      raw: this.data,
	      normalized: Chartist.getDataArray(this.data, options.reverseData, true)
	    };
	
	    // Create new svg object
	    this.svg = Chartist.createSvg(this.container, options.width, options.height, options.classNames.chart);
	    // Create groups for labels, grid and series
	    var gridGroup = this.svg.elem('g').addClass(options.classNames.gridGroup);
	    var seriesGroup = this.svg.elem('g');
	    var labelGroup = this.svg.elem('g').addClass(options.classNames.labelGroup);
	
	    var chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
	    var axisX, axisY;
	
	    if(options.axisX.type === undefined) {
	      axisX = new Chartist.StepAxis(Chartist.Axis.units.x, data, chartRect, Chartist.extend({}, options.axisX, {
	        ticks: data.raw.labels,
	        stretch: options.fullWidth
	      }));
	    } else {
	      axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data, chartRect, options.axisX);
	    }
	
	    if(options.axisY.type === undefined) {
	      axisY = new Chartist.AutoScaleAxis(Chartist.Axis.units.y, data, chartRect, Chartist.extend({}, options.axisY, {
	        high: Chartist.isNum(options.high) ? options.high : options.axisY.high,
	        low: Chartist.isNum(options.low) ? options.low : options.axisY.low
	      }));
	    } else {
	      axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data, chartRect, options.axisY);
	    }
	
	    axisX.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
	    axisY.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
	
	    // Draw the series
	    data.raw.series.forEach(function(series, seriesIndex) {
	      var seriesElement = seriesGroup.elem('g');
	
	      // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
	      seriesElement.attr({
	        'ct:series-name': series.name,
	        'ct:meta': Chartist.serialize(series.meta)
	      });
	
	      // Use series class from series data or if not set generate one
	      seriesElement.addClass([
	        options.classNames.series,
	        (series.className || options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex))
	      ].join(' '));
	
	      var pathCoordinates = [],
	        pathData = [];
	
	      data.normalized[seriesIndex].forEach(function(value, valueIndex) {
	        var p = {
	          x: chartRect.x1 + axisX.projectValue(value, valueIndex, data.normalized[seriesIndex]),
	          y: chartRect.y1 - axisY.projectValue(value, valueIndex, data.normalized[seriesIndex])
	        };
	        pathCoordinates.push(p.x, p.y);
	        pathData.push({
	          value: value,
	          valueIndex: valueIndex,
	          meta: Chartist.getMetaData(series, valueIndex)
	        });
	      }.bind(this));
	
	      var seriesOptions = {
	        lineSmooth: Chartist.getSeriesOption(series, options, 'lineSmooth'),
	        showPoint: Chartist.getSeriesOption(series, options, 'showPoint'),
	        showLine: Chartist.getSeriesOption(series, options, 'showLine'),
	        showArea: Chartist.getSeriesOption(series, options, 'showArea'),
	        areaBase: Chartist.getSeriesOption(series, options, 'areaBase')
	      };
	
	      var smoothing = typeof seriesOptions.lineSmooth === 'function' ?
	        seriesOptions.lineSmooth : (seriesOptions.lineSmooth ? Chartist.Interpolation.monotoneCubic() : Chartist.Interpolation.none());
	      // Interpolating path where pathData will be used to annotate each path element so we can trace back the original
	      // index, value and meta data
	      var path = smoothing(pathCoordinates, pathData);
	
	      // If we should show points we need to create them now to avoid secondary loop
	      // Points are drawn from the pathElements returned by the interpolation function
	      // Small offset for Firefox to render squares correctly
	      if (seriesOptions.showPoint) {
	
	        path.pathElements.forEach(function(pathElement) {
	          var point = seriesElement.elem('line', {
	            x1: pathElement.x,
	            y1: pathElement.y,
	            x2: pathElement.x + 0.01,
	            y2: pathElement.y
	          }, options.classNames.point).attr({
	            'ct:value': [pathElement.data.value.x, pathElement.data.value.y].filter(Chartist.isNum).join(','),
	            'ct:meta': pathElement.data.meta
	          });
	
	          this.eventEmitter.emit('draw', {
	            type: 'point',
	            value: pathElement.data.value,
	            index: pathElement.data.valueIndex,
	            meta: pathElement.data.meta,
	            series: series,
	            seriesIndex: seriesIndex,
	            axisX: axisX,
	            axisY: axisY,
	            group: seriesElement,
	            element: point,
	            x: pathElement.x,
	            y: pathElement.y
	          });
	        }.bind(this));
	      }
	
	      if(seriesOptions.showLine) {
	        var line = seriesElement.elem('path', {
	          d: path.stringify()
	        }, options.classNames.line, true);
	
	        this.eventEmitter.emit('draw', {
	          type: 'line',
	          values: data.normalized[seriesIndex],
	          path: path.clone(),
	          chartRect: chartRect,
	          index: seriesIndex,
	          series: series,
	          seriesIndex: seriesIndex,
	          axisX: axisX,
	          axisY: axisY,
	          group: seriesElement,
	          element: line
	        });
	      }
	
	      // Area currently only works with axes that support a range!
	      if(seriesOptions.showArea && axisY.range) {
	        // If areaBase is outside the chart area (< min or > max) we need to set it respectively so that
	        // the area is not drawn outside the chart area.
	        var areaBase = Math.max(Math.min(seriesOptions.areaBase, axisY.range.max), axisY.range.min);
	
	        // We project the areaBase value into screen coordinates
	        var areaBaseProjected = chartRect.y1 - axisY.projectValue(areaBase);
	
	        // In order to form the area we'll first split the path by move commands so we can chunk it up into segments
	        path.splitByCommand('M').filter(function onlySolidSegments(pathSegment) {
	          // We filter only "solid" segments that contain more than one point. Otherwise there's no need for an area
	          return pathSegment.pathElements.length > 1;
	        }).map(function convertToArea(solidPathSegments) {
	          // Receiving the filtered solid path segments we can now convert those segments into fill areas
	          var firstElement = solidPathSegments.pathElements[0];
	          var lastElement = solidPathSegments.pathElements[solidPathSegments.pathElements.length - 1];
	
	          // Cloning the solid path segment with closing option and removing the first move command from the clone
	          // We then insert a new move that should start at the area base and draw a straight line up or down
	          // at the end of the path we add an additional straight line to the projected area base value
	          // As the closing option is set our path will be automatically closed
	          return solidPathSegments.clone(true)
	            .position(0)
	            .remove(1)
	            .move(firstElement.x, areaBaseProjected)
	            .line(firstElement.x, firstElement.y)
	            .position(solidPathSegments.pathElements.length + 1)
	            .line(lastElement.x, areaBaseProjected);
	
	        }).forEach(function createArea(areaPath) {
	          // For each of our newly created area paths, we'll now create path elements by stringifying our path objects
	          // and adding the created DOM elements to the correct series group
	          var area = seriesElement.elem('path', {
	            d: areaPath.stringify()
	          }, options.classNames.area, true);
	
	          // Emit an event for each area that was drawn
	          this.eventEmitter.emit('draw', {
	            type: 'area',
	            values: data.normalized[seriesIndex],
	            path: areaPath.clone(),
	            series: series,
	            seriesIndex: seriesIndex,
	            axisX: axisX,
	            axisY: axisY,
	            chartRect: chartRect,
	            index: seriesIndex,
	            group: seriesElement,
	            element: area
	          });
	        }.bind(this));
	      }
	    }.bind(this));
	
	    this.eventEmitter.emit('created', {
	      bounds: axisY.bounds,
	      chartRect: chartRect,
	      axisX: axisX,
	      axisY: axisY,
	      svg: this.svg,
	      options: options
	    });
	  }
	
	  /**
	   * This method creates a new line chart.
	   *
	   * @memberof Chartist.Line
	   * @param {String|Node} query A selector query string or directly a DOM element
	   * @param {Object} data The data object that needs to consist of a labels and a series array
	   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
	   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
	   * @return {Object} An object which exposes the API for the created chart
	   *
	   * @example
	   * // Create a simple line chart
	   * var data = {
	   *   // A labels array that can contain any sort of values
	   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
	   *   // Our series array that contains series objects or in this case series data arrays
	   *   series: [
	   *     [5, 2, 4, 2, 0]
	   *   ]
	   * };
	   *
	   * // As options we currently only set a static size of 300x200 px
	   * var options = {
	   *   width: '300px',
	   *   height: '200px'
	   * };
	   *
	   * // In the global name space Chartist we call the Line function to initialize a line chart. As a first parameter we pass in a selector where we would like to get our chart created. Second parameter is the actual data object and as a third parameter we pass in our options
	   * new Chartist.Line('.ct-chart', data, options);
	   *
	   * @example
	   * // Use specific interpolation function with configuration from the Chartist.Interpolation module
	   *
	   * var chart = new Chartist.Line('.ct-chart', {
	   *   labels: [1, 2, 3, 4, 5],
	   *   series: [
	   *     [1, 1, 8, 1, 7]
	   *   ]
	   * }, {
	   *   lineSmooth: Chartist.Interpolation.cardinal({
	   *     tension: 0.2
	   *   })
	   * });
	   *
	   * @example
	   * // Create a line chart with responsive options
	   *
	   * var data = {
	   *   // A labels array that can contain any sort of values
	   *   labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
	   *   // Our series array that contains series objects or in this case series data arrays
	   *   series: [
	   *     [5, 2, 4, 2, 0]
	   *   ]
	   * };
	   *
	   * // In addition to the regular options we specify responsive option overrides that will override the default configutation based on the matching media queries.
	   * var responsiveOptions = [
	   *   ['screen and (min-width: 641px) and (max-width: 1024px)', {
	   *     showPoint: false,
	   *     axisX: {
	   *       labelInterpolationFnc: function(value) {
	   *         // Will return Mon, Tue, Wed etc. on medium screens
	   *         return value.slice(0, 3);
	   *       }
	   *     }
	   *   }],
	   *   ['screen and (max-width: 640px)', {
	   *     showLine: false,
	   *     axisX: {
	   *       labelInterpolationFnc: function(value) {
	   *         // Will return M, T, W etc. on small screens
	   *         return value[0];
	   *       }
	   *     }
	   *   }]
	   * ];
	   *
	   * new Chartist.Line('.ct-chart', data, null, responsiveOptions);
	   *
	   */
	  function Line(query, data, options, responsiveOptions) {
	    Chartist.Line.super.constructor.call(this,
	      query,
	      data,
	      defaultOptions,
	      Chartist.extend({}, defaultOptions, options),
	      responsiveOptions);
	  }
	
	  // Creating line chart type in Chartist namespace
	  Chartist.Line = Chartist.Base.extend({
	    constructor: Line,
	    createChart: createChart
	  });
	
	}(window, document, Chartist));
	;/**
	 * The bar chart module of Chartist that can be used to draw unipolar or bipolar bar and grouped bar charts.
	 *
	 * @module Chartist.Bar
	 */
	/* global Chartist */
	(function(window, document, Chartist){
	  'use strict';
	
	  /**
	   * Default options in bar charts. Expand the code view to see a detailed list of options with comments.
	   *
	   * @memberof Chartist.Bar
	   */
	  var defaultOptions = {
	    // Options for X-Axis
	    axisX: {
	      // The offset of the chart drawing area to the border of the container
	      offset: 30,
	      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
	      position: 'end',
	      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
	      labelOffset: {
	        x: 0,
	        y: 0
	      },
	      // If labels should be shown or not
	      showLabel: true,
	      // If the axis grid should be drawn or not
	      showGrid: true,
	      // Interpolation function that allows you to intercept the value from the axis label
	      labelInterpolationFnc: Chartist.noop,
	      // This value specifies the minimum width in pixel of the scale steps
	      scaleMinSpace: 30,
	      // Use only integer values (whole numbers) for the scale steps
	      onlyInteger: false
	    },
	    // Options for Y-Axis
	    axisY: {
	      // The offset of the chart drawing area to the border of the container
	      offset: 40,
	      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
	      position: 'start',
	      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
	      labelOffset: {
	        x: 0,
	        y: 0
	      },
	      // If labels should be shown or not
	      showLabel: true,
	      // If the axis grid should be drawn or not
	      showGrid: true,
	      // Interpolation function that allows you to intercept the value from the axis label
	      labelInterpolationFnc: Chartist.noop,
	      // This value specifies the minimum height in pixel of the scale steps
	      scaleMinSpace: 20,
	      // Use only integer values (whole numbers) for the scale steps
	      onlyInteger: false
	    },
	    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
	    width: undefined,
	    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
	    height: undefined,
	    // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
	    high: undefined,
	    // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
	    low: undefined,
	    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
	    chartPadding: {
	      top: 15,
	      right: 15,
	      bottom: 5,
	      left: 10
	    },
	    // Specify the distance in pixel of bars in a group
	    seriesBarDistance: 15,
	    // If set to true this property will cause the series bars to be stacked. Check the `stackMode` option for further stacking options.
	    stackBars: false,
	    // If set to 'overlap' this property will force the stacked bars to draw from the zero line.
	    // If set to 'accumulate' this property will form a total for each series point. This will also influence the y-axis and the overall bounds of the chart. In stacked mode the seriesBarDistance property will have no effect.
	    stackMode: 'accumulate',
	    // Inverts the axes of the bar chart in order to draw a horizontal bar chart. Be aware that you also need to invert your axis settings as the Y Axis will now display the labels and the X Axis the values.
	    horizontalBars: false,
	    // If set to true then each bar will represent a series and the data array is expected to be a one dimensional array of data values rather than a series array of series. This is useful if the bar chart should represent a profile rather than some data over time.
	    distributeSeries: false,
	    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
	    reverseData: false,
	    // Override the class names that get used to generate the SVG structure of the chart
	    classNames: {
	      chart: 'ct-chart-bar',
	      horizontalBars: 'ct-horizontal-bars',
	      label: 'ct-label',
	      labelGroup: 'ct-labels',
	      series: 'ct-series',
	      bar: 'ct-bar',
	      grid: 'ct-grid',
	      gridGroup: 'ct-grids',
	      vertical: 'ct-vertical',
	      horizontal: 'ct-horizontal',
	      start: 'ct-start',
	      end: 'ct-end'
	    }
	  };
	
	  /**
	   * Creates a new chart
	   *
	   */
	  function createChart(options) {
	    this.data = Chartist.normalizeData(this.data);
	    var data = {
	      raw: this.data,
	      normalized: options.distributeSeries ? Chartist.getDataArray(this.data, options.reverseData, options.horizontalBars ? 'x' : 'y').map(function(value) {
	        return [value];
	      }) : Chartist.getDataArray(this.data, options.reverseData, options.horizontalBars ? 'x' : 'y')
	    };
	
	    var highLow;
	
	    // Create new svg element
	    this.svg = Chartist.createSvg(
	      this.container,
	      options.width,
	      options.height,
	      options.classNames.chart + (options.horizontalBars ? ' ' + options.classNames.horizontalBars : '')
	    );
	
	    // Drawing groups in correct order
	    var gridGroup = this.svg.elem('g').addClass(options.classNames.gridGroup);
	    var seriesGroup = this.svg.elem('g');
	    var labelGroup = this.svg.elem('g').addClass(options.classNames.labelGroup);
	
	    if(options.stackBars && data.normalized.length !== 0) {
	      // If stacked bars we need to calculate the high low from stacked values from each series
	      var serialSums = Chartist.serialMap(data.normalized, function serialSums() {
	        return Array.prototype.slice.call(arguments).map(function(value) {
	          return value;
	        }).reduce(function(prev, curr) {
	          return {
	            x: prev.x + (curr && curr.x) || 0,
	            y: prev.y + (curr && curr.y) || 0
	          };
	        }, {x: 0, y: 0});
	      });
	
	      highLow = Chartist.getHighLow([serialSums], Chartist.extend({}, options, {
	        referenceValue: 0
	      }), options.horizontalBars ? 'x' : 'y');
	    } else {
	      highLow = Chartist.getHighLow(data.normalized, Chartist.extend({}, options, {
	        referenceValue: 0
	      }), options.horizontalBars ? 'x' : 'y');
	    }
	    // Overrides of high / low from settings
	    highLow.high = +options.high || (options.high === 0 ? 0 : highLow.high);
	    highLow.low = +options.low || (options.low === 0 ? 0 : highLow.low);
	
	    var chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
	
	    var valueAxis,
	      labelAxisTicks,
	      labelAxis,
	      axisX,
	      axisY;
	
	    // We need to set step count based on some options combinations
	    if(options.distributeSeries && options.stackBars) {
	      // If distributed series are enabled and bars need to be stacked, we'll only have one bar and therefore should
	      // use only the first label for the step axis
	      labelAxisTicks = data.raw.labels.slice(0, 1);
	    } else {
	      // If distributed series are enabled but stacked bars aren't, we should use the series labels
	      // If we are drawing a regular bar chart with two dimensional series data, we just use the labels array
	      // as the bars are normalized
	      labelAxisTicks = data.raw.labels;
	    }
	
	    // Set labelAxis and valueAxis based on the horizontalBars setting. This setting will flip the axes if necessary.
	    if(options.horizontalBars) {
	      if(options.axisX.type === undefined) {
	        valueAxis = axisX = new Chartist.AutoScaleAxis(Chartist.Axis.units.x, data, chartRect, Chartist.extend({}, options.axisX, {
	          highLow: highLow,
	          referenceValue: 0
	        }));
	      } else {
	        valueAxis = axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data, chartRect, Chartist.extend({}, options.axisX, {
	          highLow: highLow,
	          referenceValue: 0
	        }));
	      }
	
	      if(options.axisY.type === undefined) {
	        labelAxis = axisY = new Chartist.StepAxis(Chartist.Axis.units.y, data, chartRect, {
	          ticks: labelAxisTicks
	        });
	      } else {
	        labelAxis = axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data, chartRect, options.axisY);
	      }
	    } else {
	      if(options.axisX.type === undefined) {
	        labelAxis = axisX = new Chartist.StepAxis(Chartist.Axis.units.x, data, chartRect, {
	          ticks: labelAxisTicks
	        });
	      } else {
	        labelAxis = axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data, chartRect, options.axisX);
	      }
	
	      if(options.axisY.type === undefined) {
	        valueAxis = axisY = new Chartist.AutoScaleAxis(Chartist.Axis.units.y, data, chartRect, Chartist.extend({}, options.axisY, {
	          highLow: highLow,
	          referenceValue: 0
	        }));
	      } else {
	        valueAxis = axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data, chartRect, Chartist.extend({}, options.axisY, {
	          highLow: highLow,
	          referenceValue: 0
	        }));
	      }
	    }
	
	    // Projected 0 point
	    var zeroPoint = options.horizontalBars ? (chartRect.x1 + valueAxis.projectValue(0)) : (chartRect.y1 - valueAxis.projectValue(0));
	    // Used to track the screen coordinates of stacked bars
	    var stackedBarValues = [];
	
	    labelAxis.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
	    valueAxis.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
	
	    // Draw the series
	    data.raw.series.forEach(function(series, seriesIndex) {
	      // Calculating bi-polar value of index for seriesOffset. For i = 0..4 biPol will be -1.5, -0.5, 0.5, 1.5 etc.
	      var biPol = seriesIndex - (data.raw.series.length - 1) / 2;
	      // Half of the period width between vertical grid lines used to position bars
	      var periodHalfLength;
	      // Current series SVG element
	      var seriesElement;
	
	      // We need to set periodHalfLength based on some options combinations
	      if(options.distributeSeries && !options.stackBars) {
	        // If distributed series are enabled but stacked bars aren't, we need to use the length of the normaizedData array
	        // which is the series count and divide by 2
	        periodHalfLength = labelAxis.axisLength / data.normalized.length / 2;
	      } else if(options.distributeSeries && options.stackBars) {
	        // If distributed series and stacked bars are enabled we'll only get one bar so we should just divide the axis
	        // length by 2
	        periodHalfLength = labelAxis.axisLength / 2;
	      } else {
	        // On regular bar charts we should just use the series length
	        periodHalfLength = labelAxis.axisLength / data.normalized[seriesIndex].length / 2;
	      }
	
	      // Adding the series group to the series element
	      seriesElement = seriesGroup.elem('g');
	
	      // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
	      seriesElement.attr({
	        'ct:series-name': series.name,
	        'ct:meta': Chartist.serialize(series.meta)
	      });
	
	      // Use series class from series data or if not set generate one
	      seriesElement.addClass([
	        options.classNames.series,
	        (series.className || options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex))
	      ].join(' '));
	
	      data.normalized[seriesIndex].forEach(function(value, valueIndex) {
	        var projected,
	          bar,
	          previousStack,
	          labelAxisValueIndex;
	
	        // We need to set labelAxisValueIndex based on some options combinations
	        if(options.distributeSeries && !options.stackBars) {
	          // If distributed series are enabled but stacked bars aren't, we can use the seriesIndex for later projection
	          // on the step axis for label positioning
	          labelAxisValueIndex = seriesIndex;
	        } else if(options.distributeSeries && options.stackBars) {
	          // If distributed series and stacked bars are enabled, we will only get one bar and therefore always use
	          // 0 for projection on the label step axis
	          labelAxisValueIndex = 0;
	        } else {
	          // On regular bar charts we just use the value index to project on the label step axis
	          labelAxisValueIndex = valueIndex;
	        }
	
	        // We need to transform coordinates differently based on the chart layout
	        if(options.horizontalBars) {
	          projected = {
	            x: chartRect.x1 + valueAxis.projectValue(value && value.x ? value.x : 0, valueIndex, data.normalized[seriesIndex]),
	            y: chartRect.y1 - labelAxis.projectValue(value && value.y ? value.y : 0, labelAxisValueIndex, data.normalized[seriesIndex])
	          };
	        } else {
	          projected = {
	            x: chartRect.x1 + labelAxis.projectValue(value && value.x ? value.x : 0, labelAxisValueIndex, data.normalized[seriesIndex]),
	            y: chartRect.y1 - valueAxis.projectValue(value && value.y ? value.y : 0, valueIndex, data.normalized[seriesIndex])
	          }
	        }
	
	        // If the label axis is a step based axis we will offset the bar into the middle of between two steps using
	        // the periodHalfLength value. Also we do arrange the different series so that they align up to each other using
	        // the seriesBarDistance. If we don't have a step axis, the bar positions can be chosen freely so we should not
	        // add any automated positioning.
	        if(labelAxis instanceof Chartist.StepAxis) {
	          // Offset to center bar between grid lines, but only if the step axis is not stretched
	          if(!labelAxis.options.stretch) {
	            projected[labelAxis.units.pos] += periodHalfLength * (options.horizontalBars ? -1 : 1);
	          }
	          // Using bi-polar offset for multiple series if no stacked bars or series distribution is used
	          projected[labelAxis.units.pos] += (options.stackBars || options.distributeSeries) ? 0 : biPol * options.seriesBarDistance * (options.horizontalBars ? -1 : 1);
	        }
	
	        // Enter value in stacked bar values used to remember previous screen value for stacking up bars
	        previousStack = stackedBarValues[valueIndex] || zeroPoint;
	        stackedBarValues[valueIndex] = previousStack - (zeroPoint - projected[labelAxis.counterUnits.pos]);
	
	        // Skip if value is undefined
	        if(value === undefined) {
	          return;
	        }
	
	        var positions = {};
	        positions[labelAxis.units.pos + '1'] = projected[labelAxis.units.pos];
	        positions[labelAxis.units.pos + '2'] = projected[labelAxis.units.pos];
	
	        if(options.stackBars && (options.stackMode === 'accumulate' || !options.stackMode)) {
	          // Stack mode: accumulate (default)
	          // If bars are stacked we use the stackedBarValues reference and otherwise base all bars off the zero line
	          // We want backwards compatibility, so the expected fallback without the 'stackMode' option
	          // to be the original behaviour (accumulate)
	          positions[labelAxis.counterUnits.pos + '1'] = previousStack;
	          positions[labelAxis.counterUnits.pos + '2'] = stackedBarValues[valueIndex];
	        } else {
	          // Draw from the zero line normally
	          // This is also the same code for Stack mode: overlap
	          positions[labelAxis.counterUnits.pos + '1'] = zeroPoint;
	          positions[labelAxis.counterUnits.pos + '2'] = projected[labelAxis.counterUnits.pos];
	        }
	
	        // Limit x and y so that they are within the chart rect
	        positions.x1 = Math.min(Math.max(positions.x1, chartRect.x1), chartRect.x2);
	        positions.x2 = Math.min(Math.max(positions.x2, chartRect.x1), chartRect.x2);
	        positions.y1 = Math.min(Math.max(positions.y1, chartRect.y2), chartRect.y1);
	        positions.y2 = Math.min(Math.max(positions.y2, chartRect.y2), chartRect.y1);
	
	        // Create bar element
	        bar = seriesElement.elem('line', positions, options.classNames.bar).attr({
	          'ct:value': [value.x, value.y].filter(Chartist.isNum).join(','),
	          'ct:meta': Chartist.getMetaData(series, valueIndex)
	        });
	
	        this.eventEmitter.emit('draw', Chartist.extend({
	          type: 'bar',
	          value: value,
	          index: valueIndex,
	          meta: Chartist.getMetaData(series, valueIndex),
	          series: series,
	          seriesIndex: seriesIndex,
	          axisX: axisX,
	          axisY: axisY,
	          chartRect: chartRect,
	          group: seriesElement,
	          element: bar
	        }, positions));
	      }.bind(this));
	    }.bind(this));
	
	    this.eventEmitter.emit('created', {
	      bounds: valueAxis.bounds,
	      chartRect: chartRect,
	      axisX: axisX,
	      axisY: axisY,
	      svg: this.svg,
	      options: options
	    });
	  }
	
	  /**
	   * This method creates a new bar chart and returns API object that you can use for later changes.
	   *
	   * @memberof Chartist.Bar
	   * @param {String|Node} query A selector query string or directly a DOM element
	   * @param {Object} data The data object that needs to consist of a labels and a series array
	   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
	   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
	   * @return {Object} An object which exposes the API for the created chart
	   *
	   * @example
	   * // Create a simple bar chart
	   * var data = {
	   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
	   *   series: [
	   *     [5, 2, 4, 2, 0]
	   *   ]
	   * };
	   *
	   * // In the global name space Chartist we call the Bar function to initialize a bar chart. As a first parameter we pass in a selector where we would like to get our chart created and as a second parameter we pass our data object.
	   * new Chartist.Bar('.ct-chart', data);
	   *
	   * @example
	   * // This example creates a bipolar grouped bar chart where the boundaries are limitted to -10 and 10
	   * new Chartist.Bar('.ct-chart', {
	   *   labels: [1, 2, 3, 4, 5, 6, 7],
	   *   series: [
	   *     [1, 3, 2, -5, -3, 1, -6],
	   *     [-5, -2, -4, -1, 2, -3, 1]
	   *   ]
	   * }, {
	   *   seriesBarDistance: 12,
	   *   low: -10,
	   *   high: 10
	   * });
	   *
	   */
	  function Bar(query, data, options, responsiveOptions) {
	    Chartist.Bar.super.constructor.call(this,
	      query,
	      data,
	      defaultOptions,
	      Chartist.extend({}, defaultOptions, options),
	      responsiveOptions);
	  }
	
	  // Creating bar chart type in Chartist namespace
	  Chartist.Bar = Chartist.Base.extend({
	    constructor: Bar,
	    createChart: createChart
	  });
	
	}(window, document, Chartist));
	;/**
	 * The pie chart module of Chartist that can be used to draw pie, donut or gauge charts
	 *
	 * @module Chartist.Pie
	 */
	/* global Chartist */
	(function(window, document, Chartist) {
	  'use strict';
	
	  /**
	   * Default options in line charts. Expand the code view to see a detailed list of options with comments.
	   *
	   * @memberof Chartist.Pie
	   */
	  var defaultOptions = {
	    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
	    width: undefined,
	    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
	    height: undefined,
	    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
	    chartPadding: 5,
	    // Override the class names that are used to generate the SVG structure of the chart
	    classNames: {
	      chartPie: 'ct-chart-pie',
	      chartDonut: 'ct-chart-donut',
	      series: 'ct-series',
	      slicePie: 'ct-slice-pie',
	      sliceDonut: 'ct-slice-donut',
	      label: 'ct-label'
	    },
	    // The start angle of the pie chart in degrees where 0 points north. A higher value offsets the start angle clockwise.
	    startAngle: 0,
	    // An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
	    total: undefined,
	    // If specified the donut CSS classes will be used and strokes will be drawn instead of pie slices.
	    donut: false,
	    // Specify the donut stroke width, currently done in javascript for convenience. May move to CSS styles in the future.
	    // This option can be set as number or string to specify a relative width (i.e. 100 or '30%').
	    donutWidth: 60,
	    // If a label should be shown or not
	    showLabel: true,
	    // Label position offset from the standard position which is half distance of the radius. This value can be either positive or negative. Positive values will position the label away from the center.
	    labelOffset: 0,
	    // This option can be set to 'inside', 'outside' or 'center'. Positioned with 'inside' the labels will be placed on half the distance of the radius to the border of the Pie by respecting the 'labelOffset'. The 'outside' option will place the labels at the border of the pie and 'center' will place the labels in the absolute center point of the chart. The 'center' option only makes sense in conjunction with the 'labelOffset' option.
	    labelPosition: 'inside',
	    // An interpolation function for the label value
	    labelInterpolationFnc: Chartist.noop,
	    // Label direction can be 'neutral', 'explode' or 'implode'. The labels anchor will be positioned based on those settings as well as the fact if the labels are on the right or left side of the center of the chart. Usually explode is useful when labels are positioned far away from the center.
	    labelDirection: 'neutral',
	    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
	    reverseData: false,
	    // If true empty values will be ignored to avoid drawing unncessary slices and labels
	    ignoreEmptyValues: false
	  };
	
	  /**
	   * Determines SVG anchor position based on direction and center parameter
	   *
	   * @param center
	   * @param label
	   * @param direction
	   * @return {string}
	   */
	  function determineAnchorPosition(center, label, direction) {
	    var toTheRight = label.x > center.x;
	
	    if(toTheRight && direction === 'explode' ||
	      !toTheRight && direction === 'implode') {
	      return 'start';
	    } else if(toTheRight && direction === 'implode' ||
	      !toTheRight && direction === 'explode') {
	      return 'end';
	    } else {
	      return 'middle';
	    }
	  }
	
	  /**
	   * Creates the pie chart
	   *
	   * @param options
	   */
	  function createChart(options) {
	    this.data = Chartist.normalizeData(this.data);
	    var seriesGroups = [],
	      labelsGroup,
	      chartRect,
	      radius,
	      labelRadius,
	      totalDataSum,
	      startAngle = options.startAngle,
	      dataArray = Chartist.getDataArray(this.data, options.reverseData);
	
	    // Create SVG.js draw
	    this.svg = Chartist.createSvg(this.container, options.width, options.height,options.donut ? options.classNames.chartDonut : options.classNames.chartPie);
	    // Calculate charting rect
	    chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
	    // Get biggest circle radius possible within chartRect
	    radius = Math.min(chartRect.width() / 2, chartRect.height() / 2);
	    // Calculate total of all series to get reference value or use total reference from optional options
	    totalDataSum = options.total || dataArray.reduce(function(previousValue, currentValue) {
	      return previousValue + currentValue;
	    }, 0);
	
	    var donutWidth = Chartist.quantity(options.donutWidth);
	    if (donutWidth.unit === '%') {
	      donutWidth.value *= radius / 100;
	    }
	
	    // If this is a donut chart we need to adjust our radius to enable strokes to be drawn inside
	    // Unfortunately this is not possible with the current SVG Spec
	    // See this proposal for more details: http://lists.w3.org/Archives/Public/www-svg/2003Oct/0000.html
	    radius -= options.donut ? donutWidth.value / 2  : 0;
	
	    // If labelPosition is set to `outside` or a donut chart is drawn then the label position is at the radius,
	    // if regular pie chart it's half of the radius
	    if(options.labelPosition === 'outside' || options.donut) {
	      labelRadius = radius;
	    } else if(options.labelPosition === 'center') {
	      // If labelPosition is center we start with 0 and will later wait for the labelOffset
	      labelRadius = 0;
	    } else {
	      // Default option is 'inside' where we use half the radius so the label will be placed in the center of the pie
	      // slice
	      labelRadius = radius / 2;
	    }
	    // Add the offset to the labelRadius where a negative offset means closed to the center of the chart
	    labelRadius += options.labelOffset;
	
	    // Calculate end angle based on total sum and current data value and offset with padding
	    var center = {
	      x: chartRect.x1 + chartRect.width() / 2,
	      y: chartRect.y2 + chartRect.height() / 2
	    };
	
	    // Check if there is only one non-zero value in the series array.
	    var hasSingleValInSeries = this.data.series.filter(function(val) {
	      return val.hasOwnProperty('value') ? val.value !== 0 : val !== 0;
	    }).length === 1;
	
	    //if we need to show labels we create the label group now
	    if(options.showLabel) {
	      labelsGroup = this.svg.elem('g', null, null, true);
	    }
	
	    // Draw the series
	    // initialize series groups
	    for (var i = 0; i < this.data.series.length; i++) {
	      // If current value is zero and we are ignoring empty values then skip to next value
	      if (dataArray[i] === 0 && options.ignoreEmptyValues) continue;
	
	      var series = this.data.series[i];
	      seriesGroups[i] = this.svg.elem('g', null, null, true);
	
	      // If the series is an object and contains a name or meta data we add a custom attribute
	      seriesGroups[i].attr({
	        'ct:series-name': series.name
	      });
	
	      // Use series class from series data or if not set generate one
	      seriesGroups[i].addClass([
	        options.classNames.series,
	        (series.className || options.classNames.series + '-' + Chartist.alphaNumerate(i))
	      ].join(' '));
	
	      var endAngle = startAngle + dataArray[i] / totalDataSum * 360;
	
	      // Use slight offset so there are no transparent hairline issues
	      var overlappigStartAngle = Math.max(0, startAngle - (i === 0 || hasSingleValInSeries ? 0 : 0.2));
	
	      // If we need to draw the arc for all 360 degrees we need to add a hack where we close the circle
	      // with Z and use 359.99 degrees
	      if(endAngle - overlappigStartAngle >= 359.99) {
	        endAngle = overlappigStartAngle + 359.99;
	      }
	
	      var start = Chartist.polarToCartesian(center.x, center.y, radius, overlappigStartAngle),
	        end = Chartist.polarToCartesian(center.x, center.y, radius, endAngle);
	
	      // Create a new path element for the pie chart. If this isn't a donut chart we should close the path for a correct stroke
	      var path = new Chartist.Svg.Path(!options.donut)
	        .move(end.x, end.y)
	        .arc(radius, radius, 0, endAngle - startAngle > 180, 0, start.x, start.y);
	
	      // If regular pie chart (no donut) we add a line to the center of the circle for completing the pie
	      if(!options.donut) {
	        path.line(center.x, center.y);
	      }
	
	      // Create the SVG path
	      // If this is a donut chart we add the donut class, otherwise just a regular slice
	      var pathElement = seriesGroups[i].elem('path', {
	        d: path.stringify()
	      }, options.donut ? options.classNames.sliceDonut : options.classNames.slicePie);
	
	      // Adding the pie series value to the path
	      pathElement.attr({
	        'ct:value': dataArray[i],
	        'ct:meta': Chartist.serialize(series.meta)
	      });
	
	      // If this is a donut, we add the stroke-width as style attribute
	      if(options.donut) {
	        pathElement.attr({
	          'style': 'stroke-width: ' + donutWidth.value + 'px'
	        });
	      }
	
	      // Fire off draw event
	      this.eventEmitter.emit('draw', {
	        type: 'slice',
	        value: dataArray[i],
	        totalDataSum: totalDataSum,
	        index: i,
	        meta: series.meta,
	        series: series,
	        group: seriesGroups[i],
	        element: pathElement,
	        path: path.clone(),
	        center: center,
	        radius: radius,
	        startAngle: startAngle,
	        endAngle: endAngle
	      });
	
	      // If we need to show labels we need to add the label for this slice now
	      if(options.showLabel) {
	        // Position at the labelRadius distance from center and between start and end angle
	        var labelPosition = Chartist.polarToCartesian(center.x, center.y, labelRadius, startAngle + (endAngle - startAngle) / 2),
	          interpolatedValue = options.labelInterpolationFnc(this.data.labels && !Chartist.isFalseyButZero(this.data.labels[i]) ? this.data.labels[i] : dataArray[i], i);
	
	        if(interpolatedValue || interpolatedValue === 0) {
	          var labelElement = labelsGroup.elem('text', {
	            dx: labelPosition.x,
	            dy: labelPosition.y,
	            'text-anchor': determineAnchorPosition(center, labelPosition, options.labelDirection)
	          }, options.classNames.label).text('' + interpolatedValue);
	
	          // Fire off draw event
	          this.eventEmitter.emit('draw', {
	            type: 'label',
	            index: i,
	            group: labelsGroup,
	            element: labelElement,
	            text: '' + interpolatedValue,
	            x: labelPosition.x,
	            y: labelPosition.y
	          });
	        }
	      }
	
	      // Set next startAngle to current endAngle.
	      // (except for last slice)
	      startAngle = endAngle;
	    }
	
	    this.eventEmitter.emit('created', {
	      chartRect: chartRect,
	      svg: this.svg,
	      options: options
	    });
	  }
	
	  /**
	   * This method creates a new pie chart and returns an object that can be used to redraw the chart.
	   *
	   * @memberof Chartist.Pie
	   * @param {String|Node} query A selector query string or directly a DOM element
	   * @param {Object} data The data object in the pie chart needs to have a series property with a one dimensional data array. The values will be normalized against each other and don't necessarily need to be in percentage. The series property can also be an array of value objects that contain a value property and a className property to override the CSS class name for the series group.
	   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
	   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
	   * @return {Object} An object with a version and an update method to manually redraw the chart
	   *
	   * @example
	   * // Simple pie chart example with four series
	   * new Chartist.Pie('.ct-chart', {
	   *   series: [10, 2, 4, 3]
	   * });
	   *
	   * @example
	   * // Drawing a donut chart
	   * new Chartist.Pie('.ct-chart', {
	   *   series: [10, 2, 4, 3]
	   * }, {
	   *   donut: true
	   * });
	   *
	   * @example
	   * // Using donut, startAngle and total to draw a gauge chart
	   * new Chartist.Pie('.ct-chart', {
	   *   series: [20, 10, 30, 40]
	   * }, {
	   *   donut: true,
	   *   donutWidth: 20,
	   *   startAngle: 270,
	   *   total: 200
	   * });
	   *
	   * @example
	   * // Drawing a pie chart with padding and labels that are outside the pie
	   * new Chartist.Pie('.ct-chart', {
	   *   series: [20, 10, 30, 40]
	   * }, {
	   *   chartPadding: 30,
	   *   labelOffset: 50,
	   *   labelDirection: 'explode'
	   * });
	   *
	   * @example
	   * // Overriding the class names for individual series as well as a name and meta data.
	   * // The name will be written as ct:series-name attribute and the meta data will be serialized and written
	   * // to a ct:meta attribute.
	   * new Chartist.Pie('.ct-chart', {
	   *   series: [{
	   *     value: 20,
	   *     name: 'Series 1',
	   *     className: 'my-custom-class-one',
	   *     meta: 'Meta One'
	   *   }, {
	   *     value: 10,
	   *     name: 'Series 2',
	   *     className: 'my-custom-class-two',
	   *     meta: 'Meta Two'
	   *   }, {
	   *     value: 70,
	   *     name: 'Series 3',
	   *     className: 'my-custom-class-three',
	   *     meta: 'Meta Three'
	   *   }]
	   * });
	   */
	  function Pie(query, data, options, responsiveOptions) {
	    Chartist.Pie.super.constructor.call(this,
	      query,
	      data,
	      defaultOptions,
	      Chartist.extend({}, defaultOptions, options),
	      responsiveOptions);
	  }
	
	  // Creating pie chart type in Chartist namespace
	  Chartist.Pie = Chartist.Base.extend({
	    constructor: Pie,
	    createChart: createChart,
	    determineAnchorPosition: determineAnchorPosition
	  });
	
	}(window, document, Chartist));
	
	return Chartist;
	
	}));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(1178);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 273 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(465)
	  , core      = __webpack_require__(198)
	  , hide      = __webpack_require__(524)
	  , redefine  = __webpack_require__(525)
	  , ctx       = __webpack_require__(917)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.totalAngle = totalAngle;
	exports.plotData = plotData;
	exports.aggregateDataPie = aggregateDataPie;
	exports.aggregateDataTimeStep = aggregateDataTimeStep;
	exports.aggregateDataStep = aggregateDataStep;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chartist = __webpack_require__(271);
	
	var _chartist2 = _interopRequireDefault(_chartist);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Chart = __webpack_require__(2204);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function totalAngle(_ref) {
	    var source = _ref.source,
	        angle = _ref.angle,
	        identify = _ref.identify;
	
	    var total = source.reduce(function (r, v) {
	        return r + identify(v);
	    }, 0);
	    return total * 360 / angle;
	}
	
	function plotData(_ref2) {
	    var serie = _ref2.serie,
	        display = _ref2.display,
	        identify = _ref2.identify,
	        value = _ref2.value;
	
	    var series = value.map(function (value) {
	        return serie(value).map(function (v) {
	            return { x: display(v), y: identify(v) };
	        });
	    });
	
	    return { series: series };
	}
	
	function aggregateDataPie(_ref3) {
	    var display = _ref3.display,
	        identify = _ref3.identify,
	        value = _ref3.value;
	
	    var data = value.reduce(function (result, value) {
	        result.labels.push(display(value));
	        result.series.push(identify(value));
	        return result;
	    }, { labels: [], series: [] });
	
	    return _extends({}, data, {
	        labelInterpolationFnc: function labelInterpolationFnc(v) {
	            return v || null;
	        }
	    });
	}
	
	function aggregateDataTimeStep(options) {
	
	    function toStepType(dateRange) {
	        var timeframe = Math.abs(dateRange[0] - dateRange[1]);
	
	        if (timeframe < 14 * 24 * 3600000) return 'DAY';
	        if (timeframe < 365 * 24 * 3600000) return 'MONTH';
	        return 'YEAR';
	    }
	
	    function toStep(type, date) {
	        var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	        if (type == 'DAY') return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + add));
	        if (type == 'MONTH') return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + add));
	        return new Date(Date.UTC(date.getUTCFullYear() + add, 0));
	    }
	
	    function stepEquals(step1, step2) {
	        if (!step1 || !step2) return false;
	        return step1.getUTCFullYear() == step2.getUTCFullYear() && step1.getUTCMonth() == step2.getUTCMonth() && step1.getUTCDate() == step2.getUTCDate();
	    }
	
	    function toStepLabel(type, step) {
	        switch (type) {
	            case 'DAY':
	                return _moment2.default.utc(step).format('ddd');
	            case 'MONTH':
	                return _moment2.default.utc(step).format('MMM');
	            default:
	                return _moment2.default.utc(step).format('YYYY');
	        }
	    }
	
	    return aggregateDataStep(_extends({ toStepType: toStepType, toStep: toStep, toStepLabel: toStepLabel, stepEquals: stepEquals, fillSteps: true }, options));
	}
	
	function aggregateDataStep(_ref4) {
	    var toStepType = _ref4.toStepType,
	        toStep = _ref4.toStep,
	        toStepLabel = _ref4.toStepLabel,
	        stepEquals = _ref4.stepEquals,
	        stepReduce = _ref4.stepReduce,
	        _ref4$fillSteps = _ref4.fillSteps,
	        fillSteps = _ref4$fillSteps === undefined ? false : _ref4$fillSteps;
	
	    toStepType = toStepType || function () {
	        return null;
	    };
	    toStep = toStep || function (t, l) {
	        return l;
	    };
	    toStepLabel = toStepLabel || function (t, s) {
	        return s;
	    };
	    stepEquals = stepEquals || function (s1, s2) {
	        return s1 == s2;
	    };
	    stepReduce = stepReduce || function (a) {
	        return a.reduce(function (r, v) {
	            return r + v;
	        }, 0);
	    };
	
	    return function (_ref5) {
	        var axisX = _ref5.axisX,
	            serie = _ref5.serie,
	            display = _ref5.display,
	            identify = _ref5.identify,
	            value = _ref5.value;
	
	
	        function labelRangeReducer(result, value) {
	            var seriez = serie(value);
	            var startLabel = display(seriez[0]);
	            var endLabel = display(seriez[seriez.length - 1]);
	
	            result[0] = result[0] && startLabel > result[0] && result[0] || startLabel;
	            result[1] = result[1] && endLabel < result[1] && result[1] || endLabel;
	            return result;
	        }
	
	        function stepAggregator(stepType) {
	            return function (result, value, index) {
	                return serie(value).reduce(function (result, entry) {
	                    var label = display(entry);
	                    var value = identify(entry);
	                    var step = toStep(stepType, label);
	
	                    var aggrega = result.find(function (a) {
	                        return stepEquals(a.step, step);
	                    });
	                    if (!aggrega) {
	                        result.push(aggrega = {
	                            step: step,
	                            series: []
	                        });
	                    }
	
	                    aggrega.series[index] = aggrega.series[index] || [];
	                    aggrega.series[index].push(value);
	                    return result;
	                }, result);
	            };
	        }
	
	        function stepComparator(aggrega1, aggrega2) {
	            return aggrega1.step - aggrega2.step;
	        }
	
	        function fillStepsReducer(stepType) {
	            return function (result, aggrega) {
	                if (fillSteps) {
	                    var nextStep = aggrega.step;
	                    var lastAggrega = result[result.length - 1];
	                    var lastStep = lastAggrega && lastAggrega.step || nextStep;
	                    var fillStep = toStep(stepType, lastStep, 1);
	
	                    while (fillStep < nextStep) {
	                        result.push({
	                            step: fillStep,
	                            series: []
	                        });
	
	                        fillStep = toStep(stepType, fillStep, 1);
	                    }
	                }
	
	                result.push(aggrega);
	                return result;
	            };
	        }
	
	        function dataReducer(serieCount) {
	            return function (result, aggrega) {
	                result.labels.push(aggrega.step);
	                for (var i = 0; i < serieCount; i++) {
	                    var values = aggrega.series[i];
	                    var average = values && stepReduce(values);
	
	                    result.series[i] = result.series[i] || [];
	                    result.series[i].push(average);
	                }
	                return result;
	            };
	        }
	
	        var stepType = toStepType(value.reduce(labelRangeReducer, []));
	        var aggregations = value.reduce(stepAggregator(stepType), []).sort(stepComparator);
	        var filledAgregations = aggregations.reduce(fillStepsReducer(stepType), []);
	        var data = filledAgregations.reduce(dataReducer(value.length), { labels: [], series: [] });
	
	        return _extends({}, data, {
	            axisX: _extends({
	                labelInterpolationFnc: function labelInterpolationFnc(v) {
	                    return toStepLabel(stepType, v);
	                }
	            }, axisX)
	        });
	    };
	}
	
	function processData(options) {
	    var kind = options.kind,
	        axisX = options.axisX;
	
	
	    if (kind == 'Pie') {
	        return aggregateDataPie(options);
	    }
	
	    if (!axisX || !axisX.type || axisX.type == _chartist2.default.StepAxis) {
	        return aggregateDataStep({})(options);
	    }
	
	    return plotData(options);
	}
	
	var Chart = function (_Component) {
	    _inherits(Chart, _Component);
	
	    function Chart(props) {
	        _classCallCheck(this, Chart);
	
	        var _this = _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this, props));
	
	        _this.state = {
	            labels: [],
	            series: []
	        };
	        return _this;
	    }
	
	    _createClass(Chart, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                data = _props.data,
	                options = _objectWithoutProperties(_props, ['data']);
	
	            var processData = typeof data == 'function' && data || function () {
	                return data;
	            };
	
	            var _processData = processData(options),
	                labels = _processData.labels,
	                series = _processData.series,
	                enhancedOptions = _objectWithoutProperties(_processData, ['labels', 'series']);
	
	            this.setState({ labels: labels, series: series, enhancedOptions: enhancedOptions });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.value != this.props.value) {
	                var data = nextProps.data,
	                    options = _objectWithoutProperties(nextProps, ['data']);
	
	                var _processData2 = typeof data == 'function' && data || function () {
	                    return data;
	                };
	
	                var _processData3 = _processData2(options),
	                    labels = _processData3.labels,
	                    series = _processData3.series,
	                    enhancedOptions = _objectWithoutProperties(_processData3, ['labels', 'series']);
	
	                this.setState({ labels: labels, series: series, enhancedOptions: enhancedOptions });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props2 = this.props,
	                kind = _props2.kind,
	                ratio = _props2.ratio,
	                inverse = _props2.inverse,
	                brand = _props2.brand,
	                data = _props2.data,
	                serie = _props2.serie,
	                display = _props2.display,
	                identify = _props2.identify,
	                onDraw = _props2.onDraw,
	                value = _props2.value,
	                responsive = _props2.responsive,
	                options = _objectWithoutProperties(_props2, ['kind', 'ratio', 'inverse', 'brand', 'data', 'serie', 'display', 'identify', 'onDraw', 'value', 'responsive']);
	
	            var _state = this.state,
	                labels = _state.labels,
	                series = _state.series,
	                enhancedOptions = _state.enhancedOptions;
	
	
	            this._chart = new _chartist2.default[kind]((0, _reactDom.findDOMNode)(this), { labels: labels, series: series }, _extends({}, options, enhancedOptions), responsive);
	
	            if (onDraw) {
	                this._chart.on('draw', onDraw);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this._chart) {
	                var _props3 = this.props,
	                    kind = _props3.kind,
	                    ratio = _props3.ratio,
	                    inverse = _props3.inverse,
	                    brand = _props3.brand,
	                    data = _props3.data,
	                    serie = _props3.serie,
	                    display = _props3.display,
	                    identify = _props3.identify,
	                    onDraw = _props3.onDraw,
	                    value = _props3.value,
	                    responsive = _props3.responsive,
	                    options = _objectWithoutProperties(_props3, ['kind', 'ratio', 'inverse', 'brand', 'data', 'serie', 'display', 'identify', 'onDraw', 'value', 'responsive']);
	
	                var _state2 = this.state,
	                    labels = _state2.labels,
	                    series = _state2.series,
	                    enhancedOptions = _state2.enhancedOptions;
	
	
	                this._chart.update({ labels: labels, series: series }, _extends({}, options, enhancedOptions), true);
	
	                if (onDraw) {
	                    this._chart.on('draw', onDraw);
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this._chart) {
	                this._chart.detach();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props4 = this.props,
	                ratio = _props4.ratio,
	                fill = _props4.fill,
	                inverse = _props4.inverse,
	                brand = _props4.brand;
	
	            var ratioClass = ratio && 'ct-' + ratio;
	            var fillClass = fill && 'ct-fill';
	            var inverseClass = inverse && 'ct-inverse';
	            var brandClass = brand && 'ct-brand';
	
	            return _react2.default.createElement('div', { className: (0, _classnames2.default)('ct-chart', ratioClass, fillClass, inverseClass, brandClass) });
	        }
	    }]);
	
	    return Chart;
	}(_react.Component);
	
	Chart.propTypes = {
	    kind: _react.PropTypes.string,
	    ratio: _react.PropTypes.string,
	    inverse: _react.PropTypes.bool,
	    brand: _react.PropTypes.bool,
	    data: _react.PropTypes.func,
	    serie: _react.PropTypes.func,
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    onDraw: _react.PropTypes.func,
	    value: _react.PropTypes.array.isRequired
	};
	Chart.defaultProps = {
	    data: processData,
	    serie: function serie(s) {
	        return s;
	    },
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    }
	};
	exports.default = Chart;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDayPicker = __webpack_require__(1224);
	
	var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);
	
	var _moment3 = __webpack_require__(1226);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function today() {
	    var date = new Date();
	    date.setHours(0);
	    date.setMinutes(0);
	    date.setSeconds(0);
	    date.setMilliseconds(0);
	    return date;
	}
	
	var DayPicker = function (_Component) {
	    _inherits(DayPicker, _Component);
	
	    function DayPicker(props) {
	        _classCallCheck(this, DayPicker);
	
	        var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(DayPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var value = this.props.value;
	
	
	            this.setState({
	                initial: value || new Date()
	            });
	        }
	    }, {
	        key: '_selectDay',
	        value: function _selectDay(day) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange;
	
	
	            var previousValue = value || today();
	            var nextValue = new Date(day.getFullYear(), day.getMonth(), day.getDate(), previousValue.getHours(), previousValue.getMinutes());
	            onChange(nextValue);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var value = this.props.value;
	            var initial = this.state.initial;
	
	
	            var modifiers = {
	                selected: function selected(day) {
	                    return _reactDayPicker.DateUtils.isSameDay(day, value);
	                }
	            };
	
	            var display = function display(day) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    day.getDate()
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactDayPicker2.default, {
	                    renderDay: display,
	                    modifiers: modifiers,
	                    initialMonth: initial,
	                    onDayClick: function onDayClick(e, d) {
	                        return _this2._selectDay(d);
	                    },
	                    localeUtils: _moment4.default,
	                    locale: _moment2.default.locale() })
	            );
	        }
	    }]);
	
	    return DayPicker;
	}(_react.Component);
	
	DayPicker.propTypes = {
	    value: _react.PropTypes.object,
	    onChange: _react.PropTypes.func.isRequired
	};
	exports.default = DayPicker;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MultiInput = __webpack_require__(2212);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiInput = function (_Component) {
	    _inherits(MultiInput, _Component);
	
	    function MultiInput() {
	        _classCallCheck(this, MultiInput);
	
	        return _possibleConstructorReturn(this, (MultiInput.__proto__ || Object.getPrototypeOf(MultiInput)).apply(this, arguments));
	    }
	
	    _createClass(MultiInput, [{
	        key: '_add',
	        value: function _add(event) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange;
	
	
	            event.preventDefault();
	
	            var arrayValue = value || [];
	            var nextArrayValue = [null].concat(_toConsumableArray(arrayValue));
	
	            onChange(nextArrayValue);
	        }
	    }, {
	        key: '_remove',
	        value: function _remove(event, index) {
	            var _props2 = this.props,
	                value = _props2.value,
	                onChange = _props2.onChange;
	
	
	            event.preventDefault();
	
	            var arrayValue = value || [];
	            var nextArrayValue = [].concat(_toConsumableArray(arrayValue));
	            nextArrayValue.splice(index, 1);
	
	            onChange(nextArrayValue);
	        }
	    }, {
	        key: '_change',
	        value: function _change(event) {
	            var _props3 = this.props,
	                value = _props3.value,
	                onChange = _props3.onChange;
	
	
	            var nextValue = event.target.value;
	
	            var arrayValue = value || [];
	            var nextArrayValue = [].concat(_toConsumableArray(arrayValue));
	
	            nextArrayValue[0] = nextValue || null;
	            if (nextArrayValue.length == 1 && !nextArrayValue[0]) {
	                // reset array
	                nextArrayValue = [];
	            }
	
	            onChange(nextArrayValue);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                labelClassName = _props4.labelClassName,
	                wrapperClassName = _props4.wrapperClassName,
	                value = _props4.value,
	                onChange = _props4.onChange,
	                inverse = _props4.inverse,
	                bsStyle = _props4.bsStyle,
	                others = _objectWithoutProperties(_props4, ['labelClassName', 'wrapperClassName', 'value', 'onChange', 'inverse', 'bsStyle']);
	
	            var buttonAfter = function buttonAfter(index) {
	                if (value && value.length > 1) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            onClick: function onClick(e) {
	                                return _this2._remove(e, index);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	            };
	
	            var input = _react2.default.createElement(_reactBootstrap.Input, _extends({
	                labelClassName: labelClassName,
	                wrapperClassName: wrapperClassName,
	                buttonAfter: buttonAfter(),
	                onChange: function onChange(e) {
	                    return _this2._change(e);
	                },
	                value: value && value[0] || '' // fix uncontrolled input issue
	                , bsStyle: bsStyle
	            }, others));
	
	            var disabledInput = function disabledInput(item, index) {
	                return _react2.default.createElement(_reactBootstrap.Input, { disabled: true,
	                    key: index,
	                    labelClassName: labelClassName,
	                    wrapperClassName: wrapperClassName,
	                    type: 'text',
	                    label: ' ',
	                    buttonAfter: buttonAfter(index + 1),
	                    value: item });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                !inverse && _react2.default.createElement(
	                    'div',
	                    null,
	                    input,
	                    value && value.slice(1).map(disabledInput)
	                ),
	                !!inverse && _react2.default.createElement(
	                    'div',
	                    null,
	                    value && value.slice(1).reverse().map(disabledInput),
	                    input
	                ),
	                value && value.length > 0 && !bsStyle && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('div', { className: labelClassName }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: wrapperClassName },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _MultiInput2.default.add },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._add(e);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'ajouter'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MultiInput;
	}(_react.Component);
	
	MultiInput.propTypes = {
	    labelClassName: _react.PropTypes.string,
	    wrapperClassName: _react.PropTypes.string,
	    inverse: _react.PropTypes.bool,
	    value: _react.PropTypes.any,
	    onChange: _react.PropTypes.func.isRequired
	};
	exports.default = MultiInput;

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isSameDay = isSameDay;
	function isSameDay(date, otherDate) {
		date = date instanceof Date && date || new Date(date);
		otherDate = otherDate instanceof Date && otherDate || new Date(otherDate);
	
		return date.getDate() == otherDate.getDate() && date.getMonth() == otherDate.getMonth() && date.getFullYear() == otherDate.getFullYear();
	}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateCampaignAction = exports.CreateCampaignAction = function CreateCampaignAction() {
	    _classCallCheck(this, CreateCampaignAction);
	};
	
	CreateCampaignAction.schema = {
	    type: 'object',
	    properties: {
	        title: { type: 'string' },
	        questions: {
	            type: 'array',
	            minItems: 1,
	            items: { type: 'string' }
	        },
	        notationScale: {
	            type: 'array',
	            minItems: 1,
	            items: {
	                type: 'object',
	                properties: {
	                    position: { type: 'number' },
	                    label: { type: 'string' }
	                },
	                required: ['position', 'label']
	            }
	        }
	    },
	    required: ['title', 'questions', 'notationScale']
	};
	
	var UpdateNotationScaleOfCampaignAction = exports.UpdateNotationScaleOfCampaignAction = function UpdateNotationScaleOfCampaignAction() {
	    _classCallCheck(this, UpdateNotationScaleOfCampaignAction);
	};
	
	UpdateNotationScaleOfCampaignAction.schema = {
	    type: 'object',
	    properties: {
	        newNotationScale: {
	            type: 'array',
	            minItems: 1,
	            items: {
	                type: 'object',
	                properties: {
	                    position: { type: 'number' },
	                    label: { type: 'string' }
	                },
	                required: ['position', 'label']
	            }
	        }
	    },
	    required: ['newNotationScale']
	};
	
	var UpdateTitleOfCampaignAction = exports.UpdateTitleOfCampaignAction = function UpdateTitleOfCampaignAction() {
	    _classCallCheck(this, UpdateTitleOfCampaignAction);
	};
	
	UpdateTitleOfCampaignAction.schema = {
	    type: 'object',
	    properties: {
	        newTitle: { type: 'string' }
	    },
	    required: ['newTitle']
	};
	
	var AddQuestionToCampaignAction = exports.AddQuestionToCampaignAction = function AddQuestionToCampaignAction() {
	    _classCallCheck(this, AddQuestionToCampaignAction);
	};
	
	AddQuestionToCampaignAction.schema = {
	    type: 'object',
	    properties: {
	        question: { type: 'string' }
	    },
	    required: ['question']
	};
	
	var DefineAnswerRateGoalAction = exports.DefineAnswerRateGoalAction = function DefineAnswerRateGoalAction() {
	    _classCallCheck(this, DefineAnswerRateGoalAction);
	};
	
	DefineAnswerRateGoalAction.schema = {
	    type: 'object',
	    properties: {
	        rate: { type: 'number' }
	    },
	    required: ['rate']
	};
	
	var StartCampaignAction = exports.StartCampaignAction = function StartCampaignAction() {
	    _classCallCheck(this, StartCampaignAction);
	};
	
	StartCampaignAction.schema = {
	    type: 'object',
	    properties: {
	        elligibleCreateTicketDate: { type: 'date' }
	    },
	    required: ['elligibleCreateTicketDate']
	};
	
	var AnswerAction = exports.AnswerAction = function AnswerAction() {
	    _classCallCheck(this, AnswerAction);
	};
	
	AnswerAction.schema = {
	    type: 'object',
	    properties: {
	        answers: {
	            type: 'array',
	            items: {
	                type: 'object'
	            }
	        },
	        comment: { type: ['string', 'null'] }
	    },
	    required: ['answers']
	};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(59);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(32);
	var toAbsoluteIndex = __webpack_require__(100);
	var toLength = __webpack_require__(27);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(93);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(37);
	var toObject = __webpack_require__(32);
	var IObject = __webpack_require__(132);
	var toLength = __webpack_require__(27);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(37);
	var isObject = __webpack_require__(19);
	var invoke = __webpack_require__(290);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(30).f;
	var create = __webpack_require__(94);
	var redefineAll = __webpack_require__(98);
	var ctx = __webpack_require__(61);
	var anInstance = __webpack_require__(92);
	var forOf = __webpack_require__(93);
	var $iterDefine = __webpack_require__(214);
	var step = __webpack_require__(293);
	var setSpecies = __webpack_require__(99);
	var DESCRIPTORS = __webpack_require__(28);
	var fastKey = __webpack_require__(84).fastKey;
	var validate = __webpack_require__(102);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(114);
	var from = __webpack_require__(282);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(98);
	var getWeak = __webpack_require__(84).getWeak;
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(19);
	var anInstance = __webpack_require__(92);
	var forOf = __webpack_require__(93);
	var createArrayMethod = __webpack_require__(66);
	var $has = __webpack_require__(50);
	var validate = __webpack_require__(102);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(157);
	var isObject = __webpack_require__(19);
	var toLength = __webpack_require__(27);
	var ctx = __webpack_require__(61);
	var IS_CONCAT_SPREADABLE = __webpack_require__(25)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(28) && !__webpack_require__(18)(function () {
	  return Object.defineProperty(__webpack_require__(207)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(19);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(11);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(216);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(28);
	var getKeys = __webpack_require__(96);
	var gOPS = __webpack_require__(161);
	var pIE = __webpack_require__(133);
	var toObject = __webpack_require__(32);
	var IObject = __webpack_require__(132);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(18)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(30);
	var anObject = __webpack_require__(11);
	var getKeys = __webpack_require__(96);
	
	module.exports = __webpack_require__(28) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(53);
	var gOPN = __webpack_require__(95).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(50);
	var toIObject = __webpack_require__(53);
	var arrayIndexOf = __webpack_require__(154)(false);
	var IE_PROTO = __webpack_require__(221)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(28);
	var getKeys = __webpack_require__(96);
	var toIObject = __webpack_require__(53);
	var isEnum = __webpack_require__(133).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(95);
	var gOPS = __webpack_require__(161);
	var anObject = __webpack_require__(11);
	var Reflect = __webpack_require__(16).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(16).parseFloat;
	var $trim = __webpack_require__(117).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(224) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(16).parseInt;
	var $trim = __webpack_require__(117).trim;
	var ws = __webpack_require__(224);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(19);
	var newPromiseCapability = __webpack_require__(218);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(27);
	var repeat = __webpack_require__(223);
	var defined = __webpack_require__(67);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(63);
	var toLength = __webpack_require__(27);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(25);


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(285);
	var validate = __webpack_require__(102);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(155)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(219);
	__webpack_require__(3)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(28) && /./g.flags != 'g') __webpack_require__(30).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(131)
	});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(285);
	var validate = __webpack_require__(102);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(155)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(16);
	var each = __webpack_require__(66)(0);
	var redefine = __webpack_require__(44);
	var meta = __webpack_require__(84);
	var assign = __webpack_require__(297);
	var weak = __webpack_require__(287);
	var isObject = __webpack_require__(19);
	var validate = __webpack_require__(102);
	var NATIVE_WEAK_MAP = __webpack_require__(102);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(155)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(753);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(318);
	var TAG = __webpack_require__(104)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(233);
	var document = __webpack_require__(119).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(318);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(323);
	var $export = __webpack_require__(231);
	var redefine = __webpack_require__(777);
	var hide = __webpack_require__(136);
	var Iterators = __webpack_require__(137);
	var $iterCreate = __webpack_require__(768);
	var setToStringTag = __webpack_require__(326);
	var getPrototypeOf = __webpack_require__(774);
	var ITERATOR = __webpack_require__(104)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(775);
	var enumBugKeys = __webpack_require__(320);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(171).f;
	var has = __webpack_require__(170);
	var TAG = __webpack_require__(104)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(103);
	var global = __webpack_require__(119);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(323) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(230);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 329 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(778)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(322)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(785);
	var global = __webpack_require__(119);
	var hide = __webpack_require__(136);
	var Iterators = __webpack_require__(137);
	var TO_STRING_TAG = __webpack_require__(104)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 332 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DIGIT_PLACEHOLDER = undefined;
	
	var _getIterator2 = __webpack_require__(168);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(755);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(756);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.close_dangling_braces = close_dangling_braces;
	exports.count_occurences = count_occurences;
	exports.repeat = repeat;
	
	var _metadata = __webpack_require__(120);
	
	var _parse = __webpack_require__(121);
	
	var _format = __webpack_require__(238);
	
	var _common = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Used in phone number format template creation.
	// Could be any digit, I guess.
	// This is an enhanced port of Google Android `libphonenumber`'s
	// `asyoutypeformatter.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/blob/8d21a365061de2ba0675c878a710a7b24f74d2ae/javascript/i18n/phonenumbers/asyoutypeformatter.js
	
	var DUMMY_DIGIT = '9';
	var DUMMY_DIGIT_MATCHER = new RegExp(DUMMY_DIGIT, 'g');
	// I don't know why is it exactly `15`
	var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15;
	// Create a phone number consisting only of the digit 9 that matches the
	// `number_pattern` by applying the pattern to the "longest phone number" string.
	var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH);
	
	// The digits that have not been entered yet will be represented by a \u2008,
	// the punctuation space.
	var DIGIT_PLACEHOLDER = exports.DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
	var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
	var DIGIT_PLACEHOLDER_MATCHER_GLOBAL = new RegExp(DIGIT_PLACEHOLDER, 'g');
	
	// A pattern that is used to match character classes in regular expressions.
	// An example of a character class is "[1-4]".
	var CHARACTER_CLASS_PATTERN = /\[([^\[\]])*\]/g;
	
	// Any digit in a regular expression that actually denotes a digit. For
	// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
	// (8 and 0) are standalone digits, but the rest are not.
	// Two look-aheads are needed because the number following \\d could be a
	// two-digit number, since the phone number can be as long as 15 digits.
	var STANDALONE_DIGIT_PATTERN = /\d(?=[^,}][^,}])/g;
	
	// A pattern that is used to determine if a `format` is eligible
	// to be used by the "as you type formatter".
	// It is eligible when the `format` contains groups of the dollar sign
	// followed by a single digit, separated by valid phone number punctuation.
	// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
	// getting into the output of the "as you type formatter".
	var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + _parse.VALID_PUNCTUATION + ']*' + '(\\$\\d[' + _parse.VALID_PUNCTUATION + ']*)+' + '$');
	
	// This is the minimum length of the leading digits of a phone number
	// to guarantee the first "leading digits pattern" for a phone number format
	// to be preemptive.
	var MIN_LEADING_DIGITS_LENGTH = 3;
	
	var VALID_INCOMPLETE_PHONE_NUMBER = '[' + _parse.PLUS_CHARS + ']{0,1}' + '[' + _parse.VALID_PUNCTUATION + _parse.VALID_DIGITS + ']*';
	
	var VALID_INCOMPLETE_PHONE_NUMBER_PATTERN = new RegExp('^' + VALID_INCOMPLETE_PHONE_NUMBER + '$', 'i');
	
	var as_you_type = function () {
		function as_you_type(country_code, metadata) {
			(0, _classCallCheck3.default)(this, as_you_type);
	
			// Metadata is required.
			if (!metadata || !metadata.countries) {
				throw new Error('Metadata is required');
			}
	
			if (country_code && metadata.countries[country_code]) {
				this.default_country = country_code;
			}
	
			this.metadata = metadata;
	
			this.reset();
		}
	
		(0, _createClass3.default)(as_you_type, [{
			key: 'input',
			value: function input(text) {
				// Parse input
	
				var extracted_number = (0, _parse.extract_formatted_phone_number)(text);
	
				// Special case for a lone '+' sign
				// since it's not considered a possible phone number.
				if (!extracted_number) {
					if (text && text.indexOf('+') >= 0) {
						extracted_number = '+';
					}
				}
	
				// Validate possible first part of a phone number
				if (!(0, _common.matches_entirely)(extracted_number, VALID_INCOMPLETE_PHONE_NUMBER_PATTERN)) {
					return this.current_output;
				}
	
				return this.process_input((0, _parse.parse_phone_number)(extracted_number));
			}
		}, {
			key: 'process_input',
			value: function process_input(input) {
				// If an out of position '+' sign detected
				// (or a second '+' sign),
				// then just drop it from the input.
				if (input[0] === '+') {
					if (!this.parsed_input) {
						this.parsed_input += '+';
	
						// If a default country was set
						// then reset it because an explicitly international
						// phone number is being entered
						this.reset_countriness();
					}
	
					input = input.slice(1);
				}
	
				// Raw phone number
				this.parsed_input += input;
	
				// // Reset phone number validation state
				// this.valid = false
	
				// Add digits to the national number
				this.national_number += input;
	
				// Try to format the parsed input
	
				if (this.is_international()) {
					if (!this.country_phone_code) {
						// If one looks at country phone codes
						// then he can notice that no one country phone code
						// is ever a (leftmost) substring of another country phone code.
						// So if a valid country code is extracted so far
						// then it means that this is the country code.
	
						// If no country phone code could be extracted so far,
						// then just return the raw phone number,
						// because it has no way of knowing
						// how to format the phone number so far.
						if (!this.extract_country_phone_code()) {
							// Return raw phone number
							return this.parsed_input;
						}
	
						// Initialize country-specific data
						this.initialize_phone_number_formats_for_this_country_phone_code();
						this.reset_format();
						this.determine_the_country();
					}
					// `this.country` could be `undefined`,
					// for instance, when there is ambiguity
					// in a form of several different countries
					// each corresponding to the same country phone code
					// (e.g. NANPA: USA, Canada, etc),
					// and there's not enough digits entered
					// to reliably determine the country
					// the phone number belongs to.
					// Therefore, in cases of such ambiguity,
					// each time something is input,
					// try to determine the country
					// (if it's not determined yet).
					else if (!this.country) {
							this.determine_the_country();
						}
				} else {
					// Some national prefixes are substrings of other national prefixes
					// (for the same country), therefore try to extract national prefix each time
					// because a longer national prefix might be available at some point in time.
	
					var previous_national_prefix = this.national_prefix;
					this.national_number = this.national_prefix + this.national_number;
	
					// Possibly extract a national prefix
					this.extract_national_prefix();
	
					if (this.national_prefix !== previous_national_prefix) {
						// National number has changed
						// (due to another national prefix been extracted)
						// therefore national number has changed
						// therefore reset all previous formatting data.
						// (and leading digits matching state)
						this.matching_formats = this.available_formats;
						this.reset_format();
					}
				}
	
				if (!this.should_format()) {
					return this.format_as_non_formatted_number();
				}
	
				// Check the available phone number formats
				// based on the currently available leading digits.
				this.match_formats_by_leading_digits();
	
				// Format the phone number (given the next digits)
				var formatted_national_phone_number = this.format_national_phone_number(input);
	
				// If the phone number could be formatted,
				// then return it, possibly prepending with country phone code
				// (for international phone numbers only)
				if (formatted_national_phone_number) {
					return this.full_phone_number(formatted_national_phone_number);
				}
	
				// If the phone number couldn't be formatted,
				// then just fall back to the raw phone number.
				return this.parsed_input;
			}
		}, {
			key: 'format_as_non_formatted_number',
			value: function format_as_non_formatted_number() {
				if (this.is_international() && this.country_phone_code) {
					if (this.national_number) {
						// For convenience, the public `.template` property
						// contains the whole international number
						// if the phone number being input is international:
						// 'x' for the '+' sign, 'x'es for the country phone code,
						// a spacebar and then the template for the national number digits.
						this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.country_phone_code.length) + ' ' + repeat(DIGIT_PLACEHOLDER, this.national_number.length);
	
						return '+' + this.country_phone_code + ' ' + this.national_number;
					}
	
					return '+' + this.country_phone_code;
				}
	
				return this.parsed_input;
			}
		}, {
			key: 'format_national_phone_number',
			value: function format_national_phone_number(next_digits) {
				// Format the next phone number digits
				// using the previously chosen phone number format.
				//
				// This is done here because if `attempt_to_format_complete_phone_number`
				// was placed before this call then the `template`
				// wouldn't reflect the situation correctly (and would therefore be inconsistent)
				//
				var national_number_formatted_with_previous_format = void 0;
				if (this.chosen_format) {
					national_number_formatted_with_previous_format = this.format_next_national_number_digits(next_digits);
				}
	
				// See if the input digits can be formatted properly already. If not,
				// use the results from format_next_national_number_digits(), which does formatting
				// based on the formatting pattern chosen.
	
				var formatted_number = this.attempt_to_format_complete_phone_number();
	
				// Just because a phone number doesn't have a suitable format
				// that doesn't mean that the phone is invalid
				// because phone number formats only format phone numbers,
				// they don't validate them and some (rare) phone numbers
				// are meant to stay non-formatted.
				if (formatted_number) {
					// if (this.country)
					// {
					// 	this.valid = true
					// }
	
					return formatted_number;
				}
	
				// For some phone number formats national prefix
	
				// If the previously chosen phone number format
				// didn't match the next (current) digit being input
				// (leading digits pattern didn't match).
				if (this.choose_another_format()) {
					// And a more appropriate phone number format
					// has been chosen for these `leading digits`,
					// then format the national phone number (so far)
					// using the newly selected phone number pattern.
	
					// Will return `undefined` if it couldn't format
					// the supplied national number
					// using the selected phone number pattern.
	
					return this.reformat_national_number();
				}
	
				// If could format the next (current) digit
				// using the previously chosen phone number format
				// then return the formatted number so far.
	
				// If no new phone number format could be chosen,
				// and couldn't format the supplied national number
				// using the selected phone number pattern,
				// then it will return `undefined`.
	
				return national_number_formatted_with_previous_format;
			}
		}, {
			key: 'reset',
			value: function reset() {
				// Input stripped of non-phone-number characters.
				// Can only contain a possible leading '+' sign and digits.
				this.parsed_input = '';
	
				this.current_output = '';
	
				// This contains the national prefix that has been extracted. It contains only
				// digits without formatting.
				this.national_prefix = '';
	
				this.national_number = '';
	
				this.reset_countriness();
	
				this.reset_format();
	
				// this.valid = false
	
				return this;
			}
		}, {
			key: 'reset_country',
			value: function reset_country() {
				if (this.default_country && !this.is_international()) {
					this.country = this.default_country;
				} else {
					this.country = undefined;
				}
			}
		}, {
			key: 'reset_countriness',
			value: function reset_countriness() {
				this.reset_country();
	
				if (this.default_country && !this.is_international()) {
					this.country_metadata = this.metadata.countries[this.default_country];
					this.country_phone_code = (0, _metadata.get_phone_code)(this.country_metadata);
	
					this.initialize_phone_number_formats_for_this_country_phone_code();
				} else {
					this.country_metadata = undefined;
					this.country_phone_code = undefined;
	
					this.available_formats = [];
					this.matching_formats = this.available_formats;
				}
			}
		}, {
			key: 'reset_format',
			value: function reset_format() {
				this.chosen_format = undefined;
				this.template = undefined;
				this.partially_populated_template = undefined;
				this.last_match_position = -1;
			}
	
			// Format each digit of national phone number (so far)
			// using the newly selected phone number pattern.
	
		}, {
			key: 'reformat_national_number',
			value: function reformat_national_number() {
				// Format each digit of national phone number (so far)
				// using the selected phone number pattern.
				return this.format_next_national_number_digits(this.national_number);
			}
		}, {
			key: 'initialize_phone_number_formats_for_this_country_phone_code',
			value: function initialize_phone_number_formats_for_this_country_phone_code() {
				// Get all "eligible" phone number formats for this country
				this.available_formats = (0, _metadata.get_formats)(this.country_metadata).filter(function (format) {
					return ELIGIBLE_FORMAT_PATTERN.test((0, _metadata.get_format_international_format)(format));
				});
	
				this.matching_formats = this.available_formats;
			}
		}, {
			key: 'match_formats_by_leading_digits',
			value: function match_formats_by_leading_digits() {
				var leading_digits = this.national_number;
	
				// "leading digits" pattern list starts with
				// one of a maximum length of 3 digits,
				// and then with each additional digit
				// a more precise "leading digits" pattern is specified.
	
				var index_of_leading_digits_pattern = leading_digits.length - MIN_LEADING_DIGITS_LENGTH;
	
				if (index_of_leading_digits_pattern < 0) {
					index_of_leading_digits_pattern = 0;
				}
	
				this.matching_formats = this.matching_formats.filter(function (format) {
					var leading_digits_pattern_count = (0, _metadata.get_format_leading_digits_patterns)(format).length;
	
					// Keep everything that isn't restricted by leading digits.
					if (leading_digits_pattern_count === 0) {
						return true;
					}
	
					var leading_digits_pattern_index = Math.min(index_of_leading_digits_pattern, leading_digits_pattern_count - 1);
					var leading_digits_pattern = (0, _metadata.get_format_leading_digits_patterns)(format)[leading_digits_pattern_index];
	
					// Brackets are required for `^` to be applied to
					// all or-ed (`|`) parts, not just the first one.
					return new RegExp('^(' + leading_digits_pattern + ')').test(leading_digits);
				});
	
				// If there was a phone number format chosen
				// and it no longer holds given the new leading digits then reset it.
				// The test for this `if` condition is marked as:
				// "Reset a chosen format when it no longer holds given the new leading digits".
				if (this.chosen_format && this.matching_formats.indexOf(this.chosen_format) === -1) {
					this.reset_format();
				}
			}
		}, {
			key: 'should_format',
			value: function should_format() {
				// Start matching any formats at all when the national number
				// entered so far is at least 3 digits long,
				// otherwise format matching would give false negatives
				// like when the digits entered so far are `2`
				// and the leading digits pattern is `21` –
				// it's quite obvious in this case that the format could be the one
				// but due to the absence of further digits it would give false negative.
				//
				// Google could have provided leading digits patterns starting
				// with a single digit but they chose not to (for whatever reasons).
				//
				return this.national_number >= MIN_LEADING_DIGITS_LENGTH;
			}
	
			// Check to see if there is an exact pattern match for these digits. If so, we
			// should use this instead of any other formatting template whose
			// leadingDigitsPattern also matches the input.
	
		}, {
			key: 'attempt_to_format_complete_phone_number',
			value: function attempt_to_format_complete_phone_number() {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = (0, _getIterator3.default)(this.matching_formats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var format = _step.value;
	
						var matcher = new RegExp('^(?:' + (0, _metadata.get_format_pattern)(format) + ')$');
	
						if (!matcher.test(this.national_number)) {
							continue;
						}
	
						if (!this.validate_format(format)) {
							continue;
						}
	
						// To leave the formatter in a consistent state
						this.reset_format();
						this.chosen_format = format;
	
						var formatted_number = (0, _format.format_national_number_using_format)(this.national_number, format, this.is_international(), this.national_prefix.length > 0, this.country_metadata);
	
						// Set `this.template` and `this.partially_populated_template`.
						//
						// `else` case doesn't ever happen
						// with the current metadata,
						// but just in case.
						//
						/* istanbul ignore else */
						if (this.create_formatting_template(format)) {
							// Populate `this.partially_populated_template`
							this.reformat_national_number();
						} else {
							// Prepend `+CountryCode` in case of an international phone number
							var full_number = this.full_phone_number(formatted_number);
							this.template = full_number.replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
							this.partially_populated_template = full_number;
						}
	
						return formatted_number;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
	
			// Prepends `+CountryCode` in case of an international phone number
	
		}, {
			key: 'full_phone_number',
			value: function full_phone_number(formatted_national_number) {
				if (this.is_international()) {
					return '+' + this.country_phone_code + ' ' + formatted_national_number;
				}
	
				return formatted_national_number;
			}
	
			// Extracts the country calling code from the beginning
			// of the entered `national_number` (so far),
			// and places the remaining input into the `national_number`.
	
		}, {
			key: 'extract_country_phone_code',
			value: function extract_country_phone_code() {
				if (!this.national_number) {
					return;
				}
	
				var _parse_phone_number_a = (0, _parse.parse_phone_number_and_country_phone_code)(this.parsed_input, this.metadata),
				    country_phone_code = _parse_phone_number_a.country_phone_code,
				    number = _parse_phone_number_a.number;
	
				if (!country_phone_code) {
					return;
				}
	
				this.country_phone_code = country_phone_code;
				this.national_number = number;
	
				return this.country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, this.metadata);
			}
		}, {
			key: 'extract_national_prefix',
			value: function extract_national_prefix() {
				this.national_prefix = '';
	
				if (!this.country_metadata) {
					return;
				}
	
				var national_number = (0, _parse.strip_national_prefix)(this.national_number, this.country_metadata);
	
				if (national_number !== this.national_number) {
					this.national_prefix = this.national_number.slice(0, this.national_number.length - national_number.length);
					this.national_number = national_number;
				}
	
				return this.national_prefix;
			}
		}, {
			key: 'choose_another_format',
			value: function choose_another_format() {
				// When there are multiple available formats, the formatter uses the first
				// format where a formatting template could be created.
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = (0, _getIterator3.default)(this.matching_formats), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var format = _step2.value;
	
						// If this format is currently being used
						// and is still possible, then stick to it.
						if (this.chosen_format === format) {
							return;
						}
	
						// If this `format` is suitable for "as you type",
						// then extract the template from this format
						// and use it to format the phone number being input.
	
						if (!this.validate_format(format)) {
							continue;
						}
	
						if (!this.create_formatting_template(format)) {
							continue;
						}
	
						this.chosen_format = format;
	
						// With a new formatting template, the matched position
						// using the old template needs to be reset.
						this.last_match_position = -1;
	
						return true;
					}
	
					// No format matches the phone number,
					// therefore set `country` to `undefined`
					// (or to the default country).
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				this.reset_country();
	
				// No format matches the national phone number entered
				this.reset_format();
			}
		}, {
			key: 'validate_format',
			value: function validate_format(format) {
				// If national prefix is mandatory for this phone number format
				// and the user didn't input the national prefix,
				// then this phone number format isn't suitable.
				if (!this.is_international() && !this.national_prefix && (0, _metadata.get_format_national_prefix_is_mandatory_when_formatting)(format, this.country_metadata)) {
					return;
				}
	
				return true;
			}
		}, {
			key: 'create_formatting_template',
			value: function create_formatting_template(format) {
				// The formatter doesn't format numbers when numberPattern contains '|', e.g.
				// (20|3)\d{4}. In those cases we quickly return.
				// (Though there's no such format in current metadata)
				/* istanbul ignore if */
				if ((0, _metadata.get_format_pattern)(format).indexOf('|') >= 0) {
					return;
				}
	
				// Get formatting template for this phone number format
				var template = this.get_template_for_phone_number_format_pattern(format);
	
				// If the national number entered is too long
				// for any phone number format, then abort.
				if (!template) {
					return;
				}
	
				// This one is for national number only
				this.partially_populated_template = template;
	
				// For convenience, the public `.template` property
				// contains the whole international number
				// if the phone number being input is international:
				// 'x' for the '+' sign, 'x'es for the country phone code,
				// a spacebar and then the template for the formatted national number.
				if (this.is_international()) {
					this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.country_phone_code.length) + ' ' + template;
				}
				// For local numbers, replace national prefix
				// with a digit placeholder.
				else {
						this.template = template.replace(/\d/g, DIGIT_PLACEHOLDER);
					}
	
				// This one is for the full phone number
				return this.template;
			}
	
			// Generates formatting template for a phone number format
	
		}, {
			key: 'get_template_for_phone_number_format_pattern',
			value: function get_template_for_phone_number_format_pattern(format) {
				var national_prefix_formatting_rule = (0, _metadata.get_format_national_prefix_formatting_rule)(format, this.country_metadata);
	
				// A very smart trick by the guys at Google
				var number_pattern = (0, _metadata.get_format_pattern)(format)
				// Replace anything in the form of [..] with \d
				.replace(CHARACTER_CLASS_PATTERN, '\\d')
				// Replace any standalone digit (not the one in `{}`) with \d
				.replace(STANDALONE_DIGIT_PATTERN, '\\d');
	
				// This match will always succeed,
				// because the "longest dummy phone number"
				// has enough length to accomodate any possible
				// national phone number format pattern.
				var dummy_phone_number_matching_format_pattern = LONGEST_DUMMY_PHONE_NUMBER.match(number_pattern)[0];
	
				// If the national number entered is too long
				// for any phone number format, then abort.
				if (this.national_number.length > dummy_phone_number_matching_format_pattern.length) {
					return;
				}
	
				// Prepare the phone number format
				var number_format = this.get_format_format(format, national_prefix_formatting_rule);
	
				// Get a formatting template which can be used to efficiently format
				// a partial number where digits are added one by one.
	
				// Below `strict_pattern` is used for the
				// regular expression (with `^` and `$`).
				// This wasn't originally in Google's `libphonenumber`
				// and I guess they don't really need it
				// because they're not using "templates" to format phone numbers
				// but I added `strict_pattern` after encountering
				// South Korean phone number formatting bug.
				//
				// Non-strict regular expression bug demonstration:
				//
				// this.national_number : `111111111` (9 digits)
				//
				// number_pattern : (\d{2})(\d{3,4})(\d{4})
				// number_format : `$1 $2 $3`
				// dummy_phone_number_matching_format_pattern : `9999999999` (10 digits)
				//
				// '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
				//
				// template : xx xxxx xxxx
				//
				// But the correct template in this case is `xx xxx xxxx`.
				// The template was generated incorrectly because of the
				// `{3,4}` variability in the `number_pattern`.
				//
				// The fix is, if `this.national_number` has already sufficient length
				// to satisfy the `number_pattern` completely then `this.national_number` is used
				// instead of `dummy_phone_number_matching_format_pattern`.
	
				var strict_pattern = new RegExp('^' + number_pattern + '$');
				var national_number_dummy_digits = this.national_number.replace(/\d/g, DUMMY_DIGIT);
	
				// If `this.national_number` has already sufficient length
				// to satisfy the `number_pattern` completely then use it
				// instead of `dummy_phone_number_matching_format_pattern`.
				if (strict_pattern.test(national_number_dummy_digits)) {
					dummy_phone_number_matching_format_pattern = national_number_dummy_digits;
				}
	
				// Generate formatting template for this phone number format
				return dummy_phone_number_matching_format_pattern
				// Format the dummy phone number according to the format
				.replace(new RegExp(number_pattern), number_format)
				// Replace each dummy digit with a DIGIT_PLACEHOLDER
				.replace(DUMMY_DIGIT_MATCHER, DIGIT_PLACEHOLDER);
			}
		}, {
			key: 'format_next_national_number_digits',
			value: function format_next_national_number_digits(digits) {
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;
	
				try {
					for (var _iterator3 = (0, _getIterator3.default)(digits), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var digit = _step3.value;
	
						// If there is room for more digits in current `template`,
						// then set the next digit in the `template`,
						// and return the formatted digits so far.
	
						// If more digits are entered than the current format could handle
						if (this.partially_populated_template.slice(this.last_match_position + 1).search(DIGIT_PLACEHOLDER_MATCHER) === -1) {
							// Reset the current format,
							// so that the new format will be chosen
							// in a subsequent `this.choose_another_format()` call
							// later in code.
							this.chosen_format = undefined;
							this.template = undefined;
							this.partially_populated_template = undefined;
							return;
						}
	
						this.last_match_position = this.partially_populated_template.search(DIGIT_PLACEHOLDER_MATCHER);
						this.partially_populated_template = this.partially_populated_template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
					}
	
					// Return the formatted phone number so far
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
	
				return close_dangling_braces(this.partially_populated_template, this.last_match_position + 1).replace(DIGIT_PLACEHOLDER_MATCHER_GLOBAL, ' ');
			}
		}, {
			key: 'is_international',
			value: function is_international() {
				return this.parsed_input && this.parsed_input[0] === '+';
			}
		}, {
			key: 'get_format_format',
			value: function get_format_format(format, national_prefix_formatting_rule) {
				var number_format = this.is_international() ? (0, _metadata.get_format_international_format)(format) : (0, _metadata.get_format_format)(format);
	
				// If national prefix formatting rule is set
				// for this phone number format
				if (national_prefix_formatting_rule) {
					// If the user did input the national prefix
					// (or if the national prefix formatting rule does not require national prefix)
					// then maybe make it part of the phone number template
					if (this.national_prefix || !(0, _metadata.get_format_uses_national_prefix)(national_prefix_formatting_rule)) {
						// Make the national prefix part of the phone number template
						number_format = number_format.replace(_format.FIRST_GROUP_PATTERN, national_prefix_formatting_rule);
					}
				}
	
				if (this.is_international()) {
					return (0, _format.local_to_international_style)(number_format);
				}
	
				return number_format;
			}
	
			// Determines the country of the phone number
			// entered so far based on the country phone code
			// and the national phone number.
	
		}, {
			key: 'determine_the_country',
			value: function determine_the_country() {
				this.country = (0, _parse.find_country_code)(this.country_phone_code, this.national_number, this.metadata);
			}
		}]);
		return as_you_type;
	}();
	
	exports.default = as_you_type;
	function close_dangling_braces(template, cut_before) {
		var retained_template = template.slice(0, cut_before);
	
		var opening_braces = count_occurences('(', retained_template);
		var closing_braces = count_occurences(')', retained_template);
	
		var dangling_braces = opening_braces - closing_braces;
	
		while (dangling_braces > 0 && cut_before < template.length) {
			if (template[cut_before] === ')') {
				dangling_braces--;
			}
			cut_before++;
		}
	
		return template.slice(0, cut_before);
	}
	
	// Counts all occurences of a symbol in a string
	function count_occurences(symbol, string) {
		var count = 0;
	
		var _iteratorNormalCompletion4 = true;
		var _didIteratorError4 = false;
		var _iteratorError4 = undefined;
	
		try {
			for (var _iterator4 = (0, _getIterator3.default)(string), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
				var character = _step4.value;
	
				if (character === symbol) {
					count++;
				}
			}
		} catch (err) {
			_didIteratorError4 = true;
			_iteratorError4 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion4 && _iterator4.return) {
					_iterator4.return();
				}
			} finally {
				if (_didIteratorError4) {
					throw _iteratorError4;
				}
			}
		}
	
		return count;
	}
	
	// Repeats a string (or a symbol) N times.
	// http://stackoverflow.com/questions/202605/repeat-string-javascript
	function repeat(string, times) {
		if (times < 1) {
			return '';
		}
	
		var result = '';
	
		while (times > 1) {
			if (times & 1) {
				result += string;
			}
	
			times >>= 1;
			string += string;
		}
	
		return result + string;
	}
	//# sourceMappingURL=AsYouType.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(903),
	    isLength = __webpack_require__(536),
	    isObjectLike = __webpack_require__(518);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	/**
	 * Note: This is intended as a stop-gap for accessibility concerns that the
	 * Bootstrap CSS does not address as they have styled anchors and not buttons
	 * in many cases.
	 */
	
	var SafeAnchor = (function (_React$Component) {
	  _inherits(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props) {
	    _classCallCheck(this, SafeAnchor);
	
	    _React$Component.call(this, props);
	
	    this.handleClick = this.handleClick.bind(this);
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    if (this.props.href === undefined) {
	      event.preventDefault();
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    return _react2['default'].createElement('a', _extends({ role: this.props.href ? undefined : 'button'
	    }, this.props, {
	      onClick: _utilsCreateChainedFunction2['default'](this.props.onClick, this.handleClick),
	      href: this.props.href || '' }));
	  };
	
	  return SafeAnchor;
	})(_react2['default'].Component);
	
	exports['default'] = SafeAnchor;
	
	SafeAnchor.propTypes = {
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func
	};
	module.exports = exports['default'];

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1574), __esModule: true };

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(816);
	var ReactMultiChildUpdateTypes = __webpack_require__(485);
	var ReactPerf = __webpack_require__(64);
	
	var setInnerHTML = __webpack_require__(181);
	var setTextContent = __webpack_require__(254);
	var invariant = __webpack_require__(14);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(474);
	var ReactDOMServer = __webpack_require__(831);
	var ReactIsomorphic = __webpack_require__(835);
	
	var assign = __webpack_require__(22);
	var deprecated = __webpack_require__(856);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(79);
	var ReactElement = __webpack_require__(41);
	
	var emptyFunction = __webpack_require__(65);
	var traverseAllChildren = __webpack_require__(256);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(473);
	var ReactElement = __webpack_require__(41);
	var ReactPropTypeLocations = __webpack_require__(177);
	var ReactPropTypeLocationNames = __webpack_require__(176);
	var ReactNoopUpdateQueue = __webpack_require__(487);
	
	var assign = __webpack_require__(22);
	var emptyObject = __webpack_require__(145);
	var invariant = __webpack_require__(14);
	var keyMirror = __webpack_require__(182);
	var keyOf = __webpack_require__(85);
	var warning = __webpack_require__(23);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(487);
	
	var canDefineProperty = __webpack_require__(179);
	var emptyObject = __webpack_require__(145);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(78);
	var ReactDOMTextComponent = __webpack_require__(477);
	var ReactDefaultInjection = __webpack_require__(478);
	var ReactInstanceHandles = __webpack_require__(109);
	var ReactMount = __webpack_require__(39);
	var ReactPerf = __webpack_require__(64);
	var ReactReconciler = __webpack_require__(105);
	var ReactUpdates = __webpack_require__(55);
	var ReactVersion = __webpack_require__(247);
	
	var findDOMNode = __webpack_require__(248);
	var renderSubtreeIntoContainer = __webpack_require__(860);
	var warning = __webpack_require__(23);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(242);
	var ReactMount = __webpack_require__(39);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(22);
	var warning = __webpack_require__(23);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(468);
	var DOMPropertyOperations = __webpack_require__(241);
	var ReactComponentBrowserEnvironment = __webpack_require__(243);
	var ReactMount = __webpack_require__(39);
	
	var assign = __webpack_require__(22);
	var escapeTextContentForBrowser = __webpack_require__(180);
	var setTextContent = __webpack_require__(254);
	var validateDOMNesting = __webpack_require__(257);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(812);
	var ChangeEventPlugin = __webpack_require__(814);
	var ClientReactRootIndex = __webpack_require__(815);
	var DefaultEventPluginOrder = __webpack_require__(817);
	var EnterLeaveEventPlugin = __webpack_require__(818);
	var ExecutionEnvironment = __webpack_require__(36);
	var HTMLDOMPropertyConfig = __webpack_require__(821);
	var ReactBrowserComponentMixin = __webpack_require__(822);
	var ReactComponentBrowserEnvironment = __webpack_require__(243);
	var ReactDefaultBatchingStrategy = __webpack_require__(264);
	var ReactDOMComponent = __webpack_require__(826);
	var ReactDOMTextComponent = __webpack_require__(477);
	var ReactEventListener = __webpack_require__(834);
	var ReactInjection = __webpack_require__(527);
	var ReactInstanceHandles = __webpack_require__(109);
	var ReactMount = __webpack_require__(39);
	var ReactReconcileTransaction = __webpack_require__(837);
	var SelectEventPlugin = __webpack_require__(843);
	var ServerReactRootIndex = __webpack_require__(844);
	var SimpleEventPlugin = __webpack_require__(845);
	var SVGDOMPropertyConfig = __webpack_require__(842);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(41);
	var ReactPropTypeLocations = __webpack_require__(177);
	var ReactPropTypeLocationNames = __webpack_require__(176);
	var ReactCurrentOwner = __webpack_require__(78);
	
	var canDefineProperty = __webpack_require__(179);
	var getIteratorFn = __webpack_require__(252);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(41);
	var ReactEmptyComponentRegistry = __webpack_require__(481);
	var ReactReconciler = __webpack_require__(105);
	
	var assign = __webpack_require__(22);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	function registerNullComponentID() {
	  ReactEmptyComponentRegistry.registerNullComponentID(this._rootNodeID);
	}
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    transaction.getReactMountReady().enqueue(registerNullComponentID, this);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(830);
	
	var containsNode = __webpack_require__(496);
	var focusNode = __webpack_require__(497);
	var getActiveElement = __webpack_require__(498);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(854);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(182);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(22);
	var invariant = __webpack_require__(14);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(23);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(41);
	var ReactPropTypeLocationNames = __webpack_require__(176);
	
	var emptyFunction = __webpack_require__(65);
	var getIteratorFn = __webpack_require__(252);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED') == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(65);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(869);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(174);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(333);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(237).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(504);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(183).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(138);
	util.inherits = __webpack_require__(89);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(886);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(875);
	var destroyImpl = __webpack_require__(503);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(107);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(505).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(107);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(505).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(90)))

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(107);
	
	/*<replacement>*/
	var util = __webpack_require__(138);
	util.inherits = __webpack_require__(89);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(174);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(237).EventEmitter;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(183).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 507 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ASSIGNED_ENTITIES = exports.ASSIGNED_ENTITIES = ['CallCenter', 'ClientAccount'];
	var ACCOUNTABLE_ENTITIES = exports.ACCOUNTABLE_ENTITIES = ['CallCenter', 'ClientAccount', 'None'];
	
	var TicketClaim = exports.TicketClaim = function TicketClaim() {
	    _classCallCheck(this, TicketClaim);
	};
	
	TicketClaim.findLastCallCenterActor = function (ticketClaim) {
	    if (ticketClaim.ticketClaimChallengeAnswer) return ticketClaim.ticketClaimChallengeAnswer.answeredBy;
	    if (ticketClaim.ticketClaimAnswer) return ticketClaim.ticketClaimAnswer.answeredBy;
	    if (ticketClaim.ticketClaimQualification) return ticketClaim.ticketClaimQualification.qualifiedBy;
	    return null;
	};
	
	TicketClaim.findLastClientActor = function (ticketClaim) {
	    if (ticketClaim.ticketClaimChallenge) return ticketClaim.ticketClaimChallenge.challengedBy;
	    return ticketClaim.openedBy;
	};
	
	TicketClaim.findLastCallCenterAction = function (ticketClaim) {
	    var state = ticketClaim.state;
	
	    switch (state) {
	        case 'ChallengeAnswered':
	            return state;
	        case 'Challenged':
	            return 'Answered';
	        case 'Answered':
	            return state;
	        case 'Qualified':
	            return state;
	        default:
	            return null;
	    }
	};
	
	TicketClaim.findLastClientAction = function (ticketClaim) {
	    var state = ticketClaim.state;
	
	    switch (state) {
	        case 'ChallengeAnswered':
	            return 'Challenged';
	        case 'Challenged':
	            return state;
	        case 'Answered':
	            return 'Opened';
	        case 'Qualified':
	            return 'Opened';
	        case 'Opened':
	            return state;
	        default:
	            return null;
	    }
	};
	
	TicketClaim.findPriority = function (ticketClaim) {
	    if (ticketClaim.urgencyLevel) return ticketClaim.urgencyLevel;
	    if (ticketClaim.ticketClaimQualification) return ticketClaim.ticketClaimQualification.treatmentPriority;
	    return null;
	};
	
	var OpenTicketClaimCmd = exports.OpenTicketClaimCmd = function OpenTicketClaimCmd() {
	    _classCallCheck(this, OpenTicketClaimCmd);
	};
	
	OpenTicketClaimCmd.schema = {
	    oneOf: [{
	        type: 'object',
	        properties: {
	            urgencyLevelUid: { type: ['string', 'null'] },
	            description: { type: 'string' },
	            commandType: {
	                type: 'string',
	                enum: ['OpenTicketClaim']
	            }
	        },
	        required: ['description', 'commandType']
	    }, {
	        type: 'object',
	        properties: {
	            ticketReference: { type: 'string' },
	            externalClientName: { type: ['string', 'null'] },
	            externalPatrimonyReference: { type: ['string', 'null'] },
	            externalCallDate: { type: 'date' },
	            agencyUid: { type: 'string' },
	            urgencyLevelUid: { type: ['string', 'null'] },
	            description: { type: 'string' },
	            commandType: {
	                type: 'string',
	                enum: ['OpenTicketClaimOnExternalTicket']
	            }
	        },
	        required: ['ticketReference', 'externalCallDate', 'agencyUid', 'description', 'commandType']
	    }]
	};
	
	OpenTicketClaimCmd.selectSchema = function (cmd) {
	    var commandType = cmd && cmd.commandType || 'OpenTicketClaimOnExternalTicket';
	
	    return OpenTicketClaimCmd.schema.oneOf.find(function (schema) {
	        return schema.properties.commandType.enum.indexOf(commandType) >= 0;
	    });
	};
	
	var QualifyTicketClaimCmd = exports.QualifyTicketClaimCmd = function QualifyTicketClaimCmd() {
	    _classCallCheck(this, QualifyTicketClaimCmd);
	};
	
	QualifyTicketClaimCmd.schema = {
	    type: 'object',
	    properties: {
	        ticketClaimCategoryUid: { type: 'string' },
	        treatmentPriorityUid: { type: ['string', 'null'] },
	        comment: { type: 'string' }
	    },
	    required: ['ticketClaimCategoryUid', 'comment']
	};
	
	var AnswerTicketClaimCmd = exports.AnswerTicketClaimCmd = function AnswerTicketClaimCmd() {
	    _classCallCheck(this, AnswerTicketClaimCmd);
	};
	
	AnswerTicketClaimCmd.schema = {
	    type: 'object',
	    properties: {
	        failureCauseUid: { type: 'string' },
	        postAnalysisUid: { type: 'string' },
	        severityUid: { type: 'string' },
	        assignedEntities: {
	            type: 'array',
	            minItems: 1
	        },
	        accountableEntities: {
	            type: 'array',
	            minItems: 1
	        },
	        comment: { type: 'string' }
	    },
	    required: ['failureCauseUid', 'postAnalysisUid', 'severityUid', 'assignedEntities', 'accountableEntities', 'comment']
	};
	
	var ChallengeTicketClaimCmd = exports.ChallengeTicketClaimCmd = function ChallengeTicketClaimCmd() {
	    _classCallCheck(this, ChallengeTicketClaimCmd);
	};
	
	ChallengeTicketClaimCmd.schema = {
	    type: 'object',
	    properties: {
	        comment: { type: 'string' }
	    },
	    required: ['comment']
	};
	
	var AnswerChallengeTicketClaimCmd = exports.AnswerChallengeTicketClaimCmd = function AnswerChallengeTicketClaimCmd() {
	    _classCallCheck(this, AnswerChallengeTicketClaimCmd);
	};
	
	AnswerChallengeTicketClaimCmd.schema = {
	    type: 'object',
	    properties: {
	        comment: { type: 'string' }
	    },
	    required: ['comment']
	};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// workaround for missing displayName
	_reactBootstrap.Input.displayName = 'Input';
	
	var CheckboxToggle = function (_Component) {
	    _inherits(CheckboxToggle, _Component);
	
	    function CheckboxToggle() {
	        _classCallCheck(this, CheckboxToggle);
	
	        return _possibleConstructorReturn(this, (CheckboxToggle.__proto__ || Object.getPrototypeOf(CheckboxToggle)).apply(this, arguments));
	    }
	
	    _createClass(CheckboxToggle, [{
	        key: '_check',
	        value: function _check(item) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange,
	                identify = _props.identify;
	
	
	            var previousValue = value || [];
	            var itemId = identify(item);
	            var index = previousValue.findIndex(function (v) {
	                return identify(v) == itemId;
	            });
	
	            var nextValue = [].concat(_toConsumableArray(previousValue));
	            if (index >= 0) {
	                nextValue.splice(index, 1);
	            } else {
	                nextValue.push(item);
	            }
	            onChange(nextValue);
	        }
	    }, {
	        key: '_isChecked',
	        value: function _isChecked(item) {
	            var _props2 = this.props,
	                value = _props2.value,
	                identify = _props2.identify;
	
	
	            var itemId = identify(item);
	            return value && value.find(function (v) {
	                return identify(v) == itemId;
	            }) != null || false;
	        }
	    }, {
	        key: '_enhance',
	        value: function _enhance(children) {
	            var _this2 = this;
	
	            return _react2.default.Children.map(children, function (child) {
	                if (child && child.type && (child.type == 'input' || child.type.displayName == 'Input')) {
	                    var value = child.props.value;
	
	
	                    return _react2.default.cloneElement(child, {
	                        checked: _this2._isChecked(value),
	                        onChange: function onChange() {
	                            return _this2._check(value);
	                        }
	                    });
	                }
	                if (child && child.props) {
	                    var _children = child.props.children;
	
	
	                    return _children && _react2.default.cloneElement(child, {
	                        children: _this2._enhance(_children)
	                    }) || child;
	                }
	                return child;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                children = _props3.children,
	                value = _props3.value,
	                onChange = _props3.onChange;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this._enhance(children)
	            );
	        }
	    }]);
	
	    return CheckboxToggle;
	}(_react.Component);
	
	CheckboxToggle.propTypes = {
	    identify: _react.PropTypes.func,
	    value: _react.PropTypes.array,
	    onChange: _react.PropTypes.func.isRequired
	};
	CheckboxToggle.defaultProps = {
	    identify: function identify(v) {
	        return v;
	    }
	};
	exports.default = CheckboxToggle;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1043);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _i18n = __webpack_require__(545);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SearchBar = __webpack_require__(2218);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchBar = function (_Component) {
	    _inherits(SearchBar, _Component);
	
	    function SearchBar(props) {
	        _classCallCheck(this, SearchBar);
	
	        var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));
	
	        _this.state = {
	            opened: false,
	            searched: false
	        };
	        return _this;
	    }
	
	    _createClass(SearchBar, [{
	        key: '_toggle',
	        value: function _toggle(event) {
	            var _props = this.props,
	                onOpen = _props.onOpen,
	                onClose = _props.onClose;
	            var opened = this.state.opened;
	
	
	            event.preventDefault();
	            this.setState({ opened: !opened });
	
	            if (opened) {
	                onClose();
	            } else {
	                onOpen();
	            }
	        }
	    }, {
	        key: '_click',
	        value: function _click(event) {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                onClick = _props2.onClick,
	                value = _props2.value;
	
	
	            event.preventDefault();
	
	            if (onClick) {
	                Promise.resolve(onClick(event)).then(function () {
	                    _this2.setState({ searched: !!value });
	                });
	            }
	        }
	    }, {
	        key: '_keyPress',
	        value: function _keyPress(event) {
	            var _this3 = this;
	
	            var _props3 = this.props,
	                onKeyPress = _props3.onKeyPress,
	                value = _props3.value;
	
	
	            if (onKeyPress && event.key == 'Enter') {
	                Promise.resolve(onKeyPress(event)).then(function () {
	                    _this3.setState({ searched: !!value });
	                });
	            }
	        }
	    }, {
	        key: '_change',
	        value: function _change(event) {
	            var onChange = this.props.onChange;
	
	
	            if (onChange) {
	                onChange(event);
	                this.setState({ searched: false });
	            }
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _this4 = this;
	
	            var _props4 = this.props,
	                onClick = _props4.onClick,
	                onChange = _props4.onChange;
	
	
	            event.preventDefault();
	
	            if (onClick && onChange) {
	                onChange(null);
	                setTimeout(function () {
	                    // wait parent component receives new props
	                    Promise.resolve(onClick()).then(function () {
	                        _this4.setState({ searched: false });
	                    });
	                }, 0);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _props5 = this.props,
	                children = _props5.children,
	                size = _props5.size,
	                footer = _props5.footer,
	                onOpen = _props5.onOpen,
	                onClose = _props5.onClose,
	                onClick = _props5.onClick,
	                onChange = _props5.onChange,
	                onKeyPress = _props5.onKeyPress,
	                other = _objectWithoutProperties(_props5, ['children', 'size', 'footer', 'onOpen', 'onClose', 'onClick', 'onChange', 'onKeyPress']);
	
	            var _state = this.state,
	                opened = _state.opened,
	                searched = _state.searched;
	
	            var sizeClass = size && size.toLowerCase();
	
	            var transitionName = {
	                enter: _SearchBar2.default.enter,
	                enterActive: _SearchBar2.default.enterActive,
	                leave: _SearchBar2.default.leave,
	                leaveActive: _SearchBar2.default.leaveActive
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_SearchBar2.default.default, _SearchBar2.default[sizeClass]) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _SearchBar2.default.header },
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        null,
	                        children && _react2.default.createElement(
	                            'div',
	                            { className: _SearchBar2.default.advance },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _SearchBar2.default.advanceContent },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        onClick: function onClick(e) {
	                                            return _this5._toggle(e);
	                                        } },
	                                    _i18n2.default.advancedSearch,
	                                    _react2.default.createElement(_Icon2.default, {
	                                        icon: opened && 'up' || 'down',
	                                        size: 'sm' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _SearchBar2.default.search },
	                            searched && _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this5._clear(e);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'cross',
	                                    size: 'md',
	                                    active: sizeClass != 'small' })
	                            ),
	                            !searched && _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this5._click(e);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'search',
	                                    size: 'md',
	                                    active: sizeClass != 'small' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _SearchBar2.default.container },
	                                _react2.default.createElement('input', _extends({
	                                    type: 'text',
	                                    onChange: function onChange(e) {
	                                        return _this5._change(e);
	                                    },
	                                    onKeyPress: function onKeyPress(e) {
	                                        return _this5._keyPress(e);
	                                    }
	                                }, other))
	                            )
	                        )
	                    )
	                ),
	                children && _react2.default.createElement(
	                    _reactAddonsCssTransitionGroup2.default,
	                    {
	                        transitionName: transitionName,
	                        transitionEnterTimeout: 500,
	                        transitionLeaveTimeout: 500 },
	                    opened && _react2.default.createElement(
	                        'div',
	                        { className: _SearchBar2.default.body },
	                        _react2.default.createElement(
	                            _reactBootstrap.Grid,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: _SearchBar2.default.container },
	                                children
	                            )
	                        )
	                    )
	                ),
	                footer && _react2.default.createElement(
	                    'div',
	                    { className: _SearchBar2.default.footer },
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _SearchBar2.default.container },
	                            footer
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchBar;
	}(_react.Component);
	
	SearchBar.propTypes = {
	    size: _react.PropTypes.string,
	    footer: _react.PropTypes.object,
	    onOpen: _react.PropTypes.func,
	    onClose: _react.PropTypes.func
	};
	SearchBar.defaultProps = {
	    onOpen: function onOpen() {},
	    onClose: function onClose() {}
	};
	exports.default = SearchBar;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.circlePath = circlePath;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _RootCloseWrapper = __webpack_require__(1243);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _StaticMap = __webpack_require__(2220);
	
	var _StaticMap2 = _interopRequireDefault(_StaticMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ABC = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	
	function circlePath(center, radius) {
	    var googleCenter = new google.maps.LatLng(center);
	
	    var path = [];
	    for (var i = 0; i < 360; i += 8) {
	        var latLng = google.maps.geometry.spherical.computeOffset(googleCenter, radius, i);
	        path.push(latLng);
	    }
	    return path;
	}
	
	function markerLatLng(latLng) {
	    return latLng.lat + ',' + latLng.lng;
	}
	
	function displayAddress(address) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        address.quality && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                null,
	                address.quality
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                null,
	                address.number
	            ),
	            _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                address.street
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                null,
	                address.zipCode
	            ),
	            _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                address.city
	            )
	        )
	    );
	}
	
	var StaticMap = function (_Component) {
	    _inherits(StaticMap, _Component);
	
	    function StaticMap(props) {
	        _classCallCheck(this, StaticMap);
	
	        var _this = _possibleConstructorReturn(this, (StaticMap.__proto__ || Object.getPrototypeOf(StaticMap)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(StaticMap, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                apiKey = _props.apiKey,
	                path = _props.path,
	                identify = _props.identify,
	                value = _props.value;
	
	
	            var src = this._imageSrc((0, _reactDom.findDOMNode)(this), apiKey, path, identify, value);
	            this.setState({ src: src });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.value != this.props.value || nextProps.path != this.props.path) {
	                var apiKey = nextProps.apiKey,
	                    path = nextProps.path,
	                    identify = nextProps.identify,
	                    value = nextProps.value;
	
	
	                clearTimeout(this._timer);
	                this._timer = setTimeout(function () {
	                    // wait for element to get his size
	                    var src = _this2._imageSrc((0, _reactDom.findDOMNode)(_this2), apiKey, path, identify, value);
	                    _this2.setState({ src: src });
	                }, 0);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: '_imageSrc',
	        value: function _imageSrc(element, apiKey, path, identify, value) {
	            if (element.offsetWidth && element.offsetHeight) {
	                var options = {
	                    key: apiKey,
	                    size: element.offsetWidth + 'x' + element.offsetHeight
	                };
	
	                if (path) {
	                    options.path = 'fillcolor:0xAA000033|color:0xFFFFFF00|enc:' + google.maps.geometry.encoding.encodePath(path);
	                }
	
	                options.markers = value.map(function (v, i) {
	                    var latLng = identify(v);
	                    return latLng && 'label:' + ABC.charAt(i) + '|' + markerLatLng(latLng);
	                });
	
	                var query = Object.keys(options).filter(function (k) {
	                    return options[k];
	                }).map(function (key) {
	                    var option = options[key];
	
	                    if (option instanceof Array) {
	                        return option.filter(function (o) {
	                            return o;
	                        }).map(function (v) {
	                            return key + '=' + encodeURIComponent(v);
	                        }).join('&');
	                    }
	                    return key + '=' + encodeURIComponent(option);
	                });
	
	                var queryString = query.join('&');
	                var src = 'https://maps.googleapis.com/maps/api/staticmap?' + queryString;
	                return src;
	            }
	            return null;
	        }
	    }, {
	        key: '_toggle',
	        value: function _toggle() {
	            var opened = this.state.opened;
	
	            this.setState({ opened: !opened });
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({ opened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                ratio = _props2.ratio,
	                info = _props2.info,
	                display = _props2.display,
	                value = _props2.value;
	            var _state = this.state,
	                src = _state.src,
	                opened = _state.opened;
	
	
	            var defaultStyle = {
	                paddingBottom: ratio && 100 / ratio + '%' || '100%'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: (0, _classnames2.default)(_StaticMap2.default.default, _defineProperty({}, _StaticMap2.default.clickable, info)),
	                    style: defaultStyle,
	                    onClick: function onClick() {
	                        return _this3._toggle();
	                    } },
	                src && _react2.default.createElement('img', { src: src }),
	                opened && info && _react2.default.createElement(
	                    _RootCloseWrapper2.default,
	                    { noWrap: true,
	                        onRootClose: function onRootClose() {
	                            return _this3._close();
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _StaticMap2.default.info },
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _StaticMap2.default.infoContent },
	                            value.map(function (item, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _StaticMap2.default.label },
	                                        ABC.charAt(index)
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _StaticMap2.default.container },
	                                        display(item)
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StaticMap;
	}(_react.Component);
	
	StaticMap.propTypes = {
	    apiKey: _react.PropTypes.string,
	    ratio: _react.PropTypes.number,
	    info: _react.PropTypes.bool,
	    path: _react.PropTypes.array,
	    identify: _react.PropTypes.func,
	    display: _react.PropTypes.func,
	    value: _react.PropTypes.array.isRequired
	};
	StaticMap.defaultProps = {
	    identify: function identify(v) {
	        return v;
	    },
	    display: displayAddress
	};
	exports.default = StaticMap;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.matcher = matcher;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _control = __webpack_require__(964);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TypeaheadBar = __webpack_require__(2228);
	
	var _TypeaheadBar2 = _interopRequireDefault(_TypeaheadBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function escapeRegExp(value) {
	    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	function matcher(_ref) {
	    var source = _ref.source,
	        _ref$identify = _ref.identify,
	        identify = _ref$identify === undefined ? function (v) {
	        return v;
	    } : _ref$identify;
	
	    return function (q, cb) {
	        var matches;
	
	        if (q) {
	            var regexp = new RegExp(escapeRegExp(q), 'i');
	            matches = source.filter(function (value) {
	                return regexp.test(identify(value));
	            });
	        } else {
	            matches = source;
	        }
	
	        cb(matches);
	    };
	}
	
	var TypeaheadBar = function (_Component) {
	    _inherits(TypeaheadBar, _Component);
	
	    function TypeaheadBar(props) {
	        _classCallCheck(this, TypeaheadBar);
	
	        var _this = _possibleConstructorReturn(this, (TypeaheadBar.__proto__ || Object.getPrototypeOf(TypeaheadBar)).call(this, props));
	
	        _this.state = {
	            matches: []
	        };
	        return _this;
	    }
	
	    _createClass(TypeaheadBar, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var source = this.props.source;
	
	
	            source(null, function (matches) {
	                _this2.setState({ matches: matches });
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this3 = this;
	
	            if (nextProps.source != this.props.source) {
	                var source = nextProps.source;
	                var query = this.state.query;
	
	
	                source(query, function (matches) {
	                    _this3.setState({ matches: matches });
	                });
	            }
	        }
	    }, {
	        key: '_match',
	        value: function _match(event) {
	            var _this4 = this;
	
	            var source = this.props.source;
	
	            var query = event.target.value || null;
	
	            source(query, function (matches) {
	                _this4.setState({ query: query, matches: matches });
	            });
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _this5 = this;
	
	            var source = this.props.source;
	
	            var query = null;
	
	            event.preventDefault();
	
	            source(query, function (matches) {
	                _this5.setState({ query: query, matches: matches });
	            });
	        }
	    }, {
	        key: '_toggle',
	        value: function _toggle(item) {
	            var _props = this.props,
	                identify = _props.identify,
	                value = _props.value,
	                onChange = _props.onChange;
	
	            var itemId = identify(item);
	            var index = value.findIndex(function (value) {
	                return identify(value) == itemId;
	            });
	
	            var nextValue = [].concat(_toConsumableArray(value));
	            if (index >= 0) {
	                nextValue.splice(index, 1);
	            } else {
	                nextValue.push(item);
	            }
	            onChange(nextValue);
	        }
	    }, {
	        key: '_isChecked',
	        value: function _isChecked(item) {
	            var _props2 = this.props,
	                identify = _props2.identify,
	                value = _props2.value;
	
	            var itemId = identify(item);
	
	            return value.find(function (value) {
	                return identify(value) == itemId;
	            }) != null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props3 = this.props,
	                size = _props3.size,
	                split = _props3.split,
	                header = _props3.header,
	                source = _props3.source,
	                display = _props3.display,
	                identify = _props3.identify,
	                value = _props3.value,
	                onChange = _props3.onChange,
	                other = _objectWithoutProperties(_props3, ['size', 'split', 'header', 'source', 'display', 'identify', 'value', 'onChange']);
	
	            var _state = this.state,
	                query = _state.query,
	                matches = _state.matches;
	
	            var sizeClass = size && size.toLowerCase();
	            var resultLength = size == 'small' && matches.length || 16;
	
	            var matchElement = function matchElement(match) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: identify(match) },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            checked: _this6._isChecked(match),
	                            onChange: function onChange() {
	                                return _this6._toggle(match);
	                            } }),
	                        display(match)
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_TypeaheadBar2.default.default, _TypeaheadBar2.default[sizeClass], _defineProperty({}, _TypeaheadBar2.default.split, split)) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _TypeaheadBar2.default.search },
	                    query && _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this6._clear(e);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'cross', size: size == 'small' && 'xs' || 'md' })
	                    ),
	                    !query && _react2.default.createElement(_Icon2.default, { icon: 'search', size: size == 'small' && 'xs' || 'md' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _TypeaheadBar2.default.container },
	                        _react2.default.createElement('input', _extends({
	                            type: 'text',
	                            value: query,
	                            onChange: function onChange(e) {
	                                return _this6._match(e);
	                            }
	                        }, other))
	                    )
	                ),
	                header,
	                _react2.default.createElement(
	                    'div',
	                    { className: _TypeaheadBar2.default.result },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: split && 6 || 12 },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                matches.slice(0, resultLength / 2 + 1).map(matchElement)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: split && 6 || 12 },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                matches.slice(resultLength / 2 + 1, resultLength).map(matchElement)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TypeaheadBar;
	}(_react.Component);
	
	TypeaheadBar.propTypes = {
	    size: _react.PropTypes.string,
	    split: _react.PropTypes.bool,
	    header: _react.PropTypes.object,
	    source: _react.PropTypes.func.isRequired,
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    value: _react.PropTypes.array.isRequired,
	    onChange: _react.PropTypes.func.isRequired
	};
	TypeaheadBar.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    }
	};
	
	
	TypeaheadBar = (0, _control.control)({
	    value: []
	})(TypeaheadBar);
	
	exports.default = TypeaheadBar;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setUIState = setUIState;
	exports.uiReducer = uiReducer;
	exports.hydrate = hydrate;
	exports.uiState = uiState;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DEHYDRATE_KEY = 'Dehydrate/Ui';
	
	var NAMESPACE = 'Core';
	var UI_STATE_SET = exports.UI_STATE_SET = NAMESPACE + '/UIStateSet';
	
	function componentName(component) {
	    var name;
	
	    if (typeof component == 'string') {
	        name = component;
	    } else {
	        name = component.constructor.displayName;
	    }
	
	    return name;
	}
	
	//actions
	
	function setUIState(component, state) {
	    return {
	        type: UI_STATE_SET,
	        component: componentName(component),
	        state: state
	    };
	}
	
	//reducers
	
	function uiReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case UI_STATE_SET:
	            return _extends({}, state, _defineProperty({}, action.component, _extends({}, state[action.component], action.state)));
	        default:
	            return state;
	    }
	}
	
	//actors
	
	function dehydrateUIStateSet() {
	    var uiState;
	
	    return function (state, dispatch) {
	        var nextUiState = state.ui;
	
	        if (nextUiState != uiState) {
	            localStorage.setItem(DEHYDRATE_KEY, JSON.stringify({
	                ui: nextUiState
	            }));
	
	            uiState = nextUiState;
	        }
	    };
	}
	
	var uiActors = exports.uiActors = [dehydrateUIStateSet()];
	
	// hydrate
	
	function hydrate() {
	    return JSON.parse(localStorage.getItem(DEHYDRATE_KEY));
	}
	
	//helpers
	
	function uiState(component, ui) {
	    return ui[componentName(component)] || {};
	}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.connectWizard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.major = major;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NO_STEPS = [];
	
	function major(step) {
	    return Math.trunc(step);
	}
	
	var Wizard = function () {
	    function Wizard(steps, activeStep) {
	        _classCallCheck(this, Wizard);
	
	        this.steps = steps;
	        this.majorSteps = steps.map(function (s) {
	            return Math.trunc(s);
	        });
	        this.activeStep = activeStep;
	        this.majorActiveStep = Math.trunc(activeStep);
	        this.minorActiveStep = Math.round(activeStep % 1 * 10) / 10;
	    }
	
	    _createClass(Wizard, [{
	        key: 'nextStep',
	        value: function nextStep() {
	            var nextActiveStep = this.steps[this.majorSteps.indexOf(this.majorActiveStep) + 1];
	            this._onActiveStepChange(nextActiveStep);
	        }
	    }, {
	        key: 'previousStep',
	        value: function previousStep() {
	            var nextActiveStep = this.steps[this.majorSteps.indexOf(this.majorActiveStep) - 1];
	            this._onActiveStepChange(nextActiveStep);
	        }
	    }, {
	        key: 'setActiveStep',
	        value: function setActiveStep(step) {
	            var nextActiveStep = step < 1 && this.majorActiveStep + step || step;
	            this._onActiveStepChange(nextActiveStep);
	        }
	    }, {
	        key: 'matchActiveStep',
	        value: function matchActiveStep(steps) {
	            steps = steps instanceof Array && steps || [steps];
	            return steps.indexOf(this.activeStep) >= 0 || steps.indexOf(this.majorActiveStep) >= 0 || steps.indexOf(this.minorActiveStep) >= 0;
	        }
	    }, {
	        key: 'hasNextStep',
	        value: function hasNextStep() {
	            return this.majorSteps.indexOf(this.majorActiveStep) < this.majorSteps.length - 1;
	        }
	    }, {
	        key: 'hasPreviousStep',
	        value: function hasPreviousStep() {
	            return this.majorSteps.indexOf(this.majorActiveStep) > 0;
	        }
	    }]);
	
	    return Wizard;
	}();
	
	function connectWizard(options) {
	    var selectSteps = typeof options.steps == 'function' && options.steps || function () {
	        return options.steps || NO_STEPS;
	    };
	    var selectActiveStep = typeof options.activeStep == 'function' && options.activeStep || function (s) {
	        return options.activeStep || s[0];
	    };
	
	    return function (WrappedComponent) {
	        var WizardConnector = function (_Component) {
	            _inherits(WizardConnector, _Component);
	
	            function WizardConnector(props) {
	                _classCallCheck(this, WizardConnector);
	
	                var _this = _possibleConstructorReturn(this, (WizardConnector.__proto__ || Object.getPrototypeOf(WizardConnector)).call(this, props));
	
	                var steps = selectSteps(props);
	                var activeStep = selectActiveStep(steps, props);
	                var nextWizard = _this._createWizard(steps, activeStep);
	
	                _this.state = {
	                    wizard: nextWizard
	                };
	
	                _this._steps = steps;
	                _this._activeStep = activeStep;
	                return _this;
	            }
	
	            _createClass(WizardConnector, [{
	                key: 'componentWillReceiveProps',
	                value: function componentWillReceiveProps(nextProps) {
	                    var wizard = this.state.wizard;
	
	
	                    var steps = selectSteps(nextProps);
	                    var activeStep = selectActiveStep(steps, nextProps);
	
	                    if (steps != this._steps || activeStep != this._activeStep) {
	                        var nextActiveStep = activeStep != this._activeStep && activeStep || wizard.activeStep;
	                        var nextWizard = this._createWizard(steps, nextActiveStep);
	
	                        this.setState({ wizard: nextWizard });
	
	                        this._steps = steps;
	                        this._activeStep = activeStep;
	                    }
	                }
	            }, {
	                key: '_createWizard',
	                value: function _createWizard(steps, activeStep) {
	                    var _this2 = this;
	
	                    var wizard = new Wizard(steps, activeStep);
	
	                    wizard._onActiveStepChange = function (activeStep) {
	                        var nextWizard = _this2._createWizard(steps, activeStep);
	                        _this2.setState({ wizard: nextWizard });
	                    };
	
	                    return wizard;
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state));
	                }
	            }]);
	
	            return WizardConnector;
	        }(_react.Component);
	
	        return WizardConnector;
	    };
	}
	
	exports.connectWizard = connectWizard;

/***/ }),
/* 514 */,
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UserConfigs = exports.ResetLoginDemand = exports.UpdateUserCmd = exports.ResetPasswordCmd = exports.ResetPasswordDemand = exports.ActiveUserCmd = exports.Credential = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.createValidator = createValidator;
	
	var _jjv = __webpack_require__(172);
	
	var _jjv2 = _interopRequireDefault(_jjv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createValidator() {
	    var validator = (0, _jjv2.default)();
	
	    validator.addCheck('equals', function (v, p) {
	        if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) == 'object') {
	            for (var i = 1; i < p.length; i++) {
	                if (v[p[i - 1]] != v[p[i]]) return false;
	            }
	        }
	        return true;
	    });
	
	    return validator;
	}
	
	var Credential = exports.Credential = function Credential() {
	    _classCallCheck(this, Credential);
	};
	
	Credential.schema = {
	    type: 'object',
	    properties: {
	        login: { type: 'string' },
	        password: { type: 'string' }
	    },
	    required: ['login', 'password']
	};
	
	var ActiveUserCmd = exports.ActiveUserCmd = function ActiveUserCmd() {
	    _classCallCheck(this, ActiveUserCmd);
	};
	
	ActiveUserCmd.schema = {
	    type: 'object',
	    properties: {
	        password: { type: 'string' },
	        confirmPassword: { type: 'string' }
	    },
	    equals: ['password', 'confirmPassword'],
	    required: ['password', 'confirmPassword']
	};
	
	var ResetPasswordDemand = exports.ResetPasswordDemand = function ResetPasswordDemand() {
	    _classCallCheck(this, ResetPasswordDemand);
	};
	
	ResetPasswordDemand.schema = {
	    type: 'object',
	    properties: {
	        email: { type: 'string' }
	    },
	    required: ['email']
	};
	
	var ResetPasswordCmd = exports.ResetPasswordCmd = function ResetPasswordCmd() {
	    _classCallCheck(this, ResetPasswordCmd);
	};
	
	ResetPasswordCmd.schema = {
	    type: 'object',
	    properties: {
	        password: { type: 'string' },
	        confirmPassword: { type: 'string' }
	    },
	    equals: ['password', 'confirmPassword'],
	    required: ['password', 'confirmPassword']
	};
	
	var UpdateUserCmd = exports.UpdateUserCmd = function UpdateUserCmd() {
	    _classCallCheck(this, UpdateUserCmd);
	};
	
	UpdateUserCmd.schema = {
	    type: 'object',
	    properties: {
	        firstName: { type: 'string' },
	        lastName: { type: 'string' },
	        job: { type: ['string', 'null'] },
	        phone: { type: ['string', 'null'] }
	    },
	    required: ['firstName', 'lastName']
	};
	
	var ResetLoginDemand = exports.ResetLoginDemand = function ResetLoginDemand() {
	    _classCallCheck(this, ResetLoginDemand);
	};
	
	ResetLoginDemand.schema = {
	    type: 'object',
	    properties: {
	        newLogin: {
	            type: 'string',
	            format: 'email'
	        }
	    },
	    required: ['newLogin']
	};
	
	var UserConfigs = exports.UserConfigs = function UserConfigs() {
	    _classCallCheck(this, UserConfigs);
	};
	
	UserConfigs.schema = {
	    type: 'object',
	    properties: {
	        ticketOpenedNotifications: { type: 'boolean' },
	        daybookNotifications: { type: 'boolean' },
	        simplifiedRequestOpenedNotifications: { type: 'boolean' }
	    }
	};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1900),
	    getValue = __webpack_require__(1923);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 520 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 521 */,
/* 522 */,
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var types = ['button', 'reset', 'submit'];
	
	var ButtonStyles = _styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY, _styleMaps.LINK);
	
	var Button = _react2['default'].createClass({
	  displayName: 'Button',
	
	  propTypes: {
	    active: _react2['default'].PropTypes.bool,
	    disabled: _react2['default'].PropTypes.bool,
	    block: _react2['default'].PropTypes.bool,
	    navItem: _react2['default'].PropTypes.bool,
	    navDropdown: _react2['default'].PropTypes.bool,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    href: _react2['default'].PropTypes.string,
	    target: _react2['default'].PropTypes.string,
	    /**
	     * Defines HTML button type Attribute
	     * @type {("button"|"reset"|"submit")}
	     * @defaultValue 'button'
	     */
	    type: _react2['default'].PropTypes.oneOf(types)
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      block: false,
	      disabled: false,
	      navItem: false,
	      navDropdown: false
	    };
	  },
	
	  render: function render() {
	    var _extends2;
	
	    var classes = this.props.navDropdown ? {} : _utilsBootstrapUtils2['default'].getClassSet(this.props);
	    var renderFuncName = undefined;
	
	    var blockClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'block');
	
	    classes = _extends((_extends2 = {
	      active: this.props.active
	    }, _extends2[blockClass] = this.props.block, _extends2), classes);
	
	    if (this.props.navItem) {
	      return this.renderNavItem(classes);
	    }
	
	    renderFuncName = this.props.href || this.props.target || this.props.navDropdown ? 'renderAnchor' : 'renderButton';
	
	    return this[renderFuncName](classes);
	  },
	
	  renderAnchor: function renderAnchor(classes) {
	    var Component = this.props.componentClass || 'a';
	    var href = this.props.href || '#';
	    classes.disabled = this.props.disabled;
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, this.props, {
	        href: href,
	        className: _classnames2['default'](this.props.className, classes),
	        role: 'button' }),
	      this.props.children
	    );
	  },
	
	  renderButton: function renderButton(classes) {
	    var Component = this.props.componentClass || 'button';
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, this.props, {
	        type: this.props.type || 'button',
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  },
	
	  renderNavItem: function renderNavItem(classes) {
	    var liClasses = {
	      active: this.props.active
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: _classnames2['default'](liClasses) },
	      this.renderAnchor(classes)
	    );
	  }
	});
	
	Button.types = types;
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(ButtonStyles, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL, _styleMaps.Sizes.XSMALL], _utilsBootstrapUtils.bsClass('btn', Button)));
	module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(197)
	  , createDesc = __webpack_require__(1065);
	module.exports = __webpack_require__(919) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	// add fake Function#toString
	// for correct work wrapped methods / constructors with methods like LoDash isNative
	var global    = __webpack_require__(465)
	  , hide      = __webpack_require__(524)
	  , SRC       = __webpack_require__(922)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(198).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  if(typeof val == 'function'){
	    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	    val.hasOwnProperty('name') || hide(val, 'name', key);
	  }
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(122);
	var EventPluginHub = __webpack_require__(141);
	var ReactComponentEnvironment = __webpack_require__(244);
	var ReactClass = __webpack_require__(472);
	var ReactEmptyComponent = __webpack_require__(480);
	var ReactBrowserEventEmitter = __webpack_require__(175);
	var ReactNativeComponent = __webpack_require__(486);
	var ReactPerf = __webpack_require__(64);
	var ReactRootIndex = __webpack_require__(489);
	var ReactUpdates = __webpack_require__(55);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(244);
	var ReactMultiChildUpdateTypes = __webpack_require__(485);
	
	var ReactCurrentOwner = __webpack_require__(78);
	var ReactReconciler = __webpack_require__(105);
	var ReactChildReconciler = __webpack_require__(823);
	
	var flattenChildren = __webpack_require__(540);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(885);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(884);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(90)))

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconCateg = __webpack_require__(2210);
	
	var _IconCateg2 = _interopRequireDefault(_IconCateg);
	
	var _models = __webpack_require__(269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Icon = function (_Component) {
	    _inherits(Icon, _Component);
	
	    function Icon() {
	        _classCallCheck(this, Icon);
	
	        return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	    }
	
	    _createClass(Icon, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                iconId = _props.iconId,
	                exponent = _props.exponent;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'svg',
	                    { className: _IconCateg2.default.iconCateg, width: 60, height: 60 },
	                    _react2.default.createElement('use', { href: '/external/categ.svg#' + (_models.OPENING_TICKET_PURPOSE_REF_ICONS.find(function (i) {
	                            return i === iconId;
	                        }) || 'questionmark') })
	                ),
	                exponent && _react2.default.createElement(
	                    'span',
	                    { className: _IconCateg2.default.exponent },
	                    exponent
	                )
	            );
	        }
	    }]);
	
	    return Icon;
	}(_react.Component);
	
	exports.default = Icon;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Rating = __webpack_require__(2217);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapCount(fnc, count) {
	    var result = [];
	    for (var i = 0; i < count; i++) {
	        result.push(fnc(i));
	    }
	    return result;
	}
	
	var Rating = function (_Component) {
	    _inherits(Rating, _Component);
	
	    function Rating() {
	        _classCallCheck(this, Rating);
	
	        return _possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).apply(this, arguments));
	    }
	
	    _createClass(Rating, [{
	        key: '_rate',
	        value: function _rate(event, score) {
	            var onChange = this.props.onChange;
	
	
	            event.preventDefault();
	            onChange(score);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                label = _props.label,
	                range = _props.range,
	                value = _props.value,
	                onChange = _props.onChange;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _Rating2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _Rating2.default.score },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        value && Math.floor(value * 10) / 10 || '---'
	                    ),
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        label
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _Rating2.default.body },
	                    onChange && mapCount(function (rangeIndex) {
	                        return _react2.default.createElement(
	                            'a',
	                            {
	                                key: rangeIndex,
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._rate(e, rangeIndex + 1);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'star', size: 'sm', active: rangeIndex + 1 <= value })
	                        );
	                    }, range),
	                    !onChange && mapCount(function (rangeIndex) {
	                        return _react2.default.createElement(_Icon2.default, { key: rangeIndex, icon: 'star', size: 'sm', active: rangeIndex + 1 <= value });
	                    }, range)
	                )
	            );
	        }
	    }]);
	
	    return Rating;
	}(_react.Component);
	
	Rating.PropTypes = {
	    label: _react.PropTypes.string,
	    range: _react.PropTypes.number,
	    value: _react.PropTypes.number,
	    onChange: _react.PropTypes.func
	};
	Rating.defaultProps = {
	    range: 5
	};
	exports.default = Rating;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.anyRequired = exports.ValidationError = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jjv = __webpack_require__(172);
	
	var _jjv2 = _interopRequireDefault(_jjv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validator = (0, _jjv2.default)();
	
	var ValidationError = function (_Error) {
	    _inherits(ValidationError, _Error);
	
	    function ValidationError(message, validation) {
	        _classCallCheck(this, ValidationError);
	
	        var _this = _possibleConstructorReturn(this, (ValidationError.__proto__ || Object.getPrototypeOf(ValidationError)).call(this, message));
	
	        Error.captureStackTrace(_this, _this.constructor);
	        _this.message = message;
	        _this.validation = validation;
	        return _this;
	    }
	
	    _createClass(ValidationError, [{
	        key: 'name',
	        get: function get() {
	            return 'ValidationError';
	        }
	    }, {
	        key: 'statusCode',
	        get: function get() {
	            return '400';
	        }
	    }]);
	
	    return ValidationError;
	}(Error);
	
	function anyRequired(value, params) {
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
	        for (var i = 0; i < params.length; i++) {
	            if (value[params[i]] !== undefined) return true;
	        }
	    }
	    return false;
	}
	
	function validate(schema, object) {
	    return new Promise(function (resolve, reject) {
	        if (object instanceof Array) {
	            schema = {
	                type: 'array',
	                items: schema
	            };
	        }
	
	        var errors = validator.validate(schema, object, { useDefault: true, removeAdditional: false });
	
	        if (errors) {
	            reject(new ValidationError('Validation error', errors.validation));
	        } else {
	            resolve(object);
	        }
	    });
	}
	
	exports.ValidationError = ValidationError;
	exports.anyRequired = anyRequired;
	exports.default = validate;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY = exports.DEFAULT_QUERY = exports.UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED = exports.CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED = exports.DISSOCIATE_OPENING_TICKET_PURPOSE_FROM_INSTRUCTION_ACTION_SENT = exports.ASSOCIATE_OPENING_TICKET_PURPOSE_WITH_INSTRUCTION_ACTION_SENT = exports.UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT = exports.CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT = exports.OPENING_TICKET_INSTRUCTION_STREAM_QUERIED = exports.OPENING_TICKET_INSTRUCTION_STREAM_LOADED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.queryOpeningTicketInstructionStream = queryOpeningTicketInstructionStream;
	exports.loadOpeningTicketInstructionStream = loadOpeningTicketInstructionStream;
	exports.sendCreateOpeningTicketInstructionAction = sendCreateOpeningTicketInstructionAction;
	exports.sendUpdateOpeningTicketInstructionAction = sendUpdateOpeningTicketInstructionAction;
	exports.sendAssociateOpeningTicketPurposeWithInstructionAction = sendAssociateOpeningTicketPurposeWithInstructionAction;
	exports.sendDissociateOpeningTicketPurposeFromInstructionAction = sendDissociateOpeningTicketPurposeFromInstructionAction;
	exports.updateUpdateOpeningTicketInstructionAction = updateUpdateOpeningTicketInstructionAction;
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NAMESPACE = 'OpeningTicketInstruction';
	
	var OPENING_TICKET_INSTRUCTION_STREAM_LOADED = exports.OPENING_TICKET_INSTRUCTION_STREAM_LOADED = NAMESPACE + '/OpeningTicketInstructionStreamLoaded';
	var OPENING_TICKET_INSTRUCTION_STREAM_QUERIED = exports.OPENING_TICKET_INSTRUCTION_STREAM_QUERIED = NAMESPACE + '/OpeningTicketInstructionStreamQueried';
	var CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT = exports.CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT = NAMESPACE + '/CreateOpeningTicketInstructionActionSent';
	var UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT = exports.UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT = NAMESPACE + '/UpdateOpeningTicketInstructionActionSent';
	var ASSOCIATE_OPENING_TICKET_PURPOSE_WITH_INSTRUCTION_ACTION_SENT = exports.ASSOCIATE_OPENING_TICKET_PURPOSE_WITH_INSTRUCTION_ACTION_SENT = NAMESPACE + '/AssociateOpeningTicketPurposeWithInstructionActionSent';
	var DISSOCIATE_OPENING_TICKET_PURPOSE_FROM_INSTRUCTION_ACTION_SENT = exports.DISSOCIATE_OPENING_TICKET_PURPOSE_FROM_INSTRUCTION_ACTION_SENT = NAMESPACE + '/DissociateOpeningTicketPurposeFromInstructionActionSent';
	// form actions
	var CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED = exports.CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED = NAMESPACE + '/CreateOpeningTicketInstructionActionUpdated';
	var UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED = exports.UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED = NAMESPACE + '/UpdateOpeningTicketInstructionActionUpdated';
	
	var DEFAULT_QUERY = exports.DEFAULT_QUERY = {};
	
	var DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY = exports.DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY = _extends({}, DEFAULT_QUERY, {
	    openingTicketPurpose: null
	});
	
	function queryOpeningTicketInstructionStream(companyId, instructionQuery) {
	    return loadOpeningTicketInstructionStream(companyId, instructionQuery, OPENING_TICKET_INSTRUCTION_STREAM_QUERIED);
	}
	
	function loadOpeningTicketInstructionStream(companyId, instructionQuery, action) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var query = state.message.openingTicketInstruction.query;
	
	        companyId = companyId && companyId.uid || companyId || company.uid;
	
	        instructionQuery = _extends({}, DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY, query, instructionQuery);
	
	        return fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/clientcompanies/' + companyId + '/openingticketinstructions', instructionQuery), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	            var json = _ref.json;
	
	            return {
	                type: action || OPENING_TICKET_INSTRUCTION_STREAM_LOADED,
	                stream: json.result,
	                query: instructionQuery
	            };
	        });
	    }, action || OPENING_TICKET_INSTRUCTION_STREAM_LOADED);
	}
	
	function sendCreateOpeningTicketInstructionAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var createOpeningTicketInstructionAction = state.message.createOpeningTicketInstructionAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'CreateOpeningTicketInstruction'
	            }, createOpeningTicketInstructionAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketinstructions', (0, _fetchz.apiOption)(option)).then(_fetchz.apiResponse).then(function (_ref2) {
	            var json = _ref2.json;
	
	            return {
	                type: CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT,
	                openingTicketInstructionUid: json.instructionUid
	            };
	        });
	    }, CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT);
	}
	
	function sendUpdateOpeningTicketInstructionAction() {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	        var updateOpeningTicketInstructionAction = state.message.updateOpeningTicketInstructionAction;
	
	
	        var option = {
	            method: 'PATCH',
	            body: _extends({
	                action: 'UpdateOpeningTicketInstruction'
	            }, updateOpeningTicketInstructionAction)
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketinstructions', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function (_ref3) {
	            var json = _ref3.json;
	
	            return {
	                type: UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT
	            };
	        });
	    }, UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT);
	}
	
	function sendAssociateOpeningTicketPurposeWithInstructionAction(openingTicketInstructionId, openingTicketPurposeId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'AssociateOpeningTicketPurposeWithInstruction',
	                instructionUid: openingTicketInstructionId,
	                openingTicketPurposeUid: openingTicketPurposeId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketinstructions', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: ASSOCIATE_OPENING_TICKET_PURPOSE_WITH_INSTRUCTION_ACTION_SENT
	            };
	        });
	    }, ASSOCIATE_OPENING_TICKET_PURPOSE_WITH_INSTRUCTION_ACTION_SENT);
	}
	
	function sendDissociateOpeningTicketPurposeFromInstructionAction(openingTicketInstructionId, openingTicketPurposeId) {
	    return (0, _loading2.default)(function (state) {
	        var company = state.company.company;
	
	
	        var option = {
	            method: 'PATCH',
	            body: {
	                action: 'DissociateOpeningTicketPurposeFromInstruction',
	                instructionUid: openingTicketInstructionId,
	                openingTicketPurposeUid: openingTicketPurposeId
	            }
	        };
	
	        return fetch(_config2.default.api.url + '/clientcompanies/' + company.uid + '/openingticketinstructions', (0, _fetchz.apiOption)(option)).then(_fetchz.errorResponse).then(function () {
	            return {
	                type: DISSOCIATE_OPENING_TICKET_PURPOSE_FROM_INSTRUCTION_ACTION_SENT
	            };
	        });
	    }, DISSOCIATE_OPENING_TICKET_PURPOSE_FROM_INSTRUCTION_ACTION_SENT);
	}
	
	function updateUpdateOpeningTicketInstructionAction(action) {
	    return {
	        action: action,
	        type: UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(1979);
	
	var _runTransitionHook = __webpack_require__(1015);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(516);
	
	var _deprecate = __webpack_require__(517);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(800),
	    getRawTag = __webpack_require__(1920),
	    objectToString = __webpack_require__(1948);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(256);
	var warning = __webpack_require__(23);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(41);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 542 */,
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BOLD_REGEX = /\*\*(.*)\*\*/;
	
	var Markdown = function (_Component) {
	    _inherits(Markdown, _Component);
	
	    function Markdown() {
	        _classCallCheck(this, Markdown);
	
	        return _possibleConstructorReturn(this, (Markdown.__proto__ || Object.getPrototypeOf(Markdown)).apply(this, arguments));
	    }
	
	    _createClass(Markdown, [{
	        key: 'render',
	        value: function render() {
	            var markdown = this.props.markdown;
	
	
	            var markdownChunks = markdown && markdown.replace(/(\\r)?\\n/g, '\n').split(/\r?\n/) || [];
	
	            var print = function print(chunk) {
	                var matcher;
	
	                if (matcher = chunk.match(BOLD_REGEX)) {
	                    return _react2.default.createElement(
	                        'b',
	                        null,
	                        matcher[1]
	                    );
	                }
	                return chunk || '\xA0';
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                markdownChunks.map(function (chunk, index) {
	                    return _react2.default.createElement(
	                        'p',
	                        { key: index },
	                        print(chunk)
	                    );
	                })
	            );
	        }
	    }]);
	
	    return Markdown;
	}(_react.Component);
	
	Markdown.propTypes = {
	    markdown: _react.PropTypes.string.isRequired
	};
	exports.default = Markdown;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _RadioToggle = __webpack_require__(2215);
	
	var _RadioToggle2 = _interopRequireDefault(_RadioToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioToggle = function (_Component) {
	    _inherits(RadioToggle, _Component);
	
	    function RadioToggle() {
	        _classCallCheck(this, RadioToggle);
	
	        return _possibleConstructorReturn(this, (RadioToggle.__proto__ || Object.getPrototypeOf(RadioToggle)).apply(this, arguments));
	    }
	
	    _createClass(RadioToggle, [{
	        key: '_toggle',
	        value: function _toggle(item) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange;
	
	
	            var nextValue = item != value && item || null;
	            onChange(nextValue);
	        }
	    }, {
	        key: '_isChecked',
	        value: function _isChecked(item) {
	            var value = this.props.value;
	
	            return item == value;
	        }
	    }, {
	        key: '_enhance',
	        value: function _enhance(children) {
	            var _this2 = this;
	
	            return _react2.default.Children.map(children, function (child) {
	                if (child && child.type && (child.type == 'input' || child.type.displayName == 'Input')) {
	                    var value = child.props.value;
	
	
	                    return _react2.default.cloneElement(child, {
	                        checked: _this2._isChecked(value),
	                        onChange: function onChange() {
	                            return _this2._toggle(value);
	                        }
	                    });
	                }
	                if (child && child.props) {
	                    var _children = child.props.children;
	
	
	                    return _children && _react2.default.cloneElement(child, {
	                        children: _this2._enhance(_children)
	                    }) || child;
	                }
	                return child;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                children = _props2.children,
	                bsStyle = _props2.bsStyle,
	                value = _props2.value,
	                onChange = _props2.onChange;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_RadioToggle2.default.default, _defineProperty({}, _RadioToggle2.default.error, bsStyle == 'error')) },
	                this._enhance(children)
	            );
	        }
	    }]);
	
	    return RadioToggle;
	}(_react.Component);
	
	RadioToggle.propTypes = {
	    value: _react.PropTypes.any,
	    onChange: _react.PropTypes.func.isRequired
	};
	exports.default = RadioToggle;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        advancedSearch: 'recherche avancée',
	        loading: 'chargement',
	        morning: 'matin',
	        afternoon: 'après midi',
	        unitEnum: {
	            d: 'jour',
	            h: 'heure',
	            m: 'minute'
	        }
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 546 */,
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        errorTypeEnum: {
	            openingTicketPurposeIsAlreadyAssociatedWithAnotherInstruction: 'Cette raison d\'ouverture de ticket est déjà associée à une autre instruction'
	        },
	        newOpeningTicketInstruction: 'nouvelle instruction',
	        openingTicketInstruction: 'instruction',
	        openingTicketInstructions: 'instructions',
	        openingTicketPurposes: 'raisons d\'ouverture de ticket'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _form = __webpack_require__(15);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _browser = __webpack_require__(54);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _TypeaheadBar = __webpack_require__(511);
	
	var _TypeaheadBar2 = _interopRequireDefault(_TypeaheadBar);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(124);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _PatrimonyPicker = __webpack_require__(2253);
	
	var _PatrimonyPicker2 = _interopRequireDefault(_PatrimonyPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function geoLocationCriteria(zipCode, placeId, geoLocation, action) {
	    if (action) {
	        // second attempt
	        if (placeId && geoLocation && action.stream.length == 0) return { geoLocation: geoLocation };
	        return null;
	    }
	
	    // first attempt
	    if (placeId) return { placeId: placeId };
	    if (geoLocation) return { geoLocation: geoLocation };
	    if (zipCode) return { zipCode: zipCode };
	    return null;
	}
	
	function patrimonyFilter(contact) {
	    return function (patrimony) {
	        return !!contact.linkedWith.find(function (l) {
	            return l.patrimony && l.patrimony.uid == patrimony.uid;
	        });
	    };
	}
	
	var PatrimonyPicker = function (_Component) {
	    _inherits(PatrimonyPicker, _Component);
	
	    function PatrimonyPicker(props) {
	        _classCallCheck(this, PatrimonyPicker);
	
	        var _this = _possibleConstructorReturn(this, (PatrimonyPicker.__proto__ || Object.getPrototypeOf(PatrimonyPicker)).call(this, props));
	
	        _this.state = {
	            filteredStream: []
	        };
	        return _this;
	    }
	
	    _createClass(PatrimonyPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company,
	                zipCode = _props.zipCode,
	                placeId = _props.placeId,
	                geoLocation = _props.geoLocation;
	
	
	            var geoLoc = geoLocationCriteria(zipCode, placeId, geoLocation);
	
	            dispatch((0, _actions.resetMinorCriteria)());
	            dispatch((0, _actions.queryPatrimonyStream)(_extends({}, _actions.DEFAULT_PATRIMONY_QUERY, geoLoc, { companyUid: company && company.uid, range: { offset: 0, limit: 99 } }))).then(function (action) {
	                var geoLoc = geoLocationCriteria(zipCode, placeId, geoLocation, action);
	                return geoLoc && dispatch((0, _actions.queryPatrimonyStream)(_extends({}, _actions.DEFAULT_PATRIMONY_QUERY, geoLoc, { companyUid: company && company.uid, range: { offset: 0, limit: 99 } })));
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ((nextProps.company && nextProps.company.uid) != (this.props.company && this.props.company.uid) || nextProps.zipCode != this.props.zipCode || nextProps.placeId != this.props.placeId || nextProps.geoLocation != this.props.geoLocation) {
	                var dispatch = nextProps.dispatch,
	                    company = nextProps.company,
	                    zipCode = nextProps.zipCode,
	                    placeId = nextProps.placeId,
	                    geoLocation = nextProps.geoLocation;
	
	
	                var geoLoc = geoLocationCriteria(zipCode, placeId, geoLocation);
	
	                dispatch((0, _actions.resetMinorCriteria)());
	                dispatch((0, _actions.queryPatrimonyStream)(_extends({}, _actions.DEFAULT_PATRIMONY_QUERY, geoLoc, { companyUid: company && company.uid, range: { offset: 0, limit: 99 } }))).then(function (action) {
	                    var geoLoc = geoLocationCriteria(zipCode, placeId, geoLocation, action);
	                    return geoLoc && dispatch((0, _actions.queryPatrimonyStream)(_extends({}, _actions.DEFAULT_PATRIMONY_QUERY, geoLoc, { companyUid: company && company.uid, range: { offset: 0, limit: 99 } })));
	                });
	            }
	
	            if (nextProps.stream != this.props.stream || nextProps.contact != this.props.contact) {
	                var stream = nextProps.stream,
	                    contact = nextProps.contact,
	                    _placeId = nextProps.placeId,
	                    value = nextProps.value,
	                    onChange = nextProps.onChange,
	                    multi = nextProps.multi;
	
	
	                var filteredStream = contact && stream.filter(patrimonyFilter(contact)) || stream;
	                this.setState({ filteredStream: filteredStream });
	
	                if (!multi) {
	                    // auto pick single patrimony
	                    var autoPick = !value && filteredStream.length == 1;
	                    var autoPickByPlaceId = autoPick && _placeId && filteredStream[0].addresses.concat(filteredStream[0].complementaryAddresses).find(function (a) {
	                        return a.checker && a.checker.googlePlaceId == _placeId;
	                    });
	                    var autoPickByContact = autoPick && contact && contact.linkedWith.find(function (l) {
	                        return l.patrimony && l.patrimony.uid == filteredStream[0].uid;
	                    });
	
	                    if (autoPickByPlaceId || autoPickByContact) {
	                        onChange(filteredStream[0]);
	                    }
	                }
	            }
	        }
	    }, {
	        key: '_search',
	        value: function _search(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                minorCriteria = _props2.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.queryPatrimonyStream)(minorCriteria));
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props3 = this.props,
	                    dispatch = _props3.dispatch,
	                    minorCriteria = _props3.minorCriteria;
	
	                dispatch((0, _actions.queryPatrimonyStream)(minorCriteria));
	            }
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                minorCriteria = _props4.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.updateMinorCriteria)({ fullText: null }));
	            dispatch((0, _actions.queryPatrimonyStream)(_extends({}, minorCriteria, { fullText: null })));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props5 = this.props,
	                dispatch = _props5.dispatch,
	                form = _props5.form,
	                minorCriteria = _props5.minorCriteria,
	                stream = _props5.stream,
	                aggregations = _props5.aggregations,
	                range = _props5.range,
	                query = _props5.query,
	                contact = _props5.contact,
	                company = _props5.company,
	                zipCode = _props5.zipCode,
	                placeId = _props5.placeId,
	                geoLocation = _props5.geoLocation,
	                others = _objectWithoutProperties(_props5, ['dispatch', 'form', 'minorCriteria', 'stream', 'aggregations', 'range', 'query', 'contact', 'company', 'zipCode', 'placeId', 'geoLocation']);
	
	            var filteredStream = this.state.filteredStream;
	
	
	            var searched = minorCriteria && minorCriteria.fullText && minorCriteria.fullText == (query && query.fullText);
	
	            var agencySource = (0, _TypeaheadBar.matcher)({
	                source: aggregations && aggregations.agencies || [],
	                identify: function identify(a) {
	                    return a.label;
	                }
	            });
	
	            var afterPatrimonies = function afterPatrimonies() {
	                if (range && range.limit < range.count - 1) {
	                    var count = range.limit + 1;
	                    return _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _extract.replace)(_i18n2.default.useSearchPatrimonyFilters, { count: count })
	                    );
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _PatrimonyPicker2.default.default },
	                _react2.default.createElement(
	                    _Picker2.default,
	                    _extends({
	                        source: filteredStream,
	                        identify: function identify(p) {
	                            return p.uid;
	                        },
	                        display: function display(p) {
	                            return p.ref + ' - ' + p.label;
	                        },
	                        after: afterPatrimonies()
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PatrimonyPicker2.default.search },
	                            searched && _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._clear(e);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	                            ),
	                            !searched && _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._search(e);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _PatrimonyPicker2.default.container },
	                                _react2.default.createElement('input', _extends({
	                                    type: 'text',
	                                    onKeyPress: function onKeyPress(e) {
	                                        return _this2._searchOnKeyPress(e);
	                                    },
	                                    placeholder: _i18n2.default.searchPatrimony.xs
	                                }, form.fullText()))
	                            )
	                        ),
	                        _react2.default.createElement(_TypeaheadBar2.default, _extends({
	                            size: 'small',
	                            source: agencySource,
	                            identify: function identify(a) {
	                                return a.value;
	                            },
	                            display: function display(a) {
	                                return a.label + ' (' + a.count + ')';
	                            },
	                            placeholder: _i18n2.default.searchAgency.xs
	                        }, form.agencyUids()))
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PatrimonyPicker;
	}(_react.Component);
	
	PatrimonyPicker.propTypes = {
	    contact: _react.PropTypes.object,
	    company: _react.PropTypes.object,
	    zipCode: _react.PropTypes.string,
	    placeId: _react.PropTypes.string,
	    geoLocation: _react.PropTypes.object
	};
	
	
	PatrimonyPicker = (0, _loading.connectLoadingLock)()(PatrimonyPicker);
	
	PatrimonyPicker = (0, _form.connectForm)({
	    target: 'minorCriteria',
	    schema: _models.Criteria.schema,
	    action: _actions.MINOR_CRITERIA_UPDATED
	})(PatrimonyPicker);
	
	PatrimonyPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        minorCriteria: state.patrimony.minorCriteria,
	        stream: state.patrimony.stream,
	        aggregations: state.patrimony.aggregations,
	        range: state.patrimony.range,
	        query: state.patrimony.query
	    };
	})(PatrimonyPicker);
	
	exports.default = PatrimonyPicker;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _mathz = __webpack_require__(108);
	
	var _extract = __webpack_require__(12);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ClosingRateDashboardPanel = __webpack_require__(2317);
	
	var _ClosingRateDashboardPanel2 = _interopRequireDefault(_ClosingRateDashboardPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClosingRateDashboardPanel = function (_Component) {
	    _inherits(ClosingRateDashboardPanel, _Component);
	
	    function ClosingRateDashboardPanel() {
	        _classCallCheck(this, ClosingRateDashboardPanel);
	
	        return _possibleConstructorReturn(this, (ClosingRateDashboardPanel.__proto__ || Object.getPrototypeOf(ClosingRateDashboardPanel)).apply(this, arguments));
	    }
	
	    _createClass(ClosingRateDashboardPanel, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                aggregations = _props.aggregations,
	                others = _objectWithoutProperties(_props, ['dispatch', 'aggregations']);
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            var closingRate = (0, _mathz.percentage)({
	                source: aggregations.status,
	                identify: function identify(s) {
	                    return s.count;
	                },
	                match: function match(s) {
	                    return (0, _extract.sanitize)(s.value) == 'closed';
	                }
	            });
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader(_i18n2.default.closingRate)
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ClosingRateDashboardPanel2.default.closingRate },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _i18n2.default.aboutClosingRate
	                    ),
	                    !isNaN(closingRate) && _react2.default.createElement(
	                        'span',
	                        { className: _ClosingRateDashboardPanel2.default.rate },
	                        closingRate,
	                        ' %'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ClosingRateDashboardPanel;
	}(_react.Component);
	
	ClosingRateDashboardPanel.propTypes = {};
	
	
	ClosingRateDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        aggregations: state.ticket.aggregations
	    };
	})(ClosingRateDashboardPanel);
	
	exports.default = ClosingRateDashboardPanel;

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EXPECTED_EVENTS = exports.EXPECTED_EVENTS = ['DocumentAttached', 'CallEmittedTo', 'CallReceived', 'AssigneeIdentified', 'InterventionDeadlineDefined', 'FormalNoticeForProviderReported', 'SendingServiceOrderReported', 'CallAnsweredByProvider', 'CallNotAnsweredByProvider', 'InterventionScheduled', 'InterventionRequested', 'InterventionAccepted', 'InterventionRefused', 'ArrivedOnSite', 'GoneFromSite', 'InterventionStarted', 'InterventionFinished', 'MissionFinished', 'TicketCancelled', 'TicketClosed', 'TicketArchived', 'PermanentlyFixed', 'PartiallyFixed', 'TicketClosedImpossibleRepair', 'PostponedFix', 'ClosedBeyondCallCenterScope', 'ClosedAfterSeveralUnsuccessfulRecalls'];
	
	var ACTORS = exports.ACTORS = ['Executive', 'PatrimonyManager', 'CallCenterOperator'];
	
	var STEP_TIME_LIMIT_TYPE = exports.STEP_TIME_LIMIT_TYPE = ['DurationAfterPreviousStep'];
	
	var NEW_WORKFLOW = exports.NEW_WORKFLOW = {
	    identifiedRequests: [],
	    steps: []
	};
	
	var TodoCriteria = exports.TodoCriteria = function TodoCriteria() {
	    _classCallCheck(this, TodoCriteria);
	};
	
	TodoCriteria.schema = {
	    type: 'object',
	    properties: {
	        agency: { type: 'array' },
	        clientCompany: { type: 'array' },
	        expectedCommand: { type: 'array' },
	        operator: { type: 'array' },
	        actor: { type: 'array' },
	        expectedDateStart: { type: 'string' },
	        expectedDateEnd: { type: 'string' }
	    }
	};
	
	var CreateWorkflowAction = exports.CreateWorkflowAction = function CreateWorkflowAction() {
	    _classCallCheck(this, CreateWorkflowAction);
	};
	
	CreateWorkflowAction.schema = {
	    type: 'object',
	    properties: {
	        label: { type: 'string' }
	    },
	    required: ['label']
	};
	
	var UpdateWorkflowLabelAction = exports.UpdateWorkflowLabelAction = function UpdateWorkflowLabelAction() {
	    _classCallCheck(this, UpdateWorkflowLabelAction);
	};
	
	UpdateWorkflowLabelAction.schema = {
	    type: 'object',
	    properties: {
	        label: { type: 'string' }
	    },
	    required: ['label']
	};
	
	var UpdateIdentifiedRequestsAction = exports.UpdateIdentifiedRequestsAction = function UpdateIdentifiedRequestsAction() {
	    _classCallCheck(this, UpdateIdentifiedRequestsAction);
	};
	
	UpdateIdentifiedRequestsAction.schema = {
	    type: 'object',
	    properties: {
	        identifiedRequests: { type: 'array' }
	    },
	    required: ['identifiedRequests']
	};
	
	var AddStepAction = exports.AddStepAction = function AddStepAction() {
	    _classCallCheck(this, AddStepAction);
	};
	
	AddStepAction.schema = {
	    type: 'object',
	    properties: {
	        step: {
	            type: 'object',
	            properties: {
	                expectedEvent: { type: 'string' },
	                actors: {
	                    type: 'array',
	                    minItems: 1
	                },
	                order: { type: 'integer' },
	                timeLimit: {
	                    type: ['object', 'null'],
	                    properties: {
	                        duration: { type: 'integer' },
	                        workflowStepTimeLimitType: { type: 'string' }
	                    },
	                    required: ['duration', 'workflowStepTimeLimitType']
	                }
	            },
	            required: ['expectedEvent', 'actors', 'order']
	        }
	    },
	    required: ['step']
	};
	
	var UpdateStepAction = exports.UpdateStepAction = function UpdateStepAction() {
	    _classCallCheck(this, UpdateStepAction);
	};
	
	UpdateStepAction.schema = {
	    type: 'object',
	    properties: {
	        step: {
	            type: 'object',
	            properties: {
	                expectedEvent: { type: 'string' },
	                actors: {
	                    type: 'array',
	                    minItems: 1
	                },
	                order: { type: 'integer' },
	                timeLimit: {
	                    type: ['object', 'null'],
	                    properties: {
	                        duration: { type: 'integer' },
	                        workflowStepTimeLimitType: { type: 'string' }
	                    },
	                    required: ['duration', 'workflowStepTimeLimitType']
	                }
	            },
	            required: ['expectedEvent', 'actors', 'order']
	        }
	    },
	    required: ['step']
	};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(751);
	
	__webpack_require__(879);
	
	__webpack_require__(552);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(559);
	module.exports = __webpack_require__(60).RegExp.escape;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var isArray = __webpack_require__(157);
	var SPECIES = __webpack_require__(25)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(18);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(11);
	var toPrimitive = __webpack_require__(69);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(96);
	var gOPS = __webpack_require__(161);
	var pIE = __webpack_require__(133);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(134)('native-function-to-string', Function.toString);


/***/ }),
/* 558 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3);
	var $re = __webpack_require__(558)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(281) });
	
	__webpack_require__(82)('copyWithin');


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $every = __webpack_require__(66)(4);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { fill: __webpack_require__(204) });
	
	__webpack_require__(82)('fill');


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $filter = __webpack_require__(66)(2);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(66)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(82)(KEY);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(66)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(82)(KEY);


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $forEach = __webpack_require__(66)(0);
	var STRICT = __webpack_require__(62)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(61);
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(32);
	var call = __webpack_require__(292);
	var isArrayIter = __webpack_require__(212);
	var toLength = __webpack_require__(27);
	var createProperty = __webpack_require__(206);
	var getIterFn = __webpack_require__(228);
	
	$export($export.S + $export.F * !__webpack_require__(159)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $indexOf = __webpack_require__(154)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(62)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(157) });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(53);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(132) != Object || !__webpack_require__(62)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(53);
	var toInteger = __webpack_require__(63);
	var toLength = __webpack_require__(27);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(62)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $map = __webpack_require__(66)(1);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var createProperty = __webpack_require__(206);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(18)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(283);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(283);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var html = __webpack_require__(210);
	var cof = __webpack_require__(59);
	var toAbsoluteIndex = __webpack_require__(100);
	var toLength = __webpack_require__(27);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(18)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $some = __webpack_require__(66)(3);
	
	$export($export.P + $export.F * !__webpack_require__(62)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(37);
	var toObject = __webpack_require__(32);
	var fails = __webpack_require__(18);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(62)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(99)('Array');


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3);
	var toISOString = __webpack_require__(554);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(69);
	
	$export($export.P + $export.F * __webpack_require__(18)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(25)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(43)(proto, TO_PRIMITIVE, __webpack_require__(555));


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(44)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', { bind: __webpack_require__(284) });


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(19);
	var getPrototypeOf = __webpack_require__(52);
	var HAS_INSTANCE = __webpack_require__(25)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(30).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(30).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(28) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3);
	var log1p = __webpack_require__(295);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3);
	var sign = __webpack_require__(216);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3);
	var $expm1 = __webpack_require__(215);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { fround: __webpack_require__(294) });


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(18)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(295) });


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { sign: __webpack_require__(216) });


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(215);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(18)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(215);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(16);
	var has = __webpack_require__(50);
	var cof = __webpack_require__(59);
	var inheritIfRequired = __webpack_require__(211);
	var toPrimitive = __webpack_require__(69);
	var fails = __webpack_require__(18);
	var gOPN = __webpack_require__(95).f;
	var gOPD = __webpack_require__(51).f;
	var dP = __webpack_require__(30).f;
	var $trim = __webpack_require__(117).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(94)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(28) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(44)(global, NUMBER, $Number);
	}


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(3);
	var _isFinite = __webpack_require__(16).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(291) });


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(3);
	var isInteger = __webpack_require__(291);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(303);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(304);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toInteger = __webpack_require__(63);
	var aNumberValue = __webpack_require__(280);
	var repeat = __webpack_require__(223);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(18)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $fails = __webpack_require__(18);
	var aNumberValue = __webpack_require__(280);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(297) });


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(94) });


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperties: __webpack_require__(298) });


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperty: __webpack_require__(30).f });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(19);
	var meta = __webpack_require__(84).onFreeze;
	
	__webpack_require__(68)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(53);
	var $getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	__webpack_require__(68)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(68)('getOwnPropertyNames', function () {
	  return __webpack_require__(299).f;
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(32);
	var $getPrototypeOf = __webpack_require__(52);
	
	__webpack_require__(68)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(19);
	
	__webpack_require__(68)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(19);
	
	__webpack_require__(68)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(19);
	
	__webpack_require__(68)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { is: __webpack_require__(307) });


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(32);
	var $keys = __webpack_require__(96);
	
	__webpack_require__(68)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(19);
	var meta = __webpack_require__(84).onFreeze;
	
	__webpack_require__(68)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(19);
	var meta = __webpack_require__(84).onFreeze;
	
	__webpack_require__(68)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(220).set });


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(114);
	var test = {};
	test[__webpack_require__(25)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(44)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(303);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(304);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(83);
	var global = __webpack_require__(16);
	var ctx = __webpack_require__(61);
	var classof = __webpack_require__(114);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(19);
	var aFunction = __webpack_require__(37);
	var anInstance = __webpack_require__(92);
	var forOf = __webpack_require__(93);
	var speciesConstructor = __webpack_require__(135);
	var task = __webpack_require__(225).set;
	var microtask = __webpack_require__(217)();
	var newPromiseCapabilityModule = __webpack_require__(218);
	var perform = __webpack_require__(305);
	var userAgent = __webpack_require__(167);
	var promiseResolve = __webpack_require__(306);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(25)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(98)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(116)($Promise, PROMISE);
	__webpack_require__(99)(PROMISE);
	Wrapper = __webpack_require__(60)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(159)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(37);
	var anObject = __webpack_require__(11);
	var rApply = (__webpack_require__(16).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(18)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(3);
	var create = __webpack_require__(94);
	var aFunction = __webpack_require__(37);
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(19);
	var fails = __webpack_require__(18);
	var bind = __webpack_require__(284);
	var rConstruct = (__webpack_require__(16).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(30);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	var toPrimitive = __webpack_require__(69);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(18)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(3);
	var gOPD = __webpack_require__(51).f;
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(213)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(51);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(3);
	var getProto = __webpack_require__(52);
	var anObject = __webpack_require__(11);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(51);
	var getPrototypeOf = __webpack_require__(52);
	var has = __webpack_require__(50);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(19);
	var anObject = __webpack_require__(11);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(302) });


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(11);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(3);
	var setProto = __webpack_require__(220);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(30);
	var gOPD = __webpack_require__(51);
	var getPrototypeOf = __webpack_require__(52);
	var has = __webpack_require__(50);
	var $export = __webpack_require__(3);
	var createDesc = __webpack_require__(97);
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(19);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(16);
	var inheritIfRequired = __webpack_require__(211);
	var dP = __webpack_require__(30).f;
	var gOPN = __webpack_require__(95).f;
	var isRegExp = __webpack_require__(158);
	var $flags = __webpack_require__(131);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(28) && (!CORRECT_NEW || __webpack_require__(18)(function () {
	  re2[__webpack_require__(25)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(44)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(99)('RegExp');


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var toLength = __webpack_require__(27);
	var advanceStringIndex = __webpack_require__(203);
	var regExpExec = __webpack_require__(162);
	
	// @@match logic
	__webpack_require__(156)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var toObject = __webpack_require__(32);
	var toLength = __webpack_require__(27);
	var toInteger = __webpack_require__(63);
	var advanceStringIndex = __webpack_require__(203);
	var regExpExec = __webpack_require__(162);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(156)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(11);
	var sameValue = __webpack_require__(307);
	var regExpExec = __webpack_require__(162);
	
	// @@search logic
	__webpack_require__(156)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(158);
	var anObject = __webpack_require__(11);
	var speciesConstructor = __webpack_require__(135);
	var advanceStringIndex = __webpack_require__(203);
	var toLength = __webpack_require__(27);
	var callRegExpExec = __webpack_require__(162);
	var regexpExec = __webpack_require__(219);
	var fails = __webpack_require__(18);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(156)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(313);
	var anObject = __webpack_require__(11);
	var $flags = __webpack_require__(131);
	var DESCRIPTORS = __webpack_require__(28);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(44)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(18)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(45)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(45)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(45)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(45)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(165)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(27);
	var context = __webpack_require__(222);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(209)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(45)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(45)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(45)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toAbsoluteIndex = __webpack_require__(100);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(3);
	var context = __webpack_require__(222);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(209)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(45)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(165)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(214)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(45)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(53);
	var toLength = __webpack_require__(27);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(223)
	});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(45)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(27);
	var context = __webpack_require__(222);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(209)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(45)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(45)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(45)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(117)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(16);
	var has = __webpack_require__(50);
	var DESCRIPTORS = __webpack_require__(28);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(44);
	var META = __webpack_require__(84).KEY;
	var $fails = __webpack_require__(18);
	var shared = __webpack_require__(134);
	var setToStringTag = __webpack_require__(116);
	var uid = __webpack_require__(101);
	var wks = __webpack_require__(25);
	var wksExt = __webpack_require__(310);
	var wksDefine = __webpack_require__(227);
	var enumKeys = __webpack_require__(556);
	var isArray = __webpack_require__(157);
	var anObject = __webpack_require__(11);
	var isObject = __webpack_require__(19);
	var toObject = __webpack_require__(32);
	var toIObject = __webpack_require__(53);
	var toPrimitive = __webpack_require__(69);
	var createDesc = __webpack_require__(97);
	var _create = __webpack_require__(94);
	var gOPNExt = __webpack_require__(299);
	var $GOPD = __webpack_require__(51);
	var $GOPS = __webpack_require__(161);
	var $DP = __webpack_require__(30);
	var $keys = __webpack_require__(96);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(95).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(133).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(83)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(43)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $typed = __webpack_require__(166);
	var buffer = __webpack_require__(226);
	var anObject = __webpack_require__(11);
	var toAbsoluteIndex = __webpack_require__(100);
	var toLength = __webpack_require__(27);
	var isObject = __webpack_require__(19);
	var ArrayBuffer = __webpack_require__(16).ArrayBuffer;
	var speciesConstructor = __webpack_require__(135);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(18)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(99)(ARRAY_BUFFER);


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(166).ABV, {
	  DataView: __webpack_require__(226).DataView
	});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(287);
	var validate = __webpack_require__(102);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(155)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(288);
	var toObject = __webpack_require__(32);
	var toLength = __webpack_require__(27);
	var aFunction = __webpack_require__(37);
	var arraySpeciesCreate = __webpack_require__(205);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(82)('flatMap');


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(288);
	var toObject = __webpack_require__(32);
	var toLength = __webpack_require__(27);
	var toInteger = __webpack_require__(63);
	var arraySpeciesCreate = __webpack_require__(205);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(82)('flatten');


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(3);
	var $includes = __webpack_require__(154)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(82)('includes');


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(3);
	var microtask = __webpack_require__(217)();
	var process = __webpack_require__(16).process;
	var isNode = __webpack_require__(59)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3);
	var cof = __webpack_require__(59);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.G, { global: __webpack_require__(16) });


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(163)('Map');


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(164)('Map');


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(286)('Map') });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var scale = __webpack_require__(296);
	var fround = __webpack_require__(294);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { scale: __webpack_require__(296) });


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(32);
	var aFunction = __webpack_require__(37);
	var $defineProperty = __webpack_require__(30);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(28) && $export($export.P + __webpack_require__(160), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(32);
	var aFunction = __webpack_require__(37);
	var $defineProperty = __webpack_require__(30);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(28) && $export($export.P + __webpack_require__(160), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3);
	var $entries = __webpack_require__(301)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(3);
	var ownKeys = __webpack_require__(302);
	var toIObject = __webpack_require__(53);
	var gOPD = __webpack_require__(51);
	var createProperty = __webpack_require__(206);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(69);
	var getPrototypeOf = __webpack_require__(52);
	var getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(28) && $export($export.P + __webpack_require__(160), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(69);
	var getPrototypeOf = __webpack_require__(52);
	var getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(28) && $export($export.P + __webpack_require__(160), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3);
	var $values = __webpack_require__(301)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(3);
	var global = __webpack_require__(16);
	var core = __webpack_require__(60);
	var microtask = __webpack_require__(217)();
	var OBSERVABLE = __webpack_require__(25)('observable');
	var aFunction = __webpack_require__(37);
	var anObject = __webpack_require__(11);
	var anInstance = __webpack_require__(92);
	var redefineAll = __webpack_require__(98);
	var hide = __webpack_require__(43);
	var forOf = __webpack_require__(93);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(99)('Observable');


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(3);
	var core = __webpack_require__(60);
	var global = __webpack_require__(16);
	var speciesConstructor = __webpack_require__(135);
	var promiseResolve = __webpack_require__(306);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(3);
	var newPromiseCapability = __webpack_require__(218);
	var perform = __webpack_require__(305);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(314);
	var from = __webpack_require__(282);
	var metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(52);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(52);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var getPrototypeOf = __webpack_require__(52);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(75);
	var anObject = __webpack_require__(11);
	var aFunction = __webpack_require__(37);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(163)('Set');


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(164)('Set');


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(286)('Set') });


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(165)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(3);
	var defined = __webpack_require__(67);
	var toLength = __webpack_require__(27);
	var isRegExp = __webpack_require__(158);
	var getFlags = __webpack_require__(131);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(213)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(308);
	var userAgent = __webpack_require__(167);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(308);
	var userAgent = __webpack_require__(167);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(117)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(117)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(227)('asyncIterator');


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(227)('observable');


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', { global: __webpack_require__(16) });


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(163)('WeakMap');


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(164)('WeakMap');


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(163)('WeakSet');


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(164)('WeakSet');


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(229);
	var getKeys = __webpack_require__(96);
	var redefine = __webpack_require__(44);
	var global = __webpack_require__(16);
	var hide = __webpack_require__(43);
	var Iterators = __webpack_require__(115);
	var wks = __webpack_require__(25);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $task = __webpack_require__(225);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(16);
	var $export = __webpack_require__(3);
	var userAgent = __webpack_require__(167);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(679);
	__webpack_require__(618);
	__webpack_require__(620);
	__webpack_require__(619);
	__webpack_require__(622);
	__webpack_require__(624);
	__webpack_require__(629);
	__webpack_require__(623);
	__webpack_require__(621);
	__webpack_require__(631);
	__webpack_require__(630);
	__webpack_require__(626);
	__webpack_require__(627);
	__webpack_require__(625);
	__webpack_require__(617);
	__webpack_require__(628);
	__webpack_require__(632);
	__webpack_require__(633);
	__webpack_require__(585);
	__webpack_require__(587);
	__webpack_require__(586);
	__webpack_require__(635);
	__webpack_require__(634);
	__webpack_require__(605);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(606);
	__webpack_require__(607);
	__webpack_require__(608);
	__webpack_require__(609);
	__webpack_require__(610);
	__webpack_require__(611);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(614);
	__webpack_require__(588);
	__webpack_require__(589);
	__webpack_require__(590);
	__webpack_require__(591);
	__webpack_require__(592);
	__webpack_require__(593);
	__webpack_require__(594);
	__webpack_require__(595);
	__webpack_require__(596);
	__webpack_require__(597);
	__webpack_require__(598);
	__webpack_require__(599);
	__webpack_require__(600);
	__webpack_require__(601);
	__webpack_require__(602);
	__webpack_require__(603);
	__webpack_require__(604);
	__webpack_require__(666);
	__webpack_require__(671);
	__webpack_require__(678);
	__webpack_require__(669);
	__webpack_require__(661);
	__webpack_require__(662);
	__webpack_require__(667);
	__webpack_require__(672);
	__webpack_require__(674);
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(665);
	__webpack_require__(668);
	__webpack_require__(670);
	__webpack_require__(673);
	__webpack_require__(675);
	__webpack_require__(676);
	__webpack_require__(677);
	__webpack_require__(580);
	__webpack_require__(582);
	__webpack_require__(581);
	__webpack_require__(584);
	__webpack_require__(583);
	__webpack_require__(569);
	__webpack_require__(567);
	__webpack_require__(573);
	__webpack_require__(570);
	__webpack_require__(576);
	__webpack_require__(578);
	__webpack_require__(566);
	__webpack_require__(572);
	__webpack_require__(563);
	__webpack_require__(577);
	__webpack_require__(561);
	__webpack_require__(575);
	__webpack_require__(574);
	__webpack_require__(568);
	__webpack_require__(571);
	__webpack_require__(560);
	__webpack_require__(562);
	__webpack_require__(565);
	__webpack_require__(564);
	__webpack_require__(579);
	__webpack_require__(229);
	__webpack_require__(651);
	__webpack_require__(312);
	__webpack_require__(656);
	__webpack_require__(313);
	__webpack_require__(652);
	__webpack_require__(653);
	__webpack_require__(654);
	__webpack_require__(655);
	__webpack_require__(636);
	__webpack_require__(311);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(691);
	__webpack_require__(680);
	__webpack_require__(681);
	__webpack_require__(686);
	__webpack_require__(689);
	__webpack_require__(690);
	__webpack_require__(684);
	__webpack_require__(687);
	__webpack_require__(685);
	__webpack_require__(688);
	__webpack_require__(682);
	__webpack_require__(683);
	__webpack_require__(637);
	__webpack_require__(638);
	__webpack_require__(639);
	__webpack_require__(640);
	__webpack_require__(641);
	__webpack_require__(644);
	__webpack_require__(642);
	__webpack_require__(643);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(650);
	__webpack_require__(649);
	__webpack_require__(694);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(735);
	__webpack_require__(738);
	__webpack_require__(737);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(736);
	__webpack_require__(741);
	__webpack_require__(742);
	__webpack_require__(716);
	__webpack_require__(719);
	__webpack_require__(715);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(717);
	__webpack_require__(718);
	__webpack_require__(700);
	__webpack_require__(734);
	__webpack_require__(699);
	__webpack_require__(733);
	__webpack_require__(745);
	__webpack_require__(747);
	__webpack_require__(698);
	__webpack_require__(732);
	__webpack_require__(744);
	__webpack_require__(746);
	__webpack_require__(697);
	__webpack_require__(743);
	__webpack_require__(696);
	__webpack_require__(701);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(704);
	__webpack_require__(705);
	__webpack_require__(707);
	__webpack_require__(706);
	__webpack_require__(708);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(712);
	__webpack_require__(711);
	__webpack_require__(721);
	__webpack_require__(722);
	__webpack_require__(723);
	__webpack_require__(724);
	__webpack_require__(726);
	__webpack_require__(725);
	__webpack_require__(728);
	__webpack_require__(727);
	__webpack_require__(729);
	__webpack_require__(730);
	__webpack_require__(731);
	__webpack_require__(695);
	__webpack_require__(720);
	__webpack_require__(750);
	__webpack_require__(749);
	__webpack_require__(748);
	module.exports = __webpack_require__(60);


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(759), __esModule: true };

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(760), __esModule: true };

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(761), __esModule: true };

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(754);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(752);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(168);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(331);
	__webpack_require__(330);
	module.exports = __webpack_require__(783);


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(331);
	__webpack_require__(330);
	module.exports = __webpack_require__(784);


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(786);
	module.exports = __webpack_require__(103).Object.assign;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(787);
	var $Object = __webpack_require__(103).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(236);
	var toLength = __webpack_require__(780);
	var toAbsoluteIndex = __webpack_require__(779);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(762);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(119).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(118) && !__webpack_require__(232)(function () {
	  return Object.defineProperty(__webpack_require__(319)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(771);
	var descriptor = __webpack_require__(325);
	var setToStringTag = __webpack_require__(326);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(136)(IteratorPrototype, __webpack_require__(104)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(118);
	var getKeys = __webpack_require__(324);
	var gOPS = __webpack_require__(773);
	var pIE = __webpack_require__(776);
	var toObject = __webpack_require__(328);
	var IObject = __webpack_require__(321);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(232)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(169);
	var dPs = __webpack_require__(772);
	var enumBugKeys = __webpack_require__(320);
	var IE_PROTO = __webpack_require__(234)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(319)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(766).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(171);
	var anObject = __webpack_require__(169);
	var getKeys = __webpack_require__(324);
	
	module.exports = __webpack_require__(118) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 773 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(170);
	var toObject = __webpack_require__(328);
	var IE_PROTO = __webpack_require__(234)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(170);
	var toIObject = __webpack_require__(236);
	var arrayIndexOf = __webpack_require__(764)(false);
	var IE_PROTO = __webpack_require__(234)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 776 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(136);


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(235);
	var defined = __webpack_require__(230);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(235);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(235);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(233);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(317);
	var ITERATOR = __webpack_require__(104)('iterator');
	var Iterators = __webpack_require__(137);
	module.exports = __webpack_require__(103).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(169);
	var get = __webpack_require__(782);
	module.exports = __webpack_require__(103).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(317);
	var ITERATOR = __webpack_require__(104)('iterator');
	var Iterators = __webpack_require__(137);
	module.exports = __webpack_require__(103).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(763);
	var step = __webpack_require__(769);
	var Iterators = __webpack_require__(137);
	var toIObject = __webpack_require__(236);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(322)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(231);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(770) });


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(231);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(118), 'Object', { defineProperty: __webpack_require__(171).f });


/***/ }),
/* 788 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 789 */,
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(271)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Chartist) {
	      return (root.returnExportsGlobal = factory(Chartist));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like enviroments that support module.exports,
	    // like Node.
	    module.exports = factory(require("chartist"));
	  } else {
	    root['Chartist.plugins.tooltips'] = factory(Chartist);
	  }
	}(this, function (Chartist) {
	
	  /**
	   * Chartist.js plugin to display a data label on top of the points in a line chart.
	   *
	   */
	  /* global Chartist */
	  (function (window, document, Chartist) {
	    'use strict';
	
	    var defaultOptions = {
	      currency: undefined,
	      tooltipOffset: {
	        x: 0,
	        y: -20
	      },
	      anchorToPoint: false,
	      appendToBody: false,
	      class: undefined,
	      pointClass: 'ct-point'
	    };
	
	    Chartist.plugins = Chartist.plugins || {};
	    Chartist.plugins.tooltip = function (options) {
	      options = Chartist.extend({}, defaultOptions, options);
	
	      return function tooltip(chart) {
	        var tooltipSelector = options.pointClass;
	        if (chart instanceof Chartist.Bar) {
	          tooltipSelector = 'ct-bar';
	        } else if (chart instanceof Chartist.Pie) {
	          // Added support for donut graph
	          if (chart.options.donut) {
	            tooltipSelector = 'ct-slice-donut';
	          } else {
	            tooltipSelector = 'ct-slice-pie';
	          }
	        }
	
	        var $chart = chart.container;
	        var $toolTip = $chart.querySelector('.chartist-tooltip');
	        if (!$toolTip) {
	          $toolTip = document.createElement('div');
	          $toolTip.className = (!options.class) ? 'chartist-tooltip' : 'chartist-tooltip ' + options.class;
	          if (!options.appendToBody) {
	            $chart.appendChild($toolTip);
	          } else {
	            document.body.appendChild($toolTip);
	          }
	        }
	        var height = $toolTip.offsetHeight;
	        var width = $toolTip.offsetWidth;
	
	        hide($toolTip);
	
	        function on(event, selector, callback) {
	          $chart.addEventListener(event, function (e) {
	            if (!selector || hasClass(e.target, selector))
	              callback(e);
	          });
	        }
	
	        on('mouseover', tooltipSelector, function (event) {
	          var $point = event.target;
	          var tooltipText = '';
	
	          var isPieChart = (chart instanceof Chartist.Pie) ? $point : $point.parentNode;
	          var seriesName = (isPieChart) ? $point.parentNode.getAttribute('ct:meta') || $point.parentNode.getAttribute('ct:series-name') : '';
	          var meta = $point.getAttribute('ct:meta') || seriesName || '';
	          var hasMeta = !!meta;
	          var value = $point.getAttribute('ct:value');
	
	          if (options.transformTooltipTextFnc && typeof options.transformTooltipTextFnc === 'function') {
	            value = options.transformTooltipTextFnc(value);
	          }
	
	          if (options.tooltipFnc && typeof options.tooltipFnc === 'function') {
	            tooltipText = options.tooltipFnc(meta, value);
	          } else {
	            if (options.metaIsHTML) {
	              var txt = document.createElement('textarea');
	              txt.innerHTML = meta;
	              meta = txt.value;
	            }
	
	            meta = '<span class="chartist-tooltip-meta">' + meta + '</span>';
	
	            if (hasMeta) {
	              tooltipText += meta + '<br>';
	            } else {
	              // For Pie Charts also take the labels into account
	              // Could add support for more charts here as well!
	              if (chart instanceof Chartist.Pie) {
	                var label = next($point, 'ct-label');
	                if (label) {
	                  tooltipText += text(label) + '<br>';
	                }
	              }
	            }
	
	            if (value) {
	              if (options.currency) {
	                value = options.currency + value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
	              }
	              value = '<span class="chartist-tooltip-value">' + value + '</span>';
	              tooltipText += value;
	            }
	          }
	
	          if(tooltipText) {
	            $toolTip.innerHTML = tooltipText;
	            setPosition(event);
	            show($toolTip);
	
	            // Remember height and width to avoid wrong position in IE
	            height = $toolTip.offsetHeight;
	            width = $toolTip.offsetWidth;
	          }
	        });
	
	        on('mouseout', tooltipSelector, function () {
	          hide($toolTip);
	        });
	
	        on('mousemove', null, function (event) {
	          if (false === options.anchorToPoint)
	            setPosition(event);
	        });
	
	        function setPosition(event) {
	          height = height || $toolTip.offsetHeight;
	          width = width || $toolTip.offsetWidth;
	          var offsetX = - width / 2 + options.tooltipOffset.x
	          var offsetY = - height + options.tooltipOffset.y;
	          var anchorX, anchorY;
	
	          if (!options.appendToBody) {
	            var box = $chart.getBoundingClientRect();
	            var left = event.pageX - box.left - window.pageXOffset ;
	            var top = event.pageY - box.top - window.pageYOffset ;
	
	            if (true === options.anchorToPoint && event.target.x2 && event.target.y2) {
	              anchorX = parseInt(event.target.x2.baseVal.value);
	              anchorY = parseInt(event.target.y2.baseVal.value);
	            }
	
	            $toolTip.style.top = (anchorY || top) + offsetY + 'px';
	            $toolTip.style.left = (anchorX || left) + offsetX + 'px';
	          } else {
	            $toolTip.style.top = event.pageY + offsetY + 'px';
	            $toolTip.style.left = event.pageX + offsetX + 'px';
	          }
	        }
	      }
	    };
	
	    function show(element) {
	      if(!hasClass(element, 'tooltip-show')) {
	        element.className = element.className + ' tooltip-show';
	      }
	    }
	
	    function hide(element) {
	      var regex = new RegExp('tooltip-show' + '\\s*', 'gi');
	      element.className = element.className.replace(regex, '').trim();
	    }
	
	    function hasClass(element, className) {
	      return (' ' + element.getAttribute('class') + ' ').indexOf(' ' + className + ' ') > -1;
	    }
	
	    function next(element, className) {
	      do {
	        element = element.nextSibling;
	      } while (element && !hasClass(element, className));
	      return element;
	    }
	
	    function text(element) {
	      return element.innerText || element.textContent;
	    }
	
	  } (window, document, Chartist));
	
	  return Chartist.plugins.tooltips;
	
	}));


/***/ }),
/* 791 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* jshint proto: true */
	
	/**
	 * jjv.js -- A javascript library to validate json input through a json-schema.
	 *
	 * Copyright (c) 2013 Alex Cornejo.
	 *
	 * Redistributable under a MIT-style open source license.
	 */
	
	(function () {
	  var clone = function (obj) {
	      // Handle the 3 simple types (string, number, function), and null or undefined
	      if (obj === null || typeof obj !== 'object') return obj;
	      var copy;
	
	      // Handle Date
	      if (obj instanceof Date) {
	          copy = new Date();
	          copy.setTime(obj.getTime());
	          return copy;
	      }
	
	      // handle RegExp
	      if (obj instanceof RegExp) {
	        copy = new RegExp(obj);
	        return copy;
	      }
	
	      // Handle Array
	      if (obj instanceof Array) {
	          copy = [];
	          for (var i = 0, len = obj.length; i < len; i++)
	              copy[i] = clone(obj[i]);
	          return copy;
	      }
	
	      // Handle Object
	      if (obj instanceof Object) {
	          copy = {};
	          var hasOwnProperty = copy.hasOwnProperty;
	//           copy = Object.create(Object.getPrototypeOf(obj));
	          for (var attr in obj) {
	              if (hasOwnProperty.call(obj, attr))
	                copy[attr] = clone(obj[attr]);
	          }
	          return copy;
	      }
	
	      throw new Error("Unable to clone object!");
	  };
	
	  var clone_stack = function (stack) {
	    var new_stack = [ clone(stack[0]) ], key = new_stack[0].key, obj = new_stack[0].object;
	    for (var i = 1, len = stack.length; i< len; i++) {
	      obj = obj[key];
	      key = stack[i].key;
	      new_stack.push({ object: obj, key: key });
	    }
	    return new_stack;
	  };
	
	  var copy_stack = function (new_stack, old_stack) {
	    var stack_last = new_stack.length-1, key = new_stack[stack_last].key;
	    old_stack[stack_last].object[key] = new_stack[stack_last].object[key];
	  };
	
	  var handled = {
	    'type': true,
	    'not': true,
	    'anyOf': true,
	    'allOf': true,
	    'oneOf': true,
	    '$ref': true,
	    '$schema': true,
	    'id': true,
	    'exclusiveMaximum': true,
	    'exclusiveMininum': true,
	    'properties': true,
	    'patternProperties': true,
	    'additionalProperties': true,
	    'items': true,
	    'additionalItems': true,
	    'required': true,
	    'default': true,
	    'title': true,
	    'description': true,
	    'definitions': true,
	    'dependencies': true
	  };
	
	  var fieldType = {
	    'null': function (x) {
	      return x === null;
	    },
	    'string': function (x) {
	      return typeof x === 'string';
	    },
	    'boolean': function (x) {
	      return typeof x === 'boolean';
	    },
	    'number': function (x) {
	      // Use x === x instead of !isNaN(x) for speed
	      return typeof x === 'number' && x === x;
	    },
	    'integer': function (x) {
	      return typeof x === 'number' && x%1 === 0;
	    },
	    'object': function (x) {
	      return x && typeof x === 'object' && !Array.isArray(x);
	    },
	    'array': function (x) {
	      return Array.isArray(x);
	    },
	    'date': function (x) {
	      return x instanceof Date;
	    }
	  };
	
	  // missing: uri, date-time, ipv4, ipv6
	  var fieldFormat = {
	    'alpha': function (v) {
	      return (/^[a-zA-Z]+$/).test(v);
	    },
	    'alphanumeric': function (v) {
	      return (/^[a-zA-Z0-9]+$/).test(v);
	    },
	    'identifier': function (v) {
	      return (/^[-_a-zA-Z0-9]+$/).test(v);
	    },
	    'hexadecimal': function (v) {
	      return (/^[a-fA-F0-9]+$/).test(v);
	    },
	    'numeric': function (v) {
	      return (/^[0-9]+$/).test(v);
	    },
	    'date-time': function (v) {
	      return !isNaN(Date.parse(v)) && v.indexOf('/') === -1;
	    },
	    'uppercase': function (v) {
	      return v === v.toUpperCase();
	    },
	    'lowercase': function (v) {
	      return v === v.toLowerCase();
	    },
	    'hostname': function (v) {
	      return v.length < 256 && (/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9]))*$/).test(v);
	    },
	    'uri': function (v) {
	      return (/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/).test(v);
	    },
	    'email': function (v) { // email, ipv4 and ipv6 adapted from node-validator
	      return (/^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/).test(v);
	    },
	    'ipv4': function (v) {
	      if ((/^(\d?\d?\d)\.(\d?\d?\d)\.(\d?\d?\d)\.(\d?\d?\d)$/).test(v)) {
	        var parts = v.split('.').sort();
	        if (parts[3] <= 255)
	          return true;
	      }
	      return false;
	    },
	    'ipv6': function(v) {
	      return (/^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/).test(v);
	     /*  return (/^::|^::1|^([a-fA-F0-9]{1,4}::?){1,7}([a-fA-F0-9]{1,4})$/).test(v); */
	    }
	  };
	
	  var fieldValidate = {
	    'readOnly': function (v, p) {
	      return false;
	    },
	    // ****** numeric validation ********
	    'minimum': function (v, p, schema) {
	      return !(v < p || schema.exclusiveMinimum && v <= p);
	    },
	    'maximum': function (v, p, schema) {
	      return !(v > p || schema.exclusiveMaximum && v >= p);
	    },
	    'multipleOf': function (v, p) {
	      return (v/p)%1 === 0 || typeof v !== 'number';
	    },
	    // ****** string validation ******
	    'pattern': function (v, p) {
	      if (typeof v !== 'string')
	        return true;
	      var pattern, modifiers;
	      if (typeof p === 'string')
	        pattern=p;
	      else {
	        pattern=p[0];
	        modifiers=p[1];
	      }
	      var regex = new RegExp(pattern, modifiers);
	      return regex.test(v);
	    },
	    'minLength': function (v, p) {
	      return v.length >= p || typeof v !== 'string';
	    },
	    'maxLength': function (v, p) {
	      return v.length <= p || typeof v !== 'string';
	    },
	    // ***** array validation *****
	    'minItems': function (v, p) {
	      return v.length >= p || !Array.isArray(v);
	    },
	    'maxItems': function (v, p) {
	      return v.length <= p || !Array.isArray(v);
	    },
	    'uniqueItems': function (v, p) {
	      var hash = {}, key;
	      for (var i = 0, len = v.length; i < len; i++) {
	        key = JSON.stringify(v[i]);
	        if (hash.hasOwnProperty(key))
	          return false;
	        else
	          hash[key] = true;
	      }
	      return true;
	    },
	    // ***** object validation ****
	    'minProperties': function (v, p) {
	      if (typeof v !== 'object')
	        return true;
	      var count = 0;
	      for (var attr in v) if (v.hasOwnProperty(attr)) count = count + 1;
	      return count >= p;
	    },
	    'maxProperties': function (v, p) {
	      if (typeof v !== 'object')
	        return true;
	      var count = 0;
	      for (var attr in v) if (v.hasOwnProperty(attr)) count = count + 1;
	      return count <= p;
	    },
	    // ****** all *****
	    'constant': function (v, p) {
	      return JSON.stringify(v) == JSON.stringify(p);
	    },
	    'enum': function (v, p) {
	      var i, len, vs;
	      if (typeof v === 'object') {
	        vs = JSON.stringify(v);
	        for (i = 0, len = p.length; i < len; i++)
	          if (vs === JSON.stringify(p[i]))
	            return true;
	      } else {
	        for (i = 0, len = p.length; i < len; i++)
	          if (v === p[i])
	            return true;
	      }
	      return false;
	    }
	  };
	
	  var normalizeID = function (id) {
	    return id.indexOf("://") === -1 ? id : id.split("#")[0];
	  };
	
	  var resolveURI = function (env, schema_stack, uri) {
	    var curschema, components, hash_idx, name;
	
	    hash_idx = uri.indexOf('#');
	
	    if (hash_idx === -1) {
	      if (!env.schema.hasOwnProperty(uri))
	        return null;
	      return [env.schema[uri]];
	    }
	
	    if (hash_idx > 0) {
	      name = uri.substr(0, hash_idx);
	      uri = uri.substr(hash_idx+1);
	      if (!env.schema.hasOwnProperty(name)) {
	        if (schema_stack && schema_stack[0].id === name)
	          schema_stack = [schema_stack[0]];
	        else
	          return null;
	      } else
	        schema_stack = [env.schema[name]];
	    } else {
	      if (!schema_stack)
	        return null;
	      uri = uri.substr(1);
	    }
	
	    if (uri === '')
	      return [schema_stack[0]];
	
	    if (uri.charAt(0) === '/') {
	      uri = uri.substr(1);
	      curschema = schema_stack[0];
	      components = uri.split('/');
	      while (components.length > 0) {
	        if (!curschema.hasOwnProperty(components[0]))
	          return null;
	        curschema = curschema[components[0]];
	        schema_stack.push(curschema);
	        components.shift();
	      }
	      return schema_stack;
	    } else // FIX: should look for subschemas whose id matches uri
	      return null;
	  };
	
	  var resolveObjectRef = function (object_stack, uri) {
	    var components, object, last_frame = object_stack.length-1, skip_frames, frame, m = /^(\d+)/.exec(uri);
	
	    if (m) {
	      uri = uri.substr(m[0].length);
	      skip_frames = parseInt(m[1], 10);
	      if (skip_frames < 0 || skip_frames > last_frame)
	        return;
	      frame = object_stack[last_frame-skip_frames];
	      if (uri === '#')
	        return frame.key;
	    } else
	      frame = object_stack[0];
	
	    object = frame.object[frame.key];
	
	    if (uri === '')
	      return object;
	
	    if (uri.charAt(0) === '/') {
	      uri = uri.substr(1);
	      components = uri.split('/');
	      while (components.length > 0) {
	        components[0] = components[0].replace(/~1/g, '/').replace(/~0/g, '~');
	        if (!object.hasOwnProperty(components[0]))
	          return;
	        object = object[components[0]];
	        components.shift();
	      }
	      return object;
	    } else
	      return;
	  };
	
	  var checkValidity = function (env, schema_stack, object_stack, options) {
	    var i, len, count, hasProp, hasPattern;
	    var p, v, malformed = false, objerrs = {}, objerr, props, matched;
	    var sl = schema_stack.length-1, schema = schema_stack[sl], new_stack;
	    var ol = object_stack.length-1, object = object_stack[ol].object, name = object_stack[ol].key, prop = object[name];
	    var errCount, minErrCount;
	
	    if (schema.hasOwnProperty('$ref')) {
	      schema_stack= resolveURI(env, schema_stack, schema.$ref);
	      if (!schema_stack)
	        return {'$ref': schema.$ref};
	      else
	        return env.checkValidity(env, schema_stack, object_stack, options);
	    }
	
	    if (schema.hasOwnProperty('type')) {
	      if (prop === undefined) {
	        // skip
	      }
	      else if (typeof schema.type === 'string') {
	        if (options.useCoerce && env.coerceType.hasOwnProperty(schema.type))
	          prop = object[name] = env.coerceType[schema.type](prop);
	        if (!env.fieldType[schema.type](prop))
	          return {'type': schema.type};
	      } else {
	        malformed = true;
	        for (i = 0, len = schema.type.length; i < len && malformed; i++)
	          if (env.fieldType[schema.type[i]](prop))
	            malformed = false;
	        if (malformed)
	          return {'type': schema.type};
	      }
	    }
	
	    if (schema.hasOwnProperty('allOf')) {
	      for (i = 0, len = schema.allOf.length; i < len; i++) {
	        objerr = env.checkValidity(env, schema_stack.concat(schema.allOf[i]), object_stack, options);
	        if (objerr)
	          return objerr;
	      }
	    }
	
	    if (!options.useCoerce && !options.useDefault && !options.removeAdditional) {
	      if (schema.hasOwnProperty('oneOf')) {
	        minErrCount = Infinity;
	        for (i = 0, len = schema.oneOf.length, count = 0; i < len; i++) {
	          objerr = env.checkValidity(env, schema_stack.concat(schema.oneOf[i]), object_stack, options);
	          if (!objerr) {
	            count = count + 1;
	            if (count > 1)
	              break;
	          } else {
	            errCount = objerr.schema ? Object.keys(objerr.schema).length : 1;
	            if (errCount < minErrCount) {
	                minErrCount = errCount;
	                objerrs = objerr;
	            }
	          }
	        }
	        if (count > 1)
	          return {'oneOf': true};
	        else if (count < 1)
	          return objerrs;
	        objerrs = {};
	      }
	
	      if (schema.hasOwnProperty('anyOf')) {
	        objerrs = null;
	        minErrCount = Infinity;
	        for (i = 0, len = schema.anyOf.length; i < len; i++) {
	          objerr = env.checkValidity(env, schema_stack.concat(schema.anyOf[i]), object_stack, options);
	          if (!objerr) {
	            objerrs = null;
	            break;
	          }
	          else {
	            errCount = objerr.schema ? Object.keys(objerr.schema).length : 1;
	            if (errCount < minErrCount) {
	                minErrCount = errCount;
	                objerrs = objerr;
	            }
	          }
	        }
	        if (objerrs)
	          return objerrs;
	      }
	
	      if (schema.hasOwnProperty('not')) {
	        objerr = env.checkValidity(env, schema_stack.concat(schema.not), object_stack, options);
	        if (!objerr)
	          return {'not': true};
	      }
	    } else {
	      if (schema.hasOwnProperty('oneOf')) {
	        minErrCount = Infinity;
	        for (i = 0, len = schema.oneOf.length, count = 0; i < len; i++) {
	          new_stack = clone_stack(object_stack);
	          objerr = env.checkValidity(env, schema_stack.concat(schema.oneOf[i]), new_stack, options);
	          if (!objerr) {
	            count = count + 1;
	            if (count > 1)
	              break;
	            else
	              copy_stack(new_stack, object_stack);
	          } else {
	            errCount = objerr.schema ? Object.keys(objerr.schema).length : 1;
	            if (errCount < minErrCount) {
	                minErrCount = errCount;
	                objerrs = objerr;
	            }
	          }
	        }
	        if (count > 1)
	          return {'oneOf': true};
	        else if (count < 1)
	          return objerrs;
	        objerrs = {};
	      }
	
	      if (schema.hasOwnProperty('anyOf')) {
	        objerrs = null;
	        minErrCount = Infinity;
	        for (i = 0, len = schema.anyOf.length; i < len; i++) {
	          new_stack = clone_stack(object_stack);
	          objerr = env.checkValidity(env, schema_stack.concat(schema.anyOf[i]), new_stack, options);
	          if (!objerr) {
	            copy_stack(new_stack, object_stack);
	            objerrs = null;
	            break;
	          }
	          else {
	            errCount = objerr.schema ? Object.keys(objerr.schema).length : 1;
	            if (errCount < minErrCount) {
	                minErrCount = errCount;
	                objerrs = objerr;
	            }
	          }
	        }
	        if (objerrs)
	          return objerrs;
	      }
	
	      if (schema.hasOwnProperty('not')) {
	        new_stack = clone_stack(object_stack);
	        objerr = env.checkValidity(env, schema_stack.concat(schema.not), new_stack, options);
	        if (!objerr)
	          return {'not': true};
	      }
	    }
	
	    if (schema.hasOwnProperty('dependencies')) {
	      for (p in schema.dependencies)
	        if (schema.dependencies.hasOwnProperty(p) && prop.hasOwnProperty(p)) {
	          if (Array.isArray(schema.dependencies[p])) {
	            for (i = 0, len = schema.dependencies[p].length; i < len; i++)
	              if (!prop.hasOwnProperty(schema.dependencies[p][i])) {
	                return {'dependencies': true};
	              }
	          } else {
	            objerr = env.checkValidity(env, schema_stack.concat(schema.dependencies[p]), object_stack, options);
	            if (objerr)
	              return objerr;
	          }
	        }
	    }
	
	    if (!prop) {
	      //skip
	    } else if (!Array.isArray(prop)) {
	      props = [];
	      objerrs = {};
	      for (p in prop)
	        if (prop.hasOwnProperty(p))
	          props.push(p);
	
	      if (options.checkRequired && schema.required) {
	        for (i = 0, len = schema.required.length; i < len; i++)
	          if (!prop.hasOwnProperty(schema.required[i]) || prop[schema.required[i]] === undefined) {
	            objerrs[schema.required[i]] = {'required': true};
	            malformed = true;
	          }
	      }
	
	      hasProp = schema.hasOwnProperty('properties');
	      hasPattern = schema.hasOwnProperty('patternProperties');
	      if (hasProp || hasPattern) {
	        i = props.length;
	        while (i--) {
	          matched = false;
	          if (hasProp && schema.properties.hasOwnProperty(props[i])) {
	            matched = true;
	            objerr = env.checkValidity(env, schema_stack.concat(schema.properties[props[i]]), object_stack.concat({object: prop, key: props[i]}), options);
	            if (objerr !== null) {
	              objerrs[props[i]] = objerr;
	              malformed = true;
	            }
	          }
	          if (hasPattern) {
	            for (p in schema.patternProperties)
	              if (schema.patternProperties.hasOwnProperty(p) && props[i].match(p)) {
	                matched = true;
	                objerr = env.checkValidity(env, schema_stack.concat(schema.patternProperties[p]), object_stack.concat({object: prop, key: props[i]}), options);
	                if (objerr !== null) {
	                  objerrs[props[i]] = objerr;
	                  malformed = true;
	                }
	              }
	          }
	          if (matched)
	            props.splice(i, 1);
	        }
	      }
	
	      if (options.useDefault && hasProp && !malformed) {
	        for (p in schema.properties)
	          if (schema.properties.hasOwnProperty(p) && !prop.hasOwnProperty(p) && schema.properties[p].hasOwnProperty('default'))
	            prop[p] = clone(schema.properties[p]['default']);
	      }
	
	      if (options.removeAdditional && hasProp && schema.additionalProperties !== true && typeof schema.additionalProperties !== 'object') {
	        for (i = 0, len = props.length; i < len; i++)
	          delete prop[props[i]];
	      } else {
	        if (schema.hasOwnProperty('additionalProperties')) {
	          if (typeof schema.additionalProperties === 'boolean') {
	            if (!schema.additionalProperties) {
	              for (i = 0, len = props.length; i < len; i++) {
	                objerrs[props[i]] = {'additional': true};
	                malformed = true;
	              }
	            }
	          } else {
	            for (i = 0, len = props.length; i < len; i++) {
	              objerr = env.checkValidity(env, schema_stack.concat(schema.additionalProperties), object_stack.concat({object: prop, key: props[i]}), options);
	              if (objerr !== null) {
	                objerrs[props[i]] = objerr;
	                malformed = true;
	              }
	            }
	          }
	        }
	      }
	      if (malformed)
	        return {'schema': objerrs};
	    } else {
	      if (schema.hasOwnProperty('items')) {
	        if (Array.isArray(schema.items)) {
	          for (i = 0, len = schema.items.length; i < len; i++) {
	            objerr = env.checkValidity(env, schema_stack.concat(schema.items[i]), object_stack.concat({object: prop, key: i}), options);
	            if (objerr !== null) {
	              objerrs[i] = objerr;
	              malformed = true;
	            }
	          }
	          if (prop.length > len && schema.hasOwnProperty('additionalItems')) {
	            if (typeof schema.additionalItems === 'boolean') {
	              if (!schema.additionalItems)
	                return {'additionalItems': true};
	            } else {
	              for (i = len, len = prop.length; i < len; i++) {
	                objerr = env.checkValidity(env, schema_stack.concat(schema.additionalItems), object_stack.concat({object: prop, key: i}), options);
	                if (objerr !== null) {
	                  objerrs[i] = objerr;
	                  malformed = true;
	                }
	              }
	            }
	          }
	        } else {
	          for (i = 0, len = prop.length; i < len; i++) {
	            objerr = env.checkValidity(env, schema_stack.concat(schema.items), object_stack.concat({object: prop, key: i}), options);
	            if (objerr !== null) {
	              objerrs[i] = objerr;
	              malformed = true;
	            }
	          }
	        }
	      } else if (schema.hasOwnProperty('additionalItems')) {
	        if (typeof schema.additionalItems !== 'boolean') {
	          for (i = 0, len = prop.length; i < len; i++) {
	            objerr = env.checkValidity(env, schema_stack.concat(schema.additionalItems), object_stack.concat({object: prop, key: i}), options);
	            if (objerr !== null) {
	              objerrs[i] = objerr;
	              malformed = true;
	            }
	          }
	        }
	      }
	      if (malformed)
	        return {'schema': objerrs};
	    }
	
	    for (v in schema) {
	      if (schema.hasOwnProperty(v) && !handled.hasOwnProperty(v)) {
	        if (v === 'format') {
	          if (env.fieldFormat.hasOwnProperty(schema[v]) && !env.fieldFormat[schema[v]](prop, schema, object_stack, options)) {
	            objerrs[v] = true;
	            malformed = true;
	          }
	        } else {
	          if (env.fieldValidate.hasOwnProperty(v) && !env.fieldValidate[v](prop, schema[v].hasOwnProperty('$data') ? resolveObjectRef(object_stack, schema[v].$data) : schema[v], schema, object_stack, options)) {
	            objerrs[v] = true;
	            malformed = true;
	          }
	        }
	      }
	    }
	
	    if (malformed)
	      return objerrs;
	    else
	      return null;
	  };
	
	  var defaultOptions = {
	    useDefault: false,
	    useCoerce: false,
	    checkRequired: true,
	    removeAdditional: false
	  };
	
	  function Environment() {
	    if (!(this instanceof Environment))
	      return new Environment();
	
	    this.coerceType = {};
	    this.fieldType = clone(fieldType);
	    this.fieldValidate = clone(fieldValidate);
	    this.fieldFormat = clone(fieldFormat);
	    this.defaultOptions = clone(defaultOptions);
	    this.schema = {};
	  }
	
	  Environment.prototype = {
	    checkValidity: checkValidity,
	    validate: function (name, object, options) {
	      var schema_stack = [name], errors = null, object_stack = [{object: {'__root__': object}, key: '__root__'}];
	
	      if (typeof name === 'string') {
	        schema_stack = resolveURI(this, null, name);
	        if (!schema_stack)
	          throw new Error('jjv: could not find schema \'' + name + '\'.');
	      }
	
	      if (!options) {
	        options = this.defaultOptions;
	      } else {
	        for (var p in this.defaultOptions)
	          if (this.defaultOptions.hasOwnProperty(p) && !options.hasOwnProperty(p))
	            options[p] = this.defaultOptions[p];
	      }
	
	      errors = this.checkValidity(this, schema_stack, object_stack, options);
	
	      if (errors)
	        return {validation: errors.hasOwnProperty('schema') ? errors.schema : errors};
	      else
	        return null;
	    },
	
	    resolveRef: function (schema_stack, $ref) {
	      return resolveURI(this, schema_stack, $ref);
	    },
	
	    addType: function (name, func) {
	      this.fieldType[name] = func;
	    },
	
	    addTypeCoercion: function (type, func) {
	      this.coerceType[type] = func;
	    },
	
	    addCheck: function (name, func) {
	      this.fieldValidate[name] = func;
	    },
	
	    addFormat: function (name, func) {
	      this.fieldFormat[name] = func;
	    },
	
	    addSchema: function (name, schema) {
	      if (!schema && name) {
	        schema = name;
	        name = undefined;
	      }
	      if (schema.hasOwnProperty('id') && typeof schema.id === 'string' && schema.id !== name) {
	        if (schema.id.charAt(0) === '/')
	          throw new Error('jjv: schema id\'s starting with / are invalid.');
	        this.schema[normalizeID(schema.id)] = schema;
	      } else if (!name) {
	        throw new Error('jjv: schema needs either a name or id attribute.');
	      }
	      if (name)
	        this.schema[normalizeID(name)] = schema;
	    }
	  };
	
	  // Export for use in server and client.
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined')
	    module.exports = Environment;
	  else if (true)
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return Environment;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  else
	    this.jjv = Environment;
	}).call(this);


/***/ }),
/* 796 */
/***/ (function(module, exports) {

	module.exports = {"country_phone_code_to_countries":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"800":["001"],"808":["001"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"870":["001"],"878":["001"],"880":["BD"],"881":["001"],"882":["001"],"883":["001"],"886":["TW"],"888":["001"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"979":["001"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","[46]\\d{4}|[01589]\\d{5}"],"AD":["376","[16]\\d{5,8}|[37-9]\\d{5}",[["(\\d{3})(\\d{3})","$1 $2",["[137-9]|6[0-8]"]],["(\\d{4})(\\d{4})","$1 $2",["180","180[02]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["690"]]]],"AE":["971","[2-79]\\d{7,8}|800\\d{2,9}",[["([2-4679])(\\d{3})(\\d{4})","$1 $2 $3",["[2-4679][2-8]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["([479]00)(\\d)(\\d{5})","$1 $2 $3",["[479]00"],"$1"],["([68]00)(\\d{2,9})","$1 $2",["[68]00"],"$1"]],"0","0$1"],"AF":["93","[2-7]\\d{8}",[["([2-7]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"]]],"0","0$1"],"AG":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"268"],"AI":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"264"],"AL":["355","[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}",[["(4)(\\d{3})(\\d{4})","$1 $2 $3",["4[0-6]"]],["(6\\d)(\\d{3})(\\d{4})","$1 $2 $3",["6"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4[7-9]"]],["(\\d{3})(\\d{3,5})","$1 $2",["[235][16-9]|[79]|8[016-9]"]]],"0","0$1"],"AM":["374","[1-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2",["1|47"]],["(\\d{2})(\\d{6})","$1 $2",["4[1349]|[5-7]|88|9[1-9]"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8|90"],"0 $1"]],"0","(0$1)"],"AO":["244","[29]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3"]]],"AR":["54","11\\d{8}|[2368]\\d{9}|9\\d{10}",[["([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"]],["(9)(11)(\\d{4})(\\d{4})","$2 15-$3-$4",["911"],null,null,"$1 $2 $3-$4"],["(9)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9(?:2[2-4689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"],null,null,"$1 $2 $3-$4"],["(9)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9[23]"],null,null,"$1 $2 $3-$4"],["(11)(\\d{4})(\\d{4})","$1 $2-$3",["11"],null,"true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],null,"true"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]"],null,"true"]],"0","0$1","0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?","9$1"],"AS":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"684"],"AT":["43","[1-9]\\d{3,12}",[["(116\\d{3})","$1",["116"],"$1"],["(1)(\\d{3,12})","$1 $2",["1"]],["(5\\d)(\\d{3,5})","$1 $2",["5[079]"]],["(5\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["5[079]"]],["(5\\d)(\\d{4})(\\d{4,7})","$1 $2 $3",["5[079]"]],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"]],["(\\d{4})(\\d{3,9})","$1 $2",["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"]]],"0","0$1"],"AU":["61","1\\d{4,9}|[2-578]\\d{8}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["[237]\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|[6-8]\\d{4}|9(?:[02-9]\\d{3}|1(?:[0-57-9]\\d{2}|6[0135-9]\\d)))\\d{3}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12457-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,"16\\d{3,7}","550\\d{6}","13(?:00\\d{3}|45[0-4]|\\d)\\d{3}"]],"AW":["297","[25-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"AX":["358","1\\d{5,11}|[35]\\d{5,9}|2\\d{4,9}|4\\d{5,10}|6\\d{7,9}|7\\d{4,9}|8\\d{6,9}",[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(75\\d{3})","$1",["75[12]"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"]],["(\\d)(\\d{4,11})","$1 $2",["[25689][1-8]|3"]]],"0",null,null,null,null,null,["18[1-8]\\d{3,9}","4\\d{5,10}|50\\d{4,8}","800\\d{4,7}","[67]00\\d{5,6}",null,null,"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})"]],"AZ":["994","[1-9]\\d{8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2(?:[0-36]|[45]2)|365"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[4-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"]],"0","(0$1)"],"BA":["387","[3-9]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-356]|[7-9]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6[047]"]]],"0","0$1"],"BB":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"246"],"BD":["880","[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}",[["(2)(\\d{7,8})","$1-$2",["2"]],["(\\d{2})(\\d{4,6})","$1-$2",["[3-79]1"]],["(\\d{4})(\\d{3,6})","$1-$2",["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"]],["(\\d{3})(\\d{3,7})","$1-$2",["[3-79][2-9]|8"]]],"0","0$1"],"BE":["32","[1-9]\\d{7,8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[6-9]"]],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4[23]|9[2-4]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[156]|7[018]|8(?:0[1-9]|[1-79])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"]]],"0","0$1"],"BF":["226","[25-7]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BG":["359","[23567]\\d{5,7}|[489]\\d{6,8}",[["(2)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"]],["(2)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"]],["(\\d{3})(\\d{4})","$1 $2",["43[124-7]|70[1-9]"]],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[124-7]|70[1-9]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[78]00"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["99[69]"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["48|8[7-9]|9[08]"]]],"0","0$1"],"BH":["973","[136-9]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"BI":["257","[267]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BJ":["229","[2689]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"]]]],"BL":["590","[56]\\d{8}",[["([56]\\d{2})(\\d{2})(\\d{4})","$1 $2-$3",["590|69[01]"]]],"0",null,null,null,null,null,["590(?:2[7-9]|5[12]|87)\\d{4}","69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"]],"BM":["1","[4589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"441"],"BN":["673","[2-578]\\d{6}",[["([2-578]\\d{2})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","[23467]\\d{7}|8\\d{8}",[["([234])(\\d{7})","$1 $2",["[2-4]"]],["([67]\\d{7})","$1",["[67]"]],["(800)(\\d{2})(\\d{4})","$1 $2 $3",["800"]]],"0",null,"0(1\\d)?"],"BQ":["599","[347]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],["(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}","(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]],"BR":["55","[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))",[["(\\d{4})(\\d{4})","$1-$2",["300|40[02]","300|40(?:0|20)"]],["([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[1-9][1-9]9"],"($1)"]],"0",null,"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"242"],"BT":["975","[1-8]\\d{6,7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1|77"]],["([2-8])(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]]]],"BW":["267","[2-79]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(7\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(90)(\\d{5})","$1 $2",["90"]]]],"BY":["375","[1-4]\\d{8}|8(?:0(?:0\\d{3,7}|[13]\\d{7})|(?:10|20\\d)\\d{7})|9\\d{9,10}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["17[0-3589]|2[4-9]|[34]","17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])","1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"],"8 0$1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["([89]\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8[01]|9"],"8 $1"],["(82\\d)(\\d{4})(\\d{4})","$1 $2 $3",["82"],"8 $1"],["(800)(\\d{3})","$1 $2",["800"],"8 $1"],["(800)(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"]],"8",null,"8?0?"],"BZ":["501","[2-8]\\d{6}|0\\d{10}",[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(0)(800)(\\d{4})(\\d{3})","$1-$2-$3-$4",["080","0800"]]]],"CA":["1","[2-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,null,["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",null,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}","900[2-9]\\d{6}","5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}"]],"CC":["61","[1458]\\d{5,9}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:08|22|68)|4[29]8|62\\d|70[23]|959))\\d{3}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,null,"550\\d{6}","13(?:00\\d{2})?\\d{4}"]],"CD":["243","[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["12"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[0-2459]|9"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"]],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"]]],"0","0$1"],"CF":["236","[278]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"CG":["242","[028]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["800"]]]],"CH":["41","[2-9]\\d{8}|860\\d{9}",[["([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]|[89]1"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["860"]]],"0","0$1"],"CI":["225","[02-8]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"CK":["682","[2-8]\\d{4}",[["(\\d{2})(\\d{3})","$1 $2"]]],"CL":["56","1230\\d{7}|[2-46-9]\\d{8,10}|5[1-3578]\\d{7}",[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[23]"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]"],"($1)"],["(9)(\\d{4})(\\d{4})","$1 $2 $3",["9"]],["(44)(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["[68]00"],"$1"],["(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["600"],"$1"],["(1230)(\\d{3})(\\d{4})","$1 $2 $3",["123","1230"],"$1"],["(\\d{5})(\\d{4})","$1 $2",["219"],"($1)"]],"0","0$1","0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))"],"CM":["237","[2368]\\d{7,8}",[["([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|88"]]]],"CN":["86","[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}",[["([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00"]],["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2\\d)[19]","(?:10|2\\d)(?:10|9[56])","(?:10|2\\d)(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["[3-9]","[3-9]\\d\\d[19]","[3-9]\\d\\d(?:10|9[56])"],"0$1"],["(21)(\\d{4})(\\d{4,6})","$1 $2 $3",["21"],"0$1","true"],["([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"],"0$1","true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1","true"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"],"0$1","true"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["807","8078"],"0$1","true"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1(?:[3-57-9]|66)"]],["(10800)(\\d{3})(\\d{4})","$1 $2 $3",["108","1080","10800"]],["(\\d{3})(\\d{7,8})","$1 $2",["950"]]],"0",null,"(1(?:[129]\\d{3}|79\\d{2}))|0"],"CO":["57","(?:[13]\\d{0,3}|[24-8])\\d{7}",[["(\\d)(\\d{7})","$1 $2",["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]","1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(1)(\\d{3})(\\d{7})","$1-$2-$3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"],"0$1",null,"$1 $2 $3"]],"0",null,"0([3579]|4(?:44|56))?"],"CR":["506","[24-9]\\d{7,9}",[["(\\d{4})(\\d{4})","$1 $2",["[24-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]0"]]],null,null,"(19(?:0[012468]|1[09]|20|66|77|99))"],"CU":["53","[2-57]\\d{5,7}",[["(\\d)(\\d{6,7})","$1 $2",["7"]],["(\\d{2})(\\d{4,6})","$1 $2",["[2-4]"]],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"]],"0","(0$1)"],"CV":["238","[259]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]]],"CW":["599","[134679]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],["(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,["9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}","9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",null,null,null,null,null,"955\\d{5}",null,"60[0-2]\\d{4}"]],"CX":["61","[1458]\\d{5,9}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:21|49|78|81)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,null,"550\\d{6}","13(?:00\\d{2})?\\d{4}"]],"CY":["357","[257-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2"]]],"CZ":["420","[2-8]\\d{8}|9\\d{8,11}",[["([2-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(96\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["96"]],["(9\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9[36]"]]]],"DE":["49","[1-35-9]\\d{3,14}|4(?:[0-8]\\d{3,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})",[["(1\\d{2})(\\d{7,8})","$1 $2",["1[67]"]],["(15\\d{3})(\\d{6})","$1 $2",["15[0568]"]],["(1\\d{3})(\\d{7})","$1 $2",["15"]],["(\\d{2})(\\d{3,11})","$1 $2",["3[02]|40|[68]9"]],["(\\d{3})(\\d{3,11})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"]],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[1346]|8[13568])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"]],["(3\\d{4})(\\d{1,10})","$1 $2",["3"]],["(800)(\\d{7,12})","$1 $2",["800"]],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:37|80)|900","1(?:37|80)|900[1359]"]],["(1\\d{2})(\\d{5,11})","$1 $2",["181"]],["(18\\d{3})(\\d{6})","$1 $2",["185","1850","18500"]],["(18\\d{2})(\\d{7})","$1 $2",["18[68]"]],["(18\\d)(\\d{8})","$1 $2",["18[2-579]"]],["(700)(\\d{4})(\\d{4})","$1 $2 $3",["700"]],["(138)(\\d{4})","$1 $2",["138"]],["(15[013-68])(\\d{2})(\\d{8})","$1 $2 $3",["15[013-68]"]],["(15[279]\\d)(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"]],["(1[67]\\d)(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"]]],"0","0$1"],"DJ":["253","[27]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"DK":["45","[2-9]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"DM":["1","[57-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"767"],"DO":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"8[024]9"],"DZ":["213","(?:[1-4]|[5-9]\\d)\\d{7}",[["([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"]],["([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"]],["(9\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"]]],"0","0$1"],"EC":["593","1\\d{9,10}|[2-8]\\d{7}|9\\d{8}",[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[247]|[356][2-8]"],null,null,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["180","1800"],"$1"]],"0","(0$1)"],"EE":["372","[3-9]\\d{6,7}|800\\d{6,7}",[["([3-79]\\d{2})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]],["(70)(\\d{2})(\\d{4})","$1 $2 $3",["70"]],["(8000)(\\d{3})(\\d{3})","$1 $2 $3",["800","8000"]],["([458]\\d{3})(\\d{3,4})","$1 $2",["40|5|8(?:00|[1-5])","40|5|8(?:00[1-9]|[1-5])"]]]],"EG":["20","1\\d{4,9}|[24-6]\\d{8}|3\\d{7}|[89]\\d{8,9}",[["(\\d)(\\d{7,8})","$1 $2",["[23]"]],["(\\d{2})(\\d{6,7})","$1 $2",["1(?:3|5[239])|[4-6]|[89][2-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1[0-25]|[89]00"]]],"0","0$1"],"EH":["212","[5-9]\\d{8}",[["([5-7]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0",null,null,null,null,"528[89]"],"ER":["291","[178]\\d{6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3"]],"0","0$1"],"ES":["34","[5-9]\\d{8}",[["([89]00)(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[568]|[79][0-8]"]]]],"ET":["251","[1-59]\\d{8}",[["([1-59]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"]]],"0","0$1"],"FI":["358","1\\d{4,11}|[2-9]\\d{4,10}",[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(75\\d{3})","$1",["75[12]"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"]],["(\\d)(\\d{4,11})","$1 $2",["[25689][1-8]|3"]]],"0","0$1",null,null,null,null,["1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}","4(?:[0-8]\\d{4,9}|9\\d{3,8})|50\\d{4,8}","800\\d{4,7}","[67]00\\d{5,6}",null,null,"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{3,7})"]],"FJ":["679","[2-9]\\d{6}|0\\d{10}",[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]]],"FK":["500","[2-7]\\d{4}"],"FM":["691","[39]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"FO":["298","[2-9]\\d{5}",[["(\\d{6})","$1"]],null,null,"(10(?:01|[12]0|88))"],"FR":["33","[1-9]\\d{8}",[["([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"]],["(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"]],"0","0$1"],"GA":["241","0?\\d{7}",[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]]],"GB":["44","\\d{7,10}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0","0$1",null,null,null,null,["2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}","7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}","80(?:0(?:1111|\\d{6,7})|8\\d{7})","(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}","70\\d{8}",null,"(?:3[0347]|55)\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"]],"GD":["1","[4589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"473"],"GE":["995","[34578]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5"]]],"0"],"GF":["594","[56]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"GG":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1481[25-9]\\d{5}","7(?:781\\d|839\\d|911[17])\\d{5}","80(?:0(?:1111|\\d{6,7})|8\\d{7})","(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}","70\\d{8}",null,"(?:3[0347]|55)\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"]],"GH":["233","[235]\\d{8}|8\\d{7}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{5})","$1 $2",["8"]]],"0","0$1"],"GI":["350","[256]\\d{7}",[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","[1-689]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]]],"GM":["220","[2-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"GN":["224","[367]\\d{7,8}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","[56]\\d{8}",[["([56]\\d{2})(\\d{2})(\\d{4})","$1 $2-$3",["590|69[01]"]]],"0","0$1",null,null,null,null,["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}","69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"]],"GQ":["240","[23589]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","[26-9]\\d{9}",[["([27]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2[2-9]1|[689]"]],["(2\\d{3})(\\d{6})","$1 $2",["2[2-9][02-9]"]]]],"GT":["502","[2-7]\\d{7}|1[89]\\d{9}",[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"671"],"GW":["245","(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["44|9[5-7]"]],["(\\d{3})(\\d{4})","$1 $2",["40"]]]],"GY":["592","[2-46-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"HK":["852","[2-7]\\d{7}|8[0-3]\\d{6,7}|9\\d{4,10}",[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|[89](?:0[1-9]|[1-9])"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]],["(900)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["900"]],["(900)(\\d{2,5})","$1 $2",["900"]]]],"HN":["504","[237-9]\\d{7}",[["(\\d{4})(\\d{4})","$1-$2"]]],"HR":["385","[1-7]\\d{5,8}|[89]\\d{6,8}",[["(1)(\\d{4})(\\d{3})","$1 $2 $3",["1"]],["([2-5]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"]],["(9\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]],["(6[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"]],["([67]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"]],["(80[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["80[01]"]],["(80[01])(\\d{3})(\\d{3})","$1 $2 $3",["80[01]"]]],"0","0$1"],"HT":["509","[2-489]\\d{7}",[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3"]]],"HU":["36","[1-9]\\d{7,8}",[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"]]],"06","($1)"],"ID":["62","(?:[1-79]\\d{6,10}|8\\d{7,11})",[["(\\d{2})(\\d{5,8})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,8})","$1 $2",["2[035-9]|[36][02-9]|[4579]"],"(0$1)"],["(8\\d{2})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"]],["(8\\d{2})(\\d{4})(\\d{4,5})","$1-$2-$3",["8[1-35-9]"]],["(1)(500)(\\d{3})","$1 $2 $3",["150","1500"],"$1"],["(177)(\\d{6,8})","$1 $2",["177"]],["(800)(\\d{5,7})","$1 $2",["800"]],["(804)(\\d{3})(\\d{4})","$1 $2 $3",["804"]],["(80\\d)(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80[79]"]]],"0","0$1"],"IE":["353","[124-9]\\d{6,9}",[["(1)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"]],["(\\d{3})(\\d{5})","$1 $2",["40[24]|50[45]"]],["(48)(\\d{4})(\\d{4})","$1 $2 $3",["48"]],["(818)(\\d{3})(\\d{3})","$1 $2 $3",["818"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[24-69]|7[14]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["76|8[35-9]"],"0$1"],["(8\\d)(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8[35-9]5"],"0$1"],["(700)(\\d{3})(\\d{3})","$1 $2 $3",["700"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:5|8[059])","1(?:5|8[059]0)"],"$1"]],"0","(0$1)"],"IL":["972","1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}",[["([2-489])(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["([57]\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(153)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["153"]],["(1)([7-9]\\d{2})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(1255)(\\d{3})","$1-$2",["125","1255"]],["(1200)(\\d{3})(\\d{3})","$1-$2-$3",["120","1200"]],["(1212)(\\d{2})(\\d{2})","$1-$2-$3",["121","1212"]],["(1599)(\\d{6})","$1-$2",["159","1599"]],["(151)(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["151"]],["(\\d{4})","*$1",["[2-689]"]]],"0"],"IM":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1624[5-8]\\d{5}","7(?:4576|[59]24\\d|624[0-4689])\\d{5}","808162\\d{4}","(?:872299|90[0167]624)\\d{4}","70\\d{8}",null,"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}",null,"56\\d{8}","8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}"]],"IN":["91","008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}",[["(\\d{8})","$1",["561","5616","56161"],"$1"],["(\\d{5})(\\d{5})","$1 $2",["6(?:[09]0|2[03689]|3[05-9])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9","6(?:[09]0|2(?:0[01]|39|60|8[0-2]|9[04])|3(?:0[01]|5[0-2]|60|7[05]|81|9[03-5]))|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9","6(?:[09]0|2(?:0[01]|39|60|8[0-2]|9[04])|3(?:0[01]|5[0-2]|60|7[05]|81|9[03-5]))|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[5-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[05-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:0(?:[089]|7[02])|[14](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|1(?:[089]|7[02-6])|2(?:[09]|77|8[0-689])|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-68]))|9(?:[02-9]|1(?:[0289]|7[2-6])))|9"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-9]|80[2-46]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[23579]|[468][1-9])|[2-8]"]],["(\\d{2})(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3 $4",["008"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],"$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["160","1600"],"$1"],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],"$1"],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["180","1800"],"$1"],["(\\d{4})(\\d{3,4})(\\d{4})","$1 $2 $3",["186","1860"],"$1"],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18[06]"],"$1"]],"0","0$1",null,null,true],"IO":["246","3\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"IQ":["964","[1-7]\\d{7,9}",[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["([2-6]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"IR":["98","[1-8]\\d{5,9}|9(?:[0-4]\\d{8}|9\\d{8})",[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"]],["(\\d{2})(\\d{4,5})","$1 $2",["[1-8]"]],["(\\d{4,5})","$1",["96"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]]],"0","0$1"],"IS":["354","[4-9]\\d{6}|38\\d{7}",[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(3\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]]],"IT":["39","[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",[["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\d{4,6})","$1 $2",["0[26]"]],["(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,["0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})","3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","80(?:0\\d{6}|3\\d{3})","0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","1(?:78\\d|99)\\d{6}",null,null,null,"55\\d{8}","84(?:[08]\\d{6}|[17]\\d{3})"]],"JE":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1534[0-24-8]\\d{5}","7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}","80(?:07(?:35|81)|8901)\\d{4}","(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}","701511\\d{4}",null,"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}"]],"JM":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"876"],"JO":["962","[235-9]\\d{7,8}",[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(7)(\\d{4})(\\d{4})","$1 $2 $3",["7[457-9]"]],["(\\d{2})(\\d{7})","$1 $2",["70"]],["(\\d{3})(\\d{5,6})","$1 $2",["8[0158]|9"]]],"0","0$1"],"JP":["81","[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})",[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"]],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]0|80[1-9]"]],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:[34]7|[56]9|74|9[14-79])|82|993"]],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[2479][1-9]"]]],"0","0$1"],"KE":["254","20\\d{6,7}|[4-9]\\d{6,9}",[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"]],["(\\d{3})(\\d{6})","$1 $2",["7"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"]]],"0","0$1","005|0"],"KG":["996","[235-8]\\d{8,9}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[25-7]|31[25]"]],["(\\d{4})(\\d{5})","$1 $2",["3(?:1[36]|[2-9])"]],["(\\d{3})(\\d{3})(\\d)(\\d{3})","$1 $2 $3 $4",["8"]]],"0","0$1"],"KH":["855","[1-9]\\d{7,9}",[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["1\\d[1-9]|[2-9]"],"0$1"],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0","1[89]00"]]],"0"],"KI":["686","[2458]\\d{4}|3\\d{4,7}|[67]\\d{7}",[],null,null,"0"],"KM":["269","[3478]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]]],"KN":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"869"],"KP":["850","1\\d{9}|[28]\\d{7}",[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],"0","0$1"],"KR":["82","00(?:3\\d{8,9}|7\\d{9,11})|[1-7]\\d{4,9}|8\\d{8}",[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"]],["(\\d{4})(\\d{4})","$1-$2",["1(?:5[246-9]|6[046-8]|8[03579])","1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"],"$1"],["(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2[1-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60[2-9]|80"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"]],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]0"]]],"0","0$1","0(8[1-46-8]|85\\d{2})?"],"KW":["965","[12569]\\d{6,7}",[["(\\d{4})(\\d{3,4})","$1 $2",["[16]|2(?:[0-35-9]|4[0-35-9])|52[25]|9[024-9]"]],["(\\d{3})(\\d{5})","$1 $2",["244|5(?:[015]|6[56])"]]]],"KY":["1","[3589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"345"],"KZ":["7","(?:33\\d|7\\d{2}|80[089])\\d{7}",[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8",null,null,null,null,null,["33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}","7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}","800\\d{7}","809\\d{7}","808\\d{7}",null,null,null,"751\\d{7}"]],"LA":["856","[2-8]\\d{7,9}",[["(20)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["20"]],["([2-8]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"]],["(30)(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30"]]],"0","0$1"],"LB":["961","[13-9]\\d{6,7}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["([7-9]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7(?:[01]|6[013-9]|8[89]|9[1-3])|[89][01]"]]],"0"],"LC":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"758"],"LI":["423","6\\d{8}|[23789]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[56]"]],["(69)(7\\d{2})(\\d{4})","$1 $2 $3",["697"]]],"0",null,"0|10(?:01|20|66)"],"LK":["94","[1-9]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"LR":["231","2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}",[["(2\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["([4-5])(\\d{3})(\\d{3})","$1 $2 $3",["[45]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"]]],"0","0$1"],"LS":["266","[2568]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"LT":["370","[3-9]\\d{7}",[["([34]\\d)(\\d{6})","$1 $2",["37|4(?:1|5[45]|6[2-4])"]],["([3-6]\\d{2})(\\d{5})","$1 $2",["3[148]|4(?:[24]|6[09])|528|6"]],["([7-9]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1"],["(5)(2\\d{2})(\\d{4})","$1 $2 $3",["52[0-79]"]]],"8","(8-$1)","[08]",null,true],"LU":["352","[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})",[["(\\d{2})(\\d{3})","$1 $2",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})","$1 $2 $3 $4",["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["70|80[01]|90[015]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],null,null,"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)"],"LV":["371","[2689]\\d{7}",[["([2689]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2689]"]]]],"LY":["218","[25679]\\d{8}",[["([25-79]\\d)(\\d{7})","$1-$2",["[25-79]"]]],"0","0$1"],"MA":["212","[5-9]\\d{8}",[["([5-7]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0","0$1",null,null,null,null,["5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}","(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[07]))\\d{6}","80\\d{7}","89\\d{7}",null,null,null,null,"5924[01]\\d{4}"]],"MC":["377","[34689]\\d{7,8}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"],"$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"]],["(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"]],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["8"],"$1"]],"0","0$1"],"MD":["373","[235-9]\\d{7}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"]],["([25-7]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["2[13-9]|[5-7]"]],["([89]\\d{2})(\\d{5})","$1 $2",["[89]"]]],"0","0$1"],"ME":["382","[2-9]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]|6[036-9]"]]],"0","0$1"],"MF":["590","[56]\\d{8}",[["([56]\\d{2})(\\d{2})(\\d{4})","$1 $2-$3",["590|69[01]"]]],"0",null,null,null,null,null,["590(?:0[079]|13|2[79]|30|43|5[0-268]|7[79]|87)\\d{4}","69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"]],"MG":["261","[23]\\d{8}",[["([23]\\d)(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"]]],"0","0$1"],"MH":["692","[2-6]\\d{6}",[["(\\d{3})(\\d{4})","$1-$2"]],"1"],"MK":["389","[2-578]\\d{7}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([347]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[347]"]],["([58]\\d{2})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"]]],"0","0$1"],"ML":["223","[246-9]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[246-9]"]]]],"MM":["95","[178]\\d{5,7}|[24-6]\\d{5,8}|9(?:[279]\\d{0,2}|5|[34]\\d{1,2}|6(?:\\d{1,2})?|8(?:\\d{2})?)\\d{6}",[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["1|2[245]"]],["(2)(\\d{4})(\\d{4})","$1 $2 $3",["251"]],["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["432|67|81"]],["(\\d{2})(\\d{2})(\\d{3,4})","$1 $2 $3",["[4-8]"]],["(9)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"]],["(9)([34]\\d{4})(\\d{4})","$1 $2 $3",["9(?:3[0-36]|4[0-57-9])"]],["(9)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92[56]"]],["(9)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["93"]]],"0","0$1"],"MN":["976","[12]\\d{7,9}|[57-9]\\d{7}",[["([12]\\d)(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"]],["([12]2\\d)(\\d{5,6})","$1 $2",["[12]2[1-3]"]],["([12]\\d{3})(\\d{5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)2"]],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"],"$1"],["([12]\\d{4})(\\d{4,5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)[4-9]"]]],"0","0$1"],"MO":["853","[268]\\d{7}",[["([268]\\d{3})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"670"],"MQ":["596","[56]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"MR":["222","[2-48]\\d{7}",[["([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"664"],"MT":["356","[2357-9]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"MU":["230","[2-9]\\d{6,7}",[["([2-46-9]\\d{2})(\\d{4})","$1 $2",["[2-46-9]"]],["(5\\d{3})(\\d{4})","$1 $2",["5"]]]],"MV":["960","[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})",[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]00"]]]],"MW":["265","(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[17-9]"]]],"0","0$1"],"MX":["52","[1-9]\\d{9,10}",[["([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"]],["(1)([358]\\d)(\\d{4})(\\d{4})","044 $2 $3 $4",["1(?:33|55|81)"],"$1",null,"$1 $2 $3 $4"],["(1)(\\d{3})(\\d{3})(\\d{4})","044 $2 $3 $4",["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"],"$1",null,"$1 $2 $3 $4"]],"01","01 $1","0[12]|04[45](\\d{10})","1$1",true],"MY":["60","[13-9]\\d{7,9}",[["([4-79])(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(3)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["([18]\\d)(\\d{3})(\\d{3,4})","$1-$2 $3",["1[02-46-9][1-9]|8"],"0$1"],["(1)([36-8]00)(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]0","1[36-8]00"]],["(11)(\\d{4})(\\d{4})","$1-$2 $3",["11"],"0$1"],["(15[49])(\\d{3})(\\d{4})","$1-$2 $3",["15[49]"],"0$1"]],"0"],"MZ":["258","[28]\\d{7,8}",[["([28]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-7]"]],["(80\\d)(\\d{3})(\\d{3})","$1 $2 $3",["80"]]]],"NA":["264","[68]\\d{7,8}",[["(8\\d)(\\d{3})(\\d{4})","$1 $2 $3",["8[1-35]"]],["(6\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["6"]],["(88)(\\d{3})(\\d{3})","$1 $2 $3",["88"]],["(870)(\\d{3})(\\d{3})","$1 $2 $3",["870"]]],"0","0$1"],"NC":["687","[2-57-9]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-46-9]|5[0-4]"]]]],"NE":["227","[0289]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["09|[289]"]],["(08)(\\d{3})(\\d{3})","$1 $2 $3",["08"]]]],"NF":["672","[13]\\d{5}",[["(\\d{2})(\\d{4})","$1 $2",["1"]],["(\\d)(\\d{5})","$1 $2",["3"]]]],"NG":["234","[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}",[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["70|8[01]|90[235-9]"]],["([78]00)(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]00"]],["([78]00)(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]00"]],["(78)(\\d{2})(\\d{3})","$1 $2 $3",["78"]]],"0","0$1"],"NI":["505","[125-8]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"NL":["31","1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}",[["([1-578]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"]],["([1-5]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"]],["(6)(\\d{8})","$1 $2",["6[0-57-9]"]],["(66)(\\d{7})","$1 $2",["66"]],["(14)(\\d{3,4})","$1 $2",["14"],"$1"],["([89]0\\d)(\\d{4,7})","$1 $2",["[89]0"]]],"0","0$1"],"NO":["47","0\\d{4}|[2-9]\\d{7}",[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}","(?:4[015-8]|5[89]|87|9\\d)\\d{6}","80[01]\\d{5}","82[09]\\d{5}","880\\d{5}",null,"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",null,"85[0-5]\\d{5}","810(?:0[0-6]|[2-8]\\d)\\d{3}"]],"NP":["977","[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})",[["(1)(\\d{7})","$1-$2",["1[2-6]"]],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-69]|7[15-9])"]],["(9\\d{2})(\\d{7})","$1-$2",["9(?:6[013]|7[245]|8)"],"$1"]],"0","0$1"],"NR":["674","[458]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"NU":["683","[1-5]\\d{3}"],"NZ":["64","6[235-9]\\d{6}|[2-57-9]\\d{7,9}",[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["240|[346]|7[2-57-9]|9[1-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["21"]],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:1[1-9]|[69]|7[0-35-9])|70|86"]],["(2\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["2[028]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["90"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|5|[89]0"]]],"0","0$1"],"OM":["968","(?:5|[279]\\d)\\d{6}|800\\d{5,6}",[["(2\\d)(\\d{6})","$1 $2",["2"]],["([79]\\d{3})(\\d{4})","$1 $2",["[79]"]],["([58]00)(\\d{4,6})","$1 $2",["[58]00"]]]],"PA":["507","[1-9]\\d{6,7}",[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["6"]]]],"PE":["51","[14-9]\\d{7,8}",[["(1)(\\d{7})","$1 $2",["1"]],["([4-8]\\d)(\\d{6})","$1 $2",["[4-7]|8[2-4]"]],["(\\d{3})(\\d{5})","$1 $2",["80"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"$1"]],"0","(0$1)"],"PF":["689","4\\d{5,7}|8\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[09]|8[79]"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]]]],"PG":["675","[1-9]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[13-689]|27"]],["(\\d{4})(\\d{4})","$1 $2",["20|7"]]]],"PH":["63","1\\d{10,12}|2\\d{5,7}|[3-7]\\d{8}|8\\d{7,9}|9\\d{9}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(2)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["([3-8]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[3-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["81|9"],"0$1"],["(1800)(\\d{3})(\\d{4})","$1 $2 $3",["180","1800"]],["(1800)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["180","1800"]]],"0"],"PK":["92","1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,10}|2\\d(?:111\\d{6}|\\d{3,7}))",[["([89]00)(\\d{3})(\\d{2})","$1 $2 $3",["[89]00"],"0$1"],["(1\\d{3})(\\d{5})","$1 $2",["1"],"$1"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"]],["(\\d{3})(\\d{6,7})","$1 $2",["2[349]|45|54|60|72|8[2-5]|9[2-469]","(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\d[2-9]"]],["(58\\d{3})(\\d{5})","$1 $2",["58[126]"]],["(3\\d{2})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"]],["(\\d{3})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"]]],"0","(0$1)"],"PL":["48","[1-57-9]\\d{6,8}|6\\d{5,8}",[["(\\d{3})(\\d{3})","$1 $2",["11[68]|64"]],["(\\d{5})","$1",["19"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["26|39|45|5[0137]|6[0469]|7[02389]|8[08]"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]]]],"PM":["508","[45]\\d{5}",[["([45]\\d)(\\d{2})(\\d{2})","$1 $2 $3",["[45]"]]],"0","0$1"],"PR":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"787|939"],"PS":["970","1\\d{9}|[24589]\\d{7,8}",[["([2489])(2\\d{2})(\\d{4})","$1 $2 $3",["[2489]2"]],["(5[69]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["5[69]"]],["(1[78]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[78]0","1[78]00"],"$1"]],"0","0$1"],"PT":["351","[2-46-9]\\d{8}",[["(2\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["([2-46-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[3-9]|[346-9]"]]]],"PW":["680","[2-8]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"PY":["595","5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}",[["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["9[1-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["870","8700"]],["(\\d{3})(\\d{4,5})","$1 $2",["[2-8][1-9]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8][1-9]"],"0$1"]],"0"],"QA":["974","[2-8]\\d{6,7}",[["([28]\\d{2})(\\d{4})","$1 $2",["[28]"]],["([3-7]\\d{3})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","[268]\\d{8}",[["([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[268]"]]],"0","0$1",null,null,null,"262|69|8"],"RO":["40","[23]\\d{5,8}|[7-9]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"]],["(\\d{2})(\\d{4})","$1 $2",["[23]1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23][3-7]|[7-9]"]],["(2\\d{2})(\\d{3})","$1 $2",["2[3-6]"]]],"0","0$1"],"RS":["381","[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})",[["([23]\\d{2})(\\d{4,9})","$1 $2",["(?:2[389]|39)0"]],["([1-3]\\d)(\\d{5,10})","$1 $2",["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"]],["(6\\d)(\\d{6,8})","$1 $2",["6"]],["([89]\\d{2})(\\d{3,9})","$1 $2",["[89]"]],["(7[26])(\\d{4,9})","$1 $2",["7[26]"]],["(7[08]\\d)(\\d{4,9})","$1 $2",["7[08]"]]],"0","0$1"],"RU":["7","[347-9]\\d{9}",[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8","8 ($1)",null,null,true,null,["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}","9\\d{9}","80[04]\\d{7}","80[39]\\d{7}","808\\d{7}"]],"RW":["250","[027-9]\\d{7,8}",[["(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["([7-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(0\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],"0"],"SA":["966","1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}",[["([1-467])(\\d{3})(\\d{4})","$1 $2 $3",["[1-467]"]],["(1\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[1-467]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["(92\\d{2})(\\d{5})","$1 $2",["92"],"$1"],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["800"],"$1"],["(811)(\\d{3})(\\d{3,4})","$1 $2 $3",["811"]]],"0","0$1"],"SB":["677","[1-9]\\d{4,6}",[["(\\d{2})(\\d{5})","$1 $2",["[7-9]"]]]],"SC":["248","[24689]\\d{5,6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]"]]]],"SD":["249","[19]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3"]],"0","0$1"],"SE":["46","[1-35-9]\\d{5,11}|4\\d{6,8}",[["(8)(\\d{2,3})(\\d{2,3})(\\d{2})","$1-$2 $3 $4",["8"],null,null,"$1 $2 $3 $4"],["([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],null,null,"$1 $2 $3 $4"],["([1-469]\\d)(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90"],null,null,"$1 $2 $3"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3"],["(7\\d)(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["7"],null,null,"$1 $2 $3 $4"],["(77)(\\d{2})(\\d{2})","$1-$2$3",["77"],null,null,"$1 $2 $3"],["(20)(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],null,null,"$1 $2 $3"],["(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9[034]"],null,null,"$1 $2 $3 $4"],["(9[034]\\d)(\\d{4})","$1-$2",["9[034]"],null,null,"$1 $2"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["25[245]|67[3-6]"],null,null,"$1 $2 $3 $4 $5"]],"0","0$1"],"SG":["65","[36]\\d{7}|[17-9]\\d{7,10}",[["([3689]\\d{3})(\\d{4})","$1 $2",["[369]|8[1-9]"]],["(1[89]00)(\\d{3})(\\d{4})","$1 $2 $3",["1[89]0","1[89]00"]],["(7000)(\\d{4})(\\d{3})","$1 $2 $3",["700","7000"]],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["800"]]]],"SH":["290","[256]\\d{4}|8\\d{3}",[],null,null,null,null,null,null,["2(?:[0-57-9]\\d|6[4-9])\\d{2}","[56]\\d{4}",null,null,null,null,null,null,"262\\d{2}"]],"SI":["386","[1-7]\\d{6,7}|[89]\\d{4,7}",[["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[12]|[34][24-8]|5[2-8]|7[3-8]"],"(0$1)"],["([3-7]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"]],["([89][09])(\\d{3,6})","$1 $2",["[89][09]"]],["([58]\\d{2})(\\d{5})","$1 $2",["59|8[1-3]"]]],"0","0$1"],"SJ":["47","0\\d{4}|[45789]\\d{7}",[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,["79\\d{6}","(?:4[015-8]|5[89]|9\\d)\\d{6}","80[01]\\d{5}","82[09]\\d{5}","880\\d{5}",null,"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",null,"85[0-5]\\d{5}","810(?:0[0-6]|[2-8]\\d)\\d{3}"]],"SK":["421","(?:[2-68]\\d{5,8}|9\\d{6,8})",[["(2)(1[67])(\\d{3,4})","$1 $2 $3",["21[67]"]],["([3-5]\\d)(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5]"]],["(2)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"]],["([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"]],["([689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"]],["(9090)(\\d{3})","$1 $2",["909","9090"]]],"0","0$1"],"SL":["232","[2-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2"]],"0","(0$1)"],"SM":["378","[05-7]\\d{7,9}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(0549)(\\d{6})","$1 $2",["054","0549"],null,null,"($1) $2"],["(\\d{6})","0549 $1",["[89]"],null,null,"(0549) $1"]],null,null,"([89]\\d{5})","0549$1"],"SN":["221","[3789]\\d{8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"SO":["252","[1-9]\\d{5,8}",[["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[13-5]|2[0-79]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{2})(\\d{5,7})","$1 $2",["15|28|6[1-35-9]|799|9[2-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3[59]|4[89]|6[24-6]|79|8[08]|90"]]],"0"],"SR":["597","[2-8]\\d{5,6}",[["(\\d{3})(\\d{3})","$1-$2",["[2-4]|5[2-58]"]],["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","[19]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",null,"0$1"]],"0"],"ST":["239","[29]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"SV":["503","[267]\\d{7}|[89]\\d{6}(?:\\d{4})?",[["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"721"],"SY":["963","[1-59]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0","0$1",null,null,true],"SZ":["268","[027]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2",["[027]"]]]],"TA":["290","8\\d{3}",[],null,null,null,null,null,null,["8\\d{3}"]],"TC":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"649"],"TD":["235","[2679]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"TG":["228","[279]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","1\\d{8,9}|[2-9]\\d{7,8}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([13-9]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["14|[3-9]"]],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0","1[89]00"],"$1"]],"0","0$1"],"TJ":["992","[3-57-9]\\d{8}",[["([349]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["([457-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[148]|[578]|9(?:[0235-9]|1[59])"]],["(331700)(\\d)(\\d{2})","$1 $2 $3",["331","3317","33170","331700"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]","3(?:[1245]|3(?:[02-9]|1[0-589]))"]]],"8",null,null,null,true],"TK":["690","[2-47]\\d{3,6}"],"TL":["670","[2-489]\\d{6}|7\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7[3-8]"]]]],"TM":["993","[1-6]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"]],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["13|[2-5]"]]],"8","(8 $1)"],"TN":["216","[2-57-9]\\d{7}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3"]]],"TO":["676","[02-8]\\d{4,6}",[["(\\d{2})(\\d{3})","$1-$2",["[1-6]|7[0-4]|8[05]"]],["(\\d{3})(\\d{4})","$1 $2",["7[5-9]|8[47-9]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]]]],"TR":["90","[2-589]\\d{9}|444\\d{4}",[["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4(?:[0-35-9]|4[0-35-9])"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[02-69]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["51|[89]"],"0$1"],["(444)(\\d{1})(\\d{3})","$1 $2 $3",["444"]]],"0",null,null,null,true],"TT":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"868"],"TV":["688","[279]\\d{4,6}"],"TW":["886","2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}",[["(20)(\\d)(\\d{4})","$1 $2 $3",["202"]],["([258]0)(\\d{3})(\\d{4})","$1 $2 $3",["20[013-9]|50[0-46-9]|80[0-79]"]],["([2-8])(\\d{3,4})(\\d{4})","$1 $2 $3",["[25][2-8]|[346]|[78][1-9]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]],["(70)(\\d{4})(\\d{4})","$1 $2 $3",["70"]]],"0","0$1"],"TZ":["255","\\d{9}",[["([24]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[24]"]],["([67]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"]],["([89]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"]]],"0","0$1"],"UA":["380","[3-9]\\d{8}",[["([3-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]","[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"]],["([3-689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90","3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"]],["([3-6]\\d{3})(\\d{5})","$1 $2",["3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])","3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"]]],"0","0$1"],"UG":["256","\\d{9}",[["(\\d{3})(\\d{6})","$1 $2",["20[0-8]|4(?:6[45]|[7-9])|[7-9]","20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"]],["(\\d{2})(\\d{7})","$1 $2",["3|4(?:[1-5]|6[0-36-9])"]],["(2024)(\\d{5})","$1 $2",["202","2024"]]],"0","0$1"],"US":["1","[2-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,true,null,["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",null,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}","900[2-9]\\d{6}","5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}"]],"UY":["598","[2489]\\d{6,7}",[["(\\d{4})(\\d{4})","$1 $2",["[24]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9[1-9]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["[89]0"],"0$1"]],"0"],"UZ":["998","[679]\\d{8}",[["([679]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[679]"]]],"8","8 $1"],"VA":["39","(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))",[["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\d{4,6})","$1 $2",["0[26]"]],["(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,["06698\\d{5}","3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","80(?:0\\d{6}|3\\d{3})","0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","1(?:78\\d|99)\\d{6}",null,null,null,"55\\d{8}","84(?:[08]\\d{6}|[17]\\d{3})"]],"VC":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"784"],"VE":["58","[24589]\\d{9}",[["(\\d{3})(\\d{7})","$1-$2"]],"0","0$1"],"VG":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"284"],"VI":["1","[3589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"340"],"VN":["84","1\\d{6,9}|2\\d{9}|6\\d{6,7}|7\\d{6}|8\\d{6,8}|9\\d{8}",[["([17]99)(\\d{4})","$1 $2",["[17]99"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"]],["(80)(\\d{5})","$1 $2",["80"]],["(69\\d)(\\d{4,5})","$1 $2",["69"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2[0-35-79]"]],["([89]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8(?:8|9[89])|9"]],["(1[2689]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[26]|8[68]|99)"]],["(86[89])(\\d{3})(\\d{3})","$1 $2 $3",["86[89]"]],["(1[89]00)(\\d{4,6})","$1 $2",["1[89]0","1[89]00"],"$1"]],"0","0$1",null,null,true],"VU":["678","[2-57-9]\\d{4,6}",[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","[4-8]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]]],"WS":["685","[2-8]\\d{4,6}",[["(8\\d{2})(\\d{3,4})","$1 $2",["8"]],["(7\\d)(\\d{5})","$1 $2",["7"]],["(\\d{5})","$1",["[2-6]"]]]],"YE":["967","[1-7]\\d{6,8}",[["([1-7])(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"]],["(7\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7[0137]"]]],"0","0$1"],"YT":["262","[268]\\d{8}",[["([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[268]"]]],"0",null,null,null,null,"269|63"],"ZA":["27","[1-79]\\d{8}|8\\d{4,8}",[["(860)(\\d{3})(\\d{3})","$1 $2 $3",["860"]],["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-79]|8(?:[0-57]|6[1-9])"]]],"0","0$1"],"ZM":["260","[289]\\d{8}",[["(\\d{2})(\\d{4})","$1 $2",null,"$1"],["([1-8])(\\d{2})(\\d{4})","$1 $2 $3",["[1-8]"],"$1"],["([29]\\d)(\\d{7})","$1 $2",["[29]"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]]],"0","0$1"],"ZW":["263","2(?:[0-57-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-69]\\d{4,9}|7\\d{8}|8[06]\\d{5,8}",[["([49])(\\d{3})(\\d{2,4})","$1 $2 $3",["4|9[2-9]"]],["(7\\d)(\\d{3})(\\d{4})","$1 $2 $3",["7"]],["(86\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["86[24]"]],["([2356]\\d{2})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"]],["([1-356]\\d)(\\d{3,5})","$1 $2",["1[3-9]|2[02569]|3[0-69]|5[05689]|6"]],["([235]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[23]9|54"]],["([25]\\d{3})(\\d{3,5})","$1 $2",["(?:25|54)8","258[23]|5483"]],["(8\\d{3})(\\d{6})","$1 $2",["86"]],["(80\\d)(\\d{4})","$1 $2",["80"]]],"0","0$1"],"001":["979","\\d{9}",[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3"]]]}}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = is_valid;
	
	var _parse = __webpack_require__(121);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _types = __webpack_require__(239);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _metadata = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Checks if a given phone number is valid
	//
	// Example use cases:
	//
	// ```js
	// is_valid('8005553535', 'RU')
	// is_valid('8005553535', 'RU', metadata)
	// is_valid({ phone: '8005553535', country: 'RU' })
	// is_valid({ phone: '8005553535', country: 'RU' }, metadata)
	// is_valid('+78005553535')
	// is_valid('+78005553535', metadata)
	// ```
	//
	function is_valid(arg_1, arg_2, arg_3) {
		var _sort_out_arguments = (0, _types.sort_out_arguments)(arg_1, arg_2, arg_3),
		    input = _sort_out_arguments.input,
		    metadata = _sort_out_arguments.metadata;
	
		if (!input) {
			return false;
		}
	
		if (!input.country) {
			return false;
		}
	
		var country_metadata = metadata.countries[input.country];
	
		if ((0, _metadata.get_types)(country_metadata)) {
			if (!(0, _types2.default)(input, metadata)) {
				return false;
			}
		}
	
		return true;
	}
	//# sourceMappingURL=validate.js.map

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = {}
	
	exports.parse             = __webpack_require__(121).default
	exports.DIGITS            = __webpack_require__(121).DIGIT_MAPPINGS
	exports.format            = __webpack_require__(238).default
	exports.getNumberType     = __webpack_require__(239).default
	exports.isValidNumber     = __webpack_require__(797).default
	exports.AsYouType         = __webpack_require__(334).default
	exports.DIGIT_PLACEHOLDER = __webpack_require__(334).DIGIT_PLACEHOLDER
	
	// `get_number_type` name is deprecated
	exports.get_number_type = exports.getNumberType
	// `is_valid_number` name is deprecated
	exports.is_valid_number = exports.isValidNumber
	// `as_you_type` name is deprecated
	exports.as_you_type = exports.AsYouType
	// `asYouType` name is deprecated
	exports.asYouType = exports.AsYouType
	
	var get_phone_code = __webpack_require__(120).get_phone_code
	
	exports.getPhoneCode = function(country, metadata)
	{
		if (!metadata.countries[country])
		{
			throw new Error('Unknown country: "' + country + '"')
		}
	
		return get_phone_code(metadata.countries[country])
	}
	
	// exports['default'] = ...

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var custom   = __webpack_require__(798)
	var metadata = __webpack_require__(796)
	
	exports = module.exports = {}
	
	exports.parse = function parse()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parse.apply(this, parameters)
	}
	
	exports.format = function format()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.format.apply(this, parameters)
	}
	
	exports.getNumberType = function getNumberType()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.getNumberType.apply(this, parameters)
	}
	
	exports.isValidNumber = function isValidNumber()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.isValidNumber.apply(this, parameters)
	}
	
	exports.AsYouType = function AsYouType(country)
	{
		custom.AsYouType.call(this, country, metadata)
	}
	
	exports.AsYouType.prototype = Object.create(custom.AsYouType.prototype, {})
	exports.AsYouType.prototype.constructor = exports.AsYouType
	
	exports.DIGIT_PLACEHOLDER = custom.DIGIT_PLACEHOLDER
	exports.DIGITS            = custom.DIGITS
	
	// camelCase aliases
	// `get_number_type` name is deprecated
	exports.get_number_type = exports.getNumberType
	// `is_valid_number` name is deprecated
	exports.is_valid_number = exports.isValidNumber
	// `as_you_type` name is deprecated
	exports.as_you_type = exports.AsYouType
	// `asYouType` name is deprecated
	exports.asYouType = exports.AsYouType
	
	exports.getPhoneCode = function(country)
	{
		return custom.getPhoneCode(country, metadata)
	}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(272);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 337,
		"./af.js": 337,
		"./ar": 344,
		"./ar-dz": 338,
		"./ar-dz.js": 338,
		"./ar-kw": 339,
		"./ar-kw.js": 339,
		"./ar-ly": 340,
		"./ar-ly.js": 340,
		"./ar-ma": 341,
		"./ar-ma.js": 341,
		"./ar-sa": 342,
		"./ar-sa.js": 342,
		"./ar-tn": 343,
		"./ar-tn.js": 343,
		"./ar.js": 344,
		"./az": 345,
		"./az.js": 345,
		"./be": 346,
		"./be.js": 346,
		"./bg": 347,
		"./bg.js": 347,
		"./bm": 348,
		"./bm.js": 348,
		"./bn": 349,
		"./bn.js": 349,
		"./bo": 350,
		"./bo.js": 350,
		"./br": 351,
		"./br.js": 351,
		"./bs": 352,
		"./bs.js": 352,
		"./ca": 353,
		"./ca.js": 353,
		"./cs": 354,
		"./cs.js": 354,
		"./cv": 355,
		"./cv.js": 355,
		"./cy": 356,
		"./cy.js": 356,
		"./da": 357,
		"./da.js": 357,
		"./de": 360,
		"./de-at": 358,
		"./de-at.js": 358,
		"./de-ch": 359,
		"./de-ch.js": 359,
		"./de.js": 360,
		"./dv": 361,
		"./dv.js": 361,
		"./el": 362,
		"./el.js": 362,
		"./en-SG": 363,
		"./en-SG.js": 363,
		"./en-au": 364,
		"./en-au.js": 364,
		"./en-ca": 365,
		"./en-ca.js": 365,
		"./en-gb": 366,
		"./en-gb.js": 366,
		"./en-ie": 367,
		"./en-ie.js": 367,
		"./en-il": 368,
		"./en-il.js": 368,
		"./en-nz": 369,
		"./en-nz.js": 369,
		"./eo": 370,
		"./eo.js": 370,
		"./es": 373,
		"./es-do": 371,
		"./es-do.js": 371,
		"./es-us": 372,
		"./es-us.js": 372,
		"./es.js": 373,
		"./et": 374,
		"./et.js": 374,
		"./eu": 375,
		"./eu.js": 375,
		"./fa": 376,
		"./fa.js": 376,
		"./fi": 377,
		"./fi.js": 377,
		"./fo": 378,
		"./fo.js": 378,
		"./fr": 240,
		"./fr-ca": 379,
		"./fr-ca.js": 379,
		"./fr-ch": 380,
		"./fr-ch.js": 380,
		"./fr.js": 240,
		"./fy": 381,
		"./fy.js": 381,
		"./ga": 382,
		"./ga.js": 382,
		"./gd": 383,
		"./gd.js": 383,
		"./gl": 384,
		"./gl.js": 384,
		"./gom-latn": 385,
		"./gom-latn.js": 385,
		"./gu": 386,
		"./gu.js": 386,
		"./he": 387,
		"./he.js": 387,
		"./hi": 388,
		"./hi.js": 388,
		"./hr": 389,
		"./hr.js": 389,
		"./hu": 390,
		"./hu.js": 390,
		"./hy-am": 391,
		"./hy-am.js": 391,
		"./id": 392,
		"./id.js": 392,
		"./is": 393,
		"./is.js": 393,
		"./it": 395,
		"./it-ch": 394,
		"./it-ch.js": 394,
		"./it.js": 395,
		"./ja": 396,
		"./ja.js": 396,
		"./jv": 397,
		"./jv.js": 397,
		"./ka": 398,
		"./ka.js": 398,
		"./kk": 399,
		"./kk.js": 399,
		"./km": 400,
		"./km.js": 400,
		"./kn": 401,
		"./kn.js": 401,
		"./ko": 402,
		"./ko.js": 402,
		"./ku": 403,
		"./ku.js": 403,
		"./ky": 404,
		"./ky.js": 404,
		"./lb": 405,
		"./lb.js": 405,
		"./lo": 406,
		"./lo.js": 406,
		"./lt": 407,
		"./lt.js": 407,
		"./lv": 408,
		"./lv.js": 408,
		"./me": 409,
		"./me.js": 409,
		"./mi": 410,
		"./mi.js": 410,
		"./mk": 411,
		"./mk.js": 411,
		"./ml": 412,
		"./ml.js": 412,
		"./mn": 413,
		"./mn.js": 413,
		"./mr": 414,
		"./mr.js": 414,
		"./ms": 416,
		"./ms-my": 415,
		"./ms-my.js": 415,
		"./ms.js": 416,
		"./mt": 417,
		"./mt.js": 417,
		"./my": 418,
		"./my.js": 418,
		"./nb": 419,
		"./nb.js": 419,
		"./ne": 420,
		"./ne.js": 420,
		"./nl": 422,
		"./nl-be": 421,
		"./nl-be.js": 421,
		"./nl.js": 422,
		"./nn": 423,
		"./nn.js": 423,
		"./pa-in": 424,
		"./pa-in.js": 424,
		"./pl": 425,
		"./pl.js": 425,
		"./pt": 427,
		"./pt-br": 426,
		"./pt-br.js": 426,
		"./pt.js": 427,
		"./ro": 428,
		"./ro.js": 428,
		"./ru": 429,
		"./ru.js": 429,
		"./sd": 430,
		"./sd.js": 430,
		"./se": 431,
		"./se.js": 431,
		"./si": 432,
		"./si.js": 432,
		"./sk": 433,
		"./sk.js": 433,
		"./sl": 434,
		"./sl.js": 434,
		"./sq": 435,
		"./sq.js": 435,
		"./sr": 437,
		"./sr-cyrl": 436,
		"./sr-cyrl.js": 436,
		"./sr.js": 437,
		"./ss": 438,
		"./ss.js": 438,
		"./sv": 439,
		"./sv.js": 439,
		"./sw": 440,
		"./sw.js": 440,
		"./ta": 441,
		"./ta.js": 441,
		"./te": 442,
		"./te.js": 442,
		"./tet": 443,
		"./tet.js": 443,
		"./tg": 444,
		"./tg.js": 444,
		"./th": 445,
		"./th.js": 445,
		"./tl-ph": 446,
		"./tl-ph.js": 446,
		"./tlh": 447,
		"./tlh.js": 447,
		"./tr": 448,
		"./tr.js": 448,
		"./tzl": 449,
		"./tzl.js": 449,
		"./tzm": 451,
		"./tzm-latn": 450,
		"./tzm-latn.js": 450,
		"./tzm.js": 451,
		"./ug-cn": 452,
		"./ug-cn.js": 452,
		"./uk": 453,
		"./uk.js": 453,
		"./ur": 454,
		"./ur.js": 454,
		"./uz": 456,
		"./uz-latn": 455,
		"./uz-latn.js": 455,
		"./uz.js": 456,
		"./vi": 457,
		"./vi.js": 457,
		"./x-pseudo": 458,
		"./x-pseudo.js": 458,
		"./yo": 459,
		"./yo.js": 459,
		"./zh-cn": 460,
		"./zh-cn.js": 460,
		"./zh-hk": 461,
		"./zh-hk.js": 461,
		"./zh-tw": 462,
		"./zh-tw.js": 462
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 801;


/***/ }),
/* 802 */,
/* 803 */,
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _domHelpersStyle = __webpack_require__(1804);
	
	var _domHelpersStyle2 = _interopRequireDefault(_domHelpersStyle);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOverlaysLibTransition = __webpack_require__(1213);
	
	var _reactOverlaysLibTransition2 = _interopRequireDefault(_reactOverlaysLibTransition);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(807);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var capitalize = function capitalize(str) {
	  return str[0].toUpperCase() + str.substr(1);
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	var triggerBrowserReflow = function triggerBrowserReflow(node) {
	  return node.offsetHeight;
	};
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + capitalize(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt(_domHelpersStyle2['default'](elem, margins[0]), 10) + parseInt(_domHelpersStyle2['default'](elem, margins[1]), 10);
	}
	
	var Collapse = (function (_React$Component) {
	  _inherits(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    _classCallCheck(this, Collapse);
	
	    _React$Component.call(this, props, context);
	
	    this.onEnterListener = this.handleEnter.bind(this);
	    this.onEnteringListener = this.handleEntering.bind(this);
	    this.onEnteredListener = this.handleEntered.bind(this);
	    this.onExitListener = this.handleExit.bind(this);
	    this.onExitingListener = this.handleExiting.bind(this);
	  }
	
	  // Explicitly copied from Transition for doc generation.
	  // TODO: Remove duplication once #977 is resolved.
	
	  Collapse.prototype.render = function render() {
	    var enter = _utilsCreateChainedFunction2['default'](this.onEnterListener, this.props.onEnter);
	    var entering = _utilsCreateChainedFunction2['default'](this.onEnteringListener, this.props.onEntering);
	    var entered = _utilsCreateChainedFunction2['default'](this.onEnteredListener, this.props.onEntered);
	    var exit = _utilsCreateChainedFunction2['default'](this.onExitListener, this.props.onExit);
	    var exiting = _utilsCreateChainedFunction2['default'](this.onExitingListener, this.props.onExiting);
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibTransition2['default'],
	      _extends({
	        ref: 'transition'
	      }, this.props, {
	        'aria-expanded': this.props.role ? this.props['in'] : null,
	        className: _classnames2['default'](this.props.className, { width: this._dimension() === 'width' }),
	        exitedClassName: 'collapse',
	        exitingClassName: 'collapsing',
	        enteredClassName: 'collapse in',
	        enteringClassName: 'collapsing',
	        onEnter: enter,
	        onEntering: entering,
	        onEntered: entered,
	        onExit: exit,
	        onExiting: exiting,
	        onExited: this.props.onExited
	      }),
	      this.props.children
	    );
	  };
	
	  /* -- Expanding -- */
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	
	    triggerBrowserReflow(elem);
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	  Collapse.prototype._getTransitionInstance = function _getTransitionInstance() {
	    return this.refs.transition;
	  };
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + capitalize(dimension)] + 'px';
	  };
	
	  return Collapse;
	})(_react2['default'].Component);
	
	Collapse.propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * duration
	   * @private
	   */
	  duration: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.number, 'Use `timeout`.'),
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['height', 'width']), _react2['default'].PropTypes.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	Collapse.defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(806);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = deprecated;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var warned = {};
	
	function deprecated(propType, explanation) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] != null) {
	      var message = '"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation;
	      if (!warned[message]) {
	        _warning2['default'](false, message);
	        warned[message] = true;
	      }
	    }
	
	    return propType(props, propName, componentName);
	  };
	}
	
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	module.exports = exports['default'];

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(2078)
	  , defined = __webpack_require__(918);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(39);
	
	var findDOMNode = __webpack_require__(248);
	var focusNode = __webpack_require__(497);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(77);
	var EventPropagators = __webpack_require__(142);
	var ExecutionEnvironment = __webpack_require__(36);
	var FallbackCompositionState = __webpack_require__(820);
	var SyntheticCompositionEvent = __webpack_require__(847);
	var SyntheticInputEvent = __webpack_require__(850);
	
	var keyOf = __webpack_require__(85);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(467);
	var ExecutionEnvironment = __webpack_require__(36);
	var ReactPerf = __webpack_require__(64);
	
	var camelizeStyleName = __webpack_require__(862);
	var dangerousStyleValue = __webpack_require__(855);
	var hyphenateStyleName = __webpack_require__(867);
	var memoizeStringOnly = __webpack_require__(871);
	var warning = __webpack_require__(23);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(77);
	var EventPluginHub = __webpack_require__(141);
	var EventPropagators = __webpack_require__(142);
	var ExecutionEnvironment = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(55);
	var SyntheticEvent = __webpack_require__(106);
	
	var getEventTarget = __webpack_require__(251);
	var isEventSupported = __webpack_require__(253);
	var isTextInputElement = __webpack_require__(494);
	var keyOf = __webpack_require__(85);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var createNodesFromMarkup = __webpack_require__(864);
	var emptyFunction = __webpack_require__(65);
	var getMarkupWrap = __webpack_require__(499);
	var invariant = __webpack_require__(14);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(85);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(77);
	var EventPropagators = __webpack_require__(142);
	var SyntheticMouseEvent = __webpack_require__(178);
	
	var ReactMount = __webpack_require__(39);
	var keyOf = __webpack_require__(85);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(77);
	var ReactErrorUtils = __webpack_require__(482);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(79);
	
	var assign = __webpack_require__(22);
	var getTextContentAccessor = __webpack_require__(493);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(122);
	var ExecutionEnvironment = __webpack_require__(36);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(143);
	
	var findDOMNode = __webpack_require__(248);
	var warning = __webpack_require__(23);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(105);
	
	var instantiateReactComponent = __webpack_require__(190);
	var shouldUpdateReactComponent = __webpack_require__(255);
	var traverseAllChildren = __webpack_require__(256);
	var warning = __webpack_require__(23);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(244);
	var ReactCurrentOwner = __webpack_require__(78);
	var ReactElement = __webpack_require__(41);
	var ReactInstanceMap = __webpack_require__(143);
	var ReactPerf = __webpack_require__(64);
	var ReactPropTypeLocations = __webpack_require__(177);
	var ReactPropTypeLocationNames = __webpack_require__(176);
	var ReactReconciler = __webpack_require__(105);
	var ReactUpdateQueue = __webpack_require__(246);
	
	var assign = __webpack_require__(22);
	var emptyObject = __webpack_require__(145);
	var invariant = __webpack_require__(14);
	var shouldUpdateReactComponent = __webpack_require__(255);
	var warning = __webpack_require__(23);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(811);
	var CSSPropertyOperations = __webpack_require__(813);
	var DOMProperty = __webpack_require__(122);
	var DOMPropertyOperations = __webpack_require__(241);
	var EventConstants = __webpack_require__(77);
	var ReactBrowserEventEmitter = __webpack_require__(175);
	var ReactComponentBrowserEnvironment = __webpack_require__(243);
	var ReactDOMButton = __webpack_require__(825);
	var ReactDOMInput = __webpack_require__(828);
	var ReactDOMOption = __webpack_require__(829);
	var ReactDOMSelect = __webpack_require__(476);
	var ReactDOMTextarea = __webpack_require__(832);
	var ReactMount = __webpack_require__(39);
	var ReactMultiChild = __webpack_require__(528);
	var ReactPerf = __webpack_require__(64);
	var ReactUpdateQueue = __webpack_require__(246);
	
	var assign = __webpack_require__(22);
	var canDefineProperty = __webpack_require__(179);
	var escapeTextContentForBrowser = __webpack_require__(180);
	var invariant = __webpack_require__(14);
	var isEventSupported = __webpack_require__(253);
	var keyOf = __webpack_require__(85);
	var setInnerHTML = __webpack_require__(181);
	var setTextContent = __webpack_require__(254);
	var shallowEqual = __webpack_require__(500);
	var validateDOMNesting = __webpack_require__(257);
	var warning = __webpack_require__(23);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(41);
	var ReactElementValidator = __webpack_require__(479);
	
	var mapObject = __webpack_require__(870);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(245);
	var LinkedValueUtils = __webpack_require__(242);
	var ReactMount = __webpack_require__(39);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(22);
	var invariant = __webpack_require__(14);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(471);
	var ReactDOMSelect = __webpack_require__(476);
	
	var assign = __webpack_require__(22);
	var warning = __webpack_require__(23);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var getNodeForCharacterOffset = __webpack_require__(858);
	var getTextContentAccessor = __webpack_require__(493);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(478);
	var ReactServerRendering = __webpack_require__(840);
	var ReactVersion = __webpack_require__(247);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(242);
	var ReactDOMIDOperations = __webpack_require__(245);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(22);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(23);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(141);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(495);
	var ExecutionEnvironment = __webpack_require__(36);
	var PooledClass = __webpack_require__(79);
	var ReactInstanceHandles = __webpack_require__(109);
	var ReactMount = __webpack_require__(39);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(22);
	var getEventTarget = __webpack_require__(251);
	var getUnboundedScrollPosition = __webpack_require__(865);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(471);
	var ReactComponent = __webpack_require__(473);
	var ReactClass = __webpack_require__(472);
	var ReactDOMFactories = __webpack_require__(827);
	var ReactElement = __webpack_require__(41);
	var ReactElementValidator = __webpack_require__(479);
	var ReactPropTypes = __webpack_require__(488);
	var ReactVersion = __webpack_require__(247);
	
	var assign = __webpack_require__(22);
	var onlyChild = __webpack_require__(541);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(189);
	var PooledClass = __webpack_require__(79);
	var ReactBrowserEventEmitter = __webpack_require__(175);
	var ReactDOMFeatureFlags = __webpack_require__(475);
	var ReactInputSelection = __webpack_require__(483);
	var Transaction = __webpack_require__(147);
	
	var assign = __webpack_require__(22);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(836);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(264);
	var ReactElement = __webpack_require__(41);
	var ReactInstanceHandles = __webpack_require__(109);
	var ReactMarkupChecksum = __webpack_require__(484);
	var ReactServerBatchingStrategy = __webpack_require__(839);
	var ReactServerRenderingTransaction = __webpack_require__(841);
	var ReactUpdates = __webpack_require__(55);
	
	var emptyObject = __webpack_require__(145);
	var instantiateReactComponent = __webpack_require__(190);
	var invariant = __webpack_require__(14);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(79);
	var CallbackQueue = __webpack_require__(189);
	var Transaction = __webpack_require__(147);
	
	var assign = __webpack_require__(22);
	var emptyFunction = __webpack_require__(65);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(122);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(77);
	var EventPropagators = __webpack_require__(142);
	var ExecutionEnvironment = __webpack_require__(36);
	var ReactInputSelection = __webpack_require__(483);
	var SyntheticEvent = __webpack_require__(106);
	
	var getActiveElement = __webpack_require__(498);
	var isTextInputElement = __webpack_require__(494);
	var keyOf = __webpack_require__(85);
	var shallowEqual = __webpack_require__(500);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(77);
	var EventListener = __webpack_require__(495);
	var EventPropagators = __webpack_require__(142);
	var ReactMount = __webpack_require__(39);
	var SyntheticClipboardEvent = __webpack_require__(846);
	var SyntheticEvent = __webpack_require__(106);
	var SyntheticFocusEvent = __webpack_require__(849);
	var SyntheticKeyboardEvent = __webpack_require__(851);
	var SyntheticMouseEvent = __webpack_require__(178);
	var SyntheticDragEvent = __webpack_require__(848);
	var SyntheticTouchEvent = __webpack_require__(852);
	var SyntheticUIEvent = __webpack_require__(144);
	var SyntheticWheelEvent = __webpack_require__(853);
	
	var emptyFunction = __webpack_require__(65);
	var getEventCharCode = __webpack_require__(249);
	var invariant = __webpack_require__(14);
	var keyOf = __webpack_require__(85);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(106);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(106);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(178);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(144);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(106);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(144);
	
	var getEventCharCode = __webpack_require__(249);
	var getEventKey = __webpack_require__(857);
	var getEventModifierState = __webpack_require__(250);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(144);
	
	var getEventModifierState = __webpack_require__(250);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(178);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(467);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(22);
	var warning = __webpack_require__(23);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(249);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(180);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(39);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(861);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(872);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	var createArrayFromMixed = __webpack_require__(863);
	var getMarkupWrap = __webpack_require__(499);
	var invariant = __webpack_require__(14);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(866);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(868);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(107);


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(502);
	
	/*<replacement>*/
	var util = __webpack_require__(138);
	util.inherits = __webpack_require__(89);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(183).Buffer;
	var util = __webpack_require__(887);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(259).PassThrough


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(259).Transform


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(258);


/***/ }),
/* 879 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(90)))

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(237).EventEmitter;
	var inherits = __webpack_require__(89);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(259);
	Stream.Writable = __webpack_require__(878);
	Stream.Duplex = __webpack_require__(873);
	Stream.Transform = __webpack_require__(877);
	Stream.PassThrough = __webpack_require__(876);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(880);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function agencyFilter(agencies) {
	    return function (agency) {
	        return agencies.find(function (a) {
	            return a.uid == agency.uid;
	        }) != null;
	    };
	}
	
	var AgencySelectInput = function (_Component) {
	    _inherits(AgencySelectInput, _Component);
	
	    function AgencySelectInput(props) {
	        _classCallCheck(this, AgencySelectInput);
	
	        var _this = _possibleConstructorReturn(this, (AgencySelectInput.__proto__ || Object.getPrototypeOf(AgencySelectInput)).call(this, props));
	
	        _this.state = {
	            agencies: []
	        };
	        return _this;
	    }
	
	    _createClass(AgencySelectInput, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user,
	                company = _props.company,
	                agency = _props.agency;
	
	
	            if (agency) {
	                this.setState({ agencies: [agency] });
	            } else if (company && company.companyType == 'ClientAccountHolding') {
	                dispatch((0, _actions.queryHoldingAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { holdingUid: company.uid, range: { offset: 0, limit: 99 } })));
	            } else if (company) {
	                dispatch((0, _actions.queryAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { companyUid: company.uid, range: { offset: 0, limit: 99 } })));
	            } else if (user && user.company && user.isPartOfHolding) {
	                dispatch((0, _actions.queryHoldingAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { holdingUid: user.company.uid, range: { offset: 0, limit: 99 } })));
	            } else if (user && user.company) {
	                dispatch((0, _actions.queryAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { companyUid: user.company.uid, range: { offset: 0, limit: 99 } })));
	            } else if (user) {
	                this.setState({ agencies: user.managedAgencies || [] });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.user != this.props.user || nextProps.company != this.props.company || nextProps.agency != this.props.agency) {
	                var _props2 = this.props,
	                    dispatch = _props2.dispatch,
	                    user = _props2.user,
	                    company = _props2.company,
	                    agency = _props2.agency;
	
	
	                if (agency) {
	                    this.setState({ agencies: [agency] });
	                } else if (company && company.companyType == 'ClientAccountHolding') {
	                    dispatch((0, _actions.queryHoldingAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { holdingUid: company.uid, range: { offset: 0, limit: 99 } })));
	                } else if (company) {
	                    dispatch((0, _actions.queryAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { companyUid: company.uid, range: { offset: 0, limit: 99 } })));
	                } else if (user && user.company && user.isPartOfHolding) {
	                    dispatch((0, _actions.queryHoldingAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { holdingUid: user.company.uid, range: { offset: 0, limit: 99 } })));
	                } else if (user && user.company) {
	                    dispatch((0, _actions.queryAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { companyUid: user.company.uid, range: { offset: 0, limit: 99 } })));
	                } else if (user) {
	                    this.setState({ agencies: user.managedAgencies || [] });
	                }
	            }
	
	            if (nextProps.stream != this.props.stream) {
	                var _user = nextProps.user,
	                    stream = nextProps.stream;
	
	                var agencies = _user && _user.managedAgencies && _user.managedAgencies.filter(agencyFilter(stream)) || stream;
	
	                this.setState({ agencies: agencies });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                children = _props3.children,
	                dispatch = _props3.dispatch,
	                stream = _props3.stream,
	                user = _props3.user,
	                company = _props3.company,
	                agency = _props3.agency,
	                disable = _props3.disable,
	                others = _objectWithoutProperties(_props3, ['children', 'dispatch', 'stream', 'user', 'company', 'agency', 'disable']);
	
	            var agencies = this.state.agencies;
	
	
	            return _react2.default.createElement(
	                _reactBootstrap.Input,
	                _extends({
	                    type: 'select'
	                }, others),
	                children,
	                agencies.map(function (agency, index) {
	                    return !disable(agency) && _react2.default.createElement(
	                        'option',
	                        {
	                            key: index,
	                            value: agency.uid },
	                        agency.label
	                    );
	                })
	            );
	        }
	    }]);
	
	    return AgencySelectInput;
	}(_react.Component);
	
	AgencySelectInput.propTypes = {
	    user: _react.PropTypes.object,
	    company: _react.PropTypes.object,
	    agency: _react.PropTypes.object,
	    disable: _react.PropTypes.func
	};
	AgencySelectInput.defaultProps = {
	    disable: function disable(v) {
	        return false;
	    }
	};
	
	
	AgencySelectInput = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.company.agency.stream
	    };
	})(AgencySelectInput);
	
	exports.default = AgencySelectInput;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _reactDayPicker = __webpack_require__(1224);
	
	var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);
	
	var _moment3 = __webpack_require__(1226);
	
	var _moment4 = _interopRequireDefault(_moment3);
	
	var _control = __webpack_require__(964);
	
	var _i18n = __webpack_require__(545);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DayRangePicker = __webpack_require__(2207);
	
	var _DayRangePicker2 = _interopRequireDefault(_DayRangePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DayRangePicker = function (_Component) {
	    _inherits(DayRangePicker, _Component);
	
	    function DayRangePicker(props) {
	        _classCallCheck(this, DayRangePicker);
	
	        var _this = _possibleConstructorReturn(this, (DayRangePicker.__proto__ || Object.getPrototypeOf(DayRangePicker)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(DayRangePicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                toInitial: this.props.value.to || new Date(),
	                fromInitial: this.props.value.from || new Date()
	            });
	        }
	    }, {
	        key: '_selectFrom',
	        value: function _selectFrom(day) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange;
	
	
	            if (_reactDayPicker.DateUtils.isSameDay(day, value.from)) {
	                var nextValue = _extends({}, value, { from: null });
	                onChange(nextValue);
	            } else {
	                var nextFrom = day;
	                var nextTo = value.to && (day < value.to && value.to || day);
	                var nextValue = { from: nextFrom, to: nextTo };
	                onChange(nextValue);
	            }
	        }
	    }, {
	        key: '_selectTo',
	        value: function _selectTo(day) {
	            var _props2 = this.props,
	                value = _props2.value,
	                onChange = _props2.onChange;
	
	
	            if (_reactDayPicker.DateUtils.isSameDay(day, value.to)) {
	                var nextValue = _extends({}, value, { to: null });
	                onChange(nextValue);
	            } else if (_reactDayPicker.DateUtils.isSameDay(day, value.from) || day > value.from || !value.from) {
	                var nextValue = _extends({}, value, { to: day });
	                onChange(nextValue);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                value = _props3.value,
	                onChange = _props3.onChange;
	            var _state = this.state,
	                fromInitial = _state.fromInitial,
	                toInitial = _state.toInitial;
	
	
	            var modifiers = {
	                from: function from(day) {
	                    return _reactDayPicker.DateUtils.isSameDay(day, value.from);
	                },
	                to: function to(day) {
	                    return _reactDayPicker.DateUtils.isSameDay(day, value.to);
	                },
	                range: function range(day) {
	                    if (value.from && value.to) return day > value.from && day < value.to;
	                    if (value.from) return day > value.from;
	                    if (value.to) return day < value.to;
	                    return false;
	                }
	            };
	
	            var fromModifiers = _extends({}, modifiers, {
	                disabled: function disabled(day) {
	                    return day > value.to;
	                }
	
	            });
	
	            var toModifiers = _extends({}, modifiers, {
	                disabled: function disabled(day) {
	                    return day < value.from;
	                }
	            });
	
	            var display = function display(day) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    day.getDate()
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _DayRangePicker2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _DayRangePicker2.default.container },
	                    _react2.default.createElement(_reactDayPicker2.default, {
	                        renderDay: display,
	                        modifiers: fromModifiers,
	                        initialMonth: fromInitial,
	                        onDayClick: function onDayClick(e, d) {
	                            return _this2._selectFrom(d);
	                        },
	                        localeUtils: _moment4.default,
	                        locale: _moment2.default.locale() })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _DayRangePicker2.default.container },
	                    _react2.default.createElement(_reactDayPicker2.default, {
	                        renderDay: display,
	                        modifiers: toModifiers,
	                        initialMonth: toInitial,
	                        onDayClick: function onDayClick(e, d) {
	                            return _this2._selectTo(d);
	                        },
	                        localeUtils: _moment4.default,
	                        locale: _moment2.default.locale() })
	                )
	            );
	        }
	    }]);
	
	    return DayRangePicker;
	}(_react.Component);
	
	DayRangePicker.propTypes = {
	    value: _react.PropTypes.object,
	    onChange: _react.PropTypes.func.isRequired
	};
	
	
	DayRangePicker = (0, _control.control)({
	    value: {}
	})(DayRangePicker);
	
	exports.default = DayRangePicker;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DownloadIcon = __webpack_require__(2208);
	
	var _DownloadIcon2 = _interopRequireDefault(_DownloadIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadIcon = function (_Component) {
	    _inherits(DownloadIcon, _Component);
	
	    function DownloadIcon() {
	        _classCallCheck(this, DownloadIcon);
	
	        return _possibleConstructorReturn(this, (DownloadIcon.__proto__ || Object.getPrototypeOf(DownloadIcon)).apply(this, arguments));
	    }
	
	    _createClass(DownloadIcon, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                progress = _props.progress,
	                other = _objectWithoutProperties(_props, ['progress']);
	
	            var percentage = function percentage(value) {
	                return value && value * 100 || 0;
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _DownloadIcon2.default.default },
	                progress > 0 && _react2.default.createElement('div', {
	                    className: _DownloadIcon2.default.progress,
	                    style: { minHeight: percentage(progress) + '%' } }),
	                _react2.default.createElement(_Icon2.default, { icon: 'download', size: 'sm' })
	            );
	        }
	    }]);
	
	    return DownloadIcon;
	}(_react.Component);
	
	DownloadIcon.propTypes = {
	    progress: _react.PropTypes.number
	};
	exports.default = DownloadIcon;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _PercentageDashboardPanel = __webpack_require__(2213);
	
	var _PercentageDashboardPanel2 = _interopRequireDefault(_PercentageDashboardPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function metricFilter(total, identify) {
	    return function (metric) {
	        // keep only metrics with percentage > 0
	        return Math.round(identify(metric) * 100 / total) > 0;
	    };
	}
	
	var PercentageDashboardPanel = function (_Component) {
	    _inherits(PercentageDashboardPanel, _Component);
	
	    function PercentageDashboardPanel(props) {
	        _classCallCheck(this, PercentageDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (PercentageDashboardPanel.__proto__ || Object.getPrototypeOf(PercentageDashboardPanel)).call(this, props));
	
	        _this.state = {
	            metrics: []
	        };
	        return _this;
	    }
	
	    _createClass(PercentageDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                identify = _props.identify,
	                value = _props.value,
	                total = _props.total;
	
	
	            var metricTotal = total || value.reduce(function (r, v) {
	                return r + identify(v);
	            }, 0);
	            var filteredMetrics = total && value || value.filter(metricFilter(metricTotal, identify));
	            var metrics = filteredMetrics.sort(function (a, b) {
	                return identify(b) - identify(a);
	            });
	            this.setState({ metricTotal: metricTotal, metrics: metrics });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.value != this.props.value || nextProps.total != this.props.total) {
	                var identify = nextProps.identify,
	                    value = nextProps.value,
	                    total = nextProps.total;
	
	
	                var metricTotal = total || value.reduce(function (r, v) {
	                    return r + identify(v);
	                }, 0);
	                var filteredMetrics = total && value || value.filter(metricFilter(metricTotal, identify));
	                var metrics = filteredMetrics.sort(function (a, b) {
	                    return identify(b) - identify(a);
	                });
	                this.setState({ metricTotal: metricTotal, metrics: metrics });
	            }
	        }
	    }, {
	        key: '_percentage',
	        value: function _percentage(metric) {
	            var identify = this.props.identify;
	            var metricTotal = this.state.metricTotal;
	
	            return Math.round(identify(metric) * 100 / metricTotal);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                display = _props2.display,
	                identify = _props2.identify,
	                filter = _props2.filter,
	                _onClick = _props2.onClick,
	                value = _props2.value,
	                total = _props2.total,
	                others = _objectWithoutProperties(_props2, ['display', 'identify', 'filter', 'onClick', 'value', 'total']);
	
	            var metrics = this.state.metrics;
	
	
	            var colorClass = function colorClass(index) {
	                return 'color' + ((index & 0x7) + 1); // bucket in the range 1-8
	            };
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                others,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _PercentageDashboardPanel2.default.metricGroup },
	                    metrics.map(function (metric, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            {
	                                key: index },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _PercentageDashboardPanel2.default.container },
	                                _onClick && _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        onClick: function onClick(e) {
	                                            return _onClick(e, metric);
	                                        } },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        display(metric)
	                                    ),
	                                    !total && _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' (',
	                                        identify(metric),
	                                        ')'
	                                    )
	                                ) || _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        display(metric)
	                                    ),
	                                    !total && _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' (',
	                                        identify(metric),
	                                        ')'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _PercentageDashboardPanel2.default.progress },
	                                _react2.default.createElement(
	                                    'div',
	                                    {
	                                        className: (0, _classnames2.default)(_PercentageDashboardPanel2.default.progressBar, _PercentageDashboardPanel2.default[colorClass(index)]),
	                                        style: { width: _this2._percentage(metric) + '%' } },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _this2._percentage(metric),
	                                        ' %'
	                                    )
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PercentageDashboardPanel;
	}(_react.Component);
	
	PercentageDashboardPanel.propTypes = {
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    total: _react.PropTypes.number,
	    onClick: _react.PropTypes.func,
	    value: _react.PropTypes.array
	};
	PercentageDashboardPanel.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    },
	    value: []
	};
	exports.default = PercentageDashboardPanel;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _control = __webpack_require__(964);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tags = __webpack_require__(2224);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tags = function (_Component) {
	    _inherits(Tags, _Component);
	
	    function Tags() {
	        _classCallCheck(this, Tags);
	
	        return _possibleConstructorReturn(this, (Tags.__proto__ || Object.getPrototypeOf(Tags)).apply(this, arguments));
	    }
	
	    _createClass(Tags, [{
	        key: '_remove',
	        value: function _remove(tag) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange;
	
	            var index = value.indexOf(tag);
	
	            if (index >= 0) {
	                var nextValue = [].concat(_toConsumableArray(value));
	                nextValue.splice(index, 1);
	                onChange(nextValue);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                display = _props2.display,
	                active = _props2.active,
	                label = _props2.label,
	                labelClassName = _props2.labelClassName,
	                wrapperClassName = _props2.wrapperClassName,
	                value = _props2.value,
	                onChange = _props2.onChange,
	                other = _objectWithoutProperties(_props2, ['display', 'active', 'label', 'labelClassName', 'wrapperClassName', 'value', 'onChange']);
	
	            return _react2.default.createElement(
	                'div',
	                { className: _Tags2.default.default },
	                label && value.length > 0 && _react2.default.createElement(
	                    'label',
	                    { className: labelClassName },
	                    label
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: wrapperClassName },
	                    value.map(function (tag) {
	                        return _react2.default.createElement(
	                            'li',
	                            {
	                                key: display(tag),
	                                className: (0, _classnames2.default)(_defineProperty({}, _Tags2.default.active, active(tag))),
	                                onClick: function onClick() {
	                                    return _this2._remove(tag);
	                                } },
	                            _react2.default.createElement(
	                                'a',
	                                null,
	                                _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' }),
	                                display(tag)
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Tags;
	}(_react.Component);
	
	Tags.propTypes = {
	    display: _react.PropTypes.func,
	    active: _react.PropTypes.func,
	    label: _react.PropTypes.string,
	    labelClassName: _react.PropTypes.string,
	    wrapperClassName: _react.PropTypes.string,
	    value: _react.PropTypes.array.isRequired,
	    onChange: _react.PropTypes.func.isRequired
	};
	Tags.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    active: function active(v) {
	        return true;
	    }
	};
	
	
	Tags = (0, _control.control)({
	    value: []
	})(Tags);
	
	exports.default = Tags;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.matcher = matcher;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TypeaheadGridInput = __webpack_require__(2229);
	
	var _TypeaheadGridInput2 = _interopRequireDefault(_TypeaheadGridInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function escapeRegExp(value) {
	    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	function matcher(_ref) {
	    var source = _ref.source,
	        _ref$identify = _ref.identify,
	        identify = _ref$identify === undefined ? function (v) {
	        return v;
	    } : _ref$identify;
	
	    return function (q, cb) {
	        var matches;
	
	        if (q) {
	            var regexp = new RegExp(escapeRegExp(q), 'i');
	            matches = source.filter(function (value) {
	                return regexp.test(identify(value));
	            });
	        } else {
	            matches = source;
	        }
	
	        cb(matches);
	    };
	}
	
	function matchesFilter(value, identify, multi) {
	    return function (item) {
	        if (multi) {
	            return !(value && value.find(function (v) {
	                return identify(v) == identify(item);
	            }));
	        } else {
	            return (value && identify(value)) != identify(item);
	        }
	    };
	}
	
	var TypeaheadGridInput = function (_Component) {
	    _inherits(TypeaheadGridInput, _Component);
	
	    function TypeaheadGridInput(props) {
	        _classCallCheck(this, TypeaheadGridInput);
	
	        var _this = _possibleConstructorReturn(this, (TypeaheadGridInput.__proto__ || Object.getPrototypeOf(TypeaheadGridInput)).call(this, props));
	
	        _this.state = {
	            matches: []
	        };
	        return _this;
	    }
	
	    _createClass(TypeaheadGridInput, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var _props = this.props,
	                source = _props.source,
	                value = _props.value,
	                identify = _props.identify,
	                multi = _props.multi;
	
	
	            source(null, function (matches) {
	                var filteredMatches = matches.filter(matchesFilter(value, identify, multi));
	                _this2.setState({ matches: filteredMatches });
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this3 = this;
	
	            if (nextProps.source != this.props.source) {
	                var source = nextProps.source,
	                    value = nextProps.value,
	                    identify = nextProps.identify,
	                    multi = nextProps.multi;
	
	                var query = null;
	
	                source(query, function (matches) {
	                    var filteredMatches = matches.filter(matchesFilter(value, identify, multi));
	                    _this3.setState({ query: query, matches: filteredMatches });
	                });
	            }
	        }
	    }, {
	        key: 'getQuery',
	        value: function getQuery() {
	            var query = this.state.query;
	
	            return query;
	        }
	    }, {
	        key: '_match',
	        value: function _match(event) {
	            var _this4 = this;
	
	            var _props2 = this.props,
	                source = _props2.source,
	                value = _props2.value,
	                identify = _props2.identify,
	                multi = _props2.multi;
	
	            var query = event.target.value || null;
	
	            source(query, function (matches) {
	                var filteredMatches = matches.filter(matchesFilter(value, identify, multi));
	                _this4.setState({ query: query, matches: filteredMatches });
	            });
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _this5 = this;
	
	            var _props3 = this.props,
	                source = _props3.source,
	                value = _props3.value,
	                identify = _props3.identify,
	                multi = _props3.multi;
	
	            var query = null;
	
	            event.preventDefault();
	
	            source(query, function (matches) {
	                var filteredMatches = matches.filter(matchesFilter(value, identify, multi));
	                _this5.setState({ query: query, matches: filteredMatches });
	            });
	        }
	    }, {
	        key: '_toggle',
	        value: function _toggle(item) {
	            var _props4 = this.props,
	                source = _props4.source,
	                value = _props4.value,
	                onChange = _props4.onChange,
	                onSubmit = _props4.onSubmit,
	                identify = _props4.identify,
	                multi = _props4.multi;
	
	
	            if (multi) {
	                var arrayValue = value || [];
	                var itemId = identify(item);
	                var index = arrayValue.findIndex(function (value) {
	                    return identify(value) == itemId;
	                });
	
	                if (index < 0) {
	                    if (onSubmit) {
	                        onSubmit('Add', item);
	                    }
	
	                    if (onChange) {
	                        var nextValue = [].concat(_toConsumableArray(arrayValue));
	                        nextValue.push(item);
	                        onChange(nextValue);
	                    }
	                } else {
	                    if (onSubmit) {
	                        onSubmit('Remove', item);
	                    }
	
	                    if (onChange) {
	                        var nextValue = [].concat(_toConsumableArray(arrayValue));
	                        nextValue.splice(index, 1);
	                        onChange(nextValue);
	                    }
	                }
	            } else {
	                if ((value && identify(value)) != identify(item)) {
	                    if (onSubmit) {
	                        onSubmit('Add', item);
	                    }
	
	                    if (onChange) {
	                        onChange(item);
	                    }
	                } else {
	                    if (onSubmit) {
	                        onSubmit('Remove', value);
	                    }
	
	                    if (onChange) {
	                        onChange(null);
	                    }
	                }
	            }
	        }
	    }, {
	        key: '_isActive',
	        value: function _isActive(item) {
	            var _props5 = this.props,
	                identify = _props5.identify,
	                value = _props5.value,
	                multi = _props5.multi;
	
	
	            if (multi) {
	                var itemId = identify(item);
	                return value && value.find(function (value) {
	                    return identify(value) == itemId;
	                }) != null || false;
	            } else {
	                return (value && identify(value)) == identify(item);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props6 = this.props,
	                source = _props6.source,
	                display = _props6.display,
	                identify = _props6.identify,
	                header = _props6.header,
	                disabled = _props6.disabled,
	                multi = _props6.multi,
	                size = _props6.size,
	                labelClassName = _props6.labelClassName,
	                wrapperClassName = _props6.wrapperClassName,
	                value = _props6.value,
	                onChange = _props6.onChange,
	                onSubmit = _props6.onSubmit,
	                other = _objectWithoutProperties(_props6, ['source', 'display', 'identify', 'header', 'disabled', 'multi', 'size', 'labelClassName', 'wrapperClassName', 'value', 'onChange', 'onSubmit']);
	
	            var _state = this.state,
	                query = _state.query,
	                matches = _state.matches;
	
	
	            var sizeClass = size && size.toLowerCase();
	
	            var inputButton = function inputButton() {
	                if (query) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            onClick: function onClick(e) {
	                                return _this6._clear(e);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	                    );
	                }
	            };
	
	            var inputAddon = function inputAddon() {
	                if (!query) {
	                    return _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' });
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_TypeaheadGridInput2.default.default, _TypeaheadGridInput2.default[sizeClass]) },
	                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                    type: 'text',
	                    labelClassName: labelClassName,
	                    wrapperClassName: wrapperClassName,
	                    buttonAfter: inputButton(),
	                    addonAfter: inputAddon(),
	                    disabled: disabled,
	                    value: query,
	                    onChange: function onChange(e) {
	                        return _this6._match(e);
	                    }
	                }, other)),
	                _react2.default.createElement(
	                    'div',
	                    { className: _TypeaheadGridInput2.default.formResult },
	                    _react2.default.createElement('div', { className: labelClassName }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: wrapperClassName },
	                        header,
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _TypeaheadGridInput2.default.result },
	                            matches.map(function (match) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: identify(match) },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'link',
	                                            active: _this6._isActive(match),
	                                            disabled: disabled,
	                                            onClick: function onClick() {
	                                                return _this6._toggle(match);
	                                            } },
	                                        display(match)
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TypeaheadGridInput;
	}(_react.Component);
	
	TypeaheadGridInput.propTypes = {
	    source: _react.PropTypes.func.isRequired,
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    header: _react.PropTypes.object,
	    disabled: _react.PropTypes.bool,
	    multi: _react.PropTypes.bool,
	    size: _react.PropTypes.string,
	    value: _react.PropTypes.any,
	    onChange: _react.PropTypes.func,
	    onSubmit: _react.PropTypes.func
	};
	TypeaheadGridInput.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    }
	};
	exports.default = TypeaheadGridInput;

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.appQueryParameters = appQueryParameters;
	exports.appUrl = appUrl;
	function appQueryParameters(location) {
	    var search = location.search.substring(1);
	    var chunks = search.split('&');
	
	    return chunks.reduce(function (result, chunk) {
	        var _chunk$split = chunk.split('='),
	            _chunk$split2 = _slicedToArray(_chunk$split, 2),
	            key = _chunk$split2[0],
	            value = _chunk$split2[1];
	
	        result[key] = decodeURIComponent(value);
	        return result;
	    }, {});
	}
	
	function appUrl(url, query) {
	    var queryArray = Object.keys(query).reduce(function (result, key) {
	        var value = query[key];
	
	        result.push(key.toLowerCase() + '=' + encodeURIComponent(value));
	        return result;
	    }, []);
	
	    var queryString = queryArray.length > 0 && '?' + queryArray.join('&') || '';
	    return url + queryString;
	}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.delayMiddleware = delayMiddleware;
	exports.default = delay;
	
	// middleware
	
	function delayMiddleware(_ref) {
	    var dispatch = _ref.dispatch;
	
	    return function (next) {
	        return function (action) {
	            if (action.delayed) {
	                return new Promise(function (resolve, reject) {
	                    setTimeout(function () {
	                        resolve(next(action.delayed));
	                    }, action.time);
	                });
	            }
	            return next(action);
	        };
	    };
	}
	
	// action
	
	function delay(delayed) {
	    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;
	
	    return { delayed: delayed, time: time };
	}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _loading = __webpack_require__(58);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(47);
	
	var _ContactCard = __webpack_require__(1414);
	
	var _ContactCard2 = _interopRequireDefault(_ContactCard);
	
	var _ContactStream = __webpack_require__(2270);
	
	var _ContactStream2 = _interopRequireDefault(_ContactStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var ContactStream = function (_Component) {
	    _inherits(ContactStream, _Component);
	
	    function ContactStream() {
	        _classCallCheck(this, ContactStream);
	
	        return _possibleConstructorReturn(this, (ContactStream.__proto__ || Object.getPrototypeOf(ContactStream)).apply(this, arguments));
	    }
	
	    _createClass(ContactStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadContactStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, contact) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/providercontacts/' + contact.uid);
	            } else {
	                dispatch((0, _reactRouterRedux.push)('/providercontacts/' + contact.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                loading = _props.loading,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (contact) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: contact.uid,
	                                sm: 6 },
	                            _react2.default.createElement(_ContactCard2.default, {
	                                contact: contact,
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, contact);
	                                } })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true,
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return ContactStream;
	}(_react.Component);
	
	ContactStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	ContactStream = (0, _loading.connectLoadingLock)()(ContactStream);
	
	ContactStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        stream: state.provider.contact.stream,
	        range: state.provider.contact.range
	    };
	})(ContactStream);
	
	exports.default = ContactStream;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _matcher = __webpack_require__(958);
	
	var _matcher2 = _interopRequireDefault(_matcher);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconCateg = __webpack_require__(530);
	
	var _IconCateg2 = _interopRequireDefault(_IconCateg);
	
	var _actions = __webpack_require__(113);
	
	var _models = __webpack_require__(269);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OpeningTicketPurposePicker = __webpack_require__(2300);
	
	var _OpeningTicketPurposePicker2 = _interopRequireDefault(_OpeningTicketPurposePicker);
	
	var _QualificationCriteriaAnswers = __webpack_require__(1514);
	
	var _QualificationCriteriaAnswers2 = _interopRequireDefault(_QualificationCriteriaAnswers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openingTicketPurposeFilter(categories, tags) {
	    return function (openingTicketPurpose) {
	        if (!openingTicketPurpose.enabled) return false;
	
	        for (var i = 0; i < tags.length; i++) {
	            if (!openingTicketPurpose.tags.find(function (t) {
	                return t.uid == tags[i].uid;
	            })) return false;
	        }
	        for (var i = 0; i < categories.length; i++) {
	            if (openingTicketPurpose.categories.find(function (c) {
	                return c.uid == categories[i].uid;
	            })) return true;
	        }
	        return categories.length == 0 && true || false;
	    };
	}
	
	function tagAggregator(reference, tags) {
	    return function (result, openingTicketPurpose) {
	        openingTicketPurpose.tags.forEach(function (tag) {
	            var aggrega = result.find(function (a) {
	                return a.tag.uid == tag.uid;
	            });
	            if (aggrega) {
	                aggrega.count++;
	                return;
	            }
	
	            var tagz = tags.find(function (t) {
	                return t.uid == tag.uid;
	            });
	            if (tagz) {
	                return;
	            }
	
	            tagz = reference.tags.find(function (t) {
	                return t.uid == tag.uid;
	            });
	            if (!tagz) {
	                console && console.warn('tag "' + tag.uid + '" doesn\'t exist in referentiel');
	                return;
	            }
	
	            aggrega = {
	                tag: tagz,
	                count: 1
	            };
	            result.push(aggrega);
	        });
	        return result;
	    };
	}
	
	function categoryAggregator(reference, parentCategory) {
	    return function (result, openingTicketPurpose) {
	        openingTicketPurpose.categories.forEach(function (category) {
	            var categoryz = reference.categories.find(function (c) {
	                return c.uid == category.uid;
	            });
	            if (!categoryz) {
	                console && console.warn('category "' + category.uid + '" doesn\'t exist in referentiel');
	                return;
	            }
	
	            var categoryPath = _models.OpeningTicketPurposeRef.expendParentCategories(reference, categoryz);
	            var ancestorCategory = _models.OpeningTicketPurposeRef.truncCategoryPath(categoryPath, parentCategory)[0];
	
	            if (!ancestorCategory) {
	                return;
	            }
	
	            var aggrega = result.find(function (a) {
	                return a.category.uid == ancestorCategory.uid;
	            });
	            if (aggrega) {
	                return;
	            }
	
	            aggrega = {
	                category: ancestorCategory
	            };
	
	            result.push(aggrega);
	        });
	        return result;
	    };
	}
	
	function defaultTagAggregation(reference, tags) {
	    var defaultTag = reference.default.tag;
	
	    if (!tags.find(function (t) {
	        return t.uid == defaultTag.uid;
	    })) {
	        return [{
	            tag: defaultTag,
	            count: 1000
	        }];
	    }
	    return [];
	}
	
	function defaultTagCriteria(reference, tags) {
	    var defaultTag = reference.default.tag;
	
	    if (tags.find(function (t) {
	        return t.uid == defaultTag.uid;
	    })) {
	        return {
	            tags: [defaultTag],
	            category: null
	        };
	    }
	    return { tags: tags };
	}
	
	function categoryOrTagMatcher(categoryOrTags) {
	    return (0, _matcher2.default)({
	        source: categoryOrTags,
	        identify: function identify(cot) {
	            return cot.label;
	        }
	    });
	}
	
	var deepGet = function deepGet(obj, path) {
	    if (!obj) return undefined;
	    var first = path[0];
	    if (path.length === 1) return obj[first];
	    return deepGet(obj[first], path.slice(1));
	};
	
	var OpeningTicketPurposePicker = function (_Component) {
	    _inherits(OpeningTicketPurposePicker, _Component);
	
	    function OpeningTicketPurposePicker(props) {
	        _classCallCheck(this, OpeningTicketPurposePicker);
	
	        var _this = _possibleConstructorReturn(this, (OpeningTicketPurposePicker.__proto__ || Object.getPrototypeOf(OpeningTicketPurposePicker)).call(this, props));
	
	        _this.state = {
	            criteria: {
	                tags: []
	            },
	            filteredOpeningTicketPurposes: [],
	            categoryMatches: [],
	            tagMatches: []
	        };
	        return _this;
	    }
	
	    _createClass(OpeningTicketPurposePicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company;
	
	            dispatch((0, _actions.queryOpeningTicketPurposeRef)(company.uid));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.company != this.props.company) {
	                var dispatch = nextProps.dispatch,
	                    company = nextProps.company;
	
	                dispatch((0, _actions.queryOpeningTicketPurposeRef)(company.uid));
	            }
	
	            if (this.props.reference != nextProps.reference) {
	                var reference = nextProps.reference;
	
	                var categoryUid = deepGet(nextProps, ['cmd', 'otp', 'criteria', 'categoryUid']) || { uid: undefined };
	                var resolveCategory = (reference.categories || []).find(function (c) {
	                    return c.uid === categoryUid;
	                });
	
	                var criteria = this.state.criteria;
	
	
	                if (!criteria.category && resolveCategory) {
	                    this.setState({ criteria: _extends({}, criteria, { category: resolveCategory }) });
	                }
	
	                var openingTicketPurposes = [].concat(_toConsumableArray(reference.openingTicketPurposes), [reference.default.openingTicketPurpose]);
	                var filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(_models.OpeningTicketPurposeRef.expendChildrenCategories(reference, criteria.category || resolveCategory), criteria.tags));
	                var tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(reference, criteria.tags), defaultTagAggregation(reference, criteria.tags));
	                var filteredTags = tagAggregation.sort(function (a, b) {
	                    return b.count - a.count;
	                }).map(function (a) {
	                    return a.tag;
	                });
	                var filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(reference, criteria.category || resolveCategory), []).map(function (a) {
	                    return a.category;
	                });
	                var categorySource = categoryOrTagMatcher(filteredCategories);
	                var tagSource = categoryOrTagMatcher(filteredTags);
	                var query = null;
	
	                categorySource(query, function (categoryMatches) {
	                    tagSource(query, function (tagMatches) {
	                        _this2.setState({ filteredOpeningTicketPurposes: filteredOpeningTicketPurposes, categorySource: categorySource, tagSource: tagSource, query: query, categoryMatches: categoryMatches, tagMatches: tagMatches });
	                    });
	                });
	            }
	        }
	    }, {
	        key: '_filter',
	        value: function _filter(criteriaUpdate) {
	            var _this3 = this;
	
	            var reference = this.props.reference;
	            var criteria = this.state.criteria;
	
	
	            var nextCriteria = _extends({}, criteria, criteriaUpdate);
	
	            var openingTicketPurposes = [].concat(_toConsumableArray(reference.openingTicketPurposes), [reference.default.openingTicketPurpose]);
	            var filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(_models.OpeningTicketPurposeRef.expendChildrenCategories(reference, nextCriteria.category), nextCriteria.tags));
	            var tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(reference, nextCriteria.tags), defaultTagAggregation(reference, nextCriteria.tags));
	            var filteredTags = tagAggregation.sort(function (a, b) {
	                return b.count - a.count;
	            }).map(function (a) {
	                return a.tag;
	            });
	            var filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(reference, nextCriteria.category), []).map(function (a) {
	                return a.category;
	            });
	            var categorySource = categoryOrTagMatcher(filteredCategories);
	            var tagSource = categoryOrTagMatcher(filteredTags);
	            var query = null;
	
	            categorySource(query, function (categoryMatches) {
	                tagSource(query, function (tagMatches) {
	                    _this3.setState({ filteredOpeningTicketPurposes: filteredOpeningTicketPurposes, categorySource: categorySource, tagSource: tagSource, query: query, categoryMatches: categoryMatches, tagMatches: tagMatches, criteria: nextCriteria });
	                });
	            });
	        }
	    }, {
	        key: '_match',
	        value: function _match(event) {
	            var _this4 = this;
	
	            var _state = this.state,
	                categorySource = _state.categorySource,
	                tagSource = _state.tagSource;
	
	            var query = event.target.value || null;
	
	            categorySource(query, function (categoryMatches) {
	                tagSource(query, function (tagMatches) {
	                    _this4.setState({ query: query, categoryMatches: categoryMatches, tagMatches: tagMatches });
	                });
	            });
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _this5 = this;
	
	            var _state2 = this.state,
	                categorySource = _state2.categorySource,
	                tagSource = _state2.tagSource;
	
	            var query = null;
	
	            event.preventDefault();
	
	            categorySource(query, function (categoryMatches) {
	                tagSource(query, function (tagMatches) {
	                    _this5.setState({ query: query, categoryMatches: categoryMatches, tagMatches: tagMatches });
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var _props2 = this.props,
	                children = _props2.children,
	                dispatch = _props2.dispatch,
	                reference = _props2.reference,
	                company = _props2.company,
	                value = _props2.value,
	                qualification = _props2.qualification,
	                multi = _props2.multi,
	                split = _props2.split,
	                onQualificationChange = _props2.onQualificationChange,
	                others = _objectWithoutProperties(_props2, ['children', 'dispatch', 'reference', 'company', 'value', 'qualification', 'multi', 'split', 'onQualificationChange']);
	
	            var _state3 = this.state,
	                filteredOpeningTicketPurposes = _state3.filteredOpeningTicketPurposes,
	                query = _state3.query,
	                categoryMatches = _state3.categoryMatches,
	                tagMatches = _state3.tagMatches,
	                criteria = _state3.criteria;
	
	
	            var displayOpeningTicketPurpose = function displayOpeningTicketPurpose(openingTicketPurpose, mode) {
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'h4',
	                        null,
	                        openingTicketPurpose.label
	                    );
	                }
	                return openingTicketPurpose.label;
	            };
	
	            var displayCategory = function displayCategory(category, active, path) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _OpeningTicketPurposePicker2.default.category },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: category.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        category.label
	                    ),
	                    path && _react2.default.createElement(
	                        'small',
	                        null,
	                        '>'
	                    )
	                );
	            };
	
	            var displayTag = function displayTag(tag, active) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _OpeningTicketPurposePicker2.default.tag },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: tag.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        tag.label
	                    )
	                );
	            };
	
	            var inputButton = query && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    onClick: function onClick(e) {
	                        return _this6._clear(e);
	                    } },
	                _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	            );
	
	            var inputAddon = !query && _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' });
	
	            var categoryPathField = function categoryPathField() {
	                var value = _models.OpeningTicketPurposeRef.expendParentCategories(reference, criteria.category);
	
	                var onChange = function onChange(categories) {
	                    var category = _models.OpeningTicketPurposeRef.getLeafCategory(categories);
	                    _this6._filter({ category: category });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: split && 4 || 6 },
	                    !!value && children || _react2.default.createElement(
	                        'div',
	                        { className: _OpeningTicketPurposePicker2.default.side },
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            type: 'text',
	                            buttonAfter: inputButton,
	                            addonAfter: inputAddon,
	                            placeholder: _i18n2.default.searchOpeningTicketPurpose,
	                            disabled: !multi && !!value,
	                            value: query,
	                            onChange: function onChange(e) {
	                                return _this6._match(e);
	                            } }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpeningTicketPurposePicker2.default.categoryTagSection },
	                            _react2.default.createElement(
	                                _ButtonToggle2.default,
	                                {
	                                    identify: function identify(c) {
	                                        return c.uid;
	                                    },
	                                    value: criteria.category,
	                                    onChange: function onChange(category) {
	                                        return _this6._filter({ category: category });
	                                    } },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: (0, _classnames2.default)(_OpeningTicketPurposePicker2.default.categoryTagGroup, _OpeningTicketPurposePicker2.default.categoryGroup) },
	                                    categoryMatches.map(function (category) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: category.uid },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'link',
	                                                    value: category,
	                                                    disabled: !multi && !!value },
	                                                displayCategory(category)
	                                            )
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _ButtonToggle2.default,
	                                { multi: true,
	                                    identify: function identify(t) {
	                                        return t.uid;
	                                    },
	                                    value: criteria.tags,
	                                    onChange: function onChange(ts) {
	                                        return _this6._filter(defaultTagCriteria(reference, ts));
	                                    } },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: _OpeningTicketPurposePicker2.default.categoryTagGroup },
	                                    tagMatches.map(function (tag) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: tag.uid },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'link',
	                                                    value: tag,
	                                                    disabled: !multi && !!value },
	                                                displayTag(tag)
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: split && 8 || 6 },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _OpeningTicketPurposePicker2.default.main },
	                        !!value && !!children || _react2.default.createElement(
	                            'div',
	                            { className: _OpeningTicketPurposePicker2.default.categoryTagSection },
	                            _react2.default.createElement(
	                                _ButtonToggle2.default,
	                                _extends({ multi: true,
	                                    identify: function identify(c) {
	                                        return c.uid;
	                                    }
	                                }, categoryPathField()),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: (0, _classnames2.default)(_OpeningTicketPurposePicker2.default.categoryTagGroup, _OpeningTicketPurposePicker2.default.categoryGroup) },
	                                    _models.OpeningTicketPurposeRef.expendParentCategories(reference, criteria.category).map(function (category, index, array) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: category.uid },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'link',
	                                                    value: category,
	                                                    disabled: !multi && !!value || index < array.length - 1 },
	                                                displayCategory(category, index == array.length - 1, true)
	                                            )
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _ButtonToggle2.default,
	                                { multi: true,
	                                    identify: function identify(t) {
	                                        return t.uid;
	                                    },
	                                    value: criteria.tags,
	                                    onChange: function onChange(tags) {
	                                        return _this6._filter({ tags: tags });
	                                    } },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: _OpeningTicketPurposePicker2.default.categoryTagGroup },
	                                    criteria.tags.map(function (tag) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: tag.uid },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'link',
	                                                    value: tag,
	                                                    disabled: !multi && !!value },
	                                                displayTag(tag, true)
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_Picker2.default, _extends({
	                            multi: multi,
	                            split: split,
	                            source: filteredOpeningTicketPurposes,
	                            identify: function identify(otp) {
	                                return otp.uid;
	                            },
	                            display: displayOpeningTicketPurpose,
	                            value: value
	                        }, others)),
	                        !!value && onQualificationChange && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_QualificationCriteriaAnswers2.default, { clientCompany: company && company.uid,
	                                otp: value && value.uid,
	                                qualification: qualification,
	                                onChange: function onChange(qualification) {
	                                    return onQualificationChange({ qualification: qualification });
	                                } })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpeningTicketPurposePicker;
	}(_react.Component);
	
	OpeningTicketPurposePicker.propTypes = {
	    company: _react.PropTypes.any.isRequired
	};
	
	
	OpeningTicketPurposePicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        reference: state.reference.openingTicketPurposeRef,
	        cmd: state.ticket.openTicketCmd
	    };
	})(OpeningTicketPurposePicker);
	
	exports.default = OpeningTicketPurposePicker;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PercentageDashboardPanel = __webpack_require__(891);
	
	var _PercentageDashboardPanel2 = _interopRequireDefault(_PercentageDashboardPanel);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function callPurposeFilter(restrict) {
	    restrict = restrict && (restrict instanceof Array && restrict || [restrict]) || [];
	
	    return function (callPurpose) {
	        if (restrict.length > 0) {
	            return !!restrict.find(function (r) {
	                return r.value == callPurpose.value;
	            });
	        }
	        return true;
	    };
	}
	
	var CallPurposeDashboardPanel = function (_Component) {
	    _inherits(CallPurposeDashboardPanel, _Component);
	
	    function CallPurposeDashboardPanel(props) {
	        _classCallCheck(this, CallPurposeDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (CallPurposeDashboardPanel.__proto__ || Object.getPrototypeOf(CallPurposeDashboardPanel)).call(this, props));
	
	        _this.state = {
	            filteredCallPurposes: []
	        };
	        return _this;
	    }
	
	    _createClass(CallPurposeDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                aggregations = _props.aggregations,
	                query = _props.query;
	
	
	            var filteredCallPurposes = aggregations.callPurposes.filter(callPurposeFilter(query.callPurpose));
	            this.setState({ filteredCallPurposes: filteredCallPurposes });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.aggregations != this.props.aggregations || nextProps.query != this.props.query) {
	                var aggregations = nextProps.aggregations,
	                    query = nextProps.query;
	
	
	                var filteredCallPurposes = aggregations.callPurposes.filter(callPurposeFilter(query.callPurpose));
	                this.setState({ filteredCallPurposes: filteredCallPurposes });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                aggregations = _props2.aggregations,
	                query = _props2.query,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'aggregations', 'query']);
	
	            var filteredCallPurposes = this.state.filteredCallPurposes;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(_PercentageDashboardPanel2.default, _extends({
	                header: panelHeader(_i18n2.default.callPurpose),
	                display: function display(cp) {
	                    return cp.value;
	                },
	                identify: function identify(cp) {
	                    return cp.count;
	                },
	                value: filteredCallPurposes
	            }, others));
	        }
	    }]);
	
	    return CallPurposeDashboardPanel;
	}(_react.Component);
	
	CallPurposeDashboardPanel.propTypes = {};
	
	
	CallPurposeDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        aggregations: state.ticket.aggregations,
	        query: state.ticket.query
	    };
	})(CallPurposeDashboardPanel);
	
	exports.default = CallPurposeDashboardPanel;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _RankingDashboardPanel = __webpack_require__(1091);
	
	var _RankingDashboardPanel2 = _interopRequireDefault(_RankingDashboardPanel);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderDashboardPanel = function (_Component) {
	    _inherits(ProviderDashboardPanel, _Component);
	
	    function ProviderDashboardPanel(props) {
	        _classCallCheck(this, ProviderDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (ProviderDashboardPanel.__proto__ || Object.getPrototypeOf(ProviderDashboardPanel)).call(this, props));
	
	        _this.state = {
	            providers: []
	        };
	        return _this;
	    }
	
	    _createClass(ProviderDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var aggregations = this.props.aggregations;
	
	
	            var providers = aggregations.assignees.filter(function (a) {
	                return a.ref == 'ProviderContact';
	            });
	            this.setState({ providers: providers });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.aggregations != this.props.aggregations) {
	                var aggregations = nextProps.aggregations;
	
	
	                var providers = aggregations.assignees.filter(function (a) {
	                    return a.ref == 'ProviderContact';
	                });
	                this.setState({ providers: providers });
	            }
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, provider) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)('/providercontacts/' + provider.value));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                aggregations = _props.aggregations,
	                others = _objectWithoutProperties(_props, ['dispatch', 'aggregations']);
	
	            var providers = this.state.providers;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(_RankingDashboardPanel2.default, _extends({
	                header: panelHeader(_i18n2.default.providersTop10),
	                display: function display(p) {
	                    return p.label + ' (' + p.count + ')';
	                },
	                identify: function identify(p) {
	                    return p.count;
	                },
	                onClick: function onClick(e, p) {
	                    return _this2._navigate(e, p);
	                },
	                value: providers
	            }, others));
	        }
	    }]);
	
	    return ProviderDashboardPanel;
	}(_react.Component);
	
	ProviderDashboardPanel.propTypes = {};
	
	
	ProviderDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        aggregations: state.ticket.aggregations
	    };
	})(ProviderDashboardPanel);
	
	exports.default = ProviderDashboardPanel;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _loading = __webpack_require__(58);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(38);
	
	var _TicketCard = __webpack_require__(1520);
	
	var _TicketCard2 = _interopRequireDefault(_TicketCard);
	
	var _TicketStream = __webpack_require__(2338);
	
	var _TicketStream2 = _interopRequireDefault(_TicketStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var TicketStream = function (_Component) {
	    _inherits(TicketStream, _Component);
	
	    function TicketStream() {
	        _classCallCheck(this, TicketStream);
	
	        return _possibleConstructorReturn(this, (TicketStream.__proto__ || Object.getPrototypeOf(TicketStream)).apply(this, arguments));
	    }
	
	    _createClass(TicketStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadTicketStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, ticket) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/tickets/' + ticket.uid, '_blank');
	            } else {
	                dispatch((0, _reactRouterRedux.push)('/tickets/' + ticket.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                stream.map(function (ticket) {
	                    return _react2.default.createElement(_TicketCard2.default, {
	                        key: ticket.uid,
	                        ticket: ticket,
	                        onClick: function onClick(e) {
	                            return _this2._navigate(e, ticket);
	                        } });
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _TicketStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, {
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        },
	                        prev: true, next: true, first: true, last: true, ellipsis: true })
	                )
	            );
	        }
	    }]);
	
	    return TicketStream;
	}(_react.Component);
	
	TicketStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	TicketStream = (0, _loading.connectLoadingLock)()(TicketStream);
	
	TicketStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        stream: state.ticket.stream,
	        range: state.ticket.range
	    };
	})(TicketStream);
	
	exports.default = TicketStream;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(1875);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(1149),
	    bindCallback = __webpack_require__(1018),
	    pickByArray = __webpack_require__(1159),
	    pickByCallback = __webpack_require__(1160),
	    restParam = __webpack_require__(1148);
	
	/**
	 * Creates an object composed of the picked `object` properties. Property
	 * names may be specified as individual arguments or as arrays of property
	 * names. If `predicate` is provided it's invoked for each property of `object`
	 * picking the properties `predicate` returns truthy for. The predicate is
	 * bound to `thisArg` and invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to pick, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.pick(object, 'user');
	 * // => { 'user': 'fred' }
	 *
	 * _.pick(object, _.isString);
	 * // => { 'user': 'fred' }
	 */
	var pick = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  return typeof props[0] == 'function'
	    ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	    : pickByArray(object, baseFlatten(props));
	});
	
	module.exports = pick;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1934),
	    listCacheDelete = __webpack_require__(1935),
	    listCacheGet = __webpack_require__(1936),
	    listCacheHas = __webpack_require__(1937),
	    listCacheSet = __webpack_require__(1938);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(1184);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1931);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(519);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(1035);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(537),
	    getPrototype = __webpack_require__(1919),
	    isObjectLike = __webpack_require__(520);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domHelpersActiveElement = __webpack_require__(1797);
	
	var _domHelpersActiveElement2 = _interopRequireDefault(_domHelpersActiveElement);
	
	var _domHelpersQueryContains = __webpack_require__(1011);
	
	var _domHelpersQueryContains2 = _interopRequireDefault(_domHelpersQueryContains);
	
	var _keycode = __webpack_require__(1017);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _lodashCompatCollectionFind = __webpack_require__(1842);
	
	var _lodashCompatCollectionFind2 = _interopRequireDefault(_lodashCompatCollectionFind);
	
	var _lodashCompatObjectOmit = __webpack_require__(1024);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactPropTypesLibAll = __webpack_require__(916);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(1055);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(1262);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _ButtonGroup = __webpack_require__(1191);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(1991);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(1194);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsCustomPropTypes = __webpack_require__(2033);
	
	var _utilsCustomPropTypes2 = _interopRequireDefault(_utilsCustomPropTypes);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var TOGGLE_REF = 'toggle-btn';
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var Dropdown = (function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    _React$Component.call(this, props);
	
	    this.Toggle = _DropdownToggle2['default'];
	
	    this.toggleOpen = this.toggleOpen.bind(this);
	    this.handleClick = this.handleClick.bind(this);
	    this.handleKeyDown = this.handleKeyDown.bind(this);
	    this.handleClose = this.handleClose.bind(this);
	    this.extractChildren = this.extractChildren.bind(this);
	
	    this.refineMenu = this.refineMenu.bind(this);
	    this.refineToggle = this.refineToggle.bind(this);
	
	    this.childExtractors = [{
	      key: 'toggle',
	      matches: function matches(child) {
	        return child.props.bsRole === TOGGLE_ROLE;
	      },
	      refine: this.refineToggle
	    }, {
	      key: 'menu',
	      exclusive: true,
	      matches: function matches(child) {
	        return child.props.bsRole === MENU_ROLE;
	      },
	      refine: this.refineMenu
	    }];
	
	    this.state = {};
	
	    this.lastOpenEventType = null;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = _domHelpersQueryContains2['default'](_reactDom2['default'].findDOMNode(this.refs.menu), _domHelpersActiveElement2['default'](document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.open && !prevProps.open) {
	      this.focusNextOnOpen();
	    }
	
	    if (!this.props.open && prevProps.open) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _rootClasses;
	
	    var children = this.extractChildren();
	    var Component = this.props.componentClass;
	
	    var props = _lodashCompatObjectOmit2['default'](this.props, ['id', 'bsClass', 'role']);
	    var className = _utilsBootstrapUtils2['default'].prefix(this.props);
	
	    var rootClasses = (_rootClasses = {
	      open: this.props.open,
	      disabled: this.props.disabled
	    }, _rootClasses[className] = !this.props.dropup, _rootClasses.dropup = this.props.dropup, _rootClasses);
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, rootClasses)
	      }),
	      children
	    );
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen() {
	    var eventType = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventType;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open);
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick() {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen('click');
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen('keydown');
	        } else if (this.refs.menu.focusNext) {
	          this.refs.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event);
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose() {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen();
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.refs.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.refs[TOGGLE_REF]);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.extractChildren = function extractChildren() {
	    var _this = this;
	
	    var open = !!this.props.open;
	    var seen = {};
	
	    return _utilsValidComponentChildren2['default'].map(this.props.children, function (child) {
	      var extractor = _lodashCompatCollectionFind2['default'](_this.childExtractors, function (x) {
	        return x.matches(child);
	      });
	
	      if (extractor) {
	        if (seen[extractor.key]) {
	          return false;
	        }
	
	        seen[extractor.key] = extractor.exclusive;
	        child = extractor.refine(child, open);
	      }
	
	      return child;
	    });
	  };
	
	  Dropdown.prototype.refineMenu = function refineMenu(menu, open) {
	    var menuProps = {
	      ref: 'menu',
	      open: open,
	      labelledBy: this.props.id,
	      pullRight: this.props.pullRight,
	      bsClass: this.props.bsClass
	    };
	
	    menuProps.onClose = _utilsCreateChainedFunction2['default'](menu.props.onClose, this.props.onClose, this.handleClose);
	
	    menuProps.onSelect = _utilsCreateChainedFunction2['default'](menu.props.onSelect, this.props.onSelect, this.handleClose);
	
	    return _react.cloneElement(menu, menuProps, menu.props.children);
	  };
	
	  Dropdown.prototype.refineToggle = function refineToggle(toggle, open) {
	    var toggleProps = {
	      open: open,
	      id: this.props.id,
	      ref: TOGGLE_REF,
	      role: this.props.role
	    };
	
	    toggleProps.onClick = _utilsCreateChainedFunction2['default'](toggle.props.onClick, this.handleClick);
	
	    toggleProps.onKeyDown = _utilsCreateChainedFunction2['default'](toggle.props.onKeyDown, this.handleKeyDown);
	
	    return _react.cloneElement(toggle, toggleProps, toggle.props.children);
	  };
	
	  return Dropdown;
	})(_react2['default'].Component);
	
	Dropdown.Toggle = _DropdownToggle2['default'];
	
	Dropdown.TOGGLE_REF = TOGGLE_REF;
	Dropdown.TOGGLE_ROLE = TOGGLE_ROLE;
	Dropdown.MENU_ROLE = MENU_ROLE;
	
	Dropdown.defaultProps = {
	  componentClass: _ButtonGroup2['default'],
	  bsClass: 'dropdown'
	};
	
	Dropdown.propTypes = {
	
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _react2['default'].PropTypes.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  componentClass: _reactPropTypesLibElementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle/>` or a `<Dropdown.Menu/>`.
	   * @type {node}
	   */
	  children: _reactPropTypesLibAll2['default'](_utilsCustomPropTypes2['default'].requiredRoles(TOGGLE_ROLE, MENU_ROLE), _utilsCustomPropTypes2['default'].exclusiveRoles(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value.
	   *
	   * ```js
	   * function(Boolean isOpen) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * function(Object event, Any eventKey)
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	Dropdown = _uncontrollable2['default'](Dropdown, { open: 'onToggle' });
	
	Dropdown.Toggle = _DropdownToggle2['default'];
	Dropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = Dropdown;
	module.exports = exports['default'];

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = undefined;
	
	  if (typeof oldname === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? _warning2['default'](false, message) : undefined;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return (function (_Component) {
	    _inherits(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      _classCallCheck(this, DeprecatedComponent);
	
	      _Component.apply(this, arguments);
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$componentWillMount;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$componentWillMount = _Component.prototype.componentWillMount).call.apply(_Component$prototype$componentWillMount, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  })(Component);
	};
	
	exports['default'] = deprecationWarning;
	module.exports = exports['default'];

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1572), __esModule: true };

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = all;
	
	var _common = __webpack_require__(1054);
	
	function all() {
	  for (var _len = arguments.length, propTypes = Array(_len), _key = 0; _key < _len; _key++) {
	    propTypes[_key] = arguments[_key];
	  }
	
	  if (propTypes === undefined) {
	    throw new Error('No validations provided');
	  }
	
	  if (propTypes.some(function (propType) {
	    return typeof propType !== 'function';
	  })) {
	    throw new Error('Invalid arguments, must be functions');
	  }
	
	  if (propTypes.length === 0) {
	    throw new Error('No validations provided');
	  }
	
	  function validate(props, propName, componentName) {
	    for (var i = 0; i < propTypes.length; i++) {
	      var result = propTypes[i](props, propName, componentName);
	
	      if (result !== undefined && result !== null) {
	        return result;
	      }
	    }
	  }
	
	  return _common.createChainableTypeChecker(validate);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(2073);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 918 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(808)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 920 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(197).setDesc
	  , has = __webpack_require__(920)
	  , TAG = __webpack_require__(199)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(924);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(2125);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(466);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1648);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Icon.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Icon.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ACTION_FAILED = exports.VERSION_LOADED = exports.LINKS_LOADED = undefined;
	exports.loadLinks = loadLinks;
	exports.subscribeVersion = subscribeVersion;
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _context = __webpack_require__(1348);
	
	var _context2 = _interopRequireDefault(_context);
	
	var _protocol = __webpack_require__(1281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NAMESPACE = 'App';
	
	var LINKS_LOADED = exports.LINKS_LOADED = NAMESPACE + '/LinksLoaded';
	var VERSION_LOADED = exports.VERSION_LOADED = NAMESPACE + '/VersionLoaded';
	// middleware action
	var ACTION_FAILED = exports.ACTION_FAILED = NAMESPACE + '/ActionFailed';
	
	var subscribeVersionSocket;
	
	function loadLinks() {
	    return (0, _loading2.default)(fetch(_config2.default.api.url, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: LINKS_LOADED,
	            _links: json._links
	        };
	    }), LINKS_LOADED);
	}
	
	function subscribeVersion() {
	    var _this = this;
	
	    return function (state, _ref2) {
	        var getState = _ref2.getState,
	            dispatch = _ref2.dispatch;
	
	        if (!subscribeVersionSocket) {
	            subscribeVersionSocket = _context2.default.getFrontWebSocket();
	
	            subscribeVersionSocket.addEventListener('open', function () {
	                var state = getState();
	                var version = state.app.version;
	
	
	                this.send(JSON.stringify({
	                    type: _protocol.SUBSCRIBE_VERSION,
	                    catchup: version && version.hash
	                }));
	            });
	
	            subscribeVersionSocket.addEventListener('message', function (event) {
	                var data = JSON.parse(event.data);
	
	                switch (data.type) {
	                    case _protocol.VERSION_UPDATED:
	                        dispatch({
	                            type: VERSION_LOADED,
	                            version: data.version
	                        });
	                        break;
	                }
	            });
	
	            if (subscribeVersionSocket.readyState == WebSocket.OPEN) {
	                var version = state.app.version;
	
	
	                _this.send(JSON.stringify({
	                    type: _protocol.SUBSCRIBE_VERSION,
	                    catchup: version && version.hash
	                }));
	            }
	        }
	
	        return subscribeVersionSocket;
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 949 */,
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chartist = __webpack_require__(271);
	
	var _chartist2 = _interopRequireDefault(_chartist);
	
	var _chartistPluginLegend = __webpack_require__(1129);
	
	var _chartistPluginLegend2 = _interopRequireDefault(_chartistPluginLegend);
	
	var _browser = __webpack_require__(54);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _Chart = __webpack_require__(275);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _i18n = __webpack_require__(1087);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ScoreDashboardPanel = __webpack_require__(2164);
	
	var _ScoreDashboardPanel2 = _interopRequireDefault(_ScoreDashboardPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function reportFilter(audit) {
	    return function (report) {
	        return report.parentAudit.uid == audit.uid;
	    };
	}
	
	function auditAggregator(result, report) {
	    var audit = result.find(function (a) {
	        return a.uid == report.parentAudit.uid;
	    });
	
	    if (!audit) {
	        result.push(report.parentAudit);
	    }
	    return result;
	}
	
	function aggregate(reports) {
	    var audits = reports.reduce(auditAggregator, []);
	    var aggregations = audits.map(function (audit) {
	        var auditReports = reports.filter(reportFilter(audit));
	
	        return {
	            audit: audit,
	            reports: auditReports
	        };
	    });
	
	    return aggregations;
	}
	
	var ScoreDashboardPanel = function (_Component) {
	    _inherits(ScoreDashboardPanel, _Component);
	
	    function ScoreDashboardPanel(props) {
	        _classCallCheck(this, ScoreDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (ScoreDashboardPanel.__proto__ || Object.getPrototypeOf(ScoreDashboardPanel)).call(this, props));
	
	        _this.state = {
	            aggregations: []
	        };
	        return _this;
	    }
	
	    _createClass(ScoreDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var stream = this.props.stream;
	
	
	            var aggregations = aggregate(stream);
	            this.setState({ aggregations: aggregations });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.stream != this.props.stream) {
	                var stream = nextProps.stream;
	
	
	                var aggregations = aggregate(stream);
	                this.setState({ aggregations: aggregations });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                stream = _props.stream,
	                others = _objectWithoutProperties(_props, ['dispatch', 'stream']);
	
	            var aggregations = this.state.aggregations;
	
	
	            var panelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _i18n2.default.auditScores
	            );
	
	            var chartAxisX = function chartAxisX() {
	                var axisX = {
	                    divisor: 4,
	                    offset: 20,
	                    labelInterpolationFnc: function labelInterpolationFnc(v) {
	                        return (0, _moment2.default)(v).format(_i18n2.default.dateFormat.short);
	                    }
	                };
	
	                if (stream.length > 1) {
	                    axisX = _extends({
	                        type: _chartist2.default.FixedScaleAxis
	                    }, axisX);
	                }
	
	                return axisX;
	            };
	
	            var chartAxisY = {
	                type: _chartist2.default.FixedScaleAxis,
	                high: 1,
	                low: 0,
	                ticks: [0, 0.2, 0.4, 0.6, 0.8, 1],
	                labelInterpolationFnc: function labelInterpolationFnc(v) {
	                    return v * 100 + '%';
	                }
	            };
	
	            var chartPadding = {
	                left: 0,
	                right: 5,
	                bottom: 0
	            };
	
	            var chartPlugins = [(0, _chartistPluginLegend2.default)({
	                legendNames: aggregations.map(function (a) {
	                    return a.audit.name;
	                })
	            })];
	
	            var chartResponsive = [['screen and (min-width: ' + _browser.SCREEN_SM_MIN + 'px)', {
	                axisX: {
	                    divisor: 7
	                }
	            }]];
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader
	                }, others),
	                aggregations.length > 0 && _react2.default.createElement(_Chart2.default, { fill: true, showArea: true,
	                    kind: 'Line',
	                    chartPadding: chartPadding,
	                    axisX: chartAxisX(),
	                    axisY: chartAxisY,
	                    lineSmooth: _chartist2.default.Interpolation.simple(),
	                    plugins: chartPlugins,
	                    responsive: chartResponsive,
	                    serie: function serie(a) {
	                        return a.reports;
	                    },
	                    display: function display(r) {
	                        return new Date(r.created);
	                    },
	                    identify: function identify(r) {
	                        return r.score;
	                    },
	                    value: aggregations })
	            );
	        }
	    }]);
	
	    return ScoreDashboardPanel;
	}(_react.Component);
	
	ScoreDashboardPanel.propTypes = {};
	
	
	ScoreDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.audit.report.stream
	    };
	})(ScoreDashboardPanel);
	
	exports.default = ScoreDashboardPanel;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(112);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanyPicker = __webpack_require__(2182);
	
	var _CompanyPicker2 = _interopRequireDefault(_CompanyPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyPicker = function (_Component) {
	    _inherits(CompanyPicker, _Component);
	
	    function CompanyPicker() {
	        _classCallCheck(this, CompanyPicker);
	
	        return _possibleConstructorReturn(this, (CompanyPicker.__proto__ || Object.getPrototypeOf(CompanyPicker)).apply(this, arguments));
	    }
	
	    _createClass(CompanyPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                billingType = _props.billingType,
	                includeSubsidiaries = _props.includeSubsidiaries;
	
	
	            dispatch((0, _actions.resetMinorCompanyCriteria)());
	            dispatch((0, _actions.queryCompanyStream)(_extends({}, _actions.DEFAULT_COMPANY_QUERY, { billingType: billingType, includeSubsidiaries: includeSubsidiaries, range: { offset: 0, limit: 99 } })));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.billingType != this.props.billingType || nextProps.includeSubsidiaries != this.props.includeSubsidiaries) {
	                var dispatch = nextProps.dispatch,
	                    billingType = nextProps.billingType,
	                    includeSubsidiaries = nextProps.includeSubsidiaries;
	
	                dispatch((0, _actions.queryCompanyStream)(_extends({}, _actions.DEFAULT_COMPANY_QUERY, { billingType: billingType, includeSubsidiaries: includeSubsidiaries, range: { offset: 0, limit: 99 } })));
	            }
	        }
	    }, {
	        key: '_search',
	        value: function _search(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                minorCriteria = _props2.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.queryCompanyStream)(minorCriteria));
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props3 = this.props,
	                    dispatch = _props3.dispatch,
	                    minorCriteria = _props3.minorCriteria;
	
	                dispatch((0, _actions.queryCompanyStream)(minorCriteria));
	            }
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                minorCriteria = _props4.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.updateMinorCompanyCriteria)({ fullText: null }));
	            dispatch((0, _actions.queryCompanyStream)(_extends({}, minorCriteria, { fullText: null })));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props5 = this.props,
	                dispatch = _props5.dispatch,
	                form = _props5.form,
	                minorCriteria = _props5.minorCriteria,
	                stream = _props5.stream,
	                range = _props5.range,
	                query = _props5.query,
	                billingType = _props5.billingType,
	                includeSubsidiaries = _props5.includeSubsidiaries,
	                others = _objectWithoutProperties(_props5, ['dispatch', 'form', 'minorCriteria', 'stream', 'range', 'query', 'billingType', 'includeSubsidiaries']);
	
	            var searched = minorCriteria && minorCriteria.fullText && minorCriteria.fullText == (query && query.fullText);
	
	            var afterCompanies = function afterCompanies() {
	                if (range && range.limit < range.count - 1) {
	                    var count = range.limit + 1;
	                    return _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _extract.replace)(_i18n2.default.useSearchCompanyFilters, { count: count })
	                    );
	                }
	            };
	
	            var companyHeader = _react2.default.createElement(
	                'div',
	                { className: _CompanyPicker2.default.search },
	                searched && _react2.default.createElement(
	                    'a',
	                    {
	                        href: '',
	                        onClick: function onClick(e) {
	                            return _this2._clear(e);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	                ),
	                !searched && _react2.default.createElement(
	                    'a',
	                    {
	                        href: '',
	                        onClick: function onClick(e) {
	                            return _this2._search(e);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _CompanyPicker2.default.container },
	                    _react2.default.createElement('input', _extends({
	                        type: 'text',
	                        onKeyPress: function onKeyPress(e) {
	                            return _this2._searchOnKeyPress(e);
	                        },
	                        placeholder: _i18n2.default.searchStream.xs
	                    }, form.fullText()))
	                )
	            );
	
	            var displayCompany = function displayCompany(company, mode) {
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'h4',
	                        null,
	                        company.label
	                    );
	                }
	                return company.label;
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CompanyPicker2.default.default },
	                _react2.default.createElement(_Picker2.default, _extends({
	                    source: stream.filter(function (c) {
	                        return c.isActive;
	                    }),
	                    identify: function identify(c) {
	                        return c.uid;
	                    },
	                    display: displayCompany,
	                    header: companyHeader,
	                    after: afterCompanies()
	                }, others))
	            );
	        }
	    }]);
	
	    return CompanyPicker;
	}(_react.Component);
	
	CompanyPicker.propTypes = {
	    billingType: _react.PropTypes.any,
	    includeSubsidiaries: _react.PropTypes.bool
	};
	
	
	CompanyPicker = (0, _form.connectForm)({
	    target: 'minorCriteria',
	    schema: _models.CompanyCriteria.schema,
	    action: _actions.MINOR_COMPANY_CRITERIA_UPDATED
	})(CompanyPicker);
	
	CompanyPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        minorCriteria: state.company.minorCriteria,
	        stream: state.company.stream,
	        range: state.company.range,
	        query: state.company.query
	    };
	})(CompanyPicker);
	
	exports.default = CompanyPicker;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CardGroup = __webpack_require__(2203);
	
	var _CardGroup2 = _interopRequireDefault(_CardGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardGroup = function (_Component) {
	    _inherits(CardGroup, _Component);
	
	    function CardGroup() {
	        _classCallCheck(this, CardGroup);
	
	        return _possibleConstructorReturn(this, (CardGroup.__proto__ || Object.getPrototypeOf(CardGroup)).apply(this, arguments));
	    }
	
	    _createClass(CardGroup, [{
	        key: '_enhance',
	        value: function _enhance(children) {
	            return _react2.default.Children.map(children, function (child) {
	                if (child && child.props) {
	                    return _react2.default.cloneElement(child, {
	                        grouped: true
	                    });
	                }
	                return child;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CardGroup2.default.default },
	                this._enhance(children)
	            );
	        }
	    }]);
	
	    return CardGroup;
	}(_react.Component);
	
	CardGroup.propTypes = {};
	exports.default = CardGroup;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.timeUnits = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _i18n = __webpack_require__(545);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var timeUnits = exports.timeUnits = {
	    'd': 24 * 3600 * 1000,
	    'h': 3600 * 1000,
	    'm': 60 * 1000
	};
	
	function toMeasueAndUnit(units, value) {
	    var unitNames = Object.keys(units);
	
	    for (var i = 0; i < unitNames.length; i++) {
	        var unitName = unitNames[i];
	        var unitFactor = units[unitName];
	
	        if (value && value % unitFactor == 0) {
	            return {
	                measure: value / unitFactor,
	                unit: unitName
	            };
	        }
	
	        if (i == unitNames.length - 1) {
	            return {
	                measure: value && Math.round(value / unitFactor),
	                unit: unitName
	            };
	        }
	    }
	}
	
	function toMeasure(units, value, unitName) {
	    var unitFactor = units[unitName];
	    return value && value / unitFactor;
	}
	
	function toValue(units, measure, unitName) {
	    var unitFactor = units[unitName];
	    return measure && measure * unitFactor;
	}
	
	var MeasureInput = function (_Component) {
	    _inherits(MeasureInput, _Component);
	
	    function MeasureInput(props) {
	        _classCallCheck(this, MeasureInput);
	
	        var _this = _possibleConstructorReturn(this, (MeasureInput.__proto__ || Object.getPrototypeOf(MeasureInput)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(MeasureInput, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                units = _props.units,
	                value = _props.value;
	
	            var _toMeasueAndUnit = toMeasueAndUnit(units, value),
	                measure = _toMeasueAndUnit.measure,
	                unit = _toMeasueAndUnit.unit;
	
	            this.setState({ measure: measure, unit: unit });
	            this._unit = unit;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.units != this.props.units || nextProps.value != this.props.value) {
	                var units = nextProps.units,
	                    value = nextProps.value;
	
	
	                if (value != this._nextValue) {
	                    var _toMeasueAndUnit2 = toMeasueAndUnit(units, value),
	                        measure = _toMeasueAndUnit2.measure,
	                        unit = _toMeasueAndUnit2.unit;
	
	                    this.setState({ measure: measure, unit: unit });
	                    this._unit = unit;
	                } else {
	                    var _measure = toMeasure(units, value, this._unit);
	                    this.setState({ measure: _measure });
	                }
	            }
	        }
	    }, {
	        key: '_selectUnit',
	        value: function _selectUnit(event, unit) {
	            var _props2 = this.props,
	                units = _props2.units,
	                onChange = _props2.onChange;
	            var measure = this.state.measure;
	
	
	            this._nextValue = toValue(units, measure, unit);
	            onChange(this._nextValue);
	
	            this.setState({ unit: unit });
	            this._unit = unit;
	        }
	    }, {
	        key: '_selectMeasure',
	        value: function _selectMeasure(event) {
	            var _props3 = this.props,
	                units = _props3.units,
	                onChange = _props3.onChange;
	            var unit = this.state.unit;
	
	
	            var measure = parseInt(event.target.value);
	
	            this._nextValue = toValue(units, measure, unit);
	            onChange(this._nextValue);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                units = _props4.units,
	                value = _props4.value,
	                onChange = _props4.onChange,
	                others = _objectWithoutProperties(_props4, ['units', 'value', 'onChange']);
	
	            var _state = this.state,
	                measure = _state.measure,
	                unit = _state.unit;
	
	
	            var unitInputButton = _react2.default.createElement(
	                _reactBootstrap.DropdownButton,
	                {
	                    title: _i18n2.default.unitEnum[unit],
	                    onSelect: function onSelect(e, k) {
	                        return _this2._selectUnit(e, k);
	                    } },
	                Object.keys(units).map(function (unit) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        {
	                            key: unit,
	                            eventKey: unit },
	                        _i18n2.default.unitEnum[unit]
	                    );
	                })
	            );
	
	            return _react2.default.createElement(_reactBootstrap.Input, _extends({
	                type: 'text',
	                value: measure,
	                onChange: function onChange(e) {
	                    return _this2._selectMeasure(e);
	                },
	                buttonAfter: unitInputButton
	            }, others));
	        }
	    }]);
	
	    return MeasureInput;
	}(_react.Component);
	
	MeasureInput.propTypes = {
	    units: _react.PropTypes.object.isRequired,
	    value: _react.PropTypes.number,
	    onChange: _react.PropTypes.func.isRequired
	};
	exports.default = MeasureInput;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Selector = __webpack_require__(2219);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selector = function (_Component) {
	    _inherits(Selector, _Component);
	
	    function Selector() {
	        _classCallCheck(this, Selector);
	
	        return _possibleConstructorReturn(this, (Selector.__proto__ || Object.getPrototypeOf(Selector)).apply(this, arguments));
	    }
	
	    _createClass(Selector, [{
	        key: '_toggle',
	        value: function _toggle(event, item) {
	            var _props = this.props,
	                multi = _props.multi,
	                identify = _props.identify,
	                value = _props.value,
	                onChange = _props.onChange,
	                onSubmit = _props.onSubmit;
	
	
	            event.preventDefault();
	
	            if (multi) {
	                var previousValue = value || [];
	                var itemId = identify(item);
	                var index = previousValue.findIndex(function (value) {
	                    return identify(value) == itemId;
	                });
	
	                if (index < 0) {
	                    if (onSubmit) {
	                        onSubmit('Add', item);
	                    }
	
	                    if (onChange) {
	                        var nextValue = [].concat(_toConsumableArray(previousValue));
	                        nextValue.push(item);
	                        onChange(nextValue);
	                    }
	                } else {
	                    if (onSubmit) {
	                        onSubmit('Remove', item);
	                    }
	
	                    if (onChange) {
	                        var nextValue = [].concat(_toConsumableArray(previousValue));
	                        nextValue.splice(index, 1);
	                        onChange(nextValue);
	                    }
	                }
	            } else {
	                if ((value && identify(value)) != identify(item)) {
	                    if (onSubmit) {
	                        onSubmit('Add', item);
	                    }
	
	                    if (onChange) {
	                        onChange(item);
	                    }
	                } else {
	                    if (onSubmit) {
	                        onSubmit('Remove', value);
	                    }
	
	                    if (onChange) {
	                        onChange(null);
	                    }
	                }
	            }
	        }
	    }, {
	        key: '_isActive',
	        value: function _isActive(item) {
	            var _props2 = this.props,
	                multi = _props2.multi,
	                identify = _props2.identify,
	                value = _props2.value;
	
	
	            if (multi) {
	                var itemId = identify(item);
	                return value && value.find(function (v) {
	                    return identify(v) == itemId;
	                }) != null;
	            } else {
	                return (value && identify(value)) == identify(item);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                source = _props3.source,
	                kind = _props3.kind,
	                display = _props3.display,
	                identify = _props3.identify,
	                disable = _props3.disable,
	                header = _props3.header,
	                after = _props3.after,
	                bsStyle = _props3.bsStyle,
	                value = _props3.value,
	                onChange = _props3.onChange,
	                onSubmit = _props3.onSubmit,
	                other = _objectWithoutProperties(_props3, ['source', 'kind', 'display', 'identify', 'disable', 'header', 'after', 'bsStyle', 'value', 'onChange', 'onSubmit']);
	
	            var kindClass = kind && kind.toLowerCase();
	
	            var colorStyle = function colorStyle(item, index) {
	                if (_this2._isActive(item)) return null;
	                if (kindClass == 'checkbox') return null;
	
	                var opacity = 1 - index * 2 / 10;
	                opacity = opacity >= 0.2 && opacity || 0.2;
	                return 'rgba(213, 221, 229, ' + opacity + ')';
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Selector2.default.default, _Selector2.default[kindClass], _defineProperty({}, _Selector2.default.error, bsStyle == 'error')) },
	                header,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _Selector2.default.result },
	                    source.map(function (item, index) {
	                        var _cx2;
	
	                        return _react2.default.createElement(
	                            'li',
	                            {
	                                key: identify(item),
	                                className: (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _Selector2.default.active, _this2._isActive(item)), _defineProperty(_cx2, _Selector2.default.disabled, disable(item)), _cx2)),
	                                style: { background: colorStyle(item, index) },
	                                onClick: function onClick(e) {
	                                    return !disable(item) && _this2._toggle(e, item);
	                                } },
	                            kindClass == 'checkbox' && _react2.default.createElement(
	                                'label',
	                                null,
	                                _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: _this2._isActive(item) }),
	                                _react2.default.createElement('span', null)
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _Selector2.default.container },
	                                display(item)
	                            )
	                        );
	                    }),
	                    after && _react2.default.createElement(
	                        'li',
	                        {
	                            key: 'after',
	                            className: _Selector2.default.after },
	                        after
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Selector;
	}(_react.Component);
	
	Selector.propTypes = {
	    source: _react.PropTypes.array.isRequired,
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    disable: _react.PropTypes.func,
	    kind: _react.PropTypes.string,
	    multi: _react.PropTypes.bool,
	    bsStyle: _react.PropTypes.string,
	    value: _react.PropTypes.any,
	    onChange: _react.PropTypes.func,
	    onSubmit: _react.PropTypes.func
	};
	Selector.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    },
	    disable: function disable(v) {
	        return false;
	    }
	};
	exports.default = Selector;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tag = __webpack_require__(2222);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tag = function (_Component) {
	    _inherits(Tag, _Component);
	
	    function Tag() {
	        _classCallCheck(this, Tag);
	
	        return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
	    }
	
	    _createClass(Tag, [{
	        key: '_remove',
	        value: function _remove(event) {
	            var onChange = this.props.onChange;
	
	
	            event.preventDefault();
	            onChange(null);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                display = _props.display,
	                size = _props.size,
	                position = _props.position,
	                value = _props.value,
	                onChange = _props.onChange,
	                other = _objectWithoutProperties(_props, ['display', 'size', 'position', 'value', 'onChange']);
	
	            var sizeClass = size && size.toLowerCase();
	            var positionClass = position && position.toLowerCase();
	
	            return value != null && _react2.default.createElement(
	                'a',
	                {
	                    href: '',
	                    className: (0, _classnames2.default)(_Tag2.default.default, _Tag2.default[sizeClass], _Tag2.default[positionClass]),
	                    onClick: function onClick(e) {
	                        return _this2._remove(e);
	                    } },
	                positionClass != 'right' && _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' }),
	                display(value),
	                positionClass == 'right' && _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	            ) || null;
	        }
	    }]);
	
	    return Tag;
	}(_react.Component);
	
	Tag.propTypes = {
	    display: _react.PropTypes.func,
	    size: _react.PropTypes.string,
	    position: _react.PropTypes.string,
	    value: _react.PropTypes.any,
	    onChange: _react.PropTypes.func.isRequired
	};
	Tag.defaultProps = {
	    display: function display(v) {
	        return v;
	    }
	};
	exports.default = Tag;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TagBar = __webpack_require__(2223);
	
	var _TagBar2 = _interopRequireDefault(_TagBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagBar = function (_Component) {
	    _inherits(TagBar, _Component);
	
	    function TagBar(props) {
	        _classCallCheck(this, TagBar);
	
	        var _this = _possibleConstructorReturn(this, (TagBar.__proto__ || Object.getPrototypeOf(TagBar)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(TagBar, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.value != this.props.value) {
	                var value = nextProps.value,
	                    multi = nextProps.multi;
	
	
	                if (!multi && value) {
	                    this.setState({ opened: false });
	                }
	            }
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.setState({ opened: false });
	        }
	    }, {
	        key: '_remove',
	        value: function _remove(tag) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange,
	                onSubmit = _props.onSubmit,
	                identify = _props.identify,
	                multi = _props.multi;
	
	
	            if (multi) {
	                var arrayValue = value || [];
	                var tagId = identify(tag);
	                var index = arrayValue.findIndex(function (value) {
	                    return identify(value) == tagId;
	                });
	
	                if (index >= 0) {
	                    if (onSubmit) {
	                        onSubmit('Remove', tag);
	                    }
	
	                    if (onChange) {
	                        var nextValue = [].concat(_toConsumableArray(arrayValue));
	                        nextValue.splice(index, 1);
	                        onChange(nextValue);
	                    }
	                }
	            } else {
	                if ((value && identify(value)) == identify(tag)) {
	                    if (onSubmit) {
	                        onSubmit('Remove', value);
	                    }
	
	                    if (onChange) {
	                        onChange(null);
	                    }
	                }
	            }
	        }
	    }, {
	        key: '_open',
	        value: function _open(event) {
	            event.preventDefault();
	            this.setState({ opened: true });
	        }
	    }, {
	        key: '_close',
	        value: function _close(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ opened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                children = _props2.children,
	                display = _props2.display,
	                identify = _props2.identify,
	                multi = _props2.multi,
	                disabled = _props2.disabled,
	                label = _props2.label,
	                value = _props2.value,
	                onChange = _props2.onChange,
	                onSubmit = _props2.onSubmit,
	                other = _objectWithoutProperties(_props2, ['children', 'display', 'identify', 'multi', 'disabled', 'label', 'value', 'onChange', 'onSubmit']);
	
	            var opened = this.state.opened;
	            var _refs = this.refs,
	                bodyContainer = _refs.bodyContainer,
	                openIcon = _refs.openIcon;
	
	
	            var buttonDisabled = typeof disabled == 'function' && disabled || function () {
	                return disabled;
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TagBar2.default.default },
	                _react2.default.createElement(
	                    'ul',
	                    {
	                        className: _TagBar2.default.tagGroup,
	                        ref: 'bodyContainer' },
	                    multi && value && value.map(function (tag, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            {
	                                key: identify(tag) },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    disabled: buttonDisabled(tag, index),
	                                    onClick: function onClick() {
	                                        return _this2._remove(tag);
	                                    } },
	                                display(tag, index, value)
	                            )
	                        );
	                    }),
	                    !multi && value && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: buttonDisabled(value),
	                                onClick: function onClick() {
	                                    return _this2._remove(value);
	                                } },
	                            display(value)
	                        )
	                    ),
	                    (multi || !value) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: disabled == true,
	                                onClick: function onClick(e) {
	                                    return _this2._open(e);
	                                } },
	                            _react2.default.createElement(_Icon2.default, {
	                                ref: 'openIcon',
	                                icon: 'plus',
	                                size: 'md' }),
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                label
	                            )
	                        )
	                    )
	                ),
	                (multi || !value) && _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(openIcon);
	                        },
	                        placement: 'bottom',
	                        show: opened,
	                        container: bodyContainer,
	                        onHide: function onHide(e) {
	                            return _this2._close(e);
	                        } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Popover,
	                        {
	                            style: { width: '100%' } },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TagBar;
	}(_react.Component);
	
	TagBar.propTypes = {
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    multi: _react.PropTypes.bool,
	    disabled: _react.PropTypes.any,
	    label: _react.PropTypes.string,
	    value: _react.PropTypes.any,
	    onChange: _react.PropTypes.func,
	    onSubmit: _react.PropTypes.func
	};
	TagBar.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    }
	};
	exports.default = TagBar;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimePicker = __webpack_require__(2225);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function range(length) {
	    var array = [];
	    for (var i = 0; i < length; i++) {
	        array[i] = i;
	    }
	    return array;
	}
	
	function today() {
	    var date = new Date();
	    date.setHours(0);
	    date.setMinutes(0);
	    date.setSeconds(0);
	    date.setMilliseconds(0);
	    return date;
	}
	
	function validHours(hours, defaultHours) {
	    if (isNaN(hours)) return 0;
	    if (hours < 24) return hours;
	    return defaultHours;
	}
	
	function validMinutes(minutes, defaultMinutes) {
	    if (isNaN(minutes)) return 0;
	    if (minutes < 60) return minutes;
	    return defaultMinutes;
	}
	
	var TimePicker = function (_Component) {
	    _inherits(TimePicker, _Component);
	
	    function TimePicker() {
	        _classCallCheck(this, TimePicker);
	
	        return _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).apply(this, arguments));
	    }
	
	    _createClass(TimePicker, [{
	        key: '_selectHours',
	        value: function _selectHours(event) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange;
	
	
	            var previousValue = value || today();
	            var hours = parseInt(event.target.value);
	            var nextHours = validHours(hours, previousValue.getHours());
	            var nextValue = new Date(previousValue.getFullYear(), previousValue.getMonth(), previousValue.getDate(), nextHours, previousValue.getMinutes());
	
	            this._blancHours = isNaN(hours);
	            onChange(nextValue);
	        }
	    }, {
	        key: '_selectMinutes',
	        value: function _selectMinutes(event) {
	            var _props2 = this.props,
	                value = _props2.value,
	                onChange = _props2.onChange;
	
	
	            var previousValue = value || today();
	            var minutes = parseInt(event.target.value);
	            var nextMinutes = validMinutes(minutes, previousValue.getMinutes());
	            var nextValue = new Date(previousValue.getFullYear(), previousValue.getMonth(), previousValue.getDate(), previousValue.getHours(), nextMinutes);
	
	            this._blancMinutes = isNaN(minutes);
	            onChange(nextValue);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                typing = _props3.typing,
	                value = _props3.value;
	
	
	            var displayHours = function displayHours() {
	                if (_this2._blancHours) return null;
	                return value && value.getHours();
	            };
	
	            var displayMinutes = function displayMinutes() {
	                if (_this2._blancMinutes) return null;
	                return value && value.getMinutes();
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TimePicker2.default.default },
	                typing && _react2.default.createElement('input', {
	                    className: 'form-control',
	                    placeholder: 'heure',
	                    value: displayHours(),
	                    onChange: function onChange(e) {
	                        return _this2._selectHours(e);
	                    } }),
	                !typing && _react2.default.createElement(
	                    'select',
	                    {
	                        className: 'form-control',
	                        value: displayHours() || '',
	                        onChange: function onChange(e) {
	                            return _this2._selectHours(e);
	                        } },
	                    !value && _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'heure'
	                    ),
	                    range(24).map(function (v, i) {
	                        return _react2.default.createElement(
	                            'option',
	                            {
	                                key: i,
	                                value: v },
	                            v
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    ' : '
	                ),
	                typing && _react2.default.createElement('input', {
	                    className: 'form-control',
	                    placeholder: 'minutes',
	                    value: displayMinutes(),
	                    onChange: function onChange(e) {
	                        return _this2._selectMinutes(e);
	                    } }),
	                !typing && _react2.default.createElement(
	                    'select',
	                    {
	                        className: 'form-control',
	                        value: displayMinutes() || '',
	                        onChange: function onChange(e) {
	                            return _this2._selectMinutes(e);
	                        } },
	                    !value && _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        'minutes'
	                    ),
	                    range(12).map(function (v, i) {
	                        return _react2.default.createElement(
	                            'option',
	                            {
	                                key: i,
	                                value: v * 5 },
	                            v * 5
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TimePicker;
	}(_react.Component);
	
	TimePicker.propTypes = {
	    typing: _react.PropTypes.bool,
	    value: _react.PropTypes.object,
	    onChange: _react.PropTypes.func.isRequired
	};
	exports.default = TimePicker;

/***/ }),
/* 958 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.streamMatcher = streamMatcher;
	
	exports.default = function (_ref2) {
	    var source = _ref2.source,
	        _ref2$identify = _ref2.identify,
	        identify = _ref2$identify === undefined ? function (v) {
	        return v;
	    } : _ref2$identify;
	
	    return function (q, cb) {
	        var matches;
	
	        if (q) {
	            var regexp = new RegExp(escapeRegExp(q), 'i');
	            matches = source.filter(function (value) {
	                return regexp.test(identify(value));
	            });
	        } else {
	            matches = source;
	        }
	
	        cb(matches);
	    };
	};
	
	function escapeRegExp(value) {
	    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	function isSameQuery(query, q) {
	    if (!q && query && !query.fullText) return true;
	    if (q && query && q == query.fullText) return true;
	    return false;
	}
	
	function isSubQuery(query, q) {
	    if (!q && query && !query.fullText) return true;
	    if (q && query && q.startsWith(query.fullText)) return true;
	    return false;
	}
	
	function isFullRange(range) {
	    if (range && range.count == 0 || range.limit == range.count - 1) return true;
	    return false;
	}
	
	function streamMatcher(_ref) {
	    var stream = _ref.stream,
	        range = _ref.range,
	        query = _ref.query,
	        _ref$identify = _ref.identify,
	        identify = _ref$identify === undefined ? function (v) {
	        return v;
	    } : _ref$identify,
	        load = _ref.load;
	
	    var loading = false;
	
	    return function (q, cb) {
	        if (loading) {
	            // skip
	        } else if (!isSubQuery(query, q) || !isSameQuery(query, q) && !isFullRange(range)) {
	            loading = true;
	            load(q);
	            // skip
	        } else if (!q) {
	            var matches = stream;
	            cb(matches);
	        } else {
	            var regexp = new RegExp(escapeRegExp(q), 'i');
	            var _matches = stream.filter(function (value) {
	                return regexp.test(identify(value));
	            });
	            cb(_matches);
	        }
	    };
	}

/***/ }),
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.control = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function control(options) {
	    var defaultValue = options.value;
	
	    return function (Component) {
	        var ControlConnector = function (_React$Component) {
	            _inherits(ControlConnector, _React$Component);
	
	            function ControlConnector(props) {
	                _classCallCheck(this, ControlConnector);
	
	                var _this = _possibleConstructorReturn(this, (ControlConnector.__proto__ || Object.getPrototypeOf(ControlConnector)).call(this, props));
	
	                _this.state = {
	                    value: props.value || defaultValue
	                };
	                return _this;
	            }
	
	            _createClass(ControlConnector, [{
	                key: 'componentWillReceiveProps',
	                value: function componentWillReceiveProps(nextProps) {
	                    if (nextProps.value != this.props.value) {
	                        this.setState({
	                            value: nextProps.value || defaultValue
	                        });
	                    }
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    return _react2.default.createElement(Component, _extends({}, this.props, this.state));
	                }
	            }]);
	
	            return ControlConnector;
	        }(_react2.default.Component);
	
	        return ControlConnector;
	    };
	}
	
	exports.control = control;

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.progressReducer = progressReducer;
	exports.progressMiddleware = progressMiddleware;
	exports.default = progress;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NAMESPACE = 'Core';
	var PROGRESS = exports.PROGRESS = NAMESPACE + '/Progress';
	
	function progressReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case PROGRESS:
	            if (action.progress == 1) {
	                var nextState = _extends({}, state);
	                delete nextState[action.name];
	                return nextState;
	            }
	            return _extends({}, state, _defineProperty({}, action.name, action.progress));
	        default:
	            return state;
	    }
	}
	
	// middleware
	
	function progressMiddleware(_ref) {
	    var dispatch = _ref.dispatch;
	
	    return function (next) {
	        return function (action) {
	            if (action.worker) {
	                var worker = next(action.worker);
	
	                worker.addEventListener('message', function (event) {
	                    if (event.data.error) {
	                        dispatch({
	                            type: PROGRESS,
	                            name: action.name,
	                            progress: 1
	                        });
	                    } else if (event.data.progress) {
	                        dispatch({
	                            type: PROGRESS,
	                            name: action.name,
	                            progress: event.data.progress
	                        });
	                    }
	                });
	                worker.addEventListener('error', function (event) {
	                    dispatch({
	                        type: PROGRESS,
	                        name: action.name,
	                        progress: 1
	                    });
	                });
	
	                return worker;
	            }
	            return next(action);
	        };
	    };
	}
	
	// action
	
	function progress(worker, name) {
	    return { worker: worker, name: name };
	}

/***/ }),
/* 966 */,
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _distance = __webpack_require__(1092);
	
	var _distance2 = _interopRequireDefault(_distance);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _links = __webpack_require__(33);
	
	var _momentz = __webpack_require__(186);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StaticMap = __webpack_require__(510);
	
	var _StaticMap2 = _interopRequireDefault(_StaticMap);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DefineUpdateInterventionPeriodForActivityForm = __webpack_require__(1101);
	
	var _DefineUpdateInterventionPeriodForActivityForm2 = _interopRequireDefault(_DefineUpdateInterventionPeriodForActivityForm);
	
	var _DefineRemoveInterventionZoneFromInterventionPeriodForm = __webpack_require__(1430);
	
	var _DefineRemoveInterventionZoneFromInterventionPeriodForm2 = _interopRequireDefault(_DefineRemoveInterventionZoneFromInterventionPeriodForm);
	
	var _DefineRemoveServiceChargeFromInterventionPeriodForm = __webpack_require__(1432);
	
	var _DefineRemoveServiceChargeFromInterventionPeriodForm2 = _interopRequireDefault(_DefineRemoveServiceChargeFromInterventionPeriodForm);
	
	var _DefineRemoveCallOutChargesFromInterventionPeriodForm = __webpack_require__(1428);
	
	var _DefineRemoveCallOutChargesFromInterventionPeriodForm2 = _interopRequireDefault(_DefineRemoveCallOutChargesFromInterventionPeriodForm);
	
	var _SubscribeProviderCompanyToDirectoryForInterventionPeriodForm = __webpack_require__(1455);
	
	var _SubscribeProviderCompanyToDirectoryForInterventionPeriodForm2 = _interopRequireDefault(_SubscribeProviderCompanyToDirectoryForInterventionPeriodForm);
	
	var _DefineRemoveRepairTimelimitFromInterventionPeriodForm = __webpack_require__(1431);
	
	var _DefineRemoveRepairTimelimitFromInterventionPeriodForm2 = _interopRequireDefault(_DefineRemoveRepairTimelimitFromInterventionPeriodForm);
	
	var _DefineRemoveInterventionTimelimitFromInterventionPeriodForm = __webpack_require__(1429);
	
	var _DefineRemoveInterventionTimelimitFromInterventionPeriodForm2 = _interopRequireDefault(_DefineRemoveInterventionTimelimitFromInterventionPeriodForm);
	
	var _ExcludeOpeningTicketPurposesFromInterventionPeriodForm = __webpack_require__(1433);
	
	var _ExcludeOpeningTicketPurposesFromInterventionPeriodForm2 = _interopRequireDefault(_ExcludeOpeningTicketPurposesFromInterventionPeriodForm);
	
	var _UpdateInterventionPeriodPanel = __webpack_require__(2290);
	
	var _UpdateInterventionPeriodPanel2 = _interopRequireDefault(_UpdateInterventionPeriodPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function computeServiceCharge(interventionPeriod, referenceInterventionPeriod) {
	    if (interventionPeriod.serviceCharge && interventionPeriod.serviceCharge.chargeType == 'ChargePercentage') {
	        if (referenceInterventionPeriod && referenceInterventionPeriod.serviceCharge) {
	            return _extends({}, referenceInterventionPeriod.serviceCharge, {
	                value: Math.round(interventionPeriod.serviceCharge.value * referenceInterventionPeriod.serviceCharge.value * 100) / 100
	            });
	        }
	
	        console && console.log('interventionPeriod "' + interventionPeriod.uid + '" has a ChargePercentage serviceCharge with no reference defined');
	        return null;
	    }
	    return interventionPeriod.serviceCharge;
	}
	
	function openingTicketPurposeFilter(openingTicketPurpose) {
	    if (openingTicketPurpose) {
	        return function (openingTicketPurposeUid) {
	            return openingTicketPurposeUid == (openingTicketPurpose.uid || openingTicketPurpose);
	        };
	    }
	
	    return function (openingTicketPurposeUid) {
	        return true;
	    };
	}
	
	function openingTicketPurposeLabelAggregator(openingTicketPurposes) {
	    return function (result, openingTicketPurposeUid) {
	        var openingTicketPurpose = openingTicketPurposes.find(function (otp) {
	            return otp.uid == openingTicketPurposeUid;
	        });
	
	        if (openingTicketPurpose) {
	            result.push(openingTicketPurpose.label);
	        }
	        return result;
	    };
	}
	
	function timeLimitFilter(openingTicketPurpose) {
	    if (openingTicketPurpose) {
	        return function (timelimit) {
	            return timelimit.openingTicketPurposes.find(function (openingTicketPurposeUid) {
	                return openingTicketPurposeUid == (openingTicketPurpose.uid || openingTicketPurpose);
	            });
	        };
	    }
	
	    return function (timelimit) {
	        return true;
	    };
	}
	
	function timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference) {
	    return function (result, timelimit) {
	        timelimit.openingTicketPurposes.forEach(function (openingTicketPurposeUid) {
	            var openingTicketPurpose = openingTicketPurposeReference.openingTicketPurposes.find(function (otp) {
	                return otp.uid == openingTicketPurposeUid;
	            });
	
	            if (openingTicketPurpose) {
	                result.push(openingTicketPurpose);
	            } else {
	                console && console.warn('openingTicketPurpose "' + openingTicketPurposeUid + '" doesn\'t exist in referentiel');
	            }
	        });
	        return result;
	    };
	}
	
	function excludedOpeningTicketPurposeFilter(excludedIds) {
	    return function (openingTicketPurpose) {
	        return excludedIds.indexOf(openingTicketPurpose.uid) < 0;
	    };
	}
	
	function weekDaysFilter(weekDays) {
	    return function (weekDay) {
	        return weekDays.indexOf(weekDay) >= 0;
	    };
	}
	
	var UpdateInterventionPeriodPanel = function (_Component) {
	    _inherits(UpdateInterventionPeriodPanel, _Component);
	
	    function UpdateInterventionPeriodPanel(props) {
	        _classCallCheck(this, UpdateInterventionPeriodPanel);
	
	        var _this = _possibleConstructorReturn(this, (UpdateInterventionPeriodPanel.__proto__ || Object.getPrototypeOf(UpdateInterventionPeriodPanel)).call(this, props));
	
	        _this.state = {
	            repairOpeningTicketPurposes: [],
	            interventionOpeningTicketPurposes: []
	        };
	        return _this;
	    }
	
	    _createClass(UpdateInterventionPeriodPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                expanded = _props.expanded,
	                interventionPeriod = _props.interventionPeriod,
	                referenceInterventionPeriod = _props.referenceInterventionPeriod,
	                incidentTypes = _props.incidentTypes,
	                openingTicketPurposeReference = _props.openingTicketPurposeReference;
	
	
	            if (expanded) {
	                var serviceCharge = computeServiceCharge(interventionPeriod, referenceInterventionPeriod);
	                var includedOpeningTicketPurposes = incidentTypes && incidentTypes.filter(excludedOpeningTicketPurposeFilter(interventionPeriod.excludedOpeningTicketPurposes)) || [];
	                var onlyRepairOpeningTicketPurposes = interventionPeriod.repairTimelimits && interventionPeriod.repairTimelimits.reduce(timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference), []) || [];
	                var repairOpeningTicketPurposes = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(includedOpeningTicketPurposes), _toConsumableArray(onlyRepairOpeningTicketPurposes)))));
	                var onlyInterventionOpeningTicketPurposes = interventionPeriod.interventionTimelimits && interventionPeriod.interventionTimelimits.reduce(timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference), []) || [];
	                var interventionOpeningTicketPurposes = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(includedOpeningTicketPurposes), _toConsumableArray(onlyInterventionOpeningTicketPurposes)))));
	                this.setState({ serviceCharge: serviceCharge, repairOpeningTicketPurposes: repairOpeningTicketPurposes, interventionOpeningTicketPurposes: interventionOpeningTicketPurposes });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.expanded != this.props.expanded || nextProps.interventionPeriod != this.props.interventionPeriod || nextProps.referenceInterventionPeriod != this.props.referenceInterventionPeriod || nextProps.incidentTypes != this.props.incidentTypes || nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference) {
	                var expanded = nextProps.expanded,
	                    interventionPeriod = nextProps.interventionPeriod,
	                    referenceInterventionPeriod = nextProps.referenceInterventionPeriod,
	                    incidentTypes = nextProps.incidentTypes,
	                    openingTicketPurposeReference = nextProps.openingTicketPurposeReference;
	
	
	                if (expanded) {
	                    var serviceCharge = computeServiceCharge(interventionPeriod, referenceInterventionPeriod);
	                    var includedOpeningTicketPurposes = incidentTypes && incidentTypes.filter(excludedOpeningTicketPurposeFilter(interventionPeriod.excludedOpeningTicketPurposes)) || [];
	                    var onlyRepairOpeningTicketPurposes = interventionPeriod.repairTimelimits && interventionPeriod.repairTimelimits.reduce(timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference), []) || [];
	                    var repairOpeningTicketPurposes = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(includedOpeningTicketPurposes), _toConsumableArray(onlyRepairOpeningTicketPurposes)))));
	                    var onlyInterventionOpeningTicketPurposes = interventionPeriod.interventionTimelimits && interventionPeriod.interventionTimelimits.reduce(timelimitOpeningTicketPurposeAggregator(openingTicketPurposeReference), []) || [];
	                    var interventionOpeningTicketPurposes = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(includedOpeningTicketPurposes), _toConsumableArray(onlyInterventionOpeningTicketPurposes)))));
	                    this.setState({ serviceCharge: serviceCharge, repairOpeningTicketPurposes: repairOpeningTicketPurposes, interventionOpeningTicketPurposes: interventionOpeningTicketPurposes });
	                }
	            }
	
	            if (nextProps.expanded != this.props.expanded) {
	                var _expanded = nextProps.expanded;
	
	
	                if (!_expanded) {
	                    this.setState({ openedForm: null });
	                }
	            }
	        }
	    }, {
	        key: '_isOpeningTicketPurposeExcluded',
	        value: function _isOpeningTicketPurposeExcluded(openingTicketPurpose) {
	            var interventionPeriod = this.props.interventionPeriod;
	
	            return interventionPeriod.excludedOpeningTicketPurposes.indexOf(openingTicketPurpose.uid) >= 0;
	        }
	    }, {
	        key: '_toggleForm',
	        value: function _toggleForm(name) {
	            var openedForm = this.state.openedForm;
	
	
	            var nextOpenedForm = openedForm != name && name || null;
	            this.setState({ openedForm: nextOpenedForm });
	        }
	    }, {
	        key: '_closeForm',
	        value: function _closeForm() {
	            this.setState({ openedForm: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                committed = _props2.committed,
	                activity = _props2.activity,
	                interventionPeriod = _props2.interventionPeriod,
	                referenceInterventionPeriod = _props2.referenceInterventionPeriod,
	                incidentTypes = _props2.incidentTypes,
	                incidentType = _props2.incidentType,
	                openingTicketPurposeReference = _props2.openingTicketPurposeReference,
	                patrimony = _props2.patrimony,
	                bsStyle = _props2.bsStyle,
	                onSelect = _props2.onSelect,
	                onSubmit = _props2.onSubmit,
	                others = _objectWithoutProperties(_props2, ['committed', 'activity', 'interventionPeriod', 'referenceInterventionPeriod', 'incidentTypes', 'incidentType', 'openingTicketPurposeReference', 'patrimony', 'bsStyle', 'onSelect', 'onSubmit']);
	
	            var _state = this.state,
	                serviceCharge = _state.serviceCharge,
	                repairOpeningTicketPurposes = _state.repairOpeningTicketPurposes,
	                interventionOpeningTicketPurposes = _state.interventionOpeningTicketPurposes,
	                openedForm = _state.openedForm;
	
	
	            var header = _react2.default.createElement(
	                'div',
	                { className: _UpdateInterventionPeriodPanel2.default.header },
	                _react2.default.createElement(
	                    'h5',
	                    { className: _UpdateInterventionPeriodPanel2.default.headerContent },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        interventionPeriod.period.label
	                    ),
	                    _models.InterventionPeriod.isExpired(interventionPeriod) && _react2.default.createElement(
	                        'small',
	                        null,
	                        ' (',
	                        _i18n2.default.expired,
	                        ')'
	                    )
	                )
	            );
	
	            var formatTimeSlot = function formatTimeSlot(timeSlot) {
	                if (timeSlot.periods) {
	                    return timeSlot.periods.map(function (period) {
	                        return (0, _moment2.default)(period.start, 'HH:mm:ss').format(_i18n2.default.timeFormat.from) + ' ' + (0, _moment2.default)(period.end, 'HH:mm:ss').format(_i18n2.default.timeFormat.to);
	                    }).join(', ');
	                }
	                return _i18n2.default.timeSlotTypeEnum.allDayLong;
	            };
	
	            var incidentTypeElement = function incidentTypeElement(incidentType) {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        key: incidentType.uid,
	                        className: (0, _classnames2.default)(_defineProperty({}, _UpdateInterventionPeriodPanel2.default.excluded, _this2._isOpeningTicketPurposeExcluded(incidentType))) },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        incidentType.label
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Panel,
	                _extends({
	                    header: header,
	                    bsStyle: interventionPeriod.reference && 'info' || 'default',
	                    onSelect: onSelect
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _UpdateInterventionPeriodPanel2.default.defaultContent },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.period
	                            ),
	                            committed && committed._links.find((0, _links.linkFinder)(['UpdateInterventionPeriodForActivity', 'UpdateInterventionPeriod'])) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return _this2._toggleForm('DefineUpdateInterventionPeriodForActivityForm');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        ),
	                        openedForm != 'DefineUpdateInterventionPeriodForActivityForm' && _react2.default.createElement(
	                            'div',
	                            null,
	                            interventionPeriod.period.periodRanges && interventionPeriod.period.periodRanges.map(function (periodRange, index) {
	                                return _react2.default.createElement(
	                                    'p',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _models.WEEK_DAYS.filter(weekDaysFilter(periodRange.weekDays)).map(function (wd) {
	                                            return _moment2.default.weekdays(_models.WEEK_DAYS.indexOf(wd));
	                                        }).join(', ')
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        formatTimeSlot(periodRange.timeSlot)
	                                    )
	                                );
	                            }),
	                            interventionPeriod.period.exclusions && interventionPeriod.period.exclusions.map(function (exclusion, index) {
	                                return _react2.default.createElement(
	                                    'p',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'sauf'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        exclusion.days.map(function (d) {
	                                            return (0, _moment2.default)(d).format(_i18n2.default.dateFormat.longer);
	                                        }).join(', ')
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        formatTimeSlot(exclusion.timeSlot)
	                                    )
	                                );
	                            }),
	                            interventionPeriod.period.days && interventionPeriod.period.timeSlot && _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    interventionPeriod.period.days.map(function (d) {
	                                        return (0, _moment2.default)(d).format(_i18n2.default.dateFormat.longer);
	                                    }).join(', ')
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    formatTimeSlot(interventionPeriod.period.timeSlot)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    interventionPeriod.period.startDate && (0, _moment2.default)(interventionPeriod.period.startDate).format(_i18n2.default.dateFormat.from)
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    interventionPeriod.period.endDate && (0, _moment2.default)(interventionPeriod.period.endDate).format(_i18n2.default.dateFormat.to)
	                                )
	                            )
	                        ),
	                        openedForm == 'DefineUpdateInterventionPeriodForActivityForm' && _react2.default.createElement(_DefineUpdateInterventionPeriodForActivityForm2.default, {
	                            committed: committed,
	                            activity: activity,
	                            interventionPeriod: interventionPeriod,
	                            onSubmit: function onSubmit() {
	                                return _this2._closeForm();
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UpdateInterventionPeriodPanel2.default.interventionZone },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.interventionZone
	                            ),
	                            committed && committed._links.find((0, _links.linkFinder)('DefineInterventionZoneForInterventionPeriod')) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return _this2._toggleForm('DefineRemoveInterventionZoneFromInterventionPeriodForm');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        ),
	                        openedForm != 'DefineRemoveInterventionZoneFromInterventionPeriodForm' && interventionPeriod.interventionZone && _react2.default.createElement(
	                            'div',
	                            { className: _UpdateInterventionPeriodPanel2.default.container },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _UpdateInterventionPeriodPanel2.default.map },
	                                _react2.default.createElement(_StaticMap2.default, {
	                                    apiKey: _config2.default.google.apiKey,
	                                    ratio: 16 / 9,
	                                    path: (0, _StaticMap.circlePath)(interventionPeriod.interventionZone.address.geoLocation, interventionPeriod.interventionZone.range.value),
	                                    identify: function identify(a) {
	                                        return a.geoLocation;
	                                    },
	                                    value: patrimony && [].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses)) || [] })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _UpdateInterventionPeriodPanel2.default.side },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    interventionPeriod.interventionZone.address.quality
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    interventionPeriod.interventionZone.address.number,
	                                    ' ',
	                                    interventionPeriod.interventionZone.address.street
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    interventionPeriod.interventionZone.address.zipCode,
	                                    ' ',
	                                    interventionPeriod.interventionZone.address.city
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'distance : ',
	                                    (0, _distance2.default)(interventionPeriod.interventionZone.range.value).format('km')
	                                )
	                            )
	                        ),
	                        committed && committed._links.find((0, _links.linkFinder)('DefineInterventionZoneForInterventionPeriod')) && openedForm == 'DefineRemoveInterventionZoneFromInterventionPeriodForm' && _react2.default.createElement(_DefineRemoveInterventionZoneFromInterventionPeriodForm2.default, {
	                            committed: committed,
	                            activity: activity,
	                            interventionPeriod: interventionPeriod,
	                            onSubmit: function onSubmit() {
	                                return _this2._closeForm();
	                            } })
	                    ),
	                    (committed && committed._links.find((0, _links.linkFinder)('DefineServiceChargeForInterventionPeriod')) || serviceCharge) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.serviceCharge
	                            ),
	                            committed && committed._links.find((0, _links.linkFinder)('DefineServiceChargeForInterventionPeriod')) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return _this2._toggleForm('DefineRemoveServiceChargeFromInterventionPeriodForm');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        ),
	                        openedForm != 'DefineRemoveServiceChargeFromInterventionPeriodForm' && serviceCharge && _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                serviceCharge.value,
	                                ' ',
	                                (0, _extract2.default)(_i18n2.default.currencyEnum, serviceCharge.currency)
	                            ),
	                            interventionPeriod.serviceCharge.chargeType == 'ChargePercentage' && _react2.default.createElement(
	                                'span',
	                                null,
	                                ' (',
	                                (0, _extract.replace)(_i18n2.default.percentageServiceChargeInfo, { percentage: interventionPeriod.serviceCharge.value * 100 }),
	                                ')'
	                            )
	                        ),
	                        committed && committed._links.find((0, _links.linkFinder)('DefineServiceChargeForInterventionPeriod')) && openedForm == 'DefineRemoveServiceChargeFromInterventionPeriodForm' && _react2.default.createElement(_DefineRemoveServiceChargeFromInterventionPeriodForm2.default, {
	                            activity: activity,
	                            interventionPeriod: interventionPeriod,
	                            onSubmit: function onSubmit() {
	                                return _this2._closeForm();
	                            } })
	                    ),
	                    (committed && committed._links.find((0, _links.linkFinder)('DefineCallOutChargesForInterventionPeriod')) || interventionPeriod.callOutCharges) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.callOutCharge
	                            ),
	                            committed && committed._links.find((0, _links.linkFinder)('DefineCallOutChargesForInterventionPeriod')) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return _this2._toggleForm('DefineRemoveCallOutChargesFromInterventionPeriodForm');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        ),
	                        openedForm != 'DefineRemoveCallOutChargesFromInterventionPeriodForm' && interventionPeriod.callOutCharges.map(function (callOutCharge, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                {
	                                    key: index },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    (0, _extract.replace)(_i18n2.default.distanceFromTo, { from: (0, _distance2.default)(callOutCharge.range.start).format('km'), to: (0, _distance2.default)(callOutCharge.range.end).format('km') })
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' : ',
	                                    callOutCharge.charge.value,
	                                    ' ',
	                                    (0, _extract2.default)(_i18n2.default.currencyEnum, callOutCharge.charge.currency)
	                                )
	                            );
	                        }),
	                        committed && committed._links.find((0, _links.linkFinder)('DefineCallOutChargesForInterventionPeriod')) && openedForm == 'DefineRemoveCallOutChargesFromInterventionPeriodForm' && _react2.default.createElement(_DefineRemoveCallOutChargesFromInterventionPeriodForm2.default, {
	                            activity: activity,
	                            interventionPeriod: interventionPeriod,
	                            onSubmit: function onSubmit() {
	                                return _this2._closeForm();
	                            } })
	                    ),
	                    (committed && committed._links.find((0, _links.linkFinder)('SubscribeProviderCompanyToDirectoryForInterventionPeriod')) || interventionPeriod.subscriptions) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.subscription
	                            ),
	                            committed && committed._links.find((0, _links.linkFinder)('SubscribeProviderCompanyToDirectoryForInterventionPeriod')) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return _this2._toggleForm('SubscribeProviderCompanyToDirectoryForInterventionPeriodForm');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        ),
	                        openedForm != 'SubscribeProviderCompanyToDirectoryForInterventionPeriodForm' && interventionPeriod.subscriptions.map(function (subscription, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                {
	                                    key: index },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    (0, _extract2.default)(_i18n2.default.forWhoEnum, subscription.forWho),
	                                    ' :'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    subscription.forWhat.map(function (w) {
	                                        return (0, _extract2.default)(_i18n2.default.forWhatEnum, w);
	                                    }).join(', ')
	                                )
	                            );
	                        }),
	                        committed && committed._links.find((0, _links.linkFinder)('SubscribeProviderCompanyToDirectoryForInterventionPeriod')) && openedForm == 'SubscribeProviderCompanyToDirectoryForInterventionPeriodForm' && _react2.default.createElement(_SubscribeProviderCompanyToDirectoryForInterventionPeriodForm2.default, {
	                            activity: activity,
	                            interventionPeriod: interventionPeriod,
	                            onSubmit: function onSubmit() {
	                                return _this2._closeForm();
	                            } })
	                    ),
	                    (committed && committed._links.find((0, _links.linkFinder)('DefineRepairTimelimitForInterventionPeriod')) || interventionPeriod.repairTimelimits) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.repairTimelimit
	                            ),
	                            committed && committed._links.find((0, _links.linkFinder)('DefineRepairTimelimitForInterventionPeriod')) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return _this2._toggleForm('DefineRemoveRepairTimelimitFromInterventionPeriodForm');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        ),
	                        openedForm != 'DefineRemoveRepairTimelimitFromInterventionPeriodForm' && interventionPeriod.repairTimelimits.filter(timeLimitFilter(incidentType)).map(function (repairTimelimit, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                {
	                                    key: index },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    repairTimelimit.openingTicketPurposes.filter(openingTicketPurposeFilter(incidentType)).reduce(openingTicketPurposeLabelAggregator(repairOpeningTicketPurposes), []).join(', '),
	                                    ' :'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    (0, _momentz.humanize)(_moment2.default.duration(repairTimelimit.timelimit.value))
	                                )
	                            );
	                        }),
	                        committed && committed._links.find((0, _links.linkFinder)('DefineRepairTimelimitForInterventionPeriod')) && openedForm == 'DefineRemoveRepairTimelimitFromInterventionPeriodForm' && _react2.default.createElement(_DefineRemoveRepairTimelimitFromInterventionPeriodForm2.default, {
	                            interventionPeriod: interventionPeriod,
	                            openingTicketPurposes: repairOpeningTicketPurposes,
	                            onSubmit: function onSubmit() {
	                                return _this2._closeForm();
	                            } })
	                    ),
	                    (committed && committed._links.find((0, _links.linkFinder)('DefineInterventionTimelimitForInterventionPeriod')) || interventionPeriod.interventionTimelimits) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.interventionTimelimit
	                            ),
	                            committed && committed._links.find((0, _links.linkFinder)('DefineInterventionTimelimitForInterventionPeriod')) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return _this2._toggleForm('DefineRemoveInterventionTimelimitFromInterventionPeriodForm');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        ),
	                        openedForm != 'DefineRemoveInterventionTimelimitFromInterventionPeriodForm' && interventionPeriod.interventionTimelimits.filter(timeLimitFilter(incidentType)).map(function (interventionTimelimit, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                {
	                                    key: index },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    interventionTimelimit.openingTicketPurposes.filter(openingTicketPurposeFilter(incidentType)).reduce(openingTicketPurposeLabelAggregator(interventionOpeningTicketPurposes), []).join(', '),
	                                    ' :'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    (0, _momentz.humanize)(_moment2.default.duration(interventionTimelimit.timelimit.value))
	                                )
	                            );
	                        }),
	                        committed && committed._links.find((0, _links.linkFinder)('DefineInterventionTimelimitForInterventionPeriod')) && openedForm == 'DefineRemoveInterventionTimelimitFromInterventionPeriodForm' && _react2.default.createElement(_DefineRemoveInterventionTimelimitFromInterventionPeriodForm2.default, {
	                            interventionPeriod: interventionPeriod,
	                            openingTicketPurposes: interventionOpeningTicketPurposes,
	                            onSubmit: function onSubmit() {
	                                return _this2._closeForm();
	                            } })
	                    ),
	                    (committed && committed._links.find((0, _links.linkFinder)('ExcludeOpeningTicketPurposesFromInterventionPeriod')) || interventionPeriod.excludedOpeningTicketPurposes) && incidentTypes && _react2.default.createElement(
	                        'div',
	                        { className: _UpdateInterventionPeriodPanel2.default.openingTicketPurposes },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.openingTicketPurposes
	                            ),
	                            committed && committed._links.find((0, _links.linkFinder)('ExcludeOpeningTicketPurposesFromInterventionPeriod')) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return _this2._toggleForm('ExcludeOpeningTicketPurposesFromInterventionPeriodForm');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        ),
	                        openedForm != 'ExcludeOpeningTicketPurposesFromInterventionPeriodForm' && _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    incidentTypes.slice(0, incidentTypes.length / 2 + 1).map(incidentTypeElement)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    incidentTypes.slice(incidentTypes.length / 2 + 1, incidentTypes.length).map(incidentTypeElement)
	                                )
	                            )
	                        ),
	                        committed && committed._links.find((0, _links.linkFinder)('ExcludeOpeningTicketPurposesFromInterventionPeriod')) && openedForm == 'ExcludeOpeningTicketPurposesFromInterventionPeriodForm' && _react2.default.createElement(_ExcludeOpeningTicketPurposesFromInterventionPeriodForm2.default, {
	                            interventionPeriod: interventionPeriod,
	                            openingTicketPurposes: incidentTypes,
	                            onSubmit: function onSubmit() {
	                                return _this2._closeForm();
	                            } })
	                    ),
	                    committed && committed._links.find((0, _links.linkFinder)('RemoveInterventionPeriod')) && _react2.default.createElement(
	                        'div',
	                        { className: _UpdateInterventionPeriodPanel2.default.delete },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'RemoveInterventionPeriod', interventionPeriod);
	                                } },
	                            _i18n2.default.removeInterventionPeriod,
	                            ' ...'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateInterventionPeriodPanel;
	}(_react.Component);
	
	UpdateInterventionPeriodPanel.propTypes = {
	    committed: _react.PropTypes.object,
	    activity: _react.PropTypes.object,
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    referenceInterventionPeriod: _react.PropTypes.object,
	    incidentTypes: _react.PropTypes.array,
	    incidentType: _react.PropTypes.any,
	    openingTicketPurposeReference: _react.PropTypes.object.isRequired,
	    patrimony: _react.PropTypes.object,
	    onSubmit: _react.PropTypes.func
	};
	exports.default = UpdateInterventionPeriodPanel;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _places = __webpack_require__(261);
	
	var _loading = __webpack_require__(58);
	
	var _form = __webpack_require__(15);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _StaticMap = __webpack_require__(510);
	
	var _StaticMap2 = _interopRequireDefault(_StaticMap);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _PatrimonyPicker = __webpack_require__(548);
	
	var _PatrimonyPicker2 = _interopRequireDefault(_PatrimonyPicker);
	
	var _AgencyPicker = __webpack_require__(1309);
	
	var _AgencyPicker2 = _interopRequireDefault(_AgencyPicker);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OpenTicketAddressCard = __webpack_require__(2322);
	
	var _OpenTicketAddressCard2 = _interopRequireDefault(_OpenTicketAddressCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GEO_LOCATION_DISTANCE = 500;
	
	function provideFullAutocompleteMatcher(address) {
	    var input = address && address.zipCode + ' ' + address.city;
	    return (0, _places.provideAutocompleteMatcher)({ input: input });
	}
	
	var OpenTicketAddressCard = function (_Component) {
	    _inherits(OpenTicketAddressCard, _Component);
	
	    function OpenTicketAddressCard(props) {
	        _classCallCheck(this, OpenTicketAddressCard);
	
	        var _this = _possibleConstructorReturn(this, (OpenTicketAddressCard.__proto__ || Object.getPrototypeOf(OpenTicketAddressCard)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(OpenTicketAddressCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var cmd = this.props.cmd;
	
	
	            var address = cmd && cmd.ticket && cmd.ticket.address;
	            var zipCode = address && address.zipCode;
	            var placeId = address && address.street && address.checker && address.checker.googlePlaceId;
	            var geoLocation = address && address.street && address.geoLocation && _extends({}, address.geoLocation, { distance: GEO_LOCATION_DISTANCE });
	            var regionAutoCompleteMatcher = (0, _places.provideAutocompleteMatcher)({ types: ['(regions)'] });
	            var fullAutocompleteMatcher = provideFullAutocompleteMatcher(address);
	            this.setState({ zipCode: zipCode, placeId: placeId, geoLocation: geoLocation, regionAutoCompleteMatcher: regionAutoCompleteMatcher, fullAutocompleteMatcher: fullAutocompleteMatcher });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.cmd && nextProps.cmd != this.props.cmd) {
	                if (nextProps.cmd.ticket != (this.props.cmd && this.props.cmd.ticket) && nextProps.cmd.ticket.address != (this.props.cmd && this.props.cmd.ticket && this.props.cmd.ticket.address)) {
	                    var cmd = nextProps.cmd;
	
	
	                    var address = cmd && cmd.ticket && cmd.ticket.address;
	                    var zipCode = address && address.zipCode;
	                    var placeId = address && address.street && address.checker && address.checker.googlePlaceId;
	                    var geoLocation = address && address.street && address.geoLocation && _extends({}, address.geoLocation, { distance: GEO_LOCATION_DISTANCE });
	                    this.setState({ zipCode: zipCode, placeId: placeId, geoLocation: geoLocation });
	
	                    if (!address) {
	                        var regionAutoCompleteMatcher = (0, _places.provideAutocompleteMatcher)({ types: ['(regions)'] });
	                        this.setState({ regionAutoCompleteMatcher: regionAutoCompleteMatcher });
	                    }
	                    if (!(address && address.street)) {
	                        var fullAutocompleteMatcher = provideFullAutocompleteMatcher(address);
	                        this.setState({ fullAutocompleteMatcher: fullAutocompleteMatcher });
	                    }
	                }
	            }
	
	            if (nextProps.patrimonyStream != this.props.patrimonyStream) {
	                var dispatch = nextProps.dispatch,
	                    patrimonyStream = nextProps.patrimonyStream;
	
	
	                if (patrimonyStream.length == 0) {
	                    dispatch((0, _actions.updateOpenTicketCmd)({ locationRef: { locationReferenceType: 'AgencyLocation' } }));
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd,
	                authenticated = _props.authenticated,
	                patrimonyStream = _props.patrimonyStream,
	                split = _props.split,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'cmd', 'authenticated', 'patrimonyStream', 'split']);
	
	            var _state = this.state,
	                zipCode = _state.zipCode,
	                placeId = _state.placeId,
	                geoLocation = _state.geoLocation,
	                regionAutoCompleteMatcher = _state.regionAutoCompleteMatcher,
	                fullAutocompleteMatcher = _state.fullAutocompleteMatcher;
	
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.interventionLocation
	            );
	
	            var regionAddressTypeaheadButton = function regionAddressTypeaheadButton() {
	                if (cmd && cmd.ticket && cmd.ticket.address) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        (0, _form.buttonField)(form.ticket.address(), null),
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            var fullAddressTypeaheadButton = function fullAddressTypeaheadButton() {
	                if (cmd && cmd.ticket && cmd.ticket.address && cmd.ticket.address.street) {
	                    var _cmd$ticket$address = cmd.ticket.address,
	                        _zipCode = _cmd$ticket$address.zipCode,
	                        city = _cmd$ticket$address.city,
	                        country = _cmd$ticket$address.country;
	
	
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        (0, _form.buttonField)(form.ticket.address(), { zipCode: _zipCode, city: city, country: country }),
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            var addressTypeaheadAddon = function addressTypeaheadAddon(text) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: _OpenTicketAddressCard2.default.step },
	                    text
	                );
	            };
	
	            var displayPatrimonyAddress = function displayPatrimonyAddress(address) {
	                return address && _react2.default.createElement(
	                    'span',
	                    null,
	                    address.number,
	                    ' ',
	                    address.street,
	                    ', ',
	                    address.zipCode,
	                    ' ',
	                    address.city
	                );
	            };
	
	            var displayPatrimony = function displayPatrimony(patrimony, mode) {
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpenTicketAddressCard2.default.map },
	                            _react2.default.createElement(_StaticMap2.default, { info: true,
	                                apiKey: _config2.default.google.apiKey,
	                                ratio: 16 / 9,
	                                identify: function identify(a) {
	                                    return a.geoLocation;
	                                },
	                                value: [].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses)) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpenTicketAddressCard2.default.patrimony },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    patrimony.ref + ' - ' + patrimony.label
	                                ),
	                                displayPatrimonyAddress([].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses))[0])
	                            )
	                        )
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'span',
	                    { className: _OpenTicketAddressCard2.default.patrimony },
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        patrimony.ref + ' - ' + patrimony.label
	                    ),
	                    displayPatrimonyAddress([].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses))[0])
	                );
	            };
	
	            var full = function full(field) {
	                var disabled = !(cmd && cmd.ticket && cmd.ticket.address && cmd.ticket.address.zipCode);
	                return _extends({}, field, { disabled: disabled });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)(_defineProperty({}, _OpenTicketAddressCard2.default.split, split)) },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: split && 6 || 12 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _OpenTicketAddressCard2.default.main },
	                                    _react2.default.createElement(
	                                        'form',
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 12 },
	                                                _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                                    ref: 'typeahead',
	                                                    source: regionAutoCompleteMatcher,
	                                                    display: _places.displayPrediction,
	                                                    highlight: _places.highlightPrediction,
	                                                    placeholder: _i18n2.default.addAddressCity + ' *',
	                                                    buttonAfter: regionAddressTypeaheadButton(),
	                                                    addonBefore: addressTypeaheadAddon(1)
	                                                }, (0, _places.addressField)(form.ticket.address())))
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 12 },
	                                                _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                                    ref: 'typeahead',
	                                                    source: fullAutocompleteMatcher,
	                                                    display: _places.displayPrediction,
	                                                    highlight: _places.highlightPrediction,
	                                                    placeholder: _i18n2.default.addAddressStreet + ' *',
	                                                    buttonAfter: fullAddressTypeaheadButton(),
	                                                    addonBefore: addressTypeaheadAddon(2)
	                                                }, full((0, _places.addressField)(form.ticket.address()))))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 4 },
	                                                _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                                    type: 'text',
	                                                    name: 'number',
	                                                    placeholder: _i18n2.default.addressNumber
	                                                }, form.ticket.address.number()))
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 8 },
	                                                _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                                    type: 'text',
	                                                    name: 'street',
	                                                    placeholder: _i18n2.default.addressStreet
	                                                }, form.ticket.address.street()))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 4 },
	                                                _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                                    type: 'text',
	                                                    name: 'zipCode',
	                                                    placeholder: _i18n2.default.addressZipCode
	                                                }, form.ticket.address.zipCode()))
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 8 },
	                                                _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                                    type: 'text',
	                                                    name: 'city',
	                                                    placeholder: _i18n2.default.addressCity
	                                                }, form.ticket.address.city()))
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Row,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 4 },
	                                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                                    type: 'text',
	                                                    name: 'digicode',
	                                                    placeholder: _i18n2.default.addressDigicode
	                                                }, form.ticket.address.digicode()))
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 4 },
	                                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                                    type: 'text',
	                                                    name: 'staircase',
	                                                    placeholder: _i18n2.default.addressStaircase
	                                                }, form.ticket.address.staircase()))
	                                            ),
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Col,
	                                                { xs: 4 },
	                                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                                    type: 'text',
	                                                    name: 'floor',
	                                                    placeholder: _i18n2.default.addressFloor
	                                                }, form.ticket.address.floor()))
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: split && 6 || 12 },
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    form.locationRef.locationReferenceType(),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'link',
	                                            value: 'PatrimonyLocation' },
	                                        _i18n2.default.patrimony
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'link',
	                                            value: 'AgencyLocation' },
	                                        _i18n2.default.agency
	                                    )
	                                ),
	                                cmd && cmd.company && form.locationRef.patrimonyUid && _react2.default.createElement(_PatrimonyPicker2.default, _extends({
	                                    size: 'small',
	                                    contact: cmd.ticket && cmd.ticket.callerz && cmd.ticket.callerz.uid,
	                                    company: cmd.company,
	                                    zipCode: zipCode,
	                                    placeId: placeId,
	                                    geoLocation: geoLocation,
	                                    display: displayPatrimony
	                                }, form.locationRef.patrimonyUid())),
	                                cmd && cmd.company && form.locationRef.agencyUid && _react2.default.createElement(_AgencyPicker2.default, _extends({
	                                    user: authenticated,
	                                    company: cmd.company
	                                }, form.locationRef.agencyUid()))
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketAddressCard;
	}(_react.Component);
	
	OpenTicketAddressCard.propTypes = {
	    dispatch: _react.PropTypes.func.isRequired,
	    form: _react.PropTypes.func.isRequired,
	    cmd: _react.PropTypes.object,
	    split: _react.PropTypes.bool
	};
	
	
	OpenTicketAddressCard = (0, _loading.connectLoadingLock)()(OpenTicketAddressCard);
	
	OpenTicketAddressCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        authenticated: state.user.authenticated,
	        patrimonyStream: state.patrimony.stream
	    };
	})(OpenTicketAddressCard);
	
	exports.default = OpenTicketAddressCard;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _phonez = __webpack_require__(40);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _TypeaheadContactPicker = __webpack_require__(1399);
	
	var _TypeaheadContactPicker2 = _interopRequireDefault(_TypeaheadContactPicker);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenTicketCallerCard = function (_Component) {
	    _inherits(OpenTicketCallerCard, _Component);
	
	    function OpenTicketCallerCard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, OpenTicketCallerCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OpenTicketCallerCard.__proto__ || Object.getPrototypeOf(OpenTicketCallerCard)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function (e) {
	            // focus field to display datalist on (second) click
	            e.currentTarget.focus();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(OpenTicketCallerCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd,
	                patrimonyQuery = _props.patrimonyQuery,
	                patrimonyStream = _props.patrimonyStream,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'cmd', 'patrimonyQuery', 'patrimonyStream']);
	
	            var contactQuery = function contactQuery() {
	                if (cmd && cmd.ticket && cmd.ticket.callerz) {
	                    return {
	                        name: cmd.ticket.callerz.namez,
	                        contacts: cmd.ticket.callerz.medium
	                    };
	                }
	            };
	
	            var mediumField = function mediumField(field, type) {
	                var disabled = field.value && field.value.contactMediumType != type || field.disabled;
	                var value;
	
	                switch (type) {
	                    case 'Phone':
	                        value = field.value && field.value.phone;
	                        break;
	                    case 'Mail':
	                        value = field.value && field.value.mail;
	                        break;
	                    case 'Fax':
	                        value = field.value && field.value.fax;
	                        break;
	                }
	
	                function onChange(eventOrValue) {
	                    var value;
	                    if (eventOrValue && eventOrValue.target) {
	                        value = eventOrValue.target.value;
	                    } else {
	                        value = eventOrValue;
	                    }
	
	                    var medium;
	                    switch (type) {
	                        case 'Phone':
	                            medium = value && { phone: value, contactMediumType: 'Phone' } || null;
	                            break;
	                        case 'Mail':
	                            medium = value && { mail: value, contactMediumType: 'Mail' } || null;
	                            break;
	                        case 'Fax':
	                            medium = value && { fax: value, contactMediumType: 'Fax' } || null;
	                            break;
	                    }
	
	                    field.onChange(medium);
	                }
	
	                return _extends({}, field, { disabled: disabled, value: value, onChange: onChange });
	            };
	
	            var referencedContactCallerField = function referencedContactCallerField(field) {
	                var value = field.value && field.value.callerType == 'ReferencedContactCaller' && field.value.uid;
	
	                function onChange(contact) {
	                    var nextValue = contact && { uid: contact, callerType: 'ReferencedContactCaller' } || { callerType: 'HumanCaller' };
	                    field.onChange(nextValue);
	                }
	
	                return { value: value, onChange: onChange };
	            };
	
	            var missingField = function missingField(field) {
	                if (!field) {
	                    return {
	                        disabled: true,
	                        onChange: function onChange() {
	                            return null;
	                        }
	                    };
	                }
	                return field;
	            };
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.callerIdentity
	            );
	
	            var inputAddon = function inputAddon(icon) {
	                return _react2.default.createElement(_Icon2.default, { icon: icon, size: 'xs' });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'text',
	                            name: 'company',
	                            placeholder: _i18n2.default.company
	                        }, missingField(form.ticket.callerz.namez && form.ticket.callerz.namez.company()))),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'firstName',
	                                    placeholder: _i18n2.default.firstName + ' *'
	                                }, missingField(form.ticket.callerz.namez && form.ticket.callerz.namez.firstName())))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'lastName',
	                                    placeholder: _i18n2.default.lastName + ' *'
	                                }, missingField(form.ticket.callerz.namez && form.ticket.callerz.namez.lastName())))
	                            )
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({ type: "text",
	                            onMouseOver: this.focus,
	                            list: "statusz",
	                            maxLength: 100
	                        }, missingField(form.ticket.callerz.status && form.ticket.callerz.status()), {
	                            placeholder: _i18n2.default.callerStatus })),
	                        _react2.default.createElement(
	                            'datalist',
	                            { id: "statusz" },
	                            _i18n2.default.callerStatuses.map(function (s) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    null,
	                                    s
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'text',
	                            name: 'phone',
	                            placeholder: _i18n2.default.phone,
	                            addonBefore: inputAddon('phone')
	                        }, (0, _phonez.phoneField)(mediumField(missingField(form.ticket.callerz.medium && form.ticket.callerz.medium()), 'Phone')))),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'text',
	                            name: 'email',
	                            placeholder: _i18n2.default.email,
	                            addonBefore: inputAddon('mail')
	                        }, mediumField(missingField(form.ticket.callerz.medium && form.ticket.callerz.medium()), 'Mail'))),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'text',
	                            name: 'fax',
	                            placeholder: _i18n2.default.fax,
	                            addonBefore: inputAddon('fax')
	                        }, (0, _phonez.phoneField)(mediumField(missingField(form.ticket.callerz.medium && form.ticket.callerz.medium()), 'Fax')))),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'textarea',
	                            placeholder: _i18n2.default.comment
	                        }, missingField(form.ticket.callerz.comment && form.ticket.callerz.comment())))
	                    ),
	                    (cmd && cmd.locationRef && cmd.locationRef.patrimonyUid || patrimonyQuery && (patrimonyQuery.placeId || patrimonyQuery.geoLocation) && patrimonyStream.length > 0) && _react2.default.createElement(_TypeaheadContactPicker2.default, _extends({
	                        size: 'small',
	                        patrimonies: cmd && cmd.locationRef && cmd.locationRef.patrimonyUid || patrimonyStream,
	                        query: contactQuery()
	                    }, referencedContactCallerField(form.ticket.callerz())))
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketCallerCard;
	}(_react.Component);
	
	OpenTicketCallerCard.propTypes = {
	    dispatch: _react.PropTypes.func.isRequired,
	    form: _react.PropTypes.func.isRequired,
	    cmd: _react.PropTypes.object
	};
	
	
	OpenTicketCallerCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        patrimonyQuery: state.patrimony.query,
	        patrimonyStream: state.patrimony.stream
	    };
	})(OpenTicketCallerCard);
	
	exports.default = OpenTicketCallerCard;

/***/ }),
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(881).Transform;
	var inherits = __webpack_require__(89);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(1580)
	  , core      = __webpack_require__(791)
	  , ctx       = __webpack_require__(1130)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(534);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(534);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(534);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(1080) !== null) && (__webpack_require__(1081) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(332);
	
	var _PathUtils = __webpack_require__(516);
	
	var _ExecutionEnvironment = __webpack_require__(793);
	
	var _DOMUtils = __webpack_require__(902);
	
	var _DOMStateStorage = __webpack_require__(1013);
	
	var _createDOMHistory = __webpack_require__(1142);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(793);
	
	var _PathUtils = __webpack_require__(516);
	
	var _runTransitionHook = __webpack_require__(1015);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(517);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(1163);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(1154),
	    isLength = __webpack_require__(536);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(1019),
	    isObjectLike = __webpack_require__(518);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(518);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(903),
	    isArrayLike = __webpack_require__(1019),
	    isObject = __webpack_require__(336),
	    shimKeys = __webpack_require__(1874),
	    support = __webpack_require__(1025);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object == 'function' ? support.enumPrototypes : isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(1844),
	    isArguments = __webpack_require__(1020),
	    isArray = __webpack_require__(335),
	    isFunction = __webpack_require__(1162),
	    isIndex = __webpack_require__(1156),
	    isLength = __webpack_require__(536),
	    isObject = __webpack_require__(336),
	    isString = __webpack_require__(1021),
	    support = __webpack_require__(1025);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/** Used to fix the JScript `[[DontEnum]]` bug. */
	var shadowProps = [
	  'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
	  'toLocaleString', 'toString', 'valueOf'
	];
	
	/** Used for native method references. */
	var errorProto = Error.prototype,
	    objectProto = Object.prototype,
	    stringProto = String.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to avoid iterating over non-enumerable properties in IE < 9. */
	var nonEnumProps = {};
	nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
	nonEnumProps[boolTag] = nonEnumProps[stringTag] = { 'constructor': true, 'toString': true, 'valueOf': true };
	nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = { 'constructor': true, 'toString': true };
	nonEnumProps[objectTag] = { 'constructor': true };
	
	arrayEach(shadowProps, function(key) {
	  for (var tag in nonEnumProps) {
	    if (hasOwnProperty.call(nonEnumProps, tag)) {
	      var props = nonEnumProps[tag];
	      props[key] = hasOwnProperty.call(props, key);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object) || isString(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      proto = (isFunction(Ctor) && Ctor.prototype) || objectProto,
	      isProto = proto === object,
	      result = Array(length),
	      skipIndexes = length > 0,
	      skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error),
	      skipProto = support.enumPrototypes && isFunction(object);
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  // lodash skips the `constructor` property when it infers it's iterating
	  // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
	  // attribute of an existing property and the `constructor` property of a
	  // prototype defaults to non-enumerable.
	  for (var key in object) {
	    if (!(skipProto && key == 'prototype') &&
	        !(skipErrorProps && (key == 'message' || key == 'name')) &&
	        !(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  if (support.nonEnumShadows && object !== objectProto) {
	    var tag = object === stringProto ? stringTag : (object === errorProto ? errorTag : objToString.call(object)),
	        nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];
	
	    if (tag == objectTag) {
	      proto = objectProto;
	    }
	    length = shadowProps.length;
	    while (length--) {
	      key = shadowProps[length];
	      var nonEnum = nonEnums[key];
	      if (!(isProto && nonEnum) &&
	          (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) {
	        result.push(key);
	      }
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1845),
	    baseDifference = __webpack_require__(1849),
	    baseFlatten = __webpack_require__(1149),
	    bindCallback = __webpack_require__(1018),
	    keysIn = __webpack_require__(1023),
	    pickByArray = __webpack_require__(1159),
	    pickByCallback = __webpack_require__(1160),
	    restParam = __webpack_require__(1148);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	var omit = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof props[0] != 'function') {
	    var props = arrayMap(baseFlatten(props), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  var predicate = bindCallback(props[0], props[1], 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	});
	
	module.exports = omit;


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	/** Used for native method references. */
	var arrayProto = Array.prototype,
	    errorProto = Error.prototype,
	    objectProto = Object.prototype;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/**
	 * An object environment feature flags.
	 *
	 * @static
	 * @memberOf _
	 * @type Object
	 */
	var support = {};
	
	(function(x) {
	  var Ctor = function() { this.x = x; },
	      object = { '0': x, 'length': x },
	      props = [];
	
	  Ctor.prototype = { 'valueOf': x, 'y': x };
	  for (var key in new Ctor) { props.push(key); }
	
	  /**
	   * Detect if `name` or `message` properties of `Error.prototype` are
	   * enumerable by default (IE < 9, Safari < 5.1).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') ||
	    propertyIsEnumerable.call(errorProto, 'name');
	
	  /**
	   * Detect if `prototype` properties are enumerable by default.
	   *
	   * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
	   * (if the prototype or a property on the prototype has been set)
	   * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
	   * property to `true`.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');
	
	  /**
	   * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
	   *
	   * In IE < 9 an object's own properties, shadowing non-enumerable ones,
	   * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.nonEnumShadows = !/valueOf/.test(props);
	
	  /**
	   * Detect if own properties are iterated after inherited properties (IE < 9).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.ownLast = props[0] != 'x';
	
	  /**
	   * Detect if `Array#shift` and `Array#splice` augment array-like objects
	   * correctly.
	   *
	   * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
	   * `shift()` and `splice()` functions that fail to remove the last element,
	   * `value[0]`, of array-like objects even though the "length" property is
	   * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
	   * while `splice()` is buggy regardless of mode in IE < 9.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.spliceObjects = (splice.call(object, 0, 1), !object[0]);
	
	  /**
	   * Detect lack of support for accessing string characters by index.
	   *
	   * IE < 8 can't access characters by index. IE 8 can only access characters
	   * by index on string literals, not string objects.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';
	}(1, 0));
	
	module.exports = support;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(519),
	    root = __webpack_require__(272);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1939),
	    mapCacheDelete = __webpack_require__(1940),
	    mapCacheGet = __webpack_require__(1941),
	    mapCacheHas = __webpack_require__(1942),
	    mapCacheSet = __webpack_require__(1943);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(1027),
	    setCacheAdd = __webpack_require__(1950),
	    setCacheHas = __webpack_require__(1951);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(273),
	    isSymbol = __webpack_require__(1035);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1896),
	    isObjectLike = __webpack_require__(520);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(537),
	    isObjectLike = __webpack_require__(520);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1886),
	    baseKeys = __webpack_require__(1903),
	    isArrayLike = __webpack_require__(1185);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1977)();
	}


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2137);

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOverlaysLibTransition = __webpack_require__(1213);
	
	var _reactOverlaysLibTransition2 = _interopRequireDefault(_reactOverlaysLibTransition);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(807);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var Fade = (function (_React$Component) {
	  _inherits(Fade, _React$Component);
	
	  function Fade() {
	    _classCallCheck(this, Fade);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  // Explicitly copied from Transition for doc generation.
	  // TODO: Remove duplication once #977 is resolved.
	
	  Fade.prototype.render = function render() {
	    var timeout = this.props.timeout || this.props.duration;
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibTransition2['default'],
	      _extends({}, this.props, {
	        timeout: timeout,
	        className: _classnames2['default'](this.props.className, 'fade'),
	        enteredClassName: 'in',
	        enteringClassName: 'in'
	      }),
	      this.props.children
	    );
	  };
	
	  return Fade;
	})(_react2['default'].Component);
	
	Fade.propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * duration
	   * @private
	   */
	  duration: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.number, 'Use `timeout`.'),
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _react2['default'].PropTypes.func
	};
	
	Fade.defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Glyphicon = _react2['default'].createClass({
	  displayName: 'Glyphicon',
	
	  propTypes: {
	    /**
	     * bootstrap className
	     * @private
	     */
	    bsClass: _react2['default'].PropTypes.string,
	    /**
	     * An icon name. See e.g. http://getbootstrap.com/components/#glyphicons
	     */
	    glyph: _react2['default'].PropTypes.string.isRequired,
	    /**
	     * Adds 'form-control-feedback' class
	     * @private
	     */
	    formControlFeedback: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'glyphicon',
	      formControlFeedback: false
	    };
	  },
	
	  render: function render() {
	    var _classNames;
	
	    var className = _classnames2['default'](this.props.className, (_classNames = {}, _classNames[this.props.bsClass] = true, _classNames['glyphicon-' + this.props.glyph] = true, _classNames['form-control-feedback'] = this.props.formControlFeedback, _classNames));
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, { className: className }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Glyphicon;
	module.exports = exports['default'];

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Grid = _react2['default'].createClass({
	  displayName: 'Grid',
	
	  propTypes: {
	    /**
	     * Turn any fixed-width grid layout into a full-width layout by this property.
	     *
	     * Adds `container-fluid` class.
	     */
	    fluid: _react2['default'].PropTypes.bool,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div',
	      fluid: false
	    };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	    var className = this.props.fluid ? 'container-fluid' : 'container';
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, className) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Grid;
	module.exports = exports['default'];

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormGroup = __webpack_require__(1196);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Glyphicon = __webpack_require__(1045);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var InputBase = (function (_React$Component) {
	  _inherits(InputBase, _React$Component);
	
	  function InputBase() {
	    _classCallCheck(this, InputBase);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  InputBase.prototype.getInputDOMNode = function getInputDOMNode() {
	    return this.refs.input;
	  };
	
	  InputBase.prototype.getValue = function getValue() {
	    if (this.props.type === 'static') {
	      return this.props.value;
	    } else if (this.props.type) {
	      if (this.props.type === 'select' && this.props.multiple) {
	        return this.getSelectedOptions();
	      }
	      return this.getInputDOMNode().value;
	    }
	    throw new Error('Cannot use getValue without specifying input type.');
	  };
	
	  InputBase.prototype.getChecked = function getChecked() {
	    return this.getInputDOMNode().checked;
	  };
	
	  InputBase.prototype.getSelectedOptions = function getSelectedOptions() {
	    var values = [];
	
	    Array.prototype.forEach.call(this.getInputDOMNode().getElementsByTagName('option'), function (option) {
	      if (option.selected) {
	        var value = option.getAttribute('value') || option.innerHtml;
	        values.push(value);
	      }
	    });
	
	    return values;
	  };
	
	  InputBase.prototype.isCheckboxOrRadio = function isCheckboxOrRadio() {
	    return this.props.type === 'checkbox' || this.props.type === 'radio';
	  };
	
	  InputBase.prototype.isFile = function isFile() {
	    return this.props.type === 'file';
	  };
	
	  InputBase.prototype.renderInputGroup = function renderInputGroup(children) {
	    var addonBefore = this.props.addonBefore ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-addon', key: 'addonBefore' },
	      this.props.addonBefore
	    ) : null;
	
	    var addonAfter = this.props.addonAfter ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-addon', key: 'addonAfter' },
	      this.props.addonAfter
	    ) : null;
	
	    var buttonBefore = this.props.buttonBefore ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-btn' },
	      this.props.buttonBefore
	    ) : null;
	
	    var buttonAfter = this.props.buttonAfter ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-btn' },
	      this.props.buttonAfter
	    ) : null;
	
	    var inputGroupClassName = undefined;
	    switch (this.props.bsSize) {
	      case 'small':
	        inputGroupClassName = 'input-group-sm';break;
	      case 'large':
	        inputGroupClassName = 'input-group-lg';break;
	      default:
	    }
	
	    return addonBefore || addonAfter || buttonBefore || buttonAfter ? _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](inputGroupClassName, 'input-group'), key: 'input-group' },
	      addonBefore,
	      buttonBefore,
	      children,
	      addonAfter,
	      buttonAfter
	    ) : children;
	  };
	
	  InputBase.prototype.renderIcon = function renderIcon() {
	    if (this.props.hasFeedback) {
	      if (this.props.feedbackIcon) {
	        return _react2['default'].cloneElement(this.props.feedbackIcon, { formControlFeedback: true });
	      }
	
	      switch (this.props.bsStyle) {
	        case 'success':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'ok', key: 'icon' });
	        case 'warning':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'warning-sign', key: 'icon' });
	        case 'error':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'remove', key: 'icon' });
	        default:
	          return _react2['default'].createElement('span', { className: 'form-control-feedback', key: 'icon' });
	      }
	    } else {
	      return null;
	    }
	  };
	
	  InputBase.prototype.renderHelp = function renderHelp() {
	    return this.props.help ? _react2['default'].createElement(
	      'span',
	      { className: 'help-block', key: 'help' },
	      this.props.help
	    ) : null;
	  };
	
	  InputBase.prototype.renderCheckboxAndRadioWrapper = function renderCheckboxAndRadioWrapper(children) {
	    var classes = {
	      'checkbox': this.props.type === 'checkbox',
	      'radio': this.props.type === 'radio'
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](classes), key: 'checkboxRadioWrapper' },
	      children
	    );
	  };
	
	  InputBase.prototype.renderWrapper = function renderWrapper(children) {
	    return this.props.wrapperClassName ? _react2['default'].createElement(
	      'div',
	      { className: this.props.wrapperClassName, key: 'wrapper' },
	      children
	    ) : children;
	  };
	
	  InputBase.prototype.renderLabel = function renderLabel(children) {
	    var classes = {
	      'control-label': !this.isCheckboxOrRadio()
	    };
	    classes[this.props.labelClassName] = this.props.labelClassName;
	
	    return this.props.label ? _react2['default'].createElement(
	      'label',
	      { htmlFor: this.props.id, className: _classnames2['default'](classes), key: 'label' },
	      children,
	      this.props.label
	    ) : children;
	  };
	
	  InputBase.prototype.renderInput = function renderInput() {
	    if (!this.props.type) {
	      return this.props.children;
	    }
	
	    switch (this.props.type) {
	      case 'select':
	        return _react2['default'].createElement(
	          'select',
	          _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control'), ref: 'input', key: 'input' }),
	          this.props.children
	        );
	      case 'textarea':
	        return _react2['default'].createElement('textarea', _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control'), ref: 'input', key: 'input' }));
	      case 'static':
	        return _react2['default'].createElement(
	          'p',
	          _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control-static'), ref: 'input', key: 'input' }),
	          this.props.value
	        );
	      default:
	        var className = this.isCheckboxOrRadio() || this.isFile() ? '' : 'form-control';
	        return _react2['default'].createElement('input', _extends({}, this.props, { className: _classnames2['default'](this.props.className, className), ref: 'input', key: 'input' }));
	    }
	  };
	
	  InputBase.prototype.renderFormGroup = function renderFormGroup(children) {
	    return _react2['default'].createElement(
	      _FormGroup2['default'],
	      this.props,
	      children
	    );
	  };
	
	  InputBase.prototype.renderChildren = function renderChildren() {
	    return !this.isCheckboxOrRadio() ? [this.renderLabel(), this.renderWrapper([this.renderInputGroup(this.renderInput()), this.renderIcon(), this.renderHelp()])] : this.renderWrapper([this.renderCheckboxAndRadioWrapper(this.renderLabel(this.renderInput())), this.renderHelp()]);
	  };
	
	  InputBase.prototype.render = function render() {
	    var children = this.renderChildren();
	    return this.renderFormGroup(children);
	  };
	
	  return InputBase;
	})(_react2['default'].Component);
	
	InputBase.propTypes = {
	  type: _react2['default'].PropTypes.string,
	  label: _react2['default'].PropTypes.node,
	  help: _react2['default'].PropTypes.node,
	  addonBefore: _react2['default'].PropTypes.node,
	  addonAfter: _react2['default'].PropTypes.node,
	  buttonBefore: _react2['default'].PropTypes.node,
	  buttonAfter: _react2['default'].PropTypes.node,
	  bsSize: _react2['default'].PropTypes.oneOf(['small', 'medium', 'large']),
	  bsStyle: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  hasFeedback: _react2['default'].PropTypes.bool,
	  feedbackIcon: _react2['default'].PropTypes.node,
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  groupClassName: _react2['default'].PropTypes.string,
	  wrapperClassName: _react2['default'].PropTypes.string,
	  labelClassName: _react2['default'].PropTypes.string,
	  multiple: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  value: _react2['default'].PropTypes.any
	};
	
	InputBase.defaultProps = {
	  disabled: false,
	  hasFeedback: false,
	  multiple: false
	};
	
	exports['default'] = InputBase;
	module.exports = exports['default'];

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var NavbarBrand = (function (_React$Component) {
	  _inherits(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    _classCallCheck(this, NavbarBrand);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['className', 'children']);
	
	    var _context$$bs_navbar_bsClass = this.context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	
	    var brandClasses = _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: _classnames2['default'](children.props.className, className, brandClasses)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, props, { className: _classnames2['default'](className, brandClasses) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	})(_react2['default'].Component);
	
	NavbarBrand.contextTypes = {
	  $bs_navbar_bsClass: _react2['default'].PropTypes.string
	};
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	exports['default'] = valueValidation;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibSinglePropFrom = __webpack_require__(2060);
	
	var _reactPropTypesLibSinglePropFrom2 = _interopRequireDefault(_reactPropTypesLibSinglePropFrom);
	
	function valueValidation(props, propName, componentName) {
	  var error = _reactPropTypesLibSinglePropFrom2['default']('children', 'value')(props, propName, componentName);
	
	  if (!error) {
	    error = _react2['default'].PropTypes.node(props, propName, componentName);
	  }
	
	  return error;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(538));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(1221));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(2057));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(2052));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(2053));
	
	var _properties = __webpack_require__(1220);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(2054));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(1223);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.errMsg = errMsg;
	exports.createChainableTypeChecker = createChainableTypeChecker;
	
	function errMsg(props, propName, componentName, msgContinuation) {
	  return 'Invalid prop \'' + propName + '\' of value \'' + props[propName] + '\'' + (' supplied to \'' + componentName + '\'' + msgContinuation);
	}
	
	/**
	 * Create chain-able isRequired validator
	 *
	 * Largely copied directly from:
	 *  https://github.com/facebook/react/blob/0.11-stable/src/core/ReactPropTypes.js#L94
	 */
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName) {
	    componentName = componentName || '<<anonymous>>';
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required prop \'' + propName + '\' was not specified in \'' + componentName + '\'.');
	      }
	    } else {
	      return validate(props, propName, componentName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isRequiredForA11y;
	
	function isRequiredForA11y(propType) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] == null) {
	      return new Error("The prop '" + propName + "' is required to make '" + componentName + "' accessible" + " for users using assistive technologies such as screen readers");
	    }
	
	    return propType(props, propName, componentName);
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addMonths = addMonths;
	exports.clone = clone;
	exports.isSameDay = isSameDay;
	exports.isPastDay = isPastDay;
	exports.isDayBetween = isDayBetween;
	exports.addDayToRange = addDayToRange;
	exports.isDayInRange = isDayInRange;
	/**
	 * Return `d` as a new date with `n` months added.
	 * @param {[type]} d
	 * @param {[type]} n
	 */
	function addMonths(d, n) {
	  var newDate = clone(d);
	  newDate.setMonth(d.getMonth() + n);
	  return newDate;
	}
	
	/**
	 * Clone a date object.
	 *
	 * @param  {Date} d The date to clone
	 * @return {Date} The cloned date
	 */
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * Return `true` if two dates are the same day, ignoring the time.
	 *
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isSameDay(d1, d2) {
	  if (!d1 || !d2) {
	    return false;
	  }
	  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
	}
	
	/**
	 * Return `true` if a day is in the past, e.g. yesterday or any day
	 * before yesterday.
	 *
	 * @param  {Date}  d
	 * @return {Boolean}
	 */
	function isPastDay(d) {
	  var today = new Date();
	  today.setHours(0, 0, 0, 0);
	  return d < today;
	}
	
	/**
	 * Return `true` if day `d` is between days `d1` and `d2`,
	 * without including them.
	 *
	 * @param  {Date}  d
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */
	function isDayBetween(d, d1, d2) {
	  d = clone(d);
	  d1 = clone(d1);
	  d2 = clone(d2);
	
	  d.setHours(0, 0, 0, 0);
	  d1.setHours(0, 0, 0, 0);
	  d2.setHours(0, 0, 0, 0);
	  return d1 < d && d < d2 || d2 < d && d < d1;
	}
	
	/**
	 * Add a day to a range and return a new range. A range is an object with
	 * `from` and `to` days.
	 *
	 * @param {Date} day
	 * @param {Object} range
	 * @return {Object} Returns a new range object
	 */
	function addDayToRange(day) {
	  var range = arguments.length <= 1 || arguments[1] === undefined ? { from: null, to: null } : arguments[1];
	  var from = range.from;
	  var to = range.to;
	
	  if (!from) {
	    from = day;
	  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
	    from = null;
	    to = null;
	  } else if (to && day < from) {
	    from = day;
	  } else if (to && isSameDay(day, to)) {
	    from = day;
	    to = day;
	  } else {
	    to = day;
	    if (to < from) {
	      to = from;
	      from = day;
	    }
	  }
	
	  return { from: from, to: to };
	}
	
	/**
	 * Return `true` if a day is included in a range of days.
	 *
	 * @param  {Date}  day
	 * @param  {Object}  range
	 * @return {Boolean}
	 */
	function isDayInRange(day, range) {
	  var from = range.from;
	  var to = range.to;
	
	  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
	}
	
	exports.default = {
	  addDayToRange: addDayToRange,
	  addMonths: addMonths,
	  clone: clone,
	  isSameDay: isSameDay,
	  isDayInRange: isDayInRange,
	  isDayBetween: isDayBetween,
	  isPastDay: isPastDay
	};
	//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatMonthTitle = formatMonthTitle;
	exports.formatWeekdayShort = formatWeekdayShort;
	exports.formatWeekdayLong = formatWeekdayLong;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getMonths = getMonths;
	var WEEKDAYS_LONG = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	
	var WEEKDAYS_SHORT = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
	
	var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	function formatMonthTitle(d) {
	  return MONTHS[d.getMonth()] + " " + d.getFullYear();
	}
	
	function formatWeekdayShort(i) {
	  return WEEKDAYS_SHORT[i];
	}
	
	function formatWeekdayLong(i) {
	  return WEEKDAYS_LONG[i];
	}
	
	function getFirstDayOfWeek() {
	  return 0;
	}
	
	function getMonths() {
	  return MONTHS;
	}
	
	exports.default = {
	  formatMonthTitle: formatMonthTitle,
	  formatWeekdayShort: formatWeekdayShort,
	  formatWeekdayLong: formatWeekdayLong,
	  getFirstDayOfWeek: getFirstDayOfWeek,
	  getMonths: getMonths
	};
	//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1062);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(1060)
	  , TAG = __webpack_require__(199)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(917)
	  , call        = __webpack_require__(1233)
	  , isArrayIter = __webpack_require__(1232)
	  , anObject    = __webpack_require__(1058)
	  , toLength    = __webpack_require__(1067)
	  , getIterFn   = __webpack_require__(1240);
	module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(1236)
	  , $export        = __webpack_require__(274)
	  , redefine       = __webpack_require__(525)
	  , hide           = __webpack_require__(524)
	  , has            = __webpack_require__(920)
	  , Iterators      = __webpack_require__(809)
	  , $iterCreate    = __webpack_require__(2080)
	  , setToStringTag = __webpack_require__(921)
	  , getProto       = __webpack_require__(197).getProto
	  , ITERATOR       = __webpack_require__(199)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getProto($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(922)('meta')
	  , isObject = __webpack_require__(1062)
	  , has      = __webpack_require__(920)
	  , setDesc  = __webpack_require__(197).setDesc
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(808)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(1066)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(2085)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(1063)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(924);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(526);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(2123);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(2120);
	
	var _isActive2 = __webpack_require__(2128);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(2124);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(2130);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ }),
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1082 */,
/* 1083 */,
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PROVIDER_RESET = exports.PROVIDER_LOADED = undefined;
	exports.loadProvider = loadProvider;
	exports.resetProvider = resetProvider;
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NAMESPACE = 'Actradis';
	var PROVIDER_LOADED = exports.PROVIDER_LOADED = NAMESPACE + '/ProviderLoaded';
	var PROVIDER_RESET = exports.PROVIDER_RESET = NAMESPACE + '/ProviderReset';
	
	function loadProvider(siretNumber) {
	    return (0, _loading2.default)(fetch(_config2.default.api.url + '/actradis/providercompanies/' + siretNumber, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: PROVIDER_LOADED,
	            provider: json
	        };
	    }).catch((0, _fetchz.only)(404, function (error) {
	        return {
	            type: PROVIDER_LOADED,
	            provider: null
	        };
	    })), PROVIDER_LOADED);
	}
	
	function resetProvider() {
	    return {
	        type: PROVIDER_RESET
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        errorStatusCodeEnum: {
	            400: 'Erreur de validation',
	            401: 'Vous n\'êtes pas authentifié',
	            403: 'Vous n\'êtes pas autorisé',
	            404: 'Non trouvé',
	            500: 'Une erreur est survenue'
	        },
	        errorTypeEnum: {
	            badRequest: 'Erreur de validation',
	            forbidden: 'Vous n\'êtes pas autorisé',
	            jsonValidationError: 'Erreur de validation',
	            notValidDemand: 'Votre demande est invalide',
	            demandNotFound: 'Votre demande est invalide',
	            invalidCredentials: 'Les identifiants saisis ne sont pas valides',
	            impossibleToDissociatePatrimonyFromAgencyThatDoesntExist: 'Un patrimoine doit avoir au moins une agence',
	            impossibleToAssociatePatrimonyInAgencyForAlreadyAssociatedAgency: 'Cette agence est déjà associée au patrimoine',
	            impossibleToDissociateUserIfRemainsOnlyOneAgency: 'Un user doit avoir au moins une agence',
	            impossibleToRemoveOnlyAddressFromLot: 'Un lot doit avoir au moins une adresse',
	            userAlreadyExist: 'Cet email est déjà utilisé',
	            userAlreadyActived: 'Cet utilisateur est actif',
	            userNotFound: 'Cet utilisateur n\'existe pas ou est inactif',
	            loginAlreadyUsed: 'Cet email est déjà utilisé',
	            impossibleToPerformCommandOnDisabledUser: 'Cet utilisateur est déjà désactivé',
	            impossibleToUpdateLoginOfActiveUser: 'Cet utilisateur est actif',
	            impossibleToReportFormalNoticeIfNoInterventionDeadlineWasDefined: 'Une date butoir doit avoir été définie',
	            impossibleToReportFormalNoticeIfInterventionDeadlineIsNotExcedeed: 'La date butoir n\'est pas dépassée',
	            impossibleToReportFormalNoticeIfNewDeadlineIsMinusThanPreviousInterventionDeadline: 'La date doit être posterieur à l\'actuelle mise en demeure',
	            impossibleToDissociateUserIfRemainsOnlyOnePatrimony: 'Un gestionnaire doit avoir au moins un patrimoine',
	            impossibleToUpgradeCompanyToStandardAccountIfNotIdentified: 'Un siret est nécessaire pour souscrire au compte standard',
	            userAlreadyAssociatedWithThisPatrimony: 'Ce patrimoine est déjà associé au gestionnaire',
	            lotReferenceAlreadyExist: 'Cette référence existe déjà pour ce patrimoine',
	            lotNumberAlreadyExist: 'Ce numéro de lot existe déjà pour ce patrimoine',
	            patrimonyNotFound: 'Patrimoine non trouvé',
	            buildingDontExist: 'Bâtiment non trouvé',
	            addressNotConform: 'Adresse invalide',
	            impossibleToLinkAlreadyLinkedEntityWithPatrimonyContact: 'Ce contact est déjà associé',
	            impossibleToAddContactThatAlreadyExistInThisPatrimonyContact: 'Ce moyen de contact existe déjà',
	            impossibleToRemoveBecauseShouldHaveAtLeastOneRemainingContact: 'Au moins un moyen de contact doit être renseigné',
	            siretAlreadyExist: 'Cette entreprise est déjà référencée',
	            titleShouldBeUniq: 'Ce titre est déjà utilisé'
	        },
	        systemError: 'Erreur système',
	        systemErrorText: ['L\'application rencontre des difficultés techniques.', 'Veuillez réessayer ou contacter le support si le problème persiste.']
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.REPORT_STREAM_LOADED = undefined;
	exports.loadReportStream = loadReportStream;
	
	var _fetchz = __webpack_require__(86);
	
	var _loading = __webpack_require__(58);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _models = __webpack_require__(1287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NAMESPACE = 'Audit';
	var REPORT_STREAM_LOADED = exports.REPORT_STREAM_LOADED = NAMESPACE + '/ReportSteamLoaded';
	
	function loadReportStream(query) {
	    return (0, _loading2.default)(fetch((0, _fetchz.apiUrl)(_config2.default.audit.api.url + '/reports', query), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	        var json = _ref.json;
	
	        return {
	            type: REPORT_STREAM_LOADED,
	            stream: json.result.sort(function (a, b) {
	                return new Date(a.created) - new Date(b.created);
	            }),
	            stats: {
	                newAudits: {
	                    currentYear: _models.Audit.yearlyAuditCount(json.result)
	                }
	            }
	        };
	    }), REPORT_STREAM_LOADED);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
		fr: {
			score: 'score',
			auditScores: 'notes d\'audits'
		}
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanyCard = __webpack_require__(2178);
	
	var _CompanyCard2 = _interopRequireDefault(_CompanyCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyCard = function (_Component) {
	    _inherits(CompanyCard, _Component);
	
	    function CompanyCard() {
	        _classCallCheck(this, CompanyCard);
	
	        return _possibleConstructorReturn(this, (CompanyCard.__proto__ || Object.getPrototypeOf(CompanyCard)).apply(this, arguments));
	    }
	
	    _createClass(CompanyCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                company = _props.company,
	                others = _objectWithoutProperties(_props, ['company']);
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    null,
	                    text
	                );
	            };
	
	            var header = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    (0, _extract2.default)(_i18n2.default.companyTypeEnum, company.companyType)
	                ),
	                (company.billingType == 'PremiumAccount' || company.billingType == 'StandardAccount') && _react2.default.createElement(
	                    'div',
	                    { className: _CompanyCard2.default.billingType },
	                    _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip((0, _extract2.default)(_i18n2.default.billingTypeEnum, company.billingType)) },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _CompanyCard2.default[company.billingType], alt: company.billingType, title: company.billingType },
	                            company.billingType[0]
	                        )
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CompanyCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true,
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    !company.isActive && _react2.default.createElement(
	                        'div',
	                        { className: _CompanyCard2.default.status },
	                        _react2.default.createElement(_Icon2.default, { icon: 'closed', size: 'sm' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _CompanyCard2.default.label },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            '> ',
	                            company.label
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CompanyCard;
	}(_react.Component);
	
	CompanyCard.propTypes = {
	    company: _react.PropTypes.object.isRequired
	};
	exports.default = CompanyCard;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanySelectInput = function (_Component) {
	    _inherits(CompanySelectInput, _Component);
	
	    function CompanySelectInput() {
	        _classCallCheck(this, CompanySelectInput);
	
	        return _possibleConstructorReturn(this, (CompanySelectInput.__proto__ || Object.getPrototypeOf(CompanySelectInput)).apply(this, arguments));
	    }
	
	    _createClass(CompanySelectInput, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                companyType = _props.companyType;
	
	            dispatch((0, _actions.queryMinorCompanyStream)(_extends({}, _actions.DEFAULT_COMPANY_QUERY, { companyType: companyType, range: { offset: 0, limit: 99 } })));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.companyType != this.props.companyType) {
	                var dispatch = nextProps.dispatch,
	                    companyType = nextProps.companyType;
	
	                dispatch((0, _actions.queryMinorCompanyStream)(_extends({}, _actions.DEFAULT_COMPANY_QUERY, { companyType: companyType, range: { offset: 0, limit: 99 } })));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                stream = _props2.stream,
	                companyType = _props2.companyType,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'stream', 'companyType']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Input,
	                _extends({
	                    type: 'select'
	                }, others),
	                stream.map(function (company, index) {
	                    return _react2.default.createElement(
	                        'option',
	                        {
	                            key: index,
	                            value: company.uid },
	                        company.label
	                    );
	                })
	            );
	        }
	    }]);
	
	    return CompanySelectInput;
	}(_react.Component);
	
	CompanySelectInput.propTypes = {
	    companyType: _react.PropTypes.string
	};
	
	
	CompanySelectInput = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.company.minorStream
	    };
	})(CompanySelectInput);
	
	exports.default = CompanySelectInput;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Header = __webpack_require__(2209);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header() {
	        _classCallCheck(this, Header);
	
	        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	    }
	
	    _createClass(Header, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                status = _props.status,
	                help = _props.help;
	
	            var statusClass = status && status.toLowerCase();
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Header2.default.default, _Header2.default[statusClass]) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _Header2.default.main },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Header2.default.container },
	                        children
	                    ),
	                    status && _react2.default.createElement(
	                        'div',
	                        { className: _Header2.default.status },
	                        _react2.default.createElement(_Icon2.default, { icon: 'status-' + statusClass, size: 'xs' })
	                    )
	                ),
	                help && _react2.default.createElement(
	                    'div',
	                    { className: _Header2.default.side },
	                    help
	                )
	            );
	        }
	    }]);
	
	    return Header;
	}(_react.Component);
	
	Header.propTypes = {
	    status: _react.PropTypes.string,
	    help: _react.PropTypes.node
	};
	exports.default = Header;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _RankingDashboardPanel = __webpack_require__(2216);
	
	var _RankingDashboardPanel2 = _interopRequireDefault(_RankingDashboardPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RankingDashboardPanel = function (_Component) {
	    _inherits(RankingDashboardPanel, _Component);
	
	    function RankingDashboardPanel(props) {
	        _classCallCheck(this, RankingDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (RankingDashboardPanel.__proto__ || Object.getPrototypeOf(RankingDashboardPanel)).call(this, props));
	
	        _this.state = {
	            metrics: []
	        };
	        return _this;
	    }
	
	    _createClass(RankingDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                identify = _props.identify,
	                value = _props.value;
	
	
	            var metrics = value.sort(function (a, b) {
	                return identify(b) - identify(a);
	            }).slice(0, 10);
	            this.setState({ metrics: metrics });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.value != this.props.value) {
	                var identify = nextProps.identify,
	                    value = nextProps.value;
	
	
	                var metrics = value.sort(function (a, b) {
	                    return identify(b) - identify(a);
	                }).slice(0, 10);
	                this.setState({ metrics: metrics });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                light = _props2.light,
	                display = _props2.display,
	                identify = _props2.identify,
	                _onClick = _props2.onClick,
	                value = _props2.value,
	                others = _objectWithoutProperties(_props2, ['light', 'display', 'identify', 'onClick', 'value']);
	
	            var metrics = this.state.metrics;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_RankingDashboardPanel2.default.default, _defineProperty({}, _RankingDashboardPanel2.default.light, light)) },
	                _react2.default.createElement(
	                    _DashboardPanel2.default,
	                    _extends({
	                        light: light
	                    }, others),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _RankingDashboardPanel2.default.metricGroup },
	                        metrics.map(function (metric, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                {
	                                    key: index },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _RankingDashboardPanel2.default.rank },
	                                    index + 1
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _RankingDashboardPanel2.default.container },
	                                    _onClick && _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: function onClick(e) {
	                                                return _onClick(e, metric);
	                                            } },
	                                        display(metric)
	                                    ) || display(metric)
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RankingDashboardPanel;
	}(_react.Component);
	
	RankingDashboardPanel.propTypes = {
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    onClick: _react.PropTypes.func,
	    value: _react.PropTypes.array
	};
	RankingDashboardPanel.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    },
	    value: []
	};
	exports.default = RankingDashboardPanel;

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (value) {
	
	    function humanize() {
	        if (value != null) {
	            var format;
	
	            if (value < 1000) {
	                format = value + ' m';
	            } else {
	                format = Math.round(value / 1000 * 10) / 10 + ' km';
	            }
	            return format;
	        }
	        return '---';
	    }
	
	    function format(unit) {
	        if (value != null) {
	            var format;
	
	            switch (unit.toLowerCase()) {
	                case 'km':
	                    format = Math.round(value / 1000 * 10) / 10 + ' km';
	                    break;
	                default:
	                    format = value + ' m';
	            }
	
	            return format;
	        }
	        return '';
	    }
	
	    return { humanize: humanize, format: format };
	};

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var maps;
	
	// this implementation assumes the script is loaded before the maps API is used
	// this is bad practice but it works and avoid using promises
	if (!window.google || !window.google.maps) {
	    maps = {};
	
	    var url = '//maps.googleapis.com/maps/api/js?libraries=places,geometry';
	    if (_config2.default.google.apiKey) {
	        url += '&key=' + _config2.default.google.apiKey;
	    }
	
	    // load script
	    var script = document.createElement('script');
	    script.type = 'text/javascript';
	    script.src = url;
	    script.defer = true;
	    script.async = true;
	    script.onload = function () {
	        Object.assign(maps, window.google.maps);
	    };
	    document.body.appendChild(script);
	} else {
	    maps = window.google.maps;
	}
	
	exports.default = maps;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var intercom;
	
	if (!window.Intercom) {
	    intercom = function intercom() {
	        if (window.Intercom.c) {
	            window.Intercom.c(arguments);
	        } else {
	            var _window;
	
	            // window.Intercom was replaced after script load
	            (_window = window).Intercom.apply(_window, arguments);
	        }
	    };
	    intercom.q = [];
	    intercom.c = function (args) {
	        return intercom.q.push(args);
	    };
	    window.Intercom = intercom;
	
	    if (_config2.default.intercom.appId) {
	        var script = document.createElement('script');
	        script.type = 'text/javascript';
	        script.src = 'https://widget.intercom.io/widget/' + _config2.default.intercom.appId;
	        document.body.appendChild(script);
	    }
	} else {
	    intercom = window.Intercom;
	    intercom('reattach_activator');
	    intercom('update', intercomSettings);
	}
	
	exports.default = intercom;

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CreateOpeningTicketInstructionAction = exports.CreateOpeningTicketInstructionAction = function CreateOpeningTicketInstructionAction() {
	    _classCallCheck(this, CreateOpeningTicketInstructionAction);
	};
	
	CreateOpeningTicketInstructionAction.schema = {
	    type: 'object',
	    properties: {
	        title: { type: 'string' },
	        text: { type: 'string' }
	    },
	    required: ['title', 'text']
	};
	
	var UpdateOpeningTicketInstructionAction = exports.UpdateOpeningTicketInstructionAction = function UpdateOpeningTicketInstructionAction() {
	    _classCallCheck(this, UpdateOpeningTicketInstructionAction);
	};
	
	UpdateOpeningTicketInstructionAction.schema = {
	    type: 'object',
	    properties: {
	        title: { type: 'string' },
	        text: { type: 'string' }
	    },
	    required: ['title', 'text']
	};

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ContactPicker = __webpack_require__(1382);
	
	var _ContactPicker2 = _interopRequireDefault(_ContactPicker);
	
	var _actions = __webpack_require__(74);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function restrict(allowed, value) {
	    if (value) return allowed.indexOf(value) >= 0 && value || allowed[0];
	    return allowed[0];
	}
	
	var LinkPatrimonyContactWithPopover = function (_Component) {
	    _inherits(LinkPatrimonyContactWithPopover, _Component);
	
	    function LinkPatrimonyContactWithPopover(props) {
	        _classCallCheck(this, LinkPatrimonyContactWithPopover);
	
	        var _this = _possibleConstructorReturn(this, (LinkPatrimonyContactWithPopover.__proto__ || Object.getPrototypeOf(LinkPatrimonyContactWithPopover)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(LinkPatrimonyContactWithPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd,
	                patrimony = _props.patrimony,
	                lot = _props.lot;
	
	
	            var linkTypes = patrimony && _models.CONTACT_PATRIMONY_LINK_TYPES || lot && _models.CONTACT_LOT_LINK_TYPES;
	            var linkType = restrict(linkTypes, cmd && cmd.linkedWith && cmd.linkedWith.linkType);
	
	            this.setState({ linkTypes: linkTypes });
	
	            dispatch((0, _actions.updateLinkPatrimonyContactWithCmd)({
	                linkedWith: _extends({}, cmd && cmd.linkedWith, {
	                    lotUid: lot && lot.uid,
	                    patrimonyUid: patrimony && patrimony.uid,
	                    linkType: linkType
	                })
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.patrimony != this.props.patrimony || nextProps.lot != this.props.lot) {
	                var dispatch = nextProps.dispatch,
	                    cmd = nextProps.cmd,
	                    patrimony = nextProps.patrimony,
	                    lot = nextProps.lot;
	
	
	                var linkTypes = patrimony && _models.CONTACT_PATRIMONY_LINK_TYPES || lot && _models.CONTACT_LOT_LINK_TYPES;
	                var linkType = restrict(linkTypes, cmd && cmd.linkedWith && cmd.linkedWith.linkType);
	
	                this.setState({ linkTypes: linkTypes });
	
	                dispatch((0, _actions.updateLinkPatrimonyContactWithCmd)({
	                    linkedWith: _extends({}, cmd && cmd.linkedWith, {
	                        lotUid: lot && lot.uid,
	                        patrimonyUid: patrimony && patrimony.uid,
	                        linkType: linkType
	                    })
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                patrimony = _props2.patrimony,
	                lot = _props2.lot,
	                onHide = _props2.onHide;
	            var contact = this.state.contact;
	
	
	            return dispatch((0, _actions.sendLinkPatrimonyContactWithCmd)(contact.uid)).then(function () {
	                return Promise.all([patrimony && dispatch((0, _actions.loadPatrimony)()), lot && dispatch((0, _actions.loadLot)()), dispatch((0, _actions.loadContactStream)())]);
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                onHide = _props3.onHide,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                patrimony = _props3.patrimony,
	                lot = _props3.lot,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'onHide', 'form', 'cmd', 'patrimony', 'lot']);
	
	            var _state = this.state,
	                linkTypes = _state.linkTypes,
	                contact = _state.contact;
	
	
	            var contactField = function contactField() {
	                var value = contact;
	
	                var onChange = function onChange(contact) {
	                    _this2.setState({ contact: contact });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var displayContact = function displayContact(contact, mode) {
	                var phoneMedium = contact.contacts.find(function (c) {
	                    return c.contactInfoType == 'Phone';
	                });
	
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                contact.name.firstName
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                contact.name.lastName
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                contact.name.value
	                            ),
	                            phoneMedium && _react2.default.createElement(
	                                'span',
	                                null,
	                                ' (',
	                                (0, _phonez2.default)(phoneMedium.phone).format(),
	                                ')'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'form-horizontal' },
	                            _react2.default.createElement(
	                                _reactBootstrap.Input,
	                                _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'select',
	                                    name: 'linkType',
	                                    label: _i18n2.default.patrimonyContactLinkType
	                                }, form.linkedWith.linkType()),
	                                _react2.default.createElement('option', { value: '' }),
	                                linkTypes.map(function (linkType, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        {
	                                            key: index,
	                                            value: linkType },
	                                        (0, _extract2.default)(_i18n2.default.patrimonyContactLinkTypeEnum, linkType)
	                                    );
	                                })
	                            ),
	                            form.linkedWith.position && _react2.default.createElement(
	                                _reactBootstrap.Input,
	                                _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'select',
	                                    name: 'position',
	                                    label: _i18n2.default.homeOwnerAssociationPosition
	                                }, form.linkedWith.position()),
	                                _react2.default.createElement('option', { value: '' }),
	                                _models.HOME_OWNER_ASSOCIATION_POSITIONS.map(function (position, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        {
	                                            key: index,
	                                            value: position },
	                                        (0, _extract2.default)(_i18n2.default.homeOwnerAssociationPositionEnum, position)
	                                    );
	                                })
	                            )
	                        )
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        contact.name.firstName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        contact.name.lastName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        contact.name.value
	                    ),
	                    phoneMedium && _react2.default.createElement(
	                        'span',
	                        null,
	                        ' (',
	                        (0, _phonez2.default)(phoneMedium.phone).format(),
	                        ')'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    bsClass: 'popover-lg popover',
	                    title: _i18n2.default.linkPatrimonyContact
	                }, others),
	                _react2.default.createElement(_ContactPicker2.default, _extends({
	                    patrimony: patrimony || lot && lot.patrimony,
	                    display: displayContact
	                }, contactField())),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !contact || !form.isValid() }),
	                            onClick: function onClick() {
	                                return contact && form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LinkPatrimonyContactWithPopover;
	}(_react.Component);
	
	LinkPatrimonyContactWithPopover.propTypes = {
	    patrimony: _react.PropTypes.object,
	    lot: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	LinkPatrimonyContactWithPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.LinkPatrimonyContactWithCmd.selectSchema,
	    action: _actions.LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED
	})(LinkPatrimonyContactWithPopover);
	
	LinkPatrimonyContactWithPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.patrimony.linkPatrimonyContactWithCmd
	    };
	})(LinkPatrimonyContactWithPopover);
	
	exports.default = LinkPatrimonyContactWithPopover;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _places = __webpack_require__(261);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _models = __webpack_require__(124);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReferenceLotPopover = __webpack_require__(2257);
	
	var _ReferenceLotPopover2 = _interopRequireDefault(_ReferenceLotPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function addressMultiMatcher(addresses) {
	    var googleSource = _places.autocompleteMatcher;
	    var addressSource = (0, _TypeaheadInput.matcher)({
	        source: addresses,
	        identify: function identify(a) {
	            return a.number + ' ' + a.street + ' ' + a.city;
	        }
	    });
	
	    return (0, _TypeaheadInput.multiMatcher)([addressSource, googleSource]);
	}
	
	var ReferenceLotPopover = function (_Component) {
	    _inherits(ReferenceLotPopover, _Component);
	
	    function ReferenceLotPopover(props) {
	        _classCallCheck(this, ReferenceLotPopover);
	
	        var _this = _possibleConstructorReturn(this, (ReferenceLotPopover.__proto__ || Object.getPrototypeOf(ReferenceLotPopover)).call(this, props));
	
	        _this.state = {
	            activeUsageGroup: Object.keys(_models.USAGES)[0]
	        };
	        return _this;
	    }
	
	    _createClass(ReferenceLotPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var addresses = this.props.addresses;
	
	
	            var addressSource = addressMultiMatcher(addresses);
	            this.setState({ addressSource: addressSource });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.addresses != this.props.addresses) {
	                var addresses = nextProps.addresses;
	
	
	                var addressSource = addressMultiMatcher(addresses);
	                this.setState({ addressSource: addressSource });
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd,
	                onSubmit = _props.onSubmit,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendReferenceBuildingCmds)(cmd.addresses)).then(function (action) {
	                return dispatch((0, _actions.updateReferenceLotCmd)({ addresses: action.addresses }));
	            }).then(function () {
	                return dispatch((0, _actions.sendReferenceLotCmd)());
	            }).then(function () {
	                return onSubmit();
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_selectUsageGroup',
	        value: function _selectUsageGroup(event, group) {
	            event.preventDefault();
	            this.setState({ activeUsageGroup: group });
	        }
	    }, {
	        key: '_addAddress',
	        value: function _addAddress(event) {
	            var form = this.props.form;
	            var typeahead = this.refs.typeahead;
	
	
	            event.preventDefault();
	
	            form.addresses.add();
	            typeahead.reset();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                addresses = _props2.addresses,
	                building = _props2.building,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'addresses', 'building', 'onHide']);
	
	            var _state = this.state,
	                activeUsageGroup = _state.activeUsageGroup,
	                addressSource = _state.addressSource;
	            var buildingInput = this.refs.buildingInput;
	
	
	            var displayAddressTypeahead = function displayAddressTypeahead(addressOrPrediction) {
	                if (addressOrPrediction.city) {
	                    var address = addressOrPrediction;
	                    var text = address.number + ' ' + address.street + ' ' + address.city;
	                    text = text + (address.building && ' - ' + _i18n2.default.addressBuilding + ' ' + address.building.label || '');
	                    return text;
	                }
	                return (0, _places.displayPrediction)(addressOrPrediction);
	            };
	
	            var highlightAddressTypeahead = function highlightAddressTypeahead(addressOrPrediction) {
	                if (addressOrPrediction.city) {
	                    return null;
	                }
	                return (0, _places.highlightPrediction)(addressOrPrediction);
	            };
	
	            var addressTypeaheadField = function addressTypeaheadField(field) {
	
	                function onChange(addressOrPrediction) {
	                    if (addressOrPrediction.city) {
	                        var address = _extends({ building: building }, addressOrPrediction, { uid: null });
	                        field.onChange(address);
	                        buildingInput.getInputDOMNode().focus();
	                    } else {
	                        (0, _places.getPredictionAddress)(addressOrPrediction, function (predictionAddress) {
	                            var address = predictionAddress && _extends({ building: building }, predictionAddress);
	                            field.onChange(address);
	                            buildingInput.getInputDOMNode().focus();
	                        });
	                    }
	                }
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            var addressTypeaheadButton = function addressTypeaheadButton() {
	                if (form.addresses.size() > 1) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            onClick: function onClick(e) {
	                                return form.addresses.remove(e);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            var tooltipInputAddon = function tooltipInputAddon(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(text) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: _ReferenceLotPopover2.default.info },
	                        '?'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.newLot
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ReferenceLotPopover2.default.default },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ReferenceLotPopover2.default.usageGroup },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xsHidden: true, sm: 3 },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    'type'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 9 },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: _ReferenceLotPopover2.default.container },
	                                    Object.keys(_models.USAGES).map(function (group, index) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            {
	                                                key: index,
	                                                className: (0, _classnames2.default)(_defineProperty({}, _ReferenceLotPopover2.default.active, activeUsageGroup == group)) },
	                                            _react2.default.createElement(
	                                                'a',
	                                                {
	                                                    href: '',
	                                                    onClick: function onClick(e) {
	                                                        return _this2._selectUsageGroup(e, group);
	                                                    } },
	                                                _react2.default.createElement(_Icon2.default, {
	                                                    icon: group,
	                                                    size: 'md',
	                                                    active: activeUsageGroup == group }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    (0, _extract2.default)(_i18n2.default.usageGroupEnum, group)
	                                                )
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'select',
	                                name: 'usage',
	                                label: requiredLabel(_i18n2.default.usage)
	                            }, form.usage()),
	                            _react2.default.createElement('option', { value: '' }),
	                            _models.USAGES[activeUsageGroup].map(function (usage, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    {
	                                        key: index,
	                                        value: usage },
	                                    (0, _extract2.default)(_i18n2.default.usageEnum, usage)
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'reference',
	                            label: requiredLabel(_i18n2.default.reference),
	                            addonAfter: tooltipInputAddon(_i18n2.default.referenceInfo)
	                        }, form.ref())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'lotNumber',
	                            label: requiredLabel(_i18n2.default.lotNumber),
	                            addonAfter: tooltipInputAddon(_i18n2.default.lotNumberInfo)
	                        }, form.lotNumber()))
	                    ),
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _i18n2.default.address_es,
	                        ' ',
	                        _react2.default.createElement(
	                            'i',
	                            null,
	                            '*'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _ReferenceLotPopover2.default.addressGroup },
	                        (form.addresses().value || []).slice(1).reverse().map(function (address, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        className: _ReferenceLotPopover2.default.remove,
	                                        onClick: function onClick(e) {
	                                            return form.addresses.remove(e, address);
	                                        } },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        address.number
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        address.street
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ', ',
	                                        address.zipCode
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        address.city
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, sm: 3 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'gate',
	                                    placeholder: _i18n2.default.addressEntrance
	                                }, form.addresses.recipientSupplement.entrance()))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, sm: 9 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'digicode',
	                                    placeholder: _i18n2.default.addressDigicode
	                                }, form.addresses.digicode()))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, sm: 3 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'floor',
	                                    placeholder: _i18n2.default.addressFloor
	                                }, form.addresses.recipientSupplement.floor()))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, sm: 3 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'unit',
	                                    placeholder: _i18n2.default.addressUnit
	                                }, form.addresses.recipientSupplement.unit()))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, sm: 3 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'floor',
	                                    placeholder: _i18n2.default.addressElevator
	                                }, form.addresses.recipientSupplement.elevator()))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, sm: 3 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'floor',
	                                    placeholder: _i18n2.default.addressStaircase
	                                }, form.addresses.recipientSupplement.staircase()))
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                    ref: 'typeahead',
	                                    source: addressSource,
	                                    display: displayAddressTypeahead,
	                                    highlight: highlightAddressTypeahead,
	                                    placeholder: _i18n2.default.addAddress,
	                                    buttonAfter: addressTypeaheadButton()
	                                }, addressTypeaheadField((0, _form.arrayItemField)(form.addresses()))))
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, sm: 3 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                    type: 'text',
	                                    name: 'number',
	                                    placeholder: _i18n2.default.addressNumber
	                                }, form.addresses.number()))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8, sm: 9 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    ref: 'buildingInput',
	                                    type: 'text',
	                                    name: 'building',
	                                    placeholder: _i18n2.default.addressBuilding,
	                                    disabled: form.addresses.building.uid().value != null
	                                }, form.addresses.building.label()))
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                    type: 'text',
	                                    name: 'street',
	                                    placeholder: _i18n2.default.addressStreet
	                                }, form.addresses.street()))
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4, sm: 3 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                    type: 'text',
	                                    name: 'zipCode',
	                                    placeholder: _i18n2.default.addressZipCode
	                                }, form.addresses.zipCode()))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8, sm: 9 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                    type: 'text',
	                                    name: 'city',
	                                    placeholder: _i18n2.default.addressCity
	                                }, form.addresses.city()))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        form.addresses.isValid() && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                onClick: function onClick(e) {
	                                    return _this2._addAddress(e);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.addAddress
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReferenceLotPopover;
	}(_react.Component);
	
	ReferenceLotPopover.displayName = 'ReferenceLotPopover';
	ReferenceLotPopover.propTypes = {
	    addresses: _react.PropTypes.array.isRequired,
	    building: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired,
	    onSubmit: _react.PropTypes.func
	};
	ReferenceLotPopover.defaultProps = {
	    onSubmit: function onSubmit() {}
	};
	
	
	ReferenceLotPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ReferenceLotCmd.schema,
	    action: _actions.REFERENCE_LOT_CMD_UPDATED
	})(ReferenceLotPopover);
	
	ReferenceLotPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.patrimony.referenceLotCmd
	    };
	})(ReferenceLotPopover);
	
	exports.default = ReferenceLotPopover;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _form = __webpack_require__(15);
	
	var _status = __webpack_require__(13);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _links2 = __webpack_require__(33);
	
	var _places = __webpack_require__(261);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _MultiInput = __webpack_require__(277);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _actions = __webpack_require__(74);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReferencePatrimonyContactPopover = __webpack_require__(2258);
	
	var _ReferencePatrimonyContactPopover2 = _interopRequireDefault(_ReferencePatrimonyContactPopover);
	
	var _ReactDOM = __webpack_require__(474);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function restrict(allowed, value) {
	    if (value) return allowed.indexOf(value) >= 0 && value || allowed[0];
	    return allowed[0];
	}
	
	function mediumReducer(type) {
	    return function (result, medium) {
	        var filtered = result[0] || (result[0] = []);
	        var filteredOut = result[1] || (result[1] = []);
	
	        if (medium.contactInfoType == type) {
	            filtered.push(medium);
	        } else {
	            filteredOut.push(medium);
	        }
	
	        return result;
	    };
	}
	
	var mediumField = function mediumField(field, type) {
	    var arrayValue = field.value || [];
	
	    var _arrayValue$reduce = arrayValue.reduce(mediumReducer(type), [[], []]),
	        _arrayValue$reduce2 = _slicedToArray(_arrayValue$reduce, 2),
	        mediumsValue = _arrayValue$reduce2[0],
	        otherMediumsValue = _arrayValue$reduce2[1];
	
	    var value = mediumsValue.map(function (medium) {
	        switch (type) {
	            case 'Phone':
	                return medium.phone;
	            case 'Mail':
	                return medium.mail;
	            case 'Fax':
	                return medium.fax;
	        }
	    });
	
	    function onChange(value) {
	        var nextMediumsValue = value.map(function (value) {
	            switch (type) {
	                case 'Phone':
	                    return { phone: value, contactInfoType: 'Phone' };
	                case 'Mail':
	                    return { mail: value, contactInfoType: 'Mail' };
	                case 'Fax':
	                    return { fax: value || null, contactInfoType: 'Fax' };
	            }
	        });
	
	        var nextValue = [].concat(_toConsumableArray(otherMediumsValue), _toConsumableArray(nextMediumsValue));
	        field.onChange(nextValue);
	    }
	
	    return _extends({}, field, { value: value, onChange: onChange });
	};
	
	var linkTypeField = function linkTypeField(field) {
	    function onChange(value) {
	        if (value) {
	            field.onChange(value);
	        }
	    }
	
	    return _extends({}, field, { onChange: onChange });
	};
	
	var linkedWithField = function linkedWithField(lot, field) {
	    var value = field.value && field.value.position;
	
	    function onChange(event) {
	        var value = event.target.value;
	
	        var nextLinkedWithValue = value && { linkType: 'LinkToPatrimonyAsHomeOwnerAssociation', position: value, patrimonyUid: lot.patrimony.uid };
	        field.onChange(nextLinkedWithValue);
	    }
	
	    return _extends({}, field, { value: value, onChange: onChange });
	};
	
	var requiredLabel = function requiredLabel(label) {
	    return _react2.default.createElement(
	        'span',
	        null,
	        label,
	        ' ',
	        _react2.default.createElement(
	            'i',
	            null,
	            '*'
	        )
	    );
	};
	
	var addressTypeaheadButton = function addressTypeaheadButton(cmd, form) {
	    if (cmd && cmd.address) {
	        return _react2.default.createElement(
	            _reactBootstrap.Button,
	            (0, _form.buttonField)(form.address(), null),
	            _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	        );
	    }
	    return _react2.default.createElement(
	        _reactBootstrap.Button,
	        null,
	        _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	    );
	};
	
	var ReferencePatrimonyContactPopover = function (_Component) {
	    _inherits(ReferencePatrimonyContactPopover, _Component);
	
	    function ReferencePatrimonyContactPopover(props) {
	        _classCallCheck(this, ReferencePatrimonyContactPopover);
	
	        var _this = _possibleConstructorReturn(this, (ReferencePatrimonyContactPopover.__proto__ || Object.getPrototypeOf(ReferencePatrimonyContactPopover)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        return _this;
	    }
	
	    _createClass(ReferencePatrimonyContactPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.componentStart(this.props);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props, newState) {
	            this.componentStart(props, props.patrimony != this.props.patrimony || props.lot != this.props.lot);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var updateUserCmd = this.props.updateUserCmd;
	
	            var _ref = updateUserCmd || {},
	                shouldCreateUser = _ref.shouldCreateUser,
	                status = _ref.status,
	                errorType = _ref.errorType;
	
	            var show = shouldCreateUser && status === 400 && errorType === 'UserAlreadyExist';
	            return show ? this._renderUserAlreadyExists(show) : this._renderContactForm();
	        }
	    }]);
	
	    return ReferencePatrimonyContactPopover;
	}(_react.Component);
	
	ReferencePatrimonyContactPopover.propTypes = {
	    patrimony: _react.PropTypes.object,
	    lot: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired,
	    popoverToOpen: _react.PropTypes.string.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.componentStart = function (props) {
	        var shouldDispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	        var dispatch = props.dispatch,
	            cmd = props.cmd,
	            patrimony = props.patrimony,
	            lot = props.lot;
	
	        var linkTypes = patrimony && _models.CONTACT_PATRIMONY_LINK_TYPES || lot && _models.CONTACT_LOT_LINK_TYPES;
	        var linkType = restrict(linkTypes, cmd && cmd.linkedWithEntities && cmd.linkedWithEntities.linkType);
	
	        _this2.setState({ linkTypes: linkTypes });
	
	        if (shouldDispatch) {
	            dispatch((0, _actions.updateReferencePatrimonyContactCmd)({
	                linkedWithEntities: _extends({}, cmd && cmd.linkedWithEntities, {
	                    lotUid: lot && lot.uid,
	                    patrimonyUid: patrimony && patrimony.uid,
	                    linkType: linkType
	                }),
	                linkedWithPatrimonyAsHomeOwnerAssociation: _extends({}, cmd && cmd.linkedWithPatrimonyAsHomeOwnerAssociation, {
	                    patrimonyUid: lot && lot.patrimony && lot.patrimony.uid
	                })
	            }));
	        }
	    };
	
	    this._end = function () {
	        var _props = _this2.props,
	            dispatch = _props.dispatch,
	            onHide = _props.onHide,
	            patrimony = _props.patrimony,
	            lot = _props.lot;
	
	        dispatch((0, _actions.resetReferenceUserCmd)());
	
	        setTimeout(function () {
	            patrimony && dispatch((0, _actions.loadPatrimony)());
	            lot && dispatch((0, _actions.loadLot)());
	            dispatch((0, _actions.loadContactStream)());
	        }, 1000);
	
	        onHide();
	    };
	
	    this._sendLink = function () {
	        var _props2 = _this2.props,
	            dispatch = _props2.dispatch,
	            patrimony = _props2.patrimony,
	            lot = _props2.lot;
	
	        var patrimonyUid = patrimony ? patrimony.uid : lot.patrimony.uid;
	
	        return dispatch((0, _actions.sendLinkPatrimonyContactWithUser)(patrimonyUid)).then(_this2._end);
	    };
	
	    this._patrimonyContactCreated = function () {
	        var _props3 = _this2.props,
	            dispatch = _props3.dispatch,
	            updateUserCmd = _props3.updateUserCmd;
	        var shouldCreateUser = updateUserCmd.shouldCreateUser;
	
	
	        if (shouldCreateUser) {
	            return dispatch((0, _actions.sendReferenceUserCmd)()).then(function (referenceCmdUserSent) {
	                var status = referenceCmdUserSent.status,
	                    errorType = referenceCmdUserSent.errorType;
	
	                if (status === 400) {
	                    if (errorType !== 'UserAlreadyExist') {
	                        return (0, _status.errorStatus)(errorType);
	                    }
	                } else if (status === 201) {
	                    return _this2._sendLink();
	                }
	            });
	        } else {
	            return _this2._end();
	        }
	    };
	
	    this._sendCmd = function () {
	        var dispatch = _this2.props.dispatch;
	
	
	        return dispatch((0, _actions.sendReferencePatrimonyContactCmd)()).then(_this2._patrimonyContactCreated);
	    };
	
	    this._needMail = function () {
	        var form = _this2.props.form;
	        var shouldCreateUser = _this2.state.shouldCreateUser;
	
	
	        var mailsList = mediumField(form.contacts(), 'Mail').value;
	        if (shouldCreateUser) {
	            return mailsList.length === 0 || mailsList[0].length === 0;
	        }
	        return false;
	    };
	
	    this._changeUserCreation = function () {
	        var _props4 = _this2.props,
	            dispatch = _props4.dispatch,
	            cmd = _props4.cmd;
	        var shouldCreateUser = cmd.shouldCreateUser;
	
	        dispatch((0, _actions.sendShouldCreateUser)(!shouldCreateUser));
	    };
	
	    this._displayCheckboxCreateUser = function () {
	        var _props5 = _this2.props,
	            _links = _props5._links,
	            cmd = _props5.cmd;
	
	        var _ref2 = cmd ? cmd : { shouldCreateUser: false },
	            shouldCreateUser = _ref2.shouldCreateUser;
	
	        return _links.find((0, _links2.linkFinder)('ReferencePatrimonyUser')) && _react2.default.createElement(
	            'div',
	            { onClick: _this2._changeUserCreation, className: _ReferencePatrimonyContactPopover2.default.userCreation },
	            _react2.default.createElement('input', { type: 'checkbox', checked: shouldCreateUser }),
	            ' ',
	            _i18n2.default.patrimonyUser.createInSameTime
	        );
	    };
	
	    this._overrideMediumFieldForUserCreation = function (previous) {
	        var _needMail = _this2._needMail(),
	            needMail = _needMail.needMail;
	
	        var overridden = _extends({}, previous);
	
	        if (needMail) {
	            overridden.bsStyle = 'error';
	        }
	        return overridden;
	    };
	
	    this._renderContactForm = function () {
	        var _props6 = _this2.props,
	            dispatch = _props6.dispatch,
	            form = _props6.form,
	            cmd = _props6.cmd,
	            patrimony = _props6.patrimony,
	            lot = _props6.lot,
	            onHide = _props6.onHide,
	            editButton = _props6.editButton,
	            editContainer = _props6.editContainer,
	            popoverToOpen = _props6.popoverToOpen,
	            others = _objectWithoutProperties(_props6, ['dispatch', 'form', 'cmd', 'patrimony', 'lot', 'onHide', 'editButton', 'editContainer', 'popoverToOpen']);
	
	        var linkTypes = _this2.state.linkTypes;
	
	        var popover = _react2.default.createElement(
	            _reactBootstrap.Popover,
	            _extends({
	                title: _i18n2.default.newContact
	            }, others),
	            _react2.default.createElement(
	                'div',
	                { className: _ReferencePatrimonyContactPopover2.default.defaultContent },
	                linkTypes.length > 1 && _react2.default.createElement(
	                    'div',
	                    { className: _ReferencePatrimonyContactPopover2.default.linkType },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xsHidden: true, sm: 3 },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                'type'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                _ButtonToggle2.default,
	                                linkTypeField(form.linkedWithEntities.linkType()),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: _ReferencePatrimonyContactPopover2.default.container },
	                                    linkTypes.map(function (linkType, index) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            {
	                                                key: index },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'link',
	                                                    value: linkType },
	                                                _react2.default.createElement(_Icon2.default, {
	                                                    icon: patrimony && _this2._getIcon(linkType) || lot && linkType.slice(11),
	                                                    size: 'md' }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    (0, _extract2.default)(_i18n2.default.patrimonyContactLinkTypeEnum, linkType)
	                                                )
	                                            )
	                                        );
	                                    })
	                                )
	                            ),
	                            _this2._displayCheckboxCreateUser()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    form.linkedWithEntities.position && _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'position',
	                            label: _i18n2.default.homeOwnerAssociationPosition
	                        }, form.linkedWithEntities.position()),
	                        _react2.default.createElement('option', { value: '' }),
	                        _models.HOME_OWNER_ASSOCIATION_POSITIONS.map(function (position, index) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: index,
	                                    value: position },
	                                (0, _extract2.default)(_i18n2.default.homeOwnerAssociationPositionEnum, position)
	                            );
	                        })
	                    ),
	                    form.linkedWithPatrimonyAsHomeOwnerAssociation && _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'position',
	                            label: _i18n2.default.homeOwnerAssociation
	                        }, linkedWithField(lot, form.linkedWithPatrimonyAsHomeOwnerAssociation())),
	                        _react2.default.createElement('option', { value: '' }),
	                        _models.HOME_OWNER_ASSOCIATION_POSITIONS.map(function (position, index) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: index,
	                                    value: position },
	                                (0, _extract2.default)(_i18n2.default.homeOwnerAssociationPositionEnum, position)
	                            );
	                        })
	                    ),
	                    form.linkedWithEntities.linkedAs && _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'position',
	                            label: _i18n2.default.homeOwnerAssociationPosition
	                        }, form.linkedWithEntities.linkedAs()),
	                        _react2.default.createElement('option', { value: '' }),
	                        _models.NON_REFERENCED_LOT_POSITIONS.map(function (position, index) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: index,
	                                    value: position },
	                                (0, _extract2.default)(_i18n2.default.patrimonyContactLinkTypeEnum.linkToNonReferencedLot, position)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'company',
	                        label: _i18n2.default.company
	                    }, form.namez.company())),
	                    _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'gender',
	                            label: _i18n2.default.gender
	                        }, form.namez.gender()),
	                        _react2.default.createElement('option', { value: '' }),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Male' },
	                            _i18n2.default.genderEnum.male
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Female' },
	                            _i18n2.default.genderEnum.female
	                        )
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'firstName',
	                        label: requiredLabel(_i18n2.default.firstName)
	                    }, form.namez.firstName())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'lastName',
	                        label: requiredLabel(_i18n2.default.lastName)
	                    }, form.namez.lastName()))
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _i18n2.default.contactDetails,
	                        ' ',
	                        _react2.default.createElement(
	                            'i',
	                            null,
	                            '*'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        _i18n2.default.contactDetailsText
	                    )
	                ),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'phone',
	                        label: _i18n2.default.phone
	                    }, (0, _phonez.phonesField)(mediumField(form.contacts(), 'Phone')))),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'email',
	                        label: _i18n2.default.email
	                    }, _this2._overrideMediumFieldForUserCreation(mediumField(form.contacts(), 'Mail')))),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'fax',
	                        label: _i18n2.default.fax
	                    }, (0, _phonez.phonesField)(mediumField(form.contacts(), 'Fax'))))
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _i18n2.default.address
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'digicode',
	                                placeholder: _i18n2.default.addressDigicode
	                            }, form.address.digicode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'staircase',
	                                placeholder: _i18n2.default.addressStaircase
	                            }, form.address.staircase()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'floor',
	                                placeholder: _i18n2.default.addressFloor
	                            }, form.address.floor()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                ref: 'typeahead',
	                                source: _places.autocompleteMatcher,
	                                display: _places.displayPrediction,
	                                highlight: _places.highlightPrediction,
	                                placeholder: _i18n2.default.addAddress,
	                                buttonAfter: addressTypeaheadButton(cmd, form)
	                            }, (0, _places.addressField)(form.address())))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'number',
	                                placeholder: _i18n2.default.addressNumber
	                            }, form.address.number()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'street',
	                                placeholder: _i18n2.default.addressStreet
	                            }, form.address.street()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'zipCode',
	                                placeholder: _i18n2.default.addressZipCode
	                            }, form.address.zipCode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'city',
	                                placeholder: _i18n2.default.addressCity
	                            }, form.address.city()))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() || _this2._needMail() }),
	                            onClick: function onClick() {
	                                return form.validate() && !_this2._needMail() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            )
	        );
	        var overlay = _react2.default.createElement(
	            _reactBootstrap.Overlay,
	            { rootClose: true,
	                target: function target() {
	                    return (0, _ReactDOM.findDOMNode)(editButton);
	                },
	                placement: 'bottom',
	                show: popoverToOpen === 'ReferencePatrimonyContactPopover',
	                container: editContainer,
	                onHide: onHide },
	            popover
	        );
	
	        return overlay;
	    };
	
	    this._renderUserAlreadyExists = function (show) {
	        var onHide = _this2.props.onHide;
	
	        return _react2.default.createElement(
	            _reactBootstrap.Modal,
	            { show: show },
	            _react2.default.createElement(
	                _reactBootstrap.Modal.Body,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _ReferencePatrimonyContactPopover2.default.defaultContent },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _i18n2.default.patrimonyUser.linkToUserError
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                onClick: _this2._sendLink },
	                            _i18n2.default.patrimonyUser.linkToUser
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    this._getIcon = function (linkType) {
	        switch (linkType) {
	            case 'LinkToPatrimonyAsCareTaker':
	                return 'CareTaker';
	            case 'LinkToPatrimonyAsHomeOwnerAssociation':
	                return 'HomeOwnerAssociation';
	            case 'LinkToNonReferencedLot':
	                return 'HomeOwnerAssociation';
	        }
	    };
	};
	
	ReferencePatrimonyContactPopover = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.ReferencePatrimonyContactCmd.selectSchema,
	    action: _actions.REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED
	})(ReferencePatrimonyContactPopover);
	
	ReferencePatrimonyContactPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.patrimony.referencePatrimonyContactCmd,
	        updateUserCmd: state.patrimony.updateUserCmd,
	        _links: state.patrimony.contact._links
	    };
	})(ReferencePatrimonyContactPopover);
	
	exports.default = ReferencePatrimonyContactPopover;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _AgencySelectInput = __webpack_require__(888);
	
	var _AgencySelectInput2 = _interopRequireDefault(_AgencySelectInput);
	
	var _models = __webpack_require__(124);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferencePatrimonyPopover = function (_Component) {
	    _inherits(ReferencePatrimonyPopover, _Component);
	
	    function ReferencePatrimonyPopover() {
	        _classCallCheck(this, ReferencePatrimonyPopover);
	
	        return _possibleConstructorReturn(this, (ReferencePatrimonyPopover.__proto__ || Object.getPrototypeOf(ReferencePatrimonyPopover)).apply(this, arguments));
	    }
	
	    _createClass(ReferencePatrimonyPopover, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendReferencePatrimonyCmd)()).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                user = _props2.user,
	                company = _props2.company,
	                agency = _props2.agency,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'user', 'company', 'agency', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.newPatrimony
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'reference',
	                        label: requiredLabel(_i18n2.default.reference)
	                    }, form.ref())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'label',
	                        label: requiredLabel(_i18n2.default.label)
	                    }, form.label())),
	                    _react2.default.createElement(_AgencySelectInput2.default, _extends({ multiple: true,
	                        user: user,
	                        company: company,
	                        agency: agency,
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        name: 'agency',
	                        label: requiredLabel(_i18n2.default.agency)
	                    }, (0, _form.selectField)(form.agencyUids(), true)))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReferencePatrimonyPopover;
	}(_react.Component);
	
	ReferencePatrimonyPopover.propTypes = {
	    user: _react.PropTypes.object,
	    company: _react.PropTypes.object,
	    agency: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReferencePatrimonyPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ReferencePatrimonyCmd.schema,
	    action: _actions.REFERENCE_PATRIMONY_CMD_UPDATED
	})(ReferencePatrimonyPopover);
	
	ReferencePatrimonyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.patrimony.referencePatrimonyCmd
	    };
	})(ReferencePatrimonyPopover);
	
	exports.default = ReferencePatrimonyPopover;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DefineInterventionPeriodPanel = __webpack_require__(1427);
	
	var _DefineInterventionPeriodPanel2 = _interopRequireDefault(_DefineInterventionPeriodPanel);
	
	var _UpdateInterventionPeriodPanel = __webpack_require__(967);
	
	var _UpdateInterventionPeriodPanel2 = _interopRequireDefault(_UpdateInterventionPeriodPanel);
	
	var _AssignActivityToProviderCompanyModal = __webpack_require__(1409);
	
	var _AssignActivityToProviderCompanyModal2 = _interopRequireDefault(_AssignActivityToProviderCompanyModal);
	
	var _UnAssignActivityFromProviderCompanyModal = __webpack_require__(1456);
	
	var _UnAssignActivityFromProviderCompanyModal2 = _interopRequireDefault(_UnAssignActivityFromProviderCompanyModal);
	
	var _RemoveInterventionPeriodModal = __webpack_require__(1453);
	
	var _RemoveInterventionPeriodModal2 = _interopRequireDefault(_RemoveInterventionPeriodModal);
	
	var _CopyInterventionPeriodsModal = __webpack_require__(1425);
	
	var _CopyInterventionPeriodsModal2 = _interopRequireDefault(_CopyInterventionPeriodsModal);
	
	var _CommitmentLayout = __webpack_require__(2264);
	
	var _CommitmentLayout2 = _interopRequireDefault(_CommitmentLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function modalName(result) {
	    switch (result) {
	        case 'RemoveInterventionPeriod':
	            return 'RemoveInterventionPeriodModal';
	        default:
	            return result;
	    }
	}
	
	function interventionPeriodSorter(a, b) {
	    if (a.reference) return -1;
	    if (b.reference) return 1;
	    return a.period.label.localeCompare(b.period.label);
	}
	
	function aggregaSorter(a, b) {
	    return a.activity.label.localeCompare(b.activity.label);
	}
	
	function commitmentAggregator(reference) {
	    return function (result, commitment) {
	        var aggrega = result.find(function (a) {
	            return a.activity.uid == commitment.activityUid;
	        });
	        if (aggrega) {
	            aggrega.interventionPeriods = commitment.interventionPeriods.sort(interventionPeriodSorter), aggrega.referenceInterventionPeriod = commitment.interventionPeriods.find(function (ip) {
	                return ip.reference;
	            });
	            return result;
	        }
	
	        var resultActivity = reference.find(function (a) {
	            return a.uid == commitment.activityUid;
	        });
	        if (resultActivity) {
	            var _aggrega = {
	                activity: resultActivity,
	                interventionPeriods: commitment.interventionPeriods.sort(interventionPeriodSorter),
	                referenceInterventionPeriod: commitment.interventionPeriods.find(function (ip) {
	                    return ip.reference;
	                }),
	                incidentTypes: []
	            };
	
	            result.push(_aggrega);
	        } else {
	            console && console.warn('activity "' + commitment.activityUid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	function activityAggregator(activityReference, openingTicketPurposeReference) {
	    return function (result, activity) {
	        var incidentTypes = activity.includedIncidentTypes.reduce(function (result, incidentTypeId) {
	            var resultIncidentType = openingTicketPurposeReference.openingTicketPurposes.find(function (otp) {
	                return otp.uid == incidentTypeId;
	            });
	
	            if (resultIncidentType) {
	                result.push(resultIncidentType);
	            } else {
	                console && console.warn('openingTicketPurpose "' + incidentTypeId + '" doesn\'t exist in referentiel');
	            }
	            return result;
	        }, []);
	
	        var aggrega = result.find(function (a) {
	            return a.activity.uid == activity.activityUid;
	        });
	        if (aggrega) {
	            aggrega.incidentTypes = incidentTypes;
	            return result;
	        }
	
	        var resultActivity = activityReference.find(function (a) {
	            return a.uid == activity.activityUid;
	        });
	        if (resultActivity) {
	            var _aggrega2 = {
	                activity: resultActivity,
	                interventionPeriods: [],
	                referenceInterventionPeriod: [],
	                incidentTypes: incidentTypes
	            };
	
	            result.push(_aggrega2);
	        } else {
	            console && console.warn('activity "' + activity.activityUid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	var CommitmentLayout = function (_Component) {
	    _inherits(CommitmentLayout, _Component);
	
	    function CommitmentLayout(props) {
	        _classCallCheck(this, CommitmentLayout);
	
	        var _this = _possibleConstructorReturn(this, (CommitmentLayout.__proto__ || Object.getPrototypeOf(CommitmentLayout)).call(this, props));
	
	        _this.state = {
	            activityAggregation: []
	        };
	        return _this;
	    }
	
	    _createClass(CommitmentLayout, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                activityReference = _props.activityReference,
	                openingTicketPurposeReference = _props.openingTicketPurposeReference,
	                commitments = _props.commitments,
	                activities = _props.activities;
	
	
	            var commitmentAggregation = commitments.reduce(commitmentAggregator(activityReference), []);
	            var unsortedActivityAggregation = activities.reduce(activityAggregator(activityReference, openingTicketPurposeReference), commitmentAggregation);
	            var activityAggregation = unsortedActivityAggregation.sort(aggregaSorter);
	            var activeAggrega = activityAggregation[0];
	
	            this.setState({ activityAggregation: activityAggregation, activeAggrega: activeAggrega });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.activityReference != this.props.activityReference || nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference || nextProps.commitments != this.props.commitments || nextProps.activities != this.props.activities) {
	                var activityReference = nextProps.activityReference,
	                    openingTicketPurposeReference = nextProps.openingTicketPurposeReference,
	                    commitments = nextProps.commitments,
	                    activities = nextProps.activities;
	                var activeAggrega = this.state.activeAggrega;
	
	
	                var commitmentAggregation = commitments.reduce(commitmentAggregator(activityReference), []);
	                var unsortedActivityAggregation = activities.reduce(activityAggregator(activityReference, openingTicketPurposeReference), commitmentAggregation);
	                var activityAggregation = unsortedActivityAggregation.sort(aggregaSorter);
	                var nextActiveAggrega = activeAggrega && activityAggregation.find(function (a) {
	                    return a.activity.uid == activeAggrega.activity.uid;
	                }) || activityAggregation[0];
	
	                this.setState({ activityAggregation: activityAggregation, activeAggrega: nextActiveAggrega });
	            }
	        }
	    }, {
	        key: '_select',
	        value: function _select(event, activeAggrega) {
	            event.preventDefault();
	
	            this.setState({ activeAggrega: activeAggrega });
	        }
	    }, {
	        key: '_openPanel',
	        value: function _openPanel(key) {
	            var activeKey = this.state.activeKey;
	
	
	            var nextActiveKey = activeKey != key && key || null;
	            this.setState({ activeKey: nextActiveKey });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, result, activeInterventionPeriod) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            var openedModal = modalName(result);
	            this.setState({ openedModal: openedModal, activeInterventionPeriod: activeInterventionPeriod });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal(event, result, activity) {
	            var _state = this.state,
	                activityAggregation = _state.activityAggregation,
	                activeAggrega = _state.activeAggrega;
	
	
	            if (event) {
	                event.preventDefault();
	            }
	
	            var nextActiveAggrega = activity && activityAggregation.find(function (a) {
	                return a.activity.uid == activity.uid;
	            }) || activeAggrega;
	            this.setState({ openedModal: null, activeAggrega: nextActiveAggrega });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                committed = _props2.committed,
	                commitments = _props2.commitments,
	                activityReference = _props2.activityReference,
	                openingTicketPurposeReference = _props2.openingTicketPurposeReference;
	            var _state2 = this.state,
	                activityAggregation = _state2.activityAggregation,
	                activeKey = _state2.activeKey,
	                activeAggrega = _state2.activeAggrega,
	                activeInterventionPeriod = _state2.activeInterventionPeriod,
	                openedModal = _state2.openedModal;
	
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-danger' },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        activeAggrega && _react2.default.createElement(
	                            'div',
	                            { className: _CommitmentLayout2.default.main },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    activeAggrega.activity.label
	                                ),
	                                committed._links.find((0, _links.linkFinder)('UnAssignActivityFromProviderCompany')) && _react2.default.createElement(
	                                    _reactBootstrap.OverlayTrigger,
	                                    {
	                                        placement: 'bottom',
	                                        overlay: tooltip(_i18n2.default.unAssignActivity) },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'link',
	                                            onClick: function onClick(e) {
	                                                return _this2._openModal(e, 'UnAssignActivityFromProviderCompanyModal');
	                                            } },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.PanelGroup,
	                                { accordion: true,
	                                    activeKey: activeKey,
	                                    onSelect: function onSelect(k) {
	                                        return _this2._openPanel(k);
	                                    } },
	                                activeAggrega.interventionPeriods.map(function (interventionPeriod) {
	                                    return _react2.default.createElement(_UpdateInterventionPeriodPanel2.default, {
	                                        key: interventionPeriod.uid,
	                                        eventKey: interventionPeriod.uid,
	                                        committed: committed,
	                                        activity: activeAggrega.activity,
	                                        interventionPeriod: interventionPeriod,
	                                        referenceInterventionPeriod: activeAggrega.referenceInterventionPeriod,
	                                        incidentTypes: activeAggrega.incidentTypes,
	                                        openingTicketPurposeReference: openingTicketPurposeReference,
	                                        onSubmit: function onSubmit(e, r, ip) {
	                                            return _this2._openModal(e, r, ip);
	                                        } });
	                                }),
	                                committed._links.find((0, _links.linkFinder)(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])) && activeKey == 'new' && _react2.default.createElement(_DefineInterventionPeriodPanel2.default, {
	                                    eventKey: 'new',
	                                    committed: committed,
	                                    activity: activeAggrega.activity,
	                                    interventionPeriods: activeAggrega.interventionPeriods,
	                                    onSubmit: function onSubmit(e, r, ip) {
	                                        return _this2._openModal(e, r, ip);
	                                    } })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                null,
	                                committed._links.find((0, _links.linkFinder)(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])) && activeKey != 'new' && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'primary',
	                                        bsSize: 'large',
	                                        onClick: function onClick() {
	                                            return _this2._openPanel('new');
	                                        } },
	                                    _i18n2.default.newInterventionPeriod
	                                ),
	                                activeAggrega.interventionPeriods.length == 0 && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'primary',
	                                        bsSize: 'large',
	                                        onClick: function onClick(e) {
	                                            return _this2._openModal(e, 'CopyInterventionPeriodsModal');
	                                        } },
	                                    _i18n2.default.fillinAssistant
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _CommitmentLayout2.default.side },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                activityAggregation.length,
	                                ' ',
	                                _i18n2.default.activitiez
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _CommitmentLayout2.default.activityGroup },
	                                activityAggregation.map(function (aggrega) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        {
	                                            key: aggrega.activity.uid },
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._select(e, aggrega);
	                                                } },
	                                            aggrega.activity.label
	                                        )
	                                    );
	                                })
	                            ),
	                            committed._links.find((0, _links.linkFinder)('AssignActivityToProviderCompany')) && _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'primary',
	                                        bsSize: 'large',
	                                        onClick: function onClick(e) {
	                                            return _this2._openModal(e, 'AssignActivityToProviderCompanyModal');
	                                        } },
	                                    _i18n2.default.assignActivity
	                                )
	                            )
	                        )
	                    )
	                ),
	                committed._links.find((0, _links.linkFinder)('AssignActivityToProviderCompany')) && _react2.default.createElement(_AssignActivityToProviderCompanyModal2.default, {
	                    show: openedModal == 'AssignActivityToProviderCompanyModal',
	                    onHide: function onHide(e, r, a) {
	                        return _this2._closeModal(e, r, a);
	                    } }),
	                activeAggrega && committed._links.find((0, _links.linkFinder)('UnAssignActivityFromProviderCompany')) && _react2.default.createElement(_UnAssignActivityFromProviderCompanyModal2.default, {
	                    activity: activeAggrega.activity,
	                    show: openedModal == 'UnAssignActivityFromProviderCompanyModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                activeAggrega && activeInterventionPeriod && committed._links.find((0, _links.linkFinder)('RemoveInterventionPeriod')) && _react2.default.createElement(_RemoveInterventionPeriodModal2.default, {
	                    committed: committed,
	                    activity: activeAggrega.activity,
	                    interventionPeriod: activeInterventionPeriod,
	                    show: openedModal == 'RemoveInterventionPeriodModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                activeAggrega && _react2.default.createElement(_CopyInterventionPeriodsModal2.default, {
	                    committed: committed,
	                    commitments: commitments,
	                    activity: activeAggrega.activity,
	                    show: openedModal == 'CopyInterventionPeriodsModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } })
	            );
	        }
	    }]);
	
	    return CommitmentLayout;
	}(_react.Component);
	
	CommitmentLayout.propTypes = {
	    committed: _react.PropTypes.object.isRequired,
	    commitments: _react.PropTypes.array.isRequired,
	    activities: _react.PropTypes.array,
	    activityReference: _react.PropTypes.array.isRequired,
	    openingTicketPurposeReference: _react.PropTypes.object
	};
	CommitmentLayout.defaultProps = {
	    activities: []
	};
	exports.default = CommitmentLayout;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _links = __webpack_require__(33);
	
	var _CheckboxToggle = __webpack_require__(508);
	
	var _CheckboxToggle2 = _interopRequireDefault(_CheckboxToggle);
	
	var _DayPicker = __webpack_require__(276);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _TimePicker = __webpack_require__(957);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _DayRangePicker = __webpack_require__(889);
	
	var _DayRangePicker2 = _interopRequireDefault(_DayRangePicker);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DefineUpdateInterventionPeriodForActivityForm = __webpack_require__(2276);
	
	var _DefineUpdateInterventionPeriodForActivityForm2 = _interopRequireDefault(_DefineUpdateInterventionPeriodForActivityForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isContact(committed) {
	    return !!committed.commitments;
	}
	
	function periodMapper(period) {
	    return {
	        start: (0, _moment2.default)(period.start, 'HH:mm:ss').toDate(),
	        end: (0, _moment2.default)(period.end, 'HH:mm:ss').toDate()
	    };
	}
	
	function copyServiceChargeCmd(interventionPeriod) {
	    return {
	        charge: interventionPeriod.serviceCharge
	    };
	}
	
	function copyInterventionZoneCmd(interventionPeriod) {
	    return {
	        zone: interventionPeriod.interventionZone
	    };
	}
	
	function copyCallOutChargesCmd(interventionPeriod) {
	    return {
	        callOutCharges: interventionPeriod.callOutCharges
	    };
	}
	
	function copySubscriptionsCmd(interventionPeriod) {
	    return {
	        subscriptions: interventionPeriod.subscriptions
	    };
	}
	
	function copyRepairTimelimitCmd(interventionPeriod) {
	    return {
	        timelimits: interventionPeriod.repairTimelimits
	    };
	}
	
	function copyInterventionTimelimitCmd(interventionPeriod) {
	    return {
	        timelimits: interventionPeriod.interventionTimelimits
	    };
	}
	
	function copyExcludeOpeningTicketPurposesCmd(interventionPeriod) {
	    return {
	        openingTicketPurposes: interventionPeriod.excludedOpeningTicketPurposes
	    };
	}
	
	function defineCmdUpdate(interventionPeriod, committed) {
	    if (interventionPeriod) {
	        return {
	            interventionPeriodUid: interventionPeriod.uid,
	            period: _extends({}, interventionPeriod.period, {
	                periodRanges: interventionPeriod.period.periodRanges && interventionPeriod.period.periodRanges.map(function (periodRange) {
	                    return _extends({}, periodRange, {
	                        timeSlot: _extends({}, periodRange.timeSlot, {
	                            periods: periodRange.timeSlot.periods && periodRange.timeSlot.periods.map(periodMapper) || null
	                        })
	                    });
	                }) || null,
	                exclusions: interventionPeriod.period.exclusions && interventionPeriod.period.exclusions.map(function (exclusion) {
	                    return _extends({}, exclusion, {
	                        days: exclusion.days.map(function (d) {
	                            return (0, _moment2.default)(d).toDate();
	                        }),
	                        timeSlot: _extends({}, exclusion.timeSlot, {
	                            periods: exclusion.timeSlot.periods && exclusion.timeSlot.periods.map(periodMapper) || null
	                        })
	                    });
	                }) || null,
	                days: interventionPeriod.period.days && interventionPeriod.period.days.map(function (d) {
	                    return (0, _moment2.default)(d).toDate();
	                }) || null,
	                timeSlot: interventionPeriod.period.timeSlot && _extends({}, interventionPeriod.period.timeSlot, {
	                    periods: interventionPeriod.period.timeSlot.periods && interventionPeriod.period.timeSlot.periods.map(periodMapper) || null
	                }),
	                startDate: interventionPeriod.period.startDate && new Date(interventionPeriod.period.startDate),
	                endDate: interventionPeriod.period.endDate && new Date(interventionPeriod.period.endDate)
	            }),
	            commandType: committed._links.find((0, _links.linkFinder)(['UpdateInterventionPeriodForActivity', 'UpdateInterventionPeriod'])).rel
	        };
	    }
	
	    return {
	        interventionPeriodUid: null,
	        period: { periodType: _models.PERIOD_TYPES[0] },
	        commandType: committed._links.find((0, _links.linkFinder)(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])).rel
	    };
	}
	
	function weekDaysFilter(weekDays) {
	    return function (weekDay) {
	        return weekDays.indexOf(weekDay) >= 0;
	    };
	}
	
	var DefineUpdateInterventionPeriodForActivityForm = function (_Component) {
	    _inherits(DefineUpdateInterventionPeriodForActivityForm, _Component);
	
	    function DefineUpdateInterventionPeriodForActivityForm(props) {
	        _classCallCheck(this, DefineUpdateInterventionPeriodForActivityForm);
	
	        var _this = _possibleConstructorReturn(this, (DefineUpdateInterventionPeriodForActivityForm.__proto__ || Object.getPrototypeOf(DefineUpdateInterventionPeriodForActivityForm)).call(this, props));
	
	        _this.state = {
	            openedSections: []
	        };
	        return _this;
	    }
	
	    _createClass(DefineUpdateInterventionPeriodForActivityForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                committed = _props.committed,
	                interventionPeriod = _props.interventionPeriod;
	
	
	            var update = defineCmdUpdate(interventionPeriod, committed);
	            dispatch((0, _actions.updateDefineUpdateInterventionPeriodForActivityCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.committed != this.props.committed || nextProps.interventionPeriod != this.props.interventionPeriod) {
	                var dispatch = nextProps.dispatch,
	                    committed = nextProps.committed,
	                    interventionPeriod = nextProps.interventionPeriod;
	
	
	                var update = defineCmdUpdate(interventionPeriod, committed);
	                dispatch((0, _actions.updateDefineUpdateInterventionPeriodForActivityCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                committed = _props2.committed,
	                activity = _props2.activity,
	                interventionPeriod = _props2.interventionPeriod,
	                onSubmit = _props2.onSubmit;
	            var activeInterventionPeriod = this.state.activeInterventionPeriod;
	
	
	            var interventionPeriodUid = interventionPeriod && interventionPeriod.uid;
	            return dispatch((0, _actions.sendDefineUpdateInterventionPeriodForActivityCmd)(committed._links, activity.uid)).then(function (action) {
	                interventionPeriodUid = interventionPeriodUid || action.events.find(function (e) {
	                    return e.eventType == 'InterventionPeriodDefinedForActivity' || e.eventType == 'InterventionPeriodDefined';
	                }).period.uid;
	                // copy selected intervention period
	                // we have to execute all cmds sequencialy to avoid backend issues
	                return activeInterventionPeriod && activeInterventionPeriod.interventionZone && dispatch((0, _actions.sendDefineInterventionZoneForInterventionPeriodCmd)(committed._links, activity.uid, interventionPeriodUid, copyInterventionZoneCmd(activeInterventionPeriod)));
	            }).then(function () {
	                return activeInterventionPeriod && activeInterventionPeriod.serviceCharge && dispatch((0, _actions.sendDefineServiceChargeForInterventionPeriodCmd)(activity.uid, interventionPeriodUid, copyServiceChargeCmd(activeInterventionPeriod)));
	            }).then(function () {
	                return activeInterventionPeriod && activeInterventionPeriod.callOutCharges && activeInterventionPeriod.callOutCharges.length > 0 && dispatch((0, _actions.sendDefineCallOutChargesForInterventionPeriodCmd)(activity.uid, interventionPeriodUid, copyCallOutChargesCmd(activeInterventionPeriod)));
	            }).then(function () {
	                return activeInterventionPeriod && activeInterventionPeriod.subscriptions && activeInterventionPeriod.subscriptions.length > 0 && dispatch((0, _actions.sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd)(activity.uid, interventionPeriodUid, copySubscriptionsCmd(activeInterventionPeriod)));
	            }).then(function () {
	                return activeInterventionPeriod && activeInterventionPeriod.repairTimelimits && activeInterventionPeriod.repairTimelimits.length > 0 && dispatch((0, _actions.sendDefineRepairTimelimitForInterventionPeriodCmd)(interventionPeriodUid, copyRepairTimelimitCmd(activeInterventionPeriod)));
	            }).then(function () {
	                return activeInterventionPeriod && activeInterventionPeriod.interventionTimelimits && activeInterventionPeriod.interventionTimelimits.length > 0 && dispatch((0, _actions.sendDefineInterventionTimelimitForInterventionPeriodCmd)(interventionPeriodUid, copyInterventionTimelimitCmd(activeInterventionPeriod)));
	            }).then(function () {
	                return activeInterventionPeriod && activeInterventionPeriod.excludedOpeningTicketPurposes && activeInterventionPeriod.excludedOpeningTicketPurposes.length > 0 && dispatch((0, _actions.sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd)(interventionPeriodUid, copyExcludeOpeningTicketPurposesCmd(activeInterventionPeriod)));
	            }).then(function () {
	                return isContact(committed) && dispatch((0, _actions.loadContact)()) || dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onSubmit(event, 'InterventionPeriodDefinedForActivity', interventionPeriodUid);
	            });
	        }
	    }, {
	        key: '_toggleSection',
	        value: function _toggleSection(event, name) {
	            var openedSections = this.state.openedSections;
	
	
	            event.preventDefault();
	
	            var index = openedSections.indexOf(name);
	            var nextOpenedSections = [].concat(_toConsumableArray(openedSections));
	
	            if (index >= 0) {
	                nextOpenedSections.splice(index, 1);
	            } else {
	                nextOpenedSections.push(name);
	            }
	
	            this.setState({ openedSections: nextOpenedSections });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                alternateForm = _props3.alternateForm,
	                cmd = _props3.cmd,
	                committed = _props3.committed,
	                activity = _props3.activity,
	                interventionPeriod = _props3.interventionPeriod,
	                interventionPeriods = _props3.interventionPeriods,
	                onSubmit = _props3.onSubmit,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'alternateForm', 'cmd', 'committed', 'activity', 'interventionPeriod', 'interventionPeriods', 'onSubmit']);
	
	            var _state = this.state,
	                openedSections = _state.openedSections,
	                activeInterventionPeriod = _state.activeInterventionPeriod;
	
	
	            var formatTimeSlot = function formatTimeSlot(timeSlot) {
	                if (timeSlot.periods) {
	                    return timeSlot.periods.map(function (period) {
	                        return (0, _moment2.default)(period.start).format(_i18n2.default.timeFormat.from) + ' ' + (0, _moment2.default)(period.end).format(_i18n2.default.timeFormat.to);
	                    }).join(', ');
	                }
	                return _i18n2.default.timeSlotTypeEnum.allDayLong;
	            };
	
	            var periodField = function periodField(field) {
	                var value = {
	                    from: field.value && field.value.startDate,
	                    to: field.value && field.value.endDate
	                };
	
	                function onChange(value) {
	                    var nextValue = _extends({}, field.value, {
	                        startDate: value && value.from,
	                        endDate: value && value.to
	                    });
	                    field.onChange(nextValue);
	                }
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            var activeInterventionPeriodField = function activeInterventionPeriodField() {
	                var value = activeInterventionPeriod && activeInterventionPeriod.period.uid || '';
	
	                var onChange = function onChange(event) {
	                    var activeInterventionPeriodId = event.target.value || null;
	                    var activeInterventionPeriod = activeInterventionPeriodId && interventionPeriods.find(function (ip) {
	                        return ip.period.uid == activeInterventionPeriodId;
	                    });
	                    _this2.setState({ activeInterventionPeriod: activeInterventionPeriod });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var renderTimeSlotForm = function renderTimeSlotForm(form, cmd) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            type: 'select',
	                            name: 'timeSlotType'
	                        }, form.timeSlotType()),
	                        _models.TIME_SLOT_TYPES.map(function (type, index) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: index,
	                                    value: type },
	                                (0, _extract2.default)(_i18n2.default.timeSlotTypeEnum, type)
	                            );
	                        })
	                    ),
	                    form.periods && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _DefineUpdateInterventionPeriodForActivityForm2.default.group },
	                            cmd && cmd.periods && cmd.periods.slice(1).reverse().map(function (period, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            className: _DefineUpdateInterventionPeriodForActivityForm2.default.remove,
	                                            onClick: function onClick(e) {
	                                                return form.periods.remove(e, period);
	                                            } },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            (0, _moment2.default)(period.start).format(_i18n2.default.timeFormat.from)
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            (0, _moment2.default)(period.end).format(_i18n2.default.timeFormat.to)
	                                        )
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_TimePicker2.default, form.periods.start())
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(_TimePicker2.default, form.periods.end())
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            form.periods.isValid() && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return form.periods.add();
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.addTimeSlot
	                                )
	                            ),
	                            cmd && cmd.periods && cmd.periods.length > 1 && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return form.periods.remove();
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.removeTimeSlot
	                                )
	                            )
	                        )
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _DefineUpdateInterventionPeriodForActivityForm2.default.default },
	                _react2.default.createElement(
	                    _reactBootstrap.Input,
	                    _extends({
	                        type: 'select',
	                        name: 'periodType'
	                    }, form.period.periodType()),
	                    _models.PERIOD_TYPES.map(function (type, index) {
	                        return _react2.default.createElement(
	                            'option',
	                            {
	                                key: index,
	                                value: type },
	                            (0, _extract2.default)(_i18n2.default.periodTypeEnum, type)
	                        );
	                    })
	                ),
	                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                    type: 'text',
	                    name: 'label',
	                    placeholder: _i18n2.default.label + ' *'
	                }, form.period.label())),
	                form.period.periodRanges && _react2.default.createElement(
	                    'div',
	                    { className: _DefineUpdateInterventionPeriodForActivityForm2.default.section },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _i18n2.default.periodRanges,
	                        ' ',
	                        _react2.default.createElement(
	                            'i',
	                            null,
	                            '*'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _DefineUpdateInterventionPeriodForActivityForm2.default.group },
	                        cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges.slice(1).reverse().map(function (periodRange, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        className: _DefineUpdateInterventionPeriodForActivityForm2.default.remove,
	                                        onClick: function onClick(e) {
	                                            return form.period.periodRanges.remove(e, periodRange);
	                                        } },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _models.WEEK_DAYS.filter(weekDaysFilter(periodRange.weekDays)).map(function (wd) {
	                                            return _moment2.default.weekdays(_models.WEEK_DAYS.indexOf(wd));
	                                        }).join(', ')
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        formatTimeSlot(periodRange.timeSlot)
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _CheckboxToggle2.default,
	                        form.period.periodRanges.weekDays(),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _models.WEEK_DAYS.slice(0, _models.WEEK_DAYS.length / 2 + 1).map(function (weekDay, index) {
	                                    return _react2.default.createElement(_reactBootstrap.Input, {
	                                        key: index,
	                                        type: 'checkbox',
	                                        label: _moment2.default.weekdays(_models.WEEK_DAYS.indexOf(weekDay)),
	                                        value: weekDay });
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _models.WEEK_DAYS.slice(_models.WEEK_DAYS.length / 2 + 1, _models.WEEK_DAYS.length).map(function (weekDay, index) {
	                                    return _react2.default.createElement(_reactBootstrap.Input, {
	                                        key: index,
	                                        type: 'checkbox',
	                                        label: _moment2.default.weekdays(_models.WEEK_DAYS.indexOf(weekDay)),
	                                        value: weekDay });
	                                })
	                            )
	                        )
	                    ),
	                    renderTimeSlotForm(alternateForm.period.periodRanges.timeSlot, cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges[0] && cmd.period.periodRanges[0].timeSlot),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        form.period.periodRanges.isValid() && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return form.period.periodRanges.add(null, { timeSlot: { timeSlotType: _models.TIME_SLOT_TYPES[0] } });
	                                } },
	                            _i18n2.default.addPeriodRange
	                        ),
	                        cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges.length > 1 && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return form.period.periodRanges.remove();
	                                } },
	                            _i18n2.default.removePeriodRange
	                        )
	                    )
	                ),
	                form.period.exclusions && _react2.default.createElement(
	                    'div',
	                    { className: _DefineUpdateInterventionPeriodForActivityForm2.default.section },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._toggleSection(e, 'Exclusions');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.exclusions
	                            ),
	                            _react2.default.createElement(_Icon2.default, { icon: openedSections.indexOf('Exclusions') >= 0 && 'up' || 'down', size: 'xs' })
	                        )
	                    ),
	                    openedSections.indexOf('Exclusions') >= 0 && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _DefineUpdateInterventionPeriodForActivityForm2.default.group },
	                            cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions.slice(1).reverse().map(function (exclusion, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            className: _DefineUpdateInterventionPeriodForActivityForm2.default.remove,
	                                            onClick: function onClick(e) {
	                                                return form.period.exclusions.remove(e, exclusion);
	                                            } },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            exclusion.days.map(function (d) {
	                                                return (0, _moment2.default)(d).format(_i18n2.default.dateFormat.longer);
	                                            }).join(', ')
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            formatTimeSlot(exclusion.timeSlot)
	                                        )
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _DefineUpdateInterventionPeriodForActivityForm2.default.group },
	                            cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions[0] && cmd.period.exclusions[0].days && cmd.period.exclusions[0].days.slice(1).reverse().map(function (day, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            className: _DefineUpdateInterventionPeriodForActivityForm2.default.remove,
	                                            onClick: function onClick(e) {
	                                                return form.period.exclusions.days.remove(e, day);
	                                            } },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        (0, _moment2.default)(day).format(_i18n2.default.dateFormat.longer)
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _DefineUpdateInterventionPeriodForActivityForm2.default.dayPicker },
	                            _react2.default.createElement(_DayPicker2.default, (0, _form.arrayItemField)(form.period.exclusions.days()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            form.period.exclusions.days.isValid() && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return form.period.exclusions.days.add();
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.addDay
	                                )
	                            ),
	                            cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions[0] && cmd.period.exclusions[0].days && cmd.period.exclusions[0].days.length > 1 && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    onClick: function onClick() {
	                                        return form.period.exclusions.days.remove();
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.removeDay
	                                )
	                            )
	                        ),
	                        renderTimeSlotForm(alternateForm.period.exclusions.timeSlot, cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions[0] && cmd.period.exclusions[0].timeSlot),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions.length > 0 && form.period.exclusions.isValid() && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return form.period.exclusions.add(null, { timeSlot: { timeSlotType: _models.TIME_SLOT_TYPES[0] } });
	                                    } },
	                                _i18n2.default.addExclusion
	                            ),
	                            cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions.length > 0 && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'danger',
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return form.period.exclusions.remove();
	                                    } },
	                                _i18n2.default.removeExclusion
	                            )
	                        )
	                    )
	                ),
	                form.period.days && _react2.default.createElement(
	                    'div',
	                    { className: _DefineUpdateInterventionPeriodForActivityForm2.default.section },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _i18n2.default.days,
	                        ' ',
	                        _react2.default.createElement(
	                            'i',
	                            null,
	                            '*'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _DefineUpdateInterventionPeriodForActivityForm2.default.group },
	                        cmd && cmd.period && cmd.period.days && cmd.period.days.slice(1).reverse().map(function (day, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        className: _DefineUpdateInterventionPeriodForActivityForm2.default.remove,
	                                        onClick: function onClick(e) {
	                                            return form.period.days.remove(e, day);
	                                        } },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    (0, _moment2.default)(day).format(_i18n2.default.dateFormat.longer)
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DefineUpdateInterventionPeriodForActivityForm2.default.dayPicker },
	                        _react2.default.createElement(_DayPicker2.default, (0, _form.arrayItemField)(form.period.days()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        form.period.days.isValid() && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                onClick: function onClick() {
	                                    return form.period.days.add();
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.add
	                            )
	                        ),
	                        cmd && cmd.period && cmd.period.days && cmd.period.days.length > 1 && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                onClick: function onClick() {
	                                    return form.period.days.remove();
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.remove
	                            )
	                        )
	                    )
	                ),
	                form.period.timeSlot && renderTimeSlotForm(form.period.timeSlot, cmd && cmd.period && cmd.period.timeSlot),
	                form.period.startDate && form.period.endDate && _react2.default.createElement(
	                    'div',
	                    { className: _DefineUpdateInterventionPeriodForActivityForm2.default.section },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        cmd && cmd.period && cmd.period.periodType == 'WeekDaysPeriod' && _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._toggleSection(e, 'StartEndDate');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.period
	                            ),
	                            _react2.default.createElement(_Icon2.default, { icon: openedSections.indexOf('StartEndDate') >= 0 && 'up' || 'down', size: 'xs' })
	                        ),
	                        cmd && cmd.period && cmd.period.periodType != 'WeekDaysPeriod' && _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.period,
	                            ' ',
	                            _react2.default.createElement(
	                                'i',
	                                null,
	                                '*'
	                            )
	                        )
	                    ),
	                    (cmd && cmd.period && cmd.period.periodType != 'WeekDaysPeriod' || openedSections.indexOf('StartEndDate') >= 0) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_DayRangePicker2.default, periodField(form.period())),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            cmd && cmd.period && (cmd.period.startDate || cmd.period.endDate) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                _extends({
	                                    bsStyle: 'link'
	                                }, (0, _form.buttonField)(periodField(form.period()), null)),
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.removeDayRange
	                                )
	                            )
	                        )
	                    )
	                ),
	                interventionPeriods && _react2.default.createElement(
	                    'div',
	                    { className: _DefineUpdateInterventionPeriodForActivityForm2.default.section },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._toggleSection(e, 'Copy');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.fillinAssistant
	                            ),
	                            _react2.default.createElement(_Icon2.default, { icon: openedSections.indexOf('Copy') >= 0 && 'up' || 'down', size: 'xs' })
	                        )
	                    ),
	                    openedSections.indexOf('Copy') >= 0 && _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                type: 'select',
	                                name: 'activity'
	                            }, activeInterventionPeriodField()),
	                            _react2.default.createElement(
	                                'option',
	                                { value: '' },
	                                _i18n2.default.copyInterventionPeriod,
	                                ' ...'
	                            ),
	                            interventionPeriods.map(function (interventionPeriod, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    {
	                                        key: index,
	                                        value: interventionPeriod.uid },
	                                    interventionPeriod.period.label
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick(e) {
	                                return form.validate() && _this2._sendCmd(e) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        interventionPeriod && _i18n2.default.validate || _i18n2.default.save
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineUpdateInterventionPeriodForActivityForm;
	}(_react.Component);
	
	DefineUpdateInterventionPeriodForActivityForm.propTypes = {
	    committed: _react.PropTypes.object.isRequired,
	    activity: _react.PropTypes.object.isRequired,
	    interventionPeriod: _react.PropTypes.object,
	    interventionPeriods: _react.PropTypes.array,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	DefineUpdateInterventionPeriodForActivityForm = (0, _form.connectForm)({
	    name: 'alternateForm',
	    target: 'cmd',
	    schema: _models.DefineUpdateInterventionPeriodForActivityCmd.selectAlternateSchema,
	    action: _actions.DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED
	})(DefineUpdateInterventionPeriodForActivityForm);
	
	DefineUpdateInterventionPeriodForActivityForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.DefineUpdateInterventionPeriodForActivityCmd.selectSchema,
	    action: _actions.DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED
	})(DefineUpdateInterventionPeriodForActivityForm);
	
	DefineUpdateInterventionPeriodForActivityForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.defineUpdateInterventionPeriodForActivityCmd
	    };
	})(DefineUpdateInterventionPeriodForActivityForm);
	
	exports.default = DefineUpdateInterventionPeriodForActivityForm;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _browser = __webpack_require__(54);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(87);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderPicker = __webpack_require__(2282);
	
	var _ProviderPicker2 = _interopRequireDefault(_ProviderPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderPicker = function (_Component) {
	    _inherits(ProviderPicker, _Component);
	
	    function ProviderPicker() {
	        _classCallCheck(this, ProviderPicker);
	
	        return _possibleConstructorReturn(this, (ProviderPicker.__proto__ || Object.getPrototypeOf(ProviderPicker)).apply(this, arguments));
	    }
	
	    _createClass(ProviderPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company;
	
	
	            dispatch((0, _actions.resetProviderMinorCriteria)());
	            dispatch((0, _actions.queryProviderStream)(_extends({}, _actions.DEFAULT_PROVIDER_QUERY, { range: { offset: 0, limit: 99 } })));
	        }
	    }, {
	        key: '_search',
	        value: function _search(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                minorCriteria = _props2.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.queryProviderStream)(minorCriteria));
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props3 = this.props,
	                    dispatch = _props3.dispatch,
	                    minorCriteria = _props3.minorCriteria;
	
	                dispatch((0, _actions.queryProviderStream)(minorCriteria));
	            }
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                minorCriteria = _props4.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.updateProviderMinorCriteria)({ fullText: null }));
	            dispatch((0, _actions.queryProviderStream)(_extends({}, minorCriteria, { fullText: null })));
	        }
	    }, {
	        key: '_load',
	        value: function _load(provider) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _actions.loadProvider)(provider.uid));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props5 = this.props,
	                dispatch = _props5.dispatch,
	                form = _props5.form,
	                minorCriteria = _props5.minorCriteria,
	                stream = _props5.stream,
	                range = _props5.range,
	                query = _props5.query,
	                provider = _props5.provider,
	                onChange = _props5.onChange,
	                others = _objectWithoutProperties(_props5, ['dispatch', 'form', 'minorCriteria', 'stream', 'range', 'query', 'provider', 'onChange']);
	
	            var searched = minorCriteria && minorCriteria.fullText && minorCriteria.fullText == (query && query.fullText);
	
	            var header = _react2.default.createElement(
	                'div',
	                { className: _ProviderPicker2.default.search },
	                searched && _react2.default.createElement(
	                    'a',
	                    {
	                        href: '',
	                        onClick: function onClick(e) {
	                            return _this2._clear(e);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	                ),
	                !searched && _react2.default.createElement(
	                    'a',
	                    {
	                        href: '',
	                        onClick: function onClick(e) {
	                            return _this2._search(e);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ProviderPicker2.default.container },
	                    _react2.default.createElement('input', _extends({
	                        type: 'text',
	                        onKeyPress: function onKeyPress(e) {
	                            return _this2._searchOnKeyPress(e);
	                        },
	                        placeholder: _i18n2.default.searchStream.xs
	                    }, form.fullText()))
	                )
	            );
	
	            var afterProviders = function afterProviders() {
	                if (range && range.limit < range.count - 1) {
	                    var count = range.limit + 1;
	                    return _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _extract.replace)(_i18n2.default.useSearchProviderFilters, { count: count })
	                    );
	                }
	            };
	
	            var displayProvider = function displayProvider(providerPicked, mode) {
	                if (mode == 'Picked') {
	                    providerPicked = provider && provider.uid == providerPicked.uid && provider || providerPicked;
	
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            providerPicked.name
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ProviderPicker2.default.data },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.siret,
	                                    ' :'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    providerPicked.siretNumber
	                                )
	                            )
	                        )
	                    );
	                }
	                return providerPicked.name;
	            };
	
	            var onChangeProvider = function onChangeProvider(provider) {
	                if (provider) {
	                    _this2._load(provider);
	                }
	                onChange(provider);
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Picker2.default, _extends({
	                    source: stream,
	                    identify: function identify(p) {
	                        return p.uid;
	                    },
	                    display: displayProvider,
	                    header: header,
	                    after: afterProviders(),
	                    onChange: onChangeProvider
	                }, others))
	            );
	        }
	    }]);
	
	    return ProviderPicker;
	}(_react.Component);
	
	ProviderPicker.propTypes = {};
	
	
	ProviderPicker = (0, _form.connectForm)({
	    target: 'minorCriteria',
	    schema: _models.ProviderCriteria.schema,
	    action: _actions.PROVIDER_MINOR_CRITERIA_UPDATED
	})(ProviderPicker);
	
	ProviderPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        minorCriteria: state.provider.minorCriteria,
	        stream: state.provider.stream,
	        range: state.provider.range,
	        query: state.provider.query,
	        provider: state.provider.provider
	    };
	})(ProviderPicker);
	
	exports.default = ProviderPicker;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _logoPerfimmo = __webpack_require__(1829);
	
	var _logoPerfimmo2 = _interopRequireDefault(_logoPerfimmo);
	
	var _logoActradis = __webpack_require__(1827);
	
	var _logoActradis2 = _interopRequireDefault(_logoActradis);
	
	var _logoBatiref = __webpack_require__(1828);
	
	var _logoBatiref2 = _interopRequireDefault(_logoBatiref);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderScores = __webpack_require__(2283);
	
	var _ProviderScores2 = _interopRequireDefault(_ProviderScores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function actradisStatus(reportState) {
	    switch (reportState) {
	        case 'OK':
	            return 'success';
	        case 'DocumentExpiredInLessThan15Days':
	            return 'warning';
	        case 'DocumentExpired':
	            return 'danger';
	        default:
	            return 'default';
	    }
	}
	
	var ProviderScores = function (_Component) {
	    _inherits(ProviderScores, _Component);
	
	    function ProviderScores() {
	        _classCallCheck(this, ProviderScores);
	
	        return _possibleConstructorReturn(this, (ProviderScores.__proto__ || Object.getPrototypeOf(ProviderScores)).apply(this, arguments));
	    }
	
	    _createClass(ProviderScores, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                actradisProvider = _props.actradisProvider,
	                _appLinks = _props._appLinks;
	
	
	            var brandStyle = _appLinks.find((0, _links.linkFinder)('actradis/providercompanies')) && { width: '33%' } || { width: '50%' };
	
	            var actradisTooltip = function actradisTooltip(text, reportState) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: 'tooltip-' + actradisStatus(reportState) },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        (0, _extract.replace)((0, _extract2.default)(_i18n2.default.actradisReportStateEnum, reportState || 'noDocument'), { text: text })
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ProviderScores2.default.default },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _i18n2.default.scores
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ProviderScores2.default.brandGroup },
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            className: (0, _classnames2.default)(_ProviderScores2.default.brand, _ProviderScores2.default.batiref),
	                            style: brandStyle },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _ProviderScores2.default.count },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '---'
	                            ),
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                '---'
	                            )
	                        ),
	                        _react2.default.createElement('img', { src: _logoBatiref2.default }),
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            _i18n2.default.batiref
	                        )
	                    ),
	                    _appLinks.find((0, _links.linkFinder)('actradis/providercompanies')) && _react2.default.createElement(
	                        'div',
	                        {
	                            className: (0, _classnames2.default)(_ProviderScores2.default.brand, _ProviderScores2.default.actradis),
	                            style: brandStyle },
	                        _react2.default.createElement(
	                            _reactBootstrap.OverlayTrigger,
	                            {
	                                placement: 'bottom',
	                                overlay: actradisTooltip(_i18n2.default.undeclaredWorkReportState.sm, actradisProvider && actradisProvider.undeclaredWorkReportState) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_ProviderScores2.default.count, _ProviderScores2.default[(0, _extract.sanitize)(actradisProvider && actradisProvider.undeclaredWorkReportState)]) },
	                                _react2.default.createElement('span', null),
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    _i18n2.default.undeclaredWorkReportState.xs
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.OverlayTrigger,
	                            {
	                                placement: 'bottom',
	                                overlay: actradisTooltip(_i18n2.default.insuranceReportState.sm, actradisProvider && actradisProvider.insuranceReportState) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_ProviderScores2.default.count, _ProviderScores2.default[(0, _extract.sanitize)(actradisProvider && actradisProvider.insuranceReportState)]) },
	                                _react2.default.createElement('span', null),
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    _i18n2.default.insuranceReportState.xs
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.OverlayTrigger,
	                            {
	                                placement: 'bottom',
	                                overlay: actradisTooltip(_i18n2.default.specificDocumentsReportState.sm, actradisProvider && actradisProvider.specificDocumentsReportState) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_ProviderScores2.default.count, _ProviderScores2.default[(0, _extract.sanitize)(actradisProvider && actradisProvider.specificDocumentsReportState)]) },
	                                _react2.default.createElement('span', null),
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    _i18n2.default.specificDocumentsReportState.xs
	                                )
	                            )
	                        ),
	                        _react2.default.createElement('img', { src: _logoActradis2.default }),
	                        _react2.default.createElement(
	                            'small',
	                            null,
	                            _i18n2.default.actradis
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderScores;
	}(_react.Component);
	
	ProviderScores.propTypes = {};
	
	
	ProviderScores = (0, _reactRedux.connect)(function (state) {
	    return {
	        actradisProvider: state.actradis.provider.provider,
	        _appLinks: state.app._links
	    };
	})(ProviderScores);
	
	exports.default = ProviderScores;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _actions = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityPicker = function (_Component) {
	    _inherits(ActivityPicker, _Component);
	
	    function ActivityPicker() {
	        _classCallCheck(this, ActivityPicker);
	
	        return _possibleConstructorReturn(this, (ActivityPicker.__proto__ || Object.getPrototypeOf(ActivityPicker)).apply(this, arguments));
	    }
	
	    _createClass(ActivityPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _actions.queryActivityRef)());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                reference = _props.reference,
	                others = _objectWithoutProperties(_props, ['reference']);
	
	            var displayActivity = function displayActivity(activity, mode) {
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'h4',
	                        null,
	                        activity.label
	                    );
	                }
	                return activity.label;
	            };
	
	            return _react2.default.createElement(_Picker2.default, _extends({
	                source: reference,
	                identify: function identify(a) {
	                    return a.uid;
	                },
	                display: displayActivity
	            }, others));
	        }
	    }]);
	
	    return ActivityPicker;
	}(_react.Component);
	
	ActivityPicker.propTypes = {};
	
	
	ActivityPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        reference: state.reference.activityRef
	    };
	})(ActivityPicker);
	
	exports.default = ActivityPicker;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _mathz = __webpack_require__(108);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _Rating = __webpack_require__(531);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AverageNoteDashboardPanel = __webpack_require__(2307);
	
	var _AverageNoteDashboardPanel2 = _interopRequireDefault(_AverageNoteDashboardPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AverageNoteDashboardPanel = function (_Component) {
	    _inherits(AverageNoteDashboardPanel, _Component);
	
	    function AverageNoteDashboardPanel(props) {
	        _classCallCheck(this, AverageNoteDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (AverageNoteDashboardPanel.__proto__ || Object.getPrototypeOf(AverageNoteDashboardPanel)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(AverageNoteDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var campaign = this.props.campaign;
	
	
	            var maxScore = campaign && (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                    return s.position;
	                } });
	            this.setState({ maxScore: maxScore });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.campaign != this.props.campaign) {
	                var campaign = nextProps.campaign;
	
	
	                var maxScore = campaign && (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                        return s.position;
	                    } });
	                this.setState({ maxScore: maxScore });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                authenticated = _props.authenticated,
	                campaign = _props.campaign,
	                others = _objectWithoutProperties(_props, ['dispatch', 'authenticated', 'campaign']);
	
	            var maxScore = this.state.maxScore;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader(_i18n2.default.averageScore),
	                    onClick: authenticated.company && function () {
	                        return dispatch((0, _reactRouterRedux.push)('/organisations/' + authenticated.company.uid + '/satisfactioncampaigns/' + campaign.uid));
	                    }
	                }, others),
	                !!campaign && _react2.default.createElement(
	                    'div',
	                    { className: _AverageNoteDashboardPanel2.default.defaultContent },
	                    _react2.default.createElement(_Rating2.default, {
	                        range: maxScore,
	                        label: _i18n2.default.score,
	                        value: campaign.stats.averageNote })
	                )
	            );
	        }
	    }]);
	
	    return AverageNoteDashboardPanel;
	}(_react.Component);
	
	AverageNoteDashboardPanel.propTypes = {};
	
	
	AverageNoteDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        campaign: state.satisfaction.campaign.campaign
	    };
	})(AverageNoteDashboardPanel);
	
	exports.default = AverageNoteDashboardPanel;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _browser = __webpack_require__(54);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _CheckboxToggle = __webpack_require__(508);
	
	var _CheckboxToggle2 = _interopRequireDefault(_CheckboxToggle);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ExportTicketsModal = __webpack_require__(2320);
	
	var _ExportTicketsModal2 = _interopRequireDefault(_ExportTicketsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PDF_TICKET_MAX_COUNT = 350;
	var EXPORT_TYPES = ['ExportXlsx', 'ExportPdf', 'ReportPdf'];
	
	function restrictExportTypes(ticket) {
	    if (ticket) return ['ExportPdf'];
	    return EXPORT_TYPES;
	}
	
	var ExportTicketsModal = function (_Component) {
	    _inherits(ExportTicketsModal, _Component);
	
	    function ExportTicketsModal(props) {
	        _classCallCheck(this, ExportTicketsModal);
	
	        var _this = _possibleConstructorReturn(this, (ExportTicketsModal.__proto__ || Object.getPrototypeOf(ExportTicketsModal)).call(this, props));
	
	        _this.state = {
	            exportTypes: []
	        };
	        return _this;
	    }
	
	    _createClass(ExportTicketsModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                exportXlsxTicketsOption = _props.exportXlsxTicketsOption,
	                reportPdfTicketsOption = _props.reportPdfTicketsOption,
	                ticket = _props.ticket;
	
	
	            var exportTypes = restrictExportTypes(ticket);
	            var exportType = exportTypes[0];
	            this.setState({ exportTypes: exportTypes, exportType: exportType });
	
	            if (!exportXlsxTicketsOption) {
	                dispatch((0, _actions.updateExportXlsxTicketsOption)({
	                    ticketSheetColumns: _models.XLSX_TICKET_SHEET_COLUMNS,
	                    ticketSheetAdditionalData: true
	                }));
	            }
	
	            if (!reportPdfTicketsOption) {
	                dispatch((0, _actions.updateReportPdfTicketsOption)({
	                    pages: _models.PDF_REPORT_PAGES
	                }));
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket != this.props.ticket) {
	                var ticket = nextProps.ticket;
	
	
	                var exportTypes = restrictExportTypes(ticket);
	                var exportType = exportTypes[0];
	                this.setState({ exportTypes: exportTypes, exportType: exportType });
	            }
	        }
	    }, {
	        key: '_exportXlsx',
	        value: function _exportXlsx() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                query = _props2.query,
	                exportXlsxTicketsOption = _props2.exportXlsxTicketsOption,
	                onHide = _props2.onHide;
	
	
	            if (!(0, _browser.supportWorker)()) {
	                // fallback on download
	                var payload = _extends({ type: 'XlsxTicketsExport', option: exportXlsxTicketsOption }, query);
	                var encodedPayload = btoa(JSON.stringify(payload));
	                window.open('/download/' + encodedPayload, '_blank');
	                onHide();
	                return true;
	            }
	
	            return Promise.resolve(dispatch((0, _actions.exportXlsxTickets)())).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_exportPdf',
	        value: function _exportPdf() {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                query = _props3.query,
	                range = _props3.range,
	                exportPdfTicketsOption = _props3.exportPdfTicketsOption,
	                ticket = _props3.ticket,
	                onHide = _props3.onHide;
	
	
	            if (ticket) {
	                if (!(0, _browser.supportWorker)()) {
	                    // fallback on download
	                    var payload = { type: 'PdfTicketExport', ticketUid: ticket.uid, option: exportPdfTicketsOption };
	                    var encodedPayload = btoa(JSON.stringify(payload));
	                    window.open('/download/' + encodedPayload, '_blank');
	                    onHide();
	                    return true;
	                }
	
	                return Promise.resolve(dispatch((0, _actions.exportPdfTicket)())).then(function () {
	                    onHide();
	                });
	            }
	
	            if (range.count <= PDF_TICKET_MAX_COUNT) {
	                if (!(0, _browser.supportWorker)()) {
	                    // fallback on download
	                    var _payload = _extends({ type: 'PdfTicketsExport', option: exportPdfTicketsOption }, query);
	                    var _encodedPayload = btoa(JSON.stringify(_payload));
	                    window.open('/download/' + _encodedPayload, '_blank');
	                    onHide();
	                    return true;
	                }
	
	                return Promise.resolve(dispatch((0, _actions.exportPdfTickets)())).then(function () {
	                    onHide();
	                });
	            }
	            dispatch((0, _status.errorStatus)(_i18n2.default.maxTicketPdfExportSizeExceeded));
	        }
	    }, {
	        key: '_reportPdf',
	        value: function _reportPdf() {
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                query = _props4.query,
	                reportPdfTicketsOption = _props4.reportPdfTicketsOption,
	                onHide = _props4.onHide;
	
	
	            if (!(0, _browser.supportWorker)()) {
	                // fallback on download
	                var payload = _extends({ type: 'PdfTicketsReport', option: reportPdfTicketsOption }, query);
	                var encodedPayload = btoa(JSON.stringify(payload));
	                window.open('/download/' + encodedPayload, '_blank');
	                onHide();
	                return true;
	            }
	
	            return Promise.resolve(dispatch((0, _actions.reportPdfTickets)())).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_toogle',
	        value: function _toogle(exportType) {
	            if (exportType) {
	                this.setState({ exportType: exportType });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props5 = this.props,
	                dispatch = _props5.dispatch,
	                exportXlsxTicketsForm = _props5.exportXlsxTicketsForm,
	                exportPdfTicketsForm = _props5.exportPdfTicketsForm,
	                reportPdfTicketsForm = _props5.reportPdfTicketsForm,
	                exportXlsxTicketsOption = _props5.exportXlsxTicketsOption,
	                exportPdfTicketsOption = _props5.exportPdfTicketsOption,
	                reportPdfTicketsOption = _props5.reportPdfTicketsOption,
	                query = _props5.query,
	                range = _props5.range,
	                ticket = _props5.ticket,
	                onHide = _props5.onHide,
	                others = _objectWithoutProperties(_props5, ['dispatch', 'exportXlsxTicketsForm', 'exportPdfTicketsForm', 'reportPdfTicketsForm', 'exportXlsxTicketsOption', 'exportPdfTicketsOption', 'reportPdfTicketsOption', 'query', 'range', 'ticket', 'onHide']);
	
	            var _state = this.state,
	                exportTypes = _state.exportTypes,
	                exportType = _state.exportType;
	
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.exportTickets
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ExportTicketsModal2.default.exportType },
	                        _react2.default.createElement(
	                            _ButtonToggle2.default,
	                            {
	                                value: exportType,
	                                onChange: function onChange(exportType) {
	                                    return _this2._toogle(exportType);
	                                } },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _ExportTicketsModal2.default.container },
	                                exportTypes.map(function (exportType, index) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        {
	                                            key: index },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'link',
	                                                value: exportType },
	                                            _react2.default.createElement(_Icon2.default, { icon: exportType, size: 'xl' }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                (0, _extract2.default)(_i18n2.default.ticketExportEnum, exportType)
	                                            )
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    exportType == 'ExportXlsx' && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement(
	                                _CheckboxToggle2.default,
	                                exportXlsxTicketsForm.ticketSheetColumns(),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _models.XLSX_TICKET_SHEET_COLUMNS.slice(0, _models.XLSX_TICKET_SHEET_COLUMNS.length / 2).map(function (column, index) {
	                                            return _react2.default.createElement(_reactBootstrap.Input, {
	                                                key: index,
	                                                type: 'checkbox',
	                                                label: (0, _extract2.default)(_i18n2.default.xlsxTicketSheetColumnEnum, column),
	                                                value: column });
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _models.XLSX_TICKET_SHEET_COLUMNS.slice(_models.XLSX_TICKET_SHEET_COLUMNS.length / 2, _models.XLSX_TICKET_SHEET_COLUMNS.length).map(function (column, index) {
	                                            return _react2.default.createElement(_reactBootstrap.Input, {
	                                                key: index,
	                                                type: 'checkbox',
	                                                label: (0, _extract2.default)(_i18n2.default.xlsxTicketSheetColumnEnum, column),
	                                                value: column });
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6, smOffset: 6 },
	                                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                        type: 'checkbox',
	                                        label: _i18n2.default.additionalData
	                                    }, (0, _form.checkboxField)(exportXlsxTicketsForm.ticketSheetAdditionalData())))
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    className: (0, _classnames2.default)({ disabled: !exportXlsxTicketsForm.isValid() }),
	                                    onClick: function onClick() {
	                                        return exportXlsxTicketsForm.validate() && (_this2._exportXlsx() || true) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _i18n2.default.exportz
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    ),
	                    exportType == 'ExportPdf' && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement(
	                                _CheckboxToggle2.default,
	                                exportPdfTicketsForm.pages(),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _models.PDF_EXPORT_PAGES.map(function (page, index) {
	                                            return _react2.default.createElement(_reactBootstrap.Input, {
	                                                key: index,
	                                                type: 'checkbox',
	                                                label: (0, _extract2.default)(_i18n2.default.pdfExportPageEnum, page),
	                                                value: page });
	                                        })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return _this2._exportPdf();
	                                    } },
	                                _i18n2.default.exportz
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    ),
	                    exportType == 'ReportPdf' && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement(
	                                _CheckboxToggle2.default,
	                                reportPdfTicketsForm.pages(),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _models.PDF_REPORT_PAGES.slice(0, _models.PDF_REPORT_PAGES.length / 2 + 1).map(function (page, index) {
	                                            return _react2.default.createElement(_reactBootstrap.Input, {
	                                                key: index,
	                                                type: 'checkbox',
	                                                label: (0, _extract2.default)(_i18n2.default.pdfReportPageEnum, page),
	                                                value: page });
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _models.PDF_REPORT_PAGES.slice(_models.PDF_REPORT_PAGES.length / 2 + 1, _models.PDF_REPORT_PAGES.length).map(function (page, index) {
	                                            return _react2.default.createElement(_reactBootstrap.Input, {
	                                                key: index,
	                                                type: 'checkbox',
	                                                label: (0, _extract2.default)(_i18n2.default.pdfReportPageEnum, page),
	                                                value: page });
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _ExportTicketsModal2.default.info },
	                                    _i18n2.default.reportPdfInfo
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return _this2._reportPdf();
	                                    } },
	                                _i18n2.default.exportz
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ExportTicketsModal;
	}(_react.Component);
	
	ExportTicketsModal.propTypes = {
	    ticket: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ExportTicketsModal = (0, _form.connectForm)({
	    name: 'exportXlsxTicketsForm',
	    target: 'exportXlsxTicketsOption',
	    alias: 'option',
	    schema: _models.ExportXlsxTicketsOption.schema,
	    action: _actions.EXPORT_XLSX_TICKETS_OPTION_UPDATED
	})(ExportTicketsModal);
	
	ExportTicketsModal = (0, _form.connectForm)({
	    name: 'exportPdfTicketsForm',
	    target: 'exportPdfTicketsOption',
	    alias: 'option',
	    schema: _models.ExportPdfTicketsOption.schema,
	    action: _actions.EXPORT_PDF_TICKETS_OPTION_UPDATED
	})(ExportTicketsModal);
	
	ExportTicketsModal = (0, _form.connectForm)({
	    name: 'reportPdfTicketsForm',
	    target: 'reportPdfTicketsOption',
	    alias: 'option',
	    schema: _models.ReportPdfTicketsOption.schema,
	    action: _actions.REPORT_PDF_TICKETS_OPTION_UPDATED
	})(ExportTicketsModal);
	
	ExportTicketsModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        exportXlsxTicketsOption: state.ticket.exportXlsxTicketsOption,
	        exportPdfTicketsOption: state.ticket.exportPdfTicketsOption,
	        reportPdfTicketsOption: state.ticket.reportPdfTicketsOption,
	        query: state.ticket.query,
	        range: state.ticket.range
	    };
	})(ExportTicketsModal);
	
	exports.default = ExportTicketsModal;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _CompanyPicker = __webpack_require__(951);
	
	var _CompanyPicker2 = _interopRequireDefault(_CompanyPicker);
	
	var _SubsidiaryPicker = __webpack_require__(1333);
	
	var _SubsidiaryPicker2 = _interopRequireDefault(_SubsidiaryPicker);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BILLING_TYPE = ['StandardAccount', 'PremiumAccount'];
	
	function getUserCompany(user) {
	    switch (user.userType) {
	        case 'executive':
	        case 'patrimonyManager':
	            return user.company;
	        case 'clientAccountManager':
	            return !user.isPartOfHolding && user.company || undefined;
	        default:
	            return undefined;
	    }
	}
	
	function getHolding(user) {
	    if (user.isPartOfHolding) return user.company;
	    return null;
	}
	
	var OpenTicketCompanyModal = function (_Component) {
	    _inherits(OpenTicketCompanyModal, _Component);
	
	    function OpenTicketCompanyModal(props) {
	        _classCallCheck(this, OpenTicketCompanyModal);
	
	        var _this = _possibleConstructorReturn(this, (OpenTicketCompanyModal.__proto__ || Object.getPrototypeOf(OpenTicketCompanyModal)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(OpenTicketCompanyModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                authenticated = _props.authenticated;
	
	
	            var company = getUserCompany(authenticated);
	            var holding = getHolding(authenticated);
	
	            dispatch((0, _actions.updateOpenTicketCmd)({ company: company, locationRef: { locationReferenceType: 'PatrimonyLocation' } }));
	
	            var opened = !company;
	            this.setState({ opened: opened, holding: holding });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.authenticated != this.props.authenticated) {
	                var dispatch = nextProps.dispatch,
	                    authenticated = nextProps.authenticated;
	
	
	                var company = getUserCompany(authenticated);
	                var holding = getHolding(authenticated);
	
	                dispatch((0, _actions.updateOpenTicketCmd)({ company: company }));
	
	                this.setState({ holding: holding });
	            }
	            if (nextProps.cmd && nextProps.cmd != this.props.cmd) {
	                if (nextProps.cmd.company != (this.props.cmd && this.props.cmd.company)) {
	                    var cmd = nextProps.cmd;
	                    var opened = this.state.opened;
	
	
	                    var nextOpened = opened || !cmd.company;
	                    this.setState({ opened: nextOpened });
	                }
	            }
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({ opened: false });
	            return true;
	        }
	    }, {
	        key: '_cancel',
	        value: function _cancel(e) {
	            var onSubmit = this.props.onSubmit;
	
	
	            this.setState({ opened: false });
	            onSubmit && onSubmit(e, 'Cancel');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                authenticated = _props2.authenticated,
	                onSubmit = _props2.onSubmit,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'authenticated', 'onSubmit']);
	
	            var _state = this.state,
	                opened = _state.opened,
	                holding = _state.holding;
	
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    show: opened
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.pickCompany
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    holding && _react2.default.createElement(_SubsidiaryPicker2.default, _extends({
	                        holding: holding
	                    }, form.company())),
	                    !holding && _react2.default.createElement(_CompanyPicker2.default, _extends({
	                        billingType: BILLING_TYPE,
	                        includeSubsidiaries: true
	                    }, form.company())),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.company.isValid() }),
	                                onClick: function onClick() {
	                                    return (form.validate() || form.company.isValid()) && _this2._close() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return _this2._cancel(e);
	                                } },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketCompanyModal;
	}(_react.Component);
	
	OpenTicketCompanyModal.propTypes = {
	    onSubmit: _react.PropTypes.func
	};
	
	
	OpenTicketCompanyModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.OpenTicketCmd.schema,
	    action: _actions.OPEN_TICKET_CMD_UPDATED
	})(OpenTicketCompanyModal);
	
	OpenTicketCompanyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        cmd: state.ticket.openTicketCmd
	    };
	})(OpenTicketCompanyModal);
	
	exports.default = OpenTicketCompanyModal;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _phonez = __webpack_require__(40);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OpenTicketContactToCallbackCard = __webpack_require__(2325);
	
	var _OpenTicketContactToCallbackCard2 = _interopRequireDefault(_OpenTicketContactToCallbackCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function callerToContactToCallbackCmd(caller) {
	    if (caller && caller.callerType == 'HumanCaller') {
	        return {
	            namez: (0, _models.nameToPlainName)(caller.namez),
	            medium: caller.medium
	        };
	    }
	    if (caller && caller.callerType == 'ReferencedContactCaller') {
	        return caller.uid && {
	            namez: (0, _models.nameToPlainName)(caller.uid.name),
	            medium: (0, _models.mediumToContactMedium)(caller.uid.contacts[0])
	        };
	    }
	    return caller;
	}
	
	var OpenTicketContactToCallbackCard = function (_Component) {
	    _inherits(OpenTicketContactToCallbackCard, _Component);
	
	    function OpenTicketContactToCallbackCard(props) {
	        _classCallCheck(this, OpenTicketContactToCallbackCard);
	
	        var _this = _possibleConstructorReturn(this, (OpenTicketContactToCallbackCard.__proto__ || Object.getPrototypeOf(OpenTicketContactToCallbackCard)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(OpenTicketContactToCallbackCard, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.cmd && nextProps.cmd != this.props.cmd) {
	                if (nextProps.cmd.ticket != (this.props.cmd && this.props.cmd.ticket) && nextProps.cmd.ticket.callerz != (this.props.cmd && this.props.cmd.ticket && this.props.cmd.ticket.callerz)) {
	                    var dispatch = nextProps.dispatch,
	                        cmd = nextProps.cmd;
	                    var sameAsCaller = this.state.sameAsCaller;
	
	
	                    if (sameAsCaller) {
	                        var ticket = cmd && cmd.ticket;
	                        var callerz = cmd && cmd.ticket && cmd.ticket.callerz;
	                        var contactToCallback = cmd && cmd.ticket && cmd.ticket.contactToCallback;
	
	                        var nextContactToCallback = callerToContactToCallbackCmd(callerz);
	                        nextContactToCallback = nextContactToCallback && _extends({}, contactToCallback, nextContactToCallback);
	                        dispatch((0, _actions.updateOpenTicketCmd)({ ticket: _extends({}, ticket, { contactToCallback: nextContactToCallback }) }));
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'cmd']);
	
	            var sameAsCaller = this.state.sameAsCaller;
	
	
	            var sameAsCallerField = function sameAsCallerField() {
	                var value = sameAsCaller;
	
	                var onChange = function onChange(sameAsCaller) {
	                    var ticket = cmd && cmd.ticket;
	                    var callerz = cmd && cmd.ticket && cmd.ticket.callerz;
	
	                    var contactToCallback = sameAsCaller && callerToContactToCallbackCmd(callerz) || null;
	                    dispatch((0, _actions.updateOpenTicketCmd)({ ticket: _extends({}, ticket, { contactToCallback: contactToCallback }) }));
	
	                    _this2.setState({ sameAsCaller: sameAsCaller });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var mediumField = function mediumField(field, type) {
	                var disabled = field.value && field.value.contactMediumType != type || field.disabled;
	                var value;
	
	                switch (type) {
	                    case 'Phone':
	                        value = field.value && field.value.phone;
	                        break;
	                    case 'Mail':
	                        value = field.value && field.value.mail;
	                        break;
	                    case 'Fax':
	                        value = field.value && field.value.fax;
	                        break;
	                }
	
	                function onChange(eventOrValue) {
	                    var value;
	                    if (eventOrValue && eventOrValue.target) {
	                        value = eventOrValue.target.value;
	                    } else {
	                        value = eventOrValue;
	                    }
	
	                    var medium;
	                    switch (type) {
	                        case 'Phone':
	                            medium = value && { phone: value, contactMediumType: 'Phone' } || null;
	                            break;
	                        case 'Mail':
	                            medium = value && { mail: value, contactMediumType: 'Mail' } || null;
	                            break;
	                        case 'Fax':
	                            medium = value && { fax: value, contactMediumType: 'Fax' } || null;
	                            break;
	                    }
	
	                    field.onChange(medium);
	                }
	
	                return _extends({}, field, { disabled: disabled, value: value, onChange: onChange });
	            };
	
	            var disabledField = function disabledField(field, disabled) {
	                return _extends({}, field, { disabled: disabled });
	            };
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.contactToCallback
	            );
	
	            var inputAddon = function inputAddon(icon) {
	                return _react2.default.createElement(_Icon2.default, { icon: icon, size: 'xs' });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _OpenTicketContactToCallbackCard2.default.defaultContent },
	                        _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'name',
	                                placeholder: _i18n2.default.name + ' *',
	                                disabled: sameAsCaller
	                            }, form.ticket.contactToCallback.namez())),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'phone',
	                                placeholder: _i18n2.default.phone,
	                                addonBefore: inputAddon('phone'),
	                                disabled: sameAsCaller
	                            }, (0, _phonez.phoneField)(mediumField(disabledField(form.ticket.contactToCallback.medium(), sameAsCaller), 'Phone')))),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'email',
	                                placeholder: _i18n2.default.email,
	                                addonBefore: inputAddon('mail'),
	                                disabled: sameAsCaller
	                            }, mediumField(disabledField(form.ticket.contactToCallback.medium(), sameAsCaller), 'Mail'))),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'fax',
	                                placeholder: _i18n2.default.fax,
	                                addonBefore: inputAddon('fax'),
	                                disabled: sameAsCaller
	                            }, (0, _phonez.phoneField)(mediumField(disabledField(form.ticket.contactToCallback.medium(), sameAsCaller), 'Fax')))),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'textarea',
	                                name: 'comment',
	                                placeholder: _i18n2.default.comment
	                            }, (0, _form.controlledField)(form.ticket.contactToCallback.comment())))
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'checkbox',
	                            label: _i18n2.default.contactToCallbackSameAsCaller
	                        }, (0, _form.checkboxField)(sameAsCallerField())))
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketContactToCallbackCard;
	}(_react.Component);
	
	OpenTicketContactToCallbackCard.propTypes = {
	    dispatch: _react.PropTypes.func.isRequired,
	    form: _react.PropTypes.func.isRequired,
	    cmd: _react.PropTypes.object
	};
	exports.default = OpenTicketContactToCallbackCard;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _form = __webpack_require__(15);
	
	var _CardGroup = __webpack_require__(952);
	
	var _CardGroup2 = _interopRequireDefault(_CardGroup);
	
	var _models = __webpack_require__(49);
	
	var _actions = __webpack_require__(38);
	
	var _OpenTicketCallerCard = __webpack_require__(969);
	
	var _OpenTicketCallerCard2 = _interopRequireDefault(_OpenTicketCallerCard);
	
	var _OpenTicketContactToCallbackCard = __webpack_require__(1108);
	
	var _OpenTicketContactToCallbackCard2 = _interopRequireDefault(_OpenTicketContactToCallbackCard);
	
	var _OpenTicketAddressCard = __webpack_require__(968);
	
	var _OpenTicketAddressCard2 = _interopRequireDefault(_OpenTicketAddressCard);
	
	var _OpenTicketPurposeCard = __webpack_require__(1110);
	
	var _OpenTicketPurposeCard2 = _interopRequireDefault(_OpenTicketPurposeCard);
	
	var _OpenTicketRequestCard = __webpack_require__(1111);
	
	var _OpenTicketRequestCard2 = _interopRequireDefault(_OpenTicketRequestCard);
	
	var _OpenTicketButtonToolbar = __webpack_require__(1509);
	
	var _OpenTicketButtonToolbar2 = _interopRequireDefault(_OpenTicketButtonToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var schemaCache = (0, _cache2.default)();
	
	function selectSchema(target, _ref) {
	    var step = _ref.step;
	
	    var schema = _models.OpenTicketCmd.selectSchema(target);
	
	    return schemaCache([schema, step], function () {
	        if (step == 0.1) {
	            return _extends({}, schema, {
	                properties: {
	                    company: schema.properties.company,
	                    locationRef: schema.properties.locationRef,
	                    ticket: _extends({}, schema.properties.ticket, {
	                        properties: {
	                            callerz: schema.properties.ticket.properties.callerz,
	                            contactToCallback: schema.properties.ticket.properties.contactToCallback,
	                            address: schema.properties.ticket.properties.address
	                        },
	                        required: ['callerz', 'address']
	                    })
	                },
	                required: ['company', 'locationRef', 'ticket']
	            });
	        }
	        return schema;
	    });
	}
	
	var OpenTicketLayout = function (_Component) {
	    _inherits(OpenTicketLayout, _Component);
	
	    function OpenTicketLayout() {
	        _classCallCheck(this, OpenTicketLayout);
	
	        return _possibleConstructorReturn(this, (OpenTicketLayout.__proto__ || Object.getPrototypeOf(OpenTicketLayout)).apply(this, arguments));
	    }
	
	    _createClass(OpenTicketLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd,
	                step = _props.step,
	                onSubmit = _props.onSubmit,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'cmd', 'step', 'onSubmit']);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_OpenTicketAddressCard2.default, { split: true,
	                    dispatch: dispatch,
	                    form: form,
	                    cmd: cmd }),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_OpenTicketCallerCard2.default, {
	                            dispatch: dispatch,
	                            form: form,
	                            cmd: cmd })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_OpenTicketContactToCallbackCard2.default, {
	                            position: 'right',
	                            dispatch: dispatch,
	                            form: form,
	                            cmd: cmd })
	                    )
	                ),
	                step == 0.2 && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_OpenTicketPurposeCard2.default, {
	                        dispatch: dispatch,
	                        form: form,
	                        cmd: cmd }),
	                    _react2.default.createElement(
	                        _CardGroup2.default,
	                        null,
	                        _react2.default.createElement(_OpenTicketRequestCard2.default, {
	                            dispatch: dispatch,
	                            form: form,
	                            cmd: cmd })
	                    )
	                ),
	                _react2.default.createElement(_OpenTicketButtonToolbar2.default, {
	                    dispatch: dispatch,
	                    form: form,
	                    cmd: cmd,
	                    step: step,
	                    onSubmit: onSubmit })
	            );
	        }
	    }]);
	
	    return OpenTicketLayout;
	}(_react.Component);
	
	OpenTicketLayout.propTypes = {
	    step: _react.PropTypes.number.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	OpenTicketLayout = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: selectSchema,
	    action: _actions.OPEN_TICKET_CMD_UPDATED
	})(OpenTicketLayout);
	
	OpenTicketLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.openTicketCmd
	    };
	})(OpenTicketLayout);
	
	exports.default = OpenTicketLayout;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Markdown = __webpack_require__(543);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OpeningTicketPurposePicker = __webpack_require__(897);
	
	var _OpeningTicketPurposePicker2 = _interopRequireDefault(_OpeningTicketPurposePicker);
	
	var _actions = __webpack_require__(533);
	
	var _actions2 = __webpack_require__(38);
	
	var _OpenTicketPurposeCard = __webpack_require__(2327);
	
	var _OpenTicketPurposeCard2 = _interopRequireDefault(_OpenTicketPurposeCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenTicketPurposeCard = function (_Component) {
	    _inherits(OpenTicketPurposeCard, _Component);
	
	    function OpenTicketPurposeCard() {
	        _classCallCheck(this, OpenTicketPurposeCard);
	
	        return _possibleConstructorReturn(this, (OpenTicketPurposeCard.__proto__ || Object.getPrototypeOf(OpenTicketPurposeCard)).apply(this, arguments));
	    }
	
	    _createClass(OpenTicketPurposeCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd;
	
	
	            if (cmd && cmd.company && cmd.ticket && cmd.ticket.openingTicketPurpose) {
	                var company = cmd.company;
	                var openingTicketPurpose = cmd.ticket.openingTicketPurpose;
	
	                var query = {
	                    openingTicketPurpose: openingTicketPurpose.uid
	                };
	                dispatch((0, _actions.queryOpeningTicketInstructionStream)(company, query));
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.cmd && nextProps.cmd.company != (this.props.cmd && this.props.cmd.company) || nextProps.cmd && nextProps.cmd.ticket && nextProps.cmd.ticket.openingTicketPurpose != (this.props.cmd && this.props.cmd.ticket && this.props.cmd.ticket.openingTicketPurpose)) {
	                var dispatch = nextProps.dispatch,
	                    cmd = nextProps.cmd;
	
	
	                if (cmd && cmd.company && cmd.ticket && cmd.ticket.openingTicketPurpose) {
	                    var company = cmd.company;
	                    var openingTicketPurpose = cmd.ticket.openingTicketPurpose;
	
	                    var query = {
	                        openingTicketPurpose: openingTicketPurpose.uid
	                    };
	                    dispatch((0, _actions.queryOpeningTicketInstructionStream)(company, query));
	                }
	            }
	            if (nextProps.openingTicketInstructionStream != this.props.openingTicketInstructionStream) {
	                var _dispatch = nextProps.dispatch,
	                    openingTicketInstructionStream = nextProps.openingTicketInstructionStream;
	
	
	                var acknowledgeInstruction = null;
	                if (openingTicketInstructionStream.length > 0) {
	                    acknowledgeInstruction = false;
	                }
	                _dispatch((0, _actions2.updateOpenTicketCmd)({ acknowledgeInstruction: acknowledgeInstruction }));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                openingTicketInstructionStream = _props2.openingTicketInstructionStream,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'openingTicketInstructionStream']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.diagnostic
	            );
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                cmd && cmd.company && _react2.default.createElement(
	                    _OpeningTicketPurposePicker2.default,
	                    _extends({
	                        company: cmd.company,
	                        onQualificationChange: function onQualificationChange(e) {
	                            return dispatch((0, _actions2.updateOpenTicketCmd)(e));
	                        }
	                    }, form.ticket.openingTicketPurpose()),
	                    openingTicketInstructionStream.length > 0 && _react2.default.createElement(
	                        'div',
	                        { className: _OpenTicketPurposeCard2.default.openingTicketInstruction },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _i18n2.default.openingTicketInstruction
	                        ),
	                        _react2.default.createElement(_Markdown2.default, { markdown: openingTicketInstructionStream[0].text }),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'checkbox',
	                            label: requiredLabel(_i18n2.default.acknowledgeInstruction)
	                        }, (0, _form.checkboxField)(form.acknowledgeInstruction())))
	                    ),
	                    openingTicketInstructionStream.length == 0 && _react2.default.createElement('span', null)
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketPurposeCard;
	}(_react.Component);
	
	OpenTicketPurposeCard.propTypes = {
	    dispatch: _react.PropTypes.func.isRequired,
	    form: _react.PropTypes.func.isRequired,
	    cmd: _react.PropTypes.object
	};
	
	
	OpenTicketPurposeCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        openingTicketInstructionStream: state.message.openingTicketInstruction.stream
	    };
	})(OpenTicketPurposeCard);
	
	exports.default = OpenTicketPurposeCard;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _form = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenTicketRequestCard = function (_Component) {
	    _inherits(OpenTicketRequestCard, _Component);
	
	    function OpenTicketRequestCard() {
	        _classCallCheck(this, OpenTicketRequestCard);
	
	        return _possibleConstructorReturn(this, (OpenTicketRequestCard.__proto__ || Object.getPrototypeOf(OpenTicketRequestCard)).apply(this, arguments));
	    }
	
	    _createClass(OpenTicketRequestCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'cmd']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.request
	            );
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'textarea',
	                                rows: 4,
	                                placeholder: _i18n2.default.request + ' *'
	                            }, form.ticket.request()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'textarea',
	                                rows: 4,
	                                placeholder: _i18n2.default.instructions
	                            }, form.ticket.instructions()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'checkbox',
	                                label: _i18n2.default.restrictedAccess
	                            }, (0, _form.checkboxField)(form.restrictedAccess())))
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketRequestCard;
	}(_react.Component);
	
	OpenTicketRequestCard.propTypes = {
	    dispatch: _react.PropTypes.func.isRequired,
	    form: _react.PropTypes.func.isRequired,
	    cmd: _react.PropTypes.object
	};
	exports.default = OpenTicketRequestCard;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _TicketStreamCard = __webpack_require__(1530);
	
	var _TicketStreamCard2 = _interopRequireDefault(_TicketStreamCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getCallerFromOpenTicketCmd(cmd) {
	    var caller = cmd.ticket.callerz;
	
	    switch (caller.callerType) {
	        case 'ReferencedContactCaller':
	            return {
	                name: caller.uid.name,
	                medium: caller.uid.contacts
	            };
	        case 'HumanCaller':
	            return {
	                name: caller.namez,
	                medium: caller.medium && [caller.medium] || []
	            };
	    }
	}
	
	var OpenTicketStreamCardLayout = function (_Component) {
	    _inherits(OpenTicketStreamCardLayout, _Component);
	
	    function OpenTicketStreamCardLayout() {
	        _classCallCheck(this, OpenTicketStreamCardLayout);
	
	        return _possibleConstructorReturn(this, (OpenTicketStreamCardLayout.__proto__ || Object.getPrototypeOf(OpenTicketStreamCardLayout)).apply(this, arguments));
	    }
	
	    _createClass(OpenTicketStreamCardLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd,
	                _onSubmit = _props.onSubmit,
	                others = _objectWithoutProperties(_props, ['dispatch', 'cmd', 'onSubmit']);
	
	            return (cmd && cmd.locationRef && cmd.locationRef.patrimonyUid) != null && _react2.default.createElement(_TicketStreamCard2.default, {
	                patrimony: cmd.locationRef.patrimonyUid,
	                callPurpose: cmd.ticket && cmd.ticket.openingTicketPurpose && cmd.ticket.openingTicketPurpose.label,
	                onSubmit: function onSubmit(e, a, t) {
	                    return _onSubmit(e, a, getCallerFromOpenTicketCmd(cmd), t);
	                } });
	        }
	    }]);
	
	    return OpenTicketStreamCardLayout;
	}(_react.Component);
	
	OpenTicketStreamCardLayout.propTypes = {};
	
	
	OpenTicketStreamCardLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.openTicketCmd
	    };
	})(OpenTicketStreamCardLayout);
	
	exports.default = OpenTicketStreamCardLayout;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _links2 = __webpack_require__(33);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReceiveCallModal = __webpack_require__(2328);
	
	var _ReceiveCallModal2 = _interopRequireDefault(_ReceiveCallModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function assigneeHintFilter(_links) {
	    return function (hint) {
	        switch (hint) {
	            case 'assigneeInterventionAcceptation':
	                return !_links || !!_links.find((0, _links2.linkFinder)('AcceptIntervention'));
	            case 'assigneeInterventionCancellation':
	                return !_links || !!_links.find((0, _links2.linkFinder)('RefuseIntervention'));
	            default:
	                return true;
	        }
	    };
	}
	
	function restrictMediums(assignee, caller, contactToCallback, callType) {
	    switch (callType) {
	        case 'ReceiveCallFromAssignee':
	            var mediums = [];
	            mediums.push.apply(mediums, _toConsumableArray(assignee.phones.map((0, _models.plainContactToContactMedium)('Phone'))));
	            mediums.push.apply(mediums, _toConsumableArray(assignee.emails.map((0, _models.plainContactToContactMedium)('Mail'))));
	            mediums.push.apply(mediums, _toConsumableArray(assignee.fax.map((0, _models.plainContactToContactMedium)('Fax'))));
	            return mediums;
	        case 'ReceiveCallFromCaller':
	            return caller.medium.map(_models.mediumToContactMedium);
	        case 'ReceiveCallFromContactToCallback':
	            return [(0, _models.mediumToContactMedium)(contactToCallback.medium)];
	        default:
	            return [];
	    }
	}
	
	function restrictCallerz(assignee, caller, contactToCallback, callType) {
	    switch (callType) {
	        case 'ReceiveCallFromAssignee':
	            return assignee.name;
	        case 'ReceiveCallFromCaller':
	            return (0, _models.nameToPlainName)(caller.name);
	        case 'ReceiveCallFromContactToCallback':
	            return contactToCallback.name;
	        default:
	            return undefined;
	    }
	}
	
	function restrictCallTypes(assignee, caller, contactToCallback) {
	    var callTypes = [];
	
	    if (assignee === undefined || caller === undefined) {
	        callTypes.push('ReceiveCall');
	    }
	    if (assignee && caller) {
	        callTypes.push('ReceiveCall');
	    }
	    if (assignee) {
	        callTypes.push('ReceiveCallFromAssignee');
	    }
	    if (caller) {
	        callTypes.push('ReceiveCallFromCaller');
	    }
	    if (contactToCallback) {
	        callTypes.push('ReceiveCallFromContactToCallback');
	    }
	
	    return callTypes;
	}
	
	function restrictHints(ticket, callType) {
	    switch (callType) {
	        case 'ReceiveCallFromAssignee':
	            return _models.RECEIVE_CALL_FROM_ASSIGNEE_HINTS.filter(assigneeHintFilter(ticket._links));
	        case 'ReceiveCallFromCaller':
	            return _models.RECEIVE_CALL_FROM_CALLER_HINTS;
	        case 'ReceiveCallFromContactToCallback':
	            return _models.RECEIVE_CALL_FROM_CALLER_HINTS;
	        default:
	            return [];
	    }
	}
	
	function computeInterventionCmdType(hint) {
	    switch (hint) {
	        case 'assigneeInterventionAcceptation':
	            return 'AcceptIntervention';
	        case 'assigneeInterventionCancellation':
	            return 'RefuseIntervention';
	        default:
	            return null;
	    }
	}
	
	var ReceiveCallModal = function (_Component) {
	    _inherits(ReceiveCallModal, _Component);
	
	    function ReceiveCallModal(props) {
	        _classCallCheck(this, ReceiveCallModal);
	
	        var _this = _possibleConstructorReturn(this, (ReceiveCallModal.__proto__ || Object.getPrototypeOf(ReceiveCallModal)).call(this, props));
	
	        _this.state = {
	            hints: []
	        };
	        return _this;
	    }
	
	    _createClass(ReceiveCallModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket,
	                assignee = _props.assignee,
	                caller = _props.caller,
	                contactToCallback = _props.contactToCallback;
	
	
	            var callTypes = restrictCallTypes(assignee, caller, contactToCallback);
	            var callType = callTypes[0];
	            var hints = restrictHints(ticket, callType);
	
	            var callerz = restrictCallerz(assignee, caller, contactToCallback, callType);
	            var mediums = restrictMediums(assignee, caller, contactToCallback, callType);
	            var medium = undefined;
	            var comment = undefined;
	            var callPurpose = undefined;
	
	            dispatch((0, _actions.updateReceiveCallCmd)({ callerz: callerz, medium: medium, comment: comment, callPurpose: callPurpose }));
	            this.setState({ callTypes: callTypes, callType: callType, mediums: mediums, hints: hints });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket !== this.props.ticket || nextProps.assignee !== this.props.assignee || nextProps.caller !== this.props.caller || nextProps.contactToCallback !== this.props.contactToCallback) {
	                var dispatch = nextProps.dispatch,
	                    ticket = nextProps.ticket,
	                    assignee = nextProps.assignee,
	                    caller = nextProps.caller,
	                    contactToCallback = nextProps.contactToCallback;
	
	
	                var callTypes = restrictCallTypes(assignee, caller, contactToCallback);
	                var callType = callTypes[0];
	                var hints = restrictHints(ticket, callType);
	
	                var callerz = restrictCallerz(assignee, caller, contactToCallback, callType);
	                var mediums = restrictMediums(assignee, caller, contactToCallback, callType);
	                var medium = undefined;
	                var comment = undefined;
	                var callPurpose = undefined;
	                var hint = undefined;
	                var interventionCmdType = undefined;
	
	                dispatch((0, _actions.updateReceiveCallCmd)({ callerz: callerz, medium: medium, comment: comment, callPurpose: callPurpose }));
	                this.setState({ callTypes: callTypes, callType: callType, mediums: mediums, hints: hints, hint: hint, interventionCmdType: interventionCmdType });
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                ticket = _props2.ticket,
	                onHide = _props2.onHide;
	            var interventionCmdType = this.state.interventionCmdType;
	
	
	            return dispatch((0, _actions.sendReceiveCallCmd)(ticket.uid)).then(function () {
	                switch (interventionCmdType) {
	                    case 'AcceptIntervention':
	                        return dispatch((0, _actions.sendAcceptInterventionCmd)(ticket.uid));
	                    case 'RefuseIntervention':
	                        return dispatch((0, _actions.sendRefuseInterventionCmd)(ticket.uid));
	                }
	            }).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            }).then(function () {}).then(function () {
	                dispatch((0, _reactRouterRedux.push)('/tickets/' + ticket.uid));
	                onHide();
	            });
	        }
	    }, {
	        key: '_toggleCallType',
	        value: function _toggleCallType(callType) {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                ticket = _props3.ticket,
	                assignee = _props3.assignee,
	                caller = _props3.caller,
	                contactToCallback = _props3.contactToCallback;
	
	
	            if (callType) {
	                var callerz = restrictCallerz(assignee, caller, contactToCallback, callType);
	                var mediums = restrictMediums(assignee, caller, contactToCallback, callType);
	                var hints = restrictHints(ticket, callType);
	                var medium = undefined;
	                var comment = undefined;
	                var callPurpose = undefined;
	                var hint = undefined;
	
	                dispatch((0, _actions.updateReceiveCallCmd)({ callerz: callerz, medium: medium, comment: comment, callPurpose: callPurpose }));
	                this.setState({ callType: callType, mediums: mediums, hints: hints, hint: hint });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                cmd = _props4.cmd,
	                assignee = _props4.assignee,
	                caller = _props4.caller,
	                contactToCallback = _props4.contactToCallback,
	                ticket = _props4.ticket,
	                onHide = _props4.onHide,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'cmd', 'assignee', 'caller', 'contactToCallback', 'ticket', 'onHide']);
	
	            var _state = this.state,
	                callTypes = _state.callTypes,
	                callType = _state.callType,
	                mediums = _state.mediums,
	                hints = _state.hints,
	                hint = _state.hint;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var inputAddon = function inputAddon(icon) {
	                return _react2.default.createElement(_Icon2.default, { icon: icon, size: 'xs' });
	            };
	
	            var mediumInputButton = function mediumInputButton(medium) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    (0, _form.buttonField)(form.medium(), medium),
	                    _react2.default.createElement(_Icon2.default, { icon: 'radio', size: 'xs' })
	                );
	            };
	
	            var mediumField = function mediumField(field, type) {
	                var disabled = field.value && field.value.contactMediumType != type || false;
	                var value;
	
	                switch (type) {
	                    case 'Phone':
	                        value = field.value && field.value.phone;
	                        break;
	                    case 'Mail':
	                        value = field.value && field.value.mail;
	                        break;
	                    case 'Fax':
	                        value = field.value && field.value.fax;
	                        break;
	                }
	
	                function onChange(eventOrValue) {
	                    var value;
	                    if (eventOrValue && eventOrValue.target) {
	                        value = eventOrValue.target.value;
	                    } else {
	                        value = eventOrValue;
	                    }
	
	                    var medium;
	                    switch (type) {
	                        case 'Phone':
	                            medium = value && { phone: value, contactMediumType: 'Phone' } || null;
	                            break;
	                        case 'Mail':
	                            medium = value && { mail: value, contactMediumType: 'Mail' } || null;
	                            break;
	                        case 'Fax':
	                            medium = value && { fax: value, contactMediumType: 'Fax' } || null;
	                            break;
	                    }
	
	                    field.onChange(medium);
	                }
	
	                return _extends({}, field, { disabled: disabled, value: value, onChange: onChange });
	            };
	
	            var callTypeField = function callTypeField() {
	                var value = callType;
	
	                var onChange = function onChange(callType) {
	                    _this2._toggleCallType(callType);
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var hintField = function hintField(field) {
	                var value = hint || '';
	
	                var onChange = function onChange(event) {
	                    var hint = event.target.value || null;
	
	                    var data = {
	                        name: cmd.callerz || _i18n2.default.namePlaceholder
	                    };
	
	                    var callPurpose = (0, _extract2.default)(_i18n2.default.receiveCallHintEnum, hint);
	                    var comment = (0, _extract.replace)((0, _extract2.default)(_i18n2.default.receiveCallCommentEnum, hint), data);
	
	                    var interventionCmdType = computeInterventionCmdType(hint);
	
	                    dispatch((0, _actions.updateReceiveCallCmd)({ callPurpose: callPurpose, comment: comment }));
	                    _this2.setState({ hint: hint, interventionCmdType: interventionCmdType });
	                };
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        (0, _extract2.default)(_i18n2.default.receiveCallEnum, callType)
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ReceiveCallModal2.default.defaultContent },
	                        callTypes.length > 1 && _react2.default.createElement(
	                            'div',
	                            { className: _ReceiveCallModal2.default.callType },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 9, smOffset: 3 },
	                                    _react2.default.createElement(
	                                        _ButtonToggle2.default,
	                                        callTypeField(),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: _ReceiveCallModal2.default.container },
	                                            callTypes.map(function (callType, index) {
	                                                return _react2.default.createElement(
	                                                    'li',
	                                                    {
	                                                        key: index },
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Button,
	                                                        {
	                                                            bsStyle: 'link',
	                                                            value: callType },
	                                                        _react2.default.createElement(_Icon2.default, {
	                                                            icon: 'clientAccountManager',
	                                                            size: 'md' }),
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            null,
	                                                            (0, _extract2.default)(_i18n2.default.receiveCallzEnum, callType)
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'form-horizontal' },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'caller',
	                                label: requiredLabel(_i18n2.default.caller)
	                            }, form.callerz())),
	                            hints.length == 0 && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'textarea',
	                                name: 'callPurpose',
	                                label: requiredLabel(_i18n2.default.callPurposez)
	                            }, form.callPurpose())),
	                            hints.length > 0 && _react2.default.createElement(
	                                _reactBootstrap.Input,
	                                _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'select',
	                                    name: 'callPurpose',
	                                    label: requiredLabel(_i18n2.default.callPurposez)
	                                }, hintField(form.callPurpose())),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    _i18n2.default.callPurposez,
	                                    ' ...'
	                                ),
	                                hints.map(function (hint) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        {
	                                            key: hint,
	                                            value: hint },
	                                        (0, _extract2.default)(_i18n2.default.receiveCallHintEnum, hint)
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'textarea',
	                                name: 'comment',
	                                label: _i18n2.default.comment,
	                                rows: 4
	                            }, (0, _form.controlledField)(form.comment())))
	                        ),
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.contactDetails,
	                                ' ',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    '*'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                _i18n2.default.contactDetailsText
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'form-horizontal' },
	                            mediums.length == 0 && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'phone',
	                                    label: _i18n2.default.phone,
	                                    addonBefore: inputAddon('phone')
	                                }, (0, _phonez.phoneField)(mediumField(form.medium(), 'Phone')))),
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'email',
	                                    label: _i18n2.default.email,
	                                    addonBefore: inputAddon('mail')
	                                }, mediumField(form.medium(), 'Mail'))),
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'fax',
	                                    label: _i18n2.default.fax,
	                                    addonBefore: inputAddon('fax')
	                                }, (0, _phonez.phoneField)(mediumField(form.medium(), 'Fax'))))
	                            ),
	                            mediums.filter(function (m) {
	                                return m.contactMediumType == 'Phone';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(_reactBootstrap.Input, { disabled: true,
	                                    key: index,
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'phone',
	                                    label: index == 0 && _i18n2.default.phone || ' ',
	                                    addonBefore: inputAddon('phone'),
	                                    buttonAfter: mediumInputButton(medium),
	                                    value: (0, _phonez2.default)(medium.phone).format(),
	                                    bsStyle: form.medium().bsStyle });
	                            }),
	                            mediums.filter(function (m) {
	                                return m.contactMediumType == 'Mail';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(_reactBootstrap.Input, { disabled: true,
	                                    key: index,
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'email',
	                                    label: index == 0 && _i18n2.default.email || ' ',
	                                    addonBefore: inputAddon('mail'),
	                                    buttonAfter: mediumInputButton(medium),
	                                    value: medium.mail,
	                                    bsStyle: form.medium().bsStyle });
	                            }),
	                            mediums.filter(function (m) {
	                                return m.contactMediumType == 'Fax';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(_reactBootstrap.Input, { disabled: true,
	                                    key: index,
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'fax',
	                                    label: index == 0 && _i18n2.default.fax || ' ',
	                                    addonBefore: inputAddon('fax'),
	                                    buttonAfter: mediumInputButton(medium),
	                                    value: (0, _phonez2.default)(medium.fax).format(),
	                                    bsStyle: form.medium().bsStyle });
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                    onClick: function onClick() {
	                                        return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _i18n2.default.validate
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReceiveCallModal;
	}(_react.Component);
	
	ReceiveCallModal.propTypes = {
	    assignee: _react.PropTypes.object,
	    caller: _react.PropTypes.object,
	    contactToCallback: _react.PropTypes.object,
	    ticket: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReceiveCallModal = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.ReceiveCallCmd.schema,
	    action: _actions.RECEIVE_CALL_CMD_UPDATED
	})(ReceiveCallModal);
	
	ReceiveCallModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.receiveCallCmd
	    };
	})(ReceiveCallModal);
	
	exports.default = ReceiveCallModal;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _browser = __webpack_require__(54);
	
	var _DayRangePicker = __webpack_require__(889);
	
	var _DayRangePicker2 = _interopRequireDefault(_DayRangePicker);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function pageFilter(_ref) {
	    var patrimony = _ref.patrimony,
	        agency = _ref.agency;
	
	    return function (page) {
	        if (patrimony && (page == 'patrimony' || page == 'agency')) return false;
	        if (agency && page == 'agency') return false;
	        return true;
	    };
	}
	
	var ReportTicketsModal = function (_Component) {
	    _inherits(ReportTicketsModal, _Component);
	
	    function ReportTicketsModal() {
	        _classCallCheck(this, ReportTicketsModal);
	
	        return _possibleConstructorReturn(this, (ReportTicketsModal.__proto__ || Object.getPrototypeOf(ReportTicketsModal)).apply(this, arguments));
	    }
	
	    _createClass(ReportTicketsModal, [{
	        key: '_reportPdf',
	        value: function _reportPdf() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                option = _props.option,
	                patrimony = _props.patrimony,
	                agency = _props.agency,
	                onHide = _props.onHide;
	
	
	            var reportQuery = {
	                from: option.from,
	                to: option.to,
	                patrimony: patrimony && patrimony.uid,
	                agency: agency && agency.uid
	            };
	
	            var reportOption = {
	                pages: _models.PDF_REPORT_PAGES.filter(pageFilter({ patrimony: patrimony, agency: agency }))
	            };
	
	            if (!(0, _browser.supportWorker)()) {
	                // fallback on download
	                var payload = _extends({ type: 'PdfTicketsReport', option: reportOption }, reportQuery);
	                var encodedPayload = btoa(JSON.stringify(payload));
	                window.open('/download/' + encodedPayload, '_blank');
	                onHide();
	                return true;
	            }
	
	            return Promise.resolve(dispatch((0, _actions.reportPdfTickets)(_extends({}, _actions.DEFAULT_TICKET_QUERY, reportQuery), reportOption))).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                option = _props2.option,
	                patrimony = _props2.patrimony,
	                agency = _props2.agency,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'option', 'patrimony', 'agency', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.exportTickets
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_DayRangePicker2.default, form(['from', 'to'])),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._reportPdf() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.exportz
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReportTicketsModal;
	}(_react.Component);
	
	ReportTicketsModal.propTypes = {
	    patrimony: _react.PropTypes.object,
	    agency: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReportTicketsModal = (0, _form.connectForm)({
	    target: 'option',
	    schema: _models.ReportPdfTicketsOption.schema,
	    action: _actions.REPORT_PDF_TICKETS_OPTION_UPDATED
	})(ReportTicketsModal);
	
	ReportTicketsModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        option: state.ticket.reportPdfTicketsOption
	    };
	})(ReportTicketsModal);
	
	exports.default = ReportTicketsModal;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _actions = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SendInterventionInfoToAssignee = function (_Component) {
	    _inherits(SendInterventionInfoToAssignee, _Component);
	
	    function SendInterventionInfoToAssignee() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SendInterventionInfoToAssignee);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SendInterventionInfoToAssignee.__proto__ || Object.getPrototypeOf(SendInterventionInfoToAssignee)).call.apply(_ref, [this].concat(args))), _this), _this._decideIfSendNotif = function () {
	            var _this$props = _this.props,
	                acceptInterventionCmd = _this$props.acceptInterventionCmd,
	                dispatch = _this$props.dispatch;
	
	            var onChange = function onChange(event) {
	                var choice = event.target.value;
	                dispatch((0, _actions.chooseIfSendNotificationWhenInterventionAccepted)({
	                    accepted: true,
	                    sendItOrNot: choice
	                }));
	            };
	
	            var sendItOrNot = acceptInterventionCmd.sendItOrNot;
	
	            return { value: sendItOrNot || 'headerChoice', onChange: onChange };
	        }, _this._calculChoices = function () {
	            var _this$props2 = _this.props,
	                assignee = _this$props2.assignee,
	                acceptInterventionCmd = _this$props2.acceptInterventionCmd;
	            var sendItOrNot = acceptInterventionCmd.sendItOrNot;
	
	
	            var emails = assignee && assignee.emails;
	            var headChoice = [{ v: 'headerChoice', label: 'choisir d\'envoyer une notification ...' }];
	            var notSendChoice = [{ v: 'doNotSendNotif', label: 'Ne pas envoyer de notification' }];
	            var mails = emails.map(function (m) {
	                return { v: m, label: m };
	            });
	
	            return sendItOrNot ? notSendChoice.concat(mails) : headChoice.concat(notSendChoice).concat(mails);
	        }, _this.updateOtherRecipient = function (i) {
	            return function (e) {
	                var _this$props3 = _this.props,
	                    acceptInterventionCmd = _this$props3.acceptInterventionCmd,
	                    dispatch = _this$props3.dispatch;
	                var otherEmails = acceptInterventionCmd.otherEmails;
	
	                otherEmails[i] = e.target.value;
	                dispatch((0, _actions.updateOtherRecipientInInterventionAcceptedNotification)({ otherEmails: [].concat(_toConsumableArray(otherEmails)) }));
	            };
	        }, _this.addOtherRecipient = function () {
	            var _this$props4 = _this.props,
	                acceptInterventionCmd = _this$props4.acceptInterventionCmd,
	                dispatch = _this$props4.dispatch;
	            var otherEmails = acceptInterventionCmd.otherEmails;
	
	            if (_this.lastRecipientFulfilled()) {
	                dispatch((0, _actions.updateOtherRecipientInInterventionAcceptedNotification)({ otherEmails: [].concat(_toConsumableArray(otherEmails), [undefined]) }));
	            }
	        }, _this.removeOtherRecipient = function (i) {
	            return function () {
	                var _this$props5 = _this.props,
	                    acceptInterventionCmd = _this$props5.acceptInterventionCmd,
	                    dispatch = _this$props5.dispatch;
	                var otherEmails = acceptInterventionCmd.otherEmails;
	
	                var newOtherEmails = [].concat(_toConsumableArray(otherEmails.slice(0, i)), _toConsumableArray(otherEmails.slice(i + 1)));
	
	                dispatch((0, _actions.updateOtherRecipientInInterventionAcceptedNotification)({ otherEmails: newOtherEmails }));
	            };
	        }, _this.renderOtherRecipients = function () {
	            var acceptInterventionCmd = _this.props.acceptInterventionCmd;
	            var sendItOrNot = acceptInterventionCmd.sendItOrNot,
	                otherEmails = acceptInterventionCmd.otherEmails;
	
	
	            return sendItOrNot && sendItOrNot !== 'doNotSendNotif' && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        bsSize: 'small',
	                        bsStyle: 'link',
	                        onClick: _this.addOtherRecipient,
	                        disabled: !_this.lastRecipientFulfilled() },
	                    'Ajouter un autre destinataire'
	                ),
	                otherEmails.map(function (or, i) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: i },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'small',
	                                bsStyle: 'link',
	                                onClick: _this.removeOtherRecipient(i) },
	                            'Enlever ce destinataire'
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, { type: 'text', value: or, onChange: _this.updateOtherRecipient(i) })
	                    );
	                })
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SendInterventionInfoToAssignee, [{
	        key: 'lastRecipientFulfilled',
	        value: function lastRecipientFulfilled() {
	            var acceptInterventionCmd = this.props.acceptInterventionCmd;
	            var otherEmails = acceptInterventionCmd.otherEmails;
	
	
	            return Boolean(otherEmails.length === 0 || otherEmails.slice(-1)[0]);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var assignee = this.props.assignee;
	
	            var link = assignee && (assignee.assigneeType === 'ProviderContact' && '/providercontacts/' + assignee.uid || '/providers/' + assignee.uid);
	
	            var hasEmail = assignee && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Merci de confirmer ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: link, target: '_blank' },
	                            'l\'email du fournisseur'
	                        )
	                    ),
	                    ' afin de lui envoyer une notification'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.Input,
	                    _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'select',
	                        label: ''
	                    }, this._decideIfSendNotif()),
	                    this._calculChoices().map(function (choice) {
	                        return _react2.default.createElement(
	                            'option',
	                            {
	                                key: choice.v,
	                                value: choice.v },
	                            choice.label
	                        );
	                    })
	                ),
	                _react2.default.createElement('br', null),
	                this.renderOtherRecipients()
	            );
	
	            return hasEmail || _react2.default.createElement('div', null);
	        }
	    }]);
	
	    return SendInterventionInfoToAssignee;
	}(_react.Component);
	
	SendInterventionInfoToAssignee = (0, _reactRedux.connect)(function (_ref2) {
	    var ticket = _ref2.ticket;
	    var acceptInterventionCmd = ticket.acceptInterventionCmd;
	
	    return { acceptInterventionCmd: acceptInterventionCmd };
	})(SendInterventionInfoToAssignee);
	exports.default = SendInterventionInfoToAssignee;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _ShowDocumentsPage = __webpack_require__(1818);
	
	var _ShowDocumentsPage2 = _interopRequireDefault(_ShowDocumentsPage);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Icon = __webpack_require__(925);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShowDocumentsPage = function (_Component) {
	    _inherits(ShowDocumentsPage, _Component);
	
	    function ShowDocumentsPage() {
	        _classCallCheck(this, ShowDocumentsPage);
	
	        return _possibleConstructorReturn(this, (ShowDocumentsPage.__proto__ || Object.getPrototypeOf(ShowDocumentsPage)).apply(this, arguments));
	    }
	
	    _createClass(ShowDocumentsPage, [{
	        key: 'computeCriterias',
	        value: function computeCriterias() {
	            var router = this.props.router;
	            var ticket = this.props.ticket.ticket;
	            var _props$company = this.props.company,
	                company = _props$company.company,
	                agency = _props$company.agency;
	
	
	            if (router.location.pathname.match(/tickets/) && ticket) {
	                var linkedEntities = ticket.linkedEntities;
	                var openedFromSimplifiedRequest = linkedEntities.openedFromSimplifiedRequest;
	
	
	                return {
	                    simplifiedRequestUid: openedFromSimplifiedRequest || null,
	                    entityUid: ticket.uid,
	                    entityType: 'Ticket'
	                };
	            }
	            if (router.location.pathname.match(/agencies/) && agency && agency.agency) {
	                return {
	                    entityUid: agency.agency.uid,
	                    entityType: 'Agency'
	                };
	            }
	            if ((router.location.pathname.match(/companies/) || router.location.pathname.match(/organisations/)) && company) {
	                return {
	                    entityUid: company.uid,
	                    entityType: 'ClientCompany'
	                };
	            }
	
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var criterias = this.computeCriterias();
	            if (!criterias) {
	                return null;
	            }
	
	            var flags = _extends({
	                simplifiedRequestUid: null
	            }, criterias, {
	                queryApiBaseUrl: _config2.default.api.url,
	                icons: Object.entries(_Icon2.default)
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactElmComponents2.default, { src: _ShowDocumentsPage2.default.Elm.ShowDocumentsPage, flags: flags })
	            );
	        }
	    }]);
	
	    return ShowDocumentsPage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (_ref) {
	    var ticket = _ref.ticket,
	        company = _ref.company,
	        router = _ref.router;
	    return { ticket: ticket, company: company, router: router };
	})(ShowDocumentsPage);

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _SimplifiedRequestCountCard = __webpack_require__(1820);
	
	var _SimplifiedRequestCountCard2 = _interopRequireDefault(_SimplifiedRequestCountCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimplifiedRequestCountCardWrap = function (_Component) {
	    _inherits(SimplifiedRequestCountCardWrap, _Component);
	
	    function SimplifiedRequestCountCardWrap() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SimplifiedRequestCountCardWrap);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimplifiedRequestCountCardWrap.__proto__ || Object.getPrototypeOf(SimplifiedRequestCountCardWrap)).call.apply(_ref, [this].concat(args))), _this), _this.setupPorts = function (ports) {
	            ports.dispatch.subscribe(_this.subscribeDispatch);
	        }, _this.subscribeDispatch = function () {
	            var dispatch = _this.props.dispatch;
	
	            dispatch((0, _reactRouterRedux.push)('/simplifiedrequests'));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SimplifiedRequestCountCardWrap, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactElmComponents2.default, { src: _SimplifiedRequestCountCard2.default.Elm.SimplifiedRequestCountCard, ports: this.setupPorts, flags: _config2.default.api.url })
	            );
	        }
	    }]);
	
	    return SimplifiedRequestCountCardWrap;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)()(SimplifiedRequestCountCardWrap);

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StaticMap = __webpack_require__(510);
	
	var _StaticMap2 = _interopRequireDefault(_StaticMap);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketAddressCard = __webpack_require__(2332);
	
	var _TicketAddressCard2 = _interopRequireDefault(_TicketAddressCard);
	
	var _TicketCorrectLocationReference = __webpack_require__(1523);
	
	var _TicketCorrectLocationReference2 = _interopRequireDefault(_TicketCorrectLocationReference);
	
	var _links = __webpack_require__(33);
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _fetchz = __webpack_require__(86);
	
	var _status = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketAddressCard = function (_Component) {
	    _inherits(TicketAddressCard, _Component);
	
	    function TicketAddressCard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TicketAddressCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TicketAddressCard.__proto__ || Object.getPrototypeOf(TicketAddressCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._openModalLocationReference = function () {
	            _this.setState({ correctLocationReference: true });
	        }, _this._closeModalLocationReference = function () {
	            _this.setState({ correctLocationReference: undefined });
	        }, _this._correctLocationReference = function (v) {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                ticket = _this$props.ticket;
	            var uid = ticket.uid;
	
	            var options = {
	                method: 'PATCH',
	                body: _extends({
	                    processUid: _nodeUuid2.default.v4()
	                }, v, {
	                    commandType: 'CorrectLocationReference'
	                })
	            };
	
	            fetch((0, _fetchz.apiUrl)(_config2.default.api.event.url + '/tickets/' + uid), (0, _fetchz.apiOption)(options)).then(_fetchz.apiResponse).then(function () {
	                _this._closeModalLocationReference();
	                window.location.reload();
	            }).catch(function (e) {
	                dispatch((0, _status.errorStatus)(e.message));
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TicketAddressCard, [{
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket,
	                patrimony = _props.patrimony,
	                ticketIdLock = _props.ticketIdLock,
	                split = _props.split,
	                others = _objectWithoutProperties(_props, ['dispatch', 'ticket', 'patrimony', 'ticketIdLock', 'split']);
	
	            var cardHeader = function cardHeader(title) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        title
	                    ),
	                    ((ticket || {})._links || []).find((0, _links.linkFinder)('CorrectLocationReference')) && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: _this2._openModalLocationReference,
	                            title: _i18n2.default.correctLocationReference,
	                            alt: _i18n2.default.correctLocationReference
	                        },
	                        _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                    )
	                );
	            };
	
	            var isLocked = function isLocked() {
	                if (ticketIdLock && ticketIdLock != (ticket && ticket.uid)) return true;
	                return !ticket;
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TicketAddressCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: cardHeader(_i18n2.default.interventionLocation)
	                    }, others),
	                    !isLocked() && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(_TicketCorrectLocationReference2.default, {
	                            ticket: ticket,
	                            show: this.state.correctLocationReference,
	                            onHide: this._closeModalLocationReference,
	                            onSubmit: this._correctLocationReference
	                        }),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: split && 6 || 12 },
	                            ticket.linkedEntities.patrimony && _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._navigate(e, '/patrimonies/' + ticket.linkedEntities.patrimony.uid);
	                                    } },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ticket.linkedEntities.patrimony.name
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketAddressCard2.default.address },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticket.address.quality
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticket.address.number,
	                                    ' ',
	                                    ticket.address.street
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticket.address.zipCode,
	                                    ' ',
	                                    ticket.address.city
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    ticket.address.recipientSupplement && Object.keys(ticket.address.recipientSupplement).map(function (k, index) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: index },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                (0, _extract2.default)(_i18n2.default.recipientSupplementEnum, k),
	                                                ' '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ticket.address.recipientSupplement[k]
	                                            )
	                                        );
	                                    }),
	                                    ticket.address.geographicalSupplement && Object.keys(ticket.address.geographicalSupplement).map(function (k, index) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: index },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                (0, _extract2.default)(_i18n2.default.geographicalSupplementEnum, k),
	                                                ' '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ticket.address.geographicalSupplement[k]
	                                            )
	                                        );
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticket.address.complement
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: split && 6 || 12 },
	                            ticket.linkedEntities.patrimony && ticket.linkedEntities.patrimony.uid == (patrimony && patrimony.uid) && _react2.default.createElement(_StaticMap2.default, { info: true,
	                                apiKey: _config2.default.google.apiKey,
	                                ratio: 16 / 9,
	                                identify: function identify(a) {
	                                    return a.geoLocation;
	                                },
	                                value: [].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses)) })
	                        )
	                    ),
	                    isLocked() && _react2.default.createElement(
	                        'div',
	                        { className: _TicketAddressCard2.default.noTicketInfo },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.noTicketInfo
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketAddressCard;
	}(_react.Component);
	
	TicketAddressCard.propTypes = {
	    ticketIdLock: _react.PropTypes.string,
	    split: _react.PropTypes.bool
	};
	
	
	TicketAddressCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket,
	        patrimony: state.patrimony.patrimony
	    };
	})(TicketAddressCard);
	
	exports.default = TicketAddressCard;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketAssigneeCard = __webpack_require__(2333);
	
	var _TicketAssigneeCard2 = _interopRequireDefault(_TicketAssigneeCard);
	
	var _Markdown = __webpack_require__(543);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketAssigneeCard = function (_Component) {
	    _inherits(TicketAssigneeCard, _Component);
	
	    function TicketAssigneeCard() {
	        _classCallCheck(this, TicketAssigneeCard);
	
	        return _possibleConstructorReturn(this, (TicketAssigneeCard.__proto__ || Object.getPrototypeOf(TicketAssigneeCard)).apply(this, arguments));
	    }
	
	    _createClass(TicketAssigneeCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var ticket = this.props.ticket;
	
	
	            var interventionScheduledJournalEvent = _models.Ticket.findJournalEvent(ticket, 'InterventionScheduled');
	            var interventionDeadlineDefinedJournalEvent = _models.Ticket.findJournalEvent(ticket, 'InterventionDeadlineDefined');
	            var formalNoticeForProviderReportedJournalEvent = _models.Ticket.findJournalEvent(ticket, 'FormalNoticeForProviderReported');
	            var interventionTimeCompliant = _models.Ticket.isInterventionTimeCompliant(ticket);
	            var repairTimeCompliant = _models.Ticket.isRepairTimeCompliant(ticket);
	            this.setState({ interventionScheduledJournalEvent: interventionScheduledJournalEvent, interventionDeadlineDefinedJournalEvent: interventionDeadlineDefinedJournalEvent, formalNoticeForProviderReportedJournalEvent: formalNoticeForProviderReportedJournalEvent, interventionTimeCompliant: interventionTimeCompliant, repairTimeCompliant: repairTimeCompliant });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket != this.props.ticket) {
	                var ticket = nextProps.ticket;
	
	
	                var interventionScheduledJournalEvent = _models.Ticket.findJournalEvent(ticket, 'InterventionScheduled');
	                var interventionDeadlineDefinedJournalEvent = _models.Ticket.findJournalEvent(ticket, 'InterventionDeadlineDefined');
	                var formalNoticeForProviderReportedJournalEvent = _models.Ticket.findJournalEvent(ticket, 'FormalNoticeForProviderReported');
	                var interventionTimeCompliant = _models.Ticket.isInterventionTimeCompliant(ticket);
	                var repairTimeCompliant = _models.Ticket.isRepairTimeCompliant(ticket);
	                this.setState({ interventionScheduledJournalEvent: interventionScheduledJournalEvent, interventionDeadlineDefinedJournalEvent: interventionDeadlineDefinedJournalEvent, formalNoticeForProviderReportedJournalEvent: formalNoticeForProviderReportedJournalEvent, interventionTimeCompliant: interventionTimeCompliant, repairTimeCompliant: repairTimeCompliant });
	            }
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket,
	                ticketIdLock = _props.ticketIdLock,
	                split = _props.split,
	                onSubmit = _props.onSubmit,
	                others = _objectWithoutProperties(_props, ['dispatch', 'ticket', 'ticketIdLock', 'split', 'onSubmit']);
	
	            var _state = this.state,
	                interventionScheduledJournalEvent = _state.interventionScheduledJournalEvent,
	                interventionDeadlineDefinedJournalEvent = _state.interventionDeadlineDefinedJournalEvent,
	                formalNoticeForProviderReportedJournalEvent = _state.formalNoticeForProviderReportedJournalEvent,
	                interventionTimeCompliant = _state.interventionTimeCompliant,
	                repairTimeCompliant = _state.repairTimeCompliant;
	
	
	            var cardHeader = function cardHeader(title) {
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    title
	                );
	            };
	
	            var assigneeName = function assigneeName(assignee) {
	                if (assignee.assigneeType == 'ProviderContact') {
	                    return _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._navigate(e, '/providercontacts/' + assignee.uid);
	                            } },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                assignee.name
	                            ),
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                        )
	                    );
	                } else if (assignee.assigneeType == 'ProviderCompany') {
	                    return _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._navigate(e, '/providers/' + assignee.uid);
	                            } },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                assignee.name
	                            ),
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                        )
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    assignee.name
	                );
	            };
	
	            var tooltip = function tooltip(text, status) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: status && 'tooltip-' + status },
	                    text
	                );
	            };
	
	            var isLocked = function isLocked() {
	                if (ticketIdLock && ticketIdLock != (ticket && ticket.uid)) return true;
	                return !ticket;
	            };
	
	            return !!(ticket && ticket.assignee) && _react2.default.createElement(
	                'div',
	                { className: _TicketAssigneeCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: cardHeader(_i18n2.default.interventionMonitoring)
	                    }, others),
	                    !isLocked() && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: split && 6 || 12 },
	                            assigneeName(ticket.assignee),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _TicketAssigneeCard2.default.contact },
	                                ticket.assignee.phones && ticket.assignee.phones.map(function (phone, index) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'phone', size: 'xs' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            (0, _phonez2.default)(phone).format()
	                                        )
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _TicketAssigneeCard2.default.contact },
	                                ticket.assignee.emails && ticket.assignee.emails.map(function (email, index) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'mail', size: 'xs' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            email
	                                        )
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _TicketAssigneeCard2.default.contact },
	                                ticket.assignee.fax && ticket.assignee.fax.map(function (fax, index) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'fax', size: 'xs' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            (0, _phonez2.default)(fax).format()
	                                        )
	                                    );
	                                })
	                            ),
	                            ticket.serviceOrder && _react2.default.createElement(
	                                'div',
	                                { className: _TicketAssigneeCard2.default.event },
	                                _react2.default.createElement(_Icon2.default, { icon: 'calendar', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketAssigneeCard2.default.container },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        (0, _extract.replace)(_i18n2.default.serviceOrder, _extends({}, ticket.serviceOrder, { sendingDate: (0, _moment2.default)(ticket.serviceOrder.sendingDate).format(_i18n2.default.dateFormat.default) }))
	                                    )
	                                )
	                            ),
	                            interventionScheduledJournalEvent && _react2.default.createElement(
	                                'div',
	                                { className: _TicketAssigneeCard2.default.event },
	                                _react2.default.createElement(_Icon2.default, { icon: 'calendar', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketAssigneeCard2.default.container },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _models.Ticket.replaceJournalEvent(_models.Ticket.extractJournalEvent(_i18n2.default.journalEventEnum, interventionScheduledJournalEvent), interventionScheduledJournalEvent)
	                                    )
	                                )
	                            ),
	                            interventionDeadlineDefinedJournalEvent && _react2.default.createElement(
	                                'div',
	                                { className: _TicketAssigneeCard2.default.event },
	                                _react2.default.createElement(_Icon2.default, { icon: 'calendar', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketAssigneeCard2.default.container },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _models.Ticket.replaceJournalEvent(_models.Ticket.extractJournalEvent(_i18n2.default.journalEventEnum, interventionDeadlineDefinedJournalEvent), interventionDeadlineDefinedJournalEvent)
	                                    )
	                                )
	                            ),
	                            formalNoticeForProviderReportedJournalEvent && _react2.default.createElement(
	                                'div',
	                                { className: _TicketAssigneeCard2.default.event },
	                                _react2.default.createElement(_Icon2.default, { icon: 'calendar', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketAssigneeCard2.default.container },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _models.Ticket.replaceJournalEvent(_models.Ticket.extractJournalEvent(_i18n2.default.journalEventEnum, formalNoticeForProviderReportedJournalEvent), formalNoticeForProviderReportedJournalEvent)
	                                    )
	                                )
	                            ),
	                            ticket.assignee.comment && _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_TicketAssigneeCard2.default.comment, _TicketAssigneeCard2.default.warning) },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(_Markdown2.default, { markdown: ticket.assignee.comment })
	                                )
	                            ),
	                            ticket.assignee.instructionsForAssignee && _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_TicketAssigneeCard2.default.comment, _TicketAssigneeCard2.default.warning) },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'instructions: '
	                                    ),
	                                    _react2.default.createElement(_Markdown2.default, { markdown: ticket.assignee.instructionsForAssignee })
	                                )
	                            ),
	                            onSubmit && _react2.default.createElement(
	                                'ul',
	                                { className: _TicketAssigneeCard2.default.callingGroup },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    ticket._links.find((0, _links.linkFinder)('EmitCallTo')) && _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            onClick: function onClick(e) {
	                                                return onSubmit(e, 'EmitCallTo', ticket.assignee);
	                                            } },
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            _i18n2.default.emitCallz
	                                        ),
	                                        _react2.default.createElement(_Icon2.default, { icon: 'emitCall', size: 'sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    ticket._links.find((0, _links.linkFinder)('ReceiveCall')) && _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            onClick: function onClick(e) {
	                                                return onSubmit(e, 'ReceiveCall', ticket.assignee);
	                                            } },
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            _i18n2.default.receiveCallz
	                                        ),
	                                        _react2.default.createElement(_Icon2.default, { icon: 'receiveCall', size: 'sm' })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: split && 6 || 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketAssigneeCard2.default.metricGroup },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: (0, _classnames2.default)(_TicketAssigneeCard2.default.metric, _defineProperty({}, _TicketAssigneeCard2.default.danger, !interventionTimeCompliant)) },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _i18n2.default.interventionTime
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: tooltip((0, _extract.replace)(_i18n2.default.interventionTimeText, { token: !interventionTimeCompliant }), interventionTimeCompliant && 'primary' || 'danger') },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _TicketAssigneeCard2.default.time },
	                                            ticket.stats.interventionTime && _moment2.default.duration(ticket.stats.interventionTime).humanize() || '---'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketAssigneeCard2.default.metric },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _i18n2.default.interventionDuration
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: tooltip(_i18n2.default.interventionDurationText, 'primary') },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _TicketAssigneeCard2.default.time },
	                                            ticket.stats.interventionDuration && _moment2.default.duration(ticket.stats.interventionDuration).humanize() || '---'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: (0, _classnames2.default)(_TicketAssigneeCard2.default.metric, _defineProperty({}, _TicketAssigneeCard2.default.danger, !repairTimeCompliant)) },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _i18n2.default.repairTime
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: tooltip((0, _extract.replace)(_i18n2.default.repairTimeText, { token: !repairTimeCompliant }), repairTimeCompliant && 'primary' || 'danger') },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _TicketAssigneeCard2.default.time },
	                                            ticket.stats.repairTime && _moment2.default.duration(ticket.stats.repairTime).humanize() || '---'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(_reactBootstrap.Col, null),
	                        _react2.default.createElement(_reactBootstrap.Col, null)
	                    ),
	                    isLocked() && _react2.default.createElement(
	                        'div',
	                        { className: _TicketAssigneeCard2.default.noTicketInfo },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.noTicketInfo
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketAssigneeCard;
	}(_react.Component);
	
	TicketAssigneeCard.propTypes = {
	    ticketIdLock: _react.PropTypes.string,
	    split: _react.PropTypes.bool,
	    onSubmit: _react.PropTypes.func
	};
	
	
	TicketAssigneeCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket
	    };
	})(TicketAssigneeCard);
	
	exports.default = TicketAssigneeCard;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1043);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _chartistPluginLegend = __webpack_require__(1129);
	
	var _chartistPluginLegend2 = _interopRequireDefault(_chartistPluginLegend);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _ui = __webpack_require__(512);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DownloadIcon = __webpack_require__(890);
	
	var _DownloadIcon2 = _interopRequireDefault(_DownloadIcon);
	
	var _Chart = __webpack_require__(275);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ExportTicketsModal = __webpack_require__(1106);
	
	var _ExportTicketsModal2 = _interopRequireDefault(_ExportTicketsModal);
	
	var _TicketStats = __webpack_require__(2337);
	
	var _TicketStats2 = _interopRequireDefault(_TicketStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COMPONENT_NAME = 'Ticket/TicketStats';
	
	var TicketStats = function (_Component) {
	    _inherits(TicketStats, _Component);
	
	    function TicketStats(props) {
	        _classCallCheck(this, TicketStats);
	
	        var _this = _possibleConstructorReturn(this, (TicketStats.__proto__ || Object.getPrototypeOf(TicketStats)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(TicketStats, [{
	        key: '_toggle',
	        value: function _toggle(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ui = _props.ui;
	
	            var _uiState = (0, _ui.uiState)(COMPONENT_NAME, ui),
	                closed = _uiState.closed;
	
	            event.preventDefault();
	            dispatch((0, _ui.setUIState)(COMPONENT_NAME, { closed: !closed }));
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(name) {
	            this.setState({ openedModal: name });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                location = _props2.location,
	                aggregations = _props2.aggregations,
	                stats = _props2.stats,
	                range = _props2.range,
	                ui = _props2.ui,
	                progress = _props2.progress,
	                stacked = _props2.stacked;
	            var openedModal = this.state.openedModal;
	
	            var _uiState2 = (0, _ui.uiState)(COMPONENT_NAME, ui),
	                closed = _uiState2.closed;
	
	            var transitionName = {
	                enter: _TicketStats2.default.enter,
	                enterActive: _TicketStats2.default.enterActive,
	                leave: _TicketStats2.default.leave,
	                leaveActive: _TicketStats2.default.leaveActive
	            };
	
	            var statusChartTotal = (0, _Chart.totalAngle)({
	                source: aggregations.status,
	                angle: 220,
	                identify: function identify(s) {
	                    return s.count;
	                }
	            });
	
	            var statusChartPlugins = [(0, _chartistPluginLegend2.default)({
	                legendNames: aggregations.status.map(function (s) {
	                    return (0, _extract2.default)(_i18n2.default.ticketsDashboardStatusEnum, s.value);
	                })
	            })];
	
	            var interventionChartTotal = (0, _Chart.totalAngle)({
	                source: aggregations.interventions,
	                angle: 220,
	                identify: function identify(i) {
	                    return i.count;
	                }
	            });
	
	            var interventionChartPlugins = [(0, _chartistPluginLegend2.default)({
	                legendNames: aggregations.interventions.map(function (i) {
	                    return (0, _extract2.default)(_i18n2.default.ticketsInterventionEnum, i.value);
	                })
	            })];
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_TicketStats2.default.default, _defineProperty({}, _TicketStats2.default.stacked, stacked)) },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    !stacked && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smOffset: 4, xsHidden: true },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._toggle(e);
	                                } },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.summary
	                                ),
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: closed && 'down' || 'up',
	                                    size: 'xs' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        {
	                            sm: stacked && 12 || 4 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _TicketStats2.default.switch },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketStats2.default.export },
	                                _react2.default.createElement(
	                                    _reactBootstrap.OverlayTrigger,
	                                    {
	                                        placement: 'bottom',
	                                        overlay: tooltip(progress[_actions.XLSX_TICKETS_EXPORTED] && _i18n2.default.exportingTickets || _i18n2.default.exportTickets) },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'link',
	                                            bsSize: 'small',
	                                            disabled: !!progress[_actions.XLSX_TICKETS_EXPORTED],
	                                            onClick: function onClick() {
	                                                return _this2._openModal('ExportTicketsModal');
	                                            } },
	                                        _react2.default.createElement(_DownloadIcon2.default, { progress: progress[_actions.XLSX_TICKETS_EXPORTED] || progress[_actions.PDF_TICKETS_EXPORTED] || progress[_actions.PDF_TICKETS_REPORTED] })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketStats2.default.container },
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    {
	                                        value: location.pathname,
	                                        onChange: function onChange(p) {
	                                            return p && dispatch((0, _reactRouterRedux.push)(p));
	                                        } },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.ButtonGroup,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsSize: 'small',
	                                                value: '/tickets' },
	                                            _i18n2.default.search
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsSize: 'small',
	                                                value: '/tickets/dashboard' },
	                                            _i18n2.default.stats
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAddonsCssTransitionGroup2.default,
	                    {
	                        transitionName: transitionName,
	                        transitionEnterTimeout: 500,
	                        transitionLeaveTimeout: 500 },
	                    (!closed || stacked) && _react2.default.createElement(
	                        'div',
	                        { className: _TicketStats2.default.body },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: stacked && 12 || 4 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketStats2.default.newTickets },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        range.count,
	                                        ' ',
	                                        _i18n2.default.newTickets
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketStats2.default.count },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            stats.newTickets.lastSevenDays
	                                        ),
	                                        _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            _i18n2.default.lastWeek
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketStats2.default.count },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            stats.newTickets.currentMonth
	                                        ),
	                                        _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            _i18n2.default.thisMonth
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketStats2.default.count },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            stats.newTickets.lastMonth
	                                        ),
	                                        _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            _i18n2.default.lastMonth
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: stacked && 12 || 4 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketStats2.default.distribution },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        _i18n2.default.ticketsDistribution
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketStats2.default.chart },
	                                        _react2.default.createElement(_Chart2.default, { donut: true,
	                                            kind: 'Pie',
	                                            ratio: 'square',
	                                            donutWidth: 60,
	                                            startAngle: 250,
	                                            total: statusChartTotal,
	                                            plugins: statusChartPlugins,
	                                            display: function display(m) {
	                                                return m.count;
	                                            },
	                                            identify: function identify(m) {
	                                                return m.count;
	                                            },
	                                            value: aggregations.status })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketStats2.default.chart },
	                                        _react2.default.createElement(_Chart2.default, { donut: true, inverse: true,
	                                            kind: 'Pie',
	                                            ratio: 'square',
	                                            donutWidth: 60,
	                                            startAngle: 250,
	                                            total: interventionChartTotal,
	                                            plugins: interventionChartPlugins,
	                                            display: function display(m) {
	                                                return m.count;
	                                            },
	                                            identify: function identify(m) {
	                                                return m.count;
	                                            },
	                                            value: aggregations.interventions })
	                                    )
	                                )
	                            ),
	                            !stacked && _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketStats2.default.creationFrequency },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        _i18n2.default.ticketsCreationFrequency,
	                                        _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            _i18n2.default.dailyCreatedTicketCount
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketStats2.default.count },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            stats.ticketCreationFrequency.byDay
	                                        ),
	                                        _react2.default.createElement(_Icon2.default, { icon: 'file', size: 'xl' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_ExportTicketsModal2.default, {
	                    show: openedModal == 'ExportTicketsModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } })
	            );
	        }
	    }]);
	
	    return TicketStats;
	}(_react.Component);
	
	TicketStats.propTypes = {
	    stacked: _react.PropTypes.bool
	};
	
	
	TicketStats = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        ui: state.ui,
	        progress: state.progress,
	        aggregations: state.ticket.aggregations,
	        stats: state.ticket.stats,
	        range: state.ticket.range
	    };
	})(TicketStats);
	
	exports.default = TicketStats;

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = JSON.parse(localStorage.getItem(DEHYDRATE_KEY));
	
	    if (state && state.ticket.reportPdfTicketsOption) {
	        state.ticket.reportPdfTicketsOption.from = state.ticket.reportPdfTicketsOption.from && new Date(state.ticket.reportPdfTicketsOption.from), state.ticket.reportPdfTicketsOption.to = state.ticket.reportPdfTicketsOption.to && new Date(state.ticket.reportPdfTicketsOption.to);
	    }
	
	    if (state && state.ticket.exportTicketsOption) {
	        // migration
	        state.ticket.exportXlsxTicketsOption = state.ticket.exportTicketsOption;
	        delete state.ticket.exportTicketsOption;
	    }
	
	    return state;
	};
	
	var DEHYDRATE_KEY = exports.DEHYDRATE_KEY = 'Dehydrate/Ticket';

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(901);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(901);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(901);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(901);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(1003);
	var Transform = __webpack_require__(1004);
	var inherits = __webpack_require__(89);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(271)], __WEBPACK_AMD_DEFINE_RESULT__ = function (chartist) {
	            return (root.returnExportsGlobal = factory(chartist));
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like enviroments that support module.exports,
	        // like Node.
	        module.exports = factory(require('chartist'));
	    } else {
	        root['Chartist.plugins.legend'] = factory(root.Chartist);
	    }
	}(this, function (Chartist) {
	    /**
	     * This Chartist plugin creates a legend to show next to the chart.
	     *
	     */
	    'use strict';
	
	    var defaultOptions = {
	        className: '',
	        legendNames: false,
	        clickable: true
	    };
	
	    Chartist.plugins = Chartist.plugins || {};
	
	    Chartist.plugins.legend = function (options) {
	
	        options = Chartist.extend({}, defaultOptions, options);
	
	        return function legend(chart) {
	
	            // Set a unique className for each series so that when a series is removed,
	            // the other series still have the same color.
	            if (options.clickable) {
	                chart.data.series.forEach(function (series, seriesIndex) {
	                    if (typeof series !== 'object') {
	                        series = {
	                            data: series
	                        };
	                    }
	
	                    series.className = series.className || chart.options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex);
	                });
	            }
	
	            var chartElement = chart.container;
	            chartElement.innerHTML += '<ul class="ct-legend"></ul>';
	            var legendElement = chartElement.querySelector(".ct-legend");
	            if (chart instanceof Chartist.Pie) {
	                legendElement.classList.add('ct-legend-inside');
	            }
	            if (typeof options.className === "string" && options.className.length > 0) {
	                legendElement.classList.add(options.className);
	            }
	
	            var removedSeries = [],
	                originalSeries = chart.data.series.slice(0);
	
	            // Get the right array to use for generating the legend.
	            var legendNames = chart.data.series;
	            if (chart instanceof Chartist.Pie) {
	                legendNames = chart.data.labels;
	            }
	            legendNames = options.legendNames || legendNames;
	
	            // Loop through all legends to set each name in a list item.
	            var legendHtml = legendNames.map(function (legend, i) {
	                var legendName = legend.name || legend;
	                return '<li class="ct-series-' + i.toString() + '" data-legend="' + i.toString() + '">' + legendName + '</li>';
	            }).join("");
	            legendElement.innerHTML = legendHtml;
	
	            if (options.clickable) {
	                var legendChildClickEvent = function (e) {
	                    e.preventDefault();
	
	                    var seriesIndex = parseInt(this.getAttribute('data-legend')),
	                        removedSeriesIndex = removedSeries.indexOf(seriesIndex);
	
	                    if (removedSeriesIndex > -1) {
	                        // Add to series again.
	                        removedSeries.splice(removedSeriesIndex, 1);
	                        this.classList.remove('inactive');
	                    } else {
	                        // Remove from series, only if a minimum of one series is still visible.
	                        if (chart.data.series.length > 1) {
	                            removedSeries.push(seriesIndex);
	                            this.classList.add('inactive');
	                        }
	                    }
	
	                    // Reset the series to original and remove each series that
	                    // is still removed again, to remain index order.
	                    var seriesCopy = originalSeries.slice(0);
	
	                    // Reverse sort the removedSeries to prevent removing the wrong index.
	                    removedSeries.sort().reverse();
	
	                    removedSeries.forEach(function (series) {
	                        seriesCopy.splice(series, 1);
	                    });
	
	                    chart.data.series = seriesCopy;
	
	                    chart.update();
	                };
	                var legendElementChildren = legendElement.querySelectorAll("li");
	                Array.prototype.forEach.call(legendElementChildren, function (legendElementChild) {
	                    legendElementChild.onclick = legendChildClickEvent;
	                });
	            }
	
	        };
	
	    };
	
	    return Chartist.plugins.legend;
	
	}));


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(1576);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(1579);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(2153)
	
	var md5 = toConstructor(__webpack_require__(1593))
	var rmd160 = toConstructor(__webpack_require__(2150))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1796);
	var isArguments = __webpack_require__(1795);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(1806);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cce681c836a6486adb740374be888b0d.png";

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4769f9bdb7466be65088239c12046d1.eot";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(332);
	
	var _PathUtils = __webpack_require__(516);
	
	var _ExecutionEnvironment = __webpack_require__(793);
	
	var _DOMUtils = __webpack_require__(902);
	
	var _DOMStateStorage = __webpack_require__(1013);
	
	var _createDOMHistory = __webpack_require__(1142);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(793);
	
	var _DOMUtils = __webpack_require__(902);
	
	var _createHistory = __webpack_require__(1143);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(1135);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(516);
	
	var _AsyncUtils = __webpack_require__(1834);
	
	var _Actions = __webpack_require__(332);
	
	var _createLocation2 = __webpack_require__(1144);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(1015);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(517);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(332);
	
	var _PathUtils = __webpack_require__(516);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(516);
	
	var _Actions = __webpack_require__(332);
	
	var _createHistory = __webpack_require__(1143);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(793);
	
	var _DOMUtils = __webpack_require__(902);
	
	var _deprecate = __webpack_require__(517);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
	  function listener(event) {
	    var message = getBeforeUnloadPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	  }
	
	  _DOMUtils.addEventListener(window, 'beforeunload', listener);
	
	  return function () {
	    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
	  };
	}
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	function useBeforeUnload(createHistory) {
	  return function (options) {
	    var history = createHistory(options);
	
	    var stopBeforeUnloadListener = undefined;
	    var beforeUnloadHooks = [];
	
	    function getBeforeUnloadPromptMessage() {
	      var message = undefined;
	
	      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
	        message = beforeUnloadHooks[i].call();
	      }return message;
	    }
	
	    function listenBeforeUnload(hook) {
	      beforeUnloadHooks.push(hook);
	
	      if (beforeUnloadHooks.length === 1) {
	        if (_ExecutionEnvironment.canUseDOM) {
	          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	        } else {
	           false ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
	        }
	      }
	
	      return function () {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
	          stopBeforeUnloadListener();
	          stopBeforeUnloadListener = null;
	        }
	      };
	    }
	
	    // deprecated
	    function registerBeforeUnloadHook(hook) {
	      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
	        beforeUnloadHooks.push(hook);
	
	        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	      }
	    }
	
	    // deprecated
	    function unregisterBeforeUnloadHook(hook) {
	      if (beforeUnloadHooks.length > 0) {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
	      }
	    }
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload,
	
	      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
	      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
	    });
	  };
	}
	
	exports['default'] = useBeforeUnload;
	module.exports = exports['default'];

/***/ }),
/* 1147 */,
/* 1148 */
/***/ (function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1846),
	    isArguments = __webpack_require__(1020),
	    isArray = __webpack_require__(335),
	    isArrayLike = __webpack_require__(1019),
	    isObjectLike = __webpack_require__(518);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1866);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(263);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  object = toObject(object);
	  if (pathKey !== undefined && pathKey in object) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = toObject(object)[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1856),
	    isObject = __webpack_require__(336),
	    isObjectLike = __webpack_require__(518);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(263);
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : toObject(object)[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1153);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	var isHostObject = (function() {
	  try {
	    Object({ 'toString': 0 } + '');
	  } catch(e) {
	    return function() { return false; };
	  }
	  return function(value) {
	    // IE < 9 presents many host objects as `Object` objects that can coerce
	    // to strings despite having improperly defined `toString` methods.
	    return typeof value.toString != 'function' && typeof (value + '') == 'string';
	  };
	}());
	
	module.exports = isHostObject;


/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(335),
	    toObject = __webpack_require__(263);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(336);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(263);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties specified
	 * by `props`.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	module.exports = pickByArray;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(1853);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = pickByCallback;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1862),
	    isArray = __webpack_require__(335);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(336);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(519),
	    root = __webpack_require__(272);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(905),
	    stackClear = __webpack_require__(1954),
	    stackDelete = __webpack_require__(1955),
	    stackGet = __webpack_require__(1956),
	    stackHas = __webpack_require__(1957),
	    stackSet = __webpack_require__(1958);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1895);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1169),
	    isFlattenable = __webpack_require__(1930);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1175),
	    toKey = __webpack_require__(909);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1897),
	    isObjectLike = __webpack_require__(520);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(910),
	    overRest = __webpack_require__(1949),
	    setToString = __webpack_require__(1952);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(273),
	    isKey = __webpack_require__(1030),
	    stringToPath = __webpack_require__(1960),
	    toString = __webpack_require__(1971);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(519);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1028),
	    arraySome = __webpack_require__(1887),
	    cacheHas = __webpack_require__(1029);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 1178 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1034);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 1181 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 1184 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(1188),
	    isLength = __webpack_require__(1033);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(1185),
	    isObjectLike = __webpack_require__(520);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(272),
	    stubFalse = __webpack_require__(1970);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(506)(module)))

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(537),
	    isObject = __webpack_require__(1034);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1901),
	    baseUnary = __webpack_require__(1174),
	    nodeUtil = __webpack_require__(1947);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(463);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var BreadcrumbItem = _react2['default'].createClass({
	  displayName: 'BreadcrumbItem',
	
	  propTypes: {
	    /**
	     * If set to true, renders `span` instead of `a`
	     */
	    active: _react2['default'].PropTypes.bool,
	    /**
	     * HTML id for the wrapper `li` element
	     */
	    id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    /**
	     * HTML id for the inner `a` element
	     */
	    linkId: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    /**
	     * `href` attribute for the inner `a` element
	     */
	    href: _react2['default'].PropTypes.string,
	    /**
	     * `title` attribute for the inner `a` element
	     */
	    title: _react2['default'].PropTypes.node,
	    /**
	     * `target` attribute for the inner `a` element
	     */
	    target: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var className = _props.className;
	    var id = _props.id;
	    var linkId = _props.linkId;
	    var children = _props.children;
	    var href = _props.href;
	    var title = _props.title;
	    var target = _props.target;
	
	    var props = _objectWithoutProperties(_props, ['active', 'className', 'id', 'linkId', 'children', 'href', 'title', 'target']);
	
	    var linkProps = {
	      href: href,
	      title: title,
	      target: target,
	      id: linkId
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { id: id, className: _classnames2['default'](className, { active: active }) },
	      active ? _react2['default'].createElement(
	        'span',
	        props,
	        children
	      ) : _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        _extends({}, props, linkProps),
	        children
	      )
	    );
	  }
	});
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactPropTypesLibAll = __webpack_require__(916);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _Button = __webpack_require__(523);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var ButtonGroup = _react2['default'].createClass({
	  displayName: 'ButtonGroup',
	
	  propTypes: {
	    vertical: _react2['default'].PropTypes.bool,
	    justified: _react2['default'].PropTypes.bool,
	    /**
	     * Display block buttons, only useful when used with the "vertical" prop.
	     * @type {bool}
	     */
	    block: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (props) {
	      if (props.block && !props.vertical) {
	        return new Error('The block property requires the vertical property to be set to have any effect');
	      }
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      block: false,
	      justified: false,
	      vertical: false
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = !this.props.vertical;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'vertical')] = this.props.vertical;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'justified')] = this.props.justified;
	
	    // this is annoying, since the class is `btn-block` not `btn-group-block`
	    classes[_utilsBootstrapUtils2['default'].prefix(_Button2['default'].defaultProps, 'block')] = this.props.block;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utilsTransitionEvents = __webpack_require__(1208);
	
	var _utilsTransitionEvents2 = _interopRequireDefault(_utilsTransitionEvents);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var CarouselItem = _react2['default'].createClass({
	  displayName: 'CarouselItem',
	
	  propTypes: {
	    direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	    onAnimateOutEnd: _react2['default'].PropTypes.func,
	    active: _react2['default'].PropTypes.bool,
	    animateIn: _react2['default'].PropTypes.bool,
	    animateOut: _react2['default'].PropTypes.bool,
	    caption: _react2['default'].PropTypes.node,
	    index: _react2['default'].PropTypes.number
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      direction: null
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsStyle: 'carousel',
	      active: false,
	      animateIn: false,
	      animateOut: false
	    };
	  },
	
	  handleAnimateOutEnd: function handleAnimateOutEnd() {
	    if (this.props.onAnimateOutEnd && this.isMounted()) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({
	        direction: null
	      });
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (!this.props.active && prevProps.active) {
	      _utilsTransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (this.props.active !== prevProps.active) {
	      setTimeout(this.startAnimation, 20);
	    }
	  },
	
	  startAnimation: function startAnimation() {
	    if (!this.isMounted()) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  },
	
	  render: function render() {
	    var classes = {
	      item: true,
	      active: this.props.active && !this.props.animateIn || this.props.animateOut,
	      next: this.props.active && this.props.animateIn && this.props.direction === 'next',
	      prev: this.props.active && this.props.animateIn && this.props.direction === 'prev'
	    };
	
	    if (this.state.direction && (this.props.animateIn || this.props.animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children,
	      this.props.caption ? this.renderCaption() : null
	    );
	  },
	
	  renderCaption: function renderCaption() {
	    var classes = _utilsBootstrapUtils2['default'].prefix(this.props, 'caption');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: classes },
	      this.props.caption
	    );
	  }
	});
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _Object$keys = __webpack_require__(464)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styleMaps = __webpack_require__(150);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Col = _react2['default'].createClass({
	  displayName: 'Col',
	
	  propTypes: {
	    /**
	     * The number of columns you wish to span
	     *
	     * for Extra small devices Phones (<768px)
	     *
	     * class-prefix `col-xs-`
	     */
	    xs: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Small devices Tablets (≥768px)
	     *
	     * class-prefix `col-sm-`
	     */
	    sm: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Medium devices Desktops (≥992px)
	     *
	     * class-prefix `col-md-`
	     */
	    md: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Large devices Desktops (≥1200px)
	     *
	     * class-prefix `col-lg-`
	     */
	    lg: _react2['default'].PropTypes.number,
	    /**
	     * Hide column
	     *
	     * on Extra small devices Phones
	     *
	     * adds class `hidden-xs`
	     */
	    xsHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Small devices Tablets
	     *
	     * adds class `hidden-sm`
	     */
	    smHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Medium devices Desktops
	     *
	     * adds class `hidden-md`
	     */
	    mdHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Large devices Desktops
	     *
	     * adds class `hidden-lg`
	     */
	    lgHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Move columns to the right
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-offset-`
	     */
	    xsOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-offset-`
	     */
	    smOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-offset-`
	     */
	    mdOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-offset-`
	     */
	    lgOffset: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-push-`
	     */
	    xsPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-push-`
	     */
	    smPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-push-`
	     */
	    mdPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-push-`
	     */
	    lgPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-pull-`
	     */
	    xsPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-pull-`
	     */
	    smPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-pull-`
	     */
	    mdPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-pull-`
	     */
	    lgPull: _react2['default'].PropTypes.number,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var ComponentClass = this.props.componentClass;
	    var classes = {};
	
	    _Object$keys(_styleMaps2['default'].SIZES).forEach(function (key) {
	      var size = _styleMaps2['default'].SIZES[key];
	      var prop = size;
	      var classPart = size + '-';
	
	      if (_this.props[prop]) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      classes['hidden-' + size] = _this.props[size + 'Hidden'];
	
	      prop = size + 'Offset';
	      classPart = size + '-offset-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      prop = size + 'Push';
	      classPart = size + '-push-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      prop = size + 'Pull';
	      classPart = size + '-pull-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	    }, this);
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Col;
	module.exports = exports['default'];

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(523);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(463);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var CARET = _react2['default'].createElement(
	  'span',
	  null,
	  ' ',
	  _react2['default'].createElement('span', { className: 'caret' })
	);
	
	var DropdownToggle = (function (_React$Component) {
	  _inherits(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    _classCallCheck(this, DropdownToggle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var caret = this.props.noCaret ? null : CARET;
	
	    var classes = {
	      'dropdown-toggle': true
	    };
	
	    var Component = this.props.useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, this.props, {
	        className: _classnames2['default'](classes, this.props.className),
	        type: 'button',
	        'aria-haspopup': true,
	        'aria-expanded': this.props.open }),
	      this.props.children || this.props.title,
	      caret
	    );
	  };
	
	  return DropdownToggle;
	})(_react2['default'].Component);
	
	exports['default'] = DropdownToggle;
	
	DropdownToggle.defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	DropdownToggle.propTypes = {
	  bsRole: _react2['default'].PropTypes.string,
	  noCaret: _react2['default'].PropTypes.bool,
	  open: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.string,
	  useAnchor: _react2['default'].PropTypes.bool
	};
	
	DropdownToggle.isToggle = true;
	DropdownToggle.titleProp = 'title';
	DropdownToggle.onClickProp = 'onClick';
	module.exports = exports['default'];

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _Static2 = __webpack_require__(1992);
	
	var _Static3 = _interopRequireDefault(_Static2);
	
	exports.Static = _Static3['default'];

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var FormGroup = (function (_React$Component) {
	  _inherits(FormGroup, _React$Component);
	
	  function FormGroup() {
	    _classCallCheck(this, FormGroup);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  FormGroup.prototype.render = function render() {
	    var classes = {
	      'form-group': !this.props.standalone,
	      'form-group-lg': !this.props.standalone && this.props.bsSize === 'large',
	      'form-group-sm': !this.props.standalone && this.props.bsSize === 'small',
	      'has-feedback': this.props.hasFeedback,
	      'has-success': this.props.bsStyle === 'success',
	      'has-warning': this.props.bsStyle === 'warning',
	      'has-error': this.props.bsStyle === 'error'
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](classes, this.props.groupClassName) },
	      this.props.children
	    );
	  };
	
	  return FormGroup;
	})(_react2['default'].Component);
	
	FormGroup.defaultProps = {
	  hasFeedback: false,
	  standalone: false
	};
	
	FormGroup.propTypes = {
	  standalone: _react2['default'].PropTypes.bool,
	  hasFeedback: _react2['default'].PropTypes.bool,
	  bsSize: function bsSize(props) {
	    if (props.standalone && props.bsSize !== undefined) {
	      return new Error('bsSize will not be used when `standalone` is set.');
	    }
	
	    return _react2['default'].PropTypes.oneOf(['small', 'medium', 'large']).apply(null, arguments);
	  },
	  bsStyle: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  groupClassName: _react2['default'].PropTypes.string
	};
	
	exports['default'] = FormGroup;
	module.exports = exports['default'];

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	// https://www.npmjs.org/package/react-interpolate-component
	// TODO: Drop this in favor of es6 string interpolation
	
	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var REGEXP = /\%\((.+?)\)s/;
	
	var Interpolate = _react2['default'].createClass({
	  displayName: 'Interpolate',
	
	  propTypes: {
	    component: _react2['default'].PropTypes.node,
	    format: _react2['default'].PropTypes.string,
	    unsafe: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'span',
	      unsafe: false
	    };
	  },
	
	  render: function render() {
	    var format = _utilsValidComponentChildren2['default'].hasValidComponent(this.props.children) || typeof this.props.children === 'string' ? this.props.children : this.props.format;
	    var parent = this.props.component;
	    var unsafe = this.props.unsafe === true;
	    var props = _extends({}, this.props);
	
	    delete props.children;
	    delete props.format;
	    delete props.component;
	    delete props.unsafe;
	
	    if (unsafe) {
	      var content = format.split(REGEXP).reduce(function (memo, match, index) {
	        var html = undefined;
	
	        if (index % 2 === 0) {
	          html = match;
	        } else {
	          html = props[match];
	          delete props[match];
	        }
	
	        if (_react2['default'].isValidElement(html)) {
	          throw new Error('cannot interpolate a React component into unsafe text');
	        }
	
	        memo += html;
	
	        return memo;
	      }, '');
	
	      props.dangerouslySetInnerHTML = { __html: content };
	
	      return _react2['default'].createElement(parent, props);
	    }
	    var kids = format.split(REGEXP).reduce(function (memo, match, index) {
	      var child = undefined;
	
	      if (index % 2 === 0) {
	        if (match.length === 0) {
	          return memo;
	        }
	
	        child = match;
	      } else {
	        child = props[match];
	        delete props[match];
	      }
	
	      memo.push(child);
	
	      return memo;
	    }, []);
	
	    return _react2['default'].createElement(parent, props, kids);
	  }
	});
	
	exports['default'] = Interpolate;
	module.exports = exports['default'];

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var ListGroupItem = (function (_React$Component) {
	  _inherits(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    _classCallCheck(this, ListGroupItem);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ListGroupItem.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    classes.active = this.props.active;
	    classes.disabled = this.props.disabled;
	
	    if (this.props.href) {
	      return this.renderAnchor(classes);
	    } else if (this.props.onClick) {
	      return this.renderButton(classes);
	    } else if (this.props.listItem) {
	      return this.renderLi(classes);
	    }
	
	    return this.renderSpan(classes);
	  };
	
	  ListGroupItem.prototype.renderLi = function renderLi(classes) {
	    return _react2['default'].createElement(
	      'li',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderAnchor = function renderAnchor(classes) {
	    return _react2['default'].createElement(
	      'a',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderButton = function renderButton(classes) {
	    return _react2['default'].createElement(
	      'button',
	      _extends({
	        type: 'button'
	      }, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderSpan = function renderSpan(classes) {
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderStructuredContent = function renderStructuredContent() {
	    var header = undefined;
	    var headingClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'heading');
	
	    if (_react2['default'].isValidElement(this.props.header)) {
	      header = _react.cloneElement(this.props.header, {
	        key: 'header',
	        className: _classnames2['default'](this.props.header.props.className, headingClass)
	      });
	    } else {
	      header = _react2['default'].createElement(
	        'h4',
	        { key: 'header', className: headingClass },
	        this.props.header
	      );
	    }
	
	    var content = _react2['default'].createElement(
	      'p',
	      { key: 'content', className: _utilsBootstrapUtils2['default'].prefix(this.props, 'text') },
	      this.props.children
	    );
	
	    return [header, content];
	  };
	
	  return ListGroupItem;
	})(_react2['default'].Component);
	
	ListGroupItem.propTypes = {
	  className: _react2['default'].PropTypes.string,
	  active: _react2['default'].PropTypes.any,
	  disabled: _react2['default'].PropTypes.any,
	  header: _react2['default'].PropTypes.node,
	  listItem: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any,
	  href: _react2['default'].PropTypes.string,
	  target: _react2['default'].PropTypes.string
	};
	
	ListGroupItem.defaultTypes = {
	  listItem: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _utilsBootstrapUtils.bsClass('list-group-item', ListGroupItem));
	module.exports = exports['default'];

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var ModalBody = (function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody() {
	    _classCallCheck(this, ModalBody);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalBody.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].prefix(this.props, 'body')) }),
	      this.props.children
	    );
	  };
	
	  return ModalBody;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalBody);
	module.exports = exports['default'];

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var ModalFooter = (function (_React$Component) {
	  _inherits(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    _classCallCheck(this, ModalFooter);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalFooter.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].prefix(this.props, 'footer')) }),
	      this.props.children
	    );
	  };
	
	  return ModalFooter;
	})(_react2['default'].Component);
	
	ModalFooter.propTypes = {
	  /**
	   * A css class applied to the Component
	   */
	  bsClass: _react2['default'].PropTypes.string
	};
	
	ModalFooter.defaultProps = {
	  bsClass: 'modal'
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalFooter);
	module.exports = exports['default'];

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var ModalHeader = (function (_React$Component) {
	  _inherits(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    _classCallCheck(this, ModalHeader);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props;
	    var label = _props['aria-label'];
	
	    var props = _objectWithoutProperties(_props, ['aria-label']);
	
	    var onHide = _utilsCreateChainedFunction2['default'](this.context.$bs_onModalHide, this.props.onHide);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].prefix(this.props, 'header'))
	      }),
	      this.props.closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: onHide },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '×'
	        )
	      ),
	      this.props.children
	    );
	  };
	
	  return ModalHeader;
	})(_react2['default'].Component);
	
	ModalHeader.propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close button.
	   * It is used for Assistive Technology when the label text is not readable.
	   */
	  'aria-label': _react2['default'].PropTypes.string,
	
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside a Modal component, the onHide will automatically
	   * be propagated up to the parent Modal `onHide`.
	   */
	  onHide: _react2['default'].PropTypes.func
	};
	
	ModalHeader.contextTypes = {
	  '$bs_onModalHide': _react2['default'].PropTypes.func
	};
	
	ModalHeader.defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalHeader);
	module.exports = exports['default'];

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var ModalTitle = (function (_React$Component) {
	  _inherits(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    _classCallCheck(this, ModalTitle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalTitle.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'h4',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].prefix(this.props, 'title')) }),
	      this.props.children
	    );
	  };
	
	  return ModalTitle;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalTitle);
	module.exports = exports['default'];

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibAll = __webpack_require__(916);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(807);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _Collapse = __webpack_require__(804);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var Nav = (function (_React$Component) {
	  _inherits(Nav, _React$Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Nav.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var ulClassName = _props.ulClassName;
	    var id = _props.id;
	    var ulId = _props.ulId;
	
	    var isNavbar = this.props.navbar != null ? this.props.navbar : this.context.$bs_navbar;
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'stacked')] = this.props.stacked;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'justified')] = this.props.justified;
	
	    if (isNavbar) {
	      var bsClass = this.context.$bs_navbar_bsClass || 'navbar';
	      var navbarRight = this.props.right != null ? this.props.right : this.props.pullRight;
	
	      classes[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'nav')] = true;
	      classes[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'right')] = navbarRight;
	      classes[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'left')] = this.props.pullLeft;
	    } else {
	      classes['pull-right'] = this.props.pullRight;
	      classes['pull-left'] = this.props.pullLeft;
	    }
	
	    var list = _react2['default'].createElement(
	      'ul',
	      _extends({ ref: 'ul'
	      }, this.props, {
	        id: ulId || id,
	        role: this.props.bsStyle === 'tabs' ? 'tablist' : null,
	        className: _classnames2['default'](className, ulClassName, classes)
	      }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderNavItem, this)
	    );
	
	    // TODO remove in 0.29
	    if (this.context.$bs_deprecated_navbar && this.props.collapsible) {
	      list = _react2['default'].createElement(
	        _Collapse2['default'],
	        {
	          'in': this.props.expanded,
	          className: isNavbar ? 'navbar-collapse' : void 0
	        },
	        _react2['default'].createElement(
	          'div',
	          null,
	          list
	        )
	      );
	    }
	
	    return list;
	  };
	
	  Nav.prototype.getChildActiveProp = function getChildActiveProp(child) {
	    if (child.props.active) {
	      return true;
	    }
	    if (this.props.activeKey != null) {
	      if (child.props.eventKey === this.props.activeKey) {
	        return true;
	      }
	    }
	    if (this.props.activeHref != null) {
	      if (child.props.href === this.props.activeHref) {
	        return true;
	      }
	    }
	
	    return child.props.active;
	  };
	
	  Nav.prototype.renderNavItem = function renderNavItem(child, index) {
	    return _react.cloneElement(child, {
	      role: this.props.bsStyle === 'tabs' ? 'tab' : null,
	      active: this.getChildActiveProp(child),
	      activeKey: this.props.activeKey,
	      activeHref: this.props.activeHref,
	      onSelect: _utilsCreateChainedFunction2['default'](child.props.onSelect, this.props.onSelect),
	      key: child.key ? child.key : index,
	      navItem: true
	    });
	  };
	
	  return Nav;
	})(_react2['default'].Component);
	
	Nav.propTypes = {
	  activeHref: _react2['default'].PropTypes.string,
	  activeKey: _react2['default'].PropTypes.any,
	
	  stacked: _react2['default'].PropTypes.bool,
	  justified: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (_ref) {
	    var justified = _ref.justified;
	    var navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * CSS classes for the wrapper `nav` element
	   */
	  className: _react2['default'].PropTypes.string,
	  /**
	   * HTML id for the wrapper `nav` element
	   */
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  /**
	   * CSS classes for the inner `ul` element
	   *
	   * @deprecated
	   */
	  ulClassName: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.string, 'The wrapping `<nav>` has been removed you can use `className` now'),
	  /**
	   * HTML id for the inner `ul` element
	   *
	   * @deprecated
	   */
	
	  ulId: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.string, 'The wrapping `<nav>` has been removed you can use `id` now'),
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _react2['default'].PropTypes.bool,
	  eventKey: _react2['default'].PropTypes.any,
	  pullRight: _react2['default'].PropTypes.bool,
	  pullLeft: _react2['default'].PropTypes.bool,
	
	  right: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use the `pullRight` prop instead'),
	
	  /**
	   * @private
	   */
	  expanded: _react2['default'].PropTypes.bool,
	
	  /**
	   * @private
	   */
	  collapsible: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use `Navbar.Collapse` instead, to create collapsible Navbars')
	};
	
	Nav.contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.bool,
	  $bs_navbar_bsClass: _react2['default'].PropTypes.string,
	
	  $bs_deprecated_navbar: _react2['default'].PropTypes.bool
	};
	
	Nav.defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('nav', _utilsBootstrapUtils.bsStyles(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _NavbarBrand = __webpack_require__(1048);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _utilsDeprecationWarning = __webpack_require__(913);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	exports['default'] = _utilsDeprecationWarning2['default'].wrapper(_NavbarBrand2['default'], {
	  message: 'The `NavBrand` component has been renamed to: `NavbarBrand`. ' + 'Please use that component instead; this alias will be removed in an upcoming release'
	});
	module.exports = exports['default'];

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SafeAnchor = __webpack_require__(463);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var NavItem = _react2['default'].createClass({
	  displayName: 'NavItem',
	
	  propTypes: {
	    linkId: _react2['default'].PropTypes.string,
	    onSelect: _react2['default'].PropTypes.func,
	    active: _react2['default'].PropTypes.bool,
	    disabled: _react2['default'].PropTypes.bool,
	    href: _react2['default'].PropTypes.string,
	    onClick: _react2['default'].PropTypes.func,
	    role: _react2['default'].PropTypes.string,
	    title: _react2['default'].PropTypes.node,
	    eventKey: _react2['default'].PropTypes.any,
	    target: _react2['default'].PropTypes.string,
	    'aria-controls': _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      disabled: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var role = _props.role;
	    var linkId = _props.linkId;
	    var disabled = _props.disabled;
	    var active = _props.active;
	    var href = _props.href;
	    var onClick = _props.onClick;
	    var title = _props.title;
	    var target = _props.target;
	    var children = _props.children;
	    var tabIndex = _props.tabIndex;
	    var ariaControls = _props['aria-controls'];
	
	    var props = _objectWithoutProperties(_props, ['role', 'linkId', 'disabled', 'active', 'href', 'onClick', 'title', 'target', 'children', 'tabIndex', 'aria-controls']);
	
	    var classes = {
	      active: active,
	      disabled: disabled
	    };
	    var linkProps = {
	      role: role,
	      href: href,
	      onClick: _utilsCreateChainedFunction2['default'](onClick, this.handleClick),
	      title: title,
	      target: target,
	      tabIndex: tabIndex,
	      id: linkId
	    };
	
	    if (!role && href === '#') {
	      linkProps.role = 'button';
	    } else if (role === 'tab') {
	      linkProps['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      _extends({}, props, { role: 'presentation', className: _classnames2['default'](props.className, classes) }),
	      _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        _extends({}, linkProps, { 'aria-controls': ariaControls }),
	        children
	      )
	    );
	  },
	
	  handleClick: function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, this.props.href, this.props.target);
	      }
	    }
	  }
	});
	
	exports['default'] = NavItem;
	module.exports = exports['default'];
	//eslint-disable-line

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/prop-types: [2, {ignore: ["container", "containerPadding", "target", "placement", "children"] }] */
	/* These properties are validated in 'Portal' and 'Position' components */
	
	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOverlaysLibOverlay = __webpack_require__(2039);
	
	var _reactOverlaysLibOverlay2 = _interopRequireDefault(_reactOverlaysLibOverlay);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _Fade = __webpack_require__(1044);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Overlay = (function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props;
	    var child = _props.children;
	    var transition = _props.animation;
	
	    var props = _objectWithoutProperties(_props, ['children', 'animation']);
	
	    if (transition === true) {
	      transition = _Fade2['default'];
	    }
	
	    if (transition === false) {
	      transition = null;
	    }
	
	    if (!transition) {
	      child = _react.cloneElement(child, {
	        className: _classnames2['default']('in', child.props.className)
	      });
	    }
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibOverlay2['default'],
	      _extends({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	})(_react2['default'].Component);
	
	Overlay.propTypes = _extends({}, _reactOverlaysLibOverlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2['default'].PropTypes.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _react2['default'].PropTypes.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Use animation
	   */
	  animation: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _reactPropTypesLibElementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func
	});
	
	Overlay.defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false
	};
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var PanelGroup = _react2['default'].createClass({
	  displayName: 'PanelGroup',
	
	  propTypes: {
	    accordion: _react2['default'].PropTypes.bool,
	    activeKey: _react2['default'].PropTypes.any,
	    className: _react2['default'].PropTypes.string,
	    children: _react2['default'].PropTypes.node,
	    defaultActiveKey: _react2['default'].PropTypes.any,
	    onSelect: _react2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      accordion: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var defaultActiveKey = this.props.defaultActiveKey;
	
	    return {
	      activeKey: defaultActiveKey
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    if (this.props.accordion) {
	      props.role = 'tablist';
	    }
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, { className: _classnames2['default'](className, classes), onSelect: null }),
	      _utilsValidComponentChildren2['default'].map(props.children, this.renderPanel)
	    );
	  },
	
	  renderPanel: function renderPanel(child, index) {
	    var activeKey = this.props.activeKey != null ? this.props.activeKey : this.state.activeKey;
	
	    var props = {
	      bsStyle: child.props.bsStyle || this.props.bsStyle,
	      key: child.key ? child.key : index,
	      ref: child.ref
	    };
	
	    if (this.props.accordion) {
	      props.headerRole = 'tab';
	      props.panelRole = 'tabpanel';
	      props.collapsible = true;
	      props.expanded = child.props.eventKey === activeKey;
	      props.onSelect = this.handleSelect;
	    }
	
	    return _react.cloneElement(child, props);
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    // Defer any updates to this component during the `onSelect` handler.
	    return !this._isChanging;
	  },
	
	  handleSelect: function handleSelect(e, key) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this._isChanging = true;
	      this.props.onSelect(key);
	      this._isChanging = false;
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({
	      activeKey: key
	    });
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1573), __esModule: true };

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj["default"] = obj;
	    return newObj;
	  }
	};
	
	exports.__esModule = true;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(1053);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(805);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(1050);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(1051);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(1214);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(805);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(1217);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(1220);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(1217);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(2048);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(915);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(806);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(538));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(1051));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(915));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(806));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(915));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(538));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(2055));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(1223);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-env node */
	
	"use strict";
	
	module.exports = __webpack_require__(2061);
	module.exports.DateUtils = __webpack_require__(1056);
	module.exports.LocaleUtils  = __webpack_require__(1057);


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatMonthTitle = formatMonthTitle;
	exports.formatWeekdayShort = formatWeekdayShort;
	exports.formatWeekdayLong = formatWeekdayLong;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getMonths = getMonths;
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatMonthTitle(date) {
	  var locale = arguments.length <= 1 || arguments[1] === undefined ? "en" : arguments[1];
	
	  return (0, _moment2.default)(date).locale(locale).format("MMMM YYYY");
	}
	
	function formatWeekdayShort(day) {
	  var locale = arguments.length <= 1 || arguments[1] === undefined ? "en" : arguments[1];
	
	  return (0, _moment2.default)().locale(locale).weekday(day).format("dd");
	}
	
	function formatWeekdayLong(day) {
	  var locale = arguments.length <= 1 || arguments[1] === undefined ? "en" : arguments[1];
	
	  return (0, _moment2.default)().locale(locale).weekday(day).format("dddd");
	}
	
	function getFirstDayOfWeek() {
	  var locale = arguments.length <= 0 || arguments[0] === undefined ? "en" : arguments[0];
	
	  var localeData = _moment2.default.localeData(locale);
	  return localeData.firstDayOfWeek();
	}
	
	function getMonths() {
	  var locale = arguments.length <= 0 || arguments[0] === undefined ? "en" : arguments[0];
	
	  var months = [];
	  var i = 0;
	  while (i < 12) {
	    months.push((0, _moment2.default)().locale(locale).month(i++).format("MMMM"));
	  }
	  return months;
	}
	
	exports.default = {
	  formatMonthTitle: formatMonthTitle,
	  formatWeekdayShort: formatWeekdayShort,
	  formatWeekdayLong: formatWeekdayLong,
	  getFirstDayOfWeek: getFirstDayOfWeek,
	  getMonths: getMonths
	};
	//# sourceMappingURL=MomentLocaleUtils.js.map

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-env node */
	
	"use strict";
	
	module.exports = __webpack_require__(1225);
	module.exports.localeUtils = __webpack_require__(1225);


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(199)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(524)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $           = __webpack_require__(197)
	  , hide        = __webpack_require__(524)
	  , redefineAll = __webpack_require__(1237)
	  , ctx         = __webpack_require__(917)
	  , anInstance  = __webpack_require__(1228)
	  , defined     = __webpack_require__(918)
	  , forOf       = __webpack_require__(1061)
	  , $iterDefine = __webpack_require__(1063)
	  , step        = __webpack_require__(1235)
	  , setSpecies  = __webpack_require__(2084)
	  , DESCRIPTORS = __webpack_require__(919)
	  , fastKey     = __webpack_require__(1064).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(1059)
	  , from    = __webpack_require__(2074);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(465)
	  , $export        = __webpack_require__(274)
	  , redefine       = __webpack_require__(525)
	  , redefineAll    = __webpack_require__(1237)
	  , meta           = __webpack_require__(1064)
	  , forOf          = __webpack_require__(1061)
	  , anInstance     = __webpack_require__(1228)
	  , isObject       = __webpack_require__(1062)
	  , fails          = __webpack_require__(808)
	  , $iterDetect    = __webpack_require__(1234)
	  , setToStringTag = __webpack_require__(921);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = new Base;
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(809)
	  , ITERATOR   = __webpack_require__(199)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(1058);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(199)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	module.exports = false;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(525);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(465)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(918);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(1059)
	  , ITERATOR  = __webpack_require__(199)('iterator')
	  , Iterators = __webpack_require__(809);
	module.exports = __webpack_require__(198).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(1059)
	  , test    = {};
	test[__webpack_require__(199)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(525)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators     = __webpack_require__(2088)
	  , redefine       = __webpack_require__(525)
	  , global         = __webpack_require__(465)
	  , hide           = __webpack_require__(524)
	  , Iterators      = __webpack_require__(809)
	  , wks            = __webpack_require__(199)
	  , ITERATOR       = wks('iterator')
	  , TO_STRING_TAG  = wks('toStringTag')
	  , ArrayValues    = Iterators.Array;
	
	__webpack_require__(197).each.call(['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], function(NAME){
	  var Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	});

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utilsAddEventListener = __webpack_require__(2099);
	
	var _utilsAddEventListener2 = _interopRequireDefault(_utilsAddEventListener);
	
	var _utilsCreateChainedFunction = __webpack_require__(2100);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsOwnerDocument = __webpack_require__(2101);
	
	var _utilsOwnerDocument2 = _interopRequireDefault(_utilsOwnerDocument);
	
	// TODO: Consider using an ES6 symbol here, once we use babel-runtime.
	var CLICK_WAS_INSIDE = '__click_was_inside';
	
	var counter = 0;
	
	function getSuppressRootClose() {
	  var id = CLICK_WAS_INSIDE + '_' + counter++;
	  return {
	    id: id,
	    suppressRootClose: function suppressRootClose(event) {
	      // Tag the native event to prevent the root close logic on document click.
	      // This seems safer than using event.nativeEvent.stopImmediatePropagation(),
	      // which is only supported in IE >= 9.
	      event.nativeEvent[id] = true;
	    }
	  };
	}
	
	var RootCloseWrapper = (function (_React$Component) {
	  function RootCloseWrapper(props) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    _React$Component.call(this, props);
	
	    this.handleDocumentClick = this.handleDocumentClick.bind(this);
	    this.handleDocumentKeyUp = this.handleDocumentKeyUp.bind(this);
	
	    var _getSuppressRootClose = getSuppressRootClose();
	
	    var id = _getSuppressRootClose.id;
	    var suppressRootClose = _getSuppressRootClose.suppressRootClose;
	
	    this._suppressRootId = id;
	
	    this._suppressRootCloseHandler = suppressRootClose;
	  }
	
	  _inherits(RootCloseWrapper, _React$Component);
	
	  RootCloseWrapper.prototype.bindRootCloseHandlers = function bindRootCloseHandlers() {
	    var doc = _utilsOwnerDocument2['default'](this);
	
	    this._onDocumentClickListener = _utilsAddEventListener2['default'](doc, 'click', this.handleDocumentClick);
	
	    this._onDocumentKeyupListener = _utilsAddEventListener2['default'](doc, 'keyup', this.handleDocumentKeyUp);
	  };
	
	  RootCloseWrapper.prototype.handleDocumentClick = function handleDocumentClick(e) {
	    // This is now the native event.
	    if (e[this._suppressRootId]) {
	      return;
	    }
	
	    this.props.onRootClose();
	  };
	
	  RootCloseWrapper.prototype.handleDocumentKeyUp = function handleDocumentKeyUp(e) {
	    if (e.keyCode === 27) {
	      this.props.onRootClose();
	    }
	  };
	
	  RootCloseWrapper.prototype.unbindRootCloseHandlers = function unbindRootCloseHandlers() {
	    if (this._onDocumentClickListener) {
	      this._onDocumentClickListener.remove();
	    }
	
	    if (this._onDocumentKeyupListener) {
	      this._onDocumentKeyupListener.remove();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    this.bindRootCloseHandlers();
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    var _props = this.props;
	    var noWrap = _props.noWrap;
	    var children = _props.children;
	
	    var child = _react2['default'].Children.only(children);
	
	    if (noWrap) {
	      return _react2['default'].cloneElement(child, {
	        onClick: _utilsCreateChainedFunction2['default'](this._suppressRootCloseHandler, child.props.onClick)
	      });
	    }
	
	    // Wrap the child in a new element, so the child won't have to handle
	    // potentially combining multiple onClick listeners.
	    return _react2['default'].createElement(
	      'div',
	      { onClick: this._suppressRootCloseHandler },
	      child
	    );
	  };
	
	  RootCloseWrapper.prototype.getWrappedDOMNode = function getWrappedDOMNode() {
	    // We can't use a ref to identify the wrapped child, since we might be
	    // stealing the ref from the owner, but we know exactly the DOM structure
	    // that will be rendered, so we can just do this to get the child's DOM
	    // node for doing size calculations in OverlayMixin.
	    var node = _reactDom2['default'].findDOMNode(this);
	    return this.props.noWrap ? node : node.firstChild;
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unbindRootCloseHandlers();
	  };
	
	  return RootCloseWrapper;
	})(_react2['default'].Component);
	
	exports['default'] = RootCloseWrapper;
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  onRootClose: _react2['default'].PropTypes.func.isRequired,
	
	  /**
	   * Passes the suppress click handler directly to the child component instead
	   * of placing it on a wrapping div. Only use when you can be sure the child
	   * properly handle the click event.
	   */
	  noWrap: _react2['default'].PropTypes.bool
	};
	module.exports = exports['default'];

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(1042);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(1070);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(466);
	
	var _PatternUtils = __webpack_require__(539);
	
	var _InternalPropTypes = __webpack_require__(526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(924);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(535);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(1016);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1145);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(1254);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(924);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(535);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(1016);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.INIT_ACTION = exports.ActionCreators = exports.ActionTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.liftAction = liftAction;
	exports.liftReducerWith = liftReducerWith;
	exports.unliftState = unliftState;
	exports.unliftStore = unliftStore;
	exports.default = instrument;
	
	var _difference = __webpack_require__(1962);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _union = __webpack_require__(1972);
	
	var _union2 = _interopRequireDefault(_union);
	
	var _isPlainObject = __webpack_require__(911);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1261);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = {
	  PERFORM_ACTION: 'PERFORM_ACTION',
	  RESET: 'RESET',
	  ROLLBACK: 'ROLLBACK',
	  COMMIT: 'COMMIT',
	  SWEEP: 'SWEEP',
	  TOGGLE_ACTION: 'TOGGLE_ACTION',
	  SET_ACTIONS_ACTIVE: 'SET_ACTIONS_ACTIVE',
	  JUMP_TO_STATE: 'JUMP_TO_STATE',
	  JUMP_TO_ACTION: 'JUMP_TO_ACTION',
	  REORDER_ACTION: 'REORDER_ACTION',
	  IMPORT_STATE: 'IMPORT_STATE',
	  LOCK_CHANGES: 'LOCK_CHANGES',
	  PAUSE_RECORDING: 'PAUSE_RECORDING'
	};
	
	var isChrome = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof window.chrome !== 'undefined' || typeof window.process !== 'undefined' && window.process.type === 'renderer');
	
	var isChromeOrNode = isChrome || typeof process !== 'undefined' && process.release && process.release.name === 'node';
	
	/**
	 * Action creators to change the History state.
	 */
	var ActionCreators = exports.ActionCreators = {
	  performAction: function performAction(action, trace, traceLimit, toExcludeFromTrace) {
	    if (!(0, _isPlainObject2.default)(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    var stack = void 0;
	    if (trace) {
	      var extraFrames = 0;
	      if (typeof trace === 'function') {
	        stack = trace(action);
	      } else {
	        var error = Error();
	        var prevStackTraceLimit = void 0;
	        if (Error.captureStackTrace && isChromeOrNode) {
	          // avoid error-polyfill
	          if (Error.stackTraceLimit < traceLimit) {
	            prevStackTraceLimit = Error.stackTraceLimit;
	            Error.stackTraceLimit = traceLimit;
	          }
	          Error.captureStackTrace(error, toExcludeFromTrace);
	        } else {
	          extraFrames = 3;
	        }
	        stack = error.stack;
	        if (prevStackTraceLimit) Error.stackTraceLimit = prevStackTraceLimit;
	        if (extraFrames || typeof Error.stackTraceLimit !== 'number' || Error.stackTraceLimit > traceLimit) {
	          var frames = stack.split('\n');
	          if (frames.length > traceLimit) {
	            stack = frames.slice(0, traceLimit + extraFrames + (frames[0] === 'Error' ? 1 : 0)).join('\n');
	          }
	        }
	      }
	    }
	
	    return { type: ActionTypes.PERFORM_ACTION, action: action, timestamp: Date.now(), stack: stack };
	  },
	  reset: function reset() {
	    return { type: ActionTypes.RESET, timestamp: Date.now() };
	  },
	  rollback: function rollback() {
	    return { type: ActionTypes.ROLLBACK, timestamp: Date.now() };
	  },
	  commit: function commit() {
	    return { type: ActionTypes.COMMIT, timestamp: Date.now() };
	  },
	  sweep: function sweep() {
	    return { type: ActionTypes.SWEEP };
	  },
	  toggleAction: function toggleAction(id) {
	    return { type: ActionTypes.TOGGLE_ACTION, id: id };
	  },
	  setActionsActive: function setActionsActive(start, end) {
	    var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    return { type: ActionTypes.SET_ACTIONS_ACTIVE, start: start, end: end, active: active };
	  },
	  reorderAction: function reorderAction(actionId, beforeActionId) {
	    return { type: ActionTypes.REORDER_ACTION, actionId: actionId, beforeActionId: beforeActionId };
	  },
	  jumpToState: function jumpToState(index) {
	    return { type: ActionTypes.JUMP_TO_STATE, index: index };
	  },
	  jumpToAction: function jumpToAction(actionId) {
	    return { type: ActionTypes.JUMP_TO_ACTION, actionId: actionId };
	  },
	  importState: function importState(nextLiftedState, noRecompute) {
	    return { type: ActionTypes.IMPORT_STATE, nextLiftedState: nextLiftedState, noRecompute: noRecompute };
	  },
	  lockChanges: function lockChanges(status) {
	    return { type: ActionTypes.LOCK_CHANGES, status: status };
	  },
	  pauseRecording: function pauseRecording(status) {
	    return { type: ActionTypes.PAUSE_RECORDING, status: status };
	  }
	};
	
	var INIT_ACTION = exports.INIT_ACTION = { type: '@@INIT' };
	
	/**
	 * Computes the next entry with exceptions catching.
	 */
	function computeWithTryCatch(reducer, action, state) {
	  var nextState = state;
	  var nextError = void 0;
	  try {
	    nextState = reducer(state, action);
	  } catch (err) {
	    nextError = err.toString();
	    if (isChrome) {
	      // In Chrome, rethrowing provides better source map support
	      setTimeout(function () {
	        throw err;
	      });
	    } else {
	      console.error(err);
	    }
	  }
	
	  return {
	    state: nextState,
	    error: nextError
	  };
	}
	
	/**
	 * Computes the next entry in the log by applying an action.
	 */
	function computeNextEntry(reducer, action, state, shouldCatchErrors) {
	  if (!shouldCatchErrors) {
	    return { state: reducer(state, action) };
	  }
	  return computeWithTryCatch(reducer, action, state);
	}
	
	/**
	 * Runs the reducer on invalidated actions to get a fresh computation log.
	 */
	function recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, shouldCatchErrors) {
	  // Optimization: exit early and return the same reference
	  // if we know nothing could have changed.
	  if (!computedStates || minInvalidatedStateIndex === -1 || minInvalidatedStateIndex >= computedStates.length && computedStates.length === stagedActionIds.length) {
	    return computedStates;
	  }
	
	  var nextComputedStates = computedStates.slice(0, minInvalidatedStateIndex);
	  for (var i = minInvalidatedStateIndex; i < stagedActionIds.length; i++) {
	    var actionId = stagedActionIds[i];
	    var action = actionsById[actionId].action;
	
	    var previousEntry = nextComputedStates[i - 1];
	    var previousState = previousEntry ? previousEntry.state : committedState;
	
	    var shouldSkip = skippedActionIds.indexOf(actionId) > -1;
	    var entry = void 0;
	    if (shouldSkip) {
	      entry = previousEntry;
	    } else {
	      if (shouldCatchErrors && previousEntry && previousEntry.error) {
	        entry = {
	          state: previousState,
	          error: 'Interrupted by an error up the chain'
	        };
	      } else {
	        entry = computeNextEntry(reducer, action, previousState, shouldCatchErrors);
	      }
	    }
	    nextComputedStates.push(entry);
	  }
	
	  return nextComputedStates;
	}
	
	/**
	 * Lifts an app's action into an action on the lifted store.
	 */
	function liftAction(action, trace, traceLimit, toExcludeFromTrace) {
	  return ActionCreators.performAction(action, trace, traceLimit, toExcludeFromTrace);
	}
	
	/**
	 * Creates a history state reducer from an app's reducer.
	 */
	function liftReducerWith(reducer, initialCommittedState, monitorReducer, options) {
	  var initialLiftedState = {
	    monitorState: monitorReducer(undefined, {}),
	    nextActionId: 1,
	    actionsById: { 0: liftAction(INIT_ACTION) },
	    stagedActionIds: [0],
	    skippedActionIds: [],
	    committedState: initialCommittedState,
	    currentStateIndex: 0,
	    computedStates: [],
	    isLocked: options.shouldStartLocked === true,
	    isPaused: options.shouldRecordChanges === false
	  };
	
	  /**
	   * Manages how the history actions modify the history state.
	   */
	  return function (liftedState, liftedAction) {
	    var _ref = liftedState || initialLiftedState,
	        monitorState = _ref.monitorState,
	        actionsById = _ref.actionsById,
	        nextActionId = _ref.nextActionId,
	        stagedActionIds = _ref.stagedActionIds,
	        skippedActionIds = _ref.skippedActionIds,
	        committedState = _ref.committedState,
	        currentStateIndex = _ref.currentStateIndex,
	        computedStates = _ref.computedStates,
	        isLocked = _ref.isLocked,
	        isPaused = _ref.isPaused;
	
	    if (!liftedState) {
	      // Prevent mutating initialLiftedState
	      actionsById = _extends({}, actionsById);
	    }
	
	    function commitExcessActions(n) {
	      // Auto-commits n-number of excess actions.
	      var excess = n;
	      var idsToDelete = stagedActionIds.slice(1, excess + 1);
	
	      for (var i = 0; i < idsToDelete.length; i++) {
	        if (computedStates[i + 1].error) {
	          // Stop if error is found. Commit actions up to error.
	          excess = i;
	          idsToDelete = stagedActionIds.slice(1, excess + 1);
	          break;
	        } else {
	          delete actionsById[idsToDelete[i]];
	        }
	      }
	
	      skippedActionIds = skippedActionIds.filter(function (id) {
	        return idsToDelete.indexOf(id) === -1;
	      });
	      stagedActionIds = [0].concat(stagedActionIds.slice(excess + 1));
	      committedState = computedStates[excess].state;
	      computedStates = computedStates.slice(excess);
	      currentStateIndex = currentStateIndex > excess ? currentStateIndex - excess : 0;
	    }
	
	    function computePausedAction(shouldInit) {
	      var _extends2;
	
	      var computedState = void 0;
	      if (shouldInit) {
	        computedState = computedStates[currentStateIndex];
	        monitorState = monitorReducer(monitorState, liftedAction);
	      } else {
	        computedState = computeNextEntry(reducer, liftedAction.action, computedStates[currentStateIndex].state, false);
	      }
	      if (!options.pauseActionType || nextActionId === 1) {
	        return {
	          monitorState: monitorState,
	          actionsById: { 0: liftAction(INIT_ACTION) },
	          nextActionId: 1,
	          stagedActionIds: [0],
	          skippedActionIds: [],
	          committedState: computedState.state,
	          currentStateIndex: 0,
	          computedStates: [computedState],
	          isLocked: isLocked,
	          isPaused: true
	        };
	      }
	      if (shouldInit) {
	        if (currentStateIndex === stagedActionIds.length - 1) {
	          currentStateIndex++;
	        }
	        stagedActionIds = [].concat(stagedActionIds, [nextActionId]);
	        nextActionId++;
	      }
	      return {
	        monitorState: monitorState,
	        actionsById: _extends({}, actionsById, (_extends2 = {}, _extends2[nextActionId - 1] = liftAction({ type: options.pauseActionType }), _extends2)),
	        nextActionId: nextActionId,
	        stagedActionIds: stagedActionIds,
	        skippedActionIds: skippedActionIds,
	        committedState: committedState,
	        currentStateIndex: currentStateIndex,
	        computedStates: [].concat(computedStates.slice(0, stagedActionIds.length - 1), [computedState]),
	        isLocked: isLocked,
	        isPaused: true
	      };
	    }
	
	    // By default, agressively recompute every state whatever happens.
	    // This has O(n) performance, so we'll override this to a sensible
	    // value whenever we feel like we don't have to recompute the states.
	    var minInvalidatedStateIndex = 0;
	
	    // maxAge number can be changed dynamically
	    var maxAge = options.maxAge;
	    if (typeof maxAge === 'function') maxAge = maxAge(liftedAction, liftedState);
	
	    if (/^@@redux\/(INIT|REPLACE)/.test(liftedAction.type)) {
	      if (options.shouldHotReload === false) {
	        actionsById = { 0: liftAction(INIT_ACTION) };
	        nextActionId = 1;
	        stagedActionIds = [0];
	        skippedActionIds = [];
	        committedState = computedStates.length === 0 ? initialCommittedState : computedStates[currentStateIndex].state;
	        currentStateIndex = 0;
	        computedStates = [];
	      }
	
	      // Recompute states on hot reload and init.
	      minInvalidatedStateIndex = 0;
	
	      if (maxAge && stagedActionIds.length > maxAge) {
	        // States must be recomputed before committing excess.
	        computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
	
	        commitExcessActions(stagedActionIds.length - maxAge);
	
	        // Avoid double computation.
	        minInvalidatedStateIndex = Infinity;
	      }
	    } else {
	      switch (liftedAction.type) {
	        case ActionTypes.PERFORM_ACTION:
	          {
	            if (isLocked) return liftedState || initialLiftedState;
	            if (isPaused) return computePausedAction();
	
	            // Auto-commit as new actions come in.
	            if (maxAge && stagedActionIds.length >= maxAge) {
	              commitExcessActions(stagedActionIds.length - maxAge + 1);
	            }
	
	            if (currentStateIndex === stagedActionIds.length - 1) {
	              currentStateIndex++;
	            }
	            var actionId = nextActionId++;
	            // Mutation! This is the hottest path, and we optimize on purpose.
	            // It is safe because we set a new key in a cache dictionary.
	            actionsById[actionId] = liftedAction;
	            stagedActionIds = [].concat(stagedActionIds, [actionId]);
	            // Optimization: we know that only the new action needs computing.
	            minInvalidatedStateIndex = stagedActionIds.length - 1;
	            break;
	          }
	        case ActionTypes.RESET:
	          {
	            // Get back to the state the store was created with.
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = initialCommittedState;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	        case ActionTypes.COMMIT:
	          {
	            // Consider the last committed state the new starting point.
	            // Squash any staged actions into a single committed state.
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = computedStates[currentStateIndex].state;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	        case ActionTypes.ROLLBACK:
	          {
	            // Forget about any staged actions.
	            // Start again from the last committed state.
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	        case ActionTypes.TOGGLE_ACTION:
	          {
	            // Toggle whether an action with given ID is skipped.
	            // Being skipped means it is a no-op during the computation.
	            var _actionId = liftedAction.id;
	
	            var index = skippedActionIds.indexOf(_actionId);
	            if (index === -1) {
	              skippedActionIds = [_actionId].concat(skippedActionIds);
	            } else {
	              skippedActionIds = skippedActionIds.filter(function (id) {
	                return id !== _actionId;
	              });
	            }
	            // Optimization: we know history before this action hasn't changed
	            minInvalidatedStateIndex = stagedActionIds.indexOf(_actionId);
	            break;
	          }
	        case ActionTypes.SET_ACTIONS_ACTIVE:
	          {
	            // Toggle whether an action with given ID is skipped.
	            // Being skipped means it is a no-op during the computation.
	            var start = liftedAction.start,
	                end = liftedAction.end,
	                active = liftedAction.active;
	
	            var actionIds = [];
	            for (var i = start; i < end; i++) {
	              actionIds.push(i);
	            }if (active) {
	              skippedActionIds = (0, _difference2.default)(skippedActionIds, actionIds);
	            } else {
	              skippedActionIds = (0, _union2.default)(skippedActionIds, actionIds);
	            }
	
	            // Optimization: we know history before this action hasn't changed
	            minInvalidatedStateIndex = stagedActionIds.indexOf(start);
	            break;
	          }
	        case ActionTypes.JUMP_TO_STATE:
	          {
	            // Without recomputing anything, move the pointer that tell us
	            // which state is considered the current one. Useful for sliders.
	            currentStateIndex = liftedAction.index;
	            // Optimization: we know the history has not changed.
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	        case ActionTypes.JUMP_TO_ACTION:
	          {
	            // Jumps to a corresponding state to a specific action.
	            // Useful when filtering actions.
	            var _index = stagedActionIds.indexOf(liftedAction.actionId);
	            if (_index !== -1) currentStateIndex = _index;
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	        case ActionTypes.SWEEP:
	          {
	            // Forget any actions that are currently being skipped.
	            stagedActionIds = (0, _difference2.default)(stagedActionIds, skippedActionIds);
	            skippedActionIds = [];
	            currentStateIndex = Math.min(currentStateIndex, stagedActionIds.length - 1);
	            break;
	          }
	        case ActionTypes.REORDER_ACTION:
	          {
	            // Recompute actions in a new order.
	            var _actionId2 = liftedAction.actionId;
	            var idx = stagedActionIds.indexOf(_actionId2);
	            // do nothing in case the action is already removed or trying to move the first action
	            if (idx < 1) break;
	            var beforeActionId = liftedAction.beforeActionId;
	            var newIdx = stagedActionIds.indexOf(beforeActionId);
	            if (newIdx < 1) {
	              // move to the beginning or to the end
	              var count = stagedActionIds.length;
	              newIdx = beforeActionId > stagedActionIds[count - 1] ? count : 1;
	            }
	            var diff = idx - newIdx;
	
	            if (diff > 0) {
	              // move left
	              stagedActionIds = [].concat(stagedActionIds.slice(0, newIdx), [_actionId2], stagedActionIds.slice(newIdx, idx), stagedActionIds.slice(idx + 1));
	              minInvalidatedStateIndex = newIdx;
	            } else if (diff < 0) {
	              // move right
	              stagedActionIds = [].concat(stagedActionIds.slice(0, idx), stagedActionIds.slice(idx + 1, newIdx), [_actionId2], stagedActionIds.slice(newIdx));
	              minInvalidatedStateIndex = idx;
	            }
	            break;
	          }
	        case ActionTypes.IMPORT_STATE:
	          {
	            if (Array.isArray(liftedAction.nextLiftedState)) {
	              // recompute array of actions
	              actionsById = { 0: liftAction(INIT_ACTION) };
	              nextActionId = 1;
	              stagedActionIds = [0];
	              skippedActionIds = [];
	              currentStateIndex = liftedAction.nextLiftedState.length;
	              computedStates = [];
	              committedState = liftedAction.preloadedState;
	              minInvalidatedStateIndex = 0;
	              // iterate through actions
	              liftedAction.nextLiftedState.forEach(function (action) {
	                actionsById[nextActionId] = liftAction(action, options.trace || options.shouldIncludeCallstack);
	                stagedActionIds.push(nextActionId);
	                nextActionId++;
	              });
	            } else {
	              var _liftedAction$nextLif = liftedAction.nextLiftedState;
	              // Completely replace everything.
	
	              monitorState = _liftedAction$nextLif.monitorState;
	              actionsById = _liftedAction$nextLif.actionsById;
	              nextActionId = _liftedAction$nextLif.nextActionId;
	              stagedActionIds = _liftedAction$nextLif.stagedActionIds;
	              skippedActionIds = _liftedAction$nextLif.skippedActionIds;
	              committedState = _liftedAction$nextLif.committedState;
	              currentStateIndex = _liftedAction$nextLif.currentStateIndex;
	              computedStates = _liftedAction$nextLif.computedStates;
	
	
	              if (liftedAction.noRecompute) {
	                minInvalidatedStateIndex = Infinity;
	              }
	            }
	
	            break;
	          }
	        case ActionTypes.LOCK_CHANGES:
	          {
	            isLocked = liftedAction.status;
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	        case ActionTypes.PAUSE_RECORDING:
	          {
	            isPaused = liftedAction.status;
	            if (isPaused) {
	              return computePausedAction(true);
	            }
	            // Commit when unpausing
	            actionsById = { 0: liftAction(INIT_ACTION) };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = computedStates[currentStateIndex].state;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	        default:
	          {
	            // If the action is not recognized, it's a monitor action.
	            // Optimization: a monitor action can't change history.
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	      }
	    }
	
	    computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
	    monitorState = monitorReducer(monitorState, liftedAction);
	    return {
	      monitorState: monitorState,
	      actionsById: actionsById,
	      nextActionId: nextActionId,
	      stagedActionIds: stagedActionIds,
	      skippedActionIds: skippedActionIds,
	      committedState: committedState,
	      currentStateIndex: currentStateIndex,
	      computedStates: computedStates,
	      isLocked: isLocked,
	      isPaused: isPaused
	    };
	  };
	}
	
	/**
	 * Provides an app's view into the state of the lifted store.
	 */
	function unliftState(liftedState) {
	  var computedStates = liftedState.computedStates,
	      currentStateIndex = liftedState.currentStateIndex;
	  var state = computedStates[currentStateIndex].state;
	
	  return state;
	}
	
	/**
	 * Provides an app's view into the lifted store.
	 */
	function unliftStore(liftedStore, liftReducer, options) {
	  var _extends3;
	
	  var lastDefinedState = void 0;
	  var trace = options.trace || options.shouldIncludeCallstack;
	  var traceLimit = options.traceLimit || 10;
	
	  function getState() {
	    var state = unliftState(liftedStore.getState());
	    if (state !== undefined) {
	      lastDefinedState = state;
	    }
	    return lastDefinedState;
	  }
	
	  function dispatch(action) {
	    liftedStore.dispatch(liftAction(action, trace, traceLimit, dispatch));
	    return action;
	  }
	
	  return _extends({}, liftedStore, (_extends3 = {
	
	    liftedStore: liftedStore,
	
	    dispatch: dispatch,
	
	    getState: getState,
	
	    replaceReducer: function replaceReducer(nextReducer) {
	      liftedStore.replaceReducer(liftReducer(nextReducer));
	    }
	  }, _extends3[_symbolObservable2.default] = function () {
	    return _extends({}, liftedStore[_symbolObservable2.default](), {
	      subscribe: function subscribe(observer) {
	        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = liftedStore.subscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    });
	  }, _extends3));
	}
	
	/**
	 * Redux instrumentation store enhancer.
	 */
	function instrument() {
	  var monitorReducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	    return null;
	  };
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options.maxAge === 'number' && options.maxAge < 2) {
	    throw new Error('DevTools.instrument({ maxAge }) option, if specified, ' + 'may not be less than 2.');
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	
	      function liftReducer(r) {
	        if (typeof r !== 'function') {
	          if (r && typeof r.default === 'function') {
	            throw new Error('Expected the reducer to be a function. ' + 'Instead got an object with a "default" field. ' + 'Did you pass a module instead of the default export? ' + 'Try passing require(...).default instead.');
	          }
	          throw new Error('Expected the reducer to be a function.');
	        }
	        return liftReducerWith(r, initialState, monitorReducer, options);
	      }
	
	      var liftedStore = createStore(liftReducer(reducer), enhancer);
	      if (liftedStore.liftedStore) {
	        throw new Error('DevTools instrumentation should not be applied more than once. ' + 'Check your store configuration.');
	      }
	
	      return unliftStore(liftedStore, liftReducer, options);
	    };
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(911);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1261);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1724);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderStats.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderStats.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1774);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketCallerCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketCallerCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2350);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(506)(module)))

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(2351);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (component.isMounted()) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)([mixin], set);
	module.exports = exports['default'];

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	/*!
	 * The MIT License
	 *
	 * Copyright (c) 2012 James Allardice
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to
	 * deal in the Software without restriction, including without limitation the
	 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	 * sell copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
	 * IN THE SOFTWARE.
	 */
	
	( function ( global ) {
	
	  'use strict';
	
	  //
	  // Test for support. We do this as early as possible to optimise for browsers
	  // that have native support for the attribute.
	  //
	
	  var test = document.createElement('input');
	  var nativeSupport = test.placeholder !== void 0;
	
	  global.Placeholders = {
	    nativeSupport: nativeSupport,
	    disable: nativeSupport ? noop : disablePlaceholders,
	    enable: nativeSupport ? noop : enablePlaceholders
	  };
	
	  if ( nativeSupport ) {
	    return;
	  }
	
	  //
	  // If we reach this point then the browser does not have native support for
	  // the attribute.
	  //
	
	  // The list of input element types that support the placeholder attribute.
	  var validTypes = [
	    'text',
	    'search',
	    'url',
	    'tel',
	    'email',
	    'password',
	    'number',
	    'textarea'
	  ];
	
	  // The list of keycodes that are not allowed when the polyfill is configured
	  // to hide-on-input.
	  var badKeys = [
	
	    // The following keys all cause the caret to jump to the end of the input
	    // value.
	
	    27, // Escape
	    33, // Page up
	    34, // Page down
	    35, // End
	    36, // Home
	
	    // Arrow keys allow you to move the caret manually, which should be
	    // prevented when the placeholder is visible.
	
	    37, // Left
	    38, // Up
	    39, // Right
	    40, // Down
	
	    // The following keys allow you to modify the placeholder text by removing
	    // characters, which should be prevented when the placeholder is visible.
	
	    8, // Backspace
	    46 // Delete
	  ];
	
	  // Styling variables.
	  var placeholderStyleColor = '#ccc';
	  var placeholderClassName = 'placeholdersjs';
	  var classNameRegExp = new RegExp('(?:^|\\s)' + placeholderClassName + '(?!\\S)');
	
	  // The various data-* attributes used by the polyfill.
	  var ATTR_CURRENT_VAL = 'data-placeholder-value';
	  var ATTR_ACTIVE = 'data-placeholder-active';
	  var ATTR_INPUT_TYPE = 'data-placeholder-type';
	  var ATTR_FORM_HANDLED = 'data-placeholder-submit';
	  var ATTR_EVENTS_BOUND = 'data-placeholder-bound';
	  var ATTR_OPTION_FOCUS = 'data-placeholder-focus';
	  var ATTR_OPTION_LIVE = 'data-placeholder-live';
	  var ATTR_MAXLENGTH = 'data-placeholder-maxlength';
	
	  // Various other variables used throughout the rest of the script.
	  var UPDATE_INTERVAL = 100;
	  var head = document.getElementsByTagName('head')[ 0 ];
	  var root = document.documentElement;
	  var Placeholders = global.Placeholders;
	  var keydownVal;
	
	  // Get references to all the input and textarea elements currently in the DOM
	  // (live NodeList objects to we only need to do this once).
	  var inputs = document.getElementsByTagName('input');
	  var textareas = document.getElementsByTagName('textarea');
	
	  // Get any settings declared as data-* attributes on the root element.
	  // Currently the only options are whether to hide the placeholder on focus
	  // or input and whether to auto-update.
	  var hideOnInput = root.getAttribute(ATTR_OPTION_FOCUS) === 'false';
	  var liveUpdates = root.getAttribute(ATTR_OPTION_LIVE) !== 'false';
	
	  // Create style element for placeholder styles (instead of directly setting
	  // style properties on elements - allows for better flexibility alongside
	  // user-defined styles).
	  var styleElem = document.createElement('style');
	  styleElem.type = 'text/css';
	
	  // Create style rules as text node.
	  var styleRules = document.createTextNode(
	    '.' + placeholderClassName + ' {' +
	      'color:' + placeholderStyleColor + ';' +
	    '}'
	  );
	
	  // Append style rules to newly created stylesheet.
	  if ( styleElem.styleSheet ) {
	    styleElem.styleSheet.cssText = styleRules.nodeValue;
	  } else {
	    styleElem.appendChild(styleRules);
	  }
	
	  // Prepend new style element to the head (before any existing stylesheets,
	  // so user-defined rules take precedence).
	  head.insertBefore(styleElem, head.firstChild);
	
	  // Set up the placeholders.
	  var placeholder;
	  var elem;
	
	  for ( var i = 0, len = inputs.length + textareas.length; i < len; i++ ) {
	
	    // Find the next element. If we've already done all the inputs we move on
	    // to the textareas.
	    elem = i < inputs.length ? inputs[ i ] : textareas[ i - inputs.length ];
	
	    // Get the value of the placeholder attribute, if any. IE10 emulating IE7
	    // fails with getAttribute, hence the use of the attributes node.
	    placeholder = elem.attributes.placeholder;
	
	    // If the element has a placeholder attribute we need to modify it.
	    if ( placeholder ) {
	
	      // IE returns an empty object instead of undefined if the attribute is
	      // not present.
	      placeholder = placeholder.nodeValue;
	
	      // Only apply the polyfill if this element is of a type that supports
	      // placeholders and has a placeholder attribute with a non-empty value.
	      if ( placeholder && inArray(validTypes, elem.type) ) {
	        newElement(elem);
	      }
	    }
	  }
	
	  // If enabled, the polyfill will repeatedly check for changed/added elements
	  // and apply to those as well.
	  var timer = setInterval(function () {
	    for ( var i = 0, len = inputs.length + textareas.length; i < len; i++ ) {
	      elem = i < inputs.length ? inputs[ i ] : textareas[ i - inputs.length ];
	
	      // Only apply the polyfill if this element is of a type that supports
	      // placeholders, and has a placeholder attribute with a non-empty value.
	      placeholder = elem.attributes.placeholder;
	
	      if ( placeholder ) {
	
	        placeholder = placeholder.nodeValue;
	
	        if ( placeholder && inArray(validTypes, elem.type) ) {
	
	          // If the element hasn't had event handlers bound to it then add
	          // them.
	          if ( !elem.getAttribute(ATTR_EVENTS_BOUND) ) {
	            newElement(elem);
	          }
	
	          // If the placeholder value has changed or not been initialised yet
	          // we need to update the display.
	          if (
	            placeholder !== elem.getAttribute(ATTR_CURRENT_VAL) ||
	            ( elem.type === 'password' && !elem.getAttribute(ATTR_INPUT_TYPE) )
	          ) {
	
	            // Attempt to change the type of password inputs (fails in IE < 9).
	            if (
	              elem.type === 'password' &&
	              !elem.getAttribute(ATTR_INPUT_TYPE) &&
	              changeType(elem, 'text')
	            ) {
	              elem.setAttribute(ATTR_INPUT_TYPE, 'password');
	            }
	
	            // If the placeholder value has changed and the placeholder is
	            // currently on display we need to change it.
	            if ( elem.value === elem.getAttribute(ATTR_CURRENT_VAL) ) {
	              elem.value = placeholder;
	            }
	
	            // Keep a reference to the current placeholder value in case it
	            // changes via another script.
	            elem.setAttribute(ATTR_CURRENT_VAL, placeholder);
	          }
	        }
	      } else if ( elem.getAttribute(ATTR_ACTIVE) ) {
	        hidePlaceholder(elem);
	        elem.removeAttribute(ATTR_CURRENT_VAL);
	      }
	    }
	
	    // If live updates are not enabled cancel the timer.
	    if ( !liveUpdates ) {
	      clearInterval(timer);
	    }
	  }, UPDATE_INTERVAL);
	
	  // Disabling placeholders before unloading the page prevents flash of
	  // unstyled placeholders on load if the page was refreshed.
	  addEventListener(global, 'beforeunload', function () {
	    Placeholders.disable();
	  });
	
	  //
	  // Utility functions
	  //
	
	  // No-op (used in place of public methods when native support is detected).
	  function noop() {}
	
	  // Avoid IE9 activeElement of death when an iframe is used.
	  //
	  // More info:
	  //  - http://bugs.jquery.com/ticket/13393
	  //  - https://github.com/jquery/jquery/commit/85fc5878b3c6af73f42d61eedf73013e7faae408
	  function safeActiveElement() {
	    try {
	      return document.activeElement;
	    } catch ( err ) {}
	  }
	
	  // Check whether an item is in an array. We don't use Array.prototype.indexOf
	  // so we don't clobber any existing polyfills. This is a really simple
	  // alternative.
	  function inArray( arr, item ) {
	    for ( var i = 0, len = arr.length; i < len; i++ ) {
	      if ( arr[ i ] === item ) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  // Cross-browser DOM event binding
	  function addEventListener( elem, event, fn ) {
	    if ( elem.addEventListener ) {
	      return elem.addEventListener(event, fn, false);
	    }
	    if ( elem.attachEvent ) {
	      return elem.attachEvent('on' + event, fn);
	    }
	  }
	
	  // Move the caret to the index position specified. Assumes that the element
	  // has focus.
	  function moveCaret( elem, index ) {
	    var range;
	    if ( elem.createTextRange ) {
	      range = elem.createTextRange();
	      range.move('character', index);
	      range.select();
	    } else if ( elem.selectionStart ) {
	      elem.focus();
	      elem.setSelectionRange(index, index);
	    }
	  }
	
	  // Attempt to change the type property of an input element.
	  function changeType( elem, type ) {
	    try {
	      elem.type = type;
	      return true;
	    } catch ( e ) {
	      // You can't change input type in IE8 and below.
	      return false;
	    }
	  }
	
	  function handleElem( node, callback ) {
	
	    // Check if the passed in node is an input/textarea (in which case it can't
	    // have any affected descendants).
	    if ( node && node.getAttribute(ATTR_CURRENT_VAL) ) {
	      callback(node);
	    } else {
	
	      // If an element was passed in, get all affected descendants. Otherwise,
	      // get all affected elements in document.
	      var handleInputs = node ? node.getElementsByTagName('input') : inputs;
	      var handleTextareas = node ? node.getElementsByTagName('textarea') : textareas;
	
	      var handleInputsLength = handleInputs ? handleInputs.length : 0;
	      var handleTextareasLength = handleTextareas ? handleTextareas.length : 0;
	
	      // Run the callback for each element.
	      var len = handleInputsLength + handleTextareasLength;
	      var elem;
	      for ( var i = 0; i < len; i++ ) {
	
	        elem = i < handleInputsLength ?
	          handleInputs[ i ] :
	          handleTextareas[ i - handleInputsLength ];
	
	        callback(elem);
	      }
	    }
	  }
	
	  // Return all affected elements to their normal state (remove placeholder
	  // value if present).
	  function disablePlaceholders( node ) {
	    handleElem(node, hidePlaceholder);
	  }
	
	  // Show the placeholder value on all appropriate elements.
	  function enablePlaceholders( node ) {
	    handleElem(node, showPlaceholder);
	  }
	
	  // Hide the placeholder value on a single element. Returns true if the
	  // placeholder was hidden and false if it was not (because it wasn't visible
	  // in the first place).
	  function hidePlaceholder( elem, keydownValue ) {
	
	    var valueChanged = !!keydownValue && elem.value !== keydownValue;
	    var isPlaceholderValue = elem.value === elem.getAttribute(ATTR_CURRENT_VAL);
	
	    if (
	      ( valueChanged || isPlaceholderValue ) &&
	      elem.getAttribute(ATTR_ACTIVE) === 'true'
	    ) {
	
	      elem.removeAttribute(ATTR_ACTIVE);
	      elem.value = elem.value.replace(elem.getAttribute(ATTR_CURRENT_VAL), '');
	      elem.className = elem.className.replace(classNameRegExp, '');
	
	      // Restore the maxlength value. Old FF returns -1 if attribute not set.
	      // See GH-56.
	      var maxLength = elem.getAttribute(ATTR_MAXLENGTH);
	      if ( parseInt(maxLength, 10) >= 0 ) {
	        elem.setAttribute('maxLength', maxLength);
	        elem.removeAttribute(ATTR_MAXLENGTH);
	      }
	
	      // If the polyfill has changed the type of the element we need to change
	      // it back.
	      var type = elem.getAttribute(ATTR_INPUT_TYPE);
	      if ( type ) {
	        elem.type = type;
	      }
	
	      return true;
	    }
	
	    return false;
	  }
	
	  // Show the placeholder value on a single element. Returns true if the
	  // placeholder was shown and false if it was not (because it was already
	  // visible).
	  function showPlaceholder( elem ) {
	
	    var val = elem.getAttribute(ATTR_CURRENT_VAL);
	
	    if ( elem.value === '' && val ) {
	
	      elem.setAttribute(ATTR_ACTIVE, 'true');
	      elem.value = val;
	      elem.className += ' ' + placeholderClassName;
	
	      // Store and remove the maxlength value.
	      var maxLength = elem.getAttribute(ATTR_MAXLENGTH);
	      if ( !maxLength ) {
	        elem.setAttribute(ATTR_MAXLENGTH, elem.maxLength);
	        elem.removeAttribute('maxLength');
	      }
	
	      // If the type of element needs to change, change it (e.g. password
	      // inputs).
	      var type = elem.getAttribute(ATTR_INPUT_TYPE);
	      if ( type ) {
	        elem.type = 'text';
	      } else if ( elem.type === 'password' && changeType(elem, 'text') ) {
	        elem.setAttribute(ATTR_INPUT_TYPE, 'password');
	      }
	
	      return true;
	    }
	
	    return false;
	  }
	
	  // Returns a function that is used as a focus event handler.
	  function makeFocusHandler( elem ) {
	    return function () {
	
	      // Only hide the placeholder value if the (default) hide-on-focus
	      // behaviour is enabled.
	      if (
	        hideOnInput &&
	        elem.value === elem.getAttribute(ATTR_CURRENT_VAL) &&
	        elem.getAttribute(ATTR_ACTIVE) === 'true'
	      ) {
	
	        // Move the caret to the start of the input (this mimics the behaviour
	        // of all browsers that do not hide the placeholder on focus).
	        moveCaret(elem, 0);
	      } else {
	
	        // Remove the placeholder.
	        hidePlaceholder(elem);
	      }
	    };
	  }
	
	  // Returns a function that is used as a blur event handler.
	  function makeBlurHandler( elem ) {
	    return function () {
	      showPlaceholder(elem);
	    };
	  }
	
	  // Returns a function that is used as a submit event handler on form elements
	  // that have children affected by this polyfill.
	  function makeSubmitHandler( form ) {
	    return function () {
	
	        // Turn off placeholders on all appropriate descendant elements.
	        disablePlaceholders(form);
	    };
	  }
	
	  // Functions that are used as a event handlers when the hide-on-input
	  // behaviour has been activated - very basic implementation of the 'input'
	  // event.
	  function makeKeydownHandler( elem ) {
	    return function ( e ) {
	      keydownVal = elem.value;
	
	      // Prevent the use of the arrow keys (try to keep the cursor before the
	      // placeholder).
	      if (
	        elem.getAttribute(ATTR_ACTIVE) === 'true' &&
	        keydownVal === elem.getAttribute(ATTR_CURRENT_VAL) &&
	        inArray(badKeys, e.keyCode)
	      ) {
	        if ( e.preventDefault ) {
	            e.preventDefault();
	        }
	        return false;
	      }
	    };
	  }
	
	  function makeKeyupHandler(elem) {
	    return function () {
	      hidePlaceholder(elem, keydownVal);
	
	      // If the element is now empty we need to show the placeholder
	      if ( elem.value === '' ) {
	        elem.blur();
	        moveCaret(elem, 0);
	      }
	    };
	  }
	
	  function makeClickHandler(elem) {
	    return function () {
	      if (
	        elem === safeActiveElement() &&
	        elem.value === elem.getAttribute(ATTR_CURRENT_VAL) &&
	        elem.getAttribute(ATTR_ACTIVE) === 'true'
	      ) {
	        moveCaret(elem, 0);
	      }
	    };
	  }
	
	  // Bind event handlers to an element that we need to affect with the
	  // polyfill.
	  function newElement( elem ) {
	
	    // If the element is part of a form, make sure the placeholder string is
	    // not submitted as a value.
	    var form = elem.form;
	    if ( form && typeof form === 'string' ) {
	
	      // Get the real form.
	      form = document.getElementById(form);
	
	      // Set a flag on the form so we know it's been handled (forms can contain
	      // multiple inputs).
	      if ( !form.getAttribute(ATTR_FORM_HANDLED) ) {
	        addEventListener(form, 'submit', makeSubmitHandler(form));
	        form.setAttribute(ATTR_FORM_HANDLED, 'true');
	      }
	    }
	
	    // Bind event handlers to the element so we can hide/show the placeholder
	    // as appropriate.
	    addEventListener(elem, 'focus', makeFocusHandler(elem));
	    addEventListener(elem, 'blur', makeBlurHandler(elem));
	
	    // If the placeholder should hide on input rather than on focus we need
	    // additional event handlers
	    if (hideOnInput) {
	      addEventListener(elem, 'keydown', makeKeydownHandler(elem));
	      addEventListener(elem, 'keyup', makeKeyupHandler(elem));
	      addEventListener(elem, 'click', makeClickHandler(elem));
	    }
	
	    // Remember that we've bound event handlers to this element.
	    elem.setAttribute(ATTR_EVENTS_BOUND, 'true');
	    elem.setAttribute(ATTR_CURRENT_VAL, placeholder);
	
	    // If the element doesn't have a value and is not focussed, set it to the
	    // placeholder string.
	    if ( hideOnInput || elem !== safeActiveElement() ) {
	      showPlaceholder(elem);
	    }
	  }
	
	}(this) );


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(1266);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DocumentDashboardPanel = __webpack_require__(2158);
	
	var _DocumentDashboardPanel2 = _interopRequireDefault(_DocumentDashboardPanel);
	
	var _logoActradis = __webpack_require__(1825);
	
	var _logoActradis2 = _interopRequireDefault(_logoActradis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DocumentDashboardPanel = function (_Component) {
	    _inherits(DocumentDashboardPanel, _Component);
	
	    function DocumentDashboardPanel(props) {
	        _classCallCheck(this, DocumentDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (DocumentDashboardPanel.__proto__ || Object.getPrototypeOf(DocumentDashboardPanel)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(DocumentDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var provider = this.props.provider;
	
	
	            var documents = provider && provider.documents || [];
	            var undeclaredWorkDocuments = documents.filter(function (d) {
	                return d.documentCategory == 'UndeclaredWorkDocument';
	            });
	            var insuranceDocuments = documents.filter(function (d) {
	                return d.documentCategory == 'InsuranceDocument';
	            });
	            var specificDocuments = documents.filter(function (d) {
	                return d.documentCategory == 'SpecificDocument';
	            });
	            var otherDocuments = documents.filter(function (d) {
	                return d.documentCategory == 'OtherDocument';
	            });
	
	            this.setState({ undeclaredWorkDocuments: undeclaredWorkDocuments, insuranceDocuments: insuranceDocuments, specificDocuments: specificDocuments, otherDocuments: otherDocuments });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.provider != this.props.provider) {
	                var provider = nextProps.provider;
	
	
	                var documents = provider && provider.documents || [];
	                var undeclaredWorkDocuments = documents.filter(function (d) {
	                    return d.documentCategory == 'UndeclaredWorkDocument';
	                });
	                var insuranceDocuments = documents.filter(function (d) {
	                    return d.documentCategory == 'InsuranceDocument';
	                });
	                var specificDocuments = documents.filter(function (d) {
	                    return d.documentCategory == 'SpecificDocument';
	                });
	                var otherDocuments = documents.filter(function (d) {
	                    return d.documentCategory == 'OtherDocument';
	                });
	
	                this.setState({ undeclaredWorkDocuments: undeclaredWorkDocuments, insuranceDocuments: insuranceDocuments, specificDocuments: specificDocuments, otherDocuments: otherDocuments });
	            }
	        }
	    }, {
	        key: '_openDocumentWindow',
	        value: function _openDocumentWindow(event, document) {
	            event.preventDefault();
	            window.open(document.urlForDownload, '_blank');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                provider = _props.provider,
	                others = _objectWithoutProperties(_props, ['dispatch', 'provider']);
	
	            var _state = this.state,
	                undeclaredWorkDocuments = _state.undeclaredWorkDocuments,
	                insuranceDocuments = _state.insuranceDocuments,
	                specificDocuments = _state.specificDocuments,
	                otherDocuments = _state.otherDocuments;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            var replaceValidityDates = function replaceValidityDates(value, document) {
	                return (0, _extract.replace)(value, {
	                    startDate: (0, _moment2.default)(document.startValidityDate).format(_i18n2.default.dateFormat.default),
	                    endDate: (0, _moment2.default)(document.endValidityDate).format(_i18n2.default.dateFormat.default)
	                });
	            };
	
	            var documentItem = function documentItem(document, index) {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        className: _DocumentDashboardPanel2.default[(0, _extract.sanitize)(document.state)],
	                        key: index },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._openDocumentWindow(e, document);
	                            } },
	                        document.state == 'OK' && _react2.default.createElement(_Icon2.default, { icon: 'check', size: 'xs' }),
	                        document.state != 'OK' && _react2.default.createElement(
	                            'b',
	                            null,
	                            '!'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            document.label
	                        )
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader(_i18n2.default.documents),
	                    status: 'success'
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _DocumentDashboardPanel2.default.defaultContent },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DocumentDashboardPanel2.default.documentGroup },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(_Icon2.default, { icon: 'undeclaredWork', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.undeclaredWorkDocuments
	                            )
	                        ),
	                        undeclaredWorkDocuments.length == 0 && _react2.default.createElement(
	                            'small',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '>'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.emptyDocuments
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            undeclaredWorkDocuments.map(documentItem)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DocumentDashboardPanel2.default.documentGroup },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(_Icon2.default, { icon: 'insurance', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.insuranceDocuments
	                            )
	                        ),
	                        insuranceDocuments.length == 0 && _react2.default.createElement(
	                            'small',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '>'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.emptyDocuments
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            insuranceDocuments.map(documentItem)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DocumentDashboardPanel2.default.documentGroup },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(_Icon2.default, { icon: 'star', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.specificDocuments
	                            )
	                        ),
	                        specificDocuments.length == 0 && _react2.default.createElement(
	                            'small',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '>'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.emptyDocuments
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            specificDocuments.map(documentItem)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DocumentDashboardPanel2.default.documentGroup },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _react2.default.createElement(_Icon2.default, { icon: 'star', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.otherDocuments
	                            )
	                        ),
	                        otherDocuments.length == 0 && _react2.default.createElement(
	                            'small',
	                            null,
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                '>'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.emptyDocuments
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            otherDocuments.map(documentItem)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DocumentDashboardPanel2.default.logo },
	                        _react2.default.createElement('img', { src: _logoActradis2.default })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DocumentDashboardPanel;
	}(_react.Component);
	
	DocumentDashboardPanel.propTypes = {};
	
	
	DocumentDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        provider: state.actradis.provider.provider
	    };
	})(DocumentDashboardPanel);
	
	exports.default = DocumentDashboardPanel;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18n = __webpack_require__(80);
	
	var translations = exports.translations = {
	    fr: {
	        documents: 'documents',
	        emptyDocuments: 'aucun document disponible',
	        undeclaredWorkDocuments: 'travail dissimulé',
	        insuranceDocuments: 'assurances',
	        specificDocuments: 'spécifique Actradis',
	        otherDocuments: 'autres documents',
	        validityDates: 'valide du {startDate} au {endDate}'
	    }
	};
	
	exports.default = _extends({}, _i18n.translations.fr, translations.fr);

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(1084);
	
	var provider = function () {
	
	    function provider() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.PROVIDER_LOADED:
	                return action.provider;
	            case _actions.PROVIDER_RESET:
	                return null;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ provider: provider });
	}();
	
	exports.default = (0, _redux.combineReducers)({
	    provider: provider
	});

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEHYDRATE_KEYS = undefined;
	
	var _intercom = __webpack_require__(1094);
	
	var _intercom2 = _interopRequireDefault(_intercom);
	
	var _ui = __webpack_require__(512);
	
	var _actors = __webpack_require__(1496);
	
	var _actors2 = _interopRequireDefault(_actors);
	
	var _actors3 = __webpack_require__(1305);
	
	var _actors4 = _interopRequireDefault(_actors3);
	
	var _actors5 = __webpack_require__(1406);
	
	var _actors6 = _interopRequireDefault(_actors5);
	
	var _actors7 = __webpack_require__(1371);
	
	var _actors8 = _interopRequireDefault(_actors7);
	
	var _actors9 = __webpack_require__(1535);
	
	var _actors10 = _interopRequireDefault(_actors9);
	
	var _actors11 = __webpack_require__(1552);
	
	var _actors12 = _interopRequireDefault(_actors11);
	
	var _actors13 = __webpack_require__(1463);
	
	var _actors14 = _interopRequireDefault(_actors13);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DEHYDRATE_KEYS = exports.DEHYDRATE_KEYS = [_ui.DEHYDRATE_KEY, _actors.DEHYDRATE_KEY];
	
	function subDomainAuthenticatedUpdated() {
	    var authenticated;
	
	    return function (state, dispatch) {
	        var nextAuthenticated = state.user.authenticated;
	
	        if (nextAuthenticated != authenticated) {
	            var domainChunks = window.location.host.split('.');
	
	            if (domainChunks.length == 3) {
	                var locationSubDomain = domainChunks[0];
	                var userSubDomain = nextAuthenticated && nextAuthenticated.frontUriPrefix;
	
	                if (userSubDomain && userSubDomain != locationSubDomain) {
	                    // redirect to user subdomain
	                    var nextLocationHref = window.location.href.replace('//' + locationSubDomain + '.', '//' + userSubDomain + '.');
	                    window.location.href = nextLocationHref;
	                }
	            }
	            authenticated = nextAuthenticated;
	        }
	    };
	}
	
	function intercomAuthenticatedUpdated() {
	    var authenticated;
	
	    return function (state, dispatch) {
	        var nextAuthenticated = state.user.authenticated;
	
	        if (nextAuthenticated != authenticated) {
	            if (nextAuthenticated) {
	                (0, _intercom2.default)('boot', {
	                    app_id: _config2.default.intercom.appId,
	                    user_id: nextAuthenticated.uid,
	                    email: nextAuthenticated.login,
	                    name: [nextAuthenticated.firstName, nextAuthenticated.lastName].join(' '),
	                    company: nextAuthenticated.company && {
	                        id: nextAuthenticated.company.uid,
	                        name: nextAuthenticated.company.label
	                    }
	                });
	            } else {
	                (0, _intercom2.default)('shutdown');
	            }
	            authenticated = nextAuthenticated;
	        }
	    };
	}
	
	function intercomLocationUpdated() {
	    var location;
	    var timer;
	
	    return function (state, dispatch) {
	        var nextLocation = state.router.location;
	
	        if (nextLocation != location) {
	            if (nextLocation.pathname != (location && location.pathname)) {
	                clearTimeout(timer);
	                timer = setTimeout(function () {
	                    // wait for redirects
	                    (0, _intercom2.default)('update');
	                }, 500);
	            }
	            location = nextLocation;
	        }
	    };
	}
	
	function autoloadVersionUpdated() {
	    var version;
	    var location;
	    var triggerAutoReload = false;
	
	    return function (state, dispatch) {
	        var nextVersion = state.app.version;
	        var nextLocation = state.router.location;
	
	        if (nextVersion != version) {
	            if (version) {
	                triggerAutoReload = true;
	            }
	            version = nextVersion;
	        }
	
	        if (nextLocation != location) {
	            if (triggerAutoReload) {
	                if (nextLocation.pathname != (location && location.pathname)) {
	                    // autoreload
	                    triggerAutoReload = false;
	                    window.location = nextLocation.pathname;
	                }
	            }
	            location = nextLocation;
	        }
	    };
	}
	
	exports.default = [subDomainAuthenticatedUpdated(), intercomAuthenticatedUpdated(), intercomLocationUpdated(), autoloadVersionUpdated()].concat(_toConsumableArray(_ui.uiActors), _toConsumableArray(_actors2.default), _toConsumableArray(_actors4.default), _toConsumableArray(_actors6.default), _toConsumableArray(_actors8.default), _toConsumableArray(_actors10.default), _toConsumableArray(_actors12.default), _toConsumableArray(_actors14.default));

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdditionalContextButton = function (_Component) {
	    _inherits(AdditionalContextButton, _Component);
	
	    function AdditionalContextButton() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AdditionalContextButton);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdditionalContextButton.__proto__ || Object.getPrototypeOf(AdditionalContextButton)).call.apply(_ref, [this].concat(args))), _this), _this.openFichePatrimoine = function () {
	            _this.contextWindow && _this.contextWindow.close();
	            _this.contextWindow = window.open('/static/fichePatrimoine.html', '', 'location=no');
	        }, _this.isAuthorized = function () {
	            var authenticated = _this.props.authenticated;
	
	            return ['callCenterOperator', 'callCenterUser'].indexOf(authenticated.userType) !== -1;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AdditionalContextButton, [{
	        key: 'componentWillReceiveProps',
	
	
	        /**
	         *
	         * @param event return by connect
	         *        contains context & event for display additional info
	         *        can be null but always authenticated: user.authenticated setted
	         */
	        value: function componentWillReceiveProps(event) {
	            var patrimonyUid = event.patrimonyUid,
	                context = event.context,
	                eventType = event.eventType;
	
	
	            if (this.props.patrimonyUid !== patrimonyUid && this.contextWindow) {
	                this.contextWindow.postMessage({ patrimonyUid: patrimonyUid, context: context, eventType: eventType });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.isAuthorized() && _react2.default.createElement(
	                'button',
	                { onClick: this.openFichePatrimoine },
	                'Fiche Contextuelle'
	            );
	        }
	    }]);
	
	    return AdditionalContextButton;
	}(_react.Component);
	
	var ticketShowedFromDetailedTicketCtx = function ticketShowedFromDetailedTicketCtx(ticket, router) {
	    var detailedTicket = ticket.ticket;
	
	    var _ref2 = router || {},
	        location = _ref2.location;
	
	    var _ref3 = location || {},
	        pathname = _ref3.pathname;
	
	    var isTicketDetail = detailedTicket && pathname === '/tickets/' + detailedTicket.uid;
	
	    return detailedTicket && isTicketDetail && detailedTicket.linkedEntities.patrimony && {
	        patrimonyUid: detailedTicket.linkedEntities.patrimony.uid,
	        context: 'DetailedTicket',
	        eventType: 'TicketShowed'
	    };
	};
	
	var patrimonySelectedFromOpenTicketCtx = function patrimonySelectedFromOpenTicketCtx(ticket, ui) {
	    var openTicketCmd = ticket.openTicketCmd;
	
	    var _ref4 = openTicketCmd || {},
	        locationRef = _ref4.locationRef;
	
	    var _ref5 = locationRef || {},
	        patrimonyUid = _ref5.patrimonyUid;
	
	    var _ref6 = patrimonyUid || {},
	        uid = _ref6.uid;
	
	    var hasModalOpened = ui && ui['Ticket/OpenTicketModal'] && ui['Ticket/OpenTicketModal'].opened;
	
	    return uid && hasModalOpened && {
	        patrimonyUid: uid,
	        context: 'OpenTicket',
	        eventType: 'PatrimonySelected'
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(function (_ref7) {
	    var ticket = _ref7.ticket,
	        user = _ref7.user,
	        ui = _ref7.ui,
	        router = _ref7.router;
	
	    var result = patrimonySelectedFromOpenTicketCtx(ticket, ui) || ticketShowedFromDetailedTicketCtx(ticket, router);
	
	    return _extends({}, result, { authenticated: user.authenticated });
	})(AdditionalContextButton);

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StatusAlert = __webpack_require__(1275);
	
	var _StatusAlert2 = _interopRequireDefault(_StatusAlert);
	
	var _AppFooter = __webpack_require__(1271);
	
	var _AppFooter2 = _interopRequireDefault(_AppFooter);
	
	var _App = __webpack_require__(2159);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function targetOrParentHasHref(node) {
	    if (!node || node === document.documentElement) {
	        return false;
	    }
	    if (node.hasAttribute('href') && node.nodeName.toLocaleLowerCase() === 'a') {
	        return node;
	    }
	    return targetOrParentHasHref(node.parentNode);
	}
	
	var App = function (_Component) {
	    _inherits(App, _Component);
	
	    function App() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, App);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.handleHyperlink = function (e) {
	            var dispatch = _this.props.dispatch;
	
	            var node = targetOrParentHasHref(e.target);
	            var href = node && node.getAttribute('href');
	            if (href && /^\/.+/.test(href) && !/^\/static/.test(href) && node.getAttribute('target') !== '_blank') {
	                e.preventDefault();
	                dispatch((0, _reactRouterRedux.push)(href));
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(App, [{
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	
	            return _react2.default.createElement(
	                'div',
	                { onClick: this.handleHyperlink },
	                _react2.default.createElement(_StatusAlert2.default, null),
	                children,
	                _react2.default.createElement(_AppFooter2.default, null)
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component);
	
	App.propTypes = {};
	exports.default = (0, _reactRedux.connect)()(App);

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _AppFooter = __webpack_require__(2160);
	
	var _AppFooter2 = _interopRequireDefault(_AppFooter);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppFooter = function (_Component) {
	    _inherits(AppFooter, _Component);
	
	    function AppFooter() {
	        _classCallCheck(this, AppFooter);
	
	        return _possibleConstructorReturn(this, (AppFooter.__proto__ || Object.getPrototypeOf(AppFooter)).apply(this, arguments));
	    }
	
	    _createClass(AppFooter, [{
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: _AppFooter2.default.default },
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _AppFooter2.default.side },
	                        _config2.default.whiteMark.cguLink && _react2.default.createElement(
	                            'a',
	                            { href: _config2.default.whiteMark.cguLink },
	                            'CGU'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _AppFooter2.default.container },
	                        _react2.default.createElement('img', { height: 40, src: _config2.default.whiteMark.bottomLogo })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppFooter;
	}(_react.Component);
	
	AppFooter.propTypes = {};
	exports.default = AppFooter;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _UserNavItem = __webpack_require__(1547);
	
	var _UserNavItem2 = _interopRequireDefault(_UserNavItem);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _logo = __webpack_require__(1826);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppNavBar = function (_Component) {
	    _inherits(AppNavBar, _Component);
	
	    function AppNavBar() {
	        _classCallCheck(this, AppNavBar);
	
	        return _possibleConstructorReturn(this, (AppNavBar.__proto__ || Object.getPrototypeOf(AppNavBar)).apply(this, arguments));
	    }
	
	    _createClass(AppNavBar, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                location = _props.location,
	                authenticated = _props.authenticated,
	                _links = _props._links;
	
	
	            return _react2.default.createElement(
	                _reactBootstrap.Navbar,
	                {
	                    bsStyle: 'jumbo',
	                    staticTop: true },
	                _react2.default.createElement(
	                    _reactBootstrap.Navbar.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Navbar.Brand,
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/' },
	                            _react2.default.createElement('img', { src: _config2.default.resource.logo && _config2.default.resource.logo.url || _logo2.default })
	                        )
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Navbar.Toggle, null)
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Navbar.Collapse,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { pullRight: true },
	                        _react2.default.createElement(_UserNavItem2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        null,
	                        _links.find((0, _links2.linkFinder)('tickets')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { active: location.pathname.startsWith('/tickets') || location.pathname.startsWith('/claims'), href: '/tickets' },
	                            _react2.default.createElement(_Icon2.default, { icon: 'ticket', size: 'lg' }),
	                            'tickets'
	                        ),
	                        _links.find((0, _links2.linkFinder)('patrimonies')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { active: location.pathname.startsWith('/patrimonies'), href: '/patrimonies' },
	                            _react2.default.createElement(_Icon2.default, { icon: 'patrimony', size: 'lg' }),
	                            'patrimoine'
	                        ),
	                        _links.find((0, _links2.linkFinder)('providercontacts')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { active: location.pathname.startsWith('/providers') || location.pathname.startsWith('/providercontacts'), href: '/providercontacts' },
	                            _react2.default.createElement(_Icon2.default, { icon: 'provider', size: 'lg' }),
	                            'fournisseurs'
	                        ),
	                        _links.find((0, _links2.linkFinder)('clientcompanies')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { active: location.pathname.startsWith('/companies'), href: '/companies' },
	                            _react2.default.createElement(_Icon2.default, { icon: 'customer', size: 'lg' }),
	                            'clients'
	                        ),
	                        authenticated.company && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { active: location.pathname.startsWith('/organisations'), href: '/organisations' },
	                            _react2.default.createElement(_Icon2.default, { icon: 'organisation', size: 'lg' }),
	                            'organisation'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppNavBar;
	}(_react.Component);
	
	AppNavBar.propTypes = {};
	
	
	AppNavBar = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        authenticated: state.user.authenticated,
	        _links: state.app._links
	    };
	})(AppNavBar);
	
	exports.default = AppNavBar;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewTicketButton = __webpack_require__(1508);
	
	var _NewTicketButton2 = _interopRequireDefault(_NewTicketButton);
	
	var _AppToolbar = __webpack_require__(2161);
	
	var _AppToolbar2 = _interopRequireDefault(_AppToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppToolbar = function (_Component) {
	    _inherits(AppToolbar, _Component);
	
	    function AppToolbar() {
	        _classCallCheck(this, AppToolbar);
	
	        return _possibleConstructorReturn(this, (AppToolbar.__proto__ || Object.getPrototypeOf(AppToolbar)).apply(this, arguments));
	    }
	
	    _createClass(AppToolbar, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: _AppToolbar2.default.default },
	                _react2.default.createElement(_NewTicketButton2.default, null)
	            );
	        }
	    }]);
	
	    return AppToolbar;
	}(_react.Component);
	
	AppToolbar.propTypes = {};
	exports.default = AppToolbar;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppNavBar = __webpack_require__(1272);
	
	var _AppNavBar2 = _interopRequireDefault(_AppNavBar);
	
	var _AppToolbar = __webpack_require__(1273);
	
	var _AppToolbar2 = _interopRequireDefault(_AppToolbar);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthLayout = function (_Component) {
	    _inherits(AuthLayout, _Component);
	
	    function AuthLayout() {
	        _classCallCheck(this, AuthLayout);
	
	        return _possibleConstructorReturn(this, (AuthLayout.__proto__ || Object.getPrototypeOf(AuthLayout)).apply(this, arguments));
	    }
	
	    _createClass(AuthLayout, [{
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { titleTemplate: _config2.default.whiteMark.titlePrefix + ' | %s' }),
	                _react2.default.createElement(_AppNavBar2.default, null),
	                _react2.default.createElement(_AppToolbar2.default, null),
	                children
	            );
	        }
	    }]);
	
	    return AuthLayout;
	}(_react.Component);
	
	AuthLayout.propTypes = {
	    children: _react.PropTypes.node
	};
	exports.default = AuthLayout;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1043);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _StatusAlert = __webpack_require__(2162);
	
	var _StatusAlert2 = _interopRequireDefault(_StatusAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatusAlert = function (_Component) {
	    _inherits(StatusAlert, _Component);
	
	    function StatusAlert() {
	        _classCallCheck(this, StatusAlert);
	
	        return _possibleConstructorReturn(this, (StatusAlert.__proto__ || Object.getPrototypeOf(StatusAlert)).apply(this, arguments));
	    }
	
	    _createClass(StatusAlert, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                status = _props.status,
	                spacer = _props.spacer;
	
	
	            var transitionName = {
	                enter: _StatusAlert2.default.enter,
	                enterActive: _StatusAlert2.default.enterActive,
	                leave: _StatusAlert2.default.leave,
	                leaveActive: _StatusAlert2.default.leaveActive
	            };
	
	            return _react2.default.createElement(
	                _reactAddonsCssTransitionGroup2.default,
	                {
	                    transitionName: transitionName,
	                    transitionEnterTimeout: 500,
	                    transitionLeaveTimeout: 500 },
	                status && _react2.default.createElement(
	                    'div',
	                    { className: _StatusAlert2.default.default },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _StatusAlert2.default.content },
	                        _react2.default.createElement(
	                            _reactBootstrap.Grid,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Alert,
	                                {
	                                    bsStyle: status.type,
	                                    onDismiss: function onDismiss() {
	                                        return dispatch((0, _status.discardStatus)());
	                                    } },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    status.message
	                                )
	                            )
	                        )
	                    ),
	                    spacer && _react2.default.createElement('div', { className: _StatusAlert2.default.spacer })
	                )
	            );
	        }
	    }]);
	
	    return StatusAlert;
	}(_react.Component);
	
	StatusAlert.propTypes = {
	    spacer: _react.PropTypes.bool
	};
	
	
	StatusAlert = (0, _reactRedux.connect)(function (state) {
	    return {
	        status: state.status
	    };
	})(StatusAlert);
	
	exports.default = StatusAlert;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthLayout = function (_Component) {
	    _inherits(AuthLayout, _Component);
	
	    function AuthLayout() {
	        _classCallCheck(this, AuthLayout);
	
	        return _possibleConstructorReturn(this, (AuthLayout.__proto__ || Object.getPrototypeOf(AuthLayout)).apply(this, arguments));
	    }
	
	    _createClass(AuthLayout, [{
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: _config2.default.whiteMark.titlePrefix }),
	                children
	            );
	        }
	    }]);
	
	    return AuthLayout;
	}(_react.Component);
	
	AuthLayout.propTypes = {
	    children: _react.PropTypes.node
	};
	exports.default = AuthLayout;

/***/ }),
/* 1277 */,
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.errorHandler = errorHandler;
	exports.unhandledRejectionHandler = unhandledRejectionHandler;
	
	exports.default = function (error, getState) {
	    var result;
	    if (result = (0, _errors2.default)(error, getState)) return result;
	    if (result = (0, _errors4.default)(error)) return result;
	    if (result = (0, _errors6.default)(error)) return result;
	    if (result = (0, _errors8.default)(error)) return result;
	    if (result = (0, _errors10.default)(error)) return result;
	    if (result = (0, _errors12.default)(error)) return result;
	    if (result = appErrors(error)) return result;
	    return (0, _extract.sanitize)(error.type);
	};
	
	var _intercom = __webpack_require__(1094);
	
	var _intercom2 = _interopRequireDefault(_intercom);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _errors = __webpack_require__(1458);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _errors3 = __webpack_require__(1565);
	
	var _errors4 = _interopRequireDefault(_errors3);
	
	var _errors5 = __webpack_require__(1472);
	
	var _errors6 = _interopRequireDefault(_errors5);
	
	var _errors7 = __webpack_require__(1368);
	
	var _errors8 = _interopRequireDefault(_errors7);
	
	var _errors9 = __webpack_require__(1302);
	
	var _errors10 = _interopRequireDefault(_errors9);
	
	var _errors11 = __webpack_require__(1491);
	
	var _errors12 = _interopRequireDefault(_errors11);
	
	var _i18n = __webpack_require__(1085);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEXT_COLOR = '#8a959a';
	var TEXT_COLOR_DARK = '#546D79';
	
	var BG_COLOR = '#F5F5F5';
	var BORDER_COLOR = '#DADADA';
	
	var I18N = {
	    fatalError: 'Erreur système',
	    fatalErrorText: ['L\'application rencontre des difficultés techniques.', 'Veuillez réessayer ou contacter le support si le problème persiste.'],
	    backToHome: 'Retour à l\'accueil'
	};
	
	function renderFatalErrorPage() {
	
	    var css = '' + '.fatalerror {' + '   position: fixed;' + '   top: 0;' + '   bottom: 0;' + '   left: 0;' + '   right: 0;' + '   z-index: 1100;' + '   background: ' + BG_COLOR + ';' + '}' + '.fatalerror-content {' + '   margin: 15px;' + '   padding: 20px;' + '   border: 1px solid ' + BORDER_COLOR + ';' + '   background: #FFFFFF;' + '   text-align: center;' + '   color: ' + TEXT_COLOR + ';' + '}' + '.fatalerror-content h1 {' + '   margin-bottom: 50px;' + '   text-transform: uppercase;' + '   color: ' + TEXT_COLOR_DARK + ';' + '}' + '@media (min-width: 768px) {' + '   .fatalerror-content {' + '       width: 50%;' + '       margin-top: 200px;' + '       margin-left: auto;' + '       margin-right: auto;' + '   }' + '}';
	
	    var html = '' + '<div class="fatalerror-content">' + '   <h1>' + I18N.fatalError + '</h1>' + I18N.fatalErrorText.map(function (text) {
	        return '       <p>' + text + '</p>';
	    }).join('') + '   <a href="/">' + I18N.backToHome + '</a>' + '</div>';
	
	    var cssElement = document.createElement('style');
	    cssElement.type = 'text/css';
	    if (cssElement.styleSheet) {
	        // IE10 and below
	        cssElement.styleSheet.cssText = css;
	    } else {
	        cssElement.innerText = css;
	    }
	    document.body.appendChild(cssElement);
	
	    var htmlElement = document.createElement('div');
	    htmlElement.className = 'fatalerror';
	    htmlElement.innerHTML = html;
	    document.body.appendChild(htmlElement);
	}
	
	function appErrors(error) {
	    return (0, _extract2.default)(_i18n2.default.errorTypeEnum, error.type, null);
	}
	
	function errorHandler(message, source, line, col, error) {
	    if (!error || !error.statusCode) {
	        // handle only unexpected errors
	        console && console.error(error || message);
	        renderFatalErrorPage();
	        (0, _intercom2.default)('trackEvent', 'app-crashed', {
	            error: error && error.name || message,
	            message: error && error.message,
	            stack: error && error.stack,
	            source: source,
	            line: line,
	            column: col,
	            useragent: window.navigator.userAgent
	        });
	    }
	}
	
	function unhandledRejectionHandler(event) {
	    var reason = event.reason;
	
	    if (!reason || !reason.statusCode) {
	        // handle only unexpected errors
	        console && console.error(reason);
	        renderFatalErrorPage();
	        (0, _intercom2.default)('trackEvent', 'app-crashed', {
	            error: reason && reason.name,
	            message: reason && reason.message,
	            stack: reason && reason.stack,
	            useragent: window.navigator.userAgent
	        });
	    }
	}

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
		return _extends({}, (0, _ui.hydrate)(), (0, _hydrate2.default)());
	};
	
	var _ui = __webpack_require__(512);
	
	var _hydrate = __webpack_require__(1121);
	
	var _hydrate2 = _interopRequireDefault(_hydrate);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.thunk = thunk;
	exports.promise = promise;
	exports.worker = worker;
	exports.errorStatus = errorStatus;
	exports.error = error;
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _status = __webpack_require__(13);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _actions = __webpack_require__(948);
	
	var _i18n = __webpack_require__(1085);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function thunk(store) {
	    return function (next) {
	        return function (action) {
	            if (typeof action == 'function') {
	                return next(action(store.getState(), store));
	            }
	            return next(action);
	        };
	    };
	}
	
	function promise() {
	    return function (next) {
	        return function (action) {
	            if (typeof action.then == 'function') {
	                return Promise.resolve(action).catch(function (error) {
	                    return Promise.reject(next({
	                        type: _actions.ACTION_FAILED,
	                        error: error
	                    }).error);
	                }).then(function (action) {
	                    return next(action);
	                });
	            }
	            return next(action);
	        };
	    };
	}
	
	function worker() {
	    return function (next) {
	
	        function messageEventListener(event) {
	            if (event.data.error) {
	                next({
	                    type: _actions.ACTION_FAILED,
	                    error: event.data.error
	                });
	            }
	        }
	
	        function errorEventListener(event) {
	            next({
	                type: _actions.ACTION_FAILED,
	                error: { message: event.message }
	            });
	        }
	
	        return function (action) {
	            if (typeof action.addEventListener == 'function') {
	                var _worker = action;
	
	                _worker.addEventListener('message', messageEventListener);
	                _worker.addEventListener('error', errorEventListener);
	
	                // break middleware chain
	                return _worker;
	            }
	            return next(action);
	        };
	    };
	}
	
	function errorStatus(errorTypeMessage) {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	
	        function statusType(error) {
	            if (error.statusCode == 401) return 'info';
	            if (error.statusCode >= 400) return 'danger';
	            if (error.statusCode >= 200) return 'info';
	            return 'danger';
	        }
	
	        function statusMessage(error) {
	            if (error.type) return errorTypeMessage(error, getState);
	            if (error.statusCode) return (0, _extract2.default)(_i18n2.default.errorStatusCodeEnum, error.statusCode);
	            return _i18n2.default.systemError;
	        }
	
	        return function (next) {
	            return function (action) {
	                if (action.type == _actions.ACTION_FAILED) {
	                    if (action.error && action.error.statusCode) {
	                        // functional error
	                        var _error = action.error;
	                        dispatch((0, _status.status)(statusType(_error), statusMessage(_error)));
	                    }
	                    return next(action);
	                }
	                if (action.type == _reactRouterRedux.LOCATION_CHANGE) {
	                    var state = getState();
	
	                    if (state.status && action.payload.action != 'REPLACE') {
	                        dispatch((0, _status.discardStatus)());
	                    }
	                    return next(action);
	                }
	                return next(action);
	            };
	        };
	    };
	}
	
	function error() {
	    return function (next) {
	        return function (action) {
	            if (action.type == _actions.ACTION_FAILED) {
	
	                if (action.error == 'TypeError: Network request failed') {
	                    // IE 10 bug. We get this error when server returns a 401
	                    // https://connect.microsoft.com/IE/feedback/details/785990/ie-10-on-win8-does-not-assign-the-correct-status-to-xmlhttprequest-when-the-result-is-401
	                    action.error = {
	                        statusCode: 401,
	                        name: 'UnauthorizedError'
	                    };
	                }
	
	                if (action.error && action.error.name == 'TypeMismatchError') {
	                    // IE Edge bug. We get this error when server returns a 401
	                    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8653298/
	                    action.error = {
	                        statusCode: 401,
	                        name: 'UnauthorizedError'
	                    };
	                }
	
	                if (action.error == 'TypeError: Failed to fetch') {
	                    // most likely a timeout occured
	                    action.error = {
	                        statusCode: 500,
	                        name: 'ServerError'
	                    };
	                }
	
	                if (action.error && action.error.statusCode) {
	                    // functional error
	                    console && console.warn(action.error.name + ': ' + action.error.message);
	                }
	
	                return next(action);
	            }
	
	            return next(action);
	        };
	    };
	}

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAMESPACE = 'App';
	
	// socket
	var SUBSCRIBE_VERSION = exports.SUBSCRIBE_VERSION = NAMESPACE + '/SubscribeVersion';
	var VERSION_UPDATED = exports.VERSION_UPDATED = NAMESPACE + '/VersionUpdated';

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(148);
	
	var _router = __webpack_require__(123);
	
	var _loading = __webpack_require__(58);
	
	var _progress = __webpack_require__(965);
	
	var _ui = __webpack_require__(512);
	
	var _status = __webpack_require__(13);
	
	var _reducers = __webpack_require__(1404);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reducers3 = __webpack_require__(1533);
	
	var _reducers4 = _interopRequireDefault(_reducers3);
	
	var _reducers5 = __webpack_require__(1303);
	
	var _reducers6 = _interopRequireDefault(_reducers5);
	
	var _reducers7 = __webpack_require__(1346);
	
	var _reducers8 = _interopRequireDefault(_reducers7);
	
	var _reducers9 = __webpack_require__(1549);
	
	var _reducers10 = _interopRequireDefault(_reducers9);
	
	var _reducers11 = __webpack_require__(1459);
	
	var _reducers12 = _interopRequireDefault(_reducers11);
	
	var _reducers13 = __webpack_require__(1566);
	
	var _reducers14 = _interopRequireDefault(_reducers13);
	
	var _reducers15 = __webpack_require__(1369);
	
	var _reducers16 = _interopRequireDefault(_reducers15);
	
	var _reducers17 = __webpack_require__(1473);
	
	var _reducers18 = _interopRequireDefault(_reducers17);
	
	var _reducers19 = __webpack_require__(1492);
	
	var _reducers20 = _interopRequireDefault(_reducers19);
	
	var _reducers21 = __webpack_require__(1288);
	
	var _reducers22 = _interopRequireDefault(_reducers21);
	
	var _reducers23 = __webpack_require__(1267);
	
	var _reducers24 = _interopRequireDefault(_reducers23);
	
	var _actions = __webpack_require__(948);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _links() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.LINKS_LOADED:
	            return action._links;
	        default:
	            return state;
	    }
	}
	
	function version() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.VERSION_LOADED:
	            return action.version;
	        default:
	            return state;
	    }
	}
	
	exports.default = (0, _redux.combineReducers)({
	    app: (0, _redux.combineReducers)({
	        _links: _links,
	        version: version
	    }),
	    router: _router.routeReducer,
	    loading: _loading.loadingReducer,
	    progress: _progress.progressReducer,
	    ui: _ui.uiReducer,
	    status: _status.statusReducer,
	    patrimony: _reducers2.default,
	    ticket: _reducers4.default,
	    claim: _reducers6.default,
	    company: _reducers8.default,
	    user: _reducers10.default,
	    provider: _reducers12.default,
	    workflow: _reducers14.default,
	    message: _reducers16.default,
	    reference: _reducers18.default,
	    satisfaction: _reducers20.default,
	    audit: _reducers22.default,
	    actradis: _reducers24.default
	});

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = function (dispatcher, store) {
	    return [{
	        path: '/',
	        component: _App2.default,
	        indexRoute: {
	            onEnter: dispatcher(enterRoot)
	        },
	        childRoutes: [{
	            component: _AuthLayout2.default,
	            onEnter: dispatcher(enterAuth),
	            childRoutes: [(0, _routes2.default)('/patrimonies', dispatcher, store), (0, _routes.patrimonyContactRoute)('/patrimonycontacts', dispatcher, store), (0, _routes4.default)('/tickets', dispatcher, store), (0, _routes6.default)('/claims', dispatcher, store), (0, _routes8.default)('/companies', dispatcher, store), (0, _routes7.organisationRoute)('/organisations', dispatcher, store), (0, _routes11.default)('/providers', dispatcher, store), (0, _routes10.providerCoverageRoute)('/providercoverage', dispatcher, store), (0, _routes10.providerContactRoute)('/providercontacts', dispatcher, store), (0, _routes10.providerDirectoryRoute)('/providerdirectory', dispatcher, store), (0, _routes9.accountRoute)('/account', dispatcher, store), (0, _routes12.todoRoute)('/todolist', dispatcher, store), (0, _routes3.openTicketRoute)('/openticket', dispatcher, store), (0, _routes14.default)(dispatcher, store)]
	        }, {
	            component: _UnauthLayout2.default,
	            onEnter: dispatcher(enterUnauth),
	            childRoutes: [(0, _routes9.loginRoute)('/login', dispatcher, store), (0, _routes9.activeUserRoute)('/aciveuseraccount', dispatcher, store), (0, _routes9.forgotPasswordRoute)('/forgotpassword', dispatcher, store), (0, _routes9.resetPasswordRoute)('/resetpassword', dispatcher, store), (0, _routes9.resetLoginRoute)('/resetlogin', dispatcher, store)]
	        }]
	    }, {
	        path: '*',
	        onEnter: (0, _router.redirect)('/')
	    }];
	};
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _router = __webpack_require__(268);
	
	var _links = __webpack_require__(33);
	
	var _browser = __webpack_require__(54);
	
	var _routes = __webpack_require__(1405);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _actions = __webpack_require__(74);
	
	var _routes3 = __webpack_require__(1534);
	
	var _routes4 = _interopRequireDefault(_routes3);
	
	var _actions2 = __webpack_require__(38);
	
	var _routes5 = __webpack_require__(1304);
	
	var _routes6 = _interopRequireDefault(_routes5);
	
	var _actions3 = __webpack_require__(191);
	
	var _routes7 = __webpack_require__(1347);
	
	var _routes8 = _interopRequireDefault(_routes7);
	
	var _actions4 = __webpack_require__(46);
	
	var _routes9 = __webpack_require__(1550);
	
	var _actions5 = __webpack_require__(153);
	
	var _routes10 = __webpack_require__(1460);
	
	var _routes11 = _interopRequireDefault(_routes10);
	
	var _actions6 = __webpack_require__(47);
	
	var _routes12 = __webpack_require__(1567);
	
	var _actions7 = __webpack_require__(948);
	
	var _App = __webpack_require__(1270);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _AuthLayout = __webpack_require__(1274);
	
	var _AuthLayout2 = _interopRequireDefault(_AuthLayout);
	
	var _UnauthLayout = __webpack_require__(1276);
	
	var _UnauthLayout2 = _interopRequireDefault(_UnauthLayout);
	
	var _routes13 = __webpack_require__(1495);
	
	var _routes14 = _interopRequireDefault(_routes13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enterRoot(dispatch) {
	    return dispatch((0, _actions5.loadAuthenticatedUser)()).then(function (authenticatedUserAction) {
	        var user = authenticatedUserAction.user;
	
	
	        if (user.userType == 'callCenterOperator' || user.userType == 'callCenterUser') {
	            return dispatch((0, _reactRouterRedux.replace)('/todolist'));
	        }
	        return dispatch((0, _reactRouterRedux.replace)('/tickets'));
	    });
	}
	
	function enterAuth(dispatch) {
	    return Promise.all([dispatch((0, _actions7.loadLinks)()), dispatch((0, _actions5.loadAuthenticatedUser)()), (0, _browser.supportWebSocket)() && dispatch((0, _actions7.subscribeVersion)())]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 1),
	            appLinksAction = _ref2[0];
	
	        var _appLinks = appLinksAction._links;
	
	        return Promise.all([_appLinks.find((0, _links.linkFinder)('tickets')) && dispatch((0, _actions2.loadLinks)()), _appLinks.find((0, _links.linkFinder)('ticketclaims')) && dispatch((0, _actions3.loadLinks)()), _appLinks.find((0, _links.linkFinder)('clientcompanies')) && dispatch((0, _actions4.loadLinks)()), _appLinks.find((0, _links.linkFinder)('patrimonies')) && dispatch((0, _actions.loadLinks)()), _appLinks.find((0, _links.linkFinder)('providercompanies')) && dispatch((0, _actions6.loadProviderLinks)()), _appLinks.find((0, _links.linkFinder)('providercontacts')) && dispatch((0, _actions6.loadContactLinks)()), _appLinks.find((0, _links.linkFinder)('patrimonycontacts')) && dispatch((0, _actions.loadContactLinks)())]);
	    });
	}
	
	function enterUnauth(dispatch) {
	    return Promise.all([dispatch((0, _actions7.loadLinks)()), (0, _browser.supportWebSocket)() && dispatch((0, _actions7.subscribeVersion)())]).then(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 1),
	            appLinksAction = _ref4[0];
	
	        var _appLinks = appLinksAction._links;
	
	        return Promise.all([_appLinks.find((0, _links.linkFinder)('tickets')) && dispatch((0, _actions2.loadLinks)()), _appLinks.find((0, _links.linkFinder)('ticketclaims')) && dispatch((0, _actions3.loadLinks)()), _appLinks.find((0, _links.linkFinder)('clientcompanies')) && dispatch((0, _actions4.loadLinks)()), _appLinks.find((0, _links.linkFinder)('patrimonies')) && dispatch((0, _actions.loadLinks)()), _appLinks.find((0, _links.linkFinder)('providercompanies')) && dispatch((0, _actions6.loadProviderLinks)()), _appLinks.find((0, _links.linkFinder)('providercontacts')) && dispatch((0, _actions6.loadContactLinks)()), _appLinks.find((0, _links.linkFinder)('patrimonycontacts')) && dispatch((0, _actions.loadContactLinks)())]);
	    });
	}

/***/ }),
/* 1284 */,
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(1087);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReportCard = __webpack_require__(2163);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportCard = function (_Component) {
	    _inherits(ReportCard, _Component);
	
	    function ReportCard() {
	        _classCallCheck(this, ReportCard);
	
	        return _possibleConstructorReturn(this, (ReportCard.__proto__ || Object.getPrototypeOf(ReportCard)).apply(this, arguments));
	    }
	
	    _createClass(ReportCard, [{
	        key: '_openPdfWindow',
	        value: function _openPdfWindow(event) {
	            var report = this.props.report;
	
	
	            event.stopPropagation();
	            event.preventDefault();
	            window.open(_config2.default.audit.url + '/api/audits/' + report.uid + '.pdf');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                report = _props.report,
	                others = _objectWithoutProperties(_props, ['report']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                'audit ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    (0, _moment2.default)(report.updated).format(_i18n2.default.dateFormat.default)
	                )
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ReportCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true,
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'no-gutter' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ReportCard2.default.score },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.score,
	                                    ' : ',
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        report.score * 100,
	                                        ' %'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ReportCard2.default.pdf },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        onClick: function onClick(e) {
	                                            return _this2._openPdfWindow(e);
	                                        } },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'pdf', size: 'sm' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReportCard;
	}(_react.Component);
	
	ReportCard.propTypes = {
	    report: _react.PropTypes.object.isRequired
	};
	exports.default = ReportCard;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _ReportCard = __webpack_require__(1285);
	
	var _ReportCard2 = _interopRequireDefault(_ReportCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function reportFilter(audit) {
	    return function (report) {
	        return report.parentAudit.uid == audit.uid;
	    };
	}
	
	function auditAggregator(result, report) {
	    var audit = result.find(function (a) {
	        return a.uid == report.parentAudit.uid;
	    });
	
	    if (!audit) {
	        result.push(report.parentAudit);
	    }
	    return result;
	}
	
	function scoreSumAggregator(result, audit) {
	    return result + audit.score;
	}
	
	function aggregate(reports) {
	    var audits = reports.reduce(auditAggregator, []);
	    var aggregations = audits.map(function (audit) {
	        var auditReports = reports.filter(reportFilter(audit));
	        var auditScore = Math.round(auditReports.reduce(scoreSumAggregator, 0) / auditReports.length * 100) / 100;
	
	        return {
	            audit: audit,
	            reports: auditReports,
	            score: auditScore
	        };
	    });
	
	    return aggregations;
	}
	
	var ReportStream = function (_Component) {
	    _inherits(ReportStream, _Component);
	
	    function ReportStream(props) {
	        _classCallCheck(this, ReportStream);
	
	        var _this = _possibleConstructorReturn(this, (ReportStream.__proto__ || Object.getPrototypeOf(ReportStream)).call(this, props));
	
	        _this.state = {
	            aggregations: []
	        };
	        return _this;
	    }
	
	    _createClass(ReportStream, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var stream = this.props.stream;
	
	
	            var aggregations = aggregate(stream);
	            this.setState({ aggregations: aggregations });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.stream != this.props.stream) {
	                var stream = nextProps.stream;
	
	
	                var aggregations = aggregate(stream);
	                this.setState({ aggregations: aggregations });
	            }
	        }
	    }, {
	        key: '_openReportWindow',
	        value: function _openReportWindow(event, report) {
	            event.preventDefault();
	            window.open(_config2.default.audit.url + '/audits/' + report.uid + '/report');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var aggregations = this.state.aggregations;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                aggregations.map(function (aggrega, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: index },
	                        _react2.default.createElement(
	                            _reactBootstrap.PageHeader,
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'Audit ',
	                                aggrega.audit.name
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' (',
	                                aggrega.reports.length,
	                                ')'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' - ',
	                                aggrega.score * 100,
	                                ' %'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            aggrega.reports.map(function (report) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    {
	                                        key: report.uid,
	                                        sm: 4 },
	                                    _react2.default.createElement(_ReportCard2.default, {
	                                        report: report,
	                                        onClick: function onClick(e) {
	                                            return _this2._openReportWindow(e, report);
	                                        } })
	                                );
	                            })
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return ReportStream;
	}(_react.Component);
	
	ReportStream.propTypes = {};
	
	
	ReportStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.audit.report.stream
	    };
	})(ReportStream);
	
	exports.default = ReportStream;

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Audit = exports.Audit = function Audit() {
		_classCallCheck(this, Audit);
	};
	
	Audit.yearlyAuditCount = function (audits) {
		var nowYear = new Date().getFullYear();
	
		return audits.filter(function (audit) {
			var year = new Date(audit.created).getFullYear();
			return year == nowYear;
		}).length;
	};

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(1086);
	
	var report = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.REPORT_STREAM_LOADED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function stats() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.REPORT_STREAM_LOADED:
	                return action.stats;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ stream: stream, stats: stats });
	}();
	
	exports.default = (0, _redux.combineReducers)({ report: report });

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(191);
	
	var _models = __webpack_require__(507);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnswerChallengeTicketClaimForm = function (_Component) {
	    _inherits(AnswerChallengeTicketClaimForm, _Component);
	
	    function AnswerChallengeTicketClaimForm() {
	        _classCallCheck(this, AnswerChallengeTicketClaimForm);
	
	        return _possibleConstructorReturn(this, (AnswerChallengeTicketClaimForm.__proto__ || Object.getPrototypeOf(AnswerChallengeTicketClaimForm)).apply(this, arguments));
	    }
	
	    _createClass(AnswerChallengeTicketClaimForm, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendAnswerChallengeTicketClaimCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicketClaim)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'textarea',
	                        rows: 4,
	                        placeholder: _i18n2.default.answerChallengeTicketClaim + ' *'
	                    }, (0, _form.controlledField)(form.comment())))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AnswerChallengeTicketClaimForm;
	}(_react.Component);
	
	AnswerChallengeTicketClaimForm.propTypes = {};
	
	
	AnswerChallengeTicketClaimForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.AnswerChallengeTicketClaimCmd.schema,
	    action: _actions.ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED
	})(AnswerChallengeTicketClaimForm);
	
	AnswerChallengeTicketClaimForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.claim.answerChallengeTicketClaimCmd
	    };
	})(AnswerChallengeTicketClaimForm);
	
	exports.default = AnswerChallengeTicketClaimForm;

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _form = __webpack_require__(15);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _RadioToggle = __webpack_require__(544);
	
	var _RadioToggle2 = _interopRequireDefault(_RadioToggle);
	
	var _CheckboxToggle = __webpack_require__(508);
	
	var _CheckboxToggle2 = _interopRequireDefault(_CheckboxToggle);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(191);
	
	var _models = __webpack_require__(507);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AnswerTicketClaimCard = __webpack_require__(2165);
	
	var _AnswerTicketClaimCard2 = _interopRequireDefault(_AnswerTicketClaimCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnswerTicketClaimCard = function (_Component) {
	    _inherits(AnswerTicketClaimCard, _Component);
	
	    function AnswerTicketClaimCard() {
	        _classCallCheck(this, AnswerTicketClaimCard);
	
	        return _possibleConstructorReturn(this, (AnswerTicketClaimCard.__proto__ || Object.getPrototypeOf(AnswerTicketClaimCard)).apply(this, arguments));
	    }
	
	    _createClass(AnswerTicketClaimCard, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendAnswerTicketClaimCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicketClaim)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd,
	                reference = _props.reference,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'cmd', 'reference']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.answerTicketClaim
	            );
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _AnswerTicketClaimCard2.default.defaultContent },
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                type: 'select'
	                            }, (0, _form.selectField)(form.postAnalysisUid())),
	                            _react2.default.createElement(
	                                'option',
	                                { value: '' },
	                                _i18n2.default.postAnalysis,
	                                ' ...'
	                            ),
	                            reference.postAnalysis.map(function (postAnalysis) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    {
	                                        key: postAnalysis.uid,
	                                        value: postAnalysis.uid },
	                                    postAnalysis.label
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                type: 'select'
	                            }, (0, _form.selectField)(form.failureCauseUid())),
	                            _react2.default.createElement(
	                                'option',
	                                { value: '' },
	                                _i18n2.default.failureCause,
	                                ' ...'
	                            ),
	                            reference.failureCause.map(function (failureCause) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    {
	                                        key: failureCause.uid,
	                                        value: failureCause.uid },
	                                    failureCause.label
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    _i18n2.default.assignedEntity
	                                ),
	                                _react2.default.createElement(
	                                    _CheckboxToggle2.default,
	                                    form.assignedEntities(),
	                                    _models.ASSIGNED_ENTITIES.map(function (assignedEntity) {
	                                        return _react2.default.createElement(_reactBootstrap.Input, {
	                                            key: assignedEntity,
	                                            type: 'checkbox',
	                                            label: (0, _extract2.default)(_i18n2.default.entityEnum, assignedEntity),
	                                            value: assignedEntity });
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    _i18n2.default.accountableEntity
	                                ),
	                                _react2.default.createElement(
	                                    _CheckboxToggle2.default,
	                                    form.accountableEntities(),
	                                    _models.ACCOUNTABLE_ENTITIES.map(function (accountableEntity) {
	                                        return _react2.default.createElement(_reactBootstrap.Input, {
	                                            key: accountableEntity,
	                                            type: 'checkbox',
	                                            label: (0, _extract2.default)(_i18n2.default.entityEnum, accountableEntity),
	                                            value: accountableEntity });
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    _i18n2.default.severity
	                                ),
	                                _react2.default.createElement(
	                                    _RadioToggle2.default,
	                                    form.severityUid(),
	                                    reference.severity.map(function (severity) {
	                                        return _react2.default.createElement(_reactBootstrap.Input, {
	                                            key: severity.uid,
	                                            type: 'radio',
	                                            label: severity.label,
	                                            value: severity.uid });
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'textarea',
	                            rows: 4,
	                            placeholder: _i18n2.default.comment + ' *'
	                        }, (0, _form.controlledField)(form.comment())))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AnswerTicketClaimCard;
	}(_react.Component);
	
	AnswerTicketClaimCard.propTypes = {};
	
	
	AnswerTicketClaimCard = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.AnswerTicketClaimCmd.schema,
	    action: _actions.ANSWER_TICKET_CLAIM_CMD_UPDATED
	})(AnswerTicketClaimCard);
	
	AnswerTicketClaimCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.claim.answerTicketClaimCmd,
	        reference: state.reference.ticketClaimRef
	    };
	})(AnswerTicketClaimCard);
	
	exports.default = AnswerTicketClaimCard;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(191);
	
	var _models = __webpack_require__(507);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChallengeTicketClaimForm = function (_Component) {
	    _inherits(ChallengeTicketClaimForm, _Component);
	
	    function ChallengeTicketClaimForm() {
	        _classCallCheck(this, ChallengeTicketClaimForm);
	
	        return _possibleConstructorReturn(this, (ChallengeTicketClaimForm.__proto__ || Object.getPrototypeOf(ChallengeTicketClaimForm)).apply(this, arguments));
	    }
	
	    _createClass(ChallengeTicketClaimForm, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendChallengeTicketClaimCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicketClaim)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'textarea',
	                        rows: 4,
	                        placeholder: _i18n2.default.challengeTicketClaim + ' *'
	                    }, (0, _form.controlledField)(form.comment())))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ChallengeTicketClaimForm;
	}(_react.Component);
	
	ChallengeTicketClaimForm.propTypes = {};
	
	
	ChallengeTicketClaimForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ChallengeTicketClaimCmd.schema,
	    action: _actions.CHALLENGE_TICKET_CLAIM_CMD_UPDATED
	})(ChallengeTicketClaimForm);
	
	ChallengeTicketClaimForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.claim.challengeTicketClaimCmd
	    };
	})(ChallengeTicketClaimForm);
	
	exports.default = ChallengeTicketClaimForm;

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(191);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openCmdUpdate(ticket) {
	    return {
	        ticketUid: ticket.uid,
	        ticketReference: undefined,
	        commandType: 'OpenTicketClaim'
	    };
	}
	
	var NewTicketClaimCard = function (_Component) {
	    _inherits(NewTicketClaimCard, _Component);
	
	    function NewTicketClaimCard() {
	        _classCallCheck(this, NewTicketClaimCard);
	
	        return _possibleConstructorReturn(this, (NewTicketClaimCard.__proto__ || Object.getPrototypeOf(NewTicketClaimCard)).apply(this, arguments));
	    }
	
	    _createClass(NewTicketClaimCard, [{
	        key: '_navigate',
	        value: function _navigate() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket;
	
	
	            var update = openCmdUpdate(ticket);
	            dispatch((0, _actions.updateOpenTicketClaimCmd)(update));
	
	            return dispatch((0, _reactRouterRedux.push)('/claims/new'));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                ticket = _props2.ticket,
	                _links = _props2._links,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'ticket', '_links']);
	
	            var header = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.ticketClaim
	            );
	
	            return !!_links.find((0, _links2.linkFinder)(['OpenTicketClaim', 'OpenTicketClaimOnExternalTicket'])) && _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header,
	                    status: 'danger'
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'danger',
	                            bsSize: 'large',
	                            onClick: function onClick() {
	                                return _this2._navigate();
	                            } },
	                        _i18n2.default.newTicketClaim
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NewTicketClaimCard;
	}(_react.Component);
	
	NewTicketClaimCard.propTypes = {
	    ticket: _react.PropTypes.object.isRequired
	};
	
	
	NewTicketClaimCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        _links: state.claim._links
	    };
	})(NewTicketClaimCard);
	
	exports.default = NewTicketClaimCard;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _delay = __webpack_require__(895);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	var _form = __webpack_require__(15);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _RadioToggle = __webpack_require__(544);
	
	var _RadioToggle2 = _interopRequireDefault(_RadioToggle);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _DayPicker = __webpack_require__(276);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _TimePicker = __webpack_require__(957);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _AgencySelectInput = __webpack_require__(888);
	
	var _AgencySelectInput2 = _interopRequireDefault(_AgencySelectInput);
	
	var _actions = __webpack_require__(191);
	
	var _models = __webpack_require__(507);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OpenTicketClaimCard = __webpack_require__(2166);
	
	var _OpenTicketClaimCard2 = _interopRequireDefault(_OpenTicketClaimCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenTicketClaimCard = function (_Component) {
	    _inherits(OpenTicketClaimCard, _Component);
	
	    function OpenTicketClaimCard() {
	        _classCallCheck(this, OpenTicketClaimCard);
	
	        return _possibleConstructorReturn(this, (OpenTicketClaimCard.__proto__ || Object.getPrototypeOf(OpenTicketClaimCard)).apply(this, arguments));
	    }
	
	    _createClass(OpenTicketClaimCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd;
	
	
	            var commandType = cmd && cmd.commandType || 'OpenTicketClaimOnExternalTicket';
	            dispatch((0, _actions.updateOpenTicketClaimCmd)({ commandType: commandType }));
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendOpenTicketClaimCmd)()).then(function (action) {
	                var ticketClaimId = action.events.find(function (e) {
	                    return e.eventType == 'TicketClaimOpened' || e.eventType == 'TicketClaimOpenedOnExternalTicket';
	                }).aggregateUid;
	                return dispatch((0, _reactRouterRedux.push)('/claims/' + ticketClaimId));
	            }).then(function () {
	                return dispatch((0, _delay2.default)((0, _actions.queryTicketClaimStream)()));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                reference = _props2.reference,
	                authenticated = _props2.authenticated,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'reference', 'authenticated']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.openTicketClaim
	            );
	
	            var urgencyLevelLabel = function urgencyLevelLabel(urgencyLevel) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        urgencyLevel.label
	                    ),
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        urgencyLevel.info
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _OpenTicketClaimCard2.default.defaultContent },
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        form.ticketReference && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'text',
	                            placeholder: _i18n2.default.ticketReference + ' *'
	                        }, form.ticketReference())),
	                        form.externalClientName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'text',
	                            placeholder: _i18n2.default.externalClientName
	                        }, form.externalClientName())),
	                        form.externalPatrimonyReference && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'text',
	                            placeholder: _i18n2.default.externalPatrimonyReference
	                        }, form.externalPatrimonyReference())),
	                        form.agencyUid && _react2.default.createElement(
	                            _AgencySelectInput2.default,
	                            _extends({
	                                user: authenticated,
	                                name: 'agency'
	                            }, (0, _form.selectField)(form.agencyUid())),
	                            _react2.default.createElement(
	                                'option',
	                                { value: '' },
	                                _i18n2.default.selectAgency,
	                                ' *'
	                            )
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'textarea',
	                            rows: 4,
	                            placeholder: _i18n2.default.description + ' *'
	                        }, (0, _form.controlledField)(form.description())))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            reference.urgencyLevel.length > 0 && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    _i18n2.default.urgencyLevel
	                                ),
	                                _react2.default.createElement(
	                                    _RadioToggle2.default,
	                                    form.urgencyLevelUid(),
	                                    reference.urgencyLevel.map(function (urgencyLevel) {
	                                        return _react2.default.createElement(_reactBootstrap.Input, {
	                                            key: urgencyLevel.uid,
	                                            type: 'radio',
	                                            label: urgencyLevelLabel(urgencyLevel),
	                                            value: urgencyLevel.uid });
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            form.externalCallDate && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    _i18n2.default.externalCallDate
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _OpenTicketClaimCard2.default.externaCallDateTimePicker },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _OpenTicketClaimCard2.default.container },
	                                        _react2.default.createElement(_DayPicker2.default, form.externalCallDate()),
	                                        _react2.default.createElement(_TimePicker2.default, _extends({ typing: true
	                                        }, form.externalCallDate()))
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketClaimCard;
	}(_react.Component);
	
	OpenTicketClaimCard.propTypes = {};
	
	
	OpenTicketClaimCard = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.OpenTicketClaimCmd.selectSchema,
	    action: _actions.OPEN_TICKET_CLAIM_CMD_UPDATED
	})(OpenTicketClaimCard);
	
	OpenTicketClaimCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.claim.openTicketClaimCmd,
	        reference: state.reference.ticketClaimRef,
	        authenticated: state.user.authenticated
	    };
	})(OpenTicketClaimCard);
	
	exports.default = OpenTicketClaimCard;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _RadioToggle = __webpack_require__(544);
	
	var _RadioToggle2 = _interopRequireDefault(_RadioToggle);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(191);
	
	var _models = __webpack_require__(507);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _QualifyTicketClaimCard = __webpack_require__(2167);
	
	var _QualifyTicketClaimCard2 = _interopRequireDefault(_QualifyTicketClaimCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QualifyTicketClaimCard = function (_Component) {
	    _inherits(QualifyTicketClaimCard, _Component);
	
	    function QualifyTicketClaimCard() {
	        _classCallCheck(this, QualifyTicketClaimCard);
	
	        return _possibleConstructorReturn(this, (QualifyTicketClaimCard.__proto__ || Object.getPrototypeOf(QualifyTicketClaimCard)).apply(this, arguments));
	    }
	
	    _createClass(QualifyTicketClaimCard, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendQualifyTicketClaimCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicketClaim)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd,
	                reference = _props.reference,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'cmd', 'reference']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.qualifyTicketClaim
	            );
	
	            var treatmentPriorityLabel = function treatmentPriorityLabel(treatmentPriority) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        treatmentPriority.label
	                    ),
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        treatmentPriority.info
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _QualifyTicketClaimCard2.default.defaultContent },
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                type: 'select'
	                            }, (0, _form.selectField)(form.ticketClaimCategoryUid())),
	                            _react2.default.createElement(
	                                'option',
	                                { value: '' },
	                                _i18n2.default.ticketClaimCategory,
	                                ' ...'
	                            ),
	                            reference.ticketClaimCategory.map(function (ticketClaimCategory) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    {
	                                        key: ticketClaimCategory.uid,
	                                        value: ticketClaimCategory.uid },
	                                    ticketClaimCategory.label
	                                );
	                            })
	                        ),
	                        reference.treatmentPriority.length > 0 && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.treatmentPriority
	                            ),
	                            _react2.default.createElement(
	                                _RadioToggle2.default,
	                                form.treatmentPriorityUid(),
	                                reference.treatmentPriority.map(function (treatmentPriority) {
	                                    return _react2.default.createElement(_reactBootstrap.Input, {
	                                        key: treatmentPriority.uid,
	                                        type: 'radio',
	                                        label: treatmentPriorityLabel(treatmentPriority),
	                                        value: treatmentPriority.uid });
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'textarea',
	                            rows: 4,
	                            placeholder: _i18n2.default.comment + ' *'
	                        }, (0, _form.controlledField)(form.comment())))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return QualifyTicketClaimCard;
	}(_react.Component);
	
	QualifyTicketClaimCard.propTypes = {};
	
	
	QualifyTicketClaimCard = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.QualifyTicketClaimCmd.schema,
	    action: _actions.QUALIFY_TICKET_CLAIM_CMD_UPDATED
	})(QualifyTicketClaimCard);
	
	QualifyTicketClaimCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.claim.qualifyTicketClaimCmd,
	        reference: state.reference.ticketClaimRef
	    };
	})(QualifyTicketClaimCard);
	
	exports.default = QualifyTicketClaimCard;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(507);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketClaimCard = __webpack_require__(2168);
	
	var _TicketClaimCard2 = _interopRequireDefault(_TicketClaimCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function levelToStatus(level) {
	    if (level == 0) return 'success';
	    if (level == 1) return 'warning';
	    if (level >= 2) return 'danger';
	    return 'success';
	}
	
	var TicketClaimCard = function (_Component) {
	    _inherits(TicketClaimCard, _Component);
	
	    function TicketClaimCard(props) {
	        _classCallCheck(this, TicketClaimCard);
	
	        var _this = _possibleConstructorReturn(this, (TicketClaimCard.__proto__ || Object.getPrototypeOf(TicketClaimCard)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(TicketClaimCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var ticketClaim = this.props.ticketClaim;
	
	
	            var priority = _models.TicketClaim.findPriority(ticketClaim);
	            this.setState({ priority: priority });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticketClaim != this.props.ticketClaim) {
	                var ticketClaim = nextProps.ticketClaim;
	
	
	                var priority = _models.TicketClaim.findPriority(ticketClaim);
	                this.setState({ priority: priority });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                ticketClaim = _props.ticketClaim,
	                others = _objectWithoutProperties(_props, ['ticketClaim']);
	
	            var priority = this.state.priority;
	
	
	            var status = levelToStatus(priority && priority.level);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.ticketClaim,
	                ' ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    'n\xB0 ',
	                    ticketClaim.ref || ticketClaim.uid
	                )
	            );
	
	            var help = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    (0, _moment2.default)(ticketClaim.openedAt).format(_i18n2.default.openedDateTimeFormat)
	                )
	            );
	
	            var addon = _react2.default.createElement(_Icon2.default, { icon: 'status-' + status, size: 'xs' });
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TicketClaimCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        kind: 'tab',
	                        status: status,
	                        header: header,
	                        addon: addon,
	                        help: help
	                    }, others),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'no-gutter' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketClaimCard2.default.ticket },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.ticket,
	                                    ' n\xB0 ',
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        ticketClaim.ticketReference.ref || ticketClaim.ticketReference.uid
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketClaimCard2.default.state },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.state,
	                                    ' : ',
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        (0, _extract2.default)(_i18n2.default.stateEnum, ticketClaim.state)
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'no-gutter' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketClaimCard2.default.actor },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    ticketClaim.openedBy && ticketClaim.openedBy.name
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            ticketClaim.urgencyLevel && _react2.default.createElement(
	                                'div',
	                                { className: _TicketClaimCard2.default.priority },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketClaimCard2.default.priorityContent },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _i18n2.default.urgencyLevel
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        ticketClaim.urgencyLevel.label
	                                    )
	                                )
	                            ),
	                            ticketClaim.ticketClaimQualification && ticketClaim.ticketClaimQualification.treatmentPriority && _react2.default.createElement(
	                                'div',
	                                { className: _TicketClaimCard2.default.priority },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketClaimCard2.default.priorityContent },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _i18n2.default.treatmentPriority
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        ticketClaim.ticketClaimQualification.treatmentPriority.label
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketClaimCard;
	}(_react.Component);
	
	TicketClaimCard.propTypes = {
	    ticketClaim: _react.PropTypes.object.isRequired
	};
	exports.default = TicketClaimCard;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _links = __webpack_require__(33);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(191);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketClaimCountCard = __webpack_require__(2169);
	
	var _TicketClaimCountCard2 = _interopRequireDefault(_TicketClaimCountCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketClaimCountCard = function (_Component) {
	    _inherits(TicketClaimCountCard, _Component);
	
	    function TicketClaimCountCard() {
	        _classCallCheck(this, TicketClaimCountCard);
	
	        return _possibleConstructorReturn(this, (TicketClaimCountCard.__proto__ || Object.getPrototypeOf(TicketClaimCountCard)).apply(this, arguments));
	    }
	
	    _createClass(TicketClaimCountCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _actions.queryTicketClaimStream)(_extends({}, _actions.DEFAULT_TICKET_CLAIM_QUERY, { range: { offset: 0, limit: 0 } })));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                range = _props.range,
	                _appLinks = _props._appLinks,
	                others = _objectWithoutProperties(_props, ['dispatch', 'range', '_appLinks']);
	
	            var header = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.ticketClaim
	            );
	
	            return !!_appLinks.find((0, _links.linkFinder)('ticketclaims')) && _react2.default.createElement(
	                'div',
	                { className: _TicketClaimCountCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    {
	                        status: 'danger',
	                        header: header,
	                        onClick: function onClick() {
	                            return dispatch((0, _reactRouterRedux.push)('/claims'));
	                        } },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        range && range.count,
	                        ' ',
	                        _i18n2.default.ticketClaims
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketClaimCountCard;
	}(_react.Component);
	
	TicketClaimCountCard.propTypes = {
	    ticket: _react.PropTypes.object.isRequired
	};
	
	
	TicketClaimCountCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        range: state.claim.range,
	        _appLinks: state.app._links
	    };
	})(TicketClaimCountCard);
	
	exports.default = TicketClaimCountCard;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _wizard = __webpack_require__(513);
	
	var _links = __webpack_require__(33);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Header = __webpack_require__(1090);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _CardGroup = __webpack_require__(952);
	
	var _CardGroup2 = _interopRequireDefault(_CardGroup);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Markdown = __webpack_require__(543);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _TicketClaimCallerCard = __webpack_require__(1521);
	
	var _TicketClaimCallerCard2 = _interopRequireDefault(_TicketClaimCallerCard);
	
	var _TicketAddressCard = __webpack_require__(1118);
	
	var _TicketAddressCard2 = _interopRequireDefault(_TicketAddressCard);
	
	var _TicketAssigneeCard = __webpack_require__(1119);
	
	var _TicketAssigneeCard2 = _interopRequireDefault(_TicketAssigneeCard);
	
	var _models = __webpack_require__(507);
	
	var _OpenTicketClaimCard = __webpack_require__(1293);
	
	var _OpenTicketClaimCard2 = _interopRequireDefault(_OpenTicketClaimCard);
	
	var _QualifyTicketClaimCard = __webpack_require__(1294);
	
	var _QualifyTicketClaimCard2 = _interopRequireDefault(_QualifyTicketClaimCard);
	
	var _AnswerTicketClaimCard = __webpack_require__(1290);
	
	var _AnswerTicketClaimCard2 = _interopRequireDefault(_AnswerTicketClaimCard);
	
	var _ChallengeTicketClaimForm = __webpack_require__(1291);
	
	var _ChallengeTicketClaimForm2 = _interopRequireDefault(_ChallengeTicketClaimForm);
	
	var _AnswerChallengeTicketClaimForm = __webpack_require__(1289);
	
	var _AnswerChallengeTicketClaimForm2 = _interopRequireDefault(_AnswerChallengeTicketClaimForm);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketClaimDetail = __webpack_require__(2170);
	
	var _TicketClaimDetail2 = _interopRequireDefault(_TicketClaimDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function selectActiveStep(steps, _ref) {
	    var ticketClaim = _ref.ticketClaim;
	
	    if (!ticketClaim.uid) return 1;
	
	    switch (ticketClaim.state) {
	        case 'Opened':
	            return 2;
	        case 'Qualified':
	            return 3;
	        case 'Answered':
	            return 4;
	        case 'Challenged':
	            return 5;
	        default:
	            return 6;
	    }
	}
	
	function findState(step) {
	    switch ((0, _wizard.major)(step)) {
	        case 2:
	            return 'Opened';
	        case 3:
	            return 'Qualified';
	        case 4:
	            return 'Answered';
	        case 5:
	            return 'Challenged';
	        case 6:
	            return 'ChallengeAnswered';
	    }
	}
	
	function levelToStatus(level) {
	    if (level == 0) return 'success';
	    if (level == 1) return 'warning';
	    if (level >= 2) return 'danger';
	    return 'success';
	}
	
	function entityToName(ticketClaim) {
	    return function (entity) {
	        switch (entity) {
	            case 'CallCenter':
	                return ticketClaim.callCenter.name;
	            case 'ClientAccount':
	                return ticketClaim.clientCompany.name;
	            default:
	                return (0, _extract2.default)(_i18n2.default.entityEnum, entity);
	        }
	    };
	}
	
	var TicketClaimDetail = function (_Component) {
	    _inherits(TicketClaimDetail, _Component);
	
	    function TicketClaimDetail(props) {
	        _classCallCheck(this, TicketClaimDetail);
	
	        var _this = _possibleConstructorReturn(this, (TicketClaimDetail.__proto__ || Object.getPrototypeOf(TicketClaimDetail)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(TicketClaimDetail, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var ticketClaim = this.props.ticketClaim;
	
	
	            var lastCallCenterActor = _models.TicketClaim.findLastCallCenterActor(ticketClaim);
	            var lastCallCenterAction = _models.TicketClaim.findLastCallCenterAction(ticketClaim);
	            var lastClientActor = _models.TicketClaim.findLastClientActor(ticketClaim);
	            var lastClientAction = _models.TicketClaim.findLastClientAction(ticketClaim);
	            var priority = _models.TicketClaim.findPriority(ticketClaim);
	            this.setState({ lastCallCenterActor: lastCallCenterActor, lastCallCenterAction: lastCallCenterAction, lastClientActor: lastClientActor, lastClientAction: lastClientAction, priority: priority });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticketClaim != this.props.ticketClaim) {
	                var ticketClaim = nextProps.ticketClaim;
	
	
	                var lastCallCenterActor = _models.TicketClaim.findLastCallCenterActor(ticketClaim);
	                var lastCallCenterAction = _models.TicketClaim.findLastCallCenterAction(ticketClaim);
	                var lastClientActor = _models.TicketClaim.findLastClientActor(ticketClaim);
	                var lastClientAction = _models.TicketClaim.findLastClientAction(ticketClaim);
	                var priority = _models.TicketClaim.findPriority(ticketClaim);
	                this.setState({ lastCallCenterActor: lastCallCenterActor, lastCallCenterAction: lastCallCenterAction, lastClientActor: lastClientActor, lastClientAction: lastClientAction, priority: priority });
	            }
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticketClaim = _props.ticketClaim,
	                ticket = _props.ticket,
	                authenticated = _props.authenticated,
	                wizard = _props.wizard;
	            var _state = this.state,
	                lastCallCenterActor = _state.lastCallCenterActor,
	                lastCallCenterAction = _state.lastCallCenterAction,
	                lastClientActor = _state.lastClientActor,
	                lastClientAction = _state.lastClientAction,
	                priority = _state.priority;
	
	
	            var status = levelToStatus(priority && priority.level);
	
	            var stepTooltip = function stepTooltip(step, active, disabled) {
	                var className = (0, _classnames2.default)({
	                    'tooltip-primary': !active && !disabled,
	                    'tooltip-danger': active,
	                    'tooltip-disabled': disabled
	                });
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: className },
	                    (0, _extract2.default)(_i18n2.default.stateEnum, findState(step))
	                );
	            };
	
	            var headerHelp = function headerHelp() {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        (0, _moment2.default)(ticketClaim.openedAt).format(_i18n2.default.openedDateTimeFormat),
	                        ' '
	                    )
	                );
	            };
	
	            var cardHeader = function cardHeader(title) {
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    title
	                );
	            };
	
	            var cardHeaderLarge = function cardHeaderLarge(title) {
	                return _react2.default.createElement(
	                    'h3',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TicketClaimDetail2.default.default },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        wizard.matchActiveStep(1) && _react2.default.createElement(
	                            _Header2.default,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _i18n2.default.newTicketClaim
	                            )
	                        ),
	                        wizard.matchActiveStep([2, 3, 4, 5, 6]) && _react2.default.createElement(
	                            _Header2.default,
	                            {
	                                status: status,
	                                help: headerHelp() },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _i18n2.default.ticketClaim,
	                                ' n\xB0 ',
	                                ticketClaim.ref || ticketClaim.uid
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Nav,
	                            { justified: true,
	                                bsStyle: 'progress',
	                                activeKey: wizard.majorActiveStep },
	                            [2, 3, 4, 5, 6].map(function (step, index) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.NavItem,
	                                    {
	                                        key: index,
	                                        eventKey: step,
	                                        disabled: step > wizard.activeStep },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: stepTooltip(step, wizard.matchActiveStep(step), step > wizard.activeStep) },
	                                        _react2.default.createElement(
	                                            'span',
	                                            {
	                                                className: _TicketClaimDetail2.default.step },
	                                            step - 1
	                                        )
	                                    )
	                                );
	                            })
	                        ),
	                        wizard.matchActiveStep([2, 3, 4, 5, 6]) && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketClaimDetail2.default.description },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.description,
	                                    ' :'
	                                ),
	                                _react2.default.createElement(_Markdown2.default, { markdown: ticketClaim.description })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _Card2.default,
	                                        {
	                                            kind: 'tab',
	                                            header: cardHeader((0, _extract2.default)(_i18n2.default.stateEnum, lastClientAction) + ' ' + _i18n2.default.by) },
	                                        _react2.default.createElement(
	                                            'h5',
	                                            null,
	                                            lastClientActor.name
	                                        ),
	                                        _react2.default.createElement(
	                                            'h5',
	                                            null,
	                                            _react2.default.createElement(
	                                                'small',
	                                                null,
	                                                ticketClaim.clientCompany.name
	                                            )
	                                        ),
	                                        ticketClaim.urgencyLevel && _react2.default.createElement(
	                                            'h5',
	                                            { className: (0, _classnames2.default)(_TicketClaimDetail2.default.urgencyLevel, _TicketClaimDetail2.default[status]) },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _i18n2.default.urgencyLevel
	                                            ),
	                                            _react2.default.createElement(
	                                                'strong',
	                                                null,
	                                                ' ',
	                                                ticketClaim.urgencyLevel.label
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _Card2.default,
	                                        {
	                                            kind: 'tab',
	                                            position: 'right',
	                                            header: cardHeader(((0, _extract2.default)(_i18n2.default.stateEnum, lastCallCenterAction, null) || _i18n2.default.processed) + ' ' + _i18n2.default.by) },
	                                        lastCallCenterActor && _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(
	                                                'h5',
	                                                null,
	                                                lastCallCenterActor.name
	                                            ),
	                                            _react2.default.createElement(
	                                                'h5',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'small',
	                                                    null,
	                                                    ticketClaim.callCenter.name
	                                                )
	                                            )
	                                        ),
	                                        !lastCallCenterActor && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.ticketClaimNotProcessed
	                                        )
	                                    )
	                                )
	                            ),
	                            ticketClaim.ticketClaimQualification && _react2.default.createElement(
	                                _Card2.default,
	                                {
	                                    header: cardHeader(_i18n2.default.qualification) },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(
	                                            'h5',
	                                            null,
	                                            _i18n2.default.category
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            ticketClaim.ticketClaimQualification.ticketClaimCategory.label
	                                        ),
	                                        _react2.default.createElement(
	                                            'h5',
	                                            null,
	                                            _i18n2.default.comment
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            _react2.default.createElement(_Markdown2.default, { markdown: ticketClaim.ticketClaimQualification.comment })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _TicketClaimDetail2.default.metricGroup },
	                                            ticketClaim.ticketClaimQualification.treatmentPriority && _react2.default.createElement(
	                                                'div',
	                                                { className: (0, _classnames2.default)(_TicketClaimDetail2.default.metric, _TicketClaimDetail2.default[levelToStatus(ticketClaim.ticketClaimQualification.treatmentPriority.level)]) },
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    _i18n2.default.treatmentPriority
	                                                ),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: _TicketClaimDetail2.default.data },
	                                                    ticketClaim.ticketClaimQualification.treatmentPriority.label
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            ticketClaim.ticketClaimAnswer && _react2.default.createElement(
	                                _CardGroup2.default,
	                                null,
	                                _react2.default.createElement(
	                                    _Card2.default,
	                                    {
	                                        header: cardHeader(_i18n2.default.postAnalysis) },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'h5',
	                                                null,
	                                                _i18n2.default.postAnalysis
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                ticketClaim.ticketClaimAnswer.postAnalysis.label
	                                            ),
	                                            _react2.default.createElement(
	                                                'h5',
	                                                null,
	                                                _i18n2.default.failureCause
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                ticketClaim.ticketClaimAnswer.failureCause.label
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _TicketClaimDetail2.default.metricGroup },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: (0, _classnames2.default)(_TicketClaimDetail2.default.metric, _TicketClaimDetail2.default[levelToStatus(ticketClaim.ticketClaimAnswer.severity.level)]) },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        _i18n2.default.severity
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: _TicketClaimDetail2.default.data },
	                                                        ticketClaim.ticketClaimAnswer.severity.label
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Row,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _TicketClaimDetail2.default.entity },
	                                                _react2.default.createElement(
	                                                    'h5',
	                                                    null,
	                                                    _i18n2.default.assignedEntity
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    ticketClaim.ticketClaimAnswer.assignedEntities.map(entityToName(ticketClaim)).join(', ')
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Col,
	                                            { sm: 6 },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _TicketClaimDetail2.default.entity },
	                                                _react2.default.createElement(
	                                                    'h5',
	                                                    null,
	                                                    _i18n2.default.accountableEntity
	                                                ),
	                                                _react2.default.createElement(
	                                                    'p',
	                                                    null,
	                                                    ticketClaim.ticketClaimAnswer.accountableEntities.map(entityToName(ticketClaim)).join(', ')
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _Card2.default,
	                                    {
	                                        header: cardHeader(_i18n2.default.ticketClaimAnswer) },
	                                    _react2.default.createElement(_Markdown2.default, { markdown: ticketClaim.ticketClaimAnswer.comment })
	                                )
	                            )
	                        ),
	                        wizard.matchActiveStep([4, 5, 6]) && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.PageHeader,
	                                null,
	                                _i18n2.default.challenge
	                            ),
	                            ticketClaim.ticketClaimChallenge && _react2.default.createElement(
	                                'div',
	                                { className: _TicketClaimDetail2.default.challengeGroup },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    ticketClaim.ticketClaimChallenge.challengedBy.name
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _TicketClaimDetail2.default.time },
	                                            _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                (0, _moment2.default)(ticketClaim.ticketClaimChallenge.challengedAt).format(_i18n2.default.dateTimeFormat.default)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _TicketClaimDetail2.default.container },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _react2.default.createElement(_Markdown2.default, { markdown: ticketClaim.ticketClaimChallenge.comment })
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            ticketClaim.ticketClaimChallengeAnswer && _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_TicketClaimDetail2.default.challengeGroup, _TicketClaimDetail2.default.answer) },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    ticketClaim.ticketClaimChallengeAnswer.answeredBy.name
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _TicketClaimDetail2.default.time },
	                                            _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                (0, _moment2.default)(ticketClaim.ticketClaimChallengeAnswer.answeredAt).format(_i18n2.default.dateTimeFormat.default)
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _TicketClaimDetail2.default.container },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _react2.default.createElement(_Markdown2.default, { markdown: ticketClaim.ticketClaimChallengeAnswer.comment })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        wizard.matchActiveStep(1) && _react2.default.createElement(_OpenTicketClaimCard2.default, null),
	                        wizard.matchActiveStep(2) && ticketClaim._links.find((0, _links.linkFinder)('QualifyTicketClaim')) && _react2.default.createElement(_QualifyTicketClaimCard2.default, null),
	                        wizard.matchActiveStep(3) && ticketClaim._links.find((0, _links.linkFinder)('AnswerTicketClaim')) && _react2.default.createElement(_AnswerTicketClaimCard2.default, null),
	                        wizard.matchActiveStep(4) && ticketClaim._links.find((0, _links.linkFinder)('ChallengeTicketClaim')) && _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_TicketClaimDetail2.default.challengeGroup, _TicketClaimDetail2.default.form) },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                '> ',
	                                authenticated.firstName,
	                                ' ',
	                                authenticated.lastName
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketClaimDetail2.default.time },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            (0, _moment2.default)().format(_i18n2.default.dateTimeFormat.default)
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketClaimDetail2.default.container },
	                                        _react2.default.createElement(_ChallengeTicketClaimForm2.default, null)
	                                    )
	                                )
	                            )
	                        ),
	                        wizard.matchActiveStep(5) && ticketClaim._links.find((0, _links.linkFinder)('AnswerChallengeTicketClaim')) && _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_TicketClaimDetail2.default.challengeGroup, _TicketClaimDetail2.default.form, _TicketClaimDetail2.default.answer) },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                '> ',
	                                authenticated.firstName,
	                                ' ',
	                                authenticated.lastName
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketClaimDetail2.default.time },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            (0, _moment2.default)().format(_i18n2.default.dateTimeFormat.default)
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _TicketClaimDetail2.default.container },
	                                        _react2.default.createElement(_AnswerChallengeTicketClaimForm2.default, null)
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _TicketClaimDetail2.default.ticketHeader },
	                            _react2.default.createElement(
	                                _Header2.default,
	                                null,
	                                ticketClaim.ticketReference.uid && ticketClaim.ticketReference.uid == (ticket && ticket.uid) && _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: function onClick(e) {
	                                                return _this2._navigate(e, '/tickets/' + ticket.uid);
	                                            } },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            'ticket n\xB0 ',
	                                            ticket.ref
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        ticketClaim.clientCompany && ticketClaim.agencies && _react2.default.createElement(
	                            _Card2.default,
	                            {
	                                header: cardHeaderLarge(ticketClaim.clientCompany.name) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketClaimDetail2.default.company },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticketClaim.agencies[0].name
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_TicketClaimCallerCard2.default, {
	                            header: cardHeaderLarge(_i18n2.default.callerIdentity),
	                            ticketIdLock: ticketClaim.ticketReference.uid || true }),
	                        _react2.default.createElement(_TicketAddressCard2.default, {
	                            header: cardHeaderLarge(_i18n2.default.interventionLocation),
	                            ticketIdLock: ticketClaim.ticketReference.uid || true }),
	                        _react2.default.createElement(_TicketAssigneeCard2.default, {
	                            header: cardHeaderLarge(_i18n2.default.interventionMonitoring),
	                            ticketIdLock: ticketClaim.ticketReference.uid || true })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketClaimDetail;
	}(_react.Component);
	
	TicketClaimDetail.propTypes = {};
	
	
	TicketClaimDetail = (0, _wizard.connectWizard)({
	    activeStep: selectActiveStep
	})(TicketClaimDetail);
	
	TicketClaimDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticketClaim: state.claim.ticketClaim,
	        ticket: state.ticket.ticket,
	        authenticated: state.user.authenticated
	    };
	})(TicketClaimDetail);
	
	exports.default = TicketClaimDetail;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(268);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketClaimSearchBar = __webpack_require__(1299);
	
	var _TicketClaimSearchBar2 = _interopRequireDefault(_TicketClaimSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketClaimLayout = function (_Component) {
	    _inherits(TicketClaimLayout, _Component);
	
	    function TicketClaimLayout() {
	        _classCallCheck(this, TicketClaimLayout);
	
	        return _possibleConstructorReturn(this, (TicketClaimLayout.__proto__ || Object.getPrototypeOf(TicketClaimLayout)).apply(this, arguments));
	    }
	
	    _createClass(TicketClaimLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                history = _props.history,
	                routes = _props.routes,
	                params = _props.params,
	                ticketClaim = _props.ticketClaim;
	
	
	            var breadcrumbDisplay = function breadcrumbDisplay(token) {
	                switch (token) {
	                    case ':id':
	                        return ticketClaim.ref || ticketClaim.uid;
	                    default:
	                        return (0, _extract2.default)(_i18n2.default, token);
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Claims' }),
	                _react2.default.createElement(_TicketClaimSearchBar2.default, null),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        _react2.default.createElement(_router.Breadcrumb, {
	                            history: history,
	                            routes: routes,
	                            params: params,
	                            display: breadcrumbDisplay }),
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketClaimLayout;
	}(_react.Component);
	
	TicketClaimLayout.propTypes = {};
	
	
	TicketClaimLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticketClaim: state.claim.ticketClaim
	    };
	})(TicketClaimLayout);
	
	exports.default = TicketClaimLayout;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browser = __webpack_require__(54);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _SearchBar = __webpack_require__(509);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketClaimSearchBar = function (_Component) {
	    _inherits(TicketClaimSearchBar, _Component);
	
	    function TicketClaimSearchBar() {
	        _classCallCheck(this, TicketClaimSearchBar);
	
	        return _possibleConstructorReturn(this, (TicketClaimSearchBar.__proto__ || Object.getPrototypeOf(TicketClaimSearchBar)).apply(this, arguments));
	    }
	
	    _createClass(TicketClaimSearchBar, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_SearchBar2.default, {
	                placeholder: (0, _extract2.default)(_i18n2.default.searchStream, (0, _browser.mediaQuery)()) });
	        }
	    }]);
	
	    return TicketClaimSearchBar;
	}(_react.Component);
	
	TicketClaimSearchBar.propTypes = {};
	exports.default = TicketClaimSearchBar;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _loading = __webpack_require__(58);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(191);
	
	var _TicketClaimCard = __webpack_require__(1295);
	
	var _TicketClaimCard2 = _interopRequireDefault(_TicketClaimCard);
	
	var _TicketClaimStream = __webpack_require__(2171);
	
	var _TicketClaimStream2 = _interopRequireDefault(_TicketClaimStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var TicketClaimStream = function (_Component) {
	    _inherits(TicketClaimStream, _Component);
	
	    function TicketClaimStream() {
	        _classCallCheck(this, TicketClaimStream);
	
	        return _possibleConstructorReturn(this, (TicketClaimStream.__proto__ || Object.getPrototypeOf(TicketClaimStream)).apply(this, arguments));
	    }
	
	    _createClass(TicketClaimStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadTicketClaimStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, ticketClaim) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/claims/' + ticketClaim.uid, '_blank');
	            } else {
	                dispatch((0, _reactRouterRedux.push)('/claims/' + ticketClaim.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                stream.map(function (ticketClaim) {
	                    return _react2.default.createElement(_TicketClaimCard2.default, {
	                        key: ticketClaim.uid,
	                        ticketClaim: ticketClaim,
	                        onClick: function onClick(e) {
	                            return _this2._navigate(e, ticketClaim);
	                        } });
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _TicketClaimStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, {
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        },
	                        prev: true, next: true, first: true, last: true, ellipsis: true })
	                )
	            );
	        }
	    }]);
	
	    return TicketClaimStream;
	}(_react.Component);
	
	TicketClaimStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	TicketClaimStream = (0, _loading.connectLoadingLock)()(TicketClaimStream);
	
	TicketClaimStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        stream: state.claim.stream,
	        range: state.claim.range
	    };
	})(TicketClaimStream);
	
	exports.default = TicketClaimStream;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _actions = __webpack_require__(191);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketClaimStream = __webpack_require__(1300);
	
	var _TicketClaimStream2 = _interopRequireDefault(_TicketClaimStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openCmdUpdate() {
	    return {
	        ticketUid: undefined,
	        commandType: 'OpenTicketClaimOnExternalTicket'
	    };
	}
	
	var TicketClaimStreamLayout = function (_Component) {
	    _inherits(TicketClaimStreamLayout, _Component);
	
	    function TicketClaimStreamLayout() {
	        _classCallCheck(this, TicketClaimStreamLayout);
	
	        return _possibleConstructorReturn(this, (TicketClaimStreamLayout.__proto__ || Object.getPrototypeOf(TicketClaimStreamLayout)).apply(this, arguments));
	    }
	
	    _createClass(TicketClaimStreamLayout, [{
	        key: '_navigate',
	        value: function _navigate() {
	            var dispatch = this.props.dispatch;
	
	
	            var update = openCmdUpdate();
	            dispatch((0, _actions.updateOpenTicketClaimCmd)(update));
	
	            return dispatch((0, _reactRouterRedux.push)('/claims/new'));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                _links = _props._links;
	
	
	            var newTicketClaimBoxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.newTicketClaim
	            );
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 4, smPush: 8 },
	                    _links.find((0, _links2.linkFinder)(['OpenTicketClaim', 'OpenTicketClaimOnExternalTicket'])) && _react2.default.createElement(_Box2.default, {
	                        status: 'danger',
	                        header: newTicketClaimBoxTitle,
	                        help: '+',
	                        onClick: function onClick() {
	                            return _this2._navigate();
	                        } })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 8, smPull: 4 },
	                    _react2.default.createElement(_TicketClaimStream2.default, null)
	                )
	            );
	        }
	    }]);
	
	    return TicketClaimStreamLayout;
	}(_react.Component);
	
	TicketClaimStreamLayout.propTypes = {};
	
	
	TicketClaimStreamLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        _links: state.claim._links
	    };
	})(TicketClaimStreamLayout);
	
	exports.default = TicketClaimStreamLayout;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (error) {
	    return (0, _extract2.default)(_i18n2.default.errorTypeEnum, error.type, null);
	};
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(152);
	
	var _i18n2 = _interopRequireDefault(_i18n);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(191);
	
	function ticketClaim() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_CLAIM_LOADED:
	            return action.ticketClaim;
	        case _actions.TICKET_CLAIM_CREATED:
	            return action.ticketClaim;
	        default:
	            return state;
	    }
	}
	
	function stream() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_CLAIM_STREAM_LOADED:
	        case _actions.TICKET_CLAIM_STREAM_QUERIED:
	            return action.stream;
	        default:
	            return state;
	    }
	}
	
	function range() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_CLAIM_STREAM_LOADED:
	        case _actions.TICKET_CLAIM_STREAM_QUERIED:
	            return action.range;
	        default:
	            return state;
	    }
	}
	
	function query() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_CLAIM_STREAM_LOADED:
	        case _actions.TICKET_CLAIM_STREAM_QUERIED:
	            return action.query;
	        default:
	            return state;
	    }
	}
	
	function _links() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_CLAIM_STREAM_LOADED:
	        case _actions.TICKET_CLAIM_STREAM_QUERIED:
	        case _actions.LINKS_LOADED:
	            return action._links;
	        default:
	            return state;
	    }
	}
	
	function openTicketClaimCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.OPEN_TICKET_CLAIM_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.OPEN_TICKET_CLAIM_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function qualifyTicketClaimCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.QUALIFY_TICKET_CLAIM_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.QUALIFY_TICKET_CLAIM_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function answerTicketClaimCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ANSWER_TICKET_CLAIM_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ANSWER_TICKET_CLAIM_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function challengeTicketClaimCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CHALLENGE_TICKET_CLAIM_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.CHALLENGE_TICKET_CLAIM_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function answerChallengeTicketClaimCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	exports.default = (0, _redux.combineReducers)({
	    ticketClaim: ticketClaim,
	    stream: stream,
	    range: range,
	    query: query,
	    _links: _links,
	    openTicketClaimCmd: openTicketClaimCmd,
	    qualifyTicketClaimCmd: qualifyTicketClaimCmd,
	    answerTicketClaimCmd: answerTicketClaimCmd,
	    challengeTicketClaimCmd: challengeTicketClaimCmd,
	    answerChallengeTicketClaimCmd: answerChallengeTicketClaimCmd
	});

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function (rootPath, dispatcher, _ref) {
	    var getState = _ref.getState;
	
	
	    function enterTicketClaimStream(dispatch) {
	        var state = getState();
	        var criteria = state.claim.criteria;
	
	
	        return dispatch((0, _actions4.loadTicketClaimStream)(_extends({}, _actions4.DEFAULT_TICKET_CLAIM_QUERY, criteria)));
	    }
	
	    function enterNewTicketClaim(dispatch) {
	        var state = getState();
	        var openTicketClaimCmd = state.claim.openTicketClaimCmd;
	
	
	        var ticketReference = {
	            uid: openTicketClaimCmd && openTicketClaimCmd.ticketUid,
	            referenceType: openTicketClaimCmd && openTicketClaimCmd.commandType == 'OpenTicketClaim' && 'ReferencedTicket' || 'ExternalTicket'
	        };
	
	        return Promise.all([dispatch((0, _actions4.createTicketClaim)({ ticketReference: ticketReference })), dispatch((0, _actions.loadTicketClaimRef)())]).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 1),
	                createTicketClaimAction = _ref3[0];
	
	            var ticketId = createTicketClaimAction.ticketClaim.ticketReference.uid;
	            return ticketId && dispatch((0, _actions2.loadTicket)(ticketId));
	        }).then(function (loadTicketAction) {
	            var patrimony = loadTicketAction && loadTicketAction.ticket.linkedEntities.patrimony;
	            return Promise.all([patrimony && dispatch((0, _actions3.loadPatrimony)(patrimony.uid))]);
	        });
	    }
	
	    function enterTicketClaim(dispatch, params) {
	        return Promise.all([dispatch((0, _actions4.loadTicketClaim)(params.id)), dispatch((0, _actions.loadTicketClaimRef)())]).then(function (_ref4) {
	            var _ref5 = _slicedToArray(_ref4, 1),
	                loadTicketClaimAction = _ref5[0];
	
	            var ticketId = loadTicketClaimAction.ticketClaim.ticketReference.uid;
	            return ticketId && dispatch((0, _actions2.loadTicket)(ticketId));
	        }).then(function (loadTicketAction) {
	            var patrimony = loadTicketAction && loadTicketAction.ticket.linkedEntities.patrimony;
	            var caller = loadTicketAction && loadTicketAction.ticket.caller;
	            return Promise.all([patrimony && dispatch((0, _actions3.loadPatrimony)(patrimony.uid)), caller && caller.callerInfos.callerType === 'PatrimonyContactCaller' && dispatch((0, _actions3.loadContact)(caller.uid))]);
	        });
	    }
	
	    return {
	        path: rootPath,
	        component: _TicketClaimLayout2.default,
	        onEnter: dispatcher(enterTicketClaimStream),
	        indexRoute: {
	            component: _TicketClaimStreamLayout2.default
	        },
	        childRoutes: [{
	            path: 'new',
	            component: _TicketClaimDetail2.default,
	            onEnter: dispatcher(enterNewTicketClaim)
	        }, {
	            path: ':id',
	            component: _TicketClaimDetail2.default,
	            onEnter: dispatcher(enterTicketClaim)
	        }]
	    };
	};
	
	var _actions = __webpack_require__(113);
	
	var _actions2 = __webpack_require__(38);
	
	var _actions3 = __webpack_require__(74);
	
	var _actions4 = __webpack_require__(191);
	
	var _TicketClaimLayout = __webpack_require__(1298);
	
	var _TicketClaimLayout2 = _interopRequireDefault(_TicketClaimLayout);
	
	var _TicketClaimStreamLayout = __webpack_require__(1301);
	
	var _TicketClaimStreamLayout2 = _interopRequireDefault(_TicketClaimStreamLayout);
	
	var _TicketClaimDetail = __webpack_require__(1297);
	
	var _TicketClaimDetail2 = _interopRequireDefault(_TicketClaimDetail);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	function agencyCriteriaUpdated() {
	    var criteria;
	
	    return function (state, dispatch) {
	        var nextCriteria = state.company.agency.criteria;
	
	        if (criteria === undefined) {
	            // state initial value
	            criteria = nextCriteria;
	        }
	
	        if (nextCriteria != criteria) {
	            dispatch((0, _actions.loadAgencyStream)(_extends({}, _actions.DEFAULT_QUERY, nextCriteria)));
	            criteria = nextCriteria;
	        }
	    };
	}
	
	function userCriteriaUpdated() {
	    var criteria;
	
	    return function (state, dispatch) {
	        var nextCriteria = state.company.user.criteria;
	
	        if (criteria === undefined) {
	            // state initial value
	            criteria = nextCriteria;
	        }
	
	        if (nextCriteria != criteria) {
	            dispatch((0, _actions.loadUserStream)(_extends({}, _actions.DEFAULT_QUERY, nextCriteria)));
	            criteria = nextCriteria;
	        }
	    };
	}
	
	function referenceCompanyCmdUpdated() {
	    var cmd;
	
	    return function (state, dispatch) {
	        var nextCmd = state.company.referenceCompanyCmd;
	
	        if (nextCmd != cmd) {
	
	            if (nextCmd && nextCmd.commandType != (cmd && cmd.commandType)) {
	                switch (nextCmd.commandType) {
	                    case 'CreateClientAccount':
	                    case 'CreateClientAccountHolding':
	                        dispatch((0, _actions.updateReferenceCompanyCmd)({ billingType: nextCmd.billingType || _models.BILLING_TYPES[0] }));
	                        break;
	                    case 'CreateCallCenter':
	                        dispatch((0, _actions.updateReferenceCompanyCmd)({ callCenterReference: null, billingType: null }));
	                        break;
	                }
	            }
	            cmd = nextCmd;
	        }
	    };
	}
	
	function referenceUserCmdUpdated() {
	    var cmd;
	
	    return function (state, dispatch) {
	        var nextCmd = state.company.referenceUserCmd;
	
	        if (nextCmd != cmd) {
	
	            if (nextCmd && nextCmd.commandType != (cmd && cmd.commandType)) {
	                switch (nextCmd.commandType) {
	                    case 'ReferenceCallCenterUser':
	                    case 'ReferenceCallCenterOperator':
	                    case 'ReferenceClientAccountManager':
	                        dispatch((0, _actions.updateReferenceUserCmd)({ managedAgencies: null, managedPatrimonies: null }));
	                        break;
	                    case 'ReferenceExecutive':
	                        dispatch((0, _actions.updateReferenceUserCmd)({ managedPatrimonies: null }));
	                        break;
	                    case 'ReferencePatrimonyManager':
	                        dispatch((0, _actions.updateReferenceUserCmd)({ managedAgencies: null }));
	                        break;
	                }
	            }
	            cmd = nextCmd;
	        }
	    };
	}
	
	exports.default = [agencyCriteriaUpdated(), userCriteriaUpdated(), referenceCompanyCmdUpdated(), referenceUserCmdUpdated()];

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AgencyCard = __webpack_require__(2172);
	
	var _AgencyCard2 = _interopRequireDefault(_AgencyCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AgencyCard = function (_Component) {
	    _inherits(AgencyCard, _Component);
	
	    function AgencyCard() {
	        _classCallCheck(this, AgencyCard);
	
	        return _possibleConstructorReturn(this, (AgencyCard.__proto__ || Object.getPrototypeOf(AgencyCard)).apply(this, arguments));
	    }
	
	    _createClass(AgencyCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                agency = _props.agency,
	                others = _objectWithoutProperties(_props, ['agency']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.agency,
	                ' ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    agency.ref
	                )
	            );
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({ justified: true,
	                    kind: 'tab',
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _AgencyCard2.default.label },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        '> ',
	                        agency.label
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _AgencyCard2.default.address },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _i18n2.default.address
	                    ),
	                    agency.address && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            agency.address.number
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            ' ',
	                            agency.address.street
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            ' -'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            ' ',
	                            agency.address.zipCode
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            ' ',
	                            agency.address.city
	                        )
	                    ) || '---'
	                )
	            );
	        }
	    }]);
	
	    return AgencyCard;
	}(_react.Component);
	
	AgencyCard.propTypes = {
	    agency: _react.PropTypes.object.isRequired
	};
	exports.default = AgencyCard;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _links = __webpack_require__(33);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _CallPurposeDashboardPanel = __webpack_require__(898);
	
	var _CallPurposeDashboardPanel2 = _interopRequireDefault(_CallPurposeDashboardPanel);
	
	var _ProviderDashboardPanel = __webpack_require__(899);
	
	var _ProviderDashboardPanel2 = _interopRequireDefault(_ProviderDashboardPanel);
	
	var _ClosingRateDashboardPanel = __webpack_require__(549);
	
	var _ClosingRateDashboardPanel2 = _interopRequireDefault(_ClosingRateDashboardPanel);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AgencyDashboard = __webpack_require__(2173);
	
	var _AgencyDashboard2 = _interopRequireDefault(_AgencyDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AgencyDashboard = function (_Component) {
	    _inherits(AgencyDashboard, _Component);
	
	    function AgencyDashboard() {
	        _classCallCheck(this, AgencyDashboard);
	
	        return _possibleConstructorReturn(this, (AgencyDashboard.__proto__ || Object.getPrototypeOf(AgencyDashboard)).apply(this, arguments));
	    }
	
	    _createClass(AgencyDashboard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                agency = _props.agency,
	                _appLinks = _props._appLinks;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.description) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _AgencyDashboard2.default.data },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.reference,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        agency.ref
	                                    )
	                                )
	                            )
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(_ClosingRateDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } }),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(_ProviderDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(_CallPurposeDashboardPanel2.default, { light: true,
	                            size: 'large' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AgencyDashboard;
	}(_react.Component);
	
	AgencyDashboard.propTypes = {};
	
	
	AgencyDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        agency: state.company.agency.agency,
	        _appLinks: state.app._links
	    };
	})(AgencyDashboard);
	
	exports.default = AgencyDashboard;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DownloadIcon = __webpack_require__(890);
	
	var _DownloadIcon2 = _interopRequireDefault(_DownloadIcon);
	
	var _actions = __webpack_require__(38);
	
	var _ReportTicketsModal = __webpack_require__(1114);
	
	var _ReportTicketsModal2 = _interopRequireDefault(_ReportTicketsModal);
	
	var _ReferencePatrimonyPopover = __webpack_require__(1099);
	
	var _ReferencePatrimonyPopover2 = _interopRequireDefault(_ReferencePatrimonyPopover);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateAgencyPopover = __webpack_require__(1335);
	
	var _UpdateAgencyPopover2 = _interopRequireDefault(_UpdateAgencyPopover);
	
	var _DeleteAgencyModal = __webpack_require__(1323);
	
	var _DeleteAgencyModal2 = _interopRequireDefault(_DeleteAgencyModal);
	
	var _AgencyDetail = __webpack_require__(2174);
	
	var _AgencyDetail2 = _interopRequireDefault(_AgencyDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function toLink(path) {
	    return {
	        active: path === '' ? location.pathname.split('/').length === 5 : location.pathname.endsWith(path),
	        href: '/' + location.pathname.split('/').slice(1, 5).join('/') + path
	    };
	}
	
	function modalName(result) {
	    switch (result) {
	        case 'DELETE':
	            return 'DeleteAgencyModal';
	        default:
	            return null;
	    }
	}
	
	var AgencyDetail = function (_Component) {
	    _inherits(AgencyDetail, _Component);
	
	    function AgencyDetail(props) {
	        _classCallCheck(this, AgencyDetail);
	
	        var _this = _possibleConstructorReturn(this, (AgencyDetail.__proto__ || Object.getPrototypeOf(AgencyDetail)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(AgencyDetail, [{
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_closePopover',
	        value: function _closePopover(event, result) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            var openedPopover = null;
	            var openedModal = modalName(result);
	            this.setState({ openedPopover: openedPopover, openedModal: openedModal });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(name) {
	            this.setState({ openedModal: name });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                progress = _props.progress,
	                authenticated = _props.authenticated,
	                agency = _props.agency,
	                _appLinks = _props._appLinks,
	                _patrimonyLinks = _props._patrimonyLinks;
	            var _state = this.state,
	                openedPopover = _state.openedPopover,
	                openedModal = _state.openedModal;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _AgencyDetail2.default.menu },
	                    _patrimonyLinks.find((0, _links.linkFinder)('ReferencePatrimony')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferencePatrimonyPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.patrimony
	                            )
	                        )
	                    ),
	                    agency._links.find((0, _links.linkFinder)('UpdateAgency')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'UpdateAgencyPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.change
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: function onHide(e) {
	                            return _this2._closePopover(e);
	                        } },
	                    popover
	                );
	            };
	
	            var tooltip = function tooltip(text, status) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: status && 'tooltip-' + status },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _AgencyDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _AgencyDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        { className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _AgencyDetail2.default.header },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.agency,
	                                ' ',
	                                agency.label
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _AgencyDetail2.default.report },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _AgencyDetail2.default.container },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: tooltip(progress[_actions.PDF_TICKETS_REPORTED] && _i18n2.default.reportingAgency || _i18n2.default.reportPdfAgency, 'primary') },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'link',
	                                                bsSize: 'small',
	                                                disabled: !!progress[_actions.PDF_TICKETS_REPORTED],
	                                                onClick: function onClick() {
	                                                    return _this2._openModal('ReportTicketsModal');
	                                                } },
	                                            _react2.default.createElement(_DownloadIcon2.default, { progress: progress[_actions.PDF_TICKETS_REPORTED] })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _AgencyDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        _patrimonyLinks.find((0, _links.linkFinder)('ReferencePatrimony')) && editOverlay('ReferencePatrimonyPopover', _react2.default.createElement(_ReferencePatrimonyPopover2.default, {
	                            user: authenticated,
	                            agency: agency,
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        agency._links.find((0, _links.linkFinder)('UpdateAgency')) && editOverlay('UpdateAgencyPopover', _react2.default.createElement(_UpdateAgencyPopover2.default, {
	                            onHide: function onHide(e, r) {
	                                return _this2._closePopover(e, r);
	                            } }))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(_reactBootstrap.Col, { sm: 4, smOffset: 4 })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink(''),
	                            _i18n2.default.synthesis
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/tickets'),
	                            _i18n2.default.tickets
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.patrimony
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/documents'),
	                            _i18n2.default.documents
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('providercontacts')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/providercontacts'),
	                            _i18n2.default.providers
	                        )
	                    ),
	                    agency._links.find((0, _links.linkFinder)('DeleteAgency')) && _react2.default.createElement(_DeleteAgencyModal2.default, {
	                        show: openedModal == 'DeleteAgencyModal',
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } })
	                ),
	                children,
	                _react2.default.createElement(_ReportTicketsModal2.default, {
	                    agency: agency,
	                    show: openedModal == 'ReportTicketsModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } })
	            );
	        }
	    }]);
	
	    return AgencyDetail;
	}(_react.Component);
	
	AgencyDetail.propTypes = {};
	
	
	AgencyDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        progress: state.progress,
	        authenticated: state.user.authenticated,
	        agency: state.company.agency.agency,
	        _appLinks: state.app._links,
	        _patrimonyLinks: state.patrimony._links
	    };
	})(AgencyDetail);
	
	exports.default = AgencyDetail;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function agencyFilter(agencies) {
	    return function (agency) {
	        return agencies.find(function (a) {
	            return a.uid == agency.uid;
	        }) != null;
	    };
	}
	
	var AgencyPicker = function (_Component) {
	    _inherits(AgencyPicker, _Component);
	
	    function AgencyPicker(props) {
	        _classCallCheck(this, AgencyPicker);
	
	        var _this = _possibleConstructorReturn(this, (AgencyPicker.__proto__ || Object.getPrototypeOf(AgencyPicker)).call(this, props));
	
	        _this.state = {
	            agencies: []
	        };
	        return _this;
	    }
	
	    _createClass(AgencyPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user,
	                company = _props.company,
	                agency = _props.agency;
	
	
	            if (agency) {
	                this.setState({ agencies: [agency] });
	            } else if (company && company.companyType == 'ClientAccountHolding') {
	                dispatch((0, _actions.queryHoldingAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { holdingUid: company.uid, range: { offset: 0, limit: 99 } })));
	            } else if (company) {
	                dispatch((0, _actions.queryAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { companyUid: company.uid, range: { offset: 0, limit: 99 } })));
	            } else if (user && user.company && user.isPartOfHolding) {
	                dispatch((0, _actions.queryHoldingAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { holdingUid: user.company.uid, range: { offset: 0, limit: 99 } })));
	            } else if (user && user.company) {
	                dispatch((0, _actions.queryAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { companyUid: user.company.uid, range: { offset: 0, limit: 99 } })));
	            } else if (user) {
	                this.setState({ agencies: user.managedAgencies || [] });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.user != this.props.user || nextProps.company != this.props.company || nextProps.agency != this.props.agency) {
	                var _props2 = this.props,
	                    dispatch = _props2.dispatch,
	                    user = _props2.user,
	                    company = _props2.company,
	                    agency = _props2.agency;
	
	
	                if (agency) {
	                    this.setState({ agencies: [agency] });
	                } else if (company && company.companyType == 'ClientAccountHolding') {
	                    dispatch((0, _actions.queryHoldingAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { holdingUid: company.uid, range: { offset: 0, limit: 99 } })));
	                } else if (company) {
	                    dispatch((0, _actions.queryAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { companyUid: company.uid, range: { offset: 0, limit: 99 } })));
	                } else if (user && user.company && user.isPartOfHolding) {
	                    dispatch((0, _actions.queryHoldingAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { holdingUid: user.company.uid, range: { offset: 0, limit: 99 } })));
	                } else if (user && user.company) {
	                    dispatch((0, _actions.queryAgencyStream)(_extends({}, _actions.DEFAULT_AGENCY_QUERY, { companyUid: user.company.uid, range: { offset: 0, limit: 99 } })));
	                } else if (user) {
	                    this.setState({ agencies: user.managedAgencies || [] });
	                }
	            }
	
	            if (nextProps.stream != this.props.stream) {
	                var _user = nextProps.user,
	                    stream = nextProps.stream;
	
	                var agencies = _user && _user.managedAgencies && _user.managedAgencies.filter(agencyFilter(stream)) || stream;
	
	                this.setState({ agencies: agencies });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                stream = _props3.stream,
	                user = _props3.user,
	                company = _props3.company,
	                agency = _props3.agency,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'stream', 'user', 'company', 'agency']);
	
	            var agencies = this.state.agencies;
	
	
	            var displayAgency = function displayAgency(agency, mode) {
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'h4',
	                        null,
	                        agency.label
	                    );
	                }
	                return agency.label;
	            };
	
	            return _react2.default.createElement(_Picker2.default, _extends({
	                source: agencies,
	                identify: function identify(a) {
	                    return a.uid;
	                },
	                display: displayAgency
	            }, others));
	        }
	    }]);
	
	    return AgencyPicker;
	}(_react.Component);
	
	AgencyPicker.propTypes = {
	    user: _react.PropTypes.object,
	    company: _react.PropTypes.object,
	    agency: _react.PropTypes.object
	};
	
	
	AgencyPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.company.agency.stream
	    };
	})(AgencyPicker);
	
	exports.default = AgencyPicker;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AgencySearch = __webpack_require__(2175);
	
	var _AgencySearch2 = _interopRequireDefault(_AgencySearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AgencySearch = function (_Component) {
	    _inherits(AgencySearch, _Component);
	
	    function AgencySearch() {
	        _classCallCheck(this, AgencySearch);
	
	        return _possibleConstructorReturn(this, (AgencySearch.__proto__ || Object.getPrototypeOf(AgencySearch)).apply(this, arguments));
	    }
	
	    _createClass(AgencySearch, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                criteria = _props.criteria;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _AgencySearch2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _AgencySearch2.default.side },
	                    _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        form.active(),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                value: true },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _i18n2.default.agencyActive
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '|'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                value: false },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _i18n2.default.agencyInactive
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AgencySearch;
	}(_react.Component);
	
	AgencySearch.propTypes = {};
	
	
	AgencySearch = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.AgencyCriteria.schema,
	    action: _actions.AGENCY_CRITERIA_UPDATED
	})(AgencySearch);
	
	AgencySearch = (0, _reactRedux.connect)(function (state) {
	    return {
	        criteria: state.company.agency.criteria
	    };
	})(AgencySearch);
	
	exports.default = AgencySearch;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(46);
	
	var _AgencyCard = __webpack_require__(1306);
	
	var _AgencyCard2 = _interopRequireDefault(_AgencyCard);
	
	var _AgencyStream = __webpack_require__(2176);
	
	var _AgencyStream2 = _interopRequireDefault(_AgencyStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var AgencyStream = function (_Component) {
	    _inherits(AgencyStream, _Component);
	
	    function AgencyStream() {
	        _classCallCheck(this, AgencyStream);
	
	        return _possibleConstructorReturn(this, (AgencyStream.__proto__ || Object.getPrototypeOf(AgencyStream)).apply(this, arguments));
	    }
	
	    _createClass(AgencyStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadAgencyStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, agency) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open((0, _browser.resolveLocationPathname)('/*/' + agency.company.uid + '/agencies/' + agency.uid), '_blank');
	            } else {
	                dispatch((0, _router.push)('/*/' + agency.company.uid + '/agencies/' + agency.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (agency) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: agency.uid,
	                                sm: 4 },
	                            _react2.default.createElement(_AgencyCard2.default, {
	                                agency: agency,
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, agency);
	                                } })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _AgencyStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true,
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return AgencyStream;
	}(_react.Component);
	
	AgencyStream.propTypes = {};
	
	
	AgencyStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.company.agency.stream,
	        range: state.company.agency.range
	    };
	})(AgencyStream);
	
	exports.default = AgencyStream;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AgencySearch = __webpack_require__(1310);
	
	var _AgencySearch2 = _interopRequireDefault(_AgencySearch);
	
	var _AgencyStream = __webpack_require__(1311);
	
	var _AgencyStream2 = _interopRequireDefault(_AgencyStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AgencyStreamLayout = function (_Component) {
	    _inherits(AgencyStreamLayout, _Component);
	
	    function AgencyStreamLayout() {
	        _classCallCheck(this, AgencyStreamLayout);
	
	        return _possibleConstructorReturn(this, (AgencyStreamLayout.__proto__ || Object.getPrototypeOf(AgencyStreamLayout)).apply(this, arguments));
	    }
	
	    _createClass(AgencyStreamLayout, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_AgencySearch2.default, null),
	                _react2.default.createElement(_AgencyStream2.default, null)
	            );
	        }
	    }]);
	
	    return AgencyStreamLayout;
	}(_react.Component);
	
	AgencyStreamLayout.propTypes = {};
	exports.default = AgencyStreamLayout;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AssociateDissociateUserFromAgencyModal = __webpack_require__(2177);
	
	var _AssociateDissociateUserFromAgencyModal2 = _interopRequireDefault(_AssociateDissociateUserFromAgencyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function agencyFilter(agencies) {
	    return function (agency) {
	        return agencies.find(function (a) {
	            return a.uid == agency.uid;
	        }) == null;
	    };
	}
	
	var AssociateDissociateUserFromAgencyModal = function (_Component) {
	    _inherits(AssociateDissociateUserFromAgencyModal, _Component);
	
	    function AssociateDissociateUserFromAgencyModal(props) {
	        _classCallCheck(this, AssociateDissociateUserFromAgencyModal);
	
	        var _this = _possibleConstructorReturn(this, (AssociateDissociateUserFromAgencyModal.__proto__ || Object.getPrototypeOf(AssociateDissociateUserFromAgencyModal)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(AssociateDissociateUserFromAgencyModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                user = _props.user,
	                companyAgencies = _props.companyAgencies;
	
	
	            var agencies = companyAgencies.filter(agencyFilter(user.managedAgencies));
	            this.setState({ agencies: agencies });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.user != this.props.user || nextProps.companyAgencies != this.props.companyAgencies) {
	                var user = nextProps.user,
	                    companyAgencies = nextProps.companyAgencies;
	
	
	                var agencies = companyAgencies.filter(agencyFilter(user.managedAgencies));
	                this.setState({ agencies: agencies });
	            }
	        }
	    }, {
	        key: '_sendAssociateCmd',
	        value: function _sendAssociateCmd(event, agencyId) {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                user = _props2.user,
	                onHide = _props2.onHide;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendAssociateUserWithAgencyCmd)(user.uid, agencyId)).then(function () {
	                return dispatch((0, _actions.loadUserStream)());
	            }).then(function () {
	                _this2.setState({ selectedAgencyId: null });
	            }).catch(function () {
	                _this2.setState({ selectedAgencyId: null });
	            });
	        }
	    }, {
	        key: '_sendDissociateCmd',
	        value: function _sendDissociateCmd(event, agency) {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                user = _props3.user;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendDissociateUserFromAgencyCmd)(user.uid, agency.uid)).then(function () {
	                return dispatch((0, _actions.loadUserStream)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                user = _props4.user,
	                companyAgencies = _props4.companyAgencies,
	                onHide = _props4.onHide,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'user', 'companyAgencies', 'onHide']);
	
	            var _state = this.state,
	                agencies = _state.agencies,
	                selectedAgencyId = _state.selectedAgencyId;
	
	
	            var agencyField = {
	                value: selectedAgencyId || '',
	                onChange: function onChange(event) {
	                    var selectedAgencyId = event.target.value;
	                    _this3.setState({ selectedAgencyId: selectedAgencyId });
	                    _this3._sendAssociateCmd(event, selectedAgencyId);
	                }
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.associateDissociateAgencies
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _AssociateDissociateUserFromAgencyModal2.default.agencyGroup },
	                        user.managedAgencies.map(function (agency) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: agency.uid },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        className: _AssociateDissociateUserFromAgencyModal2.default.dissociate,
	                                        onClick: function onClick(e) {
	                                            return _this3._sendDissociateCmd(e, agency);
	                                        } },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    agency.label
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                type: 'select',
	                                name: 'agency'
	                            }, agencyField),
	                            _react2.default.createElement(
	                                'option',
	                                { value: '' },
	                                _i18n2.default.addAgency
	                            ),
	                            agencies.map(function (agency, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    {
	                                        key: index,
	                                        value: agency.uid },
	                                    agency.label
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssociateDissociateUserFromAgencyModal;
	}(_react.Component);
	
	AssociateDissociateUserFromAgencyModal.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AssociateDissociateUserFromAgencyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        companyAgencies: state.company.companyAgencies
	    };
	})(AssociateDissociateUserFromAgencyModal);
	
	exports.default = AssociateDissociateUserFromAgencyModal;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _PatrimonyPicker = __webpack_require__(548);
	
	var _PatrimonyPicker2 = _interopRequireDefault(_PatrimonyPicker);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssociateDissociateUserFromPatrimonyModal = function (_Component) {
	    _inherits(AssociateDissociateUserFromPatrimonyModal, _Component);
	
	    function AssociateDissociateUserFromPatrimonyModal() {
	        _classCallCheck(this, AssociateDissociateUserFromPatrimonyModal);
	
	        return _possibleConstructorReturn(this, (AssociateDissociateUserFromPatrimonyModal.__proto__ || Object.getPrototypeOf(AssociateDissociateUserFromPatrimonyModal)).apply(this, arguments));
	    }
	
	    _createClass(AssociateDissociateUserFromPatrimonyModal, [{
	        key: '_sendAssociateCmd',
	        value: function _sendAssociateCmd(patrimony) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user;
	
	
	            return dispatch((0, _actions.sendAssociateUserWithPatrimonyCmd)(user.uid, patrimony.uid)).then(function () {
	                return dispatch((0, _actions.loadUserStream)());
	            });
	        }
	    }, {
	        key: '_sendDissociateCmd',
	        value: function _sendDissociateCmd(patrimony) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                user = _props2.user;
	
	
	            return dispatch((0, _actions.sendDissociateUserFromPatrimonyCmd)(user.uid, patrimony.uid)).then(function () {
	                return dispatch((0, _actions.loadUserStream)());
	            });
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(action, patrimony) {
	            if (action == 'Add') return this._sendAssociateCmd(patrimony);
	            if (action == 'Remove') return this._sendDissociateCmd(patrimony);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                company = _props3.company,
	                user = _props3.user,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'company', 'user', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    bsSize: 'large',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.associateDissociatePatrimonies
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_PatrimonyPicker2.default, { multi: true, split: true,
	                        company: company,
	                        value: user.managedPatrimonies,
	                        onSubmit: function onSubmit(a, p) {
	                            return _this2._sendCmd(a, p);
	                        } }),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssociateDissociateUserFromPatrimonyModal;
	}(_react.Component);
	
	AssociateDissociateUserFromPatrimonyModal.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AssociateDissociateUserFromPatrimonyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        company: state.company.company
	    };
	})(AssociateDissociateUserFromPatrimonyModal);
	
	exports.default = AssociateDissociateUserFromPatrimonyModal;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanyConfigsPopover = __webpack_require__(2179);
	
	var _CompanyConfigsPopover2 = _interopRequireDefault(_CompanyConfigsPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyConfigsPopover = function (_Component) {
	    _inherits(CompanyConfigsPopover, _Component);
	
	    function CompanyConfigsPopover() {
	        _classCallCheck(this, CompanyConfigsPopover);
	
	        return _possibleConstructorReturn(this, (CompanyConfigsPopover.__proto__ || Object.getPrototypeOf(CompanyConfigsPopover)).apply(this, arguments));
	    }
	
	    _createClass(CompanyConfigsPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _actions.queryCompanyConfigs)());
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.company != this.props.company) {
	                var dispatch = nextProps.dispatch;
	
	                dispatch((0, _actions.queryCompanyConfigs)());
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendCompanyConfigs)()).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                company = _props2.company,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'company', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var prefixField = function prefixField(field) {
	                var value = field.value;
	
	                function onChange(event) {
	                    var value = event.target.value;
	                    var nextValue = value.toUpperCase().replace(/[^A-Z]/g, '').substring(0, 3);
	                    field.onChange(nextValue);
	                }
	
	                value = value || ''; // fix uncontrolled input issue
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            var tooltipInputAddon = function tooltipInputAddon(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(text) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: _CompanyConfigsPopover2.default.info },
	                        '?'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.configs
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _CompanyConfigsPopover2.default.defaultContent },
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'prefix',
	                            label: requiredLabel(_i18n2.default.ticketUidGeneratorPrefix),
	                            addonAfter: tooltipInputAddon(_i18n2.default.ticketUidGeneratorPrefixText)
	                        }, prefixField(form.ticketUidGenerator.uidPrefix()))),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            wrapperClassName: 'col-sm-offset-3 col-sm-9',
	                            type: 'checkbox',
	                            name: 'acknowledge',
	                            label: requiredLabel(_i18n2.default.acknowledgeTicketUidGenerator)
	                        }, (0, _form.checkboxField)(form.ticketUidGenerator.acknowledge())))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CompanyConfigsPopover;
	}(_react.Component);
	
	CompanyConfigsPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	CompanyConfigsPopover = (0, _form.connectForm)({
	    target: 'companyConfigs',
	    schema: _models.CompanyConfigs.schema,
	    action: _actions.COMPANY_CONFIGS_UPDATED
	})(CompanyConfigsPopover);
	
	CompanyConfigsPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        companyConfigs: state.company.companyConfigs
	    };
	})(CompanyConfigsPopover);
	
	exports.default = CompanyConfigsPopover;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _links = __webpack_require__(33);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _CallPurposeDashboardPanel = __webpack_require__(898);
	
	var _CallPurposeDashboardPanel2 = _interopRequireDefault(_CallPurposeDashboardPanel);
	
	var _ProviderDashboardPanel = __webpack_require__(899);
	
	var _ProviderDashboardPanel2 = _interopRequireDefault(_ProviderDashboardPanel);
	
	var _ClosingRateDashboardPanel = __webpack_require__(549);
	
	var _ClosingRateDashboardPanel2 = _interopRequireDefault(_ClosingRateDashboardPanel);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanyDashboard = __webpack_require__(2180);
	
	var _CompanyDashboard2 = _interopRequireDefault(_CompanyDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyDashboard = function (_Component) {
	    _inherits(CompanyDashboard, _Component);
	
	    function CompanyDashboard() {
	        _classCallCheck(this, CompanyDashboard);
	
	        return _possibleConstructorReturn(this, (CompanyDashboard.__proto__ || Object.getPrototypeOf(CompanyDashboard)).apply(this, arguments));
	    }
	
	    _createClass(CompanyDashboard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company,
	                companyAgencies = _props.companyAgencies,
	                _appLinks = _props._appLinks;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.description) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _CompanyDashboard2.default.data },
	                                company.siretNumber && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.siret,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        company.siretNumber
	                                    )
	                                )
	                            )
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && companyAgencies.length > 0 && _react2.default.createElement(_ClosingRateDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } }),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && companyAgencies.length > 0 && _react2.default.createElement(_ProviderDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && companyAgencies.length > 0 && _react2.default.createElement(_CallPurposeDashboardPanel2.default, { light: true,
	                            size: 'large' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CompanyDashboard;
	}(_react.Component);
	
	CompanyDashboard.propTypes = {};
	
	
	CompanyDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        company: state.company.company,
	        companyAgencies: state.company.companyAgencies,
	        _appLinks: state.app._links
	    };
	})(CompanyDashboard);
	
	exports.default = CompanyDashboard;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _loading = __webpack_require__(58);
	
	var _router = __webpack_require__(123);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ReferencePatrimonyPopover = __webpack_require__(1099);
	
	var _ReferencePatrimonyPopover2 = _interopRequireDefault(_ReferencePatrimonyPopover);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReferenceSubsidiaryPopover = __webpack_require__(1331);
	
	var _ReferenceSubsidiaryPopover2 = _interopRequireDefault(_ReferenceSubsidiaryPopover);
	
	var _ReferenceAgencyPopover = __webpack_require__(1329);
	
	var _ReferenceAgencyPopover2 = _interopRequireDefault(_ReferenceAgencyPopover);
	
	var _ReferenceUserPopover = __webpack_require__(1332);
	
	var _ReferenceUserPopover2 = _interopRequireDefault(_ReferenceUserPopover);
	
	var _UpdateCompanyPopover = __webpack_require__(1336);
	
	var _UpdateCompanyPopover2 = _interopRequireDefault(_UpdateCompanyPopover);
	
	var _IdentifyCompanyPopover = __webpack_require__(1326);
	
	var _IdentifyCompanyPopover2 = _interopRequireDefault(_IdentifyCompanyPopover);
	
	var _ReactiveCancelCompanyModal = __webpack_require__(1328);
	
	var _ReactiveCancelCompanyModal2 = _interopRequireDefault(_ReactiveCancelCompanyModal);
	
	var _UpgradeDowngradePremiumAccountModal = __webpack_require__(1339);
	
	var _UpgradeDowngradePremiumAccountModal2 = _interopRequireDefault(_UpgradeDowngradePremiumAccountModal);
	
	var _UpgradeDowngradeStandardAccountModal = __webpack_require__(1340);
	
	var _UpgradeDowngradeStandardAccountModal2 = _interopRequireDefault(_UpgradeDowngradeStandardAccountModal);
	
	var _CompanyConfigsPopover = __webpack_require__(1315);
	
	var _CompanyConfigsPopover2 = _interopRequireDefault(_CompanyConfigsPopover);
	
	var _CompanyDetail = __webpack_require__(2181);
	
	var _CompanyDetail2 = _interopRequireDefault(_CompanyDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function toLink(path) {
	    return {
	        active: path === '' ? location.pathname.split('/').length === 3 : location.pathname.endsWith(path),
	        href: '/' + location.pathname.split('/').slice(1, 3).join('/') + path
	    };
	}
	
	function modalName(result) {
	    switch (result) {
	        case 'ReactiveCompany':
	        case 'CancelCompany':
	            return 'ReactiveCancelCompanyModal';
	        case 'UpgradeCompanyToPremiumAccount':
	        case 'DowngradePremiumAccount':
	            return 'UpgradeDowngradePremiumAccountModal';
	        case 'UpgradeCompanyToStandardAccount':
	            return 'UpgradeDowngradeStandardAccountModal';
	        default:
	            return null;
	    }
	}
	
	var CompanyDetail = function (_Component) {
	    _inherits(CompanyDetail, _Component);
	
	    function CompanyDetail(props) {
	        _classCallCheck(this, CompanyDetail);
	
	        var _this = _possibleConstructorReturn(this, (CompanyDetail.__proto__ || Object.getPrototypeOf(CompanyDetail)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CompanyDetail, [{
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_closePopover',
	        value: function _closePopover(event, result) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            var openedPopover = null;
	            var openedModal = modalName(result);
	            this.setState({ openedPopover: openedPopover, openedModal: openedModal });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: '_openDropdown',
	        value: function _openDropdown() {
	            this.setState({ openedDropdown: true });
	        }
	    }, {
	        key: '_closeDropdown',
	        value: function _closeDropdown() {
	            this.setState({ openedDropdown: false });
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _router.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                loading = _props.loading,
	                location = _props.location,
	                authenticated = _props.authenticated,
	                company = _props.company,
	                companyAgencies = _props.companyAgencies,
	                companyUsers = _props.companyUsers,
	                companySubsidiaries = _props.companySubsidiaries,
	                _appLinks = _props._appLinks,
	                _patrimonyLinks = _props._patrimonyLinks;
	            var _state = this.state,
	                openedPopover = _state.openedPopover,
	                openedModal = _state.openedModal,
	                openedDropdown = _state.openedDropdown;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _CompanyDetail2.default.menu },
	                    companySubsidiaries._links.find((0, _links.linkFinder)('CreateClientAccount')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferenceSubsidiaryPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.subsidiary
	                            )
	                        )
	                    ),
	                    companyAgencies._links.find((0, _links.linkFinder)('CreateAgency')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferenceAgencyPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.agency
	                            )
	                        )
	                    ),
	                    companyUsers._links.find((0, _links.linkFinder)(_models.REFERENCE_USER_CMD_TYPES)) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferenceUserPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.user
	                            )
	                        )
	                    ),
	                    _patrimonyLinks.find((0, _links.linkFinder)('ReferencePatrimony')) && company._links.find((0, _links.linkFinder)(['agencies', 'subsidiaries'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferencePatrimonyPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.patrimony
	                            )
	                        )
	                    ),
	                    company._links.find((0, _links.linkFinder)('IdentifyCompany')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'IdentifyCompanyPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.identifyCompany
	                            )
	                        )
	                    ),
	                    company._links.find((0, _links.linkFinder)('configs')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'CompanyConfigsPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.configs
	                            )
	                        )
	                    ),
	                    company._links.find((0, _links.linkFinder)(_models.UPDATE_COMPANY_CMD_TYPES)) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'UpdateCompanyPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.change
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: function onHide(e) {
	                            return _this2._closePopover(e);
	                        } },
	                    popover
	                );
	            };
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    null,
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CompanyDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _CompanyDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        { className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _CompanyDetail2.default.header },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _CompanyDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _CompanyDetail2.default.headerContent },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _CompanyDetail2.default.container },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        (0, _extract2.default)(_i18n2.default.companyTypeEnum, company.companyType)
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        company.label
	                                    ),
	                                    (company.billingType == 'PremiumAccount' || company.billingType == 'StandardAccount') && _react2.default.createElement(
	                                        'div',
	                                        { className: _CompanyDetail2.default.billingType },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.OverlayTrigger,
	                                            {
	                                                placement: 'bottom',
	                                                overlay: tooltip((0, _extract2.default)(_i18n2.default.billingTypeEnum, company.billingType)) },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: _CompanyDetail2.default[company.billingType], alt: company.billingType, title: company.billingType },
	                                                company.billingType[0]
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        companySubsidiaries._links.find((0, _links.linkFinder)('CreateClientAccount')) && editOverlay('ReferenceSubsidiaryPopover', _react2.default.createElement(_ReferenceSubsidiaryPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        companyAgencies._links.find((0, _links.linkFinder)('CreateAgency')) && editOverlay('ReferenceAgencyPopover', _react2.default.createElement(_ReferenceAgencyPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        companyUsers._links.find((0, _links.linkFinder)(_models.REFERENCE_USER_CMD_TYPES)) && editOverlay('ReferenceUserPopover', _react2.default.createElement(_ReferenceUserPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        _patrimonyLinks.find((0, _links.linkFinder)('ReferencePatrimony')) && company._links.find((0, _links.linkFinder)(['agencies', 'subsidiaries'])) && editOverlay('ReferencePatrimonyPopover', _react2.default.createElement(_ReferencePatrimonyPopover2.default, {
	                            user: authenticated,
	                            company: company,
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        company._links.find((0, _links.linkFinder)('IdentifyCompany')) && editOverlay('IdentifyCompanyPopover', _react2.default.createElement(_IdentifyCompanyPopover2.default, {
	                            onHide: function onHide(e, r) {
	                                return _this2._closePopover(e, r);
	                            } })),
	                        company._links.find((0, _links.linkFinder)('configs')) && editOverlay('CompanyConfigsPopover', _react2.default.createElement(_CompanyConfigsPopover2.default, {
	                            onHide: function onHide(e, r) {
	                                return _this2._closePopover(e, r);
	                            } })),
	                        company._links.find((0, _links.linkFinder)(_models.UPDATE_COMPANY_CMD_TYPES)) && editOverlay('UpdateCompanyPopover', _react2.default.createElement(_UpdateCompanyPopover2.default, {
	                            onHide: function onHide(e, r) {
	                                return _this2._closePopover(e, r);
	                            } }))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4, smOffset: 4 },
	                            company._links.find((0, _links.linkFinder)('subsidiaries')) && _react2.default.createElement(
	                                'div',
	                                { className: _CompanyDetail2.default.metric },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.subsidiaries
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: toLink('/subsidiaries').href },
	                                    _react2.default.createElement(_Icon2.default, {
	                                        icon: 'ClientAccount',
	                                        size: 'sm',
	                                        count: companySubsidiaries.count })
	                                )
	                            ),
	                            company._links.find((0, _links.linkFinder)('agencies')) && _react2.default.createElement(
	                                'div',
	                                { className: _CompanyDetail2.default.metric },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.agencies
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: toLink('/agencies').href },
	                                    _react2.default.createElement(_Icon2.default, {
	                                        icon: 'agency',
	                                        size: 'sm',
	                                        count: companyAgencies.count })
	                                )
	                            ),
	                            company._links.find((0, _links.linkFinder)('users')) && _react2.default.createElement(
	                                'div',
	                                { className: _CompanyDetail2.default.metric },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.users
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: toLink('/users').href },
	                                    _react2.default.createElement(_Icon2.default, {
	                                        icon: 'user',
	                                        size: 'sm',
	                                        count: companyUsers.count })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink(''),
	                            _i18n2.default.synthesis
	                        ),
	                        company._links.find((0, _links.linkFinder)('subsidiaries')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/subsidiaries'),
	                            _i18n2.default.subsidiaries
	                        ),
	                        company._links.find((0, _links.linkFinder)('agencies')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/agencies'),
	                            _i18n2.default.agencies
	                        ),
	                        company._links.find((0, _links.linkFinder)('users')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/users'),
	                            _i18n2.default.users
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && companyAgencies.length > 0 && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/tickets'),
	                            _i18n2.default.tickets
	                        ),
	                        (company.companyType == 'ClientAccountHolding' || company.companyType == 'ClientAccount') && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/documents'),
	                            _i18n2.default.documents
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('providercontacts')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            toLink('/providercontacts'),
	                            _i18n2.default.providers
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavDropdown,
	                            {
	                                className: (0, _classnames2.default)({ 'active': ['openingticketpurposeref', 'criteriaref', 'contextualcommentref', 'workflows', 'criteriatrees', 'openingticketinstructions', 'satisfactioncampaigns', 'notifications'].some(function (t) {
	                                        return location.pathname.endsWith(t);
	                                    })
	                                }),
	                                title: _i18n2.default.parameters,
	                                open: openedDropdown,
	                                onToggle: function onToggle() {
	                                    return null;
	                                },
	                                onMouseEnter: function onMouseEnter() {
	                                    return _this2._openDropdown();
	                                },
	                                onMouseLeave: function onMouseLeave() {
	                                    return _this2._closeDropdown();
	                                } },
	                            company._links.find((0, _links.linkFinder)('openingticketpurposeref')) && _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                toLink('/openingticketpurposeref'),
	                                _i18n2.default.openingticketpurposeref
	                            ),
	                            company._links.find((0, _links.linkFinder)('criteriaref')) && _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                toLink('/criteriaref'),
	                                _i18n2.default.criteriaref
	                            ),
	                            company._links.find((0, _links.linkFinder)('workflows')) && _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                toLink('/workflows'),
	                                _i18n2.default.workflows
	                            ),
	                            company._links.find((0, _links.linkFinder)('contextualcommentref')) && _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                toLink('/contextualcommentref'),
	                                _i18n2.default.contextualcommentref
	                            ),
	                            company._links.find((0, _links.linkFinder)('criteriatrees')) && _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                toLink('/criteriatrees'),
	                                _i18n2.default.qualifCriterias
	                            ),
	                            _react2.default.createElement('hr', { style: { margin: '5px 0' } }),
	                            company._links.find((0, _links.linkFinder)('openingticketinstructions')) && _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                toLink('/openingticketinstructions'),
	                                _i18n2.default.openingticketinstructions
	                            ),
	                            company._links.find((0, _links.linkFinder)('ticketeventnotifications')) && _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                toLink('/notifications'),
	                                _i18n2.default.notifications
	                            ),
	                            company._links.find((0, _links.linkFinder)('satisfactioncampaigns')) && _react2.default.createElement(
	                                _reactBootstrap.MenuItem,
	                                toLink('/satisfactioncampaigns'),
	                                _i18n2.default.satisfactioncampaigns
	                            )
	                        )
	                    ),
	                    company._links.find((0, _links.linkFinder)(['ReactiveCompany', 'CancelCompany'])) && _react2.default.createElement(_ReactiveCancelCompanyModal2.default, {
	                        show: openedModal == 'ReactiveCancelCompanyModal',
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } }),
	                    company._links.find((0, _links.linkFinder)(['UpgradeCompanyToPremiumAccount', 'DowngradePremiumAccount'])) && _react2.default.createElement(_UpgradeDowngradePremiumAccountModal2.default, {
	                        show: openedModal == 'UpgradeDowngradePremiumAccountModal',
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } }),
	                    company._links.find((0, _links.linkFinder)('UpgradeCompanyToStandardAccount')) && _react2.default.createElement(_UpgradeDowngradeStandardAccountModal2.default, {
	                        show: openedModal == 'UpgradeDowngradeStandardAccountModal',
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } })
	                ),
	                children
	            );
	        }
	    }]);
	
	    return CompanyDetail;
	}(_react.Component);
	
	CompanyDetail.propTypes = {};
	
	
	CompanyDetail = (0, _loading.connectLoadingLock)()(CompanyDetail);
	
	CompanyDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        location: state.router.location,
	        authenticated: state.user.authenticated,
	        company: state.company.company,
	        companyAgencies: state.company.companyAgencies,
	        companyUsers: state.company.companyUsers,
	        companySubsidiaries: state.company.companySubsidiaries,
	        _appLinks: state.app._links,
	        _patrimonyLinks: state.patrimony._links
	    };
	})(CompanyDetail);
	
	exports.default = CompanyDetail;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(268);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanySearchBar = __webpack_require__(1319);
	
	var _CompanySearchBar2 = _interopRequireDefault(_CompanySearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyLayout = function (_Component) {
	    _inherits(CompanyLayout, _Component);
	
	    function CompanyLayout() {
	        _classCallCheck(this, CompanyLayout);
	
	        return _possibleConstructorReturn(this, (CompanyLayout.__proto__ || Object.getPrototypeOf(CompanyLayout)).apply(this, arguments));
	    }
	
	    _createClass(CompanyLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                history = _props.history,
	                routes = _props.routes,
	                params = _props.params,
	                company = _props.company,
	                agency = _props.agency,
	                campaign = _props.campaign;
	
	
	            var breadcrumbDisplay = function breadcrumbDisplay(token) {
	                switch (token) {
	                    case ':id':
	                        return company && company.label || agency && agency.company.label;
	                    case ':aid':
	                        return agency.ref;
	                    case ':cid':
	                        return campaign && campaign.title;
	                    default:
	                        return (0, _extract2.default)(_i18n2.default, token);
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Clients' }),
	                _react2.default.createElement(_CompanySearchBar2.default, null),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        _react2.default.createElement(_router.Breadcrumb, {
	                            history: history,
	                            routes: routes,
	                            params: params,
	                            display: breadcrumbDisplay }),
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CompanyLayout;
	}(_react.Component);
	
	CompanyLayout.propTypes = {};
	
	
	CompanyLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        company: state.company.company,
	        agency: state.company.agency.agency,
	        campaign: state.satisfaction.campaign.campaign
	    };
	})(CompanyLayout);
	
	exports.default = CompanyLayout;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _browser = __webpack_require__(54);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _form = __webpack_require__(15);
	
	var _SearchBar = __webpack_require__(509);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _models = __webpack_require__(112);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanySearchBar = function (_Component) {
	    _inherits(CompanySearchBar, _Component);
	
	    function CompanySearchBar() {
	        _classCallCheck(this, CompanySearchBar);
	
	        return _possibleConstructorReturn(this, (CompanySearchBar.__proto__ || Object.getPrototypeOf(CompanySearchBar)).apply(this, arguments));
	    }
	
	    _createClass(CompanySearchBar, [{
	        key: '_search',
	        value: function _search(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                criteria = _props.criteria,
	                location = _props.location;
	
	
	            if (event) {
	                event.preventDefault();
	            }
	
	            return dispatch((0, _actions.loadCompanyStream)(_extends({}, _actions.DEFAULT_COMPANY_QUERY, criteria))).then(function () {
	                if (location.pathname != 'companies') {
	                    return dispatch((0, _reactRouterRedux.push)('/companies'));
	                }
	            });
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props2 = this.props,
	                    dispatch = _props2.dispatch,
	                    criteria = _props2.criteria,
	                    location = _props2.location;
	
	
	                return dispatch((0, _actions.loadCompanyStream)(_extends({}, _actions.DEFAULT_COMPANY_QUERY, criteria))).then(function () {
	                    if (location.pathname != 'companies') {
	                        return dispatch((0, _reactRouterRedux.push)('/companies'));
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                criteria = _props3.criteria,
	                location = _props3.location;
	
	
	            return _react2.default.createElement(_SearchBar2.default, _extends({
	                placeholder: (0, _extract2.default)(_i18n2.default.searchStream, (0, _browser.mediaQuery)()),
	                onClick: function onClick(e) {
	                    return _this2._search(e);
	                },
	                onKeyPress: function onKeyPress(e) {
	                    return _this2._searchOnKeyPress(e);
	                }
	            }, form.fullText()));
	        }
	    }]);
	
	    return CompanySearchBar;
	}(_react.Component);
	
	CompanySearchBar.propTypes = {};
	
	
	CompanySearchBar = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.CompanyCriteria.schema,
	    action: _actions.COMPANY_CRITERIA_UPDATED
	})(CompanySearchBar);
	
	CompanySearchBar = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        criteria: state.company.criteria
	    };
	})(CompanySearchBar);
	
	exports.default = CompanySearchBar;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanyStats = __webpack_require__(2183);
	
	var _CompanyStats2 = _interopRequireDefault(_CompanyStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyStats = function (_Component) {
	    _inherits(CompanyStats, _Component);
	
	    function CompanyStats() {
	        _classCallCheck(this, CompanyStats);
	
	        return _possibleConstructorReturn(this, (CompanyStats.__proto__ || Object.getPrototypeOf(CompanyStats)).apply(this, arguments));
	    }
	
	    _createClass(CompanyStats, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                range = _props.range;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CompanyStats2.default.default },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    range.count,
	                    ' ',
	                    _i18n2.default.companies
	                )
	            );
	        }
	    }]);
	
	    return CompanyStats;
	}(_react.Component);
	
	CompanyStats.propTypes = {};
	
	
	CompanyStats = (0, _reactRedux.connect)(function (state) {
	    return {
	        range: state.company.range
	    };
	})(CompanyStats);
	
	exports.default = CompanyStats;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(46);
	
	var _CompanyCard = __webpack_require__(1088);
	
	var _CompanyCard2 = _interopRequireDefault(_CompanyCard);
	
	var _CompanyStream = __webpack_require__(2184);
	
	var _CompanyStream2 = _interopRequireDefault(_CompanyStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var CompanyStream = function (_Component) {
	    _inherits(CompanyStream, _Component);
	
	    function CompanyStream() {
	        _classCallCheck(this, CompanyStream);
	
	        return _possibleConstructorReturn(this, (CompanyStream.__proto__ || Object.getPrototypeOf(CompanyStream)).apply(this, arguments));
	    }
	
	    _createClass(CompanyStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadCompanyStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, company) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/companies/' + company.uid);
	            } else {
	                dispatch((0, _reactRouterRedux.push)('/companies/' + company.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (company) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: company.uid,
	                                sm: 6 },
	                            _react2.default.createElement(_CompanyCard2.default, {
	                                company: company,
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, company);
	                                } })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _CompanyStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true,
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return CompanyStream;
	}(_react.Component);
	
	CompanyStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	CompanyStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.company.stream,
	        range: state.company.range
	    };
	})(CompanyStream);
	
	exports.default = CompanyStream;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanyStream = __webpack_require__(1321);
	
	var _CompanyStream2 = _interopRequireDefault(_CompanyStream);
	
	var _CompanyStats = __webpack_require__(1320);
	
	var _CompanyStats2 = _interopRequireDefault(_CompanyStats);
	
	var _ReferenceCompanyModal = __webpack_require__(1330);
	
	var _ReferenceCompanyModal2 = _interopRequireDefault(_ReferenceCompanyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompanyStreamLayout = function (_Component) {
	    _inherits(CompanyStreamLayout, _Component);
	
	    function CompanyStreamLayout(props) {
	        _classCallCheck(this, CompanyStreamLayout);
	
	        var _this = _possibleConstructorReturn(this, (CompanyStreamLayout.__proto__ || Object.getPrototypeOf(CompanyStreamLayout)).call(this, props));
	
	        _this.state = {
	            opened: false
	        };
	        return _this;
	    }
	
	    _createClass(CompanyStreamLayout, [{
	        key: '_open',
	        value: function _open() {
	            this.setState({ opened: true });
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({ opened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _links = this.props._links;
	            var opened = this.state.opened;
	
	
	            var newCompanyBoxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.newCompany
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smPush: 8 },
	                        _react2.default.createElement(_CompanyStats2.default, null),
	                        _links.find((0, _links2.linkFinder)(_models.REFERENCE_COMPANY_CMD_TYPES)) && _react2.default.createElement(_Box2.default, {
	                            status: 'primary',
	                            header: newCompanyBoxTitle,
	                            help: '+',
	                            onClick: function onClick() {
	                                return _this2._open();
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8, smPull: 4 },
	                        _react2.default.createElement(_CompanyStream2.default, null)
	                    )
	                ),
	                _links.find((0, _links2.linkFinder)(_models.REFERENCE_COMPANY_CMD_TYPES)) && _react2.default.createElement(_ReferenceCompanyModal2.default, {
	                    show: opened,
	                    onHide: function onHide() {
	                        return _this2._close();
	                    } })
	            );
	        }
	    }]);
	
	    return CompanyStreamLayout;
	}(_react.Component);
	
	CompanyStreamLayout.propTypes = {};
	
	
	CompanyStreamLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        _links: state.company._links
	    };
	})(CompanyStreamLayout);
	
	exports.default = CompanyStreamLayout;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DeleteAgencyModal = __webpack_require__(2185);
	
	var _DeleteAgencyModal2 = _interopRequireDefault(_DeleteAgencyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteAgencyModal = function (_Component) {
	    _inherits(DeleteAgencyModal, _Component);
	
	    function DeleteAgencyModal() {
	        _classCallCheck(this, DeleteAgencyModal);
	
	        return _possibleConstructorReturn(this, (DeleteAgencyModal.__proto__ || Object.getPrototypeOf(DeleteAgencyModal)).apply(this, arguments));
	    }
	
	    _createClass(DeleteAgencyModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                agency = _props.agency,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendDeleteAgencyCmd)(agency.company.uid, agency.uid)).then(function () {
	                return Promise.all([dispatch((0, _actions.loadCompany)()), dispatch((0, _actions.loadAgencyStream)())]);
	            }).then(function () {
	                onHide();
	            }).then(function () {
	                dispatch((0, _router.push)('/*/' + agency.company.uid + '/agencies'));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                agency = _props2.agency,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'agency', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.delete
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DeleteAgencyModal2.default.text },
	                        _i18n2.default.deleteAgencyText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, agency)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return _this2._sendCmd(e);
	                                } },
	                            _i18n2.default.delete
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeleteAgencyModal;
	}(_react.Component);
	
	DeleteAgencyModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	DeleteAgencyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        agency: state.company.agency.agency
	    };
	})(DeleteAgencyModal);
	
	exports.default = DeleteAgencyModal;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DisableUserModal = __webpack_require__(2186);
	
	var _DisableUserModal2 = _interopRequireDefault(_DisableUserModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DisableUserModal = function (_Component) {
	    _inherits(DisableUserModal, _Component);
	
	    function DisableUserModal() {
	        _classCallCheck(this, DisableUserModal);
	
	        return _possibleConstructorReturn(this, (DisableUserModal.__proto__ || Object.getPrototypeOf(DisableUserModal)).apply(this, arguments));
	    }
	
	    _createClass(DisableUserModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendDisableUserCmd)(user.uid)).then(function () {
	                return Promise.all([dispatch((0, _actions.loadCompany)()), dispatch((0, _actions.loadUserStream)())]);
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                user = _props2.user,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'user', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.disable
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DisableUserModal2.default.text },
	                        _i18n2.default.disableUserText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, user)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return _this2._sendCmd(e);
	                                } },
	                            _i18n2.default.disable
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DisableUserModal;
	}(_react.Component);
	
	DisableUserModal.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	DisableUserModal = (0, _reactRedux.connect)()(DisableUserModal);
	
	exports.default = DisableUserModal;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _PatrimonyPicker = __webpack_require__(548);
	
	var _PatrimonyPicker2 = _interopRequireDefault(_PatrimonyPicker);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DowngradeExecutiveToPatrimonyManagerModal = function (_Component) {
	    _inherits(DowngradeExecutiveToPatrimonyManagerModal, _Component);
	
	    function DowngradeExecutiveToPatrimonyManagerModal() {
	        _classCallCheck(this, DowngradeExecutiveToPatrimonyManagerModal);
	
	        return _possibleConstructorReturn(this, (DowngradeExecutiveToPatrimonyManagerModal.__proto__ || Object.getPrototypeOf(DowngradeExecutiveToPatrimonyManagerModal)).apply(this, arguments));
	    }
	
	    _createClass(DowngradeExecutiveToPatrimonyManagerModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendDowngradeExecutiveToPatrimonyManagerCmd)(user.uid)).then(function () {
	                return dispatch((0, _actions.loadUserStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                company = _props2.company,
	                user = _props2.user,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'company', 'user', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    bsSize: 'large',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.downgradeExecutiveToPatrimonyManager
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_PatrimonyPicker2.default, _extends({ multi: true, split: true,
	                        company: company
	                    }, form.managedPatrimonies())),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DowngradeExecutiveToPatrimonyManagerModal;
	}(_react.Component);
	
	DowngradeExecutiveToPatrimonyManagerModal.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	DowngradeExecutiveToPatrimonyManagerModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.DowngradeExecutiveToPatrimonyManagerCmd.schema,
	    action: _actions.DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED
	})(DowngradeExecutiveToPatrimonyManagerModal);
	
	DowngradeExecutiveToPatrimonyManagerModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        company: state.company.company,
	        cmd: state.company.downgradeExecutiveToPatrimonyManagerCmd
	    };
	})(DowngradeExecutiveToPatrimonyManagerModal);
	
	exports.default = DowngradeExecutiveToPatrimonyManagerModal;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentifyCompanyPopover = function (_Component) {
	    _inherits(IdentifyCompanyPopover, _Component);
	
	    function IdentifyCompanyPopover() {
	        _classCallCheck(this, IdentifyCompanyPopover);
	
	        return _possibleConstructorReturn(this, (IdentifyCompanyPopover.__proto__ || Object.getPrototypeOf(IdentifyCompanyPopover)).apply(this, arguments));
	    }
	
	    _createClass(IdentifyCompanyPopover, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendIdentifyCompanyCmd)()).then(function () {
	                return dispatch((0, _actions.loadCompany)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                company = _props2.company,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'company', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.identifyCompany
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'siret',
	                        label: requiredLabel(_i18n2.default.siret)
	                    }, form.siretNumber()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return IdentifyCompanyPopover;
	}(_react.Component);
	
	IdentifyCompanyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	IdentifyCompanyPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.IdentifyCompanyCmd.schema,
	    action: _actions.IDENTIFY_COMPANY_CMD_UPDATED
	})(IdentifyCompanyPopover);
	
	IdentifyCompanyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.identifyCompanyCmd,
	        company: state.company.company
	    };
	})(IdentifyCompanyPopover);
	
	exports.default = IdentifyCompanyPopover;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(268);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OrganisationLayout = __webpack_require__(2187);
	
	var _OrganisationLayout2 = _interopRequireDefault(_OrganisationLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganisationLayout = function (_Component) {
	    _inherits(OrganisationLayout, _Component);
	
	    function OrganisationLayout() {
	        _classCallCheck(this, OrganisationLayout);
	
	        return _possibleConstructorReturn(this, (OrganisationLayout.__proto__ || Object.getPrototypeOf(OrganisationLayout)).apply(this, arguments));
	    }
	
	    _createClass(OrganisationLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                history = _props.history,
	                routes = _props.routes,
	                params = _props.params,
	                company = _props.company,
	                agency = _props.agency,
	                campaign = _props.campaign;
	
	
	            var breadcrumbDisplay = function breadcrumbDisplay(token) {
	                switch (token) {
	                    case ':id':
	                        return company && company.label || agency && agency.company.label;
	                    case ':aid':
	                        return agency.ref;
	                    case ':cid':
	                        return campaign.title;
	                    default:
	                        return (0, _extract2.default)(_i18n2.default, token);
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _OrganisationLayout2.default.default },
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Organisations' }),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        _react2.default.createElement(_router.Breadcrumb, {
	                            history: history,
	                            routes: routes,
	                            params: params,
	                            display: breadcrumbDisplay }),
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OrganisationLayout;
	}(_react.Component);
	
	OrganisationLayout.propTypes = {};
	
	
	OrganisationLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        company: state.company.company,
	        agency: state.company.agency.agency,
	        campaign: state.satisfaction.campaign.campaign
	    };
	})(OrganisationLayout);
	
	exports.default = OrganisationLayout;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReactiveCancelCompanyModal = __webpack_require__(2188);
	
	var _ReactiveCancelCompanyModal2 = _interopRequireDefault(_ReactiveCancelCompanyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactiveCancelCompanyModal = function (_Component) {
	    _inherits(ReactiveCancelCompanyModal, _Component);
	
	    function ReactiveCancelCompanyModal() {
	        _classCallCheck(this, ReactiveCancelCompanyModal);
	
	        return _possibleConstructorReturn(this, (ReactiveCancelCompanyModal.__proto__ || Object.getPrototypeOf(ReactiveCancelCompanyModal)).apply(this, arguments));
	    }
	
	    _createClass(ReactiveCancelCompanyModal, [{
	        key: '_sendReactiveCmd',
	        value: function _sendReactiveCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendReactiveCompanyCmd)()).then(function () {
	                return dispatch((0, _actions.loadCompany)());
	            }).then(function () {
	                return dispatch((0, _actions.loadCompanyStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_sendCancelCmd',
	        value: function _sendCancelCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendCancelCompanyCmd)()).then(function () {
	                return dispatch((0, _actions.loadCompany)());
	            }).then(function () {
	                return dispatch((0, _actions.loadCompanyStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                company = _props3.company,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'company', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        company.isActive && _i18n2.default.disable || _i18n2.default.enable
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ReactiveCancelCompanyModal2.default.text },
	                        company.isActive && _i18n2.default.disableCompanyText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, company)
	                            );
	                        }),
	                        !company.isActive && _i18n2.default.enableCompanyText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, company)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return company.isActive && _this2._sendCancelCmd() || _this2._sendReactiveCmd();
	                                } },
	                            company.isActive && _i18n2.default.disable || _i18n2.default.enable
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReactiveCancelCompanyModal;
	}(_react.Component);
	
	ReactiveCancelCompanyModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReactiveCancelCompanyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        company: state.company.company
	    };
	})(ReactiveCancelCompanyModal);
	
	exports.default = ReactiveCancelCompanyModal;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _places = __webpack_require__(261);
	
	var _phonez = __webpack_require__(40);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _MultiInput = __webpack_require__(277);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceAgencyPopover = function (_Component) {
	    _inherits(ReferenceAgencyPopover, _Component);
	
	    function ReferenceAgencyPopover() {
	        _classCallCheck(this, ReferenceAgencyPopover);
	
	        return _possibleConstructorReturn(this, (ReferenceAgencyPopover.__proto__ || Object.getPrototypeOf(ReferenceAgencyPopover)).apply(this, arguments));
	    }
	
	    _createClass(ReferenceAgencyPopover, [{
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendReferenceAgencyCmd)()).then(function () {
	                return Promise.all([dispatch((0, _actions.loadCompany)()), dispatch((0, _actions.loadAgencyStream)())]);
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var addressTypeaheadButton = function addressTypeaheadButton() {
	                if (cmd && cmd.agency && cmd.agency.address) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        (0, _form.buttonField)(form.agency.address(), null),
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.newAgency
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'reference',
	                        label: requiredLabel(_i18n2.default.reference)
	                    }, form.agency.ref())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'label',
	                        label: requiredLabel(_i18n2.default.label)
	                    }, form.agency.label())),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'email',
	                        label: _i18n2.default.email
	                    }, form.agency.emails())),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'phone',
	                        label: _i18n2.default.phone
	                    }, (0, _phonez.phonesField)(form.agency.phones()))),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'fax',
	                        label: _i18n2.default.fax
	                    }, (0, _phonez.phoneField)(form.agency.fax())))
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _i18n2.default.address
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                source: _places.autocompleteMatcher,
	                                display: _places.displayPrediction,
	                                highlight: _places.highlightPrediction,
	                                placeholder: _i18n2.default.addAddress,
	                                buttonAfter: addressTypeaheadButton()
	                            }, (0, _places.addressField)(form.agency.address())))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'number',
	                                placeholder: _i18n2.default.addressNumber
	                            }, form.agency.address.number()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'street',
	                                placeholder: _i18n2.default.addressStreet
	                            }, form.agency.address.street()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'zipCode',
	                                placeholder: _i18n2.default.addressZipCode
	                            }, form.agency.address.zipCode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'city',
	                                placeholder: _i18n2.default.addressCity
	                            }, form.agency.address.city()))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReferenceAgencyPopover;
	}(_react.Component);
	
	ReferenceAgencyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReferenceAgencyPopover = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.ReferenceAgencyCmd.schema,
	    action: _actions.REFERENCE_AGENCY_CMD_UPDATED
	})(ReferenceAgencyPopover);
	
	ReferenceAgencyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.referenceAgencyCmd
	    };
	})(ReferenceAgencyPopover);
	
	exports.default = ReferenceAgencyPopover;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _links2 = __webpack_require__(33);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _models = __webpack_require__(112);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanySelectInput = __webpack_require__(1089);
	
	var _CompanySelectInput2 = _interopRequireDefault(_CompanySelectInput);
	
	var _ReferenceCompanyModal = __webpack_require__(2189);
	
	var _ReferenceCompanyModal2 = _interopRequireDefault(_ReferenceCompanyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function restrict(allowed, value) {
	    if (value) return allowed.indexOf(value) >= 0 && value || allowed[0];
	    return allowed[0];
	}
	
	var ReferenceCompanyModal = function (_Component) {
	    _inherits(ReferenceCompanyModal, _Component);
	
	    function ReferenceCompanyModal(props) {
	        _classCallCheck(this, ReferenceCompanyModal);
	
	        var _this = _possibleConstructorReturn(this, (ReferenceCompanyModal.__proto__ || Object.getPrototypeOf(ReferenceCompanyModal)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ReferenceCompanyModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd,
	                _links = _props._links;
	
	
	            var commandTypes = _models.REFERENCE_COMPANY_CMD_TYPES.filter((0, _links2.relFilter)(_links));
	            this.setState({ commandTypes: commandTypes });
	
	            dispatch((0, _actions.updateReferenceCompanyCmd)({
	                commandType: restrict(commandTypes, cmd && cmd.commandType),
	                holdingReference: null
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps._links != this.props._links) {
	                var dispatch = nextProps.dispatch,
	                    cmd = nextProps.cmd,
	                    _links = nextProps._links;
	
	
	                var commandTypes = _models.REFERENCE_COMPANY_CMD_TYPES.filter((0, _links2.relFilter)(_links));
	                this.setState({ commandTypes: commandTypes });
	
	                dispatch((0, _actions.updateReferenceCompanyCmd)({
	                    commandType: restrict(commandTypes, cmd && cmd.commandType),
	                    holdingReference: null
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendReferenceCompanyCmd)()).then(function () {
	                return dispatch((0, _actions.loadCompanyStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                _links = _props3._links,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', '_links', 'onHide']);
	
	            var commandTypes = this.state.commandTypes;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var commandTypeField = function commandTypeField(field) {
	                function onChange(value) {
	                    if (value) {
	                        field.onChange(value);
	                    }
	                }
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.newCompany
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ReferenceCompanyModal2.default.companyCmdType },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xsHidden: true, sm: 3 },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    'type'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 9 },
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    commandTypeField(form.commandType()),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: _ReferenceCompanyModal2.default.container },
	                                        commandTypes.map(function (cmdType, index) {
	                                            return _react2.default.createElement(
	                                                'li',
	                                                {
	                                                    key: index },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        bsStyle: 'link',
	                                                        value: cmdType },
	                                                    _react2.default.createElement(_Icon2.default, {
	                                                        icon: cmdType.slice(6),
	                                                        size: 'md' }),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        (0, _extract2.default)(_i18n2.default.referenceCompanyCmdTypeEnum, cmdType)
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        form.billingType && _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'select',
	                                name: 'billingType',
	                                label: requiredLabel(_i18n2.default.billingType)
	                            }, form.billingType()),
	                            _models.BILLING_TYPES.map(function (billingType, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    {
	                                        key: index,
	                                        value: billingType },
	                                    (0, _extract2.default)(_i18n2.default.billingTypeEnum, billingType)
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'name',
	                            label: requiredLabel(_i18n2.default.label)
	                        }, form.label())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'siret',
	                            label: form.siretNumber.isRequired() && requiredLabel(_i18n2.default.siret) || _i18n2.default.siret
	                        }, form.siretNumber())),
	                        form.callCenterReference && _react2.default.createElement(_CompanySelectInput2.default, _extends({
	                            companyType: 'CallCenter',
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            name: 'callCenter',
	                            label: requiredLabel(_i18n2.default.callCenter)
	                        }, form.callCenterReference()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReferenceCompanyModal;
	}(_react.Component);
	
	ReferenceCompanyModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReferenceCompanyModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ReferenceCompanyCmd.selectSchema,
	    action: _actions.REFERENCE_COMPANY_CMD_UPDATED
	})(ReferenceCompanyModal);
	
	ReferenceCompanyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.referenceCompanyCmd,
	        _links: state.company._links
	    };
	})(ReferenceCompanyModal);
	
	exports.default = ReferenceCompanyModal;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CompanySelectInput = __webpack_require__(1089);
	
	var _CompanySelectInput2 = _interopRequireDefault(_CompanySelectInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceSubsidiaryPopover = function (_Component) {
	    _inherits(ReferenceSubsidiaryPopover, _Component);
	
	    function ReferenceSubsidiaryPopover() {
	        _classCallCheck(this, ReferenceSubsidiaryPopover);
	
	        return _possibleConstructorReturn(this, (ReferenceSubsidiaryPopover.__proto__ || Object.getPrototypeOf(ReferenceSubsidiaryPopover)).apply(this, arguments));
	    }
	
	    _createClass(ReferenceSubsidiaryPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company;
	
	
	            dispatch((0, _actions.updateReferenceCompanyCmd)({
	                commandType: 'CreateClientAccount',
	                holdingReference: company.uid
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.company != this.props.company) {
	                var dispatch = nextProps.dispatch,
	                    company = nextProps.company;
	
	
	                dispatch((0, _actions.updateReferenceCompanyCmd)({
	                    commandType: 'CreateClientAccount',
	                    holdingReference: company.uid
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendReferenceCompanyCmd)()).then(function () {
	                return Promise.all([dispatch((0, _actions.loadCompany)()), dispatch((0, _actions.loadSubsidiaryStream)())]);
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.newSubsidiary
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'name',
	                        label: requiredLabel(_i18n2.default.label)
	                    }, form.label())),
	                    _react2.default.createElement(_CompanySelectInput2.default, _extends({
	                        companyType: 'CallCenter',
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        name: 'callCenter',
	                        label: requiredLabel(_i18n2.default.callCenter)
	                    }, form.callCenterReference()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReferenceSubsidiaryPopover;
	}(_react.Component);
	
	ReferenceSubsidiaryPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReferenceSubsidiaryPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ReferenceCompanyCmd.selectSchema,
	    action: _actions.REFERENCE_COMPANY_CMD_UPDATED
	})(ReferenceSubsidiaryPopover);
	
	ReferenceSubsidiaryPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.referenceCompanyCmd,
	        company: state.company.company
	    };
	})(ReferenceSubsidiaryPopover);
	
	exports.default = ReferenceSubsidiaryPopover;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _wizard = __webpack_require__(513);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _PatrimonyPicker = __webpack_require__(548);
	
	var _PatrimonyPicker2 = _interopRequireDefault(_PatrimonyPicker);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReferenceUserPopover = __webpack_require__(2190);
	
	var _ReferenceUserPopover2 = _interopRequireDefault(_ReferenceUserPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WIZARD_STEPS = [1];
	var WIZARD_STEPS_PATRIMONY_MANAGER = [1, 2];
	
	var schemaCache = (0, _cache2.default)();
	
	function selectSchema(cmd, _ref) {
	    var wizard = _ref.wizard;
	
	    var schema = _models.ReferenceUserCmd.selectSchema(cmd);
	
	    return schemaCache([schema, wizard.activeStep], function () {
	        if (wizard.matchActiveStep(1) && cmd && cmd.commandType == 'ReferencePatrimonyManager') {
	            return _extends({}, schema, {
	                properties: {
	                    firstName: schema.properties.firstName,
	                    lastName: schema.properties.lastName,
	                    login: schema.properties.login,
	                    job: schema.properties.job,
	                    phone: schema.properties.phone,
	                    commandType: schema.properties.commandType
	                },
	                required: ['firstName', 'lastName', 'login', 'commandType']
	            });
	        }
	        return schema;
	    });
	}
	
	function selectSteps(_ref2) {
	    var cmd = _ref2.cmd;
	
	    switch (cmd && cmd.commandType) {
	        case 'ReferencePatrimonyManager':
	            return WIZARD_STEPS_PATRIMONY_MANAGER;
	        default:
	            return WIZARD_STEPS;
	    }
	}
	
	function restrict(allowed, value) {
	    if (value) return allowed.indexOf(value) >= 0 && value || allowed[0];
	    return allowed[0];
	}
	
	var ReferenceUserPopover = function (_Component) {
	    _inherits(ReferenceUserPopover, _Component);
	
	    function ReferenceUserPopover(props) {
	        _classCallCheck(this, ReferenceUserPopover);
	
	        var _this = _possibleConstructorReturn(this, (ReferenceUserPopover.__proto__ || Object.getPrototypeOf(ReferenceUserPopover)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ReferenceUserPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd,
	                company = _props.company,
	                companyUsers = _props.companyUsers;
	
	
	            var commandTypes = _models.REFERENCE_USER_CMD_TYPES.filter((0, _links.relFilter)(companyUsers._links));
	            var commandType = restrict(commandTypes, cmd && cmd.commandType);
	
	            this.setState({ commandTypes: commandTypes });
	
	            dispatch((0, _actions.updateReferenceUserCmd)({
	                commandType: commandType,
	                companyUid: company.uid
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.company != this.props.company || nextProps.companyUsers != this.props.companyUsers) {
	                var dispatch = nextProps.dispatch,
	                    cmd = nextProps.cmd,
	                    company = nextProps.company,
	                    companyUsers = nextProps.companyUsers;
	
	
	                var commandTypes = _models.REFERENCE_USER_CMD_TYPES.filter((0, _links.relFilter)(companyUsers._links));
	                this.setState({ commandTypes: commandTypes });
	
	                dispatch((0, _actions.updateReferenceUserCmd)({
	                    commandType: restrict(commandTypes, cmd && cmd.commandType),
	                    companyUid: company.uid
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendReferenceUserCmd)()).then(function () {
	                return Promise.all([dispatch((0, _actions.loadCompany)()), dispatch((0, _actions.loadUserStream)())]);
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                company = _props3.company,
	                companyAgencies = _props3.companyAgencies,
	                companyUsers = _props3.companyUsers,
	                wizard = _props3.wizard,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'company', 'companyAgencies', 'companyUsers', 'wizard', 'onHide']);
	
	            var commandTypes = this.state.commandTypes;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var commandTypeField = function commandTypeField(field) {
	                function onChange(value) {
	                    if (value) {
	                        field.onChange(value);
	                    }
	                }
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({ bsClass: 'popover-lg popover',
	                    title: _i18n2.default.newUser
	                }, others),
	                wizard.matchActiveStep(1) && _react2.default.createElement(
	                    'div',
	                    null,
	                    commandTypes.length > 1 && _react2.default.createElement(
	                        'div',
	                        { className: _ReferenceUserPopover2.default.cmdType },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xsHidden: true, sm: 3 },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    'type'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 9 },
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    commandTypeField(form.commandType()),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: _ReferenceUserPopover2.default.container },
	                                        commandTypes.map(function (cmdType, index) {
	                                            return _react2.default.createElement(
	                                                'li',
	                                                {
	                                                    key: index },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        bsStyle: 'link',
	                                                        value: cmdType },
	                                                    _react2.default.createElement(_Icon2.default, {
	                                                        icon: cmdType.slice(9),
	                                                        size: 'md' }),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        (0, _extract2.default)(_i18n2.default.referenceUserCmdTypeEnum, cmdType)
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'firstName',
	                            label: requiredLabel(_i18n2.default.firstName)
	                        }, form.firstName())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'lastName',
	                            label: requiredLabel(_i18n2.default.lastName)
	                        }, form.lastName())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'login',
	                            label: requiredLabel(_i18n2.default.login)
	                        }, form.login())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'job',
	                            label: _i18n2.default.job
	                        }, form.job())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'phone',
	                            label: _i18n2.default.phone
	                        }, (0, _phonez.phoneField)(form.phone()))),
	                        form.managedAgencies && _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({ multiple: true,
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'select',
	                                name: 'agency',
	                                label: requiredLabel(_i18n2.default.agency)
	                            }, (0, _form.selectField)(form.managedAgencies(), true)),
	                            companyAgencies.map(function (agency, index) {
	                                return _react2.default.createElement(
	                                    'option',
	                                    {
	                                        key: index,
	                                        value: agency.uid },
	                                    agency.label
	                                );
	                            })
	                        )
	                    )
	                ),
	                wizard.matchActiveStep(2) && _react2.default.createElement(
	                    'div',
	                    null,
	                    form.managedPatrimonies && _react2.default.createElement(_PatrimonyPicker2.default, _extends({ multi: true, split: true,
	                        company: company
	                    }, form.managedPatrimonies()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    !wizard.hasNextStep() && _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    wizard.hasPreviousStep() && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: function onClick(e) {
	                                return wizard.previousStep();
	                            } },
	                        'previous'
	                    ),
	                    wizard.hasNextStep() && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && (wizard.nextStep() || true) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        'next'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReferenceUserPopover;
	}(_react.Component);
	
	ReferenceUserPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReferenceUserPopover = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: selectSchema,
	    action: _actions.REFERENCE_USER_CMD_UPDATED
	})(ReferenceUserPopover);
	
	ReferenceUserPopover = (0, _wizard.connectWizard)({
	    steps: selectSteps
	})(ReferenceUserPopover);
	
	ReferenceUserPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.referenceUserCmd,
	        company: state.company.company,
	        companyAgencies: state.company.companyAgencies,
	        companyUsers: state.company.companyUsers
	    };
	})(ReferenceUserPopover);
	
	exports.default = ReferenceUserPopover;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubsidiaryPicker = function (_Component) {
	    _inherits(SubsidiaryPicker, _Component);
	
	    function SubsidiaryPicker() {
	        _classCallCheck(this, SubsidiaryPicker);
	
	        return _possibleConstructorReturn(this, (SubsidiaryPicker.__proto__ || Object.getPrototypeOf(SubsidiaryPicker)).apply(this, arguments));
	    }
	
	    _createClass(SubsidiaryPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                holding = _props.holding,
	                billingType = _props.billingType;
	
	
	            dispatch((0, _actions.querySubsidiaryStream)(_extends({}, _actions.DEFAULT_QUERY, { billingType: billingType, holdingUid: holding.uid, range: { offset: 0, limit: 99 } })));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.holding != this.props.holding || nextProps.billingType != this.props.billingType) {
	                var dispatch = nextProps.dispatch,
	                    holding = nextProps.holding,
	                    billingType = nextProps.billingType;
	
	                dispatch((0, _actions.querySubsidiaryStream)(_extends({}, _actions.DEFAULT_QUERY, { billingType: billingType, holdingUid: holding.uid, range: { offset: 0, limit: 99 } })));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                stream = _props2.stream,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'stream']);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Picker2.default, _extends({
	                    source: stream,
	                    identify: function identify(p) {
	                        return p.uid;
	                    },
	                    display: function display(p) {
	                        return p.label;
	                    }
	                }, others))
	            );
	        }
	    }]);
	
	    return SubsidiaryPicker;
	}(_react.Component);
	
	SubsidiaryPicker.propTypes = {
	    holding: _react.PropTypes.object,
	    billingType: _react.PropTypes.string
	};
	
	
	SubsidiaryPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.company.subsidiary.stream
	    };
	})(SubsidiaryPicker);
	
	exports.default = SubsidiaryPicker;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(46);
	
	var _CompanyCard = __webpack_require__(1088);
	
	var _CompanyCard2 = _interopRequireDefault(_CompanyCard);
	
	var _SubsidiaryStream = __webpack_require__(2191);
	
	var _SubsidiaryStream2 = _interopRequireDefault(_SubsidiaryStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var SubsidiaryStream = function (_Component) {
	    _inherits(SubsidiaryStream, _Component);
	
	    function SubsidiaryStream() {
	        _classCallCheck(this, SubsidiaryStream);
	
	        return _possibleConstructorReturn(this, (SubsidiaryStream.__proto__ || Object.getPrototypeOf(SubsidiaryStream)).apply(this, arguments));
	    }
	
	    _createClass(SubsidiaryStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadSubsidiaryStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, company) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _router.push)('/*/' + company.uid));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (subsidiary) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: subsidiary.uid,
	                                sm: 4 },
	                            _react2.default.createElement(_CompanyCard2.default, {
	                                company: subsidiary,
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, subsidiary);
	                                } })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _SubsidiaryStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true,
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return SubsidiaryStream;
	}(_react.Component);
	
	SubsidiaryStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	SubsidiaryStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.company.subsidiary.stream,
	        range: state.company.subsidiary.range
	    };
	})(SubsidiaryStream);
	
	exports.default = SubsidiaryStream;

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _places = __webpack_require__(261);
	
	var _links2 = __webpack_require__(33);
	
	var _phonez = __webpack_require__(40);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _MultiInput = __webpack_require__(277);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateAgencyPopover = __webpack_require__(2192);
	
	var _UpdateAgencyPopover2 = _interopRequireDefault(_UpdateAgencyPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateAgencyPopover = function (_Component) {
	    _inherits(UpdateAgencyPopover, _Component);
	
	    function UpdateAgencyPopover() {
	        _classCallCheck(this, UpdateAgencyPopover);
	
	        return _possibleConstructorReturn(this, (UpdateAgencyPopover.__proto__ || Object.getPrototypeOf(UpdateAgencyPopover)).apply(this, arguments));
	    }
	
	    _createClass(UpdateAgencyPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                agency = _props.agency;
	
	            var _links = agency._links,
	                agencyUpdate = _objectWithoutProperties(agency, ['_links']);
	
	            dispatch((0, _actions.updateUpdateAgencyCmd)({
	                agency: agencyUpdate
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.agency != this.props.agency) {
	                var dispatch = nextProps.dispatch,
	                    agency = nextProps.agency;
	
	                var _links = agency._links,
	                    agencyUpdate = _objectWithoutProperties(agency, ['_links']);
	
	                dispatch((0, _actions.updateUpdateAgencyCmd)({
	                    agency: agencyUpdate
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdateAgencyCmd)()).then(function () {
	                return dispatch((0, _actions.loadAgency)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                agency = _props3.agency,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'agency', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var addressTypeaheadButton = function addressTypeaheadButton() {
	                if (cmd && cmd.agency && cmd.agency.address) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        (0, _form.buttonField)(form.agency.address(), null),
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.updateAgency
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'reference',
	                        label: requiredLabel(_i18n2.default.reference)
	                    }, form.agency.ref())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'label',
	                        label: requiredLabel(_i18n2.default.label)
	                    }, form.agency.label())),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'email',
	                        label: _i18n2.default.email
	                    }, form.agency.emails())),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'phone',
	                        label: _i18n2.default.phone
	                    }, (0, _phonez.phonesField)(form.agency.phones()))),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'fax',
	                        label: _i18n2.default.fax
	                    }, (0, _phonez.phoneField)(form.agency.fax())))
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _i18n2.default.address
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                source: _places.autocompleteMatcher,
	                                display: _places.displayPrediction,
	                                highlight: _places.highlightPrediction,
	                                placeholder: _i18n2.default.addAddress,
	                                buttonAfter: addressTypeaheadButton()
	                            }, (0, _places.addressField)(form.agency.address())))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'number',
	                                placeholder: _i18n2.default.addressNumber
	                            }, form.agency.address.number()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'street',
	                                placeholder: _i18n2.default.addressStreet
	                            }, form.agency.address.street()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'zipCode',
	                                placeholder: _i18n2.default.addressZipCode
	                            }, form.agency.address.zipCode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'city',
	                                placeholder: _i18n2.default.addressCity
	                            }, form.agency.address.city()))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                ),
	                agency._links.find((0, _links2.linkFinder)('DeleteAgency')) && _react2.default.createElement(
	                    'div',
	                    { className: _UpdateAgencyPopover2.default.delete },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return onHide(e, 'DELETE');
	                            } },
	                        _i18n2.default.deleteAgency
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateAgencyPopover;
	}(_react.Component);
	
	UpdateAgencyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateAgencyPopover = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.UpdateAgencyCmd.schema,
	    action: _actions.UPDATE_AGENCY_CMD_UPDATED
	})(UpdateAgencyPopover);
	
	UpdateAgencyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.updateAgencyCmd,
	        agency: state.company.agency.agency
	    };
	})(UpdateAgencyPopover);
	
	exports.default = UpdateAgencyPopover;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _links = __webpack_require__(33);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateCompanyPopover = __webpack_require__(2193);
	
	var _UpdateCompanyPopover2 = _interopRequireDefault(_UpdateCompanyPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateCompanyPopover = function (_Component) {
	    _inherits(UpdateCompanyPopover, _Component);
	
	    function UpdateCompanyPopover() {
	        _classCallCheck(this, UpdateCompanyPopover);
	
	        return _possibleConstructorReturn(this, (UpdateCompanyPopover.__proto__ || Object.getPrototypeOf(UpdateCompanyPopover)).apply(this, arguments));
	    }
	
	    _createClass(UpdateCompanyPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company;
	
	
	            var commandType = _models.UPDATE_COMPANY_CMD_TYPES.find((0, _links.relFinder)(company._links));
	            dispatch((0, _actions.updateUpdateCompanyCmd)({
	                commandType: commandType,
	                holdingReference: company.holding && company.holding.uid,
	                label: company.label
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.company != this.props.company) {
	                var dispatch = nextProps.dispatch,
	                    company = nextProps.company;
	
	
	                var commandType = _models.UPDATE_COMPANY_CMD_TYPES.find((0, _links.relFinder)(company._links));
	                dispatch((0, _actions.updateUpdateCompanyCmd)({
	                    commandType: commandType,
	                    holdingReference: company.holding && company.holding.uid,
	                    label: company.label
	                }));
	            }
	        }
	    }, {
	        key: '_sendUpdateCmd',
	        value: function _sendUpdateCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdateCompanyCmd)()).then(function () {
	                return dispatch((0, _actions.loadCompany)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                company = _props3.company,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'company', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.updateCompany
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'name',
	                        label: requiredLabel(_i18n2.default.label)
	                    }, form.label()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendUpdateCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                ),
	                company._links.find((0, _links.linkFinder)(['ReactiveCompany', 'CancelCompany'])) && _react2.default.createElement(
	                    'div',
	                    { className: _UpdateCompanyPopover2.default.action },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return onHide(e, company.isActive && 'CancelCompany' || 'ReactiveCompany');
	                            } },
	                        company.isActive && _i18n2.default.disableCompany || _i18n2.default.enableCompany
	                    )
	                ),
	                company._links.find((0, _links.linkFinder)(['UpgradeCompanyToPremiumAccount', 'DowngradePremiumAccount'])) && _react2.default.createElement(
	                    'div',
	                    { className: _UpdateCompanyPopover2.default.action },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return onHide(e, company.billingType == 'PremiumAccount' && 'DowngradePremiumAccount' || 'UpgradeCompanyToPremiumAccount');
	                            } },
	                        company.billingType == 'PremiumAccount' && _i18n2.default.downgradePremiumAccount || _i18n2.default.upgradePremiumAccount
	                    )
	                ),
	                company._links.find((0, _links.linkFinder)('UpgradeCompanyToStandardAccount')) && _react2.default.createElement(
	                    'div',
	                    { className: _UpdateCompanyPopover2.default.action },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return onHide(e, company.billingType != 'StandardAccount' && 'UpgradeCompanyToStandardAccount');
	                            } },
	                        company.billingType != 'StandardAccount' && _i18n2.default.upgradeStandardAccount
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateCompanyPopover;
	}(_react.Component);
	
	UpdateCompanyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateCompanyPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.UpdateCompanyCmd.schema,
	    action: _actions.UPDATE_COMPANY_CMD_UPDATED
	})(UpdateCompanyPopover);
	
	UpdateCompanyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.updateCompanyCmd,
	        company: state.company.company
	    };
	})(UpdateCompanyPopover);
	
	exports.default = UpdateCompanyPopover;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _links = __webpack_require__(33);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateLoginModal = __webpack_require__(2194);
	
	var _UpdateLoginModal2 = _interopRequireDefault(_UpdateLoginModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateLoginModal = function (_Component) {
	    _inherits(UpdateLoginModal, _Component);
	
	    function UpdateLoginModal() {
	        _classCallCheck(this, UpdateLoginModal);
	
	        return _possibleConstructorReturn(this, (UpdateLoginModal.__proto__ || Object.getPrototypeOf(UpdateLoginModal)).apply(this, arguments));
	    }
	
	    _createClass(UpdateLoginModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user;
	
	
	            dispatch((0, _actions.updateUpdateLoginCmd)({
	                uid: user.uid,
	                login: user.login
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.user != this.props.user) {
	                var dispatch = nextProps.dispatch,
	                    user = nextProps.user;
	
	
	                dispatch((0, _actions.updateUpdateLoginCmd)({
	                    uid: user.uid,
	                    login: user.login
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdateLoginCmd)()).then(function () {
	                return dispatch((0, _actions.loadUserStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_sendDemand',
	        value: function _sendDemand(event) {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                user = _props3.user,
	                onHide = _props3.onHide;
	
	
	            event.preventDefault();
	            return dispatch((0, _actions.sendSendActivationEmailDemand)(user.uid)).then(function () {
	                return dispatch((0, _status.infoStatus)(_i18n2.default.activationEmailSent));
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                cmd = _props4.cmd,
	                user = _props4.user,
	                onHide = _props4.onHide,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'cmd', 'user', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.updateLogin
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    user._links.find((0, _links.linkFinder)('UpdateLogin')) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'form-horizontal' },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'login',
	                                label: requiredLabel(_i18n2.default.login)
	                            }, form.login()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                    onClick: function onClick() {
	                                        return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _i18n2.default.save
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    ),
	                    user._links.find((0, _links.linkFinder)('sendActivationEmailDemand')) && _react2.default.createElement(
	                        'div',
	                        { className: _UpdateLoginModal2.default.send },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._sendDemand(e);
	                                } },
	                            _i18n2.default.sendActivationEmail
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateLoginModal;
	}(_react.Component);
	
	UpdateLoginModal.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateLoginModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.UpdateLoginCmd.schema,
	    action: _actions.UPDATE_LOGIN_CMD_UPDATED
	})(UpdateLoginModal);
	
	UpdateLoginModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.updateLoginCmd
	    };
	})(UpdateLoginModal);
	
	exports.default = UpdateLoginModal;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _phonez = __webpack_require__(40);
	
	var _links = __webpack_require__(33);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(153);
	
	var _actions2 = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateUserModal = __webpack_require__(2195);
	
	var _UpdateUserModal2 = _interopRequireDefault(_UpdateUserModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function userCmdUpdate(user) {
	    return {
	        uid: user.uid || null,
	        firstName: user.firstName || null,
	        lastName: user.lastName || null,
	        job: user.job || null,
	        phone: user.phone || null
	    };
	}
	
	var UpdateUserModal = function (_Component) {
	    _inherits(UpdateUserModal, _Component);
	
	    function UpdateUserModal() {
	        _classCallCheck(this, UpdateUserModal);
	
	        return _possibleConstructorReturn(this, (UpdateUserModal.__proto__ || Object.getPrototypeOf(UpdateUserModal)).apply(this, arguments));
	    }
	
	    _createClass(UpdateUserModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user;
	
	            var update = userCmdUpdate(user);
	
	            dispatch((0, _actions2.updateUpdateUserCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.user != this.props.user) {
	                var dispatch = nextProps.dispatch,
	                    user = nextProps.user;
	
	                var update = userCmdUpdate(user);
	
	                dispatch((0, _actions2.updateUpdateUserCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide,
	                user = _props2.user,
	                authenticated = _props2.authenticated;
	
	
	            return dispatch((0, _actions2.sendUpdateUserCmd)()).then(function () {
	                return dispatch((0, _actions2.loadUserStream)());
	            }).then(function () {
	                if (user.uid == authenticated.uid) {
	                    return dispatch((0, _actions.loadAuthenticatedUser)());
	                }
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                user = _props3.user,
	                authenticated = _props3.authenticated,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'user', 'authenticated', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.updateUser
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    user._links.find((0, _links.linkFinder)('UpdateUser')) && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'form-horizontal' },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'firstName',
	                                label: requiredLabel(_i18n2.default.firstName)
	                            }, form.firstName())),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'lastName',
	                                label: requiredLabel(_i18n2.default.lastName)
	                            }, form.lastName())),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'job',
	                                label: _i18n2.default.job
	                            }, form.job())),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'phone',
	                                label: _i18n2.default.phone
	                            }, (0, _phonez.phoneField)(form.phone())))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                    onClick: function onClick() {
	                                        return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _i18n2.default.save
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    ),
	                    user._links.find((0, _links.linkFinder)('DisableUser')) && _react2.default.createElement(
	                        'div',
	                        { className: _UpdateUserModal2.default.disable },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onHide(e, 'DisableUser');
	                                } },
	                            _i18n2.default.disableUser
	                        )
	                    ),
	                    user._links.find((0, _links.linkFinder)('DowngradeExecutiveToPatrimonyManager')) && _react2.default.createElement(
	                        'div',
	                        { className: _UpdateUserModal2.default.disable },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onHide(e, 'DowngradeExecutiveToPatrimonyManager');
	                                } },
	                            _i18n2.default.downgradeExecutiveToPatrimonyManager + ' ...'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateUserModal;
	}(_react.Component);
	
	UpdateUserModal.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateUserModal = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.UpdateUserCmd.schema,
	    action: _actions2.UPDATE_USER_CMD_UPDATED
	})(UpdateUserModal);
	
	UpdateUserModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.updateUserCmd,
	        authenticated: state.user.authenticated
	    };
	})(UpdateUserModal);
	
	exports.default = UpdateUserModal;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpgradeDowngradePremiumAccountModal = __webpack_require__(2196);
	
	var _UpgradeDowngradePremiumAccountModal2 = _interopRequireDefault(_UpgradeDowngradePremiumAccountModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpgradeDowngradePremiumAccountModal = function (_Component) {
	    _inherits(UpgradeDowngradePremiumAccountModal, _Component);
	
	    function UpgradeDowngradePremiumAccountModal() {
	        _classCallCheck(this, UpgradeDowngradePremiumAccountModal);
	
	        return _possibleConstructorReturn(this, (UpgradeDowngradePremiumAccountModal.__proto__ || Object.getPrototypeOf(UpgradeDowngradePremiumAccountModal)).apply(this, arguments));
	    }
	
	    _createClass(UpgradeDowngradePremiumAccountModal, [{
	        key: '_sendUpgradeCmd',
	        value: function _sendUpgradeCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendUpgradeCompanyToPremiumAccountCmd)()).then(function () {
	                return dispatch((0, _actions.loadCompany)());
	            }).then(function () {
	                return dispatch((0, _actions.loadCompanyStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_sendDowngradeCmd',
	        value: function _sendDowngradeCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendDowngradePremiumAccountCmd)()).then(function () {
	                return dispatch((0, _actions.loadCompany)());
	            }).then(function () {
	                return dispatch((0, _actions.loadCompanyStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                company = _props3.company,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'company', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        company.billingType == 'PremiumAccount' && _i18n2.default.downgrade || _i18n2.default.upgrade
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UpgradeDowngradePremiumAccountModal2.default.text },
	                        company.billingType == 'PremiumAccount' && _i18n2.default.downgradePremiumAccountText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, company)
	                            );
	                        }),
	                        company.billingType != 'PremiumAccount' && _i18n2.default.upgradePremiumAccountText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, company)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return company.billingType == 'PremiumAccount' && _this2._sendDowngradeCmd() || _this2._sendUpgradeCmd();
	                                } },
	                            company.billingType == 'PremiumAccount' && _i18n2.default.downgrade || _i18n2.default.upgrade
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpgradeDowngradePremiumAccountModal;
	}(_react.Component);
	
	UpgradeDowngradePremiumAccountModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpgradeDowngradePremiumAccountModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        company: state.company.company
	    };
	})(UpgradeDowngradePremiumAccountModal);
	
	exports.default = UpgradeDowngradePremiumAccountModal;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpgradeDowngradeStandardAccountModal = __webpack_require__(2197);
	
	var _UpgradeDowngradeStandardAccountModal2 = _interopRequireDefault(_UpgradeDowngradeStandardAccountModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpgradeDowngradeStandardAccountModal = function (_Component) {
	    _inherits(UpgradeDowngradeStandardAccountModal, _Component);
	
	    function UpgradeDowngradeStandardAccountModal() {
	        _classCallCheck(this, UpgradeDowngradeStandardAccountModal);
	
	        return _possibleConstructorReturn(this, (UpgradeDowngradeStandardAccountModal.__proto__ || Object.getPrototypeOf(UpgradeDowngradeStandardAccountModal)).apply(this, arguments));
	    }
	
	    _createClass(UpgradeDowngradeStandardAccountModal, [{
	        key: '_sendUpgradeCmd',
	        value: function _sendUpgradeCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company,
	                onHide = _props.onHide;
	
	
	            return Promise.resolve(company.billingType != 'StandardAccount' && !company.siretNumber && dispatch((0, _actions.sendIdentifyCompanyCmd)())).then(function () {
	                return dispatch((0, _actions.sendUpgradeCompanyToStandardAccountCmd)());
	            }).then(function () {
	                return dispatch((0, _actions.loadCompany)());
	            }).then(function () {
	                return dispatch((0, _actions.loadCompanyStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                company = _props2.company,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'company', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        company.billingType == 'StandardAccount' && _i18n2.default.downgrade || _i18n2.default.upgrade
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UpgradeDowngradeStandardAccountModal2.default.defaultContent },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _UpgradeDowngradeStandardAccountModal2.default.text },
	                            company.billingType != 'StandardAccount' && _i18n2.default.upgradeStandardAccountText.map(function (text, index) {
	                                return _react2.default.createElement(
	                                    'p',
	                                    { key: index },
	                                    (0, _extract.replace)(text, company)
	                                );
	                            })
	                        ),
	                        company.billingType != 'StandardAccount' && !company.siretNumber && _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'siret',
	                                placeholder: _i18n2.default.siret + ' *'
	                            }, form.siretNumber()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'danger',
	                                    bsSize: 'large',
	                                    disabled: company.billingType != 'StandardAccount' && !company.siretNumber && !form.isValid(),
	                                    onClick: function onClick() {
	                                        return company.billingType != 'StandardAccount' && _this2._sendUpgradeCmd();
	                                    } },
	                                company.billingType == 'StandardAccount' && _i18n2.default.downgrade || _i18n2.default.upgrade
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpgradeDowngradeStandardAccountModal;
	}(_react.Component);
	
	UpgradeDowngradeStandardAccountModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpgradeDowngradeStandardAccountModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.IdentifyCompanyCmd.schema,
	    action: _actions.IDENTIFY_COMPANY_CMD_UPDATED
	})(UpgradeDowngradeStandardAccountModal);
	
	UpgradeDowngradeStandardAccountModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.company.identifyCompanyCmd,
	        company: state.company.company
	    };
	})(UpgradeDowngradeStandardAccountModal);
	
	exports.default = UpgradeDowngradeStandardAccountModal;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UserCard = __webpack_require__(2198);
	
	var _UserCard2 = _interopRequireDefault(_UserCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserCard = function (_Component) {
	    _inherits(UserCard, _Component);
	
	    function UserCard() {
	        _classCallCheck(this, UserCard);
	
	        return _possibleConstructorReturn(this, (UserCard.__proto__ || Object.getPrototypeOf(UserCard)).apply(this, arguments));
	    }
	
	    _createClass(UserCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                onSubmit = _props.onSubmit,
	                others = _objectWithoutProperties(_props, ['user', 'onSubmit']);
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            var header = _react2.default.createElement(
	                'div',
	                { className: _UserCard2.default.header },
	                _react2.default.createElement(
	                    'div',
	                    { className: _UserCard2.default.action },
	                    user._links.find((0, _links.linkFinder)(['UpdateLogin', 'sendActivationEmailDemand'])) && _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.updateLogin) },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'UpdateLogin');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'mailGear', size: 'xs' })
	                        )
	                    ),
	                    user._links.find((0, _links.linkFinder)(['AssociateUserWithAgency', 'DissociateUserFromAgency'])) && _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.associateDissociateAgencies) },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'AssociateDissociateUserFromAgency');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'agencyRefresh', size: 'xs' })
	                        )
	                    ),
	                    user._links.find((0, _links.linkFinder)(['AssociateUserWithPatrimony', 'DissociateUserFromPatrimony'])) && _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.associateDissociatePatrimonies) },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'AssociateDissociateUserFromPatrimony');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'patrimonyGear', size: 'xs' })
	                        )
	                    ),
	                    user._links.find((0, _links.linkFinder)('configs')) && _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.configs) },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'configs');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'gear', size: 'xs' })
	                        )
	                    ),
	                    user._links.find((0, _links.linkFinder)(['UpdateUser', 'DisableUser', 'DowngradeExecutiveToPatrimonyManager'])) && _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.updateUser) },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'UpdateUser');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _UserCard2.default.container },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        (0, _extract2.default)(_i18n2.default.userTypeEnum, user.userType)
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _UserCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true,
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    !user.isActive && _react2.default.createElement(
	                        'div',
	                        { className: _UserCard2.default.status },
	                        _react2.default.createElement(_Icon2.default, { icon: 'closed', size: 'sm' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UserCard2.default.label },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            '> ',
	                            user.firstName,
	                            ' ',
	                            user.lastName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UserCard2.default.label },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            '> ',
	                            _i18n2.default.email,
	                            ' ',
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                user.login
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserCard;
	}(_react.Component);
	
	UserCard.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	exports.default = UserCard;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserConfigsModal = function (_Component) {
	    _inherits(UserConfigsModal, _Component);
	
	    function UserConfigsModal() {
	        _classCallCheck(this, UserConfigsModal);
	
	        return _possibleConstructorReturn(this, (UserConfigsModal.__proto__ || Object.getPrototypeOf(UserConfigsModal)).apply(this, arguments));
	    }
	
	    _createClass(UserConfigsModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user;
	
	            dispatch((0, _actions.queryUserConfigs)(user.uid));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.user != this.props.user || nextProps.show && nextProps.show != this.props.show) {
	                var dispatch = nextProps.dispatch,
	                    user = nextProps.user;
	
	                dispatch((0, _actions.queryUserConfigs)(user.uid));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                user = _props2.user,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUserConfigs)(user.uid)).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                user = _props3.user,
	                userConfigs = _props3.userConfigs,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'user', 'userConfigs', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.configs
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        userConfigs.ticketOpenedNotifications !== undefined && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'checkbox',
	                            name: 'ticketOpenedNotifications',
	                            label: _i18n2.default.ticketOpenedNotifications
	                        }, (0, _form.checkboxField)(form.ticketOpenedNotifications()))),
	                        userConfigs.daybookNotifications !== undefined && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'checkbox',
	                            name: 'daybookNotifications',
	                            label: _i18n2.default.daybookNotifications
	                        }, (0, _form.checkboxField)(form.daybookNotifications()))),
	                        userConfigs.simplifiedRequestOpenedNotifications !== undefined && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'checkbox',
	                            name: 'simplifiedRequestOpenedNotifications',
	                            label: _i18n2.default.simplifiedRequestOpenedNotifications
	                        }, (0, _form.checkboxField)(form.simplifiedRequestOpenedNotifications())))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserConfigsModal;
	}(_react.Component);
	
	UserConfigsModal.propTypes = {
	    user: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UserConfigsModal = (0, _form.connectForm)({
	    target: 'userConfigs',
	    schema: _models.UserConfigs.schema,
	    action: _actions.USER_CONFIGS_UPDATED
	})(UserConfigsModal);
	
	UserConfigsModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        userConfigs: state.company.user.userConfigs
	    };
	})(UserConfigsModal);
	
	exports.default = UserConfigsModal;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _actions = __webpack_require__(46);
	
	var _models = __webpack_require__(112);
	
	var _i18n = __webpack_require__(48);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UserSearch = __webpack_require__(2199);
	
	var _UserSearch2 = _interopRequireDefault(_UserSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSearch = function (_Component) {
	    _inherits(UserSearch, _Component);
	
	    function UserSearch() {
	        _classCallCheck(this, UserSearch);
	
	        return _possibleConstructorReturn(this, (UserSearch.__proto__ || Object.getPrototypeOf(UserSearch)).apply(this, arguments));
	    }
	
	    _createClass(UserSearch, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                criteria = _props.criteria;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _UserSearch2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _UserSearch2.default.side },
	                    _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        form.active(),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                value: true },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _i18n2.default.userActive
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '|'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                value: false },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _i18n2.default.userInactive
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserSearch;
	}(_react.Component);
	
	UserSearch.propTypes = {};
	
	
	UserSearch = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.UserCriteria.schema,
	    action: _actions.USER_CRITERIA_UPDATED
	})(UserSearch);
	
	UserSearch = (0, _reactRedux.connect)(function (state) {
	    return {
	        criteria: state.company.user.criteria
	    };
	})(UserSearch);
	
	exports.default = UserSearch;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _browser = __webpack_require__(54);
	
	var _links = __webpack_require__(33);
	
	var _actions = __webpack_require__(46);
	
	var _UserCard = __webpack_require__(1341);
	
	var _UserCard2 = _interopRequireDefault(_UserCard);
	
	var _UpdateUserModal = __webpack_require__(1338);
	
	var _UpdateUserModal2 = _interopRequireDefault(_UpdateUserModal);
	
	var _UpdateLoginModal = __webpack_require__(1337);
	
	var _UpdateLoginModal2 = _interopRequireDefault(_UpdateLoginModal);
	
	var _AssociateDissociateUserFromAgencyModal = __webpack_require__(1313);
	
	var _AssociateDissociateUserFromAgencyModal2 = _interopRequireDefault(_AssociateDissociateUserFromAgencyModal);
	
	var _AssociateDissociateUserFromPatrimonyModal = __webpack_require__(1314);
	
	var _AssociateDissociateUserFromPatrimonyModal2 = _interopRequireDefault(_AssociateDissociateUserFromPatrimonyModal);
	
	var _DisableUserModal = __webpack_require__(1324);
	
	var _DisableUserModal2 = _interopRequireDefault(_DisableUserModal);
	
	var _DowngradeExecutiveToPatrimonyManagerModal = __webpack_require__(1325);
	
	var _DowngradeExecutiveToPatrimonyManagerModal2 = _interopRequireDefault(_DowngradeExecutiveToPatrimonyManagerModal);
	
	var _UserConfigsModal = __webpack_require__(1342);
	
	var _UserConfigsModal2 = _interopRequireDefault(_UserConfigsModal);
	
	var _UserStream = __webpack_require__(2200);
	
	var _UserStream2 = _interopRequireDefault(_UserStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	function modalName(result) {
	    switch (result) {
	        case 'configs':
	            return 'UserConfigsModal';
	        case 'UpdateUser':
	            return 'UpdateUserModal';
	        case 'UpdateLogin':
	            return 'UpdateLoginModal';
	        case 'AssociateDissociateUserFromAgency':
	            return 'AssociateDissociateUserFromAgencyModal';
	        case 'AssociateDissociateUserFromPatrimony':
	            return 'AssociateDissociateUserFromPatrimonyModal';
	        case 'DisableUser':
	            return 'DisableUserModal';
	        case 'DowngradeExecutiveToPatrimonyManager':
	            return 'DowngradeExecutiveToPatrimonyManagerModal';
	        default:
	            return null;
	    }
	}
	
	var UserStream = function (_Component) {
	    _inherits(UserStream, _Component);
	
	    function UserStream(props) {
	        _classCallCheck(this, UserStream);
	
	        var _this = _possibleConstructorReturn(this, (UserStream.__proto__ || Object.getPrototypeOf(UserStream)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(UserStream, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.stream != this.props.stream) {
	                var stream = nextProps.stream;
	                var activeUser = this.state.activeUser;
	
	
	                var nextActiveUser = stream.find(function (u) {
	                    return u.uid == (activeUser && activeUser.uid);
	                });
	                this.setState({ activeUser: nextActiveUser });
	            }
	        }
	    }, {
	        key: '_open',
	        value: function _open(event, result, activeUser) {
	            event.preventDefault();
	
	            var opened = modalName(result);
	            this.setState({ opened: opened, activeUser: activeUser });
	        }
	    }, {
	        key: '_close',
	        value: function _close(event, result) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            var opened = modalName(result);
	            this.setState({ opened: opened });
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadUserStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stream = _props.stream,
	                range = _props.range;
	            var _state = this.state,
	                opened = _state.opened,
	                activeUser = _state.activeUser;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (user) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: user.uid,
	                                sm: 4 },
	                            _react2.default.createElement(_UserCard2.default, {
	                                user: user,
	                                onSubmit: function onSubmit(e, r) {
	                                    return _this2._open(e, r, user);
	                                } })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _UserStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true,
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        } })
	                ),
	                activeUser && activeUser._links.find((0, _links.linkFinder)('configs')) && _react2.default.createElement(_UserConfigsModal2.default, {
	                    show: opened == 'UserConfigsModal',
	                    onHide: function onHide(e, r) {
	                        return _this2._close(e, r);
	                    },
	                    user: activeUser }),
	                activeUser && activeUser._links.find((0, _links.linkFinder)(['UpdateUser', 'DisableUser', 'DowngradeExecutiveToPatrimonyManager'])) && _react2.default.createElement(_UpdateUserModal2.default, {
	                    show: opened == 'UpdateUserModal',
	                    onHide: function onHide(e, r) {
	                        return _this2._close(e, r);
	                    },
	                    user: activeUser }),
	                activeUser && activeUser._links.find((0, _links.linkFinder)(['UpdateLogin', 'sendActivationEmailDemand'])) && _react2.default.createElement(_UpdateLoginModal2.default, {
	                    show: opened == 'UpdateLoginModal',
	                    onHide: function onHide(e, r) {
	                        return _this2._close(e, r);
	                    },
	                    user: activeUser }),
	                activeUser && activeUser._links.find((0, _links.linkFinder)('DisableUser')) && _react2.default.createElement(_DisableUserModal2.default, {
	                    show: opened == 'DisableUserModal',
	                    onHide: function onHide(e, r) {
	                        return _this2._close(e, r);
	                    },
	                    user: activeUser }),
	                activeUser && activeUser._links.find((0, _links.linkFinder)(['AssociateUserWithAgency', 'DissociateUserFromAgency'])) && _react2.default.createElement(_AssociateDissociateUserFromAgencyModal2.default, {
	                    show: opened == 'AssociateDissociateUserFromAgencyModal',
	                    onHide: function onHide(e, r) {
	                        return _this2._close(e, r);
	                    },
	                    user: activeUser }),
	                activeUser && activeUser._links.find((0, _links.linkFinder)(['AssociateUserWithPatrimony', 'DissociateUserFromPatrimony'])) && _react2.default.createElement(_AssociateDissociateUserFromPatrimonyModal2.default, {
	                    show: opened == 'AssociateDissociateUserFromPatrimonyModal',
	                    onHide: function onHide(e, r) {
	                        return _this2._close(e, r);
	                    },
	                    user: activeUser }),
	                activeUser && activeUser._links.find((0, _links.linkFinder)('DowngradeExecutiveToPatrimonyManager')) && _react2.default.createElement(_DowngradeExecutiveToPatrimonyManagerModal2.default, {
	                    show: opened == 'DowngradeExecutiveToPatrimonyManagerModal',
	                    onHide: function onHide(e, r) {
	                        return _this2._close(e, r);
	                    },
	                    user: activeUser })
	            );
	        }
	    }]);
	
	    return UserStream;
	}(_react.Component);
	
	UserStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	UserStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.company.user.stream,
	        range: state.company.user.range
	    };
	})(UserStream);
	
	exports.default = UserStream;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserSearch = __webpack_require__(1343);
	
	var _UserSearch2 = _interopRequireDefault(_UserSearch);
	
	var _UserStream = __webpack_require__(1344);
	
	var _UserStream2 = _interopRequireDefault(_UserStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserStreamLayout = function (_Component) {
	    _inherits(UserStreamLayout, _Component);
	
	    function UserStreamLayout() {
	        _classCallCheck(this, UserStreamLayout);
	
	        return _possibleConstructorReturn(this, (UserStreamLayout.__proto__ || Object.getPrototypeOf(UserStreamLayout)).apply(this, arguments));
	    }
	
	    _createClass(UserStreamLayout, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_UserSearch2.default, null),
	                _react2.default.createElement(_UserStream2.default, null)
	            );
	        }
	    }]);
	
	    return UserStreamLayout;
	}(_react.Component);
	
	UserStreamLayout.propTypes = {};
	exports.default = UserStreamLayout;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(46);
	
	function company() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_LOADED:
	            return action.company;
	        default:
	            return state;
	    }
	}
	
	function companyAgencies() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_LOADED:
	            return action.companyAgencies;
	        default:
	            return state;
	    }
	}
	
	function companyUsers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_LOADED:
	            return action.companyUsers;
	        default:
	            return state;
	    }
	}
	
	function companySubsidiaries() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_LOADED:
	            return action.companySubsidiaries;
	        default:
	            return state;
	    }
	}
	
	function companyConfigs() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_CONFIGS_LOADED:
	        case _actions.COMPANY_CONFIGS_QUERIED:
	            return action.companyConfigs;
	        case _actions.COMPANY_CONFIGS_UPDATED:
	            return _extends({}, state, action.companyConfigs);
	        default:
	            return state;
	    }
	}
	
	function stream() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_STREAM_LOADED:
	        case _actions.COMPANY_STREAM_QUERIED:
	            return action.stream;
	        default:
	            return state;
	    }
	}
	
	function range() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_STREAM_LOADED:
	        case _actions.COMPANY_STREAM_QUERIED:
	            return action.range;
	        default:
	            return state;
	    }
	}
	
	function _links() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_STREAM_LOADED:
	        case _actions.COMPANY_STREAM_QUERIED:
	        case _actions.LINKS_LOADED:
	            return action._links;
	        default:
	            return state;
	    }
	}
	
	function query() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_STREAM_LOADED:
	        case _actions.COMPANY_STREAM_QUERIED:
	            return action.query;
	        default:
	            return state;
	    }
	}
	
	function criteria() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.COMPANY_CRITERIA_UPDATED:
	            return _extends({}, state, action.criteria);
	        default:
	            return state;
	    }
	}
	
	function minorStream() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.MINOR_COMPANY_STREAM_QUERIED:
	            return action.stream;
	        default:
	            return state;
	    }
	}
	
	function minorRange() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.MINOR_COMPANY_STREAM_QUERIED:
	            return action.range;
	        default:
	            return state;
	    }
	}
	
	function minorCriteria() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.MINOR_COMPANY_CRITERIA_UPDATED:
	            return _extends({}, state, action.minorCriteria);
	        case _actions.MINOR_COMPANY_CRITERIA_RESET:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function referenceCompanyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REFERENCE_COMPANY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.MINOR_COMPANY_STREAM_QUERIED:
	            return _extends({}, state, { callCenterReference: action.stream && action.stream.length > 0 && action.stream[0].uid });
	        case _actions.REFERENCE_COMPANY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function referenceAgencyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REFERENCE_AGENCY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.REFERENCE_AGENCY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function referenceUserCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REFERENCE_USER_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.REFERENCE_USER_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateAgencyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_AGENCY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.UPDATE_AGENCY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateCompanyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_COMPANY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.UPDATE_COMPANY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function identifyCompanyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.IDENTIFY_COMPANY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.IDENTIFY_COMPANY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateUserCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_USER_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.UPDATE_USER_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateLoginCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_LOGIN_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.UPDATE_LOGIN_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function downgradeExecutiveToPatrimonyManagerCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	var user = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.USER_STREAM_LOADED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function range() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.USER_STREAM_LOADED:
	                return action.range;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.USER_STREAM_LOADED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    function criteria() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { active: true };
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.USER_CRITERIA_UPDATED:
	                return _extends({}, state, action.criteria);
	            default:
	                return state;
	        }
	    }
	
	    function userConfigs() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.USER_CONFIGS_LOADED:
	            case _actions.USER_CONFIGS_QUERIED:
	                return action.userConfigs;
	            case _actions.USER_CONFIGS_UPDATED:
	                return _extends({}, state, action.userConfigs);
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ stream: stream, range: range, query: query, criteria: criteria, userConfigs: userConfigs });
	}();
	
	var agency = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.AGENCY_STREAM_LOADED:
	            case _actions.AGENCY_STREAM_QUERIED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function range() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.AGENCY_STREAM_LOADED:
	            case _actions.AGENCY_STREAM_QUERIED:
	                return action.range;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.AGENCY_STREAM_LOADED:
	            case _actions.AGENCY_STREAM_QUERIED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    function criteria() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { active: true };
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.AGENCY_CRITERIA_UPDATED:
	                return _extends({}, state, action.criteria);
	            default:
	                return state;
	        }
	    }
	
	    function agency() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.AGENCY_LOADED:
	                return action.agency;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ stream: stream, range: range, query: query, criteria: criteria, agency: agency });
	}();
	
	var subsidiary = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.SUBSIDIARY_STREAM_LOADED:
	            case _actions.SUBSIDIARY_STREAM_QUERIED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function range() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.SUBSIDIARY_STREAM_LOADED:
	            case _actions.SUBSIDIARY_STREAM_QUERIED:
	                return action.range;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.SUBSIDIARY_STREAM_LOADED:
	            case _actions.SUBSIDIARY_STREAM_QUERIED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ stream: stream, range: range, query: query });
	}();
	
	exports.default = (0, _redux.combineReducers)({
	    user: user,
	    agency: agency,
	    subsidiary: subsidiary,
	    company: company,
	    companyAgencies: companyAgencies,
	    companyUsers: companyUsers,
	    companySubsidiaries: companySubsidiaries,
	    companyConfigs: companyConfigs,
	    stream: stream,
	    range: range,
	    _links: _links,
	    query: query,
	    criteria: criteria,
	    minorStream: minorStream,
	    minorRange: minorRange,
	    minorCriteria: minorCriteria,
	    referenceCompanyCmd: referenceCompanyCmd,
	    referenceAgencyCmd: referenceAgencyCmd,
	    referenceUserCmd: referenceUserCmd,
	    updateAgencyCmd: updateAgencyCmd,
	    updateCompanyCmd: updateCompanyCmd,
	    identifyCompanyCmd: identifyCompanyCmd,
	    updateUserCmd: updateUserCmd,
	    updateLoginCmd: updateLoginCmd,
	    downgradeExecutiveToPatrimonyManagerCmd: downgradeExecutiveToPatrimonyManagerCmd
	});

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.organisationRoute = organisationRoute;
	
	exports.default = function (rootPath, dispatcher, _ref2) {
	    var getState = _ref2.getState;
	
	
	    return {
	        path: rootPath,
	        component: _CompanyLayout2.default,
	        onEnter: dispatcher(enterCompanyStream(getState)),
	        indexRoute: {
	            component: _CompanyStreamLayout2.default
	        },
	        childRoutes: childRoutes(dispatcher, getState)
	    };
	};
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _links = __webpack_require__(33);
	
	var _actions = __webpack_require__(38);
	
	var _TicketStream = __webpack_require__(900);
	
	var _TicketStream2 = _interopRequireDefault(_TicketStream);
	
	var _actions2 = __webpack_require__(47);
	
	var _ContactStream = __webpack_require__(896);
	
	var _ContactStream2 = _interopRequireDefault(_ContactStream);
	
	var _actions3 = __webpack_require__(193);
	
	var _WorkflowPanelGroup = __webpack_require__(1564);
	
	var _WorkflowPanelGroup2 = _interopRequireDefault(_WorkflowPanelGroup);
	
	var _actions4 = __webpack_require__(533);
	
	var _OpeningTicketInstructionPanelGroup = __webpack_require__(1366);
	
	var _OpeningTicketInstructionPanelGroup2 = _interopRequireDefault(_OpeningTicketInstructionPanelGroup);
	
	var _actions5 = __webpack_require__(113);
	
	var _OpeningTicketPurposePanelGroup = __webpack_require__(1470);
	
	var _OpeningTicketPurposePanelGroup2 = _interopRequireDefault(_OpeningTicketPurposePanelGroup);
	
	var _actions6 = __webpack_require__(146);
	
	var _CampaignStreamLayout = __webpack_require__(1483);
	
	var _CampaignStreamLayout2 = _interopRequireDefault(_CampaignStreamLayout);
	
	var _CampaignDetail = __webpack_require__(1481);
	
	var _CampaignDetail2 = _interopRequireDefault(_CampaignDetail);
	
	var _CampaignDashboard = __webpack_require__(1480);
	
	var _CampaignDashboard2 = _interopRequireDefault(_CampaignDashboard);
	
	var _AnswerStream = __webpack_require__(1478);
	
	var _AnswerStream2 = _interopRequireDefault(_AnswerStream);
	
	var _actions7 = __webpack_require__(46);
	
	var _CompanyLayout = __webpack_require__(1318);
	
	var _CompanyLayout2 = _interopRequireDefault(_CompanyLayout);
	
	var _CompanyStreamLayout = __webpack_require__(1322);
	
	var _CompanyStreamLayout2 = _interopRequireDefault(_CompanyStreamLayout);
	
	var _CompanyDetail = __webpack_require__(1317);
	
	var _CompanyDetail2 = _interopRequireDefault(_CompanyDetail);
	
	var _UserStreamLayout = __webpack_require__(1345);
	
	var _UserStreamLayout2 = _interopRequireDefault(_UserStreamLayout);
	
	var _AgencyStreamLayout = __webpack_require__(1312);
	
	var _AgencyStreamLayout2 = _interopRequireDefault(_AgencyStreamLayout);
	
	var _SubsidiaryStream = __webpack_require__(1334);
	
	var _SubsidiaryStream2 = _interopRequireDefault(_SubsidiaryStream);
	
	var _OrganisationLayout = __webpack_require__(1327);
	
	var _OrganisationLayout2 = _interopRequireDefault(_OrganisationLayout);
	
	var _AgencyDetail = __webpack_require__(1308);
	
	var _AgencyDetail2 = _interopRequireDefault(_AgencyDetail);
	
	var _CompanyDashboard = __webpack_require__(1316);
	
	var _CompanyDashboard2 = _interopRequireDefault(_CompanyDashboard);
	
	var _AgencyDashboard = __webpack_require__(1307);
	
	var _AgencyDashboard2 = _interopRequireDefault(_AgencyDashboard);
	
	var _NotificationsLayout = __webpack_require__(1370);
	
	var _NotificationsLayout2 = _interopRequireDefault(_NotificationsLayout);
	
	var _ShowDocumentsPage = __webpack_require__(1116);
	
	var _ShowDocumentsPage2 = _interopRequireDefault(_ShowDocumentsPage);
	
	var _QualificationCriteriaRef = __webpack_require__(1461);
	
	var _QualificationCriteriaRef2 = _interopRequireDefault(_QualificationCriteriaRef);
	
	var _ContextualComment = __webpack_require__(1349);
	
	var _ContextualComment2 = _interopRequireDefault(_ContextualComment);
	
	var _QualificationCriteriaTree = __webpack_require__(1462);
	
	var _QualificationCriteriaTree2 = _interopRequireDefault(_QualificationCriteriaTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enterCompanyStream(getState) {
	    return function (dispatch, params) {
	        var state = getState();
	        var criteria = state.company.criteria;
	
	
	        return dispatch((0, _actions7.loadCompanyStream)(_extends({}, _actions7.DEFAULT_COMPANY_QUERY, criteria)));
	    };
	}
	
	function enterOrganisationRoot(getState, rootPath) {
	    return function (dispatch) {
	        var state = getState();
	        var authenticated = state.user.authenticated;
	
	
	        if (authenticated.company) {
	            return dispatch((0, _reactRouterRedux.replace)(rootPath + '/' + authenticated.company.uid));
	        }
	        return dispatch(Promise.reject({ statusCode: 403 }));
	    };
	}
	
	function enterCompany(getState) {
	    return function (dispatch, params) {
	        var state = getState();
	        var _appLinks = state.app._links;
	
	        return Promise.all([dispatch((0, _actions7.loadCompany)(params.id)),
	        // dashboard
	        _appLinks.find((0, _links.linkFinder)('tickets')) && dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, { clientCompany: params.id, range: { offset: 0, limit: 0 } })))]);
	    };
	}
	
	function enterAgency(getState) {
	    return function (dispatch, params) {
	        var state = getState();
	        var _appLinks = state.app._links;
	
	        return Promise.all([dispatch((0, _actions7.loadAgency)(params.id, params.aid)),
	        // dashboard
	        _appLinks.find((0, _links.linkFinder)('tickets')) && dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, { agency: params.aid, range: { offset: 0, limit: 0 } })))]);
	    };
	}
	
	function enterAgencyStream(getState) {
	    return function (dispatch, params) {
	        var state = getState();
	        var criteria = state.company.agency.criteria;
	
	        return dispatch((0, _actions7.loadAgencyStream)(_extends({}, _actions7.DEFAULT_AGENCY_QUERY, criteria, { companyUid: params.id })));
	    };
	}
	
	function enterUserStream(getState) {
	    return function (dispatch, params) {
	        var state = getState();
	        var criteria = state.company.user.criteria;
	
	        return dispatch((0, _actions7.loadUserStream)(_extends({}, _actions7.DEFAULT_USER_QUERY, criteria, { companyUid: params.id })));
	    };
	}
	
	function enterWorkflowPanelGroup(dispatch, params) {
	    return Promise.all([dispatch((0, _actions3.loadWorkflowStream)(params.id)), dispatch((0, _actions5.loadOpeningTicketPurposeRef)(params.id))]);
	}
	
	function enterOpeningTicketInstructionPanelGroup(dispatch, params) {
	    return Promise.all([dispatch((0, _actions4.loadOpeningTicketInstructionStream)(params.id, _actions4.DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY)), dispatch((0, _actions5.loadOpeningTicketPurposeRef)(params.id))]);
	}
	
	function enterOpeningTicketPurposePanelGroup(dispatch, params) {
	    return Promise.all([dispatch((0, _actions5.loadOpeningTicketPurposeRef)(params.id)), dispatch((0, _actions5.loadActivityRef)())]);
	}
	
	function enterCampaign(dispatch, params) {
	    return Promise.all([dispatch((0, _actions6.loadCampaign)(params.id, params.cid)), dispatch((0, _actions7.loadCompany)(params.id))]);
	}
	
	function childRoutes(dispatcher, getState) {
	    return [{
	        path: ':id',
	        component: _CompanyDetail2.default,
	        onEnter: dispatcher(enterCompany(getState)),
	        indexRoute: {
	            component: _CompanyDashboard2.default
	        },
	        childRoutes: [{
	            path: 'subsidiaries',
	            component: _SubsidiaryStream2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions7.loadSubsidiaryStream)(_extends({}, _actions7.DEFAULT_QUERY, { holdingUid: p.id })));
	            })
	        }, {
	            path: 'users',
	            component: _UserStreamLayout2.default,
	            onEnter: dispatcher(enterUserStream(getState))
	        }, {
	            path: 'agencies',
	            component: _AgencyStreamLayout2.default,
	            onEnter: dispatcher(enterAgencyStream(getState))
	        }, {
	            path: 'tickets',
	            component: _TicketStream2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, { clientCompany: p.id })));
	            })
	        }, {
	            path: 'documents',
	            component: _ShowDocumentsPage2.default
	        }, {
	            path: 'providercontacts',
	            component: _ContactStream2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions2.loadContactStream)(_extends({}, _actions2.DEFAULT_CONTACT_QUERY, { companyUid: p.id })));
	            })
	        }, {
	            path: 'workflows',
	            component: _WorkflowPanelGroup2.default,
	            onEnter: dispatcher(enterWorkflowPanelGroup)
	        }, {
	            path: 'notifications',
	            component: _NotificationsLayout2.default
	        }, {
	            path: 'criteriaref',
	            component: _QualificationCriteriaRef2.default
	        }, {
	            path: 'contextualcommentref',
	            component: _ContextualComment2.default
	        }, {
	            path: 'criteriatrees',
	            component: _QualificationCriteriaTree2.default
	        }, {
	            path: 'openingticketinstructions',
	            component: _OpeningTicketInstructionPanelGroup2.default,
	            onEnter: dispatcher(enterOpeningTicketInstructionPanelGroup)
	        }, {
	            path: 'openingticketpurposeref',
	            component: _OpeningTicketPurposePanelGroup2.default,
	            onEnter: dispatcher(enterOpeningTicketPurposePanelGroup)
	        }, {
	            path: 'satisfactioncampaigns',
	            component: _CampaignStreamLayout2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions6.loadCampaignStream)(_extends({}, _actions6.DEFAULT_CAMPAIGN_QUERY, { companyUid: p.id })));
	            })
	        }]
	    }, {
	        path: ':id/agencies/:aid',
	        component: _AgencyDetail2.default,
	        onEnter: dispatcher(enterAgency(getState)),
	        indexRoute: {
	            component: _AgencyDashboard2.default
	        },
	        childRoutes: [{
	            path: 'tickets',
	            component: _TicketStream2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, { agency: p.aid })));
	            })
	        }, {
	            path: 'providercontacts',
	            component: _ContactStream2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions2.loadContactStream)(_extends({}, _actions2.DEFAULT_CONTACT_QUERY, { agencyUids: p.aid })));
	            })
	        }, {
	            path: 'documents',
	            component: _ShowDocumentsPage2.default
	        }]
	    }, {
	        path: ':id/satisfactioncampaigns/:cid',
	        component: _CampaignDetail2.default,
	        onEnter: dispatcher(enterCampaign),
	        indexRoute: {
	            component: _CampaignDashboard2.default
	        },
	        childRoutes: [{
	            path: 'answers',
	            component: _AnswerStream2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions6.loadAnswerStream)(_extends({}, _actions6.DEFAULT_ANSWER_QUERY, {
	                    companyUid: p.id,
	                    campaignUid: p.cid
	                })));
	            })
	        }]
	    }];
	}
	
	function organisationRoute(rootPath, dispatcher, _ref) {
	    var getState = _ref.getState;
	
	    return {
	        path: rootPath,
	        component: _OrganisationLayout2.default,
	        indexRoute: {
	            onEnter: dispatcher(enterOrganisationRoot(getState, rootPath))
	        },
	        childRoutes: childRoutes(dispatcher, getState)
	    };
	}

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reconnectingWebsocket = __webpack_require__(2143);
	
	var _reconnectingWebsocket2 = _interopRequireDefault(_reconnectingWebsocket);
	
	var _websocketz = __webpack_require__(1360);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var frontWebSocket;
	
	function getFrontWebSocket() {
	    if (!frontWebSocket) {
	        var option = {
	            minReconnectionDelay: 20000,
	            maxReconnectionDelay: 20000,
	            reconnectionDelayGrowFactor: 1
	        };
	
	        frontWebSocket = new _reconnectingWebsocket2.default((0, _websocketz.wsUri)(_config2.default.socket.front.url), _config2.default.socket.front.protocol, option);
	    }
	    return frontWebSocket;
	}
	
	exports.default = { getFrontWebSocket: getFrontWebSocket };

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _ContextualComment = __webpack_require__(1812);
	
	var _ContextualComment2 = _interopRequireDefault(_ContextualComment);
	
	var _i18n = __webpack_require__(80);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactRedux = __webpack_require__(4);
	
	var _status = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextualComment = function (_Component) {
	    _inherits(ContextualComment, _Component);
	
	    function ContextualComment() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ContextualComment);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContextualComment.__proto__ || Object.getPrototypeOf(ContextualComment)).call.apply(_ref, [this].concat(args))), _this), _this.setupPorts = function (ports) {
	            var dispatch = _this.props.dispatch;
	
	            ports.sendErrorToRedux.subscribe(function (e) {
	                dispatch((0, _status.errorStatus)(e));
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ContextualComment, [{
	        key: 'render',
	        value: function render() {
	            var flags = this.props.company.company._links.find(function (x) {
	                return x.rel === 'contextualcommentref';
	            });
	
	            var component = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: _i18n2.default.qualifCriterias }),
	                _react2.default.createElement(_reactElmComponents2.default, { src: _ContextualComment2.default.Elm.ContextualComment, flags: flags, ports: this.setupPorts })
	            );
	
	            return flags ? component : _react2.default.createElement('div', null);
	        }
	    }]);
	
	    return ContextualComment;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var company = _ref2.company;
	    return { company: company };
	})(ContextualComment);

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAdministrativeDivision = getAdministrativeDivision;
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var departmentCollectionCache;
	var cityCollectionCache = {};
	
	var AdministrativeDivisionError = function (_Error) {
	    _inherits(AdministrativeDivisionError, _Error);
	
	    function AdministrativeDivisionError(message, statusCode) {
	        _classCallCheck(this, AdministrativeDivisionError);
	
	        var _this = _possibleConstructorReturn(this, (AdministrativeDivisionError.__proto__ || Object.getPrototypeOf(AdministrativeDivisionError)).call(this, message));
	
	        _this.stack = new Error().stack;
	        _this.name = 'AdministrativeDivisionError';
	        _this.message = message;
	        _this.statusCode = statusCode;
	        return _this;
	    }
	
	    return AdministrativeDivisionError;
	}(Error);
	
	function loadDepartmentCollection() {
	    if (departmentCollectionCache) {
	        return departmentCollectionCache;
	    }
	
	    if (!_config2.default.administrativeDivision.api.url || _config2.default.administrativeDivision.api.url == 'unset') {
	        return departmentCollectionCache = Promise.reject(new AdministrativeDivisionError(400, 'API url not set'));
	    }
	
	    return departmentCollectionCache = fetch(_config2.default.administrativeDivision.api.url + '/france/department/').then(function (response) {
	        if (response.status >= 200 && response.status < 300) {
	            return response.json();
	        }
	
	        var statusText = response.statusText;
	        var statusCode = response.status;
	        throw new AdministrativeDivisionError(statusText, statusCode);
	    });
	}
	
	function loadCityCollection(departmentCode) {
	    if (cityCollectionCache[departmentCode]) {
	        return cityCollectionCache[departmentCode];
	    }
	
	    if (!_config2.default.administrativeDivision.api.url || _config2.default.administrativeDivision.api.url == 'unset') {
	        return cityCollectionCache[departmentCode] = Promise.reject(new AdministrativeDivisionError(400, 'API url not set'));
	    }
	
	    return cityCollectionCache[departmentCode] = fetch(_config2.default.administrativeDivision.api.url + '/france/department/' + departmentCode + '/city/').then(function (response) {
	        if (response.status >= 200 && response.status < 300) {
	            return response.json();
	        }
	
	        var statusText = response.statusText;
	        var statusCode = response.status;
	        throw new AdministrativeDivisionError(statusText, statusCode);
	    });
	}
	
	function getAdministrativeDivision(_ref) {
	    var division = _ref.division,
	        code = _ref.code,
	        departmentCode = _ref.departmentCode;
	
	    if (division == 'department') {
	        return loadDepartmentCollection().then(function (collection) {
	            var feature = collection.features.find(function (f) {
	                return f.properties.code == code;
	            });
	
	            if (!feature) {
	                console && console.warn('department ' + code + ' doesn\'t exist in administrative data set');
	            }
	            return feature;
	        });
	    }
	
	    if (division == 'city') {
	        return loadCityCollection(departmentCode).then(function (collection) {
	            var feature = collection.features.find(function (f) {
	                return f.properties.code == code;
	            });
	
	            if (!feature) {
	                console && console.warn('city ' + code + ' doesn\'t exist in department ' + departmentCode + ' data set');
	            }
	            return feature;
	        });
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.autocompletePasswordInputField = autocompletePasswordInputField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER = 'ChromePasswordAuthocompletePlaceholder';
	
	function autocompletePasswordInputField(field) {
	    function onChange(event) {
	        if (isChromePasswordAutocompleteInitial(event.target)) {
	            field.onChange(CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER);
	            return;
	        }
	        field.onChange(event);
	    }
	
	    if (field.value == CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER) return { onChange: onChange };
	    return _extends({}, field, { onChange: onChange });
	}
	
	function isChromePasswordAutocompleteInitial(element) {
	    return element.type == 'password' && getComputedStyle(element).backgroundColor == 'rgb(250, 255, 189)' && !element.value;
	}
	
	var Autocomplete = function (_Component) {
	    _inherits(Autocomplete, _Component);
	
	    function Autocomplete() {
	        _classCallCheck(this, Autocomplete);
	
	        return _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).apply(this, arguments));
	    }
	
	    _createClass(Autocomplete, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var element = _reactDom2.default.findDOMNode(this);
	            this._inputElements = [].concat(_toConsumableArray(element.querySelectorAll('input')));
	            this._inputValues = this._inputElements.map(function (e) {
	                return e.value;
	            });
	
	            element.addEventListener('input', function (event) {
	                _this2._inputChanged(event.target);
	
	                clearTimeout(_this2._timer);
	                _this2._timer = setTimeout(function () {
	                    return _this2._dispatchMissingInputEvents();
	                }, 200);
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: '_dispatchMissingInputEvents',
	        value: function _dispatchMissingInputEvents() {
	            for (var i = 0; i < this._inputElements.length; i++) {
	                if (isChromePasswordAutocompleteInitial(this._inputElements[i])) {
	                    // Chrome password input specific
	                    if (this._inputValues[i] != CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER) {
	                        var event = document.createEvent('HTMLEvents');
	                        event.initEvent('input', true, true);
	                        this._inputElements[i].dispatchEvent(event);
	                    }
	                    continue;
	                }
	
	                if (this._inputValues[i] != this._inputElements[i].value) {
	                    var _event = document.createEvent('HTMLEvents');
	                    _event.initEvent('input', true, true);
	                    this._inputElements[i].dispatchEvent(_event);
	                    continue;
	                }
	            }
	        }
	    }, {
	        key: '_inputChanged',
	        value: function _inputChanged(element) {
	            var index = this._inputElements.findIndex(function (e) {
	                return e == element;
	            });
	
	            if (index >= 0) {
	                if (isChromePasswordAutocompleteInitial(this._inputElements[index])) {
	                    // Chrome password input specific
	                    this._inputValues[index] = CHROME_PASSWORD_AUTOCOMPLETE_PLACEHOLDER;
	                    return;
	                }
	
	                this._inputValues[index] = this._inputElements[index].value;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	            return children;
	        }
	    }]);
	
	    return Autocomplete;
	}(_react.Component);
	
	Autocomplete.propTypes = {};
	exports.default = Autocomplete;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18n = __webpack_require__(545);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _Loader = __webpack_require__(2211);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = function (_Component) {
	    _inherits(Loader, _Component);
	
	    function Loader() {
	        _classCallCheck(this, Loader);
	
	        return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
	    }
	
	    _createClass(Loader, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: _Loader2.default.default },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _i18n2.default.loading,
	                    ' ...'
	                )
	            );
	        }
	    }]);
	
	    return Loader;
	}(_react.Component);
	
	Loader.propTypes = {};
	exports.default = Loader;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.percentageStyle = percentageStyle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _maps = __webpack_require__(1093);
	
	var _maps2 = _interopRequireDefault(_maps);
	
	var _silver = __webpack_require__(1839);
	
	var _silver2 = _interopRequireDefault(_silver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function percentageStyle(_ref) {
	    var identify = _ref.identify;
	
	    return function (value) {
	        var percentage = identify(value);
	        var color = percentage < 0.5 && 'red' || percentage < 0.75 && 'yellow' || 'green';
	
	        return {
	            fillColor: color,
	            strokeColor: color,
	            strokeWeight: 1,
	            strokeOpacity: 0.5
	        };
	    };
	}
	
	function geoJsonMapper(display, identify) {
	    return function (value) {
	        return Promise.resolve(display(value)).then(function (geoJson) {
	            return geoJson && _extends({}, geoJson, {
	                properties: _extends({}, geoJson.properties, {
	                    _id: identify(value)
	                })
	            });
	        });
	    };
	}
	
	var Map = function (_Component) {
	    _inherits(Map, _Component);
	
	    function Map(props) {
	        _classCallCheck(this, Map);
	
	        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
	
	        _this.state = {
	            geoJsons: []
	        };
	        return _this;
	    }
	
	    _createClass(Map, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var _props = this.props,
	                display = _props.display,
	                identify = _props.identify,
	                value = _props.value;
	
	
	            Promise.all(value.map(geoJsonMapper(display, identify))).then(function (geoJsons) {
	                var filteredGeoJsons = geoJsons.filter(function (f) {
	                    return f;
	                });
	                _this2.setState({ geoJsons: filteredGeoJsons });
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this3 = this;
	
	            if (nextProps.value != this.props.value) {
	                var display = nextProps.display,
	                    identify = nextProps.identify,
	                    value = nextProps.value;
	
	
	                Promise.all(value.map(geoJsonMapper(display, identify))).then(function (geoJsons) {
	                    var filteredGeoJsons = geoJsons.filter(function (f) {
	                        return f;
	                    });
	                    _this3.setState({ geoJsons: filteredGeoJsons });
	                });
	            }
	        }
	    }, {
	        key: '_click',
	        value: function _click(event) {
	            var _props2 = this.props,
	                identify = _props2.identify,
	                value = _props2.value,
	                onClick = _props2.onClick;
	
	
	            var item = value.find(function (v) {
	                return event.feature.getProperty('_id') == identify(v);
	            });
	
	            if (item) {
	                onClick(event, item);
	            }
	        }
	    }, {
	        key: '_style',
	        value: function _style(feature) {
	            var _props3 = this.props,
	                identify = _props3.identify,
	                value = _props3.value,
	                style = _props3.style;
	
	
	            var item = value.find(function (v) {
	                return feature.getProperty('_id') == identify(v);
	            });
	
	            if (item) {
	                return style(item);
	            }
	            return null;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            var _props4 = this.props,
	                style = _props4.style,
	                display = _props4.display,
	                identify = _props4.identify,
	                value = _props4.value,
	                onClick = _props4.onClick,
	                options = _objectWithoutProperties(_props4, ['style', 'display', 'identify', 'value', 'onClick']);
	
	            var geoJsons = this.state.geoJsons;
	
	
	            this._map = new _maps2.default.Map((0, _reactDom.findDOMNode)(this), _extends({
	                center: { lat: 0, lng: 0 },
	                zoom: 4,
	                disableDefaultUI: true,
	                gestureHandling: 'none',
	                zoomControl: false
	            }, options));
	
	            this._map.mapTypes.set('silver', new _maps2.default.StyledMapType(_silver2.default, { name: 'Silver map' }));
	            this._map.setMapTypeId('silver');
	
	            if (style) {
	                this._map.data.setStyle(function (f) {
	                    return _this4._style(f);
	                });
	            }
	
	            if (onClick) {
	                this._map.data.addListener('click', function (e) {
	                    return _this4._click(e);
	                });
	
	                this._map.data.addListener('mouseover', function (event) {
	                    _this4._map.data.revertStyle();
	                    _this4._map.data.overrideStyle(event.feature, { fillOpacity: 0.5 });
	                });
	
	                this._map.data.addListener('mouseout', function (event) {
	                    _this4._map.data.revertStyle();
	                });
	            }
	
	            this._features = geoJsons.reduce(function (result, geoJson) {
	                result.push.apply(result, _toConsumableArray(_this4._map.data.addGeoJson(geoJson)));
	                return result;
	            }, []);
	
	            // pan and zoom to fit the features
	            this._bounds = new _maps2.default.LatLngBounds();
	            this._features.forEach(function (feature) {
	                feature.getGeometry().forEachLatLng(function (latlng) {
	                    _this4._bounds.extend(latlng);
	                });
	            });
	            this._map.fitBounds(this._bounds);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var _this5 = this;
	
	            var geoJsons = this.state.geoJsons;
	
	
	            this._features.forEach(function (feature) {
	                _this5._map.data.remove(feature);
	            });
	
	            this._features = geoJsons.reduce(function (result, geoJson) {
	                result.push.apply(result, _toConsumableArray(_this5._map.data.addGeoJson(geoJson)));
	                return result;
	            }, []);
	
	            // pan and zoom to fit the features
	            this._bounds = new _maps2.default.LatLngBounds();
	            this._features.forEach(function (feature) {
	                feature.getGeometry().forEachLatLng(function (latlng) {
	                    _this5._bounds.extend(latlng);
	                });
	            });
	            this._map.fitBounds(this._bounds);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var ratio = this.props.ratio;
	
	
	            var defaultStyle = {
	                paddingBottom: ratio && 100 / ratio + '%' || 'unset',
	                height: !ratio && '100%' || 'unset'
	            };
	
	            return _react2.default.createElement('div', {
	                style: defaultStyle });
	        }
	    }]);
	
	    return Map;
	}(_react.Component);
	
	Map.propTypes = {
	    ratio: _react.PropTypes.number,
	    style: _react.PropTypes.any,
	    display: _react.PropTypes.func,
	    identify: _react.PropTypes.func,
	    value: _react.PropTypes.array.isRequired
	};
	Map.defaultProps = {
	    display: function display(v) {
	        return v;
	    },
	    identify: function identify(v) {
	        return v;
	    }
	};
	exports.default = Map;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Strip = __webpack_require__(2221);
	
	var _Strip2 = _interopRequireDefault(_Strip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Strip = function (_Component) {
	    _inherits(Strip, _Component);
	
	    function Strip() {
	        _classCallCheck(this, Strip);
	
	        return _possibleConstructorReturn(this, (Strip.__proto__ || Object.getPrototypeOf(Strip)).apply(this, arguments));
	    }
	
	    _createClass(Strip, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                header = _props.header,
	                help = _props.help,
	                status = _props.status,
	                onClick = _props.onClick;
	
	            var statusClass = status && status.toLowerCase();
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(_Strip2.default.default, _Strip2.default[statusClass], _defineProperty({}, _Strip2.default.clickable, onClick)) },
	                header && _react2.default.createElement(
	                    'div',
	                    {
	                        className: _Strip2.default.header },
	                    header
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: _Strip2.default.body,
	                        onClick: onClick },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Strip2.default.bodySide },
	                        help
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Strip2.default.bodyContent },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _Strip2.default.container },
	                            children
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Strip;
	}(_react.Component);
	
	Strip.PropTypes = {
	    header: _react.PropTypes.node,
	    help: _react.PropTypes.node,
	    status: _react.PropTypes.string
	};
	exports.default = Strip;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _i18n = __webpack_require__(545);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TimeRangePicker = __webpack_require__(2226);
	
	var _TimeRangePicker2 = _interopRequireDefault(_TimeRangePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function range(start, end) {
	    var array = [];
	    for (var i = start; i < end; i++) {
	        array[i] = i;
	    }
	    return array;
	}
	
	function today() {
	    var date = new Date();
	    date.setHours(0);
	    date.setMinutes(0);
	    date.setSeconds(0);
	    date.setMilliseconds(0);
	    return date;
	}
	
	var TimeRangePicker = function (_Component) {
	    _inherits(TimeRangePicker, _Component);
	
	    function TimeRangePicker() {
	        _classCallCheck(this, TimeRangePicker);
	
	        return _possibleConstructorReturn(this, (TimeRangePicker.__proto__ || Object.getPrototypeOf(TimeRangePicker)).apply(this, arguments));
	    }
	
	    _createClass(TimeRangePicker, [{
	        key: '_selectFromHour',
	        value: function _selectFromHour(event) {
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange;
	
	
	            var hour = parseInt(event.target.value);
	            var previousFrom = value && value.from || today();
	            var nextFrom = new Date(previousFrom.getFullYear(), previousFrom.getMonth(), previousFrom.getDate(), hour);
	            var nextTo = value.to && (nextFrom < value.to && value.to || nextFrom);
	            var nextValue = { from: nextFrom, to: nextTo };
	            onChange(nextValue);
	        }
	    }, {
	        key: '_selectToHour',
	        value: function _selectToHour(event) {
	            var _props2 = this.props,
	                value = _props2.value,
	                onChange = _props2.onChange;
	
	
	            var hour = parseInt(event.target.value);
	            var previousTo = value && value.to || today();
	            var nextTo = new Date(previousTo.getFullYear(), previousTo.getMonth(), previousTo.getDate(), hour);
	            var nextValue = _extends({}, value, { to: nextTo });
	            onChange(nextValue);
	        }
	    }, {
	        key: '_selectRangeHour',
	        value: function _selectRangeHour(event, start, end) {
	            var _props3 = this.props,
	                value = _props3.value,
	                onChange = _props3.onChange;
	
	
	            event.preventDefault();
	
	            var previousFrom = value && value.from || today();
	            var previousTo = value && value.to || today();
	            var nextFrom = new Date(previousFrom.getFullYear(), previousFrom.getMonth(), previousFrom.getDate(), start);
	            var nextTo = new Date(previousTo.getFullYear(), previousTo.getMonth(), previousTo.getDate(), end);
	            var nextValue = { from: nextFrom, to: nextTo };
	            onChange(nextValue);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                value = _props4.value,
	                onChange = _props4.onChange;
	
	
	            var fromHour = value && value.from && value.from.getHours();
	            var toHour = value && value.to && value.to.getHours();
	
	            var fromHourRange = range(0, 24);
	            var toHourRange = range(fromHour, 24);
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TimeRangePicker2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _TimeRangePicker2.default.picker },
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            className: 'form-control',
	                            value: fromHour,
	                            onChange: function onChange(e) {
	                                return _this2._selectFromHour(e);
	                            } },
	                        (!value || !value.from) && _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            'heure'
	                        ),
	                        fromHourRange.map(function (v, i) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: i,
	                                    value: v },
	                                v
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' > '
	                    ),
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            className: 'form-control',
	                            value: toHour,
	                            onChange: function onChange(e) {
	                                return _this2._selectToHour(e);
	                            } },
	                        (!value || !value.to) && _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            'heure'
	                        ),
	                        toHourRange.map(function (v, i) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: i,
	                                    value: v },
	                                v
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _TimeRangePicker2.default.preset },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._selectRangeHour(e, 9, 12);
	                            } },
	                        _i18n2.default.morning
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' | '
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._selectRangeHour(e, 14, 18);
	                            } },
	                        _i18n2.default.afternoon
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TimeRangePicker;
	}(_react.Component);
	
	TimeRangePicker.propTypes = {
	    value: _react.PropTypes.object,
	    onChange: _react.PropTypes.func.isRequired
	};
	exports.default = TimeRangePicker;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToggleablePanel = __webpack_require__(2227);
	
	var _ToggleablePanel2 = _interopRequireDefault(_ToggleablePanel);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToggleablePanel = function (_Component) {
	    _inherits(ToggleablePanel, _Component);
	
	    function ToggleablePanel() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ToggleablePanel);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToggleablePanel.__proto__ || Object.getPrototypeOf(ToggleablePanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.togglePanel = function () {
	            if (_this.hasMoreChildren()) {
	                _this.setState({ toggle: !_this.state.toggle });
	            }
	        }, _this.hasMoreChildren = function () {
	            var children = _this.props.children;
	
	            return children.slice(1).filter(Boolean).reduce(function (a, b) {
	                return a.concat(b);
	            }, []).length > 0;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ToggleablePanel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var startHidden = this.props.startHidden;
	
	            this.setState({ toggle: !startHidden });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _cx;
	
	            var children = this.props.children;
	            var toggle = this.state.toggle;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _ToggleablePanel2.default.toggleablePanel, true), _defineProperty(_cx, _ToggleablePanel2.default.expanded, toggle), _defineProperty(_cx, _ToggleablePanel2.default.expandable, this.hasMoreChildren()), _cx)) },
	                _react2.default.createElement(
	                    'div',
	                    { onClick: this.togglePanel, className: _ToggleablePanel2.default.header },
	                    _react2.default.createElement(
	                        'span',
	                        { className: _ToggleablePanel2.default.arrow },
	                        '> '
	                    ),
	                    children[0]
	                ),
	                toggle && _react2.default.createElement(
	                    'div',
	                    null,
	                    children.slice(1)
	                )
	            );
	        }
	    }]);
	
	    return ToggleablePanel;
	}(_react.Component);
	
	exports.default = ToggleablePanel;

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    for (var _len = arguments.length, actors = Array(_len), _key = 0; _key < _len; _key++) {
	        actors[_key] = arguments[_key];
	    }
	
	    return function (next) {
	        return function (reducer, initialState) {
	            var store = next(reducer, initialState);
	            var state;
	            var acting = false;
	
	            store.subscribe(function () {
	                var nextState = store.getState();
	
	                if (nextState != state) {
	                    if (!acting) {
	                        acting = true;
	                        actors.forEach(function (actor) {
	                            actor(store.getState(), store.dispatch);
	                        });
	                        acting = false;
	                    }
	                }
	                state = nextState;
	            });
	
	            return store;
	        };
	    };
	};

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.subscribeMiddleware = subscribeMiddleware;
	exports.default = subscribe;
	
	// middleware
	
	function subscribeMiddleware(_ref) {
	    var dispatch = _ref.dispatch;
	
	    var RECONNECT_DELAY = 20000;
	
	    return function (next) {
	        return function (action) {
	            if (action.subscriber) {
	                var _subscribe = function _subscribe(subscriber) {
	                    var result = dispatch(subscriber());
	
	                    // long polling
	                    Promise.resolve(result).then(function () {
	                        clearTimeout(subscribeTimer);
	                        setTimeout(function () {
	                            return _subscribe(subscriber);
	                        }, RECONNECT_DELAY);
	                    }).catch(function (e) {
	                        clearTimeout(subscribeTimer);
	                        setTimeout(function () {
	                            return _subscribe(subscriber);
	                        }, RECONNECT_DELAY);
	                    });
	                };
	
	                var subscribeTimer;
	
	                _subscribe(action.subscriber);
	
	                // break middleware chain
	                return null;
	            }
	            return next(action);
	        };
	    };
	}
	
	// action
	
	function subscribe(subscriber) {
	    return { subscriber: subscriber };
	}

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.escapeRegExp = escapeRegExp;
	function escapeRegExp(value) {
	    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.wsUri = wsUri;
	function wsUri(path) {
	    var wsProtocol = window.location.protocol == 'https:' && 'wss:' || 'ws:';
	    var wsHost = window.location.host;
	    return wsProtocol + '//' + wsHost + path;
	}

/***/ }),
/* 1361 */,
/* 1362 */,
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRouter = __webpack_require__(2127);
	
	var _redux = __webpack_require__(148);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactRouterScroll = __webpack_require__(2110);
	
	var _reactRouterScroll2 = _interopRequireDefault(_reactRouterScroll);
	
	var _reduxDevtools = __webpack_require__(2145);
	
	var _history = __webpack_require__(1837);
	
	var _debug = __webpack_require__(1793);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _browser = __webpack_require__(54);
	
	var _locationz = __webpack_require__(894);
	
	var _applyActor = __webpack_require__(1357);
	
	var _applyActor2 = _interopRequireDefault(_applyActor);
	
	var _loading = __webpack_require__(58);
	
	var _progress = __webpack_require__(965);
	
	var _status = __webpack_require__(13);
	
	var _subscribe = __webpack_require__(1358);
	
	var _delay = __webpack_require__(895);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _i18n = __webpack_require__(80);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _middlewares = __webpack_require__(1280);
	
	var _middlewares2 = __webpack_require__(1548);
	
	var _reducers = __webpack_require__(1282);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _routes = __webpack_require__(1283);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _actors = __webpack_require__(1268);
	
	var _actors2 = _interopRequireDefault(_actors);
	
	var _hydrate = __webpack_require__(1279);
	
	var _hydrate2 = _interopRequireDefault(_hydrate);
	
	var _errors = __webpack_require__(1278);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// config logger
	_debug2.default.enable('*');
	
	// config moment
	_moment2.default.updateLocale('fr', _i18n2.default.moment);
	_moment2.default.locale('fr');
	
	var storeEnhancers = [];
	
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	if (_config2.default.env == 'development') {
	
	    storeEnhancers.push.apply(storeEnhancers, [(0, _reduxDevtools.persistState)(window.location.href.match(/[?&]debug_session=([^&]+)\b/))]);
	
	    if (false) {
	        // Enable Webpack hot module replacement for reducers
	        module.hot.accept('./app/reducers', function () {
	            store.replaceReducer(require('./app/reducers').default);
	        });
	    }
	}
	
	var browserHistory = (0, _browser.supportHistory)() && (0, _reactRouter.useRouterHistory)(_history.createHistory)() || (0, _reactRouter.useRouterHistory)(_history.createHashHistory)({ queryKey: false });
	
	var enhancer = composeEnhancers.apply(undefined, [_applyActor2.default.apply(undefined, _toConsumableArray(_actors2.default)), (0, _redux.applyMiddleware)(_delay.delayMiddleware, _loading.loadingMiddleware, _progress.progressMiddleware, _subscribe.subscribeMiddleware, _middlewares.thunk, _middlewares.promise, _middlewares.worker, _middlewares.error, (0, _middlewares2.unauthorized)('/login'), (0, _middlewares.errorStatus)(_errors2.default), _status.statusMiddleware, (0, _reactRouterRedux.routerMiddleware)(browserHistory))].concat(storeEnhancers));
	var store = (0, _redux.createStore)(_reducers2.default, _extends({}, (0, _hydrate2.default)(), queryParameters()), enhancer);
	
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(browserHistory, store, { selectLocationState: function selectLocationState(s) {
	        return s.router;
	    } });
	
	function routeDispatcher(dispatcher) {
	    return function (nextState, replaceState, callback) {
	        Promise.resolve(dispatcher(store.dispatch, nextState.params, nextState.location.query)).catch(function (error) {
	            if (error && error.statusCode) {
	                // functional error
	                var state = store.getState();
	                var nextLocation = state.router.history[0];
	                var previousLocation = state.router.history[1];
	                var targetLocation = nextState.location;
	
	                var location = previousLocation || targetLocation.pathname != '/tickets' && { pathname: '/tickets' }; // fallback to home page
	
	                if (nextLocation.pathname != targetLocation.pathname) {
	                    // a redirect occured during dispatch
	                    // keep redirect location
	                    replaceState(nextLocation);
	                } else if (location) {
	                    // go back to previous location
	                    replaceState(location);
	                } else {
	                    callback();
	                }
	                return;
	            }
	            return Promise.reject(error);
	        }).then(function (action) {
	            var state = store.getState();
	            var nextLocation = state.router.location;
	            var targetLocation = nextState.location;
	
	            if (nextLocation.pathname != targetLocation.pathname) {
	                // a redirect occured during dispatch
	                // keep redirect location
	                replaceState(nextLocation);
	            } else {
	                callback();
	            }
	        });
	    };
	}
	
	function queryParameters() {
	    var encodedState = (0, _locationz.appQueryParameters)(window.location).state;
	
	    if (encodedState) {
	        return JSON.parse(atob(encodedState));
	    }
	    return {};
	}
	
	(0, _reactDom.render)(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactRouter.Router, {
	            routes: (0, _routes2.default)(routeDispatcher, store),
	            history: history,
	            render: (0, _reactRouter.applyRouterMiddleware)((0, _reactRouterScroll2.default)()) })
	    )
	), document.getElementById('root'));
	
	window.onerror = _errors.errorHandler;
	window.onunhandledrejection = _errors.unhandledRejectionHandler;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _OpeningTicketPurposePicker = __webpack_require__(897);
	
	var _OpeningTicketPurposePicker2 = _interopRequireDefault(_OpeningTicketPurposePicker);
	
	var _actions = __webpack_require__(533);
	
	var _i18n = __webpack_require__(547);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openingTicketPurposeAggregator(reference) {
	    return function (result, openingTicketPurpose) {
	        var resultOpeningTicketPurpose = reference.openingTicketPurposes.find(function (otp) {
	            return otp.uid == openingTicketPurpose.uid;
	        });
	
	        if (resultOpeningTicketPurpose) {
	            result.push(resultOpeningTicketPurpose);
	        } else {
	            console && console.warn('openingTicketPurpose "' + openingTicketPurpose.uid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	var AssociateDissociateOpeningTicketPurposeFromInstructionModal = function (_Component) {
	    _inherits(AssociateDissociateOpeningTicketPurposeFromInstructionModal, _Component);
	
	    function AssociateDissociateOpeningTicketPurposeFromInstructionModal(props) {
	        _classCallCheck(this, AssociateDissociateOpeningTicketPurposeFromInstructionModal);
	
	        var _this = _possibleConstructorReturn(this, (AssociateDissociateOpeningTicketPurposeFromInstructionModal.__proto__ || Object.getPrototypeOf(AssociateDissociateOpeningTicketPurposeFromInstructionModal)).call(this, props));
	
	        _this.state = {
	            openingTicketPurposes: []
	        };
	        return _this;
	    }
	
	    _createClass(AssociateDissociateOpeningTicketPurposeFromInstructionModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                openingTicketInstruction = _props.openingTicketInstruction,
	                reference = _props.reference;
	
	
	            var openingTicketPurposes = openingTicketInstruction.openingTicketPurposes.reduce(openingTicketPurposeAggregator(reference), []);
	            this.setState({ openingTicketPurposes: openingTicketPurposes });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.openingTicketInstruction != this.props.openingTicketInstruction) {
	                var dispatch = nextProps.dispatch,
	                    openingTicketInstruction = nextProps.openingTicketInstruction,
	                    reference = nextProps.reference;
	
	
	                var openingTicketPurposes = openingTicketInstruction.openingTicketPurposes.reduce(openingTicketPurposeAggregator(reference), []);
	                this.setState({ openingTicketPurposes: openingTicketPurposes });
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction(action, openingTicketPurpose) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                openingTicketInstruction = _props2.openingTicketInstruction;
	
	
	            switch (action) {
	                case 'Add':
	                    return dispatch((0, _actions.sendAssociateOpeningTicketPurposeWithInstructionAction)(openingTicketInstruction.uid, openingTicketPurpose.uid)).then(function () {
	                        return dispatch((0, _actions.loadOpeningTicketInstructionStream)());
	                    });
	                case 'Remove':
	                    return dispatch((0, _actions.sendDissociateOpeningTicketPurposeFromInstructionAction)(openingTicketInstruction.uid, openingTicketPurpose.uid)).then(function () {
	                        return dispatch((0, _actions.loadOpeningTicketInstructionStream)());
	                    });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                company = _props3.company,
	                reference = _props3.reference,
	                openingTicketInstruction = _props3.openingTicketInstruction,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'company', 'reference', 'openingTicketInstruction', 'onHide']);
	
	            var openingTicketPurposes = this.state.openingTicketPurposes;
	
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    bsSize: 'large',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.openingTicketPurposes
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_OpeningTicketPurposePicker2.default, { multi: true, split: true,
	                        company: company,
	                        value: openingTicketPurposes,
	                        onSubmit: function onSubmit(a, otp) {
	                            return _this2._sendAction(a, otp);
	                        } }),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssociateDissociateOpeningTicketPurposeFromInstructionModal;
	}(_react.Component);
	
	AssociateDissociateOpeningTicketPurposeFromInstructionModal.propTypes = {
	    openingTicketInstruction: _react.PropTypes.object.isRequired
	};
	
	
	AssociateDissociateOpeningTicketPurposeFromInstructionModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        company: state.company.company,
	        reference: state.reference.openingTicketPurposeRef
	    };
	})(AssociateDissociateOpeningTicketPurposeFromInstructionModal);
	
	exports.default = AssociateDissociateOpeningTicketPurposeFromInstructionModal;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(533);
	
	var _models = __webpack_require__(1095);
	
	var _i18n = __webpack_require__(547);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CreateOpeningTicketInstructionPanel = __webpack_require__(2231);
	
	var _CreateOpeningTicketInstructionPanel2 = _interopRequireDefault(_CreateOpeningTicketInstructionPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateOpeningTicketInstructionPanel = function (_Component) {
	    _inherits(CreateOpeningTicketInstructionPanel, _Component);
	
	    function CreateOpeningTicketInstructionPanel(props) {
	        _classCallCheck(this, CreateOpeningTicketInstructionPanel);
	
	        var _this = _possibleConstructorReturn(this, (CreateOpeningTicketInstructionPanel.__proto__ || Object.getPrototypeOf(CreateOpeningTicketInstructionPanel)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CreateOpeningTicketInstructionPanel, [{
	        key: '_sendAction',
	        value: function _sendAction(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onSelect = _props.onSelect;
	
	
	            var openingTicketInstructionUid;
	            return dispatch((0, _actions.sendCreateOpeningTicketInstructionAction)()).then(function (action) {
	                openingTicketInstructionUid = action.openingTicketInstructionUid;
	                return dispatch((0, _actions.loadOpeningTicketInstructionStream)());
	            }).then(function () {
	                onSelect(event, openingTicketInstructionUid);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                action = _props2.action,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'action']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Panel,
	                others,
	                _react2.default.createElement(
	                    'div',
	                    { className: _CreateOpeningTicketInstructionPanel2.default.defaultContent },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _i18n2.default.newOpeningTicketInstruction
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'title',
	                            label: requiredLabel(_i18n2.default.title)
	                        }, form.title())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'textarea',
	                            name: 'text',
	                            label: requiredLabel(_i18n2.default.text)
	                        }, form.text()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick(e) {
	                                    return form.validate() && _this2._sendAction(e) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreateOpeningTicketInstructionPanel;
	}(_react.Component);
	
	CreateOpeningTicketInstructionPanel.propTypes = {};
	
	
	CreateOpeningTicketInstructionPanel = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.CreateOpeningTicketInstructionAction.schema,
	    action: _actions.CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED
	})(CreateOpeningTicketInstructionPanel);
	
	CreateOpeningTicketInstructionPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        action: state.message.createOpeningTicketInstructionAction
	    };
	})(CreateOpeningTicketInstructionPanel);
	
	exports.default = CreateOpeningTicketInstructionPanel;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _i18n = __webpack_require__(547);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CreateOpeningTicketInstructionPanel = __webpack_require__(1365);
	
	var _CreateOpeningTicketInstructionPanel2 = _interopRequireDefault(_CreateOpeningTicketInstructionPanel);
	
	var _UpdateOpeningTicketInstructionPanel = __webpack_require__(1367);
	
	var _UpdateOpeningTicketInstructionPanel2 = _interopRequireDefault(_UpdateOpeningTicketInstructionPanel);
	
	var _AssociateDissociateOpeningTicketPurposeFromInstructionModal = __webpack_require__(1364);
	
	var _AssociateDissociateOpeningTicketPurposeFromInstructionModal2 = _interopRequireDefault(_AssociateDissociateOpeningTicketPurposeFromInstructionModal);
	
	var _OpeningTicketInstructionPanelGroup = __webpack_require__(2232);
	
	var _OpeningTicketInstructionPanelGroup2 = _interopRequireDefault(_OpeningTicketInstructionPanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function modalName(result) {
	    switch (result) {
	        case 'AssociateDissociateOpeningTicketPurposeFromInstruction':
	            return 'AssociateDissociateOpeningTicketPurposeFromInstructionModal';
	        default:
	            return null;
	    }
	}
	
	var OpeningTicketInstructionPanelGroup = function (_Component) {
	    _inherits(OpeningTicketInstructionPanelGroup, _Component);
	
	    function OpeningTicketInstructionPanelGroup(props) {
	        _classCallCheck(this, OpeningTicketInstructionPanelGroup);
	
	        var _this = _possibleConstructorReturn(this, (OpeningTicketInstructionPanelGroup.__proto__ || Object.getPrototypeOf(OpeningTicketInstructionPanelGroup)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(OpeningTicketInstructionPanelGroup, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.stream != this.props.stream) {
	                var stream = nextProps.stream;
	                var activeOpeningTicketInstruction = this.state.activeOpeningTicketInstruction;
	
	
	                var nextActiveOpeningTicketInstruction = activeOpeningTicketInstruction && stream.find(function (i) {
	                    return i.uid == activeOpeningTicketInstruction.uid;
	                });
	                this.setState({ activeOpeningTicketInstruction: nextActiveOpeningTicketInstruction });
	            }
	        }
	    }, {
	        key: '_openPanel',
	        value: function _openPanel(key) {
	            var activeKey = this.state.activeKey;
	
	
	            var nextActiveKey = activeKey != key && key || null;
	            this.setState({ activeKey: nextActiveKey });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, result, activeOpeningTicketInstruction) {
	            event.preventDefault();
	
	            var openedModal = modalName(result);
	            this.setState({ openedModal: openedModal, activeOpeningTicketInstruction: activeOpeningTicketInstruction });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                stream = _props.stream;
	            var _state = this.state,
	                openedModal = _state.openedModal,
	                activeOpeningTicketInstruction = _state.activeOpeningTicketInstruction,
	                activeKey = _state.activeKey;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        _react2.default.createElement(
	                            _reactBootstrap.PanelGroup,
	                            { accordion: true,
	                                activeKey: activeKey,
	                                onSelect: function onSelect(k) {
	                                    return _this2._openPanel(k);
	                                } },
	                            stream.map(function (openingTicketInstruction) {
	                                return _react2.default.createElement(_UpdateOpeningTicketInstructionPanel2.default, {
	                                    key: openingTicketInstruction.uid,
	                                    eventKey: openingTicketInstruction.uid,
	                                    openingTicketInstruction: openingTicketInstruction,
	                                    onSubmit: function onSubmit(e, r, m) {
	                                        return _this2._openModal(e, r, m);
	                                    } });
	                            }),
	                            activeKey == 'new' && _react2.default.createElement(_CreateOpeningTicketInstructionPanel2.default, {
	                                eventKey: 'new' })
	                        ),
	                        activeKey != 'new' && _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return _this2._openPanel('new');
	                                    } },
	                                _i18n2.default.newOpeningTicketInstruction
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpeningTicketInstructionPanelGroup2.default.side },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                stream.length,
	                                ' ',
	                                _i18n2.default.openingTicketInstructions
	                            )
	                        )
	                    )
	                ),
	                activeOpeningTicketInstruction && _react2.default.createElement(_AssociateDissociateOpeningTicketPurposeFromInstructionModal2.default, {
	                    show: openedModal == 'AssociateDissociateOpeningTicketPurposeFromInstructionModal',
	                    onHide: function onHide(e) {
	                        return _this2._closeModal(e);
	                    },
	                    openingTicketInstruction: activeOpeningTicketInstruction })
	            );
	        }
	    }]);
	
	    return OpeningTicketInstructionPanelGroup;
	}(_react.Component);
	
	OpeningTicketInstructionPanelGroup.propTypes = {};
	
	
	OpeningTicketInstructionPanelGroup = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.message.openingTicketInstruction.stream
	    };
	})(OpeningTicketInstructionPanelGroup);
	
	exports.default = OpeningTicketInstructionPanelGroup;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(533);
	
	var _models = __webpack_require__(1095);
	
	var _i18n = __webpack_require__(547);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateOpeningTicketInstructionPanel = __webpack_require__(2233);
	
	var _UpdateOpeningTicketInstructionPanel2 = _interopRequireDefault(_UpdateOpeningTicketInstructionPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openingTicketPurposeAggregator(reference) {
	    return function (result, openingTicketPurpose) {
	        var resultOpeningTicketPurpose = reference.openingTicketPurposes.find(function (otp) {
	            return otp.uid == openingTicketPurpose.uid;
	        });
	
	        if (resultOpeningTicketPurpose) {
	            result.push(resultOpeningTicketPurpose);
	        } else {
	            console && console.warn('openingTicketPurpose "' + openingTicketPurpose.uid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	function openingTicketInstructionActionUpdate(openingTicketInstruction) {
	    return {
	        instructionUid: openingTicketInstruction.uid || null,
	        title: openingTicketInstruction.title || null,
	        text: openingTicketInstruction.text || null
	    };
	}
	
	var UpdateOpeningTicketInstructionPanel = function (_Component) {
	    _inherits(UpdateOpeningTicketInstructionPanel, _Component);
	
	    function UpdateOpeningTicketInstructionPanel(props) {
	        _classCallCheck(this, UpdateOpeningTicketInstructionPanel);
	
	        var _this = _possibleConstructorReturn(this, (UpdateOpeningTicketInstructionPanel.__proto__ || Object.getPrototypeOf(UpdateOpeningTicketInstructionPanel)).call(this, props));
	
	        _this.state = {
	            openingTicketPurposes: []
	        };
	        return _this;
	    }
	
	    _createClass(UpdateOpeningTicketInstructionPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                expanded = _props.expanded,
	                openingTicketInstruction = _props.openingTicketInstruction,
	                reference = _props.reference;
	
	
	            if (expanded) {
	                var update = openingTicketInstructionActionUpdate(openingTicketInstruction);
	                dispatch((0, _actions.updateUpdateOpeningTicketInstructionAction)(update));
	
	                var openingTicketPurposes = openingTicketInstruction.openingTicketPurposes.reduce(openingTicketPurposeAggregator(reference), []);
	                this.setState({ openingTicketPurposes: openingTicketPurposes });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.expanded != this.props.expanded || nextProps.openingTicketInstruction != this.props.openingTicketInstruction || nextProps.reference != this.props.reference) {
	                var dispatch = nextProps.dispatch,
	                    expanded = nextProps.expanded,
	                    openingTicketInstruction = nextProps.openingTicketInstruction,
	                    reference = nextProps.reference;
	
	
	                if (expanded) {
	                    var update = openingTicketInstructionActionUpdate(openingTicketInstruction);
	                    dispatch((0, _actions.updateUpdateOpeningTicketInstructionAction)(update));
	
	                    var openingTicketPurposes = openingTicketInstruction.openingTicketPurposes.reduce(openingTicketPurposeAggregator(reference), []);
	                    this.setState({ openingTicketPurposes: openingTicketPurposes });
	                }
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onSelect = _props2.onSelect;
	
	
	            return dispatch((0, _actions.sendUpdateOpeningTicketInstructionAction)()).then(function () {
	                return dispatch((0, _actions.loadOpeningTicketInstructionStream)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                reference = _props3.reference,
	                openingTicketInstruction = _props3.openingTicketInstruction,
	                onSubmit = _props3.onSubmit,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'reference', 'openingTicketInstruction', 'onSubmit']);
	
	            var openingTicketPurposes = this.state.openingTicketPurposes;
	
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                openingTicketInstruction.title
	            );
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            var openingTicketPurposeElement = function openingTicketPurposeElement(openingTicketPurpose) {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        key: openingTicketPurpose.uid },
	                    openingTicketPurpose.label
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Panel,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'title',
	                        label: requiredLabel(_i18n2.default.title)
	                    }, form.title())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'textarea',
	                        name: 'text',
	                        label: requiredLabel(_i18n2.default.text)
	                    }, form.text()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick(e) {
	                                return form.validate() && _this2._sendAction(e) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _UpdateOpeningTicketInstructionPanel2.default.openingTicketPurposes },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UpdateOpeningTicketInstructionPanel2.default.action },
	                        _react2.default.createElement(
	                            _reactBootstrap.OverlayTrigger,
	                            {
	                                placement: 'bottom',
	                                overlay: tooltip(_i18n2.default.openingTicketPurposes) },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick(e) {
	                                        return onSubmit(e, 'AssociateDissociateOpeningTicketPurposeFromInstruction', openingTicketInstruction);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                openingTicketPurposes.slice(0, openingTicketPurposes.length / 2 + 1).map(openingTicketPurposeElement)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                openingTicketPurposes.slice(openingTicketPurposes.length / 2 + 1, openingTicketPurposes.length).map(openingTicketPurposeElement)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateOpeningTicketInstructionPanel;
	}(_react.Component);
	
	UpdateOpeningTicketInstructionPanel.propTypes = {
	    openingTicketInstruction: _react.PropTypes.object.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	UpdateOpeningTicketInstructionPanel = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.UpdateOpeningTicketInstructionAction.schema,
	    action: _actions.UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED
	})(UpdateOpeningTicketInstructionPanel);
	
	UpdateOpeningTicketInstructionPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        reference: state.reference.openingTicketPurposeRef,
	        action: state.message.updateOpeningTicketInstructionAction
	    };
	})(UpdateOpeningTicketInstructionPanel);
	
	exports.default = UpdateOpeningTicketInstructionPanel;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (error) {
	    return (0, _extract2.default)(_i18n2.default.errorTypeEnum, error.type, null);
	};
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(547);
	
	var _i18n2 = _interopRequireDefault(_i18n);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(533);
	
	function createOpeningTicketInstructionAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateOpeningTicketInstructionAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	var openingTicketInstruction = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.OPENING_TICKET_INSTRUCTION_STREAM_LOADED:
	            case _actions.OPENING_TICKET_INSTRUCTION_STREAM_QUERIED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.OPENING_TICKET_INSTRUCTION_STREAM_LOADED:
	            case _actions.OPENING_TICKET_INSTRUCTION_STREAM_QUERIED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ stream: stream, query: query });
	}();
	
	exports.default = (0, _redux.combineReducers)({
	    openingTicketInstruction: openingTicketInstruction,
	    createOpeningTicketInstructionAction: createOpeningTicketInstructionAction,
	    updateOpeningTicketInstructionAction: updateOpeningTicketInstructionAction
	});

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _Notifications = __webpack_require__(1813);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _i18n = __webpack_require__(80);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactRedux = __webpack_require__(4);
	
	var _actions = __webpack_require__(113);
	
	var _links = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotificationsLayout = function (_Component) {
	    _inherits(NotificationsLayout, _Component);
	
	    function NotificationsLayout() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NotificationsLayout);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsLayout.__proto__ || Object.getPrototypeOf(NotificationsLayout)).call.apply(_ref, [this].concat(args))), _this), _this.setupPorts = function (ports) {
	            var companyId = _this.props.companyId;
	
	            (0, _actions.fetchOpeningTicketPurposeRef)(companyId).then(function (_ref2) {
	                var json = _ref2.json;
	
	                ports.otpsReceived.send(json);
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NotificationsLayout, [{
	        key: 'render',
	        value: function render() {
	            var listUrl = this.props.links.find((0, _links.linkFinder)('ticketeventnotifications')).href;
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_reactHelmet2.default, { title: _i18n2.default.notifications }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Grid,
	                        null,
	                        _react2.default.createElement(_reactElmComponents2.default, { src: _Notifications2.default.Elm.Main, flags: { listUrl: listUrl }, ports: this.setupPorts })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NotificationsLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        companyId: state.company.company.uid,
	        links: state.company.company._links
	    };
	})(NotificationsLayout);

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _actions = __webpack_require__(74);
	
	function criteriaUpdated() {
	    var criteria;
	
	    return function (state, dispatch) {
	        var nextCriteria = state.patrimony.criteria;
	
	        if (nextCriteria != criteria) {
	
	            if (nextCriteria.agencyUids != (criteria && criteria.agencyUids)) {
	                var location = state.router.location;
	
	                dispatch((0, _actions.loadPatrimonyStream)(_extends({}, _actions.DEFAULT_PATRIMONY_QUERY, nextCriteria))).then(function () {
	                    if (location.pathname != '/patrimonies') {
	                        dispatch((0, _reactRouterRedux.push)('/patrimonies'));
	                    }
	                });
	            }
	            criteria = nextCriteria;
	        }
	    };
	}
	
	function minorCriteriaUpdated() {
	    var minorCriteria;
	
	    return function (state, dispatch) {
	        var nextMinorCriteria = state.patrimony.minorCriteria;
	
	        if (nextMinorCriteria != minorCriteria) {
	
	            if (nextMinorCriteria && nextMinorCriteria.agencyUids != (minorCriteria && minorCriteria.agencyUids)) {
	                dispatch((0, _actions.queryPatrimonyStream)(nextMinorCriteria));
	            }
	            minorCriteria = nextMinorCriteria;
	        }
	    };
	}
	
	function minorContactCriteriaUpdated() {
	    var minorCriteria;
	
	    return function (state, dispatch) {
	        var nextMinorCriteria = state.patrimony.contact.minorCriteria;
	
	        if (nextMinorCriteria != minorCriteria) {
	
	            if (nextMinorCriteria && nextMinorCriteria.patrimonyUids != (minorCriteria && minorCriteria.patrimonyUids)) {
	                dispatch((0, _actions.queryMinorContactStream)(nextMinorCriteria));
	            }
	            minorCriteria = nextMinorCriteria;
	        }
	    };
	}
	
	function referencePatrimonyContactCmdUpdated() {
	    var cmd;
	
	    return function (state, dispatch) {
	        var nextCmd = state.patrimony.referencePatrimonyContactCmd;
	
	        if (nextCmd != cmd) {
	
	            if (nextCmd && nextCmd.linkedWithEntities != (cmd && cmd.linkedWithEntities)) {
	                switch (nextCmd.linkedWithEntities.linkType) {
	                    case 'LinkToLotAsTenant':
	                    case 'LinkToPatrimonyAsCareTaker':
	                    case 'LinkToPatrimonyAsHomeOwnerAssociation':
	                        dispatch((0, _actions.updateReferencePatrimonyContactCmd)({ linkedWithPatrimonyAsHomeOwnerAssociation: null }));
	                        break;
	                }
	            }
	            cmd = nextCmd;
	        }
	    };
	}
	
	exports.default = [criteriaUpdated(), minorCriteriaUpdated(), minorContactCriteriaUpdated(), referencePatrimonyContactCmdUpdated()];

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _places = __webpack_require__(261);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(74);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AddRemoveAddressFromLotPopover = __webpack_require__(2234);
	
	var _AddRemoveAddressFromLotPopover2 = _interopRequireDefault(_AddRemoveAddressFromLotPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function addressMultiMatcher(addresses) {
	    var googleSource = _places.autocompleteMatcher;
	    var addressSource = (0, _TypeaheadInput.matcher)({
	        source: addresses,
	        identify: function identify(a) {
	            return a.number + ' ' + a.street + ' ' + a.city;
	        }
	    });
	
	    return (0, _TypeaheadInput.multiMatcher)([addressSource, googleSource]);
	}
	
	var AddRemoveAddressFromLotPopover = function (_Component) {
	    _inherits(AddRemoveAddressFromLotPopover, _Component);
	
	    function AddRemoveAddressFromLotPopover(props) {
	        _classCallCheck(this, AddRemoveAddressFromLotPopover);
	
	        var _this = _possibleConstructorReturn(this, (AddRemoveAddressFromLotPopover.__proto__ || Object.getPrototypeOf(AddRemoveAddressFromLotPopover)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(AddRemoveAddressFromLotPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var addresses = this.props.addresses;
	
	
	            var addressSource = addressMultiMatcher(addresses);
	            this.setState({ addressSource: addressSource });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.addresses != this.props.addresses) {
	                var addresses = nextProps.addresses;
	
	
	                var addressSource = addressMultiMatcher(addresses);
	                this.setState({ addressSource: addressSource });
	            }
	        }
	    }, {
	        key: '_sendAddCmd',
	        value: function _sendAddCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd,
	                onHide = _props.onHide;
	            var typeahead = this.refs.typeahead;
	
	
	            return dispatch((0, _actions.sendReferenceBuildingCmds)([cmd.address])).then(function (action) {
	                return dispatch((0, _actions.updateAddAddressToLotCmd)({ address: action.addresses[0] }));
	            }).then(function () {
	                return dispatch((0, _actions.sendAddAddressToLotCmd)());
	            }).then(function () {
	                return dispatch((0, _actions.loadLot)());
	            }).then(function () {
	                typeahead.reset();
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd(event, address) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendRemoveAddressFromLotCmd)(address.uid)).then(function () {
	                return dispatch((0, _actions.loadLot)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                addresses = _props2.addresses,
	                lot = _props2.lot,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'addresses', 'lot', 'onHide']);
	
	            var addressSource = this.state.addressSource;
	            var buildingInput = this.refs.buildingInput;
	
	
	            var displayAddressTypeahead = function displayAddressTypeahead(addressOrPrediction) {
	                if (addressOrPrediction.city) {
	                    var address = addressOrPrediction;
	                    var text = address.number + ' ' + address.street + ' ' + address.city;
	                    text = text + (address.building && ' - ' + _i18n2.default.addressBuilding + ' ' + address.building.label || '');
	                    return text;
	                }
	                return (0, _places.displayPrediction)(addressOrPrediction);
	            };
	
	            var highlightAddressTypeahead = function highlightAddressTypeahead(addressOrPrediction) {
	                if (addressOrPrediction.city) {
	                    return null;
	                }
	                return (0, _places.highlightPrediction)(addressOrPrediction);
	            };
	
	            var addressTypeaheadField = function addressTypeaheadField(field) {
	
	                function onChange(addressOrPrediction) {
	                    if (addressOrPrediction.city) {
	                        var address = _extends({}, addressOrPrediction, { uid: null });
	                        field.onChange(address);
	                        buildingInput.getInputDOMNode().focus();
	                    } else {
	                        (0, _places.getPredictionAddress)(addressOrPrediction, function (predictionAddress) {
	                            var address = predictionAddress;
	                            field.onChange(address);
	                            buildingInput.getInputDOMNode().focus();
	                        });
	                    }
	                }
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            var addressTypeaheadButton = function addressTypeaheadButton() {
	                if (cmd && cmd.address) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        (0, _form.buttonField)(form.address(), null),
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.addresses
	                }, others),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _AddRemoveAddressFromLotPopover2.default.addressGroup },
	                    lot.addresses.map(function (address) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: address.uid },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _AddRemoveAddressFromLotPopover2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return _this2._sendRemoveCmd(e, address);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    address.number
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    address.street
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ', ',
	                                    address.zipCode
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    address.city
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'gate',
	                                placeholder: _i18n2.default.addressEntrance
	                            }, form.address.recipientSupplement.entrance()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'digicode',
	                                placeholder: _i18n2.default.addressDigicode
	                            }, form.address.digicode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'floor',
	                                placeholder: _i18n2.default.addressFloor
	                            }, form.address.recipientSupplement.floor()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'unit',
	                                placeholder: _i18n2.default.addressUnit
	                            }, form.address.recipientSupplement.unit()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'floor',
	                                placeholder: _i18n2.default.addressElevator
	                            }, form.address.recipientSupplement.elevator()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'floor',
	                                placeholder: _i18n2.default.addressStaircase
	                            }, form.address.recipientSupplement.staircase()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                ref: 'typeahead',
	                                source: addressSource,
	                                display: displayAddressTypeahead,
	                                highlight: highlightAddressTypeahead,
	                                placeholder: _i18n2.default.addAddress,
	                                buttonAfter: addressTypeaheadButton()
	                            }, addressTypeaheadField(form.address())))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'number',
	                                placeholder: _i18n2.default.addressNumber
	                            }, form.address.number()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                ref: 'buildingInput',
	                                type: 'text',
	                                name: 'building',
	                                placeholder: _i18n2.default.addressBuilding,
	                                disabled: form.address.building.uid().value != null
	                            }, form.address.building.label()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'street',
	                                placeholder: _i18n2.default.addressStreet
	                            }, form.address.street()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'zipCode',
	                                placeholder: _i18n2.default.addressZipCode
	                            }, form.address.zipCode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'city',
	                                placeholder: _i18n2.default.addressCity
	                            }, form.address.city()))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendAddCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddRemoveAddressFromLotPopover;
	}(_react.Component);
	
	AddRemoveAddressFromLotPopover.propTypes = {
	    addresses: _react.PropTypes.array.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AddRemoveAddressFromLotPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.AddAddressToLotCmd.schema,
	    action: _actions.ADD_ADDRESS_TO_LOT_CMD_UPDATED
	})(AddRemoveAddressFromLotPopover);
	
	AddRemoveAddressFromLotPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        lot: state.patrimony.lot.lot,
	        cmd: state.patrimony.addAddressToLotCmd
	    };
	})(AddRemoveAddressFromLotPopover);
	
	exports.default = AddRemoveAddressFromLotPopover;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _places = __webpack_require__(261);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(74);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AddRemoveComplementaryAddressFromPatrimonyPopover = __webpack_require__(2235);
	
	var _AddRemoveComplementaryAddressFromPatrimonyPopover2 = _interopRequireDefault(_AddRemoveComplementaryAddressFromPatrimonyPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddRemoveComplementaryAddressFromPatrimonyPopover = function (_Component) {
	    _inherits(AddRemoveComplementaryAddressFromPatrimonyPopover, _Component);
	
	    function AddRemoveComplementaryAddressFromPatrimonyPopover() {
	        _classCallCheck(this, AddRemoveComplementaryAddressFromPatrimonyPopover);
	
	        return _possibleConstructorReturn(this, (AddRemoveComplementaryAddressFromPatrimonyPopover.__proto__ || Object.getPrototypeOf(AddRemoveComplementaryAddressFromPatrimonyPopover)).apply(this, arguments));
	    }
	
	    _createClass(AddRemoveComplementaryAddressFromPatrimonyPopover, [{
	        key: '_sendAddCmd',
	        value: function _sendAddCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	            var typeahead = this.refs.typeahead;
	
	
	            return dispatch((0, _actions.sendAddComplementaryAddressToPatrimonyCmd)()).then(function () {
	                return dispatch((0, _actions.loadPatrimony)());
	            }).then(function () {
	                typeahead.reset();
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd(event, address) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendRemoveComplementaryAddressFromPatrimonyCmd)(address.uid)).then(function () {
	                return dispatch((0, _actions.loadPatrimony)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                patrimony = _props2.patrimony,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'patrimony', 'onHide']);
	
	            var addressTypeaheadButton = function addressTypeaheadButton() {
	                if (cmd && cmd.complementaryAddress) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        (0, _form.buttonField)(form.complementaryAddress(), null),
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.complementaryAddresses
	                }, others),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _AddRemoveComplementaryAddressFromPatrimonyPopover2.default.addressGroup },
	                    patrimony.complementaryAddresses.map(function (address) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: address.uid },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _AddRemoveComplementaryAddressFromPatrimonyPopover2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return _this2._sendRemoveCmd(e, address);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    address.number
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    address.street
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ', ',
	                                    address.zipCode
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    address.city
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                ref: 'typeahead',
	                                source: _places.autocompleteMatcher,
	                                display: _places.displayPrediction,
	                                highlight: _places.highlightPrediction,
	                                placeholder: _i18n2.default.addAddress,
	                                buttonAfter: addressTypeaheadButton()
	                            }, (0, _places.addressField)(form.complementaryAddress())))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'number',
	                                placeholder: _i18n2.default.addressNumber
	                            }, form.complementaryAddress.number()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'street',
	                                placeholder: _i18n2.default.addressStreet
	                            }, form.complementaryAddress.street()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'zipCode',
	                                placeholder: _i18n2.default.addressZipCode
	                            }, form.complementaryAddress.zipCode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'city',
	                                placeholder: _i18n2.default.addressCity
	                            }, form.complementaryAddress.city()))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendAddCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddRemoveComplementaryAddressFromPatrimonyPopover;
	}(_react.Component);
	
	AddRemoveComplementaryAddressFromPatrimonyPopover.displayName = 'AddRemoveComplementaryAddressFromPatrimonyPopover';
	AddRemoveComplementaryAddressFromPatrimonyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AddRemoveComplementaryAddressFromPatrimonyPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.AddComplementaryAddressToPatrimonyCmd.schema,
	    action: _actions.ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED
	})(AddRemoveComplementaryAddressFromPatrimonyPopover);
	
	AddRemoveComplementaryAddressFromPatrimonyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        patrimony: state.patrimony.patrimony,
	        cmd: state.patrimony.addComplementaryAddressToPatrimonyCmd
	    };
	})(AddRemoveComplementaryAddressFromPatrimonyPopover);
	
	exports.default = AddRemoveComplementaryAddressFromPatrimonyPopover;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(74);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AddRemoveContactPopover = __webpack_require__(2236);
	
	var _AddRemoveContactPopover2 = _interopRequireDefault(_AddRemoveContactPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddRemoveContactPopover = function (_Component) {
	    _inherits(AddRemoveContactPopover, _Component);
	
	    function AddRemoveContactPopover() {
	        _classCallCheck(this, AddRemoveContactPopover);
	
	        return _possibleConstructorReturn(this, (AddRemoveContactPopover.__proto__ || Object.getPrototypeOf(AddRemoveContactPopover)).apply(this, arguments));
	    }
	
	    _createClass(AddRemoveContactPopover, [{
	        key: '_sendAddCmd',
	        value: function _sendAddCmd(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            event.preventDefault();
	
	            return dispatch((0, _actions.sendAddContactCmd)()).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd(event, medium) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            return dispatch((0, _actions.sendRemoveContactCmd)(medium)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                contact = _props2.contact,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'contact', 'onHide']);
	
	            var mediumField = function mediumField(field, type) {
	                var value;
	
	                switch (type) {
	                    case 'Phone':
	                        value = field.value && field.value.phone;
	                        break;
	                    case 'Mail':
	                        value = field.value && field.value.mail;
	                        break;
	                    case 'Fax':
	                        value = field.value && field.value.fax;
	                        break;
	                }
	
	                function onChange(eventOrValue) {
	                    var value;
	                    if (eventOrValue && eventOrValue.target) {
	                        value = eventOrValue.target.value;
	                    } else {
	                        value = eventOrValue;
	                    }
	
	                    var medium;
	                    switch (type) {
	                        case 'Phone':
	                            medium = value && { phone: value, contactInfoType: 'Phone' } || null;
	                            break;
	                        case 'Mail':
	                            medium = value && { mail: value, contactInfoType: 'Mail' } || null;
	                            break;
	                        case 'Fax':
	                            medium = value && { fax: value || null, contactInfoType: 'Fax' } || null;
	                            break;
	                    }
	
	                    field.onChange(medium);
	                }
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            var inputButton = function inputButton(type) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        disabled: cmd && cmd.contact && cmd.contact.contactInfoType != type || !form.isValid(),
	                        onClick: function onClick(e) {
	                            return _this2._sendAddCmd(e);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.contacts
	                }, others),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _i18n2.default.phone
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _AddRemoveContactPopover2.default.contactGroup },
	                    contact.contacts.filter(function (m) {
	                        return m.contactInfoType == 'Phone';
	                    }).map(function (medium, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _AddRemoveContactPopover2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return _this2._sendRemoveCmd(e, medium);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                (0, _phonez2.default)(medium.phone).format()
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'text',
	                        name: 'phone',
	                        buttonAfter: inputButton('Phone')
	                    }, (0, _phonez.phoneField)(mediumField(form.contact(), 'Phone'))))
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _i18n2.default.email
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _AddRemoveContactPopover2.default.contactGroup },
	                    contact.contacts.filter(function (m) {
	                        return m.contactInfoType == 'Mail';
	                    }).map(function (medium, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _AddRemoveContactPopover2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return _this2._sendRemoveCmd(e, medium);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                medium.mail
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'text',
	                        name: 'phone',
	                        buttonAfter: inputButton('Mail')
	                    }, mediumField(form.contact(), 'Mail')))
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _i18n2.default.fax
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _AddRemoveContactPopover2.default.contactGroup },
	                    contact.contacts.filter(function (m) {
	                        return m.contactInfoType == 'Fax';
	                    }).map(function (medium, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _AddRemoveContactPopover2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return _this2._sendRemoveCmd(e, medium);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                (0, _phonez2.default)(medium.fax).format()
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'text',
	                        name: 'phone',
	                        buttonAfter: inputButton('Fax')
	                    }, (0, _phonez.phoneField)(mediumField(form.contact(), 'Fax'))))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddRemoveContactPopover;
	}(_react.Component);
	
	AddRemoveContactPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AddRemoveContactPopover = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.AddContactCmd.schema,
	    action: _actions.ADD_CONTACT_CMD_UPDATED
	})(AddRemoveContactPopover);
	
	AddRemoveContactPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        contact: state.patrimony.contact.contact,
	        cmd: state.patrimony.addContactCmd
	    };
	})(AddRemoveContactPopover);
	
	exports.default = AddRemoveContactPopover;

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdditionalInfosForm = __webpack_require__(1811);
	
	var _AdditionalInfosForm2 = _interopRequireDefault(_AdditionalInfosForm);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _reactRedux = __webpack_require__(4);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdditionalInfos = function (_Component) {
	    _inherits(AdditionalInfos, _Component);
	
	    function AdditionalInfos() {
	        _classCallCheck(this, AdditionalInfos);
	
	        return _possibleConstructorReturn(this, (AdditionalInfos.__proto__ || Object.getPrototypeOf(AdditionalInfos)).apply(this, arguments));
	    }
	
	    _createClass(AdditionalInfos, [{
	        key: 'render',
	        value: function render() {
	            var patrimonyUid = this.props.patrimonyUid;
	
	            var apiUrl = _config2.default.api.url;
	            return _react2.default.createElement(_reactElmComponents2.default, { src: _AdditionalInfosForm2.default.Elm.AdditionalInfosForm, flags: { patrimonyUid: patrimonyUid, apiUrl: apiUrl } });
	        }
	    }]);
	
	    return AdditionalInfos;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { patrimonyUid: state.patrimony.patrimony.uid };
	})(AdditionalInfos);

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AgencySelectInput = __webpack_require__(888);
	
	var _AgencySelectInput2 = _interopRequireDefault(_AgencySelectInput);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AssociateDissociatePatrimonyFromAgencyPopover = __webpack_require__(2237);
	
	var _AssociateDissociatePatrimonyFromAgencyPopover2 = _interopRequireDefault(_AssociateDissociatePatrimonyFromAgencyPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function agencyFilter(agencies) {
	    return function (agency) {
	        return agencies.find(function (a) {
	            return a.uid == agency.uid;
	        }) == null;
	    };
	}
	
	var AssociateDissociatePatrimonyFromAgencyPopover = function (_Component) {
	    _inherits(AssociateDissociatePatrimonyFromAgencyPopover, _Component);
	
	    function AssociateDissociatePatrimonyFromAgencyPopover(props) {
	        _classCallCheck(this, AssociateDissociatePatrimonyFromAgencyPopover);
	
	        var _this = _possibleConstructorReturn(this, (AssociateDissociatePatrimonyFromAgencyPopover.__proto__ || Object.getPrototypeOf(AssociateDissociatePatrimonyFromAgencyPopover)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(AssociateDissociatePatrimonyFromAgencyPopover, [{
	        key: '_sendAssociateCmd',
	        value: function _sendAssociateCmd(event, agencyId) {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendAssociatePatrimonyInAgencyCmd)(agencyId)).then(function () {
	                return dispatch((0, _actions.loadPatrimony)());
	            }).then(function () {
	                _this2.setState({ selectedAgency: null });
	            }).catch(function () {
	                _this2.setState({ selectedAgency: null });
	            });
	        }
	    }, {
	        key: '_sendDissociateCmd',
	        value: function _sendDissociateCmd(event, agency) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendDissociatePatrimonyFromAgencyCmd)(agency.uid)).then(function () {
	                return dispatch((0, _actions.loadPatrimony)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                authenticated = _props2.authenticated,
	                patrimony = _props2.patrimony,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'authenticated', 'patrimony', 'onHide']);
	
	            var selectedAgency = this.state.selectedAgency;
	
	
	            var agencyField = {
	                value: selectedAgency || '',
	                onChange: function onChange(event) {
	                    var selectedAgency = event.target.value;
	                    _this3.setState({ selectedAgency: selectedAgency });
	                    _this3._sendAssociateCmd(event, selectedAgency);
	                }
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.agencies
	                }, others),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _AssociateDissociatePatrimonyFromAgencyPopover2.default.agencyGroup },
	                    patrimony.agencies.map(function (agency) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: agency.uid },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _AssociateDissociatePatrimonyFromAgencyPopover2.default.dissociate,
	                                    onClick: function onClick(e) {
	                                        return _this3._sendDissociateCmd(e, agency);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                agency.label
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _AgencySelectInput2.default,
	                        _extends({
	                            user: authenticated,
	                            company: patrimony.company,
	                            disable: function disable(a) {
	                                return !!patrimony.agencies.find(function (pa) {
	                                    return a.uid == pa.uid;
	                                });
	                            },
	                            name: 'agency'
	                        }, agencyField),
	                        _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            _i18n2.default.addAgency
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssociateDissociatePatrimonyFromAgencyPopover;
	}(_react.Component);
	
	AssociateDissociatePatrimonyFromAgencyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AssociateDissociatePatrimonyFromAgencyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        patrimony: state.patrimony.patrimony,
	        authenticated: state.user.authenticated
	    };
	})(AssociateDissociatePatrimonyFromAgencyPopover);
	
	exports.default = AssociateDissociatePatrimonyFromAgencyPopover;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _status = __webpack_require__(13);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _ScoreDashboardPanel = __webpack_require__(950);
	
	var _ScoreDashboardPanel2 = _interopRequireDefault(_ScoreDashboardPanel);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _BuildingDashboard = __webpack_require__(2238);
	
	var _BuildingDashboard2 = _interopRequireDefault(_BuildingDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BuildingDashboard = function (_Component) {
	    _inherits(BuildingDashboard, _Component);
	
	    function BuildingDashboard() {
	        _classCallCheck(this, BuildingDashboard);
	
	        return _possibleConstructorReturn(this, (BuildingDashboard.__proto__ || Object.getPrototypeOf(BuildingDashboard)).apply(this, arguments));
	    }
	
	    _createClass(BuildingDashboard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                building = _props.building;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.description) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _BuildingDashboard2.default.data },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressCount,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        building.addresses.length
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } })
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanel2.default, { light: true,
	                            header: panelHeader(_i18n2.default.lastAudits) })
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 8 },
	                        _react2.default.createElement(_ScoreDashboardPanel2.default, { light: true })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BuildingDashboard;
	}(_react.Component);
	
	BuildingDashboard.propTypes = {};
	
	
	BuildingDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        building: state.patrimony.building.building
	    };
	})(BuildingDashboard);
	
	exports.default = BuildingDashboard;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StaticMap = __webpack_require__(510);
	
	var _StaticMap2 = _interopRequireDefault(_StaticMap);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReferenceLotPopover = __webpack_require__(1097);
	
	var _ReferenceLotPopover2 = _interopRequireDefault(_ReferenceLotPopover);
	
	var _BuildingDetail = __webpack_require__(2239);
	
	var _BuildingDetail2 = _interopRequireDefault(_BuildingDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BuildingDetail = function (_Component) {
	    _inherits(BuildingDetail, _Component);
	
	    function BuildingDetail(props) {
	        _classCallCheck(this, BuildingDetail);
	
	        var _this = _possibleConstructorReturn(this, (BuildingDetail.__proto__ || Object.getPrototypeOf(BuildingDetail)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(BuildingDetail, [{
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_closePopover',
	        value: function _closePopover(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedPopover: null });
	        }
	    }, {
	        key: '_openNewAuditWindow',
	        value: function _openNewAuditWindow(event) {
	            var building = this.props.building;
	
	
	            event.preventDefault();
	            window.open(_config2.default.audit.url + '/audits/new?externalRefType=Building&externalRefUid=' + building.uid, '_blank');
	        }
	    }, {
	        key: '_reload',
	        value: function _reload() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.loadBuilding)()).then(function () {
	                return dispatch((0, _actions.loadLotStream)());
	            });
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                building = _props.building,
	                buildingLots = _props.buildingLots,
	                auditStats = _props.auditStats;
	            var openedPopover = this.state.openedPopover;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _BuildingDetail2.default.menu },
	                    buildingLots._links.find((0, _links.linkFinder)('ReferenceLot')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferenceLotPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.newLot
	                            )
	                        )
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openNewAuditWindow(e);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.newAudit
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: function onHide() {
	                            return _this2._closePopover();
	                        } },
	                    popover
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _BuildingDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _BuildingDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        {
	                            className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _BuildingDetail2.default.header },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.building,
	                                ' ',
	                                building.label
	                            ),
	                            building.addresses[0] && _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' : ',
	                                    building.addresses[0].number
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    building.addresses[0].street
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ', ',
	                                    building.addresses[0].zipCode
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    building.addresses[0].city
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _BuildingDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        buildingLots._links.find((0, _links.linkFinder)('ReferenceLot')) && editOverlay('ReferenceLotPopover', _react2.default.createElement(_ReferenceLotPopover2.default, {
	                            addresses: building.addresses,
	                            building: building,
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            },
	                            onSubmit: function onSubmit() {
	                                return _this2._reload();
	                            } }))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _BuildingDetail2.default.stats },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.currentYearStats
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _BuildingDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.openedTickets
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _BuildingDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.nextInterventions
	                                    )
	                                ),
	                                _config2.default.feature.audit && _react2.default.createElement(
	                                    'div',
	                                    { className: _BuildingDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        auditStats.newAudits.currentYear
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.newAudits
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _BuildingDetail2.default.map },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _BuildingDetail2.default.metric },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.lots
	                                        ),
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._navigate(e, '/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid + '/lots');
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, {
	                                                icon: 'lot',
	                                                size: 'sm',
	                                                count: buildingLots.count })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_StaticMap2.default, { info: true,
	                                    apiKey: _config2.default.google.apiKey,
	                                    ratio: 16 / 9,
	                                    identify: function identify(a) {
	                                        return a.geoLocation;
	                                    },
	                                    value: building.addresses })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _BuildingDetail2.default.events },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.nextBuildingEvent
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _BuildingDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/buildings\/[\w-]+$/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid));
	                                } },
	                            _i18n2.default.synthesis
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/buildings\/[\w-]+\/lots/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid + '/lots'));
	                                } },
	                            _i18n2.default.lots
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.directory
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.tickets
	                        ),
	                        _config2.default.feature.audit && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/buildings\/[\w-]+\/audits/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid + '/audits'));
	                                } },
	                            _i18n2.default.audits
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.providers
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.documents
	                        )
	                    )
	                ),
	                children
	            );
	        }
	    }]);
	
	    return BuildingDetail;
	}(_react.Component);
	
	BuildingDetail.propTypes = {};
	
	
	BuildingDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        building: state.patrimony.building.building,
	        buildingLots: state.patrimony.building.buildingLots,
	        auditStats: state.audit.report.stats
	    };
	})(BuildingDetail);
	
	exports.default = BuildingDetail;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _models = __webpack_require__(124);
	
	var _ContactCard = __webpack_require__(2240);
	
	var _ContactCard2 = _interopRequireDefault(_ContactCard);
	
	var _PatrimonyUserModal = __webpack_require__(1403);
	
	var _PatrimonyUserModal2 = _interopRequireDefault(_PatrimonyUserModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mediumFilter(type) {
	    return function (medium) {
	        return medium.contactInfoType == type;
	    };
	}
	
	var ContactCard = function (_Component) {
	    _inherits(ContactCard, _Component);
	
	    function ContactCard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ContactCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactCard.__proto__ || Object.getPrototypeOf(ContactCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._openModal = function (event) {
	            event.stopPropagation();
	            _this.setState({ showModal: true });
	        }, _this._closeModal = function () {
	            _this.setState({ showModal: false });
	        }, _this._renderModal = function () {
	            var contact = _this.props.contact;
	
	
	            return _react2.default.createElement(_PatrimonyUserModal2.default, {
	                patrimonyContact: contact,
	                show: _this.state.showModal,
	                onHide: _this._closeModal });
	        }, _this._modalHeader = function () {
	            var _this$props = _this.props,
	                contact = _this$props.contact,
	                query = _this$props.query;
	
	
	            var primaryLinkedWith = _models.Contact.filterLinkedWith(contact, { patrimony: query.patrimonyUids, lot: query.lotUid })[0];
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactCard2.default.action, onClick: _this._openModal.bind(_this), title: _i18n2.default.patrimonyUser.title[contact.patrimonyUserState.stateType] },
	                    _react2.default.createElement(_Icon2.default, { icon: 'gear', size: 'xs' })
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    primaryLinkedWith ? _models.Contact.extractLinkedWith(_i18n2.default.patrimonyContactLinkTypeEnum, primaryLinkedWith) : _i18n2.default.patrimonyContact
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ContactCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                contact = _props.contact,
	                query = _props.query,
	                others = _objectWithoutProperties(_props, ['contact', 'query']);
	
	            var primaryLinkedWith = _models.Contact.filterLinkedWith(contact, { patrimony: query.patrimonyUids, lot: query.lotUid })[0];
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ContactCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true, active: true,
	                        kind: 'tab',
	                        header: this._modalHeader(),
	                        status: _models.CONTACT_PATRIMONY_LINK_TYPES.indexOf(primaryLinkedWith && primaryLinkedWith.linkType) >= 0 && 'success' /*ne fonctionne pas, doit avoir un enfant h3*/
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { float: 'right' }, title: _i18n2.default.patrimonyUser.stateToTooltip[contact.patrimonyUserState.stateType] },
	                        _react2.default.createElement(_Icon2.default, { icon: _i18n2.default.patrimonyUser.stateToIcon[contact.patrimonyUserState.stateType], size: 'sm' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContactCard2.default.name },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            '> ',
	                            contact.name.firstName,
	                            ' ',
	                            contact.name.lastName,
	                            ' ',
	                            contact.name.value
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContactCard2.default.detail },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _i18n2.default.contactInformation
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ContactCard2.default.contact },
	                            contact.patrimonyUserState.login && _react2.default.createElement(
	                                'li',
	                                { key: contact.patrimonyUserState.login },
	                                _react2.default.createElement(_Icon2.default, { icon: 'user', size: 'sm', title: _i18n2.default.userAccount }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    contact.patrimonyUserState.login
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ContactCard2.default.contact },
	                            contact.contacts.filter(mediumFilter('Phone')).slice(0, 2).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'phone', size: 'xs', title: _i18n2.default.phone }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        (0, _phonez2.default)(medium.phone).format()
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ContactCard2.default.contact },
	                            contact.contacts.filter(mediumFilter('Mail')).slice(0, 1).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    {
	                                        className: _ContactCard2.default.mail,
	                                        key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'mail', size: 'xs', title: _i18n2.default.email }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        medium.mail
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ContactCard2.default.contact },
	                            contact.contacts.filter(mediumFilter('Fax')).slice(0, 2).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'fax', size: 'xs', title: _i18n2.default.fax }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        (0, _phonez2.default)(medium.fax).format()
	                                    )
	                                );
	                            })
	                        )
	                    )
	                ),
	                this._renderModal()
	            );
	        }
	    }]);
	
	    return ContactCard;
	}(_react.Component);
	
	ContactCard.propTypes = {
	    query: _react.PropTypes.object.isRequired,
	    lot: _react.PropTypes.object
	};
	exports.default = ContactCard;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _status = __webpack_require__(13);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _models = __webpack_require__(124);
	
	var _ContactDashboard = __webpack_require__(2241);
	
	var _ContactDashboard2 = _interopRequireDefault(_ContactDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mediumFilter(type) {
	    return function (medium) {
	        return medium.contactInfoType == type;
	    };
	}
	
	function linkedWithFilter(linkTypes) {
	    return function (link) {
	        return linkTypes.find(function (lt) {
	            return link.linkType == lt;
	        }) != null;
	    };
	}
	
	var ContactDashboard = function (_Component) {
	    _inherits(ContactDashboard, _Component);
	
	    function ContactDashboard() {
	        _classCallCheck(this, ContactDashboard);
	
	        return _possibleConstructorReturn(this, (ContactDashboard.__proto__ || Object.getPrototypeOf(ContactDashboard)).apply(this, arguments));
	    }
	
	    _createClass(ContactDashboard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contact = _props.contact;
	
	
	            var phoneMediums = contact.contacts.filter(mediumFilter('Phone'));
	            var mailMediums = contact.contacts.filter(mediumFilter('Mail'));
	            var faxMediums = contact.contacts.filter(mediumFilter('Fax'));
	            var primaryLinkedWith = contact.linkedWith.filter(linkedWithFilter(_models.CONTACT_PATRIMONY_LINK_TYPES));
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.description) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _ContactDashboard2.default.data },
	                                primaryLinkedWith.map(function (linkedWith, index) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            '> ',
	                                            _models.Contact.extractLinkedWith(_i18n2.default.patrimonyContactLinkTypeEnum, linkedWith),
	                                            ' :'
	                                        ),
	                                        linkedWith.patrimony && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            linkedWith.patrimony.label
	                                        ),
	                                        linkedWith.patrimony && linkedWith.patrimony.ref && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' (',
	                                            linkedWith.patrimony.ref,
	                                            ')'
	                                        ),
	                                        linkedWith.lot && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            linkedWith.lot.ref
	                                        )
	                                    );
	                                }),
	                                phoneMediums.length > 0 && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.phone,
	                                        ' :'
	                                    ),
	                                    phoneMediums.map(function (medium, index) {
	                                        return _react2.default.createElement(
	                                            'span',
	                                            { key: index },
	                                            index > 0 && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' |'
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                (0, _phonez2.default)(medium.phone).format()
	                                            )
	                                        );
	                                    })
	                                ),
	                                mailMediums.length > 0 && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.email,
	                                        ' :'
	                                    ),
	                                    mailMediums.map(function (medium, index) {
	                                        return _react2.default.createElement(
	                                            'span',
	                                            { key: index },
	                                            index > 0 && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' |'
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                medium.mail
	                                            )
	                                        );
	                                    })
	                                ),
	                                faxMediums.length > 0 && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.fax,
	                                        ' :'
	                                    ),
	                                    faxMediums.map(function (medium, index) {
	                                        return _react2.default.createElement(
	                                            'span',
	                                            { key: index },
	                                            index > 0 && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' |'
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                (0, _phonez2.default)(medium.fax).format()
	                                            )
	                                        );
	                                    })
	                                ),
	                                contact.address && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.address,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        contact.address.address.number
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        contact.address.address.street
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ', ',
	                                        contact.address.address.zipCode
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        contact.address.address.city
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactDashboard;
	}(_react.Component);
	
	ContactDashboard.propTypes = {};
	
	
	ContactDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        contact: state.patrimony.contact.contact
	    };
	})(ContactDashboard);
	
	exports.default = ContactDashboard;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdatePatrimonyContactIdentityPopover = __webpack_require__(1401);
	
	var _UpdatePatrimonyContactIdentityPopover2 = _interopRequireDefault(_UpdatePatrimonyContactIdentityPopover);
	
	var _RemoveLinkFromPatrimonyContactPopover = __webpack_require__(1398);
	
	var _RemoveLinkFromPatrimonyContactPopover2 = _interopRequireDefault(_RemoveLinkFromPatrimonyContactPopover);
	
	var _AddRemoveContactPopover = __webpack_require__(1374);
	
	var _AddRemoveContactPopover2 = _interopRequireDefault(_AddRemoveContactPopover);
	
	var _ContactDetail = __webpack_require__(2242);
	
	var _ContactDetail2 = _interopRequireDefault(_ContactDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactDetail = function (_Component) {
	    _inherits(ContactDetail, _Component);
	
	    function ContactDetail(props) {
	        _classCallCheck(this, ContactDetail);
	
	        var _this = _possibleConstructorReturn(this, (ContactDetail.__proto__ || Object.getPrototypeOf(ContactDetail)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ContactDetail, [{
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_closePopover',
	        value: function _closePopover(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedPopover: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                contact = _props.contact;
	            var openedPopover = this.state.openedPopover;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _ContactDetail2.default.menu },
	                    contact._links.find((0, _links.linkFinder)('RemoveLinkFromPatrimonyContact')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'RemoveLinkFromPatrimonyContactPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.unlinkPatrimonyContact
	                            )
	                        )
	                    ),
	                    contact._links.find((0, _links.linkFinder)(['AddContact', 'RemoveContact'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AddRemoveContactPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.contacts
	                            )
	                        )
	                    ),
	                    contact._links.find((0, _links.linkFinder)('UpdatePatrimonyContactIdentity')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'UpdatePatrimonyContactIdentityPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.updatePatrimonyContact
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: function onHide() {
	                            return _this2._closePopover();
	                        } },
	                    popover
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ContactDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        { className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _ContactDetail2.default.header },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                contact.name.firstName,
	                                ' ',
	                                contact.name.lastName,
	                                ' ',
	                                contact.name.value
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _ContactDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        contact._links.find((0, _links.linkFinder)('RemoveLinkFromPatrimonyContact')) && editOverlay('RemoveLinkFromPatrimonyContactPopover', _react2.default.createElement(_RemoveLinkFromPatrimonyContactPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        contact._links.find((0, _links.linkFinder)(['AddContact', 'RemoveContact'])) && editOverlay('AddRemoveContactPopover', _react2.default.createElement(_AddRemoveContactPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        contact._links.find((0, _links.linkFinder)('UpdatePatrimonyContactIdentity')) && editOverlay('UpdatePatrimonyContactIdentityPopover', _react2.default.createElement(_UpdatePatrimonyContactIdentityPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } }))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonycontacts\/[\w-]+$/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonycontacts/' + contact.uid));
	                                } },
	                            _i18n2.default.synthesis
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.tickets
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.lots
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.documents
	                        )
	                    )
	                ),
	                children
	            );
	        }
	    }]);
	
	    return ContactDetail;
	}(_react.Component);
	
	ContactDetail.propTypes = {};
	
	
	ContactDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        contact: state.patrimony.contact.contact
	    };
	})(ContactDetail);
	
	exports.default = ContactDetail;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _browser = __webpack_require__(54);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(124);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ContactPicker = __webpack_require__(2243);
	
	var _ContactPicker2 = _interopRequireDefault(_ContactPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPicker = function (_Component) {
	    _inherits(ContactPicker, _Component);
	
	    function ContactPicker() {
	        _classCallCheck(this, ContactPicker);
	
	        return _possibleConstructorReturn(this, (ContactPicker.__proto__ || Object.getPrototypeOf(ContactPicker)).apply(this, arguments));
	    }
	
	    _createClass(ContactPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                patrimony = _props.patrimony;
	
	
	            dispatch((0, _actions.resetMinorContactCriteria)({ patrimonyUids: patrimony && patrimony.uid }));
	            dispatch((0, _actions.queryMinorContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, { patrimonyUids: patrimony && patrimony.uid, range: { offset: 0, limit: 99 } })));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.patrimony != this.props.patrimony) {
	                var dispatch = nextProps.dispatch,
	                    patrimony = nextProps.patrimony;
	
	
	                dispatch((0, _actions.resetMinorContactCriteria)({ patrimonyUids: patrimony && patrimony.uid }));
	                dispatch((0, _actions.queryMinorContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, { patrimonyUids: patrimony && patrimony.uid, range: { offset: 0, limit: 99 } })));
	            }
	        }
	    }, {
	        key: '_search',
	        value: function _search(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                minorCriteria = _props2.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.queryMinorContactStream)(minorCriteria));
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props3 = this.props,
	                    dispatch = _props3.dispatch,
	                    minorCriteria = _props3.minorCriteria;
	
	                dispatch((0, _actions.queryMinorContactStream)(minorCriteria));
	            }
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                minorCriteria = _props4.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.updateMinorContactCriteria)({ fullText: null }));
	            dispatch((0, _actions.queryMinorContactStream)(_extends({}, minorCriteria, { fullText: null })));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props5 = this.props,
	                dispatch = _props5.dispatch,
	                form = _props5.form,
	                minorCriteria = _props5.minorCriteria,
	                stream = _props5.stream,
	                range = _props5.range,
	                query = _props5.query,
	                patrimony = _props5.patrimony,
	                others = _objectWithoutProperties(_props5, ['dispatch', 'form', 'minorCriteria', 'stream', 'range', 'query', 'patrimony']);
	
	            var searched = minorCriteria && minorCriteria.fullText && minorCriteria.fullText == (query && query.fullText);
	
	            var header = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactPicker2.default.search },
	                    searched && _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._clear(e);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	                    ),
	                    !searched && _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._search(e);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContactPicker2.default.container },
	                        _react2.default.createElement('input', _extends({
	                            type: 'text',
	                            onKeyPress: function onKeyPress(e) {
	                                return _this2._searchOnKeyPress(e);
	                            },
	                            placeholder: _i18n2.default.searchStream.xs
	                        }, form.fullText()))
	                    )
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _ContactPicker2.default.filter },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _ButtonToggle2.default,
	                            form.patrimonyUids(),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: patrimony && patrimony.uid },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _i18n2.default.patrimonyContactsFilteredByPatrimony
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '|'
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: null },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _i18n2.default.allPatrimonyContacts
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	
	            var afterContacts = function afterContacts() {
	                if (range && range.limit < range.count - 1) {
	                    var count = range.limit + 1;
	                    return _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _extract.replace)(_i18n2.default.useSearchContactFilters, { count: count })
	                    );
	                }
	            };
	
	            var displayContact = function displayContact(contact, mode) {
	                var phoneMedium = contact.contacts.find(function (c) {
	                    return c.contactInfoType == 'Phone';
	                });
	
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            contact.name.firstName
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            ' ',
	                            contact.name.lastName
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            contact.name.value
	                        ),
	                        phoneMedium && _react2.default.createElement(
	                            'span',
	                            null,
	                            ' (',
	                            (0, _phonez2.default)(phoneMedium.phone).format(),
	                            ')'
	                        )
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        contact.name.firstName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        contact.name.lastName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        contact.name.value
	                    ),
	                    phoneMedium && _react2.default.createElement(
	                        'span',
	                        null,
	                        ' (',
	                        (0, _phonez2.default)(phoneMedium.phone).format(),
	                        ')'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Picker2.default, _extends({
	                    source: stream,
	                    identify: function identify(c) {
	                        return c.uid;
	                    },
	                    display: displayContact,
	                    header: header,
	                    after: afterContacts()
	                }, others))
	            );
	        }
	    }]);
	
	    return ContactPicker;
	}(_react.Component);
	
	ContactPicker.propTypes = {
	    patrimony: _react.PropTypes.object
	};
	
	
	ContactPicker = (0, _form.connectForm)({
	    target: 'minorCriteria',
	    schema: _models.ContactCriteria.schema,
	    action: _actions.MINOR_CONTACT_CRITERIA_UPDATED
	})(ContactPicker);
	
	ContactPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        minorCriteria: state.patrimony.contact.minorCriteria,
	        stream: state.patrimony.contact.minorStream,
	        range: state.patrimony.contact.minorRange,
	        query: state.patrimony.contact.minorQuery
	    };
	})(ContactPicker);
	
	exports.default = ContactPicker;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(74);
	
	var _ContactCard = __webpack_require__(1379);
	
	var _ContactCard2 = _interopRequireDefault(_ContactCard);
	
	var _ContactStream = __webpack_require__(2244);
	
	var _ContactStream2 = _interopRequireDefault(_ContactStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var ContactStream = function (_Component) {
	    _inherits(ContactStream, _Component);
	
	    function ContactStream() {
	        _classCallCheck(this, ContactStream);
	
	        return _possibleConstructorReturn(this, (ContactStream.__proto__ || Object.getPrototypeOf(ContactStream)).apply(this, arguments));
	    }
	
	    _createClass(ContactStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadContactStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, contact) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/patrimonycontacts/' + contact.uid, '_blank');
	            } else {
	                dispatch((0, _reactRouterRedux.push)('/patrimonycontacts/' + contact.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stream = _props.stream,
	                range = _props.range,
	                query = _props.query;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (contact) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: contact.uid,
	                                sm: 4 },
	                            _react2.default.createElement(_ContactCard2.default, {
	                                contact: contact,
	                                query: query,
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, contact);
	                                } })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, {
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        },
	                        prev: true, next: true, first: true, last: true, ellipsis: true })
	                )
	            );
	        }
	    }]);
	
	    return ContactStream;
	}(_react.Component);
	
	ContactStream.propTypes = {};
	
	
	ContactStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.patrimony.contact.stream,
	        range: state.patrimony.contact.range,
	        query: state.patrimony.contact.query
	    };
	})(ContactStream);
	
	exports.default = ContactStream;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DeleteLotModal = __webpack_require__(2245);
	
	var _DeleteLotModal2 = _interopRequireDefault(_DeleteLotModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteLotModal = function (_Component) {
	    _inherits(DeleteLotModal, _Component);
	
	    function DeleteLotModal() {
	        _classCallCheck(this, DeleteLotModal);
	
	        return _possibleConstructorReturn(this, (DeleteLotModal.__proto__ || Object.getPrototypeOf(DeleteLotModal)).apply(this, arguments));
	    }
	
	    _createClass(DeleteLotModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                lot = _props.lot,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendDeleteLotCmd)(lot.uid)).then(function () {
	                onHide();
	            }).then(function () {
	                dispatch((0, _router.push)('/patrimonies/' + lot.patrimony.uid + '/lots'));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                lot = _props2.lot,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'lot', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.delete
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DeleteLotModal2.default.text },
	                        _i18n2.default.deleteLotText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, lot)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return _this2._sendCmd(e);
	                                } },
	                            _i18n2.default.delete
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeleteLotModal;
	}(_react.Component);
	
	DeleteLotModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	DeleteLotModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        lot: state.patrimony.lot.lot
	    };
	})(DeleteLotModal);
	
	exports.default = DeleteLotModal;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _LotCard = __webpack_require__(2246);
	
	var _LotCard2 = _interopRequireDefault(_LotCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LotCard = function (_Component) {
	    _inherits(LotCard, _Component);
	
	    function LotCard() {
	        _classCallCheck(this, LotCard);
	
	        return _possibleConstructorReturn(this, (LotCard.__proto__ || Object.getPrototypeOf(LotCard)).apply(this, arguments));
	    }
	
	    _createClass(LotCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                lot = _props.lot,
	                others = _objectWithoutProperties(_props, ['lot']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                (0, _extract2.default)(_i18n2.default.usageEnum, lot.usage),
	                ' ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    ' ',
	                    lot.ref
	                )
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _LotCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true,
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _LotCard2.default.addressDetail },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.addressUnit,
	                                    ' : ',
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].recipientSupplement && lot.addresses[0].recipientSupplement.unit
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 6 },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.addressFloor,
	                                    ' : ',
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].recipientSupplement && lot.addresses[0].recipientSupplement.floor
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _LotCard2.default.address },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _i18n2.default.address
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            lot.addresses[0].quality && _react2.default.createElement(
	                                'span',
	                                null,
	                                lot.addresses[0].quality,
	                                ' - '
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                lot.addresses[0].number,
	                                ' ',
	                                lot.addresses[0].street,
	                                ' - '
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                lot.addresses[0].zipCode,
	                                ' ',
	                                lot.addresses[0].city
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LotCard;
	}(_react.Component);
	
	LotCard.propTypes = {
	    lot: _react.PropTypes.object.isRequired
	};
	exports.default = LotCard;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _status = __webpack_require__(13);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _ScoreDashboardPanel = __webpack_require__(950);
	
	var _ScoreDashboardPanel2 = _interopRequireDefault(_ScoreDashboardPanel);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _LotDashboard = __webpack_require__(2247);
	
	var _LotDashboard2 = _interopRequireDefault(_LotDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LotDashboard = function (_Component) {
	    _inherits(LotDashboard, _Component);
	
	    function LotDashboard() {
	        _classCallCheck(this, LotDashboard);
	
	        return _possibleConstructorReturn(this, (LotDashboard.__proto__ || Object.getPrototypeOf(LotDashboard)).apply(this, arguments));
	    }
	
	    _createClass(LotDashboard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                lot = _props.lot;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.description) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _LotDashboard2.default.data },
	                                lot.ref && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.reference,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.ref
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.lotNumber,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.lotNumber
	                                    )
	                                ),
	                                lot.addresses[0].recipientSupplement && lot.addresses[0].recipientSupplement.entrance && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressEntrance,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].recipientSupplement.entrance
	                                    )
	                                ),
	                                lot.addresses[0].digicode && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressDigicode,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].digicode
	                                    )
	                                ),
	                                lot.addresses[0].building && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressBuilding,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].building.label
	                                    )
	                                ),
	                                lot.addresses[0].recipientSupplement && lot.addresses[0].recipientSupplement.floor && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressFloor,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].recipientSupplement.floor
	                                    )
	                                ),
	                                lot.addresses[0].recipientSupplement && lot.addresses[0].recipientSupplement.unit && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressUnit,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].recipientSupplement.unit
	                                    )
	                                ),
	                                lot.addresses[0].recipientSupplement && lot.addresses[0].recipientSupplement.elevator && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressElevator,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].recipientSupplement.elevator
	                                    )
	                                ),
	                                lot.addresses[0].recipientSupplement && lot.addresses[0].recipientSupplement.staircase && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressStaircase,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        lot.addresses[0].recipientSupplement.staircase
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } })
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanel2.default, { light: true,
	                            header: panelHeader(_i18n2.default.lastAudits) })
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 8 },
	                        _react2.default.createElement(_ScoreDashboardPanel2.default, { light: true })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LotDashboard;
	}(_react.Component);
	
	LotDashboard.propTypes = {};
	
	
	LotDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        lot: state.patrimony.lot.lot
	    };
	})(LotDashboard);
	
	exports.default = LotDashboard;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StaticMap = __webpack_require__(510);
	
	var _StaticMap2 = _interopRequireDefault(_StaticMap);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReferencePatrimonyContactPopover = __webpack_require__(1098);
	
	var _ReferencePatrimonyContactPopover2 = _interopRequireDefault(_ReferencePatrimonyContactPopover);
	
	var _AddRemoveAddressFromLotPopover = __webpack_require__(1372);
	
	var _AddRemoveAddressFromLotPopover2 = _interopRequireDefault(_AddRemoveAddressFromLotPopover);
	
	var _UpdateLotPopover = __webpack_require__(1400);
	
	var _UpdateLotPopover2 = _interopRequireDefault(_UpdateLotPopover);
	
	var _LinkPatrimonyContactWithPopover = __webpack_require__(1096);
	
	var _LinkPatrimonyContactWithPopover2 = _interopRequireDefault(_LinkPatrimonyContactWithPopover);
	
	var _DeleteLotModal = __webpack_require__(1384);
	
	var _DeleteLotModal2 = _interopRequireDefault(_DeleteLotModal);
	
	var _LotDetail = __webpack_require__(2248);
	
	var _LotDetail2 = _interopRequireDefault(_LotDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function modalName(result) {
	    switch (result) {
	        case 'DeleteLot':
	            return 'DeleteLotModal';
	        default:
	            return null;
	    }
	}
	
	var LotDetail = function (_Component) {
	    _inherits(LotDetail, _Component);
	
	    function LotDetail(props) {
	        _classCallCheck(this, LotDetail);
	
	        var _this = _possibleConstructorReturn(this, (LotDetail.__proto__ || Object.getPrototypeOf(LotDetail)).call(this, props));
	
	        _this._closePopover = function (event, result) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            var openedPopover = null;
	            var openedModal = modalName(result);
	            _this.setState({ openedPopover: openedPopover, openedModal: openedModal });
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(LotDetail, [{
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: '_openNewAuditWindow',
	        value: function _openNewAuditWindow(event) {
	            var lot = this.props.lot;
	
	
	            event.preventDefault();
	            window.open(_config2.default.audit.url + '/audits/new?externalRefType=Lot&externalRefUid=' + lot.uid, '_blank');
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                lot = _props.lot,
	                lotContacts = _props.lotContacts,
	                patrimony = _props.patrimony,
	                _appLinks = _props._appLinks,
	                auditStats = _props.auditStats;
	            var _state = this.state,
	                openedPopover = _state.openedPopover,
	                openedModal = _state.openedModal;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _LotDetail2.default.menu },
	                    lotContacts._links.find((0, _links.linkFinder)('ReferencePatrimonyContact')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferencePatrimonyContactPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.newPatrimonyContact
	                            )
	                        )
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openNewAuditWindow(e);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.newAudit
	                            )
	                        )
	                    ),
	                    lot._links.find((0, _links.linkFinder)(['AddAddressToLot', 'RemoveAddressFromLot'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AddRemoveAddressFromLotPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.addresses
	                            )
	                        )
	                    ),
	                    lot._links.find((0, _links.linkFinder)(['UpdateLotNumber', 'DeleteLot'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'UpdateLotPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.updateLot
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: function onHide() {
	                            return _this2._closePopover();
	                        } },
	                    popover
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _LotDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _LotDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        {
	                            className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _LotDetail2.default.header },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                (0, _extract2.default)(_i18n2.default.usageEnum, lot.usage)
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' : ',
	                                lot.addresses[0].number
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                lot.addresses[0].street
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ', ',
	                                lot.addresses[0].zipCode
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                lot.addresses[0].city
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _LotDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        lotContacts._links.find((0, _links.linkFinder)('ReferencePatrimonyContact')) && _react2.default.createElement(_ReferencePatrimonyContactPopover2.default, {
	                            lot: lot,
	                            editButton: editButton,
	                            editContainer: editContainer,
	                            popoverToOpen: openedPopover,
	                            onHide: this._closePopover }),
	                        lot._links.find((0, _links.linkFinder)(['AddAddressToLot', 'RemoveAddressFromLot'])) && editOverlay('AddRemoveAddressFromLotPopover', _react2.default.createElement(_AddRemoveAddressFromLotPopover2.default, {
	                            addresses: patrimony.addresses,
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        editOverlay('LinkPatrimonyContactWithPopover', _react2.default.createElement(_LinkPatrimonyContactWithPopover2.default, {
	                            lot: lot,
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        lot._links.find((0, _links.linkFinder)(['UpdateLotNumber', 'DeleteLot'])) && editOverlay('UpdateLotPopover', _react2.default.createElement(_UpdateLotPopover2.default, {
	                            onHide: function onHide(e, r) {
	                                return _this2._closePopover(e, r);
	                            } }))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _LotDetail2.default.stats },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.currentYearStats
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _LotDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.openedTickets
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _LotDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.nextInterventions
	                                    )
	                                ),
	                                _config2.default.feature.audit && _react2.default.createElement(
	                                    'div',
	                                    { className: _LotDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        auditStats.newAudits.currentYear
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.newAudits
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _LotDetail2.default.map },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _LotDetail2.default.metric },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.patrimonyContacts
	                                        ),
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._navigate(e, '/patrimonies/' + lot.patrimony.uid + '/lots/' + lot.uid + '/contacts');
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, {
	                                                icon: 'user',
	                                                size: 'sm',
	                                                count: lotContacts.count })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_StaticMap2.default, { info: true,
	                                    apiKey: _config2.default.google.apiKey,
	                                    ratio: 16 / 9,
	                                    identify: function identify(a) {
	                                        return a.geoLocation;
	                                    },
	                                    value: lot.addresses })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _LotDetail2.default.events },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.nextLotEvent
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _LotDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/lots\/[\w-]+$/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + lot.patrimony.uid + '/lots/' + lot.uid));
	                                } },
	                            _i18n2.default.synthesis
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('patrimonycontacts')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/lots\/[\w-]+\/contacts/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + lot.patrimony.uid + '/lots/' + lot.uid + '/contacts'));
	                                } },
	                            _i18n2.default.directory
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.tickets
	                        ),
	                        _config2.default.feature.audit && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/lots\/[\w-]+\/audits/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + lot.patrimony.uid + '/lots/' + lot.uid + '/audits'));
	                                } },
	                            _i18n2.default.audits
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.providers
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.documents
	                        )
	                    ),
	                    lot._links.find((0, _links.linkFinder)('DeleteLot')) && _react2.default.createElement(_DeleteLotModal2.default, {
	                        show: openedModal == 'DeleteLotModal',
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } })
	                ),
	                children
	            );
	        }
	    }]);
	
	    return LotDetail;
	}(_react.Component);
	
	LotDetail.propTypes = {};
	
	
	LotDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        lot: state.patrimony.lot.lot,
	        lotContacts: state.patrimony.lot.lotContacts,
	        patrimony: state.patrimony.patrimony,
	        auditStats: state.audit.report.stats,
	        _appLinks: state.app._links
	    };
	})(LotDetail);
	
	exports.default = LotDetail;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _LotCard = __webpack_require__(1385);
	
	var _LotCard2 = _interopRequireDefault(_LotCard);
	
	var _LotStream = __webpack_require__(2249);
	
	var _LotStream2 = _interopRequireDefault(_LotStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NO_BUILDING_ID = 'NoBuilding';
	
	function buildingSorter(a, b) {
	    if (a.label < b.label) return -1;
	    if (a.label > b.label) return 1;
	    return 0;
	}
	
	function lotSorter(a, b) {
	    if (a.usage == b.usage) {
	        if (a.ref < b.ref) return -1;
	        if (a.ref > b.ref) return 1;
	        return 0;
	    }
	
	    var aUsage = (0, _extract2.default)(_i18n2.default.usageEnum, a.usage);
	    var bUsage = (0, _extract2.default)(_i18n2.default.usageEnum, b.usage);
	    if (aUsage < bUsage) return -1;
	    if (aUsage > bUsage) return 1;
	    return 0;
	}
	
	function lotsWithBuildingFilter(building) {
	    return function (lot) {
	        return lot.addresses.find(function (a) {
	            return a.building && a.building.uid == building.uid;
	        }) != null;
	    };
	}
	
	function lotsWithoutBuildingFilter(buildings) {
	    return function (lot) {
	        return lot.addresses.find(function (address) {
	            return address.building && buildings.find(function (b) {
	                return b.uid == address.building.uid;
	            });
	        }) == null;
	    };
	}
	
	function lotsFilter(filter, building) {
	    return function (lot) {
	        return (filter[lot.usage] || []).indexOf(building && building.uid || NO_BUILDING_ID) < 0;
	    };
	}
	
	function usagesAggregator(result, lot) {
	    var item = result.find(function (i) {
	        return i.value == lot.usage;
	    });
	
	    if (!item) {
	        item = {
	            value: lot.usage,
	            count: 0
	        };
	        result.push(item);
	    }
	    item.count++;
	    return result;
	}
	
	function aggregate(lots, buildings, filter) {
	    // lots with building
	    var aggregations = buildings.sort(buildingSorter).map(function (building) {
	        var buildingLots = lots.filter(lotsWithBuildingFilter(building)).sort(lotSorter);
	        var filteredLots = buildingLots.filter(lotsFilter(filter, building));
	        var usages = buildingLots.reduce(usagesAggregator, []);
	
	        return {
	            building: building,
	            lots: filteredLots,
	            usages: usages
	        };
	    });
	
	    // lots with no building
	    var noBuildingLots = lots.filter(lotsWithoutBuildingFilter(buildings)).sort(lotSorter);
	    var filteredLots = noBuildingLots.filter(lotsFilter(filter));
	    var usages = noBuildingLots.reduce(usagesAggregator, []);
	
	    if (noBuildingLots.length > 0) {
	        aggregations.splice(0, 0, {
	            lots: filteredLots,
	            usages: usages
	        });
	    }
	
	    return aggregations;
	}
	
	var LotStream = function (_Component) {
	    _inherits(LotStream, _Component);
	
	    function LotStream(props) {
	        _classCallCheck(this, LotStream);
	
	        var _this = _possibleConstructorReturn(this, (LotStream.__proto__ || Object.getPrototypeOf(LotStream)).call(this, props));
	
	        _this.state = {
	            aggregations: [],
	            filter: {}
	        };
	        return _this;
	    }
	
	    _createClass(LotStream, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                lotStream = _props.lotStream,
	                buildingStream = _props.buildingStream;
	            var filter = this.state.filter;
	
	
	            var aggregations = aggregate(lotStream, buildingStream, filter);
	            this.setState({ aggregations: aggregations });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.lotStream != this.props.lotStream || nextProps.buildingStream != this.props.buildingStream) {
	                var lotStream = nextProps.lotStream,
	                    buildingStream = nextProps.buildingStream;
	                var filter = this.state.filter;
	
	
	                var aggregations = aggregate(lotStream, buildingStream, filter);
	                this.setState({ aggregations: aggregations });
	            }
	        }
	    }, {
	        key: '_toggleFilter',
	        value: function _toggleFilter(usage, building) {
	            var _props2 = this.props,
	                lotStream = _props2.lotStream,
	                buildingStream = _props2.buildingStream;
	            var filter = this.state.filter;
	
	
	            var buildingId = building && building.uid || NO_BUILDING_ID;
	            var usageFilter = filter[usage] || [];
	            var index = usageFilter.indexOf(buildingId);
	
	            var nextUsageFilter = [].concat(_toConsumableArray(usageFilter));
	            if (index >= 0) {
	                nextUsageFilter.splice(index, 1);
	            } else {
	                nextUsageFilter.push(buildingId);
	            }
	
	            var nextFilter = _extends({}, filter, _defineProperty({}, usage, nextUsageFilter));
	            var aggregations = aggregate(lotStream, buildingStream, nextFilter);
	
	            this.setState({
	                filter: nextFilter,
	                aggregations: aggregations
	            });
	        }
	    }, {
	        key: '_isFiltered',
	        value: function _isFiltered(usage, building) {
	            var filter = this.state.filter;
	
	
	            var buildingId = building && building.uid || NO_BUILDING_ID;
	            var usageFilter = filter[usage];
	            return usageFilter && usageFilter.indexOf(buildingId) >= 0;
	        }
	    }, {
	        key: '_navigateLot',
	        value: function _navigateLot(event, lot) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/patrimonies/' + lot.patrimony.uid + '/lots/' + lot.uid, '_blank');
	            } else {
	                dispatch((0, _reactRouterRedux.push)('/patrimonies/' + lot.patrimony.uid + '/lots/' + lot.uid));
	            }
	        }
	    }, {
	        key: '_navigateBuilding',
	        value: function _navigateBuilding(event, building) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid, '_blank');
	            } else {
	                dispatch((0, _reactRouterRedux.push)('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var aggregations = this.state.aggregations;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                aggregations.map(function (aggrega, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: index },
	                        _react2.default.createElement(
	                            _reactBootstrap.PageHeader,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: _LotStream2.default.header },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _LotStream2.default.headerMain },
	                                    aggrega.building && _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: function onClick(e) {
	                                                return _this2._navigateBuilding(e, aggrega.building);
	                                            } },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            'B\xE2timent ',
	                                            aggrega.building.label
	                                        )
	                                    ) || _react2.default.createElement('span', null)
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _LotStream2.default.headerSide },
	                                    aggrega.usages.map(function (usage, index) {
	                                        return _react2.default.createElement(
	                                            'label',
	                                            { key: index },
	                                            _react2.default.createElement('input', {
	                                                type: 'checkbox',
	                                                checked: !_this2._isFiltered(usage.value, aggrega.building),
	                                                onChange: function onChange() {
	                                                    return _this2._toggleFilter(usage.value, aggrega.building);
	                                                } }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, {
	                                                    icon: usage.value,
	                                                    size: 'sm',
	                                                    count: usage.count })
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            aggrega.lots.map(function (lot) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    {
	                                        key: lot.uid,
	                                        sm: 4 },
	                                    _react2.default.createElement(_LotCard2.default, {
	                                        lot: lot,
	                                        onClick: function onClick(e) {
	                                            return _this2._navigateLot(e, lot);
	                                        } })
	                                );
	                            })
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return LotStream;
	}(_react.Component);
	
	LotStream.propTypes = {};
	
	
	LotStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        lotStream: state.patrimony.lot.stream,
	        buildingStream: state.patrimony.building.stream
	    };
	})(LotStream);
	
	exports.default = LotStream;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _PatrimonyCard = __webpack_require__(2250);
	
	var _PatrimonyCard2 = _interopRequireDefault(_PatrimonyCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PatrimonyCard = function (_Component) {
	    _inherits(PatrimonyCard, _Component);
	
	    function PatrimonyCard() {
	        _classCallCheck(this, PatrimonyCard);
	
	        return _possibleConstructorReturn(this, (PatrimonyCard.__proto__ || Object.getPrototypeOf(PatrimonyCard)).apply(this, arguments));
	    }
	
	    _createClass(PatrimonyCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                patrimony = _props.patrimony,
	                others = _objectWithoutProperties(_props, ['patrimony']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.patrimony,
	                ' ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    'n\xB0 ',
	                    patrimony.ref
	                )
	            );
	
	            var address = function address(_address) {
	                return _address && _react2.default.createElement(
	                    'div',
	                    null,
	                    _address.quality && _react2.default.createElement(
	                        'span',
	                        null,
	                        _address.quality,
	                        ' - '
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _address.number,
	                        ' ',
	                        _address.street,
	                        ' - '
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _address.zipCode,
	                        ' ',
	                        _address.city
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _PatrimonyCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true,
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _PatrimonyCard2.default.label },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            '> ',
	                            patrimony.label
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _PatrimonyCard2.default.address },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _i18n2.default.address
	                        ),
	                        address([].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses))[0])
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PatrimonyCard;
	}(_react.Component);
	
	PatrimonyCard.propTypes = {
	    patrimony: _react.PropTypes.object.isRequired
	};
	exports.default = PatrimonyCard;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _status = __webpack_require__(13);
	
	var _links = __webpack_require__(33);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _CallPurposeDashboardPanel = __webpack_require__(898);
	
	var _CallPurposeDashboardPanel2 = _interopRequireDefault(_CallPurposeDashboardPanel);
	
	var _ProviderDashboardPanel = __webpack_require__(899);
	
	var _ProviderDashboardPanel2 = _interopRequireDefault(_ProviderDashboardPanel);
	
	var _ClosingRateDashboardPanel = __webpack_require__(549);
	
	var _ClosingRateDashboardPanel2 = _interopRequireDefault(_ClosingRateDashboardPanel);
	
	var _ScoreDashboardPanel = __webpack_require__(950);
	
	var _ScoreDashboardPanel2 = _interopRequireDefault(_ScoreDashboardPanel);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _PatrimonyDashboard = __webpack_require__(2251);
	
	var _PatrimonyDashboard2 = _interopRequireDefault(_PatrimonyDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PatrimonyDashboard = function (_Component) {
	    _inherits(PatrimonyDashboard, _Component);
	
	    function PatrimonyDashboard() {
	        _classCallCheck(this, PatrimonyDashboard);
	
	        return _possibleConstructorReturn(this, (PatrimonyDashboard.__proto__ || Object.getPrototypeOf(PatrimonyDashboard)).apply(this, arguments));
	    }
	
	    _createClass(PatrimonyDashboard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                patrimony = _props.patrimony,
	                _appLinks = _props._appLinks;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.description) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _PatrimonyDashboard2.default.data },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.reference,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        patrimony.ref
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.addressCount,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        patrimony.addresses.length + patrimony.complementaryAddresses.length
	                                    )
	                                )
	                            )
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(_ClosingRateDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } }),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(_ProviderDashboardPanel2.default, { light: true })
	                    ),
	                    _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_CallPurposeDashboardPanel2.default, { light: true, size: 'large' })
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanel2.default, { light: true,
	                            header: panelHeader(_i18n2.default.lastAudits) })
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 8 },
	                        _react2.default.createElement(_ScoreDashboardPanel2.default, { light: true })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PatrimonyDashboard;
	}(_react.Component);
	
	PatrimonyDashboard.propTypes = {};
	
	
	PatrimonyDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        patrimony: state.patrimony.patrimony,
	        _appLinks: state.app._links
	    };
	})(PatrimonyDashboard);
	
	exports.default = PatrimonyDashboard;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DownloadIcon = __webpack_require__(890);
	
	var _DownloadIcon2 = _interopRequireDefault(_DownloadIcon);
	
	var _StaticMap = __webpack_require__(510);
	
	var _StaticMap2 = _interopRequireDefault(_StaticMap);
	
	var _actions = __webpack_require__(38);
	
	var _ReportTicketsModal = __webpack_require__(1114);
	
	var _ReportTicketsModal2 = _interopRequireDefault(_ReportTicketsModal);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions2 = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdatePatrimonyPopover = __webpack_require__(1402);
	
	var _UpdatePatrimonyPopover2 = _interopRequireDefault(_UpdatePatrimonyPopover);
	
	var _ReferenceLotPopover = __webpack_require__(1097);
	
	var _ReferenceLotPopover2 = _interopRequireDefault(_ReferenceLotPopover);
	
	var _ReferencePatrimonyContactPopover = __webpack_require__(1098);
	
	var _ReferencePatrimonyContactPopover2 = _interopRequireDefault(_ReferencePatrimonyContactPopover);
	
	var _AddRemoveComplementaryAddressFromPatrimonyPopover = __webpack_require__(1373);
	
	var _AddRemoveComplementaryAddressFromPatrimonyPopover2 = _interopRequireDefault(_AddRemoveComplementaryAddressFromPatrimonyPopover);
	
	var _AssociateDissociatePatrimonyFromAgencyPopover = __webpack_require__(1376);
	
	var _AssociateDissociatePatrimonyFromAgencyPopover2 = _interopRequireDefault(_AssociateDissociatePatrimonyFromAgencyPopover);
	
	var _LinkPatrimonyContactWithPopover = __webpack_require__(1096);
	
	var _LinkPatrimonyContactWithPopover2 = _interopRequireDefault(_LinkPatrimonyContactWithPopover);
	
	var _PatrimonyDetail = __webpack_require__(2252);
	
	var _PatrimonyDetail2 = _interopRequireDefault(_PatrimonyDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PatrimonyDetail = function (_Component) {
	    _inherits(PatrimonyDetail, _Component);
	
	    function PatrimonyDetail(props) {
	        _classCallCheck(this, PatrimonyDetail);
	
	        var _this = _possibleConstructorReturn(this, (PatrimonyDetail.__proto__ || Object.getPrototypeOf(PatrimonyDetail)).call(this, props));
	
	        _this._closePopover = function (event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            _this.setState({ openedPopover: null });
	        };
	
	        _this._closeModal = function (event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            _this.setState({ openedModal: null });
	        };
	
	        _this._reload = function () {
	            var dispatch = _this.props.dispatch;
	
	
	            return dispatch((0, _actions2.loadPatrimony)()).then(function () {
	                return dispatch((0, _actions2.loadPatrimonyStream)());
	            }).then(function () {
	                return dispatch((0, _actions2.loadLotAndBuildingStream)());
	            });
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(PatrimonyDetail, [{
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(name) {
	            this.setState({ openedModal: name });
	        }
	    }, {
	        key: '_openNewAuditWindow',
	        value: function _openNewAuditWindow(event) {
	            var patrimony = this.props.patrimony;
	
	
	            event.preventDefault();
	            window.open(_config2.default.audit.url + '/audits/new?externalRefType=Patrimony&externalRefUid=' + patrimony.uid, '_blank');
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                authenticated = _props.authenticated,
	                patrimony = _props.patrimony,
	                patrimonyBuildings = _props.patrimonyBuildings,
	                patrimonyLots = _props.patrimonyLots,
	                patrimonyContacts = _props.patrimonyContacts,
	                auditStats = _props.auditStats,
	                progress = _props.progress,
	                _appLinks = _props._appLinks;
	            var _state = this.state,
	                openedPopover = _state.openedPopover,
	                openedModal = _state.openedModal;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _PatrimonyDetail2.default.menu },
	                    patrimonyLots._links.find((0, _links.linkFinder)('ReferenceLot')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferenceLotPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.newLot
	                            )
	                        )
	                    ),
	                    patrimonyContacts._links.find((0, _links.linkFinder)('ReferencePatrimonyContact')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'ReferencePatrimonyContactPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.newPatrimonyContact
	                            )
	                        )
	                    ),
	                    _config2.default.feature.audit && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openNewAuditWindow(e);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.newAudit
	                            )
	                        )
	                    ),
	                    patrimony._links.find((0, _links.linkFinder)(['AddComplementaryAddressToPatrimony', 'RemoveComplementaryAddressFromPatrimony'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AddRemoveComplementaryAddressFromPatrimonyPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.complementaryAddresses
	                            )
	                        )
	                    ),
	                    patrimony._links.find((0, _links.linkFinder)(['AssociatePatrimonyInAgency', 'DissociatePatrimonyFromAgency'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AssociateDissociatePatrimonyFromAgencyPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.agencies
	                            )
	                        )
	                    ),
	                    patrimony._links.find((0, _links.linkFinder)('UpdatePatrimony')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'UpdatePatrimonyPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.updatePatrimony
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: _this2._closePopover },
	                    popover
	                );
	            };
	
	            var tooltip = function tooltip(text, status) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: status && 'tooltip-' + status },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _PatrimonyDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _PatrimonyDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        { className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _PatrimonyDetail2.default.header },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                patrimony.label
	                            ),
	                            patrimony.complementaryAddresses[0] && _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' : ',
	                                    patrimony.complementaryAddresses[0].number
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    patrimony.complementaryAddresses[0].street
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ', ',
	                                    patrimony.complementaryAddresses[0].zipCode
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    patrimony.complementaryAddresses[0].city
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _PatrimonyDetail2.default.report },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _PatrimonyDetail2.default.container },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: tooltip(progress[_actions.PDF_TICKETS_REPORTED] && _i18n2.default.reportingPatrimony || _i18n2.default.reportPdfPatrimony, 'primary') },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'link',
	                                                bsSize: 'small',
	                                                disabled: !!progress[_actions.PDF_TICKETS_REPORTED],
	                                                onClick: function onClick() {
	                                                    return _this2._openModal('ReportTicketsModal');
	                                                } },
	                                            _react2.default.createElement(_DownloadIcon2.default, { progress: progress[_actions.PDF_TICKETS_REPORTED] })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _PatrimonyDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        patrimonyLots._links.find((0, _links.linkFinder)('ReferenceLot')) && editOverlay('ReferenceLotPopover', _react2.default.createElement(_ReferenceLotPopover2.default, {
	                            addresses: patrimony.addresses,
	                            onSubmit: this._reload,
	                            onHide: this._closePopover })),
	                        patrimonyContacts._links.find((0, _links.linkFinder)('ReferencePatrimonyContact')) && _react2.default.createElement(_ReferencePatrimonyContactPopover2.default, {
	                            patrimony: patrimony,
	                            editButton: editButton,
	                            editContainer: editContainer,
	                            popoverToOpen: openedPopover,
	                            onHide: this._closePopover }),
	                        patrimony._links.find((0, _links.linkFinder)(['AddComplementaryAddressToPatrimony', 'RemoveComplementaryAddressFromPatrimony'])) && editOverlay('AddRemoveComplementaryAddressFromPatrimonyPopover', _react2.default.createElement(_AddRemoveComplementaryAddressFromPatrimonyPopover2.default, {
	                            onHide: this._closePopover })),
	                        patrimony._links.find((0, _links.linkFinder)(['AssociatePatrimonyInAgency', 'DissociatePatrimonyFromAgency'])) && editOverlay('AssociateDissociatePatrimonyFromAgencyPopover', _react2.default.createElement(_AssociateDissociatePatrimonyFromAgencyPopover2.default, {
	                            onHide: this._closePopover })),
	                        editOverlay('LinkPatrimonyContactWithPopover', _react2.default.createElement(_LinkPatrimonyContactWithPopover2.default, {
	                            patrimony: patrimony,
	                            onHide: this._closePopover })),
	                        patrimony._links.find((0, _links.linkFinder)('UpdatePatrimony')) && editOverlay('UpdatePatrimonyPopover', _react2.default.createElement(_UpdatePatrimonyPopover2.default, {
	                            onHide: this._closePopover }))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _PatrimonyDetail2.default.stats },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.currentYearStats
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _PatrimonyDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.openedTickets
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _PatrimonyDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.nextInterventions
	                                    )
	                                ),
	                                _config2.default.feature.audit && _react2.default.createElement(
	                                    'div',
	                                    { className: _PatrimonyDetail2.default.count },
	                                    auditStats && _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        auditStats.newAudits.currentYear
	                                    ) || _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.newAudits
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _PatrimonyDetail2.default.map },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _PatrimonyDetail2.default.metric },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.lots
	                                        ),
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._navigate(e, '/patrimonies/' + patrimony.uid + '/lots');
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, {
	                                                icon: 'lot',
	                                                size: 'sm',
	                                                count: patrimonyLots.count })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _PatrimonyDetail2.default.metric },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.buildings
	                                        ),
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._navigate(e, '/patrimonies/' + patrimony.uid + '/lots');
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, {
	                                                icon: 'building',
	                                                size: 'sm',
	                                                count: patrimonyBuildings.count })
	                                        )
	                                    ),
	                                    _appLinks.find((0, _links.linkFinder)('patrimonycontacts')) && _react2.default.createElement(
	                                        'div',
	                                        { className: _PatrimonyDetail2.default.metric },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.patrimonyContacts
	                                        ),
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._navigate(e, '/patrimonies/' + patrimony.uid + '/contacts');
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, {
	                                                icon: 'user',
	                                                size: 'sm',
	                                                count: patrimonyContacts.count })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_StaticMap2.default, { info: true,
	                                    apiKey: _config2.default.google.apiKey,
	                                    ratio: 16 / 9,
	                                    identify: function identify(a) {
	                                        return a.geoLocation;
	                                    },
	                                    value: [].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses)) })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _PatrimonyDetail2.default.events },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.nextPatrimonyEvent
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _PatrimonyDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+$/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.uid));
	                                } },
	                            _i18n2.default.synthesis
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/additionalinfos/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.uid + '/additionalinfos'));
	                                } },
	                            _i18n2.default.additionalInfos
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/lots/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.uid + '/lots'));
	                                } },
	                            _i18n2.default.lots
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('patrimonycontacts')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/contacts/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.uid + '/contacts'));
	                                } },
	                            _i18n2.default.directory
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/tickets/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.uid + '/tickets'));
	                                } },
	                            _i18n2.default.tickets
	                        ),
	                        _config2.default.feature.audit && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/audits/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.uid + '/audits'));
	                                } },
	                            _i18n2.default.audits
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('providercontacts')) && _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/patrimonies\/[\w-]+\/providercontacts/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.uid + '/providercontacts'));
	                                } },
	                            _i18n2.default.providers
	                        )
	                    )
	                ),
	                children,
	                _react2.default.createElement(_ReportTicketsModal2.default, {
	                    patrimony: patrimony,
	                    show: openedModal == 'ReportTicketsModal',
	                    onHide: this._closeModal })
	            );
	        }
	    }]);
	
	    return PatrimonyDetail;
	}(_react.Component);
	
	PatrimonyDetail.propTypes = {};
	
	
	PatrimonyDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        progress: state.progress,
	        authenticated: state.user.authenticated,
	        patrimony: state.patrimony.patrimony,
	        patrimonyBuildings: state.patrimony.patrimonyBuildings,
	        patrimonyLots: state.patrimony.patrimonyLots,
	        patrimonyContacts: state.patrimony.patrimonyContacts,
	        auditStats: state.audit.report.stats,
	        _appLinks: state.app._links
	    };
	})(PatrimonyDetail);
	
	exports.default = PatrimonyDetail;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(268);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _PatrimonySearchBar = __webpack_require__(1393);
	
	var _PatrimonySearchBar2 = _interopRequireDefault(_PatrimonySearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PatrimonyLayout = function (_Component) {
	    _inherits(PatrimonyLayout, _Component);
	
	    function PatrimonyLayout() {
	        _classCallCheck(this, PatrimonyLayout);
	
	        return _possibleConstructorReturn(this, (PatrimonyLayout.__proto__ || Object.getPrototypeOf(PatrimonyLayout)).apply(this, arguments));
	    }
	
	    _createClass(PatrimonyLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                history = _props.history,
	                routes = _props.routes,
	                params = _props.params,
	                patrimony = _props.patrimony,
	                lot = _props.lot,
	                building = _props.building;
	
	
	            var breadcrumbDisplay = function breadcrumbDisplay(token) {
	                switch (token) {
	                    case ':id':
	                        return patrimony && patrimony.ref || lot && lot.patrimony.ref || building && building.patrimony.ref;
	                    case ':lid':
	                        return lot.ref;
	                    case ':bid':
	                        return building.label;
	                    case 'patrimonycontacts':
	                        return (0, _extract2.default)(_i18n2.default, 'patrimonyContacts');
	                    default:
	                        return (0, _extract2.default)(_i18n2.default, token);
	                }
	            };
	
	            var breadcrumbDisable = function breadcrumbDisable(token) {
	                switch (token) {
	                    case 'buildings':
	                        return true;
	                    case 'patrimonycontacts':
	                        return true;
	                    default:
	                        return false;
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Patrimonies' }),
	                _react2.default.createElement(_PatrimonySearchBar2.default, null),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        _react2.default.createElement(_router.Breadcrumb, {
	                            history: history,
	                            routes: routes,
	                            params: params,
	                            display: breadcrumbDisplay,
	                            disable: breadcrumbDisable }),
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PatrimonyLayout;
	}(_react.Component);
	
	PatrimonyLayout.propTypes = {};
	
	
	PatrimonyLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        patrimony: state.patrimony.patrimony,
	        lot: state.patrimony.lot.lot,
	        building: state.patrimony.building.building
	    };
	})(PatrimonyLayout);
	
	exports.default = PatrimonyLayout;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _browser = __webpack_require__(54);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _form = __webpack_require__(15);
	
	var _SearchBar = __webpack_require__(509);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _TypeaheadBar = __webpack_require__(511);
	
	var _TypeaheadBar2 = _interopRequireDefault(_TypeaheadBar);
	
	var _Tags = __webpack_require__(892);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _models = __webpack_require__(124);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _PatrimonySearchBar = __webpack_require__(2254);
	
	var _PatrimonySearchBar2 = _interopRequireDefault(_PatrimonySearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isActive(source, identify) {
	    return function (item) {
	        var id = identify(item);
	        return source.find(function (i) {
	            return identify(i) == id;
	        }) != null;
	    };
	}
	
	var PatrimonySearchBar = function (_Component) {
	    _inherits(PatrimonySearchBar, _Component);
	
	    function PatrimonySearchBar() {
	        _classCallCheck(this, PatrimonySearchBar);
	
	        return _possibleConstructorReturn(this, (PatrimonySearchBar.__proto__ || Object.getPrototypeOf(PatrimonySearchBar)).apply(this, arguments));
	    }
	
	    _createClass(PatrimonySearchBar, [{
	        key: '_search',
	        value: function _search(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                criteria = _props.criteria,
	                location = _props.location;
	
	
	            if (event) {
	                event.preventDefault();
	            }
	
	            return dispatch((0, _actions.loadPatrimonyStream)(_extends({}, _actions.DEFAULT_PATRIMONY_QUERY, criteria))).then(function () {
	                if (location.pathname != 'patrimonies') {
	                    return dispatch((0, _reactRouterRedux.push)('/patrimonies'));
	                }
	            });
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props2 = this.props,
	                    dispatch = _props2.dispatch,
	                    criteria = _props2.criteria,
	                    location = _props2.location;
	
	
	                return dispatch((0, _actions.loadPatrimonyStream)(_extends({}, _actions.DEFAULT_PATRIMONY_QUERY, criteria))).then(function () {
	                    if (location.pathname != 'patrimonies') {
	                        return dispatch((0, _reactRouterRedux.push)('/patrimonies'));
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                criteria = _props3.criteria,
	                aggregations = _props3.aggregations,
	                location = _props3.location;
	
	
	            var agencySource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.agencies,
	                identify: function identify(a) {
	                    return a.label;
	                }
	            });
	
	            var footer = (0, _form.nodeHasValue)(form.agencyUids) && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Tags2.default, _extends({
	                    label: _i18n2.default.agency + ' :',
	                    labelClassName: 'col-sm-2',
	                    wrapperClassName: 'col-sm-10',
	                    display: function display(a) {
	                        return a.label;
	                    },
	                    active: isActive(aggregations.agencies, function (a) {
	                        return a.value;
	                    })
	                }, form.agencyUids()))
	            ) || null;
	
	            return _react2.default.createElement(
	                _SearchBar2.default,
	                _extends({
	                    footer: footer,
	                    placeholder: (0, _extract2.default)(_i18n2.default.searchStream, (0, _browser.mediaQuery)()),
	                    onClick: function onClick(e) {
	                        return _this2._search(e);
	                    },
	                    onKeyPress: function onKeyPress(e) {
	                        return _this2._searchOnKeyPress(e);
	                    }
	                }, form.fullText()),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _PatrimonySearchBar2.default.content },
	                            _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                                source: agencySource,
	                                identify: function identify(a) {
	                                    return a.value;
	                                },
	                                display: function display(a) {
	                                    return a.label + ' (' + a.count + ')';
	                                },
	                                placeholder: (0, _extract2.default)(_i18n2.default.searchAgency, (0, _browser.mediaQuery)())
	                            }, form.agencyUids()))
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PatrimonySearchBar;
	}(_react.Component);
	
	PatrimonySearchBar.propTypes = {};
	
	
	PatrimonySearchBar = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.Criteria.schema,
	    action: _actions.CRITERIA_UPDATED
	})(PatrimonySearchBar);
	
	PatrimonySearchBar = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        criteria: state.patrimony.criteria,
	        aggregations: state.patrimony.aggregations
	    };
	})(PatrimonySearchBar);
	
	exports.default = PatrimonySearchBar;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _PatrimonyStats = __webpack_require__(2255);
	
	var _PatrimonyStats2 = _interopRequireDefault(_PatrimonyStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PatrimonyStats = function (_Component) {
	    _inherits(PatrimonyStats, _Component);
	
	    function PatrimonyStats() {
	        _classCallCheck(this, PatrimonyStats);
	
	        return _possibleConstructorReturn(this, (PatrimonyStats.__proto__ || Object.getPrototypeOf(PatrimonyStats)).apply(this, arguments));
	    }
	
	    _createClass(PatrimonyStats, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                range = _props.range;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _PatrimonyStats2.default.default },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    range.count,
	                    ' ',
	                    _i18n2.default.patrimonies
	                )
	            );
	        }
	    }]);
	
	    return PatrimonyStats;
	}(_react.Component);
	
	PatrimonyStats.propTypes = {};
	
	
	PatrimonyStats = (0, _reactRedux.connect)(function (state) {
	    return {
	        range: state.patrimony.range
	    };
	})(PatrimonyStats);
	
	exports.default = PatrimonyStats;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(74);
	
	var _PatrimonyCard = __webpack_require__(1389);
	
	var _PatrimonyCard2 = _interopRequireDefault(_PatrimonyCard);
	
	var _PatrimonyStream = __webpack_require__(2256);
	
	var _PatrimonyStream2 = _interopRequireDefault(_PatrimonyStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var PatrimonyStream = function (_Component) {
	    _inherits(PatrimonyStream, _Component);
	
	    function PatrimonyStream() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PatrimonyStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PatrimonyStream.__proto__ || Object.getPrototypeOf(PatrimonyStream)).call.apply(_ref, [this].concat(args))), _this), _this._navigate = function (patrimony) {
	            return function (event) {
	                var dispatch = _this.props.dispatch;
	
	
	                event.preventDefault();
	
	                if (event.ctrlKey || event.metaKey) {
	                    window.open('/patrimonies/' + patrimony.uid, '_blank');
	                } else {
	                    dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.uid));
	                }
	            };
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PatrimonyStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadPatrimonyStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (patrimony) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: patrimony.uid,
	                                sm: 6 },
	                            _react2.default.createElement(_PatrimonyCard2.default, {
	                                patrimony: patrimony,
	                                onClick: _this2._navigate(patrimony) })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _PatrimonyStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, {
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        },
	                        prev: true, next: true, first: true, last: true, ellipsis: true })
	                )
	            );
	        }
	    }]);
	
	    return PatrimonyStream;
	}(_react.Component);
	
	PatrimonyStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	PatrimonyStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.patrimony.stream,
	        range: state.patrimony.range
	    };
	})(PatrimonyStream);
	
	exports.default = PatrimonyStream;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _PatrimonyStream = __webpack_require__(1395);
	
	var _PatrimonyStream2 = _interopRequireDefault(_PatrimonyStream);
	
	var _PatrimonyStats = __webpack_require__(1394);
	
	var _PatrimonyStats2 = _interopRequireDefault(_PatrimonyStats);
	
	var _ReferencePatrimonyModal = __webpack_require__(1397);
	
	var _ReferencePatrimonyModal2 = _interopRequireDefault(_ReferencePatrimonyModal);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PatrimonyStreamLayout = function (_Component) {
	    _inherits(PatrimonyStreamLayout, _Component);
	
	    function PatrimonyStreamLayout(props) {
	        _classCallCheck(this, PatrimonyStreamLayout);
	
	        var _this = _possibleConstructorReturn(this, (PatrimonyStreamLayout.__proto__ || Object.getPrototypeOf(PatrimonyStreamLayout)).call(this, props));
	
	        _this.state = {
	            opened: false
	        };
	        return _this;
	    }
	
	    _createClass(PatrimonyStreamLayout, [{
	        key: '_open',
	        value: function _open() {
	            this.setState({ opened: true });
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({ opened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                authenticated = _props.authenticated,
	                _links = _props._links;
	            var opened = this.state.opened;
	
	
	            var newPatrimonyBoxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.newPatrimony
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smPush: 8 },
	                        _react2.default.createElement(_PatrimonyStats2.default, null),
	                        _links.find((0, _links2.linkFinder)('ReferencePatrimony')) && (authenticated.managedAgencies || authenticated.company) && _react2.default.createElement(_Box2.default, {
	                            status: 'primary',
	                            header: newPatrimonyBoxTitle,
	                            help: '+',
	                            onClick: function onClick() {
	                                return _this2._open();
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8, smPull: 4 },
	                        _react2.default.createElement(_PatrimonyStream2.default, null)
	                    )
	                ),
	                _links.find((0, _links2.linkFinder)('ReferencePatrimony')) && (authenticated.managedAgencies || authenticated.company) && _react2.default.createElement(_ReferencePatrimonyModal2.default, {
	                    user: authenticated,
	                    show: opened,
	                    onHide: function onHide() {
	                        return _this2._close();
	                    } })
	            );
	        }
	    }]);
	
	    return PatrimonyStreamLayout;
	}(_react.Component);
	
	PatrimonyStreamLayout.propTypes = {};
	
	
	PatrimonyStreamLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        _links: state.patrimony._links,
	        authenticated: state.user.authenticated
	    };
	})(PatrimonyStreamLayout);
	
	exports.default = PatrimonyStreamLayout;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _AgencySelectInput = __webpack_require__(888);
	
	var _AgencySelectInput2 = _interopRequireDefault(_AgencySelectInput);
	
	var _models = __webpack_require__(124);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferencePatrimonyModal = function (_Component) {
	    _inherits(ReferencePatrimonyModal, _Component);
	
	    function ReferencePatrimonyModal() {
	        _classCallCheck(this, ReferencePatrimonyModal);
	
	        return _possibleConstructorReturn(this, (ReferencePatrimonyModal.__proto__ || Object.getPrototypeOf(ReferencePatrimonyModal)).apply(this, arguments));
	    }
	
	    _createClass(ReferencePatrimonyModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendReferencePatrimonyCmd)()).then(function () {
	                return dispatch((0, _actions.loadPatrimonyStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                user = _props2.user,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'user', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.newPatrimony
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'reference',
	                            label: requiredLabel(_i18n2.default.reference)
	                        }, form.ref())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'label',
	                            label: requiredLabel(_i18n2.default.label)
	                        }, form.label())),
	                        _react2.default.createElement(_AgencySelectInput2.default, _extends({ multiple: true,
	                            user: user,
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            name: 'agency',
	                            label: requiredLabel(_i18n2.default.agency)
	                        }, (0, _form.selectField)(form.agencyUids(), true)))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReferencePatrimonyModal;
	}(_react.Component);
	
	ReferencePatrimonyModal.propTypes = {
	    user: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReferencePatrimonyModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ReferencePatrimonyCmd.schema,
	    action: _actions.REFERENCE_PATRIMONY_CMD_UPDATED
	})(ReferencePatrimonyModal);
	
	ReferencePatrimonyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.patrimony.referencePatrimonyCmd
	    };
	})(ReferencePatrimonyModal);
	
	exports.default = ReferencePatrimonyModal;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _RemoveLinkFromPatrimonyContactPopover = __webpack_require__(2259);
	
	var _RemoveLinkFromPatrimonyContactPopover2 = _interopRequireDefault(_RemoveLinkFromPatrimonyContactPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RemoveLinkFromPatrimonyContactPopover = function (_Component) {
	    _inherits(RemoveLinkFromPatrimonyContactPopover, _Component);
	
	    function RemoveLinkFromPatrimonyContactPopover() {
	        _classCallCheck(this, RemoveLinkFromPatrimonyContactPopover);
	
	        return _possibleConstructorReturn(this, (RemoveLinkFromPatrimonyContactPopover.__proto__ || Object.getPrototypeOf(RemoveLinkFromPatrimonyContactPopover)).apply(this, arguments));
	    }
	
	    _createClass(RemoveLinkFromPatrimonyContactPopover, [{
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd(event, linkedWith) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendRemoveLinkFromPatrimonyContactCmd)(linkedWith)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contact = _props.contact,
	                onHide = _props.onHide,
	                others = _objectWithoutProperties(_props, ['dispatch', 'contact', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.unlinkPatrimonyContact
	                }, others),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _RemoveLinkFromPatrimonyContactPopover2.default.linkedWithGroup },
	                    contact.linkedWith.map(function (linkedWith, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _RemoveLinkFromPatrimonyContactPopover2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return _this2._sendRemoveCmd(e, linkedWith);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                linkedWith.linkType == 'LinkToPatrimonyAsHomeOwnerAssociation' && _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    (0, _extract2.default)(_i18n2.default.homeOwnerAssociationPositionEnum, linkedWith.position),
	                                    ' -'
	                                ),
	                                linkedWith.linkType != 'LinkToPatrimonyAsHomeOwnerAssociation' && _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    (0, _extract2.default)(_i18n2.default.patrimonyContactLinkTypeEnum, linkedWith.linkType),
	                                    ' -'
	                                ),
	                                linkedWith.patrimony && _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    linkedWith.patrimony.label
	                                ),
	                                linkedWith.patrimony && linkedWith.patrimony.ref && _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' (',
	                                    linkedWith.patrimony.ref,
	                                    ')'
	                                ),
	                                linkedWith.lot && _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    linkedWith.lot.ref
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RemoveLinkFromPatrimonyContactPopover;
	}(_react.Component);
	
	RemoveLinkFromPatrimonyContactPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	RemoveLinkFromPatrimonyContactPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        contact: state.patrimony.contact.contact
	    };
	})(RemoveLinkFromPatrimonyContactPopover);
	
	exports.default = RemoveLinkFromPatrimonyContactPopover;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _matcher = __webpack_require__(958);
	
	var _matcher2 = _interopRequireDefault(_matcher);
	
	var _extract = __webpack_require__(12);
	
	var _regexpz = __webpack_require__(1359);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Picker = __webpack_require__(260);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getIds(array) {
	    array = array instanceof Array && array || array && [array] || [];
	
	    return array.map(function (v) {
	        return v.uid || v;
	    });
	}
	
	function contactMatcher(source) {
	    return function (query, cb) {
	        var matches;
	
	        if (query && (query.name || query.contacts)) {
	            var firstNameRegexp = query.name && query.name.firstName && new RegExp((0, _regexpz.escapeRegExp)(query.name.firstName), 'i');
	            var lastNameRegexp = query.name && query.name.lastName && new RegExp((0, _regexpz.escapeRegExp)(query.name.lastName), 'i');
	            var phoneRegexp = query.contacts && query.contacts.phone && new RegExp((0, _regexpz.escapeRegExp)((0, _phonez2.default)(query.contacts.phone).toNational()), 'i');
	            var mailRegexp = query.contacts && query.contacts.mail && new RegExp((0, _regexpz.escapeRegExp)(query.contacts.mail), 'i');
	            var faxRegexp = query.contacts && query.contacts.fax && new RegExp((0, _regexpz.escapeRegExp)((0, _phonez2.default)(query.contacts.fax).toNational()), 'i');
	
	            matches = source.filter(function (contact) {
	                var match = true;
	                match = match && (!firstNameRegexp || firstNameRegexp.test(contact.name.firstName || contact.name.value));
	                match = match && (!lastNameRegexp || lastNameRegexp.test(contact.name.lastName || contact.name.value));
	                match = match && (!phoneRegexp || !!contact.contacts.find(function (c) {
	                    return c.phone && phoneRegexp.test(c.phone);
	                }));
	                match = match && (!mailRegexp || !!contact.contacts.find(function (c) {
	                    return c.mail && mailRegexp.test(c.mail);
	                }));
	                match = match && (!faxRegexp || !!contact.contacts.find(function (c) {
	                    return c.fax && faxRegexp.test(c.fax);
	                }));
	                return match;
	            });
	        } else {
	            matches = source;
	        }
	
	        cb(matches);
	    };
	
	    return (0, _matcher2.default)({
	        source: stream,
	        identify: function identify(c) {
	            return c.name.firstName + ' ' + c.name.lastName;
	        }
	    });
	}
	
	var TypeaheadContactPicker = function (_Component) {
	    _inherits(TypeaheadContactPicker, _Component);
	
	    function TypeaheadContactPicker(props) {
	        _classCallCheck(this, TypeaheadContactPicker);
	
	        var _this = _possibleConstructorReturn(this, (TypeaheadContactPicker.__proto__ || Object.getPrototypeOf(TypeaheadContactPicker)).call(this, props));
	
	        _this.state = {
	            source: function source() {
	                return null;
	            },
	            matches: []
	        };
	        return _this;
	    }
	
	    _createClass(TypeaheadContactPicker, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                patrimonies = _props.patrimonies;
	
	
	            dispatch((0, _actions.queryMinorContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, { patrimonyUids: getIds(patrimonies), range: { offset: 0, limit: 999 } })));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.patrimonies != this.props.patrimonies) {
	                var dispatch = nextProps.dispatch,
	                    patrimonies = nextProps.patrimonies;
	
	
	                dispatch((0, _actions.queryMinorContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, { patrimonyUids: getIds(patrimonies), range: { offset: 0, limit: 999 } })));
	            }
	            if (nextProps.stream != this.props.stream) {
	                var _stream = nextProps.stream,
	                    query = nextProps.query;
	
	
	                var source = contactMatcher(_stream);
	                source(query, function (matches) {
	                    _this2.setState({ source: source, matches: matches });
	                });
	            }
	            if (nextProps.query != this.props.query) {
	                var _query = nextProps.query;
	                var _source = this.state.source;
	
	
	                _source(_query, function (matches) {
	                    _this2.setState({ matches: matches });
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                stream = _props2.stream,
	                range = _props2.range,
	                query = _props2.query,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'stream', 'range', 'query']);
	
	            var matches = this.state.matches;
	
	
	            var afterContacts = function afterContacts() {
	                if (range && range.limit < range.count - 1) {
	                    var count = range.limit + 1;
	                    return _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _extract.replace)(_i18n2.default.useSearchContactFilters, { count: count })
	                    );
	                }
	            };
	
	            var displayContact = function displayContact(contact, mode) {
	                var phoneMedium = contact.contacts.find(function (c) {
	                    return c.contactInfoType == 'Phone';
	                });
	
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'h4',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            contact.name.firstName
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            ' ',
	                            contact.name.lastName
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            contact.name.value
	                        ),
	                        phoneMedium && _react2.default.createElement(
	                            'span',
	                            null,
	                            ' (',
	                            (0, _phonez2.default)(phoneMedium.phone).format(),
	                            ')'
	                        )
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        contact.name.firstName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        contact.name.lastName
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        contact.name.value
	                    ),
	                    phoneMedium && _react2.default.createElement(
	                        'span',
	                        null,
	                        ' (',
	                        (0, _phonez2.default)(phoneMedium.phone).format(),
	                        ')'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Picker2.default, _extends({
	                    source: matches,
	                    identify: function identify(c) {
	                        return c.uid;
	                    },
	                    display: displayContact,
	                    after: afterContacts()
	                }, others))
	            );
	        }
	    }]);
	
	    return TypeaheadContactPicker;
	}(_react.Component);
	
	TypeaheadContactPicker.propTypes = {
	    patrimonies: _react.PropTypes.any,
	    query: _react.PropTypes.object
	};
	
	
	TypeaheadContactPicker = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.patrimony.contact.minorStream,
	        range: state.patrimony.contact.minorRange
	    };
	})(TypeaheadContactPicker);
	
	exports.default = TypeaheadContactPicker;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _links = __webpack_require__(33);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _models = __webpack_require__(124);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateLotPopover = __webpack_require__(2260);
	
	var _UpdateLotPopover2 = _interopRequireDefault(_UpdateLotPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function usageGroupFinder(usage) {
	    return function (group) {
	        return _models.USAGES[group].find(function (u) {
	            return u == usage;
	        }) != null;
	    };
	}
	
	var UpdateLotPopover = function (_Component) {
	    _inherits(UpdateLotPopover, _Component);
	
	    function UpdateLotPopover(props) {
	        _classCallCheck(this, UpdateLotPopover);
	
	        var _this = _possibleConstructorReturn(this, (UpdateLotPopover.__proto__ || Object.getPrototypeOf(UpdateLotPopover)).call(this, props));
	
	        _this.state = {
	            activeUsageGroup: Object.keys(_models.USAGES)[0]
	        };
	        return _this;
	    }
	
	    _createClass(UpdateLotPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                lot = _props.lot;
	
	            dispatch((0, _actions.resetUpdateLotCmd)());
	
	            var activeUsageGroup = Object.keys(_models.USAGES).find(usageGroupFinder(lot.usage));
	            this.setState({ activeUsageGroup: activeUsageGroup });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.lot != this.props.lot) {
	                var dispatch = nextProps.dispatch,
	                    lot = nextProps.lot;
	
	                dispatch((0, _actions.resetUpdateLotCmd)());
	
	                var activeUsageGroup = Object.keys(_models.USAGES).find(usageGroupFinder(lot.usage));
	                this.setState({ activeUsageGroup: activeUsageGroup });
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdateLotCmd)()).then(function () {
	                return dispatch((0, _actions.loadLot)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_selectUsageGroup',
	        value: function _selectUsageGroup(event, group) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            dispatch((0, _actions.updateUpdateLotCmd)({ usage: _models.USAGES[group][0] }));
	            this.setState({ activeUsageGroup: group });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                lot = _props3.lot,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'lot', 'onHide']);
	
	            var activeUsageGroup = this.state.activeUsageGroup;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var tooltipInputAddon = function tooltipInputAddon(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(text) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: _UpdateLotPopover2.default.info },
	                        '?'
	                    )
	                );
	            };
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    bsClass: 'popover-md popover',
	                    title: _i18n2.default.updateLot
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _UpdateLotPopover2.default.usageGroup },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xsHidden: true, sm: 3 },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                'type'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _UpdateLotPopover2.default.container },
	                                Object.keys(_models.USAGES).map(function (group, index) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        {
	                                            key: index,
	                                            className: (0, _classnames2.default)(_defineProperty({}, _UpdateLotPopover2.default.active, activeUsageGroup == group)) },
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._selectUsageGroup(e, group);
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, {
	                                                icon: group,
	                                                size: 'md',
	                                                active: activeUsageGroup == group }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                (0, _extract2.default)(_i18n2.default.usageGroupEnum, group)
	                                            )
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'usage',
	                            label: requiredLabel(_i18n2.default.usage)
	                        }, (0, _form.updateField)(form.usage(), lot.usage)),
	                        _react2.default.createElement('option', { value: '' }),
	                        _models.USAGES[activeUsageGroup].map(function (usage, index) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: index,
	                                    value: usage },
	                                (0, _extract2.default)(_i18n2.default.usageEnum, usage)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'reference',
	                        label: requiredLabel(_i18n2.default.reference),
	                        addonAfter: tooltipInputAddon(_i18n2.default.referenceInfo)
	                    }, (0, _form.updateField)(form.ref(), lot.ref))),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'lotNumber',
	                        label: requiredLabel(_i18n2.default.lotNumber),
	                        addonAfter: tooltipInputAddon(_i18n2.default.lotNumberInfo)
	                    }, (0, _form.updateField)(form.lotNumber(), lot.lotNumber)))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                ),
	                lot._links.find((0, _links.linkFinder)('DeleteLot')) && _react2.default.createElement(
	                    'div',
	                    { className: _UpdateLotPopover2.default.delete },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return onHide(e, 'DeleteLot');
	                            } },
	                        _i18n2.default.deleteLot
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateLotPopover;
	}(_react.Component);
	
	UpdateLotPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateLotPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.UpdateLotCmd.schema,
	    validator: (0, _models.createValidator)(),
	    action: _actions.UPDATE_LOT_CMD_UPDATED
	})(UpdateLotPopover);
	
	UpdateLotPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.patrimony.updateLotCmd,
	        lot: state.patrimony.lot.lot
	    };
	})(UpdateLotPopover);
	
	exports.default = UpdateLotPopover;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _places = __webpack_require__(261);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _actions = __webpack_require__(74);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdatePatrimonyContactIdentityPopover = function (_Component) {
	    _inherits(UpdatePatrimonyContactIdentityPopover, _Component);
	
	    function UpdatePatrimonyContactIdentityPopover() {
	        _classCallCheck(this, UpdatePatrimonyContactIdentityPopover);
	
	        return _possibleConstructorReturn(this, (UpdatePatrimonyContactIdentityPopover.__proto__ || Object.getPrototypeOf(UpdatePatrimonyContactIdentityPopover)).apply(this, arguments));
	    }
	
	    _createClass(UpdatePatrimonyContactIdentityPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contact = _props.contact;
	
	
	            dispatch((0, _actions.updateUpdatePatrimonyContactIdentityCmd)({
	                company: contact.company,
	                namez: contact.name,
	                address: contact.address
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.contact != this.props.contact) {
	                var dispatch = nextProps.dispatch,
	                    contact = nextProps.contact;
	
	
	                dispatch((0, _actions.updateUpdatePatrimonyContactIdentityCmd)({
	                    company: contact.company,
	                    namez: contact.name,
	                    address: contact.address
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdatePatrimonyContactIdentityCmd)()).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                contact = _props3.contact,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'contact', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var addressTypeaheadButton = function addressTypeaheadButton() {
	                if (cmd && cmd.address) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        (0, _form.buttonField)(form.address(), null),
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.updatePatrimonyContact
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'company',
	                        label: _i18n2.default.company
	                    }, form.namez.company())),
	                    _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'gender',
	                            label: _i18n2.default.gender
	                        }, form.namez.gender()),
	                        _react2.default.createElement('option', { value: '' }),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Male' },
	                            _i18n2.default.genderEnum.male
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Female' },
	                            _i18n2.default.genderEnum.female
	                        )
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'firstName',
	                        label: requiredLabel(_i18n2.default.firstName)
	                    }, form.namez.firstName())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'lastName',
	                        label: requiredLabel(_i18n2.default.lastName)
	                    }, form.namez.lastName()))
	                ),
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _i18n2.default.address
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'digicode',
	                                placeholder: _i18n2.default.addressDigicode
	                            }, form.address.digicode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'staircase',
	                                placeholder: _i18n2.default.addressStaircase
	                            }, form.address.staircase()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'floor',
	                                placeholder: _i18n2.default.addressFloor
	                            }, form.address.floor()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                ref: 'typeahead',
	                                source: _places.autocompleteMatcher,
	                                display: _places.displayPrediction,
	                                highlight: _places.highlightPrediction,
	                                placeholder: _i18n2.default.addAddress,
	                                buttonAfter: addressTypeaheadButton()
	                            }, (0, _places.addressField)(form.address())))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'number',
	                                placeholder: _i18n2.default.addressNumber
	                            }, form.address.number()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'street',
	                                placeholder: _i18n2.default.addressStreet
	                            }, form.address.street()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'zipCode',
	                                placeholder: _i18n2.default.addressZipCode
	                            }, form.address.zipCode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'city',
	                                placeholder: _i18n2.default.addressCity
	                            }, form.address.city()))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdatePatrimonyContactIdentityPopover;
	}(_react.Component);
	
	UpdatePatrimonyContactIdentityPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdatePatrimonyContactIdentityPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.UpdatePatrimonyContactIdentityCmd.schema,
	    action: _actions.UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED
	})(UpdatePatrimonyContactIdentityPopover);
	
	UpdatePatrimonyContactIdentityPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.patrimony.updatePatrimonyContactIdentityCmd,
	        contact: state.patrimony.contact.contact
	    };
	})(UpdatePatrimonyContactIdentityPopover);
	
	exports.default = UpdatePatrimonyContactIdentityPopover;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _models = __webpack_require__(124);
	
	var _actions = __webpack_require__(74);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdatePatrimonyPopover = function (_Component) {
	    _inherits(UpdatePatrimonyPopover, _Component);
	
	    function UpdatePatrimonyPopover() {
	        _classCallCheck(this, UpdatePatrimonyPopover);
	
	        return _possibleConstructorReturn(this, (UpdatePatrimonyPopover.__proto__ || Object.getPrototypeOf(UpdatePatrimonyPopover)).apply(this, arguments));
	    }
	
	    _createClass(UpdatePatrimonyPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                form = _props.form,
	                patrimony = _props.patrimony;
	
	
	            form().onChange({
	                ref: patrimony.ref,
	                label: patrimony.label
	            });
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdatePatrimonyCmd)()).then(function () {
	                return dispatch((0, _actions.loadPatrimony)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                patrimony = _props3.patrimony,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'patrimony', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.updatePatrimony
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'reference',
	                        label: requiredLabel(_i18n2.default.reference)
	                    }, form.ref())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'label',
	                        label: requiredLabel(_i18n2.default.label)
	                    }, form.label()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdatePatrimonyPopover;
	}(_react.Component);
	
	UpdatePatrimonyPopover.displayName = 'ReferencePatrimonyModal';
	UpdatePatrimonyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdatePatrimonyPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.UpdatePatrimonyCmd.schema,
	    action: _actions.UPDATE_PATRIMONY_CMD_UPDATED
	})(UpdatePatrimonyPopover);
	
	UpdatePatrimonyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.patrimony.updatePatrimonyCmd,
	        patrimony: state.patrimony.patrimony
	    };
	})(UpdatePatrimonyPopover);
	
	exports.default = UpdatePatrimonyPopover;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _PatrimonyUserModal = __webpack_require__(2261);
	
	var _PatrimonyUserModal2 = _interopRequireDefault(_PatrimonyUserModal);
	
	var _actions = __webpack_require__(46);
	
	var _actions2 = __webpack_require__(74);
	
	var _reactRedux = __webpack_require__(4);
	
	var _links = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var requiredLabel = function requiredLabel(label) {
	    return _react2.default.createElement(
	        'span',
	        null,
	        label,
	        ' ',
	        _react2.default.createElement(
	            'i',
	            null,
	            '*'
	        )
	    );
	};
	
	var getTitle = function getTitle(contact) {
	    return _i18n2.default.patrimonyUser.title[(0, _actions2.getPatrimonyUserState)(contact)];
	};
	
	var getModalBody = function getModalBody(contact) {
	    return {
	        NoAccount: ModalNoAccount,
	        NotActiveAccount: ModalNotActiveAccount,
	        ActiveAccount: ModalActiveAccount
	    }[(0, _actions2.getPatrimonyUserState)(contact)];
	};
	
	var dispatchUpdateCmd = function dispatchUpdateCmd(props) {
	    var dispatch = props.dispatch,
	        patrimonyContact = props.patrimonyContact,
	        show = props.show;
	
	    if (typeof show === 'boolean') {
	        dispatch((0, _actions2.updateReferenceUserCmd)(show, patrimonyContact));
	    }
	};
	
	var PatrimonyUserModal = function (_Component) {
	    _inherits(PatrimonyUserModal, _Component);
	
	    function PatrimonyUserModal() {
	        _classCallCheck(this, PatrimonyUserModal);
	
	        return _possibleConstructorReturn(this, (PatrimonyUserModal.__proto__ || Object.getPrototypeOf(PatrimonyUserModal)).apply(this, arguments));
	    }
	
	    _createClass(PatrimonyUserModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            dispatchUpdateCmd(this.props);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            dispatchUpdateCmd(nextProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                patrimonyContact = _props.patrimonyContact,
	                onHide = _props.onHide,
	                dispatch = _props.dispatch,
	                patrimonyUid = _props.patrimonyUid,
	                others = _objectWithoutProperties(_props, ['patrimonyContact', 'onHide', 'dispatch', 'patrimonyUid']);
	
	            var ModalBody = getModalBody(patrimonyContact);
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        getTitle(patrimonyContact)
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(ModalBody, { contact: patrimonyContact, onHide: onHide, dispatch: dispatch, patrimonyUid: patrimonyUid })
	                )
	            );
	        }
	    }]);
	
	    return PatrimonyUserModal;
	}(_react.Component);
	
	// ActiveAccount: "Désactiver l'utilisateur" (juste un lien)
	
	
	PatrimonyUserModal.propTypes = {
	    patrimonyContact: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	var ModalActiveAccount = function (_Component2) {
	    _inherits(ModalActiveAccount, _Component2);
	
	    function ModalActiveAccount() {
	        var _ref;
	
	        var _temp, _this2, _ret;
	
	        _classCallCheck(this, ModalActiveAccount);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = ModalActiveAccount.__proto__ || Object.getPrototypeOf(ModalActiveAccount)).call.apply(_ref, [this].concat(args))), _this2), _this2.onClick = function (event) {
	            var _this2$props = _this2.props,
	                dispatch = _this2$props.dispatch,
	                onHide = _this2$props.onHide,
	                contact = _this2$props.contact;
	
	
	            event.preventDefault();
	            return dispatch((0, _actions.sendDisableUserCmd)(contact.patrimonyUserState.userUid)).then(function () {
	                return dispatch((0, _actions2.loadContactStream)());
	            }).then(function () {
	                onHide();
	            });
	        }, _temp), _possibleConstructorReturn(_this2, _ret);
	    }
	
	    _createClass(ModalActiveAccount, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: _PatrimonyUserModal2.default.send },
	                _react2.default.createElement(
	                    'a',
	                    { onClick: this.onClick },
	                    _i18n2.default.user.disable
	                )
	            );
	        }
	    }]);
	
	    return ModalActiveAccount;
	}(_react.Component);
	
	var ValueComponent = function (_Component3) {
	    _inherits(ValueComponent, _Component3);
	
	    function ValueComponent() {
	        var _ref2;
	
	        var _temp2, _this3, _ret2;
	
	        _classCallCheck(this, ValueComponent);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = ValueComponent.__proto__ || Object.getPrototypeOf(ValueComponent)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {}, _this3.onChange = function (e) {
	            _this3.setValue(e.target.value);
	        }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	    }
	
	    _createClass(ValueComponent, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setValue((0, _actions2.getLogin)(this.props.contact));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps, nextContext) {
	            this.setValue((0, _actions2.getLogin)(nextProps.contact));
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	            return this.state.value !== nextState.value;
	        }
	    }, {
	        key: 'setValue',
	        value: function setValue(value) {
	            this.setState({
	                value: value
	            });
	        }
	    }]);
	
	    return ValueComponent;
	}(_react.Component);
	
	// NotActiveAccount: "Modifier le login" (input login + link renvoyer mail d'activation)
	
	
	var ModalNotActiveAccount = function (_ValueComponent) {
	    _inherits(ModalNotActiveAccount, _ValueComponent);
	
	    function ModalNotActiveAccount() {
	        var _ref3;
	
	        var _temp3, _this4, _ret3;
	
	        _classCallCheck(this, ModalNotActiveAccount);
	
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	        }
	
	        return _ret3 = (_temp3 = (_this4 = _possibleConstructorReturn(this, (_ref3 = ModalNotActiveAccount.__proto__ || Object.getPrototypeOf(ModalNotActiveAccount)).call.apply(_ref3, [this].concat(args))), _this4), _this4._sendActivationEmail = function (event) {
	            var _this4$props = _this4.props,
	                dispatch = _this4$props.dispatch,
	                onHide = _this4$props.onHide,
	                contact = _this4$props.contact;
	
	
	            event.preventDefault();
	            return dispatch((0, _actions.sendSendActivationEmailDemand)(contact.patrimonyUserState.userUid)).then(function () {
	                return dispatch((0, _status.infoStatus)(_i18n2.default.user.activationEmailSent));
	            }).then(function () {
	                onHide();
	            });
	        }, _this4._sendUpdateLoginCmd = function () {
	            var _this4$props2 = _this4.props,
	                dispatch = _this4$props2.dispatch,
	                onHide = _this4$props2.onHide,
	                contact = _this4$props2.contact;
	            var value = _this4.state.value;
	
	
	            return dispatch((0, _actions2.sendUpdateLoginCmd)(contact.patrimonyUserState.userUid, value)).then(function () {
	                return dispatch((0, _actions2.loadContactStream)());
	            }).then(function () {
	                onHide();
	            });
	        }, _temp3), _possibleConstructorReturn(_this4, _ret3);
	    }
	
	    _createClass(ModalNotActiveAccount, [{
	        key: 'render',
	        value: function render() {
	            var value = this.state.value;
	            var onHide = this.props.onHide;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, {
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'login',
	                            label: requiredLabel(_i18n2.default.user.login),
	                            value: value,
	                            onChange: this.onChange
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                onClick: this._sendUpdateLoginCmd,
	                                bsSize: 'large' },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _PatrimonyUserModal2.default.send },
	                    _react2.default.createElement(
	                        'a',
	                        { onClick: this._sendActivationEmail },
	                        _i18n2.default.user.sendActivationEmail
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalNotActiveAccount;
	}(ValueComponent);
	
	// NoAccount: "Créer un compte utilisateur" input login
	
	
	var ModalNoAccount = function (_ValueComponent2) {
	    _inherits(ModalNoAccount, _ValueComponent2);
	
	    function ModalNoAccount() {
	        var _ref4;
	
	        var _temp4, _this5, _ret4;
	
	        _classCallCheck(this, ModalNoAccount);
	
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	            args[_key4] = arguments[_key4];
	        }
	
	        return _ret4 = (_temp4 = (_this5 = _possibleConstructorReturn(this, (_ref4 = ModalNoAccount.__proto__ || Object.getPrototypeOf(ModalNoAccount)).call.apply(_ref4, [this].concat(args))), _this5), _this5._end = function () {
	            var _this5$props = _this5.props,
	                dispatch = _this5$props.dispatch,
	                onHide = _this5$props.onHide;
	
	            onHide();
	            setTimeout(function () {
	                return dispatch((0, _actions2.loadContactStream)());
	            }, 1000);
	        }, _this5._sendLink = function () {
	            var _this5$props2 = _this5.props,
	                dispatch = _this5$props2.dispatch,
	                contact = _this5$props2.contact,
	                patrimonyUid = _this5$props2.patrimonyUid;
	
	
	            return dispatch((0, _actions2.sendLinkPatrimonyContactWithUser)(patrimonyUid, contact.uid)).then(_this5._end);
	        }, _this5._sendCmd = function () {
	            var dispatch = _this5.props.dispatch;
	            var value = _this5.state.value;
	
	
	            return dispatch((0, _actions2.sendReferenceUserCmd)(value)).then(function (referenceCmdUserSent) {
	                var status = referenceCmdUserSent.status,
	                    errorType = referenceCmdUserSent.errorType;
	
	                if (status === 400 && errorType === 'UserAlreadyExist') {
	                    _this5.setState({ error: true });
	                    return Promise.resolve();
	                } else if (status === 400) {
	                    return (0, _status.errorStatus)(errorType);
	                }
	                return _this5._sendLink();
	            });
	        }, _temp4), _possibleConstructorReturn(_this5, _ret4);
	    }
	
	    _createClass(ModalNoAccount, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	            return _get(ModalNoAccount.prototype.__proto__ || Object.getPrototypeOf(ModalNoAccount.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState, nextContext) || this.state.error !== nextState.error;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state,
	                value = _state.value,
	                error = _state.error;
	            var onHide = this.props.onHide;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, {
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'login',
	                        value: value,
	                        disabled: error,
	                        onChange: this.onChange,
	                        label: requiredLabel(_i18n2.default.user.login) })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    error ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _i18n2.default.patrimonyUser.linkToUserError
	                    ) : null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            onClick: error ? this._sendLink : this._sendCmd
	                        },
	                        error ? _i18n2.default.patrimonyUser.linkToUser : _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ModalNoAccount;
	}(ValueComponent);
	
	PatrimonyUserModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        patrimonyUid: state.patrimony.patrimony.uid
	    };
	})(PatrimonyUserModal);
	
	exports.default = PatrimonyUserModal;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(74);
	
	function patrimony() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_LOADED:
	            return action.patrimony;
	        default:
	            return state;
	    }
	}
	
	function patrimonyBuildings() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_LOADED:
	            return action.patrimonyBuildings;
	        default:
	            return state;
	    }
	}
	
	function patrimonyLots() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_LOADED:
	            return action.patrimonyLots;
	        default:
	            return state;
	    }
	}
	
	function patrimonyContacts() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_LOADED:
	            return action.patrimonyContacts;
	        default:
	            return state;
	    }
	}
	
	function stream() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_STREAM_LOADED:
	        case _actions.PATRIMONY_STREAM_QUERIED:
	            return action.stream;
	        default:
	            return state;
	    }
	}
	
	function aggregations() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_STREAM_LOADED:
	        case _actions.PATRIMONY_STREAM_QUERIED:
	            return action.aggregations;
	        default:
	            return state;
	    }
	}
	
	function range() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_STREAM_LOADED:
	        case _actions.PATRIMONY_STREAM_QUERIED:
	            return action.range;
	        default:
	            return state;
	    }
	}
	
	function query() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_STREAM_LOADED:
	        case _actions.PATRIMONY_STREAM_QUERIED:
	            return action.query;
	        default:
	            return state;
	    }
	}
	
	function _links() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PATRIMONY_STREAM_LOADED:
	        case _actions.PATRIMONY_STREAM_QUERIED:
	        case _actions.LINKS_LOADED:
	            return action._links;
	        default:
	            return state;
	    }
	}
	
	function criteria() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CRITERIA_UPDATED:
	            return _extends({}, state, action.criteria);
	        default:
	            return state;
	    }
	}
	
	function minorCriteria() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.MINOR_CRITERIA_UPDATED:
	            return _extends({}, state, action.minorCriteria);
	        case _actions.MINOR_CRITERIA_RESETTED:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function referencePatrimonyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REFERENCE_PATRIMONY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.REFERENCE_PATRIMONY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function referenceLotCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REFERENCE_LOT_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.REFERENCE_LOT_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function referencePatrimonyContactCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.REFERENCE_PATRIMONY_CONTACT_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updatePatrimonyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_PATRIMONY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.UPDATE_PATRIMONY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateLotCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_LOT_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.UPDATE_LOT_CMD_SENT:
	        case _actions.UPDATE_LOT_CMD_RESET:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function addComplementaryAddressToPatrimonyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function addAddressToLotCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ADD_ADDRESS_TO_LOT_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ADD_ADDRESS_TO_LOT_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function linkPatrimonyContactWithCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.LINK_PATRIMONY_CONTACT_WITH_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updatePatrimonyContactIdentityCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED:
	            var cmd = action.cmd;
	            var namez = cmd.namez;
	            var nameType = namez.nameType,
	                value = namez.value,
	                lastName = namez.lastName;
	
	            var definedLastName = nameType === 'PoorName' ? value : lastName;
	            return _extends({}, state, action.cmd, { namez: _extends({}, namez, { lastName: definedLastName }) });
	        case _actions.UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function addContactCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ADD_CONTACT_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ADD_CONTACT_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateUserCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_USER_CMD_UPDATED:
	            return action.cmd ? _extends({}, action.cmd) : null;
	        case _actions.REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED:
	            var _action$cmd = action.cmd,
	                shouldCreateUser = _action$cmd.shouldCreateUser,
	                contacts = _action$cmd.contacts,
	                namez = _action$cmd.namez;
	
	            var _ref = state ? state : { firstName: null, lastName: null, login: null, shouldCreateUser: false },
	                cmdFirstName = _ref.firstName,
	                cmdLastName = _ref.lastName,
	                cmdLogin = _ref.login,
	                cmdShouldCreateUser = _ref.shouldCreateUser;
	
	            var _ref2 = namez ? namez : { firstName: cmdFirstName, lastName: cmdLastName },
	                firstName = _ref2.firstName,
	                lastName = _ref2.lastName;
	
	            var mails = contacts ? contacts.find(function (c) {
	                return c.contactInfoType === 'Mail';
	            }) : { mail: cmdLogin };
	
	            var _ref3 = mails ? mails : { mail: null },
	                mail = _ref3.mail;
	
	            var cmd = {
	                commandType: 'ReferencePatrimonyUser',
	                login: mail,
	                lastName: lastName,
	                firstName: firstName,
	                shouldCreateUser: typeof shouldCreateUser === 'boolean' ? shouldCreateUser : cmdShouldCreateUser
	            };
	            return cmd;
	        case _actions.REFERENCE_PATRIMONY_CONTACT_CMD_SENT:
	            var contactUid = action.contactUid;
	
	            return _extends({}, state, {
	                contactUid: contactUid
	            });
	        case _actions.REFERENCE_USER_CMD_SENT:
	            var userUid = action.userUid,
	                status = action.status,
	                errorType = action.errorType;
	
	            return _extends({}, state, { userUid: userUid, status: status, errorType: errorType });
	        default:
	            return state;
	    }
	}
	
	var lot = function () {
	
	    function lot() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.LOT_LOADED:
	                return action.lot;
	            default:
	                return state;
	        }
	    }
	
	    function lotContacts() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.LOT_LOADED:
	                return action.lotContacts;
	            default:
	                return state;
	        }
	    }
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.LOT_STREAM_LOADED:
	                return action.lot.stream;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ lot: lot, lotContacts: lotContacts, stream: stream });
	}();
	
	var building = function () {
	
	    function building() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.BUILDING_LOADED:
	                return action.building;
	            default:
	                return state;
	        }
	    }
	
	    function buildingLots() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.BUILDING_LOADED:
	                return action.buildingLots;
	            default:
	                return state;
	        }
	    }
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.LOT_STREAM_LOADED:
	                return action.building.stream;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ building: building, buildingLots: buildingLots, stream: stream });
	}();
	
	var contact = function () {
	
	    function contact() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_LOADED:
	                return action.contact;
	            default:
	                return state;
	        }
	    }
	
	    function nameToSort(_ref4) {
	        var name = _ref4.name;
	
	        return [name.company, name.gender, name.firstName, name.lastName, name.value].filter(Boolean).join(' ');
	    }
	
	    function compareContacts(a, b) {
	        var nameToSortA = nameToSort(a);
	        var nameToSortB = nameToSort(b);
	        return nameToSortA < nameToSortB ? -1 : 1;
	    }
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_STREAM_LOADED:
	            case _actions.CONTACT_STREAM_QUERIED:
	                return action.stream;
	            case _actions.REFERENCE_PATRIMONY_CONTACT_CMD_SENT:
	                var name = action.name,
	                    contactUid = action.contactUid;
	
	                return state.concat({
	                    uid: contactUid,
	                    name: name,
	                    patrimonyUserState: { stateType: 'NoAccount' },
	                    contacts: [],
	                    _links: []
	                }).sort(compareContacts);
	
	            case _actions.LINK_USER_CMD_SENT:
	                var associatedContact = state.find(function (c) {
	                    return c.uid === action.contactUid;
	                });
	                var othersContact = state.filter(function (c) {
	                    return c.uid !== action.contactUid;
	                });
	                var login = action.login,
	                    userUid = action.userUid;
	
	
	                return othersContact.concat(_extends({}, associatedContact, { patrimonyUserState: { stateType: 'NotActiveAccount', login: login, userUid: userUid } })).sort(compareContacts);
	            default:
	                return state;
	        }
	    }
	
	    function range() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_STREAM_LOADED:
	            case _actions.CONTACT_STREAM_QUERIED:
	                return action.range;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_STREAM_LOADED:
	            case _actions.CONTACT_STREAM_QUERIED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    function _links() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_STREAM_LOADED:
	            case _actions.CONTACT_STREAM_QUERIED:
	            case _actions.CONTACT_LINKS_LOADED:
	                return action._links;
	            default:
	                return state;
	        }
	    }
	
	    function minorStream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.MINOR_CONTACT_STREAM_LOADED:
	            case _actions.MINOR_CONTACT_STREAM_QUERIED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function minorRange() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.MINOR_CONTACT_STREAM_LOADED:
	            case _actions.MINOR_CONTACT_STREAM_QUERIED:
	                return action.range;
	            default:
	                return state;
	        }
	    }
	
	    function minorQuery() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.MINOR_CONTACT_STREAM_LOADED:
	            case _actions.MINOR_CONTACT_STREAM_QUERIED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    function criteria() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_CRITERIA_UPDATED:
	                return _extends({}, state, action.criteria);
	            default:
	                return state;
	        }
	    }
	
	    function minorCriteria() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.MINOR_CONTACT_CRITERIA_UPDATED:
	                return _extends({}, state, action.minorCriteria);
	            case _actions.MINOR_CONTACT_CRITERIA_RESET:
	                return action.minorCriteria;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({
	        contact: contact,
	        stream: stream,
	        range: range,
	        query: query,
	        _links: _links,
	        criteria: criteria,
	        minorCriteria: minorCriteria,
	        minorStream: minorStream,
	        minorRange: minorRange,
	        minorQuery: minorQuery
	    });
	}();
	
	exports.default = (0, _redux.combineReducers)({
	    lot: lot,
	    building: building,
	    contact: contact,
	    patrimony: patrimony,
	    patrimonyBuildings: patrimonyBuildings,
	    patrimonyLots: patrimonyLots,
	    patrimonyContacts: patrimonyContacts,
	    stream: stream,
	    aggregations: aggregations,
	    range: range,
	    query: query,
	    _links: _links,
	    criteria: criteria,
	    minorCriteria: minorCriteria,
	    referencePatrimonyCmd: referencePatrimonyCmd,
	    referenceLotCmd: referenceLotCmd,
	    referencePatrimonyContactCmd: referencePatrimonyContactCmd,
	    updatePatrimonyCmd: updatePatrimonyCmd,
	    updateLotCmd: updateLotCmd,
	    addComplementaryAddressToPatrimonyCmd: addComplementaryAddressToPatrimonyCmd,
	    addAddressToLotCmd: addAddressToLotCmd,
	    linkPatrimonyContactWithCmd: linkPatrimonyContactWithCmd,
	    updatePatrimonyContactIdentityCmd: updatePatrimonyContactIdentityCmd,
	    addContactCmd: addContactCmd,
	    updateUserCmd: updateUserCmd
	});

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.patrimonyContactRoute = patrimonyContactRoute;
	
	exports.default = function (rootPath, dispatcher, _ref2) {
	    var getState = _ref2.getState;
	
	
	    function enterPatrimony(dispatch, params) {
	        var state = getState();
	        var _appLinks = state.app._links;
	
	        return Promise.all([dispatch((0, _actions4.loadPatrimony)(params.id)), _appLinks.find((0, _links.linkFinder)('tickets')) && dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, { patrimony: params.id, range: { offset: 0, limit: 0 } }))), _config2.default.feature.audit && dispatch((0, _actions3.loadReportStream)({ externalRefUid: params.id })).catch(function () {})]);
	    }
	
	    function enterBuilding(dispatch, params) {
	        return Promise.all([dispatch((0, _actions4.loadBuilding)(params.id, params.bid)), _config2.default.feature.audit && dispatch((0, _actions3.loadReportStream)({ externalRefUid: params.bid })).catch(function () {})]);
	    }
	
	    function enterLot(dispatch, params) {
	        return Promise.all([dispatch((0, _actions4.loadPatrimony)(params.id)), dispatch((0, _actions4.loadLot)(params.lid)), _config2.default.feature.audit && dispatch((0, _actions3.loadReportStream)({ externalRefUid: params.lid })).catch(function () {})]);
	    }
	
	    return {
	        path: rootPath,
	        component: _PatrimonyLayout2.default,
	        onEnter: dispatcher(enterPatrimonyStream(getState)),
	        indexRoute: {
	            component: _PatrimonyStreamLayout2.default
	        },
	        childRoutes: [{
	            path: ':id',
	            component: _PatrimonyDetail2.default,
	            onEnter: dispatcher(enterPatrimony),
	            indexRoute: {
	                component: _PatrimonyDashboard2.default
	            },
	            childRoutes: [{
	                path: 'additionalinfos',
	                component: _AdditionalInfos2.default
	            }, {
	                path: 'lots',
	                component: _LotStream2.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions4.loadLotAndBuildingStream)(p.id));
	                })
	            }, {
	                path: 'tickets',
	                component: _TicketStream2.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, { patrimony: p.id })));
	                })
	            }, {
	                path: 'contacts',
	                component: _ContactStream4.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions4.loadContactStream)(_extends({}, _actions4.DEFAULT_CONTACT_QUERY, { patrimonyUids: p.id })));
	                })
	            }, {
	                path: 'providercontacts',
	                component: _ContactStream2.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions2.loadContactStream)(_extends({}, _actions2.DEFAULT_CONTACT_QUERY, { patrimonyUids: p.id })));
	                })
	            }, {
	                path: 'audits',
	                component: _ReportStream2.default
	            }]
	        }, {
	            path: ':id/buildings/:bid',
	            component: _BuildingDetail2.default,
	            onEnter: dispatcher(enterBuilding),
	            indexRoute: {
	                component: _BuildingDashboard2.default
	            },
	            childRoutes: [{
	                path: 'lots',
	                component: _LotStream2.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions4.loadLotStream)(p.id, p.bid));
	                })
	            }, {
	                path: 'audits',
	                component: _ReportStream2.default
	            }]
	        }, {
	            path: ':id/lots/:lid',
	            component: _LotDetail2.default,
	            onEnter: dispatcher(enterLot),
	            indexRoute: {
	                component: _LotDashboard2.default
	            },
	            childRoutes: [{
	                path: 'contacts',
	                component: _ContactStream4.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions4.loadContactStream)(_extends({}, _actions4.DEFAULT_CONTACT_QUERY, { lotUid: p.lid })));
	                })
	            }, {
	                path: 'audits',
	                component: _ReportStream2.default
	            }]
	        }]
	    };
	};
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _links = __webpack_require__(33);
	
	var _actions = __webpack_require__(38);
	
	var _TicketStream = __webpack_require__(900);
	
	var _TicketStream2 = _interopRequireDefault(_TicketStream);
	
	var _actions2 = __webpack_require__(47);
	
	var _ContactStream = __webpack_require__(896);
	
	var _ContactStream2 = _interopRequireDefault(_ContactStream);
	
	var _actions3 = __webpack_require__(1086);
	
	var _ReportStream = __webpack_require__(1286);
	
	var _ReportStream2 = _interopRequireDefault(_ReportStream);
	
	var _actions4 = __webpack_require__(74);
	
	var _PatrimonyLayout = __webpack_require__(1392);
	
	var _PatrimonyLayout2 = _interopRequireDefault(_PatrimonyLayout);
	
	var _PatrimonyStreamLayout = __webpack_require__(1396);
	
	var _PatrimonyStreamLayout2 = _interopRequireDefault(_PatrimonyStreamLayout);
	
	var _PatrimonyDetail = __webpack_require__(1391);
	
	var _PatrimonyDetail2 = _interopRequireDefault(_PatrimonyDetail);
	
	var _PatrimonyDashboard = __webpack_require__(1390);
	
	var _PatrimonyDashboard2 = _interopRequireDefault(_PatrimonyDashboard);
	
	var _LotStream = __webpack_require__(1388);
	
	var _LotStream2 = _interopRequireDefault(_LotStream);
	
	var _AdditionalInfos = __webpack_require__(1375);
	
	var _AdditionalInfos2 = _interopRequireDefault(_AdditionalInfos);
	
	var _LotDetail = __webpack_require__(1387);
	
	var _LotDetail2 = _interopRequireDefault(_LotDetail);
	
	var _LotDashboard = __webpack_require__(1386);
	
	var _LotDashboard2 = _interopRequireDefault(_LotDashboard);
	
	var _BuildingDetail = __webpack_require__(1378);
	
	var _BuildingDetail2 = _interopRequireDefault(_BuildingDetail);
	
	var _BuildingDashboard = __webpack_require__(1377);
	
	var _BuildingDashboard2 = _interopRequireDefault(_BuildingDashboard);
	
	var _ContactStream3 = __webpack_require__(1383);
	
	var _ContactStream4 = _interopRequireDefault(_ContactStream3);
	
	var _ContactDetail = __webpack_require__(1381);
	
	var _ContactDetail2 = _interopRequireDefault(_ContactDetail);
	
	var _ContactDashboard = __webpack_require__(1380);
	
	var _ContactDashboard2 = _interopRequireDefault(_ContactDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enterPatrimonyStream(getState) {
	    return function (dispatch) {
	        var state = getState();
	        var criteria = state.patrimony.criteria;
	
	
	        return dispatch((0, _actions4.loadPatrimonyStream)(_extends({}, _actions4.DEFAULT_PATRIMONY_QUERY, criteria)));
	    };
	}
	
	function patrimonyContactRoute(rootPath, dispatcher, _ref) {
	    var getState = _ref.getState;
	
	    return {
	        path: rootPath,
	        component: _PatrimonyLayout2.default,
	        onEnter: dispatcher(enterPatrimonyStream(getState)),
	        childRoutes: [{
	            path: ':id',
	            component: _ContactDetail2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions4.loadContact)(p.id));
	            }),
	            indexRoute: {
	                component: _ContactDashboard2.default
	            }
	        }]
	    };
	}

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _router = __webpack_require__(123);
	
	var _links = __webpack_require__(33);
	
	var _status = __webpack_require__(13);
	
	var _actions = __webpack_require__(38);
	
	var _actions2 = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function providerCriteriaUpdated() {
	    var criteria;
	
	    return function (state, dispatch) {
	        var nextCriteria = state.provider.criteria;
	
	        if (nextCriteria != criteria) {
	
	            if (nextCriteria.activityUid != (criteria && criteria.activityUid)) {
	                dispatch((0, _actions2.loadProviderStream)(_extends({}, _actions2.DEFAULT_QUERY, nextCriteria))).then(function () {
	                    if (location.pathname != '/providers' || location.pathname != '/providerdirectory') {
	                        return dispatch((0, _router.push)('/*'));
	                    }
	                });
	            }
	            criteria = nextCriteria;
	        }
	    };
	}
	
	function providerCoverageCriteriaUpdated() {
	    var criteria;
	
	    return function (state, dispatch) {
	        var nextCriteria = state.provider.coverage.criteria;
	
	        if (criteria === undefined) {
	            // state initial value
	            criteria = nextCriteria;
	        }
	
	        if (nextCriteria != criteria) {
	
	            if (nextCriteria.activityUids.length == 0) {
	                nextCriteria = criteria;
	                dispatch((0, _actions2.updateProviderCoverageCriteria)(nextCriteria));
	                dispatch((0, _status.infoStatus)(_i18n2.default.coverageActivityIsRequired));
	            }
	
	            if (nextCriteria.zipCodes != (criteria && criteria.zipCodes)) {
	                if (nextCriteria.zipCodes == null) {
	                    dispatch((0, _actions2.loadProviderCoverage)(_extends({}, _actions2.DEFAULT_PROVIDER_COVERAGE_QUERY, nextCriteria)));
	                }
	            }
	
	            if (nextCriteria.activityUids != (criteria && criteria.activityUids) || nextCriteria.department != (criteria && criteria.department) || nextCriteria.city != (criteria && criteria.city)) {
	                dispatch((0, _actions2.loadProviderCoverage)(_extends({}, _actions2.DEFAULT_PROVIDER_COVERAGE_QUERY, nextCriteria)));
	            }
	            criteria = nextCriteria;
	        }
	    };
	}
	
	function contactFilterUpdated() {
	    var filter;
	
	    return function (state, dispatch) {
	        var nextFilter = state.provider.contact.contactFilter;
	
	        if (nextFilter != filter) {
	            var contact = state.provider.contact.contact;
	
	            var _appLinks = state.app._links;
	
	            dispatch((0, _actions2.loadContact)(null, _extends({}, _actions2.DEFAULT_CONTACT_STATS_QUERY, nextFilter)));
	
	            if (location.pathname.match(/\/providercontacts\/[\w-]+\/tickets/) != null) {
	                dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, nextFilter, { activeProviders: contact.uid })));
	            } else {
	                // dashboard
	                _appLinks.find((0, _links.linkFinder)('tickets')) && dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, nextFilter, { activeProviders: contact.uid, range: { offset: 0, limit: 0 } })));
	            }
	
	            filter = nextFilter;
	        }
	    };
	}
	
	function defineUpdateInterventionPeriodForActivityCmdUpdated() {
	    var cmd;
	
	    function ensureTimeSlots(array) {
	        return array && array.map(function (object) {
	            if (!object.timeSlot) {
	                return _extends({
	                    timeSlot: { timeSlotType: _models.TIME_SLOT_TYPES[0] }
	                }, object);
	            }
	            return object;
	        });
	    }
	
	    function ensureTimeSlot(timeSlot) {
	        return timeSlot || { timeSlotType: _models.TIME_SLOT_TYPES[0] };
	    }
	
	    return function (state, dispatch) {
	        var nextCmd = state.provider.defineUpdateInterventionPeriodForActivityCmd;
	
	        if (nextCmd != cmd) {
	
	            if (nextCmd && nextCmd.period && nextCmd.period.periodType != (cmd && cmd.period && cmd.period.periodType)) {
	                switch (nextCmd.period.periodType) {
	                    case 'DateTimePeriod':
	                        nextCmd = { period: _extends({}, nextCmd.period, { periodRanges: null, exclusions: null, days: null, timeSlot: null }) };
	                        dispatch((0, _actions2.updateDefineUpdateInterventionPeriodForActivityCmd)(nextCmd));
	                        break;
	                    case 'WeekDaysPeriod':
	                        nextCmd = { period: _extends({}, nextCmd.period, { days: null, timeSlot: null }) };
	                        dispatch((0, _actions2.updateDefineUpdateInterventionPeriodForActivityCmd)(nextCmd));
	                        break;
	                    case 'SpecificDaysPeriod':
	                        nextCmd = { period: _extends({}, nextCmd.period, { timeSlot: ensureTimeSlot(nextCmd.period.timeSlot), startDate: null, endDate: null, periodRanges: null, exclusions: null }) };
	                        dispatch((0, _actions2.updateDefineUpdateInterventionPeriodForActivityCmd)(nextCmd));
	                        break;
	                }
	            }
	
	            if (nextCmd && nextCmd.period && nextCmd.period.periodRanges && nextCmd.period.periodRanges.length != (cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges.length)) {
	                nextCmd = { period: _extends({}, nextCmd.period, { periodRanges: ensureTimeSlots(nextCmd.period.periodRanges) }) };
	                dispatch((0, _actions2.updateDefineUpdateInterventionPeriodForActivityCmd)(nextCmd));
	            }
	
	            if (nextCmd && nextCmd.period && nextCmd.period.exclusions && nextCmd.period.exclusions.length != (cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions.length)) {
	                nextCmd = { period: _extends({}, nextCmd.period, { exclusions: ensureTimeSlots(nextCmd.period.exclusions) }) };
	                dispatch((0, _actions2.updateDefineUpdateInterventionPeriodForActivityCmd)(nextCmd));
	            }
	
	            cmd = nextCmd;
	        }
	    };
	}
	
	exports.default = [providerCriteriaUpdated(), providerCoverageCriteriaUpdated(), contactFilterUpdated(), defineUpdateInterventionPeriodForActivityCmdUpdated()];

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _wizard = __webpack_require__(513);
	
	var _phonez = __webpack_require__(40);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _MultiInput = __webpack_require__(277);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	var _CompanyPicker = __webpack_require__(951);
	
	var _CompanyPicker2 = _interopRequireDefault(_CompanyPicker);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderPicker = __webpack_require__(1102);
	
	var _ProviderPicker2 = _interopRequireDefault(_ProviderPicker);
	
	var _AddProviderContactModal = __webpack_require__(2262);
	
	var _AddProviderContactModal2 = _interopRequireDefault(_AddProviderContactModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WIZARD_STEPS = [2, 3.1];
	var WIZARD_STEPS_COMPANY = [1, 2, 3.1];
	
	var schemaCache = (0, _cache2.default)();
	
	function selectSchema(cmd, _ref) {
	    var wizard = _ref.wizard;
	
	    var schema = _models.AddProviderContactCmd.selectSchema(cmd);
	
	    return schemaCache([schema, wizard.activeStep], function () {
	        if (wizard.matchActiveStep(1)) {
	            return _extends({}, schema, {
	                properties: {
	                    companyUid: schema.properties.companyUid
	                },
	                required: ['companyUid']
	            });
	        }
	        if (wizard.matchActiveStep([2, 3.2])) {
	            return _extends({}, schema, {
	                properties: {
	                    namez: schema.properties.namez,
	                    emails: schema.properties.emails,
	                    phones: schema.properties.phones,
	                    fax: schema.properties.fax,
	                    companyUid: schema.properties.companyUid
	                },
	                required: ['namez', 'companyUid']
	            });
	        }
	        return schema;
	    });
	}
	
	function selectSteps(_ref2) {
	    var authenticated = _ref2.authenticated;
	
	    var company = getUserCompany(authenticated);
	    return company && WIZARD_STEPS || WIZARD_STEPS_COMPANY;
	}
	
	function getUserCompany(user) {
	    switch (user.userType) {
	        case 'callCenterUser':
	        case 'superUser':
	            return undefined;
	        default:
	            return user.company;
	    }
	}
	
	var AddProviderContactModal = function (_Component) {
	    _inherits(AddProviderContactModal, _Component);
	
	    function AddProviderContactModal() {
	        _classCallCheck(this, AddProviderContactModal);
	
	        return _possibleConstructorReturn(this, (AddProviderContactModal.__proto__ || Object.getPrototypeOf(AddProviderContactModal)).apply(this, arguments));
	    }
	
	    _createClass(AddProviderContactModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                addProviderContactCmd = _props.addProviderContactCmd,
	                authenticated = _props.authenticated;
	
	
	            var company = getUserCompany(authenticated);
	
	            dispatch((0, _actions.updateAddProviderContactCmd)({
	                namez: addProviderContactCmd && addProviderContactCmd.namez || { nameType: 'CivilName' },
	                companyUid: company
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.authenticated != this.props.authenticated) {
	                var dispatch = nextProps.dispatch,
	                    addProviderContactCmd = nextProps.addProviderContactCmd,
	                    authenticated = nextProps.authenticated;
	
	
	                var company = getUserCompany(authenticated);
	
	                dispatch((0, _actions.updateAddProviderContactCmd)({
	                    namez: addProviderContactCmd && addProviderContactCmd.namez || { nameType: 'CivilName' },
	                    companyUid: company
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                wizard = _props2.wizard,
	                onHide = _props2.onHide;
	
	            var steps = this.state;
	
	            if (wizard.matchActiveStep(0.1)) {
	                return dispatch((0, _actions.sendAddProviderContactCmd)()).then(function () {
	                    return dispatch((0, _actions.loadContactStream)());
	                }).then(function () {
	                    onHide();
	                });
	            }
	
	            if (wizard.matchActiveStep(0.2)) {
	                return dispatch((0, _actions.sendReferenceProviderCompanyCmd)()).then(function (action) {
	                    var providerId = action.events.find(function (e) {
	                        return e.eventType == 'ProviderCompanyReferenced';
	                    }).aggregateUid;
	                    return dispatch((0, _actions.sendAddProviderContactCmd)(providerId));
	                }).then(function () {
	                    return dispatch((0, _actions.loadContactStream)());
	                }).then(function () {
	                    onHide();
	                });
	            }
	        }
	    }, {
	        key: '_isValid',
	        value: function _isValid() {
	            var _props3 = this.props,
	                addProviderContactForm = _props3.addProviderContactForm,
	                referenceProviderCompanyForm = _props3.referenceProviderCompanyForm,
	                wizard = _props3.wizard;
	
	
	            switch (wizard.activeStep) {
	                case 1:case 2:case 3.1:
	                    return addProviderContactForm.isValid();
	                case 3.2:
	                    return addProviderContactForm.isValid() && referenceProviderCompanyForm.isValid();
	            }
	        }
	    }, {
	        key: '_validate',
	        value: function _validate() {
	            var _props4 = this.props,
	                addProviderContactForm = _props4.addProviderContactForm,
	                referenceProviderCompanyForm = _props4.referenceProviderCompanyForm,
	                wizard = _props4.wizard;
	
	
	            switch (wizard.activeStep) {
	                case 1:case 2:case 3.1:
	                    return addProviderContactForm.validate();
	                case 3.2:
	                    return addProviderContactForm.validate() && referenceProviderCompanyForm.validate();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props5 = this.props,
	                dispatch = _props5.dispatch,
	                onHide = _props5.onHide,
	                addProviderContactForm = _props5.addProviderContactForm,
	                addProviderContactCmd = _props5.addProviderContactCmd,
	                referenceProviderCompanyForm = _props5.referenceProviderCompanyForm,
	                referenceProviderCompanyCmd = _props5.referenceProviderCompanyCmd,
	                wizard = _props5.wizard,
	                others = _objectWithoutProperties(_props5, ['dispatch', 'onHide', 'addProviderContactForm', 'addProviderContactCmd', 'referenceProviderCompanyForm', 'referenceProviderCompanyCmd', 'wizard']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.newProviderContact
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    wizard.matchActiveStep(1) && _react2.default.createElement(_CompanyPicker2.default, addProviderContactForm.companyUid()),
	                    wizard.matchActiveStep(2) && _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'select',
	                                name: 'nameType',
	                                label: _i18n2.default.nameType
	                            }, addProviderContactForm.namez.nameType()),
	                            _react2.default.createElement(
	                                'option',
	                                { value: 'CivilName' },
	                                _i18n2.default.nameTypeEnum.civilName
	                            ),
	                            _react2.default.createElement(
	                                'option',
	                                { value: 'PoorName' },
	                                _i18n2.default.nameTypeEnum.poorName
	                            )
	                        ),
	                        addProviderContactForm.namez.firstName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'firstName',
	                            label: requiredLabel(_i18n2.default.firstName)
	                        }, addProviderContactForm.namez.firstName())),
	                        addProviderContactForm.namez.lastName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'lastName',
	                            label: requiredLabel(_i18n2.default.lastName)
	                        }, addProviderContactForm.namez.lastName())),
	                        addProviderContactForm.namez.gender && _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'select',
	                                name: 'gender',
	                                label: _i18n2.default.gender
	                            }, addProviderContactForm.namez.gender()),
	                            _react2.default.createElement('option', { value: '' }),
	                            _react2.default.createElement(
	                                'option',
	                                { value: 'Male' },
	                                _i18n2.default.genderEnum.male
	                            ),
	                            _react2.default.createElement(
	                                'option',
	                                { value: 'Female' },
	                                _i18n2.default.genderEnum.female
	                            )
	                        ),
	                        addProviderContactForm.namez.value && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'name',
	                            label: requiredLabel(_i18n2.default.name)
	                        }, addProviderContactForm.namez.value())),
	                        _react2.default.createElement(_MultiInput2.default, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'phone',
	                            label: _i18n2.default.phone
	                        }, (0, _phonez.phonesField)(addProviderContactForm.phones()))),
	                        _react2.default.createElement(_MultiInput2.default, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'fax',
	                            label: _i18n2.default.fax
	                        }, (0, _phonez.phonesField)(addProviderContactForm.fax()))),
	                        _react2.default.createElement(_MultiInput2.default, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'email',
	                            label: _i18n2.default.email
	                        }, addProviderContactForm.emails()))
	                    ),
	                    wizard.matchActiveStep(3) && _react2.default.createElement(
	                        'div',
	                        { className: _AddProviderContactModal2.default.switch },
	                        _react2.default.createElement(
	                            _ButtonToggle2.default,
	                            {
	                                value: wizard.minorActiveStep,
	                                onChange: function onChange(s) {
	                                    return s && wizard.setActiveStep(s);
	                                } },
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonGroup,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsSize: 'small',
	                                        value: 0.1 },
	                                    _i18n2.default.selectProvider
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsSize: 'small',
	                                        value: 0.2 },
	                                    _i18n2.default.newProvider
	                                )
	                            )
	                        )
	                    ),
	                    wizard.matchActiveStep(3.1) && _react2.default.createElement(_ProviderPicker2.default, addProviderContactForm.providerCompanyUid()),
	                    wizard.matchActiveStep(3.2) && _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'label',
	                            label: requiredLabel(_i18n2.default.label)
	                        }, referenceProviderCompanyForm.label())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'siret',
	                            label: requiredLabel(_i18n2.default.siret)
	                        }, referenceProviderCompanyForm.siretNumber()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        !wizard.hasNextStep() && _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !this._isValid() }),
	                                onClick: function onClick() {
	                                    return _this2._validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        wizard.hasPreviousStep() && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return wizard.previousStep();
	                                } },
	                            'previous'
	                        ),
	                        wizard.hasNextStep() && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !this._isValid() }),
	                                onClick: function onClick() {
	                                    return _this2._validate() && (wizard.nextStep() || true) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            'next'
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddProviderContactModal;
	}(_react.Component);
	
	AddProviderContactModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AddProviderContactModal = (0, _form.connectForm)({
	    name: 'referenceProviderCompanyForm',
	    alias: 'cmd',
	    target: 'referenceProviderCompanyCmd',
	    schema: _models.ReferenceProviderCompanyCmd.schema,
	    action: _actions.REFERENCE_PROVIDER_COMPANY_CMD_UPDATED
	})(AddProviderContactModal);
	
	AddProviderContactModal = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    name: 'addProviderContactForm',
	    alias: 'cmd',
	    target: 'addProviderContactCmd',
	    schema: selectSchema,
	    action: _actions.ADD_PROVIDER_CONTACT_CMD_UPDATED
	})(AddProviderContactModal);
	
	AddProviderContactModal = (0, _wizard.connectWizard)({
	    steps: selectSteps
	})(AddProviderContactModal);
	
	AddProviderContactModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        addProviderContactCmd: state.provider.addProviderContactCmd,
	        referenceProviderCompanyCmd: state.provider.referenceProviderCompanyCmd
	    };
	})(AddProviderContactModal);
	
	exports.default = AddProviderContactModal;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _wizard = __webpack_require__(513);
	
	var _phonez = __webpack_require__(40);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _MultiInput = __webpack_require__(277);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	var _CompanyPicker = __webpack_require__(951);
	
	var _CompanyPicker2 = _interopRequireDefault(_CompanyPicker);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WIZARD_STEPS = [2];
	var WIZARD_STEPS_COMPANY = [1, 2];
	
	var schemaCache = (0, _cache2.default)();
	
	function selectSchema(cmd, _ref) {
	    var wizard = _ref.wizard;
	
	    var schema = _models.AddProviderContactCmd.selectSchema(cmd);
	
	    return schemaCache([schema, wizard.activeStep], function () {
	        if (wizard.matchActiveStep(1)) {
	            return _extends({}, schema, {
	                properties: {
	                    companyUid: schema.properties.companyUid
	                },
	                required: ['companyUid']
	            });
	        }
	        return schema;
	    });
	}
	
	function selectSteps(_ref2) {
	    var authenticated = _ref2.authenticated;
	
	    var company = getUserCompany(authenticated);
	    return company && WIZARD_STEPS || WIZARD_STEPS_COMPANY;
	}
	
	function getUserCompany(user) {
	    switch (user.userType) {
	        case 'callCenterUser':
	        case 'superUser':
	            return undefined;
	        default:
	            return user.company;
	    }
	}
	
	var AddProviderContactPopover = function (_Component) {
	    _inherits(AddProviderContactPopover, _Component);
	
	    function AddProviderContactPopover() {
	        _classCallCheck(this, AddProviderContactPopover);
	
	        return _possibleConstructorReturn(this, (AddProviderContactPopover.__proto__ || Object.getPrototypeOf(AddProviderContactPopover)).apply(this, arguments));
	    }
	
	    _createClass(AddProviderContactPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd,
	                authenticated = _props.authenticated,
	                provider = _props.provider;
	
	
	            var company = getUserCompany(authenticated);
	
	            dispatch((0, _actions.updateAddProviderContactCmd)({
	                namez: cmd && cmd.namez || { nameType: 'CivilName' },
	                companyUid: company,
	                providerCompanyUid: provider
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.authenticated != this.props.authenticated || nextProps.provider != this.props.provider) {
	                var dispatch = nextProps.dispatch,
	                    authenticated = nextProps.authenticated,
	                    provider = nextProps.provider;
	
	
	                var company = getUserCompany(authenticated);
	
	                dispatch((0, _actions.updateAddProviderContactCmd)({
	                    companyUid: company,
	                    providerCompanyUid: provider
	                }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(action) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	            return dispatch((0, _actions.sendAddProviderContactCmd)()).then(function () {
	                return dispatch((0, _actions.loadContactStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                onHide = _props3.onHide,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                provider = _props3.provider,
	                wizard = _props3.wizard,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'onHide', 'form', 'cmd', 'provider', 'wizard']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    bsClass: 'popover-lg popover',
	                    title: _i18n2.default.newProviderContact
	                }, others),
	                wizard.matchActiveStep(1) && _react2.default.createElement(_CompanyPicker2.default, form.companyUid()),
	                wizard.matchActiveStep(2) && _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'nameType',
	                            label: _i18n2.default.nameType
	                        }, form.namez.nameType()),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'CivilName' },
	                            _i18n2.default.nameTypeEnum.civilName
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'PoorName' },
	                            _i18n2.default.nameTypeEnum.poorName
	                        )
	                    ),
	                    form.namez.firstName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'firstName',
	                        label: requiredLabel(_i18n2.default.firstName)
	                    }, form.namez.firstName())),
	                    form.namez.lastName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'lastName',
	                        label: requiredLabel(_i18n2.default.lastName)
	                    }, form.namez.lastName())),
	                    form.namez.gender && _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'gender',
	                            label: _i18n2.default.gender
	                        }, form.namez.gender()),
	                        _react2.default.createElement('option', { value: '' }),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Male' },
	                            _i18n2.default.genderEnum.male
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Female' },
	                            _i18n2.default.genderEnum.female
	                        )
	                    ),
	                    form.namez.value && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'name',
	                        label: requiredLabel(_i18n2.default.name)
	                    }, form.namez.value())),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'phone',
	                        label: _i18n2.default.phone
	                    }, (0, _phonez.phonesField)(form.phones()))),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'fax',
	                        label: _i18n2.default.fax
	                    }, (0, _phonez.phonesField)(form.fax()))),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'email',
	                        label: _i18n2.default.email
	                    }, form.emails()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    !wizard.hasNextStep() && _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    wizard.hasPreviousStep() && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: function onClick(e) {
	                                return wizard.previousStep();
	                            } },
	                        'previous'
	                    ),
	                    wizard.hasNextStep() && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && (wizard.nextStep() || true) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        'next'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddProviderContactPopover;
	}(_react.Component);
	
	AddProviderContactPopover.propTypes = {
	    provider: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AddProviderContactPopover = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: selectSchema,
	    action: _actions.ADD_PROVIDER_CONTACT_CMD_UPDATED
	})(AddProviderContactPopover);
	
	AddProviderContactPopover = (0, _wizard.connectWizard)({
	    steps: selectSteps
	})(AddProviderContactPopover);
	
	AddProviderContactPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        cmd: state.provider.addProviderContactCmd
	    };
	})(AddProviderContactPopover);
	
	exports.default = AddProviderContactPopover;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ActivityPicker = __webpack_require__(1104);
	
	var _ActivityPicker2 = _interopRequireDefault(_ActivityPicker);
	
	var _models = __webpack_require__(87);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function activityAggregator(reference) {
	    return function (result, activity) {
	        var resultActivity = reference.find(function (a) {
	            return a.uid == activity.activityUid;
	        });
	        if (resultActivity) {
	            var aggrega = {
	                activity: resultActivity,
	                interventionPeriods: activity.interventionPeriods
	            };
	
	            result.push(aggrega);
	        } else {
	            console && console.warn('activity "' + activity.activityUid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	function copyInterventionPeriodCmd(interventionPeriod) {
	    return {
	        period: interventionPeriod.period,
	        commandType: 'DefineInterventionPeriodForActivity'
	    };
	}
	
	function copyServiceChargeCmd(interventionPeriod) {
	    return {
	        charge: interventionPeriod.serviceCharge
	    };
	}
	
	function copyInterventionZoneCmd(interventionPeriod) {
	    return {
	        zone: interventionPeriod.interventionZone
	    };
	}
	
	function copyCallOutChargesCmd(interventionPeriod) {
	    return {
	        callOutCharges: interventionPeriod.callOutCharges
	    };
	}
	
	function copySubscriptionsCmd(interventionPeriod) {
	    return {
	        subscriptions: interventionPeriod.subscriptions
	    };
	}
	
	var AssignActivityToProviderCompanyModal = function (_Component) {
	    _inherits(AssignActivityToProviderCompanyModal, _Component);
	
	    function AssignActivityToProviderCompanyModal(props) {
	        _classCallCheck(this, AssignActivityToProviderCompanyModal);
	
	        var _this = _possibleConstructorReturn(this, (AssignActivityToProviderCompanyModal.__proto__ || Object.getPrototypeOf(AssignActivityToProviderCompanyModal)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(AssignActivityToProviderCompanyModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                activityReference = _props.activityReference,
	                provider = _props.provider;
	
	
	            var activityAggregation = provider.activities.reduce(activityAggregator(activityReference), []);
	            this.setState({ activityAggregation: activityAggregation });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.activityReference != this.props.activityReference || nextProps.provider != this.props.provider) {
	                var activityReference = nextProps.activityReference,
	                    provider = nextProps.provider;
	
	
	                var activityAggregation = provider.activities.reduce(activityAggregator(activityReference), []);
	                this.setState({ activityAggregation: activityAggregation });
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                cmd = _props2.cmd,
	                provider = _props2.provider,
	                onHide = _props2.onHide;
	            var activeAggrega = this.state.activeAggrega;
	
	
	            function sendCopyInterventionPeriodCmds(interventionPeriod) {
	                var interventionPeriodCopyUid;
	
	                return dispatch((0, _actions.sendDefineUpdateInterventionPeriodForActivityCmd)(provider._links, activity.uid, copyInterventionPeriodCmd(interventionPeriod))).then(function (action) {
	                    interventionPeriodCopyUid = action.events.find(function (e) {
	                        return e.eventType == 'InterventionPeriodDefinedForActivity';
	                    }).period.uid;
	                    return interventionPeriod.interventionZone && dispatch((0, _actions.sendDefineInterventionZoneForInterventionPeriodCmd)(provider._links, activity.uid, interventionPeriodCopyUid, copyInterventionZoneCmd(interventionPeriod)));
	                }).then(function () {
	                    return interventionPeriod.serviceCharge && dispatch((0, _actions.sendDefineServiceChargeForInterventionPeriodCmd)(activity.uid, interventionPeriodCopyUid, copyServiceChargeCmd(interventionPeriod)));
	                }).then(function () {
	                    return interventionPeriod.callOutCharges.length > 0 && dispatch((0, _actions.sendDefineCallOutChargesForInterventionPeriodCmd)(activity.uid, interventionPeriodCopyUid, copyCallOutChargesCmd(interventionPeriod)));
	                }).then(function () {
	                    return interventionPeriod.subscriptions.length > 0 && dispatch((0, _actions.sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd)(activity.uid, interventionPeriodCopyUid, copySubscriptionsCmd(interventionPeriod)));
	                });
	            }
	
	            var activity = cmd && cmd.activityUid;
	            return dispatch((0, _actions.sendAssignActivityToProviderCompanyCmd)()).then(function () {
	                // copy selected activity
	                // we have to execute all cmds sequencialy to avoid backend issues
	                return activeAggrega && activeAggrega.interventionPeriods.reduce(function (result, interventionPeriod) {
	                    return result.then(function () {
	                        return sendCopyInterventionPeriodCmds(interventionPeriod);
	                    });
	                }, Promise.resolve());
	            }).then(function () {
	                return dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onHide(event, 'ActivityAssignedToProviderCompany', activity);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                activityReference = _props3.activityReference,
	                provider = _props3.provider,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'activityReference', 'provider', 'onHide']);
	
	            var _state = this.state,
	                activityAggregation = _state.activityAggregation,
	                activeAggrega = _state.activeAggrega;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var activeAggregaField = function activeAggregaField() {
	                var value = activeAggrega && activeAggrega.activity.uid || '';
	
	                var onChange = function onChange(event) {
	                    var activeAggregaId = event.target.value || null;
	                    var activeAggrega = activeAggregaId && activityAggregation.find(function (a) {
	                        return a.activity.uid == activeAggregaId;
	                    });
	                    _this2.setState({ activeAggrega: activeAggrega });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var displayActivity = function displayActivity(activity, mode) {
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            activity.label
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Input,
	                                _extends({
	                                    type: 'select',
	                                    name: 'activity'
	                                }, activeAggregaField()),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    _i18n2.default.copyActivity,
	                                    ' ...'
	                                ),
	                                activityAggregation.map(function (aggrega, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        {
	                                            key: index,
	                                            value: aggrega.activity.uid },
	                                        aggrega.activity.label
	                                    );
	                                })
	                            )
	                        )
	                    );
	                }
	
	                return activity.label;
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.assignActivity
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_ActivityPicker2.default, _extends({
	                        display: displayActivity,
	                        disable: function disable(a) {
	                            return activityAggregation.find(function (ag) {
	                                return ag.activity.uid == a.uid;
	                            });
	                        }
	                    }, form.activityUid())),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick(e) {
	                                    return form.validate() && _this2._sendCmd(e) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssignActivityToProviderCompanyModal;
	}(_react.Component);
	
	AssignActivityToProviderCompanyModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AssignActivityToProviderCompanyModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.AssignActivityToProviderCompanyCmd.schema,
	    action: _actions.ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED
	})(AssignActivityToProviderCompanyModal);
	
	AssignActivityToProviderCompanyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        provider: state.provider.provider,
	        activityReference: state.reference.activityRef,
	        cmd: state.provider.assignActivityToProviderCompanyCmd
	    };
	})(AssignActivityToProviderCompanyModal);
	
	exports.default = AssignActivityToProviderCompanyModal;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(113);
	
	var _actions2 = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AssignRemoveActivityFromProviderContactPopover = __webpack_require__(2263);
	
	var _AssignRemoveActivityFromProviderContactPopover2 = _interopRequireDefault(_AssignRemoveActivityFromProviderContactPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function activityAggregator(activityReference, openingTicketPurposeReference) {
	    return function (result, activity) {
	        var includedActivity = activityReference.find(function (a) {
	            return a.uid == activity.activityUid;
	        });
	
	        if (includedActivity) {
	            var incidentTypes = openingTicketPurposeReference.openingTicketPurposes.filter(function (otp) {
	                return !!otp.activities.find(function (a) {
	                    return a.uid == includedActivity.uid;
	                });
	            });
	
	            var aggrega = {
	                activity: includedActivity,
	                incidentTypes: incidentTypes,
	                includedIncidentTypeUids: activity.includedIncidentTypes
	            };
	            result.push(aggrega);
	        } else {
	            console && console.warn('activity "' + activity.activityUid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	function activityFilter(activities) {
	    return function (activity) {
	        return activities.find(function (a) {
	            return a.activityUid == activity.uid;
	        }) == null;
	    };
	}
	
	function openingTicketPurposeFilter(activity) {
	    return function (otp) {
	        return !!otp.activities.find(function (a) {
	            return a.uid == activity.uid;
	        });
	    };
	}
	
	function isIncidentTypeIncluded(aggrega, incidentType) {
	    return aggrega.includedIncidentTypeUids.find(function (uid) {
	        return uid == incidentType.uid;
	    }) != null;
	}
	
	function addIncidentType(aggrega, incidentType) {
	    var index = aggrega.includedIncidentTypeUids.findIndex(function (uid) {
	        return uid == incidentType.uid;
	    });
	
	    var nextIncidentTypeUids = [].concat(_toConsumableArray(aggrega.includedIncidentTypeUids));
	    if (index < 0) {
	        nextIncidentTypeUids.push(incidentType.uid);
	    }
	    return nextIncidentTypeUids;
	}
	
	function removeIncidentType(aggrega, incidentType) {
	    var index = aggrega.includedIncidentTypeUids.findIndex(function (uid) {
	        return uid == incidentType.uid;
	    });
	
	    var nextIncidentTypeUids = [].concat(_toConsumableArray(aggrega.includedIncidentTypeUids));
	    if (index >= 0) {
	        nextIncidentTypeUids.splice(index, 1);
	    }
	    return nextIncidentTypeUids;
	}
	
	var AssignRemoveActivityFromProviderContactPopover = function (_Component) {
	    _inherits(AssignRemoveActivityFromProviderContactPopover, _Component);
	
	    function AssignRemoveActivityFromProviderContactPopover(props) {
	        _classCallCheck(this, AssignRemoveActivityFromProviderContactPopover);
	
	        var _this = _possibleConstructorReturn(this, (AssignRemoveActivityFromProviderContactPopover.__proto__ || Object.getPrototypeOf(AssignRemoveActivityFromProviderContactPopover)).call(this, props));
	
	        _this.state = {
	            filteredActivityReference: [],
	            aggregations: []
	        };
	        return _this;
	    }
	
	    _createClass(AssignRemoveActivityFromProviderContactPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contact = _props.contact;
	
	            Promise.all([dispatch((0, _actions.queryActivityRef)()), dispatch((0, _actions.queryOpeningTicketPurposeRef)(contact.company))]);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.activityReference && nextProps.activityReference != this.props.activityReference || nextProps.openingTicketPurposeReference && nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference) {
	                var activityReference = nextProps.activityReference,
	                    openingTicketPurposeReference = nextProps.openingTicketPurposeReference,
	                    contact = nextProps.contact;
	
	
	                if (activityReference && openingTicketPurposeReference) {
	                    var aggregations = contact.activities.reduce(activityAggregator(activityReference, openingTicketPurposeReference), []);
	                    var filteredActivityReference = activityReference.filter(activityFilter(contact.activities));
	                    this.setState({ filteredActivityReference: filteredActivityReference, aggregations: aggregations });
	                }
	            }
	
	            if (nextProps.contact != this.props.contact) {
	                var dispatch = nextProps.dispatch,
	                    _contact = nextProps.contact;
	
	                dispatch((0, _actions.queryOpeningTicketPurposeRef)(_contact.company));
	            }
	        }
	    }, {
	        key: '_sendAssignCmd',
	        value: function _sendAssignCmd(event, activity, incidentTypes) {
	            var _this2 = this;
	
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions2.sendAssignActivityToProviderContactCmd)(activity, incidentTypes)).then(function () {
	                return dispatch((0, _actions2.loadContact)());
	            }).then(function () {
	                _this2.setState({ selectedActivityUid: null });
	            }).catch(function () {
	                _this2.setState({ selectedActivityUid: null });
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd(event, activity) {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions2.sendRemoveActivityFromProviderContactCmd)(activity)).then(function () {
	                return dispatch((0, _actions2.loadContact)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                activityReference = _props2.activityReference,
	                openingTicketPurposeReference = _props2.openingTicketPurposeReference,
	                contact = _props2.contact,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'activityReference', 'openingTicketPurposeReference', 'contact', 'onHide']);
	
	            var _state = this.state,
	                filteredActivityReference = _state.filteredActivityReference,
	                aggregations = _state.aggregations,
	                selectedActivityUid = _state.selectedActivityUid;
	
	
	            var activityHeader = function activityHeader(aggrega) {
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        aggrega.activity.label
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' (',
	                        aggrega.includedIncidentTypeUids.length,
	                        ')'
	                    )
	                );
	            };
	
	            var incidentTypeHeader = function incidentTypeHeader(aggrega, incidentType) {
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    incidentType.label
	                );
	            };
	
	            var incidentTypeButton = function incidentTypeButton(aggrega, incidentType) {
	                var included = isIncidentTypeIncluded(aggrega, incidentType);
	
	                if (included) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick(e) {
	                                return _this3._sendAssignCmd(e, aggrega.activity, removeIncidentType(aggrega, incidentType));
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        bsStyle: 'link',
	                        onClick: function onClick(e) {
	                            return _this3._sendAssignCmd(e, aggrega.activity, addIncidentType(aggrega, incidentType));
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            var activityField = {
	                value: selectedActivityUid || '',
	                onChange: function onChange(event) {
	                    var selectedActivityUid = event.target.value;
	                    var selectedActivity = activityReference.find(function (a) {
	                        return a.uid == selectedActivityUid;
	                    });
	                    var incidentTypes = openingTicketPurposeReference.openingTicketPurposes.filter(openingTicketPurposeFilter(selectedActivity));
	
	                    _this3.setState({ selectedActivityUid: selectedActivityUid });
	                    _this3._sendAssignCmd(event, selectedActivity, incidentTypes);
	                }
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    bsClass: 'popover-lg popover',
	                    title: _i18n2.default.assignRemoveActivities
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _AssignRemoveActivityFromProviderContactPopover2.default.addActivity },
	                    _react2.default.createElement(
	                        'select',
	                        activityField,
	                        _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            _i18n2.default.addActivity,
	                            ' ...'
	                        ),
	                        filteredActivityReference.map(function (activity, index) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: index,
	                                    value: activity.uid },
	                                activity.label
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.PanelGroup,
	                    null,
	                    aggregations.map(function (aggrega, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            {
	                                key: index,
	                                className: _AssignRemoveActivityFromProviderContactPopover2.default.panelWrapper },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    onClick: function onClick(e) {
	                                        return _this3._sendRemoveCmd(e, aggrega.activity);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Panel,
	                                { collapsible: true,
	                                    key: aggrega.activity.uid,
	                                    className: 'panel-header',
	                                    header: activityHeader(aggrega) },
	                                _react2.default.createElement(
	                                    _reactBootstrap.PanelGroup,
	                                    null,
	                                    aggrega.incidentTypes.map(function (incidentType) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            {
	                                                key: incidentType.uid,
	                                                className: _AssignRemoveActivityFromProviderContactPopover2.default.panelWrapper },
	                                            incidentTypeButton(aggrega, incidentType),
	                                            _react2.default.createElement(_reactBootstrap.Panel, { collapsible: true,
	                                                key: incidentType.uid,
	                                                header: incidentTypeHeader(aggrega, incidentType) })
	                                        );
	                                    })
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssignRemoveActivityFromProviderContactPopover;
	}(_react.Component);
	
	AssignRemoveActivityFromProviderContactPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AssignRemoveActivityFromProviderContactPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        activityReference: state.reference.activityRef,
	        openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
	        contact: state.provider.contact.contact
	    };
	})(AssignRemoveActivityFromProviderContactPopover);
	
	exports.default = AssignRemoveActivityFromProviderContactPopover;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _PatrimonyPicker = __webpack_require__(548);
	
	var _PatrimonyPicker2 = _interopRequireDefault(_PatrimonyPicker);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssociateDissociateProviderContactFromPatrimonyPopover = function (_Component) {
	    _inherits(AssociateDissociateProviderContactFromPatrimonyPopover, _Component);
	
	    function AssociateDissociateProviderContactFromPatrimonyPopover() {
	        _classCallCheck(this, AssociateDissociateProviderContactFromPatrimonyPopover);
	
	        return _possibleConstructorReturn(this, (AssociateDissociateProviderContactFromPatrimonyPopover.__proto__ || Object.getPrototypeOf(AssociateDissociateProviderContactFromPatrimonyPopover)).apply(this, arguments));
	    }
	
	    _createClass(AssociateDissociateProviderContactFromPatrimonyPopover, [{
	        key: '_sendAssociateCmd',
	        value: function _sendAssociateCmd(patrimony) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user;
	
	
	            return dispatch((0, _actions.sendAssociateProviderContactWithPatrimonyCmd)(patrimony.uid)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            });
	        }
	    }, {
	        key: '_sendDissociateCmd',
	        value: function _sendDissociateCmd(patrimony) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                user = _props2.user;
	
	
	            return dispatch((0, _actions.sendDissociateProviderContactFromPatrimonyCmd)(patrimony.uid)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            });
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(action, patrimony) {
	            if (action == 'Add') return this._sendAssociateCmd(patrimony);
	            if (action == 'Remove') return this._sendDissociateCmd(patrimony);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                contact = _props3.contact,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'contact', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    bsClass: 'popover-lg popover',
	                    title: _i18n2.default.associateDissociatePatrimonies
	                }, others),
	                _react2.default.createElement(_PatrimonyPicker2.default, { multi: true, split: true,
	                    company: contact.company,
	                    value: contact.patrimonies,
	                    onSubmit: function onSubmit(a, p) {
	                        return _this2._sendCmd(a, p);
	                    } }),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssociateDissociateProviderContactFromPatrimonyPopover;
	}(_react.Component);
	
	AssociateDissociateProviderContactFromPatrimonyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AssociateDissociateProviderContactFromPatrimonyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        contact: state.provider.contact.contact
	    };
	})(AssociateDissociateProviderContactFromPatrimonyPopover);
	
	exports.default = AssociateDissociateProviderContactFromPatrimonyPopover;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ProviderPicker = __webpack_require__(1102);
	
	var _ProviderPicker2 = _interopRequireDefault(_ProviderPicker);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssociateProviderContactWithProviderCompanyPopover = function (_Component) {
	    _inherits(AssociateProviderContactWithProviderCompanyPopover, _Component);
	
	    function AssociateProviderContactWithProviderCompanyPopover() {
	        _classCallCheck(this, AssociateProviderContactWithProviderCompanyPopover);
	
	        return _possibleConstructorReturn(this, (AssociateProviderContactWithProviderCompanyPopover.__proto__ || Object.getPrototypeOf(AssociateProviderContactWithProviderCompanyPopover)).apply(this, arguments));
	    }
	
	    _createClass(AssociateProviderContactWithProviderCompanyPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contact = _props.contact;
	
	            dispatch((0, _actions.updateAssociateProviderContactWithProviderCompanyCmd)({ providerCompanyUid: contact.providerCompany }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.contact != this.props.contact) {
	                var dispatch = nextProps.dispatch,
	                    contact = nextProps.contact;
	
	                dispatch((0, _actions.updateAssociateProviderContactWithProviderCompanyCmd)({ providerCompanyUid: contact.providerCompany }));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(action) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	            return dispatch((0, _actions.sendAssociateProviderContactWithProviderCompanyCmd)()).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                onHide = _props3.onHide,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'onHide', 'form', 'cmd']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    bsClass: 'popover-lg popover',
	                    title: _i18n2.default.associateProvider
	                }, others),
	                _react2.default.createElement(_ProviderPicker2.default, _extends({ split: true
	                }, form.providerCompanyUid())),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssociateProviderContactWithProviderCompanyPopover;
	}(_react.Component);
	
	AssociateProviderContactWithProviderCompanyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AssociateProviderContactWithProviderCompanyPopover = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.AssociateProviderContactWithProviderCompanyCmd.schema,
	    action: _actions.ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED
	})(AssociateProviderContactWithProviderCompanyPopover);
	
	AssociateProviderContactWithProviderCompanyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.associateProviderContactWithProviderCompanyCmd,
	        contact: state.provider.contact.contact
	    };
	})(AssociateProviderContactWithProviderCompanyPopover);
	
	exports.default = AssociateProviderContactWithProviderCompanyPopover;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _chartist = __webpack_require__(271);
	
	var _chartist2 = _interopRequireDefault(_chartist);
	
	var _chartistPluginTooltips = __webpack_require__(790);
	
	var _chartistPluginTooltips2 = _interopRequireDefault(_chartistPluginTooltips);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _Chart = __webpack_require__(275);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallBeforeMissionAcceptedDashboardPanel = function (_Component) {
	    _inherits(CallBeforeMissionAcceptedDashboardPanel, _Component);
	
	    function CallBeforeMissionAcceptedDashboardPanel() {
	        _classCallCheck(this, CallBeforeMissionAcceptedDashboardPanel);
	
	        return _possibleConstructorReturn(this, (CallBeforeMissionAcceptedDashboardPanel.__proto__ || Object.getPrototypeOf(CallBeforeMissionAcceptedDashboardPanel)).apply(this, arguments));
	    }
	
	    _createClass(CallBeforeMissionAcceptedDashboardPanel, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contactStats = _props.contactStats,
	                others = _objectWithoutProperties(_props, ['dispatch', 'contactStats']);
	
	            var panelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _i18n2.default.callBeforeMissionAccepted
	            );
	
	            var aggregateDataStep = (0, _Chart.aggregateDataTimeStep)({
	                stepReduce: function stepReduce(a) {
	                    return Math.round(a.reduce(function (r, v) {
	                        return r + v;
	                    }, 0) / a.length);
	                }
	            });
	
	            var chartAxisY = {
	                onlyInteger: true
	            };
	
	            var chartPlugins = [_chartist2.default.plugins.tooltip({
	                appendToBody: true
	            })];
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader,
	                    help: _i18n2.default.callBeforeMissionAcceptedText
	                }, others),
	                contactStats.callBeforeMissionAccepted.length > 0 && _react2.default.createElement(_Chart2.default, { fill: true,
	                    kind: 'Bar',
	                    axisY: chartAxisY,
	                    plugins: chartPlugins,
	                    display: function display(a) {
	                        return new Date(a.day);
	                    },
	                    identify: function identify(a) {
	                        return a.count;
	                    },
	                    data: aggregateDataStep,
	                    value: [contactStats.callBeforeMissionAccepted] })
	            );
	        }
	    }]);
	
	    return CallBeforeMissionAcceptedDashboardPanel;
	}(_react.Component);
	
	CallBeforeMissionAcceptedDashboardPanel.propTypes = {};
	
	
	CallBeforeMissionAcceptedDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        contactStats: state.provider.contact.contactStats
	    };
	})(CallBeforeMissionAcceptedDashboardPanel);
	
	exports.default = CallBeforeMissionAcceptedDashboardPanel;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ContactCard = __webpack_require__(2265);
	
	var _ContactCard2 = _interopRequireDefault(_ContactCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactCard = function (_Component) {
	    _inherits(ContactCard, _Component);
	
	    function ContactCard() {
	        _classCallCheck(this, ContactCard);
	
	        return _possibleConstructorReturn(this, (ContactCard.__proto__ || Object.getPrototypeOf(ContactCard)).apply(this, arguments));
	    }
	
	    _createClass(ContactCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                contact = _props.contact,
	                others = _objectWithoutProperties(_props, ['contact']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.providerContact
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ContactCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true,
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    !contact.active && _react2.default.createElement(
	                        'div',
	                        { className: _ContactCard2.default.status },
	                        _react2.default.createElement(_Icon2.default, { icon: 'closed', size: 'sm' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContactCard2.default.label },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            '> ',
	                            contact.name.firstName,
	                            ' ',
	                            contact.name.lastName,
	                            ' ',
	                            contact.name.value
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContactCard2.default.detail },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _i18n2.default.contactInformation
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _ContactCard2.default.company },
	                            contact.providerCompany && contact.providerCompany.name
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ContactCard2.default.contact },
	                            contact.phones.slice(0, 2).map(function (phone, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'phone', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        (0, _phonez2.default)(phone).format()
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ContactCard2.default.contact },
	                            contact.emails.slice(0, 1).map(function (email, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    {
	                                        className: _ContactCard2.default.mail,
	                                        key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'mail', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        email
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ContactCard2.default.contact },
	                            contact.fax.slice(0, 2).map(function (fax, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'fax', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        (0, _phonez2.default)(fax).format()
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactCard;
	}(_react.Component);
	
	ContactCard.propTypes = {
	    contact: _react.PropTypes.object.isRequired
	};
	exports.default = ContactCard;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _CommitmentLayout = __webpack_require__(1100);
	
	var _CommitmentLayout2 = _interopRequireDefault(_CommitmentLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactCommitmentLayout = function (_Component) {
	    _inherits(ContactCommitmentLayout, _Component);
	
	    function ContactCommitmentLayout() {
	        _classCallCheck(this, ContactCommitmentLayout);
	
	        return _possibleConstructorReturn(this, (ContactCommitmentLayout.__proto__ || Object.getPrototypeOf(ContactCommitmentLayout)).apply(this, arguments));
	    }
	
	    _createClass(ContactCommitmentLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contact = _props.contact,
	                activityReference = _props.activityReference,
	                openingTicketPurposeReference = _props.openingTicketPurposeReference;
	
	
	            return _react2.default.createElement(_CommitmentLayout2.default, {
	                committed: contact,
	                commitments: contact.commitments,
	                activities: contact.activities,
	                activityReference: activityReference,
	                openingTicketPurposeReference: openingTicketPurposeReference });
	        }
	    }]);
	
	    return ContactCommitmentLayout;
	}(_react.Component);
	
	ContactCommitmentLayout.propTypes = {};
	
	
	ContactCommitmentLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        contact: state.provider.contact.contact,
	        activityReference: state.reference.activityRef,
	        openingTicketPurposeReference: state.reference.openingTicketPurposeRef
	    };
	})(ContactCommitmentLayout);
	
	exports.default = ContactCommitmentLayout;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _links = __webpack_require__(33);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _mathz = __webpack_require__(108);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ClosingRateDashboardPanel = __webpack_require__(549);
	
	var _ClosingRateDashboardPanel2 = _interopRequireDefault(_ClosingRateDashboardPanel);
	
	var _ClosingEventDashboardPanel = __webpack_require__(1501);
	
	var _ClosingEventDashboardPanel2 = _interopRequireDefault(_ClosingEventDashboardPanel);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _InterventionDelayDashboardPanel = __webpack_require__(1434);
	
	var _InterventionDelayDashboardPanel2 = _interopRequireDefault(_InterventionDelayDashboardPanel);
	
	var _InterventionNumberDashboardPanel = __webpack_require__(1435);
	
	var _InterventionNumberDashboardPanel2 = _interopRequireDefault(_InterventionNumberDashboardPanel);
	
	var _MissionAcceptedDelayDashboardPanel = __webpack_require__(1436);
	
	var _MissionAcceptedDelayDashboardPanel2 = _interopRequireDefault(_MissionAcceptedDelayDashboardPanel);
	
	var _RepairDelayDashboardPanel = __webpack_require__(1454);
	
	var _RepairDelayDashboardPanel2 = _interopRequireDefault(_RepairDelayDashboardPanel);
	
	var _CallBeforeMissionAcceptedDashboardPanel = __webpack_require__(1413);
	
	var _CallBeforeMissionAcceptedDashboardPanel2 = _interopRequireDefault(_CallBeforeMissionAcceptedDashboardPanel);
	
	var _ContactDashboard = __webpack_require__(2266);
	
	var _ContactDashboard2 = _interopRequireDefault(_ContactDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactDashboard = function (_Component) {
	    _inherits(ContactDashboard, _Component);
	
	    function ContactDashboard() {
	        _classCallCheck(this, ContactDashboard);
	
	        return _possibleConstructorReturn(this, (ContactDashboard.__proto__ || Object.getPrototypeOf(ContactDashboard)).apply(this, arguments));
	    }
	
	    _createClass(ContactDashboard, [{
	        key: '_navigate',
	        value: function _navigate(event, provider) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)('/providers/' + provider.uid));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contact = _props.contact,
	                contactStats = _props.contactStats,
	                _appLinks = _props._appLinks;
	
	
	            var repairTimelimitStat = contactStats.complianceWithCommitments.repairTimelimit;
	            var interventionTimelimitStat = contactStats.complianceWithCommitments.interventionTimelimit;
	
	            var repairTimelimitRate = (0, _mathz.percentage)({
	                source: Object.keys(repairTimelimitStat),
	                identify: function identify(k) {
	                    return repairTimelimitStat[k];
	                },
	                match: function match(k) {
	                    return k == 'ticketCompliant';
	                }
	            });
	
	            var interventionTimelimitRate = (0, _mathz.percentage)({
	                source: Object.keys(interventionTimelimitStat),
	                identify: function identify(k) {
	                    return interventionTimelimitStat[k];
	                },
	                match: function match(k) {
	                    return k == 'ticketCompliant';
	                }
	            });
	
	            var complianceStatus = function complianceStatus(percentage) {
	                if (percentage >= 85) return 'success';
	                if (percentage >= 65) return 'warning';
	                if (!isNaN(percentage)) return 'danger';
	            };
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.description) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _ContactDashboard2.default.data },
	                                contact.phones.length > 0 && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.phone,
	                                        ' :'
	                                    ),
	                                    contact.phones.map(function (phone, index) {
	                                        return _react2.default.createElement(
	                                            'span',
	                                            { key: index },
	                                            index > 0 && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' |'
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                (0, _phonez2.default)(phone).format()
	                                            )
	                                        );
	                                    })
	                                ),
	                                contact.emails.length > 0 && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.email,
	                                        ' :'
	                                    ),
	                                    contact.emails.map(function (email, index) {
	                                        return _react2.default.createElement(
	                                            'span',
	                                            { key: index },
	                                            index > 0 && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' |'
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                email
	                                            )
	                                        );
	                                    })
	                                ),
	                                contact.fax.length > 0 && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.fax,
	                                        ' :'
	                                    ),
	                                    contact.fax.map(function (fax, index) {
	                                        return _react2.default.createElement(
	                                            'span',
	                                            { key: index },
	                                            index > 0 && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' |'
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                (0, _phonez2.default)(fax).format()
	                                            )
	                                        );
	                                    })
	                                ),
	                                contact.providerCompany && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.providerz,
	                                            ' :'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: function onClick(e) {
	                                                return _this2._navigate(e, contact.providerCompany);
	                                            } },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            contact.providerCompany.name
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(_ClosingRateDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _appLinks.find((0, _links.linkFinder)('tickets')) && _react2.default.createElement(_ClosingEventDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 8 },
	                        _react2.default.createElement(_InterventionDelayDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 6 },
	                        _react2.default.createElement(_MissionAcceptedDelayDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 6 },
	                        _react2.default.createElement(_RepairDelayDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 6 },
	                        _react2.default.createElement(_CallBeforeMissionAcceptedDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 6 },
	                        _react2.default.createElement(_InterventionNumberDashboardPanel2.default, { light: true })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 6 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.repairTimelimitRate) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ContactDashboard2.default.repairTimelimitRate },
	                                !isNaN(repairTimelimitRate) && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: (0, _classnames2.default)(_ContactDashboard2.default.rate, _ContactDashboard2.default[complianceStatus(interventionTimelimitRate)]) },
	                                        repairTimelimitRate,
	                                        ' %'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _ContactDashboard2.default.stats },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _ContactDashboard2.default.count },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                repairTimelimitStat.ticketCompliant
	                                            ),
	                                            _react2.default.createElement(
	                                                'small',
	                                                null,
	                                                _i18n2.default.compliantTickets
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _ContactDashboard2.default.count },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                repairTimelimitStat.ticketNonCompliant
	                                            ),
	                                            _react2.default.createElement(
	                                                'small',
	                                                null,
	                                                _i18n2.default.notCompliantTickets
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _ContactDashboard2.default.count },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                repairTimelimitStat.ticketCompliant + repairTimelimitStat.ticketNonCompliant
	                                            ),
	                                            _react2.default.createElement(
	                                                'small',
	                                                null,
	                                                _i18n2.default.qualifiedTickets
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 6 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.interventionTimelimitRate) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ContactDashboard2.default.interventionTimelimitRate },
	                                !isNaN(interventionTimelimitRate) && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: (0, _classnames2.default)(_ContactDashboard2.default.rate, _ContactDashboard2.default[complianceStatus(interventionTimelimitRate)]) },
	                                        interventionTimelimitRate,
	                                        ' %'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _ContactDashboard2.default.stats },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _ContactDashboard2.default.count },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                interventionTimelimitStat.ticketCompliant
	                                            ),
	                                            _react2.default.createElement(
	                                                'small',
	                                                null,
	                                                _i18n2.default.compliantTickets
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _ContactDashboard2.default.count },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                interventionTimelimitStat.ticketNonCompliant
	                                            ),
	                                            _react2.default.createElement(
	                                                'small',
	                                                null,
	                                                _i18n2.default.notCompliantTickets
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _ContactDashboard2.default.count },
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                interventionTimelimitStat.ticketCompliant + interventionTimelimitStat.ticketNonCompliant
	                                            ),
	                                            _react2.default.createElement(
	                                                'small',
	                                                null,
	                                                _i18n2.default.qualifiedTickets
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactDashboard;
	}(_react.Component);
	
	ContactDashboard.propTypes = {};
	
	
	ContactDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        contact: state.provider.contact.contact,
	        contactStats: state.provider.contact.contactStats,
	        _appLinks: state.app._links
	    };
	})(ContactDashboard);
	
	exports.default = ContactDashboard;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mathz = __webpack_require__(108);
	
	var _momentz = __webpack_require__(186);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderScores = __webpack_require__(1103);
	
	var _ProviderScores2 = _interopRequireDefault(_ProviderScores);
	
	var _ContactFilterModal = __webpack_require__(1418);
	
	var _ContactFilterModal2 = _interopRequireDefault(_ContactFilterModal);
	
	var _AssociateProviderContactWithProviderCompanyPopover = __webpack_require__(1412);
	
	var _AssociateProviderContactWithProviderCompanyPopover2 = _interopRequireDefault(_AssociateProviderContactWithProviderCompanyPopover);
	
	var _AssociateDissociateProviderContactFromPatrimonyPopover = __webpack_require__(1411);
	
	var _AssociateDissociateProviderContactFromPatrimonyPopover2 = _interopRequireDefault(_AssociateDissociateProviderContactFromPatrimonyPopover);
	
	var _AssignRemoveActivityFromProviderContactPopover = __webpack_require__(1410);
	
	var _AssignRemoveActivityFromProviderContactPopover2 = _interopRequireDefault(_AssignRemoveActivityFromProviderContactPopover);
	
	var _UpdateProviderContactPopover = __webpack_require__(1457);
	
	var _UpdateProviderContactPopover2 = _interopRequireDefault(_UpdateProviderContactPopover);
	
	var _ContactDetail = __webpack_require__(2267);
	
	var _ContactDetail2 = _interopRequireDefault(_ContactDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactDetail = function (_Component) {
	    _inherits(ContactDetail, _Component);
	
	    function ContactDetail(props) {
	        _classCallCheck(this, ContactDetail);
	
	        var _this = _possibleConstructorReturn(this, (ContactDetail.__proto__ || Object.getPrototypeOf(ContactDetail)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ContactDetail, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var contactStats = this.props.contactStats;
	
	            var repairTimelimitStat = contactStats.complianceWithCommitments.repairTimelimit;
	            var interventionTimelimitStat = contactStats.complianceWithCommitments.interventionTimelimit;
	
	            var interventionDelay = (0, _mathz.average)({ source: contactStats.interventionDelay, identify: function identify(v) {
	                    return v.duration;
	                } });
	            var missionAcceptedDelay = (0, _mathz.average)({ source: contactStats.missionAcceptedDelay, identify: function identify(v) {
	                    return v.duration;
	                } });
	            var repairDelay = (0, _mathz.average)({ source: contactStats.repairDelay, identify: function identify(v) {
	                    return v.duration;
	                } });
	            var repairTimelimit = (0, _mathz.percentage)({ source: Object.keys(repairTimelimitStat), identify: function identify(k) {
	                    return repairTimelimitStat[k];
	                }, match: function match(k) {
	                    return k == 'ticketCompliant';
	                } });
	            var interventionTimelimit = (0, _mathz.percentage)({ source: Object.keys(interventionTimelimitStat), identify: function identify(k) {
	                    return interventionTimelimitStat[k];
	                }, match: function match(k) {
	                    return k == 'ticketCompliant';
	                } });
	            this.setState({ aggregatedStats: { interventionDelay: interventionDelay, missionAcceptedDelay: missionAcceptedDelay, repairDelay: repairDelay, complianceWithCommitments: { repairTimelimit: repairTimelimit, interventionTimelimit: interventionTimelimit } } });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.contactStats != this.props.contactStats) {
	                var contactStats = nextProps.contactStats;
	
	                var repairTimelimitStat = contactStats.complianceWithCommitments.repairTimelimit;
	                var interventionTimelimitStat = contactStats.complianceWithCommitments.interventionTimelimit;
	
	                var interventionDelay = (0, _mathz.average)({ source: contactStats.interventionDelay, identify: function identify(v) {
	                        return v.duration;
	                    } });
	                var missionAcceptedDelay = (0, _mathz.average)({ source: contactStats.missionAcceptedDelay, identify: function identify(v) {
	                        return v.duration;
	                    } });
	                var repairDelay = (0, _mathz.average)({ source: contactStats.repairDelay, identify: function identify(v) {
	                        return v.duration;
	                    } });
	                var repairTimelimit = (0, _mathz.percentage)({ source: Object.keys(repairTimelimitStat), identify: function identify(k) {
	                        return repairTimelimitStat[k];
	                    }, match: function match(k) {
	                        return k == 'ticketCompliant';
	                    } });
	                var interventionTimelimit = (0, _mathz.percentage)({ source: Object.keys(interventionTimelimitStat), identify: function identify(k) {
	                        return interventionTimelimitStat[k];
	                    }, match: function match(k) {
	                        return k == 'ticketCompliant';
	                    } });
	                this.setState({ aggregatedStats: { interventionDelay: interventionDelay, missionAcceptedDelay: missionAcceptedDelay, repairDelay: repairDelay, complianceWithCommitments: { repairTimelimit: repairTimelimit, interventionTimelimit: interventionTimelimit } } });
	            }
	        }
	    }, {
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_closePopover',
	        value: function _closePopover(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedPopover: null });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, name) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedModal: name });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                contact = _props.contact,
	                contactStats = _props.contactStats,
	                contactFilter = _props.contactFilter;
	            var _state = this.state,
	                openedPopover = _state.openedPopover,
	                openedModal = _state.openedModal,
	                aggregatedStats = _state.aggregatedStats;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _ContactDetail2.default.menu },
	                    contact._links.find((0, _links.linkFinder)('AssociateProviderContactWithProviderCompany')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AssociateProviderContactWithProviderCompanyPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.associateProvider
	                            )
	                        )
	                    ),
	                    contact._links.find((0, _links.linkFinder)(['AssociateProviderContactWithPatrimony', 'DissociateProviderContactFromPatrimony'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AssociateDissociateProviderContactFromPatrimonyPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.associateDissociatePatrimonies
	                            )
	                        )
	                    ),
	                    contact._links.find((0, _links.linkFinder)(['AssignActivityToProviderContact', 'RemoveActivityFromProviderContact'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AssignRemoveActivityFromProviderContactPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.assignRemoveActivities
	                            )
	                        )
	                    ),
	                    contact._links.find((0, _links.linkFinder)('UpdateProviderContact')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'UpdateProviderContactPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.updateProviderContact
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: function onHide() {
	                            return _this2._closePopover();
	                        } },
	                    popover
	                );
	            };
	
	            var complianceStatus = function complianceStatus(percentage) {
	                if (percentage >= 85) return 'success';
	                if (percentage >= 65) return 'warning';
	                if (!isNaN(percentage)) return 'danger';
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ContactDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        { className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _ContactDetail2.default.header },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                contact.name.firstName,
	                                ' ',
	                                contact.name.lastName,
	                                ' ',
	                                contact.name.value
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _ContactDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        contact._links.find((0, _links.linkFinder)('AssociateProviderContactWithProviderCompany')) && editOverlay('AssociateProviderContactWithProviderCompanyPopover', _react2.default.createElement(_AssociateProviderContactWithProviderCompanyPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        contact._links.find((0, _links.linkFinder)(['AssociateProviderContactWithPatrimony', 'DissociateProviderContactFromPatrimony'])) && editOverlay('AssociateDissociateProviderContactFromPatrimonyPopover', _react2.default.createElement(_AssociateDissociateProviderContactFromPatrimonyPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        contact._links.find((0, _links.linkFinder)(['AssignActivityToProviderContact', 'RemoveActivityFromProviderContact'])) && editOverlay('AssignRemoveActivityFromProviderContactPopover', _react2.default.createElement(_AssignRemoveActivityFromProviderContactPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        contact._links.find((0, _links.linkFinder)('UpdateProviderContact')) && editOverlay('UpdateProviderContactPopover', _react2.default.createElement(_UpdateProviderContactPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } }))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContactDetail2.default.filter },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openModal(e, 'ContactFilterModal');
	                                } },
	                            contactFilter && (contactFilter.from || contactFilter.to) && _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    contactFilter.from && (0, _moment2.default)(contactFilter.from).format(_i18n2.default.dateFormat.from),
	                                    ' '
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    contactFilter.to && (0, _moment2.default)(contactFilter.to).format(_i18n2.default.dateFormat.to),
	                                    ' '
	                                )
	                            ) || _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.selectDateRange,
	                                ' '
	                            ),
	                            _react2.default.createElement(_Icon2.default, { icon: 'calendar', size: 'sm' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ContactDetail2.default.stats },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.delays
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _ContactDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        aggregatedStats.interventionDelay && _moment2.default.duration(aggregatedStats.interventionDelay).humanize() || '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.intervention
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _ContactDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        aggregatedStats.missionAcceptedDelay && _moment2.default.duration(aggregatedStats.missionAcceptedDelay).humanize() || '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.missionAccepted
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _ContactDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        aggregatedStats.repairDelay && _moment2.default.duration(aggregatedStats.repairDelay).humanize() || '---'
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.repair
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(_ProviderScores2.default, null)
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ContactDetail2.default.stats },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.commitments,
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.commitmentCompliancyRate
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: (0, _classnames2.default)(_ContactDetail2.default.count, _ContactDetail2.default[complianceStatus(aggregatedStats.complianceWithCommitments.repairTimelimit)]) },
	                                    !isNaN(aggregatedStats.complianceWithCommitments.repairTimelimit) && _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        aggregatedStats.complianceWithCommitments.repairTimelimit,
	                                        ' %'
	                                    ) || '---',
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.repairDelay
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: (0, _classnames2.default)(_ContactDetail2.default.count, _ContactDetail2.default[complianceStatus(aggregatedStats.complianceWithCommitments.interventionTimelimit)]) },
	                                    !isNaN(aggregatedStats.complianceWithCommitments.interventionTimelimit) && _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        aggregatedStats.complianceWithCommitments.interventionTimelimit,
	                                        ' %'
	                                    ) || '---',
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        _i18n2.default.interventionDelay
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/providercontacts\/[\w-]+$/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/providercontacts/' + contact.uid));
	                                } },
	                            _i18n2.default.synthesis
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/providercontacts\/[\w-]+\/tickets/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/providercontacts/' + contact.uid + '/tickets'));
	                                } },
	                            _i18n2.default.tickets
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/providercontacts\/[\w-]+\/commitments/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _reactRouterRedux.push)('/providercontacts/' + contact.uid + '/commitments'));
	                                } },
	                            _i18n2.default.commitments
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.documents
	                        )
	                    ),
	                    _react2.default.createElement(_ContactFilterModal2.default, {
	                        show: openedModal == 'ContactFilterModal',
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } })
	                ),
	                children
	            );
	        }
	    }]);
	
	    return ContactDetail;
	}(_react.Component);
	
	ContactDetail.propTypes = {};
	
	
	ContactDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        contact: state.provider.contact.contact,
	        contactStats: state.provider.contact.contactStats,
	        contactFilter: state.provider.contact.contactFilter
	    };
	})(ContactDetail);
	
	exports.default = ContactDetail;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _DayRangePicker = __webpack_require__(889);
	
	var _DayRangePicker2 = _interopRequireDefault(_DayRangePicker);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactFilterModal = function (_Component) {
	    _inherits(ContactFilterModal, _Component);
	
	    function ContactFilterModal() {
	        _classCallCheck(this, ContactFilterModal);
	
	        return _possibleConstructorReturn(this, (ContactFilterModal.__proto__ || Object.getPrototypeOf(ContactFilterModal)).apply(this, arguments));
	    }
	
	    _createClass(ContactFilterModal, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contactFilter = _props.contactFilter,
	                form = _props.form,
	                onHide = _props.onHide,
	                others = _objectWithoutProperties(_props, ['dispatch', 'contactFilter', 'form', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.filterStats
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_DayRangePicker2.default, form(['from', 'to']))
	                )
	            );
	        }
	    }]);
	
	    return ContactFilterModal;
	}(_react.Component);
	
	ContactFilterModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ContactFilterModal = (0, _form.connectForm)({
	    target: 'contactFilter',
	    schema: _models.Filter.schema,
	    action: _actions.CONTACT_FILTER_UPDATED
	})(ContactFilterModal);
	
	ContactFilterModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        contactFilter: state.provider.contact.contactFilter
	    };
	})(ContactFilterModal);
	
	exports.default = ContactFilterModal;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(268);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ContactSearchBar = __webpack_require__(1420);
	
	var _ContactSearchBar2 = _interopRequireDefault(_ContactSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactLayout = function (_Component) {
	    _inherits(ContactLayout, _Component);
	
	    function ContactLayout() {
	        _classCallCheck(this, ContactLayout);
	
	        return _possibleConstructorReturn(this, (ContactLayout.__proto__ || Object.getPrototypeOf(ContactLayout)).apply(this, arguments));
	    }
	
	    _createClass(ContactLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                history = _props.history,
	                routes = _props.routes,
	                params = _props.params,
	                contact = _props.contact;
	
	
	            var breadcrumbDisplay = function breadcrumbDisplay(token) {
	                switch (token) {
	                    case ':id':
	                        return contact.name.value || contact.name.firstName + ' ' + contact.name.lastName;
	                    case 'providercontacts':
	                        return (0, _extract2.default)(_i18n2.default, 'providerContacts');
	                    default:
	                        return (0, _extract2.default)(_i18n2.default, token);
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Provider contacts' }),
	                _react2.default.createElement(_ContactSearchBar2.default, null),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        _react2.default.createElement(_router.Breadcrumb, {
	                            history: history,
	                            routes: routes,
	                            params: params,
	                            display: breadcrumbDisplay }),
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactLayout;
	}(_react.Component);
	
	ContactLayout.propTypes = {};
	
	
	ContactLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        contact: state.provider.contact.contact
	    };
	})(ContactLayout);
	
	exports.default = ContactLayout;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _form = __webpack_require__(15);
	
	var _browser = __webpack_require__(54);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _status = __webpack_require__(13);
	
	var _SearchBar = __webpack_require__(509);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactSearchBar = function (_Component) {
	    _inherits(ContactSearchBar, _Component);
	
	    function ContactSearchBar() {
	        _classCallCheck(this, ContactSearchBar);
	
	        return _possibleConstructorReturn(this, (ContactSearchBar.__proto__ || Object.getPrototypeOf(ContactSearchBar)).apply(this, arguments));
	    }
	
	    _createClass(ContactSearchBar, [{
	        key: '_search',
	        value: function _search(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                criteria = _props.criteria;
	
	
	            if (event) {
	                event.preventDefault();
	            }
	
	            return dispatch((0, _actions.loadContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, criteria))).then(function () {
	                if (location.pathname != '/providercontacts') {
	                    return dispatch((0, _reactRouterRedux.push)('/providercontacts'));
	                }
	            });
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props2 = this.props,
	                    dispatch = _props2.dispatch,
	                    location = _props2.location,
	                    criteria = _props2.criteria;
	
	
	                return dispatch((0, _actions.loadContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, criteria))).then(function () {
	                    if (location.pathname != '/providercontacts') {
	                        return dispatch((0, _reactRouterRedux.push)('/providercontacts'));
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                location = _props3.location,
	                criteria = _props3.criteria,
	                form = _props3.form;
	
	
	            return _react2.default.createElement(_SearchBar2.default, _extends({
	                placeholder: (0, _extract2.default)(_i18n2.default.searchProviderContactStream, (0, _browser.mediaQuery)()),
	                onClick: function onClick(e) {
	                    return _this2._search(e);
	                },
	                onKeyPress: function onKeyPress(e) {
	                    return _this2._searchOnKeyPress(e);
	                }
	            }, form.fullText()));
	        }
	    }]);
	
	    return ContactSearchBar;
	}(_react.Component);
	
	ContactSearchBar.propTypes = {};
	
	
	ContactSearchBar = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.ContactCriteria.schema,
	    action: _actions.CONTACT_CRITERIA_UPDATED
	})(ContactSearchBar);
	
	ContactSearchBar = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        criteria: state.provider.contact.criteria
	    };
	})(ContactSearchBar);
	
	exports.default = ContactSearchBar;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Selector = __webpack_require__(954);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	var _actions = __webpack_require__(113);
	
	var _actions2 = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ContactSelector = __webpack_require__(2268);
	
	var _ContactSelector2 = _interopRequireDefault(_ContactSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactSelector = function (_Component) {
	    _inherits(ContactSelector, _Component);
	
	    function ContactSelector() {
	        _classCallCheck(this, ContactSelector);
	
	        return _possibleConstructorReturn(this, (ContactSelector.__proto__ || Object.getPrototypeOf(ContactSelector)).apply(this, arguments));
	    }
	
	    _createClass(ContactSelector, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company;
	
	
	            dispatch((0, _actions2.resetContactMinorCriteria)());
	            dispatch((0, _actions2.queryContactStream)(_extends({}, _actions2.DEFAULT_CONTACT_QUERY, { companyUid: company.uid, range: { offset: 0, limit: 99 } })));
	            dispatch((0, _actions.queryActivityRef)());
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.company != nextProps.company) {
	                var dispatch = nextProps.dispatch,
	                    company = nextProps.company;
	
	
	                dispatch((0, _actions2.resetContactMinorCriteria)());
	                dispatch((0, _actions2.queryContactStream)(_extends({}, _actions2.DEFAULT_CONTACT_QUERY, { companyUid: company.uid, range: { offset: 0, limit: 99 } })));
	            }
	        }
	    }, {
	        key: '_search',
	        value: function _search(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                minorCriteria = _props2.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions2.queryContactStream)(minorCriteria));
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props3 = this.props,
	                    dispatch = _props3.dispatch,
	                    minorCriteria = _props3.minorCriteria;
	
	                dispatch((0, _actions2.queryContactStream)(minorCriteria));
	            }
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                minorCriteria = _props4.minorCriteria;
	
	
	            event.preventDefault();
	            dispatch((0, _actions2.updateContactMinorCriteria)({ fullText: null }));
	            dispatch((0, _actions2.queryContactStream)(_extends({}, minorCriteria, { fullText: null })));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props5 = this.props,
	                dispatch = _props5.dispatch,
	                form = _props5.form,
	                company = _props5.company,
	                reference = _props5.reference,
	                minorCriteria = _props5.minorCriteria,
	                stream = _props5.stream,
	                range = _props5.range,
	                query = _props5.query,
	                others = _objectWithoutProperties(_props5, ['dispatch', 'form', 'company', 'reference', 'minorCriteria', 'stream', 'range', 'query']);
	
	            var searched = minorCriteria && minorCriteria.fullText && minorCriteria.fullText == (query && query.fullText);
	
	            var header = _react2.default.createElement(
	                'div',
	                { className: _ContactSelector2.default.search },
	                searched && _react2.default.createElement(
	                    'a',
	                    {
	                        href: '',
	                        onClick: function onClick(e) {
	                            return _this2._clear(e);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	                ),
	                !searched && _react2.default.createElement(
	                    'a',
	                    {
	                        href: '',
	                        onClick: function onClick(e) {
	                            return _this2._search(e);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactSelector2.default.container },
	                    _react2.default.createElement('input', _extends({
	                        type: 'text',
	                        onKeyPress: function onKeyPress(e) {
	                            return _this2._searchOnKeyPress(e);
	                        },
	                        placeholder: _i18n2.default.searchStream.xs
	                    }, form.fullText()))
	                )
	            );
	
	            var afterContacts = function afterContacts() {
	                if (range && range.limit < range.count - 1) {
	                    var count = range.limit + 1;
	                    return _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _extract.replace)(_i18n2.default.useSearchProviderContactFilters, { count: count })
	                    );
	                }
	            };
	
	            var displayContact = function displayContact(contact) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _ContactSelector2.default.contact },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        contact.name.firstName,
	                        ' ',
	                        contact.name.lastName,
	                        ' ',
	                        contact.name.value
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _models.resolveActivities)(reference, contact.activities).map(function (activity, index) {
	                            return _react2.default.createElement(
	                                'small',
	                                {
	                                    key: index },
	                                index > 0 && _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' - '
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    activity.label
	                                )
	                            );
	                        })
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ContactSelector2.default.default },
	                _react2.default.createElement(_Selector2.default, _extends({
	                    source: stream,
	                    identify: function identify(c) {
	                        return c.uid;
	                    },
	                    display: displayContact,
	                    header: header,
	                    after: afterContacts()
	                }, others))
	            );
	        }
	    }]);
	
	    return ContactSelector;
	}(_react.Component);
	
	ContactSelector.propTypes = {
	    company: _react.PropTypes.object.isRequired
	};
	
	
	ContactSelector = (0, _form.connectForm)({
	    target: 'minorCriteria',
	    schema: _models.ContactCriteria.schema,
	    action: _actions2.CONTACT_MINOR_CRITERIA_UPDATED
	})(ContactSelector);
	
	ContactSelector = (0, _reactRedux.connect)(function (state) {
	    return {
	        reference: state.reference.activityRef,
	        minorCriteria: state.provider.contact.minorCriteria,
	        stream: state.provider.contact.stream,
	        range: state.provider.contact.range,
	        query: state.provider.contact.query
	    };
	})(ContactSelector);
	
	exports.default = ContactSelector;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ContactStats = __webpack_require__(2269);
	
	var _ContactStats2 = _interopRequireDefault(_ContactStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactStats = function (_Component) {
	    _inherits(ContactStats, _Component);
	
	    function ContactStats() {
	        _classCallCheck(this, ContactStats);
	
	        return _possibleConstructorReturn(this, (ContactStats.__proto__ || Object.getPrototypeOf(ContactStats)).apply(this, arguments));
	    }
	
	    _createClass(ContactStats, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                range = _props.range;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ContactStats2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContactStats2.default.switch },
	                    _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        {
	                            value: location.pathname,
	                            onChange: function onChange(p) {
	                                return p && dispatch((0, _reactRouterRedux.push)(p));
	                            } },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonGroup,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'small',
	                                    value: '/providercontacts' },
	                                _i18n2.default.myProviderContacts
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'small',
	                                    value: '/providercoverage' },
	                                _i18n2.default.providerDirectory
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        {
	                            value: location.pathname,
	                            onChange: function onChange(p) {
	                                return p && dispatch((0, _reactRouterRedux.push)(p));
	                            } },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonGroup,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: '/providers' },
	                                _i18n2.default.providersz
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: '/providercontacts' },
	                                _i18n2.default.providerContactsz
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    range.count,
	                    ' ',
	                    _i18n2.default.providers
	                )
	            );
	        }
	    }]);
	
	    return ContactStats;
	}(_react.Component);
	
	ContactStats.propTypes = {};
	
	
	ContactStats = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        range: state.provider.contact.range
	    };
	})(ContactStats);
	
	exports.default = ContactStats;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _ContactStream = __webpack_require__(896);
	
	var _ContactStream2 = _interopRequireDefault(_ContactStream);
	
	var _ContactStats = __webpack_require__(1422);
	
	var _ContactStats2 = _interopRequireDefault(_ContactStats);
	
	var _AddProviderContactModal = __webpack_require__(1407);
	
	var _AddProviderContactModal2 = _interopRequireDefault(_AddProviderContactModal);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactStreamLayout = function (_Component) {
	    _inherits(ContactStreamLayout, _Component);
	
	    function ContactStreamLayout(props) {
	        _classCallCheck(this, ContactStreamLayout);
	
	        var _this = _possibleConstructorReturn(this, (ContactStreamLayout.__proto__ || Object.getPrototypeOf(ContactStreamLayout)).call(this, props));
	
	        _this.state = {
	            opened: false
	        };
	        return _this;
	    }
	
	    _createClass(ContactStreamLayout, [{
	        key: '_open',
	        value: function _open() {
	            this.setState({ opened: true });
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({ opened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                _links = _props._links;
	            var opened = this.state.opened;
	
	
	            var newProviderContactBoxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.newProviderContact
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smPush: 8 },
	                        _react2.default.createElement(_ContactStats2.default, null),
	                        _links.find((0, _links2.linkFinder)('AddProviderContact')) && _react2.default.createElement(_Box2.default, {
	                            status: 'primary',
	                            header: newProviderContactBoxTitle,
	                            help: '+',
	                            onClick: function onClick() {
	                                return _this2._open();
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8, smPull: 4 },
	                        _react2.default.createElement(_ContactStream2.default, null)
	                    )
	                ),
	                _links.find((0, _links2.linkFinder)('AddProviderContact')) && opened && _react2.default.createElement(_AddProviderContactModal2.default, {
	                    show: opened,
	                    onHide: function onHide() {
	                        return _this2._close();
	                    } })
	            );
	        }
	    }]);
	
	    return ContactStreamLayout;
	}(_react.Component);
	
	ContactStreamLayout.propTypes = {};
	
	
	ContactStreamLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        _links: state.provider.contact._links
	    };
	})(ContactStreamLayout);
	
	exports.default = ContactStreamLayout;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Selector = __webpack_require__(954);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(113);
	
	var _actions2 = __webpack_require__(47);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateInterventionPeriodPanel = __webpack_require__(967);
	
	var _UpdateInterventionPeriodPanel2 = _interopRequireDefault(_UpdateInterventionPeriodPanel);
	
	var _ContactSuggestSelector = __webpack_require__(2271);
	
	var _ContactSuggestSelector2 = _interopRequireDefault(_ContactSuggestSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function linkedWithIconName(contact) {
	    if (contact.foundViaInterventionZone) return 'location';
	
	    switch (contact.directlyLinkedWith) {
	        case 'LinkedToPatrimony':
	            return 'individualHouse';
	        case 'LinkedToContract':
	            return 'insurance';
	        case 'LinkedToAgency':
	            return 'agency';
	        case 'LinkedToCompany':
	            return 'patrimony';
	    }
	}
	
	function linkedWithInfo(contact) {
	    if (contact.foundViaInterventionZone) return _i18n2.default.foundViaInterventionZone;
	    return (0, _extract2.default)(_i18n2.default.linkedWithInfo, contact.directlyLinkedWith);
	}
	
	function linkedWithStatus(contact) {
	    if (contact.directlyLinkedWith === 'LinkedToPatrimony' || contact.directlyLinkedWith === 'LinkedToContract') return 'primary';
	}
	
	function enrichActivities(activities, _ref, activitiesReference, incidentType) {
	    var openingTicketPurposes = _ref.openingTicketPurposes;
	
	    var matchPurpose = openingTicketPurposes.find(function (o) {
	        return o.uid === incidentType;
	    });
	    var matchesActivities = matchPurpose && matchPurpose.activities;
	    return activities.map(function (activity) {
	        var activityReference = activitiesReference.find(function (o) {
	            return o.uid === activity || o.uid === activity.activityUid;
	        });
	        var doesMatch = Boolean(activityReference && matchesActivities && matchesActivities.find(function (matchActivity) {
	            return matchActivity.uid === activityReference.uid;
	        }));
	        return activityReference ? _extends({}, activityReference, { doesMatch: doesMatch }) : undefined;
	    }).filter(Boolean).sort(function (a, b) {
	        return a.doesMatch ? -1 : b.doesMatch ? 1 : 0;
	    });
	}
	
	function _displayActivitiesOfContract(activities) {
	    return _react2.default.createElement(
	        'small',
	        null,
	        ' ',
	        activities.map(function (_ref2, index) {
	            var doesMatch = _ref2.doesMatch,
	                label = _ref2.label;
	            return _react2.default.createElement(
	                'span',
	                { key: index },
	                index > 0 ? ' - ' : '',
	                doesMatch ? _react2.default.createElement(
	                    'b',
	                    null,
	                    label
	                ) : label
	            );
	        })
	    );
	}
	
	var ContactSuggestSelector = function (_Component) {
	    _inherits(ContactSuggestSelector, _Component);
	
	    function ContactSuggestSelector(props) {
	        _classCallCheck(this, ContactSuggestSelector);
	
	        var _this = _possibleConstructorReturn(this, (ContactSuggestSelector.__proto__ || Object.getPrototypeOf(ContactSuggestSelector)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ContactSuggestSelector, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company,
	                patrimony = _props.patrimony,
	                incidentType = _props.incidentType;
	
	            dispatch((0, _actions2.queryContactSuggest)({ patrimonyUid: patrimony.uid, incidentTypeUid: incidentType }));
	            dispatch((0, _actions.queryActivityRef)());
	            dispatch((0, _actions.queryOpeningTicketPurposeRef)(company.uid));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.patrimony != nextProps.patrimony || this.props.incidentType != nextProps.incidentType) {
	                var dispatch = nextProps.dispatch,
	                    patrimony = nextProps.patrimony,
	                    incidentType = nextProps.incidentType;
	
	
	                dispatch((0, _actions2.queryContactSuggest)({ patrimonyUid: patrimony.uid, incidentTypeUid: incidentType }));
	            }
	
	            if (this.props.company != nextProps.company) {
	                var _dispatch = nextProps.dispatch,
	                    company = nextProps.company;
	
	
	                _dispatch((0, _actions.queryOpeningTicketPurposeRef)(company.uid));
	            }
	        }
	    }, {
	        key: '_openPanel',
	        value: function _openPanel(key) {
	            var activeKey = this.state.activeKey;
	
	
	            var nextActiveKey = activeKey != key && key || null;
	            this.setState({ activeKey: nextActiveKey });
	        }
	    }, {
	        key: '_openContract',
	        value: function _openContract(key) {
	            var activeKeyContract = this.state.activeKeyContract;
	
	
	            var nextActiveKey = activeKeyContract !== key && key || null;
	            this.setState({ activeKeyContract: nextActiveKey });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, activeContact) {
	            event.preventDefault();
	            event.stopPropagation();
	
	            var referenceInterventionPeriod = activeContact.interventionPeriods.find(function (ip) {
	                return ip.reference;
	            });
	            var activeKey = referenceInterventionPeriod && referenceInterventionPeriod.uid;
	            var activeKeyContract = activeContact.contracts && activeContact.contracts.length > 0 && activeContact.contracts[0].uid;
	            this.setState({ modalOpened: true, activeContact: activeContact, activeKey: activeKey, activeKeyContract: activeKeyContract });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.setState({ modalOpened: false, activeContact: null, activeKey: null, activeKeyContract: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                activityReference = _props2.activityReference,
	                openingTicketPurposeReference = _props2.openingTicketPurposeReference,
	                suggest = _props2.suggest,
	                patrimony = _props2.patrimony,
	                incidentType = _props2.incidentType,
	                others = _objectWithoutProperties(_props2, ['activityReference', 'openingTicketPurposeReference', 'suggest', 'patrimony', 'incidentType']);
	
	            var _state = this.state,
	                modalOpened = _state.modalOpened,
	                activeContact = _state.activeContact;
	
	
	            var tooltip = function tooltip(text, status) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: status && 'tooltip-' + status },
	                    text
	                );
	            };
	
	            var displayContact = function displayContact(contact) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _ContactSuggestSelector2.default.contact },
	                    _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(linkedWithInfo(contact), linkedWithStatus(contact)) },
	                        _react2.default.createElement(_Icon2.default, { icon: linkedWithIconName(contact), size: 'xs' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContactSuggestSelector2.default.container },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            contact.name.firstName,
	                            ' ',
	                            contact.name.lastName,
	                            ' ',
	                            contact.name.value
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _displayActivitiesOfContract(enrichActivities(contact.activities, openingTicketPurposeReference, activityReference, incidentType))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._openModal(e, contact);
	                            } },
	                        _i18n2.default.showMore
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Selector2.default, _extends({
	                    source: suggest,
	                    identify: function identify(c) {
	                        return c.uid;
	                    },
	                    display: displayContact
	                }, others)),
	                activeContact && _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    {
	                        show: modalOpened,
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            activeContact.name.firstName,
	                            ' ',
	                            activeContact.name.lastName,
	                            ' ',
	                            activeContact.name.value
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ContactSuggestSelector2.default.data },
	                            activeContact.phones.length > 0 && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.phone,
	                                    ' :'
	                                ),
	                                activeContact.phones.map(function (phone, index) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { key: index },
	                                        index > 0 && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' |'
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            (0, _phonez2.default)(phone).format()
	                                        )
	                                    );
	                                })
	                            ),
	                            activeContact.emails.length > 0 && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.email,
	                                    ' :'
	                                ),
	                                activeContact.emails.map(function (email, index) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { key: index },
	                                        index > 0 && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' |'
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            email
	                                        )
	                                    );
	                                })
	                            ),
	                            activeContact.fax.length > 0 && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.fax,
	                                    ' :'
	                                ),
	                                activeContact.fax.map(function (fax, index) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { key: index },
	                                        index > 0 && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' |'
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            (0, _phonez2.default)(fax).format()
	                                        )
	                                    );
	                                })
	                            ),
	                            activeContact.contracts.length > 0 && _react2.default.createElement(
	                                _reactBootstrap.Well,
	                                { bsSize: "small" },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    'Les contrats'
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.PanelGroup,
	                                    { accordion: true, onSelect: function onSelect(k) {
	                                            return _this2._openContract(k);
	                                        } },
	                                    activeContact.contracts.map(function (c) {
	                                        return _react2.default.createElement(
	                                            _reactBootstrap.Panel,
	                                            { header: _react2.default.createElement(
	                                                    'h5',
	                                                    null,
	                                                    c.label
	                                                ), key: c.uid, eventKey: c.uid },
	                                            _react2.default.createElement(
	                                                'ul',
	                                                { className: _ContactSuggestSelector2.default.data },
	                                                c.contractNumber && _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        '> N\xB0 de contrat :'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        c.contractNumber
	                                                    )
	                                                ),
	                                                c.contractor && _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        '> Contractant :'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        c.contractor.patrimony && '(Patrimoine) ' + c.contractor.patrimony.name || c.contractor.contractorType
	                                                    )
	                                                ),
	                                                c.validityPeriod && _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        '> P\xE9riode de validit\xE9 :'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        (0, _moment2.default)(c.validityPeriod.startDate).format(_i18n2.default.dateFormat.fromLonger),
	                                                        ' ',
	                                                        (0, _moment2.default)(c.validityPeriod.endDate).format(_i18n2.default.dateFormat.toLonger)
	                                                    )
	                                                ),
	                                                c.phoneNumbers && _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        '> Contacts :'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        c.phoneNumbers.join(', ')
	                                                    )
	                                                ),
	                                                c.instructions && _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        '> Instructions :'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        c.instructions
	                                                    )
	                                                ),
	                                                c.commentaries && _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        '> Commentaire :'
	                                                    ),
	                                                    ' ',
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        c.commentaries
	                                                    )
	                                                ),
	                                                c.activities.length > 0 && _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        '> Activities : '
	                                                    ),
	                                                    _displayActivitiesOfContract(enrichActivities(c.activities, openingTicketPurposeReference, activityReference, incidentType))
	                                                ),
	                                                Object.keys(c.additionalInfos).length > 0 && _react2.default.createElement(
	                                                    'li',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        '> Informations compl\xE9mentaire :'
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'ul',
	                                                        null,
	                                                        Object.entries(c.additionalInfos).map(function (_ref3) {
	                                                            var _ref4 = _slicedToArray(_ref3, 2),
	                                                                key = _ref4[0],
	                                                                value = _ref4[1];
	
	                                                            return _react2.default.createElement(
	                                                                'li',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'label',
	                                                                    null,
	                                                                    ' ',
	                                                                    key,
	                                                                    ' : '
	                                                                ),
	                                                                ' ',
	                                                                value
	                                                            );
	                                                        })
	                                                    )
	                                                )
	                                            ),
	                                            c.commitments && c.commitments.length > 0 && c.commitments.map(function (interventionPeriod) {
	                                                return _react2.default.createElement(
	                                                    _reactBootstrap.Accordion,
	                                                    null,
	                                                    _react2.default.createElement(_UpdateInterventionPeriodPanel2.default, {
	                                                        key: interventionPeriod.uid,
	                                                        eventKey: interventionPeriod.uid,
	                                                        interventionPeriod: interventionPeriod,
	                                                        incidentType: incidentType,
	                                                        openingTicketPurposeReference: openingTicketPurposeReference,
	                                                        patrimony: patrimony })
	                                                );
	                                            })
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        activeContact.interventionPeriods.length > 0 && _react2.default.createElement(
	                            _reactBootstrap.Well,
	                            { bsSize: "small" },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                ' P\xE9riodes d\'interventions'
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Accordion
	                                // activeKey={activeKey} utiliser pour expand le panel de la période de référence
	                                ,
	                                { onSelect: function onSelect(k) {
	                                        return _this2._openPanel(k);
	                                    } },
	                                activeContact.interventionPeriods.map(function (interventionPeriod) {
	                                    return _react2.default.createElement(_UpdateInterventionPeriodPanel2.default, {
	                                        key: interventionPeriod.uid,
	                                        eventKey: interventionPeriod.uid,
	                                        interventionPeriod: interventionPeriod,
	                                        incidentType: incidentType,
	                                        openingTicketPurposeReference: openingTicketPurposeReference,
	                                        patrimony: patrimony });
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return _this2._closeModal();
	                                    } },
	                                _i18n2.default.close
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactSuggestSelector;
	}(_react.Component);
	
	ContactSuggestSelector.propTypes = {
	    company: _react.PropTypes.object.isRequired,
	    patrimony: _react.PropTypes.object.isRequired,
	    incidentType: _react.PropTypes.string.isRequired
	};
	
	
	ContactSuggestSelector = (0, _reactRedux.connect)(function (state) {
	    return {
	        activityReference: state.reference.activityRef,
	        openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
	        suggest: state.provider.contact.suggest
	    };
	})(ContactSuggestSelector);
	
	exports.default = ContactSuggestSelector;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _links = __webpack_require__(33);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CopyInterventionPeriodsModal = __webpack_require__(2272);
	
	var _CopyInterventionPeriodsModal2 = _interopRequireDefault(_CopyInterventionPeriodsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isContact(committed) {
	    return !!committed.commitments;
	}
	
	function commitmentAggregator(reference) {
	    return function (result, commitment) {
	        if (commitment.interventionPeriods.length == 0) {
	            return result;
	        }
	
	        var resultActivity = reference.find(function (a) {
	            return a.uid == commitment.activityUid;
	        });
	        if (resultActivity) {
	            var aggrega = {
	                activity: resultActivity,
	                interventionPeriods: commitment.interventionPeriods
	            };
	
	            result.push(aggrega);
	        } else {
	            console && console.warn('activity "' + commitment.activityUid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	function copyInterventionPeriodCmd(interventionPeriod, committed) {
	    return {
	        period: interventionPeriod.period,
	        commandType: committed._links.find((0, _links.linkFinder)(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])).rel
	    };
	}
	
	function copyServiceChargeCmd(interventionPeriod) {
	    return {
	        charge: interventionPeriod.serviceCharge
	    };
	}
	
	function copyInterventionZoneCmd(interventionPeriod) {
	    return {
	        zone: interventionPeriod.interventionZone
	    };
	}
	
	function copyCallOutChargesCmd(interventionPeriod) {
	    return {
	        callOutCharges: interventionPeriod.callOutCharges
	    };
	}
	
	function copySubscriptionsCmd(interventionPeriod) {
	    return {
	        subscriptions: interventionPeriod.subscriptions
	    };
	}
	
	var CopyInterventionPeriodsModal = function (_Component) {
	    _inherits(CopyInterventionPeriodsModal, _Component);
	
	    function CopyInterventionPeriodsModal(props) {
	        _classCallCheck(this, CopyInterventionPeriodsModal);
	
	        var _this = _possibleConstructorReturn(this, (CopyInterventionPeriodsModal.__proto__ || Object.getPrototypeOf(CopyInterventionPeriodsModal)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CopyInterventionPeriodsModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                activityReference = _props.activityReference,
	                commitments = _props.commitments;
	
	
	            var commitmentAggregation = commitments.reduce(commitmentAggregator(activityReference), []);
	            this.setState({ commitmentAggregation: commitmentAggregation });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.activityReference != this.props.activityReference || nextProps.commitments != this.props.commitments) {
	                var activityReference = nextProps.activityReference,
	                    commitments = nextProps.commitments;
	
	
	                var commitmentAggregation = commitments.reduce(commitmentAggregator(activityReference), []);
	                this.setState({ commitmentAggregation: commitmentAggregation });
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                committed = _props2.committed,
	                activity = _props2.activity,
	                onHide = _props2.onHide;
	            var activeAggrega = this.state.activeAggrega;
	
	
	            function sendCopyInterventionPeriodCmds(interventionPeriod) {
	                var interventionPeriodCopyUid;
	
	                return dispatch((0, _actions.sendDefineUpdateInterventionPeriodForActivityCmd)(committed._links, activity.uid, copyInterventionPeriodCmd(interventionPeriod, committed))).then(function (action) {
	                    interventionPeriodCopyUid = action.events.find(function (e) {
	                        return e.eventType == 'InterventionPeriodDefinedForActivity' || e.eventType == 'InterventionPeriodDefined';
	                    }).period.uid;
	                    return interventionPeriod.interventionZone && dispatch((0, _actions.sendDefineInterventionZoneForInterventionPeriodCmd)(committed._links, activity.uid, interventionPeriodCopyUid, copyInterventionZoneCmd(interventionPeriod)));
	                }).then(function () {
	                    return interventionPeriod.serviceCharge && dispatch((0, _actions.sendDefineServiceChargeForInterventionPeriodCmd)(activity.uid, interventionPeriodCopyUid, copyServiceChargeCmd(interventionPeriod)));
	                }).then(function () {
	                    return interventionPeriod.callOutCharges && interventionPeriod.callOutCharges.length > 0 && dispatch((0, _actions.sendDefineCallOutChargesForInterventionPeriodCmd)(activity.uid, interventionPeriodCopyUid, copyCallOutChargesCmd(interventionPeriod)));
	                }).then(function () {
	                    return interventionPeriod.subscriptions && interventionPeriod.subscriptions.length > 0 && dispatch((0, _actions.sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd)(activity.uid, interventionPeriodCopyUid, copySubscriptionsCmd(interventionPeriod)));
	                });
	            }
	
	            // copy selected activity
	            // we have to execute all cmds sequencialy to avoid backend issues
	            return activeAggrega.interventionPeriods.reduce(function (result, interventionPeriod) {
	                return result.then(function () {
	                    return sendCopyInterventionPeriodCmds(interventionPeriod);
	                });
	            }, Promise.resolve()).then(function () {
	                return isContact(committed) && dispatch((0, _actions.loadContact)()) || dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                activityReference = _props3.activityReference,
	                committed = _props3.committed,
	                commitments = _props3.commitments,
	                activity = _props3.activity,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'activityReference', 'committed', 'commitments', 'activity', 'onHide']);
	
	            var _state = this.state,
	                commitmentAggregation = _state.commitmentAggregation,
	                activeAggrega = _state.activeAggrega;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var activeAggregaField = function activeAggregaField() {
	                var value = activeAggrega && activeAggrega.activity.uid || '';
	
	                var onChange = function onChange(event) {
	                    var activeAggregaId = event.target.value || null;
	                    var activeAggrega = activeAggregaId && commitmentAggregation.find(function (a) {
	                        return a.activity.uid == activeAggregaId;
	                    });
	                    _this2.setState({ activeAggrega: activeAggrega });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.fillinAssistant
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _CopyInterventionPeriodsModal2.default.defaultContent },
	                        isContact(committed) && _react2.default.createElement(
	                            'p',
	                            null,
	                            _i18n2.default.copyProviderContactActivity
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Input,
	                                _extends({
	                                    type: 'select',
	                                    name: 'activity'
	                                }, activeAggregaField()),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    _i18n2.default.copyActivity,
	                                    ' ...'
	                                ),
	                                commitmentAggregation.map(function (aggrega, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        {
	                                            key: index,
	                                            value: aggrega.activity.uid },
	                                        aggrega.activity.label
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    className: (0, _classnames2.default)({ disabled: !activeAggrega }),
	                                    onClick: function onClick(e) {
	                                        return activeAggrega && _this2._sendCmd(e) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _i18n2.default.validate
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CopyInterventionPeriodsModal;
	}(_react.Component);
	
	CopyInterventionPeriodsModal.propTypes = {
	    committed: _react.PropTypes.object.isRequired,
	    commitments: _react.PropTypes.array.isRequired,
	    activity: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	CopyInterventionPeriodsModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        activityReference: state.reference.activityRef
	    };
	})(CopyInterventionPeriodsModal);
	
	exports.default = CopyInterventionPeriodsModal;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _MultiInput = __webpack_require__(277);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function contactInfosCmdUpdate(provider) {
	    return {
	        namez: provider.contactInfos && provider.contactInfos.name || { nameType: 'PoorName' },
	        phones: provider.contactInfos && provider.contactInfos.phones.map(function (p) {
	            return (0, _phonez2.default)(p).toE164();
	        }),
	        emails: provider.contactInfos && provider.contactInfos.emails,
	        fax: provider.contactInfos && provider.contactInfos.fax.map(function (p) {
	            return (0, _phonez2.default)(p).toE164();
	        })
	    };
	}
	
	var DefineContactInfosForProviderCompanyPopover = function (_Component) {
	    _inherits(DefineContactInfosForProviderCompanyPopover, _Component);
	
	    function DefineContactInfosForProviderCompanyPopover() {
	        _classCallCheck(this, DefineContactInfosForProviderCompanyPopover);
	
	        return _possibleConstructorReturn(this, (DefineContactInfosForProviderCompanyPopover.__proto__ || Object.getPrototypeOf(DefineContactInfosForProviderCompanyPopover)).apply(this, arguments));
	    }
	
	    _createClass(DefineContactInfosForProviderCompanyPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                provider = _props.provider;
	
	
	            var update = contactInfosCmdUpdate(provider);
	            dispatch((0, _actions.updateDefineContactInfosForProviderCompanyCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.provider != this.props.provider) {
	                var dispatch = nextProps.dispatch,
	                    provider = nextProps.provider;
	
	
	                var update = contactInfosCmdUpdate(provider);
	                dispatch((0, _actions.updateDefineContactInfosForProviderCompanyCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(action) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	            return dispatch((0, _actions.sendDefineContactInfosForProviderCompanyCmd)()).then(function () {
	                return dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	
	                window.opener && window.opener.postMessage({
	                    type: 'RefreshTicket'
	                });
	
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                onHide = _props3.onHide,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'onHide', 'form', 'cmd']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    bsClass: 'popover-lg popover',
	                    title: _i18n2.default.defineContactInfo
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'nameType',
	                            label: _i18n2.default.nameType
	                        }, form.namez.nameType()),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'CivilName' },
	                            _i18n2.default.nameTypeEnum.civilName
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'PoorName' },
	                            _i18n2.default.nameTypeEnum.poorName
	                        )
	                    ),
	                    form.namez.firstName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'firstName',
	                        label: requiredLabel(_i18n2.default.firstName)
	                    }, form.namez.firstName())),
	                    form.namez.lastName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'lastName',
	                        label: requiredLabel(_i18n2.default.lastName)
	                    }, form.namez.lastName())),
	                    form.namez.gender && _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'gender',
	                            label: _i18n2.default.gender
	                        }, form.namez.gender()),
	                        _react2.default.createElement('option', { value: '' }),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Male' },
	                            _i18n2.default.genderEnum.male
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Female' },
	                            _i18n2.default.genderEnum.female
	                        )
	                    ),
	                    form.namez.value && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'name',
	                        label: requiredLabel(_i18n2.default.name)
	                    }, form.namez.value())),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'phone',
	                        label: _i18n2.default.phone
	                    }, (0, _phonez.phonesField)(form.phones()))),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'fax',
	                        label: _i18n2.default.fax
	                    }, (0, _phonez.phonesField)(form.fax()))),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'email',
	                        label: _i18n2.default.email
	                    }, form.emails()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineContactInfosForProviderCompanyPopover;
	}(_react.Component);
	
	DefineContactInfosForProviderCompanyPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	DefineContactInfosForProviderCompanyPopover = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.DefineContactInfosForProviderCompanyCmd.selectSchema,
	    action: _actions.DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED
	})(DefineContactInfosForProviderCompanyPopover);
	
	DefineContactInfosForProviderCompanyPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        provider: state.provider.provider,
	        cmd: state.provider.defineContactInfosForProviderCompanyCmd
	    };
	})(DefineContactInfosForProviderCompanyPopover);
	
	exports.default = DefineContactInfosForProviderCompanyPopover;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _DefineUpdateInterventionPeriodForActivityForm = __webpack_require__(1101);
	
	var _DefineUpdateInterventionPeriodForActivityForm2 = _interopRequireDefault(_DefineUpdateInterventionPeriodForActivityForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefineInterventionPeriodPanel = function (_Component) {
	    _inherits(DefineInterventionPeriodPanel, _Component);
	
	    function DefineInterventionPeriodPanel() {
	        _classCallCheck(this, DefineInterventionPeriodPanel);
	
	        return _possibleConstructorReturn(this, (DefineInterventionPeriodPanel.__proto__ || Object.getPrototypeOf(DefineInterventionPeriodPanel)).apply(this, arguments));
	    }
	
	    _createClass(DefineInterventionPeriodPanel, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                committed = _props.committed,
	                activity = _props.activity,
	                interventionPeriods = _props.interventionPeriods,
	                bsStyle = _props.bsStyle,
	                onSelect = _props.onSelect,
	                others = _objectWithoutProperties(_props, ['committed', 'activity', 'interventionPeriods', 'bsStyle', 'onSelect']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Panel,
	                _extends({
	                    onSelect: onSelect
	                }, others),
	                _react2.default.createElement(_DefineUpdateInterventionPeriodForActivityForm2.default, {
	                    committed: committed,
	                    activity: activity,
	                    interventionPeriods: interventionPeriods,
	                    onSubmit: function onSubmit(e, r, i) {
	                        return onSelect(e, i);
	                    } })
	            );
	        }
	    }]);
	
	    return DefineInterventionPeriodPanel;
	}(_react.Component);
	
	DefineInterventionPeriodPanel.propTypes = {
	    committed: _react.PropTypes.object.isRequired,
	    activity: _react.PropTypes.object.isRequired,
	    interventionPeriods: _react.PropTypes.array.isRequired
	};
	exports.default = DefineInterventionPeriodPanel;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _distance = __webpack_require__(1092);
	
	var _distance2 = _interopRequireDefault(_distance);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DefineRemoveCallOutChargesFromInterventionPeriodForm = __webpack_require__(2273);
	
	var _DefineRemoveCallOutChargesFromInterventionPeriodForm2 = _interopRequireDefault(_DefineRemoveCallOutChargesFromInterventionPeriodForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function defineCmdUpdate(interventionPeriod) {
	    return {
	        callOutCharges: interventionPeriod.callOutCharges
	    };
	}
	
	var DefineRemoveCallOutChargesFromInterventionPeriodForm = function (_Component) {
	    _inherits(DefineRemoveCallOutChargesFromInterventionPeriodForm, _Component);
	
	    function DefineRemoveCallOutChargesFromInterventionPeriodForm() {
	        _classCallCheck(this, DefineRemoveCallOutChargesFromInterventionPeriodForm);
	
	        return _possibleConstructorReturn(this, (DefineRemoveCallOutChargesFromInterventionPeriodForm.__proto__ || Object.getPrototypeOf(DefineRemoveCallOutChargesFromInterventionPeriodForm)).apply(this, arguments));
	    }
	
	    _createClass(DefineRemoveCallOutChargesFromInterventionPeriodForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                interventionPeriod = _props.interventionPeriod;
	
	
	            var update = defineCmdUpdate(interventionPeriod);
	            dispatch((0, _actions.updateDefineCallOutChargesForInterventionPeriodCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.interventionPeriod != this.props.interventionPeriod) {
	                var dispatch = nextProps.dispatch,
	                    interventionPeriod = nextProps.interventionPeriod;
	
	
	                var update = defineCmdUpdate(interventionPeriod);
	                dispatch((0, _actions.updateDefineCallOutChargesForInterventionPeriodCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendDefineCmd',
	        value: function _sendDefineCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                activity = _props2.activity,
	                interventionPeriod = _props2.interventionPeriod,
	                onSubmit = _props2.onSubmit;
	
	
	            return dispatch((0, _actions.sendDefineCallOutChargesForInterventionPeriodCmd)(activity.uid, interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd() {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                activity = _props3.activity,
	                interventionPeriod = _props3.interventionPeriod,
	                onSubmit = _props3.onSubmit;
	
	
	            return dispatch((0, _actions.sendRemoveCallOutChargesFromInterventionPeriodCmd)(activity.uid, interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                cmd = _props4.cmd,
	                activity = _props4.activity,
	                interventionPeriod = _props4.interventionPeriod,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'cmd', 'activity', 'interventionPeriod']);
	
	            var chargeInputAddon = _react2.default.createElement(
	                'span',
	                null,
	                _i18n2.default.currencyEnum.euro
	            );
	
	            var distanceInputAddon = _react2.default.createElement(
	                'span',
	                null,
	                'km'
	            );
	
	            var distanceField = function distanceField(field) {
	                var value = field.value && field.value / 1000;
	
	                function onChange(value) {
	                    field.onChange(value && value * 1000);
	                }
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _DefineRemoveCallOutChargesFromInterventionPeriodForm2.default.callOutChargeGroup },
	                    cmd && cmd.callOutCharges && cmd.callOutCharges.slice(1).reverse().map(function (callOutCharge, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _DefineRemoveCallOutChargesFromInterventionPeriodForm2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return form.callOutCharges.remove(e, callOutCharge);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    (0, _extract.replace)(_i18n2.default.distanceFromTo, { from: (0, _distance2.default)(callOutCharge.range.start).format('km'), to: (0, _distance2.default)(callOutCharge.range.end).format('km') })
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' : ',
	                                    callOutCharge.charge.value,
	                                    ' ',
	                                    _i18n2.default.currencyEnum.euro
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'startRange',
	                                placeholder: _i18n2.default.startRange,
	                                addonAfter: distanceInputAddon
	                            }, (0, _form.integerField)(distanceField(form.callOutCharges.range.start()))))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 6 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'endRange',
	                                placeholder: _i18n2.default.endRange,
	                                addonAfter: distanceInputAddon
	                            }, (0, _form.integerField)(distanceField(form.callOutCharges.range.end()))))
	                        )
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'text',
	                        name: 'charge',
	                        placeholder: _i18n2.default.charge,
	                        addonAfter: chargeInputAddon
	                    }, (0, _form.integerField)(form.callOutCharges.charge.value())))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    form.callOutCharges.isValid() && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick() {
	                                return form.callOutCharges.add();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.add
	                        )
	                    ),
	                    cmd && cmd.callOutCharges && cmd.callOutCharges.length > 1 && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick() {
	                                return form.callOutCharges.remove();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.remove
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendDefineCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    ),
	                    interventionPeriod.callOutCharges.length > 0 && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'danger',
	                            bsSize: 'large',
	                            onClick: function onClick() {
	                                return _this2._sendRemoveCmd();
	                            } },
	                        _i18n2.default.remove
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineRemoveCallOutChargesFromInterventionPeriodForm;
	}(_react.Component);
	
	DefineRemoveCallOutChargesFromInterventionPeriodForm.propTypes = {
	    activity: _react.PropTypes.object.isRequired,
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	DefineRemoveCallOutChargesFromInterventionPeriodForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.DefineCallOutChargesForInterventionPeriodCmd.schema,
	    action: _actions.DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED
	})(DefineRemoveCallOutChargesFromInterventionPeriodForm);
	
	DefineRemoveCallOutChargesFromInterventionPeriodForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.defineCallOutChargesForInterventionPeriodCmd
	    };
	})(DefineRemoveCallOutChargesFromInterventionPeriodForm);
	
	exports.default = DefineRemoveCallOutChargesFromInterventionPeriodForm;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _momentz = __webpack_require__(186);
	
	var _CheckboxToggle = __webpack_require__(508);
	
	var _CheckboxToggle2 = _interopRequireDefault(_CheckboxToggle);
	
	var _MeasureInput = __webpack_require__(953);
	
	var _MeasureInput2 = _interopRequireDefault(_MeasureInput);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DefineRemoveInterventionTimelimitFromInterventionPeriodForm = __webpack_require__(2274);
	
	var _DefineRemoveInterventionTimelimitFromInterventionPeriodForm2 = _interopRequireDefault(_DefineRemoveInterventionTimelimitFromInterventionPeriodForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openingTicketPurposeLabelAggregator(openingTicketPurposes) {
	    return function (result, openingTicketPurposeUid) {
	        var openingTicketPurpose = openingTicketPurposes.find(function (otp) {
	            return otp.uid == openingTicketPurposeUid;
	        });
	
	        if (openingTicketPurpose) {
	            result.push(openingTicketPurpose.label);
	        }
	        return result;
	    };
	}
	
	function defineCmdUpdate(interventionPeriod) {
	    return {
	        timelimits: interventionPeriod.interventionTimelimits
	    };
	}
	
	var DefineRemoveInterventionTimelimitFromInterventionPeriodForm = function (_Component) {
	    _inherits(DefineRemoveInterventionTimelimitFromInterventionPeriodForm, _Component);
	
	    function DefineRemoveInterventionTimelimitFromInterventionPeriodForm() {
	        _classCallCheck(this, DefineRemoveInterventionTimelimitFromInterventionPeriodForm);
	
	        return _possibleConstructorReturn(this, (DefineRemoveInterventionTimelimitFromInterventionPeriodForm.__proto__ || Object.getPrototypeOf(DefineRemoveInterventionTimelimitFromInterventionPeriodForm)).apply(this, arguments));
	    }
	
	    _createClass(DefineRemoveInterventionTimelimitFromInterventionPeriodForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                interventionPeriod = _props.interventionPeriod;
	
	
	            var update = defineCmdUpdate(interventionPeriod);
	            dispatch((0, _actions.updateDefineInterventionTimelimitForInterventionPeriodCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.interventionPeriod != this.props.interventionPeriod) {
	                var dispatch = nextProps.dispatch,
	                    interventionPeriod = nextProps.interventionPeriod;
	
	
	                var update = defineCmdUpdate(interventionPeriod);
	                dispatch((0, _actions.updateDefineInterventionTimelimitForInterventionPeriodCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendDefineCmd',
	        value: function _sendDefineCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                interventionPeriod = _props2.interventionPeriod,
	                onSubmit = _props2.onSubmit;
	
	
	            return dispatch((0, _actions.sendDefineInterventionTimelimitForInterventionPeriodCmd)(interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd() {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                interventionPeriod = _props3.interventionPeriod,
	                onSubmit = _props3.onSubmit;
	
	
	            return dispatch((0, _actions.sendRemoveInterventionTimelimitFromInterventionPeriodCmd)(interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                cmd = _props4.cmd,
	                interventionPeriod = _props4.interventionPeriod,
	                openingTicketPurposes = _props4.openingTicketPurposes,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'cmd', 'interventionPeriod', 'openingTicketPurposes']);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _DefineRemoveInterventionTimelimitFromInterventionPeriodForm2.default.interventionTimelimitGroup },
	                    cmd && cmd.timelimits && cmd.timelimits.slice(1).reverse().map(function (timelimit, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _DefineRemoveInterventionTimelimitFromInterventionPeriodForm2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return form.timelimits.remove(e, timelimit);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    timelimit.openingTicketPurposes.reduce(openingTicketPurposeLabelAggregator(openingTicketPurposes), []).join(', '),
	                                    ' :'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    (0, _momentz.humanize)(_moment2.default.duration(timelimit.timelimit.value))
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_MeasureInput2.default, _extends({
	                        name: 'timelimit',
	                        units: _MeasureInput.timeUnits,
	                        placeholder: _i18n2.default.interventionTimelimit + ' *'
	                    }, form.timelimits.timelimit.value())),
	                    _react2.default.createElement(
	                        _CheckboxToggle2.default,
	                        form.timelimits.openingTicketPurposes(),
	                        openingTicketPurposes.map(function (openingTicketPurpose, index) {
	                            return _react2.default.createElement(_reactBootstrap.Input, {
	                                key: index,
	                                type: 'checkbox',
	                                label: openingTicketPurpose.label,
	                                value: openingTicketPurpose.uid });
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    form.timelimits.isValid() && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick() {
	                                return form.timelimits.add();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.add
	                        )
	                    ),
	                    cmd && cmd.timelimits && cmd.timelimits.length > 1 && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick() {
	                                return form.timelimits.remove();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.remove
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendDefineCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    ),
	                    interventionPeriod.interventionTimelimits.length > 0 && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'danger',
	                            bsSize: 'large',
	                            onClick: function onClick() {
	                                return _this2._sendRemoveCmd();
	                            } },
	                        _i18n2.default.remove
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineRemoveInterventionTimelimitFromInterventionPeriodForm;
	}(_react.Component);
	
	DefineRemoveInterventionTimelimitFromInterventionPeriodForm.propTypes = {
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    openingTicketPurposes: _react.PropTypes.array.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	DefineRemoveInterventionTimelimitFromInterventionPeriodForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.DefineInterventionTimelimitForInterventionPeriodCmd.schema,
	    action: _actions.DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED
	})(DefineRemoveInterventionTimelimitFromInterventionPeriodForm);
	
	DefineRemoveInterventionTimelimitFromInterventionPeriodForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.defineInterventionTimelimitForInterventionPeriodCmd
	    };
	})(DefineRemoveInterventionTimelimitFromInterventionPeriodForm);
	
	exports.default = DefineRemoveInterventionTimelimitFromInterventionPeriodForm;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _places = __webpack_require__(261);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StaticMap = __webpack_require__(510);
	
	var _StaticMap2 = _interopRequireDefault(_StaticMap);
	
	var _TypeaheadInput = __webpack_require__(265);
	
	var _TypeaheadInput2 = _interopRequireDefault(_TypeaheadInput);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isContact(committed) {
	    return !!committed.commitments;
	}
	
	function defineCmdUpdate(interventionPeriod) {
	    return {
	        zone: interventionPeriod.interventionZone
	    };
	}
	
	var DefineRemoveInterventionZoneFromInterventionPeriodForm = function (_Component) {
	    _inherits(DefineRemoveInterventionZoneFromInterventionPeriodForm, _Component);
	
	    function DefineRemoveInterventionZoneFromInterventionPeriodForm() {
	        _classCallCheck(this, DefineRemoveInterventionZoneFromInterventionPeriodForm);
	
	        return _possibleConstructorReturn(this, (DefineRemoveInterventionZoneFromInterventionPeriodForm.__proto__ || Object.getPrototypeOf(DefineRemoveInterventionZoneFromInterventionPeriodForm)).apply(this, arguments));
	    }
	
	    _createClass(DefineRemoveInterventionZoneFromInterventionPeriodForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                interventionPeriod = _props.interventionPeriod;
	
	
	            var update = defineCmdUpdate(interventionPeriod);
	            dispatch((0, _actions.updateDefineInterventionZoneForInterventionPeriodCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.interventionPeriod != this.props.interventionPeriod) {
	                var dispatch = nextProps.dispatch,
	                    interventionPeriod = nextProps.interventionPeriod;
	
	
	                var update = defineCmdUpdate(interventionPeriod);
	                dispatch((0, _actions.updateDefineInterventionZoneForInterventionPeriodCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendDefineCmd',
	        value: function _sendDefineCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                committed = _props2.committed,
	                activity = _props2.activity,
	                interventionPeriod = _props2.interventionPeriod,
	                onSubmit = _props2.onSubmit;
	
	
	            return dispatch((0, _actions.sendDefineInterventionZoneForInterventionPeriodCmd)(committed._links, activity.uid, interventionPeriod.uid)).then(function () {
	                return isContact(committed) && dispatch((0, _actions.loadContact)()) || dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd() {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                committed = _props3.committed,
	                activity = _props3.activity,
	                interventionPeriod = _props3.interventionPeriod,
	                onSubmit = _props3.onSubmit;
	
	
	            return dispatch((0, _actions.sendRemoveInterventionZoneFromInterventionPeriodCmd)(committed._links, activity.uid, interventionPeriod.uid)).then(function () {
	                return isContact(committed) && dispatch((0, _actions.loadContact)()) || dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                cmd = _props4.cmd,
	                committed = _props4.committed,
	                activity = _props4.activity,
	                interventionPeriod = _props4.interventionPeriod,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'cmd', 'committed', 'activity', 'interventionPeriod']);
	
	            var distanceInputAddon = _react2.default.createElement(
	                'span',
	                null,
	                'km'
	            );
	
	            var zoneField = function zoneField(field) {
	                if (field.value && field.value.address && field.value.range && field.value.range.value) {
	                    var path = (0, _StaticMap.circlePath)(field.value.address.geoLocation, field.value.range.value);
	                    var _value = [];
	                    return { path: path, value: _value };
	                }
	
	                var value = field.value && field.value.address && [field.value.address] || [];
	                var identify = function identify(a) {
	                    return a.geoLocation;
	                };
	                return { value: value, identify: identify };
	            };
	
	            var distanceField = function distanceField(field) {
	                var value = field.value && field.value / 1000;
	
	                function onChange(value) {
	                    field.onChange(value && value * 1000);
	                }
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            var addressTypeaheadButton = function addressTypeaheadButton() {
	                if (cmd && cmd.zone && cmd.zone.address) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        (0, _form.buttonField)(form.zone.address(), null),
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    null,
	                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_StaticMap2.default, _extends({
	                    apiKey: _config2.default.google.apiKey,
	                    ratio: 16 / 9
	                }, zoneField(form.zone()))),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_TypeaheadInput2.default, _extends({
	                                ref: 'typeahead',
	                                source: _places.autocompleteMatcher,
	                                display: _places.displayPrediction,
	                                highlight: _places.highlightPrediction,
	                                placeholder: _i18n2.default.addAddress,
	                                buttonAfter: addressTypeaheadButton()
	                            }, (0, _places.addressField)(form.zone.address())))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'number',
	                                placeholder: _i18n2.default.addressNumber
	                            }, form.zone.address.number()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'street',
	                                placeholder: _i18n2.default.addressStreet
	                            }, form.zone.address.street()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 4, sm: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'zipCode',
	                                placeholder: _i18n2.default.addressZipCode
	                            }, form.zone.address.zipCode()))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 8, sm: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({ disabled: true,
	                                type: 'text',
	                                name: 'city',
	                                placeholder: _i18n2.default.addressCity
	                            }, form.zone.address.city()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 12 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'distance',
	                                placeholder: _i18n2.default.distance + ' *',
	                                addonAfter: distanceInputAddon
	                            }, (0, _form.integerField)(distanceField(form.zone.range.value()))))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendDefineCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    ),
	                    interventionPeriod.interventionZone && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'danger',
	                            bsSize: 'large',
	                            onClick: function onClick() {
	                                return _this2._sendRemoveCmd();
	                            } },
	                        _i18n2.default.remove
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineRemoveInterventionZoneFromInterventionPeriodForm;
	}(_react.Component);
	
	DefineRemoveInterventionZoneFromInterventionPeriodForm.propTypes = {
	    committed: _react.PropTypes.object.isRequired,
	    activity: _react.PropTypes.object.isRequired,
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	DefineRemoveInterventionZoneFromInterventionPeriodForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.DefineInterventionZoneForInterventionPeriodCmd.schema,
	    action: _actions.DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED
	})(DefineRemoveInterventionZoneFromInterventionPeriodForm);
	
	DefineRemoveInterventionZoneFromInterventionPeriodForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.defineInterventionZoneForInterventionPeriodCmd
	    };
	})(DefineRemoveInterventionZoneFromInterventionPeriodForm);
	
	exports.default = DefineRemoveInterventionZoneFromInterventionPeriodForm;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _momentz = __webpack_require__(186);
	
	var _CheckboxToggle = __webpack_require__(508);
	
	var _CheckboxToggle2 = _interopRequireDefault(_CheckboxToggle);
	
	var _MeasureInput = __webpack_require__(953);
	
	var _MeasureInput2 = _interopRequireDefault(_MeasureInput);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DefineRemoveRepairTimelimitFromInterventionPeriodForm = __webpack_require__(2275);
	
	var _DefineRemoveRepairTimelimitFromInterventionPeriodForm2 = _interopRequireDefault(_DefineRemoveRepairTimelimitFromInterventionPeriodForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openingTicketPurposeLabelAggregator(openingTicketPurposes) {
	    return function (result, openingTicketPurposeUid) {
	        var openingTicketPurpose = openingTicketPurposes.find(function (otp) {
	            return otp.uid == openingTicketPurposeUid;
	        });
	
	        if (openingTicketPurpose) {
	            result.push(openingTicketPurpose.label);
	        }
	        return result;
	    };
	}
	
	function defineCmdUpdate(interventionPeriod) {
	    return {
	        timelimits: interventionPeriod.repairTimelimits
	    };
	}
	
	var DefineRemoveRepairTimelimitFromInterventionPeriodForm = function (_Component) {
	    _inherits(DefineRemoveRepairTimelimitFromInterventionPeriodForm, _Component);
	
	    function DefineRemoveRepairTimelimitFromInterventionPeriodForm() {
	        _classCallCheck(this, DefineRemoveRepairTimelimitFromInterventionPeriodForm);
	
	        return _possibleConstructorReturn(this, (DefineRemoveRepairTimelimitFromInterventionPeriodForm.__proto__ || Object.getPrototypeOf(DefineRemoveRepairTimelimitFromInterventionPeriodForm)).apply(this, arguments));
	    }
	
	    _createClass(DefineRemoveRepairTimelimitFromInterventionPeriodForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                interventionPeriod = _props.interventionPeriod;
	
	
	            var update = defineCmdUpdate(interventionPeriod);
	            dispatch((0, _actions.updateDefineRepairTimelimitForInterventionPeriodCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.interventionPeriod != this.props.interventionPeriod) {
	                var dispatch = nextProps.dispatch,
	                    interventionPeriod = nextProps.interventionPeriod;
	
	
	                var update = defineCmdUpdate(interventionPeriod);
	                dispatch((0, _actions.updateDefineRepairTimelimitForInterventionPeriodCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendDefineCmd',
	        value: function _sendDefineCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                interventionPeriod = _props2.interventionPeriod,
	                onSubmit = _props2.onSubmit;
	
	
	            return dispatch((0, _actions.sendDefineRepairTimelimitForInterventionPeriodCmd)(interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd() {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                interventionPeriod = _props3.interventionPeriod,
	                onSubmit = _props3.onSubmit;
	
	
	            return dispatch((0, _actions.sendRemoveRepairTimelimitFromInterventionPeriodCmd)(interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                cmd = _props4.cmd,
	                interventionPeriod = _props4.interventionPeriod,
	                openingTicketPurposes = _props4.openingTicketPurposes,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'cmd', 'interventionPeriod', 'openingTicketPurposes']);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _DefineRemoveRepairTimelimitFromInterventionPeriodForm2.default.repairTimelimitGroup },
	                    cmd && cmd.timelimits && cmd.timelimits.slice(1).reverse().map(function (timelimit, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _DefineRemoveRepairTimelimitFromInterventionPeriodForm2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return form.timelimits.remove(e, timelimit);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    timelimit.openingTicketPurposes.reduce(openingTicketPurposeLabelAggregator(openingTicketPurposes), []).join(', '),
	                                    ' :'
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    (0, _momentz.humanize)(_moment2.default.duration(timelimit.timelimit.value))
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_MeasureInput2.default, _extends({
	                        name: 'timelimit',
	                        units: _MeasureInput.timeUnits,
	                        placeholder: _i18n2.default.repairTimelimit + ' *'
	                    }, form.timelimits.timelimit.value())),
	                    _react2.default.createElement(
	                        _CheckboxToggle2.default,
	                        form.timelimits.openingTicketPurposes(),
	                        openingTicketPurposes.map(function (openingTicketPurpose, index) {
	                            return _react2.default.createElement(_reactBootstrap.Input, {
	                                key: index,
	                                type: 'checkbox',
	                                label: openingTicketPurpose.label,
	                                value: openingTicketPurpose.uid });
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    form.timelimits.isValid() && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick() {
	                                return form.timelimits.add();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.add
	                        )
	                    ),
	                    cmd && cmd.timelimits && cmd.timelimits.length > 1 && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick() {
	                                return form.timelimits.remove();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.remove
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendDefineCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    ),
	                    interventionPeriod.repairTimelimits.length > 0 && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'danger',
	                            bsSize: 'large',
	                            onClick: function onClick() {
	                                return _this2._sendRemoveCmd();
	                            } },
	                        _i18n2.default.remove
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineRemoveRepairTimelimitFromInterventionPeriodForm;
	}(_react.Component);
	
	DefineRemoveRepairTimelimitFromInterventionPeriodForm.propTypes = {
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    openingTicketPurposes: _react.PropTypes.array.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	DefineRemoveRepairTimelimitFromInterventionPeriodForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.DefineRepairTimelimitForInterventionPeriodCmd.schema,
	    action: _actions.DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED
	})(DefineRemoveRepairTimelimitFromInterventionPeriodForm);
	
	DefineRemoveRepairTimelimitFromInterventionPeriodForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.defineRepairTimelimitForInterventionPeriodCmd
	    };
	})(DefineRemoveRepairTimelimitFromInterventionPeriodForm);
	
	exports.default = DefineRemoveRepairTimelimitFromInterventionPeriodForm;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function defineCmdUpdate(interventionPeriod) {
	    return {
	        charge: interventionPeriod.serviceCharge || { chargeType: _models.CHARGE_TYPES[0] }
	    };
	}
	
	var DefineRemoveServiceChargeFromInterventionPeriodForm = function (_Component) {
	    _inherits(DefineRemoveServiceChargeFromInterventionPeriodForm, _Component);
	
	    function DefineRemoveServiceChargeFromInterventionPeriodForm() {
	        _classCallCheck(this, DefineRemoveServiceChargeFromInterventionPeriodForm);
	
	        return _possibleConstructorReturn(this, (DefineRemoveServiceChargeFromInterventionPeriodForm.__proto__ || Object.getPrototypeOf(DefineRemoveServiceChargeFromInterventionPeriodForm)).apply(this, arguments));
	    }
	
	    _createClass(DefineRemoveServiceChargeFromInterventionPeriodForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                interventionPeriod = _props.interventionPeriod;
	
	
	            var update = defineCmdUpdate(interventionPeriod);
	            dispatch((0, _actions.updateDefineServiceChargeForInterventionPeriodCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.interventionPeriod != this.props.interventionPeriod) {
	                var dispatch = nextProps.dispatch,
	                    interventionPeriod = nextProps.interventionPeriod;
	
	
	                var update = defineCmdUpdate(interventionPeriod);
	                dispatch((0, _actions.updateDefineServiceChargeForInterventionPeriodCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendDefineCmd',
	        value: function _sendDefineCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                activity = _props2.activity,
	                interventionPeriod = _props2.interventionPeriod,
	                onSubmit = _props2.onSubmit;
	
	
	            return dispatch((0, _actions.sendDefineServiceChargeForInterventionPeriodCmd)(activity.uid, interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: '_sendRemoveCmd',
	        value: function _sendRemoveCmd() {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                activity = _props3.activity,
	                interventionPeriod = _props3.interventionPeriod,
	                onSubmit = _props3.onSubmit;
	
	
	            return dispatch((0, _actions.sendRemoveServiceChargeFromInterventionPeriodCmd)(activity.uid, interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                cmd = _props4.cmd,
	                activity = _props4.activity,
	                interventionPeriod = _props4.interventionPeriod,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'cmd', 'activity', 'interventionPeriod']);
	
	            var chargeTypeField = function chargeTypeField(field) {
	                var title = (0, _extract2.default)(_i18n2.default.chargeTypeEnum, field.value && field.value.chargeType);
	
	                function onSelect(event, chargeType) {
	                    field.onChange({ value: null, chargeType: chargeType });
	                }
	
	                return { title: title, onSelect: onSelect };
	            };
	
	            var valueField = function valueField(field, chargeType) {
	                var value;
	
	                switch (chargeType) {
	                    case 'FixChargeValue':
	                        value = field.value;
	                        break;
	                    case 'ChargePercentage':
	                        value = field.value && Math.round(field.value * 100);
	                        break;
	                }
	
	                function onChange(valuez) {
	                    var value;
	
	                    switch (chargeType) {
	                        case 'FixChargeValue':
	                            value = valuez;
	                            break;
	                        case 'ChargePercentage':
	                            value = valuez && valuez / 100;
	                            break;
	                    }
	                    field.onChange(value);
	                }
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            var chargeInputButton = _react2.default.createElement(
	                _reactBootstrap.DropdownButton,
	                chargeTypeField(form.charge()),
	                _models.CHARGE_TYPES.map(function (chargeType) {
	                    return _react2.default.createElement(
	                        _reactBootstrap.MenuItem,
	                        { eventKey: chargeType },
	                        (0, _extract2.default)(_i18n2.default.chargeTypeEnum, chargeType)
	                    );
	                })
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'text',
	                        name: 'charge',
	                        placeholder: _i18n2.default.charge,
	                        buttonAfter: chargeInputButton
	                    }, (0, _form.integerField)(valueField(form.charge.value(), cmd && cmd.charge && cmd.charge.chargeType))))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendDefineCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    ),
	                    interventionPeriod.serviceCharge && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'danger',
	                            bsSize: 'large',
	                            onClick: function onClick() {
	                                return _this2._sendRemoveCmd();
	                            } },
	                        _i18n2.default.remove
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineRemoveServiceChargeFromInterventionPeriodForm;
	}(_react.Component);
	
	DefineRemoveServiceChargeFromInterventionPeriodForm.propTypes = {
	    activity: _react.PropTypes.object.isRequired,
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	DefineRemoveServiceChargeFromInterventionPeriodForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.DefineServiceChargeForInterventionPeriodCmd.schema,
	    action: _actions.DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED
	})(DefineRemoveServiceChargeFromInterventionPeriodForm);
	
	DefineRemoveServiceChargeFromInterventionPeriodForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.defineServiceChargeForInterventionPeriodCmd
	    };
	})(DefineRemoveServiceChargeFromInterventionPeriodForm);
	
	exports.default = DefineRemoveServiceChargeFromInterventionPeriodForm;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _CheckboxToggle = __webpack_require__(508);
	
	var _CheckboxToggle2 = _interopRequireDefault(_CheckboxToggle);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openingTicketPurposeAggregator(openingTicketPurposeIds) {
	    return function (result, openingTicketPurpose) {
	        if (openingTicketPurposeIds.indexOf(openingTicketPurpose.uid) < 0) {
	            result.push(openingTicketPurpose.uid);
	        }
	        return result;
	    };
	}
	
	function defineCmdUpdate(interventionPeriod) {
	    return {
	        openingTicketPurposes: interventionPeriod.excludedOpeningTicketPurposes
	    };
	}
	
	var ExcludeOpeningTicketPurposesFromInterventionPeriodForm = function (_Component) {
	    _inherits(ExcludeOpeningTicketPurposesFromInterventionPeriodForm, _Component);
	
	    function ExcludeOpeningTicketPurposesFromInterventionPeriodForm() {
	        _classCallCheck(this, ExcludeOpeningTicketPurposesFromInterventionPeriodForm);
	
	        return _possibleConstructorReturn(this, (ExcludeOpeningTicketPurposesFromInterventionPeriodForm.__proto__ || Object.getPrototypeOf(ExcludeOpeningTicketPurposesFromInterventionPeriodForm)).apply(this, arguments));
	    }
	
	    _createClass(ExcludeOpeningTicketPurposesFromInterventionPeriodForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                interventionPeriod = _props.interventionPeriod;
	
	
	            var update = defineCmdUpdate(interventionPeriod);
	            dispatch((0, _actions.updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.interventionPeriod != this.props.interventionPeriod) {
	                var dispatch = nextProps.dispatch,
	                    interventionPeriod = nextProps.interventionPeriod;
	
	
	                var update = defineCmdUpdate(interventionPeriod);
	                dispatch((0, _actions.updateExcludeOpeningTicketPurposesFromInterventionPeriodCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendExcludeCmd',
	        value: function _sendExcludeCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                activity = _props2.activity,
	                interventionPeriod = _props2.interventionPeriod,
	                onSubmit = _props2.onSubmit;
	
	
	            return dispatch((0, _actions.sendExcludeOpeningTicketPurposesFromInterventionPeriodCmd)(interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                interventionPeriod = _props3.interventionPeriod,
	                openingTicketPurposes = _props3.openingTicketPurposes,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'interventionPeriod', 'openingTicketPurposes']);
	
	            var excludedField = function excludedField(field) {
	                var value = openingTicketPurposes.reduce(openingTicketPurposeAggregator(field.value || []), []);
	
	                function onChange(value) {
	                    var nextValue = openingTicketPurposes.reduce(openingTicketPurposeAggregator(value), []);
	                    field.onChange(nextValue);
	                }
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _CheckboxToggle2.default,
	                    excludedField(form.openingTicketPurposes()),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            openingTicketPurposes.slice(0, openingTicketPurposes.length / 2 + 1).map(function (openingTicketPurpose, index) {
	                                return _react2.default.createElement(_reactBootstrap.Input, {
	                                    key: index,
	                                    type: 'checkbox',
	                                    label: openingTicketPurpose.label,
	                                    value: openingTicketPurpose.uid });
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            openingTicketPurposes.slice(openingTicketPurposes.length / 2 + 1, openingTicketPurposes.length).map(function (openingTicketPurpose, index) {
	                                return _react2.default.createElement(_reactBootstrap.Input, {
	                                    key: index,
	                                    type: 'checkbox',
	                                    label: openingTicketPurpose.label,
	                                    value: openingTicketPurpose.uid });
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendExcludeCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ExcludeOpeningTicketPurposesFromInterventionPeriodForm;
	}(_react.Component);
	
	ExcludeOpeningTicketPurposesFromInterventionPeriodForm.propTypes = {
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    openingTicketPurposes: _react.PropTypes.array.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	ExcludeOpeningTicketPurposesFromInterventionPeriodForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ExcludeOpeningTicketPurposesFromInterventionPeriodCmd.schema,
	    action: _actions.EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED
	})(ExcludeOpeningTicketPurposesFromInterventionPeriodForm);
	
	ExcludeOpeningTicketPurposesFromInterventionPeriodForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.excludeOpeningTicketPurposesFromInterventionPeriodCmd
	    };
	})(ExcludeOpeningTicketPurposesFromInterventionPeriodForm);
	
	exports.default = ExcludeOpeningTicketPurposesFromInterventionPeriodForm;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chartist = __webpack_require__(271);
	
	var _chartist2 = _interopRequireDefault(_chartist);
	
	var _chartistPluginTooltips = __webpack_require__(790);
	
	var _chartistPluginTooltips2 = _interopRequireDefault(_chartistPluginTooltips);
	
	var _momentz = __webpack_require__(186);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _Chart = __webpack_require__(275);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InterventionDelayDashboardPanel = function (_Component) {
	    _inherits(InterventionDelayDashboardPanel, _Component);
	
	    function InterventionDelayDashboardPanel(props) {
	        _classCallCheck(this, InterventionDelayDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (InterventionDelayDashboardPanel.__proto__ || Object.getPrototypeOf(InterventionDelayDashboardPanel)).call(this, props));
	
	        _this.state = {
	            interventionDelay: [],
	            corrupted: false
	        };
	        return _this;
	    }
	
	    _createClass(InterventionDelayDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var contactStats = this.props.contactStats;
	
	
	            var interventionDelay = contactStats.interventionDelay.filter(function (v) {
	                return v.duration >= 0;
	            });
	            var corrupted = interventionDelay.length < contactStats.interventionDelay.length;
	
	            this.setState({ interventionDelay: interventionDelay, corrupted: corrupted });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.contactStats != this.props.contactStats) {
	                var contactStats = nextProps.contactStats;
	
	
	                var interventionDelay = contactStats.interventionDelay.filter(function (v) {
	                    return v.duration >= 0;
	                });
	                var corrupted = interventionDelay.length < contactStats.interventionDelay.length;
	
	                this.setState({ interventionDelay: interventionDelay, corrupted: corrupted });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contactStats = _props.contactStats,
	                others = _objectWithoutProperties(_props, ['dispatch', 'contactStats']);
	
	            var _state = this.state,
	                interventionDelay = _state.interventionDelay,
	                corrupted = _state.corrupted;
	
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-danger' },
	                    text
	                );
	            };
	
	            var panelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _i18n2.default.interventionDelay
	                ),
	                corrupted && _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(_i18n2.default.statsCorrupted) },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        '!'
	                    )
	                )
	            );
	
	            var aggregateDataStep = (0, _Chart.aggregateDataTimeStep)({
	                stepReduce: function stepReduce(a) {
	                    return Math.round(a.reduce(function (r, v) {
	                        return r + v;
	                    }, 0) / a.length);
	                }
	            });
	
	            var chartAxisY = {
	                offset: 70,
	                labelInterpolationFnc: function labelInterpolationFnc(v) {
	                    return (0, _momentz.humanizeShort)(_moment2.default.duration(v));
	                }
	            };
	
	            var chartPlugins = [_chartist2.default.plugins.tooltip({
	                transformTooltipTextFnc: function transformTooltipTextFnc(t) {
	                    return (0, _momentz.humanizeShort)(_moment2.default.duration(parseInt(t)));
	                },
	                appendToBody: true
	            })];
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader,
	                    help: _i18n2.default.interventionDelayText
	                }, others),
	                interventionDelay.length > 0 && _react2.default.createElement(_Chart2.default, { fill: true,
	                    kind: 'Bar',
	                    axisY: chartAxisY,
	                    plugins: chartPlugins,
	                    display: function display(a) {
	                        return new Date(a.day);
	                    },
	                    identify: function identify(a) {
	                        return a.duration;
	                    },
	                    data: aggregateDataStep,
	                    value: [interventionDelay] })
	            );
	        }
	    }]);
	
	    return InterventionDelayDashboardPanel;
	}(_react.Component);
	
	InterventionDelayDashboardPanel.propTypes = {};
	
	
	InterventionDelayDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        contactStats: state.provider.contact.contactStats
	    };
	})(InterventionDelayDashboardPanel);
	
	exports.default = InterventionDelayDashboardPanel;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _chartist = __webpack_require__(271);
	
	var _chartist2 = _interopRequireDefault(_chartist);
	
	var _chartistPluginTooltips = __webpack_require__(790);
	
	var _chartistPluginTooltips2 = _interopRequireDefault(_chartistPluginTooltips);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _Chart = __webpack_require__(275);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InterventionNumberDashboardPanel = function (_Component) {
	    _inherits(InterventionNumberDashboardPanel, _Component);
	
	    function InterventionNumberDashboardPanel() {
	        _classCallCheck(this, InterventionNumberDashboardPanel);
	
	        return _possibleConstructorReturn(this, (InterventionNumberDashboardPanel.__proto__ || Object.getPrototypeOf(InterventionNumberDashboardPanel)).apply(this, arguments));
	    }
	
	    _createClass(InterventionNumberDashboardPanel, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contactStats = _props.contactStats,
	                others = _objectWithoutProperties(_props, ['dispatch', 'contactStats']);
	
	            var panelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _i18n2.default.interventionNumber
	            );
	
	            var aggregateDataStep = (0, _Chart.aggregateDataTimeStep)({
	                stepReduce: function stepReduce(a) {
	                    return a.reduce(function (r, v) {
	                        return r + v;
	                    }, 0);
	                }
	            });
	
	            var chartPlugins = [_chartist2.default.plugins.tooltip({
	                appendToBody: true
	            })];
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader,
	                    help: _i18n2.default.interventionNumberText
	                }, others),
	                contactStats.interventionNumber.length > 0 && _react2.default.createElement(_Chart2.default, { fill: true,
	                    kind: 'Bar',
	                    plugins: chartPlugins,
	                    display: function display(a) {
	                        return new Date(a.day);
	                    },
	                    identify: function identify(a) {
	                        return a.count;
	                    },
	                    data: aggregateDataStep,
	                    value: [contactStats.interventionNumber] })
	            );
	        }
	    }]);
	
	    return InterventionNumberDashboardPanel;
	}(_react.Component);
	
	InterventionNumberDashboardPanel.propTypes = {};
	
	
	InterventionNumberDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        contactStats: state.provider.contact.contactStats
	    };
	})(InterventionNumberDashboardPanel);
	
	exports.default = InterventionNumberDashboardPanel;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chartist = __webpack_require__(271);
	
	var _chartist2 = _interopRequireDefault(_chartist);
	
	var _chartistPluginTooltips = __webpack_require__(790);
	
	var _chartistPluginTooltips2 = _interopRequireDefault(_chartistPluginTooltips);
	
	var _momentz = __webpack_require__(186);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _Chart = __webpack_require__(275);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MissionAcceptedDelayDashboardPanel = function (_Component) {
	    _inherits(MissionAcceptedDelayDashboardPanel, _Component);
	
	    function MissionAcceptedDelayDashboardPanel(props) {
	        _classCallCheck(this, MissionAcceptedDelayDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (MissionAcceptedDelayDashboardPanel.__proto__ || Object.getPrototypeOf(MissionAcceptedDelayDashboardPanel)).call(this, props));
	
	        _this.state = {
	            missionAcceptedDelay: [],
	            corrupted: false
	        };
	        return _this;
	    }
	
	    _createClass(MissionAcceptedDelayDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var contactStats = this.props.contactStats;
	
	
	            var missionAcceptedDelay = contactStats.missionAcceptedDelay.filter(function (v) {
	                return v.duration >= 0;
	            });
	            var corrupted = missionAcceptedDelay.length < contactStats.missionAcceptedDelay.length;
	
	            this.setState({ missionAcceptedDelay: missionAcceptedDelay, corrupted: corrupted });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.contactStats != this.props.contactStats) {
	                var contactStats = nextProps.contactStats;
	
	
	                var missionAcceptedDelay = contactStats.missionAcceptedDelay.filter(function (v) {
	                    return v.duration >= 0;
	                });
	                var corrupted = missionAcceptedDelay.length < contactStats.missionAcceptedDelay.length;
	
	                this.setState({ missionAcceptedDelay: missionAcceptedDelay, corrupted: corrupted });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contactStats = _props.contactStats,
	                others = _objectWithoutProperties(_props, ['dispatch', 'contactStats']);
	
	            var _state = this.state,
	                missionAcceptedDelay = _state.missionAcceptedDelay,
	                corrupted = _state.corrupted;
	
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-danger' },
	                    text
	                );
	            };
	
	            var panelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _i18n2.default.missionAcceptedDelay
	                ),
	                corrupted && _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(_i18n2.default.statsCorrupted) },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        '!'
	                    )
	                )
	            );
	
	            var aggregateDataStep = (0, _Chart.aggregateDataTimeStep)({
	                stepReduce: function stepReduce(a) {
	                    return Math.round(a.reduce(function (r, v) {
	                        return r + v;
	                    }, 0) / a.length);
	                }
	            });
	
	            var chartAxisY = {
	                offset: 70,
	                labelInterpolationFnc: function labelInterpolationFnc(v) {
	                    return (0, _momentz.humanizeShort)(_moment2.default.duration(v));
	                }
	            };
	
	            var chartPlugins = [_chartist2.default.plugins.tooltip({
	                transformTooltipTextFnc: function transformTooltipTextFnc(t) {
	                    return (0, _momentz.humanizeShort)(_moment2.default.duration(parseInt(t)));
	                },
	                appendToBody: true
	            })];
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader,
	                    help: _i18n2.default.missionAcceptedDelayText
	                }, others),
	                missionAcceptedDelay.length > 0 && _react2.default.createElement(_Chart2.default, { fill: true,
	                    kind: 'Bar',
	                    axisY: chartAxisY,
	                    plugins: chartPlugins,
	                    display: function display(a) {
	                        return new Date(a.day);
	                    },
	                    identify: function identify(a) {
	                        return a.duration;
	                    },
	                    data: aggregateDataStep,
	                    value: [missionAcceptedDelay] })
	            );
	        }
	    }]);
	
	    return MissionAcceptedDelayDashboardPanel;
	}(_react.Component);
	
	MissionAcceptedDelayDashboardPanel.propTypes = {};
	
	
	MissionAcceptedDelayDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        contactStats: state.provider.contact.contactStats
	    };
	})(MissionAcceptedDelayDashboardPanel);
	
	exports.default = MissionAcceptedDelayDashboardPanel;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderCard = __webpack_require__(2277);
	
	var _ProviderCard2 = _interopRequireDefault(_ProviderCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderCard = function (_Component) {
	    _inherits(ProviderCard, _Component);
	
	    function ProviderCard() {
	        _classCallCheck(this, ProviderCard);
	
	        return _possibleConstructorReturn(this, (ProviderCard.__proto__ || Object.getPrototypeOf(ProviderCard)).apply(this, arguments));
	    }
	
	    _createClass(ProviderCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                provider = _props.provider,
	                others = _objectWithoutProperties(_props, ['provider']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.provider
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ProviderCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true,
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ProviderCard2.default.name },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            '> ',
	                            provider.name
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderCard;
	}(_react.Component);
	
	ProviderCard.propTypes = {
	    provider: _react.PropTypes.object.isRequired
	};
	exports.default = ProviderCard;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _CommitmentLayout = __webpack_require__(1100);
	
	var _CommitmentLayout2 = _interopRequireDefault(_CommitmentLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderCommitmentLayout = function (_Component) {
	    _inherits(ProviderCommitmentLayout, _Component);
	
	    function ProviderCommitmentLayout() {
	        _classCallCheck(this, ProviderCommitmentLayout);
	
	        return _possibleConstructorReturn(this, (ProviderCommitmentLayout.__proto__ || Object.getPrototypeOf(ProviderCommitmentLayout)).apply(this, arguments));
	    }
	
	    _createClass(ProviderCommitmentLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                provider = _props.provider,
	                reference = _props.reference;
	
	
	            return _react2.default.createElement(_CommitmentLayout2.default, {
	                committed: provider,
	                commitments: provider.activities,
	                activityReference: reference });
	        }
	    }]);
	
	    return ProviderCommitmentLayout;
	}(_react.Component);
	
	ProviderCommitmentLayout.propTypes = {};
	
	
	ProviderCommitmentLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        provider: state.provider.provider,
	        reference: state.reference.activityRef
	    };
	})(ProviderCommitmentLayout);
	
	exports.default = ProviderCommitmentLayout;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _mathz = __webpack_require__(108);
	
	var _administrativeDivision = __webpack_require__(1350);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _PercentageDashboardPanel = __webpack_require__(891);
	
	var _PercentageDashboardPanel2 = _interopRequireDefault(_PercentageDashboardPanel);
	
	var _Map = __webpack_require__(1353);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderCoverageDashboard = __webpack_require__(2278);
	
	var _ProviderCoverageDashboard2 = _interopRequireDefault(_ProviderCoverageDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function activityAggregator(reference) {
	    return function (result, administrative) {
	        administrative.coverages.forEach(function (coverage) {
	            var aggrega = result.activityAggregation.find(function (a) {
	                return a.activity.uid == coverage.activityUid;
	            });
	
	            if (aggrega) {
	                aggrega.coverage = aggrega.coverage + (coverage.coverage || coverage.covered && 1 || 0);
	                return;
	            }
	
	            var resultActivity = reference.find(function (a) {
	                return a.uid == coverage.activityUid;
	            });
	            if (resultActivity) {
	                var _aggrega = {
	                    activity: resultActivity,
	                    coverage: coverage.coverage || coverage.covered && 1 || 0
	                };
	
	                result.activityAggregation.push(_aggrega);
	            } else {
	                console && console.warn('activity "' + coverage.activityUid + '" doesn\'t exist in referentiel');
	            }
	
	            result.activityCount++;
	        });
	
	        return result;
	    };
	}
	
	function administrativeAggregator(reference) {
	    return function (result, administrative) {
	        if (administrative.cityUid) {
	            var aggrega = {
	                city: { cityUid: administrative.cityUid, zipCodes: administrative.zipCodes, name: administrative.name },
	                coverage: administrative.coverages.reduce(function (r, c) {
	                    return r + (c.coverage || c.covered && 1 || 0);
	                }, 0)
	            };
	
	            result.cityAggregation = result.cityAggregation || [];
	            result.cityAggregation.push(aggrega);
	        }
	
	        if (administrative.departmentNumber) {
	            var _aggrega2 = {
	                department: { departmentNumber: administrative.departmentNumber, name: administrative.name },
	                coverage: administrative.coverages.reduce(function (r, c) {
	                    return r + (c.coverage || c.covered && 1 || 0);
	                }, 0)
	            };
	
	            result.departmentAggregation = result.departmentAggregation || [];
	            result.departmentAggregation.push(_aggrega2);
	        }
	
	        result.administrativeCount++;
	        return result;
	    };
	}
	
	var ProviderCoverageDashboard = function (_Component) {
	    _inherits(ProviderCoverageDashboard, _Component);
	
	    function ProviderCoverageDashboard(props) {
	        _classCallCheck(this, ProviderCoverageDashboard);
	
	        var _this = _possibleConstructorReturn(this, (ProviderCoverageDashboard.__proto__ || Object.getPrototypeOf(ProviderCoverageDashboard)).call(this, props));
	
	        _this.state = {
	            activityAggregation: []
	        };
	        return _this;
	    }
	
	    _createClass(ProviderCoverageDashboard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                coverage = _props.coverage,
	                reference = _props.reference;
	
	            var _coverage$reduce = coverage.reduce(activityAggregator(reference), { activityAggregation: [], activityCount: 0 }),
	                activityAggregation = _coverage$reduce.activityAggregation,
	                activityCount = _coverage$reduce.activityCount;
	
	            var _coverage$reduce2 = coverage.reduce(administrativeAggregator(reference), { administrativeCount: 0 }),
	                cityAggregation = _coverage$reduce2.cityAggregation,
	                departmentAggregation = _coverage$reduce2.departmentAggregation,
	                administrativeCount = _coverage$reduce2.administrativeCount;
	
	            this.setState({ activityAggregation: activityAggregation, activityCount: activityCount, cityAggregation: cityAggregation, departmentAggregation: departmentAggregation, administrativeCount: administrativeCount });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.coverage != this.props.coverage || nextProps.reference != this.props.reference) {
	                var coverage = nextProps.coverage,
	                    reference = nextProps.reference;
	
	                var _coverage$reduce3 = coverage.reduce(activityAggregator(reference), { activityAggregation: [], activityCount: 0 }),
	                    activityAggregation = _coverage$reduce3.activityAggregation,
	                    activityCount = _coverage$reduce3.activityCount;
	
	                var _coverage$reduce4 = coverage.reduce(administrativeAggregator(reference), { administrativeCount: 0 }),
	                    cityAggregation = _coverage$reduce4.cityAggregation,
	                    departmentAggregation = _coverage$reduce4.departmentAggregation,
	                    administrativeCount = _coverage$reduce4.administrativeCount;
	
	                this.setState({ activityAggregation: activityAggregation, activityCount: activityCount, cityAggregation: cityAggregation, departmentAggregation: departmentAggregation, administrativeCount: administrativeCount });
	            }
	        }
	    }, {
	        key: '_updateCriteria',
	        value: function _updateCriteria(event, criteria) {
	            var dispatch = this.props.dispatch;
	
	
	            if (event.preventDefault) {
	                event.preventDefault();
	            }
	
	            return dispatch((0, _actions.updateProviderCoverageCriteria)(criteria));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                coverage = _props2.coverage;
	            var _state = this.state,
	                activityAggregation = _state.activityAggregation,
	                activityCount = _state.activityCount,
	                cityAggregation = _state.cityAggregation,
	                departmentAggregation = _state.departmentAggregation,
	                administrativeCount = _state.administrativeCount;
	
	
	            var globalCoveragePercent = (0, _mathz.average)({
	                source: activityAggregation.map(function (a) {
	                    return a.coverage * 100 / administrativeCount;
	                })
	            });
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            var mapPercentageStyle = (0, _Map.percentageStyle)({
	                identify: function identify(a) {
	                    return a.coverage / activityCount;
	                }
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_PercentageDashboardPanel2.default, { light: true,
	                            header: panelHeader(_i18n2.default.byActivity),
	                            display: function display(a) {
	                                return a.activity.label;
	                            },
	                            identify: function identify(a) {
	                                return a.coverage;
	                            },
	                            total: administrativeCount,
	                            value: activityAggregation })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.coverageRate) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ProviderCoverageDashboard2.default.coverageRate },
	                                !isNaN(globalCoveragePercent) && _react2.default.createElement(
	                                    'span',
	                                    { className: _ProviderCoverageDashboard2.default.rate },
	                                    globalCoveragePercent,
	                                    ' %'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        cityAggregation && _react2.default.createElement(_PercentageDashboardPanel2.default, { light: true,
	                            size: 'large',
	                            header: panelHeader(_i18n2.default.byCity),
	                            display: function display(a) {
	                                return a.city.name;
	                            },
	                            identify: function identify(a) {
	                                return a.coverage;
	                            },
	                            total: activityCount,
	                            onClick: function onClick(e, a) {
	                                return _this2._updateCriteria(e, { city: a.city, department: null, zipCodes: null });
	                            },
	                            value: cityAggregation }),
	                        departmentAggregation && _react2.default.createElement(_PercentageDashboardPanel2.default, { light: true,
	                            size: 'large',
	                            header: panelHeader(_i18n2.default.byDepartment),
	                            display: function display(a) {
	                                return a.department.name;
	                            },
	                            identify: function identify(a) {
	                                return a.coverage;
	                            },
	                            total: activityCount,
	                            onClick: function onClick(e, a) {
	                                return _this2._updateCriteria(e, { department: a.department, city: null, zipCodes: null });
	                            },
	                            value: departmentAggregation })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 12, md: 8 },
	                        cityAggregation && _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                size: 'large',
	                                header: panelHeader(_i18n2.default.cityCoverageMap) },
	                            _react2.default.createElement(_Map2.default, {
	                                style: mapPercentageStyle,
	                                display: function display(a) {
	                                    return (0, _administrativeDivision.getAdministrativeDivision)({ division: 'city', departmentCode: a.city.zipCodes[0].toString().substring(0, 2), code: a.city.cityUid });
	                                },
	                                identify: function identify(a) {
	                                    return a.city.cityUid;
	                                },
	                                onClick: function onClick(e, a) {
	                                    return _this2._updateCriteria(e, { city: a.city, department: null, zipCodes: null });
	                                },
	                                value: cityAggregation })
	                        ),
	                        departmentAggregation && _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                size: 'large',
	                                header: panelHeader(_i18n2.default.departmentCoverageMap) },
	                            _react2.default.createElement(_Map2.default, {
	                                style: mapPercentageStyle,
	                                display: function display(a) {
	                                    return (0, _administrativeDivision.getAdministrativeDivision)({ division: 'department', code: a.department.departmentNumber });
	                                },
	                                identify: function identify(a) {
	                                    return a.department.departmentNumber;
	                                },
	                                onClick: function onClick(e, a) {
	                                    return _this2._updateCriteria(e, { department: a.department, city: null, zipCodes: null });
	                                },
	                                value: departmentAggregation })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderCoverageDashboard;
	}(_react.Component);
	
	ProviderCoverageDashboard.propTypes = {};
	
	
	ProviderCoverageDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        coverage: state.provider.coverage.coverage,
	        reference: state.reference.activityRef
	    };
	})(ProviderCoverageDashboard);
	
	exports.default = ProviderCoverageDashboard;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _ProviderCoverageDashboard = __webpack_require__(1439);
	
	var _ProviderCoverageDashboard2 = _interopRequireDefault(_ProviderCoverageDashboard);
	
	var _ProviderCoverageStats = __webpack_require__(1443);
	
	var _ProviderCoverageStats2 = _interopRequireDefault(_ProviderCoverageStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderCoverageDashboardLayout = function (_Component) {
	    _inherits(ProviderCoverageDashboardLayout, _Component);
	
	    function ProviderCoverageDashboardLayout() {
	        _classCallCheck(this, ProviderCoverageDashboardLayout);
	
	        return _possibleConstructorReturn(this, (ProviderCoverageDashboardLayout.__proto__ || Object.getPrototypeOf(ProviderCoverageDashboardLayout)).apply(this, arguments));
	    }
	
	    _createClass(ProviderCoverageDashboardLayout, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smOffset: 8 },
	                        _react2.default.createElement(_ProviderCoverageStats2.default, null)
	                    )
	                ),
	                _react2.default.createElement(_ProviderCoverageDashboard2.default, null)
	            );
	        }
	    }]);
	
	    return ProviderCoverageDashboardLayout;
	}(_react.Component);
	
	ProviderCoverageDashboardLayout.propTypes = {};
	exports.default = ProviderCoverageDashboardLayout;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(268);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderCoverageSearchBar = __webpack_require__(1442);
	
	var _ProviderCoverageSearchBar2 = _interopRequireDefault(_ProviderCoverageSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderCoverageLayout = function (_Component) {
	    _inherits(ProviderCoverageLayout, _Component);
	
	    function ProviderCoverageLayout() {
	        _classCallCheck(this, ProviderCoverageLayout);
	
	        return _possibleConstructorReturn(this, (ProviderCoverageLayout.__proto__ || Object.getPrototypeOf(ProviderCoverageLayout)).apply(this, arguments));
	    }
	
	    _createClass(ProviderCoverageLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                history = _props.history,
	                routes = _props.routes,
	                params = _props.params;
	
	
	            var breadcrumbDisplay = function breadcrumbDisplay(token) {
	                switch (token) {
	                    case 'providercoverage':
	                        return (0, _extract2.default)(_i18n2.default, 'providerCoverage');
	                    default:
	                        return (0, _extract2.default)(_i18n2.default, token);
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Coverage' }),
	                _react2.default.createElement(_ProviderCoverageSearchBar2.default, null),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        _react2.default.createElement(_router.Breadcrumb, {
	                            history: history,
	                            routes: routes,
	                            params: params,
	                            display: breadcrumbDisplay }),
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderCoverageLayout;
	}(_react.Component);
	
	ProviderCoverageLayout.propTypes = {};
	exports.default = ProviderCoverageLayout;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _browser = __webpack_require__(54);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _form = __webpack_require__(15);
	
	var _SearchBar = __webpack_require__(509);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _TypeaheadBar = __webpack_require__(511);
	
	var _TypeaheadBar2 = _interopRequireDefault(_TypeaheadBar);
	
	var _Tags = __webpack_require__(892);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _Tag = __webpack_require__(955);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(87);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderCoverageSearchBar = __webpack_require__(2279);
	
	var _ProviderCoverageSearchBar2 = _interopRequireDefault(_ProviderCoverageSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function repairActivities(reference) {
	    var activities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    activities.forEach(function (activity) {
	        if (activity.label) return;
	
	        var referenceActivity = reference.find(function (a) {
	            return a.uid == activity.uid;
	        });
	        if (referenceActivity) {
	            // mutate so we don't trigger actors
	            activity.label = referenceActivity.label;
	        } else {
	            console && console.warn('activity "' + activity.uid + '" doesn\'t exist in referentiel');
	        }
	    });
	
	    return activities;
	}
	
	var ProviderCoverageSearchBar = function (_Component) {
	    _inherits(ProviderCoverageSearchBar, _Component);
	
	    function ProviderCoverageSearchBar() {
	        _classCallCheck(this, ProviderCoverageSearchBar);
	
	        return _possibleConstructorReturn(this, (ProviderCoverageSearchBar.__proto__ || Object.getPrototypeOf(ProviderCoverageSearchBar)).apply(this, arguments));
	    }
	
	    _createClass(ProviderCoverageSearchBar, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                criteria = _props.criteria,
	                reference = _props.reference;
	
	
	            var activityUids = repairActivities(reference, criteria && criteria.activityUids);
	            dispatch((0, _actions.updateProviderCoverageCriteria)({ activityUids: activityUids }));
	        }
	    }, {
	        key: '_search',
	        value: function _search() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                criteria = _props2.criteria;
	
	
	            var nextCriteria = _extends({}, criteria, { department: null, city: null });
	            dispatch((0, _actions.updateProviderCoverageCriteria)(nextCriteria));
	            dispatch((0, _actions.loadProviderCoverage)(_extends({}, _actions.DEFAULT_PROVIDER_COVERAGE_QUERY, nextCriteria)));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                criteria = _props3.criteria,
	                query = _props3.query,
	                reference = _props3.reference;
	
	
	            var activitySource = (0, _TypeaheadBar.matcher)({
	                source: reference,
	                identify: function identify(a) {
	                    return a.label;
	                }
	            });
	
	            var tabTitle = function tabTitle(label, icon) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: _ProviderCoverageSearchBar2.default.tabTitle },
	                    _react2.default.createElement(_Icon2.default, { icon: icon, size: 'sm' }),
	                    label
	                );
	            };
	
	            var zipCodesField = function zipCodesField(field) {
	                var value = query && query.zipCodes;
	                return _extends({}, field, { value: value });
	            };
	
	            var footer = ((0, _form.nodeHasValue)(form.activityUids, form.department, form.city) || query && query.zipCodes) && _react2.default.createElement(
	                'div',
	                { className: _ProviderCoverageSearchBar2.default.footer },
	                (0, _form.nodeHasValue)(form.department) && _react2.default.createElement(
	                    'h4',
	                    null,
	                    _i18n2.default.department,
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        _react2.default.createElement(_Tag2.default, _extends({
	                            display: function display(d) {
	                                return d.name;
	                            }
	                        }, form.department()))
	                    )
	                ),
	                (0, _form.nodeHasValue)(form.city) && _react2.default.createElement(
	                    'h4',
	                    null,
	                    _i18n2.default.city,
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        _react2.default.createElement(_Tag2.default, _extends({
	                            display: function display(c) {
	                                return c.name;
	                            }
	                        }, form.city()))
	                    )
	                ),
	                query && query.zipCodes && _react2.default.createElement(
	                    'h4',
	                    null,
	                    _i18n2.default.zipCodes,
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        _react2.default.createElement(_Tag2.default, zipCodesField(form.zipCodes()))
	                    )
	                ),
	                _react2.default.createElement(_Tags2.default, _extends({
	                    label: _i18n2.default.activity + ' :',
	                    labelClassName: 'col-sm-2',
	                    wrapperClassName: 'col-sm-10',
	                    display: function display(a) {
	                        return a.label;
	                    }
	                }, form.activityUids()))
	            );
	
	            return _react2.default.createElement(
	                _SearchBar2.default,
	                {
	                    footer: footer,
	                    placeholder: (0, _extract2.default)(_i18n2.default.searchCoverage, (0, _browser.mediaQuery)()) },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _ProviderCoverageSearchBar2.default.content },
	                            _react2.default.createElement(
	                                _reactBootstrap.Tabs,
	                                {
	                                    bsStyle: 'cursors',
	                                    defaultActiveKey: 1,
	                                    justified: true },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.cities, 'customer'),
	                                        eventKey: 1 },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _ProviderCoverageSearchBar2.default.zipCodes },
	                                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                            type: 'textarea',
	                                            rows: 10,
	                                            placeholder: _i18n2.default.zipCodesInfo
	                                        }, (0, _form.controlledField)(form.zipCodes()))),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.ButtonToolbar,
	                                            null,
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'primary',
	                                                    bsSize: 'large',
	                                                    className: (0, _classnames2.default)({ disabled: !form.zipCodes.isValid() }),
	                                                    onClick: function onClick() {
	                                                        return _this2._search();
	                                                    } },
	                                                _i18n2.default.validate
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.activities, 'customer'),
	                                        eventKey: 2 },
	                                    _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                                        source: activitySource,
	                                        identify: function identify(a) {
	                                            return a.uid;
	                                        },
	                                        display: function display(a) {
	                                            return a.label;
	                                        },
	                                        placeholder: (0, _extract2.default)(_i18n2.default.searchActivity, (0, _browser.mediaQuery)())
	                                    }, form.activityUids()))
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderCoverageSearchBar;
	}(_react.Component);
	
	ProviderCoverageSearchBar.propTypes = {};
	
	
	ProviderCoverageSearchBar = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.ProviderCoverageCriteria.schema,
	    action: _actions.PROVIDER_COVERAGE_CRITERIA_UPDATED
	})(ProviderCoverageSearchBar);
	
	ProviderCoverageSearchBar = (0, _reactRedux.connect)(function (state) {
	    return {
	        criteria: state.provider.coverage.criteria,
	        query: state.provider.coverage.query,
	        reference: state.reference.activityRef
	    };
	})(ProviderCoverageSearchBar);
	
	exports.default = ProviderCoverageSearchBar;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderStats = __webpack_require__(1259);
	
	var _ProviderStats2 = _interopRequireDefault(_ProviderStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderCoverageStats = function (_Component) {
	    _inherits(ProviderCoverageStats, _Component);
	
	    function ProviderCoverageStats() {
	        _classCallCheck(this, ProviderCoverageStats);
	
	        return _possibleConstructorReturn(this, (ProviderCoverageStats.__proto__ || Object.getPrototypeOf(ProviderCoverageStats)).apply(this, arguments));
	    }
	
	    _createClass(ProviderCoverageStats, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                location = _props.location;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ProviderStats2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ProviderStats2.default.switch },
	                    _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        {
	                            value: location.pathname,
	                            onChange: function onChange(p) {
	                                return p && dispatch((0, _reactRouterRedux.push)(p));
	                            } },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonGroup,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'small',
	                                    value: '/providercontacts' },
	                                _i18n2.default.myProviderContacts
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'small',
	                                    value: '/providercoverage' },
	                                _i18n2.default.providerDirectory
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        {
	                            value: location.pathname,
	                            onChange: function onChange(p) {
	                                return p && dispatch((0, _reactRouterRedux.push)(p));
	                            } },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonGroup,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: '/providerdirectory' },
	                                _i18n2.default.providersz
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: '/providercoverage' },
	                                _i18n2.default.providerCoverage
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderCoverageStats;
	}(_react.Component);
	
	ProviderCoverageStats.propTypes = {};
	
	
	ProviderCoverageStats = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location
	    };
	})(ProviderCoverageStats);
	
	exports.default = ProviderCoverageStats;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _links = __webpack_require__(33);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _DocumentDashboardPanel = __webpack_require__(1265);
	
	var _DocumentDashboardPanel2 = _interopRequireDefault(_DocumentDashboardPanel);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderDashboard = __webpack_require__(2280);
	
	var _ProviderDashboard2 = _interopRequireDefault(_ProviderDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderDashboard = function (_Component) {
	    _inherits(ProviderDashboard, _Component);
	
	    function ProviderDashboard() {
	        _classCallCheck(this, ProviderDashboard);
	
	        return _possibleConstructorReturn(this, (ProviderDashboard.__proto__ || Object.getPrototypeOf(ProviderDashboard)).apply(this, arguments));
	    }
	
	    _createClass(ProviderDashboard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                provider = _props.provider,
	                _appLinks = _props._appLinks;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.description) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _ProviderDashboard2.default.data },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        '> ',
	                                        _i18n2.default.siret,
	                                        ' :'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        provider.siretNumber
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } })
	                    ),
	                    _appLinks.find((0, _links.linkFinder)('actradis/providercompanies')) && _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DocumentDashboardPanel2.default, { light: true,
	                            size: 'large' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderDashboard;
	}(_react.Component);
	
	ProviderDashboard.propTypes = {};
	
	
	ProviderDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        provider: state.provider.provider,
	        _appLinks: state.app._links
	    };
	})(ProviderDashboard);
	
	exports.default = ProviderDashboard;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _links = __webpack_require__(33);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderScores = __webpack_require__(1103);
	
	var _ProviderScores2 = _interopRequireDefault(_ProviderScores);
	
	var _AddProviderContactPopover = __webpack_require__(1408);
	
	var _AddProviderContactPopover2 = _interopRequireDefault(_AddProviderContactPopover);
	
	var _DefineContactInfosForProviderCompanyPopover = __webpack_require__(1426);
	
	var _DefineContactInfosForProviderCompanyPopover2 = _interopRequireDefault(_DefineContactInfosForProviderCompanyPopover);
	
	var _ProviderDetail = __webpack_require__(2281);
	
	var _ProviderDetail2 = _interopRequireDefault(_ProviderDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderDetail = function (_Component) {
	    _inherits(ProviderDetail, _Component);
	
	    function ProviderDetail(props) {
	        _classCallCheck(this, ProviderDetail);
	
	        var _this = _possibleConstructorReturn(this, (ProviderDetail.__proto__ || Object.getPrototypeOf(ProviderDetail)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ProviderDetail, [{
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_closePopover',
	        value: function _closePopover(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedPopover: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                authenticated = _props.authenticated,
	                provider = _props.provider,
	                _contactLinks = _props._contactLinks;
	            var openedPopover = this.state.openedPopover;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _ProviderDetail2.default.menu },
	                    _contactLinks.find((0, _links.linkFinder)('AddProviderContact')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AddProviderContactPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.newProviderContact
	                            )
	                        )
	                    ),
	                    provider._links.find((0, _links.linkFinder)('DefineContactInfosForProviderCompany')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'DefineContactInfosForProviderCompanyPopover');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.defineContactInfo
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: function onHide() {
	                            return _this2._closePopover();
	                        } },
	                    popover
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ProviderDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ProviderDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        { className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _ProviderDetail2.default.header },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                provider.name
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _ProviderDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        _contactLinks.find((0, _links.linkFinder)('AddProviderContact')) && editOverlay('AddProviderContactPopover', _react2.default.createElement(_AddProviderContactPopover2.default, {
	                            provider: provider,
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        provider._links.find((0, _links.linkFinder)('DefineContactInfosForProviderCompany')) && editOverlay('DefineContactInfosForProviderCompanyPopover', _react2.default.createElement(_DefineContactInfosForProviderCompanyPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } }))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ProviderDetail2.default.contact },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.contactInformation
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    provider.contactInfos && _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            ' ',
	                                            provider.contactInfos.name.firstName,
	                                            ' ',
	                                            provider.contactInfos.name.lastName,
	                                            ' ',
	                                            provider.contactInfos.name.value
	                                        )
	                                    ),
	                                    provider.contactInfos && provider.contactInfos.phones.length > 0 && _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _i18n2.default.phone,
	                                            ' :'
	                                        ),
	                                        provider.contactInfos.phones.map(function (phone, index) {
	                                            return _react2.default.createElement(
	                                                'span',
	                                                { key: index },
	                                                index > 0 && _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' |'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' ',
	                                                    (0, _phonez2.default)(phone).format()
	                                                )
	                                            );
	                                        })
	                                    ),
	                                    provider.contactInfos && provider.contactInfos.emails.length > 0 && _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _i18n2.default.email,
	                                            ' :'
	                                        ),
	                                        provider.contactInfos.emails.map(function (email, index) {
	                                            return _react2.default.createElement(
	                                                'span',
	                                                { key: index },
	                                                index > 0 && _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' |'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' ',
	                                                    email
	                                                )
	                                            );
	                                        })
	                                    ),
	                                    provider.contactInfos && provider.contactInfos.fax.length > 0 && _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            _i18n2.default.fax,
	                                            ' :'
	                                        ),
	                                        provider.contactInfos.fax.map(function (fax, index) {
	                                            return _react2.default.createElement(
	                                                'span',
	                                                { key: index },
	                                                index > 0 && _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' |'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' ',
	                                                    (0, _phonez2.default)(fax).format()
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(_ProviderScores2.default, null)
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _ProviderDetail2.default.event },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.interventionCount
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _ProviderDetail2.default.count },
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '---'
	                                    ),
	                                    _react2.default.createElement(_Icon2.default, { icon: 'file', size: 'xl' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/^\/\w+\/[\w-]+$/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _router.push)('/*/' + provider.uid));
	                                } },
	                            _i18n2.default.synthesis
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/^\/\w+\/[\w-]+\/providercontacts/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _router.push)('/*/' + provider.uid + '/providercontacts'));
	                                } },
	                            _i18n2.default.providerContactsz
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/^\/\w+\/[\w-]+\/activities/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _router.push)('/*/' + provider.uid + '/activities'));
	                                } },
	                            _i18n2.default.activities
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.tickets
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            { disabled: true },
	                            _i18n2.default.documents
	                        )
	                    )
	                ),
	                children
	            );
	        }
	    }]);
	
	    return ProviderDetail;
	}(_react.Component);
	
	ProviderDetail.propTypes = {};
	
	
	ProviderDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        authenticated: state.user.authenticated,
	        provider: state.provider.provider,
	        _contactLinks: state.provider.contact._links
	    };
	})(ProviderDetail);
	
	exports.default = ProviderDetail;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(268);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderSearchBar = __webpack_require__(1447);
	
	var _ProviderSearchBar2 = _interopRequireDefault(_ProviderSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderLayout = function (_Component) {
	    _inherits(ProviderLayout, _Component);
	
	    function ProviderLayout() {
	        _classCallCheck(this, ProviderLayout);
	
	        return _possibleConstructorReturn(this, (ProviderLayout.__proto__ || Object.getPrototypeOf(ProviderLayout)).apply(this, arguments));
	    }
	
	    _createClass(ProviderLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                history = _props.history,
	                routes = _props.routes,
	                params = _props.params,
	                provider = _props.provider;
	
	
	            var breadcrumbDisplay = function breadcrumbDisplay(token) {
	                switch (token) {
	                    case ':id':
	                        return provider.name;
	                    case 'providerdirectory':
	                        return (0, _extract2.default)(_i18n2.default, 'providerDirectory');
	                    default:
	                        return (0, _extract2.default)(_i18n2.default, token);
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Providers' }),
	                _react2.default.createElement(_ProviderSearchBar2.default, null),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        _react2.default.createElement(_router.Breadcrumb, {
	                            history: history,
	                            routes: routes,
	                            params: params,
	                            display: breadcrumbDisplay }),
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderLayout;
	}(_react.Component);
	
	ProviderLayout.propTypes = {};
	
	
	ProviderLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        provider: state.provider.provider
	    };
	})(ProviderLayout);
	
	exports.default = ProviderLayout;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _form = __webpack_require__(15);
	
	var _browser = __webpack_require__(54);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _status = __webpack_require__(13);
	
	var _SearchBar = __webpack_require__(509);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _TypeaheadBar = __webpack_require__(511);
	
	var _TypeaheadBar2 = _interopRequireDefault(_TypeaheadBar);
	
	var _Tags = __webpack_require__(892);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderSearchBar = __webpack_require__(2284);
	
	var _ProviderSearchBar2 = _interopRequireDefault(_ProviderSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderSearchBar = function (_Component) {
	    _inherits(ProviderSearchBar, _Component);
	
	    function ProviderSearchBar() {
	        _classCallCheck(this, ProviderSearchBar);
	
	        return _possibleConstructorReturn(this, (ProviderSearchBar.__proto__ || Object.getPrototypeOf(ProviderSearchBar)).apply(this, arguments));
	    }
	
	    _createClass(ProviderSearchBar, [{
	        key: '_search',
	        value: function _search(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                criteria = _props.criteria;
	
	
	            if (event) {
	                event.preventDefault();
	            }
	
	            return dispatch((0, _actions.loadProviderStream)(_extends({}, _actions.DEFAULT_QUERY, criteria))).then(function () {
	                if (location.pathname != '/providers' || location.pathname != '/providerdirectory') {
	                    return dispatch((0, _router.push)('/*'));
	                }
	            });
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props2 = this.props,
	                    dispatch = _props2.dispatch,
	                    location = _props2.location,
	                    criteria = _props2.criteria;
	
	
	                return dispatch((0, _actions.loadProviderStream)(_extends({}, _actions.DEFAULT_QUERY, criteria))).then(function () {
	                    if (location.pathname != '/providers' || location.pathname != '/providerdirectory') {
	                        return dispatch((0, _router.push)('/*'));
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                criteria = _props3.criteria,
	                location = _props3.location,
	                reference = _props3.reference;
	
	
	            var activitySource = (0, _TypeaheadBar.matcher)({
	                source: reference,
	                identify: function identify(a) {
	                    return a.label;
	                }
	            });
	
	            var tabTitle = function tabTitle(label, icon) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: _ProviderSearchBar2.default.tabTitle },
	                    _react2.default.createElement(_Icon2.default, { icon: icon, size: 'sm' }),
	                    label
	                );
	            };
	
	            var footer = (0, _form.nodeHasValue)(form.activityUid) && _react2.default.createElement(
	                'div',
	                { className: _ProviderSearchBar2.default.footer },
	                _react2.default.createElement(_Tags2.default, _extends({
	                    label: _i18n2.default.activity + ' :',
	                    labelClassName: 'col-sm-2',
	                    wrapperClassName: 'col-sm-10',
	                    display: function display(a) {
	                        return a.label;
	                    }
	                }, form.activityUid()))
	            );
	
	            return _react2.default.createElement(
	                _SearchBar2.default,
	                _extends({
	                    footer: footer,
	                    placeholder: (0, _extract2.default)(_i18n2.default.searchStream, (0, _browser.mediaQuery)()),
	                    onClick: function onClick(e) {
	                        return _this2._search(e);
	                    },
	                    onKeyPress: function onKeyPress(e) {
	                        return _this2._searchOnKeyPress(e);
	                    }
	                }, form.fullText()),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _ProviderSearchBar2.default.content },
	                            _react2.default.createElement(
	                                _reactBootstrap.Tabs,
	                                {
	                                    bsStyle: 'cursors',
	                                    defaultActiveKey: 1,
	                                    justified: true },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.activities, 'customer'),
	                                        eventKey: 1 },
	                                    _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                                        source: activitySource,
	                                        identify: function identify(a) {
	                                            return a.uid;
	                                        },
	                                        display: function display(a) {
	                                            return a.label;
	                                        },
	                                        placeholder: (0, _extract2.default)(_i18n2.default.searchActivity, (0, _browser.mediaQuery)())
	                                    }, form.activityUid()))
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderSearchBar;
	}(_react.Component);
	
	ProviderSearchBar.propTypes = {};
	
	
	ProviderSearchBar = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.ProviderCriteria.schema,
	    action: _actions.PROVIDER_CRITERIA_UPDATED
	})(ProviderSearchBar);
	
	ProviderSearchBar = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        criteria: state.provider.criteria,
	        reference: state.reference.activityRef
	    };
	})(ProviderSearchBar);
	
	exports.default = ProviderSearchBar;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderStats = __webpack_require__(1259);
	
	var _ProviderStats2 = _interopRequireDefault(_ProviderStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderStats = function (_Component) {
	    _inherits(ProviderStats, _Component);
	
	    function ProviderStats() {
	        _classCallCheck(this, ProviderStats);
	
	        return _possibleConstructorReturn(this, (ProviderStats.__proto__ || Object.getPrototypeOf(ProviderStats)).apply(this, arguments));
	    }
	
	    _createClass(ProviderStats, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                range = _props.range;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _ProviderStats2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ProviderStats2.default.switch },
	                    _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        {
	                            value: location.pathname == '/providers' && '/providercontacts' || location.pathname == '/providerdirectory' && '/providercoverage' || location.pathname,
	                            onChange: function onChange(p) {
	                                return p && dispatch((0, _reactRouterRedux.push)(p));
	                            } },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonGroup,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'small',
	                                    value: '/providercontacts' },
	                                _i18n2.default.myProviderContacts
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'small',
	                                    value: '/providercoverage' },
	                                _i18n2.default.providerDirectory
	                            )
	                        )
	                    ),
	                    location.pathname == '/providers' && _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        {
	                            value: location.pathname,
	                            onChange: function onChange(p) {
	                                return p && dispatch((0, _reactRouterRedux.push)(p));
	                            } },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonGroup,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: '/providers' },
	                                _i18n2.default.providersz
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: '/providercontacts' },
	                                _i18n2.default.providerContactsz
	                            )
	                        )
	                    ),
	                    location.pathname == '/providerdirectory' && _react2.default.createElement(
	                        _ButtonToggle2.default,
	                        {
	                            value: location.pathname,
	                            onChange: function onChange(p) {
	                                return p && dispatch((0, _reactRouterRedux.push)(p));
	                            } },
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonGroup,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: '/providerdirectory' },
	                                _i18n2.default.providersz
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: '/providercoverage' },
	                                _i18n2.default.providerCoverage
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    range.count,
	                    ' ',
	                    _i18n2.default.providers
	                )
	            );
	        }
	    }]);
	
	    return ProviderStats;
	}(_react.Component);
	
	ProviderStats.propTypes = {};
	
	
	ProviderStats = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        range: state.provider.range
	    };
	})(ProviderStats);
	
	exports.default = ProviderStats;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _loading = __webpack_require__(58);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(47);
	
	var _ProviderCard = __webpack_require__(1437);
	
	var _ProviderCard2 = _interopRequireDefault(_ProviderCard);
	
	var _ProviderStream = __webpack_require__(2285);
	
	var _ProviderStream2 = _interopRequireDefault(_ProviderStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var ProviderStream = function (_Component) {
	    _inherits(ProviderStream, _Component);
	
	    function ProviderStream() {
	        _classCallCheck(this, ProviderStream);
	
	        return _possibleConstructorReturn(this, (ProviderStream.__proto__ || Object.getPrototypeOf(ProviderStream)).apply(this, arguments));
	    }
	
	    _createClass(ProviderStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadProviderStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, provider) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/' + location.pathname.split('/')[1] + '/' + provider.uid);
	            } else {
	                dispatch((0, _router.push)('/*/' + provider.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                loading = _props.loading,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (provider) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: provider.uid,
	                                sm: 6 },
	                            _react2.default.createElement(_ProviderCard2.default, {
	                                provider: provider,
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, provider);
	                                } })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ProviderStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true,
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return ProviderStream;
	}(_react.Component);
	
	ProviderStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	ProviderStream = (0, _loading.connectLoadingLock)()(ProviderStream);
	
	ProviderStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        stream: state.provider.stream,
	        range: state.provider.range
	    };
	})(ProviderStream);
	
	exports.default = ProviderStream;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _ProviderStats = __webpack_require__(1448);
	
	var _ProviderStats2 = _interopRequireDefault(_ProviderStats);
	
	var _ProviderStream = __webpack_require__(1449);
	
	var _ProviderStream2 = _interopRequireDefault(_ProviderStream);
	
	var _ReferenceProviderCompanyModal = __webpack_require__(1452);
	
	var _ReferenceProviderCompanyModal2 = _interopRequireDefault(_ReferenceProviderCompanyModal);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProviderStreamLayout = function (_Component) {
	    _inherits(ProviderStreamLayout, _Component);
	
	    function ProviderStreamLayout(props) {
	        _classCallCheck(this, ProviderStreamLayout);
	
	        var _this = _possibleConstructorReturn(this, (ProviderStreamLayout.__proto__ || Object.getPrototypeOf(ProviderStreamLayout)).call(this, props));
	
	        _this.state = {
	            opened: false
	        };
	        return _this;
	    }
	
	    _createClass(ProviderStreamLayout, [{
	        key: '_open',
	        value: function _open() {
	            this.setState({ opened: true });
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({ opened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                authenticated = _props.authenticated,
	                _links = _props._links;
	            var opened = this.state.opened;
	
	
	            var newProviderBoxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.newProvider
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smPush: 8 },
	                        _react2.default.createElement(_ProviderStats2.default, null),
	                        _links.find((0, _links2.linkFinder)('ReferenceProviderCompany')) && location.pathname == '/providers' && ['superUser', 'callCenterUser'].indexOf(authenticated.userType) >= 0 && _react2.default.createElement(_Box2.default, {
	                            status: 'primary',
	                            header: newProviderBoxTitle,
	                            help: '+',
	                            onClick: function onClick() {
	                                return _this2._open();
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8, smPull: 4 },
	                        _react2.default.createElement(_ProviderStream2.default, null)
	                    )
	                ),
	                _links.find((0, _links2.linkFinder)('ReferenceProviderCompany')) && location.pathname == '/providers' && ['superUser', 'callCenterUser'].indexOf(authenticated.userType) >= 0 && _react2.default.createElement(_ReferenceProviderCompanyModal2.default, {
	                    show: opened,
	                    onHide: function onHide() {
	                        return _this2._close();
	                    } })
	            );
	        }
	    }]);
	
	    return ProviderStreamLayout;
	}(_react.Component);
	
	ProviderStreamLayout.propTypes = {};
	
	
	ProviderStreamLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        authenticated: state.user.authenticated,
	        _links: state.provider._links
	    };
	})(ProviderStreamLayout);
	
	exports.default = ProviderStreamLayout;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Selector = __webpack_require__(954);
	
	var _Selector2 = _interopRequireDefault(_Selector);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(113);
	
	var _actions2 = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateInterventionPeriodPanel = __webpack_require__(967);
	
	var _UpdateInterventionPeriodPanel2 = _interopRequireDefault(_UpdateInterventionPeriodPanel);
	
	var _ProviderSuggestSelector = __webpack_require__(2286);
	
	var _ProviderSuggestSelector2 = _interopRequireDefault(_ProviderSuggestSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function interventionPeriodAggregator(result, activity) {
	    result.push.apply(result, _toConsumableArray(activity.interventionPeriods));
	    return result;
	}
	
	function findReferenceInterventionPeriod(activities) {
	    for (var i = 0; i < activities.length; i++) {
	        var activity = activities[i];
	        var referenceInterventionPeriod = activity.interventionPeriods.find(function (ip) {
	            return ip.reference;
	        });
	        if (referenceInterventionPeriod) return referenceInterventionPeriod;
	    }
	}
	
	var ProviderSuggestSelector = function (_Component) {
	    _inherits(ProviderSuggestSelector, _Component);
	
	    function ProviderSuggestSelector(props) {
	        _classCallCheck(this, ProviderSuggestSelector);
	
	        var _this = _possibleConstructorReturn(this, (ProviderSuggestSelector.__proto__ || Object.getPrototypeOf(ProviderSuggestSelector)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ProviderSuggestSelector, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                company = _props.company,
	                patrimony = _props.patrimony,
	                activities = _props.activities;
	
	            dispatch((0, _actions2.queryProviderSuggest)({ patrimonyUid: patrimony.uid, activityUid: activities }));
	            dispatch((0, _actions.queryActivityRef)());
	            dispatch((0, _actions.queryOpeningTicketPurposeRef)(company.uid));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.activities != this.props.activities || nextProps.patrimony != this.props.patrimony) {
	                var dispatch = nextProps.dispatch,
	                    patrimony = nextProps.patrimony,
	                    activities = nextProps.activities;
	
	
	                dispatch((0, _actions2.queryProviderSuggest)({ patrimonyUid: patrimony.uid, activityUid: activities }));
	            }
	
	            if (this.props.company != nextProps.company) {
	                var _dispatch = nextProps.dispatch,
	                    company = nextProps.company;
	
	
	                _dispatch((0, _actions.queryOpeningTicketPurposeRef)(company.uid));
	            }
	        }
	    }, {
	        key: '_openPanel',
	        value: function _openPanel(key) {
	            var activeKey = this.state.activeKey;
	
	
	            var nextActiveKey = activeKey != key && key || null;
	            this.setState({ activeKey: nextActiveKey });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, activeProvider) {
	            event.preventDefault();
	            event.stopPropagation();
	
	            var referenceInterventionPeriod = findReferenceInterventionPeriod(activeProvider.activities);
	            var activeKey = referenceInterventionPeriod && referenceInterventionPeriod.uid;
	            this.setState({ modalOpened: true, activeProvider: activeProvider, activeKey: activeKey });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.setState({ modalOpened: false, activeProvider: null, activeKey: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                activityReference = _props2.activityReference,
	                openingTicketPurposeReference = _props2.openingTicketPurposeReference,
	                suggest = _props2.suggest,
	                company = _props2.company,
	                patrimony = _props2.patrimony,
	                activities = _props2.activities,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'activityReference', 'openingTicketPurposeReference', 'suggest', 'company', 'patrimony', 'activities']);
	
	            var _state = this.state,
	                modalOpened = _state.modalOpened,
	                activeProvider = _state.activeProvider,
	                activeKey = _state.activeKey;
	
	
	            var displayProvider = function displayProvider(provider) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _ProviderSuggestSelector2.default.provider },
	                    _react2.default.createElement(_Icon2.default, { icon: 'some icon', size: 'xs' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ProviderSuggestSelector2.default.container },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            provider.name
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            (0, _models.resolveActivities)(activityReference, provider.activities).map(function (activity, index) {
	                                return _react2.default.createElement(
	                                    'small',
	                                    {
	                                        key: index },
	                                    index > 0 && _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' - '
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        activity.label
	                                    )
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._openModal(e, provider);
	                            } },
	                        _i18n2.default.showMore
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Selector2.default, _extends({
	                    source: suggest,
	                    identify: function identify(c) {
	                        return c.uid;
	                    },
	                    display: displayProvider
	                }, others)),
	                activeProvider && _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    {
	                        show: modalOpened,
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            activeProvider.name
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _ProviderSuggestSelector2.default.data },
	                            activeProvider.contactInfos && activeProvider.contactInfos.phones.length > 0 && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.phone,
	                                    ' :'
	                                ),
	                                activeProvider.contactInfos.phones.map(function (phone, index) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { key: index },
	                                        index > 0 && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' |'
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            (0, _phonez2.default)(phone).format()
	                                        )
	                                    );
	                                })
	                            ),
	                            activeProvider.contactInfos && activeProvider.contactInfos.emails.length > 0 && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.email,
	                                    ' :'
	                                ),
	                                activeProvider.contactInfos.emails.map(function (email, index) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { key: index },
	                                        index > 0 && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' |'
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            email
	                                        )
	                                    );
	                                })
	                            ),
	                            activeProvider.contactInfos && activeProvider.contactInfos.fax.length > 0 && _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.fax,
	                                    ' :'
	                                ),
	                                activeProvider.contactInfos.fax.map(function (fax, index) {
	                                    return _react2.default.createElement(
	                                        'span',
	                                        { key: index },
	                                        index > 0 && _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' |'
	                                        ),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            (0, _phonez2.default)(fax).format()
	                                        )
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.PanelGroup,
	                            { accordion: true,
	                                activeKey: activeKey,
	                                onSelect: function onSelect(k) {
	                                    return _this2._openPanel(k);
	                                } },
	                            activeProvider.activities.reduce(interventionPeriodAggregator, []).map(function (interventionPeriod) {
	                                return _react2.default.createElement(_UpdateInterventionPeriodPanel2.default, {
	                                    key: interventionPeriod.uid,
	                                    eventKey: interventionPeriod.uid,
	                                    interventionPeriod: interventionPeriod,
	                                    openingTicketPurposeReference: openingTicketPurposeReference,
	                                    patrimony: patrimony });
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return _this2._closeModal();
	                                    } },
	                                _i18n2.default.close
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProviderSuggestSelector;
	}(_react.Component);
	
	ProviderSuggestSelector.propTypes = {
	    company: _react.PropTypes.object.isRequired,
	    patrimony: _react.PropTypes.object.isRequired,
	    activities: _react.PropTypes.array.isRequired
	};
	
	
	ProviderSuggestSelector = (0, _reactRedux.connect)(function (state) {
	    return {
	        activityReference: state.reference.activityRef,
	        openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
	        suggest: state.provider.suggest
	    };
	})(ProviderSuggestSelector);
	
	exports.default = ProviderSuggestSelector;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _models = __webpack_require__(87);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceProviderCompanyModal = function (_Component) {
	    _inherits(ReferenceProviderCompanyModal, _Component);
	
	    function ReferenceProviderCompanyModal() {
	        _classCallCheck(this, ReferenceProviderCompanyModal);
	
	        return _possibleConstructorReturn(this, (ReferenceProviderCompanyModal.__proto__ || Object.getPrototypeOf(ReferenceProviderCompanyModal)).apply(this, arguments));
	    }
	
	    _createClass(ReferenceProviderCompanyModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendReferenceProviderCompanyCmd)()).then(function () {
	                return dispatch((0, _actions.loadProviderStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.newProvider
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'label',
	                            label: requiredLabel(_i18n2.default.label)
	                        }, form.label())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'siret',
	                            label: requiredLabel(_i18n2.default.siret)
	                        }, form.siretNumber()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReferenceProviderCompanyModal;
	}(_react.Component);
	
	ReferenceProviderCompanyModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReferenceProviderCompanyModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ReferenceProviderCompanyCmd.schema,
	    action: _actions.REFERENCE_PROVIDER_COMPANY_CMD_UPDATED
	})(ReferenceProviderCompanyModal);
	
	ReferenceProviderCompanyModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.referenceProviderCompanyCmd
	    };
	})(ReferenceProviderCompanyModal);
	
	exports.default = ReferenceProviderCompanyModal;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _RemoveInterventionPeriodModal = __webpack_require__(2287);
	
	var _RemoveInterventionPeriodModal2 = _interopRequireDefault(_RemoveInterventionPeriodModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isContact(committed) {
	    return !!committed.commitments;
	}
	
	var RemoveInterventionPeriodModal = function (_Component) {
	    _inherits(RemoveInterventionPeriodModal, _Component);
	
	    function RemoveInterventionPeriodModal() {
	        _classCallCheck(this, RemoveInterventionPeriodModal);
	
	        return _possibleConstructorReturn(this, (RemoveInterventionPeriodModal.__proto__ || Object.getPrototypeOf(RemoveInterventionPeriodModal)).apply(this, arguments));
	    }
	
	    _createClass(RemoveInterventionPeriodModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                committed = _props.committed,
	                activity = _props.activity,
	                interventionPeriod = _props.interventionPeriod,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendRemoveInterventionPeriodCmd)(committed._links, activity.uid, interventionPeriod.uid)).then(function () {
	                return isContact(committed) && dispatch((0, _actions.loadContact)()) || dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                committed = _props2.committed,
	                activity = _props2.activity,
	                interventionPeriod = _props2.interventionPeriod,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'committed', 'activity', 'interventionPeriod', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.remove
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _RemoveInterventionPeriodModal2.default.text },
	                        _i18n2.default.removeInterventionPeriodText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, interventionPeriod.period)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return _this2._sendCmd(e);
	                                } },
	                            _i18n2.default.remove
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RemoveInterventionPeriodModal;
	}(_react.Component);
	
	RemoveInterventionPeriodModal.propTypes = {
	    committed: _react.PropTypes.object.isRequired,
	    activity: _react.PropTypes.object.isRequired,
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	RemoveInterventionPeriodModal = (0, _reactRedux.connect)()(RemoveInterventionPeriodModal);
	
	exports.default = RemoveInterventionPeriodModal;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chartist = __webpack_require__(271);
	
	var _chartist2 = _interopRequireDefault(_chartist);
	
	var _chartistPluginTooltips = __webpack_require__(790);
	
	var _chartistPluginTooltips2 = _interopRequireDefault(_chartistPluginTooltips);
	
	var _momentz = __webpack_require__(186);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _Chart = __webpack_require__(275);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RepairDelayDashboardPanel = function (_Component) {
	    _inherits(RepairDelayDashboardPanel, _Component);
	
	    function RepairDelayDashboardPanel(props) {
	        _classCallCheck(this, RepairDelayDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (RepairDelayDashboardPanel.__proto__ || Object.getPrototypeOf(RepairDelayDashboardPanel)).call(this, props));
	
	        _this.state = {
	            repairDelay: [],
	            corrupted: false
	        };
	        return _this;
	    }
	
	    _createClass(RepairDelayDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var contactStats = this.props.contactStats;
	
	
	            var repairDelay = contactStats.repairDelay.filter(function (v) {
	                return v.duration >= 0;
	            });
	            var corrupted = repairDelay.length < contactStats.repairDelay.length;
	
	            this.setState({ repairDelay: repairDelay, corrupted: corrupted });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.contactStats != this.props.contactStats) {
	                var contactStats = nextProps.contactStats;
	
	
	                var repairDelay = contactStats.repairDelay.filter(function (v) {
	                    return v.duration >= 0;
	                });
	                var corrupted = repairDelay.length < contactStats.repairDelay.length;
	
	                this.setState({ repairDelay: repairDelay, corrupted: corrupted });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contactStats = _props.contactStats,
	                others = _objectWithoutProperties(_props, ['dispatch', 'contactStats']);
	
	            var _state = this.state,
	                repairDelay = _state.repairDelay,
	                corrupted = _state.corrupted;
	
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-danger' },
	                    text
	                );
	            };
	
	            var panelHeader = _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _i18n2.default.repairDelay
	                ),
	                corrupted && _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(_i18n2.default.statsCorrupted) },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        '!'
	                    )
	                )
	            );
	
	            var aggregateDataStep = (0, _Chart.aggregateDataTimeStep)({
	                stepReduce: function stepReduce(a) {
	                    return Math.round(a.reduce(function (r, v) {
	                        return r + v;
	                    }, 0) / a.length);
	                }
	            });
	
	            var chartAxisY = {
	                offset: 70,
	                labelInterpolationFnc: function labelInterpolationFnc(v) {
	                    return (0, _momentz.humanizeShort)(_moment2.default.duration(v));
	                }
	            };
	
	            var chartPlugins = [_chartist2.default.plugins.tooltip({
	                transformTooltipTextFnc: function transformTooltipTextFnc(t) {
	                    return (0, _momentz.humanizeShort)(_moment2.default.duration(parseInt(t)));
	                },
	                appendToBody: true
	            })];
	
	            return _react2.default.createElement(
	                _DashboardPanel2.default,
	                _extends({
	                    header: panelHeader,
	                    help: _i18n2.default.repairDelayText
	                }, others),
	                repairDelay.length > 0 && _react2.default.createElement(_Chart2.default, { fill: true,
	                    kind: 'Bar',
	                    axisY: chartAxisY,
	                    plugins: chartPlugins,
	                    display: function display(a) {
	                        return new Date(a.day);
	                    },
	                    identify: function identify(a) {
	                        return a.duration;
	                    },
	                    data: aggregateDataStep,
	                    value: [repairDelay] })
	            );
	        }
	    }]);
	
	    return RepairDelayDashboardPanel;
	}(_react.Component);
	
	RepairDelayDashboardPanel.propTypes = {};
	
	
	RepairDelayDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        contactStats: state.provider.contact.contactStats
	    };
	})(RepairDelayDashboardPanel);
	
	exports.default = RepairDelayDashboardPanel;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _CheckboxToggle = __webpack_require__(508);
	
	var _CheckboxToggle2 = _interopRequireDefault(_CheckboxToggle);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _SubscribeProviderCompanyToDirectoryForInterventionPeriodForm = __webpack_require__(2288);
	
	var _SubscribeProviderCompanyToDirectoryForInterventionPeriodForm2 = _interopRequireDefault(_SubscribeProviderCompanyToDirectoryForInterventionPeriodForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function defineCmdUpdate(interventionPeriod) {
	    return {
	        subscriptions: interventionPeriod.subscriptions
	    };
	}
	
	var SubscribeProviderCompanyToDirectoryForInterventionPeriodForm = function (_Component) {
	    _inherits(SubscribeProviderCompanyToDirectoryForInterventionPeriodForm, _Component);
	
	    function SubscribeProviderCompanyToDirectoryForInterventionPeriodForm() {
	        _classCallCheck(this, SubscribeProviderCompanyToDirectoryForInterventionPeriodForm);
	
	        return _possibleConstructorReturn(this, (SubscribeProviderCompanyToDirectoryForInterventionPeriodForm.__proto__ || Object.getPrototypeOf(SubscribeProviderCompanyToDirectoryForInterventionPeriodForm)).apply(this, arguments));
	    }
	
	    _createClass(SubscribeProviderCompanyToDirectoryForInterventionPeriodForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                interventionPeriod = _props.interventionPeriod;
	
	
	            var update = defineCmdUpdate(interventionPeriod);
	            dispatch((0, _actions.updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.interventionPeriod != this.props.interventionPeriod) {
	                var dispatch = nextProps.dispatch,
	                    interventionPeriod = nextProps.interventionPeriod;
	
	
	                var update = defineCmdUpdate(interventionPeriod);
	                dispatch((0, _actions.updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                activity = _props2.activity,
	                interventionPeriod = _props2.interventionPeriod,
	                onSubmit = _props2.onSubmit;
	
	
	            return dispatch((0, _actions.sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd)(activity.uid, interventionPeriod.uid)).then(function () {
	                return dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onSubmit();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                activity = _props3.activity,
	                interventionPeriod = _props3.interventionPeriod,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'activity', 'interventionPeriod']);
	
	            var subscriptionsField = function subscriptionsField(field, who) {
	                var subscriptions = field.value;
	                var index = subscriptions && subscriptions.findIndex(function (s) {
	                    return s.forWho == who;
	                });
	                var value = index >= 0 && subscriptions[index].forWhat || [];
	
	                function onChange(value) {
	                    var nextSubscriptions = subscriptions && [].concat(_toConsumableArray(subscriptions)) || [];
	
	                    if (value && value.length > 0) {
	                        var nextSubscription = {
	                            forWho: who,
	                            forWhat: value
	                        };
	
	                        if (index >= 0) {
	                            nextSubscriptions[index] = nextSubscription;
	                        } else {
	                            nextSubscriptions.push(nextSubscription);
	                        }
	                    } else {
	                        if (index >= 0) {
	                            nextSubscriptions.splice(index, 1);
	                        }
	                    }
	                    field.onChange(nextSubscriptions);
	                }
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _SubscribeProviderCompanyToDirectoryForInterventionPeriodForm2.default.default },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _SubscribeProviderCompanyToDirectoryForInterventionPeriodForm2.default.section },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.forWhoEnum.individuals
	                            ),
	                            _react2.default.createElement(
	                                _CheckboxToggle2.default,
	                                subscriptionsField(form.subscriptions(), 'Individuals'),
	                                _models.FOR_WHATS.map(function (what, index) {
	                                    return _react2.default.createElement(_reactBootstrap.Input, {
	                                        key: index,
	                                        type: 'checkbox',
	                                        label: (0, _extract2.default)(_i18n2.default.forWhatEnum, what),
	                                        value: what });
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _SubscribeProviderCompanyToDirectoryForInterventionPeriodForm2.default.section },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.forWhoEnum.professionals
	                            ),
	                            _react2.default.createElement(
	                                _CheckboxToggle2.default,
	                                subscriptionsField(form.subscriptions(), 'Professionals'),
	                                _models.FOR_WHATS.map(function (what, index) {
	                                    return _react2.default.createElement(_reactBootstrap.Input, {
	                                        key: index,
	                                        type: 'checkbox',
	                                        label: (0, _extract2.default)(_i18n2.default.forWhatEnum, what),
	                                        value: what });
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.validate
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SubscribeProviderCompanyToDirectoryForInterventionPeriodForm;
	}(_react.Component);
	
	SubscribeProviderCompanyToDirectoryForInterventionPeriodForm.propTypes = {
	    activity: _react.PropTypes.object.isRequired,
	    interventionPeriod: _react.PropTypes.object.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	SubscribeProviderCompanyToDirectoryForInterventionPeriodForm = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd.schema,
	    action: _actions.SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED
	})(SubscribeProviderCompanyToDirectoryForInterventionPeriodForm);
	
	SubscribeProviderCompanyToDirectoryForInterventionPeriodForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.provider.subscribeProviderCompanyToDirectoryForInterventionPeriodCmd
	    };
	})(SubscribeProviderCompanyToDirectoryForInterventionPeriodForm);
	
	exports.default = SubscribeProviderCompanyToDirectoryForInterventionPeriodForm;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(47);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UnAssignActivityFromProviderCompanyModal = __webpack_require__(2289);
	
	var _UnAssignActivityFromProviderCompanyModal2 = _interopRequireDefault(_UnAssignActivityFromProviderCompanyModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnAssignActivityFromProviderCompanyModal = function (_Component) {
	    _inherits(UnAssignActivityFromProviderCompanyModal, _Component);
	
	    function UnAssignActivityFromProviderCompanyModal() {
	        _classCallCheck(this, UnAssignActivityFromProviderCompanyModal);
	
	        return _possibleConstructorReturn(this, (UnAssignActivityFromProviderCompanyModal.__proto__ || Object.getPrototypeOf(UnAssignActivityFromProviderCompanyModal)).apply(this, arguments));
	    }
	
	    _createClass(UnAssignActivityFromProviderCompanyModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                activity = _props.activity,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendUnAssignActivityFromProviderCompanyCmd)(activity.uid)).then(function () {
	                return dispatch((0, _actions.loadProvider)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                activity = _props2.activity,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'activity', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.unassign
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UnAssignActivityFromProviderCompanyModal2.default.text },
	                        _i18n2.default.unAssignActivityText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, activity)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return _this2._sendCmd(e);
	                                } },
	                            _i18n2.default.unassign
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UnAssignActivityFromProviderCompanyModal;
	}(_react.Component);
	
	UnAssignActivityFromProviderCompanyModal.propTypes = {
	    activity: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UnAssignActivityFromProviderCompanyModal = (0, _reactRedux.connect)()(UnAssignActivityFromProviderCompanyModal);
	
	exports.default = UnAssignActivityFromProviderCompanyModal;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _MultiInput = __webpack_require__(277);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	var _actions = __webpack_require__(47);
	
	var _models = __webpack_require__(87);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function contactCmdUpdate(contact) {
	    return {
	        namez: contact.name,
	        phones: contact.phones.map(function (p) {
	            return (0, _phonez2.default)(p).toE164();
	        }),
	        emails: contact.emails,
	        fax: contact.fax.map(function (p) {
	            return (0, _phonez2.default)(p).toE164();
	        })
	    };
	}
	
	var UpdateProviderContactPopover = function (_Component) {
	    _inherits(UpdateProviderContactPopover, _Component);
	
	    function UpdateProviderContactPopover() {
	        _classCallCheck(this, UpdateProviderContactPopover);
	
	        return _possibleConstructorReturn(this, (UpdateProviderContactPopover.__proto__ || Object.getPrototypeOf(UpdateProviderContactPopover)).apply(this, arguments));
	    }
	
	    _createClass(UpdateProviderContactPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                contact = _props.contact;
	
	
	            var update = contactCmdUpdate(contact);
	            dispatch((0, _actions.updateUpdateProviderContactCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.contact != this.props.contact) {
	                var dispatch = nextProps.dispatch,
	                    contact = nextProps.contact;
	
	
	                var update = contactCmdUpdate(contact);
	                dispatch((0, _actions.updateUpdateProviderContactCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd(action) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	            return dispatch((0, _actions.sendUpdateProviderContactCmd)()).then(function () {
	                return dispatch((0, _actions.loadContact)());
	            }).then(function () {
	
	                window.opener && window.opener.postMessage({
	                    type: 'RefreshTicket'
	                });
	
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                onHide = _props3.onHide,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'onHide', 'form', 'cmd']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    bsClass: 'popover-lg popover',
	                    title: _i18n2.default.updateProviderContact
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'nameType',
	                            label: _i18n2.default.nameType
	                        }, form.namez.nameType()),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'CivilName' },
	                            _i18n2.default.nameTypeEnum.civilName
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'PoorName' },
	                            _i18n2.default.nameTypeEnum.poorName
	                        )
	                    ),
	                    form.namez.firstName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'firstName',
	                        label: requiredLabel(_i18n2.default.firstName)
	                    }, form.namez.firstName())),
	                    form.namez.lastName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'lastName',
	                        label: requiredLabel(_i18n2.default.lastName)
	                    }, form.namez.lastName())),
	                    form.namez.gender && _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'select',
	                            name: 'gender',
	                            label: _i18n2.default.gender
	                        }, form.namez.gender()),
	                        _react2.default.createElement('option', { value: '' }),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Male' },
	                            _i18n2.default.genderEnum.male
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Female' },
	                            _i18n2.default.genderEnum.female
	                        )
	                    ),
	                    form.namez.value && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'name',
	                        label: requiredLabel(_i18n2.default.name)
	                    }, form.namez.value())),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'phone',
	                        label: _i18n2.default.phone
	                    }, (0, _phonez.phonesField)(form.phones()))),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'fax',
	                        label: _i18n2.default.fax
	                    }, (0, _phonez.phonesField)(form.fax()))),
	                    _react2.default.createElement(_MultiInput2.default, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'email',
	                        label: _i18n2.default.email
	                    }, form.emails()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateProviderContactPopover;
	}(_react.Component);
	
	UpdateProviderContactPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateProviderContactPopover = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.UpdateProviderContactCmd.selectSchema,
	    action: _actions.UPDATE_PROVIDER_CONTACT_CMD_UPDATED
	})(UpdateProviderContactPopover);
	
	UpdateProviderContactPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        contact: state.provider.contact.contact,
	        cmd: state.provider.updateProviderContactCmd
	    };
	})(UpdateProviderContactPopover);
	
	exports.default = UpdateProviderContactPopover;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (error, getState) {
	    return replaceError(extractError(_i18n2.default.errorTypeEnum, error), error, getState);
	};
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(35);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function interventionPeriodAggregator(result, commitment) {
	    result.push.apply(result, _toConsumableArray(commitment.interventionPeriods));
	    return result;
	}
	
	function interventionPeriodMapper(interventionPeriods) {
	    return function (interventionPeriodId) {
	        var interventionPeriod = interventionPeriods.find(function (ip) {
	            return ip.uid == interventionPeriodId;
	        });
	        return interventionPeriod && interventionPeriod.period.label || interventionPeriodId;
	    };
	}
	
	function extractError(target, error) {
	    var errorType = (0, _extract.sanitize)(error && error.type);
	
	    if (target) {
	        var errorData = error && error.data;
	        var targetError = target[errorType];
	
	        switch (errorType) {
	            case 'interventionPeriodIsIncoherent':
	                return targetError && errorData.errors.map(function (error) {
	                    return targetError[(0, _extract.sanitize)(error.error)] || null;
	                });
	            default:
	                return targetError || null;
	        }
	    }
	    return null;
	}
	
	function replaceError(value, error, getState) {
	    if (value) {
	        var errorType = (0, _extract.sanitize)(error && error.type);
	        var errorData = error && error.data;
	
	        switch (errorType) {
	            case 'interventionPeriodIsIncoherent':
	                return errorData.errors.map(function (error, index) {
	                    return (0, _extract.replace)(value[index], error);
	                }).join('. ');
	            case 'interventionPeriodOverlapAnothers':
	                var state = getState();
	                var provider = state.provider.provider;
	                var contact = state.provider.contact.contact;
	
	
	                var interventionPeriods = [];
	                interventionPeriods = provider && provider.activities.reduce(interventionPeriodAggregator, interventionPeriods) || interventionPeriods;
	                interventionPeriods = contact && contact.commitments.reduce(interventionPeriodAggregator, interventionPeriods) || interventionPeriods;
	                return value + ' : ' + errorData.interventionPeriodsOverlaped.map(interventionPeriodMapper(interventionPeriods)).join(', ');
	            default:
	                return (0, _extract.replace)(value, errorData);
	        }
	    }
	    return value;
	}

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stream() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PROVIDER_STREAM_LOADED:
	        case _actions.PROVIDER_STREAM_QUERIED:
	            return action.stream;
	        default:
	            return state;
	    }
	}
	
	function range() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PROVIDER_STREAM_LOADED:
	        case _actions.PROVIDER_STREAM_QUERIED:
	            return action.range;
	        default:
	            return state;
	    }
	}
	
	function _links() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PROVIDER_LINKS_LOADED:
	        case _actions.PROVIDER_STREAM_LOADED:
	        case _actions.PROVIDER_STREAM_QUERIED:
	            return action._links;
	        default:
	            return state;
	    }
	}
	
	function query() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PROVIDER_STREAM_LOADED:
	        case _actions.PROVIDER_STREAM_QUERIED:
	            return action.query;
	        default:
	            return state;
	    }
	}
	
	function suggest() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PROVIDER_SUGGEST_LOADED:
	        case _actions.PROVIDER_SUGGEST_QUERIED:
	            return action.suggest;
	        default:
	            return state;
	    }
	}
	
	function criteria() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PROVIDER_CRITERIA_UPDATED:
	            return _extends({}, state, action.criteria);
	        default:
	            return state;
	    }
	}
	
	function minorCriteria() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PROVIDER_MINOR_CRITERIA_UPDATED:
	            return _extends({}, state, action.minorCriteria);
	        case _actions.PROVIDER_MINOR_CRITERIA_RESETTED:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function provider() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.PROVIDER_LOADED:
	            return action.provider;
	        default:
	            return state;
	    }
	}
	
	function referenceProviderCompanyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REFERENCE_PROVIDER_COMPANY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.REFERENCE_PROVIDER_COMPANY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function addProviderContactCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ADD_PROVIDER_CONTACT_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ADD_PROVIDER_CONTACT_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateProviderContactCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_PROVIDER_CONTACT_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.UPDATE_PROVIDER_CONTACT_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function associateProviderContactWithProviderCompanyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ASSOCIATE_PROVIDER_CONTACT_WITH_PROVIDER_CONPANY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function assignActivityToProviderCompanyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineUpdateInterventionPeriodForActivityCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DEFINE_UPDATE_INTERVENTION_PERIOD_FOR_ACTIVITY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineServiceChargeForInterventionPeriodCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineInterventionZoneForInterventionPeriodCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DEFINE_INTERVENTION_ZONE_FOR_INTERVENTION_PERIOD_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineCallOutChargesForInterventionPeriodCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function subscribeProviderCompanyToDirectoryForInterventionPeriodCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineContactInfosForProviderCompanyCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DEFINE_CONTACT_INFOS_FOR_PROVIDER_COMPANY_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineRepairTimelimitForInterventionPeriodCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DEFINE_REPAIR_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineInterventionTimelimitForInterventionPeriodCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DEFINE_INTERVENTION_TIMELIMIT_FOR_INTERVENTION_PERIOD_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function excludeOpeningTicketPurposesFromInterventionPeriodCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.EXCLUDE_OPENING_TICKET_PURPOSES_FROM_INTERVENTION_PERIOD_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	var coverage = function () {
	
	    function coverage() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.PROVIDER_COVERAGE_LOADED:
	                return action.coverage;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.PROVIDER_COVERAGE_LOADED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    function criteria() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { activityUids: _config2.default.data.providerCoverageCriteriaActivityUids.map(function (u) {
	                return { uid: u };
	            }) };
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.PROVIDER_COVERAGE_CRITERIA_UPDATED:
	                return _extends({}, state, action.criteria);
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({
	        coverage: coverage,
	        query: query,
	        criteria: criteria
	    });
	}();
	
	var contact = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_STREAM_LOADED:
	            case _actions.CONTACT_STREAM_QUERIED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function range() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_STREAM_LOADED:
	            case _actions.CONTACT_STREAM_QUERIED:
	                return action.range;
	            default:
	                return state;
	        }
	    }
	
	    function _links() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_LINKS_LOADED:
	            case _actions.CONTACT_STREAM_LOADED:
	            case _actions.CONTACT_STREAM_QUERIED:
	                return action._links;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_STREAM_LOADED:
	            case _actions.CONTACT_STREAM_QUERIED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    function suggest() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_SUGGEST_LOADED:
	            case _actions.CONTACT_SUGGEST_QUERIED:
	                return action.suggest;
	            default:
	                return state;
	        }
	    }
	
	    function criteria() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_CRITERIA_UPDATED:
	                return _extends({}, state, action.criteria);
	            default:
	                return state;
	        }
	    }
	
	    function minorCriteria() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_MINOR_CRITERIA_UPDATED:
	                return _extends({}, state, action.minorCriteria);
	            case _actions.CONTACT_MINOR_CRITERIA_RESET:
	                return null;
	            default:
	                return state;
	        }
	    }
	
	    function contact() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_LOADED:
	                return action.contact;
	            default:
	                return state;
	        }
	    }
	
	    function contactStats() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_LOADED:
	                return action.contactStats;
	            default:
	                return state;
	        }
	    }
	
	    function contactStatsQuery() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_LOADED:
	                return action.contactStatsQuery;
	            default:
	                return state;
	        }
	    }
	
	    function contactFilter() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CONTACT_FILTER_UPDATED:
	                return action.contactFilter;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({
	        stream: stream,
	        range: range,
	        _links: _links,
	        query: query,
	        suggest: suggest,
	        criteria: criteria,
	        minorCriteria: minorCriteria,
	        contact: contact,
	        contactStats: contactStats,
	        contactStatsQuery: contactStatsQuery,
	        contactFilter: contactFilter
	    });
	}();
	
	exports.default = (0, _redux.combineReducers)({
	    stream: stream,
	    range: range,
	    _links: _links,
	    query: query,
	    suggest: suggest,
	    criteria: criteria,
	    minorCriteria: minorCriteria,
	    coverage: coverage,
	    provider: provider,
	    contact: contact,
	    referenceProviderCompanyCmd: referenceProviderCompanyCmd,
	    addProviderContactCmd: addProviderContactCmd,
	    updateProviderContactCmd: updateProviderContactCmd,
	    associateProviderContactWithProviderCompanyCmd: associateProviderContactWithProviderCompanyCmd,
	    assignActivityToProviderCompanyCmd: assignActivityToProviderCompanyCmd,
	    defineUpdateInterventionPeriodForActivityCmd: defineUpdateInterventionPeriodForActivityCmd,
	    defineServiceChargeForInterventionPeriodCmd: defineServiceChargeForInterventionPeriodCmd,
	    defineInterventionZoneForInterventionPeriodCmd: defineInterventionZoneForInterventionPeriodCmd,
	    defineCallOutChargesForInterventionPeriodCmd: defineCallOutChargesForInterventionPeriodCmd,
	    subscribeProviderCompanyToDirectoryForInterventionPeriodCmd: subscribeProviderCompanyToDirectoryForInterventionPeriodCmd,
	    defineContactInfosForProviderCompanyCmd: defineContactInfosForProviderCompanyCmd,
	    defineRepairTimelimitForInterventionPeriodCmd: defineRepairTimelimitForInterventionPeriodCmd,
	    defineInterventionTimelimitForInterventionPeriodCmd: defineInterventionTimelimitForInterventionPeriodCmd,
	    excludeOpeningTicketPurposesFromInterventionPeriodCmd: excludeOpeningTicketPurposesFromInterventionPeriodCmd
	});

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.providerContactRoute = providerContactRoute;
	exports.providerDirectoryRoute = providerDirectoryRoute;
	exports.providerCoverageRoute = providerCoverageRoute;
	
	exports.default = function (rootPath, dispatcher, _ref4) {
	    var getState = _ref4.getState;
	
	
	    function enterProviderStream(dispatch, params) {
	        var state = getState();
	        var criteria = state.provider.criteria;
	
	
	        return Promise.all([dispatch((0, _actions4.loadProviderStream)(_extends({}, _actions4.DEFAULT_PROVIDER_QUERY, criteria, { filtered: true }))), dispatch((0, _actions3.loadActivityRef)())]);
	    }
	
	    return {
	        path: rootPath,
	        component: _ProviderLayout2.default,
	        onEnter: dispatcher(enterProviderStream),
	        indexRoute: {
	            component: _ProviderStreamLayout2.default
	        },
	        childRoutes: [{
	            path: ':id',
	            component: _ProviderDetail2.default,
	            onEnter: dispatcher(enterProvider(getState)),
	            indexRoute: {
	                component: _ProviderDashboard2.default
	            },
	            childRoutes: [{
	                path: 'providercontacts',
	                component: _ContactStream2.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions4.loadContactStream)(_extends({}, _actions4.DEFAULT_CONTACT_QUERY, { providerCompanyUid: p.id })));
	                })
	            }, {
	                path: 'activities',
	                component: _ProviderCommitmentLayout2.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions3.loadActivityRef)());
	                })
	            }]
	        }]
	    };
	};
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _links = __webpack_require__(33);
	
	var _actions = __webpack_require__(38);
	
	var _TicketStream = __webpack_require__(900);
	
	var _TicketStream2 = _interopRequireDefault(_TicketStream);
	
	var _actions2 = __webpack_require__(1084);
	
	var _actions3 = __webpack_require__(113);
	
	var _actions4 = __webpack_require__(47);
	
	var _ProviderLayout = __webpack_require__(1446);
	
	var _ProviderLayout2 = _interopRequireDefault(_ProviderLayout);
	
	var _ProviderStreamLayout = __webpack_require__(1450);
	
	var _ProviderStreamLayout2 = _interopRequireDefault(_ProviderStreamLayout);
	
	var _ProviderCoverageLayout = __webpack_require__(1441);
	
	var _ProviderCoverageLayout2 = _interopRequireDefault(_ProviderCoverageLayout);
	
	var _ProviderCoverageDashboardLayout = __webpack_require__(1440);
	
	var _ProviderCoverageDashboardLayout2 = _interopRequireDefault(_ProviderCoverageDashboardLayout);
	
	var _ProviderDetail = __webpack_require__(1445);
	
	var _ProviderDetail2 = _interopRequireDefault(_ProviderDetail);
	
	var _ProviderDashboard = __webpack_require__(1444);
	
	var _ProviderDashboard2 = _interopRequireDefault(_ProviderDashboard);
	
	var _ContactLayout = __webpack_require__(1419);
	
	var _ContactLayout2 = _interopRequireDefault(_ContactLayout);
	
	var _ContactStreamLayout = __webpack_require__(1423);
	
	var _ContactStreamLayout2 = _interopRequireDefault(_ContactStreamLayout);
	
	var _ContactStream = __webpack_require__(896);
	
	var _ContactStream2 = _interopRequireDefault(_ContactStream);
	
	var _ContactDetail = __webpack_require__(1417);
	
	var _ContactDetail2 = _interopRequireDefault(_ContactDetail);
	
	var _ContactDashboard = __webpack_require__(1416);
	
	var _ContactDashboard2 = _interopRequireDefault(_ContactDashboard);
	
	var _ProviderCommitmentLayout = __webpack_require__(1438);
	
	var _ProviderCommitmentLayout2 = _interopRequireDefault(_ProviderCommitmentLayout);
	
	var _ContactCommitmentLayout = __webpack_require__(1415);
	
	var _ContactCommitmentLayout2 = _interopRequireDefault(_ContactCommitmentLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enterProvider(getState) {
	    return function (dispatch, params) {
	        var state = getState();
	        var _appLinks = state.app._links;
	
	        return dispatch((0, _actions4.loadProvider)(params.id)).then(function (action) {
	            return Promise.all([
	            // dashboard
	            _appLinks.find((0, _links.linkFinder)('actradis/providercompanies')) && dispatch((0, _actions2.loadProvider)(action.provider.siretNumber))]);
	        });
	    };
	}
	
	function providerContactRoute(rootPath, dispatcher, _ref) {
	    var getState = _ref.getState;
	
	
	    function enterContactStream(dispatch, params) {
	        var state = getState();
	        var criteria = state.provider.contact.criteria;
	
	
	        return dispatch((0, _actions4.loadContactStream)(_extends({}, _actions4.DEFAULT_CONTACT_QUERY, criteria)));
	    }
	
	    function enterContact(dispatch, params) {
	        var state = getState();
	        var contactFilter = state.provider.contact.contactFilter;
	
	        var _appLinks = state.app._links;
	
	        return dispatch((0, _actions4.loadContact)(params.id, _extends({}, _actions4.DEFAULT_CONTACT_STATS_QUERY, contactFilter))).then(function (action) {
	            return Promise.all([
	            // dashboard
	            _appLinks.find((0, _links.linkFinder)('tickets')) && dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, contactFilter, { activeProviders: params.id, range: { offset: 0, limit: 0 } }))), _appLinks.find((0, _links.linkFinder)('actradis/providercompanies')) && (action.contact.providerCompany && dispatch((0, _actions2.loadProvider)(action.contact.providerCompany.siretNumber)) || dispatch((0, _actions2.resetProvider)()))]);
	        });
	    }
	
	    function enterTicketStream(dispatch, params) {
	        var state = getState();
	        var contactFilter = state.provider.contactFilter;
	
	
	        return dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, contactFilter, { activeProviders: params.id })));
	    }
	
	    function entreCommitment(dispatch) {
	        var state = getState();
	        var contact = state.provider.contact.contact;
	
	
	        return Promise.all([dispatch((0, _actions3.loadActivityRef)()), dispatch((0, _actions3.loadOpeningTicketPurposeRef)(contact.company))]);
	    }
	
	    return {
	        path: rootPath,
	        component: _ContactLayout2.default,
	        onEnter: dispatcher(enterContactStream),
	        indexRoute: {
	            component: _ContactStreamLayout2.default
	        },
	        childRoutes: [{
	            path: ':id',
	            component: _ContactDetail2.default,
	            onEnter: dispatcher(enterContact),
	            indexRoute: {
	                component: _ContactDashboard2.default
	            },
	            childRoutes: [{
	                path: 'tickets',
	                component: _TicketStream2.default,
	                onEnter: dispatcher(enterTicketStream)
	            }, {
	                path: 'commitments',
	                component: _ContactCommitmentLayout2.default,
	                onEnter: dispatcher(entreCommitment)
	            }]
	        }]
	    };
	}
	
	function providerDirectoryRoute(rootPath, dispatcher, _ref2) {
	    var getState = _ref2.getState;
	
	
	    function enterProviderStream(dispatch, params) {
	        var state = getState();
	        var criteria = state.provider.criteria;
	
	
	        return Promise.all([dispatch((0, _actions4.loadProviderStream)(_extends({}, _actions4.DEFAULT_PROVIDER_QUERY, criteria, { filtered: false }))), dispatch((0, _actions3.loadActivityRef)())]);
	    }
	
	    return {
	        path: rootPath,
	        component: _ProviderLayout2.default,
	        onEnter: dispatcher(enterProviderStream),
	        indexRoute: {
	            component: _ProviderStreamLayout2.default
	        },
	        childRoutes: [{
	            path: ':id',
	            component: _ProviderDetail2.default,
	            onEnter: dispatcher(enterProvider(getState)),
	            indexRoute: {
	                component: _ProviderDashboard2.default
	            },
	            childRoutes: [{
	                path: 'providercontacts',
	                component: _ContactStream2.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions4.loadContactStream)(_extends({}, _actions4.DEFAULT_CONTACT_QUERY, { providerCompanyUid: p.id })));
	                })
	            }, {
	                path: 'activities',
	                component: _ProviderCommitmentLayout2.default,
	                onEnter: dispatcher(function (d, p) {
	                    return d((0, _actions3.loadActivityRef)());
	                })
	            }]
	        }]
	    };
	}
	
	function providerCoverageRoute(rootPath, dispatcher, _ref3) {
	    var getState = _ref3.getState;
	
	
	    function enterProviderCoverage(dispatch, params) {
	        var state = getState();
	        var criteria = state.provider.coverage.criteria;
	
	
	        return Promise.all([dispatch((0, _actions4.loadProviderCoverage)(_extends({}, _actions4.DEFAULT_PROVIDER_COVERAGE_QUERY, criteria))), dispatch((0, _actions3.loadActivityRef)())]);
	    }
	
	    return {
	        path: rootPath,
	        component: _ProviderCoverageLayout2.default,
	        onEnter: dispatcher(enterProviderCoverage),
	        indexRoute: {
	            component: _ProviderCoverageDashboardLayout2.default
	        }
	    };
	}

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _QualificationCriteriaRef = __webpack_require__(1814);
	
	var _QualificationCriteriaRef2 = _interopRequireDefault(_QualificationCriteriaRef);
	
	var _i18n = __webpack_require__(80);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	__webpack_require__(2292);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reactRedux = __webpack_require__(4);
	
	var _status = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRandomInts = function getRandomInts(n) {
	    var randInts = new Uint32Array(n);
	    crypto.getRandomValues(randInts);
	    return Array.from(randInts);
	};
	
	var CrieriaRef = function (_Component) {
	    _inherits(CrieriaRef, _Component);
	
	    function CrieriaRef() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CrieriaRef);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CrieriaRef.__proto__ || Object.getPrototypeOf(CrieriaRef)).call.apply(_ref, [this].concat(args))), _this), _this.setupPorts = function (ports) {
	            var dispatch = _this.props.dispatch;
	
	            ports.sendErrorToRedux.subscribe(function (e) {
	                dispatch((0, _status.errorStatus)(e));
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CrieriaRef, [{
	        key: 'render',
	        value: function render() {
	
	            var randInts = getRandomInts(5);
	
	            var link = this.props.company.company._links.find(function (x) {
	                return x.rel === 'criteriaref';
	            });
	
	            var flags = { seedInfos: [randInts[0], randInts.slice(1)],
	                getCriteriaRefUrl: link.href,
	                getCriteriaRefMethod: link.method
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: _i18n2.default.qualifCriterias }),
	                _react2.default.createElement(_reactElmComponents2.default, { src: _QualificationCriteriaRef2.default.Elm.QualificationCriteriaRef, flags: flags, ports: this.setupPorts })
	            );
	        }
	    }]);
	
	    return CrieriaRef;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var company = _ref2.company;
	    return { company: company };
	})(CrieriaRef);

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _QualificationCriteriaTree = __webpack_require__(1816);
	
	var _QualificationCriteriaTree2 = _interopRequireDefault(_QualificationCriteriaTree);
	
	__webpack_require__(2291);
	
	var _i18n = __webpack_require__(80);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reactRedux = __webpack_require__(4);
	
	var _status = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRandomInts = function getRandomInts(n) {
	    var randInts = new Uint32Array(n);
	    crypto.getRandomValues(randInts);
	    return Array.from(randInts);
	};
	
	var QualificationCriteriaTree = function (_Component) {
	    _inherits(QualificationCriteriaTree, _Component);
	
	    function QualificationCriteriaTree() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, QualificationCriteriaTree);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QualificationCriteriaTree.__proto__ || Object.getPrototypeOf(QualificationCriteriaTree)).call.apply(_ref, [this].concat(args))), _this), _this.setupPorts = function (ports) {
	            var dispatch = _this.props.dispatch;
	
	            ports.sendErrorToRedux.subscribe(function (e) {
	                dispatch((0, _status.errorStatus)(e));
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(QualificationCriteriaTree, [{
	        key: 'render',
	        value: function render() {
	            var randInts = getRandomInts(5);
	
	            var apiEvent = _config2.default.api.event.url;
	            var apiUrl = _config2.default.api.url;
	            var links = this.props.company.company._links;
	
	            var flags = { clientCompany: this.props.company.company.uid,
	                seedInfos: [randInts[0], randInts.slice(1)],
	                apiEvent: apiEvent,
	                apiUrl: apiUrl,
	                navigationLinks: links
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: "decisionTree" },
	                _react2.default.createElement(_reactHelmet2.default, { title: _i18n2.default.qualifCriterias }),
	                _react2.default.createElement(_reactElmComponents2.default, { src: _QualificationCriteriaTree2.default.Elm.QualificationCriteriaTree, flags: flags, ports: this.setupPorts })
	            );
	        }
	    }]);
	
	    return QualificationCriteriaTree;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var company = _ref2.company;
	    return { company: company };
	})(QualificationCriteriaTree);

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(113);
	
	var _models = __webpack_require__(269);
	
	function createUpdateCategoryActionUpdated() {
	    var action;
	
	    return function (state, dispatch) {
	        var nextAction = state.reference.createUpdateCategoryAction;
	
	        if (nextAction != action) {
	
	            if (nextAction && nextAction.action != (action && action.action)) {
	                dispatch((0, _actions.updateCreateUpdateCategoryAction)({ uid: undefined, parentUid: undefined, label: undefined, iconId: undefined }));
	            }
	            action = nextAction;
	        }
	    };
	}
	
	function createUpdateTagActionUpdated() {
	    var action;
	
	    return function (state, dispatch) {
	        var nextAction = state.reference.createUpdateTagAction;
	
	        if (nextAction != action) {
	
	            if (nextAction && nextAction.action != (action && action.action)) {
	                dispatch((0, _actions.updateCreateUpdateTagAction)({ uid: undefined, label: undefined, iconId: undefined }));
	            }
	            action = nextAction;
	        }
	    };
	}
	
	exports.default = [createUpdateCategoryActionUpdated(), createUpdateTagActionUpdated()];

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _TypeaheadBar = __webpack_require__(511);
	
	var _TypeaheadBar2 = _interopRequireDefault(_TypeaheadBar);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(47);
	
	var _ActivityPicker = __webpack_require__(1104);
	
	var _ActivityPicker2 = _interopRequireDefault(_ActivityPicker);
	
	var _actions2 = __webpack_require__(113);
	
	var _models = __webpack_require__(269);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AssociateActivityWithOpeningTicketPurposeModal = __webpack_require__(2293);
	
	var _AssociateActivityWithOpeningTicketPurposeModal2 = _interopRequireDefault(_AssociateActivityWithOpeningTicketPurposeModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssociateActivityWithOpeningTicketPurposeModal = function (_Component) {
	    _inherits(AssociateActivityWithOpeningTicketPurposeModal, _Component);
	
	    function AssociateActivityWithOpeningTicketPurposeModal(props) {
	        _classCallCheck(this, AssociateActivityWithOpeningTicketPurposeModal);
	
	        var _this = _possibleConstructorReturn(this, (AssociateActivityWithOpeningTicketPurposeModal.__proto__ || Object.getPrototypeOf(AssociateActivityWithOpeningTicketPurposeModal)).call(this, props));
	
	        _this.state = {
	            selectedProviderContacts: []
	        };
	        return _this;
	    }
	
	    _createClass(AssociateActivityWithOpeningTicketPurposeModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                openingTicketPurpose = _props.openingTicketPurpose;
	
	            dispatch((0, _actions2.updateAssociateActivityWithOpeningTicketPurposeAction)({ uid: openingTicketPurpose, activityUid: undefined }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.openingTicketPurpose != this.props.openingTicketPurpose) {
	                var dispatch = nextProps.dispatch,
	                    openingTicketPurpose = nextProps.openingTicketPurpose;
	
	                dispatch((0, _actions2.updateAssociateActivityWithOpeningTicketPurposeAction)({ uid: openingTicketPurpose, activityUid: undefined }));
	            }
	            if (nextProps.action && nextProps.action.activityUid != (this.props.action && this.props.action.activityUid)) {
	                var _dispatch = nextProps.dispatch,
	                    action = nextProps.action,
	                    company = nextProps.company;
	
	
	                if (action.activityUid) {
	                    _dispatch((0, _actions.queryContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, { activityUids: action.activityUid.uid, companyUid: company.uid, range: { offset: 0, limit: 999 } })));
	                }
	            }
	            if (nextProps.providerContactStream != this.props.providerContactStream) {
	                this.setState({ selectedProviderContacts: [] });
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                action = _props2.action,
	                openingTicketPurpose = _props2.openingTicketPurpose;
	            var selectedProviderContacts = this.state.selectedProviderContacts;
	
	
	            var activity = action.activityUid;
	
	            return dispatch((0, _actions2.sendAssociateActivityWithOpeningTicketPurposeAction)()).then(function () {
	                return Promise.all(selectedProviderContacts.map(function (providerContact) {
	                    var providerContactActivity = providerContact.activities.find(function (a) {
	                        return a.activityUid == activity.uid;
	                    });
	
	                    if (providerContactActivity) {
	                        var incidentTypeIds = [].concat(_toConsumableArray(providerContactActivity.includedIncidentTypes), [openingTicketPurpose.uid]);
	                        return dispatch((0, _actions.sendAssignActivityToProviderContactCmd)(activity, incidentTypeIds, providerContact));
	                    } else {
	                        console && console.warn('Activity "' + activity.uid + '" should be associated with ProviderContact "' + providerContact.uid + '"');
	                    }
	                }));
	            }).then(function () {
	                return dispatch((0, _actions2.loadOpeningTicketPurposeRef)());
	            });
	        }
	    }, {
	        key: '_selectAllProviderContacts',
	        value: function _selectAllProviderContacts() {
	            var providerContactStream = this.props.providerContactStream;
	            var selectedProviderContacts = this.state.selectedProviderContacts;
	
	
	            this.setState({ selectedProviderContacts: providerContactStream });
	        }
	    }, {
	        key: '_unselectAllProviderContacts',
	        value: function _unselectAllProviderContacts() {
	            var selectedProviderContacts = this.state.selectedProviderContacts;
	
	
	            this.setState({ selectedProviderContacts: [] });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                providerContactStream = _props3.providerContactStream,
	                providerContactQuery = _props3.providerContactQuery,
	                openingTicketPurpose = _props3.openingTicketPurpose,
	                company = _props3.company,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'providerContactStream', 'providerContactQuery', 'openingTicketPurpose', 'company', 'onHide']);
	
	            var selectedProviderContacts = this.state.selectedProviderContacts;
	
	
	            var providerContactSource = (0, _TypeaheadBar.matcher)({
	                source: providerContactStream,
	                identify: function identify(pc) {
	                    return [pc.name.firstName, pc.name.lastName, pc.name.value].filter(function (v) {
	                        return v;
	                    }).join(' ');
	                }
	            });
	
	            var providerContactHeader = _react2.default.createElement(
	                'div',
	                { className: _AssociateActivityWithOpeningTicketPurposeModal2.default.providerContactActions },
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        bsStyle: 'link',
	                        onClick: function onClick() {
	                            return _this2._selectAllProviderContacts();
	                        } },
	                    _i18n2.default.selectAll
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    '|'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        bsStyle: 'link',
	                        onClick: function onClick() {
	                            return _this2._unselectAllProviderContacts();
	                        } },
	                    _i18n2.default.unselectAll
	                )
	            );
	
	            var displayActivity = function displayActivity(activity, mode) {
	                if (mode == 'Picked') {
	                    return _react2.default.createElement(
	                        'h4',
	                        null,
	                        activity.label
	                    );
	                }
	                return activity.label;
	            };
	
	            var providerContactsField = function providerContactsField() {
	                var value = selectedProviderContacts;
	
	                var onChange = function onChange(value) {
	                    _this2.setState({ selectedProviderContacts: value });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.associateActivity
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_ActivityPicker2.default, _extends({
	                        display: displayActivity,
	                        disable: function disable(a) {
	                            return openingTicketPurpose.activities.find(function (otpa) {
	                                return otpa.uid == a.uid;
	                            });
	                        }
	                    }, form.activityUid())),
	                    providerContactStream.length > 0 && action && action.activityUid && action.activityUid.uid == (providerContactQuery && providerContactQuery.activityUids) && _react2.default.createElement(
	                        'div',
	                        { className: _AssociateActivityWithOpeningTicketPurposeModal2.default.providerContacts },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _AssociateActivityWithOpeningTicketPurposeModal2.default.text },
	                            _i18n2.default.associateActivityText.map(function (text, index) {
	                                return _react2.default.createElement(
	                                    'p',
	                                    { key: index },
	                                    text
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                            size: 'small',
	                            header: providerContactHeader,
	                            placeholder: _i18n2.default.searchProviderContact,
	                            source: providerContactSource,
	                            display: function display(pc) {
	                                return [pc.name.firstName, pc.name.lastName, pc.name.value].filter(function (v) {
	                                    return v;
	                                }).join(' ');
	                            },
	                            identify: function identify(pc) {
	                                return pc.uid;
	                            }
	                        }, providerContactsField()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssociateActivityWithOpeningTicketPurposeModal;
	}(_react.Component);
	
	AssociateActivityWithOpeningTicketPurposeModal.propTypes = {
	    openingTicketPurpose: _react.PropTypes.object.isRequired
	};
	
	
	AssociateActivityWithOpeningTicketPurposeModal = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.AssociateActivityWithOpeningTicketPurposeAction.schema,
	    action: _actions2.ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED
	})(AssociateActivityWithOpeningTicketPurposeModal);
	
	AssociateActivityWithOpeningTicketPurposeModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        action: state.reference.associateActivityWithOpeningTicketPurposeAction,
	        providerContactStream: state.provider.contact.stream,
	        providerContactQuery: state.provider.contact.query,
	        company: state.company.company
	    };
	})(AssociateActivityWithOpeningTicketPurposeModal);
	
	exports.default = AssociateActivityWithOpeningTicketPurposeModal;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _TypeaheadGridInput = __webpack_require__(893);
	
	var _TypeaheadGridInput2 = _interopRequireDefault(_TypeaheadGridInput);
	
	var _TagBar = __webpack_require__(956);
	
	var _TagBar2 = _interopRequireDefault(_TagBar);
	
	var _IconCateg = __webpack_require__(530);
	
	var _IconCateg2 = _interopRequireDefault(_IconCateg);
	
	var _actions = __webpack_require__(113);
	
	var _models = __webpack_require__(269);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CreateOpeningTicketPurposePanel = __webpack_require__(2294);
	
	var _CreateOpeningTicketPurposePanel2 = _interopRequireDefault(_CreateOpeningTicketPurposePanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function childrenCategoryFilter(parentCategory) {
	    return function (category) {
	        return (category.parent && category.parent.uid) == (parentCategory && parentCategory.uid);
	    };
	}
	
	function categoryTagMatcher(categoriesOrTags) {
	    return (0, _TypeaheadGridInput.matcher)({
	        source: categoriesOrTags,
	        identify: function identify(cot) {
	            return cot.label;
	        }
	    });
	}
	
	var CreateOpeningTicketPurposePanel = function (_Component) {
	    _inherits(CreateOpeningTicketPurposePanel, _Component);
	
	    function CreateOpeningTicketPurposePanel(props) {
	        _classCallCheck(this, CreateOpeningTicketPurposePanel);
	
	        var _this = _possibleConstructorReturn(this, (CreateOpeningTicketPurposePanel.__proto__ || Object.getPrototypeOf(CreateOpeningTicketPurposePanel)).call(this, props));
	
	        _this._categoryTagBars = [];
	        _this._categoryTypeaheadGridInputs = [];
	        return _this;
	    }
	
	    _createClass(CreateOpeningTicketPurposePanel, [{
	        key: '_sendAction',
	        value: function _sendAction(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onSelect = _props.onSelect;
	
	
	            var openingTicketPurposeUid;
	            return dispatch((0, _actions.sendCreateOpeningTicketPurposeAction)()).then(function (action) {
	                openingTicketPurposeUid = action.openingTicketPurposeUid;
	                return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	            }).then(function () {
	                onSelect(event, openingTicketPurposeUid);
	            });
	        }
	    }, {
	        key: '_submitCreateCategory',
	        value: function _submitCreateCategory(event, parentCategory, index) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                action = _props2.action,
	                onSubmit = _props2.onSubmit;
	
	
	            var category = {
	                label: this._categoryTypeaheadGridInputs[index].getQuery(),
	                parent: parentCategory
	            };
	
	            onSubmit(event, 'CreateCategory', category).then(function (category) {
	                var categoryUids = action && action.categoryUids || [];
	                var index = categoryUids.findIndex(function (c) {
	                    return c.uid == (parentCategory && parentCategory.uid);
	                });
	
	                if (index < 0) {
	                    categoryUids.unshift(category);
	                } else {
	                    categoryUids[index] = category;
	                }
	
	                dispatch((0, _actions.updateCreateOpeningTicketPurposeAction)({ categoryUids: categoryUids }));
	            });
	        }
	    }, {
	        key: '_submitCreateTag',
	        value: function _submitCreateTag(event) {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                action = _props3.action,
	                onSubmit = _props3.onSubmit;
	
	
	            var tag = {
	                label: this._tagTypeaheadGridInput.getQuery()
	            };
	
	            onSubmit(event, 'CreateTag', tag).then(function (tag) {
	                var tagUids = action && action.tagUids || [];
	                tagUids.unshift(tag);
	
	                dispatch((0, _actions.updateCreateOpeningTicketPurposeAction)({ tagUids: tagUids }));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                action = _props4.action,
	                reference = _props4.reference,
	                onSubmit = _props4.onSubmit,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'action', 'reference', 'onSubmit']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var categorySource = function categorySource(category) {
	                return (0, _TypeaheadGridInput.matcher)({
	                    source: reference.categories.filter(childrenCategoryFilter(category)),
	                    identify: function identify(c) {
	                        return c.label;
	                    }
	                });
	            };
	
	            var tagSource = (0, _TypeaheadGridInput.matcher)({
	                source: reference.tags,
	                identify: function identify(t) {
	                    return t.label;
	                }
	            });
	
	            var tooltipInputAddon = function tooltipInputAddon(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(text) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: _CreateOpeningTicketPurposePanel2.default.info },
	                        '?'
	                    )
	                );
	            };
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            var displayCategory = function displayCategory(category, active, path) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _CreateOpeningTicketPurposePanel2.default.category },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: category.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        category.label
	                    ),
	                    path && _react2.default.createElement(
	                        'small',
	                        null,
	                        '>'
	                    )
	                );
	            };
	
	            var displayTag = function displayTag(tag, active) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _CreateOpeningTicketPurposePanel2.default.tag },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: tag.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        tag.label
	                    )
	                );
	            };
	
	            var categoryField = function categoryField(field, category) {
	                var arrayValue = field.value || [];
	                var index = arrayValue.indexOf(category);
	                var value = arrayValue[index];
	
	                var onChange = function onChange(category) {
	                    var nextArrayValue = [].concat(_toConsumableArray(arrayValue));
	
	                    if (category) {
	                        nextArrayValue[index] = category;
	                    } else {
	                        nextArrayValue.splice(index, 1);
	                    }
	
	                    field.onChange(nextArrayValue);
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var categoryPathField = function categoryPathField(field, category) {
	                var arrayValue = field.value || [];
	                var index = arrayValue.indexOf(category);
	                var value = _models.OpeningTicketPurposeRef.expendParentCategories(reference, category);
	
	                var disabled = function disabled(category, index) {
	                    return index < value.length - 1;
	                };
	
	                var onChange = function onChange(categories) {
	                    var nextValue = _models.OpeningTicketPurposeRef.getLeafCategory(categories);
	                    var nextArrayValue = [].concat(_toConsumableArray(arrayValue));
	
	                    if (nextValue) {
	                        nextArrayValue[index] = nextValue;
	                    } else {
	                        nextArrayValue.splice(index, 1);
	                    }
	
	                    field.onChange(nextArrayValue);
	                };
	
	                return { value: value, disabled: disabled, onChange: onChange };
	            };
	
	            var closeTagTagBarField = function closeTagTagBarField(field) {
	                var onChange = function onChange(eventOrValue) {
	                    _this2._tagTagBar.close();
	                    field.onChange(eventOrValue);
	                };
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            var closeCategoryTagBarField = function closeCategoryTagBarField(field, index) {
	                var onChange = function onChange(eventOrValue) {
	                    _this2._categoryTagBars[index] && _this2._categoryTagBars[index].close();
	                    field.onChange(eventOrValue);
	                };
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            var closeTagTagBar = function closeTagTagBar(next) {
	                return function () {
	                    _this2._tagTagBar.close();
	                    return next.apply(undefined, arguments);
	                };
	            };
	
	            var closeCategoryTagBar = function closeCategoryTagBar(next, index) {
	                return function () {
	                    _this2._categoryTagBars[index] && _this2._categoryTagBars[index].close();
	                    return next.apply(undefined, arguments);
	                };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Panel,
	                others,
	                _react2.default.createElement(
	                    'div',
	                    { className: _CreateOpeningTicketPurposePanel2.default.defaultContent },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _i18n2.default.newOpeningTicketPurpose
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'label',
	                            label: requiredLabel(_i18n2.default.label)
	                        }, form.label())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'reference',
	                            label: _i18n2.default.reference,
	                            addonAfter: tooltipInputAddon(_i18n2.default.referenceInfo)
	                        }, form.extId()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.categories
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            action && action.categoryUids && action.categoryUids.slice(0).reverse().map(function (category, index) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    {
	                                        className: _CreateOpeningTicketPurposePanel2.default.categorySection,
	                                        key: index },
	                                    _react2.default.createElement(
	                                        _TagBar2.default,
	                                        _extends({ multi: true,
	                                            ref: function ref(tb) {
	                                                return _this2._categoryTagBars[index] = tb;
	                                            },
	                                            display: function display(c, i, a) {
	                                                return displayCategory(c, i == a.length - 1, true);
	                                            },
	                                            identify: function identify(c) {
	                                                return c.uid;
	                                            },
	                                            label: _i18n2.default.addChildCategory
	                                        }, categoryPathField(form.categoryUids(), category)),
	                                        _react2.default.createElement(_TypeaheadGridInput2.default, _extends({
	                                            ref: function ref(tgi) {
	                                                return _this2._categoryTypeaheadGridInputs[index] = tgi;
	                                            },
	                                            source: categorySource(category),
	                                            identify: function identify(c) {
	                                                return c.uid;
	                                            },
	                                            display: displayCategory,
	                                            placeholder: _i18n2.default.searchCategory
	                                        }, closeCategoryTagBarField(categoryField(form.categoryUids(), category), index))),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _CreateOpeningTicketPurposePanel2.default.manage },
	                                            _react2.default.createElement(
	                                                'a',
	                                                {
	                                                    href: '',
	                                                    onClick: closeCategoryTagBar(function (e) {
	                                                        return _this2._submitCreateCategory(e, category, index);
	                                                    }, index) },
	                                                _i18n2.default.newCategory
	                                            )
	                                        )
	                                    )
	                                );
	                            }),
	                            _react2.default.createElement(
	                                _TagBar2.default,
	                                {
	                                    ref: function ref(tb) {
	                                        return _this2._categoryTagBars[1000] = tb;
	                                    },
	                                    value: null,
	                                    label: _i18n2.default.addCategory },
	                                _react2.default.createElement(_TypeaheadGridInput2.default, _extends({
	                                    ref: function ref(tgi) {
	                                        return _this2._categoryTypeaheadGridInputs[1000] = tgi;
	                                    },
	                                    source: categorySource(),
	                                    identify: function identify(c) {
	                                        return c.uid;
	                                    },
	                                    display: displayCategory,
	                                    placeholder: _i18n2.default.searchCategory
	                                }, closeCategoryTagBarField((0, _form.addArrayItemField)(form.categoryUids()), 1000))),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _CreateOpeningTicketPurposePanel2.default.manage },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: closeCategoryTagBar(function (e) {
	                                                return _this2._submitCreateCategory(e, null, 1000);
	                                            }, 1000) },
	                                        _i18n2.default.newCategory
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.tags
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                _TagBar2.default,
	                                _extends({ multi: true,
	                                    ref: function ref(tb) {
	                                        return _this2._tagTagBar = tb;
	                                    },
	                                    display: function display(t) {
	                                        return displayTag(t, true);
	                                    },
	                                    identify: function identify(t) {
	                                        return t.uid;
	                                    },
	                                    label: _i18n2.default.addTag
	                                }, form.tagUids()),
	                                _react2.default.createElement(_TypeaheadGridInput2.default, _extends({ multi: true,
	                                    ref: function ref(tgi) {
	                                        return _this2._tagTypeaheadGridInput = tgi;
	                                    },
	                                    source: tagSource,
	                                    identify: function identify(t) {
	                                        return t.uid;
	                                    },
	                                    display: displayTag,
	                                    placeholder: _i18n2.default.searchTag
	                                }, closeTagTagBarField(form.tagUids()))),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _CreateOpeningTicketPurposePanel2.default.manage },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: closeTagTagBar(function (e) {
	                                                return _this2._submitCreateTag(e);
	                                            }) },
	                                        _i18n2.default.newTag
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick(e) {
	                                    return form.validate() && _this2._sendAction(e) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreateOpeningTicketPurposePanel;
	}(_react.Component);
	
	CreateOpeningTicketPurposePanel.propTypes = {
	    reference: _react.PropTypes.object.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	CreateOpeningTicketPurposePanel = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.CreateOpeningTicketPurposeAction.schema,
	    action: _actions.CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED
	})(CreateOpeningTicketPurposePanel);
	
	CreateOpeningTicketPurposePanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        action: state.reference.createOpeningTicketPurposeAction
	    };
	})(CreateOpeningTicketPurposePanel);
	
	exports.default = CreateOpeningTicketPurposePanel;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _IconCateg = __webpack_require__(530);
	
	var _IconCateg2 = _interopRequireDefault(_IconCateg);
	
	var _TagBar = __webpack_require__(956);
	
	var _TagBar2 = _interopRequireDefault(_TagBar);
	
	var _TypeaheadGridInput = __webpack_require__(893);
	
	var _TypeaheadGridInput2 = _interopRequireDefault(_TypeaheadGridInput);
	
	var _actions = __webpack_require__(113);
	
	var _models = __webpack_require__(269);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CreateUpdateCategoryModal = __webpack_require__(2295);
	
	var _CreateUpdateCategoryModal2 = _interopRequireDefault(_CreateUpdateCategoryModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function resultName(action) {
	    switch (action) {
	        case 'CreateCategory':
	            return 'CategoryCreated';
	        case 'UpdateCategory':
	            return 'CategoryUpdated';
	    }
	}
	
	function childrenCategoryFilter(parentCategory) {
	    return function (category) {
	        return (category.parent && category.parent.uid) == (parentCategory && parentCategory.uid);
	    };
	}
	
	function categoryMatcher(categories) {
	    return (0, _TypeaheadGridInput.matcher)({
	        source: categories,
	        identify: function identify(c) {
	            return c.label;
	        }
	    });
	}
	
	function iconMatcher(icons) {
	    return (0, _TypeaheadGridInput.matcher)({
	        source: icons,
	        identify: function identify(i) {
	            return i;
	        }
	    });
	}
	
	function categoryUpdate(category) {
	    return {
	        uid: category && category.uid,
	        label: category && category.label,
	        iconId: category && category.iconId,
	        parentUid: category && category.parent && { uid: category.parent.uid }
	    };
	}
	
	function actionReset(category) {
	    return {
	        label: category && category.label,
	        iconId: category && category.iconId,
	        parentUid: category && category.parent && { uid: category.parent.uid },
	        action: 'CreateCategory'
	    };
	}
	
	var CreateUpdateCategoryModal = function (_Component) {
	    _inherits(CreateUpdateCategoryModal, _Component);
	
	    function CreateUpdateCategoryModal(props) {
	        _classCallCheck(this, CreateUpdateCategoryModal);
	
	        var _this = _possibleConstructorReturn(this, (CreateUpdateCategoryModal.__proto__ || Object.getPrototypeOf(CreateUpdateCategoryModal)).call(this, props));
	
	        _this.state = {
	            childrenCategorySource: function childrenCategorySource() {
	                return null;
	            },
	            siblingCategorySource: function siblingCategorySource() {
	                return null;
	            },
	            iconSource: function iconSource() {
	                return null;
	            }
	        };
	        return _this;
	    }
	
	    _createClass(CreateUpdateCategoryModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                category = _props.category;
	
	
	            var reset = actionReset(category);
	            dispatch((0, _actions.resetCreateUpdateCategoryAction)(reset));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.category != this.props.category) {
	                var dispatch = nextProps.dispatch,
	                    category = nextProps.category;
	
	
	                var reset = actionReset(category);
	                dispatch((0, _actions.resetCreateUpdateCategoryAction)(reset));
	            }
	
	            if (nextProps.reference != this.props.reference || nextProps.action != this.props.action) {
	                var action = nextProps.action,
	                    reference = nextProps.reference;
	
	
	                var childrenCategorySource = categoryMatcher(reference.categories.filter(childrenCategoryFilter(action)));
	                var siblingCategorySource = categoryMatcher(reference.categories.filter(childrenCategoryFilter(action && action.parentUid)));
	                var iconSource = iconMatcher(!(action && action.iconId) && _models.OPENING_TICKET_PURPOSE_REF_ICONS || []);
	                this.setState({ childrenCategorySource: childrenCategorySource, siblingCategorySource: siblingCategorySource, iconSource: iconSource });
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                action = _props2.action,
	                reference = _props2.reference,
	                onHide = _props2.onHide;
	
	
	            var actionName = action.action;
	            var actionUid = action.uid;
	            var actionParent = action.parentUid;
	            var category = reference.categories.find(function (c) {
	                return c.uid == action.uid;
	            });
	
	            var categoryId;
	            return dispatch((0, _actions.sendCreateUpdateCategoryAction)()).then(function (action) {
	                categoryId = action.categoryUid;
	                return category && (category.parent && category.parent.uid) != (actionParent && actionParent.uid) && dispatch((0, _actions.sendMoveParentCategoryAction)(actionParent && actionParent.uid, actionUid));
	            }).then(function () {
	                return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	            }).then(function (action) {
	                var category = action.ref.categories.find(function (c) {
	                    return c.uid == categoryId;
	                });
	                onHide(null, resultName(actionName), category);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                onHide = _props3.onHide,
	                reference = _props3.reference,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'onHide', 'reference']);
	
	            var _state = this.state,
	                childrenCategorySource = _state.childrenCategorySource,
	                siblingCategorySource = _state.siblingCategorySource,
	                iconSource = _state.iconSource;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var displayCategory = function displayCategory(category, active, path) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _CreateUpdateCategoryModal2.default.category },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: category.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        category.label
	                    ),
	                    path && _react2.default.createElement(
	                        'small',
	                        null,
	                        '>'
	                    )
	                );
	            };
	
	            var displayIcon = function displayIcon(iconId, active) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _CreateUpdateCategoryModal2.default.icon },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        iconId.replace(/_/g, ' ').replace('1-', '')
	                    )
	                );
	            };
	
	            var categoryField = function categoryField(field) {
	                function onChange(value) {
	                    var nextValue = categoryUpdate(value);
	                    field.onChange(nextValue);
	                }
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            var categoryPathField = function categoryPathField(field) {
	                var value = _models.OpeningTicketPurposeRef.expendParentCategories(reference, field.value && reference.categories.find(function (c) {
	                    return c.uid == field.value.uid;
	                }));
	
	                var onChange = function onChange(categories) {
	                    var nextValue = categoryUpdate(_models.OpeningTicketPurposeRef.getLeafCategory(categories));
	                    field.onChange(nextValue);
	                };
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            var actionField = function actionField(field) {
	                function onChange(value) {
	                    if (value) {
	                        field.onChange(value);
	                    }
	                }
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            var categoryTypeaheadHeader = _react2.default.createElement(
	                _ButtonToggle2.default,
	                _extends({ multi: true,
	                    identify: function identify(c) {
	                        return c.uid;
	                    }
	                }, categoryPathField(form())),
	                _react2.default.createElement(
	                    'ul',
	                    { className: (0, _classnames2.default)(_CreateUpdateCategoryModal2.default.typeaheadHeaderGroup, _CreateUpdateCategoryModal2.default.categoryGroup) },
	                    _models.OpeningTicketPurposeRef.expendParentCategories(reference, action && reference.categories.find(function (c) {
	                        return c.uid == action.uid;
	                    })).map(function (category) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: category.uid },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsStyle: 'link',
	                                    value: category },
	                                displayCategory(category, true, true)
	                            )
	                        );
	                    })
	                )
	            );
	
	            var iconTypeaheadHeader = action && action.iconId && _react2.default.createElement(
	                _ButtonToggle2.default,
	                form.iconId(),
	                _react2.default.createElement(
	                    'ul',
	                    { className: (0, _classnames2.default)(_CreateUpdateCategoryModal2.default.typeaheadHeaderGroup, _CreateUpdateCategoryModal2.default.iconGroup) },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                value: action.iconId },
	                            displayIcon(action.iconId, true)
	                        )
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    bsSize: 'large',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.manageCategories
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _CreateUpdateCategoryModal2.default.defaultContent },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _CreateUpdateCategoryModal2.default.actionGroup },
	                                    _react2.default.createElement(
	                                        _ButtonToggle2.default,
	                                        actionField(form.action()),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            { block: true,
	                                                value: 'CreateCategory' },
	                                            _i18n2.default.newCategory
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            { block: true,
	                                                value: 'UpdateCategory' },
	                                            _i18n2.default.updateCategory
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_TypeaheadGridInput2.default, _extends({
	                                    size: 'small',
	                                    source: childrenCategorySource,
	                                    identify: function identify(c) {
	                                        return c.uid;
	                                    },
	                                    display: displayCategory,
	                                    header: categoryTypeaheadHeader,
	                                    placeholder: _i18n2.default.searchCategory,
	                                    disabled: action && action.action == 'CreateCategory'
	                                }, categoryField(form())))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 8 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { xsHidden: true, sm: 3 },
	                                        _react2.default.createElement(
	                                            'h5',
	                                            null,
	                                            _i18n2.default.parentCategory
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 9 },
	                                        _react2.default.createElement(
	                                            _TagBar2.default,
	                                            _extends({ multi: true,
	                                                display: function display(c) {
	                                                    return displayCategory(c, true, true);
	                                                },
	                                                identify: function identify(c) {
	                                                    return c.uid;
	                                                },
	                                                disabled: action && action.action == 'UpdateCategory' && !action.uid,
	                                                label: action && action.parentUid && _i18n2.default.addChildCategory || _i18n2.default.addCategory
	                                            }, categoryPathField(form.parentUid())),
	                                            _react2.default.createElement(_TypeaheadGridInput2.default, _extends({
	                                                source: siblingCategorySource,
	                                                identify: function identify(c) {
	                                                    return c.uid;
	                                                },
	                                                display: displayCategory,
	                                                placeholder: _i18n2.default.searchCategory
	                                            }, form.parentUid()))
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'form',
	                                    { className: 'form-horizontal' },
	                                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                        labelClassName: 'col-sm-3',
	                                        wrapperClassName: 'col-sm-9',
	                                        type: 'text',
	                                        name: 'label',
	                                        label: requiredLabel(_i18n2.default.label),
	                                        disabled: action && action.action == 'UpdateCategory' && !action.uid
	                                    }, form.label())),
	                                    _react2.default.createElement(_TypeaheadGridInput2.default, _extends({
	                                        labelClassName: 'col-sm-3',
	                                        wrapperClassName: 'col-sm-9',
	                                        label: requiredLabel(_i18n2.default.icon),
	                                        source: iconSource,
	                                        display: displayIcon,
	                                        header: iconTypeaheadHeader,
	                                        placeholder: _i18n2.default.searchIcon,
	                                        disabled: action && action.action == 'UpdateCategory' && !action.uid || action && !!action.iconId
	                                    }, form.iconId()))
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                    onClick: function onClick() {
	                                        return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _i18n2.default.save
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreateUpdateCategoryModal;
	}(_react.Component);
	
	CreateUpdateCategoryModal.propTypes = {
	    category: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	CreateUpdateCategoryModal = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.CreateUpdateCategoryAction.schema,
	    action: _actions.CREATE_UPDATE_CATEGORY_ACTION_UPDATED
	})(CreateUpdateCategoryModal);
	
	CreateUpdateCategoryModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        reference: state.reference.openingTicketPurposeRef,
	        action: state.reference.createUpdateCategoryAction
	    };
	})(CreateUpdateCategoryModal);
	
	exports.default = CreateUpdateCategoryModal;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _IconCateg = __webpack_require__(530);
	
	var _IconCateg2 = _interopRequireDefault(_IconCateg);
	
	var _TypeaheadGridInput = __webpack_require__(893);
	
	var _TypeaheadGridInput2 = _interopRequireDefault(_TypeaheadGridInput);
	
	var _actions = __webpack_require__(113);
	
	var _models = __webpack_require__(269);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CreateUpdateTagModal = __webpack_require__(2296);
	
	var _CreateUpdateTagModal2 = _interopRequireDefault(_CreateUpdateTagModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function resultName(action) {
	    switch (action) {
	        case 'CreateTag':
	            return 'TagCreated';
	        case 'UpdateTag':
	            return 'TagUpdated';
	    }
	}
	
	function tagMatcher(tags) {
	    return (0, _TypeaheadGridInput.matcher)({
	        source: tags,
	        identify: function identify(t) {
	            return t.label;
	        }
	    });
	}
	
	function iconMatcher(icons) {
	    return (0, _TypeaheadGridInput.matcher)({
	        source: icons,
	        identify: function identify(i) {
	            return i;
	        }
	    });
	}
	
	function tagUpdate(tag) {
	    return {
	        uid: tag && tag.uid,
	        label: tag && tag.label,
	        iconId: tag && tag.iconId
	    };
	}
	
	function actionReset(tag) {
	    return {
	        label: tag && tag.label,
	        iconId: tag && tag.iconId,
	        action: 'CreateTag'
	    };
	}
	
	var CreateUpdateTagModal = function (_Component) {
	    _inherits(CreateUpdateTagModal, _Component);
	
	    function CreateUpdateTagModal(props) {
	        _classCallCheck(this, CreateUpdateTagModal);
	
	        var _this = _possibleConstructorReturn(this, (CreateUpdateTagModal.__proto__ || Object.getPrototypeOf(CreateUpdateTagModal)).call(this, props));
	
	        _this.state = {
	            tagSource: function tagSource() {
	                return null;
	            },
	            iconSource: function iconSource() {
	                return null;
	            }
	        };
	        return _this;
	    }
	
	    _createClass(CreateUpdateTagModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                tag = _props.tag;
	
	
	            var reset = actionReset(tag);
	            dispatch((0, _actions.resetCreateUpdateTagAction)(reset));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.tag != this.props.tag) {
	                var dispatch = nextProps.dispatch,
	                    tag = nextProps.tag;
	
	
	                var reset = actionReset(tag);
	                dispatch((0, _actions.resetCreateUpdateTagAction)(reset));
	            }
	
	            if (nextProps.reference != this.props.reference || nextProps.action != this.props.action) {
	                var action = nextProps.action,
	                    reference = nextProps.reference;
	
	
	                var tagSource = tagMatcher(reference.tags);
	                var iconSource = iconMatcher(!(action && action.iconId) && _models.OPENING_TICKET_PURPOSE_REF_ICONS || []);
	                this.setState({ tagSource: tagSource, iconSource: iconSource });
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                action = _props2.action,
	                onHide = _props2.onHide;
	
	
	            var actionName = action.action;
	
	            var tagId;
	            return dispatch((0, _actions.sendCreateUpdateTagAction)()).then(function (action) {
	                tagId = action.tagUid;
	                return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	            }).then(function (action) {
	                var tag = action.ref.tags.find(function (t) {
	                    return t.uid == tagId;
	                });
	                onHide(null, resultName(actionName), tag);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                onHide = _props3.onHide,
	                reference = _props3.reference,
	                tag = _props3.tag,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'onHide', 'reference', 'tag']);
	
	            var _state = this.state,
	                tagSource = _state.tagSource,
	                iconSource = _state.iconSource;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var displayTag = function displayTag(tag) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_IconCateg2.default, { iconId: tag.iconId }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        tag.label
	                    )
	                );
	            };
	
	            var displayIcon = function displayIcon(iconId, active) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_IconCateg2.default, { iconId: iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        iconId.replace(/_/g, ' ').replace('1-', '')
	                    )
	                );
	            };
	
	            var tagField = function tagField(field) {
	                function onChange(tag) {
	                    var nextValue = tagUpdate(tag);
	                    field.onChange(nextValue);
	                }
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            var actionField = function actionField(field) {
	                function onChange(value) {
	                    if (value) {
	                        field.onChange(value);
	                    }
	                }
	
	                return _extends({}, field, { onChange: onChange });
	            };
	
	            var iconTypeaheadHeader = action && action.iconId && _react2.default.createElement(
	                _ButtonToggle2.default,
	                form.iconId(),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _CreateUpdateTagModal2.default.typeaheadHeaderGroup },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                value: action.iconId },
	                            displayIcon(action.iconId, true)
	                        )
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    bsSize: 'large',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.manageTags
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _CreateUpdateTagModal2.default.defaultContent },
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 4 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _CreateUpdateTagModal2.default.actionGroup },
	                                    _react2.default.createElement(
	                                        _ButtonToggle2.default,
	                                        actionField(form.action()),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            { block: true,
	                                                value: 'CreateTag' },
	                                            _i18n2.default.newTag
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            { block: true,
	                                                value: 'UpdateTag' },
	                                            _i18n2.default.updateTag
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(_TypeaheadGridInput2.default, _extends({
	                                    size: 'small',
	                                    source: tagSource,
	                                    identify: function identify(t) {
	                                        return t.uid;
	                                    },
	                                    display: displayTag,
	                                    placeholder: _i18n2.default.searchTag,
	                                    disabled: action && action.action == 'CreateTag'
	                                }, tagField(form())))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 8 },
	                                _react2.default.createElement(
	                                    'form',
	                                    { className: 'form-horizontal' },
	                                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                        labelClassName: 'col-sm-3',
	                                        wrapperClassName: 'col-sm-9',
	                                        type: 'text',
	                                        name: 'label',
	                                        label: requiredLabel(_i18n2.default.label),
	                                        disabled: action && action.action == 'UpdateTag' && !action.uid
	                                    }, form.label())),
	                                    _react2.default.createElement(_TypeaheadGridInput2.default, _extends({
	                                        labelClassName: 'col-sm-3',
	                                        wrapperClassName: 'col-sm-9',
	                                        label: requiredLabel(_i18n2.default.icon),
	                                        source: iconSource,
	                                        identify: function identify(i) {
	                                            return i;
	                                        },
	                                        display: displayIcon,
	                                        header: iconTypeaheadHeader,
	                                        placeholder: _i18n2.default.searchIcon,
	                                        disabled: action && action.action == 'UpdateTag' && !action.uid || action && !!action.iconId
	                                    }, form.iconId()))
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                    onClick: function onClick() {
	                                        return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _i18n2.default.save
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: onHide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreateUpdateTagModal;
	}(_react.Component);
	
	CreateUpdateTagModal.propTypes = {
	    tag: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	CreateUpdateTagModal = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.CreateUpdateTagAction.schema,
	    action: _actions.CREATE_UPDATE_TAG_ACTION_UPDATED
	})(CreateUpdateTagModal);
	
	CreateUpdateTagModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        reference: state.reference.openingTicketPurposeRef,
	        action: state.reference.createUpdateTagAction
	    };
	})(CreateUpdateTagModal);
	
	exports.default = CreateUpdateTagModal;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(47);
	
	var _actions2 = __webpack_require__(113);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DissociateActivityFromOpeningTicketPurposeModal = __webpack_require__(2297);
	
	var _DissociateActivityFromOpeningTicketPurposeModal2 = _interopRequireDefault(_DissociateActivityFromOpeningTicketPurposeModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DissociateActivityFromOpeningTicketPurposeModal = function (_Component) {
	    _inherits(DissociateActivityFromOpeningTicketPurposeModal, _Component);
	
	    function DissociateActivityFromOpeningTicketPurposeModal() {
	        _classCallCheck(this, DissociateActivityFromOpeningTicketPurposeModal);
	
	        return _possibleConstructorReturn(this, (DissociateActivityFromOpeningTicketPurposeModal.__proto__ || Object.getPrototypeOf(DissociateActivityFromOpeningTicketPurposeModal)).apply(this, arguments));
	    }
	
	    _createClass(DissociateActivityFromOpeningTicketPurposeModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                openingTicketPurpose = _props.openingTicketPurpose,
	                activity = _props.activity,
	                company = _props.company;
	
	            dispatch((0, _actions.queryContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, { openingTicketPurposeUids: openingTicketPurpose.uid, activityUids: activity.uid, companyUid: company.uid, range: { offset: 0, limit: 999 } })));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.openingTicketPurpose != this.props.openingTicketPurpose || nextProps.activity != this.props.activity || nextProps.company != this.props.company) {
	                var dispatch = nextProps.dispatch,
	                    openingTicketPurpose = nextProps.openingTicketPurpose,
	                    activity = nextProps.activity,
	                    company = nextProps.company;
	
	                dispatch((0, _actions.queryContactStream)(_extends({}, _actions.DEFAULT_CONTACT_QUERY, { openingTicketPurposeUids: openingTicketPurpose.uid, activityUids: activity.uid, companyUid: company.uid, range: { offset: 0, limit: 999 } })));
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide,
	                openingTicketPurpose = _props2.openingTicketPurpose,
	                activity = _props2.activity;
	
	
	            return dispatch((0, _actions2.sendDissociateActivityFromOpeningTicketPurposeAction)(openingTicketPurpose.uid, activity.uid)).then(function (action) {
	                return action.providerContactUpdated > 0 && dispatch((0, _status.infoStatus)((0, _extract.replace)(_i18n2.default.providerContactDissociatedFromOpeningTicketPurpose, { count: action.providerContactUpdated })));
	            }).then(function () {
	                return dispatch((0, _actions2.loadOpeningTicketPurposeRef)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                openingTicketPurpose = _props3.openingTicketPurpose,
	                activity = _props3.activity,
	                providerContactStream = _props3.providerContactStream,
	                company = _props3.company,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'openingTicketPurpose', 'activity', 'providerContactStream', 'company', 'onHide']);
	
	            var providerContactElement = function providerContactElement(providerContact) {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        key: providerContact.uid },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        [providerContact.name.firstName, providerContact.name.lastName, providerContact.name.value].filter(function (v) {
	                            return v;
	                        }).join(' ')
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.dissociateActivity
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DissociateActivityFromOpeningTicketPurposeModal2.default.text },
	                        _i18n2.default.dissociateActivityText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, _extends({}, activity, { count: providerContactStream.length || null }))
	                            );
	                        })
	                    ),
	                    providerContactStream.length > 0 && _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _DissociateActivityFromOpeningTicketPurposeModal2.default.providerContactGroup },
	                                providerContactStream.slice(0, providerContactStream.length / 2 + 1).map(providerContactElement)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _DissociateActivityFromOpeningTicketPurposeModal2.default.providerContactGroup },
	                                providerContactStream.slice(providerContactStream.length / 2 + 1, providerContactStream.length).map(providerContactElement)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return _this2._sendAction();
	                                } },
	                            _i18n2.default.dissociate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DissociateActivityFromOpeningTicketPurposeModal;
	}(_react.Component);
	
	DissociateActivityFromOpeningTicketPurposeModal.propTypes = {
	    openingTicketPurpose: _react.PropTypes.object.isRequired,
	    activity: _react.PropTypes.object.isRequired
	};
	
	
	DissociateActivityFromOpeningTicketPurposeModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        providerContactStream: state.provider.contact.stream,
	        company: state.company.company
	    };
	})(DissociateActivityFromOpeningTicketPurposeModal);
	
	exports.default = DissociateActivityFromOpeningTicketPurposeModal;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(113);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _EnableDisableOpeningTicketPurposeModal = __webpack_require__(2298);
	
	var _EnableDisableOpeningTicketPurposeModal2 = _interopRequireDefault(_EnableDisableOpeningTicketPurposeModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EnableDisableOpeningTicketPurposeModal = function (_Component) {
	    _inherits(EnableDisableOpeningTicketPurposeModal, _Component);
	
	    function EnableDisableOpeningTicketPurposeModal() {
	        _classCallCheck(this, EnableDisableOpeningTicketPurposeModal);
	
	        return _possibleConstructorReturn(this, (EnableDisableOpeningTicketPurposeModal.__proto__ || Object.getPrototypeOf(EnableDisableOpeningTicketPurposeModal)).apply(this, arguments));
	    }
	
	    _createClass(EnableDisableOpeningTicketPurposeModal, [{
	        key: '_sendEnableAction',
	        value: function _sendEnableAction() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                openingTicketPurpose = _props.openingTicketPurpose,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendEnableOpeningTicketPurposeAction)(openingTicketPurpose.uid)).then(function () {
	                return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_sendDisableAction',
	        value: function _sendDisableAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                openingTicketPurpose = _props2.openingTicketPurpose,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendDisableOpeningTicketPurposeAction)(openingTicketPurpose.uid)).then(function () {
	                return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                openingTicketPurpose = _props3.openingTicketPurpose,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'openingTicketPurpose', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        openingTicketPurpose.disabled && _i18n2.default.enable || _i18n2.default.disable
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _EnableDisableOpeningTicketPurposeModal2.default.text },
	                        openingTicketPurpose.enabled && _i18n2.default.disableOpeningTicketPurposeText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, openingTicketPurpose)
	                            );
	                        }),
	                        !openingTicketPurpose.enabled && _i18n2.default.enableOpeningTicketPurposeText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, openingTicketPurpose)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return openingTicketPurpose.enabled && _this2._sendDisableAction() || _this2._sendEnableAction();
	                                } },
	                            openingTicketPurpose.enabled && _i18n2.default.disable || _i18n2.default.enable
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EnableDisableOpeningTicketPurposeModal;
	}(_react.Component);
	
	EnableDisableOpeningTicketPurposeModal.propTypes = {
	    openingTicketPurpose: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	EnableDisableOpeningTicketPurposeModal = (0, _reactRedux.connect)(function (state) {
	    return {};
	})(EnableDisableOpeningTicketPurposeModal);
	
	exports.default = EnableDisableOpeningTicketPurposeModal;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _matcher = __webpack_require__(958);
	
	var _matcher2 = _interopRequireDefault(_matcher);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconCateg = __webpack_require__(530);
	
	var _IconCateg2 = _interopRequireDefault(_IconCateg);
	
	var _models = __webpack_require__(269);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateOpeningTicketPurposePanel = __webpack_require__(1471);
	
	var _UpdateOpeningTicketPurposePanel2 = _interopRequireDefault(_UpdateOpeningTicketPurposePanel);
	
	var _CreateOpeningTicketPurposePanel = __webpack_require__(1465);
	
	var _CreateOpeningTicketPurposePanel2 = _interopRequireDefault(_CreateOpeningTicketPurposePanel);
	
	var _CreateUpdateTagModal = __webpack_require__(1467);
	
	var _CreateUpdateTagModal2 = _interopRequireDefault(_CreateUpdateTagModal);
	
	var _CreateUpdateCategoryModal = __webpack_require__(1466);
	
	var _CreateUpdateCategoryModal2 = _interopRequireDefault(_CreateUpdateCategoryModal);
	
	var _AssociateActivityWithOpeningTicketPurposeModal = __webpack_require__(1464);
	
	var _AssociateActivityWithOpeningTicketPurposeModal2 = _interopRequireDefault(_AssociateActivityWithOpeningTicketPurposeModal);
	
	var _DissociateActivityFromOpeningTicketPurposeModal = __webpack_require__(1468);
	
	var _DissociateActivityFromOpeningTicketPurposeModal2 = _interopRequireDefault(_DissociateActivityFromOpeningTicketPurposeModal);
	
	var _EnableDisableOpeningTicketPurposeModal = __webpack_require__(1469);
	
	var _EnableDisableOpeningTicketPurposeModal2 = _interopRequireDefault(_EnableDisableOpeningTicketPurposeModal);
	
	var _OpeningTicketPurposePanelGroup = __webpack_require__(2299);
	
	var _OpeningTicketPurposePanelGroup2 = _interopRequireDefault(_OpeningTicketPurposePanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalDeferred = function ModalDeferred(openResult) {
	    var _this = this;
	
	    _classCallCheck(this, ModalDeferred);
	
	    var expectedCloseResult;
	    switch (openResult) {
	        case 'CreateCategory':
	            expectedCloseResult = 'CategoryCreated';
	            break;
	        case 'CreateTag':
	            expectedCloseResult = 'TagCreated';
	            break;
	    }
	
	    this.promise = new Promise(function (resolve, reject) {
	
	        _this.resolve = function (closeResult, value) {
	            if (expectedCloseResult == closeResult) {
	                resolve(value);
	            }
	        };
	    });
	};
	
	function modalName(result) {
	    switch (result) {
	        case 'CreateCategory':
	            return 'CreateUpdateCategoryModal';
	        case 'CreateTag':
	            return 'CreateUpdateTagModal';
	        case 'AssociateActivityWithOpeningTicketPurpose':
	            return 'AssociateActivityWithOpeningTicketPurposeModal';
	        case 'DissociateActivityFromOpeningTicketPurpose':
	            return 'DissociateActivityFromOpeningTicketPurposeModal';
	        case 'EnableDisableOpeningTicketPurpose':
	            return 'EnableDisableOpeningTicketPurposeModal';
	        default:
	            return null;
	    }
	}
	
	function activeValues(result, value) {
	    switch (result) {
	        case 'CreateCategory':
	            return { activeCategory: value };
	        case 'CreateTag':
	            return { activeTag: value };
	        case 'AssociateActivityWithOpeningTicketPurpose':
	            return { activeOpeningTicketPurpose: value };
	        case 'DissociateActivityFromOpeningTicketPurpose':
	            return { activeOpeningTicketPurpose: value.openingTicketPurpose, activeActivity: value.activity };
	        case 'EnableDisableOpeningTicketPurpose':
	            return { activeOpeningTicketPurpose: value };
	        default:
	            return null;
	    }
	}
	
	function openingTicketPurposeFilter(categories, tags) {
	    return function (openingTicketPurpose) {
	        for (var i = 0; i < tags.length; i++) {
	            if (!openingTicketPurpose.tags.find(function (t) {
	                return t.uid == tags[i].uid;
	            })) return false;
	        }
	        for (var i = 0; i < categories.length; i++) {
	            if (openingTicketPurpose.categories.find(function (c) {
	                return c.uid == categories[i].uid;
	            })) return true;
	        }
	        return categories.length == 0 && true || false;
	    };
	}
	
	function openingTicketPurposeSorter(reference) {
	    return function (a, b) {
	        if (reference.default.openingTicketPurpose.uid == a.uid) return 1;
	        if (reference.default.openingTicketPurpose.uid == b.uid) return -1;
	        return a.label.localeCompare(b.label);
	    };
	}
	
	function tagAggregator(reference, tags) {
	    return function (result, openingTicketPurpose) {
	        openingTicketPurpose.tags.forEach(function (tag) {
	            var aggrega = result.find(function (a) {
	                return a.tag.uid == tag.uid;
	            });
	            if (aggrega) {
	                aggrega.count++;
	                return;
	            }
	
	            var tagz = tags.find(function (t) {
	                return t.uid == tag.uid;
	            });
	            if (tagz) {
	                return;
	            }
	
	            tagz = reference.tags.find(function (t) {
	                return t.uid == tag.uid;
	            });
	            if (!tagz) {
	                console && console.warn('tag "' + tag.uid + '" doesn\'t exist in referentiel');
	                return;
	            }
	
	            aggrega = {
	                tag: tagz,
	                count: 1
	            };
	            result.push(aggrega);
	        });
	        return result;
	    };
	}
	
	function categoryAggregator(reference, parentCategory) {
	    return function (result, openingTicketPurpose) {
	        openingTicketPurpose.categories.forEach(function (category) {
	            var categoryz = reference.categories.find(function (c) {
	                return c.uid == category.uid;
	            });
	            if (!categoryz) {
	                console && console.warn('category "' + category.uid + '" doesn\'t exist in referentiel');
	                return;
	            }
	
	            var categoryPath = _models.OpeningTicketPurposeRef.expendParentCategories(reference, categoryz);
	            var ancestorCategory = _models.OpeningTicketPurposeRef.truncCategoryPath(categoryPath, parentCategory)[0];
	
	            if (!ancestorCategory) {
	                return;
	            }
	
	            var aggrega = result.find(function (a) {
	                return a.category.uid == ancestorCategory.uid;
	            });
	            if (aggrega) {
	                return;
	            }
	
	            aggrega = {
	                category: ancestorCategory
	            };
	
	            result.push(aggrega);
	        });
	        return result;
	    };
	}
	
	function defaultTagAggregation(reference, tags) {
	    var defaultTag = reference.default.tag;
	
	    if (!tags.find(function (t) {
	        return t.uid == defaultTag.uid;
	    })) {
	        return [{
	            tag: defaultTag,
	            count: 1000
	        }];
	    }
	    return [];
	}
	
	function defaultTagCriteria(reference, tags) {
	    var defaultTag = reference.default.tag;
	
	    if (tags.find(function (t) {
	        return t.uid == defaultTag.uid;
	    })) {
	        return {
	            tags: [defaultTag],
	            category: null
	        };
	    }
	    return { tags: tags };
	}
	
	function categoryOrTagMatcher(categoryOrTags) {
	    return (0, _matcher2.default)({
	        source: categoryOrTags,
	        identify: function identify(cot) {
	            return cot.label;
	        }
	    });
	}
	
	var OpeningTicketPurposePanelGroup = function (_Component) {
	    _inherits(OpeningTicketPurposePanelGroup, _Component);
	
	    function OpeningTicketPurposePanelGroup(props) {
	        _classCallCheck(this, OpeningTicketPurposePanelGroup);
	
	        var _this2 = _possibleConstructorReturn(this, (OpeningTicketPurposePanelGroup.__proto__ || Object.getPrototypeOf(OpeningTicketPurposePanelGroup)).call(this, props));
	
	        _this2.state = {
	            criteria: {
	                tags: []
	            }
	        };
	        return _this2;
	    }
	
	    _createClass(OpeningTicketPurposePanelGroup, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this3 = this;
	
	            var openingTicketPurposeReference = this.props.openingTicketPurposeReference;
	            var criteria = this.state.criteria;
	
	
	            var openingTicketPurposes = [].concat(_toConsumableArray(openingTicketPurposeReference.openingTicketPurposes), [openingTicketPurposeReference.default.openingTicketPurpose]);
	            var filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(_models.OpeningTicketPurposeRef.expendChildrenCategories(openingTicketPurposeReference, criteria.category), criteria.tags));
	            var sortedOpeningTicketPurposes = filteredOpeningTicketPurposes.sort(openingTicketPurposeSorter(openingTicketPurposeReference));
	            var tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(openingTicketPurposeReference, criteria.tags), defaultTagAggregation(openingTicketPurposeReference, criteria.tags));
	            var filteredTags = tagAggregation.sort(function (a, b) {
	                return b.count - a.count;
	            }).map(function (a) {
	                return a.tag;
	            });
	            var filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(openingTicketPurposeReference, criteria.category), []).map(function (a) {
	                return a.category;
	            });
	            var categorySource = categoryOrTagMatcher(filteredCategories);
	            var tagSource = categoryOrTagMatcher(filteredTags);
	
	            categorySource(null, function (categoryMatches) {
	                tagSource(null, function (tagMatches) {
	                    _this3.setState({ sortedOpeningTicketPurposes: sortedOpeningTicketPurposes, categorySource: categorySource, tagSource: tagSource, categoryMatches: categoryMatches, tagMatches: tagMatches });
	                });
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this4 = this;
	
	            if (nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference) {
	                var openingTicketPurposeReference = nextProps.openingTicketPurposeReference;
	                var _state = this.state,
	                    criteria = _state.criteria,
	                    activeOpeningTicketPurpose = _state.activeOpeningTicketPurpose;
	
	
	                var nextActiveOpeningTicketPurpose = activeOpeningTicketPurpose && openingTicketPurposeReference.openingTicketPurposes.find(function (otp) {
	                    return otp.uid == activeOpeningTicketPurpose.uid;
	                });
	
	                var openingTicketPurposes = [].concat(_toConsumableArray(openingTicketPurposeReference.openingTicketPurposes), [openingTicketPurposeReference.default.openingTicketPurpose]);
	                var filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(_models.OpeningTicketPurposeRef.expendChildrenCategories(openingTicketPurposeReference, criteria.category), criteria.tags));
	                var sortedOpeningTicketPurposes = filteredOpeningTicketPurposes.sort(openingTicketPurposeSorter(openingTicketPurposeReference));
	                var tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(openingTicketPurposeReference, criteria.tags), defaultTagAggregation(openingTicketPurposeReference, criteria.tags));
	                var filteredTags = tagAggregation.sort(function (a, b) {
	                    return b.count - a.count;
	                }).map(function (a) {
	                    return a.tag;
	                });
	                var filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(openingTicketPurposeReference, criteria.category), []).map(function (a) {
	                    return a.category;
	                });
	                var categorySource = categoryOrTagMatcher(filteredCategories);
	                var tagSource = categoryOrTagMatcher(filteredTags);
	                var query = null;
	
	                categorySource(query, function (categoryMatches) {
	                    tagSource(query, function (tagMatches) {
	                        _this4.setState({ sortedOpeningTicketPurposes: sortedOpeningTicketPurposes, categorySource: categorySource, tagSource: tagSource, query: query, categoryMatches: categoryMatches, tagMatches: tagMatches, activeOpeningTicketPurpose: nextActiveOpeningTicketPurpose });
	                    });
	                });
	            }
	        }
	    }, {
	        key: '_filter',
	        value: function _filter(criteriaUpdate) {
	            var _this5 = this;
	
	            var openingTicketPurposeReference = this.props.openingTicketPurposeReference;
	            var criteria = this.state.criteria;
	
	
	            var nextCriteria = _extends({}, criteria, criteriaUpdate);
	
	            var openingTicketPurposes = [].concat(_toConsumableArray(openingTicketPurposeReference.openingTicketPurposes), [openingTicketPurposeReference.default.openingTicketPurpose]);
	            var filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(_models.OpeningTicketPurposeRef.expendChildrenCategories(openingTicketPurposeReference, nextCriteria.category), nextCriteria.tags));
	            var sortedOpeningTicketPurposes = filteredOpeningTicketPurposes.sort(openingTicketPurposeSorter(openingTicketPurposeReference));
	            var tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(openingTicketPurposeReference, nextCriteria.tags), defaultTagAggregation(openingTicketPurposeReference, nextCriteria.tags));
	            var filteredTags = tagAggregation.sort(function (a, b) {
	                return b.count - a.count;
	            }).map(function (a) {
	                return a.tag;
	            });
	            var filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(openingTicketPurposeReference, nextCriteria.category), []).map(function (a) {
	                return a.category;
	            });
	            var categorySource = categoryOrTagMatcher(filteredCategories);
	            var tagSource = categoryOrTagMatcher(filteredTags);
	            var query = null;
	
	            categorySource(query, function (categoryMatches) {
	                tagSource(query, function (tagMatches) {
	                    _this5.setState({ sortedOpeningTicketPurposes: sortedOpeningTicketPurposes, categorySource: categorySource, tagSource: tagSource, query: query, categoryMatches: categoryMatches, tagMatches: tagMatches, criteria: nextCriteria });
	                });
	            });
	        }
	    }, {
	        key: '_match',
	        value: function _match(event) {
	            var _this6 = this;
	
	            var _state2 = this.state,
	                categorySource = _state2.categorySource,
	                tagSource = _state2.tagSource;
	
	            var query = event.target.value || null;
	
	            categorySource(query, function (categoryMatches) {
	                tagSource(query, function (tagMatches) {
	                    _this6.setState({ query: query, categoryMatches: categoryMatches, tagMatches: tagMatches });
	                });
	            });
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(event) {
	            var _this7 = this;
	
	            var _state3 = this.state,
	                categorySource = _state3.categorySource,
	                tagSource = _state3.tagSource;
	
	            var query = null;
	
	            event.preventDefault();
	
	            categorySource(query, function (categoryMatches) {
	                tagSource(query, function (tagMatches) {
	                    _this7.setState({ query: query, categoryMatches: categoryMatches, tagMatches: tagMatches });
	                });
	            });
	        }
	    }, {
	        key: '_openPanel',
	        value: function _openPanel(key) {
	            var activeKey = this.state.activeKey;
	
	
	            var nextActiveKey = activeKey != key && key || null;
	            this.setState({ activeKey: nextActiveKey });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, result, value) {
	            event.preventDefault();
	
	            var openedModal = modalName(result);
	
	            var _activeValues = activeValues(result, value),
	                activeCategory = _activeValues.activeCategory,
	                activeTag = _activeValues.activeTag,
	                activeOpeningTicketPurpose = _activeValues.activeOpeningTicketPurpose,
	                activeActivity = _activeValues.activeActivity;
	
	            this._openedModalDeferred = new ModalDeferred(result);
	            this.setState({ openedModal: openedModal, activeCategory: activeCategory, activeTag: activeTag, activeOpeningTicketPurpose: activeOpeningTicketPurpose, activeActivity: activeActivity });
	
	            return this._openedModalDeferred.promise;
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal(event, result, value) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            if (this._openedModalDeferred) {
	                this._openedModalDeferred.resolve(result, value);
	                this._openedModalDeferred = null;
	            }
	
	            this.setState({
	                openedModal: null,
	                activeCategory: null,
	                activeTag: null,
	                activeOpeningTicketPurpose: null,
	                activeActivity: null
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var _props = this.props,
	                openingTicketPurposeReference = _props.openingTicketPurposeReference,
	                activityReference = _props.activityReference;
	            var _state4 = this.state,
	                sortedOpeningTicketPurposes = _state4.sortedOpeningTicketPurposes,
	                query = _state4.query,
	                categoryMatches = _state4.categoryMatches,
	                tagMatches = _state4.tagMatches,
	                criteria = _state4.criteria,
	                activeKey = _state4.activeKey,
	                openedModal = _state4.openedModal,
	                activeCategory = _state4.activeCategory,
	                activeTag = _state4.activeTag,
	                activeOpeningTicketPurpose = _state4.activeOpeningTicketPurpose,
	                activeActivity = _state4.activeActivity;
	
	
	            var displayCategory = function displayCategory(category, active, path) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _OpeningTicketPurposePanelGroup2.default.category },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: category.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        category.label
	                    ),
	                    path && _react2.default.createElement(
	                        'small',
	                        null,
	                        '>'
	                    )
	                );
	            };
	
	            var displayTag = function displayTag(tag, active) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _OpeningTicketPurposePanelGroup2.default.tag },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: tag.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        tag.label
	                    )
	                );
	            };
	
	            var inputButton = query && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    onClick: function onClick(e) {
	                        return _this8._clear(e);
	                    } },
	                _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	            );
	
	            var inputAddon = !query && _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' });
	
	            var categoryPathField = function categoryPathField() {
	                var value = _models.OpeningTicketPurposeRef.expendParentCategories(openingTicketPurposeReference, criteria.category);
	
	                var onChange = function onChange(categories) {
	                    var category = _models.OpeningTicketPurposeRef.getLeafCategory(categories);
	                    _this8._filter({ category: category });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpeningTicketPurposePanelGroup2.default.main },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _OpeningTicketPurposePanelGroup2.default.categoryTagSection },
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    _extends({ multi: true,
	                                        identify: function identify(c) {
	                                            return c.uid;
	                                        }
	                                    }, categoryPathField()),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: (0, _classnames2.default)(_OpeningTicketPurposePanelGroup2.default.categoryTagGroup, _OpeningTicketPurposePanelGroup2.default.categoryGroup) },
	                                        _models.OpeningTicketPurposeRef.expendParentCategories(openingTicketPurposeReference, criteria.category).map(function (category, index, array) {
	                                            return _react2.default.createElement(
	                                                'li',
	                                                { key: category.uid },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        bsStyle: 'link',
	                                                        value: category,
	                                                        disabled: index < array.length - 1 },
	                                                    displayCategory(category, index == array.length - 1, true)
	                                                )
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    { multi: true,
	                                        identify: function identify(t) {
	                                            return t.uid;
	                                        },
	                                        value: criteria.tags,
	                                        onChange: function onChange(tags) {
	                                            return _this8._filter({ tags: tags });
	                                        } },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: _OpeningTicketPurposePanelGroup2.default.categoryTagGroup },
	                                        criteria.tags.map(function (tag) {
	                                            return _react2.default.createElement(
	                                                'li',
	                                                { key: tag.uid },
	                                                _react2.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        bsStyle: 'link',
	                                                        value: tag },
	                                                    displayTag(tag, true)
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.PanelGroup,
	                                { accordion: true,
	                                    activeKey: activeKey,
	                                    onSelect: function onSelect(k) {
	                                        return _this8._openPanel(k);
	                                    } },
	                                sortedOpeningTicketPurposes.map(function (openingTicketPurpose) {
	                                    return _react2.default.createElement(_UpdateOpeningTicketPurposePanel2.default, {
	                                        key: openingTicketPurpose.uid,
	                                        eventKey: openingTicketPurpose.uid,
	                                        bsStyle: _models.OpeningTicketPurposeRef.isDefaultOpeningTicketPurpose(openingTicketPurposeReference, openingTicketPurpose) && 'info',
	                                        openingTicketPurposeReference: openingTicketPurposeReference,
	                                        activityReference: activityReference,
	                                        openingTicketPurpose: openingTicketPurpose,
	                                        onSubmit: function onSubmit(e, r, cot) {
	                                            return _this8._openModal(e, r, cot);
	                                        } });
	                                }),
	                                activeKey == 'new' && _react2.default.createElement(_CreateOpeningTicketPurposePanel2.default, {
	                                    eventKey: 'new',
	                                    reference: openingTicketPurposeReference,
	                                    onSubmit: function onSubmit(e, r, cot) {
	                                        return _this8._openModal(e, r, cot);
	                                    } })
	                            ),
	                            activeKey != 'new' && _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'primary',
	                                        bsSize: 'large',
	                                        onClick: function onClick() {
	                                            return _this8._openPanel('new');
	                                        } },
	                                    _i18n2.default.newOpeningTicketPurpose
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpeningTicketPurposePanelGroup2.default.side },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                sortedOpeningTicketPurposes.length,
	                                ' ',
	                                _i18n2.default.openingTicketPurposes
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Input, {
	                                type: 'text',
	                                buttonAfter: inputButton,
	                                addonAfter: inputAddon,
	                                placeholder: _i18n2.default.searchOpeningTicketPurpose,
	                                value: query,
	                                onChange: function onChange(e) {
	                                    return _this8._match(e);
	                                } }),
	                            _react2.default.createElement(
	                                _ButtonToggle2.default,
	                                {
	                                    identify: function identify(c) {
	                                        return c.uid;
	                                    },
	                                    value: criteria.category,
	                                    onChange: function onChange(category) {
	                                        return _this8._filter({ category: category });
	                                    } },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: (0, _classnames2.default)(_OpeningTicketPurposePanelGroup2.default.categoryTagGroup, _OpeningTicketPurposePanelGroup2.default.categoryGroup) },
	                                    categoryMatches.map(function (category) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: category.uid },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'link',
	                                                    value: category },
	                                                displayCategory(category)
	                                            )
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _ButtonToggle2.default,
	                                { multi: true,
	                                    identify: function identify(t) {
	                                        return t.uid;
	                                    },
	                                    value: criteria.tags,
	                                    onChange: function onChange(ts) {
	                                        return _this8._filter(defaultTagCriteria(openingTicketPurposeReference, ts));
	                                    } },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: _OpeningTicketPurposePanelGroup2.default.categoryTagGroup },
	                                    tagMatches.map(function (tag) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: tag.uid },
	                                            _react2.default.createElement(
	                                                _reactBootstrap.Button,
	                                                {
	                                                    bsStyle: 'link',
	                                                    value: tag },
	                                                displayTag(tag)
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_CreateUpdateTagModal2.default, {
	                    tag: activeTag,
	                    show: openedModal == 'CreateUpdateTagModal',
	                    onHide: function onHide(e, r, t) {
	                        return _this8._closeModal(e, r, t);
	                    } }),
	                _react2.default.createElement(_CreateUpdateCategoryModal2.default, {
	                    category: activeCategory,
	                    show: openedModal == 'CreateUpdateCategoryModal',
	                    onHide: function onHide(e, r, c) {
	                        return _this8._closeModal(e, r, c);
	                    } }),
	                activeOpeningTicketPurpose && _react2.default.createElement(_AssociateActivityWithOpeningTicketPurposeModal2.default, {
	                    openingTicketPurpose: activeOpeningTicketPurpose,
	                    show: openedModal == 'AssociateActivityWithOpeningTicketPurposeModal',
	                    onHide: function onHide(e) {
	                        return _this8._closeModal(e);
	                    } }),
	                activeOpeningTicketPurpose && activeActivity && _react2.default.createElement(_DissociateActivityFromOpeningTicketPurposeModal2.default, {
	                    openingTicketPurpose: activeOpeningTicketPurpose,
	                    activity: activeActivity,
	                    show: openedModal == 'DissociateActivityFromOpeningTicketPurposeModal',
	                    onHide: function onHide(e) {
	                        return _this8._closeModal(e);
	                    } }),
	                activeOpeningTicketPurpose && _react2.default.createElement(_EnableDisableOpeningTicketPurposeModal2.default, {
	                    openingTicketPurpose: activeOpeningTicketPurpose,
	                    show: openedModal == 'EnableDisableOpeningTicketPurposeModal',
	                    onHide: function onHide(e) {
	                        return _this8._closeModal(e);
	                    } })
	            );
	        }
	    }]);
	
	    return OpeningTicketPurposePanelGroup;
	}(_react.Component);
	
	OpeningTicketPurposePanelGroup.propTypes = {};
	
	
	OpeningTicketPurposePanelGroup = (0, _reactRedux.connect)(function (state) {
	    return {
	        openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
	        activityReference: state.reference.activityRef
	    };
	})(OpeningTicketPurposePanelGroup);
	
	exports.default = OpeningTicketPurposePanelGroup;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _TypeaheadGridInput = __webpack_require__(893);
	
	var _TypeaheadGridInput2 = _interopRequireDefault(_TypeaheadGridInput);
	
	var _TagBar = __webpack_require__(956);
	
	var _TagBar2 = _interopRequireDefault(_TagBar);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconCateg = __webpack_require__(530);
	
	var _IconCateg2 = _interopRequireDefault(_IconCateg);
	
	var _actions = __webpack_require__(113);
	
	var _models = __webpack_require__(269);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateOpeningTicketPurposePanel = __webpack_require__(2301);
	
	var _UpdateOpeningTicketPurposePanel2 = _interopRequireDefault(_UpdateOpeningTicketPurposePanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function childrenCategoryFilter(parentCategory) {
	    return function (category) {
	        return (category.parent && category.parent.uid) == (parentCategory && parentCategory.uid);
	    };
	}
	
	function categoryAggregator(reference) {
	    return function (result, category) {
	        var resultCategory = reference.categories.find(function (c) {
	            return c.uid == category.uid;
	        });
	
	        if (resultCategory) {
	            result.push(resultCategory);
	        } else {
	            console && console.warn('category "' + category.uid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	function tagAggregator(reference) {
	    var defaultTag = reference.default.tag;
	
	    return function (result, tag) {
	        if (defaultTag.uid == tag.uid) {
	            result.push(defaultTag);
	            return result;
	        }
	
	        var resultTag = reference.tags.find(function (t) {
	            return t.uid == tag.uid;
	        });
	
	        if (resultTag) {
	            result.push(resultTag);
	        } else {
	            console && console.warn('tag "' + tag.uid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	function activityAggregator(reference) {
	    return function (result, activity) {
	        var resultActivity = reference.find(function (a) {
	            return a.uid == activity.uid;
	        });
	
	        if (resultActivity) {
	            result.push(resultActivity);
	        } else {
	            console && console.warn('activity "' + activity.uid + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	function onPathFinder(reference, nodeCategory) {
	    return function (category) {
	        var categoryPath = _models.OpeningTicketPurposeRef.expendParentCategories(reference, category);
	        return !!categoryPath.find(function (c) {
	            return c.uid == nodeCategory.uid;
	        });
	    };
	}
	
	function categoryTagMatcher(categoriesOrTags) {
	    return (0, _TypeaheadGridInput.matcher)({
	        source: categoriesOrTags,
	        identify: function identify(cot) {
	            return cot.label;
	        }
	    });
	}
	
	function openingTicketPurposeActionUpdate(openingTicketPurpose) {
	    return {
	        uid: openingTicketPurpose.uid || null,
	        label: openingTicketPurpose.label || null,
	        extId: openingTicketPurpose.extId || null
	    };
	}
	
	var UpdateOpeningTicketPurposePanel = function (_Component) {
	    _inherits(UpdateOpeningTicketPurposePanel, _Component);
	
	    function UpdateOpeningTicketPurposePanel(props) {
	        _classCallCheck(this, UpdateOpeningTicketPurposePanel);
	
	        var _this = _possibleConstructorReturn(this, (UpdateOpeningTicketPurposePanel.__proto__ || Object.getPrototypeOf(UpdateOpeningTicketPurposePanel)).call(this, props));
	
	        _this._categoryTagBars = [];
	        _this._categoryTypeaheadGridInputs = [];
	
	        _this.state = {
	            openingTicketPurposeCategories: [],
	            openingTicketPurposeTags: [],
	            openingTicketPurposeActivities: [],
	            transientCategories: []
	        };
	        return _this;
	    }
	
	    _createClass(UpdateOpeningTicketPurposePanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                expanded = _props.expanded,
	                openingTicketPurpose = _props.openingTicketPurpose,
	                openingTicketPurposeReference = _props.openingTicketPurposeReference,
	                activityReference = _props.activityReference;
	            var transientCategories = this.state.transientCategories;
	
	
	            if (expanded) {
	                var update = openingTicketPurposeActionUpdate(openingTicketPurpose);
	                dispatch((0, _actions.updateUpdateOpeningTicketPurposeAction)(update));
	
	                var openingTicketPurposeCategories = openingTicketPurpose.categories.reduce(categoryAggregator(openingTicketPurposeReference), []);
	                var openingTicketPurposeTags = openingTicketPurpose.tags.reduce(tagAggregator(openingTicketPurposeReference), []);
	                var openingTicketPurposeActivities = openingTicketPurpose.activities.reduce(activityAggregator(activityReference), []);
	                this.setState({ openingTicketPurposeCategories: openingTicketPurposeCategories, openingTicketPurposeTags: openingTicketPurposeTags, openingTicketPurposeActivities: openingTicketPurposeActivities });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.expanded != this.props.expanded || nextProps.openingTicketPurpose != this.props.openingTicketPurpose) {
	                var dispatch = nextProps.dispatch,
	                    expanded = nextProps.expanded,
	                    openingTicketPurpose = nextProps.openingTicketPurpose,
	                    openingTicketPurposeReference = nextProps.openingTicketPurposeReference,
	                    activityReference = nextProps.activityReference;
	                var transientCategories = this.state.transientCategories;
	
	
	                if (expanded) {
	                    var update = openingTicketPurposeActionUpdate(openingTicketPurpose);
	                    dispatch((0, _actions.updateUpdateOpeningTicketPurposeAction)(update));
	
	                    var openingTicketPurposeCategories = openingTicketPurpose.categories.reduce(categoryAggregator(openingTicketPurposeReference), []);
	                    var openingTicketPurposeTags = openingTicketPurpose.tags.reduce(tagAggregator(openingTicketPurposeReference), []);
	                    var openingTicketPurposeActivities = openingTicketPurpose.activities.reduce(activityAggregator(activityReference), []);
	                    this.setState({ openingTicketPurposeCategories: openingTicketPurposeCategories, openingTicketPurposeTags: openingTicketPurposeTags, openingTicketPurposeActivities: openingTicketPurposeActivities });
	                }
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction(event) {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendUpdateOpeningTicketPurposeAction)()).then(function () {
	                return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	            });
	        }
	    }, {
	        key: '_sendAddRemoveTagFromOpeningTicketPurposeAction',
	        value: function _sendAddRemoveTagFromOpeningTicketPurposeAction(action, tag) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                openingTicketPurpose = _props2.openingTicketPurpose;
	
	
	            switch (action) {
	                case 'Add':
	                    return dispatch((0, _actions.sendAddTagToOpeningTicketPurposeAction)(openingTicketPurpose.uid, tag.uid)).then(function () {
	                        return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	                    });
	                case 'Remove':
	                    return dispatch((0, _actions.sendRemoveTagFromOpeningTicketPurposeAction)(openingTicketPurpose.uid, tag.uid)).then(function () {
	                        return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	                    });
	            }
	        }
	    }, {
	        key: '_sendAddRemoveCategoryFromOpeningTicketPurposeAction',
	        value: function _sendAddRemoveCategoryFromOpeningTicketPurposeAction(action, category) {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                openingTicketPurpose = _props3.openingTicketPurpose;
	
	
	            switch (action) {
	                case 'Add':
	                    return dispatch((0, _actions.sendAddCategoryToOpeningTicketPurposeAction)(openingTicketPurpose.uid, category.uid)).then(function () {
	                        return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	                    });
	                case 'Remove':
	                    return dispatch((0, _actions.sendRemoveCategoryFromOpeningTicketPurposeAction)(openingTicketPurpose.uid, category.uid)).then(function () {
	                        return dispatch((0, _actions.loadOpeningTicketPurposeRef)());
	                    });
	            }
	        }
	    }, {
	        key: '_submitCreateCategory',
	        value: function _submitCreateCategory(event, parentCategory, index) {
	            var _this2 = this;
	
	            var onSubmit = this.props.onSubmit;
	
	
	            var category = {
	                label: this._categoryTypeaheadGridInputs[index].getQuery(),
	                parent: parentCategory
	            };
	
	            onSubmit(event, 'CreateCategory', category).then(function (category) {
	                _this2._sendAddRemoveCategoryFromOpeningTicketPurposeAction('Add', category);
	            });
	        }
	    }, {
	        key: '_submitCreateTag',
	        value: function _submitCreateTag(event) {
	            var _this3 = this;
	
	            var onSubmit = this.props.onSubmit;
	
	
	            var tag = {
	                label: this._tagTypeaheadGridInput.getQuery()
	            };
	
	            onSubmit(event, 'CreateTag', tag).then(function (tag) {
	                _this3._sendAddRemoveTagFromOpeningTicketPurposeAction('Add', tag);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                action = _props4.action,
	                openingTicketPurpose = _props4.openingTicketPurpose,
	                openingTicketPurposeReference = _props4.openingTicketPurposeReference,
	                activityReference = _props4.activityReference,
	                onSubmit = _props4.onSubmit,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'action', 'openingTicketPurpose', 'openingTicketPurposeReference', 'activityReference', 'onSubmit']);
	
	            var _state = this.state,
	                openingTicketPurposeCategories = _state.openingTicketPurposeCategories,
	                openingTicketPurposeTags = _state.openingTicketPurposeTags,
	                openingTicketPurposeActivities = _state.openingTicketPurposeActivities,
	                transientCategories = _state.transientCategories;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var categorySource = function categorySource(category) {
	                return (0, _TypeaheadGridInput.matcher)({
	                    source: openingTicketPurposeReference.categories.filter(childrenCategoryFilter(category)),
	                    identify: function identify(c) {
	                        return c.label;
	                    }
	                });
	            };
	
	            var tagSource = (0, _TypeaheadGridInput.matcher)({
	                source: openingTicketPurposeReference.tags,
	                identify: function identify(t) {
	                    return t.label;
	                }
	            });
	
	            var header = _react2.default.createElement(
	                'h5',
	                { className: _UpdateOpeningTicketPurposePanel2.default.header },
	                !openingTicketPurpose.enabled && _react2.default.createElement(_Icon2.default, { icon: 'closed', size: 'sm' }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    openingTicketPurpose.label
	                )
	            );
	
	            var tooltipInputAddon = function tooltipInputAddon(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(text) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: _UpdateOpeningTicketPurposePanel2.default.info },
	                        '?'
	                    )
	                );
	            };
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            var displayCategory = function displayCategory(category, active, path) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _UpdateOpeningTicketPurposePanel2.default.category },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: category.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        category.label
	                    ),
	                    path && _react2.default.createElement(
	                        'small',
	                        null,
	                        '>'
	                    )
	                );
	            };
	
	            var displayTag = function displayTag(tag, active) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _UpdateOpeningTicketPurposePanel2.default.tag },
	                    _react2.default.createElement(_IconCateg2.default, { iconId: tag.iconId, exponent: active && 'X' }),
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        tag.label
	                    )
	                );
	            };
	
	            var activityElement = function activityElement(activity) {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        key: activity.uid },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return onSubmit(e, 'DissociateActivityFromOpeningTicketPurpose', { openingTicketPurpose: openingTicketPurpose, activity: activity });
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        activity.label
	                    )
	                );
	            };
	
	            var categoryPathField = function categoryPathField(category) {
	                var value = _models.OpeningTicketPurposeRef.expendParentCategories(openingTicketPurposeReference, category);
	
	                var disabled = function disabled(category, index) {
	                    return index < value.length - 1;
	                };
	
	                var onSubmit = function onSubmit(action, category) {
	                    _this4._sendAddRemoveCategoryFromOpeningTicketPurposeAction(action, category);
	                };
	
	                return { value: value, disabled: disabled, onSubmit: onSubmit };
	            };
	
	            var transientCategoryPathField = function transientCategoryPathField(category) {
	                var index = transientCategories.indexOf(category);
	                var value = _models.OpeningTicketPurposeRef.expendParentCategories(openingTicketPurposeReference, category);
	
	                var disabled = function disabled(category, index) {
	                    return index < value.length - 1;
	                };
	
	                var onChange = function onChange(categories) {
	                    var nextCategory = _models.OpeningTicketPurposeRef.getLeafCategory(categories);
	                    var nextTransientCategories = [].concat(_toConsumableArray(transientCategories));
	
	                    if (nextCategory) {
	                        nextTransientCategories[index] = nextCategory;
	                    } else {
	                        nextTransientCategories.splice(index, 1);
	                    }
	
	                    _this4.setState({ transientCategories: nextTransientCategories });
	                };
	
	                return { value: value, disabled: disabled, onChange: onChange };
	            };
	
	            var addRemoveTransientCategory = function addRemoveTransientCategory(next, category) {
	                var index = transientCategories.indexOf(category);
	
	                return function (action, category) {
	                    switch (action) {
	                        case 'Add':
	                            if (openingTicketPurposeCategories.find(onPathFinder(openingTicketPurposeReference, category))) {
	                                var nextTransientCategories = [].concat(_toConsumableArray(transientCategories));
	
	                                if (index < 0) {
	                                    nextTransientCategories.push(category);
	                                } else {
	                                    nextTransientCategories[index] = category;
	                                }
	
	                                _this4.setState({ transientCategories: nextTransientCategories });
	                                return;
	                            }
	
	                            return next(action, category).then(function () {
	                                if (index >= 0) {
	                                    var _nextTransientCategories = [].concat(_toConsumableArray(transientCategories));
	                                    _nextTransientCategories.splice(index, 1);
	
	                                    _this4.setState({ transientCategories: _nextTransientCategories });
	                                }
	                            });
	                        case 'Remove':
	                            return next(action, category);
	                    }
	                };
	            };
	
	            var closeTagTagBar = function closeTagTagBar(next) {
	                return function () {
	                    _this4._tagTagBar.close();
	                    return next.apply(undefined, arguments);
	                };
	            };
	
	            var closeCategoryTagBar = function closeCategoryTagBar(next, index) {
	                return function () {
	                    _this4._categoryTagBars[index] && _this4._categoryTagBars[index].close();
	                    return next.apply(undefined, arguments);
	                };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Panel,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _UpdateOpeningTicketPurposePanel2.default.defaultContent },
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'label',
	                            label: requiredLabel(_i18n2.default.label)
	                        }, form.label())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'reference',
	                            label: _i18n2.default.reference,
	                            addonAfter: tooltipInputAddon(_i18n2.default.referenceInfo)
	                        }, form.extId()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this4._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.categories
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            openingTicketPurposeCategories.slice(0).reverse().map(function (category, index) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    {
	                                        className: _UpdateOpeningTicketPurposePanel2.default.categoryTagSection,
	                                        key: index },
	                                    _react2.default.createElement(
	                                        _TagBar2.default,
	                                        _extends({ multi: true,
	                                            ref: function ref(tb) {
	                                                return _this4._categoryTagBars[index] = tb;
	                                            },
	                                            display: function display(c, i, a) {
	                                                return displayCategory(c, i == a.length - 1, true);
	                                            },
	                                            identify: function identify(c) {
	                                                return c.uid;
	                                            },
	                                            label: _i18n2.default.addChildCategory
	                                        }, categoryPathField(category)),
	                                        _react2.default.createElement(_TypeaheadGridInput2.default, {
	                                            ref: function ref(tgi) {
	                                                return _this4._categoryTypeaheadGridInputs[index] = tgi;
	                                            },
	                                            source: categorySource(category),
	                                            identify: function identify(c) {
	                                                return c.uid;
	                                            },
	                                            display: displayCategory,
	                                            placeholder: _i18n2.default.searchCategory,
	                                            value: category,
	                                            onSubmit: closeCategoryTagBar(function (a, c) {
	                                                return _this4._sendAddRemoveCategoryFromOpeningTicketPurposeAction(a, c);
	                                            }, index) }),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _UpdateOpeningTicketPurposePanel2.default.manage },
	                                            _react2.default.createElement(
	                                                'a',
	                                                {
	                                                    href: '',
	                                                    onClick: closeCategoryTagBar(function (e) {
	                                                        return _this4._submitCreateCategory(e, category, index);
	                                                    }, index) },
	                                                _i18n2.default.newCategory
	                                            )
	                                        )
	                                    )
	                                );
	                            }),
	                            transientCategories.map(function (category, index) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    {
	                                        className: (0, _classnames2.default)(_UpdateOpeningTicketPurposePanel2.default.categoryTagSection, _UpdateOpeningTicketPurposePanel2.default.transient),
	                                        key: index },
	                                    _react2.default.createElement(
	                                        _TagBar2.default,
	                                        _extends({ multi: true,
	                                            ref: function ref(tb) {
	                                                return _this4._categoryTagBars[100 + index] = tb;
	                                            },
	                                            display: function display(c, i, a) {
	                                                return displayCategory(c, i == a.length - 1, true);
	                                            },
	                                            identify: function identify(c) {
	                                                return c.uid;
	                                            },
	                                            label: _i18n2.default.addChildCategory
	                                        }, transientCategoryPathField(category)),
	                                        _react2.default.createElement(_TypeaheadGridInput2.default, {
	                                            ref: function ref(tgi) {
	                                                return _this4._categoryTypeaheadGridInputs[100 + index] = tgi;
	                                            },
	                                            source: categorySource(category),
	                                            identify: function identify(c) {
	                                                return c.uid;
	                                            },
	                                            display: displayCategory,
	                                            placeholder: _i18n2.default.searchCategory,
	                                            value: category,
	                                            onSubmit: closeCategoryTagBar(addRemoveTransientCategory(function (a, c) {
	                                                return _this4._sendAddRemoveCategoryFromOpeningTicketPurposeAction(a, c);
	                                            }, category), 100 + index) }),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: _UpdateOpeningTicketPurposePanel2.default.manage },
	                                            _react2.default.createElement(
	                                                'a',
	                                                {
	                                                    href: '',
	                                                    onClick: closeCategoryTagBar(function (e) {
	                                                        return _this4._submitCreateCategory(e, category, 100 + index);
	                                                    }, 100 + index) },
	                                                _i18n2.default.newCategory
	                                            )
	                                        )
	                                    )
	                                );
	                            }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _UpdateOpeningTicketPurposePanel2.default.categoryTagSection },
	                                _react2.default.createElement(
	                                    _TagBar2.default,
	                                    {
	                                        ref: function ref(tb) {
	                                            return _this4._categoryTagBars[1000] = tb;
	                                        },
	                                        value: null,
	                                        label: _i18n2.default.addCategory },
	                                    _react2.default.createElement(_TypeaheadGridInput2.default, {
	                                        ref: function ref(tgi) {
	                                            return _this4._categoryTypeaheadGridInputs[1000] = tgi;
	                                        },
	                                        source: categorySource(),
	                                        identify: function identify(c) {
	                                            return c.uid;
	                                        },
	                                        display: displayCategory,
	                                        placeholder: _i18n2.default.searchCategory,
	                                        value: null,
	                                        onSubmit: closeCategoryTagBar(addRemoveTransientCategory(function (a, c) {
	                                            return _this4._sendAddRemoveCategoryFromOpeningTicketPurposeAction(a, c);
	                                        }), 1000) }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _UpdateOpeningTicketPurposePanel2.default.manage },
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: closeCategoryTagBar(function (e) {
	                                                    return _this4._submitCreateCategory(e, null, 1000);
	                                                }, 1000) },
	                                            _i18n2.default.newCategory
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 3 },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.tags
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 9 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _UpdateOpeningTicketPurposePanel2.default.categoryTagSection },
	                                _react2.default.createElement(
	                                    _TagBar2.default,
	                                    { multi: true,
	                                        ref: function ref(tb) {
	                                            return _this4._tagTagBar = tb;
	                                        },
	                                        display: function display(t) {
	                                            return displayTag(t, true);
	                                        },
	                                        identify: function identify(t) {
	                                            return t.uid;
	                                        },
	                                        label: _i18n2.default.addTag,
	                                        value: openingTicketPurposeTags,
	                                        onSubmit: function onSubmit(a, t) {
	                                            return _this4._sendAddRemoveTagFromOpeningTicketPurposeAction(a, t);
	                                        } },
	                                    _react2.default.createElement(_TypeaheadGridInput2.default, { multi: true,
	                                        ref: function ref(tgi) {
	                                            return _this4._tagTypeaheadGridInput = tgi;
	                                        },
	                                        source: tagSource,
	                                        identify: function identify(t) {
	                                            return t.uid;
	                                        },
	                                        display: displayTag,
	                                        placeholder: _i18n2.default.searchTag,
	                                        value: openingTicketPurposeTags,
	                                        onSubmit: closeTagTagBar(function (a, t) {
	                                            return _this4._sendAddRemoveTagFromOpeningTicketPurposeAction(a, t);
	                                        }) }),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: _UpdateOpeningTicketPurposePanel2.default.manage },
	                                        _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: closeTagTagBar(function (e) {
	                                                    return _this4._submitCreateTag(e);
	                                                }) },
	                                            _i18n2.default.newTag
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UpdateOpeningTicketPurposePanel2.default.activities },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _UpdateOpeningTicketPurposePanel2.default.action },
	                            _react2.default.createElement(
	                                _reactBootstrap.OverlayTrigger,
	                                {
	                                    placement: 'bottom',
	                                    overlay: tooltip(_i18n2.default.associateActivity) },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        href: '',
	                                        bsStyle: 'link',
	                                        onClick: function onClick(e) {
	                                            return onSubmit(e, 'AssociateActivityWithOpeningTicketPurpose', openingTicketPurpose);
	                                        } },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    openingTicketPurposeActivities.slice(0, openingTicketPurposeActivities.length / 2 + 1).map(activityElement)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    openingTicketPurposeActivities.slice(openingTicketPurposeActivities.length / 2 + 1, openingTicketPurposeActivities.length).map(activityElement)
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _UpdateOpeningTicketPurposePanel2.default.disable },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'EnableDisableOpeningTicketPurpose', openingTicketPurpose);
	                                } },
	                            openingTicketPurpose.enabled && _i18n2.default.disableOpeningTicketPurpose || _i18n2.default.enableOpeningTicketPurpose
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateOpeningTicketPurposePanel;
	}(_react.Component);
	
	UpdateOpeningTicketPurposePanel.propTypes = {
	    openingTicketPurpose: _react.PropTypes.object.isRequired,
	    openingTicketPurposeReference: _react.PropTypes.object.isRequired,
	    activityReference: _react.PropTypes.array.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	UpdateOpeningTicketPurposePanel = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.UpdateOpeningTicketPurposeAction.schema,
	    action: _actions.UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED
	})(UpdateOpeningTicketPurposePanel);
	
	UpdateOpeningTicketPurposePanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        action: state.reference.updateOpeningTicketPurposeAction
	    };
	})(UpdateOpeningTicketPurposePanel);
	
	exports.default = UpdateOpeningTicketPurposePanel;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (error) {
	    return (0, _extract2.default)(_i18n2.default.errorTypeEnum, error.type, null);
	};
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(262);
	
	var _i18n2 = _interopRequireDefault(_i18n);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(113);
	
	function openingTicketPurposeRef() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.OPENING_TICKET_PURPOSE_REF_LOADED:
	        case _actions.OPENING_TICKET_PURPOSE_REF_QUERIED:
	            return action.ref;
	        default:
	            return state;
	    }
	}
	
	function activityRef() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ACTIVITY_REF_LOADED:
	        case _actions.ACTIVITY_REF_QUERIED:
	            return action.ref;
	        default:
	            return state;
	    }
	}
	
	function ticketClaimRef() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_CLAIM_REF_LOADED:
	            return action.ref;
	        default:
	            return state;
	    }
	}
	
	function createOpeningTicketPurposeAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CREATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.CREATE_OPENING_TICKET_PURPOSE_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateOpeningTicketPurposeAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_OPENING_TICKET_PURPOSE_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.UPDATE_OPENING_TICKET_PURPOSE_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function createUpdateTagAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CREATE_UPDATE_TAG_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.CREATE_UPDATE_TAG_ACTION_RESET:
	            return action.action;
	        case _actions.CREATE_UPDATE_TAG_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function createUpdateCategoryAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CREATE_UPDATE_CATEGORY_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.CREATE_UPDATE_CATEGORY_ACTION_RESET:
	            return action.action;
	        case _actions.CREATE_UPDATE_CATEGORY_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function associateActivityWithOpeningTicketPurposeAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.ASSOCIATE_ACTIVITY_WITH_OPENING_TICKET_PURPOSE_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	exports.default = (0, _redux.combineReducers)({
	    openingTicketPurposeRef: openingTicketPurposeRef,
	    activityRef: activityRef,
	    ticketClaimRef: ticketClaimRef,
	    createOpeningTicketPurposeAction: createOpeningTicketPurposeAction,
	    updateOpeningTicketPurposeAction: updateOpeningTicketPurposeAction,
	    createUpdateTagAction: createUpdateTagAction,
	    createUpdateCategoryAction: createUpdateCategoryAction,
	    associateActivityWithOpeningTicketPurposeAction: associateActivityWithOpeningTicketPurposeAction
	});

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(146);
	
	var _models = __webpack_require__(279);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AddRemoveQuestionFromCampaignPopover = __webpack_require__(2302);
	
	var _AddRemoveQuestionFromCampaignPopover2 = _interopRequireDefault(_AddRemoveQuestionFromCampaignPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddRemoveQuestionFromCampaignPopover = function (_Component) {
	    _inherits(AddRemoveQuestionFromCampaignPopover, _Component);
	
	    function AddRemoveQuestionFromCampaignPopover() {
	        _classCallCheck(this, AddRemoveQuestionFromCampaignPopover);
	
	        return _possibleConstructorReturn(this, (AddRemoveQuestionFromCampaignPopover.__proto__ || Object.getPrototypeOf(AddRemoveQuestionFromCampaignPopover)).apply(this, arguments));
	    }
	
	    _createClass(AddRemoveQuestionFromCampaignPopover, [{
	        key: '_sendAddAction',
	        value: function _sendAddAction() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendAddQuestionToCampaignAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            });
	        }
	    }, {
	        key: '_sendRemoveAction',
	        value: function _sendRemoveAction(event, question) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendRemoveQuestionFromCampaignAction)(question.uid)).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                action = _props.action,
	                campaign = _props.campaign,
	                onHide = _props.onHide,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'action', 'campaign', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.question
	                }, others),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _AddRemoveQuestionFromCampaignPopover2.default.questionGroup },
	                    campaign.questions.slice().reverse().map(function (question) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: question.uid },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _AddRemoveQuestionFromCampaignPopover2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return _this2._sendRemoveAction(e, question);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    question.text
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'text',
	                        name: 'label',
	                        placeholder: _i18n2.default.question
	                    }, form.question()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendAddAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.add
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddRemoveQuestionFromCampaignPopover;
	}(_react.Component);
	
	AddRemoveQuestionFromCampaignPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AddRemoveQuestionFromCampaignPopover = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.AddQuestionToCampaignAction.schema,
	    action: _actions.ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED
	})(AddRemoveQuestionFromCampaignPopover);
	
	AddRemoveQuestionFromCampaignPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        campaign: state.satisfaction.campaign.campaign,
	        action: state.satisfaction.addQuestionToCampaignAction
	    };
	})(AddRemoveQuestionFromCampaignPopover);
	
	exports.default = AddRemoveQuestionFromCampaignPopover;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _mathz = __webpack_require__(108);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Rating = __webpack_require__(531);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AnswerCard = __webpack_require__(2303);
	
	var _AnswerCard2 = _interopRequireDefault(_AnswerCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function questionAggregator(question) {
	    return { question: question };
	}
	
	function answerAggregator(result, answer) {
	    var aggrega = result.find(function (a) {
	        return a.question.uid == answer.questionUid;
	    });
	
	    if (aggrega) {
	        aggrega.answer = answer;
	    } else {
	        console && console.warn('Question ' + answer.questionUid + ' doesn\'t exist');
	    }
	    return result;
	}
	
	var AnswerCard = function (_Component) {
	    _inherits(AnswerCard, _Component);
	
	    function AnswerCard(props) {
	        _classCallCheck(this, AnswerCard);
	
	        var _this = _possibleConstructorReturn(this, (AnswerCard.__proto__ || Object.getPrototypeOf(AnswerCard)).call(this, props));
	
	        _this.state = {
	            aggregation: []
	        };
	        return _this;
	    }
	
	    _createClass(AnswerCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                campaign = _props.campaign,
	                answer = _props.answer;
	
	
	            var maxScore = (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                    return s.position;
	                } });
	            var averageScore = (0, _mathz.average)({ source: answer.answers, identify: function identify(a) {
	                    return a.score;
	                }, accuracy: 0.1 });
	            var questionAggregation = campaign.questions.map(questionAggregator).reverse();
	            var aggregation = answer.answers.reduce(answerAggregator, questionAggregation);
	            this.setState({ maxScore: maxScore, averageScore: averageScore, aggregation: aggregation });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.campaign != this.props.campaign || nextProps.answer != this.props.answer) {
	                var campaign = nextProps.campaign,
	                    answer = nextProps.answer;
	
	
	                var maxScore = (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                        return s.position;
	                    } });
	                var averageScore = (0, _mathz.average)({ source: answer.answers, identify: function identify(a) {
	                        return a.score;
	                    }, accuracy: 0.1 });
	                var questionAggregation = campaign.questions.map(questionAggregator).reverse();
	                var aggregation = answer.answers.reduce(answerAggregator, questionAggregation);
	                this.setState({ maxScore: maxScore, averageScore: averageScore, aggregation: aggregation });
	            }
	        }
	    }, {
	        key: '_toggle',
	        value: function _toggle() {
	            var expanded = this.state.expanded;
	
	            this.setState({ expanded: !expanded });
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                campaign = _props2.campaign,
	                answer = _props2.answer,
	                others = _objectWithoutProperties(_props2, ['campaign', 'answer']);
	
	            var _state = this.state,
	                maxScore = _state.maxScore,
	                averageScore = _state.averageScore,
	                aggregation = _state.aggregation,
	                expanded = _state.expanded;
	
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.answer
	            );
	
	            var help = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Ticket'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    {
	                        href: '',
	                        onClick: function onClick(e) {
	                            return _this2._navigate(e, '/tickets/' + answer.ticketUid);
	                        } },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        answer.ticketUid
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    kind: 'tab',
	                    header: header,
	                    help: help,
	                    onClick: function onClick() {
	                        return _this2._toggle();
	                    }
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(_Rating2.default, {
	                            label: _i18n2.default.score,
	                            range: maxScore,
	                            value: averageScore })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _AnswerCard2.default.caller },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    answer.caller.name.firstName
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' ',
	                                    answer.caller.name.lastName
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    answer.caller.name.value
	                                )
	                            )
	                        )
	                    )
	                ),
	                expanded && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _AnswerCard2.default.questionGroup },
	                        aggregation.map(function (aggrega) {
	                            return _react2.default.createElement(
	                                'li',
	                                {
	                                    key: aggrega.question.uid },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    aggrega.question.text
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_Rating2.default, {
	                                            label: _i18n2.default.score,
	                                            range: maxScore,
	                                            value: aggrega.answer.score })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        aggrega.answer.comment && _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            _react2.default.createElement(_Icon2.default, { icon: 'quote', size: 'xs' }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                aggrega.answer.comment
	                                            )
	                                        )
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    answer.comment && _react2.default.createElement(
	                        'div',
	                        { className: _AnswerCard2.default.globalComment },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _i18n2.default.globalComment
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(_reactBootstrap.Col, { sm: 6 }),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(_Icon2.default, { icon: 'quote', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        answer.comment
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AnswerCard;
	}(_react.Component);
	
	AnswerCard.propTypes = {
	    campaign: _react.PropTypes.object.isRequired,
	    answer: _react.PropTypes.object.isRequired
	};
	
	
	AnswerCard = (0, _reactRedux.connect)()(AnswerCard);
	
	exports.default = AnswerCard;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _mathz = __webpack_require__(108);
	
	var _form = __webpack_require__(15);
	
	var _Rating = __webpack_require__(531);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(279);
	
	var _actions = __webpack_require__(146);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AnswerForm = __webpack_require__(2304);
	
	var _AnswerForm2 = _interopRequireDefault(_AnswerForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnswerForm = function (_Component) {
	    _inherits(AnswerForm, _Component);
	
	    function AnswerForm(props) {
	        _classCallCheck(this, AnswerForm);
	
	        var _this = _possibleConstructorReturn(this, (AnswerForm.__proto__ || Object.getPrototypeOf(AnswerForm)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(AnswerForm, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // data already loaded by SatisfactionButton
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                campaign = _props.campaign,
	                ticket = _props.ticket;
	
	
	            var maxScore = campaign && (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                    return s.position;
	                } });
	            this.setState({ maxScore: maxScore });
	
	            dispatch((0, _actions.updateAnswerAction)({ ticketUid: ticket.uid, answers: campaign && campaign.questions.map(function () {
	                    return null;
	                }) }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.campaign != this.props.campaign) {
	                var dispatch = nextProps.dispatch,
	                    campaign = nextProps.campaign;
	
	
	                var maxScore = campaign && (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                        return s.position;
	                    } });
	                this.setState({ maxScore: maxScore });
	
	                dispatch((0, _actions.updateAnswerAction)({ answers: campaign && campaign.questions.map(function () {
	                        return null;
	                    }) }));
	            }
	
	            if (nextProps.ticket != this.props.ticket) {
	                var _dispatch = nextProps.dispatch,
	                    ticket = nextProps.ticket;
	
	                _dispatch((0, _actions.updateAnswerAction)({ ticketUid: ticket.uid, answers: null }));
	            }
	        }
	    }, {
	        key: 'sendAction',
	        value: function sendAction() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendAnswerAction)()).then(function () {
	                return dispatch((0, _actions.loadAnswerStream)());
	            });
	        }
	    }, {
	        key: 'validate',
	        value: function validate() {
	            var form = this.props.form;
	
	            return form.validate();
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            var form = this.props.form;
	
	            return form.isValid();
	        }
	    }, {
	        key: '_openComment',
	        value: function _openComment(event, openedComment) {
	            event.preventDefault();
	            this.setState({ openedComment: openedComment });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                action = _props2.action,
	                stream = _props2.stream,
	                campaign = _props2.campaign,
	                ticket = _props2.ticket,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'action', 'stream', 'campaign', 'ticket']);
	
	            var _state = this.state,
	                maxScore = _state.maxScore,
	                openedComment = _state.openedComment;
	
	
	            var answer = stream[0];
	
	            var scoreField = function scoreField(field, questionUid, questionIndex) {
	                var value = field.value && field.value[questionIndex] && field.value[questionIndex].score;
	
	                function onChange(score) {
	                    var nextValue = field.value && [].concat(_toConsumableArray(field.value)) || [];
	                    nextValue[questionIndex] = _extends({}, nextValue[questionIndex], { questionUid: questionUid, score: score });
	                    field.onChange(nextValue);
	                }
	
	                return { value: value, onChange: onChange };
	            };
	
	            var commentField = function commentField(field, questionUid, questionIndex) {
	                var value = field.value && field.value[questionIndex] && field.value[questionIndex].comment;
	
	                function onChange(event) {
	                    var comment = event.target.value || null;
	
	                    var nextValue = field.value && [].concat(_toConsumableArray(field.value)) || [];
	                    nextValue[questionIndex] = _extends({}, nextValue[questionIndex], { questionUid: questionUid, comment: comment });
	                    field.onChange(nextValue);
	                }
	
	                return { value: value, onChange: onChange };
	            };
	
	            return campaign && _react2.default.createElement(
	                'form',
	                _extends({ className: 'form-horizontal'
	                }, others),
	                campaign.questions.slice().reverse().map(function (question, questionIndex) {
	                    return _react2.default.createElement(
	                        'div',
	                        {
	                            key: question.uid },
	                        _react2.default.createElement(
	                            _reactBootstrap.Input,
	                            {
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                label: question.text },
	                            _react2.default.createElement(_Rating2.default, _extends({
	                                label: _i18n2.default.score,
	                                range: maxScore
	                            }, scoreField(form.answers(), question.uid, questionIndex)))
	                        ),
	                        (openedComment == questionIndex || action && action.answers[questionIndex] && action.answers[questionIndex].comment) && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'textarea',
	                            label: ' ',
	                            placeholder: _i18n2.default.comment
	                        }, commentField(form.answers(), question.uid, questionIndex))),
	                        !(openedComment == questionIndex || action && action.answers[questionIndex] && action.answers[questionIndex].comment) && _react2.default.createElement(
	                            'div',
	                            { className: _AnswerForm2.default.action },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openComment(e, questionIndex);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _i18n2.default.commentz
	                                )
	                            )
	                        )
	                    );
	                }),
	                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                    labelClassName: 'col-sm-3',
	                    wrapperClassName: 'col-sm-9',
	                    type: 'textarea',
	                    label: _i18n2.default.globalComment,
	                    placeholder: _i18n2.default.comment
	                }, form.comment()))
	            );
	        }
	    }]);
	
	    return AnswerForm;
	}(_react.Component);
	
	AnswerForm.propTypes = {
	    ticket: _react.PropTypes.object.isRequired
	};
	
	
	AnswerForm = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.AnswerAction.schema,
	    action: _actions.ANSWER_ACTION_UPDATED
	})(AnswerForm);
	
	AnswerForm = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.satisfaction.answer.stream,
	        campaign: state.satisfaction.campaign.campaign,
	        action: state.satisfaction.answerAction
	    };
	}, null, null, { withRef: true })(AnswerForm);
	
	var AnswerFormWrapper = function (_Component2) {
	    _inherits(AnswerFormWrapper, _Component2);
	
	    function AnswerFormWrapper() {
	        _classCallCheck(this, AnswerFormWrapper);
	
	        return _possibleConstructorReturn(this, (AnswerFormWrapper.__proto__ || Object.getPrototypeOf(AnswerFormWrapper)).apply(this, arguments));
	    }
	
	    _createClass(AnswerFormWrapper, [{
	        key: 'sendAction',
	        value: function sendAction() {
	            var answerForm = this.refs.answerForm;
	
	            return answerForm && answerForm.getWrappedInstance().getWrappedInstance().sendAction();
	        }
	    }, {
	        key: 'validate',
	        value: function validate() {
	            var answerForm = this.refs.answerForm;
	
	            return answerForm && answerForm.getWrappedInstance().getWrappedInstance().validate();
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            var answerForm = this.refs.answerForm;
	
	            return answerForm && answerForm.getWrappedInstance().getWrappedInstance().isValid();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(AnswerForm, _extends({ ref: 'answerForm' }, this.props));
	        }
	    }]);
	
	    return AnswerFormWrapper;
	}(_react.Component);
	
	exports.default = AnswerFormWrapper;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _extract = __webpack_require__(12);
	
	var _mathz = __webpack_require__(108);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Rating = __webpack_require__(531);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(279);
	
	var _actions = __webpack_require__(146);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _AnswerModal = __webpack_require__(2305);
	
	var _AnswerModal2 = _interopRequireDefault(_AnswerModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function questionAggregator(question) {
	    return { question: question };
	}
	
	function answerAggregator(result, answer) {
	    var aggrega = result.find(function (a) {
	        return a.question.uid == answer.questionUid;
	    });
	
	    if (aggrega) {
	        aggrega.answer = answer;
	    } else {
	        console && console.warn('Question ' + answer.questionUid + ' doesn\'t exist');
	    }
	    return result;
	}
	
	var AnswerModal = function (_Component) {
	    _inherits(AnswerModal, _Component);
	
	    function AnswerModal(props) {
	        _classCallCheck(this, AnswerModal);
	
	        var _this = _possibleConstructorReturn(this, (AnswerModal.__proto__ || Object.getPrototypeOf(AnswerModal)).call(this, props));
	
	        _this.state = {
	            aggregation: []
	        };
	        return _this;
	    }
	
	    _createClass(AnswerModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // data already loaded by SatisfactionButton
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                campaign = _props.campaign,
	                stream = _props.stream,
	                ticket = _props.ticket;
	
	            var answer = stream[0];
	
	            var answerRate = campaign && campaign.stats.answersNumber / campaign.stats.ticketsNumberOnCampaignPeriod;
	            var maxScore = campaign && (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                    return s.position;
	                } });
	            var questionAggregation = campaign && campaign.questions.map(questionAggregator).reverse() || [];
	            var aggregation = answer && answer.answers.reduce(answerAggregator, questionAggregation) || questionAggregation;
	            this.setState({ answerRate: answerRate, maxScore: maxScore, aggregation: aggregation });
	
	            dispatch((0, _actions.updateAnswerAction)({ ticketUid: ticket.uid, answers: aggregation.map(function () {
	                    return null;
	                }) }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.campaign != this.props.campaign || nextProps.stream != this.props.stream) {
	                var dispatch = nextProps.dispatch,
	                    campaign = nextProps.campaign,
	                    stream = nextProps.stream;
	
	                var answer = stream[0];
	
	                var answerRate = campaign && campaign.stats.answersNumber / campaign.stats.ticketsNumberOnCampaignPeriod;
	                var maxScore = campaign && (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                        return s.position;
	                    } });
	                var questionAggregation = campaign && campaign.questions.map(questionAggregator).reverse() || [];
	                var aggregation = answer && answer.answers.reduce(answerAggregator, questionAggregation) || questionAggregation;
	                this.setState({ answerRate: answerRate, maxScore: maxScore, aggregation: aggregation });
	
	                dispatch((0, _actions.updateAnswerAction)({ answers: aggregation.map(function () {
	                        return null;
	                    }) }));
	            }
	
	            if (nextProps.ticket != this.props.ticket) {
	                var _dispatch = nextProps.dispatch,
	                    ticket = nextProps.ticket;
	
	                _dispatch((0, _actions.updateAnswerAction)({ ticketUid: ticket.uid, answers: null }));
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendAnswerAction)()).then(function () {
	                return dispatch((0, _actions.loadAnswerStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: '_openComment',
	        value: function _openComment(event, openedComment) {
	            event.preventDefault();
	            this.setState({ openedComment: openedComment });
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                stream = _props3.stream,
	                campaign = _props3.campaign,
	                ticket = _props3.ticket,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'stream', 'campaign', 'ticket', 'onHide']);
	
	            var _state = this.state,
	                answerRate = _state.answerRate,
	                maxScore = _state.maxScore,
	                aggregation = _state.aggregation,
	                openedComment = _state.openedComment;
	
	
	            var answer = stream[0];
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var scoreField = function scoreField(field, questionUid, questionIndex) {
	                var value = field.value && field.value[questionIndex] && field.value[questionIndex].score;
	
	                function onChange(score) {
	                    var nextValue = field.value && [].concat(_toConsumableArray(field.value)) || [];
	                    nextValue[questionIndex] = _extends({}, nextValue[questionIndex], { questionUid: questionUid, score: score });
	                    field.onChange(nextValue);
	                }
	
	                return { value: value, onChange: onChange };
	            };
	
	            var commentField = function commentField(field, questionUid, questionIndex) {
	                var value = field.value && field.value[questionIndex] && field.value[questionIndex].comment;
	
	                function onChange(event) {
	                    var comment = event.target.value || null;
	
	                    var nextValue = field.value && [].concat(_toConsumableArray(field.value)) || [];
	                    nextValue[questionIndex] = _extends({}, nextValue[questionIndex], { questionUid: questionUid, comment: comment });
	                    field.onChange(nextValue);
	                }
	
	                return { value: value, onChange: onChange };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    bsSize: 'large',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, '/organisations/' + ticket.linkedEntities.clientCompany.uid + '/satisfactioncampaigns/' + campaign.uid);
	                                } },
	                            campaign && campaign.title
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 8 },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _AnswerModal2.default.questionGroup },
	                                aggregation.map(function (aggrega, aggregaIndex) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        {
	                                            key: aggrega.question.uid },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            null,
	                                            aggrega.question.text
	                                        ),
	                                        aggrega.answer && _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(_Rating2.default, {
	                                                label: _i18n2.default.score,
	                                                range: maxScore,
	                                                value: aggrega.answer.score }),
	                                            aggrega.answer.comment && _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, { icon: 'quote', size: 'xs' }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    aggrega.answer.comment
	                                                )
	                                            )
	                                        ),
	                                        !aggrega.answer && _react2.default.createElement(
	                                            'div',
	                                            null,
	                                            _react2.default.createElement(_Rating2.default, _extends({
	                                                label: _i18n2.default.score,
	                                                range: maxScore
	                                            }, scoreField(form.answers(), aggrega.question.uid, aggregaIndex))),
	                                            (openedComment == aggregaIndex || action && action.answers && action.answers[aggregaIndex] && action.answers[aggregaIndex].comment) && _react2.default.createElement(
	                                                'form',
	                                                null,
	                                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                                    type: 'textarea',
	                                                    placeholder: _i18n2.default.comment
	                                                }, commentField(form.answers(), aggrega.question.uid, aggregaIndex)))
	                                            ),
	                                            !(openedComment == aggregaIndex || action && action.answers && action.answers[aggregaIndex] && action.answers[aggregaIndex].comment) && _react2.default.createElement(
	                                                'div',
	                                                { className: _AnswerModal2.default.action },
	                                                _react2.default.createElement(
	                                                    'a',
	                                                    {
	                                                        href: '',
	                                                        onClick: function onClick(e) {
	                                                            return _this2._openComment(e, aggregaIndex);
	                                                        } },
	                                                    _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                                                    _react2.default.createElement(
	                                                        'span',
	                                                        null,
	                                                        _i18n2.default.commentz
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    );
	                                })
	                            ),
	                            answer && answer.comment && _react2.default.createElement(
	                                'div',
	                                { className: _AnswerModal2.default.globalComment },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.globalComment
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(_Icon2.default, { icon: 'quote', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        answer.comment
	                                    )
	                                )
	                            ),
	                            !answer && _react2.default.createElement(
	                                'div',
	                                { className: _AnswerModal2.default.globalComment },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    _i18n2.default.globalComment
	                                ),
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'textarea',
	                                    placeholder: _i18n2.default.comment
	                                }, form.comment()))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                null,
	                                !answer && _react2.default.createElement(
	                                    _LoaderButton2.default,
	                                    {
	                                        bsStyle: 'primary',
	                                        bsSize: 'large',
	                                        className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                        onClick: function onClick() {
	                                            return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                        } },
	                                    _i18n2.default.save
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsSize: 'large',
	                                        onClick: onHide },
	                                    _i18n2.default.close
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            campaign && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _AnswerModal2.default.averageScore },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        _i18n2.default.averageScore
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _AnswerModal2.default.score },
	                                        Math.round(campaign.stats.averageNote * 10) / 10
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: (0, _classnames2.default)(_AnswerModal2.default.answerCount, _defineProperty({}, _AnswerModal2.default.danger, answerRate < campaign.answersRateGoal)) },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        _i18n2.default.answerCount
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _AnswerModal2.default.count },
	                                        campaign.stats.answersNumber
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        (0, _extract.replace)(_i18n2.default.outOfEligibleTicketCount, { ticketCount: campaign.stats.ticketsNumberOnCampaignPeriod })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: (0, _classnames2.default)(_AnswerModal2.default.answerRate, _defineProperty({}, _AnswerModal2.default.danger, answerRate < campaign.answersRateGoal)) },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        null,
	                                        _i18n2.default.answerRate
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _AnswerModal2.default.rate },
	                                        Math.round(answerRate * 100),
	                                        '%'
	                                    ),
	                                    campaign.answersRateGoal && _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        (0, _extract.replace)(_i18n2.default.forAnswerGoal, { answerGoal: Math.round(campaign.answersRateGoal * 100) })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AnswerModal;
	}(_react.Component);
	
	AnswerModal.propTypes = {
	    ticket: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	AnswerModal = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.AnswerAction.schema,
	    action: _actions.ANSWER_ACTION_UPDATED
	})(AnswerModal);
	
	AnswerModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.satisfaction.answer.stream,
	        campaign: state.satisfaction.campaign.campaign,
	        action: state.satisfaction.answerAction
	    };
	})(AnswerModal);
	
	exports.default = AnswerModal;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(146);
	
	var _AnswerCard = __webpack_require__(1475);
	
	var _AnswerCard2 = _interopRequireDefault(_AnswerCard);
	
	var _AnswerStream = __webpack_require__(2306);
	
	var _AnswerStream2 = _interopRequireDefault(_AnswerStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var AnswerStream = function (_Component) {
	    _inherits(AnswerStream, _Component);
	
	    function AnswerStream() {
	        _classCallCheck(this, AnswerStream);
	
	        return _possibleConstructorReturn(this, (AnswerStream.__proto__ || Object.getPrototypeOf(AnswerStream)).apply(this, arguments));
	    }
	
	    _createClass(AnswerStream, [{
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadAnswerStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                campaign = _props.campaign,
	                stream = _props.stream,
	                range = _props.range;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                stream.map(function (answer) {
	                    return _react2.default.createElement(_AnswerCard2.default, {
	                        key: answer.ticketUid,
	                        campaign: campaign,
	                        answer: answer });
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: _AnswerStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true,
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return AnswerStream;
	}(_react.Component);
	
	AnswerStream.propTypes = {};
	
	
	AnswerStream = (0, _router.connectLocationChangeLock)()(AnswerStream);
	
	AnswerStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        campaign: state.satisfaction.campaign.campaign,
	        stream: state.satisfaction.answer.stream,
	        range: state.satisfaction.answer.range
	    };
	})(AnswerStream);
	
	exports.default = AnswerStream;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CampaignCard = __webpack_require__(2308);
	
	var _CampaignCard2 = _interopRequireDefault(_CampaignCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function status(campaign) {
	    if (campaign.finished) return 'closed';
	    if (campaign.started) return 'opened';
	    return null;
	}
	
	var CampaignCard = function (_Component) {
	    _inherits(CampaignCard, _Component);
	
	    function CampaignCard() {
	        _classCallCheck(this, CampaignCard);
	
	        return _possibleConstructorReturn(this, (CampaignCard.__proto__ || Object.getPrototypeOf(CampaignCard)).apply(this, arguments));
	    }
	
	    _createClass(CampaignCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                campaign = _props.campaign,
	                others = _objectWithoutProperties(_props, ['campaign']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.campaign
	            );
	
	            var campaignStatus = status(campaign);
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CampaignCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ justified: true,
	                        kind: 'tab',
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _CampaignCard2.default.title },
	                        campaignStatus && _react2.default.createElement(_Icon2.default, { icon: campaignStatus, size: 'sm' }),
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            '> ',
	                            campaign.title
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CampaignCard;
	}(_react.Component);
	
	CampaignCard.propTypes = {
	    campaign: _react.PropTypes.object.isRequired
	};
	exports.default = CampaignCard;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _extract = __webpack_require__(12);
	
	var _mathz = __webpack_require__(108);
	
	var _router = __webpack_require__(123);
	
	var _status = __webpack_require__(13);
	
	var _Rating = __webpack_require__(531);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	var _DashboardPanel = __webpack_require__(111);
	
	var _DashboardPanel2 = _interopRequireDefault(_DashboardPanel);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _AverageNoteDashboardPanel = __webpack_require__(1105);
	
	var _AverageNoteDashboardPanel2 = _interopRequireDefault(_AverageNoteDashboardPanel);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CampaignDashboard = __webpack_require__(2309);
	
	var _CampaignDashboard2 = _interopRequireDefault(_CampaignDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function questionAggregator(question) {
	    return {
	        question: question,
	        averageNote: 0
	    };
	}
	
	function noteAggregator(result, note) {
	    var aggrega = result.find(function (a) {
	        return a.question.uid == note.questionUid;
	    });
	
	    if (aggrega) {
	        aggrega.averageNote = note.averageNote;
	    } else {
	        console && console.warn('Question ' + note.questionUid + ' doesn\'t exist');
	    }
	    return result;
	}
	
	var CampaignDashboard = function (_Component) {
	    _inherits(CampaignDashboard, _Component);
	
	    function CampaignDashboard(props) {
	        _classCallCheck(this, CampaignDashboard);
	
	        var _this = _possibleConstructorReturn(this, (CampaignDashboard.__proto__ || Object.getPrototypeOf(CampaignDashboard)).call(this, props));
	
	        _this.state = {
	            aggregation: []
	        };
	        return _this;
	    }
	
	    _createClass(CampaignDashboard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                campaign = _props.campaign;
	
	
	            var answerRate = campaign.stats.answersNumber / campaign.stats.ticketsNumberOnCampaignPeriod;
	            var maxScore = (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                    return s.position;
	                } });
	            var questionAggregation = campaign.questions.map(questionAggregator).reverse();
	            var aggregation = campaign.stats.questionsAverageNote.reduce(noteAggregator, questionAggregation);
	            this.setState({ answerRate: answerRate, maxScore: maxScore, aggregation: aggregation });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.campaign != this.props.campaign) {
	                var dispatch = nextProps.dispatch,
	                    campaign = nextProps.campaign;
	
	
	                var answerRate = campaign.stats.answersNumber / campaign.stats.ticketsNumberOnCampaignPeriod;
	                var maxScore = (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                        return s.position;
	                    } });
	                var questionAggregation = campaign.questions.map(questionAggregator).reverse();
	                var aggregation = campaign.stats.questionsAverageNote.reduce(noteAggregator, questionAggregation);
	                this.setState({ answerRate: answerRate, maxScore: maxScore, aggregation: aggregation });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                campaign = _props2.campaign;
	            var _state = this.state,
	                answerRate = _state.answerRate,
	                maxScore = _state.maxScore,
	                aggregation = _state.aggregation;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_AverageNoteDashboardPanel2.default, { light: true }),
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.answerCount) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_CampaignDashboard2.default.answerCount, _defineProperty({}, _CampaignDashboard2.default.danger, answerRate < campaign.answersRateGoal)) },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _CampaignDashboard2.default.count },
	                                    campaign.stats.answersNumber
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    (0, _extract.replace)(_i18n2.default.outOfEligibleTicketCount, { ticketCount: campaign.stats.ticketsNumberOnCampaignPeriod })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(_DashboardPanelAdd2.default, {
	                            onClick: function onClick() {
	                                return dispatch((0, _status.infoStatus)(_i18n2.default.featureNotImplemented));
	                            } }),
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                header: panelHeader(_i18n2.default.answerRate) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_CampaignDashboard2.default.answerRate, _defineProperty({}, _CampaignDashboard2.default.danger, answerRate < campaign.answersRateGoal)) },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: _CampaignDashboard2.default.rate },
	                                    Math.round(answerRate * 100),
	                                    '%'
	                                ),
	                                campaign.answersRateGoal && _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    (0, _extract.replace)(_i18n2.default.forAnswerGoal, { answerGoal: Math.round(campaign.answersRateGoal * 100) })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 6, md: 4 },
	                        _react2.default.createElement(
	                            _DashboardPanel2.default,
	                            { light: true,
	                                size: 'large',
	                                header: panelHeader(_i18n2.default.answers) },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _CampaignDashboard2.default.answerGroup },
	                                aggregation.map(function (aggrega, aggregaIndex) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        {
	                                            key: aggrega.question.uid },
	                                        _react2.default.createElement(
	                                            'h4',
	                                            null,
	                                            aggrega.question.text
	                                        ),
	                                        _react2.default.createElement(_Rating2.default, {
	                                            range: maxScore,
	                                            label: _i18n2.default.score,
	                                            value: aggrega.averageNote })
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CampaignDashboard;
	}(_react.Component);
	
	CampaignDashboard.propTypes = {};
	
	
	CampaignDashboard = (0, _router.connectLocationChangeLock)()(CampaignDashboard);
	
	CampaignDashboard = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        campaign: state.satisfaction.campaign.campaign
	    };
	})(CampaignDashboard);
	
	exports.default = CampaignDashboard;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(146);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateNotationScaleOfCampaignPopover = __webpack_require__(1489);
	
	var _UpdateNotationScaleOfCampaignPopover2 = _interopRequireDefault(_UpdateNotationScaleOfCampaignPopover);
	
	var _UpdateTitleOfCampaignPopover = __webpack_require__(1490);
	
	var _UpdateTitleOfCampaignPopover2 = _interopRequireDefault(_UpdateTitleOfCampaignPopover);
	
	var _AddRemoveQuestionFromCampaignPopover = __webpack_require__(1474);
	
	var _AddRemoveQuestionFromCampaignPopover2 = _interopRequireDefault(_AddRemoveQuestionFromCampaignPopover);
	
	var _DefineAnswerRateGoalPopover = __webpack_require__(1485);
	
	var _DefineAnswerRateGoalPopover2 = _interopRequireDefault(_DefineAnswerRateGoalPopover);
	
	var _StartCampaignModal = __webpack_require__(1488);
	
	var _StartCampaignModal2 = _interopRequireDefault(_StartCampaignModal);
	
	var _FinishCampaignModal = __webpack_require__(1486);
	
	var _FinishCampaignModal2 = _interopRequireDefault(_FinishCampaignModal);
	
	var _CampaignDetail = __webpack_require__(2310);
	
	var _CampaignDetail2 = _interopRequireDefault(_CampaignDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignDetail = function (_Component) {
	    _inherits(CampaignDetail, _Component);
	
	    function CampaignDetail(props) {
	        _classCallCheck(this, CampaignDetail);
	
	        var _this = _possibleConstructorReturn(this, (CampaignDetail.__proto__ || Object.getPrototypeOf(CampaignDetail)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(CampaignDetail, [{
	        key: '_openPopover',
	        value: function _openPopover(event, name) {
	            event.preventDefault();
	            this.setState({ openedPopover: name });
	        }
	    }, {
	        key: '_closePopover',
	        value: function _closePopover(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            var openedPopover = null;
	            this.setState({ openedPopover: openedPopover });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(name) {
	            this.setState({ openedModal: name });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: '_sendStartAction',
	        value: function _sendStartAction() {
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _actions.sendStartCampaignAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            });
	        }
	    }, {
	        key: '_sendFinishAction',
	        value: function _sendFinishAction() {
	            var dispatch = this.props.dispatch;
	
	            return dispatch((0, _actions.sendFinishCampaignAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                dispatch = _props.dispatch,
	                location = _props.location,
	                campaign = _props.campaign;
	            var _state = this.state,
	                openedPopover = _state.openedPopover,
	                openedModal = _state.openedModal;
	            var _refs = this.refs,
	                editButton = _refs.editButton,
	                editContainer = _refs.editContainer;
	
	
	            var editMenuPopover = _react2.default.createElement(
	                _reactBootstrap.Popover,
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: _CampaignDetail2.default.menu },
	                    campaign._links.find((0, _links.linkFinder)(['AddQuestionToCampaign', 'RemoveQuestionFromCampaign'])) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'AddRemoveQuestionFromCampaignPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.questions
	                            )
	                        )
	                    ),
	                    campaign._links.find((0, _links.linkFinder)('UpdateNotationScaleOfCampaign')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'UpdateNotationScaleOfCampaignPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.notationScale
	                            )
	                        )
	                    ),
	                    campaign._links.find((0, _links.linkFinder)('DefineAnswerRateGoal')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'DefineAnswerRateGoalPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.answerRateGoal
	                            )
	                        )
	                    ),
	                    campaign._links.find((0, _links.linkFinder)('UpdateTitleOfCampaign')) && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._openPopover(e, 'UpdateTitleOfCampaignPopover');
	                                } },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '> ',
	                                _i18n2.default.change
	                            )
	                        )
	                    )
	                )
	            );
	
	            var editOverlay = function editOverlay(name, popover) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Overlay,
	                    { rootClose: true,
	                        target: function target() {
	                            return (0, _reactDom.findDOMNode)(editButton);
	                        },
	                        placement: 'bottom',
	                        show: openedPopover == name,
	                        container: editContainer,
	                        onHide: function onHide(e) {
	                            return _this2._closePopover(e);
	                        } },
	                    popover
	                );
	            };
	
	            var tooltip = function tooltip(text, status) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: status && 'tooltip-' + status },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _CampaignDetail2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _CampaignDetail2.default.defaultContent },
	                    _react2.default.createElement(
	                        _reactBootstrap.PageHeader,
	                        { className: 'large' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                ref: 'editContainer',
	                                className: _CampaignDetail2.default.header },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.campaign,
	                                ' - ',
	                                campaign.title
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: _CampaignDetail2.default.edit,
	                                    ref: 'editButton',
	                                    href: '',
	                                    onClick: function onClick(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    },
	                                    onMouseOver: function onMouseOver(e) {
	                                        return _this2._openPopover(e, 'EditMenuPopover');
	                                    } },
	                                _react2.default.createElement(_Icon2.default, {
	                                    icon: 'gear',
	                                    size: 'xs',
	                                    active: openedPopover != null })
	                            )
	                        ),
	                        editOverlay('EditMenuPopover', editMenuPopover),
	                        campaign._links.find((0, _links.linkFinder)(['AddQuestionToCampaign', 'RemoveQuestionFromCampaign'])) && editOverlay('AddRemoveQuestionFromCampaignPopover', _react2.default.createElement(_AddRemoveQuestionFromCampaignPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        campaign._links.find((0, _links.linkFinder)('UpdateNotationScaleOfCampaign')) && editOverlay('UpdateNotationScaleOfCampaignPopover', _react2.default.createElement(_UpdateNotationScaleOfCampaignPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        campaign._links.find((0, _links.linkFinder)('DefineAnswerRateGoal')) && editOverlay('DefineAnswerRateGoalPopover', _react2.default.createElement(_DefineAnswerRateGoalPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } })),
	                        campaign._links.find((0, _links.linkFinder)('UpdateTitleOfCampaign')) && editOverlay('UpdateTitleOfCampaignPopover', _react2.default.createElement(_UpdateTitleOfCampaignPopover2.default, {
	                            onHide: function onHide(e) {
	                                return _this2._closePopover(e);
	                            } }))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4, smOffset: 4 },
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                null,
	                                campaign._links.find((0, _links.linkFinder)('StartCampaign')) && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'primary',
	                                        onClick: function onClick() {
	                                            return _this2._openModal('StartCampaignModal');
	                                        } },
	                                    _i18n2.default.startCampaign
	                                ),
	                                campaign._links.find((0, _links.linkFinder)('FinishCampaign')) && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsStyle: 'danger',
	                                        onClick: function onClick() {
	                                            return _this2._openModal('FinishCampaignModal');
	                                        } },
	                                    _i18n2.default.finishCampaign
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Nav,
	                        { justified: true,
	                            bsStyle: 'list' },
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/\w+\/[\w-]+\/satisfactioncampaigns\/[\w-]+$/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _router.push)('/*/*/satisfactioncampaigns/' + campaign.uid));
	                                } },
	                            _i18n2.default.synthesis
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.NavItem,
	                            {
	                                active: location.pathname.match(/\/\w+\/[\w-]+\/satisfactioncampaigns\/[\w-]+\/answers$/) != null,
	                                onClick: function onClick() {
	                                    return dispatch((0, _router.push)('/*/*/satisfactioncampaigns/' + campaign.uid + '/answers'));
	                                } },
	                            _i18n2.default.answers
	                        )
	                    )
	                ),
	                children,
	                campaign._links.find((0, _links.linkFinder)('StartCampaign')) && _react2.default.createElement(_StartCampaignModal2.default, {
	                    show: openedModal == 'StartCampaignModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                campaign._links.find((0, _links.linkFinder)('FinishCampaign')) && _react2.default.createElement(_FinishCampaignModal2.default, {
	                    show: openedModal == 'FinishCampaignModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } })
	            );
	        }
	    }]);
	
	    return CampaignDetail;
	}(_react.Component);
	
	CampaignDetail.propTypes = {};
	
	
	CampaignDetail = (0, _router.connectLocationChangeLock)({
	    pathName: /^\/\w+\/[\w-]+\/satisfactioncampaigns\/[\w-]+/
	})(CampaignDetail);
	
	CampaignDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        campaign: state.satisfaction.campaign.campaign
	    };
	})(CampaignDetail);
	
	exports.default = CampaignDetail;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(146);
	
	var _CampaignCard = __webpack_require__(1479);
	
	var _CampaignCard2 = _interopRequireDefault(_CampaignCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var CampaignStream = function (_Component) {
	    _inherits(CampaignStream, _Component);
	
	    function CampaignStream() {
	        _classCallCheck(this, CampaignStream);
	
	        return _possibleConstructorReturn(this, (CampaignStream.__proto__ || Object.getPrototypeOf(CampaignStream)).apply(this, arguments));
	    }
	
	    _createClass(CampaignStream, [{
	        key: '_navigate',
	        value: function _navigate(event, campaign) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open(resolveLocationPathname('/*/*/satisfactioncampaigns/' + campaign.uid), '_blank');
	            } else {
	                dispatch((0, _router.push)('/*/*/satisfactioncampaigns/' + campaign.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                stream = _props.stream;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    stream.map(function (campaign) {
	                        return _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            {
	                                key: campaign.uid,
	                                sm: 6 },
	                            _react2.default.createElement(_CampaignCard2.default, {
	                                campaign: campaign,
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, campaign);
	                                } })
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return CampaignStream;
	}(_react.Component);
	
	CampaignStream.propTypes = {};
	
	
	CampaignStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.satisfaction.campaign.stream
	    };
	})(CampaignStream);
	
	exports.default = CampaignStream;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CampaignStream = __webpack_require__(1482);
	
	var _CampaignStream2 = _interopRequireDefault(_CampaignStream);
	
	var _CreateCampaignModal = __webpack_require__(1484);
	
	var _CreateCampaignModal2 = _interopRequireDefault(_CreateCampaignModal);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CampaignStreamLayout = function (_Component) {
	    _inherits(CampaignStreamLayout, _Component);
	
	    function CampaignStreamLayout(props) {
	        _classCallCheck(this, CampaignStreamLayout);
	
	        var _this = _possibleConstructorReturn(this, (CampaignStreamLayout.__proto__ || Object.getPrototypeOf(CampaignStreamLayout)).call(this, props));
	
	        _this.state = {
	            opened: false
	        };
	        return _this;
	    }
	
	    _createClass(CampaignStreamLayout, [{
	        key: '_open',
	        value: function _open() {
	            this.setState({ opened: true });
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({ opened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                _links = _props._links;
	            var opened = this.state.opened;
	
	
	            var newCampaignBoxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.newCampaign
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smPush: 8 },
	                        _links.find((0, _links2.linkFinder)('CreateCampaign')) && _react2.default.createElement(_Box2.default, {
	                            status: 'primary',
	                            header: newCampaignBoxTitle,
	                            help: '+',
	                            onClick: function onClick() {
	                                return _this2._open();
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8, smPull: 4 },
	                        _react2.default.createElement(_CampaignStream2.default, null)
	                    )
	                ),
	                _links.find((0, _links2.linkFinder)('CreateCampaign')) && _react2.default.createElement(_CreateCampaignModal2.default, {
	                    show: opened,
	                    onHide: function onHide() {
	                        return _this2._close();
	                    } })
	            );
	        }
	    }]);
	
	    return CampaignStreamLayout;
	}(_react.Component);
	
	CampaignStreamLayout.propTypes = {};
	
	
	CampaignStreamLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        _links: state.satisfaction.campaign._links
	    };
	})(CampaignStreamLayout);
	
	exports.default = CampaignStreamLayout;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _MultiInput = __webpack_require__(277);
	
	var _MultiInput2 = _interopRequireDefault(_MultiInput);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(279);
	
	var _actions = __webpack_require__(146);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CreateCampaignModal = __webpack_require__(2311);
	
	var _CreateCampaignModal2 = _interopRequireDefault(_CreateCampaignModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function defineFirstPosition(notationScale) {
	    var firstNotationScale = notationScale[0];
	    var remainingNotationScales = notationScale.slice(1);
	
	    var position = notationScale.slice(1).sort(function (a, b) {
	        return (a && a.position) - (b && b.position);
	    }).reduce(function (result, notationScale) {
	        if (result == (notationScale && notationScale.position)) {
	            return ++result;
	        }
	        return result;
	    }, 1);
	
	    return [_extends({}, firstNotationScale, {
	        position: position
	    })].concat(_toConsumableArray(remainingNotationScales));
	}
	
	var CreateCampaignModal = function (_Component) {
	    _inherits(CreateCampaignModal, _Component);
	
	    function CreateCampaignModal() {
	        _classCallCheck(this, CreateCampaignModal);
	
	        return _possibleConstructorReturn(this, (CreateCampaignModal.__proto__ || Object.getPrototypeOf(CreateCampaignModal)).apply(this, arguments));
	    }
	
	    _createClass(CreateCampaignModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                action = _props.action;
	
	
	            var notationScale = defineFirstPosition(action && action.notationScale || []);
	            dispatch((0, _actions.updateCreateCampaignAction)({ notationScale: notationScale }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.action != this.props.action && nextProps.action && nextProps.action.notationScale != (this.props.action && this.props.action.notationScale) && nextProps.action && nextProps.action.notationScale && nextProps.action.notationScale.length != (this.props.action && this.props.action.notationScale && this.props.action.notationScale.length)) {
	                var dispatch = nextProps.dispatch,
	                    action = nextProps.action;
	
	
	                var notationScale = defineFirstPosition(action && action.notationScale || []);
	                dispatch((0, _actions.updateCreateCampaignAction)({ notationScale: notationScale }));
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendCreateCampaignAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaignStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.newCampaign
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'label',
	                            label: requiredLabel(_i18n2.default.title)
	                        }, form.title())),
	                        _react2.default.createElement(_MultiInput2.default, _extends({ inverse: true,
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'question',
	                            label: _i18n2.default.questions
	                        }, form.questions()))
	                    ),
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _i18n2.default.notationScale,
	                        ' ',
	                        _react2.default.createElement(
	                            'i',
	                            null,
	                            '*'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: _CreateCampaignModal2.default.notationScaleGroup },
	                        (action && action.notationScale || []).slice(1).sort(function (a, b) {
	                            return a.position - b.position;
	                        }).map(function (notationScale, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: '',
	                                        className: _CreateCampaignModal2.default.remove,
	                                        onClick: function onClick(e) {
	                                            return form.notationScale.remove(e, notationScale);
	                                        } },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        notationScale.position
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' - ',
	                                        notationScale.label
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 3 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'position',
	                                    placeholder: _i18n2.default.notationScalePosition
	                                }, (0, _form.integerField)(form.notationScale.position())))
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 9 },
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    type: 'text',
	                                    name: 'label',
	                                    placeholder: _i18n2.default.notationScaleLabel
	                                }, form.notationScale.label()))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        form.notationScale.isValid() && _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                onClick: function onClick(e) {
	                                    return form.notationScale.add(e);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.addNotationScale
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                onClick: function onClick(e) {
	                                    return form.notationScale.remove(e);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.remove
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreateCampaignModal;
	}(_react.Component);
	
	CreateCampaignModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	CreateCampaignModal = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.CreateCampaignAction.schema,
	    action: _actions.CREATE_CAMPAIGN_ACTION_UPDATED
	})(CreateCampaignModal);
	
	CreateCampaignModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        action: state.satisfaction.createCampaignAction
	    };
	})(CreateCampaignModal);
	
	exports.default = CreateCampaignModal;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(146);
	
	var _models = __webpack_require__(279);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function actionUpdate(campaign) {
	    return {
	        rate: campaign.answersRateGoal
	    };
	}
	
	var DefineAnswerRateGoalPopover = function (_Component) {
	    _inherits(DefineAnswerRateGoalPopover, _Component);
	
	    function DefineAnswerRateGoalPopover() {
	        _classCallCheck(this, DefineAnswerRateGoalPopover);
	
	        return _possibleConstructorReturn(this, (DefineAnswerRateGoalPopover.__proto__ || Object.getPrototypeOf(DefineAnswerRateGoalPopover)).apply(this, arguments));
	    }
	
	    _createClass(DefineAnswerRateGoalPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                campaign = _props.campaign;
	
	            var update = actionUpdate(campaign);
	
	            dispatch((0, _actions.updateDefineAnswerRateGoalAction)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.campaign != this.props.campaign) {
	                var dispatch = nextProps.dispatch,
	                    campaign = nextProps.campaign;
	
	                var update = actionUpdate(campaign);
	
	                dispatch((0, _actions.updateDefineAnswerRateGoalAction)(update));
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendDefineAnswerRateGoalAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                campaign = _props3.campaign,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'campaign', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.answerRateGoal
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'label',
	                        label: requiredLabel(_i18n2.default.rate),
	                        addonAfter: '%'
	                    }, (0, _form.percentageField)(form.rate())))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineAnswerRateGoalPopover;
	}(_react.Component);
	
	DefineAnswerRateGoalPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	DefineAnswerRateGoalPopover = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.DefineAnswerRateGoalAction.schema,
	    action: _actions.DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED
	})(DefineAnswerRateGoalPopover);
	
	DefineAnswerRateGoalPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        campaign: state.satisfaction.campaign.campaign,
	        action: state.satisfaction.defineAnswerRateGoalAction
	    };
	})(DefineAnswerRateGoalPopover);
	
	exports.default = DefineAnswerRateGoalPopover;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(146);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _FinishCampaignModal = __webpack_require__(2312);
	
	var _FinishCampaignModal2 = _interopRequireDefault(_FinishCampaignModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinishCampaignModal = function (_Component) {
	    _inherits(FinishCampaignModal, _Component);
	
	    function FinishCampaignModal() {
	        _classCallCheck(this, FinishCampaignModal);
	
	        return _possibleConstructorReturn(this, (FinishCampaignModal.__proto__ || Object.getPrototypeOf(FinishCampaignModal)).apply(this, arguments));
	    }
	
	    _createClass(FinishCampaignModal, [{
	        key: '_sendAction',
	        value: function _sendAction(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendFinishCampaignAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                campaign = _props2.campaign,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'campaign', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.finishCampaign
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _FinishCampaignModal2.default.text },
	                        _i18n2.default.finishCampaignText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, campaign)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return _this2._sendAction(e);
	                                } },
	                            _i18n2.default.finish
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FinishCampaignModal;
	}(_react.Component);
	
	FinishCampaignModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	FinishCampaignModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        campaign: state.satisfaction.campaign.campaign
	    };
	})(FinishCampaignModal);
	
	exports.default = FinishCampaignModal;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _loading = __webpack_require__(58);
	
	var _mathz = __webpack_require__(108);
	
	var _Rating = __webpack_require__(531);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	var _actions = __webpack_require__(146);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _SatisfactionButton = __webpack_require__(2313);
	
	var _SatisfactionButton2 = _interopRequireDefault(_SatisfactionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SatisfactionButton = function (_Component) {
	    _inherits(SatisfactionButton, _Component);
	
	    function SatisfactionButton(props) {
	        _classCallCheck(this, SatisfactionButton);
	
	        var _this = _possibleConstructorReturn(this, (SatisfactionButton.__proto__ || Object.getPrototypeOf(SatisfactionButton)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(SatisfactionButton, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket;
	
	
	            dispatch((0, _actions.queryAnswerStream)(_extends({}, _actions.DEFAULT_ANSWER_QUERY, { companyUid: ticket.linkedEntities.clientCompany.uid, ticketUid: ticket.uid }))).then(function (response) {
	                var answer = response.stream[0];
	                if (answer) {
	                    return dispatch((0, _actions.queryCampaign)(ticket.linkedEntities.clientCompany.uid, answer.campaignUid));
	                }
	                return dispatch((0, _actions.queryActiveCampaign)(ticket.linkedEntities.clientCompany.uid));
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket != this.props.ticket) {
	                var dispatch = nextProps.dispatch,
	                    ticket = nextProps.ticket;
	
	
	                dispatch((0, _actions.queryAnswerStream)(_extends({}, _actions.DEFAULT_ANSWER_QUERY, { companyUid: ticket.linkedEntities.clientCompany.uid, ticketUid: ticket.uid }))).then(function (response) {
	                    var answer = response.stream[0];
	                    if (answer) {
	                        return dispatch((0, _actions.queryCampaign)(ticket.linkedEntities.clientCompany.uid, answer.campaignUid));
	                    }
	                    return dispatch((0, _actions.queryActiveCampaign)(ticket.linkedEntities.clientCompany.uid));
	                });
	            }
	
	            if (nextProps.stream != this.props.stream || nextProps.campaign != this.props.campaign) {
	                var stream = nextProps.stream,
	                    campaign = nextProps.campaign;
	
	                var answer = stream[0];
	
	                var score = answer && (0, _mathz.average)({ source: answer.answers, identify: function identify(a) {
	                        return a.score;
	                    }, accuracy: 0.1 });
	                var maxScore = campaign && (0, _mathz.max)({ source: campaign.notationScale, identify: function identify(s) {
	                        return s.position;
	                    } });
	                this.setState({ score: score, maxScore: maxScore });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                stream = _props2.stream,
	                campaign = _props2.campaign,
	                ticket = _props2.ticket,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'stream', 'campaign', 'ticket']);
	
	            var _state = this.state,
	                score = _state.score,
	                maxScore = _state.maxScore;
	
	
	            return !!maxScore && _react2.default.createElement(
	                'div',
	                { className: _SatisfactionButton2.default.default },
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    _extends({
	                        bsStyle: 'link'
	                    }, others),
	                    _react2.default.createElement(_Rating2.default, {
	                        label: _i18n2.default.score,
	                        range: maxScore,
	                        value: score })
	                )
	            );
	        }
	    }]);
	
	    return SatisfactionButton;
	}(_react.Component);
	
	SatisfactionButton.propTypes = {
	    ticket: _react.PropTypes.object.isRequired
	};
	
	
	SatisfactionButton = (0, _loading.connectLoadingLock)()(SatisfactionButton);
	
	SatisfactionButton = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        stream: state.satisfaction.answer.stream,
	        campaign: state.satisfaction.campaign.campaign
	    };
	})(SatisfactionButton);
	
	exports.default = SatisfactionButton;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _DayPicker = __webpack_require__(276);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _actions = __webpack_require__(146);
	
	var _models = __webpack_require__(279);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _StartCampaignModal = __webpack_require__(2314);
	
	var _StartCampaignModal2 = _interopRequireDefault(_StartCampaignModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StartCampaignModal = function (_Component) {
	    _inherits(StartCampaignModal, _Component);
	
	    function StartCampaignModal() {
	        _classCallCheck(this, StartCampaignModal);
	
	        return _possibleConstructorReturn(this, (StartCampaignModal.__proto__ || Object.getPrototypeOf(StartCampaignModal)).apply(this, arguments));
	    }
	
	    _createClass(StartCampaignModal, [{
	        key: '_sendAction',
	        value: function _sendAction(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendStartCampaignAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                action = _props2.action,
	                campaign = _props2.campaign,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'action', 'campaign', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.startCampaign
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _StartCampaignModal2.default.text },
	                        _i18n2.default.startCampaignText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, campaign)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _StartCampaignModal2.default.elligibleTicketDate },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            _i18n2.default.elligibleTicketDate
	                        ),
	                        _react2.default.createElement(_DayPicker2.default, form.elligibleCreateTicketDate())
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.start
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StartCampaignModal;
	}(_react.Component);
	
	StartCampaignModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	StartCampaignModal = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.StartCampaignAction.schema,
	    action: _actions.START_CAMPAIGN_ACTION_UPDATED
	})(StartCampaignModal);
	
	StartCampaignModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        campaign: state.satisfaction.campaign.campaign,
	        action: state.satisfaction.startCampaignAction
	    };
	})(StartCampaignModal);
	
	exports.default = StartCampaignModal;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(146);
	
	var _models = __webpack_require__(279);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UpdateNotationScaleOfCampaignPopover = __webpack_require__(2315);
	
	var _UpdateNotationScaleOfCampaignPopover2 = _interopRequireDefault(_UpdateNotationScaleOfCampaignPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function defineFirstPosition(notationScale) {
	    var firstNotationScale = notationScale[0];
	    var remainingNotationScales = notationScale.slice(1);
	
	    var position = notationScale.slice(1).sort(function (a, b) {
	        return (a && a.position) - (b && b.position);
	    }).reduce(function (result, notationScale) {
	        if (result == (notationScale && notationScale.position)) {
	            return ++result;
	        }
	        return result;
	    }, 1);
	
	    return [_extends({}, firstNotationScale, {
	        position: position
	    })].concat(_toConsumableArray(remainingNotationScales));
	}
	
	function actionUpdate(campaign) {
	    return {
	        newNotationScale: campaign.notationScale.sort(function (a, b) {
	            return b.position - a.position;
	        })
	    };
	}
	
	var UpdateNotationScaleOfCampaignPopover = function (_Component) {
	    _inherits(UpdateNotationScaleOfCampaignPopover, _Component);
	
	    function UpdateNotationScaleOfCampaignPopover() {
	        _classCallCheck(this, UpdateNotationScaleOfCampaignPopover);
	
	        return _possibleConstructorReturn(this, (UpdateNotationScaleOfCampaignPopover.__proto__ || Object.getPrototypeOf(UpdateNotationScaleOfCampaignPopover)).apply(this, arguments));
	    }
	
	    _createClass(UpdateNotationScaleOfCampaignPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                campaign = _props.campaign;
	
	            var update = actionUpdate(campaign);
	
	            dispatch((0, _actions.updateUpdateNotationScaleOfCampaignAction)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.campaign != this.props.campaign) {
	                var dispatch = nextProps.dispatch,
	                    campaign = nextProps.campaign;
	
	                var update = actionUpdate(campaign);
	
	                dispatch((0, _actions.updateUpdateNotationScaleOfCampaignAction)(update));
	            }
	
	            if (nextProps.action != this.props.action && nextProps.action && nextProps.action.newNotationScale != (this.props.action && this.props.action.newNotationScale) && nextProps.action && nextProps.action.newNotationScale && nextProps.action.newNotationScale.length != (this.props.action && this.props.action.newNotationScale && this.props.action.newNotationScale.length)) {
	                var _dispatch = nextProps.dispatch,
	                    action = nextProps.action;
	
	
	                var newNotationScale = defineFirstPosition(action && action.newNotationScale || []);
	                _dispatch((0, _actions.updateUpdateNotationScaleOfCampaignAction)({ newNotationScale: newNotationScale }));
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdateNotationScaleOfCampaignAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                campaign = _props3.campaign,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'campaign', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.notationScale
	                }, others),
	                _react2.default.createElement(
	                    'ul',
	                    { className: _UpdateNotationScaleOfCampaignPopover2.default.notationScaleGroup },
	                    (action && action.newNotationScale || []).slice(1).sort(function (a, b) {
	                        return a.position - b.position;
	                    }).map(function (notationScale, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: index },
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    href: '',
	                                    className: _UpdateNotationScaleOfCampaignPopover2.default.remove,
	                                    onClick: function onClick(e) {
	                                        return form.newNotationScale.remove(e, notationScale);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    notationScale.position
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    ' - ',
	                                    notationScale.label
	                                )
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'form',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 3 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'position',
	                                placeholder: _i18n2.default.notationScalePosition
	                            }, (0, _form.integerField)(form.newNotationScale.position())))
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 9 },
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'text',
	                                name: 'label',
	                                placeholder: _i18n2.default.notationScaleLabel
	                            }, form.newNotationScale.label()))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    form.newNotationScale.isValid() && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick(e) {
	                                return form.newNotationScale.add(e);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.addNotationScale
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: function onClick(e) {
	                                return form.newNotationScale.remove(e);
	                            } },
	                        _react2.default.createElement(_Icon2.default, { icon: 'minus', size: 'xs' }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n2.default.remove
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateNotationScaleOfCampaignPopover;
	}(_react.Component);
	
	UpdateNotationScaleOfCampaignPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateNotationScaleOfCampaignPopover = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.UpdateNotationScaleOfCampaignAction.schema,
	    action: _actions.UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED
	})(UpdateNotationScaleOfCampaignPopover);
	
	UpdateNotationScaleOfCampaignPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        campaign: state.satisfaction.campaign.campaign,
	        action: state.satisfaction.updateNotationScaleOfCampaignAction
	    };
	})(UpdateNotationScaleOfCampaignPopover);
	
	exports.default = UpdateNotationScaleOfCampaignPopover;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(146);
	
	var _models = __webpack_require__(279);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function actionUpdate(campaign) {
	    return {
	        newTitle: campaign.title
	    };
	}
	
	var UpdateTitleOfCampaignPopover = function (_Component) {
	    _inherits(UpdateTitleOfCampaignPopover, _Component);
	
	    function UpdateTitleOfCampaignPopover() {
	        _classCallCheck(this, UpdateTitleOfCampaignPopover);
	
	        return _possibleConstructorReturn(this, (UpdateTitleOfCampaignPopover.__proto__ || Object.getPrototypeOf(UpdateTitleOfCampaignPopover)).apply(this, arguments));
	    }
	
	    _createClass(UpdateTitleOfCampaignPopover, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                campaign = _props.campaign;
	
	            var update = actionUpdate(campaign);
	
	            dispatch((0, _actions.updateUpdateTitleOfCampaignAction)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.campaign != this.props.campaign) {
	                var dispatch = nextProps.dispatch,
	                    campaign = nextProps.campaign;
	
	                var update = actionUpdate(campaign);
	
	                dispatch((0, _actions.updateUpdateTitleOfCampaignAction)(update));
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdateTitleOfCampaignAction)()).then(function () {
	                return dispatch((0, _actions.loadCampaign)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                campaign = _props3.campaign,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'campaign', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Popover,
	                _extends({
	                    title: _i18n2.default.notationScale
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'label',
	                        label: requiredLabel(_i18n2.default.title)
	                    }, form.newTitle()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsSize: 'large',
	                            onClick: onHide },
	                        _i18n2.default.cancel
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateTitleOfCampaignPopover;
	}(_react.Component);
	
	UpdateTitleOfCampaignPopover.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateTitleOfCampaignPopover = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.UpdateTitleOfCampaignAction.schema,
	    action: _actions.UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED
	})(UpdateTitleOfCampaignPopover);
	
	UpdateTitleOfCampaignPopover = (0, _reactRedux.connect)(function (state) {
	    return {
	        campaign: state.satisfaction.campaign.campaign,
	        action: state.satisfaction.updateTitleOfCampaignAction
	    };
	})(UpdateTitleOfCampaignPopover);
	
	exports.default = UpdateTitleOfCampaignPopover;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (error) {
	    return (0, _extract2.default)(_i18n2.default.errorTypeEnum, error.type, null);
	};
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(130);
	
	var _i18n2 = _interopRequireDefault(_i18n);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(146);
	
	var campaign = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CAMPAIGN_STREAM_LOADED:
	            case _actions.CAMPAIGN_STREAM_QUERIED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function _links() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CAMPAIGN_LINKS_LOADED:
	            case _actions.CAMPAIGN_STREAM_LOADED:
	            case _actions.CAMPAIGN_STREAM_QUERIED:
	                return action._links;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CAMPAIGN_STREAM_LOADED:
	            case _actions.CAMPAIGN_STREAM_QUERIED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    function campaign() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.CAMPAIGN_LOADED:
	            case _actions.CAMPAIGN_QUERIED:
	                return action.campaign;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ stream: stream, _links: _links, query: query, campaign: campaign });
	}();
	
	var answer = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.ANSWER_STREAM_LOADED:
	            case _actions.ANSWER_STREAM_QUERIED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function range() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.ANSWER_STREAM_LOADED:
	            case _actions.ANSWER_STREAM_QUERIED:
	                return action.range;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.ANSWER_STREAM_LOADED:
	            case _actions.ANSWER_STREAM_QUERIED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ stream: stream, range: range, query: query });
	}();
	
	function createCampaignAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CREATE_CAMPAIGN_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.CREATE_CAMPAIGN_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateNotationScaleOfCampaignAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateTitleOfCampaignAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function addQuestionToCampaignAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineAnswerRateGoalAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.DEFINE_ANSWER_RATE_GOAL_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function startCampaignAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.START_CAMPAIGN_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.START_CAMPAIGN_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function answerAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ANSWER_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.ANSWER_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	exports.default = (0, _redux.combineReducers)({
	    answer: answer,
	    campaign: campaign,
	    createCampaignAction: createCampaignAction,
	    updateNotationScaleOfCampaignAction: updateNotationScaleOfCampaignAction,
	    updateTitleOfCampaignAction: updateTitleOfCampaignAction,
	    addQuestionToCampaignAction: addQuestionToCampaignAction,
	    defineAnswerRateGoalAction: defineAnswerRateGoalAction,
	    startCampaignAction: startCampaignAction,
	    answerAction: answerAction
	});

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _SimplifiedRequest = __webpack_require__(1819);
	
	var _SimplifiedRequest2 = _interopRequireDefault(_SimplifiedRequest);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Icon = __webpack_require__(925);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimplifiedRequest = function (_Component) {
	    _inherits(SimplifiedRequest, _Component);
	
	    function SimplifiedRequest() {
	        _classCallCheck(this, SimplifiedRequest);
	
	        return _possibleConstructorReturn(this, (SimplifiedRequest.__proto__ || Object.getPrototypeOf(SimplifiedRequest)).apply(this, arguments));
	    }
	
	    _createClass(SimplifiedRequest, [{
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Demandes' }),
	                _react2.default.createElement('base', { href: this.props.location.pathname + '/' }),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(_reactElmComponents2.default, { src: _SimplifiedRequest2.default.Elm.SimplifiedRequest, flags: { apiUrl: _config2.default.api.url, icons: Object.entries(_Icon2.default) } })
	                )
	            );
	        }
	    }]);
	
	    return SimplifiedRequest;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)()(SimplifiedRequest);

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _SimplifiedRequestDetail = __webpack_require__(1821);
	
	var _SimplifiedRequestDetail2 = _interopRequireDefault(_SimplifiedRequestDetail);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Icon = __webpack_require__(925);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _fetchz = __webpack_require__(86);
	
	var _actions = __webpack_require__(38);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRandomInts = function getRandomInts(n) {
	    var randInts = new Uint32Array(n);
	    crypto.getRandomValues(randInts);
	    return Array.from(randInts);
	};
	
	var SimplifiedRequestDetail = function (_Component) {
	    _inherits(SimplifiedRequestDetail, _Component);
	
	    function SimplifiedRequestDetail() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SimplifiedRequestDetail);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimplifiedRequestDetail.__proto__ || Object.getPrototypeOf(SimplifiedRequestDetail)).call.apply(_ref, [this].concat(args))), _this), _this.setupPorts = function (ports) {
	            ports.dispatch.subscribe(_this.subscribeDispatch);
	        }, _this.subscribeDispatch = function (msg) {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                authenticated = _this$props.authenticated;
	            var companyUid = msg.companyUid,
	                categoryUid = msg.categoryUid,
	                patrimonyUid = msg.patrimonyUid,
	                userUid = msg.userUid,
	                request = msg.request,
	                requestUid = msg.requestUid,
	                contactToCallback = msg.contactToCallback;
	
	
	            Promise.all([fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonycontacts', { patrimonyuids: patrimonyUid }), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref2) {
	                var json = _ref2.json;
	                var result = json.result;
	
	                return result.find(function (c) {
	                    return c.patrimonyUserState && c.patrimonyUserState.userUid === userUid;
	                });
	            }), fetch((0, _fetchz.apiUrl)(_config2.default.api.url + '/patrimonies/' + patrimonyUid), (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref3) {
	                var json = _ref3.json;
	
	                // 1er complementary checker
	                // ou 1er addresses checker
	                // ou 1er complementary
	                // ou 1er addresses
	                return json;
	            })]).then(function (_ref4) {
	                var _ref5 = _slicedToArray(_ref4, 2),
	                    user = _ref5[0],
	                    patrimony = _ref5[1];
	
	                var addresses = patrimony.addresses,
	                    complementaryAddresses = patrimony.complementaryAddresses;
	
	                var _ref6 = complementaryAddresses.find(function (a) {
	                    return a.geolocation;
	                }) || addresses.find(function (a) {
	                    return a.geolocation;
	                }) || complementaryAddresses[0] || addresses[0],
	                    uid = _ref6.uid,
	                    checker = _ref6.checker,
	                    geoLocation = _ref6.geoLocation,
	                    building = _ref6.building,
	                    addr = _objectWithoutProperties(_ref6, ['uid', 'checker', 'geoLocation', 'building']);
	
	                var action = (0, _actions.updateOpenTicketCmd)({
	                    locationRef: {
	                        locationReferenceType: 'PatrimonyLocation',
	                        patrimonyUid: patrimony // uniquement dans le store, la patrimonyUid est extrait après
	                    },
	                    ticket: {
	                        callerz: {
	                            callerType: 'ReferencedContactCaller',
	                            uid: user
	                        },
	                        address: addr,
	                        contactToCallback: contactToCallback,
	                        request: 'Description du demandeur: ' + request + '\n'
	                    },
	                    company: {
	                        uid: companyUid
	                    },
	                    otp: {
	                        criteria: {
	                            categoryUid: categoryUid
	                        }
	                    },
	                    requestUid: requestUid,
	                    skipActor: true
	                });
	                dispatch(action);
	
	                if (authenticated.userType === 'callCenterOperator' || authenticated.userType === 'callCenterUser') {
	                    dispatch((0, _reactRouterRedux.push)('/openticket'));
	                    return;
	                }
	                dispatch((0, _reactRouterRedux.push)('/tickets/new'));
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SimplifiedRequestDetail, [{
	        key: 'render',
	        value: function render() {
	            var randInts = getRandomInts(5);
	            var routeParams = this.props.routeParams;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Demande' }),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(_reactElmComponents2.default, { src: _SimplifiedRequestDetail2.default.Elm.SimplifiedRequestDetail, ports: this.setupPorts, flags: { apiUrl: _config2.default.api.url, requestUid: routeParams.id, seedInfos: [randInts[0], randInts.slice(1)] } })
	                )
	            );
	        }
	    }]);
	
	    return SimplifiedRequestDetail;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated
	    };
	})(SimplifiedRequestDetail);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SimplifiedRequest = __webpack_require__(1493);
	
	var _SimplifiedRequest2 = _interopRequireDefault(_SimplifiedRequest);
	
	var _SimplifiedRequestDetail = __webpack_require__(1494);
	
	var _SimplifiedRequestDetail2 = _interopRequireDefault(_SimplifiedRequestDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (dispatcher, store) {
	    return {
	        path: '/simplifiedrequests',
	        indexRoute: {
	            component: _SimplifiedRequest2.default
	        },
	        childRoutes: [{
	            path: ':id',
	            component: _SimplifiedRequestDetail2.default
	        }]
	    };
	};

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _jjv = __webpack_require__(172);
	
	var _jjv2 = _interopRequireDefault(_jjv);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _hydrate = __webpack_require__(1121);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function criteriaUpdated() {
	    var criteria;
	
	    return function (state, dispatch) {
	        var nextCriteria = state.ticket.criteria;
	
	        if (nextCriteria != criteria) {
	
	            if (nextCriteria.status != (criteria && criteria.status) || nextCriteria.intervention != (criteria && criteria.intervention) || nextCriteria.location != (criteria && criteria.location) || nextCriteria.clientCompany != (criteria && criteria.clientCompany) || nextCriteria.agency != (criteria && criteria.agency) || nextCriteria.patrimony != (criteria && criteria.patrimony) || nextCriteria.callPurpose != (criteria && criteria.callPurpose) || nextCriteria.from != (criteria && criteria.from) || nextCriteria.to != (criteria && criteria.to)) {
	
	                var location = state.router.location;
	
	                dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, nextCriteria))).then(function () {
	                    if (['/tickets', '/tickets/dashboard'].indexOf(location.pathname) < 0) {
	                        dispatch((0, _reactRouterRedux.push)('/tickets'));
	                    }
	                });
	            }
	            criteria = nextCriteria;
	        }
	    };
	}
	
	function openTicketCmdUpdated() {
	    var cmd;
	
	    var validator = (0, _jjv2.default)();
	    var addressSchema = _models.OpenTicketCmd.schema.properties.ticket.properties.address;
	
	    function computeLocationRef(locationRef) {
	        if (locationRef && locationRef.locationReferenceType == 'PatrimonyLocation') return _extends({}, locationRef, { agencyUid: null });
	        if (locationRef && locationRef.locationReferenceType == 'AgencyLocation') return _extends({}, locationRef, { patrimonyUid: null });
	        return { locationReferenceType: 'PatrimonyLocation' };
	    }
	
	    function computeCaller(caller, address, locationRef) {
	        if (!address && !(locationRef && locationRef.patrimonyUid) && !(locationRef && locationRef.agencyUid)) return { callerType: 'ReferencedContactCaller' };
	        if (locationRef && locationRef.agencyUid) return caller && caller.callerType == 'HumanCaller' && caller || { callerType: 'HumanCaller' };
	        if (caller && caller.callerType == 'HumanCaller') return caller;
	        if (caller && caller.callerType == 'ReferencedContactCaller' && caller.uid) return caller;
	        return { callerType: 'HumanCaller' };
	    }
	
	    return function (state, dispatch) {
	        var nextCmd = state.ticket.openTicketCmd;
	
	        if (nextCmd != cmd && nextCmd && !nextCmd.skipActor) {
	
	            if (nextCmd && nextCmd.ticket != (cmd && cmd.ticket) && nextCmd.ticket && nextCmd.ticket.address != (cmd && cmd.ticket && cmd.ticket.address)) {
	                var address = nextCmd.ticket.address;
	                var callerz = nextCmd.ticket.callerz;
	
	                var nextLocationRef = computeLocationRef(null);
	                var nextCallerz = computeCaller(null, address, nextLocationRef);
	
	                nextCmd = { ticket: _extends({}, nextCmd.ticket, { callerz: nextCallerz }), locationRef: nextLocationRef };
	                dispatch((0, _actions.updateOpenTicketCmd)(nextCmd));
	            }
	
	            if (nextCmd && nextCmd.locationRef != (cmd && cmd.locationRef)) {
	                var locationRef = nextCmd.locationRef;
	                var _address = nextCmd.ticket && nextCmd.ticket.address;
	                var _callerz = nextCmd.ticket && nextCmd.ticket.callerz;
	
	                var _nextLocationRef = computeLocationRef(locationRef);
	                var isAddressValid = _address && !validator.validate(addressSchema, _address);
	                var patrimony = _nextLocationRef && _nextLocationRef.patrimonyUid;
	                var nextAddress = !isAddressValid && patrimony && [].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses))[0] || _address;
	                var _nextCallerz = computeCaller(_callerz, nextAddress, _nextLocationRef);
	
	                nextCmd = { ticket: _extends({}, nextCmd.ticket, { address: nextAddress, callerz: _nextCallerz }), locationRef: _nextLocationRef };
	                dispatch((0, _actions.updateOpenTicketCmd)(nextCmd));
	            }
	            cmd = nextCmd;
	        }
	    };
	}
	
	function correctLocationReferenceCmd() {
	    var cmd;
	
	    var validator = (0, _jjv2.default)();
	    var addressSchema = _models.OpenTicketCmd.schema.properties.ticket.properties.address;
	
	    return function (state, dispatch) {
	        var nextCmd = state.ticket.correctLocationReferenceCmd;
	
	        if (nextCmd != cmd && nextCmd && !nextCmd.skipActor) {
	
	            if (nextCmd && nextCmd.locationRef != (cmd && cmd.locationRef)) {
	                var locationRef = nextCmd.locationRef;
	                var address = nextCmd.ticket && nextCmd.ticket.address;
	
	                var isAddressValid = address && !validator.validate(addressSchema, address);
	                var patrimony = locationRef && locationRef.patrimonyUid;
	                var nextAddress = !isAddressValid && patrimony && [].concat(_toConsumableArray(patrimony.addresses), _toConsumableArray(patrimony.complementaryAddresses))[0] || address;
	
	                nextCmd = { ticket: _extends({}, nextCmd.ticket, { address: nextAddress }), locationRef: locationRef };
	                dispatch((0, _actions.updateCorrectLocationReferenceCmd)(nextCmd));
	            }
	            cmd = nextCmd;
	        }
	    };
	}
	
	function emitCallToCmdUpdated() {
	    var cmd;
	
	    return function (state, dispatch) {
	        var nextCmd = state.ticket.emitCallToCmd;
	
	        if (nextCmd != cmd) {
	
	            if (nextCmd && nextCmd.medium != (cmd && cmd.medium)) {
	                var phone = cmd && cmd.medium && (0, _phonez2.default)(cmd.medium.phone).format() || _i18n2.default.phonePlaceholder;
	                var comment = nextCmd.comment;
	                var nextPhone = nextCmd.medium && (0, _phonez2.default)(nextCmd.medium.phone).format() || _i18n2.default.phonePlaceholder;
	
	                var nextComment = comment && comment.replace(phone, nextPhone);
	                dispatch((0, _actions.updateEmitCallToCmd)({ comment: nextComment }));
	            }
	
	            cmd = nextCmd;
	        }
	    };
	}
	
	function dehydrateNamespaceUpdated() {
	    var namespace;
	
	    return function (state, dispatch) {
	        var nextNamespace = state.ticket;
	
	        if (nextNamespace != namespace) {
	
	            if (nextNamespace.exportXlsxTicketsOption != (namespace && namespace.exportXlsxTicketsOption) || nextNamespace.exportPdfTicketsOption != (namespace && namespace.exportPdfTicketsOption) || nextNamespace.reportPdfTicketsOption != (namespace && namespace.reportPdfTicketsOption)) {
	                localStorage.setItem(_hydrate.DEHYDRATE_KEY, JSON.stringify({
	                    ticket: {
	                        exportXlsxTicketsOption: nextNamespace.exportXlsxTicketsOption,
	                        exportPdfTicketsOption: nextNamespace.exportPdfTicketsOption,
	                        reportPdfTicketsOption: nextNamespace.reportPdfTicketsOption
	                    }
	                }));
	            }
	            namespace = nextNamespace;
	        }
	    };
	}
	
	exports.default = [criteriaUpdated(), openTicketCmdUpdated(), dehydrateNamespaceUpdated(), emitCallToCmdUpdated(), correctLocationReferenceCmd()];

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _SendInterventionInfoToAssignee = __webpack_require__(1115);
	
	var _SendInterventionInfoToAssignee2 = _interopRequireDefault(_SendInterventionInfoToAssignee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AcceptRefuseInterventionCard = function (_Component) {
	    _inherits(AcceptRefuseInterventionCard, _Component);
	
	    function AcceptRefuseInterventionCard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AcceptRefuseInterventionCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AcceptRefuseInterventionCard.__proto__ || Object.getPrototypeOf(AcceptRefuseInterventionCard)).call.apply(_ref, [this].concat(args))), _this), _this.emailStuff = function () {
	            var assignee = _this.props.assignee;
	
	            return _react2.default.createElement(_SendInterventionInfoToAssignee2.default, { assignee: assignee });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AcceptRefuseInterventionCard, [{
	        key: '_sendAcceptCmd',
	        value: function _sendAcceptCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendAcceptInterventionCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            });
	        }
	    }, {
	        key: '_sendRefuseCmd',
	        value: function _sendRefuseCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendRefuseInterventionCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                acceptInterventionCmd = _props.acceptInterventionCmd,
	                others = _objectWithoutProperties(_props, ['dispatch', 'acceptInterventionCmd']);
	
	            var accepted = acceptInterventionCmd.accepted;
	
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.interventionAcceptation
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: header
	                    }, others),
	                    this.emailStuff(),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                disabled: !accepted,
	                                onClick: function onClick(e) {
	                                    return _this2._sendAcceptCmd(e);
	                                } },
	                            _i18n2.default.acceptIntervention
	                        ),
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick(e) {
	                                    return _this2._sendRefuseCmd(e);
	                                } },
	                            _i18n2.default.refuseIntervention
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AcceptRefuseInterventionCard;
	}(_react.Component);
	
	AcceptRefuseInterventionCard.propTypes = {};
	
	
	AcceptRefuseInterventionCard = (0, _reactRedux.connect)(function (_ref2) {
	    var ticket = _ref2.ticket;
	    var acceptInterventionCmd = ticket.acceptInterventionCmd;
	
	    return { acceptInterventionCmd: acceptInterventionCmd };
	})(AcceptRefuseInterventionCard);
	
	exports.default = AcceptRefuseInterventionCard;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _models = __webpack_require__(49);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddMessageCard = function (_Component) {
	    _inherits(AddMessageCard, _Component);
	
	    function AddMessageCard() {
	        _classCallCheck(this, AddMessageCard);
	
	        return _possibleConstructorReturn(this, (AddMessageCard.__proto__ || Object.getPrototypeOf(AddMessageCard)).apply(this, arguments));
	    }
	
	    _createClass(AddMessageCard, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendAddMessageCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                cmd = _props.cmd,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'cmd']);
	
	            var header = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.addMessage
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: header
	                    }, others),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'textarea',
	                        rows: 5
	                    }, (0, _form.controlledField)(form.message()))),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.add
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddMessageCard;
	}(_react.Component);
	
	AddMessageCard.propTypes = {};
	
	
	AddMessageCard = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.AddMessageCmd.schema,
	    action: _actions.ADD_MESSAGE_CMD_UPDATED
	})(AddMessageCard);
	
	AddMessageCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.addMessageCmd
	    };
	})(AddMessageCard);
	
	exports.default = AddMessageCard;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _PercentageDashboardPanel = __webpack_require__(891);
	
	var _PercentageDashboardPanel2 = _interopRequireDefault(_PercentageDashboardPanel);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function agencyFilter(restrict) {
	    restrict = restrict && (restrict instanceof Array && restrict || [restrict]) || [];
	
	    return function (agency) {
	        if (restrict.length > 0) {
	            return !!restrict.find(function (r) {
	                return r.value == agency.value;
	            });
	        }
	        return true;
	    };
	}
	
	var AgencyDashboardPanel = function (_Component) {
	    _inherits(AgencyDashboardPanel, _Component);
	
	    function AgencyDashboardPanel(props) {
	        _classCallCheck(this, AgencyDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (AgencyDashboardPanel.__proto__ || Object.getPrototypeOf(AgencyDashboardPanel)).call(this, props));
	
	        _this.state = {
	            filteredAgencies: []
	        };
	        return _this;
	    }
	
	    _createClass(AgencyDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                aggregations = _props.aggregations,
	                query = _props.query;
	
	
	            var filteredAgencies = aggregations.agencies.filter(agencyFilter(query.agency));
	            this.setState({ filteredAgencies: filteredAgencies });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.aggregations != this.props.aggregations || nextProps.query != this.props.query) {
	                var aggregations = nextProps.aggregations,
	                    query = nextProps.query;
	
	
	                var filteredAgencies = aggregations.agencies.filter(agencyFilter(query.agency));
	                this.setState({ filteredAgencies: filteredAgencies });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                aggregations = _props2.aggregations,
	                query = _props2.query,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'aggregations', 'query']);
	
	            var filteredAgencies = this.state.filteredAgencies;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(_PercentageDashboardPanel2.default, _extends({
	                header: panelHeader(_i18n2.default.byAgency),
	                display: function display(m) {
	                    return m.label;
	                },
	                identify: function identify(m) {
	                    return m.count;
	                },
	                value: filteredAgencies
	            }, others));
	        }
	    }]);
	
	    return AgencyDashboardPanel;
	}(_react.Component);
	
	AgencyDashboardPanel.propTypes = {};
	
	
	AgencyDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        aggregations: state.ticket.aggregations,
	        query: state.ticket.query
	    };
	})(AgencyDashboardPanel);
	
	exports.default = AgencyDashboardPanel;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _RadioToggle = __webpack_require__(544);
	
	var _RadioToggle2 = _interopRequireDefault(_RadioToggle);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Tag = __webpack_require__(955);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _DayPicker = __webpack_require__(276);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _TimePicker = __webpack_require__(957);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _models = __webpack_require__(49);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _CloseTicketCard = __webpack_require__(2316);
	
	var _CloseTicketCard2 = _interopRequireDefault(_CloseTicketCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function restrict(allowed, value) {
	    if (value) return allowed.indexOf(value) >= 0 && value || undefined;
	    return undefined;
	}
	
	var CloseTicketCard = function (_Component) {
	    _inherits(CloseTicketCard, _Component);
	
	    function CloseTicketCard(props) {
	        _classCallCheck(this, CloseTicketCard);
	
	        var _this = _possibleConstructorReturn(this, (CloseTicketCard.__proto__ || Object.getPrototypeOf(CloseTicketCard)).call(this, props));
	
	        _this._sendInterventionCmd = function () {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                startInterventionForm = _this$props.startInterventionForm,
	                finishInterventionForm = _this$props.finishInterventionForm;
	
	
	            return Promise.resolve(true).then(function () {
	                return startInterventionForm.isValid() && dispatch((0, _actions.sendStartInterventionCmd)());
	            }).then(function () {
	                return finishInterventionForm.isValid() && dispatch((0, _actions.sendFinishInterventionCmd)());
	            }).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            });
	        };
	
	        _this.state = {
	            cmdTypes: []
	        };
	        return _this;
	    }
	
	    _createClass(CloseTicketCard, [{
	        key: '_initInterventionDates',
	        value: function _initInterventionDates(ticket, dispatch) {
	            var iStarted = ticket.journal.filter(function (e) {
	                return e.eventName === 'InterventionStarted';
	            }).map(function (e) {
	                return [new Date(e.data.sentDate), e];
	            }).sort(function (d1, d2) {
	                return d2[0].getTime() - d1[0].getTime();
	            });
	
	            var iFinished = ticket.journal.filter(function (e) {
	                return e.eventName === 'InterventionFinished';
	            }).map(function (e) {
	                return [new Date(e.data.sentDate), e];
	            }).sort(function (d1, d2) {
	                return d2[0].getTime() - d1[0].getTime();
	            });
	
	            var interventionStarted = iStarted && iStarted.length > 0 ? iStarted[0][1].date : null;
	            var interventionFinished = iFinished && iFinished.length > 0 ? iFinished[0][1].date : null;
	
	            dispatch((0, _actions.updateStartInterventionCmd)({ startedDate: interventionStarted && (0, _moment2.default)(interventionStarted).format() }));
	            dispatch((0, _actions.updateFinishInterventionCmd)({ finishedDate: interventionFinished && (0, _moment2.default)(interventionFinished).format() }));
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                closeTicketCmd = _props.closeTicketCmd,
	                ticket = _props.ticket;
	
	
	            var cmdTypes = _models.CLOSE_TICKET_CMD_TYPES.filter((0, _links.relFilter)(ticket._links));
	            this.setState({ cmdTypes: cmdTypes });
	
	            dispatch((0, _actions.updateCloseTicketCmd)({
	                commandType: restrict(cmdTypes, closeTicketCmd && closeTicketCmd.commandType)
	            }));
	
	            this._initInterventionDates(ticket, dispatch);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket != this.props.ticket) {
	                var dispatch = nextProps.dispatch,
	                    closeTicketCmd = nextProps.closeTicketCmd,
	                    ticket = nextProps.ticket;
	
	
	                var cmdTypes = _models.CLOSE_TICKET_CMD_TYPES.filter((0, _links.relFilter)(ticket._links));
	                this.setState({ cmdTypes: cmdTypes });
	
	                dispatch((0, _actions.updateCloseTicketCmd)({
	                    commandType: restrict(cmdTypes, closeTicketCmd && closeTicketCmd.commandType)
	                }));
	
	                this._initInterventionDates(ticket, dispatch);
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return Promise.resolve(true) /*.then(() => {
	                                         return startInterventionForm.isValid() && dispatch(sendStartInterventionCmd())
	                                         }).then(() => {
	                                         return finishInterventionForm.isValid() && dispatch(sendFinishInterventionCmd())
	                                         })*/.then(function () {
	                return dispatch((0, _actions.sendCloseTicketCmd)());
	            }).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, name) {
	            event.preventDefault();
	            this.setState({ openedModal: name });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                startInterventionForm = _props2.startInterventionForm,
	                finishInterventionForm = _props2.finishInterventionForm,
	                closeTicketForm = _props2.closeTicketForm,
	                startInterventionCmd = _props2.startInterventionCmd,
	                finishInterventionCmd = _props2.finishInterventionCmd,
	                closeTicketCmd = _props2.closeTicketCmd,
	                ticket = _props2.ticket,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'startInterventionForm', 'finishInterventionForm', 'closeTicketForm', 'startInterventionCmd', 'finishInterventionCmd', 'closeTicketCmd', 'ticket']);
	
	            var _state = this.state,
	                cmdTypes = _state.cmdTypes,
	                openedModal = _state.openedModal;
	
	
	            var cmdTypeCheckbox = function cmdTypeCheckbox(cmdType) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: cmdType },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                        _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            value: cmdType }),
	                        (0, _extract2.default)(_i18n2.default.cmdTypeEnum, cmdType)
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({ header: _react2.default.createElement(
	                            'h5',
	                            null,
	                            _i18n2.default.interventionDetail
	                        )
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(_reactBootstrap.Col, { sm: 1 }),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 5 },
	                                ticket._links.find((0, _links.linkFinder)('StartIntervention')) && _react2.default.createElement(
	                                    'p',
	                                    { className: _CloseTicketCard2.default.interventionDate },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: function onClick(e) {
	                                                return _this2._openModal(e, 'StartInterventionModal');
	                                            } },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'calendar', size: 'xs' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            _i18n2.default.startInterventionDate,
	                                            ' : '
	                                        ),
	                                        !(startInterventionCmd && startInterventionCmd.startedDate) && _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                                    ),
	                                    _react2.default.createElement(_Tag2.default, _extends({
	                                        size: 'sm',
	                                        position: 'right',
	                                        display: function display(d) {
	                                            return (0, _moment2.default)(d).format(_i18n2.default.dateTimeFormat.default);
	                                        }
	                                    }, startInterventionForm.startedDate()))
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 5 },
	                                ticket._links.find((0, _links.linkFinder)('FinishIntervention')) && _react2.default.createElement(
	                                    'p',
	                                    { className: _CloseTicketCard2.default.interventionDate },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: function onClick(e) {
	                                                return _this2._openModal(e, 'FinishInterventionModal');
	                                            } },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'calendar', size: 'xs' }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' ',
	                                            _i18n2.default.finishInterventionDate,
	                                            ' : '
	                                        ),
	                                        !(finishInterventionCmd && finishInterventionCmd.finishedDate) && _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                                    ),
	                                    _react2.default.createElement(_Tag2.default, _extends({
	                                        size: 'sm',
	                                        position: 'right',
	                                        display: function display(d) {
	                                            return (0, _moment2.default)(d).format(_i18n2.default.dateTimeFormat.default);
	                                        }
	                                    }, finishInterventionForm.finishedDate()))
	                                )
	                            ),
	                            _react2.default.createElement(_reactBootstrap.Col, { sm: 1 })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    disabled: !(startInterventionForm.isValid() || finishInterventionForm.isValid()),
	                                    onClick: this._sendInterventionCmd },
	                                _i18n2.default.interventionFilled
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: _react2.default.createElement(
	                            'h5',
	                            null,
	                            _i18n2.default.closeTicket
	                        )
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _CloseTicketCard2.default.cmdType },
	                        _react2.default.createElement(
	                            _RadioToggle2.default,
	                            closeTicketForm.commandType(),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 4 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        cmdTypes.slice(0, 2).map(cmdTypeCheckbox)
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 4 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        cmdTypes.slice(2, 4).map(cmdTypeCheckbox)
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 4 },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        null,
	                                        cmdTypes.slice(4, 6).map(cmdTypeCheckbox)
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 12 },
	                            closeTicketForm.report && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'textarea',
	                                placeholder: _i18n2.default.closingReport
	                            }, closeTicketForm.report())),
	                            closeTicketForm.comment && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                type: 'textarea',
	                                placeholder: _i18n2.default.comment
	                            }, closeTicketForm.comment()))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !closeTicketForm.isValid() }),
	                                onClick: function onClick() {
	                                    return closeTicketForm.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.closeTicket
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    {
	                        bsSize: 'small',
	                        show: openedModal == 'StartInterventionModal',
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            _i18n2.default.startInterventionDate
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _CloseTicketCard2.default.interventionDateTimePicker },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _CloseTicketCard2.default.container },
	                                _react2.default.createElement(_DayPicker2.default, startInterventionForm.startedDate()),
	                                _react2.default.createElement(_TimePicker2.default, startInterventionForm.startedDate())
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    {
	                        bsSize: 'small',
	                        show: openedModal == 'FinishInterventionModal',
	                        onHide: function onHide() {
	                            return _this2._closeModal();
	                        } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            _i18n2.default.finishInterventionDate
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _CloseTicketCard2.default.interventionDateTimePicker },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _CloseTicketCard2.default.container },
	                                _react2.default.createElement(_DayPicker2.default, finishInterventionForm.finishedDate()),
	                                _react2.default.createElement(_TimePicker2.default, finishInterventionForm.finishedDate())
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CloseTicketCard;
	}(_react.Component);
	
	CloseTicketCard.propTypes = {};
	
	
	CloseTicketCard = (0, _form.connectForm)({
	    name: 'startInterventionForm',
	    target: 'startInterventionCmd',
	    alias: 'cmd',
	    schema: _models.StartInterventionCmd.schema,
	    action: _actions.START_INTERVENTION_CMD_UPDATED
	})(CloseTicketCard);
	
	CloseTicketCard = (0, _form.connectForm)({
	    name: 'finishInterventionForm',
	    target: 'finishInterventionCmd',
	    alias: 'cmd',
	    schema: _models.FinishInterventionCmd.schema,
	    action: _actions.FINISH_INTERVENTION_CMD_UPDATED
	})(CloseTicketCard);
	
	CloseTicketCard = (0, _form.connectForm)({
	    name: 'closeTicketForm',
	    target: 'closeTicketCmd',
	    alias: 'cmd',
	    schema: _models.CloseTicketCmd.selectSchema,
	    action: _actions.CLOSE_TICKET_CMD_UPDATED
	})(CloseTicketCard);
	
	CloseTicketCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket,
	        startInterventionCmd: state.ticket.startInterventionCmd,
	        finishInterventionCmd: state.ticket.finishInterventionCmd,
	        closeTicketCmd: state.ticket.closeTicketCmd
	    };
	})(CloseTicketCard);
	
	exports.default = CloseTicketCard;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _PercentageDashboardPanel = __webpack_require__(891);
	
	var _PercentageDashboardPanel2 = _interopRequireDefault(_PercentageDashboardPanel);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClosingEventDashboardPanel = function (_Component) {
	    _inherits(ClosingEventDashboardPanel, _Component);
	
	    function ClosingEventDashboardPanel() {
	        _classCallCheck(this, ClosingEventDashboardPanel);
	
	        return _possibleConstructorReturn(this, (ClosingEventDashboardPanel.__proto__ || Object.getPrototypeOf(ClosingEventDashboardPanel)).apply(this, arguments));
	    }
	
	    _createClass(ClosingEventDashboardPanel, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                aggregations = _props.aggregations,
	                others = _objectWithoutProperties(_props, ['dispatch', 'aggregations']);
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(_PercentageDashboardPanel2.default, _extends({
	                header: panelHeader(_i18n2.default.closingEvent),
	                display: function display(m) {
	                    return (0, _extract2.default)(_i18n2.default.stateEnum, m.value);
	                },
	                identify: function identify(m) {
	                    return m.count;
	                },
	                value: aggregations.closingEvents
	            }, others));
	        }
	    }]);
	
	    return ClosingEventDashboardPanel;
	}(_react.Component);
	
	ClosingEventDashboardPanel.propTypes = {};
	
	
	ClosingEventDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        aggregations: state.ticket.aggregations
	    };
	})(ClosingEventDashboardPanel);
	
	exports.default = ClosingEventDashboardPanel;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function correctTicketEventInformationsUpdate(event) {
	    return {
	        targetedEvent: event.processUid,
	        text: undefined
	    };
	}
	
	var CorrectTicketEventInformationsModal = function (_Component) {
	    _inherits(CorrectTicketEventInformationsModal, _Component);
	
	    function CorrectTicketEventInformationsModal() {
	        _classCallCheck(this, CorrectTicketEventInformationsModal);
	
	        return _possibleConstructorReturn(this, (CorrectTicketEventInformationsModal.__proto__ || Object.getPrototypeOf(CorrectTicketEventInformationsModal)).apply(this, arguments));
	    }
	
	    _createClass(CorrectTicketEventInformationsModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                event = _props.event;
	
	            var update = correctTicketEventInformationsUpdate(event);
	
	            dispatch((0, _actions.updateCorrectTicketEventInformationsCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.event != this.props.event) {
	                var dispatch = nextProps.dispatch,
	                    event = nextProps.event;
	
	                var update = correctTicketEventInformationsUpdate(event);
	
	                dispatch((0, _actions.updateCorrectTicketEventInformationsCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendCorrectTicketEventInformationsCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                cmd = _props3.cmd,
	                event = _props3.event,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'cmd', 'event', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.correctTicketEventInformations
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'textarea',
	                            name: 'request',
	                            label: _i18n2.default.text
	                        }, (0, _form.updateField)(form.text(), event.data.message || event.data.comment)))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CorrectTicketEventInformationsModal;
	}(_react.Component);
	
	CorrectTicketEventInformationsModal.propTypes = {
	    event: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	CorrectTicketEventInformationsModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.CorrectTicketEventInformationsCmd.schema,
	    action: _actions.CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED
	})(CorrectTicketEventInformationsModal);
	
	CorrectTicketEventInformationsModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.correctTicketEventInformationsCmd
	    };
	})(CorrectTicketEventInformationsModal);
	
	exports.default = CorrectTicketEventInformationsModal;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CorrectTicketInformationsModal = function (_Component) {
	    _inherits(CorrectTicketInformationsModal, _Component);
	
	    function CorrectTicketInformationsModal() {
	        _classCallCheck(this, CorrectTicketInformationsModal);
	
	        return _possibleConstructorReturn(this, (CorrectTicketInformationsModal.__proto__ || Object.getPrototypeOf(CorrectTicketInformationsModal)).apply(this, arguments));
	    }
	
	    _createClass(CorrectTicketInformationsModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _actions.resetCorrectTicketInformationsCmd)());
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket != this.props.ticket) {
	                var dispatch = nextProps.dispatch;
	
	                dispatch((0, _actions.resetCorrectTicketInformationsCmd)());
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendCorrectTicketInformationsCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                ticket = _props2.ticket,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'ticket', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.correctTicketInformations
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'textarea',
	                            name: 'request',
	                            label: _i18n2.default.request
	                        }, (0, _form.updateField)(form.fieldsToCorrect.request(), ticket.request))),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'textarea',
	                            name: 'instructions',
	                            label: _i18n2.default.instructions
	                        }, (0, _form.updateField)(form.fieldsToCorrect.instructions(), ticket.instructions))),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'textarea',
	                            name: 'closingReport',
	                            label: _i18n2.default.closingReport
	                        }, (0, _form.updateField)(form.fieldsToCorrect.closingReport(), ticket.report)))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CorrectTicketInformationsModal;
	}(_react.Component);
	
	CorrectTicketInformationsModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	CorrectTicketInformationsModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.CorrectTicketInformationsCmd.schema,
	    validator: (0, _models.createValidator)(),
	    action: _actions.CORRECT_TICKET_INFORMATIONS_CMD_UPDATED
	})(CorrectTicketInformationsModal);
	
	CorrectTicketInformationsModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket,
	        cmd: state.ticket.correctTicketInformationsCmd
	    };
	})(CorrectTicketInformationsModal);
	
	exports.default = CorrectTicketInformationsModal;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _DayPicker = __webpack_require__(276);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _DefineInterventionDeadlineModal = __webpack_require__(2318);
	
	var _DefineInterventionDeadlineModal2 = _interopRequireDefault(_DefineInterventionDeadlineModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefineInterventionDeadlineModal = function (_Component) {
	    _inherits(DefineInterventionDeadlineModal, _Component);
	
	    function DefineInterventionDeadlineModal() {
	        _classCallCheck(this, DefineInterventionDeadlineModal);
	
	        return _possibleConstructorReturn(this, (DefineInterventionDeadlineModal.__proto__ || Object.getPrototypeOf(DefineInterventionDeadlineModal)).apply(this, arguments));
	    }
	
	    _createClass(DefineInterventionDeadlineModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendDefineInterventionDeadlineCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.defineInterventionDeadline
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DefineInterventionDeadlineModal2.default.datePicker },
	                        _react2.default.createElement(_DayPicker2.default, form.deadline())
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DefineInterventionDeadlineModal;
	}(_react.Component);
	
	DefineInterventionDeadlineModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	DefineInterventionDeadlineModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.DefineInterventionDeadlineCmd.schema,
	    action: _actions.DEFINE_INTERVENTION_DEADLINE_CMD_UPDATED
	})(DefineInterventionDeadlineModal);
	
	DefineInterventionDeadlineModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.defineInterventionDeadlineCmd
	    };
	})(DefineInterventionDeadlineModal);
	
	exports.default = DefineInterventionDeadlineModal;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _links2 = __webpack_require__(33);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _RadioToggle = __webpack_require__(544);
	
	var _RadioToggle2 = _interopRequireDefault(_RadioToggle);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _AnswerForm = __webpack_require__(1476);
	
	var _AnswerForm2 = _interopRequireDefault(_AnswerForm);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _EmitCallToModal = __webpack_require__(2319);
	
	var _EmitCallToModal2 = _interopRequireDefault(_EmitCallToModal);
	
	var _SendInterventionInfoToAssignee = __webpack_require__(1115);
	
	var _SendInterventionInfoToAssignee2 = _interopRequireDefault(_SendInterventionInfoToAssignee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function assigneeHintFilter(_links) {
	    return function (hint) {
	        switch (hint) {
	            case 'assigneeInterventionTransfer':
	                return !!_links.find((0, _links2.linkFinder)('RequestIntervention'));
	            default:
	                return true;
	        }
	    };
	}
	
	function restrictMediums(assignee, caller, contactToCallback, callType) {
	    switch (callType) {
	        case 'EmitCallToAssignee':
	            var mediums = [];
	            mediums.push.apply(mediums, _toConsumableArray(assignee.phones.map((0, _models.plainContactToContactMedium)('Phone'))));
	            mediums.push.apply(mediums, _toConsumableArray(assignee.emails.map((0, _models.plainContactToContactMedium)('Mail'))));
	            mediums.push.apply(mediums, _toConsumableArray(assignee.fax.map((0, _models.plainContactToContactMedium)('Fax'))));
	            return mediums;
	        case 'EmitCallToCaller':
	            return caller.medium.map(_models.mediumToContactMedium);
	        case 'EmitCallToContactToCallback':
	            return [(0, _models.mediumToContactMedium)(contactToCallback.medium)];
	        default:
	            return [];
	    }
	}
	
	function restrictRecipient(assignee, caller, contactToCallback, callType) {
	    switch (callType) {
	        case 'EmitCallToAssignee':
	            if (assignee.assigneeType == 'ProviderCompany') {
	                return {
	                    namez: {
	                        value: assignee.name,
	                        nameType: 'PoorName'
	                    },
	                    status: 'ProviderCompany',
	                    personaType: 'UnClassifiedPersona'
	                };
	            }
	            return {
	                provider: assignee,
	                personaType: 'ProviderPersona'
	            };
	        case 'EmitCallToCaller':
	            return {
	                namez: {
	                    value: caller.name,
	                    nameType: 'PoorName'
	                },
	                personaType: 'UnClassifiedPersona'
	            };
	        case 'EmitCallToContactToCallback':
	            return {
	                namez: {
	                    value: contactToCallback.name,
	                    nameType: 'PoorName'
	                },
	                personaType: 'UnClassifiedPersona'
	            };
	        default:
	            return {
	                namez: {
	                    nameType: 'PoorName'
	                },
	                personaType: 'UnClassifiedPersona'
	            };
	    }
	}
	
	function restrictCallTypes(assignee, caller, contactToCallback) {
	    var callTypes = [];
	
	    if (assignee === undefined || caller === undefined) {
	        callTypes.push('EmitCall');
	    }
	    if (assignee && caller) {
	        callTypes.push('EmitCall');
	    }
	    if (assignee) {
	        callTypes.push('EmitCallToAssignee');
	    }
	    if (caller) {
	        callTypes.push('EmitCallToCaller');
	    }
	    if (contactToCallback) {
	        callTypes.push('EmitCallToContactToCallback');
	    }
	
	    return callTypes;
	}
	
	function restrictHints(ticket, callType) {
	    switch (callType) {
	        case 'EmitCallToAssignee':
	            return _models.EMIT_CALL_TO_ASSIGNEE_HINTS.filter(assigneeHintFilter(ticket._links));
	        case 'EmitCallToCaller':
	            return _models.EMIT_CALL_TO_CALLER_HINTS;
	        case 'EmitCallToContactToCallback':
	            return _models.EMIT_CALL_TO_CALLER_HINTS;
	        default:
	            return [];
	    }
	}
	
	function restrictInterventionCmdTypes(ticket, hint) {
	    switch (hint) {
	        case 'assigneeInterventionTransfer':
	            return _models.INTERVENTION_CMD_TYPES.filter((0, _links2.relFilter)(ticket._links));
	        default:
	            return [];
	    }
	}
	
	var EmitCallToModal = function (_Component) {
	    _inherits(EmitCallToModal, _Component);
	
	    function EmitCallToModal(props) {
	        _classCallCheck(this, EmitCallToModal);
	
	        var _this = _possibleConstructorReturn(this, (EmitCallToModal.__proto__ || Object.getPrototypeOf(EmitCallToModal)).call(this, props));
	
	        _this._hide = function () {
	            var onHide = _this.props.onHide;
	
	            onHide();
	        };
	
	        _this.emailStuff = function () {
	            var _this$props = _this.props,
	                assignee = _this$props.assignee,
	                form = _this$props.form;
	            var _this$state = _this.state,
	                interventionCmdTypes = _this$state.interventionCmdTypes,
	                interventionCmdType = _this$state.interventionCmdType;
	
	
	            return interventionCmdTypes.length !== 0 && interventionCmdType === 'AcceptIntervention' && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    _i18n2.default.bonDintervention
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 9, smOffset: 3 },
	                        _react2.default.createElement(_SendInterventionInfoToAssignee2.default, { assignee: assignee })
	                    )
	                )
	            );
	        };
	
	        _this.state = {
	            hints: [],
	            interventionCmdTypes: []
	        };
	        return _this;
	    }
	
	    _createClass(EmitCallToModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket,
	                assignee = _props.assignee,
	                caller = _props.caller,
	                contactToCallback = _props.contactToCallback;
	
	
	            var callTypes = restrictCallTypes(assignee, caller, contactToCallback);
	            var callType = callTypes[0];
	            var hints = restrictHints(ticket, callType);
	
	            var recipient = restrictRecipient(assignee, caller, contactToCallback, callType);
	            var mediums = restrictMediums(assignee, caller, contactToCallback, callType);
	            var medium = undefined;
	            var comment = undefined;
	
	            dispatch((0, _actions.updateEmitCallToCmd)({ recipient: recipient, medium: medium, comment: comment }));
	            this.setState({ callTypes: callTypes, callType: callType, mediums: mediums, hints: hints });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket && this.props.ticket && nextProps.ticket.uid !== this.props.ticket.uid || nextProps.assignee && this.props.assignee && nextProps.assignee.uid !== this.props.assignee.uid || nextProps.caller !== this.props.caller || nextProps.contactToCallback !== this.props.contactToCallback) {
	                var dispatch = nextProps.dispatch,
	                    ticket = nextProps.ticket,
	                    assignee = nextProps.assignee,
	                    caller = nextProps.caller,
	                    contactToCallback = nextProps.contactToCallback;
	
	
	                var callTypes = restrictCallTypes(assignee, caller, contactToCallback);
	                var callType = callTypes[0];
	                var hints = restrictHints(ticket, callType);
	
	                var recipient = restrictRecipient(assignee, caller, contactToCallback, callType);
	                var mediums = restrictMediums(assignee, caller, contactToCallback, callType);
	
	                var medium = undefined;
	                var comment = undefined;
	                var hint = undefined;
	                var interventionCmdTypes = [];
	                var interventionCmdType = undefined;
	                var interventionAcceptedClicked = undefined;
	
	                dispatch((0, _actions.updateEmitCallToCmd)({ recipient: recipient, medium: medium, comment: comment, interventionAcceptedClicked: interventionAcceptedClicked }));
	                this.setState({ callTypes: callTypes, callType: callType, mediums: mediums, hints: hints, hint: hint, interventionCmdTypes: interventionCmdTypes, interventionCmdType: interventionCmdType });
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	            var _state = this.state,
	                hint = _state.hint,
	                interventionCmdType = _state.interventionCmdType;
	
	
	            var sendPromise;
	
	            if (hint == 'assigneeInterventionTransfer') {
	                sendPromise = dispatch((0, _actions.sendRequestInterventionCmd)()).then(function () {
	                    switch (interventionCmdType) {
	                        case 'AcceptIntervention':
	                            return dispatch((0, _actions.sendAcceptInterventionCmd)());
	                        case 'RefuseIntervention':
	                            return dispatch((0, _actions.sendRefuseInterventionCmd)());
	                    }
	                });
	            } else {
	                sendPromise = dispatch((0, _actions.sendEmitCallToCmd)());
	            }
	
	            return sendPromise.then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            });
	        }
	    }, {
	        key: '_validate',
	        value: function _validate() {
	            var form = this.props.form;
	            var answerForm = this.refs.answerForm;
	
	
	            return form.validate() && (!answerForm || answerForm.validate());
	        }
	    }, {
	        key: '_isValid',
	        value: function _isValid() {
	            var _props2 = this.props,
	                form = _props2.form,
	                acceptInterventionCmd = _props2.acceptInterventionCmd;
	
	            return form.isValid() && acceptInterventionCmd.accepted;
	        }
	    }, {
	        key: '_send',
	        value: function _send() {
	            var _this2 = this;
	
	            var answerForm = this.refs.answerForm;
	
	
	            return Promise.resolve().then(function () {
	                return answerForm && answerForm.sendAction();
	            }).then(function () {
	                return _this2._sendCmd();
	            }).then(this._hide);
	        }
	    }, {
	        key: '_toggleCallType',
	        value: function _toggleCallType(callType) {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                ticket = _props3.ticket,
	                assignee = _props3.assignee,
	                caller = _props3.caller,
	                contactToCallback = _props3.contactToCallback;
	
	
	            if (callType) {
	                var recipient = restrictRecipient(assignee, caller, contactToCallback, callType);
	                var mediums = restrictMediums(assignee, caller, contactToCallback, callType);
	                var hints = restrictHints(ticket, callType);
	                var medium = undefined;
	                var comment = undefined;
	                var hint = undefined;
	
	                dispatch((0, _actions.updateEmitCallToCmd)({ recipient: recipient, medium: medium, comment: comment }));
	                this.setState({ callType: callType, mediums: mediums, hints: hints, hint: hint });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                form = _props4.form,
	                cmd = _props4.cmd,
	                ticket = _props4.ticket,
	                assignee = _props4.assignee,
	                caller = _props4.caller,
	                contactToCallback = _props4.contactToCallback,
	                others = _objectWithoutProperties(_props4, ['dispatch', 'form', 'cmd', 'ticket', 'assignee', 'caller', 'contactToCallback']);
	
	            var _state2 = this.state,
	                callTypes = _state2.callTypes,
	                callType = _state2.callType,
	                mediums = _state2.mediums,
	                hints = _state2.hints,
	                hint = _state2.hint,
	                interventionCmdTypes = _state2.interventionCmdTypes,
	                interventionCmdType = _state2.interventionCmdType;
	            var answerForm = this.refs.answerForm;
	
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var inputAddon = function inputAddon(icon) {
	                return _react2.default.createElement(_Icon2.default, { icon: icon, size: 'xs' });
	            };
	
	            var mediumInputButton = function mediumInputButton(medium) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    (0, _form.buttonField)(form.medium(), medium),
	                    _react2.default.createElement(_Icon2.default, { icon: 'radio', size: 'xs' })
	                );
	            };
	
	            var mediumField = function mediumField(field, type) {
	                var disabled = field.value && field.value.contactMediumType != type || false;
	                var value;
	
	                switch (type) {
	                    case 'Phone':
	                        value = field.value && field.value.phone;
	                        break;
	                    case 'Mail':
	                        value = field.value && field.value.mail;
	                        break;
	                    case 'Fax':
	                        value = field.value && field.value.fax;
	                        break;
	                }
	
	                function onChange(eventOrValue) {
	                    var value;
	                    if (eventOrValue && eventOrValue.target) {
	                        value = eventOrValue.target.value;
	                    } else {
	                        value = eventOrValue;
	                    }
	
	                    var medium;
	                    switch (type) {
	                        case 'Phone':
	                            medium = value && { phone: value, contactMediumType: 'Phone' } || null;
	                            break;
	                        case 'Mail':
	                            medium = value && { mail: value, contactMediumType: 'Mail' } || null;
	                            break;
	                        case 'Fax':
	                            medium = value && { fax: value || null, contactMediumType: 'Fax' } || null;
	                            break;
	                    }
	
	                    field.onChange(medium);
	                }
	
	                return _extends({}, field, { disabled: disabled, value: value, onChange: onChange });
	            };
	
	            var callTypeField = function callTypeField() {
	                var value = callType;
	
	                var onChange = function onChange(callType) {
	                    _this3._toggleCallType(callType);
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var hintField = function hintField() {
	                var value = hint || '';
	
	                var onChange = function onChange(event) {
	                    var hint = event.target.value || null;
	
	                    var data = {
	                        firstName: cmd.recipient && cmd.recipient.namez && cmd.recipient.namez.firstName,
	                        lastName: cmd.recipient && cmd.recipient.namez && cmd.recipient.namez.lastName,
	                        value: cmd.recipient && cmd.recipient.namez && cmd.recipient.namez.value || _i18n2.default.namePlaceholder,
	                        name: cmd.recipient && cmd.recipient.provider && cmd.recipient.provider.name,
	                        phone: cmd.medium && (0, _phonez2.default)(cmd.medium.phone).format() || _i18n2.default.phonePlaceholder
	                    };
	                    var comment = (0, _extract.replace)((0, _extract2.default)(_i18n2.default.emitCallCommentEnum, hint, null), data);
	
	                    var interventionCmdTypes = restrictInterventionCmdTypes(ticket, hint);
	
	                    dispatch((0, _actions.updateEmitCallToCmd)({ comment: comment }));
	
	                    _this3.setState({ hint: hint, interventionCmdTypes: interventionCmdTypes, interventionCmdType: null });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var interventionCmdTypeField = function interventionCmdTypeField() {
	                var value = interventionCmdType;
	
	                var onChange = function onChange(value) {
	                    var interventionCmdType = value;
	                    _this3.setState({ interventionCmdType: interventionCmdType });
	
	                    var interventionAcceptedChoosen = { interventionAcceptedClicked: value === 'AcceptIntervention' };
	
	                    dispatch((0, _actions.updateEmitCallToCmd)(_extends({}, interventionAcceptedChoosen)));
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: this._hide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        (0, _extract2.default)(_i18n2.default.emitCallEnum, callType)
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _EmitCallToModal2.default.defaultContent },
	                        callTypes.length > 1 && _react2.default.createElement(
	                            'div',
	                            { className: _EmitCallToModal2.default.callType },
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 9, smOffset: 3 },
	                                    _react2.default.createElement(
	                                        _ButtonToggle2.default,
	                                        callTypeField(),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: _EmitCallToModal2.default.container },
	                                            callTypes.map(function (callType, index) {
	                                                return _react2.default.createElement(
	                                                    'li',
	                                                    {
	                                                        key: index },
	                                                    _react2.default.createElement(
	                                                        _reactBootstrap.Button,
	                                                        {
	                                                            bsStyle: 'link',
	                                                            value: callType },
	                                                        _react2.default.createElement(_Icon2.default, {
	                                                            icon: 'clientAccountManager',
	                                                            size: 'md' }),
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            null,
	                                                            (0, _extract2.default)(_i18n2.default.emitCallzEnum, callType)
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _i18n2.default.contactDetails
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'form-horizontal' },
	                            form.recipient.namez && form.recipient.namez.gender && _react2.default.createElement(
	                                _reactBootstrap.Input,
	                                _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'select',
	                                    name: 'gender',
	                                    label: _i18n2.default.gender
	                                }, form.recipient.namez.gender()),
	                                _react2.default.createElement('option', { value: '' }),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'Male' },
	                                    _i18n2.default.genderEnum.male
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'Female' },
	                                    _i18n2.default.genderEnum.female
	                                )
	                            ),
	                            form.recipient.namez && form.recipient.namez.firstName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'firstName',
	                                label: requiredLabel(_i18n2.default.firstName)
	                            }, form.recipient.namez.firstName())),
	                            form.recipient.namez && form.recipient.namez.lastName && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'lastName',
	                                label: requiredLabel(_i18n2.default.lastName)
	                            }, form.recipient.namez.lastName())),
	                            form.recipient.namez && form.recipient.namez.value && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'name',
	                                label: requiredLabel(_i18n2.default.name)
	                            }, form.recipient.namez.value())),
	                            cmd && cmd.recipient.provider && _react2.default.createElement(_reactBootstrap.Input, {
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'text',
	                                name: 'provider',
	                                disabled: true,
	                                label: _i18n2.default.provider,
	                                value: cmd.recipient.provider.name }),
	                            hints.length > 0 && _react2.default.createElement(
	                                _reactBootstrap.Input,
	                                _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'select',
	                                    label: _i18n2.default.callReason
	                                }, hintField()),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    _i18n2.default.callReason,
	                                    ' ...'
	                                ),
	                                hints.map(function (hint) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        {
	                                            key: hint,
	                                            value: hint },
	                                        (0, _extract2.default)(_i18n2.default.emitCallHintEnum, hint)
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'form-horizontal' },
	                            mediums.length == 0 && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'phone',
	                                    label: _i18n2.default.phone,
	                                    addonBefore: inputAddon('phone')
	                                }, (0, _phonez.phoneField)(mediumField(form.medium(), 'Phone')))),
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'email',
	                                    label: _i18n2.default.email,
	                                    addonBefore: inputAddon('mail')
	                                }, mediumField(form.medium(), 'Mail'))),
	                                _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'fax',
	                                    label: _i18n2.default.fax,
	                                    addonBefore: inputAddon('fax')
	                                }, (0, _phonez.phoneField)(mediumField(form.medium(), 'Fax'))))
	                            ),
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    _i18n2.default.contactDetailsText,
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'i',
	                                        null,
	                                        '*'
	                                    )
	                                )
	                            ),
	                            mediums.filter(function (m) {
	                                return m.contactMediumType == 'Phone';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(_reactBootstrap.Input, { disabled: true,
	                                    key: index,
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'phone',
	                                    label: index == 0 && _i18n2.default.phone || ' ',
	                                    addonBefore: inputAddon('phone'),
	                                    buttonAfter: mediumInputButton(medium),
	                                    value: (0, _phonez2.default)(medium.phone).format(),
	                                    bsStyle: form.medium().bsStyle });
	                            }),
	                            mediums.filter(function (m) {
	                                return m.contactMediumType == 'Mail';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(_reactBootstrap.Input, { disabled: true,
	                                    key: index,
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'email',
	                                    label: index == 0 && _i18n2.default.email || ' ',
	                                    addonBefore: inputAddon('mail'),
	                                    buttonAfter: mediumInputButton(medium),
	                                    value: medium.mail,
	                                    bsStyle: form.medium().bsStyle });
	                            }),
	                            mediums.filter(function (m) {
	                                return m.contactMediumType == 'Fax';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(_reactBootstrap.Input, { disabled: true,
	                                    key: index,
	                                    labelClassName: 'col-sm-3',
	                                    wrapperClassName: 'col-sm-9',
	                                    type: 'text',
	                                    name: 'fax',
	                                    label: index == 0 && _i18n2.default.fax || ' ',
	                                    addonBefore: inputAddon('fax'),
	                                    buttonAfter: mediumInputButton(medium),
	                                    value: (0, _phonez2.default)(medium.fax).format(),
	                                    bsStyle: form.medium().bsStyle });
	                            }),
	                            _react2.default.createElement(_reactBootstrap.Input, _extends({
	                                labelClassName: 'col-sm-3',
	                                wrapperClassName: 'col-sm-9',
	                                type: 'textarea',
	                                name: 'comment',
	                                label: _i18n2.default.comment,
	                                rows: 4
	                            }, (0, _form.controlledField)(form.comment())))
	                        ),
	                        hint == 'callerSatisfaction' && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.satisfaction,
	                                ' ',
	                                _react2.default.createElement(
	                                    'i',
	                                    null,
	                                    '*'
	                                )
	                            ),
	                            _react2.default.createElement(_AnswerForm2.default, {
	                                ref: 'answerForm',
	                                ticket: ticket })
	                        ),
	                        _react2.default.createElement(
	                            'form',
	                            { className: 'form-horizontal' },
	                            interventionCmdTypes.length !== 0 && _react2.default.createElement(
	                                'h5',
	                                null,
	                                _i18n2.default.interventionModalDetail
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 9, smOffset: 3 },
	                                    _react2.default.createElement(
	                                        _RadioToggle2.default,
	                                        interventionCmdTypeField(),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: _EmitCallToModal2.default.interventionCmdType },
	                                            interventionCmdTypes.map(function (interventionCmdType, index) {
	                                                return _react2.default.createElement(
	                                                    'li',
	                                                    {
	                                                        key: index },
	                                                    _react2.default.createElement(
	                                                        'label',
	                                                        null,
	                                                        _react2.default.createElement('input', {
	                                                            type: 'radio',
	                                                            value: interventionCmdType }),
	                                                        (0, _extract2.default)(_i18n2.default.interventionCmdTypeEnum, interventionCmdType)
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            this.emailStuff()
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    className: (0, _classnames2.default)({ disabled: !this._isValid() }),
	                                    onClick: function onClick() {
	                                        return _this3._validate() && _this3._send() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _i18n2.default.validate
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: this._hide },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmitCallToModal;
	}(_react.Component);
	
	EmitCallToModal.propTypes = {
	    assignee: _react.PropTypes.object,
	    caller: _react.PropTypes.object,
	    contactToCallback: _react.PropTypes.object,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	EmitCallToModal = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.EmitCallToCmd.selectSchema,
	    action: _actions.EMIT_CALL_TO_CMD_UPDATED
	})(EmitCallToModal);
	
	EmitCallToModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket,
	        acceptInterventionCmd: state.ticket.acceptInterventionCmd,
	        cmd: state.ticket.emitCallToCmd
	    };
	})(EmitCallToModal);
	
	exports.default = EmitCallToModal;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _models = __webpack_require__(49);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinishMissionModal = function (_Component) {
	    _inherits(FinishMissionModal, _Component);
	
	    function FinishMissionModal(props) {
	        _classCallCheck(this, FinishMissionModal);
	
	        var _this = _possibleConstructorReturn(this, (FinishMissionModal.__proto__ || Object.getPrototypeOf(FinishMissionModal)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(FinishMissionModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var dispatch = this.props.dispatch;
	            // there is no required field in this cmd
	            // so we have to init the cmd to pass form validation
	
	            dispatch((0, _actions.updateFinishMissionCmd)({}));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket !== this.props.ticket) {
	                this.setState({ hint: null });
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendFinishMissionCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                ticket = _props2.ticket,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'ticket', 'onHide']);
	
	            var hint = this.state.hint;
	
	
	            var hintField = function hintField() {
	                var value = hint || '';
	
	                var onChange = function onChange(event) {
	                    var hint = event.target.value || null;
	
	                    var comment = (0, _extract2.default)(_i18n2.default.finishMissionHintEnum, hint, null);
	
	                    dispatch((0, _actions.updateFinishMissionCmd)({ comment: comment }));
	                    _this2.setState({ hint: hint });
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.finishMission
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Input,
	                        _extends({
	                            type: 'select'
	                        }, hintField()),
	                        _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            _i18n2.default.comment,
	                            ' ...'
	                        ),
	                        _models.FINISH_MISSION_HINTS.map(function (hint) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    key: hint,
	                                    value: hint },
	                                (0, _extract2.default)(_i18n2.default.finishMissionHintEnum, hint)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'textarea',
	                        rows: 5
	                    }, (0, _form.controlledField)(form.comment()))),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FinishMissionModal;
	}(_react.Component);
	
	FinishMissionModal.propTypes = {};
	
	
	FinishMissionModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.FinishMissionCmd.schema,
	    action: _actions.FINISH_MISSION_CMD_UPDATED
	})(FinishMissionModal);
	
	FinishMissionModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket,
	        cmd: state.ticket.finishMissionCmd
	    };
	})(FinishMissionModal);
	
	exports.default = FinishMissionModal;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _links = __webpack_require__(33);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _ContactSelector = __webpack_require__(1421);
	
	var _ContactSelector2 = _interopRequireDefault(_ContactSelector);
	
	var _ContactSuggestSelector = __webpack_require__(1424);
	
	var _ContactSuggestSelector2 = _interopRequireDefault(_ContactSuggestSelector);
	
	var _ProviderSuggestSelector = __webpack_require__(1451);
	
	var _ProviderSuggestSelector2 = _interopRequireDefault(_ProviderSuggestSelector);
	
	var _actions = __webpack_require__(113);
	
	var _models = __webpack_require__(49);
	
	var _actions2 = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _IdentifyAssigneeCard = __webpack_require__(2321);
	
	var _IdentifyAssigneeCard2 = _interopRequireDefault(_IdentifyAssigneeCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentifyAssignCard = function (_Component) {
	    _inherits(IdentifyAssignCard, _Component);
	
	    function IdentifyAssignCard(props) {
	        _classCallCheck(this, IdentifyAssignCard);
	
	        var _this = _possibleConstructorReturn(this, (IdentifyAssignCard.__proto__ || Object.getPrototypeOf(IdentifyAssignCard)).call(this, props));
	
	        _this._sendCmd = function () {
	            var dispatch = _this.props.dispatch;
	
	
	            return dispatch((0, _actions2.sendIdentifyAssigneeCmd)()).then(function () {
	                return dispatch((0, _actions2.loadTicket)());
	            });
	        };
	
	        _this._confirmCmd = function () {
	            _this._closeModalEmptyInstructionModal();
	            return _this._sendCmd();
	        };
	
	        _this._sendCmdProxy = function () {
	            var form = _this.props.form;
	
	            if (form.instructions() && !form.instructions().value) {
	                _this.setState({
	                    openConfirmEmptyInstructionModal: true
	                });
	                return true;
	            } else {
	                return _this._sendCmd();
	            }
	        };
	
	        _this._closeModalEmptyInstructionModal = function () {
	            _this.setState({ openConfirmEmptyInstructionModal: false });
	        };
	
	        _this.state = {
	            ticketActivities: [],
	            availableSelectors: [],
	            displayedSelectors: []
	        };
	        return _this;
	    }
	
	    _createClass(IdentifyAssignCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket;
	
	            dispatch((0, _actions.queryOpeningTicketPurposeRef)(ticket.linkedEntities.clientCompany.uid));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference || nextProps.ticket != this.props.ticket) {
	                var openingTicketPurposeReference = nextProps.openingTicketPurposeReference,
	                    ticket = nextProps.ticket,
	                    _providerLinks = nextProps._providerLinks;
	
	
	                var ticketIncidentType = openingTicketPurposeReference.openingTicketPurposes.find(function (otp) {
	                    return otp.uid == ticket.openingTicketPurpose.callPurposeUid;
	                });
	                var ticketActivities = ticketIncidentType && ticketIncidentType.activities || [];
	
	                var availableSelectors = [];
	                if (ticket.linkedEntities.patrimony && ticket.openingTicketPurpose.callPurposeUid) availableSelectors.push('ContactSuggestSelector');
	                if (ticket.linkedEntities.patrimony && ticketActivities.length > 0 && _providerLinks.find((0, _links.linkFinder)('suggest'))) availableSelectors.push('ProviderSuggestSelector');
	                availableSelectors.push('ContactSelector');
	                var displayedSelectors = availableSelectors.slice(0, 2);
	
	                this.setState({ ticketActivities: ticketActivities, availableSelectors: availableSelectors, displayedSelectors: displayedSelectors });
	            }
	        }
	    }, {
	        key: '_renderModal',
	        value: function _renderModal() {
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                {
	                    className: 'modal-danger',
	                    show: true,
	                    onHide: this._closeModalEmptyInstructionModal },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        'Confirmer l\'absence d\'instruction'
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _IdentifyAssigneeCard2.default.text },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Aucune instruction n\'a \xE9t\xE9 ajout\xE9e \xE0 destination du fournisseur. Etes-vous s\xFBr de vouloir continuer ?'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: this._confirmCmd },
	                            _i18n2.default.identifyAssignee
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: this._closeModalEmptyInstructionModal },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: '_match',
	        value: function _match(event) {
	            var fullTextTyped = event.target.value || null;
	            this.setState({ fullTextTyped: fullTextTyped });
	        }
	    }, {
	        key: '_search',
	        value: function _search(event) {
	            var fullTextTyped = this.state.fullTextTyped;
	
	            this.setState({ fullText: fullTextTyped });
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var fullTextTyped = this.state.fullTextTyped;
	
	                event.preventDefault();
	                this.setState({ fullText: fullTextTyped });
	            }
	        }
	    }, {
	        key: '_toggleDisplayedSelectors',
	        value: function _toggleDisplayedSelectors(event, show, hide) {
	            var _state = this.state,
	                availableSelectors = _state.availableSelectors,
	                displayedSelectors = _state.displayedSelectors;
	
	
	            event.preventDefault();
	
	            var showAvailableIndex = availableSelectors.indexOf(show);
	            var hideDisplayedIndex = displayedSelectors.indexOf(hide);
	
	            var nextDisplayedSelectors = [].concat(_toConsumableArray(displayedSelectors));
	            if (showAvailableIndex >= 0 && hideDisplayedIndex >= 0) {
	                nextDisplayedSelectors.splice(hideDisplayedIndex, 1);
	                nextDisplayedSelectors.push(show);
	            }
	
	            this.setState({ displayedSelectors: nextDisplayedSelectors });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                openingTicketPurposeReference = _props2.openingTicketPurposeReference,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                ticket = _props2.ticket,
	                patrimony = _props2.patrimony,
	                _providerLinks = _props2._providerLinks,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'openingTicketPurposeReference', 'form', 'cmd', 'ticket', 'patrimony', '_providerLinks']);
	
	            var _state2 = this.state,
	                fullText = _state2.fullText,
	                ticketActivities = _state2.ticketActivities,
	                availableSelectors = _state2.availableSelectors,
	                displayedSelectors = _state2.displayedSelectors;
	
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.identifyAssignee
	            );
	
	            var searchProviderButton = _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    onClick: function onClick() {
	                        return _this2._search();
	                    } },
	                _react2.default.createElement(_Icon2.default, { icon: 'search', size: 'xs' })
	            );
	
	            var referencedProviderContactField = function referencedProviderContactField(field) {
	                var value = field.value && field.value.providerUid;
	
	                var onChange = function onChange(contact) {
	                    var assignee = {
	                        assigneeType: 'ReferencedProviderContact',
	                        providerUid: contact
	                    };
	                    field.onChange(assignee);
	                };
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            var referencedProviderCompanyField = function referencedProviderCompanyField(field) {
	                var value = field.value && field.value.providerUid;
	
	                var onChange = function onChange(contact) {
	                    var assignee = {
	                        assigneeType: 'ReferencedProviderCompany',
	                        providerUid: contact
	                    };
	                    field.onChange(assignee);
	                };
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _IdentifyAssigneeCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: header
	                    }, others),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'no-gutter' },
	                        availableSelectors.indexOf('ContactSuggestSelector') >= 0 && _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_IdentifyAssigneeCard2.default.visibility, _defineProperty({}, _IdentifyAssigneeCard2.default.visible, displayedSelectors.indexOf('ContactSuggestSelector') >= 0)) },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _IdentifyAssigneeCard2.default.main },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.patrimonyProviderContacts
	                                        ),
	                                        availableSelectors.indexOf('ContactSelector') >= 0 && displayedSelectors.indexOf('ContactSelector') < 0 && _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._toggleDisplayedSelectors(e, 'ContactSelector', 'ContactSuggestSelector');
	                                                } },
	                                            _i18n2.default.otherProviderContactsz
	                                        )
	                                    ),
	                                    _react2.default.createElement(_ContactSuggestSelector2.default, _extends({
	                                        company: ticket.linkedEntities.clientCompany,
	                                        patrimony: ticket.linkedEntities.patrimony.uid == (patrimony && patrimony.uid) && patrimony || ticket.linkedEntities.patrimony,
	                                        incidentType: ticket.openingTicketPurpose.callPurposeUid,
	                                        disable: function disable(c) {
	                                            return c.uid == (ticket.assignee && ticket.assignee.uid);
	                                        }
	                                    }, referencedProviderContactField(form.assignee())))
	                                )
	                            )
	                        ),
	                        availableSelectors.indexOf('ContactSelector') >= 0 && _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_IdentifyAssigneeCard2.default.visibility, _defineProperty({}, _IdentifyAssigneeCard2.default.visible, displayedSelectors.indexOf('ContactSelector') >= 0)) },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: displayedSelectors.length == 2 && 6 || 12 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _IdentifyAssigneeCard2.default.main },
	                                    displayedSelectors.length == 2 && _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.otherProviderContacts
	                                        ),
	                                        availableSelectors.indexOf('ContactSuggestSelector') >= 0 && displayedSelectors.indexOf('ContactSuggestSelector') < 0 && _react2.default.createElement(
	                                            'a',
	                                            {
	                                                href: '',
	                                                onClick: function onClick(e) {
	                                                    return _this2._toggleDisplayedSelectors(e, 'ContactSuggestSelector', 'ContactSelector');
	                                                } },
	                                            _i18n2.default.patrimonyProviderContactsz
	                                        )
	                                    ),
	                                    _react2.default.createElement(_ContactSelector2.default, _extends({
	                                        kind: 'checkbox',
	                                        company: ticket.linkedEntities.clientCompany
	                                    }, referencedProviderContactField(form.assignee())))
	                                )
	                            )
	                        ),
	                        availableSelectors.indexOf('ProviderSuggestSelector') >= 0 && _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_IdentifyAssigneeCard2.default.visibility, _defineProperty({}, _IdentifyAssigneeCard2.default.visible, displayedSelectors.indexOf('ProviderSuggestSelector') >= 0)) },
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6 },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _IdentifyAssigneeCard2.default.main },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _i18n2.default.activityProviderCompanies
	                                    ),
	                                    _react2.default.createElement(_ProviderSuggestSelector2.default, _extends({
	                                        company: ticket.linkedEntities.clientCompany,
	                                        patrimony: ticket.linkedEntities.patrimony.uid == (patrimony && patrimony.uid) && patrimony || ticket.linkedEntities.patrimony,
	                                        activities: ticketActivities,
	                                        disable: function disable(p) {
	                                            return p.uid == (ticket.assignee && ticket.assignee.uid);
	                                        }
	                                    }, referencedProviderCompanyField(form.assignee())))
	                                )
	                            )
	                        )
	                    ),
	                    this.state.openConfirmEmptyInstructionModal && this._renderModal(),
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'textarea',
	                            rows: 4,
	                            placeholder: _i18n2.default.instructionsForAssignee
	                        }, form.instructions())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'textarea',
	                            placeholder: _i18n2.default.comment
	                        }, form.comment()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmdProxy() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.identifyAssignee
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return IdentifyAssignCard;
	}(_react.Component);
	
	IdentifyAssignCard.propTypes = {};
	
	
	IdentifyAssignCard = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.IdentifyAssigneeCmd.schema,
	    action: _actions2.IDENTIFY_ASSIGNEE_CMD_UPDATED
	})(IdentifyAssignCard);
	
	IdentifyAssignCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
	        cmd: state.ticket.identifyAssigneeCmd,
	        ticket: state.ticket.ticket,
	        patrimony: state.patrimony.patrimony,
	        _providerLinks: state.provider._links
	    };
	})(IdentifyAssignCard);
	
	exports.default = IdentifyAssignCard;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _ui = __webpack_require__(512);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewTicketButton = function (_Component) {
	    _inherits(NewTicketButton, _Component);
	
	    function NewTicketButton() {
	        _classCallCheck(this, NewTicketButton);
	
	        return _possibleConstructorReturn(this, (NewTicketButton.__proto__ || Object.getPrototypeOf(NewTicketButton)).apply(this, arguments));
	    }
	
	    _createClass(NewTicketButton, [{
	        key: '_navigate',
	        value: function _navigate() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                authenticated = _props.authenticated;
	
	
	            if (authenticated.userType == 'callCenterOperator' || authenticated.userType == 'callCenterUser') {
	                dispatch((0, _reactRouterRedux.push)('/openticket'));
	                return;
	            }
	            dispatch((0, _reactRouterRedux.push)('/tickets/new'));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                authenticated = _props2.authenticated,
	                _links = _props2._links,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'authenticated', '_links']);
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            return _links.find((0, _links2.linkFinder)('OpenTicket')) != null && _react2.default.createElement(
	                _reactBootstrap.OverlayTrigger,
	                {
	                    placement: 'left',
	                    overlay: tooltip(_i18n2.default.newTicket) },
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        bsStyle: 'primary',
	                        bsSize: 'large',
	                        onClick: function onClick() {
	                            return _this2._navigate();
	                        } },
	                    _react2.default.createElement(_Icon2.default, { icon: 'ticket', size: 'md' })
	                )
	            );
	        }
	    }]);
	
	    return NewTicketButton;
	}(_react.Component);
	
	NewTicketButton.propTypes = {};
	
	
	NewTicketButton = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        _links: state.ticket._links
	    };
	})(NewTicketButton);
	
	exports.default = NewTicketButton;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _delay = __webpack_require__(895);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OpenTicketButtonToolbar = __webpack_require__(2323);
	
	var _OpenTicketButtonToolbar2 = _interopRequireDefault(_OpenTicketButtonToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenTicketButtonToolbar = function (_Component) {
	    _inherits(OpenTicketButtonToolbar, _Component);
	
	    function OpenTicketButtonToolbar(props) {
	        _classCallCheck(this, OpenTicketButtonToolbar);
	
	        var _this = _possibleConstructorReturn(this, (OpenTicketButtonToolbar.__proto__ || Object.getPrototypeOf(OpenTicketButtonToolbar)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(OpenTicketButtonToolbar, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd;
	            var requestUid = cmd.requestUid;
	
	
	            return dispatch((0, _actions.sendOpenTicketCmd)()).then(function (action) {
	                var ticketId = action.events.find(function (e) {
	                    return e.eventType == 'TicketOpened';
	                }).aggregateUid;
	                dispatch((0, _reactRouterRedux.push)('/tickets/' + ticketId));
	
	                return (0, _actions.sendSimplifiedRequestQualified)(requestUid, ticketId).then(function () {}, function () {}).then(function () {
	                    return dispatch((0, _delay2.default)((0, _actions.queryTicketStream)()));
	                });
	            });
	        }
	    }, {
	        key: '_open',
	        value: function _open() {
	            this.setState({ opened: true });
	        }
	    }, {
	        key: '_close',
	        value: function _close() {
	            this.setState({ opened: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                stream = _props2.stream,
	                step = _props2.step,
	                onSubmit = _props2.onSubmit,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'stream', 'step', 'onSubmit']);
	
	            var opened = this.state.opened;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    step == 0.1 && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && (onSubmit(0.2) || true) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.next
	                    ),
	                    step == 0.2 && _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && (cmd.locationRef.patrimonyUid && stream.length > 0 && (_this2._open() || true) || _this2._sendCmd()) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.openTicket
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    {
	                        className: 'modal-danger',
	                        show: opened,
	                        onHide: function onHide() {
	                            return _this2._close();
	                        } },
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            _i18n2.default.newTicket
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpenTicketButtonToolbar2.default.text },
	                            _i18n2.default.newTicketText.map(function (text, index) {
	                                return _react2.default.createElement(
	                                    'p',
	                                    { key: index },
	                                    text
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.ButtonToolbar,
	                            null,
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'danger',
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return _this2._sendCmd();
	                                    } },
	                                _i18n2.default.openTicket
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: function onClick() {
	                                        return _this2._close();
	                                    } },
	                                _i18n2.default.cancel
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketButtonToolbar;
	}(_react.Component);
	
	OpenTicketButtonToolbar.propTypes = {
	    dispatch: _react.PropTypes.func.isRequired,
	    form: _react.PropTypes.func.isRequired,
	    cmd: _react.PropTypes.object,
	    step: _react.PropTypes.number.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	OpenTicketButtonToolbar = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.ticket.minorStream
	    };
	})(OpenTicketButtonToolbar);
	
	exports.default = OpenTicketButtonToolbar;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OpenTicketCompanyCard = __webpack_require__(2324);
	
	var _OpenTicketCompanyCard2 = _interopRequireDefault(_OpenTicketCompanyCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenTicketCompanyCard = function (_Component) {
	    _inherits(OpenTicketCompanyCard, _Component);
	
	    function OpenTicketCompanyCard() {
	        _classCallCheck(this, OpenTicketCompanyCard);
	
	        return _possibleConstructorReturn(this, (OpenTicketCompanyCard.__proto__ || Object.getPrototypeOf(OpenTicketCompanyCard)).apply(this, arguments));
	    }
	
	    _createClass(OpenTicketCompanyCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                cmd = _props.cmd,
	                others = _objectWithoutProperties(_props, ['dispatch', 'cmd']);
	
	            var header = function header(title) {
	                return _react2.default.createElement(
	                    'h3',
	                    null,
	                    title
	                );
	            };
	
	            return (cmd && cmd.company) != null && _react2.default.createElement(
	                'div',
	                { className: _OpenTicketCompanyCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: header(cmd.company.label)
	                    }, others),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        cmd.locationRef && cmd.locationRef.agencyUid && cmd.locationRef.agencyUid.label
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketCompanyCard;
	}(_react.Component);
	
	OpenTicketCompanyCard.propTypes = {};
	
	
	OpenTicketCompanyCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.openTicketCmd
	    };
	})(OpenTicketCompanyCard);
	
	exports.default = OpenTicketCompanyCard;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _delay = __webpack_require__(895);
	
	var _delay2 = _interopRequireDefault(_delay);
	
	var _ui = __webpack_require__(512);
	
	var _wizard = __webpack_require__(513);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _OpenTicketStreamCardLayout = __webpack_require__(1112);
	
	var _OpenTicketStreamCardLayout2 = _interopRequireDefault(_OpenTicketStreamCardLayout);
	
	var _OpenTicketAddressCard = __webpack_require__(968);
	
	var _OpenTicketAddressCard2 = _interopRequireDefault(_OpenTicketAddressCard);
	
	var _PhotoPreview = __webpack_require__(1513);
	
	var _PhotoPreview2 = _interopRequireDefault(_PhotoPreview);
	
	var _OpenTicketCallerCard = __webpack_require__(969);
	
	var _OpenTicketCallerCard2 = _interopRequireDefault(_OpenTicketCallerCard);
	
	var _OpenTicketContactToCallbackCard = __webpack_require__(1108);
	
	var _OpenTicketContactToCallbackCard2 = _interopRequireDefault(_OpenTicketContactToCallbackCard);
	
	var _OpenTicketPurposeCard = __webpack_require__(1110);
	
	var _OpenTicketPurposeCard2 = _interopRequireDefault(_OpenTicketPurposeCard);
	
	var _OpenTicketRequestCard = __webpack_require__(1111);
	
	var _OpenTicketRequestCard2 = _interopRequireDefault(_OpenTicketRequestCard);
	
	var _OpenTicketCompanyModal = __webpack_require__(1107);
	
	var _OpenTicketCompanyModal2 = _interopRequireDefault(_OpenTicketCompanyModal);
	
	var _ReceiveCallModal = __webpack_require__(1113);
	
	var _ReceiveCallModal2 = _interopRequireDefault(_ReceiveCallModal);
	
	var _OpenTicketModal = __webpack_require__(2326);
	
	var _OpenTicketModal2 = _interopRequireDefault(_OpenTicketModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COMPONENT_NAME = 'Ticket/OpenTicketModal';
	
	function stepIsValid(form, step) {
	    switch (step) {
	        case 0:
	            return (0, _form.nodeIsValid)(form.company);
	        case 1:
	            return (0, _form.nodeIsValid)(form.locationRef, form.ticket.address, form.ticket.callerz);
	        case 2:
	            return (0, _form.nodeIsValid)(form.ticket.contactToCallback);
	        case 3:
	            return (0, _form.nodeIsValid)(form.ticket.openingTicketPurpose, form.ticket.request, form.ticket.instructions, form.acknowledgeInstruction);
	    }
	}
	
	function previousStepsAreValid(form, step) {
	    var valid = true;
	
	    switch (step) {
	        case 3:
	            valid = valid && stepIsValid(form, 3);
	        case 2:
	            valid = valid && stepIsValid(form, 2);
	        case 1:
	            valid = valid && stepIsValid(form, 1);
	        case 0:
	            valid = valid && stepIsValid(form, 0);
	    }
	
	    return valid;
	}
	
	var OpenTicketModal = function (_Component) {
	    _inherits(OpenTicketModal, _Component);
	
	    function OpenTicketModal(props) {
	        _classCallCheck(this, OpenTicketModal);
	
	        var _this = _possibleConstructorReturn(this, (OpenTicketModal.__proto__ || Object.getPrototypeOf(OpenTicketModal)).call(this, props));
	
	        _this._sendCmd = function () {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                cmd = _this$props.cmd;
	            var requestUid = cmd.requestUid;
	
	
	            return dispatch((0, _actions.sendOpenTicketCmd)()).then(function (action) {
	                var ticketId = action.events.find(function (e) {
	                    return e.eventType == 'TicketOpened';
	                }).aggregateUid;
	
	                dispatch((0, _ui.setUIState)(COMPONENT_NAME, { opened: false }));
	                dispatch((0, _reactRouterRedux.push)('/tickets/' + ticketId));
	
	                return (0, _actions.sendSimplifiedRequestQualified)(requestUid, ticketId).then(function () {}, function () {}).then(function () {
	                    return dispatch((0, _delay2.default)((0, _actions.queryTicketStream)()));
	                });
	            });
	        };
	
	        _this._close = function () {
	            var dispatch = _this.props.dispatch;
	
	            dispatch((0, _ui.setUIState)(COMPONENT_NAME, { opened: false }));
	        };
	
	        _this._closeModal = function () {
	            _this.setState({ openedModal: null });
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(OpenTicketModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ui = _props.ui,
	                cmd = _props.cmd;
	
	            var _uiState = (0, _ui.uiState)(COMPONENT_NAME, ui),
	                opened = _uiState.opened;
	
	            if (opened && !(cmd && cmd.skipActor)) {
	                dispatch((0, _actions.resetOpenTicketCmd)());
	            }
	            if (opened && cmd && cmd.requestUid) {
	                dispatch((0, _actions.fetchDocumentsForOpenTicket)());
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ui != this.props.ui) {
	                var nextOpened = (0, _ui.uiState)(COMPONENT_NAME, nextProps.ui).opened;
	                var opened = (0, _ui.uiState)(COMPONENT_NAME, this.props.ui).opened;
	
	                if (nextOpened != opened) {
	                    var dispatch = nextProps.dispatch;
	
	
	                    if (nextOpened) {
	                        dispatch((0, _actions.resetOpenTicketCmd)());
	                    }
	                }
	            }
	        }
	    }, {
	        key: '_openReceiveCallModal',
	        value: function _openReceiveCallModal(event, activeCaller, activeTicket) {
	            event.preventDefault();
	
	            var openedModal = 'ReceiveCallModal';
	            this.setState({ openedModal: openedModal, activeCaller: activeCaller, activeTicket: activeTicket });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(openedModal) {
	            this.setState({ openedModal: openedModal });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                ui = _props2.ui,
	                stream = _props2.stream,
	                wizard = _props2.wizard,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'ui', 'stream', 'wizard']);
	
	            var _state = this.state,
	                openedModal = _state.openedModal,
	                activeCaller = _state.activeCaller,
	                activeTicket = _state.activeTicket;
	
	            var _uiState2 = (0, _ui.uiState)(COMPONENT_NAME, ui),
	                opened = _uiState2.opened;
	
	            var stepInfoGroupItemClassName = function stepInfoGroupItemClassName(step) {
	                var _cx;
	
	                return (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _OpenTicketModal2.default.success, stepIsValid(form, step)), _defineProperty(_cx, _OpenTicketModal2.default.active, wizard.majorActiveStep == step), _defineProperty(_cx, _OpenTicketModal2.default.disabled, !previousStepsAreValid(form, step - 1)), _cx));
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Modal,
	                    _extends({
	                        dialogClassName: 'modal-fullscreen',
	                        show: opened,
	                        onHide: this._close
	                    }, others),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpenTicketModal2.default.header },
	                            _react2.default.createElement(
	                                _reactBootstrap.Nav,
	                                { justified: true,
	                                    bsStyle: 'progress',
	                                    activeKey: wizard.majorActiveStep,
	                                    onSelect: function onSelect(s) {
	                                        return wizard.setActiveStep(s);
	                                    } },
	                                [1, 2, 3].map(function (step, index) {
	                                    return _react2.default.createElement(
	                                        _reactBootstrap.NavItem,
	                                        {
	                                            key: index,
	                                            eventKey: step,
	                                            className: (0, _classnames2.default)({ 'nav-success': stepIsValid(form, step) }),
	                                            disabled: !previousStepsAreValid(form, step - 1) },
	                                        step
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: _OpenTicketModal2.default.stepInfoGroup },
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: stepInfoGroupItemClassName(1) },
	                                    stepIsValid(form, 1) && _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _react2.default.createElement(_Icon2.default, { icon: 'check', size: 'xs', active: wizard.majorActiveStep == 1 }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.openTicketSteps.identify
	                                        ),
	                                        cmd.ticket.callerz.namez && _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            cmd.ticket.callerz.namez.firstName,
	                                            ' ',
	                                            cmd.ticket.callerz.namez.lastName
	                                        ),
	                                        cmd.ticket.callerz.uid && cmd.ticket.callerz.uid.name && _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            cmd.ticket.callerz.uid.name.firstName,
	                                            ' ',
	                                            cmd.ticket.callerz.uid.name.lastName
	                                        ),
	                                        _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                cmd.ticket.address.quality
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                cmd.ticket.address.number,
	                                                ' ',
	                                                cmd.ticket.address.street
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' ',
	                                                cmd.ticket.address.zipCode,
	                                                ' ',
	                                                cmd.ticket.address.city
	                                            )
	                                        )
	                                    ),
	                                    !stepIsValid(form, 1) && _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _i18n2.default.openTicketSteps.identify
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: stepInfoGroupItemClassName(2) },
	                                    stepIsValid(form, 2) && _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        cmd && cmd.ticket && cmd.ticket.contactToCallback && _react2.default.createElement(_Icon2.default, { icon: 'check', size: 'xs', active: wizard.majorActiveStep == 2 }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.openTicketSteps.contactToCallback
	                                        ),
	                                        cmd && cmd.ticket && cmd.ticket.contactToCallback && _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                cmd.ticket.contactToCallback.namez
	                                            ),
	                                            cmd.ticket.contactToCallback.medium.phone && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' (',
	                                                (0, _phonez2.default)(cmd.ticket.contactToCallback.medium.phone).format(),
	                                                ')'
	                                            ),
	                                            cmd.ticket.contactToCallback.medium.mail && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' (',
	                                                cmd.ticket.contactToCallback.medium.mail,
	                                                ')'
	                                            ),
	                                            cmd.ticket.contactToCallback.medium.fax && _react2.default.createElement(
	                                                'span',
	                                                null,
	                                                ' (',
	                                                (0, _phonez2.default)(cmd.ticket.contactToCallback.medium.fax).format(),
	                                                ')'
	                                            )
	                                        )
	                                    ),
	                                    !stepIsValid(form, 2) && _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _i18n2.default.openTicketSteps.contactToCallback
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: stepInfoGroupItemClassName(3) },
	                                    stepIsValid(form, 3) && _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _react2.default.createElement(_Icon2.default, { icon: 'check', size: 'xs', active: wizard.majorActiveStep == 3 }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            _i18n2.default.openTicketSteps.request
	                                        ),
	                                        _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            cmd.ticket.openingTicketPurpose.label
	                                        ),
	                                        _react2.default.createElement(
	                                            'small',
	                                            null,
	                                            cmd.ticket.request
	                                        )
	                                    ),
	                                    !stepIsValid(form, 3) && _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _i18n2.default.openTicketSteps.request
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpenTicketModal2.default.main },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_OpenTicketModal2.default.visibility, _defineProperty({}, _OpenTicketModal2.default.visible, wizard.matchActiveStep(1))) },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Row,
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_OpenTicketAddressCard2.default, {
	                                            dispatch: dispatch,
	                                            form: form,
	                                            cmd: cmd })
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Col,
	                                        { sm: 6 },
	                                        _react2.default.createElement(_OpenTicketCallerCard2.default, {
	                                            dispatch: dispatch,
	                                            form: form,
	                                            cmd: cmd })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_OpenTicketModal2.default.visibility, _defineProperty({}, _OpenTicketModal2.default.visible, wizard.matchActiveStep(2))) },
	                                _react2.default.createElement(_OpenTicketContactToCallbackCard2.default, {
	                                    dispatch: dispatch,
	                                    form: form,
	                                    cmd: cmd })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_OpenTicketModal2.default.visibility, _defineProperty({}, _OpenTicketModal2.default.visible, wizard.matchActiveStep(3))) },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(_OpenTicketPurposeCard2.default, {
	                                        dispatch: dispatch,
	                                        form: form,
	                                        cmd: cmd }),
	                                    _react2.default.createElement(_PhotoPreview2.default, { photos: cmd && cmd.photos || [] }),
	                                    _react2.default.createElement(_OpenTicketRequestCard2.default, {
	                                        dispatch: dispatch,
	                                        form: form,
	                                        cmd: cmd })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpenTicketModal2.default.side },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _classnames2.default)(_OpenTicketModal2.default.visibility, _defineProperty({}, _OpenTicketModal2.default.visible, wizard.matchActiveStep([1, 3]))) },
	                                _react2.default.createElement(_OpenTicketStreamCardLayout2.default, {
	                                    onSubmit: function onSubmit(e, a, c, t) {
	                                        return _this2._openReceiveCallModal(e, c, t);
	                                    } })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _OpenTicketModal2.default.toolbar },
	                            _react2.default.createElement(
	                                _LoaderButton2.default,
	                                {
	                                    bsStyle: 'primary',
	                                    bsSize: 'large',
	                                    disabled: !form.isValid(),
	                                    onClick: function onClick() {
	                                        return form.validate() && (cmd.locationRef.patrimonyUid && stream.length > 0 && (_this2._openModal('ConfirmModal') || true) || _this2._sendCmd()) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'checkWhite', size: 'xs' })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    disabled: !wizard.hasPreviousStep(),
	                                    onClick: function onClick() {
	                                        return wizard.previousStep();
	                                    } },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '<<'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    disabled: !wizard.hasNextStep() || !stepIsValid(form, wizard.majorActiveStep),
	                                    onClick: function onClick() {
	                                        return wizard.nextStep();
	                                    } },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '>>'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    bsSize: 'large',
	                                    onClick: this._close },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'x'
	                                )
	                            )
	                        )
	                    )
	                ),
	                opened && _react2.default.createElement(
	                    'div',
	                    null,
	                    !previousStepsAreValid(form, 0) && _react2.default.createElement(_OpenTicketCompanyModal2.default, { onSubmit: this._close }),
	                    _react2.default.createElement(_ReceiveCallModal2.default, {
	                        caller: activeCaller,
	                        assignee: null,
	                        ticket: activeTicket,
	                        show: openedModal == 'ReceiveCallModal',
	                        onHide: this._closeModal }),
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal,
	                        {
	                            className: 'modal-danger',
	                            show: openedModal == 'ConfirmModal',
	                            onHide: this._closeModal },
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Header,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Modal.Title,
	                                null,
	                                _i18n2.default.newTicket
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Modal.Body,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: _OpenTicketModal2.default.text },
	                                _i18n2.default.newTicketText.map(function (text, index) {
	                                    return _react2.default.createElement(
	                                        'p',
	                                        { key: index },
	                                        text
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.ButtonToolbar,
	                                null,
	                                _react2.default.createElement(
	                                    _LoaderButton2.default,
	                                    {
	                                        bsStyle: 'danger',
	                                        bsSize: 'large',
	                                        onClick: this._sendCmd },
	                                    _i18n2.default.openTicket
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        bsSize: 'large',
	                                        onClick: this._closeModal },
	                                    _i18n2.default.cancel
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenTicketModal;
	}(_react.Component);
	
	OpenTicketModal.propTypes = {};
	
	
	OpenTicketModal = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: _models.OpenTicketCmd.selectSchema,
	    action: _actions.OPEN_TICKET_CMD_UPDATED
	})(OpenTicketModal);
	
	OpenTicketModal = (0, _wizard.connectWizard)({
	    steps: [1, 2, 3]
	})(OpenTicketModal);
	
	OpenTicketModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        ui: state.ui,
	        cmd: state.ticket.openTicketCmd,
	        stream: state.ticket.minorStream
	    };
	})(OpenTicketModal);
	
	exports.default = OpenTicketModal;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _RankingDashboardPanel = __webpack_require__(1091);
	
	var _RankingDashboardPanel2 = _interopRequireDefault(_RankingDashboardPanel);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function patrimonyFilter(restrict) {
	    restrict = restrict && (restrict instanceof Array && restrict || [restrict]) || [];
	
	    return function (patrimony) {
	        if (restrict.length > 0) {
	            return !!restrict.find(function (r) {
	                return r.value == patrimony.value;
	            });
	        }
	        return true;
	    };
	}
	
	var PatrimonyDashboardPanel = function (_Component) {
	    _inherits(PatrimonyDashboardPanel, _Component);
	
	    function PatrimonyDashboardPanel(props) {
	        _classCallCheck(this, PatrimonyDashboardPanel);
	
	        var _this = _possibleConstructorReturn(this, (PatrimonyDashboardPanel.__proto__ || Object.getPrototypeOf(PatrimonyDashboardPanel)).call(this, props));
	
	        _this.state = {
	            filteredPatrimonies: []
	        };
	        return _this;
	    }
	
	    _createClass(PatrimonyDashboardPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                aggregations = _props.aggregations,
	                query = _props.query;
	
	
	            var filteredPatrimonies = aggregations.patrimonies.filter(patrimonyFilter(query.patrimony));
	            this.setState({ filteredPatrimonies: filteredPatrimonies });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.aggregations != this.props.aggregations || nextProps.query != this.props.query) {
	                var aggregations = nextProps.aggregations,
	                    query = nextProps.query;
	
	
	                var filteredPatrimonies = aggregations.patrimonies.filter(patrimonyFilter(query.patrimony));
	                this.setState({ filteredPatrimonies: filteredPatrimonies });
	            }
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, patrimony) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)('/patrimonies/' + patrimony.value));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                aggregations = _props2.aggregations,
	                query = _props2.query,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'aggregations', 'query']);
	
	            var filteredPatrimonies = this.state.filteredPatrimonies;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            var displayPatrimony = function displayPatrimony(patrimony) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        patrimony.ref,
	                        ' (',
	                        patrimony.count,
	                        ')'
	                    ),
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        patrimony.label
	                    )
	                );
	            };
	
	            return _react2.default.createElement(_RankingDashboardPanel2.default, _extends({
	                header: panelHeader(_i18n2.default.patrimoniesTop10),
	                display: displayPatrimony,
	                identify: function identify(p) {
	                    return p.count;
	                },
	                onClick: function onClick(e, p) {
	                    return _this2._navigate(e, p);
	                },
	                value: filteredPatrimonies
	            }, others));
	        }
	    }]);
	
	    return PatrimonyDashboardPanel;
	}(_react.Component);
	
	PatrimonyDashboardPanel.propTypes = {};
	
	
	PatrimonyDashboardPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        aggregations: state.ticket.aggregations,
	        query: state.ticket.query
	    };
	})(PatrimonyDashboardPanel);
	
	exports.default = PatrimonyDashboardPanel;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hotoPreview = __webpack_require__(2341);
	
	var _hotoPreview2 = _interopRequireDefault(_hotoPreview);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhotoPreview = function (_Component) {
	    _inherits(PhotoPreview, _Component);
	
	    function PhotoPreview() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PhotoPreview);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhotoPreview.__proto__ || Object.getPrototypeOf(PhotoPreview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.popoverPhoto = function (photo) {
	            return function () {
	                return _this.setState({ photo: photo });
	            };
	        }, _this.close = function () {
	            _this.setState({
	                photo: undefined
	            });
	        }, _this.renderPhoto = function (photo) {
	            return _react2.default.createElement(
	                'figure',
	                null,
	                _react2.default.createElement('img', { src: photo.url, width: 200, onMouseEnter: _this.popoverPhoto(photo.url), onClick: _this.popoverPhoto(photo.url) })
	            );
	        }, _this.renderPopover = function () {
	            return _this.state.photo ? _react2.default.createElement(
	                'div',
	                { className: _hotoPreview2.default.popover, onClick: _this.popoverPhoto() },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Chargement ...'
	                ),
	                _react2.default.createElement('img', { src: _this.state.photo, onMouseLeave: _this.popoverPhoto() })
	            ) : undefined;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PhotoPreview, [{
	        key: 'render',
	        value: function render() {
	            var photos = this.props.photos;
	
	
	            return photos.length > 0 ? _react2.default.createElement(
	                'section',
	                { className: _hotoPreview2.default.photoPreview },
	                _react2.default.createElement(
	                    _Card2.default,
	                    { header: _react2.default.createElement(
	                            'h5',
	                            null,
	                            'Photos envoy\xE9es lors de la demande'
	                        ) },
	                    photos.map(this.renderPhoto),
	                    this.renderPopover()
	                )
	            ) : _react2.default.createElement('div', null);
	        }
	    }]);
	
	    return PhotoPreview;
	}(_react.Component);
	
	exports.default = PhotoPreview;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _QualificationCriteriaTicketAnswers = __webpack_require__(1815);
	
	var _QualificationCriteriaTicketAnswers2 = _interopRequireDefault(_QualificationCriteriaTicketAnswers);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QualificationCriteriaAnswers = function (_Component) {
	    _inherits(QualificationCriteriaAnswers, _Component);
	
	    function QualificationCriteriaAnswers() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, QualificationCriteriaAnswers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QualificationCriteriaAnswers.__proto__ || Object.getPrototypeOf(QualificationCriteriaAnswers)).call.apply(_ref, [this].concat(args))), _this), _this.setupPorts = function (ports) {
	            var onChange = _this.props.onChange;
	
	            ports.qualifyTicketUpdate.subscribe(function (qualification) {
	                onChange(qualification);
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(QualificationCriteriaAnswers, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                clientCompany = _props.clientCompany,
	                otp = _props.otp,
	                qualification = _props.qualification;
	
	            var _ref2 = qualification || {},
	                choices = _ref2.choices;
	
	            if (!clientCompany || !otp) {
	                return _react2.default.createElement('div', null);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactElmComponents2.default, { src: _QualificationCriteriaTicketAnswers2.default.Elm.QualificationCriteriaTicketAnswers,
	                    flags: { apiUrl: _config2.default.api.url, otp: otp, clientCompany: clientCompany, choices: choices || [] },
	                    ports: this.setupPorts
	                })
	            );
	        }
	    }]);
	
	    return QualificationCriteriaAnswers;
	}(_react.Component);
	
	exports.default = QualificationCriteriaAnswers;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _DayPicker = __webpack_require__(276);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReportFormalNoticeForProviderModal = __webpack_require__(2329);
	
	var _ReportFormalNoticeForProviderModal2 = _interopRequireDefault(_ReportFormalNoticeForProviderModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportFormalNoticeForProviderModal = function (_Component) {
	    _inherits(ReportFormalNoticeForProviderModal, _Component);
	
	    function ReportFormalNoticeForProviderModal() {
	        _classCallCheck(this, ReportFormalNoticeForProviderModal);
	
	        return _possibleConstructorReturn(this, (ReportFormalNoticeForProviderModal.__proto__ || Object.getPrototypeOf(ReportFormalNoticeForProviderModal)).apply(this, arguments));
	    }
	
	    _createClass(ReportFormalNoticeForProviderModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendReportFormalNoticeForProviderCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.reportFormalNoticeForProvider
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ReportFormalNoticeForProviderModal2.default.datePicker },
	                        _react2.default.createElement(_DayPicker2.default, form.deadline())
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReportFormalNoticeForProviderModal;
	}(_react.Component);
	
	ReportFormalNoticeForProviderModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReportFormalNoticeForProviderModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ReportFormalNoticeForProviderCmd.schema,
	    action: _actions.REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_UPDATED
	})(ReportFormalNoticeForProviderModal);
	
	ReportFormalNoticeForProviderModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.reportFormalNoticeForProviderCmd
	    };
	})(ReportFormalNoticeForProviderModal);
	
	exports.default = ReportFormalNoticeForProviderModal;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _DayPicker = __webpack_require__(276);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ReportSendingServiceOrderModal = __webpack_require__(2330);
	
	var _ReportSendingServiceOrderModal2 = _interopRequireDefault(_ReportSendingServiceOrderModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportSendingServiceOrderModal = function (_Component) {
	    _inherits(ReportSendingServiceOrderModal, _Component);
	
	    function ReportSendingServiceOrderModal() {
	        _classCallCheck(this, ReportSendingServiceOrderModal);
	
	        return _possibleConstructorReturn(this, (ReportSendingServiceOrderModal.__proto__ || Object.getPrototypeOf(ReportSendingServiceOrderModal)).apply(this, arguments));
	    }
	
	    _createClass(ReportSendingServiceOrderModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendReportSendingServiceOrderCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.reportSendingServiceOrder
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'serviceOrderRef',
	                            label: requiredLabel(_i18n2.default.serviceOrderRef)
	                        }, form.ref()))
	                    ),
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _i18n2.default.serviceOrderDate
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ReportSendingServiceOrderModal2.default.datePicker },
	                        _react2.default.createElement(_DayPicker2.default, form.sendingDate())
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ReportSendingServiceOrderModal;
	}(_react.Component);
	
	ReportSendingServiceOrderModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ReportSendingServiceOrderModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ReportSendingServiceOrderCmd.schema,
	    action: _actions.REPORT_SENDING_SERVICE_ORDER_CMD_UPDATED
	})(ReportSendingServiceOrderModal);
	
	ReportSendingServiceOrderModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.reportSendingServiceOrderCmd
	    };
	})(ReportSendingServiceOrderModal);
	
	exports.default = ReportSendingServiceOrderModal;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _DayPicker = __webpack_require__(276);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _TimeRangePicker = __webpack_require__(1355);
	
	var _TimeRangePicker2 = _interopRequireDefault(_TimeRangePicker);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(38);
	
	var _models = __webpack_require__(49);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ScheduleInterventionModal = __webpack_require__(2331);
	
	var _ScheduleInterventionModal2 = _interopRequireDefault(_ScheduleInterventionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScheduleInterventionModal = function (_Component) {
	    _inherits(ScheduleInterventionModal, _Component);
	
	    function ScheduleInterventionModal() {
	        _classCallCheck(this, ScheduleInterventionModal);
	
	        return _possibleConstructorReturn(this, (ScheduleInterventionModal.__proto__ || Object.getPrototypeOf(ScheduleInterventionModal)).apply(this, arguments));
	    }
	
	    _createClass(ScheduleInterventionModal, [{
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendScheduleInterventionCmd)()).then(function () {
	                return dispatch((0, _actions.loadTicket)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'onHide']);
	
	            var dateField = function dateField(form) {
	                var value = form.value && (form.value.startDate || form.value.endDate);
	
	                var onChange = function onChange(value) {
	                    var previousStartDate = form.value && form.value.startDate;
	                    var previousEndDate = form.value && form.value.endDate;
	                    var nextStartDate = previousStartDate && new Date(value.getFullYear(), value.getMonth(), value.getDate(), previousStartDate.getHours()) || value;
	                    var nextEndDate = previousEndDate && new Date(value.getFullYear(), value.getMonth(), value.getDate(), previousEndDate.getHours()) || value;
	                    var nextValue = { startDate: nextStartDate, endDate: nextEndDate };
	                    form.onChange(nextValue);
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            var dateRangeField = function dateRangeField(form) {
	                var value = {
	                    from: form.value && form.value.startDate,
	                    to: form.value && form.value.endDate
	                };
	
	                var onChange = function onChange(value) {
	                    var nextValue = { startDate: value && value.from, endDate: value && value.to };
	                    form.onChange(nextValue);
	                };
	
	                return { value: value, onChange: onChange };
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.scheduleIntervention
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ScheduleInterventionModal2.default.dateTimePicker },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _ScheduleInterventionModal2.default.container },
	                            _react2.default.createElement(_DayPicker2.default, dateField(form(['startDate', 'endDate']))),
	                            _react2.default.createElement(_TimeRangePicker2.default, dateRangeField(form(['startDate', 'endDate'])))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.validate
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ScheduleInterventionModal;
	}(_react.Component);
	
	ScheduleInterventionModal.propTypes = {
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	ScheduleInterventionModal = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ScheduleInterventionCmd.schema,
	    action: _actions.SCHEDULE_INTERVENTION_CMD_UPDATED
	})(ScheduleInterventionModal);
	
	ScheduleInterventionModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.scheduleInterventionCmd
	    };
	})(ScheduleInterventionModal);
	
	exports.default = ScheduleInterventionModal;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _ShowDocumentsCard = __webpack_require__(1817);
	
	var _ShowDocumentsCard2 = _interopRequireDefault(_ShowDocumentsCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShowDocumentsCard = function (_Component) {
	    _inherits(ShowDocumentsCard, _Component);
	
	    function ShowDocumentsCard() {
	        _classCallCheck(this, ShowDocumentsCard);
	
	        return _possibleConstructorReturn(this, (ShowDocumentsCard.__proto__ || Object.getPrototypeOf(ShowDocumentsCard)).apply(this, arguments));
	    }
	
	    _createClass(ShowDocumentsCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                simplifiedRequest = _props.simplifiedRequest,
	                ticket = _props.ticket;
	
	            var sr = { simplifiedRequestUid: simplifiedRequest || null };
	            var flags = _extends({}, sr, {
	                entityUid: ticket,
	                queryApiBaseUrl: _config2.default.api.url
	            });
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactElmComponents2.default, { src: _ShowDocumentsCard2.default.Elm.ShowDocumentsCard, flags: flags })
	            );
	        }
	    }]);
	
	    return ShowDocumentsCard;
	}(_react.Component);
	
	exports.default = ShowDocumentsCard;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _i18n3 = __webpack_require__(24);
	
	var _i18n4 = _interopRequireDefault(_i18n3);
	
	var _TicketCallerCard = __webpack_require__(1260);
	
	var _TicketCallerCard2 = _interopRequireDefault(_TicketCallerCard);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _OpenTicketCallerCard = __webpack_require__(969);
	
	var _OpenTicketCallerCard2 = _interopRequireDefault(_OpenTicketCallerCard);
	
	var _form = __webpack_require__(15);
	
	var _models2 = __webpack_require__(49);
	
	var _actions = __webpack_require__(38);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _fetchz = __webpack_require__(86);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _status = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var schemaCache = (0, _cache2.default)();
	
	function selectSchema(target, _ref) {
	    var step = _ref.step;
	
	    var schema = _models2.OpenTicketCmd.selectSchema(target);
	
	    return schemaCache([schema, step], function () {
	        if (step == 0.1) {
	            return _extends({}, schema, {
	                properties: {
	                    company: schema.properties.company,
	                    locationRef: schema.properties.locationRef,
	                    ticket: _extends({}, schema.properties.ticket, {
	                        properties: {
	                            callerz: schema.properties.ticket.properties.callerz,
	                            contactToCallback: schema.properties.ticket.properties.contactToCallback,
	                            address: schema.properties.ticket.properties.address
	                        },
	                        required: ['callerz', 'address']
	                    })
	                },
	                required: ['company', 'locationRef', 'ticket']
	            });
	        }
	        return schema;
	    });
	}
	
	var TicketCallerCard = function (_Component) {
	    _inherits(TicketCallerCard, _Component);
	
	    function TicketCallerCard() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TicketCallerCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = TicketCallerCard.__proto__ || Object.getPrototypeOf(TicketCallerCard)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _this._init = function (props) {
	            var ticket = props.ticket,
	                dispatch = props.dispatch;
	
	            var action = {
	                locationRef: {
	                    patrimonyUid: ticket.linkedEntities.patrimony && ticket.linkedEntities.patrimony.uid
	                },
	                ticket: {
	                    callerz: {
	                        callerType: 'HumanCaller'
	                    }
	                }
	            };
	            dispatch((0, _actions.updateCorrectCallerCmd)(action));
	        }, _this._openCorrectCallerModal = function () {
	            _this.setState({ showModal: true });
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                ticket = _this$props.ticket,
	                cmd = _this$props.cmd;
	
	
	            if (ticket.caller.callerInfos.callerType === 'NonReferencedCaller') {
	                var _medium;
	
	                var medium = ticket.caller.medium[0];
	                dispatch({
	                    type: _actions.CORRECT_CALLER_CMD_UPDATED,
	                    cmd: {
	                        ticket: {
	                            callerz: {
	                                callerType: cmd.ticket.callerz.callerType,
	                                status: ticket.caller.status,
	                                comment: ticket.caller.comment,
	                                namez: {
	                                    firstName: ticket.caller.name.split(' ')[0],
	                                    lastName: ticket.caller.name.split(' ').slice(1).join(' ')
	                                },
	                                medium: (_medium = {}, _defineProperty(_medium, medium.mediumType.toLowerCase(), medium.identifier), _defineProperty(_medium, 'contactMediumType', medium.mediumType.toLowerCase().replace(/^./, function (m) {
	                                    return m.toUpperCase();
	                                })), _medium)
	                            }
	                        }
	                    }
	                });
	            }
	        }, _this._closeCorrectCallerModal = function () {
	            _this.setState({ showModal: undefined });
	        }, _this._sendCorrectCallerCmd = function () {
	            var _this$props2 = _this.props,
	                dispatch = _this$props2.dispatch,
	                cmd = _this$props2.cmd,
	                ticket = _this$props2.ticket;
	            var ticketUid = ticket.uid;
	
	            var _cmd$ticket$callerz = _extends({}, cmd.ticket.callerz),
	                namez = _cmd$ticket$callerz.namez,
	                uid = _cmd$ticket$callerz.uid,
	                otherFields = _objectWithoutProperties(_cmd$ticket$callerz, ['namez', 'uid']);
	
	            var callerName = namez || null;
	            var callerUid = uid && uid.uid || null;
	            var options = {
	                method: 'PATCH',
	                body: {
	                    processUid: _nodeUuid2.default.v4(),
	                    caller: _extends({
	                        uid: callerUid,
	                        name: _extends({}, callerName, {
	                            nameType: 'CivilName'
	                        })
	                    }, otherFields),
	                    commandType: 'CorrectCaller'
	                }
	            };
	
	            fetch((0, _fetchz.apiUrl)(_config2.default.api.event.url + '/tickets/' + ticketUid), (0, _fetchz.apiOption)(options)).then(_fetchz.apiResponse).then(function () {
	                _this._closeCorrectCallerModal();
	                window.location.reload();
	            }).catch(function (e) {
	                dispatch((0, _status.errorStatus)(e.message));
	            });
	        }, _this.render = function () {
	            var _this$props3 = _this.props,
	                dispatch = _this$props3.dispatch,
	                ticket = _this$props3.ticket,
	                patrimony = _this$props3.patrimony,
	                ticketIdLock = _this$props3.ticketIdLock,
	                onSubmit = _this$props3.onSubmit,
	                form = _this$props3.form,
	                cmd = _this$props3.cmd,
	                others = _objectWithoutProperties(_this$props3, ['dispatch', 'ticket', 'patrimony', 'ticketIdLock', 'onSubmit', 'form', 'cmd']);
	
	            var callerName = function callerName(caller) {
	                if (ticket.caller.callerInfos.callerType === 'PatrimonyContactCaller' && caller.uid) {
	                    return _react2.default.createElement(
	                        'a',
	                        { href: '/patrimonycontacts/' + caller.uid },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                caller.name
	                            ),
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                        )
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    caller.name
	                );
	            };
	
	            var isLocked = function isLocked() {
	                if (ticketIdLock && ticketIdLock != (ticket && ticket.uid)) return true;
	                return !ticket;
	            };
	
	            var cardHeader = function cardHeader(title) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        title
	                    ),
	                    ticket._links.find((0, _links.linkFinder)('CorrectCaller')) && _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            onClick: _this._openCorrectCallerModal,
	                            title: _i18n4.default.correctCaller,
	                            alt: _i18n4.default.correctCaller
	                        },
	                        _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                    )
	                );
	            };
	
	            var correctCallerModal = _react2.default.createElement(
	                _reactBootstrap.Modal,
	                {
	                    bsSize: 'large',
	                    show: _this.state.showModal,
	                    onHide: _this._closeCorrectCallerModal
	                },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n4.default.callerIdentity
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_OpenTicketCallerCard2.default, _extends({ form: form, cmd: cmd, dispatch: dispatch }, { split: true })),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large'
	                                // className={cx({disabled: !form.isValid()})}
	                                , onClick: _this._sendCorrectCallerCmd
	                            },
	                            _i18n4.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: _this._closeCorrectCallerModal
	                            },
	                            _i18n4.default.cancel
	                        )
	                    )
	                )
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TicketCallerCard2.default.default },
	                correctCallerModal,
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: cardHeader(_i18n4.default.callerIdentity)
	                    }, others),
	                    !isLocked() && _react2.default.createElement(
	                        'div',
	                        null,
	                        callerName(ticket.caller),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            ticket.caller.status
	                        ),
	                        ticket.caller.callerInfos.callerType === 'PatrimonyContactCaller' && _react2.default.createElement(
	                            'div',
	                            { className: _TicketCallerCard2.default.comment },
	                            _models.Contact.filterLinkedWith(ticket.caller.callerInfos, { patrimony: patrimony }).map(function (link, index) {
	                                return _react2.default.createElement(
	                                    'p',
	                                    { key: index },
	                                    _models.Contact.extractLinkedWith(_i18n2.default.patrimonyContactLinkTypeEnum, link)
	                                );
	                            })
	                        ),
	                        ticket.caller.callerInfos.callerType === 'ClientCompanyUserCaller' && _react2.default.createElement(
	                            'div',
	                            { className: _TicketCallerCard2.default.comment },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _i18n2.default.patrimonyUserLinkTypeEnum[ticket.caller.callerInfos.userType]
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _TicketCallerCard2.default.contact },
	                            ticket.caller.medium && ticket.caller.medium.filter(function (m) {
	                                return m.mediumType == 'PHONE';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'phone', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        (0, _phonez2.default)(medium.identifier).format()
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _TicketCallerCard2.default.contact },
	                            ticket.caller.medium && ticket.caller.medium.filter(function (m) {
	                                return m.mediumType == 'MAIL';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'mail', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        medium.identifier
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _TicketCallerCard2.default.contact },
	                            ticket.caller.medium && ticket.caller.medium.filter(function (m) {
	                                return m.mediumType == 'FAX';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'fax', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        (0, _phonez2.default)(medium.identifier).format()
	                                    )
	                                );
	                            })
	                        ),
	                        ticket.caller.comment && _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_TicketCallerCard2.default.comment, _TicketCallerCard2.default.warning) },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                ticket.caller.comment
	                            )
	                        ),
	                        onSubmit && _react2.default.createElement(
	                            'ul',
	                            { className: _TicketCallerCard2.default.callingGroup },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ticket._links.find((0, _links.linkFinder)('EmitCallTo')) && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        onClick: function onClick(e) {
	                                            return onSubmit(e, 'EmitCallTo', ticket.caller);
	                                        } },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _i18n4.default.emitCallz
	                                    ),
	                                    _react2.default.createElement(_Icon2.default, { icon: 'emitCall', size: 'sm' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ticket._links.find((0, _links.linkFinder)('ReceiveCall')) && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        onClick: function onClick(e) {
	                                            return onSubmit(e, 'ReceiveCall', ticket.caller);
	                                        } },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _i18n4.default.receiveCallz
	                                    ),
	                                    _react2.default.createElement(_Icon2.default, { icon: 'receiveCall', size: 'sm' })
	                                )
	                            )
	                        )
	                    ),
	                    isLocked() && _react2.default.createElement(
	                        'div',
	                        { className: _TicketCallerCard2.default.noTicketInfo },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n4.default.noTicketInfo
	                        )
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TicketCallerCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this._init(this.props);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.ticket.linkedEntities.clientCompany !== nextProps.ticket.linkedEntities.clientCompany) {
	                this._init(nextProps);
	            }
	        }
	    }]);
	
	    return TicketCallerCard;
	}(_react.Component);
	
	TicketCallerCard.propTypes = {
	    ticketIdLock: _react.PropTypes.string,
	    onSubmit: _react.PropTypes.func
	};
	
	
	TicketCallerCard = (0, _form.connectForm)({
	    validator: (0, _models2.createValidator)(),
	    target: 'cmd',
	    schema: selectSchema,
	    action: _actions.CORRECT_CALLER_CMD_UPDATED
	})(TicketCallerCard);
	
	TicketCallerCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket,
	        patrimony: state.patrimony.patrimony,
	        cmd: state.ticket.correctCallerCmdUpdate
	    };
	})(TicketCallerCard);
	
	exports.default = TicketCallerCard;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _models = __webpack_require__(49);
	
	var _TicketCard = __webpack_require__(2334);
	
	var _TicketCard2 = _interopRequireDefault(_TicketCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketCard = function (_Component) {
	    _inherits(TicketCard, _Component);
	
	    function TicketCard() {
	        _classCallCheck(this, TicketCard);
	
	        return _possibleConstructorReturn(this, (TicketCard.__proto__ || Object.getPrototypeOf(TicketCard)).apply(this, arguments));
	    }
	
	    _createClass(TicketCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                ticket = _props.ticket,
	                others = _objectWithoutProperties(_props, ['ticket']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                'ticket ',
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    'n\xB0 ',
	                    ticket.ref
	                )
	            );
	
	            var help = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    (0, _moment2.default)(ticket.dates.created).format(_i18n2.default.creationDateTimeFormat)
	                )
	            );
	
	            var addon = _react2.default.createElement(_Icon2.default, { icon: 'status-success', size: 'xs' });
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TicketCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        kind: 'tab',
	                        status: 'success',
	                        header: header,
	                        help: help,
	                        addon: addon
	                    }, others),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'no-gutter' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 10, sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketCard2.default.purpose },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    ticket.openingTicketPurpose.callPurpose
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xs: 2, sm: 8 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketCard2.default.status },
	                                _react2.default.createElement(_Icon2.default, { icon: _models.Ticket.accurateStatus(ticket), size: 'sm' }),
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    '> ',
	                                    _i18n2.default.status,
	                                    ' : ',
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        (0, _extract2.default)(_i18n2.default.statusEnum, ticket.status)
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        { className: 'no-gutter' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketCard2.default.caller },
	                                _react2.default.createElement(
	                                    'h5',
	                                    null,
	                                    ticket.caller.name
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticket.address.quality
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticket.address.number,
	                                    ' ',
	                                    ticket.address.street
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticket.address.zipCode,
	                                    ' ',
	                                    ticket.address.city
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    ticket.address.complement
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { xsHidden: true, sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketCard2.default.assignee },
	                                ticket.assignee && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _i18n2.default.assignee
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _TicketCard2.default.capitalize },
	                                        ticket.assignee.name
	                                    ),
	                                    ticket.assignee.phones.map(function (phone, index) {
	                                        return _react2.default.createElement(
	                                            'p',
	                                            { key: index },
	                                            (0, _phonez2.default)(phone).format()
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 4 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketCard2.default.state },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketCard2.default.stateContent },
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        _i18n2.default.state
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: _TicketCard2.default.capitalize },
	                                        (0, _extract2.default)(_i18n2.default.stateEnum, ticket.state && ticket.state.value || 'TicketOpened')
	                                    ),
	                                    ticket.state && _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            (0, _moment2.default)(ticket.state.date).format(_i18n2.default.dateFormat.long)
	                                        ),
	                                        _react2.default.createElement(
	                                            'p',
	                                            null,
	                                            (0, _moment2.default)(ticket.state.date).format(_i18n2.default.timeFormat.long)
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketCard;
	}(_react.Component);
	
	TicketCard.propTypes = {
	    ticket: _react.PropTypes.object.isRequired
	};
	exports.default = TicketCard;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _models = __webpack_require__(124);
	
	var _i18n = __webpack_require__(56);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _i18n3 = __webpack_require__(24);
	
	var _i18n4 = _interopRequireDefault(_i18n3);
	
	var _TicketCallerCard = __webpack_require__(1260);
	
	var _TicketCallerCard2 = _interopRequireDefault(_TicketCallerCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketCallerCard = function (_Component) {
	    _inherits(TicketCallerCard, _Component);
	
	    function TicketCallerCard() {
	        _classCallCheck(this, TicketCallerCard);
	
	        return _possibleConstructorReturn(this, (TicketCallerCard.__proto__ || Object.getPrototypeOf(TicketCallerCard)).apply(this, arguments));
	    }
	
	    _createClass(TicketCallerCard, [{
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket,
	                patrimony = _props.patrimony,
	                patrimonyContact = _props.patrimonyContact,
	                ticketIdLock = _props.ticketIdLock,
	                onSubmit = _props.onSubmit,
	                others = _objectWithoutProperties(_props, ['dispatch', 'ticket', 'patrimony', 'patrimonyContact', 'ticketIdLock', 'onSubmit']);
	
	            var cardHeader = function cardHeader(title) {
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    title
	                );
	            };
	
	            var callerName = function callerName(caller) {
	                if (caller.uid) {
	                    return _react2.default.createElement(
	                        'a',
	                        {
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._navigate(e, '/patrimonycontacts/' + caller.uid);
	                            } },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                caller.name
	                            ),
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' })
	                        )
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    caller.name
	                );
	            };
	
	            var isLocked = function isLocked() {
	                if (ticketIdLock && ticketIdLock != (ticket && ticket.uid)) return true;
	                return !ticket;
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TicketCallerCard2.default.default },
	                _react2.default.createElement(
	                    _Card2.default,
	                    _extends({
	                        header: cardHeader(_i18n4.default.callerIdentity)
	                    }, others),
	                    !isLocked() && _react2.default.createElement(
	                        'div',
	                        null,
	                        callerName(ticket.caller),
	                        ticket.caller.uid == (patrimonyContact && patrimonyContact.uid) && _react2.default.createElement(
	                            'div',
	                            { className: _TicketCallerCard2.default.comment },
	                            _models.Contact.filterLinkedWith(patrimonyContact, { patrimony: patrimony }).map(function (link, index) {
	                                return _react2.default.createElement(
	                                    'p',
	                                    { key: index },
	                                    _models.Contact.extractLinkedWith(_i18n2.default.patrimonyContactLinkTypeEnum, link)
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _TicketCallerCard2.default.contact },
	                            ticket.caller.medium.filter(function (m) {
	                                return m.mediumType == 'PHONE';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'phone', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        (0, _phonez2.default)(medium.identifier).format()
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _TicketCallerCard2.default.contact },
	                            ticket.caller.medium.filter(function (m) {
	                                return m.mediumType == 'MAIL';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'mail', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        medium.identifier
	                                    )
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: _TicketCallerCard2.default.contact },
	                            ticket.caller.medium.filter(function (m) {
	                                return m.mediumType == 'FAX';
	                            }).map(function (medium, index) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react2.default.createElement(_Icon2.default, { icon: 'fax', size: 'xs' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        ' ',
	                                        (0, _phonez2.default)(medium.identifier).format()
	                                    )
	                                );
	                            })
	                        ),
	                        ticket.caller.comment && _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)(_TicketCallerCard2.default.comment, _TicketCallerCard2.default.warning) },
	                            'qsdf',
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                ticket.caller.comment
	                            )
	                        ),
	                        onSubmit && _react2.default.createElement(
	                            'ul',
	                            { className: _TicketCallerCard2.default.callingGroup },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ticket._links.find((0, _links.linkFinder)('EmitCallTo')) && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        onClick: function onClick(e) {
	                                            return onSubmit(e, 'EmitCallTo', ticket.caller);
	                                        } },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _i18n4.default.emitCallz
	                                    ),
	                                    _react2.default.createElement(_Icon2.default, { icon: 'emitCall', size: 'sm' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ticket._links.find((0, _links.linkFinder)('ReceiveCall')) && _react2.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        onClick: function onClick(e) {
	                                            return onSubmit(e, 'ReceiveCall', ticket.caller);
	                                        } },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        _i18n4.default.receiveCallz
	                                    ),
	                                    _react2.default.createElement(_Icon2.default, { icon: 'receiveCall', size: 'sm' })
	                                )
	                            )
	                        )
	                    ),
	                    isLocked() && _react2.default.createElement(
	                        'div',
	                        { className: _TicketCallerCard2.default.noTicketInfo },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            _i18n4.default.noTicketInfo
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketCallerCard;
	}(_react.Component);
	
	TicketCallerCard.propTypes = {
	    ticketIdLock: _react.PropTypes.string,
	    onSubmit: _react.PropTypes.func
	};
	
	
	TicketCallerCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket,
	        patrimony: state.patrimony.patrimony,
	        patrimonyContact: state.patrimony.contact.contact
	    };
	})(TicketCallerCard);
	
	exports.default = TicketCallerCard;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactElmComponents = __webpack_require__(196);
	
	var _reactElmComponents2 = _interopRequireDefault(_reactElmComponents);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _TicketCompanyInfosCard = __webpack_require__(1822);
	
	var _TicketCompanyInfosCard2 = _interopRequireDefault(_TicketCompanyInfosCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketCompanyInfosCard = function (_Component) {
	    _inherits(TicketCompanyInfosCard, _Component);
	
	    function TicketCompanyInfosCard() {
	        _classCallCheck(this, TicketCompanyInfosCard);
	
	        return _possibleConstructorReturn(this, (TicketCompanyInfosCard.__proto__ || Object.getPrototypeOf(TicketCompanyInfosCard)).apply(this, arguments));
	    }
	
	    _createClass(TicketCompanyInfosCard, [{
	        key: 'render',
	
	        /*setupPorts = (ports) => {
	            ports.dispatch.subscribe(this.subscribeDispatch)
	        }*/
	        /*
	        subscribeDispatch = () => {
	            const {dispatch} = this.props
	            dispatch(push('/simplifiedrequests'))
	        }*/
	
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactElmComponents2.default, { src: _TicketCompanyInfosCard2.default.Elm.TicketCompanyInfosCard,
	                    ports: this.setupPorts,
	                    flags: { apiUrl: _config2.default.api.url, company: this.props.company, agencies: this.props.agencies, patrimonyUid: this.props.patrimonyUid }
	                })
	            );
	        }
	    }]);
	
	    return TicketCompanyInfosCard;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)()(TicketCompanyInfosCard);

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OpenTicketAddressCard = __webpack_require__(968);
	
	var _OpenTicketAddressCard2 = _interopRequireDefault(_OpenTicketAddressCard);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _models = __webpack_require__(49);
	
	var _actions = __webpack_require__(38);
	
	var _reactRedux = __webpack_require__(4);
	
	var _OpenTicketLayout = __webpack_require__(1109);
	
	var _OpenTicketLayout2 = _interopRequireDefault(_OpenTicketLayout);
	
	var _cache = __webpack_require__(184);
	
	var _cache2 = _interopRequireDefault(_cache);
	
	var _places = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var schemaCache = (0, _cache2.default)();
	
	function selectSchema(target, _ref) {
	    var step = _ref.step;
	
	    var schema = _models.OpenTicketCmd.selectSchema(target);
	
	    return schemaCache([schema, step], function () {
	        if (step == 0.1) {
	            return _extends({}, schema, {
	                properties: {
	                    company: schema.properties.company,
	                    locationRef: schema.properties.locationRef,
	                    ticket: _extends({}, schema.properties.ticket, {
	                        properties: {
	                            callerz: schema.properties.ticket.properties.callerz,
	                            contactToCallback: schema.properties.ticket.properties.contactToCallback,
	                            address: schema.properties.ticket.properties.address
	                        },
	                        required: ['callerz', 'address']
	                    })
	                },
	                required: ['company', 'locationRef', 'ticket']
	            });
	        }
	        return schema;
	    });
	}
	
	var TicketCorrectLocationReference = function (_Component) {
	    _inherits(TicketCorrectLocationReference, _Component);
	
	    function TicketCorrectLocationReference() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TicketCorrectLocationReference);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = TicketCorrectLocationReference.__proto__ || Object.getPrototypeOf(TicketCorrectLocationReference)).call.apply(_ref2, [this].concat(args))), _this), _this._init = function (props) {
	            var ticket = props.ticket,
	                dispatch = props.dispatch;
	
	            var _ref3 = ticket && ticket.linkedEntities,
	                company = _ref3.clientCompany;
	
	            dispatch((0, _actions.updateCorrectLocationReferenceCmd)({ ticket: ticket, company: company, locationRef: { locationReferenceType: 'PatrimonyLocation' } }));
	        }, _this._submit = function () {
	            var cmd = _this.props.cmd;
	            var ticket = cmd.ticket,
	                locationRef = cmd.locationRef;
	
	            _this.props.onSubmit({
	                address: _extends({}, ticket.address, {
	                    street: [ticket.address.number, ticket.address.street].join(' ')
	                }),
	                locationReference: {
	                    locationReferenceType: locationRef.locationReferenceType,
	                    patrimonyUid: locationRef.patrimonyUid && locationRef.patrimonyUid.uid,
	                    agencyUid: locationRef.agencyUid && locationRef.agencyUid.uid
	                }
	            });
	        }, _this.render = function () {
	            var _this$props = _this.props,
	                form = _this$props.form,
	                cmd = _this$props.cmd,
	                dispatch = _this$props.dispatch,
	                onHide = _this$props.onHide,
	                show = _this$props.show;
	
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                {
	                    bsSize: 'large',
	                    show: show,
	                    onHide: onHide
	                },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.interventionLocation
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_OpenTicketAddressCard2.default, _extends({ form: form, cmd: cmd, dispatch: dispatch }, { split: true })),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large'
	                                // className={cx({disabled: !form.isValid()})}
	                                , onClick: _this._submit
	                            },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide
	                            },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TicketCorrectLocationReference, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this._init(this.props);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.company !== nextProps.company) {
	                this._init(nextProps);
	            }
	        }
	    }]);
	
	    return TicketCorrectLocationReference;
	}(_react.Component);
	
	TicketCorrectLocationReference = (0, _form.connectForm)({
	    validator: (0, _models.createValidator)(),
	    target: 'cmd',
	    schema: selectSchema,
	    action: _actions.CORRECT_LOCATION_REFERENCE_CMD_UPDATED
	})(TicketCorrectLocationReference);
	
	TicketCorrectLocationReference = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.ticket.correctLocationReferenceCmd
	    };
	})(TicketCorrectLocationReference);
	
	exports.default = TicketCorrectLocationReference;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OpeningTicketPurposePicker = __webpack_require__(897);
	
	var _OpeningTicketPurposePicker2 = _interopRequireDefault(_OpeningTicketPurposePicker);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _reactRedux = __webpack_require__(4);
	
	var _actions = __webpack_require__(38);
	
	var _status = __webpack_require__(13);
	
	var _fetchz = __webpack_require__(86);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketCorrectOTPPicker = function (_Component) {
	    _inherits(TicketCorrectOTPPicker, _Component);
	
	    function TicketCorrectOTPPicker() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TicketCorrectOTPPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TicketCorrectOTPPicker.__proto__ || Object.getPrototypeOf(TicketCorrectOTPPicker)).call.apply(_ref, [this].concat(args))), _this), _this.otpSubmit = function (operation, otp) {
	            var dispatch = _this.props.dispatch;
	
	            dispatch({ type: _actions.CORRECT_OTP, cmd: { operation: operation, otp: otp } });
	        }, _this.qualificationChange = function (e) {
	            var dispatch = _this.props.dispatch;
	
	            dispatch({ type: _actions.CORRECT_OTP, cmd: e });
	        }, _this._submit = function () {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                qualification = _this$props.qualification,
	                value = _this$props.value,
	                uid = _this$props.ticketUid,
	                onHide = _this$props.onHide;
	
	
	            var options = {
	                method: 'PATCH',
	                body: _extends({
	                    processUid: _nodeUuid2.default.v4(),
	                    otpLabel: value.label,
	                    otpUid: value.uid,
	                    commandType: 'CorrectOpeningTicketPurpose'
	                }, qualification && qualification.length > 0 ? { qualification: qualification } : {})
	            };
	
	            fetch((0, _fetchz.apiUrl)(_config2.default.api.event.url + '/tickets/' + uid), (0, _fetchz.apiOption)(options)).then(_fetchz.apiResponse).then(function () {
	                onHide();
	                return (0, _actions.enterTicket)(dispatch, { id: uid });
	            }).catch(function (e) {
	                dispatch((0, _status.errorStatus)(e.message));
	            });
	        }, _this.render = function () {
	            var _this$props2 = _this.props,
	                company = _this$props2.company,
	                onHide = _this$props2.onHide,
	                show = _this$props2.show,
	                value = _this$props2.value,
	                qualification = _this$props2.qualification;
	
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                {
	                    bsSize: 'large',
	                    show: show,
	                    onHide: onHide
	                },
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.identifiedRequests
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_OpeningTicketPurposePicker2.default, {
	                        company: company,
	                        value: value,
	                        qualification: qualification,
	                        onSubmit: _this.otpSubmit,
	                        onQualificationChange: _this.qualificationChange
	                    }),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large'
	                                // className={cx({disabled: !form.isValid()})}
	                                , onClick: _this._submit
	                            },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide
	                            },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return TicketCorrectOTPPicker;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (_ref2) {
	    var ticket = _ref2.ticket;
	
	    var _ref3 = ticket || {},
	        cmdCorrectOTP = _ref3.cmdCorrectOTP;
	
	    return cmdCorrectOTP;
	})(TicketCorrectOTPPicker);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _DashboardPanelAdd = __webpack_require__(201);
	
	var _DashboardPanelAdd2 = _interopRequireDefault(_DashboardPanelAdd);
	
	var _AverageNoteDashboardPanel = __webpack_require__(1105);
	
	var _AverageNoteDashboardPanel2 = _interopRequireDefault(_AverageNoteDashboardPanel);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _ProviderDashboardPanel = __webpack_require__(899);
	
	var _ProviderDashboardPanel2 = _interopRequireDefault(_ProviderDashboardPanel);
	
	var _AgencyDashboardPanel = __webpack_require__(1499);
	
	var _AgencyDashboardPanel2 = _interopRequireDefault(_AgencyDashboardPanel);
	
	var _CallPurposeDashboardPanel = __webpack_require__(898);
	
	var _CallPurposeDashboardPanel2 = _interopRequireDefault(_CallPurposeDashboardPanel);
	
	var _ClosingRateDashboardPanel = __webpack_require__(549);
	
	var _ClosingRateDashboardPanel2 = _interopRequireDefault(_ClosingRateDashboardPanel);
	
	var _PatrimonyDashboardPanel = __webpack_require__(1512);
	
	var _PatrimonyDashboardPanel2 = _interopRequireDefault(_PatrimonyDashboardPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketDashboard = function (_Component) {
	    _inherits(TicketDashboard, _Component);
	
	    function TicketDashboard() {
	        _classCallCheck(this, TicketDashboard);
	
	        return _possibleConstructorReturn(this, (TicketDashboard.__proto__ || Object.getPrototypeOf(TicketDashboard)).apply(this, arguments));
	    }
	
	    _createClass(TicketDashboard, [{
	        key: 'render',
	        value: function render() {
	            var dispatch = this.props.dispatch;
	
	
	            var panelHeader = function panelHeader(title) {
	                return _react2.default.createElement(
	                    'h4',
	                    null,
	                    title
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6, md: 4 },
	                    _react2.default.createElement(_AgencyDashboardPanel2.default, null),
	                    _react2.default.createElement(_PatrimonyDashboardPanel2.default, { size: 'large' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6, md: 4 },
	                    _react2.default.createElement(_AverageNoteDashboardPanel2.default, {
	                        header: panelHeader(_i18n2.default.satisfaction) }),
	                    _react2.default.createElement(_ProviderDashboardPanel2.default, { size: 'large' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { sm: 6, md: 4 },
	                    _react2.default.createElement(_ClosingRateDashboardPanel2.default, null),
	                    _react2.default.createElement(_CallPurposeDashboardPanel2.default, { size: 'large' })
	                )
	            );
	        }
	    }]);
	
	    return TicketDashboard;
	}(_react.Component);
	
	TicketDashboard.propTypes = {};
	
	
	TicketDashboard = (0, _reactRedux.connect)()(TicketDashboard);
	
	exports.default = TicketDashboard;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TicketDashboard = __webpack_require__(1525);
	
	var _TicketDashboard2 = _interopRequireDefault(_TicketDashboard);
	
	var _TicketStats = __webpack_require__(1120);
	
	var _TicketStats2 = _interopRequireDefault(_TicketStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketStreamLayout = function (_Component) {
	    _inherits(TicketStreamLayout, _Component);
	
	    function TicketStreamLayout() {
	        _classCallCheck(this, TicketStreamLayout);
	
	        return _possibleConstructorReturn(this, (TicketStreamLayout.__proto__ || Object.getPrototypeOf(TicketStreamLayout)).apply(this, arguments));
	    }
	
	    _createClass(TicketStreamLayout, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_TicketStats2.default, null),
	                _react2.default.createElement(_TicketDashboard2.default, null)
	            );
	        }
	    }]);
	
	    return TicketStreamLayout;
	}(_react.Component);
	
	TicketStreamLayout.propTypes = {};
	exports.default = TicketStreamLayout;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _wizard = __webpack_require__(513);
	
	var _momentz = __webpack_require__(186);
	
	var _links = __webpack_require__(33);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _browser = __webpack_require__(54);
	
	var _datez = __webpack_require__(278);
	
	var _phonez = __webpack_require__(40);
	
	var _phonez2 = _interopRequireDefault(_phonez);
	
	var _Header = __webpack_require__(1090);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardGroup = __webpack_require__(952);
	
	var _CardGroup2 = _interopRequireDefault(_CardGroup);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DownloadIcon = __webpack_require__(890);
	
	var _DownloadIcon2 = _interopRequireDefault(_DownloadIcon);
	
	var _Markdown = __webpack_require__(543);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _NextStepCard = __webpack_require__(1553);
	
	var _NextStepCard2 = _interopRequireDefault(_NextStepCard);
	
	var _NewTicketClaimCard = __webpack_require__(1292);
	
	var _NewTicketClaimCard2 = _interopRequireDefault(_NewTicketClaimCard);
	
	var _SatisfactionButton = __webpack_require__(1487);
	
	var _SatisfactionButton2 = _interopRequireDefault(_SatisfactionButton);
	
	var _AnswerModal = __webpack_require__(1477);
	
	var _AnswerModal2 = _interopRequireDefault(_AnswerModal);
	
	var _models = __webpack_require__(49);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketCallerCard = __webpack_require__(1519);
	
	var _TicketCallerCard2 = _interopRequireDefault(_TicketCallerCard);
	
	var _TicketAddressCard = __webpack_require__(1118);
	
	var _TicketAddressCard2 = _interopRequireDefault(_TicketAddressCard);
	
	var _TicketAssigneeCard = __webpack_require__(1119);
	
	var _TicketAssigneeCard2 = _interopRequireDefault(_TicketAssigneeCard);
	
	var _OpenTicketLayout = __webpack_require__(1109);
	
	var _OpenTicketLayout2 = _interopRequireDefault(_OpenTicketLayout);
	
	var _OpenTicketStreamCardLayout = __webpack_require__(1112);
	
	var _OpenTicketStreamCardLayout2 = _interopRequireDefault(_OpenTicketStreamCardLayout);
	
	var _OpenTicketCompanyCard = __webpack_require__(1510);
	
	var _OpenTicketCompanyCard2 = _interopRequireDefault(_OpenTicketCompanyCard);
	
	var _IdentifyAssigneeCard = __webpack_require__(1507);
	
	var _IdentifyAssigneeCard2 = _interopRequireDefault(_IdentifyAssigneeCard);
	
	var _AcceptRefuseInterventionCard = __webpack_require__(1497);
	
	var _AcceptRefuseInterventionCard2 = _interopRequireDefault(_AcceptRefuseInterventionCard);
	
	var _AddMessageCard = __webpack_require__(1498);
	
	var _AddMessageCard2 = _interopRequireDefault(_AddMessageCard);
	
	var _CloseTicketCard = __webpack_require__(1500);
	
	var _CloseTicketCard2 = _interopRequireDefault(_CloseTicketCard);
	
	var _OpenTicketCompanyModal = __webpack_require__(1107);
	
	var _OpenTicketCompanyModal2 = _interopRequireDefault(_OpenTicketCompanyModal);
	
	var _ReportSendingServiceOrderModal = __webpack_require__(1516);
	
	var _ReportSendingServiceOrderModal2 = _interopRequireDefault(_ReportSendingServiceOrderModal);
	
	var _DefineInterventionDeadlineModal = __webpack_require__(1504);
	
	var _DefineInterventionDeadlineModal2 = _interopRequireDefault(_DefineInterventionDeadlineModal);
	
	var _ReportFormalNoticeForProviderModal = __webpack_require__(1515);
	
	var _ReportFormalNoticeForProviderModal2 = _interopRequireDefault(_ReportFormalNoticeForProviderModal);
	
	var _ScheduleInterventionModal = __webpack_require__(1517);
	
	var _ScheduleInterventionModal2 = _interopRequireDefault(_ScheduleInterventionModal);
	
	var _CorrectTicketInformationsModal = __webpack_require__(1503);
	
	var _CorrectTicketInformationsModal2 = _interopRequireDefault(_CorrectTicketInformationsModal);
	
	var _CorrectTicketEventInformationsModal = __webpack_require__(1502);
	
	var _CorrectTicketEventInformationsModal2 = _interopRequireDefault(_CorrectTicketEventInformationsModal);
	
	var _ReceiveCallModal = __webpack_require__(1113);
	
	var _ReceiveCallModal2 = _interopRequireDefault(_ReceiveCallModal);
	
	var _EmitCallToModal = __webpack_require__(1505);
	
	var _EmitCallToModal2 = _interopRequireDefault(_EmitCallToModal);
	
	var _ExportTicketsModal = __webpack_require__(1106);
	
	var _ExportTicketsModal2 = _interopRequireDefault(_ExportTicketsModal);
	
	var _FinishMissionModal = __webpack_require__(1506);
	
	var _FinishMissionModal2 = _interopRequireDefault(_FinishMissionModal);
	
	var _TicketDetail = __webpack_require__(2335);
	
	var _TicketDetail2 = _interopRequireDefault(_TicketDetail);
	
	var _TicketCompanyInfosCard = __webpack_require__(1522);
	
	var _TicketCompanyInfosCard2 = _interopRequireDefault(_TicketCompanyInfosCard);
	
	var _TicketCorrectOTPPicker = __webpack_require__(1524);
	
	var _TicketCorrectOTPPicker2 = _interopRequireDefault(_TicketCorrectOTPPicker);
	
	var _fetchz = __webpack_require__(86);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _status = __webpack_require__(13);
	
	var _ShowDocumentsCard = __webpack_require__(1518);
	
	var _ShowDocumentsCard2 = _interopRequireDefault(_ShowDocumentsCard);
	
	var _ToggleablePanel = __webpack_require__(1356);
	
	var _ToggleablePanel2 = _interopRequireDefault(_ToggleablePanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function selectActiveStep(steps, _ref) {
	    var ticket = _ref.ticket;
	
	    if (!ticket.uid) return 1.1;
	    if (!ticket.state) return 2.1;
	
	    switch (ticket.state.value) {
	        case 'AssigneeIdentified':
	            return 3.2;
	        case 'InterventionAccepted':
	            return 4.3;
	        case 'InterventionStarted':
	            return 5.3;
	        default:
	            return 6;
	    }
	}
	
	function findState(step) {
	    switch ((0, _wizard.major)(step)) {
	        case 2:
	            return 'TicketOpened';
	        case 3:
	            return 'AssigneeIdentified';
	        case 4:
	            return 'InterventionAccepted';
	        case 5:
	            return 'InterventionStarted';
	        case 6:
	            return 'TicketClosed';
	    }
	}
	
	function eventAggregator(result, event) {
	    var aggrega = result.find(function (e) {
	        return (0, _datez.isSameDay)(e.date, event.date);
	    });
	
	    if (!aggrega) {
	        aggrega = {
	            date: event.date,
	            events: [],
	            commentCount: 0
	        };
	        result.push(aggrega);
	    }
	
	    aggrega.events.push(event);
	
	    if (event.eventName == 'MessageAdded' || event.data.comment) {
	        aggrega.commentCount++;
	    }
	    return result;
	}
	
	function modalName(result) {
	    switch (result) {
	        case 'EmitCallTo':
	            return 'EmitCallToModal';
	        case 'ReceiveCall':
	            return 'ReceiveCallModal';
	        default:
	            return result;
	    }
	}
	
	var TicketDetail = function (_Component) {
	    _inherits(TicketDetail, _Component);
	
	    function TicketDetail(props) {
	        _classCallCheck(this, TicketDetail);
	
	        var _this = _possibleConstructorReturn(this, (TicketDetail.__proto__ || Object.getPrototypeOf(TicketDetail)).call(this, props));
	
	        _this.refreshTicket = function () {
	            var _this$props = _this.props,
	                dispatch = _this$props.dispatch,
	                ticket = _this$props.ticket;
	
	
	            dispatch((0, _actions.loadTicket)(ticket.uid));
	        };
	
	        _this._closeModalOTP = function () {
	            _this.setState({ modalOtpShow: false });
	        };
	
	        _this._openModalOTP = function (e) {
	            e.preventDefault();
	
	            var _this$props2 = _this.props,
	                dispatch = _this$props2.dispatch,
	                ticket = _this$props2.ticket;
	
	            var _ref2 = ticket || {},
	                openingTicketPurpose = _ref2.openingTicketPurpose,
	                qualification = _ref2.qualification;
	
	            var uid = openingTicketPurpose.callPurposeUid,
	                label = openingTicketPurpose.callPurpose;
	
	            var value = { uid: uid, label: label };
	
	            _this.setState({ modalOtpShow: true });
	            dispatch({ type: _actions.CORRECT_OTP, cmd: { value: value, qualification: qualification } });
	        };
	
	        _this.state = {
	            missionFinishedJournalEvents: [],
	            journalAggregations: []
	        };
	
	        window.addEventListener('message', function (event) {
	            if (event.data.type === 'RefreshTicket') {
	                _this.refreshTicket();
	            }
	        }, false);
	        return _this;
	    }
	
	    _createClass(TicketDetail, [{
	        key: '_cleanJournal',
	        value: function _cleanJournal(ticket) {
	            return ticket.journal.reduce(function (acc, e) {
	                if (e.eventName === 'InterventionStarted') {
	                    var evt = acc.filter(function (e) {
	                        return e.eventName === 'InterventionStarted';
	                    }).concat(e).sort(function (e1, e2) {
	                        return new Date(e2.data.sentDate).getTime() - new Date(e1.data.sentDate).getTime();
	                    })[0];
	
	                    return acc.filter(function (e) {
	                        return e.eventName !== 'InterventionStarted';
	                    }).concat(evt);
	                } else if (e.eventName === 'InterventionFinished') {
	                    var _evt = acc.filter(function (e) {
	                        return e.eventName === 'InterventionFinished';
	                    }).concat(e).sort(function (e1, e2) {
	                        return new Date(e2.data.sentDate).getTime() - new Date(e1.data.sentDate).getTime();
	                    })[0];
	
	                    return acc.filter(function (e) {
	                        return e.eventName !== 'InterventionFinished';
	                    }).concat(_evt);
	                } else {
	                    return acc.concat(e);
	                }
	            }, []);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var ticket = this.props.ticket;
	
	
	            var activeJournalEvent = _models.Ticket.findActiveStateJournalEvent(ticket);
	            var missionFinishedJournalEvents = _models.Ticket.findJournalEvents(ticket, 'MissionFinished');
	
	            var journalAggregations = this._cleanJournal(ticket).reduce(eventAggregator, []);
	            this.setState({ activeJournalEvent: activeJournalEvent, missionFinishedJournalEvents: missionFinishedJournalEvents, journalAggregations: journalAggregations });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.ticket != this.props.ticket) {
	                var ticket = nextProps.ticket;
	
	
	                var activeJournalEvent = _models.Ticket.findActiveStateJournalEvent(ticket);
	                var missionFinishedJournalEvents = _models.Ticket.findJournalEvents(ticket, 'MissionFinished');
	                var journalAggregations = this._cleanJournal(ticket).reduce(eventAggregator, []);
	                this.setState({ activeJournalEvent: activeJournalEvent, missionFinishedJournalEvents: missionFinishedJournalEvents, journalAggregations: journalAggregations, activeAssignee: ticket.assignee });
	            }
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(path) {
	            var dispatch = this.props.dispatch;
	
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, name) {
	            event.preventDefault();
	            this.setState({ openedModal: name });
	        }
	    }, {
	        key: '_openEventModal',
	        value: function _openEventModal(event, name, activeEvent) {
	            event.preventDefault();
	            this.setState({ openedModal: name, activeEvent: activeEvent });
	        }
	    }, {
	        key: '_openEmitReceiveCallModal',
	        value: function _openEmitReceiveCallModal(event, result, activeAssignee, activeCaller, activeContactToCallback, activeTicket) {
	            event.preventDefault();
	
	            var openedModal = modalName(result);
	            this.setState({ openedModal: openedModal, activeAssignee: activeAssignee, activeCaller: activeCaller, activeContactToCallback: activeContactToCallback, activeTicket: activeTicket });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal() {
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                progress = _props.progress,
	                ticket = _props.ticket,
	                wizard = _props.wizard,
	                _appLinks = _props._appLinks,
	                dispatch = _props.dispatch;
	            var _state = this.state,
	                activeJournalEvent = _state.activeJournalEvent,
	                missionFinishedJournalEvents = _state.missionFinishedJournalEvents,
	                journalAggregations = _state.journalAggregations;
	            var _state2 = this.state,
	                openedModal = _state2.openedModal,
	                activeEvent = _state2.activeEvent,
	                activeAssignee = _state2.activeAssignee,
	                activeCaller = _state2.activeCaller,
	                activeContactToCallback = _state2.activeContactToCallback,
	                activeTicket = _state2.activeTicket;
	
	
	            var headerHelp = function headerHelp() {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _TicketDetail2.default.headerHelp },
	                    _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' ',
	                        (0, _moment2.default)(ticket.dates.created).format(_i18n2.default.creationDateTimeFormat),
	                        ' '
	                    ),
	                    _react2.default.createElement(_Icon2.default, { icon: _models.Ticket.accurateStatus(ticket), size: 'sm' })
	                );
	            };
	
	            var cardHeader = function cardHeader(title) {
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    title
	                );
	            };
	
	            var cardHeaderLarge = function cardHeaderLarge(title) {
	                return _react2.default.createElement(
	                    'h3',
	                    null,
	                    title
	                );
	            };
	
	            var boxBackground = function boxBackground(icon) {
	                return _react2.default.createElement(_Icon2.default, { icon: icon, size: 'xl' });
	            };
	
	            var journalPanelHeader = function journalPanelHeader(aggrega) {
	                return _react2.default.createElement(
	                    'h5',
	                    { className: _TicketDetail2.default.journalHeader },
	                    aggrega.commentCount > 0 && _react2.default.createElement(
	                        'div',
	                        { className: _TicketDetail2.default.count },
	                        _react2.default.createElement(_Icon2.default, { icon: 'comment', size: 'sm', count: aggrega.commentCount })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _TicketDetail2.default.container },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '> ',
	                            (0, _moment2.default)(aggrega.date).format(_i18n2.default.dateFormat.longer),
	                            ' '
	                        ),
	                        _react2.default.createElement(_Icon2.default, { icon: 'up', size: 'sm' })
	                    )
	                );
	            };
	
	            var tooltip = function tooltip(text, status) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: status && 'tooltip-' + status },
	                    text
	                );
	            };
	
	            var metricBoxes = _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6 },
	                    _react2.default.createElement(
	                        _Box2.default,
	                        {
	                            kind: 'rounded',
	                            background: boxBackground('hourglass') },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _TicketDetail2.default.metricBox },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _i18n2.default.callCenterResponseTime
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.OverlayTrigger,
	                                {
	                                    placement: 'bottom',
	                                    overlay: tooltip(_i18n2.default.callCenterResponseTimeText) },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketDetail2.default.time },
	                                    (0, _momentz.humanize)(_moment2.default.duration(ticket.stats.transmissionTime))
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { xs: 6 },
	                    _react2.default.createElement(
	                        _Box2.default,
	                        {
	                            kind: 'rounded',
	                            background: boxBackground('clock-elapsed') },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _TicketDetail2.default.metricBox },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _i18n2.default.callCenterReactionTime
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.OverlayTrigger,
	                                {
	                                    placement: 'bottom',
	                                    overlay: tooltip(_i18n2.default.callCenterReactionTimeText) },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketDetail2.default.time },
	                                    (0, _momentz.humanize)(_moment2.default.duration(ticket.stats.callCenterReactionTime))
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	
	            var finishMissionEventCard = missionFinishedJournalEvents.length > 0 && _react2.default.createElement(
	                _Box2.default,
	                { active: true,
	                    status: 'danger' },
	                _react2.default.createElement(
	                    'div',
	                    { className: _TicketDetail2.default.missionFinished },
	                    missionFinishedJournalEvents.map(function (event, index) {
	                        return _react2.default.createElement(
	                            'p',
	                            {
	                                key: index },
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                event.data.companyName
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.finishedMissionEvent
	                            )
	                        );
	                    })
	                )
	            );
	
	            var patrimonyUid = ticket.linkedEntities && ticket.linkedEntities.patrimony && ticket.linkedEntities.patrimony.uid || null;
	            var companyCard = ticket.linkedEntities && ticket.linkedEntities.clientCompany && _react2.default.createElement(_TicketCompanyInfosCard2.default, {
	                company: { uid: ticket.linkedEntities.clientCompany.uid, name: ticket.linkedEntities.clientCompany.name },
	                agencies: ticket.linkedEntities.agencies,
	                patrimonyUid: patrimonyUid });
	
	            var additionalDataCard = _react2.default.createElement(
	                _Card2.default,
	                {
	                    header: cardHeaderLarge(_i18n2.default.additionalData) },
	                _react2.default.createElement(
	                    'ul',
	                    { className: _TicketDetail2.default.data },
	                    Object.keys(ticket.additionalDataz).map(function (key, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            {
	                                key: index },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                '> ',
	                                key,
	                                ' :'
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                ticket.additionalDataz[key]
	                            )
	                        );
	                    })
	                )
	            );
	
	            var instructionsCard = ticket.instructions && _react2.default.createElement(
	                _Card2.default,
	                {
	                    status: 'danger',
	                    header: cardHeaderLarge(_i18n2.default.instructions) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _TicketDetail2.default.instruction },
	                    _react2.default.createElement(_Markdown2.default, { markdown: ticket.instructions })
	                )
	            );
	
	            var editMenuCard = _react2.default.createElement(
	                _Card2.default,
	                {
	                    header: cardHeaderLarge(_i18n2.default.updateTicket) },
	                _react2.default.createElement(
	                    'ul',
	                    { className: _TicketDetail2.default.menu },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: !ticket._links.find((0, _links.linkFinder)('CorrectTicketInformations')),
	                                onClick: function onClick(e) {
	                                    return _this2._openModal(e, 'CorrectTicketInformationsModal');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.correctTicketInformations
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: !ticket._links.find((0, _links.linkFinder)('ReceiveCall')),
	                                onClick: function onClick(e) {
	                                    return _this2._openEmitReceiveCallModal(e, 'ReceiveCallModal', ticket.assignee, ticket.caller, ticket.contactToCallback);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.receiveCallzAction
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: !ticket._links.find((0, _links.linkFinder)('EmitCallTo')),
	                                onClick: function onClick(e) {
	                                    return _this2._openEmitReceiveCallModal(e, 'EmitCallToModal', ticket.assignee, ticket.caller, ticket.contactToCallback);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.emitCallzAction
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: !ticket._links.find((0, _links.linkFinder)('ScheduleIntervention')),
	                                onClick: function onClick(e) {
	                                    return _this2._openModal(e, 'ScheduleInterventionModal');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.scheduleIntervention
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: !ticket._links.find((0, _links.linkFinder)('FinishMission')),
	                                onClick: function onClick(e) {
	                                    return _this2._openModal(e, 'FinishMissionModal');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.finishMission
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: !ticket._links.find((0, _links.linkFinder)('ReportSendingServiceOrder')),
	                                onClick: function onClick(e) {
	                                    return _this2._openModal(e, 'ReportSendingServiceOrderModal');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.reportSendingServiceOrder
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: !ticket._links.find((0, _links.linkFinder)('DefineInterventionDeadline')),
	                                onClick: function onClick(e) {
	                                    return _this2._openModal(e, 'DefineInterventionDeadlineModal');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.defineInterventionDeadline
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                disabled: !ticket._links.find((0, _links.linkFinder)('ReportFormalNoticeForProvider')),
	                                onClick: function onClick(e) {
	                                    return _this2._openModal(e, 'ReportFormalNoticeForProviderModal');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.reportFormalNoticeForProvider
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'link',
	                                onClick: (0, _actions.restrictAccessToCall)(dispatch) },
	                            _react2.default.createElement(_Icon2.default, { icon: 'plus', size: 'xs' }),
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                _i18n2.default.restrictedAccess
	                            )
	                        )
	                    )
	                )
	            );
	
	            var exportButton = _react2.default.createElement(
	                'div',
	                { className: _TicketDetail2.default.export },
	                _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                        placement: 'bottom',
	                        overlay: tooltip(progress[_actions.PDF_TICKETS_EXPORTED] && _i18n2.default.exportingTickets || _i18n2.default.exportPdfTickets, 'primary') },
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'link',
	                            bsSize: 'small',
	                            disabled: !!progress[_actions.PDF_TICKETS_EXPORTED],
	                            onClick: function onClick(e) {
	                                return _this2._openModal(e, 'ExportTicketsModal');
	                            } },
	                        _react2.default.createElement(_DownloadIcon2.default, { progress: progress[_actions.PDF_TICKETS_EXPORTED] })
	                    )
	                )
	            );
	
	            var stepTooltip = function stepTooltip(step, active, success) {
	                var className = (0, _classnames2.default)({
	                    'tooltip-disabled': !active && !success,
	                    'tooltip-danger': active,
	                    'tooltip-success': success
	                });
	
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: className },
	                    (0, _extract2.default)(_i18n2.default.stateEnum, findState(step))
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TicketDetail2.default.default },
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        wizard.matchActiveStep(1) && _react2.default.createElement(
	                            _Header2.default,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _i18n2.default.newTicket
	                            )
	                        ),
	                        wizard.matchActiveStep([2, 3, 4, 5, 6]) && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _Header2.default,
	                                {
	                                    status: 'success',
	                                    help: headerHelp() },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'ticket n\xB0 ',
	                                    ticket.ref
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                { className: _TicketDetail2.default.state },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    (0, _extract2.default)(_i18n2.default.stateEnum, ticket.state && ticket.state.value || 'TicketOpened')
	                                ),
	                                _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    ' ',
	                                    activeJournalEvent && _models.Ticket.replaceJournalEvent(_models.Ticket.extractJournalEvent(_i18n2.default.journalEventEnum, activeJournalEvent), activeJournalEvent)
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Nav,
	                            { justified: true,
	                                bsStyle: 'progress',
	                                activeKey: wizard.majorActiveStep },
	                            [2, 3, 4, 5, 6].map(function (step, index) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.NavItem,
	                                    {
	                                        key: index,
	                                        eventKey: step,
	                                        className: (0, _classnames2.default)({ 'nav-success': step < wizard.activeStep }) },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: stepTooltip(step, wizard.matchActiveStep(step), step < wizard.activeStep) },
	                                        _react2.default.createElement(
	                                            'span',
	                                            {
	                                                className: _TicketDetail2.default.step },
	                                            step - 1
	                                        )
	                                    )
	                                );
	                            })
	                        ),
	                        wizard.matchActiveStep(1) && _react2.default.createElement(
	                            'div',
	                            null,
	                            !(0, _browser.matchMedia)('sm') && _react2.default.createElement(_OpenTicketCompanyCard2.default, null)
	                        ),
	                        wizard.matchActiveStep([2, 3, 4, 5, 6]) && _react2.default.createElement(
	                            'div',
	                            null,
	                            !(0, _browser.matchMedia)('sm') && _react2.default.createElement(
	                                'div',
	                                { className: _TicketDetail2.default.exportAndSatisfaction },
	                                exportButton,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketDetail2.default.satisfaction },
	                                    _react2.default.createElement(_SatisfactionButton2.default, { block: true,
	                                        ticket: ticket,
	                                        onClick: function onClick(e) {
	                                            return _this2._openModal(e, 'AnswerModal');
	                                        } })
	                                )
	                            ),
	                            !(0, _browser.matchMedia)('sm') && instructionsCard,
	                            !(0, _browser.matchMedia)('sm') && metricBoxes,
	                            !(0, _browser.matchMedia)('sm') && finishMissionEventCard,
	                            !(0, _browser.matchMedia)('sm') && companyCard,
	                            !(0, _browser.matchMedia)('sm') && _react2.default.createElement(_ShowDocumentsCard2.default, { simplifiedRequest: ticket.linkedEntities.openedFromSimplifiedRequest,
	                                ticket: ticket.uid }),
	                            _react2.default.createElement(
	                                _ToggleablePanel2.default,
	                                { startHidden: true },
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: _TicketDetail2.default.callPurpose },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _i18n2.default.callPurpose,
	                                        '\xA0:'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '\xA0',
	                                        ticket.openingTicketPurpose.callPurpose
	                                    ),
	                                    ticket._links.find((0, _links.linkFinder)('CorrectOpeningTicketPurpose')) && _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'link ' + _TicketDetail2.default.myAction,
	                                            onClick: this._openModalOTP,
	                                            title: _i18n2.default.correctOtp,
	                                            alt: _i18n2.default.correctOtp
	                                        },
	                                        _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                                    )
	                                ),
	                                ticket.qualification && ticket.qualification.comment && _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        ticket.qualification.comment.title
	                                    ),
	                                    _react2.default.createElement(_Markdown2.default, { markdown: ticket.qualification.comment.comment })
	                                ),
	                                ticket.qualification && !ticket.qualification.choices.isEmpty && _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        'Crit\xE8res de qualification'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        ticket.qualification.choices.map(function (c) {
	                                            return _react2.default.createElement(
	                                                'span',
	                                                { key: c.criterionUid },
	                                                c.criterionLabel + ': ' + c.choice.value
	                                            );
	                                        }).reduce(function (acc, item) {
	                                            return acc.concat([item, _react2.default.createElement('br', null)]);
	                                        }, [])
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(_TicketCorrectOTPPicker2.default, {
	                                company: ticket.linkedEntities.clientCompany,
	                                ticketUid: ticket.uid,
	                                onHide: this._closeModalOTP,
	                                show: this.state.modalOtpShow
	                            }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketDetail2.default.description },
	                                _react2.default.createElement(
	                                    _ToggleablePanel2.default,
	                                    { startHidden: false },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        _i18n2.default.description,
	                                        '\xA0:'
	                                    ),
	                                    _react2.default.createElement(_Markdown2.default, { markdown: ticket.request })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(_TicketCallerCard2.default, {
	                                        kind: 'tab',
	                                        onSubmit: function onSubmit(e, r, c) {
	                                            return _this2._openEmitReceiveCallModal(e, r, null, c, null);
	                                        } })
	                                ),
	                                ticket.contactToCallback && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _Card2.default,
	                                        {
	                                            kind: 'tab',
	                                            header: cardHeader(_i18n2.default.contactToCallback) },
	                                        _react2.default.createElement(
	                                            'h5',
	                                            null,
	                                            ticket.contactToCallback.name
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: _TicketDetail2.default.contact },
	                                            ticket.contactToCallback.medium && ticket.contactToCallback.medium.contactMediumType == 'Phone' && _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, { icon: 'phone', size: 'xs' }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' ',
	                                                    (0, _phonez2.default)(ticket.contactToCallback.medium && ticket.contactToCallback.medium.phone).format()
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: _TicketDetail2.default.contact },
	                                            ticket.contactToCallback.medium && ticket.contactToCallback.medium.contactMediumType == 'Mail' && _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, { icon: 'mail', size: 'xs' }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' ',
	                                                    ticket.contactToCallback.medium && ticket.contactToCallback.medium.mail
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: _TicketDetail2.default.contact },
	                                            ticket.contactToCallback.medium && ticket.contactToCallback.medium.contactMediumType == 'Fax' && _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, { icon: 'fax', size: 'xs' }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    null,
	                                                    ' ',
	                                                    (0, _phonez2.default)(ticket.contactToCallback.medium && ticket.contactToCallback.medium.fax).format()
	                                                )
	                                            )
	                                        ),
	                                        ticket.contactToCallback.comment && _react2.default.createElement(
	                                            'div',
	                                            { className: (0, _classnames2.default)(_TicketDetail2.default.comment, _TicketDetail2.default.warning) },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                ticket.contactToCallback.comment
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: _TicketDetail2.default.callingGroup },
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                ticket._links.find((0, _links.linkFinder)('EmitCallTo')) && _react2.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        onClick: function onClick(e) {
	                                                            return _this2._openEmitReceiveCallModal(e, 'EmitCallToModal', null, null, ticket.contactToCallback);
	                                                        } },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        _i18n2.default.emitCallz
	                                                    ),
	                                                    _react2.default.createElement(_Icon2.default, { icon: 'emitCall', size: 'sm' })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                ticket._links.find((0, _links.linkFinder)('ReceiveCall')) && _react2.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        onClick: function onClick(e) {
	                                                            return _this2._openEmitReceiveCallModal(e, 'ReceiveCallModal', null, null, ticket.contactToCallback);
	                                                        } },
	                                                    _react2.default.createElement(
	                                                        'p',
	                                                        null,
	                                                        _i18n2.default.receiveCallz
	                                                    ),
	                                                    _react2.default.createElement(_Icon2.default, { icon: 'receiveCall', size: 'sm' })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: ticket.contactToCallback && 12 || 6 },
	                                    _react2.default.createElement(_TicketAddressCard2.default, {
	                                        kind: 'tab',
	                                        split: !!ticket.contactToCallback
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Row,
	                                null,
	                                ticket.assignee && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: ticket.report && 6 || 12 },
	                                    _react2.default.createElement(_TicketAssigneeCard2.default, {
	                                        kind: 'tab',
	                                        split: !ticket.report,
	                                        onSubmit: function onSubmit(e, r, p) {
	                                            return _this2._openEmitReceiveCallModal(e, r, p, null, null);
	                                        } })
	                                ),
	                                ticket.report && _react2.default.createElement(
	                                    _reactBootstrap.Col,
	                                    { sm: 6 },
	                                    _react2.default.createElement(
	                                        _Card2.default,
	                                        {
	                                            position: 'right',
	                                            header: cardHeader(_i18n2.default.interventionReport) },
	                                        _react2.default.createElement(_Markdown2.default, { markdown: ticket.report })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketDetail2.default.switch },
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    {
	                                        value: wizard.minorActiveStep,
	                                        onChange: function onChange(s) {
	                                            return s && wizard.setActiveStep(s);
	                                        } },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.ButtonGroup,
	                                        { justified: true },
	                                        ticket._links.find((0, _links.linkFinder)('IdentifyAssignee')) && _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                href: '/',
	                                                value: 0.1 },
	                                            ticket.assignee && _i18n2.default.changeRecourse || _i18n2.default.identifyAssignee
	                                        ),
	                                        ticket._links.find((0, _links.linkFinder)(['AcceptIntervention', 'RefuseIntervention'])) && _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                href: '/',
	                                                value: 0.2 },
	                                            _i18n2.default.interventionAcceptation
	                                        ),
	                                        ticket._links.find((0, _links.linkFinder)(_models.CLOSE_TICKET_CMD_TYPES)) && _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                href: '/',
	                                                value: 0.3 },
	                                            _i18n2.default.closeTicket
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        wizard.matchActiveStep(1) && _react2.default.createElement(_OpenTicketLayout2.default, {
	                            step: wizard.minorActiveStep,
	                            onSubmit: function onSubmit(s) {
	                                return wizard.setActiveStep(s);
	                            } }),
	                        wizard.matchActiveStep(0.1) && ticket._links.find((0, _links.linkFinder)('IdentifyAssignee')) && _react2.default.createElement(_IdentifyAssigneeCard2.default, null),
	                        wizard.matchActiveStep(0.2) && ticket._links.find((0, _links.linkFinder)(['AcceptIntervention', 'RefuseIntervention'])) && _react2.default.createElement(_AcceptRefuseInterventionCard2.default, { assignee: ticket.assignee }),
	                        wizard.matchActiveStep(0.3) && ticket._links.find((0, _links.linkFinder)(_models.CLOSE_TICKET_CMD_TYPES)) && _react2.default.createElement(_CloseTicketCard2.default, null),
	                        wizard.matchActiveStep([2, 3, 4, 5, 6]) && _react2.default.createElement(
	                            'div',
	                            null,
	                            !(0, _browser.matchMedia)('sm') && _react2.default.createElement(_NextStepCard2.default, {
	                                ticket: ticket }),
	                            !(0, _browser.matchMedia)('sm') && editMenuCard,
	                            ticket._links.find((0, _links.linkFinder)('AddMessage')) && _react2.default.createElement(
	                                'div',
	                                null,
	                                !(0, _browser.matchMedia)('sm') && _react2.default.createElement(_AddMessageCard2.default, null)
	                            ),
	                            !(0, _browser.matchMedia)('sm') && additionalDataCard,
	                            !(0, _browser.matchMedia)('sm') && _react2.default.createElement(_NewTicketClaimCard2.default, {
	                                ticket: ticket }),
	                            _react2.default.createElement(
	                                _reactBootstrap.PageHeader,
	                                null,
	                                _i18n2.default.journalEvent
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.PanelGroup,
	                                null,
	                                journalAggregations.map(function (aggrega, index) {
	                                    return _react2.default.createElement(
	                                        _reactBootstrap.Panel,
	                                        { collapsible: true,
	                                            key: index,
	                                            className: 'panel-pageheader',
	                                            defaultExpanded: index == 0,
	                                            header: journalPanelHeader(aggrega) },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            { className: _TicketDetail2.default.journalBody },
	                                            aggrega.events.map(function (event, index) {
	                                                return _react2.default.createElement(
	                                                    'li',
	                                                    {
	                                                        key: index },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: _TicketDetail2.default.time },
	                                                        _react2.default.createElement(_Icon2.default, { icon: 'clock', size: 'xs' }),
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            null,
	                                                            (0, _moment2.default)(event.date).format(_i18n2.default.timeFormat.default)
	                                                        )
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { className: _TicketDetail2.default.container },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            null,
	                                                            event.eventName == 'MessageAdded' && _react2.default.createElement(_Icon2.default, { icon: 'quote', size: 'xs' }),
	                                                            _models.CORRECT_TICKET_EVENT_NAMES.indexOf(event.eventName) >= 0 && ticket._links.find((0, _links.linkFinder)('CorrectTicketEventInformations')) && _react2.default.createElement(
	                                                                'a',
	                                                                {
	                                                                    className: _TicketDetail2.default.action,
	                                                                    href: '',
	                                                                    onClick: function onClick(e) {
	                                                                        return _this2._openEventModal(e, 'CorrectTicketEventInformationsModal', event);
	                                                                    } },
	                                                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'span',
	                                                                null,
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    null,
	                                                                    ' ',
	                                                                    _react2.default.createElement(_Markdown2.default, { markdown: _models.Ticket.replaceJournalEvent(_models.Ticket.extractJournalEvent(_i18n2.default.journalEventEnum, event), event) })
	                                                                ),
	                                                                event.updated.length > 0 && _react2.default.createElement(
	                                                                    'span',
	                                                                    { className: _TicketDetail2.default.info },
	                                                                    ' (',
	                                                                    _i18n2.default.corrected,
	                                                                    ')'
	                                                                )
	                                                            )
	                                                        ),
	                                                        [event.data.callPurpose, event.data.comment].filter(function (t) {
	                                                            return t;
	                                                        }).map(function (text, index) {
	                                                            return _react2.default.createElement(
	                                                                'p',
	                                                                { key: index },
	                                                                _react2.default.createElement(_Icon2.default, { icon: 'quote', size: 'xs' }),
	                                                                _react2.default.createElement(
	                                                                    'span',
	                                                                    null,
	                                                                    ' ',
	                                                                    text
	                                                                )
	                                                            );
	                                                        })
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        wizard.matchActiveStep(1) && _react2.default.createElement(
	                            'div',
	                            null,
	                            (0, _browser.matchMedia)('sm') && _react2.default.createElement(_OpenTicketCompanyCard2.default, null),
	                            _react2.default.createElement(_OpenTicketStreamCardLayout2.default, {
	                                onSubmit: function onSubmit(e, a, c, t) {
	                                    return _this2._openEmitReceiveCallModal(e, 'ReceiveCallModal', null, c, null, t);
	                                } })
	                        ),
	                        wizard.matchActiveStep([2, 3, 4, 5, 6]) && _react2.default.createElement(
	                            'div',
	                            null,
	                            (0, _browser.matchMedia)('sm') && [_react2.default.createElement(
	                                'div',
	                                { className: _TicketDetail2.default.exportAndSatisfaction },
	                                exportButton,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketDetail2.default.satisfaction },
	                                    _react2.default.createElement(_SatisfactionButton2.default, { block: true,
	                                        ticket: ticket,
	                                        onClick: function onClick(e) {
	                                            return _this2._openModal(e, 'AnswerModal');
	                                        } })
	                                )
	                            ), instructionsCard, metricBoxes, _react2.default.createElement(_NextStepCard2.default, { ticket: ticket }), finishMissionEventCard, companyCard, _react2.default.createElement(_ShowDocumentsCard2.default, { simplifiedRequest: ticket.linkedEntities.openedFromSimplifiedRequest,
	                                ticket: ticket.uid }), editMenuCard, additionalDataCard],
	                            ticket._links.find((0, _links.linkFinder)('AddMessage')) && _react2.default.createElement(
	                                'div',
	                                null,
	                                (0, _browser.matchMedia)('sm') && _react2.default.createElement(_AddMessageCard2.default, null)
	                            ),
	                            (0, _browser.matchMedia)('sm') && _react2.default.createElement(_NewTicketClaimCard2.default, {
	                                ticket: ticket })
	                        )
	                    )
	                ),
	                wizard.matchActiveStep(1) && _react2.default.createElement(_OpenTicketCompanyModal2.default, {
	                    onSubmit: function onSubmit() {
	                        return _this2._navigate('/tickets');
	                    } }),
	                ticket._links.find((0, _links.linkFinder)('ReportSendingServiceOrder')) && _react2.default.createElement(_ReportSendingServiceOrderModal2.default, {
	                    show: openedModal == 'ReportSendingServiceOrderModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                ticket._links.find((0, _links.linkFinder)('DefineInterventionDeadline')) && _react2.default.createElement(_DefineInterventionDeadlineModal2.default, {
	                    show: openedModal == 'DefineInterventionDeadlineModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                ticket._links.find((0, _links.linkFinder)('ReportFormalNoticeForProvider')) && _react2.default.createElement(_ReportFormalNoticeForProviderModal2.default, {
	                    show: openedModal == 'ReportFormalNoticeForProviderModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                ticket._links.find((0, _links.linkFinder)('ScheduleIntervention')) && _react2.default.createElement(_ScheduleInterventionModal2.default, {
	                    show: openedModal == 'ScheduleInterventionModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                ticket._links.find((0, _links.linkFinder)('CorrectTicketInformations')) && _react2.default.createElement(_CorrectTicketInformationsModal2.default, {
	                    show: openedModal == 'CorrectTicketInformationsModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                activeEvent && ticket._links.find((0, _links.linkFinder)('CorrectTicketEventInformations')) && _react2.default.createElement(_CorrectTicketEventInformationsModal2.default, {
	                    event: activeEvent,
	                    show: openedModal == 'CorrectTicketEventInformationsModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                (wizard.matchActiveStep(1) || ticket._links.find((0, _links.linkFinder)('ReceiveCall'))) && _react2.default.createElement(_ReceiveCallModal2.default, {
	                    assignee: activeAssignee,
	                    caller: activeCaller,
	                    contactToCallback: activeContactToCallback,
	                    ticket: activeTicket || ticket,
	                    show: openedModal == 'ReceiveCallModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                ticket._links.find((0, _links.linkFinder)('EmitCallTo')) && _react2.default.createElement(_EmitCallToModal2.default, {
	                    assignee: activeAssignee,
	                    caller: activeCaller,
	                    contactToCallback: activeContactToCallback,
	                    show: openedModal == 'EmitCallToModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                ticket._links.find((0, _links.linkFinder)('FinishMission')) && _react2.default.createElement(_FinishMissionModal2.default, {
	                    show: openedModal == 'FinishMissionModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                _react2.default.createElement(_ExportTicketsModal2.default, {
	                    ticket: ticket,
	                    show: openedModal == 'ExportTicketsModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } }),
	                _react2.default.createElement(_AnswerModal2.default, {
	                    ticket: ticket,
	                    show: openedModal == 'AnswerModal',
	                    onHide: function onHide() {
	                        return _this2._closeModal();
	                    } })
	            );
	        }
	    }]);
	
	    return TicketDetail;
	}(_react.Component);
	
	TicketDetail.propTypes = {};
	
	
	TicketDetail = (0, _wizard.connectWizard)({
	    activeStep: selectActiveStep
	})(TicketDetail);
	
	TicketDetail = (0, _reactRedux.connect)(function (state) {
	    return {
	        progress: state.progress,
	        ticket: state.ticket.ticket,
	        _appLinks: state.app._links
	    };
	})(TicketDetail);
	
	exports.default = TicketDetail;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(268);
	
	var _loading = __webpack_require__(58);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketSearchBar = __webpack_require__(1529);
	
	var _TicketSearchBar2 = _interopRequireDefault(_TicketSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketLayout = function (_Component) {
	    _inherits(TicketLayout, _Component);
	
	    function TicketLayout() {
	        _classCallCheck(this, TicketLayout);
	
	        return _possibleConstructorReturn(this, (TicketLayout.__proto__ || Object.getPrototypeOf(TicketLayout)).apply(this, arguments));
	    }
	
	    _createClass(TicketLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                history = _props.history,
	                routes = _props.routes,
	                params = _props.params,
	                ticket = _props.ticket;
	
	
	            var breadcrumbDisplay = function breadcrumbDisplay(token) {
	                switch (token) {
	                    case ':id':
	                        return ticket.ref;
	                    default:
	                        return (0, _extract2.default)(_i18n2.default, token);
	                }
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Tickets' }),
	                _react2.default.createElement(_TicketSearchBar2.default, null),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        _react2.default.createElement(_router.Breadcrumb, {
	                            history: history,
	                            routes: routes,
	                            params: params,
	                            display: breadcrumbDisplay }),
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketLayout;
	}(_react.Component);
	
	TicketLayout.propTypes = {};
	
	
	TicketLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        ticket: state.ticket.ticket
	    };
	})(TicketLayout);
	
	exports.default = TicketLayout;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _browser = __webpack_require__(54);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _form = __webpack_require__(15);
	
	var _SearchBar = __webpack_require__(509);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _TypeaheadBar = __webpack_require__(511);
	
	var _TypeaheadBar2 = _interopRequireDefault(_TypeaheadBar);
	
	var _Tags = __webpack_require__(892);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _Tag = __webpack_require__(955);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DayRangePicker = __webpack_require__(889);
	
	var _DayRangePicker2 = _interopRequireDefault(_DayRangePicker);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _models = __webpack_require__(49);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketSearchBar = __webpack_require__(2336);
	
	var _TicketSearchBar2 = _interopRequireDefault(_TicketSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isActive(source, identify) {
	    return function (item) {
	        var id = identify(item);
	        return source.find(function (i) {
	            return identify(i) == id;
	        }) != null;
	    };
	}
	
	var TicketSearchBar = function (_Component) {
	    _inherits(TicketSearchBar, _Component);
	
	    function TicketSearchBar() {
	        _classCallCheck(this, TicketSearchBar);
	
	        return _possibleConstructorReturn(this, (TicketSearchBar.__proto__ || Object.getPrototypeOf(TicketSearchBar)).apply(this, arguments));
	    }
	
	    _createClass(TicketSearchBar, [{
	        key: '_search',
	        value: function _search(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                criteria = _props.criteria,
	                location = _props.location;
	
	
	            if (event) {
	                event.preventDefault();
	            }
	
	            return dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, criteria))).then(function () {
	                if (['/tickets', '/tickets/dashboard'].indexOf(location.pathname) < 0) {
	                    return dispatch((0, _reactRouterRedux.push)('/tickets'));
	                }
	            });
	        }
	    }, {
	        key: '_searchOnKeyPress',
	        value: function _searchOnKeyPress(event) {
	            if (event.key == 'Enter') {
	                var _props2 = this.props,
	                    dispatch = _props2.dispatch,
	                    criteria = _props2.criteria,
	                    location = _props2.location;
	
	
	                return dispatch((0, _actions.loadTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, criteria))).then(function () {
	                    if (['/tickets', '/tickets/dashboard'].indexOf(location.pathname) < 0) {
	                        return dispatch((0, _reactRouterRedux.push)('/tickets'));
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                criteria = _props3.criteria,
	                aggregations = _props3.aggregations;
	
	
	            var locationSource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.locations,
	                identify: function identify(l) {
	                    return l.value;
	                }
	            });
	
	            var companySource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.clientCompanies,
	                identify: function identify(c) {
	                    return c.label;
	                }
	            });
	
	            var agencySource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.agencies,
	                identify: function identify(a) {
	                    return a.label;
	                }
	            });
	
	            var patrimonySource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.patrimonies,
	                identify: function identify(p) {
	                    return p.label;
	                }
	            });
	
	            var callPurposeSource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.callPurposes,
	                identify: function identify(p) {
	                    return p.value;
	                }
	            });
	
	            var tabTitle = function tabTitle(label, icon) {
	                return _react2.default.createElement(
	                    'span',
	                    { className: _TicketSearchBar2.default.tabTitle },
	                    _react2.default.createElement(_Icon2.default, { icon: icon, size: 'sm' }),
	                    label
	                );
	            };
	
	            var displayPatrimony = function displayPatrimony(patrimony) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        patrimony.ref,
	                        ' (',
	                        patrimony.count,
	                        ')'
	                    ),
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        patrimony.label
	                    )
	                );
	            };
	
	            var footer = (0, _form.nodeHasValue)(form.status, form.intervention, form.location, form.clientCompany, form.agency, form.patrimony, form.callPurpose, form.from, form.to) && _react2.default.createElement(
	                'div',
	                { className: _TicketSearchBar2.default.footer },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _i18n2.default.searchSummary,
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        _react2.default.createElement(_Tag2.default, _extends({
	                            display: function display(d) {
	                                return (0, _moment2.default)(d).format(_i18n2.default.dateFormat.from);
	                            }
	                        }, form.from())),
	                        _react2.default.createElement(_Tag2.default, _extends({
	                            display: function display(d) {
	                                return (0, _moment2.default)(d).format(_i18n2.default.dateFormat.to);
	                            }
	                        }, form.to())),
	                        _react2.default.createElement(_Tag2.default, _extends({
	                            display: function display(s) {
	                                return (0, _extract2.default)(_i18n2.default.statusEnum, s);
	                            }
	                        }, form.status())),
	                        _react2.default.createElement(_Tag2.default, _extends({
	                            display: function display(i) {
	                                return (0, _extract2.default)(_i18n2.default.ticketsInterventionEnum, i && 'with' || 'without');
	                            }
	                        }, form.intervention()))
	                    )
	                ),
	                _react2.default.createElement(_Tags2.default, _extends({
	                    label: _i18n2.default.company + ' :',
	                    labelClassName: 'col-sm-2',
	                    wrapperClassName: 'col-sm-10',
	                    display: function display(c) {
	                        return c.label;
	                    },
	                    active: isActive(aggregations.clientCompanies, function (c) {
	                        return c.value;
	                    })
	                }, form.clientCompany())),
	                _react2.default.createElement(_Tags2.default, _extends({
	                    label: _i18n2.default.agency + ' :',
	                    labelClassName: 'col-sm-2',
	                    wrapperClassName: 'col-sm-10',
	                    display: function display(a) {
	                        return a.label;
	                    },
	                    active: isActive(aggregations.agencies, function (a) {
	                        return a.value;
	                    })
	                }, form.agency())),
	                _react2.default.createElement(_Tags2.default, _extends({
	                    label: _i18n2.default.patrimony + ' :',
	                    labelClassName: 'col-sm-2',
	                    wrapperClassName: 'col-sm-10',
	                    display: function display(p) {
	                        return p.ref;
	                    },
	                    active: isActive(aggregations.patrimonies, function (p) {
	                        return p.value;
	                    })
	                }, form.patrimony())),
	                _react2.default.createElement(_Tags2.default, _extends({
	                    label: _i18n2.default.callPurpose + ' :',
	                    labelClassName: 'col-sm-2',
	                    wrapperClassName: 'col-sm-10',
	                    display: function display(p) {
	                        return p.value;
	                    },
	                    active: isActive(aggregations.callPurposes, function (p) {
	                        return p.value;
	                    })
	                }, form.callPurpose())),
	                _react2.default.createElement(_Tags2.default, _extends({
	                    label: _i18n2.default.city + ' :',
	                    labelClassName: 'col-sm-2',
	                    wrapperClassName: 'col-sm-10',
	                    display: function display(l) {
	                        return l.value;
	                    },
	                    active: isActive(aggregations.locations, function (l) {
	                        return l.value;
	                    })
	                }, form.location()))
	            );
	
	            return _react2.default.createElement(
	                _SearchBar2.default,
	                _extends({
	                    footer: footer,
	                    placeholder: (0, _extract2.default)(_i18n2.default.searchStream, (0, _browser.mediaQuery)()),
	                    onClick: function onClick(e) {
	                        return _this2._search(e);
	                    },
	                    onKeyPress: function onKeyPress(e) {
	                        return _this2._searchOnKeyPress(e);
	                    }
	                }, form.fullText()),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _TicketSearchBar2.default.content },
	                            _react2.default.createElement(
	                                _reactBootstrap.Tabs,
	                                {
	                                    bsStyle: 'cursors',
	                                    defaultActiveKey: 1,
	                                    justified: true },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.company, 'customer'),
	                                        eventKey: 1 },
	                                    _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                                        source: companySource,
	                                        identify: function identify(a) {
	                                            return a.value;
	                                        },
	                                        display: function display(a) {
	                                            return a.label + ' (' + a.count + ')';
	                                        },
	                                        placeholder: (0, _extract2.default)(_i18n2.default.searchCompany, (0, _browser.mediaQuery)())
	                                    }, form.clientCompany()))
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.agency, 'file'),
	                                        eventKey: 2 },
	                                    _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                                        source: agencySource,
	                                        identify: function identify(a) {
	                                            return a.value;
	                                        },
	                                        display: function display(a) {
	                                            return a.label + ' (' + a.count + ')';
	                                        },
	                                        placeholder: (0, _extract2.default)(_i18n2.default.searchAgency, (0, _browser.mediaQuery)())
	                                    }, form.agency()))
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.patrimony, 'buildingz'),
	                                        eventKey: 3 },
	                                    _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                                        source: patrimonySource,
	                                        identify: function identify(p) {
	                                            return p.value;
	                                        },
	                                        display: displayPatrimony,
	                                        placeholder: (0, _extract2.default)(_i18n2.default.searchPatrimony, (0, _browser.mediaQuery)())
	                                    }, form.patrimony()))
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.date, 'calendar'),
	                                        eventKey: 4 },
	                                    _react2.default.createElement(_DayRangePicker2.default, form(['from', 'to']))
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.callPurposezz, 'phone-question'),
	                                        eventKey: 5 },
	                                    _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                                        source: callPurposeSource,
	                                        identify: function identify(p) {
	                                            return p.value;
	                                        },
	                                        display: function display(p) {
	                                            return p.value + ' (' + p.count + ')';
	                                        },
	                                        placeholder: (0, _extract2.default)(_i18n2.default.searchCallPurpose, (0, _browser.mediaQuery)())
	                                    }, form.callPurpose()))
	                                ),
	                                _react2.default.createElement(
	                                    _reactBootstrap.Tab,
	                                    {
	                                        title: tabTitle(_i18n2.default.city, 'location'),
	                                        eventKey: 6 },
	                                    _react2.default.createElement(_TypeaheadBar2.default, _extends({ split: true,
	                                        source: locationSource,
	                                        identify: function identify(l) {
	                                            return l.value;
	                                        },
	                                        display: function display(l) {
	                                            return l.value + ' (' + l.count + ')';
	                                        },
	                                        placeholder: (0, _extract2.default)(_i18n2.default.searchCity, (0, _browser.mediaQuery)())
	                                    }, form.location()))
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4 },
	                        _react2.default.createElement(
	                            'div',
	                            { className: _TicketSearchBar2.default.side },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Affinez votre recherche'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketSearchBar2.default.sideContent },
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    form.status(),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.ButtonToolbar,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                value: 'OPENED' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, { icon: 'ticket-opened', size: 'xl' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _i18n2.default.ticketsStatusEnum.opened
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                value: 'CLOSED' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, { icon: 'ticket-closed', size: 'xl' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _i18n2.default.ticketsStatusEnum.closed
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _ButtonToggle2.default,
	                                    form.intervention(),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.ButtonToolbar,
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                value: true },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, { icon: 'ticket-with-intervention', size: 'xl' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _i18n2.default.ticketsInterventionEnum.with
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                value: false },
	                                            _react2.default.createElement(
	                                                'div',
	                                                null,
	                                                _react2.default.createElement(_Icon2.default, { icon: 'ticket-without-intervention', size: 'xl' })
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                _i18n2.default.ticketsInterventionEnum.without
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketSearchBar;
	}(_react.Component);
	
	TicketSearchBar.propTypes = {};
	
	
	TicketSearchBar = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.Criteria.schema,
	    action: _actions.CRITERIA_UPDATED
	})(TicketSearchBar);
	
	TicketSearchBar = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.router.location,
	        criteria: state.ticket.criteria,
	        aggregations: state.ticket.aggregations
	    };
	})(TicketSearchBar);
	
	exports.default = TicketSearchBar;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(38);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketStreamCard = __webpack_require__(2339);
	
	var _TicketStreamCard2 = _interopRequireDefault(_TicketStreamCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketStreamCard = function (_Component) {
	    _inherits(TicketStreamCard, _Component);
	
	    function TicketStreamCard() {
	        _classCallCheck(this, TicketStreamCard);
	
	        return _possibleConstructorReturn(this, (TicketStreamCard.__proto__ || Object.getPrototypeOf(TicketStreamCard)).apply(this, arguments));
	    }
	
	    _createClass(TicketStreamCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                patrimony = _props.patrimony,
	                callPurpose = _props.callPurpose;
	
	            dispatch((0, _actions.queryMinorTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, { patrimony: patrimony.uid, callPurpose: callPurpose, status: 'OPENED' })));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.patrimony != this.props.patrimony || nextProps.callPurpose != this.props.callPurpose) {
	                var dispatch = nextProps.dispatch,
	                    patrimony = nextProps.patrimony,
	                    callPurpose = nextProps.callPurpose;
	
	
	                dispatch((0, _actions.queryMinorTicketStream)(_extends({}, _actions.DEFAULT_TICKET_QUERY, { patrimony: patrimony.uid, callPurpose: callPurpose, status: 'OPENED' })));
	            }
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, ticket) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open('/tickets/' + ticket.uid, '_blank');
	            } else {
	                dispatch((0, _reactRouterRedux.push)('/tickets/' + ticket.uid));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                stream = _props2.stream,
	                range = _props2.range,
	                patrimony = _props2.patrimony,
	                callPurpose = _props2.callPurpose,
	                onSubmit = _props2.onSubmit,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'stream', 'range', 'patrimony', 'callPurpose', 'onSubmit']);
	
	            var header = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.existingTickets
	            );
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: 'tooltip-success' },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _TicketStreamCard2.default.default },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        stream.map(function (ticket, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                {
	                                    key: index },
	                                _react2.default.createElement(
	                                    _reactBootstrap.OverlayTrigger,
	                                    {
	                                        placement: 'bottom',
	                                        overlay: tooltip(_i18n2.default.receiveCallz) },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            bsStyle: 'link',
	                                            onClick: function onClick(e) {
	                                                return onSubmit(e, 'ReceiveCall', ticket);
	                                            } },
	                                        _react2.default.createElement(_Icon2.default, { active: true, icon: 'phone', size: 'xs' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _TicketStreamCard2.default.container },
	                                    _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '',
	                                            onClick: function onClick(e) {
	                                                return _this2._navigate(e, ticket);
	                                            } },
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ticket.ref
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        ticket.openingTicketPurpose.callPurpose
	                                    ),
	                                    _react2.default.createElement(
	                                        'small',
	                                        null,
	                                        ticket.request
	                                    )
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TicketStreamCard;
	}(_react.Component);
	
	TicketStreamCard.propTypes = {
	    patrimony: _react.PropTypes.object,
	    callPurpose: _react.PropTypes.string,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	TicketStreamCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.ticket.minorStream,
	        range: state.ticket.minorRange
	    };
	})(TicketStreamCard);
	
	exports.default = TicketStreamCard;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _browser = __webpack_require__(54);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Markdown = __webpack_require__(543);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _TicketClaimCountCard = __webpack_require__(1296);
	
	var _TicketClaimCountCard2 = _interopRequireDefault(_TicketClaimCountCard);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _i18n = __webpack_require__(24);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TicketStream = __webpack_require__(900);
	
	var _TicketStream2 = _interopRequireDefault(_TicketStream);
	
	var _TicketStats = __webpack_require__(1120);
	
	var _TicketStats2 = _interopRequireDefault(_TicketStats);
	
	var _SimplifiedRequestCountCardWrap = __webpack_require__(1117);
	
	var _SimplifiedRequestCountCardWrap2 = _interopRequireDefault(_SimplifiedRequestCountCardWrap);
	
	var _OpenTicketModal = __webpack_require__(1511);
	
	var _OpenTicketModal2 = _interopRequireDefault(_OpenTicketModal);
	
	var _TicketStreamLayout = __webpack_require__(2340);
	
	var _TicketStreamLayout2 = _interopRequireDefault(_TicketStreamLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketStreamLayout = function (_Component) {
	    _inherits(TicketStreamLayout, _Component);
	
	    function TicketStreamLayout() {
	        _classCallCheck(this, TicketStreamLayout);
	
	        return _possibleConstructorReturn(this, (TicketStreamLayout.__proto__ || Object.getPrototypeOf(TicketStreamLayout)).apply(this, arguments));
	    }
	
	    _createClass(TicketStreamLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                authenticated = _props.authenticated;
	
	
	            var newTicketBoxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.newTicket
	            );
	
	            var welcomeBoxHelp = _config2.default.resource.welcome && _config2.default.resource.welcome.url && _react2.default.createElement('img', { src: _config2.default.resource.welcome.url });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smPush: 8 },
	                        _react2.default.createElement(_TicketStats2.default, { stacked: true }),
	                        (0, _browser.matchMedia)('sm') && _config2.default.resource.welcome && _config2.default.resource.welcome.text && _react2.default.createElement(
	                            _Box2.default,
	                            {
	                                help: welcomeBoxHelp },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _TicketStreamLayout2.default.welcome },
	                                _react2.default.createElement(_Markdown2.default, { markdown: _config2.default.resource.welcome.text })
	                            )
	                        ),
	                        _react2.default.createElement(_TicketClaimCountCard2.default, null),
	                        _react2.default.createElement(_SimplifiedRequestCountCardWrap2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8, smPull: 4 },
	                        _react2.default.createElement(_TicketStream2.default, null)
	                    )
	                ),
	                _react2.default.createElement(_OpenTicketModal2.default, null)
	            );
	        }
	    }]);
	
	    return TicketStreamLayout;
	}(_react.Component);
	
	TicketStreamLayout.propTypes = {};
	exports.default = TicketStreamLayout;

/***/ }),
/* 1532 */,
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(38);
	
	function ticket() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_LOADED:
	            return action.ticket;
	        case _actions.TICKET_CREATED:
	            return action.ticket;
	        default:
	            return state;
	    }
	}
	
	function stream() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_STREAM_LOADED:
	        case _actions.TICKET_STREAM_QUERIED:
	            return action.stream;
	        default:
	            return state;
	    }
	}
	
	function aggregations() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_STREAM_LOADED:
	        case _actions.TICKET_STREAM_QUERIED:
	            return action.aggregations;
	        default:
	            return state;
	    }
	}
	
	function range() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_STREAM_LOADED:
	        case _actions.TICKET_STREAM_QUERIED:
	            return action.range;
	        default:
	            return state;
	    }
	}
	
	function query() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_STREAM_LOADED:
	        case _actions.TICKET_STREAM_QUERIED:
	            return action.query;
	        default:
	            return state;
	    }
	}
	
	function stats() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_STREAM_LOADED:
	        case _actions.TICKET_STREAM_QUERIED:
	            return action.stats;
	        default:
	            return state;
	    }
	}
	
	function _links() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.TICKET_STREAM_LOADED:
	        case _actions.TICKET_STREAM_QUERIED:
	        case _actions.LINKS_LOADED:
	            return action._links;
	        default:
	            return state;
	    }
	}
	
	function criteria() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CRITERIA_UPDATED:
	            return _extends({}, state, action.criteria);
	        default:
	            return state;
	    }
	}
	
	function minorStream() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.MINOR_TICKET_STREAM_QUERIED:
	            return action.stream;
	        default:
	            return state;
	    }
	}
	
	function minorRange() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.MINOR_TICKET_STREAM_QUERIED:
	            return action.range;
	        default:
	            return state;
	    }
	}
	
	function minorQuery() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.MINOR_TICKET_STREAM_QUERIED:
	            return action.query;
	        default:
	            return state;
	    }
	}
	
	function exportXlsxTicketsOption() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.EXPORT_XLSX_TICKETS_OPTION_UPDATED:
	            return _extends({}, state, action.option);
	        default:
	            return state;
	    }
	}
	
	function exportPdfTicketsOption() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.EXPORT_PDF_TICKETS_OPTION_UPDATED:
	            return _extends({}, state, action.option);
	        default:
	            return state;
	    }
	}
	
	function reportPdfTicketsOption() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REPORT_PDF_TICKETS_OPTION_UPDATED:
	            return _extends({}, state, action.option);
	        default:
	            return state;
	    }
	}
	
	function openTicketCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.OPEN_TICKET_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.OPEN_TICKET_CMD_SENT:
	        case _actions.OPEN_TICKET_CMD_RESET:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function correctLocationReferenceCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CORRECT_LOCATION_REFERENCE_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.CORRECT_LOCATION_REFERENCE_CMD_SENT:
	        case _actions.CORRECT_LOCATION_REFERENCE_CMD_RESET:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function correctCallerCmdReducers() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CORRECT_CALLER_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        default:
	            return state;
	    }
	}
	
	function identifyAssigneeCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.IDENTIFY_ASSIGNEE_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.IDENTIFY_ASSIGNEE_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function reportSendingServiceOrderCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REPORT_SENDING_SERVICE_ORDER_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.REPORT_SENDING_SERVICE_ORDER_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function defineInterventionDeadlineCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.DEFINE_INTERVENTION_DEADLINE_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.DEFINE_INTERVENTION_DEADLINE_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function reportFormalNoticeForProviderCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function scheduleInterventionCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.SCHEDULE_INTERVENTION_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.SCHEDULE_INTERVENTION_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function startInterventionCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.START_INTERVENTION_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.START_INTERVENTION_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function finishInterventionCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.FINISH_INTERVENTION_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.FINISH_INTERVENTION_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function addMessageCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ADD_MESSAGE_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ADD_MESSAGE_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function closeTicketCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CLOSE_TICKET_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.CLOSE_TICKET_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function correctTicketInformationsCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CORRECT_TICKET_INFORMATIONS_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.CORRECT_TICKET_INFORMATIONS_CMD_SENT:
	        case _actions.CORRECT_TICKET_INFORMATIONS_CMD_RESET:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function correctTicketEventInformationsCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function receiveCallCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.RECEIVE_CALL_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.RECEIVE_CALL_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function emitCallToCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.EMIT_CALL_TO_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.EMIT_CALL_TO_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function finishMissionCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.FINISH_MISSION_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.FINISH_MISSION_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function acceptInterventionCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { otherEmails: [] };
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ACCEPT_INTERVENTION_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL:
	            var otherEmails = action.otherEmails;
	
	            return _extends({}, state, { otherEmails: otherEmails });
	        case _actions.ACCEPT_INTERVENTION_CMD_SENT:
	            return { otherEmails: [] };
	        default:
	            return state;
	    }
	}
	
	function cmdCorrectOTP() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CORRECT_OTP:
	            if (action.cmd) {
	                var _action$cmd = action.cmd,
	                    otp = _action$cmd.otp,
	                    operation = _action$cmd.operation;
	
	                switch (operation) {
	                    case 'Add':
	                        return _extends({}, state, { value: otp });
	                    case 'Remove':
	                        return _extends({}, state, { value: undefined, qualification: undefined });
	                }
	            }
	            return _extends({}, state, action.cmd);
	    }
	    return state;
	}
	
	exports.default = (0, _redux.combineReducers)({
	    ticket: ticket,
	    stream: stream,
	    aggregations: aggregations,
	    range: range,
	    query: query,
	    stats: stats,
	    _links: _links,
	    criteria: criteria,
	    minorStream: minorStream,
	    minorRange: minorRange,
	    minorQuery: minorQuery,
	    exportXlsxTicketsOption: exportXlsxTicketsOption,
	    exportPdfTicketsOption: exportPdfTicketsOption,
	    reportPdfTicketsOption: reportPdfTicketsOption,
	    openTicketCmd: openTicketCmd,
	    identifyAssigneeCmd: identifyAssigneeCmd,
	    reportSendingServiceOrderCmd: reportSendingServiceOrderCmd,
	    defineInterventionDeadlineCmd: defineInterventionDeadlineCmd,
	    reportFormalNoticeForProviderCmd: reportFormalNoticeForProviderCmd,
	    scheduleInterventionCmd: scheduleInterventionCmd,
	    startInterventionCmd: startInterventionCmd,
	    finishInterventionCmd: finishInterventionCmd,
	    addMessageCmd: addMessageCmd,
	    closeTicketCmd: closeTicketCmd,
	    correctTicketInformationsCmd: correctTicketInformationsCmd,
	    correctTicketEventInformationsCmd: correctTicketEventInformationsCmd,
	    receiveCallCmd: receiveCallCmd,
	    emitCallToCmd: emitCallToCmd,
	    finishMissionCmd: finishMissionCmd,
	    correctLocationReferenceCmd: correctLocationReferenceCmd,
	    acceptInterventionCmd: acceptInterventionCmd,
	    correctCallerCmdUpdate: correctCallerCmdReducers,
	    cmdCorrectOTP: cmdCorrectOTP
	});

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.openTicketRoute = openTicketRoute;
	
	exports.default = function (rootPath, dispatcher, _ref) {
	    var getState = _ref.getState;
	
	
	    function enterTicketStream(dispatch) {
	        var state = getState();
	        var criteria = state.ticket.criteria;
	        var authenticated = state.user.authenticated;
	
	
	        return Promise.all([dispatch((0, _actions2.loadTicketStream)(_extends({}, _actions2.DEFAULT_TICKET_QUERY, criteria))),
	        // dashboard
	        authenticated.company && dispatch((0, _actions.loadActiveCampaign)(authenticated.company.uid))]);
	    }
	
	    return {
	        path: rootPath,
	        component: _TicketLayout2.default,
	        onEnter: dispatcher(enterTicketStream),
	        indexRoute: {
	            component: _TicketStreamLayout2.default
	        },
	        childRoutes: [{
	            path: 'dashboard',
	            component: _TicketDashboardLayout2.default
	        }, {
	            path: 'new',
	            component: _TicketDetail2.default,
	            onEnter: dispatcher(function (d) {
	                return d((0, _actions2.createTicket)());
	            })
	        }, {
	            path: ':id',
	            component: _TicketDetail2.default,
	            onEnter: dispatcher(_actions2.enterTicket)
	        }, {
	            path: ':id/documents',
	            component: _ShowDocumentsPage2.default,
	            onEnter: dispatcher(_actions2.enterTicket)
	        }]
	    };
	};
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _ui = __webpack_require__(512);
	
	var _actions = __webpack_require__(146);
	
	var _actions2 = __webpack_require__(38);
	
	var _TicketLayout = __webpack_require__(1528);
	
	var _TicketLayout2 = _interopRequireDefault(_TicketLayout);
	
	var _TicketStreamLayout = __webpack_require__(1531);
	
	var _TicketStreamLayout2 = _interopRequireDefault(_TicketStreamLayout);
	
	var _TicketDashboardLayout = __webpack_require__(1526);
	
	var _TicketDashboardLayout2 = _interopRequireDefault(_TicketDashboardLayout);
	
	var _TicketDetail = __webpack_require__(1527);
	
	var _TicketDetail2 = _interopRequireDefault(_TicketDetail);
	
	var _ShowDocumentsPage = __webpack_require__(1116);
	
	var _ShowDocumentsPage2 = _interopRequireDefault(_ShowDocumentsPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enterOpenTicket(dispatch) {
	    dispatch((0, _ui.setUIState)('Ticket/OpenTicketModal', { opened: true }));
	    return dispatch((0, _reactRouterRedux.replace)('/tickets'));
	}
	
	function openTicketRoute(rootPath, dispatcher) {
	    return {
	        path: rootPath,
	        indexRoute: {
	            onEnter: dispatcher(enterOpenTicket)
	        }
	    };
	}

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(153);
	
	function authenticatedConfigsUpdated() {
	    var configs;
	
	    return function (state, dispatch) {
	        var nextConfigs = state.user.authenticatedConfigs;
	
	        if (nextConfigs != configs) {
	            if (configs && (nextConfigs.ticketOpenedNotifications != configs.ticketOpenedNotifications || nextConfigs.daybookNotifications != configs.daybookNotifications || nextConfigs.simplifiedRequestOpenedNotifications != configs.simplifiedRequestOpenedNotifications)) {
	                var previousConfigs = configs;
	
	                dispatch((0, _actions.sendAuthenticatedUserConfigs)()).catch(function () {
	                    configs = previousConfigs;
	                    dispatch((0, _actions.resetAuthenticatedUserConfigs)(previousConfigs));
	                });
	            }
	            configs = nextConfigs;
	        }
	    };
	}
	
	exports.default = [authenticatedConfigsUpdated()];

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _UpdateUserCard = __webpack_require__(1545);
	
	var _UpdateUserCard2 = _interopRequireDefault(_UpdateUserCard);
	
	var _ResetLoginDemandCard = __webpack_require__(1540);
	
	var _ResetLoginDemandCard2 = _interopRequireDefault(_ResetLoginDemandCard);
	
	var _ResetPasswordDemandCard = __webpack_require__(1543);
	
	var _ResetPasswordDemandCard2 = _interopRequireDefault(_ResetPasswordDemandCard);
	
	var _UserConfigsCard = __webpack_require__(1546);
	
	var _UserConfigsCard2 = _interopRequireDefault(_UserConfigsCard);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountDetail = function (_Component) {
	    _inherits(AccountDetail, _Component);
	
	    function AccountDetail() {
	        _classCallCheck(this, AccountDetail);
	
	        return _possibleConstructorReturn(this, (AccountDetail.__proto__ || Object.getPrototypeOf(AccountDetail)).apply(this, arguments));
	    }
	
	    _createClass(AccountDetail, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        _react2.default.createElement(
	                            _reactBootstrap.PageHeader,
	                            { className: 'large' },
	                            _i18n2.default.manageAccount
	                        ),
	                        _react2.default.createElement(_UpdateUserCard2.default, null),
	                        _react2.default.createElement(_ResetLoginDemandCard2.default, null),
	                        _react2.default.createElement(_ResetPasswordDemandCard2.default, null),
	                        _react2.default.createElement(_UserConfigsCard2.default, null)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AccountDetail;
	}(_react.Component);
	
	AccountDetail.propTypes = {};
	exports.default = AccountDetail;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _loading = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountLayout = function (_Component) {
	    _inherits(AccountLayout, _Component);
	
	    function AccountLayout() {
	        _classCallCheck(this, AccountLayout);
	
	        return _possibleConstructorReturn(this, (AccountLayout.__proto__ || Object.getPrototypeOf(AccountLayout)).apply(this, arguments));
	    }
	
	    _createClass(AccountLayout, [{
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Account' }),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: /Sent$/ },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AccountLayout;
	}(_react.Component);
	
	AccountLayout.propTypes = {};
	exports.default = AccountLayout;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(153);
	
	var _models = __webpack_require__(515);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActiveUserBox = function (_Component) {
	    _inherits(ActiveUserBox, _Component);
	
	    function ActiveUserBox() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ActiveUserBox);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActiveUserBox.__proto__ || Object.getPrototypeOf(ActiveUserBox)).call.apply(_ref, [this].concat(args))), _this), _this._reset = function (event) {
	            var dispatch = _this.props.dispatch;
	
	
	            event.preventDefault();
	
	            dispatch((0, _actions.sendActiveUserCmd)()).then(function () {
	                window.location = new URLSearchParams(window.location.search).get('redirecturl');
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ActiveUserBox, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form;
	
	
	            var title = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.activeUser
	            );
	
	            var help = _react2.default.createElement(_Icon2.default, { icon: 'key', size: 'xl' });
	
	            return _react2.default.createElement(
	                _Box2.default,
	                {
	                    status: 'info',
	                    header: title,
	                    help: help },
	                _react2.default.createElement(
	                    'form',
	                    {
	                        onSubmit: function onSubmit(e) {
	                            return _this2._reset(e);
	                        } },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({ hasFeedback: true,
	                        type: 'password',
	                        name: 'password',
	                        label: _i18n2.default.password
	                    }, form.password())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({ hasFeedback: true,
	                        type: 'password',
	                        name: 'password',
	                        label: _i18n2.default.confirmPassword
	                    }, form.confirmPassword())),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { block: true,
	                            type: 'submit',
	                            bsSize: 'large',
	                            disabled: !form.isValid() },
	                        _i18n2.default.send
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ActiveUserBox;
	}(_react.Component);
	
	ActiveUserBox.propTypes = {};
	
	
	ActiveUserBox = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ActiveUserCmd.schema,
	    validator: (0, _models.createValidator)(),
	    action: _actions.ACTIVE_USER_CMD_UPDATED
	})(ActiveUserBox);
	
	ActiveUserBox = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.user.activeUserCmd
	    };
	})(ActiveUserBox);
	
	exports.default = ActiveUserBox;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _form = __webpack_require__(15);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Autocomplete = __webpack_require__(1351);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _actions = __webpack_require__(153);
	
	var _models = __webpack_require__(515);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginBox = function (_Component) {
	    _inherits(LoginBox, _Component);
	
	    function LoginBox() {
	        _classCallCheck(this, LoginBox);
	
	        return _possibleConstructorReturn(this, (LoginBox.__proto__ || Object.getPrototypeOf(LoginBox)).apply(this, arguments));
	    }
	
	    _createClass(LoginBox, [{
	        key: '_login',
	        value: function _login(event) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.login)()).then(function () {
	                return dispatch((0, _router.goBack)());
	            });
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)('/forgotpassword'));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form;
	
	
	            var boxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.signin
	            );
	
	            var boxHelp = _react2.default.createElement(_Icon2.default, { icon: 'key', size: 'xl' });
	
	            var passwordInputHelp = _react2.default.createElement(
	                'a',
	                {
	                    href: '',
	                    onClick: function onClick(e) {
	                        return _this2._navigate(e);
	                    }
	                },
	                _i18n2.default.forgotPassword
	            );
	
	            return _react2.default.createElement(
	                _Box2.default,
	                {
	                    status: 'info',
	                    header: boxTitle,
	                    help: boxHelp },
	                _react2.default.createElement(
	                    _Autocomplete2.default,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        {
	                            onSubmit: function onSubmit(e) {
	                                return _this2._login(e);
	                            } },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({ hasFeedback: true,
	                            type: 'text',
	                            name: 'email',
	                            label: _i18n2.default.email
	                        }, form.login())),
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({ hasFeedback: true,
	                            type: 'password',
	                            name: 'password',
	                            label: _i18n2.default.password,
	                            help: passwordInputHelp
	                        }, (0, _Autocomplete.autocompletePasswordInputField)(form.password()))),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { block: true,
	                                type: 'submit',
	                                bsSize: 'large',
	                                disabled: !form.isValid() },
	                            _i18n2.default.signin
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginBox;
	}(_react.Component);
	
	LoginBox.propTypes = {};
	
	
	LoginBox = (0, _form.connectForm)({
	    target: 'credential',
	    schema: _models.Credential.schema,
	    action: _actions.CREDENTIAL_UPDATED
	})(LoginBox);
	
	LoginBox = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        credential: state.user.credential
	    };
	})(LoginBox);
	
	exports.default = LoginBox;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(153);
	
	var _models = __webpack_require__(515);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetLoginDemandCard = function (_Component) {
	    _inherits(ResetLoginDemandCard, _Component);
	
	    function ResetLoginDemandCard() {
	        _classCallCheck(this, ResetLoginDemandCard);
	
	        return _possibleConstructorReturn(this, (ResetLoginDemandCard.__proto__ || Object.getPrototypeOf(ResetLoginDemandCard)).apply(this, arguments));
	    }
	
	    _createClass(ResetLoginDemandCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                authenticated = _props.authenticated;
	
	
	            dispatch((0, _actions.updateResetLoginDemand)({
	                oldLogin: authenticated.login,
	                newLogin: authenticated.login
	            }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.authenticated != this.props.authenticated) {
	                var dispatch = nextProps.dispatch,
	                    authenticated = nextProps.authenticated;
	
	
	                dispatch((0, _actions.updateResetLoginDemand)({
	                    oldLogin: authenticated.login,
	                    newLogin: authenticated.login
	                }));
	            }
	        }
	    }, {
	        key: '_sendDemand',
	        value: function _sendDemand() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                authenticated = _props2.authenticated;
	
	
	            return dispatch((0, _actions.sendResetLoginDemand)()).then(function () {
	                return dispatch((0, _actions.updateResetLoginDemand)({
	                    oldLogin: authenticated.login,
	                    newLogin: authenticated.login
	                }));
	            }).then(function () {
	                return dispatch((0, _status.infoStatus)(_i18n2.default.resetLoginEmailSent));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                demand = _props3.demand,
	                authenticated = _props3.authenticated,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'demand', 'authenticated']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.changeLogin
	            );
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'login',
	                        label: requiredLabel(_i18n2.default.login)
	                    }, form.newLogin()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendDemand() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.resetLogin
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResetLoginDemandCard;
	}(_react.Component);
	
	ResetLoginDemandCard.propTypes = {};
	
	
	ResetLoginDemandCard = (0, _form.connectForm)({
	    target: 'demand',
	    schema: _models.ResetLoginDemand.schema,
	    action: _actions.RESET_LOGIN_DEMAND_UPDATED
	})(ResetLoginDemandCard);
	
	ResetLoginDemandCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        demand: state.user.resetLoginDemand
	    };
	})(ResetLoginDemandCard);
	
	exports.default = ResetLoginDemandCard;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _router = __webpack_require__(123);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(153);
	
	var _models = __webpack_require__(515);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPasswordBox = function (_Component) {
	    _inherits(ResetPasswordBox, _Component);
	
	    function ResetPasswordBox() {
	        _classCallCheck(this, ResetPasswordBox);
	
	        return _possibleConstructorReturn(this, (ResetPasswordBox.__proto__ || Object.getPrototypeOf(ResetPasswordBox)).apply(this, arguments));
	    }
	
	    _createClass(ResetPasswordBox, [{
	        key: '_reset',
	        value: function _reset(event) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendResetPasswordCmd)()).then(function () {
	                return dispatch((0, _reactRouterRedux.push)('/login'));
	            }).then(function () {
	                return dispatch((0, _router.clearHistory)());
	            }).then(function () {
	                return dispatch((0, _status.infoStatus)(_i18n2.default.passwordResetted));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form;
	
	
	            var title = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.resetPassword
	            );
	
	            var help = _react2.default.createElement(_Icon2.default, { icon: 'key', size: 'xl' });
	
	            return _react2.default.createElement(
	                _Box2.default,
	                {
	                    status: 'info',
	                    header: title,
	                    help: help },
	                _react2.default.createElement(
	                    'form',
	                    {
	                        onSubmit: function onSubmit(e) {
	                            return _this2._reset(e);
	                        } },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({ hasFeedback: true,
	                        type: 'password',
	                        name: 'password',
	                        label: _i18n2.default.password
	                    }, form.password())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({ hasFeedback: true,
	                        type: 'password',
	                        name: 'password',
	                        label: _i18n2.default.confirmPassword
	                    }, form.confirmPassword())),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { block: true,
	                            type: 'submit',
	                            bsSize: 'large',
	                            disabled: !form.isValid() },
	                        _i18n2.default.send
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResetPasswordBox;
	}(_react.Component);
	
	ResetPasswordBox.propTypes = {};
	
	
	ResetPasswordBox = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.ResetPasswordCmd.schema,
	    validator: (0, _models.createValidator)(),
	    action: _actions.RESET_PASSWORD_CMD_UPDATED
	})(ResetPasswordBox);
	
	ResetPasswordBox = (0, _reactRedux.connect)(function (state) {
	    return {
	        cmd: state.user.resetPasswordCmd
	    };
	})(ResetPasswordBox);
	
	exports.default = ResetPasswordBox;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _status = __webpack_require__(13);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(153);
	
	var _models = __webpack_require__(515);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPasswordDemandBox = function (_Component) {
	    _inherits(ResetPasswordDemandBox, _Component);
	
	    function ResetPasswordDemandBox() {
	        _classCallCheck(this, ResetPasswordDemandBox);
	
	        return _possibleConstructorReturn(this, (ResetPasswordDemandBox.__proto__ || Object.getPrototypeOf(ResetPasswordDemandBox)).apply(this, arguments));
	    }
	
	    _createClass(ResetPasswordDemandBox, [{
	        key: '_forget',
	        value: function _forget(event) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _actions.sendResetPasswordDemand)()).then(function () {
	                return dispatch((0, _status.infoStatus)(_i18n2.default.resetPasswordEmailSent));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form;
	
	
	            var title = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.forgotPassword
	            );
	
	            var help = _react2.default.createElement(_Icon2.default, { icon: 'key', size: 'xl' });
	
	            return _react2.default.createElement(
	                _Box2.default,
	                {
	                    status: 'info',
	                    header: title,
	                    help: help },
	                _react2.default.createElement(
	                    'form',
	                    {
	                        onSubmit: function onSubmit(e) {
	                            return _this2._forget(e);
	                        } },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({ hasFeedback: true,
	                        type: 'text',
	                        name: 'email',
	                        label: _i18n2.default.email
	                    }, form.email())),
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        { block: true,
	                            type: 'submit',
	                            bsSize: 'large',
	                            disabled: !form.isValid() },
	                        _i18n2.default.send
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResetPasswordDemandBox;
	}(_react.Component);
	
	ResetPasswordDemandBox.propTypes = {};
	
	
	ResetPasswordDemandBox = (0, _form.connectForm)({
	    target: 'demand',
	    schema: _models.ResetPasswordDemand.schema,
	    action: _actions.RESET_PASSWORD_DEMAND_UPDATED
	})(ResetPasswordDemandBox);
	
	ResetPasswordDemandBox = (0, _reactRedux.connect)(function (state) {
	    return {
	        demand: state.user.resetPasswordDemand
	    };
	})(ResetPasswordDemandBox);
	
	exports.default = ResetPasswordDemandBox;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _status = __webpack_require__(13);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(153);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPasswordDemandCard = function (_Component) {
	    _inherits(ResetPasswordDemandCard, _Component);
	
	    function ResetPasswordDemandCard() {
	        _classCallCheck(this, ResetPasswordDemandCard);
	
	        return _possibleConstructorReturn(this, (ResetPasswordDemandCard.__proto__ || Object.getPrototypeOf(ResetPasswordDemandCard)).apply(this, arguments));
	    }
	
	    _createClass(ResetPasswordDemandCard, [{
	        key: '_sendCmd',
	        value: function _sendCmd(event) {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                authenticated = _props.authenticated;
	
	
	            return dispatch((0, _actions.sendResetPasswordDemand)({ email: authenticated.login })).then(function () {
	                return dispatch((0, _status.infoStatus)(_i18n2.default.resetPasswordEmailSent));
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                authenticated = _props2.authenticated,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'authenticated']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.changePassword
	            );
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            onClick: function onClick(e) {
	                                return _this2._sendCmd(e);
	                            } },
	                        _i18n2.default.resetPassword
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResetPasswordDemandCard;
	}(_react.Component);
	
	ResetPasswordDemandCard.propTypes = {};
	
	
	ResetPasswordDemandCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated
	    };
	})(ResetPasswordDemandCard);
	
	exports.default = ResetPasswordDemandCard;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _loading = __webpack_require__(58);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UnauthUserLayout = __webpack_require__(2342);
	
	var _UnauthUserLayout2 = _interopRequireDefault(_UnauthUserLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnauthUserLayout = function (_Component) {
	    _inherits(UnauthUserLayout, _Component);
	
	    function UnauthUserLayout() {
	        _classCallCheck(this, UnauthUserLayout);
	
	        return _possibleConstructorReturn(this, (UnauthUserLayout.__proto__ || Object.getPrototypeOf(UnauthUserLayout)).apply(this, arguments));
	    }
	
	    _createClass(UnauthUserLayout, [{
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: _UnauthUserLayout2.default.default },
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { sm: 6, smOffset: 3 },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _i18n2.default.welcome
	                                ),
	                                children
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UnauthUserLayout;
	}(_react.Component);
	
	UnauthUserLayout.propTypes = {};
	exports.default = UnauthUserLayout;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(153);
	
	var _models = __webpack_require__(515);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function userCmdUpdate(user) {
	    return {
	        firstName: user.firstName || null,
	        lastName: user.lastName || null,
	        job: user.job || null,
	        phone: user.phone || null
	    };
	}
	
	var UpdateUserCard = function (_Component) {
	    _inherits(UpdateUserCard, _Component);
	
	    function UpdateUserCard() {
	        _classCallCheck(this, UpdateUserCard);
	
	        return _possibleConstructorReturn(this, (UpdateUserCard.__proto__ || Object.getPrototypeOf(UpdateUserCard)).apply(this, arguments));
	    }
	
	    _createClass(UpdateUserCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                authenticated = _props.authenticated;
	
	            var update = userCmdUpdate(authenticated);
	
	            dispatch((0, _actions.updateUpdateUserCmd)(update));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.authenticated != this.props.authenticated) {
	                var dispatch = nextProps.dispatch,
	                    authenticated = nextProps.authenticated;
	
	                var update = userCmdUpdate(authenticated);
	
	                dispatch((0, _actions.updateUpdateUserCmd)(update));
	            }
	        }
	    }, {
	        key: '_sendCmd',
	        value: function _sendCmd() {
	            var dispatch = this.props.dispatch;
	
	
	            return dispatch((0, _actions.sendUpdateUserCmd)()).then(function () {
	                return dispatch((0, _actions.loadAuthenticatedUser)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                form = _props2.form,
	                cmd = _props2.cmd,
	                authenticated = _props2.authenticated,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'form', 'cmd', 'authenticated']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.updateUser
	            );
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    'form',
	                    { className: 'form-horizontal' },
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'firstName',
	                        label: requiredLabel(_i18n2.default.firstName)
	                    }, form.firstName())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'lastName',
	                        label: requiredLabel(_i18n2.default.lastName)
	                    }, form.lastName())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'job',
	                        label: _i18n2.default.job
	                    }, form.job())),
	                    _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        labelClassName: 'col-sm-3',
	                        wrapperClassName: 'col-sm-9',
	                        type: 'text',
	                        name: 'phone',
	                        label: _i18n2.default.phone
	                    }, form.phone()))
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _LoaderButton2.default,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                            onClick: function onClick() {
	                                return form.validate() && _this2._sendCmd() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                            } },
	                        _i18n2.default.save
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateUserCard;
	}(_react.Component);
	
	UpdateUserCard.propTypes = {};
	
	
	UpdateUserCard = (0, _form.connectForm)({
	    target: 'cmd',
	    schema: _models.UpdateUserCmd.schema,
	    action: _actions.UPDATE_USER_CMD_UPDATED
	})(UpdateUserCard);
	
	UpdateUserCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        cmd: state.user.updateUserCmd
	    };
	})(UpdateUserCard);
	
	exports.default = UpdateUserCard;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _loading = __webpack_require__(58);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(153);
	
	var _models = __webpack_require__(515);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserConfigsCard = function (_Component) {
	    _inherits(UserConfigsCard, _Component);
	
	    function UserConfigsCard() {
	        _classCallCheck(this, UserConfigsCard);
	
	        return _possibleConstructorReturn(this, (UserConfigsCard.__proto__ || Object.getPrototypeOf(UserConfigsCard)).apply(this, arguments));
	    }
	
	    _createClass(UserConfigsCard, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                authenticatedConfigs = _props.authenticatedConfigs,
	                loading = _props.loading,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'authenticatedConfigs', 'loading']);
	
	            var header = _react2.default.createElement(
	                'h5',
	                null,
	                _i18n2.default.userConfigs
	            );
	
	            return _react2.default.createElement(
	                _Card2.default,
	                _extends({
	                    header: header
	                }, others),
	                _react2.default.createElement(
	                    _loading.LoaderForm,
	                    {
	                        loading: loading,
	                        action: _actions.AUTHENTICATED_USER_CONFIGS_SENT },
	                    authenticatedConfigs.ticketOpenedNotifications !== undefined && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'checkbox',
	                        name: 'ticketOpenedNotifications',
	                        label: _i18n2.default.ticketOpenedNotifications
	                    }, (0, _form.checkboxField)(form.ticketOpenedNotifications()))),
	                    authenticatedConfigs.daybookNotifications !== undefined && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'checkbox',
	                        name: 'daybookNotifications',
	                        label: _i18n2.default.daybookNotifications
	                    }, (0, _form.checkboxField)(form.daybookNotifications()))),
	                    authenticatedConfigs.simplifiedRequestOpenedNotifications !== undefined && _react2.default.createElement(_reactBootstrap.Input, _extends({
	                        type: 'checkbox',
	                        name: 'simplifiedRequestOpenedNotifications',
	                        label: _i18n2.default.simplifiedRequestOpenedNotifications
	                    }, (0, _form.checkboxField)(form.simplifiedRequestOpenedNotifications())))
	                )
	            );
	        }
	    }]);
	
	    return UserConfigsCard;
	}(_react.Component);
	
	UserConfigsCard.propTypes = {};
	
	
	UserConfigsCard = (0, _form.connectForm)({
	    alias: 'userConfigs',
	    target: 'authenticatedConfigs',
	    schema: _models.UserConfigs.schema,
	    action: _actions.AUTHENTICATED_USER_CONFIGS_UPDATED
	})(UserConfigsCard);
	
	UserConfigsCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.loading,
	        authenticatedConfigs: state.user.authenticatedConfigs
	    };
	})(UserConfigsCard);
	
	exports.default = UserConfigsCard;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TodoStatusIcon = __webpack_require__(1557);
	
	var _TodoStatusIcon2 = _interopRequireDefault(_TodoStatusIcon);
	
	var _actions = __webpack_require__(153);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UserNavItem = __webpack_require__(2343);
	
	var _UserNavItem2 = _interopRequireDefault(_UserNavItem);
	
	var _AdditionalContextButton = __webpack_require__(1269);
	
	var _AdditionalContextButton2 = _interopRequireDefault(_AdditionalContextButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserNavItem = function (_Component) {
	    _inherits(UserNavItem, _Component);
	
	    function UserNavItem() {
	        _classCallCheck(this, UserNavItem);
	
	        return _possibleConstructorReturn(this, (UserNavItem.__proto__ || Object.getPrototypeOf(UserNavItem)).apply(this, arguments));
	    }
	
	    _createClass(UserNavItem, [{
	        key: '_logout',
	        value: function _logout(event) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            dispatch((0, _actions.logout)()).then(function () {
	                // reload to discard app state
	                window.location = '/login';
	            });
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	            dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user;
	
	
	            var tooltip = function tooltip(text, style) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: style && 'tooltip-' + style },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _UserNavItem2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _UserNavItem2.default.side },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: _UserNavItem2.default.user,
	                            href: '',
	                            onClick: function onClick(e) {
	                                return _this2._navigate(e, '/todolist');
	                            } },
	                        _react2.default.createElement(_TodoStatusIcon2.default, {
	                            user: user,
	                            icon: 'user',
	                            size: 'md' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.manageAccount) },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, '/account');
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'cog', size: 'xs' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.signout, 'danger') },
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._logout(e);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'sign-out', size: 'xs' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _UserNavItem2.default.container },
	                    _react2.default.createElement(
	                        'p',
	                        { className: _UserNavItem2.default.name },
	                        user.firstName,
	                        ' ',
	                        user.lastName
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: _UserNavItem2.default.job },
	                        user.job
	                    ),
	                    _react2.default.createElement(_AdditionalContextButton2.default, null)
	                )
	            );
	        }
	    }]);
	
	    return UserNavItem;
	}(_react.Component);
	
	UserNavItem.propTypes = {
	    user: _react.PropTypes.object.isRequired
	};
	
	
	UserNavItem = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.user.authenticated
	    };
	})(UserNavItem);
	
	exports.default = UserNavItem;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.unauthorized = unauthorized;
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _locationz = __webpack_require__(894);
	
	function unauthorized(loginPath) {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	        return function (next) {
	            return function (action) {
	                if (_typeof(action.error) == 'object' && action.error.statusCode == 401) {
	                    // go to login page
	                    var state = getState();
	                    var location = state.router.location;
	
	
	                    var history = [{
	                        pathname: location.pathname,
	                        search: location.search
	                    }];
	
	                    // reload to discard app state
	                    // keep current location to go back after login
	                    var encodedState = btoa(JSON.stringify({ router: { history: history } }));
	                    window.location = (0, _locationz.appUrl)(loginPath, { state: encodedState });
	
	                    dispatch((0, _reactRouterRedux.push)(loginPath));
	                    return next(action);
	                }
	                return next(action);
	            };
	        };
	    };
	}

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(153);
	
	function authenticated() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.AUTHENTICATED_USER_LOADED:
	            return action.user;
	        case _actions.AUTHENTICATED_USER_DISCARDED:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function authenticatedConfigs() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.AUTHENTICATED_USER_CONFIGS_LOADED:
	        case _actions.AUTHENTICATED_USER_CONFIGS_RESET:
	            return action.userConfigs;
	        case _actions.AUTHENTICATED_USER_CONFIGS_UPDATED:
	            return _extends({}, state, action.userConfigs);
	        default:
	            return state;
	    }
	}
	
	function credential() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CREDENTIAL_UPDATED:
	            return _extends({}, state, action.credential);
	        case _actions.LOGGED_IN:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function activeUserCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ACTIVE_USER_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.ACTIVE_USER_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function resetPasswordDemand() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.RESET_PASSWORD_DEMAND_UPDATED:
	            return _extends({}, state, action.demand);
	        case _actions.RESET_PASSWORD_DEMAND_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function resetPasswordCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.RESET_PASSWORD_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.RESET_PASSWORD_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateUserCmd() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_USER_CMD_UPDATED:
	            return _extends({}, state, action.cmd);
	        case _actions.UPDATE_USER_CMD_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function resetLoginDemand() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.RESET_LOGIN_DEMAND_UPDATED:
	            return _extends({}, state, action.demand);
	        case _actions.RESET_LOGIN_DEMAND_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	exports.default = (0, _redux.combineReducers)({
	    authenticated: authenticated,
	    authenticatedConfigs: authenticatedConfigs,
	    credential: credential,
	    activeUserCmd: activeUserCmd,
	    resetPasswordDemand: resetPasswordDemand,
	    resetPasswordCmd: resetPasswordCmd,
	    updateUserCmd: updateUserCmd,
	    resetLoginDemand: resetLoginDemand
	});

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loginRoute = loginRoute;
	exports.activeUserRoute = activeUserRoute;
	exports.forgotPasswordRoute = forgotPasswordRoute;
	exports.resetPasswordRoute = resetPasswordRoute;
	exports.resetLoginRoute = resetLoginRoute;
	exports.accountRoute = accountRoute;
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _router = __webpack_require__(123);
	
	var _status = __webpack_require__(13);
	
	var _actions = __webpack_require__(153);
	
	var _i18n = __webpack_require__(192);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _UnauthUserLayout = __webpack_require__(1544);
	
	var _UnauthUserLayout2 = _interopRequireDefault(_UnauthUserLayout);
	
	var _AccountLayout = __webpack_require__(1537);
	
	var _AccountLayout2 = _interopRequireDefault(_AccountLayout);
	
	var _AccountDetail = __webpack_require__(1536);
	
	var _AccountDetail2 = _interopRequireDefault(_AccountDetail);
	
	var _LoginBox = __webpack_require__(1539);
	
	var _LoginBox2 = _interopRequireDefault(_LoginBox);
	
	var _ActiveUserBox = __webpack_require__(1538);
	
	var _ActiveUserBox2 = _interopRequireDefault(_ActiveUserBox);
	
	var _ResetPasswordDemandBox = __webpack_require__(1542);
	
	var _ResetPasswordDemandBox2 = _interopRequireDefault(_ResetPasswordDemandBox);
	
	var _ResetPasswordBox = __webpack_require__(1541);
	
	var _ResetPasswordBox2 = _interopRequireDefault(_ResetPasswordBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function enterResetLogin(dispatch, params, query) {
	    return dispatch((0, _actions.sendResetLoginCmd)({ verificationCode: params.code, userId: params.uid, login: query.login })).then(function () {
	        return dispatch((0, _reactRouterRedux.replace)('/login'));
	    }).then(function () {
	        return dispatch((0, _router.clearHistory)());
	    }).then(function () {
	        return dispatch((0, _status.infoStatus)(_i18n2.default.loginResetted));
	    });
	}
	
	function loginRoute(rootPath, dispatcher) {
	    return {
	        path: rootPath,
	        component: _UnauthUserLayout2.default,
	        indexRoute: {
	            component: _LoginBox2.default
	        }
	    };
	}
	
	function activeUserRoute(rootPath, dispatcher) {
	    return {
	        path: rootPath + '/:code/:uid',
	        component: _UnauthUserLayout2.default,
	        indexRoute: {
	            component: _ActiveUserBox2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions.updateActiveUserCmd)({ activationCode: p.code, userId: p.uid }));
	            })
	        }
	    };
	}
	
	function forgotPasswordRoute(rootPath, dispatcher) {
	    return {
	        path: rootPath,
	        component: _UnauthUserLayout2.default,
	        indexRoute: {
	            component: _ResetPasswordDemandBox2.default
	        }
	    };
	}
	
	function resetPasswordRoute(rootPath, dispatcher) {
	    return {
	        path: rootPath + '/:code/:uid',
	        component: _UnauthUserLayout2.default,
	        indexRoute: {
	            component: _ResetPasswordBox2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions.updateResetPasswordCmd)({ verificationCode: p.code, userId: p.uid }));
	            })
	        }
	    };
	}
	
	function resetLoginRoute(rootPath, dispatcher) {
	    return {
	        path: rootPath + '/:code/:uid',
	        indexRoute: {
	            onEnter: dispatcher(enterResetLogin)
	        }
	    };
	}
	
	function accountRoute(rootPath, dispatcher) {
	    return {
	        path: rootPath,
	        component: _AccountLayout2.default,
	        indexRoute: {
	            component: _AccountDetail2.default,
	            onEnter: dispatcher(function (d, p) {
	                return d((0, _actions.loadAuthenticatedUserConfigs)());
	            })
	        }
	    };
	}

/***/ }),
/* 1551 */,
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__(193);
	
	var criteria; // shared across actors
	
	function todoCriteriaUpdated() {
	
	    return function (state, dispatch) {
	        var nextCriteria = state.workflow.todo.criteria;
	
	        if (nextCriteria != criteria) {
	            dispatch((0, _actions.loadTodoStream)(_extends({}, _actions.DEFAULT_TODO_QUERY, nextCriteria)));
	
	            criteria = nextCriteria;
	        }
	    };
	}
	
	function authenticatedUpdated() {
	    var authenticated;
	
	    function getActorCriteria(user) {
	        if (user) {
	            switch (user.userType) {
	                case 'patrimonyManager':
	                case 'executive':
	                case 'callCenterOperator':
	                    return [{ value: user.userType.charAt(0).toUpperCase() + user.userType.slice(1) }];
	                default:
	                    return null;
	            }
	        }
	    }
	
	    return function (state, dispatch) {
	        var nextAuthenticated = state.user.authenticated;
	
	        if (nextAuthenticated != authenticated) {
	            var nextCriteria = { actor: getActorCriteria(nextAuthenticated) };
	            dispatch((0, _actions.resetTodoCriteria)(nextCriteria));
	
	            criteria = nextCriteria;
	            authenticated = nextAuthenticated;
	        }
	    };
	}
	
	exports.default = [todoCriteriaUpdated(), authenticatedUpdated()];

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _actions = __webpack_require__(193);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _NextStepCard = __webpack_require__(2344);
	
	var _NextStepCard2 = _interopRequireDefault(_NextStepCard);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _nodeUuid = __webpack_require__(195);
	
	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);
	
	var _fetchz = __webpack_require__(86);
	
	var _config = __webpack_require__(29);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions2 = __webpack_require__(38);
	
	var _status = __webpack_require__(13);
	
	var _actions3 = __webpack_require__(46);
	
	var _links2 = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function durationStatus(duration) {
	    if (duration && duration > 12 * 3600 * 1000) return 'success';
	    if (duration && duration > 0) return 'warning';
	    if (duration) return 'danger';
	    return 'success';
	}
	
	var NextStepCard = function (_Component) {
	    _inherits(NextStepCard, _Component);
	
	    function NextStepCard(props) {
	        _classCallCheck(this, NextStepCard);
	
	        var _this = _possibleConstructorReturn(this, (NextStepCard.__proto__ || Object.getPrototypeOf(NextStepCard)).call(this, props));
	
	        _this.fetchWorkflows = function (clientCompanyId) {
	            var dispatch = _this.props.dispatch;
	
	            fetch(_config2.default.api.url + '/clientcompanies/' + clientCompanyId, (0, _fetchz.apiOption)()).then(_fetchz.apiResponse).then(function (_ref) {
	                var json = _ref.json;
	                var _links = json._links;
	
	                if (_links && _links.find((0, _links2.linkFinder)('workflows'))) {
	                    dispatch((0, _actions.loadWorkflowStream)(clientCompanyId));
	                }
	            });
	        };
	
	        _this.toggleUpdateWorkflow = function () {
	            _this.setState({ updateWorkflow: !_this.state.updateWorkflow });
	        };
	
	        _this.updateWorkflow = function (e) {
	            var _this$props = _this.props,
	                ticket = _this$props.ticket,
	                dispatch = _this$props.dispatch;
	            var uid = ticket.uid;
	
	
	            var options = {
	                method: 'PATCH',
	                body: {
	                    processUid: _nodeUuid2.default.v4(),
	                    commandType: 'ApplyWorkflowToTicket',
	                    workflowUid: e.target.value
	                }
	            };
	
	            fetch((0, _fetchz.apiUrl)(_config2.default.api.event.url + '/tickets/' + uid), (0, _fetchz.apiOption)(options)).then(_fetchz.apiResponse).then(function () {
	                _this.setState({ updateWorkflow: !_this.state.updateWorkflow });
	                return (0, _actions2.enterTicket)(dispatch, { id: uid });
	            }).catch(function (e) {
	                dispatch((0, _status.errorStatus)(e.message));
	            });
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(NextStepCard, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                ticket = _props.ticket;
	
	            dispatch((0, _actions.queryNextStep)(ticket.uid));
	            this.fetchWorkflows(ticket.linkedEntities.clientCompany.uid);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.ticket != this.props.ticket) {
	                var dispatch = nextProps.dispatch,
	                    ticket = nextProps.ticket;
	
	                dispatch((0, _actions.queryNextStep)(ticket.uid));
	                dispatch((0, _actions.loadWorkflowStream)(ticket.linkedEntities.clientCompany.uid));
	            }
	
	            if (nextProps.nextStep != this.props.nextStep) {
	                var nextStep = nextProps.nextStep;
	
	
	                clearInterval(this._interval);
	                if (nextStep && nextStep.expectedDate) {
	                    this._computeExpectedDuration(nextStep.expectedDate);
	                    this._interval = setInterval(function () {
	                        return _this2._computeExpectedDuration(nextStep.expectedDate);
	                    }, 60 * 1000);
	                } else {
	                    this.setState({ expectedDuration: undefined });
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this._interval);
	        }
	    }, {
	        key: '_computeExpectedDuration',
	        value: function _computeExpectedDuration(expectedDate) {
	            var expectedDuration = new Date(expectedDate) - new Date();
	            this.setState({ expectedDuration: expectedDuration });
	        }
	    }, {
	        key: '_showWorkflow',
	        value: function _showWorkflow() {
	            var _props2 = this.props,
	                ticket = _props2.ticket,
	                workflows = _props2.workflows;
	            var updateWorkflow = this.state.updateWorkflow;
	            var qualification = ticket.qualification;
	
	            var _ref2 = qualification || {},
	                workflowApplied = _ref2.workflowApplied;
	
	            var matchedWorkflow = workflowApplied && workflows && workflows.length > 0 && workflows.find(function (w) {
	                return w.uid === workflowApplied;
	            });
	            return _react2.default.createElement(
	                'div',
	                { className: _NextStepCard2.default.workflow },
	                matchedWorkflow && _react2.default.createElement(
	                    'span',
	                    { title: matchedWorkflow.label },
	                    matchedWorkflow.label
	                ) || _react2.default.createElement(
	                    'span',
	                    { title: "Forcer un workflow" },
	                    'Forcer un workflow'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        bsStyle: 'link',
	                        onClick: this.toggleUpdateWorkflow,
	                        title: 'Forcer le workflow',
	                        alt: 'Forcer le workflow' },
	                    _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                ),
	                updateWorkflow && _react2.default.createElement(
	                    'select',
	                    { onChange: this.updateWorkflow, defaultValue: workflowApplied },
	                    workflowApplied || _react2.default.createElement(
	                        'option',
	                        null,
	                        'choisir un workflow'
	                    ),
	                    workflows.map(function (w) {
	                        return _react2.default.createElement(
	                            'option',
	                            { key: w.uid, value: w.uid },
	                            w.label
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                authenticated = _props3.authenticated,
	                nextStep = _props3.nextStep,
	                ticket = _props3.ticket,
	                workflows = _props3.workflows,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'authenticated', 'nextStep', 'ticket', 'workflows']);
	
	            var expectedDuration = this.state.expectedDuration;
	
	
	            return workflows && workflows.length > 0 && _react2.default.createElement(
	                _Card2.default,
	                _extends({ active: true,
	                    status: durationStatus(expectedDuration),
	                    header: _react2.default.createElement(
	                        'h3',
	                        null,
	                        _i18n2.default.nextStep
	                    )
	                }, others),
	                _react2.default.createElement(
	                    'div',
	                    { className: _NextStepCard2.default.default },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _NextStepCard2.default.container },
	                        expectedDuration && _react2.default.createElement(
	                            'p',
	                            { className: _NextStepCard2.default.expectedDuration },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _moment2.default.duration(expectedDuration).humanize()
	                            ),
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                expectedDuration < 0 && _i18n2.default.overdue
	                            )
	                        ),
	                        nextStep && _react2.default.createElement(
	                            'p',
	                            { className: _NextStepCard2.default.expectedCommand },
	                            (0, _extract2.default)(_i18n2.default.expectedCommandEnum, nextStep.expectedCommand)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: _NextStepCard2.default.actors },
	                        nextStep && nextStep.actors.map(function (actor, index) {
	                            return _react2.default.createElement(
	                                'span',
	                                {
	                                    key: index,
	                                    className: (0, _classnames2.default)(_defineProperty({}, _NextStepCard2.default.highlight, actor.toUpperCase() == authenticated.userType.toUpperCase())) },
	                                (0, _extract2.default)(_i18n2.default.actorEnum, actor)
	                            );
	                        })
	                    ),
	                    this._showWorkflow()
	                )
	            ) || null;
	        }
	    }]);
	
	    return NextStepCard;
	}(_react.Component);
	
	NextStepCard.propTypes = {
	    ticket: _react.PropTypes.object.isRequired
	};
	
	
	NextStepCard = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        nextStep: state.workflow.nextStep,
	        workflows: state.workflow.stream
	    };
	})(NextStepCard);
	
	exports.default = NextStepCard;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)))

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _actions = __webpack_require__(193);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _RemoveWorkflowModal = __webpack_require__(2345);
	
	var _RemoveWorkflowModal2 = _interopRequireDefault(_RemoveWorkflowModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RemoveWorkflowModal = function (_Component) {
	    _inherits(RemoveWorkflowModal, _Component);
	
	    function RemoveWorkflowModal() {
	        _classCallCheck(this, RemoveWorkflowModal);
	
	        return _possibleConstructorReturn(this, (RemoveWorkflowModal.__proto__ || Object.getPrototypeOf(RemoveWorkflowModal)).apply(this, arguments));
	    }
	
	    _createClass(RemoveWorkflowModal, [{
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                workflow = _props.workflow,
	                onHide = _props.onHide;
	
	
	            return dispatch((0, _actions.sendRemoveWorkflowAction)(workflow.uid)).then(function () {
	                return dispatch((0, _actions.loadWorkflowStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                workflow = _props2.workflow,
	                onHide = _props2.onHide,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'workflow', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    className: 'modal-danger',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.remove
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: _RemoveWorkflowModal2.default.text },
	                        _i18n2.default.removeWorkflowText.map(function (text, index) {
	                            return _react2.default.createElement(
	                                'p',
	                                { key: index },
	                                (0, _extract.replace)(text, workflow)
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'danger',
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return _this2._sendAction();
	                                } },
	                            _i18n2.default.remove
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RemoveWorkflowModal;
	}(_react.Component);
	
	RemoveWorkflowModal.propTypes = {
	    workflow: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	RemoveWorkflowModal = (0, _reactRedux.connect)()(RemoveWorkflowModal);
	
	exports.default = RemoveWorkflowModal;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _loading = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TodoLayout = function (_Component) {
	    _inherits(TodoLayout, _Component);
	
	    function TodoLayout() {
	        _classCallCheck(this, TodoLayout);
	
	        return _possibleConstructorReturn(this, (TodoLayout.__proto__ || Object.getPrototypeOf(TodoLayout)).apply(this, arguments));
	    }
	
	    _createClass(TodoLayout, [{
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_reactHelmet2.default, { title: 'Todo list' }),
	                _react2.default.createElement(
	                    _reactBootstrap.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _loading.Loader,
	                        {
	                            exclude: [/Sent$/, /Queried$/] },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TodoLayout;
	}(_react.Component);
	
	TodoLayout.propTypes = {};
	exports.default = TodoLayout;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _form = __webpack_require__(15);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Chart = __webpack_require__(275);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _TypeaheadBar = __webpack_require__(511);
	
	var _TypeaheadBar2 = _interopRequireDefault(_TypeaheadBar);
	
	var _ButtonToggle = __webpack_require__(91);
	
	var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);
	
	var _models = __webpack_require__(550);
	
	var _actions = __webpack_require__(193);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TodoSearch = __webpack_require__(2346);
	
	var _TodoSearch2 = _interopRequireDefault(_TodoSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function expectedDateStatusStyle(status) {
	    switch (status.value) {
	        case 'Todo':
	            return 'success';
	        case 'TodoWithin12Hours':
	            return 'warning';
	        case 'Timeout':
	            return 'danger';
	    }
	}
	
	function expectedDateStatusReducer(result, status) {
	    if (result.length == 0) {
	        result = [{ value: 'Todo', count: 0 }, { value: 'TodoWithin12Hours', count: 0 }, { value: 'Timeout', count: 0 }];
	    }
	
	    var resultStatus = result.find(function (s) {
	        return s.value == status.value;
	    });
	
	    if (resultStatus) {
	        resultStatus.count = status.count;
	    }
	    return result;
	}
	
	var TodoSearch = function (_Component) {
	    _inherits(TodoSearch, _Component);
	
	    function TodoSearch(props) {
	        _classCallCheck(this, TodoSearch);
	
	        var _this = _possibleConstructorReturn(this, (TodoSearch.__proto__ || Object.getPrototypeOf(TodoSearch)).call(this, props));
	
	        _this.state = {
	            expectedDateStatus: []
	        };
	        return _this;
	    }
	
	    _createClass(TodoSearch, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var aggregations = this.props.aggregations;
	
	
	            var expectedDateStatus = aggregations.expectedDateStatus.reduce(expectedDateStatusReducer, []);
	            this.setState({ expectedDateStatus: expectedDateStatus });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.aggregations != this.props.aggregations) {
	                var aggregations = nextProps.aggregations;
	
	
	                var expectedDateStatus = aggregations.expectedDateStatus.reduce(expectedDateStatusReducer, []);
	                this.setState({ expectedDateStatus: expectedDateStatus });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                form = _props.form,
	                criteria = _props.criteria,
	                range = _props.range,
	                aggregations = _props.aggregations,
	                others = _objectWithoutProperties(_props, ['dispatch', 'form', 'criteria', 'range', 'aggregations']);
	
	            var expectedDateStatus = this.state.expectedDateStatus;
	
	
	            var agencySource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.agencies,
	                identify: function identify(a) {
	                    return a.label;
	                }
	            });
	
	            var clientCompanySource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.clientCompanies,
	                identify: function identify(c) {
	                    return c.label;
	                }
	            });
	
	            var expectedCommandSource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.expectedCommands,
	                identify: function identify(c) {
	                    return (0, _extract2.default)(_i18n2.default.expectedCommandEnum, c.value);
	                }
	            });
	
	            var actorSource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.actors,
	                identify: function identify(c) {
	                    return (0, _extract2.default)(_i18n2.default.actorEnum, c.value);
	                }
	            });
	
	            var operatorSource = (0, _TypeaheadBar.matcher)({
	                source: aggregations.operators,
	                identify: function identify(c) {
	                    return c.label;
	                }
	            });
	
	            var panelHeader = function panelHeader(text) {
	                return _react2.default.createElement(
	                    'h5',
	                    null,
	                    text
	                );
	            };
	
	            var expectedDateField = function expectedDateField(field) {
	                var value;
	
	                if (field.value && field.value.expectedDateStart && field.value.expectedDateEnd) {
	                    value = 'TodoWithin12Hours';
	                } else if (field.value && field.value.expectedDateStart) {
	                    value = 'Todo';
	                } else if (field.value && field.value.expectedDateEnd) {
	                    value = 'Timeout';
	                } else {
	                    value = null;
	                }
	
	                function onChange(value) {
	                    var start;
	                    var end;
	
	                    switch (value) {
	                        case 'TodoWithin12Hours':
	                            start = new Date();
	                            end = new Date(start.getTime());
	                            end.setHours(end.getHours() + 12);
	
	                            field.onChange({ expectedDateStart: start.toISOString(), expectedDateEnd: end.toISOString() });
	                            break;
	                        case 'Todo':
	                            start = new Date();
	                            start.setHours(start.getHours() + 12);
	
	                            field.onChange({ expectedDateStart: start.toISOString(), expectedDateEnd: null });
	                            break;
	                        case 'Timeout':
	                            end = new Date();
	
	                            field.onChange({ expectedDateStart: null, expectedDateEnd: end.toISOString() });
	                            break;
	                        default:
	                            field.onChange({ expectedDateStart: null, expectedDateEnd: null });
	                            break;
	                    }
	                }
	
	                return _extends({}, field, { value: value, onChange: onChange });
	            };
	
	            var expectedDateStatusChartTotal = (0, _Chart.totalAngle)({
	                source: expectedDateStatus,
	                angle: 220,
	                identify: function identify(s) {
	                    return s.count;
	                }
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TodoSearch2.default.default },
	                _react2.default.createElement(
	                    'div',
	                    { className: _TodoSearch2.default.expectedDateStatus },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _i18n2.default.expectedDateStatus
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(_Chart2.default, { donut: true, brand: true,
	                                kind: 'Pie',
	                                ratio: 'square',
	                                donutWidth: 60,
	                                startAngle: 250,
	                                total: expectedDateStatusChartTotal,
	                                display: function display(m) {
	                                    return m.count;
	                                },
	                                identify: function identify(m) {
	                                    return m.count;
	                                },
	                                value: expectedDateStatus }),
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                range.count,
	                                ' ',
	                                _i18n2.default.todos
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                _ButtonToggle2.default,
	                                expectedDateField(form(['expectedDateStart', 'expectedDateEnd'])),
	                                expectedDateStatus.map(function (status, index) {
	                                    return status.count > 0 && _react2.default.createElement(
	                                        _reactBootstrap.Button,
	                                        { block: true,
	                                            key: index,
	                                            bsStyle: expectedDateStatusStyle(status),
	                                            value: status.value },
	                                        (0, _extract2.default)(_i18n2.default.expectedDateStatusEnum, status.value)
	                                    );
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.PanelGroup,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { collapsible: true,
	                            eventKey: 1,
	                            header: panelHeader(_i18n2.default.searchCompany) },
	                        _react2.default.createElement(_TypeaheadBar2.default, _extends({
	                            size: 'small',
	                            source: clientCompanySource,
	                            identify: function identify(c) {
	                                return c.value;
	                            },
	                            display: function display(c) {
	                                return c.label + ' (' + c.count + ')';
	                            },
	                            placeholder: _i18n2.default.search
	                        }, form.clientCompany()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { collapsible: true,
	                            eventKey: 2,
	                            header: panelHeader(_i18n2.default.searchAgency) },
	                        _react2.default.createElement(_TypeaheadBar2.default, _extends({
	                            size: 'small',
	                            source: agencySource,
	                            identify: function identify(a) {
	                                return a.value;
	                            },
	                            display: function display(a) {
	                                return a.label + ' (' + a.count + ')';
	                            },
	                            placeholder: _i18n2.default.search
	                        }, form.agency()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { collapsible: true, defaultExpanded: true,
	                            eventKey: 3,
	                            header: panelHeader(_i18n2.default.searchActor) },
	                        _react2.default.createElement(_TypeaheadBar2.default, _extends({
	                            size: 'small',
	                            source: actorSource,
	                            identify: function identify(c) {
	                                return c.value;
	                            },
	                            display: function display(c) {
	                                return (0, _extract2.default)(_i18n2.default.actorEnum, c.value) + ' (' + c.count + ')';
	                            },
	                            placeholder: _i18n2.default.search
	                        }, form.actor()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { collapsible: true,
	                            eventKey: 4,
	                            header: panelHeader(_i18n2.default.searchOperator) },
	                        _react2.default.createElement(_TypeaheadBar2.default, _extends({
	                            size: 'small',
	                            source: operatorSource,
	                            identify: function identify(c) {
	                                return c.value;
	                            },
	                            display: function display(c) {
	                                return c.label + ' (' + c.count + ')';
	                            },
	                            placeholder: _i18n2.default.search
	                        }, form.operator()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Panel,
	                        { collapsible: true,
	                            eventKey: 5,
	                            header: panelHeader(_i18n2.default.searchExpectedCommand) },
	                        _react2.default.createElement(_TypeaheadBar2.default, _extends({
	                            size: 'small',
	                            source: expectedCommandSource,
	                            identify: function identify(c) {
	                                return c.value;
	                            },
	                            display: function display(c) {
	                                return (0, _extract2.default)(_i18n2.default.expectedCommandEnum, c.value) + ' (' + c.count + ')';
	                            },
	                            placeholder: _i18n2.default.search
	                        }, form.expectedCommand()))
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TodoSearch;
	}(_react.Component);
	
	TodoSearch.propTypes = {};
	
	
	TodoSearch = (0, _form.connectForm)({
	    target: 'criteria',
	    schema: _models.TodoCriteria.schema,
	    action: _actions.TODO_CRITERIA_UPDATED
	})(TodoSearch);
	
	TodoSearch = (0, _reactRedux.connect)(function (state) {
	    return {
	        criteria: state.workflow.todo.criteria,
	        range: state.workflow.todo.range,
	        aggregations: state.workflow.todo.aggregations
	    };
	})(TodoSearch);
	
	exports.default = TodoSearch;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _actions = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_ORDER = ['Timeout', 'TodoWithin12Hours', 'Todo'];
	
	function statusStyle(status) {
	    if (status) {
	        switch (status.value) {
	            case 'Todo':
	                return 'success';
	            case 'TodoWithin12Hours':
	                return 'warning';
	            case 'Timeout':
	                return 'danger';
	        }
	    }
	}
	
	function getActor(user) {
	    switch (user.userType) {
	        case 'patrimonyManager':
	        case 'executive':
	        case 'callCenterOperator':
	            return user.userType.charAt(0).toUpperCase() + user.userType.slice(1);
	        default:
	            return null;
	    }
	}
	
	var TodoStatusIcon = function (_Component) {
	    _inherits(TodoStatusIcon, _Component);
	
	    function TodoStatusIcon(props) {
	        _classCallCheck(this, TodoStatusIcon);
	
	        var _this = _possibleConstructorReturn(this, (TodoStatusIcon.__proto__ || Object.getPrototypeOf(TodoStatusIcon)).call(this, props));
	
	        _this.state = {
	            exactStatus: {}
	        };
	        return _this;
	    }
	
	    _createClass(TodoStatusIcon, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                user = _props.user;
	
	            var actor = getActor(user);
	
	            if (actor) {
	                dispatch((0, _actions.queryTodoStatus)(actor));
	                this._interval = setInterval(function () {
	                    dispatch((0, _actions.queryTodoStatus)(actor));
	                }, 60 * 1000);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.status != this.props.status) {
	                var status = nextProps.status;
	
	
	                var exactStatus = status.sort(function (a, b) {
	                    return STATUS_ORDER.indexOf(a.value) - STATUS_ORDER.indexOf(b.value);
	                })[0];
	                this.setState({ exactStatus: exactStatus });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this._interval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                status = _props2.status,
	                others = _objectWithoutProperties(_props2, ['dispatch', 'status']);
	
	            var exactStatus = this.state.exactStatus;
	
	
	            return _react2.default.createElement(_Icon2.default, _extends({
	                count: exactStatus && exactStatus.count,
	                status: statusStyle(exactStatus)
	            }, others));
	        }
	    }]);
	
	    return TodoStatusIcon;
	}(_react.Component);
	
	TodoStatusIcon.propTypes = {
	    user: _react.PropTypes.object.isRequired
	};
	
	
	TodoStatusIcon = (0, _reactRedux.connect)(function (state) {
	    return {
	        status: state.workflow.todo.status
	    };
	})(TodoStatusIcon);
	
	exports.default = TodoStatusIcon;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links = __webpack_require__(33);
	
	var _browser = __webpack_require__(54);
	
	var _actions = __webpack_require__(193);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TodoStrip = __webpack_require__(1560);
	
	var _TodoStrip2 = _interopRequireDefault(_TodoStrip);
	
	var _TodoStream = __webpack_require__(2347);
	
	var _TodoStream2 = _interopRequireDefault(_TodoStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 20;
	
	var TodoStream = function (_Component) {
	    _inherits(TodoStream, _Component);
	
	    function TodoStream() {
	        _classCallCheck(this, TodoStream);
	
	        return _possibleConstructorReturn(this, (TodoStream.__proto__ || Object.getPrototypeOf(TodoStream)).apply(this, arguments));
	    }
	
	    _createClass(TodoStream, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dispatch = this.props.dispatch;
	
	
	            this._interval = setInterval(function () {
	                dispatch((0, _actions.loadTodoStream)());
	            }, 30 * 1000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this._interval);
	        }
	    }, {
	        key: '_paginate',
	        value: function _paginate(selectedEvent) {
	            var dispatch = this.props.dispatch;
	
	
	            var pageActive = selectedEvent.eventKey;
	            var offset = (pageActive - 1) * PAGE_SIZE;
	            var limit = offset + PAGE_SIZE - 1;
	
	            dispatch((0, _actions.loadTodoStream)({ range: { offset: offset, limit: limit } }));
	        }
	    }, {
	        key: '_navigate',
	        value: function _navigate(event, path) {
	            var dispatch = this.props.dispatch;
	
	
	            event.preventDefault();
	
	            if (event.ctrlKey || event.metaKey) {
	                window.open(path, '_blank');
	            } else {
	                dispatch((0, _reactRouterRedux.push)(path));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                authenticated = _props.authenticated,
	                stream = _props.stream,
	                range = _props.range,
	                company = _props.company;
	
	
	            var pageCount = Math.ceil(range.count / PAGE_SIZE);
	            var pageActive = Math.floor(range.offset / PAGE_SIZE) + 1;
	
	            var youHaveNoTodo = function youHaveNoTodo() {
	                if (company && company._links.find((0, _links.linkFinder)('workflows'))) {
	                    return _i18n2.default.youHaveNoTodoClickText.map(function (text, index) {
	                        if (index == 1) return _react2.default.createElement(
	                            'a',
	                            {
	                                key: index,
	                                href: '',
	                                onClick: function onClick(e) {
	                                    return _this2._navigate(e, '/organisations/' + company.uid + '/workflows');
	                                } },
	                            text
	                        );
	                        return _react2.default.createElement(
	                            'span',
	                            { key: index },
	                            text
	                        );
	                    });
	                }
	                return _i18n2.default.youHaveNoTodo;
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                stream.map(function (todo, index) {
	                    return _react2.default.createElement(_TodoStrip2.default, {
	                        key: index,
	                        todo: todo,
	                        authenticated: authenticated,
	                        onClick: function onClick(e) {
	                            return _this2._navigate(e, '/tickets/' + todo.ticket.uid);
	                        } });
	                }),
	                stream.length == 0 && _react2.default.createElement(
	                    'p',
	                    { className: _TodoStream2.default.noTodo },
	                    youHaveNoTodo()
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _TodoStream2.default.pagination },
	                    _react2.default.createElement(_reactBootstrap.Pagination, {
	                        items: pageCount,
	                        maxButtons: (0, _browser.matchMedia)('sm') && 5 || 4,
	                        activePage: pageActive,
	                        onSelect: function onSelect(e, se) {
	                            return _this2._paginate(se);
	                        },
	                        prev: true, next: true, first: true, last: true, ellipsis: true })
	                )
	            );
	        }
	    }]);
	
	    return TodoStream;
	}(_react.Component);
	
	TodoStream.propTypes = {
	    stream: _react.PropTypes.array.isRequired,
	    range: _react.PropTypes.object.isRequired
	};
	
	
	TodoStream = (0, _reactRedux.connect)(function (state) {
	    return {
	        authenticated: state.user.authenticated,
	        stream: state.workflow.todo.stream,
	        range: state.workflow.todo.range,
	        company: state.company.company
	    };
	})(TodoStream);
	
	exports.default = TodoStream;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactRouterRedux = __webpack_require__(31);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _links2 = __webpack_require__(33);
	
	var _Box = __webpack_require__(185);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TodoStream = __webpack_require__(1558);
	
	var _TodoStream2 = _interopRequireDefault(_TodoStream);
	
	var _TodoSearch = __webpack_require__(1556);
	
	var _TodoSearch2 = _interopRequireDefault(_TodoSearch);
	
	var _SimplifiedRequestCountCardWrap = __webpack_require__(1117);
	
	var _SimplifiedRequestCountCardWrap2 = _interopRequireDefault(_SimplifiedRequestCountCardWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TodoStreamLayout = function (_Component) {
	    _inherits(TodoStreamLayout, _Component);
	
	    function TodoStreamLayout() {
	        _classCallCheck(this, TodoStreamLayout);
	
	        return _possibleConstructorReturn(this, (TodoStreamLayout.__proto__ || Object.getPrototypeOf(TodoStreamLayout)).apply(this, arguments));
	    }
	
	    _createClass(TodoStreamLayout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                _links = _props._links;
	
	
	            var newTicketBoxTitle = _react2.default.createElement(
	                'h3',
	                null,
	                _i18n2.default.newTicket
	            );
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8 },
	                        _react2.default.createElement(
	                            _reactBootstrap.PageHeader,
	                            { className: 'large' },
	                            _i18n2.default.todolist
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 4, smPush: 8 },
	                        _react2.default.createElement(_TodoSearch2.default, null),
	                        _react2.default.createElement(_SimplifiedRequestCountCardWrap2.default, null),
	                        _links.find((0, _links2.linkFinder)('OpenTicket')) && _react2.default.createElement(_Box2.default, {
	                            status: 'primary',
	                            header: newTicketBoxTitle,
	                            help: '+',
	                            onClick: function onClick() {
	                                return dispatch((0, _reactRouterRedux.push)('/tickets/new'));
	                            } })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { sm: 8, smPull: 4 },
	                        _react2.default.createElement(_TodoStream2.default, null)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TodoStreamLayout;
	}(_react.Component);
	
	TodoStreamLayout.propTypes = {};
	
	
	TodoStreamLayout = (0, _reactRedux.connect)(function (state) {
	    return {
	        _links: state.ticket._links
	    };
	})(TodoStreamLayout);
	
	exports.default = TodoStreamLayout;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _Strip = __webpack_require__(1354);
	
	var _Strip2 = _interopRequireDefault(_Strip);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _TodoStrip = __webpack_require__(2348);
	
	var _TodoStrip2 = _interopRequireDefault(_TodoStrip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function durationStatus(duration) {
	    if (duration && duration > 12 * 3600 * 1000) return 'success';
	    if (duration && duration > 0) return 'warning';
	    if (duration) return 'danger';
	    return 'success';
	}
	
	var TodoStrip = function (_Component) {
	    _inherits(TodoStrip, _Component);
	
	    function TodoStrip() {
	        _classCallCheck(this, TodoStrip);
	
	        return _possibleConstructorReturn(this, (TodoStrip.__proto__ || Object.getPrototypeOf(TodoStrip)).apply(this, arguments));
	    }
	
	    _createClass(TodoStrip, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                todo = _props.todo,
	                authenticated = _props.authenticated,
	                others = _objectWithoutProperties(_props, ['todo', 'authenticated']);
	
	            var expectedDuration = todo.expectedDate && new Date(todo.expectedDate) - new Date();
	
	            var tooltip = function tooltip(text, status) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    { className: status && 'tooltip-' + status },
	                    text
	                );
	            };
	
	            var status = durationStatus(expectedDuration);
	
	            var header = _react2.default.createElement(
	                'h5',
	                { className: _TodoStrip2.default.header },
	                _react2.default.createElement(
	                    'div',
	                    { className: _TodoStrip2.default.side },
	                    'ticket ',
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        'n\xB0 ',
	                        todo.ticket.ref || todo.ticket.uid
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _TodoStrip2.default.container },
	                    todo.clientCompany.label
	                )
	            );
	
	            var help = todo.operators.find(function (o) {
	                return o.uid == authenticated.uid;
	            }) && _react2.default.createElement(
	                _reactBootstrap.OverlayTrigger,
	                {
	                    placement: 'bottom',
	                    overlay: tooltip(_i18n2.default.youAreOperator, status) },
	                _react2.default.createElement(_Icon2.default, { active: true, icon: 'user', size: 'sm' })
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: _TodoStrip2.default.default },
	                _react2.default.createElement(
	                    _Strip2.default,
	                    _extends({
	                        header: header,
	                        help: help,
	                        status: status
	                    }, others),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _TodoStrip2.default.body },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            todo.ticket.openingTicketPurpose.callPurpose
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            (0, _extract2.default)(_i18n2.default.expectedCommandEnum, todo.expectedCommand)
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: _TodoStrip2.default.expectedDuration },
	                            !!expectedDuration && _react2.default.createElement(
	                                'span',
	                                null,
	                                _moment2.default.duration(expectedDuration).humanize()
	                            ),
	                            expectedDuration < 0 && _react2.default.createElement(
	                                'small',
	                                null,
	                                ' (',
	                                _i18n2.default.overdue,
	                                ')'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TodoStrip;
	}(_react.Component);
	
	TodoStrip.propTypes = {
	    todo: _react.PropTypes.object.isRequired,
	    authenticated: _react.PropTypes.object.isRequired
	};
	exports.default = TodoStrip;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _OpeningTicketPurposePicker = __webpack_require__(897);
	
	var _OpeningTicketPurposePicker2 = _interopRequireDefault(_OpeningTicketPurposePicker);
	
	var _models = __webpack_require__(550);
	
	var _actions = __webpack_require__(193);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function openingTicketPurposeAggregator(reference) {
	    return function (result, openingTicketPurposeId) {
	        var openingTicketPurpose = reference.openingTicketPurposes.find(function (otp) {
	            return otp.uid == openingTicketPurposeId;
	        });
	
	        if (openingTicketPurpose) {
	            result.push(openingTicketPurpose);
	        } else {
	            console && console.warn('openingTicketPurpose "' + openingTicketPurposeId + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	var UpdateIdentifiedRequestsModal = function (_Component) {
	    _inherits(UpdateIdentifiedRequestsModal, _Component);
	
	    function UpdateIdentifiedRequestsModal() {
	        _classCallCheck(this, UpdateIdentifiedRequestsModal);
	
	        return _possibleConstructorReturn(this, (UpdateIdentifiedRequestsModal.__proto__ || Object.getPrototypeOf(UpdateIdentifiedRequestsModal)).apply(this, arguments));
	    }
	
	    _createClass(UpdateIdentifiedRequestsModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                workflow = _props.workflow,
	                reference = _props.reference;
	
	
	            var identifiedRequests = workflow.identifiedRequests.reduce(openingTicketPurposeAggregator(reference), []);
	            dispatch((0, _actions.updateUpdateIdentifiedRequestsAction)({ identifiedRequests: identifiedRequests }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.workflow != this.props.workflow) {
	                var dispatch = nextProps.dispatch,
	                    workflow = nextProps.workflow,
	                    reference = nextProps.reference;
	
	
	                var identifiedRequests = workflow.identifiedRequests.reduce(openingTicketPurposeAggregator(reference), []);
	                dispatch((0, _actions.updateUpdateIdentifiedRequestsAction)({ identifiedRequests: identifiedRequests }));
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                workflow = _props2.workflow,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdateIdentifiedRequestsAction)(workflow.uid)).then(function () {
	                return dispatch((0, _actions.loadWorkflowStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                company = _props3.company,
	                workflow = _props3.workflow,
	                reference = _props3.reference,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'company', 'workflow', 'reference', 'onHide']);
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    bsSize: 'large',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.identifiedRequests
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(_OpeningTicketPurposePicker2.default, _extends({ multi: true, split: true,
	                        company: company
	                    }, form.identifiedRequests())),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateIdentifiedRequestsModal;
	}(_react.Component);
	
	UpdateIdentifiedRequestsModal.propTypes = {
	    workflow: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateIdentifiedRequestsModal = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.UpdateIdentifiedRequestsAction.schema,
	    action: _actions.UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED
	})(UpdateIdentifiedRequestsModal);
	
	UpdateIdentifiedRequestsModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        reference: state.reference.openingTicketPurposeRef,
	        company: state.company.company,
	        action: state.workflow.updateIdentifiedRequestsAction
	    };
	})(UpdateIdentifiedRequestsModal);
	
	exports.default = UpdateIdentifiedRequestsModal;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _LoaderButton = __webpack_require__(21);
	
	var _LoaderButton2 = _interopRequireDefault(_LoaderButton);
	
	var _models = __webpack_require__(550);
	
	var _actions = __webpack_require__(193);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateWorkflowLabelModal = function (_Component) {
	    _inherits(UpdateWorkflowLabelModal, _Component);
	
	    function UpdateWorkflowLabelModal() {
	        _classCallCheck(this, UpdateWorkflowLabelModal);
	
	        return _possibleConstructorReturn(this, (UpdateWorkflowLabelModal.__proto__ || Object.getPrototypeOf(UpdateWorkflowLabelModal)).apply(this, arguments));
	    }
	
	    _createClass(UpdateWorkflowLabelModal, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                workflow = _props.workflow;
	
	            dispatch((0, _actions.updateWorkflowLabelAction)({ label: workflow.label }));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.workflow != this.props.workflow) {
	                var dispatch = nextProps.dispatch,
	                    workflow = nextProps.workflow;
	
	                dispatch((0, _actions.updateWorkflowLabelAction)({ label: workflow.label }));
	            }
	        }
	    }, {
	        key: '_sendAction',
	        value: function _sendAction() {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                workflow = _props2.workflow,
	                onHide = _props2.onHide;
	
	
	            return dispatch((0, _actions.sendUpdateWorkflowLabelAction)(workflow.uid)).then(function () {
	                return dispatch((0, _actions.loadWorkflowStream)());
	            }).then(function () {
	                onHide();
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                form = _props3.form,
	                action = _props3.action,
	                workflow = _props3.workflow,
	                onHide = _props3.onHide,
	                others = _objectWithoutProperties(_props3, ['dispatch', 'form', 'action', 'workflow', 'onHide']);
	
	            var requiredLabel = function requiredLabel(label) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    label,
	                    ' ',
	                    _react2.default.createElement(
	                        'i',
	                        null,
	                        '*'
	                    )
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Modal,
	                _extends({
	                    bsSize: 'large',
	                    onHide: onHide
	                }, others),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        _i18n2.default.updateWorkflowLabel
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            labelClassName: 'col-sm-3',
	                            wrapperClassName: 'col-sm-9',
	                            type: 'text',
	                            name: 'label',
	                            label: requiredLabel(_i18n2.default.label)
	                        }, form.label()))
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _LoaderButton2.default,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !form.isValid() }),
	                                onClick: function onClick() {
	                                    return form.validate() && _this2._sendAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.save
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: onHide },
	                            _i18n2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateWorkflowLabelModal;
	}(_react.Component);
	
	UpdateWorkflowLabelModal.propTypes = {
	    workflow: _react.PropTypes.object.isRequired,
	    onHide: _react.PropTypes.func.isRequired
	};
	
	
	UpdateWorkflowLabelModal = (0, _form.connectForm)({
	    target: 'action',
	    schema: _models.UpdateWorkflowLabelAction.schema,
	    action: _actions.UPDATE_WORKFLOW_LABEL_ACTION_UPDATED
	})(UpdateWorkflowLabelModal);
	
	UpdateWorkflowLabelModal = (0, _reactRedux.connect)(function (state) {
	    return {
	        action: state.workflow.updateWorkflowLabelAction
	    };
	})(UpdateWorkflowLabelModal);
	
	exports.default = UpdateWorkflowLabelModal;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _wizard = __webpack_require__(513);
	
	var _status = __webpack_require__(13);
	
	var _form = __webpack_require__(15);
	
	var _Icon = __webpack_require__(17);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MeasureInput = __webpack_require__(953);
	
	var _MeasureInput2 = _interopRequireDefault(_MeasureInput);
	
	var _actions = __webpack_require__(193);
	
	var _models = __webpack_require__(550);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _WorkflowPanel = __webpack_require__(2349);
	
	var _WorkflowPanel2 = _interopRequireDefault(_WorkflowPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapCount(fnc, count) {
	    var result = [];
	    for (var i = 0; i < count; i++) {
	        result.push(fnc(i));
	    }
	    return result;
	}
	
	function selectActiveStep(steps, _ref) {
	    var workflow = _ref.workflow,
	        updateStepAction = _ref.updateStepAction;
	
	    if (!workflow.uid) return 1;
	    if (workflow.steps.length == 0) return 2.2;
	    if (updateStepAction) return 2.3;
	    return 2.1;
	}
	
	function openingTicketPurposeAggregator(reference) {
	    return function (result, openingTicketPurposeId) {
	        var openingTicketPurpose = reference.openingTicketPurposes.find(function (otp) {
	            return otp.uid == openingTicketPurposeId;
	        });
	
	        if (openingTicketPurpose) {
	            result.push(openingTicketPurpose);
	        } else {
	            console && console.warn('openingTicketPurpose "' + openingTicketPurposeId + '" doesn\'t exist in referentiel');
	        }
	        return result;
	    };
	}
	
	var WorkflowPanel = function (_Component) {
	    _inherits(WorkflowPanel, _Component);
	
	    function WorkflowPanel(props) {
	        _classCallCheck(this, WorkflowPanel);
	
	        var _this = _possibleConstructorReturn(this, (WorkflowPanel.__proto__ || Object.getPrototypeOf(WorkflowPanel)).call(this, props));
	
	        _this.state = {
	            identifiedRequests: []
	        };
	        return _this;
	    }
	
	    _createClass(WorkflowPanel, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                expanded = _props.expanded,
	                workflow = _props.workflow,
	                reference = _props.reference;
	
	
	            if (expanded) {
	                var identifiedRequests = workflow.identifiedRequests.reduce(openingTicketPurposeAggregator(reference), []);
	                this.setState({ identifiedRequests: identifiedRequests });
	
	                dispatch((0, _actions.updateAddStepAction)({ step: { order: workflow.steps.length + 1 } }));
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.expanded != this.props.expanded || nextProps.workflow != this.props.workflow || nextProps.reference != this.props.reference) {
	                var dispatch = nextProps.dispatch,
	                    expanded = nextProps.expanded,
	                    workflow = nextProps.workflow,
	                    reference = nextProps.reference;
	
	
	                if (expanded) {
	                    var identifiedRequests = workflow.identifiedRequests.reduce(openingTicketPurposeAggregator(reference), []);
	                    this.setState({ identifiedRequests: identifiedRequests });
	
	                    dispatch((0, _actions.updateAddStepAction)({ step: { order: workflow.steps.length + 1 } }));
	                }
	            }
	        }
	    }, {
	        key: '_toggleUpdateStep',
	        value: function _toggleUpdateStep(step) {
	            var _props2 = this.props,
	                dispatch = _props2.dispatch,
	                updateStepAction = _props2.updateStepAction;
	
	
	            var updateStep = null;
	            if (step.uid != (updateStepAction && updateStepAction.step.uid)) {
	                updateStep = { step: step };
	            }
	
	            return dispatch((0, _actions.resetUpdateStepAction)(updateStep));
	        }
	    }, {
	        key: '_isUpdateStep',
	        value: function _isUpdateStep(step) {
	            var updateStepAction = this.props.updateStepAction;
	
	            return step.uid == (updateStepAction && updateStepAction.step.uid);
	        }
	    }, {
	        key: '_sendCreateWorkflowAction',
	        value: function _sendCreateWorkflowAction(event) {
	            var _props3 = this.props,
	                dispatch = _props3.dispatch,
	                onSelect = _props3.onSelect;
	
	
	            var workflowUid;
	            return dispatch((0, _actions.sendCreateWorkflowAction)()).then(function (action) {
	                workflowUid = action.workflowUid;
	                return dispatch((0, _actions.loadWorkflowStream)());
	            }).then(function () {
	                onSelect(event, workflowUid);
	            });
	        }
	    }, {
	        key: '_sendAddStepAction',
	        value: function _sendAddStepAction() {
	            var _props4 = this.props,
	                dispatch = _props4.dispatch,
	                workflow = _props4.workflow,
	                wizard = _props4.wizard;
	
	
	            return dispatch((0, _actions.sendAddStepAction)(workflow.uid)).then(function () {
	                return dispatch((0, _actions.loadWorkflowStream)());
	            }).then(function () {
	                wizard.setActiveStep(2.1);
	            });
	        }
	    }, {
	        key: '_sendUpdateStepAction',
	        value: function _sendUpdateStepAction() {
	            var _props5 = this.props,
	                dispatch = _props5.dispatch,
	                workflow = _props5.workflow,
	                wizard = _props5.wizard;
	
	
	            return dispatch((0, _actions.sendUpdateStepAction)(workflow.uid)).then(function () {
	                return dispatch((0, _actions.loadWorkflowStream)());
	            }).then(function () {
	                wizard.setActiveStep(2.1);
	            });
	        }
	    }, {
	        key: '_sendRemoveStepAction',
	        value: function _sendRemoveStepAction(step) {
	            var _props6 = this.props,
	                dispatch = _props6.dispatch,
	                workflow = _props6.workflow;
	
	
	            return dispatch((0, _actions.sendRemoveStepAction)(workflow.uid, step.uid)).then(function () {
	                return dispatch((0, _actions.loadWorkflowStream)());
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props7 = this.props,
	                dispatch = _props7.dispatch,
	                createWorkflowForm = _props7.createWorkflowForm,
	                addStepForm = _props7.addStepForm,
	                updateStepForm = _props7.updateStepForm,
	                createWorkflowAction = _props7.createWorkflowAction,
	                addStepAction = _props7.addStepAction,
	                updateStepAction = _props7.updateStepAction,
	                reference = _props7.reference,
	                workflow = _props7.workflow,
	                wizard = _props7.wizard,
	                onSubmit = _props7.onSubmit,
	                others = _objectWithoutProperties(_props7, ['dispatch', 'createWorkflowForm', 'addStepForm', 'updateStepForm', 'createWorkflowAction', 'addStepAction', 'updateStepAction', 'reference', 'workflow', 'wizard', 'onSubmit']);
	
	            var identifiedRequests = this.state.identifiedRequests;
	
	
	            var header = function header() {
	                if (wizard.matchActiveStep(2)) {
	                    return _react2.default.createElement(
	                        'h5',
	                        null,
	                        workflow.label,
	                        ' (',
	                        workflow.steps.length,
	                        ')'
	                    );
	                }
	            };
	
	            var identifiedRequestElement = function identifiedRequestElement(identifiedRequest) {
	                return _react2.default.createElement(
	                    'li',
	                    {
	                        key: identifiedRequest.uid },
	                    identifiedRequest.label
	                );
	            };
	
	            var tooltip = function tooltip(text) {
	                return _react2.default.createElement(
	                    _reactBootstrap.Tooltip,
	                    {
	                        className: 'tooltip-primary' },
	                    text
	                );
	            };
	
	            return _react2.default.createElement(
	                _reactBootstrap.Panel,
	                _extends({
	                    header: header()
	                }, others),
	                wizard.matchActiveStep(1) && _react2.default.createElement(
	                    'div',
	                    { className: _WorkflowPanel2.default.workflowLabel },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        _i18n2.default.workflowLabel
	                    ),
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'form-inline' },
	                        _react2.default.createElement(_reactBootstrap.Input, _extends({
	                            type: 'text',
	                            name: 'name'
	                        }, createWorkflowForm.label()))
	                    ),
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _i18n2.default.openTicket
	                    ),
	                    _react2.default.createElement(_Icon2.default, { icon: 'arrow', size: 'sm' }),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !createWorkflowForm.isValid() }),
	                                onClick: function onClick(e) {
	                                    return createWorkflowForm.validate() && _this2._sendCreateWorkflowAction(e) || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.fillStep
	                        )
	                    )
	                ),
	                wizard.matchActiveStep(2) && _react2.default.createElement(
	                    'div',
	                    { className: _WorkflowPanel2.default.workflowAction },
	                    _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.update) },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                href: '',
	                                bsStyle: 'link',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'UpdateWorkflowLabel', workflow);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.OverlayTrigger,
	                        {
	                            placement: 'bottom',
	                            overlay: tooltip(_i18n2.default.delete) },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                href: '',
	                                bsStyle: 'link',
	                                onClick: function onClick(e) {
	                                    return onSubmit(e, 'RemoveWorkflow', workflow);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { active: true, icon: 'cross', size: 'xs' })
	                        )
	                    )
	                ),
	                wizard.matchActiveStep(2) && _react2.default.createElement(
	                    'div',
	                    { className: _WorkflowPanel2.default.stepGroup },
	                    _react2.default.createElement(
	                        'h5',
	                        null,
	                        _i18n2.default.openTicket
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        workflow.steps.sort(function (a, b) {
	                            return a.order - b.order;
	                        }).map(function (step) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: step.uid },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _WorkflowPanel2.default.step },
	                                    _react2.default.createElement('strong', null)
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _WorkflowPanel2.default.action },
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: tooltip(_i18n2.default.update) },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            {
	                                                bsStyle: 'link',
	                                                active: _this2._isUpdateStep(step),
	                                                onClick: function onClick() {
	                                                    return _this2._toggleUpdateStep(step);
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, { icon: 'gear', size: 'xs' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactBootstrap.OverlayTrigger,
	                                        {
	                                            placement: 'bottom',
	                                            overlay: tooltip(_i18n2.default.delete) },
	                                        _react2.default.createElement(
	                                            _reactBootstrap.Button,
	                                            { active: true,
	                                                bsStyle: 'link',
	                                                onClick: function onClick() {
	                                                    return _this2._sendRemoveStepAction(step);
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, { icon: 'cross', size: 'xs' })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _WorkflowPanel2.default.container },
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        (0, _extract2.default)(_i18n2.default.expectedEventEnum, step.expectedEvent)
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        step.actors.map(function (a) {
	                                            return (0, _extract2.default)(_i18n2.default.actorEnum, a);
	                                        }).join(' : ')
	                                    ),
	                                    step.timeLimit && _react2.default.createElement(
	                                        'p',
	                                        null,
	                                        (0, _extract2.default)(_i18n2.default.stepTimeLimitTypeEnum, step.timeLimit.workflowStepTimeLimitType),
	                                        ' - ',
	                                        _moment2.default.duration(step.timeLimit.duration).humanize()
	                                    )
	                                )
	                            );
	                        })
	                    )
	                ),
	                wizard.matchActiveStep(2.1) && _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            onClick: function onClick() {
	                                return wizard.setActiveStep(2.2);
	                            } },
	                        _i18n2.default.newStep
	                    )
	                ),
	                wizard.matchActiveStep(2.2) && _react2.default.createElement(
	                    'div',
	                    { className: _WorkflowPanel2.default.newStep },
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Input,
	                                    _extends({
	                                        type: 'select',
	                                        name: 'expectedEvent'
	                                    }, addStepForm.step.expectedEvent()),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        _i18n2.default.expectedEvent,
	                                        ' ...'
	                                    ),
	                                    _models.EXPECTED_EVENTS.map(function (event) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            {
	                                                key: event,
	                                                value: event },
	                                            (0, _extract2.default)(_i18n2.default.expectedEventEnum, event)
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Input,
	                                    _extends({
	                                        type: 'select',
	                                        name: 'order'
	                                    }, (0, _form.integerField)(addStepForm.step.order())),
	                                    mapCount(function (index) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            {
	                                                key: index,
	                                                value: index + 1 },
	                                            index + 1
	                                        );
	                                    }, workflow.steps.length + 1)
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Input,
	                                    _extends({ multiple: true,
	                                        type: 'select',
	                                        name: 'actors'
	                                    }, (0, _form.selectField)(addStepForm.step.actors(), true)),
	                                    _models.ACTORS.map(function (actor) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            {
	                                                key: actor,
	                                                value: actor },
	                                            (0, _extract2.default)(_i18n2.default.actorEnum, actor)
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12, sm: 8 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Input,
	                                    _extends({
	                                        type: 'select',
	                                        name: 'workflowStepTimeLimitType'
	                                    }, addStepForm.step.timeLimit.workflowStepTimeLimitType()),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        _i18n2.default.stepTimeLimitType,
	                                        ' ...'
	                                    ),
	                                    _models.STEP_TIME_LIMIT_TYPE.map(function (type) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            {
	                                                key: type,
	                                                value: type },
	                                            (0, _extract2.default)(_i18n2.default.stepTimeLimitTypeEnum, type)
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12, sm: 4 },
	                                _react2.default.createElement(_MeasureInput2.default, _extends({
	                                    name: 'duration',
	                                    units: _MeasureInput.timeUnits,
	                                    placeholder: _i18n2.default.duration + ' ...'
	                                }, addStepForm.step.timeLimit.duration()))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !addStepForm.isValid() }),
	                                onClick: function onClick() {
	                                    return addStepForm.validate() && _this2._sendAddStepAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.saveStep
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return wizard.setActiveStep(2.1);
	                                } },
	                            _i18n2.default.cancel
	                        )
	                    )
	                ),
	                wizard.matchActiveStep(2.3) && _react2.default.createElement(
	                    'div',
	                    { className: _WorkflowPanel2.default.newStep },
	                    _react2.default.createElement(
	                        'form',
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 8 },
	                                _react2.default.createElement(_reactBootstrap.Input, { disabled: true,
	                                    type: 'text',
	                                    name: 'expectedEvent',
	                                    value: (0, _extract2.default)(_i18n2.default.expectedEventEnum, updateStepAction.step.expectedEvent) })
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 4 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Input,
	                                    _extends({
	                                        type: 'select',
	                                        name: 'order'
	                                    }, (0, _form.integerField)(updateStepForm.step.order())),
	                                    mapCount(function (index) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            {
	                                                key: index,
	                                                value: index + 1 },
	                                            index + 1
	                                        );
	                                    }, workflow.steps.length)
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Input,
	                                    _extends({ multiple: true,
	                                        type: 'select',
	                                        name: 'actors'
	                                    }, (0, _form.selectField)(updateStepForm.step.actors(), true)),
	                                    _models.ACTORS.map(function (actor) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            {
	                                                key: actor,
	                                                value: actor },
	                                            (0, _extract2.default)(_i18n2.default.actorEnum, actor)
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Row,
	                            null,
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12, sm: 8 },
	                                _react2.default.createElement(
	                                    _reactBootstrap.Input,
	                                    _extends({
	                                        type: 'select',
	                                        name: 'workflowStepTimeLimitType'
	                                    }, updateStepForm.step.timeLimit.workflowStepTimeLimitType()),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        _i18n2.default.stepTimeLimitType,
	                                        ' ...'
	                                    ),
	                                    _models.STEP_TIME_LIMIT_TYPE.map(function (type) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            {
	                                                key: type,
	                                                value: type },
	                                            (0, _extract2.default)(_i18n2.default.stepTimeLimitTypeEnum, type)
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactBootstrap.Col,
	                                { xs: 12, sm: 4 },
	                                _react2.default.createElement(_MeasureInput2.default, _extends({
	                                    name: 'duration',
	                                    units: _MeasureInput.timeUnits,
	                                    placeholder: _i18n2.default.duration + ' ...'
	                                }, updateStepForm.step.timeLimit.duration()))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsStyle: 'primary',
	                                bsSize: 'large',
	                                className: (0, _classnames2.default)({ disabled: !updateStepForm.isValid() }),
	                                onClick: function onClick() {
	                                    return updateStepForm.validate() && _this2._sendUpdateStepAction() || dispatch((0, _status.errorStatus)(_i18n2.default.formInvalid));
	                                } },
	                            _i18n2.default.updateStep
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                bsSize: 'large',
	                                onClick: function onClick() {
	                                    return _this2._toggleUpdateStep(updateStepAction.step);
	                                } },
	                            _i18n2.default.cancel
	                        )
	                    )
	                ),
	                wizard.matchActiveStep(2) && _react2.default.createElement(
	                    'div',
	                    { className: _WorkflowPanel2.default.identifiedRequests },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _WorkflowPanel2.default.action },
	                        _react2.default.createElement(
	                            _reactBootstrap.OverlayTrigger,
	                            {
	                                placement: 'bottom',
	                                overlay: tooltip(_i18n2.default.identifiedRequests) },
	                            _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    href: '',
	                                    bsStyle: 'link',
	                                    onClick: function onClick(e) {
	                                        return onSubmit(e, 'UpdateIdentifiedRequests', workflow);
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { icon: 'pencil', size: 'xs' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                identifiedRequests.slice(0, identifiedRequests.length / 2 + 1).map(identifiedRequestElement)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { sm: 6 },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                identifiedRequests.slice(identifiedRequests.length / 2 + 1, identifiedRequests.length).map(identifiedRequestElement)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WorkflowPanel;
	}(_react.Component);
	
	WorkflowPanel.propTypes = {
	    workflow: _react.PropTypes.object.isRequired,
	    onSubmit: _react.PropTypes.func.isRequired
	};
	
	
	WorkflowPanel = (0, _form.connectForm)({
	    name: 'createWorkflowForm',
	    target: 'createWorkflowAction',
	    alias: 'action',
	    schema: _models.CreateWorkflowAction.schema,
	    action: _actions.CREATE_WORKFLOW_ACTION_UPDATED
	})(WorkflowPanel);
	
	WorkflowPanel = (0, _form.connectForm)({
	    name: 'addStepForm',
	    target: 'addStepAction',
	    alias: 'action',
	    schema: _models.AddStepAction.schema,
	    action: _actions.ADD_STEP_ACTION_UPDATED
	})(WorkflowPanel);
	
	WorkflowPanel = (0, _form.connectForm)({
	    name: 'updateStepForm',
	    target: 'updateStepAction',
	    alias: 'action',
	    schema: _models.UpdateStepAction.schema,
	    action: _actions.UPDATE_STEP_ACTION_UPDATED
	})(WorkflowPanel);
	
	WorkflowPanel = (0, _wizard.connectWizard)({
	    activeStep: selectActiveStep
	})(WorkflowPanel);
	
	WorkflowPanel = (0, _reactRedux.connect)(function (state) {
	    return {
	        reference: state.reference.openingTicketPurposeRef,
	        createWorkflowAction: state.workflow.createWorkflowAction,
	        updateWorkflowLabelAction: state.workflow.updateWorkflowLabelAction,
	        addStepAction: state.workflow.addStepAction,
	        updateStepAction: state.workflow.updateStepAction
	    };
	})(WorkflowPanel);
	
	exports.default = WorkflowPanel;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reactBootstrap = __webpack_require__(5);
	
	var _models = __webpack_require__(550);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _WorkflowPanel = __webpack_require__(1563);
	
	var _WorkflowPanel2 = _interopRequireDefault(_WorkflowPanel);
	
	var _UpdateIdentifiedRequestsModal = __webpack_require__(1561);
	
	var _UpdateIdentifiedRequestsModal2 = _interopRequireDefault(_UpdateIdentifiedRequestsModal);
	
	var _UpdateWorkflowLabelModal = __webpack_require__(1562);
	
	var _UpdateWorkflowLabelModal2 = _interopRequireDefault(_UpdateWorkflowLabelModal);
	
	var _RemoveWorkflowModal = __webpack_require__(1554);
	
	var _RemoveWorkflowModal2 = _interopRequireDefault(_RemoveWorkflowModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function modalName(result) {
	    switch (result) {
	        case 'UpdateIdentifiedRequests':
	            return 'UpdateIdentifiedRequestsModal';
	        case 'UpdateWorkflowLabel':
	            return 'UpdateWorkflowLabelModal';
	        case 'RemoveWorkflow':
	            return 'RemoveWorkflowModal';
	        default:
	            return null;
	    }
	}
	
	var WorkflowPanelGroup = function (_Component) {
	    _inherits(WorkflowPanelGroup, _Component);
	
	    function WorkflowPanelGroup(props) {
	        _classCallCheck(this, WorkflowPanelGroup);
	
	        var _this = _possibleConstructorReturn(this, (WorkflowPanelGroup.__proto__ || Object.getPrototypeOf(WorkflowPanelGroup)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(WorkflowPanelGroup, [{
	        key: '_openPanel',
	        value: function _openPanel(key) {
	            var activeKey = this.state.activeKey;
	
	
	            var nextActiveKey = activeKey != key && key || null;
	            this.setState({ activeKey: nextActiveKey });
	        }
	    }, {
	        key: '_openModal',
	        value: function _openModal(event, result, activeWorkflow) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            var openedModal = modalName(result);
	            this.setState({ openedModal: openedModal, activeWorkflow: activeWorkflow });
	        }
	    }, {
	        key: '_closeModal',
	        value: function _closeModal(event) {
	            if (event) {
	                event.preventDefault();
	            }
	
	            this.setState({ openedModal: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dispatch = _props.dispatch,
	                stream = _props.stream;
	            var _state = this.state,
	                activeKey = _state.activeKey,
	                openedModal = _state.openedModal,
	                activeWorkflow = _state.activeWorkflow;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.PanelGroup,
	                    { accordion: true,
	                        activeKey: activeKey,
	                        onSelect: function onSelect(k) {
	                            return _this2._openPanel(k);
	                        } },
	                    stream.map(function (workflow) {
	                        return _react2.default.createElement(_WorkflowPanel2.default, {
	                            key: workflow.uid,
	                            eventKey: workflow.uid,
	                            workflow: workflow,
	                            onSubmit: function onSubmit(e, r, w) {
	                                return _this2._openModal(e, r, w);
	                            } });
	                    }),
	                    activeKey == 'new' && _react2.default.createElement(_WorkflowPanel2.default, {
	                        eventKey: 'new',
	                        workflow: _models.NEW_WORKFLOW,
	                        onSubmit: function onSubmit(e, r, w) {
	                            return _this2._openModal(e, r, w);
	                        } })
	                ),
	                activeKey != 'new' && _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            bsStyle: 'primary',
	                            bsSize: 'large',
	                            onClick: function onClick() {
	                                return _this2._openPanel('new');
	                            } },
	                        _i18n2.default.newWorkflow
	                    )
	                ),
	                activeWorkflow && _react2.default.createElement(_UpdateIdentifiedRequestsModal2.default, {
	                    show: openedModal == 'UpdateIdentifiedRequestsModal',
	                    onHide: function onHide(e) {
	                        return _this2._closeModal(e);
	                    },
	                    workflow: activeWorkflow }),
	                activeWorkflow && _react2.default.createElement(_UpdateWorkflowLabelModal2.default, {
	                    show: openedModal == 'UpdateWorkflowLabelModal',
	                    onHide: function onHide(e) {
	                        return _this2._closeModal(e);
	                    },
	                    workflow: activeWorkflow }),
	                activeWorkflow && _react2.default.createElement(_RemoveWorkflowModal2.default, {
	                    show: openedModal == 'RemoveWorkflowModal',
	                    onHide: function onHide(e) {
	                        return _this2._closeModal(e);
	                    },
	                    workflow: activeWorkflow })
	            );
	        }
	    }]);
	
	    return WorkflowPanelGroup;
	}(_react.Component);
	
	WorkflowPanelGroup.propTypes = {};
	
	
	WorkflowPanelGroup = (0, _reactRedux.connect)(function (state) {
	    return {
	        stream: state.workflow.stream
	    };
	})(WorkflowPanelGroup);
	
	exports.default = WorkflowPanelGroup;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (error) {
	    return replaceError(extractError(_i18n2.default.errorTypeEnum, error), error);
	};
	
	var _extract = __webpack_require__(12);
	
	var _extract2 = _interopRequireDefault(_extract);
	
	var _i18n = __webpack_require__(194);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extractError(target, error) {
	    var errorType = (0, _extract.sanitize)(error && error.type);
	
	    if (target) {
	        var errorData = error && error.data;
	        var targetError = target[errorType];
	
	        switch (errorType) {
	            case 'stepCoherencyError':
	                return targetError && errorData.errors.map(function (error) {
	                    return targetError[(0, _extract.sanitize)(error.error)] || null;
	                });
	            default:
	                return targetError || null;
	        }
	    }
	    return null;
	}
	
	function replaceError(value, error) {
	    if (value) {
	        var errorType = (0, _extract.sanitize)(error && error.type);
	        var errorData = error && error.data;
	
	        switch (errorType) {
	            case 'stepCoherencyError':
	                return errorData.errors.map(function (error, index) {
	                    return (0, _extract.replace)(value[index], {
	                        stepInError: (0, _extract2.default)(_i18n2.default.expectedEventEnum, error.stepInError.expectedEvent),
	                        stepsBefore: error.stepsBefore && error.stepsBefore.map(function (sb) {
	                            return (0, _extract2.default)(_i18n2.default.expectedEventEnum, sb.expectedEvent);
	                        }).join(', ')
	                    });
	                }).join('. ');
	            case 'companyDoesNotHaveRequieredBillingTypeLevel':
	                return (0, _extract.replace)(value, {
	                    expectedLevels: errorData.expectedLevels.map(function (el) {
	                        return (0, _extract2.default)(_i18n2.default.billingTypeEnum, el);
	                    }).join(', ')
	                });
	            default:
	                return (0, _extract.replace)(value, errorData);
	        }
	    }
	    return value;
	}

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(148);
	
	var _actions = __webpack_require__(193);
	
	function stream() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.WORKFLOW_STREAM_LOADED:
	            return action.stream;
	        default:
	            return state;
	    }
	}
	
	function nextStep() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.NEXT_STEP_LOADED:
	        case _actions.NEXT_STEP_QUERIED:
	            return action.nextStep;
	        default:
	            return state;
	    }
	}
	
	function createWorkflowAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.CREATE_WORKFLOW_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.CREATE_WORKFLOW_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateWorkflowLabelAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_WORKFLOW_LABEL_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.UPDATE_WORKFLOW_LABEL_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateIdentifiedRequestsAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function addStepAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.ADD_STEP_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.ADD_STEP_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	function updateStepAction() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actions.UPDATE_STEP_ACTION_UPDATED:
	            return _extends({}, state, action.action);
	        case _actions.UPDATE_STEP_ACTION_RESET:
	            return action.action;
	        case _actions.UPDATE_STEP_ACTION_SENT:
	            return null;
	        default:
	            return state;
	    }
	}
	
	var todo = function () {
	
	    function stream() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.TODO_STREAM_LOADED:
	                return action.stream;
	            default:
	                return state;
	        }
	    }
	
	    function aggregations() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.TODO_STREAM_LOADED:
	                return action.aggregations;
	            default:
	                return state;
	        }
	    }
	
	    function range() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.TODO_STREAM_LOADED:
	                return action.range;
	            default:
	                return state;
	        }
	    }
	
	    function query() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.TODO_STREAM_LOADED:
	                return action.query;
	            default:
	                return state;
	        }
	    }
	
	    function criteria() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.TODO_CRITERIA_UPDATED:
	                return _extends({}, state, action.criteria);
	            case _actions.TODO_CRITERIA_RESET:
	                return action.criteria;
	            default:
	                return state;
	        }
	    }
	
	    function status() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case _actions.TODO_STATUS_QUERIED:
	                return action.status;
	            default:
	                return state;
	        }
	    }
	
	    return (0, _redux.combineReducers)({ stream: stream, aggregations: aggregations, range: range, query: query, criteria: criteria, status: status });
	}();
	
	exports.default = (0, _redux.combineReducers)({
	    todo: todo,
	    stream: stream,
	    nextStep: nextStep,
	    createWorkflowAction: createWorkflowAction,
	    updateWorkflowLabelAction: updateWorkflowLabelAction,
	    updateIdentifiedRequestsAction: updateIdentifiedRequestsAction,
	    addStepAction: addStepAction,
	    updateStepAction: updateStepAction
	});

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.todoRoute = todoRoute;
	
	var _actions = __webpack_require__(46);
	
	var _actions2 = __webpack_require__(193);
	
	var _TodoLayout = __webpack_require__(1555);
	
	var _TodoLayout2 = _interopRequireDefault(_TodoLayout);
	
	var _TodoStreamLayout = __webpack_require__(1559);
	
	var _TodoStreamLayout2 = _interopRequireDefault(_TodoStreamLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function todoRoute(rootPath, dispatcher, _ref) {
	    var getState = _ref.getState;
	
	
	    function enterTodoStream(dispatch) {
	        var state = getState();
	        var authenticated = state.user.authenticated;
	        var criteria = state.workflow.todo.criteria;
	
	
	        return Promise.all([dispatch((0, _actions2.loadTodoStream)(_extends({}, _actions2.DEFAULT_TODO_QUERY, criteria))), authenticated.company && dispatch((0, _actions.loadCompany)(authenticated.company.uid))]);
	    }
	
	    return {
	        path: rootPath,
	        component: _TodoLayout2.default,
	        indexRoute: {
	            component: _TodoStreamLayout2.default,
	            onEnter: dispatcher(enterTodoStream)
	        }
	    };
	}

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(1003);
	var Transform = __webpack_require__(1004);
	var inherits = __webpack_require__(89);
	var modes = __webpack_require__(1005);
	var StreamCipher = __webpack_require__(1128);
	var ebtk = __webpack_require__(1122);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(1126),
	  CBC: __webpack_require__(1123),
	  CFB: __webpack_require__(1124),
	  OFB: __webpack_require__(1127),
	  CTR: __webpack_require__(1125)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(1003);
	var Transform = __webpack_require__(1004);
	var inherits = __webpack_require__(89);
	var modes = __webpack_require__(1005);
	var ebtk = __webpack_require__(1122);
	var StreamCipher = __webpack_require__(1128);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(1126),
	  CBC: __webpack_require__(1123),
	  CFB: __webpack_require__(1124),
	  OFB: __webpack_require__(1127),
	  CTR: __webpack_require__(1125)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(1569)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(1568)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(1005);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	/*
	 * classList.js: Cross-browser full element.classList implementation.
	 * 1.1.20170427
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: Dedicated to the public domain.
	 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
	 */
	
	/*global self, document, DOMException */
	
	/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
	
	if ("document" in window.self) {
	
	// Full polyfill for browsers with no classList support
	// Including IE < Edge missing SVGElement.classList
	if (!("classList" in document.createElement("_")) 
		|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {
	
	(function (view) {
	
	"use strict";
	
	if (!('Element' in view)) return;
	
	var
		  classListProp = "classList"
		, protoProp = "prototype"
		, elemCtrProto = view.Element[protoProp]
		, objCtr = Object
		, strTrim = String[protoProp].trim || function () {
			return this.replace(/^\s+|\s+$/g, "");
		}
		, arrIndexOf = Array[protoProp].indexOf || function (item) {
			var
				  i = 0
				, len = this.length
			;
			for (; i < len; i++) {
				if (i in this && this[i] === item) {
					return i;
				}
			}
			return -1;
		}
		// Vendors: please allow content code to instantiate DOMExceptions
		, DOMEx = function (type, message) {
			this.name = type;
			this.code = DOMException[type];
			this.message = message;
		}
		, checkTokenAndGetIndex = function (classList, token) {
			if (token === "") {
				throw new DOMEx(
					  "SYNTAX_ERR"
					, "An invalid or illegal string was specified"
				);
			}
			if (/\s/.test(token)) {
				throw new DOMEx(
					  "INVALID_CHARACTER_ERR"
					, "String contains an invalid character"
				);
			}
			return arrIndexOf.call(classList, token);
		}
		, ClassList = function (elem) {
			var
				  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
				, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
				, i = 0
				, len = classes.length
			;
			for (; i < len; i++) {
				this.push(classes[i]);
			}
			this._updateClassName = function () {
				elem.setAttribute("class", this.toString());
			};
		}
		, classListProto = ClassList[protoProp] = []
		, classListGetter = function () {
			return new ClassList(this);
		}
	;
	// Most DOMException implementations don't allow calling DOMException's toString()
	// on non-DOMExceptions. Error's toString() is sufficient here.
	DOMEx[protoProp] = Error[protoProp];
	classListProto.item = function (i) {
		return this[i] || null;
	};
	classListProto.contains = function (token) {
		token += "";
		return checkTokenAndGetIndex(this, token) !== -1;
	};
	classListProto.add = function () {
		var
			  tokens = arguments
			, i = 0
			, l = tokens.length
			, token
			, updated = false
		;
		do {
			token = tokens[i] + "";
			if (checkTokenAndGetIndex(this, token) === -1) {
				this.push(token);
				updated = true;
			}
		}
		while (++i < l);
	
		if (updated) {
			this._updateClassName();
		}
	};
	classListProto.remove = function () {
		var
			  tokens = arguments
			, i = 0
			, l = tokens.length
			, token
			, updated = false
			, index
		;
		do {
			token = tokens[i] + "";
			index = checkTokenAndGetIndex(this, token);
			while (index !== -1) {
				this.splice(index, 1);
				updated = true;
				index = checkTokenAndGetIndex(this, token);
			}
		}
		while (++i < l);
	
		if (updated) {
			this._updateClassName();
		}
	};
	classListProto.toggle = function (token, force) {
		token += "";
	
		var
			  result = this.contains(token)
			, method = result ?
				force !== true && "remove"
			:
				force !== false && "add"
		;
	
		if (method) {
			this[method](token);
		}
	
		if (force === true || force === false) {
			return force;
		} else {
			return !result;
		}
	};
	classListProto.toString = function () {
		return this.join(" ");
	};
	
	if (objCtr.defineProperty) {
		var classListPropDesc = {
			  get: classListGetter
			, enumerable: true
			, configurable: true
		};
		try {
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		} catch (ex) { // IE 8 doesn't support enumerable:true
			// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
			// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
			if (ex.number === undefined || ex.number === -0x7FF5EC54) {
				classListPropDesc.enumerable = false;
				objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
			}
		}
	} else if (objCtr[protoProp].__defineGetter__) {
		elemCtrProto.__defineGetter__(classListProp, classListGetter);
	}
	
	}(window.self));
	
	}
	
	// There is full or partial native classList support, so just check if we need
	// to normalize the add/remove and toggle APIs.
	
	(function () {
		"use strict";
	
		var testElement = document.createElement("_");
	
		testElement.classList.add("c1", "c2");
	
		// Polyfill for IE 10/11 and Firefox <26, where classList.add and
		// classList.remove exist but support only one argument at a time.
		if (!testElement.classList.contains("c2")) {
			var createMethod = function(method) {
				var original = DOMTokenList.prototype[method];
	
				DOMTokenList.prototype[method] = function(token) {
					var i, len = arguments.length;
	
					for (i = 0; i < len; i++) {
						token = arguments[i];
						original.call(this, token);
					}
				};
			};
			createMethod('add');
			createMethod('remove');
		}
	
		testElement.classList.toggle("c3", false);
	
		// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
		// support the second argument.
		if (testElement.classList.contains("c3")) {
			var _toggle = DOMTokenList.prototype.toggle;
	
			DOMTokenList.prototype.toggle = function(token, force) {
				if (1 in arguments && !this.contains(token) === !force) {
					return force;
				} else {
					return _toggle.call(this, token);
				}
			};
	
		}
	
		testElement = null;
	}());
	
	}


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1585);
	module.exports = __webpack_require__(791).Object.assign;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1007);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1586);
	module.exports = __webpack_require__(791).Object.keys;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1587);
	module.exports = __webpack_require__(791).Object.setPrototypeOf;

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1132);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(1578);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(1007)
	  , toObject = __webpack_require__(1133)
	  , IObject  = __webpack_require__(1581);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(1131)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1006)
	  , core    = __webpack_require__(791)
	  , fails   = __webpack_require__(1131);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(1007).getDesc
	  , isObject = __webpack_require__(1132)
	  , anObject = __webpack_require__(1577);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(1130)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1006);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(1582)});

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(1133);
	
	__webpack_require__(1583)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1006);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(1584).set});

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(1975);
	
	var emptyObject = __webpack_require__(1824);
	var _invariant = __webpack_require__(792);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1588);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1134)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(1595)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(1134)
	
	exports.createHmac = __webpack_require__(1590)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(1594)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(1570)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(1591);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(1976)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(2353)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(81).Buffer))

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DocumentDashboardPanel-defaultContent-jD-YL{position:relative;height:100%}.DocumentDashboardPanel-defaultContent-jD-YL h4{color:#8a959a}.DocumentDashboardPanel-defaultContent-jD-YL h4 i{margin-right:5px}.DocumentDashboardPanel-defaultContent-jD-YL b{display:inline-block;width:24px;height:24px;font-size:20px;line-height:1;text-align:center}.DocumentDashboardPanel-documentGroup-2L154 ul{margin:0;padding:0;list-style-type:none}.DocumentDashboardPanel-documentGroup-2L154 ul>li{display:block;padding:2px 0}.DocumentDashboardPanel-documentGroup-2L154 ul>li.DocumentDashboardPanel-ok-3xcwP a{color:#00e5ce}.DocumentDashboardPanel-documentGroup-2L154 ul>li.DocumentDashboardPanel-documentExpiredInLessThan15Days-1kvGp a{color:#faad44}.DocumentDashboardPanel-documentGroup-2L154 ul>li.DocumentDashboardPanel-documentExpired-15VTr a{color:#ff5766}.DocumentDashboardPanel-documentGroup-2L154 small{font-size:16px;color:#b0bec5}.DocumentDashboardPanel-logo-2cVj_{position:absolute;bottom:10px;right:0}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "DocumentDashboardPanel-defaultContent-jD-YL",
		"documentGroup": "DocumentDashboardPanel-documentGroup-2L154",
		"ok": "DocumentDashboardPanel-ok-3xcwP",
		"documentExpiredInLessThan15Days": "DocumentDashboardPanel-documentExpiredInLessThan15Days-1kvGp",
		"documentExpired": "DocumentDashboardPanel-documentExpired-15VTr",
		"logo": "DocumentDashboardPanel-logo-2cVj_"
	};

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(1140) + ");src:url(" + __webpack_require__(1140) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1833) + ") format(\"woff2\"),url(" + __webpack_require__(1832) + ") format(\"woff\"),url(" + __webpack_require__(1831) + ") format(\"truetype\"),url(" + __webpack_require__(1830) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Josefin Sans;font-size:16px;line-height:1.42857143;color:#8a959a;background-color:#f5f5f5}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#546d79;text-decoration:none}a:focus,a:hover{color:#35444c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:10px}.img-thumbnail{padding:4px;line-height:1.42857143;background-color:#f5f5f5;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:22px;margin-bottom:22px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:300;line-height:1.1;color:#546d79}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#8a959a}.h1,.h2,.h3,h1,h2,h3{margin-top:22px;margin-bottom:11px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:11px;margin-bottom:11px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:41px}.h2,h2{font-size:30px}.h3,h3{font-size:26px}.h4,h4{font-size:20px}.h5,h5{font-size:16px}.h6,h6{font-size:14px}p{margin:0 0 11px}.lead{margin-bottom:22px;font-size:18px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:24px}}.small,small{font-size:87%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#b0bec5}.text-primary{color:#00e5ce}a.text-primary:focus,a.text-primary:hover{color:#00b2a0}.text-success{color:#00e5ce}a.text-success:focus,a.text-success:hover{color:#00b2a0}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#ff5766}a.text-danger:focus,a.text-danger:hover{color:#ff2438}.bg-primary{color:#fff;background-color:#00e5ce}a.bg-primary:focus,a.bg-primary:hover{background-color:#00b2a0}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:10px;margin:44px 0 22px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:11px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:22px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:11px 22px;margin:0 0 22px;font-size:20px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#b0bec5}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:22px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:10.5px;margin:0 0 11px;font-size:15px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.row-no-gutters{margin-right:0;margin-left:0}.row-no-gutters [class*=col-]{padding-right:0;padding-left:0}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}caption{padding-top:8px;padding-bottom:8px;color:#b0bec5}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:22px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#f5f5f5}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover,.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:16.5px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:22px;font-size:24px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:16px;line-height:1.42857143;color:#555}.form-control{width:100%;height:36px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:36px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:33px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:49px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox.disabled label,.radio.disabled label,fieldset[disabled] .checkbox label,fieldset[disabled] .radio label{cursor:not-allowed}.checkbox label,.radio label{min-height:22px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline.disabled,.radio-inline.disabled,fieldset[disabled] .checkbox-inline,fieldset[disabled] .radio-inline{cursor:not-allowed}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.form-control-static{min-height:38px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:33px;padding:5px 10px;font-size:14px;line-height:1.5;border-radius:3px}select.input-sm{height:33px;line-height:33px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:33px;padding:5px 10px;font-size:14px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:33px;line-height:33px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:33px;min-height:36px;padding:6px 10px;font-size:14px;line-height:1.5}.input-lg{height:49px;padding:10px 16px;font-size:20px;line-height:1.3333333;border-radius:10px}select.input-lg{height:49px;line-height:49px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:49px;padding:10px 16px;font-size:20px;line-height:1.3333333;border-radius:10px}.form-group-lg select.form-control{height:49px;line-height:49px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:49px;min-height:42px;padding:11px 16px;font-size:20px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:45px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:36px;height:36px;line-height:36px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:49px;height:49px;line-height:49px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:33px;height:33px;line-height:33px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#00e5ce}.has-success .form-control{border-color:#00e5ce;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#00b2a0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #4cffed}.has-success .input-group-addon{color:#00e5ce;background-color:#dff0d8;border-color:#00e5ce}.has-success .form-control-feedback{color:#00e5ce}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#ff5766}.has-error .form-control{border-color:#ff5766;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#ff2438;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ffbdc3}.has-error .input-group-addon{color:#ff5766;background-color:#f2dede;border-color:#ff5766}.has-error .form-control-feedback{color:#ff5766}.has-feedback label~.form-control-feedback{top:27px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#ced3d5}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:29px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:20px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:14px}}.btn{display:inline-block;margin-bottom:0;font-weight:300;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;padding:6px 12px;font-size:16px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#8a959a;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);opacity:.65;box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#8a959a;background-color:#d5dde5;border-color:transparent}.btn-default.focus,.btn-default:focus,.btn-default:hover{color:#8a959a;background-color:#b6c4d2;border-color:transparent}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{color:#8a959a;background-color:#b6c4d2;background-image:none;border-color:transparent}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#8a959a;background-color:#9fb2c4;border-color:transparent}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#d5dde5;border-color:transparent}.btn-default .badge{color:#d5dde5;background-color:#8a959a}.btn-primary{color:#fff;background-color:#00e5ce;border-color:#00ccb7}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#00b2a0;border-color:#004c44}.btn-primary:hover{color:#fff;background-color:#00b2a0;border-color:#008e80}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#00b2a0;background-image:none;border-color:#008e80}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#008e80;border-color:#004c44}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#00e5ce;border-color:#00ccb7}.btn-primary .badge{color:#00e5ce;background-color:#fff}.btn-success{color:#fff;background-color:#00e5ce;border-color:#00ccb7}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#00b2a0;border-color:#004c44}.btn-success:hover{color:#fff;background-color:#00b2a0;border-color:#008e80}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#00b2a0;background-image:none;border-color:#008e80}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#008e80;border-color:#004c44}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#00e5ce;border-color:#00ccb7}.btn-success .badge{color:#00e5ce;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info:hover{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;background-image:none;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#faad44;border-color:#f9a22b}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#f99712;border-color:#a15f04}.btn-warning:hover{color:#fff;background-color:#f99712;border-color:#e18506}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#f99712;background-image:none;border-color:#e18506}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#e18506;border-color:#a15f04}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#faad44;border-color:#f9a22b}.btn-warning .badge{color:#faad44;background-color:#fff}.btn-danger{color:#fff;background-color:#ff5766;border-color:#ff3e4f}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#ff2438;border-color:#bd0011}.btn-danger:hover{color:#fff;background-color:#ff2438;border-color:#ff0017}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#ff2438;background-image:none;border-color:#ff0017}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ff0017;border-color:#bd0011}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#ff5766;border-color:#ff3e4f}.btn-danger .badge{color:#ff5766;background-color:#fff}.btn-link{font-weight:400;color:#546d79;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#35444c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#b0bec5;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:20px;line-height:1.3333333;border-radius:0}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:14px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:14px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:16px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:10px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#00e5ce;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#b0bec5}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:14px;line-height:1.42857143;color:#b0bec5;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:49px;padding:10px 16px;font-size:20px;line-height:1.3333333;border-radius:10px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:49px;line-height:49px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:33px;padding:5px 10px;font-size:14px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:33px;line-height:33px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:16px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:14px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:20px;border-radius:10px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#d3e2ea}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#d3e2ea;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#546d79}.nav .nav-divider{height:1px;margin:10px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#f5f5f5;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#f5f5f5}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#00e5ce}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#f5f5f5}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:68px;margin-bottom:22px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-brand{float:left;height:68px;padding:23px 15px;font-size:20px;line-height:22px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-right:15px;margin-top:17px;margin-bottom:17px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:11.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:22px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:22px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:23px;padding-bottom:23px}}.navbar-form{padding:10px 15px;margin:16px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:16px;margin-bottom:16px}.navbar-btn.btn-sm{margin-top:17.5px;margin-bottom:17.5px}.navbar-btn.btn-xs,.navbar-text{margin-top:23px;margin-bottom:23px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#dadada}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#dadada}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#dce2e5}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#dce2e5}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#dce2e5}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-link{color:#dce2e5}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#dce2e5}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:22px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#b0bec5}.pagination{display:inline-block;padding-left:0;margin:22px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#546d79;text-decoration:none;background-color:transparent;border:1px none}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#00e5ce;background-color:transparent;border-color:none}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#00e5ce;border-color:#00e5ce}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#b0bec5;cursor:not-allowed;background-color:transparent;border-color:none}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:20px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:10px;border-bottom-left-radius:10px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:10px;border-bottom-right-radius:10px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:14px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:22px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:transparent;border:1px none;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:transparent}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#b0bec5;cursor:not-allowed;background-color:transparent}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#b0bec5}.label-default[href]:focus,.label-default[href]:hover{background-color:#93a6af}.label-primary{background-color:#00e5ce}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#00b2a0}.label-success{background-color:#00e5ce}.label-success[href]:focus,.label-success[href]:hover{background-color:#00b2a0}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#faad44}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#f99712}.label-danger{background-color:#ff5766}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#ff2438}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:14px;font-weight:400;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#b0bec5;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#546d79;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:24px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:10px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:72px}}.thumbnail{display:block;padding:4px;margin-bottom:22px;line-height:1.42857143;background-color:#f5f5f5;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#546d79}.thumbnail .caption{padding:9px;color:#8a959a}.alert{padding:15px;margin-bottom:22px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:400}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#00e5ce;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#00b2a0}.alert-info{color:#fff;background-color:#00e5ce;border-color:#007f72}.alert-info hr{border-top-color:#00665b}.alert-info .alert-link{color:#e6e6e6}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#fff;background-color:#ffa2b5;border-color:#ff3c64}.alert-danger hr{border-top-color:#ff2250}.alert-danger .alert-link{color:#e6e6e6}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:22px;margin-bottom:22px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:14px;line-height:22px;color:#fff;text-align:center;background-color:#00e5ce;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#00e5ce}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#faad44}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#ff5766}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#b0bec5;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#b0bec5}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#00e5ce;border-color:#00e5ce}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#b2fff7}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item-success{color:#00e5ce;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#00e5ce}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#00e5ce;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#00e5ce;border-color:#00e5ce}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#ff5766;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#ff5766}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#ff5766;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#ff5766;border-color:#ff5766}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:22px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:18px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:22px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#fbfbfb;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#fbfbfb;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#00e5ce}.panel-primary>.panel-heading{color:#fff;background-color:#00e5ce;border-color:#00e5ce}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#00e5ce}.panel-primary>.panel-heading .badge{color:#00e5ce;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#00e5ce}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#00e5ce;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#00e5ce}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#00e5ce}.panel-info>.panel-heading{color:#333;background-color:#fbfbfb;border-color:#00e5ce}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#00e5ce}.panel-info>.panel-heading .badge{color:#fbfbfb;background-color:#333}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#00e5ce}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#ff5766;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#ff5766}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:10px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:24px;font-weight:400;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid #00e5ce;border-radius:10px;box-shadow:0 3px 9px rgba(0,0,0,.5);outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade,.modal-backdrop.in{filter:alpha(opacity=0);opacity:0}.modal-header{padding:15px;border-bottom:1px solid #546d79}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #546d79}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;display:block;font-family:Josefin Sans;font-style:normal;font-weight:400;line-height:1.42857143;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:14px;filter:alpha(opacity=0);opacity:0}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#8a959a}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#8a959a}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#8a959a}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#8a959a}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#8a959a}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#8a959a}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#8a959a}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#8a959a;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:600px;padding:1px;font-family:Josefin Sans;font-style:normal;font-weight:400;line-height:1.42857143;line-break:auto;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;font-size:16px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid #00e5ce;border-radius:10px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-12px}.popover.right{margin-left:12px}.popover.bottom{margin-top:12px}.popover.left{margin-left:-12px}.popover>.arrow{border-width:13px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow:after{content:\"\";border-width:12px}.popover.top>.arrow{bottom:-13px;left:50%;margin-left:-13px;border-top-color:#999;border-top-color:#00e5ce;border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-12px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-13px;margin-top:-13px;border-right-color:#999;border-right-color:#00e5ce;border-left-width:0}.popover.right>.arrow:after{bottom:-12px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-13px;left:50%;margin-left:-13px;border-top-width:0;border-bottom-color:#999;border-bottom-color:#00e5ce}.popover.bottom>.arrow:after{top:1px;margin-left:-12px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-13px;margin-top:-13px;border-right-width:0;border-left-color:#999;border-left-color:#00e5ce}.popover.left>.arrow:after{right:1px;bottom:-12px;content:\" \";border-right-width:0;border-left-color:#fff}.popover-title{padding:8px 14px;margin:0;font-size:16px;background-color:#fff;border-bottom:1px solid #f2f2f2;border-radius:9px 9px 0 0}.popover-content{padding:9px 14px}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;outline:0;filter:alpha(opacity=90);opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}.alert .close:not(.sr-only){height:26px;width:26px;line-height:26px;border-radius:13px;font-weight:300;font-size:30px}.alert .close:not(.sr-only):hover{color:inherit}.alert .close:not(.sr-only) span{display:block;margin-top:-5px}.alert p{text-align:center;font-weight:400}.alert-danger .close:not(.sr-only){background:#ff3c64}.alert-info .close:not(.sr-only){background:#007f72}.breadcrumb{padding-left:0;padding-right:0}.breadcrumb:before{content:\"\";position:relative;display:inline-block;width:24px;height:24px;margin-right:5px;vertical-align:bottom;background-repeat:no-repeat;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAx5JREFUSA3VVEtIFWEU/uafmTt3fGRKxdW0wkclRGAPNCmMIqg2QQ/BWrUoSIhW0QsiDKpFiwjahOEuKHc9ILIUiUiyXUiF4iOjDEuzut7HvDr/vfd35l5nbO3Z/DP/Oef7zus/wGIXacEEenoURLRa5CtHIMl7wFAF25YhYQQWXsIxH8BYNoCamkQQTjDBx76NyFcvQ5b2Q5F1WDbgOGkcidwYA2zLgGl3IWpcw/ptr/1I/AlG+lugqzcR1soQjxNQBjgXgRPpYSAW/0kBXET55rvzTHIvMN5/CCGtA0wqhGHMU/teKDJlhzgRncaa+navTXYGg282oUB7DEUpg2F67f7/rSiAaU5j1jiM6vpu4UCFnBMJeugswmF/cId6YC+QkUkB6eFiaPI5DDwMCVSXYKyvlhq6D8mk0HlOBxuUMFoLS6HaBCSa7bFIfSZomBhrQl5pnVC5BFAOQFaKUtMitOIk0F16Me4sqcCVogpIPBM/Ej4MiqwhFD4mXKlwGWFsB42d+Ms+mYrbM19QJDG0FUTACOfCrzECm6uEa2/zcZa2iwuXAPZaODQNQSKruDo9moq8jUol0Ts4P/MZ9ABzPIjdwkpx6SkRDdpCQk3WCTQip2OasHgvghwkSiMtLgFzPoA/HF9xsJT2w72SapzKW44TVJ5bvyl6OTd67kwYqkTKtLgEptUN2f0VBqmTmny0MIIWvQQnCbz97wSBa/4ZcIxkslf4u4im9hSm9cM3KqagMzqJnVND6Ih+J3Cf5nJEvp8sKwqH3Z9PUFU3CMN+AtXTd2FFaU/ShPXGpmHRRAWKRsSm8xz9o++FjZsBvzFoKybiQwj5gKQ2qB95BooHFk98w2ziBpqb5+Y9m6CqYRAxo5Ue2xRCAWUQoXlPlQKy8QdJ6wzWNb71qrIJuKayoQuJWAtFM5xaxXxTBgmfIl3nmY8jaR7H6i2duaZBcwkM9pVDVy5R0w/Sdl1BzaMoM+PNm8nBDdqetvUISec6Krd+ygXn/8EEwvrru1VI2LuZzPYSfBNkKDDwCpL1DJL5AhWNw/R+Ap+cgFm85z/Cp/xUQmbshAAAAABJRU5ErkJggg==)}.btn{text-transform:uppercase}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:none}.btn.disabled,.btn:disabled{opacity:.5}.btn.disabled{cursor:pointer}.btn-default.active{background:#00e5ce;color:#fff}.btn-default.active:focus,.btn-default.active:hover{background:#00ccb7;border-color:#00c1ae;color:#fff}.btn-default p{margin:0;line-height:1}.btn-link{text-transform:none}.btn-link.active{font-weight:400;color:#00e5ce}.btn-link.active:focus,.btn-link.active:hover{color:#00c1ae}.btn-link p{margin:0;line-height:1}.btn-group-sm>.btn,.btn-sm{padding-top:8px}.btn-group-lg>.btn,.btn-lg{font-size:16px;font-weight:400}@media (min-width:768px){.btn-group-lg>.btn,.btn-lg{padding-left:32px;padding-right:32px}}.btn-toolbar{margin:20px 0;text-align:center}.btn-toolbar .btn{margin-left:10px;margin-right:10px;float:none}.btn-toolbar .btn:first-child{margin-left:0}.btn-toolbar .btn:last-child{margin-right:0}@media (min-width:768px){.btn-toolbar .btn-lg{margin-left:20px;margin-right:20px}}.btn-toolbar-sm{margin:0}.btn-group-justified>.btn{display:block;width:100%}.btn-group-justified>.btn+.btn{margin-left:0}.btn-group-justified>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-left-radius:0;border-bottom-right-radius:0}.btn-group-justified>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-left-radius:4px;border-bottom-right-radius:4px}@media (min-width:768px){.btn-group-justified>.btn{display:table-cell;width:1%}.btn-group-justified>.btn+.btn{margin-left:-1px}.btn-group-justified>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-left-radius:4px;border-top-right-radius:0;border-bottom-left-radius:4px;border-bottom-right-radius:0}.btn-group-justified>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:4px;border-bottom-left-radius:0;border-bottom-right-radius:4px}}.input-group-btn>.btn-group>.btn{height:36px;padding:0 9px;border-color:#ccc;background:#fff;font-weight:400;text-transform:none;color:#555}.has-error .input-group-btn>.btn,.has-error .input-group-btn>.btn-group>.btn{color:#ff5766;border-color:#ff5766;background-color:#f2dede}.control-label{font-size:14px;font-weight:400}.control-label:first-letter{text-transform:uppercase}.control-label i{font-size:16px;font-style:normal;color:#ff5766}@media (min-width:768px){.form-horizontal .control-label{text-align:left}}.input-group-addon{padding:0 9px;background:#fff}.input-group-btn:last-child>.btn{z-index:1}.input-group-btn>.btn{height:36px;padding:0 9px;border-color:#ccc;background:#fff}.checkbox label,.radio label{padding-left:0}.modal-content{border-radius:0}.modal-header{margin:0 20px;padding:20px 0 15px}h4.modal-title{font-size:26px;text-align:center}.modal-body h5,h4.modal-title{font-weight:400;text-transform:uppercase}.modal-body h5{margin:20px 0}.modal-danger .modal-content,.modal-danger .modal-header{border-color:#ff5766}.modal-danger h4.modal-title{color:#ff5766}.modal-fullscreen{width:100%;height:100%;margin:0;padding:10px}.modal-fullscreen .modal-content{height:100%}.modal-fullscreen .modal-body{height:100%;overflow-x:hidden;overflow-y:auto}.nav-cursors{border-bottom:1px solid #dadada}.nav-cursors.nav-justified>li{display:table-cell;float:none;width:1%;text-align:center}.nav-cursors.nav-justified>li>a{display:inline-block;margin-left:0;margin-right:0}.nav-cursors>li{position:relative;display:block;float:left;white-space:nowrap}.nav-cursors>li.active>a{border-bottom:4px solid #00e5ce}.nav-cursors>li>a{position:relative;display:block;margin:0 15px -3px;padding:5px 0;font-size:26px;color:#546d79}.nav-cursors>li>a:hover{background:none}.nav-cursors>li>a:focus{background:none;outline:0}.nav-progress{margin:0 0 38px -2px}.nav-progress.nav-justified{display:table;table-layout:fixed;border-collapse:separate;border-spacing:2px}.nav-progress.nav-justified:after,.nav-progress.nav-justified:before{content:none}.nav-progress.nav-justified>li{display:table-cell;float:none;width:1%;margin-left:0}.nav-progress.nav-justified>li.active>a{margin-left:-17px}.nav-progress.nav-justified>li>a{float:left;left:50%;margin-left:-14px;margin-right:0}.nav-progress>li{float:left;margin-left:2px;border-bottom:8px solid #dadada;text-align:center}.nav-progress>li.nav-success,.nav-progress>li.nav-success>a{border-color:#00e5ce}.nav-progress>li.disabled{opacity:.2}.nav-progress>li.disabled>a{color:#8a959a}.nav-progress>li.disabled>a:focus,.nav-progress>li.disabled>a:hover{background:#f5f5f5;cursor:default}.nav-progress>li.active{border-color:#ff5766}.nav-progress>li.active>a{min-width:34px;margin-bottom:-21px;padding:5px 5px 3px;border-color:#f5f5f5;border-radius:17px;background:#ff5766;color:#fff}.nav-progress>li>a{min-width:28px;margin:0 15px -18px;padding:2px 2px 0;border:3px solid #dadada;border-radius:14px;background:#f5f5f5;font-size:14px;font-weight:400;color:#546d79}.nav-list{margin-top:30px;border-top:1px solid #dadada;border-bottom:1px solid #dadada;background:#fff}.nav-list>li:first-child>a{border-top:0}@media (min-width:768px){.nav-list>li:first-child>a{border-left:0}}.nav-list>li.disabled:hover{background:none}.nav-list>li.disabled>a:hover{cursor:default}.nav-list>li.active{background:#fbfbfb}.nav-list>li.active>a{font-weight:400}.nav-list>li.open>a,.nav-list>li.open>a:focus,.nav-list>li.open>a:hover{background:none}.nav-list>li:hover{background:#fbfbfb}.nav-list>li>a{display:block;margin:0 20px;padding:10px 0;border-top:1px solid #546d79;font-size:16px;line-height:1;text-transform:uppercase;color:#546d79}.nav-list>li>a:focus,.nav-list>li>a:hover{background:none;outline:0}@media (min-width:768px){.nav-list>li>a{margin:10px 0;padding:0 20px;border-top:0;border-left:1px solid #546d79}}.nav-list .dropdown-menu{margin:0}.nav-list .dropdown-menu>li.active>a{background:#fbfbfb;font-weight:400;color:#546d79}.nav-list .dropdown-menu>li>a{font-weight:300;text-transform:uppercase}.nav-list .dropdown-menu>li>a:focus,.nav-list .dropdown-menu>li>a:hover{background:#fbfbfb}.navbar-jumbo{margin-bottom:0;background-color:#fff;border-color:#dadada}.navbar-jumbo .navbar-brand{padding-top:8px;padding-bottom:8px}.navbar-jumbo .navbar-brand img{max-height:100%}@media (min-width:768px){.navbar-jumbo .navbar-brand{height:auto;padding-top:20px;padding-bottom:10px}}.navbar-jumbo .navbar-toggle{border-color:#dadada}.navbar-jumbo .navbar-toggle .icon-bar{background:#546d79}.navbar-jumbo .navbar-nav{overflow:hidden;float:none;margin-top:0;margin-bottom:0}.navbar-jumbo .navbar-nav>li>a{font-size:20px;font-weight:400;color:#546d79}.navbar-jumbo .navbar-nav>li>a i{vertical-align:middle}.navbar-jumbo .navbar-nav>li>a span{margin-left:20px}@media (min-width:768px){.navbar-jumbo .navbar-nav>li>a span{display:block;margin-left:0}}@media (min-width:768px){.navbar-jumbo .navbar-nav>li>a{text-align:center;padding-top:20px;padding-bottom:20px}}@media (min-width:768px){.navbar-jumbo .navbar-nav>li{float:none;display:table-cell;width:1%}}.pagination{text-align:center}.pagination>li.active>a{border-radius:18px}.pagination>li>a{min-width:36px;font-weight:400}.panel-heading{padding:15px;border-radius:0}.panel-default{box-shadow:none}.panel-default>.panel-heading{border:0;color:#8a959a}.panel-default>.panel-heading h5{margin:0}.panel-group{margin-top:22px}.panel-group .panel{margin-bottom:30px;border-radius:0}.panel-group .panel-heading+.panel-collapse>.panel-body,.panel-pageheader{border:0}.panel-pageheader>.panel-heading{background:#f5f5f5;padding:5px 0}.panel-pageheader>.panel-heading a{text-decoration:none}.panel-pageheader .panel-body{padding:10px;border:1px solid #dadada}.panel-group .panel-pageheader{margin-bottom:0}.panel-header{border:0}.panel-header>.panel-heading{padding:15px 15px 15px 30px;border:1px solid #dadada;color:#546d79}.panel-header .panel-title{font-size:16px}.panel-header .panel-body{padding:30px 0 30px 30px;background:none}.panel-input .panel-heading{height:36px;padding:6px 12px;background:#fff}.panel-input .panel-heading input,.panel-input .panel-heading select{display:block;width:100%;height:36px;margin:-6px -12px;padding:6px 12px;background:transparent;border:0}.panel-input .panel-title{font-size:16px}.panel-input .panel-title a{text-decoration:none}.panel-input .panel-footer{background:#fff;text-align:right}.panel-input .panel-heading+.panel-collapse>.panel-body{border-top:0}.panel-group .panel-input+.panel-input{margin-top:15px}.popover{border-radius:0}h3.popover-title{margin:0 10px;padding:20px 0 15px;border-bottom:1px solid #546d79;font-size:26px;font-weight:400;text-transform:uppercase;text-align:center}.popover-content{padding:15px}.popover-content h5{margin:20px 0;text-transform:uppercase;font-weight:400}.popover.popover-md{width:100%;max-width:100%}@media (min-width:992px){.popover.popover-md{width:600px;max-width:600px}}.popover.popover-lg{width:100%;max-width:100%}@media (min-width:992px){.popover.popover-lg{width:900px;max-width:900px}}.tooltip{z-index:1070}.tooltip-primary.bottom .tooltip-arrow{border-bottom-color:#00e5ce}.tooltip-primary.left .tooltip-arrow{border-left-color:#00e5ce}.tooltip-primary .tooltip-inner{background-color:#00e5ce}.tooltip-success.bottom .tooltip-arrow{border-bottom-color:#00e5ce}.tooltip-success.left .tooltip-arrow{border-left-color:#00e5ce}.tooltip-success .tooltip-inner{background-color:#00e5ce}.tooltip-warning.bottom .tooltip-arrow{border-bottom-color:#faad44}.tooltip-warning.left .tooltip-arrow{border-left-color:#faad44}.tooltip-warning .tooltip-inner{background-color:#faad44}.tooltip-danger.bottom .tooltip-arrow{border-bottom-color:#ff5766}.tooltip-danger.left .tooltip-arrow{border-left-color:#ff5766}.tooltip-danger .tooltip-inner{background-color:#ff5766}.tooltip-disabled.bottom .tooltip-arrow{border-bottom-color:#dadada}.tooltip-disabled.left .tooltip-arrow{border-left-color:#dadada}.tooltip-disabled .tooltip-inner{background-color:#dadada}.page-header{margin:20px 0;padding-bottom:5px;border-color:#546d79}.page-header h1{margin:0;font-size:16px;text-transform:uppercase}.page-header.large{margin-top:20px;padding-bottom:10px;border-color:#dadada}.page-header.large h1{font-size:26px;font-weight:400;text-align:center}.DayPicker{display:inline-block;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker:focus{outline:none}.DayPicker-Month{display:table;border-collapse:collapse;border-spacing:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-NavBar{position:absolute;left:0;right:0}.DayPicker-NavButton{position:absolute;width:20px;height:20px;background-repeat:no-repeat;background-position:50%;background-size:contain;cursor:pointer}.DayPicker-NavButton--prev{left:4px;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wcmV2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9InByZXYiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjM5MzE5MywgMjUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMy4zOTMxOTMsIC0yNS4wMDAwMDApIHRyYW5zbGF0ZSgwLjg5MzE5MywgMC4wMDAwMDApIiBmaWxsPSIjNTY1QTVDIj4KICAgICAgICAgICAgPHBhdGggZD0iTTAsNDkuMTIzNzMzMSBMMCw0NS4zNjc0MzQ1IEwyMC4xMzE4NDU5LDI0LjcyMzA2MTIgTDAsNC4yMzEzODMxNCBMMCwwLjQ3NTA4NDQ1OSBMMjUsMjQuNzIzMDYxMiBMMCw0OS4xMjM3MzMxIEwwLDQ5LjEyMzczMzEgWiIgaWQ9InJpZ2h0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K\")}.DayPicker-NavButton--next{right:4px;background-image:url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5uZXh0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9Im5leHQiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTUxNDUxLCAwLjAwMDAwMCkiIGZpbGw9IiM1NjVBNUMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMCw0OS4xMjM3MzMxIEwwLDQ1LjM2NzQzNDUgTDIwLjEzMTg0NTksMjQuNzIzMDYxMiBMMCw0LjIzMTM4MzE0IEwwLDAuNDc1MDg0NDU5IEwyNSwyNC43MjMwNjEyIEwwLDQ5LjEyMzczMzEgTDAsNDkuMTIzNzMzMSBaIiBpZD0icmlnaHQiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=\")}.DayPicker-Caption{display:table-caption;padding:2px;text-align:center;font-weight:400;color:#546d79}.DayPicker-Weekdays{display:table-header-group}.DayPicker-WeekdaysRow{display:table-row}.DayPicker-Weekday{display:table-cell;padding:4px;text-align:center;font-weight:400;color:#546d79}.DayPicker-Weekday abbr{border:0}.DayPicker-Body{display:table-row-group;border-top:1px solid #d6dde1;border-bottom:1px solid #d6dde1}.DayPicker-Week{display:table-row}.DayPicker-Day{display:table-cell;border-left:1px solid #d6dde1;border-right:1px solid #d6dde1;text-align:center;cursor:pointer;vertical-align:middle}.DayPicker-Day:focus{outline:none}.DayPicker-Day span{display:block;position:relative;margin:4px -1px;height:24px;min-width:34px}.DayPicker--interactionDisabled .DayPicker-Day{cursor:default}.DayPicker-Day--today{font-weight:400;color:#00e5ce}.DayPicker-Day--disabled,.DayPicker-Day--outside{cursor:default;color:#b0bec5}.DayPicker-Day--selected{color:#fff}.DayPicker-Day--selected span{border:1px solid #fff;background:#00e5ce;border-radius:14px}.DayPicker-Day--from{color:#fff}.DayPicker-Day--from span{border:1px solid #fff;background:#00e5ce;border-top-left-radius:14px;border-bottom-left-radius:14px}.DayPicker-Day--to{color:#fff}.DayPicker-Day--to span{border:1px solid #fff;background:#00e5ce;border-top-right-radius:14px;border-bottom-right-radius:14px}.DayPicker-Day--range{color:#fff}.DayPicker-Day--range span{border:1px solid #fff;background:#00e5ce}body,html{height:100%;font-weight:300}body>#root,html>#root{position:relative;min-height:100%;padding-bottom:80px}hr{border-color:#d6dde1}h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{font-weight:300}b,strong{font-weight:400}button,input,optgroup,select,textarea{font-weight:300}input[type=checkbox],input[type=radio]{display:none}input[type=checkbox]:disabled+span,input[type=radio]:disabled+span{opacity:.5;cursor:not-allowed}input[type=checkbox]+span:before,input[type=radio]+span:before{content:\"\";display:inline-block;width:24px;height:24px;margin:0 10px 0 0;vertical-align:middle;background-image:url(" + __webpack_require__(1139) + ");background-repeat:no-repeat;cursor:pointer}input[type=checkbox]:checked+span:before{background-position:-144px -216px}input[type=checkbox]+span:before{background-position:-120px -216px}input[type=radio]:checked+span:before{background-position:-504px -216px}input[type=radio]+span:before{background-position:-480px -216px}a:focus,button:focus{outline:0}form{margin-top:15px}@media (min-width:768px){.no-gutter [class*=col-]{padding-left:0;padding-right:0}.no-gutter [class*=col-]:first-child{padding-left:15px}.no-gutter [class*=col-]:last-child{padding-right:15px}}", ""]);
	
	// exports


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AppFooter-default-yythP{position:absolute;bottom:0;left:0;right:0;margin-top:20px;border-top:1px solid #dadada;background:#fff;text-align:center}.AppFooter-default-yythP a{display:inline-block;color:#b0bec5}.AppFooter-container-1s01E a{padding:10px 0}.AppFooter-side-gvFW7{float:right}.AppFooter-side-gvFW7 a{padding:20px 0 20px 10px}", ""]);
	
	// exports
	exports.locals = {
		"default": "AppFooter-default-yythP",
		"container": "AppFooter-container-1s01E",
		"side": "AppFooter-side-gvFW7"
	};

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AppToolbar-default-cNGQ7{position:fixed;bottom:100px;right:20px;z-index:1000}.AppToolbar-default-cNGQ7 button{width:60px;height:60px;border-radius:30px;padding:0}", ""]);
	
	// exports
	exports.locals = {
		"default": "AppToolbar-default-cNGQ7"
	};

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".StatusAlert-default-taq6v{overflow:hidden}.StatusAlert-default-taq6v.StatusAlert-enter-1ufTl.StatusAlert-enterActive-VLN9s .StatusAlert-content-2OL6N{top:0;transition:top .5s ease}.StatusAlert-default-taq6v.StatusAlert-enter-1ufTl.StatusAlert-enterActive-VLN9s .StatusAlert-spacer-oIA6K{height:53px;transition:height .5s ease}.StatusAlert-default-taq6v.StatusAlert-enter-1ufTl .StatusAlert-content-2OL6N{top:-53px}.StatusAlert-default-taq6v.StatusAlert-enter-1ufTl .StatusAlert-spacer-oIA6K{height:0}.StatusAlert-default-taq6v.StatusAlert-leave-6YS1m.StatusAlert-leaveActive-1RpDc .StatusAlert-content-2OL6N{top:-53px;transition:top .5s ease}.StatusAlert-default-taq6v.StatusAlert-leave-6YS1m.StatusAlert-leaveActive-1RpDc .StatusAlert-spacer-oIA6K{height:0;transition:height .5s ease}.StatusAlert-default-taq6v.StatusAlert-leave-6YS1m .StatusAlert-content-2OL6N{top:0}.StatusAlert-default-taq6v.StatusAlert-leave-6YS1m .StatusAlert-spacer-oIA6K{height:53px}.StatusAlert-default-taq6v .alert{border-top:0;border-radius:0 0 10px 10px}.StatusAlert-content-2OL6N{position:fixed;top:0;right:0;left:0;height:53px;z-index:10000;opacity:.95}.StatusAlert-spacer-oIA6K{height:53px}", ""]);
	
	// exports
	exports.locals = {
		"default": "StatusAlert-default-taq6v",
		"enter": "StatusAlert-enter-1ufTl",
		"enterActive": "StatusAlert-enterActive-VLN9s",
		"content": "StatusAlert-content-2OL6N",
		"spacer": "StatusAlert-spacer-oIA6K",
		"leave": "StatusAlert-leave-6YS1m",
		"leaveActive": "StatusAlert-leaveActive-1RpDc"
	};

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReportCard-score-213wz h5{height:36px;line-height:36px}.ReportCard-pdf-3kNgF{text-align:right}", ""]);
	
	// exports
	exports.locals = {
		"score": "ReportCard-score-213wz",
		"pdf": "ReportCard-pdf-3kNgF"
	};

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AnswerTicketClaimCard-defaultContent-1e3gx h5{text-transform:none}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "AnswerTicketClaimCard-defaultContent-1e3gx"
	};

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpenTicketClaimCard-defaultContent-3v3PU h5{text-transform:none}.OpenTicketClaimCard-defaultContent-3v3PU label small{display:block;margin-left:34px;font-size:14px;font-weight:300}.OpenTicketClaimCard-externaCallDateTimePicker-2gnt5{margin-top:10px;text-align:center}.OpenTicketClaimCard-externaCallDateTimePicker-2gnt5 .OpenTicketClaimCard-container-1X1ku{display:inline-block}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "OpenTicketClaimCard-defaultContent-3v3PU",
		"externaCallDateTimePicker": "OpenTicketClaimCard-externaCallDateTimePicker-2gnt5",
		"container": "OpenTicketClaimCard-container-1X1ku"
	};

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".QualifyTicketClaimCard-defaultContent-1UyX8 h5{text-transform:none}.QualifyTicketClaimCard-defaultContent-1UyX8 label small{display:block;margin-left:34px;font-size:14px;font-weight:300}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "QualifyTicketClaimCard-defaultContent-1UyX8"
	};

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".capitalize{display:inline-block}.capitalize:first-letter{text-transform:uppercase}.TicketClaimCard-ticket-3XXzT h5{overflow:hidden;height:36px;line-height:36px;white-space:nowrap;text-overflow:ellipsis}.TicketClaimCard-state-2p1Tc{overflow:hidden}.TicketClaimCard-state-2p1Tc h5{overflow:hidden;height:36px;line-height:36px;white-space:nowrap;text-overflow:ellipsis}.TicketClaimCard-state-2p1Tc h5 small{display:inline-block}.TicketClaimCard-state-2p1Tc h5 small:first-letter{text-transform:uppercase}.TicketClaimCard-actor-15yD5{padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}@media (min-width:768px){.TicketClaimCard-actor-15yD5{margin-bottom:-500px;padding-bottom:500px}}.TicketClaimCard-priority-3qHon{border-top:1px solid #d6dde1}.TicketClaimCard-priorityContent-qVEE6{margin:10px 0;padding:0 12px}", ""]);
	
	// exports
	exports.locals = {
		"ticket": "TicketClaimCard-ticket-3XXzT",
		"state": "TicketClaimCard-state-2p1Tc",
		"actor": "TicketClaimCard-actor-15yD5",
		"priority": "TicketClaimCard-priority-3qHon",
		"priorityContent": "TicketClaimCard-priorityContent-qVEE6"
	};

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketClaimCountCard-default-2ir-3 p{margin:0;padding:10px;text-transform:uppercase;color:#546d79;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "TicketClaimCountCard-default-2ir-3"
	};

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketClaimDetail-default-2vZV7 h3>a:hover{text-decoration:none}.TicketClaimDetail-default-2vZV7 h5 small{text-transform:uppercase}.TicketClaimDetail-default-2vZV7 .TicketClaimDetail-urgencyLevel-Nlw6k{margin-top:20px}.TicketClaimDetail-step-3tqP3{margin:-5px -10px;padding:5px 10px}.TicketClaimDetail-description-1QB4m{font-weight:400}.TicketClaimDetail-description-1QB4m label{display:block;text-transform:uppercase;color:#546d79}.TicketClaimDetail-company-34Wto p{margin:0;padding:10px;text-transform:uppercase;color:#546d79;text-align:center}.TicketClaimDetail-urgencyLevel-Nlw6k.TicketClaimDetail-success-1y1ir strong{color:#00e5ce}.TicketClaimDetail-urgencyLevel-Nlw6k.TicketClaimDetail-warning-19MOx strong{color:#faad44}.TicketClaimDetail-urgencyLevel-Nlw6k.TicketClaimDetail-danger-17VSH strong{color:#ff5766}.TicketClaimDetail-metricGroup-88qg1{text-align:center}.TicketClaimDetail-metric-16i-M{display:inline-block;position:relative;height:100px;width:150px;padding:10px 0;border-radius:10px;background:#f5f5f5;text-align:center;font-weight:400;color:#546d79}.TicketClaimDetail-metric-16i-M.TicketClaimDetail-warning-19MOx .TicketClaimDetail-data-3MQCU{background:#faad44}.TicketClaimDetail-metric-16i-M.TicketClaimDetail-danger-17VSH .TicketClaimDetail-data-3MQCU{background:#ff5766}.TicketClaimDetail-metric-16i-M .TicketClaimDetail-data-3MQCU{position:absolute;left:10px;right:10px;bottom:0;height:65px;line-height:20px;padding:20px 20px 5px;border-radius:65px 65px 0 0;background:#00e5ce;font-size:16px;color:#fff}.TicketClaimDetail-metric-16i-M p{margin:0 0 5px}.TicketClaimDetail-entity-3RVty{margin-top:20px;padding:20px;background:#f5f5f5;text-align:center}.TicketClaimDetail-entity-3RVty p{margin:0;text-transform:uppercase}.TicketClaimDetail-challengeGroup-1HdIJ.TicketClaimDetail-answer-3gjt2{margin-left:50px}.TicketClaimDetail-challengeGroup-1HdIJ.TicketClaimDetail-form-3pHOE ul>li .TicketClaimDetail-time-2iH7E{padding-top:6px}.TicketClaimDetail-challengeGroup-1HdIJ.TicketClaimDetail-form-3pHOE ul>li .TicketClaimDetail-container-3_Bjf{padding-left:0;border-left:0}.TicketClaimDetail-challengeGroup-1HdIJ.TicketClaimDetail-form-3pHOE ul>li .TicketClaimDetail-container-3_Bjf form{margin:0}.TicketClaimDetail-challengeGroup-1HdIJ h5{font-weight:400}.TicketClaimDetail-challengeGroup-1HdIJ ul{margin:0;padding:0;list-style-type:none}.TicketClaimDetail-challengeGroup-1HdIJ ul>li{overflow:hidden;display:block;margin:10px 0}.TicketClaimDetail-challengeGroup-1HdIJ ul>li .TicketClaimDetail-time-2iH7E{float:left;min-width:160px;margin-right:10px}.TicketClaimDetail-challengeGroup-1HdIJ ul>li .TicketClaimDetail-container-3_Bjf{overflow:hidden;padding-left:12px;border-left:1px solid #dadada;line-height:24px}.TicketClaimDetail-challengeGroup-1HdIJ ul>li .TicketClaimDetail-container-3_Bjf p{margin:0;padding:0}.TicketClaimDetail-ticketHeader-2_Ui4{margin-bottom:-21px}.TicketClaimDetail-ticketHeader-2_Ui4>div{background:#fbfbfb}", ""]);
	
	// exports
	exports.locals = {
		"default": "TicketClaimDetail-default-2vZV7",
		"urgencyLevel": "TicketClaimDetail-urgencyLevel-Nlw6k",
		"step": "TicketClaimDetail-step-3tqP3",
		"description": "TicketClaimDetail-description-1QB4m",
		"company": "TicketClaimDetail-company-34Wto",
		"success": "TicketClaimDetail-success-1y1ir",
		"warning": "TicketClaimDetail-warning-19MOx",
		"danger": "TicketClaimDetail-danger-17VSH",
		"metricGroup": "TicketClaimDetail-metricGroup-88qg1",
		"metric": "TicketClaimDetail-metric-16i-M",
		"data": "TicketClaimDetail-data-3MQCU",
		"entity": "TicketClaimDetail-entity-3RVty",
		"challengeGroup": "TicketClaimDetail-challengeGroup-1HdIJ",
		"answer": "TicketClaimDetail-answer-3gjt2",
		"form": "TicketClaimDetail-form-3pHOE",
		"time": "TicketClaimDetail-time-2iH7E",
		"container": "TicketClaimDetail-container-3_Bjf",
		"ticketHeader": "TicketClaimDetail-ticketHeader-2_Ui4"
	};

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketClaimStream-pagination-2TO8m{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "TicketClaimStream-pagination-2TO8m"
	};

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AgencyCard-label-1YkJj{padding:10px 0}.AgencyCard-address-3zG_7{min-height:67px;padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}.AgencyCard-address-3zG_7>div{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports
	exports.locals = {
		"label": "AgencyCard-label-1YkJj",
		"address": "AgencyCard-address-3zG_7"
	};

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".data{margin:0;padding:0;list-style-type:none}.data>li{margin:5px 0}.data>li label{font-weight:400;color:#546d79}.AgencyDashboard-data-5Ln9F{margin:0;padding:0;list-style-type:none}.AgencyDashboard-data-5Ln9F>li{margin:5px 0}.AgencyDashboard-data-5Ln9F>li label{font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"data": "AgencyDashboard-data-5Ln9F"
	};

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.header{position:relative}.header:after{display:block;content:\" \";clear:both}.header .edit{display:block;float:right;line-height:24px}.headerContent{margin-right:24px}.headerContent .container{position:relative;display:inline-block;padding-right:36px}.headerContent .container .billingType{position:absolute;width:36px;height:36px;top:-5px;right:0;padding:5px}.headerContent .container .billingType div{width:26px;height:26px;line-height:29px;text-align:center;border-radius:100%;color:#fff;font-weight:700}.headerContent .container .billingType .StandardAccount{background-color:#b0252e}.headerContent .container .billingType .PremiumAccount{background-color:#00e5ce}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.metric{display:table-cell;width:1%}.metric i{margin-left:5px}.AgencyDetail-headerContent-2tehb{margin-right:24px}.AgencyDetail-headerContent-2tehb .AgencyDetail-container-37M31{position:relative;display:inline-block;padding-right:36px}.AgencyDetail-headerContent-2tehb .AgencyDetail-container-37M31 .AgencyDetail-billingType-Zs8sG{position:absolute;width:36px;height:36px;top:-5px;right:0;padding:5px}.AgencyDetail-headerContent-2tehb .AgencyDetail-container-37M31 .AgencyDetail-billingType-Zs8sG div{width:26px;height:26px;line-height:29px;text-align:center;border-radius:100%;color:#fff;font-weight:700}.AgencyDetail-headerContent-2tehb .AgencyDetail-container-37M31 .AgencyDetail-billingType-Zs8sG .AgencyDetail-StandardAccount-S84fv{background-color:#b0252e}.AgencyDetail-headerContent-2tehb .AgencyDetail-container-37M31 .AgencyDetail-billingType-Zs8sG .AgencyDetail-PremiumAccount-1oivJ{background-color:#00e5ce}.AgencyDetail-defaultContent-3cUs-{margin-bottom:20px}.AgencyDetail-header-3vRBy{position:relative}.AgencyDetail-header-3vRBy:after{display:block;content:\" \";clear:both}.AgencyDetail-header-3vRBy .AgencyDetail-edit-17IM_{display:block;float:right;line-height:24px}.AgencyDetail-header-3vRBy .AgencyDetail-report-31ozz{position:relative;display:inline-block;margin-left:20px}.AgencyDetail-header-3vRBy .AgencyDetail-report-31ozz .AgencyDetail-container-37M31{position:absolute;top:-40px}.AgencyDetail-menu-BLETs{margin:0;padding:0;list-style-type:none}.AgencyDetail-menu-BLETs>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.AgencyDetail-menu-BLETs>li:first-child{border-top:0}.AgencyDetail-menu-BLETs>li a:hover{text-decoration:none}.AgencyDetail-metric-25I_y{display:table-cell;width:1%}.AgencyDetail-metric-25I_y i{margin-left:5px}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "AgencyDetail-defaultContent-3cUs-",
		"header": "AgencyDetail-header-3vRBy",
		"edit": "AgencyDetail-edit-17IM_",
		"headerContent": "AgencyDetail-headerContent-2tehb",
		"container": "AgencyDetail-container-37M31",
		"billingType": "AgencyDetail-billingType-Zs8sG",
		"StandardAccount": "AgencyDetail-StandardAccount-S84fv",
		"PremiumAccount": "AgencyDetail-PremiumAccount-1oivJ",
		"menu": "AgencyDetail-menu-BLETs",
		"metric": "AgencyDetail-metric-25I_y",
		"report": "AgencyDetail-report-31ozz"
	};

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AgencySearch-default-1uu3L{overflow:hidden;margin-bottom:10px}.AgencySearch-side-1msmr{float:right}", ""]);
	
	// exports
	exports.locals = {
		"default": "AgencySearch-default-1uu3L",
		"side": "AgencySearch-side-1msmr"
	};

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AgencyStream-pagination-10HCv{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "AgencyStream-pagination-10HCv"
	};

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AssociateDissociateUserFromAgencyModal-agencyGroup-2Dg9P{margin:10px 0;padding:0;list-style-type:none}.AssociateDissociateUserFromAgencyModal-agencyGroup-2Dg9P>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.AssociateDissociateUserFromAgencyModal-agencyGroup-2Dg9P>li .AssociateDissociateUserFromAgencyModal-dissociate-1u5vz{display:block;float:right}.AssociateDissociateUserFromAgencyModal-agencyGroup-2Dg9P>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"agencyGroup": "AssociateDissociateUserFromAgencyModal-agencyGroup-2Dg9P",
		"dissociate": "AssociateDissociateUserFromAgencyModal-dissociate-1u5vz"
	};

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CompanyCard-billingType-3rvHW{position:absolute;width:36px;height:36px;top:0;right:0;padding:5px}.CompanyCard-billingType-3rvHW div{width:26px;height:26px;line-height:29px;text-align:center;border-radius:100%;color:#fff;font-weight:700}.CompanyCard-billingType-3rvHW .CompanyCard-StandardAccount-2q-AL{background-color:#b0252e}.CompanyCard-billingType-3rvHW .CompanyCard-PremiumAccount-3cSy1{background-color:#00e5ce}.CompanyCard-label-DNLXx{padding:10px 0}.CompanyCard-label-DNLXx h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.CompanyCard-status-2l96z{float:right}", ""]);
	
	// exports
	exports.locals = {
		"billingType": "CompanyCard-billingType-3rvHW",
		"StandardAccount": "CompanyCard-StandardAccount-2q-AL",
		"PremiumAccount": "CompanyCard-PremiumAccount-3cSy1",
		"label": "CompanyCard-label-DNLXx",
		"status": "CompanyCard-status-2l96z"
	};

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CompanyConfigsPopover-defaultContent-UtDo2 .checkbox label{font-weight:300}.CompanyConfigsPopover-info-2nDBS{display:inline-block;float:right;min-width:22px;padding:4px 0 2px;border:1px solid #00e5ce;border-radius:11px;line-height:1;text-align:center;font-size:14px;font-weight:400;color:#00e5ce}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "CompanyConfigsPopover-defaultContent-UtDo2",
		"info": "CompanyConfigsPopover-info-2nDBS"
	};

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".data{margin:0;padding:0;list-style-type:none}.data>li{margin:5px 0}.data>li label{font-weight:400;color:#546d79}.CompanyDashboard-data-2YCCS{margin:0;padding:0;list-style-type:none}.CompanyDashboard-data-2YCCS>li{margin:5px 0}.CompanyDashboard-data-2YCCS>li label{font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"data": "CompanyDashboard-data-2YCCS"
	};

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.header{position:relative}.header:after{display:block;content:\" \";clear:both}.header .edit{display:block;float:right;line-height:24px}.headerContent{margin-right:24px}.headerContent .container{position:relative;display:inline-block;padding-right:36px}.headerContent .container .billingType{position:absolute;width:36px;height:36px;top:-5px;right:0;padding:5px}.headerContent .container .billingType div{width:26px;height:26px;line-height:29px;text-align:center;border-radius:100%;color:#fff;font-weight:700}.headerContent .container .billingType .StandardAccount{background-color:#b0252e}.headerContent .container .billingType .PremiumAccount{background-color:#00e5ce}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.metric{display:table-cell;width:1%}.metric i{margin-left:5px}.CompanyDetail-defaultContent-pHwSp{margin-bottom:20px}.CompanyDetail-header-2TS3A{position:relative}.CompanyDetail-header-2TS3A:after{display:block;content:\" \";clear:both}.CompanyDetail-header-2TS3A .CompanyDetail-edit-11XTr{display:block;float:right;line-height:24px}.CompanyDetail-headerContent-2_4mA{margin-right:24px}.CompanyDetail-headerContent-2_4mA .CompanyDetail-container-13nn0{position:relative;display:inline-block;padding-right:36px}.CompanyDetail-headerContent-2_4mA .CompanyDetail-container-13nn0 .CompanyDetail-billingType-1h-tQ{position:absolute;width:36px;height:36px;top:-5px;right:0;padding:5px}.CompanyDetail-headerContent-2_4mA .CompanyDetail-container-13nn0 .CompanyDetail-billingType-1h-tQ div{width:26px;height:26px;line-height:29px;text-align:center;border-radius:100%;color:#fff;font-weight:700}.CompanyDetail-headerContent-2_4mA .CompanyDetail-container-13nn0 .CompanyDetail-billingType-1h-tQ .CompanyDetail-StandardAccount-32-tm{background-color:#b0252e}.CompanyDetail-headerContent-2_4mA .CompanyDetail-container-13nn0 .CompanyDetail-billingType-1h-tQ .CompanyDetail-PremiumAccount-JIEir{background-color:#00e5ce}.CompanyDetail-menu-3MaiR{margin:0;padding:0;list-style-type:none}.CompanyDetail-menu-3MaiR>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.CompanyDetail-menu-3MaiR>li:first-child{border-top:0}.CompanyDetail-menu-3MaiR>li a:hover{text-decoration:none}.CompanyDetail-metric-1vE1R{display:table-cell;width:1%}.CompanyDetail-metric-1vE1R i{margin-left:5px}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "CompanyDetail-defaultContent-pHwSp",
		"header": "CompanyDetail-header-2TS3A",
		"edit": "CompanyDetail-edit-11XTr",
		"headerContent": "CompanyDetail-headerContent-2_4mA",
		"container": "CompanyDetail-container-13nn0",
		"billingType": "CompanyDetail-billingType-1h-tQ",
		"StandardAccount": "CompanyDetail-StandardAccount-32-tm",
		"PremiumAccount": "CompanyDetail-PremiumAccount-JIEir",
		"menu": "CompanyDetail-menu-3MaiR",
		"metric": "CompanyDetail-metric-1vE1R"
	};

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CompanyPicker-search-1wQsX{overflow:hidden;padding:10px;border-bottom:1px solid #dadada}.CompanyPicker-search-1wQsX .CompanyPicker-container-1F7jR{overflow:hidden}.CompanyPicker-search-1wQsX .CompanyPicker-container-1F7jR input{height:24px;width:100%;border:0;background:transparent;font-size:14px;font-weight:400;line-height:14px;text-transform:uppercase;text-align:center;color:#b0bec5}.CompanyPicker-search-1wQsX .CompanyPicker-container-1F7jR input:-ms-input-placeholder{color:#b0bec5}.CompanyPicker-search-1wQsX .CompanyPicker-container-1F7jR input::placeholder{color:#b0bec5}.CompanyPicker-search-1wQsX .CompanyPicker-container-1F7jR input:focus{outline:0}.CompanyPicker-search-1wQsX a{display:none}@media (min-width:768px){.CompanyPicker-search-1wQsX a{display:block;float:right}}", ""]);
	
	// exports
	exports.locals = {
		"search": "CompanyPicker-search-1wQsX",
		"container": "CompanyPicker-container-1F7jR"
	};

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CompanyStats-default-jkCrt{margin-bottom:20px;color:#546d79}.CompanyStats-default-jkCrt h3,.CompanyStats-default-jkCrt h4{text-transform:uppercase;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "CompanyStats-default-jkCrt"
	};

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CompanyStream-pagination-3BX_o{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "CompanyStream-pagination-3BX_o"
	};

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DeleteAgencyModal-text-1_yck{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "DeleteAgencyModal-text-1_yck"
	};

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DisableUserModal-text-2rP4S{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "DisableUserModal-text-2rP4S"
	};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OrganisationLayout-default-2H42w{margin-top:20px}", ""]);
	
	// exports
	exports.locals = {
		"default": "OrganisationLayout-default-2H42w"
	};

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReactiveCancelCompanyModal-text-K0O4H{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "ReactiveCancelCompanyModal-text-K0O4H"
	};

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReferenceCompanyModal-companyCmdType-3KmIw{overflow:hidden;margin:20px 0}.ReferenceCompanyModal-companyCmdType-3KmIw .ReferenceCompanyModal-container-219TN{margin:0;padding:0;list-style-type:none}.ReferenceCompanyModal-companyCmdType-3KmIw .ReferenceCompanyModal-container-219TN>li{display:table-cell;width:1%;text-align:center}.ReferenceCompanyModal-companyCmdType-3KmIw .ReferenceCompanyModal-container-219TN>li button{padding:0;font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.ReferenceCompanyModal-companyCmdType-3KmIw .ReferenceCompanyModal-container-219TN>li button.active{color:#546d79}.ReferenceCompanyModal-companyCmdType-3KmIw .ReferenceCompanyModal-container-219TN>li span{display:block}.ReferenceCompanyModal-companyCmdType-3KmIw .ReferenceCompanyModal-container-219TN>li span:first-letter{text-transform:uppercase}", ""]);
	
	// exports
	exports.locals = {
		"companyCmdType": "ReferenceCompanyModal-companyCmdType-3KmIw",
		"container": "ReferenceCompanyModal-container-219TN"
	};

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReferenceUserPopover-cmdType-2YUjC{overflow:hidden;margin:20px 0}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde{margin:0;padding:0;list-style-type:none}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li{display:table-cell;width:1%;text-align:center}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li button{padding:0;font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li button.active{color:#546d79}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li span{display:block}.ReferenceUserPopover-cmdType-2YUjC .ReferenceUserPopover-container-2tWde>li span:first-letter{text-transform:uppercase}", ""]);
	
	// exports
	exports.locals = {
		"cmdType": "ReferenceUserPopover-cmdType-2YUjC",
		"container": "ReferenceUserPopover-container-2tWde"
	};

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".SubsidiaryStream-pagination-3asbz{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "SubsidiaryStream-pagination-3asbz"
	};

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateAgencyPopover-delete-1nzqf{margin:10px;text-align:center}.UpdateAgencyPopover-delete-1nzqf a{font-weight:400;color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"delete": "UpdateAgencyPopover-delete-1nzqf"
	};

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateCompanyPopover-action-3QrVu{margin:10px;text-align:center}.UpdateCompanyPopover-action-3QrVu a{font-weight:400;color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"action": "UpdateCompanyPopover-action-3QrVu"
	};

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateLoginModal-send-29J8x{margin:10px;text-align:center}.UpdateLoginModal-send-29J8x a{font-weight:400;color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"send": "UpdateLoginModal-send-29J8x"
	};

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateUserModal-disable-1xHid{margin:10px;text-align:center}.UpdateUserModal-disable-1xHid a{font-weight:400;color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"disable": "UpdateUserModal-disable-1xHid"
	};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpgradeDowngradePremiumAccountModal-text-3s4AY{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "UpgradeDowngradePremiumAccountModal-text-3s4AY"
	};

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpgradeDowngradeStandardAccountModal-defaultContent-3BRuY input{text-align:center}.UpgradeDowngradeStandardAccountModal-text-2ddpG{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "UpgradeDowngradeStandardAccountModal-defaultContent-3BRuY",
		"text": "UpgradeDowngradeStandardAccountModal-text-2ddpG"
	};

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UserCard-header-3Ojvr .UserCard-container-7VvvC{overflow:hidden}.UserCard-header-3Ojvr .UserCard-action-3iQ7A{float:right}.UserCard-header-3Ojvr .UserCard-action-3iQ7A a{margin-left:10px}.UserCard-label-2FNc5{padding:10px 0}.UserCard-label-2FNc5 h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.UserCard-status-1rygs{float:right}", ""]);
	
	// exports
	exports.locals = {
		"header": "UserCard-header-3Ojvr",
		"container": "UserCard-container-7VvvC",
		"action": "UserCard-action-3iQ7A",
		"label": "UserCard-label-2FNc5",
		"status": "UserCard-status-1rygs"
	};

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UserSearch-default-2Cgth{overflow:hidden;margin-bottom:10px}.UserSearch-side-2ePZh{float:right}", ""]);
	
	// exports
	exports.locals = {
		"default": "UserSearch-default-2Cgth",
		"side": "UserSearch-side-2ePZh"
	};

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UserStream-pagination-1IAu3{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "UserStream-pagination-1IAu3"
	};

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Box-default-2z_sA{position:relative;margin-bottom:30px;padding:20px;border:1px solid #dadada;background:#fff}.Box-header-1wNyB{position:relative;text-align:center}.Box-header-1wNyB h3,.Box-header-1wNyB h4,.Box-header-1wNyB h5{margin:0 0 20px;font-weight:400;text-transform:uppercase}.Box-header-1wNyB .Box-help-svE4Q{display:inline-block;height:100px;line-height:100px;margin:0 0 20px;border-radius:50px;font-size:50px;font-weight:400;color:#fff}.Box-header-1wNyB .Box-help-svE4Q i{vertical-align:middle}.Box-body-2DI6g{position:relative}.Box-body-2DI6g p{color:#546d79}.Box-background-9kGjR{position:absolute;top:0;bottom:0;left:0;right:0;text-align:center}.Box-background-9kGjR:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}.Box-background-9kGjR i{vertical-align:middle}.Box-rounded-3WOq7{border-radius:10px}.Box-info-16V4g .Box-header-1wNyB .Box-help-svE4Q{width:100px;background:#8a959a}.Box-primary-2tqtP .Box-header-1wNyB .Box-help-svE4Q,.Box-success-31ycM .Box-header-1wNyB .Box-help-svE4Q{width:100px;background:#00e5ce}.Box-warning-2faSU .Box-header-1wNyB .Box-help-svE4Q{width:100px;background:#faad44}.Box-danger-2bmMn .Box-header-1wNyB .Box-help-svE4Q{width:100px;background:#ff5766}.Box-active-2zzOH.Box-info-16V4g{border-color:#8a959a}.Box-active-2zzOH.Box-primary-2tqtP,.Box-active-2zzOH.Box-success-31ycM{border-color:#00e5ce}.Box-active-2zzOH.Box-warning-2faSU{border-color:#faad44}.Box-active-2zzOH.Box-danger-2bmMn{border-color:#ff5766}.Box-clickable-130wl.Box-primary-2tqtP .Box-header-1wNyB .Box-help-svE4Q{cursor:pointer}.Box-clickable-130wl.Box-primary-2tqtP .Box-header-1wNyB .Box-help-svE4Q:focus,.Box-clickable-130wl.Box-primary-2tqtP .Box-header-1wNyB .Box-help-svE4Q:hover{background:#00ccb7;border-color:#00c1ae}.Box-clickable-130wl.Box-danger-2bmMn .Box-header-1wNyB .Box-help-svE4Q{cursor:pointer}.Box-clickable-130wl.Box-danger-2bmMn .Box-header-1wNyB .Box-help-svE4Q:focus,.Box-clickable-130wl.Box-danger-2bmMn .Box-header-1wNyB .Box-help-svE4Q:hover{background:#ff3e4f;border-color:#ff3345}", ""]);
	
	// exports
	exports.locals = {
		"default": "Box-default-2z_sA",
		"header": "Box-header-1wNyB",
		"help": "Box-help-svE4Q",
		"body": "Box-body-2DI6g",
		"background": "Box-background-9kGjR",
		"rounded": "Box-rounded-3WOq7",
		"info": "Box-info-16V4g",
		"primary": "Box-primary-2tqtP",
		"success": "Box-success-31ycM",
		"warning": "Box-warning-2faSU",
		"danger": "Box-danger-2bmMn",
		"active": "Box-active-2zzOH",
		"clickable": "Box-clickable-130wl"
	};

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Card-default-2qWyG{margin-bottom:30px}.Card-default-2qWyG h3,.Card-default-2qWyG h4,.Card-default-2qWyG h5{text-transform:uppercase}.Card-default-2qWyG h3 small,.Card-default-2qWyG h4 small,.Card-default-2qWyG h5 small{text-transform:none;font-size:inherit}.Card-default-2qWyG .Card-header-35lrW h4,.Card-default-2qWyG .Card-header-35lrW h5{margin:0;font-weight:300}.Card-header-35lrW{border-bottom:1px solid #dadada;color:#546d79}.Card-header-35lrW h3{margin:0;font-size:16px}@media (min-width:768px){.Card-header-35lrW h3{margin-top:22px;margin-bottom:11px;font-size:26px;text-align:center}}.Card-header-35lrW h4 small,.Card-header-35lrW h5 small{color:inherit}.Card-headerMain-1IlqV{margin-bottom:-1px;border-top:1px solid #dadada;border-left:1px solid #dadada;border-right:1px solid #dadada;background:#fff}.Card-headerMainContent-1ec7q{position:relative;overflow:hidden;padding:5px 0;margin:0 10px;border-bottom:1px solid #546d79}.Card-headerMainContent-1ec7q .Card-container-2974R{overflow:hidden;line-height:24px}.Card-headerMainContent-1ec7q .Card-container-2974R h3{display:inline-block;vertical-align:bottom}@media (min-width:768px){.Card-headerMainContent-1ec7q .Card-container-2974R h3{display:block}}.Card-headerMainContent-1ec7q .Card-container-2974R h4,.Card-headerMainContent-1ec7q .Card-container-2974R h5{display:inline-block;vertical-align:bottom}.Card-headerMainContent-1ec7q .Card-addon-drfES,.Card-headerSide-1bb7m{display:none}.Card-body-3gey5{padding:10px;border-right:1px solid #dadada;border-bottom:1px solid #dadada;border-left:1px solid #dadada;background:#fff}.Card-body-3gey5 h4,.Card-body-3gey5 h5{margin:0 0 5px;font-weight:400}.Card-bodyContent-3MOne{overflow:hidden}.Card-tab-3AxKJ .Card-header-35lrW:after{display:block;content:\" \";clear:both}.Card-tab-3AxKJ .Card-headerMain-1IlqV{margin-bottom:-1px;border-radius:10px 10px 0 0}@media (min-width:768px){.Card-tab-3AxKJ .Card-headerMain-1IlqV{float:left;min-width:33%}}.Card-tab-3AxKJ .Card-headerMainContent-1ec7q .Card-addon-drfES{display:block;float:right}@media (min-width:768px){.Card-tab-3AxKJ .Card-headerSide-1bb7m{display:block;float:right;padding:10px 0 0}}@media (min-width:768px){.Card-right-2604w.Card-tab-3AxKJ .Card-headerMain-1IlqV{float:right}}.Card-right-2604w.Card-tab-3AxKJ .Card-headerSide-1bb7m{display:none}@media (min-width:768px){.Card-right-2604w{text-align:right}}.Card-justified-2nWH9.Card-tab-3AxKJ .Card-headerMain-1IlqV{float:none}.Card-justified-2nWH9.Card-tab-3AxKJ .Card-headerSide-1bb7m{display:none}.Card-success-1PCrg .Card-header-35lrW h3{color:#00e5ce}.Card-success-1PCrg .Card-headerMainContent-1ec7q{border-color:#00e5ce}.Card-warning-8YFdG .Card-header-35lrW h3{color:#faad44}.Card-warning-8YFdG .Card-headerMainContent-1ec7q{border-color:#faad44}.Card-danger-3vAjm .Card-header-35lrW h3{color:#ff5766}.Card-danger-3vAjm .Card-headerMainContent-1ec7q{border-color:#ff5766}.Card-active-38KFy.Card-success-1PCrg .Card-body-3gey5,.Card-active-38KFy.Card-success-1PCrg .Card-headerMain-1IlqV{border-color:#00e5ce}.Card-active-38KFy.Card-warning-8YFdG .Card-body-3gey5,.Card-active-38KFy.Card-warning-8YFdG .Card-headerMain-1IlqV{border-color:#faad44}.Card-active-38KFy.Card-danger-3vAjm .Card-body-3gey5,.Card-active-38KFy.Card-danger-3vAjm .Card-headerMain-1IlqV{border-color:#ff5766}.Card-clickable-3qJgy .Card-body-3gey5,.Card-clickable-3qJgy .Card-headerMain-1IlqV{cursor:pointer}.Card-grouped-2QaYw{margin-bottom:0}.Card-grouped-2QaYw .Card-headerMain-1IlqV{border-top:0}.Card-grouped-2QaYw .Card-body-3gey5{border-bottom:0}", ""]);
	
	// exports
	exports.locals = {
		"default": "Card-default-2qWyG",
		"header": "Card-header-35lrW",
		"headerMain": "Card-headerMain-1IlqV",
		"headerMainContent": "Card-headerMainContent-1ec7q",
		"container": "Card-container-2974R",
		"addon": "Card-addon-drfES",
		"headerSide": "Card-headerSide-1bb7m",
		"body": "Card-body-3gey5",
		"bodyContent": "Card-bodyContent-3MOne",
		"tab": "Card-tab-3AxKJ",
		"right": "Card-right-2604w",
		"justified": "Card-justified-2nWH9",
		"success": "Card-success-1PCrg",
		"warning": "Card-warning-8YFdG",
		"danger": "Card-danger-3vAjm",
		"active": "Card-active-38KFy",
		"clickable": "Card-clickable-3qJgy",
		"grouped": "Card-grouped-2QaYw"
	};

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CardGroup-default-17jJv{margin-bottom:30px;border-top:1px solid #dadada;border-bottom:1px solid #dadada}", ""]);
	
	// exports
	exports.locals = {
		"default": "CardGroup-default-17jJv"
	};

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	exports.i(__webpack_require__(1791), "");
	
	// module
	exports.push([module.id, ".ct-line{stroke-width:2px}.ct-chart-donut .ct-label{fill:#fff;color:#fff;font-size:20px;font-weight:400}.ct-chart-bar .ct-label,.ct-chart-line .ct-label{font-size:14px;font-weight:400;color:#546d79}.ct-series-b .ct-line,.ct-series-b .ct-point{stroke:#00afff}.ct-series-b .ct-area{fill:#00afff}.ct-series-b .ct-bar,.ct-series-b .ct-slice-donut{stroke:#00afff}.ct-series-a .ct-line,.ct-series-a .ct-point{stroke:#ff4baa}.ct-series-a .ct-area{fill:#ff4baa}.ct-series-a .ct-bar,.ct-series-a .ct-slice-donut{stroke:#ff4baa}.ct-legend{margin:0;padding:0;list-style:none}.ct-legend.ct-legend-inside{position:absolute;bottom:0;left:0;right:0;z-index:10}.ct-legend.ct-legend-inside>li{float:none;padding:0}.ct-legend>li{display:block;float:right;padding-left:20px;text-align:center;font-size:14px;font-weight:400}.ct-legend>li.ct-series-1{color:#00afff}.ct-legend>li.ct-series-0{color:#ff4baa}.chartist-tooltip{position:absolute;opacity:0;padding:3px 8px;background-color:#8a959a;border-radius:4px;text-align:center;font-size:14px;pointer-events:none;color:#fff;z-index:1}.chartist-tooltip:before{content:\"\";position:absolute;top:100%;left:50%;margin-left:-5px;border:5px solid transparent;border-top-color:#8a959a}.chartist-tooltip.tooltip-show{opacity:1}.ct-brand .ct-series-c .ct-line,.ct-brand .ct-series-c .ct-point{stroke:#ff5766}.ct-brand .ct-series-c .ct-area{fill:#ff5766}.ct-brand .ct-series-c .ct-bar,.ct-brand .ct-series-c .ct-slice-donut{stroke:#ff5766}.ct-brand .ct-series-b .ct-line,.ct-brand .ct-series-b .ct-point{stroke:#faad44}.ct-brand .ct-series-b .ct-area{fill:#faad44}.ct-brand .ct-series-b .ct-bar,.ct-brand .ct-series-b .ct-slice-donut{stroke:#faad44}.ct-brand .ct-series-a .ct-line,.ct-brand .ct-series-a .ct-point{stroke:#00e5ce}.ct-brand .ct-series-a .ct-area{fill:#00e5ce}.ct-brand .ct-series-a .ct-bar,.ct-brand .ct-series-a .ct-slice-donut{stroke:#00e5ce}.ct-brand .ct-legend>li.ct-series-2{color:#ff5766}.ct-brand .ct-legend>li.ct-series-1{color:#faad44}.ct-brand .ct-legend>li.ct-series-0{color:#00e5ce}.ct-inverse .ct-series-b .ct-line,.ct-inverse .ct-series-b .ct-point{stroke:#827dff}.ct-inverse .ct-series-b .ct-area{fill:#827dff}.ct-inverse .ct-series-b .ct-bar,.ct-inverse .ct-series-b .ct-slice-donut{stroke:#827dff}.ct-inverse .ct-series-a .ct-line,.ct-inverse .ct-series-a .ct-point{stroke:#00f7b8}.ct-inverse .ct-series-a .ct-area{fill:#00f7b8}.ct-inverse .ct-series-a .ct-bar,.ct-inverse .ct-series-a .ct-slice-donut{stroke:#00f7b8}.ct-inverse .ct-legend>li.ct-series-1{color:#827dff}.ct-inverse .ct-legend>li.ct-series-0{color:#00f7b8}.ct-fill{height:100%;padding-bottom:30px}", ""]);
	
	// exports


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DashboardPanel-default-2vJso{margin-bottom:30px;background:#465c65;color:#fff;scrollbar-face-color:#2d3c41;scrollbar-arrow-color:#fff;scrollbar-highlight-color:#465c65;scrollbar-3dlight-color:#465c65;scrollbar-track-color:#465c65;scrollbar-shadow-color:#465c65;scrollbar-dark-shadow-color:#465c65}.DashboardPanel-default-2vJso h3,.DashboardPanel-default-2vJso h4{text-transform:uppercase;color:#fff}.DashboardPanel-default-2vJso a{color:#fff}.DashboardPanel-default-2vJso a:hover{text-decoration:none;color:#d9d9d9}@media (min-width:768px){.DashboardPanel-default-2vJso{height:276px}}@media (min-width:992px){.DashboardPanel-default-2vJso{height:234.66666667px}}@media (min-width:1200px){.DashboardPanel-default-2vJso{height:288px}}.DashboardPanel-header-oTAfg{position:relative;height:45px;margin-right:10px;padding:10px 0 10px 10px;text-align:center}.DashboardPanel-header-oTAfg h3,.DashboardPanel-header-oTAfg h4{margin:0}.DashboardPanel-header-oTAfg h3 strong,.DashboardPanel-header-oTAfg h4 strong{margin-left:5px;color:#ff5766}.DashboardPanel-headerMain-30XQT{overlow:hidden}.DashboardPanel-headerSide-1XSCD{float:right}.DashboardPanel-headerSide-1XSCD .DashboardPanel-help-2k8L4{display:inline-block;min-width:22px;padding:4px 0 2px;background:#fff;border-radius:11px;line-height:1;text-align:center;font-size:14px;font-weight:400;text-decoration:none;color:#465c65}.DashboardPanel-body-1PsdM{padding:10px}@media (min-width:768px){.DashboardPanel-body-1PsdM{height:100%;padding-bottom:55px}}.DashboardPanel-bodyContent-3xEpv{overflow:hidden}@media (min-width:768px){.DashboardPanel-bodyContent-3xEpv{overflow-y:auto;height:100%}}@media (min-width:768px){.DashboardPanel-large-3eZY-{height:582px}}@media (min-width:992px){.DashboardPanel-large-3eZY-{height:499.33333333px}}@media (min-width:1200px){.DashboardPanel-large-3eZY-{height:606px}}.DashboardPanel-light-2qUAs{background:#fff;border:1px solid #dadada;color:#546d79;scrollbar-face-color:#dadada;scrollbar-arrow-color:#fff;scrollbar-highlight-color:#fff;scrollbar-3dlight-color:#fff;scrollbar-track-color:#fff;scrollbar-shadow-color:#fff;scrollbar-dark-shadow-color:#fff}.DashboardPanel-light-2qUAs a,.DashboardPanel-light-2qUAs h3,.DashboardPanel-light-2qUAs h4{color:#546d79}.DashboardPanel-light-2qUAs a:hover{color:#87a0ac}.DashboardPanel-light-2qUAs .DashboardPanel-help-2k8L4{background:#a4b1b7;color:#fff}.DashboardPanel-success-1tjBx{border:1px solid #00e5ce}.DashboardPanel-success-1tjBx h3,.DashboardPanel-success-1tjBx h4{color:#00e5ce}.DashboardPanel-warning-3yrcb{border:1px solid #faad44}.DashboardPanel-warning-3yrcb h3,.DashboardPanel-warning-3yrcb h4{color:#faad44}.DashboardPanel-danger-gy4J0{border:1px solid #ff5766}.DashboardPanel-danger-gy4J0 h3,.DashboardPanel-danger-gy4J0 h4{color:#ff5766}.DashboardPanel-clickable-2zoGp{cursor:pointer}", ""]);
	
	// exports
	exports.locals = {
		"default": "DashboardPanel-default-2vJso",
		"header": "DashboardPanel-header-oTAfg",
		"headerMain": "DashboardPanel-headerMain-30XQT",
		"headerSide": "DashboardPanel-headerSide-1XSCD",
		"help": "DashboardPanel-help-2k8L4",
		"body": "DashboardPanel-body-1PsdM",
		"bodyContent": "DashboardPanel-bodyContent-3xEpv",
		"large": "DashboardPanel-large-3eZY-",
		"light": "DashboardPanel-light-2qUAs",
		"success": "DashboardPanel-success-1tjBx",
		"warning": "DashboardPanel-warning-3yrcb",
		"danger": "DashboardPanel-danger-gy4J0",
		"clickable": "DashboardPanel-clickable-2zoGp"
	};

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DashboardPanelAdd-default-11fkw{border:1px dotted #a4b1b7;margin-bottom:30px;padding:40px 0;color:#fff;text-align:center}.DashboardPanelAdd-default-11fkw:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}@media (min-width:768px){.DashboardPanelAdd-default-11fkw{height:276px}}@media (min-width:992px){.DashboardPanelAdd-default-11fkw{height:234.66666667px}}@media (min-width:1200px){.DashboardPanelAdd-default-11fkw{height:288px}}.DashboardPanelAdd-add-1OuYd{display:inline-block;width:80px;height:80px;background:#a4b1b7;border-radius:40px;vertical-align:middle;line-height:1;text-align:center;font-size:80px}.DashboardPanelAdd-clickable-3Z-gC.DashboardPanelAdd-default-11fkw{cursor:pointer}", ""]);
	
	// exports
	exports.locals = {
		"default": "DashboardPanelAdd-default-11fkw",
		"add": "DashboardPanelAdd-add-1OuYd",
		"clickable": "DashboardPanelAdd-clickable-3Z-gC"
	};

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DayRangePicker-default-3PyJg{text-align:center}.DayRangePicker-container-2djAE{display:inline-block;margin:20px}", ""]);
	
	// exports
	exports.locals = {
		"default": "DayRangePicker-default-3PyJg",
		"container": "DayRangePicker-container-2djAE"
	};

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes DownloadIcon-fadeinout{0%{height:0}to{height:100%}}.DownloadIcon-default-4UL1I{display:inline-block;position:relative}.DownloadIcon-progress-1rCpF{position:absolute;left:3px;right:3px;bottom:3px;opacity:.5;background:#00e5ce;animation:DownloadIcon-fadeinout 3s linear infinite}", ""]);
	
	// exports
	exports.locals = {
		"default": "DownloadIcon-default-4UL1I",
		"progress": "DownloadIcon-progress-1rCpF"
	};

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Header-default-rDovw{overflow:hidden;margin:0 0 20px;padding:10px;border:1px solid #dadada;border-radius:10px 10px 0 0;background:#fff}.Header-default-rDovw h3,.Header-default-rDovw h4,.Header-default-rDovw h5{margin:0;font-weight:400;text-transform:uppercase}.Header-default-rDovw h3 small,.Header-default-rDovw h4 small,.Header-default-rDovw h5 small{color:inherit}.Header-main-2sVxC{overflow:hidden;float:left;margin:5px 0 0}.Header-main-2sVxC .Header-container-k5YYq,.Header-main-2sVxC .Header-status-1rQT2{display:inline-block}.Header-side-35s1B{float:right}.Header-success-ssRSx{border-bottom:1px solid #00e5ce}.Header-warning-1EelI{border-bottom:1px solid #faad44}.Header-danger-fYp2m{border-bottom:1px solid #ff5766}", ""]);
	
	// exports
	exports.locals = {
		"default": "Header-default-rDovw",
		"main": "Header-main-2sVxC",
		"container": "Header-container-k5YYq",
		"status": "Header-status-1rQT2",
		"side": "Header-side-35s1B",
		"success": "Header-success-ssRSx",
		"warning": "Header-warning-1EelI",
		"danger": "Header-danger-fYp2m"
	};

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Icon-default-vBMH2{position:relative;display:inline-block;vertical-align:bottom;background-image:url(" + __webpack_require__(1139) + ");background-repeat:no-repeat}.Icon-default-vBMH2 .Icon-count-1sA-Q{position:absolute;top:-5px;right:-5px;height:20px;line-height:20px;min-width:20px;padding:2px 5px;background:#ff5766;border-radius:10px;font-size:14px;font-style:normal;font-weight:400;text-align:center;color:#fff}.Icon-success-dSrgu.Icon-count-1sA-Q{background:#00e5ce}.Icon-warning-3nAze.Icon-count-1sA-Q{background:#faad44}.Icon-danger-1MuPC.Icon-count-1sA-Q{background:#ff5766}.Icon-xs--tjeL{width:24px;height:24px}.Icon-sm-z1RxI{width:36px;height:36px}.Icon-md-teL1u{width:48px;height:48px}.Icon-lg-uXFJQ{width:60px;height:60px}.Icon-xl-c0ue7{width:72px;height:72px}.Icon-status-success-3EHhE.Icon-xs--tjeL{background-position:0 -216px}.Icon-status-warning-8QvZq.Icon-xs--tjeL{background-position:-24px -216px}.Icon-status-danger-2LKG7.Icon-xs--tjeL{background-position:-48px -216px}.Icon-cross-1I_XA.Icon-xs--tjeL{background-position:-72px -216px}.Icon-cross-1I_XA.Icon-xs--tjeL.Icon-active-3momR,.nav>li.active .Icon-cross-1I_XA.Icon-xs--tjeL,a.active .Icon-cross-1I_XA.Icon-xs--tjeL,a:hover .Icon-cross-1I_XA.Icon-xs--tjeL,button.active .Icon-cross-1I_XA.Icon-xs--tjeL,button:hover .Icon-cross-1I_XA.Icon-xs--tjeL{background-position:-96px -216px}.Icon-checkbox-dzfdS.Icon-xs--tjeL{background-position:-120px -216px}.Icon-checkbox-active-3wD_1.Icon-xs--tjeL{background-position:-144px -216px}.Icon-cog-Zypr4.Icon-xs--tjeL{background-position:-168px -216px}.Icon-sign-out-NdI5e.Icon-xs--tjeL{background-position:-192px -216px}.Icon-clock-JTIiz.Icon-xs--tjeL{background-position:-216px -216px}.Icon-phone-2Qqsg.Icon-xs--tjeL{background-position:-240px -216px}.Icon-mail-fsaEu.Icon-xs--tjeL{background-position:-264px -216px}.Icon-fax-1o4x2.Icon-xs--tjeL{background-position:-288px -216px}.Icon-down-3oep3.Icon-xs--tjeL{background-position:-312px -216px}.Icon-up-3yaFB.Icon-xs--tjeL{background-position:-336px -216px}.Icon-gear-17kZ-.Icon-xs--tjeL.Icon-active-3momR,.nav>li.active .Icon-gear-17kZ-.Icon-xs--tjeL,a.active .Icon-gear-17kZ-.Icon-xs--tjeL,a:hover .Icon-gear-17kZ-.Icon-xs--tjeL,button.active .Icon-gear-17kZ-.Icon-xs--tjeL,button:hover .Icon-gear-17kZ-.Icon-xs--tjeL{background-position:-360px -216px}.Icon-gear-17kZ-.Icon-xs--tjeL{background-position:-384px -216px}.Icon-plus-2ox9j.Icon-xs--tjeL{background-position:-408px -216px}.Icon-minus-11uXI.Icon-xs--tjeL{background-position:-432px -216px}.Icon-file-hZCfO.Icon-xs--tjeL{background-position:-456px -216px}.Icon-radio-3FUM7.Icon-xs--tjeL{background-position:-480px -216px}.Icon-radio-3FUM7.Icon-xs--tjeL.Icon-active-3momR,.Icon-radio-active-2cCSQ.Icon-xs--tjeL,.nav>li.active .Icon-radio-3FUM7.Icon-xs--tjeL,a.active .Icon-radio-3FUM7.Icon-xs--tjeL,a:hover .Icon-radio-3FUM7.Icon-xs--tjeL,button.active .Icon-radio-3FUM7.Icon-xs--tjeL,button:hover .Icon-radio-3FUM7.Icon-xs--tjeL{background-position:-504px -216px}.Icon-calendar-3TTwY.Icon-xs--tjeL{background-position:-528px -216px}.Icon-pencil-2Nkh-.Icon-xs--tjeL{background-position:-552px -216px}.Icon-mailGear-3yxom.Icon-xs--tjeL{background-position:-576px -216px}.Icon-agencyRefresh-1QajM.Icon-xs--tjeL{background-position:-600px -216px}.Icon-left-2trd0.Icon-xs--tjeL{background-position:-624px -216px}.Icon-left-2trd0.Icon-xs--tjeL.Icon-active-3momR,.nav>li.active .Icon-left-2trd0.Icon-xs--tjeL,a.active .Icon-left-2trd0.Icon-xs--tjeL,a:hover .Icon-left-2trd0.Icon-xs--tjeL,button.active .Icon-left-2trd0.Icon-xs--tjeL,button:hover .Icon-left-2trd0.Icon-xs--tjeL{background-position:-648px -216px}.Icon-quote-3Lauy.Icon-xs--tjeL{background-position:-672px -216px}.Icon-search-1lIr9.Icon-xs--tjeL{background-position:-696px -216px}.Icon-patrimonyGear-21MVG.Icon-xs--tjeL{background-position:-720px -216px}.Icon-undeclaredWork-2-nXo.Icon-xs--tjeL{background-position:-744px -216px}.Icon-insurance-WvyQi.Icon-xs--tjeL{background-position:-768px -216px}.Icon-star-2jxjd.Icon-xs--tjeL{background-position:-792px -216px}.Icon-check-3Tp_C.Icon-xs--tjeL{background-position:-816px -216px}.Icon-patrimony-UON0E.Icon-xs--tjeL.Icon-active-3momR,.nav>li.active .Icon-patrimony-UON0E.Icon-xs--tjeL,a.active .Icon-patrimony-UON0E.Icon-xs--tjeL,a:hover .Icon-patrimony-UON0E.Icon-xs--tjeL,button.active .Icon-patrimony-UON0E.Icon-xs--tjeL,button:hover .Icon-patrimony-UON0E.Icon-xs--tjeL{background-position:-840px -216px}.Icon-agency-LkD5o.Icon-xs--tjeL.Icon-active-3momR,.nav>li.active .Icon-agency-LkD5o.Icon-xs--tjeL,a.active .Icon-agency-LkD5o.Icon-xs--tjeL,a:hover .Icon-agency-LkD5o.Icon-xs--tjeL,button.active .Icon-agency-LkD5o.Icon-xs--tjeL,button:hover .Icon-agency-LkD5o.Icon-xs--tjeL{background-position:-864px -216px}.Icon-phone-2Qqsg.Icon-xs--tjeL.Icon-active-3momR,.nav>li.active .Icon-phone-2Qqsg.Icon-xs--tjeL,a.active .Icon-phone-2Qqsg.Icon-xs--tjeL,a:hover .Icon-phone-2Qqsg.Icon-xs--tjeL,button.active .Icon-phone-2Qqsg.Icon-xs--tjeL,button:hover .Icon-phone-2Qqsg.Icon-xs--tjeL{background-position:-888px -216px}.Icon-patrimony-UON0E.Icon-xs--tjeL{background-position:-912px -216px}.Icon-agency-LkD5o.Icon-xs--tjeL{background-position:-936px -216px}.Icon-location-3E9Pk.Icon-xs--tjeL{background-position:-960px -216px}.Icon-individualHouse-2JwKU.Icon-xs--tjeL{background-position:-984px -216px}.Icon-check-3Tp_C.Icon-xs--tjeL.Icon-active-3momR,.nav>li.active .Icon-check-3Tp_C.Icon-xs--tjeL,a.active .Icon-check-3Tp_C.Icon-xs--tjeL,a:hover .Icon-check-3Tp_C.Icon-xs--tjeL,button.active .Icon-check-3Tp_C.Icon-xs--tjeL,button:hover .Icon-check-3Tp_C.Icon-xs--tjeL{background-position:-1008px -216px}.Icon-checkWhite-QBoJ5.Icon-xs--tjeL{background-position:-1032px -216px}.Icon-opened-3zZj3.Icon-sm-z1RxI{background-position:0 -180px}.Icon-closed-ojYNP.Icon-sm-z1RxI{background-position:-36px -180px}.collapsed .Icon-up-3yaFB.Icon-sm-z1RxI,.Icon-down-3oep3.Icon-sm-z1RxI{background-position:-72px -180px}.Icon-up-3yaFB.Icon-sm-z1RxI{background-position:-108px -180px}.Icon-location-3E9Pk.Icon-sm-z1RxI{background-position:-144px -180px}.Icon-calendar-3TTwY.Icon-sm-z1RxI{background-position:-180px -180px}.Icon-file-hZCfO.Icon-sm-z1RxI{background-position:-216px -180px}.Icon-phone-question-3rL2q.Icon-sm-z1RxI{background-position:-252px -180px}.Icon-residentialParking-1xvRn.Icon-sm-z1RxI,.Icon-tertiaryParking-287Wd.Icon-sm-z1RxI{background-position:-288px -180px}.Icon-apartment-31gU5.Icon-sm-z1RxI{background-position:-324px -180px}.Icon-individualHouse-2JwKU.Icon-sm-z1RxI,.Icon-lot-3NIoh.Icon-sm-z1RxI{background-position:-360px -180px}.Icon-meetingRoom-5uIQq.Icon-sm-z1RxI{background-position:-396px -180px}.Icon-restaurant-1hOZ5.Icon-sm-z1RxI{background-position:-432px -180px}.Icon-fitness-1Kjh3.Icon-sm-z1RxI{background-position:-468px -180px}.Icon-spa-21lLm.Icon-sm-z1RxI{background-position:-504px -180px}.Icon-sportFacility-nPP6W.Icon-sm-z1RxI{background-position:-540px -180px}.Icon-otherService-33Lra.Icon-sm-z1RxI,.Icon-otherTechnical-xMPGK.Icon-sm-z1RxI{background-position:-576px -180px}.Icon-building-5wRmn.Icon-sm-z1RxI{background-position:-612px -180px}.Icon-workspace-3PlJV.Icon-sm-z1RxI{background-position:-648px -180px}.Icon-workstation-e6J2e.Icon-sm-z1RxI{background-position:-684px -180px}.Icon-office-3rs3t.Icon-sm-z1RxI{background-position:-720px -180px}.Icon-warehouse-3VbtW.Icon-sm-z1RxI{background-position:-756px -180px}.Icon-gasStation-3R0YQ.Icon-sm-z1RxI{background-position:-792px -180px}.Icon-pool-387r5.Icon-sm-z1RxI{background-position:-828px -180px}.Icon-poolHouse-25OYe.Icon-sm-z1RxI{background-position:-864px -180px}.Icon-playground-xcymK.Icon-sm-z1RxI{background-position:-900px -180px}.Icon-laundry-HWxvG.Icon-sm-z1RxI{background-position:-936px -180px}.Icon-machineRoom-2pku9.Icon-sm-z1RxI{background-position:-972px -180px}.Icon-binStorageArea-3IB8A.Icon-sm-z1RxI{background-position:-1008px -180px}.Icon-gardeningShed-2Urt0.Icon-sm-z1RxI{background-position:-1044px -180px}.Icon-intercom-1z0-1.Icon-sm-z1RxI{background-position:-1080px -180px}.Icon-retailShop-3IwQ2.Icon-sm-z1RxI{background-position:-1116px -180px}.Icon-boilerRoom-1gmyl.Icon-sm-z1RxI{background-position:-1152px -180px}.Icon-ventilationSystem-3l16V.Icon-sm-z1RxI{background-position:-1188px -180px}.Icon-elevator-1LGCv.Icon-sm-z1RxI{background-position:-1224px -180px}.Icon-gate-1qrJ1.Icon-sm-z1RxI{background-position:-1260px -180px}.Icon-pdf-2puWA.Icon-sm-z1RxI{background-position:-1296px -180px}.Icon-agency-LkD5o.Icon-sm-z1RxI{background-position:-1332px -180px}.Icon-clientAccount-1FbVA.Icon-sm-z1RxI{background-position:-1368px -180px}.Icon-user-uc4wZ.Icon-sm-z1RxI{background-position:-1404px -180px}.Icon-archived-BS43p.Icon-sm-z1RxI{background-position:-1440px -180px}.Icon-comment-27vDP.Icon-sm-z1RxI{background-position:-1476px -180px}.Icon-download-3RB6w.Icon-sm-z1RxI{background-position:-1512px -180px}.Icon-download-3RB6w.Icon-sm-z1RxI.Icon-active-3momR,.nav>li.active .Icon-download-3RB6w.Icon-sm-z1RxI,a.active .Icon-download-3RB6w.Icon-sm-z1RxI,a:hover .Icon-download-3RB6w.Icon-sm-z1RxI,button.active .Icon-download-3RB6w.Icon-sm-z1RxI,button:hover .Icon-download-3RB6w.Icon-sm-z1RxI{background-position:-1548px -180px}.Icon-buildingz-3_-rD.Icon-sm-z1RxI{background-position:-1584px -180px}.Icon-banner-2ddF5.Icon-sm-z1RxI,.Icon-premiumAccount-ZhJju.Icon-sm-z1RxI{background-position:-1620px -180px}.Icon-canceled-2gmdR.Icon-sm-z1RxI{background-position:-1656px -180px}.Icon-residentialCellar-1lOnG.Icon-sm-z1RxI{background-position:-1692px -180px}.Icon-residentialAnnex-stUxQ.Icon-sm-z1RxI{background-position:-1728px -180px}.Icon-receiveCall-3aDuS.Icon-sm-z1RxI{background-position:-1764px -180px}.Icon-emitCall-d1Djb.Icon-sm-z1RxI{background-position:-1800px -180px}.Icon-standardAccount-3zESY.Icon-sm-z1RxI{background-position:-1836px -180px}.Icon-arrow-1ywuT.Icon-sm-z1RxI{background-position:-1872px -180px}.Icon-user-uc4wZ.Icon-sm-z1RxI.Icon-active-3momR,.nav>li.active .Icon-user-uc4wZ.Icon-sm-z1RxI,a.active .Icon-user-uc4wZ.Icon-sm-z1RxI,a:hover .Icon-user-uc4wZ.Icon-sm-z1RxI,button.active .Icon-user-uc4wZ.Icon-sm-z1RxI,button:hover .Icon-user-uc4wZ.Icon-sm-z1RxI{background-position:-1908px -180px}.Icon-customer-18Vak.Icon-sm-z1RxI{background-position:-1944px -180px}.Icon-star-2jxjd.Icon-sm-z1RxI{background-position:-1980px -180px}.Icon-starHalf-TId_V.Icon-sm-z1RxI{background-position:-2016px -180px}.Icon-star-2jxjd.Icon-sm-z1RxI.Icon-active-3momR,.nav>li.active .Icon-star-2jxjd.Icon-sm-z1RxI,a.active .Icon-star-2jxjd.Icon-sm-z1RxI,a:hover .Icon-star-2jxjd.Icon-sm-z1RxI,button.active .Icon-star-2jxjd.Icon-sm-z1RxI,button:hover .Icon-star-2jxjd.Icon-sm-z1RxI{background-position:-2052px -180px}.Icon-search-1lIr9.Icon-md-teL1u{background-position:0 -132px}.Icon-search-1lIr9.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-search-1lIr9.Icon-md-teL1u,a.active .Icon-search-1lIr9.Icon-md-teL1u,a:hover .Icon-search-1lIr9.Icon-md-teL1u,button.active .Icon-search-1lIr9.Icon-md-teL1u,button:hover .Icon-search-1lIr9.Icon-md-teL1u{background-position:-48px -132px}.Icon-user-uc4wZ.Icon-md-teL1u{background-position:-96px -132px}.Icon-tertiary-1-oFi.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-tertiary-1-oFi.Icon-md-teL1u,a.active .Icon-tertiary-1-oFi.Icon-md-teL1u,a:hover .Icon-tertiary-1-oFi.Icon-md-teL1u,button.active .Icon-tertiary-1-oFi.Icon-md-teL1u,button:hover .Icon-tertiary-1-oFi.Icon-md-teL1u{background-position:-144px -132px}.Icon-tertiary-1-oFi.Icon-md-teL1u{background-position:-192px -132px}.Icon-technical-2olkF.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-technical-2olkF.Icon-md-teL1u,a.active .Icon-technical-2olkF.Icon-md-teL1u,a:hover .Icon-technical-2olkF.Icon-md-teL1u,button.active .Icon-technical-2olkF.Icon-md-teL1u,button:hover .Icon-technical-2olkF.Icon-md-teL1u{background-position:-240px -132px}.Icon-technical-2olkF.Icon-md-teL1u{background-position:-288px -132px}.Icon-service-mCtx2.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-service-mCtx2.Icon-md-teL1u,a.active .Icon-service-mCtx2.Icon-md-teL1u,a:hover .Icon-service-mCtx2.Icon-md-teL1u,button.active .Icon-service-mCtx2.Icon-md-teL1u,button:hover .Icon-service-mCtx2.Icon-md-teL1u{background-position:-336px -132px}.Icon-service-mCtx2.Icon-md-teL1u{background-position:-384px -132px}.Icon-residential-1Vbz4.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-residential-1Vbz4.Icon-md-teL1u,a.active .Icon-residential-1Vbz4.Icon-md-teL1u,a:hover .Icon-residential-1Vbz4.Icon-md-teL1u,button.active .Icon-residential-1Vbz4.Icon-md-teL1u,button:hover .Icon-residential-1Vbz4.Icon-md-teL1u{background-position:-432px -132px}.Icon-residential-1Vbz4.Icon-md-teL1u{background-position:-480px -132px}.Icon-clientAccountHolding-L_99X.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-clientAccountHolding-L_99X.Icon-md-teL1u,a.active .Icon-clientAccountHolding-L_99X.Icon-md-teL1u,a:hover .Icon-clientAccountHolding-L_99X.Icon-md-teL1u,button.active .Icon-clientAccountHolding-L_99X.Icon-md-teL1u,button:hover .Icon-clientAccountHolding-L_99X.Icon-md-teL1u{background-position:-528px -132px}.Icon-clientAccountHolding-L_99X.Icon-md-teL1u{background-position:-576px -132px}.Icon-clientAccount-1FbVA.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-clientAccount-1FbVA.Icon-md-teL1u,a.active .Icon-clientAccount-1FbVA.Icon-md-teL1u,a:hover .Icon-clientAccount-1FbVA.Icon-md-teL1u,button.active .Icon-clientAccount-1FbVA.Icon-md-teL1u,button:hover .Icon-clientAccount-1FbVA.Icon-md-teL1u{background-position:-624px -132px}.Icon-clientAccount-1FbVA.Icon-md-teL1u{background-position:-672px -132px}.Icon-callCenter-2qlwq.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-callCenter-2qlwq.Icon-md-teL1u,a.active .Icon-callCenter-2qlwq.Icon-md-teL1u,a:hover .Icon-callCenter-2qlwq.Icon-md-teL1u,button.active .Icon-callCenter-2qlwq.Icon-md-teL1u,button:hover .Icon-callCenter-2qlwq.Icon-md-teL1u{background-position:-720px -132px}.Icon-callCenter-2qlwq.Icon-md-teL1u{background-position:-768px -132px}.Icon-callCenterOperator-2ict2.Icon-md-teL1u.Icon-active-3momR,.Icon-callCenterUser-kB5J1.Icon-md-teL1u.Icon-active-3momR,.Icon-clientAccountManager-3zfWv.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-callCenterOperator-2ict2.Icon-md-teL1u,.nav>li.active .Icon-callCenterUser-kB5J1.Icon-md-teL1u,.nav>li.active .Icon-clientAccountManager-3zfWv.Icon-md-teL1u,a.active .Icon-callCenterOperator-2ict2.Icon-md-teL1u,a.active .Icon-callCenterUser-kB5J1.Icon-md-teL1u,a.active .Icon-clientAccountManager-3zfWv.Icon-md-teL1u,a:hover .Icon-callCenterOperator-2ict2.Icon-md-teL1u,a:hover .Icon-callCenterUser-kB5J1.Icon-md-teL1u,a:hover .Icon-clientAccountManager-3zfWv.Icon-md-teL1u,button.active .Icon-callCenterOperator-2ict2.Icon-md-teL1u,button.active .Icon-callCenterUser-kB5J1.Icon-md-teL1u,button.active .Icon-clientAccountManager-3zfWv.Icon-md-teL1u,button:hover .Icon-callCenterOperator-2ict2.Icon-md-teL1u,button:hover .Icon-callCenterUser-kB5J1.Icon-md-teL1u,button:hover .Icon-clientAccountManager-3zfWv.Icon-md-teL1u{background-position:-816px -132px}.Icon-callCenterOperator-2ict2.Icon-md-teL1u,.Icon-callCenterUser-kB5J1.Icon-md-teL1u,.Icon-clientAccountManager-3zfWv.Icon-md-teL1u{background-position:-864px -132px}.Icon-executive-gAw8W.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-executive-gAw8W.Icon-md-teL1u,a.active .Icon-executive-gAw8W.Icon-md-teL1u,a:hover .Icon-executive-gAw8W.Icon-md-teL1u,button.active .Icon-executive-gAw8W.Icon-md-teL1u,button:hover .Icon-executive-gAw8W.Icon-md-teL1u{background-position:-912px -132px}.Icon-executive-gAw8W.Icon-md-teL1u{background-position:-960px -132px}.Icon-barrier-3GSq-.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-barrier-3GSq-.Icon-md-teL1u,a.active .Icon-barrier-3GSq-.Icon-md-teL1u,a:hover .Icon-barrier-3GSq-.Icon-md-teL1u,button.active .Icon-barrier-3GSq-.Icon-md-teL1u,button:hover .Icon-barrier-3GSq-.Icon-md-teL1u{background-position:-1008px -132px}.Icon-barrier-3GSq-.Icon-md-teL1u{background-position:-1056px -132px}.Icon-closedlock-374p3.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-closedlock-374p3.Icon-md-teL1u,a.active .Icon-closedlock-374p3.Icon-md-teL1u,a:hover .Icon-closedlock-374p3.Icon-md-teL1u,button.active .Icon-closedlock-374p3.Icon-md-teL1u,button:hover .Icon-closedlock-374p3.Icon-md-teL1u{background-position:-1104px -132px}.Icon-closedlock-374p3.Icon-md-teL1u{background-position:-1152px -132px}.Icon-openlock-npJYK.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-openlock-npJYK.Icon-md-teL1u,a.active .Icon-openlock-npJYK.Icon-md-teL1u,a:hover .Icon-openlock-npJYK.Icon-md-teL1u,button.active .Icon-openlock-npJYK.Icon-md-teL1u,button:hover .Icon-openlock-npJYK.Icon-md-teL1u{background-position:-1200px -132px}.Icon-openlock-npJYK.Icon-md-teL1u{background-position:-1248px -132px}.Icon-fence-33nRw.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-fence-33nRw.Icon-md-teL1u,a.active .Icon-fence-33nRw.Icon-md-teL1u,a:hover .Icon-fence-33nRw.Icon-md-teL1u,button.active .Icon-fence-33nRw.Icon-md-teL1u,button:hover .Icon-fence-33nRw.Icon-md-teL1u{background-position:-1296px -132px}.Icon-fence-33nRw.Icon-md-teL1u{background-position:-1344px -132px}.Icon-door-2YKQs.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-door-2YKQs.Icon-md-teL1u,a.active .Icon-door-2YKQs.Icon-md-teL1u,a:hover .Icon-door-2YKQs.Icon-md-teL1u,button.active .Icon-door-2YKQs.Icon-md-teL1u,button:hover .Icon-door-2YKQs.Icon-md-teL1u{background-position:-1392px -132px}.Icon-door-2YKQs.Icon-md-teL1u{background-position:-1440px -132px}.Icon-window-1gnOo.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-window-1gnOo.Icon-md-teL1u,a.active .Icon-window-1gnOo.Icon-md-teL1u,a:hover .Icon-window-1gnOo.Icon-md-teL1u,button.active .Icon-window-1gnOo.Icon-md-teL1u,button:hover .Icon-window-1gnOo.Icon-md-teL1u{background-position:-1488px -132px}.Icon-window-1gnOo.Icon-md-teL1u{background-position:-1536px -132px}.Icon-rollerblind-1_SHV.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-rollerblind-1_SHV.Icon-md-teL1u,a.active .Icon-rollerblind-1_SHV.Icon-md-teL1u,a:hover .Icon-rollerblind-1_SHV.Icon-md-teL1u,button.active .Icon-rollerblind-1_SHV.Icon-md-teL1u,button:hover .Icon-rollerblind-1_SHV.Icon-md-teL1u{background-position:-1584px -132px}.Icon-rollerblind-1_SHV.Icon-md-teL1u{background-position:-1632px -132px}.Icon-keys-zDrjW.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-keys-zDrjW.Icon-md-teL1u,a.active .Icon-keys-zDrjW.Icon-md-teL1u,a:hover .Icon-keys-zDrjW.Icon-md-teL1u,button.active .Icon-keys-zDrjW.Icon-md-teL1u,button:hover .Icon-keys-zDrjW.Icon-md-teL1u{background-position:-1680px -132px}.Icon-keys-zDrjW.Icon-md-teL1u{background-position:-1728px -132px}.Icon-brokenglass-1rakx.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-brokenglass-1rakx.Icon-md-teL1u,a.active .Icon-brokenglass-1rakx.Icon-md-teL1u,a:hover .Icon-brokenglass-1rakx.Icon-md-teL1u,button.active .Icon-brokenglass-1rakx.Icon-md-teL1u,button:hover .Icon-brokenglass-1rakx.Icon-md-teL1u{background-position:-1776px -132px}.Icon-brokenglass-1rakx.Icon-md-teL1u{background-position:-1824px -132px}.Icon-boiler-2bkPv.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-boiler-2bkPv.Icon-md-teL1u,a.active .Icon-boiler-2bkPv.Icon-md-teL1u,a:hover .Icon-boiler-2bkPv.Icon-md-teL1u,button.active .Icon-boiler-2bkPv.Icon-md-teL1u,button:hover .Icon-boiler-2bkPv.Icon-md-teL1u{background-position:-1872px -132px}.Icon-boiler-2bkPv.Icon-md-teL1u{background-position:-1920px -132px}.Icon-heater-2DEF2.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-heater-2DEF2.Icon-md-teL1u,a.active .Icon-heater-2DEF2.Icon-md-teL1u,a:hover .Icon-heater-2DEF2.Icon-md-teL1u,button.active .Icon-heater-2DEF2.Icon-md-teL1u,button:hover .Icon-heater-2DEF2.Icon-md-teL1u{background-position:-1968px -132px}.Icon-heater-2DEF2.Icon-md-teL1u{background-position:-2016px -132px}.Icon-electrecity-Yt0kw.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-electrecity-Yt0kw.Icon-md-teL1u,a.active .Icon-electrecity-Yt0kw.Icon-md-teL1u,a:hover .Icon-electrecity-Yt0kw.Icon-md-teL1u,button.active .Icon-electrecity-Yt0kw.Icon-md-teL1u,button:hover .Icon-electrecity-Yt0kw.Icon-md-teL1u{background-position:-2064px -132px}.Icon-electrecity-Yt0kw.Icon-md-teL1u{background-position:-2112px -132px}.Icon-elecman-2C5HK.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-elecman-2C5HK.Icon-md-teL1u,a.active .Icon-elecman-2C5HK.Icon-md-teL1u,a:hover .Icon-elecman-2C5HK.Icon-md-teL1u,button.active .Icon-elecman-2C5HK.Icon-md-teL1u,button:hover .Icon-elecman-2C5HK.Icon-md-teL1u{background-position:-2160px -132px}.Icon-elecman-2C5HK.Icon-md-teL1u{background-position:-2208px -132px}.Icon-lamp-1G8Mu.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-lamp-1G8Mu.Icon-md-teL1u,a.active .Icon-lamp-1G8Mu.Icon-md-teL1u,a:hover .Icon-lamp-1G8Mu.Icon-md-teL1u,button.active .Icon-lamp-1G8Mu.Icon-md-teL1u,button:hover .Icon-lamp-1G8Mu.Icon-md-teL1u{background-position:-2256px -132px}.Icon-lamp-1G8Mu.Icon-md-teL1u{background-position:-2304px -132px}.Icon-hotwater-2p4KZ.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-hotwater-2p4KZ.Icon-md-teL1u,a.active .Icon-hotwater-2p4KZ.Icon-md-teL1u,a:hover .Icon-hotwater-2p4KZ.Icon-md-teL1u,button.active .Icon-hotwater-2p4KZ.Icon-md-teL1u,button:hover .Icon-hotwater-2p4KZ.Icon-md-teL1u{background-position:-2352px -132px}.Icon-hotwater-2p4KZ.Icon-md-teL1u{background-position:-2400px -132px}.Icon-plumber-_BXjC.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-plumber-_BXjC.Icon-md-teL1u,a.active .Icon-plumber-_BXjC.Icon-md-teL1u,a:hover .Icon-plumber-_BXjC.Icon-md-teL1u,button.active .Icon-plumber-_BXjC.Icon-md-teL1u,button:hover .Icon-plumber-_BXjC.Icon-md-teL1u{background-position:-2448px -132px}.Icon-plumber-_BXjC.Icon-md-teL1u{background-position:-2496px -132px}.Icon-tap-3hPbB.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-tap-3hPbB.Icon-md-teL1u,a.active .Icon-tap-3hPbB.Icon-md-teL1u,a:hover .Icon-tap-3hPbB.Icon-md-teL1u,button.active .Icon-tap-3hPbB.Icon-md-teL1u,button:hover .Icon-tap-3hPbB.Icon-md-teL1u{background-position:-2544px -132px}.Icon-tap-3hPbB.Icon-md-teL1u{background-position:-2592px -132px}.Icon-waterdrop-1ZuQ1.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-waterdrop-1ZuQ1.Icon-md-teL1u,a.active .Icon-waterdrop-1ZuQ1.Icon-md-teL1u,a:hover .Icon-waterdrop-1ZuQ1.Icon-md-teL1u,button.active .Icon-waterdrop-1ZuQ1.Icon-md-teL1u,button:hover .Icon-waterdrop-1ZuQ1.Icon-md-teL1u{background-position:-2640px -132px}.Icon-waterdrop-1ZuQ1.Icon-md-teL1u{background-position:-2688px -132px}.Icon-waterman-QwcWJ.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-waterman-QwcWJ.Icon-md-teL1u,a.active .Icon-waterman-QwcWJ.Icon-md-teL1u,a:hover .Icon-waterman-QwcWJ.Icon-md-teL1u,button.active .Icon-waterman-QwcWJ.Icon-md-teL1u,button:hover .Icon-waterman-QwcWJ.Icon-md-teL1u{background-position:-2736px -132px}.Icon-waterman-QwcWJ.Icon-md-teL1u{background-position:-2784px -132px}.Icon-watertap-Rng3T.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-watertap-Rng3T.Icon-md-teL1u,a.active .Icon-watertap-Rng3T.Icon-md-teL1u,a:hover .Icon-watertap-Rng3T.Icon-md-teL1u,button.active .Icon-watertap-Rng3T.Icon-md-teL1u,button:hover .Icon-watertap-Rng3T.Icon-md-teL1u{background-position:-2832px -132px}.Icon-watertap-Rng3T.Icon-md-teL1u{background-position:-2880px -132px}.Icon-extinctor-2DeQd.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-extinctor-2DeQd.Icon-md-teL1u,a.active .Icon-extinctor-2DeQd.Icon-md-teL1u,a:hover .Icon-extinctor-2DeQd.Icon-md-teL1u,button.active .Icon-extinctor-2DeQd.Icon-md-teL1u,button:hover .Icon-extinctor-2DeQd.Icon-md-teL1u{background-position:-2928px -132px}.Icon-extinctor-2DeQd.Icon-md-teL1u{background-position:-2976px -132px}.Icon-firealarm-3s6QP.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-firealarm-3s6QP.Icon-md-teL1u,a.active .Icon-firealarm-3s6QP.Icon-md-teL1u,a:hover .Icon-firealarm-3s6QP.Icon-md-teL1u,button.active .Icon-firealarm-3s6QP.Icon-md-teL1u,button:hover .Icon-firealarm-3s6QP.Icon-md-teL1u{background-position:-3024px -132px}.Icon-firealarm-3s6QP.Icon-md-teL1u{background-position:-3072px -132px}.Icon-firefighters-3f2wN.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-firefighters-3f2wN.Icon-md-teL1u,a.active .Icon-firefighters-3f2wN.Icon-md-teL1u,a:hover .Icon-firefighters-3f2wN.Icon-md-teL1u,button.active .Icon-firefighters-3f2wN.Icon-md-teL1u,button:hover .Icon-firefighters-3f2wN.Icon-md-teL1u{background-position:-3120px -132px}.Icon-firefighters-3f2wN.Icon-md-teL1u{background-position:-3168px -132px}.Icon-intrusionalarm-3vhrp.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-intrusionalarm-3vhrp.Icon-md-teL1u,a.active .Icon-intrusionalarm-3vhrp.Icon-md-teL1u,a:hover .Icon-intrusionalarm-3vhrp.Icon-md-teL1u,button.active .Icon-intrusionalarm-3vhrp.Icon-md-teL1u,button:hover .Icon-intrusionalarm-3vhrp.Icon-md-teL1u{background-position:-3216px -132px}.Icon-intrusionalarm-3vhrp.Icon-md-teL1u{background-position:-3264px -132px}.Icon-alarm-i2BG_.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-alarm-i2BG_.Icon-md-teL1u,a.active .Icon-alarm-i2BG_.Icon-md-teL1u,a:hover .Icon-alarm-i2BG_.Icon-md-teL1u,button.active .Icon-alarm-i2BG_.Icon-md-teL1u,button:hover .Icon-alarm-i2BG_.Icon-md-teL1u{background-position:-3312px -132px}.Icon-alarm-i2BG_.Icon-md-teL1u{background-position:-3360px -132px}.Icon-burglar-NY8AK.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-burglar-NY8AK.Icon-md-teL1u,a.active .Icon-burglar-NY8AK.Icon-md-teL1u,a:hover .Icon-burglar-NY8AK.Icon-md-teL1u,button.active .Icon-burglar-NY8AK.Icon-md-teL1u,button:hover .Icon-burglar-NY8AK.Icon-md-teL1u{background-position:-3408px -132px}.Icon-burglar-NY8AK.Icon-md-teL1u{background-position:-3456px -132px}.Icon-evacuate-1wBox.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-evacuate-1wBox.Icon-md-teL1u,a.active .Icon-evacuate-1wBox.Icon-md-teL1u,a:hover .Icon-evacuate-1wBox.Icon-md-teL1u,button.active .Icon-evacuate-1wBox.Icon-md-teL1u,button:hover .Icon-evacuate-1wBox.Icon-md-teL1u{background-position:-3504px -132px}.Icon-evacuate-1wBox.Icon-md-teL1u{background-position:-3552px -132px}.Icon-explosion-2G4uT.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-explosion-2G4uT.Icon-md-teL1u,a.active .Icon-explosion-2G4uT.Icon-md-teL1u,a:hover .Icon-explosion-2G4uT.Icon-md-teL1u,button.active .Icon-explosion-2G4uT.Icon-md-teL1u,button:hover .Icon-explosion-2G4uT.Icon-md-teL1u{background-position:-3600px -132px}.Icon-explosion-2G4uT.Icon-md-teL1u{background-position:-3648px -132px}.Icon-flood-1b1r1.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-flood-1b1r1.Icon-md-teL1u,a.active .Icon-flood-1b1r1.Icon-md-teL1u,a:hover .Icon-flood-1b1r1.Icon-md-teL1u,button.active .Icon-flood-1b1r1.Icon-md-teL1u,button:hover .Icon-flood-1b1r1.Icon-md-teL1u{background-position:-3696px -132px}.Icon-flood-1b1r1.Icon-md-teL1u{background-position:-3744px -132px}.Icon-vandalism-14pR5.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-vandalism-14pR5.Icon-md-teL1u,a.active .Icon-vandalism-14pR5.Icon-md-teL1u,a:hover .Icon-vandalism-14pR5.Icon-md-teL1u,button.active .Icon-vandalism-14pR5.Icon-md-teL1u,button:hover .Icon-vandalism-14pR5.Icon-md-teL1u{background-position:-3792px -132px}.Icon-vandalism-14pR5.Icon-md-teL1u{background-position:-3840px -132px}.Icon-elevator-1LGCv.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-elevator-1LGCv.Icon-md-teL1u,a.active .Icon-elevator-1LGCv.Icon-md-teL1u,a:hover .Icon-elevator-1LGCv.Icon-md-teL1u,button.active .Icon-elevator-1LGCv.Icon-md-teL1u,button:hover .Icon-elevator-1LGCv.Icon-md-teL1u{background-position:-3888px -132px}.Icon-elevator-1LGCv.Icon-md-teL1u{background-position:-3936px -132px}.Icon-litter-3sVrk.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-litter-3sVrk.Icon-md-teL1u,a.active .Icon-litter-3sVrk.Icon-md-teL1u,a:hover .Icon-litter-3sVrk.Icon-md-teL1u,button.active .Icon-litter-3sVrk.Icon-md-teL1u,button:hover .Icon-litter-3sVrk.Icon-md-teL1u{background-position:-3984px -132px}.Icon-litter-3sVrk.Icon-md-teL1u{background-position:-4032px -132px}.Icon-pump-31f70.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-pump-31f70.Icon-md-teL1u,a.active .Icon-pump-31f70.Icon-md-teL1u,a:hover .Icon-pump-31f70.Icon-md-teL1u,button.active .Icon-pump-31f70.Icon-md-teL1u,button:hover .Icon-pump-31f70.Icon-md-teL1u{background-position:-4080px -132px}.Icon-pump-31f70.Icon-md-teL1u{background-position:-4128px -132px}.Icon-bucket-3fqHo.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-bucket-3fqHo.Icon-md-teL1u,a.active .Icon-bucket-3fqHo.Icon-md-teL1u,a:hover .Icon-bucket-3fqHo.Icon-md-teL1u,button.active .Icon-bucket-3fqHo.Icon-md-teL1u,button:hover .Icon-bucket-3fqHo.Icon-md-teL1u{background-position:-4176px -132px}.Icon-bucket-3fqHo.Icon-md-teL1u{background-position:-4224px -132px}.Icon-vent-VGkaS.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-vent-VGkaS.Icon-md-teL1u,a.active .Icon-vent-VGkaS.Icon-md-teL1u,a:hover .Icon-vent-VGkaS.Icon-md-teL1u,button.active .Icon-vent-VGkaS.Icon-md-teL1u,button:hover .Icon-vent-VGkaS.Icon-md-teL1u{background-position:-4272px -132px}.Icon-vent-VGkaS.Icon-md-teL1u{background-position:-4320px -132px}.Icon-smokevent-2L84A.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-smokevent-2L84A.Icon-md-teL1u,a.active .Icon-smokevent-2L84A.Icon-md-teL1u,a:hover .Icon-smokevent-2L84A.Icon-md-teL1u,button.active .Icon-smokevent-2L84A.Icon-md-teL1u,button:hover .Icon-smokevent-2L84A.Icon-md-teL1u{background-position:-4368px -132px}.Icon-smokevent-2L84A.Icon-md-teL1u{background-position:-4416px -132px}.Icon-parkingvent-2x_fT.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-parkingvent-2x_fT.Icon-md-teL1u,a.active .Icon-parkingvent-2x_fT.Icon-md-teL1u,a:hover .Icon-parkingvent-2x_fT.Icon-md-teL1u,button.active .Icon-parkingvent-2x_fT.Icon-md-teL1u,button:hover .Icon-parkingvent-2x_fT.Icon-md-teL1u{background-position:-4464px -132px}.Icon-parkingvent-2x_fT.Icon-md-teL1u{background-position:-4512px -132px}.Icon-gasvent-3nL4t.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-gasvent-3nL4t.Icon-md-teL1u,a.active .Icon-gasvent-3nL4t.Icon-md-teL1u,a:hover .Icon-gasvent-3nL4t.Icon-md-teL1u,button.active .Icon-gasvent-3nL4t.Icon-md-teL1u,button:hover .Icon-gasvent-3nL4t.Icon-md-teL1u{background-position:-4560px -132px}.Icon-gasvent-3nL4t.Icon-md-teL1u{background-position:-4608px -132px}.Icon-aircon-1r6hG.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-aircon-1r6hG.Icon-md-teL1u,a.active .Icon-aircon-1r6hG.Icon-md-teL1u,a:hover .Icon-aircon-1r6hG.Icon-md-teL1u,button.active .Icon-aircon-1r6hG.Icon-md-teL1u,button:hover .Icon-aircon-1r6hG.Icon-md-teL1u{background-position:-4656px -132px}.Icon-aircon-1r6hG.Icon-md-teL1u{background-position:-4704px -132px}.Icon-gasman-vxs1x.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-gasman-vxs1x.Icon-md-teL1u,a.active .Icon-gasman-vxs1x.Icon-md-teL1u,a:hover .Icon-gasman-vxs1x.Icon-md-teL1u,button.active .Icon-gasman-vxs1x.Icon-md-teL1u,button:hover .Icon-gasman-vxs1x.Icon-md-teL1u{background-position:-4752px -132px}.Icon-gasman-vxs1x.Icon-md-teL1u{background-position:-4800px -132px}.Icon-gas-1oiQ5.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-gas-1oiQ5.Icon-md-teL1u,a.active .Icon-gas-1oiQ5.Icon-md-teL1u,a:hover .Icon-gas-1oiQ5.Icon-md-teL1u,button.active .Icon-gas-1oiQ5.Icon-md-teL1u,button:hover .Icon-gas-1oiQ5.Icon-md-teL1u{background-position:-4848px -132px}.Icon-gas-1oiQ5.Icon-md-teL1u{background-position:-4896px -132px}.Icon-manogas-3PcwY.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-manogas-3PcwY.Icon-md-teL1u,a.active .Icon-manogas-3PcwY.Icon-md-teL1u,a:hover .Icon-manogas-3PcwY.Icon-md-teL1u,button.active .Icon-manogas-3PcwY.Icon-md-teL1u,button:hover .Icon-manogas-3PcwY.Icon-md-teL1u{background-position:-4944px -132px}.Icon-manogas-3PcwY.Icon-md-teL1u{background-position:-4992px -132px}.Icon-pipe-Uktqp.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-pipe-Uktqp.Icon-md-teL1u,a.active .Icon-pipe-Uktqp.Icon-md-teL1u,a:hover .Icon-pipe-Uktqp.Icon-md-teL1u,button.active .Icon-pipe-Uktqp.Icon-md-teL1u,button:hover .Icon-pipe-Uktqp.Icon-md-teL1u{background-position:-5040px -132px}.Icon-pipe-Uktqp.Icon-md-teL1u{background-position:-5088px -132px}.Icon-pressure-3c2ao.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-pressure-3c2ao.Icon-md-teL1u,a.active .Icon-pressure-3c2ao.Icon-md-teL1u,a:hover .Icon-pressure-3c2ao.Icon-md-teL1u,button.active .Icon-pressure-3c2ao.Icon-md-teL1u,button:hover .Icon-pressure-3c2ao.Icon-md-teL1u{background-position:-5136px -132px}.Icon-pressure-3c2ao.Icon-md-teL1u{background-position:-5184px -132px}.Icon-parking-1_5wd.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-parking-1_5wd.Icon-md-teL1u,a.active .Icon-parking-1_5wd.Icon-md-teL1u,a:hover .Icon-parking-1_5wd.Icon-md-teL1u,button.active .Icon-parking-1_5wd.Icon-md-teL1u,button:hover .Icon-parking-1_5wd.Icon-md-teL1u{background-position:-5232px -132px}.Icon-parking-1_5wd.Icon-md-teL1u{background-position:-5280px -132px}.Icon-terminal-26_Ez.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-terminal-26_Ez.Icon-md-teL1u,a.active .Icon-terminal-26_Ez.Icon-md-teL1u,a:hover .Icon-terminal-26_Ez.Icon-md-teL1u,button.active .Icon-terminal-26_Ez.Icon-md-teL1u,button:hover .Icon-terminal-26_Ez.Icon-md-teL1u{background-position:-5328px -132px}.Icon-terminal-26_Ez.Icon-md-teL1u{background-position:-5376px -132px}.Icon-monitoring-1-Px1.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-monitoring-1-Px1.Icon-md-teL1u,a.active .Icon-monitoring-1-Px1.Icon-md-teL1u,a:hover .Icon-monitoring-1-Px1.Icon-md-teL1u,button.active .Icon-monitoring-1-Px1.Icon-md-teL1u,button:hover .Icon-monitoring-1-Px1.Icon-md-teL1u{background-position:-5424px -132px}.Icon-monitoring-1-Px1.Icon-md-teL1u{background-position:-5472px -132px}.Icon-tv-rrcGb.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-tv-rrcGb.Icon-md-teL1u,a.active .Icon-tv-rrcGb.Icon-md-teL1u,a:hover .Icon-tv-rrcGb.Icon-md-teL1u,button.active .Icon-tv-rrcGb.Icon-md-teL1u,button:hover .Icon-tv-rrcGb.Icon-md-teL1u{background-position:-5520px -132px}.Icon-tv-rrcGb.Icon-md-teL1u{background-position:-5568px -132px}.Icon-manager-3Fi4L.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-manager-3Fi4L.Icon-md-teL1u,a.active .Icon-manager-3Fi4L.Icon-md-teL1u,a:hover .Icon-manager-3Fi4L.Icon-md-teL1u,button.active .Icon-manager-3Fi4L.Icon-md-teL1u,button:hover .Icon-manager-3Fi4L.Icon-md-teL1u{background-position:-5616px -132px}.Icon-manager-3Fi4L.Icon-md-teL1u{background-position:-5664px -132px}.Icon-owner-2IESL.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-owner-2IESL.Icon-md-teL1u,a.active .Icon-owner-2IESL.Icon-md-teL1u,a:hover .Icon-owner-2IESL.Icon-md-teL1u,button.active .Icon-owner-2IESL.Icon-md-teL1u,button:hover .Icon-owner-2IESL.Icon-md-teL1u{background-position:-5616px -132px}.Icon-owner-2IESL.Icon-md-teL1u{background-position:-5664px -132px}.Icon-tenant-SmxIq.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-tenant-SmxIq.Icon-md-teL1u,a.active .Icon-tenant-SmxIq.Icon-md-teL1u,a:hover .Icon-tenant-SmxIq.Icon-md-teL1u,button.active .Icon-tenant-SmxIq.Icon-md-teL1u,button:hover .Icon-tenant-SmxIq.Icon-md-teL1u{background-position:-5616px -132px}.Icon-tenant-SmxIq.Icon-md-teL1u{background-position:-5664px -132px}.Icon-landlord-1khCV.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-landlord-1khCV.Icon-md-teL1u,a.active .Icon-landlord-1khCV.Icon-md-teL1u,a:hover .Icon-landlord-1khCV.Icon-md-teL1u,button.active .Icon-landlord-1khCV.Icon-md-teL1u,button:hover .Icon-landlord-1khCV.Icon-md-teL1u{background-position:-5616px -132px}.Icon-landlord-1khCV.Icon-md-teL1u{background-position:-5664px -132px}.Icon-homeOwnerAssociation-MuCHH.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-homeOwnerAssociation-MuCHH.Icon-md-teL1u,a.active .Icon-homeOwnerAssociation-MuCHH.Icon-md-teL1u,a:hover .Icon-homeOwnerAssociation-MuCHH.Icon-md-teL1u,button.active .Icon-homeOwnerAssociation-MuCHH.Icon-md-teL1u,button:hover .Icon-homeOwnerAssociation-MuCHH.Icon-md-teL1u{background-position:-5616px -132px}.Icon-homeOwnerAssociation-MuCHH.Icon-md-teL1u{background-position:-5664px -132px}.Icon-inspector-1SjWT.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-inspector-1SjWT.Icon-md-teL1u,a.active .Icon-inspector-1SjWT.Icon-md-teL1u,a:hover .Icon-inspector-1SjWT.Icon-md-teL1u,button.active .Icon-inspector-1SjWT.Icon-md-teL1u,button:hover .Icon-inspector-1SjWT.Icon-md-teL1u{background-position:-5712px -132px}.Icon-inspector-1SjWT.Icon-md-teL1u{background-position:-5760px -132px}.Icon-administrator-2QU7R.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-administrator-2QU7R.Icon-md-teL1u,a.active .Icon-administrator-2QU7R.Icon-md-teL1u,a:hover .Icon-administrator-2QU7R.Icon-md-teL1u,button.active .Icon-administrator-2QU7R.Icon-md-teL1u,button:hover .Icon-administrator-2QU7R.Icon-md-teL1u{background-position:-5808px -132px}.Icon-administrator-2QU7R.Icon-md-teL1u{background-position:-5856px -132px}.Icon-patrimonyManager-3qFOU.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-patrimonyManager-3qFOU.Icon-md-teL1u,a.active .Icon-patrimonyManager-3qFOU.Icon-md-teL1u,a:hover .Icon-patrimonyManager-3qFOU.Icon-md-teL1u,button.active .Icon-patrimonyManager-3qFOU.Icon-md-teL1u,button:hover .Icon-patrimonyManager-3qFOU.Icon-md-teL1u{background-position:-5808px -132px}.Icon-patrimonyManager-3qFOU.Icon-md-teL1u{background-position:-5856px -132px}.Icon-careTaker-3Vz2e.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-careTaker-3Vz2e.Icon-md-teL1u,a.active .Icon-careTaker-3Vz2e.Icon-md-teL1u,a:hover .Icon-careTaker-3Vz2e.Icon-md-teL1u,button.active .Icon-careTaker-3Vz2e.Icon-md-teL1u,button:hover .Icon-careTaker-3Vz2e.Icon-md-teL1u{background-position:-5904px -132px}.Icon-careTaker-3Vz2e.Icon-md-teL1u{background-position:-5952px -132px}.Icon-admin-27Gsn.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-admin-27Gsn.Icon-md-teL1u,a.active .Icon-admin-27Gsn.Icon-md-teL1u,a:hover .Icon-admin-27Gsn.Icon-md-teL1u,button.active .Icon-admin-27Gsn.Icon-md-teL1u,button:hover .Icon-admin-27Gsn.Icon-md-teL1u{background-position:-6000px -132px}.Icon-admin-27Gsn.Icon-md-teL1u{background-position:-6048px -132px}.Icon-cross-1I_XA.Icon-md-teL1u{background-position:-6096px -132px}.Icon-cross-1I_XA.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-cross-1I_XA.Icon-md-teL1u,a.active .Icon-cross-1I_XA.Icon-md-teL1u,a:hover .Icon-cross-1I_XA.Icon-md-teL1u,button.active .Icon-cross-1I_XA.Icon-md-teL1u,button:hover .Icon-cross-1I_XA.Icon-md-teL1u{background-position:-6144px -132px}.Icon-defaultOpeningTicketPurposeIcon-10Q1x.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-defaultOpeningTicketPurposeIcon-10Q1x.Icon-md-teL1u,a.active .Icon-defaultOpeningTicketPurposeIcon-10Q1x.Icon-md-teL1u,a:hover .Icon-defaultOpeningTicketPurposeIcon-10Q1x.Icon-md-teL1u,button.active .Icon-defaultOpeningTicketPurposeIcon-10Q1x.Icon-md-teL1u,button:hover .Icon-defaultOpeningTicketPurposeIcon-10Q1x.Icon-md-teL1u{background-position:-6192px -132px}.Icon-defaultOpeningTicketPurposeIcon-10Q1x.Icon-md-teL1u{background-position:-6240px -132px}.Icon-bugs-21qlT.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-bugs-21qlT.Icon-md-teL1u,a.active .Icon-bugs-21qlT.Icon-md-teL1u,a:hover .Icon-bugs-21qlT.Icon-md-teL1u,button.active .Icon-bugs-21qlT.Icon-md-teL1u,button:hover .Icon-bugs-21qlT.Icon-md-teL1u{background-position:-6288px -132px}.Icon-bugs-21qlT.Icon-md-teL1u{background-position:-6336px -132px}.Icon-relocate-23abZ.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-relocate-23abZ.Icon-md-teL1u,a.active .Icon-relocate-23abZ.Icon-md-teL1u,a:hover .Icon-relocate-23abZ.Icon-md-teL1u,button.active .Icon-relocate-23abZ.Icon-md-teL1u,button:hover .Icon-relocate-23abZ.Icon-md-teL1u{background-position:-6384px -132px}.Icon-relocate-23abZ.Icon-md-teL1u{background-position:-6432px -132px}.Icon-police-1RH8t.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-police-1RH8t.Icon-md-teL1u,a.active .Icon-police-1RH8t.Icon-md-teL1u,a:hover .Icon-police-1RH8t.Icon-md-teL1u,button.active .Icon-police-1RH8t.Icon-md-teL1u,button:hover .Icon-police-1RH8t.Icon-md-teL1u{background-position:-6480px -132px}.Icon-police-1RH8t.Icon-md-teL1u{background-position:-6528px -132px}.Icon-questionmark-1C-GT.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-questionmark-1C-GT.Icon-md-teL1u,a.active .Icon-questionmark-1C-GT.Icon-md-teL1u,a:hover .Icon-questionmark-1C-GT.Icon-md-teL1u,button.active .Icon-questionmark-1C-GT.Icon-md-teL1u,button:hover .Icon-questionmark-1C-GT.Icon-md-teL1u{background-position:-6576px -132px}.Icon-questionmark-1C-GT.Icon-md-teL1u{background-position:-6624px -132px}.Icon-message-37c68.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-message-37c68.Icon-md-teL1u,a.active .Icon-message-37c68.Icon-md-teL1u,a:hover .Icon-message-37c68.Icon-md-teL1u,button.active .Icon-message-37c68.Icon-md-teL1u,button:hover .Icon-message-37c68.Icon-md-teL1u{background-position:-6672px -132px}.Icon-message-37c68.Icon-md-teL1u{background-position:-6720px -132px}.Icon-marker-Pcmxp.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-marker-Pcmxp.Icon-md-teL1u,a.active .Icon-marker-Pcmxp.Icon-md-teL1u,a:hover .Icon-marker-Pcmxp.Icon-md-teL1u,button.active .Icon-marker-Pcmxp.Icon-md-teL1u,button:hover .Icon-marker-Pcmxp.Icon-md-teL1u{background-position:-6768px -132px}.Icon-marker-Pcmxp.Icon-md-teL1u{background-position:-6816px -132px}.Icon-roof-34vs4.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-roof-34vs4.Icon-md-teL1u,a.active .Icon-roof-34vs4.Icon-md-teL1u,a:hover .Icon-roof-34vs4.Icon-md-teL1u,button.active .Icon-roof-34vs4.Icon-md-teL1u,button:hover .Icon-roof-34vs4.Icon-md-teL1u{background-position:-6864px -132px}.Icon-roof-34vs4.Icon-md-teL1u{background-position:-6912px -132px}.Icon-masonry-17wjF.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-masonry-17wjF.Icon-md-teL1u,a.active .Icon-masonry-17wjF.Icon-md-teL1u,a:hover .Icon-masonry-17wjF.Icon-md-teL1u,button.active .Icon-masonry-17wjF.Icon-md-teL1u,button:hover .Icon-masonry-17wjF.Icon-md-teL1u{background-position:-6960px -132px}.Icon-masonry-17wjF.Icon-md-teL1u{background-position:-7008px -132px}.Icon-wrench-LgGNV.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-wrench-LgGNV.Icon-md-teL1u,a.active .Icon-wrench-LgGNV.Icon-md-teL1u,a:hover .Icon-wrench-LgGNV.Icon-md-teL1u,button.active .Icon-wrench-LgGNV.Icon-md-teL1u,button:hover .Icon-wrench-LgGNV.Icon-md-teL1u{background-position:-7056px -132px}.Icon-wrench-LgGNV.Icon-md-teL1u{background-position:-7104px -132px}.Icon-intercom-1z0-1.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-intercom-1z0-1.Icon-md-teL1u,a.active .Icon-intercom-1z0-1.Icon-md-teL1u,a:hover .Icon-intercom-1z0-1.Icon-md-teL1u,button.active .Icon-intercom-1z0-1.Icon-md-teL1u,button:hover .Icon-intercom-1z0-1.Icon-md-teL1u{background-position:-7152px -132px}.Icon-intercom-1z0-1.Icon-md-teL1u{background-position:-7200px -132px}.Icon-swimmingpool-2WKrI.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-swimmingpool-2WKrI.Icon-md-teL1u,a.active .Icon-swimmingpool-2WKrI.Icon-md-teL1u,a:hover .Icon-swimmingpool-2WKrI.Icon-md-teL1u,button.active .Icon-swimmingpool-2WKrI.Icon-md-teL1u,button:hover .Icon-swimmingpool-2WKrI.Icon-md-teL1u{background-position:-7248px -132px}.Icon-swimmingpool-2WKrI.Icon-md-teL1u{background-position:-7296px -132px}.Icon-fail-2LGXP.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-fail-2LGXP.Icon-md-teL1u,a.active .Icon-fail-2LGXP.Icon-md-teL1u,a:hover .Icon-fail-2LGXP.Icon-md-teL1u,button.active .Icon-fail-2LGXP.Icon-md-teL1u,button:hover .Icon-fail-2LGXP.Icon-md-teL1u{background-position:-7344px -132px}.Icon-fail-2LGXP.Icon-md-teL1u{background-position:-7392px -132px}.Icon-warning-3nAze.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-warning-3nAze.Icon-md-teL1u,a.active .Icon-warning-3nAze.Icon-md-teL1u,a:hover .Icon-warning-3nAze.Icon-md-teL1u,button.active .Icon-warning-3nAze.Icon-md-teL1u,button:hover .Icon-warning-3nAze.Icon-md-teL1u{background-position:-7440px -132px}.Icon-warning-3nAze.Icon-md-teL1u{background-position:-7488px -132px}.Icon-other-2SRun.Icon-md-teL1u,.Icon-other-2SRun.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-other-2SRun.Icon-md-teL1u,a.active .Icon-other-2SRun.Icon-md-teL1u,a:hover .Icon-other-2SRun.Icon-md-teL1u,button.active .Icon-other-2SRun.Icon-md-teL1u,button:hover .Icon-other-2SRun.Icon-md-teL1u{background-position:-7536px -132px}.Icon-ticket-2ZyI8.Icon-md-teL1u{background-position:-7584px -132px}.Icon-plus-2ox9j.Icon-md-teL1u{background-position:-7632px -132px}.Icon-plus-2ox9j.Icon-md-teL1u.Icon-active-3momR,.nav>li.active .Icon-plus-2ox9j.Icon-md-teL1u,a.active .Icon-plus-2ox9j.Icon-md-teL1u,a:hover .Icon-plus-2ox9j.Icon-md-teL1u,button.active .Icon-plus-2ox9j.Icon-md-teL1u,button:hover .Icon-plus-2ox9j.Icon-md-teL1u{background-position:-7680px -132px}.Icon-ticket-2ZyI8.Icon-lg-uXFJQ{background-position:0 -72px}.Icon-patrimony-UON0E.Icon-lg-uXFJQ{background-position:-60px -72px}.Icon-customer-18Vak.Icon-lg-uXFJQ{background-position:-120px -72px}.Icon-provider-kUjXP.Icon-lg-uXFJQ{background-position:-180px -72px}.Icon-ticket-2ZyI8.Icon-lg-uXFJQ.Icon-active-3momR,.nav>li.active .Icon-ticket-2ZyI8.Icon-lg-uXFJQ,a.active .Icon-ticket-2ZyI8.Icon-lg-uXFJQ,a:hover .Icon-ticket-2ZyI8.Icon-lg-uXFJQ,button.active .Icon-ticket-2ZyI8.Icon-lg-uXFJQ,button:hover .Icon-ticket-2ZyI8.Icon-lg-uXFJQ{background-position:-240px -72px}.Icon-patrimony-UON0E.Icon-lg-uXFJQ.Icon-active-3momR,.nav>li.active .Icon-patrimony-UON0E.Icon-lg-uXFJQ,a.active .Icon-patrimony-UON0E.Icon-lg-uXFJQ,a:hover .Icon-patrimony-UON0E.Icon-lg-uXFJQ,button.active .Icon-patrimony-UON0E.Icon-lg-uXFJQ,button:hover .Icon-patrimony-UON0E.Icon-lg-uXFJQ{background-position:-300px -72px}.Icon-customer-18Vak.Icon-lg-uXFJQ.Icon-active-3momR,.nav>li.active .Icon-customer-18Vak.Icon-lg-uXFJQ,a.active .Icon-customer-18Vak.Icon-lg-uXFJQ,a:hover .Icon-customer-18Vak.Icon-lg-uXFJQ,button.active .Icon-customer-18Vak.Icon-lg-uXFJQ,button:hover .Icon-customer-18Vak.Icon-lg-uXFJQ{background-position:-360px -72px}.Icon-provider-kUjXP.Icon-lg-uXFJQ.Icon-active-3momR,.nav>li.active .Icon-provider-kUjXP.Icon-lg-uXFJQ,a.active .Icon-provider-kUjXP.Icon-lg-uXFJQ,a:hover .Icon-provider-kUjXP.Icon-lg-uXFJQ,button.active .Icon-provider-kUjXP.Icon-lg-uXFJQ,button:hover .Icon-provider-kUjXP.Icon-lg-uXFJQ{background-position:-420px -72px}.Icon-organisation-YcjBu.Icon-lg-uXFJQ{background-position:-480px -72px}.Icon-organisation-YcjBu.Icon-lg-uXFJQ.Icon-active-3momR,.nav>li.active .Icon-organisation-YcjBu.Icon-lg-uXFJQ,a.active .Icon-organisation-YcjBu.Icon-lg-uXFJQ,a:hover .Icon-organisation-YcjBu.Icon-lg-uXFJQ,button.active .Icon-organisation-YcjBu.Icon-lg-uXFJQ,button:hover .Icon-organisation-YcjBu.Icon-lg-uXFJQ{background-position:-540px -72px}.Icon-bullhorn-2nxG-.Icon-xl-c0ue7{background-position:0 0}.Icon-key-UgBr_.Icon-xl-c0ue7{background-position:-72px 0}.Icon-ticket-opened-1tNgl.Icon-xl-c0ue7{background-position:-144px 0}.Icon-ticket-closed-2ImRE.Icon-xl-c0ue7{background-position:-216px 0}.Icon-ticket-opened-1tNgl.Icon-xl-c0ue7.Icon-active-3momR,.nav>li.active .Icon-ticket-opened-1tNgl.Icon-xl-c0ue7,a.active .Icon-ticket-opened-1tNgl.Icon-xl-c0ue7,a:hover .Icon-ticket-opened-1tNgl.Icon-xl-c0ue7,button.active .Icon-ticket-opened-1tNgl.Icon-xl-c0ue7,button:hover .Icon-ticket-opened-1tNgl.Icon-xl-c0ue7{background-position:-288px 0}.Icon-ticket-closed-2ImRE.Icon-xl-c0ue7.Icon-active-3momR,.nav>li.active .Icon-ticket-closed-2ImRE.Icon-xl-c0ue7,a.active .Icon-ticket-closed-2ImRE.Icon-xl-c0ue7,a:hover .Icon-ticket-closed-2ImRE.Icon-xl-c0ue7,button.active .Icon-ticket-closed-2ImRE.Icon-xl-c0ue7,button:hover .Icon-ticket-closed-2ImRE.Icon-xl-c0ue7{background-position:-360px 0}.Icon-hourglass-WL6JL.Icon-xl-c0ue7{background-position:-432px 0}.Icon-clock-elapsed-2BjtT.Icon-xl-c0ue7{background-position:-504px 0}.Icon-file-hZCfO.Icon-xl-c0ue7{background-position:-576px 0}.Icon-calendar-3TTwY.Icon-xl-c0ue7{background-position:-648px 0}.Icon-clock-JTIiz.Icon-xl-c0ue7{background-position:-720px 0}.Icon-ticket-with-intervention-3-KHj.Icon-xl-c0ue7{background-position:-792px 0}.Icon-ticket-without-intervention-2ScPv.Icon-xl-c0ue7{background-position:-864px 0}.Icon-ticket-with-intervention-3-KHj.Icon-xl-c0ue7.Icon-active-3momR,.nav>li.active .Icon-ticket-with-intervention-3-KHj.Icon-xl-c0ue7,a.active .Icon-ticket-with-intervention-3-KHj.Icon-xl-c0ue7,a:hover .Icon-ticket-with-intervention-3-KHj.Icon-xl-c0ue7,button.active .Icon-ticket-with-intervention-3-KHj.Icon-xl-c0ue7,button:hover .Icon-ticket-with-intervention-3-KHj.Icon-xl-c0ue7{background-position:-936px 0}.Icon-ticket-without-intervention-2ScPv.Icon-xl-c0ue7.Icon-active-3momR,.nav>li.active .Icon-ticket-without-intervention-2ScPv.Icon-xl-c0ue7,a.active .Icon-ticket-without-intervention-2ScPv.Icon-xl-c0ue7,a:hover .Icon-ticket-without-intervention-2ScPv.Icon-xl-c0ue7,button.active .Icon-ticket-without-intervention-2ScPv.Icon-xl-c0ue7,button:hover .Icon-ticket-without-intervention-2ScPv.Icon-xl-c0ue7{background-position:-1008px 0}.Icon-exportPdf-J2IMl.Icon-xl-c0ue7,.Icon-reportPdf-3mJ50.Icon-xl-c0ue7{background-position:-1080px 0}.Icon-exportPdf-J2IMl.Icon-xl-c0ue7.Icon-active-3momR,.Icon-reportPdf-3mJ50.Icon-xl-c0ue7.Icon-active-3momR,.nav>li.active .Icon-exportPdf-J2IMl.Icon-xl-c0ue7,.nav>li.active .Icon-reportPdf-3mJ50.Icon-xl-c0ue7,a.active .Icon-exportPdf-J2IMl.Icon-xl-c0ue7,a.active .Icon-reportPdf-3mJ50.Icon-xl-c0ue7,a:hover .Icon-exportPdf-J2IMl.Icon-xl-c0ue7,a:hover .Icon-reportPdf-3mJ50.Icon-xl-c0ue7,button.active .Icon-exportPdf-J2IMl.Icon-xl-c0ue7,button.active .Icon-reportPdf-3mJ50.Icon-xl-c0ue7,button:hover .Icon-exportPdf-J2IMl.Icon-xl-c0ue7,button:hover .Icon-reportPdf-3mJ50.Icon-xl-c0ue7{background-position:-1152px 0}.Icon-exportXlsx-1xhq4.Icon-xl-c0ue7{background-position:-1224px 0}.Icon-exportXlsx-1xhq4.Icon-xl-c0ue7.Icon-active-3momR,.nav>li.active .Icon-exportXlsx-1xhq4.Icon-xl-c0ue7,a.active .Icon-exportXlsx-1xhq4.Icon-xl-c0ue7,a:hover .Icon-exportXlsx-1xhq4.Icon-xl-c0ue7,button.active .Icon-exportXlsx-1xhq4.Icon-xl-c0ue7,button:hover .Icon-exportXlsx-1xhq4.Icon-xl-c0ue7{background-position:-1296px 0}", ""]);
	
	// exports
	exports.locals = {
		"default": "Icon-default-vBMH2",
		"count": "Icon-count-1sA-Q",
		"success": "Icon-success-dSrgu",
		"warning": "Icon-warning-3nAze",
		"danger": "Icon-danger-1MuPC",
		"xs": "Icon-xs--tjeL",
		"sm": "Icon-sm-z1RxI",
		"md": "Icon-md-teL1u",
		"lg": "Icon-lg-uXFJQ",
		"xl": "Icon-xl-c0ue7",
		"status-success": "Icon-status-success-3EHhE",
		"status-warning": "Icon-status-warning-8QvZq",
		"status-danger": "Icon-status-danger-2LKG7",
		"cross": "Icon-cross-1I_XA",
		"active": "Icon-active-3momR",
		"checkbox": "Icon-checkbox-dzfdS",
		"checkbox-active": "Icon-checkbox-active-3wD_1",
		"cog": "Icon-cog-Zypr4",
		"sign-out": "Icon-sign-out-NdI5e",
		"clock": "Icon-clock-JTIiz",
		"phone": "Icon-phone-2Qqsg",
		"mail": "Icon-mail-fsaEu",
		"fax": "Icon-fax-1o4x2",
		"down": "Icon-down-3oep3",
		"up": "Icon-up-3yaFB",
		"gear": "Icon-gear-17kZ-",
		"plus": "Icon-plus-2ox9j",
		"minus": "Icon-minus-11uXI",
		"file": "Icon-file-hZCfO",
		"radio": "Icon-radio-3FUM7",
		"radio-active": "Icon-radio-active-2cCSQ",
		"calendar": "Icon-calendar-3TTwY",
		"pencil": "Icon-pencil-2Nkh-",
		"mailGear": "Icon-mailGear-3yxom",
		"agencyRefresh": "Icon-agencyRefresh-1QajM",
		"left": "Icon-left-2trd0",
		"quote": "Icon-quote-3Lauy",
		"search": "Icon-search-1lIr9",
		"patrimonyGear": "Icon-patrimonyGear-21MVG",
		"undeclaredWork": "Icon-undeclaredWork-2-nXo",
		"insurance": "Icon-insurance-WvyQi",
		"star": "Icon-star-2jxjd",
		"check": "Icon-check-3Tp_C",
		"patrimony": "Icon-patrimony-UON0E",
		"agency": "Icon-agency-LkD5o",
		"location": "Icon-location-3E9Pk",
		"individualHouse": "Icon-individualHouse-2JwKU",
		"checkWhite": "Icon-checkWhite-QBoJ5",
		"opened": "Icon-opened-3zZj3",
		"closed": "Icon-closed-ojYNP",
		"phone-question": "Icon-phone-question-3rL2q",
		"residentialParking": "Icon-residentialParking-1xvRn",
		"tertiaryParking": "Icon-tertiaryParking-287Wd",
		"apartment": "Icon-apartment-31gU5",
		"lot": "Icon-lot-3NIoh",
		"meetingRoom": "Icon-meetingRoom-5uIQq",
		"restaurant": "Icon-restaurant-1hOZ5",
		"fitness": "Icon-fitness-1Kjh3",
		"spa": "Icon-spa-21lLm",
		"sportFacility": "Icon-sportFacility-nPP6W",
		"otherService": "Icon-otherService-33Lra",
		"otherTechnical": "Icon-otherTechnical-xMPGK",
		"building": "Icon-building-5wRmn",
		"workspace": "Icon-workspace-3PlJV",
		"workstation": "Icon-workstation-e6J2e",
		"office": "Icon-office-3rs3t",
		"warehouse": "Icon-warehouse-3VbtW",
		"gasStation": "Icon-gasStation-3R0YQ",
		"pool": "Icon-pool-387r5",
		"poolHouse": "Icon-poolHouse-25OYe",
		"playground": "Icon-playground-xcymK",
		"laundry": "Icon-laundry-HWxvG",
		"machineRoom": "Icon-machineRoom-2pku9",
		"binStorageArea": "Icon-binStorageArea-3IB8A",
		"gardeningShed": "Icon-gardeningShed-2Urt0",
		"intercom": "Icon-intercom-1z0-1",
		"retailShop": "Icon-retailShop-3IwQ2",
		"boilerRoom": "Icon-boilerRoom-1gmyl",
		"ventilationSystem": "Icon-ventilationSystem-3l16V",
		"elevator": "Icon-elevator-1LGCv",
		"gate": "Icon-gate-1qrJ1",
		"pdf": "Icon-pdf-2puWA",
		"clientAccount": "Icon-clientAccount-1FbVA",
		"user": "Icon-user-uc4wZ",
		"archived": "Icon-archived-BS43p",
		"comment": "Icon-comment-27vDP",
		"download": "Icon-download-3RB6w",
		"buildingz": "Icon-buildingz-3_-rD",
		"banner": "Icon-banner-2ddF5",
		"premiumAccount": "Icon-premiumAccount-ZhJju",
		"canceled": "Icon-canceled-2gmdR",
		"residentialCellar": "Icon-residentialCellar-1lOnG",
		"residentialAnnex": "Icon-residentialAnnex-stUxQ",
		"receiveCall": "Icon-receiveCall-3aDuS",
		"emitCall": "Icon-emitCall-d1Djb",
		"standardAccount": "Icon-standardAccount-3zESY",
		"arrow": "Icon-arrow-1ywuT",
		"customer": "Icon-customer-18Vak",
		"starHalf": "Icon-starHalf-TId_V",
		"tertiary": "Icon-tertiary-1-oFi",
		"technical": "Icon-technical-2olkF",
		"service": "Icon-service-mCtx2",
		"residential": "Icon-residential-1Vbz4",
		"clientAccountHolding": "Icon-clientAccountHolding-L_99X",
		"callCenter": "Icon-callCenter-2qlwq",
		"clientAccountManager": "Icon-clientAccountManager-3zfWv",
		"callCenterUser": "Icon-callCenterUser-kB5J1",
		"callCenterOperator": "Icon-callCenterOperator-2ict2",
		"executive": "Icon-executive-gAw8W",
		"barrier": "Icon-barrier-3GSq-",
		"closedlock": "Icon-closedlock-374p3",
		"openlock": "Icon-openlock-npJYK",
		"fence": "Icon-fence-33nRw",
		"door": "Icon-door-2YKQs",
		"window": "Icon-window-1gnOo",
		"rollerblind": "Icon-rollerblind-1_SHV",
		"keys": "Icon-keys-zDrjW",
		"brokenglass": "Icon-brokenglass-1rakx",
		"boiler": "Icon-boiler-2bkPv",
		"heater": "Icon-heater-2DEF2",
		"electrecity": "Icon-electrecity-Yt0kw",
		"elecman": "Icon-elecman-2C5HK",
		"lamp": "Icon-lamp-1G8Mu",
		"hotwater": "Icon-hotwater-2p4KZ",
		"plumber": "Icon-plumber-_BXjC",
		"tap": "Icon-tap-3hPbB",
		"waterdrop": "Icon-waterdrop-1ZuQ1",
		"waterman": "Icon-waterman-QwcWJ",
		"watertap": "Icon-watertap-Rng3T",
		"extinctor": "Icon-extinctor-2DeQd",
		"firealarm": "Icon-firealarm-3s6QP",
		"firefighters": "Icon-firefighters-3f2wN",
		"intrusionalarm": "Icon-intrusionalarm-3vhrp",
		"alarm": "Icon-alarm-i2BG_",
		"burglar": "Icon-burglar-NY8AK",
		"evacuate": "Icon-evacuate-1wBox",
		"explosion": "Icon-explosion-2G4uT",
		"flood": "Icon-flood-1b1r1",
		"vandalism": "Icon-vandalism-14pR5",
		"litter": "Icon-litter-3sVrk",
		"pump": "Icon-pump-31f70",
		"bucket": "Icon-bucket-3fqHo",
		"vent": "Icon-vent-VGkaS",
		"smokevent": "Icon-smokevent-2L84A",
		"parkingvent": "Icon-parkingvent-2x_fT",
		"gasvent": "Icon-gasvent-3nL4t",
		"aircon": "Icon-aircon-1r6hG",
		"gasman": "Icon-gasman-vxs1x",
		"gas": "Icon-gas-1oiQ5",
		"manogas": "Icon-manogas-3PcwY",
		"pipe": "Icon-pipe-Uktqp",
		"pressure": "Icon-pressure-3c2ao",
		"parking": "Icon-parking-1_5wd",
		"terminal": "Icon-terminal-26_Ez",
		"monitoring": "Icon-monitoring-1-Px1",
		"tv": "Icon-tv-rrcGb",
		"manager": "Icon-manager-3Fi4L",
		"owner": "Icon-owner-2IESL",
		"tenant": "Icon-tenant-SmxIq",
		"landlord": "Icon-landlord-1khCV",
		"homeOwnerAssociation": "Icon-homeOwnerAssociation-MuCHH",
		"inspector": "Icon-inspector-1SjWT",
		"administrator": "Icon-administrator-2QU7R",
		"patrimonyManager": "Icon-patrimonyManager-3qFOU",
		"careTaker": "Icon-careTaker-3Vz2e",
		"admin": "Icon-admin-27Gsn",
		"defaultOpeningTicketPurposeIcon": "Icon-defaultOpeningTicketPurposeIcon-10Q1x",
		"bugs": "Icon-bugs-21qlT",
		"relocate": "Icon-relocate-23abZ",
		"police": "Icon-police-1RH8t",
		"questionmark": "Icon-questionmark-1C-GT",
		"message": "Icon-message-37c68",
		"marker": "Icon-marker-Pcmxp",
		"roof": "Icon-roof-34vs4",
		"masonry": "Icon-masonry-17wjF",
		"wrench": "Icon-wrench-LgGNV",
		"swimmingpool": "Icon-swimmingpool-2WKrI",
		"fail": "Icon-fail-2LGXP",
		"other": "Icon-other-2SRun",
		"ticket": "Icon-ticket-2ZyI8",
		"provider": "Icon-provider-kUjXP",
		"organisation": "Icon-organisation-YcjBu",
		"bullhorn": "Icon-bullhorn-2nxG-",
		"key": "Icon-key-UgBr_",
		"ticket-opened": "Icon-ticket-opened-1tNgl",
		"ticket-closed": "Icon-ticket-closed-2ImRE",
		"hourglass": "Icon-hourglass-WL6JL",
		"clock-elapsed": "Icon-clock-elapsed-2BjtT",
		"ticket-with-intervention": "Icon-ticket-with-intervention-3-KHj",
		"ticket-without-intervention": "Icon-ticket-without-intervention-2ScPv",
		"exportPdf": "Icon-exportPdf-J2IMl",
		"reportPdf": "Icon-reportPdf-3mJ50",
		"exportXlsx": "Icon-exportXlsx-1xhq4"
	};

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".IconCateg-iconCateg-3BZD6{fill:#133a7f}.IconCateg-exponent-2QEzX{background-color:#ff5766;border-radius:10px;font-weight:700;font-style:normal;padding:2px 5px;min-width:10px;line-height:20px;text-align:center;color:#fff;position:absolute;height:20px;right:10px}", ""]);
	
	// exports
	exports.locals = {
		"iconCateg": "IconCateg-iconCateg-3BZD6",
		"exponent": "IconCateg-exponent-2QEzX"
	};

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Loader-default-35b3F{margin:200px 0;font-size:26px;text-align:center;text-transform:uppercase;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"default": "Loader-default-35b3F"
	};

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".MultiInput-add-QUZGy{margin-bottom:15px;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"add": "MultiInput-add-QUZGy"
	};

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".PercentageDashboardPanel-progressBar-15uME{display:block;width:50%;background:#fff;border-radius:4px;line-height:1;font-size:11.2px;text-align:right}.PercentageDashboardPanel-progressBar-15uME.PercentageDashboardPanel-color8-2ltMH{background:#8130e7}.PercentageDashboardPanel-progressBar-15uME.PercentageDashboardPanel-color7-1czLq{background:#f39431}.PercentageDashboardPanel-progressBar-15uME.PercentageDashboardPanel-color6-T2g2G{background:#ffe45f}.PercentageDashboardPanel-progressBar-15uME.PercentageDashboardPanel-color5-1MD9R{background:#4c0065}.PercentageDashboardPanel-progressBar-15uME.PercentageDashboardPanel-color4-z73lZ{background:#00a79e}.PercentageDashboardPanel-progressBar-15uME.PercentageDashboardPanel-color3-18i48{background:#ff5c44}.PercentageDashboardPanel-progressBar-15uME.PercentageDashboardPanel-color2-24Q8n{background:#00d8ff}.PercentageDashboardPanel-progressBar-15uME.PercentageDashboardPanel-color1-1GljD{background:#a6fffa}.PercentageDashboardPanel-progressBar-15uME>span{display:inline-block;width:40px;margin:0 -40px 0 0;padding:0 0 0 4px;text-align:left}.PercentageDashboardPanel-metricGroup-3T0x3{margin:0;padding:0;list-style:none}.PercentageDashboardPanel-metricGroup-3T0x3>li{overflow:hidden}.PercentageDashboardPanel-metricGroup-3T0x3>li .PercentageDashboardPanel-container-1_zfP{float:left;width:60%;margin:0 10px 0 0;padding:10px 10px 10px 0;border-right:1px solid #a4b1b7;font-size:14px;font-weight:400;text-transform:uppercase}.PercentageDashboardPanel-metricGroup-3T0x3>li .PercentageDashboardPanel-progress-2uksW{overflow:hidden;padding:0 40px 0 0;margin-top:10px;margin-bottom:10px}", ""]);
	
	// exports
	exports.locals = {
		"progressBar": "PercentageDashboardPanel-progressBar-15uME",
		"color8": "PercentageDashboardPanel-color8-2ltMH",
		"color7": "PercentageDashboardPanel-color7-1czLq",
		"color6": "PercentageDashboardPanel-color6-T2g2G",
		"color5": "PercentageDashboardPanel-color5-1MD9R",
		"color4": "PercentageDashboardPanel-color4-z73lZ",
		"color3": "PercentageDashboardPanel-color3-18i48",
		"color2": "PercentageDashboardPanel-color2-24Q8n",
		"color1": "PercentageDashboardPanel-color1-1GljD",
		"metricGroup": "PercentageDashboardPanel-metricGroup-3T0x3",
		"container": "PercentageDashboardPanel-container-1_zfP",
		"progress": "PercentageDashboardPanel-progress-2uksW"
	};

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Picker-default-1Aw-R{border:1px solid transparent;border-radius:4px}.Picker-default-1Aw-R .Picker-picked-1C8XB h4{margin:0;font-weight:400;text-transform:uppercase;text-align:center}.Picker-result-3ar3R{margin:0;padding:0;list-style-type:none;text-align:left}.Picker-result-3ar3R>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.Picker-result-3ar3R>li.Picker-after-2BarQ p{text-align:center;font-weight:300;color:#b0bec5}.Picker-result-3ar3R>li.Picker-disabled-nHLu4{opacity:.5}.Picker-result-3ar3R>li .Picker-add-36T4G,.Picker-result-3ar3R>li .Picker-remove-2m9eJ{display:block;float:right}.Picker-result-3ar3R>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}@media (min-width:768px){.Picker-result-3ar3R{max-height:450px;overflow-y:auto}}.Picker-picked-1C8XB{position:relative;overflow:hidden;border:1px solid #4cffed;border-radius:5px;background:#b2fff7;text-align:left}.Picker-picked-1C8XB .Picker-remove-2m9eJ{position:absolute;top:10px;right:10px;z-index:1000}.Picker-picked-1C8XB .Picker-remove-2m9eJ a{display:block}.Picker-picked-1C8XB .Picker-container-2Qpm2{margin-right:34px;padding:10px}.Picker-error-2zOps{border-color:#ff5766}@media (min-width:768px){.Picker-small-5KSbR .Picker-result-3ar3R{max-height:225px}}", ""]);
	
	// exports
	exports.locals = {
		"default": "Picker-default-1Aw-R",
		"picked": "Picker-picked-1C8XB",
		"result": "Picker-result-3ar3R",
		"after": "Picker-after-2BarQ",
		"disabled": "Picker-disabled-nHLu4",
		"add": "Picker-add-36T4G",
		"remove": "Picker-remove-2m9eJ",
		"container": "Picker-container-2Qpm2",
		"error": "Picker-error-2zOps",
		"small": "Picker-small-5KSbR"
	};

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".RadioToggle-default-2XR69{border:1px solid transparent;border-radius:4px}.RadioToggle-error-20LTf{border-color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"default": "RadioToggle-default-2XR69",
		"error": "RadioToggle-error-20LTf"
	};

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".RankingDashboardPanel-metricGroup-zZKjF{margin:0;padding:0;list-style:none}.RankingDashboardPanel-metricGroup-zZKjF>li{display:block;overflow:hidden;margin:10px 10px 10px 0}.RankingDashboardPanel-metricGroup-zZKjF>li .RankingDashboardPanel-container-2KVzm{display:block;overflow:hidden;margin:0;font-size:20px;font-weight:300}.RankingDashboardPanel-metricGroup-zZKjF>li .RankingDashboardPanel-container-2KVzm small{display:block;font-size:14px}.RankingDashboardPanel-metricGroup-zZKjF>li .RankingDashboardPanel-rank-3LC9d{display:block;float:left;min-width:20px;margin:2px 10px 0 0;padding:4px 0 2px;background:#a4b1b7;border-radius:9px;line-height:1;text-align:center;font-size:14px;font-weight:400}.RankingDashboardPanel-light-_ktk4 .RankingDashboardPanel-rank-3LC9d{color:#fff}", ""]);
	
	// exports
	exports.locals = {
		"metricGroup": "RankingDashboardPanel-metricGroup-zZKjF",
		"container": "RankingDashboardPanel-container-2KVzm",
		"rank": "RankingDashboardPanel-rank-3LC9d",
		"light": "RankingDashboardPanel-light-_ktk4"
	};

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Rating-default-3YoCM{margin:5px 0;background:#fbfbfb}.Rating-score-3A4di{position:relative;float:left;margin:-5px 0 -5px 15px;padding:10px 15px;background:#00e5ce;text-align:center;color:#fff}.Rating-score-3A4di strong{display:block;height:36px;width:30px;line-height:36px;font-weight:400;font-size:20px}.Rating-score-3A4di small{position:absolute;display:block;bottom:0;left:0;right:0;font-size:14px}.Rating-body-Ly1kv{overflow:hidden;padding:5px;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "Rating-default-3YoCM",
		"score": "Rating-score-3A4di",
		"body": "Rating-body-Ly1kv"
	};

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".SearchBar-default-3qrp0{position:relative;margin-bottom:20px;border-bottom:1px solid #dadada}.SearchBar-default-3qrp0 h3,.SearchBar-default-3qrp0 h4{text-transform:uppercase;font-weight:400}.SearchBar-header-3Rr2R{overflow:hidden;position:relative;margin-bottom:-1px;background:#fbfbfb;border-bottom:1px solid #dadada}.SearchBar-body-3Z2Jw{overflow:hidden;background:#fff}.SearchBar-body-3Z2Jw.SearchBar-enter-MDySY{max-height:0}.SearchBar-body-3Z2Jw.SearchBar-enter-MDySY.SearchBar-enterActive-3sJzn{max-height:500px;transition:max-height .5s ease}.SearchBar-body-3Z2Jw.SearchBar-leave-5gBod{max-height:500px}.SearchBar-body-3Z2Jw.SearchBar-leave-5gBod.SearchBar-leaveActive-U-VBX{max-height:0;transition:max-height .5s ease}.SearchBar-body-3Z2Jw .SearchBar-container-3TPaE{padding:10px 0}.SearchBar-footer-16JHJ{background:#fff}.SearchBar-footer-16JHJ .SearchBar-container-3TPaE{padding:10px 0;border-top:1px solid #dadada}.SearchBar-search-1Q2X8{overflow:hidden;padding:10px 15px 10px 0}.SearchBar-search-1Q2X8 .SearchBar-container-3TPaE{overflow:hidden}.SearchBar-search-1Q2X8 .SearchBar-container-3TPaE input{height:48px;width:100%;border:0;background:transparent;font-size:30px;font-weight:400;text-transform:uppercase;line-height:30px;text-align:center;color:#546d79}.SearchBar-search-1Q2X8 .SearchBar-container-3TPaE input:-ms-input-placeholder{color:#546d79}.SearchBar-search-1Q2X8 .SearchBar-container-3TPaE input::placeholder{color:#546d79}.SearchBar-search-1Q2X8 .SearchBar-container-3TPaE input:focus{outline:0}.SearchBar-search-1Q2X8 .SearchBar-container-3TPaE input::-ms-clear{display:none}.SearchBar-search-1Q2X8 i{display:none}@media (min-width:768px){.SearchBar-search-1Q2X8 i{display:block;float:right}}.SearchBar-advance-dtvt_{float:right}@media (min-width:768px){.SearchBar-advance-dtvt_{width:33.33333333%}}.SearchBar-advanceContent-1PsKO{margin:0 -1000px 0 15px;padding:0 1000px 0 0;background:#fff}.SearchBar-advanceContent-1PsKO a{display:block;padding:16px 0;text-align:right;font-size:14px;font-weight:400;text-transform:uppercase;text-decoration:none;color:#00e5ce}.SearchBar-advanceContent-1PsKO a i{margin:0 5px 0 20px;vertical-align:middle}@media (min-width:768px){.SearchBar-advanceContent-1PsKO a i{margin:0 0 0 10px}}.SearchBar-advanceContent-1PsKO a span{display:none}@media (min-width:768px){.SearchBar-advanceContent-1PsKO a span{display:inline-block}}.SearchBar-small-3TvSL .SearchBar-header-3Rr2R{background:#fff}.SearchBar-small-3TvSL .SearchBar-header-3Rr2R .container{width:auto}.SearchBar-small-3TvSL .SearchBar-search-1Q2X8{padding:5px 0}.SearchBar-small-3TvSL .SearchBar-search-1Q2X8 input{font-size:20px;font-weight:300;text-transform:none;text-align:left;color:#b0bec5}.SearchBar-small-3TvSL .SearchBar-search-1Q2X8 input:-ms-input-placeholder{color:#b0bec5}.SearchBar-small-3TvSL .SearchBar-search-1Q2X8 input::placeholder{color:#b0bec5}", ""]);
	
	// exports
	exports.locals = {
		"default": "SearchBar-default-3qrp0",
		"header": "SearchBar-header-3Rr2R",
		"body": "SearchBar-body-3Z2Jw",
		"enter": "SearchBar-enter-MDySY",
		"enterActive": "SearchBar-enterActive-3sJzn",
		"leave": "SearchBar-leave-5gBod",
		"leaveActive": "SearchBar-leaveActive-U-VBX",
		"container": "SearchBar-container-3TPaE",
		"footer": "SearchBar-footer-16JHJ",
		"search": "SearchBar-search-1Q2X8",
		"advance": "SearchBar-advance-dtvt_",
		"advanceContent": "SearchBar-advanceContent-1PsKO",
		"small": "SearchBar-small-3TvSL"
	};

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Selector-default-26BSN{border:1px solid transparent;border-radius:4px}.Selector-result-1XsyI{margin:0;padding:0;list-style-type:none;text-align:left}.Selector-result-1XsyI>li{overflow:hidden;display:block;margin-bottom:10px;padding:10px;background:#d5dde5;border:1px solid transparent;cursor:pointer}.Selector-result-1XsyI>li.Selector-active-1qZDw{background:#fff;border:1px solid #00e5ce}.Selector-result-1XsyI>li.Selector-disabled-Zia9-{opacity:.5;cursor:not-allowed}.Selector-result-1XsyI>li.Selector-after-3mAwQ p{text-align:center;font-weight:300;color:#b0bec5}.Selector-result-1XsyI>li label{display:block;float:left}.Selector-result-1XsyI>li .Selector-container-1wgIm{overflow:hidden;font-weight:400;color:#8a959a}@media (min-width:768px){.Selector-result-1XsyI{max-height:450px;overflow-y:auto}}.Selector-checkbox-1Bvgv .Selector-result-1XsyI{padding-top:10px}.Selector-checkbox-1Bvgv .Selector-result-1XsyI>li{margin-bottom:10px;padding:0;background:none;border:0}.Selector-error-3K_4d{border-color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"default": "Selector-default-26BSN",
		"result": "Selector-result-1XsyI",
		"active": "Selector-active-1qZDw",
		"disabled": "Selector-disabled-Zia9-",
		"after": "Selector-after-3mAwQ",
		"container": "Selector-container-1wgIm",
		"checkbox": "Selector-checkbox-1Bvgv",
		"error": "Selector-error-3K_4d"
	};

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".StaticMap-default-rvH9g{position:relative;display:block;height:0;padding:0;overflow:hidden}.StaticMap-default-rvH9g img{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%}.StaticMap-info-1Epiv{position:absolute;z-index:500;top:10px;bottom:10px;left:10px;right:10px;background:#fff;border:1px solid #dadada;border-radius:5px}.StaticMap-infoContent-2ZwLI{margin:0;padding:10px;overflow-y:auto;height:100%;list-style-type:none}.StaticMap-infoContent-2ZwLI>li{overflow:hidden;display:block;margin:10px 0}.StaticMap-infoContent-2ZwLI>li p{margin-bottom:0}.StaticMap-infoContent-2ZwLI>li .StaticMap-label-2tv1E{float:left;margin:0 10px;font-weight:400;color:#546d79}.StaticMap-infoContent-2ZwLI>li .StaticMap-container-3dal1{overflow:hidden;margin:0;padding:0 0 0 10px}.StaticMap-clickable-1C5WB{cursor:pointer}", ""]);
	
	// exports
	exports.locals = {
		"default": "StaticMap-default-rvH9g",
		"info": "StaticMap-info-1Epiv",
		"infoContent": "StaticMap-infoContent-2ZwLI",
		"label": "StaticMap-label-2tv1E",
		"container": "StaticMap-container-3dal1",
		"clickable": "StaticMap-clickable-1C5WB"
	};

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Strip-default-p8_rj{margin-bottom:30px}.Strip-default-p8_rj h3,.Strip-default-p8_rj h4,.Strip-default-p8_rj h5{text-transform:uppercase}.Strip-default-p8_rj h3 small,.Strip-default-p8_rj h4 small,.Strip-default-p8_rj h5 small{text-transform:none;font-size:inherit;color:inherit}.Strip-header-1Zha6{color:#546d79}.Strip-header-1Zha6 h4,.Strip-header-1Zha6 h5{margin:0}.Strip-body-3-5Mm{position:relative}.Strip-bodyContent-U2ssD{margin-left:36px;padding:10px 0;border:1px solid #dadada;border-left:0;background:#fff}.Strip-bodyContent-U2ssD .Strip-container-2d1rz{overflow:hidden}.Strip-bodyContent-U2ssD .Strip-container-2d1rz p{display:block;margin:0;padding:0 10px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.Strip-bodyContent-U2ssD .Strip-container-2d1rz p:first-letter{text-transform:uppercase}@media (min-width:768px){.Strip-bodyContent-U2ssD .Strip-container-2d1rz p{float:left;margin-bottom:-40px;padding-bottom:40px;border-left:1px solid #dadada;text-align:center}.Strip-bodyContent-U2ssD .Strip-container-2d1rz p:first-child{border-left:0}}.Strip-bodySide-hqI5m{position:absolute;left:0;top:0;bottom:0;width:36px;text-align:center;background:#d5dde5;opacity:.5}.Strip-bodySide-hqI5m:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}.Strip-bodySide-hqI5m i{vertical-align:middle}.Strip-clickable-1a65Q .Strip-body-3-5Mm{cursor:pointer}.Strip-success-27h0D .Strip-bodySide-hqI5m{background:#00e5ce}.Strip-warning-2Ea1x .Strip-bodySide-hqI5m{background:#faad44}.Strip-danger-3oesK .Strip-bodySide-hqI5m{background:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"default": "Strip-default-p8_rj",
		"header": "Strip-header-1Zha6",
		"body": "Strip-body-3-5Mm",
		"bodyContent": "Strip-bodyContent-U2ssD",
		"container": "Strip-container-2d1rz",
		"bodySide": "Strip-bodySide-hqI5m",
		"clickable": "Strip-clickable-1a65Q",
		"success": "Strip-success-27h0D",
		"warning": "Strip-warning-2Ea1x",
		"danger": "Strip-danger-3oesK"
	};

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "a.Tag-default-2FU36{display:inline-block;margin-right:20px;font-size:20px;font-weight:400;text-decoration:none;text-transform:lowercase;color:#b0bec5}a.Tag-default-2FU36:hover{text-decoration:none;color:#546d79}a.Tag-default-2FU36 i{margin:0 10px 0 0}a.Tag-sm-35LrB{font-size:16px;color:#8a959a}a.Tag-right-3Pb_j i{margin:0 0 0 10px}", ""]);
	
	// exports
	exports.locals = {
		"default": "Tag-default-2FU36",
		"sm": "Tag-sm-35LrB",
		"right": "Tag-right-3Pb_j"
	};

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TagBar-default-YRTqJ{margin-bottom:15px}.TagBar-tagGroup-3E3LU{position:relative;display:block;margin:0 -15px;padding:0 15px;list-style-type:none}.TagBar-tagGroup-3E3LU>li{display:inline-block;width:25%;text-align:center;vertical-align:top}.TagBar-tagGroup-3E3LU>li button{display:block;width:100%;padding:0;font-size:14px;font-weight:400;white-space:normal;color:#8a959a}.TagBar-tagGroup-3E3LU>li button:hover{text-decoration:none}.TagBar-tagGroup-3E3LU>li button label{display:block;margin:0;min-height:40px}.TagBar-tagGroup-3E3LU>li button label:first-letter{text-transform:uppercase}", ""]);
	
	// exports
	exports.locals = {
		"default": "TagBar-default-YRTqJ",
		"tagGroup": "TagBar-tagGroup-3E3LU"
	};

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".Tags-default-1g1E9{overflow:hidden}.Tags-default-1g1E9 label{margin:0;padding:10px 0;font-size:20px;font-weight:300;color:#546d79}.Tags-default-1g1E9 ul{margin:0;padding:0;list-style:none}.Tags-default-1g1E9 ul>li{display:inline-block;margin:10px 20px 10px 0}.Tags-default-1g1E9 ul>li.Tags-active-DVNDJ a{font-style:normal;color:#b0bec5}.Tags-default-1g1E9 ul>li a{display:inline-block;font-size:20px;font-weight:400;text-decoration:none;text-transform:lowercase;font-style:italic;color:#d3e2ea}.Tags-default-1g1E9 ul>li a:hover{color:#546d79}.Tags-default-1g1E9 ul>li a i{vertical-align:middle;margin:0 10px 0 0}", ""]);
	
	// exports
	exports.locals = {
		"default": "Tags-default-1g1E9",
		"active": "Tags-active-DVNDJ"
	};

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TimePicker-default-GvfvY{margin-top:10px}.TimePicker-default-GvfvY select{display:inline-block;width:45%}.TimePicker-default-GvfvY input{display:inline-block;width:100px}.TimePicker-default-GvfvY span{display:inline-block;width:10%;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "TimePicker-default-GvfvY"
	};

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TimeRangePicker-default-2hf4Y{overflow:hidden}.TimeRangePicker-picker-Y49Nh{margin-top:10px}.TimeRangePicker-picker-Y49Nh select{display:inline-block;width:45%}.TimeRangePicker-picker-Y49Nh span{display:inline-block;width:10%}.TimeRangePicker-preset-1BaRY{text-align:right}", ""]);
	
	// exports
	exports.locals = {
		"default": "TimeRangePicker-default-2hf4Y",
		"picker": "TimeRangePicker-picker-Y49Nh",
		"preset": "TimeRangePicker-preset-1BaRY"
	};

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ToggleablePanel-toggleablePanel-33h48{position:relative}.ToggleablePanel-toggleablePanel-33h48 .ToggleablePanel-header-2kuPQ{margin-left:1em;display:-ms-flexbox;display:flex}.ToggleablePanel-toggleablePanel-33h48 .ToggleablePanel-header-2kuPQ *{display:inline-block;margin:0}.ToggleablePanel-toggleablePanel-33h48 *{margin:0}.ToggleablePanel-toggleablePanel-33h48.ToggleablePanel-expandable-1hiUZ,.ToggleablePanel-toggleablePanel-33h48.ToggleablePanel-expandable-1hiUZ *{cursor:pointer}.ToggleablePanel-toggleablePanel-33h48 .ToggleablePanel-arrow-1qo_J{position:absolute;top:0;left:0;display:inline-block;transition:transform .2s ease 0s}.ToggleablePanel-toggleablePanel-33h48.ToggleablePanel-expanded-1GalI .ToggleablePanel-arrow-1qo_J{transform:rotate(90deg)}", ""]);
	
	// exports
	exports.locals = {
		"toggleablePanel": "ToggleablePanel-toggleablePanel-33h48",
		"header": "ToggleablePanel-header-2kuPQ",
		"expandable": "ToggleablePanel-expandable-1hiUZ",
		"arrow": "ToggleablePanel-arrow-1qo_J",
		"expanded": "ToggleablePanel-expanded-1GalI"
	};

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TypeaheadBar-search-1Z9Nl{overflow:hidden;padding:10px 0;border-bottom:1px solid #d6dde1}.TypeaheadBar-search-1Z9Nl .TypeaheadBar-container-2HmIf{overflow:hidden}.TypeaheadBar-search-1Z9Nl .TypeaheadBar-container-2HmIf input{height:48px;width:100%;border:0;background:transparent;font-size:26px;font-weight:400;line-height:26px;text-transform:uppercase;text-align:center;color:#b0bec5}.TypeaheadBar-search-1Z9Nl .TypeaheadBar-container-2HmIf input:-ms-input-placeholder{color:#b0bec5}.TypeaheadBar-search-1Z9Nl .TypeaheadBar-container-2HmIf input::placeholder{color:#b0bec5}.TypeaheadBar-search-1Z9Nl .TypeaheadBar-container-2HmIf input:focus{outline:0}.TypeaheadBar-search-1Z9Nl i{display:none}@media (min-width:768px){.TypeaheadBar-search-1Z9Nl i{display:block;float:right}}.TypeaheadBar-result-11hpE{margin:20px 0}.TypeaheadBar-result-11hpE ul{margin:0;padding:0;list-style:none}.TypeaheadBar-result-11hpE ul>li{display:block;padding:10px 0}.TypeaheadBar-result-11hpE ul>li label{margin:0;font-size:26px;line-height:26px;font-weight:300;text-transform:lowercase;color:#b0bec5}.TypeaheadBar-result-11hpE ul>li label small{display:block;font-size:16px}.TypeaheadBar-result-11hpE ul>li input+span{display:inline-block;margin-left:34px}.TypeaheadBar-result-11hpE ul>li input+span:before{margin-left:-34px}.TypeaheadBar-small-cICEb .TypeaheadBar-search-1Z9Nl .TypeaheadBar-container-2HmIf input{height:24px;font-size:14px;line-height:14px}.TypeaheadBar-small-cICEb .TypeaheadBar-result-11hpE{margin:0}.TypeaheadBar-small-cICEb .TypeaheadBar-result-11hpE ul>li{padding:10px;border-bottom:1px solid #dadada}.TypeaheadBar-small-cICEb .TypeaheadBar-result-11hpE ul>li label{font-size:14px;line-height:14px}@media (min-width:768px){.TypeaheadBar-small-cICEb .TypeaheadBar-result-11hpE{max-height:360px;overflow-x:hidden;overflow-y:auto}}.TypeaheadBar-split-3gjV9.TypeaheadBar-small-cICEb .TypeaheadBar-result-11hpE ul>li{border-bottom:0}", ""]);
	
	// exports
	exports.locals = {
		"search": "TypeaheadBar-search-1Z9Nl",
		"container": "TypeaheadBar-container-2HmIf",
		"result": "TypeaheadBar-result-11hpE",
		"small": "TypeaheadBar-small-cICEb",
		"split": "TypeaheadBar-split-3gjV9"
	};

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TypeaheadGridInput-default-2vgqd{overflow:hidden;margin-bottom:15px}.TypeaheadGridInput-result-3BdV0{max-height:450px;overflow-y:auto;overflow-x:hidden;margin:0;padding:0;list-style-type:none}.TypeaheadGridInput-result-3BdV0>li{display:inline-block;width:25%;text-align:center;vertical-align:middle}.TypeaheadGridInput-result-3BdV0>li button{display:block;width:100%;padding:0;font-size:14px;font-weight:400;white-space:normal;color:#8a959a}.TypeaheadGridInput-result-3BdV0>li button.active{color:#546d79}.TypeaheadGridInput-result-3BdV0>li button:hover{text-decoration:none}.TypeaheadGridInput-result-3BdV0>li button label{display:block;margin:0;min-height:40px}.TypeaheadGridInput-result-3BdV0>li button label:first-letter{text-transform:uppercase}.form-horizontal .TypeaheadGridInput-formResult-2TfJa{margin-left:-15px;margin-right:-15px}.form-horizontal .popover .TypeaheadGridInput-default-2vgqd .form-group,.form-horizontal .popover .TypeaheadGridInput-formResult-2TfJa{margin-left:0;margin-right:0}.TypeaheadGridInput-small-5KCzp .TypeaheadGridInput-result-3BdV0>li{width:33%}", ""]);
	
	// exports
	exports.locals = {
		"default": "TypeaheadGridInput-default-2vgqd",
		"result": "TypeaheadGridInput-result-3BdV0",
		"formResult": "TypeaheadGridInput-formResult-2TfJa",
		"small": "TypeaheadGridInput-small-5KCzp"
	};

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TypeaheadInput-default-3RcPf{position:relative}.TypeaheadInput-inputGroup-2I5Nq{overflow:hidden}.TypeaheadInput-result-2QAOK{position:absolute;display:block;top:100%;left:0;right:0;z-index:1000;padding:5px 0;margin:2px 0 0;list-style:none;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.TypeaheadInput-result-2QAOK>li>a{display:block;padding:3px 20px}", ""]);
	
	// exports
	exports.locals = {
		"default": "TypeaheadInput-default-3RcPf",
		"inputGroup": "TypeaheadInput-inputGroup-2I5Nq",
		"result": "TypeaheadInput-result-2QAOK"
	};

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CreateOpeningTicketInstructionPanel-defaultContent-KEBQz h4{margin:20px 0;text-align:center;text-transform:uppercase;font-weight:400}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "CreateOpeningTicketInstructionPanel-defaultContent-KEBQz"
	};

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpeningTicketInstructionPanelGroup-side-36QP5{padding-top:22px}.OpeningTicketInstructionPanelGroup-side-36QP5 h4{margin:30px 20px;text-transform:uppercase;text-align:center;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"side": "OpeningTicketInstructionPanelGroup-side-36QP5"
	};

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R{border-top:1px solid #dadada}.UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R .UpdateOpeningTicketInstructionPanel-action-JN8qk{margin:20px 0 0;text-align:right}.UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R .UpdateOpeningTicketInstructionPanel-action-JN8qk button{padding:5px}.UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R ul{margin:0;padding:0;list-style-type:none}", ""]);
	
	// exports
	exports.locals = {
		"openingTicketPurposes": "UpdateOpeningTicketInstructionPanel-openingTicketPurposes-1tM4R",
		"action": "UpdateOpeningTicketInstructionPanel-action-JN8qk"
	};

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AddRemoveAddressFromLotPopover-addressGroup-ZOIA2{margin:10px 0;padding:0;list-style-type:none}.AddRemoveAddressFromLotPopover-addressGroup-ZOIA2>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.AddRemoveAddressFromLotPopover-addressGroup-ZOIA2>li .AddRemoveAddressFromLotPopover-remove-1mmTV{display:block;float:right}.AddRemoveAddressFromLotPopover-addressGroup-ZOIA2>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"addressGroup": "AddRemoveAddressFromLotPopover-addressGroup-ZOIA2",
		"remove": "AddRemoveAddressFromLotPopover-remove-1mmTV"
	};

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AddRemoveComplementaryAddressFromPatrimonyPopover-addressGroup-2b6gC{margin:10px 0;padding:0;list-style-type:none}.AddRemoveComplementaryAddressFromPatrimonyPopover-addressGroup-2b6gC>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.AddRemoveComplementaryAddressFromPatrimonyPopover-addressGroup-2b6gC>li .AddRemoveComplementaryAddressFromPatrimonyPopover-remove-3O0og{display:block;float:right}.AddRemoveComplementaryAddressFromPatrimonyPopover-addressGroup-2b6gC>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"addressGroup": "AddRemoveComplementaryAddressFromPatrimonyPopover-addressGroup-2b6gC",
		"remove": "AddRemoveComplementaryAddressFromPatrimonyPopover-remove-3O0og"
	};

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "form{margin:0}.AddRemoveContactPopover-contactGroup-1D8zY{margin:0;padding:0;list-style-type:none}.AddRemoveContactPopover-contactGroup-1D8zY>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.AddRemoveContactPopover-contactGroup-1D8zY>li:last-child{border-bottom:0}.AddRemoveContactPopover-contactGroup-1D8zY>li .AddRemoveContactPopover-remove-3WPTY{display:block;float:right}.AddRemoveContactPopover-contactGroup-1D8zY>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"contactGroup": "AddRemoveContactPopover-contactGroup-1D8zY",
		"remove": "AddRemoveContactPopover-remove-3WPTY"
	};

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AssociateDissociatePatrimonyFromAgencyPopover-agencyGroup-bQQoS{margin:10px 0;padding:0;list-style-type:none}.AssociateDissociatePatrimonyFromAgencyPopover-agencyGroup-bQQoS>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.AssociateDissociatePatrimonyFromAgencyPopover-agencyGroup-bQQoS>li .AssociateDissociatePatrimonyFromAgencyPopover-dissociate-2i3SM{display:block;float:right}.AssociateDissociatePatrimonyFromAgencyPopover-agencyGroup-bQQoS>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"agencyGroup": "AssociateDissociatePatrimonyFromAgencyPopover-agencyGroup-bQQoS",
		"dissociate": "AssociateDissociatePatrimonyFromAgencyPopover-dissociate-2i3SM"
	};

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".data{margin:0;padding:0;list-style-type:none}.data>li{margin:5px 0}.data>li label{font-weight:400;color:#546d79}.powerConsumption{text-align:center}.powerConsumption img{display:inline-block}.powerConsumption .metricGroup{margin:0;padding:0;list-style-type:none}.powerConsumption .metric{display:table-cell;width:1%;font-size:20px;font-weight:400}.powerConsumption .metric span small{font-size:16px;font-weight:300}.powerConsumption .metric label{display:block;font-weight:300}.powerConsumption .metric:first-child label{color:#4b008f}.powerConsumption .metric:nth-child(2) label{color:#00a9e0}.powerConsumption .metric:nth-child(3) label{color:#00fc03}.powerConsumption .metric:nth-child(4) label{color:#ff3c59}.elevator{text-align:center}.elevator img{display:inline-block}.BuildingDashboard-data-3c9Aq{margin:0;padding:0;list-style-type:none}.BuildingDashboard-data-3c9Aq>li{margin:5px 0}.BuildingDashboard-data-3c9Aq>li label{font-weight:400;color:#546d79}.BuildingDashboard-powerConsumption-1V6ZI{text-align:center}.BuildingDashboard-powerConsumption-1V6ZI img{display:inline-block}.BuildingDashboard-powerConsumption-1V6ZI .BuildingDashboard-metricGroup-2fqge{margin:0;padding:0;list-style-type:none}.BuildingDashboard-powerConsumption-1V6ZI .BuildingDashboard-metric-3BxSs{display:table-cell;width:1%;font-size:20px;font-weight:400}.BuildingDashboard-powerConsumption-1V6ZI .BuildingDashboard-metric-3BxSs span small{font-size:16px;font-weight:300}.BuildingDashboard-powerConsumption-1V6ZI .BuildingDashboard-metric-3BxSs label{display:block;font-weight:300}.BuildingDashboard-powerConsumption-1V6ZI .BuildingDashboard-metric-3BxSs:first-child label{color:#4b008f}.BuildingDashboard-powerConsumption-1V6ZI .BuildingDashboard-metric-3BxSs:nth-child(2) label{color:#00a9e0}.BuildingDashboard-powerConsumption-1V6ZI .BuildingDashboard-metric-3BxSs:nth-child(3) label{color:#00fc03}.BuildingDashboard-powerConsumption-1V6ZI .BuildingDashboard-metric-3BxSs:nth-child(4) label{color:#ff3c59}.BuildingDashboard-elevator-3rzTv{text-align:center}.BuildingDashboard-elevator-3rzTv img{display:inline-block}", ""]);
	
	// exports
	exports.locals = {
		"data": "BuildingDashboard-data-3c9Aq",
		"powerConsumption": "BuildingDashboard-powerConsumption-1V6ZI",
		"metricGroup": "BuildingDashboard-metricGroup-2fqge",
		"metric": "BuildingDashboard-metric-3BxSs",
		"elevator": "BuildingDashboard-elevator-3rzTv"
	};

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.defaultContent h4{margin:30px 0;text-transform:uppercase;text-align:center}.defaultContent h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.header{position:relative}.header .edit{display:block;float:right;line-height:24px}.header .report{position:relative;display:inline-block;margin-left:20px}.header .report .container{position:absolute;top:-40px}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.count{display:inline-block}.count span{display:block;font-size:40px;line-height:1;text-transform:uppercase}.count small{display:block;margin-bottom:5px;font-size:16px}.metric{display:table-cell;width:1%}.metric i{margin-left:5px}.stats{text-align:center;color:#546d79}@media (min-width:768px){.stats h4{min-height:75px}}.stats .count{display:table-cell;width:1%}.map{padding-top:30px}.events{text-align:center;color:#546d79}@media (min-width:768px){.events h4{min-height:75px}}.BuildingDetail-menu-3Znau{margin:0;padding:0;list-style-type:none}.BuildingDetail-menu-3Znau>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.BuildingDetail-menu-3Znau>li:first-child{border-top:0}.BuildingDetail-menu-3Znau>li a:hover{text-decoration:none}.BuildingDetail-defaultContent-W1IvY{margin-bottom:20px}.BuildingDetail-defaultContent-W1IvY h4{margin:30px 0;text-transform:uppercase;text-align:center}.BuildingDetail-defaultContent-W1IvY h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.BuildingDetail-header-12kSC{position:relative}.BuildingDetail-header-12kSC .BuildingDetail-edit-OVrmy{display:block;float:right;line-height:24px}.BuildingDetail-header-12kSC .BuildingDetail-report-1Xmvp{position:relative;display:inline-block;margin-left:20px}.BuildingDetail-header-12kSC .BuildingDetail-report-1Xmvp .BuildingDetail-container-2VeuW{position:absolute;top:-40px}.BuildingDetail-count-1Nv_u{display:inline-block}.BuildingDetail-count-1Nv_u span{display:block;font-size:40px;line-height:1;text-transform:uppercase}.BuildingDetail-count-1Nv_u small{display:block;margin-bottom:5px;font-size:16px}.BuildingDetail-metric-1O-NG{display:table-cell;width:1%}.BuildingDetail-metric-1O-NG i{margin-left:5px}.BuildingDetail-stats-1eG4p{text-align:center;color:#546d79}@media (min-width:768px){.BuildingDetail-stats-1eG4p h4{min-height:75px}}.BuildingDetail-stats-1eG4p .BuildingDetail-count-1Nv_u{display:table-cell;width:1%}.BuildingDetail-map-_co5i{padding-top:30px}.BuildingDetail-events-2h_o_{text-align:center;color:#546d79}@media (min-width:768px){.BuildingDetail-events-2h_o_ h4{min-height:75px}}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "BuildingDetail-defaultContent-W1IvY",
		"header": "BuildingDetail-header-12kSC",
		"edit": "BuildingDetail-edit-OVrmy",
		"report": "BuildingDetail-report-1Xmvp",
		"container": "BuildingDetail-container-2VeuW",
		"menu": "BuildingDetail-menu-3Znau",
		"count": "BuildingDetail-count-1Nv_u",
		"metric": "BuildingDetail-metric-1O-NG",
		"stats": "BuildingDetail-stats-1eG4p",
		"map": "BuildingDetail-map-_co5i",
		"events": "BuildingDetail-events-2h_o_"
	};

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactCard-action--Z-oV{float:right}.ContactCard-name-yfdLQ{padding:10px 0}.ContactCard-name-yfdLQ h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ContactCard-detail-1ucX8{min-height:146px;padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}.ContactCard-contact-3olOR{margin:0;padding:0;list-style-type:none}.ContactCard-contact-3olOR>li{display:inline-block;margin:5px 20px 5px 0}.ContactCard-contact-3olOR>li.ContactCard-mail-3nSpM{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports
	exports.locals = {
		"action": "ContactCard-action--Z-oV",
		"name": "ContactCard-name-yfdLQ",
		"detail": "ContactCard-detail-1ucX8",
		"contact": "ContactCard-contact-3olOR",
		"mail": "ContactCard-mail-3nSpM"
	};

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactDashboard-data-1LYUr{margin:0;padding:0;list-style-type:none}.ContactDashboard-data-1LYUr>li{margin:5px 0}.ContactDashboard-data-1LYUr>li label{font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"data": "ContactDashboard-data-1LYUr"
	};

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.defaultContent h4{margin:30px 0;text-transform:uppercase;text-align:center}.defaultContent h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.header{position:relative}.header .edit{display:block;float:right;line-height:24px}.header .report{position:relative;display:inline-block;margin-left:20px}.header .report .container{position:absolute;top:-40px}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.count{display:inline-block}.count span{display:block;font-size:40px;line-height:1;text-transform:uppercase}.count small{display:block;margin-bottom:5px;font-size:16px}.metric{display:table-cell;width:1%}.metric i{margin-left:5px}.stats{text-align:center;color:#546d79}@media (min-width:768px){.stats h4{min-height:75px}}.stats .count{display:table-cell;width:1%}.map{padding-top:30px}.events{text-align:center;color:#546d79}@media (min-width:768px){.events h4{min-height:75px}}.ContactDetail-count-3wcwG{display:inline-block}.ContactDetail-count-3wcwG span{display:block;font-size:40px;line-height:1;text-transform:uppercase}.ContactDetail-count-3wcwG small{display:block;margin-bottom:5px;font-size:16px}.ContactDetail-metric-2Jlvu{display:table-cell;width:1%}.ContactDetail-metric-2Jlvu i{margin-left:5px}.ContactDetail-stats-UtbPL{text-align:center;color:#546d79}@media (min-width:768px){.ContactDetail-stats-UtbPL h4{min-height:75px}}.ContactDetail-stats-UtbPL .ContactDetail-count-3wcwG{display:table-cell;width:1%}.ContactDetail-map-3PeiX{padding-top:30px}.ContactDetail-events-16AGm{text-align:center;color:#546d79}@media (min-width:768px){.ContactDetail-events-16AGm h4{min-height:75px}}.ContactDetail-defaultContent-28iNM{margin-bottom:20px}.ContactDetail-defaultContent-28iNM h4{margin:30px 0;text-transform:uppercase;text-align:center}.ContactDetail-defaultContent-28iNM h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.ContactDetail-header-2Y-Bg{position:relative}.ContactDetail-header-2Y-Bg .ContactDetail-edit-1PtFg{display:block;float:right;line-height:24px}.ContactDetail-header-2Y-Bg .ContactDetail-report-SFyrj{position:relative;display:inline-block;margin-left:20px}.ContactDetail-header-2Y-Bg .ContactDetail-report-SFyrj .ContactDetail-container-2qQ8j{position:absolute;top:-40px}.ContactDetail-menu-1G0v7{margin:0;padding:0;list-style-type:none}.ContactDetail-menu-1G0v7>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.ContactDetail-menu-1G0v7>li:first-child{border-top:0}.ContactDetail-menu-1G0v7>li a:hover{text-decoration:none}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "ContactDetail-defaultContent-28iNM",
		"header": "ContactDetail-header-2Y-Bg",
		"edit": "ContactDetail-edit-1PtFg",
		"report": "ContactDetail-report-SFyrj",
		"container": "ContactDetail-container-2qQ8j",
		"menu": "ContactDetail-menu-1G0v7",
		"count": "ContactDetail-count-3wcwG",
		"metric": "ContactDetail-metric-2Jlvu",
		"stats": "ContactDetail-stats-UtbPL",
		"map": "ContactDetail-map-3PeiX",
		"events": "ContactDetail-events-16AGm"
	};

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactPicker-search-DLCPF{overflow:hidden;padding:10px;border-bottom:1px solid #dadada}.ContactPicker-search-DLCPF .ContactPicker-container-3T9oI{overflow:hidden}.ContactPicker-search-DLCPF .ContactPicker-container-3T9oI input{height:24px;width:100%;border:0;background:transparent;font-size:14px;font-weight:400;line-height:14px;text-transform:uppercase;text-align:center;color:#b0bec5}.ContactPicker-search-DLCPF .ContactPicker-container-3T9oI input:-ms-input-placeholder{color:#b0bec5}.ContactPicker-search-DLCPF .ContactPicker-container-3T9oI input::placeholder{color:#b0bec5}.ContactPicker-search-DLCPF .ContactPicker-container-3T9oI input:focus{outline:0}.ContactPicker-search-DLCPF i{display:none}@media (min-width:768px){.ContactPicker-search-DLCPF i{display:block;float:right}}.ContactPicker-filter-2Wbvv{margin:0;padding:0;list-style:none;border-bottom:1px solid #d6dde1}.ContactPicker-filter-2Wbvv>li{display:block;padding:10px 0;text-align:right}", ""]);
	
	// exports
	exports.locals = {
		"search": "ContactPicker-search-DLCPF",
		"container": "ContactPicker-container-3T9oI",
		"filter": "ContactPicker-filter-2Wbvv"
	};

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactStream-pagination-1OUBk{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "ContactStream-pagination-1OUBk"
	};

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DeleteLotModal-text-1YkNn{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "DeleteLotModal-text-1YkNn"
	};

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".LotCard-addressDetail-2FSy6{padding:10px 0}.LotCard-address--SpMR{min-height:67px;padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}.LotCard-address--SpMR>div{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports
	exports.locals = {
		"addressDetail": "LotCard-addressDetail-2FSy6",
		"address": "LotCard-address--SpMR"
	};

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".data{margin:0;padding:0;list-style-type:none}.data>li{margin:5px 0}.data>li label{font-weight:400;color:#546d79}.powerConsumption{text-align:center}.powerConsumption img{display:inline-block}.powerConsumption .metricGroup{margin:0;padding:0;list-style-type:none}.powerConsumption .metric{display:table-cell;width:1%;font-size:20px;font-weight:400}.powerConsumption .metric span small{font-size:16px;font-weight:300}.powerConsumption .metric label{display:block;font-weight:300}.powerConsumption .metric:first-child label{color:#4b008f}.powerConsumption .metric:nth-child(2) label{color:#00a9e0}.powerConsumption .metric:nth-child(3) label{color:#00fc03}.powerConsumption .metric:nth-child(4) label{color:#ff3c59}.elevator{text-align:center}.elevator img{display:inline-block}.LotDashboard-powerConsumption-wQC_1{text-align:center}.LotDashboard-powerConsumption-wQC_1 img{display:inline-block}.LotDashboard-powerConsumption-wQC_1 .LotDashboard-metricGroup-Ko3Tc{margin:0;padding:0;list-style-type:none}.LotDashboard-powerConsumption-wQC_1 .LotDashboard-metric-25sBd{display:table-cell;width:1%;font-size:20px;font-weight:400}.LotDashboard-powerConsumption-wQC_1 .LotDashboard-metric-25sBd span small{font-size:16px;font-weight:300}.LotDashboard-powerConsumption-wQC_1 .LotDashboard-metric-25sBd label{display:block;font-weight:300}.LotDashboard-powerConsumption-wQC_1 .LotDashboard-metric-25sBd:first-child label{color:#4b008f}.LotDashboard-powerConsumption-wQC_1 .LotDashboard-metric-25sBd:nth-child(2) label{color:#00a9e0}.LotDashboard-powerConsumption-wQC_1 .LotDashboard-metric-25sBd:nth-child(3) label{color:#00fc03}.LotDashboard-powerConsumption-wQC_1 .LotDashboard-metric-25sBd:nth-child(4) label{color:#ff3c59}.LotDashboard-elevator-c0cx6{text-align:center}.LotDashboard-elevator-c0cx6 img{display:inline-block}.LotDashboard-data-1htuI{margin:0;padding:0;list-style-type:none}.LotDashboard-data-1htuI>li{margin:5px 0}.LotDashboard-data-1htuI>li label{font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"data": "LotDashboard-data-1htuI",
		"powerConsumption": "LotDashboard-powerConsumption-wQC_1",
		"metricGroup": "LotDashboard-metricGroup-Ko3Tc",
		"metric": "LotDashboard-metric-25sBd",
		"elevator": "LotDashboard-elevator-c0cx6"
	};

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.defaultContent h4{margin:30px 0;text-transform:uppercase;text-align:center}.defaultContent h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.header{position:relative}.header .edit{display:block;float:right;line-height:24px}.header .report{position:relative;display:inline-block;margin-left:20px}.header .report .container{position:absolute;top:-40px}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.count{display:inline-block}.count span{display:block;font-size:40px;line-height:1;text-transform:uppercase}.count small{display:block;margin-bottom:5px;font-size:16px}.metric{display:table-cell;width:1%}.metric i{margin-left:5px}.stats{text-align:center;color:#546d79}@media (min-width:768px){.stats h4{min-height:75px}}.stats .count{display:table-cell;width:1%}.map{padding-top:30px}.events{text-align:center;color:#546d79}@media (min-width:768px){.events h4{min-height:75px}}.LotDetail-menu-3UKut{margin:0;padding:0;list-style-type:none}.LotDetail-menu-3UKut>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.LotDetail-menu-3UKut>li:first-child{border-top:0}.LotDetail-menu-3UKut>li a:hover{text-decoration:none}.LotDetail-metric-2px2T{display:table-cell;width:1%}.LotDetail-metric-2px2T i{margin-left:5px}.LotDetail-defaultContent-1hEmz{margin-bottom:20px}.LotDetail-defaultContent-1hEmz h4{margin:30px 0;text-transform:uppercase;text-align:center}.LotDetail-defaultContent-1hEmz h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.LotDetail-header-1IYwe{position:relative}.LotDetail-header-1IYwe .LotDetail-edit-TpIjW{display:block;float:right;line-height:24px}.LotDetail-header-1IYwe .LotDetail-report-2JcjA{position:relative;display:inline-block;margin-left:20px}.LotDetail-header-1IYwe .LotDetail-report-2JcjA .LotDetail-container-thN79{position:absolute;top:-40px}.LotDetail-count-1SW96{display:inline-block}.LotDetail-count-1SW96 span{display:block;font-size:40px;line-height:1;text-transform:uppercase}.LotDetail-count-1SW96 small{display:block;margin-bottom:5px;font-size:16px}.LotDetail-stats-1T6AM{text-align:center;color:#546d79}@media (min-width:768px){.LotDetail-stats-1T6AM h4{min-height:75px}}.LotDetail-stats-1T6AM .LotDetail-count-1SW96{display:table-cell;width:1%}.LotDetail-map-1RqBh{padding-top:30px}.LotDetail-events-2ctY9{text-align:center;color:#546d79}@media (min-width:768px){.LotDetail-events-2ctY9 h4{min-height:75px}}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "LotDetail-defaultContent-1hEmz",
		"header": "LotDetail-header-1IYwe",
		"edit": "LotDetail-edit-TpIjW",
		"report": "LotDetail-report-2JcjA",
		"container": "LotDetail-container-thN79",
		"menu": "LotDetail-menu-3UKut",
		"count": "LotDetail-count-1SW96",
		"metric": "LotDetail-metric-2px2T",
		"stats": "LotDetail-stats-1T6AM",
		"map": "LotDetail-map-1RqBh",
		"events": "LotDetail-events-2ctY9"
	};

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".LotStream-header-2kr7_{overflow:hidden}.LotStream-headerMain-205dl{float:left;padding-top:5px;line-height:36px}.LotStream-headerMain-205dl>a,.LotStream-headerMain-205dl>span{line-height:1;display:inline-block;vertical-align:bottom}.LotStream-headerSide-2wMfK{overflow:hidden;padding-top:5px;padding-right:5px}.LotStream-headerSide-2wMfK label{float:right;margin-left:20px}", ""]);
	
	// exports
	exports.locals = {
		"header": "LotStream-header-2kr7_",
		"headerMain": "LotStream-headerMain-205dl",
		"headerSide": "LotStream-headerSide-2wMfK"
	};

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".PatrimonyCard-label-1byVX{padding:10px 0}.PatrimonyCard-label-1byVX h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.PatrimonyCard-address-2-wmB{min-height:67px;padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}.PatrimonyCard-address-2-wmB>div{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports
	exports.locals = {
		"label": "PatrimonyCard-label-1byVX",
		"address": "PatrimonyCard-address-2-wmB"
	};

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".data{margin:0;padding:0;list-style-type:none}.data>li{margin:5px 0}.data>li label{font-weight:400;color:#546d79}.powerConsumption{text-align:center}.powerConsumption img{display:inline-block}.powerConsumption .metricGroup{margin:0;padding:0;list-style-type:none}.powerConsumption .metric{display:table-cell;width:1%;font-size:20px;font-weight:400}.powerConsumption .metric span small{font-size:16px;font-weight:300}.powerConsumption .metric label{display:block;font-weight:300}.powerConsumption .metric:first-child label{color:#4b008f}.powerConsumption .metric:nth-child(2) label{color:#00a9e0}.powerConsumption .metric:nth-child(3) label{color:#00fc03}.powerConsumption .metric:nth-child(4) label{color:#ff3c59}.elevator{text-align:center}.elevator img{display:inline-block}.PatrimonyDashboard-data-3nuRu{margin:0;padding:0;list-style-type:none}.PatrimonyDashboard-data-3nuRu>li{margin:5px 0}.PatrimonyDashboard-data-3nuRu>li label{font-weight:400;color:#546d79}.PatrimonyDashboard-powerConsumption-1qFL7{text-align:center}.PatrimonyDashboard-powerConsumption-1qFL7 img{display:inline-block}.PatrimonyDashboard-powerConsumption-1qFL7 .PatrimonyDashboard-metricGroup-1XIy8{margin:0;padding:0;list-style-type:none}.PatrimonyDashboard-powerConsumption-1qFL7 .PatrimonyDashboard-metric-1-FVY{display:table-cell;width:1%;font-size:20px;font-weight:400}.PatrimonyDashboard-powerConsumption-1qFL7 .PatrimonyDashboard-metric-1-FVY span small{font-size:16px;font-weight:300}.PatrimonyDashboard-powerConsumption-1qFL7 .PatrimonyDashboard-metric-1-FVY label{display:block;font-weight:300}.PatrimonyDashboard-powerConsumption-1qFL7 .PatrimonyDashboard-metric-1-FVY:first-child label{color:#4b008f}.PatrimonyDashboard-powerConsumption-1qFL7 .PatrimonyDashboard-metric-1-FVY:nth-child(2) label{color:#00a9e0}.PatrimonyDashboard-powerConsumption-1qFL7 .PatrimonyDashboard-metric-1-FVY:nth-child(3) label{color:#00fc03}.PatrimonyDashboard-powerConsumption-1qFL7 .PatrimonyDashboard-metric-1-FVY:nth-child(4) label{color:#ff3c59}.PatrimonyDashboard-elevator-2Z7ua{text-align:center}.PatrimonyDashboard-elevator-2Z7ua img{display:inline-block}", ""]);
	
	// exports
	exports.locals = {
		"data": "PatrimonyDashboard-data-3nuRu",
		"powerConsumption": "PatrimonyDashboard-powerConsumption-1qFL7",
		"metricGroup": "PatrimonyDashboard-metricGroup-1XIy8",
		"metric": "PatrimonyDashboard-metric-1-FVY",
		"elevator": "PatrimonyDashboard-elevator-2Z7ua"
	};

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.defaultContent h4{margin:30px 0;text-transform:uppercase;text-align:center}.defaultContent h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.header{position:relative}.header .edit{display:block;float:right;line-height:24px}.header .report{position:relative;display:inline-block;margin-left:20px}.header .report .container{position:absolute;top:-40px}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.count{display:inline-block}.count span{display:block;font-size:40px;line-height:1;text-transform:uppercase}.count small{display:block;margin-bottom:5px;font-size:16px}.metric{display:table-cell;width:1%}.metric i{margin-left:5px}.stats{text-align:center;color:#546d79}@media (min-width:768px){.stats h4{min-height:75px}}.stats .count{display:table-cell;width:1%}.map{padding-top:30px}.events{text-align:center;color:#546d79}@media (min-width:768px){.events h4{min-height:75px}}.PatrimonyDetail-defaultContent-3lDWY{margin-bottom:20px}.PatrimonyDetail-defaultContent-3lDWY h4{margin:30px 0;text-transform:uppercase;text-align:center}.PatrimonyDetail-defaultContent-3lDWY h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.PatrimonyDetail-header-2a_Fo{position:relative}.PatrimonyDetail-header-2a_Fo .PatrimonyDetail-edit-37zlO{display:block;float:right;line-height:24px}.PatrimonyDetail-header-2a_Fo .PatrimonyDetail-report-hTEdT{position:relative;display:inline-block;margin-left:20px}.PatrimonyDetail-header-2a_Fo .PatrimonyDetail-report-hTEdT .PatrimonyDetail-container-1Zb60{position:absolute;top:-40px}.PatrimonyDetail-menu-f4RL8{margin:0;padding:0;list-style-type:none}.PatrimonyDetail-menu-f4RL8>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.PatrimonyDetail-menu-f4RL8>li:first-child{border-top:0}.PatrimonyDetail-menu-f4RL8>li a:hover{text-decoration:none}.PatrimonyDetail-count-27766{display:inline-block}.PatrimonyDetail-count-27766 span{display:block;font-size:40px;line-height:1;text-transform:uppercase}.PatrimonyDetail-count-27766 small{display:block;margin-bottom:5px;font-size:16px}.PatrimonyDetail-metric-2HKje{display:table-cell;width:1%}.PatrimonyDetail-metric-2HKje i{margin-left:5px}.PatrimonyDetail-stats-odpEo{text-align:center;color:#546d79}@media (min-width:768px){.PatrimonyDetail-stats-odpEo h4{min-height:75px}}.PatrimonyDetail-stats-odpEo .PatrimonyDetail-count-27766{display:table-cell;width:1%}.PatrimonyDetail-map-vG5UD{padding-top:30px}.PatrimonyDetail-events-2kJqO{text-align:center;color:#546d79}@media (min-width:768px){.PatrimonyDetail-events-2kJqO h4{min-height:75px}}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "PatrimonyDetail-defaultContent-3lDWY",
		"header": "PatrimonyDetail-header-2a_Fo",
		"edit": "PatrimonyDetail-edit-37zlO",
		"report": "PatrimonyDetail-report-hTEdT",
		"container": "PatrimonyDetail-container-1Zb60",
		"menu": "PatrimonyDetail-menu-f4RL8",
		"count": "PatrimonyDetail-count-27766",
		"metric": "PatrimonyDetail-metric-2HKje",
		"stats": "PatrimonyDetail-stats-odpEo",
		"map": "PatrimonyDetail-map-vG5UD",
		"events": "PatrimonyDetail-events-2kJqO"
	};

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".PatrimonyPicker-search-3fBRN{overflow:hidden;padding:10px 0;border-bottom:1px solid #dadada}.PatrimonyPicker-search-3fBRN .PatrimonyPicker-container-3jG4r{overflow:hidden}.PatrimonyPicker-search-3fBRN .PatrimonyPicker-container-3jG4r input{height:24px;width:100%;border:0;background:transparent;font-size:14px;font-weight:400;line-height:14px;text-transform:uppercase;text-align:center;color:#b0bec5}.PatrimonyPicker-search-3fBRN .PatrimonyPicker-container-3jG4r input:-ms-input-placeholder{color:#b0bec5}.PatrimonyPicker-search-3fBRN .PatrimonyPicker-container-3jG4r input::placeholder{color:#b0bec5}.PatrimonyPicker-search-3fBRN .PatrimonyPicker-container-3jG4r input:focus{outline:0}.PatrimonyPicker-search-3fBRN i{display:none}@media (min-width:768px){.PatrimonyPicker-search-3fBRN i{display:block;float:right}}", ""]);
	
	// exports
	exports.locals = {
		"search": "PatrimonyPicker-search-3fBRN",
		"container": "PatrimonyPicker-container-3jG4r"
	};

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".PatrimonySearchBar-content-2EWQ8{min-height:475px}", ""]);
	
	// exports
	exports.locals = {
		"content": "PatrimonySearchBar-content-2EWQ8"
	};

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".PatrimonyStats-default-1cn7L{margin-bottom:20px;color:#546d79}.PatrimonyStats-default-1cn7L h3,.PatrimonyStats-default-1cn7L h4{text-transform:uppercase;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "PatrimonyStats-default-1cn7L"
	};

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".PatrimonyStream-pagination-1YXtL{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "PatrimonyStream-pagination-1YXtL"
	};

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReferenceLotPopover-default-26ifN{color:#8a959a}.ReferenceLotPopover-default-26ifN h5 i{color:#ff5766}.ReferenceLotPopover-usageGroup-170pT{overflow:hidden;margin:20px 0}.ReferenceLotPopover-usageGroup-170pT .ReferenceLotPopover-container-3enVT{margin:0;padding:0;list-style-type:none}.ReferenceLotPopover-usageGroup-170pT .ReferenceLotPopover-container-3enVT>li{display:table-cell;width:1%;text-align:center}.ReferenceLotPopover-usageGroup-170pT .ReferenceLotPopover-container-3enVT>li.ReferenceLotPopover-active-7D1oI a{color:#546d79}.ReferenceLotPopover-usageGroup-170pT .ReferenceLotPopover-container-3enVT>li a{font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.ReferenceLotPopover-usageGroup-170pT .ReferenceLotPopover-container-3enVT>li span{display:block}.ReferenceLotPopover-usageGroup-170pT .ReferenceLotPopover-container-3enVT>li span:first-letter{text-transform:uppercase}.ReferenceLotPopover-addressGroup-aBZak{margin:10px 0;padding:0;list-style-type:none}.ReferenceLotPopover-addressGroup-aBZak>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.ReferenceLotPopover-addressGroup-aBZak>li .ReferenceLotPopover-remove-2rlzT{display:block;float:right}.ReferenceLotPopover-addressGroup-aBZak>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}.ReferenceLotPopover-info-2vp2S{display:inline-block;float:right;min-width:22px;padding:4px 0 2px;border:1px solid #00e5ce;border-radius:11px;line-height:1;text-align:center;font-size:14px;font-weight:400;color:#00e5ce}", ""]);
	
	// exports
	exports.locals = {
		"default": "ReferenceLotPopover-default-26ifN",
		"usageGroup": "ReferenceLotPopover-usageGroup-170pT",
		"container": "ReferenceLotPopover-container-3enVT",
		"active": "ReferenceLotPopover-active-7D1oI",
		"addressGroup": "ReferenceLotPopover-addressGroup-aBZak",
		"remove": "ReferenceLotPopover-remove-2rlzT",
		"info": "ReferenceLotPopover-info-2vp2S"
	};

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReferencePatrimonyContactPopover-defaultContent-qQ8TN h5 i{color:#ff5766}.ReferencePatrimonyContactPopover-defaultContent-qQ8TN h5 small{display:block;margin-top:10px;font-size:16px;text-transform:none}.ReferencePatrimonyContactPopover-linkType-Pal5f{overflow:hidden;margin:20px 0}.ReferencePatrimonyContactPopover-linkType-Pal5f .ReferencePatrimonyContactPopover-container-oq4Au{margin:0;padding:0;list-style-type:none}.ReferencePatrimonyContactPopover-linkType-Pal5f .ReferencePatrimonyContactPopover-container-oq4Au>li{display:table-cell;width:1%;text-align:center}.ReferencePatrimonyContactPopover-linkType-Pal5f .ReferencePatrimonyContactPopover-container-oq4Au>li button{padding:0;font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.ReferencePatrimonyContactPopover-linkType-Pal5f .ReferencePatrimonyContactPopover-container-oq4Au>li button.active{color:#546d79}.ReferencePatrimonyContactPopover-linkType-Pal5f .ReferencePatrimonyContactPopover-container-oq4Au>li span{display:block}.ReferencePatrimonyContactPopover-linkType-Pal5f .ReferencePatrimonyContactPopover-container-oq4Au>li span:first-letter{text-transform:uppercase}.ReferencePatrimonyContactPopover-userCreation-3h8Qr{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;margin-top:1em;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "ReferencePatrimonyContactPopover-defaultContent-qQ8TN",
		"linkType": "ReferencePatrimonyContactPopover-linkType-Pal5f",
		"container": "ReferencePatrimonyContactPopover-container-oq4Au",
		"userCreation": "ReferencePatrimonyContactPopover-userCreation-3h8Qr"
	};

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".RemoveLinkFromPatrimonyContactPopover-linkedWithGroup-16su3{margin:10px 0;padding:0;list-style-type:none}.RemoveLinkFromPatrimonyContactPopover-linkedWithGroup-16su3>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.RemoveLinkFromPatrimonyContactPopover-linkedWithGroup-16su3>li .RemoveLinkFromPatrimonyContactPopover-remove-1JK2K{display:block;float:right}.RemoveLinkFromPatrimonyContactPopover-linkedWithGroup-16su3>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"linkedWithGroup": "RemoveLinkFromPatrimonyContactPopover-linkedWithGroup-16su3",
		"remove": "RemoveLinkFromPatrimonyContactPopover-remove-1JK2K"
	};

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateLotPopover-usageGroup-1maHt{overflow:hidden;margin:20px 0}.UpdateLotPopover-usageGroup-1maHt .UpdateLotPopover-container-2UEsC{margin:0;padding:0;list-style-type:none}.UpdateLotPopover-usageGroup-1maHt .UpdateLotPopover-container-2UEsC>li{display:table-cell;width:1%;text-align:center}.UpdateLotPopover-usageGroup-1maHt .UpdateLotPopover-container-2UEsC>li.UpdateLotPopover-active-3wu59 a{color:#546d79}.UpdateLotPopover-usageGroup-1maHt .UpdateLotPopover-container-2UEsC>li a{font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.UpdateLotPopover-usageGroup-1maHt .UpdateLotPopover-container-2UEsC>li span{display:block}.UpdateLotPopover-usageGroup-1maHt .UpdateLotPopover-container-2UEsC>li span:first-letter{text-transform:uppercase}.UpdateLotPopover-delete-3scVD{margin:10px;text-align:center}.UpdateLotPopover-delete-3scVD a{font-weight:400;color:#ff5766}.UpdateLotPopover-info-1R-kx{display:inline-block;float:right;min-width:22px;padding:4px 0 2px;border:1px solid #00e5ce;border-radius:11px;line-height:1;text-align:center;font-size:14px;font-weight:400;color:#00e5ce}", ""]);
	
	// exports
	exports.locals = {
		"usageGroup": "UpdateLotPopover-usageGroup-1maHt",
		"container": "UpdateLotPopover-container-2UEsC",
		"active": "UpdateLotPopover-active-3wu59",
		"delete": "UpdateLotPopover-delete-3scVD",
		"info": "UpdateLotPopover-info-1R-kx"
	};

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".PatrimonyUserModal-send-BKWDM{margin:10px;text-align:center}.PatrimonyUserModal-send-BKWDM a{font-weight:400;color:#ff5766;cursor:pointer}", ""]);
	
	// exports
	exports.locals = {
		"send": "PatrimonyUserModal-send-BKWDM"
	};

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AddProviderContactModal-switch-31x0b{margin-bottom:20px;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"switch": "AddProviderContactModal-switch-31x0b"
	};

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1{margin-top:22px;margin-bottom:22px;padding:15px 20px 15px 25px;background:#f5f5f5;border:1px solid #dadada}.AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1 select{display:block;width:100%;height:24px;line-height:24px;background:transparent;border:0;font-weight:400;text-transform:uppercase}.AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1 select:focus{outline:0}.AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1 select::-ms-clear{display:none}.AssignRemoveActivityFromProviderContactPopover-panelWrapper-tSJ4J{position:relative}.AssignRemoveActivityFromProviderContactPopover-panelWrapper-tSJ4J>button{position:absolute;top:0;right:0;padding:15px}.AssignRemoveActivityFromProviderContactPopover-panelWrapper-tSJ4J h5{height:24px;line-height:24px}", ""]);
	
	// exports
	exports.locals = {
		"addActivity": "AssignRemoveActivityFromProviderContactPopover-addActivity-2JTW1",
		"panelWrapper": "AssignRemoveActivityFromProviderContactPopover-panelWrapper-tSJ4J"
	};

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CommitmentLayout-main-h5fI6 h4{margin:30px 20px;text-transform:uppercase;text-align:center;color:#546d79}.CommitmentLayout-main-h5fI6 h4 span{display:inline-block;height:24px;line-height:24px;vertical-align:bottom}.CommitmentLayout-main-h5fI6 h4 button{padding:0 10px}.CommitmentLayout-side-3bBqR h4{margin:30px 20px;text-transform:uppercase;text-align:center;color:#546d79}.CommitmentLayout-activityGroup-1w0TQ{margin:0;padding:0;list-style-type:none}.CommitmentLayout-activityGroup-1w0TQ>li{padding:10px 0;border-bottom:1px solid #dadada}", ""]);
	
	// exports
	exports.locals = {
		"main": "CommitmentLayout-main-h5fI6",
		"side": "CommitmentLayout-side-3bBqR",
		"activityGroup": "CommitmentLayout-activityGroup-1w0TQ"
	};

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactCard-label-m3Z-N{padding:10px 0}.ContactCard-label-m3Z-N h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ContactCard-status-dg3ff{float:right}.ContactCard-detail-2xJ1h{min-height:168px;padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}.ContactCard-company-2PA0i{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ContactCard-contact-29szT{margin:0;padding:0;list-style-type:none}.ContactCard-contact-29szT>li{display:inline-block;margin:5px 20px 5px 0}.ContactCard-contact-29szT>li.ContactCard-mail-19c2Y{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports
	exports.locals = {
		"label": "ContactCard-label-m3Z-N",
		"status": "ContactCard-status-dg3ff",
		"detail": "ContactCard-detail-2xJ1h",
		"company": "ContactCard-company-2PA0i",
		"contact": "ContactCard-contact-29szT",
		"mail": "ContactCard-mail-19c2Y"
	};

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactDashboard-data-1UDw3{margin:0;padding:0;list-style-type:none}.ContactDashboard-data-1UDw3>li{margin:5px 0}.ContactDashboard-data-1UDw3>li label{font-weight:400;color:#546d79}.ContactDashboard-rate-1QhQj{display:block;margin-top:20px;font-size:100px;font-weight:lighter;line-height:1}.ContactDashboard-rate-1QhQj.ContactDashboard-success-3q8L2{color:#00e5ce}.ContactDashboard-rate-1QhQj.ContactDashboard-warning-3xGmG{color:#faad44}.ContactDashboard-rate-1QhQj.ContactDashboard-danger-VbUyj{color:#ff5766}.ContactDashboard-count-RN2Kt{display:inline-block}.ContactDashboard-count-RN2Kt span{font-size:40px;line-height:1}.ContactDashboard-stats-kMj08{margin-top:10px;text-align:center;color:#546d79}.ContactDashboard-stats-kMj08 .ContactDashboard-count-RN2Kt{display:table-cell;width:1%}.ContactDashboard-stats-kMj08 .ContactDashboard-count-RN2Kt>span{display:block}.ContactDashboard-stats-kMj08 .ContactDashboard-count-RN2Kt small{display:block;font-size:16px}.ContactDashboard-interventionTimelimitRate-x6jNG,.ContactDashboard-repairTimelimitRate-KlL1C{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"data": "ContactDashboard-data-1UDw3",
		"rate": "ContactDashboard-rate-1QhQj",
		"success": "ContactDashboard-success-3q8L2",
		"warning": "ContactDashboard-warning-3xGmG",
		"danger": "ContactDashboard-danger-VbUyj",
		"count": "ContactDashboard-count-RN2Kt",
		"stats": "ContactDashboard-stats-kMj08",
		"repairTimelimitRate": "ContactDashboard-repairTimelimitRate-KlL1C",
		"interventionTimelimitRate": "ContactDashboard-interventionTimelimitRate-x6jNG"
	};

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.defaultContent h4{margin:30px 0;text-transform:uppercase;text-align:center}.defaultContent h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.header{position:relative}.header .edit{display:block;float:right;line-height:24px}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.count{display:inline-block}.count.success span{color:#00e5ce}.count.warning span{color:#faad44}.count.danger span{color:#ff5766}.count span{font-size:40px;line-height:1}.contact ul{margin:0;padding:0;list-style-type:none}.contact ul>li{margin:5px 0}.contact ul>li label{font-weight:400;color:#546d79}.stats{text-align:center;color:#546d79}@media (min-width:768px){.stats h4{min-height:75px}}.stats .count{display:table-cell;width:1%}.stats .count>span{display:block}.stats .count small{display:block;font-size:16px}.event{text-align:center}@media (min-width:768px){.event h4{min-height:65px}}.event .count{color:#00e5ce}.event .count i,.event .count span{vertical-align:middle}@media (min-width:768px){.event .count{min-height:100px}}.ContactDetail-contact-3zcjx ul{margin:0;padding:0;list-style-type:none}.ContactDetail-contact-3zcjx ul>li{margin:5px 0}.ContactDetail-contact-3zcjx ul>li label{font-weight:400;color:#546d79}.ContactDetail-event-3Q9QU{text-align:center}@media (min-width:768px){.ContactDetail-event-3Q9QU h4{min-height:65px}}.ContactDetail-event-3Q9QU .ContactDetail-count-32k3O{color:#00e5ce}.ContactDetail-event-3Q9QU .ContactDetail-count-32k3O i,.ContactDetail-event-3Q9QU .ContactDetail-count-32k3O span{vertical-align:middle}@media (min-width:768px){.ContactDetail-event-3Q9QU .ContactDetail-count-32k3O{min-height:100px}}.ContactDetail-defaultContent-dgHmX{margin-bottom:20px}.ContactDetail-defaultContent-dgHmX h4{margin:30px 0;text-transform:uppercase;text-align:center}.ContactDetail-defaultContent-dgHmX h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.ContactDetail-header-3S6qX{position:relative}.ContactDetail-header-3S6qX .ContactDetail-edit-2NZX9{display:block;float:right;line-height:24px}.ContactDetail-menu-3zjrF{margin:0;padding:0;list-style-type:none}.ContactDetail-menu-3zjrF>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.ContactDetail-menu-3zjrF>li:first-child{border-top:0}.ContactDetail-menu-3zjrF>li a:hover{text-decoration:none}.ContactDetail-count-32k3O{display:inline-block}.ContactDetail-count-32k3O.ContactDetail-success-2lpbB span{color:#00e5ce}.ContactDetail-count-32k3O.ContactDetail-warning-26s9U span{color:#faad44}.ContactDetail-count-32k3O.ContactDetail-danger-1ECH_ span{color:#ff5766}.ContactDetail-count-32k3O span{font-size:40px;line-height:1}.ContactDetail-stats-3eJ-u{text-align:center;color:#546d79}@media (min-width:768px){.ContactDetail-stats-3eJ-u h4{min-height:75px}}.ContactDetail-stats-3eJ-u .ContactDetail-count-32k3O{display:table-cell;width:1%}.ContactDetail-stats-3eJ-u .ContactDetail-count-32k3O>span{display:block}.ContactDetail-stats-3eJ-u .ContactDetail-count-32k3O small{display:block;font-size:16px}.ContactDetail-filter-ilRAA{text-align:right;margin-top:-10px;margin-right:-5px}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "ContactDetail-defaultContent-dgHmX",
		"header": "ContactDetail-header-3S6qX",
		"edit": "ContactDetail-edit-2NZX9",
		"menu": "ContactDetail-menu-3zjrF",
		"count": "ContactDetail-count-32k3O",
		"success": "ContactDetail-success-2lpbB",
		"warning": "ContactDetail-warning-26s9U",
		"danger": "ContactDetail-danger-1ECH_",
		"contact": "ContactDetail-contact-3zcjx",
		"event": "ContactDetail-event-3Q9QU",
		"stats": "ContactDetail-stats-3eJ-u",
		"filter": "ContactDetail-filter-ilRAA"
	};

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactSelector-default-2USyZ .ContactSelector-contact-2Ug5z p{margin:0}.ContactSelector-contact-2Ug5z small{font-style:italic;font-weight:300;text-transform:none;color:#b0bec5}.ContactSelector-search-33A9V{overflow:hidden;padding:10px;border-bottom:1px solid #dadada}.ContactSelector-search-33A9V .ContactSelector-container-Zeu_6{overflow:hidden}.ContactSelector-search-33A9V .ContactSelector-container-Zeu_6 input{height:24px;width:100%;border:0;background:transparent;font-size:14px;font-weight:400;line-height:14px;text-transform:uppercase;text-align:center;color:#b0bec5}.ContactSelector-search-33A9V .ContactSelector-container-Zeu_6 input:-ms-input-placeholder{color:#b0bec5}.ContactSelector-search-33A9V .ContactSelector-container-Zeu_6 input::placeholder{color:#b0bec5}.ContactSelector-search-33A9V .ContactSelector-container-Zeu_6 input:focus{outline:0}.ContactSelector-search-33A9V i{display:none}@media (min-width:768px){.ContactSelector-search-33A9V i{display:block;float:right}}", ""]);
	
	// exports
	exports.locals = {
		"default": "ContactSelector-default-2USyZ",
		"contact": "ContactSelector-contact-2Ug5z",
		"search": "ContactSelector-search-33A9V",
		"container": "ContactSelector-container-Zeu_6"
	};

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".default{margin-bottom:20px;color:#546d79}.default h4{margin:30px 0;text-transform:uppercase}.default h4,.switch{text-align:center}.ContactStats-default-25CcM{margin-bottom:20px;color:#546d79}.ContactStats-default-25CcM h4{margin:30px 0;text-transform:uppercase;text-align:center}.ContactStats-switch-JhFa4{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "ContactStats-default-25CcM",
		"switch": "ContactStats-switch-JhFa4"
	};

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactStream-pagination-34I1Q{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "ContactStream-pagination-34I1Q"
	};

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ContactSuggestSelector-contact-1OAaN{position:relative;overflow:hidden;padding-bottom:15px;text-transform:uppercase}.ContactSuggestSelector-contact-1OAaN i{display:block;float:left;margin-right:10px}.ContactSuggestSelector-contact-1OAaN .ContactSuggestSelector-container-3yCe5{overflow:hidden}.ContactSuggestSelector-contact-1OAaN .ContactSuggestSelector-container-3yCe5 p{margin:0}.ContactSuggestSelector-contact-1OAaN .ContactSuggestSelector-container-3yCe5 small{font-style:italic;font-weight:300;text-transform:none}.ContactSuggestSelector-contact-1OAaN a{position:absolute;display:block;bottom:0;right:0;text-transform:none;color:#00e5ce}.ContactSuggestSelector-data-3Jrnj{margin:0;padding:0;list-style-type:none}.ContactSuggestSelector-data-3Jrnj>li{margin:5px 0}.ContactSuggestSelector-data-3Jrnj>li label{font-weight:400;color:#546d79}.ContactSuggestSelector-data-3Jrnj>li input{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"contact": "ContactSuggestSelector-contact-1OAaN",
		"container": "ContactSuggestSelector-container-3yCe5",
		"data": "ContactSuggestSelector-data-3Jrnj"
	};

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CopyInterventionPeriodsModal-defaultContent-oQ5fq{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "CopyInterventionPeriodsModal-defaultContent-oQ5fq"
	};

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DefineRemoveCallOutChargesFromInterventionPeriodForm-callOutChargeGroup-1cL5I{margin:10px 0;padding:0;list-style-type:none}.DefineRemoveCallOutChargesFromInterventionPeriodForm-callOutChargeGroup-1cL5I>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.DefineRemoveCallOutChargesFromInterventionPeriodForm-callOutChargeGroup-1cL5I>li .DefineRemoveCallOutChargesFromInterventionPeriodForm-remove-5HTC5{display:block;float:right}.DefineRemoveCallOutChargesFromInterventionPeriodForm-callOutChargeGroup-1cL5I>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"callOutChargeGroup": "DefineRemoveCallOutChargesFromInterventionPeriodForm-callOutChargeGroup-1cL5I",
		"remove": "DefineRemoveCallOutChargesFromInterventionPeriodForm-remove-5HTC5"
	};

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T{margin:10px 0;padding:0;list-style-type:none}.DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T>li .DefineRemoveInterventionTimelimitFromInterventionPeriodForm-remove-1U6Tt{display:block;float:right}.DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"interventionTimelimitGroup": "DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T",
		"remove": "DefineRemoveInterventionTimelimitFromInterventionPeriodForm-remove-1U6Tt"
	};

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DefineRemoveRepairTimelimitFromInterventionPeriodForm-repairTimelimitGroup-J56MX{margin:10px 0;padding:0;list-style-type:none}.DefineRemoveRepairTimelimitFromInterventionPeriodForm-repairTimelimitGroup-J56MX>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.DefineRemoveRepairTimelimitFromInterventionPeriodForm-repairTimelimitGroup-J56MX>li .DefineRemoveRepairTimelimitFromInterventionPeriodForm-remove-1-aOF{display:block;float:right}.DefineRemoveRepairTimelimitFromInterventionPeriodForm-repairTimelimitGroup-J56MX>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"repairTimelimitGroup": "DefineRemoveRepairTimelimitFromInterventionPeriodForm-repairTimelimitGroup-J56MX",
		"remove": "DefineRemoveRepairTimelimitFromInterventionPeriodForm-remove-1-aOF"
	};

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DefineUpdateInterventionPeriodForActivityForm-default-NleET .DefineUpdateInterventionPeriodForActivityForm-section-HdYQX h5{margin:10px 0;text-transform:none}.DefineUpdateInterventionPeriodForActivityForm-default-NleET .DefineUpdateInterventionPeriodForActivityForm-section-HdYQX h5 i{color:#ff5766}.DefineUpdateInterventionPeriodForActivityForm-default-NleET .DefineUpdateInterventionPeriodForActivityForm-section-HdYQX h5 a i{margin-left:10px}.DefineUpdateInterventionPeriodForActivityForm-group-LccgL{margin:10px 0;padding:0;list-style-type:none}.DefineUpdateInterventionPeriodForActivityForm-group-LccgL>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.DefineUpdateInterventionPeriodForActivityForm-group-LccgL>li .DefineUpdateInterventionPeriodForActivityForm-remove-3wuiR{display:block;float:right}.DefineUpdateInterventionPeriodForActivityForm-group-LccgL>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}.DefineUpdateInterventionPeriodForActivityForm-dayPicker-vehRW{margin:20px;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "DefineUpdateInterventionPeriodForActivityForm-default-NleET",
		"section": "DefineUpdateInterventionPeriodForActivityForm-section-HdYQX",
		"group": "DefineUpdateInterventionPeriodForActivityForm-group-LccgL",
		"remove": "DefineUpdateInterventionPeriodForActivityForm-remove-3wuiR",
		"dayPicker": "DefineUpdateInterventionPeriodForActivityForm-dayPicker-vehRW"
	};

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderCard-name-3X63Q{padding:10px 0}.ProviderCard-name-3X63Q h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports
	exports.locals = {
		"name": "ProviderCard-name-3X63Q"
	};

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderCoverageDashboard-rate-gvYPu{display:block;margin-top:20px;font-size:100px;font-weight:lighter;line-height:1}.ProviderCoverageDashboard-coverageRate-2DHcL{text-align:center}.ProviderCoverageDashboard-coverageRate-2DHcL .ProviderCoverageDashboard-rate-gvYPu{color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"rate": "ProviderCoverageDashboard-rate-gvYPu",
		"coverageRate": "ProviderCoverageDashboard-coverageRate-2DHcL"
	};

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderCoverageSearchBar-content-2kRXr{min-height:475px}.ProviderCoverageSearchBar-tabTitle-1hUdM span{display:none}@media (min-width:768px){.ProviderCoverageSearchBar-tabTitle-1hUdM span{display:inline-block}}@media (min-width:768px){.ProviderCoverageSearchBar-tabTitle-1hUdM i{display:none}}.ProviderCoverageSearchBar-zipCodes-3DE-y{margin-top:20px}.ProviderCoverageSearchBar-footer-1Wjdx h4 small{margin-left:20px;font-size:100%}", ""]);
	
	// exports
	exports.locals = {
		"content": "ProviderCoverageSearchBar-content-2kRXr",
		"tabTitle": "ProviderCoverageSearchBar-tabTitle-1hUdM",
		"zipCodes": "ProviderCoverageSearchBar-zipCodes-3DE-y",
		"footer": "ProviderCoverageSearchBar-footer-1Wjdx"
	};

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderDashboard-data-2_Jka{margin:0;padding:0;list-style-type:none}.ProviderDashboard-data-2_Jka>li{margin:5px 0}.ProviderDashboard-data-2_Jka>li label{font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"data": "ProviderDashboard-data-2_Jka"
	};

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.defaultContent h4{margin:30px 0;text-transform:uppercase;text-align:center}.defaultContent h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.header{position:relative}.header .edit{display:block;float:right;line-height:24px}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.count{display:inline-block}.count.success span{color:#00e5ce}.count.warning span{color:#faad44}.count.danger span{color:#ff5766}.count span{font-size:40px;line-height:1}.contact ul{margin:0;padding:0;list-style-type:none}.contact ul>li{margin:5px 0}.contact ul>li label{font-weight:400;color:#546d79}.stats{text-align:center;color:#546d79}@media (min-width:768px){.stats h4{min-height:75px}}.stats .count{display:table-cell;width:1%}.stats .count>span{display:block}.stats .count small{display:block;font-size:16px}.event{text-align:center}@media (min-width:768px){.event h4{min-height:65px}}.event .count{color:#00e5ce}.event .count i,.event .count span{vertical-align:middle}@media (min-width:768px){.event .count{min-height:100px}}.ProviderDetail-defaultContent-2bSBb{margin-bottom:20px}.ProviderDetail-defaultContent-2bSBb h4{margin:30px 0;text-transform:uppercase;text-align:center}.ProviderDetail-defaultContent-2bSBb h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.ProviderDetail-header-3-E12{position:relative}.ProviderDetail-header-3-E12 .ProviderDetail-edit-1RLam{display:block;float:right;line-height:24px}.ProviderDetail-menu-3UPou{margin:0;padding:0;list-style-type:none}.ProviderDetail-menu-3UPou>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.ProviderDetail-menu-3UPou>li:first-child{border-top:0}.ProviderDetail-menu-3UPou>li a:hover{text-decoration:none}.ProviderDetail-count-lLcKY{display:inline-block}.ProviderDetail-count-lLcKY.ProviderDetail-success-72kst span{color:#00e5ce}.ProviderDetail-count-lLcKY.ProviderDetail-warning-xXPzJ span{color:#faad44}.ProviderDetail-count-lLcKY.ProviderDetail-danger-3ZUUi span{color:#ff5766}.ProviderDetail-count-lLcKY span{font-size:40px;line-height:1}.ProviderDetail-contact-3ZhmU ul{margin:0;padding:0;list-style-type:none}.ProviderDetail-contact-3ZhmU ul>li{margin:5px 0}.ProviderDetail-contact-3ZhmU ul>li label{font-weight:400;color:#546d79}.ProviderDetail-event-1tR13{text-align:center}@media (min-width:768px){.ProviderDetail-event-1tR13 h4{min-height:65px}}.ProviderDetail-event-1tR13 .ProviderDetail-count-lLcKY{color:#00e5ce}.ProviderDetail-event-1tR13 .ProviderDetail-count-lLcKY i,.ProviderDetail-event-1tR13 .ProviderDetail-count-lLcKY span{vertical-align:middle}@media (min-width:768px){.ProviderDetail-event-1tR13 .ProviderDetail-count-lLcKY{min-height:100px}}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "ProviderDetail-defaultContent-2bSBb",
		"header": "ProviderDetail-header-3-E12",
		"edit": "ProviderDetail-edit-1RLam",
		"menu": "ProviderDetail-menu-3UPou",
		"count": "ProviderDetail-count-lLcKY",
		"success": "ProviderDetail-success-72kst",
		"warning": "ProviderDetail-warning-xXPzJ",
		"danger": "ProviderDetail-danger-3ZUUi",
		"contact": "ProviderDetail-contact-3ZhmU",
		"event": "ProviderDetail-event-1tR13"
	};

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderPicker-search-30FSK{overflow:hidden;padding:10px;border-bottom:1px solid #dadada}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb{overflow:hidden}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb input{height:24px;width:100%;border:0;background:transparent;font-size:14px;font-weight:400;line-height:14px;text-transform:uppercase;text-align:center;color:#b0bec5}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb input:-ms-input-placeholder{color:#b0bec5}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb input::placeholder{color:#b0bec5}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb input:focus{outline:0}.ProviderPicker-search-30FSK i{display:none}@media (min-width:768px){.ProviderPicker-search-30FSK i{display:block;float:right}}.ProviderPicker-data-T8Ls1{margin:0;padding:0;list-style-type:none}.ProviderPicker-data-T8Ls1>li{margin:5px 0}.ProviderPicker-data-T8Ls1>li label{font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"search": "ProviderPicker-search-30FSK",
		"container": "ProviderPicker-container-1yrRb",
		"data": "ProviderPicker-data-T8Ls1"
	};

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderScores-default-1xW73{color:#546d79}.ProviderScores-brandGroup-3aeAF{overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}@media (min-width:768px){.ProviderScores-brandGroup-3aeAF{border-left:1px solid #dadada;border-right:1px solid #dadada}}.ProviderScores-brand-3nlHR{text-align:center}.ProviderScores-brand-3nlHR.ProviderScores-perfimmo-39JHT .ProviderScores-count-3CS_e span{color:#00e5ce}.ProviderScores-brand-3nlHR.ProviderScores-actradis-2lBJh .ProviderScores-count-3CS_e{display:inline-block;width:33%}.ProviderScores-brand-3nlHR.ProviderScores-actradis-2lBJh .ProviderScores-count-3CS_e.ProviderScores-ok-2dmhB span{background:#00e5ce;border:none}.ProviderScores-brand-3nlHR.ProviderScores-actradis-2lBJh .ProviderScores-count-3CS_e.ProviderScores-documentExpiredInLessThan15Days-35nqW span{background:#faad44;border:none}.ProviderScores-brand-3nlHR.ProviderScores-actradis-2lBJh .ProviderScores-count-3CS_e.ProviderScores-documentExpired-2EJIy span{background:#ff5766;border:none}.ProviderScores-brand-3nlHR.ProviderScores-actradis-2lBJh .ProviderScores-count-3CS_e span{display:inline-block;width:16px;height:16px;margin-top:5px;border-radius:8px;border:1px solid #546d79}.ProviderScores-brand-3nlHR .ProviderScores-count-3CS_e{display:block;min-height:50px;margin-bottom:10px}.ProviderScores-brand-3nlHR .ProviderScores-count-3CS_e span{font-size:30px;line-height:1}.ProviderScores-brand-3nlHR .ProviderScores-count-3CS_e small{display:block}.ProviderScores-brand-3nlHR>small{display:block;margin-top:10px}", ""]);
	
	// exports
	exports.locals = {
		"default": "ProviderScores-default-1xW73",
		"brandGroup": "ProviderScores-brandGroup-3aeAF",
		"brand": "ProviderScores-brand-3nlHR",
		"perfimmo": "ProviderScores-perfimmo-39JHT",
		"count": "ProviderScores-count-3CS_e",
		"actradis": "ProviderScores-actradis-2lBJh",
		"ok": "ProviderScores-ok-2dmhB",
		"documentExpiredInLessThan15Days": "ProviderScores-documentExpiredInLessThan15Days-35nqW",
		"documentExpired": "ProviderScores-documentExpired-2EJIy"
	};

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderSearchBar-content-884ZP{min-height:475px}.ProviderSearchBar-tabTitle-1xljA span{display:none}@media (min-width:768px){.ProviderSearchBar-tabTitle-1xljA span{display:inline-block}}@media (min-width:768px){.ProviderSearchBar-tabTitle-1xljA i{display:none}}.ProviderSearchBar-footer-3DhAF h4 small{margin-left:20px;font-size:100%}", ""]);
	
	// exports
	exports.locals = {
		"content": "ProviderSearchBar-content-884ZP",
		"tabTitle": "ProviderSearchBar-tabTitle-1xljA",
		"footer": "ProviderSearchBar-footer-3DhAF"
	};

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".default{margin-bottom:20px;color:#546d79}.default h4{margin:30px 0;text-transform:uppercase}.default h4,.switch{text-align:center}.ProviderStats-default-3WSwl{margin-bottom:20px;color:#546d79}.ProviderStats-default-3WSwl h4{margin:30px 0;text-transform:uppercase;text-align:center}.ProviderStats-switch-1srHx{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "ProviderStats-default-3WSwl",
		"switch": "ProviderStats-switch-1srHx"
	};

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderStream-pagination-2OnWt{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "ProviderStream-pagination-2OnWt"
	};

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ProviderSuggestSelector-provider-8fjO3{position:relative;overflow:hidden;padding-bottom:15px;text-transform:uppercase}.ProviderSuggestSelector-provider-8fjO3 i{display:block;float:left;margin-right:10px}.ProviderSuggestSelector-provider-8fjO3 .ProviderSuggestSelector-container-3M6Zw{overflow:hidden}.ProviderSuggestSelector-provider-8fjO3 .ProviderSuggestSelector-container-3M6Zw p{margin:0}.ProviderSuggestSelector-provider-8fjO3 .ProviderSuggestSelector-container-3M6Zw small{font-style:italic;font-weight:300;text-transform:none}.ProviderSuggestSelector-provider-8fjO3 a{position:absolute;display:block;bottom:0;right:0;text-transform:none;color:#00e5ce}.ProviderSuggestSelector-data-2Ldnb{margin:0;padding:0;list-style-type:none}.ProviderSuggestSelector-data-2Ldnb>li{margin:5px 0}.ProviderSuggestSelector-data-2Ldnb>li label{font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"provider": "ProviderSuggestSelector-provider-8fjO3",
		"container": "ProviderSuggestSelector-container-3M6Zw",
		"data": "ProviderSuggestSelector-data-2Ldnb"
	};

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".RemoveInterventionPeriodModal-text-28lyq{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "RemoveInterventionPeriodModal-text-28lyq"
	};

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".SubscribeProviderCompanyToDirectoryForInterventionPeriodForm-default-2yobW .SubscribeProviderCompanyToDirectoryForInterventionPeriodForm-section-2fvBt h5{margin:10px 0;text-transform:none}.SubscribeProviderCompanyToDirectoryForInterventionPeriodForm-default-2yobW .SubscribeProviderCompanyToDirectoryForInterventionPeriodForm-section-2fvBt h5 i{color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"default": "SubscribeProviderCompanyToDirectoryForInterventionPeriodForm-default-2yobW",
		"section": "SubscribeProviderCompanyToDirectoryForInterventionPeriodForm-section-2fvBt"
	};

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UnAssignActivityFromProviderCompanyModal-text-2B1gr{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "UnAssignActivityFromProviderCompanyModal-text-2B1gr"
	};

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateInterventionPeriodPanel-defaultContent-2_GLg h5{margin:20px 0;font-weight:400;text-transform:uppercase}.UpdateInterventionPeriodPanel-defaultContent-2_GLg h5 span{display:inline-block;height:24px;line-height:24px;vertical-align:bottom}.UpdateInterventionPeriodPanel-defaultContent-2_GLg h5 button{padding:0 10px}.UpdateInterventionPeriodPanel-header-1MH2T h5.UpdateInterventionPeriodPanel-headerContent-25r1_{margin:0}.UpdateInterventionPeriodPanel-header-1MH2T h5.UpdateInterventionPeriodPanel-headerContent-25r1_ small{color:#ff5766}.UpdateInterventionPeriodPanel-delete-1xA5Q{margin:10px;text-align:center}.UpdateInterventionPeriodPanel-delete-1xA5Q a{font-weight:400;color:#ff5766}.UpdateInterventionPeriodPanel-interventionZone-3r7S2 .UpdateInterventionPeriodPanel-container-3Ww5N{overflow:hidden}.UpdateInterventionPeriodPanel-interventionZone-3r7S2 .UpdateInterventionPeriodPanel-map-YZEAY{float:left;width:50%}.UpdateInterventionPeriodPanel-interventionZone-3r7S2 .UpdateInterventionPeriodPanel-side-euEG3{float:left;width:50%;padding-left:20px}.UpdateInterventionPeriodPanel-openingTicketPurposes-3WGg7 ul{margin:0;padding:0;list-style-type:none}.UpdateInterventionPeriodPanel-openingTicketPurposes-3WGg7 ul>li.UpdateInterventionPeriodPanel-excluded-3S61Y{font-style:italic;color:#b0bec5}.UpdateInterventionPeriodPanel-openingTicketPurposes-3WGg7 ul>li p{margin:0}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "UpdateInterventionPeriodPanel-defaultContent-2_GLg",
		"header": "UpdateInterventionPeriodPanel-header-1MH2T",
		"headerContent": "UpdateInterventionPeriodPanel-headerContent-25r1_",
		"delete": "UpdateInterventionPeriodPanel-delete-1xA5Q",
		"interventionZone": "UpdateInterventionPeriodPanel-interventionZone-3r7S2",
		"container": "UpdateInterventionPeriodPanel-container-3Ww5N",
		"map": "UpdateInterventionPeriodPanel-map-YZEAY",
		"side": "UpdateInterventionPeriodPanel-side-euEG3",
		"openingTicketPurposes": "UpdateInterventionPeriodPanel-openingTicketPurposes-3WGg7",
		"excluded": "UpdateInterventionPeriodPanel-excluded-3S61Y"
	};

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".decisionTree{padding:0 20px}@media (min-width:768px){.decisionTree{margin:0 calc((750px - 100vw) / 2 - 15px)}}@media (min-width:992px){.decisionTree{margin:0 calc((970px - 100vw) / 2 - 15px)}}@media (min-width:1200px){.decisionTree{margin:0 calc((1170px - 100vw) / 2 - 15px)}}#wrapper *,#wrapper :after,#wrapper :before{box-sizing:border-box}.topWrapper,.topWrapper .actionsWrapper{display:-ms-flexbox;display:flex}.topWrapper .actionsWrapper{background-color:#f5f5f5;z-index:3;-ms-flex-direction:column;flex-direction:column;max-width:400px}#wrapper{position:relative;min-height:60px}#wrapper .branch{position:relative;margin-left:250px}#wrapper .branch:before{content:\"\";width:55px;border-top:2px solid #b8aea3;position:absolute;left:-100px;top:50%;margin-top:1px}#wrapper .entry{position:relative;min-height:60px;margin-bottom:10px}#wrapper .entry:before{content:\"\";height:100%;border-left:2px solid #b8aea3;position:absolute;left:-50px}#wrapper .entry:after{content:\"\";width:50px;border-top:2px solid #b8aea3;position:absolute;left:-50px;top:50%;margin-top:1px}#wrapper .entry:first-of-type:before{width:10px;height:50%;top:50%;margin-top:2px;border-radius:10px 0 0 0}#wrapper .entry:first-of-type:after{height:10px;border-radius:10px 0 0 0}#wrapper .entry:last-of-type:before{width:10px;height:50%;border-radius:0 0 0 10px}#wrapper .entry:last-of-type:after{height:10px;border-top:none;border-bottom:2px solid #b8aea3;border-radius:0 0 0 10px;margin-top:-9px}#wrapper .entry.sole:before{display:none}#wrapper .entry.sole:after{width:50px;height:0;margin-top:1px;border-radius:0}#wrapper .labelTree,#wrapper .rootTree{display:block;min-width:150px;min-height:60px;padding:5px 10px;line-height:20px;text-align:center;border:2px solid #b8aea3;border-radius:5px;position:absolute;left:0;top:50%;margin-top:-28px}#wrapper .criteriaBox{border:2px solid #b8aea3;background-color:#eaeaea;width:160px;padding-left:5px;text-align:center;padding-top:10px;padding-bottom:10px;margin-bottom:10px}#wrapper .criteriaBox .criteriaTitle{color:#b8aea3;font-weight:500}#wrapper .workflow{background-color:#77b5fe;color:#f5f5f5;font-weight:500;border-color:#77b5fe}#wrapper .workflow button{color:#8a859a}#wrapper .comment{background-color:#b8aea3;color:#f5f5f5;font-weight:500;border-color:#b8aea3}#wrapper .comment button{color:#8a859a}.actions{padding-top:66px}", ""]);
	
	// exports


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AssociateActivityWithOpeningTicketPurposeModal-providerContacts-2X9Od{padding:0 10px}.AssociateActivityWithOpeningTicketPurposeModal-text-1hjEM{margin:30px 0;padding:0 10px;text-align:center}.AssociateActivityWithOpeningTicketPurposeModal-providerContactActions-1E5dI{text-align:right}", ""]);
	
	// exports
	exports.locals = {
		"providerContacts": "AssociateActivityWithOpeningTicketPurposeModal-providerContacts-2X9Od",
		"text": "AssociateActivityWithOpeningTicketPurposeModal-text-1hjEM",
		"providerContactActions": "AssociateActivityWithOpeningTicketPurposeModal-providerContactActions-1E5dI"
	};

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CreateOpeningTicketPurposePanel-defaultContent-gb7vY h4{margin:20px 0;text-align:center;text-transform:uppercase;font-weight:400}.CreateOpeningTicketPurposePanel-defaultContent-gb7vY h5{margin:20px 0;font-weight:400;text-transform:uppercase}.CreateOpeningTicketPurposePanel-category-1QDox{position:relative}.CreateOpeningTicketPurposePanel-category-1QDox small{position:absolute;top:14px;right:-10px;font-size:16px;font-weight:400}.CreateOpeningTicketPurposePanel-categorySection-1I22z{margin-bottom:15px;border-bottom:1px solid #dadada}.CreateOpeningTicketPurposePanel-manage-3cTZB{margin:10px;text-align:center}.CreateOpeningTicketPurposePanel-manage-3cTZB a{font-weight:400;color:#00e5ce}.CreateOpeningTicketPurposePanel-info-1SauA{display:inline-block;float:right;min-width:22px;padding:4px 0 2px;border:1px solid #00e5ce;border-radius:11px;line-height:1;text-align:center;font-size:14px;font-weight:400;color:#00e5ce}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "CreateOpeningTicketPurposePanel-defaultContent-gb7vY",
		"category": "CreateOpeningTicketPurposePanel-category-1QDox",
		"categorySection": "CreateOpeningTicketPurposePanel-categorySection-1I22z",
		"manage": "CreateOpeningTicketPurposePanel-manage-3cTZB",
		"info": "CreateOpeningTicketPurposePanel-info-1SauA"
	};

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CreateUpdateCategoryModal-defaultContent-2RU1J form{margin:0}.CreateUpdateCategoryModal-actionGroup-3d9qC button{margin-bottom:15px}.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr{margin:0;padding:0;list-style-type:none}.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr>li{display:inline-block;text-align:center;vertical-align:top}.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr>li button{padding:0;font-size:14px;font-weight:400;white-space:normal;color:#8a959a}.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr>li button.active{color:#546d79}.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr>li button:hover{text-decoration:none}.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr>li button:hover label,.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr>li button:hover small{color:#546d79}.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr>li button label{display:block;margin:0;min-height:40px}.CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr>li button label:first-letter{text-transform:uppercase}.CreateUpdateCategoryModal-categoryGroup-2cE52>li{width:33%}.CreateUpdateCategoryModal-categoryGroup-2cE52>li:last-child .CreateUpdateCategoryModal-category-1cUP2 small{display:none}.CreateUpdateCategoryModal-iconGroup-17iL9>li{width:25%}.CreateUpdateCategoryModal-category-1cUP2{position:relative}.CreateUpdateCategoryModal-category-1cUP2 small{position:absolute;top:14px;right:-10px;font-size:16px;font-weight:400}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "CreateUpdateCategoryModal-defaultContent-2RU1J",
		"actionGroup": "CreateUpdateCategoryModal-actionGroup-3d9qC",
		"typeaheadHeaderGroup": "CreateUpdateCategoryModal-typeaheadHeaderGroup-1JrNr",
		"categoryGroup": "CreateUpdateCategoryModal-categoryGroup-2cE52",
		"category": "CreateUpdateCategoryModal-category-1cUP2",
		"iconGroup": "CreateUpdateCategoryModal-iconGroup-17iL9"
	};

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CreateUpdateTagModal-defaultContent-24t5e form{margin:0}.CreateUpdateTagModal-actionGroup-3EGF6 button{margin-bottom:15px}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb{margin:0;padding:0;list-style-type:none}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li{display:inline-block;width:25%;text-align:center;vertical-align:top}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button{padding:0;font-size:14px;font-weight:400;white-space:normal;color:#8a959a}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button.active{color:#546d79}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button:hover{text-decoration:none}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button:hover label,.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button:hover small{color:#546d79}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button label{display:block;margin:0;min-height:40px}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button label:first-letter{text-transform:uppercase}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "CreateUpdateTagModal-defaultContent-24t5e",
		"actionGroup": "CreateUpdateTagModal-actionGroup-3EGF6",
		"typeaheadHeaderGroup": "CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb"
	};

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DissociateActivityFromOpeningTicketPurposeModal-text-3TFVB{margin:30px 0;padding:0 10px;text-align:center}.DissociateActivityFromOpeningTicketPurposeModal-providerContactGroup-307sT{margin:0;padding:0;list-style-type:none}.DissociateActivityFromOpeningTicketPurposeModal-providerContactGroup-307sT>li p{margin:0;font-weight:400;text-align:left;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"text": "DissociateActivityFromOpeningTicketPurposeModal-text-3TFVB",
		"providerContactGroup": "DissociateActivityFromOpeningTicketPurposeModal-providerContactGroup-307sT"
	};

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".EnableDisableOpeningTicketPurposeModal-text-1XIlO{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "EnableDisableOpeningTicketPurposeModal-text-1XIlO"
	};

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP{margin:0;padding:0;list-style-type:none}.OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP>li{display:inline-block;width:25%;text-align:center;vertical-align:middle}.OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP>li:last-child .OpeningTicketPurposePanelGroup-category-1UrQJ small{display:none}.OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP>li button{display:block;width:100%;padding:0;font-size:14px;font-weight:400;white-space:normal;color:#8a959a}.OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP>li button.active{color:#546d79}.OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP>li button:hover{text-decoration:none}.OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP>li button label{display:block;margin:0;min-height:40px}.OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP>li button label:first-letter{text-transform:uppercase}.OpeningTicketPurposePanelGroup-main-3vul1 .OpeningTicketPurposePanelGroup-categoryTagSection-2NJ9F{overflow:hidden;margin-top:-5px;padding-top:5px}@media (min-width:768px){.OpeningTicketPurposePanelGroup-main-3vul1 .OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP{float:left}.OpeningTicketPurposePanelGroup-main-3vul1 .OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP>li{width:92.5px}}.OpeningTicketPurposePanelGroup-main-3vul1 .OpeningTicketPurposePanelGroup-categoryGroup-cmMcp{border-bottom:1px solid #dadada;margin-bottom:15px;padding-bottom:15px}@media (min-width:768px){.OpeningTicketPurposePanelGroup-main-3vul1 .OpeningTicketPurposePanelGroup-categoryGroup-cmMcp{border-bottom:0;border-right:1px solid #dadada;margin-bottom:0;margin-right:15px;padding-bottom:0;padding-right:15px}}.OpeningTicketPurposePanelGroup-side-TDpoq{padding-top:22px}.OpeningTicketPurposePanelGroup-side-TDpoq h4{margin:30px 20px;text-transform:uppercase;text-align:center;color:#546d79}.OpeningTicketPurposePanelGroup-side-TDpoq .OpeningTicketPurposePanelGroup-categoryGroup-cmMcp{margin-bottom:15px;padding-bottom:15px;border-bottom:1px solid #dadada}.OpeningTicketPurposePanelGroup-category-1UrQJ{position:relative}.OpeningTicketPurposePanelGroup-category-1UrQJ small{position:absolute;top:14px;right:-10px;font-size:16px;font-weight:400}", ""]);
	
	// exports
	exports.locals = {
		"categoryTagGroup": "OpeningTicketPurposePanelGroup-categoryTagGroup-dO-NP",
		"category": "OpeningTicketPurposePanelGroup-category-1UrQJ",
		"main": "OpeningTicketPurposePanelGroup-main-3vul1",
		"categoryTagSection": "OpeningTicketPurposePanelGroup-categoryTagSection-2NJ9F",
		"categoryGroup": "OpeningTicketPurposePanelGroup-categoryGroup-cmMcp",
		"side": "OpeningTicketPurposePanelGroup-side-TDpoq"
	};

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpeningTicketPurposePicker-categoryTagGroup-HIxc3{margin:0;padding:0;list-style-type:none}.OpeningTicketPurposePicker-categoryTagGroup-HIxc3>li{display:inline-block;width:33%;text-align:center;vertical-align:middle}.OpeningTicketPurposePicker-categoryTagGroup-HIxc3>li:last-child .OpeningTicketPurposePicker-category-2aaQh small{display:none}.OpeningTicketPurposePicker-categoryTagGroup-HIxc3>li button{display:block;width:100%;padding:0;font-size:14px;font-weight:400;white-space:normal;color:#8a959a}.OpeningTicketPurposePicker-categoryTagGroup-HIxc3>li button.active{color:#546d79}.OpeningTicketPurposePicker-categoryTagGroup-HIxc3>li button:hover{text-decoration:none}.OpeningTicketPurposePicker-categoryTagGroup-HIxc3>li button label{display:block;margin:0;min-height:40px}.OpeningTicketPurposePicker-categoryTagGroup-HIxc3>li button label:first-letter{text-transform:uppercase}.OpeningTicketPurposePicker-main-3qyeT .OpeningTicketPurposePicker-categoryTagSection-2IU0-{overflow:hidden;padding-top:5px}@media (min-width:768px){.OpeningTicketPurposePicker-main-3qyeT .OpeningTicketPurposePicker-categoryTagGroup-HIxc3{float:left}.OpeningTicketPurposePicker-main-3qyeT .OpeningTicketPurposePicker-categoryTagGroup-HIxc3>li{width:92.5px}}.OpeningTicketPurposePicker-main-3qyeT .OpeningTicketPurposePicker-categoryGroup-293D7{border-bottom:1px solid #dadada;margin-bottom:15px;padding-bottom:15px}@media (min-width:768px){.OpeningTicketPurposePicker-main-3qyeT .OpeningTicketPurposePicker-categoryGroup-293D7{border-bottom:0;border-right:1px solid #dadada;margin-bottom:0;margin-right:15px;padding-bottom:0;padding-right:15px}}.OpeningTicketPurposePicker-side-3Btfo .OpeningTicketPurposePicker-categoryTagSection-2IU0-{max-height:481px;overflow-y:auto;overflow-x:hidden}.OpeningTicketPurposePicker-side-3Btfo .OpeningTicketPurposePicker-categoryGroup-293D7{margin-bottom:15px;padding-bottom:15px;border-bottom:1px solid #dadada}.OpeningTicketPurposePicker-category-2aaQh{position:relative}.OpeningTicketPurposePicker-category-2aaQh small{position:absolute;top:14px;right:-10px;font-size:16px;font-weight:400}", ""]);
	
	// exports
	exports.locals = {
		"categoryTagGroup": "OpeningTicketPurposePicker-categoryTagGroup-HIxc3",
		"category": "OpeningTicketPurposePicker-category-2aaQh",
		"main": "OpeningTicketPurposePicker-main-3qyeT",
		"categoryTagSection": "OpeningTicketPurposePicker-categoryTagSection-2IU0-",
		"categoryGroup": "OpeningTicketPurposePicker-categoryGroup-293D7",
		"side": "OpeningTicketPurposePicker-side-3Btfo"
	};

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateOpeningTicketPurposePanel-defaultContent-1asqJ h4{margin:20px 0;text-align:center;text-transform:uppercase;font-weight:400}.UpdateOpeningTicketPurposePanel-defaultContent-1asqJ h5{margin:20px 0;font-weight:400;text-transform:uppercase}.UpdateOpeningTicketPurposePanel-header-iCj5r{overflow:hidden}.UpdateOpeningTicketPurposePanel-header-iCj5r span{display:block;overflow:hidden;height:36px;line-height:36px}.UpdateOpeningTicketPurposePanel-header-iCj5r i{display:block;float:right}.UpdateOpeningTicketPurposePanel-category-2EDW4{position:relative}.UpdateOpeningTicketPurposePanel-category-2EDW4 small{position:absolute;top:14px;right:-10px;font-size:16px;font-weight:400}.UpdateOpeningTicketPurposePanel-categoryTagSection-2p6sj{padding-top:15px;border-bottom:1px solid #dadada}.UpdateOpeningTicketPurposePanel-categoryTagSection-2p6sj.UpdateOpeningTicketPurposePanel-transient-1JYut{background:#fbfbfb}.UpdateOpeningTicketPurposePanel-categoryTagSection-2p6sj:last-child{border-bottom:0}.UpdateOpeningTicketPurposePanel-manage-pytZ1{margin:10px;text-align:center}.UpdateOpeningTicketPurposePanel-manage-pytZ1 a{font-weight:400;color:#00e5ce}.UpdateOpeningTicketPurposePanel-info-RT1g4{display:inline-block;float:right;min-width:22px;padding:4px 0 2px;border:1px solid #00e5ce;border-radius:11px;line-height:1;text-align:center;font-size:14px;font-weight:400;color:#00e5ce}.UpdateOpeningTicketPurposePanel-disable-3XZTV{margin:20px;text-align:center}.UpdateOpeningTicketPurposePanel-disable-3XZTV a{font-weight:400;color:#ff5766}.UpdateOpeningTicketPurposePanel-activities-3pUo3{border-top:1px solid #dadada}.UpdateOpeningTicketPurposePanel-activities-3pUo3 .UpdateOpeningTicketPurposePanel-action-VirVd{margin:20px 0 0;text-align:right}.UpdateOpeningTicketPurposePanel-activities-3pUo3 .UpdateOpeningTicketPurposePanel-action-VirVd button{padding:5px}.UpdateOpeningTicketPurposePanel-activities-3pUo3 ul{margin:0;padding:0;list-style-type:none}.UpdateOpeningTicketPurposePanel-activities-3pUo3 ul>li{overflow:hidden}.UpdateOpeningTicketPurposePanel-activities-3pUo3 ul>li a{display:block;float:right}.UpdateOpeningTicketPurposePanel-activities-3pUo3 ul>li p{overflow:hidden;margin:0}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "UpdateOpeningTicketPurposePanel-defaultContent-1asqJ",
		"header": "UpdateOpeningTicketPurposePanel-header-iCj5r",
		"category": "UpdateOpeningTicketPurposePanel-category-2EDW4",
		"categoryTagSection": "UpdateOpeningTicketPurposePanel-categoryTagSection-2p6sj",
		"transient": "UpdateOpeningTicketPurposePanel-transient-1JYut",
		"manage": "UpdateOpeningTicketPurposePanel-manage-pytZ1",
		"info": "UpdateOpeningTicketPurposePanel-info-RT1g4",
		"disable": "UpdateOpeningTicketPurposePanel-disable-3XZTV",
		"activities": "UpdateOpeningTicketPurposePanel-activities-3pUo3",
		"action": "UpdateOpeningTicketPurposePanel-action-VirVd"
	};

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AddRemoveQuestionFromCampaignPopover-questionGroup-2SR_M{margin:10px 0;padding:0;list-style-type:none}.AddRemoveQuestionFromCampaignPopover-questionGroup-2SR_M>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.AddRemoveQuestionFromCampaignPopover-questionGroup-2SR_M>li .AddRemoveQuestionFromCampaignPopover-remove--OULp{display:block;float:right}.AddRemoveQuestionFromCampaignPopover-questionGroup-2SR_M>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"questionGroup": "AddRemoveQuestionFromCampaignPopover-questionGroup-2SR_M",
		"remove": "AddRemoveQuestionFromCampaignPopover-remove--OULp"
	};

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AnswerCard-caller-m472U{padding:17px 0}.AnswerCard-questionGroup-2QzKO{margin:10px 0 0;padding:10px 0 0;list-style-type:none;border-top:1px solid #d6dde1}.AnswerCard-questionGroup-2QzKO>li{display:block}.AnswerCard-questionGroup-2QzKO>li h4{text-align:center;text-transform:none;margin-top:11px;margin-bottom:11px;font-weight:300}.AnswerCard-questionGroup-2QzKO>li p{overflow:hidden;margin:10px 0;padding:0}.AnswerCard-questionGroup-2QzKO>li p>i{float:left;margin-right:10px}.AnswerCard-questionGroup-2QzKO>li p>span{display:block;overflow:hidden}.AnswerCard-globalComment-1TqBC h4{text-align:center;text-transform:none;margin-top:11px;margin-bottom:11px;font-weight:300}.AnswerCard-globalComment-1TqBC p{overflow:hidden;margin:10px 0;padding:0}.AnswerCard-globalComment-1TqBC p>i{float:left;margin-right:10px}.AnswerCard-globalComment-1TqBC p>span{display:block;overflow:hidden}", ""]);
	
	// exports
	exports.locals = {
		"caller": "AnswerCard-caller-m472U",
		"questionGroup": "AnswerCard-questionGroup-2QzKO",
		"globalComment": "AnswerCard-globalComment-1TqBC"
	};

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AnswerForm-action-38p-t{margin:-5px 0 10px;text-align:right}", ""]);
	
	// exports
	exports.locals = {
		"action": "AnswerForm-action-38p-t"
	};

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AnswerModal-count-1UHuB,.AnswerModal-rate-2slzy,.AnswerModal-score-2_e_J{display:block;margin-top:20px;font-size:80px;font-weight:lighter;line-height:1}.AnswerModal-questionGroup-QmA_x{margin:0;padding:0;list-style-type:none}.AnswerModal-questionGroup-QmA_x>li{display:block}.AnswerModal-questionGroup-QmA_x>li h4{text-align:center}.AnswerModal-questionGroup-QmA_x>li p{overflow:hidden;margin:10px 0 10px 80px;padding:0}.AnswerModal-questionGroup-QmA_x>li p>i{float:left;margin-right:10px}.AnswerModal-questionGroup-QmA_x>li p>span{display:block;overflow:hidden}.AnswerModal-questionGroup-QmA_x>li .AnswerModal-action-3gWKT{margin-top:5px;text-align:right}.AnswerModal-globalComment-1nn82 h4{text-align:center}.AnswerModal-globalComment-1nn82 p{overflow:hidden;margin:10px 0 10px 80px;padding:0}.AnswerModal-globalComment-1nn82 p>i{float:left;margin-right:10px}.AnswerModal-globalComment-1nn82 p>span{display:block;overflow:hidden}.AnswerModal-averageScore-3lTHi{margin-bottom:20px;text-align:center}.AnswerModal-averageScore-3lTHi h4{text-transform:uppercase}.AnswerModal-answerCount-2cKGm{margin-bottom:20px;text-align:center}.AnswerModal-answerCount-2cKGm h4{text-transform:uppercase}.AnswerModal-answerCount-2cKGm.AnswerModal-danger-3ea5w .AnswerModal-count-1UHuB{color:#ff5766}.AnswerModal-answerCount-2cKGm .AnswerModal-count-1UHuB{color:#00e5ce}.AnswerModal-answerRate-2DRJx{margin-bottom:20px;text-align:center}.AnswerModal-answerRate-2DRJx h4{text-transform:uppercase}.AnswerModal-answerRate-2DRJx.AnswerModal-danger-3ea5w .AnswerModal-rate-2slzy{color:#ff5766}.AnswerModal-answerRate-2DRJx .AnswerModal-rate-2slzy{color:#00e5ce}", ""]);
	
	// exports
	exports.locals = {
		"count": "AnswerModal-count-1UHuB",
		"rate": "AnswerModal-rate-2slzy",
		"score": "AnswerModal-score-2_e_J",
		"questionGroup": "AnswerModal-questionGroup-QmA_x",
		"action": "AnswerModal-action-3gWKT",
		"globalComment": "AnswerModal-globalComment-1nn82",
		"averageScore": "AnswerModal-averageScore-3lTHi",
		"answerCount": "AnswerModal-answerCount-2cKGm",
		"danger": "AnswerModal-danger-3ea5w",
		"answerRate": "AnswerModal-answerRate-2DRJx"
	};

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AnswerStream-pagination-29UPg{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "AnswerStream-pagination-29UPg"
	};

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".AverageNoteDashboardPanel-defaultContent-ariDH{padding-top:60px}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "AverageNoteDashboardPanel-defaultContent-ariDH"
	};

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CampaignCard-title-E6y71{overflow:hidden}.CampaignCard-title-E6y71 i{display:block;float:right}.CampaignCard-title-E6y71 h5{overflow:hidden;height:36px;line-height:36px;white-space:nowrap;text-overflow:ellipsis}", ""]);
	
	// exports
	exports.locals = {
		"title": "CampaignCard-title-E6y71"
	};

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CampaignDashboard-count-2E6lu,.CampaignDashboard-rate-3MnFp{display:block;margin-top:20px;font-size:100px;font-weight:lighter;line-height:1}.CampaignDashboard-answerGroup-1-bIj{margin:0;padding:0;list-style-type:none}.CampaignDashboard-answerGroup-1-bIj>li{display:block}.CampaignDashboard-answerGroup-1-bIj>li h4{text-transform:none;text-align:center}.CampaignDashboard-answerGroup-1-bIj>li p{margin:10px 0 0}.CampaignDashboard-answerCount-2d5QY{text-align:center}.CampaignDashboard-answerCount-2d5QY.CampaignDashboard-danger-2E9dD .CampaignDashboard-count-2E6lu{color:#ff5766}.CampaignDashboard-answerCount-2d5QY .CampaignDashboard-count-2E6lu{color:#00e5ce}.CampaignDashboard-answerRate-1B2L1{text-align:center}.CampaignDashboard-answerRate-1B2L1.CampaignDashboard-danger-2E9dD .CampaignDashboard-rate-3MnFp{color:#ff5766}.CampaignDashboard-answerRate-1B2L1 .CampaignDashboard-rate-3MnFp{color:#00e5ce}", ""]);
	
	// exports
	exports.locals = {
		"count": "CampaignDashboard-count-2E6lu",
		"rate": "CampaignDashboard-rate-3MnFp",
		"answerGroup": "CampaignDashboard-answerGroup-1-bIj",
		"answerCount": "CampaignDashboard-answerCount-2d5QY",
		"danger": "CampaignDashboard-danger-2E9dD",
		"answerRate": "CampaignDashboard-answerRate-1B2L1"
	};

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".defaultContent{margin-bottom:20px}.header{position:relative}.header:after{display:block;content:\" \";clear:both}.header .edit{display:block;float:right;line-height:24px}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.CampaignDetail-defaultContent-1lCvQ{margin-bottom:20px}.CampaignDetail-header-2Zedy{position:relative}.CampaignDetail-header-2Zedy:after{display:block;content:\" \";clear:both}.CampaignDetail-header-2Zedy .CampaignDetail-edit-1wMOg{display:block;float:right;line-height:24px}.CampaignDetail-menu-3T3Lq{margin:0;padding:0;list-style-type:none}.CampaignDetail-menu-3T3Lq>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.CampaignDetail-menu-3T3Lq>li:first-child{border-top:0}.CampaignDetail-menu-3T3Lq>li a:hover{text-decoration:none}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "CampaignDetail-defaultContent-1lCvQ",
		"header": "CampaignDetail-header-2Zedy",
		"edit": "CampaignDetail-edit-1wMOg",
		"menu": "CampaignDetail-menu-3T3Lq"
	};

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CreateCampaignModal-notationScaleGroup-gRG5M{margin:10px 0;padding:0;list-style-type:none}.CreateCampaignModal-notationScaleGroup-gRG5M>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.CreateCampaignModal-notationScaleGroup-gRG5M>li .CreateCampaignModal-remove-3deSW{display:block;float:right}.CreateCampaignModal-notationScaleGroup-gRG5M>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"notationScaleGroup": "CreateCampaignModal-notationScaleGroup-gRG5M",
		"remove": "CreateCampaignModal-remove-3deSW"
	};

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".FinishCampaignModal-text-20vI_{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "FinishCampaignModal-text-20vI_"
	};

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".SatisfactionButton-default-2YqPy button{padding:0}", ""]);
	
	// exports
	exports.locals = {
		"default": "SatisfactionButton-default-2YqPy"
	};

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".StartCampaignModal-text-3Hh4E{margin:30px 0;text-align:center}.StartCampaignModal-elligibleTicketDate-2X0-K{text-align:center}.StartCampaignModal-elligibleTicketDate-2X0-K h4{text-transform:uppercase;margin-bottom:30px}", ""]);
	
	// exports
	exports.locals = {
		"text": "StartCampaignModal-text-3Hh4E",
		"elligibleTicketDate": "StartCampaignModal-elligibleTicketDate-2X0-K"
	};

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UpdateNotationScaleOfCampaignPopover-notationScaleGroup-2b5Wg{margin:10px 0;padding:0;list-style-type:none}.UpdateNotationScaleOfCampaignPopover-notationScaleGroup-2b5Wg>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.UpdateNotationScaleOfCampaignPopover-notationScaleGroup-2b5Wg>li .UpdateNotationScaleOfCampaignPopover-remove-1xR6r{display:block;float:right}.UpdateNotationScaleOfCampaignPopover-notationScaleGroup-2b5Wg>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"notationScaleGroup": "UpdateNotationScaleOfCampaignPopover-notationScaleGroup-2b5Wg",
		"remove": "UpdateNotationScaleOfCampaignPopover-remove-1xR6r"
	};

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".CloseTicketCard-cmdType-18nGJ{margin-bottom:10px;padding:10px 0}.CloseTicketCard-cmdType-18nGJ ul{margin:0;padding:0;list-style-type:none}.CloseTicketCard-cmdType-18nGJ ul>li label{font-weight:300}.CloseTicketCard-interventionDate-1WBuR{margin-right:-20px}.CloseTicketCard-interventionDate-1WBuR a{color:#8a959a}.CloseTicketCard-interventionDate-1WBuR a:hover{text-decoration:none;color:#546d79}.CloseTicketCard-interventionDateTimePicker-3d4-P{text-align:center}.CloseTicketCard-interventionDateTimePicker-3d4-P .CloseTicketCard-container-1RY2v{display:inline-block}", ""]);
	
	// exports
	exports.locals = {
		"cmdType": "CloseTicketCard-cmdType-18nGJ",
		"interventionDate": "CloseTicketCard-interventionDate-1WBuR",
		"interventionDateTimePicker": "CloseTicketCard-interventionDateTimePicker-3d4-P",
		"container": "CloseTicketCard-container-1RY2v"
	};

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ClosingRateDashboardPanel-rate-3GjhR{display:block;margin-top:20px;font-size:100px;font-weight:lighter;line-height:1}.ClosingRateDashboardPanel-closingRate-1mMFK{text-align:center}.ClosingRateDashboardPanel-closingRate-1mMFK .ClosingRateDashboardPanel-rate-3GjhR{color:#ff5766}", ""]);
	
	// exports
	exports.locals = {
		"rate": "ClosingRateDashboardPanel-rate-3GjhR",
		"closingRate": "ClosingRateDashboardPanel-closingRate-1mMFK"
	};

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".DefineInterventionDeadlineModal-datePicker-1A0w3{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"datePicker": "DefineInterventionDeadlineModal-datePicker-1A0w3"
	};

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".EmitCallToModal-defaultContent-2NTL_ h5 i{color:#ff5766}.EmitCallToModal-defaultContent-2NTL_ h5 small{display:block;margin-top:10px;font-size:16px;text-transform:none}.EmitCallToModal-callType-rNhm7{overflow:hidden;margin:20px 0}.EmitCallToModal-callType-rNhm7 .EmitCallToModal-container-1-G4w{margin:0;padding:0;list-style-type:none}.EmitCallToModal-callType-rNhm7 .EmitCallToModal-container-1-G4w>li{display:table-cell;width:1%;text-align:center}.EmitCallToModal-callType-rNhm7 .EmitCallToModal-container-1-G4w>li button{padding:0;font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.EmitCallToModal-callType-rNhm7 .EmitCallToModal-container-1-G4w>li button.active{color:#546d79}.EmitCallToModal-callType-rNhm7 .EmitCallToModal-container-1-G4w>li span{display:block}.EmitCallToModal-callType-rNhm7 .EmitCallToModal-container-1-G4w>li span:first-letter{text-transform:uppercase}.EmitCallToModal-interventionCmdType-1-GYm{margin:0;padding:0;list-style-type:none}.EmitCallToModal-interventionCmdType-1-GYm>li label{font-weight:300}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "EmitCallToModal-defaultContent-2NTL_",
		"callType": "EmitCallToModal-callType-rNhm7",
		"container": "EmitCallToModal-container-1-G4w",
		"interventionCmdType": "EmitCallToModal-interventionCmdType-1-GYm"
	};

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ExportTicketsModal-exportType-2WdmT{overflow:hidden;margin:20px 0}.ExportTicketsModal-exportType-2WdmT .ExportTicketsModal-container-3hxgK{margin:0;padding:0;list-style-type:none}.ExportTicketsModal-exportType-2WdmT .ExportTicketsModal-container-3hxgK>li{display:table-cell;width:1%;text-align:center}.ExportTicketsModal-exportType-2WdmT .ExportTicketsModal-container-3hxgK>li button{padding:0;font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.ExportTicketsModal-exportType-2WdmT .ExportTicketsModal-container-3hxgK>li button.active{color:#546d79}.ExportTicketsModal-exportType-2WdmT .ExportTicketsModal-container-3hxgK>li span{display:block}.ExportTicketsModal-exportType-2WdmT .ExportTicketsModal-container-3hxgK>li span:first-letter{text-transform:uppercase}.ExportTicketsModal-info-2yAM2{text-align:center;margin:20px 40px;font-style:italic;color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"exportType": "ExportTicketsModal-exportType-2WdmT",
		"container": "ExportTicketsModal-container-3hxgK",
		"info": "ExportTicketsModal-info-2yAM2"
	};

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".IdentifyAssigneeCard-main-3uRLg h5{overflow:hidden;margin:10px 0;text-transform:none}.IdentifyAssigneeCard-main-3uRLg h5 a{display:block;float:right;color:#00e5ce}.IdentifyAssigneeCard-visibility-3m9bR{display:none}.IdentifyAssigneeCard-visibility-3m9bR.IdentifyAssigneeCard-visible-27XwW{display:initial}", ""]);
	
	// exports
	exports.locals = {
		"main": "IdentifyAssigneeCard-main-3uRLg",
		"visibility": "IdentifyAssigneeCard-visibility-3m9bR",
		"visible": "IdentifyAssigneeCard-visible-27XwW"
	};

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpenTicketAddressCard-map-3CPe2{margin:-10px -44px 10px -10px}.OpenTicketAddressCard-step-2h2M9{display:inline-block;min-width:24px;padding:6px 0 4px;border-radius:12px;background:#dadada;font-size:14px;font-weight:400;color:#fff}.OpenTicketAddressCard-patrimony-2zj5K h4 small{margin-bottom:5px;text-transform:uppercase;font-size:14px;font-style:italic;color:inherit}.OpenTicketAddressCard-patrimony-2zj5K small{display:block;font-size:14px;font-weight:300;font-style:italic}.OpenTicketAddressCard-split-AXj5V .OpenTicketAddressCard-main-1qfx7{margin-top:36px}", ""]);
	
	// exports
	exports.locals = {
		"map": "OpenTicketAddressCard-map-3CPe2",
		"step": "OpenTicketAddressCard-step-2h2M9",
		"patrimony": "OpenTicketAddressCard-patrimony-2zj5K",
		"split": "OpenTicketAddressCard-split-AXj5V",
		"main": "OpenTicketAddressCard-main-1qfx7"
	};

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpenTicketButtonToolbar-text-TWHz5{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "OpenTicketButtonToolbar-text-TWHz5"
	};

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpenTicketCompanyCard-default-2fh6q p{margin:0;padding:10px;text-transform:uppercase;color:#546d79;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "OpenTicketCompanyCard-default-2fh6q"
	};

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpenTicketContactToCallbackCard-defaultContent-2aK4j{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "OpenTicketContactToCallbackCard-defaultContent-2aK4j"
	};

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpenTicketModal-header-1Oo0r{position:absolute;top:0;left:0;right:0;padding:15px 15px 0}.OpenTicketModal-main-37k3q{left:0;width:66.66666667%}.OpenTicketModal-main-37k3q,.OpenTicketModal-side-2zDe5{position:absolute;top:130px;bottom:15px;padding:0 15px;overflow-x:hidden;overflow-y:auto}.OpenTicketModal-side-2zDe5{right:0;width:33.33333333%}.OpenTicketModal-stepInfoGroup-2x-bj{overflow:hidden;margin:-30px 0 0;padding:0;list-style-type:none}.OpenTicketModal-stepInfoGroup-2x-bj li{display:block;float:left;width:33%;text-align:center}.OpenTicketModal-stepInfoGroup-2x-bj li.OpenTicketModal-success-2D6md h5,.OpenTicketModal-stepInfoGroup-2x-bj li.OpenTicketModal-success-2D6md h5 small{color:#00e5ce}.OpenTicketModal-stepInfoGroup-2x-bj li.OpenTicketModal-disabled-1v7q1{opacity:.5}.OpenTicketModal-stepInfoGroup-2x-bj li.OpenTicketModal-active-3fb3r h5,.OpenTicketModal-stepInfoGroup-2x-bj li.OpenTicketModal-active-3fb3r h5 small{color:#ff5766}.OpenTicketModal-stepInfoGroup-2x-bj li h5{position:relative;overflow:hidden;height:63px;margin:10px 0;color:#8a959a}.OpenTicketModal-stepInfoGroup-2x-bj li h5:after{content:\"\";position:absolute;bottom:0;left:0;right:0;height:10px;background:linear-gradient(hsla(0,0%,100%,0),#fff)}.OpenTicketModal-stepInfoGroup-2x-bj li h5 i{margin-top:-7px;margin-bottom:5px}.OpenTicketModal-stepInfoGroup-2x-bj li h5>span{display:inline-block;margin-bottom:5px}.OpenTicketModal-stepInfoGroup-2x-bj li h5 small{display:block;font-size:16px;font-style:italic;text-transform:none;color:#8a959a}.OpenTicketModal-toolbar-JPVud{position:absolute;bottom:0;right:80px;border-radius:30px;background:hsla(0,0%,100%,.7)}.OpenTicketModal-toolbar-JPVud button{width:60px;height:60px;border-radius:30px;padding:0;margin:10px;color:#fff}.OpenTicketModal-toolbar-JPVud button span{display:inline-block;padding-top:3px}.OpenTicketModal-visibility-3jdBp{display:none}.OpenTicketModal-visibility-3jdBp.OpenTicketModal-visible-8_sw6{display:initial}.OpenTicketModal-text-2oCpb{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"header": "OpenTicketModal-header-1Oo0r",
		"main": "OpenTicketModal-main-37k3q",
		"side": "OpenTicketModal-side-2zDe5",
		"stepInfoGroup": "OpenTicketModal-stepInfoGroup-2x-bj",
		"success": "OpenTicketModal-success-2D6md",
		"disabled": "OpenTicketModal-disabled-1v7q1",
		"active": "OpenTicketModal-active-3fb3r",
		"toolbar": "OpenTicketModal-toolbar-JPVud",
		"visibility": "OpenTicketModal-visibility-3jdBp",
		"visible": "OpenTicketModal-visible-8_sw6",
		"text": "OpenTicketModal-text-2oCpb"
	};

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".OpenTicketPurposeCard-openingTicketInstruction-1Crzx h5{margin:15px 0;color:#ff5766}.OpenTicketPurposeCard-openingTicketInstruction-1Crzx p{margin-bottom:15px;font-weight:400;color:#546d79}.OpenTicketPurposeCard-openingTicketInstruction-1Crzx .checkbox label{font-weight:300}", ""]);
	
	// exports
	exports.locals = {
		"openingTicketInstruction": "OpenTicketPurposeCard-openingTicketInstruction-1Crzx"
	};

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReceiveCallModal-defaultContent-2GeEz h5 i{color:#ff5766}.ReceiveCallModal-defaultContent-2GeEz h5 small{display:block;margin-top:10px;font-size:16px;text-transform:none}.ReceiveCallModal-callType-1wOB5{overflow:hidden;margin:20px 0}.ReceiveCallModal-callType-1wOB5 .ReceiveCallModal-container-325Uo{margin:0;padding:0;list-style-type:none}.ReceiveCallModal-callType-1wOB5 .ReceiveCallModal-container-325Uo>li{display:table-cell;width:1%;text-align:center}.ReceiveCallModal-callType-1wOB5 .ReceiveCallModal-container-325Uo>li button{padding:0;font-size:14px;font-weight:400;text-decoration:none;color:#8a959a}.ReceiveCallModal-callType-1wOB5 .ReceiveCallModal-container-325Uo>li button.active{color:#546d79}.ReceiveCallModal-callType-1wOB5 .ReceiveCallModal-container-325Uo>li span{display:block}.ReceiveCallModal-callType-1wOB5 .ReceiveCallModal-container-325Uo>li span:first-letter{text-transform:uppercase}", ""]);
	
	// exports
	exports.locals = {
		"defaultContent": "ReceiveCallModal-defaultContent-2GeEz",
		"callType": "ReceiveCallModal-callType-1wOB5",
		"container": "ReceiveCallModal-container-325Uo"
	};

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReportFormalNoticeForProviderModal-datePicker-_jzPz{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"datePicker": "ReportFormalNoticeForProviderModal-datePicker-_jzPz"
	};

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ReportSendingServiceOrderModal-datePicker-2CAe5{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"datePicker": "ReportSendingServiceOrderModal-datePicker-2CAe5"
	};

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ScheduleInterventionModal-dateTimePicker-1Z86c{text-align:center}.ScheduleInterventionModal-dateTimePicker-1Z86c .ScheduleInterventionModal-container-PNJvj{display:inline-block}", ""]);
	
	// exports
	exports.locals = {
		"dateTimePicker": "ScheduleInterventionModal-dateTimePicker-1Z86c",
		"container": "ScheduleInterventionModal-container-PNJvj"
	};

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketAddressCard-default-1AXDE .TicketAddressCard-address-3cGut p{margin:0}.TicketAddressCard-address-3cGut ul{margin:0;padding:0;list-style-type:none}.TicketAddressCard-address-3cGut ul>li{display:inline}.TicketAddressCard-address-3cGut ul>li:not(:last-child):after{content:\", \"}.TicketAddressCard-noTicketInfo-1xHif{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "TicketAddressCard-default-1AXDE",
		"address": "TicketAddressCard-address-3cGut",
		"noTicketInfo": "TicketAddressCard-noTicketInfo-1xHif"
	};

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketAssigneeCard-contact-3mnq8{margin:0;padding:0;list-style-type:none}.TicketAssigneeCard-contact-3mnq8>li{display:inline-block;margin:5px 20px 5px 0}.TicketAssigneeCard-event-2oZZ0{color:#546d79;margin:5px 0}.TicketAssigneeCard-event-2oZZ0 i{float:left;margin-right:4px}.TicketAssigneeCard-event-2oZZ0 .TicketAssigneeCard-container-Hp9Yl{overflow:hidden;padding-top:2px}.TicketAssigneeCard-comment-20FAH{margin:5px 0}.TicketAssigneeCard-comment-20FAH.TicketAssigneeCard-warning-1lJpu{margin:0}.TicketAssigneeCard-comment-20FAH.TicketAssigneeCard-warning-1lJpu p{margin:5px 0;color:#546d79}.TicketAssigneeCard-comment-20FAH.TicketAssigneeCard-warning-1lJpu strong:before{content:\"! \";margin-left:5px;font-size:20px;color:#ff5766}.TicketAssigneeCard-comment-20FAH p{margin:0;color:#b0bec5}.TicketAssigneeCard-callingGroup-1YbnE{overflow:hidden;width:100%;margin:0 -5px;padding:0;list-style-type:none}.TicketAssigneeCard-callingGroup-1YbnE>li{display:block;float:left;margin:0;padding:0 5px;width:50%}.TicketAssigneeCard-callingGroup-1YbnE>li button{width:100%;margin:0;padding:10px;border-radius:0;font-size:14px}.TicketAssigneeCard-callingGroup-1YbnE>li button:hover{border:1px solid #546d79;background:#fff}.TicketAssigneeCard-metricGroup-35b-4{margin-top:10px;margin-left:-20px;text-align:center}.TicketAssigneeCard-metricGroup-35b-4 .TicketAssigneeCard-metric-125sq{margin-left:10px;margin-bottom:10px}.TicketAssigneeCard-metric-125sq{position:relative;display:inline-block;height:100px;width:100px;padding:10px 0;border-radius:10px;background:#f5f5f5;text-align:center;font-weight:400;color:#546d79}.TicketAssigneeCard-metric-125sq.TicketAssigneeCard-danger-3eAgJ .TicketAssigneeCard-time-35qJu{background:#ff5766}.TicketAssigneeCard-metric-125sq .TicketAssigneeCard-time-35qJu{position:absolute;left:10px;right:10px;bottom:0;height:40px;line-height:40px;padding:5px;border-radius:40px 40px 0 0;background:#00e5ce;font-size:20px;color:#fff}.TicketAssigneeCard-metric-125sq p{margin:0 0 5px}.TicketAssigneeCard-noTicketInfo-2sBXa{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"contact": "TicketAssigneeCard-contact-3mnq8",
		"event": "TicketAssigneeCard-event-2oZZ0",
		"container": "TicketAssigneeCard-container-Hp9Yl",
		"comment": "TicketAssigneeCard-comment-20FAH",
		"warning": "TicketAssigneeCard-warning-1lJpu",
		"callingGroup": "TicketAssigneeCard-callingGroup-1YbnE",
		"metricGroup": "TicketAssigneeCard-metricGroup-35b-4",
		"metric": "TicketAssigneeCard-metric-125sq",
		"danger": "TicketAssigneeCard-danger-3eAgJ",
		"time": "TicketAssigneeCard-time-35qJu",
		"noTicketInfo": "TicketAssigneeCard-noTicketInfo-2sBXa"
	};

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketCallerCard-contact-WRFo-{margin:0;padding:0;list-style-type:none}.TicketCallerCard-contact-WRFo->li{display:inline-block;margin:5px 20px 5px 0}.TicketCallerCard-comment-3REuL{margin:5px 0}.TicketCallerCard-comment-3REuL.TicketCallerCard-warning-2kDW8{margin:0}.TicketCallerCard-comment-3REuL.TicketCallerCard-warning-2kDW8 p{margin:5px 0;color:#546d79}.TicketCallerCard-comment-3REuL.TicketCallerCard-warning-2kDW8 p:before{content:\"! \";margin-left:5px;font-size:20px;color:#ff5766}.TicketCallerCard-comment-3REuL p{margin:0;color:#b0bec5}.TicketCallerCard-callingGroup-3VOud{overflow:hidden;width:100%;margin:0 -5px;padding:0;list-style-type:none}.TicketCallerCard-callingGroup-3VOud>li{display:block;float:left;margin:0;padding:0 5px;width:50%}.TicketCallerCard-callingGroup-3VOud>li button{width:100%;margin:0;padding:10px;border-radius:0;font-size:14px}.TicketCallerCard-callingGroup-3VOud>li button:hover{border:1px solid #546d79;background:#fff}.TicketCallerCard-noTicketInfo-2GdWt{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"contact": "TicketCallerCard-contact-WRFo-",
		"comment": "TicketCallerCard-comment-3REuL",
		"warning": "TicketCallerCard-warning-2kDW8",
		"callingGroup": "TicketCallerCard-callingGroup-3VOud",
		"noTicketInfo": "TicketCallerCard-noTicketInfo-2GdWt"
	};

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketCard-default-2Ivtl p{margin:0}.TicketCard-purpose-r4sFp h5{overflow:hidden;height:36px;line-height:36px;white-space:nowrap;text-overflow:ellipsis}.TicketCard-status-28lMD{overflow:hidden}.TicketCard-status-28lMD i{display:block;float:right}.TicketCard-status-28lMD h5{display:none;overflow:hidden;height:36px;line-height:36px}.TicketCard-status-28lMD h5 small{display:inline-block}.TicketCard-status-28lMD h5 small:first-letter{text-transform:uppercase}@media (min-width:768px){.TicketCard-status-28lMD h5{display:initial}}.TicketCard-caller-2QWcl{padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}@media (min-width:768px){.TicketCard-caller-2QWcl{margin-bottom:-500px;padding-bottom:500px}}.TicketCard-assignee-2zm6j{padding:10px 12px}.TicketCard-assignee-2zm6j,.TicketCard-state-3jepk{border-top:1px solid #d6dde1}.TicketCard-stateContent-2mKiR{margin:10px 0;padding:0 12px}@media (min-width:768px){.TicketCard-stateContent-2mKiR{margin-bottom:-500px;padding-bottom:500px;border-left:1px dotted #d6dde1}}.TicketCard-capitalize-1mJBs{display:inline-block}.TicketCard-capitalize-1mJBs:first-letter{text-transform:uppercase}", ""]);
	
	// exports
	exports.locals = {
		"default": "TicketCard-default-2Ivtl",
		"purpose": "TicketCard-purpose-r4sFp",
		"status": "TicketCard-status-28lMD",
		"caller": "TicketCard-caller-2QWcl",
		"assignee": "TicketCard-assignee-2zm6j",
		"state": "TicketCard-state-3jepk",
		"stateContent": "TicketCard-stateContent-2mKiR",
		"capitalize": "TicketCard-capitalize-1mJBs"
	};

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketDetail-default-1MjC6 p{margin-bottom:10px}.TicketDetail-state-WR6yn{margin-bottom:20px;font-weight:400;text-transform:uppercase;color:#ff5766}.TicketDetail-state-WR6yn small{display:block;margin-top:10px;font-size:16px;text-transform:none}@media (min-width:768px){.TicketDetail-state-WR6yn small{display:inline;margin-left:20px}}.TicketDetail-step-2Ba9U{margin:-5px -10px;padding:5px 10px}.TicketDetail-callPurpose-dPDei{font-weight:400;text-transform:uppercase}.TicketDetail-callPurpose-dPDei label{color:#546d79}.TicketDetail-description-LCcWn{font-weight:400}.TicketDetail-description-LCcWn label{display:block;text-transform:uppercase;color:#546d79}.TicketDetail-contact-1w3Bt{margin:0;padding:0;list-style-type:none}.TicketDetail-contact-1w3Bt>li{display:inline-block;margin:5px 20px 5px 0}.TicketDetail-comment-3V-IK{margin:5px 0}.TicketDetail-comment-3V-IK.TicketDetail-warning-26z0h{margin:0}.TicketDetail-comment-3V-IK.TicketDetail-warning-26z0h p{margin:5px 0;color:#546d79}.TicketDetail-comment-3V-IK.TicketDetail-warning-26z0h p:before{content:\"! \";margin-left:5px;font-size:20px;color:#ff5766}.TicketDetail-comment-3V-IK p{margin:0;color:#b0bec5}.TicketDetail-missionFinished-7SSYA p{margin:0;padding:0;text-transform:uppercase;color:#546d79;text-align:center}.TicketDetail-company-RVfXs p{margin:0;padding:10px;text-transform:uppercase;color:#546d79;text-align:center}.TicketDetail-data-miTuW{margin:0;padding:0;list-style-type:none}.TicketDetail-data-miTuW>li{margin:10px 0}.TicketDetail-data-miTuW>li label{font-weight:400;color:#546d79}.TicketDetail-callingGroup-3FUNF{overflow:hidden;width:100%;margin:0 -5px;padding:0;list-style-type:none}.TicketDetail-callingGroup-3FUNF>li{display:block;float:left;margin:0;padding:0 5px;width:50%}.TicketDetail-callingGroup-3FUNF>li button{width:100%;margin:0;padding:10px;border-radius:0;font-size:14px}.TicketDetail-callingGroup-3FUNF>li button:hover{border:1px solid #546d79;background:#fff}.TicketDetail-menu-2j8NN{margin:0;padding:0;list-style-type:none}.TicketDetail-menu-2j8NN>li{padding:12px 0 10px}.TicketDetail-menu-2j8NN>li button{padding:0;text-transform:uppercase;font-weight:400}.TicketDetail-menu-2j8NN>li button:hover{text-decoration:none}.TicketDetail-switch-2RPUd{overflow:hidden;margin-bottom:30px}.TicketDetail-exportAndSatisfaction-29dYl{overflow:hidden;padding-bottom:10px}.TicketDetail-exportAndSatisfaction-29dYl .TicketDetail-satisfaction--69oy{overflow:hidden}.TicketDetail-exportAndSatisfaction-29dYl .TicketDetail-export-3CTMa{float:right}.TicketDetail-instruction-24qPG p{margin:10px 20px;font-weight:400;color:#546d79}.TicketDetail-metricBox-1CKDL{text-align:center;font-size:20px;font-weight:400;color:#546d79}.TicketDetail-metricBox-1CKDL .TicketDetail-time-1sPTA{margin:0 -15px;font-size:30px;line-height:1.2}.TicketDetail-metricBox-1CKDL p{margin:0 0 10px;line-height:1.2}.TicketDetail-headerHelp-3Llhv i,.TicketDetail-journalHeader-27wAm i{vertical-align:middle}.TicketDetail-journalHeader-27wAm .TicketDetail-container-1pehv{overflow:hidden}.TicketDetail-journalHeader-27wAm .TicketDetail-count-Qq8xy{float:right}.TicketDetail-myAction-27iyI{padding:0!important;border:0!important}.TicketDetail-journalBody-26Jbf{margin:0;padding:0;list-style-type:none}.TicketDetail-journalBody-26Jbf>li{overflow:hidden;display:block;margin:10px 0}.TicketDetail-journalBody-26Jbf>li .TicketDetail-time-1sPTA{float:left;min-width:75px;margin-right:10px}.TicketDetail-journalBody-26Jbf>li .TicketDetail-container-1pehv{overflow:hidden;padding-left:10px;border-left:1px solid #dadada;line-height:24px}.TicketDetail-journalBody-26Jbf>li .TicketDetail-container-1pehv p{overflow:hidden;margin:0;padding:0}.TicketDetail-journalBody-26Jbf>li .TicketDetail-container-1pehv p>i{float:left;margin-right:10px}.TicketDetail-journalBody-26Jbf>li .TicketDetail-container-1pehv p>span{display:block;overflow:hidden}.TicketDetail-journalBody-26Jbf>li .TicketDetail-container-1pehv p>span .TicketDetail-info-2DZ7y{font-size:14px;color:#b0bec5}.TicketDetail-journalBody-26Jbf>li .TicketDetail-container-1pehv p .TicketDetail-action-EDX_J{display:block;float:right}", ""]);
	
	// exports
	exports.locals = {
		"default": "TicketDetail-default-1MjC6",
		"state": "TicketDetail-state-WR6yn",
		"step": "TicketDetail-step-2Ba9U",
		"callPurpose": "TicketDetail-callPurpose-dPDei",
		"description": "TicketDetail-description-LCcWn",
		"contact": "TicketDetail-contact-1w3Bt",
		"comment": "TicketDetail-comment-3V-IK",
		"warning": "TicketDetail-warning-26z0h",
		"missionFinished": "TicketDetail-missionFinished-7SSYA",
		"company": "TicketDetail-company-RVfXs",
		"data": "TicketDetail-data-miTuW",
		"callingGroup": "TicketDetail-callingGroup-3FUNF",
		"menu": "TicketDetail-menu-2j8NN",
		"switch": "TicketDetail-switch-2RPUd",
		"exportAndSatisfaction": "TicketDetail-exportAndSatisfaction-29dYl",
		"satisfaction": "TicketDetail-satisfaction--69oy",
		"export": "TicketDetail-export-3CTMa",
		"instruction": "TicketDetail-instruction-24qPG",
		"metricBox": "TicketDetail-metricBox-1CKDL",
		"time": "TicketDetail-time-1sPTA",
		"headerHelp": "TicketDetail-headerHelp-3Llhv",
		"journalHeader": "TicketDetail-journalHeader-27wAm",
		"container": "TicketDetail-container-1pehv",
		"count": "TicketDetail-count-Qq8xy",
		"myAction": "TicketDetail-myAction-27iyI",
		"journalBody": "TicketDetail-journalBody-26Jbf",
		"info": "TicketDetail-info-2DZ7y",
		"action": "TicketDetail-action-EDX_J"
	};

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketSearchBar-content-31OGS{min-height:475px}.TicketSearchBar-side-1fEyZ h4{margin:0;padding:14px 0 12px;border-bottom:1px solid #dadada;text-align:center}.TicketSearchBar-sideContent-33Ag2 button{overflow:hidden;height:120px;width:120px;padding:0 10px;white-space:normal;text-transform:none}.TicketSearchBar-footer-2UgGi h4 small{margin-left:20px;font-size:100%}.TicketSearchBar-tabTitle-2aBgw span{display:none}@media (min-width:768px){.TicketSearchBar-tabTitle-2aBgw span{display:inline-block}}@media (min-width:768px){.TicketSearchBar-tabTitle-2aBgw i{display:none}}", ""]);
	
	// exports
	exports.locals = {
		"content": "TicketSearchBar-content-31OGS",
		"side": "TicketSearchBar-side-1fEyZ",
		"sideContent": "TicketSearchBar-sideContent-33Ag2",
		"footer": "TicketSearchBar-footer-2UgGi",
		"tabTitle": "TicketSearchBar-tabTitle-2aBgw"
	};

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketStats-default-26o1_{margin-bottom:20px;color:#546d79}.TicketStats-default-26o1_ a{text-decoration:none}.TicketStats-default-26o1_ h3,.TicketStats-default-26o1_ h4{text-transform:uppercase;text-align:center}.TicketStats-default-26o1_ h3{margin:10px 0;font-weight:400}.TicketStats-default-26o1_ h3 i{margin-left:10px;vertical-align:text-top}.TicketStats-default-26o1_ h4{margin:30px 0}.TicketStats-default-26o1_ h4 small{display:block;margin:5px 0;text-transform:none;color:inherit}.TicketStats-body-1C_a9{overflow:hidden}.TicketStats-body-1C_a9.TicketStats-enter-1BLql{max-height:0}.TicketStats-body-1C_a9.TicketStats-enter-1BLql.TicketStats-enterActive-2jXZQ{max-height:300px;transition:max-height .5s ease}.TicketStats-body-1C_a9.TicketStats-leave-1JBhL{max-height:300px}.TicketStats-body-1C_a9.TicketStats-leave-1JBhL.TicketStats-leaveActive-GAYw6{max-height:0;transition:max-height .5s ease}.TicketStats-count-2b3i2{display:inline-block}.TicketStats-count-2b3i2 span{font-size:40px;line-height:1}.TicketStats-switch-SVrIB{position:relative}.TicketStats-switch-SVrIB .TicketStats-container-Ub2Vi{text-align:center}.TicketStats-switch-SVrIB .TicketStats-export-39Hwu{position:absolute;right:0}.TicketStats-switch-SVrIB .TicketStats-export-39Hwu button{padding:0}.TicketStats-newTickets-1Sl2z{text-align:center}@media (min-width:768px){.TicketStats-newTickets-1Sl2z h4{min-height:75px}}.TicketStats-newTickets-1Sl2z .TicketStats-count-2b3i2{display:table-cell;width:1%}.TicketStats-newTickets-1Sl2z .TicketStats-count-2b3i2 span{display:block}.TicketStats-newTickets-1Sl2z .TicketStats-count-2b3i2 small{display:block;font-size:16px}.TicketStats-distribution-3HKK3 .TicketStats-chart-2XLE6{display:inline-block;width:50%}.TicketStats-creationFrequency-1fB9s{text-align:center}@media (min-width:768px){.TicketStats-creationFrequency-1fB9s h4{min-height:65px}}.TicketStats-creationFrequency-1fB9s .TicketStats-count-2b3i2{color:#00e5ce}.TicketStats-creationFrequency-1fB9s .TicketStats-count-2b3i2 i,.TicketStats-creationFrequency-1fB9s .TicketStats-count-2b3i2 span{vertical-align:middle}.TicketStats-stacked-15fr2 h4{min-height:auto}", ""]);
	
	// exports
	exports.locals = {
		"default": "TicketStats-default-26o1_",
		"body": "TicketStats-body-1C_a9",
		"enter": "TicketStats-enter-1BLql",
		"enterActive": "TicketStats-enterActive-2jXZQ",
		"leave": "TicketStats-leave-1JBhL",
		"leaveActive": "TicketStats-leaveActive-GAYw6",
		"count": "TicketStats-count-2b3i2",
		"switch": "TicketStats-switch-SVrIB",
		"container": "TicketStats-container-Ub2Vi",
		"export": "TicketStats-export-39Hwu",
		"newTickets": "TicketStats-newTickets-1Sl2z",
		"distribution": "TicketStats-distribution-3HKK3",
		"chart": "TicketStats-chart-2XLE6",
		"creationFrequency": "TicketStats-creationFrequency-1fB9s",
		"stacked": "TicketStats-stacked-15fr2"
	};

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketStream-pagination-1hkMZ{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"pagination": "TicketStream-pagination-1hkMZ"
	};

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketStreamCard-default-3Pgiz ul{margin:0;padding:0;list-style-type:none}.TicketStreamCard-default-3Pgiz ul li{margin:20px 0;overflow:hidden}.TicketStreamCard-default-3Pgiz ul li .TicketStreamCard-container-XPxBk{overflow:hidden}.TicketStreamCard-default-3Pgiz ul li .TicketStreamCard-container-XPxBk a{display:block;font-style:italic;font-size:14px;line-height:24px;color:#546d79}.TicketStreamCard-default-3Pgiz ul li .TicketStreamCard-container-XPxBk strong{display:block;font-weight:400;color:#546d79}.TicketStreamCard-default-3Pgiz ul li .TicketStreamCard-container-XPxBk small{display:block;font-size:14px;line-height:14px}.TicketStreamCard-default-3Pgiz ul li button{display:block;float:right;padding:0}", ""]);
	
	// exports
	exports.locals = {
		"default": "TicketStreamCard-default-3Pgiz",
		"container": "TicketStreamCard-container-XPxBk"
	};

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TicketStreamLayout-welcome-2ApFU{text-align:center}.TicketStreamLayout-welcome-2ApFU p{margin:0}.TicketStreamLayout-welcome-2ApFU b{color:#546d79}", ""]);
	
	// exports
	exports.locals = {
		"welcome": "TicketStreamLayout-welcome-2ApFU"
	};

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "._ṔhotoPreview-photoPreview-28VKI figure{margin:10px;display:inline-block;cursor:pointer}._ṔhotoPreview-photoPreview-28VKI ._ṔhotoPreview-popover-2AArz{position:fixed;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;z-index:10;background:hsla(0,0%,76%,.53);top:0;left:0;right:0;bottom:0}._ṔhotoPreview-photoPreview-28VKI ._ṔhotoPreview-popover-2AArz span{position:absolute;color:#000;font-size:2em;font-weight:700}._ṔhotoPreview-photoPreview-28VKI ._ṔhotoPreview-popover-2AArz img{max-width:90vw;max-height:90vh;cursor:pointer;position:absolute}", ""]);
	
	// exports
	exports.locals = {
		"photoPreview": "_ṔhotoPreview-photoPreview-28VKI",
		"popover": "_ṔhotoPreview-popover-2AArz"
	};

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UnauthUserLayout-default-3iI1n p{margin:70px 0;font-size:20px;font-weight:400;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"default": "UnauthUserLayout-default-3iI1n"
	};

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".UserNavItem-default-1W6F1{overflow:hidden;margin:15px 10px;padding:5px;border-bottom:1px solid #d6dde1}.UserNavItem-container-1_Xl_{overflow:hidden;margin-right:48px;padding-right:20px}.UserNavItem-container-1_Xl_ .UserNavItem-name-2U3he{color:#00e5ce}.UserNavItem-container-1_Xl_ .UserNavItem-job-3zhlm{color:#b0bec5}.UserNavItem-container-1_Xl_ p{max-width:150px;margin:0;font-size:16px;font-weight:400}.UserNavItem-side-KH1Ht{float:right}.UserNavItem-side-KH1Ht .UserNavItem-user-2Diz6{display:block}", ""]);
	
	// exports
	exports.locals = {
		"default": "UserNavItem-default-1W6F1",
		"container": "UserNavItem-container-1_Xl_",
		"name": "UserNavItem-name-2U3he",
		"job": "UserNavItem-job-3zhlm",
		"side": "UserNavItem-side-KH1Ht",
		"user": "UserNavItem-user-2Diz6"
	};

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".NextStepCard-default-3l-ik .NextStepCard-container-1_F5J{overflow:hidden}.NextStepCard-default-3l-ik p{padding:10px;text-transform:uppercase;color:#546d79;text-align:center}.NextStepCard-default-3l-ik .NextStepCard-expectedCommand-Cv3kO{margin:0;overflow:hidden}.NextStepCard-default-3l-ik .NextStepCard-expectedDuration-16uLJ{margin:0;margin-bottom:-50px;padding-bottom:50px;float:right;border-left:1px solid #d6dde1;font-weight:400}.NextStepCard-default-3l-ik .NextStepCard-expectedDuration-16uLJ small{display:block;font-weight:300;font-size:14px;line-height:14px;text-transform:none;color:#ff5766}.NextStepCard-default-3l-ik .NextStepCard-actors-2YUOH{margin:0;border-top:1px solid #d6dde1;font-size:14px;font-style:italic}.NextStepCard-default-3l-ik .NextStepCard-actors-2YUOH>span:before{content:\" : \"}.NextStepCard-default-3l-ik .NextStepCard-actors-2YUOH>span:first-child:before{content:\"\"}.NextStepCard-default-3l-ik .NextStepCard-actors-2YUOH .NextStepCard-highlight-1oinJ{font-weight:400}.NextStepCard-default-3l-ik .NextStepCard-workflow-ODRB6{text-align:center;text-transform:uppercase;text-overflow:ellipsis;font-weight:700}", ""]);
	
	// exports
	exports.locals = {
		"default": "NextStepCard-default-3l-ik",
		"container": "NextStepCard-container-1_F5J",
		"expectedCommand": "NextStepCard-expectedCommand-Cv3kO",
		"expectedDuration": "NextStepCard-expectedDuration-16uLJ",
		"actors": "NextStepCard-actors-2YUOH",
		"highlight": "NextStepCard-highlight-1oinJ",
		"workflow": "NextStepCard-workflow-ODRB6"
	};

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".RemoveWorkflowModal-text-t6MmZ{margin:30px 0;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"text": "RemoveWorkflowModal-text-t6MmZ"
	};

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TodoSearch-default-1H1BL{margin-top:-30px}.TodoSearch-default-1H1BL h4,.TodoSearch-default-1H1BL h5{text-transform:uppercase}.TodoSearch-default-1H1BL h4{margin:30px 0;text-align:center}.TodoSearch-expectedDateStatus-Oezk3{text-align:center;color:#546d79}.TodoSearch-expectedDateStatus-Oezk3 small{margin-top:-30px;display:block;font-size:16px}.TodoSearch-expectedDateStatus-Oezk3 .ct-slice-donut,.TodoSearch-expectedDateStatus-Oezk3 button{opacity:.5}", ""]);
	
	// exports
	exports.locals = {
		"default": "TodoSearch-default-1H1BL",
		"expectedDateStatus": "TodoSearch-expectedDateStatus-Oezk3"
	};

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TodoStream-noTodo-1__Jg{text-align:center}.TodoStream-noTodo-1__Jg a{font-weight:400}.TodoStream-pagination-222GO{text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"noTodo": "TodoStream-noTodo-1__Jg",
		"pagination": "TodoStream-pagination-222GO"
	};

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".TodoStrip-header-21BIs,.TodoStrip-header-21BIs .TodoStrip-container-1AhiX{overflow:hidden}.TodoStrip-header-21BIs .TodoStrip-side-giLYB{float:right}.TodoStrip-body-CV83y .TodoStrip-expectedDuration-1N2p4{font-weight:400}.TodoStrip-body-CV83y .TodoStrip-expectedDuration-1N2p4 small{font-weight:300;font-size:14px;line-height:14px;color:#ff5766}@media (min-width:768px){.TodoStrip-body-CV83y p{width:40%}.TodoStrip-body-CV83y .TodoStrip-expectedDuration-1N2p4{width:20%}}", ""]);
	
	// exports
	exports.locals = {
		"header": "TodoStrip-header-21BIs",
		"container": "TodoStrip-container-1AhiX",
		"side": "TodoStrip-side-giLYB",
		"body": "TodoStrip-body-CV83y",
		"expectedDuration": "TodoStrip-expectedDuration-1N2p4"
	};

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".WorkflowPanel-workflowLabel-1xX3r{text-align:center}.WorkflowPanel-workflowLabel-1xX3r h4{text-transform:uppercase;font-weight:400}.WorkflowPanel-workflowLabel-1xX3r h5{margin:40px 0 10px;text-transform:uppercase;font-size:20px;font-style:italic;color:#b0bec5}.WorkflowPanel-workflowAction-2f3iN{text-align:right}.WorkflowPanel-workflowAction-2f3iN button{padding:5px}.WorkflowPanel-stepGroup-3YluH h5{margin-bottom:0;text-transform:uppercase;font-size:20px;font-style:italic;color:#b0bec5}.WorkflowPanel-stepGroup-3YluH ul{margin:0;padding:0;list-style-type:none}.WorkflowPanel-stepGroup-3YluH ul>li{overflow:hidden}.WorkflowPanel-stepGroup-3YluH ul>li:last-child .WorkflowPanel-step-2WO7p{margin-bottom:0;padding-bottom:0}.WorkflowPanel-stepGroup-3YluH ul>li .WorkflowPanel-step-2WO7p{float:left;width:6px;margin:0 20px -500px 5px;padding:30px 0 500px;border-right:3px dotted #d6dde1}.WorkflowPanel-stepGroup-3YluH ul>li .WorkflowPanel-step-2WO7p strong{display:block;height:10px;width:10px;border:2px solid #fff;border-radius:5px;background:#00e5ce}.WorkflowPanel-stepGroup-3YluH ul>li .WorkflowPanel-action-2Y-gQ{float:right;margin:20px 0 0 10px}.WorkflowPanel-stepGroup-3YluH ul>li .WorkflowPanel-action-2Y-gQ button{padding:5px}.WorkflowPanel-stepGroup-3YluH ul>li .WorkflowPanel-container-3zdD8{overflow:hidden;margin:20px 0 0;border-radius:5px;background:#fbfbfb}.WorkflowPanel-stepGroup-3YluH ul>li .WorkflowPanel-container-3zdD8 p{display:block;margin:5px 0;padding:0 20px;text-transform:uppercase}@media (min-width:768px){.WorkflowPanel-stepGroup-3YluH ul>li .WorkflowPanel-container-3zdD8 p{display:inline-block;width:33%;border-left:1px solid #dadada}.WorkflowPanel-stepGroup-3YluH ul>li .WorkflowPanel-container-3zdD8 p:first-child{border-left:0}}.WorkflowPanel-newStep-Vtple{margin:0 82px 0 31px}.WorkflowPanel-identifiedRequests-1pomx{border-top:1px solid #dadada}.WorkflowPanel-identifiedRequests-1pomx .WorkflowPanel-action-2Y-gQ{margin:20px 0 0;text-align:right}.WorkflowPanel-identifiedRequests-1pomx .WorkflowPanel-action-2Y-gQ button{padding:5px}.WorkflowPanel-identifiedRequests-1pomx ul{margin:0;padding:0;list-style-type:none}", ""]);
	
	// exports
	exports.locals = {
		"workflowLabel": "WorkflowPanel-workflowLabel-1xX3r",
		"workflowAction": "WorkflowPanel-workflowAction-2f3iN",
		"stepGroup": "WorkflowPanel-stepGroup-3YluH",
		"step": "WorkflowPanel-step-2WO7p",
		"action": "WorkflowPanel-action-2Y-gQ",
		"container": "WorkflowPanel-container-3zdD8",
		"newStep": "WorkflowPanel-newStep-Vtple",
		"identifiedRequests": "WorkflowPanel-identifiedRequests-1pomx"
	};

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ct-double-octave:after,.ct-major-eleventh:after,.ct-major-second:after,.ct-major-seventh:after,.ct-major-sixth:after,.ct-major-tenth:after,.ct-major-third:after,.ct-major-twelfth:after,.ct-minor-second:after,.ct-minor-seventh:after,.ct-minor-sixth:after,.ct-minor-third:after,.ct-octave:after,.ct-perfect-fifth:after,.ct-perfect-fourth:after,.ct-square:after{content:\"\";clear:both}.ct-label{fill:rgba(0,0,0,.4);color:rgba(0,0,0,.4);font-size:.75rem;line-height:1}.ct-chart-bar .ct-label,.ct-chart-line .ct-label{display:block;display:-ms-flexbox;display:flex}.ct-label.ct-horizontal.ct-start{-ms-flex-align:flex-end;align-items:flex-end}.ct-label.ct-horizontal.ct-end,.ct-label.ct-horizontal.ct-start{-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left;text-anchor:start}.ct-label.ct-horizontal.ct-end{-ms-flex-align:flex-start;align-items:flex-start}.ct-label.ct-vertical.ct-start{-ms-flex-align:flex-end;align-items:flex-end;-ms-flex-pack:flex-end;justify-content:flex-end;text-align:right;text-anchor:end}.ct-label.ct-vertical.ct-end{-ms-flex-align:flex-end;align-items:flex-end;-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left;text-anchor:start}.ct-chart-bar .ct-label.ct-horizontal.ct-start{-ms-flex-align:flex-end;align-items:flex-end;-ms-flex-pack:center;justify-content:center;text-align:center;text-anchor:start}.ct-chart-bar .ct-label.ct-horizontal.ct-end{-ms-flex-align:flex-start;align-items:flex-start;-ms-flex-pack:center;justify-content:center;text-align:center;text-anchor:start}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start{-ms-flex-align:flex-end;align-items:flex-end;-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left;text-anchor:start}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end{-ms-flex-align:flex-start;align-items:flex-start;-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left;text-anchor:start}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start{-ms-flex-align:center;align-items:center;-ms-flex-pack:flex-end;justify-content:flex-end;text-align:right;text-anchor:end}.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end{-ms-flex-align:center;align-items:center;-ms-flex-pack:flex-start;justify-content:flex-start;text-align:left;text-anchor:end}.ct-grid{stroke:rgba(0,0,0,.2);stroke-width:1px;stroke-dasharray:2px}.ct-point{stroke-width:10px;stroke-linecap:round}.ct-line{fill:none;stroke-width:4px}.ct-area{stroke:none;fill-opacity:.1}.ct-bar{fill:none;stroke-width:10px}.ct-slice-donut{fill:none;stroke-width:60px}.ct-series-a .ct-bar,.ct-series-a .ct-line,.ct-series-a .ct-point,.ct-series-a .ct-slice-donut{stroke:#d70206}.ct-series-a .ct-area,.ct-series-a .ct-slice-pie{fill:#d70206}.ct-series-b .ct-bar,.ct-series-b .ct-line,.ct-series-b .ct-point,.ct-series-b .ct-slice-donut{stroke:#f05b4f}.ct-series-b .ct-area,.ct-series-b .ct-slice-pie{fill:#f05b4f}.ct-series-c .ct-bar,.ct-series-c .ct-line,.ct-series-c .ct-point,.ct-series-c .ct-slice-donut{stroke:#f4c63d}.ct-series-c .ct-area,.ct-series-c .ct-slice-pie{fill:#f4c63d}.ct-series-d .ct-bar,.ct-series-d .ct-line,.ct-series-d .ct-point,.ct-series-d .ct-slice-donut{stroke:#d17905}.ct-series-d .ct-area,.ct-series-d .ct-slice-pie{fill:#d17905}.ct-series-e .ct-bar,.ct-series-e .ct-line,.ct-series-e .ct-point,.ct-series-e .ct-slice-donut{stroke:#453d3f}.ct-series-e .ct-area,.ct-series-e .ct-slice-pie{fill:#453d3f}.ct-series-f .ct-bar,.ct-series-f .ct-line,.ct-series-f .ct-point,.ct-series-f .ct-slice-donut{stroke:#59922b}.ct-series-f .ct-area,.ct-series-f .ct-slice-pie{fill:#59922b}.ct-series-g .ct-bar,.ct-series-g .ct-line,.ct-series-g .ct-point,.ct-series-g .ct-slice-donut{stroke:#0544d3}.ct-series-g .ct-area,.ct-series-g .ct-slice-pie{fill:#0544d3}.ct-series-h .ct-bar,.ct-series-h .ct-line,.ct-series-h .ct-point,.ct-series-h .ct-slice-donut{stroke:#6b0392}.ct-series-h .ct-area,.ct-series-h .ct-slice-pie{fill:#6b0392}.ct-series-i .ct-bar,.ct-series-i .ct-line,.ct-series-i .ct-point,.ct-series-i .ct-slice-donut{stroke:#f05b4f}.ct-series-i .ct-area,.ct-series-i .ct-slice-pie{fill:#f05b4f}.ct-series-j .ct-bar,.ct-series-j .ct-line,.ct-series-j .ct-point,.ct-series-j .ct-slice-donut{stroke:#dda458}.ct-series-j .ct-area,.ct-series-j .ct-slice-pie{fill:#dda458}.ct-series-k .ct-bar,.ct-series-k .ct-line,.ct-series-k .ct-point,.ct-series-k .ct-slice-donut{stroke:#eacf7d}.ct-series-k .ct-area,.ct-series-k .ct-slice-pie{fill:#eacf7d}.ct-series-l .ct-bar,.ct-series-l .ct-line,.ct-series-l .ct-point,.ct-series-l .ct-slice-donut{stroke:#86797d}.ct-series-l .ct-area,.ct-series-l .ct-slice-pie{fill:#86797d}.ct-series-m .ct-bar,.ct-series-m .ct-line,.ct-series-m .ct-point,.ct-series-m .ct-slice-donut{stroke:#b2c326}.ct-series-m .ct-area,.ct-series-m .ct-slice-pie{fill:#b2c326}.ct-series-n .ct-bar,.ct-series-n .ct-line,.ct-series-n .ct-point,.ct-series-n .ct-slice-donut{stroke:#6188e2}.ct-series-n .ct-area,.ct-series-n .ct-slice-pie{fill:#6188e2}.ct-series-o .ct-bar,.ct-series-o .ct-line,.ct-series-o .ct-point,.ct-series-o .ct-slice-donut{stroke:#a748ca}.ct-series-o .ct-area,.ct-series-o .ct-slice-pie{fill:#a748ca}.ct-square{display:block;position:relative;width:100%}.ct-square:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:100%}.ct-square:after{display:table}.ct-square>svg{display:block;position:absolute;top:0;left:0}.ct-minor-second{display:block;position:relative;width:100%}.ct-minor-second:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:93.75%}.ct-minor-second:after{display:table}.ct-minor-second>svg{display:block;position:absolute;top:0;left:0}.ct-major-second{display:block;position:relative;width:100%}.ct-major-second:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:88.8888888889%}.ct-major-second:after{display:table}.ct-major-second>svg{display:block;position:absolute;top:0;left:0}.ct-minor-third{display:block;position:relative;width:100%}.ct-minor-third:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:83.3333333333%}.ct-minor-third:after{display:table}.ct-minor-third>svg{display:block;position:absolute;top:0;left:0}.ct-major-third{display:block;position:relative;width:100%}.ct-major-third:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:80%}.ct-major-third:after{display:table}.ct-major-third>svg{display:block;position:absolute;top:0;left:0}.ct-perfect-fourth{display:block;position:relative;width:100%}.ct-perfect-fourth:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:75%}.ct-perfect-fourth:after{display:table}.ct-perfect-fourth>svg{display:block;position:absolute;top:0;left:0}.ct-perfect-fifth{display:block;position:relative;width:100%}.ct-perfect-fifth:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:66.6666666667%}.ct-perfect-fifth:after{display:table}.ct-perfect-fifth>svg{display:block;position:absolute;top:0;left:0}.ct-minor-sixth{display:block;position:relative;width:100%}.ct-minor-sixth:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:62.5%}.ct-minor-sixth:after{display:table}.ct-minor-sixth>svg{display:block;position:absolute;top:0;left:0}.ct-golden-section{display:block;position:relative;width:100%}.ct-golden-section:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:61.804697157%}.ct-golden-section:after{content:\"\";display:table;clear:both}.ct-golden-section>svg{display:block;position:absolute;top:0;left:0}.ct-major-sixth{display:block;position:relative;width:100%}.ct-major-sixth:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:60%}.ct-major-sixth:after{display:table}.ct-major-sixth>svg{display:block;position:absolute;top:0;left:0}.ct-minor-seventh{display:block;position:relative;width:100%}.ct-minor-seventh:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:56.25%}.ct-minor-seventh:after{display:table}.ct-minor-seventh>svg{display:block;position:absolute;top:0;left:0}.ct-major-seventh{display:block;position:relative;width:100%}.ct-major-seventh:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:53.3333333333%}.ct-major-seventh:after{display:table}.ct-major-seventh>svg{display:block;position:absolute;top:0;left:0}.ct-octave{display:block;position:relative;width:100%}.ct-octave:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:50%}.ct-octave:after{display:table}.ct-octave>svg{display:block;position:absolute;top:0;left:0}.ct-major-tenth{display:block;position:relative;width:100%}.ct-major-tenth:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:40%}.ct-major-tenth:after{display:table}.ct-major-tenth>svg{display:block;position:absolute;top:0;left:0}.ct-major-eleventh{display:block;position:relative;width:100%}.ct-major-eleventh:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:37.5%}.ct-major-eleventh:after{display:table}.ct-major-eleventh>svg{display:block;position:absolute;top:0;left:0}.ct-major-twelfth{display:block;position:relative;width:100%}.ct-major-twelfth:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:33.3333333333%}.ct-major-twelfth:after{display:table}.ct-major-twelfth>svg{display:block;position:absolute;top:0;left:0}.ct-double-octave{display:block;position:relative;width:100%}.ct-double-octave:before{display:block;float:left;content:\"\";width:0;height:0;padding-bottom:25%}.ct-double-octave:after{display:table}.ct-double-octave>svg{display:block;position:absolute;top:0;left:0}", ""]);
	
	// exports


/***/ }),
/* 1792 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1794);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1792);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1795 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(1137);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(1010);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var contains = __webpack_require__(1011),
	    qsa = __webpack_require__(1800);
	
	module.exports = function (selector, handler) {
	  return function (e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = qsa(top, selector);
	
	    if (matches.some(function (match) {
	      return contains(match, target);
	    })) handler.call(this, e);
	  };
	};

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var on = __webpack_require__(1009),
	    off = __webpack_require__(1008),
	    filter = __webpack_require__(1798);
	
	module.exports = { on: on, off: off, filter: filter };

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

	'use strict';
	//     Zepto.js
	//     (c) 2010-2015 Thomas Fuchs
	//     Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/,
	    toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	module.exports = function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	};

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(1136);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	};

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(1136);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(1137);
	
	var _utilCamelizeStyle = __webpack_require__(1138);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(1138),
	    hyphenate = __webpack_require__(1808),
	    _getComputedStyle = __webpack_require__(1803),
	    removeStyle = __webpack_require__(1805);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(1807);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(534);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(534);
	
	var size;
	
	module.exports = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$AdditionalInfosForm$FetchAdditionalInfos = {$: 'FetchAdditionalInfos'};
	var author$project$AdditionalInfosForm$Model = F3(
		function (inputs, flags, editableState) {
			return {editableState: editableState, flags: flags, inputs: inputs};
		});
	var author$project$AdditionalInfosForm$Unmodified = {$: 'Unmodified'};
	var author$project$AdditionalInfosForm$InputLine = F3(
		function (key, value, type_) {
			return {key: key, type_: type_, value: value};
		});
	var author$project$AdditionalInfosForm$InputText = {$: 'InputText'};
	var author$project$AdditionalInfosForm$Provided = {$: 'Provided'};
	var author$project$AdditionalInfosForm$TextArea = function (a) {
		return {$: 'TextArea', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var author$project$AdditionalInfosForm$initStaticInput = _List_fromArray(
		[
			A3(author$project$AdditionalInfosForm$InputLine, 'Identifiant externe', elm$core$Maybe$Nothing, author$project$AdditionalInfosForm$InputText),
			A3(author$project$AdditionalInfosForm$InputLine, 'Secteur', elm$core$Maybe$Nothing, author$project$AdditionalInfosForm$InputText),
			A3(
			author$project$AdditionalInfosForm$InputLine,
			'Informations d\'accès',
			elm$core$Maybe$Nothing,
			author$project$AdditionalInfosForm$TextArea(author$project$AdditionalInfosForm$Provided)),
			A3(
			author$project$AdditionalInfosForm$InputLine,
			'Consignes',
			elm$core$Maybe$Nothing,
			author$project$AdditionalInfosForm$TextArea(author$project$AdditionalInfosForm$Provided)),
			A3(author$project$AdditionalInfosForm$InputLine, 'Boite à clef', elm$core$Maybe$Nothing, author$project$AdditionalInfosForm$InputText),
			A3(
			author$project$AdditionalInfosForm$InputLine,
			'Instructions',
			elm$core$Maybe$Nothing,
			author$project$AdditionalInfosForm$TextArea(author$project$AdditionalInfosForm$Provided)),
			A3(author$project$AdditionalInfosForm$InputLine, 'Code chantier', elm$core$Maybe$Nothing, author$project$AdditionalInfosForm$InputText),
			A3(author$project$AdditionalInfosForm$InputLine, 'Code chauffage', elm$core$Maybe$Nothing, author$project$AdditionalInfosForm$InputText),
			A3(
			author$project$AdditionalInfosForm$InputLine,
			'Ouverture du site',
			elm$core$Maybe$Nothing,
			author$project$AdditionalInfosForm$TextArea(author$project$AdditionalInfosForm$Provided)),
			A3(
			author$project$AdditionalInfosForm$InputLine,
			'fermeture du site',
			elm$core$Maybe$Nothing,
			author$project$AdditionalInfosForm$TextArea(author$project$AdditionalInfosForm$Provided)),
			A3(author$project$AdditionalInfosForm$InputLine, 'Informations sur les équipements', elm$core$Maybe$Nothing, author$project$AdditionalInfosForm$InputText),
			A3(author$project$AdditionalInfosForm$InputLine, 'Contrat du site (client - Site)', elm$core$Maybe$Nothing, author$project$AdditionalInfosForm$InputText)
		]);
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var author$project$AdditionalInfosForm$init = function (f) {
		return _Utils_Tuple2(
			A3(author$project$AdditionalInfosForm$Model, author$project$AdditionalInfosForm$initStaticInput, f, author$project$AdditionalInfosForm$Unmodified),
			author$project$Utils$Command$msgToElmCmd(author$project$AdditionalInfosForm$FetchAdditionalInfos));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$AdditionalInfosForm$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var author$project$AdditionalInfosForm$AdditionalInfosFetched = function (a) {
		return {$: 'AdditionalInfosFetched', a: a};
	};
	var author$project$AdditionalInfosForm$Custom = {$: 'Custom'};
	var author$project$AdditionalInfosForm$FormSaved = function (a) {
		return {$: 'FormSaved', a: a};
	};
	var author$project$AdditionalInfosForm$Modified = {$: 'Modified'};
	var author$project$AdditionalInfosForm$Sent = {$: 'Sent'};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$AdditionalInfosForm$AdditionalInfos = F2(
		function (uid, infos) {
			return {infos: infos, uid: uid};
		});
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$fromList = function (assocs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, dict) {
					var key = _n0.a;
					var value = _n0.b;
					return A3(elm$core$Dict$insert, key, value, dict);
				}),
			elm$core$Dict$empty,
			assocs);
	};
	var elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$dict = function (decoder) {
		return A2(
			elm$json$Json$Decode$map,
			elm$core$Dict$fromList,
			elm$json$Json$Decode$keyValuePairs(decoder));
	};
	var elm$json$Json$Decode$string = _Json_decodeString;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$AdditionalInfosForm$additionalInfosDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'infos',
		elm$json$Json$Decode$dict(elm$json$Json$Decode$string),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$AdditionalInfosForm$AdditionalInfos)));
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var elm$core$Dict$foldl = F3(
		function (func, acc, dict) {
			foldl:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldl, func, acc, left)),
						$temp$dict = right;
					func = $temp$func;
					acc = $temp$acc;
					dict = $temp$dict;
					continue foldl;
				}
			}
		});
	var elm$json$Json$Encode$dict = F3(
		function (toKey, toValue, dictionary) {
			return _Json_wrap(
				A3(
					elm$core$Dict$foldl,
					F3(
						function (key, value, obj) {
							return A3(
								_Json_addField,
								toKey(key),
								toValue(value),
								obj);
						}),
					_Json_emptyObject(_Utils_Tuple0),
					dictionary));
		});
	var elm$json$Json$Encode$string = _Json_wrap;
	var author$project$AdditionalInfosForm$toKV = function (inputs) {
		var tuples = A2(
			elm$core$List$map,
			function (x) {
				return _Utils_Tuple2(x.key, x.value);
			},
			inputs);
		var tuplesClean = A2(
			elm$core$List$filterMap,
			function (_n0) {
				var k = _n0.a;
				var v = _n0.b;
				return A2(
					elm$core$Maybe$map,
					function (vv) {
						return _Utils_Tuple2(k, vv);
					},
					v);
			},
			tuples);
		return A3(
			elm$json$Json$Encode$dict,
			elm$core$Basics$identity,
			elm$json$Json$Encode$string,
			elm$core$Dict$fromList(tuplesClean));
	};
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$jsonBody = function (value) {
		return A2(
			_Http_pair,
			'application/json',
			A2(elm$json$Json$Encode$encode, 0, value));
	};
	var elm$json$Json$Encode$object = function (pairs) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, obj) {
						var k = _n0.a;
						var v = _n0.b;
						return A3(_Json_addField, k, v, obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				pairs));
	};
	var author$project$AdditionalInfosForm$toBody = function (model) {
		return elm$http$Http$jsonBody(
			elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'infos',
						author$project$AdditionalInfosForm$toKV(model.inputs)),
						_Utils_Tuple2(
						'linkToEntity',
						elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'type',
									elm$json$Json$Encode$string('Patrimony')),
									_Utils_Tuple2(
									'uid',
									elm$json$Json$Encode$string(model.flags.patrimonyUid))
								])))
					])));
	};
	var author$project$AdditionalInfosForm$rankList = function (inputs) {
		var rank = F2(
			function (elem, acc) {
				return _Utils_ap(
					acc,
					_List_fromArray(
						[
							_Utils_Tuple2(
							elm$core$List$length(acc),
							elem)
						]));
			});
		return A3(elm$core$List$foldl, rank, _List_Nil, inputs);
	};
	var elm$core$String$trim = _String_trim;
	var author$project$AdditionalInfosForm$stringToOption = function (s) {
		var _n0 = elm$core$String$trim(s);
		if (_n0 === '') {
			return elm$core$Maybe$Nothing;
		} else {
			return elm$core$Maybe$Just(s);
		}
	};
	var elm$core$Basics$always = F2(
		function (a, _n0) {
			return a;
		});
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$partition = F2(
		function (pred, list) {
			var step = F2(
				function (x, _n0) {
					var trues = _n0.a;
					var falses = _n0.b;
					return pred(x) ? _Utils_Tuple2(
						A2(elm$core$List$cons, x, trues),
						falses) : _Utils_Tuple2(
						trues,
						A2(elm$core$List$cons, x, falses));
				});
			return A3(
				elm$core$List$foldr,
				step,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				list);
		});
	var elm$core$List$sortBy = _List_sortBy;
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var elm$core$Tuple$second = function (_n0) {
		var y = _n0.b;
		return y;
	};
	var author$project$AdditionalInfosForm$upsertInput = F2(
		function (_n0, inputs) {
			var k = _n0.a;
			var v = _n0.b;
			var _n1 = A2(
				elm$core$List$partition,
				function (_n2) {
					var x = _n2.b;
					return _Utils_eq(x.key, k);
				},
				author$project$AdditionalInfosForm$rankList(inputs));
			var l1 = _n1.a;
			var l2 = _n1.b;
			var updated = A2(
				elm$core$List$map,
				function (_n3) {
					var i = _n3.a;
					var x = _n3.b;
					return _Utils_Tuple2(
						i,
						_Utils_update(
							x,
							{
								value: author$project$AdditionalInfosForm$stringToOption(v)
							}));
				},
				l1);
			var newValue = A2(
				elm$core$Maybe$withDefault,
				_List_fromArray(
					[
						_Utils_Tuple2(
						elm$core$List$length(l2),
						A3(
							author$project$AdditionalInfosForm$InputLine,
							k,
							author$project$AdditionalInfosForm$stringToOption(v),
							author$project$AdditionalInfosForm$TextArea(author$project$AdditionalInfosForm$Custom)))
					]),
				A2(
					elm$core$Maybe$map,
					elm$core$Basics$always(updated),
					elm$core$List$head(updated)));
			var sorted = A2(
				elm$core$List$sortBy,
				elm$core$Tuple$first,
				_Utils_ap(newValue, l2));
			return A2(elm$core$List$map, elm$core$Tuple$second, sorted);
		});
	var elm$core$List$drop = F2(
		function (n, list) {
			drop:
			while (true) {
				if (n <= 0) {
					return list;
				} else {
					if (!list.b) {
						return list;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs;
						n = $temp$n;
						list = $temp$list;
						continue drop;
					}
				}
			}
		});
	var elm_community$list_extra$List$Extra$getAt = F2(
		function (idx, xs) {
			return (idx < 0) ? elm$core$Maybe$Nothing : elm$core$List$head(
				A2(elm$core$List$drop, idx, xs));
		});
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var elm_community$list_extra$List$Extra$updateAt = F3(
		function (index, fn, list) {
			if (index < 0) {
				return list;
			} else {
				var tail = A2(elm$core$List$drop, index, list);
				var head = A2(elm$core$List$take, index, list);
				if (tail.b) {
					var x = tail.a;
					var xs = tail.b;
					return _Utils_ap(
						head,
						A2(
							elm$core$List$cons,
							fn(x),
							xs));
				} else {
					return list;
				}
			}
		});
	var elm_community$list_extra$List$Extra$setAt = F2(
		function (index, value) {
			return A2(
				elm_community$list_extra$List$Extra$updateAt,
				index,
				elm$core$Basics$always(value));
		});
	var author$project$AdditionalInfosForm$upsertInputKey = F2(
		function (_n0, inputs) {
			var n = _n0.a;
			var k = _n0.b;
			var lineToUpdate = A2(elm_community$list_extra$List$Extra$getAt, n, inputs);
			var updated = A2(
				elm$core$Maybe$map,
				function (x) {
					return _Utils_update(
						x,
						{key: k});
				},
				lineToUpdate);
			return A2(
				elm$core$Maybe$withDefault,
				inputs,
				A2(
					elm$core$Maybe$map,
					function (x) {
						return A3(elm_community$list_extra$List$Extra$setAt, n, x, inputs);
					},
					updated));
		});
	var author$project$AdditionalInfosForm$upsertInputValue = F2(
		function (_n0, inputs) {
			var n = _n0.a;
			var v = _n0.b;
			var lineToUpdate = A2(elm_community$list_extra$List$Extra$getAt, n, inputs);
			var updated = A2(
				elm$core$Maybe$map,
				function (x) {
					return _Utils_update(
						x,
						{
							value: author$project$AdditionalInfosForm$stringToOption(v)
						});
				},
				lineToUpdate);
			return A2(
				elm$core$Maybe$withDefault,
				inputs,
				A2(
					elm$core$Maybe$map,
					function (x) {
						return A3(elm_community$list_extra$List$Extra$setAt, n, x, inputs);
					},
					updated));
		});
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Post = F3(
		function (a, b, c) {
			return {$: 'Post', a: a, b: b, c: c};
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm$http$Http$expectBytesResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'arraybuffer',
				_Http_toDataView,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$expectWhatever = function (toMsg) {
		return A2(
			elm$http$Http$expectBytesResponse,
			toMsg,
			elm$http$Http$resolve(
				function (_n0) {
					return elm$core$Result$Ok(_Utils_Tuple0);
				}));
	};
	var author$project$AdditionalInfosForm$update = F2(
		function (action, model) {
			switch (action.$) {
				case 'FetchAdditionalInfos':
					var url = model.flags.apiUrl + ('/additionalinfos/' + model.flags.patrimonyUid);
					var cmd = author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							url,
							A2(elm$http$Http$expectJson, author$project$AdditionalInfosForm$AdditionalInfosFetched, author$project$AdditionalInfosForm$additionalInfosDecoder)));
					return _Utils_Tuple2(model, cmd);
				case 'AdditionalInfosFetched':
					var result = action.a;
					var infos = elm$core$Dict$toList(
						A2(
							elm$core$Result$withDefault,
							elm$core$Dict$empty,
							A2(
								elm$core$Result$map,
								function ($) {
									return $.infos;
								},
								result)));
					var inputs = A3(elm$core$List$foldl, author$project$AdditionalInfosForm$upsertInput, model.inputs, infos);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{editableState: author$project$AdditionalInfosForm$Unmodified, inputs: inputs}),
						elm$core$Platform$Cmd$none);
				case 'SaveForm':
					var url = model.flags.apiUrl + '/additionalinfos';
					var body = author$project$AdditionalInfosForm$toBody(model);
					var cmd = author$project$Utils$Http$HttpRequest$withAuthReq(
						A3(
							author$project$Utils$Http$HttpRequest$Post,
							url,
							body,
							elm$http$Http$expectWhatever(author$project$AdditionalInfosForm$FormSaved)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{editableState: author$project$AdditionalInfosForm$Sent}),
						cmd);
				case 'FormSaved':
					return _Utils_Tuple2(
						model,
						author$project$Utils$Command$msgToElmCmd(author$project$AdditionalInfosForm$FetchAdditionalInfos));
				case 'UpdateInputValue':
					var rank = action.a;
					var value = action.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								editableState: author$project$AdditionalInfosForm$Modified,
								inputs: A2(
									author$project$AdditionalInfosForm$upsertInputValue,
									_Utils_Tuple2(rank, value),
									model.inputs)
							}),
						elm$core$Platform$Cmd$none);
				case 'UpdateInputKey':
					var rank = action.a;
					var key = action.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								editableState: author$project$AdditionalInfosForm$Modified,
								inputs: A2(
									author$project$AdditionalInfosForm$upsertInputKey,
									_Utils_Tuple2(rank, key),
									model.inputs)
							}),
						elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								inputs: _Utils_ap(
									model.inputs,
									_List_fromArray(
										[
											A3(
											author$project$AdditionalInfosForm$InputLine,
											'',
											elm$core$Maybe$Nothing,
											author$project$AdditionalInfosForm$TextArea(author$project$AdditionalInfosForm$Custom))
										]))
							}),
						elm$core$Platform$Cmd$none);
			}
		});
	var author$project$AdditionalInfosForm$SaveForm = {$: 'SaveForm'};
	var author$project$AdditionalInfosForm$AddLine = {$: 'AddLine'};
	var author$project$AdditionalInfosForm$UpdateInputKey = F2(
		function (a, b) {
			return {$: 'UpdateInputKey', a: a, b: b};
		});
	var author$project$AdditionalInfosForm$UpdateInputValue = F2(
		function (a, b) {
			return {$: 'UpdateInputValue', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$row = {flexDirection: rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'row'};
	var rtfeldman$elm_css$Css$column = _Utils_update(
		rtfeldman$elm_css$Css$row,
		{value: 'column'});
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$flexDirection = rtfeldman$elm_css$Css$prop1('flex-direction');
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$none = {backgroundImage: rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, cursor: rtfeldman$elm_css$Css$Structure$Compatible, display: rtfeldman$elm_css$Css$Structure$Compatible, hoverCapability: rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, keyframes: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: rtfeldman$elm_css$Css$Structure$Compatible, none: rtfeldman$elm_css$Css$Structure$Compatible, outline: rtfeldman$elm_css$Css$Structure$Compatible, pointerDevice: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, resize: rtfeldman$elm_css$Css$Structure$Compatible, scriptingSupport: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: rtfeldman$elm_css$Css$Structure$Compatible, textTransform: rtfeldman$elm_css$Css$Structure$Compatible, touchAction: rtfeldman$elm_css$Css$Structure$Compatible, transform: rtfeldman$elm_css$Css$Structure$Compatible, updateFrequency: rtfeldman$elm_css$Css$Structure$Compatible, value: 'none'};
	var rtfeldman$elm_css$Css$resize = rtfeldman$elm_css$Css$prop1('resize');
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var rtfeldman$elm_css$Html$Styled$input = rtfeldman$elm_css$Html$Styled$node('input');
	var rtfeldman$elm_css$Html$Styled$label = rtfeldman$elm_css$Html$Styled$node('label');
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$String$fromList = _String_fromList;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var elm$virtual_dom$VirtualDom$attribute = F2(
		function (key, value) {
			return A2(
				_VirtualDom_attribute,
				_VirtualDom_noOnOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$attribute, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$rows = function (n) {
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$attribute,
			'rows',
			elm$core$String$fromInt(n));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$value = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
	var rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
		return _Utils_Tuple2(x, true);
	};
	var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
		return {$: 'MayStopPropagation', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
		});
	var elm$json$Json$Decode$at = F2(
		function (fields, decoder) {
			return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
		});
	var rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'value']),
		elm$json$Json$Decode$string);
	var rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
			'input',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
				A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue)));
	};
	var author$project$AdditionalInfosForm$displayTheInput = F3(
		function (_n0, elem, state) {
			var n = _n0.a;
			var line = _n0.b;
			var myValue = A2(elm$core$Maybe$withDefault, '', line.value);
			var labelPart = function () {
				if (state.$ === 'Provided') {
					return A2(
						rtfeldman$elm_css$Html$Styled$label,
						_List_Nil,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(line.key)
							]));
				} else {
					return A2(
						rtfeldman$elm_css$Html$Styled$input,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onInput(
								author$project$AdditionalInfosForm$UpdateInputKey(n)),
								rtfeldman$elm_css$Html$Styled$Attributes$value(line.key),
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$marginBottom(
										rtfeldman$elm_css$Css$em(0.3))
									]))
							]),
						_List_Nil);
				}
			}();
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$displayFlex,
								rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$column),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$em(1.5))
							]))
					]),
				_List_fromArray(
					[
						labelPart,
						A2(
						elem,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onInput(
								author$project$AdditionalInfosForm$UpdateInputValue(n)),
								rtfeldman$elm_css$Html$Styled$Attributes$value(myValue),
								rtfeldman$elm_css$Html$Styled$Attributes$rows(
								elm$core$List$length(
									A2(elm$core$String$split, '\n', myValue))),
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$resize(rtfeldman$elm_css$Css$none)
									]))
							]),
						_List_Nil)
					]));
		});
	var rtfeldman$elm_css$Html$Styled$textarea = rtfeldman$elm_css$Html$Styled$node('textarea');
	var author$project$AdditionalInfosForm$displayInput = function (_n0) {
		var n = _n0.a;
		var i = _n0.b;
		var _n1 = i.type_;
		if (_n1.$ === 'InputText') {
			return A3(
				author$project$AdditionalInfosForm$displayTheInput,
				_Utils_Tuple2(n, i),
				rtfeldman$elm_css$Html$Styled$input,
				author$project$AdditionalInfosForm$Provided);
		} else {
			var s = _n1.a;
			return A3(
				author$project$AdditionalInfosForm$displayTheInput,
				_Utils_Tuple2(n, i),
				rtfeldman$elm_css$Html$Styled$textarea,
				s);
		}
	};
	var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
	var rtfeldman$elm_css$Html$Styled$Attributes$class = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
	var rtfeldman$elm_css$Html$Styled$Attributes$type_ = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$AdditionalInfosForm$displayInputs = function (inputs) {
		return _Utils_ap(
			A2(elm$core$List$map, author$project$AdditionalInfosForm$displayInput, inputs),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$AdditionalInfosForm$AddLine),
							rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-lg btn-default')
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('Ajouter une ligne')
						]))
				]));
	};
	var elm$json$Json$Encode$bool = _Json_wrap;
	var rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
		function (key, bool) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$bool(bool));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$disabled = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
	var author$project$AdditionalInfosForm$shouldEnabledSend = function (formState) {
		switch (formState.$) {
			case 'Unmodified':
				return rtfeldman$elm_css$Html$Styled$Attributes$disabled(true);
			case 'Modified':
				return rtfeldman$elm_css$Html$Styled$Attributes$disabled(false);
			default:
				return rtfeldman$elm_css$Html$Styled$Attributes$disabled(true);
		}
	};
	var rtfeldman$elm_css$Css$margin = rtfeldman$elm_css$Css$prop1('margin');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var rtfeldman$elm_css$Html$Styled$fieldset = rtfeldman$elm_css$Html$Styled$node('fieldset');
	var rtfeldman$elm_css$Html$Styled$form = rtfeldman$elm_css$Html$Styled$node('form');
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault = function (msg) {
		return _Utils_Tuple2(msg, true);
	};
	var elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
		return {$: 'MayPreventDefault', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onSubmit = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			'submit',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault,
				elm$json$Json$Decode$succeed(msg)));
	};
	var author$project$AdditionalInfosForm$view = function (model) {
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$form,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onSubmit(author$project$AdditionalInfosForm$SaveForm)
							]),
						_List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Html$Styled$fieldset,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												rtfeldman$elm_css$Css$width(
												rtfeldman$elm_css$Css$pct(50)),
												rtfeldman$elm_css$Css$margin(
												rtfeldman$elm_css$Css$em(2))
											]))
									]),
								author$project$AdditionalInfosForm$displayInputs(
									author$project$AdditionalInfosForm$rankList(model.inputs))),
								A2(
								rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										author$project$AdditionalInfosForm$shouldEnabledSend(model.editableState),
										rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-lg btn-primary')
									]),
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text('Sauvegarder')
									])),
								rtfeldman$elm_css$Html$Styled$text(' '),
								A2(
								rtfeldman$elm_css$Html$Styled$button,
								_List_fromArray(
									[
										author$project$AdditionalInfosForm$shouldEnabledSend(model.editableState),
										rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-lg btn-default'),
										rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
										rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$AdditionalInfosForm$FetchAdditionalInfos)
									]),
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text('Annuler les modifications')
									]))
							]))
					])));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$core$String$toInt = _String_toInt;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var author$project$AdditionalInfosForm$main = elm$browser$Browser$element(
		{init: author$project$AdditionalInfosForm$init, subscriptions: author$project$AdditionalInfosForm$subscriptions, update: author$project$AdditionalInfosForm$update, view: author$project$AdditionalInfosForm$view});
	_Platform_export({'AdditionalInfosForm':{'init':author$project$AdditionalInfosForm$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (patrimonyUid) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (apiUrl) {
						return elm$json$Json$Decode$succeed(
							{apiUrl: apiUrl, patrimonyUid: patrimonyUid});
					},
					A2(elm$json$Json$Decode$field, 'apiUrl', elm$json$Json$Decode$string));
			},
			A2(elm$json$Json$Decode$field, 'patrimonyUid', elm$json$Json$Decode$string)))(0)}});}(this));

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerb = function (s) {
		switch (s) {
			case 'GET':
				return elm$core$Result$Ok(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$core$Result$Ok(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$core$Result$Ok(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$core$Result$Ok(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$core$Result$Err(other + ' is not an known http verb in app');
		}
	};
	var author$project$Components$ContextualComment$State$Model = F4(
		function (fetchCommentsRef, comments, navigationLinks, editingComment) {
			return {comments: comments, editingComment: editingComment, fetchCommentsRef: fetchCommentsRef, navigationLinks: navigationLinks};
		});
	var author$project$Components$ContextualComment$Update$FetchComments = {$: 'FetchComments'};
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var author$project$Components$ContextualComment$Update$init = function (flags) {
		var link = A3(
			author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink,
			flags.rel,
			flags.href,
			A2(
				elm$core$Result$withDefault,
				author$project$Binding$RestNavigationLinkDecoder$GET,
				author$project$Binding$RestNavigationLinkDecoder$string2HttpVerb(flags.method)));
		return _Utils_Tuple2(
			A4(author$project$Components$ContextualComment$State$Model, link, _List_Nil, _List_Nil, elm$core$Maybe$Nothing),
			author$project$Utils$Command$msgToElmCmd(author$project$Components$ContextualComment$Update$FetchComments));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$Components$ContextualComment$Update$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Components$ContextualComment$State$Comment = F4(
		function (uid, title, comment, links) {
			return {comment: comment, links: links, title: title, uid: uid};
		});
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$ContextualCommentDecoder$commentRefDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'comment',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				elm$json$Json$Decode$string,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Components$ContextualComment$State$Comment)))));
	var elm$json$Json$Encode$object = function (pairs) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, obj) {
						var k = _n0.a;
						var v = _n0.b;
						return A3(_Json_addField, k, v, obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				pairs));
	};
	var elm$json$Json$Encode$string = _Json_wrap;
	var author$project$Binding$ContextualCommentEncoder$encodeComment = function (comment) {
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					elm$json$Json$Encode$string(comment.title)),
					_Utils_Tuple2(
					'comment',
					elm$json$Json$Encode$string(comment.comment))
				]));
	};
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var author$project$Components$ContextualComment$State$CommentForEdition = F3(
		function (uid, title, comment) {
			return {comment: comment, title: title, uid: uid};
		});
	var author$project$Components$ContextualComment$State$EditingComment = F2(
		function (action, comment) {
			return {action: action, comment: comment};
		});
	var author$project$Components$ContextualComment$Update$CommentEdited = function (a) {
		return {$: 'CommentEdited', a: a};
	};
	var author$project$Components$ContextualComment$Update$CommentFetched = function (a) {
		return {$: 'CommentFetched', a: a};
	};
	var author$project$Components$ContextualComment$Update$sendErrorToRedux = _Platform_outgoingPort('sendErrorToRedux', elm$json$Json$Encode$string);
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var author$project$Utils$Command$noOp = function (model) {
		return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
	};
	var author$project$Utils$Http$HttpRequest$Delete = F2(
		function (a, b) {
			return {$: 'Delete', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Patch = F3(
		function (a, b, c) {
			return {$: 'Patch', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$Post = F3(
		function (a, b, c) {
			return {$: 'Post', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$request = F3(
		function (link, body, exp) {
			var _n0 = link.method;
			switch (_n0.$) {
				case 'GET':
					return A2(author$project$Utils$Http$HttpRequest$Get, link.href, exp);
				case 'POST':
					return A3(author$project$Utils$Http$HttpRequest$Post, link.href, body, exp);
				case 'PATCH':
					return A3(author$project$Utils$Http$HttpRequest$Patch, link.href, body, exp);
				default:
					return A2(author$project$Utils$Http$HttpRequest$Delete, link.href, exp);
			}
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var author$project$Utils$Http$HttpRequest$authRequest = F3(
		function (link, body, exp) {
			return author$project$Utils$Http$HttpRequest$withAuthReq(
				A3(author$project$Utils$Http$HttpRequest$request, link, body, exp));
		});
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm$http$Http$expectBytesResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'arraybuffer',
				_Http_toDataView,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$expectWhatever = function (toMsg) {
		return A2(
			elm$http$Http$expectBytesResponse,
			toMsg,
			elm$http$Http$resolve(
				function (_n0) {
					return elm$core$Result$Ok(_Utils_Tuple0);
				}));
	};
	var elm$http$Http$jsonBody = function (value) {
		return A2(
			_Http_pair,
			'application/json',
			A2(elm$json$Json$Encode$encode, 0, value));
	};
	var author$project$Components$ContextualComment$Update$update = F2(
		function (action, model) {
			switch (action.$) {
				case 'FetchComments':
					var expected = A2(
						elm$http$Http$expectJson,
						author$project$Components$ContextualComment$Update$CommentFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Binding$ContextualCommentDecoder$commentRefDecoder)));
					var fetchComments = A3(author$project$Utils$Http$HttpRequest$authRequest, model.fetchCommentsRef, elm$http$Http$emptyBody, expected);
					return _Utils_Tuple2(model, fetchComments);
				case 'CommentFetched':
					if (action.a.$ === 'Ok') {
						var comments = action.a.a;
						return author$project$Utils$Command$noOp(
							_Utils_update(
								model,
								{comments: comments.result, navigationLinks: comments.links}));
					} else {
						return _Utils_Tuple2(
							model,
							author$project$Components$ContextualComment$Update$sendErrorToRedux('Récupération du référentiel de commentaires impossible'));
					}
				case 'AddNewComment':
					var link = action.a;
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{
								editingComment: elm$core$Maybe$Just(
									A2(
										author$project$Components$ContextualComment$State$EditingComment,
										link,
										A3(author$project$Components$ContextualComment$State$CommentForEdition, elm$core$Maybe$Nothing, '', '')))
							}));
				case 'EditCommentModeOn':
					var comment = action.a;
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{
								editingComment: elm$core$Maybe$Just(comment)
							}));
				case 'DisplayCommentModeOn':
					var comment = action.a;
					return author$project$Utils$Command$noOp(model);
				case 'EditCommentModeOff':
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{editingComment: elm$core$Maybe$Nothing}));
				case 'EditTitle':
					var title = action.a;
					var editTitle = function (c) {
						return _Utils_update(
							c,
							{title: title});
					};
					var editedComment = A2(
						elm$core$Maybe$map,
						function (editing) {
							return _Utils_update(
								editing,
								{
									comment: editTitle(editing.comment)
								});
						},
						model.editingComment);
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{editingComment: editedComment}));
				case 'EditCommentValue':
					var content = action.a;
					var editContent = function (c) {
						return _Utils_update(
							c,
							{comment: content});
					};
					var editedComment = A2(
						elm$core$Maybe$map,
						function (e) {
							return _Utils_update(
								e,
								{
									comment: editContent(e.comment)
								});
						},
						model.editingComment);
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{editingComment: editedComment}));
				case 'EditComment':
					var comment = action.a;
					var expected = elm$http$Http$expectWhatever(author$project$Components$ContextualComment$Update$CommentEdited);
					var body = elm$http$Http$jsonBody(
						author$project$Binding$ContextualCommentEncoder$encodeComment(comment.comment));
					var editComment = A3(author$project$Utils$Http$HttpRequest$authRequest, comment.action, body, expected);
					return _Utils_Tuple2(model, editComment);
				default:
					if (action.a.$ === 'Ok') {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{editingComment: elm$core$Maybe$Nothing}),
							author$project$Utils$Command$msgToElmCmd(author$project$Components$ContextualComment$Update$FetchComments));
					} else {
						var error = author$project$Components$ContextualComment$Update$sendErrorToRedux('Erreur - Sauvegarde impossible');
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{editingComment: elm$core$Maybe$Nothing}),
							elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										author$project$Utils$Command$msgToElmCmd(author$project$Components$ContextualComment$Update$FetchComments),
										error
									])));
					}
			}
		});
	var author$project$Components$ContextualComment$State$AddComment = {$: 'AddComment'};
	var author$project$Components$ContextualComment$State$showRel = function (right) {
		switch (right.$) {
			case 'AddComment':
				return 'AddComment';
			case 'UpdateComment':
				return 'UpdateComment';
			default:
				return 'DeleteComment';
		}
	};
	var author$project$Components$ContextualComment$Update$AddNewComment = function (a) {
		return {$: 'AddNewComment', a: a};
	};
	var elm_community$list_extra$List$Extra$find = F2(
		function (predicate, list) {
			find:
			while (true) {
				if (!list.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var first = list.a;
					var rest = list.b;
					if (predicate(first)) {
						return elm$core$Maybe$Just(first);
					} else {
						var $temp$predicate = predicate,
							$temp$list = rest;
						predicate = $temp$predicate;
						list = $temp$list;
						continue find;
					}
				}
			}
		});
	var author$project$Utils$Http$NavigationLinkUtils$find = F2(
		function (rel, links) {
			return A2(
				elm_community$list_extra$List$Extra$find,
				function (l) {
					return _Utils_eq(rel, l.rel);
				},
				links);
		});
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$String$fromList = _String_fromList;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$Components$ContextualComment$View$addCommentButton = function (model) {
		var rightToAddComment = A2(
			author$project$Utils$Http$NavigationLinkUtils$find,
			author$project$Components$ContextualComment$State$showRel(author$project$Components$ContextualComment$State$AddComment),
			model.navigationLinks);
		var addButton = function (l) {
			return A2(
				rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onClick(
						author$project$Components$ContextualComment$Update$AddNewComment(l)),
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(10))
							]))
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('ajouter un commentaire')
					]));
		};
		return A2(
			elm$core$Maybe$withDefault,
			A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
			A2(elm$core$Maybe$map, addButton, rightToAddComment));
	};
	var author$project$Components$ContextualComment$State$UpdateComment = {$: 'UpdateComment'};
	var author$project$Components$ContextualComment$State$initEditingComment = function (comment) {
		return A3(
			author$project$Components$ContextualComment$State$CommentForEdition,
			elm$core$Maybe$Just(comment.uid),
			comment.title,
			comment.comment);
	};
	var author$project$Components$ContextualComment$Update$DisplayCommentModeOn = function (a) {
		return {$: 'DisplayCommentModeOn', a: a};
	};
	var author$project$Components$ContextualComment$Update$EditCommentModeOn = function (a) {
		return {$: 'EditCommentModeOn', a: a};
	};
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var author$project$Components$ContextualComment$View$commentAbstractView = function (comment) {
		var rightToEditComment = A2(
			author$project$Utils$Http$NavigationLinkUtils$find,
			author$project$Components$ContextualComment$State$showRel(author$project$Components$ContextualComment$State$UpdateComment),
			comment.links);
		var editingComment = function (link) {
			return A2(
				author$project$Components$ContextualComment$State$EditingComment,
				link,
				author$project$Components$ContextualComment$State$initEditingComment(comment));
		};
		var editMode = A2(
			elm$core$Maybe$withDefault,
			author$project$Components$ContextualComment$Update$DisplayCommentModeOn(
				author$project$Components$ContextualComment$State$initEditingComment(comment)),
			A2(
				elm$core$Maybe$map,
				function (link) {
					return author$project$Components$ContextualComment$Update$EditCommentModeOn(
						editingComment(link));
				},
				rightToEditComment));
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
							rtfeldman$elm_css$Css$padding(
							rtfeldman$elm_css$Css$px(15))
						])),
					rtfeldman$elm_css$Html$Styled$Events$onClick(editMode)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(comment.title)
				]));
	};
	var author$project$Components$ContextualComment$View$commentUidForAdd = 'ADD';
	var author$project$Components$ContextualComment$Update$EditComment = function (a) {
		return {$: 'EditComment', a: a};
	};
	var author$project$Components$ContextualComment$Update$EditCommentModeOff = {$: 'EditCommentModeOff'};
	var author$project$Components$ContextualComment$Update$EditTitle = function (a) {
		return {$: 'EditTitle', a: a};
	};
	var author$project$Components$ContextualComment$Update$EditCommentValue = function (a) {
		return {$: 'EditCommentValue', a: a};
	};
	var author$project$Components$ContextualComment$View$textAreaHeight = 300;
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var rtfeldman$elm_css$Css$height = rtfeldman$elm_css$Css$prop1('height');
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var author$project$Components$ContextualComment$View$textAreaCss = rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$height(
				rtfeldman$elm_css$Css$px(author$project$Components$ContextualComment$View$textAreaHeight)),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$px(800)),
				rtfeldman$elm_css$Css$padding(
				rtfeldman$elm_css$Css$px(10)),
				A3(
				rtfeldman$elm_css$Css$border3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid,
				rtfeldman$elm_css$Css$hex('ccc'))
			]));
	var rtfeldman$elm_css$Html$Styled$textarea = rtfeldman$elm_css$Html$Styled$node('textarea');
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$value = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
	var rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
		return _Utils_Tuple2(x, true);
	};
	var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
		return {$: 'MayStopPropagation', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
		});
	var elm$json$Json$Decode$at = F2(
		function (fields, decoder) {
			return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
		});
	var rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'value']),
		elm$json$Json$Decode$string);
	var rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
			'input',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
				A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue)));
	};
	var author$project$Components$ContextualComment$View$commentDetailedView = function (comment) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$marginBottom(
							rtfeldman$elm_css$Css$px(20))
						]))
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$textarea,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$value(comment.comment),
							rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Components$ContextualComment$Update$EditCommentValue),
							author$project$Components$ContextualComment$View$textAreaCss
						]),
					_List_Nil)
				]));
	};
	var rtfeldman$elm_css$Css$paddingLeft = rtfeldman$elm_css$Css$prop1('padding-left');
	var author$project$Components$ContextualComment$View$inputCss = rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$height(
				rtfeldman$elm_css$Css$px(40)),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$px(800)),
				rtfeldman$elm_css$Css$paddingLeft(
				rtfeldman$elm_css$Css$px(10)),
				A3(
				rtfeldman$elm_css$Css$border3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid,
				rtfeldman$elm_css$Css$hex('ccc'))
			]));
	var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
	var rtfeldman$elm_css$Html$Styled$input = rtfeldman$elm_css$Html$Styled$node('input');
	var author$project$Components$ContextualComment$View$editFormView = function (editing) {
		return _List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$value(editing.comment.title),
						rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Components$ContextualComment$Update$EditTitle),
						author$project$Components$ContextualComment$View$inputCss
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$marginTop(
								rtfeldman$elm_css$Css$px(10))
							]))
					]),
				_List_fromArray(
					[
						author$project$Components$ContextualComment$View$commentDetailedView(editing.comment),
						A2(
						rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Components$ContextualComment$Update$EditCommentModeOff)
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('annuler')
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onClick(
								author$project$Components$ContextualComment$Update$EditComment(editing))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('sauvegarder')
							]))
					]))
			]);
	};
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$hidden = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, value: 'hidden', visibility: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$overflow = rtfeldman$elm_css$Css$prop1('overflow');
	var rtfeldman$elm_css$Css$visibility = rtfeldman$elm_css$Css$prop1('visibility');
	var rtfeldman$elm_css$Css$visible = {overflow: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, value: 'visible', visibility: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$Transitions$Height = {$: 'Height'};
	var rtfeldman$elm_css$Css$Transitions$Transition = function (a) {
		return {$: 'Transition', a: a};
	};
	var rtfeldman$elm_css$Css$Transitions$durationTransition = F2(
		function (animation, duration) {
			return rtfeldman$elm_css$Css$Transitions$Transition(
				{animation: animation, delay: elm$core$Maybe$Nothing, duration: duration, timing: elm$core$Maybe$Nothing});
		});
	var rtfeldman$elm_css$Css$Transitions$height = rtfeldman$elm_css$Css$Transitions$durationTransition(rtfeldman$elm_css$Css$Transitions$Height);
	var rtfeldman$elm_css$Css$Transitions$Padding = {$: 'Padding'};
	var rtfeldman$elm_css$Css$Transitions$padding = rtfeldman$elm_css$Css$Transitions$durationTransition(rtfeldman$elm_css$Css$Transitions$Padding);
	var rtfeldman$elm_css$Css$Transitions$propToString = function (prop) {
		switch (prop.$) {
			case 'Background':
				return 'background';
			case 'BackgroundColor':
				return 'background-color';
			case 'BackgroundPosition':
				return 'background-position';
			case 'BackgroundSize':
				return 'background-size';
			case 'Border':
				return 'border';
			case 'BorderBottom':
				return 'border-bottom';
			case 'BorderBottomColor':
				return 'border-bottom-color';
			case 'BorderBottomLeftRadius':
				return 'border-bottom-left-radius';
			case 'BorderBottomRightRadius':
				return 'border-bottom-right-radius';
			case 'BorderBottomWidth':
				return 'border-bottom-width';
			case 'BorderColor':
				return 'border-color';
			case 'BorderLeft':
				return 'border-left';
			case 'BorderLeftColor':
				return 'border-left-color';
			case 'BorderLeftWidth':
				return 'border-left-width';
			case 'BorderRadius':
				return 'border-radius';
			case 'BorderRight':
				return 'border-right';
			case 'BorderRightColor':
				return 'border-right-color';
			case 'BorderRightWidth':
				return 'border-right-width';
			case 'BorderTop':
				return 'border-top';
			case 'BorderTopColor':
				return 'border-top-color';
			case 'BorderTopLeftRadius':
				return 'border-top-left-radius';
			case 'BorderTopRightRadius':
				return 'border-top-right-radius';
			case 'BorderTopWidth':
				return 'border-top-width';
			case 'BorderWidth':
				return 'border-width';
			case 'Bottom':
				return 'bottom';
			case 'BoxShadow':
				return 'box-shadow';
			case 'CaretColor':
				return 'caret-color';
			case 'Clip':
				return 'clip';
			case 'ClipPath':
				return 'clip-path';
			case 'Color':
				return 'color';
			case 'ColumnCount':
				return 'column-count';
			case 'ColumnGap':
				return 'column-gap';
			case 'ColumnRule':
				return 'column-rule';
			case 'ColumnRuleColor':
				return 'column-rule-color';
			case 'ColumnRuleWidth':
				return 'column-rule-width';
			case 'ColumnWidth':
				return 'column-width';
			case 'Columns':
				return 'columns';
			case 'Filter':
				return 'filter';
			case 'Flex':
				return 'flex';
			case 'FlexBasis':
				return 'flex-basis';
			case 'FlexGrow':
				return 'flex-grow';
			case 'FlexShrink':
				return 'flex-shrink';
			case 'Font':
				return 'font';
			case 'FontSize':
				return 'font-size';
			case 'FontSizeAdjust':
				return 'font-size-adjust';
			case 'FontStretch':
				return 'font-stretch';
			case 'FontVariationSettings':
				return 'font-variation-settings';
			case 'FontWeight':
				return 'font-weight';
			case 'GridColumnGap':
				return 'grid-column-gap';
			case 'GridGap':
				return 'grid-gap';
			case 'GridRowGap':
				return 'grid-row-gap';
			case 'Height':
				return 'height';
			case 'Left':
				return 'left';
			case 'LetterSpacing':
				return 'letter-spacing';
			case 'LineHeight':
				return 'line-height';
			case 'Margin':
				return 'margin';
			case 'MarginBottom':
				return 'margin-bottom';
			case 'MarginLeft':
				return 'margin-left';
			case 'MarginRight':
				return 'margin-right';
			case 'MarginTop':
				return 'margin-top';
			case 'Mask':
				return 'mask';
			case 'MaskPosition':
				return 'mask-position';
			case 'MaskSize':
				return 'mask-size';
			case 'MaxHeight':
				return 'max-height';
			case 'MaxWidth':
				return 'max-width';
			case 'MinHeight':
				return 'min-height';
			case 'MinWidth':
				return 'min-width';
			case 'ObjectPosition':
				return 'object-position';
			case 'Offset':
				return 'offset';
			case 'OffsetAnchor':
				return 'offset-anchor';
			case 'OffsetDistance':
				return 'offset-distance';
			case 'OffsetPath':
				return 'offset-path';
			case 'OffsetRotate':
				return 'offset-rotate';
			case 'Opacity':
				return 'opacity';
			case 'Order':
				return 'order';
			case 'Outline':
				return 'outline';
			case 'OutlineColor':
				return 'outline-color';
			case 'OutlineOffset':
				return 'outline-offset';
			case 'OutlineWidth':
				return 'outline-width';
			case 'Padding':
				return 'padding';
			case 'PaddingBottom':
				return 'padding-bottom';
			case 'PaddingLeft':
				return 'padding-left';
			case 'PaddingRight':
				return 'padding-right';
			case 'PaddingTop':
				return 'padding-top';
			case 'Right':
				return 'right';
			case 'TabSize':
				return 'tab-size';
			case 'TextIndent':
				return 'text-indent';
			case 'TextShadow':
				return 'text-shadow';
			case 'Top':
				return 'top';
			case 'Transform':
				return 'transform';
			case 'TransformOrigin':
				return 'transform-origin';
			case 'VerticalAlign':
				return 'vertical-align';
			case 'Visibility':
				return 'visibility';
			case 'Width':
				return 'width';
			case 'WordSpacing':
				return 'word-spacing';
			default:
				return 'z-index';
		}
	};
	var rtfeldman$elm_css$Css$Transitions$timeToString = function (time) {
		return elm$core$String$fromFloat(time) + 'ms';
	};
	var rtfeldman$elm_css$Css$Transitions$timingFunctionToString = function (tf) {
		switch (tf.$) {
			case 'Ease':
				return 'ease';
			case 'Linear':
				return 'linear';
			case 'EaseIn':
				return 'ease-in';
			case 'EaseOut':
				return 'ease-out';
			case 'EaseInOut':
				return 'ease-in-out';
			case 'StepStart':
				return 'step-start';
			case 'StepEnd':
				return 'step-end';
			default:
				var _float = tf.a;
				var float2 = tf.b;
				var float3 = tf.c;
				var float4 = tf.d;
				return 'cubic-bezier(' + (elm$core$String$fromFloat(_float) + (' , ' + (elm$core$String$fromFloat(float2) + (' , ' + (elm$core$String$fromFloat(float3) + (' , ' + (elm$core$String$fromFloat(float4) + ')')))))));
		}
	};
	var rtfeldman$elm_css$Css$Transitions$transition = function (options) {
		var v = A3(
			elm$core$String$slice,
			0,
			-1,
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, s) {
						var animation = _n0.a.animation;
						var duration = _n0.a.duration;
						var delay = _n0.a.delay;
						var timing = _n0.a.timing;
						return s + (A2(
							elm$core$String$join,
							' ',
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Transitions$propToString(animation),
									rtfeldman$elm_css$Css$Transitions$timeToString(duration),
									A2(
									elm$core$Maybe$withDefault,
									'',
									A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Transitions$timeToString, delay)),
									A2(
									elm$core$Maybe$withDefault,
									'',
									A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Transitions$timingFunctionToString, timing))
								])) + ',');
					}),
				'',
				options));
		return A2(rtfeldman$elm_css$Css$property, 'transition', v);
	};
	var rtfeldman$elm_css$Css$Transitions$Visibility = {$: 'Visibility'};
	var rtfeldman$elm_css$Css$Transitions$visibility = rtfeldman$elm_css$Css$Transitions$durationTransition(rtfeldman$elm_css$Css$Transitions$Visibility);
	var author$project$Components$ContextualComment$View$commentEditModView = F2(
		function (mEditing, comment) {
			var totalHeight = author$project$Components$ContextualComment$View$textAreaHeight + 200;
			var testEdition = function (editing) {
				return (_Utils_eq(
					editing.action.rel,
					author$project$Components$ContextualComment$State$showRel(author$project$Components$ContextualComment$State$AddComment)) && _Utils_eq(comment.uid, author$project$Components$ContextualComment$View$commentUidForAdd)) ? _Utils_Tuple2(
					true,
					author$project$Components$ContextualComment$View$editFormView(editing)) : A2(
					elm$core$Maybe$withDefault,
					_Utils_Tuple2(false, _List_Nil),
					A2(
						elm$core$Maybe$map,
						function (e_uid) {
							return _Utils_eq(e_uid, comment.uid) ? _Utils_Tuple2(
								true,
								author$project$Components$ContextualComment$View$editFormView(editing)) : _Utils_Tuple2(false, _List_Nil);
						},
						editing.comment.uid));
			};
			var _n0 = A2(
				elm$core$Maybe$withDefault,
				_Utils_Tuple2(false, _List_Nil),
				A2(
					elm$core$Maybe$map,
					function (editing) {
						return testEdition(editing);
					},
					mEditing));
			var displayDetail = _n0.a;
			var form = _n0.b;
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								displayDetail ? rtfeldman$elm_css$Css$visibility(rtfeldman$elm_css$Css$visible) : rtfeldman$elm_css$Css$visibility(rtfeldman$elm_css$Css$hidden),
								displayDetail ? rtfeldman$elm_css$Css$height(
								rtfeldman$elm_css$Css$px(totalHeight)) : rtfeldman$elm_css$Css$height(
								rtfeldman$elm_css$Css$px(0)),
								displayDetail ? rtfeldman$elm_css$Css$padding(
								rtfeldman$elm_css$Css$px(25)) : rtfeldman$elm_css$Css$padding(
								rtfeldman$elm_css$Css$px(0)),
								rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden),
								rtfeldman$elm_css$Css$Transitions$transition(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$Transitions$height(450.0),
										rtfeldman$elm_css$Css$Transitions$visibility(450.0),
										rtfeldman$elm_css$Css$Transitions$padding(450)
									])),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('fff'))
							]))
					]),
				form);
		});
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var author$project$Components$ContextualComment$View$commentBox = F2(
		function (toEdit, comment) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$color(
								rtfeldman$elm_css$Css$hex('8a959a')),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('FBFBFB')),
								A3(
								rtfeldman$elm_css$Css$border3,
								rtfeldman$elm_css$Css$px(1),
								rtfeldman$elm_css$Css$solid,
								rtfeldman$elm_css$Css$hex('ddd')),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(10))
							]))
					]),
				_List_fromArray(
					[
						author$project$Components$ContextualComment$View$commentAbstractView(comment),
						A2(author$project$Components$ContextualComment$View$commentEditModView, toEdit, comment)
					]));
		});
	var author$project$Components$ContextualComment$View$displayAllComments = function (model) {
		var editNewComment = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Maybe$map,
				function (e) {
					var _n0 = e.comment.uid;
					if (_n0.$ === 'Just') {
						return _List_Nil;
					} else {
						return _List_fromArray(
							[
								A4(author$project$Components$ContextualComment$State$Comment, author$project$Components$ContextualComment$View$commentUidForAdd, e.comment.title, e.comment.comment, _List_Nil)
							]);
					}
				},
				model.editingComment));
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				elm$core$List$map,
				author$project$Components$ContextualComment$View$commentBox(model.editingComment),
				_Utils_ap(editNewComment, model.comments)));
	};
	var author$project$Components$ContextualComment$View$view = function (model) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					author$project$Components$ContextualComment$View$addCommentButton(model),
					author$project$Components$ContextualComment$View$displayAllComments(model)
				]));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$core$String$toInt = _String_toInt;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var author$project$ContextualComment$main = elm$browser$Browser$element(
		{
			init: author$project$Components$ContextualComment$Update$init,
			subscriptions: author$project$Components$ContextualComment$Update$subscriptions,
			update: author$project$Components$ContextualComment$Update$update,
			view: A2(elm$core$Basics$composeR, author$project$Components$ContextualComment$View$view, rtfeldman$elm_css$Html$Styled$toUnstyled)
		});
	_Platform_export({'ContextualComment':{'init':author$project$ContextualComment$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (rel) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (method) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (href) {
								return elm$json$Json$Decode$succeed(
									{href: href, method: method, rel: rel});
							},
							A2(elm$json$Json$Decode$field, 'href', elm$json$Json$Decode$string));
					},
					A2(elm$json$Json$Decode$field, 'method', elm$json$Json$Decode$string));
			},
			A2(elm$json$Json$Decode$field, 'rel', elm$json$Json$Decode$string)))(0)}});}(this));

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	var author$project$Components$TicketEventNotification$ListNotifications$FetchListNotifications = {$: 'FetchListNotifications'};
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var author$project$Components$TicketEventNotification$ListNotifications$fetchList = author$project$Utils$Command$msgToElmCmd(author$project$Components$TicketEventNotification$ListNotifications$FetchListNotifications);
	var author$project$Components$TicketEventNotification$ListNotifications$Model = F2(
		function (notification, currentNotification) {
			return {currentNotification: currentNotification, notification: notification};
		});
	var author$project$Components$TicketEventNotification$ListNotifications$init = A2(author$project$Components$TicketEventNotification$ListNotifications$Model, _List_Nil, elm$core$Maybe$Nothing);
	var author$project$Main$ListNotificationMsg = function (a) {
		return {$: 'ListNotificationMsg', a: a};
	};
	var author$project$Main$Model = F4(
		function (flags, notification, otpsRef, list) {
			return {flags: flags, list: list, notification: notification, otpsRef: otpsRef};
		});
	var elm$core$Platform$Cmd$map = _Platform_map;
	var author$project$Main$init = function (flags) {
		return _Utils_Tuple2(
			A4(author$project$Main$Model, flags, elm$core$Maybe$Nothing, elm$core$Maybe$Nothing, author$project$Components$TicketEventNotification$ListNotifications$init),
			A2(elm$core$Platform$Cmd$map, author$project$Main$ListNotificationMsg, author$project$Components$TicketEventNotification$ListNotifications$fetchList));
	};
	var author$project$Main$OtpRefReceived = function (a) {
		return {$: 'OtpRefReceived', a: a};
	};
	var elm$json$Json$Decode$value = _Json_decodeValue;
	var author$project$Main$otpsReceived = _Platform_incomingPort('otpsReceived', elm$json$Json$Decode$value);
	var author$project$Main$subscriptions = function (_n0) {
		return author$project$Main$otpsReceived(author$project$Main$OtpRefReceived);
	};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$Binding$OTPDecoder$OtpsRecord = F2(
		function (categories, openingTicketPurposes) {
			return {categories: categories, openingTicketPurposes: openingTicketPurposes};
		});
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$decodeValue = _Json_run;
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
		function (pathDecoder, valDecoder, fallback) {
			var nullOr = function (decoder) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							decoder,
							elm$json$Json$Decode$null(fallback)
						]));
			};
			var handleResult = function (input) {
				var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
				if (_n0.$ === 'Ok') {
					var rawValue = _n0.a;
					var _n1 = A2(
						elm$json$Json$Decode$decodeValue,
						nullOr(valDecoder),
						rawValue);
					if (_n1.$ === 'Ok') {
						var finalResult = _n1.a;
						return elm$json$Json$Decode$succeed(finalResult);
					} else {
						var finalErr = _n1.a;
						return elm$json$Json$Decode$fail(
							elm$json$Json$Decode$errorToString(finalErr));
					}
				} else {
					return elm$json$Json$Decode$succeed(fallback);
				}
			};
			return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
		});
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
		function (key, valDecoder, fallback, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
					A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
					valDecoder,
					fallback),
				decoder);
		});
	var author$project$Binding$OTPDecoder$CategoryRecord = F4(
		function (uid, label, iconId, parent) {
			return {iconId: iconId, label: label, parent: parent, uid: uid};
		});
	var author$project$Binding$OTPDecoder$UidRecord = function (uid) {
		return {uid: uid};
	};
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$OTPDecoder$uidRecordDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uid',
		elm$json$Json$Decode$string,
		elm$json$Json$Decode$succeed(author$project$Binding$OTPDecoder$UidRecord));
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$nullable = function (decoder) {
		return elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
				]));
	};
	var author$project$Binding$OTPDecoder$categorieDecoder = A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'parent',
		elm$json$Json$Decode$nullable(author$project$Binding$OTPDecoder$uidRecordDecoder),
		elm$core$Maybe$Nothing,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'iconId',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'label',
				elm$json$Json$Decode$string,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Binding$OTPDecoder$CategoryRecord)))));
	var author$project$Binding$OTPDecoder$OtpRecord = F3(
		function (uid, categories, label) {
			return {categories: categories, label: label, uid: uid};
		});
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$OTPDecoder$otpDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'categories',
			elm$json$Json$Decode$list(author$project$Binding$OTPDecoder$uidRecordDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$OTPDecoder$OtpRecord))));
	var author$project$Binding$OTPDecoder$otpsDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'openingTicketPurposes',
		elm$json$Json$Decode$list(author$project$Binding$OTPDecoder$otpDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'categories',
			elm$json$Json$Decode$list(author$project$Binding$OTPDecoder$categorieDecoder),
			elm$json$Json$Decode$succeed(author$project$Binding$OTPDecoder$OtpsRecord)));
	var author$project$Components$TicketEventNotification$EditNotification$Model = F5(
		function (config, multiselectTriggerEvents, multiselectOtps, apiError, formErrors) {
			return {apiError: apiError, config: config, formErrors: formErrors, multiselectOtps: multiselectOtps, multiselectTriggerEvents: multiselectTriggerEvents};
		});
	var author$project$Components$TicketEventNotification$EditNotification$TicketEventNotificationConfig = F5(
		function (id, label, triggerEvent, otps, messages) {
			return {id: id, label: label, messages: messages, otps: otps, triggerEvent: triggerEvent};
		});
	var author$project$Components$TicketEventNotification$EditNotification$NotificationMessage = F3(
		function (text, recipients, recipientToAdd) {
			return {recipientToAdd: recipientToAdd, recipients: recipients, text: text};
		});
	var author$project$Components$TicketEventNotification$EditNotification$emptyMessage = A3(author$project$Components$TicketEventNotification$EditNotification$NotificationMessage, '', _List_Nil, elm$core$Maybe$Nothing);
	var author$project$Components$TicketEventNotification$EditNotification$emptyConfig = A5(
		author$project$Components$TicketEventNotification$EditNotification$TicketEventNotificationConfig,
		elm$core$Maybe$Nothing,
		elm$core$Maybe$Nothing,
		_List_Nil,
		_List_Nil,
		_List_fromArray(
			[author$project$Components$TicketEventNotification$EditNotification$emptyMessage]));
	var author$project$Components$TicketEventNotification$NotificationData$triggerEvents = _List_fromArray(
		[
			_Utils_Tuple2('TicketOpenedEvent', 'Ticket ouvert'),
			_Utils_Tuple2('DocumentAttachedEvent', 'Document attaché'),
			_Utils_Tuple2('CallEmittedToEvent', 'Appel émis'),
			_Utils_Tuple2('CallReceivedEvent', 'Appel reçu'),
			_Utils_Tuple2('AssigneeIdentifiedEvent', 'Intervenant identifié'),
			_Utils_Tuple2('InterventionDeadlineDefinedEvent', 'Date limite d’intervention définie'),
			_Utils_Tuple2('FormalNoticeForProviderReportedEvent', 'Mise en demeure définie'),
			_Utils_Tuple2('SendingServiceOrderReportedEvent', 'Ordre de service envoyé'),
			_Utils_Tuple2('CallAnsweredByProviderEvent', 'Appel pris par le fournisseur'),
			_Utils_Tuple2('CallNotAnsweredByProviderEvent', 'Appel non pris par le fournisseur'),
			_Utils_Tuple2('InterventionScheduledEvent', 'Intervention plannifiée'),
			_Utils_Tuple2('InterventionRequestedEvent', 'Intervention demandée'),
			_Utils_Tuple2('InterventionAcceptedEvent', 'Intervention acceptée'),
			_Utils_Tuple2('InterventionRefusedEvent', 'intervention refusée'),
			_Utils_Tuple2('TicketReopenedEvent', 'Ticket réouvert'),
			_Utils_Tuple2('MessageAddedEvent', 'Commentaire'),
			_Utils_Tuple2('ArrivedOnSiteEvent', 'Arrivée sur site'),
			_Utils_Tuple2('GoneFromSiteEvent', 'Départ du site'),
			_Utils_Tuple2('InterventionStartedEvent', 'Intervention débutée'),
			_Utils_Tuple2('InterventionFinishedEvent', 'Intervention terminée'),
			_Utils_Tuple2('OpeningTicketPurposeCorrectedEvent', 'Diagnostique corrigé'),
			_Utils_Tuple2('LocationReferenceCorrectedEvent', 'Localisation corrigé'),
			_Utils_Tuple2('CallerCorrectedEvent', 'Appelant corrigé'),
			_Utils_Tuple2('TicketCancelledEvent', 'Ticket annulé'),
			_Utils_Tuple2('TicketClosedEvent', 'Ticket clôturé'),
			_Utils_Tuple2('TicketArchivedEvent', 'Ticket archivé'),
			_Utils_Tuple2('PermanentlyFixedEvent', 'Ticket clôturé : réparation définitive'),
			_Utils_Tuple2('PartiallyFixedEvent', 'Ticket clôturé : réparation partielle'),
			_Utils_Tuple2('TicketClosedImpossibleRepairEvent', 'Ticket clôturé : réparation impossible'),
			_Utils_Tuple2('PostponedFixEvent', 'Ticket clôturé : réparation reportée'),
			_Utils_Tuple2('ClosedBeyondCallCenterScopeEvent', 'Ticket clôturé : en dehors du scope'),
			_Utils_Tuple2('ClosedAfterSeveralUnsuccessfulRecallsEvent', 'Ticket clôturé après plusieurs appels infructueux')
		]);
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var inkuzmin$elm_multiselect$Multiselect$Closed = {$: 'Closed'};
	var inkuzmin$elm_multiselect$Multiselect$Model = function (a) {
		return {$: 'Model', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$initModel = F2(
		function (values, tag1) {
			return inkuzmin$elm_multiselect$Multiselect$Model(
				{
					error: elm$core$Maybe$Nothing,
					filtered: values,
					hovered: elm$core$List$head(values),
					input: '',
					inputWidth: 23.0,
					_protected: false,
					selected: _List_Nil,
					status: inkuzmin$elm_multiselect$Multiselect$Closed,
					tag: tag1,
					values: values
				});
		});
	var author$project$Components$TicketEventNotification$EditNotification$init = function (otps) {
		var otpsValues = A2(
			elm$core$List$map,
			function (n) {
				return _Utils_Tuple2(n.uid, n.label);
			},
			A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					function ($) {
						return $.openingTicketPurposes;
					},
					otps)));
		return A5(
			author$project$Components$TicketEventNotification$EditNotification$Model,
			author$project$Components$TicketEventNotification$EditNotification$emptyConfig,
			A2(inkuzmin$elm_multiselect$Multiselect$initModel, author$project$Components$TicketEventNotification$NotificationData$triggerEvents, 'triggerEvents'),
			A2(inkuzmin$elm_multiselect$Multiselect$initModel, otpsValues, 'otps'),
			elm$core$Maybe$Nothing,
			_List_Nil);
	};
	var elm$core$Basics$always = F2(
		function (a, _n0) {
			return a;
		});
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var elm_community$list_extra$List$Extra$find = F2(
		function (predicate, list) {
			find:
			while (true) {
				if (!list.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var first = list.a;
					var rest = list.b;
					if (predicate(first)) {
						return elm$core$Maybe$Just(first);
					} else {
						var $temp$predicate = predicate,
							$temp$list = rest;
						predicate = $temp$predicate;
						list = $temp$list;
						continue find;
					}
				}
			}
		});
	var inkuzmin$elm_multiselect$Multiselect$getValues = function (_n0) {
		var model = _n0.a;
		return model.values;
	};
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$member = F2(
		function (x, xs) {
			return A2(
				elm$core$List$any,
				function (a) {
					return _Utils_eq(a, x);
				},
				xs);
		});
	var inkuzmin$elm_multiselect$Multiselect$filter = F2(
		function (selected, values) {
			return A2(
				elm$core$List$filter,
				function (value) {
					return !A2(elm$core$List$member, value, selected);
				},
				values);
		});
	var inkuzmin$elm_multiselect$Multiselect$populateValues = F3(
		function (_n0, values, selected) {
			var model = _n0.a;
			var filtered = elm$core$List$isEmpty(selected) ? values : A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, values);
			return inkuzmin$elm_multiselect$Multiselect$Model(
				_Utils_update(
					model,
					{filtered: filtered, selected: selected, values: values}));
		});
	var author$project$Components$TicketEventNotification$EditNotification$setSelectedValues = F2(
		function (model, keys) {
			var values = inkuzmin$elm_multiselect$Multiselect$getValues(model);
			var predicate = function (_n0) {
				var s = _n0.a;
				return A2(
					elm$core$Maybe$withDefault,
					false,
					A2(
						elm$core$Maybe$map,
						elm$core$Basics$always(true),
						A2(
							elm_community$list_extra$List$Extra$find,
							function (x) {
								return _Utils_eq(s, x);
							},
							keys)));
			};
			var selectedEvents = A2(elm$core$List$filter, predicate, values);
			return A3(inkuzmin$elm_multiselect$Multiselect$populateValues, model, values, selectedEvents);
		});
	var author$project$Components$TicketEventNotification$EditNotification$buildModelFromConfig = F2(
		function (otps, config) {
			var model = author$project$Components$TicketEventNotification$EditNotification$init(otps);
			return _Utils_update(
				model,
				{
					config: config,
					multiselectOtps: A2(author$project$Components$TicketEventNotification$EditNotification$setSelectedValues, model.multiselectOtps, config.otps),
					multiselectTriggerEvents: A2(author$project$Components$TicketEventNotification$EditNotification$setSelectedValues, model.multiselectTriggerEvents, config.triggerEvent)
				});
		});
	var author$project$Components$TicketEventNotification$EditNotification$isDone = function (msg) {
		if (msg.$ === 'NotificationAdded') {
			return elm$core$Maybe$Just(_Utils_Tuple0);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var author$project$Binding$TicketEventNotificationAPIErrorDecoder$ErrorTypeRecord = function (errorType) {
		return {errorType: errorType};
	};
	var author$project$Components$TicketEventNotification$NotificationAPIError$ActionForbidden = {$: 'ActionForbidden'};
	var author$project$Components$TicketEventNotification$NotificationAPIError$LabelShouldBeUniq = {$: 'LabelShouldBeUniq'};
	var author$project$Components$TicketEventNotification$NotificationAPIError$NeedHigherCompanyBillingType = {$: 'NeedHigherCompanyBillingType'};
	var author$project$Components$TicketEventNotification$NotificationAPIError$OtherError = {$: 'OtherError'};
	var author$project$Components$TicketEventNotification$NotificationAPIError$TicketEventNotificationDomainError = function (a) {
		return {$: 'TicketEventNotificationDomainError', a: a};
	};
	var author$project$Components$TicketEventNotification$NotificationAPIError$TriggerEventAndOtpsOverlapBetweenTwoConfig = {$: 'TriggerEventAndOtpsOverlapBetweenTwoConfig'};
	var author$project$Components$TicketEventNotification$NotificationAPIError$UserDoesNotHandleThisCompany = {$: 'UserDoesNotHandleThisCompany'};
	var author$project$Components$TicketEventNotification$NotificationAPIError$UserRightError = function (a) {
		return {$: 'UserRightError', a: a};
	};
	var author$project$Binding$TicketEventNotificationAPIErrorDecoder$stringToAPIError = function (s) {
		var _n0 = s.errorType;
		switch (_n0) {
			case 'NeedHigherCompanyBillingType':
				return author$project$Components$TicketEventNotification$NotificationAPIError$UserRightError(author$project$Components$TicketEventNotification$NotificationAPIError$NeedHigherCompanyBillingType);
			case 'UserDoesNotHandleThisCompany':
				return author$project$Components$TicketEventNotification$NotificationAPIError$UserRightError(author$project$Components$TicketEventNotification$NotificationAPIError$UserDoesNotHandleThisCompany);
			case 'ActionForbidden':
				return author$project$Components$TicketEventNotification$NotificationAPIError$UserRightError(author$project$Components$TicketEventNotification$NotificationAPIError$ActionForbidden);
			case 'TriggerEventAndOtpsOverlapBetweenTwoConfig':
				return author$project$Components$TicketEventNotification$NotificationAPIError$TicketEventNotificationDomainError(author$project$Components$TicketEventNotification$NotificationAPIError$TriggerEventAndOtpsOverlapBetweenTwoConfig);
			case 'LabelShouldBeUniq':
				return author$project$Components$TicketEventNotification$NotificationAPIError$TicketEventNotificationDomainError(author$project$Components$TicketEventNotification$NotificationAPIError$LabelShouldBeUniq);
			default:
				return author$project$Components$TicketEventNotification$NotificationAPIError$OtherError;
		}
	};
	var author$project$Binding$TicketEventNotificationAPIErrorDecoder$ticketEventNotificationAPIErrorDecoder = A2(
		elm$json$Json$Decode$map,
		author$project$Binding$TicketEventNotificationAPIErrorDecoder$stringToAPIError,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'errorType',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Binding$TicketEventNotificationAPIErrorDecoder$ErrorTypeRecord)));
	var author$project$Components$TicketEventNotification$EditNotification$NotificationAddResult = function (a) {
		return {$: 'NotificationAddResult', a: a};
	};
	var author$project$Components$TicketEventNotification$EditNotification$NotificationAdded = {$: 'NotificationAdded'};
	var author$project$Components$TicketEventNotification$EditNotification$OtpsMultiselect = function (a) {
		return {$: 'OtpsMultiselect', a: a};
	};
	var author$project$Components$TicketEventNotification$EditNotification$TriggerEventMultiselect = function (a) {
		return {$: 'TriggerEventMultiselect', a: a};
	};
	var author$project$Components$TicketEventNotification$EditNotification$MessageKO = {$: 'MessageKO'};
	var elm$core$Basics$ge = _Utils_ge;
	var elm$core$Maybe$map2 = F3(
		function (func, ma, mb) {
			if (ma.$ === 'Nothing') {
				return elm$core$Maybe$Nothing;
			} else {
				var a = ma.a;
				if (mb.$ === 'Nothing') {
					return elm$core$Maybe$Nothing;
				} else {
					var b = mb.a;
					return elm$core$Maybe$Just(
						A2(func, a, b));
				}
			}
		});
	var elm$core$Result$fromMaybe = F2(
		function (err, maybe) {
			if (maybe.$ === 'Just') {
				var v = maybe.a;
				return elm$core$Result$Ok(v);
			} else {
				return elm$core$Result$Err(err);
			}
		});
	var mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2(
		function (a, b) {
			return {$: 'Nonempty', a: a, b: b};
		});
	var mgold$elm_nonempty_list$List$Nonempty$fromList = function (ys) {
		if (ys.b) {
			var x = ys.a;
			var xs = ys.b;
			return elm$core$Maybe$Just(
				A2(mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, xs));
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var author$project$Components$TicketEventNotification$EditNotification$messageAreOK = function (messages) {
		var textLengthByMessages = A2(
			elm$core$List$map,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.recipients;
				},
				elm$core$List$length),
			messages);
		var numberOfRecipientsByMessages = A2(
			elm$core$List$map,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.recipients;
				},
				elm$core$List$length),
			messages);
		var nonemptyListResult = mgold$elm_nonempty_list$List$Nonempty$fromList(messages);
		var keepIntZero = elm$core$List$filter(
			elm$core$Basics$eq(0));
		var numberOfMessagesWithoutRecipients = keepIntZero(numberOfRecipientsByMessages);
		var messagesWithoutRecipients = !elm$core$List$length(numberOfMessagesWithoutRecipients);
		var numberOfMessagesWithoutText = keepIntZero(textLengthByMessages);
		var messagesWithoutText = elm$core$List$length(numberOfMessagesWithoutText) >= 0;
		var rulesResult = (messagesWithoutRecipients && messagesWithoutText) ? elm$core$Maybe$Just(_Utils_Tuple0) : elm$core$Maybe$Nothing;
		return A2(
			elm$core$Result$fromMaybe,
			author$project$Components$TicketEventNotification$EditNotification$MessageKO,
			A3(
				elm$core$Maybe$map2,
				F2(
					function (l, _n0) {
						return l;
					}),
				nonemptyListResult,
				rulesResult));
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm_community$result_extra$Result$Extra$isOk = function (x) {
		if (x.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var author$project$Components$TicketEventNotification$EditNotification$addMessageToNotification = function (model) {
		var newMessage = A2(
			elm$core$List$append,
			model.config.messages,
			_List_fromArray(
				[author$project$Components$TicketEventNotification$EditNotification$emptyMessage]));
		var config = model.config;
		var newConfig = _Utils_update(
			config,
			{
				messages: elm_community$result_extra$Result$Extra$isOk(
					author$project$Components$TicketEventNotification$EditNotification$messageAreOK(model.config.messages)) ? newMessage : model.config.messages
			});
		return _Utils_update(
			model,
			{config: newConfig});
	};
	var author$project$Components$TicketEventNotification$EditNotification$updateMessagesOfConfig = F2(
		function (config, message) {
			return _Utils_update(
				config,
				{messages: message});
		});
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var author$project$Components$TicketEventNotification$EditNotification$addRecipientMessageToNotification = F2(
		function (message, model) {
			var defineField = function (maybe) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A2(elm$core$Maybe$map, elm$core$List$singleton, maybe));
			};
			var updateField = function (message2) {
				return _Utils_eq(message2, message) ? _Utils_update(
					message2,
					{
						recipientToAdd: elm$core$Maybe$Nothing,
						recipients: A2(
							elm$core$List$append,
							message2.recipients,
							defineField(message2.recipientToAdd))
					}) : message2;
			};
			return _Utils_update(
				model,
				{
					config: A2(
						author$project$Components$TicketEventNotification$EditNotification$updateMessagesOfConfig,
						model.config,
						A2(elm$core$List$map, updateField, model.config.messages))
				});
		});
	var author$project$Components$TicketEventNotification$EditNotification$MandatoryConfigLabel = {$: 'MandatoryConfigLabel'};
	var author$project$Components$TicketEventNotification$EditNotification$NEL_Otps = {$: 'NEL_Otps'};
	var author$project$Components$TicketEventNotification$EditNotification$NEL_TrigerredEvents = {$: 'NEL_TrigerredEvents'};
	var author$project$Components$TicketEventNotification$EditNotification$ValidCommand = F5(
		function (id, label, triggerEvent, otps, messages) {
			return {id: id, label: label, messages: messages, otps: otps, triggerEvent: triggerEvent};
		});
	var author$project$Components$TicketEventNotification$EditNotification$buildValidCommand = F5(
		function (id, label, events, otps, messages) {
			return A5(author$project$Components$TicketEventNotification$EditNotification$ValidCommand, id, label, events, otps, messages);
		});
	var author$project$Components$TicketEventNotification$EditNotification$concateErrors = F3(
		function (f, r1, r2) {
			var _n0 = _Utils_Tuple2(r1, r2);
			if (_n0.a.$ === 'Ok') {
				if (_n0.b.$ === 'Ok') {
					var x = _n0.a.a;
					var y = _n0.b.a;
					return elm$core$Result$Ok(
						A2(f, x, y));
				} else {
					var e = _n0.b.a;
					return elm$core$Result$Err(
						_List_fromArray(
							[e]));
				}
			} else {
				if (_n0.b.$ === 'Ok') {
					var e = _n0.a.a;
					return elm$core$Result$Err(
						_List_fromArray(
							[e]));
				} else {
					var e1 = _n0.a.a;
					var e2 = _n0.b.a;
					return elm$core$Result$Err(
						_List_fromArray(
							[e1, e2]));
				}
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var author$project$Components$TicketEventNotification$EditNotification$concateErrors2 = F3(
		function (f, r1, r2) {
			var r2List = A2(
				elm$core$Result$mapError,
				function (e) {
					return _List_fromArray(
						[e]);
				},
				r2);
			var r3 = A3(author$project$Components$TicketEventNotification$EditNotification$concateErrors, f, r1, r2List);
			return A2(elm$core$Result$mapError, elm$core$List$concat, r3);
		});
	var inkuzmin$elm_multiselect$Multiselect$getSelectedValues = function (_n0) {
		var model = _n0.a;
		return model.selected;
	};
	var author$project$Components$TicketEventNotification$EditNotification$getMultiselectValues = function (m) {
		return A2(
			elm$core$List$map,
			elm$core$Tuple$first,
			inkuzmin$elm_multiselect$Multiselect$getSelectedValues(m));
	};
	var author$project$Components$TicketEventNotification$EditNotification$checkCommandCompletness = function (model) {
		var triggeredEventResult = A2(
			elm$core$Result$fromMaybe,
			author$project$Components$TicketEventNotification$EditNotification$NEL_TrigerredEvents,
			mgold$elm_nonempty_list$List$Nonempty$fromList(
				author$project$Components$TicketEventNotification$EditNotification$getMultiselectValues(model.multiselectTriggerEvents)));
		var otpsResult = A2(
			elm$core$Result$fromMaybe,
			author$project$Components$TicketEventNotification$EditNotification$NEL_Otps,
			mgold$elm_nonempty_list$List$Nonempty$fromList(
				author$project$Components$TicketEventNotification$EditNotification$getMultiselectValues(model.multiselectOtps)));
		var messageResult = author$project$Components$TicketEventNotification$EditNotification$messageAreOK(model.config.messages);
		var labelResult = A2(elm$core$Result$fromMaybe, author$project$Components$TicketEventNotification$EditNotification$MandatoryConfigLabel, model.config.label);
		var r = A3(
			author$project$Components$TicketEventNotification$EditNotification$concateErrors,
			author$project$Components$TicketEventNotification$EditNotification$buildValidCommand(model.config.id),
			labelResult,
			triggeredEventResult);
		var s = A3(
			author$project$Components$TicketEventNotification$EditNotification$concateErrors2,
			F2(
				function (f, o) {
					return f(o);
				}),
			r,
			otpsResult);
		var t = A3(
			author$project$Components$TicketEventNotification$EditNotification$concateErrors2,
			F2(
				function (f, m) {
					return f(m);
				}),
			s,
			messageResult);
		return t;
	};
	var author$project$Utils$String$stringToNonEmptyString = function (s) {
		if (s === '') {
			return elm$core$Maybe$Nothing;
		} else {
			return elm$core$Maybe$Just(s);
		}
	};
	var elm$json$Json$Encode$list = F2(
		function (func, entries) {
			return _Json_wrap(
				A3(
					elm$core$List$foldl,
					_Json_addEntry(func),
					_Json_emptyArray(_Utils_Tuple0),
					entries));
		});
	var elm$json$Json$Encode$object = function (pairs) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, obj) {
						var k = _n0.a;
						var v = _n0.b;
						return A3(_Json_addField, k, v, obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				pairs));
	};
	var elm$json$Json$Encode$string = _Json_wrap;
	var mgold$elm_nonempty_list$List$Nonempty$toList = function (_n0) {
		var x = _n0.a;
		var xs = _n0.b;
		return A2(elm$core$List$cons, x, xs);
	};
	var author$project$Components$TicketEventNotification$EditNotification$encode = function (data) {
		var otps = A2(
			elm$json$Json$Encode$list,
			elm$json$Json$Encode$string,
			mgold$elm_nonempty_list$List$Nonempty$toList(data.otps));
		var mapRecipient = function (r) {
			if (r.$ === 'Role') {
				var _n1 = r.a;
				var key = _n1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'recipientType',
						elm$json$Json$Encode$string('UserRoleRecipient')),
						_Utils_Tuple2(
						'role',
						elm$json$Json$Encode$string(key))
					]);
			} else {
				var e = r.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'recipientType',
						elm$json$Json$Encode$string('EmailRecipient')),
						_Utils_Tuple2(
						'email',
						elm$json$Json$Encode$string(e))
					]);
			}
		};
		var mapMessage = function (m) {
			return A2(
				elm$core$List$append,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recipients',
						A2(
							elm$json$Json$Encode$list,
							elm$json$Json$Encode$object,
							A2(elm$core$List$map, mapRecipient, m.recipients)))
					]),
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						elm$core$Maybe$map,
						function (s) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'text',
									elm$json$Json$Encode$string(s))
								]);
						},
						author$project$Utils$String$stringToNonEmptyString(m.text))));
		};
		var messages = A2(
			elm$core$List$map,
			mapMessage,
			mgold$elm_nonempty_list$List$Nonempty$toList(data.messages));
		var events = A2(
			elm$json$Json$Encode$list,
			elm$json$Json$Encode$string,
			mgold$elm_nonempty_list$List$Nonempty$toList(data.triggerEvent));
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'label',
					elm$json$Json$Encode$string(data.label)),
					_Utils_Tuple2('otps', otps),
					_Utils_Tuple2('triggerEvents', events),
					_Utils_Tuple2(
					'messages',
					A2(elm$json$Json$Encode$list, elm$json$Json$Encode$object, messages))
				]));
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm_community$list_extra$List$Extra$filterNot = F2(
		function (pred, list) {
			return A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, pred),
				list);
		});
	var author$project$Components$TicketEventNotification$EditNotification$removeMessageRecipient = F3(
		function (message, value, model) {
			var removeRecipient = function (role) {
				if (role.$ === 'Role') {
					var _n1 = role.a;
					var id = _n1.a;
					return _Utils_eq(value, id);
				} else {
					var email = role.a;
					return _Utils_eq(value, email);
				}
			};
			var updateField = function (message2) {
				return _Utils_eq(message2, message) ? _Utils_update(
					message2,
					{
						recipients: A2(elm_community$list_extra$List$Extra$filterNot, removeRecipient, message2.recipients)
					}) : message2;
			};
			return _Utils_update(
				model,
				{
					config: A2(
						author$project$Components$TicketEventNotification$EditNotification$updateMessagesOfConfig,
						model.config,
						A2(elm$core$List$map, updateField, model.config.messages))
				});
		});
	var author$project$Components$TicketEventNotification$NotificationData$Email = function (a) {
		return {$: 'Email', a: a};
	};
	var author$project$Components$TicketEventNotification$EditNotification$setMailRecipientMessageToNotification = F3(
		function (message, value, model) {
			var updateField = function (message2) {
				return _Utils_eq(message2, message) ? _Utils_update(
					message2,
					{
						recipientToAdd: elm$core$Maybe$Just(
							author$project$Components$TicketEventNotification$NotificationData$Email(value))
					}) : message2;
			};
			return _Utils_update(
				model,
				{
					config: A2(
						author$project$Components$TicketEventNotification$EditNotification$updateMessagesOfConfig,
						model.config,
						A2(elm$core$List$map, updateField, model.config.messages))
				});
		});
	var author$project$Components$TicketEventNotification$NotificationData$Role = function (a) {
		return {$: 'Role', a: a};
	};
	var author$project$Components$TicketEventNotification$NotificationData$roles = _List_fromArray(
		[
			_Utils_Tuple2('CallCenterOperatorRole', 'Conseiller de centre d’appel'),
			_Utils_Tuple2('ClientAccountManagerRole', 'Administrateur'),
			_Utils_Tuple2('ExecutiveRole', 'Cadre'),
			_Utils_Tuple2('PatrimonyManagerRole', 'Gestionnaire'),
			_Utils_Tuple2('PatrimonyCareTakerRole', 'Gardien / responsable de site'),
			_Utils_Tuple2('PatrimonyHomeOwnerAssociationPresidentRole', 'Président de conseil syndical'),
			_Utils_Tuple2('PatrimonyHomeOwnerAssociationMemberRole', 'Membre de conseil syndical'),
			_Utils_Tuple2('LotOwnerRole', 'Propriétaire'),
			_Utils_Tuple2('LotLandlordRole', 'Propriétaire bailleur'),
			_Utils_Tuple2('LotTenantRole', 'Locataire'),
			_Utils_Tuple2('ProviderUserRole', 'Intervenant')
		]);
	var author$project$Components$TicketEventNotification$EditNotification$setRoleRecipientMessageToNotification = F3(
		function (message, value, model) {
			var getRoleById = function (id) {
				return A2(
					elm$core$Maybe$map,
					author$project$Components$TicketEventNotification$NotificationData$Role,
					A2(
						elm_community$list_extra$List$Extra$find,
						function (_n0) {
							var code = _n0.a;
							return _Utils_eq(code, id);
						},
						author$project$Components$TicketEventNotification$NotificationData$roles));
			};
			var updateField = function (message2) {
				return _Utils_eq(message2, message) ? _Utils_update(
					message2,
					{
						recipientToAdd: getRoleById(value)
					}) : message2;
			};
			return _Utils_update(
				model,
				{
					config: A2(
						author$project$Components$TicketEventNotification$EditNotification$updateMessagesOfConfig,
						model.config,
						A2(elm$core$List$map, updateField, model.config.messages))
				});
		});
	var author$project$Components$TicketEventNotification$EditNotification$setTextMessageToNotification = F3(
		function (message, value, model) {
			var updateField = function (message2) {
				return _Utils_eq(message2, message) ? _Utils_update(
					message2,
					{text: value}) : message2;
			};
			return _Utils_update(
				model,
				{
					config: A2(
						author$project$Components$TicketEventNotification$EditNotification$updateMessagesOfConfig,
						model.config,
						A2(elm$core$List$map, updateField, model.config.messages))
				});
		});
	var author$project$Utils$Http$HttpRequest$Post = F3(
		function (a, b, c) {
			return {$: 'Post', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$Put = F3(
		function (a, b, c) {
			return {$: 'Put', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$BodyResponse = F2(
		function (a, b) {
			return {$: 'BodyResponse', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$DomainError = function (a) {
		return {$: 'DomainError', a: a};
	};
	var author$project$Utils$Http$HttpRequest$TechnicalError = function (a) {
		return {$: 'TechnicalError', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var author$project$Utils$Http$HttpRequest$expectWhateverOkResult = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				function (response) {
					switch (response.$) {
						case 'BadUrl_':
							var url = response.a;
							return elm$core$Result$Err(
								author$project$Utils$Http$HttpRequest$TechnicalError('Http.BadUrl' + url));
						case 'Timeout_':
							return elm$core$Result$Err(
								author$project$Utils$Http$HttpRequest$TechnicalError('Http.Timeout'));
						case 'NetworkError_':
							return elm$core$Result$Err(
								author$project$Utils$Http$HttpRequest$TechnicalError('Http.NetworkError'));
						case 'BadStatus_':
							var metadata = response.a;
							var body = response.b;
							var result = function () {
								var _n1 = A2(elm$json$Json$Decode$decodeString, decoder, body);
								if (_n1.$ === 'Ok') {
									var value = _n1.a;
									return author$project$Utils$Http$HttpRequest$DomainError(
										A2(author$project$Utils$Http$HttpRequest$BodyResponse, metadata, value));
								} else {
									return author$project$Utils$Http$HttpRequest$TechnicalError('json parsing error');
								}
							}();
							return elm$core$Result$Err(result);
						default:
							var metadata = response.a;
							return elm$core$Result$Ok(
								A2(author$project$Utils$Http$HttpRequest$BodyResponse, metadata, _Utils_Tuple0));
					}
				});
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var elm$http$Http$jsonBody = function (value) {
		return A2(
			_Http_pair,
			'application/json',
			A2(elm$json$Json$Encode$encode, 0, value));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$core$String$toInt = _String_toInt;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$Dom$focus = _Browser_call('focus');
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Task$onError = _Scheduler_onError;
	var elm$core$Task$attempt = F2(
		function (resultToMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(
						elm$core$Task$onError,
						A2(
							elm$core$Basics$composeL,
							A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
							elm$core$Result$Err),
						A2(
							elm$core$Task$andThen,
							A2(
								elm$core$Basics$composeL,
								A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
								elm$core$Result$Ok),
							task))));
		});
	var inkuzmin$elm_multiselect$Multiselect$Cleared = {$: 'Cleared'};
	var inkuzmin$elm_multiselect$Multiselect$DisableProtection = {$: 'DisableProtection'};
	var inkuzmin$elm_multiselect$Multiselect$FocusResult = function (a) {
		return {$: 'FocusResult', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Opened = {$: 'Opened'};
	var inkuzmin$elm_multiselect$Multiselect$ScrollResult = function (a) {
		return {$: 'ScrollResult', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$ScrollY = function (a) {
		return {$: 'ScrollY', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Selected = function (a) {
		return {$: 'Selected', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Unselected = function (a) {
		return {$: 'Unselected', a: a};
	};
	var elm$core$Process$sleep = _Process_sleep;
	var inkuzmin$elm_multiselect$Multiselect$delayInMs = F2(
		function (ms, msg) {
			return A2(
				elm$core$Task$perform,
				function (_n0) {
					return msg;
				},
				elm$core$Process$sleep(ms));
		});
	var elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
	var elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
	var inkuzmin$elm_multiselect$Multiselect$domScrollToY = F2(
		function (id, y) {
			return A2(
				elm$core$Task$andThen,
				function (vp) {
					return A3(elm$browser$Browser$Dom$setViewportOf, id, vp.viewport.x, y);
				},
				elm$browser$Browser$Dom$getViewportOf(id));
		});
	var inkuzmin$elm_multiselect$Multiselect$domScrollY = function (id) {
		return A2(
			elm$core$Task$map,
			function (vp) {
				return vp.viewport.y;
			},
			elm$browser$Browser$Dom$getViewportOf(id));
	};
	var inkuzmin$elm_multiselect$Multiselect$fitViewPort = F2(
		function (_n0, _n1) {
			var top = _n0.a;
			var bottom = _n0.b;
			var vpTop = _n1.a;
			var vpBottom = _n1.b;
			return (_Utils_cmp(top, vpTop) < 0) ? top : ((_Utils_cmp(bottom, vpBottom) > 0) ? (vpTop + (bottom - vpBottom)) : vpTop);
		});
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight = 32;
	var inkuzmin$elm_multiselect$Multiselect$getBoundaries = function (i) {
		return _Utils_Tuple2(i * inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight, (i * inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight) + inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight);
	};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight = 200;
	var inkuzmin$elm_multiselect$Multiselect$getViewPortBoundaries = function (i) {
		return _Utils_Tuple2(i, i + inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight);
	};
	var inkuzmin$elm_multiselect$Multiselect$indexOf = F2(
		function (el, list) {
			var helper = F2(
				function (l, index) {
					helper:
					while (true) {
						if (!l.b) {
							return elm$core$Maybe$Nothing;
						} else {
							var x = l.a;
							var xs = l.b;
							if (_Utils_eq(x, el)) {
								return elm$core$Maybe$Just(index);
							} else {
								var $temp$l = xs,
									$temp$index = index + 1;
								l = $temp$l;
								index = $temp$index;
								continue helper;
							}
						}
					}
				});
			return A2(helper, list, 0);
		});
	var inkuzmin$elm_multiselect$Multiselect$lastElem = A2(
		elm$core$List$foldl,
		A2(elm$core$Basics$composeR, elm$core$Maybe$Just, elm$core$Basics$always),
		elm$core$Maybe$Nothing);
	var inkuzmin$elm_multiselect$Multiselect$nextItem = F2(
		function (list, item) {
			var findNextInList = function (l) {
				findNextInList:
				while (true) {
					if (!l.b) {
						return elm$core$Maybe$Nothing;
					} else {
						if (!l.b.b) {
							var x = l.a;
							return _Utils_eq(x, item) ? elm$core$List$head(list) : elm$core$Maybe$Nothing;
						} else {
							var x = l.a;
							var _n1 = l.b;
							var y = _n1.a;
							var rest = _n1.b;
							if (_Utils_eq(x, item)) {
								return elm$core$Maybe$Just(y);
							} else {
								var $temp$l = A2(elm$core$List$cons, y, rest);
								l = $temp$l;
								continue findNextInList;
							}
						}
					}
				}
			};
			return findNextInList(list);
		});
	var inkuzmin$elm_multiselect$Multiselect$nextSelectedItem = F2(
		function (list, item) {
			var takeLast = function (l) {
				if (!l.b) {
					return elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						return elm$core$Maybe$Nothing;
					} else {
						var _n3 = l.b;
						var y = _n3.a;
						return elm$core$Maybe$Just(y);
					}
				}
			};
			var findNextInList = function (l) {
				findNextInList:
				while (true) {
					if (!l.b) {
						return elm$core$Maybe$Nothing;
					} else {
						if (!l.b.b) {
							var x = l.a;
							return _Utils_eq(x, item) ? takeLast(
								elm$core$List$reverse(list)) : elm$core$Maybe$Nothing;
						} else {
							var x = l.a;
							var _n1 = l.b;
							var y = _n1.a;
							var rest = _n1.b;
							if (_Utils_eq(x, item)) {
								return elm$core$Maybe$Just(y);
							} else {
								var $temp$l = A2(elm$core$List$cons, y, rest);
								l = $temp$l;
								continue findNextInList;
							}
						}
					}
				}
			};
			return findNextInList(list);
		});
	var inkuzmin$elm_multiselect$Multiselect$prevItem = F2(
		function (list, item) {
			return A2(
				inkuzmin$elm_multiselect$Multiselect$nextItem,
				elm$core$List$reverse(list),
				item);
		});
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$backspace = 8;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow = 40;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$end = 35;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$escape = 27;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$home = 36;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$pageDown = 34;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$pageUp = 33;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$return = 13;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$tab = 9;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow = 38;
	var inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter = '\u200c\u200c';
	var inkuzmin$elm_multiselect$Multiselect$update = F2(
		function (msg, _n0) {
			var model = _n0.a;
			switch (msg.$) {
				case 'Start':
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(model),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'Toggle':
					return _Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Opened) ? _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{status: inkuzmin$elm_multiselect$Multiselect$Closed})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
								])),
						elm$core$Maybe$Nothing) : _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{status: inkuzmin$elm_multiselect$Multiselect$Opened})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
								])),
						elm$core$Maybe$Nothing);
				case 'Click':
					return model._protected ? _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{_protected: false})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing) : _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{status: inkuzmin$elm_multiselect$Multiselect$Closed})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'DisableProtection':
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{_protected: false})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'ClickOnComponent':
					return model._protected ? _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(model),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing) : _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{_protected: true, status: inkuzmin$elm_multiselect$Multiselect$Opened})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag)),
									A2(inkuzmin$elm_multiselect$Multiselect$delayInMs, 100, inkuzmin$elm_multiselect$Multiselect$DisableProtection)
								])),
						elm$core$Maybe$Nothing);
				case 'ScrollResult':
					var result = msg.a;
					if (result.$ === 'Err') {
						var id = result.a.a;
						return _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{
										error: elm$core$Maybe$Just('Could not find dom id: ' + id)
									})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					} else {
						return _Utils_eq(model.input, inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{input: ''})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing) : _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{error: elm$core$Maybe$Nothing})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					}
				case 'FocusResult':
					var result = msg.a;
					if (result.$ === 'Err') {
						var id = result.a.a;
						return _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{
										error: elm$core$Maybe$Just('Could not find dom id: ' + id)
									})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					} else {
						return _Utils_eq(model.input, inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{input: ''})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing) : _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{error: elm$core$Maybe$Nothing})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					}
				case 'Adjust':
					var value = msg.a;
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{inputWidth: value})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'Filter':
					var value = msg.a;
					var filtered = A2(
						inkuzmin$elm_multiselect$Multiselect$filter,
						model.selected,
						A2(
							elm$core$List$filter,
							function (_n5) {
								var val = _n5.b;
								return A2(
									elm$core$String$contains,
									elm$core$String$toLower(value),
									elm$core$String$toLower(val));
							},
							model.values));
					if (model._protected) {
						return _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{_protected: false})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					} else {
						var _n4 = model.hovered;
						if (_n4.$ === 'Nothing') {
							return _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{
											filtered: filtered,
											hovered: elm$core$List$head(filtered),
											input: value,
											status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
										})),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing);
						} else {
							var item = _n4.a;
							return (!elm$core$List$length(
								A2(
									elm$core$List$filter,
									function (i) {
										return _Utils_eq(i, item);
									},
									filtered))) ? _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{
											filtered: filtered,
											hovered: elm$core$List$head(filtered),
											input: value,
											status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
										})),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing) : _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{
											filtered: filtered,
											input: value,
											status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
										})),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing);
						}
					}
				case 'OnSelect':
					var item = msg.a;
					var selected = _Utils_ap(
						model.selected,
						_List_fromArray(
							[item]));
					var filtered = A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values);
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{
									filtered: filtered,
									hovered: A2(inkuzmin$elm_multiselect$Multiselect$nextSelectedItem, model.filtered, item),
									input: inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
									selected: selected,
									status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
								})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
								])),
						elm$core$Maybe$Just(
							inkuzmin$elm_multiselect$Multiselect$Selected(item)));
				case 'RemoveItem':
					var item = msg.a;
					var selected = A2(
						elm$core$List$filter,
						function (value) {
							return !_Utils_eq(value, item);
						},
						model.selected);
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{
									filtered: A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values),
									hovered: elm$core$Maybe$Just(item),
									selected: selected
								})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$ScrollY,
									inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
								])),
						elm$core$Maybe$Just(
							inkuzmin$elm_multiselect$Multiselect$Unselected(item)));
				case 'Clear':
					var selected = _List_Nil;
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{
									filtered: A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values),
									input: inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
									selected: selected,
									status: inkuzmin$elm_multiselect$Multiselect$Closed
								})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
								])),
						elm$core$Maybe$Just(inkuzmin$elm_multiselect$Multiselect$Cleared));
				case 'OnHover':
					var item = msg.a;
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{
									hovered: elm$core$Maybe$Just(item)
								})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'ScrollY':
					var result = msg.a;
					if (result.$ === 'Err') {
						var id = result.a.a;
						return _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{
										error: elm$core$Maybe$Just('Could not find dom id: ' + id)
									})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					} else {
						var y = result.a;
						var _n7 = model.hovered;
						if (_n7.$ === 'Nothing') {
							return _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(model),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing);
						} else {
							var item = _n7.a;
							var _n8 = A2(inkuzmin$elm_multiselect$Multiselect$indexOf, item, model.filtered);
							if (_n8.$ === 'Nothing') {
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(model),
									elm$core$Platform$Cmd$none,
									elm$core$Maybe$Nothing);
							} else {
								var idx = _n8.a;
								var vpBoundaries = inkuzmin$elm_multiselect$Multiselect$getViewPortBoundaries(y);
								var boundaries = inkuzmin$elm_multiselect$Multiselect$getBoundaries(idx);
								var scroll = A2(inkuzmin$elm_multiselect$Multiselect$fitViewPort, boundaries, vpBoundaries);
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(
										_Utils_update(
											model,
											{error: elm$core$Maybe$Nothing})),
									elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												elm$core$Task$attempt,
												inkuzmin$elm_multiselect$Multiselect$ScrollResult,
												A2(inkuzmin$elm_multiselect$Multiselect$domScrollToY, 'multiselectMenu' + model.tag, scroll))
											])),
									elm$core$Maybe$Nothing);
							}
						}
					}
				default:
					var key = msg.a;
					if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow)) {
						var _n9 = model.hovered;
						if (_n9.$ === 'Nothing') {
							return _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{
											hovered: elm$core$List$head(model.filtered)
										})),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing);
						} else {
							var item = _n9.a;
							var prev = A2(inkuzmin$elm_multiselect$Multiselect$prevItem, model.filtered, item);
							return _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{hovered: prev})),
								elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											elm$core$Task$attempt,
											inkuzmin$elm_multiselect$Multiselect$ScrollY,
											inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
										])),
								elm$core$Maybe$Nothing);
						}
					} else {
						if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow)) {
							var _n10 = model.hovered;
							if (_n10.$ === 'Nothing') {
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(
										_Utils_update(
											model,
											{
												hovered: elm$core$List$head(model.filtered)
											})),
									elm$core$Platform$Cmd$none,
									elm$core$Maybe$Nothing);
							} else {
								var item = _n10.a;
								var next = A2(inkuzmin$elm_multiselect$Multiselect$nextItem, model.filtered, item);
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(
										_Utils_update(
											model,
											{hovered: next})),
									elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												elm$core$Task$attempt,
												inkuzmin$elm_multiselect$Multiselect$ScrollY,
												inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
											])),
									elm$core$Maybe$Nothing);
							}
						} else {
							if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$pageUp) || _Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$home)) {
								var first = elm$core$List$head(model.filtered);
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(
										_Utils_update(
											model,
											{hovered: first})),
									elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												elm$core$Task$attempt,
												inkuzmin$elm_multiselect$Multiselect$ScrollY,
												inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
											])),
									elm$core$Maybe$Nothing);
							} else {
								if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$pageDown) || _Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$end)) {
									var last = inkuzmin$elm_multiselect$Multiselect$lastElem(model.filtered);
									return _Utils_Tuple3(
										inkuzmin$elm_multiselect$Multiselect$Model(
											_Utils_update(
												model,
												{hovered: last})),
										elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													A2(
													elm$core$Task$attempt,
													inkuzmin$elm_multiselect$Multiselect$ScrollY,
													inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
												])),
										elm$core$Maybe$Nothing);
								} else {
									if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$return)) {
										var _n11 = model.hovered;
										if (_n11.$ === 'Nothing') {
											var isInvisible = _Utils_eq(model.input, inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter);
											var isEmpty = elm$core$String$isEmpty(model.input);
											return (isInvisible || isEmpty) ? _Utils_Tuple3(
												inkuzmin$elm_multiselect$Multiselect$Model(model),
												elm$core$Platform$Cmd$none,
												elm$core$Maybe$Nothing) : _Utils_Tuple3(
												inkuzmin$elm_multiselect$Multiselect$Model(model),
												elm$core$Platform$Cmd$none,
												elm$core$Maybe$Just(
													inkuzmin$elm_multiselect$Multiselect$NotFound(model.input)));
										} else {
											var item = _n11.a;
											var selected = _Utils_ap(
												model.selected,
												_List_fromArray(
													[item]));
											var filtered = A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values);
											return _Utils_Tuple3(
												inkuzmin$elm_multiselect$Multiselect$Model(
													_Utils_update(
														model,
														{
															filtered: filtered,
															hovered: A2(inkuzmin$elm_multiselect$Multiselect$nextSelectedItem, model.filtered, item),
															input: inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
															selected: selected,
															status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
														})),
												elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2(
															elm$core$Task$attempt,
															inkuzmin$elm_multiselect$Multiselect$FocusResult,
															elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
														])),
												elm$core$Maybe$Just(
													inkuzmin$elm_multiselect$Multiselect$Selected(item)));
										}
									} else {
										if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$escape)) {
											return _Utils_Tuple3(
												inkuzmin$elm_multiselect$Multiselect$Model(
													_Utils_update(
														model,
														{_protected: true, status: inkuzmin$elm_multiselect$Multiselect$Closed})),
												elm$core$Platform$Cmd$none,
												elm$core$Maybe$Nothing);
										} else {
											if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$tab)) {
												return _Utils_Tuple3(
													inkuzmin$elm_multiselect$Multiselect$Model(
														_Utils_update(
															model,
															{status: inkuzmin$elm_multiselect$Multiselect$Closed})),
													elm$core$Platform$Cmd$none,
													elm$core$Maybe$Nothing);
											} else {
												if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$backspace)) {
													if (model.input === '') {
														var _n12 = inkuzmin$elm_multiselect$Multiselect$lastElem(model.selected);
														if (_n12.$ === 'Nothing') {
															return _Utils_Tuple3(
																inkuzmin$elm_multiselect$Multiselect$Model(model),
																elm$core$Platform$Cmd$none,
																elm$core$Maybe$Nothing);
														} else {
															var item = _n12.a;
															var selected = A2(
																elm$core$List$filter,
																function (value) {
																	return !_Utils_eq(value, item);
																},
																model.selected);
															return _Utils_Tuple3(
																inkuzmin$elm_multiselect$Multiselect$Model(
																	_Utils_update(
																		model,
																		{
																			filtered: A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values),
																			hovered: elm$core$Maybe$Just(item),
																			selected: selected
																		})),
																elm$core$Platform$Cmd$batch(
																	_List_fromArray(
																		[
																			A2(
																			elm$core$Task$attempt,
																			inkuzmin$elm_multiselect$Multiselect$ScrollY,
																			inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
																		])),
																elm$core$Maybe$Just(
																	inkuzmin$elm_multiselect$Multiselect$Unselected(item)));
														}
													} else {
														return _Utils_Tuple3(
															inkuzmin$elm_multiselect$Multiselect$Model(model),
															elm$core$Platform$Cmd$none,
															elm$core$Maybe$Nothing);
													}
												} else {
													return _Utils_Tuple3(
														inkuzmin$elm_multiselect$Multiselect$Model(model),
														elm$core$Platform$Cmd$none,
														elm$core$Maybe$Nothing);
												}
											}
										}
									}
								}
							}
						}
					}
			}
		});
	var author$project$Components$TicketEventNotification$EditNotification$update = F3(
		function (apiList, msg, model) {
			switch (msg.$) {
				case 'RemoveMessageNotification':
					var m = msg.a;
					var newMessage = A2(
						elm_community$list_extra$List$Extra$filterNot,
						elm$core$Basics$eq(m),
						model.config.messages);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								config: A2(author$project$Components$TicketEventNotification$EditNotification$updateMessagesOfConfig, model.config, newMessage)
							}),
						elm$core$Platform$Cmd$none);
				case 'MessageTextChange':
					var m = msg.a;
					var s = msg.b;
					return _Utils_Tuple2(
						A3(author$project$Components$TicketEventNotification$EditNotification$setTextMessageToNotification, m, s, model),
						elm$core$Platform$Cmd$none);
				case 'ChangeMailRecipient':
					var m = msg.a;
					var s = msg.b;
					return _Utils_Tuple2(
						A3(author$project$Components$TicketEventNotification$EditNotification$setMailRecipientMessageToNotification, m, s, model),
						elm$core$Platform$Cmd$none);
				case 'AddRecipient':
					var m = msg.a;
					return _Utils_Tuple2(
						A2(author$project$Components$TicketEventNotification$EditNotification$addRecipientMessageToNotification, m, model),
						elm$core$Platform$Cmd$none);
				case 'SelectRoleRecipient':
					var m = msg.a;
					var s = msg.b;
					return _Utils_Tuple2(
						A3(author$project$Components$TicketEventNotification$EditNotification$setRoleRecipientMessageToNotification, m, s, model),
						elm$core$Platform$Cmd$none);
				case 'RemoveRecipient':
					var m = msg.a;
					var s = msg.b;
					return _Utils_Tuple2(
						A3(author$project$Components$TicketEventNotification$EditNotification$removeMessageRecipient, m, s, model),
						elm$core$Platform$Cmd$none);
				case 'TriggerEventMultiselect':
					var subMsg = msg.a;
					var _n1 = A2(inkuzmin$elm_multiselect$Multiselect$update, subMsg, model.multiselectTriggerEvents);
					var msModel = _n1.a;
					var msCmd = _n1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{multiselectTriggerEvents: msModel}),
						A2(elm$core$Platform$Cmd$map, author$project$Components$TicketEventNotification$EditNotification$TriggerEventMultiselect, msCmd));
				case 'OtpsMultiselect':
					var subMsg = msg.a;
					var _n2 = A2(inkuzmin$elm_multiselect$Multiselect$update, subMsg, model.multiselectOtps);
					var msModel = _n2.a;
					var msCmd = _n2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{multiselectOtps: msModel}),
						A2(elm$core$Platform$Cmd$map, author$project$Components$TicketEventNotification$EditNotification$OtpsMultiselect, msCmd));
				case 'AddMessageNotification':
					return _Utils_Tuple2(
						author$project$Components$TicketEventNotification$EditNotification$addMessageToNotification(model),
						elm$core$Platform$Cmd$none);
				case 'AddNotification':
					var queryUpdate = function (id) {
						return author$project$Utils$Http$HttpRequest$Put(apiList + ('/' + id));
					};
					var queryCreate = author$project$Utils$Http$HttpRequest$Post(apiList);
					var query = A2(
						elm$core$Maybe$withDefault,
						queryCreate,
						A2(elm$core$Maybe$map, queryUpdate, model.config.id));
					var checkCmdResult = author$project$Components$TicketEventNotification$EditNotification$checkCommandCompletness(model);
					var body = A2(
						elm$core$Result$map,
						A2(elm$core$Basics$composeR, author$project$Components$TicketEventNotification$EditNotification$encode, elm$http$Http$jsonBody),
						checkCmdResult);
					var request = A2(
						elm$core$Result$map,
						function (b) {
							return author$project$Utils$Http$HttpRequest$withAuthReq(
								A2(
									query,
									b,
									A2(author$project$Utils$Http$HttpRequest$expectWhateverOkResult, author$project$Components$TicketEventNotification$EditNotification$NotificationAddResult, author$project$Binding$TicketEventNotificationAPIErrorDecoder$ticketEventNotificationAPIErrorDecoder)));
						},
						body);
					var result = function () {
						if (request.$ === 'Ok') {
							var req = request.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{formErrors: _List_Nil}),
								req);
						} else {
							var errors = request.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{formErrors: errors}),
								elm$core$Platform$Cmd$none);
						}
					}();
					return result;
				case 'NotificationAddResult':
					var r = msg.a;
					var error = function () {
						if (r.$ === 'Ok') {
							return elm$core$Maybe$Nothing;
						} else {
							var e = r.a;
							return elm$core$Maybe$Just(e);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{apiError: error}),
						A2(
							elm$core$Result$withDefault,
							elm$core$Platform$Cmd$none,
							A2(
								elm$core$Result$map,
								elm$core$Basics$always(
									author$project$Utils$Command$msgToElmCmd(author$project$Components$TicketEventNotification$EditNotification$NotificationAdded)),
								r)));
				case 'NotificationAdded':
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				default:
					var label = msg.a;
					var config = model.config;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								config: _Utils_update(
									config,
									{
										label: author$project$Utils$String$stringToNonEmptyString(label)
									})
							}),
						elm$core$Platform$Cmd$none);
			}
		});
	var author$project$Components$TicketEventNotification$ListNotifications$isEdit = function (msg) {
		if (msg.$ === 'EditNotification') {
			var notification = msg.a;
			return elm$core$Maybe$Just(notification);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var author$project$Binding$ResultDecoder$resultsDecoder = function (listDecoder) {
		return A2(
			elm$json$Json$Decode$map,
			function (x) {
				return x.result;
			},
			author$project$Binding$ResultDecoder$resultDecoder(listDecoder));
	};
	var author$project$Binding$TicketEventNotificationConfigDecoder$TicketEventNotification = F2(
		function (uid, config) {
			return {config: config, uid: uid};
		});
	var author$project$Binding$TicketEventNotificationConfigDecoder$TicketEventNotificationConfig = F4(
		function (label, triggerEvents, otps, messages) {
			return {label: label, messages: messages, otps: otps, triggerEvents: triggerEvents};
		});
	var author$project$Binding$TicketEventNotificationConfigDecoder$NotificationMessage = F2(
		function (text, recipients) {
			return {recipients: recipients, text: text};
		});
	var author$project$Binding$TicketEventNotificationConfigDecoder$Recipient = F3(
		function (email, recipientType, role) {
			return {email: email, recipientType: recipientType, role: role};
		});
	var author$project$Binding$TicketEventNotificationConfigDecoder$recipientDecoder = A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'role',
		elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
		elm$core$Maybe$Nothing,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'recipientType',
			elm$json$Json$Decode$string,
			A4(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'email',
				elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
				elm$core$Maybe$Nothing,
				elm$json$Json$Decode$succeed(author$project$Binding$TicketEventNotificationConfigDecoder$Recipient))));
	var author$project$Binding$TicketEventNotificationConfigDecoder$ticketEventMessage = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recipients',
		elm$json$Json$Decode$list(author$project$Binding$TicketEventNotificationConfigDecoder$recipientDecoder),
		A4(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'text',
			elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
			elm$core$Maybe$Nothing,
			elm$json$Json$Decode$succeed(author$project$Binding$TicketEventNotificationConfigDecoder$NotificationMessage)));
	var author$project$Binding$TicketEventNotificationConfigDecoder$ticketEventNotificationConfigDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'messages',
		elm$json$Json$Decode$list(author$project$Binding$TicketEventNotificationConfigDecoder$ticketEventMessage),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'otps',
			elm$json$Json$Decode$list(elm$json$Json$Decode$string),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'triggerEvents',
				elm$json$Json$Decode$list(elm$json$Json$Decode$string),
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'label',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Binding$TicketEventNotificationConfigDecoder$TicketEventNotificationConfig)))));
	var author$project$Components$TicketEventNotification$NotificationData$toRole = function (id) {
		return A2(
			elm$core$Maybe$map,
			author$project$Components$TicketEventNotification$NotificationData$Role,
			A2(
				elm_community$list_extra$List$Extra$find,
				function (r) {
					return _Utils_eq(r.a, id);
				},
				author$project$Components$TicketEventNotification$NotificationData$roles));
	};
	var ccapndave$elm_flat_map$Maybe$FlatMap$join = function (mx) {
		if (mx.$ === 'Just') {
			var x = mx.a;
			return x;
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var ccapndave$elm_flat_map$Maybe$FlatMap$flatMap = F2(
		function (f, maybe) {
			return ccapndave$elm_flat_map$Maybe$FlatMap$join(
				A2(elm$core$Maybe$map, f, maybe));
		});
	var elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
		if (m.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var x = m.a;
			return _List_fromArray(
				[x]);
		}
	};
	var author$project$Binding$TicketEventNotificationConfigDecoder$toModelRecipient = function (x) {
		var r = function () {
			var _n0 = x.recipientType;
			switch (_n0) {
				case 'UserRoleRecipient':
					return A2(ccapndave$elm_flat_map$Maybe$FlatMap$flatMap, author$project$Components$TicketEventNotification$NotificationData$toRole, x.role);
				case 'EmailRecipient':
					return A2(elm$core$Maybe$map, author$project$Components$TicketEventNotification$NotificationData$Email, x.email);
				default:
					return elm$core$Maybe$Nothing;
			}
		}();
		return elm_community$maybe_extra$Maybe$Extra$toList(r);
	};
	var ccapndave$elm_flat_map$List$FlatMap$join = A2(elm$core$List$foldr, elm$core$Basics$append, _List_Nil);
	var ccapndave$elm_flat_map$List$FlatMap$flatMap = F2(
		function (f, list) {
			return ccapndave$elm_flat_map$List$FlatMap$join(
				A2(elm$core$List$map, f, list));
		});
	var author$project$Binding$TicketEventNotificationConfigDecoder$toModelMessage = function (x) {
		return A3(
			author$project$Components$TicketEventNotification$EditNotification$NotificationMessage,
			A2(elm$core$Maybe$withDefault, '', x.text),
			A2(ccapndave$elm_flat_map$List$FlatMap$flatMap, author$project$Binding$TicketEventNotificationConfigDecoder$toModelRecipient, x.recipients),
			elm$core$Maybe$Nothing);
	};
	var author$project$Binding$TicketEventNotificationConfigDecoder$toModel = function (x) {
		return A5(
			author$project$Components$TicketEventNotification$EditNotification$TicketEventNotificationConfig,
			elm$core$Maybe$Just(x.uid),
			elm$core$Maybe$Just(x.config.label),
			x.config.triggerEvents,
			x.config.otps,
			A2(elm$core$List$map, author$project$Binding$TicketEventNotificationConfigDecoder$toModelMessage, x.config.messages));
	};
	var author$project$Binding$TicketEventNotificationConfigDecoder$ticketEventNotificationDecoder = A2(
		elm$json$Json$Decode$map,
		author$project$Binding$TicketEventNotificationConfigDecoder$toModel,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'config',
			author$project$Binding$TicketEventNotificationConfigDecoder$ticketEventNotificationConfigDecoder,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$TicketEventNotificationConfigDecoder$TicketEventNotification))));
	var author$project$Binding$TicketEventNotificationConfigDecoder$listTicketEventNotificationConfigDecoder = author$project$Binding$ResultDecoder$resultsDecoder(
		elm$json$Json$Decode$list(author$project$Binding$TicketEventNotificationConfigDecoder$ticketEventNotificationDecoder));
	var author$project$Components$TicketEventNotification$ListNotifications$ListNotificationsFetched = function (a) {
		return {$: 'ListNotificationsFetched', a: a};
	};
	var author$project$Components$TicketEventNotification$ListNotifications$NotifcationRemoved = function (a) {
		return {$: 'NotifcationRemoved', a: a};
	};
	var author$project$Utils$Http$HttpRequest$Delete = F2(
		function (a, b) {
			return {$: 'Delete', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm$http$Http$expectBytesResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'arraybuffer',
				_Http_toDataView,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$expectWhatever = function (toMsg) {
		return A2(
			elm$http$Http$expectBytesResponse,
			toMsg,
			elm$http$Http$resolve(
				function (_n0) {
					return elm$core$Result$Ok(_Utils_Tuple0);
				}));
	};
	var author$project$Components$TicketEventNotification$ListNotifications$update = F3(
		function (listUrl, msg, model) {
			switch (msg.$) {
				case 'FetchListNotifications':
					var cmd = author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							listUrl,
							A2(elm$http$Http$expectJson, author$project$Components$TicketEventNotification$ListNotifications$ListNotificationsFetched, author$project$Binding$TicketEventNotificationConfigDecoder$listTicketEventNotificationConfigDecoder)));
					return _Utils_Tuple2(model, cmd);
				case 'ListNotificationsFetched':
					var result = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								notification: A2(elm$core$Result$withDefault, _List_Nil, result)
							}),
						elm$core$Platform$Cmd$none);
				case 'EditNotification':
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				case 'NotificationOverview':
					var notification = msg.a;
					var newNewCurrentNotification = function () {
						var _n1 = model.currentNotification;
						if (_n1.$ === 'Just') {
							var n = _n1.a;
							return _Utils_eq(n, notification) ? elm$core$Maybe$Nothing : elm$core$Maybe$Just(notification);
						} else {
							return elm$core$Maybe$Just(notification);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{currentNotification: newNewCurrentNotification}),
						elm$core$Platform$Cmd$none);
				case 'RemoveNotification':
					var id = msg.a;
					return _Utils_Tuple2(
						model,
						author$project$Utils$Http$HttpRequest$withAuthReq(
							A2(
								author$project$Utils$Http$HttpRequest$Delete,
								listUrl + ('/' + id),
								elm$http$Http$expectWhatever(author$project$Components$TicketEventNotification$ListNotifications$NotifcationRemoved))));
				default:
					return _Utils_Tuple2(
						model,
						author$project$Utils$Command$msgToElmCmd(author$project$Components$TicketEventNotification$ListNotifications$FetchListNotifications));
			}
		});
	var author$project$Main$EditNotificationMsg = function (a) {
		return {$: 'EditNotificationMsg', a: a};
	};
	var author$project$Main$NotificationAdded = {$: 'NotificationAdded'};
	var elm$core$Result$toMaybe = function (result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return elm$core$Maybe$Just(v);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var author$project$Main$update = F2(
		function (action, model) {
			switch (action.$) {
				case 'ListNotificationMsg':
					var msg = action.a;
					var notificationModel = A2(
						elm$core$Maybe$map,
						author$project$Components$TicketEventNotification$EditNotification$buildModelFromConfig(model.otpsRef),
						author$project$Components$TicketEventNotification$ListNotifications$isEdit(msg));
					var _n1 = A3(author$project$Components$TicketEventNotification$ListNotifications$update, model.flags.listUrl, msg, model.list);
					var subModel = _n1.a;
					var subCmd = _n1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{list: subModel, notification: notificationModel}),
						A2(elm$core$Platform$Cmd$map, author$project$Main$ListNotificationMsg, subCmd));
				case 'ShowAddView':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								notification: elm$core$Maybe$Just(
									author$project$Components$TicketEventNotification$EditNotification$init(model.otpsRef))
							}),
						elm$core$Platform$Cmd$none);
				case 'NotificationAdded':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{notification: elm$core$Maybe$Nothing}),
						A2(elm$core$Platform$Cmd$map, author$project$Main$ListNotificationMsg, author$project$Components$TicketEventNotification$ListNotifications$fetchList));
				case 'OtpRefReceived':
					var otpRef = action.a;
					var otpsRef = elm$core$Result$toMaybe(
						A2(elm$json$Json$Decode$decodeValue, author$project$Binding$OTPDecoder$otpsDecoder, otpRef));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{otpsRef: otpsRef}),
						elm$core$Platform$Cmd$none);
				default:
					var subMsg = action.a;
					var sub = A2(
						elm$core$Maybe$map,
						A2(author$project$Components$TicketEventNotification$EditNotification$update, model.flags.listUrl, subMsg),
						model.notification);
					var closeCmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(
							elm$core$Maybe$map,
							elm$core$Basics$always(
								author$project$Utils$Command$msgToElmCmd(author$project$Main$NotificationAdded)),
							author$project$Components$TicketEventNotification$EditNotification$isDone(subMsg)));
					var subCmd = function (_n2) {
						var cmd = _n2.b;
						return elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(elm$core$Platform$Cmd$map, author$project$Main$EditNotificationMsg, cmd),
									closeCmd
								]));
					};
					var newCmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(elm$core$Maybe$map, subCmd, sub));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								notification: A2(elm$core$Maybe$map, elm$core$Tuple$first, sub)
							}),
						newCmd);
			}
		});
	var author$project$Main$ShowAddView = {$: 'ShowAddView'};
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$class = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
	var author$project$Utils$Style$primaryButtonStyle = rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-lg btn-primary');
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
	var rtfeldman$elm_css$Css$Internal$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
		return {$: 'ApplyStyles', a: a};
	};
	var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
		function (functionName, desiredKey, style) {
			getOverloadedProperty:
			while (true) {
				switch (style.$) {
					case 'AppendProperty':
						var str = style.a;
						var key = A2(
							elm$core$Maybe$withDefault,
							'',
							elm$core$List$head(
								A2(elm$core$String$split, ':', str)));
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
					case 'ExtendSelector':
						var selector = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
					case 'NestSnippet':
						var combinator = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
					case 'WithPseudoElement':
						var pseudoElement = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
					case 'WithMedia':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
					case 'WithKeyframes':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
					default:
						if (!style.a.b) {
							return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
						} else {
							if (!style.a.b.b) {
								var _n1 = style.a;
								var only = _n1.a;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = only;
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							} else {
								var _n2 = style.a;
								var first = _n2.a;
								var rest = _n2.b;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							}
						}
				}
			}
		});
	var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
	var rtfeldman$elm_css$Css$textAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'textAlign',
			'text-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$String$fromList = _String_fromList;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$Main$addNotificationButton = A2(
		rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Main$ShowAddView),
						author$project$Utils$Style$primaryButtonStyle
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('Ajouter une notification')
					]))
			]));
	var author$project$Components$TicketEventNotification$ListNotifications$NotificationOverview = function (a) {
		return {$: 'NotificationOverview', a: a};
	};
	var author$project$Components$TicketEventNotification$ListNotifications$getLabelFromOtp = F2(
		function (otpsRef, key) {
			var match = function (ref) {
				return A2(
					elm$core$Maybe$map,
					function ($) {
						return $.label;
					},
					A2(
						elm_community$list_extra$List$Extra$find,
						A2(
							elm$core$Basics$composeR,
							function ($) {
								return $.uid;
							},
							elm$core$Basics$eq(key)),
						ref));
			};
			return A2(
				ccapndave$elm_flat_map$Maybe$FlatMap$flatMap,
				A2(
					elm$core$Basics$composeR,
					function ($) {
						return $.openingTicketPurposes;
					},
					match),
				otpsRef);
		});
	var author$project$Components$TicketEventNotification$ListNotifications$toggleNotif = F4(
		function (current, notif, _true, _false) {
			var t = A2(
				elm$core$Maybe$withDefault,
				false,
				A2(
					elm$core$Maybe$map,
					elm$core$Basics$eq(notif),
					current));
			return t ? _true : _false;
		});
	var author$project$Components$TicketEventNotification$ListNotifications$RemoveNotification = function (a) {
		return {$: 'RemoveNotification', a: a};
	};
	var author$project$Utils$Style$defaultButtonStyle = rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-lg btn-default');
	var rtfeldman$elm_css$Css$display = rtfeldman$elm_css$Css$prop1('display');
	var rtfeldman$elm_css$Css$none = {backgroundImage: rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, cursor: rtfeldman$elm_css$Css$Structure$Compatible, display: rtfeldman$elm_css$Css$Structure$Compatible, hoverCapability: rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, keyframes: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: rtfeldman$elm_css$Css$Structure$Compatible, none: rtfeldman$elm_css$Css$Structure$Compatible, outline: rtfeldman$elm_css$Css$Structure$Compatible, pointerDevice: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, resize: rtfeldman$elm_css$Css$Structure$Compatible, scriptingSupport: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: rtfeldman$elm_css$Css$Structure$Compatible, textTransform: rtfeldman$elm_css$Css$Structure$Compatible, touchAction: rtfeldman$elm_css$Css$Structure$Compatible, transform: rtfeldman$elm_css$Css$Structure$Compatible, updateFrequency: rtfeldman$elm_css$Css$Structure$Compatible, value: 'none'};
	var author$project$Components$TicketEventNotification$ListNotifications$viewActions = function (notification) {
		var displayButton = function () {
			var _n0 = notification.id;
			if (_n0.$ === 'Just') {
				var s = _n0.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onClick(
						author$project$Components$TicketEventNotification$ListNotifications$RemoveNotification(s))
					]);
			} else {
				return _List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none)
							]))
					]);
			}
		}();
		return A2(
			rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				displayButton,
				_List_fromArray(
					[author$project$Utils$Style$defaultButtonStyle])),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text('Supprimer')
				]));
	};
	var author$project$Components$TicketEventNotification$ListNotifications$EditNotification = function (a) {
		return {$: 'EditNotification', a: a};
	};
	var author$project$Components$TicketEventNotification$ListNotifications$viewEdit = function (notification) {
		return A2(
			rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onClick(
					author$project$Components$TicketEventNotification$ListNotifications$EditNotification(notification)),
					author$project$Utils$Style$primaryButtonStyle
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text('Modifier')
				]));
	};
	var author$project$Components$TicketEventNotification$ListNotifications$viewRecipients = function (recipients) {
		var recipientToString = function (r) {
			if (r.$ === 'Role') {
				return 'rôle(s)';
			} else {
				return 'email(s)';
			}
		};
		var label = F2(
			function (s, i) {
				return (!i) ? _List_Nil : _List_fromArray(
					[
						elm$core$String$fromInt(i) + (' ' + s)
					]);
			});
		var countByKey = F2(
			function (k, l) {
				return elm$core$List$length(
					A2(
						elm$core$List$filter,
						elm$core$Basics$eq(k),
						l));
			});
		var buildLabel = F2(
			function (s, l) {
				return A2(
					label,
					s,
					A2(countByKey, s, l));
			});
		var result = function (l) {
			return A2(
				elm$core$String$join,
				', ',
				_Utils_ap(
					A2(buildLabel, 'rôle(s)', l),
					A2(buildLabel, 'email(s)', l)));
		};
		return result(
			A2(elm$core$List$map, recipientToString, recipients));
	};
	var rtfeldman$elm_css$Html$Styled$td = rtfeldman$elm_css$Html$Styled$node('td');
	var rtfeldman$elm_css$Html$Styled$tr = rtfeldman$elm_css$Html$Styled$node('tr');
	var author$project$Components$TicketEventNotification$ListNotifications$viewMessage = function (message) {
		return A2(
			rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(message.text)
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(
							author$project$Components$TicketEventNotification$ListNotifications$viewRecipients(message.recipients))
						]))
				]));
	};
	var rtfeldman$elm_css$Html$Styled$th = rtfeldman$elm_css$Html$Styled$node('th');
	var author$project$Components$TicketEventNotification$ListNotifications$viewMessageHeader = A2(
		rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$th,
				_List_Nil,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('Message')
					])),
				A2(
				rtfeldman$elm_css$Html$Styled$th,
				_List_Nil,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('Destinataires')
					]))
			]));
	var rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
		function (a, b) {
			return {$: 'ExtendSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
		return {$: 'PseudoClassSelector', a: a};
	};
	var rtfeldman$elm_css$Css$pseudoClass = function (_class) {
		return rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
			rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
	};
	var rtfeldman$elm_css$Html$Styled$span = rtfeldman$elm_css$Html$Styled$node('span');
	var author$project$Components$TicketEventNotification$ListNotifications$viewString = function (otp) {
		return A2(
			rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Css$pseudoClass,
							'not(:last-child):after',
							_List_fromArray(
								[
									A2(rtfeldman$elm_css$Css$property, 'content', '\', \'')
								]))
						]))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(otp)
				]));
	};
	var elm$core$Tuple$second = function (_n0) {
		var y = _n0.b;
		return y;
	};
	var author$project$Components$TicketEventNotification$NotificationData$getLabelFromTriggerEvents = function (key) {
		return A2(
			elm$core$Maybe$map,
			elm$core$Tuple$second,
			A2(
				elm_community$list_extra$List$Extra$find,
				A2(
					elm$core$Basics$composeR,
					elm$core$Tuple$first,
					elm$core$Basics$eq(key)),
				author$project$Components$TicketEventNotification$NotificationData$triggerEvents));
	};
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
	var rtfeldman$elm_css$Css$flexGrow = rtfeldman$elm_css$Css$prop1('flex-grow');
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$UnitlessInteger = {$: 'UnitlessInteger'};
	var rtfeldman$elm_css$Css$int = function (val) {
		return {
			fontWeight: rtfeldman$elm_css$Css$Structure$Compatible,
			intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
			number: rtfeldman$elm_css$Css$Structure$Compatible,
			numberOrInfinite: rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: val,
			unitLabel: '',
			units: rtfeldman$elm_css$Css$UnitlessInteger,
			value: elm$core$String$fromInt(val)
		};
	};
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$marginRight = rtfeldman$elm_css$Css$prop1('margin-right');
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$Css$cssFunction = F2(
		function (funcName, args) {
			return funcName + ('(' + (A2(elm$core$String$join, ', ', args) + ')'));
		});
	var rtfeldman$elm_css$Css$rgb = F3(
		function (r, g, b) {
			return {
				alpha: 1,
				blue: b,
				color: rtfeldman$elm_css$Css$Structure$Compatible,
				green: g,
				red: r,
				value: A2(
					rtfeldman$elm_css$Css$cssFunction,
					'rgb',
					A2(
						elm$core$List$map,
						elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])))
			};
		});
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var rtfeldman$elm_css$Html$Styled$h5 = rtfeldman$elm_css$Html$Styled$node('h5');
	var rtfeldman$elm_css$Html$Styled$label = rtfeldman$elm_css$Html$Styled$node('label');
	var rtfeldman$elm_css$Html$Styled$table = rtfeldman$elm_css$Html$Styled$node('table');
	var author$project$Components$TicketEventNotification$ListNotifications$viewNotificationOverview = F3(
		function (otpsRecord, current, notification) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A3(
								rtfeldman$elm_css$Css$border3,
								rtfeldman$elm_css$Css$px(1),
								rtfeldman$elm_css$Css$solid,
								rtfeldman$elm_css$Css$hex('ddd')),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(30)),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('fbfbfb')),
								rtfeldman$elm_css$Css$width(
								rtfeldman$elm_css$Css$pct(70))
							]))
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[rtfeldman$elm_css$Css$displayFlex]))
							]),
						_List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Html$Styled$h5,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												rtfeldman$elm_css$Css$flexGrow(
												rtfeldman$elm_css$Css$int(1)),
												rtfeldman$elm_css$Css$padding(
												rtfeldman$elm_css$Css$px(10)),
												rtfeldman$elm_css$Css$fontSize(
												rtfeldman$elm_css$Css$px(18)),
												rtfeldman$elm_css$Css$color(
												A3(rtfeldman$elm_css$Css$rgb, 138, 149, 154)),
												rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer)
											])),
										rtfeldman$elm_css$Html$Styled$Events$onClick(
										author$project$Components$TicketEventNotification$ListNotifications$NotificationOverview(notification))
									]),
								_List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														rtfeldman$elm_css$Css$marginRight(
														rtfeldman$elm_css$Css$px(10))
													]))
											]),
										_List_fromArray(
											[
												rtfeldman$elm_css$Html$Styled$text(
												A2(elm$core$Maybe$withDefault, '', notification.label))
											]))
									]))
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap(
									A4(
										author$project$Components$TicketEventNotification$ListNotifications$toggleNotif,
										current,
										notification,
										_List_fromArray(
											[
												A2(rtfeldman$elm_css$Css$property, 'display', 'grid'),
												A2(rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(3, 33%)')
											]),
										_List_fromArray(
											[
												rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none)
											])),
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$backgroundColor(
											rtfeldman$elm_css$Css$hex('FFF')),
											rtfeldman$elm_css$Css$padding(
											rtfeldman$elm_css$Css$px(10))
										])))
							]),
						_List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Html$Styled$label,
								_List_Nil,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text('Raison d\'ouverture de ticket')
									])),
								A2(
								rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												A2(rtfeldman$elm_css$Css$property, 'grid-row', '2')
											]))
									]),
								A2(
									ccapndave$elm_flat_map$List$FlatMap$flatMap,
									A2(
										elm$core$Basics$composeR,
										author$project$Components$TicketEventNotification$ListNotifications$getLabelFromOtp(otpsRecord),
										A2(
											elm$core$Basics$composeR,
											elm$core$Maybe$map(author$project$Components$TicketEventNotification$ListNotifications$viewString),
											elm_community$maybe_extra$Maybe$Extra$toList)),
									notification.otps)),
								A2(
								rtfeldman$elm_css$Html$Styled$label,
								_List_Nil,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text('Evenements déclencheurs')
									])),
								A2(
								rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												A2(rtfeldman$elm_css$Css$property, 'grid-row', '2')
											]))
									]),
								A2(
									elm$core$List$map,
									function (eventKey) {
										return author$project$Components$TicketEventNotification$ListNotifications$viewString(
											A2(
												elm$core$Maybe$withDefault,
												eventKey,
												author$project$Components$TicketEventNotification$NotificationData$getLabelFromTriggerEvents(eventKey)));
									},
									notification.triggerEvent)),
								A2(
								rtfeldman$elm_css$Html$Styled$table,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												A2(rtfeldman$elm_css$Css$property, 'grid-row', '3'),
												A2(rtfeldman$elm_css$Css$property, 'grid-column', 'span 2')
											]))
									]),
								A2(
									elm$core$List$cons,
									author$project$Components$TicketEventNotification$ListNotifications$viewMessageHeader,
									A2(elm$core$List$map, author$project$Components$TicketEventNotification$ListNotifications$viewMessage, notification.messages))),
								A2(
								rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												A2(rtfeldman$elm_css$Css$property, 'grid-row', '1 / span 4')
											]))
									]),
								_List_fromArray(
									[
										author$project$Components$TicketEventNotification$ListNotifications$viewActions(notification),
										author$project$Components$TicketEventNotification$ListNotifications$viewEdit(notification)
									]))
							]))
					]));
		});
	var author$project$Components$TicketEventNotification$ListNotifications$view = F2(
		function (otpsRecord, model) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				A2(
					elm$core$List$map,
					A2(author$project$Components$TicketEventNotification$ListNotifications$viewNotificationOverview, otpsRecord, model.currentNotification),
					model.notification));
		});
	var elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
	var elm$html$Html$map = elm$virtual_dom$VirtualDom$map;
	var rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
	var rtfeldman$elm_css$Html$Styled$fromUnstyled = rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var author$project$Main$viewList = F2(
		function (list, otpsRef) {
			return rtfeldman$elm_css$Html$Styled$fromUnstyled(
				A2(
					elm$html$Html$map,
					author$project$Main$ListNotificationMsg,
					rtfeldman$elm_css$Html$Styled$toUnstyled(
						A2(author$project$Components$TicketEventNotification$ListNotifications$view, otpsRef, list))));
		});
	var rtfeldman$elm_css$Html$Styled$h1 = rtfeldman$elm_css$Html$Styled$node('h1');
	var author$project$Main$defaultView = F2(
		function (list, otpsRef) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$h1,
						_List_Nil,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('Liste des notifications')
							])),
						A2(author$project$Main$viewList, list, otpsRef),
						author$project$Main$addNotificationButton
					]));
		});
	var author$project$Components$TicketEventNotification$EditNotification$AddMessageNotification = {$: 'AddMessageNotification'};
	var author$project$Components$TicketEventNotification$EditNotification$AddNotification = {$: 'AddNotification'};
	var author$project$Components$TicketEventNotification$EditNotification$LabelChange = function (a) {
		return {$: 'LabelChange', a: a};
	};
	var author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer = rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$marginRight(
				rtfeldman$elm_css$Css$px(15))
			]));
	var author$project$Components$TicketEventNotification$EditNotification$printlnError = F2(
		function (config, e) {
			if (e.$ === 'TechnicalError') {
				var s = e.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('Une erreur est survenue')
					]);
			} else {
				var _n1 = e.a;
				var body = _n1.b;
				switch (body.$) {
					case 'UserRightError':
						return _List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('Action interdite')
							]);
					case 'TicketEventNotificationDomainError':
						var domainError = body.a;
						if (domainError.$ === 'LabelShouldBeUniq') {
							return _List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(
									'Le nom [' + (A2(elm$core$Maybe$withDefault, '', config.label) + '] est déjà utilisé par une autre notification'))
								]);
						} else {
							return _List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Les évènements déclencheurs ainsi que les raisons d\'ouverture de ticket sont déjà utilisées par une autre notification')
								]);
						}
					default:
						return _List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('Une erreur est survenue')
							]);
				}
			}
		});
	var rtfeldman$elm_css$Css$paddingLeft = rtfeldman$elm_css$Css$prop1('padding-left');
	var author$project$Components$TicketEventNotification$EditNotification$decorateForError = function (maybeErrorLabel) {
		var label = A2(elm$core$Maybe$withDefault, '', maybeErrorLabel);
		return A2(
			rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$color(
							rtfeldman$elm_css$Css$hex('f00')),
							rtfeldman$elm_css$Css$paddingLeft(
							rtfeldman$elm_css$Css$px(5))
						]))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(label)
				]));
	};
	var author$project$Components$TicketEventNotification$EditNotification$formErrorLabel = function (error) {
		switch (error.$) {
			case 'MandatoryConfigLabel':
				return 'Saisir un label';
			case 'NEL_Otps':
				return 'Choisir au moins un élément';
			case 'NEL_TrigerredEvents':
				return 'Choisir au moins un élément';
			default:
				return 'configuration du message invalide';
		}
	};
	var author$project$Components$TicketEventNotification$EditNotification$showFormError = F2(
		function (errors, expectedError) {
			return author$project$Components$TicketEventNotification$EditNotification$decorateForError(
				A2(
					elm$core$Maybe$map,
					author$project$Components$TicketEventNotification$EditNotification$formErrorLabel,
					A2(
						elm_community$list_extra$List$Extra$find,
						elm$core$Basics$eq(expectedError),
						errors)));
		});
	var inkuzmin$elm_multiselect$Multiselect$ClickOnComponent = {$: 'ClickOnComponent'};
	var inkuzmin$elm_multiselect$Multiselect$Focused = {$: 'Focused'};
	var inkuzmin$elm_multiselect$Multiselect$Toggle = {$: 'Toggle'};
	var inkuzmin$elm_multiselect$Multiselect$withOptions = F2(
		function (options, decoder) {
			return A2(
				elm$json$Json$Decode$map,
				function (m) {
					return {message: m, preventDefault: options.preventDefault, stopPropagation: options.stopPropagation};
				},
				decoder);
		});
	var elm$virtual_dom$VirtualDom$Custom = function (a) {
		return {$: 'Custom', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$custom = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Custom(decoder));
		});
	var inkuzmin$elm_multiselect$Multiselect$onClickNoDefault = function (message) {
		var config = {preventDefault: true, stopPropagation: true};
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$custom,
			'click',
			A2(
				inkuzmin$elm_multiselect$Multiselect$withOptions,
				config,
				elm$json$Json$Decode$succeed(message)));
	};
	var rtfeldman$elm_css$Css$batch = rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
	var rtfeldman$elm_css$Css$borderBottomWidth = rtfeldman$elm_css$Css$prop1('border-bottom-width');
	var rtfeldman$elm_css$Css$borderColor3 = F3(
		function (c1, c2, c3) {
			var value = A2(
				elm$core$String$join,
				' ',
				_List_fromArray(
					[c1.value, c2.value, c3.value]));
			return A2(rtfeldman$elm_css$Css$property, 'border-color', value);
		});
	var rtfeldman$elm_css$Css$borderLeftWidth = rtfeldman$elm_css$Css$prop1('border-left-width');
	var rtfeldman$elm_css$Css$borderRightWidth = rtfeldman$elm_css$Css$prop1('border-right-width');
	var rtfeldman$elm_css$Css$borderStyle = rtfeldman$elm_css$Css$prop1('border-style');
	var rtfeldman$elm_css$Css$borderTopWidth = rtfeldman$elm_css$Css$prop1('border-top-width');
	var rtfeldman$elm_css$Css$height = rtfeldman$elm_css$Css$prop1('height');
	var rtfeldman$elm_css$Css$inlineBlock = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'inline-block'};
	var rtfeldman$elm_css$Css$position = rtfeldman$elm_css$Css$prop1('position');
	var rtfeldman$elm_css$Css$relative = {position: rtfeldman$elm_css$Css$Structure$Compatible, value: 'relative'};
	var rtfeldman$elm_css$Css$transparent = {color: rtfeldman$elm_css$Css$Structure$Compatible, value: 'transparent'};
	var rtfeldman$elm_css$Css$zero = {length: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible, number: rtfeldman$elm_css$Css$Structure$Compatible, numericValue: 0, outline: rtfeldman$elm_css$Css$Structure$Compatible, unitLabel: '', units: rtfeldman$elm_css$Css$UnitlessInteger, value: '0'};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$arrow = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A3(
				rtfeldman$elm_css$Css$borderColor3,
				rtfeldman$elm_css$Css$hex('#999'),
				rtfeldman$elm_css$Css$transparent,
				rtfeldman$elm_css$Css$transparent),
				rtfeldman$elm_css$Css$borderStyle(rtfeldman$elm_css$Css$solid),
				rtfeldman$elm_css$Css$borderTopWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderLeftWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderRightWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderBottomWidth(
				rtfeldman$elm_css$Css$px(2.5)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$height(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$width(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative)
			]));
	var rtfeldman$elm_css$Css$top = rtfeldman$elm_css$Css$prop1('top');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowUpside = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A3(
				rtfeldman$elm_css$Css$borderColor3,
				rtfeldman$elm_css$Css$transparent,
				rtfeldman$elm_css$Css$transparent,
				rtfeldman$elm_css$Css$hex('#999')),
				rtfeldman$elm_css$Css$borderStyle(rtfeldman$elm_css$Css$solid),
				rtfeldman$elm_css$Css$borderTopWidth(
				rtfeldman$elm_css$Css$px(2.5)),
				rtfeldman$elm_css$Css$borderLeftWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderRightWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderBottomWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$height(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$width(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$top(
				rtfeldman$elm_css$Css$px(-2.5))
			]));
	var rtfeldman$elm_css$Css$middle = rtfeldman$elm_css$Css$prop1('middle');
	var rtfeldman$elm_css$Css$paddingRight = rtfeldman$elm_css$Css$prop1('padding-right');
	var rtfeldman$elm_css$Css$tableCell = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'table-cell'};
	var rtfeldman$elm_css$Css$verticalAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'verticalAlign',
			'vertical-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowWrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$tableCell),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$px(25)),
				rtfeldman$elm_css$Css$paddingRight(
				rtfeldman$elm_css$Css$px(5))
			]));
	var elm$virtual_dom$VirtualDom$attribute = F2(
		function (key, value) {
			return A2(
				_VirtualDom_attribute,
				_VirtualDom_noOnOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$attribute, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$rel = rtfeldman$elm_css$VirtualDom$Styled$attribute('rel');
	var inkuzmin$elm_multiselect$Multiselect$arrow = function (_n0) {
		var model = _n0.a;
		var arrowRel = _Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Opened) ? 'arrowUpside' : 'arrow';
		var arrowCss = _Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Opened) ? _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowUpside]) : _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$arrow]);
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowWrap])),
					inkuzmin$elm_multiselect$Multiselect$onClickNoDefault(inkuzmin$elm_multiselect$Multiselect$Toggle)
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(arrowCss),
							rtfeldman$elm_css$Html$Styled$Attributes$rel(arrowRel)
						]),
					_List_Nil)
				]));
	};
	var inkuzmin$elm_multiselect$Multiselect$Clear = {$: 'Clear'};
	var rtfeldman$elm_css$Css$lineHeight = rtfeldman$elm_css$Css$prop1('line-height');
	var rtfeldman$elm_css$Css$UnitlessFloat = {$: 'UnitlessFloat'};
	var rtfeldman$elm_css$Css$num = function (val) {
		return {
			lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
			number: rtfeldman$elm_css$Css$Structure$Compatible,
			numberOrInfinite: rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: val,
			unitLabel: '',
			units: rtfeldman$elm_css$Css$UnitlessFloat,
			value: elm$core$String$fromFloat(val)
		};
	};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$clear = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$fontSize(
				rtfeldman$elm_css$Css$px(18)),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$num(1))
			]));
	var rtfeldman$elm_css$Css$hover = rtfeldman$elm_css$Css$pseudoClass('hover');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$clearWrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$px(17)),
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#999')),
				rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$tableCell),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle),
				rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$color(
						rtfeldman$elm_css$Css$hex('#D0021B'))
					]))
			]));
	var inkuzmin$elm_multiselect$Multiselect$clear = function (_n0) {
		var model = _n0.a;
		return (!elm$core$List$isEmpty(model.selected)) ? A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$clearWrap])),
					inkuzmin$elm_multiselect$Multiselect$onClickNoDefault(inkuzmin$elm_multiselect$Multiselect$Clear)
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[inkuzmin$elm_multiselect$Multiselect$SelectCss$clear]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('×')
						]))
				])) : A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	};
	var inkuzmin$elm_multiselect$Multiselect$Adjust = function (a) {
		return {$: 'Adjust', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Filter = function (a) {
		return {$: 'Filter', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Shortcut = function (a) {
		return {$: 'Shortcut', a: a};
	};
	var elm$json$Json$Decode$float = _Json_decodeFloat;
	var debois$elm_dom$DOM$offsetWidth = A2(elm$json$Json$Decode$field, 'offsetWidth', elm$json$Json$Decode$float);
	var debois$elm_dom$DOM$previousSibling = function (decoder) {
		return A2(elm$json$Json$Decode$field, 'previousSibling', decoder);
	};
	var debois$elm_dom$DOM$target = function (decoder) {
		return A2(elm$json$Json$Decode$field, 'target', decoder);
	};
	var inkuzmin$elm_multiselect$Multiselect$onKeyDown = function (tagger) {
		var domF = debois$elm_dom$DOM$target(
			debois$elm_dom$DOM$previousSibling(debois$elm_dom$DOM$offsetWidth));
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'keypress',
			A2(elm$json$Json$Decode$map, tagger, domF));
	};
	var elm$json$Json$Decode$int = _Json_decodeInt;
	var rtfeldman$elm_css$Html$Styled$Events$keyCode = A2(elm$json$Json$Decode$field, 'keyCode', elm$json$Json$Decode$int);
	var inkuzmin$elm_multiselect$Multiselect$onKeyPress = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'keydown',
			A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$keyCode));
	};
	var elm$json$Json$Decode$at = F2(
		function (fields, decoder) {
			return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
		});
	var rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'value']),
		elm$json$Json$Decode$string);
	var inkuzmin$elm_multiselect$Multiselect$onKeyUp = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'keyup',
			A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue));
	};
	var inkuzmin$elm_multiselect$Multiselect$Start = {$: 'Start'};
	var inkuzmin$elm_multiselect$Multiselect$fromResult = function (result) {
		if (result.$ === 'Ok') {
			var successValue = result.a;
			return elm$json$Json$Decode$succeed(successValue);
		} else {
			var errorMessage = result.a;
			return elm$json$Json$Decode$fail(errorMessage);
		}
	};
	var inkuzmin$elm_multiselect$Multiselect$preventDefaultButtons = function () {
		var options = {preventDefault: true, stopPropagation: false};
		var filterKey = function (code) {
			return (_Utils_eq(code, inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow) || _Utils_eq(code, inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow)) ? elm$core$Result$Ok(code) : elm$core$Result$Err('ignored input');
		};
		var decoder = A2(
			elm$json$Json$Decode$map,
			elm$core$Basics$always(inkuzmin$elm_multiselect$Multiselect$Start),
			A2(
				elm$json$Json$Decode$andThen,
				A2(elm$core$Basics$composeR, filterKey, inkuzmin$elm_multiselect$Multiselect$fromResult),
				rtfeldman$elm_css$Html$Styled$Events$keyCode));
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$custom,
			'keydown',
			A2(inkuzmin$elm_multiselect$Multiselect$withOptions, options, decoder));
	}();
	var rtfeldman$elm_css$Css$border = rtfeldman$elm_css$Css$prop1('border');
	var rtfeldman$elm_css$Css$initial = {alignItems: rtfeldman$elm_css$Css$Structure$Compatible, all: rtfeldman$elm_css$Css$Structure$Compatible, backgroundAttachment: rtfeldman$elm_css$Css$Structure$Compatible, backgroundBlendMode: rtfeldman$elm_css$Css$Structure$Compatible, backgroundImage: rtfeldman$elm_css$Css$Structure$Compatible, backgroundOrigin: rtfeldman$elm_css$Css$Structure$Compatible, backgroundRepeat: rtfeldman$elm_css$Css$Structure$Compatible, backgroundRepeatShorthand: rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, boxSizing: rtfeldman$elm_css$Css$Structure$Compatible, color: rtfeldman$elm_css$Css$Structure$Compatible, cursor: rtfeldman$elm_css$Css$Structure$Compatible, display: rtfeldman$elm_css$Css$Structure$Compatible, flexBasis: rtfeldman$elm_css$Css$Structure$Compatible, flexDirection: rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, flexWrap: rtfeldman$elm_css$Css$Structure$Compatible, fontFamily: rtfeldman$elm_css$Css$Structure$Compatible, fontSize: rtfeldman$elm_css$Css$Structure$Compatible, fontStyle: rtfeldman$elm_css$Css$Structure$Compatible, fontVariant: rtfeldman$elm_css$Css$Structure$Compatible, fontWeight: rtfeldman$elm_css$Css$Structure$Compatible, intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, justifyContent: rtfeldman$elm_css$Css$Structure$Compatible, keyframes: rtfeldman$elm_css$Css$Structure$Compatible, length: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, listStylePosition: rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: rtfeldman$elm_css$Css$Structure$Compatible, none: rtfeldman$elm_css$Css$Structure$Compatible, number: rtfeldman$elm_css$Css$Structure$Compatible, numericValue: 0, outline: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, tableLayout: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, textIndent: rtfeldman$elm_css$Css$Structure$Compatible, textRendering: rtfeldman$elm_css$Css$Structure$Compatible, textTransform: rtfeldman$elm_css$Css$Structure$Compatible, touchAction: rtfeldman$elm_css$Css$Structure$Compatible, unitLabel: '', units: rtfeldman$elm_css$Css$Internal$IncompatibleUnits, value: 'initial', visibility: rtfeldman$elm_css$Css$Structure$Compatible, whiteSpace: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$inherit = _Utils_update(
		rtfeldman$elm_css$Css$initial,
		{value: 'inherit'});
	var rtfeldman$elm_css$Css$outlineStyle = rtfeldman$elm_css$Css$prop1('outline-style');
	var rtfeldman$elm_css$Css$paddingTop = rtfeldman$elm_css$Css$prop1('padding-top');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$input = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$borderStyle(rtfeldman$elm_css$Css$none),
				rtfeldman$elm_css$Css$border(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$px(14)),
				rtfeldman$elm_css$Css$outlineStyle(rtfeldman$elm_css$Css$none),
				rtfeldman$elm_css$Css$fontSize(rtfeldman$elm_css$Css$inherit),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$int(1)),
				rtfeldman$elm_css$Css$padding(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$paddingTop(
				rtfeldman$elm_css$Css$px(8))
			]));
	var rtfeldman$elm_css$Css$absolute = {position: rtfeldman$elm_css$Css$Structure$Compatible, value: 'absolute'};
	var rtfeldman$elm_css$Css$fontStyle = rtfeldman$elm_css$Css$prop1('font-style');
	var rtfeldman$elm_css$Css$fontWeight = function (_n0) {
		var value = _n0.value;
		return A2(rtfeldman$elm_css$Css$property, 'font-weight', value);
	};
	var rtfeldman$elm_css$Css$left = rtfeldman$elm_css$Css$prop1('left');
	var rtfeldman$elm_css$Css$normal = {featureTagValue: rtfeldman$elm_css$Css$Structure$Compatible, fontStyle: rtfeldman$elm_css$Css$Structure$Compatible, fontWeight: rtfeldman$elm_css$Css$Structure$Compatible, overflowWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'normal', whiteSpace: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$overflow = rtfeldman$elm_css$Css$prop1('overflow');
	var rtfeldman$elm_css$Css$scroll = {backgroundAttachment: rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, scroll: rtfeldman$elm_css$Css$Structure$Compatible, value: 'scroll'};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$inputMirrow = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
				rtfeldman$elm_css$Css$top(
				rtfeldman$elm_css$Css$px(-100)),
				rtfeldman$elm_css$Css$left(
				rtfeldman$elm_css$Css$px(-100)),
				rtfeldman$elm_css$Css$height(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$scroll),
				rtfeldman$elm_css$Css$fontWeight(rtfeldman$elm_css$Css$normal),
				rtfeldman$elm_css$Css$fontStyle(rtfeldman$elm_css$Css$normal),
				rtfeldman$elm_css$Css$fontSize(rtfeldman$elm_css$Css$inherit),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$int(1))
			]));
	var rtfeldman$elm_css$Css$marginLeft = rtfeldman$elm_css$Css$prop1('margin-left');
	var rtfeldman$elm_css$Css$paddingBottom = rtfeldman$elm_css$Css$prop1('padding-bottom');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$inputWrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$marginLeft(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$padding(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle),
				rtfeldman$elm_css$Css$paddingBottom(
				rtfeldman$elm_css$Css$px(8))
			]));
	var rtfeldman$elm_css$Html$Styled$input = rtfeldman$elm_css$Html$Styled$node('input');
	var rtfeldman$elm_css$Html$Styled$Attributes$id = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
	var rtfeldman$elm_css$Html$Styled$Attributes$property = rtfeldman$elm_css$VirtualDom$Styled$property;
	var elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
	var rtfeldman$elm_css$VirtualDom$Styled$style = F2(
		function (key, val) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$style, key, val),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$style = rtfeldman$elm_css$VirtualDom$Styled$style;
	var inkuzmin$elm_multiselect$Multiselect$input = function (_n0) {
		var model = _n0.a;
		var w = elm$core$String$fromFloat(model.inputWidth + 23.0);
		var value = _Utils_eq(model.input, inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? A2(
			rtfeldman$elm_css$Html$Styled$Attributes$property,
			'value',
			elm$json$Json$Encode$string(model.input)) : A2(
			rtfeldman$elm_css$Html$Styled$Attributes$property,
			'type',
			elm$json$Json$Encode$string('text'));
		var inputStyle = A2(rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', w + 'px');
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					inkuzmin$elm_multiselect$Multiselect$preventDefaultButtons,
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$inputWrap]))
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[inkuzmin$elm_multiselect$Multiselect$SelectCss$inputMirrow]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(model.input)
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectInput' + model.tag),
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[inkuzmin$elm_multiselect$Multiselect$SelectCss$input])),
							inkuzmin$elm_multiselect$Multiselect$onKeyDown(inkuzmin$elm_multiselect$Multiselect$Adjust),
							inkuzmin$elm_multiselect$Multiselect$onKeyPress(inkuzmin$elm_multiselect$Multiselect$Shortcut),
							inkuzmin$elm_multiselect$Multiselect$onKeyUp(inkuzmin$elm_multiselect$Multiselect$Filter),
							inputStyle,
							value
						]),
					_List_Nil)
				]));
	};
	var inkuzmin$elm_multiselect$Multiselect$OnHover = function (a) {
		return {$: 'OnHover', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$OnSelect = function (a) {
		return {$: 'OnSelect', a: a};
	};
	var rtfeldman$elm_css$Css$borderBottomLeftRadius = rtfeldman$elm_css$Css$prop1('border-bottom-left-radius');
	var rtfeldman$elm_css$Css$borderBottomRightRadius = rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
	var rtfeldman$elm_css$Css$borderTopColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'border-top-color', c.value);
	};
	var rtfeldman$elm_css$Css$prop4 = F5(
		function (key, argA, argB, argC, argD) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value, argD.value])));
		});
	var rtfeldman$elm_css$Css$boxShadow4 = rtfeldman$elm_css$Css$prop4('box-shadow');
	var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
	var rtfeldman$elm_css$Css$maxHeight = rtfeldman$elm_css$Css$prop1('max-height');
	var rtfeldman$elm_css$Css$overflowY = rtfeldman$elm_css$Css$prop1('overflow-y');
	var rtfeldman$elm_css$Css$rgba = F4(
		function (r, g, b, alpha) {
			return {
				alpha: alpha,
				blue: b,
				color: rtfeldman$elm_css$Css$Structure$Compatible,
				green: g,
				red: r,
				value: A2(
					rtfeldman$elm_css$Css$cssFunction,
					'rgba',
					_Utils_ap(
						A2(
							elm$core$List$map,
							elm$core$String$fromInt,
							_List_fromArray(
								[r, g, b])),
						_List_fromArray(
							[
								elm$core$String$fromFloat(alpha)
							])))
			};
		});
	var rtfeldman$elm_css$Css$zIndex = rtfeldman$elm_css$Css$prop1('z-index');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$menu = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$borderBottomRightRadius(
				rtfeldman$elm_css$Css$px(4)),
				rtfeldman$elm_css$Css$borderBottomLeftRadius(
				rtfeldman$elm_css$Css$px(4)),
				rtfeldman$elm_css$Css$backgroundColor(
				rtfeldman$elm_css$Css$hex('#fff')),
				A3(
				rtfeldman$elm_css$Css$border3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid,
				rtfeldman$elm_css$Css$hex('#ccc')),
				rtfeldman$elm_css$Css$borderTopColor(
				rtfeldman$elm_css$Css$hex('#e6e6e6')),
				A4(
				rtfeldman$elm_css$Css$boxShadow4,
				rtfeldman$elm_css$Css$zero,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$zero,
				A4(rtfeldman$elm_css$Css$rgba, 0, 0, 0, 6.0e-2)),
				rtfeldman$elm_css$Css$marginTop(
				rtfeldman$elm_css$Css$px(-1)),
				rtfeldman$elm_css$Css$maxHeight(
				rtfeldman$elm_css$Css$px(inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight)),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(100)),
				rtfeldman$elm_css$Css$zIndex(
				rtfeldman$elm_css$Css$int(1)),
				rtfeldman$elm_css$Css$overflowY(rtfeldman$elm_css$Css$scroll)
			]));
	var rtfeldman$elm_css$Css$prop2 = F3(
		function (key, argA, argB) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value])));
		});
	var rtfeldman$elm_css$Css$padding2 = rtfeldman$elm_css$Css$prop2('padding');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#666')),
				rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
				A2(
				rtfeldman$elm_css$Css$padding2,
				rtfeldman$elm_css$Css$px(8),
				rtfeldman$elm_css$Css$px(10)),
				rtfeldman$elm_css$Css$maxHeight(
				rtfeldman$elm_css$Css$px(inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight))
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItemHovered = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$backgroundColor(
				A4(rtfeldman$elm_css$Css$rgba, 0, 126, 255, 8.0e-2)),
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#333'))
			]));
	var inkuzmin$elm_multiselect$Multiselect$Utils$fst = elm$core$Tuple$first;
	var rtfeldman$elm_css$Html$Styled$Events$onMouseOver = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'mouseover',
			elm$json$Json$Decode$succeed(msg));
	};
	var inkuzmin$elm_multiselect$Multiselect$menu = function (_n0) {
		var model = _n0.a;
		var _n1 = model.status;
		if (_n1.$ === 'Opened') {
			var hovered = function () {
				var _n3 = model.hovered;
				if (_n3.$ === 'Nothing') {
					return '';
				} else {
					var item = _n3.a;
					return inkuzmin$elm_multiselect$Multiselect$Utils$fst(item);
				}
			}();
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[inkuzmin$elm_multiselect$Multiselect$SelectCss$menu])),
						rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectMenu' + model.tag)
					]),
				A2(
					elm$core$List$map,
					function (_n2) {
						var name = _n2.a;
						var value = _n2.b;
						return A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_eq(name, hovered) ? _List_fromArray(
										[inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItemHovered, inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem]) : _List_fromArray(
										[inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem])),
									inkuzmin$elm_multiselect$Multiselect$onClickNoDefault(
									inkuzmin$elm_multiselect$Multiselect$OnSelect(
										_Utils_Tuple2(name, value))),
									rtfeldman$elm_css$Html$Styled$Events$onMouseOver(
									inkuzmin$elm_multiselect$Multiselect$OnHover(
										_Utils_Tuple2(name, value)))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(value)
								]));
					},
					model.filtered));
		} else {
			return A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
		}
	};
	var inkuzmin$elm_multiselect$Multiselect$RemoveItem = function (a) {
		return {$: 'RemoveItem', a: a};
	};
	var rtfeldman$elm_css$Css$border2 = rtfeldman$elm_css$Css$prop2('border');
	var rtfeldman$elm_css$Css$borderColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'border-color', c.value);
	};
	var rtfeldman$elm_css$Css$borderRadius = rtfeldman$elm_css$Css$prop1('border-radius');
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$tag = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#007eff')),
				A2(
				rtfeldman$elm_css$Css$border2,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid),
				rtfeldman$elm_css$Css$borderColor(
				A4(rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.24)),
				rtfeldman$elm_css$Css$borderRadius(
				rtfeldman$elm_css$Css$px(2)),
				rtfeldman$elm_css$Css$backgroundColor(
				A4(rtfeldman$elm_css$Css$rgba, 0, 126, 255, 8.0e-2)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$fontSize(
				rtfeldman$elm_css$Css$em(0.9)),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$num(1.4)),
				rtfeldman$elm_css$Css$marginLeft(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$marginTop(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$top)
			]));
	var rtfeldman$elm_css$Css$borderRight3 = rtfeldman$elm_css$Css$prop3('border-right');
	var rtfeldman$elm_css$Css$padding3 = rtfeldman$elm_css$Css$prop3('padding');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$tagIcon = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$backgroundColor(
						rtfeldman$elm_css$Css$hex('#d8eafd'))
					])),
				rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
				A3(
				rtfeldman$elm_css$Css$borderRight3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid,
				A4(rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.24)),
				A3(
				rtfeldman$elm_css$Css$padding3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$px(5),
				rtfeldman$elm_css$Css$px(3)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle)
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$tagLabel = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Css$padding2,
				rtfeldman$elm_css$Css$px(2),
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle)
			]));
	var inkuzmin$elm_multiselect$Multiselect$tag = F2(
		function (name, value) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[inkuzmin$elm_multiselect$Multiselect$SelectCss$tag]))
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[inkuzmin$elm_multiselect$Multiselect$SelectCss$tagIcon])),
								rtfeldman$elm_css$Html$Styled$Events$onClick(
								inkuzmin$elm_multiselect$Multiselect$RemoveItem(
									_Utils_Tuple2(name, value)))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('×')
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[inkuzmin$elm_multiselect$Multiselect$SelectCss$tagLabel]))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(value)
							]))
					]));
		});
	var rtfeldman$elm_css$Css$inline = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'inline'};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$tagWrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inline)
			]));
	var inkuzmin$elm_multiselect$Multiselect$tags = function (_n0) {
		var model = _n0.a;
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$tagWrap]))
				]),
			A2(
				elm$core$List$map,
				function (_n1) {
					var name = _n1.a;
					var value = _n1.b;
					return A2(inkuzmin$elm_multiselect$Multiselect$tag, name, value);
				},
				model.selected));
	};
	var rtfeldman$elm_css$Css$table = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'table'};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$container = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A3(
				rtfeldman$elm_css$Css$border3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid,
				rtfeldman$elm_css$Css$hex('#ccc')),
				rtfeldman$elm_css$Css$borderRadius(
				rtfeldman$elm_css$Css$px(4)),
				A3(
				rtfeldman$elm_css$Css$borderColor3,
				rtfeldman$elm_css$Css$hex('#d9d9d9'),
				rtfeldman$elm_css$Css$hex('#ccc'),
				rtfeldman$elm_css$Css$hex('#b3b3b3')),
				rtfeldman$elm_css$Css$backgroundColor(
				rtfeldman$elm_css$Css$hex('#fff')),
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#333')),
				rtfeldman$elm_css$Css$height(
				rtfeldman$elm_css$Css$px(34)),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(100)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$table)
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$boxShadowCustom = function (p) {
		return A2(rtfeldman$elm_css$Css$property, 'box-shadow', p);
	};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$focused = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$borderColor(
				rtfeldman$elm_css$Css$hex('#007eff')),
				inkuzmin$elm_multiselect$Multiselect$SelectCss$boxShadowCustom('inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1)')
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$opened = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$borderBottomLeftRadius(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$borderBottomRightRadius(rtfeldman$elm_css$Css$zero)
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$wrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(100))
			]));
	var inkuzmin$elm_multiselect$Multiselect$styledView = function (_n0) {
		var model = _n0.a;
		var inputCss = _Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Focused) ? _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$container, inkuzmin$elm_multiselect$Multiselect$SelectCss$focused]) : (_Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Opened) ? _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$container, inkuzmin$elm_multiselect$Multiselect$SelectCss$opened]) : _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$container]));
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$wrap])),
					rtfeldman$elm_css$Html$Styled$Events$onClick(inkuzmin$elm_multiselect$Multiselect$ClickOnComponent)
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(inputCss)
						]),
					_List_fromArray(
						[
							inkuzmin$elm_multiselect$Multiselect$tags(
							inkuzmin$elm_multiselect$Multiselect$Model(model)),
							inkuzmin$elm_multiselect$Multiselect$input(
							inkuzmin$elm_multiselect$Multiselect$Model(model)),
							inkuzmin$elm_multiselect$Multiselect$clear(
							inkuzmin$elm_multiselect$Multiselect$Model(model)),
							inkuzmin$elm_multiselect$Multiselect$arrow(
							inkuzmin$elm_multiselect$Multiselect$Model(model))
						])),
					inkuzmin$elm_multiselect$Multiselect$menu(
					inkuzmin$elm_multiselect$Multiselect$Model(model))
				]));
	};
	var inkuzmin$elm_multiselect$Multiselect$view = A2(elm$core$Basics$composeR, inkuzmin$elm_multiselect$Multiselect$styledView, rtfeldman$elm_css$Html$Styled$toUnstyled);
	var author$project$Components$TicketEventNotification$EditNotification$showOtp = function (multiSelectModel) {
		return rtfeldman$elm_css$Html$Styled$fromUnstyled(
			A2(
				elm$html$Html$map,
				author$project$Components$TicketEventNotification$EditNotification$OtpsMultiselect,
				inkuzmin$elm_multiselect$Multiselect$view(multiSelectModel)));
	};
	var author$project$Components$TicketEventNotification$EditNotification$verticalSpacer = rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$marginBottom(
				rtfeldman$elm_css$Css$px(15))
			]));
	var author$project$Components$TicketEventNotification$EditNotification$AddRecipient = function (a) {
		return {$: 'AddRecipient', a: a};
	};
	var author$project$Components$TicketEventNotification$EditNotification$ChangeMailRecipient = F2(
		function (a, b) {
			return {$: 'ChangeMailRecipient', a: a, b: b};
		});
	var author$project$Components$TicketEventNotification$EditNotification$MessageTextChange = F2(
		function (a, b) {
			return {$: 'MessageTextChange', a: a, b: b};
		});
	var author$project$Components$TicketEventNotification$EditNotification$RemoveMessageNotification = function (a) {
		return {$: 'RemoveMessageNotification', a: a};
	};
	var author$project$Components$TicketEventNotification$EditNotification$emailValue = function (recipient) {
		if (recipient.$ === 'Role') {
			return '';
		} else {
			var email = recipient.a;
			return email;
		}
	};
	var author$project$Components$TicketEventNotification$EditNotification$RemoveRecipient = F2(
		function (a, b) {
			return {$: 'RemoveRecipient', a: a, b: b};
		});
	var rtfeldman$elm_css$Html$Styled$i = rtfeldman$elm_css$Html$Styled$node('i');
	var author$project$Components$TicketEventNotification$EditNotification$viewRecipient = F2(
		function (notificationMessage, recipients) {
			var _n0 = function () {
				if (recipients.$ === 'Role') {
					var _n2 = recipients.a;
					var code = _n2.a;
					var label = _n2.b;
					return _Utils_Tuple3('role ', code, label);
				} else {
					var email = recipients.a;
					return _Utils_Tuple3('email ', email, email);
				}
			}();
			var icon = _n0.a;
			var id = _n0.b;
			var labelToDisplay = _n0.c;
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$i,
						_List_fromArray(
							[author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(icon)
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(labelToDisplay)
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onClick(
								A2(author$project$Components$TicketEventNotification$EditNotification$RemoveRecipient, notificationMessage, id))
							]),
						_List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Html$Styled$i,
								_List_Nil,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text('x')
									]))
							]))
					]));
		});
	var author$project$Components$TicketEventNotification$EditNotification$SelectRoleRecipient = F2(
		function (a, b) {
			return {$: 'SelectRoleRecipient', a: a, b: b};
		});
	var author$project$Components$TicketEventNotification$EditNotification$recipientToId = function (recipient) {
		if (recipient.$ === 'Role') {
			var r = recipient.a;
			return r.a;
		} else {
			var email = recipient.a;
			return email;
		}
	};
	var rtfeldman$elm_css$Html$Styled$option = rtfeldman$elm_css$Html$Styled$node('option');
	var rtfeldman$elm_css$Html$Styled$select = rtfeldman$elm_css$Html$Styled$node('select');
	var elm$json$Json$Encode$bool = _Json_wrap;
	var rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
		function (key, bool) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$bool(bool));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$selected = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
	var rtfeldman$elm_css$Html$Styled$Attributes$value = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
	var rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
		return _Utils_Tuple2(x, true);
	};
	var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
		return {$: 'MayStopPropagation', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
			'input',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
				A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue)));
	};
	var author$project$Components$TicketEventNotification$EditNotification$viewRoleToAdd = function (message) {
		var buildOption = function (_n0) {
			var a = _n0.a;
			var b = _n0.b;
			return A2(
				rtfeldman$elm_css$Html$Styled$option,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$selected(
						A2(
							elm$core$Maybe$withDefault,
							false,
							A2(
								elm$core$Maybe$map,
								A2(
									elm$core$Basics$composeR,
									author$project$Components$TicketEventNotification$EditNotification$recipientToId,
									elm$core$Basics$eq(a)),
								message.recipientToAdd))),
						rtfeldman$elm_css$Html$Styled$Attributes$value(a)
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text(b)
					]));
		};
		return A2(
			rtfeldman$elm_css$Html$Styled$select,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onInput(
					author$project$Components$TicketEventNotification$EditNotification$SelectRoleRecipient(message)),
					author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer
				]),
			A2(
				elm$core$List$map,
				buildOption,
				A2(
					elm$core$List$cons,
					_Utils_Tuple2('', ''),
					author$project$Components$TicketEventNotification$NotificationData$roles)));
	};
	var rtfeldman$elm_css$Css$row = {flexDirection: rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'row'};
	var rtfeldman$elm_css$Css$column = _Utils_update(
		rtfeldman$elm_css$Css$row,
		{value: 'column'});
	var rtfeldman$elm_css$Css$flexDirection = rtfeldman$elm_css$Css$prop1('flex-direction');
	var elm$core$Basics$pi = _Basics_pi;
	var rtfeldman$elm_css$Css$degreesToRadians = function (degrees) {
		return (degrees * 180) / elm$core$Basics$pi;
	};
	var elm$core$Basics$abs = function (n) {
		return (n < 0) ? (-n) : n;
	};
	var elm$core$Basics$degrees = function (angleInDegrees) {
		return (angleInDegrees * elm$core$Basics$pi) / 180;
	};
	var rtfeldman$elm_css$Css$fmod = F2(
		function (f, n) {
			var integer = elm$core$Basics$floor(f);
			return (A2(elm$core$Basics$modBy, n, integer) + f) - integer;
		});
	var rtfeldman$elm_css$Css$hslToRgb = F3(
		function (hueVal, saturationVal, lightness) {
			var normHue = hueVal / elm$core$Basics$degrees(60);
			var chroma = (1 - elm$core$Basics$abs((2 * lightness) - 1)) * saturationVal;
			var m = lightness - (chroma / 2);
			var x = chroma * (1 - elm$core$Basics$abs(
				A2(rtfeldman$elm_css$Css$fmod, normHue, 2) - 1));
			var _n0 = (normHue < 0) ? _Utils_Tuple3(0, 0, 0) : ((normHue < 1) ? _Utils_Tuple3(chroma, x, 0) : ((normHue < 2) ? _Utils_Tuple3(x, chroma, 0) : ((normHue < 3) ? _Utils_Tuple3(0, chroma, x) : ((normHue < 4) ? _Utils_Tuple3(0, x, chroma) : ((normHue < 5) ? _Utils_Tuple3(x, 0, chroma) : ((normHue < 6) ? _Utils_Tuple3(chroma, 0, x) : _Utils_Tuple3(0, 0, 0)))))));
			var r = _n0.a;
			var g = _n0.b;
			var b = _n0.c;
			return _Utils_Tuple3(r + m, g + m, b + m);
		});
	var rtfeldman$elm_css$Css$hslaToRgba = F5(
		function (value, hueVal, saturationVal, lightness, hslAlpha) {
			var _n0 = A3(
				rtfeldman$elm_css$Css$hslToRgb,
				rtfeldman$elm_css$Css$degreesToRadians(hueVal),
				saturationVal,
				lightness);
			var red = _n0.a;
			var green = _n0.b;
			var blue = _n0.c;
			return {
				alpha: hslAlpha,
				blue: elm$core$Basics$floor(blue),
				color: rtfeldman$elm_css$Css$Structure$Compatible,
				green: elm$core$Basics$floor(green),
				red: elm$core$Basics$floor(red),
				value: value
			};
		});
	var rtfeldman$elm_css$Css$numericalPercentageToString = function (value) {
		return elm$core$String$fromFloat(value * 100) + '%';
	};
	var rtfeldman$elm_css$Css$hsl = F3(
		function (hueVal, saturationVal, lightnessVal) {
			var valuesList = _List_fromArray(
				[
					elm$core$String$fromFloat(hueVal),
					rtfeldman$elm_css$Css$numericalPercentageToString(saturationVal),
					rtfeldman$elm_css$Css$numericalPercentageToString(lightnessVal)
				]);
			var value = A2(rtfeldman$elm_css$Css$cssFunction, 'hsl', valuesList);
			return A5(rtfeldman$elm_css$Css$hslaToRgba, value, hueVal, saturationVal, lightnessVal, 1);
		});
	var rtfeldman$elm_css$Html$Styled$textarea = rtfeldman$elm_css$Html$Styled$node('textarea');
	var author$project$Components$TicketEventNotification$EditNotification$viewNotificationMessage = function (message) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$displayFlex,
							rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$row),
							rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
							A3(
							rtfeldman$elm_css$Css$border3,
							rtfeldman$elm_css$Css$px(1),
							rtfeldman$elm_css$Css$solid,
							A3(rtfeldman$elm_css$Css$hsl, 0, 0, 0)),
							rtfeldman$elm_css$Css$padding(
							rtfeldman$elm_css$Css$px(10))
						]))
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flexGrow(
									rtfeldman$elm_css$Css$int(1)),
									rtfeldman$elm_css$Css$displayFlex,
									rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$column)
								])),
							author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$label,
							_List_Nil,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Message')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$textarea,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onInput(
									author$project$Components$TicketEventNotification$EditNotification$MessageTextChange(message))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(message.text)
								]))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flexGrow(
									rtfeldman$elm_css$Css$int(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$label,
							_List_Nil,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Destinataires')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[author$project$Components$TicketEventNotification$EditNotification$verticalSpacer]),
							_List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Html$Styled$input,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onInput(
											author$project$Components$TicketEventNotification$EditNotification$ChangeMailRecipient(message)),
											rtfeldman$elm_css$Html$Styled$Attributes$value(
											A2(
												elm$core$Maybe$withDefault,
												'',
												A2(elm$core$Maybe$map, author$project$Components$TicketEventNotification$EditNotification$emailValue, message.recipientToAdd))),
											author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer
										]),
									_List_Nil),
									A2(
									rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(
											author$project$Components$TicketEventNotification$EditNotification$AddRecipient(message))
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('Ajouter un email')
										]))
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[author$project$Components$TicketEventNotification$EditNotification$verticalSpacer]),
							_List_fromArray(
								[
									author$project$Components$TicketEventNotification$EditNotification$viewRoleToAdd(message),
									A2(
									rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(
											author$project$Components$TicketEventNotification$EditNotification$AddRecipient(message))
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('Ajouter un role')
										]))
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2(
								elm$core$List$map,
								author$project$Components$TicketEventNotification$EditNotification$viewRecipient(message),
								message.recipients))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Components$TicketEventNotification$EditNotification$RemoveMessageNotification(message)),
									author$project$Utils$Style$defaultButtonStyle
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Supprimer le message')
								]))
						]))
				]));
	};
	var rtfeldman$elm_css$Css$right = rtfeldman$elm_css$Css$prop1('right');
	var rtfeldman$elm_css$Html$Styled$h2 = rtfeldman$elm_css$Html$Styled$node('h2');
	var rtfeldman$elm_css$Html$Styled$section = rtfeldman$elm_css$Html$Styled$node('section');
	var author$project$Components$TicketEventNotification$EditNotification$view = function (model) {
		var showError = author$project$Components$TicketEventNotification$EditNotification$showFormError(model.formErrors);
		return A2(
			rtfeldman$elm_css$Html$Styled$section,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(
							A2(
								elm$core$Maybe$withDefault,
								'Ajouter une notification',
								A2(
									elm$core$Maybe$map,
									elm$core$Basics$always('Editer une notification'),
									model.config.id)))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[author$project$Components$TicketEventNotification$EditNotification$verticalSpacer]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Nom de la notification')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$value(
									A2(elm$core$Maybe$withDefault, '', model.config.label)),
									rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Components$TicketEventNotification$EditNotification$LabelChange)
								]),
							_List_Nil),
							showError(author$project$Components$TicketEventNotification$EditNotification$MandatoryConfigLabel)
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[author$project$Components$TicketEventNotification$EditNotification$verticalSpacer]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('Raison d\'ouverture de ticket')
										])),
									showError(author$project$Components$TicketEventNotification$EditNotification$NEL_Otps)
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									author$project$Components$TicketEventNotification$EditNotification$showOtp(model.multiselectOtps)
								]))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[author$project$Components$TicketEventNotification$EditNotification$verticalSpacer]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Html$Styled$label,
									_List_fromArray(
										[author$project$Components$TicketEventNotification$EditNotification$horizontalSpacer]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('Evènements déclencheurs')
										])),
									showError(author$project$Components$TicketEventNotification$EditNotification$NEL_TrigerredEvents)
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$fromUnstyled(
									A2(
										elm$html$Html$map,
										author$project$Components$TicketEventNotification$EditNotification$TriggerEventMultiselect,
										inkuzmin$elm_multiselect$Multiselect$view(model.multiselectTriggerEvents)))
								]))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[author$project$Components$TicketEventNotification$EditNotification$verticalSpacer]),
					A2(elm$core$List$map, author$project$Components$TicketEventNotification$EditNotification$viewNotificationMessage, model.config.messages)),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Components$TicketEventNotification$EditNotification$AddMessageNotification),
									author$project$Utils$Style$defaultButtonStyle
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Ajouter un autre message')
								])),
							showError(author$project$Components$TicketEventNotification$EditNotification$MessageKO),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$flexGrow(
											rtfeldman$elm_css$Css$int(1)),
											rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$right)
										]))
								]),
							_List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Components$TicketEventNotification$EditNotification$NotificationAdded),
											rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$marginRight(
													rtfeldman$elm_css$Css$em(3))
												])),
											author$project$Utils$Style$defaultButtonStyle
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('Annuler')
										])),
									A2(
									rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Components$TicketEventNotification$EditNotification$AddNotification),
											author$project$Utils$Style$primaryButtonStyle
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text(
											A2(
												elm$core$Maybe$withDefault,
												'Créer la notification',
												A2(
													elm$core$Maybe$map,
													elm$core$Basics$always('Modifier'),
													model.config.id)))
										]))
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$color(
													rtfeldman$elm_css$Css$hex('f00'))
												]))
										]),
									A2(
										elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											elm$core$Maybe$map,
											author$project$Components$TicketEventNotification$EditNotification$printlnError(model.config),
											model.apiError)))
								]))
						]))
				]));
	};
	var author$project$Main$viewEdit = function (subModel) {
		return rtfeldman$elm_css$Html$Styled$fromUnstyled(
			A2(
				elm$html$Html$map,
				author$project$Main$EditNotificationMsg,
				rtfeldman$elm_css$Html$Styled$toUnstyled(
					author$project$Components$TicketEventNotification$EditNotification$view(subModel))));
	};
	var author$project$Main$view = function (model) {
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$core$Maybe$withDefault,
						A2(author$project$Main$defaultView, model.list, model.otpsRef),
						A2(elm$core$Maybe$map, author$project$Main$viewEdit, model.notification))
					])));
	};
	var elm$browser$Browser$element = _Browser_element;
	var author$project$Main$main = elm$browser$Browser$element(
		{init: author$project$Main$init, subscriptions: author$project$Main$subscriptions, update: author$project$Main$update, view: author$project$Main$view});
	_Platform_export({'Main':{'init':author$project$Main$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (listUrl) {
				return elm$json$Json$Decode$succeed(
					{listUrl: listUrl});
			},
			A2(elm$json$Json$Decode$field, 'listUrl', elm$json$Json$Decode$string)))(0)}});}(this));

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$Components$QualificationCriteria$Referential$Model$Model = F4(
		function (flags, criteria, editingCriterion, navigationLinks) {
			return {criteria: criteria, editingCriterion: editingCriterion, flags: flags, navigationLinks: navigationLinks};
		});
	var author$project$Components$QualificationCriteria$Referential$Update$FetchCriteria = {$: 'FetchCriteria'};
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var author$project$Components$QualificationCriteria$Referential$Update$init = function (flags) {
		return _Utils_Tuple2(
			A4(author$project$Components$QualificationCriteria$Referential$Model$Model, flags, _List_Nil, elm$core$Maybe$Nothing, _List_Nil),
			author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Referential$Update$FetchCriteria));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$Components$QualificationCriteria$Referential$Update$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerb = function (s) {
		switch (s) {
			case 'GET':
				return elm$core$Result$Ok(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$core$Result$Ok(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$core$Result$Ok(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$core$Result$Ok(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$core$Result$Err(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var author$project$Components$QualificationCriteria$Referential$Model$Criterion = F4(
		function (uid, title, values, links) {
			return {links: links, title: title, uid: uid, values: values};
		});
	var author$project$Components$QualificationCriteria$Referential$Model$CriterionForEdition = F3(
		function (uid, title, values) {
			return {title: title, uid: uid, values: values};
		});
	var author$project$Components$QualificationCriteria$Referential$Model$CriterionValue = F2(
		function (uid, value) {
			return {uid: uid, value: value};
		});
	var author$project$Components$QualificationCriteria$Referential$Model$EditingCriterion = F2(
		function (action, criterion) {
			return {action: action, criterion: criterion};
		});
	var elm$json$Json$Decode$decodeValue = _Json_run;
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var elm$json$Json$Decode$value = _Json_decodeValue;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
		function (pathDecoder, valDecoder, fallback) {
			var nullOr = function (decoder) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							decoder,
							elm$json$Json$Decode$null(fallback)
						]));
			};
			var handleResult = function (input) {
				var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
				if (_n0.$ === 'Ok') {
					var rawValue = _n0.a;
					var _n1 = A2(
						elm$json$Json$Decode$decodeValue,
						nullOr(valDecoder),
						rawValue);
					if (_n1.$ === 'Ok') {
						var finalResult = _n1.a;
						return elm$json$Json$Decode$succeed(finalResult);
					} else {
						var finalErr = _n1.a;
						return elm$json$Json$Decode$fail(
							elm$json$Json$Decode$errorToString(finalErr));
					}
				} else {
					return elm$json$Json$Decode$succeed(fallback);
				}
			};
			return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
		});
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
		function (key, valDecoder, fallback, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
					A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
					valDecoder,
					fallback),
				decoder);
		});
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$nullable = function (decoder) {
		return elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
				]));
	};
	var author$project$Components$QualificationCriteria$Referential$Model$criterionValueDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		elm$json$Json$Decode$string,
		A4(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'uid',
			elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
			elm$core$Maybe$Nothing,
			elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Referential$Model$CriterionValue)));
	var author$project$Components$QualificationCriteria$Referential$Model$criterionDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'values',
			elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Referential$Model$criterionValueDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				elm$json$Json$Decode$string,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Referential$Model$Criterion)))));
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var elm$json$Json$Encode$null = _Json_encodeNull;
	var elm$json$Json$Encode$object = function (pairs) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, obj) {
						var k = _n0.a;
						var v = _n0.b;
						return A3(_Json_addField, k, v, obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				pairs));
	};
	var elm$json$Json$Encode$string = _Json_wrap;
	var author$project$Components$QualificationCriteria$Referential$MyEncoder$encodeCriteriaValue = F2(
		function (link, value) {
			return A2(
				elm$core$Maybe$withDefault,
				function () {
					var _n0 = link.method;
					switch (_n0.$) {
						case 'POST':
							return elm$json$Json$Encode$string(value.value);
						case 'PATCH':
							return elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'value',
										elm$json$Json$Encode$string(value.value))
									]));
						default:
							return elm$json$Json$Encode$null;
					}
				}(),
				A2(
					elm$core$Maybe$map,
					function (uid) {
						return elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'uid',
									elm$json$Json$Encode$string(uid)),
									_Utils_Tuple2(
									'value',
									elm$json$Json$Encode$string(value.value))
								]));
					},
					value.uid));
		});
	var elm$json$Json$Encode$list = F2(
		function (func, entries) {
			return _Json_wrap(
				A3(
					elm$core$List$foldl,
					_Json_addEntry(func),
					_Json_emptyArray(_Utils_Tuple0),
					entries));
		});
	var author$project$Components$QualificationCriteria$Referential$MyEncoder$encodeCriterion = F2(
		function (link, criterion) {
			return elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'title',
						elm$json$Json$Encode$string(criterion.title)),
						_Utils_Tuple2(
						'values',
						A2(
							elm$json$Json$Encode$list,
							author$project$Components$QualificationCriteria$Referential$MyEncoder$encodeCriteriaValue(link),
							criterion.values))
					]));
		});
	var author$project$Components$QualificationCriteria$Referential$Update$CriteriaFetched = function (a) {
		return {$: 'CriteriaFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$Referential$Update$CriterionSaved = function (a) {
		return {$: 'CriterionSaved', a: a};
	};
	var author$project$Components$QualificationCriteria$Referential$Update$EditCriterionModeOn = function (a) {
		return {$: 'EditCriterionModeOn', a: a};
	};
	var author$project$Components$QualificationCriteria$Referential$Update$criterionUidForAdd = 'ADD';
	var author$project$Components$QualificationCriteria$Referential$Update$sendErrorToRedux = _Platform_outgoingPort('sendErrorToRedux', elm$json$Json$Encode$string);
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var author$project$Utils$Command$noOp = function (model) {
		return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
	};
	var author$project$Utils$Http$HttpRequest$Delete = F2(
		function (a, b) {
			return {$: 'Delete', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Patch = F3(
		function (a, b, c) {
			return {$: 'Patch', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$Post = F3(
		function (a, b, c) {
			return {$: 'Post', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$request = F3(
		function (link, body, exp) {
			var _n0 = link.method;
			switch (_n0.$) {
				case 'GET':
					return A2(author$project$Utils$Http$HttpRequest$Get, link.href, exp);
				case 'POST':
					return A3(author$project$Utils$Http$HttpRequest$Post, link.href, body, exp);
				case 'PATCH':
					return A3(author$project$Utils$Http$HttpRequest$Patch, link.href, body, exp);
				default:
					return A2(author$project$Utils$Http$HttpRequest$Delete, link.href, exp);
			}
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var author$project$Utils$Http$HttpRequest$authRequest = F3(
		function (link, body, exp) {
			return author$project$Utils$Http$HttpRequest$withAuthReq(
				A3(author$project$Utils$Http$HttpRequest$request, link, body, exp));
		});
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm$http$Http$expectBytesResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'arraybuffer',
				_Http_toDataView,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$expectWhatever = function (toMsg) {
		return A2(
			elm$http$Http$expectBytesResponse,
			toMsg,
			elm$http$Http$resolve(
				function (_n0) {
					return elm$core$Result$Ok(_Utils_Tuple0);
				}));
	};
	var elm$http$Http$jsonBody = function (value) {
		return A2(
			_Http_pair,
			'application/json',
			A2(elm$json$Json$Encode$encode, 0, value));
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var elm_community$list_extra$List$Extra$filterNot = F2(
		function (pred, list) {
			return A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, pred),
				list);
		});
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$drop = F2(
		function (n, list) {
			drop:
			while (true) {
				if (n <= 0) {
					return list;
				} else {
					if (!list.b) {
						return list;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs;
						n = $temp$n;
						list = $temp$list;
						continue drop;
					}
				}
			}
		});
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var elm_community$list_extra$List$Extra$removeAt = F2(
		function (index, l) {
			if (index < 0) {
				return l;
			} else {
				var tail = elm$core$List$tail(
					A2(elm$core$List$drop, index, l));
				var head = A2(elm$core$List$take, index, l);
				if (tail.$ === 'Nothing') {
					return l;
				} else {
					var t = tail.a;
					return A2(elm$core$List$append, head, t);
				}
			}
		});
	var elm_community$list_extra$List$Extra$updateAt = F3(
		function (index, fn, list) {
			if (index < 0) {
				return list;
			} else {
				var tail = A2(elm$core$List$drop, index, list);
				var head = A2(elm$core$List$take, index, list);
				if (tail.b) {
					var x = tail.a;
					var xs = tail.b;
					return _Utils_ap(
						head,
						A2(
							elm$core$List$cons,
							fn(x),
							xs));
				} else {
					return list;
				}
			}
		});
	var author$project$Components$QualificationCriteria$Referential$Update$update = F2(
		function (action, model) {
			switch (action.$) {
				case 'FetchCriteria':
					var link = A3(
						author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink,
						'criteriaref',
						model.flags.getCriteriaRefUrl,
						A2(
							elm$core$Result$withDefault,
							author$project$Binding$RestNavigationLinkDecoder$GET,
							author$project$Binding$RestNavigationLinkDecoder$string2HttpVerb(model.flags.getCriteriaRefMethod)));
					var cmd = A2(
						elm$http$Http$expectJson,
						author$project$Components$QualificationCriteria$Referential$Update$CriteriaFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Referential$Model$criterionDecoder)));
					return _Utils_Tuple2(
						model,
						A3(author$project$Utils$Http$HttpRequest$authRequest, link, elm$http$Http$emptyBody, cmd));
				case 'CriteriaFetched':
					if (action.a.$ === 'Ok') {
						var result = action.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{criteria: result.result, navigationLinks: result.links}),
							elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							model,
							author$project$Components$QualificationCriteria$Referential$Update$sendErrorToRedux('Récupération du référentiel de critères impossible'));
					}
				case 'AddNewCriterion':
					var link = action.a;
					var editCriterion = A3(author$project$Components$QualificationCriteria$Referential$Model$CriterionForEdition, elm$core$Maybe$Nothing, '', _List_Nil);
					var editingCriterion = A2(author$project$Components$QualificationCriteria$Referential$Model$EditingCriterion, link, editCriterion);
					var editModeOn = author$project$Utils$Command$msgToElmCmd(
						author$project$Components$QualificationCriteria$Referential$Update$EditCriterionModeOn(editingCriterion));
					var blankCriterion = A4(author$project$Components$QualificationCriteria$Referential$Model$Criterion, author$project$Components$QualificationCriteria$Referential$Update$criterionUidForAdd, '', _List_Nil, _List_Nil);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								criteria: _Utils_ap(
									_List_fromArray(
										[blankCriterion]),
									model.criteria)
							}),
						editModeOn);
				case 'EditCriterionModeOn':
					var criterion = action.a;
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{
								editingCriterion: elm$core$Maybe$Just(criterion)
							}));
				case 'DisplayCriterionModeOn':
					return author$project$Utils$Command$noOp(model);
				case 'EditCriterionModeOff':
					var removeNewCrit = A2(
						elm_community$list_extra$List$Extra$filterNot,
						function (c) {
							return _Utils_eq(c.uid, author$project$Components$QualificationCriteria$Referential$Update$criterionUidForAdd);
						},
						model.criteria);
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{criteria: removeNewCrit, editingCriterion: elm$core$Maybe$Nothing}));
				case 'EditTitle':
					var title = action.a;
					var editTitle = function (c) {
						return _Utils_update(
							c,
							{title: title});
					};
					var editedCriterion = A2(
						elm$core$Maybe$map,
						function (editing) {
							return _Utils_update(
								editing,
								{
									criterion: editTitle(editing.criterion)
								});
						},
						model.editingCriterion);
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{editingCriterion: editedCriterion}));
				case 'EditCriterionValue':
					var valIndex = action.a;
					var newValue = action.b;
					var editValue = function (c) {
						return A3(
							elm_community$list_extra$List$Extra$updateAt,
							valIndex,
							function (v) {
								return _Utils_update(
									v,
									{value: newValue});
							},
							c.values);
					};
					var editValues = function (c) {
						return _Utils_update(
							c,
							{
								values: editValue(c)
							});
					};
					var editedCriterion = A2(
						elm$core$Maybe$map,
						function (editing) {
							return _Utils_update(
								editing,
								{
									criterion: editValues(editing.criterion)
								});
						},
						model.editingCriterion);
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{editingCriterion: editedCriterion}));
				case 'RemoveCriterionValue':
					var criterionValueIndex = action.a;
					var removeValue = function (c) {
						return _Utils_update(
							c,
							{
								values: A2(elm_community$list_extra$List$Extra$removeAt, criterionValueIndex, c.values)
							});
					};
					var editedCriterion = A2(
						elm$core$Maybe$map,
						function (editing) {
							return _Utils_update(
								editing,
								{
									criterion: removeValue(editing.criterion)
								});
						},
						model.editingCriterion);
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{editingCriterion: editedCriterion}));
				case 'AddCriterionValue':
					var addValue = function (c) {
						return _Utils_update(
							c,
							{
								values: _Utils_ap(
									c.values,
									_List_fromArray(
										[
											A2(author$project$Components$QualificationCriteria$Referential$Model$CriterionValue, elm$core$Maybe$Nothing, '')
										]))
							});
					};
					var newCriteria = A2(
						elm$core$Maybe$map,
						function (editing) {
							return _Utils_update(
								editing,
								{
									criterion: addValue(editing.criterion)
								});
						},
						model.editingCriterion);
					return author$project$Utils$Command$noOp(
						_Utils_update(
							model,
							{editingCriterion: newCriteria}));
				case 'SaveCriterion':
					var editing = action.a;
					var expected = elm$http$Http$expectWhatever(author$project$Components$QualificationCriteria$Referential$Update$CriterionSaved);
					var body = elm$http$Http$jsonBody(
						A2(author$project$Components$QualificationCriteria$Referential$MyEncoder$encodeCriterion, editing.action, editing.criterion));
					var editComment = A3(author$project$Utils$Http$HttpRequest$authRequest, editing.action, body, expected);
					return _Utils_Tuple2(model, editComment);
				default:
					if (action.a.$ === 'Ok') {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{editingCriterion: elm$core$Maybe$Nothing}),
							author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Referential$Update$FetchCriteria));
					} else {
						var error = author$project$Components$QualificationCriteria$Referential$Update$sendErrorToRedux('Erreur - Sauvegarde impossible');
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{editingCriterion: elm$core$Maybe$Nothing}),
							elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Referential$Update$FetchCriteria),
										error
									])));
					}
			}
		});
	var author$project$Components$QualificationCriteria$Referential$Model$AddCriterion = {$: 'AddCriterion'};
	var author$project$Components$QualificationCriteria$Referential$Model$showRel = function (right) {
		switch (right.$) {
			case 'AddCriterion':
				return 'AddCriterion';
			case 'UpdateCriterion':
				return 'UpdateCriterion';
			default:
				return 'DeleteCriterion';
		}
	};
	var author$project$Components$QualificationCriteria$Referential$Update$AddNewCriterion = function (a) {
		return {$: 'AddNewCriterion', a: a};
	};
	var elm_community$list_extra$List$Extra$find = F2(
		function (predicate, list) {
			find:
			while (true) {
				if (!list.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var first = list.a;
					var rest = list.b;
					if (predicate(first)) {
						return elm$core$Maybe$Just(first);
					} else {
						var $temp$predicate = predicate,
							$temp$list = rest;
						predicate = $temp$predicate;
						list = $temp$list;
						continue find;
					}
				}
			}
		});
	var author$project$Utils$Http$NavigationLinkUtils$find = F2(
		function (rel, links) {
			return A2(
				elm_community$list_extra$List$Extra$find,
				function (l) {
					return _Utils_eq(rel, l.rel);
				},
				links);
		});
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$String$fromList = _String_fromList;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$Components$QualificationCriteria$Referential$View$addCriterionButton = function (model) {
		var rightToAddComment = A2(
			author$project$Utils$Http$NavigationLinkUtils$find,
			author$project$Components$QualificationCriteria$Referential$Model$showRel(author$project$Components$QualificationCriteria$Referential$Model$AddCriterion),
			model.navigationLinks);
		var addButton = function (l) {
			return A2(
				rtfeldman$elm_css$Html$Styled$button,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onClick(
						author$project$Components$QualificationCriteria$Referential$Update$AddNewCriterion(l)),
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(10))
							]))
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('ajouter un critère')
					]));
		};
		return A2(
			elm$core$Maybe$withDefault,
			A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
			A2(elm$core$Maybe$map, addButton, rightToAddComment));
	};
	var author$project$Components$QualificationCriteria$Referential$Model$UpdateCriterion = {$: 'UpdateCriterion'};
	var author$project$Components$QualificationCriteria$Referential$Model$initEditingCriterion = function (criterion) {
		return A3(
			author$project$Components$QualificationCriteria$Referential$Model$CriterionForEdition,
			elm$core$Maybe$Just(criterion.uid),
			criterion.title,
			criterion.values);
	};
	var author$project$Components$QualificationCriteria$Referential$Update$DisplayCriterionModeOn = function (a) {
		return {$: 'DisplayCriterionModeOn', a: a};
	};
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var author$project$Components$QualificationCriteria$Referential$View$criterionAbstractView = function (criterion) {
		var rightToEditCriterion = A2(
			author$project$Utils$Http$NavigationLinkUtils$find,
			author$project$Components$QualificationCriteria$Referential$Model$showRel(author$project$Components$QualificationCriteria$Referential$Model$UpdateCriterion),
			criterion.links);
		var editingComment = function (link) {
			return A2(
				author$project$Components$QualificationCriteria$Referential$Model$EditingCriterion,
				link,
				author$project$Components$QualificationCriteria$Referential$Model$initEditingCriterion(criterion));
		};
		var editMode = A2(
			elm$core$Maybe$withDefault,
			author$project$Components$QualificationCriteria$Referential$Update$DisplayCriterionModeOn(
				author$project$Components$QualificationCriteria$Referential$Model$initEditingCriterion(criterion)),
			A2(
				elm$core$Maybe$map,
				function (link) {
					return author$project$Components$QualificationCriteria$Referential$Update$EditCriterionModeOn(
						editingComment(link));
				},
				rightToEditCriterion));
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
							rtfeldman$elm_css$Css$padding(
							rtfeldman$elm_css$Css$px(15))
						])),
					rtfeldman$elm_css$Html$Styled$Events$onClick(editMode)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(
					criterion.title + (' (' + (elm$core$String$fromInt(
						elm$core$List$length(criterion.values)) + ')')))
				]));
	};
	var author$project$Components$QualificationCriteria$Referential$Update$AddCriterionValue = {$: 'AddCriterionValue'};
	var author$project$Components$QualificationCriteria$Referential$Update$EditCriterionModeOff = {$: 'EditCriterionModeOff'};
	var author$project$Components$QualificationCriteria$Referential$Update$EditTitle = function (a) {
		return {$: 'EditTitle', a: a};
	};
	var author$project$Components$QualificationCriteria$Referential$Update$SaveCriterion = function (a) {
		return {$: 'SaveCriterion', a: a};
	};
	var author$project$Components$QualificationCriteria$Referential$View$addIndex = function (l) {
		var fn = F2(
			function (item, acc) {
				return _Utils_ap(
					acc,
					_List_fromArray(
						[
							_Utils_Tuple2(
							elm$core$List$length(acc),
							item)
						]));
			});
		return A3(elm$core$List$foldl, fn, _List_Nil, l);
	};
	var author$project$Components$QualificationCriteria$Referential$Update$EditCriterionValue = F2(
		function (a, b) {
			return {$: 'EditCriterionValue', a: a, b: b};
		});
	var author$project$Components$QualificationCriteria$Referential$Update$RemoveCriterionValue = function (a) {
		return {$: 'RemoveCriterionValue', a: a};
	};
	var author$project$Components$QualificationCriteria$Referential$View$inputHeight = 40;
	var rtfeldman$elm_css$Css$height = rtfeldman$elm_css$Css$prop1('height');
	var rtfeldman$elm_css$Css$paddingLeft = rtfeldman$elm_css$Css$prop1('padding-left');
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var author$project$Components$QualificationCriteria$Referential$View$inputCss = rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$height(
				rtfeldman$elm_css$Css$px(author$project$Components$QualificationCriteria$Referential$View$inputHeight)),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$px(500)),
				rtfeldman$elm_css$Css$paddingLeft(
				rtfeldman$elm_css$Css$px(10))
			]));
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var rtfeldman$elm_css$Html$Styled$input = rtfeldman$elm_css$Html$Styled$node('input');
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$value = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
	var rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
		return _Utils_Tuple2(x, true);
	};
	var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
		return {$: 'MayStopPropagation', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
		});
	var elm$json$Json$Decode$at = F2(
		function (fields, decoder) {
			return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
		});
	var rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'value']),
		elm$json$Json$Decode$string);
	var rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
			'input',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
				A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue)));
	};
	var author$project$Components$QualificationCriteria$Referential$View$criteriaValueView = function (_n0) {
		var criterionValueIndex = _n0.a;
		var criterionValue = _n0.b;
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$value(criterionValue.value),
							rtfeldman$elm_css$Html$Styled$Events$onInput(
							author$project$Components$QualificationCriteria$Referential$Update$EditCriterionValue(criterionValueIndex)),
							author$project$Components$QualificationCriteria$Referential$View$inputCss
						]),
					_List_Nil),
					A2(
					rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Components$QualificationCriteria$Referential$Update$RemoveCriterionValue(criterionValueIndex)),
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$height(
									rtfeldman$elm_css$Css$px(author$project$Components$QualificationCriteria$Referential$View$inputHeight - 2)),
									rtfeldman$elm_css$Css$fontSize(
									rtfeldman$elm_css$Css$px(20))
								]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(' - ')
						]))
				]));
	};
	var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
	var author$project$Components$QualificationCriteria$Referential$View$editFormView = function (editing) {
		return _List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$value(editing.criterion.title),
						rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Components$QualificationCriteria$Referential$Update$EditTitle),
						author$project$Components$QualificationCriteria$Referential$View$inputCss
					]),
				_List_Nil),
				A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_Utils_ap(
					A2(
						elm$core$List$map,
						author$project$Components$QualificationCriteria$Referential$View$criteriaValueView,
						author$project$Components$QualificationCriteria$Referential$View$addIndex(editing.criterion.values)),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Components$QualificationCriteria$Referential$Update$AddCriterionValue)
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('ajouter une valeur')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$marginTop(
											rtfeldman$elm_css$Css$px(10))
										]))
								]),
							_List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Components$QualificationCriteria$Referential$Update$EditCriterionModeOff)
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('annuler')
										])),
									A2(
									rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Events$onClick(
											author$project$Components$QualificationCriteria$Referential$Update$SaveCriterion(editing))
										]),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text('sauvegarder')
										]))
								]))
						])))
			]);
	};
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$hidden = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, value: 'hidden', visibility: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$overflow = rtfeldman$elm_css$Css$prop1('overflow');
	var rtfeldman$elm_css$Css$visibility = rtfeldman$elm_css$Css$prop1('visibility');
	var rtfeldman$elm_css$Css$visible = {overflow: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, value: 'visible', visibility: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$Transitions$Height = {$: 'Height'};
	var rtfeldman$elm_css$Css$Transitions$Transition = function (a) {
		return {$: 'Transition', a: a};
	};
	var rtfeldman$elm_css$Css$Transitions$durationTransition = F2(
		function (animation, duration) {
			return rtfeldman$elm_css$Css$Transitions$Transition(
				{animation: animation, delay: elm$core$Maybe$Nothing, duration: duration, timing: elm$core$Maybe$Nothing});
		});
	var rtfeldman$elm_css$Css$Transitions$height = rtfeldman$elm_css$Css$Transitions$durationTransition(rtfeldman$elm_css$Css$Transitions$Height);
	var rtfeldman$elm_css$Css$Transitions$Padding = {$: 'Padding'};
	var rtfeldman$elm_css$Css$Transitions$padding = rtfeldman$elm_css$Css$Transitions$durationTransition(rtfeldman$elm_css$Css$Transitions$Padding);
	var rtfeldman$elm_css$Css$Transitions$propToString = function (prop) {
		switch (prop.$) {
			case 'Background':
				return 'background';
			case 'BackgroundColor':
				return 'background-color';
			case 'BackgroundPosition':
				return 'background-position';
			case 'BackgroundSize':
				return 'background-size';
			case 'Border':
				return 'border';
			case 'BorderBottom':
				return 'border-bottom';
			case 'BorderBottomColor':
				return 'border-bottom-color';
			case 'BorderBottomLeftRadius':
				return 'border-bottom-left-radius';
			case 'BorderBottomRightRadius':
				return 'border-bottom-right-radius';
			case 'BorderBottomWidth':
				return 'border-bottom-width';
			case 'BorderColor':
				return 'border-color';
			case 'BorderLeft':
				return 'border-left';
			case 'BorderLeftColor':
				return 'border-left-color';
			case 'BorderLeftWidth':
				return 'border-left-width';
			case 'BorderRadius':
				return 'border-radius';
			case 'BorderRight':
				return 'border-right';
			case 'BorderRightColor':
				return 'border-right-color';
			case 'BorderRightWidth':
				return 'border-right-width';
			case 'BorderTop':
				return 'border-top';
			case 'BorderTopColor':
				return 'border-top-color';
			case 'BorderTopLeftRadius':
				return 'border-top-left-radius';
			case 'BorderTopRightRadius':
				return 'border-top-right-radius';
			case 'BorderTopWidth':
				return 'border-top-width';
			case 'BorderWidth':
				return 'border-width';
			case 'Bottom':
				return 'bottom';
			case 'BoxShadow':
				return 'box-shadow';
			case 'CaretColor':
				return 'caret-color';
			case 'Clip':
				return 'clip';
			case 'ClipPath':
				return 'clip-path';
			case 'Color':
				return 'color';
			case 'ColumnCount':
				return 'column-count';
			case 'ColumnGap':
				return 'column-gap';
			case 'ColumnRule':
				return 'column-rule';
			case 'ColumnRuleColor':
				return 'column-rule-color';
			case 'ColumnRuleWidth':
				return 'column-rule-width';
			case 'ColumnWidth':
				return 'column-width';
			case 'Columns':
				return 'columns';
			case 'Filter':
				return 'filter';
			case 'Flex':
				return 'flex';
			case 'FlexBasis':
				return 'flex-basis';
			case 'FlexGrow':
				return 'flex-grow';
			case 'FlexShrink':
				return 'flex-shrink';
			case 'Font':
				return 'font';
			case 'FontSize':
				return 'font-size';
			case 'FontSizeAdjust':
				return 'font-size-adjust';
			case 'FontStretch':
				return 'font-stretch';
			case 'FontVariationSettings':
				return 'font-variation-settings';
			case 'FontWeight':
				return 'font-weight';
			case 'GridColumnGap':
				return 'grid-column-gap';
			case 'GridGap':
				return 'grid-gap';
			case 'GridRowGap':
				return 'grid-row-gap';
			case 'Height':
				return 'height';
			case 'Left':
				return 'left';
			case 'LetterSpacing':
				return 'letter-spacing';
			case 'LineHeight':
				return 'line-height';
			case 'Margin':
				return 'margin';
			case 'MarginBottom':
				return 'margin-bottom';
			case 'MarginLeft':
				return 'margin-left';
			case 'MarginRight':
				return 'margin-right';
			case 'MarginTop':
				return 'margin-top';
			case 'Mask':
				return 'mask';
			case 'MaskPosition':
				return 'mask-position';
			case 'MaskSize':
				return 'mask-size';
			case 'MaxHeight':
				return 'max-height';
			case 'MaxWidth':
				return 'max-width';
			case 'MinHeight':
				return 'min-height';
			case 'MinWidth':
				return 'min-width';
			case 'ObjectPosition':
				return 'object-position';
			case 'Offset':
				return 'offset';
			case 'OffsetAnchor':
				return 'offset-anchor';
			case 'OffsetDistance':
				return 'offset-distance';
			case 'OffsetPath':
				return 'offset-path';
			case 'OffsetRotate':
				return 'offset-rotate';
			case 'Opacity':
				return 'opacity';
			case 'Order':
				return 'order';
			case 'Outline':
				return 'outline';
			case 'OutlineColor':
				return 'outline-color';
			case 'OutlineOffset':
				return 'outline-offset';
			case 'OutlineWidth':
				return 'outline-width';
			case 'Padding':
				return 'padding';
			case 'PaddingBottom':
				return 'padding-bottom';
			case 'PaddingLeft':
				return 'padding-left';
			case 'PaddingRight':
				return 'padding-right';
			case 'PaddingTop':
				return 'padding-top';
			case 'Right':
				return 'right';
			case 'TabSize':
				return 'tab-size';
			case 'TextIndent':
				return 'text-indent';
			case 'TextShadow':
				return 'text-shadow';
			case 'Top':
				return 'top';
			case 'Transform':
				return 'transform';
			case 'TransformOrigin':
				return 'transform-origin';
			case 'VerticalAlign':
				return 'vertical-align';
			case 'Visibility':
				return 'visibility';
			case 'Width':
				return 'width';
			case 'WordSpacing':
				return 'word-spacing';
			default:
				return 'z-index';
		}
	};
	var rtfeldman$elm_css$Css$Transitions$timeToString = function (time) {
		return elm$core$String$fromFloat(time) + 'ms';
	};
	var rtfeldman$elm_css$Css$Transitions$timingFunctionToString = function (tf) {
		switch (tf.$) {
			case 'Ease':
				return 'ease';
			case 'Linear':
				return 'linear';
			case 'EaseIn':
				return 'ease-in';
			case 'EaseOut':
				return 'ease-out';
			case 'EaseInOut':
				return 'ease-in-out';
			case 'StepStart':
				return 'step-start';
			case 'StepEnd':
				return 'step-end';
			default:
				var _float = tf.a;
				var float2 = tf.b;
				var float3 = tf.c;
				var float4 = tf.d;
				return 'cubic-bezier(' + (elm$core$String$fromFloat(_float) + (' , ' + (elm$core$String$fromFloat(float2) + (' , ' + (elm$core$String$fromFloat(float3) + (' , ' + (elm$core$String$fromFloat(float4) + ')')))))));
		}
	};
	var rtfeldman$elm_css$Css$Transitions$transition = function (options) {
		var v = A3(
			elm$core$String$slice,
			0,
			-1,
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, s) {
						var animation = _n0.a.animation;
						var duration = _n0.a.duration;
						var delay = _n0.a.delay;
						var timing = _n0.a.timing;
						return s + (A2(
							elm$core$String$join,
							' ',
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Transitions$propToString(animation),
									rtfeldman$elm_css$Css$Transitions$timeToString(duration),
									A2(
									elm$core$Maybe$withDefault,
									'',
									A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Transitions$timeToString, delay)),
									A2(
									elm$core$Maybe$withDefault,
									'',
									A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Transitions$timingFunctionToString, timing))
								])) + ',');
					}),
				'',
				options));
		return A2(rtfeldman$elm_css$Css$property, 'transition', v);
	};
	var rtfeldman$elm_css$Css$Transitions$Visibility = {$: 'Visibility'};
	var rtfeldman$elm_css$Css$Transitions$visibility = rtfeldman$elm_css$Css$Transitions$durationTransition(rtfeldman$elm_css$Css$Transitions$Visibility);
	var author$project$Components$QualificationCriteria$Referential$View$criterionEditModView = F2(
		function (toEdit, criterion) {
			var testEdition = function (editing) {
				return (_Utils_eq(
					editing.action.rel,
					author$project$Components$QualificationCriteria$Referential$Model$showRel(author$project$Components$QualificationCriteria$Referential$Model$AddCriterion)) && _Utils_eq(criterion.uid, author$project$Components$QualificationCriteria$Referential$Update$criterionUidForAdd)) ? _Utils_Tuple2(
					true,
					author$project$Components$QualificationCriteria$Referential$View$editFormView(editing)) : A2(
					elm$core$Maybe$withDefault,
					_Utils_Tuple2(false, _List_Nil),
					A2(
						elm$core$Maybe$map,
						function (e_uid) {
							return _Utils_eq(e_uid, criterion.uid) ? _Utils_Tuple2(
								true,
								author$project$Components$QualificationCriteria$Referential$View$editFormView(editing)) : _Utils_Tuple2(false, _List_Nil);
						},
						editing.criterion.uid));
			};
			var calcHeight = function (vs) {
				return (elm$core$List$length(vs) * author$project$Components$QualificationCriteria$Referential$View$inputHeight) + 155;
			};
			var totalHeight = A2(
				elm$core$Maybe$withDefault,
				calcHeight(criterion.values),
				A2(
					elm$core$Maybe$map,
					function (e) {
						return calcHeight(e.criterion.values);
					},
					toEdit));
			var _n0 = A2(
				elm$core$Maybe$withDefault,
				_Utils_Tuple2(false, _List_Nil),
				A2(
					elm$core$Maybe$map,
					function (editing) {
						return testEdition(editing);
					},
					toEdit));
			var displayDetail = _n0.a;
			var form = _n0.b;
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								displayDetail ? rtfeldman$elm_css$Css$visibility(rtfeldman$elm_css$Css$visible) : rtfeldman$elm_css$Css$visibility(rtfeldman$elm_css$Css$hidden),
								displayDetail ? rtfeldman$elm_css$Css$height(
								rtfeldman$elm_css$Css$px(totalHeight)) : rtfeldman$elm_css$Css$height(
								rtfeldman$elm_css$Css$px(0)),
								displayDetail ? rtfeldman$elm_css$Css$padding(
								rtfeldman$elm_css$Css$px(25)) : rtfeldman$elm_css$Css$padding(
								rtfeldman$elm_css$Css$px(0)),
								rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden),
								rtfeldman$elm_css$Css$Transitions$transition(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$Transitions$height(450.0),
										rtfeldman$elm_css$Css$Transitions$visibility(450.0),
										rtfeldman$elm_css$Css$Transitions$padding(450)
									])),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('fff'))
							]))
					]),
				form);
		});
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var author$project$Components$QualificationCriteria$Referential$View$criterionBox = F2(
		function (toEdit, criterion) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$color(
								rtfeldman$elm_css$Css$hex('8a959a')),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('FBFBFB')),
								A3(
								rtfeldman$elm_css$Css$border3,
								rtfeldman$elm_css$Css$px(1),
								rtfeldman$elm_css$Css$solid,
								rtfeldman$elm_css$Css$hex('ddd')),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(10))
							]))
					]),
				_List_fromArray(
					[
						author$project$Components$QualificationCriteria$Referential$View$criterionAbstractView(criterion),
						A2(author$project$Components$QualificationCriteria$Referential$View$criterionEditModView, toEdit, criterion)
					]));
		});
	var author$project$Components$QualificationCriteria$Referential$View$view = function (model) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					author$project$Components$QualificationCriteria$Referential$View$addCriterionButton(model),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2(
						elm$core$List$map,
						function (c) {
							return A2(author$project$Components$QualificationCriteria$Referential$View$criterionBox, model.editingCriterion, c);
						},
						model.criteria))
				]));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$core$String$toInt = _String_toInt;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var author$project$QualificationCriteriaRef$main = elm$browser$Browser$element(
		{
			init: author$project$Components$QualificationCriteria$Referential$Update$init,
			subscriptions: author$project$Components$QualificationCriteria$Referential$Update$subscriptions,
			update: author$project$Components$QualificationCriteria$Referential$Update$update,
			view: A2(elm$core$Basics$composeR, author$project$Components$QualificationCriteria$Referential$View$view, rtfeldman$elm_css$Html$Styled$toUnstyled)
		});
	_Platform_export({'QualificationCriteriaRef':{'init':author$project$QualificationCriteriaRef$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (getCriteriaRefUrl) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (getCriteriaRefMethod) {
						return elm$json$Json$Decode$succeed(
							{getCriteriaRefMethod: getCriteriaRefMethod, getCriteriaRefUrl: getCriteriaRefUrl});
					},
					A2(elm$json$Json$Decode$field, 'getCriteriaRefMethod', elm$json$Json$Decode$string));
			},
			A2(elm$json$Json$Decode$field, 'getCriteriaRefUrl', elm$json$Json$Decode$string)))(0)}});}(this));

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$Components$QualificationCriteria$TicketAnswers$Model$Model = F8(
		function (flags, networkAccess, tree, answers, availableWorkflows, criteriaRef, contextualComments, treeUid) {
			return {answers: answers, availableWorkflows: availableWorkflows, contextualComments: contextualComments, criteriaRef: criteriaRef, flags: flags, networkAccess: networkAccess, tree: tree, treeUid: treeUid};
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$FetchContextualComment = {$: 'FetchContextualComment'};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$FetchCriteriaRef = {$: 'FetchCriteriaRef'};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$FetchWorkflow = {$: 'FetchWorkflow'};
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$init = function (flags) {
		return _Utils_Tuple2(
			A8(author$project$Components$QualificationCriteria$TicketAnswers$Model$Model, flags, 0, elm$core$Maybe$Nothing, _List_Nil, _List_Nil, _List_Nil, _List_Nil, elm$core$Maybe$Nothing),
			elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$TicketAnswers$Update$FetchWorkflow),
						author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$TicketAnswers$Update$FetchCriteriaRef),
						author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$TicketAnswers$Update$FetchContextualComment)
					])));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Components$ContextualComment$State$Comment = F4(
		function (uid, title, comment, links) {
			return {comment: comment, links: links, title: title, uid: uid};
		});
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$ContextualCommentDecoder$commentRefDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'comment',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				elm$json$Json$Decode$string,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Components$ContextualComment$State$Comment)))));
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var author$project$Components$QualificationCriteria$Common$Model$WorkflowRef = F2(
		function (uid, label) {
			return {label: label, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Common$ModelJsonDecoder$decodeWorkflow = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Common$Model$WorkflowRef)));
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$Criterion = F3(
		function (uid, title, values) {
			return {title: title, uid: uid, values: values};
		});
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var elm_community$list_extra$List$Extra$find = F2(
		function (predicate, list) {
			find:
			while (true) {
				if (!list.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var first = list.a;
					var rest = list.b;
					if (predicate(first)) {
						return elm$core$Maybe$Just(first);
					} else {
						var $temp$predicate = predicate,
							$temp$list = rest;
						predicate = $temp$predicate;
						list = $temp$list;
						continue find;
					}
				}
			}
		});
	var author$project$Components$QualificationCriteria$Common$Service$getCriteria = F2(
		function (criteriaRef, uid) {
			return A2(
				elm$core$Maybe$withDefault,
				A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$Criterion, 'nocrit', 'noid', _List_Nil),
				A2(
					elm_community$list_extra$List$Extra$find,
					function (c) {
						return _Utils_eq(c.uid, uid);
					},
					criteriaRef));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$ContextualCommentLeaf = function (a) {
		return {$: 'ContextualCommentLeaf', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Criterion = F3(
		function (label, values, uid) {
			return {label: label, uid: uid, values: values};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionNode = function (a) {
		return {$: 'CriterionNode', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionValue = F3(
		function (value, nextStep, uid) {
			return {nextStep: nextStep, uid: uid, value: value};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CtxCommentLeaf = F3(
		function (uid, title, content) {
			return {content: content, title: title, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Workflow = F3(
		function (uid, label, nextStep) {
			return {label: label, nextStep: nextStep, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$WorkflowLeaf = function (a) {
		return {$: 'WorkflowLeaf', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$fromCommentRefToLeaf = function (ctx) {
		return A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CtxCommentLeaf, ctx.uid, ctx.title, ctx.comment);
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var author$project$Components$QualificationCriteria$Common$Service$treeDto2Model = F4(
		function (workflows, criteriaRef, commentsRef, treeDto) {
			var subTree2Model = A3(author$project$Components$QualificationCriteria$Common$Service$treeDto2Model, workflows, criteriaRef, commentsRef);
			var criteriaValueDTO2Model = F2(
				function (c, valueDto) {
					var getCriteriaValueLabel = A2(
						elm$core$Maybe$withDefault,
						'nolabel',
						A2(
							elm$core$Maybe$map,
							function ($) {
								return $.value;
							},
							A2(
								elm_community$list_extra$List$Extra$find,
								function (v) {
									return _Utils_eq(v.uid, valueDto.uid);
								},
								c.values)));
					return A3(
						author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionValue,
						getCriteriaValueLabel,
						A2(elm$core$Maybe$map, subTree2Model, valueDto.nextStep),
						valueDto.uid);
				});
			if (treeDto.$ === 'CriteriaNodeDTO') {
				var uid = treeDto.a;
				var values = treeDto.b;
				var criterion = A2(author$project$Components$QualificationCriteria$Common$Service$getCriteria, criteriaRef, uid);
				var newChilds = A2(
					elm$core$List$map,
					criteriaValueDTO2Model(criterion),
					values);
				return author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionNode(
					A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Criterion, criterion.title, newChilds, uid));
			} else {
				var uid = treeDto.a;
				var nextStep = treeDto.b;
				var comment = function (next) {
					return A2(
						elm$core$Maybe$withDefault,
						A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CtxCommentLeaf, next.uid, 'error', ''),
						A2(
							elm$core$Maybe$map,
							author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$fromCommentRefToLeaf,
							A2(
								elm_community$list_extra$List$Extra$find,
								function (c) {
									return _Utils_eq(c.uid, next.uid);
								},
								commentsRef)));
				};
				var child = A2(
					elm$core$Maybe$map,
					A2(elm$core$Basics$composeL, author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$ContextualCommentLeaf, comment),
					nextStep);
				var workflow = A2(
					elm$core$Maybe$withDefault,
					A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Workflow, uid, 'nowf', elm$core$Maybe$Nothing),
					A2(
						elm$core$Maybe$map,
						function (w) {
							return A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Workflow, uid, w.label, child);
						},
						A2(
							elm_community$list_extra$List$Extra$find,
							function (w) {
								return _Utils_eq(w.uid, uid);
							},
							workflows)));
				return author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$WorkflowLeaf(workflow);
			}
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$ContextualCommentFetched = function (a) {
		return {$: 'ContextualCommentFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$CriteriaRefFetched = function (a) {
		return {$: 'CriteriaRefFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$TreeFetched = function (a) {
		return {$: 'TreeFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$WorkflowFetched = function (a) {
		return {$: 'WorkflowFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$SelectAnswer = F2(
		function (a, b) {
			return {$: 'SelectAnswer', a: a, b: b};
		});
	var ccapndave$elm_flat_map$Maybe$FlatMap$join = function (mx) {
		if (mx.$ === 'Just') {
			var x = mx.a;
			return x;
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var ccapndave$elm_flat_map$Maybe$FlatMap$flatMap = F2(
		function (f, maybe) {
			return ccapndave$elm_flat_map$Maybe$FlatMap$join(
				A2(elm$core$Maybe$map, f, maybe));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$autocompleteNextAnswer = F2(
		function (model, nextQuestion) {
			var answerMatchQuestion = F2(
				function (alreadyAnswered, nextQ) {
					return _Utils_eq(alreadyAnswered.criterionUid, nextQ.criteria.uid) ? elm$core$Maybe$Just(
						A2(author$project$Components$QualificationCriteria$TicketAnswers$Update$SelectAnswer, nextQ.criteria, alreadyAnswered.choice.uid)) : elm$core$Maybe$Nothing;
				});
			return elm$core$Platform$Cmd$batch(
				A2(
					elm$core$List$map,
					author$project$Utils$Command$msgToElmCmd,
					A2(
						elm$core$List$filterMap,
						elm$core$Basics$identity,
						A2(
							elm$core$List$map,
							function (c) {
								return A2(
									ccapndave$elm_flat_map$Maybe$FlatMap$flatMap,
									answerMatchQuestion(c),
									nextQuestion);
							},
							model.flags.choices))));
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$FetchTree = {$: 'FetchTree'};
	var author$project$Utils$Command$decrementCounter = function (c) {
		return _Utils_update(
			c,
			{networkAccess: c.networkAccess - 1});
	};
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var author$project$Utils$Command$launchCmdWhenAllIsDone = F2(
		function (counter, cmd) {
			var decrementedCounter = author$project$Utils$Command$decrementCounter(counter);
			var ableToLaunchCmd = (!decrementedCounter.networkAccess) ? cmd : elm$core$Platform$Cmd$none;
			return _Utils_Tuple2(decrementedCounter, ableToLaunchCmd);
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$fetchTreeWhenRefsAllDownload = function (model) {
		return A2(
			author$project$Utils$Command$launchCmdWhenAllIsDone,
			model,
			author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$TicketAnswers$Update$FetchTree));
	};
	var elm$json$Json$Encode$list = F2(
		function (func, entries) {
			return _Json_wrap(
				A3(
					elm$core$List$foldl,
					_Json_addEntry(func),
					_Json_emptyArray(_Utils_Tuple0),
					entries));
		});
	var elm$json$Json$Encode$object = function (pairs) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, obj) {
						var k = _n0.a;
						var v = _n0.b;
						return A3(_Json_addField, k, v, obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				pairs));
	};
	var elm$json$Json$Encode$string = _Json_wrap;
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$qualifyTicketUpdate = _Platform_outgoingPort(
		'qualifyTicketUpdate',
		elm$json$Json$Encode$list(
			function ($) {
				return elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'choice',
							function ($) {
								return elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'uid',
											elm$json$Json$Encode$string($.uid)),
											_Utils_Tuple2(
											'value',
											elm$json$Json$Encode$string($.value))
										]));
							}($.choice)),
							_Utils_Tuple2(
							'criterionLabel',
							elm$json$Json$Encode$string($.criterionLabel)),
							_Utils_Tuple2(
							'criterionUid',
							elm$json$Json$Encode$string($.criterionUid))
						]));
			}));
	var author$project$Components$QualificationCriteria$TicketAnswers$Model$CriteriaAnswer = F2(
		function (criteria, selected) {
			return {criteria: criteria, selected: selected};
		});
	var ccapndave$elm_flat_map$List$FlatMap$join = A2(elm$core$List$foldr, elm$core$Basics$append, _List_Nil);
	var ccapndave$elm_flat_map$List$FlatMap$flatMap = F2(
		function (f, list) {
			return ccapndave$elm_flat_map$List$FlatMap$join(
				A2(elm$core$List$map, f, list));
		});
	var elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
		if (m.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var x = m.a;
			return _List_fromArray(
				[x]);
		}
	};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$toNextQuestion = function (t) {
		switch (t.$) {
			case 'CriterionNode':
				var criteria = t.a;
				return _List_fromArray(
					[
						A2(author$project$Components$QualificationCriteria$TicketAnswers$Model$CriteriaAnswer, criteria, elm$core$Maybe$Nothing)
					]);
			case 'WorkflowLeaf':
				var w = t.a;
				var text = '\n Workflow appliqué: ' + w.label;
				var commentChild = A2(
					ccapndave$elm_flat_map$List$FlatMap$flatMap,
					author$project$Components$QualificationCriteria$TicketAnswers$Update$toNextQuestion,
					elm_community$maybe_extra$Maybe$Extra$toList(w.nextStep));
				return _Utils_ap(
					_List_fromArray(
						[
							A2(
							author$project$Components$QualificationCriteria$TicketAnswers$Model$CriteriaAnswer,
							A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Criterion, text, _List_Nil, w.uid),
							elm$core$Maybe$Nothing)
						]),
					commentChild);
			default:
				var c = t.a;
				var text = '\n Commentaire: \n' + (c.title + ('\n' + c.content));
				return _List_fromArray(
					[
						A2(
						author$project$Components$QualificationCriteria$TicketAnswers$Model$CriteriaAnswer,
						A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Criterion, text, _List_Nil, c.uid),
						elm$core$Maybe$Nothing)
					]);
		}
	};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$CriterionChoice = F3(
		function (criterionUid, criterionLabel, choice) {
			return {choice: choice, criterionLabel: criterionLabel, criterionUid: criterionUid};
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$CriterionValue = F2(
		function (uid, value) {
			return {uid: uid, value: value};
		});
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$toCriterionChoice = F2(
		function (criteria, criterionAnswer) {
			var criterionValueUid = A2(elm$core$Maybe$withDefault, '', criterionAnswer.selected);
			var criterionValueValue = A2(
				elm$core$Maybe$withDefault,
				'',
				elm$core$List$head(
					A2(
						elm$core$List$map,
						function ($) {
							return $.value;
						},
						A2(
							elm$core$List$filterMap,
							function (c) {
								return A2(
									elm_community$list_extra$List$Extra$find,
									function (v) {
										return _Utils_eq(v.uid, criterionValueUid);
									},
									c.values);
							},
							criteria))));
			return A3(
				author$project$Components$QualificationCriteria$TicketAnswers$Update$CriterionChoice,
				criterionAnswer.criteria.uid,
				criterionAnswer.criteria.label,
				A2(author$project$Components$QualificationCriteria$TicketAnswers$Update$CriterionValue, criterionValueUid, criterionValueValue));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm_community$list_extra$List$Extra$filterNot = F2(
		function (pred, list) {
			return A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, pred),
				list);
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$toRequestQualification = F2(
		function (criteria, criteriaAnswers) {
			return A2(
				elm_community$list_extra$List$Extra$filterNot,
				function (c) {
					return (c.choice.uid === '') || (c.choice.value === '');
				},
				A2(
					elm$core$List$map,
					author$project$Components$QualificationCriteria$TicketAnswers$Update$toCriterionChoice(criteria),
					A2(
						elm$core$List$filter,
						function (c) {
							return !elm$core$List$isEmpty(c.criteria.values);
						},
						criteriaAnswers)));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$CriterionValue = F2(
		function (uid, value) {
			return {uid: uid, value: value};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaRefDecoder$criterionValueDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$CriterionValue)));
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaRefDecoder$criteriaRefDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'values',
		elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaRefDecoder$criterionValueDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$Criterion))));
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaTreeQueryView = F6(
		function (uid, clientCompanyReference, otps, tree, title, links) {
			return {clientCompanyReference: clientCompanyReference, links: links, otps: otps, title: title, tree: tree, uid: uid};
		});
	var elm$json$Json$Decode$decodeValue = _Json_run;
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var elm$json$Json$Decode$value = _Json_decodeValue;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
		function (pathDecoder, valDecoder, fallback) {
			var nullOr = function (decoder) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							decoder,
							elm$json$Json$Decode$null(fallback)
						]));
			};
			var handleResult = function (input) {
				var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
				if (_n0.$ === 'Ok') {
					var rawValue = _n0.a;
					var _n1 = A2(
						elm$json$Json$Decode$decodeValue,
						nullOr(valDecoder),
						rawValue);
					if (_n1.$ === 'Ok') {
						var finalResult = _n1.a;
						return elm$json$Json$Decode$succeed(finalResult);
					} else {
						var finalErr = _n1.a;
						return elm$json$Json$Decode$fail(
							elm$json$Json$Decode$errorToString(finalErr));
					}
				} else {
					return elm$json$Json$Decode$succeed(fallback);
				}
			};
			return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
		});
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
		function (key, valDecoder, fallback, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
					A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
					valDecoder,
					fallback),
				decoder);
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaNodeDTO = F2(
		function (a, b) {
			return {$: 'CriteriaNodeDTO', a: a, b: b};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaValueDTO = F2(
		function (uid, nextStep) {
			return {nextStep: nextStep, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$WorkflowNodeDTO = F2(
		function (a, b) {
			return {$: 'WorkflowNodeDTO', a: a, b: b};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$ContextualCommentNodeDTO = function (uid) {
		return {uid: uid};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCommentDTO = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'commentUid',
		elm$json$Json$Decode$string,
		elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$ContextualCommentNodeDTO));
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$nullable = function (decoder) {
		return elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
				]));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decoderWorkflow = A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'nextStep',
		elm$json$Json$Decode$nullable(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCommentDTO),
		elm$core$Maybe$Nothing,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'workflowUid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$WorkflowNodeDTO)));
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTreeNode = function (v) {
		switch (v) {
			case 'CriteriaNode':
				return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decoderCriteria();
			case 'WorkflowNode':
				return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decoderWorkflow;
			default:
				return elm$json$Json$Decode$fail('nodeType ' + (v + 'inconnu'));
		}
	};
	function author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decoderCriteria() {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'values',
			elm$json$Json$Decode$list(
				author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaValue()),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'criteriaUid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaNodeDTO)));
	}
	function author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaValue() {
		return A4(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nextStep',
			elm$json$Json$Decode$nullable(
				author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaTree()),
			elm$core$Maybe$Nothing,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaValueDTO)));
	}
	function author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaTree() {
		return A2(
			elm$json$Json$Decode$andThen,
			author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTreeNode,
			A2(elm$json$Json$Decode$field, 'nodeType', elm$json$Json$Decode$string));
	}
	try {
		var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decoderCriteria = author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decoderCriteria();
		author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decoderCriteria = function () {
			return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decoderCriteria;
		};
		var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaValue = author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaValue();
		author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaValue = function () {
			return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaValue;
		};
		var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTree = author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaTree();
		author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaTree = function () {
			return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTree;
		};
	} catch ($) {
	throw 'Some top-level definitions from `Components.QualificationCriteria.Tree.Edit.Json.Decoder.CriteriaTreeQueryViewDecoder` are causing infinite recursion:\n\n  ┌─────┐\n  │    decoderCriteria\n  │     ↓\n  │    decodeCriteriaValue\n  │     ↓\n  │    decodeCriteriaTree\n  │     ↓\n  │    decodeCriteriaTreeNode\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.0/halting-problem to learn how to fix it!';}
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTreeQueryView = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tree',
				author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTree,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'otps',
					elm$json$Json$Decode$list(elm$json$Json$Decode$string),
					A3(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'clientCompanyReference',
						elm$json$Json$Decode$string,
						A3(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'uid',
							elm$json$Json$Decode$string,
							elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaTreeQueryView)))))));
	var author$project$Utils$Command$incrementCounter = function (c) {
		return _Utils_update(
			c,
			{networkAccess: c.networkAccess + 1});
	};
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm_community$list_extra$List$Extra$dropWhile = F2(
		function (predicate, list) {
			dropWhile:
			while (true) {
				if (!list.b) {
					return _List_Nil;
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$predicate = predicate,
							$temp$list = xs;
						predicate = $temp$predicate;
						list = $temp$list;
						continue dropWhile;
					} else {
						return list;
					}
				}
			}
		});
	var elm_community$list_extra$List$Extra$takeWhile = function (predicate) {
		var takeWhileMemo = F2(
			function (memo, list) {
				takeWhileMemo:
				while (true) {
					if (!list.b) {
						return elm$core$List$reverse(memo);
					} else {
						var x = list.a;
						var xs = list.b;
						if (predicate(x)) {
							var $temp$memo = A2(elm$core$List$cons, x, memo),
								$temp$list = xs;
							memo = $temp$memo;
							list = $temp$list;
							continue takeWhileMemo;
						} else {
							return elm$core$List$reverse(memo);
						}
					}
				}
			});
		return takeWhileMemo(_List_Nil);
	};
	var elm_community$list_extra$List$Extra$span = F2(
		function (p, xs) {
			return _Utils_Tuple2(
				A2(elm_community$list_extra$List$Extra$takeWhile, p, xs),
				A2(elm_community$list_extra$List$Extra$dropWhile, p, xs));
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$Update$update = F2(
		function (action, model) {
			switch (action.$) {
				case 'FetchCriteriaRef':
					var url = model.flags.apiUrl + ('/clientcompanies/' + (model.flags.clientCompany + '/criteriaref'));
					var cmd = A2(
						elm$http$Http$expectJson,
						author$project$Components$QualificationCriteria$TicketAnswers$Update$CriteriaRefFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaRefDecoder$criteriaRefDecoder)));
					return _Utils_Tuple2(
						author$project$Utils$Command$incrementCounter(model),
						author$project$Utils$Http$HttpRequest$withAuthReq(
							A2(author$project$Utils$Http$HttpRequest$Get, url, cmd)));
				case 'CriteriaRefFetched':
					if (action.a.$ === 'Ok') {
						var result = action.a.a;
						var _n1 = author$project$Components$QualificationCriteria$TicketAnswers$Update$fetchTreeWhenRefsAllDownload(model);
						var decrementedCounter = _n1.a;
						var readyToFetchTree = _n1.b;
						return _Utils_Tuple2(
							_Utils_update(
								decrementedCounter,
								{criteriaRef: result.result}),
							readyToFetchTree);
					} else {
						return _Utils_Tuple2(
							author$project$Utils$Command$decrementCounter(model),
							elm$core$Platform$Cmd$none);
					}
				case 'FetchWorkflow':
					var url = model.flags.apiUrl + ('/clientcompanies/' + (model.flags.clientCompany + '/workflows'));
					var cmd = A2(
						elm$http$Http$expectJson,
						author$project$Components$QualificationCriteria$TicketAnswers$Update$WorkflowFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Common$ModelJsonDecoder$decodeWorkflow)));
					return _Utils_Tuple2(
						author$project$Utils$Command$incrementCounter(model),
						author$project$Utils$Http$HttpRequest$withAuthReq(
							A2(author$project$Utils$Http$HttpRequest$Get, url, cmd)));
				case 'WorkflowFetched':
					if (action.a.$ === 'Ok') {
						var result = action.a.a;
						var _n2 = author$project$Components$QualificationCriteria$TicketAnswers$Update$fetchTreeWhenRefsAllDownload(model);
						var decrementedCounter = _n2.a;
						var readyToFetchTree = _n2.b;
						return _Utils_Tuple2(
							_Utils_update(
								decrementedCounter,
								{availableWorkflows: result.result}),
							readyToFetchTree);
					} else {
						return _Utils_Tuple2(
							author$project$Utils$Command$decrementCounter(model),
							elm$core$Platform$Cmd$none);
					}
				case 'FetchContextualComment':
					var url = model.flags.apiUrl + ('/clientcompanies/' + (model.flags.clientCompany + '/contextualcommentref'));
					var cmd = A2(
						elm$http$Http$expectJson,
						author$project$Components$QualificationCriteria$TicketAnswers$Update$ContextualCommentFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Binding$ContextualCommentDecoder$commentRefDecoder)));
					return _Utils_Tuple2(
						author$project$Utils$Command$incrementCounter(model),
						author$project$Utils$Http$HttpRequest$withAuthReq(
							A2(author$project$Utils$Http$HttpRequest$Get, url, cmd)));
				case 'ContextualCommentFetched':
					if (action.a.$ === 'Ok') {
						var result = action.a.a;
						var _n3 = author$project$Components$QualificationCriteria$TicketAnswers$Update$fetchTreeWhenRefsAllDownload(model);
						var decrementedCounter = _n3.a;
						var readyToFetchTree = _n3.b;
						return _Utils_Tuple2(
							_Utils_update(
								decrementedCounter,
								{contextualComments: result.result}),
							readyToFetchTree);
					} else {
						return _Utils_Tuple2(
							author$project$Utils$Command$decrementCounter(model),
							elm$core$Platform$Cmd$none);
					}
				case 'FetchTree':
					var url = model.flags.apiUrl + ('/clientcompanies/' + (model.flags.clientCompany + ('/criteriatrees/findbyotp/' + model.flags.otp)));
					var cmd = A2(elm$http$Http$expectJson, author$project$Components$QualificationCriteria$TicketAnswers$Update$TreeFetched, author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTreeQueryView);
					return _Utils_Tuple2(
						model,
						author$project$Utils$Http$HttpRequest$withAuthReq(
							A2(author$project$Utils$Http$HttpRequest$Get, url, cmd)));
				case 'TreeFetched':
					if (action.a.$ === 'Ok') {
						var queryView = action.a.a;
						var newTree = A4(author$project$Components$QualificationCriteria$Common$Service$treeDto2Model, model.availableWorkflows, model.criteriaRef, model.contextualComments, queryView.tree);
						var firstAnswer = author$project$Components$QualificationCriteria$TicketAnswers$Update$toNextQuestion(newTree);
						var nextCmd = A2(
							author$project$Components$QualificationCriteria$TicketAnswers$Update$autocompleteNextAnswer,
							model,
							elm$core$List$head(firstAnswer));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									answers: firstAnswer,
									tree: elm$core$Maybe$Just(newTree),
									treeUid: elm$core$Maybe$Just(queryView.uid)
								}),
							nextCmd);
					} else {
						return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
					}
				default:
					var currentCriterion = action.a;
					var valueChosenUid = action.b;
					var valueMatch = function (v) {
						return _Utils_eq(v.uid, valueChosenUid);
					};
					var valuesMatchAnswer = function (a) {
						return A2(elm$core$List$any, valueMatch, a.criteria.values);
					};
					var nextQuestion = A2(
						ccapndave$elm_flat_map$List$FlatMap$flatMap,
						author$project$Components$QualificationCriteria$TicketAnswers$Update$toNextQuestion,
						elm_community$maybe_extra$Maybe$Extra$toList(
							A2(
								ccapndave$elm_flat_map$Maybe$FlatMap$flatMap,
								function ($) {
									return $.nextStep;
								},
								A2(elm_community$list_extra$List$Extra$find, valueMatch, currentCriterion.values))));
					var criteriaBeforeAnswer = function (a) {
						return A2(
							elm$core$List$all,
							A2(elm$core$Basics$composeR, valueMatch, elm$core$Basics$not),
							a.criteria.values);
					};
					var answerQuestion = function (a) {
						return valuesMatchAnswer(a) ? _Utils_update(
							a,
							{
								selected: elm$core$Maybe$Just(valueChosenUid)
							}) : a;
					};
					var alreadyAnswered = A2(
						author$project$Components$QualificationCriteria$TicketAnswers$Update$autocompleteNextAnswer,
						model,
						elm$core$List$head(nextQuestion));
					var _n4 = A2(
						elm_community$list_extra$List$Extra$span,
						criteriaBeforeAnswer,
						A2(elm$core$List$map, answerQuestion, model.answers));
					var before = _n4.a;
					var after = _n4.b;
					var getAnswer = elm_community$maybe_extra$Maybe$Extra$toList(
						elm$core$List$head(after));
					var answeredQuestions = _Utils_ap(before, getAnswer);
					var newAnswers = _Utils_ap(answeredQuestions, nextQuestion);
					var sendToRedux = author$project$Components$QualificationCriteria$TicketAnswers$Update$qualifyTicketUpdate(
						A2(author$project$Components$QualificationCriteria$TicketAnswers$Update$toRequestQualification, model.criteriaRef, newAnswers));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{answers: newAnswers}),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[sendToRedux, alreadyAnswered])));
			}
		});
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$ellipsis = {textOverflow: rtfeldman$elm_css$Css$Structure$Compatible, value: 'ellipsis'};
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$textOverflow = rtfeldman$elm_css$Css$prop1('text-overflow');
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$option = rtfeldman$elm_css$Html$Styled$node('option');
	var rtfeldman$elm_css$Html$Styled$select = rtfeldman$elm_css$Html$Styled$node('select');
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$json$Json$Encode$bool = _Json_wrap;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
		function (key, bool) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$bool(bool));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$selected = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$value = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
	var rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
		return _Utils_Tuple2(x, true);
	};
	var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
		return {$: 'MayStopPropagation', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
		});
	var elm$json$Json$Decode$at = F2(
		function (fields, decoder) {
			return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
		});
	var rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'value']),
		elm$json$Json$Decode$string);
	var rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
			'input',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
				A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue)));
	};
	var elm$virtual_dom$VirtualDom$attribute = F2(
		function (key, value) {
			return A2(
				_VirtualDom_attribute,
				_VirtualDom_noOnOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$String$fromList = _String_fromList;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Svg$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classAttribute = A2(elm$virtual_dom$VirtualDom$attribute, 'class', classname);
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classAttribute, styles, classname);
	};
	var rtfeldman$elm_css$Svg$Styled$Attributes$css = rtfeldman$elm_css$Svg$Styled$Internal$css;
	var author$project$Components$QualificationCriteria$TicketAnswers$View$mySelect = F3(
		function (action, values, current) {
			var toOption = function (_n1) {
				var key = _n1.a;
				var label = _n1.b;
				return A2(
					rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$value(key),
							rtfeldman$elm_css$Html$Styled$Attributes$selected(
							A2(
								elm$core$Maybe$withDefault,
								false,
								A2(
									elm$core$Maybe$map,
									elm$core$Basics$eq(key),
									current)))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(label)
						]));
			};
			var toOptions = A2(elm$core$List$map, toOption, values);
			var firstAnswer = A2(
				rtfeldman$elm_css$Html$Styled$option,
				_List_Nil,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('Choisir une réponse')
					]));
			var first = function () {
				if (current.$ === 'Nothing') {
					return elm$core$List$singleton(firstAnswer);
				} else {
					return _List_Nil;
				}
			}();
			return A2(
				rtfeldman$elm_css$Html$Styled$select,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onInput(action),
						rtfeldman$elm_css$Svg$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$fontSize(
								rtfeldman$elm_css$Css$em(1.1)),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$em(0.5)),
								rtfeldman$elm_css$Css$textOverflow(rtfeldman$elm_css$Css$ellipsis),
								rtfeldman$elm_css$Css$width(
								rtfeldman$elm_css$Css$pct(90))
							]))
					]),
				_Utils_ap(first, toOptions));
		});
	var author$project$Components$QualificationCriteria$TicketAnswers$View$toTuples = function (c) {
		return _Utils_Tuple2(c.uid, c.value);
	};
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var rtfeldman$elm_css$Html$Styled$p = rtfeldman$elm_css$Html$Styled$node('p');
	var author$project$Components$QualificationCriteria$TicketAnswers$View$viewCriteriaAnswer = function (answer) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2(
						elm$core$List$map,
						function (l) {
							return A2(
								rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text(l)
									]));
						},
						A2(elm$core$String$split, '\n', answer.criteria.label))),
					elm$core$List$isEmpty(answer.criteria.values) ? A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil) : A3(
					author$project$Components$QualificationCriteria$TicketAnswers$View$mySelect,
					author$project$Components$QualificationCriteria$TicketAnswers$Update$SelectAnswer(answer.criteria),
					A2(elm$core$List$map, author$project$Components$QualificationCriteria$TicketAnswers$View$toTuples, answer.criteria.values),
					answer.selected)
				]));
	};
	var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var author$project$Components$QualificationCriteria$TicketAnswers$View$view = function (model) {
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Svg$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$marginTop(
								rtfeldman$elm_css$Css$px(15))
							]))
					]),
				A2(elm$core$List$map, author$project$Components$QualificationCriteria$TicketAnswers$View$viewCriteriaAnswer, model.answers)));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$core$String$toInt = _String_toInt;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var author$project$QualificationCriteriaTicketAnswers$main = elm$browser$Browser$element(
		{init: author$project$Components$QualificationCriteria$TicketAnswers$Update$init, subscriptions: author$project$Components$QualificationCriteria$TicketAnswers$Update$subscriptions, update: author$project$Components$QualificationCriteria$TicketAnswers$Update$update, view: author$project$Components$QualificationCriteria$TicketAnswers$View$view});
	_Platform_export({'QualificationCriteriaTicketAnswers':{'init':author$project$QualificationCriteriaTicketAnswers$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (otp) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (clientCompany) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (choices) {
								return A2(
									elm$json$Json$Decode$andThen,
									function (apiUrl) {
										return elm$json$Json$Decode$succeed(
											{apiUrl: apiUrl, choices: choices, clientCompany: clientCompany, otp: otp});
									},
									A2(elm$json$Json$Decode$field, 'apiUrl', elm$json$Json$Decode$string));
							},
							A2(
								elm$json$Json$Decode$field,
								'choices',
								elm$json$Json$Decode$list(
									A2(
										elm$json$Json$Decode$andThen,
										function (criterionUid) {
											return A2(
												elm$json$Json$Decode$andThen,
												function (criterionLabel) {
													return A2(
														elm$json$Json$Decode$andThen,
														function (choice) {
															return elm$json$Json$Decode$succeed(
																{choice: choice, criterionLabel: criterionLabel, criterionUid: criterionUid});
														},
														A2(
															elm$json$Json$Decode$field,
															'choice',
															A2(
																elm$json$Json$Decode$andThen,
																function (value) {
																	return A2(
																		elm$json$Json$Decode$andThen,
																		function (uid) {
																			return elm$json$Json$Decode$succeed(
																				{uid: uid, value: value});
																		},
																		A2(elm$json$Json$Decode$field, 'uid', elm$json$Json$Decode$string));
																},
																A2(elm$json$Json$Decode$field, 'value', elm$json$Json$Decode$string))));
												},
												A2(elm$json$Json$Decode$field, 'criterionLabel', elm$json$Json$Decode$string));
										},
										A2(elm$json$Json$Decode$field, 'criterionUid', elm$json$Json$Decode$string)))));
					},
					A2(elm$json$Json$Decode$field, 'clientCompany', elm$json$Json$Decode$string));
			},
			A2(elm$json$Json$Decode$field, 'otp', elm$json$Json$Decode$string)))(0)}});}(this));

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$List$cons = _List_cons;
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Components$QualificationCriteria$Tree$List$Model$Flags = F3(
		function (apiUrl, clientCompany, navigationLinks) {
			return {apiUrl: apiUrl, clientCompany: clientCompany, navigationLinks: navigationLinks};
		});
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var author$project$Binding$ResultDecoder$emptyResultRecord = A2(author$project$Binding$ResultDecoder$ResultRecord, _List_Nil, _List_Nil);
	var author$project$Components$QualificationCriteria$Tree$List$Model$Model = F3(
		function (flags, list, leaveComponentState) {
			return {flags: flags, leaveComponentState: leaveComponentState, list: list};
		});
	var author$project$Components$QualificationCriteria$Tree$List$Update$FetchList = {$: 'FetchList'};
	var author$project$Components$QualificationCriteria$Utils$In = {$: 'In'};
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var author$project$Components$QualificationCriteria$Tree$List$Update$init = function (flags) {
		return _Utils_Tuple2(
			A3(author$project$Components$QualificationCriteria$Tree$List$Model$Model, flags, author$project$Binding$ResultDecoder$emptyResultRecord, author$project$Components$QualificationCriteria$Utils$In),
			author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Tree$List$Update$FetchList));
	};
	var author$project$QualificationCriteriaTree$ListAction = function (a) {
		return {$: 'ListAction', a: a};
	};
	var author$project$QualificationCriteriaTree$ListModel = function (a) {
		return {$: 'ListModel', a: a};
	};
	var author$project$QualificationCriteriaTree$State = F3(
		function (flags, componentModel, navigationLinks) {
			return {componentModel: componentModel, flags: flags, navigationLinks: navigationLinks};
		});
	var elm$core$Platform$Cmd$map = _Platform_map;
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var elm$json$Json$Decode$decodeValue = _Json_run;
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$QualificationCriteriaTree$init = function (flags) {
		var links = A2(
			elm$core$Result$withDefault,
			_List_Nil,
			A2(
				elm$json$Json$Decode$decodeValue,
				elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
				flags.navigationLinks));
		var _n0 = author$project$Components$QualificationCriteria$Tree$List$Update$init(
			A3(author$project$Components$QualificationCriteria$Tree$List$Model$Flags, flags.apiUrl, flags.clientCompany, links));
		var model = _n0.a;
		var cmd = _n0.b;
		return _Utils_Tuple2(
			A3(
				author$project$QualificationCriteriaTree$State,
				flags,
				author$project$QualificationCriteriaTree$ListModel(model),
				links),
			A2(elm$core$Platform$Cmd$map, author$project$QualificationCriteriaTree$ListAction, cmd));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$QualificationCriteriaTree$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var NoRedInk$elm_random_general$Random$General$step = F2(
		function (_n0, seed) {
			var gen = _n0.a;
			return gen(seed);
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$step = NoRedInk$elm_random_general$Random$General$step;
	var NoRedInk$elm_random_general$Random$General$Generator = function (a) {
		return {$: 'Generator', a: a};
	};
	var NoRedInk$elm_random_general$Random$General$map = F2(
		function (func, _n0) {
			var genA = _n0.a;
			return NoRedInk$elm_random_general$Random$General$Generator(
				function (seed0) {
					var _n1 = genA(seed0);
					var a = _n1.a;
					var seed1 = _n1.b;
					return _Utils_Tuple2(
						func(a),
						seed1);
				});
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map = NoRedInk$elm_random_general$Random$General$map;
	var NoRedInk$elm_uuid$Prng$Uuid$Uuid = function (a) {
		return {$: 'Uuid', a: a};
	};
	var NoRedInk$elm_random_general$Random$General$listHelp = F4(
		function (list_, n, generate, seed) {
			listHelp:
			while (true) {
				if (n < 1) {
					return _Utils_Tuple2(list_, seed);
				} else {
					var _n0 = generate(seed);
					var value = _n0.a;
					var newSeed = _n0.b;
					var $temp$list_ = A2(elm$core$List$cons, value, list_),
						$temp$n = n - 1,
						$temp$generate = generate,
						$temp$seed = newSeed;
					list_ = $temp$list_;
					n = $temp$n;
					generate = $temp$generate;
					seed = $temp$seed;
					continue listHelp;
				}
			}
		});
	var NoRedInk$elm_random_general$Random$General$list = F2(
		function (n, _n0) {
			var generate = _n0.a;
			return NoRedInk$elm_random_general$Random$General$Generator(
				function (seed) {
					return A4(NoRedInk$elm_random_general$Random$General$listHelp, _List_Nil, n, generate, seed);
				});
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$list = NoRedInk$elm_random_general$Random$General$list;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var NoRedInk$elm_random_general$Random$General$int = F3(
		function (_n0, a, b) {
			var c = _n0.a;
			return NoRedInk$elm_random_general$Random$General$Generator(
				function (seed0) {
					var _n1 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
					var lo = _n1.a;
					var hi = _n1.b;
					var range = (hi - lo) + 1;
					if (!((range - 1) & range)) {
						return _Utils_Tuple2(
							(((range - 1) & c.peel(seed0)) >>> 0) + lo,
							c.next(seed0));
					} else {
						var threshhold = (((-range) >>> 0) % range) >>> 0;
						var accountForBias = function (seed) {
							accountForBias:
							while (true) {
								var x = c.peel(seed);
								var seedN = c.next(seed);
								if (_Utils_cmp(x, threshhold) < 0) {
									var $temp$seed = seedN;
									seed = $temp$seed;
									continue accountForBias;
								} else {
									return _Utils_Tuple2((x % range) + lo, seedN);
								}
							}
						};
						return accountForBias(seed0);
					}
				});
		});
	var NoRedInk$elm_random_general$Random$General$Config = function (a) {
		return {$: 'Config', a: a};
	};
	var NoRedInk$elm_random_general$Random$General$makeConfig = F2(
		function (next, peel) {
			return NoRedInk$elm_random_general$Random$General$Config(
				{next: next, peel: peel});
		});
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed = F2(
		function (a, b) {
			return {$: 'Seed', a: a, b: b};
		});
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$next = function (_n0) {
		var state0 = _n0.a;
		var incr = _n0.b;
		return A2(NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
	};
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$Seed = function (a) {
		return {$: 'Seed', a: a};
	};
	var elm$core$Array$bitMask = 4294967295 >>> (32 - elm$core$Array$shiftStep);
	var elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
	var elm$core$Array$getHelp = F3(
		function (shift, index, tree) {
			getHelp:
			while (true) {
				var pos = elm$core$Array$bitMask & (index >>> shift);
				var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, pos, tree);
				if (_n0.$ === 'SubTree') {
					var subTree = _n0.a;
					var $temp$shift = shift - elm$core$Array$shiftStep,
						$temp$index = index,
						$temp$tree = subTree;
					shift = $temp$shift;
					index = $temp$index;
					tree = $temp$tree;
					continue getHelp;
				} else {
					var values = _n0.a;
					return A2(elm$core$Elm$JsArray$unsafeGet, elm$core$Array$bitMask & index, values);
				}
			}
		});
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var elm$core$Array$tailIndex = function (len) {
		return (len >>> 5) << 5;
	};
	var elm$core$Basics$ge = _Utils_ge;
	var elm$core$Array$get = F2(
		function (index, _n0) {
			var len = _n0.a;
			var startShift = _n0.b;
			var tree = _n0.c;
			var tail = _n0.d;
			return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? elm$core$Maybe$Nothing : ((_Utils_cmp(
				index,
				elm$core$Array$tailIndex(len)) > -1) ? elm$core$Maybe$Just(
				A2(elm$core$Elm$JsArray$unsafeGet, elm$core$Array$bitMask & index, tail)) : elm$core$Maybe$Just(
				A3(elm$core$Array$getHelp, startShift, index, tree)));
		});
	var elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
	var elm$core$Array$setHelp = F4(
		function (shift, index, value, tree) {
			var pos = elm$core$Array$bitMask & (index >>> shift);
			var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_n0.$ === 'SubTree') {
				var subTree = _n0.a;
				var newSub = A4(elm$core$Array$setHelp, shift - elm$core$Array$shiftStep, index, value, subTree);
				return A3(
					elm$core$Elm$JsArray$unsafeSet,
					pos,
					elm$core$Array$SubTree(newSub),
					tree);
			} else {
				var values = _n0.a;
				var newLeaf = A3(elm$core$Elm$JsArray$unsafeSet, elm$core$Array$bitMask & index, value, values);
				return A3(
					elm$core$Elm$JsArray$unsafeSet,
					pos,
					elm$core$Array$Leaf(newLeaf),
					tree);
			}
		});
	var elm$core$Array$set = F3(
		function (index, value, array) {
			var len = array.a;
			var startShift = array.b;
			var tree = array.c;
			var tail = array.d;
			return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
				index,
				elm$core$Array$tailIndex(len)) > -1) ? A4(
				elm$core$Array$Array_elm_builtin,
				len,
				startShift,
				tree,
				A3(elm$core$Elm$JsArray$unsafeSet, elm$core$Array$bitMask & index, value, tail)) : A4(
				elm$core$Array$Array_elm_builtin,
				len,
				startShift,
				A4(elm$core$Array$setHelp, startShift, index, value, tree),
				tail));
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtensionHelp = F3(
		function (index, prev, arr) {
			incrementExtensionHelp:
			while (true) {
				if (!prev) {
					var _n0 = A2(elm$core$Array$get, index, arr);
					if (_n0.$ === 'Just') {
						var elem = _n0.a;
						var newElem = (elem + 1013904223) >>> 0;
						var $temp$index = index + 1,
							$temp$prev = newElem,
							$temp$arr = A3(elm$core$Array$set, index, newElem, arr);
						index = $temp$index;
						prev = $temp$prev;
						arr = $temp$arr;
						continue incrementExtensionHelp;
					} else {
						return arr;
					}
				} else {
					return arr;
				}
			}
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtension = function (arr) {
		return A3(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtensionHelp, 0, 0, arr);
	};
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$next = function (_n0) {
		var s = _n0.a;
		var newBase = NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(s.base);
		var baseState = newBase.a;
		return NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$Seed(
			{
				base: newBase,
				extension: (!baseState) ? NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtension(s.extension) : s.extension
			});
	};
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel = function (_n0) {
		var state = _n0.a;
		var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
		return ((word >>> 22) ^ word) >>> 0;
	};
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$config = A2(NoRedInk$elm_random_general$Random$General$makeConfig, NoRedInk$elm_random_pcg_extended$Internal$Pcg$next, NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel);
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$int = NoRedInk$elm_random_general$Random$General$int(NoRedInk$elm_random_pcg_extended$Internal$Pcg$config);
	var elm$core$Array$length = function (_n0) {
		var len = _n0.a;
		return len;
	};
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$peel = function (_n0) {
		var s = _n0.a;
		var baseOut = NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel(s.base);
		var _n1 = A2(
			NoRedInk$elm_random_general$Random$General$step,
			A2(
				NoRedInk$elm_random_pcg_extended$Internal$Pcg$int,
				0,
				elm$core$Array$length(s.extension) - 1),
			s.base);
		var randIndex = _n1.a;
		var extension = A2(
			elm$core$Maybe$withDefault,
			0,
			A2(elm$core$Array$get, randIndex, s.extension));
		return (baseOut ^ extension) >>> 0;
	};
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$config = A2(NoRedInk$elm_random_general$Random$General$makeConfig, NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$next, NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$peel);
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$int = NoRedInk$elm_random_general$Random$General$int(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$config);
	var NoRedInk$elm_uuid$Prng$Uuid$hexGenerator = A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$int, 0, 15);
	var elm$core$Bitwise$or = _Bitwise_or;
	var NoRedInk$elm_uuid$Prng$Uuid$Barebones$limitDigitRange8ToB = function (digit) {
		return (digit & 3) | 8;
	};
	var elm$core$Array$fromListHelp = F3(
		function (list, nodeList, nodeListSize) {
			fromListHelp:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, list);
				var jsArray = _n0.a;
				var remainingItems = _n0.b;
				if (_Utils_cmp(
					elm$core$Elm$JsArray$length(jsArray),
					elm$core$Array$branchFactor) < 0) {
					return A2(
						elm$core$Array$builderToArray,
						true,
						{nodeList: nodeList, nodeListSize: nodeListSize, tail: jsArray});
				} else {
					var $temp$list = remainingItems,
						$temp$nodeList = A2(
						elm$core$List$cons,
						elm$core$Array$Leaf(jsArray),
						nodeList),
						$temp$nodeListSize = nodeListSize + 1;
					list = $temp$list;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue fromListHelp;
				}
			}
		});
	var elm$core$Array$fromList = function (list) {
		if (!list.b) {
			return elm$core$Array$empty;
		} else {
			return A3(elm$core$Array$fromListHelp, list, _List_Nil, 0);
		}
	};
	var elm$core$Char$fromCode = _Char_fromCode;
	var NoRedInk$elm_uuid$Prng$Uuid$Barebones$hexDigits = function () {
		var mapChars = F2(
			function (offset, digit) {
				return elm$core$Char$fromCode(digit + offset);
			});
		return elm$core$Array$fromList(
			_Utils_ap(
				A2(
					elm$core$List$map,
					mapChars(48),
					A2(elm$core$List$range, 0, 9)),
				A2(
					elm$core$List$map,
					mapChars(97),
					A2(elm$core$List$range, 0, 5))));
	}();
	var NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex = function (index) {
		var maybeResult = A2(elm$core$Array$get, index, NoRedInk$elm_uuid$Prng$Uuid$Barebones$hexDigits);
		if (maybeResult.$ === 'Nothing') {
			return _Utils_chr('x');
		} else {
			var result = maybeResult.a;
			return result;
		}
	};
	var elm$core$List$drop = F2(
		function (n, list) {
			drop:
			while (true) {
				if (n <= 0) {
					return list;
				} else {
					if (!list.b) {
						return list;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs;
						n = $temp$n;
						list = $temp$list;
						continue drop;
					}
				}
			}
		});
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var elm$core$String$concat = function (strings) {
		return A2(elm$core$String$join, '', strings);
	};
	var elm$core$String$fromList = _String_fromList;
	var NoRedInk$elm_uuid$Prng$Uuid$Barebones$toUuidString = function (thirtyOneHexDigits) {
		return elm$core$String$concat(
			_List_fromArray(
				[
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(elm$core$List$take, 8, thirtyOneHexDigits))),
					'-',
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$take,
							4,
							A2(elm$core$List$drop, 8, thirtyOneHexDigits)))),
					'-',
					'4',
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$take,
							3,
							A2(elm$core$List$drop, 12, thirtyOneHexDigits)))),
					'-',
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$map,
							NoRedInk$elm_uuid$Prng$Uuid$Barebones$limitDigitRange8ToB,
							A2(
								elm$core$List$take,
								1,
								A2(elm$core$List$drop, 15, thirtyOneHexDigits))))),
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$take,
							3,
							A2(elm$core$List$drop, 16, thirtyOneHexDigits)))),
					'-',
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$take,
							12,
							A2(elm$core$List$drop, 19, thirtyOneHexDigits))))
				]));
	};
	var NoRedInk$elm_uuid$Prng$Uuid$stringGenerator = A2(
		NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map,
		NoRedInk$elm_uuid$Prng$Uuid$Barebones$toUuidString,
		A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$list, 31, NoRedInk$elm_uuid$Prng$Uuid$hexGenerator));
	var NoRedInk$elm_uuid$Prng$Uuid$generator = A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map, NoRedInk$elm_uuid$Prng$Uuid$Uuid, NoRedInk$elm_uuid$Prng$Uuid$stringGenerator);
	var author$project$Components$ContextualComment$State$Comment = F4(
		function (uid, title, comment, links) {
			return {comment: comment, links: links, title: title, uid: uid};
		});
	var author$project$Binding$ContextualCommentDecoder$commentRefDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'comment',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				elm$json$Json$Decode$string,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Components$ContextualComment$State$Comment)))));
	var author$project$Binding$OTPDecoder$OtpsRecord = F2(
		function (categories, openingTicketPurposes) {
			return {categories: categories, openingTicketPurposes: openingTicketPurposes};
		});
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var elm$json$Json$Decode$value = _Json_decodeValue;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
		function (pathDecoder, valDecoder, fallback) {
			var nullOr = function (decoder) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							decoder,
							elm$json$Json$Decode$null(fallback)
						]));
			};
			var handleResult = function (input) {
				var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
				if (_n0.$ === 'Ok') {
					var rawValue = _n0.a;
					var _n1 = A2(
						elm$json$Json$Decode$decodeValue,
						nullOr(valDecoder),
						rawValue);
					if (_n1.$ === 'Ok') {
						var finalResult = _n1.a;
						return elm$json$Json$Decode$succeed(finalResult);
					} else {
						var finalErr = _n1.a;
						return elm$json$Json$Decode$fail(
							elm$json$Json$Decode$errorToString(finalErr));
					}
				} else {
					return elm$json$Json$Decode$succeed(fallback);
				}
			};
			return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
		});
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
		function (key, valDecoder, fallback, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
					A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
					valDecoder,
					fallback),
				decoder);
		});
	var author$project$Binding$OTPDecoder$CategoryRecord = F4(
		function (uid, label, iconId, parent) {
			return {iconId: iconId, label: label, parent: parent, uid: uid};
		});
	var author$project$Binding$OTPDecoder$UidRecord = function (uid) {
		return {uid: uid};
	};
	var author$project$Binding$OTPDecoder$uidRecordDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uid',
		elm$json$Json$Decode$string,
		elm$json$Json$Decode$succeed(author$project$Binding$OTPDecoder$UidRecord));
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$nullable = function (decoder) {
		return elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
				]));
	};
	var author$project$Binding$OTPDecoder$categorieDecoder = A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'parent',
		elm$json$Json$Decode$nullable(author$project$Binding$OTPDecoder$uidRecordDecoder),
		elm$core$Maybe$Nothing,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'iconId',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'label',
				elm$json$Json$Decode$string,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uid',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Binding$OTPDecoder$CategoryRecord)))));
	var author$project$Binding$OTPDecoder$OtpRecord = F3(
		function (uid, categories, label) {
			return {categories: categories, label: label, uid: uid};
		});
	var author$project$Binding$OTPDecoder$otpDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'categories',
			elm$json$Json$Decode$list(author$project$Binding$OTPDecoder$uidRecordDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$OTPDecoder$OtpRecord))));
	var author$project$Binding$OTPDecoder$otpsDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'openingTicketPurposes',
		elm$json$Json$Decode$list(author$project$Binding$OTPDecoder$otpDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'categories',
			elm$json$Json$Decode$list(author$project$Binding$OTPDecoder$categorieDecoder),
			elm$json$Json$Decode$succeed(author$project$Binding$OTPDecoder$OtpsRecord)));
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var author$project$Components$QualificationCriteria$Common$Model$WorkflowRef = F2(
		function (uid, label) {
			return {label: label, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Common$ModelJsonDecoder$decodeWorkflow = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Common$Model$WorkflowRef)));
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$Criterion = F3(
		function (uid, title, values) {
			return {title: title, uid: uid, values: values};
		});
	var elm_community$list_extra$List$Extra$find = F2(
		function (predicate, list) {
			find:
			while (true) {
				if (!list.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var first = list.a;
					var rest = list.b;
					if (predicate(first)) {
						return elm$core$Maybe$Just(first);
					} else {
						var $temp$predicate = predicate,
							$temp$list = rest;
						predicate = $temp$predicate;
						list = $temp$list;
						continue find;
					}
				}
			}
		});
	var author$project$Components$QualificationCriteria$Common$Service$getCriteria = F2(
		function (criteriaRef, uid) {
			return A2(
				elm$core$Maybe$withDefault,
				A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$Criterion, 'nocrit', 'noid', _List_Nil),
				A2(
					elm_community$list_extra$List$Extra$find,
					function (c) {
						return _Utils_eq(c.uid, uid);
					},
					criteriaRef));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$ContextualCommentLeaf = function (a) {
		return {$: 'ContextualCommentLeaf', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Criterion = F3(
		function (label, values, uid) {
			return {label: label, uid: uid, values: values};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionNode = function (a) {
		return {$: 'CriterionNode', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionValue = F3(
		function (value, nextStep, uid) {
			return {nextStep: nextStep, uid: uid, value: value};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CtxCommentLeaf = F3(
		function (uid, title, content) {
			return {content: content, title: title, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Workflow = F3(
		function (uid, label, nextStep) {
			return {label: label, nextStep: nextStep, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$WorkflowLeaf = function (a) {
		return {$: 'WorkflowLeaf', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$fromCommentRefToLeaf = function (ctx) {
		return A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CtxCommentLeaf, ctx.uid, ctx.title, ctx.comment);
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var author$project$Components$QualificationCriteria$Common$Service$treeDto2Model = F4(
		function (workflows, criteriaRef, commentsRef, treeDto) {
			var subTree2Model = A3(author$project$Components$QualificationCriteria$Common$Service$treeDto2Model, workflows, criteriaRef, commentsRef);
			var criteriaValueDTO2Model = F2(
				function (c, valueDto) {
					var getCriteriaValueLabel = A2(
						elm$core$Maybe$withDefault,
						'nolabel',
						A2(
							elm$core$Maybe$map,
							function ($) {
								return $.value;
							},
							A2(
								elm_community$list_extra$List$Extra$find,
								function (v) {
									return _Utils_eq(v.uid, valueDto.uid);
								},
								c.values)));
					return A3(
						author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionValue,
						getCriteriaValueLabel,
						A2(elm$core$Maybe$map, subTree2Model, valueDto.nextStep),
						valueDto.uid);
				});
			if (treeDto.$ === 'CriteriaNodeDTO') {
				var uid = treeDto.a;
				var values = treeDto.b;
				var criterion = A2(author$project$Components$QualificationCriteria$Common$Service$getCriteria, criteriaRef, uid);
				var newChilds = A2(
					elm$core$List$map,
					criteriaValueDTO2Model(criterion),
					values);
				return author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionNode(
					A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Criterion, criterion.title, newChilds, uid));
			} else {
				var uid = treeDto.a;
				var nextStep = treeDto.b;
				var comment = function (next) {
					return A2(
						elm$core$Maybe$withDefault,
						A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CtxCommentLeaf, next.uid, 'error', ''),
						A2(
							elm$core$Maybe$map,
							author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$fromCommentRefToLeaf,
							A2(
								elm_community$list_extra$List$Extra$find,
								function (c) {
									return _Utils_eq(c.uid, next.uid);
								},
								commentsRef)));
				};
				var child = A2(
					elm$core$Maybe$map,
					A2(elm$core$Basics$composeL, author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$ContextualCommentLeaf, comment),
					nextStep);
				var workflow = A2(
					elm$core$Maybe$withDefault,
					A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Workflow, uid, 'nowf', elm$core$Maybe$Nothing),
					A2(
						elm$core$Maybe$map,
						function (w) {
							return A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Workflow, uid, w.label, child);
						},
						A2(
							elm_community$list_extra$List$Extra$find,
							function (w) {
								return _Utils_eq(w.uid, uid);
							},
							workflows)));
				return author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$WorkflowLeaf(workflow);
			}
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$CriterionValue = F2(
		function (uid, value) {
			return {uid: uid, value: value};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaRefDecoder$criterionValueDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$CriterionValue)));
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaRefDecoder$criteriaRefDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'values',
		elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaRefDecoder$criterionValueDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaRef$Criterion))));
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaTreeQueryView = F6(
		function (uid, clientCompanyReference, otps, tree, title, links) {
			return {clientCompanyReference: clientCompanyReference, links: links, otps: otps, title: title, tree: tree, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaNodeDTO = F2(
		function (a, b) {
			return {$: 'CriteriaNodeDTO', a: a, b: b};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaValueDTO = F2(
		function (uid, nextStep) {
			return {nextStep: nextStep, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$WorkflowNodeDTO = F2(
		function (a, b) {
			return {$: 'WorkflowNodeDTO', a: a, b: b};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$ContextualCommentNodeDTO = function (uid) {
		return {uid: uid};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCommentDTO = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'commentUid',
		elm$json$Json$Decode$string,
		elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$ContextualCommentNodeDTO));
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decoderWorkflow = A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'nextStep',
		elm$json$Json$Decode$nullable(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCommentDTO),
		elm$core$Maybe$Nothing,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'workflowUid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$WorkflowNodeDTO)));
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTreeNode = function (v) {
		switch (v) {
			case 'CriteriaNode':
				return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decoderCriteria();
			case 'WorkflowNode':
				return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decoderWorkflow;
			default:
				return elm$json$Json$Decode$fail('nodeType ' + (v + 'inconnu'));
		}
	};
	function author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decoderCriteria() {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'values',
			elm$json$Json$Decode$list(
				author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaValue()),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'criteriaUid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaNodeDTO)));
	}
	function author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaValue() {
		return A4(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'nextStep',
			elm$json$Json$Decode$nullable(
				author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaTree()),
			elm$core$Maybe$Nothing,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaValueDTO)));
	}
	function author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaTree() {
		return A2(
			elm$json$Json$Decode$andThen,
			author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTreeNode,
			A2(elm$json$Json$Decode$field, 'nodeType', elm$json$Json$Decode$string));
	}
	try {
		var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decoderCriteria = author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decoderCriteria();
		author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decoderCriteria = function () {
			return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decoderCriteria;
		};
		var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaValue = author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaValue();
		author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaValue = function () {
			return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaValue;
		};
		var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTree = author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaTree();
		author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$cyclic$decodeCriteriaTree = function () {
			return author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTree;
		};
	} catch ($) {
	throw 'Some top-level definitions from `Components.QualificationCriteria.Tree.Edit.Json.Decoder.CriteriaTreeQueryViewDecoder` are causing infinite recursion:\n\n  ┌─────┐\n  │    decoderCriteria\n  │     ↓\n  │    decodeCriteriaValue\n  │     ↓\n  │    decodeCriteriaTree\n  │     ↓\n  │    decodeCriteriaTreeNode\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.0/halting-problem to learn how to fix it!';}
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTreeQueryView = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tree',
				author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTree,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'otps',
					elm$json$Json$Decode$list(elm$json$Json$Decode$string),
					A3(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'clientCompanyReference',
						elm$json$Json$Decode$string,
						A3(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'uid',
							elm$json$Json$Decode$string,
							elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$CriteriaTreeQueryView)))))));
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$CreateCriteriaAPICommand = F6(
		function (processUid, clientCompanyReference, otps, treeUid, tree, title) {
			return {clientCompanyReference: clientCompanyReference, otps: otps, processUid: processUid, title: title, tree: tree, treeUid: treeUid};
		});
	var NoRedInk$elm_uuid$Prng$Uuid$toString = function (_n0) {
		var internalString = _n0.a;
		return internalString;
	};
	var elm$json$Json$Encode$object = function (pairs) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, obj) {
						var k = _n0.a;
						var v = _n0.b;
						return A3(_Json_addField, k, v, obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				pairs));
	};
	var elm$json$Json$Encode$string = _Json_wrap;
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeCtx = function (ctx) {
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'commentUid',
					elm$json$Json$Encode$string(ctx.uid))
				]));
	};
	var elm$json$Json$Encode$list = F2(
		function (func, entries) {
			return _Json_wrap(
				A3(
					elm$core$List$foldl,
					_Json_addEntry(func),
					_Json_emptyArray(_Utils_Tuple0),
					entries));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeCriteriaValue = function (criteriaValue) {
		var fNextStep = function (v) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nextStep',
					author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeTree(v))
				]);
		};
		var nextStep = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(elm$core$Maybe$map, fNextStep, criteriaValue.nextStep));
		return elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'uid',
						elm$json$Json$Encode$string(criteriaValue.uid)),
						_Utils_Tuple2(
						'value',
						elm$json$Json$Encode$string(criteriaValue.value))
					]),
				nextStep));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeTree = function (tree) {
		switch (tree.$) {
			case 'CriterionNode':
				var criteria = tree.a;
				return author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encoreCriteria(criteria);
			case 'WorkflowLeaf':
				var workflow = tree.a;
				return author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeWorkflow(workflow);
			default:
				var ctx = tree.a;
				return author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeCtx(ctx);
		}
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeWorkflow = function (workflow) {
		var next = function (t) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'nextStep',
					author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeTree(t))
				]);
		};
		var nextStep = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(elm$core$Maybe$map, next, workflow.nextStep));
		return elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'workflowUid',
						elm$json$Json$Encode$string(workflow.uid)),
						_Utils_Tuple2(
						'nodeType',
						elm$json$Json$Encode$string('WorkflowNode')),
						_Utils_Tuple2(
						'label',
						elm$json$Json$Encode$string(workflow.label))
					]),
				nextStep));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encoreCriteria = function (criteria) {
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'criteriaUid',
					elm$json$Json$Encode$string(criteria.uid)),
					_Utils_Tuple2(
					'label',
					elm$json$Json$Encode$string(criteria.label)),
					_Utils_Tuple2(
					'values',
					A2(elm$json$Json$Encode$list, author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeCriteriaValue, criteria.values)),
					_Utils_Tuple2(
					'nodeType',
					elm$json$Json$Encode$string('CriteriaNode'))
				]));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeCreateCmd = function (cmd) {
		var treeUidJson = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Maybe$map,
				function (t) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'treeUid',
							elm$json$Json$Encode$string(t))
						]);
				},
				cmd.treeUid));
		return elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						elm$json$Json$Encode$string(
							NoRedInk$elm_uuid$Prng$Uuid$toString(cmd.processUid))),
						_Utils_Tuple2(
						'clientCompanyReference',
						elm$json$Json$Encode$string(cmd.clientCompanyReference)),
						_Utils_Tuple2(
						'commandType',
						elm$json$Json$Encode$string('ConfigureCriteriaTree')),
						_Utils_Tuple2(
						'otps',
						A2(elm$json$Json$Encode$list, elm$json$Json$Encode$string, cmd.otps)),
						_Utils_Tuple2(
						'tree',
						author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeTree(cmd.tree)),
						_Utils_Tuple2(
						'title',
						elm$json$Json$Encode$string(cmd.title))
					]),
				treeUidJson));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$BackToList = {$: 'BackToList'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$fromWorkflowRefToLeaf = F2(
		function (child, ref) {
			return A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Workflow, ref.uid, ref.label, child);
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$ModelTranslator$criterionRef2Tree = function (ref) {
		var v2T = function (v) {
			return A3(author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionValue, v.value, elm$core$Maybe$Nothing, v.uid);
		};
		return A3(
			author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$Criterion,
			ref.title,
			A2(elm$core$List$map, v2T, ref.values),
			ref.uid);
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$BackToList = {$: 'BackToList'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$ContextualCommentRefFetched = function (a) {
		return {$: 'ContextualCommentRefFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$CriteriaRefFetched = function (a) {
		return {$: 'CriteriaRefFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$GenerateUuid = function (a) {
		return {$: 'GenerateUuid', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$OtpFetched = function (a) {
		return {$: 'OtpFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$OtpsMultiselect = function (a) {
		return {$: 'OtpsMultiselect', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$SaveTreeWithUid = F2(
		function (a, b) {
			return {$: 'SaveTreeWithUid', a: a, b: b};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$TreeFetched = function (a) {
		return {$: 'TreeFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$TreeRemoved = function (a) {
		return {$: 'TreeRemoved', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$TreeSaved = function (a) {
		return {$: 'TreeSaved', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$WorkflowFetched = function (a) {
		return {$: 'WorkflowFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$decorateDomainError = function (e) {
		switch (e.$) {
			case 'ImpossibleToConfigureTreeWithSameOtpThanAnotherTree':
				return 'Un autre arbre a déjà le même OTP';
			case 'ImpossibleToRemoveNonExinstingTree':
				return 'l\'arbre à supprimer n\'existe pas';
			default:
				return 'Une erreur est survenue';
		}
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$ImpossibleToConfigureTreeWithSameOtpThanAnotherTree = {$: 'ImpossibleToConfigureTreeWithSameOtpThanAnotherTree'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$ImpossibleToRemoveNonExinstingTree = {$: 'ImpossibleToRemoveNonExinstingTree'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$UnknownError = {$: 'UnknownError'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$sToDomainError = function (s) {
		switch (s) {
			case 'ImpossibleToConfigureTreeWithSameOtpThanAnotherTree':
				return author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$ImpossibleToConfigureTreeWithSameOtpThanAnotherTree;
			case 'ImpossibleToRemoveNonExinstingTree':
				return author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$ImpossibleToRemoveNonExinstingTree;
			default:
				return author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$UnknownError;
		}
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$decodeError = function (e) {
		var error = function () {
			if (e.$ === 'TechnicalError') {
				var s = e.a;
				return s;
			} else {
				var _n1 = e.a;
				var s = _n1.b;
				return s;
			}
		}();
		return A2(elm$core$Basics$composeR, author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$sToDomainError, author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTreeError$decorateDomainError)(error);
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$ConfigureCriteriaTree = {$: 'ConfigureCriteriaTree'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$showRel = function (right) {
		if (right.$ === 'ConfigureCriteriaTree') {
			return 'ConfigureCriteriaTree';
		} else {
			return 'RemoveCriteriaTree';
		}
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchTree = function (a) {
		return {$: 'FetchTree', a: a};
	};
	var author$project$Utils$Command$decrementCounter = function (c) {
		return _Utils_update(
			c,
			{networkAccess: c.networkAccess - 1});
	};
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var author$project$Utils$Command$launchCmdWhenAllIsDone = F2(
		function (counter, cmd) {
			var decrementedCounter = author$project$Utils$Command$decrementCounter(counter);
			var ableToLaunchCmd = (!decrementedCounter.networkAccess) ? cmd : elm$core$Platform$Cmd$none;
			return _Utils_Tuple2(decrementedCounter, ableToLaunchCmd);
		});
	var author$project$Utils$Http$NavigationLinkUtils$find = F2(
		function (rel, links) {
			return A2(
				elm_community$list_extra$List$Extra$find,
				function (l) {
					return _Utils_eq(rel, l.rel);
				},
				links);
		});
	var elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
		if (m.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var x = m.a;
			return _List_fromArray(
				[x]);
		}
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$fetchTreeWhenRefsAllDownload = function (model) {
		var fetchTree = A2(
			elm$core$Maybe$withDefault,
			elm$core$Platform$Cmd$none,
			A2(
				elm$core$Maybe$map,
				A2(elm$core$Basics$composeR, author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchTree, author$project$Utils$Command$msgToElmCmd),
				model.flags.getTreeLink));
		var configureTreeLink = elm_community$maybe_extra$Maybe$Extra$toList(
			A2(
				author$project$Utils$Http$NavigationLinkUtils$find,
				author$project$Components$QualificationCriteria$Tree$Edit$Model$showRel(author$project$Components$QualificationCriteria$Tree$Edit$Model$ConfigureCriteriaTree),
				model.flags.getDependenciesLinks));
		var _n0 = A2(author$project$Utils$Command$launchCmdWhenAllIsDone, model, fetchTree);
		var counterModel = _n0.a;
		var result = _n0.b;
		return _Utils_Tuple2(
			_Utils_update(
				counterModel,
				{treeLinks: configureTreeLink}),
			result);
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$sendErrorToRedux = _Platform_outgoingPort('sendErrorToRedux', elm$json$Json$Encode$string);
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$updateLeafToTree = F3(
		function (path, leaf, tree) {
			if (tree.$ === 'Just') {
				switch (tree.a.$) {
					case 'CriterionNode':
						var criteria = tree.a.a;
						var updateValue = F2(
							function (lastUid, v) {
								return _Utils_eq(v.uid, lastUid) ? _Utils_update(
									v,
									{nextStep: leaf}) : v;
							});
						var updateCriteria = function (vs) {
							return elm$core$Maybe$Just(
								author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionNode(
									_Utils_update(
										criteria,
										{values: vs})));
						};
						var rec = F2(
							function (criteriaValue, tPath) {
								return A3(author$project$Components$QualificationCriteria$Tree$Edit$Update$updateLeafToTree, tPath, leaf, criteriaValue.nextStep);
							});
						var recUpdateValue = F2(
							function (criteriaValue, tPath) {
								return _Utils_update(
									criteriaValue,
									{
										nextStep: A2(rec, criteriaValue, tPath)
									});
							});
						if (!path.b) {
							return leaf;
						} else {
							if (!path.b.b) {
								var lastUid = path.a;
								return updateCriteria(
									A2(
										elm$core$List$map,
										updateValue(lastUid),
										criteria.values));
							} else {
								var h = path.a;
								var tailPath = path.b;
								return updateCriteria(
									A2(
										elm$core$List$map,
										function (v) {
											return _Utils_eq(v.uid, h) ? A2(recUpdateValue, v, tailPath) : v;
										},
										criteria.values));
							}
						}
					case 'WorkflowLeaf':
						var w = tree.a.a;
						if (leaf.$ === 'Just') {
							if (leaf.a.$ === 'ContextualCommentLeaf') {
								return elm$core$Maybe$Just(
									author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$WorkflowLeaf(
										_Utils_update(
											w,
											{nextStep: leaf})));
							} else {
								return tree;
							}
						} else {
							if (!path.b) {
								return elm$core$Maybe$Nothing;
							} else {
								if (!path.b.b) {
									var lastUid = path.a;
									return _Utils_eq(lastUid, w.uid) ? elm$core$Maybe$Just(
										author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$WorkflowLeaf(
											_Utils_update(
												w,
												{nextStep: elm$core$Maybe$Nothing}))) : tree;
								} else {
									return tree;
								}
							}
						}
					default:
						if (leaf.$ === 'Just') {
							return tree;
						} else {
							return elm$core$Maybe$Nothing;
						}
				}
			} else {
				return leaf;
			}
		});
	var author$project$Components$QualificationCriteria$Utils$Out = function (a) {
		return {$: 'Out', a: a};
	};
	var author$project$Utils$Binding$DecoderUtils$ErrorTypeRecord = function (errorType) {
		return {errorType: errorType};
	};
	var author$project$Utils$Binding$DecoderUtils$eventAPIErrorDecoder = function (f) {
		return A2(
			elm$json$Json$Decode$map,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.errorType;
				},
				f),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'errorType',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Utils$Binding$DecoderUtils$ErrorTypeRecord)));
	};
	var author$project$Utils$Command$incrementCounter = function (c) {
		return _Utils_update(
			c,
			{networkAccess: c.networkAccess + 1});
	};
	var author$project$Utils$Command$noOp = function (model) {
		return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
	};
	var author$project$Utils$Http$HttpRequest$Delete = F2(
		function (a, b) {
			return {$: 'Delete', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Patch = F3(
		function (a, b, c) {
			return {$: 'Patch', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$Post = F3(
		function (a, b, c) {
			return {$: 'Post', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$request = F3(
		function (link, body, exp) {
			var _n0 = link.method;
			switch (_n0.$) {
				case 'GET':
					return A2(author$project$Utils$Http$HttpRequest$Get, link.href, exp);
				case 'POST':
					return A3(author$project$Utils$Http$HttpRequest$Post, link.href, body, exp);
				case 'PATCH':
					return A3(author$project$Utils$Http$HttpRequest$Patch, link.href, body, exp);
				default:
					return A2(author$project$Utils$Http$HttpRequest$Delete, link.href, exp);
			}
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var author$project$Utils$Http$HttpRequest$authRequest = F3(
		function (link, body, exp) {
			return author$project$Utils$Http$HttpRequest$withAuthReq(
				A3(author$project$Utils$Http$HttpRequest$request, link, body, exp));
		});
	var author$project$Utils$Http$HttpRequest$BodyResponse = F2(
		function (a, b) {
			return {$: 'BodyResponse', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$DomainError = function (a) {
		return {$: 'DomainError', a: a};
	};
	var author$project$Utils$Http$HttpRequest$TechnicalError = function (a) {
		return {$: 'TechnicalError', a: a};
	};
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var author$project$Utils$Http$HttpRequest$expectWhateverOkResult = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				function (response) {
					switch (response.$) {
						case 'BadUrl_':
							var url = response.a;
							return elm$core$Result$Err(
								author$project$Utils$Http$HttpRequest$TechnicalError('Http.BadUrl' + url));
						case 'Timeout_':
							return elm$core$Result$Err(
								author$project$Utils$Http$HttpRequest$TechnicalError('Http.Timeout'));
						case 'NetworkError_':
							return elm$core$Result$Err(
								author$project$Utils$Http$HttpRequest$TechnicalError('Http.NetworkError'));
						case 'BadStatus_':
							var metadata = response.a;
							var body = response.b;
							var result = function () {
								var _n1 = A2(elm$json$Json$Decode$decodeString, decoder, body);
								if (_n1.$ === 'Ok') {
									var value = _n1.a;
									return author$project$Utils$Http$HttpRequest$DomainError(
										A2(author$project$Utils$Http$HttpRequest$BodyResponse, metadata, value));
								} else {
									return author$project$Utils$Http$HttpRequest$TechnicalError('json parsing error');
								}
							}();
							return elm$core$Result$Err(result);
						default:
							var metadata = response.a;
							return elm$core$Result$Ok(
								A2(author$project$Utils$Http$HttpRequest$BodyResponse, metadata, _Utils_Tuple0));
					}
				});
		});
	var author$project$Utils$String$stringToNonEmptyString = function (s) {
		if (s === '') {
			return elm$core$Maybe$Nothing;
		} else {
			return elm$core$Maybe$Just(s);
		}
	};
	var elm$core$List$sortBy = _List_sortBy;
	var elm$core$Maybe$map2 = F3(
		function (func, ma, mb) {
			if (ma.$ === 'Nothing') {
				return elm$core$Maybe$Nothing;
			} else {
				var a = ma.a;
				if (mb.$ === 'Nothing') {
					return elm$core$Maybe$Nothing;
				} else {
					var b = mb.a;
					return elm$core$Maybe$Just(
						A2(func, a, b));
				}
			}
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm$http$Http$expectBytesResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'arraybuffer',
				_Http_toDataView,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$expectWhatever = function (toMsg) {
		return A2(
			elm$http$Http$expectBytesResponse,
			toMsg,
			elm$http$Http$resolve(
				function (_n0) {
					return elm$core$Result$Ok(_Utils_Tuple0);
				}));
	};
	var elm$http$Http$jsonBody = function (value) {
		return A2(
			_Http_pair,
			'application/json',
			A2(elm$json$Json$Encode$encode, 0, value));
	};
	var elm_community$maybe_extra$Maybe$Extra$orElse = F2(
		function (ma, mb) {
			if (mb.$ === 'Nothing') {
				return ma;
			} else {
				return mb;
			}
		});
	var inkuzmin$elm_multiselect$Multiselect$getSelectedValues = function (_n0) {
		var model = _n0.a;
		return model.selected;
	};
	var inkuzmin$elm_multiselect$Multiselect$getValues = function (_n0) {
		var model = _n0.a;
		return model.values;
	};
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var inkuzmin$elm_multiselect$Multiselect$Closed = {$: 'Closed'};
	var inkuzmin$elm_multiselect$Multiselect$Model = function (a) {
		return {$: 'Model', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$initModel = F2(
		function (values, tag1) {
			return inkuzmin$elm_multiselect$Multiselect$Model(
				{
					error: elm$core$Maybe$Nothing,
					filtered: values,
					hovered: elm$core$List$head(values),
					input: '',
					inputWidth: 23.0,
					_protected: false,
					selected: _List_Nil,
					status: inkuzmin$elm_multiselect$Multiselect$Closed,
					tag: tag1,
					values: values
				});
		});
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$member = F2(
		function (x, xs) {
			return A2(
				elm$core$List$any,
				function (a) {
					return _Utils_eq(a, x);
				},
				xs);
		});
	var inkuzmin$elm_multiselect$Multiselect$filter = F2(
		function (selected, values) {
			return A2(
				elm$core$List$filter,
				function (value) {
					return !A2(elm$core$List$member, value, selected);
				},
				values);
		});
	var inkuzmin$elm_multiselect$Multiselect$populateValues = F3(
		function (_n0, values, selected) {
			var model = _n0.a;
			var filtered = elm$core$List$isEmpty(selected) ? values : A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, values);
			return inkuzmin$elm_multiselect$Multiselect$Model(
				_Utils_update(
					model,
					{filtered: filtered, selected: selected, values: values}));
		});
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$core$String$toInt = _String_toInt;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$Dom$focus = _Browser_call('focus');
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Task$onError = _Scheduler_onError;
	var elm$core$Task$attempt = F2(
		function (resultToMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(
						elm$core$Task$onError,
						A2(
							elm$core$Basics$composeL,
							A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
							elm$core$Result$Err),
						A2(
							elm$core$Task$andThen,
							A2(
								elm$core$Basics$composeL,
								A2(elm$core$Basics$composeL, elm$core$Task$succeed, resultToMessage),
								elm$core$Result$Ok),
							task))));
		});
	var inkuzmin$elm_multiselect$Multiselect$Cleared = {$: 'Cleared'};
	var inkuzmin$elm_multiselect$Multiselect$DisableProtection = {$: 'DisableProtection'};
	var inkuzmin$elm_multiselect$Multiselect$FocusResult = function (a) {
		return {$: 'FocusResult', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Opened = {$: 'Opened'};
	var inkuzmin$elm_multiselect$Multiselect$ScrollResult = function (a) {
		return {$: 'ScrollResult', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$ScrollY = function (a) {
		return {$: 'ScrollY', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Selected = function (a) {
		return {$: 'Selected', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Unselected = function (a) {
		return {$: 'Unselected', a: a};
	};
	var elm$core$Process$sleep = _Process_sleep;
	var inkuzmin$elm_multiselect$Multiselect$delayInMs = F2(
		function (ms, msg) {
			return A2(
				elm$core$Task$perform,
				function (_n0) {
					return msg;
				},
				elm$core$Process$sleep(ms));
		});
	var elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
	var elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
	var inkuzmin$elm_multiselect$Multiselect$domScrollToY = F2(
		function (id, y) {
			return A2(
				elm$core$Task$andThen,
				function (vp) {
					return A3(elm$browser$Browser$Dom$setViewportOf, id, vp.viewport.x, y);
				},
				elm$browser$Browser$Dom$getViewportOf(id));
		});
	var inkuzmin$elm_multiselect$Multiselect$domScrollY = function (id) {
		return A2(
			elm$core$Task$map,
			function (vp) {
				return vp.viewport.y;
			},
			elm$browser$Browser$Dom$getViewportOf(id));
	};
	var inkuzmin$elm_multiselect$Multiselect$fitViewPort = F2(
		function (_n0, _n1) {
			var top = _n0.a;
			var bottom = _n0.b;
			var vpTop = _n1.a;
			var vpBottom = _n1.b;
			return (_Utils_cmp(top, vpTop) < 0) ? top : ((_Utils_cmp(bottom, vpBottom) > 0) ? (vpTop + (bottom - vpBottom)) : vpTop);
		});
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight = 32;
	var inkuzmin$elm_multiselect$Multiselect$getBoundaries = function (i) {
		return _Utils_Tuple2(i * inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight, (i * inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight) + inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight);
	};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight = 200;
	var inkuzmin$elm_multiselect$Multiselect$getViewPortBoundaries = function (i) {
		return _Utils_Tuple2(i, i + inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight);
	};
	var inkuzmin$elm_multiselect$Multiselect$indexOf = F2(
		function (el, list) {
			var helper = F2(
				function (l, index) {
					helper:
					while (true) {
						if (!l.b) {
							return elm$core$Maybe$Nothing;
						} else {
							var x = l.a;
							var xs = l.b;
							if (_Utils_eq(x, el)) {
								return elm$core$Maybe$Just(index);
							} else {
								var $temp$l = xs,
									$temp$index = index + 1;
								l = $temp$l;
								index = $temp$index;
								continue helper;
							}
						}
					}
				});
			return A2(helper, list, 0);
		});
	var elm$core$Basics$always = F2(
		function (a, _n0) {
			return a;
		});
	var inkuzmin$elm_multiselect$Multiselect$lastElem = A2(
		elm$core$List$foldl,
		A2(elm$core$Basics$composeR, elm$core$Maybe$Just, elm$core$Basics$always),
		elm$core$Maybe$Nothing);
	var inkuzmin$elm_multiselect$Multiselect$nextItem = F2(
		function (list, item) {
			var findNextInList = function (l) {
				findNextInList:
				while (true) {
					if (!l.b) {
						return elm$core$Maybe$Nothing;
					} else {
						if (!l.b.b) {
							var x = l.a;
							return _Utils_eq(x, item) ? elm$core$List$head(list) : elm$core$Maybe$Nothing;
						} else {
							var x = l.a;
							var _n1 = l.b;
							var y = _n1.a;
							var rest = _n1.b;
							if (_Utils_eq(x, item)) {
								return elm$core$Maybe$Just(y);
							} else {
								var $temp$l = A2(elm$core$List$cons, y, rest);
								l = $temp$l;
								continue findNextInList;
							}
						}
					}
				}
			};
			return findNextInList(list);
		});
	var inkuzmin$elm_multiselect$Multiselect$nextSelectedItem = F2(
		function (list, item) {
			var takeLast = function (l) {
				if (!l.b) {
					return elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						return elm$core$Maybe$Nothing;
					} else {
						var _n3 = l.b;
						var y = _n3.a;
						return elm$core$Maybe$Just(y);
					}
				}
			};
			var findNextInList = function (l) {
				findNextInList:
				while (true) {
					if (!l.b) {
						return elm$core$Maybe$Nothing;
					} else {
						if (!l.b.b) {
							var x = l.a;
							return _Utils_eq(x, item) ? takeLast(
								elm$core$List$reverse(list)) : elm$core$Maybe$Nothing;
						} else {
							var x = l.a;
							var _n1 = l.b;
							var y = _n1.a;
							var rest = _n1.b;
							if (_Utils_eq(x, item)) {
								return elm$core$Maybe$Just(y);
							} else {
								var $temp$l = A2(elm$core$List$cons, y, rest);
								l = $temp$l;
								continue findNextInList;
							}
						}
					}
				}
			};
			return findNextInList(list);
		});
	var inkuzmin$elm_multiselect$Multiselect$prevItem = F2(
		function (list, item) {
			return A2(
				inkuzmin$elm_multiselect$Multiselect$nextItem,
				elm$core$List$reverse(list),
				item);
		});
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$backspace = 8;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow = 40;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$end = 35;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$escape = 27;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$home = 36;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$pageDown = 34;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$pageUp = 33;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$return = 13;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$tab = 9;
	var inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow = 38;
	var inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter = '\u200c\u200c';
	var inkuzmin$elm_multiselect$Multiselect$update = F2(
		function (msg, _n0) {
			var model = _n0.a;
			switch (msg.$) {
				case 'Start':
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(model),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'Toggle':
					return _Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Opened) ? _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{status: inkuzmin$elm_multiselect$Multiselect$Closed})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
								])),
						elm$core$Maybe$Nothing) : _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{status: inkuzmin$elm_multiselect$Multiselect$Opened})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
								])),
						elm$core$Maybe$Nothing);
				case 'Click':
					return model._protected ? _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{_protected: false})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing) : _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{status: inkuzmin$elm_multiselect$Multiselect$Closed})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'DisableProtection':
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{_protected: false})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'ClickOnComponent':
					return model._protected ? _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(model),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing) : _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{_protected: true, status: inkuzmin$elm_multiselect$Multiselect$Opened})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag)),
									A2(inkuzmin$elm_multiselect$Multiselect$delayInMs, 100, inkuzmin$elm_multiselect$Multiselect$DisableProtection)
								])),
						elm$core$Maybe$Nothing);
				case 'ScrollResult':
					var result = msg.a;
					if (result.$ === 'Err') {
						var id = result.a.a;
						return _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{
										error: elm$core$Maybe$Just('Could not find dom id: ' + id)
									})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					} else {
						return _Utils_eq(model.input, inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{input: ''})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing) : _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{error: elm$core$Maybe$Nothing})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					}
				case 'FocusResult':
					var result = msg.a;
					if (result.$ === 'Err') {
						var id = result.a.a;
						return _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{
										error: elm$core$Maybe$Just('Could not find dom id: ' + id)
									})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					} else {
						return _Utils_eq(model.input, inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{input: ''})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing) : _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{error: elm$core$Maybe$Nothing})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					}
				case 'Adjust':
					var value = msg.a;
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{inputWidth: value})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'Filter':
					var value = msg.a;
					var filtered = A2(
						inkuzmin$elm_multiselect$Multiselect$filter,
						model.selected,
						A2(
							elm$core$List$filter,
							function (_n5) {
								var val = _n5.b;
								return A2(
									elm$core$String$contains,
									elm$core$String$toLower(value),
									elm$core$String$toLower(val));
							},
							model.values));
					if (model._protected) {
						return _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{_protected: false})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					} else {
						var _n4 = model.hovered;
						if (_n4.$ === 'Nothing') {
							return _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{
											filtered: filtered,
											hovered: elm$core$List$head(filtered),
											input: value,
											status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
										})),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing);
						} else {
							var item = _n4.a;
							return (!elm$core$List$length(
								A2(
									elm$core$List$filter,
									function (i) {
										return _Utils_eq(i, item);
									},
									filtered))) ? _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{
											filtered: filtered,
											hovered: elm$core$List$head(filtered),
											input: value,
											status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
										})),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing) : _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{
											filtered: filtered,
											input: value,
											status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
										})),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing);
						}
					}
				case 'OnSelect':
					var item = msg.a;
					var selected = _Utils_ap(
						model.selected,
						_List_fromArray(
							[item]));
					var filtered = A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values);
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{
									filtered: filtered,
									hovered: A2(inkuzmin$elm_multiselect$Multiselect$nextSelectedItem, model.filtered, item),
									input: inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
									selected: selected,
									status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
								})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
								])),
						elm$core$Maybe$Just(
							inkuzmin$elm_multiselect$Multiselect$Selected(item)));
				case 'RemoveItem':
					var item = msg.a;
					var selected = A2(
						elm$core$List$filter,
						function (value) {
							return !_Utils_eq(value, item);
						},
						model.selected);
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{
									filtered: A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values),
									hovered: elm$core$Maybe$Just(item),
									selected: selected
								})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$ScrollY,
									inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
								])),
						elm$core$Maybe$Just(
							inkuzmin$elm_multiselect$Multiselect$Unselected(item)));
				case 'Clear':
					var selected = _List_Nil;
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{
									filtered: A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values),
									input: inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
									selected: selected,
									status: inkuzmin$elm_multiselect$Multiselect$Closed
								})),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									elm$core$Task$attempt,
									inkuzmin$elm_multiselect$Multiselect$FocusResult,
									elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
								])),
						elm$core$Maybe$Just(inkuzmin$elm_multiselect$Multiselect$Cleared));
				case 'OnHover':
					var item = msg.a;
					return _Utils_Tuple3(
						inkuzmin$elm_multiselect$Multiselect$Model(
							_Utils_update(
								model,
								{
									hovered: elm$core$Maybe$Just(item)
								})),
						elm$core$Platform$Cmd$none,
						elm$core$Maybe$Nothing);
				case 'ScrollY':
					var result = msg.a;
					if (result.$ === 'Err') {
						var id = result.a.a;
						return _Utils_Tuple3(
							inkuzmin$elm_multiselect$Multiselect$Model(
								_Utils_update(
									model,
									{
										error: elm$core$Maybe$Just('Could not find dom id: ' + id)
									})),
							elm$core$Platform$Cmd$none,
							elm$core$Maybe$Nothing);
					} else {
						var y = result.a;
						var _n7 = model.hovered;
						if (_n7.$ === 'Nothing') {
							return _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(model),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing);
						} else {
							var item = _n7.a;
							var _n8 = A2(inkuzmin$elm_multiselect$Multiselect$indexOf, item, model.filtered);
							if (_n8.$ === 'Nothing') {
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(model),
									elm$core$Platform$Cmd$none,
									elm$core$Maybe$Nothing);
							} else {
								var idx = _n8.a;
								var vpBoundaries = inkuzmin$elm_multiselect$Multiselect$getViewPortBoundaries(y);
								var boundaries = inkuzmin$elm_multiselect$Multiselect$getBoundaries(idx);
								var scroll = A2(inkuzmin$elm_multiselect$Multiselect$fitViewPort, boundaries, vpBoundaries);
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(
										_Utils_update(
											model,
											{error: elm$core$Maybe$Nothing})),
									elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												elm$core$Task$attempt,
												inkuzmin$elm_multiselect$Multiselect$ScrollResult,
												A2(inkuzmin$elm_multiselect$Multiselect$domScrollToY, 'multiselectMenu' + model.tag, scroll))
											])),
									elm$core$Maybe$Nothing);
							}
						}
					}
				default:
					var key = msg.a;
					if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow)) {
						var _n9 = model.hovered;
						if (_n9.$ === 'Nothing') {
							return _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{
											hovered: elm$core$List$head(model.filtered)
										})),
								elm$core$Platform$Cmd$none,
								elm$core$Maybe$Nothing);
						} else {
							var item = _n9.a;
							var prev = A2(inkuzmin$elm_multiselect$Multiselect$prevItem, model.filtered, item);
							return _Utils_Tuple3(
								inkuzmin$elm_multiselect$Multiselect$Model(
									_Utils_update(
										model,
										{hovered: prev})),
								elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											elm$core$Task$attempt,
											inkuzmin$elm_multiselect$Multiselect$ScrollY,
											inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
										])),
								elm$core$Maybe$Nothing);
						}
					} else {
						if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow)) {
							var _n10 = model.hovered;
							if (_n10.$ === 'Nothing') {
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(
										_Utils_update(
											model,
											{
												hovered: elm$core$List$head(model.filtered)
											})),
									elm$core$Platform$Cmd$none,
									elm$core$Maybe$Nothing);
							} else {
								var item = _n10.a;
								var next = A2(inkuzmin$elm_multiselect$Multiselect$nextItem, model.filtered, item);
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(
										_Utils_update(
											model,
											{hovered: next})),
									elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												elm$core$Task$attempt,
												inkuzmin$elm_multiselect$Multiselect$ScrollY,
												inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
											])),
									elm$core$Maybe$Nothing);
							}
						} else {
							if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$pageUp) || _Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$home)) {
								var first = elm$core$List$head(model.filtered);
								return _Utils_Tuple3(
									inkuzmin$elm_multiselect$Multiselect$Model(
										_Utils_update(
											model,
											{hovered: first})),
									elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												elm$core$Task$attempt,
												inkuzmin$elm_multiselect$Multiselect$ScrollY,
												inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
											])),
									elm$core$Maybe$Nothing);
							} else {
								if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$pageDown) || _Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$end)) {
									var last = inkuzmin$elm_multiselect$Multiselect$lastElem(model.filtered);
									return _Utils_Tuple3(
										inkuzmin$elm_multiselect$Multiselect$Model(
											_Utils_update(
												model,
												{hovered: last})),
										elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													A2(
													elm$core$Task$attempt,
													inkuzmin$elm_multiselect$Multiselect$ScrollY,
													inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
												])),
										elm$core$Maybe$Nothing);
								} else {
									if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$return)) {
										var _n11 = model.hovered;
										if (_n11.$ === 'Nothing') {
											var isInvisible = _Utils_eq(model.input, inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter);
											var isEmpty = elm$core$String$isEmpty(model.input);
											return (isInvisible || isEmpty) ? _Utils_Tuple3(
												inkuzmin$elm_multiselect$Multiselect$Model(model),
												elm$core$Platform$Cmd$none,
												elm$core$Maybe$Nothing) : _Utils_Tuple3(
												inkuzmin$elm_multiselect$Multiselect$Model(model),
												elm$core$Platform$Cmd$none,
												elm$core$Maybe$Just(
													inkuzmin$elm_multiselect$Multiselect$NotFound(model.input)));
										} else {
											var item = _n11.a;
											var selected = _Utils_ap(
												model.selected,
												_List_fromArray(
													[item]));
											var filtered = A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values);
											return _Utils_Tuple3(
												inkuzmin$elm_multiselect$Multiselect$Model(
													_Utils_update(
														model,
														{
															filtered: filtered,
															hovered: A2(inkuzmin$elm_multiselect$Multiselect$nextSelectedItem, model.filtered, item),
															input: inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
															selected: selected,
															status: elm$core$List$isEmpty(filtered) ? inkuzmin$elm_multiselect$Multiselect$Closed : inkuzmin$elm_multiselect$Multiselect$Opened
														})),
												elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2(
															elm$core$Task$attempt,
															inkuzmin$elm_multiselect$Multiselect$FocusResult,
															elm$browser$Browser$Dom$focus('multiselectInput' + model.tag))
														])),
												elm$core$Maybe$Just(
													inkuzmin$elm_multiselect$Multiselect$Selected(item)));
										}
									} else {
										if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$escape)) {
											return _Utils_Tuple3(
												inkuzmin$elm_multiselect$Multiselect$Model(
													_Utils_update(
														model,
														{_protected: true, status: inkuzmin$elm_multiselect$Multiselect$Closed})),
												elm$core$Platform$Cmd$none,
												elm$core$Maybe$Nothing);
										} else {
											if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$tab)) {
												return _Utils_Tuple3(
													inkuzmin$elm_multiselect$Multiselect$Model(
														_Utils_update(
															model,
															{status: inkuzmin$elm_multiselect$Multiselect$Closed})),
													elm$core$Platform$Cmd$none,
													elm$core$Maybe$Nothing);
											} else {
												if (_Utils_eq(key, inkuzmin$elm_multiselect$Multiselect$Keycodes$backspace)) {
													if (model.input === '') {
														var _n12 = inkuzmin$elm_multiselect$Multiselect$lastElem(model.selected);
														if (_n12.$ === 'Nothing') {
															return _Utils_Tuple3(
																inkuzmin$elm_multiselect$Multiselect$Model(model),
																elm$core$Platform$Cmd$none,
																elm$core$Maybe$Nothing);
														} else {
															var item = _n12.a;
															var selected = A2(
																elm$core$List$filter,
																function (value) {
																	return !_Utils_eq(value, item);
																},
																model.selected);
															return _Utils_Tuple3(
																inkuzmin$elm_multiselect$Multiselect$Model(
																	_Utils_update(
																		model,
																		{
																			filtered: A2(inkuzmin$elm_multiselect$Multiselect$filter, selected, model.values),
																			hovered: elm$core$Maybe$Just(item),
																			selected: selected
																		})),
																elm$core$Platform$Cmd$batch(
																	_List_fromArray(
																		[
																			A2(
																			elm$core$Task$attempt,
																			inkuzmin$elm_multiselect$Multiselect$ScrollY,
																			inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.tag))
																		])),
																elm$core$Maybe$Just(
																	inkuzmin$elm_multiselect$Multiselect$Unselected(item)));
														}
													} else {
														return _Utils_Tuple3(
															inkuzmin$elm_multiselect$Multiselect$Model(model),
															elm$core$Platform$Cmd$none,
															elm$core$Maybe$Nothing);
													}
												} else {
													return _Utils_Tuple3(
														inkuzmin$elm_multiselect$Multiselect$Model(model),
														elm$core$Platform$Cmd$none,
														elm$core$Maybe$Nothing);
												}
											}
										}
									}
								}
							}
						}
					}
			}
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$update = F2(
		function (action, model) {
			switch (action.$) {
				case 'FetchOtp':
					var getOTPsLink = A2(author$project$Utils$Http$NavigationLinkUtils$find, 'openingticketpurposeref', model.flags.getDependenciesLinks);
					var expected = A2(elm$http$Http$expectJson, author$project$Components$QualificationCriteria$Tree$Edit$Update$OtpFetched, author$project$Binding$OTPDecoder$otpsDecoder);
					var getOTPs = function (l) {
						return A3(author$project$Utils$Http$HttpRequest$authRequest, l, elm$http$Http$emptyBody, expected);
					};
					var cmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(elm$core$Maybe$map, getOTPs, getOTPsLink));
					return _Utils_Tuple2(
						author$project$Utils$Command$incrementCounter(model),
						cmd);
				case 'OtpFetched':
					if (action.a.$ === 'Ok') {
						var newOtps = action.a.a;
						var values = A2(
							elm$core$List$map,
							function (otp) {
								return _Utils_Tuple2(otp.uid, otp.label);
							},
							A2(
								elm$core$List$sortBy,
								function ($) {
									return $.label;
								},
								newOtps.openingTicketPurposes));
						var _n1 = author$project$Components$QualificationCriteria$Tree$Edit$Update$fetchTreeWhenRefsAllDownload(model);
						var decrementedCounter = _n1.a;
						var ableFetchTree = _n1.b;
						return _Utils_Tuple2(
							_Utils_update(
								decrementedCounter,
								{
									multiselectOtps: A2(inkuzmin$elm_multiselect$Multiselect$initModel, values, 'otps')
								}),
							ableFetchTree);
					} else {
						return author$project$Utils$Command$noOp(
							author$project$Utils$Command$decrementCounter(model));
					}
				case 'FetchWorkflow':
					var getWsLink = A2(author$project$Utils$Http$NavigationLinkUtils$find, 'workflows', model.flags.getDependenciesLinks);
					var expected = A2(
						elm$http$Http$expectJson,
						author$project$Components$QualificationCriteria$Tree$Edit$Update$WorkflowFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Common$ModelJsonDecoder$decodeWorkflow)));
					var getWs = function (l) {
						return A3(author$project$Utils$Http$HttpRequest$authRequest, l, elm$http$Http$emptyBody, expected);
					};
					var cmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(elm$core$Maybe$map, getWs, getWsLink));
					return _Utils_Tuple2(
						author$project$Utils$Command$incrementCounter(model),
						cmd);
				case 'WorkflowFetched':
					if (action.a.$ === 'Ok') {
						var result = action.a.a;
						var _n2 = author$project$Components$QualificationCriteria$Tree$Edit$Update$fetchTreeWhenRefsAllDownload(model);
						var decrementedCounter = _n2.a;
						var ableFetchTree = _n2.b;
						return _Utils_Tuple2(
							_Utils_update(
								decrementedCounter,
								{availableWorkflows: result.result}),
							ableFetchTree);
					} else {
						return author$project$Utils$Command$noOp(
							author$project$Utils$Command$decrementCounter(model));
					}
				case 'FetchCriteriaRef':
					var getCrietriaRefLink = A2(author$project$Utils$Http$NavigationLinkUtils$find, 'criteriaref', model.flags.getDependenciesLinks);
					var expected = A2(
						elm$http$Http$expectJson,
						author$project$Components$QualificationCriteria$Tree$Edit$Update$CriteriaRefFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaRefDecoder$criteriaRefDecoder)));
					var getCriteriaRef = function (l) {
						return A3(author$project$Utils$Http$HttpRequest$authRequest, l, elm$http$Http$emptyBody, expected);
					};
					var cmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(elm$core$Maybe$map, getCriteriaRef, getCrietriaRefLink));
					return _Utils_Tuple2(
						author$project$Utils$Command$incrementCounter(model),
						cmd);
				case 'CriteriaRefFetched':
					if (action.a.$ === 'Ok') {
						var result = action.a.a;
						var _n3 = author$project$Components$QualificationCriteria$Tree$Edit$Update$fetchTreeWhenRefsAllDownload(model);
						var decrementedCounter = _n3.a;
						var ableFetchTree = _n3.b;
						return _Utils_Tuple2(
							_Utils_update(
								decrementedCounter,
								{criteriaRef: result.result}),
							ableFetchTree);
					} else {
						return author$project$Utils$Command$noOp(
							author$project$Utils$Command$decrementCounter(model));
					}
				case 'FetchContextualCommentRef':
					var getCommentRefLink = A2(author$project$Utils$Http$NavigationLinkUtils$find, 'contextualcommentref', model.flags.getDependenciesLinks);
					var expected = A2(
						elm$http$Http$expectJson,
						author$project$Components$QualificationCriteria$Tree$Edit$Update$ContextualCommentRefFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Binding$ContextualCommentDecoder$commentRefDecoder)));
					var getComment = function (l) {
						return A3(author$project$Utils$Http$HttpRequest$authRequest, l, elm$http$Http$emptyBody, expected);
					};
					var cmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(elm$core$Maybe$map, getComment, getCommentRefLink));
					return _Utils_Tuple2(
						author$project$Utils$Command$incrementCounter(model),
						cmd);
				case 'ContextualCommentRefFetched':
					if (action.a.$ === 'Ok') {
						var result = action.a.a;
						var _n4 = author$project$Components$QualificationCriteria$Tree$Edit$Update$fetchTreeWhenRefsAllDownload(model);
						var decrementedCounter = _n4.a;
						var ableFetchTree = _n4.b;
						return _Utils_Tuple2(
							_Utils_update(
								decrementedCounter,
								{contextualComments: result.result}),
							ableFetchTree);
					} else {
						var _n5 = author$project$Components$QualificationCriteria$Tree$Edit$Update$fetchTreeWhenRefsAllDownload(model);
						var decrementedCounter = _n5.a;
						var ableFetchTree = _n5.b;
						return _Utils_Tuple2(decrementedCounter, ableFetchTree);
					}
				case 'FetchTree':
					var link = action.a;
					var expected = A2(elm$http$Http$expectJson, author$project$Components$QualificationCriteria$Tree$Edit$Update$TreeFetched, author$project$Components$QualificationCriteria$Tree$Edit$Json$Decoder$CriteriaTreeQueryViewDecoder$decodeCriteriaTreeQueryView);
					var getTree = function (l) {
						return A3(author$project$Utils$Http$HttpRequest$authRequest, l, elm$http$Http$emptyBody, expected);
					};
					return _Utils_Tuple2(
						model,
						getTree(link));
				case 'TreeFetched':
					if (action.a.$ === 'Ok') {
						var queryView = action.a.a;
						var newTree = A4(author$project$Components$QualificationCriteria$Common$Service$treeDto2Model, model.availableWorkflows, model.criteriaRef, model.contextualComments, queryView.tree);
						var availableOtps = inkuzmin$elm_multiselect$Multiselect$getValues(model.multiselectOtps);
						var newSelected = A2(
							elm$core$List$filterMap,
							function (o) {
								return A2(
									elm_community$list_extra$List$Extra$find,
									function (o2) {
										return _Utils_eq(o, o2.a);
									},
									availableOtps);
							},
							queryView.otps);
						var newMultiselect = A3(inkuzmin$elm_multiselect$Multiselect$populateValues, model.multiselectOtps, availableOtps, newSelected);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									decisionTree: elm$core$Maybe$Just(newTree),
									label: elm$core$Maybe$Just(queryView.title),
									multiselectOtps: newMultiselect,
									treeLinks: queryView.links
								}),
							elm$core$Platform$Cmd$none);
					} else {
						return author$project$Utils$Command$noOp(model);
					}
				case 'OtpsMultiselect':
					var subMsg = action.a;
					var _n6 = A2(inkuzmin$elm_multiselect$Multiselect$update, subMsg, model.multiselectOtps);
					var msModel = _n6.a;
					var msCmd = _n6.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hasChangeSomething: elm$core$Maybe$Just(_Utils_Tuple0),
								multiselectOtps: msModel
							}),
						A2(elm$core$Platform$Cmd$map, author$project$Components$QualificationCriteria$Tree$Edit$Update$OtpsMultiselect, msCmd));
				case 'AskToIncrementTree':
					var treeAction = action.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								action: elm$core$Maybe$Just(treeAction)
							}),
						elm$core$Platform$Cmd$none);
				case 'ChangeLabel':
					var v = action.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hasChangeSomething: elm$core$Maybe$Just(_Utils_Tuple0),
								label: author$project$Utils$String$stringToNonEmptyString(v)
							}),
						elm$core$Platform$Cmd$none);
				case 'AddCriteriaToTree':
					var path = action.a;
					var newUuid = action.b;
					var newCriteria = A2(
						elm$core$Maybe$map,
						A2(elm$core$Basics$composeR, author$project$Components$QualificationCriteria$Tree$Edit$Model$ModelTranslator$criterionRef2Tree, author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$CriterionNode),
						A2(
							elm_community$list_extra$List$Extra$find,
							function (c) {
								return _Utils_eq(c.uid, newUuid);
							},
							model.criteriaRef));
					var result = A2(
						elm_community$maybe_extra$Maybe$Extra$orElse,
						model.decisionTree,
						A3(author$project$Components$QualificationCriteria$Tree$Edit$Update$updateLeafToTree, path, newCriteria, model.decisionTree));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								action: elm$core$Maybe$Nothing,
								decisionTree: result,
								hasChangeSomething: elm$core$Maybe$Just(_Utils_Tuple0)
							}),
						elm$core$Platform$Cmd$none);
				case 'AffectWorkflowToTree':
					var path = action.a;
					var wUid = action.b;
					var wLeaf = A2(
						elm$core$Maybe$map,
						A2(
							elm$core$Basics$composeR,
							author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$fromWorkflowRefToLeaf(elm$core$Maybe$Nothing),
							author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$WorkflowLeaf),
						A2(
							elm_community$list_extra$List$Extra$find,
							function (w) {
								return _Utils_eq(w.uid, wUid);
							},
							model.availableWorkflows));
					var result = A2(
						elm_community$maybe_extra$Maybe$Extra$orElse,
						model.decisionTree,
						A3(author$project$Components$QualificationCriteria$Tree$Edit$Update$updateLeafToTree, path, wLeaf, model.decisionTree));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								action: elm$core$Maybe$Nothing,
								decisionTree: result,
								hasChangeSomething: elm$core$Maybe$Just(_Utils_Tuple0),
								workflowSelected: elm$core$Maybe$Nothing
							}),
						elm$core$Platform$Cmd$none);
				case 'AffectContextualCommentToBranch':
					var path = action.a;
					var cUid = action.b;
					var ctxLeaf = A2(
						elm$core$Maybe$map,
						A2(elm$core$Basics$composeR, author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$fromCommentRefToLeaf, author$project$Components$QualificationCriteria$Tree$Edit$Model$CriteriaTree$ContextualCommentLeaf),
						A2(
							elm_community$list_extra$List$Extra$find,
							function (c) {
								return _Utils_eq(c.uid, cUid);
							},
							model.contextualComments));
					var result = A2(
						elm_community$maybe_extra$Maybe$Extra$orElse,
						model.decisionTree,
						A3(author$project$Components$QualificationCriteria$Tree$Edit$Update$updateLeafToTree, path, ctxLeaf, model.decisionTree));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								action: elm$core$Maybe$Nothing,
								decisionTree: result,
								hasChangeSomething: elm$core$Maybe$Just(_Utils_Tuple0)
							}),
						elm$core$Platform$Cmd$none);
				case 'RemoveLeaf':
					var path = action.a;
					var result = A3(author$project$Components$QualificationCriteria$Tree$Edit$Update$updateLeafToTree, path, elm$core$Maybe$Nothing, model.decisionTree);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								action: elm$core$Maybe$Nothing,
								decisionTree: result,
								hasChangeSomething: elm$core$Maybe$Just(_Utils_Tuple0),
								workflowSelected: elm$core$Maybe$Nothing
							}),
						elm$core$Platform$Cmd$none);
				case 'SaveTree':
					var link = action.a;
					return _Utils_Tuple2(
						model,
						author$project$Utils$Command$msgToElmCmd(
							author$project$Components$QualificationCriteria$Tree$Edit$Update$GenerateUuid(
								author$project$Components$QualificationCriteria$Tree$Edit$Update$SaveTreeWithUid(link))));
				case 'GenerateUuid':
					var forwardAction = action.a;
					var _n7 = A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$step, NoRedInk$elm_uuid$Prng$Uuid$generator, model.seed);
					var newUuid = _n7.a;
					var newSeed = _n7.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{seed: newSeed}),
						author$project$Utils$Command$msgToElmCmd(
							forwardAction(newUuid)));
				case 'SaveTreeWithUid':
					var link = action.a;
					var uid = action.b;
					var otps = A2(
						elm$core$List$map,
						elm$core$Tuple$first,
						inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.multiselectOtps));
					var exp = A2(
						author$project$Utils$Http$HttpRequest$expectWhateverOkResult,
						author$project$Components$QualificationCriteria$Tree$Edit$Update$TreeSaved,
						author$project$Utils$Binding$DecoderUtils$eventAPIErrorDecoder(elm$core$Basics$identity));
					var save = function (body) {
						return A3(
							author$project$Utils$Http$HttpRequest$authRequest,
							link,
							elm$http$Http$jsonBody(body),
							exp);
					};
					var buildCmd = A4(author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$CreateCriteriaAPICommand, uid, model.flags.clientCompany, otps, model.flags.uid);
					var command = A3(
						elm$core$Maybe$map2,
						F2(
							function (t, s) {
								return save(
									author$project$Components$QualificationCriteria$Tree$Edit$Json$Encoder$TreeEncoder$encodeCreateCmd(
										A2(buildCmd, t, s)));
							}),
						model.decisionTree,
						model.label);
					var result = A2(
						elm$core$Maybe$withDefault,
						author$project$Utils$Command$noOp(model),
						A2(
							elm$core$Maybe$map,
							function (c) {
								return _Utils_Tuple2(
									author$project$Utils$Command$incrementCounter(model),
									c);
							},
							command));
					return result;
				case 'TreeSaved':
					if (action.a.$ === 'Ok') {
						return _Utils_Tuple2(
							author$project$Utils$Command$decrementCounter(model),
							author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Tree$Edit$Update$BackToList));
					} else {
						var e = action.a.a;
						var decremented = author$project$Utils$Command$decrementCounter(model);
						return _Utils_Tuple2(
							decremented,
							author$project$Components$QualificationCriteria$Tree$Edit$Update$sendErrorToRedux(
								author$project$Components$QualificationCriteria$Tree$Edit$Update$decodeError(e)));
					}
				case 'BackToList':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								leaveComponentState: author$project$Components$QualificationCriteria$Utils$Out(author$project$Components$QualificationCriteria$Tree$Edit$Model$BackToList)
							}),
						elm$core$Platform$Cmd$none);
				case 'RemoveTree':
					var link = action.a;
					var cmd = A3(
						author$project$Utils$Http$HttpRequest$authRequest,
						link,
						elm$http$Http$emptyBody,
						elm$http$Http$expectWhatever(author$project$Components$QualificationCriteria$Tree$Edit$Update$TreeRemoved));
					return _Utils_Tuple2(model, cmd);
				default:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								leaveComponentState: author$project$Components$QualificationCriteria$Utils$Out(author$project$Components$QualificationCriteria$Tree$Edit$Model$BackToList)
							}),
						elm$core$Platform$Cmd$none);
			}
		});
	var author$project$Components$QualificationCriteria$Tree$List$CriteriaResultDecoder$CriteriaTreeEntry = F3(
		function (uid, title, links) {
			return {links: links, title: title, uid: uid};
		});
	var author$project$Components$QualificationCriteria$Tree$List$CriteriaResultDecoder$criteriaTreeEntryDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Components$QualificationCriteria$Tree$List$CriteriaResultDecoder$CriteriaTreeEntry))));
	var author$project$Components$QualificationCriteria$Tree$List$Model$CreateTree = function (a) {
		return {$: 'CreateTree', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$List$Model$EditTree = F2(
		function (a, b) {
			return {$: 'EditTree', a: a, b: b};
		});
	var author$project$Components$QualificationCriteria$Tree$List$Update$ListFetched = function (a) {
		return {$: 'ListFetched', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$List$Update$update = F2(
		function (action, model) {
			switch (action.$) {
				case 'FetchList':
					var getTreesLink = A2(author$project$Utils$Http$NavigationLinkUtils$find, 'criteriatrees', model.flags.navigationLinks);
					var expected = A2(
						elm$http$Http$expectJson,
						author$project$Components$QualificationCriteria$Tree$List$Update$ListFetched,
						author$project$Binding$ResultDecoder$resultDecoder(
							elm$json$Json$Decode$list(author$project$Components$QualificationCriteria$Tree$List$CriteriaResultDecoder$criteriaTreeEntryDecoder)));
					var getTrees = function (l) {
						return A3(author$project$Utils$Http$HttpRequest$authRequest, l, elm$http$Http$emptyBody, expected);
					};
					var cmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(elm$core$Maybe$map, getTrees, getTreesLink));
					return _Utils_Tuple2(model, cmd);
				case 'ListFetched':
					if (action.a.$ === 'Ok') {
						var r = action.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{list: r}),
							elm$core$Platform$Cmd$none);
					} else {
						return author$project$Utils$Command$noOp(model);
					}
				case 'CreateTree':
					var link = action.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								leaveComponentState: author$project$Components$QualificationCriteria$Utils$Out(
									author$project$Components$QualificationCriteria$Tree$List$Model$CreateTree(link))
							}),
						elm$core$Platform$Cmd$none);
				default:
					var uid = action.a;
					var link = action.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								leaveComponentState: author$project$Components$QualificationCriteria$Utils$Out(
									A2(author$project$Components$QualificationCriteria$Tree$List$Model$EditTree, uid, link))
							}),
						elm$core$Platform$Cmd$none);
			}
		});
	var author$project$QualificationCriteriaTree$EditAction = function (a) {
		return {$: 'EditAction', a: a};
	};
	var author$project$QualificationCriteriaTree$EditModel = function (a) {
		return {$: 'EditModel', a: a};
	};
	var author$project$QualificationCriteriaTree$handleEditAction = F3(
		function (flags, links, _n0) {
			var model = _n0.a;
			var cmd = _n0.b;
			var _n1 = model.leaveComponentState;
			if (_n1.$ === 'In') {
				return _Utils_Tuple2(
					author$project$QualificationCriteriaTree$EditModel(model),
					A2(elm$core$Platform$Cmd$map, author$project$QualificationCriteriaTree$EditAction, cmd));
			} else {
				var act = _n1.a;
				var flag = A3(author$project$Components$QualificationCriteria$Tree$List$Model$Flags, flags.apiUrl, flags.clientCompany, links);
				var _n3 = author$project$Components$QualificationCriteria$Tree$List$Update$init(flag);
				var newModel = _n3.a;
				var c = _n3.b;
				return _Utils_Tuple2(
					author$project$QualificationCriteriaTree$ListModel(newModel),
					A2(elm$core$Platform$Cmd$map, author$project$QualificationCriteriaTree$ListAction, c));
			}
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$Flags = F5(
		function (clientCompany, seedInfos, uid, getTreeLink, getDependenciesLinks) {
			return {clientCompany: clientCompany, getDependenciesLinks: getDependenciesLinks, getTreeLink: getTreeLink, seedInfos: seedInfos, uid: uid};
		});
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$initialSeed = function (x) {
		var _n0 = NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(
			A2(NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, 0, 1013904223));
		var state1 = _n0.a;
		var incr = _n0.b;
		var state2 = (state1 + x) >>> 0;
		return NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(
			A2(NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, state2, incr));
	};
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$initialSeed = F2(
		function (baseSeed, extendedSeed) {
			return NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$Seed(
				{
					base: NoRedInk$elm_random_pcg_extended$Internal$Pcg$initialSeed(baseSeed),
					extension: elm$core$Array$fromList(extendedSeed)
				});
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$Model = function (flags) {
		return function (leaveComponentState) {
			return function (availableWorkflows) {
				return function (decisionTree) {
					return function (action) {
						return function (workflowSelected) {
							return function (criteriaRef) {
								return function (contextualComments) {
									return function (seed) {
										return function (multiselectOtps) {
											return function (label) {
												return function (treeLinks) {
													return function (networkAccess) {
														return function (hasChangeSomething) {
															return {action: action, availableWorkflows: availableWorkflows, contextualComments: contextualComments, criteriaRef: criteriaRef, decisionTree: decisionTree, flags: flags, hasChangeSomething: hasChangeSomething, label: label, leaveComponentState: leaveComponentState, multiselectOtps: multiselectOtps, networkAccess: networkAccess, seed: seed, treeLinks: treeLinks, workflowSelected: workflowSelected};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchContextualCommentRef = {$: 'FetchContextualCommentRef'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchCriteriaRef = {$: 'FetchCriteriaRef'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchOtp = {$: 'FetchOtp'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchWorkflow = {$: 'FetchWorkflow'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$init = function (flags) {
		var cmds = _List_fromArray(
			[
				author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchOtp),
				author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchWorkflow),
				author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchCriteriaRef),
				author$project$Utils$Command$msgToElmCmd(author$project$Components$QualificationCriteria$Tree$Edit$Update$FetchContextualCommentRef)
			]);
		var _n0 = flags.seedInfos;
		var seed = _n0.a;
		var seedExtension = _n0.b;
		return _Utils_Tuple2(
			author$project$Components$QualificationCriteria$Tree$Edit$Model$Model(flags)(author$project$Components$QualificationCriteria$Utils$In)(_List_Nil)(elm$core$Maybe$Nothing)(elm$core$Maybe$Nothing)(elm$core$Maybe$Nothing)(_List_Nil)(_List_Nil)(
				A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$initialSeed, seed, seedExtension))(
				A2(inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'otps'))(elm$core$Maybe$Nothing)(_List_Nil)(0)(elm$core$Maybe$Nothing),
			elm$core$Platform$Cmd$batch(cmds));
	};
	var author$project$QualificationCriteriaTree$handleListAction = F3(
		function (flags, links, _n0) {
			var model = _n0.a;
			var cmd = _n0.b;
			var _n1 = model.leaveComponentState;
			if (_n1.$ === 'In') {
				return _Utils_Tuple2(
					author$project$QualificationCriteriaTree$ListModel(model),
					A2(elm$core$Platform$Cmd$map, author$project$QualificationCriteriaTree$ListAction, cmd));
			} else {
				var act = _n1.a;
				if (act.$ === 'EditTree') {
					var uid = act.a;
					var getTreeLink = act.b;
					var flag = A5(
						author$project$Components$QualificationCriteria$Tree$Edit$Model$Flags,
						flags.clientCompany,
						flags.seedInfos,
						elm$core$Maybe$Just(uid),
						elm$core$Maybe$Just(getTreeLink),
						links);
					var _n3 = author$project$Components$QualificationCriteria$Tree$Edit$Update$init(flag);
					var newModel = _n3.a;
					var c = _n3.b;
					return _Utils_Tuple2(
						author$project$QualificationCriteriaTree$EditModel(newModel),
						A2(elm$core$Platform$Cmd$map, author$project$QualificationCriteriaTree$EditAction, c));
				} else {
					var configNewTreeLink = act.a;
					var flag = A5(
						author$project$Components$QualificationCriteria$Tree$Edit$Model$Flags,
						flags.clientCompany,
						flags.seedInfos,
						elm$core$Maybe$Nothing,
						elm$core$Maybe$Nothing,
						_Utils_ap(
							links,
							_List_fromArray(
								[configNewTreeLink])));
					var _n4 = author$project$Components$QualificationCriteria$Tree$Edit$Update$init(flag);
					var newModel = _n4.a;
					var c = _n4.b;
					return _Utils_Tuple2(
						author$project$QualificationCriteriaTree$EditModel(newModel),
						A2(elm$core$Platform$Cmd$map, author$project$QualificationCriteriaTree$EditAction, c));
				}
			}
		});
	var author$project$QualificationCriteriaTree$update = F2(
		function (action, state) {
			var _n0 = state.componentModel;
			if (_n0.$ === 'ListModel') {
				var model = _n0.a;
				if (action.$ === 'ListAction') {
					var msg = action.a;
					var _n2 = A3(
						author$project$QualificationCriteriaTree$handleListAction,
						state.flags,
						state.navigationLinks,
						A2(author$project$Components$QualificationCriteria$Tree$List$Update$update, msg, model));
					var newModel = _n2.a;
					var cmd = _n2.b;
					return _Utils_Tuple2(
						_Utils_update(
							state,
							{componentModel: newModel}),
						cmd);
				} else {
					return author$project$Utils$Command$noOp(state);
				}
			} else {
				var model = _n0.a;
				if (action.$ === 'ListAction') {
					return author$project$Utils$Command$noOp(state);
				} else {
					var msg = action.a;
					var _n4 = A3(
						author$project$QualificationCriteriaTree$handleEditAction,
						state.flags,
						state.navigationLinks,
						A2(author$project$Components$QualificationCriteria$Tree$Edit$Update$update, msg, model));
					var newModel = _n4.a;
					var cmd = _n4.b;
					return _Utils_Tuple2(
						_Utils_update(
							state,
							{componentModel: newModel}),
						cmd);
				}
			}
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$ChangeLabel = function (a) {
		return {$: 'ChangeLabel', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$AddCriteriaToTree = F2(
		function (a, b) {
			return {$: 'AddCriteriaToTree', a: a, b: b};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$option = rtfeldman$elm_css$Html$Styled$node('option');
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$value = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
	var author$project$Components$QualificationCriteria$Tree$Edit$View$criteriaOption = function (criteria) {
		return A2(
			rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$value(criteria.uid)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(criteria.title)
				]));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$View$emptyCriteria = A2(
		rtfeldman$elm_css$Html$Styled$option,
		_List_Nil,
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$text('Choisir un critère')
			]));
	var elm_community$list_extra$List$Extra$filterNot = F2(
		function (pred, list) {
			return A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, pred),
				list);
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$View$leftCriteria = F2(
		function (criteria, path) {
			return A2(
				elm_community$list_extra$List$Extra$filterNot,
				function (c) {
					return A2(
						elm$core$List$any,
						function (c2) {
							return A2(elm$core$List$member, c2.uid, path);
						},
						c.values);
				},
				criteria);
		});
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var rtfeldman$elm_css$Html$Styled$select = rtfeldman$elm_css$Html$Styled$node('select');
	var rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
		return _Utils_Tuple2(x, true);
	};
	var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
		return {$: 'MayStopPropagation', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
		});
	var elm$json$Json$Decode$at = F2(
		function (fields, decoder) {
			return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
		});
	var rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'value']),
		elm$json$Json$Decode$string);
	var rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
			'input',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
				A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue)));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$View$addCriteriaForm = F2(
		function (model, path) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onInput(
								author$project$Components$QualificationCriteria$Tree$Edit$Update$AddCriteriaToTree(path))
							]),
						_Utils_ap(
							_List_fromArray(
								[author$project$Components$QualificationCriteria$Tree$Edit$View$emptyCriteria]),
							A2(
								elm$core$List$map,
								author$project$Components$QualificationCriteria$Tree$Edit$View$criteriaOption,
								A2(author$project$Components$QualificationCriteria$Tree$Edit$View$leftCriteria, model.criteriaRef, path))))
					]));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$AffectContextualCommentToBranch = F2(
		function (a, b) {
			return {$: 'AffectContextualCommentToBranch', a: a, b: b};
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$View$addCtxCommentForm = F2(
		function (model, path) {
			var fOption = function (comment) {
				return A2(
					rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$value(comment.uid)
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(comment.title)
						]));
			};
			var askChooseCtx = _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$option,
					_List_Nil,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('Choisir un Commentaire')
						]))
				]);
			var selectW = A2(
				rtfeldman$elm_css$Html$Styled$select,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onInput(
						author$project$Components$QualificationCriteria$Tree$Edit$Update$AffectContextualCommentToBranch(path))
					]),
				_Utils_ap(
					askChooseCtx,
					A2(elm$core$List$map, fOption, model.contextualComments)));
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[selectW]));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$AffectWorkflowToTree = F2(
		function (a, b) {
			return {$: 'AffectWorkflowToTree', a: a, b: b};
		});
	var elm$json$Json$Encode$bool = _Json_wrap;
	var rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
		function (key, bool) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$bool(bool));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$selected = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
	var author$project$Components$QualificationCriteria$Tree$Edit$View$addWorkflowForm = F2(
		function (model, path) {
			var isSelected = function (w) {
				return A2(
					elm$core$Maybe$withDefault,
					false,
					A2(
						elm$core$Maybe$map,
						function (ws) {
							return _Utils_eq(ws.uid, w.uid);
						},
						model.workflowSelected));
			};
			var fOption = function (w) {
				return A2(
					rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$value(w.uid),
							rtfeldman$elm_css$Html$Styled$Attributes$selected(
							isSelected(w))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(w.label)
						]));
			};
			var askChooseW = A2(
				elm$core$Maybe$withDefault,
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$option,
						_List_Nil,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('Choisir un worflow')
							]))
					]),
				A2(
					elm$core$Maybe$map,
					elm$core$Basics$always(_List_Nil),
					model.workflowSelected));
			var selectW = A2(
				rtfeldman$elm_css$Html$Styled$select,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onInput(
						author$project$Components$QualificationCriteria$Tree$Edit$Update$AffectWorkflowToTree(path))
					]),
				_Utils_ap(
					askChooseW,
					A2(elm$core$List$map, fOption, model.availableWorkflows)));
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[selectW]));
		});
	var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$View$cancelButton = _List_fromArray(
		[
			A2(
			rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$Components$QualificationCriteria$Tree$Edit$Update$BackToList)
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text('Annuler')
				]))
		]);
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$RemoveCriteriaTree = {$: 'RemoveCriteriaTree'};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$RemoveTree = function (a) {
		return {$: 'RemoveTree', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$View$removeButton = function (links) {
		var theButton = function (link) {
			return _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Components$QualificationCriteria$Tree$Edit$Update$RemoveTree(link))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('Supprimer')
						]))
				]);
		};
		var rightToRemove = A2(
			author$project$Utils$Http$NavigationLinkUtils$find,
			author$project$Components$QualificationCriteria$Tree$Edit$Model$showRel(author$project$Components$QualificationCriteria$Tree$Edit$Model$RemoveCriteriaTree),
			links);
		return A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(elm$core$Maybe$map, theButton, rightToRemove));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$AddCriteria = function (a) {
		return {$: 'AddCriteria', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$AddWorkflow = function (a) {
		return {$: 'AddWorkflow', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$AskToIncrementTree = function (a) {
		return {$: 'AskToIncrementTree', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$display = rtfeldman$elm_css$Css$prop1('display');
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$inline = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'inline'};
	var rtfeldman$elm_css$Css$none = {backgroundImage: rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, cursor: rtfeldman$elm_css$Css$Structure$Compatible, display: rtfeldman$elm_css$Css$Structure$Compatible, hoverCapability: rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, keyframes: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: rtfeldman$elm_css$Css$Structure$Compatible, none: rtfeldman$elm_css$Css$Structure$Compatible, outline: rtfeldman$elm_css$Css$Structure$Compatible, pointerDevice: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, resize: rtfeldman$elm_css$Css$Structure$Compatible, scriptingSupport: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: rtfeldman$elm_css$Css$Structure$Compatible, textTransform: rtfeldman$elm_css$Css$Structure$Compatible, touchAction: rtfeldman$elm_css$Css$Structure$Compatible, transform: rtfeldman$elm_css$Css$Structure$Compatible, updateFrequency: rtfeldman$elm_css$Css$Structure$Compatible, value: 'none'};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var author$project$Components$QualificationCriteria$Tree$Edit$View$addNodeButton = F2(
		function (criterias, path) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onClick(
								author$project$Components$QualificationCriteria$Tree$Edit$Update$AskToIncrementTree(
									author$project$Components$QualificationCriteria$Tree$Edit$Model$AddCriteria(path))),
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										elm$core$List$isEmpty(
										A2(author$project$Components$QualificationCriteria$Tree$Edit$View$leftCriteria, criterias, path)) ? rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none) : rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inline)
									]))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('+')
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onClick(
								author$project$Components$QualificationCriteria$Tree$Edit$Update$AskToIncrementTree(
									author$project$Components$QualificationCriteria$Tree$Edit$Model$AddWorkflow(path)))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('W')
							]))
					]));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Model$AddCtxComment = function (a) {
		return {$: 'AddCtxComment', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$title = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
	var author$project$Components$QualificationCriteria$Tree$Edit$View$addCtxCommentButton = function (path) {
		return A2(
			rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onClick(
					author$project$Components$QualificationCriteria$Tree$Edit$Update$AskToIncrementTree(
						author$project$Components$QualificationCriteria$Tree$Edit$Model$AddCtxComment(path))),
					rtfeldman$elm_css$Html$Styled$Attributes$title('Ajouter un commentaire contextuel')
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text('C')
				]));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$RemoveLeaf = function (a) {
		return {$: 'RemoveLeaf', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$View$removeLeafButton = function (path) {
		return A2(
			rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onClick(
					author$project$Components$QualificationCriteria$Tree$Edit$Update$RemoveLeaf(path)),
					rtfeldman$elm_css$Html$Styled$Attributes$title('Retirer le noeud de la branche')
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text('D')
				]));
	};
	var author$project$Components$QualificationCriteria$Tree$Edit$View$shouldRemoveLeaf = function (path) {
		return author$project$Components$QualificationCriteria$Tree$Edit$View$removeLeafButton(path);
	};
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var author$project$Utils$String$StringUtils$ellips = F2(
		function (size, s) {
			var x = elm$core$String$fromList(
				A2(
					elm$core$List$take,
					size,
					elm$core$String$toList(s)));
			var result = _Utils_eq(x, s) ? x : (x + ' ...');
			return result;
		});
	var author$project$Utils$String$StringUtils$ellips20 = author$project$Utils$String$StringUtils$ellips(20);
	var rtfeldman$elm_css$Html$Styled$span = rtfeldman$elm_css$Html$Styled$node('span');
	var rtfeldman$elm_css$Html$Styled$Attributes$class = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
	var author$project$Components$QualificationCriteria$Tree$Edit$View$renderCtx = F2(
		function (path, ctx) {
			return _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('entry sole')
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('labelTree comment'),
									rtfeldman$elm_css$Html$Styled$Attributes$title(ctx.title)
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(
									author$project$Utils$String$StringUtils$ellips20(ctx.title)),
									A2(
									rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											author$project$Components$QualificationCriteria$Tree$Edit$View$shouldRemoveLeaf(path)
										]))
								]))
						]))
				]);
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$View$renderCriteria = F3(
		function (criterias, path, criteria) {
			var others = A2(
				elm$core$List$map,
				A2(author$project$Components$QualificationCriteria$Tree$Edit$View$renderCriteriaValue, criterias, path),
				criteria.values);
			var deleteButton = author$project$Components$QualificationCriteria$Tree$Edit$View$shouldRemoveLeaf(path);
			var canDelete = A2(
				elm$core$Maybe$withDefault,
				_List_fromArray(
					[deleteButton]),
				A2(
					elm$core$Maybe$map,
					elm$core$Basics$always(_List_Nil),
					elm$core$List$head(
						A2(
							elm$core$List$filterMap,
							function ($) {
								return $.nextStep;
							},
							criteria.values))));
			var meta = _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$title(criteria.label),
										rtfeldman$elm_css$Html$Styled$Attributes$class('criteriaTitle')
									]),
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text(
										author$project$Utils$String$StringUtils$ellips20(criteria.label))
									]))
							]),
						canDelete))
				]);
			return _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('criteriaBox')
						]),
					_Utils_ap(meta, others))
				]);
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$View$renderCriteriaValue = F3(
		function (criterias, path, v) {
			var childs = A2(
				elm$core$Maybe$withDefault,
				A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				A2(
					elm$core$Maybe$map,
					A2(
						author$project$Components$QualificationCriteria$Tree$Edit$View$renderTree,
						criterias,
						_Utils_ap(
							path,
							_List_fromArray(
								[v.uid]))),
					v.nextStep));
			var addActions = A2(
				elm$core$Maybe$withDefault,
				A2(
					author$project$Components$QualificationCriteria$Tree$Edit$View$addNodeButton,
					criterias,
					_Utils_ap(
						path,
						_List_fromArray(
							[v.uid]))),
				A2(
					elm$core$Maybe$map,
					elm$core$Basics$always(
						A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
					v.nextStep));
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class('entry')
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$class('labelTree'),
								rtfeldman$elm_css$Html$Styled$Attributes$title(v.value)
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(
								author$project$Utils$String$StringUtils$ellips20(v.value)),
								addActions
							])),
						childs
					]));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$View$renderTree = F3(
		function (criterias, path, tree) {
			var children = function () {
				switch (tree.$) {
					case 'CriterionNode':
						var crit = tree.a;
						return A3(author$project$Components$QualificationCriteria$Tree$Edit$View$renderCriteria, criterias, path, crit);
					case 'WorkflowLeaf':
						var w = tree.a;
						return A2(author$project$Components$QualificationCriteria$Tree$Edit$View$renderWorkflow, path, w);
					default:
						var ctx = tree.a;
						return A2(author$project$Components$QualificationCriteria$Tree$Edit$View$renderCtx, path, ctx);
				}
			}();
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$class('branch')
					]),
				children);
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$View$renderWorkflow = F2(
		function (path, w) {
			var noChild = A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						author$project$Components$QualificationCriteria$Tree$Edit$View$shouldRemoveLeaf(path),
						author$project$Components$QualificationCriteria$Tree$Edit$View$addCtxCommentButton(
						_Utils_ap(
							path,
							_List_fromArray(
								[w.uid])))
					]));
			var child = function (next) {
				return A3(
					author$project$Components$QualificationCriteria$Tree$Edit$View$renderTree,
					_List_Nil,
					_Utils_ap(
						path,
						_List_fromArray(
							[w.uid])),
					next);
			};
			return _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('entry sole')
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('labelTree workflow'),
									rtfeldman$elm_css$Html$Styled$Attributes$title(w.label)
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(
									author$project$Utils$String$StringUtils$ellips20(w.label)),
									A2(
									elm$core$Maybe$withDefault,
									noChild,
									A2(
										elm$core$Maybe$map,
										function (_n0) {
											return A2(rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil);
										},
										w.nextStep))
								])),
							A2(
							elm$core$Maybe$withDefault,
							A2(rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil),
							A2(elm$core$Maybe$map, child, w.nextStep))
						]))
				]);
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$id = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
	var author$project$Components$QualificationCriteria$Tree$Edit$View$renderRoot = F2(
		function (criterias, tree) {
			var children = A2(
				elm$core$Maybe$withDefault,
				rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					elm$core$Maybe$map,
					A2(author$project$Components$QualificationCriteria$Tree$Edit$View$renderTree, criterias, _List_Nil),
					tree));
			var actions = A2(
				elm$core$Maybe$withDefault,
				A2(author$project$Components$QualificationCriteria$Tree$Edit$View$addNodeButton, criterias, _List_Nil),
				A2(
					elm$core$Maybe$map,
					elm$core$Basics$always(
						rtfeldman$elm_css$Html$Styled$text('')),
					tree));
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$id('wrapper')
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$class('rootTree')
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('#'),
								actions
							])),
						children
					]));
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$Update$SaveTree = function (a) {
		return {$: 'SaveTree', a: a};
	};
	var elm$core$Maybe$map3 = F4(
		function (func, ma, mb, mc) {
			if (ma.$ === 'Nothing') {
				return elm$core$Maybe$Nothing;
			} else {
				var a = ma.a;
				if (mb.$ === 'Nothing') {
					return elm$core$Maybe$Nothing;
				} else {
					var b = mb.a;
					if (mc.$ === 'Nothing') {
						return elm$core$Maybe$Nothing;
					} else {
						var c = mc.a;
						return elm$core$Maybe$Just(
							A3(func, a, b, c));
					}
				}
			}
		});
	var author$project$Components$QualificationCriteria$Tree$Edit$View$shouldEnableSentIt = function (model) {
		var hasOtps = elm$core$List$head(
			inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.multiselectOtps));
		return (!model.networkAccess) && A2(
			elm$core$Maybe$withDefault,
			false,
			A4(
				elm$core$Maybe$map3,
				F3(
					function (_n0, _n1, _n2) {
						return true;
					}),
				hasOtps,
				model.label,
				model.hasChangeSomething));
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$disabled = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
	var author$project$Components$QualificationCriteria$Tree$Edit$View$saveButton = function (model) {
		var canConfigueTree = A2(
			author$project$Utils$Http$NavigationLinkUtils$find,
			author$project$Components$QualificationCriteria$Tree$Edit$Model$showRel(author$project$Components$QualificationCriteria$Tree$Edit$Model$ConfigureCriteriaTree),
			model.treeLinks);
		var but = function (link) {
			return _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Components$QualificationCriteria$Tree$Edit$Update$SaveTree(link)),
							rtfeldman$elm_css$Html$Styled$Attributes$disabled(
							!author$project$Components$QualificationCriteria$Tree$Edit$View$shouldEnableSentIt(model))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('Sauvegarder')
						]))
				]);
		};
		return A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(elm$core$Maybe$map, but, canConfigueTree));
	};
	var elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
	var elm$html$Html$map = elm$virtual_dom$VirtualDom$map;
	var inkuzmin$elm_multiselect$Multiselect$ClickOnComponent = {$: 'ClickOnComponent'};
	var inkuzmin$elm_multiselect$Multiselect$Focused = {$: 'Focused'};
	var inkuzmin$elm_multiselect$Multiselect$Toggle = {$: 'Toggle'};
	var inkuzmin$elm_multiselect$Multiselect$withOptions = F2(
		function (options, decoder) {
			return A2(
				elm$json$Json$Decode$map,
				function (m) {
					return {message: m, preventDefault: options.preventDefault, stopPropagation: options.stopPropagation};
				},
				decoder);
		});
	var elm$virtual_dom$VirtualDom$Custom = function (a) {
		return {$: 'Custom', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$custom = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Custom(decoder));
		});
	var inkuzmin$elm_multiselect$Multiselect$onClickNoDefault = function (message) {
		var config = {preventDefault: true, stopPropagation: true};
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$custom,
			'click',
			A2(
				inkuzmin$elm_multiselect$Multiselect$withOptions,
				config,
				elm$json$Json$Decode$succeed(message)));
	};
	var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
		return {$: 'ApplyStyles', a: a};
	};
	var rtfeldman$elm_css$Css$batch = rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
	var rtfeldman$elm_css$Css$borderBottomWidth = rtfeldman$elm_css$Css$prop1('border-bottom-width');
	var rtfeldman$elm_css$Css$borderColor3 = F3(
		function (c1, c2, c3) {
			var value = A2(
				elm$core$String$join,
				' ',
				_List_fromArray(
					[c1.value, c2.value, c3.value]));
			return A2(rtfeldman$elm_css$Css$property, 'border-color', value);
		});
	var rtfeldman$elm_css$Css$borderLeftWidth = rtfeldman$elm_css$Css$prop1('border-left-width');
	var rtfeldman$elm_css$Css$borderRightWidth = rtfeldman$elm_css$Css$prop1('border-right-width');
	var rtfeldman$elm_css$Css$borderStyle = rtfeldman$elm_css$Css$prop1('border-style');
	var rtfeldman$elm_css$Css$borderTopWidth = rtfeldman$elm_css$Css$prop1('border-top-width');
	var rtfeldman$elm_css$Css$height = rtfeldman$elm_css$Css$prop1('height');
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$inlineBlock = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'inline-block'};
	var rtfeldman$elm_css$Css$position = rtfeldman$elm_css$Css$prop1('position');
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$Css$relative = {position: rtfeldman$elm_css$Css$Structure$Compatible, value: 'relative'};
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var rtfeldman$elm_css$Css$transparent = {color: rtfeldman$elm_css$Css$Structure$Compatible, value: 'transparent'};
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var rtfeldman$elm_css$Css$UnitlessInteger = {$: 'UnitlessInteger'};
	var rtfeldman$elm_css$Css$zero = {length: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible, number: rtfeldman$elm_css$Css$Structure$Compatible, numericValue: 0, outline: rtfeldman$elm_css$Css$Structure$Compatible, unitLabel: '', units: rtfeldman$elm_css$Css$UnitlessInteger, value: '0'};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$arrow = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A3(
				rtfeldman$elm_css$Css$borderColor3,
				rtfeldman$elm_css$Css$hex('#999'),
				rtfeldman$elm_css$Css$transparent,
				rtfeldman$elm_css$Css$transparent),
				rtfeldman$elm_css$Css$borderStyle(rtfeldman$elm_css$Css$solid),
				rtfeldman$elm_css$Css$borderTopWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderLeftWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderRightWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderBottomWidth(
				rtfeldman$elm_css$Css$px(2.5)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$height(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$width(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative)
			]));
	var rtfeldman$elm_css$Css$top = rtfeldman$elm_css$Css$prop1('top');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowUpside = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A3(
				rtfeldman$elm_css$Css$borderColor3,
				rtfeldman$elm_css$Css$transparent,
				rtfeldman$elm_css$Css$transparent,
				rtfeldman$elm_css$Css$hex('#999')),
				rtfeldman$elm_css$Css$borderStyle(rtfeldman$elm_css$Css$solid),
				rtfeldman$elm_css$Css$borderTopWidth(
				rtfeldman$elm_css$Css$px(2.5)),
				rtfeldman$elm_css$Css$borderLeftWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderRightWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$borderBottomWidth(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$height(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$width(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$top(
				rtfeldman$elm_css$Css$px(-2.5))
			]));
	var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$middle = rtfeldman$elm_css$Css$prop1('middle');
	var rtfeldman$elm_css$Css$paddingRight = rtfeldman$elm_css$Css$prop1('padding-right');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var rtfeldman$elm_css$Css$tableCell = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'table-cell'};
	var rtfeldman$elm_css$Css$Internal$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
		function (functionName, desiredKey, style) {
			getOverloadedProperty:
			while (true) {
				switch (style.$) {
					case 'AppendProperty':
						var str = style.a;
						var key = A2(
							elm$core$Maybe$withDefault,
							'',
							elm$core$List$head(
								A2(elm$core$String$split, ':', str)));
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
					case 'ExtendSelector':
						var selector = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
					case 'NestSnippet':
						var combinator = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
					case 'WithPseudoElement':
						var pseudoElement = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
					case 'WithMedia':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
					case 'WithKeyframes':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
					default:
						if (!style.a.b) {
							return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
						} else {
							if (!style.a.b.b) {
								var _n1 = style.a;
								var only = _n1.a;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = only;
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							} else {
								var _n2 = style.a;
								var first = _n2.a;
								var rest = _n2.b;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							}
						}
				}
			}
		});
	var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
	var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
	var rtfeldman$elm_css$Css$textAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'textAlign',
			'text-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$verticalAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'verticalAlign',
			'vertical-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowWrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$tableCell),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$px(25)),
				rtfeldman$elm_css$Css$paddingRight(
				rtfeldman$elm_css$Css$px(5))
			]));
	var elm$virtual_dom$VirtualDom$attribute = F2(
		function (key, value) {
			return A2(
				_VirtualDom_attribute,
				_VirtualDom_noOnOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$attribute, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$rel = rtfeldman$elm_css$VirtualDom$Styled$attribute('rel');
	var inkuzmin$elm_multiselect$Multiselect$arrow = function (_n0) {
		var model = _n0.a;
		var arrowRel = _Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Opened) ? 'arrowUpside' : 'arrow';
		var arrowCss = _Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Opened) ? _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowUpside]) : _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$arrow]);
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowWrap])),
					inkuzmin$elm_multiselect$Multiselect$onClickNoDefault(inkuzmin$elm_multiselect$Multiselect$Toggle)
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(arrowCss),
							rtfeldman$elm_css$Html$Styled$Attributes$rel(arrowRel)
						]),
					_List_Nil)
				]));
	};
	var inkuzmin$elm_multiselect$Multiselect$Clear = {$: 'Clear'};
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var rtfeldman$elm_css$Css$lineHeight = rtfeldman$elm_css$Css$prop1('line-height');
	var rtfeldman$elm_css$Css$UnitlessFloat = {$: 'UnitlessFloat'};
	var rtfeldman$elm_css$Css$num = function (val) {
		return {
			lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
			number: rtfeldman$elm_css$Css$Structure$Compatible,
			numberOrInfinite: rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: val,
			unitLabel: '',
			units: rtfeldman$elm_css$Css$UnitlessFloat,
			value: elm$core$String$fromFloat(val)
		};
	};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$clear = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$fontSize(
				rtfeldman$elm_css$Css$px(18)),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$num(1))
			]));
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
		function (a, b) {
			return {$: 'ExtendSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
		return {$: 'PseudoClassSelector', a: a};
	};
	var rtfeldman$elm_css$Css$pseudoClass = function (_class) {
		return rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
			rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
	};
	var rtfeldman$elm_css$Css$hover = rtfeldman$elm_css$Css$pseudoClass('hover');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$clearWrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$px(17)),
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#999')),
				rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$tableCell),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle),
				rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$color(
						rtfeldman$elm_css$Css$hex('#D0021B'))
					]))
			]));
	var inkuzmin$elm_multiselect$Multiselect$clear = function (_n0) {
		var model = _n0.a;
		return (!elm$core$List$isEmpty(model.selected)) ? A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$clearWrap])),
					inkuzmin$elm_multiselect$Multiselect$onClickNoDefault(inkuzmin$elm_multiselect$Multiselect$Clear)
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[inkuzmin$elm_multiselect$Multiselect$SelectCss$clear]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('×')
						]))
				])) : A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	};
	var inkuzmin$elm_multiselect$Multiselect$Adjust = function (a) {
		return {$: 'Adjust', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Filter = function (a) {
		return {$: 'Filter', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$Shortcut = function (a) {
		return {$: 'Shortcut', a: a};
	};
	var elm$json$Json$Decode$float = _Json_decodeFloat;
	var debois$elm_dom$DOM$offsetWidth = A2(elm$json$Json$Decode$field, 'offsetWidth', elm$json$Json$Decode$float);
	var debois$elm_dom$DOM$previousSibling = function (decoder) {
		return A2(elm$json$Json$Decode$field, 'previousSibling', decoder);
	};
	var debois$elm_dom$DOM$target = function (decoder) {
		return A2(elm$json$Json$Decode$field, 'target', decoder);
	};
	var inkuzmin$elm_multiselect$Multiselect$onKeyDown = function (tagger) {
		var domF = debois$elm_dom$DOM$target(
			debois$elm_dom$DOM$previousSibling(debois$elm_dom$DOM$offsetWidth));
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'keypress',
			A2(elm$json$Json$Decode$map, tagger, domF));
	};
	var elm$json$Json$Decode$int = _Json_decodeInt;
	var rtfeldman$elm_css$Html$Styled$Events$keyCode = A2(elm$json$Json$Decode$field, 'keyCode', elm$json$Json$Decode$int);
	var inkuzmin$elm_multiselect$Multiselect$onKeyPress = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'keydown',
			A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$keyCode));
	};
	var inkuzmin$elm_multiselect$Multiselect$onKeyUp = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'keyup',
			A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue));
	};
	var inkuzmin$elm_multiselect$Multiselect$Start = {$: 'Start'};
	var inkuzmin$elm_multiselect$Multiselect$fromResult = function (result) {
		if (result.$ === 'Ok') {
			var successValue = result.a;
			return elm$json$Json$Decode$succeed(successValue);
		} else {
			var errorMessage = result.a;
			return elm$json$Json$Decode$fail(errorMessage);
		}
	};
	var inkuzmin$elm_multiselect$Multiselect$preventDefaultButtons = function () {
		var options = {preventDefault: true, stopPropagation: false};
		var filterKey = function (code) {
			return (_Utils_eq(code, inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow) || _Utils_eq(code, inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow)) ? elm$core$Result$Ok(code) : elm$core$Result$Err('ignored input');
		};
		var decoder = A2(
			elm$json$Json$Decode$map,
			elm$core$Basics$always(inkuzmin$elm_multiselect$Multiselect$Start),
			A2(
				elm$json$Json$Decode$andThen,
				A2(elm$core$Basics$composeR, filterKey, inkuzmin$elm_multiselect$Multiselect$fromResult),
				rtfeldman$elm_css$Html$Styled$Events$keyCode));
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$custom,
			'keydown',
			A2(inkuzmin$elm_multiselect$Multiselect$withOptions, options, decoder));
	}();
	var rtfeldman$elm_css$Css$border = rtfeldman$elm_css$Css$prop1('border');
	var rtfeldman$elm_css$Css$initial = {alignItems: rtfeldman$elm_css$Css$Structure$Compatible, all: rtfeldman$elm_css$Css$Structure$Compatible, backgroundAttachment: rtfeldman$elm_css$Css$Structure$Compatible, backgroundBlendMode: rtfeldman$elm_css$Css$Structure$Compatible, backgroundImage: rtfeldman$elm_css$Css$Structure$Compatible, backgroundOrigin: rtfeldman$elm_css$Css$Structure$Compatible, backgroundRepeat: rtfeldman$elm_css$Css$Structure$Compatible, backgroundRepeatShorthand: rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, boxSizing: rtfeldman$elm_css$Css$Structure$Compatible, color: rtfeldman$elm_css$Css$Structure$Compatible, cursor: rtfeldman$elm_css$Css$Structure$Compatible, display: rtfeldman$elm_css$Css$Structure$Compatible, flexBasis: rtfeldman$elm_css$Css$Structure$Compatible, flexDirection: rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, flexWrap: rtfeldman$elm_css$Css$Structure$Compatible, fontFamily: rtfeldman$elm_css$Css$Structure$Compatible, fontSize: rtfeldman$elm_css$Css$Structure$Compatible, fontStyle: rtfeldman$elm_css$Css$Structure$Compatible, fontVariant: rtfeldman$elm_css$Css$Structure$Compatible, fontWeight: rtfeldman$elm_css$Css$Structure$Compatible, intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, justifyContent: rtfeldman$elm_css$Css$Structure$Compatible, keyframes: rtfeldman$elm_css$Css$Structure$Compatible, length: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, listStylePosition: rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: rtfeldman$elm_css$Css$Structure$Compatible, none: rtfeldman$elm_css$Css$Structure$Compatible, number: rtfeldman$elm_css$Css$Structure$Compatible, numericValue: 0, outline: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, tableLayout: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, textIndent: rtfeldman$elm_css$Css$Structure$Compatible, textRendering: rtfeldman$elm_css$Css$Structure$Compatible, textTransform: rtfeldman$elm_css$Css$Structure$Compatible, touchAction: rtfeldman$elm_css$Css$Structure$Compatible, unitLabel: '', units: rtfeldman$elm_css$Css$Internal$IncompatibleUnits, value: 'initial', visibility: rtfeldman$elm_css$Css$Structure$Compatible, whiteSpace: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$inherit = _Utils_update(
		rtfeldman$elm_css$Css$initial,
		{value: 'inherit'});
	var rtfeldman$elm_css$Css$int = function (val) {
		return {
			fontWeight: rtfeldman$elm_css$Css$Structure$Compatible,
			intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
			number: rtfeldman$elm_css$Css$Structure$Compatible,
			numberOrInfinite: rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: val,
			unitLabel: '',
			units: rtfeldman$elm_css$Css$UnitlessInteger,
			value: elm$core$String$fromInt(val)
		};
	};
	var rtfeldman$elm_css$Css$outlineStyle = rtfeldman$elm_css$Css$prop1('outline-style');
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$paddingTop = rtfeldman$elm_css$Css$prop1('padding-top');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$input = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$borderStyle(rtfeldman$elm_css$Css$none),
				rtfeldman$elm_css$Css$border(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$px(14)),
				rtfeldman$elm_css$Css$outlineStyle(rtfeldman$elm_css$Css$none),
				rtfeldman$elm_css$Css$fontSize(rtfeldman$elm_css$Css$inherit),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$int(1)),
				rtfeldman$elm_css$Css$padding(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$paddingTop(
				rtfeldman$elm_css$Css$px(8))
			]));
	var rtfeldman$elm_css$Css$absolute = {position: rtfeldman$elm_css$Css$Structure$Compatible, value: 'absolute'};
	var rtfeldman$elm_css$Css$fontStyle = rtfeldman$elm_css$Css$prop1('font-style');
	var rtfeldman$elm_css$Css$fontWeight = function (_n0) {
		var value = _n0.value;
		return A2(rtfeldman$elm_css$Css$property, 'font-weight', value);
	};
	var rtfeldman$elm_css$Css$left = rtfeldman$elm_css$Css$prop1('left');
	var rtfeldman$elm_css$Css$normal = {featureTagValue: rtfeldman$elm_css$Css$Structure$Compatible, fontStyle: rtfeldman$elm_css$Css$Structure$Compatible, fontWeight: rtfeldman$elm_css$Css$Structure$Compatible, overflowWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'normal', whiteSpace: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$overflow = rtfeldman$elm_css$Css$prop1('overflow');
	var rtfeldman$elm_css$Css$scroll = {backgroundAttachment: rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, scroll: rtfeldman$elm_css$Css$Structure$Compatible, value: 'scroll'};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$inputMirrow = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
				rtfeldman$elm_css$Css$top(
				rtfeldman$elm_css$Css$px(-100)),
				rtfeldman$elm_css$Css$left(
				rtfeldman$elm_css$Css$px(-100)),
				rtfeldman$elm_css$Css$height(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$scroll),
				rtfeldman$elm_css$Css$fontWeight(rtfeldman$elm_css$Css$normal),
				rtfeldman$elm_css$Css$fontStyle(rtfeldman$elm_css$Css$normal),
				rtfeldman$elm_css$Css$fontSize(rtfeldman$elm_css$Css$inherit),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$int(1))
			]));
	var rtfeldman$elm_css$Css$marginLeft = rtfeldman$elm_css$Css$prop1('margin-left');
	var rtfeldman$elm_css$Css$paddingBottom = rtfeldman$elm_css$Css$prop1('padding-bottom');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$inputWrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$marginLeft(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$padding(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle),
				rtfeldman$elm_css$Css$paddingBottom(
				rtfeldman$elm_css$Css$px(8))
			]));
	var rtfeldman$elm_css$Html$Styled$input = rtfeldman$elm_css$Html$Styled$node('input');
	var rtfeldman$elm_css$Html$Styled$Attributes$property = rtfeldman$elm_css$VirtualDom$Styled$property;
	var elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
	var rtfeldman$elm_css$VirtualDom$Styled$style = F2(
		function (key, val) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$style, key, val),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$style = rtfeldman$elm_css$VirtualDom$Styled$style;
	var inkuzmin$elm_multiselect$Multiselect$input = function (_n0) {
		var model = _n0.a;
		var w = elm$core$String$fromFloat(model.inputWidth + 23.0);
		var value = _Utils_eq(model.input, inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? A2(
			rtfeldman$elm_css$Html$Styled$Attributes$property,
			'value',
			elm$json$Json$Encode$string(model.input)) : A2(
			rtfeldman$elm_css$Html$Styled$Attributes$property,
			'type',
			elm$json$Json$Encode$string('text'));
		var inputStyle = A2(rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', w + 'px');
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					inkuzmin$elm_multiselect$Multiselect$preventDefaultButtons,
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$inputWrap]))
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[inkuzmin$elm_multiselect$Multiselect$SelectCss$inputMirrow]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(model.input)
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectInput' + model.tag),
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[inkuzmin$elm_multiselect$Multiselect$SelectCss$input])),
							inkuzmin$elm_multiselect$Multiselect$onKeyDown(inkuzmin$elm_multiselect$Multiselect$Adjust),
							inkuzmin$elm_multiselect$Multiselect$onKeyPress(inkuzmin$elm_multiselect$Multiselect$Shortcut),
							inkuzmin$elm_multiselect$Multiselect$onKeyUp(inkuzmin$elm_multiselect$Multiselect$Filter),
							inputStyle,
							value
						]),
					_List_Nil)
				]));
	};
	var inkuzmin$elm_multiselect$Multiselect$OnHover = function (a) {
		return {$: 'OnHover', a: a};
	};
	var inkuzmin$elm_multiselect$Multiselect$OnSelect = function (a) {
		return {$: 'OnSelect', a: a};
	};
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var rtfeldman$elm_css$Css$borderBottomLeftRadius = rtfeldman$elm_css$Css$prop1('border-bottom-left-radius');
	var rtfeldman$elm_css$Css$borderBottomRightRadius = rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
	var rtfeldman$elm_css$Css$borderTopColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'border-top-color', c.value);
	};
	var rtfeldman$elm_css$Css$prop4 = F5(
		function (key, argA, argB, argC, argD) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value, argD.value])));
		});
	var rtfeldman$elm_css$Css$boxShadow4 = rtfeldman$elm_css$Css$prop4('box-shadow');
	var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
	var rtfeldman$elm_css$Css$maxHeight = rtfeldman$elm_css$Css$prop1('max-height');
	var rtfeldman$elm_css$Css$overflowY = rtfeldman$elm_css$Css$prop1('overflow-y');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$cssFunction = F2(
		function (funcName, args) {
			return funcName + ('(' + (A2(elm$core$String$join, ', ', args) + ')'));
		});
	var rtfeldman$elm_css$Css$rgba = F4(
		function (r, g, b, alpha) {
			return {
				alpha: alpha,
				blue: b,
				color: rtfeldman$elm_css$Css$Structure$Compatible,
				green: g,
				red: r,
				value: A2(
					rtfeldman$elm_css$Css$cssFunction,
					'rgba',
					_Utils_ap(
						A2(
							elm$core$List$map,
							elm$core$String$fromInt,
							_List_fromArray(
								[r, g, b])),
						_List_fromArray(
							[
								elm$core$String$fromFloat(alpha)
							])))
			};
		});
	var rtfeldman$elm_css$Css$zIndex = rtfeldman$elm_css$Css$prop1('z-index');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$menu = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$borderBottomRightRadius(
				rtfeldman$elm_css$Css$px(4)),
				rtfeldman$elm_css$Css$borderBottomLeftRadius(
				rtfeldman$elm_css$Css$px(4)),
				rtfeldman$elm_css$Css$backgroundColor(
				rtfeldman$elm_css$Css$hex('#fff')),
				A3(
				rtfeldman$elm_css$Css$border3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid,
				rtfeldman$elm_css$Css$hex('#ccc')),
				rtfeldman$elm_css$Css$borderTopColor(
				rtfeldman$elm_css$Css$hex('#e6e6e6')),
				A4(
				rtfeldman$elm_css$Css$boxShadow4,
				rtfeldman$elm_css$Css$zero,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$zero,
				A4(rtfeldman$elm_css$Css$rgba, 0, 0, 0, 6.0e-2)),
				rtfeldman$elm_css$Css$marginTop(
				rtfeldman$elm_css$Css$px(-1)),
				rtfeldman$elm_css$Css$maxHeight(
				rtfeldman$elm_css$Css$px(inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight)),
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$absolute),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(100)),
				rtfeldman$elm_css$Css$zIndex(
				rtfeldman$elm_css$Css$int(1)),
				rtfeldman$elm_css$Css$overflowY(rtfeldman$elm_css$Css$scroll)
			]));
	var rtfeldman$elm_css$Css$prop2 = F3(
		function (key, argA, argB) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value])));
		});
	var rtfeldman$elm_css$Css$padding2 = rtfeldman$elm_css$Css$prop2('padding');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#666')),
				rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
				A2(
				rtfeldman$elm_css$Css$padding2,
				rtfeldman$elm_css$Css$px(8),
				rtfeldman$elm_css$Css$px(10)),
				rtfeldman$elm_css$Css$maxHeight(
				rtfeldman$elm_css$Css$px(inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight))
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItemHovered = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$backgroundColor(
				A4(rtfeldman$elm_css$Css$rgba, 0, 126, 255, 8.0e-2)),
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#333'))
			]));
	var inkuzmin$elm_multiselect$Multiselect$Utils$fst = elm$core$Tuple$first;
	var rtfeldman$elm_css$Html$Styled$Events$onMouseOver = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'mouseover',
			elm$json$Json$Decode$succeed(msg));
	};
	var inkuzmin$elm_multiselect$Multiselect$menu = function (_n0) {
		var model = _n0.a;
		var _n1 = model.status;
		if (_n1.$ === 'Opened') {
			var hovered = function () {
				var _n3 = model.hovered;
				if (_n3.$ === 'Nothing') {
					return '';
				} else {
					var item = _n3.a;
					return inkuzmin$elm_multiselect$Multiselect$Utils$fst(item);
				}
			}();
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[inkuzmin$elm_multiselect$Multiselect$SelectCss$menu])),
						rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectMenu' + model.tag)
					]),
				A2(
					elm$core$List$map,
					function (_n2) {
						var name = _n2.a;
						var value = _n2.b;
						return A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_eq(name, hovered) ? _List_fromArray(
										[inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItemHovered, inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem]) : _List_fromArray(
										[inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem])),
									inkuzmin$elm_multiselect$Multiselect$onClickNoDefault(
									inkuzmin$elm_multiselect$Multiselect$OnSelect(
										_Utils_Tuple2(name, value))),
									rtfeldman$elm_css$Html$Styled$Events$onMouseOver(
									inkuzmin$elm_multiselect$Multiselect$OnHover(
										_Utils_Tuple2(name, value)))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text(value)
								]));
					},
					model.filtered));
		} else {
			return A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
		}
	};
	var inkuzmin$elm_multiselect$Multiselect$RemoveItem = function (a) {
		return {$: 'RemoveItem', a: a};
	};
	var rtfeldman$elm_css$Css$border2 = rtfeldman$elm_css$Css$prop2('border');
	var rtfeldman$elm_css$Css$borderColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'border-color', c.value);
	};
	var rtfeldman$elm_css$Css$borderRadius = rtfeldman$elm_css$Css$prop1('border-radius');
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$tag = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#007eff')),
				A2(
				rtfeldman$elm_css$Css$border2,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid),
				rtfeldman$elm_css$Css$borderColor(
				A4(rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.24)),
				rtfeldman$elm_css$Css$borderRadius(
				rtfeldman$elm_css$Css$px(2)),
				rtfeldman$elm_css$Css$backgroundColor(
				A4(rtfeldman$elm_css$Css$rgba, 0, 126, 255, 8.0e-2)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$fontSize(
				rtfeldman$elm_css$Css$em(0.9)),
				rtfeldman$elm_css$Css$lineHeight(
				rtfeldman$elm_css$Css$num(1.4)),
				rtfeldman$elm_css$Css$marginLeft(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$marginTop(
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$top)
			]));
	var rtfeldman$elm_css$Css$borderRight3 = rtfeldman$elm_css$Css$prop3('border-right');
	var rtfeldman$elm_css$Css$padding3 = rtfeldman$elm_css$Css$prop3('padding');
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$tagIcon = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$backgroundColor(
						rtfeldman$elm_css$Css$hex('#d8eafd'))
					])),
				rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
				A3(
				rtfeldman$elm_css$Css$borderRight3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid,
				A4(rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.24)),
				A3(
				rtfeldman$elm_css$Css$padding3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$px(5),
				rtfeldman$elm_css$Css$px(3)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle)
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$tagLabel = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Css$padding2,
				rtfeldman$elm_css$Css$px(2),
				rtfeldman$elm_css$Css$px(5)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
				rtfeldman$elm_css$Css$verticalAlign(rtfeldman$elm_css$Css$middle)
			]));
	var inkuzmin$elm_multiselect$Multiselect$tag = F2(
		function (name, value) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[inkuzmin$elm_multiselect$Multiselect$SelectCss$tag]))
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[inkuzmin$elm_multiselect$Multiselect$SelectCss$tagIcon])),
								rtfeldman$elm_css$Html$Styled$Events$onClick(
								inkuzmin$elm_multiselect$Multiselect$RemoveItem(
									_Utils_Tuple2(name, value)))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('×')
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[inkuzmin$elm_multiselect$Multiselect$SelectCss$tagLabel]))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(value)
							]))
					]));
		});
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$tagWrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inline)
			]));
	var inkuzmin$elm_multiselect$Multiselect$tags = function (_n0) {
		var model = _n0.a;
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$tagWrap]))
				]),
			A2(
				elm$core$List$map,
				function (_n1) {
					var name = _n1.a;
					var value = _n1.b;
					return A2(inkuzmin$elm_multiselect$Multiselect$tag, name, value);
				},
				model.selected));
	};
	var rtfeldman$elm_css$Css$table = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'table'};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$container = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A3(
				rtfeldman$elm_css$Css$border3,
				rtfeldman$elm_css$Css$px(1),
				rtfeldman$elm_css$Css$solid,
				rtfeldman$elm_css$Css$hex('#ccc')),
				rtfeldman$elm_css$Css$borderRadius(
				rtfeldman$elm_css$Css$px(4)),
				A3(
				rtfeldman$elm_css$Css$borderColor3,
				rtfeldman$elm_css$Css$hex('#d9d9d9'),
				rtfeldman$elm_css$Css$hex('#ccc'),
				rtfeldman$elm_css$Css$hex('#b3b3b3')),
				rtfeldman$elm_css$Css$backgroundColor(
				rtfeldman$elm_css$Css$hex('#fff')),
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('#333')),
				rtfeldman$elm_css$Css$height(
				rtfeldman$elm_css$Css$px(34)),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(100)),
				rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$table)
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$boxShadowCustom = function (p) {
		return A2(rtfeldman$elm_css$Css$property, 'box-shadow', p);
	};
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$focused = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$borderColor(
				rtfeldman$elm_css$Css$hex('#007eff')),
				inkuzmin$elm_multiselect$Multiselect$SelectCss$boxShadowCustom('inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1)')
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$opened = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$borderBottomLeftRadius(rtfeldman$elm_css$Css$zero),
				rtfeldman$elm_css$Css$borderBottomRightRadius(rtfeldman$elm_css$Css$zero)
			]));
	var inkuzmin$elm_multiselect$Multiselect$SelectCss$wrap = rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$position(rtfeldman$elm_css$Css$relative),
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(100))
			]));
	var inkuzmin$elm_multiselect$Multiselect$styledView = function (_n0) {
		var model = _n0.a;
		var inputCss = _Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Focused) ? _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$container, inkuzmin$elm_multiselect$Multiselect$SelectCss$focused]) : (_Utils_eq(model.status, inkuzmin$elm_multiselect$Multiselect$Opened) ? _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$container, inkuzmin$elm_multiselect$Multiselect$SelectCss$opened]) : _List_fromArray(
			[inkuzmin$elm_multiselect$Multiselect$SelectCss$container]));
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[inkuzmin$elm_multiselect$Multiselect$SelectCss$wrap])),
					rtfeldman$elm_css$Html$Styled$Events$onClick(inkuzmin$elm_multiselect$Multiselect$ClickOnComponent)
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(inputCss)
						]),
					_List_fromArray(
						[
							inkuzmin$elm_multiselect$Multiselect$tags(
							inkuzmin$elm_multiselect$Multiselect$Model(model)),
							inkuzmin$elm_multiselect$Multiselect$input(
							inkuzmin$elm_multiselect$Multiselect$Model(model)),
							inkuzmin$elm_multiselect$Multiselect$clear(
							inkuzmin$elm_multiselect$Multiselect$Model(model)),
							inkuzmin$elm_multiselect$Multiselect$arrow(
							inkuzmin$elm_multiselect$Multiselect$Model(model))
						])),
					inkuzmin$elm_multiselect$Multiselect$menu(
					inkuzmin$elm_multiselect$Multiselect$Model(model))
				]));
	};
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var inkuzmin$elm_multiselect$Multiselect$view = A2(elm$core$Basics$composeR, inkuzmin$elm_multiselect$Multiselect$styledView, rtfeldman$elm_css$Html$Styled$toUnstyled);
	var rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
	var rtfeldman$elm_css$Html$Styled$fromUnstyled = rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
	var author$project$Components$QualificationCriteria$Tree$Edit$View$showOtp = function (multiSelectModel) {
		return rtfeldman$elm_css$Html$Styled$fromUnstyled(
			A2(
				elm$html$Html$map,
				author$project$Components$QualificationCriteria$Tree$Edit$Update$OtpsMultiselect,
				inkuzmin$elm_multiselect$Multiselect$view(multiSelectModel)));
	};
	var rtfeldman$elm_css$Css$auto = {alignItemsOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, cursor: rtfeldman$elm_css$Css$Structure$Compatible, flexBasis: rtfeldman$elm_css$Css$Structure$Compatible, intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, justifyContentOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, tableLayout: rtfeldman$elm_css$Css$Structure$Compatible, textRendering: rtfeldman$elm_css$Css$Structure$Compatible, touchAction: rtfeldman$elm_css$Css$Structure$Compatible, value: 'auto'};
	var rtfeldman$elm_css$Css$flex = rtfeldman$elm_css$Css$prop1('flex');
	var rtfeldman$elm_css$Html$Styled$label = rtfeldman$elm_css$Html$Styled$node('label');
	var author$project$Components$QualificationCriteria$Tree$Edit$View$view = function (model) {
		var treePart = A2(author$project$Components$QualificationCriteria$Tree$Edit$View$renderRoot, model.criteriaRef, model.decisionTree);
		var globalActionButtons = _Utils_ap(
			author$project$Components$QualificationCriteria$Tree$Edit$View$cancelButton,
			_Utils_ap(
				author$project$Components$QualificationCriteria$Tree$Edit$View$saveButton(model),
				author$project$Components$QualificationCriteria$Tree$Edit$View$removeButton(model.treeLinks)));
		var actionsPart = function () {
			var _n0 = model.action;
			if (_n0.$ === 'Just') {
				switch (_n0.a.$) {
					case 'AddCriteria':
						var path = _n0.a.a;
						return A2(author$project$Components$QualificationCriteria$Tree$Edit$View$addCriteriaForm, model, path);
					case 'AddWorkflow':
						var path = _n0.a.a;
						return A2(author$project$Components$QualificationCriteria$Tree$Edit$View$addWorkflowForm, model, path);
					default:
						var path = _n0.a.a;
						return A2(author$project$Components$QualificationCriteria$Tree$Edit$View$addCtxCommentForm, model, path);
				}
			} else {
				return rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$class('topWrapper')
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$flex(
									rtfeldman$elm_css$Css$int(1)),
									rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$auto)
								]))
						]),
					_List_fromArray(
						[treePart])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('actionsWrapper')
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$label,
							_List_Nil,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Nom de l\'arbre')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$Components$QualificationCriteria$Tree$Edit$Update$ChangeLabel),
									rtfeldman$elm_css$Html$Styled$Attributes$value(
									A2(elm$core$Maybe$withDefault, '', model.label))
								]),
							_List_Nil),
							A2(
							rtfeldman$elm_css$Html$Styled$label,
							_List_Nil,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Choisir au moins un OTP')
								])),
							author$project$Components$QualificationCriteria$Tree$Edit$View$showOtp(model.multiselectOtps),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('actions')
								]),
							_List_fromArray(
								[actionsPart])),
							A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, globalActionButtons)
						]))
				]));
	};
	var author$project$Components$QualificationCriteria$Tree$List$Update$CreateTree = function (a) {
		return {$: 'CreateTree', a: a};
	};
	var author$project$Components$QualificationCriteria$Tree$List$Update$EditTree = F2(
		function (a, b) {
			return {$: 'EditTree', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var author$project$Components$QualificationCriteria$Tree$List$View$lineCss = _List_fromArray(
		[
			rtfeldman$elm_css$Css$color(
			rtfeldman$elm_css$Css$hex('8a959a')),
			rtfeldman$elm_css$Css$backgroundColor(
			rtfeldman$elm_css$Css$hex('FBFBFB')),
			A3(
			rtfeldman$elm_css$Css$border3,
			rtfeldman$elm_css$Css$px(1),
			rtfeldman$elm_css$Css$solid,
			rtfeldman$elm_css$Css$hex('ddd')),
			rtfeldman$elm_css$Css$marginBottom(
			rtfeldman$elm_css$Css$px(10)),
			rtfeldman$elm_css$Css$padding(
			rtfeldman$elm_css$Css$px(15))
		]);
	var author$project$Components$QualificationCriteria$Tree$List$View$entry = function (l) {
		var getTree = A2(author$project$Utils$Http$NavigationLinkUtils$find, 'self', l.links);
		var editTree = function (link) {
			return _List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$batch(
							_Utils_ap(
								author$project$Components$QualificationCriteria$Tree$List$View$lineCss,
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer)
									])))
						])),
					rtfeldman$elm_css$Html$Styled$Events$onClick(
					A2(author$project$Components$QualificationCriteria$Tree$List$Update$EditTree, l.uid, link))
				]);
		};
		var params = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(elm$core$Maybe$map, editTree, getTree));
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			params,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(l.title)
				]));
	};
	var rtfeldman$elm_css$Css$margin = rtfeldman$elm_css$Css$prop1('margin');
	var author$project$Components$QualificationCriteria$Tree$List$View$view = function (model) {
		var addLink = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Maybe$map,
				function (link) {
					return _List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onClick(
									author$project$Components$QualificationCriteria$Tree$List$Update$CreateTree(link)),
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
											rtfeldman$elm_css$Css$marginBottom(
											rtfeldman$elm_css$Css$px(25))
										]))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('ajouter')
								]))
						]);
				},
				A2(
					elm_community$list_extra$List$Extra$find,
					function (l) {
						return l.rel === 'ConfigureCriteriaTree';
					},
					model.list.links)));
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$width(
							rtfeldman$elm_css$Css$px(1140)),
							rtfeldman$elm_css$Css$margin(rtfeldman$elm_css$Css$auto)
						]))
				]),
			_List_fromArray(
				[
					A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, addLink),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2(elm$core$List$map, author$project$Components$QualificationCriteria$Tree$List$View$entry, model.list.result))
				]));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$KeyedNode = F3(
		function (a, b, c) {
			return {$: 'KeyedNode', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS = F4(
		function (a, b, c, d) {
			return {$: 'KeyedNodeNS', a: a, b: b, c: c, d: d};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
		function (a, b, c, d) {
			return {$: 'NodeNS', a: a, b: b, c: c, d: d};
		});
	var elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
	var rtfeldman$elm_css$VirtualDom$Styled$mapAttribute = F2(
		function (transform, _n0) {
			var prop = _n0.a;
			var styles = _n0.b;
			var classname = _n0.c;
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$mapAttribute, transform, prop),
				styles,
				classname);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$map = F2(
		function (transform, vdomNode) {
			switch (vdomNode.$) {
				case 'Node':
					var elemType = vdomNode.a;
					var properties = vdomNode.b;
					var children = vdomNode.c;
					return A3(
						rtfeldman$elm_css$VirtualDom$Styled$Node,
						elemType,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
							properties),
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$map(transform),
							children));
				case 'NodeNS':
					var ns = vdomNode.a;
					var elemType = vdomNode.b;
					var properties = vdomNode.c;
					var children = vdomNode.d;
					return A4(
						rtfeldman$elm_css$VirtualDom$Styled$NodeNS,
						ns,
						elemType,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
							properties),
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$map(transform),
							children));
				case 'KeyedNode':
					var elemType = vdomNode.a;
					var properties = vdomNode.b;
					var children = vdomNode.c;
					return A3(
						rtfeldman$elm_css$VirtualDom$Styled$KeyedNode,
						elemType,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
							properties),
						A2(
							elm$core$List$map,
							function (_n1) {
								var key = _n1.a;
								var child = _n1.b;
								return _Utils_Tuple2(
									key,
									A2(rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
							},
							children));
				case 'KeyedNodeNS':
					var ns = vdomNode.a;
					var elemType = vdomNode.b;
					var properties = vdomNode.c;
					var children = vdomNode.d;
					return A4(
						rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS,
						ns,
						elemType,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
							properties),
						A2(
							elm$core$List$map,
							function (_n2) {
								var key = _n2.a;
								var child = _n2.b;
								return _Utils_Tuple2(
									key,
									A2(rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
							},
							children));
				default:
					var vdom = vdomNode.a;
					return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
						A2(elm$virtual_dom$VirtualDom$map, transform, vdom));
			}
		});
	var rtfeldman$elm_css$Html$Styled$map = rtfeldman$elm_css$VirtualDom$Styled$map;
	var author$project$QualificationCriteriaTree$view = function (state) {
		var _n0 = state.componentModel;
		if (_n0.$ === 'ListModel') {
			var model = _n0.a;
			return A2(
				rtfeldman$elm_css$Html$Styled$map,
				author$project$QualificationCriteriaTree$ListAction,
				author$project$Components$QualificationCriteria$Tree$List$View$view(model));
		} else {
			var model = _n0.a;
			return A2(
				rtfeldman$elm_css$Html$Styled$map,
				author$project$QualificationCriteriaTree$EditAction,
				author$project$Components$QualificationCriteria$Tree$Edit$View$view(model));
		}
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$json$Json$Decode$index = _Json_decodeIndex;
	var author$project$QualificationCriteriaTree$main = elm$browser$Browser$element(
		{
			init: author$project$QualificationCriteriaTree$init,
			subscriptions: author$project$QualificationCriteriaTree$subscriptions,
			update: author$project$QualificationCriteriaTree$update,
			view: A2(elm$core$Basics$composeR, author$project$QualificationCriteriaTree$view, rtfeldman$elm_css$Html$Styled$toUnstyled)
		});
	_Platform_export({'QualificationCriteriaTree':{'init':author$project$QualificationCriteriaTree$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (seedInfos) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (navigationLinks) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (clientCompany) {
								return A2(
									elm$json$Json$Decode$andThen,
									function (apiUrl) {
										return A2(
											elm$json$Json$Decode$andThen,
											function (apiEvent) {
												return elm$json$Json$Decode$succeed(
													{apiEvent: apiEvent, apiUrl: apiUrl, clientCompany: clientCompany, navigationLinks: navigationLinks, seedInfos: seedInfos});
											},
											A2(elm$json$Json$Decode$field, 'apiEvent', elm$json$Json$Decode$string));
									},
									A2(elm$json$Json$Decode$field, 'apiUrl', elm$json$Json$Decode$string));
							},
							A2(elm$json$Json$Decode$field, 'clientCompany', elm$json$Json$Decode$string));
					},
					A2(elm$json$Json$Decode$field, 'navigationLinks', elm$json$Json$Decode$value));
			},
			A2(
				elm$json$Json$Decode$field,
				'seedInfos',
				A2(
					elm$json$Json$Decode$andThen,
					function (x0) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (x1) {
								return elm$json$Json$Decode$succeed(
									_Utils_Tuple2(x0, x1));
							},
							A2(
								elm$json$Json$Decode$index,
								1,
								elm$json$Json$Decode$list(elm$json$Json$Decode$int)));
					},
					A2(elm$json$Json$Decode$index, 0, elm$json$Json$Decode$int)))))(0)}});}(this));

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$ShowDocumentsCard$CountDocuments = function (a) {
		return {$: 'CountDocuments', a: a};
	};
	var author$project$ShowDocumentsCard$Model = F2(
		function (flags, documents) {
			return {documents: documents, flags: flags};
		});
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var author$project$ShowDocumentsCard$init = function (f) {
		return _Utils_Tuple2(
			A2(author$project$ShowDocumentsCard$Model, f, _List_Nil),
			author$project$Utils$Command$msgToElmCmd(
				author$project$ShowDocumentsCard$CountDocuments(f.simplifiedRequestUid)));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$ShowDocumentsCard$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var elm$json$Json$Decode$map = _Json_map1;
	var author$project$Binding$ResultDecoder$resultsDecoder = function (listDecoder) {
		return A2(
			elm$json$Json$Decode$map,
			function (x) {
				return x.result;
			},
			author$project$Binding$ResultDecoder$resultDecoder(listDecoder));
	};
	var author$project$ShowDocumentsCard$DocumentFetched = function (a) {
		return {$: 'DocumentFetched', a: a};
	};
	var author$project$ShowDocumentsCard$Document = F2(
		function (url, documentType) {
			return {documentType: documentType, url: url};
		});
	var author$project$ShowDocumentsCard$documentDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$ShowDocumentsCard$Document)));
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
		if (m.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var x = m.a;
			return _List_fromArray(
				[x]);
		}
	};
	var author$project$ShowDocumentsCard$update = F2(
		function (msg, model) {
			if (msg.$ === 'CountDocuments') {
				var srUid = msg.a;
				var fetchSrImagesUrl = function (uid) {
					return model.flags.queryApiBaseUrl + ('/documents?aggregatetype=SimplifiedRequest&aggregateuid=' + uid);
				};
				var fetchSrImages = function (uid) {
					return author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							fetchSrImagesUrl(uid),
							A2(
								elm$http$Http$expectJson,
								author$project$ShowDocumentsCard$DocumentFetched,
								author$project$Binding$ResultDecoder$resultsDecoder(
									elm$json$Json$Decode$list(author$project$ShowDocumentsCard$documentDecoder)))));
				};
				var countEntityDocuments = model.flags.queryApiBaseUrl + ('/documents?aggregatetype=Ticket&aggregateuid=' + model.flags.entityUid);
				var countDocument = author$project$Utils$Http$HttpRequest$withAuthReq(
					A2(
						author$project$Utils$Http$HttpRequest$Get,
						countEntityDocuments,
						A2(
							elm$http$Http$expectJson,
							author$project$ShowDocumentsCard$DocumentFetched,
							author$project$Binding$ResultDecoder$resultsDecoder(
								elm$json$Json$Decode$list(author$project$ShowDocumentsCard$documentDecoder)))));
				var cmds = elm$core$Platform$Cmd$batch(
					A2(
						elm$core$List$cons,
						countDocument,
						elm_community$maybe_extra$Maybe$Extra$toList(
							A2(elm$core$Maybe$map, fetchSrImages, srUid))));
				return _Utils_Tuple2(model, cmds);
			} else {
				if (msg.a.$ === 'Ok') {
					var documents = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								documents: _Utils_ap(model.documents, documents)
							}),
						elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$borderBottom3 = rtfeldman$elm_css$Css$prop3('border-bottom');
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$String$fromList = _String_fromList;
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var rtfeldman$elm_css$Css$textTransform = rtfeldman$elm_css$Css$prop1('text-transform');
	var rtfeldman$elm_css$Css$uppercase = {textTransform: rtfeldman$elm_css$Css$Structure$Compatible, value: 'uppercase'};
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$json$Json$Encode$string = _Json_wrap;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var author$project$UIComponents$Card$titleBlock = function (title) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A3(
							rtfeldman$elm_css$Css$borderBottom3,
							rtfeldman$elm_css$Css$px(1),
							rtfeldman$elm_css$Css$solid,
							rtfeldman$elm_css$Css$hex('#546D79')),
							rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase),
							rtfeldman$elm_css$Css$padding(
							rtfeldman$elm_css$Css$em(0.5)),
							rtfeldman$elm_css$Css$width(
							rtfeldman$elm_css$Css$pct(100)),
							rtfeldman$elm_css$Css$fontSize(
							rtfeldman$elm_css$Css$px(26)),
							rtfeldman$elm_css$Css$color(
							rtfeldman$elm_css$Css$hex('#546D79'))
						]))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(title)
				]));
	};
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
	var rtfeldman$elm_css$Css$row = {flexDirection: rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'row'};
	var rtfeldman$elm_css$Css$column = _Utils_update(
		rtfeldman$elm_css$Css$row,
		{value: 'column'});
	var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
	var rtfeldman$elm_css$Css$flexDirection = rtfeldman$elm_css$Css$prop1('flex-direction');
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$Internal$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
		return {$: 'ApplyStyles', a: a};
	};
	var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
		function (functionName, desiredKey, style) {
			getOverloadedProperty:
			while (true) {
				switch (style.$) {
					case 'AppendProperty':
						var str = style.a;
						var key = A2(
							elm$core$Maybe$withDefault,
							'',
							elm$core$List$head(
								A2(elm$core$String$split, ':', str)));
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
					case 'ExtendSelector':
						var selector = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
					case 'NestSnippet':
						var combinator = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
					case 'WithPseudoElement':
						var pseudoElement = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
					case 'WithMedia':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
					case 'WithKeyframes':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
					default:
						if (!style.a.b) {
							return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
						} else {
							if (!style.a.b.b) {
								var _n1 = style.a;
								var only = _n1.a;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = only;
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							} else {
								var _n2 = style.a;
								var first = _n2.a;
								var rest = _n2.b;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							}
						}
				}
			}
		});
	var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
	var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
	var rtfeldman$elm_css$Css$textAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'textAlign',
			'text-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var author$project$UIComponents$Card$card = F2(
		function (title, childs) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A3(
								rtfeldman$elm_css$Css$border3,
								rtfeldman$elm_css$Css$px(1),
								rtfeldman$elm_css$Css$solid,
								rtfeldman$elm_css$Css$hex('#DADADA')),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(30)),
								rtfeldman$elm_css$Css$padding(
								rtfeldman$elm_css$Css$px(10)),
								rtfeldman$elm_css$Css$displayFlex,
								rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$column),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('#fff')),
								rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						author$project$UIComponents$Card$titleBlock(title),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$padding(
										rtfeldman$elm_css$Css$em(1)),
										rtfeldman$elm_css$Css$fontSize(
										rtfeldman$elm_css$Css$px(16)),
										rtfeldman$elm_css$Css$color(
										rtfeldman$elm_css$Css$hex('#546D79'))
									]))
							]),
						childs)
					]));
		});
	var rtfeldman$elm_css$Html$Styled$a = rtfeldman$elm_css$Html$Styled$node('a');
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
		return A2(rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
	};
	var author$project$ShowDocumentsCard$view = function (model) {
		var docLabel = function (i) {
			return elm$core$String$fromInt(i) + (' document' + ((i > 1) ? 's' : ''));
		};
		var count = elm$core$List$length(model.documents);
		var bloc = A2(
			author$project$UIComponents$Card$card,
			'documents',
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(
							docLabel(count))
						]))
				]));
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$href('/tickets/' + (model.flags.entityUid + '/documents'))
					]),
				_List_fromArray(
					[bloc])));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$core$String$toInt = _String_toInt;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var author$project$ShowDocumentsCard$main = elm$browser$Browser$element(
		{init: author$project$ShowDocumentsCard$init, subscriptions: author$project$ShowDocumentsCard$subscriptions, update: author$project$ShowDocumentsCard$update, view: author$project$ShowDocumentsCard$view});
	_Platform_export({'ShowDocumentsCard':{'init':author$project$ShowDocumentsCard$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (simplifiedRequestUid) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (queryApiBaseUrl) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (entityUid) {
								return elm$json$Json$Decode$succeed(
									{entityUid: entityUid, queryApiBaseUrl: queryApiBaseUrl, simplifiedRequestUid: simplifiedRequestUid});
							},
							A2(elm$json$Json$Decode$field, 'entityUid', elm$json$Json$Decode$string));
					},
					A2(elm$json$Json$Decode$field, 'queryApiBaseUrl', elm$json$Json$Decode$string));
			},
			A2(
				elm$json$Json$Decode$field,
				'simplifiedRequestUid',
				elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
							A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, elm$json$Json$Decode$string)
						])))))(0)}});}(this));

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	// DECODER
	
	var _File_decoder = _Json_decodePrim(function(value) {
		// NOTE: checks if `File` exists in case this is run on node
		return (typeof File !== 'undefined' && value instanceof File)
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FILE', value);
	});
	
	
	// METADATA
	
	function _File_name(file) { return file.name; }
	function _File_mime(file) { return file.type; }
	function _File_size(file) { return file.size; }
	
	function _File_lastModified(file)
	{
		return elm$time$Time$millisToPosix(file.lastModified);
	}
	
	
	// DOWNLOAD
	
	var _File_downloadNode;
	
	function _File_getDownloadNode()
	{
		return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
	}
	
	var _File_download = F3(function(name, mime, content)
	{
		return _Scheduler_binding(function(callback)
		{
			var blob = new Blob([content], {type: mime});
	
			// for IE10+
			if (navigator.msSaveOrOpenBlob)
			{
				navigator.msSaveOrOpenBlob(blob, name);
				return;
			}
	
			// for HTML5
			var node = _File_getDownloadNode();
			var objectUrl = URL.createObjectURL(blob);
			node.href = objectUrl;
			node.download = name;
			_File_click(node);
			URL.revokeObjectURL(objectUrl);
		});
	});
	
	function _File_downloadUrl(href)
	{
		return _Scheduler_binding(function(callback)
		{
			var node = _File_getDownloadNode();
			node.href = href;
			node.download = '';
			node.origin === location.origin || (node.target = '_blank');
			_File_click(node);
		});
	}
	
	
	// IE COMPATIBILITY
	
	function _File_makeBytesSafeForInternetExplorer(bytes)
	{
		// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
		// all other browsers can just run `new Blob([bytes])` directly with no problem
		//
		return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	}
	
	function _File_click(node)
	{
		// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
		// all other browsers have MouseEvent and do not need this conditional stuff
		//
		if (typeof MouseEvent === 'function')
		{
			node.dispatchEvent(new MouseEvent('click'));
		}
		else
		{
			var event = document.createEvent('MouseEvents');
			event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			document.body.appendChild(node);
			node.dispatchEvent(event);
			document.body.removeChild(node);
		}
	}
	
	
	// UPLOAD
	
	var _File_node;
	
	function _File_uploadOne(mimes)
	{
		return _Scheduler_binding(function(callback)
		{
			_File_node = document.createElement('input');
			_File_node.type = 'file';
			_File_node.accept = A2(elm$core$String$join, ',', mimes);
			_File_node.addEventListener('change', function(event)
			{
				callback(_Scheduler_succeed(event.target.files[0]));
			});
			_File_click(_File_node);
		});
	}
	
	function _File_uploadOneOrMore(mimes)
	{
		return _Scheduler_binding(function(callback)
		{
			_File_node = document.createElement('input');
			_File_node.type = 'file';
			_File_node.multiple = true;
			_File_node.accept = A2(elm$core$String$join, ',', mimes);
			_File_node.addEventListener('change', function(event)
			{
				var elmFiles = _List_fromArray(event.target.files);
				callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
			});
			_File_click(_File_node);
		});
	}
	
	
	// CONTENT
	
	function _File_toString(blob)
	{
		return _Scheduler_binding(function(callback)
		{
			var reader = new FileReader();
			reader.addEventListener('loadend', function() {
				callback(_Scheduler_succeed(reader.result));
			});
			reader.readAsText(blob);
			return function() { reader.abort(); };
		});
	}
	
	function _File_toBytes(blob)
	{
		return _Scheduler_binding(function(callback)
		{
			var reader = new FileReader();
			reader.addEventListener('loadend', function() {
				callback(_Scheduler_succeed(new DataView(reader.result)));
			});
			reader.readAsArrayBuffer(blob);
			return function() { reader.abort(); };
		});
	}
	
	function _File_toUrl(blob)
	{
		return _Scheduler_binding(function(callback)
		{
			var reader = new FileReader();
			reader.addEventListener('loadend', function() {
				callback(_Scheduler_succeed(reader.result));
			});
			reader.readAsDataURL(blob);
			return function() { reader.abort(); };
		});
	}
	
	
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	// CREATE
	
	var _Regex_never = /.^/;
	
	var _Regex_fromStringWith = F2(function(options, string)
	{
		var flags = 'g';
		if (options.multiline) { flags += 'm'; }
		if (options.caseInsensitive) { flags += 'i'; }
	
		try
		{
			return elm$core$Maybe$Just(new RegExp(string, flags));
		}
		catch(error)
		{
			return elm$core$Maybe$Nothing;
		}
	});
	
	
	// USE
	
	var _Regex_contains = F2(function(re, string)
	{
		return string.match(re) !== null;
	});
	
	
	var _Regex_findAtMost = F3(function(n, re, str)
	{
		var out = [];
		var number = 0;
		var string = str;
		var lastIndex = re.lastIndex;
		var prevLastIndex = -1;
		var result;
		while (number++ < n && (result = re.exec(string)))
		{
			if (prevLastIndex == re.lastIndex) break;
			var i = result.length - 1;
			var subs = new Array(i);
			while (i > 0)
			{
				var submatch = result[i];
				subs[--i] = submatch
					? elm$core$Maybe$Just(submatch)
					: elm$core$Maybe$Nothing;
			}
			out.push(A4(elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
			prevLastIndex = re.lastIndex;
		}
		re.lastIndex = lastIndex;
		return _List_fromArray(out);
	});
	
	
	var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
	{
		var count = 0;
		function jsReplacer(match)
		{
			if (count++ >= n)
			{
				return match;
			}
			var i = arguments.length - 3;
			var submatches = new Array(i);
			while (i > 0)
			{
				var submatch = arguments[i];
				submatches[--i] = submatch
					? elm$core$Maybe$Just(submatch)
					: elm$core$Maybe$Nothing;
			}
			return replacer(A4(elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
		}
		return string.replace(re, jsReplacer);
	});
	
	var _Regex_splitAtMost = F3(function(n, re, str)
	{
		var string = str;
		var out = [];
		var start = re.lastIndex;
		var restoreLastIndex = re.lastIndex;
		while (n--)
		{
			var result = re.exec(string);
			if (!result) break;
			out.push(string.slice(start, result.index));
			start = re.lastIndex;
		}
		out.push(string.slice(start));
		re.lastIndex = restoreLastIndex;
		return _List_fromArray(out);
	});
	
	var _Regex_infinity = Infinity;
	
	
	
	
	// STRINGS
	
	
	var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
	{
		var smallLength = smallString.length;
		var isGood = offset + smallLength <= bigString.length;
	
		for (var i = 0; isGood && i < smallLength; )
		{
			var code = bigString.charCodeAt(offset);
			isGood =
				smallString[i++] === bigString[offset++]
				&& (
					code === 0x000A /* \n */
						? ( row++, col=1 )
						: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
				)
		}
	
		return _Utils_Tuple3(isGood ? offset : -1, row, col);
	});
	
	
	
	// CHARS
	
	
	var _Parser_isSubChar = F3(function(predicate, offset, string)
	{
		return (
			string.length <= offset
				? -1
				:
			(string.charCodeAt(offset) & 0xF800) === 0xD800
				? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
				:
			(predicate(_Utils_chr(string[offset]))
				? ((string[offset] === '\n') ? -2 : (offset + 1))
				: -1
			)
		);
	});
	
	
	var _Parser_isAsciiCode = F3(function(code, offset, string)
	{
		return string.charCodeAt(offset) === code;
	});
	
	
	
	// NUMBERS
	
	
	var _Parser_chompBase10 = F2(function(offset, string)
	{
		for (; offset < string.length; offset++)
		{
			var code = string.charCodeAt(offset);
			if (code < 0x30 || 0x39 < code)
			{
				return offset;
			}
		}
		return offset;
	});
	
	
	var _Parser_consumeBase = F3(function(base, offset, string)
	{
		for (var total = 0; offset < string.length; offset++)
		{
			var digit = string.charCodeAt(offset) - 0x30;
			if (digit < 0 || base <= digit) break;
			total = base * total + digit;
		}
		return _Utils_Tuple2(offset, total);
	});
	
	
	var _Parser_consumeBase16 = F2(function(offset, string)
	{
		for (var total = 0; offset < string.length; offset++)
		{
			var code = string.charCodeAt(offset);
			if (0x30 <= code && code <= 0x39)
			{
				total = 16 * total + code - 0x30;
			}
			else if (0x41 <= code && code <= 0x46)
			{
				total = 16 * total + code - 55;
			}
			else if (0x61 <= code && code <= 0x66)
			{
				total = 16 * total + code - 87;
			}
			else
			{
				break;
			}
		}
		return _Utils_Tuple2(offset, total);
	});
	
	
	
	// FIND STRING
	
	
	var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
	{
		var newOffset = bigString.indexOf(smallString, offset);
		var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;
	
		while (offset < target)
		{
			var code = bigString.charCodeAt(offset++);
			code === 0x000A /* \n */
				? ( col=1, row++ )
				: ( col++, (code & 0xF800) === 0xD800 && offset++ )
		}
	
		return _Utils_Tuple3(newOffset, row, col);
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var author$project$Binding$ResultDecoder$emptyResultRecord = A2(author$project$Binding$ResultDecoder$ResultRecord, _List_Nil, _List_Nil);
	var author$project$ShowDocumentsPage$FetchDocuments = {$: 'FetchDocuments'};
	var author$project$ShowDocumentsPage$Model = F7(
		function (flags, documentsFromSR, documents, addDoc, documentCategories, uploadInProgress, zone) {
			return {addDoc: addDoc, documentCategories: documentCategories, documents: documents, documentsFromSR: documentsFromSR, flags: flags, uploadInProgress: uploadInProgress, zone: zone};
		});
	var author$project$ShowDocumentsPage$categories = _List_fromArray(
		['Photo', 'Devis', 'Ordre de service', 'Reporting', 'Maintenance', 'Planning', 'Installation technique', 'Commercial', 'Administratif', 'Sanitaire', 'Autre']);
	var author$project$ShowDocumentsPage$chooseCategory = 'Choisir une catégorie';
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var elm$time$Time$Jan = {$: 'Jan'};
	var elm$time$Time$Zone = F2(
		function (a, b) {
			return {$: 'Zone', a: a, b: b};
		});
	var elm$time$Time$customZone = elm$time$Time$Zone;
	var justinmimbs$timezone_data$TimeZone$maxYear = 2037;
	var justinmimbs$timezone_data$TimeZone$minYear = 1970;
	var elm$core$Tuple$second = function (_n0) {
		var y = _n0.b;
		return y;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
		function (year, month, day, time, clock) {
			return {clock: clock, day: day, month: month, time: time, year: year};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$Universal = {$: 'Universal'};
	var justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_n0) {
		dropChangesBeforeEpoch:
		while (true) {
			var initial = _n0.a;
			var changes = _n0.b;
			if (changes.b) {
				var change = changes.a;
				var rest = changes.b;
				if (change.start <= 0) {
					var $temp$_n0 = _Utils_Tuple2(change.offset, rest);
					_n0 = $temp$_n0;
					continue dropChangesBeforeEpoch;
				} else {
					return _Utils_Tuple2(initial, changes);
				}
			} else {
				return _Utils_Tuple2(initial, _List_Nil);
			}
		}
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var elm$core$List$sortBy = _List_sortBy;
	var elm$core$Basics$modBy = _Basics_modBy;
	var justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
		var _n0 = A2(elm$core$Basics$modBy, 7, rd);
		if (!_n0) {
			return 7;
		} else {
			var n = _n0;
			return n;
		}
	};
	var justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
		switch (wd.$) {
			case 'Mon':
				return 1;
			case 'Tue':
				return 2;
			case 'Wed':
				return 3;
			case 'Thu':
				return 4;
			case 'Fri':
				return 5;
			case 'Sat':
				return 6;
			default:
				return 7;
		}
	};
	var justinmimbs$timezone_data$RataDie$floorWeekday = F2(
		function (weekday, rd) {
			var daysSincePreviousWeekday = A2(
				elm$core$Basics$modBy,
				7,
				(justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
			return rd - daysSincePreviousWeekday;
		});
	var justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
		function (weekday, rd) {
			var floored = A2(justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
			return _Utils_eq(rd, floored) ? rd : (floored + 7);
		});
	var elm$core$Basics$neq = _Utils_notEqual;
	var justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
		return ((!A2(elm$core$Basics$modBy, 4, y)) && A2(elm$core$Basics$modBy, 100, y)) || (!A2(elm$core$Basics$modBy, 400, y));
	};
	var justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
		function (y, m) {
			var leapDays = justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
			switch (m.$) {
				case 'Jan':
					return 0;
				case 'Feb':
					return 31;
				case 'Mar':
					return 59 + leapDays;
				case 'Apr':
					return 90 + leapDays;
				case 'May':
					return 120 + leapDays;
				case 'Jun':
					return 151 + leapDays;
				case 'Jul':
					return 181 + leapDays;
				case 'Aug':
					return 212 + leapDays;
				case 'Sep':
					return 243 + leapDays;
				case 'Oct':
					return 273 + leapDays;
				case 'Nov':
					return 304 + leapDays;
				default:
					return 334 + leapDays;
			}
		});
	var justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
		var y = y1 - 1;
		var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
		return (365 * y) + leapYears;
	};
	var justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
		function (y, m, d) {
			return (justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2(justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
		});
	var justinmimbs$timezone_data$RataDie$daysInMonth = F2(
		function (y, m) {
			switch (m.$) {
				case 'Jan':
					return 31;
				case 'Feb':
					return justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
				case 'Mar':
					return 31;
				case 'Apr':
					return 30;
				case 'May':
					return 31;
				case 'Jun':
					return 30;
				case 'Jul':
					return 31;
				case 'Aug':
					return 31;
				case 'Sep':
					return 30;
				case 'Oct':
					return 31;
				case 'Nov':
					return 30;
				default:
					return 31;
			}
		});
	var justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
		function (y, m) {
			return (justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2(justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2(justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
		return (rd - 719163) * 1440;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
		function (clock, _n0) {
			var standard = _n0.standard;
			var save = _n0.save;
			switch (clock.$) {
				case 'Universal':
					return 0;
				case 'Standard':
					return 0 - standard;
				default:
					return 0 - (standard + save);
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_n0) {
		var year = _n0.year;
		var month = _n0.month;
		var day = _n0.day;
		var time = _n0.time;
		return justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
			A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
		function (offset, datetime) {
			return justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.clock, offset);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
		function (previousOffset, start, until, standardOffset, rules) {
			var transitions = A2(
				elm$core$List$concatMap,
				function (year) {
					return A2(
						elm$core$List$sortBy,
						function ($) {
							return $.start;
						},
						A2(
							elm$core$List$map,
							function (rule) {
								return {
									clock: rule.clock,
									save: rule.save,
									start: justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
										function () {
											var _n2 = rule.day;
											switch (_n2.$) {
												case 'Day':
													var day = _n2.a;
													return A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, day);
												case 'First':
													var weekday = _n2.a;
													var onOrAfterDay = _n2.b;
													return A2(
														justinmimbs$timezone_data$RataDie$ceilingWeekday,
														weekday,
														A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, onOrAfterDay));
												default:
													var weekday = _n2.a;
													return A2(
														justinmimbs$timezone_data$RataDie$floorWeekday,
														weekday,
														A2(justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.month));
											}
										}()) + rule.time
								};
							},
							A2(
								elm$core$List$filter,
								function (rule) {
									return (_Utils_cmp(rule.from, year) < 1) && (_Utils_cmp(year, rule.to) < 1);
								},
								rules)));
				},
				A2(elm$core$List$range, start.year - 1, until.year));
			var initialOffset = {save: 0, standard: standardOffset};
			var initialChange = {
				offset: standardOffset,
				start: A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
			};
			var _n0 = A3(
				elm$core$List$foldl,
				F2(
					function (transition, _n1) {
						var currentOffset = _n1.a;
						var changes = _n1.b;
						var newOffset = {save: transition.save, standard: standardOffset};
						if (_Utils_cmp(
							transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, previousOffset),
							initialChange.start) < 1) {
							var updatedInitialChange = {offset: standardOffset + transition.save, start: initialChange.start};
							return _Utils_Tuple2(
								newOffset,
								_List_fromArray(
									[updatedInitialChange]));
						} else {
							if (_Utils_cmp(
								transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset),
								A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
								var change = {
									offset: standardOffset + transition.save,
									start: transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset)
								};
								return _Utils_Tuple2(
									newOffset,
									A2(elm$core$List$cons, change, changes));
							} else {
								return _Utils_Tuple2(currentOffset, changes);
							}
						}
					}),
				_Utils_Tuple2(
					initialOffset,
					_List_fromArray(
						[initialChange])),
				transitions);
			var nextOffset = _n0.a;
			var descendingChanges = _n0.b;
			return _Utils_Tuple2(
				elm$core$List$reverse(descendingChanges),
				nextOffset);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
		function (previousOffset, start, until, _n0) {
			var standardOffset = _n0.standardOffset;
			var zoneRules = _n0.zoneRules;
			if (zoneRules.$ === 'Save') {
				var save = zoneRules.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							{
							offset: standardOffset + save,
							start: A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
						}
						]),
					{save: save, standard: standardOffset});
			} else {
				var rules = zoneRules.a;
				return A5(justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
		function (f, a, rev, list) {
			stripDuplicatesByHelp:
			while (true) {
				if (!list.b) {
					return elm$core$List$reverse(rev);
				} else {
					var x = list.a;
					var xs = list.b;
					var b = f(x);
					var rev_ = (!_Utils_eq(a, b)) ? A2(elm$core$List$cons, x, rev) : rev;
					var $temp$f = f,
						$temp$a = b,
						$temp$rev = rev_,
						$temp$list = xs;
					f = $temp$f;
					a = $temp$a;
					rev = $temp$rev;
					list = $temp$list;
					continue stripDuplicatesByHelp;
				}
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
		function (zoneStart, zoneUntil, zone) {
			var _n0 = A3(
				elm$core$List$foldl,
				F2(
					function (_n1, _n2) {
						var state = _n1.a;
						var nextStart = _n1.b;
						var start = _n2.a;
						var ranges = _n2.b;
						return _Utils_Tuple2(
							nextStart,
							A2(
								elm$core$List$cons,
								_Utils_Tuple3(start, state, nextStart),
								ranges));
					}),
				_Utils_Tuple2(zoneStart, _List_Nil),
				zone.history);
			var currentStart = _n0.a;
			var historyRanges = _n0.b;
			return elm$core$List$reverse(
				A2(
					elm$core$List$cons,
					_Utils_Tuple3(currentStart, zone.current, zoneUntil),
					historyRanges));
		});
	var justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
		function (minYear, maxYear, zone) {
			var initialState = function () {
				var _n5 = zone.history;
				if (_n5.b) {
					var _n6 = _n5.a;
					var earliest = _n6.a;
					return earliest;
				} else {
					return zone.current;
				}
			}();
			var initialOffset = {
				save: function () {
					var _n4 = initialState.zoneRules;
					if (_n4.$ === 'Save') {
						var save = _n4.a;
						return save;
					} else {
						return 0;
					}
				}(),
				standard: initialState.standardOffset
			};
			var ascendingChanges = A4(
				justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
				function ($) {
					return $.offset;
				},
				initialOffset.standard + initialOffset.save,
				_List_Nil,
				A3(
					elm$core$List$foldl,
					F2(
						function (_n1, _n2) {
							var start = _n1.a;
							var state = _n1.b;
							var until = _n1.c;
							var prevOffset = _n2.a;
							var prevChanges = _n2.b;
							var _n3 = A4(justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
							var nextChanges = _n3.a;
							var nextOffset = _n3.b;
							return _Utils_Tuple2(
								nextOffset,
								_Utils_ap(prevChanges, nextChanges));
						}),
					_Utils_Tuple2(initialOffset, _List_Nil),
					A3(
						justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$Universal),
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$Universal),
						zone)).b);
			var _n0 = justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
				_Utils_Tuple2(initialOffset.standard + initialOffset.save, ascendingChanges));
			var initial = _n0.a;
			var ascending = _n0.b;
			return _Utils_Tuple2(
				elm$core$List$reverse(ascending),
				initial);
		});
	var justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
		var _n0 = A3(justinmimbs$timezone_data$TimeZone$Specification$toOffsets, justinmimbs$timezone_data$TimeZone$minYear, justinmimbs$timezone_data$TimeZone$maxYear, zone);
		var descending = _n0.a;
		var bottom = _n0.b;
		return A2(elm$time$Time$customZone, bottom, descending);
	};
	var elm$time$Time$Apr = {$: 'Apr'};
	var elm$time$Time$Mar = {$: 'Mar'};
	var elm$time$Time$Oct = {$: 'Oct'};
	var elm$time$Time$Sep = {$: 'Sep'};
	var elm$time$Time$Sun = {$: 'Sun'};
	var justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
		return {$: 'Day', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$First = F2(
		function (a, b) {
			return {$: 'First', a: a, b: b};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
		return {$: 'Last', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
		function (from, to, month, day, time, clock, save) {
			return {clock: clock, day: day, from: from, month: month, save: save, time: time, to: to};
		});
	var justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
		[
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1977,
			1980,
			elm$time$Time$Apr,
			A2(justinmimbs$timezone_data$TimeZone$Specification$First, elm$time$Time$Sun, 1),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1977,
			1977,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1978,
			1978,
			elm$time$Time$Oct,
			justinmimbs$timezone_data$TimeZone$Specification$Day(1),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1979,
			1995,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1981,
			justinmimbs$timezone_data$TimeZone$maxYear,
			elm$time$Time$Mar,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1996,
			justinmimbs$timezone_data$TimeZone$maxYear,
			elm$time$Time$Oct,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0)
		]);
	var justinmimbs$timezone_data$TimeZone$Specification$WallClock = {$: 'WallClock'};
	var justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
		[
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1976,
			1976,
			elm$time$Time$Mar,
			justinmimbs$timezone_data$TimeZone$Specification$Day(28),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$WallClock,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1976,
			1976,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Day(26),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$WallClock,
			0)
		]);
	var justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
		return {$: 'Rules', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
		function (history, current) {
			return {current: current, history: history};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
		function (standardOffset, zoneRules) {
			return {standardOffset: standardOffset, zoneRules: zoneRules};
		});
	var justinmimbs$timezone_data$TimeZone$europe__paris = function (_n0) {
		return justinmimbs$timezone_data$TimeZone$fromSpecification(
			A2(
				justinmimbs$timezone_data$TimeZone$Specification$Zone,
				_List_fromArray(
					[
						_Utils_Tuple2(
						A2(
							justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
							60,
							justinmimbs$timezone_data$TimeZone$Specification$Rules(justinmimbs$timezone_data$TimeZone$rules_France)),
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$WallClock))
					]),
				A2(
					justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
					60,
					justinmimbs$timezone_data$TimeZone$Specification$Rules(justinmimbs$timezone_data$TimeZone$rules_EU))));
	};
	var author$project$ShowDocumentsPage$init = function (f) {
		return _Utils_Tuple2(
			A7(
				author$project$ShowDocumentsPage$Model,
				f,
				author$project$Binding$ResultDecoder$emptyResultRecord,
				author$project$Binding$ResultDecoder$emptyResultRecord,
				elm$core$Maybe$Nothing,
				A2(elm$core$List$cons, author$project$ShowDocumentsPage$chooseCategory, author$project$ShowDocumentsPage$categories),
				false,
				justinmimbs$timezone_data$TimeZone$europe__paris(_Utils_Tuple0)),
			author$project$Utils$Command$msgToElmCmd(author$project$ShowDocumentsPage$FetchDocuments));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$ShowDocumentsPage$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var author$project$ShowDocumentsPage$DocumentDeleted = F2(
		function (a, b) {
			return {$: 'DocumentDeleted', a: a, b: b};
		});
	var author$project$ShowDocumentsPage$DocumentFetched = function (a) {
		return {$: 'DocumentFetched', a: a};
	};
	var author$project$ShowDocumentsPage$DocumentToDisplay = F7(
		function (url, public_id, documentType, fileName, category, uploadDate, links) {
			return {category: category, documentType: documentType, fileName: fileName, links: links, public_id: public_id, uploadDate: uploadDate, url: url};
		});
	var author$project$ShowDocumentsPage$DocumentToUpload = F3(
		function (label, category, file) {
			return {category: category, file: file, label: label};
		});
	var author$project$ShowDocumentsPage$DocumentUploaded = F2(
		function (a, b) {
			return {$: 'DocumentUploaded', a: a, b: b};
		});
	var author$project$ShowDocumentsPage$FileChoosen = function (a) {
		return {$: 'FileChoosen', a: a};
	};
	var author$project$ShowDocumentsPage$SRDocumentFetched = function (a) {
		return {$: 'SRDocumentFetched', a: a};
	};
	var author$project$ShowDocumentsPage$acceptedTypeFiles = _List_fromArray(
		['text/csv', 'application/pdf', 'text/plain', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/epub+zip', 'image/*', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.text', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']);
	var author$project$ShowDocumentsPage$DocumentUpload = function (publicId) {
		return {publicId: publicId};
	};
	var author$project$ShowDocumentsPage$decodeDocumentUpload = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'publicId',
		elm$json$Json$Decode$string,
		elm$json$Json$Decode$succeed(author$project$ShowDocumentsPage$DocumentUpload));
	var elm$json$Json$Decode$decodeValue = _Json_run;
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var elm$json$Json$Decode$value = _Json_decodeValue;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
		function (pathDecoder, valDecoder, fallback) {
			var nullOr = function (decoder) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							decoder,
							elm$json$Json$Decode$null(fallback)
						]));
			};
			var handleResult = function (input) {
				var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
				if (_n0.$ === 'Ok') {
					var rawValue = _n0.a;
					var _n1 = A2(
						elm$json$Json$Decode$decodeValue,
						nullOr(valDecoder),
						rawValue);
					if (_n1.$ === 'Ok') {
						var finalResult = _n1.a;
						return elm$json$Json$Decode$succeed(finalResult);
					} else {
						var finalErr = _n1.a;
						return elm$json$Json$Decode$fail(
							elm$json$Json$Decode$errorToString(finalErr));
					}
				} else {
					return elm$json$Json$Decode$succeed(fallback);
				}
			};
			return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
		});
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
		function (key, valDecoder, fallback, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
					A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
					valDecoder,
					fallback),
				decoder);
		});
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$nullable = function (decoder) {
		return elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
				]));
	};
	var author$project$ShowDocumentsPage$documentDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_links',
		elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uploadDate',
			elm$json$Json$Decode$string,
			A4(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'category',
				elm$json$Json$Decode$string,
				'autre',
				A4(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'fileName',
					elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
					elm$core$Maybe$Nothing,
					A3(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						elm$json$Json$Decode$string,
						A3(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'public_id',
							elm$json$Json$Decode$string,
							A3(
								NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'url',
								elm$json$Json$Decode$string,
								elm$json$Json$Decode$succeed(author$project$ShowDocumentsPage$DocumentToDisplay))))))));
	var author$project$ShowDocumentsPage$removeDoc = F2(
		function (id, docs) {
			var newDocs = A2(
				elm$core$List$filter,
				function (d) {
					return !_Utils_eq(d.public_id, id);
				},
				docs.result);
			return _Utils_update(
				docs,
				{result: newDocs});
		});
	var author$project$Utils$Http$HttpRequest$Delete = F2(
		function (a, b) {
			return {$: 'Delete', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Post = F3(
		function (a, b, c) {
			return {$: 'Post', a: a, b: b, c: c};
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var author$project$Utils$String$stringToNonEmptyString = function (s) {
		if (s === '') {
			return elm$core$Maybe$Nothing;
		} else {
			return elm$core$Maybe$Just(s);
		}
	};
	var ccapndave$elm_flat_map$Maybe$FlatMap$join = function (mx) {
		if (mx.$ === 'Just') {
			var x = mx.a;
			return x;
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var ccapndave$elm_flat_map$Maybe$FlatMap$flatMap = F2(
		function (f, maybe) {
			return ccapndave$elm_flat_map$Maybe$FlatMap$join(
				A2(elm$core$Maybe$map, f, maybe));
		});
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var elm$time$Time$Posix = function (a) {
		return {$: 'Posix', a: a};
	};
	var elm$time$Time$millisToPosix = elm$time$Time$Posix;
	var elm$file$File$name = _File_name;
	var elm$file$File$Select$file = F2(
		function (mimes, toMsg) {
			return A2(
				elm$core$Task$perform,
				toMsg,
				_File_uploadOne(mimes));
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm$http$Http$expectBytesResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'arraybuffer',
				_Http_toDataView,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$expectWhatever = function (toMsg) {
		return A2(
			elm$http$Http$expectBytesResponse,
			toMsg,
			elm$http$Http$resolve(
				function (_n0) {
					return elm$core$Result$Ok(_Utils_Tuple0);
				}));
	};
	var elm$http$Http$filePart = _Http_pair;
	var elm$http$Http$multipartBody = function (parts) {
		return A2(
			_Http_pair,
			'',
			_Http_toFormData(parts));
	};
	var elm$http$Http$stringPart = _Http_pair;
	var elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
		if (m.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var x = m.a;
			return _List_fromArray(
				[x]);
		}
	};
	var author$project$ShowDocumentsPage$update = F2(
		function (msg, model) {
			switch (msg.$) {
				case 'FetchDocuments':
					var fetchSrImagesUrl = function (uid) {
						return model.flags.queryApiBaseUrl + ('/documents?aggregatetype=SimplifiedRequest&aggregateuid=' + uid);
					};
					var fetchSrImages = function (uid) {
						return author$project$Utils$Http$HttpRequest$withAuthReq(
							A2(
								author$project$Utils$Http$HttpRequest$Get,
								fetchSrImagesUrl(uid),
								A2(
									elm$http$Http$expectJson,
									author$project$ShowDocumentsPage$SRDocumentFetched,
									author$project$Binding$ResultDecoder$resultDecoder(
										elm$json$Json$Decode$list(author$project$ShowDocumentsPage$documentDecoder)))));
					};
					var aggregateType = model.flags.entityType;
					var countEntityDocuments = model.flags.queryApiBaseUrl + ('/documents?aggregatetype=' + (aggregateType + ('&aggregateuid=' + model.flags.entityUid)));
					var fetchEntityDocuments = author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							countEntityDocuments,
							A2(
								elm$http$Http$expectJson,
								author$project$ShowDocumentsPage$DocumentFetched,
								author$project$Binding$ResultDecoder$resultDecoder(
									elm$json$Json$Decode$list(author$project$ShowDocumentsPage$documentDecoder)))));
					var cmds = elm$core$Platform$Cmd$batch(
						A2(
							elm$core$List$cons,
							fetchEntityDocuments,
							elm_community$maybe_extra$Maybe$Extra$toList(
								A2(elm$core$Maybe$map, fetchSrImages, model.flags.simplifiedRequestUid))));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{documents: author$project$Binding$ResultDecoder$emptyResultRecord, documentsFromSR: author$project$Binding$ResultDecoder$emptyResultRecord}),
						cmds);
				case 'SRDocumentFetched':
					if (msg.a.$ === 'Ok') {
						var documents = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{documentsFromSR: documents}),
							elm$core$Platform$Cmd$none);
					} else {
						var e = msg.a.a;
						return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
					}
				case 'DocumentFetched':
					if (msg.a.$ === 'Ok') {
						var documents = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{documents: documents}),
							elm$core$Platform$Cmd$none);
					} else {
						var e = msg.a.a;
						return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
					}
				case 'AddDocument':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								addDoc: elm$core$Maybe$Just(
									A3(author$project$ShowDocumentsPage$DocumentToUpload, elm$core$Maybe$Nothing, elm$core$Maybe$Nothing, elm$core$Maybe$Nothing))
							}),
						elm$core$Platform$Cmd$none);
				case 'SetLabel':
					var label = msg.a;
					var setLabel = A2(
						elm$core$Maybe$map,
						function (doc) {
							return _Utils_update(
								doc,
								{
									label: author$project$Utils$String$stringToNonEmptyString(label)
								});
						},
						model.addDoc);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{addDoc: setLabel}),
						elm$core$Platform$Cmd$none);
				case 'SetCategory':
					var category = msg.a;
					var setCategory = A2(
						elm$core$Maybe$map,
						function (doc) {
							return _Utils_update(
								doc,
								{
									category: elm$core$Maybe$Just(category)
								});
						},
						model.addDoc);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{addDoc: setCategory, documentCategories: author$project$ShowDocumentsPage$categories}),
						elm$core$Platform$Cmd$none);
				case 'JoinFile':
					var cmd = A2(elm$file$File$Select$file, author$project$ShowDocumentsPage$acceptedTypeFiles, author$project$ShowDocumentsPage$FileChoosen);
					return _Utils_Tuple2(model, cmd);
				case 'FileChoosen':
					var file = msg.a;
					var chooseFile = A2(
						elm$core$Maybe$map,
						function (doc) {
							return _Utils_update(
								doc,
								{
									file: elm$core$Maybe$Just(file),
									label: elm$core$Maybe$Just(
										elm$file$File$name(file))
								});
						},
						model.addDoc);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{addDoc: chooseFile}),
						elm$core$Platform$Cmd$none);
				case 'UploadDocument':
					var url = model.flags.queryApiBaseUrl + '/documents';
					var req = F2(
						function (b2, b) {
							return A3(
								author$project$Utils$Http$HttpRequest$Post,
								url,
								b,
								A2(
									elm$http$Http$expectJson,
									author$project$ShowDocumentsPage$DocumentUploaded(b2),
									author$project$ShowDocumentsPage$decodeDocumentUpload));
						});
					var labelBody = function (doc) {
						return A2(
							elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								elm$core$Maybe$map,
								function (l) {
									return _List_fromArray(
										[
											A2(elm$http$Http$stringPart, 'fileName', l)
										]);
								},
								doc.label));
					};
					var categoryBody = function (doc) {
						return A2(
							elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								elm$core$Maybe$map,
								function (c) {
									return _List_fromArray(
										[
											A2(elm$http$Http$stringPart, 'category', c)
										]);
								},
								doc.category));
					};
					var commonBody = function (doc) {
						return _Utils_ap(
							_List_fromArray(
								[
									A2(elm$http$Http$stringPart, 'aggregateUid', model.flags.entityUid),
									A2(elm$http$Http$stringPart, 'aggregateType', model.flags.entityType),
									A2(elm$http$Http$stringPart, 'documentType', 'Raw')
								]),
							_Utils_ap(
								labelBody(doc),
								categoryBody(doc)));
					};
					var body = function (doc) {
						return A2(
							elm$core$Maybe$map,
							function (f3) {
								return elm$http$Http$multipartBody(
									_Utils_ap(
										_List_fromArray(
											[
												A2(elm$http$Http$filePart, 'documentToUpload', f3)
											]),
										commonBody(doc)));
							},
							doc.file);
					};
					var buildCmd = function (b) {
						return A2(
							elm$core$Maybe$map,
							A2(
								elm$core$Basics$composeR,
								req(b),
								author$project$Utils$Http$HttpRequest$withAuthReq),
							body(b));
					};
					var cmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(ccapndave$elm_flat_map$Maybe$FlatMap$flatMap, buildCmd, model.addDoc));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{uploadInProgress: true}),
						cmd);
				case 'DocumentUploaded':
					if (msg.b.$ === 'Ok') {
						var documentToUpload = msg.a;
						var upload = msg.b.a;
						var previousDocumentsResult = model.documents;
						var documentUploaded = A7(
							author$project$ShowDocumentsPage$DocumentToDisplay,
							model.flags.queryApiBaseUrl + ('/documents/' + upload.publicId),
							upload.publicId,
							'Raw',
							documentToUpload.label,
							A2(elm$core$Maybe$withDefault, 'autre', documentToUpload.category),
							'maintenant',
							_List_fromArray(
								[
									A3(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink, 'RemoveDocument', upload.publicId, author$project$Binding$RestNavigationLinkDecoder$DELETE)
								]));
						var newDocuments = _Utils_update(
							previousDocumentsResult,
							{
								result: A2(elm$core$List$cons, documentUploaded, previousDocumentsResult.result)
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{addDoc: elm$core$Maybe$Nothing, documents: newDocuments, uploadInProgress: false}),
							elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{addDoc: elm$core$Maybe$Nothing, uploadInProgress: false}),
							elm$core$Platform$Cmd$none);
					}
				case 'CancelUploadDocument':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{addDoc: elm$core$Maybe$Nothing}),
						elm$core$Platform$Cmd$none);
				case 'DeleteDocument':
					var publicId = msg.a;
					var deleteDocumentUrl = model.flags.queryApiBaseUrl + ('/documents/' + publicId);
					var deleteDocCmd = author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Delete,
							deleteDocumentUrl,
							elm$http$Http$expectWhatever(
								author$project$ShowDocumentsPage$DocumentDeleted(publicId))));
					return _Utils_Tuple2(model, deleteDocCmd);
				default:
					if (msg.b.$ === 'Ok') {
						var publicId = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									documents: A2(author$project$ShowDocumentsPage$removeDoc, publicId, model.documents)
								}),
							elm$core$Platform$Cmd$none);
					} else {
						var publicId = msg.a;
						var e = msg.b.a;
						return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
					}
			}
		});
	var author$project$ShowDocumentsPage$AddDocument = {$: 'AddDocument'};
	var elm$core$Basics$always = F2(
		function (a, _n0) {
			return a;
		});
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$auto = {alignItemsOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, cursor: rtfeldman$elm_css$Css$Structure$Compatible, flexBasis: rtfeldman$elm_css$Css$Structure$Compatible, intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, justifyContentOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, tableLayout: rtfeldman$elm_css$Css$Structure$Compatible, textRendering: rtfeldman$elm_css$Css$Structure$Compatible, touchAction: rtfeldman$elm_css$Css$Structure$Compatible, value: 'auto'};
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$marginLeft = rtfeldman$elm_css$Css$prop1('margin-left');
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$json$Json$Encode$string = _Json_wrap;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$class = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$String$fromList = _String_fromList;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$ShowDocumentsPage$addDocButton = function (model) {
		var myButton = _List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$marginLeft(rtfeldman$elm_css$Css$auto)
							]))
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$ShowDocumentsPage$AddDocument),
								rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-lg btn-primary')
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('Ajouter un document')
							]))
					]))
			]);
		var canUpload = elm$core$List$head(
			A2(
				elm$core$List$filter,
				function (l) {
					return l.rel === 'AttachDocumentTo';
				},
				model.documents.links));
		return A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$always(myButton),
				canUpload));
	};
	var author$project$ShowDocumentsPage$CancelUploadDocument = {$: 'CancelUploadDocument'};
	var author$project$ShowDocumentsPage$JoinFile = {$: 'JoinFile'};
	var author$project$ShowDocumentsPage$SetLabel = function (a) {
		return {$: 'SetLabel', a: a};
	};
	var author$project$ShowDocumentsPage$UploadDocument = {$: 'UploadDocument'};
	var elm$core$Maybe$map2 = F3(
		function (func, ma, mb) {
			if (ma.$ === 'Nothing') {
				return elm$core$Maybe$Nothing;
			} else {
				var a = ma.a;
				if (mb.$ === 'Nothing') {
					return elm$core$Maybe$Nothing;
				} else {
					var b = mb.a;
					return elm$core$Maybe$Just(
						A2(func, a, b));
				}
			}
		});
	var author$project$ShowDocumentsPage$disableSubmit = function (model) {
		var f = function (e) {
			return A2(
				elm$core$Maybe$withDefault,
				true,
				A3(
					elm$core$Maybe$map2,
					F2(
						function (_n0, _n1) {
							return false;
						}),
					e.label,
					e.file));
		};
		var formValid = A2(
			elm$core$Maybe$withDefault,
			false,
			A2(elm$core$Maybe$map, f, model.addDoc));
		return formValid || model.uploadInProgress;
	};
	var author$project$ShowDocumentsPage$getLabel = function (model) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				ccapndave$elm_flat_map$Maybe$FlatMap$flatMap,
				function ($) {
					return $.label;
				},
				model.addDoc));
	};
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var rtfeldman$elm_css$Css$paddingBottom = rtfeldman$elm_css$Css$prop1('padding-bottom');
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var author$project$ShowDocumentsPage$labelStyle = rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$em(14)),
				rtfeldman$elm_css$Css$paddingBottom(
				rtfeldman$elm_css$Css$px(10))
			]));
	var author$project$ShowDocumentsPage$SetCategory = function (a) {
		return {$: 'SetCategory', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$label = rtfeldman$elm_css$Html$Styled$node('label');
	var rtfeldman$elm_css$Html$Styled$option = rtfeldman$elm_css$Html$Styled$node('option');
	var rtfeldman$elm_css$Html$Styled$select = rtfeldman$elm_css$Html$Styled$node('select');
	var rtfeldman$elm_css$Html$Styled$Attributes$for = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
	var rtfeldman$elm_css$Html$Styled$Attributes$id = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
	var elm$json$Json$Encode$bool = _Json_wrap;
	var rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
		function (key, bool) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$bool(bool));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$selected = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
	var rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
		return _Utils_Tuple2(x, true);
	};
	var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
		return {$: 'MayStopPropagation', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
		});
	var elm$json$Json$Decode$at = F2(
		function (fields, decoder) {
			return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
		});
	var rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'value']),
		elm$json$Json$Decode$string);
	var rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
			'input',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
				A2(elm$json$Json$Decode$map, tagger, rtfeldman$elm_css$Html$Styled$Events$targetValue)));
	};
	var author$project$ShowDocumentsPage$selectCategory = function (model) {
		var isSelected = function (cat) {
			return A2(
				elm$core$Maybe$withDefault,
				rtfeldman$elm_css$Html$Styled$Attributes$selected(false),
				A2(
					elm$core$Maybe$map,
					function (d) {
						return rtfeldman$elm_css$Html$Styled$Attributes$selected(
							_Utils_eq(
								d.category,
								elm$core$Maybe$Just(cat)));
					},
					model.addDoc));
		};
		var elemSelect = function (cat) {
			return A2(
				rtfeldman$elm_css$Html$Styled$option,
				_List_fromArray(
					[
						isSelected(cat)
					]),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text(cat)
					]));
		};
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$for('Category'),
							author$project$ShowDocumentsPage$labelStyle
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('Catégorie')
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$select,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$id('categories'),
							rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$ShowDocumentsPage$SetCategory)
						]),
					A2(elm$core$List$map, elemSelect, model.documentCategories))
				]));
	};
	var rtfeldman$elm_css$Css$Internal$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
		return {$: 'ApplyStyles', a: a};
	};
	var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
		function (functionName, desiredKey, style) {
			getOverloadedProperty:
			while (true) {
				switch (style.$) {
					case 'AppendProperty':
						var str = style.a;
						var key = A2(
							elm$core$Maybe$withDefault,
							'',
							elm$core$List$head(
								A2(elm$core$String$split, ':', str)));
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
					case 'ExtendSelector':
						var selector = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
					case 'NestSnippet':
						var combinator = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
					case 'WithPseudoElement':
						var pseudoElement = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
					case 'WithMedia':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
					case 'WithKeyframes':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
					default:
						if (!style.a.b) {
							return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
						} else {
							if (!style.a.b.b) {
								var _n1 = style.a;
								var only = _n1.a;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = only;
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							} else {
								var _n2 = style.a;
								var first = _n2.a;
								var rest = _n2.b;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							}
						}
				}
			}
		});
	var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
	var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
	var rtfeldman$elm_css$Css$alignItems = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'alignItems',
			'align-items',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
	var rtfeldman$elm_css$Css$display = rtfeldman$elm_css$Css$prop1('display');
	var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
	var rtfeldman$elm_css$Css$flex = rtfeldman$elm_css$Css$prop1('flex');
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$UnitlessInteger = {$: 'UnitlessInteger'};
	var rtfeldman$elm_css$Css$int = function (val) {
		return {
			fontWeight: rtfeldman$elm_css$Css$Structure$Compatible,
			intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
			number: rtfeldman$elm_css$Css$Structure$Compatible,
			numberOrInfinite: rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: val,
			unitLabel: '',
			units: rtfeldman$elm_css$Css$UnitlessInteger,
			value: elm$core$String$fromInt(val)
		};
	};
	var rtfeldman$elm_css$Css$marginRight = rtfeldman$elm_css$Css$prop1('margin-right');
	var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var rtfeldman$elm_css$Css$table = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'table'};
	var rtfeldman$elm_css$Html$Styled$form = rtfeldman$elm_css$Html$Styled$node('form');
	var rtfeldman$elm_css$Html$Styled$input = rtfeldman$elm_css$Html$Styled$node('input');
	var rtfeldman$elm_css$Html$Styled$span = rtfeldman$elm_css$Html$Styled$node('span');
	var rtfeldman$elm_css$Html$Styled$Attributes$disabled = rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
	var elm$virtual_dom$VirtualDom$attribute = F2(
		function (key, value) {
			return A2(
				_VirtualDom_attribute,
				_VirtualDom_noOnOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$attribute, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$size = function (n) {
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$attribute,
			'size',
			elm$core$String$fromInt(n));
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$type_ = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
	var rtfeldman$elm_css$Html$Styled$Attributes$value = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
	var rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault = function (msg) {
		return _Utils_Tuple2(msg, true);
	};
	var elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
		return {$: 'MayPreventDefault', a: a};
	};
	var rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onSubmit = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			'submit',
			A2(
				elm$json$Json$Decode$map,
				rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault,
				elm$json$Json$Decode$succeed(msg)));
	};
	var author$project$ShowDocumentsPage$addDocform = function (model) {
		return A2(
			rtfeldman$elm_css$Html$Styled$form,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Events$onSubmit(author$project$ShowDocumentsPage$UploadDocument),
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$marginLeft(rtfeldman$elm_css$Css$auto),
							rtfeldman$elm_css$Css$marginRight(rtfeldman$elm_css$Css$auto),
							rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$table),
							A3(
							rtfeldman$elm_css$Css$border3,
							rtfeldman$elm_css$Css$px(1),
							rtfeldman$elm_css$Css$solid,
							rtfeldman$elm_css$Css$hex('#DADADA')),
							rtfeldman$elm_css$Css$padding(
							rtfeldman$elm_css$Css$px(10)),
							rtfeldman$elm_css$Css$backgroundColor(
							rtfeldman$elm_css$Css$hex('#fff'))
						]))
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[author$project$ShowDocumentsPage$labelStyle]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Joindre un fichier')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$ShowDocumentsPage$JoinFile),
									rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Joindre')
								])),
							A2(
							elm$core$Maybe$withDefault,
							rtfeldman$elm_css$Html$Styled$text(''),
							A2(
								ccapndave$elm_flat_map$Maybe$FlatMap$flatMap,
								function (d) {
									return A2(
										elm$core$Maybe$map,
										function (f) {
											return rtfeldman$elm_css$Html$Styled$text(
												elm$file$File$name(f));
										},
										d.file);
								},
								model.addDoc))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$for('label'),
									author$project$ShowDocumentsPage$labelStyle
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Nom du document')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$input,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$id('label'),
									rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
									rtfeldman$elm_css$Html$Styled$Attributes$size(30),
									rtfeldman$elm_css$Html$Styled$Events$onInput(author$project$ShowDocumentsPage$SetLabel),
									rtfeldman$elm_css$Html$Styled$Attributes$value(
									author$project$ShowDocumentsPage$getLabel(model))
								]),
							_List_Nil)
						])),
					author$project$ShowDocumentsPage$selectCategory(model),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$marginTop(
									rtfeldman$elm_css$Css$px(10)),
									rtfeldman$elm_css$Css$displayFlex,
									rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-lg btn-default'),
									rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$ShowDocumentsPage$CancelUploadDocument),
									rtfeldman$elm_css$Html$Styled$Attributes$disabled(model.uploadInProgress)
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Annuler')
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$flex(
											rtfeldman$elm_css$Css$int(1))
										]))
								]),
							_List_Nil),
							A2(
							rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-lg btn-primary'),
									rtfeldman$elm_css$Html$Styled$Attributes$disabled(
									author$project$ShowDocumentsPage$disableSubmit(model))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Ajouter')
								]))
						]))
				]));
	};
	var author$project$ShowDocumentsPage$from_sr_category = 'Demande simplifiée';
	var author$project$Components$CategoryIcons$XS = {$: 'XS'};
	var author$project$Components$CategoryIcons$showSize = function (size) {
		if (size.$ === 'MD') {
			return 'md';
		} else {
			return 'xs';
		}
	};
	var author$project$Components$CategoryIcons$getIconClasses = F3(
		function (size, icons, iconId) {
			var t = function (i) {
				return _Utils_Tuple2(
					A2(
						elm$core$Maybe$withDefault,
						'',
						A2(elm$core$Dict$get, i, icons)),
					true);
			};
			return _List_fromArray(
				[
					t('default'),
					t(iconId),
					t(
					author$project$Components$CategoryIcons$showSize(size))
				]);
		});
	var elm$core$Dict$fromList = function (assocs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, dict) {
					var key = _n0.a;
					var value = _n0.b;
					return A3(elm$core$Dict$insert, key, value, dict);
				}),
			elm$core$Dict$empty,
			assocs);
	};
	var author$project$ShowDocumentsPage$getXSIcon = function (model) {
		return A2(
			author$project$Components$CategoryIcons$getIconClasses,
			author$project$Components$CategoryIcons$XS,
			elm$core$Dict$fromList(model.flags.icons));
	};
	var author$project$ShowDocumentsPage$groupByCat = F2(
		function (_n0, acc) {
			var i = _n0.a;
			var d = _n0.b;
			var value = _Utils_ap(
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A2(elm$core$Dict$get, d.category, acc)),
				_List_fromArray(
					[
						_Utils_Tuple2(i, d)
					]));
			return A3(elm$core$Dict$insert, d.category, value, acc);
		});
	var author$project$ShowDocumentsPage$DeleteDocument = function (a) {
		return {$: 'DeleteDocument', a: a};
	};
	var elm$time$Time$Aug = {$: 'Aug'};
	var elm$time$Time$Dec = {$: 'Dec'};
	var elm$time$Time$Feb = {$: 'Feb'};
	var elm$time$Time$Jul = {$: 'Jul'};
	var elm$time$Time$Jun = {$: 'Jun'};
	var elm$time$Time$May = {$: 'May'};
	var elm$time$Time$Nov = {$: 'Nov'};
	var elm$time$Time$flooredDiv = F2(
		function (numerator, denominator) {
			return elm$core$Basics$floor(numerator / denominator);
		});
	var elm$time$Time$posixToMillis = function (_n0) {
		var millis = _n0.a;
		return millis;
	};
	var elm$time$Time$toAdjustedMinutesHelp = F3(
		function (defaultOffset, posixMinutes, eras) {
			toAdjustedMinutesHelp:
			while (true) {
				if (!eras.b) {
					return posixMinutes + defaultOffset;
				} else {
					var era = eras.a;
					var olderEras = eras.b;
					if (_Utils_cmp(era.start, posixMinutes) < 0) {
						return posixMinutes + era.offset;
					} else {
						var $temp$defaultOffset = defaultOffset,
							$temp$posixMinutes = posixMinutes,
							$temp$eras = olderEras;
						defaultOffset = $temp$defaultOffset;
						posixMinutes = $temp$posixMinutes;
						eras = $temp$eras;
						continue toAdjustedMinutesHelp;
					}
				}
			}
		});
	var elm$time$Time$toAdjustedMinutes = F2(
		function (_n0, time) {
			var defaultOffset = _n0.a;
			var eras = _n0.b;
			return A3(
				elm$time$Time$toAdjustedMinutesHelp,
				defaultOffset,
				A2(
					elm$time$Time$flooredDiv,
					elm$time$Time$posixToMillis(time),
					60000),
				eras);
		});
	var elm$core$Basics$ge = _Utils_ge;
	var elm$time$Time$toCivil = function (minutes) {
		var rawDay = A2(elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
		var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
		var dayOfEra = rawDay - (era * 146097);
		var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
		var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
		var mp = (((5 * dayOfYear) + 2) / 153) | 0;
		var month = mp + ((mp < 10) ? 3 : (-9));
		var year = yearOfEra + (era * 400);
		return {
			day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
			month: month,
			year: year + ((month <= 2) ? 1 : 0)
		};
	};
	var elm$time$Time$toMonth = F2(
		function (zone, time) {
			var _n0 = elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).month;
			switch (_n0) {
				case 1:
					return elm$time$Time$Jan;
				case 2:
					return elm$time$Time$Feb;
				case 3:
					return elm$time$Time$Mar;
				case 4:
					return elm$time$Time$Apr;
				case 5:
					return elm$time$Time$May;
				case 6:
					return elm$time$Time$Jun;
				case 7:
					return elm$time$Time$Jul;
				case 8:
					return elm$time$Time$Aug;
				case 9:
					return elm$time$Time$Sep;
				case 10:
					return elm$time$Time$Oct;
				case 11:
					return elm$time$Time$Nov;
				default:
					return elm$time$Time$Dec;
			}
		});
	var author$project$Utils$Strftime$abbreviatedMonth = F2(
		function (zone, time) {
			var _n0 = A2(elm$time$Time$toMonth, zone, time);
			switch (_n0.$) {
				case 'Jan':
					return 'Jan';
				case 'Feb':
					return 'Fev';
				case 'Mar':
					return 'Mar';
				case 'Apr':
					return 'Avr';
				case 'May':
					return 'Mai';
				case 'Jun':
					return 'Jun';
				case 'Jul':
					return 'Jul';
				case 'Aug':
					return 'Aou';
				case 'Sep':
					return 'Sep';
				case 'Oct':
					return 'Oct';
				case 'Nov':
					return 'Nov';
				default:
					return 'Dec';
			}
		});
	var elm$time$Time$Fri = {$: 'Fri'};
	var elm$time$Time$Mon = {$: 'Mon'};
	var elm$time$Time$Sat = {$: 'Sat'};
	var elm$time$Time$Thu = {$: 'Thu'};
	var elm$time$Time$Tue = {$: 'Tue'};
	var elm$time$Time$Wed = {$: 'Wed'};
	var elm$time$Time$toWeekday = F2(
		function (zone, time) {
			var _n0 = A2(
				elm$core$Basics$modBy,
				7,
				A2(
					elm$time$Time$flooredDiv,
					A2(elm$time$Time$toAdjustedMinutes, zone, time),
					60 * 24));
			switch (_n0) {
				case 0:
					return elm$time$Time$Thu;
				case 1:
					return elm$time$Time$Fri;
				case 2:
					return elm$time$Time$Sat;
				case 3:
					return elm$time$Time$Sun;
				case 4:
					return elm$time$Time$Mon;
				case 5:
					return elm$time$Time$Tue;
				default:
					return elm$time$Time$Wed;
			}
		});
	var author$project$Utils$Strftime$abbreviatedWeekday = F2(
		function (zone, time) {
			var _n0 = A2(elm$time$Time$toWeekday, zone, time);
			switch (_n0.$) {
				case 'Mon':
					return 'Lun';
				case 'Tue':
					return 'Mar';
				case 'Wed':
					return 'Mer';
				case 'Thu':
					return 'Jeu';
				case 'Fri':
					return 'Ven';
				case 'Sat':
					return 'Sam';
				default:
					return 'Dim';
			}
		});
	var elm$time$Time$toHour = F2(
		function (zone, time) {
			return A2(
				elm$core$Basics$modBy,
				24,
				A2(
					elm$time$Time$flooredDiv,
					A2(elm$time$Time$toAdjustedMinutes, zone, time),
					60));
		});
	var author$project$Utils$Strftime$amPmString = F2(
		function (zone, time) {
			return (A2(elm$time$Time$toHour, zone, time) > 11) ? 'PM' : 'AM';
		});
	var author$project$Utils$Strftime$fullMonth = F2(
		function (zone, time) {
			var _n0 = A2(elm$time$Time$toMonth, zone, time);
			switch (_n0.$) {
				case 'Jan':
					return 'Janvier';
				case 'Feb':
					return 'Février';
				case 'Mar':
					return 'Mars';
				case 'Apr':
					return 'Avril';
				case 'May':
					return 'Mai';
				case 'Jun':
					return 'Juin';
				case 'Jul':
					return 'Juillet';
				case 'Aug':
					return 'Aout';
				case 'Sep':
					return 'Septembre';
				case 'Oct':
					return 'Octobre';
				case 'Nov':
					return 'Novembre';
				default:
					return 'Décembre';
			}
		});
	var author$project$Utils$Strftime$fullWeekday = F2(
		function (zone, time) {
			var _n0 = A2(elm$time$Time$toWeekday, zone, time);
			switch (_n0.$) {
				case 'Mon':
					return 'Lundi';
				case 'Tue':
					return 'Mardi';
				case 'Wed':
					return 'Mercredi';
				case 'Thu':
					return 'Jeudi';
				case 'Fri':
					return 'Vendredi';
				case 'Sat':
					return 'Samedi';
				default:
					return 'Dimanche';
			}
		});
	var author$project$Utils$Strftime$numberWeekday = F2(
		function (zone, time) {
			var _n0 = A2(elm$time$Time$toWeekday, zone, time);
			switch (_n0.$) {
				case 'Sun':
					return '0';
				case 'Mon':
					return '1';
				case 'Tue':
					return '2';
				case 'Wed':
					return '3';
				case 'Thu':
					return '4';
				case 'Fri':
					return '5';
				default:
					return '6';
			}
		});
	var author$project$Utils$Strftime$numericMonth = F2(
		function (zone, time) {
			var _n0 = A2(elm$time$Time$toMonth, zone, time);
			switch (_n0.$) {
				case 'Jan':
					return 1;
				case 'Feb':
					return 2;
				case 'Mar':
					return 3;
				case 'Apr':
					return 4;
				case 'May':
					return 5;
				case 'Jun':
					return 6;
				case 'Jul':
					return 7;
				case 'Aug':
					return 8;
				case 'Sep':
					return 9;
				case 'Oct':
					return 10;
				case 'Nov':
					return 11;
				default:
					return 12;
			}
		});
	var elm$regex$Regex$Match = F4(
		function (match, index, number, submatches) {
			return {index: index, match: match, number: number, submatches: submatches};
		});
	var elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
	var elm$regex$Regex$fromString = function (string) {
		return A2(
			elm$regex$Regex$fromStringWith,
			{caseInsensitive: false, multiline: false},
			string);
	};
	var elm$regex$Regex$never = _Regex_never;
	var author$project$Utils$Strftime$regex = A2(
		elm$core$Basics$composeR,
		elm$regex$Regex$fromString,
		elm$core$Maybe$withDefault(elm$regex$Regex$never));
	var author$project$Utils$Strftime$twentyFourHourToTwelveHour = function (hour) {
		return (!hour) ? 12 : ((hour > 12) ? (hour - 12) : hour);
	};
	var author$project$Utils$Strftime$zeroPad = function (number) {
		return (number < 10) ? ('0' + elm$core$String$fromInt(number)) : elm$core$String$fromInt(number);
	};
	var elm$core$String$right = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(
				elm$core$String$slice,
				-n,
				elm$core$String$length(string),
				string);
		});
	var elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
	var elm$time$Time$toDay = F2(
		function (zone, time) {
			return elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).day;
		});
	var elm$time$Time$toMinute = F2(
		function (zone, time) {
			return A2(
				elm$core$Basics$modBy,
				60,
				A2(elm$time$Time$toAdjustedMinutes, zone, time));
		});
	var elm$time$Time$toSecond = F2(
		function (_n0, time) {
			return A2(
				elm$core$Basics$modBy,
				60,
				A2(
					elm$time$Time$flooredDiv,
					elm$time$Time$posixToMillis(time),
					1000));
		});
	var elm$time$Time$toYear = F2(
		function (zone, time) {
			return elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).year;
		});
	var author$project$Utils$Strftime$format = F3(
		function (fmt, zone, time) {
			return A3(
				elm$regex$Regex$replace,
				author$project$Utils$Strftime$regex('%S'),
				function (_n19) {
					return author$project$Utils$Strftime$zeroPad(
						A2(elm$time$Time$toSecond, zone, time));
				},
				A3(
					elm$regex$Regex$replace,
					author$project$Utils$Strftime$regex('%-S'),
					function (_n18) {
						return elm$core$String$fromInt(
							A2(elm$time$Time$toSecond, zone, time));
					},
					A3(
						elm$regex$Regex$replace,
						author$project$Utils$Strftime$regex('%M'),
						function (_n17) {
							return author$project$Utils$Strftime$zeroPad(
								A2(elm$time$Time$toMinute, zone, time));
						},
						A3(
							elm$regex$Regex$replace,
							author$project$Utils$Strftime$regex('%-M'),
							function (_n16) {
								return elm$core$String$fromInt(
									A2(elm$time$Time$toMinute, zone, time));
							},
							A3(
								elm$regex$Regex$replace,
								author$project$Utils$Strftime$regex('%p'),
								function (_n15) {
									return A2(author$project$Utils$Strftime$amPmString, zone, time);
								},
								A3(
									elm$regex$Regex$replace,
									author$project$Utils$Strftime$regex('%I'),
									function (_n14) {
										return author$project$Utils$Strftime$zeroPad(
											author$project$Utils$Strftime$twentyFourHourToTwelveHour(
												A2(elm$time$Time$toHour, zone, time)));
									},
									A3(
										elm$regex$Regex$replace,
										author$project$Utils$Strftime$regex('%-I'),
										function (_n13) {
											return elm$core$String$fromInt(
												author$project$Utils$Strftime$twentyFourHourToTwelveHour(
													A2(elm$time$Time$toHour, zone, time)));
										},
										A3(
											elm$regex$Regex$replace,
											author$project$Utils$Strftime$regex('%H'),
											function (_n12) {
												return author$project$Utils$Strftime$zeroPad(
													A2(elm$time$Time$toHour, zone, time));
											},
											A3(
												elm$regex$Regex$replace,
												author$project$Utils$Strftime$regex('%-H'),
												function (_n11) {
													return elm$core$String$fromInt(
														A2(elm$time$Time$toHour, zone, time));
												},
												A3(
													elm$regex$Regex$replace,
													author$project$Utils$Strftime$regex('%Y'),
													function (_n10) {
														return elm$core$String$fromInt(
															A2(elm$time$Time$toYear, zone, time));
													},
													A3(
														elm$regex$Regex$replace,
														author$project$Utils$Strftime$regex('%y'),
														function (_n9) {
															return A2(
																elm$core$String$right,
																2,
																elm$core$String$fromInt(
																	A2(elm$time$Time$toYear, zone, time)));
														},
														A3(
															elm$regex$Regex$replace,
															author$project$Utils$Strftime$regex('%d'),
															function (_n8) {
																return author$project$Utils$Strftime$zeroPad(
																	A2(elm$time$Time$toDay, zone, time));
															},
															A3(
																elm$regex$Regex$replace,
																author$project$Utils$Strftime$regex('%-d'),
																function (_n7) {
																	return elm$core$String$fromInt(
																		A2(elm$time$Time$toDay, zone, time));
																},
																A3(
																	elm$regex$Regex$replace,
																	author$project$Utils$Strftime$regex('%w'),
																	function (_n6) {
																		return A2(author$project$Utils$Strftime$numberWeekday, zone, time);
																	},
																	A3(
																		elm$regex$Regex$replace,
																		author$project$Utils$Strftime$regex('%A'),
																		function (_n5) {
																			return A2(author$project$Utils$Strftime$fullWeekday, zone, time);
																		},
																		A3(
																			elm$regex$Regex$replace,
																			author$project$Utils$Strftime$regex('%a'),
																			function (_n4) {
																				return A2(author$project$Utils$Strftime$abbreviatedWeekday, zone, time);
																			},
																			A3(
																				elm$regex$Regex$replace,
																				author$project$Utils$Strftime$regex('%m'),
																				function (_n3) {
																					return author$project$Utils$Strftime$zeroPad(
																						A2(author$project$Utils$Strftime$numericMonth, zone, time));
																				},
																				A3(
																					elm$regex$Regex$replace,
																					author$project$Utils$Strftime$regex('%-m'),
																					function (_n2) {
																						return elm$core$String$fromInt(
																							A2(author$project$Utils$Strftime$numericMonth, zone, time));
																					},
																					A3(
																						elm$regex$Regex$replace,
																						author$project$Utils$Strftime$regex('%B'),
																						function (_n1) {
																							return A2(author$project$Utils$Strftime$fullMonth, zone, time);
																						},
																						A3(
																							elm$regex$Regex$replace,
																							author$project$Utils$Strftime$regex('%b'),
																							function (_n0) {
																								return A2(author$project$Utils$Strftime$abbreviatedMonth, zone, time);
																							},
																							fmt))))))))))))))))))));
		});
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$ellipsis = {textOverflow: rtfeldman$elm_css$Css$Structure$Compatible, value: 'ellipsis'};
	var rtfeldman$elm_css$Css$help = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'help'};
	var rtfeldman$elm_css$Css$hidden = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, overflow: rtfeldman$elm_css$Css$Structure$Compatible, value: 'hidden', visibility: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$justifyContent = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'justifyContent',
			'justify-content',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$left = rtfeldman$elm_css$Css$prop1('left');
	var rtfeldman$elm_css$Css$noWrap = {flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, flexWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'nowrap', whiteSpace: rtfeldman$elm_css$Css$Structure$Compatible};
	var rtfeldman$elm_css$Css$overflow = rtfeldman$elm_css$Css$prop1('overflow');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var rtfeldman$elm_css$Css$spaceBetween = rtfeldman$elm_css$Css$prop1('space-between');
	var rtfeldman$elm_css$Css$textAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'textAlign',
			'text-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$textOverflow = rtfeldman$elm_css$Css$prop1('text-overflow');
	var rtfeldman$elm_css$Css$whiteSpace = rtfeldman$elm_css$Css$prop1('white-space');
	var rtfeldman$elm_css$Html$Styled$a = rtfeldman$elm_css$Html$Styled$node('a');
	var rtfeldman$elm_css$Html$Styled$i = rtfeldman$elm_css$Html$Styled$node('i');
	var rtfeldman$elm_css$Html$Styled$Attributes$classList = function (classes) {
		return rtfeldman$elm_css$Html$Styled$Attributes$class(
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$map,
					elm$core$Tuple$first,
					A2(elm$core$List$filter, elm$core$Tuple$second, classes))));
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
		return A2(rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$target = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
	var rtfeldman$elm_css$Html$Styled$Attributes$title = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
	var elm$parser$Parser$DeadEnd = F3(
		function (row, col, problem) {
			return {col: col, problem: problem, row: row};
		});
	var elm$parser$Parser$problemToDeadEnd = function (p) {
		return A3(elm$parser$Parser$DeadEnd, p.row, p.col, p.problem);
	};
	var elm$parser$Parser$Advanced$bagToList = F2(
		function (bag, list) {
			bagToList:
			while (true) {
				switch (bag.$) {
					case 'Empty':
						return list;
					case 'AddRight':
						var bag1 = bag.a;
						var x = bag.b;
						var $temp$bag = bag1,
							$temp$list = A2(elm$core$List$cons, x, list);
						bag = $temp$bag;
						list = $temp$list;
						continue bagToList;
					default:
						var bag1 = bag.a;
						var bag2 = bag.b;
						var $temp$bag = bag1,
							$temp$list = A2(elm$parser$Parser$Advanced$bagToList, bag2, list);
						bag = $temp$bag;
						list = $temp$list;
						continue bagToList;
				}
			}
		});
	var elm$parser$Parser$Advanced$run = F2(
		function (_n0, src) {
			var parse = _n0.a;
			var _n1 = parse(
				{col: 1, context: _List_Nil, indent: 1, offset: 0, row: 1, src: src});
			if (_n1.$ === 'Good') {
				var value = _n1.b;
				return elm$core$Result$Ok(value);
			} else {
				var bag = _n1.b;
				return elm$core$Result$Err(
					A2(elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
			}
		});
	var elm$parser$Parser$run = F2(
		function (parser, source) {
			var _n0 = A2(elm$parser$Parser$Advanced$run, parser, source);
			if (_n0.$ === 'Ok') {
				var a = _n0.a;
				return elm$core$Result$Ok(a);
			} else {
				var problems = _n0.a;
				return elm$core$Result$Err(
					A2(elm$core$List$map, elm$parser$Parser$problemToDeadEnd, problems));
			}
		});
	var elm$parser$Parser$Advanced$Bad = F2(
		function (a, b) {
			return {$: 'Bad', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$Good = F3(
		function (a, b, c) {
			return {$: 'Good', a: a, b: b, c: c};
		});
	var elm$parser$Parser$Advanced$Parser = function (a) {
		return {$: 'Parser', a: a};
	};
	var elm$parser$Parser$Advanced$andThen = F2(
		function (callback, _n0) {
			var parseA = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parseA(s0);
					if (_n1.$ === 'Bad') {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p1 = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						var _n2 = callback(a);
						var parseB = _n2.a;
						var _n3 = parseB(s1);
						if (_n3.$ === 'Bad') {
							var p2 = _n3.a;
							var x = _n3.b;
							return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
						} else {
							var p2 = _n3.a;
							var b = _n3.b;
							var s2 = _n3.c;
							return A3(elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
						}
					}
				});
		});
	var elm$parser$Parser$andThen = elm$parser$Parser$Advanced$andThen;
	var elm$parser$Parser$ExpectingEnd = {$: 'ExpectingEnd'};
	var elm$parser$Parser$Advanced$AddRight = F2(
		function (a, b) {
			return {$: 'AddRight', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$DeadEnd = F4(
		function (row, col, problem, contextStack) {
			return {col: col, contextStack: contextStack, problem: problem, row: row};
		});
	var elm$parser$Parser$Advanced$Empty = {$: 'Empty'};
	var elm$parser$Parser$Advanced$fromState = F2(
		function (s, x) {
			return A2(
				elm$parser$Parser$Advanced$AddRight,
				elm$parser$Parser$Advanced$Empty,
				A4(elm$parser$Parser$Advanced$DeadEnd, s.row, s.col, x, s.context));
		});
	var elm$parser$Parser$Advanced$end = function (x) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return _Utils_eq(
					elm$core$String$length(s.src),
					s.offset) ? A3(elm$parser$Parser$Advanced$Good, false, _Utils_Tuple0, s) : A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, x));
			});
	};
	var elm$parser$Parser$end = elm$parser$Parser$Advanced$end(elm$parser$Parser$ExpectingEnd);
	var elm$parser$Parser$Advanced$map2 = F3(
		function (func, _n0, _n1) {
			var parseA = _n0.a;
			var parseB = _n1.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n2 = parseA(s0);
					if (_n2.$ === 'Bad') {
						var p = _n2.a;
						var x = _n2.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p1 = _n2.a;
						var a = _n2.b;
						var s1 = _n2.c;
						var _n3 = parseB(s1);
						if (_n3.$ === 'Bad') {
							var p2 = _n3.a;
							var x = _n3.b;
							return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
						} else {
							var p2 = _n3.a;
							var b = _n3.b;
							var s2 = _n3.c;
							return A3(
								elm$parser$Parser$Advanced$Good,
								p1 || p2,
								A2(func, a, b),
								s2);
						}
					}
				});
		});
	var elm$parser$Parser$Advanced$ignorer = F2(
		function (keepParser, ignoreParser) {
			return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$always, keepParser, ignoreParser);
		});
	var elm$parser$Parser$ignorer = elm$parser$Parser$Advanced$ignorer;
	var elm$parser$Parser$Advanced$keeper = F2(
		function (parseFunc, parseArg) {
			return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$apL, parseFunc, parseArg);
		});
	var elm$parser$Parser$keeper = elm$parser$Parser$Advanced$keeper;
	var elm$parser$Parser$Advanced$Append = F2(
		function (a, b) {
			return {$: 'Append', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$oneOfHelp = F3(
		function (s0, bag, parsers) {
			oneOfHelp:
			while (true) {
				if (!parsers.b) {
					return A2(elm$parser$Parser$Advanced$Bad, false, bag);
				} else {
					var parse = parsers.a.a;
					var remainingParsers = parsers.b;
					var _n1 = parse(s0);
					if (_n1.$ === 'Good') {
						var step = _n1;
						return step;
					} else {
						var step = _n1;
						var p = step.a;
						var x = step.b;
						if (p) {
							return step;
						} else {
							var $temp$s0 = s0,
								$temp$bag = A2(elm$parser$Parser$Advanced$Append, bag, x),
								$temp$parsers = remainingParsers;
							s0 = $temp$s0;
							bag = $temp$bag;
							parsers = $temp$parsers;
							continue oneOfHelp;
						}
					}
				}
			}
		});
	var elm$parser$Parser$Advanced$oneOf = function (parsers) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A3(elm$parser$Parser$Advanced$oneOfHelp, s, elm$parser$Parser$Advanced$Empty, parsers);
			});
	};
	var elm$parser$Parser$oneOf = elm$parser$Parser$Advanced$oneOf;
	var elm$parser$Parser$Advanced$succeed = function (a) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A3(elm$parser$Parser$Advanced$Good, false, a, s);
			});
	};
	var elm$parser$Parser$succeed = elm$parser$Parser$Advanced$succeed;
	var elm$parser$Parser$ExpectingSymbol = function (a) {
		return {$: 'ExpectingSymbol', a: a};
	};
	var elm$parser$Parser$Advanced$Token = F2(
		function (a, b) {
			return {$: 'Token', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
	var elm$parser$Parser$Advanced$token = function (_n0) {
		var str = _n0.a;
		var expecting = _n0.b;
		var progress = !elm$core$String$isEmpty(str);
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				var _n1 = A5(elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
				var newOffset = _n1.a;
				var newRow = _n1.b;
				var newCol = _n1.c;
				return _Utils_eq(newOffset, -1) ? A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
					elm$parser$Parser$Advanced$Good,
					progress,
					_Utils_Tuple0,
					{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
			});
	};
	var elm$parser$Parser$Advanced$symbol = elm$parser$Parser$Advanced$token;
	var elm$parser$Parser$symbol = function (str) {
		return elm$parser$Parser$Advanced$symbol(
			A2(
				elm$parser$Parser$Advanced$Token,
				str,
				elm$parser$Parser$ExpectingSymbol(str)));
	};
	var elm$core$Basics$round = _Basics_round;
	var elm$core$String$toFloat = _String_toFloat;
	var elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
	var elm$parser$Parser$Advanced$chompWhileHelp = F5(
		function (isGood, offset, row, col, s0) {
			chompWhileHelp:
			while (true) {
				var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
				if (_Utils_eq(newOffset, -1)) {
					return A3(
						elm$parser$Parser$Advanced$Good,
						_Utils_cmp(s0.offset, offset) < 0,
						_Utils_Tuple0,
						{col: col, context: s0.context, indent: s0.indent, offset: offset, row: row, src: s0.src});
				} else {
					if (_Utils_eq(newOffset, -2)) {
						var $temp$isGood = isGood,
							$temp$offset = offset + 1,
							$temp$row = row + 1,
							$temp$col = 1,
							$temp$s0 = s0;
						isGood = $temp$isGood;
						offset = $temp$offset;
						row = $temp$row;
						col = $temp$col;
						s0 = $temp$s0;
						continue chompWhileHelp;
					} else {
						var $temp$isGood = isGood,
							$temp$offset = newOffset,
							$temp$row = row,
							$temp$col = col + 1,
							$temp$s0 = s0;
						isGood = $temp$isGood;
						offset = $temp$offset;
						row = $temp$row;
						col = $temp$col;
						s0 = $temp$s0;
						continue chompWhileHelp;
					}
				}
			}
		});
	var elm$parser$Parser$Advanced$chompWhile = function (isGood) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A5(elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.offset, s.row, s.col, s);
			});
	};
	var elm$parser$Parser$chompWhile = elm$parser$Parser$Advanced$chompWhile;
	var elm$parser$Parser$Advanced$mapChompedString = F2(
		function (func, _n0) {
			var parse = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parse(s0);
					if (_n1.$ === 'Bad') {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						return A3(
							elm$parser$Parser$Advanced$Good,
							p,
							A2(
								func,
								A3(elm$core$String$slice, s0.offset, s1.offset, s0.src),
								a),
							s1);
					}
				});
		});
	var elm$parser$Parser$Advanced$getChompedString = function (parser) {
		return A2(elm$parser$Parser$Advanced$mapChompedString, elm$core$Basics$always, parser);
	};
	var elm$parser$Parser$getChompedString = elm$parser$Parser$Advanced$getChompedString;
	var elm$parser$Parser$Problem = function (a) {
		return {$: 'Problem', a: a};
	};
	var elm$parser$Parser$Advanced$problem = function (x) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, x));
			});
	};
	var elm$parser$Parser$problem = function (msg) {
		return elm$parser$Parser$Advanced$problem(
			elm$parser$Parser$Problem(msg));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
		elm$parser$Parser$andThen,
		function (str) {
			if (elm$core$String$length(str) <= 9) {
				var _n0 = elm$core$String$toFloat('0.' + str);
				if (_n0.$ === 'Just') {
					var floatVal = _n0.a;
					return elm$parser$Parser$succeed(
						elm$core$Basics$round(floatVal * 1000));
				} else {
					return elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
				}
			} else {
				return elm$parser$Parser$problem(
					'Expected at most 9 digits, but got ' + elm$core$String$fromInt(
						elm$core$String$length(str)));
			}
		},
		elm$parser$Parser$getChompedString(
			elm$parser$Parser$chompWhile(elm$core$Char$isDigit)));
	var rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
		function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
			return elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
		});
	var elm$core$String$toInt = _String_toInt;
	var elm$parser$Parser$Done = function (a) {
		return {$: 'Done', a: a};
	};
	var elm$parser$Parser$Loop = function (a) {
		return {$: 'Loop', a: a};
	};
	var elm$parser$Parser$UnexpectedChar = {$: 'UnexpectedChar'};
	var elm$parser$Parser$Advanced$chompIf = F2(
		function (isGood, expecting) {
			return elm$parser$Parser$Advanced$Parser(
				function (s) {
					var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
					return _Utils_eq(newOffset, -1) ? A2(
						elm$parser$Parser$Advanced$Bad,
						false,
						A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
						elm$parser$Parser$Advanced$Good,
						true,
						_Utils_Tuple0,
						{col: 1, context: s.context, indent: s.indent, offset: s.offset + 1, row: s.row + 1, src: s.src}) : A3(
						elm$parser$Parser$Advanced$Good,
						true,
						_Utils_Tuple0,
						{col: s.col + 1, context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src}));
				});
		});
	var elm$parser$Parser$chompIf = function (isGood) {
		return A2(elm$parser$Parser$Advanced$chompIf, isGood, elm$parser$Parser$UnexpectedChar);
	};
	var elm$parser$Parser$Advanced$map = F2(
		function (func, _n0) {
			var parse = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parse(s0);
					if (_n1.$ === 'Good') {
						var p = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						return A3(
							elm$parser$Parser$Advanced$Good,
							p,
							func(a),
							s1);
					} else {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					}
				});
		});
	var elm$parser$Parser$map = elm$parser$Parser$Advanced$map;
	var elm$parser$Parser$Advanced$Done = function (a) {
		return {$: 'Done', a: a};
	};
	var elm$parser$Parser$Advanced$Loop = function (a) {
		return {$: 'Loop', a: a};
	};
	var elm$parser$Parser$toAdvancedStep = function (step) {
		if (step.$ === 'Loop') {
			var s = step.a;
			return elm$parser$Parser$Advanced$Loop(s);
		} else {
			var a = step.a;
			return elm$parser$Parser$Advanced$Done(a);
		}
	};
	var elm$parser$Parser$Advanced$loopHelp = F4(
		function (p, state, callback, s0) {
			loopHelp:
			while (true) {
				var _n0 = callback(state);
				var parse = _n0.a;
				var _n1 = parse(s0);
				if (_n1.$ === 'Good') {
					var p1 = _n1.a;
					var step = _n1.b;
					var s1 = _n1.c;
					if (step.$ === 'Loop') {
						var newState = step.a;
						var $temp$p = p || p1,
							$temp$state = newState,
							$temp$callback = callback,
							$temp$s0 = s1;
						p = $temp$p;
						state = $temp$state;
						callback = $temp$callback;
						s0 = $temp$s0;
						continue loopHelp;
					} else {
						var result = step.a;
						return A3(elm$parser$Parser$Advanced$Good, p || p1, result, s1);
					}
				} else {
					var p1 = _n1.a;
					var x = _n1.b;
					return A2(elm$parser$Parser$Advanced$Bad, p || p1, x);
				}
			}
		});
	var elm$parser$Parser$Advanced$loop = F2(
		function (state, callback) {
			return elm$parser$Parser$Advanced$Parser(
				function (s) {
					return A4(elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
				});
		});
	var elm$parser$Parser$loop = F2(
		function (state, callback) {
			return A2(
				elm$parser$Parser$Advanced$loop,
				state,
				function (s) {
					return A2(
						elm$parser$Parser$map,
						elm$parser$Parser$toAdvancedStep,
						callback(s));
				});
		});
	var rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
		var helper = function (str) {
			if (_Utils_eq(
				elm$core$String$length(str),
				quantity)) {
				var _n0 = elm$core$String$toInt(str);
				if (_n0.$ === 'Just') {
					var intVal = _n0.a;
					return A2(
						elm$parser$Parser$map,
						elm$parser$Parser$Done,
						elm$parser$Parser$succeed(intVal));
				} else {
					return elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
				}
			} else {
				return A2(
					elm$parser$Parser$map,
					function (nextChar) {
						return elm$parser$Parser$Loop(
							A2(elm$core$String$append, str, nextChar));
					},
					elm$parser$Parser$getChompedString(
						elm$parser$Parser$chompIf(elm$core$Char$isDigit)));
			}
		};
		return A2(elm$parser$Parser$loop, '', helper);
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
		return elm$parser$Parser$problem(
			'Invalid day: ' + elm$core$String$fromInt(day));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
		return (!A2(elm$core$Basics$modBy, 4, year)) && (A2(elm$core$Basics$modBy, 100, year) || (!A2(elm$core$Basics$modBy, 400, year)));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
		var y = y1 - 1;
		return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_n0) {
		var year = _n0.a;
		var month = _n0.b;
		var dayInMonth = _n0.c;
		if (dayInMonth < 0) {
			return rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
		} else {
			var succeedWith = function (extraMs) {
				var yearMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
				var days = ((month < 3) || (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
				var dayMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + (rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
				return elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
			};
			switch (month) {
				case 1:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
				case 2:
					return ((dayInMonth > 29) || ((dayInMonth === 29) && (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
				case 3:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
				case 4:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
				case 5:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
				case 6:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
				case 7:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
				case 8:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
				case 9:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
				case 10:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
				case 11:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
				case 12:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
				default:
					return elm$parser$Parser$problem(
						'Invalid month: \"' + (elm$core$String$fromInt(month) + '\"'));
			}
		}
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
		elm$parser$Parser$andThen,
		rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						F3(
							function (year, month, day) {
								return _Utils_Tuple3(year, month, day);
							})),
					rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(elm$core$Basics$identity),
								elm$parser$Parser$symbol('-')),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
						]))),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(elm$core$Basics$identity),
							elm$parser$Parser$symbol('-')),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))));
	var rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
		var utcOffsetMinutesFromParts = F3(
			function (multiplier, hours, minutes) {
				return (multiplier * (hours * 60)) + minutes;
			});
		return A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$map,
						function (_n0) {
							return 0;
						},
						elm$parser$Parser$symbol('Z')),
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$keeper,
								elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
								elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											elm$parser$Parser$map,
											function (_n1) {
												return 1;
											},
											elm$parser$Parser$symbol('+')),
											A2(
											elm$parser$Parser$map,
											function (_n2) {
												return -1;
											},
											elm$parser$Parser$symbol('-'))
										]))),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$succeed(elm$core$Basics$identity),
										elm$parser$Parser$symbol(':')),
									rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
									rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
									elm$parser$Parser$succeed(0)
								]))),
						A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(0),
						elm$parser$Parser$end)
					])));
	}();
	var rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
		elm$parser$Parser$andThen,
		function (datePart) {
			return elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$keeper,
								A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											elm$parser$Parser$succeed(
												rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
											elm$parser$Parser$symbol('T')),
										rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
									elm$parser$Parser$oneOf(
										_List_fromArray(
											[
												A2(
												elm$parser$Parser$keeper,
												A2(
													elm$parser$Parser$ignorer,
													elm$parser$Parser$succeed(elm$core$Basics$identity),
													elm$parser$Parser$symbol(':')),
												rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
												rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
											]))),
								elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											elm$parser$Parser$keeper,
											A2(
												elm$parser$Parser$ignorer,
												elm$parser$Parser$succeed(elm$core$Basics$identity),
												elm$parser$Parser$symbol(':')),
											rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											elm$parser$Parser$succeed(elm$core$Basics$identity),
											elm$parser$Parser$symbol('.')),
										rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
										elm$parser$Parser$succeed(0)
									]))),
						A2(elm$parser$Parser$ignorer, rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, elm$parser$Parser$end)),
						A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(
							A6(rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
						elm$parser$Parser$end)
					]));
		},
		rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
	var rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
		return A2(elm$parser$Parser$run, rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
	};
	var author$project$ShowDocumentsPage$viewDocument = F4(
		function (zone, removable, getXsIcon, _n0) {
			var n = _n0.a;
			var doc = _n0.b;
			var removeIcon = A2(
				rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Events$onClick(
						author$project$ShowDocumentsPage$DeleteDocument(doc.public_id)),
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer)
							]))
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$i,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$classList(
								getXsIcon('minus'))
							]),
						_List_Nil)
					]));
			var removable2 = elm$core$List$head(
				A2(
					elm$core$List$filter,
					function (l) {
						return l.rel === 'RemoveDocument';
					},
					doc.links));
			var toggleRemoveicon = removable ? A2(
				elm$core$Maybe$withDefault,
				A2(rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil),
				A2(
					elm$core$Maybe$map,
					elm$core$Basics$always(removeIcon),
					removable2)) : A2(rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil);
			var longFomatedDate = A2(
				elm$core$Result$withDefault,
				doc.uploadDate,
				A2(
					elm$core$Result$map,
					A2(author$project$Utils$Strftime$format, 'le %A %-d %B %Y à %-Hh%M', zone),
					rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(doc.uploadDate)));
			var formatedDate = A2(
				elm$core$Result$withDefault,
				doc.uploadDate,
				A2(
					elm$core$Result$map,
					A2(author$project$Utils$Strftime$format, 'Le %A %d %b', zone),
					rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(doc.uploadDate)));
			var fileName = A2(
				elm$core$Maybe$withDefault,
				'Photo ' + (elm$core$String$fromInt(n + 1) + ' '),
				doc.fileName);
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$displayFlex,
								rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween)
							]))
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$href(doc.url),
								rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
								rtfeldman$elm_css$Html$Styled$Attributes$title(fileName),
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$textOverflow(rtfeldman$elm_css$Css$ellipsis),
										rtfeldman$elm_css$Css$width(
										rtfeldman$elm_css$Css$px(140)),
										rtfeldman$elm_css$Css$whiteSpace(rtfeldman$elm_css$Css$noWrap),
										rtfeldman$elm_css$Css$overflow(rtfeldman$elm_css$Css$hidden),
										rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$left)
									]))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(fileName)
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$marginLeft(rtfeldman$elm_css$Css$auto),
										rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$help)
									])),
								rtfeldman$elm_css$Html$Styled$Attributes$title(longFomatedDate)
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(formatedDate)
							])),
						toggleRemoveicon
					]));
		});
	var rtfeldman$elm_css$Css$borderBottom3 = rtfeldman$elm_css$Css$prop3('border-bottom');
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$textTransform = rtfeldman$elm_css$Css$prop1('text-transform');
	var rtfeldman$elm_css$Css$uppercase = {textTransform: rtfeldman$elm_css$Css$Structure$Compatible, value: 'uppercase'};
	var author$project$UIComponents$Card$titleBlock = function (title) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A3(
							rtfeldman$elm_css$Css$borderBottom3,
							rtfeldman$elm_css$Css$px(1),
							rtfeldman$elm_css$Css$solid,
							rtfeldman$elm_css$Css$hex('#546D79')),
							rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase),
							rtfeldman$elm_css$Css$padding(
							rtfeldman$elm_css$Css$em(0.5)),
							rtfeldman$elm_css$Css$width(
							rtfeldman$elm_css$Css$pct(100)),
							rtfeldman$elm_css$Css$fontSize(
							rtfeldman$elm_css$Css$px(26)),
							rtfeldman$elm_css$Css$color(
							rtfeldman$elm_css$Css$hex('#546D79'))
						]))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(title)
				]));
	};
	var rtfeldman$elm_css$Css$row = {flexDirection: rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'row'};
	var rtfeldman$elm_css$Css$column = _Utils_update(
		rtfeldman$elm_css$Css$row,
		{value: 'column'});
	var rtfeldman$elm_css$Css$flexDirection = rtfeldman$elm_css$Css$prop1('flex-direction');
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var author$project$UIComponents$Card$card = F2(
		function (title, childs) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A3(
								rtfeldman$elm_css$Css$border3,
								rtfeldman$elm_css$Css$px(1),
								rtfeldman$elm_css$Css$solid,
								rtfeldman$elm_css$Css$hex('#DADADA')),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(30)),
								rtfeldman$elm_css$Css$padding(
								rtfeldman$elm_css$Css$px(10)),
								rtfeldman$elm_css$Css$displayFlex,
								rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$column),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('#fff')),
								rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						author$project$UIComponents$Card$titleBlock(title),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$padding(
										rtfeldman$elm_css$Css$em(1)),
										rtfeldman$elm_css$Css$fontSize(
										rtfeldman$elm_css$Css$px(16)),
										rtfeldman$elm_css$Css$color(
										rtfeldman$elm_css$Css$hex('#546D79'))
									]))
							]),
						childs)
					]));
		});
	var author$project$ShowDocumentsPage$viewCategory = F4(
		function (zone, getIcon, title, docs) {
			var removable = !_Utils_eq(title, author$project$ShowDocumentsPage$from_sr_category);
			return A2(
				author$project$UIComponents$Card$card,
				title,
				A2(
					elm$core$List$map,
					A3(author$project$ShowDocumentsPage$viewDocument, zone, removable, getIcon),
					docs));
		});
	var elm$core$Dict$foldl = F3(
		function (func, acc, dict) {
			foldl:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldl, func, acc, left)),
						$temp$dict = right;
					func = $temp$func;
					acc = $temp$acc;
					dict = $temp$dict;
					continue foldl;
				}
			}
		});
	var elm$core$Dict$filter = F2(
		function (isGood, dict) {
			return A3(
				elm$core$Dict$foldl,
				F3(
					function (k, v, d) {
						return A2(isGood, k, v) ? A3(elm$core$Dict$insert, k, v, d) : d;
					}),
				elm$core$Dict$empty,
				dict);
		});
	var elm$core$Dict$map = F2(
		function (func, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					A2(func, key, value),
					A2(elm$core$Dict$map, func, left),
					A2(elm$core$Dict$map, func, right));
			}
		});
	var elm$core$Dict$values = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, valueList) {
					return A2(elm$core$List$cons, value, valueList);
				}),
			_List_Nil,
			dict);
	};
	var author$project$ShowDocumentsPage$viewCategories = F3(
		function (zone, getIcon, docs) {
			var children = elm$core$Dict$values(
				A2(
					elm$core$Dict$map,
					F2(
						function (k, v) {
							return A4(author$project$ShowDocumentsPage$viewCategory, zone, getIcon, k, v);
						}),
					A2(
						elm$core$Dict$filter,
						F2(
							function (_n0, v) {
								return !elm$core$List$isEmpty(v);
							}),
						docs)));
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A2(rtfeldman$elm_css$Css$property, 'display', 'grid'),
								A2(rtfeldman$elm_css$Css$property, 'gap', '10px 10px '),
								A2(rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(3,30%)')
							]))
					]),
				children);
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var author$project$ShowDocumentsPage$page = function (model) {
		var indexedSrDocuments = A3(
			elm$core$List$foldl,
			F2(
				function (e, acc) {
					return _Utils_ap(
						acc,
						_List_fromArray(
							[
								_Utils_Tuple2(
								elm$core$List$length(acc),
								e)
							]));
				}),
			_List_Nil,
			model.documentsFromSR.result);
		var indexedDocuments = A3(
			elm$core$List$foldl,
			F2(
				function (e, acc) {
					return _Utils_ap(
						acc,
						_List_fromArray(
							[
								_Utils_Tuple2(
								elm$core$List$length(acc),
								e)
							]));
				}),
			_List_Nil,
			model.documents.result);
		var groupedByCategory = A3(
			elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A2(author$project$ShowDocumentsPage$groupByCat, x, acc);
				}),
			A2(elm$core$Dict$singleton, 'autre', _List_Nil),
			indexedDocuments);
		var allDocs = (model.flags.entityType === 'Ticket') ? A3(elm$core$Dict$insert, author$project$ShowDocumentsPage$from_sr_category, indexedSrDocuments, groupedByCategory) : groupedByCategory;
		var displayDocs = _List_fromArray(
			[
				A3(
				author$project$ShowDocumentsPage$viewCategories,
				model.zone,
				author$project$ShowDocumentsPage$getXSIcon(model),
				allDocs)
			]);
		return A2(
			elm$core$Maybe$withDefault,
			displayDocs,
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$always(
					_List_fromArray(
						[
							author$project$ShowDocumentsPage$addDocform(model)
						])),
				model.addDoc));
	};
	var rtfeldman$elm_css$Html$Styled$h2 = rtfeldman$elm_css$Html$Styled$node('h2');
	var author$project$ShowDocumentsPage$documentsBox = function (model) {
		return _List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$displayFlex,
								rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center)
							]))
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Documents')
								]))
						]),
					A2(
						elm$core$Maybe$withDefault,
						author$project$ShowDocumentsPage$addDocButton(model),
						A2(
							elm$core$Maybe$map,
							elm$core$Basics$always(_List_Nil),
							model.addDoc)))),
				A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				A2(
					elm$core$Maybe$withDefault,
					author$project$ShowDocumentsPage$page(model),
					A2(
						elm$core$Maybe$map,
						elm$core$Basics$always(
							_List_fromArray(
								[
									author$project$ShowDocumentsPage$addDocform(model)
								])),
						model.addDoc)))
			]);
	};
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var author$project$ShowDocumentsPage$view = function (model) {
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				author$project$ShowDocumentsPage$documentsBox(model)));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$json$Json$Decode$index = _Json_decodeIndex;
	var author$project$ShowDocumentsPage$main = elm$browser$Browser$element(
		{init: author$project$ShowDocumentsPage$init, subscriptions: author$project$ShowDocumentsPage$subscriptions, update: author$project$ShowDocumentsPage$update, view: author$project$ShowDocumentsPage$view});
	_Platform_export({'ShowDocumentsPage':{'init':author$project$ShowDocumentsPage$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (simplifiedRequestUid) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (queryApiBaseUrl) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (icons) {
								return A2(
									elm$json$Json$Decode$andThen,
									function (entityUid) {
										return A2(
											elm$json$Json$Decode$andThen,
											function (entityType) {
												return elm$json$Json$Decode$succeed(
													{entityType: entityType, entityUid: entityUid, icons: icons, queryApiBaseUrl: queryApiBaseUrl, simplifiedRequestUid: simplifiedRequestUid});
											},
											A2(elm$json$Json$Decode$field, 'entityType', elm$json$Json$Decode$string));
									},
									A2(elm$json$Json$Decode$field, 'entityUid', elm$json$Json$Decode$string));
							},
							A2(
								elm$json$Json$Decode$field,
								'icons',
								elm$json$Json$Decode$list(
									A2(
										elm$json$Json$Decode$andThen,
										function (x0) {
											return A2(
												elm$json$Json$Decode$andThen,
												function (x1) {
													return elm$json$Json$Decode$succeed(
														_Utils_Tuple2(x0, x1));
												},
												A2(elm$json$Json$Decode$index, 1, elm$json$Json$Decode$string));
										},
										A2(elm$json$Json$Decode$index, 0, elm$json$Json$Decode$string)))));
					},
					A2(elm$json$Json$Decode$field, 'queryApiBaseUrl', elm$json$Json$Decode$string));
			},
			A2(
				elm$json$Json$Decode$field,
				'simplifiedRequestUid',
				elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
							A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, elm$json$Json$Decode$string)
						])))))(0)}});}(this));

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	
	// STRINGS
	
	
	var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
	{
		var smallLength = smallString.length;
		var isGood = offset + smallLength <= bigString.length;
	
		for (var i = 0; isGood && i < smallLength; )
		{
			var code = bigString.charCodeAt(offset);
			isGood =
				smallString[i++] === bigString[offset++]
				&& (
					code === 0x000A /* \n */
						? ( row++, col=1 )
						: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
				)
		}
	
		return _Utils_Tuple3(isGood ? offset : -1, row, col);
	});
	
	
	
	// CHARS
	
	
	var _Parser_isSubChar = F3(function(predicate, offset, string)
	{
		return (
			string.length <= offset
				? -1
				:
			(string.charCodeAt(offset) & 0xF800) === 0xD800
				? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
				:
			(predicate(_Utils_chr(string[offset]))
				? ((string[offset] === '\n') ? -2 : (offset + 1))
				: -1
			)
		);
	});
	
	
	var _Parser_isAsciiCode = F3(function(code, offset, string)
	{
		return string.charCodeAt(offset) === code;
	});
	
	
	
	// NUMBERS
	
	
	var _Parser_chompBase10 = F2(function(offset, string)
	{
		for (; offset < string.length; offset++)
		{
			var code = string.charCodeAt(offset);
			if (code < 0x30 || 0x39 < code)
			{
				return offset;
			}
		}
		return offset;
	});
	
	
	var _Parser_consumeBase = F3(function(base, offset, string)
	{
		for (var total = 0; offset < string.length; offset++)
		{
			var digit = string.charCodeAt(offset) - 0x30;
			if (digit < 0 || base <= digit) break;
			total = base * total + digit;
		}
		return _Utils_Tuple2(offset, total);
	});
	
	
	var _Parser_consumeBase16 = F2(function(offset, string)
	{
		for (var total = 0; offset < string.length; offset++)
		{
			var code = string.charCodeAt(offset);
			if (0x30 <= code && code <= 0x39)
			{
				total = 16 * total + code - 0x30;
			}
			else if (0x41 <= code && code <= 0x46)
			{
				total = 16 * total + code - 55;
			}
			else if (0x61 <= code && code <= 0x66)
			{
				total = 16 * total + code - 87;
			}
			else
			{
				break;
			}
		}
		return _Utils_Tuple2(offset, total);
	});
	
	
	
	// FIND STRING
	
	
	var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
	{
		var newOffset = bigString.indexOf(smallString, offset);
		var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;
	
		while (offset < target)
		{
			var code = bigString.charCodeAt(offset++);
			code === 0x000A /* \n */
				? ( col=1, row++ )
				: ( col++, (code & 0xF800) === 0xD800 && offset++ )
		}
	
		return _Utils_Tuple3(newOffset, row, col);
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$Components$SimplifiedRequest$List$FetchSimplifiedRequest = {$: 'FetchSimplifiedRequest'};
	var author$project$Components$SimplifiedRequest$List$Model = F4(
		function (result, page, itemsByPage, timezone) {
			return {itemsByPage: itemsByPage, page: page, result: result, timezone: timezone};
		});
	var author$project$Utils$Http$Range$PrivateItemsByPage = function (a) {
		return {$: 'PrivateItemsByPage', a: a};
	};
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var author$project$Utils$Http$Range$defaultItemsByPage = author$project$Utils$Http$Range$PrivateItemsByPage(10);
	var author$project$Utils$Http$Range$PrivatePageNumber = function (a) {
		return {$: 'PrivatePageNumber', a: a};
	};
	var author$project$Utils$Http$Range$firstPage = author$project$Utils$Http$Range$PrivatePageNumber(0);
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var author$project$Components$SimplifiedRequest$List$init = function (zone) {
		return A4(author$project$Components$SimplifiedRequest$List$Model, _List_Nil, author$project$Utils$Http$Range$firstPage, author$project$Utils$Http$Range$defaultItemsByPage, zone);
	};
	var author$project$SimplifiedRequest$ListMsg = function (a) {
		return {$: 'ListMsg', a: a};
	};
	var author$project$SimplifiedRequest$Model = F3(
		function (apiUrl, icons, list) {
			return {apiUrl: apiUrl, icons: icons, list: list};
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$Dict$fromList = function (assocs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, dict) {
					var key = _n0.a;
					var value = _n0.b;
					return A3(elm$core$Dict$insert, key, value, dict);
				}),
			elm$core$Dict$empty,
			assocs);
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var elm$time$Time$Jan = {$: 'Jan'};
	var elm$time$Time$Zone = F2(
		function (a, b) {
			return {$: 'Zone', a: a, b: b};
		});
	var elm$time$Time$customZone = elm$time$Time$Zone;
	var justinmimbs$timezone_data$TimeZone$maxYear = 2037;
	var justinmimbs$timezone_data$TimeZone$minYear = 1970;
	var elm$core$Tuple$second = function (_n0) {
		var y = _n0.b;
		return y;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
		function (year, month, day, time, clock) {
			return {clock: clock, day: day, month: month, time: time, year: year};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$Universal = {$: 'Universal'};
	var justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_n0) {
		dropChangesBeforeEpoch:
		while (true) {
			var initial = _n0.a;
			var changes = _n0.b;
			if (changes.b) {
				var change = changes.a;
				var rest = changes.b;
				if (change.start <= 0) {
					var $temp$_n0 = _Utils_Tuple2(change.offset, rest);
					_n0 = $temp$_n0;
					continue dropChangesBeforeEpoch;
				} else {
					return _Utils_Tuple2(initial, changes);
				}
			} else {
				return _Utils_Tuple2(initial, _List_Nil);
			}
		}
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var elm$core$List$sortBy = _List_sortBy;
	var elm$core$Basics$modBy = _Basics_modBy;
	var justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
		var _n0 = A2(elm$core$Basics$modBy, 7, rd);
		if (!_n0) {
			return 7;
		} else {
			var n = _n0;
			return n;
		}
	};
	var justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
		switch (wd.$) {
			case 'Mon':
				return 1;
			case 'Tue':
				return 2;
			case 'Wed':
				return 3;
			case 'Thu':
				return 4;
			case 'Fri':
				return 5;
			case 'Sat':
				return 6;
			default:
				return 7;
		}
	};
	var justinmimbs$timezone_data$RataDie$floorWeekday = F2(
		function (weekday, rd) {
			var daysSincePreviousWeekday = A2(
				elm$core$Basics$modBy,
				7,
				(justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
			return rd - daysSincePreviousWeekday;
		});
	var justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
		function (weekday, rd) {
			var floored = A2(justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
			return _Utils_eq(rd, floored) ? rd : (floored + 7);
		});
	var elm$core$Basics$neq = _Utils_notEqual;
	var justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
		return ((!A2(elm$core$Basics$modBy, 4, y)) && A2(elm$core$Basics$modBy, 100, y)) || (!A2(elm$core$Basics$modBy, 400, y));
	};
	var justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
		function (y, m) {
			var leapDays = justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
			switch (m.$) {
				case 'Jan':
					return 0;
				case 'Feb':
					return 31;
				case 'Mar':
					return 59 + leapDays;
				case 'Apr':
					return 90 + leapDays;
				case 'May':
					return 120 + leapDays;
				case 'Jun':
					return 151 + leapDays;
				case 'Jul':
					return 181 + leapDays;
				case 'Aug':
					return 212 + leapDays;
				case 'Sep':
					return 243 + leapDays;
				case 'Oct':
					return 273 + leapDays;
				case 'Nov':
					return 304 + leapDays;
				default:
					return 334 + leapDays;
			}
		});
	var justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
		var y = y1 - 1;
		var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
		return (365 * y) + leapYears;
	};
	var justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
		function (y, m, d) {
			return (justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2(justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
		});
	var justinmimbs$timezone_data$RataDie$daysInMonth = F2(
		function (y, m) {
			switch (m.$) {
				case 'Jan':
					return 31;
				case 'Feb':
					return justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
				case 'Mar':
					return 31;
				case 'Apr':
					return 30;
				case 'May':
					return 31;
				case 'Jun':
					return 30;
				case 'Jul':
					return 31;
				case 'Aug':
					return 31;
				case 'Sep':
					return 30;
				case 'Oct':
					return 31;
				case 'Nov':
					return 30;
				default:
					return 31;
			}
		});
	var justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
		function (y, m) {
			return (justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2(justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2(justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
		return (rd - 719163) * 1440;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
		function (clock, _n0) {
			var standard = _n0.standard;
			var save = _n0.save;
			switch (clock.$) {
				case 'Universal':
					return 0;
				case 'Standard':
					return 0 - standard;
				default:
					return 0 - (standard + save);
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_n0) {
		var year = _n0.year;
		var month = _n0.month;
		var day = _n0.day;
		var time = _n0.time;
		return justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
			A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
		function (offset, datetime) {
			return justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.clock, offset);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
		function (previousOffset, start, until, standardOffset, rules) {
			var transitions = A2(
				elm$core$List$concatMap,
				function (year) {
					return A2(
						elm$core$List$sortBy,
						function ($) {
							return $.start;
						},
						A2(
							elm$core$List$map,
							function (rule) {
								return {
									clock: rule.clock,
									save: rule.save,
									start: justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
										function () {
											var _n2 = rule.day;
											switch (_n2.$) {
												case 'Day':
													var day = _n2.a;
													return A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, day);
												case 'First':
													var weekday = _n2.a;
													var onOrAfterDay = _n2.b;
													return A2(
														justinmimbs$timezone_data$RataDie$ceilingWeekday,
														weekday,
														A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, onOrAfterDay));
												default:
													var weekday = _n2.a;
													return A2(
														justinmimbs$timezone_data$RataDie$floorWeekday,
														weekday,
														A2(justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.month));
											}
										}()) + rule.time
								};
							},
							A2(
								elm$core$List$filter,
								function (rule) {
									return (_Utils_cmp(rule.from, year) < 1) && (_Utils_cmp(year, rule.to) < 1);
								},
								rules)));
				},
				A2(elm$core$List$range, start.year - 1, until.year));
			var initialOffset = {save: 0, standard: standardOffset};
			var initialChange = {
				offset: standardOffset,
				start: A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
			};
			var _n0 = A3(
				elm$core$List$foldl,
				F2(
					function (transition, _n1) {
						var currentOffset = _n1.a;
						var changes = _n1.b;
						var newOffset = {save: transition.save, standard: standardOffset};
						if (_Utils_cmp(
							transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, previousOffset),
							initialChange.start) < 1) {
							var updatedInitialChange = {offset: standardOffset + transition.save, start: initialChange.start};
							return _Utils_Tuple2(
								newOffset,
								_List_fromArray(
									[updatedInitialChange]));
						} else {
							if (_Utils_cmp(
								transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset),
								A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
								var change = {
									offset: standardOffset + transition.save,
									start: transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset)
								};
								return _Utils_Tuple2(
									newOffset,
									A2(elm$core$List$cons, change, changes));
							} else {
								return _Utils_Tuple2(currentOffset, changes);
							}
						}
					}),
				_Utils_Tuple2(
					initialOffset,
					_List_fromArray(
						[initialChange])),
				transitions);
			var nextOffset = _n0.a;
			var descendingChanges = _n0.b;
			return _Utils_Tuple2(
				elm$core$List$reverse(descendingChanges),
				nextOffset);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
		function (previousOffset, start, until, _n0) {
			var standardOffset = _n0.standardOffset;
			var zoneRules = _n0.zoneRules;
			if (zoneRules.$ === 'Save') {
				var save = zoneRules.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							{
							offset: standardOffset + save,
							start: A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
						}
						]),
					{save: save, standard: standardOffset});
			} else {
				var rules = zoneRules.a;
				return A5(justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
		function (f, a, rev, list) {
			stripDuplicatesByHelp:
			while (true) {
				if (!list.b) {
					return elm$core$List$reverse(rev);
				} else {
					var x = list.a;
					var xs = list.b;
					var b = f(x);
					var rev_ = (!_Utils_eq(a, b)) ? A2(elm$core$List$cons, x, rev) : rev;
					var $temp$f = f,
						$temp$a = b,
						$temp$rev = rev_,
						$temp$list = xs;
					f = $temp$f;
					a = $temp$a;
					rev = $temp$rev;
					list = $temp$list;
					continue stripDuplicatesByHelp;
				}
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
		function (zoneStart, zoneUntil, zone) {
			var _n0 = A3(
				elm$core$List$foldl,
				F2(
					function (_n1, _n2) {
						var state = _n1.a;
						var nextStart = _n1.b;
						var start = _n2.a;
						var ranges = _n2.b;
						return _Utils_Tuple2(
							nextStart,
							A2(
								elm$core$List$cons,
								_Utils_Tuple3(start, state, nextStart),
								ranges));
					}),
				_Utils_Tuple2(zoneStart, _List_Nil),
				zone.history);
			var currentStart = _n0.a;
			var historyRanges = _n0.b;
			return elm$core$List$reverse(
				A2(
					elm$core$List$cons,
					_Utils_Tuple3(currentStart, zone.current, zoneUntil),
					historyRanges));
		});
	var justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
		function (minYear, maxYear, zone) {
			var initialState = function () {
				var _n5 = zone.history;
				if (_n5.b) {
					var _n6 = _n5.a;
					var earliest = _n6.a;
					return earliest;
				} else {
					return zone.current;
				}
			}();
			var initialOffset = {
				save: function () {
					var _n4 = initialState.zoneRules;
					if (_n4.$ === 'Save') {
						var save = _n4.a;
						return save;
					} else {
						return 0;
					}
				}(),
				standard: initialState.standardOffset
			};
			var ascendingChanges = A4(
				justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
				function ($) {
					return $.offset;
				},
				initialOffset.standard + initialOffset.save,
				_List_Nil,
				A3(
					elm$core$List$foldl,
					F2(
						function (_n1, _n2) {
							var start = _n1.a;
							var state = _n1.b;
							var until = _n1.c;
							var prevOffset = _n2.a;
							var prevChanges = _n2.b;
							var _n3 = A4(justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
							var nextChanges = _n3.a;
							var nextOffset = _n3.b;
							return _Utils_Tuple2(
								nextOffset,
								_Utils_ap(prevChanges, nextChanges));
						}),
					_Utils_Tuple2(initialOffset, _List_Nil),
					A3(
						justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$Universal),
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$Universal),
						zone)).b);
			var _n0 = justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
				_Utils_Tuple2(initialOffset.standard + initialOffset.save, ascendingChanges));
			var initial = _n0.a;
			var ascending = _n0.b;
			return _Utils_Tuple2(
				elm$core$List$reverse(ascending),
				initial);
		});
	var justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
		var _n0 = A3(justinmimbs$timezone_data$TimeZone$Specification$toOffsets, justinmimbs$timezone_data$TimeZone$minYear, justinmimbs$timezone_data$TimeZone$maxYear, zone);
		var descending = _n0.a;
		var bottom = _n0.b;
		return A2(elm$time$Time$customZone, bottom, descending);
	};
	var elm$time$Time$Apr = {$: 'Apr'};
	var elm$time$Time$Mar = {$: 'Mar'};
	var elm$time$Time$Oct = {$: 'Oct'};
	var elm$time$Time$Sep = {$: 'Sep'};
	var elm$time$Time$Sun = {$: 'Sun'};
	var justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
		return {$: 'Day', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$First = F2(
		function (a, b) {
			return {$: 'First', a: a, b: b};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
		return {$: 'Last', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
		function (from, to, month, day, time, clock, save) {
			return {clock: clock, day: day, from: from, month: month, save: save, time: time, to: to};
		});
	var justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
		[
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1977,
			1980,
			elm$time$Time$Apr,
			A2(justinmimbs$timezone_data$TimeZone$Specification$First, elm$time$Time$Sun, 1),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1977,
			1977,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1978,
			1978,
			elm$time$Time$Oct,
			justinmimbs$timezone_data$TimeZone$Specification$Day(1),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1979,
			1995,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1981,
			justinmimbs$timezone_data$TimeZone$maxYear,
			elm$time$Time$Mar,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1996,
			justinmimbs$timezone_data$TimeZone$maxYear,
			elm$time$Time$Oct,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0)
		]);
	var justinmimbs$timezone_data$TimeZone$Specification$WallClock = {$: 'WallClock'};
	var justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
		[
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1976,
			1976,
			elm$time$Time$Mar,
			justinmimbs$timezone_data$TimeZone$Specification$Day(28),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$WallClock,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1976,
			1976,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Day(26),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$WallClock,
			0)
		]);
	var justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
		return {$: 'Rules', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
		function (history, current) {
			return {current: current, history: history};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
		function (standardOffset, zoneRules) {
			return {standardOffset: standardOffset, zoneRules: zoneRules};
		});
	var justinmimbs$timezone_data$TimeZone$europe__paris = function (_n0) {
		return justinmimbs$timezone_data$TimeZone$fromSpecification(
			A2(
				justinmimbs$timezone_data$TimeZone$Specification$Zone,
				_List_fromArray(
					[
						_Utils_Tuple2(
						A2(
							justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
							60,
							justinmimbs$timezone_data$TimeZone$Specification$Rules(justinmimbs$timezone_data$TimeZone$rules_France)),
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$WallClock))
					]),
				A2(
					justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
					60,
					justinmimbs$timezone_data$TimeZone$Specification$Rules(justinmimbs$timezone_data$TimeZone$rules_EU))));
	};
	var author$project$SimplifiedRequest$init = function (flags) {
		var timezone = justinmimbs$timezone_data$TimeZone$europe__paris(_Utils_Tuple0);
		var model = A3(
			author$project$SimplifiedRequest$Model,
			flags.apiUrl,
			elm$core$Dict$fromList(flags.icons),
			author$project$Components$SimplifiedRequest$List$init(timezone));
		var cmd = A2(
			elm$core$Task$perform,
			elm$core$Basics$identity,
			elm$core$Task$succeed(
				author$project$SimplifiedRequest$ListMsg(author$project$Components$SimplifiedRequest$List$FetchSimplifiedRequest)));
		return _Utils_Tuple2(model, cmd);
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$SimplifiedRequest$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var elm$json$Json$Decode$map = _Json_map1;
	var author$project$Binding$ResultDecoder$resultsDecoder = function (listDecoder) {
		return A2(
			elm$json$Json$Decode$map,
			function (x) {
				return x.result;
			},
			author$project$Binding$ResultDecoder$resultDecoder(listDecoder));
	};
	var elm$json$Json$Decode$decodeValue = _Json_run;
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var elm$json$Json$Decode$value = _Json_decodeValue;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
		function (pathDecoder, valDecoder, fallback) {
			var nullOr = function (decoder) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							decoder,
							elm$json$Json$Decode$null(fallback)
						]));
			};
			var handleResult = function (input) {
				var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
				if (_n0.$ === 'Ok') {
					var rawValue = _n0.a;
					var _n1 = A2(
						elm$json$Json$Decode$decodeValue,
						nullOr(valDecoder),
						rawValue);
					if (_n1.$ === 'Ok') {
						var finalResult = _n1.a;
						return elm$json$Json$Decode$succeed(finalResult);
					} else {
						var finalErr = _n1.a;
						return elm$json$Json$Decode$fail(
							elm$json$Json$Decode$errorToString(finalErr));
					}
				} else {
					return elm$json$Json$Decode$succeed(fallback);
				}
			};
			return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
		});
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
		function (key, valDecoder, fallback, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
					A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
					valDecoder,
					fallback),
				decoder);
		});
	var author$project$Binding$SimplifiedRequestSearchDecoder$SimplifiedRequestSearchItem = F6(
		function (uid, state, ticketUid, category, patrimony, requestDate) {
			return {category: category, patrimony: patrimony, requestDate: requestDate, state: state, ticketUid: ticketUid, uid: uid};
		});
	var author$project$Binding$SimplifiedRequestSearchDecoder$Category = F3(
		function (iconId, label, uid) {
			return {iconId: iconId, label: label, uid: uid};
		});
	var author$project$Binding$SimplifiedRequestSearchDecoder$categoryDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uid',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'iconId',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$Category))));
	var author$project$Binding$SimplifiedRequestSearchDecoder$PatrimonyAbstract = F3(
		function (uid, ref, name) {
			return {name: name, ref: ref, uid: uid};
		});
	var author$project$Binding$SimplifiedRequestSearchDecoder$patrimonyAbstractDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ref',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$PatrimonyAbstract))));
	var author$project$Binding$SimplifiedRequestSearchDecoder$Declared = {$: 'Declared'};
	var author$project$Binding$SimplifiedRequestSearchDecoder$Qualified = {$: 'Qualified'};
	var author$project$Binding$SimplifiedRequestSearchDecoder$Seen = {$: 'Seen'};
	var author$project$Binding$SimplifiedRequestSearchDecoder$stringToRequestStateDecoder = function (s) {
		switch (s) {
			case 'Declared':
				return elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$Declared);
			case 'Seen':
				return elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$Seen);
			case 'Qualified':
				return elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$Qualified);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not a valid request state');
		}
	};
	var author$project$Binding$SimplifiedRequestSearchDecoder$requestStateDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$SimplifiedRequestSearchDecoder$stringToRequestStateDecoder, elm$json$Json$Decode$string);
	var elm$json$Json$Decode$nullable = function (decoder) {
		return elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
				]));
	};
	var author$project$Binding$SimplifiedRequestSearchDecoder$simplifiedRequestSearchItemDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'requestDate',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patrimony',
			author$project$Binding$SimplifiedRequestSearchDecoder$patrimonyAbstractDecoder,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'category',
				author$project$Binding$SimplifiedRequestSearchDecoder$categoryDecoder,
				A4(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'tickedUid',
					elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
					elm$core$Maybe$Nothing,
					A3(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'state',
						author$project$Binding$SimplifiedRequestSearchDecoder$requestStateDecoder,
						A3(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'uid',
							elm$json$Json$Decode$string,
							elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$SimplifiedRequestSearchItem)))))));
	var author$project$Binding$SimplifiedRequestSearchDecoder$simplifiedRequestSearchItemsDecoder = author$project$Binding$ResultDecoder$resultsDecoder(
		elm$json$Json$Decode$list(author$project$Binding$SimplifiedRequestSearchDecoder$simplifiedRequestSearchItemDecoder));
	var author$project$Components$HttpPathDirectory$listRequestsPath = function (range) {
		return '/simplifiedrequests?range=' + (range + '&state=Declared&state=Seen');
	};
	var author$project$Components$SimplifiedRequest$List$SimplifiedRequestFetched = function (a) {
		return {$: 'SimplifiedRequestFetched', a: a};
	};
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var author$project$Components$SimplifiedRequest$List$fetchSimplifiedRequestCmd = author$project$Utils$Command$msgToElmCmd(author$project$Components$SimplifiedRequest$List$FetchSimplifiedRequest);
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var author$project$Utils$Http$Range$calcRange = F2(
		function (_n0, _n1) {
			var itemsBy = _n0.a;
			var page = _n1.a;
			var x = page * itemsBy;
			var y = (x + itemsBy) - 1;
			return A2(
				elm$core$String$join,
				'-',
				A2(
					elm$core$List$map,
					elm$core$String$fromInt,
					_List_fromArray(
						[x, y])));
		});
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var author$project$Components$SimplifiedRequest$List$update = F3(
		function (apiUrl, msg, model) {
			switch (msg.$) {
				case 'FetchSimplifiedRequest':
					var uri = _Utils_ap(
						apiUrl,
						author$project$Components$HttpPathDirectory$listRequestsPath(
							A2(author$project$Utils$Http$Range$calcRange, model.itemsByPage, model.page)));
					var cmd = author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							uri,
							A2(elm$http$Http$expectJson, author$project$Components$SimplifiedRequest$List$SimplifiedRequestFetched, author$project$Binding$SimplifiedRequestSearchDecoder$simplifiedRequestSearchItemsDecoder)));
					return _Utils_Tuple2(model, cmd);
				case 'SimplifiedRequestFetched':
					var result = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								result: A2(elm$core$Result$withDefault, _List_Nil, result)
							}),
						elm$core$Platform$Cmd$none);
				case 'ShowDetail':
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				default:
					var page = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{page: page}),
						author$project$Components$SimplifiedRequest$List$fetchSimplifiedRequestCmd);
			}
		});
	var elm$core$Platform$Cmd$map = _Platform_map;
	var author$project$SimplifiedRequest$update = F2(
		function (msg, model) {
			var listMsg = msg.a;
			var _n1 = A3(author$project$Components$SimplifiedRequest$List$update, model.apiUrl, listMsg, model.list);
			var nestedModel = _n1.a;
			var cmd = _n1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{list: nestedModel}),
				elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(elm$core$Platform$Cmd$map, author$project$SimplifiedRequest$ListMsg, cmd)
						])));
		});
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var author$project$Components$CategoryIcons$getMDIconClasses = F2(
		function (icons, iconId) {
			var t = function (i) {
				return _Utils_Tuple2(
					A2(
						elm$core$Maybe$withDefault,
						'',
						A2(elm$core$Dict$get, i, icons)),
					true);
			};
			return _List_fromArray(
				[
					t('default'),
					t(iconId),
					t('md')
				]);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$i = rtfeldman$elm_css$Html$Styled$node('i');
	var elm$json$Json$Encode$string = _Json_wrap;
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$class = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
	var rtfeldman$elm_css$Html$Styled$Attributes$classList = function (classes) {
		return rtfeldman$elm_css$Html$Styled$Attributes$class(
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$map,
					elm$core$Tuple$first,
					A2(elm$core$List$filter, elm$core$Tuple$second, classes))));
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$title = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
	var author$project$Components$SimplifiedRequest$List$getIcon = F2(
		function (iconLabel, icons) {
			return A2(
				rtfeldman$elm_css$Html$Styled$i,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$classList(icons),
						rtfeldman$elm_css$Html$Styled$Attributes$title(iconLabel)
					]),
				_List_Nil);
		});
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$String$fromList = _String_fromList;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var author$project$Components$SimplifiedRequest$List$placeElemInBox = rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$width(
				rtfeldman$elm_css$Css$pct(50))
			]));
	var author$project$Components$SimplifiedRequest$List$showCategoryState = function (state) {
		switch (state.$) {
			case 'Declared':
				return 'À traiter';
			case 'Seen':
				return 'En cours de traitement';
			default:
				return 'Qualifée';
		}
	};
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var elm$core$String$length = _String_length;
	var elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
	var elm$core$String$repeatHelp = F3(
		function (n, chunk, result) {
			return (n <= 0) ? result : A3(
				elm$core$String$repeatHelp,
				n >> 1,
				_Utils_ap(chunk, chunk),
				(!(n & 1)) ? result : _Utils_ap(result, chunk));
		});
	var elm$core$String$repeat = F2(
		function (n, chunk) {
			return A3(elm$core$String$repeatHelp, n, chunk, '');
		});
	var elm$core$String$padLeft = F3(
		function (n, _char, string) {
			return _Utils_ap(
				A2(
					elm$core$String$repeat,
					n - elm$core$String$length(string),
					elm$core$String$fromChar(_char)),
				string);
		});
	var author$project$Utils$Date$DateUtils$formatTimeElement = function (i) {
		return A3(
			elm$core$String$padLeft,
			2,
			_Utils_chr('0'),
			elm$core$String$fromInt(i));
	};
	var author$project$Utils$Date$DateUtils$monthToNum = function (m) {
		switch (m.$) {
			case 'Jan':
				return 1;
			case 'Feb':
				return 2;
			case 'Mar':
				return 3;
			case 'Apr':
				return 4;
			case 'May':
				return 5;
			case 'Jun':
				return 6;
			case 'Jul':
				return 7;
			case 'Aug':
				return 8;
			case 'Sep':
				return 9;
			case 'Oct':
				return 10;
			case 'Nov':
				return 11;
			default:
				return 12;
		}
	};
	var elm$time$Time$flooredDiv = F2(
		function (numerator, denominator) {
			return elm$core$Basics$floor(numerator / denominator);
		});
	var elm$time$Time$posixToMillis = function (_n0) {
		var millis = _n0.a;
		return millis;
	};
	var elm$time$Time$toAdjustedMinutesHelp = F3(
		function (defaultOffset, posixMinutes, eras) {
			toAdjustedMinutesHelp:
			while (true) {
				if (!eras.b) {
					return posixMinutes + defaultOffset;
				} else {
					var era = eras.a;
					var olderEras = eras.b;
					if (_Utils_cmp(era.start, posixMinutes) < 0) {
						return posixMinutes + era.offset;
					} else {
						var $temp$defaultOffset = defaultOffset,
							$temp$posixMinutes = posixMinutes,
							$temp$eras = olderEras;
						defaultOffset = $temp$defaultOffset;
						posixMinutes = $temp$posixMinutes;
						eras = $temp$eras;
						continue toAdjustedMinutesHelp;
					}
				}
			}
		});
	var elm$time$Time$toAdjustedMinutes = F2(
		function (_n0, time) {
			var defaultOffset = _n0.a;
			var eras = _n0.b;
			return A3(
				elm$time$Time$toAdjustedMinutesHelp,
				defaultOffset,
				A2(
					elm$time$Time$flooredDiv,
					elm$time$Time$posixToMillis(time),
					60000),
				eras);
		});
	var elm$core$Basics$ge = _Utils_ge;
	var elm$time$Time$toCivil = function (minutes) {
		var rawDay = A2(elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
		var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
		var dayOfEra = rawDay - (era * 146097);
		var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
		var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
		var mp = (((5 * dayOfYear) + 2) / 153) | 0;
		var month = mp + ((mp < 10) ? 3 : (-9));
		var year = yearOfEra + (era * 400);
		return {
			day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
			month: month,
			year: year + ((month <= 2) ? 1 : 0)
		};
	};
	var elm$time$Time$toDay = F2(
		function (zone, time) {
			return elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).day;
		});
	var elm$time$Time$toHour = F2(
		function (zone, time) {
			return A2(
				elm$core$Basics$modBy,
				24,
				A2(
					elm$time$Time$flooredDiv,
					A2(elm$time$Time$toAdjustedMinutes, zone, time),
					60));
		});
	var elm$time$Time$toMinute = F2(
		function (zone, time) {
			return A2(
				elm$core$Basics$modBy,
				60,
				A2(elm$time$Time$toAdjustedMinutes, zone, time));
		});
	var elm$time$Time$Aug = {$: 'Aug'};
	var elm$time$Time$Dec = {$: 'Dec'};
	var elm$time$Time$Feb = {$: 'Feb'};
	var elm$time$Time$Jul = {$: 'Jul'};
	var elm$time$Time$Jun = {$: 'Jun'};
	var elm$time$Time$May = {$: 'May'};
	var elm$time$Time$Nov = {$: 'Nov'};
	var elm$time$Time$toMonth = F2(
		function (zone, time) {
			var _n0 = elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).month;
			switch (_n0) {
				case 1:
					return elm$time$Time$Jan;
				case 2:
					return elm$time$Time$Feb;
				case 3:
					return elm$time$Time$Mar;
				case 4:
					return elm$time$Time$Apr;
				case 5:
					return elm$time$Time$May;
				case 6:
					return elm$time$Time$Jun;
				case 7:
					return elm$time$Time$Jul;
				case 8:
					return elm$time$Time$Aug;
				case 9:
					return elm$time$Time$Sep;
				case 10:
					return elm$time$Time$Oct;
				case 11:
					return elm$time$Time$Nov;
				default:
					return elm$time$Time$Dec;
			}
		});
	var elm$time$Time$toYear = F2(
		function (zone, time) {
			return elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).year;
		});
	var author$project$Utils$Date$DateUtils$posixToHumanDate = F2(
		function (zone, posix) {
			var y = elm$core$String$fromInt(
				A2(elm$time$Time$toYear, zone, posix));
			var mi = author$project$Utils$Date$DateUtils$formatTimeElement(
				A2(elm$time$Time$toMinute, zone, posix));
			var m = author$project$Utils$Date$DateUtils$formatTimeElement(
				author$project$Utils$Date$DateUtils$monthToNum(
					A2(elm$time$Time$toMonth, zone, posix)));
			var h = author$project$Utils$Date$DateUtils$formatTimeElement(
				A2(elm$time$Time$toHour, zone, posix));
			var d = author$project$Utils$Date$DateUtils$formatTimeElement(
				A2(elm$time$Time$toDay, zone, posix));
			return A2(
				elm$core$String$join,
				' à ',
				_List_fromArray(
					[
						A2(
						elm$core$String$join,
						'/',
						_List_fromArray(
							[d, m, y])),
						A2(
						elm$core$String$join,
						':',
						_List_fromArray(
							[h, mi]))
					]));
		});
	var elm$parser$Parser$DeadEnd = F3(
		function (row, col, problem) {
			return {col: col, problem: problem, row: row};
		});
	var elm$parser$Parser$problemToDeadEnd = function (p) {
		return A3(elm$parser$Parser$DeadEnd, p.row, p.col, p.problem);
	};
	var elm$parser$Parser$Advanced$bagToList = F2(
		function (bag, list) {
			bagToList:
			while (true) {
				switch (bag.$) {
					case 'Empty':
						return list;
					case 'AddRight':
						var bag1 = bag.a;
						var x = bag.b;
						var $temp$bag = bag1,
							$temp$list = A2(elm$core$List$cons, x, list);
						bag = $temp$bag;
						list = $temp$list;
						continue bagToList;
					default:
						var bag1 = bag.a;
						var bag2 = bag.b;
						var $temp$bag = bag1,
							$temp$list = A2(elm$parser$Parser$Advanced$bagToList, bag2, list);
						bag = $temp$bag;
						list = $temp$list;
						continue bagToList;
				}
			}
		});
	var elm$parser$Parser$Advanced$run = F2(
		function (_n0, src) {
			var parse = _n0.a;
			var _n1 = parse(
				{col: 1, context: _List_Nil, indent: 1, offset: 0, row: 1, src: src});
			if (_n1.$ === 'Good') {
				var value = _n1.b;
				return elm$core$Result$Ok(value);
			} else {
				var bag = _n1.b;
				return elm$core$Result$Err(
					A2(elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
			}
		});
	var elm$parser$Parser$run = F2(
		function (parser, source) {
			var _n0 = A2(elm$parser$Parser$Advanced$run, parser, source);
			if (_n0.$ === 'Ok') {
				var a = _n0.a;
				return elm$core$Result$Ok(a);
			} else {
				var problems = _n0.a;
				return elm$core$Result$Err(
					A2(elm$core$List$map, elm$parser$Parser$problemToDeadEnd, problems));
			}
		});
	var elm$parser$Parser$Advanced$Bad = F2(
		function (a, b) {
			return {$: 'Bad', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$Good = F3(
		function (a, b, c) {
			return {$: 'Good', a: a, b: b, c: c};
		});
	var elm$parser$Parser$Advanced$Parser = function (a) {
		return {$: 'Parser', a: a};
	};
	var elm$parser$Parser$Advanced$andThen = F2(
		function (callback, _n0) {
			var parseA = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parseA(s0);
					if (_n1.$ === 'Bad') {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p1 = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						var _n2 = callback(a);
						var parseB = _n2.a;
						var _n3 = parseB(s1);
						if (_n3.$ === 'Bad') {
							var p2 = _n3.a;
							var x = _n3.b;
							return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
						} else {
							var p2 = _n3.a;
							var b = _n3.b;
							var s2 = _n3.c;
							return A3(elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
						}
					}
				});
		});
	var elm$parser$Parser$andThen = elm$parser$Parser$Advanced$andThen;
	var elm$parser$Parser$ExpectingEnd = {$: 'ExpectingEnd'};
	var elm$parser$Parser$Advanced$AddRight = F2(
		function (a, b) {
			return {$: 'AddRight', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$DeadEnd = F4(
		function (row, col, problem, contextStack) {
			return {col: col, contextStack: contextStack, problem: problem, row: row};
		});
	var elm$parser$Parser$Advanced$Empty = {$: 'Empty'};
	var elm$parser$Parser$Advanced$fromState = F2(
		function (s, x) {
			return A2(
				elm$parser$Parser$Advanced$AddRight,
				elm$parser$Parser$Advanced$Empty,
				A4(elm$parser$Parser$Advanced$DeadEnd, s.row, s.col, x, s.context));
		});
	var elm$parser$Parser$Advanced$end = function (x) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return _Utils_eq(
					elm$core$String$length(s.src),
					s.offset) ? A3(elm$parser$Parser$Advanced$Good, false, _Utils_Tuple0, s) : A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, x));
			});
	};
	var elm$parser$Parser$end = elm$parser$Parser$Advanced$end(elm$parser$Parser$ExpectingEnd);
	var elm$core$Basics$always = F2(
		function (a, _n0) {
			return a;
		});
	var elm$parser$Parser$Advanced$map2 = F3(
		function (func, _n0, _n1) {
			var parseA = _n0.a;
			var parseB = _n1.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n2 = parseA(s0);
					if (_n2.$ === 'Bad') {
						var p = _n2.a;
						var x = _n2.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p1 = _n2.a;
						var a = _n2.b;
						var s1 = _n2.c;
						var _n3 = parseB(s1);
						if (_n3.$ === 'Bad') {
							var p2 = _n3.a;
							var x = _n3.b;
							return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
						} else {
							var p2 = _n3.a;
							var b = _n3.b;
							var s2 = _n3.c;
							return A3(
								elm$parser$Parser$Advanced$Good,
								p1 || p2,
								A2(func, a, b),
								s2);
						}
					}
				});
		});
	var elm$parser$Parser$Advanced$ignorer = F2(
		function (keepParser, ignoreParser) {
			return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$always, keepParser, ignoreParser);
		});
	var elm$parser$Parser$ignorer = elm$parser$Parser$Advanced$ignorer;
	var elm$parser$Parser$Advanced$keeper = F2(
		function (parseFunc, parseArg) {
			return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$apL, parseFunc, parseArg);
		});
	var elm$parser$Parser$keeper = elm$parser$Parser$Advanced$keeper;
	var elm$parser$Parser$Advanced$Append = F2(
		function (a, b) {
			return {$: 'Append', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$oneOfHelp = F3(
		function (s0, bag, parsers) {
			oneOfHelp:
			while (true) {
				if (!parsers.b) {
					return A2(elm$parser$Parser$Advanced$Bad, false, bag);
				} else {
					var parse = parsers.a.a;
					var remainingParsers = parsers.b;
					var _n1 = parse(s0);
					if (_n1.$ === 'Good') {
						var step = _n1;
						return step;
					} else {
						var step = _n1;
						var p = step.a;
						var x = step.b;
						if (p) {
							return step;
						} else {
							var $temp$s0 = s0,
								$temp$bag = A2(elm$parser$Parser$Advanced$Append, bag, x),
								$temp$parsers = remainingParsers;
							s0 = $temp$s0;
							bag = $temp$bag;
							parsers = $temp$parsers;
							continue oneOfHelp;
						}
					}
				}
			}
		});
	var elm$parser$Parser$Advanced$oneOf = function (parsers) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A3(elm$parser$Parser$Advanced$oneOfHelp, s, elm$parser$Parser$Advanced$Empty, parsers);
			});
	};
	var elm$parser$Parser$oneOf = elm$parser$Parser$Advanced$oneOf;
	var elm$parser$Parser$Advanced$succeed = function (a) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A3(elm$parser$Parser$Advanced$Good, false, a, s);
			});
	};
	var elm$parser$Parser$succeed = elm$parser$Parser$Advanced$succeed;
	var elm$parser$Parser$ExpectingSymbol = function (a) {
		return {$: 'ExpectingSymbol', a: a};
	};
	var elm$parser$Parser$Advanced$Token = F2(
		function (a, b) {
			return {$: 'Token', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
	var elm$parser$Parser$Advanced$token = function (_n0) {
		var str = _n0.a;
		var expecting = _n0.b;
		var progress = !elm$core$String$isEmpty(str);
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				var _n1 = A5(elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
				var newOffset = _n1.a;
				var newRow = _n1.b;
				var newCol = _n1.c;
				return _Utils_eq(newOffset, -1) ? A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
					elm$parser$Parser$Advanced$Good,
					progress,
					_Utils_Tuple0,
					{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
			});
	};
	var elm$parser$Parser$Advanced$symbol = elm$parser$Parser$Advanced$token;
	var elm$parser$Parser$symbol = function (str) {
		return elm$parser$Parser$Advanced$symbol(
			A2(
				elm$parser$Parser$Advanced$Token,
				str,
				elm$parser$Parser$ExpectingSymbol(str)));
	};
	var elm$core$Basics$round = _Basics_round;
	var elm$core$String$toFloat = _String_toFloat;
	var elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
	var elm$parser$Parser$Advanced$chompWhileHelp = F5(
		function (isGood, offset, row, col, s0) {
			chompWhileHelp:
			while (true) {
				var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
				if (_Utils_eq(newOffset, -1)) {
					return A3(
						elm$parser$Parser$Advanced$Good,
						_Utils_cmp(s0.offset, offset) < 0,
						_Utils_Tuple0,
						{col: col, context: s0.context, indent: s0.indent, offset: offset, row: row, src: s0.src});
				} else {
					if (_Utils_eq(newOffset, -2)) {
						var $temp$isGood = isGood,
							$temp$offset = offset + 1,
							$temp$row = row + 1,
							$temp$col = 1,
							$temp$s0 = s0;
						isGood = $temp$isGood;
						offset = $temp$offset;
						row = $temp$row;
						col = $temp$col;
						s0 = $temp$s0;
						continue chompWhileHelp;
					} else {
						var $temp$isGood = isGood,
							$temp$offset = newOffset,
							$temp$row = row,
							$temp$col = col + 1,
							$temp$s0 = s0;
						isGood = $temp$isGood;
						offset = $temp$offset;
						row = $temp$row;
						col = $temp$col;
						s0 = $temp$s0;
						continue chompWhileHelp;
					}
				}
			}
		});
	var elm$parser$Parser$Advanced$chompWhile = function (isGood) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A5(elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.offset, s.row, s.col, s);
			});
	};
	var elm$parser$Parser$chompWhile = elm$parser$Parser$Advanced$chompWhile;
	var elm$core$String$slice = _String_slice;
	var elm$parser$Parser$Advanced$mapChompedString = F2(
		function (func, _n0) {
			var parse = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parse(s0);
					if (_n1.$ === 'Bad') {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						return A3(
							elm$parser$Parser$Advanced$Good,
							p,
							A2(
								func,
								A3(elm$core$String$slice, s0.offset, s1.offset, s0.src),
								a),
							s1);
					}
				});
		});
	var elm$parser$Parser$Advanced$getChompedString = function (parser) {
		return A2(elm$parser$Parser$Advanced$mapChompedString, elm$core$Basics$always, parser);
	};
	var elm$parser$Parser$getChompedString = elm$parser$Parser$Advanced$getChompedString;
	var elm$parser$Parser$Problem = function (a) {
		return {$: 'Problem', a: a};
	};
	var elm$parser$Parser$Advanced$problem = function (x) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, x));
			});
	};
	var elm$parser$Parser$problem = function (msg) {
		return elm$parser$Parser$Advanced$problem(
			elm$parser$Parser$Problem(msg));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
		elm$parser$Parser$andThen,
		function (str) {
			if (elm$core$String$length(str) <= 9) {
				var _n0 = elm$core$String$toFloat('0.' + str);
				if (_n0.$ === 'Just') {
					var floatVal = _n0.a;
					return elm$parser$Parser$succeed(
						elm$core$Basics$round(floatVal * 1000));
				} else {
					return elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
				}
			} else {
				return elm$parser$Parser$problem(
					'Expected at most 9 digits, but got ' + elm$core$String$fromInt(
						elm$core$String$length(str)));
			}
		},
		elm$parser$Parser$getChompedString(
			elm$parser$Parser$chompWhile(elm$core$Char$isDigit)));
	var elm$time$Time$Posix = function (a) {
		return {$: 'Posix', a: a};
	};
	var elm$time$Time$millisToPosix = elm$time$Time$Posix;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
		function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
			return elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
		});
	var elm$core$String$toInt = _String_toInt;
	var elm$parser$Parser$Done = function (a) {
		return {$: 'Done', a: a};
	};
	var elm$parser$Parser$Loop = function (a) {
		return {$: 'Loop', a: a};
	};
	var elm$parser$Parser$UnexpectedChar = {$: 'UnexpectedChar'};
	var elm$parser$Parser$Advanced$chompIf = F2(
		function (isGood, expecting) {
			return elm$parser$Parser$Advanced$Parser(
				function (s) {
					var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
					return _Utils_eq(newOffset, -1) ? A2(
						elm$parser$Parser$Advanced$Bad,
						false,
						A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
						elm$parser$Parser$Advanced$Good,
						true,
						_Utils_Tuple0,
						{col: 1, context: s.context, indent: s.indent, offset: s.offset + 1, row: s.row + 1, src: s.src}) : A3(
						elm$parser$Parser$Advanced$Good,
						true,
						_Utils_Tuple0,
						{col: s.col + 1, context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src}));
				});
		});
	var elm$parser$Parser$chompIf = function (isGood) {
		return A2(elm$parser$Parser$Advanced$chompIf, isGood, elm$parser$Parser$UnexpectedChar);
	};
	var elm$parser$Parser$Advanced$map = F2(
		function (func, _n0) {
			var parse = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parse(s0);
					if (_n1.$ === 'Good') {
						var p = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						return A3(
							elm$parser$Parser$Advanced$Good,
							p,
							func(a),
							s1);
					} else {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					}
				});
		});
	var elm$parser$Parser$map = elm$parser$Parser$Advanced$map;
	var elm$parser$Parser$Advanced$Done = function (a) {
		return {$: 'Done', a: a};
	};
	var elm$parser$Parser$Advanced$Loop = function (a) {
		return {$: 'Loop', a: a};
	};
	var elm$parser$Parser$toAdvancedStep = function (step) {
		if (step.$ === 'Loop') {
			var s = step.a;
			return elm$parser$Parser$Advanced$Loop(s);
		} else {
			var a = step.a;
			return elm$parser$Parser$Advanced$Done(a);
		}
	};
	var elm$parser$Parser$Advanced$loopHelp = F4(
		function (p, state, callback, s0) {
			loopHelp:
			while (true) {
				var _n0 = callback(state);
				var parse = _n0.a;
				var _n1 = parse(s0);
				if (_n1.$ === 'Good') {
					var p1 = _n1.a;
					var step = _n1.b;
					var s1 = _n1.c;
					if (step.$ === 'Loop') {
						var newState = step.a;
						var $temp$p = p || p1,
							$temp$state = newState,
							$temp$callback = callback,
							$temp$s0 = s1;
						p = $temp$p;
						state = $temp$state;
						callback = $temp$callback;
						s0 = $temp$s0;
						continue loopHelp;
					} else {
						var result = step.a;
						return A3(elm$parser$Parser$Advanced$Good, p || p1, result, s1);
					}
				} else {
					var p1 = _n1.a;
					var x = _n1.b;
					return A2(elm$parser$Parser$Advanced$Bad, p || p1, x);
				}
			}
		});
	var elm$parser$Parser$Advanced$loop = F2(
		function (state, callback) {
			return elm$parser$Parser$Advanced$Parser(
				function (s) {
					return A4(elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
				});
		});
	var elm$parser$Parser$loop = F2(
		function (state, callback) {
			return A2(
				elm$parser$Parser$Advanced$loop,
				state,
				function (s) {
					return A2(
						elm$parser$Parser$map,
						elm$parser$Parser$toAdvancedStep,
						callback(s));
				});
		});
	var rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
		var helper = function (str) {
			if (_Utils_eq(
				elm$core$String$length(str),
				quantity)) {
				var _n0 = elm$core$String$toInt(str);
				if (_n0.$ === 'Just') {
					var intVal = _n0.a;
					return A2(
						elm$parser$Parser$map,
						elm$parser$Parser$Done,
						elm$parser$Parser$succeed(intVal));
				} else {
					return elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
				}
			} else {
				return A2(
					elm$parser$Parser$map,
					function (nextChar) {
						return elm$parser$Parser$Loop(
							A2(elm$core$String$append, str, nextChar));
					},
					elm$parser$Parser$getChompedString(
						elm$parser$Parser$chompIf(elm$core$Char$isDigit)));
			}
		};
		return A2(elm$parser$Parser$loop, '', helper);
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
		return elm$parser$Parser$problem(
			'Invalid day: ' + elm$core$String$fromInt(day));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
		return (!A2(elm$core$Basics$modBy, 4, year)) && (A2(elm$core$Basics$modBy, 100, year) || (!A2(elm$core$Basics$modBy, 400, year)));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
		var y = y1 - 1;
		return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_n0) {
		var year = _n0.a;
		var month = _n0.b;
		var dayInMonth = _n0.c;
		if (dayInMonth < 0) {
			return rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
		} else {
			var succeedWith = function (extraMs) {
				var yearMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
				var days = ((month < 3) || (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
				var dayMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + (rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
				return elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
			};
			switch (month) {
				case 1:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
				case 2:
					return ((dayInMonth > 29) || ((dayInMonth === 29) && (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
				case 3:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
				case 4:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
				case 5:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
				case 6:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
				case 7:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
				case 8:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
				case 9:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
				case 10:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
				case 11:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
				case 12:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
				default:
					return elm$parser$Parser$problem(
						'Invalid month: \"' + (elm$core$String$fromInt(month) + '\"'));
			}
		}
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
		elm$parser$Parser$andThen,
		rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						F3(
							function (year, month, day) {
								return _Utils_Tuple3(year, month, day);
							})),
					rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(elm$core$Basics$identity),
								elm$parser$Parser$symbol('-')),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
						]))),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(elm$core$Basics$identity),
							elm$parser$Parser$symbol('-')),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))));
	var rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
		var utcOffsetMinutesFromParts = F3(
			function (multiplier, hours, minutes) {
				return (multiplier * (hours * 60)) + minutes;
			});
		return A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$map,
						function (_n0) {
							return 0;
						},
						elm$parser$Parser$symbol('Z')),
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$keeper,
								elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
								elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											elm$parser$Parser$map,
											function (_n1) {
												return 1;
											},
											elm$parser$Parser$symbol('+')),
											A2(
											elm$parser$Parser$map,
											function (_n2) {
												return -1;
											},
											elm$parser$Parser$symbol('-'))
										]))),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$succeed(elm$core$Basics$identity),
										elm$parser$Parser$symbol(':')),
									rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
									rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
									elm$parser$Parser$succeed(0)
								]))),
						A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(0),
						elm$parser$Parser$end)
					])));
	}();
	var rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
		elm$parser$Parser$andThen,
		function (datePart) {
			return elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$keeper,
								A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											elm$parser$Parser$succeed(
												rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
											elm$parser$Parser$symbol('T')),
										rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
									elm$parser$Parser$oneOf(
										_List_fromArray(
											[
												A2(
												elm$parser$Parser$keeper,
												A2(
													elm$parser$Parser$ignorer,
													elm$parser$Parser$succeed(elm$core$Basics$identity),
													elm$parser$Parser$symbol(':')),
												rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
												rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
											]))),
								elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											elm$parser$Parser$keeper,
											A2(
												elm$parser$Parser$ignorer,
												elm$parser$Parser$succeed(elm$core$Basics$identity),
												elm$parser$Parser$symbol(':')),
											rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											elm$parser$Parser$succeed(elm$core$Basics$identity),
											elm$parser$Parser$symbol('.')),
										rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
										elm$parser$Parser$succeed(0)
									]))),
						A2(elm$parser$Parser$ignorer, rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, elm$parser$Parser$end)),
						A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(
							A6(rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
						elm$parser$Parser$end)
					]));
		},
		rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
	var rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
		return A2(elm$parser$Parser$run, rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
	};
	var author$project$Utils$Date$DateUtils$printHumanDate = F2(
		function (zone, dIso8601) {
			var resultD = rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dIso8601);
			if (resultD.$ === 'Ok') {
				var posix = resultD.a;
				return A2(author$project$Utils$Date$DateUtils$posixToHumanDate, zone, posix);
			} else {
				return '';
			}
		});
	var rtfeldman$elm_css$Css$Internal$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
		return {$: 'ApplyStyles', a: a};
	};
	var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
		function (functionName, desiredKey, style) {
			getOverloadedProperty:
			while (true) {
				switch (style.$) {
					case 'AppendProperty':
						var str = style.a;
						var key = A2(
							elm$core$Maybe$withDefault,
							'',
							elm$core$List$head(
								A2(elm$core$String$split, ':', str)));
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
					case 'ExtendSelector':
						var selector = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
					case 'NestSnippet':
						var combinator = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
					case 'WithPseudoElement':
						var pseudoElement = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
					case 'WithMedia':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
					case 'WithKeyframes':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
					default:
						if (!style.a.b) {
							return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
						} else {
							if (!style.a.b.b) {
								var _n1 = style.a;
								var only = _n1.a;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = only;
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							} else {
								var _n2 = style.a;
								var first = _n2.a;
								var rest = _n2.b;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							}
						}
				}
			}
		});
	var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
	var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
	var rtfeldman$elm_css$Css$alignItems = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'alignItems',
			'align-items',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
		if (expression.$ === 'Addition') {
			return '+';
		} else {
			return '-';
		}
	};
	var rtfeldman$elm_css$Css$cssFunction = F2(
		function (funcName, args) {
			return funcName + ('(' + (A2(elm$core$String$join, ', ', args) + ')'));
		});
	var rtfeldman$elm_css$Css$calc = F3(
		function (firstExpr, expression, secondExpr) {
			var withoutCalcStr = function (l) {
				return A2(elm$core$String$startsWith, 'calc(', l.value) ? A2(elm$core$String$dropLeft, 4, l.value) : l.value;
			};
			var calcs = A2(
				elm$core$String$join,
				' ',
				_List_fromArray(
					[
						withoutCalcStr(firstExpr),
						rtfeldman$elm_css$Css$calcExpressionToString(expression),
						withoutCalcStr(secondExpr)
					]));
			var value = A2(
				rtfeldman$elm_css$Css$cssFunction,
				'calc',
				_List_fromArray(
					[calcs]));
			return {calc: rtfeldman$elm_css$Css$Structure$Compatible, flexBasis: rtfeldman$elm_css$Css$Structure$Compatible, fontSize: rtfeldman$elm_css$Css$Structure$Compatible, length: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, textIndent: rtfeldman$elm_css$Css$Structure$Compatible, value: value};
		});
	var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
	var rtfeldman$elm_css$Css$flexWrap = rtfeldman$elm_css$Css$prop1('flex-wrap');
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Basics$pow = _Basics_pow;
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$Subtraction = {$: 'Subtraction'};
	var rtfeldman$elm_css$Css$minus = rtfeldman$elm_css$Css$Subtraction;
	var rtfeldman$elm_css$Css$prop2 = F3(
		function (key, argA, argB) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value])));
		});
	var rtfeldman$elm_css$Css$padding2 = rtfeldman$elm_css$Css$prop2('padding');
	var rtfeldman$elm_css$Css$paddingLeft = rtfeldman$elm_css$Css$prop1('padding-left');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var rtfeldman$elm_css$Css$wrap = {flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, flexWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'wrap'};
	var rtfeldman$elm_css$Html$Styled$a = rtfeldman$elm_css$Html$Styled$node('a');
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
		return A2(rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
	};
	var author$project$Components$SimplifiedRequest$List$displaySR = F3(
		function (zone, getIcons, item) {
			return A2(
				rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A3(
								rtfeldman$elm_css$Css$border3,
								rtfeldman$elm_css$Css$px(1),
								rtfeldman$elm_css$Css$solid,
								rtfeldman$elm_css$Css$hex('#DADADA')),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('#FFF')),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(30)),
								A2(
								rtfeldman$elm_css$Css$padding2,
								rtfeldman$elm_css$Css$px(10),
								rtfeldman$elm_css$Css$px(30)),
								rtfeldman$elm_css$Css$width(
								rtfeldman$elm_css$Css$pct(50)),
								rtfeldman$elm_css$Css$displayFlex,
								rtfeldman$elm_css$Css$flexWrap(rtfeldman$elm_css$Css$wrap),
								rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center),
								rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer)
							])),
						rtfeldman$elm_css$Html$Styled$Attributes$href('/simplifiedrequests/' + item.uid)
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$width(
										rtfeldman$elm_css$Css$px(48))
									]))
							]),
						_List_fromArray(
							[
								A2(
								author$project$Components$SimplifiedRequest$List$getIcon,
								item.category.label,
								getIcons(item.category.iconId))
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$width(
										A3(
											rtfeldman$elm_css$Css$calc,
											rtfeldman$elm_css$Css$pct(50),
											rtfeldman$elm_css$Css$minus,
											rtfeldman$elm_css$Css$px(48))),
										rtfeldman$elm_css$Css$paddingLeft(
										rtfeldman$elm_css$Css$px(10))
									]))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(item.category.label)
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[author$project$Components$SimplifiedRequest$List$placeElemInBox]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(item.patrimony.name)
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[author$project$Components$SimplifiedRequest$List$placeElemInBox]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(
								author$project$Components$SimplifiedRequest$List$showCategoryState(item.state))
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[author$project$Components$SimplifiedRequest$List$placeElemInBox]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(
								A2(author$project$Utils$Date$DateUtils$printHumanDate, zone, item.requestDate))
							]))
					]));
		});
	var author$project$Components$SimplifiedRequest$List$ChangePage = function (a) {
		return {$: 'ChangePage', a: a};
	};
	var author$project$Utils$Http$Range$nextPage = function (_n0) {
		var page = _n0.a;
		return author$project$Utils$Http$Range$PrivatePageNumber(page + 1);
	};
	var author$project$Utils$Http$Range$pageNumberSafeValue = function (_n0) {
		var i = _n0.a;
		return i;
	};
	var author$project$Utils$Http$Range$ShouldBePositiveInt = {$: 'ShouldBePositiveInt'};
	var author$project$Utils$Http$Range$pageNumber = function (i) {
		return (i >= 0) ? elm$core$Result$Ok(
			author$project$Utils$Http$Range$PrivatePageNumber(i)) : elm$core$Result$Err(author$project$Utils$Http$Range$ShouldBePositiveInt);
	};
	var author$project$Utils$Http$Range$previousPage = function (_n0) {
		var page = _n0.a;
		return A2(
			elm$core$Result$withDefault,
			author$project$Utils$Http$Range$PrivatePageNumber(page),
			author$project$Utils$Http$Range$pageNumber(page - 1));
	};
	var rtfeldman$elm_css$Css$display = rtfeldman$elm_css$Css$prop1('display');
	var rtfeldman$elm_css$Css$inlineBlock = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'inline-block'};
	var rtfeldman$elm_css$Css$textAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'textAlign',
			'text-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
	var rtfeldman$elm_css$Html$Styled$span = rtfeldman$elm_css$Html$Styled$node('span');
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$Components$SimplifiedRequest$List$paginationView = function (model) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$width(
							rtfeldman$elm_css$Css$pct(50)),
							rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Components$SimplifiedRequest$List$ChangePage(
								author$project$Utils$Http$Range$previousPage(model.page)))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('<<')
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$inlineBlock),
									rtfeldman$elm_css$Css$width(
									rtfeldman$elm_css$Css$px(160))
								]))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(
							'page ' + elm$core$String$fromInt(
								author$project$Utils$Http$Range$pageNumberSafeValue(model.page) + 1))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$Components$SimplifiedRequest$List$ChangePage(
								author$project$Utils$Http$Range$nextPage(model.page)))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('>>')
						]))
				]));
	};
	var author$project$Components$SimplifiedRequest$List$view = F2(
		function (getIcons, model) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					A2(author$project$Components$SimplifiedRequest$List$displaySR, model.timezone, getIcons),
					model.result),
				A2(
					elm$core$List$cons,
					author$project$Components$SimplifiedRequest$List$paginationView(model),
					_List_Nil));
		});
	var elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
	var rtfeldman$elm_css$VirtualDom$Styled$KeyedNode = F3(
		function (a, b, c) {
			return {$: 'KeyedNode', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS = F4(
		function (a, b, c, d) {
			return {$: 'KeyedNodeNS', a: a, b: b, c: c, d: d};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
		function (a, b, c, d) {
			return {$: 'NodeNS', a: a, b: b, c: c, d: d};
		});
	var elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
	var rtfeldman$elm_css$VirtualDom$Styled$mapAttribute = F2(
		function (transform, _n0) {
			var prop = _n0.a;
			var styles = _n0.b;
			var classname = _n0.c;
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$mapAttribute, transform, prop),
				styles,
				classname);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$map = F2(
		function (transform, vdomNode) {
			switch (vdomNode.$) {
				case 'Node':
					var elemType = vdomNode.a;
					var properties = vdomNode.b;
					var children = vdomNode.c;
					return A3(
						rtfeldman$elm_css$VirtualDom$Styled$Node,
						elemType,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
							properties),
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$map(transform),
							children));
				case 'NodeNS':
					var ns = vdomNode.a;
					var elemType = vdomNode.b;
					var properties = vdomNode.c;
					var children = vdomNode.d;
					return A4(
						rtfeldman$elm_css$VirtualDom$Styled$NodeNS,
						ns,
						elemType,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
							properties),
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$map(transform),
							children));
				case 'KeyedNode':
					var elemType = vdomNode.a;
					var properties = vdomNode.b;
					var children = vdomNode.c;
					return A3(
						rtfeldman$elm_css$VirtualDom$Styled$KeyedNode,
						elemType,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
							properties),
						A2(
							elm$core$List$map,
							function (_n1) {
								var key = _n1.a;
								var child = _n1.b;
								return _Utils_Tuple2(
									key,
									A2(rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
							},
							children));
				case 'KeyedNodeNS':
					var ns = vdomNode.a;
					var elemType = vdomNode.b;
					var properties = vdomNode.c;
					var children = vdomNode.d;
					return A4(
						rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS,
						ns,
						elemType,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
							properties),
						A2(
							elm$core$List$map,
							function (_n2) {
								var key = _n2.a;
								var child = _n2.b;
								return _Utils_Tuple2(
									key,
									A2(rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
							},
							children));
				default:
					var vdom = vdomNode.a;
					return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
						A2(elm$virtual_dom$VirtualDom$map, transform, vdom));
			}
		});
	var rtfeldman$elm_css$Html$Styled$map = rtfeldman$elm_css$VirtualDom$Styled$map;
	var author$project$SimplifiedRequest$displayList = F2(
		function (getIcon, model) {
			return A2(
				elm$core$List$map,
				rtfeldman$elm_css$Html$Styled$map(author$project$SimplifiedRequest$ListMsg),
				A2(author$project$Components$SimplifiedRequest$List$view, getIcon, model));
		});
	var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var author$project$SimplifiedRequest$view = function (model) {
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$marginTop(
								rtfeldman$elm_css$Css$px(30))
							]))
					]),
				A2(
					author$project$SimplifiedRequest$displayList,
					author$project$Components$CategoryIcons$getMDIconClasses(model.icons),
					model.list)));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$json$Json$Decode$index = _Json_decodeIndex;
	var author$project$SimplifiedRequest$main = elm$browser$Browser$element(
		{init: author$project$SimplifiedRequest$init, subscriptions: author$project$SimplifiedRequest$subscriptions, update: author$project$SimplifiedRequest$update, view: author$project$SimplifiedRequest$view});
	_Platform_export({'SimplifiedRequest':{'init':author$project$SimplifiedRequest$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (icons) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (apiUrl) {
						return elm$json$Json$Decode$succeed(
							{apiUrl: apiUrl, icons: icons});
					},
					A2(elm$json$Json$Decode$field, 'apiUrl', elm$json$Json$Decode$string));
			},
			A2(
				elm$json$Json$Decode$field,
				'icons',
				elm$json$Json$Decode$list(
					A2(
						elm$json$Json$Decode$andThen,
						function (x0) {
							return A2(
								elm$json$Json$Decode$andThen,
								function (x1) {
									return elm$json$Json$Decode$succeed(
										_Utils_Tuple2(x0, x1));
								},
								A2(elm$json$Json$Decode$index, 1, elm$json$Json$Decode$string));
						},
						A2(elm$json$Json$Decode$index, 0, elm$json$Json$Decode$string))))))(0)}});}(this));

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$SimplifiedRequestCountCard$FetchSimplifiedRequestCount = {$: 'FetchSimplifiedRequestCount'};
	var author$project$SimplifiedRequestCountCard$Model = F2(
		function (count, apiUrl) {
			return {apiUrl: apiUrl, count: count};
		});
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var author$project$SimplifiedRequestCountCard$init = function (apiUrl) {
		return _Utils_Tuple2(
			A2(author$project$SimplifiedRequestCountCard$Model, 0, apiUrl),
			author$project$Utils$Command$msgToElmCmd(author$project$SimplifiedRequestCountCard$FetchSimplifiedRequestCount));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$SimplifiedRequestCountCard$subscriptions = function (model) {
		return elm$core$Platform$Sub$none;
	};
	var author$project$Components$HttpPathDirectory$listRequestsPath = function (range) {
		return '/simplifiedrequests?range=' + (range + '&state=Declared&state=Seen');
	};
	var author$project$SimplifiedRequestCountCard$SimplifiedRequestCountFetched = function (a) {
		return {$: 'SimplifiedRequestCountFetched', a: a};
	};
	var author$project$SimplifiedRequestCountCard$dispatch = _Platform_outgoingPort('dispatch', elm$core$Basics$identity);
	var ccapndave$elm_flat_map$Maybe$FlatMap$join = function (mx) {
		if (mx.$ === 'Just') {
			var x = mx.a;
			return x;
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var ccapndave$elm_flat_map$Maybe$FlatMap$flatMap = F2(
		function (f, maybe) {
			return ccapndave$elm_flat_map$Maybe$FlatMap$join(
				A2(elm$core$Maybe$map, f, maybe));
		});
	var elm$core$String$toInt = _String_toInt;
	var elm_community$list_extra$List$Extra$last = function (items) {
		last:
		while (true) {
			if (!items.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!items.b.b) {
					var x = items.a;
					return elm$core$Maybe$Just(x);
				} else {
					var rest = items.b;
					var $temp$items = rest;
					items = $temp$items;
					continue last;
				}
			}
		}
	};
	var author$project$Utils$Http$Headers$contentRange = function (s) {
		var xs = A2(elm$core$String$split, '/', s);
		var total = A2(
			ccapndave$elm_flat_map$Maybe$FlatMap$flatMap,
			elm$core$String$toInt,
			elm_community$list_extra$List$Extra$last(xs));
		return A2(
			elm$core$Maybe$map,
			function (t) {
				return {total: t};
			},
			total);
	};
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var author$project$Utils$Http$Headers$fieldFromContentRangeHeader = F2(
		function (f, m) {
			var contentRangeHeader = A2(elm$core$Dict$get, 'content-range', m.headers);
			return A2(
				elm$core$Maybe$withDefault,
				0,
				A2(
					ccapndave$elm_flat_map$Maybe$FlatMap$flatMap,
					A2(
						elm$core$Basics$composeR,
						author$project$Utils$Http$Headers$contentRange,
						elm$core$Maybe$map(f)),
					contentRangeHeader));
		});
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var author$project$Utils$Http$HttpRequest$expectWhateverResponse = function (toMsg) {
		return A2(
			elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 'BadUrl_':
						var url = response.a;
						return elm$core$Result$Err(
							elm$http$Http$BadUrl(url));
					case 'Timeout_':
						return elm$core$Result$Err(elm$http$Http$Timeout);
					case 'NetworkError_':
						return elm$core$Result$Err(elm$http$Http$NetworkError);
					case 'BadStatus_':
						var metadata = response.a;
						var body = response.b;
						return elm$core$Result$Err(
							elm$http$Http$BadStatus(metadata.statusCode));
					default:
						var metadata = response.a;
						return elm$core$Result$Ok(metadata);
				}
			});
	};
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var elm$json$Json$Encode$null = _Json_encodeNull;
	var author$project$SimplifiedRequestCountCard$update = F2(
		function (msg, model) {
			switch (msg.$) {
				case 'FetchSimplifiedRequestCount':
					var cmd = author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							_Utils_ap(
								model.apiUrl,
								author$project$Components$HttpPathDirectory$listRequestsPath('0-0')),
							author$project$Utils$Http$HttpRequest$expectWhateverResponse(author$project$SimplifiedRequestCountCard$SimplifiedRequestCountFetched)));
					return _Utils_Tuple2(model, cmd);
				case 'SimplifiedRequestCountFetched':
					var result = msg.a;
					var r = A2(
						elm$core$Result$withDefault,
						0,
						A2(
							elm$core$Result$map,
							author$project$Utils$Http$Headers$fieldFromContentRangeHeader(
								function ($) {
									return $.total;
								}),
							result));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{count: r}),
						elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(
						model,
						author$project$SimplifiedRequestCountCard$dispatch(elm$json$Json$Encode$null));
			}
		});
	var author$project$SimplifiedRequestCountCard$Click = {$: 'Click'};
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$Internal$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
		return {$: 'ApplyStyles', a: a};
	};
	var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
		function (functionName, desiredKey, style) {
			getOverloadedProperty:
			while (true) {
				switch (style.$) {
					case 'AppendProperty':
						var str = style.a;
						var key = A2(
							elm$core$Maybe$withDefault,
							'',
							elm$core$List$head(
								A2(elm$core$String$split, ':', str)));
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
					case 'ExtendSelector':
						var selector = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
					case 'NestSnippet':
						var combinator = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
					case 'WithPseudoElement':
						var pseudoElement = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
					case 'WithMedia':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
					case 'WithKeyframes':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
					default:
						if (!style.a.b) {
							return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
						} else {
							if (!style.a.b.b) {
								var _n1 = style.a;
								var only = _n1.a;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = only;
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							} else {
								var _n2 = style.a;
								var first = _n2.a;
								var rest = _n2.b;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							}
						}
				}
			}
		});
	var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
	var rtfeldman$elm_css$Css$alignItems = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'alignItems',
			'align-items',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$alignSelf = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'alignSelf',
			'align-self',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var rtfeldman$elm_css$Css$borderBottom3 = rtfeldman$elm_css$Css$prop3('border-bottom');
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var rtfeldman$elm_css$Css$row = {flexDirection: rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'row'};
	var rtfeldman$elm_css$Css$column = _Utils_update(
		rtfeldman$elm_css$Css$row,
		{value: 'column'});
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var rtfeldman$elm_css$Css$flexDirection = rtfeldman$elm_css$Css$prop1('flex-direction');
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$String$fromList = _String_fromList;
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var rtfeldman$elm_css$Css$textAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'textAlign',
			'text-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$textTransform = rtfeldman$elm_css$Css$prop1('text-transform');
	var rtfeldman$elm_css$Css$uppercase = {textTransform: rtfeldman$elm_css$Css$Structure$Compatible, value: 'uppercase'};
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$map2 = _Json_map2;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var elm$json$Json$Encode$string = _Json_wrap;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$SimplifiedRequestCountCard$view = function (model) {
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A3(
								rtfeldman$elm_css$Css$border3,
								rtfeldman$elm_css$Css$px(1),
								rtfeldman$elm_css$Css$solid,
								rtfeldman$elm_css$Css$hex('#DADADA')),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(30)),
								rtfeldman$elm_css$Css$padding(
								rtfeldman$elm_css$Css$px(10)),
								rtfeldman$elm_css$Css$displayFlex,
								rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$column),
								rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center),
								rtfeldman$elm_css$Css$alignSelf(rtfeldman$elm_css$Css$center),
								rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('#fff'))
							])),
						rtfeldman$elm_css$Html$Styled$Events$onClick(author$project$SimplifiedRequestCountCard$Click)
					]),
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										A3(
										rtfeldman$elm_css$Css$borderBottom3,
										rtfeldman$elm_css$Css$px(1),
										rtfeldman$elm_css$Css$solid,
										rtfeldman$elm_css$Css$hex('#FF5766')),
										rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase),
										rtfeldman$elm_css$Css$padding(
										rtfeldman$elm_css$Css$em(0.5)),
										rtfeldman$elm_css$Css$width(
										rtfeldman$elm_css$Css$pct(100)),
										rtfeldman$elm_css$Css$fontSize(
										rtfeldman$elm_css$Css$px(26)),
										rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
										rtfeldman$elm_css$Css$color(
										rtfeldman$elm_css$Css$hex('#FF5766'))
									]))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text('Demande')
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$padding(
										rtfeldman$elm_css$Css$em(1)),
										rtfeldman$elm_css$Css$fontSize(
										rtfeldman$elm_css$Css$px(16)),
										rtfeldman$elm_css$Css$color(
										rtfeldman$elm_css$Css$hex('#546D79')),
										rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase)
									]))
							]),
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(
								elm$core$String$fromInt(model.count) + ' Demandes')
							]))
					])));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$SimplifiedRequestCountCard$main = elm$browser$Browser$element(
		{init: author$project$SimplifiedRequestCountCard$init, subscriptions: author$project$SimplifiedRequestCountCard$subscriptions, update: author$project$SimplifiedRequestCountCard$update, view: author$project$SimplifiedRequestCountCard$view});
	_Platform_export({'SimplifiedRequestCountCard':{'init':author$project$SimplifiedRequestCountCard$main(elm$json$Json$Decode$string)(0)}});}(this));

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	
	// STRINGS
	
	
	var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
	{
		var smallLength = smallString.length;
		var isGood = offset + smallLength <= bigString.length;
	
		for (var i = 0; isGood && i < smallLength; )
		{
			var code = bigString.charCodeAt(offset);
			isGood =
				smallString[i++] === bigString[offset++]
				&& (
					code === 0x000A /* \n */
						? ( row++, col=1 )
						: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
				)
		}
	
		return _Utils_Tuple3(isGood ? offset : -1, row, col);
	});
	
	
	
	// CHARS
	
	
	var _Parser_isSubChar = F3(function(predicate, offset, string)
	{
		return (
			string.length <= offset
				? -1
				:
			(string.charCodeAt(offset) & 0xF800) === 0xD800
				? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
				:
			(predicate(_Utils_chr(string[offset]))
				? ((string[offset] === '\n') ? -2 : (offset + 1))
				: -1
			)
		);
	});
	
	
	var _Parser_isAsciiCode = F3(function(code, offset, string)
	{
		return string.charCodeAt(offset) === code;
	});
	
	
	
	// NUMBERS
	
	
	var _Parser_chompBase10 = F2(function(offset, string)
	{
		for (; offset < string.length; offset++)
		{
			var code = string.charCodeAt(offset);
			if (code < 0x30 || 0x39 < code)
			{
				return offset;
			}
		}
		return offset;
	});
	
	
	var _Parser_consumeBase = F3(function(base, offset, string)
	{
		for (var total = 0; offset < string.length; offset++)
		{
			var digit = string.charCodeAt(offset) - 0x30;
			if (digit < 0 || base <= digit) break;
			total = base * total + digit;
		}
		return _Utils_Tuple2(offset, total);
	});
	
	
	var _Parser_consumeBase16 = F2(function(offset, string)
	{
		for (var total = 0; offset < string.length; offset++)
		{
			var code = string.charCodeAt(offset);
			if (0x30 <= code && code <= 0x39)
			{
				total = 16 * total + code - 0x30;
			}
			else if (0x41 <= code && code <= 0x46)
			{
				total = 16 * total + code - 55;
			}
			else if (0x61 <= code && code <= 0x66)
			{
				total = 16 * total + code - 87;
			}
			else
			{
				break;
			}
		}
		return _Utils_Tuple2(offset, total);
	});
	
	
	
	// FIND STRING
	
	
	var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
	{
		var newOffset = bigString.indexOf(smallString, offset);
		var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;
	
		while (offset < target)
		{
			var code = bigString.charCodeAt(offset++);
			code === 0x000A /* \n */
				? ( col=1, row++ )
				: ( col++, (code & 0xF800) === 0xD800 && offset++ )
		}
	
		return _Utils_Tuple3(newOffset, row, col);
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed = F2(
		function (a, b) {
			return {$: 'Seed', a: a, b: b};
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$List$cons = _List_cons;
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$next = function (_n0) {
		var state0 = _n0.a;
		var incr = _n0.b;
		return A2(NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
	};
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$initialSeed = function (x) {
		var _n0 = NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(
			A2(NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, 0, 1013904223));
		var state1 = _n0.a;
		var incr = _n0.b;
		var state2 = (state1 + x) >>> 0;
		return NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(
			A2(NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, state2, incr));
	};
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$Seed = function (a) {
		return {$: 'Seed', a: a};
	};
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Array$branchFactor = 32;
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Array$fromListHelp = F3(
		function (list, nodeList, nodeListSize) {
			fromListHelp:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, list);
				var jsArray = _n0.a;
				var remainingItems = _n0.b;
				if (_Utils_cmp(
					elm$core$Elm$JsArray$length(jsArray),
					elm$core$Array$branchFactor) < 0) {
					return A2(
						elm$core$Array$builderToArray,
						true,
						{nodeList: nodeList, nodeListSize: nodeListSize, tail: jsArray});
				} else {
					var $temp$list = remainingItems,
						$temp$nodeList = A2(
						elm$core$List$cons,
						elm$core$Array$Leaf(jsArray),
						nodeList),
						$temp$nodeListSize = nodeListSize + 1;
					list = $temp$list;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue fromListHelp;
				}
			}
		});
	var elm$core$Array$fromList = function (list) {
		if (!list.b) {
			return elm$core$Array$empty;
		} else {
			return A3(elm$core$Array$fromListHelp, list, _List_Nil, 0);
		}
	};
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$initialSeed = F2(
		function (baseSeed, extendedSeed) {
			return NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$Seed(
				{
					base: NoRedInk$elm_random_pcg_extended$Internal$Pcg$initialSeed(baseSeed),
					extension: elm$core$Array$fromList(extendedSeed)
				});
		});
	var author$project$Components$PhotoList$init = _List_Nil;
	var author$project$SimplifiedRequestDetail$FetchDetail = function (a) {
		return {$: 'FetchDetail', a: a};
	};
	var author$project$SimplifiedRequestDetail$Model = F5(
		function (apiUrl, detail, timezone, photos, seed) {
			return {apiUrl: apiUrl, detail: detail, photos: photos, seed: seed, timezone: timezone};
		});
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var elm$time$Time$Jan = {$: 'Jan'};
	var elm$time$Time$Zone = F2(
		function (a, b) {
			return {$: 'Zone', a: a, b: b};
		});
	var elm$time$Time$customZone = elm$time$Time$Zone;
	var justinmimbs$timezone_data$TimeZone$maxYear = 2037;
	var justinmimbs$timezone_data$TimeZone$minYear = 1970;
	var elm$core$Tuple$second = function (_n0) {
		var y = _n0.b;
		return y;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
		function (year, month, day, time, clock) {
			return {clock: clock, day: day, month: month, time: time, year: year};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$Universal = {$: 'Universal'};
	var justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_n0) {
		dropChangesBeforeEpoch:
		while (true) {
			var initial = _n0.a;
			var changes = _n0.b;
			if (changes.b) {
				var change = changes.a;
				var rest = changes.b;
				if (change.start <= 0) {
					var $temp$_n0 = _Utils_Tuple2(change.offset, rest);
					_n0 = $temp$_n0;
					continue dropChangesBeforeEpoch;
				} else {
					return _Utils_Tuple2(initial, changes);
				}
			} else {
				return _Utils_Tuple2(initial, _List_Nil);
			}
		}
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var elm$core$List$sortBy = _List_sortBy;
	var elm$core$Basics$modBy = _Basics_modBy;
	var justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
		var _n0 = A2(elm$core$Basics$modBy, 7, rd);
		if (!_n0) {
			return 7;
		} else {
			var n = _n0;
			return n;
		}
	};
	var justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
		switch (wd.$) {
			case 'Mon':
				return 1;
			case 'Tue':
				return 2;
			case 'Wed':
				return 3;
			case 'Thu':
				return 4;
			case 'Fri':
				return 5;
			case 'Sat':
				return 6;
			default:
				return 7;
		}
	};
	var justinmimbs$timezone_data$RataDie$floorWeekday = F2(
		function (weekday, rd) {
			var daysSincePreviousWeekday = A2(
				elm$core$Basics$modBy,
				7,
				(justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
			return rd - daysSincePreviousWeekday;
		});
	var justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
		function (weekday, rd) {
			var floored = A2(justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
			return _Utils_eq(rd, floored) ? rd : (floored + 7);
		});
	var elm$core$Basics$neq = _Utils_notEqual;
	var justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
		return ((!A2(elm$core$Basics$modBy, 4, y)) && A2(elm$core$Basics$modBy, 100, y)) || (!A2(elm$core$Basics$modBy, 400, y));
	};
	var justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
		function (y, m) {
			var leapDays = justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
			switch (m.$) {
				case 'Jan':
					return 0;
				case 'Feb':
					return 31;
				case 'Mar':
					return 59 + leapDays;
				case 'Apr':
					return 90 + leapDays;
				case 'May':
					return 120 + leapDays;
				case 'Jun':
					return 151 + leapDays;
				case 'Jul':
					return 181 + leapDays;
				case 'Aug':
					return 212 + leapDays;
				case 'Sep':
					return 243 + leapDays;
				case 'Oct':
					return 273 + leapDays;
				case 'Nov':
					return 304 + leapDays;
				default:
					return 334 + leapDays;
			}
		});
	var justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
		var y = y1 - 1;
		var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
		return (365 * y) + leapYears;
	};
	var justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
		function (y, m, d) {
			return (justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2(justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
		});
	var justinmimbs$timezone_data$RataDie$daysInMonth = F2(
		function (y, m) {
			switch (m.$) {
				case 'Jan':
					return 31;
				case 'Feb':
					return justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
				case 'Mar':
					return 31;
				case 'Apr':
					return 30;
				case 'May':
					return 31;
				case 'Jun':
					return 30;
				case 'Jul':
					return 31;
				case 'Aug':
					return 31;
				case 'Sep':
					return 30;
				case 'Oct':
					return 31;
				case 'Nov':
					return 30;
				default:
					return 31;
			}
		});
	var justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
		function (y, m) {
			return (justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2(justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2(justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
		return (rd - 719163) * 1440;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
		function (clock, _n0) {
			var standard = _n0.standard;
			var save = _n0.save;
			switch (clock.$) {
				case 'Universal':
					return 0;
				case 'Standard':
					return 0 - standard;
				default:
					return 0 - (standard + save);
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_n0) {
		var year = _n0.year;
		var month = _n0.month;
		var day = _n0.day;
		var time = _n0.time;
		return justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
			A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
	};
	var justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
		function (offset, datetime) {
			return justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.clock, offset);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
		function (previousOffset, start, until, standardOffset, rules) {
			var transitions = A2(
				elm$core$List$concatMap,
				function (year) {
					return A2(
						elm$core$List$sortBy,
						function ($) {
							return $.start;
						},
						A2(
							elm$core$List$map,
							function (rule) {
								return {
									clock: rule.clock,
									save: rule.save,
									start: justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
										function () {
											var _n2 = rule.day;
											switch (_n2.$) {
												case 'Day':
													var day = _n2.a;
													return A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, day);
												case 'First':
													var weekday = _n2.a;
													var onOrAfterDay = _n2.b;
													return A2(
														justinmimbs$timezone_data$RataDie$ceilingWeekday,
														weekday,
														A3(justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, onOrAfterDay));
												default:
													var weekday = _n2.a;
													return A2(
														justinmimbs$timezone_data$RataDie$floorWeekday,
														weekday,
														A2(justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.month));
											}
										}()) + rule.time
								};
							},
							A2(
								elm$core$List$filter,
								function (rule) {
									return (_Utils_cmp(rule.from, year) < 1) && (_Utils_cmp(year, rule.to) < 1);
								},
								rules)));
				},
				A2(elm$core$List$range, start.year - 1, until.year));
			var initialOffset = {save: 0, standard: standardOffset};
			var initialChange = {
				offset: standardOffset,
				start: A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
			};
			var _n0 = A3(
				elm$core$List$foldl,
				F2(
					function (transition, _n1) {
						var currentOffset = _n1.a;
						var changes = _n1.b;
						var newOffset = {save: transition.save, standard: standardOffset};
						if (_Utils_cmp(
							transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, previousOffset),
							initialChange.start) < 1) {
							var updatedInitialChange = {offset: standardOffset + transition.save, start: initialChange.start};
							return _Utils_Tuple2(
								newOffset,
								_List_fromArray(
									[updatedInitialChange]));
						} else {
							if (_Utils_cmp(
								transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset),
								A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
								var change = {
									offset: standardOffset + transition.save,
									start: transition.start + A2(justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset)
								};
								return _Utils_Tuple2(
									newOffset,
									A2(elm$core$List$cons, change, changes));
							} else {
								return _Utils_Tuple2(currentOffset, changes);
							}
						}
					}),
				_Utils_Tuple2(
					initialOffset,
					_List_fromArray(
						[initialChange])),
				transitions);
			var nextOffset = _n0.a;
			var descendingChanges = _n0.b;
			return _Utils_Tuple2(
				elm$core$List$reverse(descendingChanges),
				nextOffset);
		});
	var justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
		function (previousOffset, start, until, _n0) {
			var standardOffset = _n0.standardOffset;
			var zoneRules = _n0.zoneRules;
			if (zoneRules.$ === 'Save') {
				var save = zoneRules.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							{
							offset: standardOffset + save,
							start: A2(justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
						}
						]),
					{save: save, standard: standardOffset});
			} else {
				var rules = zoneRules.a;
				return A5(justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
		function (f, a, rev, list) {
			stripDuplicatesByHelp:
			while (true) {
				if (!list.b) {
					return elm$core$List$reverse(rev);
				} else {
					var x = list.a;
					var xs = list.b;
					var b = f(x);
					var rev_ = (!_Utils_eq(a, b)) ? A2(elm$core$List$cons, x, rev) : rev;
					var $temp$f = f,
						$temp$a = b,
						$temp$rev = rev_,
						$temp$list = xs;
					f = $temp$f;
					a = $temp$a;
					rev = $temp$rev;
					list = $temp$list;
					continue stripDuplicatesByHelp;
				}
			}
		});
	var justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
		function (zoneStart, zoneUntil, zone) {
			var _n0 = A3(
				elm$core$List$foldl,
				F2(
					function (_n1, _n2) {
						var state = _n1.a;
						var nextStart = _n1.b;
						var start = _n2.a;
						var ranges = _n2.b;
						return _Utils_Tuple2(
							nextStart,
							A2(
								elm$core$List$cons,
								_Utils_Tuple3(start, state, nextStart),
								ranges));
					}),
				_Utils_Tuple2(zoneStart, _List_Nil),
				zone.history);
			var currentStart = _n0.a;
			var historyRanges = _n0.b;
			return elm$core$List$reverse(
				A2(
					elm$core$List$cons,
					_Utils_Tuple3(currentStart, zone.current, zoneUntil),
					historyRanges));
		});
	var justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
		function (minYear, maxYear, zone) {
			var initialState = function () {
				var _n5 = zone.history;
				if (_n5.b) {
					var _n6 = _n5.a;
					var earliest = _n6.a;
					return earliest;
				} else {
					return zone.current;
				}
			}();
			var initialOffset = {
				save: function () {
					var _n4 = initialState.zoneRules;
					if (_n4.$ === 'Save') {
						var save = _n4.a;
						return save;
					} else {
						return 0;
					}
				}(),
				standard: initialState.standardOffset
			};
			var ascendingChanges = A4(
				justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
				function ($) {
					return $.offset;
				},
				initialOffset.standard + initialOffset.save,
				_List_Nil,
				A3(
					elm$core$List$foldl,
					F2(
						function (_n1, _n2) {
							var start = _n1.a;
							var state = _n1.b;
							var until = _n1.c;
							var prevOffset = _n2.a;
							var prevChanges = _n2.b;
							var _n3 = A4(justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
							var nextChanges = _n3.a;
							var nextOffset = _n3.b;
							return _Utils_Tuple2(
								nextOffset,
								_Utils_ap(prevChanges, nextChanges));
						}),
					_Utils_Tuple2(initialOffset, _List_Nil),
					A3(
						justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$Universal),
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$Universal),
						zone)).b);
			var _n0 = justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
				_Utils_Tuple2(initialOffset.standard + initialOffset.save, ascendingChanges));
			var initial = _n0.a;
			var ascending = _n0.b;
			return _Utils_Tuple2(
				elm$core$List$reverse(ascending),
				initial);
		});
	var justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
		var _n0 = A3(justinmimbs$timezone_data$TimeZone$Specification$toOffsets, justinmimbs$timezone_data$TimeZone$minYear, justinmimbs$timezone_data$TimeZone$maxYear, zone);
		var descending = _n0.a;
		var bottom = _n0.b;
		return A2(elm$time$Time$customZone, bottom, descending);
	};
	var elm$time$Time$Apr = {$: 'Apr'};
	var elm$time$Time$Mar = {$: 'Mar'};
	var elm$time$Time$Oct = {$: 'Oct'};
	var elm$time$Time$Sep = {$: 'Sep'};
	var elm$time$Time$Sun = {$: 'Sun'};
	var justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
		return {$: 'Day', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$First = F2(
		function (a, b) {
			return {$: 'First', a: a, b: b};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
		return {$: 'Last', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
		function (from, to, month, day, time, clock, save) {
			return {clock: clock, day: day, from: from, month: month, save: save, time: time, to: to};
		});
	var justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
		[
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1977,
			1980,
			elm$time$Time$Apr,
			A2(justinmimbs$timezone_data$TimeZone$Specification$First, elm$time$Time$Sun, 1),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1977,
			1977,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1978,
			1978,
			elm$time$Time$Oct,
			justinmimbs$timezone_data$TimeZone$Specification$Day(1),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1979,
			1995,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1981,
			justinmimbs$timezone_data$TimeZone$maxYear,
			elm$time$Time$Mar,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1996,
			justinmimbs$timezone_data$TimeZone$maxYear,
			elm$time$Time$Oct,
			justinmimbs$timezone_data$TimeZone$Specification$Last(elm$time$Time$Sun),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$Universal,
			0)
		]);
	var justinmimbs$timezone_data$TimeZone$Specification$WallClock = {$: 'WallClock'};
	var justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
		[
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1976,
			1976,
			elm$time$Time$Mar,
			justinmimbs$timezone_data$TimeZone$Specification$Day(28),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$WallClock,
			60),
			A7(
			justinmimbs$timezone_data$TimeZone$Specification$Rule,
			1976,
			1976,
			elm$time$Time$Sep,
			justinmimbs$timezone_data$TimeZone$Specification$Day(26),
			60,
			justinmimbs$timezone_data$TimeZone$Specification$WallClock,
			0)
		]);
	var justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
		return {$: 'Rules', a: a};
	};
	var justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
		function (history, current) {
			return {current: current, history: history};
		});
	var justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
		function (standardOffset, zoneRules) {
			return {standardOffset: standardOffset, zoneRules: zoneRules};
		});
	var justinmimbs$timezone_data$TimeZone$europe__paris = function (_n0) {
		return justinmimbs$timezone_data$TimeZone$fromSpecification(
			A2(
				justinmimbs$timezone_data$TimeZone$Specification$Zone,
				_List_fromArray(
					[
						_Utils_Tuple2(
						A2(
							justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
							60,
							justinmimbs$timezone_data$TimeZone$Specification$Rules(justinmimbs$timezone_data$TimeZone$rules_France)),
						A5(justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, elm$time$Time$Jan, 1, 0, justinmimbs$timezone_data$TimeZone$Specification$WallClock))
					]),
				A2(
					justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
					60,
					justinmimbs$timezone_data$TimeZone$Specification$Rules(justinmimbs$timezone_data$TimeZone$rules_EU))));
	};
	var author$project$SimplifiedRequestDetail$init = function (flags) {
		var timezone = justinmimbs$timezone_data$TimeZone$europe__paris(_Utils_Tuple0);
		var _n0 = flags.seedInfos;
		var seed = _n0.a;
		var seedExtension = _n0.b;
		var model = A5(
			author$project$SimplifiedRequestDetail$Model,
			flags.apiUrl,
			elm$core$Maybe$Nothing,
			timezone,
			author$project$Components$PhotoList$init,
			A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$initialSeed, seed, seedExtension));
		return _Utils_Tuple2(
			model,
			author$project$Utils$Command$msgToElmCmd(
				author$project$SimplifiedRequestDetail$FetchDetail(flags.requestUid)));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$SimplifiedRequestDetail$subscriptions = function (_n0) {
		return elm$core$Platform$Sub$none;
	};
	var NoRedInk$elm_random_general$Random$General$step = F2(
		function (_n0, seed) {
			var gen = _n0.a;
			return gen(seed);
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$step = NoRedInk$elm_random_general$Random$General$step;
	var NoRedInk$elm_random_general$Random$General$Generator = function (a) {
		return {$: 'Generator', a: a};
	};
	var NoRedInk$elm_random_general$Random$General$map = F2(
		function (func, _n0) {
			var genA = _n0.a;
			return NoRedInk$elm_random_general$Random$General$Generator(
				function (seed0) {
					var _n1 = genA(seed0);
					var a = _n1.a;
					var seed1 = _n1.b;
					return _Utils_Tuple2(
						func(a),
						seed1);
				});
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map = NoRedInk$elm_random_general$Random$General$map;
	var NoRedInk$elm_uuid$Prng$Uuid$Uuid = function (a) {
		return {$: 'Uuid', a: a};
	};
	var NoRedInk$elm_random_general$Random$General$listHelp = F4(
		function (list_, n, generate, seed) {
			listHelp:
			while (true) {
				if (n < 1) {
					return _Utils_Tuple2(list_, seed);
				} else {
					var _n0 = generate(seed);
					var value = _n0.a;
					var newSeed = _n0.b;
					var $temp$list_ = A2(elm$core$List$cons, value, list_),
						$temp$n = n - 1,
						$temp$generate = generate,
						$temp$seed = newSeed;
					list_ = $temp$list_;
					n = $temp$n;
					generate = $temp$generate;
					seed = $temp$seed;
					continue listHelp;
				}
			}
		});
	var NoRedInk$elm_random_general$Random$General$list = F2(
		function (n, _n0) {
			var generate = _n0.a;
			return NoRedInk$elm_random_general$Random$General$Generator(
				function (seed) {
					return A4(NoRedInk$elm_random_general$Random$General$listHelp, _List_Nil, n, generate, seed);
				});
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$list = NoRedInk$elm_random_general$Random$General$list;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$Bitwise$and = _Bitwise_and;
	var NoRedInk$elm_random_general$Random$General$int = F3(
		function (_n0, a, b) {
			var c = _n0.a;
			return NoRedInk$elm_random_general$Random$General$Generator(
				function (seed0) {
					var _n1 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
					var lo = _n1.a;
					var hi = _n1.b;
					var range = (hi - lo) + 1;
					if (!((range - 1) & range)) {
						return _Utils_Tuple2(
							(((range - 1) & c.peel(seed0)) >>> 0) + lo,
							c.next(seed0));
					} else {
						var threshhold = (((-range) >>> 0) % range) >>> 0;
						var accountForBias = function (seed) {
							accountForBias:
							while (true) {
								var x = c.peel(seed);
								var seedN = c.next(seed);
								if (_Utils_cmp(x, threshhold) < 0) {
									var $temp$seed = seedN;
									seed = $temp$seed;
									continue accountForBias;
								} else {
									return _Utils_Tuple2((x % range) + lo, seedN);
								}
							}
						};
						return accountForBias(seed0);
					}
				});
		});
	var NoRedInk$elm_random_general$Random$General$Config = function (a) {
		return {$: 'Config', a: a};
	};
	var NoRedInk$elm_random_general$Random$General$makeConfig = F2(
		function (next, peel) {
			return NoRedInk$elm_random_general$Random$General$Config(
				{next: next, peel: peel});
		});
	var elm$core$Array$bitMask = 4294967295 >>> (32 - elm$core$Array$shiftStep);
	var elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
	var elm$core$Array$getHelp = F3(
		function (shift, index, tree) {
			getHelp:
			while (true) {
				var pos = elm$core$Array$bitMask & (index >>> shift);
				var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, pos, tree);
				if (_n0.$ === 'SubTree') {
					var subTree = _n0.a;
					var $temp$shift = shift - elm$core$Array$shiftStep,
						$temp$index = index,
						$temp$tree = subTree;
					shift = $temp$shift;
					index = $temp$index;
					tree = $temp$tree;
					continue getHelp;
				} else {
					var values = _n0.a;
					return A2(elm$core$Elm$JsArray$unsafeGet, elm$core$Array$bitMask & index, values);
				}
			}
		});
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var elm$core$Array$tailIndex = function (len) {
		return (len >>> 5) << 5;
	};
	var elm$core$Basics$ge = _Utils_ge;
	var elm$core$Array$get = F2(
		function (index, _n0) {
			var len = _n0.a;
			var startShift = _n0.b;
			var tree = _n0.c;
			var tail = _n0.d;
			return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? elm$core$Maybe$Nothing : ((_Utils_cmp(
				index,
				elm$core$Array$tailIndex(len)) > -1) ? elm$core$Maybe$Just(
				A2(elm$core$Elm$JsArray$unsafeGet, elm$core$Array$bitMask & index, tail)) : elm$core$Maybe$Just(
				A3(elm$core$Array$getHelp, startShift, index, tree)));
		});
	var elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
	var elm$core$Array$setHelp = F4(
		function (shift, index, value, tree) {
			var pos = elm$core$Array$bitMask & (index >>> shift);
			var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_n0.$ === 'SubTree') {
				var subTree = _n0.a;
				var newSub = A4(elm$core$Array$setHelp, shift - elm$core$Array$shiftStep, index, value, subTree);
				return A3(
					elm$core$Elm$JsArray$unsafeSet,
					pos,
					elm$core$Array$SubTree(newSub),
					tree);
			} else {
				var values = _n0.a;
				var newLeaf = A3(elm$core$Elm$JsArray$unsafeSet, elm$core$Array$bitMask & index, value, values);
				return A3(
					elm$core$Elm$JsArray$unsafeSet,
					pos,
					elm$core$Array$Leaf(newLeaf),
					tree);
			}
		});
	var elm$core$Array$set = F3(
		function (index, value, array) {
			var len = array.a;
			var startShift = array.b;
			var tree = array.c;
			var tail = array.d;
			return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
				index,
				elm$core$Array$tailIndex(len)) > -1) ? A4(
				elm$core$Array$Array_elm_builtin,
				len,
				startShift,
				tree,
				A3(elm$core$Elm$JsArray$unsafeSet, elm$core$Array$bitMask & index, value, tail)) : A4(
				elm$core$Array$Array_elm_builtin,
				len,
				startShift,
				A4(elm$core$Array$setHelp, startShift, index, value, tree),
				tail));
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtensionHelp = F3(
		function (index, prev, arr) {
			incrementExtensionHelp:
			while (true) {
				if (!prev) {
					var _n0 = A2(elm$core$Array$get, index, arr);
					if (_n0.$ === 'Just') {
						var elem = _n0.a;
						var newElem = (elem + 1013904223) >>> 0;
						var $temp$index = index + 1,
							$temp$prev = newElem,
							$temp$arr = A3(elm$core$Array$set, index, newElem, arr);
						index = $temp$index;
						prev = $temp$prev;
						arr = $temp$arr;
						continue incrementExtensionHelp;
					} else {
						return arr;
					}
				} else {
					return arr;
				}
			}
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtension = function (arr) {
		return A3(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtensionHelp, 0, 0, arr);
	};
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$next = function (_n0) {
		var s = _n0.a;
		var newBase = NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(s.base);
		var baseState = newBase.a;
		return NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$Seed(
			{
				base: newBase,
				extension: (!baseState) ? NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtension(s.extension) : s.extension
			});
	};
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel = function (_n0) {
		var state = _n0.a;
		var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
		return ((word >>> 22) ^ word) >>> 0;
	};
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$config = A2(NoRedInk$elm_random_general$Random$General$makeConfig, NoRedInk$elm_random_pcg_extended$Internal$Pcg$next, NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel);
	var NoRedInk$elm_random_pcg_extended$Internal$Pcg$int = NoRedInk$elm_random_general$Random$General$int(NoRedInk$elm_random_pcg_extended$Internal$Pcg$config);
	var elm$core$Array$length = function (_n0) {
		var len = _n0.a;
		return len;
	};
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$peel = function (_n0) {
		var s = _n0.a;
		var baseOut = NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel(s.base);
		var _n1 = A2(
			NoRedInk$elm_random_general$Random$General$step,
			A2(
				NoRedInk$elm_random_pcg_extended$Internal$Pcg$int,
				0,
				elm$core$Array$length(s.extension) - 1),
			s.base);
		var randIndex = _n1.a;
		var extension = A2(
			elm$core$Maybe$withDefault,
			0,
			A2(elm$core$Array$get, randIndex, s.extension));
		return (baseOut ^ extension) >>> 0;
	};
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$config = A2(NoRedInk$elm_random_general$Random$General$makeConfig, NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$next, NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$peel);
	var NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$int = NoRedInk$elm_random_general$Random$General$int(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$config);
	var NoRedInk$elm_uuid$Prng$Uuid$hexGenerator = A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$int, 0, 15);
	var elm$core$Bitwise$or = _Bitwise_or;
	var NoRedInk$elm_uuid$Prng$Uuid$Barebones$limitDigitRange8ToB = function (digit) {
		return (digit & 3) | 8;
	};
	var elm$core$Char$fromCode = _Char_fromCode;
	var NoRedInk$elm_uuid$Prng$Uuid$Barebones$hexDigits = function () {
		var mapChars = F2(
			function (offset, digit) {
				return elm$core$Char$fromCode(digit + offset);
			});
		return elm$core$Array$fromList(
			_Utils_ap(
				A2(
					elm$core$List$map,
					mapChars(48),
					A2(elm$core$List$range, 0, 9)),
				A2(
					elm$core$List$map,
					mapChars(97),
					A2(elm$core$List$range, 0, 5))));
	}();
	var NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex = function (index) {
		var maybeResult = A2(elm$core$Array$get, index, NoRedInk$elm_uuid$Prng$Uuid$Barebones$hexDigits);
		if (maybeResult.$ === 'Nothing') {
			return _Utils_chr('x');
		} else {
			var result = maybeResult.a;
			return result;
		}
	};
	var elm$core$List$drop = F2(
		function (n, list) {
			drop:
			while (true) {
				if (n <= 0) {
					return list;
				} else {
					if (!list.b) {
						return list;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs;
						n = $temp$n;
						list = $temp$list;
						continue drop;
					}
				}
			}
		});
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var elm$core$String$concat = function (strings) {
		return A2(elm$core$String$join, '', strings);
	};
	var elm$core$String$fromList = _String_fromList;
	var NoRedInk$elm_uuid$Prng$Uuid$Barebones$toUuidString = function (thirtyOneHexDigits) {
		return elm$core$String$concat(
			_List_fromArray(
				[
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(elm$core$List$take, 8, thirtyOneHexDigits))),
					'-',
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$take,
							4,
							A2(elm$core$List$drop, 8, thirtyOneHexDigits)))),
					'-',
					'4',
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$take,
							3,
							A2(elm$core$List$drop, 12, thirtyOneHexDigits)))),
					'-',
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$map,
							NoRedInk$elm_uuid$Prng$Uuid$Barebones$limitDigitRange8ToB,
							A2(
								elm$core$List$take,
								1,
								A2(elm$core$List$drop, 15, thirtyOneHexDigits))))),
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$take,
							3,
							A2(elm$core$List$drop, 16, thirtyOneHexDigits)))),
					'-',
					elm$core$String$fromList(
					A2(
						elm$core$List$map,
						NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
						A2(
							elm$core$List$take,
							12,
							A2(elm$core$List$drop, 19, thirtyOneHexDigits))))
				]));
	};
	var NoRedInk$elm_uuid$Prng$Uuid$stringGenerator = A2(
		NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map,
		NoRedInk$elm_uuid$Prng$Uuid$Barebones$toUuidString,
		A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$list, 31, NoRedInk$elm_uuid$Prng$Uuid$hexGenerator));
	var NoRedInk$elm_uuid$Prng$Uuid$generator = A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map, NoRedInk$elm_uuid$Prng$Uuid$Uuid, NoRedInk$elm_uuid$Prng$Uuid$stringGenerator);
	var elm$json$Json$Encode$object = function (pairs) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				F2(
					function (_n0, obj) {
						var k = _n0.a;
						var v = _n0.b;
						return A3(_Json_addField, k, v, obj);
					}),
				_Json_emptyObject(_Utils_Tuple0),
				pairs));
	};
	var elm$json$Json$Encode$string = _Json_wrap;
	var author$project$Binding$QualifyRequestEncoder$contactInfoEncoder = function (contactInfo) {
		return elm$json$Json$Encode$object(
			function () {
				if (contactInfo.$ === 'Phone') {
					var p = contactInfo.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'contactMediumType',
							elm$json$Json$Encode$string('Phone')),
							_Utils_Tuple2(
							'phone',
							elm$json$Json$Encode$string(p))
						]);
				} else {
					var p = contactInfo.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'contactMediumType',
							elm$json$Json$Encode$string('Mail')),
							_Utils_Tuple2(
							'mail',
							elm$json$Json$Encode$string(p))
						]);
				}
			}());
	};
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var author$project$Binding$QualifyRequestEncoder$contactToCallbackEncoder = function (contact) {
		return A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Maybe$map,
				function (c) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'contactToCallback',
							elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'namez',
										elm$json$Json$Encode$string(c.name)),
										_Utils_Tuple2(
										'medium',
										author$project$Binding$QualifyRequestEncoder$contactInfoEncoder(c.contact))
									])))
						]);
				},
				contact));
	};
	var author$project$Binding$QualifyRequestEncoder$qualifyRequestJsonCmd = function (detail) {
		return A2(
			elm$core$Maybe$map,
			function (uid) {
				return elm$json$Json$Encode$object(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'companyUid',
								elm$json$Json$Encode$string(detail.linkedEntities.company.uid)),
								_Utils_Tuple2(
								'categoryUid',
								elm$json$Json$Encode$string(detail.category.uid)),
								_Utils_Tuple2(
								'patrimonyUid',
								elm$json$Json$Encode$string(detail.linkedEntities.patrimony.uid)),
								_Utils_Tuple2(
								'userUid',
								elm$json$Json$Encode$string(uid)),
								_Utils_Tuple2(
								'request',
								elm$json$Json$Encode$string(detail.description)),
								_Utils_Tuple2(
								'requestUid',
								elm$json$Json$Encode$string(detail.uid))
							]),
						author$project$Binding$QualifyRequestEncoder$contactToCallbackEncoder(detail.contactToCallback)));
			},
			detail.requester.uid);
	};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$decodeValue = _Json_run;
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var elm$json$Json$Decode$value = _Json_decodeValue;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
		function (pathDecoder, valDecoder, fallback) {
			var nullOr = function (decoder) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							decoder,
							elm$json$Json$Decode$null(fallback)
						]));
			};
			var handleResult = function (input) {
				var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
				if (_n0.$ === 'Ok') {
					var rawValue = _n0.a;
					var _n1 = A2(
						elm$json$Json$Decode$decodeValue,
						nullOr(valDecoder),
						rawValue);
					if (_n1.$ === 'Ok') {
						var finalResult = _n1.a;
						return elm$json$Json$Decode$succeed(finalResult);
					} else {
						var finalErr = _n1.a;
						return elm$json$Json$Decode$fail(
							elm$json$Json$Decode$errorToString(finalErr));
					}
				} else {
					return elm$json$Json$Decode$succeed(fallback);
				}
			};
			return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
		});
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
		function (key, valDecoder, fallback, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
					A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
					valDecoder,
					fallback),
				decoder);
		});
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var elm$json$Json$Decode$string = _Json_decodeString;
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Binding$SimplifiedRequestDetailDecoder$SimplifiedRequestDetail = function (uid) {
		return function (state) {
			return function (category) {
				return function (linkedEntities) {
					return function (requestDate) {
						return function (description) {
							return function (requester) {
								return function (seen) {
									return function (qualified) {
										return function (links) {
											return function (contactToCallback) {
												return {category: category, contactToCallback: contactToCallback, description: description, linkedEntities: linkedEntities, links: links, qualified: qualified, requestDate: requestDate, requester: requester, seen: seen, state: state, uid: uid};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$Caller = F2(
		function (name, uid) {
			return {name: name, uid: uid};
		});
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$nullable = function (decoder) {
		return elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
				]));
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$callerDecoder = A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'uid',
		elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
		elm$core$Maybe$Nothing,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$Caller)));
	var author$project$Binding$SimplifiedRequestDetailDecoder$ContactToCallback = F2(
		function (name, contact) {
			return {contact: contact, name: name};
		});
	var author$project$Binding$SimplifiedRequestDetailDecoder$Mail = function (a) {
		return {$: 'Mail', a: a};
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$Phone = function (a) {
		return {$: 'Phone', a: a};
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$contactInfoDecoder = function (s) {
		switch (s) {
			case 'Phone':
				return A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'phone',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$Phone));
			case 'Mail':
				return A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mail',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$Mail));
			default:
				return elm$json$Json$Decode$fail(s);
		}
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$contactToCallbackDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contact',
		A2(
			elm$json$Json$Decode$andThen,
			author$project$Binding$SimplifiedRequestDetailDecoder$contactInfoDecoder,
			A2(elm$json$Json$Decode$field, 'contactType', elm$json$Json$Decode$string)),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$ContactToCallback)));
	var author$project$Binding$SimplifiedRequestDetailDecoder$QualifiedPart = F3(
		function (ticketUid, qualifier, date) {
			return {date: date, qualifier: qualifier, ticketUid: ticketUid};
		});
	var author$project$Binding$SimplifiedRequestDetailDecoder$ReferencedUserC = function (a) {
		return {$: 'ReferencedUserC', a: a};
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$ReferencedUser = F2(
		function (uid, name) {
			return {name: name, uid: uid};
		});
	var author$project$Binding$SimplifiedRequestDetailDecoder$referencedUserDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$ReferencedUser)));
	var author$project$Binding$SimplifiedRequestDetailDecoder$stringToUserWhoActOnSimplifiedRequestDecoder = function (s) {
		if (s === 'ReferencedUser') {
			return A2(elm$json$Json$Decode$map, author$project$Binding$SimplifiedRequestDetailDecoder$ReferencedUserC, author$project$Binding$SimplifiedRequestDetailDecoder$referencedUserDecoder);
		} else {
			var other = s;
			return elm$json$Json$Decode$fail(other + 'is not a valid UserWhoActOnSimplifiedRequest');
		}
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$userWhoActOnSimplifiedRequestDecoder = A2(
		elm$json$Json$Decode$andThen,
		author$project$Binding$SimplifiedRequestDetailDecoder$stringToUserWhoActOnSimplifiedRequestDecoder,
		A2(elm$json$Json$Decode$field, 'userType', elm$json$Json$Decode$string));
	var author$project$Binding$SimplifiedRequestDetailDecoder$decoderQualified = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'qualifier',
			author$project$Binding$SimplifiedRequestDetailDecoder$userWhoActOnSimplifiedRequestDecoder,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ticketUid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$QualifiedPart))));
	var author$project$Binding$SimplifiedRequestDetailDecoder$LinkedEntities = F4(
		function (patrimony, company, agencies, callCenters) {
			return {agencies: agencies, callCenters: callCenters, company: company, patrimony: patrimony};
		});
	var author$project$Binding$SimplifiedRequestDetailDecoder$AgencyAbstract = F2(
		function (uid, name) {
			return {name: name, uid: uid};
		});
	var author$project$Binding$SimplifiedRequestDetailDecoder$agencyAbstractDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$AgencyAbstract)));
	var author$project$Binding$SimplifiedRequestDetailDecoder$ClientCompanyAbstract = F2(
		function (uid, name) {
			return {name: name, uid: uid};
		});
	var author$project$Binding$SimplifiedRequestDetailDecoder$clientCompanyAbstractDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uid',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$ClientCompanyAbstract)));
	var author$project$Binding$SimplifiedRequestSearchDecoder$PatrimonyAbstract = F3(
		function (uid, ref, name) {
			return {name: name, ref: ref, uid: uid};
		});
	var author$project$Binding$SimplifiedRequestSearchDecoder$patrimonyAbstractDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ref',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uid',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$PatrimonyAbstract))));
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$SimplifiedRequestDetailDecoder$linkedEntitiesDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'callCenters',
		elm$json$Json$Decode$list(elm$json$Json$Decode$string),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'agencies',
			elm$json$Json$Decode$list(author$project$Binding$SimplifiedRequestDetailDecoder$agencyAbstractDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'company',
				author$project$Binding$SimplifiedRequestDetailDecoder$clientCompanyAbstractDecoder,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patrimony',
					author$project$Binding$SimplifiedRequestSearchDecoder$patrimonyAbstractDecoder,
					elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$LinkedEntities)))));
	var author$project$Binding$SimplifiedRequestDetailDecoder$SeenPart = F2(
		function (date, personInChargeOf) {
			return {date: date, personInChargeOf: personInChargeOf};
		});
	var author$project$Binding$SimplifiedRequestDetailDecoder$seenDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'personInChargeOf',
		author$project$Binding$SimplifiedRequestDetailDecoder$userWhoActOnSimplifiedRequestDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'date',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$SeenPart)));
	var author$project$Binding$SimplifiedRequestSearchDecoder$Category = F3(
		function (iconId, label, uid) {
			return {iconId: iconId, label: label, uid: uid};
		});
	var author$project$Binding$SimplifiedRequestSearchDecoder$categoryDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uid',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'iconId',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$Category))));
	var author$project$Binding$SimplifiedRequestSearchDecoder$Declared = {$: 'Declared'};
	var author$project$Binding$SimplifiedRequestSearchDecoder$Qualified = {$: 'Qualified'};
	var author$project$Binding$SimplifiedRequestSearchDecoder$Seen = {$: 'Seen'};
	var author$project$Binding$SimplifiedRequestSearchDecoder$stringToRequestStateDecoder = function (s) {
		switch (s) {
			case 'Declared':
				return elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$Declared);
			case 'Seen':
				return elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$Seen);
			case 'Qualified':
				return elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestSearchDecoder$Qualified);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not a valid request state');
		}
	};
	var author$project$Binding$SimplifiedRequestSearchDecoder$requestStateDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$SimplifiedRequestSearchDecoder$stringToRequestStateDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$SimplifiedRequestDetailDecoder$simplifiedRequestDetailDecoder = A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'contactToCallback',
		elm$json$Json$Decode$nullable(author$project$Binding$SimplifiedRequestDetailDecoder$contactToCallbackDecoder),
		elm$core$Maybe$Nothing,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A4(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'qualified',
				elm$json$Json$Decode$nullable(author$project$Binding$SimplifiedRequestDetailDecoder$decoderQualified),
				elm$core$Maybe$Nothing,
				A4(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'seen',
					elm$json$Json$Decode$nullable(author$project$Binding$SimplifiedRequestDetailDecoder$seenDecoder),
					elm$core$Maybe$Nothing,
					A3(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'requester',
						author$project$Binding$SimplifiedRequestDetailDecoder$callerDecoder,
						A3(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'description',
							elm$json$Json$Decode$string,
							A3(
								NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'requestDate',
								elm$json$Json$Decode$string,
								A3(
									NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'linkedEntities',
									author$project$Binding$SimplifiedRequestDetailDecoder$linkedEntitiesDecoder,
									A3(
										NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'category',
										author$project$Binding$SimplifiedRequestSearchDecoder$categoryDecoder,
										A3(
											NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'state',
											author$project$Binding$SimplifiedRequestSearchDecoder$requestStateDecoder,
											A3(
												NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'uid',
												elm$json$Json$Decode$string,
												elm$json$Json$Decode$succeed(author$project$Binding$SimplifiedRequestDetailDecoder$SimplifiedRequestDetail))))))))))));
	var author$project$Components$PhotoList$FetchPhotos = function (a) {
		return {$: 'FetchPhotos', a: a};
	};
	var author$project$Components$PhotoList$PhotoFetched = function (a) {
		return {$: 'PhotoFetched', a: a};
	};
	var author$project$Components$PhotoList$PhotoList = function (documents) {
		return {documents: documents};
	};
	var author$project$Components$PhotoList$Photo = F2(
		function (url, type_) {
			return {type_: type_, url: url};
		});
	var author$project$Components$PhotoList$decodePhoto = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			elm$json$Json$Decode$string,
			elm$json$Json$Decode$succeed(author$project$Components$PhotoList$Photo)));
	var author$project$Components$PhotoList$decodePhotoList = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'result',
		elm$json$Json$Decode$list(author$project$Components$PhotoList$decodePhoto),
		elm$json$Json$Decode$succeed(author$project$Components$PhotoList$PhotoList));
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var author$project$Components$PhotoList$update = F3(
		function (apiUrl, action, model) {
			if (action.$ === 'FetchPhotos') {
				var uid = action.a;
				return _Utils_Tuple2(
					model,
					author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							apiUrl + ('/documents?aggregatetype=SimplifiedRequest&aggregateuid=' + uid),
							A2(elm$http$Http$expectJson, author$project$Components$PhotoList$PhotoFetched, author$project$Components$PhotoList$decodePhotoList))));
			} else {
				var result = action.a;
				return _Utils_Tuple2(
					A2(
						elm$core$Result$withDefault,
						_List_Nil,
						A2(
							elm$core$Result$map,
							function ($) {
								return $.documents;
							},
							result)),
					elm$core$Platform$Cmd$none);
			}
		});
	var author$project$SimplifiedRequestDetail$DetailFetched = function (a) {
		return {$: 'DetailFetched', a: a};
	};
	var author$project$SimplifiedRequestDetail$GenerateUuid = function (a) {
		return {$: 'GenerateUuid', a: a};
	};
	var author$project$SimplifiedRequestDetail$PhotoListAction = function (a) {
		return {$: 'PhotoListAction', a: a};
	};
	var author$project$SimplifiedRequestDetail$ReportRequestSeen = function (a) {
		return {$: 'ReportRequestSeen', a: a};
	};
	var author$project$SimplifiedRequestDetail$ReportRequestSeenAsked = {$: 'ReportRequestSeenAsked'};
	var author$project$SimplifiedRequestDetail$dispatch = _Platform_outgoingPort('dispatch', elm$core$Basics$identity);
	var author$project$SimplifiedRequestDetail$RequestSeen = function (a) {
		return {$: 'RequestSeen', a: a};
	};
	var author$project$Utils$Http$HttpRequest$Delete = F2(
		function (a, b) {
			return {$: 'Delete', a: a, b: b};
		});
	var author$project$Utils$Http$HttpRequest$Patch = F3(
		function (a, b, c) {
			return {$: 'Patch', a: a, b: b, c: c};
		});
	var author$project$Utils$Http$HttpRequest$Post = F3(
		function (a, b, c) {
			return {$: 'Post', a: a, b: b, c: c};
		});
	var author$project$SimplifiedRequestDetail$fromHttpVerbToHttpAction = F3(
		function (verb, uri, body) {
			switch (verb.$) {
				case 'GET':
					return author$project$Utils$Http$HttpRequest$Get(uri);
				case 'POST':
					return A2(
						author$project$Utils$Http$HttpRequest$Post,
						uri,
						A2(elm$core$Maybe$withDefault, elm$http$Http$emptyBody, body));
				case 'PATCH':
					return A2(
						author$project$Utils$Http$HttpRequest$Patch,
						uri,
						A2(elm$core$Maybe$withDefault, elm$http$Http$emptyBody, body));
				default:
					return author$project$Utils$Http$HttpRequest$Delete(uri);
			}
		});
	var NoRedInk$elm_uuid$Prng$Uuid$toString = function (_n0) {
		var internalString = _n0.a;
		return internalString;
	};
	var author$project$SimplifiedRequestDetail$reportRequestSeenRel = 'ReportSimplifiedRequestSeenByPersonInChargeOf';
	var elm$http$Http$jsonBody = function (value) {
		return A2(
			_Http_pair,
			'application/json',
			A2(elm$json$Json$Encode$encode, 0, value));
	};
	var author$project$SimplifiedRequestDetail$reportRequestSeenBody = function (uuid) {
		return elm$http$Http$jsonBody(
			elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'processUid',
						elm$json$Json$Encode$string(
							NoRedInk$elm_uuid$Prng$Uuid$toString(uuid))),
						_Utils_Tuple2(
						'commandType',
						elm$json$Json$Encode$string(author$project$SimplifiedRequestDetail$reportRequestSeenRel))
					])));
	};
	var elm$http$Http$expectBytesResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'arraybuffer',
				_Http_toDataView,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$expectWhatever = function (toMsg) {
		return A2(
			elm$http$Http$expectBytesResponse,
			toMsg,
			elm$http$Http$resolve(
				function (_n0) {
					return elm$core$Result$Ok(_Utils_Tuple0);
				}));
	};
	var author$project$SimplifiedRequestDetail$reportRequestSeenHttpCmd = F3(
		function (uuid, verb, uri) {
			var action = A3(
				author$project$SimplifiedRequestDetail$fromHttpVerbToHttpAction,
				verb,
				uri,
				elm$core$Maybe$Just(
					author$project$SimplifiedRequestDetail$reportRequestSeenBody(uuid)));
			return author$project$Utils$Http$HttpRequest$withAuthReq(
				action(
					elm$http$Http$expectWhatever(author$project$SimplifiedRequestDetail$RequestSeen)));
		});
	var ccapndave$elm_flat_map$Maybe$FlatMap$join = function (mx) {
		if (mx.$ === 'Just') {
			var x = mx.a;
			return x;
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var ccapndave$elm_flat_map$Maybe$FlatMap$flatMap = F2(
		function (f, maybe) {
			return ccapndave$elm_flat_map$Maybe$FlatMap$join(
				A2(elm$core$Maybe$map, f, maybe));
		});
	var elm$core$Basics$always = F2(
		function (a, _n0) {
			return a;
		});
	var elm$core$Platform$Cmd$map = _Platform_map;
	var elm_community$list_extra$List$Extra$find = F2(
		function (predicate, list) {
			find:
			while (true) {
				if (!list.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var first = list.a;
					var rest = list.b;
					if (predicate(first)) {
						return elm$core$Maybe$Just(first);
					} else {
						var $temp$predicate = predicate,
							$temp$list = rest;
						predicate = $temp$predicate;
						list = $temp$list;
						continue find;
					}
				}
			}
		});
	var author$project$SimplifiedRequestDetail$update = F2(
		function (msg, model) {
			switch (msg.$) {
				case 'FetchDetail':
					var uid = msg.a;
					var cmd = author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							model.apiUrl + ('/simplifiedrequests/' + uid),
							A2(elm$http$Http$expectJson, author$project$SimplifiedRequestDetail$DetailFetched, author$project$Binding$SimplifiedRequestDetailDecoder$simplifiedRequestDetailDecoder)));
					return _Utils_Tuple2(
						model,
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									author$project$Utils$Command$msgToElmCmd(
									author$project$SimplifiedRequestDetail$PhotoListAction(
										author$project$Components$PhotoList$FetchPhotos(uid)))
								])));
				case 'DetailFetched':
					var result = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								detail: A2(
									elm$core$Result$withDefault,
									elm$core$Maybe$Nothing,
									A2(elm$core$Result$map, elm$core$Maybe$Just, result))
							}),
						author$project$Utils$Command$msgToElmCmd(author$project$SimplifiedRequestDetail$ReportRequestSeenAsked));
				case 'ReportRequestSeenAsked':
					return _Utils_Tuple2(
						model,
						author$project$Utils$Command$msgToElmCmd(
							author$project$SimplifiedRequestDetail$GenerateUuid(author$project$SimplifiedRequestDetail$ReportRequestSeen)));
				case 'ReportRequestSeen':
					var uuid = msg.a;
					var canReport = A2(
						ccapndave$elm_flat_map$Maybe$FlatMap$flatMap,
						A2(
							elm$core$Basics$composeR,
							function ($) {
								return $.links;
							},
							elm_community$list_extra$List$Extra$find(
								function (l) {
									return _Utils_eq(l.rel, author$project$SimplifiedRequestDetail$reportRequestSeenRel);
								})),
						model.detail);
					var httpCmd = A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(
							elm$core$Maybe$map,
							function (l) {
								return A3(author$project$SimplifiedRequestDetail$reportRequestSeenHttpCmd, uuid, l.method, l.href);
							},
							canReport));
					return _Utils_Tuple2(model, httpCmd);
				case 'RequestSeen':
					var result = msg.a;
					var detailSeen = function (d) {
						return _Utils_update(
							d,
							{state: author$project$Binding$SimplifiedRequestSearchDecoder$Seen});
					};
					var newDetail = function (d) {
						return A2(
							elm$core$Result$withDefault,
							d,
							A2(
								elm$core$Result$map,
								elm$core$Basics$always(
									detailSeen(d)),
								result));
					};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								detail: A2(elm$core$Maybe$map, newDetail, model.detail)
							}),
						elm$core$Platform$Cmd$none);
				case 'QualifyRequest':
					var request = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							elm$core$Maybe$withDefault,
							elm$core$Platform$Cmd$none,
							A2(
								elm$core$Maybe$map,
								author$project$SimplifiedRequestDetail$dispatch,
								author$project$Binding$QualifyRequestEncoder$qualifyRequestJsonCmd(request))));
				case 'PhotoListAction':
					var photoAction = msg.a;
					var _n1 = A3(author$project$Components$PhotoList$update, model.apiUrl, photoAction, model.photos);
					var newModel = _n1.a;
					var newCmd = _n1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{photos: newModel}),
						A2(elm$core$Platform$Cmd$map, author$project$SimplifiedRequestDetail$PhotoListAction, newCmd));
				default:
					var f = msg.a;
					var _n2 = A2(NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$step, NoRedInk$elm_uuid$Prng$Uuid$generator, model.seed);
					var newUuid = _n2.a;
					var newSeed = _n2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{seed: newSeed}),
						author$project$Utils$Command$msgToElmCmd(
							f(newUuid)));
			}
		});
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$html$Html$a = _VirtualDom_node('a');
	var elm$html$Html$div = _VirtualDom_node('div');
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var elm$html$Html$text = elm$virtual_dom$VirtualDom$text;
	var elm$html$Html$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				_VirtualDom_property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var elm$html$Html$Attributes$href = function (url) {
		return A2(
			elm$html$Html$Attributes$stringProperty,
			'href',
			_VirtualDom_noJavaScriptUri(url));
	};
	var elm$html$Html$Attributes$target = elm$html$Html$Attributes$stringProperty('target');
	var author$project$Components$PhotoList$linkPhoto = function (photo) {
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$a,
					_List_fromArray(
						[
							elm$html$Html$Attributes$href(photo.url),
							elm$html$Html$Attributes$target('blank')
						]),
					_List_fromArray(
						[
							elm$html$Html$text(' Photo ')
						]))
				]));
	};
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$html$Html$details = _VirtualDom_node('details');
	var elm$html$Html$summary = _VirtualDom_node('summary');
	var author$project$Components$PhotoList$view = function (model) {
		return A2(
			elm$core$Maybe$withDefault,
			A2(elm$html$Html$div, _List_Nil, _List_Nil),
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$always(
					A2(
						elm$html$Html$details,
						_List_Nil,
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									elm$html$Html$summary,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('Voir les photos')
										]))
								]),
							A2(elm$core$List$map, author$project$Components$PhotoList$linkPhoto, model)))),
				elm$core$List$head(model)));
	};
	var author$project$Components$SimplifiedRequest$List$showCategoryState = function (state) {
		switch (state.$) {
			case 'Declared':
				return 'À traiter';
			case 'Seen':
				return 'En cours de traitement';
			default:
				return 'Qualifée';
		}
	};
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$paddingTop = rtfeldman$elm_css$Css$prop1('padding-top');
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var author$project$SimplifiedRequestDetail$blocBody = _List_fromArray(
		[
			rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$paddingTop(
					rtfeldman$elm_css$Css$em(1))
				]))
		]);
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var author$project$SimplifiedRequestDetail$elemStyle = _List_fromArray(
		[
			rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$marginBottom(
					rtfeldman$elm_css$Css$px(30))
				]))
		]);
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var author$project$SimplifiedRequestDetail$blockStyle = _Utils_ap(
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$backgroundColor(
						rtfeldman$elm_css$Css$hex('#fff')),
						A3(
						rtfeldman$elm_css$Css$border3,
						rtfeldman$elm_css$Css$px(1),
						rtfeldman$elm_css$Css$solid,
						rtfeldman$elm_css$Css$hex('#DADADA')),
						rtfeldman$elm_css$Css$padding(
						rtfeldman$elm_css$Css$px(10))
					]))
			]),
		author$project$SimplifiedRequestDetail$elemStyle);
	var rtfeldman$elm_css$Css$borderBottom3 = rtfeldman$elm_css$Css$prop3('border-bottom');
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var rtfeldman$elm_css$Css$textTransform = rtfeldman$elm_css$Css$prop1('text-transform');
	var rtfeldman$elm_css$Css$uppercase = {textTransform: rtfeldman$elm_css$Css$Structure$Compatible, value: 'uppercase'};
	var author$project$SimplifiedRequestDetail$blockTitle = _List_fromArray(
		[
			rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					A3(
					rtfeldman$elm_css$Css$borderBottom3,
					rtfeldman$elm_css$Css$px(1),
					rtfeldman$elm_css$Css$solid,
					rtfeldman$elm_css$Css$hex('#546D79')),
					rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase),
					rtfeldman$elm_css$Css$fontSize(
					rtfeldman$elm_css$Css$em(1.2)),
					rtfeldman$elm_css$Css$color(
					rtfeldman$elm_css$Css$hex('#546D79'))
				]))
		]);
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var author$project$SimplifiedRequestDetail$bloc = F2(
		function (title, body) {
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				author$project$SimplifiedRequestDetail$blockStyle,
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						author$project$SimplifiedRequestDetail$blockTitle,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(title)
							])),
						A2(rtfeldman$elm_css$Html$Styled$div, author$project$SimplifiedRequestDetail$blocBody, body)
					]));
		});
	var author$project$SimplifiedRequestDetail$QualifyRequest = function (a) {
		return {$: 'QualifyRequest', a: a};
	};
	var author$project$SimplifiedRequestDetail$buttonStyle = _List_fromArray(
		[
			rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$color(
					rtfeldman$elm_css$Css$hex('#546D79')),
					rtfeldman$elm_css$Css$padding(
					rtfeldman$elm_css$Css$em(0.7)),
					rtfeldman$elm_css$Css$fontSize(
					rtfeldman$elm_css$Css$em(1.3))
				]))
		]);
	var author$project$SimplifiedRequestDetail$haveRightToQualify = function (links) {
		return A2(
			elm_community$list_extra$List$Extra$find,
			function (l) {
				return l.rel === 'QualifySimplifiedRequest';
			},
			links);
	};
	var rtfeldman$elm_css$Html$Styled$button = rtfeldman$elm_css$Html$Styled$node('button');
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$SimplifiedRequestDetail$showQualifyButton = function (sr) {
		var qualifButton = _List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$button,
				_Utils_ap(
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Events$onClick(
							author$project$SimplifiedRequestDetail$QualifyRequest(sr))
						]),
					_Utils_ap(author$project$SimplifiedRequestDetail$elemStyle, author$project$SimplifiedRequestDetail$buttonStyle)),
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text('Qualifier la demande')
					]))
			]);
		var result = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$always(qualifButton),
				author$project$SimplifiedRequestDetail$haveRightToQualify(sr.links)));
		return A2(
			elm$core$Maybe$withDefault,
			result,
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$always(_List_Nil),
				sr.qualified));
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$userOnRequest = function (a) {
		var u = a.a;
		return u;
	};
	var rtfeldman$elm_css$Css$marginTop = rtfeldman$elm_css$Css$prop1('margin-top');
	var rtfeldman$elm_css$Html$Styled$p = rtfeldman$elm_css$Html$Styled$node('p');
	var author$project$SimplifiedRequestDetail$stateView = F2(
		function (label, user) {
			var content = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					function (u) {
						return _List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$text(
								label + (': ' + author$project$Binding$SimplifiedRequestDetailDecoder$userOnRequest(u).name))
							]);
					},
					user));
			return A2(
				rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								rtfeldman$elm_css$Css$marginTop(
								rtfeldman$elm_css$Css$px(15))
							]))
					]),
				content);
		});
	var rtfeldman$elm_css$Css$fontWeight = function (_n0) {
		var value = _n0.value;
		return A2(rtfeldman$elm_css$Css$property, 'font-weight', value);
	};
	var rtfeldman$elm_css$Css$UnitlessInteger = {$: 'UnitlessInteger'};
	var rtfeldman$elm_css$Css$int = function (val) {
		return {
			fontWeight: rtfeldman$elm_css$Css$Structure$Compatible,
			intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
			number: rtfeldman$elm_css$Css$Structure$Compatible,
			numberOrInfinite: rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: val,
			unitLabel: '',
			units: rtfeldman$elm_css$Css$UnitlessInteger,
			value: elm$core$String$fromInt(val)
		};
	};
	var author$project$SimplifiedRequestDetail$titleStyle = _Utils_ap(
		author$project$SimplifiedRequestDetail$blockStyle,
		_List_fromArray(
			[
				rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A3(
						rtfeldman$elm_css$Css$borderBottom3,
						rtfeldman$elm_css$Css$px(1),
						rtfeldman$elm_css$Css$solid,
						rtfeldman$elm_css$Css$hex('#00E5CE')),
						rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase),
						rtfeldman$elm_css$Css$fontSize(
						rtfeldman$elm_css$Css$em(1.5)),
						rtfeldman$elm_css$Css$fontWeight(
						rtfeldman$elm_css$Css$int(400)),
						rtfeldman$elm_css$Css$color(
						rtfeldman$elm_css$Css$hex('#546D79'))
					]))
			]));
	var author$project$Binding$SimplifiedRequestDetailDecoder$contactToLink = function (contactInfo) {
		if (contactInfo.$ === 'Phone') {
			var p = contactInfo.a;
			return 'tel:' + p;
		} else {
			var p = contactInfo.a;
			return 'mailto:' + p;
		}
	};
	var author$project$Binding$SimplifiedRequestDetailDecoder$contactToRawValue = function (contactInfo) {
		if (contactInfo.$ === 'Phone') {
			var p = contactInfo.a;
			return p;
		} else {
			var p = contactInfo.a;
			return p;
		}
	};
	var rtfeldman$elm_css$Html$Styled$a = rtfeldman$elm_css$Html$Styled$node('a');
	var rtfeldman$elm_css$VirtualDom$Styled$property = F2(
		function (key, value) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$property, key, value),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
		function (key, string) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$property,
				key,
				elm$json$Json$Encode$string(string));
		});
	var rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
		return A2(rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
	};
	var author$project$SimplifiedRequestDetail$viewContactToCallback = function (contactToCallback) {
		return A2(
			author$project$SimplifiedRequestDetail$bloc,
			'Personne à recontacter',
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(contactToCallback.name + ' au '),
					A2(
					rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$href(
							author$project$Binding$SimplifiedRequestDetailDecoder$contactToLink(contactToCallback.contact))
						]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(
							author$project$Binding$SimplifiedRequestDetailDecoder$contactToRawValue(contactToCallback.contact))
						]))
				]));
	};
	var rtfeldman$elm_css$Html$Styled$br = rtfeldman$elm_css$Html$Styled$node('br');
	var author$project$SimplifiedRequestDetail$viewFormattedText = function (t) {
		return elm$core$List$concat(
			A2(
				elm$core$List$map,
				function (x) {
					return _List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(x),
							A2(rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
						]);
				},
				A2(elm$core$String$split, '\n', t)));
	};
	var author$project$SimplifiedRequestDetail$viewPatrimony = function (p) {
		return A2(
			author$project$SimplifiedRequestDetail$bloc,
			'Lieu de demande',
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(p.name)
				]));
	};
	var elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
	var elm$core$String$repeatHelp = F3(
		function (n, chunk, result) {
			return (n <= 0) ? result : A3(
				elm$core$String$repeatHelp,
				n >> 1,
				_Utils_ap(chunk, chunk),
				(!(n & 1)) ? result : _Utils_ap(result, chunk));
		});
	var elm$core$String$repeat = F2(
		function (n, chunk) {
			return A3(elm$core$String$repeatHelp, n, chunk, '');
		});
	var elm$core$String$padLeft = F3(
		function (n, _char, string) {
			return _Utils_ap(
				A2(
					elm$core$String$repeat,
					n - elm$core$String$length(string),
					elm$core$String$fromChar(_char)),
				string);
		});
	var author$project$Utils$Date$DateUtils$formatTimeElement = function (i) {
		return A3(
			elm$core$String$padLeft,
			2,
			_Utils_chr('0'),
			elm$core$String$fromInt(i));
	};
	var author$project$Utils$Date$DateUtils$monthToNum = function (m) {
		switch (m.$) {
			case 'Jan':
				return 1;
			case 'Feb':
				return 2;
			case 'Mar':
				return 3;
			case 'Apr':
				return 4;
			case 'May':
				return 5;
			case 'Jun':
				return 6;
			case 'Jul':
				return 7;
			case 'Aug':
				return 8;
			case 'Sep':
				return 9;
			case 'Oct':
				return 10;
			case 'Nov':
				return 11;
			default:
				return 12;
		}
	};
	var elm$time$Time$flooredDiv = F2(
		function (numerator, denominator) {
			return elm$core$Basics$floor(numerator / denominator);
		});
	var elm$time$Time$posixToMillis = function (_n0) {
		var millis = _n0.a;
		return millis;
	};
	var elm$time$Time$toAdjustedMinutesHelp = F3(
		function (defaultOffset, posixMinutes, eras) {
			toAdjustedMinutesHelp:
			while (true) {
				if (!eras.b) {
					return posixMinutes + defaultOffset;
				} else {
					var era = eras.a;
					var olderEras = eras.b;
					if (_Utils_cmp(era.start, posixMinutes) < 0) {
						return posixMinutes + era.offset;
					} else {
						var $temp$defaultOffset = defaultOffset,
							$temp$posixMinutes = posixMinutes,
							$temp$eras = olderEras;
						defaultOffset = $temp$defaultOffset;
						posixMinutes = $temp$posixMinutes;
						eras = $temp$eras;
						continue toAdjustedMinutesHelp;
					}
				}
			}
		});
	var elm$time$Time$toAdjustedMinutes = F2(
		function (_n0, time) {
			var defaultOffset = _n0.a;
			var eras = _n0.b;
			return A3(
				elm$time$Time$toAdjustedMinutesHelp,
				defaultOffset,
				A2(
					elm$time$Time$flooredDiv,
					elm$time$Time$posixToMillis(time),
					60000),
				eras);
		});
	var elm$time$Time$toCivil = function (minutes) {
		var rawDay = A2(elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
		var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
		var dayOfEra = rawDay - (era * 146097);
		var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
		var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
		var mp = (((5 * dayOfYear) + 2) / 153) | 0;
		var month = mp + ((mp < 10) ? 3 : (-9));
		var year = yearOfEra + (era * 400);
		return {
			day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
			month: month,
			year: year + ((month <= 2) ? 1 : 0)
		};
	};
	var elm$time$Time$toDay = F2(
		function (zone, time) {
			return elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).day;
		});
	var elm$time$Time$toHour = F2(
		function (zone, time) {
			return A2(
				elm$core$Basics$modBy,
				24,
				A2(
					elm$time$Time$flooredDiv,
					A2(elm$time$Time$toAdjustedMinutes, zone, time),
					60));
		});
	var elm$time$Time$toMinute = F2(
		function (zone, time) {
			return A2(
				elm$core$Basics$modBy,
				60,
				A2(elm$time$Time$toAdjustedMinutes, zone, time));
		});
	var elm$time$Time$Aug = {$: 'Aug'};
	var elm$time$Time$Dec = {$: 'Dec'};
	var elm$time$Time$Feb = {$: 'Feb'};
	var elm$time$Time$Jul = {$: 'Jul'};
	var elm$time$Time$Jun = {$: 'Jun'};
	var elm$time$Time$May = {$: 'May'};
	var elm$time$Time$Nov = {$: 'Nov'};
	var elm$time$Time$toMonth = F2(
		function (zone, time) {
			var _n0 = elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).month;
			switch (_n0) {
				case 1:
					return elm$time$Time$Jan;
				case 2:
					return elm$time$Time$Feb;
				case 3:
					return elm$time$Time$Mar;
				case 4:
					return elm$time$Time$Apr;
				case 5:
					return elm$time$Time$May;
				case 6:
					return elm$time$Time$Jun;
				case 7:
					return elm$time$Time$Jul;
				case 8:
					return elm$time$Time$Aug;
				case 9:
					return elm$time$Time$Sep;
				case 10:
					return elm$time$Time$Oct;
				case 11:
					return elm$time$Time$Nov;
				default:
					return elm$time$Time$Dec;
			}
		});
	var elm$time$Time$toYear = F2(
		function (zone, time) {
			return elm$time$Time$toCivil(
				A2(elm$time$Time$toAdjustedMinutes, zone, time)).year;
		});
	var author$project$Utils$Date$DateUtils$posixToHumanDate = F2(
		function (zone, posix) {
			var y = elm$core$String$fromInt(
				A2(elm$time$Time$toYear, zone, posix));
			var mi = author$project$Utils$Date$DateUtils$formatTimeElement(
				A2(elm$time$Time$toMinute, zone, posix));
			var m = author$project$Utils$Date$DateUtils$formatTimeElement(
				author$project$Utils$Date$DateUtils$monthToNum(
					A2(elm$time$Time$toMonth, zone, posix)));
			var h = author$project$Utils$Date$DateUtils$formatTimeElement(
				A2(elm$time$Time$toHour, zone, posix));
			var d = author$project$Utils$Date$DateUtils$formatTimeElement(
				A2(elm$time$Time$toDay, zone, posix));
			return A2(
				elm$core$String$join,
				' à ',
				_List_fromArray(
					[
						A2(
						elm$core$String$join,
						'/',
						_List_fromArray(
							[d, m, y])),
						A2(
						elm$core$String$join,
						':',
						_List_fromArray(
							[h, mi]))
					]));
		});
	var elm$parser$Parser$DeadEnd = F3(
		function (row, col, problem) {
			return {col: col, problem: problem, row: row};
		});
	var elm$parser$Parser$problemToDeadEnd = function (p) {
		return A3(elm$parser$Parser$DeadEnd, p.row, p.col, p.problem);
	};
	var elm$parser$Parser$Advanced$bagToList = F2(
		function (bag, list) {
			bagToList:
			while (true) {
				switch (bag.$) {
					case 'Empty':
						return list;
					case 'AddRight':
						var bag1 = bag.a;
						var x = bag.b;
						var $temp$bag = bag1,
							$temp$list = A2(elm$core$List$cons, x, list);
						bag = $temp$bag;
						list = $temp$list;
						continue bagToList;
					default:
						var bag1 = bag.a;
						var bag2 = bag.b;
						var $temp$bag = bag1,
							$temp$list = A2(elm$parser$Parser$Advanced$bagToList, bag2, list);
						bag = $temp$bag;
						list = $temp$list;
						continue bagToList;
				}
			}
		});
	var elm$parser$Parser$Advanced$run = F2(
		function (_n0, src) {
			var parse = _n0.a;
			var _n1 = parse(
				{col: 1, context: _List_Nil, indent: 1, offset: 0, row: 1, src: src});
			if (_n1.$ === 'Good') {
				var value = _n1.b;
				return elm$core$Result$Ok(value);
			} else {
				var bag = _n1.b;
				return elm$core$Result$Err(
					A2(elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
			}
		});
	var elm$parser$Parser$run = F2(
		function (parser, source) {
			var _n0 = A2(elm$parser$Parser$Advanced$run, parser, source);
			if (_n0.$ === 'Ok') {
				var a = _n0.a;
				return elm$core$Result$Ok(a);
			} else {
				var problems = _n0.a;
				return elm$core$Result$Err(
					A2(elm$core$List$map, elm$parser$Parser$problemToDeadEnd, problems));
			}
		});
	var elm$parser$Parser$Advanced$Bad = F2(
		function (a, b) {
			return {$: 'Bad', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$Good = F3(
		function (a, b, c) {
			return {$: 'Good', a: a, b: b, c: c};
		});
	var elm$parser$Parser$Advanced$Parser = function (a) {
		return {$: 'Parser', a: a};
	};
	var elm$parser$Parser$Advanced$andThen = F2(
		function (callback, _n0) {
			var parseA = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parseA(s0);
					if (_n1.$ === 'Bad') {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p1 = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						var _n2 = callback(a);
						var parseB = _n2.a;
						var _n3 = parseB(s1);
						if (_n3.$ === 'Bad') {
							var p2 = _n3.a;
							var x = _n3.b;
							return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
						} else {
							var p2 = _n3.a;
							var b = _n3.b;
							var s2 = _n3.c;
							return A3(elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
						}
					}
				});
		});
	var elm$parser$Parser$andThen = elm$parser$Parser$Advanced$andThen;
	var elm$parser$Parser$ExpectingEnd = {$: 'ExpectingEnd'};
	var elm$parser$Parser$Advanced$AddRight = F2(
		function (a, b) {
			return {$: 'AddRight', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$DeadEnd = F4(
		function (row, col, problem, contextStack) {
			return {col: col, contextStack: contextStack, problem: problem, row: row};
		});
	var elm$parser$Parser$Advanced$Empty = {$: 'Empty'};
	var elm$parser$Parser$Advanced$fromState = F2(
		function (s, x) {
			return A2(
				elm$parser$Parser$Advanced$AddRight,
				elm$parser$Parser$Advanced$Empty,
				A4(elm$parser$Parser$Advanced$DeadEnd, s.row, s.col, x, s.context));
		});
	var elm$parser$Parser$Advanced$end = function (x) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return _Utils_eq(
					elm$core$String$length(s.src),
					s.offset) ? A3(elm$parser$Parser$Advanced$Good, false, _Utils_Tuple0, s) : A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, x));
			});
	};
	var elm$parser$Parser$end = elm$parser$Parser$Advanced$end(elm$parser$Parser$ExpectingEnd);
	var elm$parser$Parser$Advanced$map2 = F3(
		function (func, _n0, _n1) {
			var parseA = _n0.a;
			var parseB = _n1.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n2 = parseA(s0);
					if (_n2.$ === 'Bad') {
						var p = _n2.a;
						var x = _n2.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p1 = _n2.a;
						var a = _n2.b;
						var s1 = _n2.c;
						var _n3 = parseB(s1);
						if (_n3.$ === 'Bad') {
							var p2 = _n3.a;
							var x = _n3.b;
							return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
						} else {
							var p2 = _n3.a;
							var b = _n3.b;
							var s2 = _n3.c;
							return A3(
								elm$parser$Parser$Advanced$Good,
								p1 || p2,
								A2(func, a, b),
								s2);
						}
					}
				});
		});
	var elm$parser$Parser$Advanced$ignorer = F2(
		function (keepParser, ignoreParser) {
			return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$always, keepParser, ignoreParser);
		});
	var elm$parser$Parser$ignorer = elm$parser$Parser$Advanced$ignorer;
	var elm$parser$Parser$Advanced$keeper = F2(
		function (parseFunc, parseArg) {
			return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$apL, parseFunc, parseArg);
		});
	var elm$parser$Parser$keeper = elm$parser$Parser$Advanced$keeper;
	var elm$parser$Parser$Advanced$Append = F2(
		function (a, b) {
			return {$: 'Append', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$oneOfHelp = F3(
		function (s0, bag, parsers) {
			oneOfHelp:
			while (true) {
				if (!parsers.b) {
					return A2(elm$parser$Parser$Advanced$Bad, false, bag);
				} else {
					var parse = parsers.a.a;
					var remainingParsers = parsers.b;
					var _n1 = parse(s0);
					if (_n1.$ === 'Good') {
						var step = _n1;
						return step;
					} else {
						var step = _n1;
						var p = step.a;
						var x = step.b;
						if (p) {
							return step;
						} else {
							var $temp$s0 = s0,
								$temp$bag = A2(elm$parser$Parser$Advanced$Append, bag, x),
								$temp$parsers = remainingParsers;
							s0 = $temp$s0;
							bag = $temp$bag;
							parsers = $temp$parsers;
							continue oneOfHelp;
						}
					}
				}
			}
		});
	var elm$parser$Parser$Advanced$oneOf = function (parsers) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A3(elm$parser$Parser$Advanced$oneOfHelp, s, elm$parser$Parser$Advanced$Empty, parsers);
			});
	};
	var elm$parser$Parser$oneOf = elm$parser$Parser$Advanced$oneOf;
	var elm$parser$Parser$Advanced$succeed = function (a) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A3(elm$parser$Parser$Advanced$Good, false, a, s);
			});
	};
	var elm$parser$Parser$succeed = elm$parser$Parser$Advanced$succeed;
	var elm$parser$Parser$ExpectingSymbol = function (a) {
		return {$: 'ExpectingSymbol', a: a};
	};
	var elm$parser$Parser$Advanced$Token = F2(
		function (a, b) {
			return {$: 'Token', a: a, b: b};
		});
	var elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
	var elm$parser$Parser$Advanced$token = function (_n0) {
		var str = _n0.a;
		var expecting = _n0.b;
		var progress = !elm$core$String$isEmpty(str);
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				var _n1 = A5(elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
				var newOffset = _n1.a;
				var newRow = _n1.b;
				var newCol = _n1.c;
				return _Utils_eq(newOffset, -1) ? A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
					elm$parser$Parser$Advanced$Good,
					progress,
					_Utils_Tuple0,
					{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
			});
	};
	var elm$parser$Parser$Advanced$symbol = elm$parser$Parser$Advanced$token;
	var elm$parser$Parser$symbol = function (str) {
		return elm$parser$Parser$Advanced$symbol(
			A2(
				elm$parser$Parser$Advanced$Token,
				str,
				elm$parser$Parser$ExpectingSymbol(str)));
	};
	var elm$core$Basics$round = _Basics_round;
	var elm$core$String$toFloat = _String_toFloat;
	var elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
	var elm$parser$Parser$Advanced$chompWhileHelp = F5(
		function (isGood, offset, row, col, s0) {
			chompWhileHelp:
			while (true) {
				var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
				if (_Utils_eq(newOffset, -1)) {
					return A3(
						elm$parser$Parser$Advanced$Good,
						_Utils_cmp(s0.offset, offset) < 0,
						_Utils_Tuple0,
						{col: col, context: s0.context, indent: s0.indent, offset: offset, row: row, src: s0.src});
				} else {
					if (_Utils_eq(newOffset, -2)) {
						var $temp$isGood = isGood,
							$temp$offset = offset + 1,
							$temp$row = row + 1,
							$temp$col = 1,
							$temp$s0 = s0;
						isGood = $temp$isGood;
						offset = $temp$offset;
						row = $temp$row;
						col = $temp$col;
						s0 = $temp$s0;
						continue chompWhileHelp;
					} else {
						var $temp$isGood = isGood,
							$temp$offset = newOffset,
							$temp$row = row,
							$temp$col = col + 1,
							$temp$s0 = s0;
						isGood = $temp$isGood;
						offset = $temp$offset;
						row = $temp$row;
						col = $temp$col;
						s0 = $temp$s0;
						continue chompWhileHelp;
					}
				}
			}
		});
	var elm$parser$Parser$Advanced$chompWhile = function (isGood) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A5(elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.offset, s.row, s.col, s);
			});
	};
	var elm$parser$Parser$chompWhile = elm$parser$Parser$Advanced$chompWhile;
	var elm$parser$Parser$Advanced$mapChompedString = F2(
		function (func, _n0) {
			var parse = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parse(s0);
					if (_n1.$ === 'Bad') {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					} else {
						var p = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						return A3(
							elm$parser$Parser$Advanced$Good,
							p,
							A2(
								func,
								A3(elm$core$String$slice, s0.offset, s1.offset, s0.src),
								a),
							s1);
					}
				});
		});
	var elm$parser$Parser$Advanced$getChompedString = function (parser) {
		return A2(elm$parser$Parser$Advanced$mapChompedString, elm$core$Basics$always, parser);
	};
	var elm$parser$Parser$getChompedString = elm$parser$Parser$Advanced$getChompedString;
	var elm$parser$Parser$Problem = function (a) {
		return {$: 'Problem', a: a};
	};
	var elm$parser$Parser$Advanced$problem = function (x) {
		return elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, x));
			});
	};
	var elm$parser$Parser$problem = function (msg) {
		return elm$parser$Parser$Advanced$problem(
			elm$parser$Parser$Problem(msg));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
		elm$parser$Parser$andThen,
		function (str) {
			if (elm$core$String$length(str) <= 9) {
				var _n0 = elm$core$String$toFloat('0.' + str);
				if (_n0.$ === 'Just') {
					var floatVal = _n0.a;
					return elm$parser$Parser$succeed(
						elm$core$Basics$round(floatVal * 1000));
				} else {
					return elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
				}
			} else {
				return elm$parser$Parser$problem(
					'Expected at most 9 digits, but got ' + elm$core$String$fromInt(
						elm$core$String$length(str)));
			}
		},
		elm$parser$Parser$getChompedString(
			elm$parser$Parser$chompWhile(elm$core$Char$isDigit)));
	var elm$time$Time$Posix = function (a) {
		return {$: 'Posix', a: a};
	};
	var elm$time$Time$millisToPosix = elm$time$Time$Posix;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
		function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
			return elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
		});
	var elm$core$String$toInt = _String_toInt;
	var elm$parser$Parser$Done = function (a) {
		return {$: 'Done', a: a};
	};
	var elm$parser$Parser$Loop = function (a) {
		return {$: 'Loop', a: a};
	};
	var elm$parser$Parser$UnexpectedChar = {$: 'UnexpectedChar'};
	var elm$parser$Parser$Advanced$chompIf = F2(
		function (isGood, expecting) {
			return elm$parser$Parser$Advanced$Parser(
				function (s) {
					var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
					return _Utils_eq(newOffset, -1) ? A2(
						elm$parser$Parser$Advanced$Bad,
						false,
						A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
						elm$parser$Parser$Advanced$Good,
						true,
						_Utils_Tuple0,
						{col: 1, context: s.context, indent: s.indent, offset: s.offset + 1, row: s.row + 1, src: s.src}) : A3(
						elm$parser$Parser$Advanced$Good,
						true,
						_Utils_Tuple0,
						{col: s.col + 1, context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src}));
				});
		});
	var elm$parser$Parser$chompIf = function (isGood) {
		return A2(elm$parser$Parser$Advanced$chompIf, isGood, elm$parser$Parser$UnexpectedChar);
	};
	var elm$parser$Parser$Advanced$map = F2(
		function (func, _n0) {
			var parse = _n0.a;
			return elm$parser$Parser$Advanced$Parser(
				function (s0) {
					var _n1 = parse(s0);
					if (_n1.$ === 'Good') {
						var p = _n1.a;
						var a = _n1.b;
						var s1 = _n1.c;
						return A3(
							elm$parser$Parser$Advanced$Good,
							p,
							func(a),
							s1);
					} else {
						var p = _n1.a;
						var x = _n1.b;
						return A2(elm$parser$Parser$Advanced$Bad, p, x);
					}
				});
		});
	var elm$parser$Parser$map = elm$parser$Parser$Advanced$map;
	var elm$parser$Parser$Advanced$Done = function (a) {
		return {$: 'Done', a: a};
	};
	var elm$parser$Parser$Advanced$Loop = function (a) {
		return {$: 'Loop', a: a};
	};
	var elm$parser$Parser$toAdvancedStep = function (step) {
		if (step.$ === 'Loop') {
			var s = step.a;
			return elm$parser$Parser$Advanced$Loop(s);
		} else {
			var a = step.a;
			return elm$parser$Parser$Advanced$Done(a);
		}
	};
	var elm$parser$Parser$Advanced$loopHelp = F4(
		function (p, state, callback, s0) {
			loopHelp:
			while (true) {
				var _n0 = callback(state);
				var parse = _n0.a;
				var _n1 = parse(s0);
				if (_n1.$ === 'Good') {
					var p1 = _n1.a;
					var step = _n1.b;
					var s1 = _n1.c;
					if (step.$ === 'Loop') {
						var newState = step.a;
						var $temp$p = p || p1,
							$temp$state = newState,
							$temp$callback = callback,
							$temp$s0 = s1;
						p = $temp$p;
						state = $temp$state;
						callback = $temp$callback;
						s0 = $temp$s0;
						continue loopHelp;
					} else {
						var result = step.a;
						return A3(elm$parser$Parser$Advanced$Good, p || p1, result, s1);
					}
				} else {
					var p1 = _n1.a;
					var x = _n1.b;
					return A2(elm$parser$Parser$Advanced$Bad, p || p1, x);
				}
			}
		});
	var elm$parser$Parser$Advanced$loop = F2(
		function (state, callback) {
			return elm$parser$Parser$Advanced$Parser(
				function (s) {
					return A4(elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
				});
		});
	var elm$parser$Parser$loop = F2(
		function (state, callback) {
			return A2(
				elm$parser$Parser$Advanced$loop,
				state,
				function (s) {
					return A2(
						elm$parser$Parser$map,
						elm$parser$Parser$toAdvancedStep,
						callback(s));
				});
		});
	var rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
		var helper = function (str) {
			if (_Utils_eq(
				elm$core$String$length(str),
				quantity)) {
				var _n0 = elm$core$String$toInt(str);
				if (_n0.$ === 'Just') {
					var intVal = _n0.a;
					return A2(
						elm$parser$Parser$map,
						elm$parser$Parser$Done,
						elm$parser$Parser$succeed(intVal));
				} else {
					return elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
				}
			} else {
				return A2(
					elm$parser$Parser$map,
					function (nextChar) {
						return elm$parser$Parser$Loop(
							A2(elm$core$String$append, str, nextChar));
					},
					elm$parser$Parser$getChompedString(
						elm$parser$Parser$chompIf(elm$core$Char$isDigit)));
			}
		};
		return A2(elm$parser$Parser$loop, '', helper);
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
		return elm$parser$Parser$problem(
			'Invalid day: ' + elm$core$String$fromInt(day));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
		return (!A2(elm$core$Basics$modBy, 4, year)) && (A2(elm$core$Basics$modBy, 100, year) || (!A2(elm$core$Basics$modBy, 400, year)));
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
		var y = y1 - 1;
		return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
	var rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_n0) {
		var year = _n0.a;
		var month = _n0.b;
		var dayInMonth = _n0.c;
		if (dayInMonth < 0) {
			return rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
		} else {
			var succeedWith = function (extraMs) {
				var yearMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
				var days = ((month < 3) || (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
				var dayMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + (rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
				return elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
			};
			switch (month) {
				case 1:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
				case 2:
					return ((dayInMonth > 29) || ((dayInMonth === 29) && (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
				case 3:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
				case 4:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
				case 5:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
				case 6:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
				case 7:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
				case 8:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
				case 9:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
				case 10:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
				case 11:
					return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
				case 12:
					return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
				default:
					return elm$parser$Parser$problem(
						'Invalid month: \"' + (elm$core$String$fromInt(month) + '\"'));
			}
		}
	};
	var rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
		elm$parser$Parser$andThen,
		rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						F3(
							function (year, month, day) {
								return _Utils_Tuple3(year, month, day);
							})),
					rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(elm$core$Basics$identity),
								elm$parser$Parser$symbol('-')),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
						]))),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(elm$core$Basics$identity),
							elm$parser$Parser$symbol('-')),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))));
	var rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
		var utcOffsetMinutesFromParts = F3(
			function (multiplier, hours, minutes) {
				return (multiplier * (hours * 60)) + minutes;
			});
		return A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$map,
						function (_n0) {
							return 0;
						},
						elm$parser$Parser$symbol('Z')),
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$keeper,
								elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
								elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											elm$parser$Parser$map,
											function (_n1) {
												return 1;
											},
											elm$parser$Parser$symbol('+')),
											A2(
											elm$parser$Parser$map,
											function (_n2) {
												return -1;
											},
											elm$parser$Parser$symbol('-'))
										]))),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$succeed(elm$core$Basics$identity),
										elm$parser$Parser$symbol(':')),
									rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
									rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
									elm$parser$Parser$succeed(0)
								]))),
						A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(0),
						elm$parser$Parser$end)
					])));
	}();
	var rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
		elm$parser$Parser$andThen,
		function (datePart) {
			return elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$keeper,
								A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											elm$parser$Parser$succeed(
												rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
											elm$parser$Parser$symbol('T')),
										rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
									elm$parser$Parser$oneOf(
										_List_fromArray(
											[
												A2(
												elm$parser$Parser$keeper,
												A2(
													elm$parser$Parser$ignorer,
													elm$parser$Parser$succeed(elm$core$Basics$identity),
													elm$parser$Parser$symbol(':')),
												rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
												rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
											]))),
								elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											elm$parser$Parser$keeper,
											A2(
												elm$parser$Parser$ignorer,
												elm$parser$Parser$succeed(elm$core$Basics$identity),
												elm$parser$Parser$symbol(':')),
											rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											elm$parser$Parser$succeed(elm$core$Basics$identity),
											elm$parser$Parser$symbol('.')),
										rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
										elm$parser$Parser$succeed(0)
									]))),
						A2(elm$parser$Parser$ignorer, rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, elm$parser$Parser$end)),
						A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(
							A6(rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
						elm$parser$Parser$end)
					]));
		},
		rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
	var rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
		return A2(elm$parser$Parser$run, rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
	};
	var author$project$Utils$Date$DateUtils$printHumanDate = F2(
		function (zone, dIso8601) {
			var resultD = rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dIso8601);
			if (resultD.$ === 'Ok') {
				var posix = resultD.a;
				return A2(author$project$Utils$Date$DateUtils$posixToHumanDate, zone, posix);
			} else {
				return '';
			}
		});
	var elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
	var elm$html$Html$map = elm$virtual_dom$VirtualDom$map;
	var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
	var rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
		function (a, b) {
			return {$: 'ExtendSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
		return {$: 'PseudoClassSelector', a: a};
	};
	var rtfeldman$elm_css$Css$pseudoClass = function (_class) {
		return rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
			rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
	};
	var rtfeldman$elm_css$Css$hover = rtfeldman$elm_css$Css$pseudoClass('hover');
	var rtfeldman$elm_css$Css$Internal$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
		return {$: 'ApplyStyles', a: a};
	};
	var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
		function (functionName, desiredKey, style) {
			getOverloadedProperty:
			while (true) {
				switch (style.$) {
					case 'AppendProperty':
						var str = style.a;
						var key = A2(
							elm$core$Maybe$withDefault,
							'',
							elm$core$List$head(
								A2(elm$core$String$split, ':', str)));
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
					case 'ExtendSelector':
						var selector = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
					case 'NestSnippet':
						var combinator = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
					case 'WithPseudoElement':
						var pseudoElement = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
					case 'WithMedia':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
					case 'WithKeyframes':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
					default:
						if (!style.a.b) {
							return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
						} else {
							if (!style.a.b.b) {
								var _n1 = style.a;
								var only = _n1.a;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = only;
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							} else {
								var _n2 = style.a;
								var first = _n2.a;
								var rest = _n2.b;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							}
						}
				}
			}
		});
	var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
	var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
	var rtfeldman$elm_css$Css$justifyContent = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'justifyContent',
			'justify-content',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$paddingLeft = rtfeldman$elm_css$Css$prop1('padding-left');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var rtfeldman$elm_css$Css$spaceBetween = rtfeldman$elm_css$Css$prop1('space-between');
	var rtfeldman$elm_css$Css$textAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'textAlign',
			'text-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$textDecoration = rtfeldman$elm_css$Css$prop1('text-decoration');
	var rtfeldman$elm_css$Css$underline = {textDecorationLine: rtfeldman$elm_css$Css$Structure$Compatible, value: 'underline'};
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
	var rtfeldman$elm_css$Html$Styled$fromUnstyled = rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
	var rtfeldman$elm_css$Html$Styled$Attributes$class = rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
	var author$project$SimplifiedRequestDetail$viewSimplifiedRequest = F3(
		function (zone, photos, sr) {
			return _List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$class('breadcrumb')
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$href('/simplifiedrequests'),
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$paddingLeft(
											rtfeldman$elm_css$Css$em(1)),
											rtfeldman$elm_css$Css$color(
											rtfeldman$elm_css$Css$hex('#546D79')),
											rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
											rtfeldman$elm_css$Css$hover(
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$textDecoration(rtfeldman$elm_css$Css$underline),
													rtfeldman$elm_css$Css$color(
													rtfeldman$elm_css$Css$hex('#35444c'))
												]))
										]))
								]),
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$text('Demandes')
								]))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$displayFlex,
									rtfeldman$elm_css$Css$justifyContent(rtfeldman$elm_css$Css$spaceBetween)
								]))
						]),
					_List_fromArray(
						[
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$width(
											rtfeldman$elm_css$Css$pct(63)),
											A2(rtfeldman$elm_css$Css$property, 'display', 'grid'),
											A2(rtfeldman$elm_css$Css$property, 'grid-template-columns', '50% 50%'),
											A2(rtfeldman$elm_css$Css$property, 'column-gap', '30px'),
											A2(rtfeldman$elm_css$Css$property, 'grid-auto-flow', 'dense')
										]))
								]),
							_List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Html$Styled$div,
									_Utils_ap(
										author$project$SimplifiedRequestDetail$titleStyle,
										_List_fromArray(
											[
												rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														A2(rtfeldman$elm_css$Css$property, 'grid-column', '1 / span 2')
													]))
											])),
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text(
											'Déclarée le ' + A2(author$project$Utils$Date$DateUtils$printHumanDate, zone, sr.requestDate))
										])),
									A2(
									rtfeldman$elm_css$Html$Styled$div,
									author$project$SimplifiedRequestDetail$blockStyle,
									_List_fromArray(
										[
											A2(
											rtfeldman$elm_css$Html$Styled$div,
											author$project$SimplifiedRequestDetail$blockTitle,
											_List_fromArray(
												[
													rtfeldman$elm_css$Html$Styled$text(
													author$project$Components$SimplifiedRequest$List$showCategoryState(sr.state))
												])),
											A2(
											author$project$SimplifiedRequestDetail$stateView,
											'Pris en charge par',
											A2(
												elm$core$Maybe$map,
												function ($) {
													return $.personInChargeOf;
												},
												sr.seen)),
											A2(
											author$project$SimplifiedRequestDetail$stateView,
											'Qualifié par',
											A2(
												elm$core$Maybe$map,
												function ($) {
													return $.qualifier;
												},
												sr.qualified)),
											A2(
											elm$core$Maybe$withDefault,
											A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
											A2(
												elm$core$Maybe$map,
												function (q) {
													return A2(
														rtfeldman$elm_css$Html$Styled$a,
														_List_fromArray(
															[
																rtfeldman$elm_css$Html$Styled$Attributes$href('/tickets/' + q.ticketUid)
															]),
														_List_fromArray(
															[
																rtfeldman$elm_css$Html$Styled$text('lien vers le ticket')
															]));
												},
												sr.qualified))
										])),
									A2(
									author$project$SimplifiedRequestDetail$bloc,
									'Déclarée par',
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text(sr.requester.name)
										])),
									A2(
									author$project$SimplifiedRequestDetail$bloc,
									'Description',
									author$project$SimplifiedRequestDetail$viewFormattedText(sr.description)),
									A2(
									elm$core$Maybe$withDefault,
									A2(rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
									A2(elm$core$Maybe$map, author$project$SimplifiedRequestDetail$viewContactToCallback, sr.contactToCallback)),
									A2(
									author$project$SimplifiedRequestDetail$bloc,
									'Catégorie',
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text(sr.category.label)
										])),
									author$project$SimplifiedRequestDetail$viewPatrimony(sr.linkedEntities.patrimony)
								])),
							A2(
							rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											rtfeldman$elm_css$Css$width(
											rtfeldman$elm_css$Css$pct(33))
										]))
								]),
							_List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center)
												]))
										]),
									author$project$SimplifiedRequestDetail$showQualifyButton(sr)),
									rtfeldman$elm_css$Html$Styled$fromUnstyled(
									A2(
										elm$html$Html$map,
										author$project$SimplifiedRequestDetail$PhotoListAction,
										author$project$Components$PhotoList$view(photos)))
								]))
						]))
				]);
		});
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var author$project$SimplifiedRequestDetail$view = function (model) {
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						elm$core$Maybe$map,
						A2(author$project$SimplifiedRequestDetail$viewSimplifiedRequest, model.timezone, model.photos),
						model.detail))));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var elm$json$Json$Decode$index = _Json_decodeIndex;
	var elm$json$Json$Decode$int = _Json_decodeInt;
	var author$project$SimplifiedRequestDetail$main = elm$browser$Browser$element(
		{init: author$project$SimplifiedRequestDetail$init, subscriptions: author$project$SimplifiedRequestDetail$subscriptions, update: author$project$SimplifiedRequestDetail$update, view: author$project$SimplifiedRequestDetail$view});
	_Platform_export({'SimplifiedRequestDetail':{'init':author$project$SimplifiedRequestDetail$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (seedInfos) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (requestUid) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (apiUrl) {
								return elm$json$Json$Decode$succeed(
									{apiUrl: apiUrl, requestUid: requestUid, seedInfos: seedInfos});
							},
							A2(elm$json$Json$Decode$field, 'apiUrl', elm$json$Json$Decode$string));
					},
					A2(elm$json$Json$Decode$field, 'requestUid', elm$json$Json$Decode$string));
			},
			A2(
				elm$json$Json$Decode$field,
				'seedInfos',
				A2(
					elm$json$Json$Decode$andThen,
					function (x0) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (x1) {
								return elm$json$Json$Decode$succeed(
									_Utils_Tuple2(x0, x1));
							},
							A2(
								elm$json$Json$Decode$index,
								1,
								elm$json$Json$Decode$list(elm$json$Json$Decode$int)));
					},
					A2(elm$json$Json$Decode$index, 0, elm$json$Json$Decode$int)))))(0)}});}(this));

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	(function(scope){
	'use strict';
	
	function F(arity, fun, wrapper) {
	  wrapper.a = arity;
	  wrapper.f = fun;
	  return wrapper;
	}
	
	function F2(fun) {
	  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
	}
	function F3(fun) {
	  return F(3, fun, function(a) {
	    return function(b) { return function(c) { return fun(a, b, c); }; };
	  });
	}
	function F4(fun) {
	  return F(4, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return fun(a, b, c, d); }; }; };
	  });
	}
	function F5(fun) {
	  return F(5, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
	  });
	}
	function F6(fun) {
	  return F(6, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return fun(a, b, c, d, e, f); }; }; }; }; };
	  });
	}
	function F7(fun) {
	  return F(7, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
	  });
	}
	function F8(fun) {
	  return F(8, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) {
	    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
	  });
	}
	function F9(fun) {
	  return F(9, fun, function(a) { return function(b) { return function(c) {
	    return function(d) { return function(e) { return function(f) {
	    return function(g) { return function(h) { return function(i) {
	    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
	  });
	}
	
	function A2(fun, a, b) {
	  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
	}
	function A3(fun, a, b, c) {
	  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
	}
	function A4(fun, a, b, c, d) {
	  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
	}
	function A5(fun, a, b, c, d, e) {
	  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
	}
	function A6(fun, a, b, c, d, e, f) {
	  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
	}
	function A7(fun, a, b, c, d, e, f, g) {
	  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
	}
	function A8(fun, a, b, c, d, e, f, g, h) {
	  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
	}
	function A9(fun, a, b, c, d, e, f, g, h, i) {
	  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
	}
	
	console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.0/optimize for better performance and smaller assets.');
	
	
	var _JsArray_empty = [];
	
	function _JsArray_singleton(value)
	{
	    return [value];
	}
	
	function _JsArray_length(array)
	{
	    return array.length;
	}
	
	var _JsArray_initialize = F3(function(size, offset, func)
	{
	    var result = new Array(size);
	
	    for (var i = 0; i < size; i++)
	    {
	        result[i] = func(offset + i);
	    }
	
	    return result;
	});
	
	var _JsArray_initializeFromList = F2(function (max, ls)
	{
	    var result = new Array(max);
	
	    for (var i = 0; i < max && ls.b; i++)
	    {
	        result[i] = ls.a;
	        ls = ls.b;
	    }
	
	    result.length = i;
	    return _Utils_Tuple2(result, ls);
	});
	
	var _JsArray_unsafeGet = F2(function(index, array)
	{
	    return array[index];
	});
	
	var _JsArray_unsafeSet = F3(function(index, value, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[index] = value;
	    return result;
	});
	
	var _JsArray_push = F2(function(value, array)
	{
	    var length = array.length;
	    var result = new Array(length + 1);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = array[i];
	    }
	
	    result[length] = value;
	    return result;
	});
	
	var _JsArray_foldl = F3(function(func, acc, array)
	{
	    var length = array.length;
	
	    for (var i = 0; i < length; i++)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_foldr = F3(function(func, acc, array)
	{
	    for (var i = array.length - 1; i >= 0; i--)
	    {
	        acc = A2(func, array[i], acc);
	    }
	
	    return acc;
	});
	
	var _JsArray_map = F2(function(func, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = func(array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_indexedMap = F3(function(func, offset, array)
	{
	    var length = array.length;
	    var result = new Array(length);
	
	    for (var i = 0; i < length; i++)
	    {
	        result[i] = A2(func, offset + i, array[i]);
	    }
	
	    return result;
	});
	
	var _JsArray_slice = F3(function(from, to, array)
	{
	    return array.slice(from, to);
	});
	
	var _JsArray_appendN = F3(function(n, dest, source)
	{
	    var destLen = dest.length;
	    var itemsToCopy = n - destLen;
	
	    if (itemsToCopy > source.length)
	    {
	        itemsToCopy = source.length;
	    }
	
	    var size = destLen + itemsToCopy;
	    var result = new Array(size);
	
	    for (var i = 0; i < destLen; i++)
	    {
	        result[i] = dest[i];
	    }
	
	    for (var i = 0; i < itemsToCopy; i++)
	    {
	        result[i + destLen] = source[i];
	    }
	
	    return result;
	});
	
	
	
	var _List_Nil_UNUSED = { $: 0 };
	var _List_Nil = { $: '[]' };
	
	function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
	function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }
	
	
	var _List_cons = F2(_List_Cons);
	
	function _List_fromArray(arr)
	{
		var out = _List_Nil;
		for (var i = arr.length; i--; )
		{
			out = _List_Cons(arr[i], out);
		}
		return out;
	}
	
	function _List_toArray(xs)
	{
		for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
		{
			out.push(xs.a);
		}
		return out;
	}
	
	var _List_map2 = F3(function(f, xs, ys)
	{
		for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
		{
			arr.push(A2(f, xs.a, ys.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map3 = F4(function(f, xs, ys, zs)
	{
		for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A3(f, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map4 = F5(function(f, ws, xs, ys, zs)
	{
		for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
	{
		for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
		{
			arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
		}
		return _List_fromArray(arr);
	});
	
	var _List_sortBy = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			return _Utils_cmp(f(a), f(b));
		}));
	});
	
	var _List_sortWith = F2(function(f, xs)
	{
		return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
			var ord = A2(f, a, b);
			return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
		}));
	});
	
	
	
	// LOG
	
	var _Debug_log_UNUSED = F2(function(tag, value)
	{
		return value;
	});
	
	var _Debug_log = F2(function(tag, value)
	{
		console.log(tag + ': ' + _Debug_toString(value));
		return value;
	});
	
	
	// TODOS
	
	function _Debug_todo(moduleName, region)
	{
		return function(message) {
			_Debug_crash(8, moduleName, region, message);
		};
	}
	
	function _Debug_todoCase(moduleName, region, value)
	{
		return function(message) {
			_Debug_crash(9, moduleName, region, value, message);
		};
	}
	
	
	// TO STRING
	
	function _Debug_toString_UNUSED(value)
	{
		return '<internals>';
	}
	
	function _Debug_toString(value)
	{
		return _Debug_toAnsiString(false, value);
	}
	
	function _Debug_toAnsiString(ansi, value)
	{
		if (typeof value === 'function')
		{
			return _Debug_internalColor(ansi, '<function>');
		}
	
		if (typeof value === 'boolean')
		{
			return _Debug_ctorColor(ansi, value ? 'True' : 'False');
		}
	
		if (typeof value === 'number')
		{
			return _Debug_numberColor(ansi, value + '');
		}
	
		if (value instanceof String)
		{
			return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
		}
	
		if (typeof value === 'string')
		{
			return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
		}
	
		if (typeof value === 'object' && '$' in value)
		{
			var tag = value.$;
	
			if (typeof tag === 'number')
			{
				return _Debug_internalColor(ansi, '<internals>');
			}
	
			if (tag[0] === '#')
			{
				var output = [];
				for (var k in value)
				{
					if (k === '$') continue;
					output.push(_Debug_toAnsiString(ansi, value[k]));
				}
				return '(' + output.join(',') + ')';
			}
	
			if (tag === 'Set_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Set')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
			}
	
			if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Dict')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
			}
	
			if (tag === 'Array_elm_builtin')
			{
				return _Debug_ctorColor(ansi, 'Array')
					+ _Debug_fadeColor(ansi, '.fromList') + ' '
					+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
			}
	
			if (tag === '::' || tag === '[]')
			{
				var output = '[';
	
				value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)
	
				for (; value.b; value = value.b) // WHILE_CONS
				{
					output += ',' + _Debug_toAnsiString(ansi, value.a);
				}
				return output + ']';
			}
	
			var output = '';
			for (var i in value)
			{
				if (i === '$') continue;
				var str = _Debug_toAnsiString(ansi, value[i]);
				var c0 = str[0];
				var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
				output += ' ' + (parenless ? str : '(' + str + ')');
			}
			return _Debug_ctorColor(ansi, tag) + output;
		}
	
		if (typeof DataView === 'function' && value instanceof DataView)
		{
			return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
		}
	
		if (typeof File === 'function' && value instanceof File)
		{
			return _Debug_internalColor(ansi, '<' + value.name + '>');
		}
	
		if (typeof value === 'object')
		{
			var output = [];
			for (var key in value)
			{
				var field = key[0] === '_' ? key.slice(1) : key;
				output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
			}
			if (output.length === 0)
			{
				return '{}';
			}
			return '{ ' + output.join(', ') + ' }';
		}
	
		return _Debug_internalColor(ansi, '<internals>');
	}
	
	function _Debug_addSlashes(str, isChar)
	{
		var s = str
			.replace(/\\/g, '\\\\')
			.replace(/\n/g, '\\n')
			.replace(/\t/g, '\\t')
			.replace(/\r/g, '\\r')
			.replace(/\v/g, '\\v')
			.replace(/\0/g, '\\0');
	
		if (isChar)
		{
			return s.replace(/\'/g, '\\\'');
		}
		else
		{
			return s.replace(/\"/g, '\\"');
		}
	}
	
	function _Debug_ctorColor(ansi, string)
	{
		return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_numberColor(ansi, string)
	{
		return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_stringColor(ansi, string)
	{
		return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_charColor(ansi, string)
	{
		return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_fadeColor(ansi, string)
	{
		return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_internalColor(ansi, string)
	{
		return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
	}
	
	function _Debug_toHexDigit(n)
	{
		return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
	}
	
	
	// CRASH
	
	
	function _Debug_crash_UNUSED(identifier)
	{
		throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
	}
	
	
	function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
	{
		switch(identifier)
		{
			case 0:
				throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
	
			case 1:
				throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
	
			case 2:
				var jsonErrorString = fact1;
				throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
	
			case 3:
				var portName = fact1;
				throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
	
			case 4:
				var portName = fact1;
				var problem = fact2;
				throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
	
			case 5:
				throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
	
			case 6:
				var moduleName = fact1;
				throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
	
			case 8:
				var moduleName = fact1;
				var region = fact2;
				var message = fact3;
				throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
	
			case 9:
				var moduleName = fact1;
				var region = fact2;
				var value = fact3;
				var message = fact4;
				throw new Error(
					'TODO in module `' + moduleName + '` from the `case` expression '
					+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
					+ _Debug_toString(value).replace('\n', '\n    ')
					+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
				);
	
			case 10:
				throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
	
			case 11:
				throw new Error('Cannot perform mod 0. Division by zero error.');
		}
	}
	
	function _Debug_regionToString(region)
	{
		if (region.start.line === region.end.line)
		{
			return 'on line ' + region.start.line;
		}
		return 'on lines ' + region.start.line + ' through ' + region.end.line;
	}
	
	
	
	// EQUALITY
	
	function _Utils_eq(x, y)
	{
		for (
			var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
			isEqual && (pair = stack.pop());
			isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
			)
		{}
	
		return isEqual;
	}
	
	function _Utils_eqHelp(x, y, depth, stack)
	{
		if (depth > 100)
		{
			stack.push(_Utils_Tuple2(x,y));
			return true;
		}
	
		if (x === y)
		{
			return true;
		}
	
		if (typeof x !== 'object' || x === null || y === null)
		{
			typeof x === 'function' && _Debug_crash(5);
			return false;
		}
	
		/**/
		if (x.$ === 'Set_elm_builtin')
		{
			x = elm$core$Set$toList(x);
			y = elm$core$Set$toList(y);
		}
		if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		/**_UNUSED/
		if (x.$ < 0)
		{
			x = elm$core$Dict$toList(x);
			y = elm$core$Dict$toList(y);
		}
		//*/
	
		for (var key in x)
		{
			if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}
	
	var _Utils_equal = F2(_Utils_eq);
	var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });
	
	
	
	// COMPARISONS
	
	// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
	// the particular integer values assigned to LT, EQ, and GT.
	
	function _Utils_cmp(x, y, ord)
	{
		if (typeof x !== 'object')
		{
			return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
		}
	
		/**/
		if (x instanceof String)
		{
			var a = x.valueOf();
			var b = y.valueOf();
			return a === b ? 0 : a < b ? -1 : 1;
		}
		//*/
	
		/**_UNUSED/
		if (typeof x.$ === 'undefined')
		//*/
		/**/
		if (x.$[0] === '#')
		//*/
		{
			return (ord = _Utils_cmp(x.a, y.a))
				? ord
				: (ord = _Utils_cmp(x.b, y.b))
					? ord
					: _Utils_cmp(x.c, y.c);
		}
	
		// traverse conses until end of a list or a mismatch
		for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
		return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
	}
	
	var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
	var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
	var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
	var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });
	
	var _Utils_compare = F2(function(x, y)
	{
		var n = _Utils_cmp(x, y);
		return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
	});
	
	
	// COMMON VALUES
	
	var _Utils_Tuple0_UNUSED = 0;
	var _Utils_Tuple0 = { $: '#0' };
	
	function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
	function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }
	
	function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
	function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }
	
	function _Utils_chr_UNUSED(c) { return c; }
	function _Utils_chr(c) { return new String(c); }
	
	
	// RECORDS
	
	function _Utils_update(oldRecord, updatedFields)
	{
		var newRecord = {};
	
		for (var key in oldRecord)
		{
			newRecord[key] = oldRecord[key];
		}
	
		for (var key in updatedFields)
		{
			newRecord[key] = updatedFields[key];
		}
	
		return newRecord;
	}
	
	
	// APPEND
	
	var _Utils_append = F2(_Utils_ap);
	
	function _Utils_ap(xs, ys)
	{
		// append Strings
		if (typeof xs === 'string')
		{
			return xs + ys;
		}
	
		// append Lists
		if (!xs.b)
		{
			return ys;
		}
		var root = _List_Cons(xs.a, ys);
		xs = xs.b
		for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
		{
			curr = curr.b = _List_Cons(xs.a, ys);
		}
		return root;
	}
	
	
	
	// TASKS
	
	function _Scheduler_succeed(value)
	{
		return {
			$: 0,
			a: value
		};
	}
	
	function _Scheduler_fail(error)
	{
		return {
			$: 1,
			a: error
		};
	}
	
	function _Scheduler_binding(callback)
	{
		return {
			$: 2,
			b: callback,
			c: null
		};
	}
	
	var _Scheduler_andThen = F2(function(callback, task)
	{
		return {
			$: 3,
			b: callback,
			d: task
		};
	});
	
	var _Scheduler_onError = F2(function(callback, task)
	{
		return {
			$: 4,
			b: callback,
			d: task
		};
	});
	
	function _Scheduler_receive(callback)
	{
		return {
			$: 5,
			b: callback
		};
	}
	
	
	// PROCESSES
	
	var _Scheduler_guid = 0;
	
	function _Scheduler_rawSpawn(task)
	{
		var proc = {
			$: 0,
			e: _Scheduler_guid++,
			f: task,
			g: null,
			h: []
		};
	
		_Scheduler_enqueue(proc);
	
		return proc;
	}
	
	function _Scheduler_spawn(task)
	{
		return _Scheduler_binding(function(callback) {
			callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
		});
	}
	
	function _Scheduler_rawSend(proc, msg)
	{
		proc.h.push(msg);
		_Scheduler_enqueue(proc);
	}
	
	var _Scheduler_send = F2(function(proc, msg)
	{
		return _Scheduler_binding(function(callback) {
			_Scheduler_rawSend(proc, msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	function _Scheduler_kill(proc)
	{
		return _Scheduler_binding(function(callback) {
			var task = proc.f;
			if (task.$ === 2 && task.c)
			{
				task.c();
			}
	
			proc.f = null;
	
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	}
	
	
	/* STEP PROCESSES
	
	type alias Process =
	  { $ : tag
	  , id : unique_id
	  , root : Task
	  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
	  , mailbox : [msg]
	  }
	
	*/
	
	
	var _Scheduler_working = false;
	var _Scheduler_queue = [];
	
	
	function _Scheduler_enqueue(proc)
	{
		_Scheduler_queue.push(proc);
		if (_Scheduler_working)
		{
			return;
		}
		_Scheduler_working = true;
		while (proc = _Scheduler_queue.shift())
		{
			_Scheduler_step(proc);
		}
		_Scheduler_working = false;
	}
	
	
	function _Scheduler_step(proc)
	{
		while (proc.f)
		{
			var rootTag = proc.f.$;
			if (rootTag === 0 || rootTag === 1)
			{
				while (proc.g && proc.g.$ !== rootTag)
				{
					proc.g = proc.g.i;
				}
				if (!proc.g)
				{
					return;
				}
				proc.f = proc.g.b(proc.f.a);
				proc.g = proc.g.i;
			}
			else if (rootTag === 2)
			{
				proc.f.c = proc.f.b(function(newRoot) {
					proc.f = newRoot;
					_Scheduler_enqueue(proc);
				});
				return;
			}
			else if (rootTag === 5)
			{
				if (proc.h.length === 0)
				{
					return;
				}
				proc.f = proc.f.b(proc.h.shift());
			}
			else // if (rootTag === 3 || rootTag === 4)
			{
				proc.g = {
					$: rootTag === 3 ? 0 : 1,
					b: proc.f.b,
					i: proc.g
				};
				proc.f = proc.f.d;
			}
		}
	}
	
	
	
	// MATH
	
	var _Basics_add = F2(function(a, b) { return a + b; });
	var _Basics_sub = F2(function(a, b) { return a - b; });
	var _Basics_mul = F2(function(a, b) { return a * b; });
	var _Basics_fdiv = F2(function(a, b) { return a / b; });
	var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
	var _Basics_pow = F2(Math.pow);
	
	var _Basics_remainderBy = F2(function(b, a) { return a % b; });
	
	// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
	var _Basics_modBy = F2(function(modulus, x)
	{
		var answer = x % modulus;
		return modulus === 0
			? _Debug_crash(11)
			:
		((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
			? answer + modulus
			: answer;
	});
	
	
	// TRIGONOMETRY
	
	var _Basics_pi = Math.PI;
	var _Basics_e = Math.E;
	var _Basics_cos = Math.cos;
	var _Basics_sin = Math.sin;
	var _Basics_tan = Math.tan;
	var _Basics_acos = Math.acos;
	var _Basics_asin = Math.asin;
	var _Basics_atan = Math.atan;
	var _Basics_atan2 = F2(Math.atan2);
	
	
	// MORE MATH
	
	function _Basics_toFloat(x) { return x; }
	function _Basics_truncate(n) { return n | 0; }
	function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }
	
	var _Basics_ceiling = Math.ceil;
	var _Basics_floor = Math.floor;
	var _Basics_round = Math.round;
	var _Basics_sqrt = Math.sqrt;
	var _Basics_log = Math.log;
	var _Basics_isNaN = isNaN;
	
	
	// BOOLEANS
	
	function _Basics_not(bool) { return !bool; }
	var _Basics_and = F2(function(a, b) { return a && b; });
	var _Basics_or  = F2(function(a, b) { return a || b; });
	var _Basics_xor = F2(function(a, b) { return a !== b; });
	
	
	
	function _Char_toCode(char)
	{
		var code = char.charCodeAt(0);
		if (0xD800 <= code && code <= 0xDBFF)
		{
			return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
		}
		return code;
	}
	
	function _Char_fromCode(code)
	{
		return _Utils_chr(
			(code < 0 || 0x10FFFF < code)
				? '\uFFFD'
				:
			(code <= 0xFFFF)
				? String.fromCharCode(code)
				:
			(code -= 0x10000,
				String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
			)
		);
	}
	
	function _Char_toUpper(char)
	{
		return _Utils_chr(char.toUpperCase());
	}
	
	function _Char_toLower(char)
	{
		return _Utils_chr(char.toLowerCase());
	}
	
	function _Char_toLocaleUpper(char)
	{
		return _Utils_chr(char.toLocaleUpperCase());
	}
	
	function _Char_toLocaleLower(char)
	{
		return _Utils_chr(char.toLocaleLowerCase());
	}
	
	
	
	var _String_cons = F2(function(chr, str)
	{
		return chr + str;
	});
	
	function _String_uncons(string)
	{
		var word = string.charCodeAt(0);
		return word
			? elm$core$Maybe$Just(
				0xD800 <= word && word <= 0xDBFF
					? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
					: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
			)
			: elm$core$Maybe$Nothing;
	}
	
	var _String_append = F2(function(a, b)
	{
		return a + b;
	});
	
	function _String_length(str)
	{
		return str.length;
	}
	
	var _String_map = F2(function(func, string)
	{
		var len = string.length;
		var array = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = string.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				array[i] = func(_Utils_chr(string[i] + string[i+1]));
				i += 2;
				continue;
			}
			array[i] = func(_Utils_chr(string[i]));
			i++;
		}
		return array.join('');
	});
	
	var _String_filter = F2(function(isGood, str)
	{
		var arr = [];
		var len = str.length;
		var i = 0;
		while (i < len)
		{
			var char = str[i];
			var word = str.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += str[i];
				i++;
			}
	
			if (isGood(_Utils_chr(char)))
			{
				arr.push(char);
			}
		}
		return arr.join('');
	});
	
	function _String_reverse(str)
	{
		var len = str.length;
		var arr = new Array(len);
		var i = 0;
		while (i < len)
		{
			var word = str.charCodeAt(i);
			if (0xD800 <= word && word <= 0xDBFF)
			{
				arr[len - i] = str[i + 1];
				i++;
				arr[len - i] = str[i - 1];
				i++;
			}
			else
			{
				arr[len - i] = str[i];
				i++;
			}
		}
		return arr.join('');
	}
	
	var _String_foldl = F3(function(func, state, string)
	{
		var len = string.length;
		var i = 0;
		while (i < len)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			i++;
			if (0xD800 <= word && word <= 0xDBFF)
			{
				char += string[i];
				i++;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_foldr = F3(function(func, state, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			state = A2(func, _Utils_chr(char), state);
		}
		return state;
	});
	
	var _String_split = F2(function(sep, str)
	{
		return str.split(sep);
	});
	
	var _String_join = F2(function(sep, strs)
	{
		return strs.join(sep);
	});
	
	var _String_slice = F3(function(start, end, str) {
		return str.slice(start, end);
	});
	
	function _String_trim(str)
	{
		return str.trim();
	}
	
	function _String_trimLeft(str)
	{
		return str.replace(/^\s+/, '');
	}
	
	function _String_trimRight(str)
	{
		return str.replace(/\s+$/, '');
	}
	
	function _String_words(str)
	{
		return _List_fromArray(str.trim().split(/\s+/g));
	}
	
	function _String_lines(str)
	{
		return _List_fromArray(str.split(/\r\n|\r|\n/g));
	}
	
	function _String_toUpper(str)
	{
		return str.toUpperCase();
	}
	
	function _String_toLower(str)
	{
		return str.toLowerCase();
	}
	
	var _String_any = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (isGood(_Utils_chr(char)))
			{
				return true;
			}
		}
		return false;
	});
	
	var _String_all = F2(function(isGood, string)
	{
		var i = string.length;
		while (i--)
		{
			var char = string[i];
			var word = string.charCodeAt(i);
			if (0xDC00 <= word && word <= 0xDFFF)
			{
				i--;
				char = string[i] + char;
			}
			if (!isGood(_Utils_chr(char)))
			{
				return false;
			}
		}
		return true;
	});
	
	var _String_contains = F2(function(sub, str)
	{
		return str.indexOf(sub) > -1;
	});
	
	var _String_startsWith = F2(function(sub, str)
	{
		return str.indexOf(sub) === 0;
	});
	
	var _String_endsWith = F2(function(sub, str)
	{
		return str.length >= sub.length &&
			str.lastIndexOf(sub) === str.length - sub.length;
	});
	
	var _String_indexes = F2(function(sub, str)
	{
		var subLen = sub.length;
	
		if (subLen < 1)
		{
			return _List_Nil;
		}
	
		var i = 0;
		var is = [];
	
		while ((i = str.indexOf(sub, i)) > -1)
		{
			is.push(i);
			i = i + subLen;
		}
	
		return _List_fromArray(is);
	});
	
	
	// TO STRING
	
	function _String_fromNumber(number)
	{
		return number + '';
	}
	
	
	// INT CONVERSIONS
	
	function _String_toInt(str)
	{
		var total = 0;
		var code0 = str.charCodeAt(0);
		var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
	
		for (var i = start; i < str.length; ++i)
		{
			var code = str.charCodeAt(i);
			if (code < 0x30 || 0x39 < code)
			{
				return elm$core$Maybe$Nothing;
			}
			total = 10 * total + code - 0x30;
		}
	
		return i == start
			? elm$core$Maybe$Nothing
			: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
	}
	
	
	// FLOAT CONVERSIONS
	
	function _String_toFloat(s)
	{
		// check if it is a hex, octal, or binary number
		if (s.length === 0 || /[\sxbo]/.test(s))
		{
			return elm$core$Maybe$Nothing;
		}
		var n = +s;
		// faster isNaN check
		return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
	}
	
	function _String_fromList(chars)
	{
		return _List_toArray(chars).join('');
	}
	
	
	
	
	/**/
	function _Json_errorToString(error)
	{
		return elm$json$Json$Decode$errorToString(error);
	}
	//*/
	
	
	// CORE DECODERS
	
	function _Json_succeed(msg)
	{
		return {
			$: 0,
			a: msg
		};
	}
	
	function _Json_fail(msg)
	{
		return {
			$: 1,
			a: msg
		};
	}
	
	function _Json_decodePrim(decoder)
	{
		return { $: 2, b: decoder };
	}
	
	var _Json_decodeInt = _Json_decodePrim(function(value) {
		return (typeof value !== 'number')
			? _Json_expecting('an INT', value)
			:
		(-2147483647 < value && value < 2147483647 && (value | 0) === value)
			? elm$core$Result$Ok(value)
			:
		(isFinite(value) && !(value % 1))
			? elm$core$Result$Ok(value)
			: _Json_expecting('an INT', value);
	});
	
	var _Json_decodeBool = _Json_decodePrim(function(value) {
		return (typeof value === 'boolean')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a BOOL', value);
	});
	
	var _Json_decodeFloat = _Json_decodePrim(function(value) {
		return (typeof value === 'number')
			? elm$core$Result$Ok(value)
			: _Json_expecting('a FLOAT', value);
	});
	
	var _Json_decodeValue = _Json_decodePrim(function(value) {
		return elm$core$Result$Ok(_Json_wrap(value));
	});
	
	var _Json_decodeString = _Json_decodePrim(function(value) {
		return (typeof value === 'string')
			? elm$core$Result$Ok(value)
			: (value instanceof String)
				? elm$core$Result$Ok(value + '')
				: _Json_expecting('a STRING', value);
	});
	
	function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
	function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }
	
	function _Json_decodeNull(value) { return { $: 5, c: value }; }
	
	var _Json_decodeField = F2(function(field, decoder)
	{
		return {
			$: 6,
			d: field,
			b: decoder
		};
	});
	
	var _Json_decodeIndex = F2(function(index, decoder)
	{
		return {
			$: 7,
			e: index,
			b: decoder
		};
	});
	
	function _Json_decodeKeyValuePairs(decoder)
	{
		return {
			$: 8,
			b: decoder
		};
	}
	
	function _Json_mapMany(f, decoders)
	{
		return {
			$: 9,
			f: f,
			g: decoders
		};
	}
	
	var _Json_andThen = F2(function(callback, decoder)
	{
		return {
			$: 10,
			b: decoder,
			h: callback
		};
	});
	
	function _Json_oneOf(decoders)
	{
		return {
			$: 11,
			g: decoders
		};
	}
	
	
	// DECODING OBJECTS
	
	var _Json_map1 = F2(function(f, d1)
	{
		return _Json_mapMany(f, [d1]);
	});
	
	var _Json_map2 = F3(function(f, d1, d2)
	{
		return _Json_mapMany(f, [d1, d2]);
	});
	
	var _Json_map3 = F4(function(f, d1, d2, d3)
	{
		return _Json_mapMany(f, [d1, d2, d3]);
	});
	
	var _Json_map4 = F5(function(f, d1, d2, d3, d4)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4]);
	});
	
	var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
	});
	
	var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
	});
	
	var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
	});
	
	var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
	{
		return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
	});
	
	
	// DECODE
	
	var _Json_runOnString = F2(function(decoder, string)
	{
		try
		{
			var value = JSON.parse(string);
			return _Json_runHelp(decoder, value);
		}
		catch (e)
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
		}
	});
	
	var _Json_run = F2(function(decoder, value)
	{
		return _Json_runHelp(decoder, _Json_unwrap(value));
	});
	
	function _Json_runHelp(decoder, value)
	{
		switch (decoder.$)
		{
			case 2:
				return decoder.b(value);
	
			case 5:
				return (value === null)
					? elm$core$Result$Ok(decoder.c)
					: _Json_expecting('null', value);
	
			case 3:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('a LIST', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
	
			case 4:
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
	
			case 6:
				var field = decoder.d;
				if (typeof value !== 'object' || value === null || !(field in value))
				{
					return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
				}
				var result = _Json_runHelp(decoder.b, value[field]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));
	
			case 7:
				var index = decoder.e;
				if (!_Json_isArray(value))
				{
					return _Json_expecting('an ARRAY', value);
				}
				if (index >= value.length)
				{
					return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
				}
				var result = _Json_runHelp(decoder.b, value[index]);
				return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));
	
			case 8:
				if (typeof value !== 'object' || value === null || _Json_isArray(value))
				{
					return _Json_expecting('an OBJECT', value);
				}
	
				var keyValuePairs = _List_Nil;
				// TODO test perf of Object.keys and switch when support is good enough
				for (var key in value)
				{
					if (value.hasOwnProperty(key))
					{
						var result = _Json_runHelp(decoder.b, value[key]);
						if (!elm$core$Result$isOk(result))
						{
							return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
						}
						keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
					}
				}
				return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));
	
			case 9:
				var answer = decoder.f;
				var decoders = decoder.g;
				for (var i = 0; i < decoders.length; i++)
				{
					var result = _Json_runHelp(decoders[i], value);
					if (!elm$core$Result$isOk(result))
					{
						return result;
					}
					answer = answer(result.a);
				}
				return elm$core$Result$Ok(answer);
	
			case 10:
				var result = _Json_runHelp(decoder.b, value);
				return (!elm$core$Result$isOk(result))
					? result
					: _Json_runHelp(decoder.h(result.a), value);
	
			case 11:
				var errors = _List_Nil;
				for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
				{
					var result = _Json_runHelp(temp.a, value);
					if (elm$core$Result$isOk(result))
					{
						return result;
					}
					errors = _List_Cons(result.a, errors);
				}
				return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));
	
			case 1:
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
	
			case 0:
				return elm$core$Result$Ok(decoder.a);
		}
	}
	
	function _Json_runArrayDecoder(decoder, value, toElmValue)
	{
		var len = value.length;
		var array = new Array(len);
		for (var i = 0; i < len; i++)
		{
			var result = _Json_runHelp(decoder, value[i]);
			if (!elm$core$Result$isOk(result))
			{
				return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
			}
			array[i] = result.a;
		}
		return elm$core$Result$Ok(toElmValue(array));
	}
	
	function _Json_isArray(value)
	{
		return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
	}
	
	function _Json_toElmArray(array)
	{
		return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
	}
	
	function _Json_expecting(type, value)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
	}
	
	
	// EQUALITY
	
	function _Json_equality(x, y)
	{
		if (x === y)
		{
			return true;
		}
	
		if (x.$ !== y.$)
		{
			return false;
		}
	
		switch (x.$)
		{
			case 0:
			case 1:
				return x.a === y.a;
	
			case 2:
				return x.b === y.b;
	
			case 5:
				return x.c === y.c;
	
			case 3:
			case 4:
			case 8:
				return _Json_equality(x.b, y.b);
	
			case 6:
				return x.d === y.d && _Json_equality(x.b, y.b);
	
			case 7:
				return x.e === y.e && _Json_equality(x.b, y.b);
	
			case 9:
				return x.f === y.f && _Json_listEquality(x.g, y.g);
	
			case 10:
				return x.h === y.h && _Json_equality(x.b, y.b);
	
			case 11:
				return _Json_listEquality(x.g, y.g);
		}
	}
	
	function _Json_listEquality(aDecoders, bDecoders)
	{
		var len = aDecoders.length;
		if (len !== bDecoders.length)
		{
			return false;
		}
		for (var i = 0; i < len; i++)
		{
			if (!_Json_equality(aDecoders[i], bDecoders[i]))
			{
				return false;
			}
		}
		return true;
	}
	
	
	// ENCODE
	
	var _Json_encode = F2(function(indentLevel, value)
	{
		return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
	});
	
	function _Json_wrap(value) { return { $: 0, a: value }; }
	function _Json_unwrap(value) { return value.a; }
	
	function _Json_wrap_UNUSED(value) { return value; }
	function _Json_unwrap_UNUSED(value) { return value; }
	
	function _Json_emptyArray() { return []; }
	function _Json_emptyObject() { return {}; }
	
	var _Json_addField = F3(function(key, value, object)
	{
		object[key] = _Json_unwrap(value);
		return object;
	});
	
	function _Json_addEntry(func)
	{
		return F2(function(entry, array)
		{
			array.push(_Json_unwrap(func(entry)));
			return array;
		});
	}
	
	var _Json_encodeNull = _Json_wrap(null);
	
	
	
	function _Process_sleep(time)
	{
		return _Scheduler_binding(function(callback) {
			var id = setTimeout(function() {
				callback(_Scheduler_succeed(_Utils_Tuple0));
			}, time);
	
			return function() { clearTimeout(id); };
		});
	}
	
	
	
	
	// PROGRAMS
	
	
	var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function() { return function() {} }
		);
	});
	
	
	
	// INITIALIZE A PROGRAM
	
	
	function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
	{
		var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
		elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
		var managers = {};
		result = init(result.a);
		var model = result.a;
		var stepper = stepperBuilder(sendToApp, model);
		var ports = _Platform_setupEffects(managers, sendToApp);
	
		function sendToApp(msg, viewMetadata)
		{
			result = A2(update, msg, model);
			stepper(model = result.a, viewMetadata);
			_Platform_dispatchEffects(managers, result.b, subscriptions(model));
		}
	
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	
		return ports ? { ports: ports } : {};
	}
	
	
	
	// TRACK PRELOADS
	//
	// This is used by code in elm/browser and elm/http
	// to register any HTTP requests that are triggered by init.
	//
	
	
	var _Platform_preload;
	
	
	function _Platform_registerPreload(url)
	{
		_Platform_preload.add(url);
	}
	
	
	
	// EFFECT MANAGERS
	
	
	var _Platform_effectManagers = {};
	
	
	function _Platform_setupEffects(managers, sendToApp)
	{
		var ports;
	
		// setup all necessary effect managers
		for (var key in _Platform_effectManagers)
		{
			var manager = _Platform_effectManagers[key];
	
			if (manager.a)
			{
				ports = ports || {};
				ports[key] = manager.a(key, sendToApp);
			}
	
			managers[key] = _Platform_instantiateManager(manager, sendToApp);
		}
	
		return ports;
	}
	
	
	function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
	{
		return {
			b: init,
			c: onEffects,
			d: onSelfMsg,
			e: cmdMap,
			f: subMap
		};
	}
	
	
	function _Platform_instantiateManager(info, sendToApp)
	{
		var router = {
			g: sendToApp,
			h: undefined
		};
	
		var onEffects = info.c;
		var onSelfMsg = info.d;
		var cmdMap = info.e;
		var subMap = info.f;
	
		function loop(state)
		{
			return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
			{
				var value = msg.a;
	
				if (msg.$ === 0)
				{
					return A3(onSelfMsg, router, value, state);
				}
	
				return cmdMap && subMap
					? A4(onEffects, router, value.i, value.j, state)
					: A3(onEffects, router, cmdMap ? value.i : value.j, state);
			}));
		}
	
		return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
	}
	
	
	
	// ROUTING
	
	
	var _Platform_sendToApp = F2(function(router, msg)
	{
		return _Scheduler_binding(function(callback)
		{
			router.g(msg);
			callback(_Scheduler_succeed(_Utils_Tuple0));
		});
	});
	
	
	var _Platform_sendToSelf = F2(function(router, msg)
	{
		return A2(_Scheduler_send, router.h, {
			$: 0,
			a: msg
		});
	});
	
	
	
	// BAGS
	
	
	function _Platform_leaf(home)
	{
		return function(value)
		{
			return {
				$: 1,
				k: home,
				l: value
			};
		};
	}
	
	
	function _Platform_batch(list)
	{
		return {
			$: 2,
			m: list
		};
	}
	
	
	var _Platform_map = F2(function(tagger, bag)
	{
		return {
			$: 3,
			n: tagger,
			o: bag
		}
	});
	
	
	
	// PIPE BAGS INTO EFFECT MANAGERS
	
	
	function _Platform_dispatchEffects(managers, cmdBag, subBag)
	{
		var effectsDict = {};
		_Platform_gatherEffects(true, cmdBag, effectsDict, null);
		_Platform_gatherEffects(false, subBag, effectsDict, null);
	
		for (var home in managers)
		{
			_Scheduler_rawSend(managers[home], {
				$: 'fx',
				a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
			});
		}
	}
	
	
	function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
	{
		switch (bag.$)
		{
			case 1:
				var home = bag.k;
				var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
				effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
				return;
	
			case 2:
				for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
				{
					_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
				}
				return;
	
			case 3:
				_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
					p: bag.n,
					q: taggers
				});
				return;
		}
	}
	
	
	function _Platform_toEffect(isCmd, home, taggers, value)
	{
		function applyTaggers(x)
		{
			for (var temp = taggers; temp; temp = temp.q)
			{
				x = temp.p(x);
			}
			return x;
		}
	
		var map = isCmd
			? _Platform_effectManagers[home].e
			: _Platform_effectManagers[home].f;
	
		return A2(map, applyTaggers, value)
	}
	
	
	function _Platform_insert(isCmd, newEffect, effects)
	{
		effects = effects || { i: _List_Nil, j: _List_Nil };
	
		isCmd
			? (effects.i = _List_Cons(newEffect, effects.i))
			: (effects.j = _List_Cons(newEffect, effects.j));
	
		return effects;
	}
	
	
	
	// PORTS
	
	
	function _Platform_checkPortName(name)
	{
		if (_Platform_effectManagers[name])
		{
			_Debug_crash(3, name)
		}
	}
	
	
	
	// OUTGOING PORTS
	
	
	function _Platform_outgoingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			e: _Platform_outgoingPortMap,
			r: converter,
			a: _Platform_setupOutgoingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });
	
	
	function _Platform_setupOutgoingPort(name)
	{
		var subs = [];
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Process_sleep(0);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
		{
			for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
			{
				// grab a separate reference to subs in case unsubscribe is called
				var currentSubs = subs;
				var value = _Json_unwrap(converter(cmdList.a));
				for (var i = 0; i < currentSubs.length; i++)
				{
					currentSubs[i](value);
				}
			}
			return init;
		});
	
		// PUBLIC API
	
		function subscribe(callback)
		{
			subs.push(callback);
		}
	
		function unsubscribe(callback)
		{
			// copy subs into a new array in case unsubscribe is called within a
			// subscribed callback
			subs = subs.slice();
			var index = subs.indexOf(callback);
			if (index >= 0)
			{
				subs.splice(index, 1);
			}
		}
	
		return {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		};
	}
	
	
	
	// INCOMING PORTS
	
	
	function _Platform_incomingPort(name, converter)
	{
		_Platform_checkPortName(name);
		_Platform_effectManagers[name] = {
			f: _Platform_incomingPortMap,
			r: converter,
			a: _Platform_setupIncomingPort
		};
		return _Platform_leaf(name);
	}
	
	
	var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
	{
		return function(value)
		{
			return tagger(finalTagger(value));
		};
	});
	
	
	function _Platform_setupIncomingPort(name, sendToApp)
	{
		var subs = _List_Nil;
		var converter = _Platform_effectManagers[name].r;
	
		// CREATE MANAGER
	
		var init = _Scheduler_succeed(null);
	
		_Platform_effectManagers[name].b = init;
		_Platform_effectManagers[name].c = F3(function(router, subList, state)
		{
			subs = subList;
			return init;
		});
	
		// PUBLIC API
	
		function send(incomingValue)
		{
			var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
	
			elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
	
			var value = result.a;
			for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
			{
				sendToApp(temp.a(value));
			}
		}
	
		return { send: send };
	}
	
	
	
	// EXPORT ELM MODULES
	//
	// Have DEBUG and PROD versions so that we can (1) give nicer errors in
	// debug mode and (2) not pay for the bits needed for that in prod mode.
	//
	
	
	function _Platform_export_UNUSED(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsProd(scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsProd(obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6)
					: _Platform_mergeExportsProd(obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	function _Platform_export(exports)
	{
		scope['Elm']
			? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
			: scope['Elm'] = exports;
	}
	
	
	function _Platform_mergeExportsDebug(moduleName, obj, exports)
	{
		for (var name in exports)
		{
			(name in obj)
				? (name == 'init')
					? _Debug_crash(6, moduleName)
					: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
				: (obj[name] = exports[name]);
		}
	}
	
	
	
	// SEND REQUEST
	
	var _Http_toTask = F3(function(router, toTask, request)
	{
		return _Scheduler_binding(function(callback)
		{
			function done(response) {
				callback(toTask(request.expect.a(response)));
			}
	
			var xhr = new XMLHttpRequest();
			xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
			xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
			xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
			elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);
	
			try {
				xhr.open(request.method, request.url, true);
			} catch (e) {
				return done(elm$http$Http$BadUrl_(request.url));
			}
	
			_Http_configureRequest(xhr, request);
	
			request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
			xhr.send(request.body.b);
	
			return function() { xhr.c = true; xhr.abort(); };
		});
	});
	
	
	// CONFIGURE
	
	function _Http_configureRequest(xhr, request)
	{
		for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
		{
			xhr.setRequestHeader(headers.a.a, headers.a.b);
		}
		xhr.timeout = request.timeout.a || 0;
		xhr.responseType = request.expect.d;
		xhr.withCredentials = request.allowCookiesFromOtherDomains;
	}
	
	
	// RESPONSES
	
	function _Http_toResponse(toBody, xhr)
	{
		return A2(
			200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
			_Http_toMetadata(xhr),
			toBody(xhr.response)
		);
	}
	
	
	// METADATA
	
	function _Http_toMetadata(xhr)
	{
		return {
			url: xhr.responseURL,
			statusCode: xhr.status,
			statusText: xhr.statusText,
			headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
		};
	}
	
	
	// HEADERS
	
	function _Http_parseHeaders(rawHeaders)
	{
		if (!rawHeaders)
		{
			return elm$core$Dict$empty;
		}
	
		var headers = elm$core$Dict$empty;
		var headerPairs = rawHeaders.split('\r\n');
		for (var i = headerPairs.length; i--; )
		{
			var headerPair = headerPairs[i];
			var index = headerPair.indexOf(': ');
			if (index > 0)
			{
				var key = headerPair.substring(0, index);
				var value = headerPair.substring(index + 2);
	
				headers = A3(elm$core$Dict$update, key, function(oldValue) {
					return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
						? value + ', ' + oldValue.a
						: value
					);
				}, headers);
			}
		}
		return headers;
	}
	
	
	// EXPECT
	
	var _Http_expect = F3(function(type, toBody, toValue)
	{
		return {
			$: 0,
			d: type,
			b: toBody,
			a: toValue
		};
	});
	
	var _Http_mapExpect = F2(function(func, expect)
	{
		return {
			$: 0,
			d: expect.d,
			b: expect.b,
			a: function(x) { return func(expect.a(x)); }
		};
	});
	
	function _Http_toDataView(arrayBuffer)
	{
		return new DataView(arrayBuffer);
	}
	
	
	// BODY and PARTS
	
	var _Http_emptyBody = { $: 0 };
	var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });
	
	function _Http_toFormData(parts)
	{
		for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
		{
			var part = parts.a;
			formData.append(part.a, part.b);
		}
		return formData;
	}
	
	var _Http_bytesToBlob = F2(function(mime, bytes)
	{
		return new Blob([bytes], { type: mime });
	});
	
	
	// PROGRESS
	
	function _Http_track(router, xhr, tracker)
	{
		// TODO check out lengthComputable on loadstart event
	
		xhr.upload.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
				sent: event.loaded,
				size: event.total
			}))));
		});
		xhr.addEventListener('progress', function(event) {
			if (xhr.c) { return; }
			_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
				received: event.loaded,
				size: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
			}))));
		});
	}
	
	
	
	// HELPERS
	
	
	var _VirtualDom_divertHrefToApp;
	
	var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
	
	
	function _VirtualDom_appendChild(parent, child)
	{
		parent.appendChild(child);
	}
	
	var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
	{
		// NOTE: this function needs _Platform_export available to work
	
		/**_UNUSED/
		var node = args['node'];
		//*/
		/**/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/
	
		node.parentNode.replaceChild(
			_VirtualDom_render(virtualNode, function() {}),
			node
		);
	
		return {};
	});
	
	
	
	// TEXT
	
	
	function _VirtualDom_text(string)
	{
		return {
			$: 0,
			a: string
		};
	}
	
	
	
	// NODE
	
	
	var _VirtualDom_nodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 1,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
	
	
	
	// KEYED NODE
	
	
	var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
	{
		return F2(function(factList, kidList)
		{
			for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
			{
				var kid = kidList.a;
				descendantsCount += (kid.b.b || 0);
				kids.push(kid);
			}
			descendantsCount += kids.length;
	
			return {
				$: 2,
				c: tag,
				d: _VirtualDom_organizeFacts(factList),
				e: kids,
				f: namespace,
				b: descendantsCount
			};
		});
	});
	
	
	var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
	
	
	
	// CUSTOM
	
	
	function _VirtualDom_custom(factList, model, render, diff)
	{
		return {
			$: 3,
			d: _VirtualDom_organizeFacts(factList),
			g: model,
			h: render,
			i: diff
		};
	}
	
	
	
	// MAP
	
	
	var _VirtualDom_map = F2(function(tagger, node)
	{
		return {
			$: 4,
			j: tagger,
			k: node,
			b: 1 + (node.b || 0)
		};
	});
	
	
	
	// LAZY
	
	
	function _VirtualDom_thunk(refs, thunk)
	{
		return {
			$: 5,
			l: refs,
			m: thunk,
			k: undefined
		};
	}
	
	var _VirtualDom_lazy = F2(function(func, a)
	{
		return _VirtualDom_thunk([func, a], function() {
			return func(a);
		});
	});
	
	var _VirtualDom_lazy2 = F3(function(func, a, b)
	{
		return _VirtualDom_thunk([func, a, b], function() {
			return A2(func, a, b);
		});
	});
	
	var _VirtualDom_lazy3 = F4(function(func, a, b, c)
	{
		return _VirtualDom_thunk([func, a, b, c], function() {
			return A3(func, a, b, c);
		});
	});
	
	var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
	{
		return _VirtualDom_thunk([func, a, b, c, d], function() {
			return A4(func, a, b, c, d);
		});
	});
	
	var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e], function() {
			return A5(func, a, b, c, d, e);
		});
	});
	
	var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
			return A6(func, a, b, c, d, e, f);
		});
	});
	
	var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
			return A7(func, a, b, c, d, e, f, g);
		});
	});
	
	var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
	{
		return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
			return A8(func, a, b, c, d, e, f, g, h);
		});
	});
	
	
	
	// FACTS
	
	
	var _VirtualDom_on = F2(function(key, handler)
	{
		return {
			$: 'a0',
			n: key,
			o: handler
		};
	});
	var _VirtualDom_style = F2(function(key, value)
	{
		return {
			$: 'a1',
			n: key,
			o: value
		};
	});
	var _VirtualDom_property = F2(function(key, value)
	{
		return {
			$: 'a2',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attribute = F2(function(key, value)
	{
		return {
			$: 'a3',
			n: key,
			o: value
		};
	});
	var _VirtualDom_attributeNS = F3(function(namespace, key, value)
	{
		return {
			$: 'a4',
			n: key,
			o: { f: namespace, o: value }
		};
	});
	
	
	
	// XSS ATTACK VECTOR CHECKS
	
	
	function _VirtualDom_noScript(tag)
	{
		return tag == 'script' ? 'p' : tag;
	}
	
	function _VirtualDom_noOnOrFormAction(key)
	{
		return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
	}
	
	function _VirtualDom_noInnerHtmlOrFormAction(key)
	{
		return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
	}
	
	function _VirtualDom_noJavaScriptUri_UNUSED(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptUri(value)
	{
		return /^javascript:/i.test(value.replace(/\s/g,''))
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
	}
	
	function _VirtualDom_noJavaScriptOrHtmlUri(value)
	{
		return /^\s*(javascript:|data:text\/html)/i.test(value)
			? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
			: value;
	}
	
	
	
	// MAP FACTS
	
	
	var _VirtualDom_mapAttribute = F2(function(func, attr)
	{
		return (attr.$ === 'a0')
			? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
			: attr;
	});
	
	function _VirtualDom_mapHandler(func, handler)
	{
		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom
	
		return {
			$: handler.$,
			a:
				!tag
					? A2(elm$json$Json$Decode$map, func, handler.a)
					:
				A3(elm$json$Json$Decode$map2,
					tag < 3
						? _VirtualDom_mapEventTuple
						: _VirtualDom_mapEventRecord,
					elm$json$Json$Decode$succeed(func),
					handler.a
				)
		};
	}
	
	var _VirtualDom_mapEventTuple = F2(function(func, tuple)
	{
		return _Utils_Tuple2(func(tuple.a), tuple.b);
	});
	
	var _VirtualDom_mapEventRecord = F2(function(func, record)
	{
		return {
			message: func(record.message),
			stopPropagation: record.stopPropagation,
			preventDefault: record.preventDefault
		}
	});
	
	
	
	// ORGANIZE FACTS
	
	
	function _VirtualDom_organizeFacts(factList)
	{
		for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
		{
			var entry = factList.a;
	
			var tag = entry.$;
			var key = entry.n;
			var value = entry.o;
	
			if (tag === 'a2')
			{
				(key === 'className')
					? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
					: facts[key] = _Json_unwrap(value);
	
				continue;
			}
	
			var subFacts = facts[tag] || (facts[tag] = {});
			(tag === 'a3' && key === 'class')
				? _VirtualDom_addClass(subFacts, key, value)
				: subFacts[key] = value;
		}
	
		return facts;
	}
	
	function _VirtualDom_addClass(object, key, newClass)
	{
		var classes = object[key];
		object[key] = classes ? classes + ' ' + newClass : newClass;
	}
	
	
	
	// RENDER
	
	
	function _VirtualDom_render(vNode, eventNode)
	{
		var tag = vNode.$;
	
		if (tag === 5)
		{
			return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
		}
	
		if (tag === 0)
		{
			return _VirtualDom_doc.createTextNode(vNode.a);
		}
	
		if (tag === 4)
		{
			var subNode = vNode.k;
			var tagger = vNode.j;
	
			while (subNode.$ === 4)
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.j]
					: tagger.push(subNode.j);
	
				subNode = subNode.k;
			}
	
			var subEventRoot = { j: tagger, p: eventNode };
			var domNode = _VirtualDom_render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;
		}
	
		if (tag === 3)
		{
			var domNode = vNode.h(vNode.g);
			_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
			return domNode;
		}
	
		// at this point `tag` must be 1 or 2
	
		var domNode = vNode.f
			? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
			: _VirtualDom_doc.createElement(vNode.c);
	
		if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
		{
			domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
		}
	
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
	
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
		}
	
		return domNode;
	}
	
	
	
	// APPLY FACTS
	
	
	function _VirtualDom_applyFacts(domNode, eventNode, facts)
	{
		for (var key in facts)
		{
			var value = facts[key];
	
			key === 'a1'
				? _VirtualDom_applyStyles(domNode, value)
				:
			key === 'a0'
				? _VirtualDom_applyEvents(domNode, eventNode, value)
				:
			key === 'a3'
				? _VirtualDom_applyAttrs(domNode, value)
				:
			key === 'a4'
				? _VirtualDom_applyAttrsNS(domNode, value)
				:
			((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
		}
	}
	
	
	
	// APPLY STYLES
	
	
	function _VirtualDom_applyStyles(domNode, styles)
	{
		var domNodeStyle = domNode.style;
	
		for (var key in styles)
		{
			domNodeStyle[key] = styles[key];
		}
	}
	
	
	
	// APPLY ATTRS
	
	
	function _VirtualDom_applyAttrs(domNode, attrs)
	{
		for (var key in attrs)
		{
			var value = attrs[key];
			typeof value !== 'undefined'
				? domNode.setAttribute(key, value)
				: domNode.removeAttribute(key);
		}
	}
	
	
	
	// APPLY NAMESPACED ATTRS
	
	
	function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
	{
		for (var key in nsAttrs)
		{
			var pair = nsAttrs[key];
			var namespace = pair.f;
			var value = pair.o;
	
			typeof value !== 'undefined'
				? domNode.setAttributeNS(namespace, key, value)
				: domNode.removeAttributeNS(namespace, key);
		}
	}
	
	
	
	// APPLY EVENTS
	
	
	function _VirtualDom_applyEvents(domNode, eventNode, events)
	{
		var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
	
		for (var key in events)
		{
			var newHandler = events[key];
			var oldCallback = allCallbacks[key];
	
			if (!newHandler)
			{
				domNode.removeEventListener(key, oldCallback);
				allCallbacks[key] = undefined;
				continue;
			}
	
			if (oldCallback)
			{
				var oldHandler = oldCallback.q;
				if (oldHandler.$ === newHandler.$)
				{
					oldCallback.q = newHandler;
					continue;
				}
				domNode.removeEventListener(key, oldCallback);
			}
	
			oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
			domNode.addEventListener(key, oldCallback,
				_VirtualDom_passiveSupported
				&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
			);
			allCallbacks[key] = oldCallback;
		}
	}
	
	
	
	// PASSIVE EVENTS
	
	
	var _VirtualDom_passiveSupported;
	
	try
	{
		window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
			get: function() { _VirtualDom_passiveSupported = true; }
		}));
	}
	catch(e) {}
	
	
	
	// EVENT HANDLERS
	
	
	function _VirtualDom_makeCallback(eventNode, initialHandler)
	{
		function callback(event)
		{
			var handler = callback.q;
			var result = _Json_runHelp(handler.a, event);
	
			if (!elm$core$Result$isOk(result))
			{
				return;
			}
	
			var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);
	
			// 0 = Normal
			// 1 = MayStopPropagation
			// 2 = MayPreventDefault
			// 3 = Custom
	
			var value = result.a;
			var message = !tag ? value : tag < 3 ? value.a : value.message;
			var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
			var currentEventNode = (
				stopPropagation && event.stopPropagation(),
				(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
				eventNode
			);
			var tagger;
			var i;
			while (tagger = currentEventNode.j)
			{
				if (typeof tagger == 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.p;
			}
			currentEventNode(message, stopPropagation); // stopPropagation implies isSync
		}
	
		callback.q = initialHandler;
	
		return callback;
	}
	
	function _VirtualDom_equalEvents(x, y)
	{
		return x.$ == y.$ && _Json_equality(x.a, y.a);
	}
	
	
	
	// DIFF
	
	
	// TODO: Should we do patches like in iOS?
	//
	// type Patch
	//   = At Int Patch
	//   | Batch (List Patch)
	//   | Change ...
	//
	// How could it not be better?
	//
	function _VirtualDom_diff(x, y)
	{
		var patches = [];
		_VirtualDom_diffHelp(x, y, patches, 0);
		return patches;
	}
	
	
	function _VirtualDom_pushPatch(patches, type, index, data)
	{
		var patch = {
			$: type,
			r: index,
			s: data,
			t: undefined,
			u: undefined
		};
		patches.push(patch);
		return patch;
	}
	
	
	function _VirtualDom_diffHelp(x, y, patches, index)
	{
		if (x === y)
		{
			return;
		}
	
		var xType = x.$;
		var yType = y.$;
	
		// Bail if you run into different types of nodes. Implies that the
		// structure has changed significantly and it's not worth a diff.
		if (xType !== yType)
		{
			if (xType === 1 && yType === 2)
			{
				y = _VirtualDom_dekey(y);
				yType = 1;
			}
			else
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}
		}
	
		// Now we know that both nodes are the same $.
		switch (yType)
		{
			case 5:
				var xRefs = x.l;
				var yRefs = y.l;
				var i = xRefs.length;
				var same = i === yRefs.length;
				while (same && i--)
				{
					same = xRefs[i] === yRefs[i];
				}
				if (same)
				{
					y.k = x.k;
					return;
				}
				y.k = y.m();
				var subPatches = [];
				_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
				subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
				return;
	
			case 4:
				// gather nested taggers
				var xTaggers = x.j;
				var yTaggers = y.j;
				var nesting = false;
	
				var xSubNode = x.k;
				while (xSubNode.$ === 4)
				{
					nesting = true;
	
					typeof xTaggers !== 'object'
						? xTaggers = [xTaggers, xSubNode.j]
						: xTaggers.push(xSubNode.j);
	
					xSubNode = xSubNode.k;
				}
	
				var ySubNode = y.k;
				while (ySubNode.$ === 4)
				{
					nesting = true;
	
					typeof yTaggers !== 'object'
						? yTaggers = [yTaggers, ySubNode.j]
						: yTaggers.push(ySubNode.j);
	
					ySubNode = ySubNode.k;
				}
	
				// Just bail if different numbers of taggers. This implies the
				// structure of the virtual DOM has changed.
				if (nesting && xTaggers.length !== yTaggers.length)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				// check if taggers are "the same"
				if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
				{
					_VirtualDom_pushPatch(patches, 2, index, yTaggers);
				}
	
				// diff everything below the taggers
				_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
				return;
	
			case 0:
				if (x.a !== y.a)
				{
					_VirtualDom_pushPatch(patches, 3, index, y.a);
				}
				return;
	
			case 1:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
				return;
	
			case 2:
				_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
				return;
	
			case 3:
				if (x.h !== y.h)
				{
					_VirtualDom_pushPatch(patches, 0, index, y);
					return;
				}
	
				var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
				factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
				var patch = y.i(x.g, y.g);
				patch && _VirtualDom_pushPatch(patches, 5, index, patch);
	
				return;
		}
	}
	
	// assumes the incoming arrays are the same length
	function _VirtualDom_pairwiseRefEqual(as, bs)
	{
		for (var i = 0; i < as.length; i++)
		{
			if (as[i] !== bs[i])
			{
				return false;
			}
		}
	
		return true;
	}
	
	function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
	{
		// Bail if obvious indicators have changed. Implies more serious
		// structural changes such that it's not worth it to diff.
		if (x.c !== y.c || x.f !== y.f)
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	
		var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
		factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
	
		diffKids(x, y, patches, index);
	}
	
	
	
	// DIFF FACTS
	
	
	// TODO Instead of creating a new diff object, it's possible to just test if
	// there *is* a diff. During the actual patch, do the diff again and make the
	// modifications directly. This way, there's no new allocations. Worth it?
	function _VirtualDom_diffFacts(x, y, category)
	{
		var diff;
	
		// look for changes and removals
		for (var xKey in x)
		{
			if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
			{
				var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
				if (subDiff)
				{
					diff = diff || {};
					diff[xKey] = subDiff;
				}
				continue;
			}
	
			// remove if not in the new facts
			if (!(xKey in y))
			{
				diff = diff || {};
				diff[xKey] =
					!category
						? (typeof x[xKey] === 'string' ? '' : null)
						:
					(category === 'a1')
						? ''
						:
					(category === 'a0' || category === 'a3')
						? undefined
						:
					{ f: x[xKey].f, o: undefined };
	
				continue;
			}
	
			var xValue = x[xKey];
			var yValue = y[xKey];
	
			// reference equal, so don't worry about it
			if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
				|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
			{
				continue;
			}
	
			diff = diff || {};
			diff[xKey] = yValue;
		}
	
		// add new stuff
		for (var yKey in y)
		{
			if (!(yKey in x))
			{
				diff = diff || {};
				diff[yKey] = y[yKey];
			}
		}
	
		return diff;
	}
	
	
	
	// DIFF KIDS
	
	
	function _VirtualDom_diffKids(xParent, yParent, patches, index)
	{
		var xKids = xParent.e;
		var yKids = yParent.e;
	
		var xLen = xKids.length;
		var yLen = yKids.length;
	
		// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
	
		if (xLen > yLen)
		{
			_VirtualDom_pushPatch(patches, 6, index, {
				v: yLen,
				i: xLen - yLen
			});
		}
		else if (xLen < yLen)
		{
			_VirtualDom_pushPatch(patches, 7, index, {
				v: xLen,
				e: yKids
			});
		}
	
		// PAIRWISE DIFF EVERYTHING ELSE
	
		for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
		{
			var xKid = xKids[i];
			_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
			index += xKid.b || 0;
		}
	}
	
	
	
	// KEYED DIFF
	
	
	function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
	{
		var localPatches = [];
	
		var changes = {}; // Dict String Entry
		var inserts = []; // Array { index : Int, entry : Entry }
		// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
	
		var xKids = xParent.e;
		var yKids = yParent.e;
		var xLen = xKids.length;
		var yLen = yKids.length;
		var xIndex = 0;
		var yIndex = 0;
	
		var index = rootIndex;
	
		while (xIndex < xLen && yIndex < yLen)
		{
			var x = xKids[xIndex];
			var y = yKids[yIndex];
	
			var xKey = x.a;
			var yKey = y.a;
			var xNode = x.b;
			var yNode = y.b;
	
			var newMatch = undefined;
			var oldMatch = undefined;
	
			// check if keys match
	
			if (xKey === yKey)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex++;
				yIndex++;
				continue;
			}
	
			// look ahead 1 to detect insertions and removals.
	
			var xNext = xKids[xIndex + 1];
			var yNext = yKids[yIndex + 1];
	
			if (xNext)
			{
				var xNextKey = xNext.a;
				var xNextNode = xNext.b;
				oldMatch = yKey === xNextKey;
			}
	
			if (yNext)
			{
				var yNextKey = yNext.a;
				var yNextNode = yNext.b;
				newMatch = xKey === yNextKey;
			}
	
	
			// swap x and y
			if (newMatch && oldMatch)
			{
				index++;
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			// insert y
			if (newMatch)
			{
				index++;
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
				index += xNode.b || 0;
	
				xIndex += 1;
				yIndex += 2;
				continue;
			}
	
			// remove x
			if (oldMatch)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 1;
				continue;
			}
	
			// remove x, insert y
			if (xNext && xNextKey === yNextKey)
			{
				index++;
				_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
				_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
				index += xNode.b || 0;
	
				index++;
				_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
				index += xNextNode.b || 0;
	
				xIndex += 2;
				yIndex += 2;
				continue;
			}
	
			break;
		}
	
		// eat up any remaining nodes with removeNode and insertNode
	
		while (xIndex < xLen)
		{
			index++;
			var x = xKids[xIndex];
			var xNode = x.b;
			_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
			index += xNode.b || 0;
			xIndex++;
		}
	
		while (yIndex < yLen)
		{
			var endInserts = endInserts || [];
			var y = yKids[yIndex];
			_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
			yIndex++;
		}
	
		if (localPatches.length > 0 || inserts.length > 0 || endInserts)
		{
			_VirtualDom_pushPatch(patches, 8, rootIndex, {
				w: localPatches,
				x: inserts,
				y: endInserts
			});
		}
	}
	
	
	
	// CHANGES FROM KEYED DIFF
	
	
	var _VirtualDom_POSTFIX = '_elmW6BL';
	
	
	function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			entry = {
				c: 0,
				z: vnode,
				r: yIndex,
				s: undefined
			};
	
			inserts.push({ r: yIndex, A: entry });
			changes[key] = entry;
	
			return;
		}
	
		// this key was removed earlier, a match!
		if (entry.c === 1)
		{
			inserts.push({ r: yIndex, A: entry });
	
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
			entry.r = yIndex;
			entry.s.s = {
				w: subPatches,
				A: entry
			};
	
			return;
		}
	
		// this key has already been inserted or moved, a duplicate!
		_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
	}
	
	
	function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
	{
		var entry = changes[key];
	
		// never seen this key before
		if (!entry)
		{
			var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
	
			changes[key] = {
				c: 1,
				z: vnode,
				r: index,
				s: patch
			};
	
			return;
		}
	
		// this key was inserted earlier, a match!
		if (entry.c === 0)
		{
			entry.c = 2;
			var subPatches = [];
			_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
	
			_VirtualDom_pushPatch(localPatches, 9, index, {
				w: subPatches,
				A: entry
			});
	
			return;
		}
	
		// this key has already been removed or moved, a duplicate!
		_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
	}
	
	
	
	// ADD DOM NODES
	//
	// Each DOM node has an "index" assigned in order of traversal. It is important
	// to minimize our crawl over the actual DOM, so these indexes (along with the
	// descendantsCount of virtual nodes) let us skip touching entire subtrees of
	// the DOM if we know there are no patches there.
	
	
	function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
	{
		_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
	}
	
	
	// assumes `patches` is non-empty and indexes increase monotonically.
	function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
	{
		var patch = patches[i];
		var index = patch.r;
	
		while (index === low)
		{
			var patchType = patch.$;
	
			if (patchType === 1)
			{
				_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
			}
			else if (patchType === 8)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var subPatches = patch.s.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
			else if (patchType === 9)
			{
				patch.t = domNode;
				patch.u = eventNode;
	
				var data = patch.s;
				if (data)
				{
					data.A.s = domNode;
					var subPatches = data.w;
					if (subPatches.length > 0)
					{
						_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
					}
				}
			}
			else
			{
				patch.t = domNode;
				patch.u = eventNode;
			}
	
			i++;
	
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
	
		var tag = vNode.$;
	
		if (tag === 4)
		{
			var subNode = vNode.k;
	
			while (subNode.$ === 4)
			{
				subNode = subNode.k;
			}
	
			return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
		}
	
		// tag must be 1 or 2 at this point
	
		var vKids = vNode.e;
		var childNodes = domNode.childNodes;
		for (var j = 0; j < vKids.length; j++)
		{
			low++;
			var vKid = tag === 1 ? vKids[j] : vKids[j].b;
			var nextLow = low + (vKid.b || 0);
			if (low <= index && index <= nextLow)
			{
				i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
				if (!(patch = patches[i]) || (index = patch.r) > high)
				{
					return i;
				}
			}
			low = nextLow;
		}
		return i;
	}
	
	
	
	// APPLY PATCHES
	
	
	function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
	{
		if (patches.length === 0)
		{
			return rootDomNode;
		}
	
		_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
		return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
	}
	
	function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
	{
		for (var i = 0; i < patches.length; i++)
		{
			var patch = patches[i];
			var localDomNode = patch.t
			var newNode = _VirtualDom_applyPatch(localDomNode, patch);
			if (localDomNode === rootDomNode)
			{
				rootDomNode = newNode;
			}
		}
		return rootDomNode;
	}
	
	function _VirtualDom_applyPatch(domNode, patch)
	{
		switch (patch.$)
		{
			case 0:
				return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
	
			case 4:
				_VirtualDom_applyFacts(domNode, patch.u, patch.s);
				return domNode;
	
			case 3:
				domNode.replaceData(0, domNode.length, patch.s);
				return domNode;
	
			case 1:
				return _VirtualDom_applyPatchesHelp(domNode, patch.s);
	
			case 2:
				if (domNode.elm_event_node_ref)
				{
					domNode.elm_event_node_ref.j = patch.s;
				}
				else
				{
					domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
				}
				return domNode;
	
			case 6:
				var data = patch.s;
				for (var i = 0; i < data.i; i++)
				{
					domNode.removeChild(domNode.childNodes[data.v]);
				}
				return domNode;
	
			case 7:
				var data = patch.s;
				var kids = data.e;
				var i = data.v;
				var theEnd = domNode.childNodes[i];
				for (; i < kids.length; i++)
				{
					domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
				}
				return domNode;
	
			case 9:
				var data = patch.s;
				if (!data)
				{
					domNode.parentNode.removeChild(domNode);
					return domNode;
				}
				var entry = data.A;
				if (typeof entry.r !== 'undefined')
				{
					domNode.parentNode.removeChild(domNode);
				}
				entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
				return domNode;
	
			case 8:
				return _VirtualDom_applyPatchReorder(domNode, patch);
	
			case 5:
				return patch.s(domNode);
	
			default:
				_Debug_crash(10); // 'Ran into an unknown patch!'
		}
	}
	
	
	function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
	{
		var parentNode = domNode.parentNode;
		var newNode = _VirtualDom_render(vNode, eventNode);
	
		if (!newNode.elm_event_node_ref)
		{
			newNode.elm_event_node_ref = domNode.elm_event_node_ref;
		}
	
		if (parentNode && newNode !== domNode)
		{
			parentNode.replaceChild(newNode, domNode);
		}
		return newNode;
	}
	
	
	function _VirtualDom_applyPatchReorder(domNode, patch)
	{
		var data = patch.s;
	
		// remove end inserts
		var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
	
		// removals
		domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
	
		// inserts
		var inserts = data.x;
		for (var i = 0; i < inserts.length; i++)
		{
			var insert = inserts[i];
			var entry = insert.A;
			var node = entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u);
			domNode.insertBefore(node, domNode.childNodes[insert.r]);
		}
	
		// add end inserts
		if (frag)
		{
			_VirtualDom_appendChild(domNode, frag);
		}
	
		return domNode;
	}
	
	
	function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
	{
		if (!endInserts)
		{
			return;
		}
	
		var frag = _VirtualDom_doc.createDocumentFragment();
		for (var i = 0; i < endInserts.length; i++)
		{
			var insert = endInserts[i];
			var entry = insert.A;
			_VirtualDom_appendChild(frag, entry.c === 2
				? entry.s
				: _VirtualDom_render(entry.z, patch.u)
			);
		}
		return frag;
	}
	
	
	function _VirtualDom_virtualize(node)
	{
		// TEXT NODES
	
		if (node.nodeType === 3)
		{
			return _VirtualDom_text(node.textContent);
		}
	
	
		// WEIRD NODES
	
		if (node.nodeType !== 1)
		{
			return _VirtualDom_text('');
		}
	
	
		// ELEMENT NODES
	
		var attrList = _List_Nil;
		var attrs = node.attributes;
		for (var i = attrs.length; i--; )
		{
			var attr = attrs[i];
			var name = attr.name;
			var value = attr.value;
			attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
		}
	
		var tag = node.tagName.toLowerCase();
		var kidList = _List_Nil;
		var kids = node.childNodes;
	
		for (var i = kids.length; i--; )
		{
			kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
		}
		return A3(_VirtualDom_node, tag, attrList, kidList);
	}
	
	function _VirtualDom_dekey(keyedNode)
	{
		var keyedKids = keyedNode.e;
		var len = keyedKids.length;
		var kids = new Array(len);
		for (var i = 0; i < len; i++)
		{
			kids[i] = keyedKids[i].b;
		}
	
		return {
			$: 1,
			c: keyedNode.c,
			d: keyedNode.d,
			e: kids,
			f: keyedNode.f,
			b: keyedNode.b
		};
	}
	
	
	
	var _Bitwise_and = F2(function(a, b)
	{
		return a & b;
	});
	
	var _Bitwise_or = F2(function(a, b)
	{
		return a | b;
	});
	
	var _Bitwise_xor = F2(function(a, b)
	{
		return a ^ b;
	});
	
	function _Bitwise_complement(a)
	{
		return ~a;
	};
	
	var _Bitwise_shiftLeftBy = F2(function(offset, a)
	{
		return a << offset;
	});
	
	var _Bitwise_shiftRightBy = F2(function(offset, a)
	{
		return a >> offset;
	});
	
	var _Bitwise_shiftRightZfBy = F2(function(offset, a)
	{
		return a >>> offset;
	});
	
	
	
	
	// ELEMENT
	
	
	var _Debugger_element;
	
	var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var view = impl.view;
				/**_UNUSED/
				var domNode = args['node'];
				//*/
				/**/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);
	
				return _Browser_makeAnimator(initialModel, function(model)
				{
					var nextNode = view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});
			}
		);
	});
	
	
	
	// DOCUMENT
	
	
	var _Debugger_document;
	
	var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var view = impl.view;
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				var currNode = _VirtualDom_virtualize(bodyNode);
				return _Browser_makeAnimator(initialModel, function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});
			}
		);
	});
	
	
	
	// ANIMATION
	
	
	var _Browser_cancelAnimationFrame =
		typeof cancelAnimationFrame !== 'undefined'
			? cancelAnimationFrame
			: function(id) { clearTimeout(id); };
	
	var _Browser_requestAnimationFrame =
		typeof requestAnimationFrame !== 'undefined'
			? requestAnimationFrame
			: function(callback) { return setTimeout(callback, 1000 / 60); };
	
	
	function _Browser_makeAnimator(model, draw)
	{
		draw(model);
	
		var state = 0;
	
		function updateIfNeeded()
		{
			state = state === 1
				? 0
				: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
		}
	
		return function(nextModel, isSync)
		{
			model = nextModel;
	
			isSync
				? ( draw(model),
					state === 2 && (state = 1)
					)
				: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
					state = 2
					);
		};
	}
	
	
	
	// APPLICATION
	
	
	function _Browser_application(impl)
	{
		var onUrlChange = impl.onUrlChange;
		var onUrlRequest = impl.onUrlRequest;
		var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
	
		return _Browser_document({
			setup: function(sendToApp)
			{
				key.a = sendToApp;
				_Browser_window.addEventListener('popstate', key);
				_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
	
				return F2(function(domNode, event)
				{
					if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
					{
						event.preventDefault();
						var href = domNode.href;
						var curr = _Browser_getUrl();
						var next = elm$url$Url$fromString(href).a;
						sendToApp(onUrlRequest(
							(next
								&& curr.protocol === next.protocol
								&& curr.host === next.host
								&& curr.port_.a === next.port_.a
							)
								? elm$browser$Browser$Internal(next)
								: elm$browser$Browser$External(href)
						));
					}
				});
			},
			init: function(flags)
			{
				return A3(impl.init, flags, _Browser_getUrl(), key);
			},
			view: impl.view,
			update: impl.update,
			subscriptions: impl.subscriptions
		});
	}
	
	function _Browser_getUrl()
	{
		return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
	}
	
	var _Browser_go = F2(function(key, n)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			n && history.go(n);
			key();
		}));
	});
	
	var _Browser_pushUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.pushState({}, '', url);
			key();
		}));
	});
	
	var _Browser_replaceUrl = F2(function(key, url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
			history.replaceState({}, '', url);
			key();
		}));
	});
	
	
	
	// GLOBAL EVENTS
	
	
	var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
	var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
	var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
	
	var _Browser_on = F3(function(node, eventName, sendToSelf)
	{
		return _Scheduler_spawn(_Scheduler_binding(function(callback)
		{
			function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
			node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
			return function() { node.removeEventListener(eventName, handler); };
		}));
	});
	
	var _Browser_decodeEvent = F2(function(decoder, event)
	{
		var result = _Json_runHelp(decoder, event);
		return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
	});
	
	
	
	// PAGE VISIBILITY
	
	
	function _Browser_visibilityInfo()
	{
		return (typeof _VirtualDom_doc.hidden !== 'undefined')
			? { hidden: 'hidden', change: 'visibilitychange' }
			:
		(typeof _VirtualDom_doc.mozHidden !== 'undefined')
			? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
			:
		(typeof _VirtualDom_doc.msHidden !== 'undefined')
			? { hidden: 'msHidden', change: 'msvisibilitychange' }
			:
		(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
			? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
			: { hidden: 'hidden', change: 'visibilitychange' };
	}
	
	
	
	// ANIMATION FRAMES
	
	
	function _Browser_rAF()
	{
		return _Scheduler_binding(function(callback)
		{
			var id = _Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(Date.now()));
			});
	
			return function() {
				_Browser_cancelAnimationFrame(id);
			};
		});
	}
	
	
	function _Browser_now()
	{
		return _Scheduler_binding(function(callback)
		{
			callback(_Scheduler_succeed(Date.now()));
		});
	}
	
	
	
	// DOM STUFF
	
	
	function _Browser_withNode(id, doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				var node = document.getElementById(id);
				callback(node
					? _Scheduler_succeed(doStuff(node))
					: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
				);
			});
		});
	}
	
	
	function _Browser_withWindow(doStuff)
	{
		return _Scheduler_binding(function(callback)
		{
			_Browser_requestAnimationFrame(function() {
				callback(_Scheduler_succeed(doStuff()));
			});
		});
	}
	
	
	// FOCUS and BLUR
	
	
	var _Browser_call = F2(function(functionName, id)
	{
		return _Browser_withNode(id, function(node) {
			node[functionName]();
			return _Utils_Tuple0;
		});
	});
	
	
	
	// WINDOW VIEWPORT
	
	
	function _Browser_getViewport()
	{
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: _Browser_window.pageXOffset,
				y: _Browser_window.pageYOffset,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			}
		};
	}
	
	function _Browser_getScene()
	{
		var body = _Browser_doc.body;
		var elem = _Browser_doc.documentElement;
		return {
			width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
			height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
		};
	}
	
	var _Browser_setViewport = F2(function(x, y)
	{
		return _Browser_withWindow(function()
		{
			_Browser_window.scroll(x, y);
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT VIEWPORT
	
	
	function _Browser_getViewportOf(id)
	{
		return _Browser_withNode(id, function(node)
		{
			return {
				scene: {
					width: node.scrollWidth,
					height: node.scrollHeight
				},
				viewport: {
					x: node.scrollLeft,
					y: node.scrollTop,
					width: node.clientWidth,
					height: node.clientHeight
				}
			};
		});
	}
	
	
	var _Browser_setViewportOf = F3(function(id, x, y)
	{
		return _Browser_withNode(id, function(node)
		{
			node.scrollLeft = x;
			node.scrollTop = y;
			return _Utils_Tuple0;
		});
	});
	
	
	
	// ELEMENT
	
	
	function _Browser_getElement(id)
	{
		return _Browser_withNode(id, function(node)
		{
			var rect = node.getBoundingClientRect();
			var x = _Browser_window.pageXOffset;
			var y = _Browser_window.pageYOffset;
			return {
				scene: _Browser_getScene(),
				viewport: {
					x: x,
					y: y,
					width: _Browser_doc.documentElement.clientWidth,
					height: _Browser_doc.documentElement.clientHeight
				},
				element: {
					x: x + rect.left,
					y: y + rect.top,
					width: rect.width,
					height: rect.height
				}
			};
		});
	}
	
	
	
	// LOAD and RELOAD
	
	
	function _Browser_reload(skipCache)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			_VirtualDom_doc.location.reload(skipCache);
		}));
	}
	
	function _Browser_load(url)
	{
		return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
		{
			try
			{
				_Browser_window.location = url;
			}
			catch(err)
			{
				// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
				// Other browsers reload the page, so let's be consistent about that.
				_VirtualDom_doc.location.reload(false);
			}
		}));
	}
	var author$project$Components$TicketCompanyInfosCard$State$Model = F4(
		function (initData, patrimonyManagers, agencyInfos, usersInfosState) {
			return {agencyInfos: agencyInfos, initData: initData, patrimonyManagers: patrimonyManagers, usersInfosState: usersInfosState};
		});
	var author$project$TicketCompanyInfosCard$FetchAgencies = {$: 'FetchAgencies'};
	var author$project$TicketCompanyInfosCard$FetchPatrimonyManagers = {$: 'FetchPatrimonyManagers'};
	var elm$core$Basics$composeR = F3(
		function (f, g, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$identity = function (x) {
		return x;
	};
	var elm$core$Task$Perform = function (a) {
		return {$: 'Perform', a: a};
	};
	var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
	var elm$core$Array$foldr = F3(
		function (func, baseCase, _n0) {
			var tree = _n0.c;
			var tail = _n0.d;
			var helper = F2(
				function (node, acc) {
					if (node.$ === 'SubTree') {
						var subTree = node.a;
						return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var values = node.a;
						return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
					}
				});
			return A3(
				elm$core$Elm$JsArray$foldr,
				helper,
				A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
				tree);
		});
	var elm$core$Basics$EQ = {$: 'EQ'};
	var elm$core$Basics$LT = {$: 'LT'};
	var elm$core$List$cons = _List_cons;
	var elm$core$Array$toList = function (array) {
		return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
	};
	var elm$core$Basics$GT = {$: 'GT'};
	var elm$core$Dict$foldr = F3(
		function (func, acc, t) {
			foldr:
			while (true) {
				if (t.$ === 'RBEmpty_elm_builtin') {
					return acc;
				} else {
					var key = t.b;
					var value = t.c;
					var left = t.d;
					var right = t.e;
					var $temp$func = func,
						$temp$acc = A3(
						func,
						key,
						value,
						A3(elm$core$Dict$foldr, func, acc, right)),
						$temp$t = left;
					func = $temp$func;
					acc = $temp$acc;
					t = $temp$t;
					continue foldr;
				}
			}
		});
	var elm$core$Dict$toList = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, list) {
					return A2(
						elm$core$List$cons,
						_Utils_Tuple2(key, value),
						list);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Dict$keys = function (dict) {
		return A3(
			elm$core$Dict$foldr,
			F3(
				function (key, value, keyList) {
					return A2(elm$core$List$cons, key, keyList);
				}),
			_List_Nil,
			dict);
	};
	var elm$core$Set$toList = function (_n0) {
		var dict = _n0.a;
		return elm$core$Dict$keys(dict);
	};
	var elm$core$Task$succeed = _Scheduler_succeed;
	var elm$core$Task$init = elm$core$Task$succeed(_Utils_Tuple0);
	var elm$core$Basics$add = _Basics_add;
	var elm$core$Basics$gt = _Utils_gt;
	var elm$core$List$foldl = F3(
		function (func, acc, list) {
			foldl:
			while (true) {
				if (!list.b) {
					return acc;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$func = func,
						$temp$acc = A2(func, x, acc),
						$temp$list = xs;
					func = $temp$func;
					acc = $temp$acc;
					list = $temp$list;
					continue foldl;
				}
			}
		});
	var elm$core$List$reverse = function (list) {
		return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
	};
	var elm$core$List$foldrHelper = F4(
		function (fn, acc, ctr, ls) {
			if (!ls.b) {
				return acc;
			} else {
				var a = ls.a;
				var r1 = ls.b;
				if (!r1.b) {
					return A2(fn, a, acc);
				} else {
					var b = r1.a;
					var r2 = r1.b;
					if (!r2.b) {
						return A2(
							fn,
							a,
							A2(fn, b, acc));
					} else {
						var c = r2.a;
						var r3 = r2.b;
						if (!r3.b) {
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(fn, c, acc)));
						} else {
							var d = r3.a;
							var r4 = r3.b;
							var res = (ctr > 500) ? A3(
								elm$core$List$foldl,
								fn,
								acc,
								elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
							return A2(
								fn,
								a,
								A2(
									fn,
									b,
									A2(
										fn,
										c,
										A2(fn, d, res))));
						}
					}
				}
			}
		});
	var elm$core$List$foldr = F3(
		function (fn, acc, ls) {
			return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
		});
	var elm$core$List$map = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, acc) {
						return A2(
							elm$core$List$cons,
							f(x),
							acc);
					}),
				_List_Nil,
				xs);
		});
	var elm$core$Basics$apR = F2(
		function (x, f) {
			return f(x);
		});
	var elm$core$Task$andThen = _Scheduler_andThen;
	var elm$core$Task$map = F2(
		function (func, taskA) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return elm$core$Task$succeed(
						func(a));
				},
				taskA);
		});
	var elm$core$Task$map2 = F3(
		function (func, taskA, taskB) {
			return A2(
				elm$core$Task$andThen,
				function (a) {
					return A2(
						elm$core$Task$andThen,
						function (b) {
							return elm$core$Task$succeed(
								A2(func, a, b));
						},
						taskB);
				},
				taskA);
		});
	var elm$core$Task$sequence = function (tasks) {
		return A3(
			elm$core$List$foldr,
			elm$core$Task$map2(elm$core$List$cons),
			elm$core$Task$succeed(_List_Nil),
			tasks);
	};
	var elm$core$Basics$False = {$: 'False'};
	var elm$core$Basics$True = {$: 'True'};
	var elm$core$Result$isOk = function (result) {
		if (result.$ === 'Ok') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Array$branchFactor = 32;
	var elm$core$Array$Array_elm_builtin = F4(
		function (a, b, c, d) {
			return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
		});
	var elm$core$Basics$ceiling = _Basics_ceiling;
	var elm$core$Basics$fdiv = _Basics_fdiv;
	var elm$core$Basics$logBase = F2(
		function (base, number) {
			return _Basics_log(number) / _Basics_log(base);
		});
	var elm$core$Basics$toFloat = _Basics_toFloat;
	var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
		A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
	var elm$core$Elm$JsArray$empty = _JsArray_empty;
	var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
	var elm$core$Array$Leaf = function (a) {
		return {$: 'Leaf', a: a};
	};
	var elm$core$Array$SubTree = function (a) {
		return {$: 'SubTree', a: a};
	};
	var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
	var elm$core$Array$compressNodes = F2(
		function (nodes, acc) {
			compressNodes:
			while (true) {
				var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
				var node = _n0.a;
				var remainingNodes = _n0.b;
				var newAcc = A2(
					elm$core$List$cons,
					elm$core$Array$SubTree(node),
					acc);
				if (!remainingNodes.b) {
					return elm$core$List$reverse(newAcc);
				} else {
					var $temp$nodes = remainingNodes,
						$temp$acc = newAcc;
					nodes = $temp$nodes;
					acc = $temp$acc;
					continue compressNodes;
				}
			}
		});
	var elm$core$Basics$eq = _Utils_equal;
	var elm$core$Tuple$first = function (_n0) {
		var x = _n0.a;
		return x;
	};
	var elm$core$Array$treeFromBuilder = F2(
		function (nodeList, nodeListSize) {
			treeFromBuilder:
			while (true) {
				var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
				if (newNodeSize === 1) {
					return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
				} else {
					var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
						$temp$nodeListSize = newNodeSize;
					nodeList = $temp$nodeList;
					nodeListSize = $temp$nodeListSize;
					continue treeFromBuilder;
				}
			}
		});
	var elm$core$Basics$apL = F2(
		function (f, x) {
			return f(x);
		});
	var elm$core$Basics$floor = _Basics_floor;
	var elm$core$Basics$max = F2(
		function (x, y) {
			return (_Utils_cmp(x, y) > 0) ? x : y;
		});
	var elm$core$Basics$mul = _Basics_mul;
	var elm$core$Basics$sub = _Basics_sub;
	var elm$core$Elm$JsArray$length = _JsArray_length;
	var elm$core$Array$builderToArray = F2(
		function (reverseNodeList, builder) {
			if (!builder.nodeListSize) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail),
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					builder.tail);
			} else {
				var treeLen = builder.nodeListSize * elm$core$Array$branchFactor;
				var depth = elm$core$Basics$floor(
					A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
				var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.nodeList) : builder.nodeList;
				var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
				return A4(
					elm$core$Array$Array_elm_builtin,
					elm$core$Elm$JsArray$length(builder.tail) + treeLen,
					A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
					tree,
					builder.tail);
			}
		});
	var elm$core$Basics$idiv = _Basics_idiv;
	var elm$core$Basics$lt = _Utils_lt;
	var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
	var elm$core$Array$initializeHelp = F5(
		function (fn, fromIndex, len, nodeList, tail) {
			initializeHelp:
			while (true) {
				if (fromIndex < 0) {
					return A2(
						elm$core$Array$builderToArray,
						false,
						{nodeList: nodeList, nodeListSize: (len / elm$core$Array$branchFactor) | 0, tail: tail});
				} else {
					var leaf = elm$core$Array$Leaf(
						A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
					var $temp$fn = fn,
						$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
						$temp$len = len,
						$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
						$temp$tail = tail;
					fn = $temp$fn;
					fromIndex = $temp$fromIndex;
					len = $temp$len;
					nodeList = $temp$nodeList;
					tail = $temp$tail;
					continue initializeHelp;
				}
			}
		});
	var elm$core$Basics$le = _Utils_le;
	var elm$core$Basics$remainderBy = _Basics_remainderBy;
	var elm$core$Array$initialize = F2(
		function (len, fn) {
			if (len <= 0) {
				return elm$core$Array$empty;
			} else {
				var tailLen = len % elm$core$Array$branchFactor;
				var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
				var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
				return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
			}
		});
	var elm$core$Maybe$Just = function (a) {
		return {$: 'Just', a: a};
	};
	var elm$core$Maybe$Nothing = {$: 'Nothing'};
	var elm$core$Result$Err = function (a) {
		return {$: 'Err', a: a};
	};
	var elm$core$Result$Ok = function (a) {
		return {$: 'Ok', a: a};
	};
	var elm$json$Json$Decode$Failure = F2(
		function (a, b) {
			return {$: 'Failure', a: a, b: b};
		});
	var elm$json$Json$Decode$Field = F2(
		function (a, b) {
			return {$: 'Field', a: a, b: b};
		});
	var elm$json$Json$Decode$Index = F2(
		function (a, b) {
			return {$: 'Index', a: a, b: b};
		});
	var elm$json$Json$Decode$OneOf = function (a) {
		return {$: 'OneOf', a: a};
	};
	var elm$core$Basics$and = _Basics_and;
	var elm$core$Basics$append = _Utils_append;
	var elm$core$Basics$or = _Basics_or;
	var elm$core$Char$toCode = _Char_toCode;
	var elm$core$Char$isLower = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (97 <= code) && (code <= 122);
	};
	var elm$core$Char$isUpper = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 90) && (65 <= code);
	};
	var elm$core$Char$isAlpha = function (_char) {
		return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
	};
	var elm$core$Char$isDigit = function (_char) {
		var code = elm$core$Char$toCode(_char);
		return (code <= 57) && (48 <= code);
	};
	var elm$core$Char$isAlphaNum = function (_char) {
		return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
	};
	var elm$core$List$length = function (xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n0, i) {
					return i + 1;
				}),
			0,
			xs);
	};
	var elm$core$List$map2 = _List_map2;
	var elm$core$List$rangeHelp = F3(
		function (lo, hi, list) {
			rangeHelp:
			while (true) {
				if (_Utils_cmp(lo, hi) < 1) {
					var $temp$lo = lo,
						$temp$hi = hi - 1,
						$temp$list = A2(elm$core$List$cons, hi, list);
					lo = $temp$lo;
					hi = $temp$hi;
					list = $temp$list;
					continue rangeHelp;
				} else {
					return list;
				}
			}
		});
	var elm$core$List$range = F2(
		function (lo, hi) {
			return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
		});
	var elm$core$List$indexedMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$map2,
				f,
				A2(
					elm$core$List$range,
					0,
					elm$core$List$length(xs) - 1),
				xs);
		});
	var elm$core$String$all = _String_all;
	var elm$core$String$fromInt = _String_fromNumber;
	var elm$core$String$join = F2(
		function (sep, chunks) {
			return A2(
				_String_join,
				sep,
				_List_toArray(chunks));
		});
	var elm$core$String$uncons = _String_uncons;
	var elm$core$String$split = F2(
		function (sep, string) {
			return _List_fromArray(
				A2(_String_split, sep, string));
		});
	var elm$json$Json$Decode$indent = function (str) {
		return A2(
			elm$core$String$join,
			'\n    ',
			A2(elm$core$String$split, '\n', str));
	};
	var elm$json$Json$Encode$encode = _Json_encode;
	var elm$json$Json$Decode$errorOneOf = F2(
		function (i, error) {
			return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
				elm$json$Json$Decode$errorToString(error))));
		});
	var elm$json$Json$Decode$errorToString = function (error) {
		return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
	};
	var elm$json$Json$Decode$errorToStringHelp = F2(
		function (error, context) {
			errorToStringHelp:
			while (true) {
				switch (error.$) {
					case 'Field':
						var f = error.a;
						var err = error.b;
						var isSimple = function () {
							var _n1 = elm$core$String$uncons(f);
							if (_n1.$ === 'Nothing') {
								return false;
							} else {
								var _n2 = _n1.a;
								var _char = _n2.a;
								var rest = _n2.b;
								return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
							}
						}();
						var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, fieldName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'Index':
						var i = error.a;
						var err = error.b;
						var indexName = '[' + (elm$core$String$fromInt(i) + ']');
						var $temp$error = err,
							$temp$context = A2(elm$core$List$cons, indexName, context);
						error = $temp$error;
						context = $temp$context;
						continue errorToStringHelp;
					case 'OneOf':
						var errors = error.a;
						if (!errors.b) {
							return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
								if (!context.b) {
									return '!';
								} else {
									return ' at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
						} else {
							if (!errors.b.b) {
								var err = errors.a;
								var $temp$error = err,
									$temp$context = context;
								error = $temp$error;
								context = $temp$context;
								continue errorToStringHelp;
							} else {
								var starter = function () {
									if (!context.b) {
										return 'Json.Decode.oneOf';
									} else {
										return 'The Json.Decode.oneOf at json' + A2(
											elm$core$String$join,
											'',
											elm$core$List$reverse(context));
									}
								}();
								var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
									elm$core$List$length(errors)) + ' ways:'));
								return A2(
									elm$core$String$join,
									'\n\n',
									A2(
										elm$core$List$cons,
										introduction,
										A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
							}
						}
					default:
						var msg = error.a;
						var json = error.b;
						var introduction = function () {
							if (!context.b) {
								return 'Problem with the given value:\n\n';
							} else {
								return 'Problem with the value at json' + (A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context)) + ':\n\n    ');
							}
						}();
						return introduction + (elm$json$Json$Decode$indent(
							A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
				}
			}
		});
	var elm$core$Platform$sendToApp = _Platform_sendToApp;
	var elm$core$Task$spawnCmd = F2(
		function (router, _n0) {
			var task = _n0.a;
			return _Scheduler_spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToApp(router),
					task));
		});
	var elm$core$Task$onEffects = F3(
		function (router, commands, state) {
			return A2(
				elm$core$Task$map,
				function (_n0) {
					return _Utils_Tuple0;
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						elm$core$Task$spawnCmd(router),
						commands)));
		});
	var elm$core$Task$onSelfMsg = F3(
		function (_n0, _n1, _n2) {
			return elm$core$Task$succeed(_Utils_Tuple0);
		});
	var elm$core$Task$cmdMap = F2(
		function (tagger, _n0) {
			var task = _n0.a;
			return elm$core$Task$Perform(
				A2(elm$core$Task$map, tagger, task));
		});
	_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
	var elm$core$Task$command = _Platform_leaf('Task');
	var elm$core$Task$perform = F2(
		function (toMessage, task) {
			return elm$core$Task$command(
				elm$core$Task$Perform(
					A2(elm$core$Task$map, toMessage, task)));
		});
	var author$project$Utils$Command$msgToElmCmd = A2(
		elm$core$Basics$composeR,
		elm$core$Task$succeed,
		elm$core$Task$perform(elm$core$Basics$identity));
	var elm$core$Platform$Cmd$batch = _Platform_batch;
	var author$project$TicketCompanyInfosCard$init = function (flags) {
		return _Utils_Tuple2(
			A4(author$project$Components$TicketCompanyInfosCard$State$Model, flags, _List_Nil, elm$core$Maybe$Nothing, _List_Nil),
			elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						author$project$Utils$Command$msgToElmCmd(author$project$TicketCompanyInfosCard$FetchPatrimonyManagers),
						author$project$Utils$Command$msgToElmCmd(author$project$TicketCompanyInfosCard$FetchAgencies)
					])));
	};
	var elm$core$Platform$Sub$batch = _Platform_batch;
	var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
	var author$project$TicketCompanyInfosCard$subscriptions = function (model) {
		return elm$core$Platform$Sub$none;
	};
	var elm$json$Json$Decode$map2 = _Json_map2;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
	var elm$json$Json$Decode$field = _Json_decodeField;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
		function (key, valDecoder, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(elm$json$Json$Decode$field, key, valDecoder),
				decoder);
		});
	var author$project$Components$TicketCompanyInfosCard$State$Address = F4(
		function (number, street, zipCode, city) {
			return {city: city, number: number, street: street, zipCode: zipCode};
		});
	var elm$json$Json$Decode$string = _Json_decodeString;
	var elm$json$Json$Decode$succeed = _Json_succeed;
	var author$project$Binding$PatrimonyManagerInfosDecoder$addressDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'city',
		elm$json$Json$Decode$string,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'zipCode',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'street',
				elm$json$Json$Decode$string,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'number',
					elm$json$Json$Decode$string,
					elm$json$Json$Decode$succeed(author$project$Components$TicketCompanyInfosCard$State$Address)))));
	var author$project$Components$TicketCompanyInfosCard$State$AgencyInfos = F3(
		function (address, phones, emails) {
			return {address: address, emails: emails, phones: phones};
		});
	var elm$json$Json$Decode$list = _Json_decodeList;
	var author$project$Binding$PatrimonyManagerInfosDecoder$agencyInfosDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'emails',
		elm$json$Json$Decode$list(elm$json$Json$Decode$string),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phones',
			elm$json$Json$Decode$list(elm$json$Json$Decode$string),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'address',
				author$project$Binding$PatrimonyManagerInfosDecoder$addressDecoder,
				elm$json$Json$Decode$succeed(author$project$Components$TicketCompanyInfosCard$State$AgencyInfos))));
	var elm$json$Json$Decode$andThen = _Json_andThen;
	var elm$json$Json$Decode$decodeValue = _Json_run;
	var elm$json$Json$Decode$fail = _Json_fail;
	var elm$json$Json$Decode$null = _Json_decodeNull;
	var elm$json$Json$Decode$oneOf = _Json_oneOf;
	var elm$json$Json$Decode$value = _Json_decodeValue;
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
		function (pathDecoder, valDecoder, fallback) {
			var nullOr = function (decoder) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							decoder,
							elm$json$Json$Decode$null(fallback)
						]));
			};
			var handleResult = function (input) {
				var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
				if (_n0.$ === 'Ok') {
					var rawValue = _n0.a;
					var _n1 = A2(
						elm$json$Json$Decode$decodeValue,
						nullOr(valDecoder),
						rawValue);
					if (_n1.$ === 'Ok') {
						var finalResult = _n1.a;
						return elm$json$Json$Decode$succeed(finalResult);
					} else {
						var finalErr = _n1.a;
						return elm$json$Json$Decode$fail(
							elm$json$Json$Decode$errorToString(finalErr));
					}
				} else {
					return elm$json$Json$Decode$succeed(fallback);
				}
			};
			return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
		});
	var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
		function (key, valDecoder, fallback, decoder) {
			return A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
					A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
					valDecoder,
					fallback),
				decoder);
		});
	var author$project$Components$TicketCompanyInfosCard$State$UserInfos = F5(
		function (uid, name, email, phoneNumber, job) {
			return {email: email, job: job, name: name, phoneNumber: phoneNumber, uid: uid};
		});
	var elm$json$Json$Decode$map = _Json_map1;
	var elm$json$Json$Decode$nullable = function (decoder) {
		return elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
				]));
	};
	var author$project$Binding$PatrimonyManagerInfosDecoder$userInfosDecoder = A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'job',
		elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
		elm$core$Maybe$Nothing,
		A4(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'phoneNumber',
			elm$json$Json$Decode$nullable(elm$json$Json$Decode$string),
			elm$core$Maybe$Nothing,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'email',
				elm$json$Json$Decode$string,
				A3(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					elm$json$Json$Decode$string,
					A3(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uid',
						elm$json$Json$Decode$string,
						elm$json$Json$Decode$succeed(author$project$Components$TicketCompanyInfosCard$State$UserInfos))))));
	var author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink = F3(
		function (rel, href, method) {
			return {href: href, method: method, rel: rel};
		});
	var author$project$Binding$RestNavigationLinkDecoder$DELETE = {$: 'DELETE'};
	var author$project$Binding$RestNavigationLinkDecoder$GET = {$: 'GET'};
	var author$project$Binding$RestNavigationLinkDecoder$PATCH = {$: 'PATCH'};
	var author$project$Binding$RestNavigationLinkDecoder$POST = {$: 'POST'};
	var author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder = function (s) {
		switch (s) {
			case 'GET':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$GET);
			case 'POST':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$POST);
			case 'PATCH':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$PATCH);
			case 'DELETE':
				return elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$DELETE);
			default:
				var other = s;
				return elm$json$Json$Decode$fail(other + ' is not an known http verb in app');
		}
	};
	var author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder = A2(elm$json$Json$Decode$andThen, author$project$Binding$RestNavigationLinkDecoder$string2HttpVerbDecoder, elm$json$Json$Decode$string);
	var author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder = A3(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'method',
		author$project$Binding$RestNavigationLinkDecoder$httpVerbDecoder,
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'href',
			elm$json$Json$Decode$string,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rel',
				elm$json$Json$Decode$string,
				elm$json$Json$Decode$succeed(author$project$Binding$RestNavigationLinkDecoder$RestNavigationLink))));
	var author$project$Binding$ResultDecoder$ResultRecord = F2(
		function (result, links) {
			return {links: links, result: result};
		});
	var author$project$Binding$ResultDecoder$resultDecoder = function (listDecoder) {
		return A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_links',
			elm$json$Json$Decode$list(author$project$Binding$RestNavigationLinkDecoder$restNavigationLinkDecoder),
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'result',
				listDecoder,
				elm$json$Json$Decode$succeed(author$project$Binding$ResultDecoder$ResultRecord)));
	};
	var author$project$Binding$ResultDecoder$resultsDecoder = function (listDecoder) {
		return A2(
			elm$json$Json$Decode$map,
			function (x) {
				return x.result;
			},
			author$project$Binding$ResultDecoder$resultDecoder(listDecoder));
	};
	var author$project$Components$TicketCompanyInfosCard$State$Display = {$: 'Display'};
	var author$project$Components$TicketCompanyInfosCard$State$Hide = {$: 'Hide'};
	var author$project$Components$TicketCompanyInfosCard$State$toggle = function (s) {
		if (s.$ === 'Display') {
			return author$project$Components$TicketCompanyInfosCard$State$Hide;
		} else {
			return author$project$Components$TicketCompanyInfosCard$State$Display;
		}
	};
	var author$project$TicketCompanyInfosCard$AgenciesFetched = function (a) {
		return {$: 'AgenciesFetched', a: a};
	};
	var author$project$TicketCompanyInfosCard$PatrimonyManagersFetched = function (a) {
		return {$: 'PatrimonyManagersFetched', a: a};
	};
	var author$project$Components$TicketCompanyInfosCard$State$ContactInfosToggleState = F2(
		function (uid, state) {
			return {state: state, uid: uid};
		});
	var author$project$TicketCompanyInfosCard$initToggleState = function (u) {
		return A2(author$project$Components$TicketCompanyInfosCard$State$ContactInfosToggleState, u.uid, author$project$Components$TicketCompanyInfosCard$State$Hide);
	};
	var author$project$Utils$Http$HttpRequest$Get = F2(
		function (a, b) {
			return {$: 'Get', a: a, b: b};
		});
	var elm$http$Http$Request = function (a) {
		return {$: 'Request', a: a};
	};
	var elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
	var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
	var elm$http$Http$State = F2(
		function (reqs, subs) {
			return {reqs: reqs, subs: subs};
		});
	var elm$http$Http$init = elm$core$Task$succeed(
		A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
	var elm$core$Basics$compare = _Utils_compare;
	var elm$core$Dict$get = F2(
		function (targetKey, dict) {
			get:
			while (true) {
				if (dict.$ === 'RBEmpty_elm_builtin') {
					return elm$core$Maybe$Nothing;
				} else {
					var key = dict.b;
					var value = dict.c;
					var left = dict.d;
					var right = dict.e;
					var _n1 = A2(elm$core$Basics$compare, targetKey, key);
					switch (_n1.$) {
						case 'LT':
							var $temp$targetKey = targetKey,
								$temp$dict = left;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
						case 'EQ':
							return elm$core$Maybe$Just(value);
						default:
							var $temp$targetKey = targetKey,
								$temp$dict = right;
							targetKey = $temp$targetKey;
							dict = $temp$dict;
							continue get;
					}
				}
			}
		});
	var elm$core$Dict$Black = {$: 'Black'};
	var elm$core$Dict$RBNode_elm_builtin = F5(
		function (a, b, c, d, e) {
			return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
		});
	var elm$core$Dict$Red = {$: 'Red'};
	var elm$core$Dict$balance = F5(
		function (color, key, value, left, right) {
			if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
				var _n1 = right.a;
				var rK = right.b;
				var rV = right.c;
				var rLeft = right.d;
				var rRight = right.e;
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
					var _n3 = left.a;
					var lK = left.b;
					var lV = left.c;
					var lLeft = left.d;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						key,
						value,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						rK,
						rV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, left, rLeft),
						rRight);
				}
			} else {
				if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
					var _n5 = left.a;
					var lK = left.b;
					var lV = left.c;
					var _n6 = left.d;
					var _n7 = _n6.a;
					var llK = _n6.b;
					var llV = _n6.c;
					var llLeft = _n6.d;
					var llRight = _n6.e;
					var lRight = left.e;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Red,
						lK,
						lV,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, lRight, right));
				} else {
					return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
				}
			}
		});
	var elm$core$Dict$insertHelp = F3(
		function (key, value, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
			} else {
				var nColor = dict.a;
				var nKey = dict.b;
				var nValue = dict.c;
				var nLeft = dict.d;
				var nRight = dict.e;
				var _n1 = A2(elm$core$Basics$compare, key, nKey);
				switch (_n1.$) {
					case 'LT':
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							A3(elm$core$Dict$insertHelp, key, value, nLeft),
							nRight);
					case 'EQ':
						return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
					default:
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							nLeft,
							A3(elm$core$Dict$insertHelp, key, value, nRight));
				}
			}
		});
	var elm$core$Dict$insert = F3(
		function (key, value, dict) {
			var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Dict$getMin = function (dict) {
		getMin:
		while (true) {
			if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
				var left = dict.d;
				var $temp$dict = left;
				dict = $temp$dict;
				continue getMin;
			} else {
				return dict;
			}
		}
	};
	var elm$core$Dict$moveRedLeft = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var lLeft = _n1.d;
				var lRight = _n1.e;
				var _n2 = dict.e;
				var rClr = _n2.a;
				var rK = _n2.b;
				var rV = _n2.c;
				var rLeft = _n2.d;
				var _n3 = rLeft.a;
				var rlK = rLeft.b;
				var rlV = rLeft.c;
				var rlL = rLeft.d;
				var rlR = rLeft.e;
				var rRight = _n2.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					rlK,
					rlV,
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						rlL),
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, rK, rV, rlR, rRight));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n4 = dict.d;
				var lClr = _n4.a;
				var lK = _n4.b;
				var lV = _n4.c;
				var lLeft = _n4.d;
				var lRight = _n4.e;
				var _n5 = dict.e;
				var rClr = _n5.a;
				var rK = _n5.b;
				var rV = _n5.c;
				var rLeft = _n5.d;
				var rRight = _n5.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$moveRedRight = function (dict) {
		if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
			if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n1 = dict.d;
				var lClr = _n1.a;
				var lK = _n1.b;
				var lV = _n1.c;
				var _n2 = _n1.d;
				var _n3 = _n2.a;
				var llK = _n2.b;
				var llV = _n2.c;
				var llLeft = _n2.d;
				var llRight = _n2.e;
				var lRight = _n1.e;
				var _n4 = dict.e;
				var rClr = _n4.a;
				var rK = _n4.b;
				var rV = _n4.c;
				var rLeft = _n4.d;
				var rRight = _n4.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					elm$core$Dict$Red,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						lRight,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight)));
			} else {
				var clr = dict.a;
				var k = dict.b;
				var v = dict.c;
				var _n5 = dict.d;
				var lClr = _n5.a;
				var lK = _n5.b;
				var lV = _n5.c;
				var lLeft = _n5.d;
				var lRight = _n5.e;
				var _n6 = dict.e;
				var rClr = _n6.a;
				var rK = _n6.b;
				var rV = _n6.c;
				var rLeft = _n6.d;
				var rRight = _n6.e;
				if (clr.$ === 'Black') {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						elm$core$Dict$Black,
						k,
						v,
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, lK, lV, lLeft, lRight),
						A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, rK, rV, rLeft, rRight));
				}
			}
		} else {
			return dict;
		}
	};
	var elm$core$Dict$removeHelpPrepEQGT = F7(
		function (targetKey, dict, color, key, value, left, right) {
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _n1 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					lK,
					lV,
					lLeft,
					A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Red, key, value, lRight, right));
			} else {
				_n2$2:
				while (true) {
					if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
						if (right.d.$ === 'RBNode_elm_builtin') {
							if (right.d.a.$ === 'Black') {
								var _n3 = right.a;
								var _n4 = right.d;
								var _n5 = _n4.a;
								return elm$core$Dict$moveRedRight(dict);
							} else {
								break _n2$2;
							}
						} else {
							var _n6 = right.a;
							var _n7 = right.d;
							return elm$core$Dict$moveRedRight(dict);
						}
					} else {
						break _n2$2;
					}
				}
				return dict;
			}
		});
	var elm$core$Dict$removeMin = function (dict) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var lColor = left.a;
			var lLeft = left.d;
			var right = dict.e;
			if (lColor.$ === 'Black') {
				if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
					var _n3 = lLeft.a;
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						elm$core$Dict$removeMin(left),
						right);
				} else {
					var _n4 = elm$core$Dict$moveRedLeft(dict);
					if (_n4.$ === 'RBNode_elm_builtin') {
						var nColor = _n4.a;
						var nKey = _n4.b;
						var nValue = _n4.c;
						var nLeft = _n4.d;
						var nRight = _n4.e;
						return A5(
							elm$core$Dict$balance,
							nColor,
							nKey,
							nValue,
							elm$core$Dict$removeMin(nLeft),
							nRight);
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	};
	var elm$core$Dict$removeHelp = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return elm$core$Dict$RBEmpty_elm_builtin;
			} else {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_cmp(targetKey, key) < 0) {
					if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
						var _n4 = left.a;
						var lLeft = left.d;
						if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
							var _n6 = lLeft.a;
							return A5(
								elm$core$Dict$RBNode_elm_builtin,
								color,
								key,
								value,
								A2(elm$core$Dict$removeHelp, targetKey, left),
								right);
						} else {
							var _n7 = elm$core$Dict$moveRedLeft(dict);
							if (_n7.$ === 'RBNode_elm_builtin') {
								var nColor = _n7.a;
								var nKey = _n7.b;
								var nValue = _n7.c;
								var nLeft = _n7.d;
								var nRight = _n7.e;
								return A5(
									elm$core$Dict$balance,
									nColor,
									nKey,
									nValue,
									A2(elm$core$Dict$removeHelp, targetKey, nLeft),
									nRight);
							} else {
								return elm$core$Dict$RBEmpty_elm_builtin;
							}
						}
					} else {
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					}
				} else {
					return A2(
						elm$core$Dict$removeHelpEQGT,
						targetKey,
						A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
				}
			}
		});
	var elm$core$Dict$removeHelpEQGT = F2(
		function (targetKey, dict) {
			if (dict.$ === 'RBNode_elm_builtin') {
				var color = dict.a;
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				if (_Utils_eq(targetKey, key)) {
					var _n1 = elm$core$Dict$getMin(right);
					if (_n1.$ === 'RBNode_elm_builtin') {
						var minKey = _n1.b;
						var minValue = _n1.c;
						return A5(
							elm$core$Dict$balance,
							color,
							minKey,
							minValue,
							left,
							elm$core$Dict$removeMin(right));
					} else {
						return elm$core$Dict$RBEmpty_elm_builtin;
					}
				} else {
					return A5(
						elm$core$Dict$balance,
						color,
						key,
						value,
						left,
						A2(elm$core$Dict$removeHelp, targetKey, right));
				}
			} else {
				return elm$core$Dict$RBEmpty_elm_builtin;
			}
		});
	var elm$core$Dict$remove = F2(
		function (key, dict) {
			var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
			if ((_n0.$ === 'RBNode_elm_builtin') && (_n0.a.$ === 'Red')) {
				var _n1 = _n0.a;
				var k = _n0.b;
				var v = _n0.c;
				var l = _n0.d;
				var r = _n0.e;
				return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, k, v, l, r);
			} else {
				var x = _n0;
				return x;
			}
		});
	var elm$core$Process$kill = _Scheduler_kill;
	var elm$core$Process$spawn = _Scheduler_spawn;
	var elm$core$Dict$update = F3(
		function (targetKey, alter, dictionary) {
			var _n0 = alter(
				A2(elm$core$Dict$get, targetKey, dictionary));
			if (_n0.$ === 'Just') {
				var value = _n0.a;
				return A3(elm$core$Dict$insert, targetKey, value, dictionary);
			} else {
				return A2(elm$core$Dict$remove, targetKey, dictionary);
			}
		});
	var elm$core$Maybe$isJust = function (maybe) {
		if (maybe.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
	var elm$core$Result$map = F2(
		function (func, ra) {
			if (ra.$ === 'Ok') {
				var a = ra.a;
				return elm$core$Result$Ok(
					func(a));
			} else {
				var e = ra.a;
				return elm$core$Result$Err(e);
			}
		});
	var elm$http$Http$BadStatus_ = F2(
		function (a, b) {
			return {$: 'BadStatus_', a: a, b: b};
		});
	var elm$http$Http$BadUrl_ = function (a) {
		return {$: 'BadUrl_', a: a};
	};
	var elm$http$Http$GoodStatus_ = F2(
		function (a, b) {
			return {$: 'GoodStatus_', a: a, b: b};
		});
	var elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
	var elm$http$Http$Receiving = function (a) {
		return {$: 'Receiving', a: a};
	};
	var elm$http$Http$Sending = function (a) {
		return {$: 'Sending', a: a};
	};
	var elm$http$Http$Timeout_ = {$: 'Timeout_'};
	var elm$http$Http$updateReqs = F3(
		function (router, cmds, reqs) {
			updateReqs:
			while (true) {
				if (!cmds.b) {
					return elm$core$Task$succeed(reqs);
				} else {
					var cmd = cmds.a;
					var otherCmds = cmds.b;
					if (cmd.$ === 'Cancel') {
						var tracker = cmd.a;
						var _n2 = A2(elm$core$Dict$get, tracker, reqs);
						if (_n2.$ === 'Nothing') {
							var $temp$router = router,
								$temp$cmds = otherCmds,
								$temp$reqs = reqs;
							router = $temp$router;
							cmds = $temp$cmds;
							reqs = $temp$reqs;
							continue updateReqs;
						} else {
							var pid = _n2.a;
							return A2(
								elm$core$Task$andThen,
								function (_n3) {
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A2(elm$core$Dict$remove, tracker, reqs));
								},
								elm$core$Process$kill(pid));
						}
					} else {
						var req = cmd.a;
						return A2(
							elm$core$Task$andThen,
							function (pid) {
								var _n4 = req.tracker;
								if (_n4.$ === 'Nothing') {
									return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
								} else {
									var tracker = _n4.a;
									return A3(
										elm$http$Http$updateReqs,
										router,
										otherCmds,
										A3(elm$core$Dict$insert, tracker, pid, reqs));
								}
							},
							elm$core$Process$spawn(
								A3(
									_Http_toTask,
									router,
									elm$core$Platform$sendToApp(router),
									req)));
					}
				}
			}
		});
	var elm$http$Http$onEffects = F4(
		function (router, cmds, subs, state) {
			return A2(
				elm$core$Task$andThen,
				function (reqs) {
					return elm$core$Task$succeed(
						A2(elm$http$Http$State, reqs, subs));
				},
				A3(elm$http$Http$updateReqs, router, cmds, state.reqs));
		});
	var elm$core$List$maybeCons = F3(
		function (f, mx, xs) {
			var _n0 = f(mx);
			if (_n0.$ === 'Just') {
				var x = _n0.a;
				return A2(elm$core$List$cons, x, xs);
			} else {
				return xs;
			}
		});
	var elm$core$List$filterMap = F2(
		function (f, xs) {
			return A3(
				elm$core$List$foldr,
				elm$core$List$maybeCons(f),
				_List_Nil,
				xs);
		});
	var elm$http$Http$maybeSend = F4(
		function (router, desiredTracker, progress, _n0) {
			var actualTracker = _n0.a;
			var toMsg = _n0.b;
			return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
				A2(
					elm$core$Platform$sendToApp,
					router,
					toMsg(progress))) : elm$core$Maybe$Nothing;
		});
	var elm$http$Http$onSelfMsg = F3(
		function (router, _n0, state) {
			var tracker = _n0.a;
			var progress = _n0.b;
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				elm$core$Task$sequence(
					A2(
						elm$core$List$filterMap,
						A3(elm$http$Http$maybeSend, router, tracker, progress),
						state.subs)));
		});
	var elm$http$Http$Cancel = function (a) {
		return {$: 'Cancel', a: a};
	};
	var elm$http$Http$cmdMap = F2(
		function (func, cmd) {
			if (cmd.$ === 'Cancel') {
				var tracker = cmd.a;
				return elm$http$Http$Cancel(tracker);
			} else {
				var r = cmd.a;
				return elm$http$Http$Request(
					{
						allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
						body: r.body,
						expect: A2(_Http_mapExpect, func, r.expect),
						headers: r.headers,
						method: r.method,
						timeout: r.timeout,
						tracker: r.tracker,
						url: r.url
					});
			}
		});
	var elm$http$Http$MySub = F2(
		function (a, b) {
			return {$: 'MySub', a: a, b: b};
		});
	var elm$http$Http$subMap = F2(
		function (func, _n0) {
			var tracker = _n0.a;
			var toMsg = _n0.b;
			return A2(
				elm$http$Http$MySub,
				tracker,
				A2(elm$core$Basics$composeR, toMsg, func));
		});
	_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
	var elm$http$Http$command = _Platform_leaf('Http');
	var elm$http$Http$subscription = _Platform_leaf('Http');
	var elm$http$Http$riskyRequest = function (r) {
		return elm$http$Http$command(
			elm$http$Http$Request(
				{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
	};
	var author$project$Utils$Http$HttpRequest$executeRequest = F5(
		function (method, headers, url, body, expect) {
			return elm$http$Http$riskyRequest(
				{body: body, expect: expect, headers: headers, method: method, timeout: elm$core$Maybe$Nothing, tracker: elm$core$Maybe$Nothing, url: url});
		});
	var elm$http$Http$emptyBody = _Http_emptyBody;
	var author$project$Utils$Http$HttpRequest$withAuthReq = function (req) {
		switch (req.$) {
			case 'Get':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'GET', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Delete':
				var url = req.a;
				var msg = req.b;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'DELETE', _List_Nil, url, elm$http$Http$emptyBody, msg);
			case 'Post':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'POST', _List_Nil, url, body, msg);
			case 'Put':
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PUT', _List_Nil, url, body, msg);
			default:
				var url = req.a;
				var body = req.b;
				var msg = req.c;
				return A5(author$project$Utils$Http$HttpRequest$executeRequest, 'PATCH', _List_Nil, url, body, msg);
		}
	};
	var elm$core$List$head = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(x);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$Maybe$map = F2(
		function (f, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return elm$core$Maybe$Just(
					f(value));
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
	var elm$core$Maybe$withDefault = F2(
		function (_default, maybe) {
			if (maybe.$ === 'Just') {
				var value = maybe.a;
				return value;
			} else {
				return _default;
			}
		});
	var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
	var elm$core$Result$withDefault = F2(
		function (def, result) {
			if (result.$ === 'Ok') {
				var a = result.a;
				return a;
			} else {
				return def;
			}
		});
	var elm$core$Result$mapError = F2(
		function (f, result) {
			if (result.$ === 'Ok') {
				var v = result.a;
				return elm$core$Result$Ok(v);
			} else {
				var e = result.a;
				return elm$core$Result$Err(
					f(e));
			}
		});
	var elm$http$Http$expectStringResponse = F2(
		function (toMsg, toResult) {
			return A3(
				_Http_expect,
				'',
				elm$core$Basics$identity,
				A2(elm$core$Basics$composeR, toResult, toMsg));
		});
	var elm$http$Http$BadBody = function (a) {
		return {$: 'BadBody', a: a};
	};
	var elm$http$Http$BadStatus = function (a) {
		return {$: 'BadStatus', a: a};
	};
	var elm$http$Http$BadUrl = function (a) {
		return {$: 'BadUrl', a: a};
	};
	var elm$http$Http$NetworkError = {$: 'NetworkError'};
	var elm$http$Http$Timeout = {$: 'Timeout'};
	var elm$http$Http$resolve = F2(
		function (toResult, response) {
			switch (response.$) {
				case 'BadUrl_':
					var url = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadUrl(url));
				case 'Timeout_':
					return elm$core$Result$Err(elm$http$Http$Timeout);
				case 'NetworkError_':
					return elm$core$Result$Err(elm$http$Http$NetworkError);
				case 'BadStatus_':
					var metadata = response.a;
					return elm$core$Result$Err(
						elm$http$Http$BadStatus(metadata.statusCode));
				default:
					var body = response.b;
					return A2(
						elm$core$Result$mapError,
						elm$http$Http$BadBody,
						toResult(body));
			}
		});
	var elm$json$Json$Decode$decodeString = _Json_runOnString;
	var elm$http$Http$expectJson = F2(
		function (toMsg, decoder) {
			return A2(
				elm$http$Http$expectStringResponse,
				toMsg,
				elm$http$Http$resolve(
					function (string) {
						return A2(
							elm$core$Result$mapError,
							elm$json$Json$Decode$errorToString,
							A2(elm$json$Json$Decode$decodeString, decoder, string));
					}));
		});
	var elm_community$list_extra$List$Extra$updateIf = F3(
		function (predicate, update, list) {
			return A2(
				elm$core$List$map,
				function (item) {
					return predicate(item) ? update(item) : item;
				},
				list);
		});
	var author$project$TicketCompanyInfosCard$update = F2(
		function (msg, model) {
			switch (msg.$) {
				case 'FetchAgencies':
					var uri = function (a) {
						return model.initData.apiUrl + ('/clientcompanies/' + (model.initData.company.uid + ('/agencies/' + a.uid)));
					};
					var cmd = function (a) {
						return author$project$Utils$Http$HttpRequest$withAuthReq(
							A2(
								author$project$Utils$Http$HttpRequest$Get,
								uri(a),
								A2(elm$http$Http$expectJson, author$project$TicketCompanyInfosCard$AgenciesFetched, author$project$Binding$PatrimonyManagerInfosDecoder$agencyInfosDecoder)));
					};
					var agency = elm$core$List$head(model.initData.agencies);
					return _Utils_Tuple2(
						model,
						A2(
							elm$core$Maybe$withDefault,
							elm$core$Platform$Cmd$none,
							A2(elm$core$Maybe$map, cmd, agency)));
				case 'FetchPatrimonyManagers':
					var url = model.initData.apiUrl + ('/patrimonies/' + (A2(elm$core$Maybe$withDefault, 'test', model.initData.patrimonyUid) + '/patrimonymanagers?active=true'));
					var cmd = author$project$Utils$Http$HttpRequest$withAuthReq(
						A2(
							author$project$Utils$Http$HttpRequest$Get,
							url,
							A2(
								elm$http$Http$expectJson,
								author$project$TicketCompanyInfosCard$PatrimonyManagersFetched,
								author$project$Binding$ResultDecoder$resultsDecoder(
									elm$json$Json$Decode$list(author$project$Binding$PatrimonyManagerInfosDecoder$userInfosDecoder)))));
					return _Utils_Tuple2(model, cmd);
				case 'AgenciesFetched':
					var result = msg.a;
					return A2(
						elm$core$Result$withDefault,
						_Utils_Tuple2(model, elm$core$Platform$Cmd$none),
						A2(
							elm$core$Result$map,
							function (ai) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											agencyInfos: elm$core$Maybe$Just(ai)
										}),
									elm$core$Platform$Cmd$none);
							},
							result));
				case 'PatrimonyManagersFetched':
					var result = msg.a;
					return A2(
						elm$core$Result$withDefault,
						_Utils_Tuple2(model, elm$core$Platform$Cmd$none),
						A2(
							elm$core$Result$map,
							function (ps) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											patrimonyManagers: ps,
											usersInfosState: A2(elm$core$List$map, author$project$TicketCompanyInfosCard$initToggleState, ps)
										}),
									elm$core$Platform$Cmd$none);
							},
							result));
				default:
					var uid = msg.a;
					var newState = A3(
						elm_community$list_extra$List$Extra$updateIf,
						function (s) {
							return _Utils_eq(s.uid, uid);
						},
						function (s) {
							return _Utils_update(
								s,
								{
									state: author$project$Components$TicketCompanyInfosCard$State$toggle(s.state)
								});
						},
						model.usersInfosState);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{usersInfosState: newState}),
						elm$core$Platform$Cmd$none);
			}
		});
	var author$project$TicketCompanyInfosCard$toStringAddress = function (address) {
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[address.number, address.street, address.zipCode, address.city]));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
		function (a, b, c) {
			return {$: 'Node', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$VirtualDom$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$Node;
	var rtfeldman$elm_css$Html$Styled$node = rtfeldman$elm_css$VirtualDom$Styled$node;
	var rtfeldman$elm_css$Html$Styled$li = rtfeldman$elm_css$Html$Styled$node('li');
	var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
		switch (handler.$) {
			case 'Normal':
				return 0;
			case 'MayStopPropagation':
				return 1;
			case 'MayPreventDefault':
				return 2;
			default:
				return 3;
		}
	};
	var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
	var rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
		return {$: 'Unstyled', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
		return rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			elm$virtual_dom$VirtualDom$text(str));
	};
	var rtfeldman$elm_css$Html$Styled$text = rtfeldman$elm_css$VirtualDom$Styled$text;
	var author$project$TicketCompanyInfosCard$agencyContacts = function (agency) {
		return _List_fromArray(
			[
				A2(
				rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text(
						author$project$TicketCompanyInfosCard$toStringAddress(agency.address))
					])),
				A2(
				rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text(
						'Tel: ' + A2(elm$core$String$join, ', ', agency.phones))
					])),
				A2(
				rtfeldman$elm_css$Html$Styled$li,
				_List_Nil,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$text(
						'Emails: ' + A2(elm$core$String$join, ', ', agency.emails))
					]))
			]);
	};
	var author$project$TicketCompanyInfosCard$agencyName = function (model) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function ($) {
					return $.name;
				},
				elm$core$List$head(model.initData.agencies)));
	};
	var rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
		return {$: 'AppendProperty', a: a};
	};
	var rtfeldman$elm_css$Css$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$prop1 = F2(
		function (key, arg) {
			return A2(rtfeldman$elm_css$Css$property, key, arg.value);
		});
	var rtfeldman$elm_css$Css$center = rtfeldman$elm_css$Css$prop1('center');
	var rtfeldman$elm_css$Css$color = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'color', c.value);
	};
	var rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
	var elm$core$String$fromFloat = _String_fromNumber;
	var rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
	var rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
		function (units, unitLabel, numericValue) {
			return {
				absoluteLength: rtfeldman$elm_css$Css$Structure$Compatible,
				calc: rtfeldman$elm_css$Css$Structure$Compatible,
				flexBasis: rtfeldman$elm_css$Css$Structure$Compatible,
				fontSize: rtfeldman$elm_css$Css$Structure$Compatible,
				length: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrAutoOrCoverOrContain: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
				lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
				numericValue: numericValue,
				textIndent: rtfeldman$elm_css$Css$Structure$Compatible,
				unitLabel: unitLabel,
				units: units,
				value: _Utils_ap(
					elm$core$String$fromFloat(numericValue),
					unitLabel)
			};
		});
	var rtfeldman$elm_css$Css$em = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$EmUnits, 'em');
	var rtfeldman$elm_css$Css$fontWeight = function (_n0) {
		var value = _n0.value;
		return A2(rtfeldman$elm_css$Css$property, 'font-weight', value);
	};
	var elm$core$String$length = _String_length;
	var elm$core$String$slice = _String_slice;
	var elm$core$String$dropLeft = F2(
		function (n, string) {
			return (n < 1) ? string : A3(
				elm$core$String$slice,
				n,
				elm$core$String$length(string),
				string);
		});
	var elm$core$String$startsWith = _String_startsWith;
	var elm$core$String$foldr = _String_foldr;
	var elm$core$String$toList = function (string) {
		return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
	};
	var elm$core$String$cons = _String_cons;
	var rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
		return A2(elm$core$String$startsWith, '#', str) ? str : A2(
			elm$core$String$cons,
			_Utils_chr('#'),
			str);
	};
	var rtfeldman$elm_css$Css$erroneousHex = function (str) {
		return {
			alpha: 1,
			blue: 0,
			color: rtfeldman$elm_css$Css$Structure$Compatible,
			green: 0,
			red: 0,
			value: rtfeldman$elm_css$Css$withPrecedingHash(str)
		};
	};
	var elm$core$String$fromList = _String_fromList;
	var elm$core$String$toLower = _String_toLower;
	var elm$core$Basics$negate = function (n) {
		return -n;
	};
	var elm$core$List$tail = function (list) {
		if (list.b) {
			var x = list.a;
			var xs = list.b;
			return elm$core$Maybe$Just(xs);
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	var elm$core$String$isEmpty = function (string) {
		return string === '';
	};
	var elm$core$Basics$pow = _Basics_pow;
	var elm$core$String$fromChar = function (_char) {
		return A2(elm$core$String$cons, _char, '');
	};
	var rtfeldman$elm_hex$Hex$fromStringHelp = F3(
		function (position, chars, accumulated) {
			fromStringHelp:
			while (true) {
				if (!chars.b) {
					return elm$core$Result$Ok(accumulated);
				} else {
					var _char = chars.a;
					var rest = chars.b;
					switch (_char.valueOf()) {
						case '0':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated;
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '1':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + A2(elm$core$Basics$pow, 16, position);
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '2':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (2 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '3':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (3 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '4':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (4 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '5':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (5 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '6':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (6 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '7':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (7 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '8':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (8 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case '9':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (9 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'a':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (10 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'b':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (11 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'c':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (12 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'd':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (13 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'e':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (14 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						case 'f':
							var $temp$position = position - 1,
								$temp$chars = rest,
								$temp$accumulated = accumulated + (15 * A2(elm$core$Basics$pow, 16, position));
							position = $temp$position;
							chars = $temp$chars;
							accumulated = $temp$accumulated;
							continue fromStringHelp;
						default:
							var nonHex = _char;
							return elm$core$Result$Err(
								elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
					}
				}
			}
		});
	var rtfeldman$elm_hex$Hex$fromString = function (str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
		} else {
			var result = function () {
				if (A2(elm$core$String$startsWith, '-', str)) {
					var list = A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						elm$core$List$tail(
							elm$core$String$toList(str)));
					return A2(
						elm$core$Result$map,
						elm$core$Basics$negate,
						A3(
							rtfeldman$elm_hex$Hex$fromStringHelp,
							elm$core$List$length(list) - 1,
							list,
							0));
				} else {
					return A3(
						rtfeldman$elm_hex$Hex$fromStringHelp,
						elm$core$String$length(str) - 1,
						elm$core$String$toList(str),
						0);
				}
			}();
			var formatError = function (err) {
				return A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
			};
			return A2(elm$core$Result$mapError, formatError, result);
		}
	};
	var rtfeldman$elm_css$Css$validHex = F5(
		function (str, _n0, _n1, _n2, _n3) {
			var r1 = _n0.a;
			var r2 = _n0.b;
			var g1 = _n1.a;
			var g2 = _n1.b;
			var b1 = _n2.a;
			var b2 = _n2.b;
			var a1 = _n3.a;
			var a2 = _n3.b;
			var toResult = A2(
				elm$core$Basics$composeR,
				elm$core$String$fromList,
				A2(elm$core$Basics$composeR, elm$core$String$toLower, rtfeldman$elm_hex$Hex$fromString));
			var results = _Utils_Tuple2(
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[r1, r2])),
					toResult(
						_List_fromArray(
							[g1, g2]))),
				_Utils_Tuple2(
					toResult(
						_List_fromArray(
							[b1, b2])),
					toResult(
						_List_fromArray(
							[a1, a2]))));
			if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
				var _n5 = results.a;
				var red = _n5.a.a;
				var green = _n5.b.a;
				var _n6 = results.b;
				var blue = _n6.a.a;
				var alpha = _n6.b.a;
				return {
					alpha: alpha / 255,
					blue: blue,
					color: rtfeldman$elm_css$Css$Structure$Compatible,
					green: green,
					red: red,
					value: rtfeldman$elm_css$Css$withPrecedingHash(str)
				};
			} else {
				return rtfeldman$elm_css$Css$erroneousHex(str);
			}
		});
	var rtfeldman$elm_css$Css$hex = function (str) {
		var withoutHash = A2(elm$core$String$startsWith, '#', str) ? A2(elm$core$String$dropLeft, 1, str) : str;
		var _n0 = elm$core$String$toList(withoutHash);
		_n0$4:
		while (true) {
			if ((_n0.b && _n0.b.b) && _n0.b.b.b) {
				if (!_n0.b.b.b.b) {
					var r = _n0.a;
					var _n1 = _n0.b;
					var g = _n1.a;
					var _n2 = _n1.b;
					var b = _n2.a;
					return A5(
						rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(
							_Utils_chr('f'),
							_Utils_chr('f')));
				} else {
					if (!_n0.b.b.b.b.b) {
						var r = _n0.a;
						var _n3 = _n0.b;
						var g = _n3.a;
						var _n4 = _n3.b;
						var b = _n4.a;
						var _n5 = _n4.b;
						var a = _n5.a;
						return A5(
							rtfeldman$elm_css$Css$validHex,
							str,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					} else {
						if (_n0.b.b.b.b.b.b) {
							if (!_n0.b.b.b.b.b.b.b) {
								var r1 = _n0.a;
								var _n6 = _n0.b;
								var r2 = _n6.a;
								var _n7 = _n6.b;
								var g1 = _n7.a;
								var _n8 = _n7.b;
								var g2 = _n8.a;
								var _n9 = _n8.b;
								var b1 = _n9.a;
								var _n10 = _n9.b;
								var b2 = _n10.a;
								return A5(
									rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(
										_Utils_chr('f'),
										_Utils_chr('f')));
							} else {
								if (_n0.b.b.b.b.b.b.b.b && (!_n0.b.b.b.b.b.b.b.b.b)) {
									var r1 = _n0.a;
									var _n11 = _n0.b;
									var r2 = _n11.a;
									var _n12 = _n11.b;
									var g1 = _n12.a;
									var _n13 = _n12.b;
									var g2 = _n13.a;
									var _n14 = _n13.b;
									var b1 = _n14.a;
									var _n15 = _n14.b;
									var b2 = _n15.a;
									var _n16 = _n15.b;
									var a1 = _n16.a;
									var _n17 = _n16.b;
									var a2 = _n17.a;
									return A5(
										rtfeldman$elm_css$Css$validHex,
										str,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								} else {
									break _n0$4;
								}
							}
						} else {
							break _n0$4;
						}
					}
				}
			} else {
				break _n0$4;
			}
		}
		return rtfeldman$elm_css$Css$erroneousHex(str);
	};
	var rtfeldman$elm_css$Css$UnitlessInteger = {$: 'UnitlessInteger'};
	var rtfeldman$elm_css$Css$int = function (val) {
		return {
			fontWeight: rtfeldman$elm_css$Css$Structure$Compatible,
			intOrAuto: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
			number: rtfeldman$elm_css$Css$Structure$Compatible,
			numberOrInfinite: rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: val,
			unitLabel: '',
			units: rtfeldman$elm_css$Css$UnitlessInteger,
			value: elm$core$String$fromInt(val)
		};
	};
	var rtfeldman$elm_css$Css$marginBottom = rtfeldman$elm_css$Css$prop1('margin-bottom');
	var rtfeldman$elm_css$Css$Internal$property = F2(
		function (key, value) {
			return rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
		});
	var rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
		return {$: 'ApplyStyles', a: a};
	};
	var rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
		function (functionName, desiredKey, style) {
			getOverloadedProperty:
			while (true) {
				switch (style.$) {
					case 'AppendProperty':
						var str = style.a;
						var key = A2(
							elm$core$Maybe$withDefault,
							'',
							elm$core$List$head(
								A2(elm$core$String$split, ':', str)));
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
					case 'ExtendSelector':
						var selector = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
					case 'NestSnippet':
						var combinator = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
					case 'WithPseudoElement':
						var pseudoElement = style.a;
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
					case 'WithMedia':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
					case 'WithKeyframes':
						return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
					default:
						if (!style.a.b) {
							return A2(rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
						} else {
							if (!style.a.b.b) {
								var _n1 = style.a;
								var only = _n1.a;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = only;
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							} else {
								var _n2 = style.a;
								var first = _n2.a;
								var rest = _n2.b;
								var $temp$functionName = functionName,
									$temp$desiredKey = desiredKey,
									$temp$style = rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
								functionName = $temp$functionName;
								desiredKey = $temp$desiredKey;
								style = $temp$style;
								continue getOverloadedProperty;
							}
						}
				}
			}
		});
	var rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
	var rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
	var rtfeldman$elm_css$Css$textAlign = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'textAlign',
			'text-align',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$textTransform = rtfeldman$elm_css$Css$prop1('text-transform');
	var rtfeldman$elm_css$Css$uppercase = {textTransform: rtfeldman$elm_css$Css$Structure$Compatible, value: 'uppercase'};
	var elm$json$Json$Encode$string = _Json_wrap;
	var elm$virtual_dom$VirtualDom$property = F2(
		function (key, value) {
			return A2(
				_VirtualDom_property,
				_VirtualDom_noInnerHtmlOrFormAction(key),
				_VirtualDom_noJavaScriptOrHtmlUri(value));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
		function (a, b, c) {
			return {$: 'Attribute', a: a, b: b, c: c};
		});
	var elm$core$List$isEmpty = function (xs) {
		if (!xs.b) {
			return true;
		} else {
			return false;
		}
	};
	var elm$core$List$singleton = function (value) {
		return _List_fromArray(
			[value]);
	};
	var rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
		return {charset: elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
	};
	var elm$core$List$append = F2(
		function (xs, ys) {
			if (!ys.b) {
				return xs;
			} else {
				return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
			}
		});
	var elm$core$List$concat = function (lists) {
		return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
	};
	var elm$core$List$concatMap = F2(
		function (f, list) {
			return elm$core$List$concat(
				A2(elm$core$List$map, f, list));
		});
	var rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_n0) {
		var declarations = _n0.a;
		return declarations;
	};
	var elm$core$Basics$neq = _Utils_notEqual;
	var elm$core$List$takeReverse = F3(
		function (n, list, kept) {
			takeReverse:
			while (true) {
				if (n <= 0) {
					return kept;
				} else {
					if (!list.b) {
						return kept;
					} else {
						var x = list.a;
						var xs = list.b;
						var $temp$n = n - 1,
							$temp$list = xs,
							$temp$kept = A2(elm$core$List$cons, x, kept);
						n = $temp$n;
						list = $temp$list;
						kept = $temp$kept;
						continue takeReverse;
					}
				}
			}
		});
	var elm$core$List$takeTailRec = F2(
		function (n, list) {
			return elm$core$List$reverse(
				A3(elm$core$List$takeReverse, n, list, _List_Nil));
		});
	var elm$core$List$takeFast = F3(
		function (ctr, n, list) {
			if (n <= 0) {
				return _List_Nil;
			} else {
				var _n0 = _Utils_Tuple2(n, list);
				_n0$1:
				while (true) {
					_n0$5:
					while (true) {
						if (!_n0.b.b) {
							return list;
						} else {
							if (_n0.b.b.b) {
								switch (_n0.a) {
									case 1:
										break _n0$1;
									case 2:
										var _n2 = _n0.b;
										var x = _n2.a;
										var _n3 = _n2.b;
										var y = _n3.a;
										return _List_fromArray(
											[x, y]);
									case 3:
										if (_n0.b.b.b.b) {
											var _n4 = _n0.b;
											var x = _n4.a;
											var _n5 = _n4.b;
											var y = _n5.a;
											var _n6 = _n5.b;
											var z = _n6.a;
											return _List_fromArray(
												[x, y, z]);
										} else {
											break _n0$5;
										}
									default:
										if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
											var _n7 = _n0.b;
											var x = _n7.a;
											var _n8 = _n7.b;
											var y = _n8.a;
											var _n9 = _n8.b;
											var z = _n9.a;
											var _n10 = _n9.b;
											var w = _n10.a;
											var tl = _n10.b;
											return (ctr > 1000) ? A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
												elm$core$List$cons,
												x,
												A2(
													elm$core$List$cons,
													y,
													A2(
														elm$core$List$cons,
														z,
														A2(
															elm$core$List$cons,
															w,
															A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
										} else {
											break _n0$5;
										}
								}
							} else {
								if (_n0.a === 1) {
									break _n0$1;
								} else {
									break _n0$5;
								}
							}
						}
					}
					return list;
				}
				var _n1 = _n0.b;
				var x = _n1.a;
				return _List_fromArray(
					[x]);
			}
		});
	var elm$core$List$take = F2(
		function (n, list) {
			return A3(elm$core$List$takeFast, 0, n, list);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
		collectSelectors:
		while (true) {
			if (!declarations.b) {
				return _List_Nil;
			} else {
				if (declarations.a.$ === 'StyleBlockDeclaration') {
					var _n1 = declarations.a.a;
					var firstSelector = _n1.a;
					var otherSelectors = _n1.b;
					var rest = declarations.b;
					return _Utils_ap(
						A2(elm$core$List$cons, firstSelector, otherSelectors),
						rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
				} else {
					var rest = declarations.b;
					var $temp$declarations = rest;
					declarations = $temp$declarations;
					continue collectSelectors;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
		last:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!list.b.b) {
					var singleton = list.a;
					return elm$core$Maybe$Just(singleton);
				} else {
					var rest = list.b;
					var $temp$list = rest;
					list = $temp$list;
					continue last;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
		lastDeclaration:
		while (true) {
			if (!declarations.b) {
				return elm$core$Maybe$Nothing;
			} else {
				if (!declarations.b.b) {
					var x = declarations.a;
					return elm$core$Maybe$Just(
						_List_fromArray(
							[x]));
				} else {
					var xs = declarations.b;
					var $temp$declarations = xs;
					declarations = $temp$declarations;
					continue lastDeclaration;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
		oneOf:
		while (true) {
			if (!maybes.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var maybe = maybes.a;
				var rest = maybes.b;
				if (maybe.$ === 'Nothing') {
					var $temp$maybes = rest;
					maybes = $temp$maybes;
					continue oneOf;
				} else {
					return maybe;
				}
			}
		}
	};
	var rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
		return {$: 'FontFeatureValues', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
		var expandTuples = function (tuplesToExpand) {
			if (!tuplesToExpand.b) {
				return _List_Nil;
			} else {
				var properties = tuplesToExpand.a;
				var rest = tuplesToExpand.b;
				return A2(
					elm$core$List$cons,
					properties,
					expandTuples(rest));
			}
		};
		var newTuples = expandTuples(tuples);
		return _List_fromArray(
			[
				rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
			]);
	};
	var rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
		function (a, b, c, d, e) {
			return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
		function (str1, str2, str3, str4, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var structureStyleBlock = declaration.a;
				return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			} else {
				return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$MediaRule = F2(
		function (a, b) {
			return {$: 'MediaRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
		function (a, b) {
			return {$: 'SupportsRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
		function (mediaQueries, declaration) {
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var structureStyleBlock = declaration.a;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						mediaQueries,
						_List_fromArray(
							[structureStyleBlock]));
				case 'MediaRule':
					var newMediaQueries = declaration.a;
					var structureStyleBlocks = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$MediaRule,
						_Utils_ap(mediaQueries, newMediaQueries),
						structureStyleBlocks);
				case 'SupportsRule':
					var str = declaration.a;
					var declarations = declaration.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$SupportsRule,
						str,
						A2(
							elm$core$List$map,
							rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
							declarations));
				case 'DocumentRule':
					var str1 = declaration.a;
					var str2 = declaration.b;
					var str3 = declaration.c;
					var str4 = declaration.d;
					var structureStyleBlock = declaration.e;
					return A5(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
				case 'PageRule':
					return declaration;
				case 'FontFace':
					return declaration;
				case 'Keyframes':
					return declaration;
				case 'Viewport':
					return declaration;
				case 'CounterStyle':
					return declaration;
				default:
					return declaration;
			}
		});
	var rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
		return {$: 'CounterStyle', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
		return {$: 'FontFace', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
		return {$: 'Keyframes', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$PageRule = F2(
		function (a, b) {
			return {$: 'PageRule', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$Selector = F3(
		function (a, b, c) {
			return {$: 'Selector', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
		return {$: 'Viewport', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$mapLast = F2(
		function (update, list) {
			if (!list.b) {
				return list;
			} else {
				if (!list.b.b) {
					var only = list.a;
					return _List_fromArray(
						[
							update(only)
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
		function (property, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			return A3(
				rtfeldman$elm_css$Css$Structure$StyleBlock,
				firstSelector,
				otherSelectors,
				_Utils_ap(
					properties,
					_List_fromArray(
						[property])));
		});
	var rtfeldman$elm_css$Css$Structure$appendProperty = F2(
		function (property, declarations) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return _List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
									A2(rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
								]);
						case 'MediaRule':
							var _n1 = declarations.a;
							var mediaQueries = _n1.a;
							var styleBlocks = _n1.b;
							return _List_fromArray(
								[
									A2(
									rtfeldman$elm_css$Css$Structure$MediaRule,
									mediaQueries,
									A2(
										rtfeldman$elm_css$Css$Structure$mapLast,
										rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
										styleBlocks))
								]);
						default:
							return declarations;
					}
				} else {
					var first = declarations.a;
					var rest = declarations.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
		function (f, styleBlock) {
			if (!styleBlock.b.b) {
				var only = styleBlock.a;
				var properties = styleBlock.c;
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
						A3(
						rtfeldman$elm_css$Css$Structure$StyleBlock,
						f(only),
						_List_Nil,
						_List_Nil)
					]);
			} else {
				var first = styleBlock.a;
				var rest = styleBlock.b;
				var properties = styleBlock.c;
				var newRest = A2(elm$core$List$map, f, rest);
				var newFirst = f(first);
				return _List_fromArray(
					[
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
						A3(rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
					]);
			}
		});
	var rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
		function (pseudo, _n0) {
			var sequence = _n0.a;
			var selectors = _n0.b;
			return A3(
				rtfeldman$elm_css$Css$Structure$Selector,
				sequence,
				selectors,
				elm$core$Maybe$Just(pseudo));
		});
	var rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
		function (pseudo, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
		function (a, b) {
			return {$: 'CustomSelector', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
		function (a, b) {
			return {$: 'TypeSelectorSequence', a: a, b: b};
		});
	var rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
		return {$: 'UniversalSelectorSequence', a: a};
	};
	var rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
		function (selector, sequence) {
			switch (sequence.$) {
				case 'TypeSelectorSequence':
					var typeSelector = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
						typeSelector,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				case 'UniversalSelectorSequence':
					var list = sequence.a;
					return rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
				default:
					var str = sequence.a;
					var list = sequence.b;
					return A2(
						rtfeldman$elm_css$Css$Structure$CustomSelector,
						str,
						_Utils_ap(
							list,
							_List_fromArray(
								[selector])));
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
		function (selector, list) {
			if (!list.b) {
				return _List_Nil;
			} else {
				if (!list.b.b) {
					var _n1 = list.a;
					var combinator = _n1.a;
					var sequence = _n1.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							combinator,
							A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
						]);
				} else {
					var first = list.a;
					var rest = list.b;
					return A2(
						elm$core$List$cons,
						first,
						A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
				}
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
		function (repeatableSimpleSelector, selector) {
			if (!selector.b.b) {
				var sequence = selector.a;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
					_List_Nil,
					pseudoElement);
			} else {
				var firstSelector = selector.a;
				var tuples = selector.b;
				var pseudoElement = selector.c;
				return A3(
					rtfeldman$elm_css$Css$Structure$Selector,
					firstSelector,
					A2(rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
					pseudoElement);
			}
		});
	var rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
		function (selector, styleBlock) {
			return A2(
				rtfeldman$elm_css$Css$Structure$appendToLastSelector,
				rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
				styleBlock);
		});
	var rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
		function (update, declarations) {
			_n0$12:
			while (true) {
				if (!declarations.b) {
					return declarations;
				} else {
					if (!declarations.b.b) {
						switch (declarations.a.$) {
							case 'StyleBlockDeclaration':
								var styleBlock = declarations.a.a;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
									update(styleBlock));
							case 'MediaRule':
								if (declarations.a.b.b) {
									if (!declarations.a.b.b.b) {
										var _n1 = declarations.a;
										var mediaQueries = _n1.a;
										var _n2 = _n1.b;
										var styleBlock = _n2.a;
										return _List_fromArray(
											[
												A2(
												rtfeldman$elm_css$Css$Structure$MediaRule,
												mediaQueries,
												update(styleBlock))
											]);
									} else {
										var _n3 = declarations.a;
										var mediaQueries = _n3.a;
										var _n4 = _n3.b;
										var first = _n4.a;
										var rest = _n4.b;
										var _n5 = A2(
											rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
											update,
											_List_fromArray(
												[
													A2(rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
												]));
										if ((_n5.b && (_n5.a.$ === 'MediaRule')) && (!_n5.b.b)) {
											var _n6 = _n5.a;
											var newMediaQueries = _n6.a;
											var newStyleBlocks = _n6.b;
											return _List_fromArray(
												[
													A2(
													rtfeldman$elm_css$Css$Structure$MediaRule,
													newMediaQueries,
													A2(elm$core$List$cons, first, newStyleBlocks))
												]);
										} else {
											var newDeclarations = _n5;
											return newDeclarations;
										}
									}
								} else {
									break _n0$12;
								}
							case 'SupportsRule':
								var _n7 = declarations.a;
								var str = _n7.a;
								var nestedDeclarations = _n7.b;
								return _List_fromArray(
									[
										A2(
										rtfeldman$elm_css$Css$Structure$SupportsRule,
										str,
										A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
									]);
							case 'DocumentRule':
								var _n8 = declarations.a;
								var str1 = _n8.a;
								var str2 = _n8.b;
								var str3 = _n8.c;
								var str4 = _n8.d;
								var styleBlock = _n8.e;
								return A2(
									elm$core$List$map,
									A4(rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
									update(styleBlock));
							case 'PageRule':
								var _n9 = declarations.a;
								return declarations;
							case 'FontFace':
								return declarations;
							case 'Keyframes':
								return declarations;
							case 'Viewport':
								return declarations;
							case 'CounterStyle':
								return declarations;
							default:
								return declarations;
						}
					} else {
						break _n0$12;
					}
				}
			}
			var first = declarations.a;
			var rest = declarations.b;
			return A2(
				elm$core$List$cons,
				first,
				A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
		});
	var rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
		function (mediaQueries, declaration) {
			if (declaration.$ === 'StyleBlockDeclaration') {
				var styleBlock = declaration.a;
				return A2(
					rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[styleBlock]));
			} else {
				return declaration;
			}
		});
	var elm$core$String$foldl = _String_foldl;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
		function (shift, seed, hash, charsProcessed) {
			return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
		});
	var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
	var elm$core$Bitwise$xor = _Bitwise_xor;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
	var elm$core$Bitwise$and = _Bitwise_and;
	var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
		function (b, a) {
			return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
		});
	var elm$core$Bitwise$or = _Bitwise_or;
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
		function (b, a) {
			return (a << b) | (a >>> (32 - b));
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
		var acc = data.hash ? (data.seed ^ A2(
			rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
			A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				15,
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
		var h0 = acc ^ data.charsProcessed;
		var h1 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
		var h2 = A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
		return (h2 ^ (h2 >>> 16)) >>> 0;
	};
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
		function (h1, k1) {
			return A2(
				rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
				5,
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
					13,
					h1 ^ A2(
						rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
						rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
						A2(
							rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
							15,
							A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
		function (c, data) {
			var res = data.hash | ((255 & elm$core$Char$toCode(c)) << data.shift);
			var _n0 = data.shift;
			if (_n0 === 24) {
				return {
					charsProcessed: data.charsProcessed + 1,
					hash: 0,
					seed: A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
					shift: 0
				};
			} else {
				return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
			}
		});
	var rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
		function (seed, str) {
			return rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
				A3(
					elm$core$String$foldl,
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
					A4(rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
					str));
		});
	var rtfeldman$elm_css$Hash$murmurSeed = 15739;
	var elm$core$Basics$modBy = _Basics_modBy;
	var rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
		unsafeToDigit:
		while (true) {
			switch (num) {
				case 0:
					return _Utils_chr('0');
				case 1:
					return _Utils_chr('1');
				case 2:
					return _Utils_chr('2');
				case 3:
					return _Utils_chr('3');
				case 4:
					return _Utils_chr('4');
				case 5:
					return _Utils_chr('5');
				case 6:
					return _Utils_chr('6');
				case 7:
					return _Utils_chr('7');
				case 8:
					return _Utils_chr('8');
				case 9:
					return _Utils_chr('9');
				case 10:
					return _Utils_chr('a');
				case 11:
					return _Utils_chr('b');
				case 12:
					return _Utils_chr('c');
				case 13:
					return _Utils_chr('d');
				case 14:
					return _Utils_chr('e');
				case 15:
					return _Utils_chr('f');
				default:
					var $temp$num = num;
					num = $temp$num;
					continue unsafeToDigit;
			}
		}
	};
	var rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
		function (digits, num) {
			unsafePositiveToDigits:
			while (true) {
				if (num < 16) {
					return A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(num),
						digits);
				} else {
					var $temp$digits = A2(
						elm$core$List$cons,
						rtfeldman$elm_hex$Hex$unsafeToDigit(
							A2(elm$core$Basics$modBy, 16, num)),
						digits),
						$temp$num = (num / 16) | 0;
					digits = $temp$digits;
					num = $temp$num;
					continue unsafePositiveToDigits;
				}
			}
		});
	var rtfeldman$elm_hex$Hex$toString = function (num) {
		return elm$core$String$fromList(
			(num < 0) ? A2(
				elm$core$List$cons,
				_Utils_chr('-'),
				A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2(rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
	};
	var rtfeldman$elm_css$Hash$fromString = function (str) {
		return A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, rtfeldman$elm_css$Hash$murmurSeed, str)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
		function (nestedStyles, rest, f, declarations) {
			var withoutParent = function (decls) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					elm$core$List$tail(decls));
			};
			var nextResult = A2(
				rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
				rest,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			var newDeclarations = function () {
				var _n14 = _Utils_Tuple2(
					elm$core$List$head(nextResult),
					rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
				if ((_n14.a.$ === 'Just') && (_n14.b.$ === 'Just')) {
					var nextResultParent = _n14.a.a;
					var originalParent = _n14.b.a;
					return _Utils_ap(
						A2(
							elm$core$List$take,
							elm$core$List$length(declarations) - 1,
							declarations),
						_List_fromArray(
							[
								(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
							]));
				} else {
					return declarations;
				}
			}();
			var insertStylesToNestedDecl = function (lastDecl) {
				return elm$core$List$concat(
					A2(
						rtfeldman$elm_css$Css$Structure$mapLast,
						rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
						A2(
							elm$core$List$map,
							elm$core$List$singleton,
							A2(rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
			};
			var initialResult = A2(
				elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					elm$core$Maybe$map,
					insertStylesToNestedDecl,
					rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
			return _Utils_ap(
				newDeclarations,
				_Utils_ap(
					withoutParent(initialResult),
					withoutParent(nextResult)));
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
		function (styles, declarations) {
			if (!styles.b) {
				return declarations;
			} else {
				switch (styles.a.$) {
					case 'AppendProperty':
						var property = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
					case 'ExtendSelector':
						var _n4 = styles.a;
						var selector = _n4.a;
						var nestedStyles = _n4.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
							declarations);
					case 'NestSnippet':
						var _n5 = styles.a;
						var selectorCombinator = _n5.a;
						var snippets = _n5.b;
						var rest = styles.b;
						var chain = F2(
							function (_n9, _n10) {
								var originalSequence = _n9.a;
								var originalTuples = _n9.b;
								var originalPseudoElement = _n9.c;
								var newSequence = _n10.a;
								var newTuples = _n10.b;
								var newPseudoElement = _n10.c;
								return A3(
									rtfeldman$elm_css$Css$Structure$Selector,
									originalSequence,
									_Utils_ap(
										originalTuples,
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(selectorCombinator, newSequence),
											newTuples)),
									rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
										_List_fromArray(
											[newPseudoElement, originalPseudoElement])));
							});
						var expandDeclaration = function (declaration) {
							switch (declaration.$) {
								case 'StyleBlockDeclaration':
									var _n7 = declaration.a;
									var firstSelector = _n7.a;
									var otherSelectors = _n7.b;
									var nestedStyles = _n7.c;
									var newSelectors = A2(
										elm$core$List$concatMap,
										function (originalSelector) {
											return A2(
												elm$core$List$map,
												chain(originalSelector),
												A2(elm$core$List$cons, firstSelector, otherSelectors));
										},
										rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
									var newDeclarations = function () {
										if (!newSelectors.b) {
											return _List_Nil;
										} else {
											var first = newSelectors.a;
											var remainder = newSelectors.b;
											return _List_fromArray(
												[
													rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
													A3(rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
												]);
										}
									}();
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
								case 'MediaRule':
									var mediaQueries = declaration.a;
									var styleBlocks = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
								case 'SupportsRule':
									var str = declaration.a;
									var otherSnippets = declaration.b;
									return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
								case 'DocumentRule':
									var str1 = declaration.a;
									var str2 = declaration.b;
									var str3 = declaration.c;
									var str4 = declaration.d;
									var styleBlock = declaration.e;
									return A2(
										elm$core$List$map,
										A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
										rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
								case 'PageRule':
									var str = declaration.a;
									var properties = declaration.b;
									return _List_fromArray(
										[
											A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
										]);
								case 'FontFace':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$FontFace(properties)
										]);
								case 'Viewport':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$Viewport(properties)
										]);
								case 'CounterStyle':
									var properties = declaration.a;
									return _List_fromArray(
										[
											rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
										]);
								default:
									var tuples = declaration.a;
									return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
							}
						};
						return elm$core$List$concat(
							_Utils_ap(
								_List_fromArray(
									[
										A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
									]),
								A2(
									elm$core$List$map,
									expandDeclaration,
									A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
					case 'WithPseudoElement':
						var _n11 = styles.a;
						var pseudoElement = _n11.a;
						var nestedStyles = _n11.b;
						var rest = styles.b;
						return A4(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
							nestedStyles,
							rest,
							rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
							declarations);
					case 'WithKeyframes':
						var str = styles.a.a;
						var rest = styles.b;
						var name = rtfeldman$elm_css$Hash$fromString(str);
						var newProperty = 'animation-name:' + name;
						var newDeclarations = A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							rest,
							A2(rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
						return A2(
							elm$core$List$append,
							newDeclarations,
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$Structure$Keyframes(
									{declaration: str, name: name})
								]));
					case 'WithMedia':
						var _n12 = styles.a;
						var mediaQueries = _n12.a;
						var nestedStyles = _n12.b;
						var rest = styles.b;
						var extraDeclarations = function () {
							var _n13 = rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
							if (!_n13.b) {
								return _List_Nil;
							} else {
								var firstSelector = _n13.a;
								var otherSelectors = _n13.b;
								return A2(
									elm$core$List$map,
									rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
									A2(
										rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
										nestedStyles,
										elm$core$List$singleton(
											rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
							}
						}();
						return _Utils_ap(
							A2(rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
							extraDeclarations);
					default:
						var otherStyles = styles.a.a;
						var rest = styles.b;
						return A2(
							rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
							_Utils_ap(otherStyles, rest),
							declarations);
				}
			}
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_n2) {
		var firstSelector = _n2.a;
		var otherSelectors = _n2.b;
		var styles = _n2.c;
		return A2(
			rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			styles,
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
					A3(rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
				]));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
		if (!snippetDeclarations.b) {
			return _List_Nil;
		} else {
			var first = snippetDeclarations.a;
			var rest = snippetDeclarations.b;
			return _Utils_ap(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
				rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
		function (mediaQueries, styleBlocks) {
			var handleStyleBlock = function (styleBlock) {
				return A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			};
			return A2(elm$core$List$concatMap, handleStyleBlock, styleBlocks);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
		function (str, snippets) {
			var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
				A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
			return _List_fromArray(
				[
					A2(rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
				]);
		});
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
		switch (snippetDeclaration.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
			case 'MediaRule':
				var mediaQueries = snippetDeclaration.a;
				var styleBlocks = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
			case 'SupportsRule':
				var str = snippetDeclaration.a;
				var snippets = snippetDeclaration.b;
				return A2(rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
			case 'DocumentRule':
				var str1 = snippetDeclaration.a;
				var str2 = snippetDeclaration.b;
				var str3 = snippetDeclaration.c;
				var str4 = snippetDeclaration.d;
				var styleBlock = snippetDeclaration.e;
				return A2(
					elm$core$List$map,
					A4(rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
					rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
			case 'PageRule':
				var str = snippetDeclaration.a;
				var properties = snippetDeclaration.b;
				return _List_fromArray(
					[
						A2(rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
					]);
			case 'FontFace':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$FontFace(properties)
					]);
			case 'Viewport':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Viewport(properties)
					]);
			case 'CounterStyle':
				var properties = snippetDeclaration.a;
				return _List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
					]);
			default:
				var tuples = snippetDeclaration.a;
				return rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
		}
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var snippets = _n0.snippets;
		var declarations = rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2(elm$core$List$concatMap, rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$Basics$composeL = F3(
		function (g, f, x) {
			return g(
				f(x));
		});
	var elm$core$Basics$not = _Basics_not;
	var elm$core$List$any = F2(
		function (isOkay, list) {
			any:
			while (true) {
				if (!list.b) {
					return false;
				} else {
					var x = list.a;
					var xs = list.b;
					if (isOkay(x)) {
						return true;
					} else {
						var $temp$isOkay = isOkay,
							$temp$list = xs;
						isOkay = $temp$isOkay;
						list = $temp$list;
						continue any;
					}
				}
			}
		});
	var elm$core$List$all = F2(
		function (isOkay, list) {
			return !A2(
				elm$core$List$any,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
				list);
		});
	var rtfeldman$elm_css$Css$Structure$compactHelp = F2(
		function (declaration, _n0) {
			var keyframesByName = _n0.a;
			var declarations = _n0.b;
			switch (declaration.$) {
				case 'StyleBlockDeclaration':
					var _n2 = declaration.a;
					var properties = _n2.c;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'MediaRule':
					var styleBlocks = declaration.b;
					return A2(
						elm$core$List$all,
						function (_n3) {
							var properties = _n3.c;
							return elm$core$List$isEmpty(properties);
						},
						styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'SupportsRule':
					var otherDeclarations = declaration.b;
					return elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'DocumentRule':
					return _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'PageRule':
					var properties = declaration.b;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'FontFace':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'Keyframes':
					var record = declaration.a;
					return elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						A3(elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
						declarations);
				case 'Viewport':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				case 'CounterStyle':
					var properties = declaration.a;
					return elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
				default:
					var tuples = declaration.a;
					return A2(
						elm$core$List$all,
						function (_n4) {
							var properties = _n4.b;
							return elm$core$List$isEmpty(properties);
						},
						tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
						keyframesByName,
						A2(elm$core$List$cons, declaration, declarations));
			}
		});
	var rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
		function (keyframesByName, compactedDeclarations) {
			return A2(
				elm$core$List$append,
				A2(
					elm$core$List$map,
					function (_n0) {
						var name = _n0.a;
						var decl = _n0.b;
						return rtfeldman$elm_css$Css$Structure$Keyframes(
							{declaration: decl, name: name});
					},
					elm$core$Dict$toList(keyframesByName)),
				compactedDeclarations);
		});
	var rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		var _n1 = A3(
			elm$core$List$foldr,
			rtfeldman$elm_css$Css$Structure$compactHelp,
			_Utils_Tuple2(elm$core$Dict$empty, _List_Nil),
			declarations);
		var keyframesByName = _n1.a;
		var compactedDeclarations = _n1.b;
		var finalDeclarations = A2(rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
		return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
	};
	var elm$core$List$filter = F2(
		function (isGood, list) {
			return A3(
				elm$core$List$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				list);
		});
	var rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
		return A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (str) {
					return '@charset \"' + (str + '\"');
				},
				charset));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
		return '(' + (expression.feature + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				elm$core$Basics$append(': '),
				expression.value)) + ')'));
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
		switch (mediaType.$) {
			case 'Print':
				return 'print';
			case 'Screen':
				return 'screen';
			default:
				return 'speech';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
		var prefixWith = F3(
			function (str, mediaType, expressions) {
				return str + (' ' + A2(
					elm$core$String$join,
					' and ',
					A2(
						elm$core$List$cons,
						rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
			});
		switch (mediaQuery.$) {
			case 'AllQuery':
				var expressions = mediaQuery.a;
				return A2(
					elm$core$String$join,
					' and ',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
			case 'OnlyQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'only', mediaType, expressions);
			case 'NotQuery':
				var mediaType = mediaQuery.a;
				var expressions = mediaQuery.b;
				return A3(prefixWith, 'not', mediaType, expressions);
			default:
				var str = mediaQuery.a;
				return str;
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
		function (name, mediaQuery) {
			return '@import \"' + (name + (rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
		});
	var rtfeldman$elm_css$Css$Structure$Output$importToString = function (_n0) {
		var name = _n0.a;
		var mediaQueries = _n0.b;
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
				mediaQueries));
	};
	var rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_n0) {
		var prefix = _n0.a;
		var str = _n0.b;
		return '@namespace ' + (prefix + ('\"' + (str + '\"')));
	};
	var rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
	var rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
		return _Utils_ap(rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
	};
	var rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
	var rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
		return str + ';';
	};
	var rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
		return A2(
			elm$core$String$join,
			'\n',
			A2(
				elm$core$List$map,
				A2(elm$core$Basics$composeL, rtfeldman$elm_css$Css$Structure$Output$indent, rtfeldman$elm_css$Css$Structure$Output$emitProperty),
				properties));
	};
	var elm$core$String$append = _String_append;
	var rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_n0) {
		var str = _n0.a;
		return '::' + str;
	};
	var rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
		switch (combinator.$) {
			case 'AdjacentSibling':
				return '+';
			case 'GeneralSibling':
				return '~';
			case 'Child':
				return '>';
			default:
				return '';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
		switch (repeatableSimpleSelector.$) {
			case 'ClassSelector':
				var str = repeatableSimpleSelector.a;
				return '.' + str;
			case 'IdSelector':
				var str = repeatableSimpleSelector.a;
				return '#' + str;
			case 'PseudoClassSelector':
				var str = repeatableSimpleSelector.a;
				return ':' + str;
			default:
				var str = repeatableSimpleSelector.a;
				return '[' + (str + ']');
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
		switch (simpleSelectorSequence.$) {
			case 'TypeSelectorSequence':
				var str = simpleSelectorSequence.a.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
			case 'UniversalSelectorSequence':
				var repeatableSimpleSelectors = simpleSelectorSequence.a;
				return elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
					elm$core$String$join,
					'',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
			default:
				var str = simpleSelectorSequence.a;
				var repeatableSimpleSelectors = simpleSelectorSequence.b;
				return A2(
					elm$core$String$join,
					'',
					A2(
						elm$core$List$cons,
						str,
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_n0) {
		var combinator = _n0.a;
		var sequence = _n0.b;
		return A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
					rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
				]));
	};
	var rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_n0) {
		var simpleSelectorSequence = _n0.a;
		var chain = _n0.b;
		var pseudoElement = _n0.c;
		var segments = A2(
			elm$core$List$cons,
			rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
		var pseudoElementsString = A2(
			elm$core$String$join,
			'',
			_List_fromArray(
				[
					A2(
					elm$core$Maybe$withDefault,
					'',
					A2(elm$core$Maybe$map, rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
				]));
		return A2(
			elm$core$String$append,
			A2(
				elm$core$String$join,
				' ',
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
					segments)),
			pseudoElementsString);
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
		function (indentLevel, _n0) {
			var firstSelector = _n0.a;
			var otherSelectors = _n0.b;
			var properties = _n0.c;
			var selectorStr = A2(
				elm$core$String$join,
				', ',
				A2(
					elm$core$List$map,
					rtfeldman$elm_css$Css$Structure$Output$selectorToString,
					A2(elm$core$List$cons, firstSelector, otherSelectors)));
			return A2(
				elm$core$String$join,
				'',
				_List_fromArray(
					[
						selectorStr,
						' {\n',
						indentLevel,
						rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
						'\n',
						indentLevel,
						'}'
					]));
		});
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
		switch (decl.$) {
			case 'StyleBlockDeclaration':
				var styleBlock = decl.a;
				return A2(rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
			case 'MediaRule':
				var mediaQueries = decl.a;
				var styleBlocks = decl.b;
				var query = A2(
					elm$core$String$join,
					',\n',
					A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
				var blocks = A2(
					elm$core$String$join,
					'\n\n',
					A2(
						elm$core$List$map,
						A2(
							elm$core$Basics$composeL,
							rtfeldman$elm_css$Css$Structure$Output$indent,
							rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
						styleBlocks));
				return '@media ' + (query + (' {\n' + (blocks + '\n}')));
			case 'SupportsRule':
				return 'TODO';
			case 'DocumentRule':
				return 'TODO';
			case 'PageRule':
				return 'TODO';
			case 'FontFace':
				return 'TODO';
			case 'Keyframes':
				var name = decl.a.name;
				var declaration = decl.a.declaration;
				return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
			case 'Viewport':
				return 'TODO';
			case 'CounterStyle':
				return 'TODO';
			default:
				return 'TODO';
		}
	};
	var rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_n0) {
		var charset = _n0.charset;
		var imports = _n0.imports;
		var namespaces = _n0.namespaces;
		var declarations = _n0.declarations;
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(
				elm$core$List$filter,
				A2(elm$core$Basics$composeL, elm$core$Basics$not, elm$core$String$isEmpty),
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
						A2(
						elm$core$String$join,
						'\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
						A2(
						elm$core$String$join,
						'\n\n',
						A2(elm$core$List$map, rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
					])));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
		return rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
			rtfeldman$elm_css$Css$Structure$compactStylesheet(
				rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
	};
	var rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
		return A2(
			elm$core$String$join,
			'\n\n',
			A2(elm$core$List$map, rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
	};
	var rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
		return {$: 'Snippet', a: a};
	};
	var rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
		function (a, b, c) {
			return {$: 'StyleBlock', a: a, b: b, c: c};
		});
	var rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
		return {$: 'StyleBlockDeclaration', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
		function (styles, sequence) {
			var selector = A3(rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, elm$core$Maybe$Nothing);
			return rtfeldman$elm_css$Css$Preprocess$Snippet(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3(rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
					]));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
	var rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
		return elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
			elm$core$String$cons,
			_Utils_chr('_'),
			rtfeldman$elm_hex$Hex$toString(
				A2(
					rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
					rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
					rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						elm$core$List$singleton(
							rtfeldman$elm_css$Css$Preprocess$stylesheet(
								elm$core$List$singleton(
									A2(
										rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
										styles,
										rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
	};
	var rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
		var classname = rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
		var classProperty = A2(
			elm$virtual_dom$VirtualDom$property,
			'className',
			elm$json$Json$Encode$string(classname));
		return A3(rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
	};
	var rtfeldman$elm_css$Html$Styled$Attributes$css = rtfeldman$elm_css$Html$Styled$Internal$css;
	var author$project$TicketCompanyInfosCard$companyInfosBoxStyle = rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				rtfeldman$elm_css$Css$fontWeight(
				rtfeldman$elm_css$Css$int(300)),
				rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase),
				rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
				rtfeldman$elm_css$Css$marginBottom(
				rtfeldman$elm_css$Css$em(1)),
				rtfeldman$elm_css$Css$color(
				rtfeldman$elm_css$Css$hex('546d79'))
			]));
	var rtfeldman$elm_css$Css$listStyle = rtfeldman$elm_css$Css$prop1('list-style');
	var rtfeldman$elm_css$Css$none = {backgroundImage: rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, cursor: rtfeldman$elm_css$Css$Structure$Compatible, display: rtfeldman$elm_css$Css$Structure$Compatible, hoverCapability: rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: rtfeldman$elm_css$Css$Structure$Compatible, keyframes: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: rtfeldman$elm_css$Css$Structure$Compatible, none: rtfeldman$elm_css$Css$Structure$Compatible, outline: rtfeldman$elm_css$Css$Structure$Compatible, pointerDevice: rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: rtfeldman$elm_css$Css$Structure$Compatible, resize: rtfeldman$elm_css$Css$Structure$Compatible, scriptingSupport: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: rtfeldman$elm_css$Css$Structure$Compatible, textTransform: rtfeldman$elm_css$Css$Structure$Compatible, touchAction: rtfeldman$elm_css$Css$Structure$Compatible, transform: rtfeldman$elm_css$Css$Structure$Compatible, updateFrequency: rtfeldman$elm_css$Css$Structure$Compatible, value: 'none'};
	var rtfeldman$elm_css$Css$padding = rtfeldman$elm_css$Css$prop1('padding');
	var rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
	var rtfeldman$elm_css$Css$px = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PxUnits, 'px');
	var rtfeldman$elm_css$Html$Styled$div = rtfeldman$elm_css$Html$Styled$node('div');
	var rtfeldman$elm_css$Html$Styled$ul = rtfeldman$elm_css$Html$Styled$node('ul');
	var author$project$TicketCompanyInfosCard$agencyBlock = function (model) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
							rtfeldman$elm_css$Css$marginBottom(
							rtfeldman$elm_css$Css$px(20))
						]))
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[author$project$TicketCompanyInfosCard$companyInfosBoxStyle]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text(
							author$project$TicketCompanyInfosCard$agencyName(model))
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$listStyle(rtfeldman$elm_css$Css$none),
									rtfeldman$elm_css$Css$padding(
									rtfeldman$elm_css$Css$px(0))
								]))
						]),
					A2(
						elm$core$Maybe$withDefault,
						_List_Nil,
						A2(elm$core$Maybe$map, author$project$TicketCompanyInfosCard$agencyContacts, model.agencyInfos)))
				]));
	};
	var rtfeldman$elm_css$Css$prop3 = F4(
		function (key, argA, argB, argC) {
			return A2(
				rtfeldman$elm_css$Css$property,
				key,
				A2(
					elm$core$String$join,
					' ',
					_List_fromArray(
						[argA.value, argB.value, argC.value])));
		});
	var rtfeldman$elm_css$Css$borderBottom3 = rtfeldman$elm_css$Css$prop3('border-bottom');
	var rtfeldman$elm_css$Css$fontSize = rtfeldman$elm_css$Css$prop1('font-size');
	var rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
	var rtfeldman$elm_css$Css$pct = A2(rtfeldman$elm_css$Css$Internal$lengthConverter, rtfeldman$elm_css$Css$PercentageUnits, '%');
	var rtfeldman$elm_css$Css$solid = {borderStyle: rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
	var rtfeldman$elm_css$Css$width = rtfeldman$elm_css$Css$prop1('width');
	var author$project$TicketCompanyInfosCard$companyBlock = function (model) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A3(
							rtfeldman$elm_css$Css$borderBottom3,
							rtfeldman$elm_css$Css$px(1),
							rtfeldman$elm_css$Css$solid,
							rtfeldman$elm_css$Css$hex('#546D79')),
							rtfeldman$elm_css$Css$textTransform(rtfeldman$elm_css$Css$uppercase),
							rtfeldman$elm_css$Css$padding(
							rtfeldman$elm_css$Css$em(0.5)),
							rtfeldman$elm_css$Css$width(
							rtfeldman$elm_css$Css$pct(100)),
							rtfeldman$elm_css$Css$fontSize(
							rtfeldman$elm_css$Css$px(26)),
							rtfeldman$elm_css$Css$textAlign(rtfeldman$elm_css$Css$center),
							rtfeldman$elm_css$Css$color(
							rtfeldman$elm_css$Css$hex('#546D79'))
						]))
				]),
			_List_fromArray(
				[
					rtfeldman$elm_css$Html$Styled$text(model.initData.company.name)
				]));
	};
	var rtfeldman$elm_css$Css$block = {display: rtfeldman$elm_css$Css$Structure$Compatible, value: 'block'};
	var rtfeldman$elm_css$Css$display = rtfeldman$elm_css$Css$prop1('display');
	var author$project$TicketCompanyInfosCard$contactDisplayStrategy = function (patrimonyUid) {
		if (patrimonyUid.$ === 'Just') {
			return rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$block)
					]));
		} else {
			return rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none)
					]));
		}
	};
	var author$project$TicketCompanyInfosCard$ToggleContacts = function (a) {
		return {$: 'ToggleContacts', a: a};
	};
	var elm_community$list_extra$List$Extra$find = F2(
		function (predicate, list) {
			find:
			while (true) {
				if (!list.b) {
					return elm$core$Maybe$Nothing;
				} else {
					var first = list.a;
					var rest = list.b;
					if (predicate(first)) {
						return elm$core$Maybe$Just(first);
					} else {
						var $temp$predicate = predicate,
							$temp$list = rest;
						predicate = $temp$predicate;
						list = $temp$list;
						continue find;
					}
				}
			}
		});
	var author$project$TicketCompanyInfosCard$getToggleState = F2(
		function (userUid, states) {
			return A2(
				elm$core$Maybe$withDefault,
				author$project$Components$TicketCompanyInfosCard$State$Hide,
				A2(
					elm$core$Maybe$map,
					function ($) {
						return $.state;
					},
					A2(
						elm_community$list_extra$List$Extra$find,
						function (t) {
							return _Utils_eq(t.uid, userUid);
						},
						states)));
		});
	var author$project$TicketCompanyInfosCard$toggleDisplay = F2(
		function (userUid, usersInfosState) {
			var state = A2(author$project$TicketCompanyInfosCard$getToggleState, userUid, usersInfosState);
			if (state.$ === 'Hide') {
				return rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$none);
			} else {
				return rtfeldman$elm_css$Css$display(rtfeldman$elm_css$Css$block);
			}
		});
	var rtfeldman$elm_css$Css$borderLeft3 = rtfeldman$elm_css$Css$prop3('border-left');
	var rtfeldman$elm_css$Css$borderRight3 = rtfeldman$elm_css$Css$prop3('border-right');
	var rtfeldman$elm_css$Css$borderTop3 = rtfeldman$elm_css$Css$prop3('border-top');
	var rtfeldman$elm_css$Css$height = rtfeldman$elm_css$Css$prop1('height');
	var rtfeldman$elm_css$Css$transparent = {color: rtfeldman$elm_css$Css$Structure$Compatible, value: 'transparent'};
	var author$project$TicketCompanyInfosCard$toggleTriangle = F2(
		function (userUid, states) {
			var triangleToLeft = _List_fromArray(
				[
					A3(
					rtfeldman$elm_css$Css$borderTop3,
					rtfeldman$elm_css$Css$px(6),
					rtfeldman$elm_css$Css$solid,
					rtfeldman$elm_css$Css$transparent),
					A3(
					rtfeldman$elm_css$Css$borderBottom3,
					rtfeldman$elm_css$Css$px(6),
					rtfeldman$elm_css$Css$solid,
					rtfeldman$elm_css$Css$transparent),
					A3(
					rtfeldman$elm_css$Css$borderRight3,
					rtfeldman$elm_css$Css$px(12),
					rtfeldman$elm_css$Css$solid,
					rtfeldman$elm_css$Css$hex('a8b5bb'))
				]);
			var triangleToBottom = _List_fromArray(
				[
					A3(
					rtfeldman$elm_css$Css$borderLeft3,
					rtfeldman$elm_css$Css$px(6),
					rtfeldman$elm_css$Css$solid,
					rtfeldman$elm_css$Css$transparent),
					A3(
					rtfeldman$elm_css$Css$borderRight3,
					rtfeldman$elm_css$Css$px(6),
					rtfeldman$elm_css$Css$solid,
					rtfeldman$elm_css$Css$transparent),
					A3(
					rtfeldman$elm_css$Css$borderTop3,
					rtfeldman$elm_css$Css$px(12),
					rtfeldman$elm_css$Css$solid,
					rtfeldman$elm_css$Css$hex('a8b5bb'))
				]);
			var state = A2(author$project$TicketCompanyInfosCard$getToggleState, userUid, states);
			return rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap(
					_List_fromArray(
						[
							rtfeldman$elm_css$Css$width(
							rtfeldman$elm_css$Css$px(0)),
							rtfeldman$elm_css$Css$height(
							rtfeldman$elm_css$Css$px(0))
						]),
					function () {
						if (state.$ === 'Hide') {
							return triangleToLeft;
						} else {
							return triangleToBottom;
						}
					}()));
		});
	var elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
		if (m.$ === 'Nothing') {
			return _List_Nil;
		} else {
			var x = m.a;
			return _List_fromArray(
				[x]);
		}
	};
	var rtfeldman$elm_css$Css$cursor = rtfeldman$elm_css$Css$prop1('cursor');
	var rtfeldman$elm_css$Css$displayFlex = A2(rtfeldman$elm_css$Css$property, 'display', 'flex');
	var rtfeldman$elm_css$Css$fontStyle = rtfeldman$elm_css$Css$prop1('font-style');
	var rtfeldman$elm_css$Css$italic = {fontStyle: rtfeldman$elm_css$Css$Structure$Compatible, value: 'italic'};
	var rtfeldman$elm_css$Css$UnitlessFloat = {$: 'UnitlessFloat'};
	var rtfeldman$elm_css$Css$num = function (val) {
		return {
			lengthOrNumber: rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: rtfeldman$elm_css$Css$Structure$Compatible,
			number: rtfeldman$elm_css$Css$Structure$Compatible,
			numberOrInfinite: rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: val,
			unitLabel: '',
			units: rtfeldman$elm_css$Css$UnitlessFloat,
			value: elm$core$String$fromFloat(val)
		};
	};
	var rtfeldman$elm_css$Css$opacity = rtfeldman$elm_css$Css$prop1('opacity');
	var rtfeldman$elm_css$Css$paddingLeft = rtfeldman$elm_css$Css$prop1('padding-left');
	var rtfeldman$elm_css$Css$paddingRight = rtfeldman$elm_css$Css$prop1('padding-right');
	var rtfeldman$elm_css$Css$pointer = {cursor: rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
	var elm$virtual_dom$VirtualDom$Normal = function (a) {
		return {$: 'Normal', a: a};
	};
	var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
	var rtfeldman$elm_css$VirtualDom$Styled$on = F2(
		function (eventName, handler) {
			return A3(
				rtfeldman$elm_css$VirtualDom$Styled$Attribute,
				A2(elm$virtual_dom$VirtualDom$on, eventName, handler),
				_List_Nil,
				'');
		});
	var rtfeldman$elm_css$Html$Styled$Events$on = F2(
		function (event, decoder) {
			return A2(
				rtfeldman$elm_css$VirtualDom$Styled$on,
				event,
				elm$virtual_dom$VirtualDom$Normal(decoder));
		});
	var rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
		return A2(
			rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			elm$json$Json$Decode$succeed(msg));
	};
	var author$project$TicketCompanyInfosCard$displayUserInfos = F2(
		function (u, usersInfosState) {
			var job = function (j) {
				return rtfeldman$elm_css$Html$Styled$text(j);
			};
			var infos = A2(
				elm$core$List$cons,
				'Email: ' + u.email,
				elm_community$maybe_extra$Maybe$Extra$toList(
					A2(
						elm$core$Maybe$map,
						function (p) {
							return 'Tel: ' + p;
						},
						u.phoneNumber)));
			return A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Events$onClick(
								author$project$TicketCompanyInfosCard$ToggleContacts(u.uid)),
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$cursor(rtfeldman$elm_css$Css$pointer),
										rtfeldman$elm_css$Css$displayFlex,
										A2(rtfeldman$elm_css$Css$property, 'align-items', 'center')
									]))
							]),
						_List_fromArray(
							[
								A2(
								rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												rtfeldman$elm_css$Css$fontSize(
												rtfeldman$elm_css$Css$em(1.1)),
												rtfeldman$elm_css$Css$paddingRight(
												rtfeldman$elm_css$Css$px(5))
											]))
									]),
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$text(u.name)
									])),
								A2(
								rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												rtfeldman$elm_css$Css$fontStyle(rtfeldman$elm_css$Css$italic),
												rtfeldman$elm_css$Css$color(
												rtfeldman$elm_css$Css$hex('a8b5bb')),
												rtfeldman$elm_css$Css$paddingRight(
												rtfeldman$elm_css$Css$px(5))
											]))
									]),
								_List_fromArray(
									[
										A2(
										elm$core$Maybe$withDefault,
										rtfeldman$elm_css$Html$Styled$text(''),
										A2(elm$core$Maybe$map, job, u.job))
									])),
								A2(
								rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										A2(author$project$TicketCompanyInfosCard$toggleTriangle, u.uid, usersInfosState)
									]),
								_List_Nil)
							])),
						A2(
						rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$listStyle(rtfeldman$elm_css$Css$none),
										rtfeldman$elm_css$Css$paddingLeft(
										rtfeldman$elm_css$Css$px(0)),
										A2(author$project$TicketCompanyInfosCard$toggleDisplay, u.uid, usersInfosState),
										rtfeldman$elm_css$Css$opacity(
										rtfeldman$elm_css$Css$num(0.6))
									]))
							]),
						A2(
							elm$core$List$map,
							function (i) {
								return A2(
									rtfeldman$elm_css$Html$Styled$li,
									_List_Nil,
									_List_fromArray(
										[
											rtfeldman$elm_css$Html$Styled$text(i)
										]));
							},
							infos))
					]));
		});
	var rtfeldman$elm_css$Css$paddingBottom = rtfeldman$elm_css$Css$prop1('padding-bottom');
	var author$project$TicketCompanyInfosCard$patrimonyManagersInfos = F2(
		function (users, usersInfosState) {
			var style = rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$paddingBottom(
						rtfeldman$elm_css$Css$px(8))
					]));
			var u = function (user) {
				return A2(
					rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[style]),
					_List_fromArray(
						[
							A2(author$project$TicketCompanyInfosCard$displayUserInfos, user, usersInfosState)
						]));
			};
			return A2(elm$core$List$map, u, users);
		});
	var author$project$TicketCompanyInfosCard$contactsBlock = function (model) {
		return A2(
			rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					author$project$TicketCompanyInfosCard$contactDisplayStrategy(model.initData.patrimonyUid)
				]),
			_List_fromArray(
				[
					A2(
					rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[author$project$TicketCompanyInfosCard$companyInfosBoxStyle]),
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$text('Contacts')
						])),
					A2(
					rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									rtfeldman$elm_css$Css$listStyle(rtfeldman$elm_css$Css$none),
									rtfeldman$elm_css$Css$paddingLeft(
									rtfeldman$elm_css$Css$px(10))
								]))
						]),
					A2(author$project$TicketCompanyInfosCard$patrimonyManagersInfos, model.patrimonyManagers, model.usersInfosState))
				]));
	};
	var rtfeldman$elm_css$Css$alignItems = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'alignItems',
			'align-items',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$alignSelf = function (fn) {
		return A3(
			rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
			'alignSelf',
			'align-self',
			fn(rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
	};
	var rtfeldman$elm_css$Css$backgroundColor = function (c) {
		return A2(rtfeldman$elm_css$Css$property, 'background-color', c.value);
	};
	var rtfeldman$elm_css$Css$border3 = rtfeldman$elm_css$Css$prop3('border');
	var rtfeldman$elm_css$Css$row = {flexDirection: rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: rtfeldman$elm_css$Css$Structure$Compatible, value: 'row'};
	var rtfeldman$elm_css$Css$column = _Utils_update(
		rtfeldman$elm_css$Css$row,
		{value: 'column'});
	var rtfeldman$elm_css$Css$flexDirection = rtfeldman$elm_css$Css$prop1('flex-direction');
	var elm$virtual_dom$VirtualDom$node = function (tag) {
		return _VirtualDom_node(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
		return _VirtualDom_keyedNode(
			_VirtualDom_noScript(tag));
	};
	var elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
		function (namespace, tag) {
			return A2(
				_VirtualDom_keyedNodeNS,
				namespace,
				_VirtualDom_noScript(tag));
		});
	var elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
		return _VirtualDom_nodeNS(
			_VirtualDom_noScript(tag));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
		function (_n0, styles) {
			var newStyles = _n0.b;
			var classname = _n0.c;
			return elm$core$List$isEmpty(newStyles) ? styles : A3(elm$core$Dict$insert, classname, newStyles, styles);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_n0) {
		var val = _n0.a;
		return val;
	};
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
		function (_n6, _n7) {
			var key = _n6.a;
			var html = _n6.b;
			var pairs = _n7.a;
			var styles = _n7.b;
			switch (html.$) {
				case 'Unstyled':
					var vdom = html.a;
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n9 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n9.a;
					var finalStyles = _n9.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n10 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n10.a;
					var finalStyles = _n10.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n11 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n11.a;
					var finalStyles = _n11.b;
					var vdom = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n12 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n12.a;
					var finalStyles = _n12.b;
					var vdom = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(key, vdom),
							pairs),
						finalStyles);
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
		function (html, _n0) {
			var nodes = _n0.a;
			var styles = _n0.b;
			switch (html.$) {
				case 'Unstyled':
					var vdomNode = html.a;
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						styles);
				case 'Node':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n2 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n2.a;
					var finalStyles = _n2.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$node,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'NodeNS':
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n3 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n3.a;
					var finalStyles = _n3.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$nodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				case 'KeyedNode':
					var elemType = html.a;
					var properties = html.b;
					var children = html.c;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n4 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n4.a;
					var finalStyles = _n4.b;
					var vdomNode = A3(
						elm$virtual_dom$VirtualDom$keyedNode,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
				default:
					var ns = html.a;
					var elemType = html.b;
					var properties = html.c;
					var children = html.d;
					var combinedStyles = A3(elm$core$List$foldl, rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
					var _n5 = A3(
						elm$core$List$foldl,
						rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
						_Utils_Tuple2(_List_Nil, combinedStyles),
						children);
					var childNodes = _n5.a;
					var finalStyles = _n5.b;
					var vdomNode = A4(
						elm$virtual_dom$VirtualDom$keyedNodeNS,
						ns,
						elemType,
						A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
						elm$core$List$reverse(childNodes));
					return _Utils_Tuple2(
						A2(elm$core$List$cons, vdomNode, nodes),
						finalStyles);
			}
		});
	var elm$core$Dict$singleton = F2(
		function (key, value) {
			return A5(elm$core$Dict$RBNode_elm_builtin, elm$core$Dict$Black, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
		function (candidate, properties) {
			stylesFromPropertiesHelp:
			while (true) {
				if (!properties.b) {
					return candidate;
				} else {
					var _n1 = properties.a;
					var styles = _n1.b;
					var classname = _n1.c;
					var rest = properties.b;
					if (elm$core$String$isEmpty(classname)) {
						var $temp$candidate = candidate,
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					} else {
						var $temp$candidate = elm$core$Maybe$Just(
							_Utils_Tuple2(classname, styles)),
							$temp$properties = rest;
						candidate = $temp$candidate;
						properties = $temp$properties;
						continue stylesFromPropertiesHelp;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
		var _n0 = A2(rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, elm$core$Maybe$Nothing, properties);
		if (_n0.$ === 'Nothing') {
			return elm$core$Dict$empty;
		} else {
			var _n1 = _n0.a;
			var classname = _n1.a;
			var styles = _n1.b;
			return A2(elm$core$Dict$singleton, classname, styles);
		}
	};
	var rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
		return {$: 'ClassSelector', a: a};
	};
	var rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_n0) {
		var classname = _n0.a;
		var styles = _n0.b;
		return A2(
			rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
					])));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
		return rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			elm$core$List$singleton(
				rtfeldman$elm_css$Css$Preprocess$stylesheet(
					A2(
						elm$core$List$map,
						rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
						elm$core$Dict$toList(dict)))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
		return A3(
			elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			elm$core$List$singleton(
				elm$virtual_dom$VirtualDom$text(
					rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
	};
	var rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
		function (elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A3(
				elm$virtual_dom$VirtualDom$node,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
		function (key, pairs) {
			containsKey:
			while (true) {
				if (!pairs.b) {
					return false;
				} else {
					var _n1 = pairs.a;
					var str = _n1.a;
					var rest = pairs.b;
					if (_Utils_eq(key, str)) {
						return true;
					} else {
						var $temp$key = key,
							$temp$pairs = rest;
						key = $temp$key;
						pairs = $temp$pairs;
						continue containsKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
		function (_default, pairs) {
			getUnusedKey:
			while (true) {
				if (!pairs.b) {
					return _default;
				} else {
					var _n1 = pairs.a;
					var firstKey = _n1.a;
					var rest = pairs.b;
					var newKey = '_' + firstKey;
					if (A2(rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
						var $temp$default = newKey,
							$temp$pairs = rest;
						_default = $temp$default;
						pairs = $temp$pairs;
						continue getUnusedKey;
					} else {
						return newKey;
					}
				}
			}
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
		function (allStyles, keyedChildNodes) {
			var styleNodeKey = A2(rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
			var finalNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
			return _Utils_Tuple2(styleNodeKey, finalNode);
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
		function (elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A3(
				elm$virtual_dom$VirtualDom$keyedNode,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
		function (ns, elemType, properties, keyedChildren) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				keyedChildren);
			var keyedChildNodes = _n0.a;
			var styles = _n0.b;
			var keyedStyleNode = A2(rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
			return A4(
				elm$virtual_dom$VirtualDom$keyedNodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					keyedStyleNode,
					elm$core$List$reverse(keyedChildNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
		function (ns, elemType, properties, children) {
			var unstyledProperties = A2(elm$core$List$map, rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
			var initialStyles = rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
			var _n0 = A3(
				elm$core$List$foldl,
				rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
				_Utils_Tuple2(_List_Nil, initialStyles),
				children);
			var childNodes = _n0.a;
			var styles = _n0.b;
			var styleNode = rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
			return A4(
				elm$virtual_dom$VirtualDom$nodeNS,
				ns,
				elemType,
				unstyledProperties,
				A2(
					elm$core$List$cons,
					styleNode,
					elm$core$List$reverse(childNodes)));
		});
	var rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
		switch (vdom.$) {
			case 'Unstyled':
				var plainNode = vdom.a;
				return plainNode;
			case 'Node':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
			case 'NodeNS':
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
			case 'KeyedNode':
				var elemType = vdom.a;
				var properties = vdom.b;
				var children = vdom.c;
				return A3(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
			default:
				var ns = vdom.a;
				var elemType = vdom.b;
				var properties = vdom.c;
				var children = vdom.d;
				return A4(rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
		}
	};
	var rtfeldman$elm_css$Html$Styled$toUnstyled = rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
	var author$project$TicketCompanyInfosCard$view = function (model) {
		return rtfeldman$elm_css$Html$Styled$toUnstyled(
			A2(
				rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A3(
								rtfeldman$elm_css$Css$border3,
								rtfeldman$elm_css$Css$px(1),
								rtfeldman$elm_css$Css$solid,
								rtfeldman$elm_css$Css$hex('#DADADA')),
								rtfeldman$elm_css$Css$marginBottom(
								rtfeldman$elm_css$Css$px(30)),
								rtfeldman$elm_css$Css$padding(
								rtfeldman$elm_css$Css$px(10)),
								rtfeldman$elm_css$Css$displayFlex,
								rtfeldman$elm_css$Css$flexDirection(rtfeldman$elm_css$Css$column),
								rtfeldman$elm_css$Css$alignItems(rtfeldman$elm_css$Css$center),
								rtfeldman$elm_css$Css$alignSelf(rtfeldman$elm_css$Css$center),
								rtfeldman$elm_css$Css$backgroundColor(
								rtfeldman$elm_css$Css$hex('#fff'))
							]))
					]),
				_List_fromArray(
					[
						author$project$TicketCompanyInfosCard$companyBlock(model),
						A2(
						rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										rtfeldman$elm_css$Css$padding(
										rtfeldman$elm_css$Css$em(1)),
										rtfeldman$elm_css$Css$fontSize(
										rtfeldman$elm_css$Css$px(16)),
										rtfeldman$elm_css$Css$color(
										rtfeldman$elm_css$Css$hex('#546D79'))
									]))
							]),
						_List_fromArray(
							[
								author$project$TicketCompanyInfosCard$agencyBlock(model),
								author$project$TicketCompanyInfosCard$contactsBlock(model)
							]))
					])));
	};
	var elm$browser$Browser$External = function (a) {
		return {$: 'External', a: a};
	};
	var elm$browser$Browser$Internal = function (a) {
		return {$: 'Internal', a: a};
	};
	var elm$browser$Browser$Dom$NotFound = function (a) {
		return {$: 'NotFound', a: a};
	};
	var elm$core$Basics$never = function (_n0) {
		never:
		while (true) {
			var nvr = _n0.a;
			var $temp$_n0 = nvr;
			_n0 = $temp$_n0;
			continue never;
		}
	};
	var elm$url$Url$Http = {$: 'Http'};
	var elm$url$Url$Https = {$: 'Https'};
	var elm$core$String$indexes = _String_indexes;
	var elm$core$String$left = F2(
		function (n, string) {
			return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
		});
	var elm$core$String$contains = _String_contains;
	var elm$core$String$toInt = _String_toInt;
	var elm$url$Url$Url = F6(
		function (protocol, host, port_, path, query, fragment) {
			return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
		});
	var elm$url$Url$chompBeforePath = F5(
		function (protocol, path, params, frag, str) {
			if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, ':', str);
				if (!_n0.b) {
					return elm$core$Maybe$Just(
						A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
				} else {
					if (!_n0.b.b) {
						var i = _n0.a;
						var _n1 = elm$core$String$toInt(
							A2(elm$core$String$dropLeft, i + 1, str));
						if (_n1.$ === 'Nothing') {
							return elm$core$Maybe$Nothing;
						} else {
							var port_ = _n1;
							return elm$core$Maybe$Just(
								A6(
									elm$url$Url$Url,
									protocol,
									A2(elm$core$String$left, i, str),
									port_,
									path,
									params,
									frag));
						}
					} else {
						return elm$core$Maybe$Nothing;
					}
				}
			}
		});
	var elm$url$Url$chompBeforeQuery = F4(
		function (protocol, params, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '/', str);
				if (!_n0.b) {
					return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
				} else {
					var i = _n0.a;
					return A5(
						elm$url$Url$chompBeforePath,
						protocol,
						A2(elm$core$String$dropLeft, i, str),
						params,
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompBeforeFragment = F3(
		function (protocol, frag, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '?', str);
				if (!_n0.b) {
					return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
				} else {
					var i = _n0.a;
					return A4(
						elm$url$Url$chompBeforeQuery,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						frag,
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$chompAfterProtocol = F2(
		function (protocol, str) {
			if (elm$core$String$isEmpty(str)) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n0 = A2(elm$core$String$indexes, '#', str);
				if (!_n0.b) {
					return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
				} else {
					var i = _n0.a;
					return A3(
						elm$url$Url$chompBeforeFragment,
						protocol,
						elm$core$Maybe$Just(
							A2(elm$core$String$dropLeft, i + 1, str)),
						A2(elm$core$String$left, i, str));
				}
			}
		});
	var elm$url$Url$fromString = function (str) {
		return A2(elm$core$String$startsWith, 'http://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Http,
			A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
			elm$url$Url$chompAfterProtocol,
			elm$url$Url$Https,
			A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
	};
	var elm$browser$Browser$element = _Browser_element;
	var author$project$TicketCompanyInfosCard$main = elm$browser$Browser$element(
		{init: author$project$TicketCompanyInfosCard$init, subscriptions: author$project$TicketCompanyInfosCard$subscriptions, update: author$project$TicketCompanyInfosCard$update, view: author$project$TicketCompanyInfosCard$view});
	_Platform_export({'TicketCompanyInfosCard':{'init':author$project$TicketCompanyInfosCard$main(
		A2(
			elm$json$Json$Decode$andThen,
			function (patrimonyUid) {
				return A2(
					elm$json$Json$Decode$andThen,
					function (company) {
						return A2(
							elm$json$Json$Decode$andThen,
							function (apiUrl) {
								return A2(
									elm$json$Json$Decode$andThen,
									function (agencies) {
										return elm$json$Json$Decode$succeed(
											{agencies: agencies, apiUrl: apiUrl, company: company, patrimonyUid: patrimonyUid});
									},
									A2(
										elm$json$Json$Decode$field,
										'agencies',
										elm$json$Json$Decode$list(
											A2(
												elm$json$Json$Decode$andThen,
												function (uid) {
													return A2(
														elm$json$Json$Decode$andThen,
														function (name) {
															return elm$json$Json$Decode$succeed(
																{name: name, uid: uid});
														},
														A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string));
												},
												A2(elm$json$Json$Decode$field, 'uid', elm$json$Json$Decode$string)))));
							},
							A2(elm$json$Json$Decode$field, 'apiUrl', elm$json$Json$Decode$string));
					},
					A2(
						elm$json$Json$Decode$field,
						'company',
						A2(
							elm$json$Json$Decode$andThen,
							function (uid) {
								return A2(
									elm$json$Json$Decode$andThen,
									function (name) {
										return elm$json$Json$Decode$succeed(
											{name: name, uid: uid});
									},
									A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string));
							},
							A2(elm$json$Json$Decode$field, 'uid', elm$json$Json$Decode$string))));
			},
			A2(
				elm$json$Json$Decode$field,
				'patrimonyUid',
				elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
							A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, elm$json$Json$Decode$string)
						])))))(0)}});}(this));

/***/ }),
/* 1823 */,
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8242f6e88ead455da5822ed8354db9f9.png";

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89ce07f28c9963656f83f818c62fe095.png";

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4aac80ff62f21f02e8c4cdaf46d1e4ee.png";

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "08abac8179d06a2a7f7aed9a6195a8cd.png";

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cdd7c274867b0f83fad13d55932274e1.png";

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89889688147bd7575d6327160d64e760.svg";

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(517);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useBeforeUnload = __webpack_require__(1146);
	
	var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);
	
	exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
	module.exports = exports['default'];

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(517);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useQueries = __webpack_require__(535);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
	module.exports = exports['default'];

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(517);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _createLocation2 = __webpack_require__(1144);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _createBrowserHistory = __webpack_require__(1141);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	exports.createHistory = _createBrowserHistory2['default'];
	
	var _createHashHistory2 = __webpack_require__(1014);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	exports.createHashHistory = _createHashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(1145);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];
	
	var _useBasename2 = __webpack_require__(1016);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	exports.useBasename = _useBasename3['default'];
	
	var _useBeforeUnload2 = __webpack_require__(1146);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	exports.useBeforeUnload = _useBeforeUnload3['default'];
	
	var _useQueries2 = __webpack_require__(535);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	exports.useQueries = _useQueries3['default'];
	
	var _Actions2 = __webpack_require__(332);
	
	var _Actions3 = _interopRequireDefault(_Actions2);
	
	exports.Actions = _Actions3['default'];
	
	// deprecated
	
	var _enableBeforeUnload2 = __webpack_require__(1835);
	
	var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);
	
	exports.enableBeforeUnload = _enableBeforeUnload3['default'];
	
	var _enableQueries2 = __webpack_require__(1836);
	
	var _enableQueries3 = _interopRequireDefault(_enableQueries2);
	
	exports.enableQueries = _enableQueries3['default'];
	var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
	exports.createLocation = createLocation;

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 1839 */
/***/ (function(module, exports) {

	module.exports = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"administrative.land_parcel","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]

/***/ }),
/* 1840 */,
/* 1841 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1850),
	    createFind = __webpack_require__(1868);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.exports = find;


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(1864),
	    getNative = __webpack_require__(903);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 1845 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 1846 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1858),
	    baseMatchesProperty = __webpack_require__(1859),
	    bindCallback = __webpack_require__(1018),
	    identity = __webpack_require__(1163),
	    property = __webpack_require__(1878);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1855),
	    cacheIndexOf = __webpack_require__(1863),
	    createCache = __webpack_require__(1867);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1854),
	    createBaseEach = __webpack_require__(1865);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 1851 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ }),
/* 1852 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1150),
	    keysIn = __webpack_require__(1023);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1150),
	    keys = __webpack_require__(1022);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(1873);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(1869),
	    equalByTag = __webpack_require__(1870),
	    equalObjects = __webpack_require__(1871),
	    isArray = __webpack_require__(335),
	    isHostObject = __webpack_require__(1155),
	    isTypedArray = __webpack_require__(1876);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(1152),
	    toObject = __webpack_require__(263);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1857),
	    getMatchData = __webpack_require__(1872),
	    toObject = __webpack_require__(263);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      object = toObject(object);
	      return object[key] === value && (value !== undefined || (key in object));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1151),
	    baseIsEqual = __webpack_require__(1152),
	    baseSlice = __webpack_require__(1861),
	    isArray = __webpack_require__(335),
	    isKey = __webpack_require__(1157),
	    isStrictComparable = __webpack_require__(1158),
	    last = __webpack_require__(1841),
	    toObject = __webpack_require__(263),
	    toPath = __webpack_require__(1161);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1151),
	    toPath = __webpack_require__(1161);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1861 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 1862 */
/***/ (function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(336);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(336);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(1154),
	    isLength = __webpack_require__(536),
	    toObject = __webpack_require__(263);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(263);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(1843),
	    getNative = __webpack_require__(903);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(1848),
	    baseFind = __webpack_require__(1851),
	    baseFindIndex = __webpack_require__(1852),
	    isArray = __webpack_require__(335);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(1847);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 1870 */
/***/ (function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(1022);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(1158),
	    pairs = __webpack_require__(1877);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1873 */
/***/ (function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(1020),
	    isArray = __webpack_require__(335),
	    isIndex = __webpack_require__(1156),
	    isLength = __webpack_require__(536),
	    isString = __webpack_require__(1021),
	    keysIn = __webpack_require__(1023);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object) || isString(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(1162),
	    isHostObject = __webpack_require__(1155),
	    isObjectLike = __webpack_require__(518);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	}
	
	module.exports = isNative;


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(536),
	    isObjectLike = __webpack_require__(518);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(1022),
	    toObject = __webpack_require__(263);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1153),
	    basePropertyDeep = __webpack_require__(1860),
	    isKey = __webpack_require__(1157);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(519),
	    root = __webpack_require__(272);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1925),
	    hashDelete = __webpack_require__(1926),
	    hashGet = __webpack_require__(1927),
	    hashHas = __webpack_require__(1928),
	    hashSet = __webpack_require__(1929);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(519),
	    root = __webpack_require__(272);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(272);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(519),
	    root = __webpack_require__(272);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 1884 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 1885 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1909),
	    isArguments = __webpack_require__(1032),
	    isArray = __webpack_require__(273),
	    isBuffer = __webpack_require__(1187),
	    isIndex = __webpack_require__(1179),
	    isTypedArray = __webpack_require__(1189);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 1887 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(1176);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1028),
	    arrayIncludes = __webpack_require__(1166),
	    arrayIncludesWith = __webpack_require__(1167),
	    arrayMap = __webpack_require__(1168),
	    baseUnary = __webpack_require__(1174),
	    cacheHas = __webpack_require__(1029);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 1890 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1913);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1891),
	    keys = __webpack_require__(1036);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1169),
	    isArray = __webpack_require__(273);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 1894 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1890),
	    baseIsNaN = __webpack_require__(1899),
	    strictIndexOf = __webpack_require__(1959);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(537),
	    isObjectLike = __webpack_require__(520);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(1165),
	    equalArrays = __webpack_require__(1177),
	    equalByTag = __webpack_require__(1915),
	    equalObjects = __webpack_require__(1916),
	    getTag = __webpack_require__(1922),
	    isArray = __webpack_require__(273),
	    isBuffer = __webpack_require__(1187),
	    isTypedArray = __webpack_require__(1189);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(1165),
	    baseIsEqual = __webpack_require__(1172);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1899 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(1188),
	    isMasked = __webpack_require__(1932),
	    isObject = __webpack_require__(1034),
	    toSource = __webpack_require__(1183);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(537),
	    isLength = __webpack_require__(1033),
	    isObjectLike = __webpack_require__(520);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1904),
	    baseMatchesProperty = __webpack_require__(1905),
	    identity = __webpack_require__(910),
	    isArray = __webpack_require__(273),
	    property = __webpack_require__(1968);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1933),
	    nativeKeys = __webpack_require__(1946);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1898),
	    getMatchData = __webpack_require__(1918),
	    matchesStrictComparable = __webpack_require__(1181);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(1172),
	    get = __webpack_require__(1963),
	    hasIn = __webpack_require__(1964),
	    isKey = __webpack_require__(1030),
	    isStrictComparable = __webpack_require__(1180),
	    matchesStrictComparable = __webpack_require__(1181),
	    toKey = __webpack_require__(909);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1906 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1171);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1961),
	    defineProperty = __webpack_require__(1176),
	    identity = __webpack_require__(910);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1909 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(800),
	    arrayMap = __webpack_require__(1168),
	    isArray = __webpack_require__(273),
	    isSymbol = __webpack_require__(1035);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1028),
	    arrayIncludes = __webpack_require__(1166),
	    arrayIncludesWith = __webpack_require__(1167),
	    cacheHas = __webpack_require__(1029),
	    createSet = __webpack_require__(1914),
	    setToArray = __webpack_require__(1031);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(272);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1913 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(1164),
	    noop = __webpack_require__(1967),
	    setToArray = __webpack_require__(1031);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(800),
	    Uint8Array = __webpack_require__(1882),
	    eq = __webpack_require__(1184),
	    equalArrays = __webpack_require__(1177),
	    mapToArray = __webpack_require__(1944),
	    setToArray = __webpack_require__(1031);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1917);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1893),
	    getSymbols = __webpack_require__(1921),
	    keys = __webpack_require__(1036);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(1180),
	    keys = __webpack_require__(1036);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1182);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(800);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1885),
	    stubArray = __webpack_require__(1969);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1879),
	    Map = __webpack_require__(1026),
	    Promise = __webpack_require__(1881),
	    Set = __webpack_require__(1164),
	    WeakMap = __webpack_require__(1883),
	    baseGetTag = __webpack_require__(537),
	    toSource = __webpack_require__(1183);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 1923 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(1175),
	    isArguments = __webpack_require__(1032),
	    isArray = __webpack_require__(273),
	    isIndex = __webpack_require__(1179),
	    isLength = __webpack_require__(1033),
	    toKey = __webpack_require__(909);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(908);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1926 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(908);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(908);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(908);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(800),
	    isArguments = __webpack_require__(1032),
	    isArray = __webpack_require__(273);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1931 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1912);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1933 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 1934 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(906);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(906);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(906);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(906);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1880),
	    ListCache = __webpack_require__(905),
	    Map = __webpack_require__(1026);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(907);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(907);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(907);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(907);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1944 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1966);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1182);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(1178);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(506)(module)))

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1884);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 1950 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1951 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1908),
	    shortOut = __webpack_require__(1953);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 1953 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(905);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1955 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1956 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1957 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(905),
	    Map = __webpack_require__(1026),
	    MapCache = __webpack_require__(1027);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1959 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1945);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1961 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(1889),
	    baseFlatten = __webpack_require__(1170),
	    baseRest = __webpack_require__(1173),
	    isArrayLikeObject = __webpack_require__(1186);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(1171);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1894),
	    hasPath = __webpack_require__(1924);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(1888),
	    baseForOwn = __webpack_require__(1892),
	    baseIteratee = __webpack_require__(1902);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(1027);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1967 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1906),
	    basePropertyDeep = __webpack_require__(1907),
	    isKey = __webpack_require__(1030),
	    toKey = __webpack_require__(909);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1969 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 1970 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1910);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(1170),
	    baseRest = __webpack_require__(1173),
	    baseUniq = __webpack_require__(1911),
	    isArrayLikeObject = __webpack_require__(1186);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ }),
/* 1973 */
/***/ (function(module, exports) {

	/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. MIT license */
	(function(){
	    // Bail out for browsers that have addListener support
	    if (window.matchMedia && window.matchMedia('all').addListener) {
	        return false;
	    }
	
	    var localMatchMedia = window.matchMedia,
	        hasMediaQueries = localMatchMedia('only all').matches,
	        isListening     = false,
	        timeoutID       = 0,    // setTimeout for debouncing 'handleChange'
	        queries         = [],   // Contains each 'mql' and associated 'listeners' if 'addListener' is used
	        handleChange    = function(evt) {
	            // Debounce
	            clearTimeout(timeoutID);
	
	            timeoutID = setTimeout(function() {
	                for (var i = 0, il = queries.length; i < il; i++) {
	                    var mql         = queries[i].mql,
	                        listeners   = queries[i].listeners || [],
	                        matches     = localMatchMedia(mql.media).matches;
	
	                    // Update mql.matches value and call listeners
	                    // Fire listeners only if transitioning to or from matched state
	                    if (matches !== mql.matches) {
	                        mql.matches = matches;
	
	                        for (var j = 0, jl = listeners.length; j < jl; j++) {
	                            listeners[j].call(window, mql);
	                        }
	                    }
	                }
	            }, 30);
	        };
	
	    window.matchMedia = function(media) {
	        var mql         = localMatchMedia(media),
	            listeners   = [],
	            index       = 0;
	
	        mql.addListener = function(listener) {
	            // Changes would not occur to css media type so return now (Affects IE <= 8)
	            if (!hasMediaQueries) {
	                return;
	            }
	
	            // Set up 'resize' listener for browsers that support CSS3 media queries (Not for IE <= 8)
	            // There should only ever be 1 resize listener running for performance
	            if (!isListening) {
	                isListening = true;
	                window.addEventListener('resize', handleChange, true);
	            }
	
	            // Push object only if it has not been pushed already
	            if (index === 0) {
	                index = queries.push({
	                    mql         : mql,
	                    listeners   : listeners
	                });
	            }
	
	            listeners.push(listener);
	        };
	
	        mql.removeListener = function(listener) {
	            for (var i = 0, il = listeners.length; i < il; i++){
	                if (listeners[i] === listener){
	                    listeners.splice(i, 1);
	                }
	            }
	        };
	
	        return mql;
	    };
	}());


/***/ }),
/* 1974 */
/***/ (function(module, exports) {

	/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license */
	
	window.matchMedia || (window.matchMedia = function() {
	    "use strict";
	
	    // For browsers that support matchMedium api such as IE 9 and webkit
	    var styleMedia = (window.styleMedia || window.media);
	
	    // For those that don't support matchMedium
	    if (!styleMedia) {
	        var style       = document.createElement('style'),
	            script      = document.getElementsByTagName('script')[0],
	            info        = null;
	
	        style.type  = 'text/css';
	        style.id    = 'matchmediajs-test';
	
	        if (!script) {
	          document.head.appendChild(style);
	        } else {
	          script.parentNode.insertBefore(style, script);
	        }
	
	        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
	        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;
	
	        styleMedia = {
	            matchMedium: function(media) {
	                var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';
	
	                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
	                if (style.styleSheet) {
	                    style.styleSheet.cssText = text;
	                } else {
	                    style.textContent = text;
	                }
	
	                // Test if media query is true or false
	                return info.width === '1px';
	            }
	        };
	    }
	
	    return function(media) {
	        return {
	            matches: styleMedia.matchMedium(media || 'all'),
	            media: media || 'all'
	        };
	    };
	}());


/***/ }),
/* 1975 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1978);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1978 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(2157);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(1207);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	var Accordion = _react2['default'].createClass({
	  displayName: 'Accordion',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      _extends({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var Alert = _react2['default'].createClass({
	  displayName: 'Alert',
	
	  propTypes: {
	    onDismiss: _react2['default'].PropTypes.func,
	    dismissAfter: _react2['default'].PropTypes.number,
	    closeLabel: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      closeLabel: 'Close Alert'
	    };
	  },
	
	  renderDismissButton: function renderDismissButton() {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: this.props.onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1' },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '×'
	      )
	    );
	  },
	
	  renderSrOnlyDismissButton: function renderSrOnlyDismissButton() {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: this.props.onDismiss },
	      this.props.closeLabel
	    );
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	    var isDismissable = !!this.props.onDismiss;
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'dismissable')] = isDismissable;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { role: 'alert', className: _classnames2['default'](this.props.className, classes) }),
	      isDismissable ? this.renderDismissButton() : null,
	      this.props.children,
	      isDismissable ? this.renderSrOnlyDismissButton() : null
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.dismissAfter && this.props.onDismiss) {
	      this.dismissTimer = setTimeout(this.props.onDismiss, this.props.dismissAfter);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.dismissTimer);
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _styleMaps.State.INFO, _utilsBootstrapUtils.bsClass('alert', Alert));
	module.exports = exports['default'];

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var Badge = _react2['default'].createClass({
	  displayName: 'Badge',
	
	  propTypes: {
	    pullRight: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      pullRight: false,
	      bsClass: 'badge'
	    };
	  },
	
	  hasContent: function hasContent() {
	    return _utilsValidComponentChildren2['default'].hasValidComponent(this.props.children) || _react2['default'].Children.count(this.props.children) > 1 || typeof this.props.children === 'string' || typeof this.props.children === 'number';
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {
	      'pull-right': this.props.pullRight
	    }, _classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = this.hasContent(), _classes);
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Badge;
	module.exports = exports['default'];

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _BreadcrumbItem = __webpack_require__(1190);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var Breadcrumb = _react2['default'].createClass({
	  displayName: 'Breadcrumb',
	
	  propTypes: {
	    /**
	     * bootstrap className
	     * @private
	     */
	    bsClass: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'breadcrumb'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2['default'].createElement(
	      'ol',
	      _extends({}, props, {
	        role: 'navigation',
	        'aria-label': 'breadcrumbs',
	        className: _classnames2['default'](className, this.props.bsClass) }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderBreadcrumbItem)
	    );
	  },
	
	  renderBreadcrumbItem: function renderBreadcrumbItem(child, index) {
	    return _react.cloneElement(child, { key: child.key || index });
	  }
	});
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = Breadcrumb;
	module.exports = exports['default'];

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(523);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormGroup = __webpack_require__(1196);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _InputBase2 = __webpack_require__(1047);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _utilsChildrenValueInputValidation = __webpack_require__(1049);
	
	var _utilsChildrenValueInputValidation2 = _interopRequireDefault(_utilsChildrenValueInputValidation);
	
	var ButtonInput = (function (_InputBase) {
	  _inherits(ButtonInput, _InputBase);
	
	  function ButtonInput() {
	    _classCallCheck(this, ButtonInput);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  ButtonInput.prototype.renderFormGroup = function renderFormGroup(children) {
	    var _props = this.props;
	    var bsStyle = _props.bsStyle;
	    var value = _props.value;
	
	    var other = _objectWithoutProperties(_props, ['bsStyle', 'value']);
	
	    return _react2['default'].createElement(
	      _FormGroup2['default'],
	      other,
	      children
	    );
	  };
	
	  ButtonInput.prototype.renderInput = function renderInput() {
	    var _props2 = this.props;
	    var children = _props2.children;
	    var value = _props2.value;
	
	    var other = _objectWithoutProperties(_props2, ['children', 'value']);
	
	    var val = children ? children : value;
	    return _react2['default'].createElement(_Button2['default'], _extends({}, other, { componentClass: 'input', ref: 'input', key: 'input', value: val }));
	  };
	
	  return ButtonInput;
	})(_InputBase3['default']);
	
	ButtonInput.types = _Button2['default'].types;
	
	ButtonInput.defaultProps = {
	  type: 'button'
	};
	
	ButtonInput.propTypes = {
	  type: _react2['default'].PropTypes.oneOf(ButtonInput.types),
	  bsStyle: function bsStyle() {
	    // defer to Button propTypes of bsStyle
	    return null;
	  },
	  children: _utilsChildrenValueInputValidation2['default'],
	  value: _utilsChildrenValueInputValidation2['default']
	};
	
	exports['default'] = ButtonInput;
	module.exports = exports['default'];

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _Button = __webpack_require__(523);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var ButtonToolbar = _react2['default'].createClass({
	  displayName: 'ButtonToolbar',
	
	  propTypes: {
	    bsSize: _Button2['default'].propTypes.bsSize
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'btn-toolbar'
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        role: 'toolbar',
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = ButtonToolbar;
	module.exports = exports['default'];

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _Object$assign = __webpack_require__(914)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _Glyphicon = __webpack_require__(1045);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _CarouselCaption = __webpack_require__(1987);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(1192);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var Carousel = _react2['default'].createClass({
	  displayName: 'Carousel',
	
	  propTypes: {
	    slide: _react2['default'].PropTypes.bool,
	    indicators: _react2['default'].PropTypes.bool,
	    interval: _react2['default'].PropTypes.number,
	    controls: _react2['default'].PropTypes.bool,
	    pauseOnHover: _react2['default'].PropTypes.bool,
	    wrap: _react2['default'].PropTypes.bool,
	    onSelect: _react2['default'].PropTypes.func,
	    onSlideEnd: _react2['default'].PropTypes.func,
	    activeIndex: _react2['default'].PropTypes.number,
	    defaultActiveIndex: _react2['default'].PropTypes.number,
	    direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	    prevIcon: _react2['default'].PropTypes.node,
	    nextIcon: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'carousel',
	      slide: true,
	      interval: 5000,
	      pauseOnHover: true,
	      wrap: true,
	      indicators: true,
	      controls: true,
	      prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	      nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' })
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      activeIndex: this.props.defaultActiveIndex == null ? 0 : this.props.defaultActiveIndex,
	      previousActiveIndex: null,
	      direction: null
	    };
	  },
	
	  getDirection: function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.waitForNext();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  },
	
	  next: function next(e) {
	    if (e) {
	      e.preventDefault();
	    }
	
	    var index = this.getActiveIndex() + 1;
	    var count = _utilsValidComponentChildren2['default'].numberOf(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.handleSelect(index, 'next');
	  },
	
	  prev: function prev(e) {
	    if (e) {
	      e.preventDefault();
	    }
	
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _utilsValidComponentChildren2['default'].numberOf(this.props.children) - 1;
	    }
	
	    this.handleSelect(index, 'prev');
	  },
	
	  pause: function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  },
	
	  play: function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  },
	
	  waitForNext: function waitForNext() {
	    if (!this.isPaused && this.props.slide && this.props.interval && this.props.activeIndex == null) {
	      this.timeout = setTimeout(this.next, this.props.interval);
	    }
	  },
	
	  handleMouseOver: function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	
	  handleMouseOut: function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = true, _classes.slide = this.props.slide, _classes);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut }),
	      this.props.indicators ? this.renderIndicators() : null,
	      _react2['default'].createElement(
	        'div',
	        {
	          ref: 'inner',
	          className: _utilsBootstrapUtils2['default'].prefix(this.props, 'inner')
	        },
	        _utilsValidComponentChildren2['default'].map(this.props.children, this.renderItem)
	      ),
	      this.props.controls ? this.renderControls() : null
	    );
	  },
	
	  renderPrev: function renderPrev() {
	    var classes = 'left ' + _utilsBootstrapUtils2['default'].prefix(this.props, 'control');
	
	    return _react2['default'].createElement(
	      'a',
	      { className: classes, href: '#prev', key: 0, onClick: this.prev },
	      this.props.prevIcon
	    );
	  },
	
	  renderNext: function renderNext() {
	    var classes = 'right ' + _utilsBootstrapUtils2['default'].prefix(this.props, 'control');
	
	    return _react2['default'].createElement(
	      'a',
	      { className: classes, href: '#next', key: 1, onClick: this.next },
	      this.props.nextIcon
	    );
	  },
	
	  renderControls: function renderControls() {
	    if (!this.props.wrap) {
	      var activeIndex = this.getActiveIndex();
	      var count = _utilsValidComponentChildren2['default'].numberOf(this.props.children);
	
	      return [activeIndex !== 0 ? this.renderPrev() : null, activeIndex !== count - 1 ? this.renderNext() : null];
	    }
	
	    return [this.renderPrev(), this.renderNext()];
	  },
	
	  renderIndicator: function renderIndicator(child, index) {
	    var className = index === this.getActiveIndex() ? 'active' : null;
	
	    return _react2['default'].createElement('li', {
	      key: index,
	      className: className,
	      onClick: this.handleSelect.bind(this, index, null) });
	  },
	
	  renderIndicators: function renderIndicators() {
	    var _this = this;
	
	    var indicators = [];
	    _utilsValidComponentChildren2['default'].forEach(this.props.children, function (child, index) {
	      indicators.push(_this.renderIndicator(child, index),
	
	      // Force whitespace between indicator elements, bootstrap
	      // requires this for correct spacing of elements.
	      ' ');
	    }, this);
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'indicators') },
	      indicators
	    );
	  },
	
	  getActiveIndex: function getActiveIndex() {
	    return this.props.activeIndex != null ? this.props.activeIndex : this.state.activeIndex;
	  },
	
	  handleItemAnimateOutEnd: function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  },
	
	  renderItem: function renderItem(child, index) {
	    var activeIndex = this.getActiveIndex();
	    var isActive = index === activeIndex;
	    var isPreviousActive = this.state.previousActiveIndex != null && this.state.previousActiveIndex === index && this.props.slide;
	
	    return _react.cloneElement(child, {
	      active: isActive,
	      ref: child.ref,
	      key: child.key ? child.key : index,
	      index: index,
	      animateOut: isPreviousActive,
	      animateIn: isActive && this.state.previousActiveIndex != null && this.props.slide,
	      direction: this.state.direction,
	      onAnimateOutEnd: isPreviousActive ? this.handleItemAnimateOutEnd : null
	    });
	  },
	
	  handleSelect: function handleSelect(index, direction) {
	    clearTimeout(this.timeout);
	
	    if (this.isMounted()) {
	      var previousActiveIndex = this.getActiveIndex();
	      direction = direction || this.getDirection(previousActiveIndex, index);
	
	      if (this.props.onSelect) {
	        this.props.onSelect(index, direction);
	      }
	
	      if (this.props.activeIndex == null && index !== previousActiveIndex) {
	        if (this.state.previousActiveIndex != null) {
	          // If currently animating don't activate the new index.
	          // TODO: look into queuing this canceled call and
	          // animating after the current animation has ended.
	          return;
	        }
	
	        this.setState({
	          activeIndex: index,
	          previousActiveIndex: previousActiveIndex,
	          direction: direction
	        });
	      }
	    }
	  }
	});
	
	Carousel = _Object$assign(Carousel, { Caption: _CarouselCaption2['default'], Item: _CarouselItem2['default'] });
	
	exports['default'] = Carousel;
	module.exports = exports['default'];

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var CarouselCaption = _react2['default'].createClass({
	  displayName: 'Carousel.Caption',
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'carousel-caption') }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = CarouselCaption;
	module.exports = exports['default'];

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _Object$keys = __webpack_require__(464)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styleMaps = __webpack_require__(150);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Clearfix = _react2['default'].createClass({
	  displayName: 'Clearfix',
	
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    /**
	     * Apply clearfix
	     *
	     * on Extra small devices Phones
	     *
	     * adds class `visible-xs-block`
	     */
	    visibleXsBlock: _react2['default'].PropTypes.bool,
	    /**
	     * Apply clearfix
	     *
	     * on Small devices Tablets
	     *
	     * adds class `visible-sm-block`
	     */
	    visibleSmBlock: _react2['default'].PropTypes.bool,
	    /**
	     * Apply clearfix
	     *
	     * on Medium devices Desktops
	     *
	     * adds class `visible-md-block`
	     */
	    visibleMdBlock: _react2['default'].PropTypes.bool,
	    /**
	     * Apply clearfix
	     *
	     * on Large devices Desktops
	     *
	     * adds class `visible-lg-block`
	     */
	    visibleLgBlock: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var ComponentClass = this.props.componentClass;
	
	    var classes = {};
	
	    _Object$keys(_styleMaps2['default'].SIZES).forEach(function (key) {
	      var size = _styleMaps2['default'].SIZES[key];
	
	      classes['visible-' + size + '-block'] = _this.props['visible' + size.charAt(0).toUpperCase() + size.slice(1) + 'Block'];
	    }, this);
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'clearfix', classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Clearfix;
	module.exports = exports['default'];

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Collapse = __webpack_require__(804);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsDeprecationWarning = __webpack_require__(913);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var CollapsibleNav = _react2['default'].createClass({
	  displayName: 'CollapsibleNav',
	
	  propTypes: {
	    onSelect: _react2['default'].PropTypes.func,
	    activeHref: _react2['default'].PropTypes.string,
	    activeKey: _react2['default'].PropTypes.any,
	    collapsible: _react2['default'].PropTypes.bool,
	    expanded: _react2['default'].PropTypes.bool,
	    eventKey: _react2['default'].PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      collapsible: false,
	      expanded: false
	    };
	  },
	
	  render: function render() {
	    /*
	     * this.props.collapsible is set in NavBar when an eventKey is supplied.
	     */
	    var classes = this.props.collapsible ? 'navbar-collapse' : null;
	    var renderChildren = this.props.collapsible ? this.renderCollapsibleNavChildren : this.renderChildren;
	
	    var nav = _react2['default'].createElement(
	      'div',
	      { eventKey: this.props.eventKey, className: _classnames2['default'](this.props.className, classes) },
	      _utilsValidComponentChildren2['default'].map(this.props.children, renderChildren)
	    );
	
	    if (this.props.collapsible) {
	      return _react2['default'].createElement(
	        _Collapse2['default'],
	        { 'in': this.props.expanded },
	        nav
	      );
	    }
	    return nav;
	  },
	
	  getChildActiveProp: function getChildActiveProp(child) {
	    if (child.props.active) {
	      return true;
	    }
	    if (this.props.activeKey != null) {
	      if (child.props.eventKey === this.props.activeKey) {
	        return true;
	      }
	    }
	    if (this.props.activeHref != null) {
	      if (child.props.href === this.props.activeHref) {
	        return true;
	      }
	    }
	
	    return child.props.active;
	  },
	
	  renderChildren: function renderChildren(child, index) {
	    var key = child.key ? child.key : index;
	    return _react.cloneElement(child, {
	      activeKey: this.props.activeKey,
	      activeHref: this.props.activeHref,
	      ref: 'nocollapse_' + key,
	      key: key,
	      navItem: true
	    });
	  },
	
	  renderCollapsibleNavChildren: function renderCollapsibleNavChildren(child, index) {
	    var key = child.key ? child.key : index;
	    return _react.cloneElement(child, {
	      active: this.getChildActiveProp(child),
	      activeKey: this.props.activeKey,
	      activeHref: this.props.activeHref,
	      onSelect: _utilsCreateChainedFunction2['default'](child.props.onSelect, this.props.onSelect),
	      ref: 'collapsible_' + key,
	      key: key,
	      navItem: true
	    });
	  }
	});
	
	exports['default'] = _utilsDeprecationWarning2['default'].wrapper(CollapsibleNav, 'CollapsibleNav', 'Navbar.Collapse', 'http://react-bootstrap.github.io/components.html#navbars');
	module.exports = exports['default'];

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _Object$keys = __webpack_require__(464)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(912);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _lodashCompatObjectOmit = __webpack_require__(1024);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _lodashCompatObjectPick = __webpack_require__(904);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var _Button = __webpack_require__(523);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var DropdownButton = (function (_React$Component) {
	  _inherits(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    _classCallCheck(this, DropdownButton);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props;
	    var bsStyle = _props.bsStyle;
	    var bsSize = _props.bsSize;
	    var disabled = _props.disabled;
	    var _props2 = this.props;
	    var title = _props2.title;
	    var children = _props2.children;
	
	    var props = _objectWithoutProperties(_props2, ['title', 'children']);
	
	    var dropdownProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	    var toggleProps = _lodashCompatObjectOmit2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      _extends({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        _extends({}, toggleProps, {
	          disabled: disabled
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	})(_react2['default'].Component);
	
	DropdownButton.propTypes = _extends({
	  disabled: _react2['default'].PropTypes.bool,
	  bsStyle: _Button2['default'].propTypes.bsStyle,
	  bsSize: _Button2['default'].propTypes.bsSize,
	
	  /**
	   * When used with the `title` prop, the noCaret option will not render a caret icon, in the toggle element.
	   */
	  noCaret: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.node.isRequired
	
	}, _Dropdown2['default'].propTypes);
	
	DropdownButton.defaultProps = {
	  disabled: false,
	  pullRight: false,
	  dropup: false,
	  navItem: false,
	  noCaret: false
	};
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _keycode = __webpack_require__(1017);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactOverlaysLibRootCloseWrapper = __webpack_require__(1212);
	
	var _reactOverlaysLibRootCloseWrapper2 = _interopRequireDefault(_reactOverlaysLibRootCloseWrapper);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var DropdownMenu = (function (_React$Component) {
	  _inherits(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    _classCallCheck(this, DropdownMenu);
	
	    _React$Component.call(this, props);
	
	    this.focusNext = this.focusNext.bind(this);
	    this.focusPrevious = this.focusPrevious.bind(this);
	    this.getFocusableMenuItems = this.getFocusableMenuItems.bind(this);
	    this.getItemsAndActiveIndex = this.getItemsAndActiveIndex.bind(this);
	
	    this.handleKeyDown = this.handleKeyDown.bind(this);
	  }
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event);
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveIndex = this.getItemsAndActiveIndex();
	
	    var items = _getItemsAndActiveIndex.items;
	    var activeItemIndex = _getItemsAndActiveIndex.activeItemIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    if (activeItemIndex === items.length - 1) {
	      items[0].focus();
	      return;
	    }
	
	    items[activeItemIndex + 1].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveIndex2 = this.getItemsAndActiveIndex();
	
	    var items = _getItemsAndActiveIndex2.items;
	    var activeItemIndex = _getItemsAndActiveIndex2.activeItemIndex;
	
	    if (activeItemIndex === 0) {
	      items[items.length - 1].focus();
	      return;
	    }
	
	    items[activeItemIndex - 1].focus();
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeElement = document.activeElement;
	    var activeItemIndex = items.indexOf(activeElement);
	
	    return { items: items, activeItemIndex: activeItemIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var menuNode = _reactDom2['default'].findDOMNode(this);
	
	    if (menuNode === undefined) {
	      return [];
	    }
	
	    return [].slice.call(menuNode.querySelectorAll('[tabIndex="-1"]'), 0);
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _classes,
	        _this = this;
	
	    var _props = this.props;
	    var children = _props.children;
	    var onSelect = _props.onSelect;
	    var pullRight = _props.pullRight;
	    var className = _props.className;
	    var labelledBy = _props.labelledBy;
	    var open = _props.open;
	    var onClose = _props.onClose;
	
	    var props = _objectWithoutProperties(_props, ['children', 'onSelect', 'pullRight', 'className', 'labelledBy', 'open', 'onClose']);
	
	    var items = _utilsValidComponentChildren2['default'].map(children, function (child) {
	      var childProps = child.props || {};
	
	      return _react2['default'].cloneElement(child, {
	        onKeyDown: _utilsCreateChainedFunction2['default'](childProps.onKeyDown, _this.handleKeyDown),
	        onSelect: _utilsCreateChainedFunction2['default'](childProps.onSelect, onSelect)
	      }, childProps.children);
	    });
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'menu')] = true, _classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'menu-right')] = pullRight, _classes);
	
	    var list = _react2['default'].createElement(
	      'ul',
	      _extends({
	        className: _classnames2['default'](className, classes),
	        role: 'menu',
	        'aria-labelledby': labelledBy
	      }, props),
	      items
	    );
	
	    if (open) {
	      list = _react2['default'].createElement(
	        _reactOverlaysLibRootCloseWrapper2['default'],
	        { noWrap: true, onRootClose: onClose },
	        list
	      );
	    }
	
	    return list;
	  };
	
	  return DropdownMenu;
	})(_react2['default'].Component);
	
	DropdownMenu.defaultProps = {
	  bsRole: 'menu',
	  bsClass: 'dropdown',
	  pullRight: false
	};
	
	DropdownMenu.propTypes = {
	  open: _react2['default'].PropTypes.bool,
	  pullRight: _react2['default'].PropTypes.bool,
	  onClose: _react2['default'].PropTypes.func,
	  labelledBy: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  onSelect: _react2['default'].PropTypes.func
	};
	
	exports['default'] = DropdownMenu;
	module.exports = exports['default'];

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _InputBase2 = __webpack_require__(1047);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _utilsChildrenValueInputValidation = __webpack_require__(1049);
	
	var _utilsChildrenValueInputValidation2 = _interopRequireDefault(_utilsChildrenValueInputValidation);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Static = (function (_InputBase) {
	  _inherits(Static, _InputBase);
	
	  function Static() {
	    _classCallCheck(this, Static);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  Static.prototype.getValue = function getValue() {
	    var _props = this.props;
	    var children = _props.children;
	    var value = _props.value;
	
	    return children ? children : value;
	  };
	
	  Static.prototype.renderInput = function renderInput() {
	    var _props2 = this.props;
	    var ComponentClass = _props2.componentClass;
	
	    var props = _objectWithoutProperties(_props2, ['componentClass']);
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, props, { className: _classnames2['default'](props.className, 'form-control-static'), ref: 'input', key: 'input' }),
	      this.getValue()
	    );
	  };
	
	  return Static;
	})(_InputBase3['default']);
	
	Static.propTypes = {
	  value: _utilsChildrenValueInputValidation2['default'],
	  /**
	   * You can override the default 'p' with a custom element
	   */
	  componentClass: _reactPropTypesLibElementType2['default'],
	  children: _utilsChildrenValueInputValidation2['default']
	};
	
	Static.defaultProps = {
	  componentClass: 'p'
	};
	
	exports['default'] = Static;
	module.exports = exports['default'];

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Image = _react2['default'].createClass({
	  displayName: 'Image',
	
	  propTypes: {
	
	    /**
	     * Sets image as responsive image
	     */
	    responsive: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as rounded
	     */
	    rounded: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as circle
	     */
	    circle: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as thumbnail
	     */
	    thumbnail: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      responsive: false,
	      rounded: false,
	      circle: false,
	      thumbnail: false
	    };
	  },
	
	  render: function render() {
	    var classes = {
	      'img-responsive': this.props.responsive,
	      'img-rounded': this.props.rounded,
	      'img-circle': this.props.circle,
	      'img-thumbnail': this.props.thumbnail
	    };
	
	    return _react2['default'].createElement('img', _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }));
	  }
	});
	
	exports['default'] = Image;
	module.exports = exports['default'];

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	var _interopRequireWildcard = __webpack_require__(1210)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputBase2 = __webpack_require__(1047);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _FormControls = __webpack_require__(1195);
	
	var FormControls = _interopRequireWildcard(_FormControls);
	
	var _utilsDeprecationWarning = __webpack_require__(913);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var Input = (function (_InputBase) {
	  _inherits(Input, _InputBase);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  Input.prototype.render = function render() {
	    if (this.props.type === 'static') {
	      _utilsDeprecationWarning2['default']('Input type=static', 'FormControls.Static');
	      return _react2['default'].createElement(FormControls.Static, this.props);
	    }
	
	    return _InputBase.prototype.render.call(this);
	  };
	
	  return Input;
	})(_InputBase3['default']);
	
	Input.propTypes = {
	  type: _react2['default'].PropTypes.string
	};
	
	exports['default'] = Input;
	module.exports = exports['default'];

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Jumbotron = _react2['default'].createClass({
	  displayName: 'Jumbotron',
	
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return { componentClass: 'div' };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'jumbotron') }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Jumbotron;
	module.exports = exports['default'];

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var Label = (function (_React$Component) {
	  _inherits(Label, _React$Component);
	
	  function Label() {
	    _classCallCheck(this, _Label);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Label.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  };
	
	  var _Label = Label;
	  Label = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY), _styleMaps.DEFAULT)(Label) || Label;
	  Label = _utilsBootstrapUtils.bsClass('label')(Label) || Label;
	  return Label;
	})(_react2['default'].Component);
	
	exports['default'] = Label;
	module.exports = exports['default'];

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ListGroupItem = __webpack_require__(1198);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var ListGroup = (function (_React$Component) {
	  _inherits(ListGroup, _React$Component);
	
	  function ListGroup() {
	    _classCallCheck(this, ListGroup);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _this = this;
	
	    var items = _utilsValidComponentChildren2['default'].map(this.props.children, function (item, index) {
	      return _react.cloneElement(item, { key: item.key ? item.key : index });
	    });
	
	    if (this.areCustomChildren(items)) {
	      var Component = this.props.componentClass;
	      return _react2['default'].createElement(
	        Component,
	        _extends({}, this.props, {
	          className: _classnames2['default'](this.props.className, 'list-group') }),
	        items
	      );
	    }
	
	    var shouldRenderDiv = false;
	
	    if (!this.props.children) {
	      shouldRenderDiv = true;
	    } else {
	      _utilsValidComponentChildren2['default'].forEach(this.props.children, function (child) {
	        if (_this.isAnchorOrButton(child.props)) {
	          shouldRenderDiv = true;
	        }
	      });
	    }
	
	    return shouldRenderDiv ? this.renderDiv(items) : this.renderUL(items);
	  };
	
	  ListGroup.prototype.isAnchorOrButton = function isAnchorOrButton(props) {
	    return props.href || props.onClick;
	  };
	
	  ListGroup.prototype.areCustomChildren = function areCustomChildren(children) {
	    var customChildren = false;
	
	    _utilsValidComponentChildren2['default'].forEach(children, function (child) {
	      if (child.type !== _ListGroupItem2['default']) {
	        customChildren = true;
	      }
	    }, this);
	
	    return customChildren;
	  };
	
	  ListGroup.prototype.renderUL = function renderUL(items) {
	    var listItems = _utilsValidComponentChildren2['default'].map(items, function (item) {
	      return _react.cloneElement(item, { listItem: true });
	    });
	
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'list-group') }),
	      listItems
	    );
	  };
	
	  ListGroup.prototype.renderDiv = function renderDiv(items) {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'list-group') }),
	      items
	    );
	  };
	
	  return ListGroup;
	})(_react2['default'].Component);
	
	ListGroup.defaultProps = {
	  componentClass: 'div'
	};
	
	ListGroup.propTypes = {
	  className: _react2['default'].PropTypes.string,
	  /**
	   * The element for ListGroup if children are
	   * user-defined custom components.
	   * @type {("ul"|"div")}
	   */
	  componentClass: _react2['default'].PropTypes.oneOf(['ul', 'div']),
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])
	};
	
	exports['default'] = ListGroup;
	module.exports = exports['default'];

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _Object$assign = __webpack_require__(914)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MediaHeading = __webpack_require__(2000);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaBody = __webpack_require__(1999);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaLeft = __webpack_require__(2001);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaRight = __webpack_require__(2004);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _MediaList = __webpack_require__(2002);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(2003);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var Media = _react2['default'].createClass({
	  displayName: 'Media',
	  propTypes: {
	    /**
	     * You can use a custom element for the media container
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var ComponentClass = _props.componentClass;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['componentClass', 'className']);
	
	    return _react2['default'].createElement(ComponentClass, _extends({}, props, { className: _classnames2['default'](className, 'media') }));
	  }
	});
	
	Media = _Object$assign(Media, { Heading: _MediaHeading2['default'], Body: _MediaBody2['default'], Left: _MediaLeft2['default'], Right: _MediaRight2['default'], List: _MediaList2['default'], ListItem: _MediaListItem2['default'] });
	
	exports['default'] = Media;
	module.exports = exports['default'];

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaBody = _react2['default'].createClass({
	  displayName: 'Media.Body',
	  propTypes: {
	    /**
	     * You can use a custom element for the media body
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var ComponentClass = _props.componentClass;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['componentClass', 'className']);
	
	    return _react2['default'].createElement(ComponentClass, _extends({}, props, { className: _classnames2['default'](className, 'media-body') }));
	  }
	});
	
	exports['default'] = MediaBody;
	module.exports = exports['default'];

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaHeading = _react2['default'].createClass({
	  displayName: 'Media.Heading',
	  propTypes: {
	    /**
	     * You can use a custom element for the media heading
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'h4'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var ComponentClass = _props.componentClass;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['componentClass', 'className']);
	
	    return _react2['default'].createElement(ComponentClass, _extends({}, props, { className: _classnames2['default'](className, 'media-heading') }));
	  }
	});
	
	exports['default'] = MediaHeading;
	module.exports = exports['default'];

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaLeft = _react2['default'].createClass({
	  displayName: 'Media.Left',
	  propTypes: {
	    /**
	     * Align the media to the top, middle or bottom
	     * of the media object
	     */
	    align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	  },
	
	  render: function render() {
	    var _classNames;
	
	    var _props = this.props;
	    var align = _props.align;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['align', 'className']);
	
	    var classes = _classnames2['default'](className, 'media-left', (_classNames = {}, _classNames['media-' + align] = Boolean(align), _classNames));
	
	    // Only add the media-alignment class if align is passed in props
	    return _react2['default'].createElement('div', _extends({}, props, { className: classes }));
	  }
	});
	
	exports['default'] = MediaLeft;
	module.exports = exports['default'];

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaList = _react2['default'].createClass({
	  displayName: 'Media.List',
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2['default'].createElement('ul', _extends({}, props, { className: _classnames2['default'](className, 'media-list') }));
	  }
	});
	
	exports['default'] = MediaList;
	module.exports = exports['default'];

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaListItem = _react2['default'].createClass({
	  displayName: 'Media.ListItem',
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2['default'].createElement('li', _extends({}, props, { className: _classnames2['default'](className, 'media') }));
	  }
	});
	
	exports['default'] = MediaListItem;
	module.exports = exports['default'];

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaRight = _react2['default'].createClass({
	  displayName: 'Media.Right',
	  propTypes: {
	    /**
	     * Align the media to the top, middle or bottom
	     * of the media object
	     */
	    align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	  },
	
	  render: function render() {
	    var _classNames;
	
	    var _props = this.props;
	    var align = _props.align;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['align', 'className']);
	
	    var classes = _classnames2['default'](className, 'media-right', (_classNames = {}, _classNames['media-' + align] = Boolean(align), _classNames));
	
	    // Only add the media-alignment class if align is passed in props
	    return _react2['default'].createElement('div', _extends({}, props, { className: classes }));
	  }
	});
	
	exports['default'] = MediaRight;
	module.exports = exports['default'];

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactPropTypesLibAll = __webpack_require__(916);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _SafeAnchor = __webpack_require__(463);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var MenuItem = (function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem(props) {
	    _classCallCheck(this, MenuItem);
	
	    _React$Component.call(this, props);
	
	    this.handleClick = this.handleClick.bind(this);
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    if (!this.props.href || this.props.disabled) {
	      event.preventDefault();
	    }
	
	    if (this.props.disabled) {
	      return;
	    }
	
	    if (this.props.onSelect) {
	      this.props.onSelect(event, this.props.eventKey);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    if (this.props.divider) {
	      return _react2['default'].createElement('li', {
	        role: 'separator',
	        className: _classnames2['default']('divider', this.props.className),
	        style: this.props.style
	      });
	    }
	
	    if (this.props.header) {
	      var headerClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'header');
	
	      return _react2['default'].createElement(
	        'li',
	        {
	          role: 'heading',
	          className: _classnames2['default'](headerClass, this.props.className),
	          style: this.props.style
	        },
	        this.props.children
	      );
	    }
	
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	    var onClick = _props.onClick;
	
	    var props = _objectWithoutProperties(_props, ['className', 'style', 'onClick']);
	
	    var classes = {
	      disabled: this.props.disabled,
	      active: this.props.active
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { role: 'presentation',
	        className: _classnames2['default'](className, classes),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], _extends({}, props, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: _utilsCreateChainedFunction2['default'](onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	})(_react2['default'].Component);
	
	MenuItem.propTypes = {
	
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _react2['default'].PropTypes.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (props) {
	    if (props.divider && props.children) {
	      return new Error('Children will not be rendered for dividers');
	    }
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _react2['default'].PropTypes.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _react2['default'].PropTypes.string,
	
	  /**
	   * HTML `target` attribute corresponding to `a.target`.
	   */
	  target: _react2['default'].PropTypes.string,
	
	  /**
	   * HTML `title` attribute corresponding to `a.title`.
	   */
	  title: _react2['default'].PropTypes.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _react2['default'].PropTypes.func,
	
	  onKeyDown: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * function(Object event, Any eventKey)
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * HTML `id` attribute.
	   */
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])
	};
	
	MenuItem.defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* eslint-disable react/prop-types */
	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _Object$keys = __webpack_require__(464)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var _domHelpersUtilScrollbarSize = __webpack_require__(1810);
	
	var _domHelpersUtilScrollbarSize2 = _interopRequireDefault(_domHelpersUtilScrollbarSize);
	
	var _domHelpersUtilInDOM = __webpack_require__(534);
	
	var _domHelpersUtilInDOM2 = _interopRequireDefault(_domHelpersUtilInDOM);
	
	var _domHelpersOwnerDocument = __webpack_require__(1010);
	
	var _domHelpersOwnerDocument2 = _interopRequireDefault(_domHelpersOwnerDocument);
	
	var _domHelpersEvents = __webpack_require__(1799);
	
	var _domHelpersEvents2 = _interopRequireDefault(_domHelpersEvents);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _Fade = __webpack_require__(1044);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalDialog = __webpack_require__(2007);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalBody = __webpack_require__(1199);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalHeader = __webpack_require__(1201);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(1202);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _ModalFooter = __webpack_require__(1200);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _reactOverlaysLibModal = __webpack_require__(2037);
	
	var _reactOverlaysLibModal2 = _interopRequireDefault(_reactOverlaysLibModal);
	
	var _reactOverlaysLibUtilsIsOverflowing = __webpack_require__(1215);
	
	var _reactOverlaysLibUtilsIsOverflowing2 = _interopRequireDefault(_reactOverlaysLibUtilsIsOverflowing);
	
	var _lodashCompatObjectPick = __webpack_require__(904);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var Modal = _react2['default'].createClass({
	  displayName: 'Modal',
	
	  propTypes: _extends({}, _reactOverlaysLibModal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	    /**
	     * Include a backdrop component. Specify 'static' for a backdrop that doesn't trigger an "onHide" when clicked.
	     */
	    backdrop: _react2['default'].PropTypes.oneOf(['static', true, false]),
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2['default'].PropTypes.bool,
	
	    /**
	     * Open and close the Modal with a slide and fade animation.
	     */
	    animation: _react2['default'].PropTypes.bool,
	
	    /**
	     * A Component type that provides the modal content Markup. This is a useful prop when you want to use your own
	     * styles and markup to create a custom modal component.
	     */
	    dialogComponent: _reactPropTypesLibElementType2['default'],
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and replace it to the last focused element when it closes.
	     * Generally this should never be set to false as it makes the Modal less accessible to assistive technologies, like screen-readers.
	     */
	    autoFocus: _react2['default'].PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     * Consider leaving the default value here, as it is necessary to make the Modal work well with assistive technologies,
	     * such as screen readers.
	     */
	    enforceFocus: _react2['default'].PropTypes.bool,
	
	    /**
	     * Hide this from automatic props documentation generation.
	     * @private
	     */
	    bsStyle: _react2['default'].PropTypes.string,
	
	    /**
	     * When `true` The modal will show itself.
	     */
	    show: _react2['default'].PropTypes.bool,
	
	    /**
	     * A callback fired when the header closeButton or non-static backdrop is
	     * clicked. Required if either are specified.
	     */
	    onHide: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2['default'].PropTypes.func
	  }),
	
	  childContextTypes: {
	    '$bs_onModalHide': _react2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return _extends({}, _reactOverlaysLibModal2['default'].defaultProps, {
	      bsClass: 'modal',
	      animation: true,
	      dialogComponent: _ModalDialog2['default']
	    });
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      modalStyles: {}
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      $bs_onModalHide: this.props.onHide
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _domHelpersEvents2['default'].off(window, 'resize', this.handleWindowResize);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var dialogClassName = _props.dialogClassName;
	    var animation = _props.animation;
	
	    var props = _objectWithoutProperties(_props, ['className', 'children', 'dialogClassName', 'animation']);
	
	    var modalStyles = this.state.modalStyles;
	
	    var inClass = { 'in': props.show && !animation };
	    var Dialog = props.dialogComponent;
	
	    var parentProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_reactOverlaysLibModal2['default'].propTypes).concat(['onExit', 'onExiting', 'onEnter', 'onEntered']) // the rest are fired in _onHide() and _onShow()
	    );
	
	    var modal = _react2['default'].createElement(
	      Dialog,
	      _extends({
	        key: 'modal',
	        ref: function (ref) {
	          return _this._modal = ref;
	        }
	      }, props, {
	        style: modalStyles,
	        className: _classnames2['default'](className, inClass),
	        dialogClassName: dialogClassName,
	        onClick: props.backdrop === true ? this.handleDialogClick : null
	      }),
	      this.props.children
	    );
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibModal2['default'],
	      _extends({}, parentProps, {
	        show: props.show,
	        ref: function (ref) {
	          _this._wrapper = ref && ref.refs.modal;
	          _this._backdrop = ref && ref.refs.backdrop;
	        },
	        onEntering: this._onShow,
	        onExited: this._onHide,
	        backdropClassName: _classnames2['default'](_utilsBootstrapUtils2['default'].prefix(props, 'backdrop'), inClass),
	        containerClassName: _utilsBootstrapUtils2['default'].prefix(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      modal
	    );
	  },
	
	  _onShow: function _onShow() {
	    _domHelpersEvents2['default'].on(window, 'resize', this.handleWindowResize);
	
	    this.setState(this._getStyles());
	
	    if (this.props.onEntering) {
	      var _props2;
	
	      (_props2 = this.props).onEntering.apply(_props2, arguments);
	    }
	  },
	
	  _onHide: function _onHide() {
	    _domHelpersEvents2['default'].off(window, 'resize', this.handleWindowResize);
	
	    if (this.props.onExited) {
	      var _props3;
	
	      (_props3 = this.props).onExited.apply(_props3, arguments);
	    }
	  },
	
	  handleDialogClick: function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  },
	
	  handleWindowResize: function handleWindowResize() {
	    this.setState(this._getStyles());
	  },
	
	  _getStyles: function _getStyles() {
	    if (!_domHelpersUtilInDOM2['default']) {
	      return {};
	    }
	
	    var node = _reactDom2['default'].findDOMNode(this._modal);
	    var doc = _domHelpersOwnerDocument2['default'](node);
	
	    var scrollHt = node.scrollHeight;
	    var bodyIsOverflowing = _reactOverlaysLibUtilsIsOverflowing2['default'](_reactDom2['default'].findDOMNode(this.props.container || doc.body));
	    var modalIsOverflowing = scrollHt > doc.documentElement.clientHeight;
	
	    return {
	      modalStyles: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? _domHelpersUtilScrollbarSize2['default']() : void 0,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? _domHelpersUtilScrollbarSize2['default']() : void 0
	      }
	    };
	  }
	});
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL], _utilsBootstrapUtils.bsClass('modal', Modal));
	module.exports = exports['default'];

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types */
	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var ModalDialog = _react2['default'].createClass({
	  displayName: 'ModalDialog',
	
	  propTypes: {
	    /**
	     * A css class to apply to the Modal dialog DOM node.
	     */
	    dialogClassName: _react2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var modalStyle = _extends({
	      display: 'block'
	    }, this.props.style);
	    var prefix = _utilsBootstrapUtils2['default'].prefix(this.props);
	    var dialogClasses = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    delete dialogClasses[prefix];
	    dialogClasses[_utilsBootstrapUtils2['default'].prefix(this.props, 'dialog')] = true;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        title: null,
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: _classnames2['default'](this.props.className, prefix)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: _classnames2['default'](this.props.dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'content'), role: 'document' },
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL], _utilsBootstrapUtils.bsClass('modal', ModalDialog));
	module.exports = exports['default'];

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(912);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var NavDropdown = (function (_React$Component) {
	  _inherits(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    _classCallCheck(this, NavDropdown);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  NavDropdown.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var title = _props.title;
	    var noCaret = _props.noCaret;
	
	    var props = _objectWithoutProperties(_props, ['children', 'title', 'noCaret']);
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      _extends({}, props, { componentClass: 'li' }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        {
	          useAnchor: true,
	          disabled: props.disabled,
	          noCaret: noCaret
	        },
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return NavDropdown;
	})(_react2['default'].Component);
	
	NavDropdown.propTypes = _extends({
	  noCaret: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.node.isRequired
	}, _Dropdown2['default'].propTypes);
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint react/no-multi-comp: 0 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uncontrollable = __webpack_require__(1262);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(807);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _utilsDeprecationWarning = __webpack_require__(913);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _Grid = __webpack_require__(1046);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _deprecatedNavbar = __webpack_require__(2032);
	
	var _deprecatedNavbar2 = _interopRequireDefault(_deprecatedNavbar);
	
	var _NavbarBrand = __webpack_require__(1048);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarHeader = __webpack_require__(2011);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(2012);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _NavbarCollapse = __webpack_require__(2010);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var has = function has(obj, key) {
	  return obj && ({}).hasOwnProperty.call(obj, key);
	};
	
	function shouldRenderOldNavbar(component) {
	  var props = component.props;
	  return has(props, 'brand') || has(props, 'toggleButton') || has(props, 'toggleNavKey') || has(props, 'navExpanded') || has(props, 'defaultNavExpanded') ||
	  // this should be safe b/c the new version requires wrapping in a Header
	  _utilsValidComponentChildren2['default'].findValidComponents(props.children, function (child) {
	    return child.props.bsRole === 'brand';
	  }).length > 0;
	}
	
	var Navbar = _react2['default'].createClass({
	  displayName: 'Navbar',
	
	  propTypes: {
	    /**
	     * Create a fixed navbar along the top of the screen, that scrolls with the page
	     */
	    fixedTop: _react2['default'].PropTypes.bool,
	    /**
	     * Create a fixed navbar along the bottom of the screen, that scrolls with the page
	     */
	    fixedBottom: _react2['default'].PropTypes.bool,
	    /**
	     * Create a full-width navbar that scrolls away with the page
	     */
	    staticTop: _react2['default'].PropTypes.bool,
	    /**
	     * An alternative dark visual style for the Navbar
	     */
	    inverse: _react2['default'].PropTypes.bool,
	    /**
	     * Allow the Navbar to fluidly adjust to the page or container width, instead of at the
	     * predefined screen breakpoints
	     */
	    fluid: _react2['default'].PropTypes.bool,
	
	    /**
	     * Set a custom element for this component.
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    /**
	     * A callback fired when the `<Navbar>` body collapses or expands.
	     * Fired when a `<Navbar.Toggle>` is clicked and called with the new `navExpanded` boolean value.
	     *
	     * @controllable navExpanded
	     */
	    onToggle: _react2['default'].PropTypes.func,
	
	    /**
	     * Explicitly set the visiblity of the navbar body
	     *
	     * @controllable onToggle
	     */
	    expanded: _react2['default'].PropTypes.bool,
	
	    /**
	     * @deprecated
	     */
	    navExpanded: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use `expanded` and `defaultExpanded` instead.')
	  },
	
	  childContextTypes: {
	    $bs_navbar: _react.PropTypes.bool,
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_onToggle: _react.PropTypes.func,
	    $bs_navbar_expanded: _react.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'nav',
	      fixedTop: false,
	      fixedBottom: false,
	      staticTop: false,
	      inverse: false,
	      fluid: false
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      $bs_navbar: true,
	      $bs_navbar_bsClass: this.props.bsClass,
	      $bs_navbar_onToggle: this.handleToggle,
	      $bs_navbar_expanded: this.props.expanded
	    };
	  },
	
	  handleToggle: function handleToggle() {
	    this.props.onToggle(!this.props.expanded);
	  },
	
	  isNavExpanded: function isNavExpanded() {
	    return !!this.props.expanded;
	  },
	
	  render: function render() {
	    if (shouldRenderOldNavbar(this)) {
	      _utilsDeprecationWarning2['default']({ message: 'Rendering a deprecated version of the Navbar due to the use of deprecated ' + 'props. Please use the new Navbar api, and remove `toggleButton`, ' + '`toggleNavKey`, `brand`, `navExpanded`, `defaultNavExpanded` props or the ' + 'use of the `<NavBrand>` component outside of a `<Navbar.Header>`. \n\n' + 'for more details see: http://react-bootstrap.github.io/components.html#navbars'
	      });
	
	      return _react2['default'].createElement(_deprecatedNavbar2['default'], this.props);
	    }
	
	    var _props = this.props;
	    var fixedTop = _props.fixedTop;
	    var fixedBottom = _props.fixedBottom;
	    var staticTop = _props.staticTop;
	    var inverse = _props.inverse;
	    var ComponentClass = _props.componentClass;
	    var fluid = _props.fluid;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'componentClass', 'fluid', 'className', 'children']);
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	    if (props.role === undefined && ComponentClass !== 'nav') {
	      props.role = 'navigation';
	    }
	
	    if (inverse) {
	      props.bsStyle = _styleMaps.INVERSE;
	    }
	
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(props);
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'fixed-top')] = fixedTop;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'fixed-bottom')] = fixedBottom;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'static-top')] = staticTop;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, props, { className: _classnames2['default'](className, classes) }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  }
	});
	
	var NAVBAR_STATES = [_styleMaps.DEFAULT, _styleMaps.INVERSE];
	
	Navbar = _utilsBootstrapUtils.bsStyles(NAVBAR_STATES, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsClass('navbar', _uncontrollable2['default'](Navbar, { expanded: 'onToggle' })));
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var wrapper = function wrapper(_ref, _ref2) {
	    var Tag = _ref.componentClass;
	    var className = _ref.className;
	
	    var props = _objectWithoutProperties(_ref, ['componentClass', 'className']);
	
	    var _classNames;
	
	    var _ref2$$bs_navbar_bsClass = _ref2.$bs_navbar_bsClass;
	    var bsClass = _ref2$$bs_navbar_bsClass === undefined ? 'navbar' : _ref2$$bs_navbar_bsClass;
	    return _react2['default'].createElement(Tag, _extends({}, props, {
	      className: _classnames2['default'](className, _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, suffix), (_classNames = {}, _classNames[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'right')] = props.pullRight, _classNames[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'left')] = props.pullLeft, _classNames))
	    }));
	  };
	
	  wrapper.displayName = displayName;
	
	  wrapper.propTypes = {
	    componentClass: _reactPropTypesLibElementType2['default'],
	    pullRight: _react2['default'].PropTypes.bool,
	    pullLeft: _react2['default'].PropTypes.bool
	  };
	  wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  wrapper.contextTypes = {
	    $bs_navbar_bsClass: _react.PropTypes.string
	  };
	
	  return wrapper;
	}
	
	Navbar.Brand = _NavbarBrand2['default'];
	Navbar.Header = _NavbarHeader2['default'];
	Navbar.Toggle = _NavbarToggle2['default'];
	Navbar.Collapse = _NavbarCollapse2['default'];
	
	Navbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	Navbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	Navbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	exports['default'] = Navbar;
	module.exports = exports['default'];

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _Collapse = __webpack_require__(804);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var NavbarCollapse = _react2['default'].createClass({
	  displayName: 'NavbarCollapse',
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_expanded: _react.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['children']);
	
	    var _context = this.context;
	    var _context$$bs_navbar_bsClass = _context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	    var expanded = _context.$bs_navbar_expanded;
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      _extends({ 'in': expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'collapse') },
	        children
	      )
	    );
	  }
	});
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var NavbarHeader = _react2['default'].createClass({
	  displayName: 'NavbarHeader',
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    var _context$$bs_navbar_bsClass = this.context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	
	    var headerClasses = _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'header');
	
	    return _react2['default'].createElement('div', _extends({}, props, { className: _classnames2['default'](className, headerClasses) }));
	  }
	});
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var NavbarToggle = _react2['default'].createClass({
	  displayName: 'NavbarToggle',
	
	  propTypes: {
	    onClick: _react2['default'].PropTypes.func,
	    /**
	     * The toggle content, if left empty it will render the default toggle (seen above).
	     */
	    children: _react.PropTypes.node
	  },
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_onToggle: _react.PropTypes.func
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var onClick = _props.onClick;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['onClick', 'className', 'children']);
	
	    var _context = this.context;
	    var _context$$bs_navbar_bsClass = _context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	    var onToggle = _context.$bs_navbar_onToggle;
	
	    var buttonProps = _extends({
	      type: 'button'
	    }, props, {
	      onClick: _utilsCreateChainedFunction2['default'](onClick, onToggle),
	      className: _classnames2['default'](className, _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'toggle'))
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  }
	});
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types */
	
	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _Object$keys = __webpack_require__(464)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _domHelpersQueryContains = __webpack_require__(1011);
	
	var _domHelpersQueryContains2 = _interopRequireDefault(_domHelpersQueryContains);
	
	var _lodashCompatObjectPick = __webpack_require__(904);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(1206);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var OverlayTrigger = _react2['default'].createClass({
	  displayName: 'OverlayTrigger',
	
	  propTypes: _extends({}, _Overlay2['default'].propTypes, {
	
	    /**
	    * Specify which action or actions trigger Overlay visibility
	    */
	    trigger: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']), _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']))]),
	
	    /**
	     * A millisecond delay amount to show and hide the Overlay once triggered
	     */
	    delay: _react2['default'].PropTypes.number,
	    /**
	     * A millisecond delay amount before showing the Overlay once triggered.
	     */
	    delayShow: _react2['default'].PropTypes.number,
	    /**
	     * A millisecond delay amount before hiding the Overlay once triggered.
	     */
	    delayHide: _react2['default'].PropTypes.number,
	
	    /**
	     * The initial visibility state of the Overlay, for more nuanced visibility controll consider
	     * using the Overlay component directly.
	     */
	    defaultOverlayShown: _react2['default'].PropTypes.bool,
	
	    /**
	     * An element or text to overlay next to the target.
	     */
	    overlay: _react2['default'].PropTypes.node.isRequired,
	
	    /**
	     * @private
	     */
	    onBlur: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onClick: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onFocus: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onMouseEnter: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onMouseLeave: _react2['default'].PropTypes.func,
	
	    // override specific overlay props
	    /**
	     * @private
	     */
	    target: function target() {},
	    /**
	    * @private
	    */
	    onHide: function onHide() {},
	    /**
	     * @private
	     */
	    show: function show() {}
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultOverlayShown: false,
	      trigger: ['hover', 'focus']
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isOverlayShown: this.props.defaultOverlayShown
	    };
	  },
	
	  show: function show() {
	    this.setState({
	      isOverlayShown: true
	    });
	  },
	
	  hide: function hide() {
	    this.setState({
	      isOverlayShown: false
	    });
	  },
	
	  toggle: function toggle() {
	    if (this.state.isOverlayShown) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.handleMouseOver = this.handleMouseOverOut.bind(null, this.handleDelayedShow);
	    this.handleMouseOut = this.handleMouseOverOut.bind(null, this.handleDelayedHide);
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  },
	
	  renderOverlay: function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this._mountNode) {
	      this.renderOverlay();
	    }
	  },
	
	  getOverlayTarget: function getOverlayTarget() {
	    return _reactDom2['default'].findDOMNode(this);
	  },
	
	  getOverlay: function getOverlay() {
	    var overlayProps = _extends({}, _lodashCompatObjectPick2['default'](this.props, _Object$keys(_Overlay2['default'].propTypes)), {
	      show: this.state.isOverlayShown,
	      onHide: this.hide,
	      target: this.getOverlayTarget,
	      onExit: this.props.onExit,
	      onExiting: this.props.onExiting,
	      onExited: this.props.onExited,
	      onEnter: this.props.onEnter,
	      onEntering: this.props.onEntering,
	      onEntered: this.props.onEntered
	    });
	
	    var overlay = _react.cloneElement(this.props.overlay, {
	      placement: overlayProps.placement,
	      container: overlayProps.container
	    });
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      overlayProps,
	      overlay
	    );
	  },
	
	  render: function render() {
	    var trigger = _react2['default'].Children.only(this.props.children);
	    var triggerProps = trigger.props;
	
	    var props = {
	      'aria-describedby': this.props.overlay.props.id
	    };
	
	    // create in render otherwise owner is lost...
	    this._overlay = this.getOverlay();
	
	    props.onClick = _utilsCreateChainedFunction2['default'](triggerProps.onClick, this.props.onClick);
	
	    if (isOneOf('click', this.props.trigger)) {
	      props.onClick = _utilsCreateChainedFunction2['default'](this.toggle, props.onClick);
	    }
	
	    if (isOneOf('hover', this.props.trigger)) {
	       false ? _warning2['default'](!(this.props.trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the visibilty of the overlay to just mouse users. ' + 'Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.') : undefined;
	
	      props.onMouseOver = _utilsCreateChainedFunction2['default'](this.handleMouseOver, this.props.onMouseOver, triggerProps.onMouseOver);
	      props.onMouseOut = _utilsCreateChainedFunction2['default'](this.handleMouseOut, this.props.onMouseOut, triggerProps.onMouseOut);
	    }
	
	    if (isOneOf('focus', this.props.trigger)) {
	      props.onFocus = _utilsCreateChainedFunction2['default'](this.handleDelayedShow, this.props.onFocus, triggerProps.onFocus);
	      props.onBlur = _utilsCreateChainedFunction2['default'](this.handleDelayedHide, this.props.onBlur, triggerProps.onBlur);
	    }
	
	    return _react.cloneElement(trigger, props);
	  },
	
	  handleDelayedShow: function handleDelayedShow() {
	    var _this = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.isOverlayShown || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this._hoverShowDelay = null;
	      _this.show();
	    }, delay);
	  },
	
	  handleDelayedHide: function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.isOverlayShown || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	      _this2.hide();
	    }, delay);
	  },
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker moving
	  // from one child element to another.
	  handleMouseOverOut: function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !_domHelpersQueryContains2['default'](target, related)) {
	      handler(e);
	    }
	  }
	
	});
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var PageHeader = _react2['default'].createClass({
	  displayName: 'PageHeader',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'page-header') }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = PageHeader;
	module.exports = exports['default'];

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SafeAnchor = __webpack_require__(463);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var PageItem = _react2['default'].createClass({
	  displayName: 'PageItem',
	
	  propTypes: {
	    href: _react2['default'].PropTypes.string,
	    target: _react2['default'].PropTypes.string,
	    title: _react2['default'].PropTypes.string,
	    disabled: _react2['default'].PropTypes.bool,
	    previous: _react2['default'].PropTypes.bool,
	    next: _react2['default'].PropTypes.bool,
	    onSelect: _react2['default'].PropTypes.func,
	    eventKey: _react2['default'].PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      previous: false,
	      next: false
	    };
	  },
	
	  render: function render() {
	    var classes = {
	      'disabled': this.props.disabled,
	      'previous': this.props.previous,
	      'next': this.props.next
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        {
	          href: this.props.href,
	          title: this.props.title,
	          target: this.props.target,
	          onClick: this.handleSelect },
	        this.props.children
	      )
	    );
	  },
	
	  handleSelect: function handleSelect(e) {
	    if (this.props.onSelect || this.props.disabled) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, this.props.href, this.props.target);
	      }
	    }
	  }
	});
	
	exports['default'] = PageItem;
	module.exports = exports['default'];

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var Pager = _react2['default'].createClass({
	  displayName: 'Pager',
	
	  propTypes: {
	    onSelect: _react2['default'].PropTypes.func
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'pager') }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderPageItem)
	    );
	  },
	
	  renderPageItem: function renderPageItem(child, index) {
	    return _react.cloneElement(child, {
	      onSelect: _utilsCreateChainedFunction2['default'](child.props.onSelect, this.props.onSelect),
	      key: child.key ? child.key : index
	    });
	  }
	});
	
	exports['default'] = Pager;
	module.exports = exports['default'];

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _PaginationButton = __webpack_require__(2018);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _SafeAnchor = __webpack_require__(463);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var Pagination = _react2['default'].createClass({
	  displayName: 'Pagination',
	
	  propTypes: {
	    activePage: _react2['default'].PropTypes.number,
	    items: _react2['default'].PropTypes.number,
	    maxButtons: _react2['default'].PropTypes.number,
	    /**
	     * When `true`, will display the first and the last button page
	     */
	    boundaryLinks: _react2['default'].PropTypes.bool,
	    /**
	     * When `true`, will display the default node value ('&hellip;').
	     * Otherwise, will display provided node (when specified).
	     */
	    ellipsis: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&laquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    first: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&raquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    last: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&lsaquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    prev: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&rsaquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    next: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    onSelect: _react2['default'].PropTypes.func,
	    /**
	     * You can use a custom element for the buttons
	     */
	    buttonComponentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      activePage: 1,
	      items: 1,
	      maxButtons: 0,
	      first: false,
	      last: false,
	      prev: false,
	      next: false,
	      ellipsis: true,
	      boundaryLinks: false,
	      buttonComponentClass: _SafeAnchor2['default'],
	      bsClass: 'pagination'
	    };
	  },
	
	  renderPageButtons: function renderPageButtons() {
	    var pageButtons = [];
	    var startPage = undefined,
	        endPage = undefined,
	        hasHiddenPagesAfter = undefined;
	    var _props = this.props;
	    var maxButtons = _props.maxButtons;
	    var activePage = _props.activePage;
	    var items = _props.items;
	    var onSelect = _props.onSelect;
	    var ellipsis = _props.ellipsis;
	    var buttonComponentClass = _props.buttonComponentClass;
	    var boundaryLinks = _props.boundaryLinks;
	
	    if (maxButtons) {
	      var hiddenPagesBefore = activePage - parseInt(maxButtons / 2, 10);
	      startPage = hiddenPagesBefore > 1 ? hiddenPagesBefore : 1;
	      hasHiddenPagesAfter = startPage + maxButtons <= items;
	
	      if (!hasHiddenPagesAfter) {
	        endPage = items;
	        startPage = items - maxButtons + 1;
	        if (startPage < 1) {
	          startPage = 1;
	        }
	      } else {
	        endPage = startPage + maxButtons - 1;
	      }
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var pagenumber = startPage; pagenumber <= endPage; pagenumber++) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: pagenumber,
	          eventKey: pagenumber,
	          active: pagenumber === activePage,
	          onSelect: onSelect,
	          buttonComponentClass: buttonComponentClass },
	        pagenumber
	      ));
	    }
	
	    if (boundaryLinks && ellipsis && startPage !== 1) {
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsisFirst',
	          disabled: true,
	          buttonComponentClass: buttonComponentClass },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          this.props.ellipsis === true ? '…' : this.props.ellipsis
	        )
	      ));
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 1,
	          eventKey: 1,
	          active: false,
	          onSelect: onSelect,
	          buttonComponentClass: buttonComponentClass },
	        '1'
	      ));
	    }
	
	    if (maxButtons && hasHiddenPagesAfter && ellipsis) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsis',
	          disabled: true,
	          buttonComponentClass: buttonComponentClass },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          this.props.ellipsis === true ? '…' : this.props.ellipsis
	        )
	      ));
	
	      if (boundaryLinks && endPage !== items) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: items,
	            eventKey: items,
	            active: false,
	            onSelect: onSelect,
	            buttonComponentClass: buttonComponentClass },
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  },
	
	  renderPrev: function renderPrev() {
	    if (!this.props.prev) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'prev',
	        eventKey: this.props.activePage - 1,
	        disabled: this.props.activePage === 1,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Previous' },
	        this.props.prev === true ? '‹' : this.props.prev
	      )
	    );
	  },
	
	  renderNext: function renderNext() {
	    if (!this.props.next) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'next',
	        eventKey: this.props.activePage + 1,
	        disabled: this.props.activePage >= this.props.items,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Next' },
	        this.props.next === true ? '›' : this.props.next
	      )
	    );
	  },
	
	  renderFirst: function renderFirst() {
	    if (!this.props.first) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'first',
	        eventKey: 1,
	        disabled: this.props.activePage === 1,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'First' },
	        this.props.first === true ? '«' : this.props.first
	      )
	    );
	  },
	
	  renderLast: function renderLast() {
	    if (!this.props.last) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'last',
	        eventKey: this.props.items,
	        disabled: this.props.activePage >= this.props.items,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Last' },
	        this.props.last === true ? '»' : this.props.last
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].getClassSet(this.props)) }),
	      this.renderFirst(),
	      this.renderPrev(),
	      this.renderPageButtons(),
	      this.renderNext(),
	      this.renderLast()
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('pagination', Pagination);
	module.exports = exports['default'];

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsCreateSelectedEvent = __webpack_require__(2035);
	
	var _utilsCreateSelectedEvent2 = _interopRequireDefault(_utilsCreateSelectedEvent);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var PaginationButton = _react2['default'].createClass({
	  displayName: 'PaginationButton',
	
	  propTypes: {
	    className: _react2['default'].PropTypes.string,
	    eventKey: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    onSelect: _react2['default'].PropTypes.func,
	    disabled: _react2['default'].PropTypes.bool,
	    active: _react2['default'].PropTypes.bool,
	    /**
	     * You can use a custom element for this component
	     */
	    buttonComponentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      disabled: false
	    };
	  },
	
	  handleClick: function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    if (this.props.onSelect) {
	      var selectedEvent = _utilsCreateSelectedEvent2['default'](this.props.eventKey);
	      this.props.onSelect(event, selectedEvent);
	    }
	  },
	
	  render: function render() {
	    var classes = {
	      active: this.props.active,
	      disabled: this.props.disabled
	    };
	
	    var _props = this.props;
	    var className = _props.className;
	
	    var anchorProps = _objectWithoutProperties(_props, ['className']);
	
	    var ButtonComponentClass = this.props.buttonComponentClass;
	
	    return _react2['default'].createElement(
	      'li',
	      { className: _classnames2['default'](className, classes) },
	      _react2['default'].createElement(ButtonComponentClass, _extends({}, anchorProps, {
	        onClick: this.handleClick }))
	    );
	  }
	});
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var _Collapse = __webpack_require__(804);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var Panel = _react2['default'].createClass({
	  displayName: 'Panel',
	
	  propTypes: {
	    collapsible: _react2['default'].PropTypes.bool,
	    onSelect: _react2['default'].PropTypes.func,
	    header: _react2['default'].PropTypes.node,
	    id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    footer: _react2['default'].PropTypes.node,
	    defaultExpanded: _react2['default'].PropTypes.bool,
	    expanded: _react2['default'].PropTypes.bool,
	    eventKey: _react2['default'].PropTypes.any,
	    headerRole: _react2['default'].PropTypes.string,
	    panelRole: _react2['default'].PropTypes.string,
	
	    onEnter: _Collapse2['default'].propTypes.onEnter,
	    onEntering: _Collapse2['default'].propTypes.onEntering,
	    onEntered: _Collapse2['default'].propTypes.onEntered,
	    onExit: _Collapse2['default'].propTypes.onExit,
	    onExiting: _Collapse2['default'].propTypes.onExiting,
	    onExited: _Collapse2['default'].propTypes.onExited
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultExpanded: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      expanded: this.props.defaultExpanded
	    };
	  },
	
	  handleSelect: function handleSelect(e) {
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(e, this.props.eventKey);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.handleToggle();
	    }
	  },
	
	  handleToggle: function handleToggle() {
	    this.setState({ expanded: !this.state.expanded });
	  },
	
	  isExpanded: function isExpanded() {
	    return this.props.expanded != null ? this.props.expanded : this.state.expanded;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var headerRole = _props.headerRole;
	    var panelRole = _props.panelRole;
	
	    var props = _objectWithoutProperties(_props, ['headerRole', 'panelRole']);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].getClassSet(this.props)),
	        id: this.props.collapsible ? null : this.props.id, onSelect: null }),
	      this.renderHeading(headerRole),
	      this.props.collapsible ? this.renderCollapsibleBody(panelRole) : this.renderBody(),
	      this.renderFooter()
	    );
	  },
	
	  renderCollapsibleBody: function renderCollapsibleBody(panelRole) {
	    var collapseProps = {
	      onEnter: this.props.onEnter,
	      onEntering: this.props.onEntering,
	      onEntered: this.props.onEntered,
	      onExit: this.props.onExit,
	      onExiting: this.props.onExiting,
	      onExited: this.props.onExited,
	      'in': this.isExpanded()
	    };
	    var props = {
	      className: _utilsBootstrapUtils2['default'].prefix(this.props, 'collapse'),
	      id: this.props.id,
	      ref: 'panel',
	      'aria-hidden': !this.isExpanded()
	    };
	    if (panelRole) {
	      props.role = panelRole;
	    }
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      collapseProps,
	      _react2['default'].createElement(
	        'div',
	        props,
	        this.renderBody()
	      )
	    );
	  },
	
	  renderBody: function renderBody() {
	    var _this = this;
	
	    var allChildren = this.props.children;
	    var bodyElements = [];
	    var panelBodyChildren = [];
	    var bodyClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'body');
	
	    function getProps() {
	      return { key: bodyElements.length };
	    }
	
	    function addPanelChild(child) {
	      bodyElements.push(_react.cloneElement(child, getProps()));
	    }
	
	    function addPanelBody(children) {
	      bodyElements.push(_react2['default'].createElement(
	        'div',
	        _extends({ className: bodyClass }, getProps()),
	        children
	      ));
	    }
	
	    function maybeRenderPanelBody() {
	      if (panelBodyChildren.length === 0) {
	        return;
	      }
	
	      addPanelBody(panelBodyChildren);
	      panelBodyChildren = [];
	    }
	
	    // Handle edge cases where we should not iterate through children.
	    if (!Array.isArray(allChildren) || allChildren.length === 0) {
	      if (this.shouldRenderFill(allChildren)) {
	        addPanelChild(allChildren);
	      } else {
	        addPanelBody(allChildren);
	      }
	    } else {
	      allChildren.forEach(function (child) {
	        if (_this.shouldRenderFill(child)) {
	          maybeRenderPanelBody();
	
	          // Separately add the filled element.
	          addPanelChild(child);
	        } else {
	          panelBodyChildren.push(child);
	        }
	      });
	
	      maybeRenderPanelBody();
	    }
	
	    return bodyElements;
	  },
	
	  shouldRenderFill: function shouldRenderFill(child) {
	    return _react2['default'].isValidElement(child) && child.props.fill != null;
	  },
	
	  renderHeading: function renderHeading(headerRole) {
	    var header = this.props.header;
	
	    if (!header) {
	      return null;
	    }
	
	    if (!_react2['default'].isValidElement(header) || Array.isArray(header)) {
	      header = this.props.collapsible ? this.renderCollapsibleTitle(header, headerRole) : header;
	    } else {
	      var className = _classnames2['default'](_utilsBootstrapUtils2['default'].prefix(this.props, 'title'), header.props.className);
	
	      if (this.props.collapsible) {
	        header = _react.cloneElement(header, {
	          className: className,
	          children: this.renderAnchor(header.props.children, headerRole)
	        });
	      } else {
	        header = _react.cloneElement(header, { className: className });
	      }
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'heading') },
	      header
	    );
	  },
	
	  renderAnchor: function renderAnchor(header, headerRole) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        href: '#' + (this.props.id || ''),
	        'aria-controls': this.props.collapsible ? this.props.id : null,
	        className: this.isExpanded() ? null : 'collapsed',
	        'aria-expanded': this.isExpanded(),
	        'aria-selected': this.isExpanded(),
	        onClick: this.handleSelect,
	        role: headerRole },
	      header
	    );
	  },
	
	  renderCollapsibleTitle: function renderCollapsibleTitle(header, headerRole) {
	    return _react2['default'].createElement(
	      'h4',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'title'), role: 'presentation' },
	      this.renderAnchor(header, headerRole)
	    );
	  },
	
	  renderFooter: function renderFooter() {
	    if (!this.props.footer) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'footer') },
	      this.props.footer
	    );
	  }
	});
	
	var PANEL_STATES = _styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY);
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(PANEL_STATES, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsClass('panel', Panel));
	module.exports = exports['default'];

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(1055);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var Popover = _react2['default'].createClass({
	  displayName: 'Popover',
	
	  propTypes: {
	
	    /**
	     * An html id attribute, necessary for accessibility
	     * @type {string}
	     * @required
	     */
	    id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	    /**
	     * Sets the direction the Popover is positioned towards.
	     */
	    placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The "left" position value for the Popover.
	     */
	    positionLeft: _react2['default'].PropTypes.number,
	    /**
	     * The "top" position value for the Popover.
	     */
	    positionTop: _react2['default'].PropTypes.number,
	    /**
	     * The "left" position value for the Popover arrow.
	     */
	    arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * The "top" position value for the Popover arrow.
	     */
	    arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * Title text
	     */
	    title: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placement: 'right',
	      bsClass: 'popover'
	    };
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = true, _classes[this.props.placement] = true, _classes);
	
	    var style = _extends({
	      'left': this.props.positionLeft,
	      'top': this.props.positionTop,
	      'display': 'block'
	    }, this.props.style);
	
	    // eslint-disable-line react/prop-types
	    var arrowStyle = {
	      'left': this.props.arrowOffsetLeft,
	      'top': this.props.arrowOffsetTop
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({ role: 'tooltip' }, this.props, { className: _classnames2['default'](this.props.className, classes), style: style, title: null }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      this.props.title ? this.renderTitle() : null,
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'content') },
	        this.props.children
	      )
	    );
	  },
	
	  renderTitle: function renderTitle() {
	    return _react2['default'].createElement(
	      'h3',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'title') },
	      this.props.title
	    );
	  }
	});
	
	exports['default'] = Popover;
	module.exports = exports['default'];
	// we don't want to expose the `style` property

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Interpolate = __webpack_require__(1197);
	
	var _Interpolate2 = _interopRequireDefault(_Interpolate);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	/**
	 * Custom propTypes checker
	 */
	function onlyProgressBar(props, propName, componentName) {
	  if (props[propName]) {
	    var _ret = (function () {
	      var error = undefined,
	          childIdentifier = undefined;
	
	      _react2['default'].Children.forEach(props[propName], function (child) {
	        if (child.type !== ProgressBar) {
	          //eslint-disable-line
	          childIdentifier = child.type.displayName ? child.type.displayName : child.type;
	          error = new Error('Children of ' + componentName + ' can contain only ProgressBar components. Found ' + childIdentifier);
	        }
	      });
	
	      return {
	        v: error
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  }
	}
	
	var ProgressBar = (function (_React$Component) {
	  _inherits(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    _classCallCheck(this, ProgressBar);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ProgressBar.prototype.getPercentage = function getPercentage(now, min, max) {
	    var roundPrecision = 1000;
	    return Math.round((now - min) / (max - min) * 100 * roundPrecision) / roundPrecision;
	  };
	
	  ProgressBar.prototype.render = function render() {
	    if (this.props.isChild) {
	      return this.renderProgressBar();
	    }
	
	    var content = undefined;
	
	    if (this.props.children) {
	      content = _utilsValidComponentChildren2['default'].map(this.props.children, this.renderChildBar);
	    } else {
	      content = this.renderProgressBar();
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'progress'),
	        min: null,
	        max: null,
	        label: null,
	        'aria-valuetext': null
	      }),
	      content
	    );
	  };
	
	  ProgressBar.prototype.renderChildBar = function renderChildBar(child, index) {
	    return _react.cloneElement(child, {
	      isChild: true,
	      key: child.key ? child.key : index
	    });
	  };
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar() {
	    var _classNames;
	
	    var _props = this.props;
	    var className = _props.className;
	    var label = _props.label;
	    var now = _props.now;
	    var min = _props.min;
	    var max = _props.max;
	    var style = _props.style;
	
	    var props = _objectWithoutProperties(_props, ['className', 'label', 'now', 'min', 'max', 'style']);
	
	    var percentage = this.getPercentage(now, min, max);
	
	    if (typeof label === 'string') {
	      label = this.renderLabel(percentage);
	    }
	
	    if (this.props.srOnly) {
	      label = _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      );
	    }
	
	    var classes = _classnames2['default'](className, _utilsBootstrapUtils2['default'].getClassSet(this.props), (_classNames = {
	      active: this.props.active
	    }, _classNames[_utilsBootstrapUtils2['default'].prefix(this.props, 'striped')] = this.props.active || this.props.striped, _classNames));
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: classes,
	        role: 'progressbar',
	        style: _extends({ width: percentage + '%' }, style),
	        'aria-valuenow': this.props.now,
	        'aria-valuemin': this.props.min,
	        'aria-valuemax': this.props.max }),
	      label
	    );
	  };
	
	  ProgressBar.prototype.renderLabel = function renderLabel(percentage) {
	    var InterpolateClass = this.props.interpolateClass || _Interpolate2['default'];
	
	    return _react2['default'].createElement(
	      InterpolateClass,
	      {
	        now: this.props.now,
	        min: this.props.min,
	        max: this.props.max,
	        percent: percentage,
	        bsStyle: this.props.bsStyle },
	      this.props.label
	    );
	  };
	
	  return ProgressBar;
	})(_react2['default'].Component);
	
	ProgressBar.propTypes = _extends({}, ProgressBar.propTypes, {
	  min: _react.PropTypes.number,
	  now: _react.PropTypes.number,
	  max: _react.PropTypes.number,
	  label: _react.PropTypes.node,
	  srOnly: _react.PropTypes.bool,
	  striped: _react.PropTypes.bool,
	  active: _react.PropTypes.bool,
	  children: onlyProgressBar,
	  className: _react2['default'].PropTypes.string,
	  interpolateClass: _react.PropTypes.node,
	  /**
	   * @private
	   */
	  isChild: _react.PropTypes.bool
	});
	
	ProgressBar.defaultProps = _extends({}, ProgressBar.defaultProps, {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	});
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _utilsBootstrapUtils.bsClass('progress-bar', ProgressBar));
	module.exports = exports['default'];

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(149);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var ResponsiveEmbed = (function (_React$Component) {
	  _inherits(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    _classCallCheck(this, ResponsiveEmbed);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _props = this.props;
	    var bsClass = _props.bsClass;
	    var className = _props.className;
	    var a16by9 = _props.a16by9;
	    var a4by3 = _props.a4by3;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['bsClass', 'className', 'a16by9', 'a4by3', 'children']);
	
	     false ? _warning2['default'](!(!a16by9 && !a4by3), '`a16by9` or `a4by3` attribute must be set.') : undefined;
	     false ? _warning2['default'](!(a16by9 && a4by3), 'Either `a16by9` or `a4by3` attribute can be set. Not both.') : undefined;
	
	    var aspectRatio = {
	      'embed-responsive-16by9': a16by9,
	      'embed-responsive-4by3': a4by3
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](bsClass, aspectRatio) },
	      _react.cloneElement(children, _extends({}, props, {
	        className: _classnames2['default'](className, 'embed-responsive-item')
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	})(_react2['default'].Component);
	
	ResponsiveEmbed.defaultProps = {
	  bsClass: 'embed-responsive',
	  a16by9: false,
	  a4by3: false
	};
	
	ResponsiveEmbed.propTypes = {
	  /**
	   * bootstrap className
	   * @private
	   */
	  bsClass: _react.PropTypes.string,
	  /**
	   * This component accepts only one child element
	   */
	  children: _react.PropTypes.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _react.PropTypes.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _react.PropTypes.bool
	};
	
	exports['default'] = ResponsiveEmbed;
	module.exports = exports['default'];

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Row = _react2['default'].createClass({
	  displayName: 'Row',
	
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'row') }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Row;
	module.exports = exports['default'];

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _Object$keys = __webpack_require__(464)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(523);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(912);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(2025);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _lodashCompatObjectOmit = __webpack_require__(1024);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _lodashCompatObjectPick = __webpack_require__(904);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var SplitButton = (function (_React$Component) {
	  _inherits(SplitButton, _React$Component);
	
	  function SplitButton() {
	    _classCallCheck(this, SplitButton);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var title = _props.title;
	    var onClick = _props.onClick;
	    var target = _props.target;
	    var href = _props.href;
	    var toggleLabel = _props.toggleLabel;
	    var bsSize = _props.bsSize;
	    var bsStyle = _props.bsStyle;
	
	    var props = _objectWithoutProperties(_props, ['children', 'title', 'onClick', 'target', 'href', 'toggleLabel', 'bsSize', 'bsStyle']);
	
	    var disabled = props.disabled;
	
	    var dropdownProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	    var buttonProps = _lodashCompatObjectOmit2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      dropdownProps,
	      _react2['default'].createElement(
	        _Button2['default'],
	        _extends({}, buttonProps, {
	          onClick: onClick,
	          bsStyle: bsStyle,
	          bsSize: bsSize,
	          disabled: disabled,
	          target: target,
	          href: href
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsStyle: bsStyle,
	        bsSize: bsSize,
	        disabled: disabled
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	})(_react2['default'].Component);
	
	SplitButton.propTypes = _extends({}, _Dropdown2['default'].propTypes, {
	  bsStyle: _Button2['default'].propTypes.bsStyle,
	
	  /**
	   * @private
	   */
	  onClick: function onClick() {},
	  target: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  /**
	   * The content of the split button.
	   */
	  title: _react2['default'].PropTypes.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _react2['default'].PropTypes.string
	});
	
	SplitButton.defaultProps = {
	  disabled: false,
	  dropup: false,
	  pullRight: false
	};
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(1194);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var SplitToggle = (function (_React$Component) {
	  _inherits(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    _classCallCheck(this, SplitToggle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], _extends({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	})(_react2['default'].Component);
	
	exports['default'] = SplitToggle;
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	module.exports = exports['default'];

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsTransitionEvents = __webpack_require__(1208);
	
	var _utilsTransitionEvents2 = _interopRequireDefault(_utilsTransitionEvents);
	
	var Tab = _react2['default'].createClass({
	  displayName: 'Tab',
	
	  propTypes: {
	    /**
	     * @private
	     */
	    active: _react2['default'].PropTypes.bool,
	    animation: _react2['default'].PropTypes.bool,
	    /**
	     * It is used by 'Tabs' - parent component
	     * @private
	     */
	    onAnimateOutEnd: _react2['default'].PropTypes.func,
	    disabled: _react2['default'].PropTypes.bool,
	    title: _react2['default'].PropTypes.node,
	    /**
	     * tabClassName is used as className for the associated NavItem
	     */
	    tabClassName: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'tab',
	      animation: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      animateIn: false,
	      animateOut: false
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.animation) {
	      if (!this.state.animateIn && nextProps.active && !this.props.active) {
	        this.setState({
	          animateIn: true
	        });
	      } else if (!this.state.animateOut && !nextProps.active && this.props.active) {
	        this.setState({
	          animateOut: true
	        });
	      }
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.state.animateIn) {
	      setTimeout(this.startAnimateIn, 0);
	    }
	    if (this.state.animateOut) {
	      _utilsTransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.stopAnimateOut);
	    }
	  },
	
	  startAnimateIn: function startAnimateIn() {
	    if (this.isMounted()) {
	      this.setState({
	        animateIn: false
	      });
	    }
	  },
	
	  stopAnimateOut: function stopAnimateOut() {
	    if (this.isMounted()) {
	      this.setState({
	        animateOut: false
	      });
	
	      if (this.props.onAnimateOutEnd) {
	        this.props.onAnimateOutEnd();
	      }
	    }
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'pane')] = true, _classes['fade'] = true, _classes['active'] = this.props.active || this.state.animateOut, _classes['in'] = this.props.active && !this.state.animateIn, _classes);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        title: undefined,
	        role: 'tabpanel',
	        'aria-hidden': !this.props.active,
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Table = _react2['default'].createClass({
	  displayName: 'Table',
	
	  propTypes: {
	    striped: _react2['default'].PropTypes.bool,
	    bordered: _react2['default'].PropTypes.bool,
	    condensed: _react2['default'].PropTypes.bool,
	    hover: _react2['default'].PropTypes.bool,
	    responsive: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bordered: false,
	      condensed: false,
	      hover: false,
	      responsive: false,
	      striped: false
	    };
	  },
	
	  render: function render() {
	    var classes = {
	      'table': true,
	      'table-striped': this.props.striped,
	      'table-bordered': this.props.bordered,
	      'table-condensed': this.props.condensed,
	      'table-hover': this.props.hover
	    };
	    var table = _react2['default'].createElement(
	      'table',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	
	    return this.props.responsive ? _react2['default'].createElement(
	      'div',
	      { className: 'table-responsive' },
	      table
	    ) : table;
	  }
	});
	
	exports['default'] = Table;
	module.exports = exports['default'];

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _Object$keys = __webpack_require__(464)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Col = __webpack_require__(1193);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Nav = __webpack_require__(1203);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(1205);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _styleMaps = __webpack_require__(150);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _keycode = __webpack_require__(1017);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var paneId = function paneId(props, child) {
	  return child.props.id ? child.props.id : props.id && props.id + '___pane___' + child.props.eventKey;
	};
	var tabId = function tabId(props, child) {
	  return child.props.id ? child.props.id + '___tab' : props.id && props.id + '___tab___' + child.props.eventKey;
	};
	
	var findChild = _utilsValidComponentChildren2['default'].find;
	
	function getDefaultActiveKeyFromChildren(children) {
	  var defaultActiveKey = undefined;
	
	  _utilsValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	function move(children, currentKey, keys, moveNext) {
	  var lastIdx = keys.length - 1;
	  var stopAt = keys[moveNext ? Math.max(lastIdx, 0) : 0];
	  var nextKey = currentKey;
	
	  function getNext() {
	    var idx = keys.indexOf(nextKey);
	    nextKey = moveNext ? keys[Math.min(lastIdx, idx + 1)] : keys[Math.max(0, idx - 1)];
	
	    return findChild(children, function (_child) {
	      return _child.props.eventKey === nextKey;
	    });
	  }
	
	  var next = getNext();
	
	  while (next.props.eventKey !== stopAt && next.props.disabled) {
	    next = getNext();
	  }
	
	  return next.props.disabled ? currentKey : next.props.eventKey;
	}
	
	var Tabs = _react2['default'].createClass({
	  displayName: 'Tabs',
	
	  propTypes: {
	    activeKey: _react2['default'].PropTypes.any,
	    defaultActiveKey: _react2['default'].PropTypes.any,
	    /**
	     * Navigation style for tabs
	     *
	     * If not specified, it will be treated as `'tabs'` when vertically
	     * positioned and `'pills'` when horizontally positioned.
	     */
	    bsStyle: _react2['default'].PropTypes.oneOf(['tabs', 'pills']),
	    animation: _react2['default'].PropTypes.bool,
	    id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    onSelect: _react2['default'].PropTypes.func,
	    position: _react2['default'].PropTypes.oneOf(['top', 'left', 'right']),
	    /**
	     * Number of grid columns for the tabs if horizontally positioned
	     *
	     * This accepts either a single width or a mapping of size to width.
	     */
	    tabWidth: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.object]),
	    /**
	     * Number of grid columns for the panes if horizontally positioned
	     *
	     * This accepts either a single width or a mapping of size to width. If not
	     * specified, it will be treated as `styleMaps.GRID_COLUMNS` minus
	     * `tabWidth`.
	     */
	    paneWidth: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.object]),
	    /**
	     * Render without clearfix if horizontally positioned
	     */
	    standalone: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'tab',
	      animation: true,
	      tabWidth: 2,
	      position: 'top',
	      standalone: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var defaultActiveKey = this.props.defaultActiveKey != null ? this.props.defaultActiveKey : getDefaultActiveKeyFromChildren(this.props.children);
	
	    return {
	      activeKey: defaultActiveKey,
	      previousActiveKey: null
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this = this;
	
	    if (nextProps.activeKey != null && nextProps.activeKey !== this.props.activeKey) {
	      (function () {
	        // check if the 'previousActiveKey' child still exists
	        var previousActiveKey = _this.props.activeKey;
	        _react2['default'].Children.forEach(nextProps.children, function (child) {
	          if (_react2['default'].isValidElement(child)) {
	            if (child.props.eventKey === previousActiveKey) {
	              _this.setState({
	                previousActiveKey: previousActiveKey
	              });
	              return;
	            }
	          }
	        });
	      })();
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    var tabs = this._tabs;
	    var tabIdx = this._eventKeys().indexOf(this.getActiveKey());
	
	    if (this._needsRefocus) {
	      this._needsRefocus = false;
	      if (tabs && tabIdx !== -1) {
	        var tabNode = _reactDom2['default'].findDOMNode(tabs[tabIdx]);
	
	        if (tabNode) {
	          tabNode.firstChild.focus();
	        }
	      }
	    }
	  },
	
	  handlePaneAnimateOutEnd: function handlePaneAnimateOutEnd() {
	    this.setState({
	      previousActiveKey: null
	    });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var id = _props.id;
	    var className = _props.className;
	    var style = _props.style;
	    var position = _props.position;
	    var bsStyle = _props.bsStyle;
	    var tabWidth = _props.tabWidth;
	    var paneWidth = _props.paneWidth;
	    var standalone = _props.standalone;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['id', 'className', 'style', 'position', 'bsStyle', 'tabWidth', 'paneWidth', 'standalone', 'children']);
	
	    var isHorizontal = position === 'left' || position === 'right';
	
	    if (bsStyle == null) {
	      bsStyle = isHorizontal ? 'pills' : 'tabs';
	    }
	
	    var containerProps = { id: id, className: className, style: style };
	
	    var tabsProps = _extends({}, props, {
	      bsStyle: bsStyle,
	      bsClass: undefined,
	      stacked: isHorizontal,
	      activeKey: this.getActiveKey(),
	      onSelect: this.handleSelect,
	      ref: 'tabs',
	      role: 'tablist'
	    });
	    var childTabs = _utilsValidComponentChildren2['default'].map(children, this.renderTab);
	
	    var panesProps = {
	      className: _utilsBootstrapUtils2['default'].prefix(this.props, 'content'),
	      ref: 'panes'
	    };
	    var childPanes = _utilsValidComponentChildren2['default'].map(children, this.renderPane);
	
	    if (isHorizontal) {
	      if (!standalone) {
	        containerProps.className = _classnames2['default'](containerProps.className, 'clearfix');
	      }
	
	      var _getColProps = this.getColProps({ tabWidth: tabWidth, paneWidth: paneWidth });
	
	      var tabsColProps = _getColProps.tabsColProps;
	      var panesColProps = _getColProps.panesColProps;
	
	      var tabs = _react2['default'].createElement(
	        _Col2['default'],
	        _extends({ componentClass: _Nav2['default'] }, tabsProps, tabsColProps),
	        childTabs
	      );
	      var panes = _react2['default'].createElement(
	        _Col2['default'],
	        _extends({}, panesProps, panesColProps),
	        childPanes
	      );
	
	      if (position === 'left') {
	        return _react2['default'].createElement(
	          'div',
	          containerProps,
	          tabs,
	          panes
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        containerProps,
	        panes,
	        tabs
	      );
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      containerProps,
	      _react2['default'].createElement(
	        _Nav2['default'],
	        tabsProps,
	        childTabs
	      ),
	      _react2['default'].createElement(
	        'div',
	        panesProps,
	        childPanes
	      )
	    );
	  },
	
	  getActiveKey: function getActiveKey() {
	    return this.props.activeKey !== undefined ? this.props.activeKey : this.state.activeKey;
	  },
	
	  renderPane: function renderPane(child, index) {
	    var previousActiveKey = this.state.previousActiveKey;
	
	    var shouldPaneBeSetActive = child.props.eventKey === this.getActiveKey();
	    var thereIsNoActivePane = previousActiveKey == null;
	
	    var paneIsAlreadyActive = previousActiveKey != null && child.props.eventKey === previousActiveKey;
	
	    return _react.cloneElement(child, {
	      active: shouldPaneBeSetActive && (thereIsNoActivePane || !this.props.animation),
	      id: paneId(this.props, child),
	      'aria-labelledby': tabId(this.props, child),
	      key: child.key ? child.key : index,
	      animation: this.props.animation,
	      onAnimateOutEnd: paneIsAlreadyActive ? this.handlePaneAnimateOutEnd : null
	    });
	  },
	
	  renderTab: function renderTab(child, index) {
	    var _this2 = this;
	
	    if (child.props.title == null) {
	      return null;
	    }
	
	    var _child$props = child.props;
	    var eventKey = _child$props.eventKey;
	    var title = _child$props.title;
	    var disabled = _child$props.disabled;
	    var onKeyDown = _child$props.onKeyDown;
	    var tabClassName = _child$props.tabClassName;
	    var _child$props$tabIndex = _child$props.tabIndex;
	    var tabIndex = _child$props$tabIndex === undefined ? 0 : _child$props$tabIndex;
	
	    var isActive = this.getActiveKey() === eventKey;
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        linkId: tabId(this.props, child),
	        ref: function (ref) {
	          return (_this2._tabs || (_this2._tabs = []))[index] = ref;
	        },
	        'aria-controls': paneId(this.props, child),
	        onKeyDown: _utilsCreateChainedFunction2['default'](this.handleKeyDown, onKeyDown),
	        eventKey: eventKey,
	        tabIndex: isActive ? tabIndex : -1,
	        disabled: disabled,
	        className: tabClassName },
	      title
	    );
	  },
	
	  getColProps: function getColProps(_ref) {
	    var tabWidth = _ref.tabWidth;
	    var paneWidth = _ref.paneWidth;
	
	    var tabsColProps = undefined;
	    if (tabWidth instanceof Object) {
	      tabsColProps = tabWidth;
	    } else {
	      tabsColProps = { xs: tabWidth };
	    }
	
	    var panesColProps = undefined;
	    if (paneWidth == null) {
	      panesColProps = {};
	      _Object$keys(tabsColProps).forEach(function (size) {
	        panesColProps[size] = _styleMaps2['default'].GRID_COLUMNS - tabsColProps[size];
	      });
	    } else if (paneWidth instanceof Object) {
	      panesColProps = paneWidth;
	    } else {
	      panesColProps = { xs: paneWidth };
	    }
	
	    return { tabsColProps: tabsColProps, panesColProps: panesColProps };
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    // Defer any updates to this component during the `onSelect` handler.
	    return !this._isChanging;
	  },
	
	  handleSelect: function handleSelect(selectedKey) {
	    if (this.props.onSelect) {
	      this._isChanging = true;
	      this.props.onSelect(selectedKey);
	      this._isChanging = false;
	      return;
	    }
	
	    // if there is no external handler, then use embedded one
	    var previousActiveKey = this.getActiveKey();
	    if (selectedKey !== previousActiveKey) {
	      this.setState({
	        activeKey: selectedKey,
	        previousActiveKey: previousActiveKey
	      });
	    }
	  },
	
	  handleKeyDown: function handleKeyDown(event) {
	    var keys = this._eventKeys();
	    var currentKey = this.getActiveKey() || keys[0];
	    var next = undefined;
	
	    switch (event.keyCode) {
	
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        next = move(this.props.children, currentKey, keys, false);
	
	        if (next && next !== currentKey) {
	          event.preventDefault();
	          this.handleSelect(next);
	          this._needsRefocus = true;
	        }
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        next = move(this.props.children, currentKey, keys, true);
	
	        if (next && next !== currentKey) {
	          event.preventDefault();
	          this.handleSelect(next);
	          this._needsRefocus = true;
	        }
	        break;
	      default:
	    }
	  },
	
	  _eventKeys: function _eventKeys() {
	    var keys = [];
	
	    _utilsValidComponentChildren2['default'].forEach(this.props.children, function (_ref2) {
	      var eventKey = _ref2.props.eventKey;
	      return keys.push(eventKey);
	    });
	
	    return keys;
	  }
	});
	
	exports['default'] = Tabs;
	module.exports = exports['default'];

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SafeAnchor = __webpack_require__(463);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var Thumbnail = _react2['default'].createClass({
	  displayName: 'Thumbnail',
	
	  propTypes: {
	    alt: _react2['default'].PropTypes.string,
	    href: _react2['default'].PropTypes.string,
	    src: _react2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    if (this.props.href) {
	      return _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        _extends({}, this.props, { href: this.props.href, className: _classnames2['default'](this.props.className, classes) }),
	        _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt })
	      );
	    }
	
	    if (this.props.children) {
	      return _react2['default'].createElement(
	        'div',
	        _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	        _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'caption' },
	          this.props.children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt })
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(1055);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var Tooltip = _react2['default'].createClass({
	  displayName: 'Tooltip',
	
	  propTypes: {
	    /**
	     * An html id attribute, necessary for accessibility
	     * @type {string}
	     * @required
	     */
	    id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	    /**
	     * Sets the direction the Tooltip is positioned towards.
	     */
	    placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The "left" position value for the Tooltip.
	     */
	    positionLeft: _react2['default'].PropTypes.number,
	    /**
	     * The "top" position value for the Tooltip.
	     */
	    positionTop: _react2['default'].PropTypes.number,
	    /**
	     * The "left" position value for the Tooltip arrow.
	     */
	    arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * The "top" position value for the Tooltip arrow.
	     */
	    arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * Title text
	     */
	    title: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'tooltip',
	      placement: 'right'
	    };
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = true, _classes[this.props.placement] = true, _classes);
	
	    var style = _extends({
	      'left': this.props.positionLeft,
	      'top': this.props.positionTop
	    }, this.props.style);
	
	    var arrowStyle = {
	      'left': this.props.arrowOffsetLeft,
	      'top': this.props.arrowOffsetTop
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({ role: 'tooltip' }, this.props, { className: _classnames2['default'](this.props.className, classes), style: style }),
	      _react2['default'].createElement('div', { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'inner') },
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(73)['default'];
	
	var _classCallCheck = __webpack_require__(72)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var Well = (function (_React$Component) {
	  _inherits(Well, _React$Component);
	
	  function Well() {
	    _classCallCheck(this, _Well);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Well.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  };
	
	  var _Well = Well;
	  Well = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL])(Well) || Well;
	  Well = _utilsBootstrapUtils.bsClass('well')(Well) || Well;
	  return Well;
	})(_react2['default'].Component);
	
	exports['default'] = Well;
	module.exports = exports['default'];

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(70)['default'];
	
	var _extends = __webpack_require__(26)['default'];
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(807);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _reactPropTypesLibElementType = __webpack_require__(126);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _Grid = __webpack_require__(1046);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavBrand = __webpack_require__(1204);
	
	var _NavBrand2 = _interopRequireDefault(_NavBrand);
	
	var _utilsBootstrapUtils = __webpack_require__(57);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(150);
	
	var _utilsCreateChainedFunction = __webpack_require__(151);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsValidComponentChildren = __webpack_require__(139);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var Navbar = _react2['default'].createClass({
	  displayName: 'Navbar',
	
	  propTypes: {
	    fixedTop: _react2['default'].PropTypes.bool,
	    fixedBottom: _react2['default'].PropTypes.bool,
	    staticTop: _react2['default'].PropTypes.bool,
	    inverse: _react2['default'].PropTypes.bool,
	    fluid: _react2['default'].PropTypes.bool,
	    role: _react2['default'].PropTypes.string,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    brand: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.node, 'Use the `NavBrand` component.'),
	    toggleButton: _react2['default'].PropTypes.node,
	    toggleNavKey: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    onToggle: _react2['default'].PropTypes.func,
	    navExpanded: _react2['default'].PropTypes.bool,
	    defaultNavExpanded: _react2['default'].PropTypes.bool
	  },
	
	  // TODO Remove in 0.29
	  childContextTypes: {
	    $bs_deprecated_navbar: _react2['default'].PropTypes.bool
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      $bs_deprecated_navbar: true
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      role: 'navigation',
	      componentClass: 'nav',
	      fixedTop: false,
	      fixedBottom: false,
	      staticTop: false,
	      inverse: false,
	      fluid: false,
	      defaultNavExpanded: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      navExpanded: this.props.defaultNavExpanded
	    };
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    // Defer any updates to this component during the `onSelect` handler.
	    return !this._isChanging;
	  },
	
	  handleToggle: function handleToggle() {
	    if (this.props.onToggle) {
	      this._isChanging = true;
	      this.props.onToggle();
	      this._isChanging = false;
	    }
	
	    this.setState({
	      navExpanded: !this.state.navExpanded
	    });
	  },
	
	  isNavExpanded: function isNavExpanded() {
	    return this.props.navExpanded != null ? this.props.navExpanded : this.state.navExpanded;
	  },
	
	  hasNavBrandChild: function hasNavBrandChild() {
	    return _utilsValidComponentChildren2['default'].findValidComponents(this.props.children, function (child) {
	      return child.props.bsRole === 'brand';
	    }).length > 0;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var brand = _props.brand;
	    var toggleButton = _props.toggleButton;
	    var toggleNavKey = _props.toggleNavKey;
	    var fixedTop = _props.fixedTop;
	    var fixedBottom = _props.fixedBottom;
	    var staticTop = _props.staticTop;
	    var inverse = _props.inverse;
	    var ComponentClass = _props.componentClass;
	    var fluid = _props.fluid;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['brand', 'toggleButton', 'toggleNavKey', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'componentClass', 'fluid', 'className', 'children']);
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	    if (props.role === undefined && ComponentClass !== 'nav') {
	      props.role = 'navigation';
	    }
	
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'fixed-top')] = this.props.fixedTop;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'fixed-bottom')] = this.props.fixedBottom;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'static-top')] = this.props.staticTop;
	
	    // handle built-in styles manually to provide the convenience `inverse` prop
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, _styleMaps.INVERSE)] = this.props.inverse;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, _styleMaps.DEFAULT)] = !this.props.inverse;
	
	    var showHeader = (brand || toggleButton || toggleNavKey != null) && !this.hasNavBrandChild();
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, props, { className: _classnames2['default'](className, classes) }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        showHeader ? this.renderBrandHeader() : null,
	        _utilsValidComponentChildren2['default'].map(children, this.renderChild)
	      )
	    );
	  },
	
	  renderBrandHeader: function renderBrandHeader() {
	    var brand = this.props.brand;
	
	    if (brand) {
	      brand = _react2['default'].createElement(
	        _NavBrand2['default'],
	        null,
	        brand
	      );
	    }
	
	    return this.renderHeader(brand);
	  },
	
	  renderHeader: function renderHeader(brand) {
	    var hasToggle = this.props.toggleButton || this.props.toggleNavKey != null;
	    var headerClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'header');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: headerClass },
	      brand,
	      hasToggle ? this.renderToggleButton() : null
	    );
	  },
	
	  renderChild: function renderChild(child, index) {
	    var key = child.key != null ? child.key : index;
	
	    if (child.props.bsRole === 'brand') {
	      return _react2['default'].cloneElement(this.renderHeader(child), { key: key });
	    }
	
	    var toggleNavKey = this.props.toggleNavKey;
	
	    var collapsible = toggleNavKey != null && toggleNavKey === child.props.eventKey;
	
	    return _react2['default'].cloneElement(child, {
	      navbar: true,
	      collapsible: collapsible,
	      expanded: collapsible && this.isNavExpanded(),
	      key: key
	    });
	  },
	
	  renderToggleButton: function renderToggleButton() {
	    var toggleButton = this.props.toggleButton;
	
	    var toggleClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'toggle');
	
	    if (_react2['default'].isValidElement(toggleButton)) {
	      return _react2['default'].cloneElement(toggleButton, {
	        className: _classnames2['default'](toggleButton.props.className, toggleClass),
	        onClick: _utilsCreateChainedFunction2['default'](this.handleToggle, toggleButton.props.onClick)
	      });
	    }
	
	    var children = undefined;
	    if (toggleButton != null) {
	      children = toggleButton;
	    } else {
	      children = [_react2['default'].createElement(
	        'span',
	        { className: 'sr-only', key: 0 },
	        'Toggle navigation'
	      ), _react2['default'].createElement('span', { className: 'icon-bar', key: 1 }), _react2['default'].createElement('span', { className: 'icon-bar', key: 2 }), _react2['default'].createElement('span', { className: 'icon-bar', key: 3 })];
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        onClick: this.handleToggle,
	        className: toggleClass
	      },
	      children
	    );
	  }
	
	});
	
	var NAVBAR_STATES = [_styleMaps.DEFAULT, _styleMaps.INVERSE];
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(NAVBAR_STATES, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsClass('navbar', Navbar));
	module.exports = exports['default'];

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	
	var _reactPropTypesLibCommon = __webpack_require__(1054);
	
	var _childrenToArray = __webpack_require__(2034);
	
	var _childrenToArray2 = _interopRequireDefault(_childrenToArray);
	
	exports['default'] = {
	
	  requiredRoles: function requiredRoles() {
	    for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	      roles[_key] = arguments[_key];
	    }
	
	    return _reactPropTypesLibCommon.createChainableTypeChecker(function requiredRolesValidator(props, propName, component) {
	      var missing = undefined;
	      var children = _childrenToArray2['default'](props.children);
	
	      var inRole = function inRole(role, child) {
	        return role === child.props.bsRole;
	      };
	
	      roles.every(function (role) {
	        if (!children.some(function (child) {
	          return inRole(role, child);
	        })) {
	          missing = role;
	          return false;
	        }
	        return true;
	      });
	
	      if (missing) {
	        return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + missing + '. ' + (component + ' must have at least one child of each of the following bsRoles: ' + roles.join(', ')));
	      }
	    });
	  },
	
	  exclusiveRoles: function exclusiveRoles() {
	    for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      roles[_key2] = arguments[_key2];
	    }
	
	    return _reactPropTypesLibCommon.createChainableTypeChecker(function exclusiveRolesValidator(props, propName, component) {
	      var children = _childrenToArray2['default'](props.children);
	      var duplicate = undefined;
	
	      roles.every(function (role) {
	        var childrenWithRole = children.filter(function (child) {
	          return child.props.bsRole === role;
	        });
	
	        if (childrenWithRole.length > 1) {
	          duplicate = role;
	          return false;
	        }
	        return true;
	      });
	
	      if (duplicate) {
	        return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + duplicate + '. ' + ('Only one child each allowed with the following bsRoles: ' + roles.join(', ')));
	      }
	    });
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(20)['default'];
	
	exports.__esModule = true;
	exports['default'] = childrenAsArray;
	
	var _ValidComponentChildren = __webpack_require__(139);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function childrenAsArray(children) {
	  var result = [];
	
	  if (children === undefined) {
	    return result;
	  }
	
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    result.push(child);
	  });
	
	  return result;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createSelectedEvent;
	
	function createSelectedEvent(eventKey) {
	  var selectionPrevented = false;
	
	  return {
	    eventKey: eventKey,
	
	    preventSelection: function preventSelection() {
	      selectionPrevented = true;
	    },
	
	    isSelectionPrevented: function isSelectionPrevented() {
	      return selectionPrevented;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1575), __esModule: true };

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(2059);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(1053);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(1222);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(1211);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(2038);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(805);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(1214);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(2041);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(538);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(2044);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(1051);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(1050);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(1052);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(2046);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(2058);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(1215);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(2043);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(1211);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(2040);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(1212);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(1222);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(1053);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(2042);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(1050);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(805);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(1218);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(2050);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(1219);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(805);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(806));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1216));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(2045));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(2047));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1216));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(538));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(806));
	
	var _style = _interopRequireDefault(__webpack_require__(1052));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(1263));
	
	var _offset = _interopRequireDefault(__webpack_require__(1218));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(2049));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(1219));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(2051));
	
	var _style = _interopRequireDefault(__webpack_require__(1052));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(915));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(1221));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(2056));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(128);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(538));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 2060 */
/***/ (function(module, exports) {

	/**
	 * Checks if only one of the listed properties is in use. An error is given
	 * if multiple have a value
	 *
	 * @param props
	 * @param propName
	 * @param componentName
	 * @returns {Error|undefined}
	 */
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createSinglePropFromChecker;
	
	function createSinglePropFromChecker() {
	  for (var _len = arguments.length, arrOfProps = Array(_len), _key = 0; _key < _len; _key++) {
	    arrOfProps[_key] = arguments[_key];
	  }
	
	  function validate(props, propName) {
	    var usedPropCount = arrOfProps.map(function (listedProp) {
	      return props[listedProp];
	    }).reduce(function (acc, curr) {
	      return acc + (curr !== undefined ? 1 : 0);
	    }, 0);
	
	    if (usedPropCount > 1) {
	      var first = arrOfProps[0];
	      var others = arrOfProps.slice(1);
	
	      var message = others.join(', ') + ' and ' + first;
	      return new Error('Invalid prop \'' + propName + '\', only one of the following ' + ('may be provided: ' + message));
	    }
	  }
	  return validate;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Helpers = __webpack_require__(2062);
	
	var Helpers = _interopRequireWildcard(_Helpers);
	
	var _DateUtils = __webpack_require__(1056);
	
	var DateUtils = _interopRequireWildcard(_DateUtils);
	
	var _LocaleUtils = __webpack_require__(1057);
	
	var LocaleUtils = _interopRequireWildcard(_LocaleUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var keys = {
	  LEFT: 37,
	  RIGHT: 39,
	  ENTER: 13,
	  SPACE: 32
	};
	
	var Caption = function (_Component) {
	  _inherits(Caption, _Component);
	
	  function Caption() {
	    _classCallCheck(this, Caption);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Caption).apply(this, arguments));
	  }
	
	  _createClass(Caption, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var date = _props.date;
	      var locale = _props.locale;
	      var localeUtils = _props.localeUtils;
	      var onClick = _props.onClick;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "DayPicker-Caption", onClick: onClick },
	        localeUtils.formatMonthTitle(date, locale)
	      );
	    }
	  }]);
	
	  return Caption;
	}(_react.Component);
	
	var DayPicker = function (_Component2) {
	  _inherits(DayPicker, _Component2);
	
	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);
	
	    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(DayPicker).call(this, props));
	
	    _this2.state = {
	      currentMonth: Helpers.startOfMonth(props.initialMonth)
	    };
	    return _this2;
	  }
	
	  _createClass(DayPicker, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.initialMonth !== nextProps.initialMonth) {
	        this.setState({
	          currentMonth: Helpers.startOfMonth(nextProps.initialMonth)
	        });
	      }
	    }
	  }, {
	    key: "allowPreviousMonth",
	    value: function allowPreviousMonth() {
	      var fromMonth = this.props.fromMonth;
	
	      if (!fromMonth) {
	        return true;
	      }
	      var currentMonth = this.state.currentMonth;
	
	      return Helpers.getMonthsDiff(currentMonth, fromMonth) < 0;
	    }
	  }, {
	    key: "allowNextMonth",
	    value: function allowNextMonth() {
	      var _props2 = this.props;
	      var toMonth = _props2.toMonth;
	      var numberOfMonths = _props2.numberOfMonths;
	
	      if (!toMonth) {
	        return true;
	      }
	      var currentMonth = this.state.currentMonth;
	
	      return Helpers.getMonthsDiff(currentMonth, toMonth) >= numberOfMonths;
	    }
	  }, {
	    key: "allowMonth",
	    value: function allowMonth(d) {
	      var _props3 = this.props;
	      var fromMonth = _props3.fromMonth;
	      var toMonth = _props3.toMonth;
	
	      if (fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "showMonth",
	    value: function showMonth(d) {
	      if (!this.allowMonth(d)) {
	        return;
	      }
	      this.setState({
	        currentMonth: Helpers.startOfMonth(d)
	      });
	    }
	  }, {
	    key: "showNextMonth",
	    value: function showNextMonth(callback) {
	      var _this3 = this;
	
	      if (!this.allowNextMonth()) {
	        return;
	      }
	      var currentMonth = this.state.currentMonth;
	
	      var nextMonth = DateUtils.addMonths(currentMonth, 1);
	      this.setState({
	        currentMonth: nextMonth
	      }, function () {
	        if (callback) {
	          callback();
	        }
	        if (_this3.props.onMonthChange) {
	          _this3.props.onMonthChange(_this3.state.currentMonth);
	        }
	      });
	    }
	  }, {
	    key: "showPreviousMonth",
	    value: function showPreviousMonth(callback) {
	      var _this4 = this;
	
	      if (!this.allowPreviousMonth()) {
	        return;
	      }
	      var currentMonth = this.state.currentMonth;
	
	      var prevMonth = DateUtils.addMonths(currentMonth, -1);
	      this.setState({
	        currentMonth: prevMonth
	      }, function () {
	        if (callback) {
	          callback();
	        }
	        if (_this4.props.onMonthChange) {
	          _this4.props.onMonthChange(_this4.state.currentMonth);
	        }
	      });
	    }
	  }, {
	    key: "focusPreviousDay",
	    value: function focusPreviousDay(dayNode) {
	      var body = dayNode.parentNode.parentNode.parentNode.parentNode;
	      var dayNodes = body.querySelectorAll(".DayPicker-Day:not(.DayPicker-Day--outside)");
	      var nodeIndex = void 0;
	      for (var i = 0; i < dayNodes.length; i++) {
	        if (dayNodes[i] === dayNode) {
	          nodeIndex = i;
	          break;
	        }
	      }
	      if (nodeIndex === 0) {
	        var currentMonth = this.state.currentMonth;
	        var numberOfMonths = this.props.numberOfMonths;
	
	        var prevMonth = DateUtils.addMonths(currentMonth, -numberOfMonths);
	        this.setState({
	          currentMonth: prevMonth
	        }, function () {
	          dayNodes = body.querySelectorAll(".DayPicker-Day:not(.DayPicker-Day--outside)");
	          dayNodes[dayNodes.length - 1].focus();
	        });
	      } else {
	        dayNodes[nodeIndex - 1].focus();
	      }
	    }
	  }, {
	    key: "focusNextDay",
	    value: function focusNextDay(dayNode) {
	      var body = dayNode.parentNode.parentNode.parentNode.parentNode;
	      var dayNodes = body.querySelectorAll(".DayPicker-Day:not(.DayPicker-Day--outside)");
	      var nodeIndex = void 0;
	      for (var i = 0; i < dayNodes.length; i++) {
	        if (dayNodes[i] === dayNode) {
	          nodeIndex = i;
	          break;
	        }
	      }
	
	      if (nodeIndex === dayNodes.length - 1) {
	        var currentMonth = this.state.currentMonth;
	        var numberOfMonths = this.props.numberOfMonths;
	
	        var nextMonth = DateUtils.addMonths(currentMonth, numberOfMonths);
	        this.setState({
	          currentMonth: nextMonth
	        }, function () {
	          dayNodes = body.querySelectorAll(".DayPicker-Day:not(.DayPicker-Day--outside)");
	          dayNodes[0].focus();
	        });
	      } else {
	        dayNodes[nodeIndex + 1].focus();
	      }
	    }
	
	    // Event handlers
	
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(e) {
	      e.persist();
	      var _props4 = this.props;
	      var canChangeMonth = _props4.canChangeMonth;
	      var onKeyDown = _props4.onKeyDown;
	
	
	      if (!canChangeMonth && onKeyDown) {
	        onKeyDown(e);
	        return;
	      }
	
	      if (canChangeMonth) {
	        switch (e.keyCode) {
	          case keys.LEFT:
	            this.showPreviousMonth(onKeyDown);
	            break;
	          case keys.RIGHT:
	            this.showNextMonth(onKeyDown);
	            break;
	          default:
	            if (onKeyDown) {
	              onKeyDown(e);
	            }
	        }
	      }
	    }
	  }, {
	    key: "handleDayKeyDown",
	    value: function handleDayKeyDown(e, day, modifiers) {
	      e.persist();
	      switch (e.keyCode) {
	        case keys.LEFT:
	          e.preventDefault();
	          e.stopPropagation();
	          this.focusPreviousDay(e.target);
	          break;
	        case keys.RIGHT:
	          e.preventDefault();
	          e.stopPropagation();
	          this.focusNextDay(e.target);
	          break;
	        case keys.ENTER:
	        case keys.SPACE:
	          e.preventDefault();
	          e.stopPropagation();
	          if (this.props.onDayClick) {
	            this.handleDayClick(e, day, modifiers);
	          }
	          if (this.props.onDayTouchTap) {
	            this.handleDayTouchTap(e, day, modifiers);
	          }
	          break;
	      }
	    }
	  }, {
	    key: "handleNextMonthClick",
	    value: function handleNextMonthClick() {
	      this.showNextMonth();
	    }
	  }, {
	    key: "handlePrevMonthClick",
	    value: function handlePrevMonthClick() {
	      this.showPreviousMonth();
	    }
	  }, {
	    key: "handleCaptionClick",
	    value: function handleCaptionClick(e, currentMonth) {
	      e.persist();
	      this.props.onCaptionClick(e, currentMonth);
	    }
	  }, {
	    key: "handleDayTouchTap",
	    value: function handleDayTouchTap(e, day, modifiers) {
	      e.persist();
	      if (modifiers.indexOf("outside") > -1) {
	        this.handleOutsideDayPress(day);
	      }
	      this.props.onDayTouchTap(e, day, modifiers);
	    }
	  }, {
	    key: "handleDayClick",
	    value: function handleDayClick(e, day, modifiers) {
	      e.persist();
	      if (modifiers.indexOf("outside") > -1) {
	        this.handleOutsideDayPress(day);
	      }
	
	      this.props.onDayClick(e, day, modifiers);
	    }
	  }, {
	    key: "handleDayMouseEnter",
	    value: function handleDayMouseEnter(e, day, modifiers) {
	      e.persist();
	      this.props.onDayMouseEnter(e, day, modifiers);
	    }
	  }, {
	    key: "handleDayMouseLeave",
	    value: function handleDayMouseLeave(e, day, modifiers) {
	      e.persist();
	      this.props.onDayMouseLeave(e, day, modifiers);
	    }
	  }, {
	    key: "handleOutsideDayPress",
	    value: function handleOutsideDayPress(day) {
	      var currentMonth = this.state.currentMonth;
	      var numberOfMonths = this.props.numberOfMonths;
	
	      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
	      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
	        this.showNextMonth();
	      } else if (diffInMonths < 0) {
	        this.showPreviousMonth();
	      }
	    }
	  }, {
	    key: "renderNavBar",
	    value: function renderNavBar() {
	      var baseClass = "DayPicker-NavButton DayPicker-NavButton";
	      var isRTL = this.props.dir === "rtl";
	
	      var leftButton = isRTL ? this.allowNextMonth() : this.allowPreviousMonth();
	      var rightButton = isRTL ? this.allowPreviousMonth() : this.allowNextMonth();
	      return _react2.default.createElement(
	        "div",
	        { className: "DayPicker-NavBar" },
	        leftButton && _react2.default.createElement("span", {
	          key: "left",
	          className: baseClass + "--prev",
	          onClick: isRTL ? this.handleNextMonthClick.bind(this) : this.handlePrevMonthClick.bind(this)
	        }),
	        rightButton && _react2.default.createElement("span", {
	          key: "right",
	          className: baseClass + "--next",
	          onClick: isRTL ? this.handlePrevMonthClick.bind(this) : this.handleNextMonthClick.bind(this)
	        })
	      );
	    }
	  }, {
	    key: "renderMonth",
	    value: function renderMonth(date, i) {
	      var _this5 = this;
	
	      var _props5 = this.props;
	      var locale = _props5.locale;
	      var localeUtils = _props5.localeUtils;
	      var onCaptionClick = _props5.onCaptionClick;
	      var captionElement = _props5.captionElement;
	
	
	      var caption = _react2.default.cloneElement(captionElement, {
	        date: date, localeUtils: localeUtils, locale: locale,
	        onClick: onCaptionClick ? function (e) {
	          return _this5.handleCaptionClick(e, date);
	        } : null
	      });
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "DayPicker-Month",
	          key: i },
	        caption,
	        _react2.default.createElement(
	          "div",
	          { className: "DayPicker-Weekdays" },
	          _react2.default.createElement(
	            "div",
	            { className: "DayPicker-WeekdaysRow" },
	            this.renderWeekDays()
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "DayPicker-Body" },
	          this.renderWeeksInMonth(date)
	        )
	      );
	    }
	  }, {
	    key: "renderWeekDays",
	    value: function renderWeekDays() {
	      var _props6 = this.props;
	      var locale = _props6.locale;
	      var localeUtils = _props6.localeUtils;
	
	      var days = [];
	      for (var i = 0; i < 7; i++) {
	        days.push(_react2.default.createElement(
	          "div",
	          { key: i, className: "DayPicker-Weekday" },
	          _react2.default.createElement(
	            "abbr",
	            { title: localeUtils.formatWeekdayLong(i, locale) },
	            localeUtils.formatWeekdayShort(i, locale)
	          )
	        ));
	      }
	      return days;
	    }
	  }, {
	    key: "renderWeeksInMonth",
	    value: function renderWeeksInMonth(month) {
	      var _this6 = this;
	
	      var _props7 = this.props;
	      var locale = _props7.locale;
	      var localeUtils = _props7.localeUtils;
	
	      var firstDayOfWeek = localeUtils.getFirstDayOfWeek(locale);
	      return Helpers.getWeekArray(month, firstDayOfWeek).map(function (week, i) {
	        return _react2.default.createElement(
	          "div",
	          { key: i, className: "DayPicker-Week", role: "row" },
	          week.map(function (day) {
	            return _this6.renderDay(month, day);
	          })
	        );
	      });
	    }
	  }, {
	    key: "renderDay",
	    value: function renderDay(month, day) {
	      var _this7 = this;
	
	      var _props8 = this.props;
	      var enableOutsideDays = _props8.enableOutsideDays;
	      var modifierFunctions = _props8.modifiers;
	
	
	      var className = "DayPicker-Day";
	      var modifiers = [];
	      var key = "" + day.getFullYear() + day.getMonth() + day.getDate();
	
	      var isToday = DateUtils.isSameDay(day, new Date());
	      if (isToday) {
	        modifiers.push("today");
	      }
	
	      var isOutside = day.getMonth() !== month.getMonth();
	      if (isOutside) {
	        modifiers.push("outside");
	      }
	
	      if (modifierFunctions) {
	        var customModifiers = Helpers.getModifiersForDay(day, modifierFunctions);
	        modifiers = [].concat(_toConsumableArray(modifiers), _toConsumableArray(customModifiers));
	      }
	
	      className += modifiers.map(function (modifier) {
	        return " " + className + "--" + modifier;
	      }).join("");
	
	      if (isOutside && !enableOutsideDays) {
	        return _react2.default.createElement("div", { key: "outside-" + key, className: className });
	      }
	
	      var _props9 = this.props;
	      var onDayMouseEnter = _props9.onDayMouseEnter;
	      var onDayMouseLeave = _props9.onDayMouseLeave;
	      var onDayTouchTap = _props9.onDayTouchTap;
	      var onDayClick = _props9.onDayClick;
	
	      var tabIndex = null;
	      if ((onDayTouchTap || onDayClick) && !isOutside) {
	        tabIndex = -1;
	        // Focus on the first day of the month
	        if (day.getDate() === 1) {
	          tabIndex = this.props.tabIndex;
	        }
	      }
	      return _react2.default.createElement(
	        "div",
	        { key: key, className: className,
	          tabIndex: tabIndex,
	          role: "gridcell",
	          onKeyDown: function onKeyDown(e) {
	            return _this7.handleDayKeyDown(e, day, modifiers);
	          },
	          onMouseEnter: onDayMouseEnter ? function (e) {
	            return _this7.handleDayMouseEnter(e, day, modifiers);
	          } : null,
	          onMouseLeave: onDayMouseLeave ? function (e) {
	            return _this7.handleDayMouseLeave(e, day, modifiers);
	          } : null,
	          onClick: onDayClick ? function (e) {
	            return _this7.handleDayClick(e, day, modifiers);
	          } : null,
	          onTouchTap: onDayTouchTap ? function (e) {
	            return _this7.handleDayTouchTap(e, day, modifiers);
	          } : null
	        },
	        this.props.renderDay(day)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var _props10 = this.props;
	      var numberOfMonths = _props10.numberOfMonths;
	      var locale = _props10.locale;
	      var canChangeMonth = _props10.canChangeMonth;
	
	      var attributes = _objectWithoutProperties(_props10, ["numberOfMonths", "locale", "canChangeMonth"]);
	
	      var currentMonth = this.state.currentMonth;
	
	      var className = "DayPicker DayPicker--" + locale;
	
	      if (!this.props.onDayClick && !this.props.onDayTouchTap) {
	        className = className + " DayPicker--interactionDisabled";
	      }
	      if (attributes.className) {
	        className = className + " " + attributes.className;
	      }
	
	      var months = [];
	      var month = void 0;
	      for (var i = 0; i < numberOfMonths; i++) {
	        month = DateUtils.addMonths(currentMonth, i);
	        months.push(this.renderMonth(month, i));
	      }
	
	      return _react2.default.createElement(
	        "div",
	        _extends({}, attributes, {
	          className: className,
	          role: "widget",
	          tabIndex: canChangeMonth && attributes.tabIndex,
	          onKeyDown: function onKeyDown(e) {
	            return _this8.handleKeyDown(e);
	          } }),
	        canChangeMonth && this.renderNavBar(),
	        months
	      );
	    }
	  }]);
	
	  return DayPicker;
	}(_react.Component);
	
	DayPicker.propTypes = {
	
	  initialMonth: _react.PropTypes.instanceOf(Date),
	  numberOfMonths: _react.PropTypes.number,
	
	  modifiers: _react.PropTypes.object,
	
	  locale: _react.PropTypes.string,
	  localeUtils: _react.PropTypes.shape({
	    formatMonthTitle: _react.PropTypes.func,
	    formatWeekdayShort: _react.PropTypes.func,
	    formatWeekdayLong: _react.PropTypes.func,
	    getFirstDayOfWeek: _react.PropTypes.func
	  }),
	
	  enableOutsideDays: _react.PropTypes.bool,
	  canChangeMonth: _react.PropTypes.bool,
	  fromMonth: _react.PropTypes.instanceOf(Date),
	  toMonth: _react.PropTypes.instanceOf(Date),
	
	  onDayClick: _react.PropTypes.func,
	  onDayTouchTap: _react.PropTypes.func,
	  onDayMouseEnter: _react.PropTypes.func,
	  onDayMouseLeave: _react.PropTypes.func,
	  onMonthChange: _react.PropTypes.func,
	  onCaptionClick: _react.PropTypes.func,
	
	  renderDay: _react.PropTypes.func,
	
	  captionElement: _react.PropTypes.element
	
	};
	DayPicker.defaultProps = {
	  tabIndex: 0,
	  initialMonth: new Date(),
	  numberOfMonths: 1,
	  locale: "en",
	  localeUtils: LocaleUtils,
	  enableOutsideDays: false,
	  canChangeMonth: true,
	  renderDay: function renderDay(day) {
	    return day.getDate();
	  },
	  captionElement: _react2.default.createElement(Caption, null)
	};
	exports.default = DayPicker;
	//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.startOfMonth = startOfMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getWeekArray = getWeekArray;
	exports.getModifiersForDay = getModifiersForDay;
	exports.getMonthsDiff = getMonthsDiff;
	
	var _DateUtils = __webpack_require__(1056);
	
	var _LocaleUtils = __webpack_require__(1057);
	
	function startOfMonth(d) {
	  var newDate = (0, _DateUtils.clone)(d);
	  newDate.setDate(1);
	  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
	  return newDate;
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getWeekArray(d) {
	  var firstDayOfWeek = arguments.length <= 1 || arguments[1] === undefined ? (0, _LocaleUtils.getFirstDayOfWeek)() : arguments[1];
	
	  var daysInMonth = getDaysInMonth(d);
	  var dayArray = [];
	
	  var week = [];
	  var weekArray = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
	  }
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      weekArray.push(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      weekArray.push(week);
	    }
	  });
	
	  // unshift days to start the first week
	  var firstWeek = weekArray[0];
	  for (var _i = 7 - firstWeek.length; _i > 0; _i--) {
	    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
	    outsideDate.setDate(firstWeek[0].getDate() - 1);
	    firstWeek.unshift(outsideDate);
	  }
	
	  // push days until the end of the last week
	  var lastWeek = weekArray[weekArray.length - 1];
	  for (var _i2 = lastWeek.length; _i2 < 7; _i2++) {
	    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
	    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
	    lastWeek.push(_outsideDate);
	  }
	
	  return weekArray;
	}
	
	function getModifiersForDay(d, modifierFunctions) {
	  var modifiers = [];
	  if (modifierFunctions) {
	    for (var modifier in modifierFunctions) {
	      var func = modifierFunctions[modifier];
	      if (func(d)) {
	        modifiers.push(modifier);
	      }
	    }
	  }
	  return modifiers;
	}
	
	function getMonthsDiff(d1, d2) {
	  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
	}
	//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(2134);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(1135);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetConstantsJs = __webpack_require__(2064);
	
	var _PlainComponent = __webpack_require__(2065);
	
	var _PlainComponent2 = _interopRequireDefault(_PlainComponent);
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = [].concat(_toConsumableArray(propsList)).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var props = _step.value;
	
	            if (props[property]) {
	                return props[property];
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator["return"]) {
	                _iterator["return"]();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        return innermostTemplate.replace(/\%s/g, innermostTitle);
	    }
	
	    return innermostTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(validTags, propsList) {
	    return propsList.filter(function (props) {
	        return !Object.is(typeof props[_HelmetConstantsJs.TAG_NAMES.BASE], "undefined");
	    }).map(function (props) {
	        return props[_HelmetConstantsJs.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.keys(tag)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var attributeKey = _step2.value;
	
	                    var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                    if (validTags.includes(lowerCaseAttributeKey)) {
	                        return innermostBaseTag.concat(tag);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
	                        _iterator2["return"]();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, validTags, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = new Map();
	
	    var tagList = propsList.filter(function (props) {
	        return !Object.is(typeof props[tagName], "undefined");
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = new Map();
	
	        instanceTags.filter(function (tag) {
	            var validAttributeKey = undefined;
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = Object.keys(tag)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var attributeKey = _step3.value;
	
	                    var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                    // Special rule with link tags, since rel and href are both valid tags, rel takes priority
	                    if (validTags.includes(lowerCaseAttributeKey) && !(Object.is(validAttributeKey, _HelmetConstantsJs.TAG_PROPERTIES.REL) && Object.is(tag[validAttributeKey].toLowerCase(), "canonical")) && !(Object.is(lowerCaseAttributeKey, _HelmetConstantsJs.TAG_PROPERTIES.REL) && Object.is(tag[lowerCaseAttributeKey].toLowerCase(), "stylesheet"))) {
	                        validAttributeKey = lowerCaseAttributeKey;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3["return"]) {
	                        _iterator3["return"]();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	
	            if (!validAttributeKey) {
	                return false;
	            }
	
	            var value = tag[validAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags.has(validAttributeKey)) {
	                approvedSeenTags.set(validAttributeKey, new Set());
	            }
	
	            if (!instanceSeenTags.has(validAttributeKey)) {
	                instanceSeenTags.set(validAttributeKey, new Set());
	            }
	
	            if (!approvedSeenTags.get(validAttributeKey).has(value)) {
	                instanceSeenTags.get(validAttributeKey).add(value);
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = instanceSeenTags.keys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var attributeKey = _step4.value;
	
	                var tagUnion = new Set([].concat(_toConsumableArray(approvedSeenTags.get(attributeKey)), _toConsumableArray(instanceSeenTags.get(attributeKey))));
	
	                approvedSeenTags.set(attributeKey, tagUnion);
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4["return"]) {
	                    _iterator4["return"]();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        instanceSeenTags.clear();
	        return approvedTags;
	    }, []).reverse();
	
	    return tagList;
	};
	
	var updateTitle = function updateTitle(title) {
	    document.title = title || document.title;
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var oldTags = [].concat(_toConsumableArray(headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]")));
	    var newTags = [];
	    var indexToDelete = undefined;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    newElement.setAttribute(attribute, tag[attribute]);
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title) {
	    var stringifiedMarkup = "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	
	    return stringifiedMarkup;
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    var stringifiedMarkup = tags.map(function (tag) {
	        var attributeHtml = Object.keys(tag).map(function (attribute) {
	            var encodedValue = encodeSpecialCharacters(tag[attribute]);
	            return attribute + "=\"" + encodedValue + "\"";
	        }).join(" ");
	
	        return "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (Object.is(type, _HelmetConstantsJs.TAG_NAMES.SCRIPT) ? "></" + type + ">" : "/>");
	    }).join("");
	
	    return stringifiedMarkup;
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title) {
	    // assigning into an array to define toString function on it
	    var component = [_react2["default"].createElement(_HelmetConstantsJs.TAG_NAMES.TITLE, _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true), title)];
	
	    return component;
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    /* eslint-disable react/display-name */
	    var component = [].concat(_toConsumableArray(tags)).map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstantsJs.REACT_TAG_MAP[attribute] || attribute;
	
	            mappedTag[mappedAttribute] = tag[attribute];
	        });
	
	        return _react2["default"].createElement(type, mappedTag);
	    });
	
	    return component;
	    /* eslint-enable react/display-name */
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    return {
	        toComponent: type === _HelmetConstantsJs.TAG_NAMES.TITLE ? function () {
	            return generateTitleAsReactComponent(type, tags);
	        } : function () {
	            return generateTagsAsReactComponent(type, tags);
	        },
	        toString: type === _HelmetConstantsJs.TAG_NAMES.TITLE ? function () {
	            return generateTitleAsString(type, tags);
	        } : function () {
	            return generateTagsAsString(type, tags);
	        }
	    };
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var title = _ref.title;
	    var baseTag = _ref.baseTag;
	    var metaTags = _ref.metaTags;
	    var linkTags = _ref.linkTags;
	    var scriptTags = _ref.scriptTags;
	    return {
	        title: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.TITLE, title),
	        base: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    /* eslint-disable react/no-multi-comp */
	
	    var HelmetWrapper = (function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            _get(Object.getPrototypeOf(HelmetWrapper.prototype), "constructor", this).apply(this, arguments);
	        }
	
	        /* eslint-enable react/no-multi-comp */
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2["default"])(this.props, nextProps);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2["default"].createElement(Component, this.props);
	            }
	        }], [{
	            key: "propTypes",
	
	            /**
	             * @param {String} title: "Title"
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"src": "http://mysite.com/js/test.js", "type": "text/javascript"}]
	             */
	            value: {
	                title: _react2["default"].PropTypes.string,
	                onChangeClientState: _react2["default"].PropTypes.func,
	                titleTemplate: _react2["default"].PropTypes.string,
	                base: _react2["default"].PropTypes.object,
	                meta: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                link: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                script: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object)
	            },
	            enumerable: true
	        }, {
	            key: "peek",
	            value: Component.peek,
	            enumerable: true
	        }, {
	            key: "rewind",
	            value: function value() {
	                var mappedState = Component.rewind();
	                if (!mappedState) {
	                    // provide fallback if mappedState is undefined
	                    mappedState = mapStateOnServer({
	                        title: "",
	                        baseTag: [],
	                        metaTags: [],
	                        linkTags: [],
	                        scriptTags: []
	                    });
	                }
	
	                return mappedState;
	            },
	            enumerable: true
	        }, {
	            key: "canUseDOM",
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    })(_react2["default"].Component);
	
	    return HelmetWrapper;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        title: getTitleFromPropsList(propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.META, [_HelmetConstantsJs.TAG_PROPERTIES.NAME, _HelmetConstantsJs.TAG_PROPERTIES.CHARSET, _HelmetConstantsJs.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstantsJs.TAG_PROPERTIES.PROPERTY], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.LINK, [_HelmetConstantsJs.TAG_PROPERTIES.REL, _HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.SCRIPT, [_HelmetConstantsJs.TAG_PROPERTIES.SRC], propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var title = newState.title;
	    var baseTag = newState.baseTag;
	    var metaTags = newState.metaTags;
	    var linkTags = newState.linkTags;
	    var scriptTags = newState.scriptTags;
	    var onChangeClientState = newState.onChangeClientState;
	
	    updateTitle(title);
	
	    var tagUpdates = {
	        scriptTags: updateTags(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags),
	        linkTags: updateTags(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        baseTag: updateTags(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType];
	        var newTags = _tagUpdates$tagType.newTags;
	        var oldTags = _tagUpdates$tagType.oldTags;
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var SideEffect = (0, _reactSideEffect2["default"])(reducePropsToState, handleClientStateChange, mapStateOnServer);
	
	// PlainComponent is used to be a blank component decorated by react-side-effect
	exports["default"] = Helmet(SideEffect(_PlainComponent2["default"]));
	module.exports = exports["default"];

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TAG_NAMES = {
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script"
	};
	
	exports.TAG_NAMES = TAG_NAMES;
	var TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src"
	};
	
	exports.TAG_PROPERTIES = TAG_PROPERTIES;
	var REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv"
	};
	exports.REACT_TAG_MAP = REACT_TAG_MAP;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PlainComponent = (function (_React$Component) {
	    _inherits(PlainComponent, _React$Component);
	
	    function PlainComponent() {
	        _classCallCheck(this, PlainComponent);
	
	        _get(Object.getPrototypeOf(PlainComponent.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(PlainComponent, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PlainComponent;
	})(_react2["default"].Component);
	
	exports["default"] = PlainComponent;
	module.exports = exports["default"];

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1068);
	__webpack_require__(2087);
	module.exports = __webpack_require__(198).Array.from;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2094);
	module.exports = __webpack_require__(198).Array.includes;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1241);
	__webpack_require__(1068);
	__webpack_require__(1242);
	__webpack_require__(2089);
	__webpack_require__(2095);
	module.exports = __webpack_require__(198).Map;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2093);
	module.exports = __webpack_require__(198).Object.getOwnPropertySymbols;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2090);
	module.exports = __webpack_require__(198).Object.is;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2091);
	module.exports = __webpack_require__(198).Object.keys;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1241);
	__webpack_require__(1068);
	__webpack_require__(1242);
	__webpack_require__(2092);
	__webpack_require__(2096);
	module.exports = __webpack_require__(198).Set;

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(1061);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(810)
	  , toLength  = __webpack_require__(1067)
	  , toIndex   = __webpack_require__(2086);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(197);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(810)
	  , getNames  = __webpack_require__(197).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : getNames(toIObject(it));
	};

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(1060);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(1060);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(197)
	  , descriptor     = __webpack_require__(1065)
	  , setToStringTag = __webpack_require__(921)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(524)(IteratorPrototype, __webpack_require__(199)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(197)
	  , toIObject = __webpack_require__(810);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(274)
	  , core    = __webpack_require__(198)
	  , fails   = __webpack_require__(808);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(465)
	  , $           = __webpack_require__(197)
	  , DESCRIPTORS = __webpack_require__(919)
	  , SPECIES     = __webpack_require__(199)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(1066)
	  , defined   = __webpack_require__(918);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(1066)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(917)
	  , $export     = __webpack_require__(274)
	  , toObject    = __webpack_require__(1239)
	  , call        = __webpack_require__(1233)
	  , isArrayIter = __webpack_require__(1232)
	  , toLength    = __webpack_require__(1067)
	  , getIterFn   = __webpack_require__(1240);
	$export($export.S + $export.F * !__webpack_require__(1234)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1227)
	  , step             = __webpack_require__(1235)
	  , Iterators        = __webpack_require__(809)
	  , toIObject        = __webpack_require__(810);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(1063)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(1229);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(1231)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(274);
	$export($export.S, 'Object', {is: __webpack_require__(2083)});

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(1239);
	
	__webpack_require__(2082)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(1229);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(1231)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(197)
	  , global         = __webpack_require__(465)
	  , core           = __webpack_require__(198)
	  , has            = __webpack_require__(920)
	  , DESCRIPTORS    = __webpack_require__(919)
	  , $export        = __webpack_require__(274)
	  , redefine       = __webpack_require__(525)
	  , META           = __webpack_require__(1064).KEY
	  , $fails         = __webpack_require__(808)
	  , shared         = __webpack_require__(1238)
	  , setToStringTag = __webpack_require__(921)
	  , uid            = __webpack_require__(922)
	  , wks            = __webpack_require__(199)
	  , keyOf          = __webpack_require__(2081)
	  , $names         = __webpack_require__(2077)
	  , enumKeys       = __webpack_require__(2076)
	  , isArray        = __webpack_require__(2079)
	  , anObject       = __webpack_require__(1058)
	  , toIObject      = __webpack_require__(810)
	  , createDesc     = __webpack_require__(1065)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , ObjectProto    = Object.prototype
	  , USE_NATIVE     = typeof $Symbol == 'function';
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , replacer, $replacer;
	  while(arguments.length > i)args.push(arguments[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var BUGGY_JSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(1236)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var Wrapper = core.Symbol
	    , sym     = wks(it);
	  if(!(it in Wrapper))setDesc(Wrapper, it, {value: USE_NATIVE ? sym : wrap(sym)});
	});
	
	setter = true;
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || BUGGY_JSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(274)
	  , $includes = __webpack_require__(2075)(true);
	
	$export($export.P, 'Array', {
	  // https://github.com/domenic/Array.prototype.includes
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(1227)('includes');

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(274);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(1230)('Map')});

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(274);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(1230)('Set')});

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2097);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domHelpersEventsOn = __webpack_require__(1009);
	
	var _domHelpersEventsOn2 = _interopRequireDefault(_domHelpersEventsOn);
	
	var _domHelpersEventsOff = __webpack_require__(1008);
	
	var _domHelpersEventsOff2 = _interopRequireDefault(_domHelpersEventsOff);
	
	exports['default'] = function (node, event, handler) {
	  _domHelpersEventsOn2['default'](node, event, handler);
	  return {
	    remove: function remove() {
	      _domHelpersEventsOff2['default'](node, event, handler);
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	'use strict';
	
	exports.__esModule = true;
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domHelpersOwnerDocument = __webpack_require__(1010);
	
	var _domHelpersOwnerDocument2 = _interopRequireDefault(_domHelpersOwnerDocument);
	
	exports['default'] = function (componentOrElement) {
	  return _domHelpersOwnerDocument2['default'](_reactDom2['default'].findDOMNode(componentOrElement));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(1042);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(1244);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(1245);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(1244);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(2104);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(2105);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(1245);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(911);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(2106);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(148);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(2098);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(1246);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(1247);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehavior = __webpack_require__(2151);
	
	var _ScrollBehavior2 = _interopRequireDefault(_ScrollBehavior);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollBehaviorContainer = function (_React$Component) {
	  _inherits(ScrollBehaviorContainer, _React$Component);
	
	  function ScrollBehaviorContainer() {
	    _classCallCheck(this, ScrollBehaviorContainer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ScrollBehaviorContainer.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var routerProps = this.props.routerProps;
	
	
	    this.scrollBehavior = new _ScrollBehavior2.default(routerProps.router, function () {
	      return _this2.props.routerProps.location;
	    });
	
	    this.onUpdate(null, routerProps);
	  };
	
	  ScrollBehaviorContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var routerProps = this.props.routerProps;
	
	    var prevRouterProps = prevProps.routerProps;
	
	    if (routerProps.location === prevRouterProps.location) {
	      return;
	    }
	
	    this.onUpdate(prevRouterProps, routerProps);
	  };
	
	  ScrollBehaviorContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollBehaviorContainer.prototype.onUpdate = function onUpdate(prevRouterProps, routerProps) {
	    var shouldUpdateScroll = this.props.shouldUpdateScroll;
	
	
	    var scrollPosition = void 0;
	    if (!shouldUpdateScroll) {
	      scrollPosition = true;
	    } else {
	      scrollPosition = shouldUpdateScroll.call(this.scrollBehavior, prevRouterProps, routerProps);
	    }
	
	    this.scrollBehavior.updateScroll(scrollPosition);
	  };
	
	  ScrollBehaviorContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollBehaviorContainer;
	}(_react2.default.Component);
	
	ScrollBehaviorContainer.propTypes = {
	  shouldUpdateScroll: _react2.default.PropTypes.func,
	  routerProps: _react2.default.PropTypes.object.isRequired,
	  children: _react2.default.PropTypes.node.isRequired
	};
	exports.default = ScrollBehaviorContainer;
	module.exports = exports['default'];

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useScroll;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollBehaviorContainer = __webpack_require__(2109);
	
	var _ScrollBehaviorContainer2 = _interopRequireDefault(_ScrollBehaviorContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useScroll(shouldUpdateScroll) {
	  return {
	    renderRouterContext: function renderRouterContext(child, props) {
	      return _react2.default.createElement(
	        _ScrollBehaviorContainer2.default,
	        {
	          shouldUpdateScroll: shouldUpdateScroll,
	          routerProps: props
	        },
	        child
	      );
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(1248);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(1249);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(466);
	
	var _InternalPropTypes = __webpack_require__(526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(466);
	
	var _InternalPropTypes = __webpack_require__(526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(1014);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(535);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(1071);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(526);
	
	var _RouterContext = __webpack_require__(923);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(466);
	
	var _RouterUtils = __webpack_require__(1250);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(923);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(1069);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(923);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1141);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(1252);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(539);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1069);
	
	var _makeStateWithLocation = __webpack_require__(1253);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(539);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1014);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(1252);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(466);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(1070);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(539);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(2118);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(1248);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(2112);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(2132);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(2113);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(2114);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(1249);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(2116);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(2111);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(2115);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(2117);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(2131);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(923);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(2119);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(2129);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(1254);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(2121);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(2122);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(2126);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(1251);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(539);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(332);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(1251);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(1071);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(466);
	
	var _RouterUtils = __webpack_require__(1250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(1069);
	
	var _makeStateWithLocation = __webpack_require__(1253);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(539);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(535);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(1071);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(140);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(1838);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(1070);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbjsLibExecutionEnvironment = __webpack_require__(2135);
	
	var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);
	
	var _fbjsLibShallowEqual = __webpack_require__(2136);
	
	var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(470);
	
	var assign = __webpack_require__(22);
	
	var ReactTransitionGroup = __webpack_require__(2141);
	var ReactCSSTransitionGroupChild = __webpack_require__(2138);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	        }
	    }
	  };
	}
	
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool,
	    transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	    transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	    transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	  },
	
	  getDefaultProps: function () {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function (child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return React.createElement(ReactCSSTransitionGroupChild, {
	      name: this.props.transitionName,
	      appear: this.props.transitionAppear,
	      enter: this.props.transitionEnter,
	      leave: this.props.transitionLeave,
	      appearTimeout: this.props.transitionAppearTimeout,
	      enterTimeout: this.props.transitionEnterTimeout,
	      leaveTimeout: this.props.transitionLeaveTimeout
	    }, child);
	  },
	
	  render: function () {
	    return React.createElement(ReactTransitionGroup, assign({}, this.props, { childFactory: this._wrapChild }));
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(470);
	var ReactDOM = __webpack_require__(474);
	
	var CSSCore = __webpack_require__(2142);
	var ReactTransitionEvents = __webpack_require__(2140);
	
	var onlyChild = __webpack_require__(541);
	
	// We don't remove the element from the DOM until we receive an animationend or
	// transitionend event. If the user screws up and forgets to add an animation
	// their node will be stuck in the DOM forever, so we detect if an animation
	// does not start and if it doesn't, we just call the end listener immediately.
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactDOM.findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClass: function (className) {
	    this.classNameQueue.push(className);
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },
	
	  flushClassNameQueue: function () {
	    if (this.isMounted()) {
	      this.classNameQueue.forEach(CSSCore.addClass.bind(CSSCore, ReactDOM.findDOMNode(this)));
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(540);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children) {
	    if (!children) {
	      return children;
	    }
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(36);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(470);
	var ReactTransitionChildMapping = __webpack_require__(2139);
	
	var assign = __webpack_require__(22);
	var emptyFunction = __webpack_require__(65);
	
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function () {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function () {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function () {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function () {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function (key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      this.setState(function (state) {
	        var newChildren = assign({}, state.children);
	        delete newChildren[key];
	        return { children: newChildren };
	      });
	    }
	  },
	
	  render: function () {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	    return React.createElement(this.props.component, this.props, childrenToRender);
	  }
	});
	
	module.exports = ReactTransitionGroup;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSCore
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function (element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : undefined;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function (element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : undefined;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function (element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function (element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : undefined;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  }
	
	};
	
	module.exports = CSSCore;

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

	"use strict";
	;
	;
	;
	var isWebSocket = function (constructor) {
	    return constructor && constructor.CLOSING === 2;
	};
	var isGlobalWebSocket = function () {
	    return typeof WebSocket !== 'undefined' && isWebSocket(WebSocket);
	};
	var getDefaultOptions = function () { return ({
	    constructor: isGlobalWebSocket() ? WebSocket : null,
	    maxReconnectionDelay: 10000,
	    minReconnectionDelay: 1500,
	    reconnectionDelayGrowFactor: 1.3,
	    connectionTimeout: 4000,
	    maxRetries: Infinity,
	    debug: false,
	}); };
	var bypassProperty = function (src, dst, name) {
	    Object.defineProperty(dst, name, {
	        get: function () { return src[name]; },
	        set: function (value) { src[name] = value; },
	        enumerable: true,
	        configurable: true,
	    });
	};
	var initReconnectionDelay = function (config) {
	    return (config.minReconnectionDelay + Math.random() * config.minReconnectionDelay);
	};
	var updateReconnectionDelay = function (config, previousDelay) {
	    var newDelay = previousDelay * config.reconnectionDelayGrowFactor;
	    return (newDelay > config.maxReconnectionDelay)
	        ? config.maxReconnectionDelay
	        : newDelay;
	};
	var LEVEL_0_EVENTS = ['onopen', 'onclose', 'onmessage', 'onerror'];
	var reassignEventListeners = function (ws, oldWs, listeners) {
	    Object.keys(listeners).forEach(function (type) {
	        listeners[type].forEach(function (_a) {
	            var listener = _a[0], options = _a[1];
	            ws.addEventListener(type, listener, options);
	        });
	    });
	    if (oldWs) {
	        LEVEL_0_EVENTS.forEach(function (name) {
	            ws[name] = oldWs[name];
	        });
	    }
	};
	var ReconnectingWebsocket = function (url, protocols, options) {
	    var _this = this;
	    if (options === void 0) { options = {}; }
	    var ws;
	    var connectingTimeout;
	    var reconnectDelay = 0;
	    var retriesCount = 0;
	    var shouldRetry = true;
	    var savedOnClose = null;
	    var listeners = {};
	    // require new to construct
	    if (!(this instanceof ReconnectingWebsocket)) {
	        throw new TypeError("Failed to construct 'ReconnectingWebSocket': Please use the 'new' operator");
	    }
	    // Set config. Not using `Object.assign` because of IE11
	    var config = getDefaultOptions();
	    Object.keys(config)
	        .filter(function (key) { return options.hasOwnProperty(key); })
	        .forEach(function (key) { return config[key] = options[key]; });
	    if (!isWebSocket(config.constructor)) {
	        throw new TypeError('Invalid WebSocket constructor. Set `options.constructor`');
	    }
	    var log = config.debug ? function () {
	        var params = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            params[_i] = arguments[_i];
	        }
	        return console.log.apply(console, ['RWS:'].concat(params));
	    } : function () { };
	    /**
	     * Not using dispatchEvent, otherwise we must use a DOM Event object
	     * Deferred because we want to handle the close event before this
	     */
	    var emitError = function (code, msg) { return setTimeout(function () {
	        var err = new Error(msg);
	        err.code = code;
	        if (Array.isArray(listeners.error)) {
	            listeners.error.forEach(function (_a) {
	                var fn = _a[0];
	                return fn(err);
	            });
	        }
	        if (ws.onerror) {
	            ws.onerror(err);
	        }
	    }, 0); };
	    var handleClose = function () {
	        log('handleClose', { shouldRetry: shouldRetry });
	        retriesCount++;
	        log('retries count:', retriesCount);
	        if (retriesCount > config.maxRetries) {
	            emitError('EHOSTDOWN', 'Too many failed connection attempts');
	            return;
	        }
	        if (!reconnectDelay) {
	            reconnectDelay = initReconnectionDelay(config);
	        }
	        else {
	            reconnectDelay = updateReconnectionDelay(config, reconnectDelay);
	        }
	        log('handleClose - reconnectDelay:', reconnectDelay);
	        if (shouldRetry) {
	            setTimeout(connect, reconnectDelay);
	        }
	    };
	    var connect = function () {
	        if (!shouldRetry) {
	            return;
	        }
	        log('connect');
	        var oldWs = ws;
	        var wsUrl = (typeof url === 'function') ? url() : url;
	        ws = new config.constructor(wsUrl, protocols);
	        connectingTimeout = setTimeout(function () {
	            log('timeout');
	            ws.close();
	            emitError('ETIMEDOUT', 'Connection timeout');
	        }, config.connectionTimeout);
	        log('bypass properties');
	        for (var key in ws) {
	            // @todo move to constant
	            if (['addEventListener', 'removeEventListener', 'close', 'send'].indexOf(key) < 0) {
	                bypassProperty(ws, _this, key);
	            }
	        }
	        ws.addEventListener('open', function () {
	            clearTimeout(connectingTimeout);
	            log('open');
	            reconnectDelay = initReconnectionDelay(config);
	            log('reconnectDelay:', reconnectDelay);
	            retriesCount = 0;
	        });
	        ws.addEventListener('close', handleClose);
	        reassignEventListeners(ws, oldWs, listeners);
	        // because when closing with fastClose=true, it is saved and set to null to avoid double calls
	        ws.onclose = ws.onclose || savedOnClose;
	        savedOnClose = null;
	    };
	    log('init');
	    connect();
	    this.close = function (code, reason, _a) {
	        if (code === void 0) { code = 1000; }
	        if (reason === void 0) { reason = ''; }
	        var _b = _a === void 0 ? {} : _a, _c = _b.keepClosed, keepClosed = _c === void 0 ? false : _c, _d = _b.fastClose, fastClose = _d === void 0 ? true : _d, _e = _b.delay, delay = _e === void 0 ? 0 : _e;
	        log('close - params:', { reason: reason, keepClosed: keepClosed, fastClose: fastClose, delay: delay, retriesCount: retriesCount, maxRetries: config.maxRetries });
	        shouldRetry = !keepClosed && retriesCount <= config.maxRetries;
	        if (delay) {
	            reconnectDelay = delay;
	        }
	        ws.close(code, reason);
	        if (fastClose) {
	            var fakeCloseEvent_1 = {
	                code: code,
	                reason: reason,
	                wasClean: true,
	            };
	            // execute close listeners soon with a fake closeEvent
	            // and remove them from the WS instance so they
	            // don't get fired on the real close.
	            handleClose();
	            ws.removeEventListener('close', handleClose);
	            // run and remove level2
	            if (Array.isArray(listeners.close)) {
	                listeners.close.forEach(function (_a) {
	                    var listener = _a[0], options = _a[1];
	                    listener(fakeCloseEvent_1);
	                    ws.removeEventListener('close', listener, options);
	                });
	            }
	            // run and remove level0
	            if (ws.onclose) {
	                savedOnClose = ws.onclose;
	                ws.onclose(fakeCloseEvent_1);
	                ws.onclose = null;
	            }
	        }
	    };
	    this.send = function (data) {
	        ws.send(data);
	    };
	    this.addEventListener = function (type, listener, options) {
	        if (Array.isArray(listeners[type])) {
	            if (!listeners[type].some(function (_a) {
	                var l = _a[0];
	                return l === listener;
	            })) {
	                listeners[type].push([listener, options]);
	            }
	        }
	        else {
	            listeners[type] = [[listener, options]];
	        }
	        ws.addEventListener(type, listener, options);
	    };
	    this.removeEventListener = function (type, listener, options) {
	        if (Array.isArray(listeners[type])) {
	            listeners[type] = listeners[type].filter(function (_a) {
	                var l = _a[0];
	                return l !== listener;
	            });
	        }
	        ws.removeEventListener(type, listener, options);
	    };
	};
	module.exports = ReconnectingWebsocket;


/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createDevTools;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1042);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(4);
	
	var _reduxDevtoolsInstrument = __webpack_require__(1255);
	
	var _reduxDevtoolsInstrument2 = _interopRequireDefault(_reduxDevtoolsInstrument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function logError(type) {
	  if (type === 'NoStore') {
	    console.error('Redux DevTools could not render. You must pass the Redux store ' + 'to <DevTools> either as a "store" prop or by wrapping it in a ' + '<Provider store={store}>.');
	  } else {
	    console.error('Redux DevTools could not render. Did you forget to include ' + 'DevTools.instrument() in your store enhancer chain before ' + 'using createStore()?');
	  }
	}
	
	function createDevTools(children) {
	  var _class, _temp;
	
	  var monitorElement = _react.Children.only(children);
	  var monitorProps = monitorElement.props;
	  var Monitor = monitorElement.type;
	  var ConnectedMonitor = (0, _reactRedux.connect)(function (state) {
	    return state;
	  })(Monitor);
	
	  return _temp = _class = function (_Component) {
	    _inherits(DevTools, _Component);
	
	    function DevTools(props, context) {
	      _classCallCheck(this, DevTools);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      if (_reactRedux.ReactReduxContext) {
	        if (_this.props.store && !_this.props.store.liftedStore) {
	          logError('NoLiftedStore');
	        }
	        return _possibleConstructorReturn(_this);
	      }
	
	      if (!props.store && !context.store) {
	        logError('NoStore');
	        return _possibleConstructorReturn(_this);
	      }
	
	      if (context.store) {
	        _this.liftedStore = context.store.liftedStore;
	      } else {
	        _this.liftedStore = props.store.liftedStore;
	      }
	
	      if (!_this.liftedStore) {
	        logError('NoLiftedStore');
	      }
	      return _this;
	    }
	
	    DevTools.prototype.render = function render() {
	      if (_reactRedux.ReactReduxContext) {
	        // For react-redux@6
	        if (this.props.store) {
	          if (!this.props.store.liftedStore) {
	            return null;
	          }
	          return _react2.default.createElement(
	            _reactRedux.Provider,
	            { store: this.props.store.liftedStore },
	            _react2.default.createElement(ConnectedMonitor, monitorProps)
	          );
	        }
	        return _react2.default.createElement(
	          _reactRedux.ReactReduxContext.Consumer,
	          null,
	          function (props) {
	            if (!props || !props.store) {
	              logError('NoStore');
	              return null;
	            }
	            if (!props.store.liftedStore) {
	              logError('NoLiftedStore');
	              return null;
	            }
	            return _react2.default.createElement(
	              _reactRedux.Provider,
	              { store: props.store.liftedStore },
	              _react2.default.createElement(ConnectedMonitor, monitorProps)
	            );
	          }
	        );
	      }
	
	      if (!this.liftedStore) {
	        return null;
	      }
	
	      return _react2.default.createElement(ConnectedMonitor, _extends({}, monitorProps, { store: this.liftedStore }));
	    };
	
	    return DevTools;
	  }(_react.Component), _class.contextTypes = {
	    store: _propTypes2.default.object
	  }, _class.propTypes = {
	    store: _propTypes2.default.object
	  }, _class.instrument = function (options) {
	    return (0, _reduxDevtoolsInstrument2.default)(function (state, action) {
	      return Monitor.update(monitorProps, state, action);
	    }, options);
	  }, _temp;
	}

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reduxDevtoolsInstrument = __webpack_require__(1255);
	
	Object.defineProperty(exports, 'instrument', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reduxDevtoolsInstrument).default;
	  }
	});
	Object.defineProperty(exports, 'ActionCreators', {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.ActionCreators;
	  }
	});
	Object.defineProperty(exports, 'ActionTypes', {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.ActionTypes;
	  }
	});
	
	var _persistState = __webpack_require__(2146);
	
	Object.defineProperty(exports, 'persistState', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_persistState).default;
	  }
	});
	
	var _createDevTools = __webpack_require__(2144);
	
	Object.defineProperty(exports, 'createDevTools', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createDevTools).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = persistState;
	
	var _mapValues = __webpack_require__(1965);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _identity = __webpack_require__(910);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function persistState(sessionId) {
	  var deserializeState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	  var deserializeAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity2.default;
	
	  if (!sessionId) {
	    return function (next) {
	      return function () {
	        return next.apply(undefined, arguments);
	      };
	    };
	  }
	
	  function deserialize(state) {
	    return _extends({}, state, {
	      actionsById: (0, _mapValues2.default)(state.actionsById, function (liftedAction) {
	        return _extends({}, liftedAction, {
	          action: deserializeAction(liftedAction.action)
	        });
	      }),
	      committedState: deserializeState(state.committedState),
	      computedStates: state.computedStates.map(function (computedState) {
	        return _extends({}, computedState, {
	          state: deserializeState(computedState.state)
	        });
	      })
	    });
	  }
	
	  return function (next) {
	    return function (reducer, initialState, enhancer) {
	      var key = 'redux-dev-session-' + sessionId;
	
	      var finalInitialState = void 0;
	      try {
	        var json = localStorage.getItem(key);
	        if (json) {
	          finalInitialState = deserialize(JSON.parse(json)) || initialState;
	          next(reducer, initialState);
	        }
	      } catch (e) {
	        console.warn('Could not read debug session from localStorage:', e);
	        try {
	          localStorage.removeItem(key);
	        } finally {
	          finalInitialState = undefined;
	        }
	      }
	
	      var store = next(reducer, finalInitialState, enhancer);
	
	      return _extends({}, store, {
	        dispatch: function dispatch(action) {
	          store.dispatch(action);
	
	          try {
	            localStorage.setItem(key, JSON.stringify(store.getState()));
	          } catch (e) {
	            console.warn('Could not write debug session to localStorage:', e);
	          }
	
	          return action;
	        }
	      });
	    };
	  };
	}

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(1256);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(1257);
	
	var _isPlainObject = __webpack_require__(911);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1258);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81).Buffer))

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(1008);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(1009);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(1801);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(1802);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(1809);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _Actions = __webpack_require__(332);
	
	var _DOMStateStorage = __webpack_require__(1013);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// FIXME: Stop using this gross hack. This won't collide with any actual
	// history location keys, but it's dirty to sneakily use the same storage here.
	var KEY_PREFIX = 's/';
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(history, getCurrentLocation) {
	    var _this = this;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (_this._savePositionHandle === null) {
	        _this._savePositionHandle = (0, _requestAnimationFrame2.default)(_this._savePosition);
	      }
	
	      if (_this._scrollTarget) {
	        var _scrollTarget = _this._scrollTarget;
	        var xTarget = _scrollTarget[0];
	        var yTarget = _scrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._scrollTarget = null;
	          _this._cancelCheckScroll();
	        }
	      }
	    };
	
	    this._savePosition = function () {
	      _this._savePositionHandle = null;
	
	      // We have to directly update `DOMStateStorage`, because actually updating
	      // the location could cause e.g. React Router to re-render the entire page,
	      // which would lead to observably bad scroll performance.
	      (0, _DOMStateStorage.saveState)(_this._getKey(_this._getCurrentLocation()), [(0, _scrollLeft2.default)(window), (0, _scrollTop2.default)(window)]);
	    };
	
	    this._checkScrollPosition = function () {
	      _this._checkScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._scrollTarget) {
	        return;
	      }
	
	      var _scrollTarget2 = _this._scrollTarget;
	      var x = _scrollTarget2[0];
	      var y = _scrollTarget2[1];
	
	      window.scrollTo(x, y);
	
	      ++_this._numScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._scrollTarget = null;
	        return;
	      }
	
	      _this._checkScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkScrollPosition);
	    };
	
	    this._history = history;
	    this._getCurrentLocation = getCurrentLocation;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if ('scrollRestoration' in window.history) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = 'manual';
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._savePositionHandle = null;
	    this._checkScrollHandle = null;
	    this._scrollTarget = null;
	    this._numScrollAttempts = 0;
	
	    // We have to listen to each scroll update rather than to just location
	    // updates, because some browsers will update scroll position before
	    // emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onScroll);
	
	    this._unlistenBefore = history.listenBefore(function () {
	      if (_this._savePositionHandle !== null) {
	        _requestAnimationFrame2.default.cancel(_this._savePositionHandle);
	        _this._savePositionHandle = null;
	      }
	    });
	  }
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      window.history.scrollRestoration = this._oldScrollRestoration;
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onScroll);
	    this._cancelCheckScroll();
	
	    this._unlistenBefore();
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(scrollPosition) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckScroll();
	
	    if (scrollPosition && !Array.isArray(scrollPosition)) {
	      this._scrollTarget = this._getDefaultScrollTarget();
	    } else {
	      this._scrollTarget = scrollPosition;
	    }
	
	    // Check the scroll position to see if we even need to scroll.
	    this._onScroll();
	
	    if (!this._scrollTarget) {
	      return;
	    }
	
	    this._numScrollAttempts = 0;
	    this._checkScrollPosition();
	  };
	
	  ScrollBehavior.prototype.readPosition = function readPosition(location) {
	    return (0, _DOMStateStorage.readState)(this._getKey(location));
	  };
	
	  ScrollBehavior.prototype._getKey = function _getKey(location) {
	    // Use fallback key when actual key is unavailable.
	    var key = location.key || this._history.createPath(location);
	
	    return '' + KEY_PREFIX + key;
	  };
	
	  ScrollBehavior.prototype._cancelCheckScroll = function _cancelCheckScroll() {
	    if (this._checkScrollHandle !== null) {
	      _requestAnimationFrame2.default.cancel(this._checkScrollHandle);
	      this._checkScrollHandle = null;
	    }
	  };
	
	  ScrollBehavior.prototype._getDefaultScrollTarget = function _getDefaultScrollTarget() {
	    var location = this._getCurrentLocation();
	    if (location.action === _Actions.PUSH) {
	      return [0, 0];
	    }
	
	    return this.readPosition(location) || [0, 0];
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(81).Buffer
	var Hash   = __webpack_require__(2152)(Buffer)
	
	exports.sha1 = __webpack_require__(2154)(Buffer, Hash)
	exports.sha256 = __webpack_require__(2155)(Buffer, Hash)
	exports.sha512 = __webpack_require__(2156)(Buffer, Hash)


/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(529).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(529).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(529).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ }),
/* 2157 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1596);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DocumentDashboardPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DocumentDashboardPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1597);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./App.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./App.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1598);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AppFooter.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AppFooter.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1599);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AppToolbar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AppToolbar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1600);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./StatusAlert.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./StatusAlert.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1601);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReportCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReportCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1602);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ScoreDashboardPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ScoreDashboardPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1603);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerTicketClaimCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerTicketClaimCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1604);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketClaimCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketClaimCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1605);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./QualifyTicketClaimCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./QualifyTicketClaimCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1606);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketClaimCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketClaimCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1607);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketClaimCountCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketClaimCountCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1608);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketClaimDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketClaimDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1609);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketClaimStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketClaimStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1610);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencyCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencyCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1611);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencyDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencyDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1612);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencyDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencyDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1613);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencySearch.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencySearch.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1614);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencyStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AgencyStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1615);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AssociateDissociateUserFromAgencyModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AssociateDissociateUserFromAgencyModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1616);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1617);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyConfigsPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyConfigsPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1618);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1619);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1620);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyPicker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyPicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1621);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyStats.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyStats.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1622);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CompanyStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1623);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DeleteAgencyModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DeleteAgencyModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1624);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DisableUserModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DisableUserModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1625);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OrganisationLayout.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OrganisationLayout.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1626);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReactiveCancelCompanyModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReactiveCancelCompanyModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1627);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReferenceCompanyModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReferenceCompanyModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1628);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReferenceUserPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReferenceUserPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1629);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./SubsidiaryStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./SubsidiaryStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1630);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateAgencyPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateAgencyPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1631);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateCompanyPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateCompanyPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1632);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateLoginModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateLoginModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1633);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateUserModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateUserModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1634);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpgradeDowngradePremiumAccountModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpgradeDowngradePremiumAccountModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1635);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpgradeDowngradeStandardAccountModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpgradeDowngradeStandardAccountModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1636);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UserCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UserCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1637);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UserSearch.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UserSearch.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1638);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UserStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UserStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1639);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Box.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Box.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1640);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Card.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Card.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1641);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CardGroup.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CardGroup.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1642);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Chart.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Chart.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1643);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DashboardPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DashboardPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1644);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DashboardPanelAdd.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DashboardPanelAdd.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1645);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DayRangePicker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DayRangePicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1646);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DownloadIcon.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DownloadIcon.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1647);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Header.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Header.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1649);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./IconCateg.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./IconCateg.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1650);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Loader.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Loader.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1651);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./MultiInput.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./MultiInput.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1652);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PercentageDashboardPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PercentageDashboardPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1653);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Picker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Picker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1654);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RadioToggle.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RadioToggle.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1655);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RankingDashboardPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RankingDashboardPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1656);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Rating.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Rating.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1657);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./SearchBar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./SearchBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1658);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Selector.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Selector.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1659);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./StaticMap.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./StaticMap.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1660);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Strip.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Strip.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1661);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Tag.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Tag.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1662);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TagBar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TagBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1663);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Tags.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./Tags.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1664);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TimePicker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TimePicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1665);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TimeRangePicker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TimeRangePicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1666);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ToggleablePanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ToggleablePanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1667);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TypeaheadBar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TypeaheadBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1668);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TypeaheadGridInput.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TypeaheadGridInput.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1669);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TypeaheadInput.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TypeaheadInput.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1670);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateOpeningTicketInstructionPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateOpeningTicketInstructionPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1671);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpeningTicketInstructionPanelGroup.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpeningTicketInstructionPanelGroup.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1672);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateOpeningTicketInstructionPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateOpeningTicketInstructionPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1673);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddRemoveAddressFromLotPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddRemoveAddressFromLotPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1674);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddRemoveComplementaryAddressFromPatrimonyPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddRemoveComplementaryAddressFromPatrimonyPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1675);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddRemoveContactPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddRemoveContactPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1676);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AssociateDissociatePatrimonyFromAgencyPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AssociateDissociatePatrimonyFromAgencyPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1677);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./BuildingDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./BuildingDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1678);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./BuildingDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./BuildingDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1679);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1680);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1681);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1682);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactPicker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactPicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1683);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1684);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DeleteLotModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DeleteLotModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./LotCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./LotCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1686);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./LotDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./LotDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1687);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./LotDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./LotDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1688);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./LotStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./LotStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1689);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1690);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1691);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1692);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyPicker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyPicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1693);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonySearchBar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonySearchBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1694);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyStats.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyStats.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1695);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./PatrimonyStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1696);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReferenceLotPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReferenceLotPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1697);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReferencePatrimonyContactPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReferencePatrimonyContactPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1698);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RemoveLinkFromPatrimonyContactPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RemoveLinkFromPatrimonyContactPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1699);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateLotPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateLotPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1700);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../../node_modules/autoprefixer-loader/index.js!../../../../node_modules/less-loader/index.js!./PatrimonyUserModal.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../../node_modules/autoprefixer-loader/index.js!../../../../node_modules/less-loader/index.js!./PatrimonyUserModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1701);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddProviderContactModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddProviderContactModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1702);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AssignRemoveActivityFromProviderContactPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AssignRemoveActivityFromProviderContactPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1703);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CommitmentLayout.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CommitmentLayout.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1704);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1705);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1706);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1707);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactSelector.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactSelector.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1708);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactStats.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactStats.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1709);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1710);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactSuggestSelector.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ContactSuggestSelector.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1711);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CopyInterventionPeriodsModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CopyInterventionPeriodsModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1712);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineRemoveCallOutChargesFromInterventionPeriodForm.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineRemoveCallOutChargesFromInterventionPeriodForm.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1713);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineRemoveInterventionTimelimitFromInterventionPeriodForm.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineRemoveInterventionTimelimitFromInterventionPeriodForm.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1714);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineRemoveRepairTimelimitFromInterventionPeriodForm.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineRemoveRepairTimelimitFromInterventionPeriodForm.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1715);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineUpdateInterventionPeriodForActivityForm.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineUpdateInterventionPeriodForActivityForm.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1716);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1717);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderCoverageDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderCoverageDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1718);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderCoverageSearchBar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderCoverageSearchBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1719);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1720);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1721);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderPicker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderPicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1722);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderScores.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderScores.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1723);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderSearchBar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderSearchBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1725);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1726);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderSuggestSelector.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ProviderSuggestSelector.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1727);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RemoveInterventionPeriodModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RemoveInterventionPeriodModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1728);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./SubscribeProviderCompanyToDirectoryForInterventionPeriodForm.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./SubscribeProviderCompanyToDirectoryForInterventionPeriodForm.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1729);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UnAssignActivityFromProviderCompanyModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UnAssignActivityFromProviderCompanyModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1730);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateInterventionPeriodPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateInterventionPeriodPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1731);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../node_modules/autoprefixer-loader/index.js!../../node_modules/less-loader/index.js!./QualificationCriteriaEdit.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../node_modules/autoprefixer-loader/index.js!../../node_modules/less-loader/index.js!./QualificationCriteriaEdit.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1732);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../node_modules/autoprefixer-loader/index.js!../../node_modules/less-loader/index.js!./QualificationCriteriaRef.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../node_modules/autoprefixer-loader/index.js!../../node_modules/less-loader/index.js!./QualificationCriteriaRef.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1733);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AssociateActivityWithOpeningTicketPurposeModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AssociateActivityWithOpeningTicketPurposeModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1734);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateOpeningTicketPurposePanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateOpeningTicketPurposePanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1735);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateUpdateCategoryModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateUpdateCategoryModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1736);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateUpdateTagModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateUpdateTagModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1737);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DissociateActivityFromOpeningTicketPurposeModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DissociateActivityFromOpeningTicketPurposeModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1738);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./EnableDisableOpeningTicketPurposeModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./EnableDisableOpeningTicketPurposeModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1739);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpeningTicketPurposePanelGroup.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpeningTicketPurposePanelGroup.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1740);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpeningTicketPurposePicker.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpeningTicketPurposePicker.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1741);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateOpeningTicketPurposePanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateOpeningTicketPurposePanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1742);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddRemoveQuestionFromCampaignPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AddRemoveQuestionFromCampaignPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1743);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1744);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerForm.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerForm.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1745);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1746);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AnswerStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1747);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AverageNoteDashboardPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./AverageNoteDashboardPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1748);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CampaignCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CampaignCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1749);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CampaignDashboard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CampaignDashboard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1750);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CampaignDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CampaignDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1751);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateCampaignModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CreateCampaignModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1752);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./FinishCampaignModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./FinishCampaignModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1753);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./SatisfactionButton.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./SatisfactionButton.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1754);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./StartCampaignModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./StartCampaignModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1755);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateNotationScaleOfCampaignPopover.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UpdateNotationScaleOfCampaignPopover.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1756);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CloseTicketCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./CloseTicketCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1757);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ClosingRateDashboardPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ClosingRateDashboardPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1758);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineInterventionDeadlineModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./DefineInterventionDeadlineModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1759);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./EmitCallToModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./EmitCallToModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1760);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ExportTicketsModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ExportTicketsModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1761);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./IdentifyAssigneeCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./IdentifyAssigneeCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1762);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketAddressCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketAddressCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1763);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketButtonToolbar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketButtonToolbar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1764);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketCompanyCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketCompanyCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1765);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketContactToCallbackCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketContactToCallbackCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1766);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1767);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketPurposeCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./OpenTicketPurposeCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1768);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReceiveCallModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReceiveCallModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1769);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReportFormalNoticeForProviderModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReportFormalNoticeForProviderModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1770);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReportSendingServiceOrderModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ReportSendingServiceOrderModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1771);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ScheduleInterventionModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ScheduleInterventionModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1772);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketAddressCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketAddressCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1773);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketAssigneeCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketAssigneeCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1775);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1776);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketDetail.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketDetail.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1777);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketSearchBar.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketSearchBar.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1778);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketStats.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketStats.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1779);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1780);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketStreamCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketStreamCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1781);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketStreamLayout.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TicketStreamLayout.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1782);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ṔhotoPreview.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./ṔhotoPreview.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1783);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UnauthUserLayout.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UnauthUserLayout.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1784);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UserNavItem.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./UserNavItem.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1785);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./NextStepCard.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./NextStepCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1786);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RemoveWorkflowModal.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./RemoveWorkflowModal.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1787);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TodoSearch.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TodoSearch.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1788);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TodoStream.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TodoStream.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1789);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TodoStrip.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./TodoStrip.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1790);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./WorkflowPanel.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?localIdentName=[name]-[local]-[hash:base64:5]!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/less-loader/index.js!./WorkflowPanel.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2350 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(2352);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function createUncontrollable(mixins, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var methods = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        propTypes;
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'becasue they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = _react2.default.createClass(_extends({
	
	      displayName: 'Uncontrolled(' + displayName + ')',
	
	      mixins: mixins,
	
	      propTypes: propTypes
	
	    }, methods, {
	      componentWillMount: function componentWillMount() {
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        this._values = utils.transform(keys, function (values, key) {
	          values[key] = props[utils.defaultKey(key)];
	        }, {});
	      },
	
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this = this;
	
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        keys.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      },
	      render: function render() {
	        var _this2 = this;
	
	        var newProps = {};
	        var _props = this.props;
	        var valueLink = _props.valueLink;
	        var checkedLink = _props.checkedLink;
	
	        var props = _objectWithoutProperties(_props, ['valueLink', 'checkedLink']);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this2.props[propName];
	
	          if (linkPropName && !isProp(_this2.props, propName) && isProp(_this2.props, linkPropName)) {
	            prop = _this2.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this2._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this2, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      }
	    }));
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.customPropType = customPropType;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.isReactComponent = isReactComponent;
	exports.has = has;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(125);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function customPropType(handler, propType, name) {
	
	  return function (props, propName) {
	
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	
	      return propType && propType(props, propName, name);
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      var type = basePropTypes[prop];
	
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = customPropType(handler, type, displayName);
	
	      if (type !== undefined) obj[defaultKey(prop)] = type;
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}

/***/ }),
/* 2353 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// 0ab9d432d67c05bf3641.js